/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/catalog-ws/view/modernwar-vol2/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 273);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(321);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_styles__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(247);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var colorCss = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(['', ' ', ' g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill="none"]{stroke-width:0;}}*[stroke*="#"],*[STROKE*="#"]{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*="#"],*[FILL*="#"]{fill:inherit;stroke:none;}'], function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_grommet_styles__["b" /* colorStyle */])('fill', props.color || props.theme.global.colors.icon, props.theme);
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_grommet_styles__["b" /* colorStyle */])('stroke', props.color || props.theme.global.colors.icon, props.theme);
});

var IconInner = function IconInner(_ref) {
  var a11yTitle = _ref.a11yTitle,
      color = _ref.color,
      size = _ref.size,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ['a11yTitle', 'color', 'size', 'theme']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', _extends({ 'aria-label': a11yTitle }, rest));
};
IconInner.displayName = 'Icon';

var StyledIcon = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(IconInner).withConfig({
  displayName: 'StyledIcon',
  componentId: 'ofa7kd-0'
})(['display:inline-block;flex:0 0 auto;', ' ', ' ', ''], function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === undefined ? 'medium' : _ref2$size,
      theme = _ref2.theme;
  return '\n    width: ' + (theme.icon.size[size] || size) + ';\n    height: ' + (theme.icon.size[size] || size) + ';\n  ';
}, function (_ref3) {
  var color = _ref3.color;
  return color !== 'plain' && colorCss;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme && theme.icon.extend;
});

StyledIcon.defaultProps = {};
Object.setPrototypeOf(StyledIcon.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);



/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return keyframes; });
/* unused harmony export createGlobalStyle */
/* unused harmony export isStyledComponent */
/* unused harmony export ThemeConsumer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThemeContext; });
/* unused harmony export ThemeProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return withTheme; });
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_memoize_one__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__emotion_is_prop_valid__ = __webpack_require__(351);










// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return ( false ? typeof target === 'string' && target : false) || target.displayName || target.name || 'Component';
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 

var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"/catalog-ws/view/modernwar-vol2"}).SC_ATTR || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper (see https://www.styled-components.com/docs/api#css), which ensures the styles are injected correctly.\n\n",
  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n"
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  var a = arguments.length <= 0 ? undefined : arguments[0];
  var b = [];

  for (var c = 1, len = arguments.length; c < len; c += 1) {
    b.push(arguments.length <= c ? undefined : arguments[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};

/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */
var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.1.2");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.1.2" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.1.2", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

var rehydrate = function rehydrate(tag, els, extracted) {
  /* add all extracted components to the new tag */
  for (var i = 0, len = extracted.length; i < len; i += 1) {
    var _extracted$i = extracted[i],
        componentId = _extracted$i.componentId,
        cssFromDOM = _extracted$i.cssFromDOM;

    var cssRules = splitByRules(cssFromDOM);
    tag.insertRules(componentId, cssRules);
  }

  /* remove old HTMLStyleElements, since they have been rehydrated */
  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
    var el = els[_i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  /* a map from ids to tags */

  /* deferred rules for a given id */

  /* this is used for not reinjecting rules via hasNameForId() */

  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */

  /* a list of tags belonging to this StyleSheet */

  /* a tag for import rules */

  /* current capacity until a new tag must be created */

  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
    if (!IS_BROWSER || this.forceServer) return this;

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.1.2" + '"]');

    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (!nodesSize) return this;

    for (var i = 0; i < nodesSize; i += 1) {
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0, name; j < elNamesSize; j += 1) {
        name = elNames[j];
        /* add rehydrated name to sheet to avoid re-adding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (!extractedSize) return this;

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);

    rehydrate(tag, els, extracted);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(tag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = tag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for createGlobalStyle to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);

    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;

    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 

/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
  // $FlowFixMe
  if (value == null || typeof value === 'boolean' || value === '') {
    return '';
  }

  if (typeof value === 'number' && value !== 0 && !(name in __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__["a" /* default */])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
}

// 

/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    return !isFalsish(obj[key]);
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  /* Handle other components */
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  /* Either execute or defer the function */
  if (isFunction(chunk)) {
    if (executionContext) {
      var shouldThrow = false;

      try {
        // eslint-disable-next-line new-cap
        if (Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isElement"])(new chunk(executionContext))) {
          shouldThrow = true;
        }
      } catch (e) {
        /* */
      }

      if (shouldThrow) {
        throw new StyledComponentsError(13, getComponentName(chunk));
      }

      return flatten(chunk(executionContext), executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  /* Handle objects */
  return isPlainObject(chunk) ? objToCss(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (isFunction(styles) || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isValidElementType"])(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  /* This is callable directly as a template function */
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  /* If config methods are called, wrap up a new template function and merge options */
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
  };

  /* Modify/inject new props at runtime */
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function hasFunctionObjectKey(obj) {
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in obj) {
    if (isFunction(obj[key])) {
      return true;
    }
  }

  return false;
}

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
      return false;
    } else if (isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs.some(function (x) {
    return isFunction(x) || hasFunctionObjectKey(x);
  })) return false;

  return true;
}

// 

var isHMREnabled = "production" !== 'production' && typeof module !== 'undefined' && module.hot;

/* combines hashStr (murmurhash) and nameGenerator for convenience */
var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */

var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function isTag(target) {
  return typeof target === 'string' && ( false ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
}

// 

function generateDisplayName(target) {
  // $FlowFixMe
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

var _TYPE_STATICS;

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDerivedStateFromProps: true,
  propTypes: true,
  type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[__WEBPACK_IMPORTED_MODULE_4_react_is__["ForwardRef"]] = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;


function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            /* fail silently */
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb.apply(undefined, arguments);
    }
  };
});

// 

var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();

var ThemeConsumer = ThemeContext.Consumer;

/**
 * Provide a theme to an entire react component tree via context
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Consumer,
      null,
      this.renderInner
    );
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Provider,
      { value: context },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children)
    );
  };

  /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */


  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */


  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      /* Remove sealed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });
    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();

var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;


    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetContext.Provider,
      { value: this.getContext(sheet, target) },
       false ? React.Children.only(children) : children
    );
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),

  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var didWarnAboutClassNameUsage = new Set();

var classNameUsageCheckInjector = (function (target) {
  var elementClassName = '';

  var targetCDM = target.componentDidMount;

  // eslint-disable-next-line no-param-reassign
  target.componentDidMount = function componentDidMount() {
    if (typeof targetCDM === 'function') {
      targetCDM.call(this);
    }

    var forwardTarget = this.props.forwardedComponent.target;

    if (target.props && target.props.suppressClassNameWarning || target.attrs && target.attrs.suppressClassNameWarning || didWarnAboutClassNameUsage.has(forwardTarget)) {
      return;
    }

    didWarnAboutClassNameUsage.add(forwardTarget);

    var classNames = elementClassName.replace(/ +/g, ' ').trim().split(' ');
    // eslint-disable-next-line react/no-find-dom-node
    var node = __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this);
    var selector = classNames.map(function (s) {
      return '.' + s;
    }).join('');

    if (node && node.nodeType === 1 && !classNames.every(function (className) {
      return node.classList && node.classList.contains(className);
    }) && !node.querySelector(selector)) {
      console.warn('It looks like you\'ve wrapped styled() around your React component (' + getComponentName(forwardTarget) + '), but the className prop is not being passed down to a child. No styles will be rendered unless className is composed within your React component.');
    }
  };

  var prevRenderInner = target.renderInner;

  // eslint-disable-next-line no-param-reassign
  target.renderInner = function renderInner() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var element = prevRenderInner.apply(this, args);

    elementClassName = element.props.className;

    return element;
  };
});

// 

var identifiers = {};

/* We depend on components having unique IDs */
function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {
      _this.warnInnerRef = once(function (displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component. "innerRef" was detected on component "' + displayName + '".')
        );
      });

      _this.warnAttrsFnObjectKeyDeprecated = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('Functions as object-form attrs({}) keys are now deprecated and will be removed in a future version of styled-components. Switch to the new attrs(props => ({})) syntax instead for easier and more powerful composition. The attrs key in question is "' + key + '" on component "' + displayName + '".')
        );
      });

      _this.warnNonStyledComponentAttrsObjectKey = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('It looks like you\'ve used a non styled-component as the value for the "' + key + '" prop in an object-form attrs constructor of "' + displayName + '".\n' + 'You should use the new function-form attrs constructor which avoids this issue: attrs(props => ({ yourStuff }))\n' + "To continue using the deprecated object syntax, you'll need to wrap your component prop in a function to make it available inside the styled component (you'll still get the deprecation warning though.)\n" + ('For example, { ' + key + ': () => InnerComponent } instead of { ' + key + ': InnerComponent }'))
        );
      });
    }

    if (false) {
      classNameUsageCheckInjector(_this);
    }
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetConsumer,
      null,
      this.renderOuter
    );
  };

  StyledComponent.prototype.renderOuter = function renderOuter() {
    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;

    this.styleSheet = styleSheet;

    // No need to subscribe a static component to theme changes, it won't change anything
    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      this.renderInner
    );
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedCompo = this.props.forwardedComponent,
        componentStyle = _props$forwardedCompo.componentStyle,
        defaultProps = _props$forwardedCompo.defaultProps,
        displayName = _props$forwardedCompo.displayName,
        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
        styledComponentId = _props$forwardedCompo.styledComponentId,
        target = _props$forwardedCompo.target;


    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
    } else if (theme !== undefined) {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps), this.props);
    } else {
      generatedClassName = this.generateAndInjectStyles(this.props.theme || EMPTY_OBJECT, this.props);
    }

    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = {};
    var computedProps = _extends({}, this.attrs, this.props);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in computedProps) {
      if (false) {
        this.warnInnerRef(displayName);
      }

      if (key === 'forwardedComponent' || key === 'as') continue;else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (!isTargetTag || Object(__WEBPACK_IMPORTED_MODULE_8__emotion_is_prop_valid__["a" /* default */])(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
      }
    }

    if (this.props.style && this.attrs.style) {
      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
    }

    propsForElement.className = Array.prototype.concat(foldedComponentIds, this.props.className, styledComponentId, this.attrs.className, generatedClassName).filter(Boolean).join(' ');

    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var _this2 = this;

    var context = _extends({}, props, { theme: theme });

    if (!attrs.length) return context;

    this.attrs = {};

    attrs.forEach(function (attrDef) {
      var resolvedAttrDef = attrDef;
      var attrDefWasFn = false;
      var attr = void 0;
      var key = void 0;

      if (isFunction(resolvedAttrDef)) {
        // $FlowFixMe
        resolvedAttrDef = resolvedAttrDef(context);
        attrDefWasFn = true;
      }

      /* eslint-disable guard-for-in */
      // $FlowFixMe
      for (key in resolvedAttrDef) {
        attr = resolvedAttrDef[key];

        if (!attrDefWasFn) {
          if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
            if (false) {
              _this2.warnAttrsFnObjectKeyDeprecated(key, props.forwardedComponent.displayName);
            }

            attr = attr(context);

            if (false) {
              _this2.warnNonStyledComponentAttrsObjectKey(key, props.forwardedComponent.displayName);
            }
          }
        }

        _this2.attrs[key] = attr;
        context[key] = attr;
      }
      /* eslint-enable */
    });

    return context;
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _props$forwardedCompo2 = props.forwardedComponent,
        attrs = _props$forwardedCompo2.attrs,
        componentStyle = _props$forwardedCompo2.componentStyle,
        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && !attrs.length) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);

    if (false) warnTooManyClasses(className);

    return className;
  };

  return StyledComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;


  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */
  var WrappedStyledComponent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
  });

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;
  WrappedStyledComponent.displayName = displayName;

  // $FlowFixMe
  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;

  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);


    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

    var newOptions = _extends({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  if (false) {
    // $FlowFixMe
    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
  }

  // $FlowFixMe
  WrappedStyledComponent.toString = function () {
    return '.' + WrappedStyledComponent.styledComponentId;
  };

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      foldedComponentIds: true,
      styledComponentId: true,
      target: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent() {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;


      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {
        // eslint-disable-next-line no-console
        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyleSheetConsumer,
        null,
        function (styleSheet) {
          _this2.styleSheet = styleSheet || StyleSheet.master;

          var globalStyle = _this2.state.globalStyle;


          if (globalStyle.isStatic) {
            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

            return null;
          } else {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              ThemeConsumer,
              null,
              function (theme) {
                // $FlowFixMe
                var defaultProps = _this2.constructor.defaultProps;


                var context = _extends({}, _this2.props);

                if (typeof theme !== 'undefined') {
                  context.theme = determineTheme(_this2.props, theme, defaultProps);
                }

                globalStyle.renderStyles(context, _this2.styleSheet);

                return null;
              }
            );
          }
        }
      );
    };

    return GlobalStyleComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;


  return GlobalStyleComponent;
}

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

function keyframes(strings) {
  /* Warning if you've used keyframes on React Native */
  if (false) {
    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
  }

  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));

  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));

  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
}

// 

var withTheme = (function (Component$$1) {
  var WithTheme = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      function (theme) {
        // $FlowFixMe
        var defaultProps = Component$$1.defaultProps;

        var themeProp = determineTheme(props, theme, defaultProps);

        if (false) {
          // eslint-disable-next-line no-console
          console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + getComponentName(Component$$1) + '"');
        }

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({}, props, { theme: themeProp, ref: ref }));
      }
    );
  });

  hoistNonReactStatics(WithTheme, Component$$1);

  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';

  return WithTheme;
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

//

/* harmony default export */ __webpack_exports__["c"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(121), __webpack_require__(171)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(349)();
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export propTypes */
/* unused harmony export PropTypes */
/* unused harmony export onError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return observer; });
/* unused harmony export Observer */
/* unused harmony export renderReporter */
/* unused harmony export componentByNodeRegistery */
/* unused harmony export componentByNodeRegistry */
/* unused harmony export trackComponents */
/* unused harmony export useStaticRendering */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inject; });
/* unused harmony export disposeOnUnmount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

// These functions can be stubbed out in specific environments

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var reactIs_production_min = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.forward_ref"):60112,n=b?Symbol.for("react.placeholder"):60113;
function q(a){if("object"===typeof a&&null!==a){var p=a.$$typeof;switch(p){case c:switch(a=a.type,a){case l:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case m:case h:return a;default:return p}}case d:return p}}}exports.typeOf=q;exports.AsyncMode=l;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=m;exports.Fragment=e;exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;
exports.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===l||a===g||a===f||a===n||"object"===typeof a&&null!==a&&("function"===typeof a.then||a.$$typeof===h||a.$$typeof===k||a.$$typeof===m)};exports.isAsyncMode=function(a){return q(a)===l};exports.isContextConsumer=function(a){return q(a)===k};exports.isContextProvider=function(a){return q(a)===h};exports.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};
exports.isForwardRef=function(a){return q(a)===m};exports.isFragment=function(a){return q(a)===e};exports.isProfiler=function(a){return q(a)===g};exports.isPortal=function(a){return q(a)===d};exports.isStrictMode=function(a){return q(a)===f};
});

unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_4 = reactIs_production_min.ContextProvider;
var reactIs_production_min_5 = reactIs_production_min.Element;
var reactIs_production_min_6 = reactIs_production_min.ForwardRef;
var reactIs_production_min_7 = reactIs_production_min.Fragment;
var reactIs_production_min_8 = reactIs_production_min.Profiler;
var reactIs_production_min_9 = reactIs_production_min.Portal;
var reactIs_production_min_10 = reactIs_production_min.StrictMode;
var reactIs_production_min_11 = reactIs_production_min.isValidElementType;
var reactIs_production_min_12 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_13 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_14 = reactIs_production_min.isContextProvider;
var reactIs_production_min_15 = reactIs_production_min.isElement;
var reactIs_production_min_16 = reactIs_production_min.isForwardRef;
var reactIs_production_min_17 = reactIs_production_min.isFragment;
var reactIs_production_min_18 = reactIs_production_min.isProfiler;
var reactIs_production_min_19 = reactIs_production_min.isPortal;
var reactIs_production_min_20 = reactIs_production_min.isStrictMode;

var reactIs = createCommonjsModule(function (module) {

{
  module.exports = reactIs_production_min;
}
});

var _ReactIs$ForwardRef;

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var TYPE_STATICS = _defineProperty$1({}, reactIs.ForwardRef, (_ReactIs$ForwardRef = {}, _defineProperty$1(_ReactIs$ForwardRef, '$$typeof', true), _defineProperty$1(_ReactIs$ForwardRef, 'render', true), _ReactIs$ForwardRef));

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.listeners = [];
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(cb) {
      var _this = this;

      this.listeners.push(cb);
      return function () {
        var index = _this.listeners.indexOf(cb);

        if (index !== -1) _this.listeners.splice(index, 1);
      };
    }
  }, {
    key: "emit",
    value: function emit(data) {
      this.listeners.forEach(function (fn) {
        return fn(data);
      });
    }
  }]);

  return EventEmitter;
}();

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      rest[_key - 6] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["z" /* untracked */])(function () {
      componentName = componentName || "<<anonymous>>";
      propFullName = propFullName || propName;

      if (props[propName] == null) {
        if (isRequired) {
          var actual = props[propName] === null ? "null" : "undefined";
          return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
        }

        return null;
      } else {
        return validate.apply(void 0, [props, propName, componentName, location, propFullName].concat(rest));
      }
    });
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
} // Copied from React.PropTypes


function isSymbol(propType, propValue) {
  // Native Symbol.
  if (propType === "symbol") {
    return true;
  } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


  if (propValue["@@toStringTag"] === "Symbol") {
    return true;
  } // Fallback for non-spec compliant Symbols which are polyfilled.


  if (typeof Symbol === "function" && propValue instanceof Symbol) {
    return true;
  }

  return false;
} // Copied from React.PropTypes


function getPropType(propValue) {
  var propType = _typeof(propValue);

  if (Array.isArray(propValue)) {
    return "array";
  }

  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
  }

  if (isSymbol(propType, propValue)) {
    return "symbol";
  }

  return propType;
} // This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes


function getPreciseType(propValue) {
  var propType = getPropType(propValue);

  if (propType === "object") {
    if (propValue instanceof Date) {
      return "date";
    } else if (propValue instanceof RegExp) {
      return "regexp";
    }
  }

  return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
  return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["z" /* untracked */])(function () {
      if (allowNativeType) {
        if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
      }

      var mobxChecker;

      switch (mobxType) {
        case "Array":
          mobxChecker = __WEBPACK_IMPORTED_MODULE_1_mobx__["p" /* isObservableArray */];
          break;

        case "Object":
          mobxChecker = __WEBPACK_IMPORTED_MODULE_1_mobx__["r" /* isObservableObject */];
          break;

        case "Map":
          mobxChecker = __WEBPACK_IMPORTED_MODULE_1_mobx__["q" /* isObservableMap */];
          break;

        default:
          throw new Error("Unexpected mobxType: ".concat(mobxType));
      }

      var propValue = props[propName];

      if (!mobxChecker(propValue)) {
        var preciseType = getPreciseType(propValue);
        var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
        return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
      }

      return null;
    });
  });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
  return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
      rest[_key2 - 5] = arguments[_key2];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["z" /* untracked */])(function () {
      if (typeof typeChecker !== "function") {
        return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
      }

      var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
      if (error instanceof Error) return error;
      var propValue = props[propName];

      for (var i = 0; i < propValue.length; i++) {
        error = typeChecker.apply(void 0, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
        if (error instanceof Error) return error;
      }

      return null;
    });
  });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");

var propTypes = /*#__PURE__*/Object.freeze({
  observableArray: observableArray,
  observableArrayOf: observableArrayOf,
  observableMap: observableMap,
  observableObject: observableObject,
  arrayOrObservableArray: arrayOrObservableArray,
  arrayOrObservableArrayOf: arrayOrObservableArrayOf,
  objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
  // `function() {}` has prototype, but `() => {}` doesn't
  // `() => {}` via Babel has prototype too.
  return !(component.prototype && component.prototype.render);
}
var symbolId = 0;
function newSymbol(name) {
  if (typeof Symbol === "function") {
    return Symbol(name);
  }

  var symbol = "__$mobx-react ".concat(name, " (").concat(symbolId, ")");
  symbolId++;
  return symbol;
}
var mobxMixins = newSymbol("patchMixins");
var mobxPatchedDefinition = newSymbol("patchedDefinition");
var mobxRealMethod = newSymbol("patchRealMethod");

function getMixins(target, methodName) {
  var mixins = target[mobxMixins] = target[mobxMixins] || {};
  var methodMixins = mixins[methodName] = mixins[methodName] || {};
  methodMixins.locks = methodMixins.locks || 0;
  methodMixins.methods = methodMixins.methods || [];
  return methodMixins;
}

function wrapper(realMethod, mixins) {
  var _this = this;

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
  mixins.locks++;

  try {
    var retVal;

    if (realMethod !== undefined && realMethod !== null) {
      retVal = realMethod.apply(this, args);
    }

    return retVal;
  } finally {
    mixins.locks--;

    if (mixins.locks === 0) {
      mixins.methods.forEach(function (mx) {
        mx.apply(_this, args);
      });
    }
  }
}

function wrapFunction(mixins) {
  var fn = function fn() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    wrapper.call.apply(wrapper, [this, fn[mobxRealMethod], mixins].concat(args));
  };

  return fn;
}

function patch(target, methodName) {
  var mixins = getMixins(target, methodName);

  for (var _len3 = arguments.length, mixinMethods = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    mixinMethods[_key3 - 2] = arguments[_key3];
  }

  for (var _i = 0; _i < mixinMethods.length; _i++) {
    var mixinMethod = mixinMethods[_i];

    if (mixins.methods.indexOf(mixinMethod) < 0) {
      mixins.methods.push(mixinMethod);
    }
  }

  var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);

  if (oldDefinition && oldDefinition[mobxPatchedDefinition]) {
    // already patched definition, do not repatch
    return;
  }

  var originalMethod = target[methodName];
  var newDefinition = createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
  Object.defineProperty(target, methodName, newDefinition);
}

function createDefinition(target, methodName, enumerable, mixins, originalMethod) {
  var _ref;

  var wrappedFunc = wrapFunction(mixins);
  wrappedFunc[mobxRealMethod] = originalMethod;
  return _ref = {}, _defineProperty(_ref, mobxPatchedDefinition, true), _defineProperty(_ref, "get", function get() {
    return wrappedFunc;
  }), _defineProperty(_ref, "set", function set(value) {
    if (this === target) {
      wrappedFunc[mobxRealMethod] = value;
    } else {
      // when it is an instance of the prototype/a child prototype patch that particular case again separately
      // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
      // e.g. the method for super might not be the same as the method for the prototype which might be not the same
      // as the method for the instance
      var newDefinition = createDefinition(this, methodName, enumerable, mixins, value);
      Object.defineProperty(this, methodName, newDefinition);
    }
  }), _defineProperty(_ref, "configurable", true), _defineProperty(_ref, "enumerable", enumerable), _ref;
}

var injectorContextTypes = {
  mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);
var proxiedInjectorProps = {
  contextTypes: {
    get: function get() {
      return injectorContextTypes;
    },
    set: function set(_) {
      console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
    },
    configurable: true,
    enumerable: false
  },
  isMobxInjector: {
    value: true,
    writable: true,
    configurable: true,
    enumerable: true
  }
  /**
   * Store Injection
   */

};

function createStoreInjector(grabStoresFn, component, injectNames) {
  var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
  if (injectNames) displayName += "-with-" + injectNames;

  var Injector =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Injector, _Component);

    function Injector() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Injector);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Injector)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _this.storeRef = function (instance) {
        _this.wrappedInstance = instance;
      };

      return _this;
    }

    _createClass(Injector, [{
      key: "render",
      value: function render() {
        // Optimization: it might be more efficient to apply the mapper function *outside* the render method
        // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
        // See this test: 'using a custom injector is not too reactive' in inject.js
        var newProps = {};

        for (var key in this.props) {
          if (this.props.hasOwnProperty(key)) {
            newProps[key] = this.props[key];
          }
        }

        var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};

        for (var _key2 in additionalProps) {
          newProps[_key2] = additionalProps[_key2];
        }

        if (!isStateless(component)) {
          newProps.ref = this.storeRef;
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, newProps);
      }
    }]);

    return Injector;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); // Static fields from component should be visible on the generated Injector


  Injector.displayName = displayName;
  hoistNonReactStatics_cjs(Injector, component);
  Injector.wrappedComponent = component;
  Object.defineProperties(Injector, proxiedInjectorProps);
  return Injector;
}

function grabStoresByName(storeNames) {
  return function (baseStores, nextProps) {
    storeNames.forEach(function (storeName) {
      if (storeName in nextProps // prefer props over stores
      ) return;
      if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
      nextProps[storeName] = baseStores[storeName];
    });
    return nextProps;
  };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */


function inject()
/* fn(stores, nextProps) or ...storeNames */
{
  var grabStoresFn;

  if (typeof arguments[0] === "function") {
    grabStoresFn = arguments[0];
    return function (componentClass) {
      var injected = createStoreInjector(grabStoresFn, componentClass);
      injected.isMobxInjector = false; // supress warning
      // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
      // see #111

      injected = observer(injected);
      injected.isMobxInjector = true; // restore warning

      return injected;
    };
  } else {
    var storeNames = [];

    for (var i = 0; i < arguments.length; i++) {
      storeNames[i] = arguments[i];
    }

    grabStoresFn = grabStoresByName(storeNames);
    return function (componentClass) {
      return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
    };
  }
}

var mobxAdminProperty = __WEBPACK_IMPORTED_MODULE_1_mobx__["a" /* $mobx */] || "$mobx";
var mobxIsUnmounted = newSymbol("isUnmounted");
/**
 * dev tool support
 */

var isDevtoolsEnabled = false;
var isUsingStaticRendering = false;
var warnedAboutObserverInjectDeprecation = false; // WeakMap<Node, Object>;

var componentByNodeRegistry = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();
var skipRenderKey = newSymbol("skipRender");
var isForcingUpdateKey = newSymbol("isForcingUpdate");
/**
 * Helper to set `prop` to `this` as non-enumerable (hidden prop)
 * @param target
 * @param prop
 * @param value
 */

function setHiddenProp(target, prop, value) {
  if (!Object.hasOwnProperty.call(target, prop)) {
    Object.defineProperty(target, prop, {
      enumerable: false,
      configurable: true,
      writable: true,
      value: value
    });
  } else {
    target[prop] = value;
  }
}

function findDOMNode$2(component) {
  if (__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"]) {
    try {
      return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
    } catch (e) {
      // findDOMNode will throw in react-test-renderer, see:
      // See https://github.com/mobxjs/mobx-react/issues/216
      // Is there a better heuristic?
      return null;
    }
  }

  return null;
}

function reportRendering(component) {
  var node = findDOMNode$2(component);
  if (node && componentByNodeRegistry) componentByNodeRegistry.set(node, component);
  renderReporter.emit({
    event: "render",
    renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
    totalTime: Date.now() - component.__$mobRenderStart,
    component: component,
    node: node
  });
}

function trackComponents() {
  if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
  if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}
function useStaticRendering(useStaticRendering) {
  isUsingStaticRendering = useStaticRendering;
}
/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();
/**
 * Utilities
 */

function patch$1(target, funcName) {
  patch(target, funcName, reactiveMixin[funcName]);
}

function shallowEqual(objA, objB) {
  //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
  if (is(objA, objB)) return true;

  if (_typeof(objA) !== "object" || objA === null || _typeof(objB) !== "object" || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function is(x, y) {
  // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function makeComponentReactive(render) {
  var _this2 = this;

  if (isUsingStaticRendering === true) return render.call(this);

  function reactiveRender() {
    var _this = this;

    isRenderingPending = false;
    var exception = undefined;
    var rendering = undefined;
    reaction.track(function () {
      if (isDevtoolsEnabled) {
        _this.__$mobRenderStart = Date.now();
      }

      try {
        rendering = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* _allowStateChanges */])(false, baseRender);
      } catch (e) {
        exception = e;
      }

      if (isDevtoolsEnabled) {
        _this.__$mobRenderEnd = Date.now();
      }
    });

    if (exception) {
      errorsReporter.emit(exception);
      throw exception;
    }

    return rendering;
  } // Generate friendly name for debugging


  var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
  var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalInstance && this._reactInternalInstance._debugID || this._reactInternalFiber && this._reactInternalFiber._debugID;
  /**
   * If props are shallowly modified, react will render anyway,
   * so atom.reportChanged() should not result in yet another re-render
   */

  setHiddenProp(this, skipRenderKey, false);
  /**
   * forceUpdate will re-assign this.props. We don't want that to cause a loop,
   * so detect these changes
   */

  setHiddenProp(this, isForcingUpdateKey, false); // wire up reactive render

  var baseRender = render.bind(this);
  var isRenderingPending = false;
  var reaction = new __WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* Reaction */]("".concat(initialName, "#").concat(rootNodeID, ".render()"), function () {
    if (!isRenderingPending) {
      // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
      // This unidiomatic React usage but React will correctly warn about this so we continue as usual
      // See #85 / Pull #44
      isRenderingPending = true;
      if (typeof _this2.componentWillReact === "function") _this2.componentWillReact(); // TODO: wrap in action?

      if (_this2[mobxIsUnmounted] !== true) {
        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
        // However, people also claim this migth happen during unit tests..
        var hasError = true;

        try {
          setHiddenProp(_this2, isForcingUpdateKey, true);
          if (!_this2[skipRenderKey]) __WEBPACK_IMPORTED_MODULE_0_react__["Component"].prototype.forceUpdate.call(_this2);
          hasError = false;
        } finally {
          setHiddenProp(_this2, isForcingUpdateKey, false);
          if (hasError) reaction.dispose();
        }
      }
    }
  });
  reaction.reactComponent = this;
  reactiveRender[mobxAdminProperty] = reaction;
  this.render = reactiveRender;
  return reactiveRender.call(this);
}
/**
 * ReactiveMixin
 */


var reactiveMixin = {
  componentWillUnmount: function componentWillUnmount() {
    if (isUsingStaticRendering === true) return;
    this.render[mobxAdminProperty] && this.render[mobxAdminProperty].dispose();
    this[mobxIsUnmounted] = true;

    if (isDevtoolsEnabled) {
      var node = findDOMNode$2(this);

      if (node && componentByNodeRegistry) {
        componentByNodeRegistry.delete(node);
      }

      renderReporter.emit({
        event: "destroy",
        component: this,
        node: node
      });
    }
  },
  componentDidMount: function componentDidMount() {
    if (isDevtoolsEnabled) {
      reportRendering(this);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    if (isDevtoolsEnabled) {
      reportRendering(this);
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    if (isUsingStaticRendering) {
      console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    } // update on any state changes (as is the default)


    if (this.state !== nextState) {
      return true;
    } // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.


    return !shallowEqual(this.props, nextProps);
  }
};

function makeObservableProp(target, propName) {
  var valueHolderKey = newSymbol("reactProp_".concat(propName, "_valueHolder"));
  var atomHolderKey = newSymbol("reactProp_".concat(propName, "_atomHolder"));

  function getAtom() {
    if (!this[atomHolderKey]) {
      setHiddenProp(this, atomHolderKey, Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["k" /* createAtom */])("reactive " + propName));
    }

    return this[atomHolderKey];
  }

  Object.defineProperty(target, propName, {
    configurable: true,
    enumerable: true,
    get: function get() {
      getAtom.call(this).reportObserved();
      return this[valueHolderKey];
    },
    set: function set(v) {
      if (!this[isForcingUpdateKey] && !shallowEqual(this[valueHolderKey], v)) {
        setHiddenProp(this, valueHolderKey, v);
        setHiddenProp(this, skipRenderKey, true);
        getAtom.call(this).reportChanged();
        setHiddenProp(this, skipRenderKey, false);
      } else {
        setHiddenProp(this, valueHolderKey, v);
      }
    }
  });
}
/**
 * Observer function / decorator
 */


function observer(arg1, arg2) {
  if (typeof arg1 === "string") {
    throw new Error("Store names should be provided as array");
  }

  if (Array.isArray(arg1)) {
    // TODO: remove in next major
    // component needs stores
    if (!warnedAboutObserverInjectDeprecation) {
      warnedAboutObserverInjectDeprecation = true;
      console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
    }

    if (!arg2) {
      // invoked as decorator
      return function (componentClass) {
        return observer(arg1, componentClass);
      };
    } else {
      return inject.apply(null, arg1)(observer(arg2));
    }
  }

  var componentClass = arg1;

  if (componentClass.isMobxInjector === true) {
    console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
  }

  if (componentClass.__proto__ === __WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]) {
    console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together");
  } // Stateless function component:
  // If it is function but doesn't seem to be a react class constructor,
  // wrap it to a react class automatically


  if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !__WEBPACK_IMPORTED_MODULE_0_react__["Component"].isPrototypeOf(componentClass)) {
    var _class, _temp;

    var observerComponent = observer((_temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          return componentClass.call(this, this.props, this.context);
        }
      }]);

      return _class;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
    hoistNonReactStatics_cjs(observerComponent, componentClass);
    return observerComponent;
  }

  if (!componentClass) {
    throw new Error("Please pass a valid component to 'observer'");
  }

  var target = componentClass.prototype || componentClass;
  mixinLifecycleEvents(target);
  componentClass.isMobXReactObserver = true;
  makeObservableProp(target, "props");
  makeObservableProp(target, "state");
  var baseRender = target.render;

  target.render = function () {
    return makeComponentReactive.call(this, baseRender);
  };

  return componentClass;
}

function mixinLifecycleEvents(target) {
  ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
    patch$1(target, funcName);
  });

  if (!target.shouldComponentUpdate) {
    target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
  } else {
    if (target.shouldComponentUpdate !== reactiveMixin.shouldComponentUpdate) {
      // TODO: make throw in next major
      console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.");
    }
  }
}

var Observer = observer(function (_ref) {
  var children = _ref.children,
      observerInject = _ref.inject,
      render = _ref.render;
  var component = children || render;

  if (typeof component === "undefined") {
    return null;
  }

  if (!observerInject) {
    return component();
  } // TODO: remove in next major


  console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
  var InjectComponent = inject(observerInject)(component);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InjectComponent, null);
});
Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
  var extraKey = key === "children" ? "render" : "children";

  if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
    return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
  }

  if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
    return;
  }

  return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
  render: ObserverPropsCheck,
  children: ObserverPropsCheck
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component$$1) {
  var prototype = Component$$1.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component$$1.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component$$1;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component$$1.displayName || Component$$1.name;
    var newApiName =
      typeof Component$$1.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component$$1.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component$$1;
}

var specialReactKeys = {
  children: true,
  key: true,
  ref: true
};

var Provider =
/*#__PURE__*/
function (_Component) {
  _inherits(Provider, _Component);

  function Provider(props, context) {
    var _this;

    _classCallCheck(this, Provider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this, props, context));
    _this.state = {};
    copyStores(props, _this.state);
    return _this;
  }

  _createClass(Provider, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      var stores = {}; // inherit stores

      copyStores(this.context.mobxStores, stores); // add own stores

      copyStores(this.props, stores);
      return {
        mobxStores: stores
      };
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!nextProps) return null;
      if (!prevState) return nextProps; // Maybe this warning is too aggressive?

      if (Object.keys(nextProps).filter(validStoreName).length !== Object.keys(prevState).filter(validStoreName).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
      if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
        if (validStoreName(key) && prevState[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
      }
      return nextProps;
    }
  }]);

  return Provider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Provider.contextTypes = {
  mobxStores: objectOrObservableObject
};
Provider.childContextTypes = {
  mobxStores: objectOrObservableObject.isRequired
};

function copyStores(from, to) {
  if (!from) return;

  for (var key in from) {
    if (validStoreName(key)) to[key] = from[key];
  }
}

function validStoreName(key) {
  return !specialReactKeys[key] && key !== "suppressChangedStoreWarning";
} // TODO: kill in next major


polyfill(Provider);

var storeKey = newSymbol("disposeOnUnmount");

function runDisposersOnWillUnmount() {
  var _this = this;

  if (!this[storeKey]) {
    // when disposeOnUnmount is only set to some instances of a component it will still patch the prototype
    return;
  }

  this[storeKey].forEach(function (propKeyOrFunction) {
    var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;

    if (prop !== undefined && prop !== null) {
      if (typeof prop !== "function") {
        throw new Error("[mobx-react] disposeOnUnmount only works on functions such as disposers returned by reactions, autorun, etc.");
      }

      prop();
    }
  });
  this[storeKey] = [];
}

function disposeOnUnmount(target, propertyKeyOrFunction) {
  if (Array.isArray(propertyKeyOrFunction)) {
    return propertyKeyOrFunction.map(function (fn) {
      return disposeOnUnmount(target, fn);
    });
  }

  if (!target instanceof __WEBPACK_IMPORTED_MODULE_0_react__["Component"]) {
    throw new Error("[mobx-react] disposeOnUnmount only works on class based React components.");
  }

  if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function") {
    throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
  } // add property key / function we want run (disposed) to the store


  var componentWasAlreadyModified = !!target[storeKey];
  var store = target[storeKey] || (target[storeKey] = []);
  store.push(propertyKeyOrFunction); // tweak the component class componentWillUnmount if not done already

  if (!componentWasAlreadyModified) {
    patch(target, "componentWillUnmount", runDisposersOnWillUnmount);
  } // return the disposer as is if invoked as a non decorator


  if (typeof propertyKeyOrFunction !== "string") {
    return propertyKeyOrFunction;
  }
}

if (!__WEBPACK_IMPORTED_MODULE_0_react__["Component"]) throw new Error("mobx-react requires React to be available");
if (!__WEBPACK_IMPORTED_MODULE_1_mobx__["y" /* spy */]) throw new Error("mobx-react requires mobx to be available");
if (typeof __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] === "function") Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["j" /* configure */])({
  reactionScheduler: __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"]
});
var onError = function onError(fn) {
  return errorsReporter.on(fn);
};

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
  var mobx = {
    spy: __WEBPACK_IMPORTED_MODULE_1_mobx__["y" /* spy */],
    extras: {
      getDebugName: __WEBPACK_IMPORTED_MODULE_1_mobx__["m" /* getDebugName */]
    }
  };
  var mobxReact = {
    renderReporter: renderReporter,
    componentByNodeRegistry: componentByNodeRegistry,
    componentByNodeRegistery: componentByNodeRegistry,
    trackComponents: trackComponents
  };

  __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx);
}




/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(172);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__mixins__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_0__mixins__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__background__ = __webpack_require__(359);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__background__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__background__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__background__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1__background__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__background__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(122);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__colors__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_2__colors__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__debounce__ = __webpack_require__(360);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__debounce__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__debounce__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DOM__ = __webpack_require__(361);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_4__DOM__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_4__DOM__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_4__DOM__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_4__DOM__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_4__DOM__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_4__DOM__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_4__DOM__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_4__DOM__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_4__DOM__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphics__ = __webpack_require__(362);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__graphics__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_5__graphics__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prop_types__ = __webpack_require__(363);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(173);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__styles__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__styles__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_7__styles__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_7__styles__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__styles__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_7__styles__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_7__styles__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_7__styles__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__(176);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__object__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_8__object__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_8__object__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__responsive__ = __webpack_require__(368);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_9__responsive__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__responsive__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(369);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__throttle__ = __webpack_require__(370);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_11__throttle__["a"]; });













/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultProps; });
/* unused harmony export extendDefaultTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(123);


var defaultProps = {
  theme: __WEBPACK_IMPORTED_MODULE_1__themes__["a" /* base */]
};
var extendDefaultTheme = function extendDefaultTheme(theme) {
  defaultProps.theme = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["l" /* deepMerge */])(__WEBPACK_IMPORTED_MODULE_1__themes__["a" /* base */], theme);
};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(328);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["o"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contexts__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__themes__ = __webpack_require__(123);
/* unused harmony namespace reexport */





/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapProps */
/* unused harmony export withProps */
/* unused harmony export withPropsOnChange */
/* unused harmony export withHandlers */
/* unused harmony export defaultProps */
/* unused harmony export renameProp */
/* unused harmony export renameProps */
/* unused harmony export flattenProp */
/* unused harmony export withState */
/* unused harmony export withStateHandlers */
/* unused harmony export withReducer */
/* unused harmony export branch */
/* unused harmony export renderComponent */
/* unused harmony export renderNothing */
/* unused harmony export shouldUpdate */
/* unused harmony export pure */
/* unused harmony export onlyUpdateForKeys */
/* unused harmony export onlyUpdateForPropTypes */
/* unused harmony export withContext */
/* unused harmony export getContext */
/* unused harmony export lifecycle */
/* unused harmony export toClass */
/* unused harmony export toRenderProps */
/* unused harmony export fromRenderProps */
/* unused harmony export setStatic */
/* unused harmony export setPropTypes */
/* unused harmony export setDisplayName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compose; });
/* unused harmony export getDisplayName */
/* unused harmony export wrapDisplayName */
/* unused harmony export isClassComponent */
/* unused harmony export createSink */
/* unused harmony export componentFromProp */
/* unused harmony export nest */
/* unused harmony export hoistStatics */
/* unused harmony export componentFromStream */
/* unused harmony export componentFromStreamWithConfig */
/* unused harmony export mapPropsStream */
/* unused harmony export mapPropsStreamWithConfig */
/* unused harmony export createEventHandler */
/* unused harmony export createEventHandlerWithConfig */
/* unused harmony export setObservableConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_shallowEqual__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_change_emitter__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_symbol_observable__ = __webpack_require__(170);
/* unused harmony reexport shallowEqual */










var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */

    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + "(" + getDisplayName(BaseComponent) + ")";
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }

    return MapProps;
  };
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, typeof input === 'function' ? input(props) : input);
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }

  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }

  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.state = {
          computedProps: propsMapper(_this.props),
          prevProps: _this.props
        };
        return _this;
      }

      WithPropsOnChange.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (shouldMap(prevState.prevProps, nextProps)) {
          return {
            computedProps: propsMapper(nextProps),
            prevProps: nextProps
          };
        }

        return {
          prevProps: nextProps
        };
      };

      var _proto = WithPropsOnChange.prototype;

      _proto.render = function render() {
        return factory(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, this.state.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object(__WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__["a" /* polyfill */])(WithPropsOnChange);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }

    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */


  return result;
};

var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(WithHandlers, _Component);

      function WithHandlers() {
        var _this;

        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
          _args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(_args)) || this;
        _this.handlers = mapValues(typeof handlers === 'function' ? handlers(_this.props) : handlers, function (createHandler) {
          return function () {
            var handler = createHandler(_this.props);

            if (false) {
              console.error( // eslint-disable-line no-console
              'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
            }

            return handler.apply(void 0, arguments);
          };
        });
        return _this;
      }

      var _proto = WithHandlers.prototype;

      _proto.render = function render() {
        return factory(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }

    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };

    DefaultProps.defaultProps = props;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }

    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, obj);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }

  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _extends2;

    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, omit(props, [oldName]), (_extends2 = {}, _extends2[newName] = props[oldName], _extends2));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }

  return hoc;
};

var keys = Object.keys;

var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */

    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */

    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }

  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var FlattenProp = function FlattenProp(props) {
      return factory(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }

    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(WithState, _Component);

      function WithState() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        };

        _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        };

        return _this;
      }

      var _proto = WithState.prototype;

      _proto.render = function render() {
        var _extends2;

        return factory(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }

    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _this;

        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
          _args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(_args)) || this;
        _this.state = typeof initialState === 'function' ? initialState(_this.props) : initialState;
        _this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
          return function (mayBeEvent) {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            // Having that functional form of setState can be called async
            // we need to persist SyntheticEvent
            if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
              mayBeEvent.persist();
            }

            _this.setState(function (state, props) {
              return handler(state, props).apply(void 0, [mayBeEvent].concat(args));
            });
          };
        });
        return _this;
      }

      var _proto = WithStateHandlers.prototype;

      _proto.render = function render() {
        return factory(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }

    return WithStateHandlers;
  };
};

var noop = function noop() {};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(WithReducer, _Component);

      function WithReducer() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.state = {
          stateValue: _this.initializeStateValue()
        };

        _this.dispatch = function (action, callback) {
          if (callback === void 0) {
            callback = noop;
          }

          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          }, function () {
            return callback(_this.state.stateValue);
          });
        };

        return _this;
      }

      var _proto = WithReducer.prototype;

      _proto.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }

        return reducer(undefined, {
          type: '@@recompose/INIT'
        });
      };

      _proto.render = function render() {
        var _extends2;

        return factory(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[dispatchName] = this.dispatch, _extends2)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }

    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left, right) {
  if (right === void 0) {
    right = identity;
  }

  return function (BaseComponent) {
    var leftFactory;
    var rightFactory;

    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }

      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }

    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);

    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };

    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }

    return RenderComponent;
  };
};

var Nothing =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Nothing, _Component);

  function Nothing() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Nothing.prototype;

  _proto.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ShouldUpdate, _Component);

      function ShouldUpdate() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = ShouldUpdate.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      _proto.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }

    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }

  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ("component with display name \"" + getDisplayName(BaseComponent) + "\"."));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }

  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(WithContext, _Component);

      function WithContext() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;

        _this.getChildContext = function () {
          return getChildContext(_this.props);
        };

        return _this;
      }

      var _proto = WithContext.prototype;

      _proto.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }

    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var GetContext = function GetContext(ownerProps, context) {
      return factory(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }

    return GetContext;
  };
};

var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _Component);

      function Lifecycle() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = Lifecycle.prototype;

      _proto.render = function render() {
        return factory(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }

    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  var _class, _temp;

  return isClassComponent(baseComponent) ? baseComponent : (_temp = _class =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ToClass, _Component);

    function ToClass() {
      return _Component.apply(this, arguments) || this;
    }

    var _proto = ToClass.prototype;

    _proto.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }

      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = getDisplayName(baseComponent), _class.propTypes = baseComponent.propTypes, _class.contextTypes = baseComponent.contextTypes, _class.defaultProps = baseComponent.defaultProps, _temp);
};

function toRenderProps(hoc) {
  var RenderPropsComponent = function RenderPropsComponent(props) {
    return props.children(props);
  };

  return hoc(RenderPropsComponent);
}

var fromRenderProps = function fromRenderProps(RenderPropsComponent, propsMapper, renderPropName) {
  if (renderPropName === void 0) {
    renderPropName = 'children';
  }

  return function (BaseComponent) {
    var baseFactory = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createFactory(BaseComponent);
    var renderPropsFactory = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createFactory(RenderPropsComponent);

    var FromRenderProps = function FromRenderProps(ownerProps) {
      var _renderPropsFactory;

      return renderPropsFactory((_renderPropsFactory = {}, _renderPropsFactory[renderPropName] = function () {
        return baseFactory(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownerProps, propsMapper.apply(void 0, arguments)));
      }, _renderPropsFactory));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'fromRenderProps'))(FromRenderProps);
    }

    return FromRenderProps;
  };
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

var compose = function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  }, function (arg) {
    return arg;
  });
};

var createSink = function createSink(callback) {
  var Sink =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Sink, _Component);

    function Sink() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      _this.state = {};
      return _this;
    }

    Sink.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
      callback(nextProps);
      return null;
    };

    var _proto = Sink.prototype;

    _proto.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Object(__WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__["a" /* polyfill */])(Sink);
  return Sink;
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };

  Component$$1.displayName = "componentFromProp(" + propName + ")";
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = new Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);

  var Nest = function Nest(_ref) {
    var children = _ref.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["children"]);

    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = "nest(" + displayNames.join(', ') + ")";
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent, blacklist) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(NewComponent, BaseComponent, blacklist);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return (
      /*#__PURE__*/
      function (_Component) {
        Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ComponentFromStream, _Component);

        function ComponentFromStream() {
          var _config$fromESObserva;

          var _this;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = _Component.call.apply(_Component, [this].concat(args)) || this;
          _this.state = {
            vdom: null
          };
          _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_7_change_emitter__["createChangeEmitter"])();
          _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
            subscribe: function subscribe(observer) {
              var unsubscribe = _this.propsEmitter.listen(function (props) {
                if (props) {
                  observer.next(props);
                } else {
                  observer.complete();
                }
              });

              return {
                unsubscribe: unsubscribe
              };
            }
          }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_8_symbol_observable__["a" /* default */]] = function () {
            return this;
          }, _config$fromESObserva));
          _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$));
          return _this;
        }

        var _proto = ComponentFromStream.prototype;

        _proto.componentWillMount = function componentWillMount() {
          var _this2 = this;

          // Subscribe to child prop changes so we know when to re-render
          this.subscription = this.vdom$.subscribe({
            next: function next(vdom) {
              _this2.setState({
                vdom: vdom
              });
            }
          });
          this.propsEmitter.emit(this.props);
        };

        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          // Receive new props from the owner
          this.propsEmitter.emit(nextProps);
        };

        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
          return nextState.vdom !== this.state.vdom;
        };

        _proto.componentWillUnmount = function componentWillUnmount() {
          // Call without arguments to complete stream
          this.propsEmitter.emit(); // Clean-up subscription before un-mounting

          this.subscription.unsubscribe();
        };

        _proto.render = function render() {
          return this.state.vdom;
        };

        return ComponentFromStream;
      }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])
    );
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream$$1 = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;
      return componentFromStream$$1(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_8_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }

  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_7_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_8_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};
var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box__ = __webpack_require__(331);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Box__["a"]; });


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(528)(module)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_props__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons__ = __webpack_require__(800);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["A"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes__ = __webpack_require__(248);
/* unused harmony namespace reexport */




/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return withDocs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return withFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return withForwardRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withAnnounce; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_getDisplayName__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_getDisplayName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_getDisplayName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contexts__ = __webpack_require__(36);
/* unused harmony reexport withTheme */
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/no-multi-comp */






var doc = function doc() {
  return function (x) {
    return x;
  };
}; // Do not use the documentation wrapper in production.


if (false) {
  doc = function doc(component) {
    return require("./" + component + "/doc").doc;
  }; // eslint-disable-line

}

var withDocs = doc;
var withFocus = function withFocus(WrappedComponent) {
  var FocusableComponent =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(FocusableComponent, _Component);

    function FocusableComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mouseActive", false);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        focus: false,
        wrappedRef: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef()
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidMount", function () {
        var wrappedRef = _this.state.wrappedRef;
        window.addEventListener('mousedown', _this.handleActiveMouse); // we could be using onFocus in the wrapper node itself
        // but react does not invoke it if you programically
        // call wrapperNode.focus() inside componentWillUnmount
        // see Drop "this.originalFocusedElement.focus();" for reference

        var wrapperNode = wrappedRef.current;

        if (wrapperNode && wrapperNode.addEventListener) {
          wrapperNode.addEventListener('focus', _this.setFocus);
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
        var wrappedRef = _this.state.wrappedRef;
        window.removeEventListener('mousedown', _this.handleActiveMouse);
        var wrapperNode = wrappedRef.current;

        if (wrapperNode && wrapperNode.addEventListener) {
          wrapperNode.removeEventListener('focus', _this.setFocus);
        }

        clearTimeout(_this.focusTimer);
        clearTimeout(_this.mouseTimer);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleActiveMouse", function () {
        // from https://marcysutton.com/button-focus-hell/
        _this.mouseActive = true; // this avoids showing focus when clicking around

        clearTimeout(_this.mouseTimer); // empirical number to reset mouseActive after
        // some time has passed without mousedown

        _this.mouseTimer = setTimeout(function () {
          _this.mouseActive = false;
        }, 150);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setFocus", function () {
        // delay setting focus to avoid interupting events,
        // 1ms was chosen empirically based on ie11 using Select and TextInput
        // with and without a FormField.
        clearTimeout(_this.focusTimer);
        _this.focusTimer = setTimeout(function () {
          var focus = _this.state.focus;

          if (!focus && !_this.mouseActive) {
            _this.setState({
              focus: true
            });
          }
        }, 1);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resetFocus", function () {
        clearTimeout(_this.focusTimer);
        _this.focusTimer = setTimeout(function () {
          var focus = _this.state.focus;

          if (focus) {
            _this.setState({
              focus: false
            });
          }
        }, 1);
      });

      return _this;
    }

    FocusableComponent.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      var withFocusRef = nextProps.withFocusRef;
      var wrappedRef = prevState.wrappedRef;
      var nextWrappedRef = withFocusRef || wrappedRef;

      if (nextWrappedRef !== wrappedRef) {
        return {
          wrappedRef: nextWrappedRef
        };
      }

      return null;
    };

    var _proto = FocusableComponent.prototype;

    _proto.render = function render() {
      var _this2 = this;

      var _this$props = this.props,
          _onFocus = _this$props.onFocus,
          _onBlur = _this$props.onBlur,
          withFocusRef = _this$props.withFocusRef,
          rest = _objectWithoutPropertiesLoose(_this$props, ["onFocus", "onBlur", "withFocusRef"]);

      var _this$state = this.state,
          focus = _this$state.focus,
          wrappedRef = _this$state.wrappedRef;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
        ref: wrappedRef,
        focus: focus
      }, rest, {
        onFocus: function onFocus(event) {
          _this2.setFocus();

          if (_onFocus) {
            _onFocus(event);
          }
        },
        onBlur: function onBlur(event) {
          _this2.resetFocus();

          if (_onBlur) {
            _onBlur(event);
          }
        }
      }));
    };

    return FocusableComponent;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  var ForwardRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FocusableComponent, _extends({}, props, {
      withFocusRef: ref
    }));
  });
  ForwardRef.displayName = __WEBPACK_IMPORTED_MODULE_1_recompose_getDisplayName___default()(WrappedComponent);
  ForwardRef.name = ForwardRef.displayName;
  ForwardRef.defaultProps = WrappedComponent.defaultProps;
  __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(ForwardRef, WrappedComponent);
  return ForwardRef;
};
var withForwardRef = function withForwardRef(WrappedComponent) {
  var ForwardRefComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
      forwardRef: ref
    }, props));
  });
  ForwardRefComponent.displayName = __WEBPACK_IMPORTED_MODULE_1_recompose_getDisplayName___default()(WrappedComponent);
  ForwardRefComponent.name = ForwardRefComponent.displayName;
  ForwardRefComponent.defaultProps = WrappedComponent.defaultProps;
  __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(ForwardRefComponent, WrappedComponent);
  return ForwardRefComponent;
};
var withAnnounce = function withAnnounce(WrappedComponent) {
  var ForwardRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__contexts__["a" /* AnnounceContext */].Consumer, null, function (announce) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, props, {
        announce: announce,
        ref: ref
      }));
    });
  });
  ForwardRef.displayName = __WEBPACK_IMPORTED_MODULE_1_recompose_getDisplayName___default()(WrappedComponent);
  ForwardRef.name = ForwardRef.displayName;
  ForwardRef.defaultProps = WrappedComponent.defaultProps;
  __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(ForwardRef, WrappedComponent);
  return ForwardRef;
};


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_state_AppState__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var BookElement={};BookElement.isNotSelected=function(path){return __WEBPACK_IMPORTED_MODULE_0_app_state_AppState__["a" /* default */].selectedSection[1]!==path[1];};BookElement.extractChapterNumber=function(path){return path[1].replace(/chapter /i,'');};BookElement.extractTitleFromPath=function(path){return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.chain(path).last().split(' ').map(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.capitalize).join(' ').value();};/* harmony default export */ __webpack_exports__["a"] = (BookElement);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet__ = __webpack_require__(7);
var _templateObject=_taggedTemplateLiteral(['\n  cursor: pointer;\n'],['\n  cursor: pointer;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Button=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1_grommet__["d" /* Box */])(_templateObject);/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(157)('wks');
var uid = __webpack_require__(109);
var Symbol = __webpack_require__(21).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(322);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_styles__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(378);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var colorCss = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(['', ' ', ' g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill="none"]{stroke-width:0;}}*[stroke*="#"],*[STROKE*="#"]{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*="#"],*[FILL*="#"]{fill:inherit;stroke:none;}'], function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_grommet_styles__["b" /* colorStyle */])('fill', props.color || props.theme.global.colors.icon, props.theme);
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_grommet_styles__["b" /* colorStyle */])('stroke', props.color || props.theme.global.colors.icon, props.theme);
});

var IconInner = function IconInner(_ref) {
  var a11yTitle = _ref.a11yTitle,
      color = _ref.color,
      size = _ref.size,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ['a11yTitle', 'color', 'size', 'theme']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', _extends({ 'aria-label': a11yTitle }, rest));
};
IconInner.displayName = 'Icon';

var StyledIcon = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(IconInner).withConfig({
  displayName: 'StyledIcon',
  componentId: 'ofa7kd-0'
})(['display:inline-block;flex:0 0 auto;', ' ', ' ', ''], function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === undefined ? 'medium' : _ref2$size,
      theme = _ref2.theme;
  return '\n    width: ' + (theme.icon.size[size] || size) + ';\n    height: ' + (theme.icon.size[size] || size) + ';\n  ';
}, function (_ref3) {
  var color = _ref3.color;
  return color !== 'plain' && colorCss;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme && theme.icon.extend;
});

StyledIcon.defaultProps = {};
Object.setPrototypeOf(StyledIcon.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);



/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function isElement(el) {
  return el != null && typeof el === 'object' && (el.nodeType === 1 || el.nodeType === 11);
}

function canOverflow(overflow, skipOverflowHiddenElements) {
  if (skipOverflowHiddenElements && overflow === 'hidden') {
    return false;
  }

  return overflow !== 'visible' && overflow !== 'clip';
}

function isScrollable(el, skipOverflowHiddenElements) {
  if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
    var style = getComputedStyle(el, null);
    return canOverflow(style.overflowY, skipOverflowHiddenElements) || canOverflow(style.overflowX, skipOverflowHiddenElements);
  }

  return false;
}

function alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
  if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) {
    return 0;
  }

  if (elementEdgeStart < scrollingEdgeStart && elementSize < scrollingSize || elementEdgeEnd > scrollingEdgeEnd && elementSize > scrollingSize) {
    return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
  }

  if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) {
    return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
  }

  return 0;
}

var compute = (function (target, options) {
  var scrollMode = options.scrollMode,
      block = options.block,
      inline = options.inline,
      boundary = options.boundary,
      skipOverflowHiddenElements = options.skipOverflowHiddenElements;
  var checkBoundary = typeof boundary === 'function' ? boundary : function (node) {
    return node !== boundary;
  };

  if (!isElement(target)) {
    throw new TypeError('Invalid target');
  }

  var scrollingElement = document.scrollingElement || document.documentElement;
  var frames = [];
  var cursor = target;

  while (isElement(cursor) && checkBoundary(cursor)) {
    cursor = cursor.parentNode || cursor.host;

    if (cursor === scrollingElement) {
      frames.push(cursor);
      break;
    }

    if (cursor === document.body && isScrollable(cursor) && !isScrollable(document.documentElement)) {
      continue;
    }

    if (isScrollable(cursor, skipOverflowHiddenElements)) {
      frames.push(cursor);
    }
  }

  var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
  var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
  var viewportX = window.scrollX || pageXOffset;
  var viewportY = window.scrollY || pageYOffset;

  var _target$getBoundingCl = target.getBoundingClientRect(),
      targetHeight = _target$getBoundingCl.height,
      targetWidth = _target$getBoundingCl.width,
      targetTop = _target$getBoundingCl.top,
      targetRight = _target$getBoundingCl.right,
      targetBottom = _target$getBoundingCl.bottom,
      targetLeft = _target$getBoundingCl.left;

  var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
  var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
  var computations = [];

  for (var index = 0; index < frames.length; index++) {
    var frame = frames[index];

    var _frame$getBoundingCli = frame.getBoundingClientRect(),
        _height = _frame$getBoundingCli.height,
        _width = _frame$getBoundingCli.width,
        _top = _frame$getBoundingCli.top,
        right = _frame$getBoundingCli.right,
        bottom = _frame$getBoundingCli.bottom,
        _left = _frame$getBoundingCli.left;

    if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= _top && targetBottom <= bottom && targetLeft >= _left && targetRight <= right) {
      return computations;
    }

    var frameStyle = getComputedStyle(frame);
    var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
    var borderTop = parseInt(frameStyle.borderTopWidth, 10);
    var borderRight = parseInt(frameStyle.borderRightWidth, 10);
    var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
    var blockScroll = 0;
    var inlineScroll = 0;
    var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
    var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;

    if (scrollingElement === frame) {
      if (block === 'start') {
        blockScroll = targetBlock;
      } else if (block === 'end') {
        blockScroll = targetBlock - viewportHeight;
      } else if (block === 'nearest') {
        blockScroll = alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
      } else {
        blockScroll = targetBlock - viewportHeight / 2;
      }

      if (inline === 'start') {
        inlineScroll = targetInline;
      } else if (inline === 'center') {
        inlineScroll = targetInline - viewportWidth / 2;
      } else if (inline === 'end') {
        inlineScroll = targetInline - viewportWidth;
      } else {
        inlineScroll = alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
      }

      blockScroll = Math.max(0, blockScroll + viewportY);
      inlineScroll = Math.max(0, inlineScroll + viewportX);
    } else {
      if (block === 'start') {
        blockScroll = targetBlock - _top - borderTop;
      } else if (block === 'end') {
        blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
      } else if (block === 'nearest') {
        blockScroll = alignNearest(_top, bottom, _height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
      } else {
        blockScroll = targetBlock - (_top + _height / 2) + scrollbarHeight / 2;
      }

      if (inline === 'start') {
        inlineScroll = targetInline - _left - borderLeft;
      } else if (inline === 'center') {
        inlineScroll = targetInline - (_left + _width / 2) + scrollbarWidth / 2;
      } else if (inline === 'end') {
        inlineScroll = targetInline - right + borderRight + scrollbarWidth;
      } else {
        inlineScroll = alignNearest(_left, right, _width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
      }

      var scrollLeft = frame.scrollLeft,
          scrollTop = frame.scrollTop;
      blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - _height + scrollbarHeight));
      inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - _width + scrollbarWidth));
      targetBlock += scrollTop - blockScroll;
      targetInline += scrollLeft - inlineScroll;
    }

    computations.push({
      el: frame,
      top: blockScroll,
      left: inlineScroll
    });
  }

  return computations;
});

function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}

function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }

  var canSmoothScroll = 'scrollBehavior' in document.body.style;
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;

    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}

function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }

  if (isOptionsObject(options)) {
    return options;
  }

  return {
    block: 'start',
    inline: 'nearest'
  };
}

function scrollIntoView(target, options) {
  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(compute(target, options));
  }

  var computeOptions = getOptions(options);
  return defaultBehavior(compute(target, computeOptions), computeOptions.behavior);
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var ScrollIntoViewIfNeeded = function (_PureComponent) {
  inherits(ScrollIntoViewIfNeeded, _PureComponent);

  function ScrollIntoViewIfNeeded() {
    classCallCheck(this, ScrollIntoViewIfNeeded);

    var _this = possibleConstructorReturn(this, (ScrollIntoViewIfNeeded.__proto__ || Object.getPrototypeOf(ScrollIntoViewIfNeeded)).call(this));

    _this.handleScrollIntoViewIfNeeded = function () {
      var options = _this.props.options;
      var node = _this.node.current;

      scrollIntoView(node, options);
    };

    _this.node = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();
    return _this;
  }

  createClass(ScrollIntoViewIfNeeded, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var active = this.props.active;

      if (active) {
        this.handleScrollIntoViewIfNeeded();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref) {
      var active = _ref.active;
      var isNowActive = this.props.active;

      if (!active && isNowActive) {
        this.handleScrollIntoViewIfNeeded();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          elementType = _props.elementType,
          children = _props.children,
          options = _props.options,
          wrapperProps = objectWithoutProperties(_props, ['active', 'elementType', 'children', 'options']);

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(elementType, _extends({ ref: this.node }, wrapperProps), children);
    }
  }]);
  return ScrollIntoViewIfNeeded;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ScrollIntoViewIfNeeded.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  elementType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // this shape should mirror the scroll-into-view-if-needed options
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    behavior: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'smooth', 'instant']), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
    block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['center', 'end', 'nearest', 'start']),
    inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['center', 'end', 'nearest', 'start']),
    scrollMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['always', 'if-needed']),
    boundary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
    skipOverflowHiddenElements: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })
};
ScrollIntoViewIfNeeded.defaultProps = {
  active: true,
  elementType: 'div',
  options: {
    behavior: 'smooth',
    scrollMode: 'if-needed'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ScrollIntoViewIfNeeded);
//# sourceMappingURL=index.js.map


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Keyboard__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Keyboard__["a"]; });


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_BookElements_Accordion__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_BookElements_Carousel__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Figure__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_IFrame__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_List__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_Media__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_BookElements_Modal__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_BookElements_Picture__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_BookElements_Section__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_BookElements_SectionBreak__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_BookElements_Table__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_BookElements_Tabs__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_BookElements_Title__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_api_layoutEngine__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var layoutEngine=new __WEBPACK_IMPORTED_MODULE_18_app_api_layoutEngine__["a" /* default */]({accordion:__WEBPACK_IMPORTED_MODULE_3_app_components_BookElements_Accordion__["default"],audio:__WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_Media__["default"],carousel:__WEBPACK_IMPORTED_MODULE_5_app_components_BookElements_Carousel__["default"],critical:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"],disabled:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"],halt:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"],figure:__WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Figure__["default"],info:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"],interactive:__WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_IFrame__["default"],list:__WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_List__["default"],modal:__WEBPACK_IMPORTED_MODULE_10_app_components_BookElements_Modal__["default"],picture:__WEBPACK_IMPORTED_MODULE_11_app_components_BookElements_Picture__["default"],ok:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"],section:__WEBPACK_IMPORTED_MODULE_12_app_components_BookElements_Section__["default"],table:__WEBPACK_IMPORTED_MODULE_14_app_components_BookElements_Table__["default"],tabs:__WEBPACK_IMPORTED_MODULE_15_app_components_BookElements_Tabs__["default"],title:__WEBPACK_IMPORTED_MODULE_16_app_components_BookElements_Title__["default"],unknown:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"],video:__WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_Media__["default"],warning:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"]});function compileLayoutData(path,content,index){var data=void 0;if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isString(content)){data={type:"paragraph",path:[].concat(_toConsumableArray(path),[index])};}else{var key=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(content)[0];key=key.replace(new RegExp(content[key].prefix,"i"),"").replace(new RegExp(content[key].postfix,"i"),"");key=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.trim(key);var type=key.split(" ")[0];data={type:type,path:[].concat(_toConsumableArray(path),[index,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(content)[0]])};}return data;}var Composite=function(_React$Component){_inherits(Composite,_React$Component);function Composite(){_classCallCheck(this,Composite);return _possibleConstructorReturn(this,(Composite.__proto__||Object.getPrototypeOf(Composite)).apply(this,arguments));}_createClass(Composite,[{key:"render",value:function render(){var _props=this.props,path=_props.path,content=_props.content;if(__WEBPACK_IMPORTED_MODULE_17_app_api_bookElement__["a" /* default */].isNotSelected(path))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(content,function(content,index){return layoutEngine.render(compileLayoutData(path,content,index));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_BookElements_SectionBreak__["default"],null));}}]);return Composite;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Composite.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * book elements array
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]))};Composite.defaultProps={content:[]};/* harmony default export */ __webpack_exports__["default"] = (Composite);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(137);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(610);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(614);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(137);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var scrollIntoViewOptions={behavior:'instant',block:'start'};function TableOfContentsEntry(_ref){var AppState=_ref.AppState,selectedPath=_ref.path,children=_ref.children;var elementPath=AppState.selectedSectionItem;if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.chain(AppState.selectedSectionItem).last().isInteger().value()){elementPath=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.dropRight(AppState.selectedSectionItem);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(elementPath,selectedPath)},children);}/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(TableOfContentsEntry)));

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Text__ = __webpack_require__(432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Text__["a"]; });


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaProperties = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.formatTime = formatTime;
exports.isVideoChild = isVideoChild;
exports.mergeAndSortChildren = mergeAndSortChildren;
exports.deprecatedWarning = deprecatedWarning;
exports.throttle = throttle;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @file format-time.js
 *
 * Format seconds as a time string, H:MM:SS or M:SS
 * Supplying a guide (in seconds) will force a number of leading zeros
 * to cover the length of the guide
 *
 * @param  {Number} seconds Number of seconds to be turned into a string
 * @param  {Number} guide   Number (in seconds) to model the string after
 * @return {String}         Time formatted as H:MM:SS or M:SS
 * @private
 * @function formatTime
 */
function formatTime() {
  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;

  var s = Math.floor(seconds % 60);
  var m = Math.floor(seconds / 60 % 60);
  var h = Math.floor(seconds / 3600);
  var gm = Math.floor(guide / 60 % 60);
  var gh = Math.floor(guide / 3600);

  // handle invalid times
  if (isNaN(seconds) || seconds === Infinity) {
    // '-' is false for all relational operators (e.g. <, >=) so this setting
    // will add the minimum number of fields specified by the guide
    h = m = s = '-';
  }

  // Check if we need to show hours
  h = h > 0 || gh > 0 ? h + ':' : '';

  // If hours are showing, we may need to add a leading zero.
  // Always show at least one digit of minutes.
  m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':';

  // Check if leading zero is need for seconds
  s = s < 10 ? '0' + s : s;

  return h + m + s;
}

// Check if the element belongs to a video element
// only accept <source />, <track />,
// <MyComponent isVideoChild />
// elements
function isVideoChild(c) {
  if (c.props && c.props.isVideoChild) {
    return true;
  }
  return c.type === 'source' || c.type === 'track';
}

var find = function find(elements, func) {
  return elements.filter(func)[0];
};

// check if two components are the same type
var isTypeEqual = function isTypeEqual(component1, component2) {
  var type1 = component1.type;
  var type2 = component2.type;

  if (typeof type1 === 'string' || typeof type2 === 'string') {
    return type1 === type2;
  }

  if (typeof type1 === 'function' && typeof type2 === 'function') {
    return type1.displayName === type2.displayName;
  }

  return false;
};

// merge default children
// sort them by `order` property
// filter them by `disabled` property
function mergeAndSortChildren(defaultChildren, _children, _parentProps) {
  var defaultOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  var children = _react2.default.Children.toArray(_children);
  var parentProps = _extends({}, _parentProps);
  return children.filter(function (e) {
    return !e.props.disabled;
  }) // filter the disabled components
  .concat(defaultChildren.filter(function (c) {
    return !find(children, function (component) {
      return isTypeEqual(component, c);
    });
  })).map(function (element) {
    var defaultComponent = find(defaultChildren, function (c) {
      return isTypeEqual(c, element);
    });
    delete parentProps.order;
    var defaultProps = defaultComponent ? defaultComponent.props : {};
    var props = _extends({}, parentProps, defaultProps, element.props);
    var e = _react2.default.cloneElement(element, props, element.props.children);
    return e;
  }).sort(function (a, b) {
    return (a.props.order || defaultOrder) - (b.props.order || defaultOrder);
  });
}

/**
 * Temporary utility for generating the warnings
 */
function deprecatedWarning(oldMethodCall, newMethodCall) {
  // eslint-disable-next-line no-console
  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon! Please use ' + newMethodCall + ' instead.');
}

function throttle(callback, limit) {
  var _arguments = arguments;

  var wait = false;
  return function () {
    if (!wait) {
      callback.apply(null, _arguments);
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  };
}

var mediaProperties = exports.mediaProperties = ['error', 'src', 'srcObject', 'currentSrc', 'crossOrigin', 'networkState', 'preload', 'buffered', 'readyState', 'seeking', 'currentTime', 'duration', 'paused', 'defaultPlaybackRate', 'playbackRate', 'played', 'seekable', 'ended', 'autoplay', 'loop', 'mediaGroup', 'controller', 'controls', 'volume', 'muted', 'defaultMuted', 'audioTracks', 'videoTracks', 'textTracks', 'width', 'height', 'videoWidth', 'videoHeight', 'poster'];

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_content_logo_svg__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_content_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_content_logo_svg__);
var _templateObject=_taggedTemplateLiteral(["\n  max-width: 100%;\n  min-height: 175px;\n"],["\n  max-width: 100%;\n  min-height: 175px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledBox=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_grommet__["d" /* Box */])(_templateObject);function SectionBreak(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledBox,{justify:"start",align:"center",pad:{top:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"TRADOC Logo",width:24,height:24,src:__WEBPACK_IMPORTED_MODULE_3_content_logo_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet__["m" /* Text */],{color:"dark-6"},"Supplement"));}/* harmony default export */ __webpack_exports__["default"] = (SectionBreak);

/***/ }),
/* 32 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var core = __webpack_require__(24);
var hide = __webpack_require__(48);
var redefine = __webpack_require__(59);
var ctx = __webpack_require__(60);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var theme={global:{colors:{brand:'#000000',black:'#000000',focus:'#FEC325',text:'#444444',white:'#FFFFFF','accent-1':'#f5c24c','accent-2':'#DDDDDD','accent-3':'#DDD0A1','accent-4':'#C9B469','accent-5':'#f7f7f7','neutral-1':'#CA3C45','neutral-2':'#0554A3','neutral-3':'#333333','neutral-4':'#262826','status-critical':'#EB6060','status-error':'#EB6060','status-warning':'#F7E463','status-ok':'#7CD992','status-info':'#0554A3','status-unknown':'#a8a8a8','status-disabled':'#a8a8a8','status-halt':'#f2e36c','dark-1':'#333333','dark-2':'#444444','dark-3':'#555555','dark-4':'#666666','dark-5':'#777777','dark-6':'#999999','light-1':'#F6F6F6','light-2':'#EEEEEE','light-3':'#DDDDDD','light-4':'#CCCCCC','light-5':'#BBBBBB','light-6':'#AAAAAA'}},anchor:{color:{dark:'#0554A3',light:'#0554A3'}},button:{border:{radius:'0px'}},icon:{colors:{brand:'#000000',black:'#000000',focus:'#FEC325',text:'#444444',white:'#FFFFFF','accent-1':'#f5c24c','accent-2':'#E9E4D3','accent-3':'#DDD0A1','accent-4':'#C9B469','neutral-1':'#CA3C45','neutral-2':'#0554A3','neutral-3':'#696B5D','neutral-4':'#262826','status-critical':'#EB6060','status-error':'#EB6060','status-warning':'#F7E463','status-ok':'#7CD992','status-info':'#0554A3','status-unknown':'#a8a8a8','status-disabled':'#a8a8a8'}},paragraph:{small:{size:'14px',height:'20px',maxWidth:'336px'},medium:{size:'18px',height:'24px',maxWidth:'600px'},large:{size:'22px',height:'28px',maxWidth:'600px'},xlarge:{size:'26px',height:'32px',maxWidth:'600px'}}};/*
const base = {
  global: {
    animation: {
      duration: '1s',
      jiggle: {
        duration: '0.1s'
      }
    },
    borderSize: {
      xsmall: '1px',
      small: '2px',
      medium: '4px',
      large: '12px',
      xlarge: '24px',
      narrow: {
        xsmall: '1px',
        small: '2px',
        medium: '4px',
        large: '6px',
        xlarge: '12px'
      }
    },
    breakpoints: {
      narrow: 699
    },
    colors: {
      active: 'rgba(221,221,221,0.5)',
      black: '#000000',
      border: 'rgba(0, 0, 0, 0.33)',
      'border-light': 'rgba(0, 0, 0, 0.33)',
      'border-dark': 'rgba(255, 255, 255, 0.33)',
      brand: '#7D4CDB',
      focus: '#FD6FFF',
      placeholder: '#AAAAAA',
      text: '#444444',
      white: '#FFFFFF',
      'accent-1': '#FD6FFF',
      'accent-2': '#61EC9F',
      'accent-3': '#60EBE1',
      'accent-4': '#FFCA58',
      'dark-1': '#333333',
      'dark-2': '#444444',
      'dark-3': '#555555',
      'dark-4': '#666666',
      'dark-5': '#777777',
      'dark-6': '#999999',
      'light-1': '#F6F6F6',
      'light-2': '#EEEEEE',
      'light-3': '#DDDDDD',
      'light-4': '#CCCCCC',
      'light-5': '#BBBBBB',
      'light-6': '#AAAAAA',
      'neutral-1': '#3D138D',
      'neutral-2': '#BE60EB',
      'neutral-3': '#00C781',
      'neutral-4': '#6194EB',
      'neutral-5': '#FFB202',
      'status-critical': '#EB6060',
      'status-error': '#EB6060',
      'status-warning': '#F7E463',
      'status-ok': '#7CD992',
      'status-unknown': '#a8a8a8',
      'status-disabled': '#a8a8a8'
    },
    control: {
      border: {
        width: '2px',
        color: {
          dark: [
            null
          ],
          light: [
            null
          ]
        }
      },
      color: {
        dark: [
          null
        ],
        light: [
          null
        ]
      }
    },
    drop: {
      background: '#ffffff',
      border: {
        width: '0px',
        radius: '0px'
      },
      shadow: {
        light: '0px 3px 8px rgba(100, 100, 100, 0.50)',
        dark: '0px 3px 8px rgba(255, 255, 255, 0.40)'
      }
    },
    edgeSize: {
      none: '0',
      hair: '1px',
      xxsmall: '3px',
      xsmall: '6px',
      small: '12px',
      medium: '24px',
      large: '48px',
      xlarge: '96px',
      narrow: {
        none: '0',
        hair: '1px',
        xxsmall: '2px',
        xsmall: '3px',
        small: '6px',
        medium: '12px',
        large: '24px',
        xlarge: '48px'
      }
    },
    elevation: {
      light: {
        none: 'none',
        xsmall: '0px 1px 2px rgba(100, 100, 100, 0.50)',
        small: '0px 2px 4px rgba(100, 100, 100, 0.50)',
        medium: '0px 3px 8px rgba(100, 100, 100, 0.50)',
        large: '0px 6px 12px rgba(100, 100, 100, 0.50)',
        xlarge: '0px 8px 16px rgba(100, 100, 100, 0.50)'
      },
      dark: {
        none: 'none',
        xsmall: '0px 2px 2px rgba(255, 255, 255, 0.40)',
        small: '0px 4px 4px rgba(255, 255, 255, 0.40)',
        medium: '0px 6px 8px rgba(255, 255, 255, 0.40)',
        large: '0px 8px 16px rgba(255, 255, 255, 0.40)',
        xlarge: '0px 10px 24px rgba(255, 255, 255, 0.40)'
      }
    },
    focus: {
      border: {
        color: [
          null
        ],
        width: '2px'
      }
    },
    font: {
      size: '18px',
      height: '24px',
      maxWidth: '432px'
    },
    hover: {
      background: {
        dark: {
          color: 'active',
          opacity: 'medium'
        },
        light: {
          color: 'active',
          opacity: 'medium'
        }
      },
      color: {
        dark: 'white',
        light: 'black'
      }
    },
    input: {
      border: {
        width: '1px',
        radius: '4px'
      },
      weight: 600
    },
    opacity: {
      strong: '0.8',
      medium: '0.4',
      weak: '0.1'
    },
    spacing: '24px',
    size: {
      xxsmall: '48px',
      xsmall: '96px',
      small: '192px',
      medium: '384px',
      large: '768px',
      xlarge: '1152px',
      full: '100%',
      narrow: {
        xxsmall: '24px',
        xsmall: '48px',
        small: '96px',
        medium: '192px',
        large: '384px',
        xlarge: '768px',
        full: '100%'
      }
    },
    text: {
      color: {
        dark: '#f8f8f8',
        light: '#444444'
      }
    }
  },
  accordion: {
    icons: {}
  },
  anchor: {
    textDecoration: 'none',
    fontWeight: 600,
    color: {
      dark: '#6194EB',
      light: '#6194EB'
    }
  },
  button: {
    border: {
      width: '2px',
      radius: '18px'
    },
    primary: {
      color: {
        dark: [
          null
        ],
        light: [
          null
        ]
      }
    },
    disabled: {
      opacity: 0.3
    },
    minWidth: '96px',
    maxWidth: '384px',
    padding: {
      vertical: '4px',
      horizontal: '22px'
    }
  },
  calendar: {
    small: {
      fontSize: '14px',
      lineHeight: 1.375,
      daySize: '27.428571428571427px',
      slideDuration: '0.2s'
    },
    medium: {
      fontSize: '18px',
      lineHeight: 1.45,
      daySize: '54.857142857142854px',
      slideDuration: '0.5s'
    },
    large: {
      fontSize: '22px',
      lineHeight: 1.11,
      daySize: '109.71428571428571px',
      slideDuration: '0.8s'
    },
    icons: {
      small: {}
    }
  },
  carousel: {
    icons: {}
  },
  checkBox: {
    border: {
      color: {
        dark: 'rgba(255, 255, 255, 0.5)',
        light: 'rgba(0, 0, 0, 0.15)'
      },
      radius: '4px',
      width: '2px'
    },
    check: {
      width: '4px'
    },
    icons: {},
    hover: {
      border: {
        color: {
          dark: [
            null
          ],
          light: [
            null
          ]
        }
      }
    },
    size: '24px',
    toggle: {
      color: {
        dark: '#d9d9d9',
        light: '#d9d9d9'
      },
      radius: '24px',
      size: '48px'
    }
  },
  clock: {
    analog: {
      hour: {
        color: {
          dark: [
            null
          ],
          light: [
            null
          ]
        },
        width: '8px',
        size: '24px',
        shape: 'round'
      },
      minute: {
        color: {
          dark: [
            null
          ],
          light: [
            null
          ]
        },
        width: '4px',
        size: '12px',
        shape: 'round'
      },
      second: {
        color: {
          dark: [
            null
          ],
          light: [
            null
          ]
        },
        width: '3px',
        size: '9px',
        shape: 'round'
      },
      size: {
        small: '72px',
        medium: '96px',
        large: '144px',
        xlarge: '216px',
        huge: '288px'
      }
    },
    digital: {
      text: {
        xsmall: {
          size: '10px',
          height: 1.5
        },
        small: {
          size: '14px',
          height: 1.43
        },
        medium: {
          size: '18px',
          height: 1.375
        },
        large: {
          size: '22px',
          height: 1.167
        },
        xlarge: {
          size: '26px',
          height: 1.1875
        },
        xxlarge: {
          size: '34px',
          height: 1.125
        }
      }
    }
  },
  collapsible: {
    minSpeed: 150,
    baseHeight: 500
  },
  dataTable: {
    body: {
      pad: {
        horizontal: 'small',
        vertical: 'xsmall'
      }
    },
    footer: {
      border: {
        side: 'top',
        size: 'small'
      },
      pad: {
        horizontal: 'small',
        vertical: 'xsmall'
      }
    },
    groupHeader: {
      border: {
        side: 'bottom',
        size: 'xsmall'
      },
      pad: {
        horizontal: 'small',
        vertical: 'xsmall'
      },
      background: {
        dark: 'dark-2',
        light: 'light-2'
      }
    },
    header: {
      border: {
        side: 'bottom',
        size: 'small'
      },
      pad: {
        horizontal: 'small',
        vertical: 'xsmall'
      },
      background: {
        dark: 'dark-1',
        light: 'light-1'
      }
    },
    icons: {},
    resize: {
      border: {
        side: 'right',
        color: {
          dark: 'border-dark',
          light: 'border-light'
        }
      }
    }
  },
  formField: {
    border: {
      color: {
        dark: 'border-dark',
        light: 'border-light'
      },
      position: 'inner',
      side: 'bottom',
      error: {
        color: {
          dark: 'white',
          light: 'status-critical'
        }
      }
    },
    error: {
      color: {
        dark: 'status-critical',
        light: 'status-critical'
      }
    },
    help: {
      color: {
        dark: 'dark-5',
        light: 'dark-5'
      }
    },
    label: {}
  },
  grommet: {},
  heading: {
    font: {},
    level: {
      '1': {
        small: {
          size: '34px',
          height: '40px',
          maxWidth: '816px'
        },
        medium: {
          size: '50px',
          height: '56px',
          maxWidth: '1200px'
        },
        large: {
          size: '82px',
          height: '88px',
          maxWidth: '1968px'
        }
      },
      '2': {
        small: {
          size: '26px',
          height: '32px',
          maxWidth: '624px'
        },
        medium: {
          size: '34px',
          height: '40px',
          maxWidth: '816px'
        },
        large: {
          size: '50px',
          height: '56px',
          maxWidth: '1200px'
        }
      },
      '3': {
        small: {
          size: '22px',
          height: '28px',
          maxWidth: '528px'
        },
        medium: {
          size: '22px',
          height: '28px',
          maxWidth: '528px'
        },
        large: {
          size: '34px',
          height: '40px',
          maxWidth: '816px'
        }
      },
      '4': {
        small: {
          size: '18px',
          height: '24px',
          maxWidth: '432px'
        },
        medium: {
          size: '18px',
          height: '24px',
          maxWidth: '432px'
        },
        large: {
          size: '18px',
          height: '24px',
          maxWidth: '432px'
        }
      }
    },
    weight: 600
  },
  icon: {
    colors: {
      active: 'rgba(221,221,221,0.5)',
      black: '#000000',
      border: 'rgba(0, 0, 0, 0.33)',
      'border-light': 'rgba(0, 0, 0, 0.33)',
      'border-dark': 'rgba(255, 255, 255, 0.33)',
      brand: '#7D4CDB',
      focus: '#FD6FFF',
      placeholder: '#AAAAAA',
      text: '#444444',
      white: '#FFFFFF',
      'accent-1': '#FD6FFF',
      'accent-2': '#61EC9F',
      'accent-3': '#60EBE1',
      'accent-4': '#FFCA58',
      'dark-1': '#333333',
      'dark-2': '#444444',
      'dark-3': '#555555',
      'dark-4': '#666666',
      'dark-5': '#777777',
      'dark-6': '#999999',
      'light-1': '#F6F6F6',
      'light-2': '#EEEEEE',
      'light-3': '#DDDDDD',
      'light-4': '#CCCCCC',
      'light-5': '#BBBBBB',
      'light-6': '#AAAAAA',
      'neutral-1': '#3D138D',
      'neutral-2': '#BE60EB',
      'neutral-3': '#00C781',
      'neutral-4': '#6194EB',
      'neutral-5': '#FFB202',
      'status-critical': '#EB6060',
      'status-error': '#EB6060',
      'status-warning': '#F7E463',
      'status-ok': '#7CD992',
      'status-unknown': '#a8a8a8',
      'status-disabled': '#a8a8a8'
    }
  },
  iconThemes: {},
  layer: {
    background: 'white',
    border: {
      radius: '4px'
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.5)'
    }
  },
  menu: {
    icons: {}
  },
  paragraph: {
    small: {
      size: '14px',
      height: '20px',
      maxWidth: '336px'
    },
    medium: {
      size: '18px',
      height: '24px',
      maxWidth: '432px'
    },
    large: {
      size: '22px',
      height: '28px',
      maxWidth: '528px'
    },
    xlarge: {
      size: '26px',
      height: '32px',
      maxWidth: '624px'
    }
  },
  radioButton: {
    check: {},
    border: {
      color: {
        dark: 'rgba(255, 255, 255, 0.5)',
        light: 'rgba(0, 0, 0, 0.15)'
      },
      radius: '100%',
      width: '2px'
    },
    size: '24px'
  },
  rangeInput: {
    track: {
      height: '4px',
      color: {
        dark: [
          null
        ],
        light: [
          null
        ]
      }
    },
    thumb: {}
  },
  select: {
    icons: {},
    step: 20
  },
  text: {
    xsmall: {
      size: '12px',
      height: '18px',
      maxWidth: '288px'
    },
    small: {
      size: '14px',
      height: '20px',
      maxWidth: '336px'
    },
    medium: {
      size: '18px',
      height: '24px',
      maxWidth: '432px'
    },
    large: {
      size: '22px',
      height: '28px',
      maxWidth: '528px'
    },
    xlarge: {
      size: '26px',
      height: '32px',
      maxWidth: '624px'
    },
    xxlarge: {
      size: '34px',
      height: '40px',
      maxWidth: '816px'
    }
  },
  video: {
    captions: {
      background: 'rgba(0,0,0,0.7)'
    },
    icons: {}
  },
  worldMap: {
    continent: {
      active: '8px',
      base: '6px'
    },
    place: {
      active: '20px',
      base: '8px'
    }
  }
}
*//* harmony default export */ __webpack_exports__["a"] = (theme);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet__ = __webpack_require__(7);
var _templateObject=_taggedTemplateLiteral(['\n  max-width: 100%;\n  text-align: start;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  word-break: break-word;\n  hyphens: auto;\n'],['\n  max-width: 100%;\n  text-align: start;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  word-break: break-word;\n  hyphens: auto;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Paragraph=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1_grommet__["i" /* Paragraph */])(_templateObject);/* harmony default export */ __webpack_exports__["a"] = (Paragraph);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnnounceContext__ = __webpack_require__(353);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AnnounceContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResponsiveContext__ = __webpack_require__(355);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ResponsiveContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ThemeContext__ = __webpack_require__(357);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__ThemeContext__["a"]; });




/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_contents__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_BookElements_Paragraph__ = __webpack_require__(128);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LayoutEngine=function(){function LayoutEngine(){var elements=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_classCallCheck(this,LayoutEngine);// elements = object indexed by element type
this.elements=Object.assign({paragraph:__WEBPACK_IMPORTED_MODULE_2_app_components_BookElements_Paragraph__["default"]},elements);}_createClass(LayoutEngine,[{key:"render",value:function render(_ref){var type=_ref.type,path=_ref.path;var content=__WEBPACK_IMPORTED_MODULE_1_app_api_contents__["a" /* default */].get(path);var Element=this.elements[type];if(!Element)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Element,Object.assign({key:path},this.props,{path:path,content:content}));}}]);return LayoutEngine;}();/* harmony default export */ __webpack_exports__["a"] = (LayoutEngine);

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 39 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./content/book": 87,
	"./content/book.json": 87,
	"./content/book.yaml": 650,
	"./content/figures/m/map-afghanistan-transition.svg": 651,
	"./content/figures/m/map-bm-afghanistan-2005-2014.svg": 652,
	"./content/figures/m/map-figure-11-1.svg": 653,
	"./content/figures/m/map-figure-11-5.svg": 654,
	"./content/figures/m/map-figure-11-7.svg": 655,
	"./content/figures/m/map-figure-12-2.svg": 656,
	"./content/figures/m/map-figure-13-1.svg": 657,
	"./content/figures/m/map-figure-13-4.svg": 658,
	"./content/figures/m/map-figure-2-2.svg": 659,
	"./content/figures/m/map-figure-2-5.svg": 660,
	"./content/figures/m/map-figure-2-8.svg": 661,
	"./content/figures/m/map-figure-3-2.svg": 662,
	"./content/figures/m/map-figure-3-4.svg": 663,
	"./content/figures/m/map-figure-3-5.svg": 664,
	"./content/figures/m/map-figure-3-7.svg": 665,
	"./content/figures/m/map-figure-3-9.svg": 666,
	"./content/figures/m/map-figure-4-2.svg": 667,
	"./content/figures/m/map-figure-4-4.svg": 668,
	"./content/figures/m/map-figure-4-5.svg": 669,
	"./content/figures/m/map-figure-5-2.svg": 670,
	"./content/figures/m/map-figure-5-6.svg": 671,
	"./content/figures/m/map-figure-5-m.svg": 672,
	"./content/figures/m/map-figure-6-1.svg": 673,
	"./content/figures/m/map-figure-6-3.svg": 674,
	"./content/figures/m/map-figure-6-m.svg": 675,
	"./content/figures/m/map-figure-7-4.svg": 676,
	"./content/figures/m/map-figure-7-7.svg": 677,
	"./content/figures/m/map-figure-7-m.svg": 678,
	"./content/figures/m/map-figure-8-1.svg": 679,
	"./content/figures/m/map-figure-8-11.svg": 680,
	"./content/figures/m/map-figure-8-2.svg": 681,
	"./content/figures/m/map-figure-8-5.svg": 682,
	"./content/figures/m/map-figure-8-9.svg": 683,
	"./content/figures/m/map-figure-9-4.svg": 684,
	"./content/figures/m/map-figure-9-5.svg": 685,
	"./content/figures/m/map-fm-AfghanistanProvincialBoundaries.svg": 686,
	"./content/figures/m/map-s2-helmand-and-kandahar.svg": 687,
	"./content/figures/v2/Img_7-4.svg": 688,
	"./content/figures/v2/OEF_CVR2.png": 689,
	"./content/figures/v2/art_14-2.png": 690,
	"./content/figures/v2/art_S3-1.png": 691,
	"./content/figures/v2/art_sII-1.png": 692,
	"./content/figures/v2/grafik_9-4.png": 693,
	"./content/figures/v2/grafik_Fig1-1.png": 694,
	"./content/figures/v2/grafik_Fig1-6.png": 695,
	"./content/figures/v2/img_1-1.png": 696,
	"./content/figures/v2/img_1-3.png": 697,
	"./content/figures/v2/img_1-4.png": 698,
	"./content/figures/v2/img_1-5.png": 699,
	"./content/figures/v2/img_10-1.png": 700,
	"./content/figures/v2/img_10-2.png": 701,
	"./content/figures/v2/img_10-3.png": 702,
	"./content/figures/v2/img_11-1.png": 703,
	"./content/figures/v2/img_11-2.png": 704,
	"./content/figures/v2/img_11-3.png": 705,
	"./content/figures/v2/img_11-4.png": 706,
	"./content/figures/v2/img_11-5.png": 707,
	"./content/figures/v2/img_11-6.png": 708,
	"./content/figures/v2/img_12-1.png": 709,
	"./content/figures/v2/img_12-2.png": 710,
	"./content/figures/v2/img_12-3.png": 711,
	"./content/figures/v2/img_13-1.png": 712,
	"./content/figures/v2/img_13-2.png": 713,
	"./content/figures/v2/img_13-3.png": 714,
	"./content/figures/v2/img_13-4.png": 715,
	"./content/figures/v2/img_14-1.png": 716,
	"./content/figures/v2/img_2-1.png": 717,
	"./content/figures/v2/img_2-2.png": 718,
	"./content/figures/v2/img_2-3.png": 719,
	"./content/figures/v2/img_2-4.png": 720,
	"./content/figures/v2/img_3-1.png": 721,
	"./content/figures/v2/img_3-2.png": 722,
	"./content/figures/v2/img_3-3.png": 723,
	"./content/figures/v2/img_3-4.png": 724,
	"./content/figures/v2/img_3-5.png": 725,
	"./content/figures/v2/img_4-1.png": 726,
	"./content/figures/v2/img_4-2.png": 727,
	"./content/figures/v2/img_4-3.png": 728,
	"./content/figures/v2/img_4-4.png": 729,
	"./content/figures/v2/img_5-1.png": 730,
	"./content/figures/v2/img_5-2.png": 731,
	"./content/figures/v2/img_5-3.png": 732,
	"./content/figures/v2/img_5-4a.png": 733,
	"./content/figures/v2/img_5-4b.png": 734,
	"./content/figures/v2/img_5-5.png": 735,
	"./content/figures/v2/img_6-1.png": 736,
	"./content/figures/v2/img_6-2.png": 737,
	"./content/figures/v2/img_6-3.png": 738,
	"./content/figures/v2/img_7-1.png": 739,
	"./content/figures/v2/img_7-2.png": 740,
	"./content/figures/v2/img_7-2.svg": 741,
	"./content/figures/v2/img_7-3.png": 742,
	"./content/figures/v2/img_7-5.png": 743,
	"./content/figures/v2/img_7-6.png": 744,
	"./content/figures/v2/img_8-1.png": 745,
	"./content/figures/v2/img_8-2.png": 746,
	"./content/figures/v2/img_8-3.png": 747,
	"./content/figures/v2/img_8-4.png": 748,
	"./content/figures/v2/img_8-5.png": 749,
	"./content/figures/v2/img_8-6.png": 750,
	"./content/figures/v2/img_8-7.png": 751,
	"./content/figures/v2/img_9-1.png": 752,
	"./content/figures/v2/img_9-2.png": 753,
	"./content/figures/v2/img_9-3.png": 754,
	"./content/figures/v2/img_9-5.png": 755,
	"./content/figures/v2/img_cvr_oef2.png": 756,
	"./content/figures/v2/img_sII-2.png": 757,
	"./content/figures/v2/map_11-3.svg": 758,
	"./content/figures/v2/map_2-1.svg": 759,
	"./content/figures/v2/map_2-2.svg": 760,
	"./content/figures/v2/map_2-3.svg": 761,
	"./content/figures/v2/map_3-1.svg": 762,
	"./content/figures/v2/map_3-2.svg": 763,
	"./content/figures/v2/map_3-3.svg": 764,
	"./content/figures/v2/map_3-4.svg": 765,
	"./content/figures/v2/map_3-5.svg": 766,
	"./content/figures/v2/map_4-1.svg": 767,
	"./content/figures/v2/map_4-2.svg": 768,
	"./content/figures/v2/map_4-3.svg": 769,
	"./content/figures/v2/map_5-1.svg": 770,
	"./content/figures/v2/map_5-2.svg": 771,
	"./content/figures/v2/map_5-3.svg": 772,
	"./content/figures/v2/map_6-1.svg": 773,
	"./content/figures/v2/map_6-2.svg": 774,
	"./content/figures/v2/map_7-1.svg": 775,
	"./content/figures/v2/map_7-3.svg": 776,
	"./content/figures/v2/map_SIII-1.svg": 777,
	"./content/figures/v2/map_sII-1.svg": 778,
	"./content/iframe/ch14/VOLII_Ch14Conclusionv2.html": 779,
	"./content/iframe/ch2/OEF_VII_Ch_2_v2.html": 780,
	"./content/logo.svg": 218,
	"./content/media/audio.example.mp3": 781,
	"./content/media/media.example.poster.png": 782,
	"./content/media/video.example.mp4": 783
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(42);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableCell__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableCell__["a"]; });


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(68);
var IE8_DOM_DEFINE = __webpack_require__(197);
var toPrimitive = __webpack_require__(130);
var dP = Object.defineProperty;

exports.f = __webpack_require__(45) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(69)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__propertyUtils__ = __webpack_require__(631);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

var getComputedStyleX = void 0;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = value + 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box = void 0;
  var x = void 0;
  var y = void 0;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["c" /* getTransitionProperty */])(elem) || '';
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = presetH + 'px';
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = presetV + 'px';
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}

function setTransform(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["b" /* getTransformXY */])(elem);
  var resultXY = { x: originalXY.x, y: originalXY.y };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["d" /* setTransformXY */])(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);

    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["a" /* getTransformName */])() in document.body.style) {
    setTransform(elem, offset, option);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = void 0;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = void 0;
  var j = void 0;
  var i = void 0;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = '' + prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val = void 0;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },

  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i = void 0;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },

  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
      args[_key3] = arguments[_key3];
    }

    for (var i = 0; i < args.length; i++) {
      utils.mix(ret, args[i]);
    }
    return ret;
  },

  viewportWidth: 0,
  viewportHeight: 0
};

mix(utils, domUtils);

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(76);
var createDesc = __webpack_require__(156);
module.exports = __webpack_require__(58) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledTableCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StyledTableDataCaption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return StyledTableRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledTableBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StyledTableHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledTableFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var SIZE_MAP = {
  '1/2': '50%',
  '1/4': '25%',
  '2/4': '50%',
  '3/4': '75%',
  '1/3': '33.33%',
  '2/3': '66.66%'
};
var sizeStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["width:", ";max-width:", ";overflow:hidden;"], function (props) {
  return SIZE_MAP[props.size] || props.theme.global.size[props.size];
}, function (props) {
  return SIZE_MAP[props.size] || props.theme.global.size[props.size];
});
var StyledTableCell = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].td.withConfig({
  displayName: "StyledTable__StyledTableCell",
  componentId: "sc-1m3u5g-0"
})(["margin:0;padding:0;font-weight:inherit;text-align:inherit;height:100%;", " ", " ", ""], function (props) {
  return props.size && sizeStyle;
}, function (props) {
  return props.verticalAlign && "vertical-align: " + props.verticalAlign + ";";
}, function (props) {
  return props.tableContextTheme && props.tableContextTheme.extend;
});
StyledTableCell.defaultProps = {};
Object.setPrototypeOf(StyledTableCell.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledTableDataCaption = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].caption.withConfig({
  displayName: "StyledTable__StyledTableDataCaption",
  componentId: "sc-1m3u5g-1"
})(["display:none;"]);
StyledTableDataCaption.defaultProps = {};
Object.setPrototypeOf(StyledTableDataCaption.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledTableRow = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].tr.withConfig({
  displayName: "StyledTable__StyledTableRow",
  componentId: "sc-1m3u5g-2"
})(["height:100%;"]);
StyledTableRow.defaultProps = {};
Object.setPrototypeOf(StyledTableRow.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledTableBody = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].tbody.withConfig({
  displayName: "StyledTable__StyledTableBody",
  componentId: "sc-1m3u5g-3"
})([""]);
StyledTableBody.defaultProps = {};
Object.setPrototypeOf(StyledTableBody.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledTableHeader = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].thead.withConfig({
  displayName: "StyledTable__StyledTableHeader",
  componentId: "sc-1m3u5g-4"
})([""]);
StyledTableHeader.defaultProps = {};
Object.setPrototypeOf(StyledTableHeader.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledTableFooter = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].tfoot.withConfig({
  displayName: "StyledTable__StyledTableFooter",
  componentId: "sc-1m3u5g-5"
})([""]);
StyledTableFooter.defaultProps = {};
Object.setPrototypeOf(StyledTableFooter.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledTable = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].table.withConfig({
  displayName: "StyledTable",
  componentId: "sc-1m3u5g-6"
})(["border-spacing:0;border-collapse:collapse;", " ", ";"], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return props.theme.table && props.theme.table.extend;
});
StyledTable.defaultProps = {};
Object.setPrototypeOf(StyledTable.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var assign = make_assign()
var create = make_create()
var trim = make_trim()
var Global = (typeof window !== 'undefined' ? window : global)

module.exports = {
	assign: assign,
	create: create,
	trim: trim,
	bind: bind,
	slice: slice,
	each: each,
	map: map,
	pluck: pluck,
	isList: isList,
	isFunction: isFunction,
	isObject: isObject,
	Global: Global
}

function make_assign() {
	if (Object.assign) {
		return Object.assign
	} else {
		return function shimAssign(obj, props1, props2, etc) {
			for (var i = 1; i < arguments.length; i++) {
				each(Object(arguments[i]), function(val, key) {
					obj[key] = val
				})
			}			
			return obj
		}
	}
}

function make_create() {
	if (Object.create) {
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			return assign.apply(this, [Object.create(obj)].concat(assignArgsList))
		}
	} else {
		function F() {} // eslint-disable-line no-inner-declarations
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			F.prototype = obj
			return assign.apply(this, [new F()].concat(assignArgsList))
		}
	}
}

function make_trim() {
	if (String.prototype.trim) {
		return function trim(str) {
			return String.prototype.trim.call(str)
		}
	} else {
		return function trim(str) {
			return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')
		}
	}
}

function bind(obj, fn) {
	return function() {
		return fn.apply(obj, Array.prototype.slice.call(arguments, 0))
	}
}

function slice(arr, index) {
	return Array.prototype.slice.call(arr, index || 0)
}

function each(obj, fn) {
	pluck(obj, function(val, key) {
		fn(val, key)
		return false
	})
}

function map(obj, fn) {
	var res = (isList(obj) ? [] : {})
	pluck(obj, function(v, k) {
		res[k] = fn(v, k)
		return false
	})
	return res
}

function pluck(obj, fn) {
	if (isList(obj)) {
		for (var i=0; i<obj.length; i++) {
			if (fn(obj[i], i)) {
				return obj[i]
			}
		}
	} else {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				if (fn(obj[key], key)) {
					return obj[key]
				}
			}
		}
	}
}

function isList(val) {
	return (val != null && typeof val != 'function' && typeof val.length == 'number')
}

function isFunction(val) {
	return val && {}.toString.call(val) === '[object Function]'
}

function isObject(val) {
	return val && {}.toString.call(val) === '[object Object]'
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(38);
var core = __webpack_require__(39);
var ctx = __webpack_require__(196);
var hide = __webpack_require__(53);
var has = __webpack_require__(46);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(44);
var createDesc = __webpack_require__(90);
module.exports = __webpack_require__(45) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(200);
var defined = __webpack_require__(131);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(134)('wks');
var uid = __webpack_require__(93);
var Symbol = __webpack_require__(38).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  max-width: 600px;\n  max-height: 600px;\n  margin: 32px auto;\n'],['\n  max-width: 600px;\n  max-height: 600px;\n  margin: 32px auto;\n']),_templateObject2=_taggedTemplateLiteral(['\n  max-width: 100%;\n  height: auto;\n'],['\n  max-width: 100%;\n  height: auto;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject);var Image=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].img(_templateObject2);var Picture=function(_React$Component){_inherits(Picture,_React$Component);function Picture(){_classCallCheck(this,Picture);return _possibleConstructorReturn(this,(Picture.__proto__||Object.getPrototypeOf(Picture)).apply(this,arguments));}_createClass(Picture,[{key:'render',value:function render(){var content=this.props.content;var source=content.source.startsWith('http')?content.source:__webpack_require__(40)("./content"+content.source);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet__["d" /* Box */],{'aria-label':'figure',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:source,alt:content.caption}),content.caption&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet__["m" /* Text */],{weight:'bold',textAlign:'center'},content.caption)));}}]);return Picture;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["default"] = (Picture);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(107)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var hide = __webpack_require__(48);
var has = __webpack_require__(77);
var SRC = __webpack_require__(109)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(24).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(78);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Heading__ = __webpack_require__(402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Heading__["a"]; });


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Anchor__ = __webpack_require__(404);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Anchor__["a"]; });


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledDataTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledDataTableRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledDataTableBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StyledDataTableHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledDataTableFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var StyledDataTable = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].table.withConfig({
  displayName: "StyledDataTable",
  componentId: "xrlyjm-0"
})(["border-spacing:0;border-collapse:collapse;height:100%;", ";"], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */]);
StyledDataTable.defaultProps = {};
Object.setPrototypeOf(StyledDataTable.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledDataTableRow = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].tr.withConfig({
  displayName: "StyledDataTable__StyledDataTableRow",
  componentId: "xrlyjm-1"
})(["", ";"], function (props) {
  return props.size && "\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  ";
});
StyledDataTableRow.defaultProps = {};
Object.setPrototypeOf(StyledDataTableRow.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledDataTableBody = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].tbody.withConfig({
  displayName: "StyledDataTable__StyledDataTableBody",
  componentId: "xrlyjm-2"
})(["", ";"], function (props) {
  return props.size && "\n    display: block;\n    width: 100%;\n    max-height: " + props.theme.global.size[props.size] + ";\n    overflow: auto;\n  ";
});
StyledDataTableBody.defaultProps = {};
Object.setPrototypeOf(StyledDataTableBody.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledDataTableHeader = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].thead.withConfig({
  displayName: "StyledDataTable__StyledDataTableHeader",
  componentId: "xrlyjm-3"
})(["", ";"], function (props) {
  return props.size && "\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  ";
});
StyledDataTableHeader.defaultProps = {};
Object.setPrototypeOf(StyledDataTableHeader.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledDataTableFooter = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].tfoot.withConfig({
  displayName: "StyledDataTable__StyledDataTableFooter",
  componentId: "xrlyjm-4"
})(["", ";"], function (props) {
  return props.size && "\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  ";
});
StyledDataTableFooter.defaultProps = {};
Object.setPrototypeOf(StyledDataTableFooter.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderBy; });
/* unused harmony export compare */
var compareNumbers = function compareNumbers(numberA, numberB) {
  if (numberA < numberB) {
    return -1;
  }
  if (numberA > numberB) {
    return 1;
  }
  return 0;
};

var RE_NUMBERS = /(^0x[\da-fA-F]+$|^([+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?!\.\d+)(?=\D|\s|$))|\d+)/g;
var RE_LEADING_OR_TRAILING_WHITESPACES = /^\s+|\s+$/g; // trim pre-post whitespace
var RE_WHITESPACES = /\s+/g; // normalize all whitespace to single ' ' character
var RE_INT_OR_FLOAT = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/; // identify integers and floats
var RE_DATE = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[/-]\d{1,4}[/-]\d{1,4}|^\w+, \w+ \d+, \d{4})/; // identify date strings
var RE_LEADING_ZERO = /^0+[1-9]{1}[0-9]*$/;
var RE_UNICODE_CHARACTERS = /[^\x00-\x80]/;

var compareUnicode = function compareUnicode(stringA, stringB) {
  var result = stringA.localeCompare(stringB);
  return result ? result / Math.abs(result) : 0;
};

var stringCompare = function stringCompare(stringA, stringB) {
  if (stringA < stringB) {
    return -1;
  }
  if (stringA > stringB) {
    return 1;
  }
  return 0;
};

var compareChunks = function compareChunks(chunksA, chunksB) {
  var lengthA = chunksA.length;
  var lengthB = chunksB.length;
  var size = Math.min(lengthA, lengthB);
  for (var i = 0; i < size; i++) {
    var chunkA = chunksA[i];
    var chunkB = chunksB[i];
    if (chunkA !== chunkB) {
      if (chunkA === '' !== (chunkB === '')) {
        // empty strings have lowest value
        return chunkA === '' ? -1 : 1;
      }
      if (typeof chunkA === 'number' && typeof chunkB === 'number') {
        // compare numbers
        return compareNumbers(chunkA, chunkB);
      } else if (typeof chunkA === 'number' || typeof chunkB === 'number') {
        // number < string
        return typeof chunkA === 'number' ? -1 : 1;
      } else if (RE_UNICODE_CHARACTERS.test(chunkA + chunkB) && chunkA.localeCompare) {
        // use locale comparison only if one of the chunks contains unicode characters
        return compareUnicode(chunkA, chunkB);
      } else {
        // use common string comparison for performance reason
        return stringCompare(chunkA, chunkB);
      }
    }
  }
  // if the chunks are equal so far, the one which has more chunks is greater than the other one
  if (lengthA > size || lengthB > size) {
    return lengthA <= size ? -1 : 1;
  }
  return 0;
};

var compareOtherTypes = function compareOtherTypes(valueA, valueB) {
  if (!valueA.chunks ? valueB.chunks : !valueB.chunks) {
    return !valueA.chunks ? 1 : -1;
  }
  if (valueA.isNaN ? !valueB.isNaN : valueB.isNaN) {
    return valueA.isNaN ? -1 : 1;
  }
  if (valueA.isSymbol ? !valueB.isSymbol : valueB.isSymbol) {
    return valueA.isSymbol ? -1 : 1;
  }
  if (valueA.isObject ? !valueB.isObject : valueB.isObject) {
    return valueA.isObject ? -1 : 1;
  }
  if (valueA.isArray ? !valueB.isArray : valueB.isArray) {
    return valueA.isArray ? -1 : 1;
  }
  if (valueA.isFunction ? !valueB.isFunction : valueB.isFunction) {
    return valueA.isFunction ? -1 : 1;
  }
  if (valueA.isNull ? !valueB.isNull : valueB.isNull) {
    return valueA.isNull ? -1 : 1;
  }
  return 0;
};

var compareValues = function compareValues(valueA, valueB) {
  if (valueA.value === valueB.value) {
    return 0;
  }
  if (valueA.parsedNumber !== undefined && valueB.parsedNumber !== undefined) {
    return compareNumbers(valueA.parsedNumber, valueB.parsedNumber);
  }
  if (valueA.chunks && valueB.chunks) {
    return compareChunks(valueA.chunks, valueB.chunks);
  }
  return compareOtherTypes(valueA, valueB);
};

var compareMultiple = function compareMultiple(recordA, recordB, orders) {
  var valuesA = recordA.values;
  var valuesB = recordB.values;
  var length = valuesA.length;

  var ordersLength = orders.length;
  for (var i = 0; i < length; i++) {
    var order = i < ordersLength ? orders[i] : null;
    if (order && typeof order === 'function') {
      var result = order(valuesA[i].value, valuesB[i].value);
      if (result) {
        return result;
      }
    } else {
      var _result = compareValues(valuesA[i], valuesB[i]);
      if (_result) {
        return _result * (order === 'desc' ? -1 : 1);
      }
    }
  }
  return 0;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var createIdentifierFn = function createIdentifierFn(identifier) {
  if (typeof identifier === 'function') {
    // identifier is already a lookup function
    return identifier;
  }
  return function (value) {
    if (Array.isArray(value)) {
      var index = Number(identifier);
      if (Number.isInteger(index)) {
        return value[index];
      }
    } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof identifier !== 'function') {
      return value[identifier];
    }
    return value;
  };
};

var stringify = function stringify(value, caseSensitive) {
  if (typeof value === 'boolean' || value instanceof Boolean) {
    return Number(value).toString();
  }
  if (typeof value === 'number' || value instanceof Number) {
    return value.toString();
  }
  if (value instanceof Date) {
    return value.getTime().toString();
  }
  if (typeof value === 'string' || value instanceof String) {
    return (caseSensitive ? value : value.toLowerCase()).replace(RE_LEADING_OR_TRAILING_WHITESPACES, '');
  }
  return '';
};

var parseNumber = function parseNumber(value) {
  if (value.length !== 0) {
    var parsedNumber = Number(value);
    if (!Number.isNaN(parsedNumber)) {
      return parsedNumber;
    }
  }
  return undefined;
};

var parseDate = function parseDate(value) {
  if (RE_DATE.test(value)) {
    var parsedDate = Date.parse(value);
    if (!Number.isNaN(parsedDate)) {
      return parsedDate;
    }
  }
  return undefined;
};

var numberify = function numberify(value) {
  var parsedNumber = parseNumber(value);
  if (parsedNumber !== undefined) {
    return parsedNumber;
  }
  return parseDate(value);
};

var createChunks = function createChunks(value) {
  return value.replace(RE_NUMBERS, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0');
};

var normalizeChunk = function normalizeChunk(chunk, chunksLength) {
  if (RE_INT_OR_FLOAT.test(chunk) && (!RE_LEADING_ZERO.test(chunk) || chunksLength === 1)) {
    return parseNumber(chunk) || 0;
  }
  return chunk.replace(RE_WHITESPACES, ' ').replace(RE_LEADING_OR_TRAILING_WHITESPACES, '');
};

var createChunksList = function createChunksList(value) {
  var chunks = createChunks(value).map(function (chunk, index, array) {
    return normalizeChunk(chunk, array.length);
  });
  return chunks;
};

var isFunction = function isFunction(value) {
  return typeof value === 'function';
};

var isNaN = function isNaN(value) {
  return Number.isNaN(value) || value instanceof Number && Number.isNaN(value.valueOf());
};

var isNull = function isNull(value) {
  return value === null;
};

var isObject = function isObject(value) {
  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !Array.isArray(value) && !(value instanceof Number) && !(value instanceof String) && !(value instanceof Boolean) && !(value instanceof Date);
};

var isSymbol = function isSymbol(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol';
};

var isUndefined = function isUndefined(value) {
  return value === undefined;
};

var getMappedValueRecord = function getMappedValueRecord() {
  var caseSensitive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (value) {
    if (typeof value === 'string' || value instanceof String || (typeof value === 'number' || value instanceof Number) && !isNaN(value) || typeof value === 'boolean' || value instanceof Boolean || value instanceof Date) {
      var stringValue = stringify(value, caseSensitive);
      var parsedNumber = numberify(stringValue);
      var chunks = createChunksList(parsedNumber ? '' + parsedNumber : stringValue);
      return {
        parsedNumber: parsedNumber,
        chunks: chunks,
        value: value
      };
    }
    return {
      isArray: Array.isArray(value),
      isFunction: isFunction(value),
      isNaN: isNaN(value),
      isNull: isNull(value),
      isObject: isObject(value),
      isSymbol: isSymbol(value),
      isUndefined: isUndefined(value),
      value: value
    };
  };
};

var getValueByIdentifier = function getValueByIdentifier(value, getValue) {
  return getValue(value);
};

var getElementByIndex = function getElementByIndex(collection, index) {
  return collection[index];
};

var baseOrderBy = function baseOrderBy(collection, identifiers, orders) {
  var identifierFns = identifiers.length ? identifiers.map(createIdentifierFn) : [function (value) {
    return value;
  }];

  // temporary array holds elements with position and sort-values
  var mappedCollection = collection.map(function (element, index) {
    var values = identifierFns.map(function (identifier) {
      return getValueByIdentifier(element, identifier);
    }).map(getMappedValueRecord());
    return {
      index: index,
      values: values
    };
  });

  // iterate over values and compare values until a != b or last value reached
  mappedCollection.sort(function (recordA, recordB) {
    return compareMultiple(recordA, recordB, orders);
  });

  return mappedCollection.map(function (element) {
    return getElementByIndex(collection, element.index);
  });
};

var getIdentifiers = function getIdentifiers(identifiers) {
  if (!identifiers) {
    return [];
  }
  var identifierList = !Array.isArray(identifiers) ? [identifiers] : [].concat(identifiers);
  if (identifierList.some(function (identifier) {
    return typeof identifier !== 'string' && typeof identifier !== 'number' && typeof identifier !== 'function';
  })) {
    return [];
  }
  return identifierList;
};

var getOrders = function getOrders(orders) {
  if (!orders) {
    return [];
  }
  var orderList = !Array.isArray(orders) ? [orders] : [].concat(orders);
  if (orderList.some(function (order) {
    return order !== 'asc' && order !== 'desc' && typeof order !== 'function';
  })) {
    return [];
  }
  return orderList;
};

/**
 * Creates an array of elements, natural sorted by specified identifiers and
 * the corresponding sort orders. This method implements a stable sort
 * algorithm, which means the original sort order of equal elements is
 * preserved.
 *
 * If `collection` is an array of primitives, `identifiers` may be unspecified.
 * Otherwise, you should specify `identifiers` to sort by or `collection` will
 * be returned unsorted. An identifier can expressed by:
 *
 * - an index position, if `collection` is a nested array,
 * - a property name, if `collection` is an array of objects,
 * - a function which returns a particular value from an element of a nested array or an array of objects. This function will be invoked by passing one element of `collection`.
 *
 * If `orders` is unspecified, all values are sorted in ascending order.
 * Otherwise, specify an order of `'desc'` for descending or `'asc'` for
 * ascending sort order of corresponding values. You may also specify a compare
 * function for an order, which will be invoked by two arguments:
 * `(valueA, valueB)`. It must return a number representing the sort order.
 *
 * @example
 *
 * import { orderBy } from 'natural-orderby';
 *
 * const users = [
 *   {
 *     username: 'Bamm-Bamm',
 *     ip: '192.168.5.2',
 *     datetime: 'Fri Jun 15 2018 16:48:00 GMT+0200 (CEST)'
 *   },
 *   {
 *     username: 'Wilma',
 *     ip: '192.168.10.1',
 *     datetime: '14 Jun 2018 00:00:00 PDT'
 *   },
 *   {
 *     username: 'dino',
 *     ip: '192.168.0.2',
 *     datetime: 'June 15, 2018 14:48:00'
 *   },
 *   {
 *     username: 'Barney',
 *     ip: '192.168.1.1',
 *     datetime: 'Thu, 14 Jun 2018 07:00:00 GMT'
 *   },
 *   {
 *     username: 'Pebbles',
 *     ip: '192.168.1.21',
 *     datetime: '15 June 2018 14:48 UTC'
 *   },
 *   {
 *     username: 'Hoppy',
 *     ip: '192.168.5.10',
 *     datetime: '2018-06-15T14:48:00.000Z'
 *   },
 * ];
 *
 * orderBy(
 *   users,
 *   [v => v.datetime, v => v.ip],
 *   ['desc', 'asc']
 * );
 *
 * // => [
 * //      {
 * //        username: 'dino',
 * //        ip: '192.168.0.2',
 * //        datetime: 'June 15, 2018 14:48:00',
 * //      },
 * //      {
 * //        username: 'Pebbles',
 * //        ip: '192.168.1.21',
 * //        datetime: '15 June 2018 14:48 UTC',
 * //      },
 * //      {
 * //        username: 'Bamm-Bamm',
 * //        ip: '192.168.5.2',
 * //        datetime: 'Fri Jun 15 2018 16:48:00 GMT+0200 (CEST)',
 * //      },
 * //      {
 * //        username: 'Hoppy',
 * //        ip: '192.168.5.10',
 * //        datetime: '2018-06-15T14:48:00.000Z',
 * //      },
 * //      {
 * //        username: 'Barney',
 * //        ip: '192.168.1.1',
 * //        datetime: 'Thu, 14 Jun 2018 07:00:00 GMT',
 * //      },
 * //      {
 * //        username: 'Wilma',
 * //        ip: '192.168.10.1',
 * //        datetime: '14 Jun 2018 00:00:00 PDT',
 * //      },
 * //    ]
 */
function orderBy(collection, identifiers, orders) {
  if (!collection || !Array.isArray(collection)) {
    return [];
  }

  var validatedIdentifiers = getIdentifiers(identifiers);
  var validatedOrders = getOrders(orders);

  return baseOrderBy(collection, validatedIdentifiers, validatedOrders);
}

var baseCompare = function baseCompare(options) {
  return function (valueA, valueB) {
    var getMappedValueRecord$$1 = getMappedValueRecord(options.caseSensitive);
    var a = getMappedValueRecord$$1(valueA);
    var b = getMappedValueRecord$$1(valueB);

    var result = compareValues(a, b);
    return result * (options.order === 'desc' ? -1 : 1);
  };
};

var defaultOptions = {
  caseSensitive: true,
  order: 'asc'
};


var getOptions = function getOptions(customOptions) {
  if (!customOptions || (typeof customOptions === 'undefined' ? 'undefined' : _typeof(customOptions)) !== 'object') {
    return defaultOptions;
  }
  return {
    caseSensitive: typeof customOptions.caseSensitive === 'boolean' ? customOptions.caseSensitive : defaultOptions.caseSensitive,
    order: customOptions.order === 'asc' || customOptions.order === 'desc' ? customOptions.order : defaultOptions.order
  };
};

/**
 * Creates a compare function that defines the natural sort order considering
 * the given `options` which may be passed to [`Array.prototype.sort()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort).
 *
 * If `options` or its property `caseSensitive` is unspecified, values are
 * sorted case sensitive. Otherwise, specify `true` for case sensitive or
 * `false` for case insensitive sorting.
 *
 * If `options` or its property `order` is unspecified, values are sorted in
 * ascending sort order. Otherwise, specify an order of `'desc'` for descending
 * or `'asc'` for ascending sort order of values.
 *
 * @example
 *
 * import { compare } from 'natural-orderby';
 *
 * const users = [
 *   {
 *     username: 'Bamm-Bamm',
 *     lastLogin: {
 *       ip: '192.168.5.2',
 *       datetime: 'Fri Jun 15 2018 16:48:00 GMT+0200 (CEST)'
 *     },
 *   },
 *   {
 *     username: 'Wilma',
 *     lastLogin: {
 *       ip: '192.168.10.1',
 *       datetime: '14 Jun 2018 00:00:00 PDT'
 *     },
 *   },
 *   {
 *     username: 'dino',
 *     lastLogin: {
 *       ip: '192.168.0.2',
 *       datetime: 'June 15, 2018 14:48:00'
 *     },
 *   },
 *   {
 *     username: 'Barney',
 *     lastLogin: {
 *       ip: '192.168.1.1',
 *       datetime: 'Thu, 14 Jun 2018 07:00:00 GMT'
 *     },
 *   },
 *   {
 *     username: 'Pebbles',
 *     lastLogin: {
 *       ip: '192.168.1.21',
 *       datetime: '15 June 2018 14:48 UTC'
 *     },
 *   },
 *   {
 *     username: 'Hoppy',
 *     lastLogin: {
 *       ip: '192.168.5.10',
 *       datetime: '2018-06-15T14:48:00.000Z'
 *     },
 *   },
 * ];
 *
 * users.sort((a, b) => compare()(a.ip, b.ip));
 *
 * // => [
 * //      {
 * //        username: 'dino',
 * //        ip: '192.168.0.2',
 * //        datetime: 'June 15, 2018 14:48:00'
 * //      },
 * //      {
 * //        username: 'Barney',
 * //        ip: '192.168.1.1',
 * //        datetime: 'Thu, 14 Jun 2018 07:00:00 GMT'
 * //      },
 * //      {
 * //        username: 'Pebbles',
 * //        ip: '192.168.1.21',
 * //        datetime: '15 June 2018 14:48 UTC'
 * //      },
 * //      {
 * //        username: 'Bamm-Bamm',
 * //        ip: '192.168.5.2',
 * //        datetime: 'Fri Jun 15 2018 16:48:00 GMT+0200 (CEST)'
 * //      },
 * //      {
 * //        username: 'Hoppy',
 * //        ip: '192.168.5.10',
 * //        datetime: '2018-06-15T14:48:00.000Z'
 * //      },
 * //      {
 * //        username: 'Wilma',
 * //        ip: '192.168.10.1',
 * //        datetime: '14 Jun 2018 00:00:00 PDT'
 * //      }
 * //    ]
 */
function compare(options) {
  var validatedOptions = getOptions(options);

  return baseCompare(validatedOptions);
}


//# sourceMappingURL=natural-orderby.es.js.map


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchFromStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stopword__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stopword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stopword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_book__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_contents__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_state_stores_BookmarkStore__ = __webpack_require__(572);
var fetchFromStorage=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var storedAppState;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual("production","development")){_context.next=3;break;}_context.next=3;return __WEBPACK_IMPORTED_MODULE_4_store___default.a.get(JSON.stringify(__WEBPACK_IMPORTED_MODULE_5_app_api_book__["a" /* default */].metadata));case 3:_context.next=5;return __WEBPACK_IMPORTED_MODULE_4_store___default.a.get(JSON.stringify(__WEBPACK_IMPORTED_MODULE_5_app_api_book__["a" /* default */].metadata));case 5:storedAppState=_context.sent;if(storedAppState){Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["a" /* applySnapshot */])(appState,JSON.parse(storedAppState));}return _context.abrupt("return",appState);case 8:case"end":return _context.stop();}}},_callee,this);}));return function fetchFromStorage(){return _ref2.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var AppState=__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].model({_selectedSection:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].array(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].union(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].string,__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].integer)),_selectedSectionItem:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].array(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].union(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].string,__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].integer)),menuBarContents:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].enumeration("MENU_BAR_CONTENTS",["MAIN_MENU","BOOKMARKS_MENU","USER_IS_BOOKMARKING","USER_IS_DELETING","USER_IS_CLEARING","USER_IS_ANNOTATING","BOOKMARKING_MENU"]),isFullscreen:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].boolean,isTOCMenuOpen:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].boolean,isBookmarksMenuOpen:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].boolean,isSearchResultsOpen:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].boolean,isUserSearching:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].boolean,bookmarkingSelectionPath:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].array(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].union(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].string,__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].integer)),bookmarkingSelectionContent:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].string,bookmarkingNote:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].string,bookmarks:__WEBPACK_IMPORTED_MODULE_7_app_state_stores_BookmarkStore__["a" /* default */],bookmarkToDelete:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].array(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].union(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].string,__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].integer)),searchTerm:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].string,searchResults:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].frozen(),searchStatus:__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["c" /* types */].enumeration("SEARCH_RESULTS_STATUS",["SEARCH_RESULTS_PENDING","SEARCH_RESULTS_FOUND","SEARCH_RESULTS_EMPTY"])}).views(function(self){return{get isSearchResultsPending(){return self.searchStatus==="SEARCH_RESULTS_PENDING";},get isSearchResultsFound(){return self.searchStatus==="SEARCH_RESULTS_FOUND";},get isSearchResultsEmpty(){return self.searchStatus==="SEARCH_RESULTS_EMPTY";},get isMainMenuBar(){return self.menuBarContents==="MAIN_MENU";},get isBookmarksMenuBar(){return self.menuBarContents==="BOOKMARKS_MENU";},get isBookmarkingMenuBar(){return self.menuBarContents==="BOOKMARKING_MENU";},get isUserBookmarking(){return self.menuBarContents==="USER_IS_BOOKMARKING";},get isUserAnnotating(){return self.menuBarContents==="USER_IS_ANNOTATING";},get isUserDeleting(){return self.menuBarContents==="USER_IS_DELETING";},get isUserClearing(){return self.menuBarContents==="USER_IS_CLEARING";},get selectedSectionItem(){return self._selectedSectionItem.slice();},get selectedSection(){return self._selectedSection.slice();},get hasSearchResults(){return!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(self.searchResults,{matches:[]});}};}).actions(function(self){return{setSearchStatus:function setSearchStatus(content){self.searchStatus=content;},setMenuBar:function setMenuBar(content){self.menuBarContents=content;},toggleFullscreen:function toggleFullscreen(){self.isFullscreen=!self.isFullscreen;},toggleTOCMenu:function toggleTOCMenu(){self.isBookmarksMenuOpen=false;self.isUserSearching=false;self.isSearchResultsOpen=false;self.isTOCMenuOpen=!self.isTOCMenuOpen;},toggleSearchResults:function toggleSearchResults(){self.isBookmarksMenuOpen=false;self.isTOCMenuOpen=false;self.isSearchResultsOpen=!self.isSearchResultsOpen;self.isUserSearching=!self.isUserSearching;},toggleBookmarksMenu:function toggleBookmarksMenu(){self.isTOCMenuOpen=false;self.isUserSearching=false;self.isSearchResultsOpen=false;self.isBookmarksMenuOpen=!self.isBookmarksMenuOpen;if(!self.isBookmarksMenuBar){self.setMenuBar("BOOKMARKS_MENU");}else{self.setMenuBar("MAIN_MENU");}},closeMenus:function closeMenus(){self.isTOCMenuOpen=false;self.isBookmarksMenuOpen=false;self.isUserSearching=false;self.isSearchResultsOpen=false;},changeSectionItem:function changeSectionItem(sectionItem){//DEBUG:  console.log("IN AppState sectionItem " + sectionItem);
self._selectedSection=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.take(sectionItem,2);self._selectedSectionItem=sectionItem;},newBookmarkingSelection:function newBookmarkingSelection(_ref){var path=_ref.path,content=_ref.content;self.newBookmarkingSelectionPath(path);self.newBookmarkingSelectionContent(content);},newBookmarkingSelectionPath:function newBookmarkingSelectionPath(path){self.bookmarkingSelectionPath=path;},newBookmarkingSelectionContent:function newBookmarkingSelectionContent(content){self.bookmarkingSelectionContent=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isArray(content)?__WEBPACK_IMPORTED_MODULE_6_app_api_contents__["a" /* default */].get(content):content;},newBookmarkingNote:function newBookmarkingNote(note){self.bookmarkingNote=note;},resetBookmarkingSelection:function resetBookmarkingSelection(){self.bookmarkingSelectionPath=[];self.bookmarkingSelectionContent="";self.bookmarkingNote="";},resetBookmarkingNote:function resetBookmarkingNote(){self.bookmarkingNote="";},prepareToDeleteBookmark:function prepareToDeleteBookmark(path){self.bookmarkToDelete=path;},deleteBookmark:function deleteBookmark(){self.bookmarks.delete(self.bookmarkToDelete);},clearBookmarks:function clearBookmarks(){self.bookmarks.clearBookmarks();},newSearchTerm:function newSearchTerm(term){self.searchResults={matches:[]};term=__WEBPACK_IMPORTED_MODULE_3_stopword___default.a.removeStopwords(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.words(term)).join(" ");self.searchTerm=term;},newSearchResults:function newSearchResults(results){self.searchResults=results;},changeSearchStatus:function changeSearchStatus(status){self.searchStatus=status;}};});var appState=AppState.create({_selectedSection:["$","cover"],_selectedSectionItem:["$","cover"],menuBarContents:"MAIN_MENU",isFullscreen:false,isTOCMenuOpen:false,isBookmarksMenuOpen:false,isSearchResultsOpen:false,isUserSearching:false,bookmarkingSelectionPath:[],bookmarkingSelectionContent:"",bookmarkingNote:"",bookmarks:{collection:[]},bookmarkToDelete:[],searchTerm:"",searchResults:{matches:[]},searchStatus:"SEARCH_RESULTS_FOUND"});Object(__WEBPACK_IMPORTED_MODULE_1_mobx_state_tree__["b" /* onSnapshot */])(appState,function(storedAppState){// fetch AppState except search-related stuff
storedAppState=Object.assign({},storedAppState,{isSearchResultsOpen:false,isUserSearching:false,searchTerm:"",searchResults:{matches:[]}});__WEBPACK_IMPORTED_MODULE_4_store___default.a.set(JSON.stringify(__WEBPACK_IMPORTED_MODULE_5_app_api_book__["a" /* default */].metadata),JSON.stringify(storedAppState));});/* harmony default export */ __webpack_exports__["a"] = (appState);

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(580);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 600px;\n  hyphens: auto;\n'],['\n  width: 100%;\n  max-width: 600px;\n  hyphens: auto;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledParagraph=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].p(_templateObject);function Words(_ref){var path=_ref.path,content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledParagraph,null,content);}/* harmony default export */ __webpack_exports__["default"] = (Words);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_video_react__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_video_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_video_react__);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 600px;\n  display: block;\n  overflow: visible;\n  min-height: initial;\n'],['\n  width: 100%;\n  max-width: 600px;\n  display: block;\n  overflow: visible;\n  min-height: initial;\n']),_templateObject2=_taggedTemplateLiteral(['\n  height: 40px;\n'],['\n  height: 40px;\n']),_templateObject3=_taggedTemplateLiteral(['\n  max-height: 150px;\n  max-width: 600px;\n  overflow-y: auto;\n  box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.5) inset;\n  padding: 0 6px;\n'],['\n  max-height: 150px;\n  max-width: 600px;\n  overflow-y: auto;\n  box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.5) inset;\n  padding: 0 6px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  max-width: 600px !important;\n  font-family: inherit !important;\n'],['\n  max-width: 600px !important;\n  font-family: inherit !important;\n']),_templateObject5=_taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 600px;\n  margin: 12px 0;\n'],['\n  width: 100%;\n  max-width: 600px;\n  margin: 12px 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AccordionBookElement=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_grommet__["a" /* Accordion */])(_templateObject);var AccordionPanel=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_grommet__["b" /* AccordionPanel */])(_templateObject2);var AccordionContent=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_grommet__["d" /* Box */])(_templateObject3);var Player=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_video_react__["Player"])(_templateObject4);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject5);function MediaClip(_ref){var path=_ref.path,content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{margin:'vertical'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Player,{'aria-label':'media clip',alt:content.caption,poster:__webpack_require__(40)("./content"+content.poster)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__webpack_require__(40)("./content"+content.source)})),content.transcript&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionBookElement,{animate:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionPanel,{background:'light-4',label:'transcript'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet__["i" /* Paragraph */],null,content.transcript))))));}/* harmony default export */ __webpack_exports__["default"] = (MediaClip);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_ACTIVATE = exports.PLAYER_ACTIVATE = exports.FULLSCREEN_CHANGE = exports.OPERATE = undefined;
exports.handleFullscreenChange = handleFullscreenChange;
exports.activate = activate;
exports.userActivate = userActivate;
exports.play = play;
exports.pause = pause;
exports.togglePlay = togglePlay;
exports.seek = seek;
exports.forward = forward;
exports.replay = replay;
exports.changeRate = changeRate;
exports.changeVolume = changeVolume;
exports.mute = mute;
exports.toggleFullscreen = toggleFullscreen;

var _fullscreen = __webpack_require__(221);

var _fullscreen2 = _interopRequireDefault(_fullscreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OPERATE = exports.OPERATE = 'video-react/OPERATE';
var FULLSCREEN_CHANGE = exports.FULLSCREEN_CHANGE = 'video-react/FULLSCREEN_CHANGE';
var PLAYER_ACTIVATE = exports.PLAYER_ACTIVATE = 'video-react/PLAYER_ACTIVATE';
var USER_ACTIVATE = exports.USER_ACTIVATE = 'video-react/USER_ACTIVATE';

function handleFullscreenChange(isFullscreen) {
  return {
    type: FULLSCREEN_CHANGE,
    isFullscreen: isFullscreen
  };
}

function activate(activity) {
  return {
    type: PLAYER_ACTIVATE,
    activity: activity
  };
}

function userActivate(activity) {
  return {
    type: USER_ACTIVATE,
    activity: activity
  };
}

function play() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'play',
    source: ''
  };

  this.video.play();

  return {
    type: OPERATE,
    operation: operation
  };
}

function pause() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'pause',
    source: ''
  };

  this.video.pause();

  return {
    type: OPERATE,
    operation: operation
  };
}

function togglePlay() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'toggle-play',
    source: ''
  };

  this.video.togglePlay();

  return {
    type: OPERATE,
    operation: operation
  };
}

// seek video by time
function seek(time) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'seek',
    source: ''
  };

  this.video.seek(time);

  return {
    type: OPERATE,
    operation: operation
  };
}

// jump forward x seconds
function forward(seconds) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'forward-' + seconds,
    source: ''
  };

  this.video.forward(seconds);

  return {
    type: OPERATE,
    operation: operation
  };
}

// jump back x seconds
function replay(seconds) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'replay-' + seconds,
    source: ''
  };

  this.video.replay(seconds);

  return {
    type: OPERATE,
    operation: operation
  };
}

function changeRate(rate) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'change-rate',
    source: ''
  };

  this.video.playbackRate = rate;

  return {
    type: OPERATE,
    operation: operation
  };
}

function changeVolume(volume) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'change-volume',
    source: ''
  };

  var v = volume;
  if (volume < 0) {
    v = 0;
  }
  if (volume > 1) {
    v = 1;
  }
  this.video.volume = v;

  return {
    type: OPERATE,
    operation: operation
  };
}

function mute(muted) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: muted ? 'muted' : 'unmuted',
    source: ''
  };

  this.video.muted = muted;

  return {
    type: OPERATE,
    operation: operation
  };
}

function toggleFullscreen(player) {
  if (_fullscreen2.default.enabled) {
    if (_fullscreen2.default.isFullscreen) {
      _fullscreen2.default.exit();
    } else {
      _fullscreen2.default.request(this.rootElement);
    }
    return {
      type: OPERATE,
      operation: {
        action: 'toggle-fullscreen',
        source: ''
      }
    };
  }

  return {
    type: FULLSCREEN_CHANGE,
    isFullscreen: !player.isFullscreen
  };
}

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_Paragraph__ = __webpack_require__(35);
var _templateObject=_taggedTemplateLiteral(['\n  max-width: 150px;\n  height: auto;\n'],['\n  max-width: 150px;\n  height: auto;\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 18px;\n  margin-bottom: 18px;\n  margin: 0;\n  padding: 0;\n'],['\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 18px;\n  margin-bottom: 18px;\n  margin: 0;\n  padding: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Image=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].img(_templateObject);var ImageFrame=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2);function Thumbnail(_ref){var path=_ref.path,content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet__["d" /* Box */],{direction:'row',flex:'grow',gap:'small',margin:{top:'small',bottom:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageFrame,{'aria-label':'thumbnail object'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:__webpack_require__(40)("./content"+content.source),alt:content.caption})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_Paragraph__["a" /* default */],{margin:'none'},content.text));}/* harmony default export */ __webpack_exports__["default"] = (Thumbnail);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalloutComponent", function() { return CalloutComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_HighlightedSentences__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.5);\n  @media (min-width: 600px) {\n    width: 600px;\n  }\n'],['\n  box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.5);\n  @media (min-width: 600px) {\n    width: 600px;\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var scrollIntoViewOptions={behavior:'instant',block:'start'};var icons={critical:__WEBPACK_IMPORTED_MODULE_6_grommet_icons__["t" /* StatusCritical */],warning:__WEBPACK_IMPORTED_MODULE_6_grommet_icons__["y" /* StatusWarning */],ok:__WEBPACK_IMPORTED_MODULE_6_grommet_icons__["v" /* StatusGood */],info:__WEBPACK_IMPORTED_MODULE_6_grommet_icons__["w" /* StatusInfo */],unknown:__WEBPACK_IMPORTED_MODULE_6_grommet_icons__["x" /* StatusUnknown */],disabled:__WEBPACK_IMPORTED_MODULE_6_grommet_icons__["u" /* StatusDisabled */],halt:__WEBPACK_IMPORTED_MODULE_6_grommet_icons__["m" /* Halt */]};var colors={critical:'light-1',warning:'dark-1',ok:'dark-1',info:'light-1',unknown:'dark-1',disabled:'dark-1',halt:'black'};var StyledBox=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5_grommet__["d" /* Box */])(_templateObject);/** Callout component */var Callout=function(_React$Component){_inherits(Callout,_React$Component);function Callout(){_classCallCheck(this,Callout);return _possibleConstructorReturn(this,(Callout.__proto__||Object.getPrototypeOf(Callout)).apply(this,arguments));}_createClass(Callout,[{key:'render',value:function render(){var _props=this.props,AppState=_props.AppState,path=_props.path,content=_props.content;var status=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.last(path);var StatusIcon=icons[status];var isNewSelection=!AppState.bookmarkingSelectionContent||!content.includes(AppState.bookmarkingSelectionContent);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(path,AppState.selectedSectionItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledBox,{'aria-label':'callout',align:'center',background:'status-'+status,direction:'row',flex:'grow',justify:'start',margin:{vertical:'medium'},gap:'small',pad:{horizontal:'small'},onClick:function onClick(){AppState.isUserBookmarking&&AppState.setMenuBar('BOOKMARKING_MENU');var isBookmarking=AppState.isBookmarkingMenuBar||AppState.isUserAnnotating;if(isNewSelection&&isBookmarking){AppState.newBookmarkingSelection({path:path,content:path});}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatusIcon,{color:colors[status]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_HighlightedSentences__["a" /* default */],Object.assign({},this.props,{path:path,content:content,color:colors[status]})))));}}]);return Callout;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Callout.propTypes={/**
   * content path, determines callout type
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * message
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Callout.defaultProps={content:' '};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Callout));Component.displayName='Callout';var CalloutComponent=Callout;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var IE8_DOM_DEFINE = __webpack_require__(284);
var toPrimitive = __webpack_require__(285);
var dP = Object.defineProperty;

exports.f = __webpack_require__(58) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(112);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(374);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__styles__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__styles__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(178);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__utils__["a"]; });



/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var TableContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableRow__ = __webpack_require__(430);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableRow__["a"]; });


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextInput__ = __webpack_require__(437);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextInput__["a"]; });


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Drop__ = __webpack_require__(438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Drop__["a"]; });


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfiniteScroll__ = __webpack_require__(441);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InfiniteScroll__["a"]; });


/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = {"metadata":{"title":"Modern War in an Ancient Land Volume II","publication number":"Volume II","author":"Edmund J. \"E.J.\" Degen, Mark J. Reardon","date":"June 2021","distribution restriction":"Approved for public release; distribution is unlimited."},"cover":[{"picture":{"source":"/figures/v2/OEF_CVR2.png","caption":""}},"","","","","","","",{"picture":{"source":"/figures/m/map-fm-AfghanistanProvincialBoundaries.svg","caption":"Afghanistan Provincial Boundaries"}},"","","","","","","","${Prepared by the Chief of Staff of the Army Operation Enduring Freedom Study Group}{bold}","Col. (USA Ret.) Edmund J. “E. J.” Degen, Study Director and Editor","Lt. Col. (USA Ret.) Mark J. Reardon, Senior Historian and Editor","","Study Group Research and Writing Team","Col. Adrian A. Donahoe","Col. Bryan R. Gibby","Dr. Brian F. Neumann","Col. Francis J. H. Park","Dr. Gregory G. Roberts","Lt. Col. (USA Ret.) Matthew B. Smith","Lt. Col. (USA Ret.) John R. Stark","Maj. Miranda M. Summers-Lowe","Col. Victor H. Sundquist","Dr. Colin J. Williams"," "," ","Foreword by","General James C. McConville, CSA"," "," ","${...to Those Who Served}{bold}"],"supplement":{"details":"Endnotes are not included in the supplement.  Alternate options for viewing are available on the Modern War website at https://rdl.train.army.mil/catalog-ws/view/modernwar/index.html"},"instructions":null,"information":null,"foreword":[{"title":"Foreword"},"The terrorist attacks of 11 September 2001 resulted in the initiation of Operation ENDURING FREEDOM, the longest-tenured named operation in U.S. history. Focused primarily on objectives within the borders of Afghanistan, ENDURING FREEDOM lasted for more than thirteen years. The speed with which our nation concentrated military forces in an undeveloped theater, before executing a coordinated air-ground offensive with our Afghan allies against al-Qaeda and their Taliban supporters, amazed friend and foe alike. Although the “Shock and Awe” campaign removed the threat that al-Qaeda would launch another strike against the United States from its Afghan sanctuary, it was less successful in its efforts to help the post-Taliban Afghan government establish security throughout the newly liberated nation. Achieving the desired level of security in the face of a resurgent Taliban would require a much larger commitment of ground forces, national treasure, and time than originally envisioned.","As we learned in volume one of Modern War in an Ancient Land, initiatives to provide security in Afghanistan struggled because of a lack of resources. After the end of the initial military campaign, the strategic end state for Afghanistan remained ill-defined, and the means to achieve the goal of creating a stable, friendly nation with a functioning government were not immediately forthcoming. American commanders and their subordinates in Afghanistan constantly sought innovative solutions to make up for shortfalls in troops and equipment. However, from 2003, the National Command Authorities prioritized the Iraq conflict—and for those who served in Afghanistan, operating with insufficient means would become the norm rather than the exception.","The worldwide demand for ground forces to fight the Global War on Terrorism highlighted dormant issues within all components of the U.S. Army. Although the Army that existed on 11 September 2001 was prepared to deploy, fight, and win our nation’s wars, Cold War–era thought permeated its existing force structure, training, and equipment design. The initiative known as modularity redesigned the basic combat formation around the maneuver brigade. By pushing assets normally allocated to higher echelons down to brigade levels, the Army was able to increase the number of combat brigades available for worldwide employment and realign brigade capabilities with the dispersed nature of both Iraqi and Afghan battlefields.","Equipping issues also came to the forefront. The Abrams main battle tank and the Bradley infantry fighting vehicle were optimal for combat on the plains of Europe, but they did not transition easily to the counterinsurgency operations in Iraq and Afghanistan. To provide soldiers with needed mobility and protection in these challenging environments, the Department of Defense accelerated the development of new wheeled combat vehicles such as Strykers and Ground Combat Vehicles. Myriad other programs also sought to ensure American soldiers had all of the equipment and resources they would need to locate, engage, and defeat their enemies.","As it waged two simultaneous conflicts that demanded lengthy commitments from its forces, the Army made significant changes in the way it trained and prepared soldiers for deployment to active theaters of operation. It instituted a predeployment readiness and training model known as Army Force Generation (ARFORGEN) to replace Cold War–era readiness and deployment practices. The ARFORGEN model provided better predictability for units, soldiers, and families during this period of sustained conflict by designating predictable timelines. It also made the best use of resources dedicated to preparing soldiers and units for combat by synchronizing the allocation of personnel, equipment, and training.","All three components of the Army—Active, Guard, and Reserve were in high demand for extended periods. To more equitably share operational burdens, senior leaders introduced the “Grow the Army” initiative, which increased the size of the force. Another major program involved an investment in individual readiness, especially for National Guard and Reserve forces. Recognizing the unparalleled demands on these forces, the Army strove to give them proper healthcare, coupled with training opportunities to ensure continued support for their mission. Those programs, along with ARFORGEN, were critical to ensuring the soldiers and families had time to rest and rebuild their strength.","Even as the Army recategorized its thinking at home to better support the war, the conflict in Afghanistan intensified as the enemy used sanctuaries I Pakistan to regenerate combat power. This volume shows the evolution of the international coalition during this period, as our allies dedicated more forces and the NATO-led International Security Assistance Force assumes overall responsibility for the campaign. Later, as the war in Iraq wound down, the war in Afghanistan began to receive the resources it needed—not merely to keep the enemy in check but also to build capacity within the country in order for the Afghan people to take the lead in providing their own security and stability. As this point of transition to Afghan-led security approached, U.S. and coalition forces rapidly and dramatically reduced their presence in theater and returned to their home stations.","Nevertheless, the transition of responsibilities to host-nation security forces has not signaled the end of American efforts in Afghanistan. Leaders at all echelons must continue to build upon their experiences and prepare for the next challenge. As stated in The Army Vision, the Army as a whole must prepare to deploy, fight, and win decisively against an adversary, anytime and anywhere, in a joint, multidomain, high-intensity conflict, while simultaneously deterring others and maintaining its ability to conduct irregular warfare. For our Army, this means high-quality soldiers. We must equip our formations with the latest technology and maximize these organizations to take advantage of our skills in combined arms warfare. Leaders throughout the Army must become expert trainers, prepared to reach the highest levels of readiness in an era of reduced resources. The Army’s training and educational institutions must provide dynamic learning environments. Most importantly, Army leaders must never relinquish the agility and innovation they have gained in the past two decades of the Global War on Terrorism.","These two volumes are the first of many efforts our Army will generate to ensure we learn all we can from Operation ENDURING FREEDOM. History has always been a cornerstone of our education process, and that will remain true for the foreseeable future. The insights and dialogue generated by reading and reflecting on these histories will prove invaluable in the next war. I trust that not just our military readers, but also our civilian counterparts and leaders, can gain value from studying these efforts.","Washington, D.C.","GENERAL JAMES C. MCCONVILLE","40th Chief of Staff of the Army, 2019–"],"preface":[{"title":"Preface"},"Following the fall 2005 elections in Afghanistan, the key question driving the United States’ approach to Operation ENDURING FREEDOM was how to reduce forces without sacrificing the security gains made since 2001. After more than a year of searching, a potential answer emerged in April 2003 when the North Atlantic Treaty Organization (NATO) agreed to broaden the International Security Assistance Force (ISAF) mandate it assumed from the United Nations (UN). Taking leadership of Regional Command (RC) North in October 2004, NATO planned to expand in a counterclockwise direction until it could provide security and developmental assistance to all of Afghanistan. Secretary of Defense Donald H. Rumsfeld understood the importance of the NATO decision, believing that America would “continue to be tied down . . . [in Afghanistan] until the Afghans can provide their own security,” a situation that was “costing the US taxpayers a fortune.” Greater European participation would allow deployed American military forces to protect the U.S. homeland by focusing on counterterrorist missions rather than less essential tasks such as nation building.","With the Global War on Terrorism nearing its fifth year, the United States still devoted a scant 3.9 percent of its gross domestic product to national defense, with only 1.1 percent going to the Army. Subtracting the emergency supplemental allocations passed by Congress to address unforeseen issues affecting combat operations, the Army received only slightly more than one-third of a percent of the U.S. government’s annual budget. As a result of the budget disparity, the Army’s ability to undertake missions other than Iraq and Afghanistan continued to degrade as equipment not needed for immediate warfighting requirements was neither maintained nor upgraded. The lack of funding also took other discrete forms, such as declining opportunities for nondeploying units to maintain proficiency and inadequate recruiting incentives.","Readers will note that many problems and challenges captured in the first volume of Modern War in an Ancient Land persist during the subsequent stages of the conflict in Afghanistan as detailed in this volume. Although the struggle for resources became less urgent for a time following the defeat of the Iraqi insurgency, that issue returned in 2011 as U.S. commanders in theater prepared to transition security responsibilities to their Afghan counterparts. This volume discusses the path taken by Operation ENDURING FREEDOM beginning with ISAF’s expansion through the change of mission on 31 December 2014. The first section examines how ISAF adjusted to the evolving campaign in the aftermath of the Taliban’s return to the fight. The second section examines the Obama administration’s decision, made possible only after the defeat of the Iraqi insurgency, to change the course of the campaign by resourcing a surge in Afghanistan. The concluding section captures the downsizing story and the transition of the ENDURING FREEDOM mission—a period of great complexity."],"section I":[{"title":"AN ECONOMY OF FORCE"},"In October 2005, the Army had 270,000 soldiers—27 percent of its 1,032,587 officers, warrant officers, cadets, and enlisted soldiers—deployed or forward stationed in 120 countries. The total force of more than 1 million troops included 492,728 active component soldiers, 206,682 Army Reserve members, and 333,177 National Guard personnel. Those figures reflected a decrease over the previous year of 5,888 active component soldiers, 14,126 Army Reserve members, and 9,741 National Guard personnel. Across the entire Army, every component had failed to achieve its retention goals. The Army’s willingness to accept more recruits with waivers and minimum skill qualification test scores also resulted in the number of high school graduates in uniform dropping from 92 to 87 percent.","The personnel crisis improved marginally in 2006 after recruiting programs received more funding to support their efforts. Active component retention and recruiting goals were met, while the National Guard and Army Reserve recruiting targets were not. The drop in qualitative levels continued as the number of service members who had high school diplomas fell to 81 percent. At the end of the fiscal year, the active component numbered 502,790, while the National Guard and Army Reserve totals were 346,288 and 189,975 respectively. The totals reflected an active component gain of 10,062, as well as 13,111 more national guardsmen in uniform, while Army Reserve end strength dropped by 16,707. The latter stemmed in part from widespread dissatisfaction with the Department of Defense’s (DoD) ad hoc approach to employing reservists during the early phases of the Iraq conflict.","During this period, the Army continued its efforts to reach a goal of 70 modular combat brigades and 211 modular support brigades. Those totals were a 46 percent increase in comparison with the premodular force. Nineteen brigade combat teams had converted by the end of 2005, with another eighteen in the process of modularizing by mid-2006. In addition to implementing widespread force structure changes, the Army placed considerable priority on meeting near-term tactical and operational battlefield challenges. It enhanced both the M2A3 Bradley Infantry Fighting Vehicle and the M1A2 Abrams Main Battle Tank to make them more survivable in urban environments. The growing threat posed by improvised explosive devices (IEDs) led to accelerated fielding of up-armored M1114 High Mobility Multipurpose Wheeled Vehicles (HMMWVs), which would be replaced by a totally new design, the Mine Resistant Ambush Protected (MRAP) vehicle, in 2007. Unmanned aerial vehicles also received a higher priority as the Army distributed more RQ–5A Hunter and RQ–7A Shadows to divisions and brigades. Most of the new equipment went to Iraq rather than being deployed to Afghanistan.","A quick comparison of Operation IRAQI FREEDOM (OIF) with its counterpart in Afghanistan reveals why the latter was a lower priority. In January 2006, more than 98,000 soldiers were serving in Iraq with another 14,000 supporting them from Kuwait. The U.S. Army contribution to the U.S.-led Multi-National Force–Iraq consisted of fourteen brigade combat teams, innumerable support elements, two division headquarters, and one corps headquarters. In comparison, Afghanistan required three brigade combat teams with support units and one division headquarters totaling 16,000 soldiers. During fiscal year 2006, Army units in Iraq suffered 440 killed in action, 92 other deaths, and 3,610 wounded in action. Despite the Taliban resurgence, comparable figures for Afghanistan were 54 killed in action, 21 other deaths, and 292 wounded in action. Steadily rising sectarian violence and U.S. military casualties in Iraq, coupled with the Bush administration’s determination to hand over Afghanistan to the NATO-led ISAF, ensured Operation ENDURING FREEDOM (OEF) remained an economy of force effort for the foreseeable future.","In light of the tremendous pressure being exerted on the Army, it is unsurprising that the American approach in Afghanistan from late 2005 through 2008 centered on making the transition to NATO, and eventually the Kabul government, a reality. This process would take time and resources, the two things that the administration of President George W. Bush wanted to avoid committing. It also required that NATO meet Afghanistan’s security and governmental needs, a condition that member nations accepted as a natural outcome of the long-term military commitments experienced in the Balkans. The difficult change from U.S. to ISAF leadership needed a secure environment in order to be successful. Unfortunately for the United States and NATO, Afghanistan’s dynamic environment and the Taliban’s rejuvenation in late 2005 blunted the progress that ENDURING FREEDOM had brought to the country. When America transferred Regional Command (RC) South and RC East to NATO in 2006, the handovers did not go unopposed as the Taliban and its allies launched sequential offensives against incoming NATO forces. Although unsuccessful, the attacks revealed that NATO was unprepared for the renewed violence. As a result, America halted its drawdown as NATO members reevaluated what type of assistance they were prepared to provide. When ENDURING FREEDOM continued to deteriorate in early 2007, the Bush administration committed additional forces to Afghanistan and increased its support for the Kabul government.","America’s concurrent war in Iraq provided the background for this deteriorating situation. In February 2006, the bombing of the al-Askari mosque in Samarra’, Iraq, triggered a sectarian civil war that, combined with the persistent anticoalition insurgency, convinced President Bush that he needed to send a surge of forces there. With the balance of the U.S. Army’s available personnel participating in, recovering from, or preparing for OIF, policymakers confined the United States to an economy of force mission in Afghanistan in 2007–2008. Although violence in Afghanistan escalated, security problems did not reach levels comparable to the events that forced the Bush administration to completely refashion its warfighting strategy in Iraq.","Consequently, the next two years passed in Afghanistan without significant changes to America’s operational approach. Both the U.S. military and the other NATO member nations failed to deploy sufficient forces to meet ISAF objectives, and the Afghan war deteriorated to the point that the United States, its international coalition, and the Afghan government faced the possibility of stalemate or defeat by early 2009.","This section chronicles the three-and-a-half years between the 2005 Afghan national and provincial elections, which marked the end of the original Bonn Process agreed upon in December 2001, and the start of President Barack H. Obama’s administration in early 2009. The initial chapter captures the challenges the Army faced while supporting two major combat theaters simultaneously. The second chapter introduces the strategic situation in Afghanistan following the September 2005 National Assembly and provincial council elections, while analyzing the emerging threat posed by a revived Taliban and other anticoalition groups. It concludes by examining how American forces prepared for the arrival of NATO forces in 2006 and the joint Army and Marine Corps efforts to update counterinsurgency doctrine. The third chapter details how the enemy contested control of RC South— which led to an ISAF counteroffensive to regain the initiative—before ending with a discussion of how U.S. troops refocused on RC East during this period. The fourth chapter begins in 2007 with a new ISAF commander, General Dan K. McNeill, implementing a strategy to smother the insurgency while managing the disparate elements of the NATO coalition. The final chapter details how his successor, General David D. McKiernan, arrived in the summer of 2008 to find a coalition divided by various command chains and lacking a cohesive strategy. Each chapter examines American and ISAF efforts to create Afghan security institutions and rebuild national and local infrastructure."],"chapter 1":[{"title":"The Challenges of Protracted War"},{"section":["As Task Force SPARTAN (3d Brigade, 10th Mountain Division) spread forces out among the Afghan population in 2005, the Army and Marine Corps were thoroughly reviewing the doctrine that was being used in the wars. The unanticipated trajectory of the Global War on Terrorism placed increasing stress on the Army as the simultaneous conflicts in Afghanistan and Iraq showed few signs of abating, and both conventional and Special Operations Forces (SOF) felt the detrimental effects. The Army initially sought to address this problem by restructuring brigade combat teams and siphoning personnel from nondeployable institutional organizations, namely the Generating Force. The DoD reinforced the Army’s indirect approach to constant combat deployments by creating more indigenous security forces and convincing coalition partners to assume more responsibilities. Although NATO ultimately agreed to expand its mandate while indigenous security forces grew steadily in size and capability, the organizational and operational pressures exerted on the Army lingered long past the January 2007 decision to surge troops into Iraq. When the decision was made to grow the Army force structure, great thought and care had to be put into that effort to ensure there would be no long-lasting negative effects on the mission, the overall quality of the force, and families. Besides the challenges, the manner in which the Army was prosecuting the campaign was under scrutiny at the same time. A full examination of the doctrine that guided campaigns was beginning in earnest at Fort Leavenworth, Kansas."]},{"title":"Revamping Doctrine","level":2},{"section":["The Army initiated Operation ENDURING FREEDOM with doctrine reflecting the experiences of Operation DESERT STORM, recent peace enforcement operations, and the defense transformation efforts of the 1990s. Operations (Department of the Army Field Manual 3–0), the Army’s capstone publication published on 14 June 2001, described the Army’s newly adopted doctrinal approach as “full spectrum operations,” which combined offense, defense, stability, and support operations. It indicated that training to the highest readiness levels required for combat operations would enable units to win in less-demanding stability and support missions. This approach sought to reconcile two conflicting demands. Although the Army had an overarching need for a strategically agile heavy force, capable of waging decisive combined arms operations against a conventional regional aggressor, U.S. soldiers also had to be prepared for other types of operations against less-conventional opponents. Humanitarian and peacekeeping missions such as those in Somalia and the Balkans, and regional interventions to protect U.S. interests like those in Grenada and Panama, had presented unanticipated challenges to commanders in the field and at home, and the Army wanted to prepare its soldiers for the volatile environment inherent in these types of contingency operations. However, the painful memory of the Vietnam conflict—in which the U.S. military had fought both a conventional opponent and an insurgency and found it difficult to eradicate either—also had left a lasting impression on senior Army leaders. Because the Army leadership was determined never to repeat the experiences of Vietnam, the new field manual dedicated only a single page to counterinsurgency operations. Rather than provide soldiers in Afghanistan and Iraq with guidance that might help them understand the combat environment, the 2001 edition of Field Manual 3–0 left a doctrinal void.","With Field Manual 3–0 lacking necessary insight, commanders turned to Military Operations in Low Intensity Conflicts (Department of the Army Field Manual 100–20), first published in 1990. Although it was still in the final stages of revision, Field Manual 100–20 would become a temporary source of information until it was superseded by Stability Operations and Support Operations (Department of the Army Field Manual 3–07) in 2003. Field Manual 3–07 discussed counterinsurgency and foreign internal defense operations as they related to stability and support operations within full spectrum operations articulated in the 2001 Operations manual. However, troops deploying to Afghanistan had little to no opportunity to train for stability and support operations because the Joint Readiness Training Center only offered a one-week “low intensity conflict” scenario for light forces. Units such as the 1st Cavalry Division, which had some experience with peacekeeping missions in the Balkans, deployed to Iraq in early 2004 optimized for stability and support operations only to discover a full-fledged insurgency in progress.","In response to the urgent need for more detailed counterinsurgency doctrine following the spring 2004 uprising in Iraq, Lt. Col. Jan S. Horvath of the Combined Arms Center at Fort Leavenworth borrowed heavily from French experiences in the Algerian War from 1954 through 1962 to produce an interim document, released to the force in October 2004 as Field Manual–Interim 3–07.22, Counterinsurgency Operations. The manual provided more detail than Field Manual 3–07 had on how to conduct such operations, but Colonel Horvath still faced the unenviable task of sifting out applicable lessons from what could be characterized as a French defeat in Algeria to produce a publication designed to temporarily fill the doctrinal void. This interim manual was rolled out to little fanfare, but its replacement would be far more influential.","In February 2006, Lt. Gen. David H. Petraeus, who had assumed command of the Combined Arms Center five months earlier, hosted a conference of experts on irregular warfare and counterinsurgency drawn from the military, the intelligence community, the Department of State, academia, and elsewhere. The conference solicited input and backing for a new doctrinal publication, Counterinsurgency (Department of the Army Field Manual 3–24). Work on the manual, which included input from the U.S. Marine Corps, had started five months earlier with the arrival of Dr. Conrad C. Crane, a West Point classmate of General Petraeus, who was on loan to Leavenworth from the Military History Institute at the U.S. Army War College in Carlyle, Pennsylvania. Although the first draft reflected a variety of inspirations, its intellectual underpinnings drew heavily from Robert Thompson and Frank Kitson, British commanders whose experiences facing insurgencies in Kenya, Malaya, and Northern Ireland provided a strategic counterpoint to related works by N. Lenin, Mao Zedong, Vo Nguyen Giap, and Ché Guevara. Crane’s other sources included material from Dr. Steven K. Metz of the Army War College’s Strategic Studies Institute, and most significantly, two articles citing Iraq lessons learned from Petraeus, who had commanded the 101st Airborne Division (Air Assault) and the Multinational Security Transition Command–Iraq, and Maj. Gen. Peter W. Chiarelli, who had commanded the 1st Cavalry Division in Baghdad.","Work on the counterinsurgency manual also led to the publication of another important update, ${Stability Operations}{italic} (Department of the Army Field Manual 3–07), during this period. The revision of Field Manual 3–07 began in late 2006, following a discussion between Petraeus and Lt. Col. Steven M. Leonard, a former planner with the 101st Airborne Division in Iraq, who had become chief of operational-level doctrine at the Combined Arms Doctrine Directorate at Fort Leavenworth. After noting that Field Manual 3–24 did not cover all of the potential missions a unit might conduct during counterinsurgency operations, Petraeus told Colonel Leonard to ask the Department of State and the U.S. Agency for International Development for help in updating the Army’s guide to stability and support operations. Leonard also received significant assistance from the Peacekeeping and Stability Operations Institute at Carlisle Barracks.","The resulting manual included some distinctly nonmilitary sources of guidance. At its highest level, ${Stability Operations}{italic} drew on the 2006 National Security Strategy, but more practically, it borrowed from National Security Presidential Directive 44 and DoD Directive 3000.05. Both of the latter documents, first unveiled in 2005, gave authoritative guidance on the conduct of stability operations, with the State Department designated as the lead federal agency for such operations. Other influential sources for Field Manual 3–24 were the U.S. Agency for International Development’s 2005 Fragile States Strategy and the United States Institute of Peace’s Fragile States Framework, as well as Post-Conflict Reconstruction Essential Tasks from the Office of the Coordinator for Reconstruction and Stability at the State Department, which directly linked military operations to a broader whole-of-government approach. Much like its Counterinsurgency predecessor, the ${Stability Operations}{italic} manual also was released by a separate civilian publisher, the University of Michigan Press, with a foreword from Undersecretary of Defense for Policy Michèle A. Flournoy and an introduction by Flournoy’s director of stability operations capabilities, Dr. Janine A. Davidson.","The publication of updated operations, counterinsurgency, and stability operations doctrine showed that the Army could adapt to the immediate needs of two combat theaters, even though it also illustrated the operational limitations of technology-based transformation. In both Afghanistan and Iraq, air- and space-based systems played a central role in defeating the Taliban forces led by Mullah Mohammed Omar and Saddam Hussein’s Iraqi armed forces. In each instance, however, airpower and space-based assets backed by world-class command, control, communications, and intelligence systems could not defeat opponents who subsequently adopted new methods that negated U.S. technological advantages. The Army and Marine Corps ultimately countered these new threats only by adopting new doctrine that enabled ground forces to fill the operational warfighting shortfalls created when asymmetrical enemy countermeasures relegated air- and space-based systems to a distinctly secondary role.","The two doctrinal manuals outlined above would have much greater influence on future doctrine, most significantly in the concepts  of Design and Mission Command. The December 2006 version of Field Manual 3–24 addresses the initial concept of Design:",{"list":["It is important to understand the distinction between design and planning. . . . While both activities seek to formulate ways to bring about preferable futures, they are cognitively different. Planning applies established procedures to solve a largely understood problem within an accepted framework. Design inquires into the nature of a problem to conceive a framework for solving that problem. In general, planning is problem solving, while design is problem setting. Where planning focuses on generating a plan—a series of executable actions—design focuses on learning about the nature of an unfamiliar problem."]}]},{"figure":{"source":"/figures/v2/grafik_Fig1-1.png","caption":"Iterative Nature of Design"}},"Figure 4-2 from the 2006 Field Manual 3–24 also shows the iterative nature of Design. A number of artifacts from the counterinsurgency manual, such as lines of operation, lines of effort, and the importance of dialogue, were included in the final design concept. Design, therefore, included much of the understanding and visualizing in what was then called Battle Command. It viewed these actions by the commander as conceptual and separate from planning. In the interim period, before The Operations Process (Department of the Army Field Manual 5–0) was published in 2010, planning consisted of a conceptual component (Design) performed by commanders and the detailed planning (Military Decision Making Process and Joint Operation Planning Process) subsequently conducted by the staff:",{"list":["4–1. For every operation, commanders develop personal, detailed understanding of the situation and operational environment. They then visualize a desired end state and craft a broad concept for shaping the current conditions toward that end state. Finally, they describe their visualization through the commander’s intent, planning guidance, and concept of operations, setting formal planning processes in motion. Thus, planning is an adaptive process that ebbs and flows with the situation; as understanding of the situation evolves, planners develop branches and sequels to account for such evolution. Planning is a continuous activity, constantly adapting as the conditions of the operational environment are shaped by activities, both natural and human. Since planning is an ongoing process, the resultant plan is an interim product of deliberate thought, based on knowledge and understanding at a specific point in time and space. The truest measure of a good plan is not whether execution occurs as planned, but whether the plan fosters flexibility, initiative, and adaptability in the face of unforeseen events.","4–2. Planning consists of two separate, but closely related aspects: a conceptual component, represented by the  less tangible aspects of visualization, and a detailed component, which introduces specificity to the plan through a deliberate process. During planning these activities overlap; there is no clear delineation between either. As commanders conceptualize the operation, their vision informs the staff to add detail to the plan."]},"In comparison, the 2010 edition of Field Manual 5–0, paragraph 3–2, nearly mirrors the opening sentence of paragraph 4–2 above:",{"list":["3–2. Planning consists of two separate, but closely related components: a conceptual component and a detailed component.  The conceptual component is represented by the cognitive application of design. The detailed component translates broad concepts into a complete and practical plan. During planning, these components overlap with no clear delineation between them. As commanders conceptualize the operation, their vision guides the staff through design and into detailed planning. Design is continuous throughout planning and evolves with increased understanding throughout the operations process. Design underpins the exercise of battle command, guiding the iterative and often cyclic application of understanding, visualizing, and describing. As these iterations occur, the design concept—the tangible link to detailed planning—is forged."]},"The introduction of the concepts of Design, Operational Design, and the Army Design Methodology was a major change to the way the Army approached campaign planning. The inclusion of lines of effort and lines of operations, coupled with a new operational approach, reshaped how the Army defined problems and solved them. This conceptual framework had a tremendous impact on the conduct of Enduring Freedom, especially as the Army looked at the overall campaign during the 2010–2011 time frame.",{"figure":{"source":"/figures/v2/img_1-1.png","caption":"Army Chief of Staff General Peter J. Schoomaker"}},{"title":"Stresses on the Force","level":2},{"section":["The difficulty of fighting two simultaneous conflicts created a tremendous amount of stress on the Army, particularly its human component. The physical and mental health of service members, whether active or reserve, suffered under the strain of multiple rotations. Although the Army made efforts to address these concerns, particularly by giving reservists access to much-needed healthcare services, it struggled to mitigate the effects of personnel problems and shortages as it responded to the rising tempo of operations overseas.","${Dwell Time and Its Effect on Resiliency}{bold}","Keenly aware that Secretary of Defense Donald H. Rumsfeld did not support conventional force structure increases as the primary means of meeting sustained operational requirements, Army Chief of Staff General Peter J. Schoomaker instituted a policy known as dwell time in an effort to ameliorate the stress on service members during and in between deployments. As a core component of the Army Force Generation process, dwell time sought to manage the intervals between deployments, providing service members with time to recuperate from their most recent overseas tour while also preparing for their next one. Despite General Schoomaker’s best intentions, the policy of managing dwell time met with mixed success depending on the soldier’s component. Active component service members could expect only twelve to fifteen months at home station between deployments, which was less than the intended goal of a two-year interval. The policy was more successful for reserve component service members: most, but not all, could expect five years at home for every one year deployed. However, the reserve component soon faced a host of unexpected readiness challenges that emerged during the lengthy interval between deployments."]},{"figure":{"source":"/figures/v2/img_1-3.png","caption":"Michigan Army National Guard Soldiers"}},"Meeting dwell time goals proved to be even more elusive as the tempo of operations in both conflicts ramped up. As of 2007, the deployed-to-dwell time ratio for the active component was closer to 1:1, and for National Guard and Army Reserve it was closer to 1:3. The Iraq surge, the Afghanistan surge, the transformation to modularity, and reductions in overall end strength following a brief period of growth all combined to push against the trend to make mobilizations predictable. The rotational nature of the Army Force Generation process rested on the assumption that all soldiers, and reserve component soldiers specifically, found multiple rotations less stressful than long mobilizations. For many reservists, this particular assumption did not hold true. With the added commitments to complete professional education courses and the need to continue the cross-leveling of personnel to fill units, multiple deployments meant that military service was a larger part of a reservist’s life for longer periods. All of this elevated stress on reservists, who did not have access to the support mechanisms of their active-duty counterparts.","As reservists returned home, the burden of combat shifted to civilian healthcare providers and the Veterans Administration. A Walter Reed Institute study published in 2007 found that there was no reason to believe that reservists were less mentally healthy at the start of a deployment than those on active duty, but they faced significant challenges unique to their situation after a deployment. Active component soldiers continued to have day-to-day contact with their units (or at least with other soldiers) after a deployment, unlike their reserve peers who became isolated in their experiences. As a result, some reservists found little relief in their return to civilian employment. Posttraumatic stress disorder, a condition that affected 15 to 30 percent of soldiers, typically manifested three to twelve months after a traumatic event, but reservists faced legal hurdles in receiving treatment if they did not report symptoms of this condition before they left active duty. As the frequency of deployments increased, many employers unofficially balked at hiring or reemploying reservists. In many cases, unemployment meant that reservists lost their health insurance, which added to their stress and created another hindrance to mobilizing troops.","Demobilization became, in essence, the first chance to prepare a soldier for his or her next deployment. However, the one-year cap on mobilized time increased the pressure on the Army to shorten demobilization procedures to a few days. Healthcare exemplifies the case. Medical and dental care, often needed to treat injuries from previous deployments, continued to be the largest single factor keeping reserve soldiers from returning to combat. In 2007, barely 50 percent of returning Army Reserve personnel sent to Afghanistan or Iraq as individual augmentees met dental readiness requirements at the end of their deployment, mainly because of deferred dental work that had deteriorated further during their deployment. The reservists then returned to their original units, but were nondeployable because the constricted demobilization timeline did not leave enough time to fix their medical and dental issues.","These issues motivated the decision to give all National Guard and Army Reserve personnel access to premium-based healthcare at all times, and starting in October 2007 they would receive free healthcare before deployment. By September 2009, more than 100,000 reservists had signed up for this plan. The program expanded options for reservists who were preparing for deployment and provided comfort to families who now knew that loved ones who were injured on duty would be able to receive long-term medical care. It was also one of the most expensive DoD programs provided to the reserve component after the September 11th attacks.","${Stress Within the Force}{bold}","Although Schoomaker factored dwell time into the Army Force Generation process to help manage the negative effects of multiple combat deployments, it did not turn out to be as effective as hoped. The Army’s first mention of perceptible stress within the force appeared in the 2005 Army Posture Statement. Although the statement explicitly referred to stress in terms of the recapitalization of equipment used in combat, the remarks applied equally well to individual augmentees serving in joint task force headquarters and similar organizations, as well as “low-density/high-demand” units such as civil affairs, military intelligence, and military police. The narrative of the Army Posture Statement soon shifted squarely onto soldiers, their families, and civilian workers as increased stress led to skyrocketing numbers of suicides and other self-destructive behavior.","As Army leaders sought ways to cope with the situation, they learned that stress did not affect soldiers only when they were in combat. In fact, soldiers carried that stress back to their home stations after their deployments ended. Early studies of the problem suggested that stress did not dissipate immediately upon soldiers’ return. In fact, the stress levels of soldiers returning from deployments peaked four to nine months after their return—by which time the soldier was already preparing for the next deployment. The secondhand effects of stress took a toll on soldiers’ families. Whether the result of a soldier’s absence during deployment, violent acts committed by a soldier during or after deployment, or bouts of depression experienced by a soldier who had returned home, stress often had traumatic and damaging results.","As rising operational commitments made units deploy more frequently, both soldiers and their families turned to extreme measures, such as suicide or divorce, to end a downward spiral from which there seemed to be no escape.","Suicide occurred more frequently in the Army than in other services. The vast majority of suicides took place not while soldiers were in Afghanistan or Iraq, but after they returned to their home stations. White soldiers were one-third more likely to commit suicide than African American, Asian, or Hispanic soldiers. Junior enlisted soldiers were slightly more likely to take their own lives compared to career noncommissioned officers, while officers committed suicide at a rate just over half that of junior enlisted. Suicides were more likely to take place in the barracks or in on-post housing than in homes located outside of a military installation. Just as disturbingly, studies disclosed that stress did not diminish even after soldiers returned to civilian life. A Veterans Administration study covering the period 2001–2007 disclosed that deployed and nondeployed veterans respectively committed suicide at rates of 41 and 61 percent higher than the general population.","Aside from the direct impact of growing stress on soldiers and their families, reduced intervals between deployments created long-term issues that threatened the collective fabric of the Army. Inadequate dwell time at home station between deployments not only reduced the time needed to adequately balance soldiers’ needs, but also had detrimental effects on their units. The unit and commanders still had to conduct predeployment training, which encompassed everything from individual skills through large-unit collective training. Officers and noncommissioned officers received fewer opportunities to learn more about their profession as impending deployments delayed their military education. A growing number of potential career noncommissioned officers left the active component for civilian life or reservist duty rather than submit their families to repeated deployments with no relief in sight. Those soldiers who remained in the force, officers and enlisted alike, had to concentrate on learning the counterinsurgency and advisory skills needed for combat deployments rather than hone their abilities to a much broader range of combat operations.","The Army took several different approaches to respond to the increasing stress on the force. The onset of readiness and healthcare  problems that followed multiple combat deployments, and the gradual reduction of time spent at home station between overseas tours, became starkly visible in 2008 when suicide rates exceeded the civilian average for the first time. In a direct response to the increased suicide rate and other reports of high-risk behavior, the Army established the Comprehensive Soldier Fitness Program on 1 October 2008. The program was designed to “increase the resilience of Soldiers and families,” decrease posttraumatic stress, reduce undesirable or destructive behaviors, and promote positive growth from stressors. In 2009, General Chiarelli, now vice chief of staff of the Army, visited six installations to examine suicide prevention efforts in the force. He and his team identified a trend of increased self-destructive, high-risk behavior such as self-harm, illicit drug use, binge drinking, and criminal activity. Chiarelli directed the production of what became the Army Health Promotion/Risk Reduction/ Suicide Prevention Report in 2010, also known as the “Red Book” for its cover color. The conclusions in the Red Book cited a “direct link to increased life stressors and increased risk behavior,” but more pointedly, noted:",{"figure":{"source":"/figures/v2/img_1-4.png","caption":"General Chiarelli"}},{"list":["For some, the rigors of service, repeated deployments, injuries and separations from Family resulted in a sense of isolation,  hopelessness and life fatigue. For others, a permissive unit environment, promoted by an out of balance Army with a BOG:dwell of less than 1:2, failed to hold Soldiers accountable for their actions and allowed for risk-taking behavior— sometimes with fatal consequences."]},"Addressing sources of the stressors themselves required a reduction in demand, which started with the end of the Iraq surge in 2007, and continued through 2009 when the last soldiers on fifteen-month deployments completed their combat tours. On 4 August 2011, Secretary of the Army John M. McHugh directed that combat tours be reduced from twelve to nine months for active division headquarters and their subordinate forces. Although corps headquarters and individual augmentation tours remained at twelve months, the change brought the deployed-to-dwell-time ratios back into a semblance of the goals originally set as part of Army Force Generation.","Even as the Army significantly curtailed the length of combat deployment tours in comparison to previous years, it continued its efforts  to combat stress within the force. Chiarelli’s initial findings were followed up in a 2012 report called ${Army 2020: Generating Health & Discipline in the Force Ahead of the Strategic Reset}{italic}, which was nicknamed the “Gold Book” for its cover. The study illustrated trends resulting from deploying the Army’s forces at the intensity required to meet the demand for twenty-three brigade combat teams. The Gold Book featured an update of the Composite Life Cycle Model from the Red Book, illustrating the aggregate stress to the force over time. Whereas previous analyses of stress to the force focused either on equipment or units, stress levels measured across the overall force indicated the situation was more dire than expected. The Gold Book noted that cumulative stress had built up to the point where soldiers were experiencing a lifetime of stress during their first six years in service. Stress typically occurred in overlapping intervals, and when many stressors concentrated at a given time period, it correlated with the greatest risk of self-harm or suicide, as well as related high-risk behaviors or criminal offenses. Obviously this was an issue requiring a generational approach for the Army and all the services to confront and repair in the upcoming years.","${The Unsustainability of Individual Augmentation}{bold}","The sheer number of deployed brigades obscured the fact that the U.S. Central Command (CENTCOM) command and control structure was taxing the force to its limits. Although the modular force structure resulted in less personnel turbulence within tactical units, it did not address staffing needs for headquarters above the brigade level. Divisions, corps, army service component command headquarters, and units serving as land component headquarters or joint task forces still required robust individual augmentation to fill positions coded for skills normally found only above the tactical level within the Army. Examples of the latter category included strategic intelligence, operations research and systems analysis, force management, acquisitions, and strategic plans and policy specialists. The majority of those positions were also found outside of what the Army called its Operations Career Field, which were its traditional command-track branches and specialties. Joint task forces that were not built around existing organizations, such as Multi-National Force–Iraq, Combined Forces Command–Afghanistan (CFC-A), Combined Joint Interagency Task Force 435, and Combined Security Transition Command–Afghanistan (CSTC-A), had to fill personnel requirements from other organizations.","The DoD’s method of sourcing individual staffing requirements across the components, the Worldwide Individual Augmentation System, dated back to the early 1990s. Under that system, initial responsibility for sourcing a requirement in a combatant command area of responsibility fell to the theater army, navy, or air force using its own assets. For the U.S. Army in particular, if the theater army could not meet the requirement, then it was passed back to Headquarters, Department of the Army, which then tasked the requirement out to another Army organization. Tasked individuals deployed under temporary change of station orders—normally orders for up to one year—to fill the wartime requirement, but this temporary deployment left a vacancy in their parent organizations that would not be backfilled during their absence. For short-term contingency operations, sourcing requirements through individual augmentation was not an excessive strain, but over many years it had a detrimental effect on both individual and collective readiness across the entire force.","The long-term requirements of individual augmentation, such as those necessitated by IRAQI FREEDOM and ENDURING FREEDOM, became a major burden on the active Army for certain high-demand, low-density skills. The impact of maintaining this level of readiness through individual augmentation did not become apparent until several years into the conflict, and it differed by component. The reserve component was able to fill the ranks with volunteers in the short term, but by 2004 the lack of available personnel made many units nondeployable. This was most pronounced in the psychological operations and civil affairs forces that were slated to deploy. At the end of 2004, close to 50 percent of Army Reserve personnel (almost 100,000) had been mobilized since 11 September 2001, including 15,000 who had been mobilized twice and 2,000 mobilized three or more times. Within a few months, only 31,000 of 205,000 Army Reserve soldiers were eligible for mobilization under the policy of twenty-four-month cumulative mobilization without a volunteer statement.","In the active component, those pressures became most apparent by 2006. The individual augmentation requirements for both IRAQI FREEDOM and ENDURING FREEDOM started in earnest in 2003. Individual augmentees typically deployed for a full year in a combat zone. During that time, they were unavailable to their organizations, and according to Army personnel policy they could not be replaced as they were on temporary change of station orders. Once they had returned to their home units, they were nominally exempt from deployment for another year as they met mandatory dwell time at home station. Furthermore, wartime requirements created the additional load of filling organizations such as advisory teams or joint manning documents that did not exist in the permanent force structure. However, the Generating Force that was the usual source for those personnel had already been gutted to provide additional personnel spaces to the Operating Force under modularity. In both cases, personnel deficits—especially in low-density, high-demand specialties—peaked during 2007, just as the Army hit its peak demand for brigade combat teams in ENDURING FREEDOM and IRAQI FREEDOM.","Personnel deficits paralleled equipment shortages as the Army shuffled equipment among organizations to meet requirements for the units slated for deployment. This trend did not abate until November 2008, when equipment-on-hand numbers finally began to improve as surge operations in Iraq came to an end. By 2006, active component brigade combat teams were deploying after spending only a year at home station, even with the Army National Guard’s commitment to replace units undergoing modular conversion. Division and corps headquarters were on similar deployment timelines. For much of the Army, there simply were no personnel available to backfill all of the shortages.",{"title":"The Near-Term Impact of the Iraq Surge on the Army","level":2},{"section":["Under the force-sizing construct envisioned by the 2001 ${Quadrennial Defense Review}{italic}, the Army maintained an authorized personnel end strength of 480,000 active component, 350,000 Army National Guard, and 205,000 Army Reserve soldiers. Although those authorizations never envisioned the Army supporting two simultaneous regional conflicts, for more than six years the troop figures remained virtually unchanged. From April 2003 to January 2007, the Army usually sent fourteen brigade combat teams to Iraq and another three to Afghanistan while continuing to meet other contingency response requirements articulated in standing war plans. Those figures tilted dramatically when the Bush administration decided to surge additional forces into Iraq. The commitment of additional troops began with the deployment to Baghdad of the 82d Airborne Division’s 2d Brigade Combat Team, then serving as the CENTCOM “call forward force” in Kuwait. On 10 January 2007, President Bush announced that the Army would send four more brigade combat teams from the United States to Baghdad as part of the surge strategy designed to reclaim the Iraqi capital from insurgents. In addition to the five active component brigade combat teams, the National Guard’s 1st Brigade, 34th Infantry Division, would remain in Iraq for 125 days past its original redeployment date."]},{"figure":{"source":"/figures/v2/img_1-5.png","caption":"Secretary of Defense Robert M. Gates"}},"${Curtailing Predeployment Training}{bold}","The need for more personnel in Iraq temporarily overwhelmed both the Army Force Generation process and its related Army policies. Two of the five brigades being sent to Iraq did not have enough time to go to the Joint Readiness Training Center or the National Training Center for their mission rehearsal exercises, originally scheduled for February and May 2007 respectively. Instead, those two combat training centers sent observers/ controllers, role players, opposing forces, and equipment to Fort Lewis, Washington, to train the 4th Brigade Combat Team, 2d Infantry Division, and to Fort Stewart, Georgia, to train the 2d Brigade Combat Team, 3d Infantry Division. Although Army Force Generation originally had been predicated on a deployment cycle in which brigades remained at home station for two years before serving twelve months in Iraq or Afghanistan, brigade combat teams were now deploying less than two years after returning from a previous combat tour.","${Extending Tours of Duty}{bold}","Even before the additional demand from the Iraq surge, the Army’s standard twelve-month deployment tour did not allow the units next to deploy sufficient time at home station to prepare for their combat deployment. The Army’s solution was to increase deployment lengths to fifteen months for active component brigades, which Secretary of Defense Dr. Robert M. Gates announced on 11 April 2007. The rationale for the three-month extension to overseas tours was twofold. First was for “a fair, predictable and sustainable commitment to our troops,” to provide as much advanced notice as possible to units that were deploying, as well as to eliminate uncertainties that surrounded past extensions. The other reason was to provide the capability to sustain the deployed force. The ad hoc mission rehearsal exercises at units’ home stations were a necessary stopgap, but it would be unacceptable to deploy insufficiently prepared forces. Keeping units at home station for a year was the minimum time required to adequately prepare those units that were returning to combat. However, the cuts made to the Generating Force to fill the Operating Force meant that the Army had already mortgaged its institutional capacity to speed up both individual and collective training.","Secretary Gates’ directive met with the approval of General George W. Casey Jr., who assumed the position of Army Chief of Staff from Schoomaker  on 10 April 2007. General Casey described the existing strategic environment as a period of protracted confrontation among state, nonstate, and individual actors using violence to achieve their political and ideological ends. He also emphasized that the Army was out of balance: the demand for forces exceeded the sustainable supply, systems designed for a pre–September 11th peacetime force had been unequal to the pressures of six years of war, and the Army’s readiness was being consumed as fast as it could be built.","${Utilization of the Total Force}{bold}","By late 2007, the increased operations tempo in Iraq compounded the pressures on the force to a critical point. The peak demand to the Army started that October, when it had twenty-three brigade combat teams in combat, of which twenty were in Iraq. At the same time, three brigade combat teams were still operating in Afghanistan. These were the 4th Brigade Combat Team, 82d Airborne Division; the South Carolina Army National Guard’s 218th Infantry Brigade; and the 173d Airborne Brigade Combat Team, which had been redirected from its originally intended Iraq deployment.","The reserve components received some relief from the policy changes initiated in anticipation of the October 2007 peak. On 19 January 2007,  Gates took the next step in transforming the reserves by outlining a new policy on the “Utilization of the Total Force,” codifying best practices for mobilization. It would provide for consistent troop presence; develop a sustainable long-term rotation policy; spread the burden of operational demands across components; provide predictability to service members, families, and employers; and maintain the all-volunteer force for the long war. The policy outlined several key items:",{"list":["1.  Planning objectives for the active force would be a 1:2 deploy to dwell ratio, 1:5 for Reserve and Guard. Minimize stop loss [a force management program used to involuntarily retain enlisted personnel] for both active duty and reserve component members. Establish a new program to incentivize or compensate active and reserve members required to deploy/mobilize early or often, or beyond rotational goals. Provide hardship waivers that recognize exceptional circumstances facing members and families of mobilized/deployed members. Manage mobilization of reserve component members on a unit basis. Limit involuntary mobilizations of reserve component members and units to one year.","2.  Minimize stop loss [a force management program used to involuntarily retain enlisted personnel] for both active duty  and reserve component members.","3.  Establish a new program to incentivize or compensate active and reserve members required to deploy/mobilize early or often, or beyond rotational goals.","4.  Provide hardship waivers that recognize exceptional circumstances facing members and families of mobilized/deployed members.","5.  Manage mobilization of reserve component members on a unit basis.","6.  Limit involuntary mobilizations of reserve component members and units to one year."]},"Although the reserve typically had mobilized for sixteen to eighteen months under previous policies, the new approach limited the entire mobilization and deployment process to one year. The revised deployment cycle consisted of extended training weekends and annual training periods for a year before mobilization, forty-five days of premobilization, and nine months deployed time in theater. The policy also made reserve leadership responsible for predeployment training and certification. This development was a dramatic shift from long-standing guidance that only training witnessed by an active component representative at a designated mobilization station was valid for certifying reserves readiness. The new policy remained unchanged for little more than a year before Congress passed legislation in January 2008 prohibiting the deployment of reservists without a minimum of thirty days’ advanced notice.","That same month, the Commission on the National Guard and Reserves, an independent thirteen-member body charged with studying reserve  component organization, equipment, and compensation, published Transforming the National Guard and Reserves into a 21st-Century Operational Force. The commission’s findings were a policy watershed: it recommended that the reserves be reshaped as a force designed for consistent deployments. The DoD would implement that finding, along with many of the commission’s other recommendations, in DoD Directive 1200.17, Managing the Reserve Component as an Operational Force. The new directive had minimal impact on existing practices, however, because the Army’s deputy chief of staff G–3/5/7 for operations, plans, and training had anticipated the impending changes by almost a year when he issued Execution Order 150–08 on 29 February 2008. This order contained an expansive adjustment of mobilization procedures, which included bringing Army-wide expectations in line with Directive 1200.17, adjusting critical timelines and benchmarks, and providing detailed procedures for training tasks and validations, particularly for nonstandard missions.","${Readiness and Training}{bold}","When the Army realized Afghanistan and Iraq had evolved into protracted conflicts waged by ground troops, it began to discard long-accepted readiness practices. The standards used up to 2001, including tiered readiness, the mix of organizational designs in the force, and particular types of unit or force packages, provided the only broadly quantifiable measure of readiness. The structures of those units were aligned with the acquisitions system and its goals, rather than operational requirements. Such an arrangement would have sufficed had the transformational form of warfare envisioned by the DoD produced rapid, decisive victories. In reality, it became clear that pre–September 11th readiness models and organizational methodologies were increasingly irrelevant given the frequency with which units deploying to Afghanistan and Iraq replaced outgoing units with significantly dissimilar structures and capabilities.","Recognizing that a wartime army could not afford to take risks in its current capability to resource future force development, the Army implemented plans to spend more money to increase force readiness. From 2003 to 2009, a huge amount of supplemental funding was allocated to that program in order to provide combat units with the necessary capabilities to perform all assigned missions in Afghanistan and Iraq. That action also marked a repudiation of the previous vision of transformation. The issuance of the Army Campaign Plan in 2004 meant that the old Army Transformation Campaign Plan, and everything it was supposed to drive, no longer applied. Other changes included cancellation of the Comanche helicopter and the Crusader howitzer, along with major restructuring of the Future Combat System designed to “spiral” capabilities as they were ready as opposed to fielding full combat systems. The Future Combat System lingered for several years in a reduced capacity until it was canceled in 2009, having faced criticism that it did not “adequately reflect the lessons of counterinsurgency and close quarters combat in Iraq and Afghanistan.”","The implementation of modularity and Army Force Generation, combined with Schoomaker’s directive to bring the entire Army to the highest manning possible, sought to ensure that all units, most notably brigade combat teams, received equitable resources and training to fit their intended mission. In sharp contrast to the discarded tiered readiness and resourcing approach, the constant rotation of forces between home station and combat ensured that the state of training and readiness among active component brigade combat teams reached a rough parity. Units that had not been maintained at full readiness before September 2001 now benefited from an Army Force Generation process that allocated resources solely on the basis of scheduled combat deployments. Within the active component, high readiness levels were no longer limited to select units with a contingency response mission. Instead, the preponderance of the force was now trained to the highest levels of readiness based on a unit’s upcoming deployment or mission set.","In addition to improving force readiness, the Army’s involvement in Afghanistan and Iraq meant that light and heavy forces gained a degree of mutual familiarization that would not have happened in peacetime. The nexus between the two communities that began with the creation of Stryker brigades expanded further when the Army deployed all three types of brigade combat teams to fill requirements in a given division’s area of operations, as was the case in 2005–2006 in Multinational Division North in Iraq. The first heavy brigade combat teams to deploy to Afghanistan did so in an advisory role, and two-star headquarters long associated with the mechanized and armor community, such as the 3d Infantry Division, 1st Infantry Division, and the 1st Cavalry Division, began serving as regional command headquarters in Afghanistan from 2011 onward. Time and repetitive combat rotations helped break down the divides between the light and heavy subcultures.","Although units from various communities worked with increasing harmony and synchronization in overseas combat zones, predeployment training continued to focus on specific mission-oriented tasks rather than a broader approach to honing warfighting proficiency. An unintended effect of that approach, which concentrated on specific deployed mission-essential tasks at the expense of core mission-essential tasks, resulted in a loss of proficiency for traditional skills such as combined arms warfare. That troubling development convinced Col. Sean B. MacFarland, Col. Michael H. Shields, and Col. Jeffrey J. Snow, who had respectively commanded the 1st Brigade Combat Team, 1st Armored Division; 172d Infantry Brigade Combat Team; and the 1st Brigade, 10th Mountain Division, to formulate and send a white paper to Army Chief of Staff General Casey.","That jointly authored document, released in May 2008, minced no words with its title: “The King and I: The Impending Crisis in  Field Artillery’s Ability to Provide Fire Support to Maneuver Commanders.” The authors asserted that “no branch of the Army has suffered a greater identity crisis than Field Artillery, as a result of transformation, COIN-centric [counterinsurgency] operations, and the nonstandard staff demands of OIF/ OEF.” The basic premise was alarming in itself, but the white paper also provided a wealth of evidence from home station and the combat training centers highlighting the fact that the loss of those skills and the attrition of experienced artillerymen risked “mortgaging not only flexibility in today’s fight, but our ability to fight the next war as well.” The paper, one of the few internal critiques of modularity, went viral soon afterward. Anticipating that decreasing force levels in Iraq from 2008 onward would permit more emphasis on regaining proficiency in core mission-essential warfighting tasks, the Army acknowledged the concerns raised by MacFarland, Shields, and Snow by issuing updated training and leader-development guidance. The new directive stated that active units with eighteen months or more (thirty-six months for reserve units) of dwell time would retrain on core mission-essential warfighting tasks in addition to their deployment-oriented mission-essential task training, while units with twenty-four months or more dwell time would regain proficiency in both core tasks and deployment tasks. In the years to follow, many of the modularity force structure changes would be reversed.","The mission-specific requirements of the Afghanistan and Iraq conflicts not only influenced the Army’s overall training philosophy but also created internal organizational tensions, arising from the use of a predominantly conventional force against irregular opponents. An increasingly vocal group of irregular warfare proponents sought to influence the ongoing debate over the roles, missions, and structure best suited for the Army. Two influential papers published in 2007 and 2008 highlighted their views. The first, “An Army at the Crossroads” by Andrew F. Krepinevich, proposed a formal division of forces between those geared to conduct irregular warfare and security force assistance versus those focused on major combat operations. The second, “Institutionalizing Adaptation” by Lt. Col. John A. Nagl, proposed the creation of a permanent advisory corps using personnel drawn from the conventional force. Although the papers had a considerable following, the successes of the Iraq surge convinced senior Army leaders that conventional forces could conduct irregular warfare as well as they carried out major combat operations. In addition, the Army’s institutional expertise in advising was already resident in the Special Forces, and conventional forces could and did supplement these capabilities as needed.",{"title":"An Army Out of Balance","level":2},{"section":["Even with the ongoing revisions to doctrine and structure intended to improve efficiency and overhaul the service’s approach to twenty-first-century warfare, the Army faced one overarching problem: it simply did not have enough soldiers to carry out its missions. After years of constraints on the force structure, the Bush administration embarked on an ambitious plan to grow the Army across the board, with a particular focus on the skill sets needed for continued operations in Iraq and Afghanistan."]},"${Grow the Army}{bold}","In early 2007, President Bush approved adding 74,000 active Army, 8,200 National Guard, and 1,000 Army Reserve soldiers to the force. That increase allowed for an initiative that became known as “Grow the Army,” resulting in an authorized permanent end strength of 547,000 active personnel and 358,200 national guardsmen by 2010, as well as 206,000 reservists by 2013. The decision to increase the Army force structure signaled the Bush administration’s acceptance of the fact that the Army had to expand because there was no other way to reduce the amount of time soldiers were deployed versus at home. Army Force Generation planners had optimistically estimated the deployed-to-dwell ratio as not exceeding 1:2 for the active component and 1:5 for the reserve component. In reality, most active component brigade combat teams were deployed at a 1:1 ratio, with certain portions of the reserve component force, predominantly military intelligence and aviation units, at a 1:3 ratio.","The Grow the Army initiative began to reverse the previous Army end strength plan for modularity, which had paid for the Army’s deployable Operating Force increases by cutting the Generating Force and lesser-used combat formations. On numerous occasions, the Army had redirected or reappropriated the Generating Force’s personnel and resources to make up deficits in other areas, ranging from bringing the entire force to the highest readiness levels, to modular conversions, individual augmentation, and the Iraq surge. However, that approach was a short-term solution at best. The Generating Force was the Army’s institutional repository of knowledge and skills, and it needed sufficient instructors, trainees, transients, and students to continue to resource future requirements in the Operating Force.","Secretary Gates further approved an accelerated Grow the Army plan that would restore balance in the force in 2011, rather than 2013 as originally planned. This increase would create another six infantry brigade combat teams, two signal brigades, and one additional brigade in fires, maneuver enhancement, battlefield surveillance, sustainment, air defense, and engineers. In the meantime, the Army accepted that the Generating Force would have to make do with its existing resource and personnel shortages until the Operating Force expanded enough to meet demand.","The first brigade combat team to be built from scratch as part of that expansion, which was flagged as the 3d Infantry Brigade Combat Team, 1st Armored Division, initially stood up on 2 July 2009—spanning four force generation cycles from decision to availability of the first new Grow the Army unit. The new brigade then underwent almost two years of training, culminating with a June 2011 validation exercise at Fort Irwin, California, before deploying five months later to Afghanistan. Other units built under the provisions of Grow the Army had been converted from units that were already in the force structure and were not representative of the true time required to build a unit from scratch. No matter what plans or programs were implemented to accelerate the growth of the Army, it would simply take time to build and train ready forces for deployment in combat.",{"figure":{"source":"/figures/v2/grafik_Fig1-6.png","caption":"Efforts to Bring the Army into Balance by 2011"}},"Even though it took several years to produce a deployment-ready infantry brigade combat team from scratch, Grow the Army did not create any heavy brigade combat teams, which also would have placed a much greater demand on the supporting industrial base. The Army sought to avoid exactly that type of situation because it was still reconstituting its prepositioned equipment stockpiles, which had been depleted as units rotated through combat operations in Iraq and Afghanistan.","The expansion also allowed the Army to end certain policies that had been difficult but unavoidable for the force. President Bush reinstituted twelve-month deployments on 10 April 2008, effective for units deploying after 1 August 2008, to return to a dwell time of two years at home station for each year deployed. The president’s directive happened to coincide with the withdrawal of the five surge brigades committed to IRAQI FREEDOM. In the sixteen months that the Army used those units in the Iraq surge, multiple active brigade combat teams had an aggregate deployed-to-dwell ratio below 1:1.","The combined effects of the end of the Iraq surge and the expansion in troop numbers also allowed the Army to end the force management program known as stop loss, in which the Army involuntarily extended or retained active-duty enlisted personnel beyond the end date of their enlistment. Stop loss had existed in various forms since 2002, mostly to prevent soldiers in critical occupation fields from leaving the military, but its most unpopular form started in late 2003 and affected all personnel (regardless of component) in units that were slated to deploy. On 18 March 2009, Secretary Gates announced that the stop loss policy would end in August and September for the reserve component and on 1 January 2010 for the active component.","${Growing Special Operations}{bold}","Efforts to field sufficient Special Forces personnel to meet the combined requirements of both Afghanistan and Iraq predated programs to expand conventional forces. The 2006 National Defense Authorization Act included a proposal to increase Army Special Operations authorizations over the next four years. The increase sought to expand each active component group by one battalion, add a forward-support company to each Special Forces battalion, and expand the group-support battalions. Army National Guard Special Forces battalions would not undergo identical changes, but they received additional support units, including augmented military intelligence, logistics, and reconnaissance detachments. To meet the additional personnel demands, U.S. Army Special Operations Command also received permission to form a Special Operations recruiting battalion.","The force structure increases in the defense act affected more than just the seven active and reserve Special Forces groups. The 160th Aviation Regiment (Special Operations), which supported not only the groups but also Joint Special Operations Command, doubled in size to six battalions. The 75th Ranger Regiment added a Ranger company and a forward-support company to each of its three battalions, and bolstered its intelligence, reconnaissance, and surveillance capabilities. In addition, the sole active component civil affairs battalion expanded to form the 95th Civil Affairs Brigade, which would provide dedicated support to deployed SOF. A second active component civil affairs brigade was projected to be activated in 2009 to perform a similar function for conventional forces. Recognizing the need to fully support an increased number of deployed units, the 528th Support Battalion tripled in size to become the 528th Sustainment Brigade. These proposals were approved without significant modification, which allowed the expansion to begin as scheduled in 2007.","Increased SOF force structure meant additional buildings, training areas, and facilities, and realignment of training and deployments to support conventional forces whenever possible. The Special Warfare Center and School readily adapted to growing requirements for qualified Army SOF, and did so in a deliberate manner. To train more personnel and units, it expanded existing facilities at Camp Mackall, North Carolina, eventually moving an entire training battalion there. Simultaneously, each SOF group received additional facilities at Forts Campbell, Bragg, and Lewis to accommodate their fourth battalion and to meet their increased sustainment and training requirements.","As the ranks of the SOF community swelled, individual SOF units found themselves competing for access to ranges and training areas on major installations with sister organizations as well as conventional units. Seeking a near-term solution to that challenge, Army Special Operations turned to contractors in order to maintain, refine, and enhance their shooting, driving, and sustainment skills. The contractors conducting this training provided fully supported, dedicated training areas and instructors, as well as adaptive scheduling. Special Operations personnel attending the training later disseminated the techniques they learned to other members of their units upon returning to home station.","After evaluating the results of the initial contracted training programs, Army Special Operations leadership expanded them to include other specialized mission-essential skills such as diving, military freefall operations, and the newly added multipurpose canine enablers. More Special Operations personnel requested contractor-led training, and some even felt that the training set the standard for determining a team’s deployment readiness. U.S. Army Special Operations Command initially funded these courses and eventually incorporated them into their programmed budget request.","Reliance on contractor support augmented, rather than diminished, the Special Warfare Center and School’s role in providing advanced skills training. Based on lessons learned and collected from teams returning from combat tours, the Special Warfare Center instituted new courses tailored for troops in Afghanistan, such as high-angle shooting, pack animal operations, and parachute resupply. Unlike the conventional army, which had access to combined arms training centers, the Special Warfare Center and School did not have the ability to conduct predeployment certification rotations—featuring friendly and neutral role players as well as simulated enemy forces—at a specially tailored training center resembling the remote, isolated environments they would encounter in Afghanistan and Iraq.","By 2009, however, U.S. Army Special Operations Command gained the funding necessary to create a Special Operations training facility  at Fort Bliss, Texas. Although the new facility addressed long-deferred collective training requirements, it failed to meet a critical shortfall for the Army: incorporating Special Operations training and support into an overall exercise with conventional forces. This mission belonged to the combat training centers and could never be completely satisfied for several reasons. First, the seven-month rotation cycles for Special Operations personnel rarely matched the conventional force’s twelve-month deployment cycles, making it difficult to coordinate predeployment training and their respective arrival dates in theater. Second, the inherently light nature of Army Special Forces meant that the majority of their training center rotations took place at the Joint Readiness Training Center at Fort Polk, Louisiana, rather than the National Training Center at Fort Irwin—while conventional forces trained at both locations. Third, as the Special Operations commitments in theater increased, they had less time for anything besides mission-critical predeployment training.","An often overlooked development during this period was the growing reliance on female soldiers within Special Operations. With all Special Forces and Ranger authorizations coded for male soldiers, Army Special Forces relied heavily on female soldiers in its civil affairs, psychological operations, support, and staff organizations to engage with female civilians who made up 50 percent of the population in Afghanistan and Iraq. Recognizing the need to communicate with these individuals, Army Special Operations formed ad hoc teams of female soldiers as early as 2002 to enhance civil-military operations. By 2009, U.S. Army Special Operations Command formally created a new organization known as a cultural support team. Cultural support teams interacted with indigenous female populations when such contact was deemed culturally inappropriate if performed by a male soldier. Although similar to the female engagement team program for conventional units, cultural support team members were specifically assessed, selected, trained, and educated to support Army Special Operations. The cultural support teams participated in a wide spectrum of activities ranging from medical civic-action programs, searches and seizures, humanitarian assistance, and civil-military operations.","Not only did the Special Operations community have to meet operational requirements while synchronizing force structure increases, constructing additional facilities, and allotting sufficient preparation time to deploying units, it also had to cope with unforeseen decisions by the Base Closure and Realignment Commission. The commission was created to provide an objective, thorough, accurate, and nonpartisan review and analysis, through a process determined by law, of the list of bases and military installations that the DoD recommended be closed or realigned. In 2007, that body determined the 7th Special Forces Group, 1st Special Forces Regiment, would relocate from Fort Bragg, North Carolina, to Eglin Air Force Base, Florida, by 2011. However, because Eglin Air Force Base did not have facilities to accommodate the incoming unit, the DoD spent $255 million to construct new ranges, training areas, motor pools, and barracks before the 7th Special Forces Group arrived. The move also effectively precluded the 7th Special Forces Group from serving as the headquarters and primary force-providing elements for Combined Joint Special Operations Task Force (CJSOTF)–Afghanistan from mid-2010 through late 2011. This only added to the tempo and stress of the other Special Forces Groups who had to fill the void.","As an institution, the U.S. Army’s evolution during these years was critical to its ability to support the Global War on Terrorism with trained and ready forces, as well as to the development of updated counterinsurgency doctrine to guide those operations. As the following chapters will show, this doctrine provided a sound basis for future operations in both Afghanistan and Iraq. Doctrine was only a part of the overall project; efforts to relieve stresses on the force were another vital component. Getting dwell time back to acceptable lengths, reducing stress on military families, improving medical and dental readiness, growing the force, and updating training facilities all would be key elements needed to sustain the U.S. Army through the conflicts ahead."],"chapter  2":[{"title":"A War in Transition"},{"section":["With the completion of the Bonn Process, Afghanistan possessed the framework for a centralized state that could support the U.S.-led Global War on Terrorism. However, adopting a constitution, holding elections, and forming a government did not by themselves guarantee a functioning bureaucracy or popular support. To achieve those objectives, the state needed to protect its population from foreign and domestic threats, provide essential services such as healthcare and education, and support an economic environment in which people provided for themselves and their families. Consequently, linking the state apparatus established during the Bonn Process to the general populace was necessary for creating a unified nation. As Ambassador Ronald E. Neumann stated, “The fundamental issue all along has been that if you have the goal of preventing a recurrence of terrorism in the country then you have to have a security force to do that. To have a security force you have to have a government. To have a government you have to have a state and an economy. And then you’re doing nation-building.”","${Implementing the NATO Operational Approach}{bold}","As the lead nation for building the Afghan National Army (ANA) under the Bonn Process, the U.S. effort that started with only a few Special Forces detachments had expanded into the Office of Security Cooperation–Afghanistan, an element of Operation ENDURING FREEDOM coequal with its counterterrorist operations under Combined Joint Task Force 76 (CJTF-76). Insurgent attacks in 2005 and 2006, however, made it evident that more work needed to be done before the Afghan government could provide its citizens with adequate security. Lt. Gen. Karl W. Eikenberry and Ambassador Neumann inherited a program to develop the Afghan Army that was well underway by 2005, as well as efforts to build the Afghan National Police (ANP) that could not yet meet the nation’s basic security needs.","After the coalition removed insurgents from communities, a representative of national authority had to secure the population and demonstrate the Afghan government’s presence before Provincial Reconstruction Teams, nongovernmental organizations, and other agencies could inject seed money to build local institutions. Neumann and Eikenberry focused on building indigenous security forces because they saw the Afghan army and police as fulfilling important roles in establishing a functioning Afghan state. While they championed Afghan participation in ongoing combat operations, they also embraced the continued upgrading of Afghan National Security Forces (ANSF) capabilities. In the view of Eikenberry and the CFC-A, ANSF owned the “hold” phase of the “clear, hold, build, and engage” counterinsurgency model.","The Bush administration held views similar to Eikenberry and Neumann, but for different reasons. It viewed Afghanistan’s National Assembly and provincial council elections as the culmination of the Bonn Process and a potential transition point for ENDURING FREEDOM. The elections prompted Secretary of Defense Donald H. Rumsfeld to ask Joint Chiefs Chairman General Richard B. Myers in January 2005 for a strategic approach to Afghanistan for the next twelve to eighteen months. “I think it is critically important that we, very promptly, have a plan for the rest of this year in Afghanistan,” wrote Rumsfeld. “If we announce it and it is a good plan, it can have a positive effect in Iraq.” The note indicated that although the Pentagon needed clear direction in Afghanistan, the secretary’s focus remained on the war in Iraq.","Rumsfeld’s concerns stemmed from his belief that the United States could not maintain its current levels of commitment in Afghanistan as violence mounted in Iraq. As CFC-A understood it, Rumsfeld sought to put U.S. forces on a path out of Afghanistan. He demanded weekly metrics from CFC-A showing progress in ANA training and customs collection and the public revenue necessary for the Afghan government to sustain its army. To hasten the development of Afghan security capabilities, the defense secretary also sought to gain control of training the ANP. He understood that “an effective, professional police force” would be “central to the achievement of [the] U.S. Government’s strategic objectives in Afghanistan.” Effective police forces were needed for counterinsurgency (in support of similar ANA efforts), political development (such as election security), counternarcotics (including interdiction and eradication), border security, customs collection, domestic law and order (personal security for the Afghan people), and the disarmament and demobilization of the remaining private militias. In April 2005, after much interagency and congressional wrangling, the State Department relinquished its responsibility for overseeing Afghan police training to the DoD.","Meanwhile, Rumsfeld also pushed NATO to increase its combat involvement in Afghanistan. Even though ISAF initially agreed to expand into RC West, force generation issues prevented that expansion from happening before the Afghan presidential election. When NATO forces did arrive, the North Atlantic Council could not reach an agreement with the Bush administration about merging the ENDURING FREEDOM (counterterrorist) and ISAF (security) missions. At a meeting of NATO defense ministers in Berlin in September 2005, Germany—with the support of France, Britain, and other European countries—made it clear that they would not accept such a merger. Rumsfeld seemed intent on beginning a U.S. drawdown, with or without increased NATO involvement, as reports surfaced that the Pentagon was considering downsizing the U.S. presence by as much as 4,000 troops.","With the Bonn Process completed and the war in Iraq showing no signs of ending, the American government unilaterally decided to reduce resources already allocated for Afghanistan. The administration reduced total spending on the country from $4.9 billion in fiscal year 2005 to $3.5 billion in 2006. Cuts across the board included significant reductions in the security, governance, development, and humanitarian allocations. In terms of deployed troops, the United States had just 19,500 service members in Afghanistan in April 2005, compared to roughly 137,000 in Iraq. American policymakers continued to press for keeping the U.S. Army’s footprint in Afghanistan small. As a result, Rumsfeld ordered the 10th Mountain Division to trim its planned 2006 ENDURING FREEDOM deployment by roughly 40 percent. The decision reduced the projected number of American forces in Afghanistan from 19,000 to 16,000 by spring 2006.","With the Bush administration intent on reducing U.S. military participation in Afghanistan, NATO took steps to secure and develop the country until the Afghans were capable of doing so themselves. By September 2005, the treaty organization expanded ISAF’s footprint into RC West. Three months later, the North Atlantic Council agreed to a timeframe for taking over RC South and RC East. That same month, NATO revised Supreme Allied Commander Europe Operational Plan 10302 to better align its political and military goals with those pursued by the United States. Politically, NATO aimed for “a self-sustaining, moderate and democratic Afghan government able to exercise its sovereign authority, independently, throughout Afghanistan.” NATO planned to achieve these goals through security and stability operations, in particular through reconstruction teams who would “expand the beneficial ISAF effect” into unassimilated provinces. Militarily, the goal was to develop ANSF to the point that they could “provide security and sustain stability . . . without NATO support.” As with the United States, NATO’s exit from Afghanistan was “dependent on the successful development of credible, professional and legitimate Afghan security structures.” In contrast with earlier American campaign language, the plan called on NATO to “operate with subtlety and a light touch” and to “facilitate the continued physical and moral extension of Afghan government authority.”","The Pentagon welcomed this pathway to securing Afghanistan because it did not rely exclusively on U.S. troops. The shift to international responsibility meant that the United States could begin extricating its forces and sending them to Iraq. In deciding on this course of action, Rumsfeld listened to his closest military advisers rather than their civilian counterparts. Even though Rumsfeld shared his civilian advisers’ worries that ISAF’s capabilities would be limited by member nations’ caveats on force contributions, NATO’s inability to sustain itself over long distances without U.S. assistance, and the inevitable reduction in American influence following a U.S. troop drawdown, he ultimately accepted the military’s opinion that NATO was ready. The next four years would show this assessment to be a critical miscalculation that ignored the enemy’s ability to alter the strategic equation."]},{"title":"The Afghanistan Compact","level":2},{"section":["As the United States and NATO worked to transition the ISAF mission, President Hamid Karzai’s government and the international community made new plans for Afghanistan’s future. At a January 2006 conference in London, all parties agreed on a new framework to guide development for the next five years. The subsequent Afghanistan Compact amounted to a pledge by the international community to “build lasting Afghan capacity” with an eye toward Afghan “ownership,” and in return the Afghan government promised to “combat corruption and ensure public transparency and accountability.” Combined with an Interim National Development Strategy agreed upon around the same time, the Afghanistan Compact set specific deadlines for improving security, governance, and economic development.","The compact called for the disbandment of all “illegal armed groups” in 2007, an ethnically balanced Afghan  army of 70,000 to be fully operational by 2010, and a combined ANP and Border Police component of 62,000 by the end of 2010. Among the numerous development initiatives, two in particular would affect U.S. Army operations: the call for a “fully upgraded and maintained” Ring Road, with arteries connecting Afghanistan’s main national highway to neighboring countries by the end of 2008; and an electric system that could supply 65 percent of households and 90 percent of nonresidential establishments in urban areas, as well as 25 percent of households in rural areas, by the end of 2010. Sixty countries represented at the London Conference pledged more than $10 billion to fund these projects. This sum was significant but met only half of Afghanistan’s projected needs for the next five years. To guide program implementation and report on progress, the Afghanistan Compact also established a Joint Coordination Monitoring Board of international and Afghan representatives in Kabul.","For the U.S. Army, the compact’s most relevant portions dealt with security. Its authors articulated that ISAF, U.S. forces, and partner nations would continue to “provide strong support to the Afghan Government in establishing and sustaining security and stability in Afghanistan, subject to participating states’ national approval procedures.” Security and stability operations would become ISAF’s responsibility, particularly through Provincial Reconstruction Teams, which would increase in number to cover the entire country by the end of the year. The agreement further stated that the ENDURING FREEDOM counterterrorism mission, specifically identified as a separate American effort, would be closely coordinated with the Afghan government and ISAF. Taken as a whole, the Afghanistan Compact reaffirmed the international community’s involvement in and support for Afghan development and formalized the process by which NATO would assume the strategic lead for coalition activities in Afghanistan. The United States would continue to conduct counterterrorist operations, but it would fold most American forces into the ISAF structure.","Unfortunately for the coalition, none of the plans for Afghanistan’s future—America’s gradual exit, NATO’s assumption of the stability mission, and the Afghanistan Compact—fully accounted for the realities on the ground. Requests for increased resources by American leaders in Afghanistan went unfilled by Washington. Throughout the fall and winter of 2005–2006, Ambassador Neumann fought to increase funding for agriculture and infrastructure development programs with little success. He warned in October 2005 that the embassy could not implement the National Security Council’s comprehensive strategy without additional monies. In a February 2006 cable, he argued that the United States stood to lose years of critical infrastructure development, especially in the transportation and energy sectors, with negative strategic consequences for the overall war effort.","General Eikenberry separately recommended increases for the train-and-equip missions for both the ANA and the ANP. Unfortunately for America’s ranking civilian and military leaders in Afghanistan, the Office of Management and Budget was dealing with more urgent priorities in Iraq and the aftermath of Hurricane Katrina at the time, and ultimately included only $32 million (rather than the $600 million originally requested) for Afghanistan in the emergency supplemental budget that year. As other priorities diverted and distracted the Bush administration’s attention over the next three years, circumstances in Afghanistan slowly deteriorated."]},{"figure":{"source":"/figures/v2/img_2-1.png","caption":"Maj. Gen. Jason K. Kamiya"}},{"title":"The Situation in Fall 2005","level":2},{"section":["At the operational level, the 2005 National Assembly and provincial council elections had little influence on U.S. forces in Afghanistan. Based out of Camp Eggers in Kabul, General Eikenberry continued to exercise command and control through his two major subordinate headquarters, the Office of Security Cooperation–Afghanistan under Air Force Maj. Gen. John T. Brennan and CJTF-76 under Maj. Gen. Jason K. Kamiya. Kamiya’s maneuver forces consisted of Col. Patrick J. Donahue II’s 1st Brigade Combat Team, 82d Airborne Division (Task Force DEVIL), located in RC East, and Col. Kevin C. Owens’ 173d Airborne Brigade (Task Force BAYONET) in RC South.","As the CJTF-76 commander, Kamiya exercised operational control over all conventional U.S. Army forces in the country, as well as CJSOTF-Afghanistan until December 2005. To support CJTF-76’s main lines of effort, U.S. SOF conducted counterterrorism operations against high-value targets, foreign internal defense operations in support of the new Afghan government, and security assistance to develop ANSF participation in security sector reforms. At the operational level, the SOF mission included supporting the National Assembly and provincial council elections; disbanding the Afghan militias under the disarmament, demobilization, and reintegration programs; and preparing for the realignment of coalition SOF under ISAF. At the tactical level, SOF aided CJTF-76 with armed reconnaissance, network assessment, and battlefield preparation. A combination of nonlethal and lethal operations had succeeded in safeguarding the presidential elections in 2004 and, to a lesser degree, the national and provincial elections in 2005. Kamiya looked to continue the practice for as long as he had the authority to do so. With the help of Special Forces, Kamiya increasingly emphasized civil affairs and psychological operations during this period. These techniques for exercising influence became particularly relevant as Provincial Reconstruction Teams increased in number."]},{"figure":{"source":"/figures/m/map-figure-2-2.svg","caption":"Force Laydown","prefix":"MAP"}},"With the SOF remaining under CJTF-76 until December 2005, they requested permission to change missions from guarding borders to developing, partnering, and advising newly trained ANA infantry kandaks (Afghan battalion-sized unit). Recognizing the role that Operation NEWBURGH played in securing the elections, Kamiya approved the request, directing the Special Operations Task Force to issue a new directive named VALLEY FORGE in October 2005, outlining the change in mission. To ease the planned handover, Operational Detachments Alpha (ODAs) holding isolated firebases along the Afghanistan-Pakistan border in RC East and RC South were augmented with infantry squads or an infantry platoon in order to familiarize incoming units with mission requirements.","As the order was being finalized, the command’s ODAs transferred their border mission to conventional forces while preparing for 7th Special Forces Group’s return. The change ensured the incoming group would become intimately involved in training and partnering with ANA kandaks, border police, and local security forces. The new mission also meant that special operations units would be working throughout the country rather than along the borders, which translated into a significant need for additional airlift. With the Army sending most of the 160th Aviation Regiment (Special Forces) to Iraq, a dearth of dedicated airframes, combined with poor roads in many parts of RC South and RC East, forced SOF to rely increasingly on conventional army airframes, which often were not equipped to the same standards as SOF aircraft.","The SOF were not alone in having to meet their mission objectives with limited resources. Eikenberry understood that political leaders in Washington expected U.S. troop levels to drop over the next several years. Correspondingly, he viewed his primary mission as creating “the conditions for a successful battle handoff from CFC-A to ISAF.” He had reduced Lt. Gen. David W. Barno’s lines of operation from twelve to three. Security remained the primary focus for CFC-A in this reduction, with the interconnected goals of defeating al-Qaeda and its associated groups and building up the Afghan government’s ability to provide for its national security as supporting lines. Two parallel lines of effort—governance and justice, and economic and strategic reconstruction—now supported the security thread. Counternarcotics operations remained a tertiary goal, integrated into the primary and secondary lines of operation. Finally, Eikenberry set for himself the tasks of engaging with Central Asia governments and communicating the threat posed by Pakistan to Washington.","While Eikenberry harmonized CFC-A’s theater approach with ISAF’s increased operational role, Kamiya cautioned his Task Force commanders that “the enemy, realizing defeat in his efforts to derail the election process, will launch at least one more offensive surge prior to beginning withdrawal to winter sanctuary [in Pakistan].” U.S. forces would “meet his [i.e., the enemy’s] challenge by sustaining the tempo and nature of our offensive operations.” To do so, Kamiya called for “equally aggressive non-kinetic, offensive-oriented CERP [Commander’s Emergency Response Program]/civil military operations in those areas that the enemy will cede to us due to the oncoming of winter.” Kamiya further noted that although initial planning requests for emergency response funds totaled some $67 million for fiscal year 2006, that amount would grow to $166 million by the end of the fiscal year. Thus, U.S. forces sought to bolster their gains along the Pakistani border during the remainder of 2005 with an ambitious aid program designed to foster support among the local population. An aggressive program of information operations highlighted projects to erode the standing of enemy leaders and build support for Afghan government officials. As Kamiya recalled, “We are engaged in an information campaign that is supported by military operations. We are no longer in a military campaign supported by military operations.” General Kamiya and the CJTF-76 headquarters, the Southern European Task Force, were scheduled to rotate out of Afghanistan in early 2006. In preparation, CJTF-76 crafted its last major operation, SECURE PROSPERITY, to begin in February 2006 and continue into the 10th Mountain Division’s deployment. In congruence with the contraction of U.S. forces in theater to RC East, the plan called for targeting Hezb-e-Islami Gulbuddin (HIG) until it was “defeated and incapable of supporting [al-Qaeda] operations or disrupting the CJTF relief-in-place process.” Operations in central and southern RC East, as well as those in RC South, were to “contain” Haqqani and Taliban forces while, at the same time, build Afghan security force capabilities. The four-phased operation included elements of U.S., coalition, Afghan, and Pakistani forces on both sides of the border. The operation’s goals were to deny the enemy a permanent base of operations in Afghanistan, to maintain continuity of operations during the U.S. transition, to increase Afghan confidence in their own security forces, and to establish a more permanent Afghan security presence in northern RC East, to include establishing a reconstruction team in Nuristan Province. By acclimating Afghan forces to winter operations, Kamiya hoped they would stay close to local communities long enough to build relationships and prevent a resurgence of the insurgency in the spring.","With the successful National Assembly and provincial council elections and apparent synchronization of the ENDURING FREEDOM and ISAF missions, ISAF moved forward with its plan to take over the final two regional commands in 2006. After months of deliberation and planning, NATO announced in December 2005 that it would accomplish that goal over the following year. The move to RC South would be completed by midsummer 2006. A Canadian Task Force would deploy in the spring, operating under CJTF-76 until additional NATO forces arrived and RC South transitioned to ISAF control. After that, ISAF would take control of RC East. CJTF-76 would contract its forces into the region and shift from CFC-A to ISAF command sometime in the fall. With the transition finalized, CFC-A would be disbanded and ISAF would become the headquarters responsible for all military operations in Afghanistan.",{"title":"Reforming the ANP Training Mission","level":2},{"section":["As American forces prepared to transition security responsibilities to NATO ISAF, the Office of Security Cooperation spent the latter half of 2005 building a police program and supporting ANP training. The realization that trained and equipped police units were just as important as ANA units gained increasing traction among American and NATO officials as the transition to ISAF control loomed. In December 2005, President Karzai approved an organizational document known as the tashkil (from the Dari word for “organization,” used here in the sense of an official list) that dictated “force structure, personnel end strength, command relationships, and unit/staff functions and mission descriptions for the ANP.” The product of negotiations between the German Police Project Office and the Afghan Ministry of Interior, with input from the United States and other international partners, the tashkil set the maximum size of the ANP at 62,000. The Afghanistan Compact detailed this desired end state in early February 2006, stating that the ANP not only would become “fully constituted, professional, functional and ethnically balanced” by the end of 2010 but also would be “able to meet the security needs of the country and will be increasingly fiscally responsible.” Considering the current state of the force, these were ambitious goals.","In addition to overseeing the creation of the tashkil, General Brennan initiated pay and rank reform to “break the chain of corruption” that low wages encouraged and designed a nationally recruited police force that based rank and promotion “on merit, not loyalty or connections.” To oversee the effort, the Ministry of Interior formed an all-Afghan board known as the Rank Reform Commission. After consulting with the Office of Security Cooperation–Afghanistan, the commission determined that all new officers would be graduates of the police academy and both new and existing officers would be paid according to new pay scales. Salaries would be funded from the Law and Order Trust Fund for Afghanistan at the annual rate of $75 million. As conceived by the Security Cooperation headquarters, the commission would finish its work by June 2006. Unfortunately, this milestone also proved ambitious. The new protocol called for all officers to take a written exam and mandated both a file review by the Rank Reform Commission and vetting for human rights abuses by the United Nations (UN) Assistance Mission and State Department officials. Widespread illiteracy and the paucity of available records meant that vetting the almost 20,000 officers and noncommissioned officers took longer than anticipated; the final phase (selecting sergeants and patrolmen) did not begin until May 2007.","Reforming the Afghan police required effective leadership as well as time. By necessity, selecting senior ANP officers became the first step in instituting change. After the Reform Commission chose the ANP’s most senior generals, it filled the Ministry of Interior’s 34 provincial police chief positions from a pool of 317 applicants. Driven by a different understanding of effective leadership, Karzai ignored the commission’s recommendations and named his own appointees, including fourteen individuals who either had failed their exams or were known to be corrupt. Although the president eventually agreed to replace eleven of the fourteen generals with commission recommendations, his intransigence set the process back six months.","Karzai’s reluctance to follow his commission’s recommendations highlighted the difference between Afghan and Western concepts of effective governance. While Americans and their allies wanted to remove the corruption they believed was impeding institutional growth, Karzai viewed the political landscape differently. He needed influence and a support base to maintain his position, and experience in Afghan politics had taught him that effectiveness depended on indebting powerful leaders to himself and his network. According to Ambassador Neumann, “Without force, money, or unified support within the government, the power of appointment to build political support networks was Karzai’s only political tool.” By distributing political offices as far down as the district level, Karzai and his coterie could build a patronage system with the stability that the formal Afghan political structure lacked. The practice also ensured that a steady stream of favors and money made their way back to Karzai as officeholders of questionable competency sought to maintain their positions of power. “Some of those appointed were corrupt,” Neumann noted, “but when the U.S. menaced them, it menaced [Karzai’s] entire structure of support.” Unsurprisingly, the patronage system undercut the official political system’s legitimacy, which the Taliban exploited to promote instability. Short-term expediency and personal gain took precedence over the long-term stability of the nascent Afghan government in the eyes of those profiting from the patronage arrangement. In January 2006 the U.S. Army’s Maj. Gen. Robert E. Durbin succeeded General Brennan as the chief of the Office of Security Cooperation–Afghanistan. Unlike his predecessor, Durbin had significant experience in training ground combat troops. Before arriving in Afghanistan, he commanded at company, battalion, and brigade levels in armored and infantry divisions. Soon after Durbin’s arrival, the CENTCOM commander, General John P. Abizaid, elevated Durbin’s organization from an office to a command. The organization’s new name, Combined Security Transition Command–Afghanistan (CSTC-A), went into effect in a redesignation ceremony at Camp Eggers on 6 May 2006. The move not only made the command arrangement between Durbin and his higher headquarters similar to that used in Iraq, but also raised the profile of the training mission in anticipation of CFC-A’s impending disestablishment at the end of the year. Once CFC-A went away, the security transition headquarters could absorb some of its personnel and, because it would operate outside the ISAF chain of command, the training organization needed to have increased authority in theater.","After discerning that he lacked the resources for the mission given to his command, Durbin sought to add an additional  brigade-sized training force to his organization. It took until February 2007 for the Army to agree to his request, and it was not until 2009, long after Durbin had left the assignment, that any significant troop increases took place. Durbin also was dismayed to find a significant imbalance of capabilities within his command. More than 4,000 personnel were involved with training the Afghan Army, while only 88 personnel—later increased to 108—were overseeing the police training mission. Durbin would later observe that police training was “under resourced dollar wise for the first four years, [and] under resourced manpower wise for the next three to four years.” General Eikenberry concurred: “Here, I think the competing demands of the Iraq War were hurting our own efforts.”","One particularly troubling development in local security was that government officials were hiring militia forces as police officers and using them for personal protection. Afghanistan had a long history of local militia leaders increasing their power by supporting warlords. Hiring police as personal militias undercut their professionalism and divided their loyalties, making it possible for police to join militia groups that challenged the central government’s authority. To prevent this from happening, Karzai initiated two new programs. The first, known as Disarmament of Illegal Armed Groups, was launched in May 2006 as a successor to the disarmament, demobilization, and reintegration program that ended with the completion of the Bonn Process. The program sought to disarm and disband all armed groups that were not sanctioned by Kabul. The second was a bridging mechanism that Karzai hoped would provide local security until the Afghan Uniformed Police were more capable. Despite objections from the international community, the Afghan president moved in early June to coopt militias by incorporating them into a new organization called the Afghan National Auxiliary Police. Formalized by presidential decree in October, the auxiliary police proposal called for a force of 11,241 recruited from local militia pools in 124 high-risk districts in Farah, Ghazni, Helmand, Kandahar, Uruzgan, and Zabul Provinces. Recruits would receive ten days of training (five days of classroom instruction, five of range firing) and then be issued an AK47 rifle and a standard ANP uniform (with a distinct patch). Afghan auxiliary policemen would receive a further ten days of training every three months, and would be paid the same monthly salary (US$70) as their regular police counterparts."]},{"figure":{"source":"/figures/v2/img_2-2.png","caption":"An ANA officer"}},"The auxiliary police program sought to legitimize the tribal militia groups that played an important part in Afghan politics. Despite his support for the new disarmament program, Karzai did not want to end the power that the militias represented; rather, he wanted to incorporate their influence into Afghanistan’s formal government. Supporting the Afghan National Auxiliary Police allowed him to regulate a power base that he did not normally control. Reflecting the president’s position, the disarmament and auxiliary police programs were politically sensitive elements of the American and coalition “rebalancing plan” for the ANP. This rebalancing involved eliminating the corrupt and ineffective Afghan Highway Police and integrating their rolls into the Uniformed Police. Unfortunately, many highway police chose to quit rather than join the regular police force, taking their uniforms and weapons and going home. CSTC-A initially intended the auxiliary police to protect rural Afghans for two years while it developed other reform initiatives, but the program’s deficiencies caused it to end within eighteen months. The Afghan auxiliary police program’s failure surprised coalition leaders such as Ambassador Neumann, who later stated that “we knew that the program was a desperate effort when we set it up, but we spent that whole winter of 2005–2006 groping around for anything we could do to deal with what we assumed was going to be an intensified insurgency.”","The rebalancing plan had greater success with the Afghan Standby Police. Instead of simply folding the unit back into the regular police,  Durbin’s planners decided to convert it into a specialized force. The result was the Afghan National Civil Order Police. Developed in the fall of 2006, the concept gave the new unit two primary roles: respond to civil unrest and national emergencies in eight major metropolitan areas and patrol high-threat and remote areas to maintain a robust police presence there. The 5,000-strong, multiethnic force would receive modern equipment and vehicles (including armored patrol vehicles for increased IED survivability), robust training (sixteen weeks rather than the ANP’s standard five to eight weeks), increased communications and logistical support, and other incentives “to attract a better pool of applicants.” The overall force consisted of a headquarters company, three patrol brigades, and one civil order brigade. The Ministry of Interior distributed the patrol brigades among the most unstable districts in the country’s southern and eastern provinces and divided the civil order brigade among eight major population centers. Although the units had specific geographical responsibilities, they could be sent to other provinces as needed. To prevent provincial governors from blocking their deployments, all civil order police units fell under the authority of the Ministry of Interior, with their headquarters in Kabul. Although small, the civil order police would be a vital component of U.S.-led police reforms in the coming years.",{"title":"Civil Military Operations","level":2},{"section":["By the fall of 2005, reconstruction efforts in Afghanistan faced two dramatically different environments. In the western and northern regions, where the Taliban had failed to regain a foothold, reconstruction flourished. In sharp contrast, enemy activity in RC South and RC East threatened humanitarian efforts and inhibited development projects. As the Taliban and its associated insurgent groups intensified their campaigns against the Kabul government and the international coalition, nongovernmental organizations began leaving threatened areas, even if the district or province was otherwise calm. In some cases, the Taliban targeted aid workers and employees of these organizations, seeing them as agents or partners of the government. In other instances, criminal groups preyed on unarmed aid workers, prompting a similar hurried departure and a marked reluctance to return unless their security could be absolutely assured. Over time, this phenomenon resulted in nongovernmental organizations clustering in quiet regions such as northwestern Afghanistan and being virtually absent from the country’s volatile south and east.","As the Taliban grew more aggressive, it began to threaten national infrastructure projects funded by the U.S. Agency for International Development. Insurgents targeted the building efforts of the Kajaki hydroelectric facility in northern Helmand, the Gardez to Khost road, large portions of the Ring Road near Kabul, and the Jalalabad to Asadabad road. The U.S. Agency for International Development was just as reluctant as nongovernmental organizations to venture into disputed provinces. Even the temporary absence of aid officials degraded regional reconstruction efforts because each major project required time, site observation, and constant attention to maintain momentum. As a result, humanitarian projects could take place only in areas where U.S. and ISAF forces maintained a presence or conducted major operations to reestablish security.","In order to focus efforts, General Eikenberry’s reconstruction plans centered on rebuilding Afghanistan’s basic road network. Better roads would not only enable the transport of goods but also improve the Afghan government’s access to communities, strengthening their ties to Kabul. Eikenberry did not want the U.S. military to dominate reconstruction efforts, thinking instead that civilian agencies had the technical expertise needed to oversee projects. He understood that “relative to the civilian team, a military commander usually has comparative advantages in transportation, communication, security, planning competency, flexible funding, and niche skills.” In Eikenberry’s view, the military needed to make these resources available so that civilians could apply their expertise to mission-critical areas while avoiding “the hubris of believing [that] soldiers can do everything well and then indeed trying to do everything.” Instead, he preferred to work in support of the State Department and the U.S. Agency for International Development’s reconstruction projects. These initiatives included both those that could provide short-term tactical benefits for U.S. and Afghan forces as well as those offering long-term improvements to be sustained by the Afghan government.","With American maneuver forces focusing on security, reconstruction teams continued to be the primary means of promoting governance and reconstruction. The teams had been created as “an interim civil-military organization designed to operate in semi-permissive environments” in order to “improve stability in a given area by helping build the host nation’s legitimacy and effectiveness in providing security to its citizens and delivering essential government services.” Ideally, the reconstruction teams could be dissolved “when normal development operations can be carried out without [their] assistance.” Therefore, teams needed sufficient security to prevent the enemy from disrupting their efforts to improve governance and support reconstruction."]},{"figure":{"source":"/figures/v2/img_2-3.png","caption":"The Gardez-Khost road construction project"}},{"title":"A Renewed Enemy","level":2},{"section":["Compared to earlier years, the prospects for enhancing the security situation in Afghanistan seemed dim. During the 2006 fighting season, sustained offensives replaced the Taliban’s hit-and-run tactics of previous years. In 2004, ISAF reported 900 security-related incidents countrywide. Attacks increased in the later part of the campaigning season but were largely held in check by the resource surge that preceded the National Assembly and provincial council elections. By 2006, reported security incidents rose to 5,000. In particular, IED attacks increased from 325 to 1,931 over the period. Coalition casualties also increased, more than tripling from 58 killed in action in 2004 to 191 killed two years later. While Afghanistan had experienced continuous violence since early 2003, the increase in attacks demonstrated that the insurgency was “well past the incubation stage.” Coalition forces now faced deliberate attacks and ambushes, along with attempts to interdict ground lines of communications, harass key bases in outlying provinces, and assassinate effective Afghan partners. All these actions ensured that insurgents maintained a coercive influence on a population suspicious of the Karzai government.","The fact that the U.S.-led coalition did not face a unified front further complicated matters. By the end of the 2005 fighting season,  coalition and Afghan security forces faced three interconnected conflicts. The first was a regional struggle against the Afghan Taliban and associated groups such as Gulbuddin Hekmatyar’s HIG and the Haqqani Network. These groups were motivated by a desire to expel foreigners from Afghanistan and return to implementing the rule of law according to their interpretation of Islam. The second was the Global War on Terrorism directed against al-Qaeda remnants based in Pakistan’s tribal areas and enabled by Pakistani extremists. Finally, coalition and Afghan troops faced numerous destabilizing actors: predatory warlords, narcotics producers, criminal gangs, petty thieves, and smugglers. Some of these parties occasionally allied with factions within the government or insurgent groups, but in sum they were a corrosive presence in both Afghanistan and Pakistan.","Of these three conflicts, the Taliban-led insurgent coalition posed the greatest direct threat to Afghan stability and security. The Quetta Shura Taliban had its strongest organizations in Afghanistan’s Pashtun-dominated southern provinces of Zabul, Uruzgan, Helmand, and Kandahar. In 2005, coalition officers estimated the threat posed in these provinces as low key, with IEDs and ambush cells periodically recruiting the help of local farmers. The absence of sustained enemy activity led one American commander to think that they had the Taliban “all but defeated.” The remaining armed opposition groups in Helmand, Uruzgan, and Kandahar were considered marginal threats. However, fighters trained in Pakistan were arriving in strength, ready to conduct operations once the poppy harvest ended in the late spring. Their successful and largely unnoticed infiltration into the Arghandab and Helmand River valleys menaced the provincial capitals of Kandahar City and Lashkar Gah. By April 2006, the Taliban had assembled numerous well-trained and well-supplied foot soldiers in southern Afghanistan.","The south was not the only region penetrated by substantial insurgent forces. In eastern Afghanistan, the Haqqani family  network directed or facilitated many insurgent and tribal militia groups operating in a region, encompassing Khost, Logar, Paktika, Paktiya, and parts of Nangarhar and Wardak Provinces called Loya-Paktia. The Haqqani and their subordinates were not strictly Taliban, but they were willing to affiliate with Mullah Mohammed Omar’s movement for pragmatic objectives: fighting foreign soldiers, capturing Kabul for the Pashtuns, and establishing sharia (Islamic religious law). In exchange, the Haqqani family had free rein to run their own jihad (struggle, in the sense of a holy war waged on behalf of Islam) on both sides of the border. The Haqqani Network’s main ties to the insurgency stemmed from its value as a facilitator for al-Qaeda and other foreign extremists. From their Pakistan base area of Miran Shah, Haqqani transit lines entered Afghanistan’s Khost Province. The Haqqani knew Khost well, and the restrictive terrain ensured the region remained an active sanctuary for insurgents operating as far away as Kabul. With dozens of madrassas (religious educational institutions) across the border churning out thousands of graduates each year, units operating in eastern Afghanistan faced a seemingly endless stream of potential recruits prepared for jihad.","Throughout 2005 and into 2006, the Haqqani Network expanded from its established positions along the border into Khost and Paktiya Provinces. This expansion was possible not only because of the Haqqani forces but also because religious networks had become stronger at the expense of local tribal leadership. This shift toward fundamentalism allowed the Haqqani to substitute their patronage of madrassas for traditional power structures. Ineffectual district governance then gave the Haqqani the opportunity to exploit their financial strength and prestige as successful mujahideen (holy warriors) in a grab for power. Haqqani-backed insurgents operating from Pakistan became more ambitious in 2006, establishing infiltration routes across the frontier leading to Kabul. As in the south, these groups became more aggressive after several years of low-level action, targeting troops, combat outposts, and forward operating bases with IEDs and rockets. As a significant threat, they endangered the villages and district centers that the United States considered crucial to the region’s stability and inhospitality to al-Qaeda.","Farther north, HIG also became more active in 2006. Pursuing Hekmatyar’s exclusionary political program, HIG fighters surrounded their fundamentalism with a modern, disciplined organization that resembled a Soviet-style political front. Although the group numbered only a few thousand active members, Hekmatyar exploited his position around the Pakistani city of Peshawar to increase his ranks and prepare for military operations in Nuristan, Kunar, and Nangarhar Provinces. These isolated provinces were full of capillary valleys populated by tribes that resented any intrusion by outsiders, especially by those who did not practice their fundamentalist version of Islam. HIG might not have enjoyed tremendous popularity in these regions, but they could exploit the ideals of pashtunwali, Wahhabism, and traditional sociopolitical norms better than any other intruding force could."]},{"figure":{"source":"/figures/m/map-figure-2-5.svg","caption":"The Insurgency","prefix":"MAP"}},{"interactive":{"source":"/iframe/ch2/OEF_VII_Ch_2_v2.html","caption":"2006 Key Insurgent Activity"}},"The region also contained numerous other militant groups with agendas in Afghanistan, Pakistan, or both. Two of the larger groups, based out of North Waziristan within the Federally Administered Tribal Areas, were the Islamic Movement of Uzbekistan and the Tehrik-i-Taliban Pakistan (TTP). The former had fought alongside the Afghan Taliban from the earliest days of the U.S. invasion, while the latter was a more recently organized coalition of different Pakistani Taliban groups that opposed not only the U.S. and ISAF presence but also the central government in Islamabad. Hezbe-e-Islami Khalis, an HIG splinter group that broke with Hekmatyar’s forces in the late 1970s, was located along the Afghanistan-Pakistan border in southern Nangarhar Province. Finally, the group known as Tehrik-i-Nezaf Shariat Muhammad was located north of the Pakistan city of Peshawar and inside the northern sections of the tribal areas. For the most part, these organizations did not conduct unilateral operations within Afghanistan, but instead provided support to the larger forces of the Taliban, the Haqqani Network, or HIG.","As the 2006 fighting season began, a new Taliban opposed the coalition and its Afghan partners. Their tactics were beginning to show greater sophistication, daring, and effectiveness. Taliban fighters now went to battle armed with rifles, machine guns, rocket-propelled grenades, mines, mortars, and rockets. They were led by command and control elements capable of discriminating targets and taking countermeasures against U.S. tactics. As an American intelligence officer recalled, by 2006, “You get a large enough [friendly] force and the enemy would disappear; get a small enough force and [the Taliban] would come out from behind every rock or hill top.” The Taliban also began importing methods used by insurgents in Iraq, employing ambushes, IEDs, and suicide attacks. They also benefited from training, financing, and logistical support from extremist groups such as the Haqqani Network.","The use of IEDs escalated in 2006 with nearly 1,300 attacks compared to 782 the year before. Although Taliban IEDs never reached the level of sophistication seen in Iraq, coalition troops learned to respect these deadly and difficult-to-detect bombs. A network of informants, sometimes children, gave advance warning to allow Taliban groups to mass fighters and arm preplaced IEDs, which often initiated or accompanied an ambush. Insurgents began using radio-controlled bombs in 2005–2006, which were more sophisticated than the booby traps with trip wires previously seen. A triggerman could now detonate a hidden bomb from several hundred meters away. When coalition forces began using radio-defeating technologies to protect mounted and dismounted forces, the insurgents went low-tech, substituting command-wire detonators for the radio-controlled variety.","Even as IEDs became more prolific, the tactic that had the most dramatic impact in Afghanistan was the suicide bomb. Unlike in Iraq, suicide attacks began slowly in Afghanistan. The first documented attack took place on 7 June 2003, when a single bomber killed four ISAF soldiers and wounded thirty-one bystanders in Kabul. In just a few years, however, suicide bombings had increased from 21 in 2005 to 141 in 2006, causing a reported 1,166 casualties. This new lethality was attributable primarily to foreign volunteers and technical and ideological training in Pakistan’s tribal area sanctuaries. Often recruited in Pakistani madrassas, bombers were glorified as martyrs, and their families usually received cash payments. On occasion, madrassa students in Pakistan were specifically groomed to participate in these operations, as peer pressure and ideological training made them reliable delivery systems.","The Taliban’s greatest advocate for these martyrdom operations was Mullah Dadullah “Lame” Akhund. In April 2007, a month before he was killed in a U.S. airstrike, Dadullah told a reporter, “We have sent thousands of Taliban suicide bombers to all Afghan cities for attacks on foreign troops and their Afghan puppets, and we will turn our motherland into the graveyard of the U.S. forces, and their families should wait for their dead bodies.” He and others in the Taliban’s leadership justified such tactics by arguing that the Taliban was fighting “for the freedom of Afghanistan from the enemies of Muslims.”","As evidenced by the rise of IEDs, suicide attacks, assassinations, and abductions, the superiority of Afghan and coalition security forces in conventional battles had forced insurgent groups to adopt asymmetric tactics aimed largely at Afghan security and civilian targets. Although the insurgency drew strength from elements within the Afghan community, its leadership, planning, training, funding, and equipment came from foreign-based networks. These networks remained largely beyond the reach of U.S. and ISAF forces in Afghanistan, being formed and controlled from bases in Pakistan.","These same extremists also were poised to attack Pakistan itself. Whether by design or neglect, the Pakistani military proved incapable of securing the border crossings, allowing insurgents to travel back and forth between the Pakistani safe havens and the Afghan battlefields almost at will. Despite growing complaints from American officials and Karzai, the Pakistani government of President Pervez Musharraf issued a steady stream of denials regarding the existence of a Taliban-driven insurgency emanating from Pakistan. The Pakistanis were playing a complicated diplomatic game by accepting billions in U.S. aid to eradicate al-Qaeda in connection with ENDURING FREEDOM counterterrorist operations, while offering political cover and financial support for other militant groups operating in Afghanistan. Pakistan’s true motivations concerned its territorial disputes with India. Its decades of support for radical Islamic governance in Afghanistan was intended to provide both fighters and a secure flank for future conflicts in Kashmir. The Pakistanis thus saw the transfer of authority to NATO ISAF as an opportunity to return to a more traditional security state. With the United States apparently divesting itself of ENDURING FREEDOM, much as it had turned away from Afghanistan after the 1989 Soviet withdrawal, Washington’s support seemed less important to securing Pakistan’s sovereignty.","Islamabad had been utilizing groups such as the Haqqani Network to maintain order among the tribes in the Federally Administered Tribal Areas since before the Soviet-Afghan War. In recent years, however, Pakistan’s evolving interests and loyalties proved unable to provide stability along the frontier, and it was now suffering from the threat of a “Talibanized belt” in the tribal areas. As the region became less stable, the Pakistani government decided that the traditional militia-based security force for the provinces, the Frontier Corps, was no longer sufficient to maintain security. Instead, it turned to the Pakistani Army to assert governmental authority in North and South Waziristan in June 2002.","As thousands of Pakistani soldiers deployed to the tribal areas, radical Islamist groups began calling for a jihad against the central government. Multiple operations by Pakistani military forces that had no counterterrorism or counterinsurgency training invariably failed to constrain the region’s tribal and religious forces while at the same time inflaming local sentiment and increasing popular discontent with the government. After several years of inconclusive results and growing dissent within the army, the Pakistani government agreed to a truce with militants in South Waziristan in early 2005. The government withdrew its troops from the tribal zone in exchange for assurances that the militant groups would not attack the Pakistani Army or give shelter to foreign terrorists. It did not, however, prevent radical Islamists from launching attacks against coalition troops in Afghanistan.","After signing the truce, the Pakistani military began operating in North Waziristan to pursue foreign militants fleeing the southern tribal areas. As in other parts of the tribal areas, soldiers met heavy resistance from groups motivated by both Islamist ideology and tribal autonomy. In an effort to restore order, the Haqqani family helped broker a peace between the government and tribal representatives in North Waziristan in early September 2006. Once again the government agreed to withdraw troops in exchange for a cessation of hostilities, although this time it also secured promises from militants not to conduct attacks in Afghanistan.","The coalition in Afghanistan suffered from Islamabad’s reluctance to continue employing tens of thousands of troops to quell the fiercely independent Pashtun tribes dominating affairs within the Federally Administered Tribal Areas. As General Eikenberry noted in November 2006, the number of attacks emanating from North Waziristan tripled after the peace agreement. The coalition had little means of blunting this influx as U.S. forces in theater began to contract into RC East in preparation for ISAF’s postelection and postconflict stabilization campaign. Policymakers remained blind to a brewing catastrophe as Eikenberry struggled to convince his political superiors that they needed to pressure Islamabad on sanctuaries.","Apart from destabilizing Pakistan and supporting the growing Afghan insurgency, radical Islamists in the tribal areas  also helped ensure the survival of al-Qaeda and Osama bin Laden’s continued leadership of Sunni extremist groups. Although al-Qaeda’s cohesion had been shattered during its withdrawal from Afghanistan, hampering its ability to oversee a global jihad, the group had enough support in Pakistan to survive. In fact, al-Qaeda soon expanded its sanctuary in South Asia by partnering with groups such as the Haqqani Network. This reliance on allies meshed with al-Qaeda’s original intent of representing the Islamic vanguard for the global jihad. Al-Qaeda did not need to engage directly in bombings to be dangerous: its value to the jihadist movement was its ability to link local groups with global sources and to merge regional conflicts with bin Laden’s vision of a worldwide struggle.","Even before the September 11th attacks, bin Laden had supported Pakistan’s conflict with India over the Kashmir region,  comparing it to the jihad in Afghanistan and inviting Pakistanis to join his movement. After the U.S. invasion toppled its Taliban allies, al-Qaeda used its ideological authority to promote increased confrontation with the Pakistani state. The objective was to destabilize the Pakistani government, distract U.S. attention from Afghanistan, and undermine Islamabad’s support for America’s war on terrorism in Southwest Asia. Al-Qaeda’s leaders followed their own lines of operation: providing religious justification to rally tribal support for antigovernment militants; leveraging military experience and organizational reach to train, advise, and fund militant groups; and mediating disputes and building coalitions within Pakistan to insulate bin Laden from external attack.","Though al-Qaeda remained active, bin Laden maintained a low profile, likely settling down in a reclusive Abbottabad compound on the southeastern edge of the Northwest Frontier Province of Pakistan in early 2006. His deputy, Ayman al-Zawahiri, regularly moved among safe houses in the tribal areas. Al-Qaeda’s entrenchment in Pakistan’s tribal areas secured the ideological foundation of the radical Islamist movement. At the same time, the Taliban’s reestablishment in Quetta and the growth of such groups as the Haqqani Network and HIG gave the Islamist militants a stable support base and access to thousands of potential recruits from local madrassas. With sufficient international financial backing, a capable training system, and a logistical network, nefarious groups had the motivation and means to wage a large-scale, multifaceted insurgency against the international coalition and the Karzai government. At a time when the war in Iraq was limiting the resources the United States could make available for its fight in Afghanistan, these militant groups looked to expand their campaign. Because Afghanistan’s new security forces were still being developed, its security and stability would depend on ISAF’s ability to quell an armed insurgency operating out of a Pakistani safe haven.",{"title":"The Return of the 10th Mountain Division","level":2},{"section":["With the Taliban and other anticoalition groups preparing to mount offensives in 2006, the United States rotated its maneuver forces for the coming year. Senior Defense officials had chosen the 10th Mountain Division to oversee the transition to ISAF lead in Afghanistan. Initial proposals called for the 10th Mountain to divide its 3d and 4th Brigade Combat Teams between RC East and RC South, where they would spend the year-long deployment conducting major operations. However, the Department of Defense settled on sending only a portion of the 4th Brigade Combat Team to RC South due to concerns about generating sufficient combat troops for Iraq, coupled with Abizaid’s and Eikenberry’s belief that sending an entire U.S. brigade to RC South could stall the NATO deployment. This meant that U.S. commanders in Afghanistan would not be able to mount simultaneous major operations in the two regional commands, and instead would need to shift forces between the two in order to weight the one most in need."]},{"figure":{"source":"/figures/v2/img_2-4.png","caption":"General Freakley, pictured as a Lieutenant General in 2011"}},"Advance units from the 10th Mountain Division began arriving in December 2005, with the majority of the troops touching ground in January and February. The full transition would be completed by April 2006. The 10th Mountain commander, Maj. Gen. Benjamin C. Freakley, brought his division headquarters and took over CJTF-76 from General Kamiya on 21 February at Bagram Air Base. Col. Michael S. Rose’s Combat Aviation Brigade, 10th Mountain Division (Task Force FALCON), and Col. Larry D. Wyche’s 10th Sustainment Brigade (Task Force MULESKINNER) also deployed to Bagram, where they could provide air and logistical support to CJTF-76.","Col. John W. “Mick” Nicholson Jr.’s 3d Brigade Combat Team (TF SPARTAN) was the 10th Mountain Division maneuver force in RC East.  Headquartered at Forward Operating Base SALERNO in Khost Province, Colonel Nicholson’s force included four combat battalions: Lt. Col. Christopher G. Cavoli’s 1st Battalion, 32d Infantry Regiment (Task Force CHOSIN); Lt. Col. Christopher R. Toner’s 2d Battalion, 87th Infantry Regiment (Task Force CATAMOUNT); Lt. Col. Joseph M. Fenty’s 3d Squadron, 71st Cavalry Regiment (Task Force TITANS); and Lt. Col. David A. Bushey’s 4th Battalion, 25th Field Artillery Regiment (Task Force WOLFPACK). Nicholson distributed the combat units across the regional command while retaining his field artillery at Salerno. Filling out Nicholson’s combat team were Lt. Col. Richard G. Kaiser’s Special Troops Battalion (Task Force VANGUARD) and Lt. Col. Vernon L. Baker’s 710th Support Battalion (Task Force SUPPORT). For the first few months of its deployment, TF SPARTAN also included 1st Battalion, 3d Marines, under the command of Lt. Col. James “Chip” Bierman, which was nearing the end of its seven-month rotation.","The impending ISAF transition in southern Afghanistan, and the U.S. decision not to deploy all of 10th Mountain’s 4th Brigade Combat Team, significantly limited planned operations in RC South. In evaluating the impact of that decision, CENTCOM planners noted that “CFC-A’s current analysis does not indicate the need for [4th Brigade Combat Team, 10th Mountain] as long as Canadian and Great Britain . . . forces arrive as currently planned [no later than] April, 2006.” However, CENTCOM also estimated that if British “forces do not arrive in adequate numbers by the end of March 2006; there will likely be a maneuver force capability gap from April to May.” The absence of 10th Mountain’s 4th Brigade Combat Team would therefore create deficiencies only if NATO deployments were delayed.","Canadian Brig. Gen. David Fraser, who took over RC South from Colonel Owens’s TF BAYONET in mid-February 2006, would oversee the incoming ISAF units. His new command headquarters, Combined Task Force AEGIS, initially fell under CJTF-76’s command before the formal turnover to ISAF. At the time, Fraser’s command consisted of a Canadian Task Force (Task Force ORION) under the command of Col. Ian Hope built around the newly arrived 1st Battalion, Princess Patricia’s Canadian Light Infantry and the Canadian-led Provincial Reconstruction Team in Kandahar City.","Problems emerged with the projected RC South deployment soon afterward because, unlike earlier ISAF efforts in northern and western Afghanistan, sending troops into a potentially dangerous region sparked vigorous political discussions within some participating NATO nations. The Dutch contingent, for example, only received approval to deploy following an extensive parliamentary debate that ended in February 2006, which meant it could not take over responsibility for Uruzgan Province until August. The debate took place because the Dutch government deliberately chose a province where Taliban fighters were active rather than settle for reconstruction work in quieter northern Afghanistan. This delay also set back the arrival of British forces until April because London wanted firm commitments from the other NATO members before sending its own troops.","The combined delays produced the worst-case capability gap in RC South, prompting CENTCOM to fill the void with a composite organization siphoned from Freakley’s newly formed 4th Brigade Combat Team based at Fort Polk, Louisiana. That unit, built around Lt. Col. Frank D. Sturek’s 2d Battalion, 4th Infantry Regiment (Task Force WARRIOR), contained three more companies in addition to its three organic rifle companies, antitank company, and headquarters company to enable the unit to operate as an independent Task Force. In March, General Freakley sent Sturek’s Task Force to Zabul Province in RC South, where it covered ISAF forces filtering into the region.","Although the entire 4th Brigade did not deploy, Freakley received Col. A. Kent Schweikert, the 4th Brigade commander, along with parts of his staff and 200 soldiers from Lt. Col. Michael C. Howitz’s brigade support battalion (Task Force STRENGTH). Freakley dispatched Schweikert to Kandahar to perform as U.S. National Command Element, U.S. National Support Element, and General Fraser’s deputy for Combined TF AEGIS. As head of the U.S. National Command and Support Elements, Schweikert provided logistical, intelligence, and communications support to American (but not ISAF) forces operating in RC South. With the Americans and Canadians comprising the core of his multinational brigade-sized force, Fraser’s command slowly grew as more NATO forces arrived in anticipation of the RC South transfer of responsibility to ISAF. The rotation for 10th Mountain culminated in March 2006, at which point General Freakley’s command now consisted of roughly 20,000 troops, with the majority of U.S. forces located in RC East.","The campaign plan for the new CJTF-76 built on CFC-A’s emphasis on security, governance, and reconstruction as well as ISAF’s goal to “extend and deepen the areas in which the [Afghan Government] and [international agencies and nongovernmental organizations] can safely operate in the interests of the people of Afghanistan.” Freakley thought that Eikenberry’s guidelines and objectives permitted CJTF-76 to exercise “pretty much free rein with constructing our campaign plan.” His staff took this opportunity to develop a campaign to extend the Afghan government’s reach into isolated regions in northeast RC East, block insurgent infiltration routes in the central and southern portions of RC East, and facilitate NATO forces as they moved into RC South.","CJTF-76 sought to achieve these objectives by simultaneously conducting “full spectrum operations” and integrating “joint, inter-agency and multinational forces partnered with the Afghans [in order to] establish security and deter the re-emergence of terrorism to enhance the sovereignty of Afghanistan.” These goals would be realized by implementing a four-step “clear, hold, build, and engage” approach. In simpler terms, coalition troops conducted combat operations against enemy fighters, reducing their strength to the point at which Afghan troops and police could maintain a permanent presence in the designated area of operations. At that point, CJTF-76 would initiate reconstruction projects designed to better the life of local inhabitants while supporting Afghan government and coalition efforts to develop ties with the local communities. The CJTF-76 approach emphasizing “build” and “engage” was a more nuanced variation of the “clear, hold, and consolidate” method found in ${Counterinsurgency Operations}{italic} (Department of the Army Field Manual–Interim 3–07.22).","For CJTF-76’s major operations, the four phases were “initially sequential and [began] with kinetic operations to kill or capture insurgents in a named area of operation.” A further technique to clear an area was an amnesty program that sought to align insurgents behind the Afghan government. Once the clear phase separated the enemy from the population, U.S. and Afghan security forces would maintain or hold that separation by building combat outposts, overseeing the development and deployment of local security forces, and establishing government agencies. The third phase, build, consisted of transforming “the physical and human terrain” through reconstruction and development projects, creating stable local security forces, and encouraging relationships between the population and their governmental representatives. The final phase, engage, was an overarching effort that included meetings with Afghan civil and military leaders and regular civilians “to help them develop the sense of responsibility they would need to eliminate insurgent activity in sanctuaries, among the population, or in transit through the border region.” Although initially sequential, implementation eventually would shift to all four phases being performed in conjunction as “concurrent and ongoing efforts.”","The clear, hold, build, and engage model not only translated operational objectives into tactical approaches but also aligned CJTF-76’s efforts with General Eikenberry’s desire to improve access to communities in RC East. Eikenberry summarized the problem: “Where the road ends, the Taliban begins.” He and Ambassador Neumann had made road construction a centerpiece of their efforts in 2005. Neumann sought additional congressional funding while Eikenberry pushed his military forces to improve the Afghan government’s access to isolated areas and deny that access to insurgents. As NATO prepared to move into RC South, TF SPARTAN would spread throughout RC East, often moving into regions that had seen only limited coalition activity in the past.","In addition to U.S. conventional forces, the 2006 campaign relied heavily on SOF. CJSOTF-Afghanistan now fell under the operational control of Combined Forces Special Operations Component Command–Afghanistan and the tactical control of CFC-A, meaning that CFC-A could only assign missions to SOF and not task-organize or relocate them in theater. The new SOF Task Force commander, Col. Edward M. Reeder Jr., returned to Afghanistan in February 2006, having twice served in the country as a battalion commander in 3d Special Forces Group. His new command consisted of twenty-five ODAs, six civil affairs teams, six psychological operations teams, and SOF units from five partnering nations. His mandate was to develop the ANA, particularly the Afghan 205th and 207th Corps. With Afghanistan rotations normalized between the 3d and 7th Special Forces Groups, 1st Special Forces Regiment, SOF could now be integrated more efficiently into CJTF-76’s upcoming operations.","CJTF-76 planned to conduct four major operations in 2006, two of which specifically targeted RC East. The first, Operation MOUNTAIN LION—the second operation in Afghanistan with that name—would take advantage of a Marine Corps battalion that stayed in country when Kamiya’s forces departed. Freakley wanted to use these available combat forces to push into the northeastern provinces of Nuristan, Kunar, and Laghman, all of which were dominated by isolated river valleys whose resident communities had little to no contact with the central government, much less the outside world. The plan was for U.S. and Afghan troops to move gradually into these regions, especially the dangerous Pech River Valley in Kunar Province and border district of Kamdesh in southern Nuristan Province. In addition, the CJTF-76 commander sought to improve security forces and developmental projects in Nangarhar Province. Unlike previous operations where coalition forces stayed in a region for a brief time, CJTF-76 units would establish outposts and remain for an extended period, overseeing development projects and supporting Provincial Reconstruction Team efforts.","Operation MOUNTAIN LION had two purposes. First, Freakley wanted to connect the Afghan government to areas where it had little to no influence. Second, the operation was to “employ our strengths against the enemy weaknesses” by targeting HIG forces that constituted the primary threat in the region. Though Hekmatyar had a long history of radicalism and armed opposition to any Kabul government that did not reflect his Islamist views, his organization remained a consortium of disparate groups held together more by personality and rhetoric than by core principles. The combination of Hekmatyar’s brutal reputation and vocal opposition to the Kabul government, his known ties to al-Qaeda, and his group’s relative weakness in comparison to the Taliban or Haqqani Network made HIG an appealing target.","CJTF-76 would conduct the second operation, MOUNTAIN THRUST, in RC South from mid-May until the transfer of authority to ISAF on 31 July. Freakley intended to reduce insurgent capabilities long enough to ensure a smooth transition to NATO ISAF. NATO movements likely would be met with lethal attacks. To counter this possibility, MOUNTAIN THRUST would send patrols into isolated areas of Zabul, Uruzgan, and Kandahar Provinces. The operation was designed to “inflict a defeat upon the Taliban, sufficient to force them on the defensive for the time being, and to temporarily instill a period of calm in the southern provinces at a time of year when the Taliban were usually at their strongest.” The objective was not to eliminate opposition groups in RC South but to give international forces time to establish positions within the region and begin their own operations.","Once NATO forces established themselves in RC South, TF SPARTAN would shift forces back to RC East for an offensive named Operation MOUNTAIN FURY. As units in northeast Afghanistan continued to occupy new outposts, the 10th Mountain’s remaining forces would keep the insurgency off balance. Anticipated for late summer or early fall, MOUNTAIN FURY targeted the Haqqani Network by securing the border in “Paktika and Khost Provinces and expanding internally in Paktiya and Gardez [sic] Provinces.” The operation would also increase the ANA’s footprint in the region as elements from the 203d Corps moved to positions from which they could protect approaches to Kabul. Freakley intended the operation to “defeat [Haqqani-backed insurgents], help the Afghan army with that deployment in that area, and reinforce [local, district, and provincial] governments.”","The fourth major effort for TF SPARTAN, initially called Operation MOUNTAIN VICTORY, was planned to begin when the fall weather started to hinder insurgent operations and continue until the anticipated transfer of command and control of CJTF-76 to the 82d Airborne Division. The operation extended northeast from Paktiya Province in central RC East to Nuristan Province. Freakley designed MOUNTAIN VICTORY to ensure “insurgent forces and terrorist networks are defeated in the interior portions of RC-East” so as to consolidate gains made during MOUNTAIN LION and MOUNTAIN FURY. TF SPARTAN sought to assess the enemy’s capabilities throughout the operation so as to advise their successors on how best to secure the gains made in 2006. Freakley would use this intelligence to shift units into new areas to continue pushing the enemy away from the population. Of particular concern was maintaining access to roads cleared or built over the year. All of this had the dual purpose of supporting ISAF and setting conditions for a successful February 2007 handover with the 82d Airborne Division.",{"figure":{"source":"/figures/m/map-figure-2-8.svg","caption":"Area of Operation MOUNTAIN LION","prefix":"MAP"}},{"title":"Operation MOUNTAIN LION (April–June 2006)","level":2},{"section":["In his preparation for Operation MOUNTAIN LION, Freakley took an important step in improving relations between CJTF-76 and the Afghans. During a planning meeting, the general asked Abdul Rahim Wardak, the Afghanistan minister of defense, for permission to execute the operation. It was the first time an American commander sought such permission, and it marked an important turning point in American-Afghan relations. Deeply appreciative of the request, Wardak gave his approval, and the operation began on 11 April. In addition to TF SPARTAN, participating units included the 3d Brigade of the Afghan Army’s 203d Corps and the 1st Battalion, 3d Marines.","Preparations for Operation MOUNTAIN LION began in March 2006. Initial movements called for the insertion of a reconnaissance and surveillance unit in Asadabad where it could monitor Kunar and Nuristan. Next, Colonel Fenty’s TF TITANS would move north of Asadabad to secure the Chawkay Valley in central Kunar Province, from which TF SPARTAN would mount its movement into the two northeastern provinces. The main part of the mission involved soldiers from Colonel Cavoli’s TF CHOSIN and Fenty’s squadron air-assaulting into previously isolated valleys to establish company-sized operating bases and platoon-sized combat outposts. The marines were vital to the operation, as Colonel Nicholson needed additional combat power to support his two battalions. They had been responsible for the entire operational area now being divided between the two U.S. Army battalions.","By nearly doubling the forces in the region, Nicholson’s men could reach isolated areas that had not seen foreign troops since the 1980s. In one remote village, an elder mistook the soldiers for Russians and inquired as to when they had changed their uniforms. An Afghan interpreter explained who the soldiers were and reassured the elder that the Americans were better behaved than the Soviets, which comforted the old man considerably. The arrival of the Americans had a marked effect on insurgent groups. The insurgents had become accustomed to U.S. forces conducting operations for only a few days and then withdrawing, and so they were surprised by the Americans’ new tactic of setting up permanent positions. They eventually withdrew to assess the new situation and determine how to react.","The movement into the Korangal and Shoryak River Valleys of Kunar and Nuristan Provinces also included a large SOF presence. The Special Operations Task Force tasked its Naval Special Warfare assets, the SEALs, and coalition SOF to conduct special reconnaissance and direct action missions targeting mid-level HIG leadership before conventional forces began clearing operations. Colonel Reeder followed these initial forays with orders for six ODAs from Special Operations Task Force 202 to conduct partnered operations with the Afghan 201st and 203d Corps. Operation MOUNTAIN LION lasted roughly a month, ending in mid-May, and did not force any major engagements with enemy combatants, who evidently were trying to determine how to adjust to losing their freedom of movement. Intelligence analysts continued to find it difficult to provide maneuver commanders with actionable information.","The American push into the valleys did not come without tragedy. On 5 May, during a nighttime extraction of two observation teams from mountainside positions, a CH–47 Chinook helicopter struck a tree and crashed. The TF TITANS commander, Colonel Fenty, was riding in the helicopter’s jump seat. He and nine other soldiers died when the aircraft fell several hundred feet to the rocks below. Their deaths were the first fatalities for TF SPARTAN and highlighted the difficulties faced by U.S. Army aviators operating in Afghanistan’s rugged mountain terrain.","One of TF SPARTAN’s most ambitious moves came on 7 May, when it established an outpost in the middle of the Korangal Valley. The Korangalis had a long tradition of hostility toward anyone they viewed as an outsider, including Afghans from other valleys. They also practiced Wahhabism, which was brought into their valley in the 1980s by foreign mujahideen fighters sheltering from Soviet attacks. When the ANA chief of staff, General Bismillah Khan Mohammadi, raised the Afghan national flag over the Korangal outpost, he signaled the beginning of a government effort to exert its authority over the traditionally isolated region. (The Korangalis, for their part, seemed indifferent to the arrival of the Afghan government.) This flag-raising accomplished Freakley’s objective for the operation, which was “to go where we hadn’t been before with strength, establish a presence with combat outposts and partner with the Afghan military, and stay there . . . [to] do reconstruction.” The soldiers of TF SPARTAN were ready to begin their counterinsurgency efforts in the northern provinces of RC East."]}],"chapter 3":[{"title":"The Conflict Intensifies"},{"section":["The handover to NATO ISAF presented unexpected challenges to the coalition’s key leaders, including Lt. Gen. Karl W. Eikenberry and British Lt. Gen. David J. Richards, who assumed command of ISAF on 4 May 2006. Despite different geography and enemy formations, the regions coming under ISAF control presented similar problems for coalition forces. Whether facing HIG or the Taliban, the United States and its ISAF allies had to defeat the enemy and convince local populations to accept the authority of Afghanistan’s central government. Whether fighting in the mountains or over open terrain, they had to locate insurgents, apply firepower, stay supplied, and partner with the ANSF. The central differences between RC East and RC South were the arrival, focus, and capabilities of the forces executing the main effort. Whereas RC East was a unilateral effort, RC South was coalition warfare, with American units operating alongside British, Canadian, ANSF, and Dutch forces.","By late 2005, NATO finalized Supreme Allied Commander Europe’s Operations Plan 10302 to implement the final transitions of the Afghan regional commands. The plan articulated a clear political and military end state, as well as a basic strategy for how to achieve them. According to 10302, the alliance would follow the transfer of the regional commands to NATO ISAF control with a period of “stabilization” in which ISAF forces would “assist the Afghan government to extend and exercise its authority and influence” until enough “stability is achieved to allow the handover of ISAF military tasks to Afghan authorities.” The operations plan specified that “Provincial Reconstruction Teams . . . will be at the leading edge of NATO’s effort” and “military support to them is one of NATO’s major contributions to the success of ISAF in Afghanistan.” Although “recognizing the different national characters of PRTs [Provincial Reconstruction Teams],” the plan optimistically stated that “increasing convergence between the activities of all PRTs, with synchronized movement towards a set of common objectives, will have the desired strategic impact.”1 How to accomplish this synchronization was left to Richards to work out with the national contingents under his command."]},{"title":"NATO ISAF in RC South","level":2},{"section":["Responsibility for overseeing the transfer of RC South and RC East fell to Richards. As commander of NATO’s Allied Rapid Reaction Corps, a high-readiness force that could deploy within a week’s time to address emerging crises, Richards faced a daunting challenge. His most pressing concern was the fact that ISAF did not have a permanent headquarters. Richards solved the problem by bringing the Allied Rapid Reaction Corps headquarters with him, though he struggled to get the unit prepared for deployment. Employing the Allied Rapid Reaction Corps staff proved only a temporary solution, however, as it did not have the mandate or personnel to deploy for long periods or exercise control over international forces. Ultimately, ISAF solved the problem by creating a permanent headquarters in Kabul but, much to Richards’ dismay, not until early 2007.","Richards occupied a unique position as the ISAF commander during this period. He operated within the NATO command chain, reporting  to the head of Joint Forces Command–Brunssum, German General Gerhard Beck, in the Netherlands. Above Beck was the American General James L. Jones, who served as the Supreme Allied Commander Europe. Richards did not occupy a position within his national command chain, but exerted control over British soldiers indirectly via Canadian Brig. Gen. David Fraser’s Combined TF AEGIS. While preparing for his deployment, Richards struggled to convince officials in London and Brussels of the complexity of the task ahead:",{"list":["I was a British General about to command a major NATO campaign but my own country was not prepared to give me a helicopter or an aircraft to fly around a country that was half the size of Europe so that I could properly exercise command. More important than that, I had no proper reserve force of any kind. No military commander, even at the platoon or company level, will go on operations without a reserve. I had none and NATO and my own country appeared content with this."]},"Richards never received dedicated air transportation, instead having to work with what he could secure in theater. As for a reserve force, he eventually received a light infantry company from Portugal that would serve as his only reserve unit. Unfortunately, Richards would not be the last ISAF commander frustrated with the level of support he received from NATO."]},{"figure":{"source":"/figures/v2/img_3-1.png","caption":"Defense Secretary Gates & ISAF commander General Richards"}},"With Operations Plan 10302 as their guide, Richards and his staff developed a three-pronged operational approach for Afghanistan. Richards found that the plan contained “lots of fine intent, phasing, and all that, but it is not an operational plan for ground forces in the provinces of Afghanistan.” He soon discovered “big gaps between the ground needs and the higher headquarters’ plan.” Richards therefore used higher headquarters’ guidelines to develop an intent that focused on three areas. The first involved identifying highly populated regions where the majority of security, development, and governance efforts would take place. Termed Afghan Development Zones and modeled after the Regional Development Zones that Lt. Gen. David W. Barno sought to implement in 2004, they were to expand the central government’s influence by widening the spheres of control and progress found around reconstruction team locations. Once security and development improved within a zone, the coalition would tie that progress to the Afghan central government and publicize it. The second element of Richards’ approach was the creation of a Policy Action Group in Kabul with President Hamid Karzai as the head and key leaders of the Afghan government and the international community as its members. The Policy Action Group would monitor the development zones, direct the distribution of resources, and provide unity of effort for Afghan and ISAF endeavors. The final feature of Richards’ approach looked to areas outside of the Afghan Development Zones. Rejecting the American practice of targeting insurgents, Richards wanted operations outside these zones to persuade local leaders to align with the central government. Where necessary, his forces would engage in combat operations, but the emphasis would be on shaping the operational environment in preparation for a counterinsurgency-driven clear, hold, and build campaign.","Although Richards based his approach on a classic understanding of counterinsurgency operations, he incorporated a degree of  controversy. First and foremost, his plan to mass forces in Afghan Development Zones was complicated by the fact that several NATO members prohibited their troops from engaging in combat operations. Massing forces anywhere in an economy-of-force effort led to a second problem: the need to forgo an operational reserve. Without a dedicated theater-level reserve, Richards could not respond to changing circumstances on the ground, especially if he honored the various national caveats within his command. With slim chance of having those caveats rescinded, Richards would need either additional forces or a different plan to succeed in RC South.","The security situation in RC South further constrained Richards’ options. In January, a suicide attacker in Kandahar City killed senior Canadian diplomat Glyn R. Berry, the director of the Kandahar Provincial Reconstruction Team. The Taliban had infiltrated into Zabul and Uruzgan Provinces, intending to bring pressure against Kandahar City from the north. At the same time, Taliban infiltration from Helmand into Kandahar helped reactivate long dormant mujahideen networks in the Arghandab River districts west of Kandahar City. Many Taliban leaders hailed from these districts, so local tribal sympathy, if not active support, was easily obtained. At the time, coalition forces lacked any presence in the region capable of countering Taliban influence. U.S. Special Forces, trying to stave off Taliban encroachment into areas previously considered secure, executed night raids at the expense of rural development and local security. For its part, TF BAYONET was absorbed in maintaining freedom of movement along the Ring Road, leaving it without the combat power to police the provincial boundaries, interdict the flow of Taliban from the north, or halt insurgent traffic between Helmand and Kandahar.","The Arrival of NATO Forces Col. Kevin C. Owens’ TF BAYONET (173d Airborne Brigade) departed Afghanistan in March as an assortment of NATO battle groups rotated into RC South. Before the ISAF transfer of authority on 31 July, the regional command operated under the authority of Maj. Gen. Benjamin C. Freakley’s CJTF-76. The departure of Owens’ brigade and the reduced number of 4th Brigade Combat Team soldiers deployed to Afghanistan limited Freakley’s ability to use U.S. units to provide space and time for incoming NATO forces in RC South. To set the conditions for their arrival, Freakley directed NATO maneuver forces already in the region to operate under the command of U.S. forces in the months leading up to the ISAF transition. Already on the ground were the Canadians, who had staffed the Provincial Reconstruction Team in Kandahar the previous August. In February, General Fraser’s headquarters, Combined TF AEGIS, became Multinational Brigade South under CJTF-76. Freakley’s decision to assign Col. A. Kent Schweikert as Fraser’s deputy at Combined TF AEGIS placed a liaison in the brigade with enough rank to settle problems that arose between the Canadians and the U.S. command. Schweikert and his staff “focused on making sure the American contribution to the combat effort was straight [i.e., with clear and understood command lines], and did all [they] could to ease the bumps to not only the Canadian multinational brigade coming in, but later [with] the arrival and integration of ISAF into the effort.” Despite the best efforts of Fraser and Schweikert, synchronization could not overcome the shortage in effective combat power caused by the staggered arrival times of incoming NATO forces.","Maneuver forces tasked to resource NATO ISAF’s first year in RC South began arriving in February 2006 with Col. Ian Hope’s TF ORION in Kandahar City. Colonel Sturek’s TF WARRIOR followed in March by moving into Zabul Province until the Romanians’ Task Force CALUGENARI could take over in July. After the Romanians arrived, TF WARRIOR served as the command’s quick reaction force until it redeployed to Fort Drum in November. Britain’s Task Force HELMAND assumed responsibility for Helmand Province in April 2006, while Uruzgan remained a U.S. joint special operations area until the arrival of the Dutch Task Force URUZGAN in August. On 29 April, Lt. Col. Steven Gilbert’s 1st Battalion, 102d Infantry (Connecticut Army National Guard), conducted a transfer of authority with the 3d Battalion, 141st Infantry, at Forward Operating Base GHAZNI.","The fundamentally disjointed nature of NATO’s contingency planning and command structure meant that each national battle group arrived with its own ideas about what it was going to do in its respective province. Some, like the Dutch, focused on promoting “stability and security by increasing the support of the local population for the Afghan authorities and eroding the support for the Taliban and related groups.” Although this approach sounded something akin to counterinsurgency, the Dutch government omitted that word from their mission objectives and refused to admit that their troops were involved in a “combat mission.” In a similar vein, the British government did not anticipate that its troops would be engaged in intensive combat. As described by British Lt. Col. Stuart Tootal, the commander of 3d Battalion, Parachute Regiment, “the mission was conceived as a peace support operation. Any use of force was seen as a last resort and actually having to hunt down the Taliban was not part of the mission. Instead our intended role was to provide security to protect the development and reconstruction efforts of the [Provincial Reconstruction Team] that would deploy with the task force.”","Because the British categorized their missions as peacekeeping rather than counterinsurgency, Tootal’s unit deployed without indirect fire assets, armored transport, or attack aviation. The British paratroopers employed unarmored vehicles so as to move easily about the population without conveying an aggressive military presence. The British also staggered Tootal’s deployment, sending one parachute company at a time so as not to overstress their limited strategic movement assets. Consequently, while the first British soldiers began arriving in Helmand in April, the full battle group was not in place until July.","Incoming ISAF units rarely replaced American units with anything close to equal numbers, let alone firepower. With the end of the Cold War, most NATO countries had significantly reduced their militaries, and many of the remaining units were still serving in the Balkans. When TF ORION assumed responsibility for Kandahar in February 2006, its 850 troops took on a mission that previously involved many more soldiers. In a more dramatic example, the Romanian task force replacing Sturek’s TF WARRIOR had only a third of the combat power of its predecessor. As Colonel Schweikert observed, “you don’t just replace an enabled, fully loaded battalion . . . with what is really less than a battalion [I]t just wasn’t going to be the same and they didn’t have the capability to go into some of the areas [we did] because they just didn’t [have the numbers].” CJTF-76 had to assign an American company from 1st Battalion, 4th Infantry Regiment, to provide additional support to the Romanians.","Finally, because the British initially approached operations in RC South with a nonlethal focus, TF HELMAND contained only about 650 combat troops, with the remaining four-fifths of its 3,300 soldiers serving support functions. This balance severely limited the task force’s ability to contribute to combat operations while, at the same time, it simplified the Taliban’s goal of mustering sufficient resources to challenge NATO. As ISAF assumed command of RC South, it was evident that its units had differing levels of combat effectiveness, support capabilities, or rules of engagement, making it difficult to achieve unity of effort throughout the regional command.","${Operation MOUNTAIN THRUST (May–July 2006)}{bold}",{"figure":{"source":"/figures/m/map-figure-3-2.svg","caption":"Operation MOUNTAIN THRUST","prefix":"MAP"}},{"figure":{"source":"/figures/v2/img_3-2.png","caption":"Romanian troops"}},"As Operation MOUNTAIN LION drew to a close, CJTF-76 and TF Spartan launched Operation MOUNTAIN THRUST to transition RC South to NATO ISAF control. The absence of Freakley’s entire 4th Brigade Combat Team compounded problems created by the piecemeal arrival of NATO forces into RC South and different understandings of the operations in which those forces would engage. The CJTF–76 commander “advocated for 4th Brigade to come to take the pressure off of NATO, to let 4th Brigade come and do [MOUNTAIN THRUST], let NATO get there, get their feet on the ground, understand the situation, start operating, and then send the 4th Brigade home,” but to no avail.","Without requisite support for a smooth transfer, the responsibility for executing MOUNTAIN THRUST devolved to TF AEGIS and the assorted coalition battle groups available in RC South. Changing units presented a problem because the British and Canadians did not anticipate taking part in a major U.S. operation, even if only in a supporting role. Trying to align the various coalition forces operating in RC South in the early summer of 2006 would reveal fundamental flaws within the NATO ISAF mission.","Operation MOUNTAIN THRUST proved nonstandard in that CJTF-76 utilized SOF as the decisive effort and defined success as SOF’s  ability to partner effectively with reliable ANA forces. Special Operations Task Force 73, based out of Kandahar, and Special Operations Task Force 202, based out of Bagram, began operations in May 2006 with a straightforward task: “ANA 205th Corps, combat advised by CJSOTF-A [CJSOTF-Afghanistan], conducts combat operations to defeat Taliban extremists in NE [northeast] Helmand/Uruzgan and deny them sanctuary in this area.” The ANSF were to remain in the area while a Dutch battalion and reconstruction team moved into Uruzgan Province and Romanians took over operations in Zabul Province.","The plan called for coalition forces to establish positions in Qalat, Kandahar City, and Lashkar Gah by mid-May. From there they would push north to “reduce the enemies [sic] ability to either reinforce or exfiltrate from key sanctuaries in [northeast] Helmond [sic] and Uruzgan.” This force array would form a protective belt around Uruzgan Province, allowing Sturek’s TF WARRIOR to conduct aggressive operations in Zabul and Canada’s TF ORION to move into northern Kandahar. Freakley wanted to use British troops for operations in northern Helmand as well, but their staggered deployment meant that too few were available for this mission.","On paper, Freakley was able to commit more than 10,000 troops to MOUNTAIN THRUST (3,300 British, 2,200 Canadians, 2,300 Americans from conventional and special operations units, and 3,500 Afghans) but only a fraction of those were combat forces. To provide additional combat power for the operation, Freakley moved elements of Toner’s TF CATAMOUNT, augmented by Troop A, 3d Squadron, 71st Cavalry Regiment, into RC South. Colonel Toner’s forces conducted a 750-kilometer road march from Paktika to Kandahar Airfield in early May before moving into northern Helmand for operations in the Baghran District. Significantly, CJTF-76 placed TF CATAMOUNT under the tactical control of the CJSOTF, while TF WARRIOR would be under the operational control of the same SOF headquarters.","Early reports from MOUNTAIN THRUST indicated far stiffer resistance than anticipated. RC South contained only 10 percent of the total Afghan population, but Kandahar and Uruzgan were the birthplaces of the Taliban movement and harbored numerous committed fighters. Helmand was also home to large numbers of Taliban supporters but, more importantly, accounted for more than 85 percent of all opium and heroin production in Afghanistan, which the Taliban levied to fund their insurgency. As the Taliban’s spiritual and financial base, RC South would not surrender to NATO willingly.","As a result, the Taliban presented a stauncher defense against the spring operation than in previous years. On 17 May, Canadian troops fought a sustained battle against Taliban fighters who stayed in defensive fighting positions until killed in close combat or by U.S. AH–64 Apache helicopters. Over the following three weeks, Colonel Hope and his soldiers “were engaging, on some days, four or five platoons’ worth of enemy in different locations in these districts . . . there are hundreds of Taliban fighters here.” ISAF troops found enemy bases with logistical support for insurgent forces, including medical services and a cottage industry of IED and suicide vest production. Unable to prevail over the Canadians, insurgents focused on inflicting casualties on Afghan police units in the area.","Conventional U.S. forces fought numerous platoon- and company-sized engagements as the operation’s supporting effort. Soldiers from Toner’s TF CATAMOUNT met stiff opposition in the Baghran Valley in northeast Helmand. A vital avenue used by the enemy to move south from staging areas in Uruzgan Province into the northern portions of Helmand and Kandahar, the valley had been the launching point of several large-scale ambushes to disrupt the American movements. Even though Toner’s men repulsed attacks, conducted cordon-and-search operations, held village shuras (local consultative councils or assemblies) to connect with the local population, and delivered humanitarian assistance, the situation remained tenuous throughout June and July.","Colonel Sturek’s TF WARRIOR faced similar opposition in Zabul Province. He utilized one of his rifle platoons, an Afghan Army platoon, and a Special Forces ODA, supported by six artillery pieces, to establish a base in the Chalekor Valley in the Daychopan District in northern Zabul. Like the Baghran Valley, Chalekor provided an infiltration route into Uruzgan. If TF WARRIOR blocked both valleys, then the Taliban would be hard-pressed to bring reinforcements into Uruzgan. The Chalekor Valley contained members of Mullah Mohammed Omar’s tribe, and as Sturek recalled, “We didn’t find many friendly people when we moved into the area.” In a meeting with local villagers, elders asked U.S. and Afghan governmental forces to withdraw from the region. According to Sturek, “When it was understood that we were not leaving the villagers started to leave.” Anticipating an enemy attack, Sturek sought to secure air and artillery support, but he “couldn’t convince anybody it was really happening.” Only after his men began taking enemy fire did he receive the requested support.","The special operations contribution to MOUNTAIN THRUST proved to be a truly international effort. As supporting efforts, Romanian and U.S. SOF units partnered with a kandak from the 207th ANA Corps to disrupt Taliban elements on the eastern border of Farah Province. The main effort required coalition and U.S. special operations personnel to partner with 205th ANA Corps kandaks in order to shape operations in Kandahar, Helmand, and Uruzgan Provinces. Combined U.S., Czech SOF, and ANA units executed combat reconnaissance in the Chahar Chinah and Khod Valleys of northern Kandahar Province to identify and target enemy forces. At the same time, Dutch and U.S. special operations units partnered with the ANA to reinforce U.S. infantry units conducting air assaults in southern Uruzgan and northern Helmand Provinces to block entrance into the Baghran Valley. Finally, U.S. Special Operations and ANA air-assaulted into the southern portion of the valley in conjunction with Canadian SOF reconnaissance patrols. With the assistance of kandaks from the 205th Corps, the coalition’s special operations detachments were able to push into the Khod, Baghran, and Chore Mandeh Valleys. These forces conducted clearing operations “as part of MOUNTAIN THRUST [which] enabled PRTs [Provincial Reconstruction Teams] and engineers to initiate selected reconstruction projects.” Through the efforts of combined special operations units, the operation ended in late July, with RC South deemed secure enough to continue transitioning to ISAF control.","Despite unexpected difficulties, Operation MOUNTAIN THRUST accomplished its goal of creating time and space for the United States to transfer RC South to NATO ISAF on 31 July. The main problem was achieving unity of effort among the various coalition elements. According to Freakley, “We were operating on a seam between Operation ENDURING FREEDOM rules and procedures, and then ISAF rules in the south.” During the operation, TF AEGIS had to coordinate the decisive ANA and SOF effort taking place in and around Uruzgan under CJSOTF-Afghanistan while managing American maneuver task forces in Zabul and Helmand, along with Canadian units in Kandahar. For their part, the Canadians had to oversee the staged insertion of British troops into Helmand over the course of MOUNTAIN THRUST, and provide road support for the Dutch task force moving into Uruzgan. The organized resistance that all of these units faced showed that the insurgency presented a far greater threat than previously anticipated. The Taliban, in fact, was mustering a major effort to defend its homeland from NATO forces.","With a rejuvenated Taliban arrayed against an untested international military coalition consisting mainly of inexperienced combatants, the situation in RC South in 2006 marked the beginning of a new phase in the Afghan war. Unlike in previous encounters, the enemy now routinely stood to fight rather than flee to nearby sanctuaries after minimal contact. In numerous platoon- and company-sized engagements, coalition units faced insurgent groups numbering in the hundreds that displayed levels of tenacity, training, and staying power previously unseen during the war. Though coalition firepower prevailed in most cases, insurgents waged a steady propaganda campaign to counter their field losses. They maintained ties to the local population, threatening any who aided the coalition or the Karzai government, and brought in reinforcements to keep the pressure on NATO ISAF.","${The Taliban Seizes the Initiative in Helmand}{bold}","The most significant setback for NATO occurred during summer 2006 in Helmand Province. Like the Canadians, the British government deployed troops to Afghanistan with a view of the mission that did not account for all variables. In looking at the upcoming deployment, British Defense Minister John Reid announced that the British “would not be aggressors.” Instead, he highlighted the planned reconstruction and development work British forces would undertake, and believed that, “If we came for three years here to accomplish our mission and had not fired one shot at the end of it, we would be very happy indeed.” However, Reid’s statement overlooked the fact that the United Kingdom planned to wage a drug eradication program in the same region in which it sought to conduct reconstruction and stability operations. Given that many Afghans in Helmand depended on opium farming for income, the local population would view any attempt by foreigners to eradicate the poppy fields as an aggressive move against their economic livelihood, and instigate rising levels of violence.","Stability and economic development would support the other British mission: counternarcotics. The fight against illegal  drug proliferation was critical to building domestic support for the mission in Afghanistan. It was a way for politicians to justify foreign intervention to their constituents and, while not explicitly stated as such, an effective condition for the United Kingdom’s continued involvement in Operation Enduring Freedom. General John P. Abizaid, a strong proponent of British leadership of ISAF, instructed Eikenberry to support the program, even though he personally viewed counternarcotics as a periphery effort that drained limited military assets. Supported by CENTCOM and the CFC-A commander, British soldiers would eradicate poppy fields and target production and transportation networks. It was a daunting task, as opium production was 30 percent of the Afghan economy. Helmand alone accounted for 42 percent of all poppy cultivation in Afghanistan in 2006 and 30 percent of the world’s supply of opium. Also, the powerful provincial governor, Sher Mohammed Akhundzada, had suspected ties to the narcotics trade.","Given their mandate for counternarcotics, the British pushed to have Akhundzada removed from office before they arrived. An important ally of Karzai’s, Akhundzada used his connections to secure a seat in the Afghan senate and arranged for his replacement, Mohammed Daoud, to accept Akhundzada’s younger brother as his deputy, thus ensuring that the elder Akhundzada’s interests remained secure. Even then, however, Akhundzada did not step down quietly; he later claimed to have encouraged 3,000 of his supporters to side with the Taliban. The nature of the Afghan economy and Helmand politics presented tremendous challenges to the British from the outset.","Some individuals within the British defense establishment felt that British soldiers might encounter armed resistance in Helmand, but they exerted little or no influence over predeployment preparations. When the commander of the British contingent slated to deploy to Afghanistan informed his superiors that a minimum of 14,000 military personnel would be required to secure Helmand, they greeted that number with derision before pointedly directing him to downsize the estimate. Although some lower-ranking British military leaders harbored concerns about their ability to conduct their assigned mission, Americans interacting with senior British officials came away with a different impression. General Freakley later recalled, “[The British] held us in somewhat of a negative light in that we had Vietnam and they had Northern Ireland; who had the better outcome? So far as counterterrorism, they looked at themselves as ‘we know how to do this.’”","To accomplish their objectives for Helmand, the British planned to create a secure area (which they called the “Triangle” or “Lozenge”) circumscribed by their main base at Camp Bastion, the provincial capital of Lashkar Gah, and the market town of Girishk. Although this zone represented less than a sixth of the province’s total area, it included two major population centers and comprised the economic heart of the province, bisecting the fertile Helmand River Valley that ran through the province from northeast to southwest. To secure this area, the British sent 16 Air Assault Brigade under Brig. Gen. Edward A. Butler. Because their troops fell under RC South led by a Canadian brigadier, the British military deemed it improper for Butler to serve under a foreign officer of the same rank. London subsequently removed Butler from the ISAF command chain and established him as national contingent commander and senior officer in Afghanistan answering to his political leaders at Whitehall. Effectively removed from any ISAF tactical responsibilities, Butler instead had authority under his national command chain. British forces in Helmand (TF HELMAND) were placed under Col. Charles P. H. Knaggs, who reported to both Fraser and Butler. Knaggs exercised direct authority over British maneuver forces (Tootal’s battalion) and the Helmand Provincial Reconstruction Team.","Knaggs planned to secure the Triangle with the 3d Parachute Battalion, which would enable the reconstruction team to begin work. According to Butler, “Our priorities were to build up the Camp Bastion infrastructure, establish our presence in Lashkar Gah and in Girishk, raise the PRT [Provincial Reconstruction Team] and forge our relationship with Governor Daoud.” Once they were secure, the British would then range outward to the north and south, expanding their area of control in an effort to challenge Taliban encroachment, support the ANP, and link the villages to the provincial capital.","Meanwhile, the Taliban strengthened its position in RC South in anticipation of the arrival of additional NATO troops.  The impending transition offered them an unparalleled opportunity: the Americans were being replaced by newcomers unfamiliar with the region, and the Pashtun majority population remained either uncommitted or supportive of Taliban efforts. Mullah Mohammed Omar dispatched Mullah Dadullah “Lame” Akhund, one of his most committed followers, to take command of the fighters in the south. A native of Uruzgan Province, Dadullah came from the younger generation of Taliban commanders absolutely committed to Omar’s Islamist vision. He also was described as “the most brutal of all [the Taliban’s] commanders” for having shot his own men and massacred unarmed Hazaras a decade earlier. NATO estimated that his fighting force ranged from 300 to more than 2,000. In February 2006, Dadullah sent 300 men to capture Sangin, a town controlling the northern branch of the Helmand River. His fighters also turned the town of Marjah in central Helmand into the Taliban’s biggest stronghold in the province. Unfortunately, these actions were merely a glimpse of what was to come.","By May 2006, the Taliban established a strong position in the town of Baghran in northern Helmand and made a move to seize key points in the adjacent Musa Qal’ah District. After a battle that killed twenty Afghan soldiers, a Taliban spokesman declared, “We are here to destroy the British. We will hunt and kill them. We will not let them go back to England and say that they have defeated the Afghans.” The Taliban were consciously invoking nearly 200 years’ worth of animosity dating back to the British-Afghan wars of the mid-nineteenth century. One British officer recalled, “What we found when we had forces on the ground was starkly different from what we had anticipated and hoped for. We were ready for an adverse reaction, but to be fair we did not expect it to be as vehement as it turned out to be.” That situation did not stem from the British forces’ inability to anticipate Afghan reactions, but rather from systemic issues within the U.S. intelligence effort, which now had to figure out how to share sensitive material with NATO allies in addition to identifying effective methods to gain relevant information about their elusive enemies.","The decision to delay the British deployment until late spring limited what 16 Air Assault Brigade could accomplish. Instead of establishing positions in a relatively benign environment, the British began arriving at the traditional start of the fighting season in April and May. Their staggered arrival also meant they could not contribute to Operation MOUNTAIN THRUST to the degree that General Freakley wanted. To make matters worse, Governor Daoud responded to the Taliban’s attacks in northern Helmand, often with the support of President Karzai, by requesting that the British protect the district centers. As Tootal’s solitary battalion still did not have all of its combat units, sending even a platoon up north limited British ability to develop the Triangle. Even though Butler tried to explain that he was trading space up north for time to build a zone from which to mount a counterattack, “Governor Daoud and President Karzai made it very clear that the ‘black flag’ of Mullah Omar should never be allowed to fly over the district centers and that the Afghan flag must fly at all costs.” Daoud told Butler, “Unless [the British] occupied the District Centers, [they] might as well go home.” Daoud had few other options because both the ANA and the ANP lacked the skill and numbers necessary to confront the Taliban.","In June, Butler consented to secure the province’s northern district centers. Establishing permanent positions in the northern districts meant abandoning their plan to develop the Triangle. It also meant his troops were now spread so thin holding static positions that 16 Air Assault Brigade lacked any capability to maneuver against the Taliban. The British established fortified positions in the government buildings (termed “platoon houses”) in Musa Qal’ah, Sangin, and Now Zad, along with a position protecting the vital Band-e Kajaki hydroelectric complex. What initially had been characterized as a peace-support mission soon turned into a bitter defense of isolated positions.","The Taliban reacted predictably by launching numerous attacks on the dispersed British units. When direct assault failed  to bring victory, the Taliban sought to cut the defenders off from supplies by laying numerous IEDs along access roads. Even though the defenders enjoyed adequate artillery and air support, they now could be supplied only by air, which presented the constant threat of the enemy downing a helicopter. Despite the unfavorable tactical situation, Butler thought that the Taliban had made an error:",{"list":["[The Taliban] became engaged in a conventional fight, a pretty ferocious one. We fixed them and fixed ourselves, but that kept the fight on what I called the “strategic pegs” of the northern District Centers. They were acting as “breakwaters” which the Taliban focused on for the next three months. As a result of that, we kept the “deep.”"]},"Freakley disagreed. To the CJTF-76 commander, the British “played straight into the Taliban’s hands,” falling into the same type of trap that the mujahideen had used against the Soviets in the 1980s. Fraser had a more measured view, saying that the British would have been hard-pressed to avoid getting fixed “without ignoring the Afghans completely.”","General Richards thought that the platoon houses, although they might have “achieved some sort of ascendancy over the Taliban in a military sense,” did nothing to win Afghan “hearts and minds.” Prodigious use of artillery and air support invariably devastated the villages in the vicinity of the outposts, while many of the Taliban fighters killed by the British were unemployed opium farmers with familial and tribal ties to the local area. Whatever the case, the British conducted far more combat operations than reconstruction and development missions during their first six months in northern Helmand.","The constant attacks and wide distribution of their forces so strained the British that TF HELMAND agreed in October to withdraw from Musa Qal’ah District Center if the Taliban followed suit. The controversial deal, initially put forward by locals who wanted the fighting to stop, called for a temporary ceasefire followed by the withdrawal of both British and Taliban forces from the area. Although the Americans were critical of the deal, it helped British leaders to recognize belatedly that they had underestimated the security needs of Helmand Province. Whitehall therefore made sure that the 3d Parachute Battalion’s replacement would not cede the initiative to the enemy. When 3 Royal Marine Commando Brigade arrived in Helmand in October 2006, it brought an additional 870 soldiers, armored vehicles, heavier weaponry, more helicopters, and an aggressive tactical mindset. The British had learned a hard lesson about the resources needed to bring stability to southern Afghanistan.","${Operation Medusa (2–17 September 2006)}{bold}","Even after RC South came under ISAF control, the Taliban showed no signs of reducing their attacks in the area. Three days after the transfer of authority, the Taliban sprang a deadly ambush on Canadian troops southwest of Kandahar City. Intelligence reports confirmed that, while Canadian forces were operating in the province’s northern districts, the Taliban had relocated west and southwest of the provincial capital. Having failed to stop NATO’s entry into the region, the Taliban now focused on retaking Kandahar City. Taliban infiltration had already secured entire districts surrounding the city. Abandoning low-level guerrilla tactics, battalion-sized Taliban elements openly fought against coalition troops in a major push, despite their vulnerability to air and rotary-wing support. Coalition leaders understood these tactical changes as evidence that the area around Kandahar City was growing increasingly volatile.","The Canadians also could not counter Taliban presence in Panjwa’i and Zharey Districts west of the city because of their commitments to MOUNTAIN THRUST. General Fraser understood that the region was “an important area for the Taliban” but “didn’t have enough forces to go in there earlier for a sustained offensive effort.” When the Canadians did launch a clearing mission into Panjwa’i on 3 August, a vehicle struck a large IED, killing two soldiers. After dismounting, the Canadians found themselves facing determined fire on three sides from enemy fighters displaying unusual tactical skill. Radio chatter indicated that there might have been as many as a thousand insurgents in the area. After a hard fight to extricate their lead elements, the Canadians pulled back to reassess the situation. Many Kandaharis openly began speculating that the Taliban would return and seize the capital.","Colonel Hope, who led the 3 August attack, anticipated that a determined effort to clear Panjwa’i would require “a brigade operation.” As events transpired, neither a brigade nor Hope’s battalion undertook that mission. Due to the fixed rotation schedule, Fraser would have to rely on a new force for the mission, as Lt. Col. Omer H. Lavoie’s 1st Battalion, Royal Canadian Regiment (Task Force KANDAHAR) began replacing TF ORION in mid-August. Planning for a return to Panjwa’i also began mid-August. The first substantive step of the plan envisioned a major offensive against the town of Pashmul and was set for October.","Events converged to accelerate the original timetable. The Taliban’s steady propaganda sparked considerable distress and  increased anxiety among Afghan civilians and international aid workers in Kandahar City. In mid-August, the governor of Kandahar, Asadullah Khalid, exacerbated the situation by ordering local Afghan Border Police commander Abdul Raziq, a Karzai ally and virulent opponent of the Taliban, to clear Panjwa’i. The move ignited a violent tribal feud, as it sent Raziq’s mostly Achakzai forces into traditional Noorzai territory. Haji Mohammed Qassam, a Kandahar Provincial Council member, acknowledged that the operation boosted local support for the Taliban. “One village had 10 or 20 fighters against the government before he [Raziq] came,” he noted, “and the next day, maybe 200.” Although the new fighters were inexperienced and untrained, they confronted ISAF and Afghan troops in open battle, presenting a direct challenge not only to coalition forces but also to the Karzai government. As if to drive the point home, on the afternoon of 19 August an insurgent force of 300–500 fighters launched a coordinated attack on an ANP position at the large Ma’sum Ghar hill adjacent to the Bazar-e Panjwa’i city center. After hard fighting, the Afghan police unit and an undersized Canadian company (sent as a quick reaction force) withdrew under cover of darkness. Fraser could now see that the “scale of Taliban activity made it clear that we would have to come back” to Pashmul. Only one question remained: When?","In response to the Taliban’s growing influence, Richards and Fraser accelerated the move into Panjwa’i. Spurring their efforts was their knowledge that Freakley’s CJTF-76 wanted to launch Operation MOUNTAIN FURY in RC East in late September, which would limit the availability of U.S. assets in RC South. The attack in Panjwa’i, called Operation MEDUSA, would test ISAF’s ability to conduct major operations against the Taliban. With Richards describing it as the “NATO main effort” and the “first large-scale offensive in [NATO’s] history,” Fraser set about developing his plan and assembling his forces. The main effort consisted of three Canadian infantry companies (designated as Task Force 3-06) commanded by Colonel Lavoie, supported by a battalion from the 205th Afghan National Army Corps. Fraser could also count on the services of a company headquarters and two ODAs from Lt. Col. Donald C. Bolduc’s Special Operations Task Force 31, which were partnered with comparably-sized Afghan units.","Given the Taliban’s willingness to engage in open battle, Fraser decided against a frontal assault on Pashmul, instead directing one company to advance from the north while another moved from the southeast. This double envelopment sought to prevent the Taliban from escaping toward Highway 1 to the north or Kandahar City to the east. After examining the draft plan, Richards felt that it lacked sufficient combat power. At the ISAF commander’s request, Freakley assigned Company A from Sturek’s TF WARRIOR to augment the northern effort while also sending Company C from TF CATAMOUNT south to support TF-31. In addition, various ISAF contingents would establish blocking positions to the west. Freakley also dedicated additional artillery (including 105-mm. howitzers from Battery B, 2d Battalion, 25th Field Artillery Regiment, and a High Mobility Artillery Rocket System launcher) and aviation support to the operation, and asked the 1st Kandak, 3d Brigade, 201st Afghan Corps, to serve as a reserve. Richards approved the adjustments, thinking it enabled Fraser and Lavoie to “compensate for lack of troops with firepower.”","Colonel Bolduc’s ODAs were to conduct reconnaissance, act as a diversion for the Canadian main effort, and establish a blocking position south of Panjwa’i. As Bolduc evaluated the plan, he decided to reinforce the ODAs with additional command and control capabilities to ensure nothing went wrong during the next phase of the operation. The augmented SOF task force planned to take a circuitous route to minimize the chances of inadvertently encountering enemy fighters. Although they would begin by heading south parallel to Highway 4, the SOF personnel then planned to detour west and north through a sparsely populated stretch of desert before occupying their assigned objective. A third ODA would join the task force to act as a quick reaction force. Even with the addition of more command and control capabilities, the SOF element remained a secondary effort in the overall battle plan.","${MEDUSA}{bold}${:}{bold} ${PHASE I (2–4 September 2006)}{bold}.  The initial ISAF plan called for several days of heavy bombardment by indirect fire and aviation assets. During this period, an international battle group composed of Lavoie’s Company B; Company A from the 2d Battalion, 4th Infantry Regiment; and a third company from the 205 ANA Corps would move south from Afghanistan National Highway 1 toward Objective CRICKET on the northern edge of Pashmul. The move would be a feint to draw the Taliban fighters out of their fortified positions and distract them from operations to the south. The main effort was to come from Company C, 1 Royal Canadian Regiment, setting up a blocking position on the southern bank of the Arghandab River as the bombardment pounded the enemy. After the bombardment inflicted enough casualties on the defenders, Canadian foot soldiers were to cross the river and move on Objective RUGBY, the small village of Bayanzi just south of Pashmul, with the support of Lavoie’s Company A, which would air-assault behind Company C, isolate Bazar-e Panjwa’i, and provide overwatch from the Ma’sum Ghar hilltop.",{"figure":{"source":"/figures/m/map-figure-3-4.svg","caption":"OPERATION MEDUSA","prefix":"MAP"}},"As ISAF prepared to launch Operation MEDUSA, the governor of Kandahar announced on 1 September that civilians should evacuate Panjwa’i. Civilian casualties were a likely consequence of military action that neither NATO nor the Afghan government wanted to face. The call also helped to isolate the Taliban from the populace, as the locals were showing every sign of opposing a coalition move on the town. The terrain around Pashmul (situated between company objectives RUGBY, CRICKET, and LACROSSE), just north of the Arghandab, was littered with irrigation ditches, bunker-like grape storage huts (some with mud walls up to three feet thick), and lush fields of grape and marijuana. Intelligence was vague; most estimates of Taliban strength ranged in the hundreds. The actual number was likely closer to 2,000 to 3,000 men capable of coordinating large attacks with multiple groups of fighters.","Like innumerable military operations, MEDUSA did not proceed as planned. The step-off on 2 September went well as both northern and southern task forces established their positions while artillery rained down upon the enemy positions. The first deviation from the plan occurred soon afterward as reports that the Taliban fighters were fleeing prompted pressure from higher headquarters for Colonel Lavoie to push Company C across the river to assault rugby on 3 September. The Canadians crossed only to encounter intense fire from prepared defensive positions well-stocked with weapons and ammunition. Mud-walled compounds, reinforced dugouts, trenches, and fighting bunkers turned every cluster of homes into a miniature fortress, impervious to all but armored bulldozers, tanks, or artillery.","Following a seven-hour fight in which they suffered deaths and the loss of vehicles to rocket-propelled grenade fire, the Canadians extricated themselves and reestablished their position on the southern bank of the Arghandab. After spending the night preparing to relaunch the assault, disaster struck. Just after 0500 on 4 September, a U.S. A–10 Thunderbolt II attack aircraft accidently strafed the Canadian position. The attack killed one soldier from Company C, wounded at least thirty others, including the company commander, and rendered the company combat-ineffective. For the second time during ENDURING FREEDOM, mistakes made by American pilots caused the deaths of Canadian soldiers. Unlike the previous incident, however, this fratricidal attack had far more tragic consequences, throwing the main thrust of TF 3-06’s attack into complete disarray.","To the north, the attack of Company B initially went well. The terrain was suited to the Canadian wheeled light-armored vehicles, which could cover a good deal of ground with their 25-mm. cannon. The international battle group had established positions just south of Highway 1 by 2 September. From there the attackers began a back-and-forth engagement with the Taliban, alternating between small feints toward Objective CRICKET and repulsing enemy attacks, while coalition artillery and air assets dropped ordnance on Taliban positions. Company B was preparing to launch its strongest move against the Taliban lines when it received word of the friendly-fire incident to the south. All operations ground to a halt as Fraser and Lavoie evacuated their casualties and reassessed the situation.","${MEDUSA}{bold}${:}{bold}  ${PHASE II (5-10 September 2006)}{bold}. The errant A–10 strike that halted TF 3-06’s southern attack had a profound effect on the coalition. Colonel Lavoie and his men were shocked by the incident, with some arguing that allowing the scheduled three-day bombardment could have averted the tragedy. Fraser acknowledged pressure coming from higher headquarters to “get it done” but responded that “you don’t fight a plan; you fight the enemy guided by a plan.” Intelligence reports indicated that the enemy was sufficiently battered by the initial day’s bombardment, and Fraser decided to push forward rather than allow the Taliban time to recover or withdraw. Now Fraser faced a different challenge. Lavoie had no desire to resume the attack along the same path and preferred a more methodical approach to seizing RUGBY. Fraser understood that this would delay the operation, which was contrary to the desires of ISAF headquarters.","According to the TF AEGIS operations officer, Richards and Freakley were adamant that the attack go forward, telling Fraser, “this is the most important thing NATO’s ever done, the future of NATO rides on this, the future of Afghanistan rides on this.” At the same time, as the Canadian national component commander, Fraser was under pressure from Ottawa not to incur heavy casualties. Richards had to communicate directly with the Canadian government to convince them to approve the attack’s continuation. The next few days would show whether the coalition was capable of conducting the aggressive combat operations needed to secure RC South.","To the southwest, the soldiers of Special Operations TF-31 provided an unexpected opportunity for the coalition to reclaim the initiative. After departing Kandahar on 26 August and moving along a circuitous path from which they could identify Taliban infiltration and resupply routes, training camps, and a command and control node, the Special Forces soldiers and their Afghan partners established their assigned blocking positions on 1 September. Following the friendly fire incident, the partnered SOF task force asked to move from its blocking positions and occupy key terrain to support the offensive.",{"figure":{"source":"/figures/m/map-figure-3-5.svg","caption":"OPERATION MEDUSA Phase II","prefix":"MAP"}},"With ISAF permission secured, and with the rifle company from 2d Battalion, 87th Infantry Regiment, taking over its original positions, the small force of eighty-nine U.S. SOF and ANA soldiers assaulted a large hill, called Sperwan Ghundey (also known as Sperwan Ghar), which overlooked the surrounding area. After being repulsed on their first attack, the combined SOF-ANA force took Sperwan Ghundey on 6 September. The feat handed possession of the high ground covering the entire area to Fraser. In evaluating TF-31’s accomplishment, one Canadian officer called it, “one of the most profound acts of bravery I’ve seen since I’ve been over here.” Facing an anticipated counterattack from the Taliban, the special operators and their Afghan counterparts dug defensive positions. They were soon aided by the arrival of an additional ODA and troops from Company C, 2d Battalion, 87th Infantry Regiment. With the extra firepower, along with artillery and air support, TF-31 defeated multiple Taliban counterattacks before finally establishing a firebase at Sperwan Ghundey on 11 September.",{"figure":{"source":"/figures/v2/img_3-3.png","caption":"Member of Company A, 2d Princess Patricia’s Canadian Light Infantry"}},"As SOF seized the initiative to the southwest, Fraser reconstituted his brigade and revised his attack plan. With General Freakley’s support, Fraser turned to Col. R. Steven Williams, whose Task Force GRIZZLY had replaced Schweikert’s force in June as the U.S. National Command Element in RC South. Williams’ unit, composed of the Alaska Army National Guard’s 207th Infantry Group headquarters and the 297th Support Battalion, was never intended to operate as a combat force. Fraser, however, now called on his American deputy to reinforce and reorganize Company C for a renewed move on Objective RUGBY. In an effort to fix the enemy in place, Williams was told to make his ad hoc unit “look like a thousand man organization.” Williams and his men moved out on 6 September and consolidated the Canadian position south of the Arghandab. Described by Fraser as a “warrior,” Williams immediately began calling in airstrikes against the Taliban across the river and doing everything he could to signal an impending assault against RUGBY from the southeast.","With Special Operations TF-31 securing the high ground to the southwest and TF GRIZZLY fixing the enemy at RUGBY, the main focus of the battle shifted north. Fraser redeployed Company A, 2d Battalion, 4th Infantry Regiment, to the northern battle group to increase its combat strength. Now with three coalition companies (two Canadian and one American) and support from the ANA’s 205th Corps, the combined task force began a slow but steady push south on 6 September. Using what one officer described as “World War I tactics,” the battle group established a line of advance, identified Taliban targets, destroyed them with air and ground fire, and then sent the infantry bounding forward to establish a new position. In this manner the combined task force slowly ground through the Taliban, who found that the constant pressure shattered their command and control and logistics capabilities. As the Taliban began to lose cohesion, the combined task force secured Objective CRICKET on 10 September, setting the stage for MEDUSA’s final phase.","${MEDUSA}{bold}${:}{bold} ${PHASE III (11-17 September 2006)}{bold}","By 11 September, Fraser began preparing to end Operation MEDUSA. With his northern battle group clawing its way south and TF-31 and TF GRIZZLY directing fire on the Taliban from the south and southeast, Fraser directed Williams to assault RUGBY. Against weak resistance, Williams led his men across the river, swept north, and then turned east to advance on the objective. Meanwhile, the combined battle group to the north continued its attack. The U.S. contribution (Company A, 2d Battalion, 4th Infantry Regiment, called Task Force MOHAWK) shifted to the west and seized Objective LACROSSE on 12 September, after which it moved against the western portion of RUGBY. As the Canadian Company A drove toward the northeast portion of RUGBY, Williams’ TF GRIZZLY approached from the east. By 13 September ISAF forces controlled roughly 65 percent of the objective, and TF MOHAWK seized the western portion of RUGBY the following day.",{"figure":{"source":"/figures/m/map-figure-3-7.svg","caption":"OPERATION MEDUSA Phase III","prefix":"MAP"}},"As his forces consolidated at Objective RUGBY, Fraser shifted his attention to the southwest, where TF-31 remained entrenched atop Sperwan Ghundey. Fraser ordered the Special Forces task force to push across the river to seize Objective TENNIS at the village of Siyah Choy. For the move, which Fraser designated as the new “main effort,” he “allotted them priority on artillery, aviation, and everything else.” The original plan never called for TF-31 to cross the Arghandab but, as with their earlier exploits, the American and Afghan soldiers unhesitatingly accepted the mission. They forded the river on 12 September, supported by two companies of ANA troops and Company C, 2d Battalion, 87th Infantry Regiment, to begin a sweep west toward Siyah Choy. They found that most of the Taliban had departed, allowing the soldiers to secure the entire objective within a week. Fraser’s units then began preparing for Phase IV operations by establishing security positions near villages in the area. As villagers returned to their homes around Pashmul, General Richards announced that Operation MEDUSA had been successful.","${Continuing the Fight}{bold}","As the largest battle since Operation ANACONDA in March 2002, Operation MEDUSA was an anomaly. It was far closer to a conventional force-on-force battle than the typical experience in Afghanistan. Although the Taliban committed a significant tactical misstep attempting a deliberate defense of Pashmul and Panjwa’i, those actions revealed an enemy with previously unseen military capabilities and resilience. Taliban fighters had stockpiled several months’ worth of munitions that they utilized during MEDUSA and they did not give ground even in the face of logistical shortages. The Taliban fired off 400,000 rounds of small arms, 2,000 rocket-propelled grenades, and 1,000 mortar shells during the battle, expenditures which reflected firepower rarely seen since the first months of the war. Personnel losses, which the coalition estimated to be 512 killed and 160 captured, were easily replaced by the Pakistan madrassas. In the meantime, the insurgents either retreated to Pakistan or melted into the population, content to resume their insurgency at a time and place of their choosing. As for ISAF, the battle ended without coalition forces possessing sufficient resources to prevent the Taliban from returning to Kandahar’s western districts. The engagement, however, assuaged doubts that NATO forces could not or would not fight when pressed. By its international involvement and conventional tactics, if not its ambiguous outcome, Operation MEDUSA had little parallel in almost five years of combat operations.","After MEDUSA, CJTF-76 withdrew U.S. conventional forces from RC South for duty in RC East. The Americans would not return to the south in large numbers until 2008. In the meantime, CJSOTF-Afghanistan continued to support both ISAF and CJTF-76, despite not having a direct command and control relationship with either headquarters. Special Operations TF-31 was called upon to support ISAF in the south not long after MEDUSA’s end. Though ISAF forces began stability operations in Panjwa’i on 23 September, the lack of a large, capable, and permanent security force enabled the Taliban to reoccupy many of their previous strongholds. The Taliban also took advantage of the pause created by ISAF changing command in RC South from Fraser to Maj. Gen. Ton van Loon of the Netherlands on 1 November 2006. In keeping with his experience in Bosnia, van Loon brought with him a new mission emphasis, shifting ISAF efforts to provide more humanitarian assistance.","Following a month of increasing violence and stalled reconstruction in Panjwa’i, van Loon approved Operation FALCON SUMMIT (BAAZ TSUKA in Dari) to follow MEDUSA in December. He sought to drive the Taliban out of its strongholds, provide humanitarian assistance, enhance local infrastructure, and reestablish an Afghan security presence. As executed, FALCON SUMMIT was a series of coordinated efforts involving ANA, U.S. SOF, and Canadian and Dutch forces. Between 15 December 2006 and 12 January 2007, ISAF cleared the Zharey and Panjwa’i regions around the village of Howz-e Madad, located north of the Arghandab River, while SOF-ANA partnered units cleared objectives west from Sperwan Ghundey. The operation included an air assault by a Dutch infantry company into the village of Mushan on 22 December, which established the overall western limit of advance. The operation successfully concluded with the creation of permanent ANSF-staffed checkpoints throughout the area.","The key American contribution to FALCON SUMMIT was to locate and kill Taliban commander Akhtar Mohammed Osmani in Helmand. His loss was a blow to the Taliban leadership and removed a major conduit for funding al-Qaeda. Two months later, as Vice President Richard B. “Dick” Cheney visited Afghanistan and Pakistan in February 2007, Pakistani forces arrested Mullah Obiadullah Akhund, the former Taliban defense minister and insurgent commander, in Quetta. In May 2007, coalition forces in Helmand killed Mullah Dadullah Akhund, described by a NATO spokesman as “the top person in our scope of Afghanistan that we were interested in removing.” These losses, when added to the overall impact of ISAF counterinsurgency efforts, significantly reduced the possibility of renewed Taliban offensive across the south and west in the summer of 2007. The trio of successes capped a year of frustration in Afghanistan, staunching the trend of local reverses that had started with the Taliban revival in late 2005.","${Coalition Difficulties}{bold}","Although ISAF successfully took over responsibility for RC South in mid-2006 and reduced the enemy threat to Kandahar City with Operation MEDUSA, coalition efforts in Afghanistan still faced clear internal problems. The decision not to deploy 10th Mountain’s 4th Brigade Combat Team meant that the forces operating in RC South in mid-2006 had varying capabilities, missions, and rules of engagement. The core issue remained a failure to achieve unity of effort among the troop-contributing nations. Each assumed responsibility for a separate province, crafted its own campaign plan, and deployed forces specifically designed to achieve its objectives. As a result, no single effort covered all of RC South. With the exception of Operation MOUNTAIN THRUST, task forces conducted operations according to their own goals, which were normally national goals. This segmented approach proved ill-suited to the environment, where important tribal alliances spanned provinces. The Taliban, which was not tied to political boundaries, operated along provincial borders to take advantage of weaknesses within the coalition’s structure. The lack of significant reserve forces made it difficult for U.S. and ISAF commands to shift forces between provinces when necessary. The degree to which these ambiguities caused problems varied within the untested, multiple chains of command, but on the whole they highlighted the inefficiency that often defines coalition operations.","Even MOUNTAIN THRUST, which was designed to coordinate multiple national task forces across four provinces, was not free from coalition friction. Although CJTF-76 had designed the operation, the execution fell to the Canadian TF AEGIS. As one observer noted, “The reality was that MOUNTAIN THRUST was a divisional plan using mostly resources executed in TF AEGIS’ area of operations, with CJSOTF-A commanding its own part of the operation and TF AEGIS commanding two battle groups in a supporting role—TF ORION in Kandahar and TF WARRIOR in Zabul.”","Aligning those various efforts proved challenging, particularly because many incoming NATO units had not been briefed on their participation in the operation. General Butler complained that the staggered nature of the British deployment left his nation’s forces with “very little influence on MOUNTAIN THRUST planning, but we were expected to participate in it. . . . We were being asked to do too many tasks beyond our capabilities.” In the end, the British were not able to contribute to MOUNTAIN THRUST to the degree CJTF-76 intended, forcing Freakley to shift U.S. units to Helmand for the operation.","Operation MOUNTAIN THRUST exposed the problems that NATO incurred by not utilizing a rigid chain of command. As a political  alliance, each government within NATO maintained control over its own forces. Field commanders could therefore receive directives from their NATO superiors that contradicted instructions from their own national governments. Navigating these situations required commanders to display more diplomatic skills in executing their military operations and placed a premium on personal relationships. Some, like General Fraser, adapted easily to the challenge. Although deployed to command a NATO force, Fraser served for several months under the U.S. chain of command. To Fraser this was not an issue: “It was real dead simple. General Freakley was the commander of Combined Joint Task Forces 76. [As the RC South commander,] I worked for Freakley.” Others, however, found the command arrangement more difficult. While the British TF HELMAND fell under Fraser’s command, it also reported to General Butler. Although Butler possessed no tactical command authorities, he represented the direct link between British ground forces in Helmand and Whitehall in London. When Fraser sought to use British forces as a part of larger operations in RC South, Butler became an impediment rather than an enabler. The situation eventually pushed Fraser to insist that Richards rectify the matter once RC South transitioned to ISAF control. Richards complied, placing Butler under Fraser’s command authority.","For his part, Butler never thought General Freakley appreciated the pressures constraining national component commanders, nor the fact that they remained responsible to their home governments. “I think as the Afghanistan campaign matures,” Butler later stated, “it will be better understood that” lead nations have to increase their ability to accommodate the “coalitions of the willing.” Freakley drew different conclusions. In looking at NATO, he thought the alliance was “a good strategic platform to keep nations in the fold, have a common interest, have common goals and objectives and strategies, but operational[ly] and tactically . . . [it was] extremely hard” to implement these ideals. The respective viewpoints are telling. Butler focused on personalities and the immature nature of ISAF, whereas Freakley emphasized the ways in which coalition forces cooperated seamlessly with their American counterparts. As the violence spread in Afghanistan, the commanders of ISAF contingents faced the difficult choice of supporting American needs or following the wishes of their home governments.",{"title":"Competing Approaches to Police Training","level":2},{"section":["The understandable frictions taking place on the battlefield as NATO ISAF assumed responsibility for Afghan security were mirrored in other areas as well. Although the United States took responsibility for developing the ANP in 2005, the coalition still played a role, leading to continuing disagreements over the proper direction of reforms and the training program. Americans believed that police should be incorporated in the larger framework of Afghan security, linking their efforts to those of coalition and Afghan military forces. Afghan police, therefore, needed to be equipped and trained to secure territory cleared through combat operations, enabling army units to move to other areas. Holding territory, however, required “the addition of a counterinsurgency role for the ANP.” For the Germans, who continued to operate the Kabul Police Academy, this militarization constituted a shift away from the idea that police served as providers of civilian law enforcement. Unlike the Americans, the Germans still believed that there needed to be a sharp division in Afghanistan between the police and the military. According to German embassy officials, the ANP needed to continue exercising “policing functions and should not be altered into a paramilitary force.”"]},{"figure":{"source":"/figures/v2/img_3-4.png","caption":"42d Brigade (Romania) troops"}},"The German viewpoint diverged significantly from tactical reality in 2006 as the resurgent Taliban and other insurgent groups increasingly targeted the ANP. According to CSTC-A, the ANP suffered 1,113 casualties (406 killed and 707 wounded) from May 2006 to May 2007 while the ANA suffered 776 casualties (170 killed and 606 wounded) during the same period. Comparatively, coalition forces suffered 1,220 causalities (181 killed and 1,039 wounded). For the ANP, therefore, 36.5 percent of total casualties were fatalities, compared to 21.9 percent for the ANA and 14.8 percent for coalition forces. Another report indicated that police killed in action rose from 9 in 2002–2003 to 627 in 2006–2007. As Maj. Gen. Robert E. Durbin explained, “we had more Afghan National Police dying [by the fall of 2006] than Afghan National Army and Coalition military combined . . . so, we made the decision that the Afghan National Police needed to be at least as well armed and at least as well trained in self-defense as the enemy they were fighting.”","In 2006, the mounting human cost, coupled with a belated willingness to contribute additional resources, helped the American vision supersede German arguments on Afghan police training. Germany had reached the limits of its capacity regarding the Afghan police program. Although the nominal lead for police reform, it could not match the $2.1 billion in aid that the United States contributed to the ANP between 2002 and 2006. Sensing Germany’s financial limitations, the European Union discussed taking an increased role in police training in mid-summer 2006. After sending a fact-finding mission to Afghanistan, the European Union announced in February 2007 that it would take the international lead. The European Police, formed in the following months, assumed control over Afghan police training from Germany in mid-June 2007. Europeans subsequently deployed some 220 personnel to Kabul, including 160 police officers. However, the involvement of the European Police did not expand police training. Instead, it drew “under one umbrella nearly all non-U.S. actors, including sixteen European Union member states and seven others.” The Germans represented the largest contingent of European Police, with more than thirty members of the former Police Policy Office participating in the effort. The renamed German Police Project Team shed some personnel but continued mentoring police trainers at the Kabul Police Academy. Not surprisingly, the Germans influenced the European Police’s efforts, which were oriented primarily on developing new officers and less focused on meeting American concerns about the inadequate scope of the program or expanding ANP capabilities.","Recognizing the disconnect, Maj. Gen. Robert W. Cone, General Durbin’s replacement at CSTC-A, ordered his staff to reassess the U.S. police training program. It found little improvement, even though the program had shifted roughly 800 trainers from the ANA to the ANP during the previous year. Members of Cone’s staff and CFC-A argued repeatedly that systemic corruption within the Ministry of Interior and the ANP prevented the police from deterring crime, providing stability, and combating the growing insurgency. As Cone explained, “What was actually happening was [trainers] were training large numbers of individuals and then firing them out into these dysfunctional and corrupt organizations that they couldn’t change.” Cone and his staff concluded that they needed to concentrate on individual districts while stepping up their efforts to implement ministerial reform. Adding a local focus had the benefit of allowing Cone’s organization and the ANP to contribute to the fight against the Taliban, something General Dan K. McNeill, the new ISAF commander, expected CSTC-A to do.",{"title":"Recalibrating Reconstruction","level":2},{"section":["In 2006, the U.S. military’s main effort to oversee Afghan reconstruction consisted of twelve Provincial Reconstruction Teams, ten of which were spread throughout RC East. Eight of the teams in RC East, located in the contested provinces of Khost, Kunar, Laghman, Nangarhar, Nuristan, Paktika, and Paktiya, consisted of roughly eighty-nine military personnel, several interpreters, and two or three interagency civilians. They coordinated their activities with the U.S. maneuver brigades operating in that region. The reconstruction teams in Parwan and Panjshir Provinces were allocated somewhat fewer personnel because they were located in relatively benign areas compared to RC East. These teams were eventually placed under an ad hoc tactical headquarters, which had the mission of transitioning ongoing reconstruction projects from the reconstruction teams to the U.S. Agency for International Development and nongovernmental agencies. The final pair of U.S. teams operated under ISAF control in RC South and RC West. These, located in Zabul and Farah Provinces respectively, were authorized ten additional personnel because they were responsible for managing the forward operating bases that housed them and coalition units. Unfortunately, their ISAF-related responsibilities became so consuming that these teams often lacked the time and resources to conduct their primary mission.","In contrast to their U.S. counterparts, the fourteen ISAF Provincial Reconstruction Teams varied significantly in size and composition. The Italian, German, Canadian, and British Provincial Reconstruction Teams all numbered over a hundred personnel, with the Germans having nearly 500 in Kunduz. The non-U.S. teams also had far more civilians, with the German and Canadian contingents numbering twenty civilian personnel each, while the British in Helmand had thirty civilian experts divided into functional cells such as rule of law, governance, development, and stability. The civilian head of the Helmand reconstruction team outranked, but did not exercise direct command of, the British military officer in the province. In addition to non-U.S. civilians, U.S. Agency for International Development and U.S. State Department representatives were assigned to a number of ISAF reconstruction teams.","Provincial Reconstruction Teams in Afghanistan had ample opportunity to improve the economic situation of ordinary Afghans  through both direct and indirect means. The teams, however, had to ensure that every project that they sponsored advanced the goals articulated in the document governing Afghanistan’s reconstruction and development: the Afghan National Development Strategy. Approved in interim form at the London Conference held on 31 January–1 February 2006, the Afghan National Development Strategy was a vision for development that was consistent with Islamic law and the cultural values stated in the Afghan constitution. The strategy not only supported the Afghanistan Compact but also included language to reassure international donors that their reconstruction funds were being used in an effective and coherent manner. Finally, it integrated existing provincial development plans by approving projects drawn up by 345 district development assemblies and 16,753 (later 18,500) community development councils.","As the conflict in Afghanistan entered its sixth year, Provincial Reconstruction Teams deploying to that country underwent significant changes in order to meet the needs of the greater war on terrorism. With the Iraq war limiting available Army personnel, the DoD assigned Air Force and Navy officers to command reconstruction teams. The teams were reconfigured based on feedback from earlier deployments and a growing awareness of Afghan needs. Each of the twelve authorized U.S. teams now had five primary sections: command, administrative, logistics, security forces, and specialized staff comprising the State Department, Department of Agriculture, and U.S. Agency for International Development experts. Reconstruction teams also now included two engineer officers who provided expertise as project managers for construction projects. The engineers, along with interagency subject matter experts and three to eight civil affairs officers, performed most reconstruction-related tasks. The remaining seventy to eighty personnel provided security, mostly for those dozen or so individuals who managed the core missions of the teams.","By 2007, most Provincial Reconstruction Teams sought to give local shuras the responsibility for making key reconstruction decisions. The shura would develop ideas, identify the right contractors, and ensure locals were employed as workers. This approach fostered the notion among Afghans that coalition troops were not a threat to the established hierarchy. As using shuras became accepted practice, U.S commanders recognized that “the more we work in partnership with them, the more the government works in true partnership with them, the more they come to the side of the government, and the more likely they are to take an active role in denying the influence of the insurgents in their local areas.” It took time to build these relationships and establish trust, but designing reconstruction and development efforts so that they were seen as providing sustainable value to the local community was the most effective way to grow support for the central government."]},{"title":"Operations MOUNTAIN FURY and MOUNTAIN EAGLE (July 2006-February 2007)","level":2},{"section":["As NATO and U.S. forces battled for control of RC South, American efforts in RC East continued on a considerably smaller scale. The soldiers in TF TITANS and TF CHOSIN worked to establish relations with local villagers and solidify the inroads they had made into Kunar and Nuristan during Operation MOUNTAIN LION. With the majority of CJTF-76’s logistics and air support operating in RC South, Eikenberry and Freakley allowed RC East to become a secondary effort. Units still held outposts and patrolled their immediate areas, but efforts to expand the coalition footprint would have to wait until additional resources became available. By August, after most of TF WARRIOR and TF CATAMOUNT returned from RC South, Freakley stood ready to execute MOUNTAIN FURY, an operation targeting the provinces of Paktika, Paktiya, Khost, and Ghazni."]},{"figure":{"source":"/figures/m/map-figure-3-9.svg","caption":"Operation MOUNTAIN FURY","prefix":"MAP"}},"In designing Operation MOUNTAIN FURY, CJTF-76 planners took into consideration developments within Pakistan and among the various enemy groups. The Taliban’s efforts in RC South had made it clear that its fighters were attempting to isolate the region from Kabul and the eastern provinces. At the same time, the Taliban was making inroads into Pakistan’s Federally Administered Tribal Areas, the base of the Haqqani family franchise. The result was a “simultaneous expansion of [Taliban] influence from the FATA [Federally Administered Tribal Areas] into the interior portions of Afghanistan [which] has empowered the [Haqqani Network] to establish sanctuaries within Afghanistan.” Haqqani fighters began arming in Ghazni Province as early as 2005, and foreign fighters, including al-Qaeda recruits, began transiting through Paktiya Province via old mujahideen supply routes in the Shahi Kot.","The Taliban leadership pushed the Haqqani Network to pressure the Afghan government in Logar, Paktiya, Khost, and Paktika Provinces;  establish shadow governments; and target Afghan government and security force officials. The network utilized its ties to al-Qaeda, the Pakistani intelligence service, and other militant extremists to launch its signature tactic: the high-profile attack. These attacks, executed by Haqqani operators but typically claimed by the Quetta Shura Taliban, embarrassed the Karzai government and increased the cost of the U.S. and NATO occupation. Favored targets were political and diplomatic figures, civilian-commercial facilities in Kabul, and ISAF bases in eastern Afghanistan. The potential for high casualties became one of the most significant strategic threats to the ISAF mission, earning the Haqqani Network the label of “most lethal insurgent actor operating in Afghanistan today.”","For Operation MOUNTAIN FURY, Freakley consolidated his forces in RC East. Their primary mission was to eliminate insurgent strongholds in western Paktika and southeast Ghazni while simultaneously disrupting enemy activity along the Pakistan border. Freakley and Colonel Nicholson, the TF SPARTAN commander, divided the regional command into seven operational areas, each with a battalion-equivalent force. Units throughout RC East began shaping operations in late August to set conditions for the operation’s decisive phase. Colonel Nicholson also called upon TF WARRIOR in southern Ghazni and TF CATAMOUNT in Paktika to clear insurgents out of the districts along the provincial boundary with the Afghan Army’s 203d Corps.","Unlike previous operations in which American maneuver units tried to connect their efforts in an overarching framework, MOUNTAIN FURY consisted of small unit actions across large areas. As in RC South, the insurgent groups reacted aggressively to coalition movements into previously unoccupied areas, massing fighters against U.S. mounted patrols in an effort to gain an information operations victory by wiping out a platoon-sized American force. ISAF soldiers were usually outnumbered in these attacks, but their better skill, training, and firepower inflicted considerable damage on the enemy. Despite coalition successes, the attacks continued, reminding the Americans they were operating in hostile territory. Ultimately, CJTF-76 utilized roughly 7,000 soldiers in six weeks of operation across the four provinces, killing hundreds of insurgents and capturing numerous weapons caches while suffering sixteen American deaths and eighty-four other casualties.","Operation MOUNTAIN FURY included efforts to improve the lives of local residents. In Paktika and Ghazni Provinces, civil affairs teams followed clearing operations, identifying small, immediate-impact projects that could link communities to Afghanistan’s central government. The teams utilized funds from the Commander’s Emergency Response Program to repair roads, rebuild district centers, provide medical and veterinary assistance, and distribute supplies for schools and clinics. Throughout the rest of TF SPARTAN’s operational area, U.S. forces continued to consolidate the gains achieved during MOUNTAIN LION and support reconstruction and development. During the six-week operation, TF SPARTAN completed one major road project, built thirty-eight district centers, and provided medical assistance to more than 6,000 patients. The tactics pursued in MOUNTAIN FURY were not new, although, like in the 10th Mountain Division’s three previous operations, Freakley directed them to be exercised in communities that had not yet experienced coalition activity.","Halfway through MOUNTAIN FURY, American conventional forces completed the final shift to NATO ISAF authority. On 5 October 2006, CJTF-76 formally became the ISAF RC East headquarters. Freakley maintained command over U.S. forces but took on the role of ISAF deputy commanding officer for security operations. British General Richards said of the move, “By bringing all of these forces under unified command, we enhance the effectiveness of the operation, as we have far greater flexibility in the use of our assets.” For Freakley, the added duties began “one of the hardest times in my life.” He was particularly concerned that German General Beck, the Joint Forces Command–Brunssum commander and Richards’ direct NATO superior, wanted him to spend most of his time in Kabul and travel throughout the other regional commands to coordinate operations. Freakley also had to fend off requests from NATO nations for using American assets in other regional commands. “Had I just agreed,” Freakley later stated, “they would have, in essence, pulled [CJTF-76] apart.” Thankfully for Freakley, Richards allowed the American general to maintain his headquarters at Bagram. For his part, Richards was fighting his own battles trying to secure more troops for the ISAF mission, with limited success.","With Richards’ support, Freakley designed the last operation for TF SPARTAN’s year-long deployment to return American soldiers to aggressive counterinsurgency tactics. The RC East commander wanted to set conditions for TF SPARTAN’s relief by 4th Brigade, 82d Airborne Division (Task Force FURY), and was already seeing his forces rotate out of theater, as Lt. Col. Ronald J. Metternich’s 2d Battalion, 30th Infantry Regiment, 4th Brigade Combat Team, 10th Mountain Division (Task Force WILD BOAR), replaced Sturek’s TF WARRIOR in November. In Freakley’s understanding, the best way to protect the gains achieved during the three previous operations was to open more of the countryside to “steady state COIN [counterinsurgency]” operations.","Operation MOUNTAIN EAGLE (1 November 2006–20 February 2007) therefore pushed soldiers into remote valleys in the northeastern provinces and pressured infiltration routes in RC East’s southern provinces. To block enemy lines of communications with Pakistan and disrupt Taliban and Haqqani coordination before winter, coalition and Afghan forces established twelve new combat outposts during the operation. As Eikenberry prepared to end the CFC-A mission, the political counterinsurgency he had inherited from General David W. Barno, which had been simplified during his first months of command and then imperfectly implemented by NATO in RC South, now became Freakley’s preferred method of securing Afghanistan.","While U.S. conventional forces conducted their final operations in RC East, Colonel Bolduc’s CJSOTF focused on disruptive elements closer to Kabul. In Kapisa Province, just north of RC Capital, Taliban forces had infiltrated the Tagab District in Kapisa Province and established a sanctuary from which they could launch attacks into Kabul, harass convoys, and threaten the security of Bagram Air Base. The locals, left without security since a coalition offensive cleared the valley in 2005, feared Taliban reprisal and were reluctant to accept humanitarian assistance, let alone provide information on Taliban networks or activities. In response, Bolduc directed Special Operations Task Force 33 to plan a multinational effort to establish long-term security and reaffirm Afghan governmental legitimacy in the area. Described as a three-way partnership including TF-33, ANSF, and Task Force 8 (a United Arab Emirates SOF task force), the effort was more than a clearing operation. TF-33 integrated the ANSF, Kapisa provincial government, U.S. agencies, and the United Arab Emirates in the operational planning to ensure a holistic effort that could be transitioned to Afghan lead. The plan leveraged the good relationship between the TF-8 commander, Lt. Col. Nasser al Ottabi, and the Kapisa governor, Satar Murad. Their cooperation led to a better understanding of the terrain, local leadership, and Taliban networks, as well as corresponding improvements in both civil-military targeting and kinetic operations.","The Kapisa segment of MOUNTAIN EAGLE began on 31 October when coalition forces air-assaulted into the northern end of the Tagab Nawah, and two U.S. SOF A-teams infiltrated the southern end with their ANP partners. Aided by AH–64 Apaches, AC–130 Spectre gunships, and more than 900 ANP personnel from Kapisa and neighboring provinces, the combined force cleared the valley over the next eleven days. Within hours of areas being cleared, support personnel built firebases using prepackaged construction materials (often referred to as “firebases-in-a-box”) for the ANSF. An ODA combat outpost was established to maintain partnership with the ANP and develop new auxiliary police forces.","More importantly, the combined multinational and interagency force provided humanitarian and medical assistance to the local residents using international and Afghan government resources. The United Arab Emirates contributed to the effort by funding infrastructure projects, as its international development financing had fewer restrictions than those of the Afghan or U.S. systems. CJTF-76 later dedicated millions of dollars in Commander’s Emergency Response Program funds to the area, while the Kapisa Provincial Reconstruction Team and the U.S. Agency for International Development produced a long-term infrastructure strategy with the governor. All of these efforts were publicized through a radio, leaflet, and shura campaign in which the governor highlighted the benefits of the operation and refuted Taliban misinformation. Partnered security operations, unprecedented levels of civil-military coordination, and substantial infrastructure support during and after kinetic operations all helped the operation succeed, and Eikenberry considered it a model for future counterinsurgency operations.",{"figure":{"source":"/figures/v2/img_3-5.png","caption":"Soldiers from Company B, 1st Battalion, 32d Infantry Regiment, 10th Mountain Division"}},{"title":"Reassessing the Situation","level":2},{"section":["TF SPARTAN’s deployment occurred during a tumultuous period as the Taliban committed everything to opposing the shift to NATO ISAF lead. In RC East, American forces pushed into new regions to expand Kabul’s reach. During their deployment, soldiers from the 10th Mountain Division increased the number of outposts in RC East from twenty to forty, conducted hundreds of patrols, and attended seemingly endless shuras as they worked to implement a comprehensive counterinsurgency approach. At the same time, RC South erupted in a level of violence not seen since 2001. British soldiers in Helmand Province and Canadian soldiers in neighboring Kandahar Province faced a far greater test than anyone anticipated. Over many months of hard fighting, they strove to adapt to the enemy while reassessing their resources for the campaign.","In Washington, U.S. policymakers tried to downplay the return of the Taliban. Even with the increase in enemy attacks, Secretary of Defense Donald H. Rumsfeld maintained that “weak provincial governments and corruption” and not security were the chief problems in Afghanistan. In the summer of 2006, he sent Marin J. Strmecki, a former assistant to Ambassador Zalmay M. Khalilzad, to analyze the situation in order to develop policy recommendations. Strmecki’s diagnosis supported Rumsfeld’s views, identifying a “crisis in governance” in Afghanistan. “Enormous popular discontent is building against corrupt and ineffective governance,” Strmecki concluded, “undermining Karzai’s political standing, weakening the legitimacy of the new political order, and creating a vacuum of power in the south and other areas that the Taliban can control.” The insurgency had boomed when the Taliban decided to exploit this “vacuum of governance.” Strmecki recommended escalating initiatives in the security, governance, and economic sectors. Beyond poor governance, he highlighted Pakistan’s role in providing a safe haven for the insurgents. He stated that the elements within Pakistan’s Inter-Service Intelligence organization who had provided “some operational support” to enemy activities and President Pervez Musharraf had “not made the strategic choice to cooperate fully with the U.S. and Afghanistan to suppress the Taliban.” Strmecki recommended a diplomatic initiative to induce “Pakistan’s leaders to deprive the Taliban of sanctuary and support.” Crucially, this “asymmetrical counter-escalation” of diplomatic efforts and reconstruction efforts did not require more U.S. or international military forces. Rumsfeld was so impressed with Strmecki’s analysis that he asked Vice President Cheney and National Security Advisor Steven J. Hadley to try to arrange a briefing for him with the president.","Rumsfeld and Strmecki were not wrong about Musharraf, governmental weakness, or endemic corruption; nonetheless, their analysis was self-serving in that it did not lead to changes in the conflict’s ends or means. The related ENDURING FREEDOMand NATO ISAF campaigns had weathered a tumultuous year in 2006. Poor governance might have been the central reason why the country had returned to a degraded existence, but other factors contributed as well. Some of these were preventable. The late and insufficient arrival of partner nations in RC South, their misunderstanding of the conflict to which they had deployed, and their lack of flexibility on the ground were solvable problems. The enemy’s growing assertiveness owed as much to the coalition and the ANA’s inability to provide consistent levels of security as to domestic issues or the innate popularity of violent Islamic fundamentalism. Faced with multiple challenges, Eikenberry, Richards, and Freakley designed campaigns that addressed the threats they faced. Unfortunately for them and their successors, the execution of these campaigns could never account fully for Afghanistan’s social and political complexities."]}],"chapter 4":[{"title":"A Campaign in Transition"},{"section":["The war in Afghanistan entered a new phase in 2007 as NATO ISAF struggled to react to the growing insurgency. The United States now split its forces and missions between ISAF under NATO leadership and Operation ENDURING FREEDOM under U.S. command. While NATO ISAF continued to provide security, governance, and reconstruction assistance to the Afghan government, the remaining American forces divided their efforts between counterterrorist operations and building Afghanistan’s own security forces. The separate American efforts featured competing command chains that could be ruinous to both. In particular, the incoming ISAF commander, American General Dan K. McNeill, would need to overcome burdensome national caveats that prevented him from responding adequately to an increasingly active insurgency.","For the U.S. forces in RC East, 2007 brought a much-needed infusion of troops with the arrival of Col. Martin P. Schweitzer’s 4th Brigade, 82d Airborne Division (TF FURY), and the four-month extension of 3d Brigade, 10th Mountain Division (TF SPARTAN). Maj. Gen. David M. Rodriguez, the 82d Airborne commander, and General McNeill’s senior tactical commander in the east, replaced Maj. Gen. Benjamin C. Freakley and his headquarters. Having two brigades allowed General Rodriguez to conduct operations in the northeastern provinces while maintaining pressure on the central provinces and the Pakistan border.","Unfortunately, these efforts spread American forces thin across the regional command. Insurgents responded by massing fighters and identifying potential weaknesses in the American force array. Taliban efforts to exploit the extension of forces led to a massive attack on a new outpost in the town of Wanat in Nuristan’s Waygal Valley in July 2008 and the stalling of U.S. efforts to exert influence in RC East’s northern provinces.","In RC South, coalition forces presided over a measurable decline in the overall security situation. Insurgents continued to pin down the British in Helmand while increasing the pressure on the Canadians in Kandahar. Taliban fighters avoided a direct confrontation after Operation MEDUSA, choosing instead to infiltrate the territory surrounding Kandahar City as a preliminary step to laying siege to the provincial capital. To aid NATO, the United States sent the 24th Marine Expeditionary Unit to RC South in early 2008, signaling a major increase in the American commitment to the region and an expansion in the overall U.S. effort in Afghanistan."]},{"title":"Strategic Drift","level":2},{"section":["Violence against American forces in Iraq increased drastically at the same time that attacks on coalition units began to permeate Afghanistan. From his headquarters at MacDill Air Force Base in Tampa, Florida, General John P. Abizaid agreed that “the situation in Iraq was deteriorating. And it was more essential to have combat power in Iraq than in Afghanistan.” He acknowledged that “the priority for all military activity was in Iraq. And whatever we need to do to fight the fight in Iraq, that’s what took priority.” Concerned more with Iraq, President George W. Bush increased deployments to that country in what would become known as “the surge.” This prioritization meant that the war in Afghanistan would remain a supporting effort in the Global War on Terrorism as long as Iraq absorbed the majority of available U.S. resources.","Secretary of Defense Robert M. Gates faced that reality when he replaced Donald H. Rumsfeld in December 2006. When Gates took  the position, he resolved to “give our commanders in Iraq and Afghanistan everything they needed to be successful,” but he soon learned that he could not “deliver in both places at once.” He agreed to keep two brigades in Afghanistan, but found that “in terms of major units, that was all we could do, frankly, until we began drawing down from the [planned] surge in Iraq.” In the meantime, the mission for U.S. forces in Afghanistan remained the same: to create a stable state that could support America’s war on terrorism and deny al-Qaeda a safe haven for large-scale terrorist operations.","Instead of charting a new path in Afghanistan, the Bush administration began 2007 by pressuring NATO partners to meet their troop commitments, drop national caveats, and combat the growing insurgency. As General Abizaid explained, the United States pushed NATO and the international community to increase their troop levels because “there weren’t enough American forces to be able to do the things that we wanted ultimately to do with combat power.” Despite this push, some NATO allies continued to resist calls for boosting force levels, insisting instead that the alliance focus on reconstruction and economic development. NATO Secretary General Jaap de Hoop Scheffer argued to Gates, Secretary of State Condoleezza Rice, and National Security Advisor Stephen J. Hadley that NATO could contain but not prevail against the Taliban. Moreover, diplomatic overtures to Pakistan failed to eliminate insurgent sanctuaries across the border.","Unity of effort within the international coalition was proving elusive, as was gaining a clear picture of the situation on the ground.  Secretary Gates remained frustrated by conflicting intelligence estimates, with Central Intelligence Agency (CIA) analysts painting a dire picture while General McNeill, Ambassador William B. Wood, and others assuring him that the Taliban posed no strategic threat. The frustration would continue through the first half of 2007, culminating in June when Gates concluded that, strategically, the war was “at best, at a stalemate.” Testifying before the House Armed Services Committee, Chairman of the Joint Chiefs of Staff Admiral Michael G. Mullen summed up the situation: “In Afghanistan, we do what we can. In Iraq, we do what we must.” The United States’ continued relegation of Afghanistan to an economy of force effort fixed the conflict’s strategic and operational direction for the next two years. Although Gates provided what resources could be spared, success rested on the international community and its ability to provide forces to achieve the security, governance, and reconstruction objectives outlined in the Afghanistan Compact."]},{"title":"A New American Team","level":2},{"section":["After nearly seven years of war, the U.S. Army in Afghanistan had gone through five theater commanders and an evolving operational framework. Though each of the five commanders implemented his own initiatives, the overall U.S. policy objectives remained the same, as did restrictions on troop levels from Washington. Secretary Rumsfeld had begrudgingly accepted the additional tasks of security assistance and state building in Afghanistan, but staunchly opposed major U.S. troop increases. This restriction changed with Gates. In his first meeting with President Bush, the defense secretary expressed deep “concern about Afghanistan and [his] feeling that it was being neglected.”","Gates’ willingness to accept that Afghanistan needed additional resources was not lost on the CFC-A staff. Col. Bart Howard, Lt. Gen. Karl W. Eikenberry’s chief of staff, noted that his subordinates briefed Secretary Rumsfeld in October 2006 about the deteriorating situation in RC East and the danger of CJTF-76 becoming too dispersed. Unconvinced, Rumsfeld asked CFC-A to make better use of what it had on hand. Gates received a similar briefing during his first visit to Afghanistan in January 2007. General Freakley, in his last full month as CJTF-76 commander, pointed to the fact that neither ISAF nor U.S. forces had a reserve force, which limited their ability to mass for specific operations without putting considerable strain on other units. Throughout 2006, Freakley continuously shifted units within RC East and between the eastern and southern regional commands, interrupting the continuity of effort fundamental to counterinsurgency. Gates recognized his predicament, stating that RC East needed another brigade. As the Iraq surge had left only limited forces available, Gates extended TF SPARTAN’s tour for 120 days until it could be replaced by a yet-to-be-determined brigade. Despite Gates’ inability to immediately secure more forces, those on the ground in Afghanistan found the new secretary’s approach “refreshing.”","The soldiers Gates extended would serve alongside members of the 82d Airborne Division arriving in theater beginning in  mid-January 2007. The division commander, General Rodriguez, assumed command of CJTF-76 from Freakley on 2 February. On Rodriguez’s order, that headquarters renamed itself Combined Joint Task Force 82 (CJTF-82) on 7 March. For maneuver forces, Rodriguez brought Colonel Schweitzer’s TF FURY, which included three maneuver battalions: Lt. Col. Brian J. Mennes’ 1st Battalion, 508th Infantry Regiment (Task Force 1 FURY); the 2d Battalion, 508th Infantry Regiment (Task Force 2 FURY) under Lt. Col. Timothy J. McAteer; and Lt. Col. David J. Woods’ 4th Squadron, 73d Cavalry Regiment (Task Force 3 FURY). Because of the lack of an ISAF reserve, the CJTF-82 commander designated TF 1 FURY as a tactical theater reserve.","The other units that Rodriguez brought from Fort Bragg to Afghanistan included Lt. Col. Scott D. Custer’s 2d Battalion, 321st Field Artillery Regiment (Task Force PROFESSIONALS); Lt. Col. Michael P. Peterman’s 782d Support Battalion (Task Force SPARTANS); and Lt. Col. Steven A. Baker’s Special Troops Battalion, 4th Brigade Combat Team (Task Force DIABLO). The latter pair were responsible for providing TF FURY’s combat support and combat service support while Custer’s unit furnished indirect fires to Schweitzer’s infantry battalions as needed. Finally, Col. Kelly J. Thomas’ Combat Aviation Brigade, 82d Airborne Division (Task Force PEGASUS), provided airlift, aerial fires, and medical evacuation support for the new CJTF headquarters."]},{"figure":{"source":"/figures/v2/img_4-1.png","caption":"TF Spartan commander Colonel Nicholson"}},"In addition to acquiring a new defense secretary and extra ground forces, the United States assumed leadership of NATO ISAF. On 4 February 2007, General McNeill formally replaced Lt. Gen. David J. Richards as ISAF commander. Having served as the Combined Joint Task Force 180 (CJTF-180) commander from May 2002 to May 2003, McNeill was no stranger to Afghanistan. His second deployment, however, would be markedly different than his first tour. Instead of heading an American force of less than 10,000, McNeill now led an international coalition of more than 35,000 service members from thirty-seven countries. The mission also had changed from destroying al-Qaeda and the Taliban remnants in Afghanistan to countering a growing insurgency operating from Pakistani sanctuaries while simultaneously strengthening the nascent Kabul government.","McNeill understood the challenges and constraints he faced. As for the U.S. military, the new ISAF commander believed “the expectation was we were an economy of force and that our real mission was to train Afghan National Security Forces so that someday . . . they took responsibility for themselves.” At the same time, he wanted “to attack the insurgents more” in order to gain “better control of certain amounts of battlespace [so that] . . . reconstruction would really take off.” To some degree, these objectives mirrored NATO’s lines of effort, which remained focused on security, governance, and reconstruction.","Despite the apparent similarity, aligning these efforts proved challenging. As McNeill knew, “In Coalition warfare, members will first and foremost see to their own interests, their own national security needs, before they see to anything in the collective and they will see to things in the collective only when it doesn’t go contrary or detract from their national interest.” This focus on national interest included the United States. “I didn’t delude myself,” he later stated, “I got it. It was all about Iraq. I understood that.” The challenge, therefore, was to achieve unity of effort among coalition forces, most of whom had their own conceptions of what they wanted to achieve as well as national caveats that set out what their soldiers would and would not do.","The change in ISAF leadership also marked an overhaul in the American chain of command. As a NATO commander, McNeill reported to  Joint Forces Command–Brunssum, then to Supreme Headquarters Allied Powers Europe, and finally to the North Atlantic Council. This meant that two American command chains would operate in Afghanistan: the ISAF chain through NATO and the Operation ENDURING FREEDOM chain through CENTCOM. It also meant that even though McNeill would be the highest-ranking American commander in Afghanistan, he did not have command authority over all American troops in theater. That command would now fall to General Rodriguez. With NATO ISAF having assumed responsibility for all regional commands, CENTCOM determined that CFC-A no longer had a purpose, and shuttered the headquarters. This situation led to a unique relationship between McNeill and Rodriguez. As the RC East commander, Rodriguez reported to McNeill in his NATO role but, as commander of the U.S. National Support Element, Rodriguez answered to CENTCOM.","At the time of McNeill’s return to Afghanistan, CENTCOM experienced a leadership change of its own, with Admiral William J. Fallon replacing Abizaid in March 2007. A stickler for formal procedures, Admiral Fallon nixed a workaround that would have enabled McNeill to give orders through the CENTCOM command chain directly to U.S. forces—a move the theater commander believed would have simplified targeting operations. McNeill suffered this predicament throughout his command, as did his staff and subordinates at CJTF-82.",{"title":"Steady-State Operations","level":2},{"section":["At the tactical level, Schweitzer’s staff incorporated both TF SPARTAN’s ongoing efforts and NATO ISAF’s overall initiatives when composing TF FURY’s deployment order. Planners noted the insurgents had targeted western Paktika and southern Ghazni Provinces in an attempt to cut off lines of communications between Kandahar City and Kabul. With greater Kandahar remaining the Taliban’s decisive effort, the southern half of RC East became an avenue of transit for fighters and equipment from Pakistan. Despite significant combat losses in RC South during 2006, “the steady influx of replacement fighters . . . resulted in little degradation in the [Taliban’s] ability to conduct operations.” The Taliban’s growing cross-border influence also strengthened the organization’s position in the Afghan interior. Recognizing their increasing strength, Mullah Mohammed Omar and other senior Taliban leaders pushed their fighters to take “a more proactive stance in the insurgency.” Their foot soldiers responded with a nuanced effort that combined lethal methods (direct attacks on coalition and ANSF, targeted assassination of government officials, and increased usage of IEDs) with nonlethal efforts such as propaganda campaigns and the creation of shadow governments.At the tactical level, Schweitzer’s staff incorporated both TF SPARTAN’s ongoing efforts and NATO ISAF’s overall initiatives when composing TF FURY’s deployment order. Planners noted the insurgents had targeted western Paktika and southern Ghazni Provinces in an attempt to cut off lines of communications between Kandahar City and Kabul. With greater Kandahar remaining the Taliban’s decisive effort, the southern half of RC East became an avenue of transit for fighters and equipment from Pakistan. Despite significant combat losses in RC South during 2006, “the steady influx of replacement fighters . . . resulted in little degradation in the [Taliban’s] ability to conduct operations.” The Taliban’s growing cross-border influence also strengthened the organization’s position in the Afghan interior. Recognizing their increasing strength, Mullah Mohammed Omar and other senior Taliban leaders pushed their fighters to take “a more proactive stance in the insurgency.” Their foot soldiers responded with a nuanced effort that combined lethal methods (direct attacks on coalition and ANSF, targeted assassination of government officials, and increased usage of IEDs) with nonlethal efforts such as propaganda campaigns and the creation of shadow governments.","Complicating the problem facing ISAF was the realization that areas often deemed stable because of a lack of insurgent activity were in fact enemy safe havens. As one officer found out over the course of 2007, “just because we didn’t see [incidents] occurring [in certain areas] that didn’t mean that we didn’t have to look there.” Another officer explained, “If the insurgents were walking on [a] path every day for the last year and there was nobody to fire upon and then all of a sudden you put a force there and they are fired upon, does that mean that area has now become worse?” These observations suggest that the insurgents remained capable of exploiting the Kabul government’s lack of a strong presence, even in relatively quiet areas.","At the operational level, General Rodriguez focused on maintaining the integrity of the coalition while, at the tactical level, he utilized Provincial Reconstruction Teams and maneuver forces to support the provincial governments and build ANSF capabilities. To implement these efforts, CJTF-82 adopted the clear, hold, and build dynamic of their predecessors, with the understanding that “the decisive operation will fall within the build portion.” With the extension of the 3d Brigade, 10th Mountain Division, CJTF-82 scrambled to accommodate two brigades in RC East. The revised plan divided RC East in half, with TF SPARTAN operating in Nuristan, Nangarhar, Kunar, and Laghman Provinces and TF FURY taking Paktiya, Paktika, Khost, Ghazni, and Logar Provinces. Focusing on the build phase, CJTF-82’s plan envisioned three sequential counterinsurgency operations to establish Afghan Development Zones around Ghazni, Sharan, and Gardez. These zones eventually would connect to form one single zone in the center of TF FURY’s southern area.","Depending on circumstances, CJTF-82 considered executing a branch plan that would shift the decisive effort to the north in June by creating a development zone in Nuristan that could be linked to the one around Jalalabad in Nangarhar. If the CJTF-82 leadership chose this option, efforts in the south would become shaping operations focused on creating a development zone in Ghazni and Sharan, but forgoing the one in Gardez. Whichever path CJTF-82 took, its subordinate units would work to enhance security, promote good governance, and support economic reconstruction and development throughout RC East.","Before this plan could be enacted, however, the American infrastructure within the regional command needed to be expanded to accommodate two brigade combat teams. Gates’ late decision to extend TF SPARTAN meant that most of TF FURY’s equipment was already enroute to Afghanistan. As previously planned and coordinated, the paratroopers had been counting on using equipment that TF SPARTAN left behind as it rotated out of theater and did not ship their total inventory. The extension decision meant that TF FURY logisticians had to reroute some of their equipment and secure additional materiel. The process took time, as facilities had to be expanded to accommodate the larger American military footprint. In the end, it took several months for logistical systems to adapt to the increased requirements. By the time TF SPARTAN rotated out in May 2007, RC East had forty-three forward operating bases and combat outposts, roughly twice the number that had existed at the beginning of 2006.","Even with two brigades, Rodriguez lacked sufficient forces to cover RC East in its entirety. One key location that he did not want to leave unattended was eastern Paktika. Keeping TF CATAMOUNT there required him to make creative adjustments to his subordinate units’ missions. As a result, Colonel Baker’s Special Troops Battalion became a battlespace owner with a maneuver mission. The unit sent its signal and military intelligence companies to Forward Operating Base SALERNO to support the brigade headquarters and, in turn, received maneuver and artillery support from other TF FURY units. Even with the new forces and mission, Colonel Baker understood that his unit “was the economy of force within the greater economy of force, in comparison of Afghanistan to Iraq.” Likewise, TF PROFESSIONALS continued the practice of splitting its resources between fire support and maneuver tasks. Colonel Custer divided responsibilities between his two key subordinates, directing his executive officer to serve as deputy commander for fires and his operations officer to be the deputy commander for maneuver.","The Army’s attempts to solve resource shortfalls by assembling bits and pieces of disparate organizations to perform nonstandard  missions extended well beyond Schweitzer’s brigade. Another hastily formed ad hoc unit became CJTF-82’s third major battlespace owner: Task Force CINCINNATUS. Shortly after CJTF-82 arrived, the Minnesota Army National Guard’s 219th Support Group, which had provided support and base management for TF Spartan, rotated out of Afghanistan. The active component 43d Support Group normally would have replaced them in support of the 82d Airborne Division. However, the critical needs of the Army diverted that unit to Iraq. In response, U.S. Army Forces Command (FORSCOM) pieced together TF CINCINNATUS, a unit built around officers and noncommissioned officers drawn from Lt. Col. James Bonner’s 23d Chemical Battalion at Fort Lewis, Washington. Its initial responsibilities were to oversee base operations for CJTF-82 installations at Bagram, Kandahar, SALERNO, Jalalabad Airfield, and Camp Eggers in Kabul. To command the new task force, FORSCOM assigned Col. Jonathan G. Ives from the Army Reserve.","When TF CINCINNATUS mobilized on 19 January 2007, it received a complex, nonstandard mission. Fifteen days before his task force took over the area support mission, Ives learned that he would become the battlespace owner for five provinces north and west of Kabul, though he would turn over Wardak Province to TF DIABLO and then TF 2 FURY as security in the province deteriorated. Ives also gained responsibility for New Zealand’s Provincial Reconstruction Team in Bamyan, a Turkish one in Wardak, and American teams in Panjshir and Bagram. To create maneuver forces for his area of operations, Ives pulled the security elements out of the Bagram reconstruction team along with military police from the division special troops battalion and whatever other qualified augmentees he could find. With its forces set across RC East, CJTF-82 was prepared to commence operations.","${Operation OQAB HAMKARI (February - June 2007)}{bold}","Operation OQAB HAMKARI (EAGLE TEAMWORK), McNeill’s first brigade-level operation as ISAF commander, had been designed by his predecessor in an effort to forge Afghan Development Zones. As the CJTF-82 deputy commander for operations termed it, the operation was “a little bit of an ‘ink blot’ approach” to counterinsurgency, and it became the underlying theme for CJTF-82’s efforts in their southern zone of RC East over the first half of 2007. Responsibility for making and maintaining connections with the populace was divided between unit commanders and members of the Provincial Reconstruction Teams, while brigade and battalion commanders developed connections with the provincial governors and the democratically elected provincial councils. Bottom-up and top-down approaches would create a latticework where government officials established connections with their superiors and subordinates and reached out to other leaders for advice and support."]},{"figure":{"source":"/figures/m/map-figure-4-2.svg","caption":"TF CINCINNATUS","prefix":"MAP"}},{"figure":{"source":"/figures/v2/img_4-2.png","caption":"MAJ Rosemary Reed helps SFC Paula Reill"}},"Operation OQAB HAMKARI had been developed before TF Spartan had its tour extended. It primarily involved TF FURY, and was one  of three operations ordered in RC East’s Operation Plan 07–02. The other two operations in the plan were OQAB ETEHAB (EAGLE UNITY) and EAGLE STRENGTH. The overall scope of the plan centered on RC East’s southern provinces, with OQAB HAMKARI focused on establishing an Afghan Development Zone in Ghazni. The operation, which was designed to exploit the gains achieved during Operation MOUNTAIN EAGLE, had three interlocking phases: build, clear, and hold. In the first phase, TF FURY would build relationships with local leaders, identifying target areas for economic development and partnering efforts with ANSF. The orders established the conditions for a functioning Afghan Development Zone as: “security threats reduced to minor criminal elements, rule of law maintained by [Afghan government] officials and enforced by ANP, [Afghan government] officials [able to] provide for population needs, local market activity expanded in terms of quality and diversity, and lines of communication expanded to connect outlying communities.” In the second phase, clearing missions would allow the ANSF to maintain security, defeat insurgent groups, and deny sanctuary. American forces were to partner with Afghan forces to improve the latter’s ability to operate alongside coalition forces and eventually as independent units. Once coalition and Afghan forces had cleared an area, then efforts would shift to the holding phase, as police established themselves and linked local communities judicially to the central government.",{"figure":{"source":"/figures/m/map-figure-4-4.svg","caption":"Operation Plan 07-02","prefix":"MAP"}},"The most significant display of ANSF capacity-building occurred during Operation MAIWAND, a supporting effort of OQAB HAMKARI. The former, which sought to clear the restive Andar District of Ghazni Province, marked the first time in which Afghans took the lead in both operational planning and execution. It grew out of a meeting in May between Schweitzer and Maj. Gen. Abdul Khaliq, commander of the 203d Afghan Corps. While discussing the anticipated events that would take place over the next three months, the pair agreed that Andar had become increasingly problematic. Khaliq assured Schweitzer that his men could clear the district in a month if the ANA received logistical support during the operation. Schweitzer concurred, but wanted Khaliq’s men to plan and conduct the operation with coalition forces operating in support. Both men agreed and set their staffs to work.","Named after the Afghan victory over the British in 1880, MAIWAND was a substantial step forward in ANA development. To aid Khaliq’s efforts, Schweitzer placed his tactical operations center with the headquarters of the Afghan 2d Brigade, which became the 203d Afghan Corps main effort. He also ordered troops from McAteer’s TF 2 FURY, Woods’ TF 3 FURY, U.S. support elements, and the Polish Brigade Group to assume blocking positions, clear roads, and provide logistical support. Finally, TF FURY helped the 203d Corps establish a fires and effects coordination cell that mirrored the American model but reflected Afghan cultural and religious sensitivities.","Operation MAIWAND began on 1 June 2007, following a shura attended by President Hamid Karzai. Though there were sporadic firefights, the Afghans met limited resistance. In most cases, the insurgents fled long before the ANA arrived. Whenever Afghan soldiers appeared, the local population welcomed them and provided intelligence on insurgents and weapons caches. While MAIWAND garnered little attention from the media or from the CJTF-82 staff, the thirty-day operation succeeded in building “the reputation among the people for the police and the army.” The Afghan people’s acceptance of national police and army forces was not the ultimate goal of the development zone concept; nonetheless, it was progress along the government’s long path to political legitimacy. The mission also reverberated within ISAF after a German officer attended a briefing on the operation. Though initially critical of the American approach, he soon came to believe that the partnering and support displayed between U.S. and Afghan forces during MAIWAND was exactly the type of effort that needed to be replicated amongst ISAF forces. He encouraged British and Canadian commanders in RC South to study the operation closely.","TF FURY commanders considered the operation successful as their staffs were able to build effective working relationships with their Afghan counterparts. As the Afghan officers began to write their own orders and give briefings in Dari, both they and their American counterparts developed more confidence in the ANA’s ability to operate as an independent force. According to one American officer, “getting a cohesive U.S. staff married up with an Afghan brigade staff began to show some incredible benefit.” The example set during MAIWAND would be emulated in several operations conducted by the 203d Corps and TF FURY over the remainder of the latter’s deployment in Afghanistan. The Afghan Development Zone concept may not have been universally successful, but in fostering the relationships between U.S. and ANA units, it had shown clear progress.","${Task Force BAYONET in Nuristan, Nangarhar, Kunar, and Laghman Provinces}{bold}","TF SPARTAN’s extended tour began winding down several weeks before MAIWAND commenced, as the brigade started a relief-in-place with Col. Charles A. Preysler’s 173d Airborne Brigade Combat Team (TF BAYONET). TF BAYONET’s five battalion-sized elements assumed control of TF SPARTAN’s operational area of Nuristan, Nangarhar, Kunar, and Laghman Provinces in the northern portion of RC East. At this point, relief-in-place operations started to become much more structured and formal in order to give the incoming unit full critical knowledge of all facets of the area of operations. Three or more days were set for “right-seat ride” opportunities, during which the incoming leadership followed their outgoing counterparts throughout daily operations, followed by “left-seat ride” sessions, in which the incoming leaders led the daily operations and the outgoing leaders rode along to coach them. At the end of the cycle, a brief would be given to the higher headquarters. If requirements were satisfied, a transfer of authority to the incoming unit was approved. On the whole, the 173d deployed some 3,500 soldiers to provide support to four Provincial Reconstruction Teams while also providing security for an area the size of West Virginia with a population of just over 2.3 million.",{"figure":{"source":"/figures/m/map-figure-4-5.svg","caption":"Nangarhar, Nuristan, Kunar, and Laghman Provinces","prefix":"MAP"}},"Initially, Colonel Preysler’s brigade had been slated to deploy to Iraq, but TF BAYONET’S readiness for deployment and its soldiers’ familiarity with Afghanistan made it a natural selection to fulfill Secretary Gates’ commitment to deploy two brigades to RC East. The decision was controversial because the change meant that the brigade could not undergo the normal deployment preparation or gather detailed intelligence of the intended area of operations. As the brigade commander noted, “there’s [sic] two different wars here.” Training for the primarily urban environment of Iraq was not applicable in the remote mountains of Afghanistan, which required more “light infantry classic warfare.” The truncated timetable for preparation also meant that Preysler and his staff were conducting a predeployment site survey in Afghanistan while the rest of the brigade began its mission-rehearsal exercise. During his visit to their proposed area of operations, Preysler discovered that although one battalion from TF SPARTAN had spent the last year in the region, the remainder of the brigade had been in the area for only a few months. This short tenancy limited the situational awareness available to Preysler’s incoming units. Upon their return, Preysler and his staff completed the training exercise, enjoyed a brief holiday, and rolled out for Afghanistan eight days later. Upon reflection, he thought it was a “pretty tough way to come into combat.”","The deployment promised to be a lively one for Colonel Preysler’s paratroopers, as Nuristan and Kunar Provinces were traditional safe havens for regional militant groups. Taliban leaders sought to safeguard the lines of communications running from the tribal areas and Pakistan’s northwestern provinces through the region’s steep river valleys to the provinces surrounding Kabul. To block routes into Nangarhar and Kabul, Preysler spread his three maneuver battalions along a line straddling the southern border of Nuristan and bisecting the brigade’s area of operations. In the northeast, Lt. Col. Christopher D. Kolenda’s 1st Squadron, 91st Cavalry Regiment (Task Force SABER), established a position at Forward Operating Base BOSTICK. Lt. Col. William B. Ostlund’s 2d Battalion, 503d Infantry Regiment (Task Force ROCK), established itself at Camp Blessing in the Pech River Valley in Kunar Province. Farther to the west, Lt. Col. Stephen J. Maranian’s 4th Battalion, 319th Field Artillery Regiment (Task Force KING), converted part of itself to light infantry and settled into Forward Operating Base KALAGUSH.","The brigade headquarters, Lt. Col. James R. Ryan’s 173d Support Battalion, and Lt. Col. Jeffrey O. Milhorn’s Special Troops Battalion, 173d Airborne Brigade Combat Team (Task Force RAPTOR), located themselves at Forward Operating Base FENTY near Jalalabad. Originally configured as a support unit, Milhorn’s TF RAPTOR received a cavalry troop from 1st Squadron, 91st Cavalry Regiment; two field artillery batteries operating in a dismounted infantry role; and a company of Fort Lewis–based military police to enable it to operate in a maneuver role mirroring that of TF DIABLO. The brigade received air support from the 101st Airborne Division’s 2d Squadron, 17th Cavalry Regiment (Task Force OUT FRONT) led by Lt. Col. John M. Lynch, also at FENTY. The Arizona Army National Guard’s 1st Battalion, 158th Infantry Regiment (Task Force DIAMONDBACK), under the command of Lt. Col. Alberto C. Gonzalez, arrived with the rest of TF BAYONET and took up position at Forward Operating Base MEHTAR LAM in Laghman Province until the Pennsylvania Army National Guard’s 3d Battalion, 103d Armored Regiment (Task Force PACESETTER), commanded by Lt. Col. Stephen M. Radulski, arrived in March 2008 for service in the same operational area.",{"figure":{"source":"/figures/v2/img_4-3.png","caption":"173d Airborne Brigade Soldiers"}},"Preysler designed his campaign to build upon the 10th Mountain Division’s efforts to develop the two most populated areas in the  region: Nangarhar and the Pech River Valley. Nangarhar Province would be the focus of the brigade’s main developmental effort, with an Afghan Development Zone centered on the city of Jalalabad and stretching out into most of the province. Termed “Nangarhar Inc.” by the Americans, the zone was designed to bring $3.2 billion in economic development and employment opportunities to the province.","Preysler distributed his forces across the operational area to build support among the local population, deny insurgents safe havens and infiltration routes, and project TF BAYONET units north of Jalalabad, all in accordance with current counterinsurgency doctrine. Movement north of Jalalabad had begun in 2006 under TF SPARTAN, but could be executed only incrementally; the farther American troops penetrated into remote valleys, the fewer soldiers could participate in missions and the more contact they made with enemy fighters. The rough terrain isolated American and ANSF positions in Kunar and Nuristan and made them vulnerable to attack. Moreover, the incursions presented a broad spectrum of opponents, including local extremists, criminal terrorists, and Taliban insurgents, all of whom refused to accept encroachment by the Karzai government. Isolation made remote American and ANSF detachments prime targets for militants and extremists, based just across the border in Pakistan, who had sophisticated tactical training, leadership, and modern equipment.","The Taliban’s most experienced commander in Nuristan and Kunar, Sheikh Dost Mohammed, had been the top military leader and shadow governor in Nuristan Province for several years, and his influence helped make the resistance to coalition forces formidable. Sheikh Dost Mohammed’s insurgent network maintained deep ties to regional Salafist movements and al-Qaeda, and promoted local Taliban and Haqqani Network operations. Proximity to the border brought the region under firm Taliban influence and made it susceptible to militant strikes from Pakistan. These militants engaged in a constant probing war with the Americans, waiting for the proper time and place to mount a sustained attack to drive the intruders out of the region.",{"title":"Improving Afghan Security Capabilities","level":2},{"section":["As the Americans deployed more troops to restive RC East, CSTC-A planners began developing a complementary program for comprehensive, security-sector reform. The new initiative, known as Focused District Development, was designed to improve police standards and capabilities at the district level. Once a district was designated for police reform, it would go through six phases of reform in forty-three weeks. The first phase, lasting eight weeks, was an evaluation by a district assessment and reform team, composed of a police mentor team, representatives from several Afghan governmental ministries, and other international partners. After the assessment, the second phase began as an Afghan National Civil Order Police unit deployed to the district to relieve the local Afghan Uniformed Police. The uniformed police then reported to a regional training center to begin eight weeks of reconstitution (the third phase). In addition to intense training and administrative processing, the police received daily instruction from their mentor teams, which would return for a week with the reformed police unit to its home district (fourth phase). Once there, they began the fifth phase, consisting of twelve weeks of collective training in the district. Finally, after validating the trained police force, the mentor team shifted into an oversight role (during the sixth and final phase, lasting twelve weeks) to ensure the police retained the ethics and skills they had learned. The first cycle of Focused District Development commenced in seven districts in November 2007. McNeill had chosen these districts, which were scattered across the country, “for military imperatives rather than their potential for durable institutional reform.” Because of this criterion, McNeill’s efforts to improve individual districts were unable to build momentum nationwide. Even so, the ISAF commander believed Focused District Development would “bear some fruit,” although it would “take several years” to do so. He was correct in his prediction. Shortages in available police mentor teams, trained civil order police, and training center billets slowed the pace of training. By December 2008, roughly fifty districts had undergone part or all of the program, though only the first seven had reached full capability.","Although Focused District Development was a step in the right direction, several problems prevented it from building on its initial successes. In particular, the program suffered from a lack of necessary resources. The security transition command estimated that it needed a total of 399 police mentor teams, with the first 250 teams being fielded by the end of 2009 and the remainder by the end of 2010, to apply the program to the entire uniformed police force. Even if the additional personnel were made available by the stated milestones, too much time had passed for the program to meet the deadline established in the Afghanistan Compact for a fully trained and functioning police force by the end of 2010. In addition, the Focused District Development effort placed so much unanticipated stress on the Afghan Civil Order Police that attrition rates skyrocketed and significantly threatened its capabilities."]},{"title":"Growing and Mentoring the Afghan National Army","level":2},{"section":["If Americans were exasperated by the problems they faced in building the ANP, they could at least take satisfaction in the ANA, which was developing more or less according to plan. The program called for creating an ANA that could act as the bridge between ISAF and the Afghan po lice. Coalition forces were responsible for engaging with and destroying enemy forces and reducing opposition enclaves to a point at which they could hand over responsibility to the ANA, whose mission was to prevent the enemy from reestablishing a foothold in that area. Once the central government had secured a solid police and governance presence in that region, the ANA would then turn its security responsibilities over to the Afghan police.","However, the ANA’s potential had not been acknowledged at the onset, when the DoD viewed it as a counterbalance to warlord militias rather than a full-fledged counterinsurgency partner. As a result, the nascent Afghan military did not receive sufficient security assistance funding from the start. Although additional dollars were allocated from 2003 onward, the Bush administration remained reluctant to send more trainers, invest in building ministerial capacity, or create a logistics infrastructure. U.S. efforts continued to gain momentum, but the main problem from 2005 to 2008 was not the ANA’s structure, deployment, or ethnic balance but rather its effectiveness against the resurgent Taliban. Battlefield proficiency took time to develop. Even so, compared to the problems affecting the ANP, the ANA remained a bright spot in the effort to build Afghan National Security Forces.","The most positive ANA development from September 2005 to November 2008 resulted from the decision to implement Accelerating Success. That program succeeded in increasing kandak production to the point at which the Ministry of Defense could start building regional corps. In addition to the Kabul Corps, renamed the 201st Sailab (Flood) Corps, the Ministry of Defense had established the 203d Tandar (Thunder) Corps in Paktiya Province, the 205th Atal (Hero) Corps in Kandahar Province, the 207th Zafar (Victory) Corps in Herat Province, and the 209th Shaheen (Falcon) Corps in Balkh Province. These commands continued to grow as the allowable size of the ANA increased from 70,000 to 80,000 in February 2008. The authorized ceiling rose again in September to 122,000.","Each of the ANA’s corps resided in one of the coalition’s regional commands, presenting opportunities for partnered operations. Partnering increased in frequency under Eikenberry and expanded to include coalition forces after McNeill took over ISAF. Including kandaks on operations did not differ tactically from working with warlord militias or early incarnations of Afghan security forces; nonetheless, it had strategic benefit in that it helped legitimize the Afghan national government. Coalition units partnered with Afghan forces “in almost all operations,” letting them take “the lead in about half of them by 2009.”","Embedded Training Teams operating under Task Force PHOENIX became the primary mechanism for overseeing Afghan units in the field. These nineteen-man teams started working with kandaks before graduation and shared their expertise in both garrison and combat duties. Like many jobs in Afghanistan, training-team duty was difficult. Embedded teams served far from U.S. leadership, logistical support, the reach of protective fires, and medical evacuation coverage. They ate, slept, and fought side by side with their Afghan partners, often with limited interactions with or support from coalition maneuver forces. This isolation was not lost on the Taliban, who found the teams to be tempting targets. The training teams were also dangerous to the insurgents, as they had ready access to the freshest and most actionable human intelligence available to non-Afghan forces. Utilizing the information they collected proved challenging, however, as there was no advisory intelligence chain that could receive reports from the field and conduct timely analysis.","Filling these billets proved similarly frustrating. Even after reducing Embedded Training Teams to sixteen soldiers, TF PHOENIX  never received the personnel it needed to meet requirements. The soldiers it did get often were not of the appropriate rank or specialty for the job, or lacked the training or experience to serve as effective mentors. The personnel shortage was serious enough that a 2005 Army study recommended filling officer positions with senior noncommissioned officers, despite Afghan reluctance to interact with coalition advisers of lesser rank. NATO’s assumption of the ISAF mission did not resolve the problem. Although the alliance had a formation to replace training teams—Operational Mentor and Liaison Teams—it experienced the same team staffing and support challenges that U.S. forces did. Larger than the Embedded Training Teams (twenty-five versus sixteen personnel), mentor teams began replacing their American counterparts in May 2006 when a British team started advising the 3d Brigade, 205th Corps, in Helmand Province. Progress was slow: by August 2008, NATO had contributed personnel for only thirty-four of the seventy-one teams deemed necessary to meet ANA training goals.","TF PHOENIX experienced similar difficulties providing sufficient training teams for the 203d Corps in RC East. Because kandaks needed advisers until they were “fully capable of planning, executing and sustaining operations,” they had to be supported by successive training or mentor team rotations. As a result, the ANA required a steadily increasing number of advisers. The 119 teams (71 NATO and 48 U.S.) authorized in summer 2008 were estimated to grow to “125 teams in December 2009, 133 teams in December 2010, 141 teams in December 2011, 159 teams in December 2012, and 168 teams in December 2014.” Given the scarcity of necessary team personnel in 2008, filling the projected 40 percent increase in teams over the next six years would be impossible without a proportional expansion of the international training mission.","As U.S. conventional forces struggled to find the personnel to partner with Afghan security forces, SOF found similar opportunities dwindling. With the disarmament, demobilization, and reintegration process winding down in 2005, SOF units had fewer non-Kabul-sanctioned defense forces with which to conduct counterinsurgency operations. Eikenberry accelerated the SOF transition away from partnering operations by directing CJSOTF−Afghanistan commander Col. Edward M. Reeder Jr. to disband the remaining Afghan militia forces partnered with SOF and position his detachments so as to prevent the Taliban from disrupting the upcoming elections. SOF responded by increasing counterterrorism missions in support of Eikenberry and his priorities but did so with decreasing efficiency as SOF operations depended on intelligence gained from their ANSF partners and the access they provided to local communities.","After analyzing the most effective use of the limited U.S. SOF available in Afghanistan, Special Operations Command Central directed Colonel Reeder to form an Afghan special operations capability. Reeder proposed the creation of Ranger-like, light infantry kandaks. Both 3d Special Forces Group and Special Operations Command Central supported the initiative, which helped develop new Afghan Commando kandaks over the next eight months. American SOF formed these units by selecting 100 soldiers from existing ANA kandaks and sending them to Jordan to receive specialized training. After returning to Afghanistan in March 2007, these soldiers formed the cadre for the first two Commando kandaks. By 16 October 2008, each of the five ANA corps had one Commando kandak consisting of 865 officers and enlisted personnel supporting its operations. Two of these units functioned at partial operational capability, two at initial operational capability, and one had just been formed. Even with the varying capabilities between Commando kandaks, the high standards, constant training, and continued support from Reeder’s command enabled the Afghan Special Forces to become one of the most effective organizations within the Afghan military.","With the addition of the Commando kandaks, the ANA increased to roughly 70,000 trained soldiers by the end of 2008. Of the forty-two infantry kandaks rated in October 2008, seven were deemed capable of planning, executing, and sustaining operations without the support of mentor or training teams. Thirteen more were assessed to be partially operational, meaning that they could plan and support operations but still required guidance from embedded mentors. Overall, roughly 40 percent of the ANA was judged partially or fully capable of conducting operations above the company level independently or with some support. However, a corresponding 60 percent of the ANA still lacked that capability. Considering that the United States had contributed over $10 billion to train and equip the ANA between 2002 and 2008, tremendous work would be needed before the ANA could make good on that investment."]},{"title":"Expanding Development","level":2},{"section":["While ISAF increased efforts to build capable Afghan security forces, it also worked to expedite the Afghan governance capacity. The latter effort continued to be challenging. Even though Provincial Reconstruction Teams continued to invest significant effort into new construction and development projects, they found it difficult to make a fundamental and lasting impact on the Afghan standard of living. Reports from reconstruction teams indicated that agricultural knowledge, which had been passed down orally in a culture with a 10 to 15 percent literacy rate, had vanished as tens of thousands of farmers perished or sought other employment as a result of more than twenty years of conflict. Consequently, U.S. civilian and military leaders developed a concept to deploy soldiers with agricultural expertise and embedded security capabilities to Afghanistan as part of the Agribusiness Development Teams. By improving the agricultural system of a nation in which 80 percent of the population was involved in farming or herding, the program would offer young men a reason not to join the insurgency and also contribute significantly to their communities’ standards of living. Although the new program marked a change in how the coalition interacted with rural Afghans, it built on a concept that the United States had used with success for more than two decades in Central America. All told, the National Guard Bureau sent six teams in support of Combined Joint Task Force 101 (CJTF-101) (which would replace CJTF-82) during the first year of the program.","The first project for the agribusiness teams was to train Afghan government officials how to perform the duties of provincial and district agricultural advisers. Team members then made their presence known to local communities by teaching farmers techniques to provide better care for the fruit trees that the Americans found in almost every Afghan compound they visited. The teams distributed basic tools such as tree saws, grafting knives, and metal buckets filled with two pounds of hydrated lime—all suitably marked “Courtesy of the Afghan government”—to improve the growing conditions for the fruit. Agribusiness Development Teams built upon their initial offering to rural Afghans with lessons on how to care for fruit trees, fertilize soil, and take care of farm animals. Unlike many reconstruction team projects, the agribusiness teams produced sustainable local effects that resulted in long-term gains for Afghans, the ultimate goal for the international development effort."]},{"figure":{"source":"/figures/v2/img_4-4.png","caption":"Soldiers move through poppy fields"}},{"title":"An Interagency Approach","level":2},{"section":["The growing importance of reconstruction within the overall counterinsurgency approach mandated the need for greater interagency coordination at all levels. Provincial Reconstruction Teams continued to serve as the interagency coordinators for individual provinces while the civil affairs cell within brigade combat teams did the same for all of the provinces within its area of operations. An integrated civil-military action group, consisting of senior State Department, U.S. Agency for International Development, and military officers with roles in development, was established within the U.S. embassy in 2008 and met regularly to provide senior decision makers with information and recommendations. The State Department’s Office of the Coordinator of Reconstruction and Stabilization ensured the synergy of the overall effort through planning officers assigned to the embassy, brigades, and reconstruction teams.","The project initiated by the 173d Airborne Brigade staff in Nangarhar Province in 2008 illustrates the benefits of an interagency approach. Nangarhar Inc. brought together U.S. players involved in counterinsurgency, counternarcotics, and long-term development in the province. The brigade staff members thought that providing the local population with economic opportunities would complement ongoing counterinsurgency efforts, as most Taliban members in the province appeared to be motivated less by politics or ideology and more by the need to support themselves and their families. The brigade sought to create a sustainable model rather than rely on short-term projects, but it ran into problems because it received little or no assistance from civilian agencies. In an effort to restart the project, the brigade commander sent eight leaders, including his operations officer, fire support officer, CJTF-82 liaison officer, and representatives from the Nangarhar Provincial Reconstruction Team, to the U.S. Embassy to work with State Department and U.S. development assistance officials on a coordinated economic development plan for the province.","The final version of the plan included a range of projects classified as quick-impact, near-term, and long-range. Quick-impact projects offered Afghan farmers a way out of the opium poppy trade, encouraging them to increase their economic gains by growing alternative crops. Near-term and long-range goals were designed to enable quick-impact projects to realize a profit. Near-term goals involved purchasing portable cold storage units that vendors could use to refrigerate produce before selling it in Pakistan. The high fuel costs of these cold storage units, however, prevented them from being a viable long-term solution. To address this predicament, the 173d Airborne Brigade staff initiated a long-term project to build a series of dams in adjacent Kunar Province that would provide Nangarhar merchants with electricity and improve the storage and transportation options for the local economy. The scope and cost of the long-term project required interagency involvement at all levels because the project fell within the purview of multiple U.S. agencies as well as several Afghan government ministries. The Nangarhar Inc. model demonstrated that multiple agencies could work together to contribute to the overall counterinsurgency effort. It proved so promising that reconstruction teams in Kunar, Laghman, and eastern Nuristan Provinces adopted a similar approach.","Yet even with the success of Nangarhar Inc., the varying capabilities and resources of the different reconstruction teams  made it difficult to replicate this model across all of Afghanistan. ISAF had yet to standardize the Provincial Reconstruction Teams, which complicated attempts to link efforts across provincial lines. The Supreme Allied Commander Europe’s operations plan acknowledged that “a ‘one size fits all’ PRT [Provincial Reconstruction Team] makeup could not be applied to various Afghan provinces,” but it still “connected the ‘desired strategic impact’ to convergence between PRT activities and synchronized movement toward common objectives.” Whether a diverse reconstruction team system truly could achieve stability—while also reflecting a unified effort—remained to be seen. Without that unified effort, the various training, reconstruction, and development teams would become an impediment to the very thing they were trying to achieve: a capable, sustainable Afghan state."]}],"chapter 5":[{"title":"Campaign at the Crossroads"},{"section":["With NATO forces fully engaged across Afghanistan and General Dan K. McNeill aligning, however informally, the American and ISAF efforts, the coalition was approaching the point of maximum effort under economy-of-force resourcing. Secretary of Defense Robert M. Gates’ approval of an additional American brigade had increased the Army’s footprint, but rather than significantly expanding the American campaign, the arriving troops mainly shored up ISAF’s ability to continue to execute its current operations. Even as the situation in Iraq improved as a result of the surge, coalition forces in Afghanistan were working to simply maintain a status quo against an insurgency that showed little signs of abating."]},{"title":"Continuing Issues with Pakistan","level":2},{"section":["Although more American troops were deploying to RC East, their presence exerted limited influence in Pakistan’s adjacent tribal areas. Before the September 2006 peace agreement in North Waziristan, the tribal areas became a collective sanctuary where al-Qaeda terrorists intermingled with the Haqqani family network, Taliban sympathizers, and radicalized tribes such as the Mehsud, and were able to operate with relative impunity. Using funds from various sources, including wealthy private donors from the Arab states in the Persian Gulf region, the militants succeeded in acquiring better weaponry than Pakistan’s Frontier Corps, who nominally were in charge of controlling the border provinces. As one Western official noted, militants “have rockets. They have advanced weapons. And the Frontier Corps has sandals and a bolt-action rifle.” While Washington pressured Islamabad to take more aggressive action in dealing with the militant problem, President George W. Bush acknowledged that controlling the remote mountainous region was difficult, describing it as “wilder than the Wild West.” Even though the Bush administration was under no illusions about the region’s instability, it had given Pakistan $1 billion a year for the past five years and now wanted a return on that investment.","General McNeill, the ISAF commander, remained frustrated with the situation across the border. He had clear evidence of a spike in insurgent attacks in RC East after the Waziristan peace agreement, an increase he logically attributed to the fact that “the Pakistanis quit putting pressure on them.” McNeill recalled the radical jihadist leader Baitullah Mehsud telling a gathering of reporters, “Jihad knows no boundaries. There is no reason why we can’t go to Afghanistan.” Because of the NATO mandate, however, McNeill had limited options in addressing issues with Pakistan. He had no authority to conduct operations across the border and could only affect the situation by improving relations among ISAF forces, Afghans, and Pakistanis. One method of achieving the desired level of unity was the Tripartite Commission, a set of recurring meetings between McNeill, Afghan chief of defense General Bismillah Khan Mohammadi, and Pakistan Army chief of staff General Ahsan Hyat (later replaced by General Ashfaq Kayani). Yet getting the sides to cooperate proved difficult. “There is deep and abiding suspicion between the Pakistanis and the Afghans,” McNeill noted, “and it is not going away anytime soon.”","In an effort to expand the program, Brig. Gen. Joseph L. Votel, the CJTF-82 deputy commander for operations, began coordinating meetings among Afghan, Pakistani, and coalition general officers and senior colonels in early 2007. Votel held these meetings to resolve issues and improve coordination in targeting insurgents traveling across the border. The ultimate goal was to formalize the program with a series of border coordination centers that could bring “Afghans, Paks [Pakistanis], and ISAF, [and] the US, under one roof where they could coordinate activities on a portion of the border.” The program went slowly as long-standing disputes over the location of the border and Pakistan’s previous support of the Taliban created considerable distrust. An incident during a 14 May meeting in Pakistan, in which U.S. Maj. Larry J. Bauguess Jr. was murdered by a Pakistani soldier, amplified American concerns over Islamabad’s ability to deal with the internal threat posed by radical Islamists.","President Pervez Musharraf’s government was slowly recognizing the danger these groups posed. The situation finally exploded in early July when a brigade of Pakistani soldiers surrounded the Lal Masjid (Red Mosque) complex in Islamabad. Activists from the mosque had been increasingly aggressive in enforcing their moral views on the community; in one notable instance, they had kidnapped six Chinese women from a local acupuncture clinic on the charge that it was a brothel. Government forces eventually stepped in and laid siege to the mosque for a week (3–11 July). After a three-day battle that resulted in the deaths of more than one hundred militants, including numerous students, and at least ten Pakistani soldiers, the Pakistani military finally seized the compound.","The assault on the Red Mosque reignited the conflict between Islamic militants and the Musharraf government that had been simmering since the North Waziristan peace treaty. Musharraf declared a renewed commitment to securing the Afghanistan-Pakistan border, and stated, “Extremism and terrorism will be defeated in every corner of the country.” Fazal Hayat, more commonly known by his pseudonym Mullah Fazlullah, one of several radical Islamists energized by the mosque raid, initiated his own revolt against the government that July in the Khiali Valley of the Northwest Frontier Province.","By the fall of 2007, the Pakistan government was in crisis. As militants targeted the Pakistani military and intelligence community, Musharraf began to see his political support crumble. Former political leaders such as Benazir Bhutto and Nawaz Sharif openly challenged his government. Meanwhile, Pakistan’s Supreme Court appeared on the verge of declaring the president’s reelection in October invalid. In the face of internal and external threats to his power, Musharraf declared a state of emergency on 3 November, suspending the country’s constitution, blacking out independent media, and postponing the upcoming parliamentary elections. Amid domestic and international opposition, Musharraf agreed that he would step down as head of the Pakistani Army the day before he took the oath of office for a new five-year term and would hold parliamentary elections in early 2008. Although he remained in office, Musharraf relinquished his influence over the Pakistani military. Pakistan’s political structure was imploding just as the jihadist militancy was threatening to overwhelm the state.","By December 2007, Baitullah Mehsud had increased his political power so much that he could form the Tehrik-i-Taliban Pakistan, as an umbrella group harnessing various Islamist factions fighting against the Islamabad government. Although not formally affiliated with Mullah Mohammed Omar’s Taliban, many Pakistani Taliban commanders and foot soldiers had fought in Afghanistan. Baitullah Mehsud’s forces also benefitted from associations with al-Qaeda, the Haqqani Network, Lashkar-e-Taiba, and other extremists. This convergence of talent and tactics spawned an increase in suicide attacks against the Pakistani state from 56 in 2007 to more than 100 in 2008, resulting in a staggering 461 deaths. When Benazir Bhutto was assassinated at a political rally in Rawalpindi on 27 December 2007, the Pakistani government and CIA blamed militants with ties to Baitullah’s organization and al-Qaeda. Bhutto’s death was a tragic end to a long year in which radical Islamic fundamentalists in Pakistan offered a more direct and severe challenge to Islamabad than to the fledgling Karzai administration. This new focus made it increasingly unlikely that whoever was in power in Islamabad would be able to offer meaningful assistance to the United States, ISAF, or the Afghan government.","${A Shift in the ISAF Effort}{bold}","As Pakistan grew increasingly unstable, TF FURY made progress in the southern zone of RC East. It expanded the coalition footprint, blocked traditional insurgent infiltration routes, and supported the continuing development of ANSF. In Khost Province, Taliban presence declined until it was more nuisance than threat. The TF PROFESSIONALS commander, Lt. Col. Scott D. Custer, thought simple criminal activity was the most prevalent problem. Colonel Custer developed a good working relationship with the provincial governor, Arsallah Jamal, whom he considered an effective leader, and encouraged his unit commanders to establish productive relationships with district leaders.","Other provinces proved less welcoming than Khost. In eastern Paktika and western Ghazni, which Operation MAIWAND had  cleared of insurgents, neither the Afghan government nor TF FURY could prevent the return of terrorist groups. Less than a month after MAIWAND, the Taliban captured and held hostage twenty-three South Korean missionaries who were traveling south of the city of Ghazni. The Taliban accused them of proselytizing, while their church leaders claimed they only were doing relief work. Much to the dismay of the Americans, the Korean government negotiated directly with the Taliban, “acknowledging or promoting the legitimacy of the enemy,” as one American officer put it. Following six weeks of negotiations, during which the captors killed two of the hostages and released two others, the Taliban released the remainder after securing a promise from Seoul to withdraw its 200 troops by the end of the year. Subsequently, U.S. special operators systematically dismantled the kidnappers’ network within six weeks, but the message had been clear: just as they had in Iraq, terrorists could force coalition members to pull out of contested areas.","By summer 2007, the continuing security threat convinced McNeill that ISAF needed to be more aggressive in targeting insurgents. Two months into his tour, he could not get a definitive agreement from coalition members or the Afghan government as to the purpose of Afghan Development Zones. Without a consensus, he abandoned the concept. McNeill believed the zones were too ill-defined to support economic development, especially because security remained so poor. He told one Afghan government official, “We’re not where we need to be in security for these things to have a fair chance to succeed. It’s that simple.”","For McNeill, the problem with the American approach was not a lack of effort, but faulty design. He thought that the continuing instability in RC East warranted shifting the main ISAF effort from the south. Of particular concern was Haqqani infiltration into the Tora Bora cave system in southern Nangarhar, from which the network could interdict the main road between Kabul and Jalalabad. To address this challenge, McNeill transferred his Theater Tactical Force, Lt. Col. Brian J. Mennes’ 1st Battalion, 508th Infantry Regiment, from RC South to RC East in August. The paratroopers in the Theater Tactical Force conducted a relief-in-place with Lt. Col. Jeffrey O. Milhorn’s TF RAPTOR before taking responsibility for Nangarhar Province. They would stand ready as the ISAF reserve, keeping one company and the battalion command element prepared to move within twenty-four hours, with the remainder following within forty-eight to seventy-two hours. The Theater Tactical Force remained in RC East until November, when it returned to RC South to help prepare for winter operations.","${Operation PAMIR HAMKARI (October 2007–March 2008)}{bold}","McNeill’s shift away from the Afghan Development Zone concept required an overhaul of CJTF-82’s campaign plan. Intelligence analysis indicated that insurgent groups were adjusting to the presence of two combat brigades within RC East. Although they were capable of massing when necessary or when the opportunity arose, they were more interested in mounting attacks that generated instability rather than defeating ISAF and Afghan forces. To accomplish this, the various groups increased cooperation, coordinating a two-pronged approach to keep ISAF off balance. They continued attacking Afghan Border Police units, forcing other ISAF forces to respond when necessary. At the same time, insurgents sought to establish positions in provinces surrounding Kabul from which they could mount intimidation campaigns against the residents and direct terror attacks against the Afghan government."]},{"figure":{"source":"/figures/v2/img_5-1.png","caption":"SGT Jonathan Guidry of the 173d Airborne Brigade"}},"To combat these efforts, CJTF-82 developed an operations order to serve as the division’s campaign plan from October 2007 to March 2008. The revised plan shifted CJTF-82’s focus away from the population by aggressively targeting insurgents. Termed Operation PAMIR HAMKARI (MOUNTAIN TEAMWORK), it specified that “the decisive operation will remain with TF FURY and its partnered ANA, ANP, and Afghan Border Police forces. TF BAYONET and TF CINCINNATUS with their Afghan security counterparts will conduct shaping operations to help set conditions for the main effort.” Forces within RC East would maintain pressure along the Pakistan border while continuing to develop ANSF. PAMIR HAMKARI sought to maintain pressure on the insurgents during the fall and winter in order to disrupt their ability to resume operations in 2008. To ensure favorable conditions for the spring 2008 campaign, Maj. Gen. David M. Rodriguez and his planners “concentrate[d] CJTF-82’s finite resources into prioritized districts to reinforce success from Operation OQAB HAMKARI and adjust[ed] to changes in the operational environment.” They continued to frame the division’s approach in the standard three lines of operation (security, governance, and development) but changed the targeted districts to commercial centers and those with critical lines of communications. Notably, Rodriguez’s guidance stated that efforts to reinforce economic successes were “not limited to ADZs [Afghan Development Zones].” This process included identifying essential Afghan leaders who understood the needs of the populace and supported the goals outlined in the Afghan National Development Strategy.",{"figure":{"source":"/figures/m/map-figure-5-2.svg","caption":"Operation PAMIR HAMKARI","prefix":"MAP"}},"In the first phase, the 4th Brigade, 82d Airborne Division, continued its border security and interdiction efforts  in the Burmal and Ster Giyan areas of Paktika Province as supporting efforts while focusing on the Sperah District of Khost Province for the campaign’s main effort. Other maneuver forces would secure six vital districts: Dzadran, Shwak, and Zurmat in Paktiya Province; and Kharwar, Charkh, and Baraki Barak in Logar Province. These districts supported key commercial centers in Gardez and Khost. Disruption operations in several other districts were launched either to maintain ANSF and coalition presence or set conditions for phase two of the operation, scheduled to begin in mid-December.","In the second phase, TF FURY would spread to the districts of Deh Yak and Ghazni in Ghazni Province, Jaghatu in Wardak Province, and Sharan in Paktika Province, while securing critical lines of communications and interdicting border crossings. In this manner, TF FURY sought to take advantage of the anticipated winter lull in insurgent activity to expand security operations and make areas hostile to insurgents when they returned in the spring.","Despite the shift away from development zones and toward key districts and lines of communications, the campaign changed little at the tactical level. Instead, the main changes were geographic and therefore operational. The districts with lower priority were along Afghanistan National Highway 1, while higher-priority districts were generally closer to Kabul. Whether centered on Afghan Development Zones or Kabul, the operational approach for RC East still had to be executed by troops on the ground. Maneuver forces had to separate the enemy from the local population, connect that population to the central government, and transform areas from insurgent safe havens to loyal jurisdictions of the central government. It also did not alter efforts to develop ANSF capacity. Their ability to secure operational areas and connect with the population would be one criterion of future success. But there were limits to what U.S. forces could achieve. Without indigenous security forces providing for the needs of the people, it would be difficult for the national government to attain public support. Absent that support and trust, the Karzai government would continue to compete with the insurgency for legitimate political authority.","${The Challenge for Task Force ROCK}{bold}","For all of CJTF-82’s focus on Gardez and on Khost Province, the soldiers of TF BAYONET in the northern sector of RC East endured some of the heaviest fighting in late 2007 and early 2008. Operation PAMIR HAMKARI called for TF BAYONET and its partnered Afghan forces to “maintain their forward presence,” secure Bihsud and Jalalabad Districts in Nangarhar Province and the city of Asadabad in Kunar Province, continue to interdict cross-border infiltration, and maintain critical lines of communications. Although comprehensive, the effort equated only to a shaping operation for the decisive effort in TF FURY’s sector to the south. As a supporting effort, TF BAYONET did not receive as many enablers (such as aviation support; funding for projects; and intelligence, surveillance, and reconnaissance assets) as available elsewhere.","Nangarhar remained the focus of the TF BAYONET’s economic development, but the Pech River Valley was the greatest challenge to implementing counterinsurgency tactics and gaining the support of the population. As Col. Charles A. Preysler’s battalions distributed companies and platoons, troop levels at key points in the area of operations decreased commensurately, with some outposts held by as few as fifteen to twenty American soldiers, supported by assorted Afghan security personnel. As their units sought to secure areas where U.S. troops had earlier established a presence under far different conditions, some TF BAYONET leaders became concerned that their predecessors had “gone too far, too fast” in establishing bases in the remote valleys in Nuristan. Few units suffered the dangers of dispersion more than Lt. Col. William B. Ostlund’s TF ROCK in the Pech River.","TF ROCK had inherited efforts to build the Pech River Valley politically and economically. To protect these efforts,  Ostlund directed his maneuver companies to maintain combat outposts and patrol in three surrounding valleys. Their goal was to extend security and development into the valleys and tie them to the main effort along the river. The TF ROCK commander recalled:",{"list":["Each platoon went out on two patrols a day, every day, and the intent of nearly every patrol was a non-lethal engagement, checking on a project, meeting with the business people of a village, meeting with the farmers of a village, meeting with the teachers of a village, or meeting with political leaders. It was just shura after shura after shura after shura and with that constant interaction you kind of get it [i.e., understand the population and the environment]."]},"This constant presence gave Ostlund frequent opportunities to assess intelligence coming out of the communities and  reposition forces accordingly. In some instances, this meant pulling back where units were not having the desired influence, or when positions became too difficult to maintain. Such conditions affected two combat outposts in the Waygal Valley: BELLA and RANCH HOUSE. Both were held by less than a platoon and could be supported only by helicopters. Their small size and isolated positions were considered acceptable risks when they were established in 2006. However, while each new outpost increased the ability of Americans to reach Afghan civilians and link them to the government, it also provided another target for the enemy to attack.","The first significant indication of this vulnerability came on 22 August 2007 when a sizable insurgent force led by Hazrat Omar, a reputed al-Qaeda devotee and resident of the nearby village of Arahnas, assaulted Combat Outpost RANCH HOUSE. Having studied the outpost for weeks, Omar had devised a detailed plan that allowed his force to overrun the position before its defenders could mount an effective defense. After penetrating the outer perimeter, the estimated sixty attackers engaged the defenders with hand grenades, not being repulsed until the TF ROCK soldiers called in close air support on their own position. Two Afghan soldiers were killed in the assault, and nearly half of the twenty-two American personnel at the outpost were wounded. Hazrat Omar failed to gain the dramatic victory he so eagerly sought—the assault cost him his life without killing a single American.","The attack forced the Army to reevaluate both outposts’ locations. Delays in constructing a trafficable road up the valley meant that the local population remained largely isolated from the central government. The valley’s residents, who generally did not want a closer relationship with Kabul, grew sympathetic to insurgent groups when the soldiers could not demonstrate the advantages of national governance. The outposts remained accessible only by air, which made them ideal targets for insurgents seeking to control the valley. With the change in circumstances, TF ROCK closed RANCH HOUSE in October and prepared to transfer BELLA to a more suitable position.","Major changes were not limited to ISAF forces. Senior insurgent leaders remained determined to push the Americans out of the valley. With Hazrat Omar dead, they dispatched Mullah Maulawi Mohammed Osman to take up the fight against TF ROCK. Intelligence soon indicated that the insurgents were prioritizing support for Hazrat Omar’s replacement, as Osman busily assembled hundreds of fighters from villages throughout the area in preparation for an attack on BELLA.",{"figure":{"source":"/figures/v2/img_5-2.png","caption":"SFC Kahler and PFC Ayers and PFC Hamby"}},"Unsurprisingly, insurgent attacks increased in the Pech River Valley and the ancillary Watapur and Korangal Valleys as well as the Waygal Valley. The Korangal was of particular concern. Historically, the Korangalis had been antagonistic to outsiders, and they refused to side with the Americans despite the economic and developmental incentives the coalition forces offered. The Pashtun residents resisted American penetration in early 2007 even more strenuously than they had in Nuristan. As the situation in the Korangal failed to improve over the summer, Ostlund authorized company-sized air assaults along a series of ridgelines meant to funnel the enemy into kill zones. These October operations, known as ROCK AVALANCHE, drove enemy fighters toward the southern end of the valley, pushing them away from the area and making it easier to link the valley politically and economically to the rest of the region. The fight proved difficult, as every family compound the Americans faced was a hardened fort difficult to overcome without artillery or air power—a perfect recipe for civilian casualties that caused yet further hostility. Despite significant enemy losses, the local tribal leaders declined to participate in the American plan to secure the valley. In several cases, they sided with the insurgents in opposition to both the Karzai government and its international backers.","Even considering the antagonistic response of some of the Korangalis, Ostlund viewed ROCK AVALANCHE as a success. He noted a sharp decline in American casualties in the valley, dropping from seven killed and twenty-seven wounded in the five months preceding the operation to zero killed and thirteen wounded in the eight months following it. Continual patrolling and aggressive tactics had overcome the lack of resources to make the valley more hospitable to coalition efforts.","Ostlund was overly simplistic in attributing the decline in casualties solely to aggressive operations. Two other factors  contributed to the shift in the operational environment: the decline coincided with the onset of winter, traditionally the offseason for insurgents, and improved tactics reduced the troops’ exposure to dangers. Whatever the case, the reduced number of American casualties in the isolated valleys of Kunar and Nuristan did not signify that the local population had decided to support the Kabul government. Terrorist leaders still found fertile ground for inspiring homegrown insurgents to fight against the U.S.-Afghan coalition in the northern zone of RC East.","The struggle for the valley was indicative of the larger challenge facing American and Afghan units. Their outposts, purposely positioned in steep valleys, often were surrounded by high ground that made them vulnerable to plunging sniper fire, rocket-propelled grenade volleys, mortar attacks, and outright assault. American and Afghan units existed at the front lines of the war, an environment where success usually was measured in enemy body counts. However, these lethal metrics were the opposite of those articulated as critical in counterinsurgency doctrine, which focused on public diplomacy and strengthening relationships. To influence local populations, units had to push into remote valleys. To create security areas in which Provincial Reconstruction Teams and other agencies could engage in development efforts, commanders had to disperse their forces. At the same time, the division and subdivision of units across multiple outposts increased each position’s vulnerability to attack. Balancing the risk of attack against the need to create time and space for the Afghan government was a dangerous undertaking that could have deadly repercussions should the scales shift too far in the insurgents’ favor.","Indeed, ROCK AVALANCHE provided only a temporary respite. On 9 November, a complex ambush near Arahnas resulted in the deaths of six U.S. and three Afghan soldiers. The timing and location of the attack suggested collusion with local tribal leaders. The attack also confirmed that more insurgents had moved into the region, with an estimated one hundred disciplined fighters having taken part in the ambush. In response, battalion and brigade leaders planned to withdraw to a more defensible position closer to the 2d Battalion’s headquarters at Camp Blessing. Negotiations began that fall to establish a new outpost at the village of Wanat, roughly seven kilometers north of Blessing, although it would take nearly ten months before the move could be arranged.",{"title":"2008 Force Rotations","level":2},{"section":["In the spring of 2008, American forces in Afghanistan experienced yet another major force rotation. At the end of their  fifteen-month deployment, the soldiers of TF FURY prepared for their relief by the 4th Brigade Combat Team, 101st Airborne Division (Task Force CURRAHEE) in March. The incoming brigade, commanded by Col. John P. “Pete” Johnson, consisted of its six organic units: Lt. Col. Anthony G. DeMartino’s 1st Battalion, 506th Infantry Regiment (Task Force RED CURRAHEE); Lt. Col. John C. Allred’s 2d Battalion, 506th Infantry Regiment (Task Force WHITE CURRAHEE); 1st Squadron, 61st Cavalry Regiment (Task Force PANTHER) led by Lt. Col. Thomas W. O’Steen; Lt. Col. David J. Ell’s 4th Battalion, 320th Field Artillery Regiment (Task Force GLORY); Lt. Col. Anthony K. “Kirk” Whitson’s 801st Support Battalion (Task Force MOUNTAINEER); and Lt. Col. Charles D. Bradley’s Special Troops Battalion (Task Force STRENGTH). Johnson received welcome augmentation provided by TF PHOENIX in the form of the Illinois Army National Guard’s 1st Battalion, 178th Infantry Regiment, led by Lt. Col. Daniel J. Fuhr.","The incoming brigade took over TF FURY’s operational area, with Allred’s TF WHITE CURRAHEE replacing Colonel Mennes’ TF 1 FURY. The division also sent Col. Jeffrey P. Kelly’s headquarters from the 101st Sustainment Brigade (Task Force LIFELINER), Col. James M. Richardson’s Combat Aviation Brigade, 101st Airborne Division (Task Force DESTINY), and Lt. Col. David L. Dellinger’s Special Troops Battalion, 101st Airborne Division (Task Force GLADIATOR). The division commander, Maj. Gen. Jeffrey J. Schloesser, assumed command of the newly named CJTF-101 in early April.","Following the arrival of TF CURRAHEE, CJTF-101 managed the arrival of additional U.S. forces into Afghanistan. In early March, the 2,500-strong 24th Marine Expeditionary Unit, under Col. Peter Petronzio, deployed to RC South to serve under ISAF command in support of the British in Helmand. In RC East, Col. Scott A. Spellmon’s 1st Maneuver Enhancement Brigade, a newly formed unit activated at Fort Polk on 16 September 2007, took over from TF CINCINNATUS in June. Spellmon’s brigade only brought two of its four assigned battalions to Afghanistan, with the other pair deploying to Iraq at the same time.","The 3d Brigade Combat Team, 1st Infantry Division (Task Force DUKE), led by Col. John M. Spiszer, would follow in June to replace TF BAYONET in northern RC East. Spiszer’s 3,000-plus task force included Lt. Col. Daniel S. Hurlbut’s 2d Battalion, 2d Infantry Regiment (Task Force RAMROD); Lt. Col. Brett C. Jenkinson’s 1st Battalion, 26th Infantry Regiment (Task Force BLUE SPADER); Lt. Col. James C. Markert’s 6th Squadron, 4th Cavalry Regiment (Task Force RAIDER); 1st Battalion, 6th Field Artillery Regiment (Task Force CENTAUR) led by Lt. Col. Salvatore J. Petrovia; Lt. Col. Patrick Daniel’s Special Troops Battalion, 3d Brigade Combat Team (Task Force VALIANT); and Lt. Col. Bradley A. White’s 201st Support Battalion (Task Force SUPPORT). TF DUKE also received Lt. Col. Stephen M. Radulski’s 3d Battalion, 103d Armored Regiment, which deployed as a maneuver force in Laghman Province."]},{"figure":{"source":"/figures/v2/img_5-3.png","caption":"General Schloesser and Admiral Mullen"}},"As with previous rotations, American forces existed within a bifurcated chain of command. CJTF-101 was under the operational  control of ISAF in RC East. At the same time, it had Title 10 responsibilities for American forces in theater as the National Support Element under CENTCOM. As one of two U.S. major generals in Afghanistan, General Schloesser (and his staff) had a challenging relationship with the other two-star U.S. command, Maj. Gen. Robert W. Cone’s CSTC-A. Both reported directly to CENTCOM along the U.S. command chain, but only CJTF-101 fell under ISAF control as a regional battlespace owner. Coordinating the disparate missions of both commands was, as one staff officer phrased it, “spotty.” The missions that these units engaged in, however, remained relatively straightforward. As the RC East headquarters for ISAF, CJTF-101 and its subordinate units conducted full spectrum operations in support of the three standard lines of operation: security, governance, and development. The security transition command, meanwhile, provided training and security force assistance for the Afghan military and police. Complicating this command and control arrangement was the counterterrorist mission pursued by American SOF, which remained largely independent of both ISAF and CSTC-A. In addition to supporting counterterrorism, SOF conducted foreign internal defense in support of the ANSF.","${A New Operational Focus}{bold}","As the CJTF commander, Schloesser revised the ENDURING FREEDOM operational focus while retaining its clear, hold, and build framework. For the security line of operation, he emphasized developing ANSF over securing territory or maintaining freedom of movement for coalition forces. Although earlier deployments had sought to support ANSF development through partnered operations and coordinating with the Pakistani military, General Schloesser made the ANSF the centerpiece of CJTF-101’s rotation. Tactically, he expanded the definition of combat operations to include those operations “in conjunction with ANSF and [the Pakistani military]” launched to disrupt enemy support areas, interdict insurgent lines of communications along the border, and retain freedom of movement along major lines of communications within Afghanistan.","The new campaign followed this changed emphasis. CJTF-101 developed a three-stage campaign built around four lines of effort:  security; governance; development; and information operations, a new but long overdue line. Schloesser added the last line because he felt that insurgent propaganda had been echoed for far too long in Western and regional media without challenge. The first stage, designed to exploit successes achieved by CJTF-82, began with the transfer of authority and was to run through the fall of 2008. Decisive operations during this phase included partnering throughout the regional command. All other efforts were defined as shaping operations.","The campaign’s second stage, beginning in the fall of 2008 and running through early 2009, was to develop “provincial and district-level governance and development to assist in achieving [Afghan National Development Strategy] milestones.” The goal was to take advantage of security gains over the summer and early fall 2008 as well as the anticipated winter lull in the fighting season to improve governance in targeted districts. If these efforts went well, the campaign would transition to the third phase, which consisted of setting conditions “for capable provincial and district governance and successful transition of security for select districts to ANSF” in the spring of 2009 while also preparing RC East for another rotation of U.S. forces.",{"figure":{"source":"/figures/v2/img_5-4a.png","caption":"CWO Sammy Rodriguez, 2d Battalion, 503d Infantry Regiment"}},"This new RC East operational approach, which made ANSF development a primary goal, was the culmination of the efforts that the U.S. and ISAF forces had made over the previous three years. However, it highlighted limitations in CJTF-82’s and CJTF-101’s capabilities. Even with considerable expenditures of American resources, neither task force had sufficient strength to provide localized security throughout the regional command. When asked if CJTF-101’s task organization was adequate to meet its needs, one staff officer replied, “In terms of executing the full spectrum operations mission, it was barely sufficient in some places and completely insufficient in others. The fact that a company out of the division special troops battalion was being employed as foot soldiers in lieu of trained infantry was an indicator of that.”","As in previous deployments, American and Afghan units could clear insurgents from a district, but they did not have enough forces to hold these areas long enough to implement meaningful economic and government-building gains. Even though the insurgents had suffered significant losses during these clearing operations, the insurgency as a whole showed no signs of abating so long as it maintained sanctuaries and a base of operations within Pakistan. Another significant (and almost insurmountable) challenge to ISAF counterinsurgency efforts was the fact that many Afghans viewed the Karzai regime as self-serving and corrupt rather than interested in their well-being. For all its proficiency in combat operations and experience with battling a diverse collection of enemies, the U.S. military was reaching the limits of its operational capability in RC East.","${The Limits of Counterinsurgency}{bold}","U.S. and Afghan forces in RC East’s northern sector, particularly in the valleys that branched off from the Pech River Valley, faced an increasingly strained situation. The paratroopers of TF ROCK had an especially trying experience. Operating out of combat outposts, firebases, and observation posts, the troops endured spartan living conditions, an often indifferent or uncooperative populace, and the country’s most mountainous terrain. As their tour wound to a close in the summer of 2008, TF ROCK soldiers prepared to turn over the battlespace to the incoming TF DUKE. Colonel Ostlund remained particularly concerned about Combat Outpost BELLA in the Waygal Valley. Since the closure of RANCH HOUSE the previous October, Ostlund’s staff had sought to relocate the exposed outpost closer to the battalion’s headquarters at Camp Blessing. Schloesser also wanted to place units where they could most influence the population. After months of negotiating for land, the Americans finally procured a local agreement to construct a vehicle patrol base in the village of Wanat. Located seven kilometers from Camp Blessing, it was home to the district governor and police chief and was accessible by road, rather than air only. From there, the battalion could hold the entrance to the Pech River Valley from the Waygal Valley.","CJTF-101 approved TF ROCK’s realignment in the Waygal Valley in late June 2008. Although TF ROCK was in the final weeks of its deployment, Schloesser and his headquarters determined that the unit with the most Afghan experience should execute the operation, as opposed to assigning it to the newly arriving TF DUKE. TF ROCK soldiers had fought forty-eight engagements with insurgents during their fourteen-month deployment. As one analysis put it, “The soldiers of TF ROCK knew how the insurgents fought, they understood their tactics and how they preferred to employ their weapons, and they respected the [anti-Afghan forces] as tough, determined, committed, and skilled fighters.” The soldiers also understood the urgency of the movement, having suffered an attack on Combat Outpost BELLA on 4 July and read reports that the insurgents were massing in anticipation of a more determined assault.","The move from Combat Outpost BELLA to Wanat began on 8 July. Supplies were airlifted out of BELLA, and members of Company C, 2d Battalion, 503d Infantry Regiment, conducted a ground assault convoy from Camp Blessing to Wanat. This position would become Vehicle Patrol Base KAHLER, named after one of the unit’s platoon sergeants who had been killed earlier in the deployment. Over the next several days, the paratroopers worked to construct the outpost, but were hampered by delays in getting heavy equipment to the position. They established the outpost’s basic perimeter, set up defensive positions, and constructed an observation post above the main base for additional protection. Given their experience over the previous year, the soldiers did not expect the insurgents to immediately launch a large attack. What the Americans did not realize, however, was that the move to Wanat forestalled a massive coordinated assault against BELLA organized by Mullah Maulawi Mohammed Osman. Rather than abandon his plan to overrun an ISAF base, the insurgent leader simply redirected his fighters toward Wanat. Within four days, he had assembled between 120 and 300 fighters ready to attack the platoon constructing the outpost.","Insurgent forces launched a blistering attack on Wanat on the night of 13 July. The initial volley of rocket-propelled grenades targeted the base’s heavy weapon systems, disabling a tube-launched, optically tracked wire-guided missile launcher and the outpost’s 120-mm. mortar pit. The attackers also targeted the vulnerable observation post, which was occupied by a squad whose machine guns would be disabled over the course of the battle. The topography enabled the insurgents to approach within hand-grenade distance of the observation post before the attack, and they were able to breach its perimeter briefly during the assault. The fierce battle lasted for hours before the insurgents broke off in the face of repeated attacks by close air support and AH–64 Apaches. In total, nine Americans were killed, most either defending the observation post or trying to reinforce it, and another twenty-seven were wounded. Four of the twenty-four ANA soldiers positioned to the south were also wounded.",{"figure":{"source":"/figures/m/map-figure-5-6.svg","caption":"Battle of Wanat","prefix":"MAP"}},"","","The 13 July attack at Wanat reflected the limitations of American operations in RC East. Investigations indicated that members of the local population, including the district governor and police chief, were complicit in the attack. Ostlund later contended that the Waygal Valley had been a significant challenge to his forces throughout their deployment, and stated that “no matter what we did we were just not effective.” Counterinsurgency operations failed when faced with an insurgent force with a strong support base across the border, an intransigent population that was hostile to any incursion into the valley by either the Americans or Afghan security forces, and terrain that made any forward position susceptible to harassing fire and coordinated attack. Schloesser determined that maintaining forces within the Waygal Valley did not justify the risks of doing so. TF DUKE soon abandoned the outpost and launched patrols into the valley from the more defensible Camp Blessing.",{"title":"The Ongoing Fight in RC South","level":2},{"section":["McNeill had originally shifted the ISAF main effort to RC East in 2007 because he wanted to free the southern portion of shadow governments and open lines of communications into the region. This move, however, did not mean that the Taliban’s main effort had transitioned to the region. After being battered by coalition forces in 2006, the Taliban adjusted its operational approach in RC South. It avoided massing in areas that could be cleared by large-scale coalition operations such as mEdusa. Instead, it worked to build its presence in northern Helmand while preparing for a more concerted effort against Kandahar City. Thus, insurgent activity in RC East remained a shaping operation designed to keep the American forces occupied and separate the region from RC South, where the Taliban sought to reestablish control.","The acceleration of insurgent and terrorist activity in RC South since the beginning of the Taliban’s 2006 efforts placed increasing pressure on local governments and security forces, many of which consisted primarily of local warlord forces. ISAF efforts to root out insurgent groups exposed the extent of extremist penetration. Coalition forces would need to do more than merely identify and engage with the enemy, they had to follow tactical successes with aid, jobs, governance, and rule-of-law reforms. Even if U.S. and ISAF operations managed to unveil and dislodge those in the employ of the Taliban, it still would be difficult to maintain the gains without the successful integration of Afghan governance. As a result, the intensified fighting in 2007 did not fatally wound the Taliban, and it remained a viable alternative to the Karzai administration’s incomplete, underresourced, and often unpopular district governments. The 2008 campaign would be the toughest and bloodiest since the conflict began, as coalition fatalities rose from 130 in 2006 to 263 in 2008. Nearly 60 percent of these casualties were caused by IEDs, showing the insurgents’ increased aggressiveness and sophistication in using this tactic.","Growing violence drove ISAF to focus nearly exclusively on security, even though the Taliban sought goals that were more political than military. In general, the Taliban’s military operations—or the mere threat of violence— wanted to expand the group’s political and economic influence, not necessarily to defeat ISAF and government forces in open battle. It was a war of wills in which ISAF, foreign leaders, nongovernmental aid organizations, and the Afghan people all were being led to the conclusion that only a settlement with the Taliban would provide peace and stability. Several polls of ordinary Afghans suggested that the Taliban and other Islamist fighters were achieving these objectives, even if the insurgency did not control entire districts or provinces.","The one area where the Taliban took aggressive moves to seize territory was in northern Helmand. After negotiating a cease-fire with the British in Musa Qal’ah, the Taliban began rebuilding its operational base there. In early 2007, fully reconstituted, the insurgents seized control of Musa Qal’ah. The British responded by announcing that 12 Mechanized Brigade would deploy to Helmand in April. In addition to the 6,300 troops in the brigade, the British committed an additional 1,400 soldiers to the campaign, bringing their force level in Helmand to 7,700, doubling their initial deployment in 2006. With the support of Canadian and American forces (especially TF 1 FURY operating as the ISAF Theater Tactical Force), the British launched Operation ACHILLES in April to clear the Taliban from northern Helmand. Although they recaptured Musa Qal’ah in December 2007, the British still did not have sufficient forces to prevent the eventual return of the Taliban. Focusing on northern Helmand also meant that the southern half of the province lay largely unprotected, enabling the Taliban to establish a presence there."]},{"figure":{"source":"/figures/v2/img_5-4b.png","caption":"British Royal Air Force"}},"British struggles in Helmand convinced the Bush administration that it needed to aid its closest NATO ally. In January 2008, it announced that the U.S. Marine Corps would send Lt. Col. Richard D. Hall’s 2d Battalion, 7th Marines (Reinforced), and Colonel Petronzio’s 24th Marine Expeditionary Unit (Special Operations Capable) to Helmand in the spring. The arrival of the marines considerably increased the coalition’s combat power in Helmand. The 24th consisted of a 1,200-strong reinforced infantry battalion (1st Battalion, 6th Marines), an artillery battery, six AV–8B Harrier fighter aircraft, eight AH–1W attack helicopters, and air and ground support assets. The 2d Battalion, 7th Marines, would serve as police trainers and mentors while the 24th Marine Expeditionary Unit provided security. Soon after establishing a position in southern Helmand, the marines launched an aggressive campaign to secure the Garm Ser District.","The Taliban continued operations in Helmand even with additional coalition forces arrayed against them. Significant numbers of enemy fighters were sent to the province for a counteroffensive called Operation EBRAT (Lesson) designed to secure lines of communications, exert influence over the drug trade, and promote the Taliban’s political authority in the verdant riverine communities. On 11 October 2008, a Taliban force estimated at 150 to 200 fighters attacked the provincial capital of Lashkar Gah. Although more than sixty insurgents were killed in the four-hour fight, the assault proved the enemy remained capable of threatening a provincial capital. Other operations consolidated the Taliban’s grip along a belt of territory stretching from Nawah-ye Barkaza’i District to Nad ‘Ali District and along the Helmand River to Girishk and Sangin. More importantly, the Taliban’s brazenness demonstrated that the coalition and government could not keep the insurgent group from controlling huge swaths of the province.","Although the fighting in Helmand was intense, it was not the main effort for the Taliban in RC South. Their primary focus was to isolate and then seize Kandahar City. Coalition troops’ clearing operations interrupted the Taliban’s efforts to establish shadow governments in the Zharey and Panjwa’i Districts. Although ISAF initiated these operations for good reasons, and the operations had good effects, by dedicating combat forces in these districts, ISAF was unable to maintain an effective troop presence in the province’s northern regions.","Beginning in late 2007, the Taliban sought to use the heavily vegetated Arghandab District as a base for operations throughout adjacent areas. From there, Taliban fighters infiltrated the suburbs of Kandahar City. Canadian forces, still representing the main ISAF contingent in the province, were unable to prevent this infiltration. By the end of 2008, insurgents virtually surrounded the city, controlling the northern, southern, and western districts from which they could project influence, political coercion, and military cells. To the east, Afghan Border Police Commander Abdul Raziq, with a force of about 400 followers aided by U.S. SOF based in Spin Boldak, controlled the road from the border to Kandahar City and kept the surrounding regions from falling to the Taliban. Without his presence and influence, Kandahar City would have been completely surrounded.","As the Taliban advanced, the Canadians realized they needed help defending Kandahar. In January 2008, an independent Canadian government panel recommended that the nation’s contribution to ISAF continue beyond its scheduled termination date in February 2009. The panel’s suggestion was contingent on an additional battle group of 1,000 soldiers from NATO or another ally deploying to Kandahar. A stunning example of the need for better security in Kandahar came on 13 June 2008, when a complex attack on Sarposa Prison freed some 1,000 prisoners, 400 of whom were Taliban captives, including a number of midlevel commanders. Insurgents used suicide bombers to blow holes in the front and back walls of the prison before launching a ground assault and evacuating the prisoners in a disciplined fashion. Waiting buses transported the escapees out of the city. It was a spectacular propaganda coup with tangible results. Two days later, Taliban fighters surged into the Arghandab District in another sophisticated assault that cowed the local population and began a palpable turn away from the government and ISAF forces. The Taliban was now poised to recapture Kandahar City.","By the end of 2008, Kandahar City and its surrounding environs had become the front line in the Taliban’s war against the Karzai government and ISAF. The attack on Sarposa Prison, coupled with the Taliban’s continued offensive in Arghandab, marked a critical point in the battle for Kandahar Province. With the operational initiative, the Taliban began to project military cadres into Kandahar City. A Taliban spokesman announced the deployment of the Khalid ibn bin-Walid suicide bombing cell to Kandahar specifically to target government leaders and police commanders. Several police districts came under direct attack, killing some officers and prompting many more to flee. This initial foray enabled the Taliban to move intelligence agents, large caches of weapons, and multiple fighting cells into the city.",{"figure":{"source":"/figures/v2/img_5-5.png","caption":"General McKiernan welcomes Defense Secretary Gates"}},"After the Taliban established a large vehicle-borne IED construction and staging center, their explosive devices blew up vehicles in the city center on a weekly basis. As Kandahar teetered on the brink, the United States sent additional forces to support the Canadians. In August 2008, CJTF-101 dispatched Colonel Hurlbut’s 2d Battalion, 2d Infantry Regiment, from TF DUKE for service under the Canadian command in Kandahar. Without ready-made positions or a logistical structure, the American battalion had to devote a considerable period of time establishing itself before conducting full-scale operations in support of its NATO ally. Even with the additional support, the Canadians struggled to stabilize the city. Unable to project force everywhere, they failed to prevent the villages of Nakhune and Bilanday, near the city’s southeastern suburbs, from becoming home to Taliban IED factories, safe houses, weapons caches, and field hospitals.",{"title":"McKiernan Takes Command","level":2},{"section":["The worsening situation around Kandahar City would become the responsibility of a new American officer as General David D. McKiernan replaced McNeill as the commander of NATO ISAF on 3 June 2008. Although known for his command of the land forces that invaded Iraq in 2003, McKiernan developed an appreciation for the situation in Kabul and in RC East while serving as commander of U.S. Army Europe and Seventh Army. His understanding of RCs North, West, and South was more limited, but improved as he took the opportunity to assess the situation more closely. On the ground, RC East continued to be a hotbed of enemy activity as CJTF-101 efforts to build the ANSF and bring security to targeted districts were hampered by command and control relationships so complex and geographically stretched that they nearly brought the division to its breaking point. McKiernan recognized that CJTF-101 was operating at, or beyond, its capacity. One of his first initiatives, therefore, was to bring a greater order to the overall campaign. He believed that dividing command and control for U.S. forces between U.S. and NATO command chains was unwieldy, and that the overall ISAF campaign lacked unity of effort and unity of command. As he would state, “in reality, the regional campaigns were all operating to different drumbeats, and a lot of those dictated by the drum being played back in national capitals.” McKiernan was particularly concerned with RC South, where he felt “there were really four different campaigns going on.” He wanted to align the various efforts under a single commander who would articulate a unified strategy and vision. On the U.S. side, this meant breaking down the division between the U.S. and NATO command chains. In response, the new ISAF commander and his staff launched an initiative to create a new headquarters, known as United States Forces–Afghanistan (USFOR-A). Established in October 2008, the headquarters was designed as a Title 10 coordinating headquarters, not one that would give operational guidance, which McKiernan would provide. In particular, USFOR-A would “coordinate the funding, resourcing, and activities on the U.S. side to meet and support that one intent, that one command and one strategy.” The new headquarters would take a heavy burden off of the RC East commander. McKiernan would spend the rest of his command trying to align the coalition to this comprehensive approach.","From the moment he arrived in Afghanistan, McKiernan understood that “whatever the strategy had been, was, and might be in the future, whatever azimuth changes, it was an under-resourced strategy.” Officials in Washington also were noting the dearth of resources available in Afghanistan and its impact on the campaign. In September 2008, Chairman of the Joint Chiefs of Staff Admiral Michael G. Mullen told Congress that, “I would say success in Iraq means we are steadily reducing our commitment for the theater. . . . At the same time, we are able, under those circumstances, to increase our commitment and resources to Afghanistan.” Unfortunately for senior U.S. defense officials, increases in troops, funding, and national assets remained tied to developments in Iraq. CENTCOM had already developed a request for forces in Afghanistan, asking the joint staff for more than 3,000 personnel to assist in training Afghan security forces (primarily the police). With American forces stretched to the limit between Iraq and Afghanistan, the request went unfilled.","The need for more forces in Afghanistan remained, and McKiernan continued to press for more resources. In the fall of 2008, President Bush approved an additional brigade for RC East and some additional forces for RC South. McKiernan received support when a new National Security Council study on Afghanistan, directed by Army Lt. Gen. Douglas E. Lute, also recommended pursuing counterinsurgency over counterterrorism efforts in Afghanistan, a modification which would entail significantly more resources. Bush, however, decided not to authorize additional forces so as to give President-elect Barack H. Obama as many options as possible when he took office in January 2009."]},{"figure":{"source":"/figures/m/map-figure-5-m.svg","caption":"National Commands 2008","prefix":"MAP"}},{"title":"Troop to Task Overmatch","level":2},{"section":["By the time General McKiernan took command of ISAF, U.S. and coalition forces had spent six years working to build a functioning Afghan state that had the support of the population. For the majority of that time, Americans were working to implement a counterinsurgency approach that could degrade the enemy and provide Afghans the time and space necessary to develop their own capabilities. Despite the effort expended, the goal remained elusive in large part because sufficient numbers of troops had never been allocated to achieve those objectives.","The Afghan central government needed to function well and serve the Afghan people to gain their support. Government agencies and security forces needed to develop organizations from a population that had lost human capital through more than twenty years of warfare, strife, and divisiveness. No simple solution or singular area of focus linked the people and government. It required a comprehensive approach, which was exceedingly difficult to achieve.","For the U.S. Army, success in Afghanistan remained indelibly linked to providing security, governance, and reconstruction. Between 2005 and 2008, the United States contributed considerable resources to providing security in Afghanistan and enabling Afghans to sustain that security for themselves. Progress was slow. The Afghan police, unable to enforce the law, remained years behind the Afghan Army in terms of capabilities. The Afghan legal system was even further behind and could not provide the public with a sense of fair and impartial justice in a society in which personal honor was of critical importance. The United States and the coalition needed more time and additional resources to train, advise, and assist the expanding ANSF. To that end, McKiernan requested in late 2008 that CSTC-A be doubled in size, effectively growing it to two brigades.","Although the presence of more personnel would help Afghans provide for their own security, it was not the only need. Like building the ANSF, the U.S. military’s approach toward reconstruction had evolved significantly from 2006 to 2008. Recognizing that many Afghans supported the Taliban out of a sheer lack of alternatives, U.S. commanders viewed economic development and reconstruction projects as important tools in their fight against the enemy. Rather than sustain past practices where local authorities had little say in reconstruction projects, Provincial Reconstruction Teams and brigade combat teams invested time and effort to ensure Afghan involvement and to counter Taliban efforts to disenfranchise tribal leaders in contested provinces. As a result, local initiatives assumed as great an importance to the overall success of the reconstruction effort as national-level projects had previously. Evolving battlefield dynamics proved the worth of the reconstruction teams while also serving to convince brigade and battalion commanders of the importance of using all available tools—including reconstruction and economic development—in the fight against the Taliban."]},{"title":"SECTION I Conclusion","level":2},"Between Afghanistan’s National Assembly and provincial council elections in September 2005 and the end of 2008, Operation ENDURING FREEDOM was in a state of constant change. Throughout the three-and-a-half-year period, U.S. policymakers relegated the intervention in Afghanistan to an economy-of-force effort. Although troop commitments fluctuated, and were rising at the end of 2008, total numbers paled in comparison to those committed to Operation IRAQI FREEDOM. With the deterioration of the situation in Iraq in 2006, the George W. Bush administration sought to transition primary responsibility for Afghanistan to NATO. However, disparate views between coalition members as to mission requirements resulted in a lack of unity of effort within ISAF and between ISAF and Operation ENDURING FREEDOM. A renewed insurgency by the Taliban and its allied organizations exacerbated this deficiency within the coalition. In effect, between 2005 and 2008 the United States and NATO ceded the operational initiative to the insurgents. As the coalition struggled with internal issues and varied approaches to Afghanistan, by 2008 the entire mission faced the possibility of strategic failure.","The primary demand on the Army during this period was the need to provide sufficient resources for simultaneous operations in Iraq and Afghanistan. Efforts to grow the Army—and to deal with the causes and effects of stress on the armed forces—made it possible to source and sustain a surge of troops in Iraq beginning in 2007 while maintaining a limited presence in Afghanistan. Without these initiatives, senior leaders believed the force as a whole risked being broken. Modularity was one effort to find efficiency in force structure that would enable the Army to do more with less. However, in addition to its detrimental effect on the Field Artillery, among other branches, modularity nearly eliminated the Air Defense Artillery branch. Less visible changes affected the health, discipline, accountability, training, and teamwork of the force. Fifteen-month deployments and the overuse of National Guard and Army Reserve forces were coping strategies for an Army too small for its assigned missions. Recruiting, promotion, accountability, assignment, and training shortcuts also sacrificed long-term capacities for short-term needs.","Beyond the larger problems of Army doctrine, efforts to strengthen the service’s force structure, force design, readiness initiatives, and myriad smaller programs proved that the Army could be agile and adaptable to human and cultural dimensions of the fight. Army leaders inculcated the force into similar environments via new training models created at home stations and at combat training centers. To ensure that soldiers were fully prepared for their upcoming deployments, units rotating through the combat training centers were judged on unit readiness instead of the old model of leader development. Other efforts encompassed training in anthropology, languages, professional readings, studies of the Soviet experience in Afghanistan, and more. The Army established Red Team University to teach members of an organization to challenge itself by assuming an adversarial role or point of view, forcing unit leaders to think differently. All of this contributed to a better prepared and more critically thinking Army.","Even so, the growth of the Army still did not solve all readiness issues, especially in the area of training. Because of time constraints before deployment, soldier training focused intensely on counterinsurgency missions, causing proficiency in combined-arms warfare to atrophy. These skills would not fully recover until the drawdown from both Iraq and Afghanistan. Moreover, despite improvements, the Army would face training and personnel readiness issues for years to come.","For U.S. forces in Afghanistan, the 2005 elections marked the nominal culmination of the Bonn Process begun in 2002. The establishment of a new Afghan government under President Hamid Karzai was meant to mark the end of Taliban rule and the emergence of Afghanistan as a burgeoning democracy that would no longer support and harbor international terrorist organizations such as al-Qaeda. However, the question remained open as to who would provide security as the Afghan state developed and stabilized. The ANSF was not yet ready to take on that responsibility, despite significant strides in building the ANA and the beginnings of a more comprehensive training program for the police. With its growing commitments in Iraq, the United States was incapable of providing additional military resources to adequately secure the country. Responsibility therefore fell to the NATO-resourced ISAF. NATO members saw operations in Afghanistan—the first deployment of alliance forces outside of Europe—as a means to maintain relevancy in a post–Cold War environment. Most alliance members, however, did not envision providing significant forces to establish and maintain security, but rather planned to conduct peacekeeping operations until the ANSF could stand up.","The emergence of an aggressive, multifaceted insurgency in 2006 that targeted various coalition elements fundamentally altered the operational environment in Afghanistan. American and coalition leadership had to react to the changing situation on the ground rather than initiating a more unified coalition effort. For most of 2006, Lt. Gen. Karl W. Eikenberry’s CFC-A worked to finalize the transition to NATO ISAF under the command of British Lt. Gen. David J. Richards despite rising insurgent attacks, particularly in RC South. When General Dan K. McNeill took over command of ISAF in early 2007, he sought to implement a more aggressive approach to battling the growing insurgency. However, a lack of unity of effort and unity of command within NATO ISAF, as evidenced by operational restrictions dictated by national caveats, limited his effectiveness throughout his eighteen-month deployment. Inefficiencies between American forces in ISAF and ENDURING FREEDOM, as seen with competing American command chains operating in theater, further hindered American operations. His successor, General David D. McKiernan, spent the latter half of 2008 working to unify American and coalition efforts through the establishment of USFOR-A. Although successful, the time that passed between the end of the Bonn Process and the firm establishment of NATO ISAF under American leadership enabled the various allied insurgent groups to solidify their presence in Afghanistan’s southern and eastern provinces.","However, even though the Taliban in RC South and the Haqqani Network in the southern and HIG in the northern parts of RC East mounted vigorous opposition, their activity was not the key impediment to American or ISAF goals. Local counterinsurgency successes after the Bonn Process attest to the ability of Afghan, American, and ISAF forces to exert positive influence. In particular, Nangarhar Inc. and the Kapisa portion of Operation MOUNTAIN EAGLE improved stability through increased security operations and economic development, while Operations MAIWAND and MEDUSA established prototypes for effective partnered operations at the brigade level. As these operations indicate, adequate resources devoted to counterinsurgency could increase popular support for the Afghan central government. Nonetheless, insufficient resources prevented theater commanders from focusing on multiple regions at the same time while separate U.S. and ISAF decisions to expand their respective operational footprints—without effective coordination—exacerbated the overall lack of resources.","The coalition forces had good reasons to enlarge their presence in RC South and RC East. In RC South, Helmand Province was the largest source of poppy production in the world, and Kandahar City was the ancestral home of the Pashtuns, the Taliban’s main base of support. RC East, the staging base for HIG and the Haqqani Network, was the primary crossing point into Pakistan where insurgent groups established their operational bases. Neither region necessarily took precedence as each was vital to coalition and Afghan long-term objectives. However, limited resources made it difficult to sustain concurrent efforts to extend coalition influence in southern and northeastern RC East, while also expanding into the rural interior of Helmand and Kandahar Provinces. Without a common enemy and conducted in separate areas, one operation could not necessarily be made to support or shape the other. Maj. Gen. Benjamin C. Freakley was forced to shift American units between the two regional commands in 2006, interrupting the implementation of his campaign plan and forcing some units to curtail their activities while the main effort resided elsewhere. A few months into his command, General McNeill sought to mitigate this problem by establishing one region as his priority, but it instead reflected a continuation of American and NATO forces having to emphasize one region over another. Successive theater commanders found ways to integrate the capabilities of member nations in an effort to align the campaigns, but were continually constrained by a lack of coalition consensus on what the problem in Afghanistan was and how best to solve it. Meanwhile, domestic extremism in Pakistan forced Islamabad to turn its attention away from Afghanistan, which undermined the work of the coalition. The continued existence of insurgent sanctuaries in Pakistan enabled the enemy to sustain activities in both RC South and RC East while the coalition shifted focus between the two.","From a strategic perspective, throughout this period the United States maintained a consistent goal of creating a secure and stable Afghanistan capable of preventing the return of international terrorist groups. What changed were the forces acting in opposition to this objective. Instability and corruption within the Karzai government, coupled with the continued division of the population along religious, ethnic, and tribal lines, undercut coalition efforts to build up popular support for the central government. The slow development of the ANSF forced the coalition to take on far greater responsibility for local and regional security than initially intended by either the United States or the troop-contributing members of NATO. As coalition forces spread out among the population to the greatest extent possible, they became wedded to the terrain they tried to hold. Company, battalion, and brigade commanders were forced to accept tactical risk to cover as much of the ground and the local population as possible, making their units more vulnerable. This increased vulnerability became an opportunity for insurgent operations, where the Taliban propaganda machine could spin any casualty-producing attack into a strategic victory regardless of the large insurgent losses.","Thus by 2008, the challenges facing Operation ENDURING FREEDOM appeared significantly greater than they had been three years earlier. In April, an assassination attempt on President Hamid Karzai killed numerous high-level officials attending the Afghan Victory Day parade in Kabul. In June, attacks on Kandahar City culminated in a breakout at the Sarposa Prison that freed hundreds of suspected Taliban fighters. The following month, an assault on an American platoon and its ANA reinforcements at Wanat in the Waygal Valley upset the coalition’s influence campaign in RC East. Meanwhile, the bombing of the Indian Embassy in Karachi signaled increasing instability in Pakistan, which required a more aggressive stance by the United States. All signs pointed to the fact that the U.S. political and military leadership faced a fundamental disconnect of ends, ways, and means in regard to Afghanistan. The deteriorating security environment prompted the Bush administration to consider McKiernan’s recommendations for troop increases. With the fight in Iraq largely stabilized by the summer of 2008, the administration could undertake a comprehensive reassessment of its strategic objectives and commitment of resources in Afghanistan. The election of a new president in November, however, meant that whatever course the United States and its Army pursued would be in the hands of a new administration."],"section Ii":[{"title":"THE SURGE IN AFGHANISTAN"},{"picture":{"source":"/figures/v2/art_sII-1.png","caption":"Engaging the People"}},"President Barack H. Obama took office on 20 January 2009 having pledged to end the war in Iraq and defeat al-Qaeda in Afghanistan. The two conflicts were going in opposite directions. The surge was complete in Iraq and violence was down significantly. President George W. Bush had signed a Status of Forces Agreement with the Iraqi government to withdraw the nearly 150,000 U.S. troops in country by the end of 2011. Afghanistan, meanwhile, remained an economy-of-force mission, with 30,000 troops fighting a resurgent Taliban. Although General David D. McKiernan, the senior U.S. commander in Afghanistan, had requested additional forces, President Bush only partially fulfilled the request, so as not to handicap the next administration.","Security in Afghanistan had been deteriorating since 2006. The ensuing years had been the most violent for the coalition and U.S. Army since the conflict began in late 2001. In 2007, there had been 771 U.S. battle casualties of whom 78 were killed in action, and in 2008, there had been 663 total casualties including 97 killed in action. For the U.S. Army, 2007 and 2008 experienced a near doubling of the casualties from 2006 (373 casualties, 62 killed), or about two-thirds of the combined total for 2001–2005 (555 casualties, 97 killed). By late 2008, there were more IED and small-arms attacks per month in Afghanistan than in Iraq. This alarming trend showed no sign of reversing, suggesting that the number of Americans killed or wounded in Afghanistan would soon surpass the number of killed or wounded in Iraq for the first time in 2009. While the Joint Staff had begun investigating options for shifting troops from Iraq to Afghanistan as early as May 2008, prior to that date no one had suggested that the situation had reached a point at which the current national strategy in Afghanistan needed to be reexamined.","That situation changed between late 2008 and 2011, during what would come to be known as the surge in Afghanistan. The surge resulted from three discrete decisions—one by Bush and two by Obama—to deploy more forces to Afghanistan. By the end of 2011, 80,000 of the 106,000 U.S. service members deployed in support of Operation Enduring Freedom would be Army personnel, representing more than half of the 140,000 troops deployed from all services and troop-contributing nations. For both administrations, the decision to surge came at the end of intensive and sometimes contentious strategic reviews.","This section covers the surge, focusing on RC South. It reviews the events that occurred during the  successive tenures of three senior American commanders: General David D. McKiernan, June 2008–May 2009; General Stanley A. McChrystal, June 2009–May 2010; and General David H. Petraeus, May 2010–August 2011. The McKiernan section explains the decision-making process behind the surge in Afghanistan, the shift toward a counterinsurgency approach, and the abrupt end to his command. The McChrystal chapter details the campaign pursued and events experienced by McKiernan’s successor, dealing specifically with how additional troops were deployed in RC South, Phase II of Operation Moshtarak (Together), and the changes McChrystal made in how the conflict was fought. The Petraeus section includes Phase III of Operation Moshtarak, fought in and around Kandahar City. The section ends with analysis of the surge, civilian participation, and contributions of Special Forces.","When General McKiernan took command of ISAF on 3 June 2008, the U.S. Army had more than 250,000 soldiers serving across the globe with more than 140,000 of those troops deployed in combat zones. Almost 25 percent of the Army’s total 1,097,050 officers and enlisted personnel were serving outside the continental United States. The active component numbered 539,675, reflecting an increase of 21,982 compared to the previous year. The Army National Guard stood at 360,351, and the Army Reserve numbered 197,024, with these organizations experiencing growth of 7,644 and 7,142 personnel respectively.","The soldiers making up the Army’s ranks were now far more seasoned than their Cold War–era predecessors. From 11 September 2001 to April 2009, a million soldiers from all components completed combat tours, with almost 40 percent of active and 30 percent of reserve personnel deploying two or more times. By fall 2009, soldiers accounted for 70 percent of the nearly 5,300 combat deaths. Despite the high probability of a soldier seeing combat, all three components exceeded not only their recruiting goals but also their enlisted retention targets during 2008, which resulted in nearly 300,000 personnel either enlisting or choosing to remain in the military during the seventh year of the Global War on Terrorism.","The Army’s recruiting and retention success made it possible to begin filling the tens of thousands of additional personnel spaces approved by Secretary of Defense Robert M. Gates in early 2007. Many of these personnel were used to fill six new active component infantry brigade combat teams, two of which began forming in 2008. Others were allocated to eight new active component sustainment brigades, bringing the Army-wide total to 76 brigade combat teams and 225 support brigades. In addition to creating new units, the process of converting existing organizations to the new modular design continued, with 85 percent of the Army having converted by the end of 2008. Considerable resources also went into managing the Army’s equipment fleet, as soldiers were using tanks, infantry fighting vehicles, and helicopters at a rate five times greater than programmed. As a result, the Army refurbished almost 125,000 pieces of equipment and issued nearly one million new items; including 6,500 MRAP vehicles, during 2008.","In addition to the unrelenting press of wartime operations, the Army experienced major internal turbulence  as congressionally mandated Base Realignment and Closure (BRAC) moves took place. Tens of thousands of soldiers and dozens of military installations at home and abroad were affected. Major relocations included the removal of two heavy divisions from Germany: the 1st Armored Division taking up residence at Fort Bliss, Texas, and the 1st Infantry Division, split between Fort Riley, Kansas, and Fort Knox, Kentucky. In addition, the 7th Special Forces Group relocated from Fort Bragg, North Carolina, to Eglin Air Force Base, Florida. None of the units taking part in the realignment process were eligible to send troops to Afghanistan or Iraq, which meant organizations unaffected by BRAC would carry the combat load.","${An Uncertain Way Forward}{bold}","The close of the 2008 fighting season pointed to a grim future for the U.S.-led coalition in Afghanistan. The coalition’s efforts to win the support and loyalty of the people, and eventually transfer that support to the government of Afghanistan, were only marginally more successful than they had been in 2005. The highland Pashtuns of RC East were willing to accept American money and development assistance, and even tolerated American troops in some areas, but the local population generally was not interested in and often was hostile to what coalition forces had to offer. In RC South, NATO forces were hard-pressed to secure the major population centers in the Taliban’s homeland. Taliban forces enjoyed multiple secure lines of communication to safe havens in Pakistan, and the call of jihad ensured a continuous flow of motivated, trained, and experienced foreigners who could mentor and lead local insurgent groups. Lastly, the unrestricted drug industry fueled lawlessness, funded antigovernment groups, enticed government officials to look the other way in return for massive bribes, and gave local communities a stake in the Taliban’s success.","Since the ISAF transition, coalition and Afghan forces had conducted hundreds of counterinsurgency missions in an effort to arrest the Taliban’s momentum in RC South, block the constant stream of jihadist fighters from Pakistan in RC East, and contain the Haqqani Network. Despite killing thousands of insurgents and spending billions on reconstruction and development, ISAF could point to little tangible evidence of lasting success. In fact, the Taliban broke with previous patterns at the end of the 2008 fighting season and did not withdraw its fighting forces to Pakistan. In a surprise move, the Taliban continued ${Operation Ebrat}{italic} in Helmand and increased suicide operations in Kabul. This late-season offensive threw off balance the Afghan and ISAF attempts to secure the population over the winter. In early 2009, the Taliban followed its efforts in Helmand with ${Operation Nasrat}{italic} (Victory). A concentrated campaign to isolate Lashkar Gah, ${Nasrat}{italic} was the Taliban’s boldest move to date in the south. Although it failed to seize the provincial capital, the instability it perpetuated undercut the Karzai government’s legitimacy and weakened popular support for ISAF.","Pakistan’s strategic interests further complicated the situation. The government in Islamabad continued to diverge from the interests of the ISAF coalition and began to focus solely on state survival as growing civil unrest, political turmoil, and concern over India’s actions diverted Pakistani security resources from the Federally Administered Tribal Areas. The enemy’s eastern networks not only affected the Afghan insurgency, but also further destabilized Pakistan by launching offensive operations against its military deployed within the tribal areas. Capitalizing on the gains they had made in 2008, Pakistan-based extremists used the winter months to reconstitute and emerge the following year as a viable threat to Afghanistan, ISAF, and the Pakistan government.","From their sanctuaries in Pakistan, al-Qaeda and local jihadist groups cooperated to plan new attacks in the name of Islam. While the Pakistani Taliban defended refugees from the Pakistani Army, presenting a clear threat to the Pakistani state and contributing to the Afghan Taliban’s momentum, al-Qaeda and like-minded organizations provided money, training, materiel, and leadership to insurgents fighting on both sides of the Afghanistan-Pakistan border. The Afghan Taliban benefited significantly from this nexus of ideology, insurgency, and regional extremism—and even more so as it grew in importance and authority.","${National Strategy: New Goals, New Resources}{bold}","As pressure in Iraq began to ease in 2008, some members of the Bush administration expressed the opinion that the United States should refocus on Afghanistan. Addressing this concern, President Bush ordered Lt. Gen. Douglas E. Lute, the deputy national security advisor for Iraq and Afghanistan, to chair a National Security Council strategy review in early fall 2008. Lute’s report recommended a better-resourced counterinsurgency approach in Afghanistan and a regional strategy that included Pakistan. Although someone in the administration leaked a draft of the report in early October, the final version would not be completed before voters chose Bush’s successor. The outgoing president did not respond formally to Lute’s findings to avoid committing the next president to implementing someone else’s strategy.",{"picture":{"source":"/figures/m/map-s2-helmand-and-kandahar.svg","caption":"Map-Helmand and Kandahar"}},"The election of President Obama heralded major changes to how the United States waged the conflict in Afghanistan. The Obama national security team held a pragmatic regional view, including on the core motivation of the Pakistani and Afghan governments. The White House newcomers saw Pakistan as a conflicted nation whose leaders sought to promote their nation’s interests at the expense of those of the United States. They also believed Kabul’s politics were so infused with graft and corruption that the Afghan people refused to show allegiance to their government. Afghanistan’s endemic corruption shocked many observers; in one egregious example, the Finance Ministry collected 40 billion afghanis (roughly $800 million) in revenue between March 2007 and March 2008, even though its own calculations stated that the total should have been 120 billion afghanis (about $2.4 billion). Most people believed the disappearance of $1.6 billion—more than 66 percent of forecasted revenues—reflected unsanctioned negligence or the criminal handiwork of low-level officials.","A foretaste of the new administration’s views had surfaced in February 2008 when a U.S. delegation headed by then Senator Joseph R. Biden Jr. visited Kabul. Biden and two other senators questioned Afghan President Hamid Karzai about corruption in his government at a state dinner. Karzai repeatedly assured Biden and his dinner companions that if any corruption in fact existed, then he should not be held responsible for it. After forty-five minutes of fruitless discussion, Biden and the other Americans abruptly left without another word to their host. Many in the new administration shared Biden’s doubts. Soon after Obama’s inauguration, the New York Times reported that “President Barack Obama said he regarded Karzai as unreliable and ineffective. Secretary of State Hillary R. Clinton said he presided over a ‘narco-state.’ The Americans making Afghan policy, worried that the war is being lost, are vowing to bypass Karzai and deal directly with the governors in the countryside.”","In January 2009, now Vice President Biden delivered one of the administration’s first messages to Karzai: he would not enjoy regular video teleconferences with Obama as he had with Bush, a practice Obama officials believed had undermined commanders in the field. The relationship between the two administrations deteriorated further during the 2009 Afghan presidential election, in which Karzai sought his second and final five-year term in office. The new special representative for Afghanistan and Pakistan, Richard C. Holbrooke, reportedly postponed the election from May 2009 to August 2009 in order to give Karzai’s opponents a better chance to win, even though this delay went against the Afghan constitution. He and Ambassador (Ret. Gen.) Karl W. Eikenberry then worked to bolster Karzai’s opponents, including former foreign minister Abdullah Abdullah and former finance minister Ashraf Ghani, so that Karzai would be forced into a run-off that he might lose. This “clumsy and failed putsch,” as Secretary Gates has since called it, likely incited Karzai to arrange the alleged massive voter fraud that marred the 2009 presidential election.","The Obama administration’s dissatisfaction with Kabul became public in early 2010 following the unauthorized release of classified State Department messages by U.S. Army Spec. Bradley E. Manning (now known as Chelsea E. Manning). Manning, a disaffected soldier, had sent several hundred thousand documents containing classified information on Iraq and Afghanistan to a third party who then posted that material on the internet. Within hours, global media consumers were reading that Ambassador Eikenberry viewed Karzai “as an inadequate strategic partner.” Although discomfited by the public exposure of diplomatic cables, the Obama administration did not abandon its goal of eliminating corruption in Kabul. Rather than distance itself from the outspoken former general, the administration signaled that it agreed with Eikenberry by retaining him as U.S. ambassador through July 2011.","In addition to having qualms about America’s Afghan partners, Obama believed that “there just didn’t seem to be a clear, coherent strategy there.”  As the incoming administration looked to rectify this problem, Obama asked Gates to remain as secretary of defense and Lute to stay on as deputy national security advisor. Although Obama’s defense team now included holdovers from the Bush administration, the president asked former CIA analyst Bruce O. Riedel on 30 January 2009 to review the progress of U.S. military efforts in Afghanistan. As with Lute’s effort, Riedel sought to answer two fundamental questions: (1) what were the United States’ goals in Afghanistan, and (2) how should they resource the war.","The strategic review, which drew heavily from Riedel’s work at the Brookings Institution, took two months. After Riedel finished his assessment, Obama presented its broader points to the American public in a speech on 27 March 2009. Obama reframed the war in tighter terms, focusing only on the terrorist group responsible for the September 11th attacks. He made it clear that the war’s “core goal” was “to disrupt, dismantle, and defeat al-Qaeda in Pakistan and Afghanistan, and to prevent their return to either country in the future.” This new strategy departed from the Bush administration’s Global War on Terrorism approach, which sought to eliminate all state-sponsored terrorism that could threaten the American way of life. Indeed, the Obama administration was hostile to the global war concept, which it saw as sanctioning endless war. As the president later remarked:",{"list":["\"I think the most important aspect of the entire exercise with the Riedel report was making sure everybody reminded ourselves of how we got in there in the first place, which was that al-Qaeda had killed 3,000 Americans and that our goal here had to be focused on dismantling and defeating those extremist elements in that region that could launch an attack of the U.S. homeland or our allies or our outposts.\""]},"Continued interest in preventing al-Qaeda from operating with impunity in Afghanistan or Pakistan guaranteed that the approach  favored by the administration included both new and familiar strategic concepts. The Obama administration rephrased the fundamental aim of Operation Enduring Freedom—to deny terrorists sanctuary, implying a continuing war with the Taliban. Supporting objectives for this core goal included: (1) disrupting terrorist networks and degrading their ability to launch international attacks; (2) “promoting a more capable, accountable, and effective government . . . that serves the Afghan people and can eventually function, especially regarding internal security, with limited international support”; (3) developing Afghan security forces to lead counterinsurgency and counterterrorism operations with reduced U.S. support. Denying safe haven thus remained key to American counterterrorism strategy. The Obama administration would stand by these objectives for the remainder of Enduring Freedom.","Even though Obama had abandoned the democracy-building language of the Bush administration, he still wanted an accountable  and effective Afghan government. In his view, this broader goal included:",{"list":["1. Executing and resourcing an integrated civilian-military counterinsurgency strategy;","2. Resourcing and prioritizing civilian assistance in Afghanistan;","3. Expanding the ANSF to 134,000 soldiers and 82,000 police over the next two years, with the potential for additional enlargements;","4. Engaging the Afghan government and bolstering its legitimacy;","5. Encouraging Afghan government efforts to integrate reconcilable insurgents;","6. Including provincial and local governments in our capacity building efforts;","7. Breaking the link between narcotics and the insurgency; and several others dealing with international support and Pakistan."]},"The Obama administration viewed Pakistan and Afghanistan as an indivisible problem set. The overarching objective for Pakistan involved “[a]ssisting efforts to enhance civilian control and stable constitutional government . . . and a vibrant economy that provides opportunity for the people of Pakistan.” Other goals included building stronger relationships between the Pakistanis and Americans and also between the Afghans and Pakistanis. In addition, Riedel recommended providing the Pakistani Special Forces and Frontier Corps with the training needed to wage sustained counterterrorism and counterinsurgency operations. The Obama administration’s preferred approach to dealing with Pakistan was not a change in emphasis, but a realization that it needed a coordinated interagency approach rather than the previous ad hoc efforts.","Before Riedel had finished his review—but taking into account his input—Obama decided to fill part of General McKiernan’s outstanding troop request so as to secure Afghan elections. On 17 February 2009, the White House announced that the president was sending more forces to Afghanistan in time to secure its upcoming presidential election, scheduled for August 2009. The president initially believed he was approving a request for 17,000, but the Pentagon continued to revise troop numbers until the total reached 21,000. The discrepancy reflected poor staff work by military planners who had overlooked a requirement to send supporting units and trainers to build the ANSF. The shifting numbers fueled the administration’s already considerable suspicions about the Pentagon’s agenda. With the adjusted 21,000 increase, the official number of U.S troops from all services committed to Afghanistan was now 68,000. President Obama also called for a “substantial increase” in the number of civilians in theater, an initiative that came to be known as the “civilian surge.”","The Riedel report received mixed approval from audiences outside the White House when the Obama administration released it in late March 2009. Secretary of Defense Gates recalled that he “was very disappointed in the Riedel review” mostly because it “contained no new ideas.” The White House planned to monitor the adjusted Afghanistan-Pakistan strategy for twelve months before revisiting potential policy and resourcing issues. Holbrooke, the diplomat who had brokered the 1995 Dayton Accords to secure the end of the war in Bosnia and Herzegovina, served as a special representative for Afghanistan and Pakistan to oversee the strategy. Holbrooke’s mission was to coordinate diplomacy in both countries and implement the initiatives outlined in Riedel’s report while working with the State Department.","${Counterinsurgency Redux}{bold}","When President Obama took office on 20 January 2009, the Iraq surge was complete and assessed as a success. Regardless of what else  had happened in 2009 (an uprising of Sunni tribes against al-Qaeda, a political reconciliation to take advantage of that situation, and more), the surge looked like a formula for winning in Afghanistan. In the words of General David H. Petraeus, who executed the Iraq strategy:",{"list":["\"It [counterinsurgency doctrine coupled with the surge] did prove itself in Iraq. There was no question about when you drive down  the level of violence by 85 to 90 percent; I mean that is proving itself. And keep in mind of course it was sustained for a number of years after the surge . . . almost three-and-a-half years until [Iraqi prime minister Nouri al-]Maliki . . . really undid what it is that we had done together."]},"As the CENTCOM commander, General Petraeus now championed the adoption of a counterinsurgency approach in Afghanistan that required a  further increase in troop numbers. He used briefing charts similar to those he had used in his congressional testimony in 2007 when he had charted the path out of the surge in Iraq just months after it had begun. In this instance, Petraeus argued that the rising violence in Afghanistan could be punctuated by “Surge Offensives,” eventually leading to a sharp decline in enemy attacks. Petraeus was explicit in signaling that he wanted to apply the lessons of Iraq to Afghanistan. Comparing the rise in enemy activity in Afghanistan to what U.S. commanders in Iraq had faced in 2006, he said:",{"list":["\"I think, as we turn and shift our focus to Afghanistan and Pakistan, it is very important to reflect on what we learned from Iraq  and to remember that you have to apply what was learned there with a very nuanced understanding, a very granular understanding of local circumstances in which those lessons are being applied . . . you have to—in Iraq—live among the people . . . you have to realize now that as you apply this in Afghanistan, that you don’t live among the people in Afghanistan. First of all, there’s no empty house. Second, the villages, particularly in the rural areas tend to be small. . . . You cannot clear and leave. You have to clear and hold. . . . And again, adapting this to the circumstances in Afghanistan with sufficient understanding will be critical.\""]},"The mention of clear and hold is a reference to the clear, hold, and build sequencing in the Army’s ${Counterinsurgency}{italic} manual (Department of the Army Field Manual 3–24), released in December 2006 under Petraeus’ signature. Harkening back to his Iraq experience, Petraeus exhorted Congress to use all resources, government and otherwise, in a “comprehensive” strategy to defeat the enemy militarily and promote political reconciliation.","Petraeus’ ideas resonated with Riedel’s recommendations while adding the gravitas of the fresh success. They also implied that specific detailed efforts from counterinsurgency in Iraq needed to be reproduced in Afghanistan. The clearest reference to Iraq was in command structure. Petraeus recognized that the existing command structure in Afghanistan lacked the mechanisms necessary to facilitate international, interservice, and interagency cooperation. Petraeus proposed adding both a tactical headquarters and a security force assistance-and-training command to the existing ISAF headquarters. More extensive changes were envisioned for U.S. Forces–Afghanistan (USFOR-A), including joint interagency task forces for detention operations and counternarcotics, a business and stability operations task force to aid the Afghan economy’s development, a combined intelligence operations center, an information operations task force, a specialized cell to track terrorist financing, and an interagency task force to promote effective Afghan governance and combat corruption.","Petraeus, convinced of the success of the Iraq surge, set out to export its “big ideas” to Afghanistan. From his position as commander of CENTCOM, he was uniquely positioned to influence the implementation of the doctrine he had coauthored at Fort Leavenworth and tested in Iraq. Although he could not know it at the time, he soon would be in a position to implement its concepts personally.","${The Resilient Threat, 2009}{bold}","The 2008 fighting season did not taper off in winter as previous fighting seasons had. McKiernan was aware that, with elections coming in the spring of 2009, the security situation was of particular concern. The enemy showed no sign that it was preparing to rotate fighters back to Pakistan for rest and reconstitution. The constant activity reflected the Quetta Shura Taliban’s secure position as the leader of armed opposition to Karzai’s government and ISAF. Taliban leaders were willing to conduct sustained combat operations in order to maintain their position as the dominant faction in the loose collection of extremist groups in Central Asia. The Pakistan Taliban had also been growing in numbers and influence, although it remained focused mainly on turning Pakistan into a fundamentalist Muslim state.","The Taliban leadership placed great importance on swaying local Afghan populations to its side and instructing its fighters to  avoid collateral damage and unnecessary casualties. In 2006, the Quetta Shura leadership originally published a ${layeha}{italic}, or code of conduct. This document, updated and reissued in 2009 and again in 2010, touched on cultural, religious, and historical themes familiar to Pashtuns, stating: “This Book of Rules is intended for the ${Mujahedeen [sic]}{italic} who dedicate their lives to Islam and the almighty Allah. This is a complete guidebook for the progress of Jihad, and every ${Mujahid}{italic} must keep these rules; it is the duty of every Jihadist and true believer.” The otherwise silent voice of Mullah Mohammed Omar figured prominently in later editions of the laheya, possibly signaling that some had lost faith in the Taliban’s reclusive leader. His reemergence indicated that the Taliban was at a critical junction where internal factionalism and wanton bloodshed threatened its strategic aims.",{"picture":{"source":"/figures/v2/img_sII-2.png","caption":"MQ-9 Reaper"}},"American intelligence assessments admitted that, while the core aims of the Taliban factions remained obscure, their operational goals were clear and “coming into alignment.” Militarily, the insurgency sought to expand its support in Afghanistan through influence and military operations in the western and northern provinces; conducting targeted operations to undermine governance, security, and economic development; inflicting casualties on ISAF and Afghan security forces; and consolidating footholds in the south and east. The Taliban appeared to be making considerable geographic progress by the end of 2009. Of Afghanistan’s 364 districts, 10 were assessed as under Taliban control. A staggering 156, most near the Pakistan border, were coded as “under Taliban influence.” The American surge would attempt to remove or reduce the influence of the Taliban in these contested districts and give the Afghan government a chance to establish legitimacy.","${Drone Operations Reach Their Peak}{bold}","One of the few bright spots of the campaign in the months leading up to the new administration taking office came out of the decision made several years earlier to take the fight into Pakistan’s tribal lands. The Bush administration had some successes using drone strikes against key figures in al-Qaeda operating in Pakistan from late 2005 to the end of 2007. One of the most notable resulted in the death of Abu Hamza al Rabia, al-Qaeda’s third most senior leader and chief operational planner, near Miran Shah in North Waziristan on 30 November 2005. However, drone activity remained limited through 2007, as military planners were still refining effective procedures for locating, identifying, and striking targets. That process had proceeded in fits and spurts as new procedures were tried and discarded or improved. The strikes also began to generate opposition within Pakistan and the United States as increasing civilian casualties were attributed to unmanned aerial vehicles, including one incident in which missiles struck a religious school in Damadola in the northern tribal lands on 30 October 2006.","In the final year of the Bush presidency, U.S. forces solved several procedural and technical challenges that had impeded the unmanned aerial vehicle program, and launched an increasing number of drone strikes within Pakistan. The increase in attacks attributed to unmanned aerial vehicles during 2008—totaling thirty-four, in comparison to an average of three to five in previous years—stimulated a commensurate increase in popular opposition to their use. The first indication that the new president’s views on the potential of unmanned aerial vehicles were somewhat similar to his predecessor came three days after Obama’s inauguration when drones struck several targets in Waziristan.","During Obama’s first term in office, which encompassed the Afghanistan surge, drone strikes steadily rose in numbers and increased in  lethality with fewer civilian casualties than before. The trend stemmed from the fielding of longer-ranging drones, which were capable of loitering over an area for hours in order to collect more detailed information, and the replacement of Hellfire antitank missile warheads by less powerful models. Although few nongovernment sources agreed on the estimated numbers, drone strikes in Pakistan numbered between 53 and 54 in 2009, 117 and 128 in 2010, 64 and 75 in 2011, and anywhere from 46 to 50 attacks in 2012. Based on the source, civilians accounted for a minimum of 2 percent and a maximum of 12 percent of the total casualties in Pakistan credited to drones during Obama’s first term. Obama was keenly aware that some claims of civilian casualties were derived from unverified reports. However, he made his personal views clear: “This is a targeted, focused effort at people who are on a list of active terrorists who are trying to go in and harm Americans, hit American facilities and bases.”","${Operational Overview}{bold}","Each of the three operational commanders from 2009 to 2011 altered ISAF’s approach to the war during his tenure. General David D. McKiernan, who commanded in a resource-constrained environment until 11 May 2009, requested to double the American force from 30,000 to more than 60,000 and attempted to unify the regional commands through coherent campaign revisions before being abruptly replaced.","Assuming command in June 2009, a month after Gates removed McKiernan, General Stanley A. McChrystal adapted and executed his predecessor’s plan. Gates and Obama impressed upon McChrystal the need to reduce civilian casualties, conduct a strategic assessment of the war within sixty days, and streamline the command. McChrystal did this but then asked for even more troops. While McChrystal’s request was mostly filled, he also abruptly left command after a reporter quoted his staff’s disparaging remarks regarding senior leaders in the Obama White House.","General Petraeus relinquished his command of CENTCOM to take over ISAF in May 2010. Petraeus oversaw the Afghan surge. He sought to repeat his Iraq success in Afghanistan, accelerating offensive operations in order to make progress toward ISAF’s operational objectives. The Petraeus period, during which American troop strength exceeded 100,000, ended with a transition plan for the next phase of the war to begin in summer 2011.","Although the term “surge” implies a temporary increase in troops, like a tide that rises and ebbs, it was more than that. The surge in Afghanistan also entailed debates over the strategy, the evolving command structures, and the unique personalities of senior ISAF commanders. It concluded in July 2011 when reinforcing units began returning home and Afghan forces started assuming responsibility for their nation’s security. Simultaneous with the start of the drawdown, President Obama announced that the American combat role would end in 2014.","The Afghan surge was an attempt by American leaders to bring Enduring Freedom to a successful close. The course of this surge led to five conclusions. First, it highlighted the incongruity between the national strategic and operational levels of war, more publicly and openly than ever before. Second, it illuminated and corrected past difficulties in commanding and controlling Enduring Freedom. Third, it exposed problems in tactics, training, counterinsurgency doctrine, and force generation. Fourth, in the rush to train the ANSF, it would test the U.S. Army’s resolve in dealing with difficult subjects like violations of the laws of land warfare, insider attacks, and transitioning key responsibilities from U.S. to indigenous control during combat operations.","Finally, the surge highlighted the DoD’s inability to manage strategic communications effectively. This challenge began when senior administration officials replaced the incumbent ISAF commander on short notice and for reasons that were unclear to the general public. It was exacerbated by poor decision making on the part of senior personnel, which led to another ISAF commander’s resignation in the wake of a damning story filed by a journalist embedded with his command group. Throughout these incidents and thereafter, information operations specialists and public affairs personnel failed to keep pace with events. As they struggled to overcome conceptual and cultural barriers, the management of the public perception of the war would become more and more central to the war in Afghanistan."],"chapter 6":[{"title":"McKiernan’s War Ends"},{"section":["Although U.S. forces had operated throughout Afghanistan since 2001, eight years later two-thirds of the 30,000 American troops committed to that conflict were concentrated in RC East. By early 2011, 106,000 American troops would be divided almost equally between RC East, RC South, and the newly formed RC Southwest. This increase and dispersion of U.S. forces led to American generals supplanting British, Canadian, and Dutch officers as commanders of RC South. By November 2010, Americans commanded three of the six regional commands (East, South, and Southwest). Even before Americans ascended to operational command, General David D. McKiernan used the pending surge to enhance unity of effort."]},{"title":"Unity of Effort","level":2},{"section":["In early 2009, all American troops operated under CJTF-101, CSTC-A, or Special Operations commands. However, by the end of the year, they would be funneled under regional commands as part of the ISAF mandate. McKiernan moved to align U.S. forces by creating a new headquarters, designated as USFOR-A, to serve as the national command element. At the same time, McKiernan did not agree with the idea—favored by General David H. Petraeus at CENTCOM—of forming a similar headquarters for ISAF. While McKiernan recognized that command and control relationships were challenging for ISAF, he believed in less international command and control structure rather than more.","${The Campaign Plan: More Troops and Counterinsurgency}{bold}","While the U.S. military sought to improve its command and control deficiencies, other issues were more pressing. Increased enemy activity had prompted McKiernan to request more forces, particularly in southern Afghanistan. He initially asked for these forces during the last months of the Bush administration. As McKiernan waited for the request to be approved, he directed infrastructure to be built to support them. He also remained aware that to get approval for more forces, he needed a plan for what the requested troops would do. An update to his plan would also help get his units in step with the embassy’s plan for Afghanistan and further enhance unity of effort. To this end, McKiernan drafted an updated Civil-Military Campaign Plan designed to unite the efforts of the embassy and military actors.","On the military side, McKiernan believed that the regional commands were conducting independent campaigns and, even within some regional commands, national efforts were not coordinated. To establish unity of effort among the regional commands, McKiernan authorized a campaign plan known as ISAF Operation Plan 38302. After viewing the initial drafts, he added language from Field Manual 3–24 to the document. Each successive change to the order incorporated more counterinsurgency terminology. Shortly after issuing 38302, McKiernan revised his concept of operations in an ISAF operations order known as TOLO HAMKARI (Dawn of Cooperation, hereafter referred to as OP [Operation] TOLO). The second version (OP TOLO 2) and third revision (referred to as Revision 3 or Rev 3) to ISAF Operation Plan 38302 made greater strides toward achieving unity of effort.","OP TOLO sought to foster “support [for] the population of Afghanistan through an ISAF and the Government of the Islamic Republic of Afghanistan (GIRoA) partnership to build GIRoA capacity and credibility (legitimacy).” The campaign consisted of four lines of operation under which all subordinate efforts were to be nested. The regional commands used these lines to design their operations. The first was governance. In this line, ISAF and U.S. forces supported civilian agencies such as the State Department and the United Nations Assistance Mission in Afghanistan. The second line was security, for which ISAF was the lead. The third line was ISAF-supported, civilian-led reconstruction and development initiatives designed to better the lives of the Afghan people. The final line of effort, information operations and strategic communications, sought to illustrate how ISAF goals were aimed at ending the violence and helping Afghans transform their embattled country into a self-sufficient member of the global community.","With one exception, the lines of operation remained constant in the first three versions of OP TOLO. The only difference was that McKiernan emphasized securing the elections and characterized the enemy as an insurgency in OP TOLO 2. This order was the first official acknowledgment that an insurgency was the main threat in Afghanistan. Until this time, President Hamid Karzai had vehemently denied that an insurgency existed, noting that the term made his government appear illegitimate. Earlier versions of the order had reflected this reluctance to define the problem by inferring that only loose border security had provided the opportunities for foreign militaries to infiltrate the country. The mission before 2009 had not been about defeating an enemy, but “conducting military operations to assist” in securing the country. As the mission statement for ENDURING FREEDOM since 2007 awkwardly stated, U.S. forces were to “conduct military operations in the assigned Area of Operations (AOO) to assist the Government of Afghanistan (GOA) in the establishment and maintenance of a safe and secure environment with full engagement of ANSF, in order to extend GOA authority and influence, thereby facilitating AFG’s [Afghanistan’s] reconstruction and enabling the GOA to control the country.”","For the most part, American commanders in Afghanistan accepted that they were fighting an insurgency. For years, ENDURING FREEDOM documents had referred to the Field Manual 3–24 counterinsurgency terminology of shape, clear, hold, and build while ISAF orders focused on nation building. McKiernan insisted on adding the expression “Shape, Clear, Hold, and Build” to the OP TOLO concept of the operation, but was not successful in changing the mission statement to “conduct counterinsurgency operations.” Because counterinsurgency missions frequently required heavy investments in time and resources, NATO allies were hesitant to identify the mission as a counterinsurgency in their own documents.","McKiernan had misgivings about adopting the population-centric counterinsurgency approach used in Iraq. He interpreted Field Manual 3–24 as directing that he position most of his troops in urban areas and along the Ring Road (Afghanistan National Highway 1). To the ISAF commander, such a disposition was not applicable to Afghanistan, where the insurgency had its roots in rural tradition. This was a significant difference from Iraq, where the insurgency was largely an urban phenomenon. If Afghan and ISAF troops focused on the country’s fourteen largest population centers, the Ring Road, and main border crossing sites, no forces would be available to drive enemy forces out of their rural enclaves. McKiernan concluded that pursuing a population-centric counterinsurgency in Afghanistan meant ceding the initiative to the enemy.","Field Manual 3–24’s emphasis on population-centric counterinsurgency, coupled with Afghanistan’s compartmentalized terrain, created a difficult problem for McKiernan to overcome. Given the theater’s limited infrastructure, large troop increases would be a cost-intensive logistics challenge. Relying on lines of communications that traversed Pakistan presented another operational problem. CJTF-101 leaders had spread their available forces over an expansive operational area. This trend led to outpost garrisons becoming increasingly smaller, which made them more vulnerable to attacks by the enemy—such as in the assault at Wanat in 2008. By any definition, these battles were tactical defeats for the enemy with scores of insurgents killed. Despite this, they demonstrated that the Afghan insurgency still thrived while also using masterful strategic messaging to convince ordinary Afghans that the Taliban was winning. Even after inflicting repeated tactical defeats on the enemy, American commanders began pulling forces out of exceptionally vulnerable small outposts. Thus, when President Barack H. Obama assumed office, the coalition still had not regained the initiative from the Taliban’s 2006 resurgence.","${General McKiernan’s Requests for Forces}{bold}","The Pentagon had all but abandoned its system for generating forces for employment in the war on terrorism by the time McKiernan submitted a formal request for forces through CENTCOM. The Joint Operation Planning and Execution System had been a useful management tool to project which units were training, when they would be deploying, and where they would go. Now, as a result of the U.S. Army and Marine Corps being deployed nearly to full capacity, the Joint Staff required commanders to submit a detailed justification known as a Request for Forces. Although the Request for Forces process theoretically enabled commanders to request exactly what they deemed necessary, it allowed almost every agency in the approval chain to ask for additional clarifying data, which invariably resulted in lengthy delays.","Part of the problem lay with the inherently ad hoc nature of the force request system. First, the granularity of detail required to obtain approval for a unit to be deployed often overwhelmed the staffs and commands tasked with generating these requests. Second, the bureaucracy at every echelon up to the National Command Authority had the opportunity to delay the request for their staffing purposes. Finally, decision makers up to the president of the United States had the ability to approve or disapprove the Request for Forces. For McKiernan, the system resembled a valve that could be opened or closed to control the flow of troops, but would be opened only if a request satisfied every decision maker in the command chain. Instead of the services or the joint forces commander managing what was needed, McKiernan felt that a team of supervisors, with their hands on the valves, micromanaged a process that should have been executed by an operational commander in an efficient manner. The process being what it was, the final hand on the valve was the president. President George W. Bush had opened the valve partially at the end of his term, and now President Obama would assume responsibility for opening it further.","The 15 September 2008 Request for Forces Serial 920—known as RFF 920—stemmed from the shared assessment of the intelligence community that the enemy was moving back into RC South and that RC East needed more troops to secure Wardak and Logar Provinces, outside Kabul. McKiernan based the request strictly on his sense of where troops were needed prior to the elections. He assessed that the enemy would try to influence the Pashtun vote and focused his efforts there. RFF 920 justified the need for a battalion in Helmand and a battalion each in Wardak and Logar Provinces. The Bush administration approved the request, deploying a Marine Air-Ground Task Force configured around Lt. Col. David L. Odom’s 3d Battalion, 8th Marines, to Helmand Province and Col. David B. Haight’s 3d Brigade Combat Team, 10th Mountain Division, to RC East.","McKiernan modified his force request on 24 October 2008 to address three emerging problems. First, CJTF-101 aviation assets were overwhelmed by the need to provide rotary airlift for the whole of Afghanistan. A second combat aviation brigade would cover RCs South and West and allow the aviation brigade at Bagram to focus on RCs East, Capital, and North. Second, McKiernan specifically requested a Stryker brigade combat team to reinforce RC South. He argued that the wheeled Stryker would be effective in the region’s open terrain. Finally, he requested another brigade to deploy as trainers and mentors under CSTC-A. If approved, this last request would double their trainers from 3,000 to 6,000. The first two items were approved, but the request for trainers was denied, as the Bush administration wanted to let the next administration make that decision. That development left McKiernan with the belief that the Request for Forces process did not allow the deployed commander sufficient flexibility or responsiveness.","The request for an additional brigade of trainers and advisers had not been denied because McKiernan’s superiors felt that  additional troops were not needed. Both Chairman of the Joint Chiefs of Staff Admiral Michael G. Mullen and General Petraeus agreed that more “boots on the ground” were necessary in Afghanistan. As violence in Iraq declined and President Obama shifted focus toward the new Afghanistan-Pakistan policy, Operation ENDURING FREEDOM would no longer be an economy-of-force mission but rather the main effort. During a 23 March 2009 video teleconference with McKiernan, Petraeus, and the Joint Chiefs of Staff, Mullen stated: “2009 has to be the year we throw the kitchen sink into Afghanistan. [We m]ust generate progress and some early wins there. We’ll have to once again resource some of the civil surge. I need your best. [We] must arrest this thing this year. Afghanistan is highest priority.”","Petraeus noted Mullen’s reference to the military resourcing some of the civil surge. To Petraeus, this meant that expectations for the civilian side were limited and the military could now begin brainstorming other ways to “arrest this thing.” The idea of doing it all in 2009 seemed overly ambitious, given that additional resources necessary to fulfill Mullen’s proclamation would not be authorized for another eight months. The surge forces could not begin arriving until late 2009 and would not peak until 2011.","Although Petraeus openly agreed that the Pentagon should surge troops to Afghanistan, he saw Mullen’s assessment as a way  to attack as many of Afghanistan’s problems as he could imagine. Soon after Mullen’s suggestion about “throwing the kitchen sink” at Afghanistan, Petraeus listed twelve categories in his personal notebook:",{"list":["1. Elections","2. STRATCOM/ IO [strategic communications/information operations]","3. CN [counternarcotics]","4. Agricultural Development","5. Prisons","6. Rule of Law","7. Police Training","8. International Coordination","9. Counter Corruption","10. PRTs [Provincial Reconstruction Teams]","11. Health","12. Education"]},"Petraeus noted that several of these challenging problems lined up well with actors and resources. He put those in parentheses:  counternarcotics (Drug Enforcement Agency), agricultural development (Department of Agriculture), prisons (International Narcotics and Law Enforcement), rule of law (Department of Justice), and international coordination (Ambassador Richard C. Holbrooke). Other areas, such as countercorruption, health, and education, would require more robust support from the Afghan government because the coalition’s military and political resources would not be enough to address them. Some areas, interrelated to others, required visible countercorruption initiatives by the Kabul government and an information-operations effort to begin restoring the Afghan people’s faith in the election process. Petraeus thought in terms of interagency solutions and would push for those when politically opportune. Yet almost from the beginning, some of his programs were destined to achieve far less than desired because they faced resistance from the Taliban. Some also ran counter to fundamental aspects of Afghan culture or to the self-serving nature of the Karzai government.","With 21,000 additional forces authorized and the shift in priority from Iraq to Afghanistan underway, discussions at McKiernan’s headquarters increasingly focused on what missions to assign to the incoming troops. For the most part, enemy activity drove the decisions. An Estonian, British, and U.S. operation in Helmand Province revealed large numbers of IEDs placed to disrupt movement around the capital of Lashkar Gah. At about the same time, the Taliban targeted the Afghan Special Counter-Narcotics Police Force in separate incidents in the district surrounding the Helmand capital. Then, at the intersection of the Ring Road and Helmand River in the town of Girishk, home to the largest and most important bazaar in the province, a single raid netted half a ton of recently harvested opium. Afghan and coalition forces interpreted the increased use of IEDs and the attacks on the counternarcotics police as an effort to protect opium production in Helmand over the next poppy-growing season.","Based on this analysis, McKiernan directed a significant portion of the additional forces, primarily U.S. Marines, to combat the growing threat to stability in Helmand Province—the area at the heart of the illicit opium trade. McKiernan wanted the incoming troops to clear and hold this area until sufficient ANSF could be trained to secure the region. The ANSF, aided by ISAF, could mass forces to clear specific areas but lacked the forces and the logistics necessary to hold them. Soon after clearing any area, the enemy would return. A prime example in Helmand was the village of Babaji, north of Lashkar Gah, used as a transit point for Taliban fighters. In mid-February 2009, more than 700 Afghan, British, Danish, and Canadian troops had established a police station in the area. The operation was deemed successful, but shortly after the assault force departed, the Taliban reasserted control. That development should not have come as a surprise to ISAF commanders familiar with the Taliban’s tactic of falling back in the face of strength before returning when the odds were more favorable. The area had to be cleared again in June 2009."]},{"title":"Significant Operations in RC East, Early 2009","level":2},{"section":["McKiernan’s justification for the surge shifted the primary effort from eastern to southern Afghanistan. RC East usually had been the American main effort since Operation ANACONDA. ISAF assumed responsibility for the other regional commands, but RC East remained under U.S. command. While the Marines surged into RC South in 2009–2010, RC East increased in size by one Army brigade combat team. In January 2009, Colonel Haight’s 3d Brigade Combat Team, 10th Mountain Division (TF SPARTAN), established operations with Lt. Col. Kimo C. Gallahue’s 2d Battalion, 87th Infantry (TF CATAMOUNT), in Wardak Province and Lt. Col. Daniel P. Goldthorpe’s 3d Squadron, 71st Cavalry (TF TITANS), in Logar Province. McKiernan detached the third maneuver battalion, Lt. Col. Frederick M. McDonnell’s 1st Battalion, 32d Infantry (TF CHOSIN), to Col. John M. Spiszer’s TF DUKE in Kunar Province. The rest of TF SPARTAN, including Lt. Col. Michael P. Gabel’s 4th Battalion, 25th Field Artillery (TF WOLFPACK); Lt. Col. Eugene A. Shearer’s 710th Brigade Support Battalion (TF SUPPORT); and Lt. Col. Steve Pitts’ Special Troops Battalion (TF VANGUARD), remained with Haight. These units represented the last expansions into new battlespace in RC East under McKiernan’s senior tactician in the region, CJTF-101 commander Maj. Gen. Jeffrey J. Schloesser.","Although the overall main effort would shift to RC South, it was vital to reinforce RC East before the marines arrived.  Violence had spiked in Wardak and Logar Provinces in 2008, and these provinces controlled the southern approaches to Kabul. As Brig. Gen. Mark A. Milley, deputy commanding general for operations of RC East, explained to Brig. Gen. Michael S. Tucker, deputy commanding general for ISAF operations:",{"list":["\"Kabul is the political center of gravity of Afghanistan and has been for centuries. The enemy is making a conscious effort to surround  Kabul and they project they can do this by end of year 2008. There are four historic approaches to Kabul. The Afghans call these the “gates to Kabul.”The enemy has set up support zones and is infiltrating additional combat power into these support zones that generally align with the approaches and associated districts. From these support zones the enemy plans to launch a steady and increasingly deadly series of spectacular attacks into Kabul— that campaign has already begun. Additionally, from these support zones, the enemy plans to cut the GLOCs [ground lines of communications] (principally Ring Road but other feeder hardball roads as well) leading to Kabul and connecting Kabul to Kandahar. That campaign has also already begun in earnest.  If we get an additional IBCT [Infantry Brigade Combat Team] we will have sufficient combat power to secure the high density population areas; really secure Highway 1 and associated roads; conduct aggressive offensive operations in enemy support zones; and concentrate adequate forces to interdict enemy rat lines from Pakistan border. By positioning the forces in RC-East we will have the second and third order effect of increasing the confidence of the Afghan Government, morale and skill of the ANSF, and concurrently demoralize the enemy because he will realize that his objectives are not achievable.  Our estimate is that the war will be won or lost in RC-East. RC-South is important but the war will not be won or lost in that area of operations. The decisive fight is in RC-East as it has been throughout Afghan history.\""]}]},"This statement, in advocating for forces in Wardak and Logar Provinces, revealed another idea about where the main effort should be located. While ISAF was shifting to RC South, there were those who fervently believed RC East was still the pivotal fight in Afghanistan.","${The American Shift to Counterinsurgency Gains Traction}{bold}","After attempts by Lt. Gen. Karl W. Eikenberry and General Dan K. McNeill to pursue enemy forces where they were strongest and McKiernan’s desire to win the support of the people of Afghanistan’s hinterlands, RC East was characterized by small units occupying combat outposts along regional lines of communications. Many of these outposts, which numbered 101 upon Schloesser’s arrival in April 2008, were supportable only by airlift. Day-to-day operations at the tactical level included trying to reach the population to assess their needs to gain access for Afghan officials or nongovernmental organizations to provide basic services, secure elections, and gain intelligence on the enemy. As the enemy began to step up attacks on the American positions, these tactical units began to shift more toward combat missions in the form of raids, interdiction, and clearing operations. All of these often took the form of air-assault operations as mounted ground movements became more dangerous over time with the growth in size of IEDs and the limited number of trafficable roads in the restrictive, mountain terrain. These operations put a further strain on the already overworked aviation units.","With the deployment of the 3d Brigade, 10th Mountain Division, to Wardak and Logar Provinces, three American infantry brigade combat teams were now in RC East. Schloesser focused these brigade combat teams in three contiguous areas. While TF SPARTAN covered the southern and western approaches to Kabul, TF DUKE secured the four provinces of Nangarhar, Nuristan, Kunar, and Laghman in the northern zone. In the southern portion of Schloesser’s regional command, the 4th Brigade, 25th Infantry Division, would replace 4th Brigade, 101st Airborne Division (Air Assault), to secure Paktiya, Paktika, and Khost Provinces. Predictably, these border provinces endured the most enemy activity and required the most attention from the Americans. In addition to the three infantry brigades, RC East included the Polish Task Force WHITE EAGLE in Ghazni Province; Col. Scott A. Spellmon’s 1st Maneuver Enhancement Brigade (TF WARRIOR) in Bamyan, Parwan, and Panjshir Provinces; and the French Task Force LAFAYETTE operating in both Kapisa Province and the Sarobi District of Kabul Province.","The addition of TF SPARTAN pushed the personnel strength of RC East to more than 20,000, up from approximately 15,000 one year earlier. However, RC South workforce totals surpassed RC East for the first time, reaching more than 22,000. From February 2009, RC South would grow faster than RC East. RC East would lose its status as the main effort by the end of 2009 and would have a lower troop strength than the south until the end of the subsequent surge instituted by President Obama. Although it was now a supporting effort, RC East would grow in strength by another third, maxing out at approximately 30,000 troops. The reinforcement enabled ISAF to extend its reach into many small combat outposts where ISAF troops could target insurgents more effectively, even though bases located far from population centers provided only marginal support to counterinsurgency efforts. Initial deployments into places like the Pech River Valley led to commanders venturing into sparsely populated tributary valleys in search of an elusive enemy. Experiences like those at Combat Outposts RANCH HOUSE and BELLA, as well as Wanat in 2008, indicated that lack of adequate intelligence, surveillance, and reconnaissance assets at key times made smaller outposts vulnerable to surprise attacks. Commanders subsequently withdrew their troops from a number of isolated bases to minimize tactical risk in the face of an evolving threat while simultaneously placing more emphasis on population-centric counterinsurgency by moving displaced units closer to larger villages and towns.",{"figure":{"source":"/figures/m/map-figure-6-1.svg","caption":"CJTF - 101 Regional Command East","prefix":"MAP"}},{"figure":{"source":"/figures/v2/img_6-1.png","caption":"Soldiers of Company C, 1st Battalion, 26th Infantry"}},"In spite of these challenges, coalition forces in RC East continued to secure the area surrounding Kabul and the most  contentious provinces on the Pakistan border. While other units in RC East conducted operations to disrupt the enemy, TF SPARTAN deployed into Wardak and Logar Provinces to secure roads. Afghanistan National Highway 1 (the Ring Road) approached Kabul through Wardak, and Highway 2 connected Kabul with Pakistan through Khost Province. Thus TF SPARTAN operations, both lethal and nonlethal, focused first on clearing and securing and then on building the roads. As Haight reflected:",{"list":["'[M]y top three development priorities were roads, as number one; number two was roads; and number three was roads. And if I  had a four, five, and six, they would have been roads—not literally, but I used to make a joke and say, “I like libraries, I like clinics, I like schools, and I like all those things, but I would turn them all in for one more mile of road.” . . . [R]oads were the most important thing because they fix their economy.'"]},"For the first half of 2009, the remaining brigades focused on “ANSF partnering and mentoring with the two Afghan major commands in RC East, the 201st Corps and 203rd Corps.”","Prior to this troop increase, the mission of ISAF forces in Afghanistan had always been conveyed as full spectrum operations.  After the initial troop increases, this mission would formally change to counterinsurgency operations. The difference in the terms was subtle but important. Counterinsurgency operations indicate the presence of an enemy insurgency, whereas full spectrum operations convey a broad range of military activity from humanitarian assistance to high-intensity conflict. Counterinsurgency also came to mean coordinating efforts from outside the military as well. In any event, until April 2009, Schloesser’s mission statement for RC East was:",{"list":["\"In conjunction with the Government of the Islamic Republic of Afghanistan (GIRoA), NATO ISAF, and the Interagency  [i.e., other U.S. governmental agencies outside of DoD], RC-(E[ast])/CJTF-101 conducts full spectrum operations to develop Afghan national capability to secure its people, exercise capable governance, and develop a sustainable economy, while defeating terrorists and insurgents, in order to extend GIRoA authority and influence as the legitimate government of the Afghan people.\""]},"In April 2009, following the publication of McKiernan’s OP TOLO 2, the American-led RC East (but not the other regional commands)  would change its mission to:",{"list":["Regional Command (East), in close coordination with the Government of the Islamic Republic of Afghanistan (GIRoA), joint, interagency, and multinational partners, conducts counter-insurgency (COIN) operations from 01 APR 09 until the continuance or transfer of constitutional power following the 2009 Afghan Presidential election, in order to improve GIRoA’s capacity to provide security, exercise good governance, develop a sustainable licit economy, and improve the quality of life for the Afghan people."]},"The success of the Iraq surge, coupled with the Riedel Report and the elevation of Petraeus to CENTCOM commander, influenced the change in the RC East mission to conduct counterinsurgency operations. Securing the elections justified additional forces for RC East. As General Milley explained to General Tucker, Kabul had to be secured for the upcoming elections to be successful.","To enable a shift to a counterinsurgency approach, McKiernan ordered CJTF-101 to relinquish National Support and Command Element responsibilities in April 2009 to USFOR-A, which had been established for exactly that purpose. This transfer allowed the leaders of RC East to focus on the tactical fight.","Although the upcoming elections were supposed to remain the priority for the remainder of the summer, everyone in RC East soon found themselves shifting focus for a completely different reason. At the end of June 2009, Pfc. Beaudry Robert “Bowe” Bergdahl of Lt. Col. Clinton J. Baker’s 1st Battalion, 501st Infantry, disappeared from his base in Paktika Province and was seized by the Taliban. The search for Bergdahl drove operations in RC East for months to come. The diversion of significant resources to that effort would have a major impact on the campaign in Afghanistan for the duration of the search.",{"figure":{"source":"/figures/m/map-figure-6-3.svg","caption":"Regional Command East Transfer of Authority","prefix":"MAP"}},"Helicopters were in critically short supply before the deployment of a second combat aviation brigade as part of McKiernan’s most recent request for forces. This scarcity increased after Bergdahl’s disappearance. Almost all units in RC East began conducting additional operations—requiring rotary-wing aircraft; unmanned aerial vehicles; and intelligence, surveillance, and reconnaissance assets—to locate the missing soldier. The search for Bergdahl continued throughout July and into August 2009, when the main effort for all forces in Afghanistan returned to securing the 20 August 2009 elections. These two events—the search for Bergdahl and security preparations for the elections—consumed the second half of the Afghan fighting season.","Another factor influencing operations at the time was the rapid turnover of units. Relief-in-place missions are highly disruptive to campaigns. As in previous years, most Army units deployed to Afghanistan on an annual deployment cycle. CENTCOM and providing commands staggered brigades so that they did not all change at once, which resulted in a constant churn of units coming and going. Most often, the brigades serving in Afghanistan did not serve under their normal stateside divisional headquarters, which meant that they had to take time to become familiar with command structure and practices of their newly assigned higher headquarters.","The one brigade combat team that was aligned under its stateside command—the 4th Brigade, 101st Airborne Division (Air Assault)—had redeployed in March 2009, leaving the rest of the units in RC East populated by soldiers from different divisions. This arrangement was indicative of how modularity supported contingency operations; brigades were supposed to be able to serve under any division headquarters. Although this state of affairs was normal in Operation ENDURING FREEDOM, it gave the divisional team no time for team building. Units, staffs, and commanders often had to develop relationships while conducting combat missions. The Army had adopted modularity so it could “plug and play” units at the brigade combat team level, a structural change that generated flexibility, enabled independent operations, and simplified sustainment. The success of modularity appeared evident in the fact that all brigade combat teams came from different divisions, but the actual situation on the ground challenged Army leaders who were already struggling through a coalition environment that made it difficult to conduct coherent operations.","TF SPARTAN (3d Brigade, 10th Mountain Division) continued securing and clearing its new area throughout 2009 while the other task forces were relieved in place. Task Force YUKON (4th Brigade Combat Team, 25th Infantry Division), under the command of Col. Michael L. Howard, had relieved Col. John P. “Pete” Johnson’s 4th Brigade, 101st Airborne Division (Air Assault), (TF CURRAHEE) in March 2009. On 3 June 2009, Maj. Gen. Curtis M. Scaparrotti’s 82d Airborne Division replaced General Schloesser’s 101st Airborne Division (Air Assault) and reflagged as Combined Joint Task Force 82 (CJTF-82). Just after CJTF-82 arrived, Col. Randy A. George’s Task Force MOUNTAIN WARRIOR, 4th Brigade, 4th Infantry Division, relieved Spiszer’s TF DUKE. The high tempo of units being replaced while searching for Bergdahl and preparing for elections dominated RC East during mid-2009. After the elections, RC East units focused on partnering with and preparing ANSF for transition, and the main effort was to shift to RC South. Simultaneously, the mission changed to conducting counterinsurgency operations.",{"figure":{"source":"/figures/v2/img_6-2.png","caption":"RC East Soldiers"}},{"title":"McKiernan Chooses Helmand","level":2},{"section":["During the debate over whether or not to embrace population-centric counterinsurgency, some in the Obama administration began to question  why so many troops had been deployed to sparsely populated Helmand Province, and why that effort rested primarily on the shoulders of the U.S. Marine Corps. Certainly, Petraeus’ map of enemy activity in 2008 helped explain the choice of Helmand. General McKiernan painted a more straightforward picture of why the marines had been assigned to Helmand:",{"list":["\"Now despite a lot of writings and people saying they decided where they [additional forces] would go, I can categorically tell  you that I personally decided where they would go and briefed that as part of the Request for Forces process—briefed it and got concurrence from the Afghan Ministry of Defense and ultimately briefed it to President Karzai . . . it was a top-down approach of my saying I need these additional capabilities in these particular areas, south, particularly in the Helmand River Valley. \""]},"According to McKiernan’s reasoning, of the two contentious areas in RC South, the smaller problem should be solved first. To provide coalition forces momentum, he sent the marines to Helmand Province. Even though Helmand had extensive poppy fields and had witnessed the most violent insurgent events in 2008, it was a barren land without the cultural and historical importance of Kandahar Province. McKiernan also believed that a long, drawn-out battle in Kandahar just before the elections would not be wise. He lobbied and vetted his proposed troop-deployment locations with the RC commanders, who all felt they would receive additional forces and deploy them as they saw fit. Most importantly, McKiernan vetted his ideas with the RC South commander, Dutch Maj. Gen. Mart de Kruif, who consented to the plan.","The military command in Afghanistan delineated the plan to reinforce RC South in Operations Order 1 for 2009. This document orchestrated the deployment of the combat aviation brigade and Stryker brigade combat team under USFOR-A. It accepted the Marine Expeditionary Brigade–Afghanistan as a voluntary national contribution to ISAF. As ISAF commander, McKiernan delegated NATO tactical command of the expeditionary brigade to RC South. This command relationship allowed de Kruif to designate local control measures and delegate tactical tasks, but prevented him from reorganizing or dividing the Marine brigade. U.S. Marine Corps Forces Central Command in Tampa retained operational control of the unit. To change Marine Expeditionary Brigade–Afghanistan’s task organization, the Marine component commander in Tampa would have to issue the necessary order.","This decision conferred unprecedented authority to someone outside the authority of the joint force commander. It reflected the fact that the modern U.S. military placed as much emphasis on institutional legacy as it did on efficiency when waging war. Considering that the marines operated under similar conditions in Iraq’s Al Anbar Province from March 2004 through January 2010, the decision should not have come as a surprise. Service parochialism, in addition to coalition considerations, had colored U.S. involvement in Afghanistan since the conflict began and continued to complicate the fight. Secretary of Defense Robert M. Gates would reflect that not breaking these institutional barriers was “my biggest mistake in overseeing the wars in Iraq and Afghanistan.” In Gates’ mind, service inflexibility affected the conflict in negative ways.",{"list":["\"We knew pretty early on—maybe a year in for me [2008]—that the command and control in Afghanistan was all screwed up—that the commander of ISAF, who was an American, did not have command of all the American troops. . . . It was really convoluted, in terms of the command authority of the Marines, because the Marines were actually under the command of a three-star in Tampa, and then back to the Pentagon.\""]}]},{"figure":{"source":"/figures/m/map-figure-6-m.svg","caption":"Regional Command South","prefix":"MAP"}},"The contorted command relationship in RC South derived from Marine Corps doctrine. The standard task organization of Marine Corps forces since 1952 had been the Marine air-ground task force, consisting of a command element, ground combat element, air combat element, and a logistics combat element. The task force is considered indivisible, fighting in a single battlespace. The sanctity of the U.S. Marine Corps doctrine had been a recurrent thread in previous campaigns, most recently in Operation DESERT STORM where U.S. Marine Corps Forces Central Command retained control over its air combat element after putting up spirited opposition to the Air Force’s view that all aviation in a theater should be under a single joint-force air component command.","Key to the Marine Corps view of operations was the concept of “single battle.” The operational commander must have the authority to use forces as necessary. Within that concept, a Marine air-ground task force commander conducts central planning and enables decentralized execution. As noted in the current version of Marine Corps Doctrinal Publication 1–0, Marine Corps Operations, “a commander must view his area of operations as an indivisible entity.” Although Marine doctrine allows an air-ground task force to be spread over a noncontiguous area of operations, it assumes that the combat force is operating alone. As part of a larger joint ground campaign, Marine Corps forces fought within a single contiguous area, as had been the case in Kuwait during DESERT STORM or in Al Anbar Province during IRAQI FREEDOM. Planners in Afghanistan, the Pentagon, and Tampa took a contiguous area of operations as an article of faith, recognizing that separating the components of Marine Expeditionary Brigade–Afghanistan would have been a deal-breaker for the marines’ deployment to Helmand.",{"figure":{"source":"/figures/v2/img_6-3.png","caption":"U.S. Army UH-60 helicopters airlift Marines"}},"${Counterinsurgency}{bold}","The U.S. Marine Corps caveats to its deployment into RC South revealed other differences of opinion within the coalition ranks. The United States and the other ISAF nations had adopted operational language that suited their domestic audiences but was incongruous with their allies in Afghanistan. In particular, some ISAF nations disagreed with the population-centric counterinsurgency methods that Petraeus had pursued in Iraq. In early 2009, there would be no official use of the term “counterinsurgency” outside of American commands. Thus, the mission for the incoming forces was to “reinforce Coalition Forces in RC-South with an increase in enduring ground and air/aviation forces beginning no later than 31 March, 2009, in order to ensure success of the ISAF mission in Afghanistan.”","The command of RC South rotated among Canada, Great Britain, and the Netherlands every six months. Dutch General de Kruif had been appointed in late 2008 with the agreement that his tour would last one year to provide continuity. No discussion of changing the mission statement would take place without the North Atlantic Council first agreeing to change it. To nations like the Netherlands, counterinsurgency was an operational paradigm that indicated a larger commitment than they felt was politically acceptable.","McKiernan understood these political considerations. He had not yet rewritten the ISAF mission for several reasons. Neither the North Atlantic Council nor ISAF had officially recognized counterinsurgency as the mission in Afghanistan. Some key players, including Karzai, denied the existence of an insurgency. McKiernan recognized that changing the mission statement would require lobbying coalition nations individually, something he could not do as theater commander. Instead, McKiernan tried to shift operational language toward counterinsurgency gradually. In June, RC South Operations Order 09–07 echoed the language of a counterinsurgency approach by stating that the mission was to neutralize the insurgency, but did not use the specific phrase “conduct counterinsurgency operations.” To make matters more confusing, the order for RC South described the enemy as “a networked movement with diverse motivations aimed at the overthrow of the elected Government of the Islamic Republic of Afghanistan through the use of subversion and armed conflict in order to establish local authority in support of their aims such as the reestablishment of a Taliban government.” Thus, the order employed a classic Western definition of an insurgency without calling it as such. In the same vein, it labeled the enemy’s most dangerous course of action as coordinated attacks to disrupt the upcoming Afghan elections. The order predicted that opposing forces would most likely continue their disjointed and unpredictable attacks on soft vehicle targets to “dissuade contractors and the local populous [sic] from supporting ISAF/GIRoA [Government of the Islamic Republic of Afghanistan] operations” and to steal voter registration materials. In either case, the tactics employed would be those used by insurgents working to overthrow a legitimate government. McKiernan’s careful use of language indicated that the term “counterinsurgency” was still controversial to coalition members, who regarded their role in Afghanistan largely as part of a stabilization and reconstruction mission, not as combatants in a protracted war. At the same time, the Americans had been conducting counterinsurgency operations (since 2002, according to some) and, as the lead nation in ISAF, began to infuse counterinsurgency methods and terminology into ISAF language and orders. McKiernan was able to integrate counterinsurgency doctrine into ISAF Order 001-2009, which was synonymous with the USFOR-A order. This change was a shift in thinking and a significant movement toward unity of effort.","The American forces may have regarded counterinsurgency as relatively benign in comparison to high-intensity combat operations against a conventional regional foe, but several ISAF member nations had far different perspectives on their own activities in Afghanistan. In the past, these countries had used morally questionable methods against insurgents seeking to gain independence from European rule, and they were not inclined to repeat this approach in their current military ventures. A few nations, most notably Germany, faced legal constraints to their use of military power abroad. Although European parliamentary members and their constituents were willing to support sustained peace-enforcement operations in conflicts like that in the Balkans, they would not countenance aggressive combat operations that caused either friendly or civilian casualties. The Americans, by contrast, had first entered Afghanistan in response to the September 11th terrorist attacks, and were much more willing to model their counterinsurgency approach after their successful experiences in Iraq during the 2007–2009 timeframe.","${Change of Command}{bold}","Thousands of troops began to arrive in RC South, prepared to carry out the counterinsurgency mission that the Obama administration hoped  would provide greater security and stability to Afghanistan and its beleaguered central government. Even as the new forces began deploying in April 2009, Gates felt that he needed to solve another problem important to both Karzai and Obama: civilian casualties. He agonized over how to make the necessary corrections: “I don’t believe any military force ever worked harder to avoid innocent victims, but it seemed like every incident was a strategic defeat and we needed to take dramatic action.”","McKiernan’s resistance to a new command and control model—combined with some unease with the general—led Gates to consider  if McKiernan was the best choice to command ISAF. McKiernan had been selected at the recommendation of the military’s highest authorities and was well-respected within the Army; nonetheless, the secretary felt he was not the best officer available: “I told Mullen, ‘I’ve got kids out there dying, and if I don’t have confidence I have the very best commander, I couldn’t live with myself.’”","At the time, Admiral Mullen was looking to change the trajectory of the war. He ordered CENTCOM and the Joint Staff to assess the strategy in Afghanistan and the overall CENTCOM area of responsibility. One result of this assessment was the Afghan Hands program, later called AfPak Hands. Brig. Gen. Austin S. “Scott” Miller and Brig. Gen. Michael T. Flynn created the program to subject the best officers from all services to intense culture and language training to generate expertise and a continuous knowledge base. The AfPak Hands were to be assigned to mentor Afghan leaders in the region for one year, return stateside for a year, and then deploy again to the region on a regular basis. In theory, the program looked promising, but in the end, many of the services’ best and brightest did not participate because they were reluctant to venture off proven career tracks. Indeed, it is not apparent if those that did were rewarded with promotion and opportunity. Even before the AfPak Hands initiative, the Joint Staff, led by its then director Lt. Gen. Stanley A. McChrystal, had shifted its focus from Iraq to Afghanistan and Pakistan. It was during this period that McChrystal emerged as the “heir apparent” for Afghanistan.","The U.S. Army’s decision to accept a counterinsurgency framework in Afghanistan did not quell fighting in RC South. More troops were still needed, but unbeknownst to McKiernan, he would retire before the forces he had requested were fully deployed. The first inkling that his command was in jeopardy emerged in March 2009, when Chief of Staff of the Army General George W. Casey Jr. asked McKiernan if he had a good relationship with the chairman of the Joint Chiefs of Staff. McKiernan replied, “Yeah, I think so,” before realizing something was awry. A month after Casey talked with McKiernan, Under Secretary of Defense for Policy Michèle A. Flournoy visited Afghanistan. When she returned, Flournoy told Gates that McKiernan might not be the best man for the job. The specific concerns she raised paralleled his own.","Admiral Mullen and Secretary Gates had come to agree with Petraeus that the United States needed a three-star operational headquarters between ISAF and the regional commands. McKiernan’s resistance to changing the ISAF command structure continued to irritate the Pentagon’s two senior leaders. Putting a layer of command between him and the troops seemed unnatural to McKiernan, and he candidly made his thinking known. By his own admission, McKiernan spent most of his time and energy working laterally and down, not higher. It was a noble sentiment, but it did not endear him to political leaders who had banked their reputations—and their country’s—on the outcome of the prioritized operations in Afghanistan in April. The discussion in Washington, D.C., came to a head when Mullen sought to convince McKiernan to retire of his own accord. Taken aback, McKiernan told Mullen that he had promised the Afghans and others that he would command at least until 2010, and if he and the secretary wanted to replace him, they would have to fire him. Gates spoke to Obama “on several occasions privately,” and the president backed recommendations from Gates, Petraeus, and Mullen to replace McKiernan with McChrystal. Notably, Casey opposed the move, calling it a “rotten thing to do.”","In the end, the decision was Obama’s, and despite the “political ruckus caused by firing the senior commander in the war . . . he was willing to make the change.” On 6 May 2009, Gates flew to Kabul and informed the ISAF commander who “acceded with extraordinary dignity and class.” According to Gates, “Relieving McKiernan of command was one of the hardest decisions I ever made. He had made no egregious mistake and was deeply respected throughout the Army.” The official record notes that the secretary of defense accepted McKiernan’s resignation on 11 May 2009. In reality, McKiernan had been fired.","Despite rumors that he was too conventionally minded for the complex environment of post-Taliban Afghanistan, McKiernan had accomplished a great deal. His initiatives included many things later attributed to others. He had simplified command and control by standing up USFOR-A to relieve CJTF-101 of extraneous Title 10 (i.e., Army support to all services in the Afghan theater) responsibilities. He had developed the basing and reception initiatives needed to enable the surge. He had piloted the Afghan Public Protection Program, which morphed into the Afghan Local Police in Logar and Wardak Provinces. McKiernan also initiated the first Civil-Military Campaign Plan. Signed by McChrystal in August 2009, the document presented a request to surge some 2,000 civilian governance and development experts to Afghanistan so as to accelerate reconstruction efforts.","In a 2015 interview, McKiernan reflected on lessons drawn from his experience as the ENDURING FREEDOM commander. Chief among them was the need for campaign planning to harness all elements of national power into the overall strategy. McKiernan also felt that America’s NATO allies had been drawn into Afghanistan too quickly and given far too much to do. The coalition, including the United States, lacked understanding of Afghanistan and the region. Its inadequate ways to deal with enemy sanctuaries proved impossible to remedy. Additionally, the Americans’ tendency to speak with Karzai through multiple voices—the ISAF commander, Ambassador Holbrooke, other ambassadors, congressional delegations, and the like—distracted from strategic and diplomatic coherence. Finally, McKiernan believed that there was not enough time to build institutions that would last long enough to resonate with Afghans.","General McKiernan noted that American and allied solutions for Afghan problems were inadequate because top-down, international initiatives outweighed bottom-up, Afghan-centric approaches like the Public Protection Program and Local Police. A key example was the constant focus on the size of the Afghan National Security Forces. While quantity was important, McKiernan felt that the quality of leadership was more important and time would be required before a solid cadre of officers could be developed. Even with McKiernan’s abrupt departure, the campaign plan had been developed and postured to attain its strategic objectives. Regardless of which person was in command, the multiyear campaign plan would continue to shape U.S. and ISAF operations in Afghanistan."],"chapter 7":[{"title":"McChrystal’s War"},{"section":["On 11 May 2009, General David D. McKiernan left Afghanistan. His replacement, General Stanley A. McChrystal, would not arrive in country until 15 June. McChrystal had served as Admiral Michael G. Mullen’s director of the Joint Staff, responsible for briefing the chairman on developments in Afghanistan on a daily basis in addition to his many other duties. Despite the five-week gap between McKiernan’s departure and his successor’s arrival, ISAF published Operations Plan 38302 Revision 3 on 1 June 2009 with McKiernan’s signature in absentia. These revisions incorporated the shape, clear, hold, and build language of Counterinsurgency (Department of the Army Field Manual 3–24) in its execution paragraphs, but stopped short of changing the mission statement to “conduct counterinsurgency operations.”"]},{"title":"McChrystal’s Assessment and Opening Moves","level":2},{"section":["McKiernan’s relief changed ISAF’s conduct of the war. McChrystal’s first task upon arriving in Afghanistan was to assemble the  people he needed to assess the situation on the ground. The officer in charge of the ISAF commander’s critical Strategic Advisory Group, Col. Gordon B. “Skip” Davis, had already selected qualified military officers and credentialed scholars to guide the assessment. However, McChrystal preferred U.S. Army officers with Afghanistan experience with whom he had previously served. Davis was replaced by Col. Kevin C. Owens, who had commanded the 173d Airborne Brigade in a previous tour of duty. Col. Christopher D. Kolenda, who had commanded a battalion in Nuristan in 2007, joined Owens. Owens and Kolenda began framing McChrystal’s assessment with members of McKiernan’s remaining staff. Colonel Owens noted the tension:",{"list":["\"When I came over here [to ISAF headquarters], there was some scar tissue in the force—in the headquarters particularly—but also  in the force. Maybe [there was] some resentment in the change [due to] personal loyalty, and that [is] always going to happen . . . the “old team” felt like it was part of the problem. There was also this perception that this “A team” of handpicked guys was here to take over. I’ve never considered myself a “handpicked” guy. Plus it was a U.S.-only team. This created a palpable resentment when we came on board, and frankly, we probably reinforced it at times, whether consciously or otherwise.\""]},"Whereas McKiernan had been hamstrung by an awkward relationship with General David H. Petraeus (who had been his subordinate years before),  a resistance to changing the command structure, and a lack of resources, McChrystal enjoyed a stellar reputation from his previous work in the special operations community and as director of the Joint Staff. He had a positive relationship both with Mullen and with Secretary of Defense Robert M. Gates, who believed McChrystal would bring synergy to the fight. It also helped that the additional troops McKiernan had requested were arriving. McChrystal planned a listening tour, or battlefield circulation, of Afghanistan beginning on 18 June, before he formally received the orders to begin his assessment. The week-long tour included visits to every regional command headquarters and selected lower-echelon locations. Both the assessment team in Kabul and McChrystal’s traveling entourage focused on three basic questions: Can the mission be achieved? If so, how should ISAF accomplish it? Finally, what is required to achieve the mission?","The initial findings were disquieting. It seemed to McChrystal that there were different wars being fought against different insurgencies  in Afghanistan. The Taliban had taken advantage of local grievances and broken government promises to maintain and strengthen their presence on the ground. McChrystal saw this perceived enemy strength as a weakness to exploit. He believed that effective local governments that relied on and were strengthened by a strong national government would be more effective than firepower when it came to defeating the enemies of Afghanistan. He expressed this same belief in his memoirs: “The introduction of minimally decent and competent governance could cause the local resistance to wilt.”","Although this emphasis on governance was not new, McChrystal’s determination to devote more attention to protecting the populace than finding and killing the enemy was a notable shift in the American operational approach. As McChrystal knew, reducing violence would limit collateral damage. After seeing how Afghan populations responded to civilian casualties from an errant airstrike, he realized that “the instinctive way we reacted to alleged incidents made it worse . . . Afghans viewed our skepticism about the validity of their claims as obfuscation, even if we followed our comments with thorough investigations.”"]},{"figure":{"source":"/figures/v2/img_7-1.png","caption":"General McChrystal"}},"The listening tour predated McChrystal’s formal instructions from the Pentagon. On 26 June, Secretary Gates directed CENTCOM commander Petraeus to order McChrystal to conduct an assessment within sixty days upon his assumption of command. On 1 July, NATO issued similar instructions to McChrystal from both Secretary General Jaap de Hoop Scheffer and the Supreme Allied Commander Europe General Bantz J. Craddock. On 2 July, McChrystal received the written order from CENTCOM for the same purpose.","McChrystal wasted no time, immediately implementing a new tactical directive and issuing guidance to reduce civilian casualties. He also began to establish the three-star headquarters desired by Petraeus and Gates. The new command was called ISAF Joint Command (IJC) under American Lt. Gen. David M. Rodriguez, who had served under Mullen on the Joint Staff before taking on this assignment. In November, McChrystal also created NATO Training Mission–Afghanistan (NTM-A) under American Lt. Gen. William B. Caldwell IV to unify NATO and U.S. efforts in building Afghan security forces. Caldwell would continue to command CSTC-A as the U.S. training headquarters. McChrystal utilized his expertise in special operations to initiate changes to first American and then coalition special operations so as to unify their command structures.","McChrystal ordered Revision 4 of COMISAF (Commander ISAF) Operations Plan 38302 to change the mission statement to “conduct population-centric counterinsurgency operations.” It would take several months for this alteration to be approved, as NATO political realities continued to impede American attempts to change the direction of the conflict. Revision 4 adjusted the concept of McKiernan’s four lines of operation, removing information operations and dividing security into three separate lines: protect the population, enable ANSF, and neutralize malign influence. The updated lines of operation now consisted of:",{"list":["1.  Protect the population","2.  Enable Afghan National Security Forces","3.  Neutralize malign influence","4.  Support governance","5.  Support development"]},"The new order needed North Atlantic Council approval, which would not be granted until McChrystal completed his strategic assessment.  Because the new ISAF commander had started the assessment while serving as the director of the Joint Staff, he was armed with a perspective that others may not have had—namely, an understanding of the issues that most concerned the political leadership in Washington. McChrystal requested directives from NATO and CENTCOM to unify the command structure and make his mandate clear: as commander of all U.S. and ISAF forces, he would assess the situation and recommend a way to achieve end-state goals for Afghanistan. Even before he finished his assessment, McChrystal realized that the situation was worse than he thought when he had worked at the Pentagon. Gates learned of this new appraisal when Mullen returned from a trip to Afghanistan in mid-August 2009 and warned the secretary that there would likely be a request for up to 40,000 more troops above the 68,000 already authorized. In response, Gates stated, “I nearly fell off my chair.” Although the secretary could not imagine what all those troops would do, McChrystal could. With nearly half of Helmand’s districts under Taliban control, elections postponed until the fall, and casualty rates accelerating, McChrystal perceived the need for a major shift in both strategy and resources. Even before he submitted his official assessment, he began changing the course of the war.","On 6 July, McChrystal implemented changes to reverse Afghan impressions about the degree to which ISAF cared about civilian casualties.  He coined the term “courageous restraint” while personally authoring parts of a new tactical directive. Key sentences from the document summarized his intent and provided insight as to what his assessment recommended:",{"list":["\"We will not win based on the number of Taliban we kill, but instead on our ability to separate insurgents from the center of gravity—the people.  That means we must respect and protect the population from coercion and violence—and operate in a manner which will win their support. . . . We must avoid the trap of winning tactical victories—but suffering strategic defeats—by causing civilian casualties or excessive damage and thus alienating the people.\""]},"From McChrystal’s perspective, commanders would need to exercise “courageous restraint” when they weighed the possible gains of using close air support and other weapon systems to attack enemy fighters against the likelihood that such methods would harm civilians and further damage Afghan support for the ISAF mission. In a counterinsurgency campaign, as one NATO press statement read, “sometimes the most effective bullet is the bullet not fired.”","McChrystal formally transmitted his assessment to CENTCOM on 30 August 2009. It began by acknowledging that coalition forces aimed to disrupt, dismantle, and eventually defeat al-Qaeda and prevent its return to Afghanistan. In addition, it pointed out the need to prevent the Taliban from returning to power lest Afghanistan once again became a terrorist haven. The assessment called for an overarching civil-military counterinsurgency strategy based on a population-centric counterinsurgency approach to be fostered by ISAF. The report caused some friction, as the counterinsurgency terminology, while palatable in Washington in 2009, meant different things to different people given their familiarity with the basic concept. To some European members of ISAF, counterinsurgency was an escalation away from the stability and reconstruction missions that their people and political leadership were willing to support. To be effective on the battlefield, warfighters needed a clear understanding of how the strategy chosen by their superiors was supposed to drive operations; using the term “counterinsurgency” to define both the strategy and the operational method militated against this clarity.","Terminology aside, the assessment determined that ISAF was not executing its mission properly and needed a new operational culture. McChrystal was best known for his work in the Special Operations community and considered himself a student of counterinsurgency from his time in Special Forces. However, he had never been an architect of counterinsurgency doctrine. Although he had studied irregular warfare, all of his operational experience was in counterterrorism. McChrystal’s improvements in information flow had turned Special Operations raids into an efficient approach to eliminating al-Qaeda fighters and supporters. He was now being called upon to lead a counterinsurgency in an environment that NATO treated primarily as a reconstruction project, a mission for which his prior operational experience had not prepared him.","McChrystal’s proposal called for ISAF to shift to a counterinsurgency strategy based upon four pillars:",{"list":["1. Improved effectiveness through greater radically improved partnering with the Afghan military at every level in order to  prepare them to take the lead in security operations.","2. A series of kinetic operations early in the fighting season to gain the initiative and reverse the insurgency’s momentum.","3. A program to prioritize responsive and accountable governance at all levels, from national to local.","4. The prioritization of resources to those critical areas where vulnerable populations are most threatened—specifically  the eastern border region and the southeastern provinces."]},"McChrystal specified a “properly-resourced” strategy, meaning enough resources to accomplish the mission with acceptable risk based on the theater commander’s assessment, as opposed to a “fully resourced” strategy, which was untenable and defined differently at every level of command. The assessment explained that civilian as well as military resources needed to be applied to problems in Afghanistan. It called on the Departments of State and Justice, as well as other interagency partners, to participate.","McChrystal suggested investing additional resources in Afghanistan, but only after deciding on a new strategy. He feared that numbers  would be mistaken for strategy when, instead, they should be the outcome of objective analysis:",{"list":["\"General Rodriguez and I did not come over here expecting to ask for more forces. Of course we spent so much time together in the  Pentagon talking about it; prepping after the day they directed us to do it [the assessment]. We actually thought we didn’t need any more forces. It was only the analysis that pulled us toward that, and we were actually a little bit surprised by it. But we talked every day during that process, often just one-on-one. We let the analysis pull us where it did. We made decisions based on that. We didn’t just start with a pre-conceived notion.\""]},"Shortly after McChrystal delivered his assessment, the Washington Post received a leaked copy of the document, and published a slightly redacted version a few days later. The leak put President Barack H. Obama in the unenviable position of deciding whether to accept the advice of the military or repudiate it. A pervasive belief that the military was trying to box the president into a single solution complicated his staff’s response to the request, with the result that McChrystal had to wait three months for an answer. The situation increased the friction between military and civilian leadership within the Obama administration.",{"title":"A Disconnect between Ends, Ways, and Means","level":2},{"section":["In a public television interview midway through his assessment, McChrystal articulated what he believed was President Obama’s strategy on Afghanistan:",{"list":["\"Well, I think the decision [as] he described it in that strategy was to do a fully resourced counterinsurgency strategy, to focus on first preventing Al-Qaeda[’s] return to safe havens—it had been here before 9/11—but then also to review the way we fought. And I think that the fully resourced part—that we were going to provide enough forces to do what we felt we had to do— was a major change.\""]},"McChrystal’s understanding that the president had already approved a fully resourced counterinsurgency was reasonable but premature and ultimately incorrect. The president intended to see how well the 21,000 additional troops he had ordered to Afghanistan in February were securing the fall elections before making further deployment decisions. Based on his own experience and the Riedel Report, McChrystal assumed that population-centric counterinsurgency was already being implemented.","While waiting for White House approval, McChrystal took a cue from Gates and NATO secretary general Anders Fogh Rasmussen and changed the ISAF mission to “conduct population-centric counterinsurgency operations” by publishing Operations Plan 38302 Revision 4 in September 2009. When the president formally announced his decision, the national security memo specifically stated that the strategy was not fully resourced, population-centric counterinsurgency. It never had been and indeed never would be.","The ratio of security forces to population drove calculations of how many troops were needed. The accepted wisdom had been that for every 1,000 inhabitants, an intervening force needed twenty troops (a ratio of 50:1) to secure an area with an insurgency. Never did anyone suggest deploying enough foreign troops to approach the 50:1 figure for the entire country, which would have been prohibitively expensive. Most arguments rested upon the assumption that the 50:1 ratio was only necessary in the worst areas and would always be achieved by adding ISAF and ANSF numbers together. McChrystal and Petraeus thought that victory would be achievable with fewer troops than this ratio dictated as long as there was a surge force large enough to clear regions sequentially and enough trained ANSF to hold them once surge forces had shifted to new areas. In the meantime, the surge troops already in country began setting conditions for decisive operations in RC South—namely Operation MOSHTARAK—to be conducted if the second increment of surge units should be approved.","While awaiting a response from the White House, McChrystal and his staff reviewed their options for what to do with the different troop numbers the president could authorize. Recognizing that ISAF would never be able to train enough ANSF or deploy enough of its own forces to obtain the recommended ratio of security forces to population nationwide, McChrystal’s staff looked at what could be achieved by focusing incoming reinforcements on the most volatile areas. This approach appealed to McChrystal, who thought that sequencing could compensate for troop strength. Instead of distributing reinforcements across the theater, he would send them first to Helmand Province, then to Kandahar Province, and finally to selected areas of RC East. This concept depended on the ability of the combined training command to deploy enough ANSF to hold areas cleared by coalition forces. It also assumed that insurgents would not launch offensives in areas of Afghanistan not reinforced by surge forces. Although this approach may have judged the Quetta Shura Taliban’s intentions correctly, it misjudged the strength that sanctuary in Pakistan gave the Taliban and its influence over HIG and other allies."]},{"title":"McChrystal’s Changes in the Command Structure","level":2},{"section":["When McChrystal arrived in June 2009, he began to implement the change in command structure desired by Gates. The incoming commander had the support of Petraeus at CENTCOM, who felt strongly that Operation ENDURING FREEDOM never had the right command structure and needed it now. McChrystal was changing that command structure with the creation of the NATO Training Mission–Afghanistan and the IJC. To give the IJC maximum authority, he recommended granting it operational control of all deployed SOF.","McChrystal stood up the three-star IJC between the four-star ISAF headquarters and the two-star regional commands in September 2009. The new headquarters mirrored the command structure in Iraq in many ways. McChrystal had selected General Rodriguez as his deputy commander for USFOR-A with the understanding that, after NATO’s approval, he would become the inaugural IJC commander. Making Rodriguez both the IJC commander and the USFOR-A deputy commander was a political stretch for NATO; nonetheless, the alliance agreed because it saw value in merging the missions.","Creating a new headquarters came at a cost. The IJC required more than 1,000 coalition staff members just to perform its basic functions. Given the zero-sum approach to troop levels, any increase in staff officers and headquarters personnel invariably led to a commensurate reduction in the number of troops available for many other missions required in the theater. It took all summer and into the fall to fill the new headquarters, with the result that it was not fully operational until 12 November 2009.","Despite the draw on the available workforce, the IJC fostered greater unity of effort among ISAF partners. Although establishing IJC enhanced unity of command, the relationship of specific nations to the overall mission remained complex. Even with the United States in command, every nation still had veto power over implementing any aspect of the U.S.-led strategy. The U.S. and ISAF missions could never be merged fully."]},{"figure":{"source":"/figures/v2/img_7-2.png","caption":"General Rodriguez"}},"Other factors limited the IJC’s ability to influence the fight. After the 2009 Strasbourg Summit, during which NATO heads of state and government discussed the alliance’s strategy for Afghanistan, NATO issued a statement recognizing that “extremists in Pakistan especially in western areas and insurgency in Afghanistan undermine security and stability in both countries and that the problems are deeply intertwined.” The declaration listed many items to which NATO already had agreed, but mentioned Pakistan only once more by noting NATO’s desire to “encourage and support the strengthening of Afghan and Pakistani government cooperation; and build a broader political and practical relationship between NATO and Pakistan.” In reality, the only tangible effect of this relationship was that “NATO offered a few training courses for Pakistani officers and emergency relief on occasion.” NATO never really intended to contribute to counterinsurgency operations in Pakistan in any substantive measure.","Although Obama felt that Pakistan held strategic importance to the United States, Bruce O. Riedel’s recommendation to conduct a counterinsurgency campaign was an operational pathway that the political leadership of the NATO forces under American command would not fully accept. NATO, even under American leadership, did not accept Pakistan as part of the mandate. NATO had never been willing to accept counterterrorism as the mission, nor did it acknowledge counterinsurgency until October 2009. At times, various ISAF nations and even President Hamid Karzai denied the existence of the insurgency itself. As a result, the IJC’s influence stopped at the Afghanistan-Pakistan border.","Lacking NATO support, the United States attempted to work with Pakistan bilaterally. Under an agreement reached in late 2008, SOF stood up a Special Operations command in Pakistan to control Special Forces, civil affairs, and psychological operations units training and advising the Pakistani Frontier Corps. Political considerations constrained the activities and operational areas of this small force, under the command of Col. Kurt L. Sonntag, but its personnel aided the Pakistani military forces who belatedly acknowledged their own growing insurgency.","The Americans got part of what they wanted when NATO approved the establishment of the IJC. Nonetheless, the benefit gained from merging the U.S. and ISAF missions remained elusive. Although both special operations and drone strikes in Pakistan were part of the campaign run by American officers who also held NATO positions, other NATO nations provided little support for these efforts. These limitations aside, the headquarters created efficiencies for ISAF nations and regional commanders. More importantly, it streamlined the chain of command of joint ground forces as U.S. troops in Afghanistan were poised to reach peak levels.","McChrystal wasted no time in refocusing the ISAF staff. A key component was his selection of Maj. Gen. Michael T. Flynn as his chief  intelligence officer or J2. Flynn quickly and correctly assessed that the intelligence infrastructure in Afghanistan was built to support tactical operations and did little to support operational and strategic objectives. In Flynn’s own words:",{"list":["\"Eight years into the war in Afghanistan, the U.S. intelligence community is only marginally relevant to the overall strategy.  Having focused the overwhelming majority of its collection efforts and analytical brainpower on insurgent groups, the vast intelligence apparatus is unable to answer fundamental questions about the environment in which U.S. and allied forces operate and the people they seek to persuade. Ignorant of local economics and landowners, hazy about who the powerbrokers are and how they might be influenced, incurious about the correlations between various development projects and the levels of cooperation among villagers, and disengaged from people in the best position to find answers—whether aid workers or Afghan soldiers—U.S. intelligence officers and analysts can do little but shrug in response to high level decision-makers seeking the knowledge, analysis, and information they need to wage a successful counterinsurgency.\"","To achieve the objectives outlined by the Obama administration, the intelligence community would need to make changes in how it conducted daily operations. The U.S. military as a whole would also need to make a huge investment in intelligence, surveillance, and reconnaissance equipment. Flynn thus faced an almost insurmountable challenge as he sought to reorient and restructure intelligence operations in Afghanistan in time to have a tangible impact on the campaign envisioned by McChrystal."]}," ",{"title":"RC South Becomes the Main Effort","level":2},{"section":["The majority of the reinforcements approved by President George W. Bush in late 2008 and by President Obama in February 2009 were committed to executing McKiernan’s plan for RC South. Most of the troops were American—even though command of RC South had rotated through British, Canadian, and Dutch leadership—because the other nations could not generate sufficient domestic political support for deploying the troops necessary for this dangerous work.","The United States faced resource limitations as well. The Marines and Army were deployed to maximum capacity in Iraq and Afghanistan, and also were occupied with training requirements. Even approved requests for forces took time to fill and deploy to theater. Knowing that the Marine Corps had immediately available units, Pentagon leaders chose them to secure Helmand Province. It helped that the Marines wanted their own battlespace and that Helmand provided a relatively uncongested airspace for their fixed-wing aircraft and helicopters. In the end, increased enemy activity made the most pressing argument for committing troops in Helmand.","The legitimacy of the Afghan presidential and provincial council elections planned for 2009 would be heavily dependent on the Pashtun population. Since Pashtuns were concentrated in the south (and east) of Afghanistan, McKiernan had planned to expand security in the south before the elections. The former ISAF commander had requested reinforcements of 21,000 troops from the Bush administration for this purpose, and Obama had approved the request. Kandahar, the largest population center in the south, seemed the logical place to receive the influx. However, the British government had lobbied for help in neighboring Helmand, and the U.S. Marines, available first, preferred to operate there. McKiernan agreed that Kandahar, although more important, was the less prudent choice in an election year.","The Marine Corps formed Marine Expeditionary Brigade–Afghanistan specifically for Helmand. In mid-2009, Marine forces flooded into  southern Helmand to seize control of the logistical lines providing the Taliban’s lifeblood: opium outward bound, money and manpower inward bound. As expressed by a Marine officer, “Helmand is the Taliban’s Ruhr Valley—its industrial base,” likening it to the western German industrial region that had supplied the German armies in both of the twentieth century’s world wars. Even though that opinion could be seen as somewhat exaggerated, considering that Pakistan’s tribal areas were the primary source of personnel, training bases, and equipment depots for the Taliban, Helmand Province was a key component in the financial network funding the insurgency. Not only had Helmand Province become the source of 45 percent of the world’s illegal opium, its population was 92 percent Pashtun. In addition, the British were unable to operate in large, unoccupied swathes of terrain by themselves.","Marine commanders recognized that the decisive showdown would take place in the population clusters surrounding the provincial capital of  Lashkar Gah and the district centers of Nawah-ye Barkaza’i, Marjah, Nad ‘Ali, Sangin, Now Zad, and Girishk. Taliban cells effectively ruled in these districts and towns, often coordinating their activities with sympathetic tribal elders, poppy farmers, and drug lords. In addition to harassing ISAF patrols, insurgent groups massed to attack coalition bases and police checkpoints, pinning down the security forces while advertising Taliban supremacy in the region. One marine officer summed up the dilemma affecting ISAF efforts to bring government presence and security to Helmand: “The local cops and the farmers know who the Taliban are. We’re the ones in the dark.” The marines were determined to regain the initiative by extensive and aggressive patrolling, always in conjunction with a like number of Afghan police or soldiers. They sought to secure key towns in the Helmand River Valley, starting near Lashkar Gah, and in critical districts such as Sangin.","A surprise air assault into Nawah-ye Barkaza’i gave the marines a solid base from which to operate. Units quickly pushed south toward Garm Ser, Khan Neshin, and even to Bahram Chah, a border town with a lawless reputation. The Taliban responded to the sudden vigor of ISAF activity by boxing the marines in with IEDs, forcing them to allot more troops to force protection and more surveillance assets to monitor busy transit routes and points. When outgunned, local Taliban kept a few steps ahead of the marine wave, side-stepping or even relocating in Pakistan. The marines could claim to have cleared a vast swath of the Helmand River Valley, but the extent of their actual control of the valley remained in question.","In early 2010, the marines focused their operations on the nearby town of Marjah in southern Nad ‘Ali District, only twenty-five kilometers southwest of Lashkar Gah. Its population consisted mostly of transplanted Pashtuns who had little loyalty to anyone outside their own village. One of the largest known Taliban sanctuaries in Afghanistan, Marjah was a nexus for insurgents reaping economic gain from Helmand’s poppy industry and a base from which they launched attacks into Helmand’s capital. The Taliban found easy refuge here and adequate support for their reemergence in Helmand in 2006–2008. Local farmers growing poppy readily teamed with Taliban cells to protect their fields from government-sponsored eradication efforts. This relationship allowed both the Taliban and narcotics traffickers to operate freely in the populated areas.","Even though ISAF had launched major operations in and around Marjah since the summer of 2009, it had failed to break the Taliban’s hold on the region. Many insurgents simply avoided coalition sweeps, leaving behind hundreds of IEDs and occasionally snipers to distract and weaken ISAF forces. At the same time, enemy commanders called for reinforcements from Pakistan, showing the Taliban’s willingness to fight for Marjah and its surrounding communities. Consequently, Taliban fighters avoided contact when they wanted to and flowed into vacated areas when they came under pressure from ground operations.","Special operations raids into Marjah during 2009 increased pressure on Taliban leaders and gained critical intelligence for the plan developed by RC South commander British Maj. Gen. Nicholas P. “Nick” Carter. Intelligence analysts estimated as many as 1,000 fighters were dug in amid hundreds of IEDs. The town’s buildings and canals provided opportunities for IED and mine strikes, ambushes, and sniper attacks, as the Taliban drove ISAF forces into kill-zones. Evidence suggested that these Taliban fighters were more experienced and tactically proficient than usual, and may have included foreign fighters trained in Pakistan.","The persistent threat of Taliban actions against civilians in the form of IED attacks, night letters (unsigned intimidating messages  from the Taliban, warning locals that they would face reprisal for cooperating with foreign forces), and assassinations undermined the promise of the coalition: side with the government, and the government will protect you. McChrystal and Carter recognized this obstacle and were determined to make Helmand a successful example of how to conduct counterinsurgency operations. McChrystal also recognized that legitimate elections were critical to maintaining a viable partnership with the Afghan government. Otherwise, the military campaign would have no end."]},{"figure":{"source":"/figures/v2/img_7-3.png","caption":"Soldiers from A Company, The Highlanders, 4th Battalion, The Royal Regiment of Scotland"}},"Marjah had been a known Taliban stronghold for months. McKiernan and his RC South commander had known that the town had to be cleared and secured, but wanted to wait until after the elections before initiating what likely would become a bloody battle. Everyone involved believed the effort would require U.S. air assets and troops. These would become available at almost the exact moment that McChrystal arrived in Afghanistan.","${Shaping Operations}{bold}","Even before ANSF units had been designated for the mission to hold RC South, U.S. forces began clearing operations in the region. By summer 2009, time was running short as the new date of the elections was set for 20 August. McChrystal knew his strategy and the additional troops approved in February needed to show progress quickly. He understood that early success would improve the chance that the National Security Council would approve his recommendations in the strategic assessment. With the Marines already clearing villages in the Helmand River Valley, McChrystal wanted to use ISAF’s success in securing the elections as proof that his campaign was progressing.","With additional forces still arriving into RC South and only two months until ballots were to be cast, ISAF conducted one of the largest operations of the war. On 19 June 2009, British, Danish, and Afghan troops launched Operation PANCHAI PALANG (Panther’s Claw) to secure portions of the Helmand River Valley near the provincial capital of Lashkar Gah. The mission had varied results. ISAF troops suffered several casualties from IEDs, including a British infantry battalion commander. Intelligence confirmed Marjah as the main enemy stronghold. PANCHAI PALANG eliminated the Taliban fighters caught between the attacking units, but it did nothing to reduce the enemy operating just outside the area secured by ISAF troops.","On 2 July 2009, more than 4,000 marines of Marine Expeditionary Brigade–Afghanistan and 650 Afghan soldiers launched a sequel to PANCHAI PALANG called Operation KHANJAR (Strike of the Sword) in the Helmand River Valley. Although marines had been fighting in Afghanistan since 2002, KHANJAR was the largest helicopter insertion conducted by the U.S. Marine Corps since the Vietnam conflict. Lt. Col. William F. McCullough’s 1st Battalion, 5th Marines, and Lt. Col. Christian G. Cabaniss’ 2d Battalion, 8th Marines, assaulted into Nawah-ye Barkaza’i and Garm Ser Districts respectively, courtesy of the U.S. Army’s 82d Combat Aviation Brigade. British, Estonian, and other coalition forces followed to establish security. Initially successful, the Marines reported problems getting local leaders to support operations in Helmand. When possible, marines asked elders for support before missions so as to prevent collateral damage and civilian casualties. Elders in the hamlets of Helmand responded that they had seen similar, smaller operations for each of the past four summers, and told the marines that the Taliban had returned after these previous operations to retaliate against those who had aided coalition troops.","In early August, Marine Expeditionary Brigade–Afghanistan continued clearing operations in Helmand with Operation EASTERN RESOLVE II. In bazaar raids south of Garm Ser, near Khan Neshin, the brigade seized over fourteen tons of raw opium and a plethora of IED-making materials, along with other weapons. Despite local skepticism, the three operations had secured Helmand Province temporarily for the upcoming elections. While the decrease in violence provided more Afghans with the opportunity to vote, the local populace’s Pashtun sympathies, coupled with long-standing discontent with the Kabul government, did not guarantee a large turnout at the polls.","Operation KHANJAR could now be seen as a rehearsal for the larger Operation MOSHTARAK, which would clear Marjah in early 2010. The methods and tactics used in KHANJAR were employed again in MOSHTARAK the following year. While KHANJAR was underway, U.S. Army units were starting to arrive in Kandahar, where they began their own shaping operations.",{"figure":{"source":"/figures/m/map-figure-7-4.svg","caption":"Operations PANCHAI PALANG and KHANJAR","prefix":"MAP"}},"","","In July 2009, just a month before the Afghan national elections, the 5th Brigade Combat Team, 2d Infantry Division, arrived from Fort Lewis, Washington, to fill McKiernan’s 2008 request for a Stryker brigade for Kandahar. The 4th Brigade, 82d Airborne Division, would soon follow with the mission to partner with Afghan Army units. One battalion would partner with Afghan forces in RC West, and the remainder would work in RC South. The Stryker brigade’s deployment differed from those of other U.S. Army units for several reasons. First, the 5th Stryker Brigade (as it would be known) was the only Army brigade in Operation ENDURING FREEDOM to serve its entire tour as a battlespace-owning unit under the command of a non-U.S. general. Second, they were the first U.S. Army brigade deployed to RC South for the surge. The unit featured the M1126 Stryker, a wheeled combat vehicle with advanced digital technology. No other command in Afghanistan was built around this system. The Kandahar mission would be the 5th Stryker Brigade’s first combat deployment since its activation.","The deployment of the 5th Stryker Brigade to Afghanistan is critical to understanding Operation ENDURING FREEDOM during the initial troop increases authorized by the Bush administration. The ways in which the unit interpreted its mission, understood its enemy, and reacted to the enemy sanctuary in Kandahar were notably different than the mindset and actions of other units deployed at the same time. Friction quickly developed between the brigade commander and the ISAF-appointed RC South commander over the unit tactics involved in a counterinsurgency fight. The deployment of the 5th Stryker Brigade culminated not only in battles that killed hundreds of insurgents but also in war crimes that killed several innocent civilians. The brigade’s leadership suffered negatively from these events and the unit’s legacy would be tarnished for years to come.","To understand the problems surrounding the 5th Stryker Brigade’s time in Afghanistan, it is worth taking a closer look at the circumstances of its training and assignment. In February 2009, in preparation for a long-anticipated deployment to Iraq, the brigade was conducting its mission-readiness exercise at the National Training Center at Fort Irwin, California. On 21 February 2009, the brigade commander, Col. Harry D. Tunnell IV, interrupted the exercise to inform his brigade that it was now going to deploy to Afghanistan. The fact that the 2d Infantry Division’s 5th Stryker Brigade would be sent to Afghanistan instead of Iraq was neither ideal nor unique. Other units, such as the 3d Brigade Combat Team, 10th Mountain Division, in Wardak and Logar Provinces, had received the same change of mission. However, preparation for the two conflicts differed greatly. For example, the brigade had trained about 120 soldiers to speak Arabic, which would now be largely unhelpful as Arabic is not widely spoken in Afghanistan. Although the unit wore the patch of the 2d Infantry Division, the division was headquartered in Korea and not responsible for preparing the brigade to deploy. Therefore, the I Corps assumed this role. The I Corps and FORSCOM approved a letter delineating the training for the brigade that Tunnell wrote using CENTCOM’s prescribed training matrix for deploying forces. This matrix referred to Counterguerrilla Operations (Department of the Army Field Manual 90–8), but not Counterinsurgency (Department of the Army Field Manual 3–24). As a result, the 5th Stryker Brigade’s training focused on a different doctrine than the one that McChrystal intended to employ for U.S. operations in Afghanistan.","The 5th Stryker Brigade’s mission rehearsal exercise showed the friction between the training design and the mission that the unit would assume in Iraq and subsequently Afghanistan. Colonel Tunnell wanted his unit trained in high-intensity battle, the worst-case scenario of any combat action, at a time when the Army’s training centers had switched to providing more discreet scenarios resembling their interpretation of conditions in Iraq and Afghanistan. Although Tunnell was aware that the National Training Center had switched emphasis from its previous focus on high-intensity combat, he was disappointed that his formal request for such training could not be accommodated. Tunnell was sure that the National Training Center’s leadership was misinterpreting the fight his brigade might face in Afghanistan. After arriving at Fort Irwin, the Stryker brigade commander did not endear himself to the trainers by insisting on using more counterguerrilla doctrine rather than population-centric counterinsurgency doctrine to guide his unit’s operations.","Tunnell disagreed not only with the National Training Center and CENTCOM on the nature of the fight, but also with the U.S. and  ISAF mission concepts. The current mission in the NATO-led RC South, where 5th Stryker Brigade would operate, was not the same as the American-led RC East mission. The mission in RC East was to “conduct full-spectrum operations” through 2008 and then changed to “conduct counterinsurgency operations” in April 2009. In RC South, the term “conduct counterinsurgency” was not yet included in the mission statement. The paragraph in the operations order describing the enemy situation in RC South began:",{"list":["On 10MAR09, the Insurgent Syndicate (INS) initiated a “Tet-like” [surprise] offensive in RC-South starting with a major attack in Kandahar Province followed a few days later with another large-scale attack in Helmand Province. INS forces in RC-South are now equipped with more sophisticated air defense and anti-armor weapons systems. Enemy main effort remains in Kandahar Province to fix coalition forces allowing the INS freedom of maneuver."]},"Despite the word “insurgent” in the order, the then RC South commander, Maj. Gen. Mart de Kruif, had avoided the term counterinsurgency,  preferring a mission statement that read:","RC South partnered with ANSF neutralizes insurgent syndicate influence and secures critical areas in order to establish and maintain a safe and secure environment that extends government authority and influence facilitating Afghanistan’s reconstruction and enabling the GIRoA [Government of the Islamic Republic of Afghanistan] to exercise its sovereignty throughout the country.","Although the RC South operations order did not state “conduct counterinsurgency operations,” it did include counterinsurgency doctrinal language. The paragraph on commander’s intent even gave a nod to the term “population-centric.”",{"list":["${Commander’s Intent}{bold}. In partnership with ANSF we will concentrate our resources to SHAPE, CLEAR, HOLD and BUILD [emphasis in original] critical areas in order to enable GIRoA [Government of the Islamic Republic of Afghanistan] to deliver improved Governance, Security and Development within the framework of our ‘population-centric’ regional plans. We will continue to operate in partnership with the ANSF and the International Community (IC) to synchronize our efforts across all LOEs [lines of effort] and bring greater coherence to operations in Southern Afghanistan. The Operational Center of Gravity in RC-South is the population’s support of the provincial governments and ANSF. This will deny the insurgent syndicate (INS) access to the population and serve to separate the INS from Afghan citizens both morally and physically."]},"The campaign plan for RC South consisted of three lines of operations: security, governance, and development. This approach  was not called counterinsurgency, but it closely resembled the definition in Field Manual 3–24. Tunnell deployed his brigade with the understanding that it would serve as a clear-and-hold force, which would indicate a more offensive mission oriented on security rather than the other two lines of operations. Indeed, the RC South operations order defined the operation as offensive, continuing to describe how offensive operations would neutralize the insurgency:",{"list":["Decisive to this operation is RC-South’s ability to neutralize the INS [insurgent syndicate] and maintain the lines of communication in our AOR [Area of Responsibility]. Upon completion of the attacks on OBJs [Objectives] COBRA and VIPER, RC-South resumes civil security throughout the AOR to establish and maintain a safe and secure environment that extends government authority and influence facilitating Afghanistan’s reconstruction and enabling the GIRoA [Government of the Islamic Republic of Afghanistan] to exercise its sovereignty throughout the country."]},"From the outset, General de Kruif and his staff had reservations about how the 5th Stryker Brigade Combat Team would achieve this.  While Tunnell understood that RC South’s mission was to neutralize the enemy, he chose “defeat” as the core mission for his own unit: in essence, to temporarily or permanently destroy the enemy’s physical ability or will to fight, whether by using or threatening the use of force. When Tunnell explained his understanding of his mission and key tasks at the commander’s backbrief, de Kruif disagreed. The American colonel had used the terms “interdict” and “clear” to describe specified tasks from RC South for his unit, indicating that he saw his mission from a more offensive perspective, in which he and his unit would eliminate enemy fighters and organized resistance within their assigned area. De Kruif stopped the briefing and expressed concern that this was not what he wanted. He did not think interdicting was a brigade-level task, and he disagreed with Tunnell’s choice of that term. The Dutch general clearly thought Tunnell was too offensively focused. American Brig. Gen. John W. “Mick” Nicholson Jr., serving as RC South deputy commanding general for stability, was not present at the backbrief but later attempted to mediate the misunderstanding by restraining Tunnell from conducting offensive clearing operations.",{"figure":{"source":"/figures/v2/Img_7-4.svg","caption":"Note on U.S. Military Tactical Terminology"}},"Tunnell disagreed with his superiors on the interpretation of his mission. To him, “neutralize insurgents” implied offensive military force used to clear and hold terrain, in order to prevent enemy fighters from operating in the area. McKiernan had requested the Stryker brigade specifically for its unique capabilities. De Kruif wanted to use nonlethal methods and operations, such as reconstruction and development projects, to achieve the effect “neutralize,” which he thought more appropriate for the build phase of counterinsurgency. The higher standard of defeat was Tunnell’s own doctrinal interpretation. As long as he was defeating the enemy forces, he was also neutralizing them as the higher order directed. Other ISAF commanders, however, regarded Tunnell’s emphasis on a more offensive approach with skepticism, and sought to remind him that nonlethal effects were just as important or even preferred in the counterinsurgency environment being established in Afghanistan. These differences of opinion magnified the long-standing friction within ISAF about how to interpret and implement counterinsurgency doctrine.","Despite misgivings about Tunnell’s views of tactical priorities, de Kruif recognized that the Strykers had capabilities that would prove useful in RC South. Just before the August 2009 national elections, de Kruif tasked Tunnell’s brigade with securing parts of Kandahar and Zabul Provinces known to harbor Taliban fighters. On 18 August, two days before Afghans went to the polls, the enemy attacked a Stryker in Lt. Col. Jonathan A. Neumann’s 1st Battalion, 17th Infantry, with an IED. The damage to the vehicle was so severe that one soldier could not be found or identified. When Tunnell requested additional assets to search for the missing soldier, de Kruif directed all forces under his command to support every Stryker brigade request as much as possible. During the search, another soldier was reported missing following a second massive IED blast. It took two days of intense fighting to locate the remains of both soldiers, during which time six more soldiers were wounded. Ten enemy fighters were confirmed killed and an unknown number wounded.","Enemy contact increased whenever Strykers approached the area near the river in Arghandab District known as “the Green Zone.” Because of its dense vegetation and lack of intensive patrolling, the enemy had chosen Arghandab as its home. The Canadians had not been able to hold the Arghandab District after Operation MEDUSA in 2006, and so it and the neighboring districts of Maywand, Zharey, and Panjwa’i had become insurgent bases. This was not a place insurgents came to train and store weapons, nor was it a transitory safe haven. The Arghandab District was where the enemy lived: he would stand and fight for this terrain. An assault on it would be exactly the high-intensity fight for which the Strykers had trained. Tunnell was determined to neutralize the district.",{"figure":{"source":"/figures/v2/img_7-5.png","caption":"A Stryker combat vehicle"}},"Intelligence estimated thirty to forty enemy fighters in the entire area of the Arghandab, but future operations would show that that estimate was far too low. Tunnell directed a deliberate attack, Operation OPPORTUNITY HOLD, to seize a foothold in the Arghandab from which the brigade could conduct subsequent clearing operations. Nine days after the elections, 5th Stryker attacked. In the IED-laden Arghandab, the clearing operation required the brigade to breach multiple belts of obstacles that the enemy had laid throughout the terrain. The Stryker was fast, quiet, and able to carry an infantry squad and its equipment over long distances, which made it ideal for surveillance missions, but unlike the MRAP vehicle with its V-shaped hull, it was vulnerable to mine strikes. To address this deficiency, troops cleared the area on foot with Strykers in support-by-fire positions.","Operation OPPORTUNITY HOLD lasted an entire month and was immediately followed with Operations FOCUS HOLD and SUSTAIN HOLD.  These operations lasted until November 2009 and generated the majority of 5th Stryker Brigade’s own casualties: 35 killed in action and 239 wounded. In Arghandab, the Stryker brigade killed fifty insurgents and wounded a sizeable but unknown number as well. During OPPORTUNITY HOLD, it became clear that the new estimate of 200 insurgents was still too low. Instead, a battalion-sized unit of 300–400 Taliban fighters operated from the Green Zone of Arghandab. The fighting continued as the enemy-controlled area gradually shrank. Although the Stryker soldiers were making progress, each victory came at a cost of more killed and wounded. Each casualty report generated renewed discussion of Tunnell’s methods among military leaders in Afghanistan. The IJC commander, General Rodriguez, wondered if the casualties could be attributed to Tunnell’s tactics, rather than considered as the price of having left the enemy to his own devices in and around the Arghandab for years. Yet even with these concerns about the 5th Stryker Brigade’s use of counterguerrilla tactics during the clear phase of their operations, Tunnell and his solders also implemented counterinsurgency tactics in the hold and build phases. The unit aggressively applied nonlethal means as well, dispersing millions of dollars from the Commander’s Emergency Response Program—54 percent of the total for RC South during this period—toward urgent civilian needs even before clearance operations were complete.","In the first months of its deployment, the 5th Stryker Brigade had helped secure the elections. However, its aggressive tactics gave it a reputation among the new RC South leadership, one that was not necessarily beneficial for the brigade or its commander. Tunnell had received mentorship from the I Corps deputy commander at home station, but his unit was now part of a larger U.S. division deployment in which the senior leaders were not necessarily focused on the same training objectives. Although mentoring offered part of the answer, the U.S. Army was still grappling with understanding its own newly devised counterinsurgency doctrine and allies who had a totally different interpretation. Tunnell’s experience was brought on by his and his unit’s own doing, but was amplified exponentially under NATO command.",{"title":"Unexpected Developments in RC East","level":2},{"section":["The most obvious example of how important elections were to McChrystal came in Nuristan Province, where he imposed a moratorium on realigning or closing coalition bases until votes had been counted. Small outposts in remote locations had been attacked previously and were still vulnerable. A 3 October 2009 attack on one of the bases that had been kept open for the elections became the most telling and important event in RC East—and perhaps the entire theater. The assault on Combat Outpost KEATING, as in earlier instances, resulted in devastating losses for the attackers, with U.S. forces weathering the storm albeit with numerous casualties. Although the attackers would have preferred to achieve an unequivocal victory by overrunning their objective and eliminating the defending American and Afghan troops, the Taliban and their allies were just as willing to trade lives for the sustained global media coverage that invariably accompanied every dramatic turn of events on Afghan battlefields. The strategic messaging effect was worth the loss of fighters to the Taliban.","${Combat Outpost Keating}{bold}","The events before the assault on KEATING illustrate both the potential and the pitfalls of counterinsurgency theory. Lt. Col. Joseph M. Fenty’s 3d Squadron, 71st Cavalry, from the 10th Mountain Division’s 3d Brigade Combat Team, originally established then Camp Keating in 2006 to secure the local road networks and to provide a secure location from which the Kamdesh Provincial Reconstruction Team could expand economic opportunity and promote local governance in eastern Nuristan Province. It was also the one location where U.S. forces could interdict road traffic from Barg-e Matal, an insurgent base area on the Pakistan border. Although ideally suited for these campaign-related priorities, the outpost was poorly situated from a tactical perspective. It stood at the bottom of a valley surrounded by towering mountains, linked to the outside world by a single unimproved road.","In 2007, Lt. Col. Christopher D. Kolenda’s 1st Squadron, 91st Cavalry, which replaced the 3d Squadron, 71st Cavalry, began to comprehend the situational reality in Kamdesh District. Fighting was seasonal, with hardened cadres flowing in from Pakistan during the late spring and early summer to reinforce local insurgents who knew the terrain and people. During the fighting season, local power brokers refused to meet with Americans, and fewer young men were available for projects. These details indicated that a popular insurrection was forming around isolated KEATING at the apex of the valley. Successive troop and company commanders followed the counterinsurgency template and at times appeared to be making progress using money and words instead of bombs and bullets. The results, though, were personality-dependent and therefore transitory and not exportable. Throughout Combat Outpost KEATING’s lifespan, the incontrovertible evidence was that the locals, even when protected and financially supported by the Americans, did not accept the presence of the newcomers. No amount of aid would suffice to convince them to accept the authority of the government in distant Kabul or tolerate the presence of uninvited foreigners.","S. Sgt. Clinton L. Romesha, who was awarded the Medal of Honor for his actions during the 3 October engagement, later described KEATING as “tactically indefensible.” Unfortunately for successor units, the original decision to spread security forces across the region from 2006 and beyond did not envision the enemy massing against the isolated posts. As a result, force protection was accorded a lesser priority, as counterinsurgency doctrine suggested it might. Initial operations confirmed the wisdom of taking this tactical risk, but progress was slow over the next few years. Police, government officials, and tribal leaders who had been working with the Americans in the area had faced a mounting insurgent backlash, causing the populace to back away from American and Afghan government assistance. Taliban fighters maintained the initiative, eventually closing the one road connecting KEATING and the Kamdesh Provincial Reconstruction Team with other coalition units. Lack of additional resources meant that security remained too frail to enable a build phase, and the area around KEATING had yet to be fully cleared. The original rationale for establishing the position was increasingly irrelevant.","While preparing to deploy to Afghanistan, the commander of 3d Squadron, 61st Cavalry, Lt. Col. Robert B. “Brad” Brown, and his brigade commander, Col. Randy A. George of 4th Brigade Combat Team, 4th Infantry Division, planned to close Combat Outpost KEATING. They believed the outpost’s remote location made it unimportant to the counterinsurgency campaign as the resources it absorbed could be spent more profitably elsewhere. In the past three years, U.S. forces at the outpost had not expanded the Afghan government’s reach, and the scarce resources meant that progress in the area would remain far below expectations for the foreseeable future.","Before deploying in spring 2009, Brown and George briefed their plan for the outpost to the CJTF-82 commander, Maj. Gen. Curtis M. Scaparrotti, who agreed but never approved the extensive resources needed to execute the closure mission. Therefore, Brown’s troopers occupied KEATING with the intent to shutter it as quickly as possible. Their logic reflected McChrystal’s focus on the population centers, which KEATING was not. Proximity to population centers was not a new criterion in deciding where to position forces, but it trumped competing concerns in RC East after the Battle of Wanat in 2008.","During a routine battlefield circulation, McChrystal visited Forward Operating Base BOSTICK where Brown presented his case for  realigning forces, which included closing KEATING and other isolated posts within six weeks. The tactical commanders knew that closing any outpost required airlift assets, which were scarce and needed to be allocated. Brown pitched the closures to McChrystal during his visit so as to alert him that this request would be forthcoming. Brown believed “the presence of the camps had actually worsened the security situation in Nuristan.” But even though McChrystal agreed with the logic of closing bases, he had strategic concerns. Karzai feared that any realignment or closure would be interpreted as a withdrawal: a sign that the American military lacked faith in the Afghan government. This visible retreat would deter turnout in the national election, especially among Karzai supporters. McChrystal wanted to be seen as supporting Karzai, yet at the same time he wanted to avoid the perception in Washington that he was acting in advance of a decision on his strategic assessment. “I don’t want to get ahead of the president,” he told George. McChrystal understood that any realignment could be seen as pulling out troops and could appear as if some bold decision had been made.","Another factor emerged just before the elections. Pfc. Beaudry R. “Bowe” Bergdahl had left his small outpost near Forward O perating Base SHARANA in Paktika on 30 June 2009, and nearly every unit in RC East made his recovery a priority. In addition to conventional units already operating there, Special Operations elements with responsibility for missions across the entire breadth of Afghanistan refocused their efforts on RC East. Every bit of information on Bergdahl’s location, regardless of its plausibility, had to be verified by sending soldiers to the location in question. Troops were shuttled from location to location via helicopter in quick succession in an attempt to catch the Taliban as they shifted their captive from one location to another. The constant movement of troops, combined with their attendant logistical needs, overwhelmed RC East’s already overtasked helicopter fleet. With the search area expanding in scope as time passed, the committed airlift would not be available for other missions until long after the elections.","As if to emphasize McChrystal’s point about perceptions during the election, Karzai asked him for help in the town of Barg-e Matal in northern Nuristan. This town was within George’s boundaries, but it had never been cleared by conventional troops. Karzai was concerned with a recent Taliban takeover, which he needed to reverse before the election. Barg-e Matal, being even more remote than KEATING, was difficult to reach and would be even more difficult to hold. KEATING was the closest U.S. outpost with a helicopter landing pad. ISAF, IJC, and some on the RC East planning staff saw it as a forward arming and refueling point for operations in Barg-e Matal. Brown and others in his command informed the planning staff that the landing zone at KEATING was a tiny flat space in a creek bed, which supported only one aircraft at a time and was safe only at night. Nonetheless, RC East and ISAF staff planners continued to believe that KEATING could support operations in Barg-e Matal.","A combination of unforeseen factors, including the Bergdahl search and the Barg-e Matal mission, delayed the closure of KEATING for almost two months. During that period, Colonel Brown ordered his troops to ship out of KEATING everything deemed nonessential to the outpost’s defense, in order to close KEATING quickly once they received approval to withdraw. (This common practice is referred to as “getting light.”) They did not, however, remove items needed for force protection, because the Taliban often sent small detachments to test the KEATING defenses. These incidents had occurred almost weekly since early 2008, and as the combined U.S.-Afghan garrison prepared to shut down the outpost they did not feel that these relatively minor Taliban incursions warranted them spending additional time and resources to improve their defenses.","At 0558 on 3 October, the Taliban attacked KEATING in strength. The attackers were able to mass undetected because the available unmanned aerial vehicles could not monitor the surrounding area on a regular basis. The assault opened with a bombardment by rocket-propelled grenades and numerous automatic weapons directing fire at the heaviest weapons available to the garrison. The incoming fire pinned down U.S. and ANA mortar crews, inflicted casualties, and suppressed all vehicle-mounted heavy weapons. As soon as the opening barrage ended, the attackers breached the perimeter section held by the ANA. After killing or wounding all of the Afghan soldiers who did not flee, the Taliban attempted to penetrate the U.S. portion of the outpost. In a grueling, close-range firefight, the Americans overcame the attackers, killing or driving out all of the Taliban who had managed to breach the KEATING perimeter."]},{"figure":{"source":"/figures/m/map-figure-7-7.svg","caption":"Attack on COP KEATING"}},"It took almost thirty minutes for helicopter gunships to be launched in support of the beleaguered outpost. Close air support by a pair of F–15E Strike Eagle fighters began orbiting above KEATING forty-one minutes after the assault began. At 0648, the fighters began making strafing runs and dropping bombs on enemy positions overlooking the outpost. Fifteen minutes later, the first team of AH–64 Apache gunships arrived. Although their appearance meant the defenders now had a decisive advantage in firepower, the Taliban continued the fight. Medical evacuation helicopters made several attempts to lift the wounded out of KEATING, but heavy incoming fire forced them all to turn back. Worn down by an unrelenting aerial assault, the enemy retreated as U.S. ground reinforcements neared KEATING. The battle had lasted nine hours from start to finish. Eight U.S. and three Afghan soldiers, as well as dozens of their assailants, died during the engagement, while numerous enemy fighters, twenty-two U.S. soldiers, and five Afghan soldiers were wounded.","${Folding up Valley Outposts in Kunar and Nuristan}{bold}","Insurgents portrayed the American withdrawal from KEATING as a significant victory. This claim is not entirely accurate, as the redeployment was driven less by enemy pressure and more by the fact that the outpost had little to no impact on the counterinsurgency campaign. In political terms, the local population had learned a hard lesson about staying power. An insurgent cadre with guns in a mountainside cache could outlast an American platoon backed by artillery and air support. Insurgent leaders could call upon dozens or even hundreds of fighters to descend on small mountain communities whenever it suited them. As retired Lt. Gen. Douglas E. Lute, former deputy national security advisor, recalled General John P. Abizaid saying, “Our presence itself, when it is sustained, in countries and cultures like in Iraq and Afghanistan creates antibodies against our presence itself.”","The battle at Combat Outpost KEATING exemplified the limits of Field Manual 3–24 ${Counterinsurgency}{italic} and McChrystal’s tactical directive. Although KEATING’s location, geography, and history made it a unique example, it was also emblematic of larger issues. Tactical commanders up to the brigade level had struggled with the outpost’s location, task, and purpose from its establishment in March 2006, but it was only in 2009 that officers seriously considered closing KEATING. Just weeks before KEATING would be attacked by hundreds of enemy fighters, McChrystal visited the brigade area, but not KEATING itself. Commanders up to the RC East level believed McChrystal wanted to delay the closure of KEATING, but McChrystal had not intended to give that impression.","A January 2009 DoD report to Congress singled out RC East as an example of how counterinsurgency should work. “Our COIN [counterinsurgency] approach is effective in areas such as RC-East where the U.S. and ISAF are able to concentrate sufficient forces (partnered with ANSF), development resources, and civilian expertise. This successful COIN approach integrates military and civilian resources to create a stable and secure environment.” This optimistic interpretation rested on an uncertain tactical foundation. Combat Outpost KEATING, along with many other outposts, was an outgrowth of the wide dispersion of U.S. forces over vast areas of Afghanistan. New units arrived with fewer soldiers, which meant fewer patrols, as the reduced workforce was tied to base security requirements. As roads became more dangerous, units increasingly relied on aerial resupply, which had its own set of logistical and tactical vulnerabilities.","In the aftermath of KEATING, the Army conducted a detailed investigation of the attack. Noting that the 3d Squadron, 61st Cavalry, after-action report identified force-protection shortcomings at KEATING as a contributing factor, the investigation concluded the unit chain of command had been negligent by failing to correct those problems. The findings resulted in letters of reprimand for the entire chain of command at the tactical level. Yet because the investigation focused on the actions of American leaders, it did not account for the ANA role in the battle, including the fact that the enemy penetrated the Afghan portion of the perimeter rather than the section held by U.S. forces.","Some of the investigation’s conclusions were contradictory. It found simultaneously that the perimeter of KEATING was both too large to be defended by the number of troops available and too small to include the helicopter landing zone. These were among the criteria Colonel Brown used in the argument for closing KEATING in the first place. Although most portrayals of the incident directly linked the assault on the outpost to McChrystal telling George and Brown not to close it, the reality was more nuanced. McChrystal never vetoed the plan to close KEATING, and George admitted this. Instead, each request for the helicopters needed for the complex operation was denied, not out of the desire to keep KEATING open, but because the equipment was being used for higher-priority missions, such as the search for Bergdahl and operations at Barg-e Matal.","The analysis of the attack on Combat Outpost KEATING was problematic in other ways. In particular, it did not consider fully the  counterinsurgency principles laid out in Field Manual 3–24 and highlighted in McChrystal’s tactical directive. The investigation found the leaders of 3d Squadron, 61st Cavalry, negligent because they stopped improving the outpost defenses once they knew that KEATING was due to be closed. However, that assessment did not account for the inability of the intelligence system to predict a large-scale attack. In fact, numerous unsubstantiated and erroneous reports of the enemy massing near KEATING before 3 October played a part in the squadron’s decision to defer force-protection improvements. As a result, the final determination relied more on the apparent clarity of hindsight than on the more concrete factors of the situation: intelligence shortcomings, the tactical friction of pairing U.S. and Afghan units, and the subtly corrosive nature of an economy-of-force campaign in which units often made do with far less than their counterparts in Iraq.",{"figure":{"source":"/figures/v2/img_7-6.png","caption":"Soldiers from 1st Battalion, 32d Infantry Regiment"}},"The investigation’s findings also did not consider fully that the mission at KEATING involved both conducting operations against the enemy and interacting with the local civilian population, requiring the outpost’s command staff to weigh the careful balance between security and accessibility. Field Manual 3–24 and McChrystal’s tactical directive emphasized the need for the commanders to have the authority and flexibility to determine appropriate force protection measures for each area of operations. The U.S. Army had built KEATING in a valley so it could protect the local Provincial Reconstruction Team and the area’s road network. Therefore, the outpost could not have been reinforced as the impregnable fortress needed on 3 October 2009 without inhibiting the counterinsurgency missions of both the soldiers and the team they were supporting. Considering how little the occupying units at KEATING had changed the outpost’s design and structure in the three years since the Army had built it, the risk levels in the vicinity appeared to be within acceptable limits. Even when the new leadership recommended closing this outpost, noting that population outreach efforts had made little progress in the local situation and that the shift from geographic to population-centric counterinsurgency had made KEATING more of a liability than an asset, the Army had delayed the request because other missions took priority.","The investigation had used strong terminology in assigning blame to tactical leaders. “The commander’s plan to abandon COP [Combat Outpost]  KEATING inadvertently undermined the focus on current base defense and preparedness.” It found no fault in operational decisions by general officers, nor did it comment on the larger issues of counterinsurgency doctrine, the tactical directive, or McChrystal’s visit. In fact, it found “no specific responsibility or accountability for inadequate base defense at KEATING above the brigade level.” It mentioned neither the importance of the outpost to the forthcoming elections nor the reasoning behind delaying its closure a few months before the battle. The findings noted the overall approach: the U.S. Army “dedicates the appropriate level of resources and attention to trying to determine what happened and more importantly, to garner lessons learned so that [the] same mistake is not repeated.” On the whole, though, the investigation did not seem to match the doctrine being employed in Afghanistan at that time.","McChrystal determined that the reprimands would remain “locally filed,” meaning that as long as they had no further negative actions against them, dthe reprimands would not be in their permanent records. In the end, the talent and quality of those leaders shone through, as they continued to excel and receive promotion. Later, the investigating officer acknowledged that “the unit probably never should have occupied Combat Outpost KEATING. It should have been closed upon departure of the previous unit.” The reasons for keeping KEATING open were never compelling. Much later, American commanders realized that one of the original reasons for keeping KEATING open was a moot point. Even after U.S. forces closed nearly all outposts in the area, including KEATING, troops “were able to still reach into Barg-e-Matal and [beyond] as late as 2010–2011.”",{"title":"The Afghan Presidential Election: August–November 2009","level":2},{"section":["The American strategic review concluded shortly before Afghans went to the polls to elect a new president. Beginning with the Riedel Report, the Obama administration had actively sought to improve Afghan governance, strengthen links between Kabul and remote provinces, and sever ties between Karzai and Afghan drug lords. The concern with governance reflected the corrosive effects of high-level graft and an earnest desire to undercut support for the Taliban among ordinary Afghans. Rather than take drastic and possibly counterproductive measures, the Obama administration sought to install a chief executive officer to relieve the Afghan president of the bulk of his administrative responsibilities. Karzai would not agree to that plan.","The United States, and many ISAF nations, therefore came to view the August 2009 elections as an opportunity to replace Karzai with someone more capable of banishing corruption in the Afghan government. Many candidates actively opposed Karzai’s bid for reelection, but only two were palatable to Western governments. One was Abdullah Abdullah, who had served as foreign minister of the Afghan Transitional Authority for a year after Karzai’s election in 2005. The second candidate, a Western-educated Afghan intellectual named Ashraf Ghani, had been the Obama administration’s favorite. Unfortunately for U.S. intentions, preelection polls indicated that Ghani, who had spent most of his life outside Afghanistan, stood little chance of winning the popular vote. Nonetheless, a number of U.S. officials, including Special Representative to Afghanistan and Pakistan Richard C. Holbrooke and Ambassador Karl W. Eikenberry, openly associated with Ghani during the preelection campaign.","ISAF efforts to secure the August elections met with mixed results. Coordinated assaults, rockets, and IED attacks killed twenty-six people, including nine civilians, nine police, and eight Afghan soldiers. The Taliban also succeeded in shooting down a Royal Air Force CH–47 helicopter in a well-planned aerial ambush near Sangin. While the death toll remained fairly low, UN observers calculated that only 10 percent of eligible voters went to the polls in the Pashtun south. Although voter turnout was lower than desired, President Obama proclaimed, “We had what appears to be a successful election in Afghanistan despite the Taliban’s efforts to disrupt it.” NATO Secretary General Rasmussen observed, “Seen from a security point of view, the election has been a success. It has been conducted effectively.” CENTCOM commander Petraeus told reporters that the elections went “reasonably well,” while cautioning that more time would be needed to assess the results.","Petraeus’ words proved prescient as developments continued to unfold. Unofficial results announced on 16 September showed Karzai garnered 54.6 percent of the ballots cast, with Abdullah’s 27.8 percent placing him solidly in second place. The candidate preferred by the Americans, Ashraf Ghani, came in fourth. However, verified reports of Karzai supporters stuffing ballot boxes dominated both U.S. and international news. On 11 October, the top UN official in Kabul, Kai Eide, confirmed that widespread voter fraud had taken place. As a result, the UN would oversee the audit of 358 ballot boxes by a five-member Afghan electoral committee. Eide explained that if the committee determined that the total number of votes cast for Karzai fell below 50 percent, a nationwide runoff election would have to be held.","Karzai responded to Eide’s remarks by denouncing what he characterized as unwarranted foreign interference in Afghan affairs. Western officials, including Secretary of State Hillary R. Clinton, Richard Holbrooke, Robert Gates, and British prime minister Gordon Brown, publicly encouraged Karzai to accept the audit results. The potential for an equally inconclusive runoff election spurred renewed U.S. efforts to insert a chief executive officer between the Afghan head of state and provincial governors. One suggestion was for Karzai to form a unity government with another candidate. A Karzai spokesman denied that the Afghan president would reject the audit’s findings, though he noted that the electoral process seemed in danger of being “overshadowed by political discussions.”","On 2 November 2009, Afghan officials declared incumbent Karzai the winner of another term in office following the previous day’s announcement that Abdullah Abdullah had withdrawn his candidacy. UN Secretary-General Ban-Ki Moon, who arrived in Kabul that day, issued a statement renewing his commitment to backing the democratically elected government in Kabul. In Washington, Obama told White House reporters that, after congratulating Karzai during a telephone conversation, he had informed his Afghan counterpart that “this has to be a point in time in which we begin to write a new chapter based on improved governance, a much more serious effort to eradicate corruption, joint efforts to accelerate the training of Afghan security forces so that the Afghan people can provide for their own security.”","Although the election appeared to suggest that the Afghan people renewed Karzai’s mandate, low voter turnout in many areas, coupled with ballot stuffing by the Afghan president’s proxies, eroded support for Karzai within the international community. Postelection tensions between Karzai and the international community were rising, fueled by the fact that he was limited to two terms in office by law and exacerbated by Karzai’s attempts to appoint Ghani as chief executive officer. None of this boded well for ISAF. Rather than continue playing the part of staunch ally, Karzai lashed out at those who doubted his legitimacy."]},{"figure":{"source":"/figures/m/map-figure-7-m.svg","caption":"RC East Transfer of Authority June 2009-November 2010","prefix":"MAP"}},"One of the earliest examples of that political metamorphosis occurred at a January 2010 London conference when Karzai demanded all discussion on important strategic issues be deferred until the Kabul summit scheduled for that summer. The NATO Senior Civilian Representative, British diplomat Mark P. Sedwill, agreed to the request by deferring major strategic questions, such as how the transition to Afghan governance would take place and when Western troops would depart, to the Kabul summit scheduled for the summer."],"chapter 8":[{"title":"Exit McChrystal, Enter Petraeus"},{"section":["When President Barack H. Obama took office in January 2009, he and his administration were determined to reevaluate the strategic vision of their predecessors. In a dramatic departure from the accelerated process originally adopted by the Bush administration, the Obama White House devoted considerable time and thought to the reassessment effort that led to the Riedel Report. Rather than passively accepting an updated concept provided by the Pentagon, the National Security Council thoroughly overhauled the existing approach, first by redefining the threat and then by reexamining what the United States sought to accomplish and how success would be defined."]},{"title":"The Results of the Strategy Review","level":2},{"section":["Competing viewpoints soon surfaced, with Vice President Joseph R. Biden Jr. preferring a counterterrorism option while others supported population-centric counterinsurgency. As the administration discussed the pros and cons of different approaches, counterinsurgency emerged as a favorite even in light of concerns about whether the Afghan government was a worthy strategic partner. In the midst of this process, the Pentagon sought permission for the newly appointed ISAF commander, General Stanley A. McChrystal, to conduct a strategic assessment of his own. The White House initially viewed that prospect as a potential source of friction should McChrystal arrive at a different conclusion than the National Security Council. In the end, however, the president approved the request.","The White House’s concern about contradictory statements was prescient. General McChrystal’s assessment, leaked to the media  just before the August 2009 elections in Afghanistan, stressed “the criticality of time” while raising the specter of mission failure: “Failure to gain the initiative and reverse insurgent momentum in the near-term (next 12 months)—while Afghan security capacity matures—risks an outcome where defeating the insurgency is no longer possible.” Troop levels became the lead story, with news outlets indicating that McChrystal was preparing to ask for a significant troop increase. A series of public statements by McChrystal, General David H. Petraeus, and Admiral Michael G. Mullen not only supported this perception, but also fed anxiety within the White House that military leaders intended to hijack the strategic decision-making process. McChrystal had not helped his case when the three troop options he presented to Obama—increases of 11,000, 40,000, or 85,000—made it abundantly clear that he wanted 40,000 more troops. Military planners never seriously explored McChrystal’s first and third options. These developments fueled suspicions between the military and White House staff that would color future debates over Afghanistan policy.","The National Security Council debated McChrystal’s assessment for nearly three months, near the end of which Ambassador Karl W.  Eikenberry felt it necessary to question the counterinsurgency and any potential surge. His concerns in a cable sent directly to Secretary of State Hillary R. Clinton were leaked to the media, which further escalated tensions within the administration just before the president’s 1 December decision on McChrystal’s recommendations. Eikenberry identified six problems with the proposed counterinsurgency strategy:",{"list":["1. President Hamid Karzai is not an adequate strategic partner.","2. We overestimate the ability of Afghan security forces to take over.","3. We underestimate the length of time it will take to restore or establish civilian government.","4. The proposed strategy does not remedy an inadequate civilian structure.","5. The proposed strategy may not be cost-effective.","6. More troops won’t end the insurgency as long as Pakistan sanctuaries remain."]},"Eikenberry blunted his arguments by calling for “a comprehensive, deliberate and interdisciplinary re-examination of our strategic options” at a juncture where little support existed within the administration for another strategic review. However, his concerns about the Afghan government and the insurgency’s safe havens in Pakistan were well-founded.","By late November, McChrystal’s assessment was almost three months old. Petraeus took strong exception to Eikenberry’s critique,  noting that the ambassador had not offered any substantive objections prior to sending the cable to Clinton. Petraeus later observed that “we’re now at the point where literally the president is going to announce his decision and this is on the table waiting for us. And it just comes in out of left field. It wasn’t coordinated with General McChrystal.” The lack of coordination between the embassy and the military was unintentional but consequential. Even though the military had the advantage of having a retired general as ambassador to Afghanistan, Eikenberry and McChrystal had significantly different interpretations of the situation. The resultant disagreement led McChrystal to reflect on the disparity between State Department and Pentagon views:",{"list":["\"In retrospect, it would have been valuable if the U.S. embassy had also been directed to conduct a parallel analysis.  Although we coordinated our review with the embassy staff, the failure to clearly identify and bring to the fore any differing assessments proved to be [a] problem during the White House’s subsequent decision-making process on our ISAF strategy and troop request.\""]},"Eventually, the president accepted the 40,000 troop increase, but stated that it would consist of 30,000 Americans, with 3,000 more at the discretion of Secretary of Defense Robert M. Gates, and 10,000 more from other ISAF nations. Before announcing his decision, Obama met in the Oval Office with Gates and Petraeus and then video teleconferenced with Eikenberry and McChrystal. He asked each of them if a twenty-one month surge of 30,000 American forces and 10,000 more from ISAF troop-contributing nations would be acceptable. All agreed. McChrystal noted that although the president did not offer enough time, which was itself a critical resource, he decided to give his consent. McChrystal said in an interview that he thought that “it was better to try than not to try at that point.” He then added, “You know, I’ll spend a lot of time for the rest of my life, wondering if I should have said all stop, wait a minute, I don’t think that’s a good plan.” That decision to try would significantly change the scope and character of Operation ENDURING FREEDOM over its remaining five years.","The White House’s second strategic review concluded in November after nine or ten National Security Council meetings that totaled r oughly twenty-five hours. At first glance, the new review did not seem to alter U.S. strategic goals significantly. The revised strategy retained the core goal of disrupting, dismantling, and defeating al-Qaeda, and set out two supporting goals: (1) “deny safe haven to al-Qaeda” and (2) “deny the Taliban the ability to overthrow the Afghan government.” The first goal had been in place since the autumn of 2001, and defending the central government from overthrow had been policy since July 2003. However, President Obama’s revised Afghanistan-Pakistan strategy significantly limited U.S. strategic goals. The new strategy no longer considered it necessary, or even possible, to defeat the insurgency. By doing just enough to keep the Taliban out of power, the Obama administration believed it could deny al-Qaeda sanctuary in its former home.","Thus, the new strategic concept called for the United States “to degrade the Taliban insurgency while building sufficient Afghan c apacity to secure and govern their country, creating conditions for the United States to begin reducing its forces by July 2011.” A major goal was to reconcile the Taliban with the Afghan government through peace negotiations, which the Obama administration saw as the only feasible way to stabilize Afghanistan. The second important change in strategic goals focused on building the capacity of select Afghan ministries, primarily defense and interior. No longer would the U.S. government pursue a capacity-building strategy across the whole of the Afghan government. Rather than seeking to shape a moderate, democratic government capable of exercising full sovereignty, as in Bush-era strategies, the Obama administration would selectively build government capacity, with an emphasis on security institutions. The new policy explicitly stated that the strategy was not “nation building”—a shift that reflected the White House’s growing disillusionment with “the profound problems of legitimacy and effectiveness with the Karzai government.” The Obama administration recognized that it would not be feasible to build a stable democracy in Afghanistan, yet believed it could make the ANSF strong enough to secure the country against the Taliban and ultimately al-Qaeda. The question became: what resources would be necessary to achieve these goals?","After speaking with Karzai and the new Pakistani president Asif Ali Zadari via teleconference, as well as key NATO leaders, Obama announced the troop increase in a speech at the United States Military Academy West Point, New York, on 1 December 2009. The 30,000 American troops plus 10,000 coalition troops option, which had been proposed by Secretary Gates, was a compromise between the military’s counterinsurgency approach and the less resource-intensive counterterrorism advocated by Biden and others in the White House. Although the final summary of the president’s decision, called a “terms sheet,” spoke of denying the Taliban access to the population— language that reflected the tenets of counterinsurgency doctrine—it also stated that the strategy was “not fully resourced counterinsurgency.” Obama had approved a partially resourced political and military compromise to buy time for Afghan security forces to grow and mature.","The surge was a compromise in both resources and time, specifically projected to last eighteen to twenty-one months as opposed  to an indeterminate length of time required to meet the objectives and desired end conditions. Surge forces were to arrive in the first half of 2010 and begin redeploying in July 2011, as President Obama made public in his West Point speech. The president believed he was balancing opportunity costs. He quoted President Dwight D. Eisenhower as stating that national security proposals “must be weighed in the light of a broader consideration: the need to maintain balance in and among national programs.” In light of the 2008 economic crisis and the nearly $1 trillion cost of the wars in Iraq and Afghanistan, Obama opposed dramatic or open-ended escalation. The surge would bring U.S. troop levels in Afghanistan to more than 100,000 by early 2011 at enormous cost to the U.S. Treasury, to say nothing of the human costs. Officially, the force cap was set at 98,000 U.S. soldiers, sailors, airmen, and marines at any one time, with the caveat that 5 to 10 percent over that cap was acceptable to accommodate relief-in-place operations for rotating forces.","Senior policy and military leaders critical of Obama’s decisions pointed out that this seemingly arbitrary deadline signaled to the Afghans, the enemy, and regional actors that they should prepare for an American departure. The Obama administration hoped to bring the Taliban to the bargaining table on favorable terms, but the Taliban now had strong reason to believe that it had the easier task—to survive and wait for the coalition to leave. However, as one senior Army leader later noted, “if we don’t put markers on the table, then things have a tendency to languish on, without clear goals or objectives and from the very start, our goal was to ensure that at some point the Afghans would be able to do this for themselves. We can’t stay there forever.”"]},{"title":"Operation MOSHTARAK","level":2},{"section":["Now that the presidential and provincial council elections were over, the next priority for ISAF was to eliminate Taliban enclaves in Helmand and Kandahar Provinces. With the Marine Expeditionary Brigade–Afghanistan already engaged in clearing the Helmand River Valley, McChrystal felt that expanding that effort would be an opportunity to demonstrate visible progress. McChrystal also wanted to prove the applicability of the principles he had espoused in his assessment, the changes in command structure he had initiated in theater, and the tactical directive he had issued to his troops. McChrystal’s vision, dubbed Operation MOSHTARAK, provided a chance to demonstrate that combining increased troop strength with counterinsurgency techniques could clear, hold, and build pro–central government strength in an enemy-held region. The commander of RC South, British General Nicholas P. “Nick” Carter, would be responsible for executing Operation MOSHTARAK in accordance with McChrystal’s directive. Although MOSHTARAK was supposed to begin soon after the Afghan elections, logistical issues and the delayed deployment timelines of surge forces would delay it until 2010.","McChrystal and Carter envisioned MOSHTARAK as a three-phase operation to expand the authority of the Afghan government in RC South by protecting the population, separating insurgents from innocents, and partnering with ANSF at all levels. Committed forces included three brigades of the ANA’s 205th Corps supported by British and U.S. troops. Describing American involvement using the term “supported” understated the fact that the Marine Expeditionary Brigade would deploy thousands of marines into the region encompassing Helmand and Nimroz Provinces. The sheer number of ISAF troops involved, coupled with the ambitious scope of the effort, led to the three provinces being split off from RC South to become RC Southwest in June. Phase I consisted of the 5th Stryker Brigade Combat Team conducting freedom-of-movement operations (clearing routes and roads) to enable other units to reach the population. Phase II centered on clearing operations in Nad ‘Ali District, particularly Marjah, which became the perceived focus of MOSHTARAK. That impression arose because prominent Afghan officials and ISAF leaders invested considerable time and effort in describing what would happen in Marjah after the Taliban was driven out. In reality, Marjah was one of several second-phase goals of MOSHTARAK.","The final phase focused on central Kandahar. The directive for this phase emphasized the need for stable political conditions and the arrival of the surge forces as preconditions for its execution. The Army units allocated to this phase—Lt. Col. John M. Paganini’s 1st Squadron, 71st Cavalry; followed by Col. Arthur A. Kandarian’s 2d Brigade Combat Team (Combined Task Force STRIKE), 101st Airborne Division; and Col. James D. Edwards’ 525th Battlefield Surveillance Brigade—had been identified well in advance and were soon to arrive. The incoming U.S. units would partner with ANSF immediately after arriving in Afghanistan.","${MOSHTARAK Phase I, Shaping Operations}{bold}","The 5th Stryker Brigade Combat Team provided the main effort in the initial phase of MOSHTARAK. The aggressive attitude of Col. Harry D. Tunnell IV caused friction between him and General Carter soon after the latter took command of RC South. The tension resulted in part from differing visions of how to achieve success. Carter believed Tunnell focused too much on engaging the enemy and too little on the population-centric counterinsurgency approach espoused by McChrystal, stating afterward, “Harry Tunnell was an impediment to the 4-star commander’s intent.” Carter, however, made no effort to impart his intentions or otherwise connect with subordinate commanders by continuing General Mart de Kruif’s practice of visiting or patrolling with frontline units. The same could be said of Tunnell, who apparently made no heartfelt attempt to embrace or otherwise accommodate Carter’s vision.","Thirty days after taking command, Carter changed the 5th Stryker Brigade Combat Team’s mission to route security. The RC South commander wanted to ensure freedom of movement for the populace as well as ISAF and Afghan forces. Carter chose Tunnell’s brigade because it had a large number of light, armored vehicles suitable for covering long distances quickly. The new mission parameters specified by RC South, however, did not authorize the Stryker soldiers to operate more than two kilometers from the routes they were tasked to clear. As a result, units in the 5th Stryker Brigade Combat Team were confined to mounted patrols and key leader engagements with local officials in the villages sited on the tasked routes. Carter was trying to find the best way to employ the Stryker unit’s unique capabilities while harnessing its aggressive brigade commander’s mindset to McChrystal’s operational intent.","The new mission forced most of the 5th Brigade’s subordinate elements to relocate. Lt. Col. Jeffrey W. French’s 2d Battalion, 1st Infantry, was the sole exception, remaining along the Ring Road in Panjwa’i and Maywand Districts. This rearrangement of geographic responsibilities left the Arghandab River Valley vulnerable at almost the exact moment that 5th Stryker Brigade leaders felt they were gaining strength against the enemy. The lost opportunity for tactical success caused friction between Carter and Tunnell, as the latter felt the new directive relied on information crafted months before the current state of affairs, which now clearly showed the Arghandab River Valley as an enemy sanctuary.","Tunnell disagreed with Carter’s approach because intelligence indicated that the IEDs being used on the routes his brigade was supposed to secure were being manufactured in the Arghandab District. Colonel Tunnell did not see the sense in committing troops to dealing with IEDs one at a time for hundreds of kilometers when he believed that he could strike the Taliban strongholds that were making them. Tunnell insisted his units were better suited for clearing operations than light infantry because they had more foot soldiers whose actions could be synchronized through the brigade’s unparalleled digital command and control network. However, Tunnell did not accept alternative solutions, including the use of other units to perform the mission he sought. In fact, Special Operations units were conducting “an aggressive but carefully orchestrated campaign of precision strike operations” to degrade insurgent strength and undermine insurgent confidence across the area of operations. Their precision-strike operations removed key insurgent leaders whose responsibilities included deciding where to mass IEDs.","Colonel Tunnell also had problems with the nebulous language that General Carter used in the task and purpose for the route-security operation, which were to “discombobulate” the enemy so as to “place him on the horns of a dilemma.” Tunnell bristled at receiving directives containing such nondoctrinal terminology, particularly as they also failed to assign sufficient importance to defeating the enemy after seizing the tactical initiative. He felt that Carter had oversimplified the problem and was unable to articulate the mission in achievable doctrinal terms."]},{"figure":{"source":"/figures/m/map-figure-8-1.svg","caption":"MOSHTARAK Phase I","prefix":"MAP"}},"Carter fully disclosed his reasons for using the Strykers as route security to Tunnell. In focusing on roads, this first phase of MOSHTARAK also served as a deception. Most of the supplies allocated to MOSHTARAK would be carried by ground convoys that required route security, but the key maneuver elements of Phase II would travel not by road, but by air. By focusing enemy attention on the region’s road networks rather than aviation avenues of approach, Carter and McChrystal sought to gain the time they needed to set up the second critical phase in the struggle for RC South.","Nearly simultaneous with the change in mission, a controversy emerged inside the 5th Stryker Brigade Combat Team. The Army Times published an article alleging that Capt. Max Hanlin was replacing Capt. Joel R. Kassulke as commander of Company C, 1st Battalion, 17th Infantry, because the outgoing commander had philosophical differences with Tunnell. The article quoted soldiers, noncommissioned officers, and junior officers who believed that the brigade’s techniques for clearing operations were too enemy-focused and hence antithetical to McChrystal’s tactical directive. Kassulke did not confirm or deny the implied rift between Tunnell and himself. Instead, the article highlighted how his soldiers were surprised by Kassulke’s sudden departure, as well as the unexpected order from RC South to switch from clearing operations to route security in another sector. The soldiers assumed both developments were due to mission failure on their part. Getting units at all echelons in step with a population-centric counterinsurgency plan was proving more difficult than predicted. In this case, tension arose within an American brigade because junior officers interpreted the ISAF commander’s vision in literal terms, while senior leaders viewed McChrystal’s guidance as more nuanced.","${MOSHTARAK Phase II, Operations in Central Helmand}{bold}","McChrystal wanted Phase II to be a truly new and distinct milestone for Operation ENDURING FREEDOM. He wanted to convince Karzai that the south needed to be cleared, but was not sure how to do so. In seeking a way to approach the Afghan president, McChrystal took advice from former Ambassador Ronald E. Neumann, who stated that Karzai “trusts individuals, not reports and frequently told me so.” Neumann elaborated that “Karzai is completely tactical. . . . you cannot be too detailed with Karzai . . . show him a map and walk him through terrain illustrate what you mean.”","On 12 February 2010, McChrystal visited the presidential palace in Kabul to gain Karzai’s approval for Phase II of Operation MOSHTARAK. McChrystal made it a point to ask for permission to execute the operation, even though preparation for MOSHTARAK, and even announcements of its goals, had been known for weeks. According to McChrystal, Karzai paused and said, “General McChrystal, you’ll have to forgive me. I’ve never been asked to approve this kind of operation before.” After specific questions, Karzai gave his approval.","The most controversial part of the second phase of Operation MOSHTARAK was the idea that a “government in a box”—meaning a prepared governmental presence with resources and personnel—would immediately link disaffected residents in a former Taliban stronghold with their provincial and national governments. Building these ties between the population and the government proved harder to execute than to conceptualize. McChrystal later acknowledged that the term “government in a box” was a “superficial description we’d mistakenly coined” and that it “distracted from the serious effort to bring Afghan governance into what had been enemy territory.”","Brig. Gen. Larry D. Nicholson, commander of Marine Expeditionary Brigade–Afghanistan, felt the same way. He recognized in retrospect that finding the right people to lead the Marjah government was his greatest obstacle. Past attempts by previous Afghan governments to irrigate, modernize, and populate the area with tribes from outside Helmand had created demographic chaos, leaving Marjah without a true native population base that could provide a foundation for a strong local government. Sixty years earlier, a U.S. Agency for International Development program had created an irrigation system that was now being used for poppy production, adding to the problems in the region. The Afghans chosen for the government in a box were not from Helmand Province and their American counterparts could not provide the impetus to enable the government to have its promised immediate impact. In spite of these obstacles, the operation went forward.","With more than 3,000 U.S. marines and 4,400 Afghan troops in the assault force, Phase II of Operation MOSHTARAK involved around 15,000 troops in all roles, making it the largest ENDURING FREEDOM operation to date. It would be the first operation in which each U.S. battalion would pair with an ANSF battalion. ISAF announced the operation a few weeks in advance to generate enemy activity and give civilians a chance to leave, which they did in great numbers. Prior to Phase II, elders from the region urged the marines to start the operation as soon as possible, but the flood of people fleeing Marjah was so unmanageable that the elders began asking for time to evacuate more innocents and persuade the enemy to surrender. The marines granted a one-day delay after cutting off all avenues in and out of the town.","On 13 February, 900 British troops and their partnered Afghan forces air-assaulted into Nad ‘Ali to the west of Lashkar Gah, while 1,420 U.S. marines and their partnered Afghan forces air-assaulted into Marjah. The idea was to avoid getting bogged down fighting through the IED belts protecting the ground approaches to Marjah. While massive helicopter lifts of up to sixty rotary-wing aircraft transported part of the attack force, others still had to move by indirect ground routes. Capt. John A. Moder’s Company C, 1st Battalion, 6th Marines, received the unenviable mission of clearing routes into Marjah so as to meet the assault forces and open sustained lines of communications. Knowing that IEDs had been emplaced on the obvious approaches, Moder’s company used a circuitous route that avoided roads and crossed water obstacles without using bridges in order to link up first with its battalion command element and subsequently with Capt. Carl A. Havens’ Company A in the center of Marjah. Company C took no casualties but received sporadic gunfire and found dozens of IEDs, which they detonated harmlessly. Marjah now belonged to the U.S. Marines and Afghan Army.",{"figure":{"source":"/figures/m/map-figure-8-2.svg","caption":"MOSHTARAK Phase II","prefix":"MAP"}},{"figure":{"source":"/figures/v2/img_8-1.png","caption":"The 1st Battalion, The Royal Welsh"}},"This overwhelming success pleased General Nicholson, who entered Marjah to see firsthand how the situation was developing. Upon arrival, he noted that Lt. Col. Calvert L. Worth Jr., the commander of 1st Battalion, 6th Marines, was speaking to men in black turbans. Worth was telling them that U.S. and Afghan forces were there to install civilian government, protect the population, and help reestablish public services. One of the men stood, gestured to the group, and said, “I am Taliban. We are all Taliban. But we agree and we trust you. But if you lie to us or do not do as you say, I will come back here and kill you and your marines.” For the moment, Marjah remained quiet.","Task Force MOHAWK, formed around Lt. Col. Burton K. Shields’ 4th Battalion, 23d Infantry, was a late addition to the assault on Marjah. In mid-January, Colonel Tunnell notified the unit that it would be attached to Marine Regimental Combat Team 7 for Operation HELMAND SPIDER, a supporting effort to Phase II of MOSHTARAK. Company A, 1st Battalion, 17th Infantry— attached by Tunnell to Shields’ battalion—would operate in Nad ‘Ali while the remainder of TF MOHAWK partnered with 1st Kandak, 2d Brigade, 205th Afghan National Army Corps. Their mission was to seize crossing points over the Trikh Zabur Canal to deny the enemy freedom of movement between Sayyidabad and Marjah and disrupt any enemy counterattacks.","Col. Paul W. Bricker’s 3,200-soldier 82d Combat Aviation Brigade, organized with five battalions equipped with 155 cargo, utility, reconnaissance, attack, and medical evacuation helicopters, doubled the rotary-wing platforms taking part in Operation MOSHTARAK. By ferrying units by air, Bricker’s brigade enabled the high operational tempo sought by Carter in Phase II by preventing the Taliban from canalizing ISAF troops into IED belts. The 82d Combat Aviation Brigade not only transported Army, Marine Corps, and Afghan infantry, but also provided British forces with reconnaissance, aerial fire support, cargo lift, and medical evacuation assets. The Army’s UH–60 Black Hawks and CH–47s Chinooks played a prominent role in the opening days due to the Marines’ decision to dedicate their MV–22 Osprey tilt-rotor lift aircraft to supporting a quick-reaction force.","Although the assault on Marjah was successful, it identified ways in which joint operations in Afghanistan needed to improve. Notably, improperly planned logistics left Stryker units short of lodging and maintenance support. Working with the ANA stretched both Army and Marine leaders who were unprepared for the low level of proficiency of many of their Afghan counterparts. Language barriers between Afghans and Americans made rehearsals even more important than anticipated and quadrupled the time necessary to conduct such events.","The enemy remained in Marjah during the operation but did not fight. Marine General Nicholson believed his opposition had made that decision after so many coalition forces had arrived in the center of Marjah and the key areas that surrounded it. The citizens of Marjah were aware that the enemy had decided not to fight, as evidenced by their return en masse only eight days after the air assault. A few weeks later, the area was deemed safe enough for Karzai to attend a local shura and discuss the new situation with elders. The locals made known their concerns about those chosen to lead the district. Karzai assuaged their concerns, and the locals agreed to give the new government a chance.","The seizure of Marjah was the decisive point of Operation MOSHTARAK, but it did not mark the end of hostilities in Helmand Province. To the contrary, it marked the beginning of frustration for the Marines and their Afghan partners as well as for McChrystal. Although the Taliban’s initial reluctance to become entangled in a major engagement meant that U.S. forces were able to net large caches of weapons, drugs, and explosive materials, civil government was not progressing with the same rapidity. In a May 2010 visit to the 3d Battalion, 6th Marines, McChrystal exhorted the unit commander, Lt. Col. Brian S. Christmas, to help representatives of the Afghan government achieve more progress. Christmas replied that doing so required far more time than the ninety days his marines had already spent in Marjah. McChrystal then asked how many days Christmas believed it would take and how many days Washington might give them. When Christmas replied that he did not know, McChrystal responded, “[W]e don’t have as many days as we’d like.”","These situational factors meant that clearing operations in Helmand were characterized by a mix of tactical gains and strategic stalemates. Although the Marines achieved all of their tactical and operational objectives, the province had yet to heed to the dictates of the Karzai government and remained an insurgent base. Afghan government and ISAF claims that reconstruction efforts would begin immediately and that Kabul would reach out to the province’s inhabitants after the Taliban departed rang hollow, in large part because Afghan and American interagency participation fell far short of the Marines’ effort. In fact, Helmandis perceived Operation MOSHTARAK in a negative light precisely because they saw only armed troops, not aid officials, construction crews, or earnest Afghan administrators.","In March, the International Council on Security and Development, a European think tank, interviewed 427 local Afghans in Lashkar Gah  District to capture their opinion on recent security measures and the motivations of the Taliban. Two-thirds of respondents characterized ISAF operations in Marjah as “bad.” About the same number said they would not support ISAF forces in their province, and even more felt that NATO troops should leave Afghanistan and believed the Taliban would return. Oddly enough, two-thirds also answered “yes” to the question: “Should the international and government forces now ‘clean [clear] the road from Lashkar Gah to Kandahar to Kabul’ and start a similar operation in Kandahar or other regions?”","Although Marjah produced relatively little in the way of casualties or results, it still could be considered a showcase operation. However, similar operations in nearby districts such as Sangin and Nad ‘Ali proved more irritating and produced the bulk of the casualties for the U.S. Marine Corps during this period. Just as British troops discovered earlier, the marines found that the enemy had cunningly and effectively employed IEDs throughout the area. Of the 14,803 U.S. marines killed or wounded in all theaters of war since 2001, 5,324 of these casualties—more than a third—occurred in Afghanistan. More than 80 percent (287 killed, 3,953 wounded) of those losses occurred in Helmand from 2009 to 2011.",{"figure":{"source":"/figures/v2/img_8-2.png","caption":"General Mills & Chairman of the Joint Chiefs of Staff Admiral Mullen"}},"The assignment of Marine Expeditionary Brigade–Afghanistan to Helmand under operational command of Marine Central Command limited the flexibility of the tactical commander. Although RC South sent TF MOHAWK and the 82d Combat Aviation Brigade to Helmand to support the Marines in Phase II of Operation MOSHTARAK, marines contributed far fewer assets in support of operations in other regional commands. The doctrine that deploys a Marine Air-Ground Task Force prevented the Marine brigade from being parceled out to support other operations, which meant that ISAF could not extract the marines from Helmand to augment other major operations. McChrystal conceivably could have requested a boundary change so marines could fight outside of Helmand Province, or he could have requested a change in the command and control arrangements, but he did neither.","In July, General Nicholson’s Marine Expeditionary Brigade was replaced by a much larger force, the I Marine Expeditionary Force (Forward) commanded by Maj. Gen. Richard P. Mills. The arrival of Mills’ command doubled the U.S. Marine Corps commitment in Helmand Province, which now stood at 20,000. With the number of troops in Helmand equaling that in other regional commands and with a two-star general in command, IJC decided to create RC Southwest, consisting of Helmand and Nimroz Provinces. RC South retained responsibility for Kandahar, Uruzgan, Daykundi, and Zabul Provinces.",{"figure":{"source":"/figures/m/map-figure-8-5.svg","caption":"Regional Commands South & Southwest","prefix":"MAP"}},"Mills’ marines began operating as a self-contained regional command in May 2010 during what ISAF termed as an “assessment phase.” By the end of May, the I Marine Expeditionary Force (Forward) reported to IJC that it was capable of operating as an independent regional command. On 28 May, the North Atlantic Council officially recognized the establishment of RC Southwest, with IJC doing likewise on 14 June 2010. With the creation of a sixth regional command, command and control arrangements, which had evolved significantly during the past year and a half, were set for the remainder of the surge.","Some irony could be derived from the events that resulted in the U.S. Marine Corps, sent to reinforce the British contingent in Helmand Province two years earlier, gaining command and control over the bulk of British forces in Afghanistan while the majority of the troops reporting to British General Carter in RC South were supplied by the U.S. Army. Carter’s predecessor, General de Kruif, had opposed the division of RC South into two regional commands. He believed such an initiative would be detrimental to the overall coalition unity of effort in the Pashtun heartland, which he insisted represented one battlespace. Thus, in response to the “single battle” doctrine espoused by the Marines, McChrystal had divided what preceding leaders originally considered an indivisible battlespace.","The changes taking place in southern Afghanistan initially resulted in more than 10,000 U.S. marines, or about 10 percent of U.S. forces in the country, operating in remote parts of Helmand to secure only 1 percent of the Afghan population, while the British continued to secure the more populated capital of Lashkar Gah. When the marines in RC Southwest doubled to more than 20,000, now about 20 percent of U.S. forces in country, their new area of operations encompassed about 5 percent of the Afghan population. Arguments about insurgent density or poppy production were used to justify those decisions, but some U.S. officials questioned whether ISAF understood the precepts of counterinsurgency by sending so many troops to secure so few civilians. Regardless of any lingering skepticism about ISAF’s warfighting approach, the marines were successful in shaping, clearing, and holding remote areas of Helmand Province. Like their U.S. Army counterparts in other contentious areas of Afghanistan, however, the U.S. Marine Corps found the build and Afghan-lead phases more difficult to achieve.","${The Stryker Finale}{bold}","A preemptive strike against insurgents massing in Shah Wali Kot by the 5th Stryker Brigade Combat Team in the waning months of its  deployment indicated that ISAF could seize the initiative given the right tactical conditions. In May 2010, Lt. Col. Jonathan A. Neumann, commander of 1st Battalion, 17th Infantry, in northern Kandahar Province, did just that. His units had learned of an imminent massing of Taliban fighters for an attack, likely against ISAF forces near Shah Wali Kot. Being cautious in the last weeks of the brigade’s tour, Tunnell reinforced Neumann with a company from 4th Battalion, 23d Infantry, before taking further action.","When Lt. Col. Karl E. Slaugenhaupt, the deputy brigade commander, recommended attacking the Taliban in Neumann’s area of operations, Tunnell agreed on a series of company-sized operations aimed at destroying the enemy force. Tunnell used companies because Carter still wanted him to focus on maintaining route security until the Stryker brigade left Afghanistan in July 2010. Over the next several days, Colonel Neumann’s task force killed or wounded an estimated one hundred insurgents belonging to the group gathering near Shah Wali Kot.","During the same period, ISAF authorities were searching all personally owned computers in the brigade for photographs or videos showing Afghans being killed by U.S. forces. The images violated standing military policy prohibiting soldiers in a war zone from photographing or filming dead enemy personnel. The hunt for the illicit images began in spring 2010 after their existence became known outside of the brigade. The Army, concerned that some of Tunnell’s soldiers also had sent images to stateside recipients, ordered its own Criminal Investigation Command to perform similar searches of computers belonging to the relatives of soldiers. The search for photos would lead to findings even more atrocious than simply recording the deaths of enemy combatants.","When Army investigators discovered photographs of dead Afghans on laptop computers belonging to soldiers in the Stryker brigade, the initial suspicions of wrongdoing sparked a further investigation. The expanded investigation over the period of many months revealed that four soldiers of a platoon from Company B, 2d Battalion, 1st Infantry, had committed murders while in Afghanistan. Led by S. Sgt. Calvin R. Gibbs, the group orchestrated situations in which they could kill civilians, whom they framed as insurgents. This was not the first time Gibbs had been implicated in illegal actions; earlier in the deployment, he had been relieved of his duties in the brigade command post after receiving nonjudicial punishment for stealing. The actions of Gibbs and several other individuals came to the chain of command’s attention when peers reported them for smoking hashish and telling incriminating stories. Once Tunnell learned all of the details, he immediately referred this case to the Army’s Criminal Investigation Command. The ensuing formal investigation revealed that the soldiers had carried out three staged killings, each falsely reported as a legitimate enemy engagement.","The mentality, methods, and attitude of the 2d Battalion, 1st Infantry, had always been a concern of Tunnell’s. The colonel had worried about the unit long before it arrived in Afghanistan because he felt its former commander had allowed discipline to erode to a dangerous level. As a result, after Tunnell considered formally relieving Lt. Col. Richard A. Demaree of command, he instead cut short the officer’s tour of duty before the deployment. Before Tunnell departed Fort Lewis in 2009, he informed that officer’s replacement, Colonel French, that the 2d Battalion, 1st Infantry’s collective discipline had deteriorated to a point where the performance of individual soldiers in combat could be affected.","It was becoming clear that the reputation of the 5th Stryker was now in question. The first inkling that the 5th Stryker Brigade had fallen  into official disfavor emerged when the 4th Battalion, 23d Infantry’s recommendation for a Presidential Unit Citation successfully made its way through the chain of command while similar awards for all other 5th Stryker Brigade units were returned without action. When Tunnell’s inquiries about the awards went unaddressed by the U.S. chain of command, he sent a memorandum titled “Subject: Open Door Policy—Report from a Tactical Commander” to Secretary of the Army John M. McHugh in August 2010. Tunnell’s memorandum went far beyond the subject of lost awards. In it, he stated that his unit had been denied live-fire training, constrained to policing roads after Carter had assumed command, and forced to share precious resources with allies, all of which amounted to what he called professional malfeasance. The U.S. Army did not take any immediate action, and McHugh released no response.","On 18 October 2010, newly assigned I Corps and Fort Lewis commander Lt. Gen. Curtis M. Scaparrotti appointed Brig. Gen. Stephen M. Twitty to investigate the command climate in Tunnell’s brigade. Officially, he initiated the investigation because of administrative problems associated with submitting awards and officer evaluations. The investigation also looked for any possible connection between the brigade’s overall command climate and the murders committed by Sergeant Gibbs and his associates. Twitty’s investigation found no link between the illegal killings and the command climate. However, Twitty recommended that Tunnell be reprimanded and retired at lieutenant colonel, blaming the poor administration of the unit. A board of officers that convened to discuss the investigation’s findings did not find cause to demote Tunnell, who retained the rank of colonel when he later retired from the Army.","Although the friction between General Carter and the 5th Stryker Brigade Combat Team’s commander did not figure prominently in the investigation, Tunnell’s memorandum had spread word of his dissatisfaction well beyond the confines of Fort Lewis. Although part of the problem could be attributed to a clash of personalities, it also reflected that counterinsurgency was neither uniformly understood nor implemented in Afghanistan. Tunnell incorrectly interpreted the main problem with the doctrine as stemming from its “assumption” that the population represented the center of gravity. That was true at the time in Afghanistan, but only because of the ISAF commander’s personal interpretation of doctrine. Both McChrystal and Tunnell may have been correct to a degree, but their respective approaches suffered from a single-mindedness that failed to account for all of the variables present on a complex battlefield. McChrystal overemphasized courageous restraint— to the point where his soldiers felt they were being put unnecessarily at risk—even as Colonel Tunnell placed overriding faith in more aggressive counterguerrilla tactics.",{"figure":{"source":"/figures/v2/img_8-3.png","caption":"General McChrystal"}},"Tunnell’s Stryker brigade successfully executed its transfer of authority with the 2d Cavalry Regiment (Stryker) in July 2010. Under the  command of Col. James R. Blackburn Jr., the 2d Cavalry would assume more of a security force assistance mission by more closely partnering with Afghan Army units in RC South. Although the 5th Stryker Brigade was now back at home station in Fort Lewis, its legacy would continue to be marred in the public forum and the press. In March 2011, Rolling Stone magazine published an article about the brigade titled “The Kill Team: How U.S. Soldiers in Afghanistan Murdered Innocent Civilians for Sport.” The story discussed the investigation into the pictures of dead Afghans and the illegal actions of Gibbs and his accomplices. For the military, the Rolling Stone piece was an information operations disaster because the article claimed that the Army had attempted to keep both the illicit photographs and murders secret. Rolling Stone also suggested that Tunnell, which it described as a commander who “openly mocked the military’s approach to counterinsurgency,” had fostered a toxic climate within the brigade by constantly exhorting his men to relentlessly pursue the Taliban. Tunnell had wanted the legacy of his unit’s deployment to be its success at exploiting information dominance to defeat the enemy. Instead, the 5th Stryker Brigade would be remembered as the “Kill Team,” a black mark on the record of U.S. involvement in Afghanistan.",{"title":"General McChrystal’s Exit","level":2},{"section":["In April 2010, McChrystal was traveling from Europe to Afghanistan when he received an email from S. Sgt. Israel Arroyo. Six weeks earlier he had patrolled with Arroyo’s squad from Lt. Col. Reik C. Andersen’s 1st Battalion, 12th Infantry, 4th Brigade Combat Team, 4th Infantry Division. Arroyo wrote now inviting McChrystal to a memorial for Cpl. Michael K. Ingram, a team leader in his squad, who died as a result of an IED attack on 17 April, not far from where McChrystal accompanied the patrol. McChrystal accepted the invitation and traveled to Zharey District with personal staff and Rolling Stone reporter Michael M. Hastings.","Following the memorial service, McChrystal spoke with the fallen service member’s platoon and discussed the challenges of focusing on protecting the civilian population to defeat the insurgency. The soldiers did not respond positively to his remarks. Although McChrystal’s staff tried to explain to Hastings that such a reaction was normal, an article published in mid-June reflected the platoon’s skepticism. “The session ends with no clapping, and no real resolution. McChrystal may have sold President Obama on counterinsurgency, but many of his own men aren’t buying it.” Hastings had intended to highlight the widening disconnect between the counterinsurgency theory espoused by senior leaders and the growing frustration experienced by soldiers fighting a tenacious foe. However, the article also recounted unprofessional and demeaning remarks made by McChrystal’s staff about Vice President Biden, others in the administration, and American allies. In fact, McChrystal’s apparent insubordination seemed to be the central theme of the article, with the title of “The Runaway General” drawing even more attention. The article had been slated for release on 22 June 2010, but an advance copy leaked to senior administration officials and to the press. The article went viral, and senior leaders at multiple levels quickly tried to control the damage.","On 21 June 2010, President Obama summoned McChrystal to the White House. Before arriving, General McChrystal issued a written statement:",{"list":["\"I extend my sincerest apology for this profile. It was a mistake reflecting poor judgment and should never have happened.  Throughout my career, I have lived by the principles of personal honor and professional integrity. What is reflected in this article falls far short of that standard. I have enormous respect for President Obama and his national security team, and for the civilian leaders and the troops fighting this war and I remain committed to ensuring its successful outcome.\""]},"On 23 June, less than a year after replacing McKiernan, Obama accepted the resignation of McChrystal. The ISAF deputy commander,  British Lt. Gen. Nicholas R. Parker, assumed McChrystal’s duties until the appointment of a successor. The ISAF Web site posted the following announcement from McChrystal:","\"This morning the President accepted my resignation as Commander of U.S. and NATO Coalition Forces in Afghanistan. I strongly support  the President’s strategy in Afghanistan and am deeply committed to our coalition forces, our partner nations, and the Afghan people. It was out of respect for this commitment and a desire to see the mission succeed—that I tendered my resignation. It has been my privilege and honor to lead our nation’s finest.\"","Before McChrystal’s resignation, and with the support of Vice President Biden, Gates had tried to mediate the situation. However, when Gates asked McChrystal for his explanation, the only response he received was, “No excuse, sir”—the standard line expected from a new cadet at West Point. Gates, lamenting that McChrystal had given him nothing to work with, approached the president, who now seemed determined to take a stand against what he saw as a trend of insubordinate behavior by senior officers, including Petraeus, Admiral Mullen, and McChrystal. Gates told Obama, “If you lose McChrystal, I believe we lose the war in Afghanistan.” Gates cited the gains made in the relationship with Karzai and the length of time that might be needed to get someone else approved. “And without hesitation Obama says, ‘How about Petraeus?’”","${Enter Petraeus}{bold}","General Petraeus took over as ISAF commanding general on 4 July 2010. The selection of Petraeus to replace McChrystal surprised those who saw the change of assignment as a downward move in the profession of a respected and well-known senior commander. Nonetheless, Petraeus’ selection reassured allies of America’s commitment even after two senior American generals had been replaced in two years. The fact that the Obama administration could not easily afford to replace a third senior commander in Afghanistan granted Petraeus greater influence in Washington, D.C., circles than his immediate predecessors had had."]},{"figure":{"source":"/figures/v2/img_8-4.png","caption":"General Petraeus"}},"Petraeus immediately updated the Civil-Military Campaign Plan and published Operation Plan 38302 Revision 5. Both documents continued to  reflect selected elements of McChrystal’s vision, with the exception that they permitted more aggressive execution in order to meet the White House’s goal of buying time and space for the development of Afghan National Security Forces. Revision 5 adapted the existing campaign plan to six lines of operation:",{"list":["1. Protect the Population","2. Neutralize Insurgent Networks","3. Support Development of ANSF","4. Neutralize Criminal Patronage Networks","5. Support Development of Legitimate Governance","6. Support Sustainable Socio-Economic Development"]},"The overriding goal still was to protect the population, but the new ISAF commander would employ more aggressive methods to accomplish that task. Prioritizing the neutralization of insurgent networks over supporting ANSF development reflected Petraeus’ belief that both of those tasks were interrelated, but the former rated a higher priority because it also supported protecting the population by degrading the enemy’s capability to intimidate innocents. Yet Petraeus’ priorities also mirrored the Obama administration’s concerns about the Kabul government; the last three lines of operation concentrated on reform within Afghanistan rather than eliminating the enemy.",{"figure":{"source":"/figures/v2/img_8-5.png","caption":"Anaconda Strategy in Afghanistan"}},"Building upon all of the troops and structure changes begun by McKiernan and McChrystal, Petraeus adapted to evolving battlefield dynamics by altering the trajectory of the surge to the degree necessary to achieve the goals sought by the White House, and monitored its progress. Under Petraeus, RC South completed Operation MOSHTARAK, and IJC oversaw the Afghan-designed Operation NAWEED (Good News). Petraeus’ efforts produced a timeline and plan for transition, with 2014 identified as the tentative completion year.","${Petraeus}{bold}${:}{bold} ${Counterinsurgency Legacy and the Iraq Effect}{bold}","With General Petraeus in command in Afghanistan, ISAF adopted a nuanced counterinsurgency approach, dubbed the Anaconda Strategy, that blended elements of the population-centric version advocated by McChrystal with the more kinetic aspects favored by McKiernan and his predecessors. To explain the numerous facets of the new approach to his superiors, allies, and subordinates, Petraeus prepared a visual aid modified from the same slide he used in Iraq to display his tailored amalgamation of theory, doctrine, and operational method.","While the Anaconda Strategy sought to reduce the visual representation of counterinsurgency to a single page, the number of items in the graphic overwhelmed the senses of many who viewed it. The graphic gave the impression that the enemy was surrounded by programs and efforts— some violent—aimed at suffocating him. This portrayal belied the fact that the thinly spread coalition forces often were the ones surrounded and outnumbered. Still, Petraeus believed the Anaconda Strategy made it easier for multiple audiences to visualize his approach, albeit with the risk that some might confuse aspirations with capabilities. The Anaconda Strategy slide sought to simplify the complicated nature of counterinsurgency; if nothing else, it convinced decision-makers that the general who created it had mastered its complexities. Given the dramatic downturn in sectarian and insurgent violence in Iraq following the arrival of sufficient U.S. troops to simultaneously protect the people and take the fight to the enemy, few could argue that the surge had not been an effective approach. However, several unacknowledged factors played a part in that success. First, the insurgents had located their primary operating bases within Iraq, not in neighboring Iran and Syria. Thus, they had no enabling sanctuaries similar to those used by the Taliban in Pakistan. In addition, the Iraqi government implemented sweeping (albeit temporary) concessions to the Sunni minority during the surge that contributed to the drop in violence. A similar compromise between Karzai and the Taliban seemed all but impossible. Finally, American troops in Iraq had protected civilians of all ethnicities from sectarian death squads, earning first their trust and then their support. Although the Taliban had been guilty of similar crimes during its conflict with the United Front, Mullah Mohammed Omar’s followers had not committed those deeds as part of a systematic ethnic cleansing program.",{"title":"Operation MOSHTARAK Phase III and Operation HAMKARI","level":2},{"section":["The first operation conducted under General Patraeus’ leadership was Phase III of Operation MOSHTARAK. As Americans surged into Helmand Province, the Taliban responded in Kandahar Province, Kabul, and elsewhere in eastern Afghanistan. In the south, ISAF documented the increasing toll suffered by Afghan civilians caught in the crossfire or deliberately targeted by insurgent IEDs, suicide-bombings, and assassinations. The first five months of 2010 were deadlier than the first six months of 2009. The new Taliban commander in the south was the 37-year-old Mullah Abdul Qayyum Zakir. Zakir was competent, charismatic, and a veteran military commander who recognized the value of IEDs and suicide operations. Like Mullah Dadullah Akhund, he had gained a reputation for extreme and uncompromising views.","During the previous summer, the Taliban had conducted intimidation operations in and around Kandahar City by assassinating key officials. The Afghan government managed to keep power in the provincial capital but was unable to prevent Taliban attacks. These killings continued through Phase II of MOSHTARAK. During 2010, a media source in the city documented almost 400 assassinations between June and September. While the Taliban in Kandahar City carried out some of these attacks, the majority were launched from strongholds in the outlying districts of Arghandab, Zharey, and Panjwa’i.","The Taliban recognized that, after Marjah, the next logical target for ISAF was Kandahar Province, a vital nerve center for the southern insurgency. The insurgents placed a high priority on defending their most important political and military stronghold, which promised to turn the struggle for Kandahar Province into a decisive engagement. The Taliban knew ISAF intended to increase its security forces in Kandahar and countered by importing volunteers from Pakistani madrassas and recruiting from the surrounding villages. The enemy fighters massing around Kandahar did not affect the ISAF deployment or subsequent operations materially, but they did make it more likely that innocents would be caught between the warring factions.","Phase II of Operation MOSHTARAK in Helmand Province had been highly publicized and quick. Phase III, redesignated as Operation HAMKARI, was designed to achieve dominance over the Taliban in three subphases. The first was to secure Kandahar City. The second subphase was to expand the security zone around Kandahar City and clear the Arghandab District to the northwest. The third and final subphase was to clear the Zharey and Panjwa’i Districts to the west and southwest. Upon completion of the final phase, it would be up to Afghan forces to hold the gained ground and maintain security. HAMKARI was also an attempt to persuade Pashtun tribes maintaining grudges against Karzai’s allies in Kandahar to support the central government. The fact that these tribes were culturally, socially, and religiously inclined to align with the Taliban made that goal problematic.","The preparation for HAMKARI was more deliberate than that for MOSHTARAK because ISAF officers knew the Taliban would commit to defending Kandahar Province. The terrain made the operation forbidding as most residents lived along riverbeds cut by canals. Living compounds were walled, with many roads flanked on both sides by hedgerow-like vines and hundreds of stone and masonry green houses. These features concealed movement and canalized routes, driving forces into choke points that made for optimal ambush sites. Shaping operations for Phase III were to be conducted by units already in Afghanistan as well as those that had not yet arrived. These units were to partner with ANSF upon arrival and gradually disperse throughout the province.","Four months seemed like such a long time to wait for HAMKARI to begin, and locals began circulating rumors that major coalition operations would not take place in Kandahar. A Marjah-style air assault into the middle of a Taliban stronghold was anticipated by the locals for several reasons. First, Kandahar City was not in the hands of the Taliban. Second, ANSF and ISAF had been operating in or nearby the city since 2001. The area had simply been falling under greater Taliban influence. Without reason to trust ISAF’s announced intentions, HAMKARI would surprise the population with its size and intensity.","${HAMKARI Overview}{bold}","Prior to Operation HAMKARI 2,000 Canadians had worked to control the approximately 1.2 million Pashtuns living in Kandahar Province. ISAF forces had now swelled to 24,000 soldiers and police before the attack; ANA force levels were tripled, and the Afghan police saw a five-fold increase in the province. For the first time, ISAF devoted enough forces to clear and hold Kandahar City’s outlying districts while simultaneously interdicting infiltration routes from Pakistan. ISAF commanders ratcheted up the pressure on Taliban leaders before the operation by increasing Special Operations raids. Despite making their own preparations, Taliban fighting cells were unable to stem ISAF’s growing influence in the region.","${HAMKARI Phase I}{bold}. Securing the city of Kandahar was never a matter of attacking to clear it, as there were no known enemy strongholds to eliminate. Instead, the first order of business was to increase ANSF presence in the city. Afghan security forces constructed and staffed sixteen checkpoints in and around the city. American Military Police assisted both the Afghan National Police and Civil Order Police in opening substations at each checkpoint. In sharp contrast to the Operational Mentor and Liaison Teams or Police Operational Mentor and Liaison Teams that commuted to work from an ISAF base, the Americans partnering with the Afghan police in Kandahar were collocated with their counterparts. By ensuring partnered units spent more time together, ISAF sought to increase the professionalism of the indigenous police in the shortest time possible. The checkpoints prevented enemy materiel and personnel from entering the city, and the basic plan paid quick dividends as violence within the city decreased dramatically.","Phase I initially involved establishing a loose cordon around Kandahar using troops siphoned from Col. Brian M. Drinkwine’s 4th Brigade, 82d Airborne Division (TF FURY) of Fort Bragg, North Carolina. Originally earmarked to provide security force assistance in RC West and RC South, Drinkwine’s unit was called upon to maintain a presence in the Arghandab, following the departure of the Stryker brigade, and to assume initial responsibility for Kandahar. The paratroopers were replaced in late June 2010 by Col. Jeffrey R. Martindale’s 1st Brigade Combat Team, 4th Infantry Division (TF RAIDER), of Fort Carson, Colorado, which served as part of the surge forces.","Martindale’s TF RAIDER consisted of Lt. Col. Charles Mitchell’s 7th Squadron, 10th Cavalry; Lt. Col. Clay Padgett’s 1st Battalion, 22d Infantry; Lt. Col. Rodger Lemon’s 1st Battalion, 66th Armored Regiment; and Lt. Col. Craig Berryman’s 4th Battalion, 42d Field Artillery. Mitchell’s reconnaissance squadron and Berryman’s field artillery battalion replaced their counterparts from Drinkwine’s brigade in RC West rather than accompany the remainder of their parent unit to Kandahar. The remaining elements of Martindale’s brigade, which also included Lt. Col. Christopher G. Beck’s 1st Brigade Special Troops Battalion and Lt. Col. Gregory S. Applegate’s 4th Brigade Support Battalion, were positioned within Kandahar or just north of the city. In addition to his own troops, Colonel Martindale received welcome assistance from Lt. Col. John G. Voorhees’ American 504th Military Police Battalion; Lt. Col. Conrad J. Mialkowski’s 1st Battalion, Royal Canadian Regiment; and Lt. Col. John M. Paganini’s 1st Squadron, 71st Cavalry, a U.S. unit operating with Canadian Brig. Gen. Jonathan H. Vance’s Task Force KANDAHAR.","${HAMKARI Phase II}{bold}. The critical district of Arghandab abuts Kandahar City to the north and west. It was here, during the 2001 invasion, that Karzai negotiated with major tribes to secure their support against the Taliban. In 2004 and 2005, U.S. units sought to keep the Taliban out of the region by building a road through the district. The handover to ISAF during the following year, in which a smaller Canadian force replaced a larger American one, changed the tactical balance. With the exception of Operation MEDUSA in September 2006, the initiative had swung to the Taliban by the time Colonel Tunnell’s 5th Stryker Brigade arrived in 2009. The 5th Stryker Brigade Combat Team believed it had begun to loosen the Taliban’s control before it was replaced by the 2d Battalion, 508th Infantry, from the 4th Brigade, 82d Airborne Division. To the residents of the Arghandab River Valley, the absence of a substantial coalition presence and the lack of progress by the Afghan government symbolized the apathy or incompetence of both outside parties. General Carter understood that this perception was the key “terrain” to clear and hold during HAMKARI."]},{"figure":{"source":"/figures/m/map-figure-8-9.svg","caption":"Operation HAMKARI","prefix":"MAP"}},"The 2nd Brigade, 101st Airborne Division (TF STRIKE), under the command of Colonel Kandarian assumed responsibility for the Arghandab from the 2d Battalion, 508th Infantry, just prior to the execution of phase two. The incoming brigade combat team initially occupied forward operating bases located north of Kandahar as it prepared to mount successive operations in the northern and southern Arghandab. Kandarian’s formation included the 1st Battalion, 502d Infantry, under Lt. Col. Johnny K. Davis; the 2d Battalion, 502d Infantry, under Lt. Col. Peter N. Benchoff; 1st Squadron, 75th Cavalry, with Lt. Col. Thomas N. McFayden commanding; and Lt. Col. David S. Flynn’s 1st Battalion, 320th Field Artillery. Lt. Col. Thomas M. Spenard’s Support Battalion and Lt. Col. Alan R. Preble’s Special Troops Battalion rounded out the brigade combat team. In addition to his organic units, Colonel Kandarian received tactical control of Colonel Lemon’s 1st Battalion, 66th Armored Regiment, and 3d Squadron, 2d Stryker Cavalry Regiment, under Lt. Col. Bryan E. Denny.","TF STRIKE, along with other forces, cleared the Arghandab and Panjwa’i Districts in HAMKARI Phase II. RC South brought more combat power and combat multipliers to bear in the region than at any time before. Petraeus recognized that previous attempts to reduce civilian casualties, although successful, had been so stifling that offensive operations against the enemy had become less effective. He let it be known that he wanted to increase lethal operations against the insurgency. As Petraeus told Kandarian, “You know you’re the main effort of the world, right?” He then worked to get everything Kandarian asked for, including interpreters, mine-clearing equipment, military working dogs, and MRAPs. Although many of these shortages had been identified long before the current operation, most of them were not solved until Petraeus took a personal interest in the mission. From September to December, Kandarian received an infantry battalion from RC East in the form of 1st Battalion, 187th Infantry, under the command of Lt. Col. Robert J. Harmon Jr. With all the forces at his disposal, Kandarian quickly overwhelmed enemy resistance.",{"figure":{"source":"/figures/v2/img_8-6.png","caption":"A Soldier patrols"}},"In September 2010, the border police commander from Spin Boldak, Abdul Raziq, approached SOF operating in northern Kandahar Province and offered his assistance. Raziq had conducted previous operations with coalition forces; nonetheless, he was controversial among ISAF staffers due to alleged criminal activity. Despite his poor reputation, Raziq was an able tactician, and was popular with the people of Kandahar for his previous contributions to their safety and security. His methods proved devastating to the Taliban, who feared and loathed him. When Raziq offered to clear Arghandab District—which the Taliban had repopulated since the departure of Tunnell’s units—special operators agreed and accompanied his men. On the first day, Raziq’s men removed more than one hundred IEDs and captured dozens of Taliban fighters with hardly any casualties. The speed and ease with which Raziq and his men cleared Arghandab—equipped with Toyota pickup trucks and armed with little more than AK47s and a few rocket-propelled grenades—amazed the special operators and impressed RC South leaders. The police commander from Spin Boldak eventually would be appointed chief of police for all of Kandahar Province and promoted to brigadier general. As Raziq’s forces cleared IEDs from roads, they also gathered valuable and actionable intelligence.","Raziq’s success did not end the fight for Arghandab District. Kandarian needed to be able to hold all the terrain secured by Raziq’s unconventional methods. The American commander felt he needed a minimum of twelve battalions to accomplish that task. Assigned only three organic maneuver battalions, two attached battalions, and six Afghan kandaks, Kandarian needed one more battalion. Before deploying, he had ordered Colonel Flynn’s 1st Battalion, 320th Field Artillery, to train as provisional infantry. This battalion, aided by Lemon’s dismounted tankers, routed the Taliban remnants ensconced in northern Arghandab District.","Intelligence provided by Raziq proved exceptionally useful for TF STRIKE. With mine-clearing equipment, the newly acquired MRAP vehicles, and dismounted patrolling, Flynn’s Task Force TOP GUNS truly cleared the Green Zone of Arghandab for the first time. In the process, they discovered that the villages of Tarok Kolache and Khosrow Sofla were devoid of inhabitants and full of explosives; they had been transformed into IED factories. Using 500-pound bombs and twenty-four tons of artillery munitions, TF TOP GUNS destroyed all structures, enabling the villages to be rebuilt safely.","The tone of the latest fight for the Arghandab reflected Petraeus’ adjusted campaign trajectory. Carter subsequently described the 1st Battalion, 320th Field Artillery’s reduction of the Taliban enclave in northwestern Arghandab as “the greatest achievement of my command.” Over a ninety-day period, Kandarian’s brigade expended 2,035 rounds of 155-mm. artillery, 2,952 mortar rounds, 60 guided rockets, 266 aerial bombs, 19 Hellfire missiles, and uncounted thousands of 30-mm. rounds delivered by A–10 attack aircraft or AH–64 Apache helicopter gunships. The shift to highly kinetic operations did not indicate that Carter had significantly changed his vision of the fight so much as it reflected his willingness to reduce enemy enclaves when suitable assets became available.","The efforts of Kandarian’s brigade combat team were consistent with the ISAF commanding general’s guidance. All told, TF STRIKE killed hundreds of Taliban fighters at the cost of 65 killed and 426 wounded. Although the 5th Stryker Brigade Combat Team had garnered a reputation for unnecessarily heavy casualties, with 37 killed and 239 wounded while fighting the Taliban in that same region, those losses occurred under a different ISAF chain of command that had placed a higher priority on protecting the population than on eliminating the enemy deep in the Arghandab. Whereas Tunnell’s methods had caused friction with his superiors, Kandarian’s similarly unrelenting emphasis on taking the fight to the Taliban met with his superiors’ approval.","${HAMKARI Phase III}{bold}. ISAF renamed HAMKARI Phase III Operation DRAGON STRIKE before its execution. As the last large-scale operation in Operation ENDURING FREEDOM, clearing Zharey and then Panjwa’i Districts would mark the turning point in the surge. From September to October 2010, Operation DRAGON STRIKE featured three battalions of U.S. infantry simultaneously clearing eastern, central, and western Zharey with partnered kandaks. Both of Kandarian’s organic infantry battalions attacked southward through the objective area while the attached 3d Squadron, 2d Stryker Cavalry Regiment blocked enemy escape to the west. In the finale, Colonel Harmon’s 1st Battalion, 187th Infantry, on loan from RC East; SOF; and three Afghan kandaks cleared the horn of Panjwa’i in a two-day operation that began on 15 October. Harmon had expected to be tested by stiff enemy resistance in this last Taliban enclave, but the enemy leadership fled for the city of Kandahar where they melted into the population rather than fight to the death.","Despite launching violent clearing operations around Kandahar, HAMKARI was not a “gloves off” approach to counterinsurgency.  The rules of engagement for RC South were in some ways more restrictive than ever. Operational implications meant that leaders had to take even more care and time to prepare for missions. Before, during, and after each patrol, Kandarian’s troops had to answer fourteen questions:",{"list":["1.\tDid the mission include Afghan National Army or Afghan National Police?","2.\tWere there any civilians killed or wounded?","3.\tWas the local civil leadership notified ahead of time?","4.\tDid they agree?","5.\tWere bombs dropped, attack helicopters used, artillery delivered, or mortars  fired?","6.\tDid the enemy present an imminent threat?","7.\tWere any houses entered without invitation?","8.\tDid the Afghan forces do the home entries?","9.\tDid any element enter a mosque?","10.\tWere any civilians searched?","11.\tDid the unit search the objective to locate enemy and civilian casualties and material damage?","12.\tWere there any unobserved fires?","13.\tHad any escalation of force incidents occurred?","14.\tWere the Afghan or Western media informed?"]},"This checklist ensured that organic units and those attached to TF STRIKE employed artillery and airstrikes only when necessary. Each question sought to protect troops from violating the laws of armed conflict and the theater-prescribed rules of engagement. Many military leaders complained about the questions, but they established control measures necessary to preventing and minimizing civilian casualties.",{"figure":{"source":"/figures/m/map-figure-8-11.svg","caption":"Operation HAMKARI Phase III","prefix":"MAP"}},"Other kinetic and lethal operations, such as the intelligence-driven night raids by SOF, spiked in frequency after Petraeus assumed command. These raids inflicted unprecedented losses on the Taliban. As soon as an insurgent leader rose to a command position, he became a high-value target whose life expectancy was measured in days, not months. The tempo and scale of these operations made life exceedingly difficult for the enemy, regardless of the support that the Taliban continued to enjoy among portions of the local populace. Over a thirty-day period in the summer of 2010, Afghan and ISAF forces eliminated most high-level Taliban leaders in southern Afghanistan; in September, SOF captured twenty-one Taliban fighters in Kandahar City alone. The visiting head of the Virginia-based Joint Forces Command, Marine General James N. Mattis, was so impressed that he told reporters, “Taliban commanders shouldn’t invest in 401(k)s.”","By November 2010, Afghan and ISAF forces had eliminated the Taliban as major players in the provincial capital of Kandahar and its outlying districts. That effort had required more than 24,000 troops, police, and other security forces. After clearing western Kandahar Province, most of the conventional units in Afghanistan pursued hold and build operations. This transition meant that, while some battalion-sized operations still took place, most missions were company-sized or smaller. The enemy was still present, though not in strength. Fighting remained dangerous at the platoon level during these small-scale operations, but there would be no further large-scale clearing operations after the surge peaked in March 2011.","By 2011, Kandahar had moved fully from the clear phase into the hold phase. Unfortunately for the coalition, their efforts stalled here. Afghan civilians in several key regions did not support ANSF in great numbers despite the promise of economic development and improved governance in exchange for withholding support for the Taliban. For the most part, locals never really turned away from the Taliban to support ISAF or the Afghan government. Even though the Taliban had lost many leaders, its fighters continued attacking with suicide bombers, IEDs, and other small-scale operations. When civilians were caught in the crossfire, these events undermined trust in the Afghan government, not the insurgency. One Taliban supporter who eventually became a suicide bomber in Panjwa’i declared, “It [violent resistance] will not stop; this will continue until the day of judgment.” Statements such as these indicated that even though the counterinsurgency campaign could produce tactical victories and some measurable operational progress, there would be little progress at the strategic level so long as the influence of the radical ideology nurtured within the sanctuary of Pakistan went unchecked.",{"figure":{"source":"/figures/v2/img_8-7.png","caption":"Vice Admiral Harward"}},"${Surge Detentions}{bold}","In 2009, General Petraeus, while commanding CENTCOM, dispatched Marine Maj. Gen. Douglas M. Stone to Afghanistan to evaluate the ISAF detention system. Stone had successfully reformed detention operations in Iraq following the Abu Ghraib scandal, and so Petraeus selected him to review the status of detainees in Afghanistan’s Law of Armed Conflict detention facilities, which were designed to hold those captured on the battlefield. During his tenure in Iraq, Stone learned that detention facilities were serving as recruiting centers for the enemy, and he knew this was likely the case in Afghanistan as well. He confirmed those suspicions in what came to be known as the Stone Report, a comprehensive interagency examination of detentions in Afghanistan. Stone’s revelations led to a new detention facility being built at Parwan, adjacent to Bagram Air Base. This not only consolidated detainees in one modern facility, but also brought together the entire spectrum of critical functions, including incarceration, interrogation, skills training for moderate detainees (who were now held separately from those identified as extremists), and even access to legal services to review the cases of detainees. Stone also recommended the immediate release of 400 to 600 detainees who had no ties to the insurgency and posed no real threat.","On 9 July 2009, just a few weeks after arriving in Afghanistan, McChrystal requested to establish Joint Task Force 435 (later Combined Joint Interagency Task Force 435) to command Law of Armed Conflict detentions operations. McChrystal’s request was approved, and the task force stood up on 24 September 2009, although it did not reach fully operational capability until January 2010. Initially commanded by V. Adm. Robert S. Harward and later by Lt. Gen. Keith M. Huber, the unit reported to USFOR-A, not ISAF, so as to maintain a U.S. chain of command. This was possible since most coalition nations preferred to turn their detainees over to nascent Afghan legal authorities for prosecution and detention.","The new headquarters was not established just to detain and hold enemy combatants. Joint Task Force 435 had a robust military interrogation organization that could rapidly and effectively collect and discern actionable intelligence that was fed back to the battlespace owners and SOF for future operations. The information collected in these interrogations was also critical for discerning real, long-term threats versus what was termed the “$10-a-day Taliban”—those detainees who merely fought on occasion to put food on the table.","Changes to the detention process were well timed. Predictably, incarcerations by U.S forces rose dramatically during the surge, doubling the number of detainees by 2010 and again by the end of 2011. During 2010, U.S. forces took 6,439 individuals into custody, of whom 1,359 (21 percent) were transferred to Parwan for long-term detention. Since 2001, 3,599 of the 6,006 detainees to pass through the U.S. detention facilities in Afghanistan had been released, and 54 individuals had been recaptured while fighting for the insurgency, for a 1.5 percent recidivism rate. About a third of all detainees held during all of Operation ENDURING FREEDOM up to this point were detained during the surge.","Recognizing that it could not oversee detentions indefinitely, the U.S. military sought to turn that responsibility over to  the Kabul government. Joint Task Force 435 managed that transition. The first step was to reevaluate all detainees to determine which could be released, which should be turned over to the Afghans, which non-Afghan citizens should be transferred to other countries, and which still had intelligence value and warranted continued detention. During 2010, U.S. forces conducted 2,342 detention review boards—the legal process that discerned the category to which a detainee belonged. About 1,450 Afghan community members and Afghan government officials participated in the hearings at Parwan. They also provided testimony via video, telephone, letters, and other written material. In roughly 75 percent of the boards, representatives from coalition forces outlined the factual basis for capture by appearing in person, participating via video, or submitting written correspondence; at times, they even spoke on behalf of the detainee. Following the review boards, the detainees faced four options: release, continued internment, referral for prosecution by the Afghan government, or transfer to their country of origin. By the end of the year, 10 percent of the detainees were released, along with another 9 percent who met the criteria for continued detention but were released via reintegration recommendations. A further 58 percent remained in internment, which meant that they continued to have intelligence value or were considered too dangerous to be released. Finally, 21 percent were referred for prosecution by the Afghan government, and 2 percent were transferred to their country of origin.","In 2011, U.S. forces captured more than 9,000 enemy combatants, a 35 percent increase from the preceding year. Of that total, more than 2,000 were transferred to Parwan. The results were 4 percent released; 2 percent met criteria, but were released via reintegration recommended; 76 percent continued internment; and 18 percent referred to the Afghan government for prosecution. The increased inflow, coupled with less-frequent releases by review boards, doubled the overall detainee population for a second year in a row. This growth triggered discussions about housing capacity, which led to a plan to increase capacity by more than 2,100 beds.","Joint Task Force 435 also worked to increase the ANA’s ability to assume the Law of Armed Conflict detention mission when the time came to transition the function to the Afghan Ministry of Defense. An ANA military police brigade worked side by side with its U.S. counterparts to learn all facets of military detention. The Parwan facility eventually was successfully transferred to Afghan control. ISAF then mandated that Joint Task Force 435 partner with and mentor the Afghan Central Prisons Directorate to increase the capacity of the Afghans to detain their civilian criminal population at acceptable international standards. Although efforts in this vein were often lethargic, progress was made and measureable in this critical area. Both the military and civilian detention missions amplified the importance of building the capabilities and capacity of host-nation entities to ensure long-term stability.","The surge period was marked by an increase in operations on the ground and an uptick in number of detainees. However, with this renewed push came the knowledge that the U.S. and ISAF missions were operating under a deadline. Extensive operations like MOSHTARAK and HAMKARI demonstrated that counterinsurgency techniques could produce positive results, but only the increased capacity of the Afghan security forces would be able to extend and maintain the security reach of the coalition. As the Afghan government continued to expand its area of control over the country and reduce the insurgent threat, the focus of U.S. and ISAF efforts would turn to preparing the Afghan forces to take control of the fight."],"chapter 9":[{"title":"Preparing the Afghans to Take Over the Fight"},{"section":["At the beginning of the surge, it was apparent to senior American and ISAF officials that it would be impossible to stabilize Afghanistan without indigenous governance and security capacity. The commander of the United States’ CSTC-A was responsible for training the ANSF, developing ministries, and funding security assistance under Title 22 of the U.S. Code. In April 2009, President Barack H. Obama pressed for NATO leaders to adopt the recommendations of the Riedel Report during a conference held to observe NATO’s sixtieth anniversary at Strasbourg, France. One of the top recommendations involved creating a new organization to oversee the training and equipping of the ANSF. A multinational approach would allow member states to contribute as they saw fit to the Afghan security sector. The North Atlantic Council formally approved the concepts discussed at Strasbourg on 12 June 2009."]},{"title":"The Pivotal Role of the NATO Training Mission, 2009–2011","level":2},{"section":["CTSC-A formed the core of the new organization, designated as NATO Training Mission–Afghanistan, which also replaced the ISAF Directorate of Afghan National Army Training and Equipping. Giving the same officer command of both the new organization and its American counterpart provided both the unity of effort and the unity of command absent from previous efforts to develop the Afghan security forces. The commander would remain a U.S. officer to ensure the legal spending of American funds designated for the mission, and also would be the commander of the NATO element. Yet even though the NATO Training Mission–Afghanistan was to be a focal point for all security sector reforms, ministerial development remained conspicuously absent from the alliance’s agenda. That critical task would remain solely an American effort.","The designated commander of the NATO Training Mission, American Lt. Gen. William B. Caldwell IV, received guidance from Secretary of Defense Robert M. Gates before departing the United States. During one meeting, Gates told Caldwell, “Look, when you get over there what I need you to tell us [is:] ‘Is this mission even doable?’ And, if it is doable, [to] what level can we realistically expect to be able to grow the Afghan National Security Force?” Gates’ concerns stemmed from the fact that previous efforts to increase the size of the ANSF had been negated by attrition and inadequate recruiting. The secretary of defense expected Caldwell not only to integrate current U.S. efforts with NATO programs but also to make the combined ANSF development effort more productive and efficient.","General Caldwell departed for his new assignment accompanied by two members of his personal staff. Because the U.S. Congress did not confirm Caldwell’s promotion until three days before he left the United States, he landed in Kabul without any preparatory training or structural reorganization having taken place. In addition, he had to sort through evolving internal responsibilities generated by an ongoing reorganization. With the exception of twenty to thirty individuals, Americans filled all billets in Caldwell’s headquarters. Just two countries—the United States and Italy—were the inaugural members. Caldwell later reflected, “[T]here was really just three [sic] nations when we stood up the training mission that had forces on the ground that were ready to be a part of and contribute to that mission; with promises of more coming in all ready at that point. Almost all funding for [NATO Training Mission–Afghanistan] also came from the United States.” The change of command between Caldwell and outgoing CTSC-A commander Maj. Gen. Richard P. Formica took place at Camp Eggers in Kabul on 21 November 2009. Not only did Caldwell have to deal with bureaucratic turbulence upon his arrival, but one of the first ISAF directives he received mandated that NATO Training Mission–Afghanistan transfer 10 percent of its end strength to the newly created IJC headquarters. General Stanley A. McChrystal’s well-intentioned but ill-timed effort to bolster IJC resulted in the secretary of defense diverting the 10th Mountain Division’s 2d Battalion, 22d Infantry, to Caldwell’s unit in December 2009 to alleviate his personnel shortfalls. Although the arrival of an infantry battalion provided relief, the command faced personnel shortfalls for the first two years of its existence. The training mission ostensibly was a top priority in Afghanistan, but it comprised only 3 percent of ISAF’s total workforce. The average trainer-to-trainee ratio was 1 trainer per 79 trainees; some locations had a better ratio, while other training sites had only 1 trainer per 466 trainees. When Caldwell took over NATO Training Mission–Afghanistan, he counted one soldier on hand for every four authorized positions. Although more personnel were forthcoming, his command rarely averaged more than 60 percent for the first two years of its existence."]},{"figure":{"source":"/figures/v2/img_9-1.png","caption":"General Caldwell briefs Ambassador Eikenberry"}},"Caldwell intended to ensure that Afghans were capable of conducting operations without considerable coalition assistance for an  entire campaign. He sought to create an ANSF that could prevail in battle and also demonstrate the durability to sustain efforts. Maintaining a purely tactical approach to developing the ANSF would have made it impossible to accomplish this goal. In the American view, growing Afghanistan’s security forces included professionalizing its training, educational, and recruiting programs and developing self-sufficient defense and interior ministries. It focused more on building and supporting the institutions as a whole, as opposed to just training the frontline forces. It was no accident that the NATO Training Mission adopted as its motto the Dari phrase shona ba shona, meaning shoulder-to-shoulder. From its modest beginnings in 2002 with a 600-person kandak, the ANSF grew until it could fight alongside other coalition forces. This progress addressed one of the most fundamental goals for the success of counterinsurgency: creating a self-sufficient, capable, and sustainable ANSF.","${The Building Blocks of Professionalism}{bold}","Before Caldwell assumed command, he met with Richard C. Holbrooke. Holbrooke told the general, “You’re really going to have to  take on the illiteracy issue.” Caldwell answered by explaining, “Ambassador, with all due respect I’m a soldier, I don’t do literacy training.” Less than two weeks after arriving, the new NATO Training Mission–Afghanistan commander realized just how uninformed he had been on that topic. As he later reflected:",{"list":["\"About 14 percent of the recruits coming in had some level of literacy—14 percent. That meant 86 percent of the recruits coming  in could not read, write, or even count. They had no capability. I’ve been in a lot of places over my career. I had never seen the level of illiteracy or failed to recognize the dramatic impact that that has when you’re trying to build a sustaining, enduring kind of capability.\""]},"In early spring 2010, Caldwell decided to mandate literacy training for ANSF personnel. It took almost half a year for him to obtain funding, acquire materials, develop courses, hire teachers, and send them to Afghan bases. Caldwell later acknowledged, “Dr. Jack Kem led that effort . . . and he did an incredible job of making that happen.” NATO Training Mission–Afghanistan sought support from the Afghan government and NATO. Literacy lesson plans, for example, required Ministry of Education approval. Caldwell also championed a NATO educational trust fund so that member nations that did not want to send personnel to Afghanistan could contribute to the literacy program. When soliciting Western support for this program, training mission representatives argued that “a literate workforce is more likely to observe, understand, and report corrupt behavior. Additionally, a literate workforce is less susceptible to radicalization as they can self-educate and ‘cross-check’ the ‘truth’ being proffered by radical leaders.” Caldwell did not feel that he could pursue the state-building goals sought by the Obama administration without teaching Afghanistan’s soldiers and policemen how to read.","The literacy program had to instruct new inductees, enlisted soldiers, noncommissioned officers, and commissioned officers. Recruits received lessons covering the most common and basic military terms during their eight weeks of initial entry training, while leaders were expected to gain even higher levels of proficiency by attending specialty schools or professional development courses. Instructing soldiers already in the operational force on the front lines presented the greatest challenge. Out of 88,000 ANSF attending literacy training during 2010–2011, only 33,000 received instruction during initial entry or professional development training. The remaining 55,000 received the training while serving in police and army units. The literacy program had to expand every time more local security organizations or ANSF units were generated. Although the literacy program may have made it easier to train soldiers, its impact on ANSF combat effectiveness remained to be seen.","Improvements in literacy proficiency within ANSF ranks did produce near-term benefits by facilitating a nationwide inventory of weapons, communications equipment, and vehicles by Afghan security forces. Although eight months elapsed between the introduction of literacy training and the start of the inventory, Caldwell tolerated the delay because the end state—an account of all the equipment provided to the Afghans since 2002—was only worthwhile if it proved accurate. The inventory took place incrementally, focusing successively on vehicles, weapons, and then communications equipment. The inventory determined what units owned and provided a baseline for identifying the future needs of an expanding ANSF. It helped develop Afghan security forces by demonstrating the value of equipment accountability and the way to conduct a nationwide inventory.","Caldwell also sought to synchronize ANSF concepts of waging war with those practiced by Western troops. He recognized that following a counterinsurgency approach based on U.S. doctrine would be far less effective if ISAF’s Afghan partners did not follow its precepts. Since the best way to instruct Afghan units was through partnering with coalition forces, the training mission commander pushed to have deploying units train in the Dari and Pashto languages as well as cultural sensitivity and religious awareness. This would facilitate a better understanding and working relationship between the partners, exponentially increasing both the efficiency and the effectiveness of the partnership.","NATO Training Mission–Afghanistan devised an ANSF counterinsurgency training model that combined Western and Afghan concepts. This model included more than a refresher on counterguerrilla tactics by introducing students to the economic, political, and military aspects of the warfighting approach. It consisted of three components featuring both individual and collective training approaches. The first component focused on the professional development of noncommissioned and commissioned officers by sending them to an Afghan-led counterinsurgency academy. The second component consisted of rotating kandaks from the operational force through a counterinsurgency-oriented training center. Mobile training teams that deployed to kandaks unable to attend the collective training center were the final component of the Afghan counterinsurgency triad.","${ANSF Expansion}{bold}","The surge in Afghanistan was not just an American or coalition effort. Although American forces in Afghanistan increased from 28,000 in 2008 to more than 100,000 in 2011, and the contributions of other nations grew from 32,000 to nearly 50,000 during the same period, population-centric counterinsurgency could not be pursued in the country unless comparable increases were made in Afghan security forces. ISAF’s efforts to develop the ANSF had initially stressed numbers over quality. Unit partnering then provided ANSF units the opportunity to develop competence and confidence while executing the security mission. The idea was that once fully formed in 2012, the ANSF could address shortfalls in equipment, logistics, personnel, and leadership. After 2012, ISAF shifted focus to enabling the ANSF and professionalizing its units before ISAF combat operations ended in 2014.","At its inception, the NATO Training Mission inherited the Combined Security Training Command’s goal of growing the ANSF to 195,000 (100,000 in the ANA, 95,000 in the ANP). By March 2011, ANSF authorizations had grown to 276,000, increasing even further to 330,000 in March 2012. By September 2011, the ANSF finally started to approach its expanded authorizations. As the surge recovery began and coalition forces started departing Afghanistan, the Afghan Army and Air Force had 170,781 soldiers and airmen, with another 136,122 in the national police for a total of 306,903. The NATO Training Mission needed to increase its trainers quickly in order to keep up with the growing ANSF numbers. At its founding in November 2009, Caldwell’s organization had 3,000 members, of which only thirty were from coalition nations. By November 2010, it had more than doubled in strength to 6,497, with slightly more than 1,000 international trainers from 37 different troop-contributing nations. By the end of 2011, the number of international trainers reached 1,600 with another 700 pledged. Although the mission had grown substantially, it was still 460 trainers short of its authorized level of 2,760. As the organization’s commander, Caldwell tried to convince ambassadors to maximize their nations’ participation in the training mission.",{"figure":{"source":"/figures/v2/img_9-2.png","caption":"ANA recruits fire .50 caliber machine guns"}},"At the May 2012 NATO Summit in Chicago, ISAF troop-contributing nations agreed to decrease the ANSF end strength to a “sustainable level,” with the goal of Afghanistan being able to fund its security forces by 2024. As the ANSF increased from 330,000 to 352,000 personnel, with an additional 30,000 Afghan Local Police, it became obvious that the Kabul government could not financially maintain a force of that size without international assistance. The dependence on U.S. and ISAF tactical support was particularly critical for Afghan special operations and aviation units. The Afghan security ministries were equally dependent on coalition assistance in planning and sustaining extended campaigns. The premise upon which ISAF had defended building the ANSF to almost 400,000 personnel was that an aggressive expansion would beget security gains impossible to reverse by the time Afghan security forces would have to reduce to a sustainable level. ISAF established Operational Coordination Centers to interact with ANSF components regionally and provincially. At the regional level, coordination occurred among the Afghan Army, National Police, and Border Police. At the provincial level, Afghan Army brigades coordinated with provincial chiefs of police and the nearest Border Police brigade. Local police secured areas outside those of conventional ANSF units, in addition to providing early warning to the other Afghan security forces.","An urgent need to overhaul the police training managed by the U.S. State Department soon surfaced as one of Caldwell’s top priorities. As one member of Caldwell’s command noted, the police training effort experienced major problems with the manner in which contracts were written, as well as the fact that “contractors . . . had no incentive to work themselves out of a job [by teaching] the Afghans to [train] themselves.” Rather than scrap the existing program, Caldwell directed the current contract be amended. As the revision neared completion in March 2010, it encountered a legal challenge in U.S. courts. Faced with at least a twelve-month delay, Caldwell turned to NATO for assistance.","Recognizing that European law enforcement organizations with paramilitary skills possessed the best qualifications to teach these skills to Afghan police, Caldwell’s staff began soliciting trainers from NATO members that had national paramilitary police forces, such as Romania, France, and Italy. However, NATO Training Mission–Afghanistan acknowledged that it would never acquire enough NATO trainers to replace contractors; therefore, recruits would have to receive instruction from contractors until the legal challenges to the new contract could be resolved. Lacking more NATO police trainers, Caldwell focused incoming NATO assets at installations and facilities his planners deemed most critical to the overall effort. The training programs at installations lacking full-time NATO representation were revised once the legal challenges to the new contract were resolved.",{"title":"Special Operations and Local Security Forces","level":2},{"section":["Numerous programs and initiatives arose throughout the duration of the U.S. mission to establish local police forces that better understood the environment and the populations where they served. With the completion of the disarmament, demobilization, and reintegration program, but with ANA capacity still lacking, tribal elders called upon ISAF, U.S. forces, and President Hamid Karzai’s government to support forming local militia formations known as arbakai. Fearing a return to warlord militias, the Karzai government instead agreed with a Combined Security Training Command and Ministry of Interior initiative known as the Afghan National Auxiliary Police. Instituted in late 2006 with the support of Ambassador Neumann and General Eikenberry, the program would recruit a community policing force from the local populace. Those selected would receive uniforms, weapons, eighty hours of training, and approximately $70 a month in salary.","Although the program called for more than 10,000 auxiliary police, it had come under scrutiny by May 2008 because of inadequate vetting, poor accountability, unclear lines of command and control, and inadequate logistical support. The effort ended in failure, and the units were disbanded. Some auxiliary police were absorbed into the Afghan Uniformed Police, Border Police, or recruited into the Afghan National Civil Order Police upon the program’s termination in September 2008. However, the poor literacy rates and lack of competency of those auxiliary police that transferred to national police units adversely affected the quality of the gaining units. The failure of the Afghan National Auxiliary Police program also had a measurable, negative impact on police recruitment across the nation.","By 2010, after lengthy negotiations with the IJC, the Karzai government again agreed to establish local security forces in remote provinces. Their creation involved identifying areas that wanted the security, vetting those able to provide the security, empowering and minimally resourcing those willing to provide volunteers, and then supporting the organizations with ANSF assistance and guidance. This process would be the model for what would become the Afghan Local Police. The new program would get off to a slow start, as numerous organizations had large roles in the planning, including the Afghan Ministry of Interior, ISAF, and Combined Forces Special Operations Component Command–Afghanistan, all of which actually would execute the program.","${Decentralizing Security: Afghan Public Protection Program}{bold}","In January 2009, ISAF created a new one-star Special Operations headquarters to provide an operational-level command and control headquarters for NATO forces. Army Brig. Gen. Edward M. Reeder Jr. took charge of the new organization, designated Combined Forces Special Operations Component Command–Afghanistan. Although this new command continued to develop the Afghan special operations kandaks and brigades, and conducted counterterrorism operations against mid-level Taliban and al-Qaeda leadership, it sought to place more emphasis on local security initiatives. Reeder soon discovered that General David D. McKiernan agreed with that approach and had already implemented an experimental program along these lines, the Afghan Public Protection Program, in Wardak Province.","Recruiting for the program, overseen by a Special Forces company led by Maj. Bradley D. Moses, began immediately after Reeder’s arrival. Rather than create a Western-style paramilitary organization, the program drew inspiration from the accepted practice of establishing arbakai. The arbakai differed from previous militias because they formed only when tribal elders determined a need for collective security against external threats. The program sought to correct earlier failures by recruiting only motivated individuals; providing the proper equipment, training, and salaries; and bringing in Ministry of Interior police from district offices to mentor the units. Although the training regimen was shorter than that of a conventional Afghan police recruit, it was conducted at an established police training facility in Mehtar Lam, Laghman Province, and overseen by the same SOF that would later mentor the police in Wardak.","The first forces trained and equipped by the program completed their training in March. The forces were to be employed by the Ministry of Interior in conjunction with McKiernan’s Focused District Development program. By tying the local police initiative to Focused District Development, the coalition and Afghan government alike hoped to reward increased security through additional infrastructure improvements and in turn provide enhanced security for those same projects. Based on the initial success of the program, Reeder pushed to expand the Afghan Public Protection Program throughout the country, and put his staff to work developing an approach focused on internal motivation and Afghan-sponsored solutions. Expanding the program required the support of the ISAF commander, the State Department, and, most importantly, the Afghan government.","The approval process began anew when McChrystal replaced McKiernan. McChrystal approved Reeder’s plan to begin trial runs for six months while attempts were made to subordinate the program to the Ministry of Interior. Labeled the Community Defense Initiative, McChrystal’s idea was distinct from the Afghan Public Protection Program in that locals would volunteer to participate in the initiative to resist the Taliban, request permission to form security forces, provide their own weapons, and receive no salary. Afghan government support would be limited to ammunition, communications equipment, food, and training. Although there were a few Community Defense Initiative success stories, the program never received Karzai’s endorsement.","Adding to the difficulties of gaining a viable local security program was the deterioration of the Afghan Public Protection Program by early 2010. The program faltered as it handed over vetting, partnering, and mentorship responsibilities to unprepared and underresourced conventional battlespace owners. It could not overcome a drastic shift in mission from point defense of the local populace and infrastructure to that of mounted highway patrol. It was further weakened when local political leaders tried to install men with questionable motives as unit commanders and unquestionable loyalty to the politician. Seeking to correct these deficiencies, the coalition Special Operations command renamed the program the Local Defense Initiative but still faced challenges from within the coalition and resistance from the U.S. Embassy.","In March 2010, Brig. Gen. Austin S. “Scott” Miller assumed command of the Combined Forces Special Operations Component Command–Afghanistan and, in April 2010, USFOR-A gained operational control of the headquarters. Miller embraced the program and made it his primary focus. Following the path forged by Reeder and foundations established by 3d and 7th Special Forces Groups, his command began addressing obstacles to community defense at both the operational and tactical (or local) levels. Seeking to flatten his organization, optimize assets in theater, and integrate his plans into Afghan government efforts, Miller called on the new commander of CJSOTF-Afghanistan, Col. Donald C. Bolduc, to overhaul the Local Defense Initiative.","In May 2010, Miller provided a new blueprint now known as Village Stability Operations. Pentagon officials described Village Stability Operations as “a bottom-up counterinsurgency initiative” designed to promote local governance and development by creating secure rural villages. A twelve-man SOF team conducted each operation, establishing itself within selected villages to engage regularly with locals and gauge whether the program would succeed in the area. Village Stability Operations teams linked to district and provincial augmentation teams, as well as Provincial Reconstruction Teams, through Village Stability Platforms that house security and stability assets. Village Stability Platforms required a self-nominated village, an embedded SOF team, ANSF battlespace owners, participation by district and provincial governments, and Ministry of Interior approval and resourcing. Most Village Stability Platforms would request and develop their own Afghan Local Police forces monitored and supported by the district and provincial Afghan National Police commanders. The Afghan government and ISAF enabled the effort through village stability coordination centers where district and provincial augmentation teams received infrastructure improvement projects funded by Provincial Reconstruction Teams.","Using the combined joint special operations task force’s extensive analysis from August 2009 through February 2010 and interviews with local, district, and provincial leaders, the Village Stability Operations pilot program began in five districts in May 2010. In acknowledgment of their success, Karzai signed a presidential decree in August 2010 officially integrating the Afghan Local Police into the Ministry of Interior. Connecting district and provincial governance to national leaders and ministries, mentorship and support from ANSF units, and joint oversight between ISAF and the Afghan government had provided enough layering to satisfy all interested parties.","American SOF units supporting the growing Village Stability program were called upon to employ infantry and Commando kandaks to targeted districts. In many cases, a preliminary clearing operation was required. SOF partnered with the ANA to conduct clearing operations, and then remained on site to serve as civil affairs and military information support teams to publicize opportunities for the Village Stability Operations. In the arbakai tradition, and with prior coordination of the district and provincial governance, embedded SOF, ANA, and ANP units would promote shuras leading to a jirga (larger tribal assembly) and the appointment of volunteers to form Afghan Local Police. Embedded SOF and ANA personnel would vet the nominees through Ministry of Interior, National Directorate of Security, and ISAF security organizations. The new Afghan Local Police unit received training, uniforms, weapons, communications equipment, and vehicles but was not granted the authority to arrest anyone. With local security established, the villages became more resistant to Taliban influence, allowing the coalition military commander, reconstruction teams, nongovernmental organizations, and Afghan government to pursue infrastructure development and other quality of life initiatives."]},{"figure":{"source":"/figures/v2/img_9-3.png","caption":"Afghan Commandos"}},"The Village Stability Operations soon expanded to twenty-three sites, and the appetite for the program began to exceed available SOF teams. The model relied on competent and relatively uncorrupt district and provincial leaders in both the government and police. Those areas supported by district augmentation teams and Provincial Reconstruction Teams were able to mentor these leaders or advocate for the removal of poor leaders. Additionally, resourcing these efforts required close coordination with the Afghan Ministry of Interior, the U.S. State Department, and the NATO Training Mission.","However, not all village stability sites succeeded in forming Afghan Local Police, and not all Village Stability Operations efforts were initially successful. As Village Stability Operations proliferated, Combined Forces Special Operations Component Command–Afghanistan and ISAF Special Operations Command realized the resources required to train and support their foreign internal defense programs, including Village Stability Operations, resided in the NATO Training Mission. Seeking to synchronize both efforts, U.S. Special Operations Command commander Admiral Eric T. Olson and McChrystal agreed to assign an assistant commander for Special Operations to the NATO training organization. General David H. Petraeus supported McChrystal’s decision after the latter’s departure, with the result that Brig. Gen. James B. Linder arrived in October 2011 to oversee the Afghan Special Forces, special police, and Village Stability Operations initiatives. By integrating Village Stability Operations into IJC’s Operational Plan, OMID 1390, and the ISAF commander’s 2011 campaign plan, Linder synchronized all special operations efforts in Afghanistan. Although it was difficult to coordinate the layered security involving a multitude of Afghan security entities, strong leadership and aggressive mentorship overcame these challenges. The many efforts began to coalesce in early 2012.","The success of Village Stability Operations produced unexpected challenges. While Karzai officially validated the program by inducting units into the Ministry of Interior in 2010, he simultaneously outlawed private security forces. Although he initially required all private security forces to disband by 1 January 2011, he later allowed them to remain until 20 March 2012. Beyond this date, a limited number of formerly Afghan-licensed companies were absorbed into the Ministry of Interior under the newly reestablished Afghan Public Protection Force. Yet Karzai’s decree posed a challenge for conventional American units, which had begun to mimic the Village Stability Operations concept by creating ad hoc local security units. Using Commander’s Emergency Response Program funds to resource community-based security solutions, conventional forces had hired locals to provide security for remote bases and small-scale reconstruction projects. As IJC’s executive agent, Miller’s headquarters provided guidance for integrating these security forces into planned or existing Ministry of Interior–approved village stability sites. All of these efforts needed support from the Afghan government or risked being dissolved when coalition conventional forces departed Afghanistan.","By September 2011, Combined Forces Special Operations Component Command–Afghanistan, now commanded by Brig. Gen. Christopher K. Haas had expanded Village Stability Operations to seventy-six sites, forcing Haas and the Ministry of Interior to cap Afghan Local Police based on available special operations teams, projected surge reductions, and resource sustainability. The determined maximum became ninety-nine villages, with each program to last no longer than five years and the forces themselves being disbanded or absorbed into the ANSF by 2016.",{"title":"Efforts in Development and Governance, 2009–2011","level":2},{"section":["Even though the U.S. Embassy and the military often generated bureaucratic friction rather than results when they made efforts to work together, cooperation between the DoD and the State Department generally remained positive when it came to Provincial Reconstruction Teams. During the surge, reconstruction team efforts benefited significantly from decisions made before the additional troops arrived. Owing to McKiernan’s estimate that 2,100 civilian positions were needed and Ambassador Karl W. Eikenberry’s push to improve governance and development, more than 1,000 additional civilian positions were filled during the surge."]},"${The Civilian Surge}{bold}","Although Eikenberry took pride in quadrupling the number of civilian personnel in provincial positions, a typical reconstruction team in 2009 included just three civilians and between sixty-three and ninety-nine military personnel. An average of thirty-five civilians from the Department of State, U.S. Agency for International Development, and the U.S. Department of Agriculture thus were assigned to reconstruction teams nationwide. This number was dwarfed by the funding they managed, which exceeded $600 million. Increases in personnel and funding were managed by the Regional Command’s new senior civilian representative, giving the civilian side its own chain of responsibility. Although more civilian expertise had become available, it fell short of what military commanders wanted and desperately needed. Over time, the civilian staffing issues would improve, but in many cases there simply were not enough people on hand to complete the massive amount of work that was necessary.","During the surge, Americans sought to focus their available resources in geographical areas chosen by the Afghan government. The newly formed Afghan Independent Directorate of Local Governance selected the areas. At the successive requests of McChrystal, Petraeus, and Eikenberry, Afghans identified eighty key-terrain districts and forty-one area-of-interest districts. These districts were mostly along the Ring Road and near border crossings, with approximate locations in Helmand and Kandahar Provinces, and in the most dangerous districts and provinces of RC East that ISAF already had designated for the military surge.","Admiral Mullen’s decision to “throw the kitchen sink” at Afghanistan in 2009 permitted new ideas to be tried. New organizations stood up under the ISAF umbrella to aid in accelerating governance and development. Through these organizations, McChrystal and Petraeus aggressively began pursuing solutions to problems identified years earlier. The key-terrain district concept proved important in focusing the additional resources during 2010–2011. However, when the Afghans and IJC added three more key-terrain districts to the list in mid-2011, before any were considered ready to move to the build phase, interest in the program diminished rapidly. Attention swiftly turned from key-terrain districts to the five tranches—the NATO term designating the selected parts of Afghanistan that would be transitioned to Afghan authority by 2014. Now, rather than try to build Afghan governmental capacity one key district at a time and then transition it to Afghan control, the plan was to transition control in large swaths.",{"figure":{"source":"/figures/m/map-figure-9-4.svg","caption":"Regional Commands South & Southwest","prefix":"MAP"}},{"figure":{"source":"/figures/m/map-figure-9-5.svg","caption":"Regional Command East","prefix":"MAP"}},"${Corruption and the Rule of Law}{bold}","On 1 July 2010, Brig. Gen. Herbert R. McMaster stood up Task Force SHAFAFIYAT (Transparency) in Afghanistan. Its mission was to foster a common understanding of the corruption problem, plan and implement ISAF anticorruption efforts, and integrate activities in support of an active and honest Afghan administration. It was an unprecedented effort for a foreign military to take such a broad stance on dealing with a host nation’s internal corruption problems. Starting with just three senior personnel, McMaster’s means and results were modest; nonetheless, it showed the extent to which the U.S. military was willing to attempt innovative solutions to old problems during the surge. As McMaster brought more people and assets to support his task force, its results improved over time, but corruption was an issue that would take generations to fix.","Eliminating corruption was not limited to Afghan practices. With billions of dollars spent annually in Afghanistan, American leaders were concerned that contract prices in the country had become inflated. Some inflation came from legitimate security charges that contractors incurred, but often these charges were protection money paid to warlords, Taliban, militias, and even Afghan police. These payments sparked inflation and created an artificial and unsustainable economy in some areas. In response to those concerns, USFOR-A and ISAF created Task Force 2010 in June 2010. Under the command of U.S. Navy R. Adm. Kathleen M. Dussault, the task force mirrored and supervised the U.S. Army’s Task Force SPOTLIGHT, commanded by Army Brig. Gen. Margaret W. Boor. Both organizations focused on identifying and eliminating fraud, waste, and abuse within the contracting processes supporting coalition operations. They tracked contracting funds from allocation to commitment and through the delivery of the services purchased. Task Forces 2010 and SPOTLIGHT discovered that considerable funds were being used for unintended purposes, and the task forces became a viable means of ensuring that this problem did not continue.","Although several NATO nations supported the reform of Afghanistan’s legal institutions, few were willing to send experts to aid in the effort. In a prime example, in September 2010 the United States created the Rule of Law Field Force–Afghanistan, which brought in military lawyers, engineers, police, and others to support civilian efforts in bolstering rule of law in Afghanistan. The organization had become necessary when it became clear that the civilian surge would be insufficient to push judicial reform and infrastructure down to the local levels. It was also critical in Afghanistan to provide the population a responsive and fair recourse in a court of law, as opposed to deferring to traditional sharia law, the preferred Taliban method. Under the command of the U.S. Army’s Brig. Gen. Mark A. Martins, this headquarters eventually also would command NATO’s Rule of Law Field Support Mission–Afghanistan. The decision to add the NATO title was intended to encourage contributions from coalition partners, but it was largely unsuccessful. Experts from outside the United States did not enthusiastically support American military designs for innovation, even if they had been approved by the North Atlantic Council. The U.S. Army filled 80 percent of these billets; other branches of the U.S. military filled most of the remainder. The effort achieved much in terms of pushing the rule of law from the Afghan national government down through the provinces and to the districts. However, the end of the surge greatly hindered the rule of law effort, as it would take more than two years to institute legal reforms of such magnitude in an environment such as Afghanistan.",{"title":"Special Operations Command and Control","level":2},{"section":["For nearly seven years, CJSOTF-Afghanistan had been the Special Operations Command element in Afghanistan. The overall operational dynamic began changing just before the start of the surge as Afghan SOF improved in proficiency, adding complexity to partnered operations. At the same time, U.S. and ISAF SOF in Afghanistan oversaw the formation and training of progovernment militias. The new missions, which were added to other critical tasks such as attacking threat networks and Taliban leadership, took a heavy toll on task force resources, which had been focused on managing operational and tactical integration with the conventional and international forces. Based on recommendations from Admiral Olson and General McKiernan, CENTCOM originally created a new Combined Forces Special Operations Component Command–Afghanistan to relieve the SOF task force’s operational-level burdens. Many viewed the creation of the new headquarters as layering more bureaucracy onto the existing force structure, but the structure under Reeder allowed CJSOTF-Afghanistan to focus on its tactical-level command and advisory requirements.","In addition to gaining operational control of CJSOTF-Afghanistan, Reeder’s headquarters sought to establish a greater unity of effort among U.S. and ISAF Special Operations contingents, as well as the dedicated U.S. counterterrorism forces in Afghanistan. That goal could be achieved only through integrating Special Operations plans within the overall ISAF campaign plan. Although Reeder had no command authority over either ISAF SOF or the counterterrorism task forces, he dedicated considerable time throughout the surge to synchronizing their efforts.","In 2009, recognizing that SOF unity of effort would be almost impossible to achieve under the existing command and control structure, McChrystal proposed changes to CENTCOM that would unify the separate SOF entities. With CENTCOM’s approval, IJC published Fragmentary Order 408 directing that operational control of the Combined Forces Special Operations Component Command–Afghanistan be transferred to NATO by spring 2010. The Combined Forces Special Operations Component Command–Afghanistan provided overall direction to its subordinate units while ensuring they coordinated their activities with regional commands. Fragmentary Order 408 instructed the international SOF contingent to provide command and control elements to the ISAF SOF headquarters and send liaisons to each regional command. The counterterrorism task forces remained under CENTCOM control, but they were directed to provide liaisons to ISAF, USFOR-A, and CJSOTF-Afghanistan."]},{"figure":{"source":"/figures/v2/grafik_9-4.png","caption":"Evolution of Special Operations Command and Control"}},"${Special Operations in Afghanistan Receives More Resources}{bold}","While the Combined Forces Special Operations Component Command–Afghanistan now exercised operational control of both ANA Commando units and CJSOTF-Afghanistan, the changes listed in Fragmentary Order 408 did not provide the forces required to address an expanding range of missions. As Col. Gus Benton II prepared to take command of the task force in January 2009, his 3d Special Forces Group staff had to make do with inadequate resources caused by outdated plans. Rather than utilize augmentees provided by other units before deployment, Benton’s group would have to cull from its own ranks to meet increased liaison requirements levied by the Combined Forces Special Operations Component Command–Afghanistan.","Although Benton would receive some assistance from Naval Special Warfare Task Units and Marine Special Operations companies, as well as Special Operations contingents furnished by Canada, Great Britain, France, and the United Arab Emirates, 3d Group found itself hard-pressed to fulfill the demands placed upon CJSOTF-Afghanistan by Fragmentary Order 408. All of these forces and more were essential, as the task force’s operational requirements were increasing with its foreign internal defense efforts. Benton and his organization continued the development of the ANA Commandos, formalized partnerships with conventional ANA units, and experimented with local constabulary-like forces in remote locations. Colonel Benton’s boss, General Reeder, grew more convinced that the last initiative, when combined with the other foreign internal defense programs, would be the key to improving security within Afghanistan.","By May 2009, there were five fully operational Commando kandaks supporting the regional commands, with a sixth kandak nearing the end of its training and preparation for employment, along with a brigade headquarters. Partnered forces raided mid-level enemy leadership and networks, conducted reconnaissance in support of conventional operations, provided regional quick response capabilities, and were publicized as the new face of Afghan Army professionalism through a concentrated information campaign. Commando kandaks had the highest retention rates in the ANA because of their regularly scheduled leave, higher pay, continuous indoctrination and training cycles, predictable deployment cycles, and esprit de corps. As the Commandos increased in capability and capacity, CJSOTF-Afghanistan and the Ministry of Defense began focusing them (with their advisers) on specific areas.","SOF had long supported conventional ANA units by operating in areas of RC West and RC South that lacked ISAF presence. In addition to this informal arrangement, Reeder’s teams sought to develop local security in remote districts and in conjunction with Afghan conventional forces. Increased numbers of SOF personnel were needed to turn this vision into reality if the surge was to produce the outcomes sought by the Obama administration.","${The Special Operation Surge Begins}{bold}","As the conventional forces began increasing in numbers in early 2009, SOF also was preparing to surge operations in Afghanistan. To increase available personnel, all Special Forces Groups activated a fourth battalion, and the 75th Ranger Regiment added a fourth company to each of its three battalions. Similar initiatives had occurred over the past several years within the other services. As a result of these force structure increases, Col. James E. Kraft of the 7th Special Forces Group arrived in Afghanistan in July 2009 with three Special Forces battalions and significantly more Marine and Naval Special Warfare augmentation. The additional manpower permitted the group commander to work with ISAF regional commanders and establish partnerships with ANA corps. In addition, Kraft now had enough resources to support small Afghan units in areas where international forces did not maintain a presence.","Kraft distributed his available resources so they could partner with the ANA’s 201st, 203d, 205th, 207th, and 209th Corps. He left the sixth Commando kandak uncommitted to allow it to meet short-notice requirements such as counterterrorism operations, deploying a quick-reaction force, or relieving other Commando kandaks. In addition to the kandak partnerships, Special Operations detachments were allocated to twelve areas where community defense initiatives were being implemented. In addition to Kraft’s efforts, SOF resources under the control of Combined Forces Special Operations Component Command–Afghanistan supported McChrystal’s population-centric counterinsurgency through a combination of foreign internal defense operations and robust counterterrorism.","At the same time, a growing number of dedicated counterterrorism resources and personnel based in the United States were being diverted from Iraq to increase pressure on enemy logistical networks in Afghanistan. The 75th Ranger Regiment dedicated nearly a full battalion to command and support these assets while Navy Special Warfare elements, the 160th Aviation Regiment (Special Operations), and other Army forces provided assistance. The increased raids and attacks on enemy networks were unfortunately accompanied by increased danger as nineteen special operators were killed in action during the latter half of 2009. Noncombat fatalities and the loss of specialized aircraft proved as harmful to the mission as lost service members. On 28 October, low visibility caused a CH–47 Chinook helicopter to crash in Badghis, killing seven military personnel and three Drug Enforcement Agency civilians on a counternarcotics raid. With limited numbers of Special Operations aircraft available in theater, the loss of every airframe and every highly skilled pilot dealt a serious blow to the entire force.","${Special Operations Presence}{bold}","When Colonel Benton returned with 3d Special Forces Group to relieve the 7th Group and assume command of CJSOTF-Afghanistan in January 2010, he knew that his tour would be shorter than normal. The Defense Base Closure and Realignment Commission had removed the 7th Special Forces Group from the Afghan rotation cycle so it could relocate from Fort. Bragg, North Carolina, to Eglin Air Force Base, Florida. The move would take fourteen months to complete. Rather than commit another group to cover the gap, the U.S. Army Special Operations Command sent Benton to Afghanistan for ninety days before replacing his command with an ad hoc headquarters. Benton thus turned over his command to Colonel Bolduc in April 2010.","Unlike units in earlier rotations, Bolduc’s unit arrived knowing it would remain in Afghanistan until the 7th Special Forces Group resumed operational status in March 2011 and would be available for deployment. Bolduc’s staff was made up of part of the 3d Group headquarters augmented by individuals from a number of organizations, including many drawn from his subordinate elements. The 2d Battalion, 1st Special Forces Group, which formed the core of Special Operations Task Force 12, supported RC South. Responsibility for RC North and RC West fell to Special Operations Task Force 81, which included the first battalion-level Marine Special Operations Command unit in Afghanistan. The 3d Battalion, 3d Special Forces Group provided the core of Special Operations Task Force 33 supporting RC East.","The handover between Benton and Bolduc also signaled the introduction of the “flag-forward” concept designed to provide greater continuity over  time to high-priority projects. This concept involved splitting operational detachments into two halves, each of which was brought back up to full strength by individual replacements. Splitting the teams enabled commanders to send one element to Afghanistan for a specific mission before replacing it with the second half of the split team. It also maintained a single higher headquarters in country for longer periods of time. Allowing for some overlap during changeover, the arrangement allowed commanders to commit an operational detachment to a specific mission for a period greatly exceeding a normal tour of duty, lending tremendous continuity to the effort. Reeder applied “flag forward” to his top priorities: Village Stability Operations and Commando kandaks aligned with ANA Corps.","That decision proved timely as SOF and the conventional forces increasingly needed Afghans in the lead to compensate for restrictions on the use of force mandated by ISAF. Between 2008 and 2010, airstrikes, aerial interdiction, and night raids caused a marked increase in civilian casualties. McChrystal personally intervened by issuing his “Tactical Directive” on 1 July 2009 as well as a “Night Raids Tactical Directive” on 23 January 2010. Both documents were intended to reinforce the tenet of “courageous restraint” introduced by McChrystal as ISAF sought to minimize collateral civilian casualties and placate cultural sensitivities. The directives were well intended, but the Taliban was quick to recognize and take advantage of the revised rules of engagement. As a result, the policy met with mounting disfavor among American and ISAF combat troops who believed McChrystal’s approach placed their own lives at risk by ceding the tactical initiative to their opponents.","Two incidents of special operations units inflicting casualties on Afghan civilians following the introduction of “courageous restraint” called attention to the need for even more deliberate procedures. The reaction to each event illustrated how strongly all parties felt about the accidental targeting of innocents. The first incident, which highlighted the increased activity of counterterrorism units in Afghanistan, took place when troops from the 75th Ranger Regiment raided Khatabah, near Gardez, on 12 February 2010. The operation resulted in the death of five Afghan civilians while provoking accusations from Karzai of an ISAF cover-up. As a testament to the special operations community’s willingness to back McChrystal, Navy V. Adm. William H. McRaven, flew from MacDill Air Base in Florida to the Khatabah to apologize formally for the deaths.","The second incident occurred in Uruzgan Province nine days later, when CJSOTF-Afghanistan authorized a Scout Weapons Team to engage a suspected enemy convoy detected by an unmanned aerial vehicle operator. Events began with a SOF element receiving reports of a potential attack on its position following a night raid. The unmanned aerial vehicle operator who initially detected an approaching convoy chose to discount subsequent analysis indicating that the vehicles contained women and children. Based on the flawed analysis, the SOF task force authorized OH–58 Kiowa pilots to engage the convoy. The strike took place approximately twelve kilometers from friendly forces and clear of populated areas. Once the special operations element reached the destroyed convoy, it discovered that the occupants were unarmed civilians. A total of twenty-seven Afghans, including four women and one child, were killed while numerous others were wounded. The chief investigator subsequently recommended reprimands for the commanders of CJSOTF-Afghanistan and the Special Operations Task Force for failing to report the incident in a timely fashion. He further recommended reprimands for the unmanned aerial vehicle crew for ignoring analysis that indicated a civilian presence. Both incidents served as cautionary indicators for SOF units whose unparalleled ability to connect with a wide range of Afghan tribes and communities was critical to their overall tactical effectiveness.",{"title":"Special Operations Continues to Evolve, 2010–2011","level":2},{"section":["Reeder passed command of Combined Forces Special Operations Component Command–Afghanistan to General Miller in March 2010. Some leaders worried that Miller’s previous assignments with Ranger and dedicated counterterrorism units would lead him to abandon the less-direct approaches championed by Reeder and Bolduc. To the command’s relief, Miller immediately recognized the importance of local defense initiatives such as the Village Stability Operations program. Acknowledging its importance to the ISAF counterinsurgency effort, Miller promoted layered security for towns and villages."]},{"figure":{"source":"/figures/v2/img_9-5.png","caption":"ANA and U.S. Soldiers are airlifted"}},"As Miller’s staff refined its approach to local security, counterterrorism forces increased the tempo and precision of their operations. McChrystal, lacking a direct command and control relationship with the counterterrorism task forces, relied on personal relationships with their commanders to redirect their focus toward mid-level networks and leadership. As operations in Iraq ended, counterterrorism resources shifted to Afghanistan. With the increased headquarters, reconnaissance and surveillance, airlift, and fire support assets flowing into theater, counterterrorism missions grew by 200 percent in 2009 before doubling again in 2010. By February 2011, counterterrorism forces led by and consisting primarily of 75th Ranger elements were partnering with Afghan Special Operations units to conduct more than 200 operations a month. Significantly, 90 percent of these missions were conducted without a shot being fired.","Pressuring the enemy’s mid-level networks, combined with the conventional force surge, improvements in local security, and increased infrastructure expenditures began to pay dividends for Afghanistan. Success came at a cost, however. The elevated operational tempo resulted in the loss of an Air Force Special Operations MV–22 Osprey in Zabul Province on 9 April 2010, killing two U.S. Air Force airmen and one Army Ranger. Less than two weeks later, on 21 September 2010 an MH–60 Black Hawk helicopter crashed in Daychopan District, also in Zabul Province, killing nine special operators. As special operations elements increased efforts in Afghanistan, the complementary foreign internal defense initiative in neighboring Pakistan drew to a close. Although the Special Operations Command (Forward)–Pakistan felt that it had been successful within the scope of its authorities, it suffered a series of setbacks, including the loss of three personnel in an IED attack in February 2010 and increasing Pakistani restrictions resulting from border disputes and cross-border incursions by ISAF and ANSF personnel. The initiative ended in 2011 after Pakistan refused to renew the visas of Americans training the Frontier Corps and other Pakistani counterterrorism units.",{"title":"Taking on the Northern Insurgency","level":2},{"section":["While the Americans remained focused on RC East throughout 2009, shifting to RC South and RC Southwest from 2009 to 2011, the enemy quietly opened a new front in the country’s northeastern provinces bordering Tajikistan and Uzbekistan. These militants had two objectives. The first was to launch high-visibility attacks that were guaranteed to generate Western media reports and create the perception of a nationwide uprising beyond the southern Pashtun regions. The second objective was to seize criminal enterprises such as drug and weapons trafficking in order to garner the profits to support their future endeavors. Conditions in the northern provinces, including the Afghan government’s inability to overcome Tajik and Uzbek warlords, political marginalization of Pashtun minorities comprising one-third of the region’s population, and inadequate ISAF and Afghan security personnel offered fertile ground for this latest Taliban effort. Kunduz Province soon emerged as a stronghold for insurgent operations, giving the Taliban and other extremist groups access to Pashtun communities in the north.","The insurgency spread to nearby Takhar and Baghlan Provinces, upsetting efforts by the German Provincial Reconstruction Teams in Kunduz to project the Kabul government’s authority in the region. German troops operated under severe political constraints that limited their ability to confront the insurgency. One particular restriction prevented their forces from conducting night operations. Meanwhile, the disparate insurgent groups now flourishing in the north, including the Quetta Shura Taliban, HIG, and the Islamic Movement of Uzbekistan, were building popular support and cooperating with each other. With increasing frequency, militants launched attacks against ISAF troops and Afghan government targets. IEDs and suicide attacks limited ISAF freedom of movement while increasing the casualties suffered by German and ANSF units in a pattern strongly reminiscent of the British experience in Helmand. Neither the 1,200 Germans nor the ANSF had adequate numbers to confront the burgeoning Taliban threat.","As Operation HAMKARI reached a climax in late fall 2010, U.S. troops from 1st Battalion, 87th Infantry (Task Force SUMMIT), began clearing operations in Kunduz Province with German and ANSF elements. These operations killed or captured dozens of militants and disrupted several Taliban and Uzbek militant networks. One incident revealed evidence of Taliban-Uzbek militant collaboration. A late December raid killed Maulawi Bahadur, a senior Taliban commander with strong links to cells in neighboring Balkh and Baghlan Provinces. He was responsible for IED facilitation and distribution in the region, and had been linked to prominent members of the Uzbek Islamist movement. These connections may have been crucial to several successful suicide bombings. In these attacks, the Uzbek militants likely acted as the conduit for bombers, much as the Haqqanis supported similar operations in southeastern Afghanistan.","The insurgents responded by attacking Afghan security forces and government officials. Suicide bombings struck at the ANA headquarters and targeted the district governor in Chahar Darah District, Kunduz Province, in mid-December. A more brash assault occurred on 19 December 2010, when four attackers outfitted with suicide vests and automatic weapons opened fire on the ANA recruiting center in the city of Kunduz. The attackers killed eight Afghan soldiers and police at the cost of their own lives, and communicated the message that even government centers remained vulnerable. Intelligence pointed to the Gor Teppah area, just south of the city, as the likely staging ground. ISAF responded with SOF raids that killed foreign fighters while destroying an IED factory and capturing an imam suspected of planning the attack.","Although subsequent raids by special operators met with similar success, they failed to quell insurgent activity among Pashtun communities in the north. The first two months of 2011 were particularly active, with insurgent attacks against ANSF and government leaders succeeding in coercing large segments of the population to remain neutral if not actively supporting the Taliban cadres. When American pressure grew too strong, insurgent leaders moved to regions that had fewer ISAF troops. Although results indicated the success of the ISAF and ANSF efforts, many districts in Afghanistan’s northeast corner had not been completely cleared. An uneasy stalemate arose as northern Pashtuns waited to see who would hold military and political superiority."]},{"title":"The Death of Osama bin Laden","level":2},{"section":["On 2 May 2011, American SOF conducted the raid that would begin to close a chapter of the Global War on Terrorism that had opened on 11 September 2001. The overnight attack against Osama bin Laden’s home in Abbottabad, Pakistan, combined perceptive intelligence analysis, operational boldness, and good luck. Although bin Laden’s death coincided neatly with the beginning of transition to Afghan control, it had little effect on the war itself. Mullah Mohammed Omar remained central to the Taliban’s identity. As one insurgent commander said, “We are fighting for Mullah Muhammad Omar [sic]. He is our amir [ruler, chief, or commander]. We have never fought for Osama bin Laden. His death does not matter to us. We will continue with our struggle.”"]},{"title":"SECTION II CONCLUSION","level":2},"${PLACEHOLDER INTERACTION 9-1 TIMELINE}{bold}","Although the 2009 Bush troop increases to support the Afghan elections, followed by the Obama surge in 2010–2011, bore some resemblance to the surge in Iraq, the similarities between them did not stem from deliberate design, but rather from a misinterpretation of strategic objectives. Upon taking office in January 2009, President Barack H. Obama received three assessments on strategy and operations in Afghanistan. Because these assessments had been conducted under President George W. Bush, Obama directed another strategic assessment, referred to as the Riedel Report. Recognizing that the United States could no longer afford to deal with Pakistan and Afghanistan separately, the Riedel Report noted that a military defeat of the Taliban remained unlikely as long as Pakistan offered sanctuary to Afghan insurgents. Rather than accept an indefinite stalemate, the report recommended transitioning security responsibilities to the Afghans once their army and police forces had improved to the point at which they could check Taliban attempts to overthrow the Kabul government. That course of action, however, also involved degrading Taliban capabilities enough so that the transition could begin. To hand over control of the conflict to the Afghans, the United States would have to provide resources for this transition and devote more effort to neutralizing or eliminating extremist groups in the region that posed a potential threat to the American homeland.","When General Stanley A. McChrystal replaced General David D. McKiernan in mid-2009, the incoming commander’s view of his new responsibilities was influenced by early interpretations of why the surge in Iraq had worked. Proponents of population-centric counterinsurgency loudly proclaimed that the Iraq surge had been successful because it used U.S. troops to protect ethnic communities ravaged by sectarian civil war. These same counterinsurgency advocates paid less attention, however, to the fact that American troops had waged an intensive kinetic campaign against insurgent strongholds within Iraq both before and during the surge. In addition, most accounts ignored the key role played by the Iraqi Army in maintaining order and contributing to the fight against local insurgents.","Upon assuming his responsibilities at ISAF, McChrystal conducted his own assessment. As it was based on recent interpretations of the Iraq surge, it determined that a population-centric counterinsurgency approach would be successful in Afghanistan. However, the Iraq model could not be duplicated in its entirety in Afghanistan, most notably because population-centric counterinsurgency did not directly support the strategic goals articulated in the Riedel Report. President Bush originally approved the Iraq surge in an effort to end sectarian violence and defeat the insurgency, whereas President Obama sought to buy time and space for the Afghan army and police to improve by employing more U.S. troops against the Taliban. Obama’s plan focused on both the enemy and the capacity of the Afghan government to control its country. McChrystal realized from the outset that even though he had been asked to undertake a virtually identical operational approach to that of the Iraq surge, he would not receive the same level of resources for his mission. As he said to an aide, “They [the U.S. government] did not give me enough [troops] to win outright.” He also recognized that unlike the government of Prime Minister Nouri al-Maliki of Iraq, Karzai’s government was “not going to win the battle of legitimacy” by making significant policy changes because the Taliban insurgency was not strong enough to pose a direct threat to the Afghan government’s immediate existence. McChrystal had to adjust the campaign to fit these limitations.","Confusion ensued as some of McChrystal’s subordinates sided with the approach articulated in the Riedel Report while others embraced the Iraq version of counterinsurgency as they understood it. On the ground, tactical commanders independently developed their own views on how to conduct population-centric counterinsurgency, creating additional friction along the chain of command. That friction had been less of a problem in Iraq, where some commanders were able to focus on the far less ambiguous mission of eliminating enemy strongholds. To further complicate matters, a number of allied nations viewed any and all types of counterinsurgency differently than their American counterparts. This created more problems in Afghanistan than in Iraq because the Iraq surge involved primarily U.S. troops while the Afghanistan surge incorporated both U.S. and ISAF personnel. Finally, matters worsened when ISAF issued the “courageous restraint” directive, fostering significant resentment among combat troops who faced an adaptive enemy that took advantage of the new rules of engagement.","The population-centric approach, while admirable from a moral perspective in its desire to limit collateral civilian casualties, did not materially contribute to ongoing efforts to improve Afghan security forces. According to one Strategic Studies Institute analysis published in 2007, counterinsurgency strategies of the kind that McChrystal would later apply in Afghanistan cede the initiative to the insurgents. Although the vagaries of Army doctrine played no part in General David H. Petraeus’ subsequent appointment as ISAF commander, McChrystal’s successor leveraged his firsthand experience with the Iraq surge to realign the command’s population-centric counterinsurgency. Petraeus understood that counterinsurgency’s clear, hold, and build approach was a reminder that there is more than one way for military force to influence the enemy. The approach favored by Petraeus reaped greater operational benefits because ISAF dictated when and where combat occurred rather than simply reacting to enemy efforts to disrupt the hold and build phases of the counterinsurgency in Afghanistan.","The ultimate outcome of the Afghan surge depended on far more than changing the approach to counterinsurgency. Outside observers often were critical of the surge’s impact on the overall campaign because it did not produce the dramatic results that the United States had seen in Iraq. However, the Afghan surge ultimately showed progress once General Petraeus refocused it on protecting the population, improving the ANSF, and targeting enemy sanctuaries and leadership. Crippled by losses suffered during this period, the Taliban was prevented not only from interfering with coalition efforts to improve the ANSF but also from derailing the handover of ISAF security responsibilities to the Afghan government. What remained to be seen was whether the ISAF coalition could strengthen Afghan institutions in a manner that would withstand the future departure of ISAF forces."],"section Iii":[{"title":"END OF CAMPAIGNS"},{"picture":{"source":"/figures/v2/art_S3-1.png","caption":"GIVE 'EM THE GUN"}},"${Section III: Introduction}{bold}","The surge in Afghanistan did not render the same outcomes as its predecessor in Iraq. The latter ended a protracted insurgency on the cusp of becoming a devastating civil war. Efforts to protect ordinary Iraqis from ethnic death squads won the American military popular support, and its alliance with Sunni paramilitaries expanded indigenous opposition to al-Qaeda insurgents. Twenty thousand reinforcements permitted coalition forces to protect the majority of the populace and to eliminate enemy safe havens in Baghdad, Al Anbar Province, and Al Basrah. Deprived of access to the population and safe areas from which it could plan and organize, the Iraqi insurgency collapsed.","The Afghan surge created the time and space necessary for ISAF to transition from combat operations to security force assistance by targeting the Taliban and eliminating its enclaves within Afghanistan. Although it did not result in the Taliban’s outright defeat, the Obama administration’s approach to the mission established the conditions for an uncontested withdrawal of most American and ISAF troops. It also allowed ISAF to retrograde, or remove and reassign, equipment and supplies aggressively within the limited time available. At the same time, the surge provided the ANSF with sufficient breathing space to expand in size, absorb new equipment, upgrade logistics, develop ministerial capacity, take control of former ISAF bases, and refine its command and control procedures. In doing so, it laid the groundwork for the orderly transition of nation-building responsibilities from ISAF and U.S. Provincial Reconstruction Teams to the Afghan government in 2014.","However, time would tell if the ANSF could gain enough experience during and after the retrograde to perform well without coalition assistance, or whether the Government of the Islamic Republic of Afghanistan could refocus its priorities toward serving the people rather than the political elite after the departure of coalition forces.","Reducing troop strength in Afghanistan was the key element to President Barack H. Obama’s strategy for ENDURING FREEDOM. On 22 June 2011, the president announced that he would withdraw 10,000 troops from Afghanistan by year’s end and another 23,000 troops by summer 2012. The Obama administration’s initial reductions of U.S. forces in Afghanistan dropped force levels to 68,000 from 100,000 two months before the U.S. presidential election in November 2012. Obama noted that, after the killing of Osama bin Laden on 1 May 2011, America could reduce forces from “a position of strength” and that it was time to end America’s long wars to “focus on nation building here at home.” Beyond summer 2012, the timetable for drawdown remained unclear, but Obama called for steadily reducing U.S. deployment numbers by the end of 2014, at which point an agreed-upon force, sized for long-term stability operations, would remain.","ISAF sought to transition security responsibilities to Afghans sooner rather than later in order to maximize the effect of the surge. The combination of more ISAF troops, a higher operational tempo, and the increasingly capable Afghan security forces curtailed enemy movement, eliminated many of its leaders and fighters, severed its logistical routes, and separated the Taliban from the Afghan people. These factors prevented the insurgents from seizing more of Afghanistan’s sovereign territory during their 2011 AL-BADR campaign. Many veteran Taliban fighters also were showing signs of disillusionment. As many as 4,990 enemy combatants, a twofold increase over the previous year, had renounced their ties to the insurgency between July 2011 and July 2012 by participating in the Afghan Peace and Reintegration Program.","During this same period, the Pakistani armed forces launched several major offensives against extremist groups based within Pakistan’s Federally Administered Tribal Areas. In some instances, government forces received aid from militia units formed by Pashtun tribes that rejected the corrosive influence of extremist ideologies. However, the Pakistani military’s main targets were extremists that rejected secular rule and challenged the Islamabad regime specifically—such as the Tehrik-i-Taliban Pakistan, al-Qaeda, the Islamic Movement of Uzbekistan, and Lashkar-e-Islam—rather than groups such as the Haqqani Network or the Quetta Shura Taliban that focused on cross-border operations. As a result, Pakistani efforts bolstered their own internal stability but did not necessarily aid the ISAF counterinsurgency campaign being waged in Afghanistan.","At the same time, Americans had not persuaded the Afghans to overcome their ingrained distrust for central government. The self-interested behavior of public officials at the local, district, provincial, and national levels confirmed this perception to many. Despite the battlefield successes of its security forces, the relatively ineffective government of President Hamid Karzai remained incapable of making substantive inroads against the Taliban as it threatened unprotected populations and reconstituted its forces in the Pashtun tribal areas of northwestern Pakistan. U.S. drone attacks and limited Pakistani military offensives created significant problems for some extremist groups, but most Taliban base areas remained undisturbed.","Given both these promising and unfavorable aspects, the Operation ENDURING FREEDOM and ISAF campaigns were defined by two major efforts over their final two-and-a-half years. The first was the Joint Framework for INTEQAL (Transition), an effort to have ANSF lead military operations in all provinces by the end of 2014. This plan had been agreed upon at NATO’s Lisbon Summit in November 2010. The second was the redeployment of forces out of Afghanistan as the United States prepared for the anticipated post-2014 support mission. Backing these efforts were Afghan and coalition partnered offensives against enemy networks and leadership. Implementing these initiatives simultaneously required both coalition and Afghan forces to rebalance their means constantly, with redeployment drawing U.S. resources out of Afghanistan on a fixed schedule and the American personnel remaining in country becoming increasingly devoted to improving ANSF capabilities.","The U.S. Army stood at a crossroads at the time of the Lisbon Summit. The Army’s global commitment at that time numbered more than 230,000 officers and enlisted personnel serving in nearly eighty countries and at the U.S. borders. That figure represented roughly one-fifth of the overall authorized end strength of 1,129,275. As of October 2010, more than one million Army personnel had deployed to Afghanistan and Iraq one or more times, with 4,100 soldiers giving their lives and leaving behind 20,000 surviving family members. Another 27,000 soldiers were wounded, 7,500 of them requiring long-term care. In addition, 10,000 suffered traumatic brain injuries, and 4,500 grappled with post-traumatic stress following their deployments overseas. Despite those sobering statistics, the Army had experienced record retention numbers for enlisted soldiers within every component, averaging 110 percent of their targeted retention numbers during 2010. In terms of new recruits, both the active component and Army Reserve had exceeded their 2010 accession goals, with the Army National Guard achieving more than 95 percent of its end of fiscal year target.","The end of combat operations in Iraq finally allowed the Army to address mounting internal stress by implementing a rotational model of one year deployed to two years at home-station for the active component and a one-to-four ratio for the National Guard and Army Reserve. At the same time, however, the Army still had unprecedented numbers of soldiers in Afghanistan to support the new strategic direction in that vital theater. That effort began to wind down in mid-2011 with an equally intensive redeployment of equipment and materiel from Afghanistan that lasted through December 2014. Throughout the period 2011–2014, Army Chief of Staff General Raymond T. Odierno reinforced his predecessor’s efforts to invest more resources in training, equipping, and staffing the force to perform a wider and more traditional range of missions rather than remain singularly focused on counterinsurgency and security force assistance.","In recognition of negative trends that showed no signs of dissipating—as evidenced by the fact that in 2012 the Army experienced more suicides than combat deaths—the Army’s senior leadership introduced the Ready and Resilient Campaign in March 2013. It was intended to enhance individual and collective resilience in Army soldiers, civilians, and family members. It expanded on the Comprehensive Soldier Fitness Program to integrate Army-wide efforts to improve physical, psychological, and emotional health, with readiness of the force as the overall goal. The Ready and Resilient Campaign sought to influence cultural change in the Army by linking personal resilience to readiness, while addressing destructive behavior such as suicide, domestic violence, substance abuse, sexual harassment and assault, bullying, and hazing. It also sought to promote positive behaviors while eliminating stigmas and cultural norms that discouraged asking for help. Such an initiative was a step forward, but the true costs of employing the force over a sustained period of time still remain to be seen.","${Policy and Strategy Considerations}{bold}","As the security transition began and the balance of the ISAF conventional force shifted from combat to training, advising, and assisting, the Obama administration faced three major policy questions on Afghanistan. First, it had to determine how rapid the drawdown should be. Second, it had to consider whether to establish a long-term security arrangement with the Afghan government that would allow U.S. forces to remain beyond 2014. Finally, it had to ascertain how large the residual force should be based on the potential range of responsibilities and missions it received.","Both Afghan and ISAF leaders believed that the drawdown could be best managed if it took place incrementally. Transitioning security responsibilities in the thirty-four provinces would therefore occur in stages, known as tranches. Debate occurred over the decision to transition certain areas. Even though ISAF literature explicitly stated that its forces would not depart areas until the Afghans could secure them, political considerations still determined who left where and when. Consequently, operational leaders had to choose whether to transition the relatively uncomplicated areas or the more difficult areas first. Although it seemed self-evident to focus on the easier areas first, it would be more difficult to transition harder areas later on because fewer coalition forces would be available.","On 22 March 2011, Karzai publically listed the first provinces and districts to begin transition. Tranche 1 included Bamyan, Panjshir, Kabul (except the Sarobi District), and districts surrounding certain provincial capitals, including Herat, Lashkar Gah, Mazar-e Sharif, and Mehtar Lam. Those areas, especially Panjshir and Bamyan, had been pacified for some time and had good security. The first provincial transition ceremony occurred in Bamyan, the capital of Bamyan Province, on 17 July 2011.","The process continued as planned. Tranche 2 was announced on 27 November 2011. This tranche, which included Balkh, Takhar, Samangan, Daykundi, Nimroz, and Kabul Provinces, as well as selected districts in Parwan, Helmand, Ghazni, and Herat Provinces, began without serious interference in December 2011. Tranche 3, slated to begin in July 2012, not only transferred 122 additional districts but also initiated the handover preparations for all remaining provinces. Upon completion of the fourth tranche, slated to begin in early 2013, Afghan security forces would assume responsibility for 87 percent of the nation’s population and 312 districts in 23 of 34 provinces. The fifth and final tranche, involving the remaining eleven provinces, would take place in mid-2013. Tranches 2 through 5 included areas under government control as well as those still contested, a necessity given that the process had to occur while sufficient coalition resources were still present in country.",{"picture":{"source":"/figures/m/map-afghanistan-transition.svg","caption":"Map - Afghanistan Transition"}},"One end state remained inexorably clear throughout the process: ready or not, Afghans would be responsible for their own security  by 31 December 2014. On that date, Operation RESOLUTE SUPPORT would replace ISAF as a noncombat NATO mission intended to continue the development of Afghan ministries. Similarly, the United States would transition its missions on the same date, replacing Operation ENDURING FREEDOM with Operation FREEDOM’S SENTINEL.","${Transition in a Complex Operating Environment}{bold}","As the United States brought its combat mission in Afghanistan to a close, its goal in the CENTCOM area of responsibility remained  “to disrupt, dismantle, and eventually defeat al-Qaeda, and to prevent its return to either Afghanistan or Pakistan.” The objectives unique to Afghanistan also remained constant: “to deny safe haven to al-Qaeda and to deny the Taliban the ability to overthrow the Afghan government.” Insofar as the United States was still executing combat missions, it was “to degrade the Taliban insurgency in order to provide time and space to increase the capacity of the Afghan National Security Forces and the Afghan Government so they can assume the lead for Afghanistan’s security by the end of 2014,” although the clear emphasis was now on security force assistance, not combat operations. As a complement to its military campaign, the Obama administration continued its efforts to reconcile the Taliban to the Afghan government.","NATO’s mission likewise changed little in these years, with the North Atlantic Council calling for counterinsurgency operations to protect the Afghan people, neutralize insurgent networks, and build legitimate and sustainable Afghan institutions. Since 2007, a counterinsurgency approach designed to enable Afghanistan to secure and govern itself had translated that guidance into campaign direction. Although tactical methods had varied, the conceptual approach remained in place through 2011. When Marine General John R. Allen succeeded General David H. Petraeus as ISAF commander on 18 July 2011, the campaign changed again. Allen initiated a deliberate transition from counterinsurgency operations to security force assistance by approving Revision 6 to ISAF Operations Plan 38302 on 15 November 2011.","Two subsequent amendments to the plan incorporated guidance for reducing the theater’s “footprint” and retrograding units, personnel, and  equipment out of Afghanistan. Allen approved the second and last amendment to the plan on 27 October 2012. The campaign centered on developing a capable and sustainable ANSF, as described in the mission statement:",{"list":["ISAF, in partnership with the International Community, supports GIRoA [Government of the Islamic Republic of Afghanistan] in the conduct of counter-insurgency operations to support development of governmental institutions for legitimate, credible, and enduring governance, security, and sustainable socio-economic growth; support the ANSF as it assumes lead responsibility for security to protect the Afghan people; and neutralize insurgent networks in order to deny terrorist safe-havens, ensure GIRoA stability and sovereignty, and set the conditions for the NATO-led post-ISAF engagement NLT [no later than] 31 December 2014."]},"${The Evolving Threat}{bold}","The Taliban’s retreat from the battlefield following the surge did not reflect a lasting defeat. Opposition groups had enough money and motivated fighters to continue military operations against ISAF and Afghan security forces.","The Haqqani Network remained foremost among these groups. Its operators and facilitators had survived the surge by avoiding contact with American forces and focusing on well-planned operations offering a high payoff for an acceptable price in lives and materials. During this period, however, the Taliban suffered an internal power struggle that unfolded largely hidden from the U.S. intelligence apparatus. Yet even with the Taliban’s private upheaval, there were no shortage of willing opponents for U.S. and ISAF forces during the transition period.","For much of Operation ENDURING FREEDOM, commanders in Afghanistan dealt with the fact that the economy of force also applied to the entire range of intelligence, surveillance, and reconnaissance systems. The drawdown in Iraq freed up a number of these assets for employment in Afghanistan during the surge, but it took time for commanders and staff to learn how best to use these increased capabilities and then fully integrate them. Unlike in Iraq, American troops worked side by side with international contingents from several dozen nations as well as Afghan security forces on a daily basis. As a result, procedures had to be developed to address myriad interoperability issues, data management problems, and data-sharing policies. Intelligence analysts who previously focused on Iraq had to acquire a new set of skills, including familiarity with different languages, new relationships with ISAF and Afghan counterparts, and efforts to obtain optimal results from systems being employed in a physical environment that differed significantly from Iraq. Regrettably, many of these personnel and some assets were withdrawn just as they reached their peak proficiency in accordance to the firm timetables imposed on the surge.","The Afghan intelligence services also faced comparable challenges, albeit of a far different nature. Even though the vast majority of insurgent groups hailed from Pashtun tribes in the south, approximately 70 percent of National Directorate of Security personnel were Tajiks from the Panjshir region of northeast Afghanistan. The ethnic imbalance had a starkly negative impact on the National Directorate of Security, prompting one of its operatives to complain, “When they send Panjshiri to Pashtun areas they can’t do anything. They don’t know anything about the South or the East. They don’t know how Pashtuns talk or move. If you need information about a Pashtun, you should have a Pashtun to get that information. This is the problem.”26 As a result, even Afghanistan’s own domestic intelligence service had limited ability to infiltrate enemy ranks.","Although the surge helped improve ISAF intelligence, surveillance, and reconnaissance capabilities in Afghanistan, those systems had limited access to Pakistan. The Taliban’s inner workings were well protected in Quetta and its leaders avoided exposing their disagreements. In addition, the success of the drone campaign worked against ISAF intelligence collection efforts by instilling a growing sense of fear and caution in insurgent leaders. Nonetheless, when Pakistani officials arrested Mullah Mohammed Omar’s top deputy, Mullah Abdul Ghani Baradar, in 2010, two Taliban commanders openly clashed as they each tried to replace Baradar. The first was Mullah Abdul Qayyum Zakir, who had commanded the Taliban’s forces in southern Afghanistan. The second was a relatively unknown functionary, Mullah Akhtar Mohammed Mansour. Akhtar Mansour had made his mark in the insurgency through the opium trade. He had allegedly become the Taliban’s main tax collector, responsible for funding the fundamentalist group. This power struggle would resume in the near future with the death of Mullah Mohammed Omar.","New Taliban leadership combined with reduced battlefield operations for the past year promised a renewal of intensive fighting in  2012. On 2 May, just three weeks after German Brig. Gen. Carsten Jacobson, the ISAF spokesman, reiterated his organization’s position that it would not face a sustained, large-scale enemy offensive that spring, the Taliban released a statement that would be paraphrased in the press:",{"list":["\"[The] Al Farooq Jihadi operation spring offensive would target “foreign invaders, their advisors, their contractors and members  of all associated military, intelligence and auxiliary departments . . . high ranking officials of the stooge Kabul regime; members of Parliament; those associated with Ministries of Defense, Intelligence and Interior; members of the so called High Peace Council; Militia under the name of “Arbakai” and all those people who work against the Mujahedeen [sic], toil to pave ground for the occupation of Afghanistan and become the cause for the strength of the invaders.\""]},"Rather than launch large-scale attacks, the Taliban sought to influence the security handover by indirect means, namely by targeting the ISAF personnel who trained Afghan soldiers and police. Taliban leaders also took advantage of the desperate need for new ANSF personnel by seizing opportunities to infiltrate these formations with insurgents. As more and more foreign soldiers advised Afghan formations, violence by Afghan security forces against their coalition partners, referred to as insider or “green-on-blue” attacks, occurred with increasing frequency. The Taliban infiltration efforts began to yield results in 2008 when two such attacks took place, followed by ten more green-on-blue incidents occurring in 2009 and 2010. A spike in these incidents led some coalition members to question the feasibility of partnering with Afghan forces.","Fifteen green-on-blue attacks occurred in 2011, skyrocketing to forty-two by mid-November 2012. The majority took place in RCs East, South, and Southwest. Although insurgent spokespeople routinely claimed credit for insider attacks, the motives for committing these deadly incidents, which eroded trust between ISAF and Afghan personnel, varied significantly. One of the most publicized attacks, in which an Afghan Air Force colonel executed eight American service members and a civilian contractor, occurred on 27 April 2011 at Kabul International Airport. Although CENTCOM investigators did not uncover proof of third-party involvement, an American news outlet alleged that other U.S. officials discovered that the assailant’s substantial gambling debts were paid off and his family received a large bank deposit one week before the incident.","These attacks directly influenced the theater campaign at the beginning of 2012. On 20 January, an Afghan soldier fired on French trainers who were conducting physical training on their base northeast of Kabul, killing four and wounding fifteen. News of the incident, which took place as a tough election season began in France, led President Nicolas Sarkozy to proclaim, “We are friends of the Afghan people, allies of the Afghan people. But I cannot accept that Afghan soldiers fire on French soldiers.” During a press conference with Karzai on 27 January, Sarkozy announced that his country would pull its combat forces out of Afghanistan one year earlier than scheduled and urged other NATO members to do the same.","${The Decline of Drone Attacks}{bold}","Even as the insider attacks increased, the United States carried out fewer drone attacks in the wake of the surge in Afghanistan and during retrograde operations. This trend reflected the growing American sensitivity to the large-scale public demonstrations in Pakistan from 2012 onward that took place in response to actual or suspected strikes. The decrease in drone attacks also can be attributed to guidance issued by the Obama administration governing their use outside of areas of active hostilities. Without specifically mentioning drones, a White House press statement issued on 23 May 2013 explained, “Lethal force will be used only to prevent or stop attacks against U.S. persons, and even then, only when capture is not feasible and no other reasonable alternatives exist to address the threat effectively.” The statement further elaborated, “The United States will use lethal force only against a target that poses a continuing, imminent threat to U.S. persons. It is simply not the case that all terrorists pose a continuing, imminent threat to U.S. persons; if a terrorist does not pose such a threat, the United States will not use lethal force.”","That same day, President Obama spoke publicly on the drone program at the National Defense University on Fort McNair in Washington, D.C. Even though he admitted that drones offered an alternative to the less-palatable scenario of sending Special Operations units into other countries, he acknowledged the drawbacks of that course of action: “The very precision of drone strikes, and the necessary secrecy involved in such actions can end up shielding our government from the public scrutiny that a troop deployment invites. It can also lead a president and his team to view drone strikes as a cure-all for terrorism.” After noting the wide gap between official government figures and private estimates of civilian deaths, Obama stated, “It is a hard fact that U.S. strikes have resulted in civilian casualties, a risk that exists in all wars. For the families of those civilians, no words or legal construct can justify their loss. For me, and those in my chain of command, these deaths will haunt us for as long as we live, just as we are haunted by civilian casualties that have occurred through conventional fighting in Afghanistan and Iraq.” The president’s address at McNair thus effectively signaled his intention to use drones more selectively and less frequently.","Although nongovernment estimates of the number of drone attacks vary, alleged strikes by unmanned aerial vehicles in Pakistan ranged from forty-six to fifty in 2012 before dropping to twenty-six to twenty-eight incidents in 2013, and between twenty-two to twenty-five attacks in the final year of Operation ENDURING FREEDOM. Depending on the source of the figures, civilians accounted for a minimum of 0.6 percent and a maximum of 14 percent of the total casualties in Pakistan credited to drones during the campaign’s retrograde and transition phase. Although the drone strikes occurred less frequently, they continued to achieve notable results, including the successful targeting of the Tehrik-i-Taliban Pakistan leader Hakimullah Mehsud and his chief deputy in North Waziristan on 1 November 2013. In early February 2014, officials in Washington informally agreed to halt drone strikes in Pakistan, except on positively identified al-Qaeda leaders, while Islamabad pursued peace talks with Taliban militants based in the tribal lands.","With the surge at its peak, efforts to prepare the Afghans to assume the lead in security and stability initiatives across the country had begun in earnest. Beyond putting Afghan soldiers and police out front in the security mission, ISAF had to pull back the stability organizations it had developed, such as Provincial Reconstruction Teams, in order to force the Afghan government to take the lead at all levels. These efforts would require a detailed plan coauthored by ISAF and their Afghan partners."],"chapter 10":[{"title":"Afghans Into The Lead"},{"section":["President Hamid Karzai’s inauguration remarks on 19 November 2009 indicated that the ANSF would assume full responsibility for securing their country by the end of 2014. ISAF troop-contributing nations formalized that goal two months later at the January 2010 London Conference on Afghanistan. Half a year of planning and negotiation leading up to the Kabul International Conference on Afghanistan in July 2010 had produced a plan for a phased transition. ISAF nations formalized the pending handover with the Afghan government on 20 November 2010 at the NATO head-of-state summit in Lisbon.","The centerpiece of the process was the Joint Framework for INTEQAL, agreed upon by the Afghan government, NATO ISAF, the UN,  nations outside the coalition, and other interested parties. Released on 19 July 2010, the document proposed a two-step process for turning responsibilities over to the ANSF and Afghan government: assessment followed by phased implementation. Regulating the pace of these transitions would be based on the progress made not just in security, but also in governance and economic development."]},{"title":"Inteqal: The Transition Process","level":2},{"section":["Four principles guided the Joint Framework for INTEQAL. First, the transition was to be based on the conditions on the ground, not on a particular timeline. Second, it would not end ISAF’s involvement in Afghanistan. Instead, intervening forces would shift to a supporting role as the ANSF and Afghan civilian authorities became better at security, governance, and development. Coalition members would support, mentor, enable, and sustain progress. Third, the transition was to be a district- or even subdistrict-level process, netting a “dividend” that would free ISAF resources to be “reinvested in other areas.” Finally, transition was not purely geographical. It also involved Afghan institutions and functions that could be assumed from the Provincial Reconstruction Teams, thus allowing these teams to be dissolved as needed. A potential sensitivity arose as a result of ISAF being able to move assets such as money, forces, and equipment to other areas of the country. Although such movement was unavoidable, unit reassignments disheartened Afghans who had built relationships with coalition forces and also sparked resentment from ISAF nations whose troops were reluctant to move to a location that might present a greater threat. In practice, only American forces could enter areas where new forces might be required. Only the United States, primarily through the Army’s theater and tactical sustainment infrastructure, had the capability to sustain combat power outside the tactical reach of logistics hubs at Bagram and Kandahar.","What made the handover of security unique was the use of distinctive language that introduced the concept of “irreversible transition.” The first public reference to “irreversible transition” appeared at the Kabul Conference in July 2010. Although the Lisbon Communiqué that conveyed the results of the November 2010 conference did not refer to this specific term, it stated that “Afghan forces will be assuming full responsibility for security across the whole of Afghanistan.” The Joint Framework for INTEQAL contained the statement “to ensure the [transition] process is irreversible, at the beginning of INTEQAL the combined ANSF/ISAF forces, under overarching Afghan lead in a province, shall be capable of tackling existing and new challenges that may arise from the insurgency.”"]},{"title":"The First Step: Retiring Provincial Reconstruction Teams","level":2},{"section":["INTEQAL disestablished the Provincial Reconstruction Teams that had been a fixture of the coalition campaign in Afghanistan since January 2003, when CJTF-180 commander General Dan K. McNeill had established the first team in Gardez, Paktiya Province. In his remarks at the 47th Munich Security Conference on 6 February 2011, Karzai condemned the reconstruction teams as “parallel structures” that delivered assistance to communities without going through the Afghan central government in Kabul. Karzai’s rhetoric played to Pashtun audiences but belied the patronage system that pervaded Afghan politics and was considered corrupt by Western audiences. Those misgivings had been amplified in 2010 after the near failure of the Kabul Bank, an organization that a 2012 audit revealed as a pyramid scheme.","Karzai’s Presidential Directive 45, dated 26 July 2012, ordered Provincial Reconstruction Teams across the country to end operations. Americans closed their teams in Paktiya, Khost, Kunar, Laghman, and Panjshir Provinces that month, while other ISAF nations closed teams in Badakhshan, Faryab, Ghor, Baghlan, and Jowzjan Provinces. Karzai’s advisers welcomed the closures, noting their country’s long-term prospects were not being supported by provincial officials who relied on ISAF representatives for funding rather than their own compatriots in Kabul. Closing the reconstruction teams also forced the preponderance of funding to funnel through the Karzai government. Although most of the remaining reconstruction teams were not slated to cease operations until the 2013–14 timeframe, they received less funding from the Commander’s Emergency Response Program, which forced local officials to route requests for money through the Afghan central government.","The full transition to Afghan civilian authority depended on connecting the government in Kabul with subnational governance, a process that reconstruction teams had fostered but could not enforce and, as Karzai realized, often hindered. One Afghan initiative that could backfill the void left by the dissolution of the Provincial Reconstruction Teams was the National Solidarity Program. This program was a promising development, as it was an initiative of the Ministry of Rural Rehabilitation and Development intended to empower local governance. However, the programs that fell under the National Solidarity Program were still dependent on international financial assistance. Without such aid, the National Solidarity Program was not likely to continue. Much as with efforts to improve the ANSF, efforts to improve governance not only had to prevent the Afghans from failing, but also build their self-sufficiency."]},{"figure":{"source":"/figures/v2/img_10-1.png","caption":"An Afghan Commando hands out radios"}},{"title":"The Strategic Partnership Agreement","level":2},{"section":["As INTEQAL gained momentum, the United States sought to form a strategic partnership with Afghanistan beyond 2014 to ensure that the government could survive the insurgency and prevent the reemergence of al-Qaeda safe havens. Karzai proved a difficult negotiating partner. He insisted that his government assume responsibility for all U.S. detention centers and that coalition forces stop conducting raids at night before he would sign an agreement. After U.S.-led ISAF and Afghan negotiations had carried on for more than a year, the first breakthrough came in March 2012 when the two sides agreed to transfer prisoners. The memorandum of understanding, signed by General John R. Allen and Afghan defense minister Abdul Rahim Wardak, immediately placed an Afghan official in charge of the U.S. detention facility in Parwan but allowed Americans to transfer their 3,200 detainees over a six-month period. The United States retained control over non-Afghan prisoners and could veto the release of suspected Taliban fighters.","Another development of similar importance took place, although for less positive reasons, soon afterward. After taking command, General David H. Petraeus placed growing emphasis on night raids by U.S. Special Operations elements to eliminate or capture enemy leaders, bomb makers, financiers, and arms dealers. The raids were carried out in darkness to achieve surprise and take advantage of U.S. superiority in night vision. These operations often involved combined U.S. and Afghan units, but the targets were chosen exclusively by American intelligence analysts. However, a series of mistakes led to the raids becoming an increasingly public and controversial element of the overall counterinsurgency campaign. Despite impressive statistics of enemy combatants killed or captured, the benefit of night raids waned as new tales of accidental killings and targeting errors led to mounting criticism from inside and outside Afghanistan. By spring 2012, the United States agreed to give Afghan forces control over night raids and other special operations, while the coalition adopted a supporting role.","These specific agreements paved the way for President Barack H. Obama and Karzai to sign the Enduring Strategic Partnership Agreement on 1 May 2012. The strategic agreement allowed the United States to train Afghan forces and target al-Qaeda beyond 2014 but did not specify troop or funding levels. It also called for the two sides to replace the U.S. State Department’s Diplomatic Note 202, which had served as a Status of Forces Agreement since 2003, a critical step for protecting the legal rights of U.S. combatants in Afghanistan. In its place, a Bilateral Security Agreement would constitute a formal agreement; the United States was also to designate Afghanistan as a major non-NATO ally. The Obama administration followed through with the designation one month later, making it easier for Afghanistan to obtain security funding and assistance in the future. The partnership agreement had symbolic importance, as it was meant to signal the Taliban and Afghanistan’s neighbors that America would not abandon Afghanistan as it had done in the 1990s. In the end, Karzai refused to sign the security agreement and the NATO Status of Forces Agreement, instead having his national security adviser sign the Bilateral Security Agreement on 30 September 2014."]},{"title":"Adapting Tactical Forces for Transition","level":2},{"section":["To answer the increased demand for advisers, the Army shifted from deploying brigade combat teams to deploying brigades task organized for security force assistance. Operation IRAQI FREEDOM provided the precedent for a brigade fulfilling both combat and advisory roles in June 2008 when the 4th Brigade Combat Team, 1st Armored Division, deployed as an advise and assist brigade. Even though the Army National Guard assumed the TF PHOENIX mission in Afghanistan, the active Army did not deploy brigades for advisory duties until it ordered Col. Brian M. Drinkwine’s 4th Brigade Combat Team, 82d Airborne Division (TF FURY) to Afghanistan in the summer of 2009 as a modular brigade augmented for security force assistance. The differences within this formation, when compared to the advise and assist brigades deployed earlier to Iraq, were not purely semantic. Unlike brigades sent to Iraq, TF FURY and other brigades augmented for security force assistance were not intended to operate as combat forces. Much like TF PHOENIX, they were purely advisory. Rather than owning an area of operations, a modular brigade augmented for security force assistance would provide advisers who operated under the security “umbrella” of another brigade combat team conducting counterinsurgency operations.","The nuance between the two advising formations was important. Unlike in Iraq, where the United States could position units relatively easily, the political sensitivities of the ISAF mission made changes to task organization a delicate matter. Bringing an American combat force into a coalition commander’s area of operations created command and control problems and risked offending national sensitivities. Nonetheless, brigades augmented for security force assistance would be a less controversial approach than deploying additional combat units. They bolstered existing forces in RCs North, West, and Capital as part of ISAF’s operational approach of partnered operations with the ANSF. They also allowed U.S. and ISAF combat forces to start leaving the country.","One impetus for sourcing advisers from brigades was the cumulative effect of individually sourcing advisers, rather than sourcing them from units. The Army’s Worldwide Individual Augmentation System plucked service members from units to fill operational requirements elsewhere without replacing them. Because the system issued only temporary change-of-station orders, the individuals selected were not considered as having been reassigned. The losing unit simply took a gap in staffing, which detracted from its own readiness. Another impetus for sourcing advisers from brigade combat teams was procedural. In the Joint Operations Planning and Execution System, the overhead associated with each force package being built and readied for deployment was the same, whether it was an ad hoc group of individual augmentees or a full brigade combat team with its organic units. Because of system parameters, it was easier for the Army to source advising personnel by forming brigades.","The institutional solution to providing the ANSF with advisers was a hybrid of the individual augmentation and brigade task organization approaches. Building a modular brigade augmented for security force assistance entailed merging two organizations. In January 2012, the Army started to train security force assistance advisory teams to meet ISAF’s requirements. Armored and infantry brigades across the force supplied the personnel and equipment for these teams. The brigade combat teams that became donors for advisory teams were called security force assistance brigades. The 162d Infantry Brigade at Fort Polk, which inherited duties for training advisers on 31 August 2009 from 1st Brigade, 1st Infantry Division, out of Fort Riley, Kansas, became the responsible agent for molding groups of individuals into advisory teams.","To create modular brigades augmented for security force assistance, the Army incorporated advisory teams into standard brigade combat teams. The underlying assumption was that an infantry brigade combat team or a heavy brigade combat team could be the building block for any combat mission that Army forces might conduct, including training, advising, and assistance operations. The teams included officers and noncommissioned officers with the rank and experience to mentor Afghan leaders up to ANA corps or Afghan Uniformed Police region headquarters. They also provided advisers for the operational coordination centers that were intended to facilitate communication between the ANA and the ANP at the regional and provincial level.","Within the DoD’s Global Force Management system, units were designated as security force assistance brigades or modular brigades augmented for security force assistance according to their intended role. Army leaders tried to meet the demand for personnel without using the Worldwide Individual Augmentation System. At the same time, the Army sought to adjust heavy and light infantry brigade combat teams designed for combat operations for advisory missions. Preparing these units required a significant augmentation of officers and senior noncommissioned officers. The creation of the modular brigade augmented for security force assistance streamlined command and control relationships for advisers and provided partnered forces to conduct combat operations alongside the ANSF.","The Army’s sourcing of security force assistance brigades and augmented modular brigades coincided with a reduction in the demand for Army forces. With the impending end of military operations in Iraq, the Army was able to reallocate heavy brigade combat teams that had been earmarked for that mission. The first heavy brigade combat team redirected to Afghanistan was TF RAIDER, formed from 1st Brigade Combat Team, 4th Infantry Division, and commanded by Col. Jeffrey R. Martindale. In July 2010, TF RAIDER replaced TF FURY as a modular brigade augmented for security force assistance covering Kandahar City. TF RAIDER deployed from Fort Carson, Colorado, without tanks and Bradley fighting vehicles; they assumed control over equipment that the paratroopers of TF FURY had been using. Following this model, the Army converted other heavy brigade combat teams into advisory forces for Operation ENDURING FREEDOM, a theater accustomed to light forces.","The Army’s employment of heavy brigade combat teams in Afghanistan was an opportunity provided by the success of the Iraq surge combined with decisions made as part of the Grow the Army Plan. Approved in January 2007, the Grow the Army Plan sought to add 65,000 soldiers to the active Army, 8,200 to the Army National Guard, and approximately 1,000 to the Army Reserve by fiscal year 2013. New personnel supported an expansion of force to 76 brigade combat teams (48 Active Army, 28 Army National Guard), 97 multifunctional support brigades (including battlefield surveillance, aviation, fires, maneuver enhancement, and sustainment), and 130 functional support brigades (such as air defense, chemical, engineer, intelligence, military police, signal, and medical). All of the new ground maneuver combat units were infantry brigade combat teams. The first completely new unit was the 3d Brigade Combat Team, 1st Armored Division, which did not activate until 16 August 2009. Under the command of Col. Mark H. Landes, it deployed to Wardak and Logar Provinces in October 2011. In a sense, growing the Army initially benefited the Afghan mission, rather than the Iraqi one as intended. The only two maneuver units yet to have undergone modular conversion were the Germany-based 170th Infantry Brigade and 172d Infantry Brigade. They both deployed to Afghanistan as heavy forces instead of light infantry, without their tanks and Bradley fighting vehicles. The 170th Infantry Brigade, commanded by Col. Patrick E. Matlock, deployed to RC North from February 2011 to February 2012 as a modular brigade augmented for security force assistance, minus the 4th Battalion, 70th Armored Regiment, which was assigned as a security force in support of NATO Training Mission–Afghanistan advisers in RC South. Matlock’s brigade replaced Col. Willard M. “Bill” Burleson III’s 1st Brigade Combat Team, 10th Mountain Division, which had spent the past year training Afghan Uniformed Police and Afghan National Border Police. The 172d Infantry Brigade, led by Col. Edward T. Bohnemann, served as a modular brigade augmented for security force assistance in Paktika Province from May 2011 to May 2012.","As the ANSF assumed greater responsibility for security, the requirement for combat power shifted from modular brigades augmented for security force assistance to security force assistance brigades. Although modular brigades augmented for security force assistance were capable of self-defense and independent combat operations if necessary, their most immediate contribution to combat power was providing ANA and ANP units with intelligence and access to close air support and rotary-wing aviation. By the end of 2012, the U.S. Army was no longer sending forces trained, organized, and equipped principally for combat operations. Security force assistance brigades had become the norm.","The last brigade combat team to deploy to Afghanistan not specifically structured for advising was the 3d Brigade Combat Team, 101st Airborne Division, under Col. Reynolds J. Lillibridge. Although ISAF embraced security force assistance as its core mission in 2012, the experiences of several brigades demonstrated that counterinsurgency operations were still necessary to set conditions for the stability operations conducted by units structured for security force assistance. Lillibridge’s brigade replaced the 4th Brigade Combat Team (Airborne), 25th Infantry Division, at Forward Operating Base SALERNO in RC East in September 2012. Its area of responsibility encompassed the volatile Khost, Paktiya, and northeast Paktika Provinces that the Haqqani Network had long sought to dominate. Given that few ANSF were capable of competing with the Haqqani without considerable U.S. assistance, Colonel Lillibridge’s soldiers conducted operations in much the same manner as their predecessors.","Handing over security responsibility to ANSF began with securing the population. Understanding this, Lillibridge supported expanding Village Stability Operations in his districts. These operations began with establishing a village stability platform (similar to a forward operating base) where local Afghan police could be trained to protect their neighborhoods and impede Haqqani IED teams. While ANA units or ANP elements always accompanied units of the 3d Brigade Combat Team, 101st Airborne Division, the high threat environment ensured that the Americans led these combined operations. The firefights that occurred motivated ANSF units to improve their infantry skills, tactical planning, and communications."]},{"title":"The Goal of a Self-Sufficient ANSF","level":2},{"section":["As the United States was deploying more advisory units to partner with fielded ANA units, the NATO Training Mission–Afghanistan, now headed by American Lt. Gen. Daniel P. Bolger, remained ISAF’s primary means of ensuring that the ANSF were capable of securing their own country. Between November 2009 and August 2011, the unit issued 56,859 weapons, 10,700 vehicles, and 70,262 radios to the ANA, which expanded during the period by 74,000 personnel and 64 kandaks. These figures indicated the mission’s impressive achievements, but they also created a long-term challenge as the lack of support infrastructure made it difficult for the Afghan military force to maintain the Western-made equipment. The ANA found itself grappling with unfamiliar Western technology while attempting to master tactical proficiency in an expanding force."]},{"figure":{"source":"/figures/v2/img_10-2.png","caption":"Chairman of the Joint Chiefs of Staff General Dempsey meets with General Bolger"}},"The ANSF units created during that period reflected the coalition’s near-term need to generate sufficient light infantry to augment ISAF counterinsurgency efforts as well as Commando units to aid coalition-led counterterrorist operations. Whenever Afghan units were committed alongside ISAF, the latter provided all supporting fires; rotary-wing assets; intelligence, surveillance, and reconnaissance platforms; and logistical support. Bolger’s ambitious charter therefore included not only growing the ANSF—not an easy task, given the average 30 percent annual attrition rate—but also providing Afghans with some of the more critical capabilities previously furnished by ISAF. These capabilities included the further development of self-sustaining branch and vocational schools, as well as army aviation, fire support, engineers, and logistical units.","Coalition efforts to develop the ANSF initially stressed quantity over quality. The idea was that once indigenous forces reached their target sizes in 2012, the ANSF would be better postured to address shortfalls in equipment, logistics, personnel, and leadership. After 2012, advisers and their Afghan counterparts would focus on developing enablers and professionalizing the force. The December 2014 deadline for the transition of the mission was of pressing importance to Afghan Special Operations and aviation units, which were heavily dependent on coalition intelligence collection and close air support.","Increasing ANSF authorizations to 352,000 in October 2012 was a calculated risk. The defense and interior ministries still depended on coalition assistance for planning and sustaining campaigns. A larger ANSF was needed to achieve security gains that would be irreversible by the time decreasing foreign aid forced the ANSF to downsize. Achieving those gains relied on a broad approach across multiple Afghan national defense and security force organizations.","The NATO Training Mission’s tactical advisory efforts in 2012 focused on ANA Corps and Afghan Uniformed Police regions, while CSTC-A covered institutional aspects with the Ministry of Defense, Ministry of Interior, National Directorate of Security, and Kabul Military Academy. Developing an Afghan security establishment that could sustain military and police forces entailed establishing institutions for training, education, and recruiting, and systems for strategic planning, intelligence gathering, logistics, and force generation. Advising commands sought an ANSF that could prevail in battle and sustain forces throughout an entire campaign.",{"title":"Unexpected Developments","level":2},{"section":["Although green-on-blue incidents impeded security force assistance, the actions of some Western soldiers also set back Afghan-ISAF relations. On the night of 20 February 2012, soldiers from the 535th Military Police Battalion’s intelligence section burned Islamic religious books at the detention facility in Parwan. The books had been confiscated from the facility library when the Theater Intelligence Group’s counterintelligence team discovered that detainees were using them to pass messages. As the books were examined, an interpreter informed the Americans that three-quarters of them contained extremist sentiments. Several days later, a junior leader acting on his own initiative ordered almost 2,000 of these confiscated books onto a truck for transport to the camp incinerator. Observing U.S. personnel loading Qurans and other religious texts into the vehicle, an ANA soldier went to the detention facility’s operations center to voice his concerns. Operations center personnel attempted to stop the truck but were unsuccessful. The detail arrived at the waste disposal site and began burning the books, only to be stopped by Afghan civilian workers who tossed water into the incinerator in an attempt to extinguish the flames. As the detail ignored continued protests by Afghan workers and attempted to resume burning the books, operations center personnel arrived to terminate their efforts.","Just weeks later, on 11 March 2012, S. Sgt. Robert Bales, a noncommissioned officer from Company B, 2d Battalion, 3d Infantry Regiment, 3d Brigade Combat Team, 2d Infantry Division, out of Fort Lewis, Washington, murdered sixteen Afghan civilians and injured many others during an unauthorized nocturnal foray from Village Stability Platform Belambai in Kandahar Province. Although originally a Special Forces program, Village Stability Operations had proven so successful that Combined Forces Special Operations Component Command–Afghanistan requested two infantry battalions to expand their implementation. At the time of the incident, Bales was the senior member of a two-squad infantry element supporting an operational detachment securing the Belambai platform. Following the Quran burnings, news of an American soldier killing innocent women and children dealt yet another severe setback to ISAF efforts to strengthen its ties with the Afghan populace.","Although a subsequent investigation noted the collocated element’s overall morale was good, the ODA leadership rarely interacted with the infantry squads, preferring to leave that task to noncommissioned officers. In addition, Combined Special Operations Task Force South had denied a request by Bales’ parent company to send a more senior leader to the stability platform. Leaders from the 2d Battalion, 3d Infantry, were not able to visit the outpost on a regular basis because of the remoteness of the platform and difficulties associated with obtaining helicopter transportation to the area. Although Bales did not exhibit overt signs of erratic behavior prior to the 11 March incident, his actions had concerned junior members of the infantry element on several occasions. Unfortunately, those soldiers were reluctant to voice their concerns because Bales was the senior noncommissioned officer in their chain of command. These circumstances enabled Bales to conduct a murderous rampage and hand the Taliban a major information operations victory while eroding the Afghan people’s trust in ISAF."]},{"title":"The Insider Threat: More Green-on-Blue Attacks","level":2},{"section":["The decision to end combat operations hinged upon Afghan security forces being able to prevent the Taliban from toppling the Kabul government. In preparation for the handover, ISAF invested more personnel, money, and resources in preparing the ANSF for increased responsibilities. ISAF not only sent more advisers to work with ANSF but also conducted more partnered operations in the field. The increasing interaction between foreign and Afghan troops made green-on-blue attacks more common. Vetting of Afghan security forces became even more critical, but assets in theater that could conduct these detailed background checks were limited.","The much publicized Quran burnings encouraged attacks and riots across the country. Company B, 2d Battalion, 508th Infantry Regiment, of the 82d Airborne Division’s 4th Brigade Combat Team experienced a green-on-blue incident within seventy-two hours of arriving at Combat Outpost SANGSAR on 1 March 2012. Although the incoming soldiers knew they were vulnerable to such attacks from news sources and word of mouth, they believed they were far enough from Kabul to escape Afghan discontent.","The incident involving Company B began at 0200 on 2 March when three Afghan attackers shot one of their comrades and an American manning the entry control point separating the Afghan and American portions of the outpost. Both of the wounded men survived, but two attackers were able to gain access to a guard tower on the American side after killing the soldier inside it. The third attacker appeared to lose heart and returned to his barracks. The two Afghans occupying the heavily armored guard tower then turned their weapons on the tents and buildings housing Company B. Within seconds, the attackers killed an American noncommissioned officer making his way to the guard tower to investigate the situation. Fortunately, concrete barriers surrounding the tents and buildings occupied by the Americans prevented the assailants in the guard tower from inflicting additional casualties on Company B.","The other paratroopers on duty mounted a hasty counterattack to recover the downed noncommissioned officer and prevent the rogue ANA soldiers from leaving the tower and entering the sleeping area on the U.S. side of the outpost. The Americans quickly discovered that all of the antitank rockets and 40-mm. grenades they fired at the tower were bouncing off it without inflicting damage because their warheads did not have sufficient time to arm. Undeterred, the paratroopers poured an intense volume of machine-gun fire into the tower, silencing their opponents long enough for several Americans to begin tossing grenades at the guard post atop the tower. Although the grenades only succeeded in setting fire to a fuel container underneath the tower, smoke and flames soon enveloped it. Using the cover provided by the inadvertent conflagration, the attackers climbed down to the top of the perimeter wall, whereupon they began making their way from the camp to the surrounding wood line. The Americans made a quick call to a nearby Apache helicopter, whose crew tracked down and killed both assailants.","The investigative process began almost immediately after the fires were extinguished, as information from the U.S. soldier wounded at the entry control point proved sufficient to identify and arrest the third attacker. The investigation disclosed that an Afghan civilian instructor contracted to teach reading and writing to the Afghan soldiers at the outpost had been the instigator of the attack. The teacher, who had radical ideas and ties to the Taliban, used the Quran burnings as a motivation to recruit an Afghan noncommissioned officer and two enlisted soldiers for a surprise attack on the Americans. The assailants then waited until the U.S. units were in the middle of their relief-in-place to make their move. Although the Americans had adequate reason to distrust their allies, one platoon leader marveled at the sight of “two of my soldiers sitting down, trying to talk with the ANA soldiers. Most of the platoon felt betrayed by these partner forces, but there were a few who understood better than I did that if we showed them we were human too and built a relationship, we could possibly deter these Green on Blue attacks.”","In April 2012, American Lt. Gen. James L. Terry, the V Corps and IJC commander, estimated that 25 percent of green-on-blue incidents were “insurgent-related.” In response, he announced “the vetting process of individuals who are coming into the Afghan National Army and Afghan National Police with an eight-step process [including] the requirement to have valid identification cards, letters of endorsement or recommendation from village elders and other aspects, criminal background checks, and so on.” Expanded collection of biometric data such as fingerprints and iris scans and intensified counterintelligence screening were expected to exclude potential security risks and reduce inside attacks. These efforts led to the discharge of hundreds of recruits who displayed any sign that they were capable of being radicalized. In addition, the deaths of two Americans killed in the offices of the Afghan defense ministry prompted ISAF to implement a program in August 2012 in which armed NATO service members, designated as “guardian angels,” protected unarmed comrades working in administrative areas.","Insider attacks reached new heights in 2012 and influenced NATO’s advisory plan. Protectors such as the guardian angels were now  required to ensure the safety of teams embedded with their Afghan counterparts, increasing the personnel committed to each mission. According to Maj. Gen. Tod D. Wolters, the commander of the 9th Air and Space Expeditionary Task Force–Afghanistan from 2011 to 2012, a single green-on-blue incident could force ISAF at any time:",{"list":["\"to go back and look at the math equation as far as the ratio is concerned in this Security Force Assistance model. . . .  Any time you have one of these Green on Blue incidents, as you can well imagine, you’re probably a little less prone to have one coalition member support 50 Afghan security members. You might be in a position where you desire to have five or six coalition members.\""]}," "]},{"title":"Operation NAWEED","level":2},{"section":["Maintaining trust between ISAF and Afghan soldiers became paramount as Afghan security forces began repositioning major elements in advance of the security transition. During autumn 2011, the IJC staff worked on a plan supporting Operation NAWEED (Good News), the ANA, ANP, and National Directorate of Security operational campaign for 2012. Operation NAWEED utilized an overarching approach to synchronizing ANSF and ISAF efforts. Also known as Operational Plan 1391 (after the year 1391 under the Afghan calendar), it was authored by the Ministry of Defense with help from the IJC, and was the Kabul government’s attempt to convince its citizens that Afghan army and police units could provide for their safety. The plan divided the country into geographical sections concurrent to the regional command boundaries designated by ISAF, and described a detailed concept for how ISAF, National Directorate of Security, Afghan police, and army forces would cooperate in each region. It listed ISAF and ANSF responsibilities, detailed the conditions under which the handover would occur, and laid out a general timetable.","Operation NAWEED was unique in that it was the first plan conceived and written by the ANSF. The Afghan authors of NAWEED recognized that security transition entailed more than transferring responsibility from one party to the other. As a result, their plan directed shaping operations in the provinces of Nuristan, Kunar, Nangarhar, Logar, Paktiya, Khost, Zabul, Kandahar, Helmand, Nimroz, and Farah to target known enemy strongholds to wrest the operational initiative from the insurgents. The ANSF would also have to blunt enemy counterattacks so as to maintain security in key areas. The Afghan government viewed NAWEED as an opportunity to exert greater control over its borders. Although ISAF would continue to provide air support, helicopters, medical evacuation, and other critical services, General Allen convinced the Afghan Ministry of Defense to use NAWEED to develop the Afghan military’s logistical systems. The nine-month planning process ended with the Afghan Ministry of Defense publishing Joint Order No. 5 on 1 September 2012. Immediately after issuing the plan, the Ministry created the Afghan Army’s Ground Forces Command and ANSF National Military Operations Center. NAWEED would be the first test for both organizations.","Operation NAWEED involved all six ANA Corps, the separate 111th Division, Afghan Uniformed Police, Afghan Border Police, National Security Directorate organizations, and developmental ministries, including the Ministry of Rural Rehabilitation and Development; the Ministry of Agriculture, Irrigation, and Livestock; and the Independent Directorate of Local Government. Each major ANA formation received broad goals and objectives tailored to its area of operations. These objectives included preventing insurgent groups from conducting operations and ensuring that criminal elements such as smugglers, kidnappers, extortionists, and drug lords were unable to take advantage of the security transition process.","Because implementing the plan simultaneously across the country would overwhelm the nascent ANSF logistical system and newly reconfigured national command and control structure, U.S. and Afghan planners ensured that Operation NAWEED unfolded deliberately. By the time Tranche 3 was announced on 13 May 2012, the ANSF was responsible for securing 75 percent of Afghanistan. This period also marked a major structural change for the ANSF, namely the creation of the Afghan National Army Special Operations Command and Special Mission Wing, both of which began operations on 16 July 2012. The first command created an advocate for Afghan SOF that prevented the Afghan conventional force leadership from improperly utilizing their unique capabilities."]},{"figure":{"source":"/figures/v2/img_10-3.png","caption":"ISAF commander General Allen"}},"The Special Mission Wing provided aviation support for the Afghan Special Forces. The wing was created from the former Ministry of Interior Air Interdiction Unit, which was originally formed for counternarcotics operations. Its charter, outlined in a memorandum of understanding among the U.S. Office of the Secretary of Defense, Combined Training Command, and the U.S. Drug Enforcement Administration, expanded the scope of the organization to include aviation support for Afghan counterterrorism and SOF. In spite of an agreement signed by the National Defense Service and the interior and defense ministers in August 2013, the Special Mission Wing’s split parentage was beset with infighting, and its command relationship remained unresolved through the end of the ISAF campaign.","The one bright spot for the Special Mission Wing was its tactical capability. In spite of the fight over the unit, it successfully conducted multiple air assault and aerial surveillance missions in support of Afghan SOF operations. The NATO Training Mission’s deputy commanding general for SOF had originally trained, advised, and assisted the wing. Eventually, oversight was transferred to the newly created NATO Special Operations Component Command–Afghanistan, with Army Special Operations Aviation personnel in charge of training, advising, and assisting. The creation of Afghan SOF and Special Mission Wing came at a favorable moment in September 2012, as Tranche 4 gave the ANSF lead security responsibility for 87 percent of the population.","With the Afghans continuing to increase their control of the security environment across the country, and the Afghan government building capacity and pushing it out to the provinces, the coalition drawdown of forces and materiel could begin in earnest. However, a successful drawdown would be much more complex than merely redeploying soldiers and equipment. An intricate, coordinated plan of base closures throughout Afghanistan would be required so as not to leave security or governance voids that insurgents could exploit. U.S. and ISAF leadership would have to strike the right balance between steadily removing their assets on the ground and maintaining support for continued stability within Afghanistan—a mission that would put all of their hard-learned experience to the test."],"chapter 11":[{"title":"Drawdown"},{"section":["In his address at the United States Military Academy at West Point, New York, on 1 December 2009, President Barack H.  Obama told the assembled cadets:",{"list":["\"I have determined that it is in our vital national interest to send an additional 30,000  U.S. troops to Afghanistan. After eighteen months, our troops will begin to come home The 30,000 additional troops  that I’m announcing tonight will deploy in the first part of 2010—the fastest possible pace—so that they can target the insurgency and secure key population centers.\""]},"Seventeen months later, in late June 2011, he followed up on those remarks:",{"list":["\"Thanks to our extraordinary men and women in uniform, our civilian personnel, and our many coalition partners, we are meeting our goals. As a result, starting next month, we will be able to remove 10,000 of our troops from Afghanistan by the end of this year, and we will bring home a total of 33,000 troops by next summer, fully recovering the surge I announced at West Point.\""]},"The president also explained that U.S. troop withdrawals would not end with the recovery of the surge forces. In fact, tens of thousands of additional American troops would depart Afghanistan in the months leading up to the planned transition of security responsibilities at the end of 2014.","Drawing down forces entailed the retrograde of equipment and the disposal of materiel that would be uneconomical to return to the United States. The stockpile that had to be reduced, retrograded, and disposed of had been accumulating since the U.S. mission began in 2001. In addition to the sheer amount of materiel involved, the equipment was widely dispersed and had to travel long distances over routes that the coalition did not control. Consequently, planning for the retrograde became a multiyear effort to meet the policy goals that had been set for the end of 2014. Although ANSF and Afghan civilian leaders eagerly accepted coalition equipment and bases, materiel without further utility was scrapped or destroyed. The U.S. military leaders who planned and executed the drawdown were mindful of the fact that Soviet military equipment and supplies left over from the Soviet-Afghan War of the 1980s had been used extensively in the Afghan civil war of the early 1990s by government and opposition forces alike. This knowledge shaped their approach to handling their own equipment as the United States pulled back from its involvement in Afghanistan.","Senior commanders in the final three years of the ISAF and Operation ENDURING FREEDOM missions had to balance two necessary tasks while maintaining the force caps specified by policy decisions. Those policy decisions mandated that coalition military equipment in Afghanistan be reduced, while enablers such as close air support and intelligence support to the ANSF would be continued at current levels. Throughout the process, the coalition had to protect itself from the same malign elements that it was training the ANSF to fight. Although the retrograde of equipment and materiel and the transition to security force assistance were separate efforts, they complemented each other."]},{"title":"Scoping the Surge Recovery","level":2},{"section":["Planning for the drawdown started before Obama announced at the NATO Summit in Lisbon on 20 November 2010 that ISAF would begin transitioning security responsibility to the ANSF in early 2011. The first substantive work toward planning the drawdown of surge forces started in June 2010 and resulted in an order on 18 August 2010 directing units in Afghanistan to prepare to dispose of specified excess equipment. A second conference on excess equipment at the CENTCOM forward headquarters in Qatar from 13–14 October 2010 and a CENTCOM order on 7 December 2010 directed USFOR-A to begin planning to redistribute or dispose of equipment that was not mission essential.","As the USFOR-A deputy commander for support, Maj. Gen. Timothy P. McHale was responsible for withdrawing forces and equipment from Afghanistan. His planning had to occur concurrently with planning for surging forces into theater. As early as July 2010, the 401st Army Field Support Brigade, an organization from the U.S. Army Materiel Command supporting USFOR-A, took advantage of lessons learned in Iraq to begin preparations to expand property holding facilities even as the military saturated the theater with new units. Yet even with these proactive measures, the contractors overseeing operations in the yards soon found themselves struggling with the growing workload.","Although planning continued through winter and spring, it competed with combat operations throughout Afghanistan,  which included the 10th Mountain Division’s assumption of responsibility for RC South from the British. The Afghan surge also marked an expansion of the Afghan Local Police and aggressive clearing operations in Helmand, Kandahar, and Uruzgan Provinces. On 5 April 2012, while those operations were underway, USFOR-A published Fragmentary Order 11–072: ${Interim Base Closure and Transfer Guidance}{italic}, ordering all U.S. units in Afghanistan to prepare for withdrawal concurrent with ongoing combat operations.","Although commanders at all levels understood how important it was to reduce theater assets, units in combat were hard-pressed to account for equipment, redistribute property, remediate hazardous environments, and modify or terminate contracts. The tensions among combat operations, growth of the force as a result of the surge, and planned retrograde were greatest in RCs South and Southwest. Each regional command stood to lose more than one hundred combat outposts and bases by summer 2011. Requirements to return those bases to their original environmental state demanded close oversight from the engineer staff at USFOR-A, and added to the complexity of missions.","Leaders made some broad assumptions at the beginning of the planning process. When the American command started looking at how it could reduce excess, it did not contemplate a full withdrawal from Afghanistan. Furthermore, ISAF and IJC staff officers recognized that the theater had to shed personnel but did not consider that equipment had to be withdrawn in tonnage greater than the equipment associated with current troop numbers. They also had to deal with warehouses and motor parks full of equipment not being used by units in the field. Tactical planners, focused on combat operations, simply wanted to mitigate the burden that retrograde placed on their units that were still conducting combat operations to clear and hold terrain in support of the Afghan surge. This made concurrent planning for the retrograde difficult to attain at all echelons.","Other ISAF members also were reducing their personnel and equipment. The Netherlands ended its combat mission on 1 August 2010, while Canada withdrew its task force in July 2011. The British planned to withdraw roughly 500 troops from their commitment of approximately 9,000 troops, with the goal of reducing the total to 4,500 by 2013.","Planning the drawdown of forces from Afghanistan was not a direct equivalent to the retrograde from Iraq. Brig.  Gen. Scottie D. Carpenter, commanding the 311th Sustainment Command near the end of the Afghan drawdown, was forthright about the considerations:",{"list":["\"It took me about a week here to realize, this isn’t Iraq. In Iraq, it was a fairly simple process of driving equipment to  Kuwait and letting it sit there until someone else could ship it home. Afghanistan is a landlocked country. Here, everything is difficult. Retrograding equipment is time-consuming, it’s expensive. You have to consider the PAK GLOC [ground lines of communication through Pakistan] and whether it’s open or not. Iraq had improved roads, here the road networks can be very difficult. So, retrograde here is much more complex and difficult than what I experienced in Iraq.\""]},"The stark differences between the two redeployments dwarfed any similarities they shared."]},{"title":"Geography and the Initial Disposition of the Force","level":2},{"section":["The manner in which the United States retrograded forces from Afghanistan reflected how the conflict had expanded geographically over the past decade. From ISAF’s arrival in Kabul in late 2001 and the 10th Mountain Division’s occupation of the Bagram and Kandahar airfields in early 2002, coalition forces had spread eastward and southward. The desire to interdict lines of communication to Pakistan and interact with Afghans through Provincial Reconstruction Teams justified new bases such as SALERNO in Khost Province and ORGUN-E in Paktika Province. Later, the shift to population-centric counterinsurgency expanded the coalition footprint to the northeast and southwest into the heavily populated Pashtun areas. Because the U.S. footprint had expanded, most of the forces and materiel needing to be withdrawn from Afghanistan were concentrated in RC East, RC South, and RC Southwest.","The Hindu Kush and Afghanistan’s landlocked borders posed challenges to logisticians. Most of the country was either mountainous or desert, cargo coming in by road would transit Afghanistan National Highway 1, the Ring Road, which circled the Hindu Kush in the south, west, and north, and penetrated the mountain range by way of the Salang Tunnel in the east. This increasingly decrepit tunnel was the only alternative to transporting cargo through Taliban-controlled areas in RC South.","There were four border crossing points where cargo could exit Afghanistan via ground transportation in the north. The easternmost, at Qizil Qal’ah in Kunduz Province, led to Tajikistan. Located approximately 260 kilometers by road to the west was a crossing into Uzbekistan at Hairatan in Balkh Province. Hairatan was also the location of the only rail line in Afghanistan, which extended only as far south as the north-central city of Mazar-e Sharif. The third crossing was about 290 kilometers by road west of Hairatan at Aqineh in Faryab Province, bordering Turkmenistan. The westernmost crossing was approximately 940 kilometers west by road at Toraghundi in Herat Province and also spilled traffic into Turkmenistan. The first three, and later all four, of those border crossings were entry points in what the United States called the Northern Distribution Network, a connection of truck, rail, and water routes through Kazakhstan, Russia, and Latvia to Baltic seaports. The network was also operated under NATO authorities as the Northern Ground Line of Communications.","Afghanistan had two border crossing points suitable for heavy cargo south of the Hindu Kush. The eastern crossing was at a gate complex between Tor Kham, Afghanistan, and Tor Kham, Pakistan, entering the Khyber Pass from Nangarhar Province toward the Pakistani city of Peshawar. The western crossing was at Spin Boldak in Kandahar Province, directly opposite the Pakistani city of Chaman and on the route to Quetta, the provincial capital of Balochistan. Both the Peshawar and Quetta routes converged at Karachi on the Arabian Sea. These routes collectively constituted the Pakistan ground line of communications.","All of these border crossing points could handle vehicle traffic. In February 2012, a rail line opened from Mazar-e Sharif to Termiz, Uzbekistan. A subsidiary of the Uzbekistan State Railways Company operated the line, in conjunction with ISAF advisers, while it trained Afghan engineers and mechanics to assume those roles. The continued operation of a rail line required a secure environment, and Balkh Province had been relatively quiet. However, the Taliban had made inroads into neighboring Kunduz Province and launched several successful attacks into Balkh in 2011."]},{"figure":{"source":"/figures/m/map-figure-11-1.svg","caption":"Northern Distribution Network","prefix":"MAP"}},"Both the Northern Distribution Network and Pakistani ground routes had significant limitations. The latter had been in use for most of the war, but Pakistani instability and cargo theft had persuaded U.S. Transportation Command to develop the Northern Distribution Network as an alternative. Although there was little pilferage of cargo transiting the northern route, it cost approximately double what the Pakistani routes cost and took anywhere from twenty to forty days longer to deliver the goods.","Unfortunately for ISAF, bilateral agreements prevented the Northern Distribution Network from being used for combat vehicles, weapons, and ammunition. Those cargos had to go through Pakistan or move by air transport. Meanwhile, Islamabad’s political sensitivities would not accommodate U.S. personnel working at the Port of Karachi or along the routes connecting offloading docks to Afghanistan. Some outsized cargos such as Stryker personnel carriers and MRAP vehicles were too impractical or sensitive to move through Pakistan and had to exit the theater on Air Force C–5 or C–17 cargo aircraft.",{"title":"Air Transport and Multimodal Operations","level":2},{"section":["Air transport was the fastest and most secure method to bring cargo in or out of Afghanistan, but it was also the most expensive. It cost approximately $12,400 to haul a single 6.1-meter shipping container (empty or full) via commercial truck from Afghanistan to Karachi, load it on a ship, and return it to the United States. In comparison, it cost $167,400—nearly $56,000 per container—to transport the equivalent of three fully loaded shipping containers aboard an Air Force C–17 fixed-wing transport aircraft from Kandahar Airfield to Fort Campbell, Kentucky. Furthermore, although airlift was faster than sealift, the actual throughput via air was slower because a single cargo vessel ferried the equivalent of hundreds of aircraft sorties during a single voyage.","The compromise that emerged combined truck, rail, sea, and air transportation in what was called multimodal operations. The Northern Distribution Network was effectively multimodal because cargo moved from border crossing points by truck, watercraft, and rail to the seaports in Europe prior to returning to the United States. Multimodal transport paid huge dividends for cargo leaving from southern Afghanistan. Outgoing cargo could be loaded onto a C–17 at Bagram or Kandahar and flown to Kuwait or another location in the CENTCOM area of responsibility. After being offloaded, vehicles and containers could then be shipped back to the United States. The throughput was greater and cheaper. Because the shorter flights were considered intratheater lift, they were under the control of the Combined Air Operations Center at Al Udeid Air Base in Qatar rather than U.S. Transportation Command. Because of this, they were more responsive to the theater requirements; an important consideration given that circumstances frequently required reallocating transport assets."]},{"title":"Competition for Limited Assets","level":2},{"section":["One of the fundamental differences between the drawdowns in Iraq and Afghanistan was coalition presence. The expiration of UN Security Council Resolution 1790 and the refusal of the Iraqi government to approve coalition missions beyond 31 July 2009 meant that the British and Australians departed Iraq on 28 July 2009, leaving only American forces by the end of Operation NEW DAWN. In Afghanistan, however, ISAF’s status as a NATO mission meant that coalition members would continue missions throughout the ISAF campaign. The simultaneous extraction of troops and equipment by several nations complicated retrograde efforts as coalition partners competed for space on ground and air lines of communications."]},{"figure":{"source":"/figures/v2/img_11-1.png","caption":"A C–17 Globemaster"}},"Under NATO doctrine, logistics, including transportation expenses, were a national responsibility. Only NATO equipment and headquarters could receive NATO funding; anything provided by a country for the ISAF mission was paid for by that country. In some cases, the United States supported other countries through lift and sustain agreements. Eligibility for such assistance was limited to those allies deemed essential to stability operations. In practice, it meant that the United States was responsible for redeploying the personnel and equipment for multiple nations. Army forces conducted most of the retrograde activity within the CENTCOM area of responsibility. To coordinate all of the moving parts in multimodal transportation, retrograde required tight synchronization. Detailed planning and control of participating units mitigated the risk of well-meaning tactical commanders unhinging the entire effort through their own, undisciplined initiatives.",{"figure":{"source":"/figures/v2/img_11-2.png","caption":"General Rapp visits Army Field Support Battalion Kandahar"}},{"title":"Planning the Retrograde","level":2},{"section":["Translating policy guidance into campaign plans started with a Joint Staff order on 1 July 2011 directing the planning of surge recovery. On 20 August, CENTCOM published Fragmentary Order 07–769, Order to Plan Drawdown of U.S. Surge Forces in Afghanistan, directing USFOR-A to begin withdrawing surge forces in accordance with President Obama’s national address. The order outlined two phases. The first was to reduce end strength by 10,000 troops by the end of 2011, leaving 91,000 U.S. service members in country. The second was to send another 33,000 troops back to the United States by the end of September 2012. Planners at USFOR-A were responsible for identifying who would be withdrawn and sequencing their departure. In the meantime, McHale’s tour as deputy commander for support ended on 1 September 2011 when he transferred his duties to Maj. Gen. William E. Rapp. As planning continued, it became apparent that the U.S. forces did not have a truly accurate assessment of what materiel actually was in Afghanistan. Because retrograde planning could not proceed without that knowledge, the USFOR-A Fusion Cell published Fragmentary Order 11–228 on 21 September 2011. The order directed Operation CLEAN SWEEP–AFGHANISTAN, a phased retrograde and base reduction plan that would identify serviceable and unserviceable theater-provided equipment. On 29 September 2011, the initial estimate of theater-provided equipment in Afghanistan was approximately 26,000 vehicles and 1.8 million pieces of nonrolling stock, which later was estimated to require the equivalent of 95,000 containers. The initial estimate valued that materiel at approximately $17 billion and predicted that it would cost $6 billion to move it out of Afghanistan. Those estimates increased to $25 billion and $10 billion respectively as Operation CLEAN SWEEP–AFGHANISTAN continued.","In a discussion near the end of September 2011, Rapp told ISAF commander General John R. Allen that “we have a physics problem.” There was always the potential that the coalition might have “to go to zero,” meaning total withdrawal of all personnel at the end of 2014. Consequently, any planning for surge recovery had to account for the materiel that had accumulated since 2001. In 1989, the Soviet Union’s 40th Guards Army had left stockpiles of weapons, ammunition, and other equipment for the military of the Republic of Afghanistan, and that equipment had been a major factor in the ensuing Afghan civil war. It was unlikely that the American public or NATO would tolerate its war materiel being used in a similar uprising.","General Rapp realized that his subordinate commanders and staff needed a target with which to plan and measure progress. That target, which he termed the “Number,” was his estimate of how much excess needed to be pushed out of theater per month once the surge recovery had ended. The initial Number, calculated on 24 October 2011, was estimated at 1,250 vehicles and equivalent containers. Rapp’s intent was to create a consistent stream of rolling and nonrolling stock to be turned in for disposal. Whatever was not disposed of in Afghanistan would have to be transported out of the theater. As USFOR-A staff members continued analyzing the retrograde, they settled on 1,200 vehicles and 1,000 containers transported a month, along with the closure of twenty bases per month through November 2012. Some believed that President Obama would keep a residual force of 10,000 to 20,000 service members in Afghanistan after 2014, but Rapp assumed the American forces would have to empty the theater by the end of 2014 under the premise that slowing retrograde was easier than accelerating it.","To meet these three targets, USFOR-A would need the assistance of partners outside Afghanistan. The most vital of these were the Army Materiel Command, Defense Logistics Agency, U.S. Transportation Command, and Office of the Assistant Secretary of Defense for Logistics and Materiel Readiness, which granted the authority for much of what eventually transpired. Most of the equipment in theater had been provided by the Army, and the U.S. Army Materiel Command was the agent for identifying outbound equipment to fill requirements outside Afghanistan. Items not identified for shipment out of Afghanistan were slated for disposal and became the responsibility of the Defense Logistics Agency. Armored vehicles were cut apart with plasma torches, while smaller equipment was destroyed in industrial shredders. Finally, U.S. Transportation Command was responsible for moving cargo from Afghanistan to its final destination. Retrograde could not have occurred without outside assistance, although it was impossible for these state-based units to alleviate all withdrawal tasks from deployed units."]},{"figure":{"source":"/figures/v2/img_11-3.png","caption":"IJC Commander General Scaparrotti"}},{"title":"The CENTCOM Materiel Recovery Element","level":2},{"section":["Planning for retrograde had to account for the reality that Afghanistan remained an active combat zone. In his first “surge recovery workshop”  on 5 October 2011, Rapp outlined three priorities for USFOR-A: maintain campaign momentum, plan the surge recovery, and exercise stewardship of equipment. A week earlier, IJC commander Lt. Gen. Curtis M. Scaparrotti had voiced concerns that surge recovery might interfere with combat operations. Scaparrotti’s worries were well founded, as ISAF’s posture at the time included bases ranging in size from giant air fields at Bagram and Kandahar to assistance platforms housing only ANSF advisers. RCs South and Southwest retrograding began the previous summer. As tactical units occupying small bases simply did not have the personnel or resources to conduct advisory operations, protect themselves in contested areas, and retrograde equipment all at the same time.","In mid-November 2011, Rapp asked Scaparrotti for a dedicated force to handle retrograde actions so that units would be free to focus on combat operations. Any dedicated retrograde force had to be counted toward force caps for military personnel as well as limits on exempted staff for contractors. The only other way to get personnel that would be exempt from force caps was to utilize an external logistics task force on temporary duty orders, as was the case with the Marine Corps’ Retrograde and Redeployment In Support of Reset and Reconstitution Operations Group which had been formed the year before to begin the retrograde of RC Southwest. The forces were critical to the retrograde mission, but they could not be assigned the mission unless they were exempt from theater force caps."]},{"figure":{"source":"/figures/m/map-figure-11-5.svg","caption":"Force Laydown","prefix":"MAP"}},"Fortunately, Scaparrotti and Allen readily endorsed Rapp’s proposal for a Retrograde Task Force, which was intended to be a joint organization, given that RC Southwest included a Marine Air-Ground Task Force and a sizable Army support structure. Rapp had engaged senior leaders such as CENTCOM commander Marine Corps General James N. Mattis and Deputy Secretary of Defense Ashton B. Carter to gain support. In parallel, the USFOR-A and ISAF staffs engaged their counterparts at CENTCOM, Third Army/U.S. Army Central Command, the Defense Logistics Agency, and U.S. Army Materiel Command. Their work came to fruition on 12 December 2011 when CENTCOM published Fragmentary Order 07–778 directing the actions necessary to reduce to 68,000 personnel; setting the roles, missions, command, and control structure for the retrograde; and preparing the theater to endure steady-state retrograde operations through the end of the campaign. The order explicitly stated the need for a “Reposture Task Force” dedicated to retrograde operations.","The retrograde was to be divided into four phases, generally corresponding to the targets that had been given in policy statements on force levels. Phase I, from July 2011 to March 2012, was dedicated to achieving initial operating capability and withdrawing 10,000 troops by the end of 2011 as directed by President Obama in his 22 June 2011 speech. The Phase I goal was to close 10 bases and eliminate 800 containers and 600 vehicles per month. To achieve those aims, approximately 4,000 troops were redeployed or curtailed without replacement. Planners envisioned a Reposture Task Force becoming operational during Phase II to assist in reducing troop strength to 68,000 by the end of summer 2012. They proposed continuing the retrograde based on 10,000–20,000 U.S. forces remaining in Afghanistan after 2014. Rapp’s Number—12,000 vehicles, 1,000 containers, and 20 bases—would remain constant once Phase II started.","The competing demands of progressively smaller force caps, the advising mission, and force protection had stalled previous attempts to retrograde equipment. On 4 January 2012, Mattis formally requested that the secretary of defense and chairman of the Joint Chiefs of Staff support force cap exemptions for the 2,400 military and 1,400 civilian personnel needed for the CENTCOM Materiel Recovery Element and, two days later, sent a formal request to the Joint Staff. After endorsements from Chairman of Joint Chiefs of Staff General Martin E. Dempsey and Secretary of Defense Charles T. “Chuck” Hagel, the president approved a 2,400-troop exemption in March. The Materiel Recovery Element exemption was crucial to pushing forces out of Afghanistan because it concentrated retrograding expertise on the retrograde itself, thereby enabling combat commanders to focus on the immediate needs of the Afghans in their areas of operations.",{"title":"Trouble on the Border","level":2},{"section":["As the retrograde gathered momentum, an unforeseen development in late 2011 closed the Pakistan ground line of communications. On the night of 25–26 November, an ANA Special Forces Company, aided by fourteen U.S. Special Forces soldiers, targeted a Taliban cell operating from the village of Maya near the Afghanistan-Pakistan border. Soon after CH–47 Chinook pilots deposited the Afghan and U.S. forces, they came under machine gun and mortar fire from positions atop a ridgeline to the east. Given the proximity of Maya to the border, the troops on the ground requested a show of force rather than return fire. The unidentified assailants continued targeting the Afghan and U.S. forces despite a low-level pass by an F–15E Strike Eagle. In response, an AC–130 Spectre gunship and AH–64 Apache helicopters engaged the assailants. Over the next ninety minutes, the commander on the ground authorized two more air strikes as his troops continued to receive fire. The engagement ended at 0105 after IJC confirmed that Pakistani Army personnel occupied the high ground overlooking Maya and had been firing on U.S. and Afghan forces. The Afghan and U.S. forces then entered Maya, where they collected a substantial amount of Taliban weapons, supplies, and equipment before being airlifted out on 27 November.","Upon receiving news of the incident, CENTCOM ordered an investigation. CENTCOM offered to conduct a joint inquiry with the Pakistani military, but Islamabad declined. As a result, CENTCOM relied on news agencies for the Pakistani perspective. After interviewing all U.S. and Afghan participants, investigators learned that the Pakistani military had not been notified of the raid in a complete or timely fashion, a required practice. In addition, electronic mapping devices mistakenly depicted the nearest Pakistani unit as fourteen kilometers from Maya. However, poor coordination and erroneous map data do not satisfactorily explain why Pakistani military personnel ignored the show of force or continued firing at U.S. and Afghan troops for almost two hours. In retrospect, it is clear that mistakes by both parties contributed to the fatal encounter.","The incident triggered claims and counterclaims by the United States and Pakistan. According to news accounts, the Pakistani government strongly believed that the air strikes against the ridgeline east of Maya were “premeditated, irresponsible and deliberate. . . . The [Afghan and U.S.] soldiers were 300 meters inside Pakistan, in the Mohmad [Mohmand Agency] tribal areas, recently cleared of militants.” Not content with trading claims with Washington, Islamabad ordered CIA drone operators to leave Shamsi Airfield in southwest Pakistan within fifteen days. Determined to gain as much diplomatic leverage as possible, Pakistan’s high commissioner to the United Kingdom, Hina Rabbani Khar, warned British officials that “this business could . . . wreck the timetable for an American troop withdrawal.” To prove its point, the Pakistani government shut down the roads running through the Khyber Pass that led to the Port of Karachi. Severing the Pakistan ground line of communications posed a tremendous challenge to ISAF; nearly 40 percent of its inbound and outbound logistical traffic utilized those routes. It would take months of negotiation to reopen the Pakistani routes.","The reopening of the ground route through Pakistan on 3 July 2012 did not accelerate retrograde efforts, as the first containers of nonrolling stock did not transit it until February 2013. Although the route was nominally open, throughput lagged for different reasons. Pakistani drivers operating out of Karachi had gone on strike to protest their government’s demand that local truckers could carry ISAF equipment only if they worked with an authorized transport company. Afghan and Pakistani customs agencies had ongoing disputes with each other over procedures and protocol. The only method available to move cargo out of Afghanistan was now flying transport planes to seaports in the CENTCOM area of responsibility."]},{"title":"Accelerating the Surge Recovery","level":2},{"section":["The loss of the Pakistan ground lines of communications interrupted the retrograde before it had started in earnest. Before that point, outbound retrograde throughput was a trickle; as few as fifty vehicles exited in September 2011. Retrograding the theater became a two-part problem encompassing both inbound and outbound cargo. In its role as the National Support Element, USFOR-A had to control inbound cargo flow while ensuring that it disposed of any equipment that could be dealt with in Afghanistan. Reducing equipment in Afghanistan required controls to ensure that units did not bring in more equipment than could be retrograded; the issue was net cargo flow rather than just outbound throughput. At the front end, the cargo coming into the theater had to be reduced. Units rotating into Afghanistan had tried to bring their own equipment, much of which included the latest and most modern technology. After arriving in Afghanistan, many units received additional equipment specific for the mission they would assume.","The 401st Army Field Support Brigade, which had set up redistribution property accountability yards in anticipation of the surge recovery, began identifying what was actually in Afghanistan. Years of fielding equipment to units after their arrival in Afghanistan had left a mass of excess equipment in theater. After multiple transfers of authority and changes in areas of operations, much of this equipment was badly in need of a proper inventory. Redistribution property accountability teams were responsible for inventorying and accounting for this excess equipment, which then became available to incoming units.","One of the greatest innovations to assist the property accountability process came from Col. Kurt J. Ryan’s 10th Sustainment Brigade, which established a retrograde sorting (“retrosort”) yard at Bagram in December 2011. Retrosort yards accepted excess, nonmission-essential equipment and cargo containers from units that were reducing their bases in Afghanistan, even if the units did not have complete custody paperwork. By relieving units from having to account for this property, retrosort yards helped units clear bases while still conducting partnered operations with the ANSF, and lifted the burden of maintaining, sorting, and processing, materiel not on their property books. The yards also served as reutilization warehouses that provided free issue to units that needed it, rather than shipping it from home station. From February to July 2012, Col. Jeffrey W. Drushal’s 45th Sustainment Brigade established another retrosort yard at Kandahar Airfield and a third at Camp John Pratt near Mazar-e Sharif.","As could be expected, it took time to stand up the CENTCOM Materiel Recovery Element. Although units already in Afghanistan such as the 10th Sustainment Brigade shifted to the mission once approved, the first unit allocated in its entirety to the CENTCOM Materiel Recovery Element mission was the New York Army National Guard’s 427th Support Battalion. Upon its arrival in March 2012, the battalion was split between the 10th and 45th Sustainment Brigades in RC East and RC South respectively. The first dedicated Materiel Recovery Element organization at Kandahar Airfield was established in July 2012 with the arrival of the 18th Support Battalion commanded by Lt. Col. Michelle M. T. Letcher."]},{"figure":{"source":"/figures/v2/img_11-4.png","caption":"Spc. Jackie Tackett uses a rough terrain container handler"}},"Addressing inbound flow required units to identify what equipment they required for the mission. U.S. Army Central Command was the broker for all requests for equipment, which it did in conferences with USFOR-A, IJC, and incoming units. These consultations helped USFOR-A achieve its monthly goal of 1,200 vehicles and 1,000 containers in March 2012, a substantial improvement over the 50 pieces of rolling stock that had moved in September 2011. This achievement validated the multimodal approach and was all the more remarkable because the Pakistani lines of communications were still closed.","Equipment designated for disposal in Afghanistan fell into categories that all required different authorities. Much of the property that had built up in theater, whether operated by military units or contractors, was termed foreign excess personal property since it was no longer necessary to the mission. Foreign excess personal property included containerized housing units, industrial safety equipment, air conditioners, refrigerators, generators, computers, furniture, water trucks, forklifts, tractors, and other nontactical vehicles. On 23 January 2012, Alan F. Estevez, assistant secretary of defense for logistics and materiel readiness, greatly accelerated the retrograde by granting “tiered delegation authority” to tactical commanders, allowing them to approve transfers of foreign excess personal property directly to the Afghans after vetting the transaction with USFOR-A.","Equipment too expensive to transport was designated as excess defense articles. The United States offered excess defense articles to other countries at no charge under the proviso that it was “where is, as is.” Those who received these items were responsible for transporting and maintaining them. USFOR-A worked closely with the U.S. Embassy in Kabul to solicit interest from other Central Asian states, though those countries generally were interested in only new equipment available through foreign military sales. Therefore, the excess defense article program would never become the primary dispersal method of excess property for U.S. forces.","Because Rapp was adamant that the United States would not leave military equipment behind after a drawdown, he permitted excess defense articles to be transferred to the ANSF only under exceptional circumstances. His counterpart in these transactions was Lt. Gen. William B. Caldwell IV, commander of the NATO Training Mission. Caldwell’s command had spent significant effort to disabuse Afghan soldiers of the belief that equipment and other resources had to be hoarded. The tendency to mass combat equipment for status reasons ran counter to the coalition’s efforts to build an Afghan logistics enterprise and streamline ANSF vehicle fleets so to reduce their maintenance burden. The Training Mission had been trying to stop this type of hoarding behavior for years. A similar rationale existed for transferring bases; the ANSF had to be able to maintain any property they received from the coalition. A base that the ANSF could not maintain ran the risk of becoming either a drain on the Afghan government’s resources or a battle position for the insurgency if abandoned or overrun.","In most cases, there was still serviceable equipment left even after disposing of excess personal property and defense articles. On 1 March 2012, the DoD granted its Defense Logistics Agency authority to destroy serviceable equipment that U.S. Transportation Command representatives jointly determined too costly to ship. Serviceable vehicles that were not required elsewhere or whose values were less than the cost to ship them back to the United States—the majority of items being in the latter category—were destroyed in theater. In the absence of the Pakistan ground lines of communications and with the lack of significant backhaul throughput on the Northern Distribution Network, multimodal transport was the most reliable method for equipment that could not be disposed of or destroyed. It was a costly option, but nonetheless it was the most fiscally sound decision given that the campaign was coming to a close.",{"figure":{"source":"/figures/v2/map_11-3.svg","caption":"Force Laydown","prefix":"MAP"}},"The CENTCOM Materiel Recovery Element formed around Letcher’s battalion preceded much larger ones. The August 2012 arrival of the 593d Sustainment Brigade, commanded by Col. Douglas M. McBride Jr., enabled USFOR-A to establish a single materiel recovery element headquarters for all of Afghanistan. As retrograde throughput continued to accelerate, the last of the 33,000 troops constituting the Afghan surge departed by 21 September 2012, marking the end of Phase II and shrinking U.S. forces to their 68,000 force cap.",{"title":"Securing the Retrograde","level":2},{"section":["Along with sending additional logistical elements to manage the retrograde, CENTCOM sought to prevent the Taliban from exploiting vulnerabilities in the country’s contested eastern region by temporarily allocating General Allen additional combat power to use as he saw fit. As a result, the U.S. Army deployed Lt. Col. David W. Gardner’s 2d Battalion, 505th Infantry Regiment, 3d Brigade Combat Team, 82d Airborne Division, from Fort Bragg, North Carolina, to Afghanistan as the ISAF Operational Reserve Force. Gardner’s unit was to conduct Operation READY EAGLE, which began on 10 July 2012 and lasted for four months. The mission was “disrupting enemy forces in Afghanistan’s Regional Command East to provide repositioning units space and time to perform retrograde operations and battlespace handover.” In other words, the battalion would engage the Haqqani and the Taliban where they found them so they would not interfere with the retrograde. The forces included a company from the 2d Battalion; an ODA from the 1st Special Forces Group, 1st Special Forces Regiment; and an ANA Commando company. Throughout the operation, the infantry company normally would establish a cordon around the targeted area to secure it so the U.S. and Afghan SOF could search the objective, interact with locals, and gather intelligence. Unlike the broad geographical charter of its predecessors, 2d Battalion, 505th Infantry, focused on Afghanistan National Highway 1, the primary land route supporting retrograde operations in RC East. Rather than react to Taliban attacks, Gardner executed intelligence-driven preemptive strikes on known Taliban bases in order to eliminate fighters and destroy caches stockpiled for future attacks on ISAF convoys. The Taliban fighters could have abandoned their positions near the highway, but they trusted that their elaborate IED fields would give them advance notice of ISAF encroachment and inflict casualties on potential attackers. Many Taliban outposts featured extensive tunnel systems that allowed fighters to avoid detection while minimizing the damage inflicted by fires called in by ISAF ground troops. Conducting READY EAGLE missions until winter terminated the 2012 fighting season, 2d Battalion, 505th Infantry, was able to shift the Taliban’s attention from attacking retrograde convoys to defending their safe havens along the highway."]},{"title":"ISAF Infrastructure Comes Under Attack","level":2},{"section":["Although the Taliban focused on reconstituting its ranks following the surge, it also sought to remain in the media by  conducting high-profile attacks. This quest for favorable news coverage began on 15 April 2012 with a coordinated assault by Haqqani fighters on embassies, a supermarket, a hotel, and the parliament building in Kabul, as well as targets in eastern Nangarhar, Logar, and Paktiya Provinces. Eleven ANSF personnel, four Afghan civilians, and thirty-six insurgents were killed in the ensuing fighting. ISAF commanders may have considered the attacks relatively ineffective from a purely military standpoint, but Western media outlets took a different view: “Though the death toll was relatively low . . . it highlighted the ability of militants to strike high-profile targets in the heart of the city even after ten years of war.”","The sharply contrasting assessments of the same event once again highlighted the fact that ISAF and the U.S. military rarely conducted effective information operations. News releases from the various military headquarters in Afghanistan often presented the perceptions and beliefs of senior leaders to the public rather than unvarnished facts. They tended to downplay mishaps by friendly forces and enemy successes and overemphasize friendly successes. Even among news agencies that were dedicated to presenting events as objectively as possible, without any particular editorial bias, their reporting was only as accurate as the information they received from official sources. President Hamid Karzai magnified these disparities in reporting when he began regularly contradicting ISAF releases during his second and final term in office. Consequently, global audiences were far more likely to consider the media as more reliable than the military, regardless of the latter’s nationality."]},{"figure":{"source":"/figures/v2/img_11-5.png","caption":"Field artillery at Forward Operating Base Pasab"}},"The media-oriented approach continued when Haqqani fighters launched a complex attack on Forward Operating Base SALERNO near the city of Khost on 1 June 2012. Originally established in September 2002, SALERNO had grown into a sprawling community. The base, which now hosted nearly 5,000 ISAF service members and contractors, had been unsuccessfully assaulted by the Taliban in 2008 and 2010. At the time of the Haqqani attack, it boasted a combat support hospital, aviation hangars, helicopter arming and refueling facilities, subcamps for U.S. special operators, a gymnasium, a post exchange, a chapel, a community dining facility, and a gravel runway capable of supporting C–130 Hercules aircraft.","The Haqqani Network had earned a reputation among ISAF personnel for meticulous planning, disciplined leadership, and mastery of small unit tactics. Exploiting familial ties within Khost, Paktiya, and Paktika Provinces to gain intelligence and access, Haqqani fighters often launched unexpected attacks on ISAF targets before withdrawing to their sanctuary in Miran Shah, Pakistan. At 1200 on 1 June, a flatbed truck loaded with roughly a ton of explosives detonated after being parked next to the southern perimeter wall at SALERNO. A few moments later, an insurgent drove a white minivan through the gaping hole in the wall to disgorge more than a dozen attackers intent on massacring unarmed soldiers and contractors in the nearby dining facility, which had been severely damaged by the blast. Unbeknownst to the insurgents, a platoon from Company A, 1st Battalion, 501st Infantry Regiment, reserved by the commander of 4th Brigade Combat Team, 25th Infantry Division, for high-value targets of opportunity, was billeted near the dining facility.","Without taking time to organize, soldiers from the platoon rushed to the damaged dining hall. An inner wall prevented the Haqqani fighters from advancing directly on their target, allowing the Americans to win the race to the dining facility where they occupied positions overlooking the breach. With bursts of machine gun fire, they cut down a number of heavily armed insurgents clad in U.S. uniforms. As the firefight continued, several American combat vehicles arrived at the scene, oblivious that some of the men dressed in U.S. uniforms were Haqqani fighters.","To the Americans occupying defensive positions near the dining hall, it seemed as if the enemy fighters were chafing at the imposed delay. Instead of remaining in their relatively secure positions, the attackers sprinted across the road, incurring more casualties before stopping to shoot rocket-propelled grenades at their defenders. While the delay permitted the American platoon to consolidate, a single attacker sought cover under vehicles parked near the dining facility. As the firefight increased in intensity, drivers positioned MRAP vehicles and Afghan police vehicles on the flanks of the attackers to cut off their escape routes.","Next to appear on the scene were several OH–58 Kiowa Warrior helicopters from the 82d Airborne Division. The Kiowa pilots could not employ rockets or Hellfire missiles because of the proximity of friendly troops, so they leaned out of their cockpits and emptied M4 rifles at the attackers while making low-level passes over the breach. Reacting to the fire from overhead, the Haqqani sought cover elsewhere only to be killed by Americans firing at point-blank range from their defensive positions. One Haqqani fighter managed to reach a sewage-filled ditch, where he resisted for a few minutes before being shot. At about the same time, the attacker hiding under the vehicles was killed after wounding two Americans. The battle ended with the enemy force eliminated, five Afghan civilians killed, and one 4th Brigade soldier mortally wounded. About one hundred ISAF soldiers and civilians were treated for superficial injuries incurred when the dining facility and adjacent post exchange collapsed.","Although the Haqqani Network failed to inflict serious damage and casualties at Forward Operating Base SALERNO, Taliban spokesmen described the attack as a tremendous victory. To the Americans, it showcased the tensions between retrograde efforts and combat operations. Even though the U.S. military was drawing down its presence in Afghanistan, it still needed sufficient materiel to safeguard U.S. and ISAF forces against well-coordinated insurgent attacks. On the international scene, the incident at SALERNO triggered diplomatic broadsides between Washington and Islamabad. Obama administration officials cited the incident as an example of why the Pakistani government needed to take extraordinary steps against the Haqqani Network. The attack prompted Defense Secretary Leon E. Panetta to proclaim during a 7 June 2012 visit to Kabul that the United States had reached “the limits of our patience” with Pakistan. Those remarks came one day after Panetta “slammed Pakistan as an untrustworthy partner” during a visit to neighboring India.","The Taliban gained the victory it sought with a subsequent attack on the Bastion-Leatherneck-Shorabak base complex in RC Southwest on the night of 14–15 September 2012. Built around Camp Bastion, a British-occupied compound supporting operations in what was then RC South, the complex had merged in June 2010 with the adjacent Camps Leatherneck and Shorabak, respectively occupied by U.S. marines and ANA forces. Forty kilometers of chain-link fence and guard towers girded the base, which could accommodate up to 30,000 personnel within its one hundred square kilometers. The Taliban attack benefited from the fact that ISAF commanders were expected to protect bases enlarged to accommodate surge troops with a dwindling number of personnel. The Marine contingent on Leatherneck, which numbered more than 17,000 in March 2012, had shrunk to 7,000 by the time of the attack.","Fifteen enemy fighters infiltrated through a chain-link fence near an unguarded tower on Camp Bastion just after dark on 14 September. The Taliban strike force, wearing U.S. uniforms adorned with name tags and 10th Mountain Division insignia, split into three five-man teams to attack the fixed-wing aircraft and helicopters of the 3d Marine Air Wing (Forward) parked on the airfield. The infiltrators remained undetected for sixteen minutes while they destroyed six Marine AV–8B Harriers and damaged two more, along with one Army C–12 fixed-wing transport, three Marine MV–22 Ospreys, one C–130 Hercules, and one British Sea King helicopter.","In addition to the damaged and destroyed aircraft, the assault teams exploded three fuel bladders, destroyed five fabric aircraft shelters, and severely damaged two British vehicles. A combination of Taliban grenades, machine guns, and fire from responding ISAF helicopters damaged four more aircraft shelters and a maintenance building. Two Americans were killed and eight more were wounded in the attack, while the British forces suffered eight wounded. ISAF personnel responding to the attack, aided by Marine helicopters, killed fourteen of the fifteen attackers in a hectic four-hour battle. A company from the 2d Battalion, 75th Ranger Regiment, which remained uncommitted during the fight to avoid fratricide, swept the flight line at dawn. Shortly afterward, ISAF soldiers captured the one enemy survivor, who provided his captors with enough information to enable SOF to track down the planner of the attack.","The Taliban’s efforts to duplicate its successful attack on Camp Bastion elsewhere did not prove as fruitful. Twelve Taliban insurgents attacked Forward Operating Base FENTY on the eastern outskirts of Jalalabad on the afternoon of 2 December 2012. At the time, FENTY housed the incoming 1st Brigade Combat Team, 101st Airborne Division; the outgoing 4th Brigade Combat Team, 4th Infantry Division; medical evacuation and attack aviation assets; SOF; ANSF units; contractors; and other tenants. FENTY also had a surgical hospital capable of stabilizing combat injuries prior to sending wounded soldiers out of country. Additionally, FENTY had the only asphalt airfield capable of supporting C–130s in the region, which meant that it handled most of the ISAF air traffic into Nangarhar and surrounding provinces. The attack began suddenly. Insurgents directed a truck bomb against a guard tower overlooking the pedestrian gate entrance on FENTY’s northern perimeter at 0550, and followed it with a second truck bomb at the same location. Twelve enemy fighters, covered by machine guns and rocket-propelled grenades firing from hidden positions across the Kabul-Jalalabad Road on the other side of the ruined pedestrian gate, charged in an attempt to enter FENTY. Fortunately for the camp’s inhabitants, the ANSF unit billeted nearest the gate was preparing for a dawn live-fire exercise. The Afghan soldiers and their American advisers began shooting at the Taliban seeking to enter FENTY, forcing the attackers to take cover in a drainage ditch running along the adjacent highway. Using the fire as cover, soldiers from 3d Special Forces Group, 1st Special Forces Regiment, blocked enemy access to the camp by physically wedging one of their HMMWVs in the gap opened by the truck bomb.",{"figure":{"source":"/figures/v2/img_11-6.png","caption":"An AH–64 Apache"}},"American troops from the 3d Battalion, 75th Ranger Regiment, ascended the surviving guard tower in order to engage Taliban fighters sheltering in a ditch outside the camp. At the same time, two pilots from 2d Squadron, 17th Cavalry Regiment, jumped in their Kiowa Warrior helicopters and flew to the scene, followed by a pair of AH–64 Apaches. All four helicopters made firing passes along the length of the ditch while the Taliban began engaging the pedestrian gate defenders with mortar fire. Shortly afterward, a third truck bomb rammed the perimeter wall beneath the tower. The explosion wounded six Rangers, forcing them to abandon their vantage point. The efforts of the third truck-bomb operator were in vain, however, as the orbiting Apaches wiped out the pinned-down enemy assault element with 2.75-inch rockets.","The attack, which ended ninety minutes after the first truck bomb exploded, resulted in twelve Taliban deaths, four ANSF fatalities, fourteen Afghan military wounded, ten American service members wounded, and one U.S. civilian contractor injured. The events at FENTY illustrated that although the Taliban had informants within many ISAF installations, those individuals were rarely capable of gathering a full and timely picture of activities taking place within the bases. In this instance, the attackers unexpectedly encountered Afghan and U.S. Special Operations personnel gathering at the point of the attack for a training exercise. Galvanized by the brazen assault, U.S. forces stepped up their own intelligence collection efforts in the region. Consequently, only three weeks later, the timely acquisition of intelligence led to a SOF raid that apprehended six individuals who had been organizing a repeat attack. As coalition forces continued the drawdown, the confidence and competence of the ANSF would become even more critical."],"chapter 12":[{"title":"Transitioning from Counterinsurgency to Security"},{"section":["By 21 September 2012, the last of the surge forces had redeployed and USFOR-A met the White House’s guidance by reducing end strength to 68,000. The 33,000 troops withdrawn over the previous year predominantly came from everywhere but RC East. Those reductions included six Army brigade combat teams, five Marine infantry battalions, elements of a combat aviation brigade, and headquarters staff. Coalition forces had also reduced, most significantly with the departure of Task Force LAFAYETTE, the French brigade operating in RC East on 16 July 2012. In its place, ISAF increased its security force assistance teams, reflecting the shift in mission from combat to advising. That advisory focus was crucial as the ANSF assumed greater responsibility for securing Afghanistan."]},{"title":"The ANSF and the Culmination of INTEQAL","level":2},{"section":["Command of ISAF changed in the midst of security transition. On 10 February 2013, Marine General Joseph F. Dunford Jr. assumed command of ISAF from General John R. Allen. Dunford signaled the soundness of the campaign plan developed by Allen with an 18 June 2013 announcement heralding the start of Tranche 5, also known as Milestone 2013. On that day, the ANSF assumed responsibility for securing all of Afghanistan, a landmark achievement that testified to the progress made in the past years. The ANSF also had taken responsibility for planning their annual and seasonal operations. Among the new ANSF plans was Operation OQAB (Eagle), which coordinated the efforts of Afghan ministries. OQAB was the successor of the previous year’s Operation NAWEED. Political corruption and criminality remained problems, but the Ministry of Defense and the Ministry of Interior were markedly better and more independent at Milestone 2013 than they had been in 2011 at the beginning of the surge recovery."]},{"figure":{"source":"/figures/v2/img_12-1.png","caption":"General Dunford, Lt. Gen. Keith M. Huber, and Brig. Gen. Balan R. Ayyar"}},"The decision to stress capability development over rapid growth had started to have a noticeable effect. By the end of June 2013, the ANSF led nearly 90 percent of all operations and secured almost 90 percent of Afghanistan. By the time Milestone 2013 was reached, ANA kandaks had proven themselves capable of planning and executing tactical operations from start to finish and had developed a nascent capability for combined arms operations at the brigade level while preventing the insurgency from seizing population centers or lines of communications. Work remained on logistics, operational and strategic planning, intelligence sharing, and aviation. Enabling Afghans to consolidate gains beyond the small-unit level, however, would require ISAF to change its operational method.","ISAF intensified its efforts to shift from combat advising to functionally based security force assistance during 2013. Advisers now aligned  with Afghan components on eight essential stability functions: (1) plan, program, budget, and execute; (2) transparency, accountability, and oversight; (3) civilian governance of Afghanistan’s security ministries and adherence to rule of law; (4) force generation; (5) sustain the force; (6) plan, resource, and execute effective security campaigns; (7) develop sufficient intelligence capabilities and processes; and (8) maintain internal and external strategic communications capability. Connecting these eight functions was intended to develop the long-term sustainability of the Afghan security ministries and forces. By October 2013, 344,602 Afghans were serving in the army, police, or paramilitary organizations such as the Afghan Local Police. Afghan security forces conducted 95 percent of conventional operations and 98 percent of special operations in Afghanistan. Although the ANA did not exhibit the tactical aptitude of ISAF units, its performance was good enough to force the Taliban to abandon open battle and restrict attacks to indirect methods such as IEDs.",{"figure":{"source":"/figures/m/map-figure-12-2.svg","caption":"Force Laydown","prefix":"MAP"}},"The ANA planned, executed, and sustained several major offensives aimed at eliminating staging grounds for insurgent attacks on Kabul during 2013. The largest of these efforts, which took place in Logar Province in September and October, involved several ANA corps, Afghan SOF, and the Afghan Air Force. Its purpose was to clear a valley and secure a district center so that humanitarian supplies and voter registration materials could reach the local population. After three weeks of fighting with intermittent air support as a result of inclement weather, government forces achieved their objectives. As the ANA withdrew from the valley, the Ministry of Interior replaced the departing soldiers with police to provide sustained security.","Now that they led most combat operations, Afghan security forces suffered more killed and wounded than in previous years. During a September  interview, Dunford expressed his concern that ANSF were averaging more than one hundred deaths per week: “I’m not assuming that those casualties are sustainable.” The Afghan National Army’s nonbattle attrition rates, which included desertion due to diminishing ISAF medical support and the increased chance of injury, doubled to almost 3 percent monthly and 30 percent annually. Despite combat losses and nonbattle attrition, no Afghan Army unit collapsed in battle, and recruiting goals continued to be met.","The trends emerging from this period indicated both the strengths and weaknesses of U.S. security force assistance efforts. Fielding new equipment such as the U.S.-manufactured M224 60-mm. mortar proved helpful. This lightweight and easily maintained weapon increased the Afghan Army’s ability to overmatch enemy forces while reducing its reliance on ISAF air support. The ANA performed credibly at the tactical level, but Afghan military units experienced difficulties mastering intricate battlefield functions such as counter-IED operations, maintenance, fire support, collecting and disseminating intelligence, and providing medical care.",{"title":"The Unified Implementation Plan","level":2},"Putting the Lisbon Communiqué and Allen’s campaign direction into practice required an operational plan to guide tactical actions during INTEQAL. That task initially fell to Lt. Gen. James L. Terry, who approved a support plan that came to be called the Unified Implementation Plan. The Unified Implementation Plan had its roots in Terry’s experience commanding the 10th Mountain Division and RC South in 2010–2011 when Terry attempted to unify the guidance his unit received from the various headquarters in its area of operations. As General Terry prepared to deploy the V Corps staff to Afghanistan, he envisioned a similar approach for IJC. Work on the Implementation Plan started in January 2012 at the V Corps’ home station in Germany and was refined during a mission rehearsal exercise held from 18 March to 5 April 2012. The plan became active after Terry assumed command of IJC when the V Corps relieved Maj. Gen. Curtis M. Scaparrotti’s I Corps on 12 June 2012.","Several years of operating under IJC and with the NATO Training Mission had given conventional ground units a degree of coherence that had not existed before 2012. Unfortunately for unity of effort, that coherence excluded ISAF’s other subordinate commands, most notably NATO Special Operations Component Command–Afghanistan and NATO Air Command–Afghanistan. While operationally relevant within their own domains, these organizations were not part of a unified framework and pursued different campaign objectives. Another factor complicating coalition unity was the Afghan concern that the Unified Implementation Plan would supersede Operation OQAB, the Afghan-planned operation for 2013. Although competition between the two plans was always possible, Terry’s goal was to complement ANSF efforts, not replace them.","Allen had provided Terry guidance on the Unified Implementation Plan by setting the acceptable risks to both the force and the mission. In his own assessments, Terry recognized that the Unified Implementation Plan had to translate ISAF’s strategic guidance into tactical direction for his regional commands. The plan needed to provide context to coalition partners in the joint operating area as well. Even though it had been informed by the highest levels of expertise in operational planning in theater, the plan was limited in that it encompassed only units in IJC’s hierarchy. Therefore, it excluded special operations, air-advisory actions, and much more. The Unified Implementation Plan could not direct the detention and rule of law functions that fell under Lt. Gen. Keith M. Huber’s Combined Joint Interagency Task Force 435 or the anticorruption and economic development efforts that fell under Combined Joint Interagency Task Force SHAFAFIYAT, a command that had just passed from Maj. Gen. Herbert R. McMaster to Maj. Gen. Richard C. Longo. Terry’s immediate concern, consistent with his tactical responsibilities as a corps commander, would be to balance force reductions with risk to the force over time. In October 2012, concurrent with work on the Unified Implementation Plan, ISAF had added additional retrograde guidance by publishing Amendment 2 to Revision 6 of its campaign plan. This plan was inherently a compromise, as it had to be vetted through the NATO chain of command and approved by the North Atlantic Council. It consequently did not meet with Terry’s satisfaction.","The Unified Implementation Plan was not written like a traditional operations plan. Its structure was narrative in form, starting with a statement of operational design more consistent with a theater strategy than a campaign plan. Its planning horizon extended beyond INTEQAL to the end of the ISAF mission in December 2014. It was intended to continue transitioning security responsibility to the ANSF independent of the stability planning occurring at IJC. In the absence of a comprehensive theater strategy in Operation Plan 38302, the Unified Implementation Plan approved by Terry on 1 January 2013 provided long-term direction for U.S. forces in theater.","After seeing the clarity that the Unified Implementation Plan provided to Terry’s subordinate units, Dunford wanted to reexamine Operation Plan 38302 but refrained from doing so knowing that any revision might stall in the NATO approval process. In its existing state, Operation Plan 38302 covered ISAF’s activities to the end of the Afghan surge recovery, which had concluded a year earlier. Because a document such as the Unified Implementation Plan could not serve as authoritative guidance to ISAF beyond regional commands, Dunford filled the gap by directing his deputy chief of staff for operations, American Maj. Gen. Sean B. MacFarland, to develop fragmentary orders that complemented the IJC plan.",{"figure":{"source":"/figures/v2/img_12-2.png","caption":"IJC commander General Terry (left) speaks with ISAF commander General Dunford"}},"The order to complete Operation Plan 38302, issued as ISAF Fragmentary Order 081–2013 on 20 May 2013, was the first clear statement of what ISAF would do after INTEQAL ended. Fragmentary orders did not normally offer strategic guidance, but 081–2013 foretold how the ISAF and Enduring Freedom campaigns would progress from Milestone 2013 to the end of both missions on 31 December 2014. It built on work in the Unified Implementation Plan to provide guidance critical to implementing Dunford’s campaign visualization. It was through this fragmentary order that Dunford would direct the transformation, started under Allen, of ISAF into an organization dedicated to security force assistance.","The concept, to be instituted in May 2013, included general principles but offered scarce guidance on how units would interact with the ANSF. Because little time was left in the campaign and the ISAF troop-contributing nations had diverse backgrounds, the principles were less prescriptive for adviser conduct. Rather than focus on operations, Dunford emphasized that security force assistance must be done with ANSF sustainability in mind, provisionally defined as “the ability to maintain the SFA [security force assistance] effort throughout all the phases of the operation and the ability of the Afghan Security Institutions and ANSF to sustain their capabilities independently over the long term.”","One example of ANSF sustainability was in the area of planning and executing campaigns, where there had been decent progress already. By fall 2013, the Ministry of Defense had developed the Afghan National Military Strategy to guide the ANA through 2017. The ANA General Staff had completed its planning for Operation OQAB, its operations order for Solar Year 1392 (2013), earlier than in previous years. The Ministry of Interior made similar progress, publishing both a National Police Strategy and a National Police Plan without direct coalition assistance. Although both ministries had made substantial progress in improving their logistics, they still needed help in identifying national sustainment requirements and getting supplies and maintenance to the force.","One of the greatest obstacles to developing those capabilities in the ANSF was finding the appropriate expertise in the coalition itself. Above the tactical level, troop-contributing nations had little expertise in the strategic planning, programming, force structure, and budgeting necessary to advise a national defense establishment. The largest repository of those skills was the contractors and civilians at CTSC-A. Such knowledge was less common in CTSC-A’s uniformed military members, let alone other Operation ENDURING FREEDOM or ISAF organizations. Exacerbating the issue was the need to balance short-term operational imperatives with long-term developmental needs. Building professional security institutions from individual and small-unit skills up to the ministerial level required coalition commanders to allow the Afghans to build expertise in basic tasks such as operational planning, supply, maintenance, and transportation while also addressing their long-term developmental deficiencies.","At the end of 2013, recognizing how little time was left in the ISAF and ENDURING FREEDOM campaigns, Dunford directed a change in emphasis from advising tactical units to advising ANA corps, ANP regional headquarters, and the national ministries. Dunford truly believed the ANSF were becoming tactically proficient, and therefore a change in advisory efforts was warranted. In a statement to the Senate Armed Services Committee on 12 March 2014, he highlighted the improved skills and continued cohesion of the ANSF in spite of increased casualties. As a result of the change from counterinsurgency to stability operations, American and coalition casualties in 2013 were a quarter of what they had been in 2010, when ISAF had started partnered security operations with the ANSF. Dunford’s statements, while indicating the progress that the security forces and Afghan ministries had made, were a precursor to the immense effort required to reshape ISAF and its subordinate commands for the shift away from security operations.","The U.S. policy guidance supported this shift during 2013 and 2014 but remained vague for the post–ENDURING FREEDOM campaign. Surge recovery guidance not only affected retrograde efforts but also changed ISAF’s operational approach. Up to the transition, coalition forces had taken the lead for security so that the ANSF could stand up as an independent force. Coming at the end of surge recovery, a self-sufficient ANSF, capable Afghan institutions, and a transformed ISAF became the operational goals of allied intervention.","The campaign’s dependence on hard policy guidance for the post-2014 mission complicated planning for the retrograde. The final international agreement authorizing military operations in Afghanistan under the ISAF mission was published on 10 October 2013 as United Nations Security Council Resolution 2120. That resolution granted ISAF’s authorization under Chapter VII of the United Nations Charter through 31 December 2014 but indicated that the mission would not be extended further, stipulating that the headquarters would render its final report by December 2014. The way around this impasse came in changing how participants defined the post-2014 mission. As a noncombat mission, the subsequent NATO-led Operation Resolute Support did not fall under the provisions of Chapter VII. Prior to any subsequent UN Security Council resolution, agreements for a noncombat post-2014 mission would have to be negotiated bilaterally between Afghanistan and individual states or multinational entities.","In spite of repeated claims that he would sign a bilateral security agreement between the U.S. and Afghan governments, Afghan president Hamid Karzai refused to do so, even after a referendum and loya jirga (grand assembly) overwhelmingly called for such a document. Karzai’s reticence troubled Dunford and his political leadership as the majority of personnel and equipment for the post-2014 mission would come from the United States. The need for counterterrorism operations to continue under Operation FREEDOM’S SENTINEL (the U.S. mission following ENDURING FREEDOM) required a bilateral security agreement granting the United States legal authorization for military operations in Afghanistan after 2014. Without this authorization, U.S. forces would not be able to participate in the mission—and without the U.S. military contribution, there would be no RESOLUTE SUPPORT mission.",{"title":"Layered Security and the Maturation of the ANSF","level":2},{"section":["With assistance from the NATO Training Mission and CSTC-A, efforts to develop the ANSF and their supporting institutions evolved into what ISAF commander General Allen initially termed as a “layered defense in depth,” in which synchronization, redundancy, and ANSF components would complement each other. Over time, the concept of layered defense in depth gave way to the more general notion of layered security.","Dunford formally introduced his layered security concept in March 2013 as an addendum to the ANSF’s Operation 1392, or OQAB. Rather than applying personnel, resources, attention, and intellectual effort to one component of the ANSF, layered security sought to establish coordination across Afghanistan’s security apparatus. According to the concept, the Afghan Uniformed Police, which comprised most of the Ministry of Interior’s conventional police forces, would operate in the population centers, while the ANA would cover the areas beyond those centers. As its name implied, the Afghan Border Police would control border crossing points.","As the layered security concept evolved, it came to encompass local indigenous forces such as the Afghan Local Police (ALP).  A year earlier, in front of the Senate Armed Services Committee, Allen attested to the effectiveness of the ALP by stating:",{"list":["\"What has happened with the ALP is it has created opportunities for large amounts of the Afghan population to reject the Taliban.  And there—there is—there have been some SIGINT [signals intelligence] . . . where Taliban commanders have said, if you can, kill an ALP commander, so an Afghan local policeman who is leading his own tribesmen in that particular village, if you can kill an ALP commander it’s worth 10 coalition soldiers. The Taliban are very threatened by the ALP because the significant terrain, the key terrain in a counterinsurgency, is the human terrain, and the Afghan local police deny the human terrain to the Taliban.\""]},"Layered security protected coalition forces as well as Afghans. Dunford used an analogy of a soccer game to describe force protection under the construct. As the last line of defense, security forces guarding coalition bases equated to goalkeepers. Prior to shooting on goal, the insurgency would have to go through the Afghan Border Police, ANA, and ANP. Even though a skilled goalkeeper would stop most shots, given enough opportunities and time, the insurgents would eventually score. The goalkeeper would have a much better chance of defending the goal if the other lines of defense denied the attacker opportunities to shoot. Therefore, it was in the best interest of all to develop all the lines of defense equally. The soccer analogy resonated with coalition audiences and encouraged continued engagement by other troop-contributing nations. What remained, of course, was building those relationships among the ANSF.","The layered security concept would undergo a sustained test even as it was adopted. In early 2013, the Taliban announced that its spring offensive KHALID BIN WALEED—named after the great Muslim general from the time of the Prophet Muhammad—would begin on 28 April. The Taliban promised to direct suicide assaults on coalition installations, launch “special military tactics” and “collective martyrdom operations,” and employ “insider attacks” known as green-on-blue attacks. Although ISAF had met previous spring offensives with intense summer campaigns, recent developments prevented similar action in 2013. The 33,000 additional military personnel deployed to Afghanistan as part of the 2010 surge were now largely gone. The wholesale departure of foreign troops convinced the Taliban that efforts to discredit coalition and ANSF security gains would produce greater dividends at less cost than in the recent past. As a result, the Taliban sought to reassert itself within the Pashtun-dominated south and began to expand its footprint in the east while also making a long-deferred appearance in the west. At the same time, the Taliban sought to influence the domestic political climate of ISAF-contributing nations and dissuade Afghans from supporting the Karzai government by launching multiple, high-profile attacks in Kabul.","Taliban efforts in early 2013 thus focused on gaining tactical advantage over the ANSF and moral ascendency over the Karzai government before the 2014 elections. Although the Taliban’s spring offensive did not begin until 28 April, 2,331 attacks were recorded during the first four months of 2013, a figure that exceeded the previous year’s total for the same period by 47 percent. In addition to launching more attacks, the Taliban targeted ANSF personnel rather than coalition forces. In the first quarter of 2013, the Taliban and its associates killed 1,183 Afghan soldiers, compared to 841 during the same period in 2012. In a related development, coalition fatalities fell from 183 (135 U.S.) during the January–May period in 2012 to 66 (53 U.S.) over the same period in 2013.","Recognizing the threat that the ALP posed, the insurgents focused their attacks on Afghanistan’s auxiliary forces, which suffered disproportionate casualties in the 2013 fighting season and continued to receive the brunt of attacks through 2014. In spite of the Ministry of Interior’s difficulties sustaining the ALP, its formations prevailed against the insurgency even in the face of high casualties, and even had spikes in recruitment following those attacks. Even as the ALP faced increased attacks, it remained an integral element of the layered security concept, which envisaged relationships among ANSF that enabled the whole to be greater than the sum of its parts.","Given that most ANSF senior leaders had once fought as tribal or militia chieftains, the need for unity of command was pronounced. ISAF’s advocacy of a layered security construct was a critical factor in improving the coordination at the ministerial level and among the ANA, ANP, and Afghan Border Police on the ground. The layered security construct broke the competition that existed among components of the ANSF. It also promoted national unity."]},{"title":"Balancing Priorities: Security Force Assistance versus Retrograde","level":2},{"section":["Whereas most American troops who had deployed to Afghanistan in 2012 understood that they had to ready Afghan security forces for independent operations while preparing to downsize ISAF presence, incoming personnel in 2013 faced an even more complex situation. The CENTCOM Materiel Recovery Element reduced the burden of base closing, but incoming units still had to assist their Afghan army or police counterparts to secure the Afghan population. The units also still had to defend against Taliban and Haqqani attempts to disrupt their operations.","The fact that fewer Americans could provide security assistance to the ANSF meant that incoming U.S. units often found themselves nested within progressively larger Afghan formations. When the 140 soldiers of Capt. Benjamin E. Scott’s Company A, 1st Battalion, 506th Infantry Regiment, 101st Airborne Division, arrived at Assistance Platform CHAMKANI in April–May 2013, they occupied a small portion of a sprawling Afghan installation. CHAMKANI also housed the 7/1 ANA Kandak, the 2/2 Afghan Border Patrol Battalion, a National Directorate of Security office, district-level Afghan Uniformed Police, and Afghan Local Police. In addition, an explosive ordinance detachment team, several Air Force joint terminal attack controllers, a female engagement team, the battalion surgeon, and two howitzers from 4th Battalion, 320th Field Artillery Regiment, were located with Captain Scott’s company. On any given day, the troops under Scott’s command performed force protection duties, mentored ANA soldiers, conducted partnered operations with the Afghan Uniformed Police, fired counterbattery missions against insurgent rocket and mortar teams, worked with the Afghan chain of command to coordinate local operations, inventoried equipment for transfer, or interacted with their own battalion headquarters.","The priority task for the first several months of Company A’s deployment was to train the ANSF by conducting partnered planning and operations. Each of Scott’s platoons was partnered with an Afghan company, though the requirements of other missions prevented them from working with their counterparts daily. Tactical instruction focused on improving individual skills, with emphasis on map reading and marksmanship, while also teaching collective skills such as squad or platoon battle drill and employing the crew-served weapons organic to an infantry company. During partnered operations, the Americans taught planning procedures, orders briefs, and mission rehearsals in lieu of maneuver-oriented skills. The training and partnered operations were aimed at preparing 7/1 Kandak for a multiweek, ANA corps-level mission in RC East. The 203d Corps conducted the mission, designated Operation SEMOURGH, in Logar Province during early August. After three weeks of fighting, Afghan forces succeeded in bringing in humanitarian aid to Azrah and Jaji Districts, securing the Azrah district center, and delivering registration materials for the 2014 national elections.","Captain Scott’s company discovered that mentoring the ANA was simple compared to ridding CHAMKANI of equipment that had accumulated on the post after five years of American troop rotations. This equipment could not be turned over to the Afghans because it exceeded the items authorized for 7/1 Kandak. Because Assistance Platform CHAMKANI was being transferred to the Afghans rather than reoccupied by another U.S. unit, Company A had to turn in 1,000 theater-specific pieces of equipment valued at $30 million. Scott had to modify his own supply procedures to reduce consumables before his unit departed. In addition to his own resources, Scott could count on assistance from the 101st Airborne’s 4th Brigade Combat Team’s support battalion. The logistical specialists from this unit planned to transfer equipment to Forward Operating Base GARDEZ using M1120 Heavy Expanded Mobility Tactical Truck Load Handling Systems, each carrying a shipping container with a second container towed behind the vehicle. Items slated to be retrograded filled seventy containers and required five M1120 trucks towing trailers making seven trips between GARDEZ and CHAMKANI and airlifts to move sensitive equipment. All equipment was sequenced for movement to ensure that mission-essential items would leave on the last convoy.","Backhauling equipment to GARDEZ began with equipment boxes lifted out by six CH–47 Chinooks. Loading and flying took place at night to minimize opportunities for the Haqqani to engage the helicopters. The final airlift, which included a pair of howitzers and two containers of ammunition, was deferred until the day the Americans permanently left the base. A base-closure assistance team provided expertise on force protection, preventative medicine, ordnance disposal, and commodity reduction. The property transfer culminated with Scott signing over $400,000 worth of equipment to 7/1 Kandak.","The final and most dangerous phase took place when oversized items were trucked from CHAMKANI to GARDEZ. The convoy consisted of sixteen cargo trucks, including ten Afghan-operated commercial tractor trailers, escorted by forty-four other vehicles. As the Americans disassembled the tethered surveillance aerostat and tower-mounted cameras, they positioned a thermal sight-equipped outpost overlooking their base while reconfiguring internal barriers to create a 360-degree defensive perimeter. After waiting three days for the weather to allow close air support and predator unmanned aerial vehicles to maintain station over the route, the ground convoy departed from CHAMKANI during the early morning hours of 4 October 2013. Despite constant overhead aerial support and 155-mm. artillery fire missions against suspected ambush positions, a Haqqani recoilless rifle team scored a direct hit on an engineer MRAP, wounding four Americans. The injured soldiers were evacuated by helicopter, and the convoy exited the ambush without further incident, arriving at its destination before dark.","Just before midnight on 5 October, Chinook helicopters airlifted the two howitzers, two mortars, and all four gun crews from CHAMKANI. Within three weeks, Scott’s company began working with the rest of 1st Battalion, 506th Infantry Regiment, to close the massive forward operating base at GARDEZ. Continuing with the orchestrated retrograde plan, elements of the 101st Airborne Division departed GARDEZ on 24 November 2013, transferring to Forward Operating Base SHANK in Logar Province for a short stay before returning to Fort Campbell in early December.","Although ISAF remained focused on advising in 2013, the fact that it was shrinking in size complicated its task. The advisory teams assigned to ANA kandaks, now designated as Security Force Advise and Assist Teams, averaged just nine personnel, all of whom instructed the Afghan kandak headquarters rather than accompanying infantry companies outside the base. In addition, more units and fewer advisers meant that junior U.S. and coalition officers were routinely assigned to mentor Afghans older and more senior to them.","One member of a newly deployed advise-and-assist team working with 1/1 Kandak in Paktiya Province during this period observed:",{"list":["Our initial attempts at training the Afghans were largely unsuccessful. . . . First, our mission was to train ANA officers and NCOs, but we had no authority over them. Second, our ability to incentivize constructive change with support or equipment began to disappear as the United States began drawing down its forces and limiting how much its ground forces could get involved in operations the ANA interpreted this as a lack of effort and competence on our part."]},"The teaching methods adopted by advisory personnel, who often lacked specific guidance and tailored programs of instruction, were counterproductive during this period. Far too many teams wasted time attempting to impart U.S. doctrine to unreceptive Afghan counterparts before switching to other methods. As a result, many advisory teams achieved only incremental success, such as convincing a kandak mortar platoon to make firing calculations using a portable laptop or showing an Afghan kandak how to deploy its companies in an effective cordon."]},{"title":"Operation DRUMBEAT: Cutting the Force in Half by 2014","level":2},{"section":["Although the Unified Implementation Plan was an IJC document, it served as the basis for Operation DRUMBEAT, the plan guiding the retrograde through the end of the ISAF and ENDURING FREEDOM campaigns. Operation DRUMBEAT was the product of the USFOR-A Joint Operational Corps Headquarters, an entity created on 6 June 2012 to streamline command and control arrangements in Afghanistan. The Joint Operational Corps Headquarters allowed select American members of the IJC staff to contribute to U.S. national planning. That arrangement acknowledged the joint command’s separation from ISAF proper while leveraging the intellectual capacity of the V Corps. The ability to work both sides of the ISAF and ENDURING FREEDOM missions paid dividends with Operation DRUMBEAT, which supported the force posture line of operation in the Unified Implementation Plan.","The creation of the Joint Operational Corps Headquarters coincided with the return to a single command and control arrangement for all U.S. logistical forces in Afghanistan. At the creation of USFOR-A, the Army expeditionary sustainment command and its subordinate sustainment brigades had been controlled by U.S. Army Central Command in its role as the Army service component for CENTCOM. That first experiment in a single logistics command and control had ended on 16 June 2010 when all Army forces were transferred to USFOR-A control.","The return to a single logistics command and control arrangement was a by-product of creating the CENTCOM Materiel Recovery Element and the subsequent division of labor necessary to execute the surge recovery. The centralized control necessary to execute logistics across Afghanistan left no latitude for competing priorities of logistical support. Between a tactical commander’s priorities and the retrograde effort, the latter necessarily took precedence. Instead of exercising command of the U.S. logistics organizations in Afghanistan, USFOR-A became a supported unit for U.S. Army Central Command and its efforts to retrograde rolling and nonrolling stock.","The U.S. units and service members executing the Operation DRUMBEAT directive published on 16 June 2013 faced the challenge of maintaining ISAF’s momentum while achieving the force posture milestones directed by national policy. Although the United States did not command other national elements, it provided about 65 percent of the personnel and 85 percent of the materiel to the coalition in Afghanistan, and so other countries naturally would follow the U.S. lead. Before the start of Operation DRUMBEAT, personnel levels had fallen from 91,000 to 68,000 through relatively natural attrition. Rather than curtail units already in theater and send them home early, the DoD chose not to replace units that redeployed at the end of their tours, and repositioned units already in theater to cover any vacancies. The plan to further reduce U.S. forces to 34,000, however, had to balance several considerations. American and coalition forces had to retain enough capacity to ensure that the ANSF remained tactically successful while continuing to wean the ANSF off coalition support.","The consequences of departing theater early varied greatly between the U.S. Army’s active and reserve components. Deployed Army Reserve and National Guard units were mobilized with the expectation of being away from their civilian jobs for a set period of time. Curtailing expected combat tours or, worse, “off-ramping” mobilized units within 180 days of their originally scheduled deployments—both of which were common at the beginning of the surge recovery—created major administrative difficulties for the soldiers involved. In an effort to mitigate the disruptive consequences of these practices and to ease reintegration into civilian life, the Army published an execution order detailing the administrative requirements for units that were curtailed or off-ramped.","The challenge of reducing U.S. troops to 34,000 was known long before the release of the Operation DRUMBEAT directive. Withdrawing forces required accelerating retrograde, disposal, and base closure efforts while improving “asset visibility,” which is the process of identifying documented and undocumented military equipment in Afghanistan. Maj. Gen. William E. Rapp’s target goal of 1,250 pieces of rolling stock and 1,000 containers per month was still the prevailing guidance. With DRUMBEAT, the retrograde and redeployment pace accelerated in what was called the “R2 Surge” that started in September 2013 and lasted through January 2014. Exceeding monthly targets during those five months cleared much of the theater before the start of the 2014 fighting season and the transition of security force assistance.","By the end of 2013, the R2 Surge actually had increased retrograde capacity beyond the specified targets to 2,975 pieces of rolling stock and 3,300 containers a month. The increased capacity was due solely to multimodal transport. Some equipment did exit theater along the Pakistan ground lines of communications, but the route remained unpredictable. Throughput along the lines stalled when a protest against U.S. drone strikes in the Khyber Pakhtunkhwa Province of Pakistan closed northern routes. The protesters, led by politician and former cricket player Imran Khan and his Pakistan Tehreek-e-Insaf party, blocked the roads with the support of the Khyber Pakhtunkhwa provincial government. More than 10,000 protesters stopped vehicles carrying cargo for ISAF to protest the 1 November 2013 death of Hakimullah Mehsud, the self-proclaimed emir of the Pakistani Taliban who reportedly had been killed by a missile launched from a remotely piloted aircraft."]},{"figure":{"source":"/figures/v2/img_12-3.png","caption":"MRAPs and other vehicles at Bagram’s Camp Warrior retrosort yard"}},"The blockade of the Khyber Pakhtunkhwa route backlogged vehicles and containers at holding yards in eastern Afghanistan. Logisticians at CENTCOM and U.S. Transportation Command responded by developing enhanced options in December 2013 to clear the backlog, which included increasing multimodal lift and shifting cargos to the southern Pakistan route through the Spin Boldak border-crossing point. The latter option required moving cargo from the northern route along Afghanistan National Highway 1 to Kandahar. Such a route was hardly tortuous, but nonetheless it was not a straightforward replacement for the blockaded route. The enhanced options were extraordinarily successful, retrograding 3,000 vehicles in only two months. By February 2014, the cargo backlog along the routes had been cleared in its entirety while backlogged containers at holding yards in eastern Afghanistan were repositioned at Bagram for multimodal movement.",{"title":"The Retrograde Gains Momentum","level":2},{"section":["As part of the enhanced options, the deputy commanding general of the 1st Support Command (Forward), Brig. Gen. Duane A. Gamble, had established a “channel flight” or regular air rotation between Kuwait and Afghanistan. Channel flights allowed certain retrograde functions such as sorting cargo and customs clearance to be done in Kuwait. Assets in Kuwait included the 595th Transportation Brigade, a subordinate unit of the U.S. Army Surface Deployment and Distribution Command, and the 402d Army Field Support Brigade, a forward-deployed U.S. Army Sustainment Command unit.","To reduce the property that had to be shipped or destroyed, the Defense Logistics Agency conducted a “white goods” sale on 28 June 2014 at Bagram Air Base. Unlike excess defense articles, white goods were foreign excess personal property such as usable nonmilitary vehicles, appliances, and furniture. In addition to reducing the retrograde load, the sale stimulated the Afghan economy. Because it recouped value that otherwise would have been lost in scrapping or disposal, the sale generated goodwill with the Afghan government and local businesses and demonstrated good stewardship of taxpayer dollars.","In March 2014, USFOR-A determined that leaving behind only the materiel required for the Resolute Support mission meant that it had to reduce on-hand quantities to about 11,000 pieces of rolling stock and containers by 1 August 2014. The reopening of the Pakistan ground lines of communications, as well as the continued channel flights, enabled USFOR-A to meet this goal by 29 July 2014 and reduce further to 10,350 vehicles by 9 August 2014. The command had to plan carefully so retrograde velocity would not adversely affect operational capacity.","From the start of Operation DRUMBEAT on 1 June 2013 to the end of Phase II on 1 February 2014, logisticians throughout the Afghan theater had met all their goals. They did this in spite of difficulties with the northern route through Pakistan, which did not reopen fully until 27 February 2014, after the Peshawar High Court ruled that the protests by Imran Khan’s Pakistan Tehreek-e-Insaf party were illegal. Of the 158 bases open in June 2013, USFOR-A and ISAF had closed 70, removing all buildings, eliminating all explosive material, and remediating all environmental hazards. The force was also able to redeploy, retrograde, or divest 11,600 pieces of rolling stock, about 55 percent of the original number. More impressively, it had moved more than 1,000,000 pieces, or 2,900 containers, of nonrolling stock, leaving 674,000 pieces, or 1,900 containers. The number of cargo containers in the Afghan theater was reduced by almost 60 percent. The collective efforts of the USFOR-A team and supporting agencies enabled ISAF and ENDURING FREEDOM to meet or exceed all of their redeployment, retrograde, divestiture, and base closure goals. Now the coalition was well-postured to begin the most sweeping change it had yet undertaken in its operational approach."]},{"title":"Functionally Based Security Force Assistance","level":2},{"section":["Despite its importance to the termination of Operation ENDURING FREEDOM and the ISAF mission, the change from counterinsurgency to stability operations was not recognized immediately in the force. The change in mission marked the first time that ISAF had taken as its primary role security force assistance rather than combat operations. To make this transition work smoothly, ISAF needed to fully restructure not only its force but also its organizational culture.","The vehicle for that change was an evolving process, eventually called functionally based security force assistance, spanning from mid-2011 to late 2014 to reach its final form. Because NATO had no approved plan for advancing the advising mission, General Allen’s 2011 security force assistance concept had served as a stopgap. In the absence of established procedures, ISAF forces needed guidance on how coalition forces would transition from combat to advising.","${Reorganizing the Headquarters for Security Force Assistance}{bold}","With the change in focus from counterinsurgency operations to security force assistance, ISAF headquarters became responsible for many of the functions held by the NATO Training Mission–Afghanistan. The two outgoing change of command ceremonies held on 4 September 2013 for Lt. Gen. Kenneth E. Tovo, commander of both the NATO Training Mission and CSTC-A, were the first visible movements toward that end. When Maj. Gen. Kevin R. Wendel assumed command of CSTC-A from Tovo, it marked the organization’s separation from the NATO Training Mission and ended its responsibility for combat-advising the ANSF conventional forces. At the same time, USFOR-A retained command over Wendel’s formation, because the latter disbursed U.S. security assistance funding to the Afghans.","Wendel also assumed the duties of the newly designated ISAF deputy commander of the Ministerial Advisory Group. This role had two sets of oversight responsibilities. First, Wendel worked with the advisers to the defense and interior ministries and maintained liaisons with the nonsecurity ministries, including the Ministries of Finance, Education, Justice, Public Health, Commerce and Industry, and Communication and Information Technology. Second, he provided advisory oversight of functional enterprises, including human resource management, sustainment, strategic plans and policy, and most notably, inspector general transparency, accountability, and oversight. In addition to these tasks, Wendel was responsible for integrating, coordinating, and synchronizing the critical security force assistance tasks for ISAF.","The full scope of oversight duties for CSTC-A, particularly for fiscal support to the ANSF, required significant expertise in acquisitions and fiscal matters. A deputy command position was established to oversee this critical function. The first deputy commanding general of CSTC-A to serve in that capacity after the training headquarters split was Maj. Gen. Harold R. Greene, a career Acquisitions Corps officer. While Wendel and his staff were looking outward to manage outreach to the ANSF, Greene was looking inward to ensure that the United States and other donor nations provided the ANSF with proper resources through the Afghan Security Forces Fund, security assistance and foreign military sales, contracts, and infrastructure support. The second change of command passed the NATO Training Mission and its oversight for combat advising of the conventional ANSF to Maj. Gen. Dean J. Milner, a Canadian officer who had served as deputy commanding general of the III Corps under Lt. Gen. Mark A. Milley. Under this new arrangement, NATO Training Mission–Afghanistan was subordinated to IJC—a fortuitous development—as the III Corps was the unit providing the nucleus for both headquarters. Milner would once again work for Milley, whose III Corps had succeeded Terry and his V Corps. Under IJC, Milner and his NATO Training Mission were responsible for training, advising, and assisting the ANSF to develop their training, logistics, and medical institutions to support the creation of a sustainable and increasingly professional ANA and ANP capable of protecting the population and denying safe haven to the enemies of Afghanistan. Rather than the previous focus on advising at the brigade and below level, the training mission supported ANSF institutional training centers for their branches of service, as well as in sustainment, police, and combat health support.","In his visualization of the remaining ISAF campaign, Dunford described a “single battle” of security force assistance from the ministerial level down to the kandak level. The notion of single battle came from Marine Corps doctrine, in which a commander would plan centrally and then execute the plan in a decentralized fashion while viewing the area of operations as one indivisible entity. The single-battle concept was intended for a Marine Air-Ground Task Force, but it aptly described Dunford’s vision for the ISAF campaign, in which previously disparate efforts would have to be tied into preparing Afghan ministries and ANSF for RESOLUTE SUPPORT.","To help unity of effort and provide technical assistance to those implementing General Dunford’s guidance, a security force assistance fusion cell began operations under Wendel’s oversight on 27 January 2014. This cell was an instrument for transforming ISAF from a headquarters overseeing counterinsurgency operations to one overseeing stability operations. It served as the secretariat for all of the functionally based security force assistance staff functions and was the focal point for coordination among all related activities.","Instead of relying on the previous pillars of security force assistance outlined in the campaign plan, General Dunford directed Wendel to develop a new organizational design for supporting the Afghan security ministries and increasing ANSF self-sustainability. From 21 to 26 March 2014, the security force assistance fusion cell developed a definition of self-sustainability and, more importantly, eight essential functions that shifted focus to the ministerial level. The release of these eight functions on 26 March 2014 occurred with only 280 days left in the ISAF campaign. Dunford, recognizing that a revision of COMISAF (Commander ISAF) Operational Plan 38302 would require approval by the North Atlantic Council, published the changes in guidance to the force through fragmentary orders. Changing the battle rhythm was a deliberate attempt to change the culture of the organization. It was also a consequence of the inexorable flow of equipment and personnel out of Afghanistan in 2014 and the considerable reorganization of the force itself in its last year.","${Reorganizing the Force for the New Mission}{bold}","The first major reorganization of ISAF toward the RESOLUTE SUPPORT mission, which resulted in the split of NATO Training Mission–Afghanistan and CSTC-A, also included a realignment of the command. The rationale for this realignment was to better posture systems and processes for the advisory missions in accordance with the eight essential functions of functionally based security force assistance. The distribution of missions previously held under the training commands resulted in a completely reorganized ISAF headquarters. The magnitude of the changes that occurred in the ISAF staff and subordinate commands starting on 1 July 2014 was a testament to establishing ISAF as a command that focused primarily on security force assistance.","On 1 July 2014, NATO Training Mission–Afghanistan cased its colors for the last time and was deactivated, with its personnel and functions becoming the CJ–7 (Training and Exercises) staff section within ISAF headquarters. Simultaneously, the title of deputy commander of the Ministerial Advisory Group ceased to exist, leaving Wendel solely with his duties as the commander of CSTC-A. This reorganization codified a number of changes that had been proposed in late 2013 to set the command for the RESOLUTE SUPPORT mission. First was the change of the security force assistance fusion cell into a more expansive Security Force Assistance Center working directly under ISAF. The ministerial advisers who had been part of General Wendel’s groups moved into the ISAF headquarters and picked up advisory roles to the ANSF. Rather than having dedicated advisers, the intent was for the principal staff and their subordinates to double as the ISAF battle staff and as advisers to their Afghan counterparts in the Ministry of Interior, the Ministry of Defense, and the ANA General Staff.","External to the ISAF headquarters, Special Operations institutional training was overseen by the NATO Special Operations Component Command–Afghanistan, commanded by Maj. Gen. Edward M. Reeder Jr., who had five previous Operation ENDURING FREEDOM rotations at multiple levels of command. Air institutional training was overseen by NATO Air Command–Afghanistan, under the command of U.S. Air Force Maj. Gen. Kenneth S. Wilsbach, who also commanded the 9th Air and Space Expeditionary Task Force–Afghanistan.","From 2003 to 2014, ISAF had divided its area of operations into regional commands, which were usually divisional headquarters led by a one- or two-star general officer. Up to 2013, the mission of regional commands had been to control operations at the tactical level, although this singular focus was modified when the United States started deploying security force assistance brigades instead of combat brigades as part of the surge recovery. These headquarters controlled combat forces and also oversaw NATO Operational Mentoring and Liaison Teams in their areas of operation after TF PHOENIX disestablished in 2011. They later added embedded training teams and police mentoring teams.","The regional command structure worked well for overseeing combat operations, but fundamental changes were needed once modular brigades augmented for security force assistance began arriving in theater. By the end of the surge in August 2011, the prevailing philosophy in the campaign— encapsulated in the informal motto “shona ba shona” (shoulder to shoulder)—was that coalition forces were to be partnered fully with their ANSF counterparts. The change to security force assistance in Revision 6 to Operational Plan 38302 shifted the underlying philosophy again to Afghans taking the lead with coalition forces in a supporting role."]}],"chapter 13":[{"title":"ENDURING FREEDOM Becomes Resolute Support"},{"section":["The final three years of the ISAF and Operation ENDURING FREEDOM campaigns presented one of the most difficult challenges faced by the coalition and its leaders during the entire conflict. Changing the mission from counterinsurgency operations to security force assistance while simultaneously withdrawing the force was difficult enough. The chaotic policy environment that characterized the last two years of the conflict made closing out the campaign even harder."]},{"title":"A Campaign in Transition","level":2},{"section":["One factor that hindered ISAF in transitioning to Resolute Support was the ambiguity of national policy in terms of ends, ways, and means. Delays in signing the Bilateral Security Agreement and the NATO Status of Forces Agreement, combined with the lack of a substantive policy decision, resulted in incomplete campaign guidance and orders. Operational Plan 38312 for RESOLUTE SUPPORT and Operational Plan 1710–14 for Operation FREEDOM’S SENTINEL could not be updated and published with a clearly articulated end state to operations in Afghanistan. Uncertainty over what forces would be available beyond 2014, a direct outcome of the U.S. policy debate, contributed to that ambiguity. Absent clarity, any campaign planning for the post-2014 mission was at best an estimate.","Although President Barack H. Obama had announced that 9,800 U.S. personnel would remain in Afghanistan following the end of Operation ENDURING FREEDOM, some senior officials within the administration continued to press for a much smaller residual force. They proposed that the total of 9,800 personnel could be a starting point, with the desired final number of residual forces being 1,000 officers and enlisted personnel operating from a single base near Kabul. General Joseph F. Dunford Jr.’s replacement, General John F. Campbell, would spend months championing the need to stick to the original target for residual forces and convinced the White House and key members of Congress not to reduce the 9,800 figure before his departure from command. The decision to maintain agreed-upon post–ENDURING FREEDOM troop levels did not come easily given Obama’s pledge to withdraw all U.S. forces by the end of his second term.","Even if there had been complete certainty on the campaign objectives and force structure beyond 2014, getting the right people for the job still remained a challenge. It had not been difficult to choose and train advisers for duty with ANA tactical units from among the large number of eligible individuals, but the same could not be said for advisers responsible for aiding Afghan defense ministry officials. The number of qualified individuals was much smaller because the U.S. Army itself had fewer positions calling for specialized knowledge in strategic planning, large-scale logistics, programming, and budgeting compared to the number of soldiers familiar with leading companies, battalions, and brigades. The former set of responsibilities normally was assigned to selected officers and civilians midway or later in their careers, while all officers had to pass through the crucible of command before advancing to senior ranks. In addition, a number of installations and units were able to provide multiweek advisory-related courses for officers and enlisted soldiers, whereas it required a year or more of specialized education at dedicated learning institutions to provide similar levels of training to ministerial-level advisers. The Army’s ability to generate ministerial-level advisers thus had to contend with limited numbers of qualified individuals within its ranks as well as an equally constrained ability to generate more of them. The confluence of all of these factors meant that more work would be needed to translate unclear policy through military strategy and meaningful operations. Without a coherent strategy, the spirit, blood, and treasure spent in Afghanistan would be for naught. In spite of the extensive efforts to adapt operations and logistics in Afghanistan to the challenges of the ENDURING FREEDOM and ISAF campaigns, the future of Afghanistan, even with forces set for Operations FREEDOM’S SENTINEL and RESOLUTE SUPPORT, remained uncertain."]},{"title":"Competing Demands in the 2014 Fighting Season","level":2},{"section":["Although the Taliban had halted most of its large-scale efforts to oppose ISAF on the battlefield after the American-led surge, it had not been defeated. Opposition groups had sufficient resources and motivation to continue military operations against ISAF and the government of Afghanistan. Foremost among these groups was the Haqqani Network, whose operators and facilitators had survived the surge by focusing their energies on discrete suicide operations with high payoff and minor cost in lives and property.","The Taliban, meanwhile, was embroiled in an internal power struggle that unfolded largely out of public view. An earlier conflict had developed between Mullah Abdul Qayyum Zakir and Mullah Akhtar Mohammed Mansour to replace Mullah Mohammed Omar’s top deputy, Mullah Abdul Ghani Baradar. The new struggle began when Omar mysteriously died in the summer of 2013. After a two-year power struggle, Akhtar Mansour emerged as the Taliban’s de facto leader. In the process, he recommended ties with the Haqqani Network, choosing two deputies from the Haqqani leadership. This decision was important as the Haqqanis had become somewhat disconnected from the Taliban fight in the south. Bringing Haqqani members and influence into the Taliban’s core leadership channeled the network’s military actions in ways that supported the Taliban’s goals to discredit and undermine the Kabul regime while striking at significant American targets.","Turmoil within the Taliban was not readily apparent in its announcement that the 2014 spring offensive KHAYBAR (named after the Battle of Khaybar, in which Muslim forces led by the Prophet Muhammad overcame a Jewish stronghold in CE 629) would begin on 12 May. ISAF personnel and facilities topped the list of Taliban goals for 2014, which included eliminating “foreign invaders and their backers under various names like spies, military and civilian contractors and everyone working for them like translators, administrators and logistics personnel.” In addition, the Taliban targeted members of the Afghan government such as cabinet ministers, members of Parliament, Interior and Foreign Ministry officials, agents in the National Directorate of Security, and attorneys and judges involved in criminal trials for captured Taliban.","The Taliban claimed it was prepared to utilize “various modern military technique[s],” such as “martyrdom strikes” (suicide attacks and bombings), “infiltrator operations” (insider or green-on-blue attacks), and “head-on offensive operations against enemy gatherings” (attacks on ISAF installations). The Taliban released a list of potential targets for 2014 that included foreign and Afghan bases, “diplomatic centers,” military and civilian convoys, and other “facilities of foreign, interior, intelligence and Arbakai [local] militia.” The reference to the last organization attested to the success of Village Stability Operations. Although the Taliban did not threaten to disrupt the June runoff election—suggesting that such an undertaking would have exceeded its current capabilities—the 2014 announcement made it clear that the Taliban would actively exploit any emerging vulnerability as the ISAF drawdown continued.","The Afghan presidential and provincial council elections would be the biggest tests for the ANSF in 2014. The ANSF had successfully provided security to campaign rallies, but both they and the coalition anticipated high-profile attacks in an attempt to undermine the elections. On 20 March 2014, two weeks before election day, the Taliban attacked the Serena Hotel in Kabul, a popular spot for foreign visitors, killing nine civilians, four of whom were foreigners. That attack came a day after the Taliban conducted a complex attack on a police station in downtown Jalalabad, near the Nangarhar governor’s residence, and two days after a suicide bomber killed sixteen people in a market in Faryab Province. In spite of these events, the Afghans continued to carry on their daily business, an optimistic trend for the election.","The 2014 fighting season was the first in which the ANSF took the lead for security operations. Leaders at ISAF and its subordinate headquarters, anticipating increased election security requirements and reduced coalition visibility during the election period, slowed the pace of retrograde accordingly. The intent was that the capabilities required to support the ANSF would be available through the end of the 2014 fighting season, then retrograded after the election was complete. The Taliban tested the ANSF by launching massed assaults against isolated checkpoints and outlying government centers. Although the attacks often succeeded, the insurgents invariably failed to hold onto their gains. Overall, the ANSF continued to demonstrate tactical superiority over insurgents with some assistance from United States and coalition partners throughout the presidential elections and the fighting season.","When the Afghan people went to the polls on 5 April 2014, less ISAF support was required than expected, even in light of numerous security incidents throughout the day. ANSF operations to disrupt the Taliban prior to the election, along with a comprehensive security plan for the election itself, ensured that no major attacks succeeded and that the 2014 elections saw less violence overall than in the 2009 presidential and the 2010 provincial elections. Even with the high voter turnout, neither Ashraf Ghani nor Abdullah Abdullah, the two leading presidential candidates, was able to secure a decisive victory with more than 50 percent of the vote."]},{"figure":{"source":"/figures/m/map-figure-13-1.svg","caption":"Force Laydown January 2014","prefix":"MAP"}},"The ANSF protected the candidates and voters leading up to and during the April election, and did so again less than two months later when Ghani and Abdullah competed in a runoff election. More than seven million voters participated in this second round. After credible reports of significant irregularities voided the 14 June runoff, the Afghan Independent Election Commission declared Ghani as Hamid Karzai’s official successor on 21 September. That same day, Ghani announced that he would form a national unity government, with Abdullah holding the newly created post of chief executive. Though initial reports suggested that insurgents had attempted approximately 300 attacks during the June election, along with 351 incidents during the April election, the Taliban was unable to disrupt either event. Throughout the process, U.S. forces limited their involvement to transporting ballots to an audit location where ANSF provided security for the actual counting.","Although the ANSF had succeeded in protecting the runoff election, the fighting continued throughout the year. On 21 June 2014, the Taliban caught the ANSF off guard with an offensive in the Sangin and Now Zad Districts of Helmand Province. Despite the surprise attack, the ANA and Afghan Uniformed Police in those districts were able to regain lost territory before the end of July, preventing the Taliban from holding key terrain. Support from RC South was limited to intelligence, armed helicopter escort for medical evacuation flights, close air support, and advisory support. The ANSF conducted virtually all of the ground combat operations.","By the end of summer 2014, the ANSF were on track to assume responsibility for all conventional and Special Operations missions, many of which were already being conducted solely by Afghans. The successes experienced by the ANSF came at the expense of the retrograde velocity that had accelerated over the winter and decelerated for the fighting season. With only a few months left in ENDURING FREEDOM, USFOR-A focused on clearing the theater in time for the transition to RESOLUTE SUPPORT.","The retrograding success that the United States and its coalition partners had achieved through the 2014 fighting season meant that Operation DRUMBEAT was already about 80 percent complete by the beginning of the fourth and final phase of the plan. Coming out of the surge recovery in January 2012, USFOR-A was responsible for 396 bases, 48,677 pieces of rolling stock, 26,816 containers of equipment, and 78,000 contractors. From the start of DRUMBEAT on 1 June 2013 to its conclusion at the end of 2014, USFOR-A and its coalition partners had closed or transferred 189 bases. They transferred, shipped home, or destroyed 24,450 pieces of rolling stock, 1,794,450 pieces of nonrolling stock (5,300 containers), and 80,900 cargo containers. During the same period, the command reduced the number of civilian contractors in Afghanistan by 45,900 personnel. Commanders and staff balanced downsizing force activities with retaining the capabilities needed to continue advising the ANSF. In most cases, the requirements had reduced to the degree that remaining forces would be able to perform those duties. In some cases, requirements no longer existed and the organizations to which they were assigned were repurposed or withdrawn altogether.",{"figure":{"source":"/figures/v2/img_13-1.png","caption":"ANA Commando directs ANA Soldiers"}},{"title":"From Regional Commands to Train, Advise, and Assist Commands","level":2},{"section":["By 30 September 2012, coalition troop levels had reduced from their surge strength of 134,000 to approximately 107,000. A year later, the total ISAF number had shrunk to approximately 65,000, with the U.S. presence in Afghanistan down from 68,000 to just over 39,000 personnel. By October 2014, short of ISAF’s full reorganization, ISAF end strength was just over 34,000 personnel, with American forces constituting approximately 24,000 of that number.","In order to decrease the number of American personnel serving in Afghanistan, tactical units were redeployed to the United States without replacement. With the expanded ANSF assuming greater responsibility for operation planning and execution, U.S. soldiers and marines were no longer needed in the same numbers as before. Although the Bilateral Security Agreement did not stipulate a particular echelon for advisory efforts, the Resolute Support mission eliminated all tactical-level advising except that conducted by special operators working alongside the Afghan Commandos. As a result, advisers from conventional units were withdrawn from every echelon of command below ANA corps.","Coincident with the reduction in force, ISAF began to replace regional commands with train, advise, and assist commands, which ended the military’s practice of appointing battlespace owners. These train, advise, and assist headquarters, which were smaller than the regional commands they replaced, would be the focal point for developing and improving the ANA corps and ANP regional and provincial headquarters in their areas of operations. Their role hearkened to CTSC-A’s previous Afghan Regional Security Integration Commands, which had been located at the same bases as ANA corps headquarters before NATO had established its training missions.","Train, advise, and assist commands had fewer capabilities than their predecessors. In the conversion, regional commands transferred former functions such as medical evacuation and the collection and processing of battlefield intelligence to IJC, which retained tactical responsibilities. Two aspects of these transfers forced the ANSF to become more self-sufficient. First, authority for the release of coalition combat enablers moved to IJC, making it more difficult to request enablers and less likely that they would be provided. Second, as forces redeployed and countries reduced their presence in theater, those combat enablers became less available to provide assistance, decreasing the probability that the ANSF would be able to call on them for help even in exigent circumstances.","The first regional command to transition to a train, advise, and assist command was the Turkish headquarters serving as RC Capital, which became Train, Advise, and Assist Command–Central on 10 July 2014. Next, the Italian headquarters serving as RC West in Herat became Train, Advise, and Assist Command–West on 16 July 2014. The German headquarters in Mazar-e Sharif serving as RC North became Train, Advise, and Assist Command–North on 1 August 2014. The American headquarters at RCs Southwest, South, and East were the last to transition. Each had been organized around an Army division or a reduced Marine Expeditionary Force command and had overseen the efforts of large subordinate units with many troops. On 14 October 2014, RC South transferred authority to Train, Advise, and Assist Command–South in Kandahar. Maj. Gen. Paul J. LaCamera, commanding the 4th Infantry Division, handed over command to Maj. Gen. Michael A. Bills, his counterpart in the 1st Cavalry Division. Bills did not remain in Afghanistan, as command of the newly created headquarters fell to Brig. Gen. Viet Luong, deputy commanding general for maneuver, who remained with a small staff element. In the meantime, most of the 1st Cavalry Division’s staff officers remained at Fort Hood and would rotate with their counterparts in Afghanistan midway through the year."]},{"figure":{"source":"/figures/v2/img_13-2.png","caption":"Joint Patrol"}},"The withdrawal of forces from RC Southwest differed markedly from other areas, as it was the one region where responsibility for ANSF would not transfer to a train, advise, and assist command that would be physically present. On 5 February 2014, authority transferred from II Marine Expeditionary Force (Forward) to the Marine Expeditionary Brigade–Afghanistan. That transfer reduced the grade of the RC commander from major general to brigadier general.","Coalition forces in RC Southwest reduced measurably in early 2014 with the departure of the Tongan, Estonian, Bosnian, and Danish forces. The Georgian and Jordanian missions left a few months later, and by the end of summer 2014 the only forces left in RC Southwest were Marine Expeditionary Brigade–Afghanistan and Task Force HELMAND, formed around the Desert Rats of the British Army’s 7th Armored Brigade.",{"figure":{"source":"/figures/m/map-figure-13-4.svg","caption":"Force Laydown December 2014","prefix":"MAP"}},"RC Southwest conducted its end-of-operations ceremony at Camp Leatherneck in Helmand Province on 26 October 2014, transferring the Bastion-Leatherneck-Shorabak base complex to the 215th ANA Corps on 27 October 2014. It turned over its responsibilities to the Kabul-based Train, Advise, and Assist Cell–Southwest, which had begun operations on 15 July 2014 and achieved full operational capability by the end of October. While not an ideal design, Train, Advise, and Assist Cell–Southwest was able to provide some measure of oversight for the ANSF in Helmand and Nimroz Provinces. A similar cell was formed to support the 203d ANA Corps, which had forces in Wardak, Logar, Paktiya, Khost, Paktika, and Ghazni Provinces. In the wake of Milestone 2013, some risk could be assumed, as all four brigades in 203d Corps and three of the four brigades in 215th Corps had shown promise. The American command rated them capable of planning and conducting joint and combined arms operations with minimal to no coalition assistance. The ANP in those areas received similar ratings.","Unlike other regional commands, RC East, now covered by the 10th Mountain Division under the command of Maj. Gen. Stephen J. Townsend, handled two ANA Corps, two Afghan Uniformed Police Type A (Regional) headquarters, and two Afghan Border Police zones. In addition to the 203d ANA Corps headquarters next to Forward Operating Base LIGHTNING at Gardez in Paktiya Province, RC East was responsible for training, advising, and assisting the 201st ANA Corps, whose headquarters was at Forward Operating Base GAMBERI in Laghman Province, a short drive from Jalalabad, the capital of Nangarhar Province. This arrangement led to the creation of two advising commands forward of Bagram, where the RC East main headquarters was located. The 201st ANA Corps was the responsibility of Train, Advise, and Assist Command–East at GAMBERI. The 203d ANA Corps was the responsibility of Train, Advise, and Assist Command–Southeast at LIGHTNING. Each command was led by a one-star general who also had advisory responsibilities to the ANP and Afghan Border Police. Each was assisted in its mission by a brigade combat team serving as a corps support platform, with tactical forces to partner with ANSF units. More importantly, these commands were able to partner with Afghan enablers such as close air support, intelligence, and logistics.","By 2014, the 10th Mountain Division and 3d Cavalry Regiment were sourcing Train, Advise, and Assist Command–Southwest. As the ISAF footprint continued to shrink, this headquarters ceased operations on 1 October 2014 and transferred to Forward Operating Base LIGHTNING to support the 203d ANA Corps while the 3d Cavalry Regiment moved to GAMBERI to serve as the Train, Advise, and Assist Command–East. Although no longer collocated with 203d ANA Corps, the cavalry had built relationships with their ANA counterparts that would help to bridge advising efforts until Train, Advise, and Assist Command–Southeast could be stood up in Kabul. The experience that RC East established with two advising commands was an invaluable test for how to advise at the regional level before ISAF and its subordinate units were reorganized for RESOLUTE SUPPORT.","On 4 November 2014, the 10th Mountain Division curtailed its deployment to RC East, conducting an early transfer of authority with the 3d Infantry Division. The early relief gave the 3d Infantry Division more time to assume its new requirements. The first requirement was to relieve the 3d Cavalry Regiment of the Train, Advise, and Assist Command–East mission at Forward Operating Base GAMBERI. The second was to provide the personnel for the U.S. national support element at Bagram Air Base, which it inherited from the XVIII Airborne Corps. Maj. Gen. John M. Murray, commanding the 3d Infantry Division, assumed the role of the commander of Joint Task Force 3 and also assumed the responsibilities of deputy commander, USFOR-A, from Lt. Gen. Joseph T. Anderson, the XVIII Airborne Corps commander and previous USFOR-A deputy commander.","The decision not to maintain an advisory presence in the two ANSF units covering the most contested areas of the country had a certain degree of logic to it. The 215th ANA Corps had fought a bitter effort to secure the Helmand River Valley and its surrounding districts while the 203d ANA Corps remained astride territory that the Haqqani Network considered its home terrain. The two corps had displayed their capabilities, indicating that they were better equipped (relative to the rest of the ANSF) to operate independently; therefore, it seemed feasible to withdraw the advisers. However, other practical considerations were in play. Both ANA corps were located in dangerous areas, and to maintain a continued advisory presence in those areas, coalition forces would have needed to retain their bases to provide close air support and medical evacuation. More U.S. personnel also would have had to remain behind to operate and secure those sites. Given the noncombat framing of the RESOLUTE SUPPORT mission, the NATO troop-contributing nations were particularly sensitive to casualties, and they were reluctant to leave their advisers in contested areas where they were virtually guaranteed to make contact with the enemy. As the advisers increasingly left ANA units in southern Afghanistan to their own devices, the Afghan forces suffered from mounting desertion rates resulting from poor leadership, intermittent pay, and inadequate logistics, all of which were compounded by increasing casualties.",{"title":"Consolidating the Task Organization","level":2},{"section":["Another consequence of reducing forces was the elimination of organizations whose roles had been greatly diminished or made redundant as the counterinsurgency mission transitioned. Much like tactical units that left Afghanistan as part of the drawdown, many of the functional headquarters consolidated roles or simply ended their missions. An example of an organization that eventually disappeared was Combined Joint Task Force PALADIN, which had grown as a response to the enemy’s use of IEDs. PALADIN began in 2005 as a counter-IED organization built around a rotational explosive ordnance disposal group headquarters. It had provided expertise and training to coalition forces throughout Afghanistan but reduced its outreach as part of the drawdown. Although CJTF PALADIN was not an ISAF unit, its mission had evolved to encompass training, advising, and assisting the ANSF. On 15 December 2013, Col. Marue R. Quick’s 52d Ordnance Group (Explosive Ordnance Disposal) began to return to Fort Campbell, Kentucky.","One of the outgrowths of the ISAF population-centric counterinsurgency approach was Combined Joint Interagency Task Force 435, which had been established on 24 September 2009 to manage Law of Armed Conflict detention, Afghan rule of law proceedings, biometrics, and advisory functions to Afghan Central Prisons Directorate. The 25 March 2013 transfer of the U.S. detention facility in Parwan just outside Bagram Air Base coincided with signing a memorandum of understanding on detentions that transferred responsibility for the facility and its detainees to the Afghan Ministry of Defense. Although some U.S. authorities for detentions continued through the ISAF mission, many of Combined Joint Interagency Task Force 435’s authorities would end when the Bilateral Security Agreement took effect on 1 January 2015.","When it was disestablished on 1 October 2014, the interagency task force had assisted the Afghans in moving from confessions to evidence-based justice, a critical element of the rule of law. With the task force’s oversight, the Rule of Law Field Force–Afghanistan worked closely with the Afghan ministries and the U.S. Embassy in Kabul to expand Afghan judiciary coverage to provinces and districts. The organization’s remaining missions transitioned to a Rule of Law Development Team to provide ministerial advising in Kabul after Combined Joint Interagency Task Force 435 and the Rule of Law headquarters were disbanded. Besides managing the critical Law of Armed Conflict detention mission, the task force significantly advanced the Afghan institutional capacity in the rule of law, prisons, and law enforcement.","As the force continued to contract, other functions consolidated. One example was the Joint Force Engineer Command–Afghanistan, which had been established in 2009. Its functions were divided between the USFOR-A and IJC headquarters in 2014. Other organizations ceasing operations included the anticorruption Combined Joint Interagency Task Force SHAFAFIYAT in 2010. Those missions merged with another task force on anticorruption in 2013 to create Combined Joint Interagency Task Force–Afghanistan. This short-lived task force quietly disappeared when the ISAF headquarters reorganized in the second half of 2014.","The largest change was the disbanding of ISAF Joint Command on 8 December 2014. The expansion of the ISAF force structure in 2009 had created the need for a tactical corps headquarters to command and control regional commands, while ISAF conducted engagements at the operational and strategic levels. As the ISAF mission evolved under functionally based security force assistance, the functions that had come to be performed by IJC reconsolidated back into the ISAF headquarters.","IJC had significantly more soldiers and marines in Afghanistan than the rest of ISAF by the beginning of the final transition. As part of the shift to RESOLUTE SUPPORT, IJC passed its responsibility for command and control of the ISAF area of operations to a newly reconstituted ISAF Combined Joint Operations Center starting on 1 November 2014. The Combined Joint Operations Center assumed full responsibility for monitoring current operations and exercising command and control of ISAF subordinate units on 14 November 2014.","The XVIII Airborne Corps was the last corps headquarters to provide the troops for both the USFOR-A and the IJC headquarters missions at the same time. On 8 December 2014, a ceremony held at Kabul’s international airport—recently renamed after former President Hamid Karzai—marked the end of mission for IJC and the end of tour for the XVIII Airborne Corps. The mission passed to the 3d Infantry Division at Bagram.","As ISAF shifted to a supporting position in the wake of Milestone 2013, it took on the same challenging role for the upcoming RESOLUTE SUPPORT mission that the now-defunct NATO Training Mission–Afghanistan had faced before. Reorganizing the ISAF headquarters for security force assistance as IJC stood down created three competing demands. First, the ISAF headquarters retained its theater-strategic role as the senior NATO military organization in Afghanistan. Second, ISAF was also creating a new NATO Training Mission of sorts, though its advisory efforts were almost exclusively focused at the Afghan ministerial level. Third, with the disestablishment of IJC, the ISAF headquarters had to reconstitute the capability to exercise tactical command and control that it had divested to IJC in 2009.","The RESOLUTE SUPPORT troop-contributing nations continued to source forces for the mission, augmenting the ISAF Combined Joint Operations Center with personnel, mostly Army officers and senior noncommissioned officers from Train, Advise, and Assist Commands South and East. Those personnel were in excess of post-2014 requirements; nonetheless, they had the skills and grades to bring the operations center to full operating capability. The joint operations center was capable of monitoring tactical dispositions throughout Afghanistan, but much like its parent command, it now had a different role. Finding the people to run the center was not as much of an issue as finding the people who could advise ministerial-level leaders on their national responsibilities."]},{"title":"The Right People","level":2},{"section":["Getting the right people in the right numbers and in a timely fashion was not a new problem in Afghanistan. This issue affected plans as far back as Operation ANACONDA and the original formulation of training organizations. The leading challenge that ISAF now faced in assuming the NATO Training Mission was a lack of expertise for its advisory efforts to build ministerial capabilities. Tactical advisers, which had been in demand until 2012, were relatively easy to locate and acquire, but personnel who had experience in the ministerial-level functions needed to strengthen national ministries were far less common. Individuals with these highly specialized skills were difficult to mobilize, partly because most of them were civilians. Those who could deploy could not provide sufficient coverage, especially considering the extent of the reform needed. Even the U.S. Army, which had more capacity for such functions than its sister services, could not meet the requirements.","In a letter to the CENTCOM Commander General Lloyd J. Austin III, General Dunford outlined the changes that ISAF needed to make to  fill its adviser requirements starting in early 2014. To build the long-term sustainability of the Afghan security ministries and ANSF, the pre-mission training would have to change:",{"list":["This change in focus will require that advisors sourced by CJSOR (Combined Joint Statement of Requirements) 13.5 and CE (Crisis Establishment) 21 are trained to execute the functional SFA [security force assistance] model at the Afghan ministerial level as well as at the Corps/Zone/Region level. As a result, pre-deployment training for SFA teams will need to be updated.","Rather than studying Afghan tactics and maneuvers, SFA teams will require instruction that is oriented towards  Afghan institutional development. . .  "," . . . Additionally, success in Resolute Support will depend on the proper identification, screening,  and selection of personnel to fill advisor positions. I would ask your full support in conveying to the Military Services the importance of sourcing personnel with the correct grade, experience, and skill set for each job."]},"Unfortunately, no solutions were available to provide an adviser force at the institutional level. The uniformed services simply did not have the personnel to fill the requirements for RESOLUTE SUPPORT. The problem was structural in nature. None of the services, the Army included, had established a way to produce officers in sufficient quantities with technical skills in high-level functions such as strategic assessment, strategic planning, or force management, let alone the DoD’s planning, programming, budgeting, and execution processes that provided context for those skills. Such skills could only be built through experience. Furthermore, every adviser deployed with those skills counted against a force cap for uniformed personnel that became immovable by 2013.","Even in the best circumstances, the likelihood of finding an officer who was experienced at the operational and strategic levels outside of the Army’s functional areas was low. In the case of the combat arms, the demand for tactical command and staff assignments in those branches of the Army made it even less likely to locate suitable candidates. Given the competition for battalion and brigade command, there was little opportunity for officers to gain broader experience outside of their career fields where they might gain a sense of policy and strategy. American officers simply did not have enough time in their careers for such assignments. Many coalition members who sent officers to the ISAF staff did not provide these developmental opportunities either, with the exception of a few who might have gained experience by working in their countries’ defense ministries or on their general staffs.","The U.S. Army’s regulatory guidance for commissioned officer professional development went into effect when ISAF recrafted its mission  to security force assistance and identified three foundations for leader development: institutional training, operational assignments, and self-development. Virtually all the key developmental duty positions critical to promotion, and the majority of the developmental and broadening assignments, were at the tactical level. Battalion and brigade command were viewed as prerequisites to be considered for general officer. Officers seeking those positions needed to take repetitive tactical-level assignments to remain competitive. Those who took multiple broadening assignments found themselves at a disadvantage, especially as promotion timelines accelerated to create the ranks necessary for the modular force. The alternative was to pull from the functional areas, but they were smaller than the basic branches. The demand for functional area officers in operations research, systems analysis, force management, information operations, and strategy development far outstripped the supply available.","An alternative source for those skills might have been found in the Army and other services’ civilian workforces. However, in the case of the Army Civilian Corps and other U.S. civil service personnel, no authority could direct personnel to fill critical ministerial advisory positions. It was easy to advertise such positions, but no mechanism was in place to reassign civilians involuntarily to positions in Afghanistan. Civilians who volunteered then had to meet the physical standards to deploy. This was quite often a challenge.","The last source of personnel was contractors, but their employment was also problematic given the changes in legal protections affected by the Bilateral Security Agreement. The jurisdictional limitations written into the Bilateral Security Agreement and the NATO Status of Forces Agreement reflected Karzai’s August 2010 Presidential Directive 62, which responded to allegations of employee misconduct by banning private security companies in Afghanistan. The bilateral and NATO agreements both specified that Afghanistan maintained the right to exercise jurisdiction over U.S. and NATO contractors and their employees, a distinct change from the permissions given under the preceding U.S. State Department Diplomatic Note 202 and the ISAF Military-Technical Agreement. As a result, it was legally risky for commanders to send contractors to work on predominantly Afghan bases located away from urban centers. In addition to potential legal complications, contractors working at isolated locations often encountered significant transportation difficulties.","Even though the rhetoric about the post-2014 mission consistently emphasized its status as a noncombat mission, the environment remained dangerous. The death of Maj. Gen. Harold R. Greene at the hands of a rogue Afghan soldier on 5 August 2014 served notice that the Guardian Angel program could not prevent all insider attacks. Greene, the first U.S. flag officer to die in combat since Vietnam, was killed by gunfire directed at coalition personnel from a barracks window at Camp Qargha’s Marshal Fahim National Defense University in Kabul. Greene and about ninety other U.S. and coalition personnel were visiting the base for an update on its construction projects and a preview of its officer-producing capabilities. At about 1140, the group made an unplanned stop near the military police barracks for a briefing. About fifteen minutes later, an Afghan military policeman, later identified as Rafiqullah, started shooting. The Afghan army claimed the attacker, a Pashtun serving since 2012, had exhibited no signs of anti-American or anti-ISAF sentiments, but the U.S. investigation “indicated he may have had some bias against coalition forces” with “disdain for Americans in particular.”","At the same time, ISAF continued to walk a fine line between encouraging the ANSF to operate independently and letting them fail. Coalition advisers had become accustomed to desperate pleas for assistance, often containing exaggerated estimates of enemy strength or friendly casualties in an attempt to trigger coalition enablers. Nevertheless, ANSF personnel grudgingly learned how to stand on their own. They had been successful throughout the 2014 fighting season, and yet their sustainability was the pivotal question as the ISAF and ENDURING FREEDOM missions came to a close."]},{"title":"Special Operations at the End of the Campaign","level":2},{"section":["As the end of Operation ENDURING FREEDOM neared, U.S. SOF in Afghanistan experienced changes similar to those affecting their conventional brethren. The top priority of CJSOTF–Afghanistan during this period was to build Commando kandaks so that they could assume the missions previously accomplished by ISAF units. The most difficult goal associated with this transition was persuading U.S. Special Operations personnel to allow the Afghans to lead in planning and executing missions. To facilitate the necessary mindset, Col. Patrick B. Roberson, the 3d Special Forces Group, 1st Special Forces Regiment, commander in charge of the combined joint special operations task force from March to November 2013, limited the number of U.S. Special Operations personnel accompanying their Afghan counterparts in the field. When some Americans complained that the Afghans were not as practiced in these tasks as U.S. forces, Roberson explained, “If you want to put the Afghans in the lead, you’re going to have to accept the fact that they are, in some ways, going to be less capable.” By ensuring that Afghans constituted 90 percent of any mission task force, Roberson created a situation where U.S. personnel were forced to assign more responsibility to their Afghan counterparts. As a result, Afghan Commando officers and noncommissioned officers gained experience in tactical planning and mission execution."]},{"figure":{"source":"/figures/v2/img_13-3.png","caption":"ANA Soldiers rest"}},"Ranked immediately below preparing Commando kandaks was turning Village Stability Operations over to Afghan district and provincial officials. The transition involved preparing local police to work with their fellow citizens while showing Afghan officials how to manage the program. The dispersion of local security forces and their unique one-on-one relationships with the American mentors who lived among them added complexity to the transfer. The transition began with consolidating or eliminating some Village Stability Operations sites and continued with transferring the remainder to Afghan security forces. During this phase, U.S. personnel gradually turned over responsibility for training ALP to their ANSF counterparts. As the number of U.S. SOF operational detachments decreased, they transitioned to mounted patrols and circulated among multiple Village Stability Operations locations. The Afghans displayed growing proficiency, so the U.S. SOF personnel incrementally reduced their profile until Afghans owned all platforms and conducted nearly all operations.","The ANSF led nearly all of both conventional and special operations from January to the end of October 2014. The ANSF were generally but not uniformly successful while in the lead. Most promising, they showed resilience after initial setbacks. On the morning of 23 February 2014, Taliban fighters overran an ANA base in Ghaziabad District, near the provincial capital of Asadabad in Kunar Province, killing twenty-one soldiers from 2d Brigade, 201st ANA Corps. The ANA retook the base the same day, using Mi–17 cargo helicopters for air assault and casualty evacuation. Coalition involvement was limited to close air and intelligence support. The Afghan public rallied around the ANA in a large memorial ceremony held in Kabul that week, a resounding indicator of ANSF success.","American Special Operations units and their Afghan counterparts continued to conduct dangerous missions as other ISAF forces retrograded before and after the 2014 Afghan elections. Five Americans, including two soldiers from the 5th Special Forces Group, 1st Special Operations Regiment, and one Afghan Commando were killed on 9 June 2014 by an errant air strike during an intense firefight in the Arghandab District of Zabul Province. The U.S. and Afghan special operators were targeting insurgent groups in advance of the runoff election. The June casualties were followed by more losses as SOF continued to conduct aggressive offensive operations during the last half of the year. The 7th Special Forces Group, 1st Special Forces Regiment, suffered fatalities from enemy small-arms fire during separate combat operations in Helmand and Zabul Provinces in September and December while the 3d Special Forces Group lost one soldier to small-arms fire in Kunduz in November.","Special Operations Task Force–Afghanistan, configured around a core provided by the 3d Battalion, 3d Special Forces Group, under the command of Lt. Col. Michael P. Sullivan, gained responsibility for U.S. SOF in country when CJSOTF-Afghanistan deactivated on 31 December 2014. Sullivan assumed command when the conditions facing SOF in Afghanistan were undergoing significant change. For the first time in more than a decade, the Special Operations geographical footprint aligned with that of conventional forces. While consolidating American units in a few locations and then deploying out to conduct operations eased force protection and logistical burdens, it did not facilitate Sullivan’s mission to conduct ground combat operations against armed groups targeting U.S. troops throughout Afghanistan. Complications arising from consolidating supporting fires, medical evacuation, and logistical assets would hinder the task force’s ability to conduct missions beyond the immediate range of U.S. enclaves.",{"title":"Obtaining Closure","level":2},{"section":["America’s senior commanders in Afghanistan changed once again during this period as Army General John F. Campbell replaced Dunford on 26 August 2014. For the next several months, Campbell guided ENDURING FREEDOM along the established path toward Operation RESOLUTE SUPPORT. Organizational changes associated with the transition included replacing regional commands with the smaller train, advise, and assist commands and merging the IJC with ISAF headquarters so the latter could assume command of all ground operations. These changes occurred in the midst of continuing violence in eastern Afghanistan.","When Campbell told media representatives in fall 2014 that “we’re not out on patrol with the Afghans; they’ve taken over the fight. We’re focused on the systems and processes that they have at the corps level. We’re no longer with the brigades. We’re no longer with the Kandaks,” he was highlighting the rationale behind changes to his command’s physical footprint within Afghanistan prior to ENDURING FREEDOM ending. The total U.S. contribution to RESOLUTE SUPPORT, including both conventional and Special Operations Forces, would not exceed 9,800 personnel. NATO nations added another 2,900 soldiers for a total of 12,700 personnel. Downsizing ISAF dropped personnel numbers and reduced the amount of close air support; intelligence, surveillance, and reconnaissance; medical evacuation; and logistics the coalition could bring to the aid of the Afghans.","A much smaller foreign military presence in Afghanistan would exist, and the remaining troops would be located in just a few key areas  rather than spread across the entire country. As Campbell explained,",{"list":["\"We will have forces in the north, in the west, in the east, and in the south, and then in Kabul center. So we’re going to really  a spoke and hub, and come 1 January, in the east, we’ll have forces in Jalalabad, in Gamberi, in Bagram. In the north, they’ll be in Mazar-e-Sharif, in the west, they’ll be in Herat, and in the south, they’ll be in Kandahar.\""]},"The smaller geographical footprint, coupled with reduced troop levels, meant that ISAF troops would be collocated with only four of the six ANA corps. The advisory needs of the remaining corps were addressed when resources became available or when the tactical situation dictated additional support, albeit on a temporary basis.","Downsizing ISAF reduced the support available to Afghan security forces, and meant that any available resources had to be concentrated on the most dangerous threats. Identifying these threats was a priority given the fragile state of Afghan politics in this period. The highly contested presidential election reflected this fragility, which barely improved with the installation of a National Unity Government that did not address the Afghan government’s inherent structural problems. In addition, the tense election period had presented the Taliban with an opportunity to exploit political divisions within Afghanistan. Aware that the Constitutional Loya Jirga scheduled for 2016 had the authority to alter the power arrangements in Afghanistan by either codifying or invalidating the president/prime minister structure of the National Unity Government further clouded the political landscape.","Although no fewer than six insurgent or criminal organizations sought to destabilize the newly elected administration of President Ghani by launching attacks in Kabul, both ISAF and Afghans considered the Haqqani the most dangerous. CJSOTF–Afghanistan focused on degrading and disrupting this network. ISAF had been waging an intense battle against the terrorist organization for many years, and countering it was now a top priority for coalition forces. In mid-October 2014, Afghan and ISAF troops managed to detain Anas Haqqani, son of the network’s founder, and Hafiz Raschid, a key planner and suicide attack facilitator. Pakistani armed forces provided belated but welcome assistance during summer 2014 when they responded to a terrorist attack against the Jinnah International Airport in Karachi on 8 June by cordoning off several towns in North Waziristan that had provided safe havens for extremists. Government forces initiated Operation ZARB-E-AZB (Swift and Conclusive Strike) with a series of air strikes against terrorist targets, killing dozens of foreign fighters and prompting others to flee toward the waiting Pakistani ground units. After 450,000 civilians were safely evacuated from the area, government troops initiated a sustained series of attacks against the terrorists that continued through fall 2016. In addition to landing damaging blows against the Pakistan Taliban and the Islamic Movement of Uzbekistan, Pakistani counterterrorist operations also disrupted Haqqani infrastructure in the region."]},{"figure":{"source":"/figures/v2/img_13-4.png","caption":"General Hans-Lothar Domröse & General Campbell"}},"On 28 December 2014, General Campbell presided over a ceremony marking the end of Operation ENDURING FREEDOM and the start of RESOLUTE SUPPORT.  Scores of attendees were present to witness the lowering of the NATO flag, marking a symbolic shift to a new, much smaller assistance and training mission. The speakers included Afghan national security adviser Mohammed Hanif Atmar, who acknowledged past sacrifices by observing, “We recognize that you carried on the fight for us when we were not ready. We pray for the fallen, for your sons and daughters who died on our soil.” In a written statement also issued that day, President Obama reminded Americans of their future responsibilities: “The United States—along with our allies and partners—will maintain a limited military presence in Afghanistan. Our personnel will continue to face risks, but this reflects the enduring commitment of the United States to the Afghan people and to a united, secure and sovereign Afghanistan that is never again used as a source of attacks against our nation.”","With the U.S. Army’s personnel now mostly back at their home stations, whether in the continental United States or abroad, it was time for Army leaders to reset the force. Nearly two decades of irregular warfare had required many changes in order to provide trained and ready formations in numbers necessary to meet the demands. Force designs, structures, doctrine, training methodologies, and much more needed to be reevaluated, adjusted, and reconstituted in order to prepare for the proverbial “Next War.” That war could come from anywhere across the spectrum of conflict, ranging from the lowest to the highest threat."],"chapter 14":[{"title":"The U.S. Army Beyond ENDURING FREEDOM"},{"section":["Preparations for the 2010 ${Quadrennial Defense Review}{italic} spurred U.S. Army leaders to consider the role of the Army in future conflicts. The first results of that effort produced the ${Army Capstone Concept}{italic} in 2009, but the true harbinger of a significant conceptual change appeared in August 2010 with the publication of the ${Army Operating Concept}{italic}. This release promoted the “central idea” that Army forces would conduct “combined arms maneuver” and “wide area security.”","In 2010, as the School of Advanced Military Studies at Fort Leavenworth prepared to update the Army’s ${Operations}{italic} manual (Department of the Army Field Manual 3–0), General Martin E. Dempsey, commanding U.S. Army Training and Doctrine Command, directed the school to include “combined arms maneuver” and “wide area security” as a distinct statement of the Army’s unique contributions to the nation. Those missions did not replace the offense, defense, stability, or civil support (later defense support to civil authorities) construct that formed full-spectrum operations. Nonetheless, their inclusion undoubtedly informed the Army’s internal fight over whether to stress major combat operations or irregular warfare in its preparation for the 2010 Defense Review. In spite of initial opposition to Dempsey’s guidance, the Field Manual 3–0 authors included “combined arms maneuver” and “wide area security” as “Army core competencies” overlaid on top of full-spectrum operations. Their addition created considerable confusion among readers of the early drafts.","By including combined arms maneuver and wide area security in the official publication describing how the Army fights, the authors ensured that these concepts would receive wide readership. Normally, a strategic concept would be published in The Army (Department of the Army Field Manual 1), but this document had not been revised since 2005. As Army leaders looked to a future beyond Iraq and Afghanistan, they also sought to inform future strategy by including a clear statement of what the Army did in the new national defense strategy that the DoD was about to publish. With General George W. Casey Jr. nearing the end of his term, the responsibility for publishing the new Field Manual 1 would fall to the Army’s new chief of staff.","President Barack H. Obama nominated Dempsey to replace Casey on 8 February 2011. The former Training and Doctrine commander assumed his new duties on 11 April 2011 but held that office less than two months before his name was announced on 26 May 2011 as the nominee to replace Admiral Michael G. Mullen as chairman of the Joint Chiefs of Staff. As the Field Manual 3–0 rewrites continued during 2011, Dempsey recognized that his successor, General Raymond T. Odierno, would inherit the publication. It meant that any planned revision of Field Manual 1 would be deferred until Odierno assumed his duties on 7 September 2011. The next iteration of The Army, now labeled Army Doctrine Publication 1, would be published in September 2012."]},{"title":"Roles, Missions, Strategy, and Doctrine","level":2},{"section":["The final version of the revised Field Manual 3–0, labeled as Army Doctrine Publication 3–0 and published in October 2011 as Unified Land Operations, introduced the operational concept of the same name. Unified land operations drew initially from the concept of AirLand Battle that had been unveiled in the 1982 edition of Operations (Department of the Army Field Manual 100–5), and then was modified to reflect recent wartime lessons. The new doctrinal manual reestablished the importance of operational art and realigned the doctrinal hierarchy to place stability operations on par with combat operations. As an operational concept, unified land operations sustained intellectual trends that originated with the 2010 Army Operating Concept. In addition to introducing combined arms maneuver and wide area security, the concept replaced “command and control” with “mission command.” Unified land operations established a broader doctrinal framework that provided a stronger foundation than its predecessors had for blending offense, defense, stability operations, and defense support to civil authority.","One other small but far-reaching change occurred with the publication of Army Doctrine Publication 3–0. Odierno had not mandated changes in the content, but he directed that the term “full spectrum operations” be replaced by “decisive action” just after assuming his duties as Army chief of staff. The earliest reference to the new term occurred on 21 July 2011, during General Odierno’s confirmation testimony to the Senate Armed Services Committee, when he described the Army as the “force of decisive action.” In spite of the seemingly drastic change in terminology, there was no change to the arrangements of offense, defense, stability operations, and defense support to civil authorities inherent to full-spectrum operations.","The new operational concept described how the Army fought, but it did not define the Army’s role to the nation, which seemed about to change. When Odierno became chief of staff, the Iraq campaign was nearing its end, and the transformation of the Afghanistan campaign had already been announced. Policy statements by the Obama administration signified that less funding would be allocated to military needs. The role of the Army may have seemed self-evident internally, but externally, the role of the Army in the future was seen in a much different way by the civilian leaders of government."]},{"title":"Budgetary Pressures and Institutional Strategy","level":2},{"section":["Continuing the work of the 2010 Defense Review, a new National Defense Strategy appeared in January 2012 under the  title ${Sustaining U.S. Global Leadership: Priorities for 21st Century Defense}{italic}. Referred to as the Defense Strategic Guidance, this document announced a need for “a force that would be smaller and leaner, but agile, flexible, ready, and technologically advanced:” language reminiscent of the literature that Secretary of Defense Donald H. Rumsfeld had influenced on defense transformation at the beginning of the Bush administration.","Reductions to the defense budget stemmed from the 2011 Budget Control Act. This act, which formed the underlying context for the ${Defense Strategic Guidance}{italic}, mandated $487 billion in defense cuts to be made from 2012 to 2022, with the stipulation that $259 billion would be cut in the first five years. Other sweeping changes included a repudiation of the 1990s policy of massing resources to defeat one regional adversary while conducting a holding action against a second. Instead, the nation’s military would be sized to defeat a single adversary and then “facilitate a transition to stable governance on a small scale for a limited period using standing forces and, if necessary, for an extended period with mobilized forces.” The force would “no longer be sized to conduct large-scale, prolonged stability operations,” an unmistakable reference to the conflicts in Iraq and Afghanistan. According to the ${Defense Strategic Guidance}{italic}, U.S. forces would “rebalance toward the Asia-Pacific region,” an explicit geographical reprioritization that further distanced the military from the wars of the last decade.","The other major outcome of the ${Defense Strategic Guidance}{italic} was its introduction of ten unclassified missions for U.S. Armed Forces:",{"list":["1. Counter Terrorism and Irregular Warfare","2. Deter and Defeat Aggression","3. Project Power Despite Anti-Access/Area Denial Challenges","4. Counter Weapons of Mass Destruction","5. Operate Effectively in Cyberspace and Space","6. Maintain a Safe, Secure, and Effective Nuclear Deterrent","7. Defend the Homeland and Provide Support to Civil Authorities","8. Provide a Stabilizing Presence","9. Conduct Stability and Counterinsurgency Operations","10. Conduct Humanitarian, Disaster Relief, and Other Operations."]},"","Of those missions, the force was to be sized only to fulfill four: counter terrorism and irregular warfare; deter and defeat aggression; maintain a safe, secure, and effective nuclear deterrent; and defend the homeland and provide support to civil authorities. These “force-sizing missions” drove discussions on force structure and size. By focusing on only one adversary at a time, the new approach lent weight to arguments calling for a reduction in the number of ground units in the active component, meaning the Army and Marine Corps. In addition, the new strategic vision materially influenced Army efforts to articulate its role beyond the wars in Iraq and Afghanistan.","General Odierno’s institutional strategy for the Army rested on a globally engaged and regionally responsive force that could “Prevent, Shape, and Win,” as the Defense Strategic Guidance put it. His vision first appeared in a January 2012 pamphlet that promised to emphasize training on tasks required for decisive action that the Army had put aside during its wartime shift to counterinsurgency and irregular warfare operations. However, such a vision could not ignore the continuing requirement for forces in Afghanistan. Although the Army was recovering from the Afghan surge, it still had to generate forces capable of combat and advising for at least another three years.","Implementing Odierno’s vision meant changing how the Army generated deployable forces in an environment that demanded less from conventional units. One change was reducing combat deployments for most personnel from a year to nine months. The Army also would begin training “Regionally Aligned Forces,” which were tailored to the needs of combatant commands and provided on a predictable basis, while retaining widespread capabilities in the force through units trained for the full range of military operations. Finally, the Army would support the Asia-Pacific “rebalance” by preparing theater support forces and Army service-component commands.","The Regionally Aligned Forces concept, in which forces trained in “decisive action” would be “habitually aligned” to combatant commanders, included corps headquarters, division headquarters, brigade combat teams, and sustainment units charged with providing theater-wide support. Regionally Aligned Forces would conduct more than security cooperation. In addition, they would be capable of operations up to and including combat. By predetermining the theater to which they would deploy, these units would have real-world missions on which they could focus their preparatory training. Implementing Regionally Aligned Forces required the Army to change how it generated forces because there would be little demand for a brigade combat team acting as an undivided or whole organization in a noncombat role. Instead, deployments lasting anywhere from a week to several months and involving small units, teams, or individuals with specific capabilities would become the norm."]},{"title":"Reducing the Force","level":2},{"section":["President Obama’s pronouncement that “the tide of war is receding” and “it is time to focus on nation building here at home” in a 22 June 2011 speech at the White House presaged cuts to military spending. It was a foregone conclusion that the Army would shrink after Operation ENDURING FREEDOM and Operation IRAQI FREEDOM. The questions were how much and how quickly. In anticipation of change, the 2012 ${Army Posture Statement}{italic} introduced two terms to govern potential postconflict developments. The first was reversibility, which it described as “structuring and pacing reductions in the Nation’s ground forces in a way that preserves the ability to make a course change to surge, regenerate and mobilize the capabilities needed for any contingency.” The second was expansibility, described as “managing the force in ways that protect the Army’s ability to regenerate capabilities that might be needed to meet future, unforeseen demands, maintaining intellectual capital, rank structure and other assets that could be called upon to expand key elements of the force.”","The first reductions began in 2009 when Secretary of Defense Robert M. Gates announced that the Army would curtail its Grow the Army Plan. The plan was designed to add brigade combat teams to bring the active Army up to a total of forty-eight; Gates’ order stopped that growth at forty-five. Gates then announced that the Army would reduce its active component strength by some 27,000 on 6 January 2011. That reduction included a retraction from its temporary end strength authorized by Section 403 of the National Defense Authorization Act for Fiscal Year 2010, which was effective for two years.","In 2012, the Army planned to decrease its end strength from a wartime peak of 570,000 in the active Army, 358,200 in the Army National Guard, and 206,000 in the Army Reserve to 490,000 active Army, 353,500 Army National Guard, and 205,000 Army Reserve. Those reductions were projected to occur at a measured pace through the end of 2017 so as to allow the Army to meet its commitments in Afghanistan and elsewhere. The pace would facilitate reversibility of the force should unforeseen circumstances arise. To “keep faith” with soldiers and their families, the reductions would not be immediate or massive.","As part of restructuring, the Army decreased its brigade combat teams from forty-five to thirty-three. Although the Army was projected to have fewer brigades, the ones that remained were more capable than their predecessors. As part of the planned reduction, active component units based in the continental United States regained their third maneuver battalion that had been removed in order to create modular brigades. Stryker-equipped brigades, which already had three maneuver battalions, received an engineer battalion. In addition, the Army converted brigade support troop battalions within remaining brigade combat teams into engineer battalions. Artillery battalions in the remaining combat brigades would convert from two firing batteries with eight howitzers apiece to three firing batteries with six howitzers apiece, permitting each maneuver battalion to be supported by a dedicated artillery battery. Upon completion, the reductions left the Army with twelve armored brigades, fourteen infantry brigades, and seven Stryker brigades in the active force.","Army plans to reduce to 490,000 personnel by the end of fiscal year 2017 reverberated throughout organizations above the brigade level. On 12 June 2013, the Army deactivated the V Corps, which had been spared that fate almost exactly four years earlier to fill the requirement for ISAF Joint Command headquarters. With the impending end of this joint command mission, a corps headquarters based in the United States would temporarily fill that billet. The V Corps was left with no subordinate elements following the relocation of the 1st Armored Division from Germany to Fort Bliss, Texas, in 2011.","What was not readily visible in those changes was the streamlining of units outside the combat brigade structure. Consolidations substantially changed the Army’s school systems, perhaps none more so than the restationing of the Air Defense Center and School from Fort Bliss to Fort Sill, Oklahoma, to form the Fires Center of Excellence in 2010. The following year, the Maneuver Center of Excellence was created at Fort Benning, Georgia, by merging the post’s Infantry Center and School with the Armor Center and School, newly arrived from Fort Knox, Kentucky. Other economies came through eliminating overhead such as the U.S. Army Accessions Command in 2012 as well as a mandated 25 percent reduction in the Army Staff and equivalent lower-level headquarters."]},{"title":"Readiness for an Army after ENDURING FREEDOM","level":2},{"section":["The impending end of combat operations in Afghanistan meant a corresponding decrease in supplemental funding—a troubling prospect for Army leaders, since their service’s base budget did not permit maintaining even a reduced force at full readiness. Faced with less money and fewer soldiers to maintain its operational responsibilities across the globe, Army leadership took steps to synchronize fiscal and strategic realities. The contingency force program was the Army’s means of ensuring it could still meet time-sensitive requirements. Instead of maintaining the force pools created by the Army Force Generation process, a smaller mix of armored, infantry, and Stryker brigade combat teams were kept at full combat readiness. Only those units would benefit from combat training center rotations; the remainder of the Army would be trained at lower levels of proficiency. At the same time, the Army adopted the sustainable readiness model, which brought back what in 2001 had been known as the Band of Excellence, an echelonment in which a unit’s readiness fluctuated but remained below deployable status until assigned missions.","These arrangements to ensure that selected units received the training they needed to achieve deployable readiness did not address the fact that the Army needed to regain experience in conventional warfare after a decade of counterinsurgency operations. That process began in 2009 with the publication of ${Army Training and Leader Development Guidance}{italic}, which combined the core mission essential task list and the directed mission essential task list into a full spectrum mission essential task list. The next step did not take place until the demand for units trained in counterinsurgency abated with the retraction of the Afghan surge. Between August 2011 and February 2012, maneuver combat training centers began discarding tailored mission rehearsal exercises in favor of generic full-spectrum scenarios pitting units against similarly equipped conventional opponents.","The shift from counterinsurgency to full-spectrum operations or decisive action would not be easy. By the end of ENDURING FREEDOM, the Army’s principal repository for skills in conducting major combat operations was senior leaders who had grown up with those processes. In fact, by that point, soldiers who might have had substantial experience in combined arms warfare were brigade commanders and their command sergeants major, a situation the Army had not experienced since the early 1970s. Division commanders noted that leaders at the battalion level simply did not have the knowledge or experience to train their units on techniques that were common knowledge before 2001.","After watching several rotations in which visiting units attempted full-spectrum operations, Brig. Gen. Terry R. Ferrell, c ommanding general of the National Training Center at Fort Irwin, California, observed that “we have second lieutenants, first lieutenants, captains, and many majors now who have not operated or trained on major combat operations.” Ferrell’s comments echoed observations found in a white paper written at the behest of Maj. Gen. Michael S. Tucker, whose South Korea–based 2d Infantry Division faced the threat of conventional invasion across the 38th Parallel. The paper noted that small-unit leaders had “little or no knowledge of breaching or gap crossing operations, have difficulty analyzing the terrain, visualizing enemy courses of action, and developing event templates with time and distance analysis to identify signature equipment and High Value Targets.” Similarly, a soldier at the Joint Readiness Training Center in October 2014 observed that “the basics of fighting position construction, sectors of fire, sector sketches, interlocking fire, obstacle preparation and many more basics of defensive operations have atrophied over the past 13 years at war.” Even more indicative of over a decade of nondoctrinal missions was that junior leaders, many of whom had known no other professional reality, “seemed to be operating with a FOB [forward operating base] mindset.” In this context, “FOB mindset” was shorthand for counterinsurgency operations, a dangerous approach to pursue when engaged in high-intensity combat.","The return to full-spectrum or decisive operations recognized that future opponents likely would be skilled in cyber warfare, unlike those the Army faced in Iraq and Afghanistan. This challenge would be as difficult to address as that of retraining units to fight against conventional foes. Ever since the original decision to go to war as part of a multinational effort, the Secure Internet Protocol Routing Network, a U.S. national secured communications network, gave way to coalition networks such as the ISAF Secret network and national extensions like the British OVERTASK network. A replacement, the U.S. Combined Enterprise Regional Information Exchange System, followed a similar path after General Stanley A. McChrystal directed all units to transition as much traffic as possible off their national networks and onto the Afghan Mission Network in January 2010.","Blending networks hurt the campaign by triggering numerous security breaches as American personnel sent information not cleared for universal distribution to coalition recipients. The Army’s insufficient security protocols against insider threats came to light during the court-martial and conviction of Spc. Bradley E. Manning (now known as Chelsea E. Manning), who had leaked classified diplomatic cables and Army reports to a third-party Web site. Recognizing that future conflicts would likely be multinational, that potential regional aggressors would employ cyber warfare specialists, and that insider threats could cause grievous national harm, the Army began training the entire force in information assurance procedures previously practiced only by its intelligence community.","Although senior Army leaders recognized that the Army had to change its approach to training, the service’s normal means of regaining expertise in long-neglected skills were either greatly diminished or gone. The streamlining of the force that had created centers of excellence from branch schools and substituted civilian instructors for military faculty gave the U.S. Army little excess personnel from which to rebuild expertise. By taking personnel from the Generating Force (mainly from the Army schools) to fill requirements in the Operating Force (forces under FORSCOM prepared for contingency operations), the Army effectively had used up its source for rebuilding expertise in warfighting approaches other than tactical counterinsurgency. It would take time, money, and concerted effort to build proficiency in old and new mission sets alike.","The inescapable need to grow the Army for ENDURING FREEDOM and IRAQI FREEDOM also contributed to the evisceration of the Generating Force. As the Army expanded, promotion timelines shortened so that it could field the appropriate rank of officers and noncommissioned officers needed to fill new requirements. Promotions came overwhelmingly to those who held repetitive tactical command, preferably in combat. In a period of compressed timelines, officers had fewer opportunities to gain experience in anything other than their basic branches. For the majority of the Army’s future senior leaders who came from the combat arms branches, such experience was predominantly in the Operating Force and frequently in units that operated most comfortably at the tactical level.","Studies on officer personnel management conducted as early as 1997 identified these risks but did not forecast the amplifying effects of an expanded Army. The emphasis on brigades, divisions, and corps as the building blocks of the Army’s contribution to the joint force excluded many skills needed at joint task force, service staff, and combatant command levels. In 2005, Human Resources Command had recognized problems with building experience outside an officer’s branch or functional area in the existing Officer Professional Management System—which did nothing to facilitate General Peter J. Schoomaker’s original intent for “pentathletes” who were capable across a broader spectrum of the conflict."]},{"title":"The Reserve Component after Fifteen Years of War","level":2},{"section":["The wars in both Iraq and Afghanistan were shaped by the decisions to adopt a total-force policy and an all-volunteer force following the Vietnam War. Operation ENDURING FREEDOM and its counterpart in Iraq tested the Army’s ability to sustain overlapping campaigns for almost a decade without the need for the draft. Mobilizing the Guard and Reserve had connected the American public to the Global War on Terrorism in some ways, but it still did not produce wide public support for—or opposition to—the war as conscription had in the past. Although successful, the total-force concept suffered as the reserve component strained under the demands of performing both homeland defense and overseas combat operations after the September 11th attacks. As former Acting Assistant Secretary of Defense for Reserve Affairs David L. McGinnis stated, “If there’s anything you ought to give to the reserve components . . . it’s the high demand/low density unit . . . [which] represents the chasm between service culture and the needs of the nation, because the services will not invest their money . . . in these things that they don’t think is [sic] important to their culture.” Elevating the National Guard and Reserve to full readiness levels between 2001 and 2016 was a costly exercise, undermining the notion that the total-force approach would save money.","Despite the challenges of their varied missions, the National Guard and the Reserve benefited from playing key roles in Iraq and Afghanistan. At the end of both conflicts, reserve units and personnel were more experienced, better trained, and better equipped than they had been in 2001. The number of power projection platforms for the Guard, for example, increased from four in 2001 to fourteen by 2008, ten of which were filled by the reserve component. Until 2007, individual readiness checks and small-unit tasks were permitted only under active component supervision at mobilization stations, but they would now be performed by reserve component personnel ahead of mobilization. Medical and dental readiness went from being the primary factor keeping soldiers from deploying to an administrative issue, although the cost of offering premium-based healthcare for the entire force at all times and no-cost insurance for reservists prior to deployment rose exponentially. The reserve component experienced as dramatic a change in force structure as the active Army. Modularity created interchangeable units across components, eliminating the last vestiges of tiered readiness. The components of the Army came to resemble each other in many ways, although bureaucratic competition for missions, funding, and resources resumed as the tempo of combat operations decreased. For example, the 2014 Army Aviation Restructuring Initiative deactivated two combat aviation brigades and led to the decision to phase out all OH–58 Kiowa Warrior helicopters from the force by fiscal year 2018. An initiative to transfer four National Guard AH–64 Apache helicopter battalions to the active component, in exchange for transferring active component UH–60 Black Hawks to the National Guard and Army Reserve, encountered skepticism from Congress. As a result, while some elements of the restructuring plan proceeded as scheduled, the Apache battalions remained in place until a congressionally appointed commission studied the issue. The commission recommended against the transfer of Apaches, suggesting instead that the National Guard procure fewer modernized Black Hawks to offset the cost of maintaining more attack helicopters.","The Declaration of National Emergency by Reason of Certain Terrorist Attacks, in place since 14 September 2001, underpinned the continued operational use of the reserve component as well as supplemental funding. Although this declaration was renewed each year after 2001, the authority to continue employing the Guard and Reserve as an operational force was not guaranteed. Nearly twenty years after September 11th, the United States continues to use emergency powers. Though the active component likely will continue to call upon the reserve component even after repairs and modifications to the forces are made, access to the reservists may well depend on a reexamination of existing legislation."]},{"title":"Retrospect and a View to the Future","level":2},{"section":["To the casual observer, the Army at the end of 2014 looked much the same as it had in late 2001. The force structure appeared outwardly similar in many organizations and the overall size differed little from the beginning of the Afghanistan and Iraq campaigns. The reality, expressed mostly in intangibles, was that the Army had changed significantly. The Army of 2001 had been organized, trained, staffed, and commanded in a manner consistent with its fight against Iraq during Operation DESERT STORM. Changes forced upon the Department of the Army after 2001 occurred in the context of a conflict that senior leaders had not predicted. That experience transformed the Army into a force that started off by fighting terrorists, then countered insurgents, then pursued functionally based security force assistance, and finally prepared for stability operations. A tenacious enemy, an evolving national strategy, and a dynamic environment changed the Army over the longest overseas war it has ever fought.","The Army faced numerous challenges as the fighting in Afghanistan and Iraq continued longer than anticipated. Undisciplined force management—fostered in part by the pervasive but illusory notion in the 1990s that future wars would be short, decisive, and dominated by the precise application of firepower against opposing conventional forces—led to severe staff shortages soon after 11 September 2001. Ironically, the Army had helped create this crisis through its own practice of granting exceptions to existing assignment policies for individuals in the reserve component who volunteered to fill the ranks of joint headquarters and low-density, high-demand units in both Iraq and Afghanistan. Several factors produced this volunteerism, including a professional desire for combat experience and anxieties among Guard and Reserve soldiers that the war would end before they had a chance to deploy, as had happened in Operation DESERT STORM. Though the active component did not experience as significant a backlash, many reserve component units ultimately became nondeployable by 2004 because key individuals had volunteered for overseas service and did not have enough dwell time to return to service.","The Army remained an all-volunteer, professional organization by spreading necessary sacrifices among the various branches of service in deployed active component contingents as well as within the reserve component and stateside Generating Force. These sacrifices included deploying a large number of National Guard units to Iraq to enable the active force to implement modularity, repurposing combat support and combat service support units to perform combat missions, and revising training curriculum to better prepare soldiers for what they would face in Iraq and Afghanistan. Although these developments showed that the Army was adapting to the conflicts it faced, the limited time available to reset units returning from combat meant that whatever proficiency was left in their core mission essential task lists eroded over time as predeployment training continued to focus on tasks unique to Iraq and Afghanistan. Ignoring pre–September 11th core tasks came at a price. By 2011, the revamping of doctrine in the form of the Unified Land Operations manual (Army Doctrine Publication 3–0), and the difficulties the Army faced in reestablishing expertise in full-spectrum operations and decisive action made it clear that the Army had lost much of its original expertise in functions that were not irregular warfare.","Training in full-spectrum operations only partially addressed this deficit in traditional skills. Major structural changes to the modular force were also required. The Army started that process by reflagging its fires brigades as division artillery brigades, beginning with the 1st Armored Division on 23 July 2014, bringing back a combat support command and control structure that had disappeared with the introduction of modularity. Although direct support artillery battalions remained in brigade combat teams, authority for training and certifying fires now became the responsibility of the division artillery commander, infusing a critical mentorship role back into the force structure. Similarly, the return of armor and infantry brigade combat teams with three maneuver battalions was another step away from modularity, although the reorganized brigades retained their cavalry squadrons and organic support organizations that previously belonged under divisional headquarters.","Although the 2012 ${Defense Strategic Guidance}{italic} and 2014 ${Quadrennial Defense Review}{italic} appeared to reinforce the argument that the Army needed to be sized in anticipation of another long-duration conflict, both documents noted that near-term force structure decisions likely would not be influenced by the remote possibility of more conflicts like Iraq and Afghanistan. Given the likelihood that military budgets would shrink, policymakers instead began exploring how to manage the force in ways that would allow the Army to regenerate capabilities that had atrophied as a result of its decade-plus focus on irregular warfare. The 2012 D${Defense Strategic Guidance}{italic} explicitly mentioned the need for “intellectual capital and rank structure that could be called upon to expand key elements of the force.” The 2014 ${Quadrennial Defense Review}{italic} contained similar language suggesting a requirement for regeneration of the force.","If the United States became involved in a conflict that seemed like it might be protracted, a decision to grow the force would have to be made much sooner than occurred during the Bush administration’s Global War on Terrorism. In the Army’s 2015 annual posture statement to the Senate Armed Services Committee, Secretary of the Army John M. McHugh and Chief of Staff General Raymond Odierno noted that it takes around thirty months to generate a complete brigade combat team. That period includes recruiting new soldiers and putting them through initial entry training, assembling the chain of command, building facilities, issuing equipment, and mastering the individual and collective training goals that must be met before committing a unit to combat.","Training concerns were not confined to the physical side of operations. The uniformed expertise previously resident in the Army’s schools and centers had been replaced by civilians as uniformed authorizations were moved from the Generating Force into the Operating Force to fill new unit authorizations. Some of that expertise remained in the reserve component, but those forces were subject to constraints. Maintaining the Guard and Reserve at the same level of readiness as their Active Army counterpart would either increase costs or, worse, force reserve expertise to leave the service because of the higher operations tempo. For competencies such as attack aviation and combined arms warfare, those talents could not be replaced easily.","To regenerate the force, senior leaders would have to make some hard tradeoffs. As the Army at large reduced in size, the size of the Generating Force needed to expand relative to the size of the whole Army. The greatest challenge to regeneration rested in midgrade officers and noncommissioned officers who needed to be capable of serving as a cadre for expansion of the Operating Force and training the personnel that were part of the expansion itself. Those midgrade officers and noncommissioned officers would serve as building blocks to enable that expansion, which itself would require additional recruiters.","In an effort reminiscent of Donald Rumsfeld’s first year as secretary of defense, like-minded Obama administration officials  recommended that U.S. conventional forces should not be resourced or configured to conduct large-scale stability operations over an extended period. The Army’s senior leadership remained opposed to the narrow strategic path espoused by transformation advocates. In a 20 July 2013 New York Times article, Maj. Gen. Herbert R. McMaster exposed the fundamental flaw in both presidential administrations’ arguments by pointing out that technological superiority did not guarantee that the United States could avoid being drawn into irregular conflicts. Two years earlier, Marine General James N. Mattis, then CENTCOM commander, had voiced a similarly sobering assessment before the Senate Armed Services Committee: “I think, as we look toward the future, I have been a horrible prophet. I have never fought anywhere I expected to in all my years.”"]},{"title":"SECTION III CONCLUSION","level":2},"${Modern War in an Ancient Land: The United States Army in OPERATION ENDURING FREEDOM, 2001–2014}{bold}",{"interactive":{"source":"/iframe/ch14/VOLII_Ch14Conclusionv2.html","caption":"Key Events 2001-2014"}},"Following the September 11th terror attacks, the U.S. Army entered an era of sustained warfare unlike anything experienced during its 225-year history. The challenges that the Army faced included skilled and tenacious foes, unreliable regional allies, shifting objectives, and inadequate resourcing. The course of Operation ENDURING FREEDOM thus swung from the high of its initial success in toppling the Taliban to a three-year period where the United States searched for the right operational approach in Afghanistan while it shifted its primary focus to Iraq. As NATO assumed the operational lead in Afghanistan starting in 2006, the Taliban and its allies seized the initiative while the United States maintained an economy of force effort as the situation in Iraq deteriorated. After the election of Barack H. Obama in 2008, the United States reinvigorated its efforts in Afghanistan for roughly eighteen months before retrograding its forces and bringing the campaign to a close. Even after a successful drawdown of American forces, the legacy of the nearly 15-year-long ENDURING FREEDOM campaign remains inconclusive.","${An Imperfect Strategic Crystal Ball}{bold}","The events of 11 September 2001 shocked the United States. In the immediate wake of the attacks, President George W. Bush and his cabinet raced to formulate a retaliatory strategy and prevent further attacks. The 21st-century news cycle, which broadcast images of death and destruction in New York City and at the Pentagon for weeks afterward, influenced strategic deliberation and campaign planning to an unprecedented degree. The speed of the American counterstrike, coupled with the fact that American conventional forces were ill-equipped for a rapid and coordinated response a decade after the end of the Cold War, largely shaped the Army’s opening involvement in Afghanistan.","Despite the many challenges inherent in a U.S. intervention in Afghanistan, the DoD and CENTCOM, with the approval of the National Security Council, championed an untested style of campaign planning and warfighting during the opening phase of Operation ENDURING FREEDOM. The new approach, based on the concept of transformation, blended coalition conventional and unconventional units, airpower, CIA operatives and indigenous opposition groups, to form an effective fighting team against an irregular enemy using conventional tactics. The unproven approach favored by the Bush administration delivered decisive results at little cost in American lives while avoiding the appearance of a Soviet-style occupation. The Taliban government crumbled under the pressure of the United Front supported by American advisors controlling precision aerial strikes. Resistance from al-Qaeda broke after the combined U.S.-Afghan assault at Tora Bora in December 2001. The remnants of al-Qaeda and the Taliban scattered, seeking refuge in rural Afghanistan or in sanctuaries in Pakistan. The speed of the coalition’s victory caught everyone by surprise and appeared to vindicate the American embrace of a new style of warfare.","In the second phase of the campaign, culminating with Operation ANACONDA in March 2002, a number of unexpected issues emerged after the fall of Kabul which signaled the fragile nature of the new coalition and questionable durability of the strategic choices made by the United States. The Americans soon learned that ethnic and personal agendas prevented the United Front from seamlessly transitioning into the role of Afghanistan’s primary security force. The Taliban and al-Qaeda learned the limits of American aerial capabilities and adjusted their tactics accordingly. With enemy fighters focused on reconstituting their power base in cross-border sanctuaries, conventional units increasingly confronted growing administrative responsibilities in support of nation building and humanitarian relief. American combat units also took over many of the missions formerly allocated to allied indigenous forces after diminished United Front involvement affected the ability of Special Forces and the CIA to contribute to the campaign.","President Bush’s speech at the Virginia Military Institute on 17 April 2002 announced a shift in the American approach to Afghanistan, with the employment of additional conventional forces in ground operations and a new commitment to some form of nation building. Operation MOUNTAIN LION, initiated by Maj. Gen. Franklin L. “Buster” Hagenbeck’s CJTF-MOUNTAIN and concluded under General Dan K. McNeill’s CJTF-180 during the summer of 2002, signaled the beginning of a new stage in the campaign, in which American units conducted security operations in support of a new Afghan government established under the aegis of the United Nations. The transition marked a crossroads for the Global War on Terrorism, as the United States shifted its strategic focus to Iraq while continuing to support stabilization efforts in Afghanistan. The invasion of Iraq jeopardized the successful campaign in Afghanistan as the United States was not militarily prepared to wage two protracted conflicts simultaneously. With the Bush administration unwilling to raise taxes, establish additional Army and Marine combat units, or mobilize the nation as a whole to devote greater resources to the war, fighting in multiple locations presented a complex operational challenge. The de facto relegation of Afghanistan to a secondary effort—for the purpose of redirecting limited resources to Iraq—undercut the gains of the opening campaign in the Global War on Terrorism.","${Sustaining the Initial Victories}{bold}","Making Operation ENDURING FREEDOM a lower priority sparked a number of collateral changes as the international community, U.S. government, coalition partners, and Afghans were forced to make do with less support and fewer resources. One justification for shifting the DoD’s attention to Iraq was the American assumption that the Taliban was a defeated entity and no longer of serious concern. Successive U.S. commanders thus received unaccustomed authority and discretion in Afghanistan. However, circumstances on the ground soon began to inhibit the smooth implementation of the Bonn Process. The international humanitarian aid effort, which U.S. authorities originally envisioned as the centerpiece of reconstruction, gradually imploded. The U.S. leadership also came to realize that Pakistan supported the Taliban’s return, a factor that complicated attempts to stabilize Afghanistan’s border regions. Nevertheless, the Bush administration remained reluctant to commit additional U.S. ground combat power to maintain internal stability until sufficient indigenous security forces and government bureaucracies could be created.","American military efforts in Afghanistan from 2002 through 2005 failed to gain momentum owing to the overall lack of boots on the ground and the need to deploy these limited forces in geographically isolated locations. With a focus on mounting counterterrorism operations, newly deployed American combat units discovered that sparse allocations of intelligence and surveillance assets made it difficult to find and engage the enemy. Growing demands for infantry in Iraq resulted in noninfantry organizations being sent to Afghanistan to perform close-combat missions. Even with augmentation by noninfantry units, however, U.S. commanders in Afghanistan lacked adequate numbers to secure the entire country. As a result, available units were deployed in eastern Afghan provinces opposite HIG and Haqqani strongholds as well as in Pashtun tribal areas around Kandahar. In addition, confirmation of growing cross-border traffic between Afghanistan and Pakistan led U.S. and coalition Special Forces, conventional units, and new Afghan security organizations to focus more on securing the eastern and southeastern borders with Pakistan.","Although a larger number of indigenous military units could have helped redress the unavailability of American troops, various obstacles hindered early attempts to create those security forces. First, the U.S. defense establishment balked at absorbing the projected cost of this program. Second, the United Front proved unwilling to deploy its forces in the Pashtun-dominated areas of Afghanistan, or to convert its militia units into regular forces answering to a central government, without commensurate incentives. As the United States hesitated to make significant early investments in security force assistance, these incentives never appeared. By January 2003, the U.S.-led effort had trained only 1,800 ANA troops. The resultant lack of sustainable security beyond the confines of Kabul hampered reconstruction efforts and economic development in areas where U.S. troops did not operate, and facilitated the rise of local strongmen and the reemergence of the opium trade.","Insufficient funding was not the only challenge associated with the creation of Afghan security forces. As a result of growing demands from Iraq, the mission of training Afghan troops shifted from SOF to rotating conventional units operating under the designation of TF PHOENIX. At the same time, the U.S. Special Operations units remaining in Afghanistan made effective security assistance all the more complicated by forming their own indigenous auxiliary units to help fill the security vacuum created by the lack of conventional units in theater. Although this approach satisfied near-term needs, it siphoned off thousands of potential ANA recruits while creating paramilitary units beholden to local authorities rather than the central Afghan government. The limited resourcing caused by the invasion of Iraq therefore directly hampered reconstruction and security force assistance efforts, and offered fewer opportunities to improve the integration of Special Operations and U.S. conventional forces.","American interest in Afghanistan briefly revived after U.S. and coalition troops ousted Iraq’s Saddam Hussein from power in April 2003. Within two months, the National Security Council adopted a new political-military action plan titled Accelerating Success, which aimed to curtail the power of warlords and reform Afghanistan’s interior and defense ministries. Weeks later, the DoD adopted new policy guidelines for the Operation ENDURING FREEDOM coalition. The overarching objective was still to “prevent Afghanistan from serving as a base for terrorists,” but policymakers viewed this goal quite differently. The United States now sought to create a representative and democratic Afghan government capable of controlling and overseeing its territory. NATO, which assumed leadership of ISAF from the UN in August 2003, shared this lofty ambition. CENTCOM tasked Lt. Gen. David W. Barno with overseeing the complex transition from counterterrorist operations to an appropriate mix of counterinsurgency methods. The United States did not digress from this path for the remainder of the Bush presidency.","The adoption of expanded political objectives invariably meant a broader military role as most U.S. government organizations were unwilling to send their personnel into an unstable security environment. Awareness of the difficulties associated with implementing a whole-of-government approach had been growing for some time as Provincial Reconstruction Teams struggled to obtain experts from the Department of State, the U.S. Agency for International Development, the Department of Agriculture, and other agencies. Although these organizations made some efforts to address this issue, the lengthy time required to train these experts coupled with the constant need to provide personnel for similar missions in Iraq ensured that the problem remained unsolved throughout ENDURING FREEDOM.","${The Strategic Equation Is Altered Again}{bold}","The Bush administration viewed the completion of the Bonn Process with the Afghan election in September 2005 as the logical time to downsize the U.S. military presence in Afghanistan. Taking a page from the successful peacekeeping efforts in the Balkans, the Americans sought to transfer security responsibilities to the NATO-led ISAF. After lengthy negotiations, NATO agreed to extend ISAF’s mandate across all of Afghanistan. Likewise, the American government saw the transition as a means to avoid sending more troops rather than as a sign of imminent withdrawal.","Tying the NATO ISAF transition to the culmination of the Bonn Process placed U.S. commanders in Afghanistan in the position of having to factor coalition politics and the concerns of an increasingly assertive Afghan government into strategic deliberations. The uneven nature of insurgent activity throughout Afghanistan influenced NATO ISAF’s initial plans for assuming responsibility over the various regional commands. However, the Taliban’s decision to aggressively oppose the deployment of NATO units into RC South in 2006 added to the challenges facing Operation ENDURING FREEDOM. The enemy actively sought opportunities to fracture the opposing military coalition by inflicting casualties on less resolute participants until domestic political pressure from those nations prompted their withdrawal.","The Taliban viewed the transition period as the optimal time to stage a comeback. Its leadership was aware that the impending transition did not guarantee the departure of U.S. forces. Nonetheless, it knew that a favorable window of opportunity would close once ISAF reinforced the American troop presence and their efforts to provide security assistance and humanitarian aid to the Kabul government, and so it chose to exploit the evolving strategic environment by launching major offensives in contested eastern and southern Afghanistan. In doing so, the Taliban finally shed the strategic and operational hubris that had led to its humiliating rout in late 2001. Their assault caught both the Americans and NATO as they were adjusting dispositions, reconfiguring their command and control apparatus, and refining tactical-level interoperability.","The sheer ferocity of the Taliban’s unexpected return to the battlefield upset American efforts to realign their involvement in Afghanistan. Even though American commanders initially intended to wage an aggressive counterterrorist campaign in RC East, growing insecurity beginning in 2006 forced them to divide their attention between pursuing their own objectives and assisting their NATO allies. The Taliban’s rejuvenation served as a rude shock to the ISAF members who planned to focus on rebuilding war-torn Afghanistan. Many of the United States’ European allies had signed on to the Afghanistan mission expecting to provide security assistance along the lines of their engagements in Kosovo and Bosnia; accordingly, they were reluctant to actively confront the Taliban. What resulted was a bifurcation of the American effort—divided along separate command chains—between counterterrorist operations and support for ISAF. Slowly, the United States assumed full command of the operations in Afghanistan, including both the U.S.-only ENDURING FREEDOM and its NATO ISAF forces, beginning with the appointment of General Dan K. McNeill as ISAF commander in early 2007. Aligning the two campaigns, however, would take considerably more time.","The urgent task of defeating Taliban efforts to reassert control in the south and east fell to ISAF and American conventional and Special Operations units. With the Afghan army and police proving unequal to the demands of fast-paced combat operations, American units also found themselves aiding their underprepared NATO brethren on short notice. The impressive achievements made by coalition and Afghan forces during Operation MEDUSA in September 2006 proved that they could work together and establish clear dominance in a region. The same could be said of Lt. Col. Brian J. Mennes’ 1st Battalion, 508th Infantry’s service as the ISAF Theater Tactical Reserve beginning in mid-2007, which demonstrated that a single battalion could exert a significant impact on the path of the campaign. The experience of Mennes’ battalion, and of other units that performed just as effectively, indicated that both ISAF and American conventional units could develop good working relationships under trying circumstances. However, ISAF simply did not have the numbers and resources needed to fight for every piece of contested ground while attempting to win the Afghan people’s hearts and minds. The ISAF decision to spread its manpower across as many areas as possible in an attempt to hold ground and safeguard the populace, rather than accepting near-term risk by massing to defeat the enemy’s main effort, inadvertently ceded the operational initiative to the insurgents. The Taliban would maintain the gains it had made during the ISAF transition until the end of the surge in Iraq made it possible to send more U.S. troops to Afghanistan. As might be expected, the Taliban resurgence triggered considerable changes in security assistance and reconstruction. Indigenous army and police units that had existed before the Taliban resurgence suffered considerably from casualties and desertions as a result of the high tempo of operations. Armed with additional funding, the U.S. Army undertook immediate steps to rebuild and expand the Afghan army and police forces. Of course, competent armies take time to build. The Afghan police forces required even more augmentation than their army counterparts. ISAF invested considerable funding, time, and effort in forming ad hoc home guard police units in an effort to solve personnel shortfalls more rapidly. However, most of these initiatives fell short of their intended goals or failed outright despite generous funding. Consequently, Afghan security forces were in only marginally better shape several years after NATO ISAF began to devote more resources to train and equip them.","Similar and more successful efforts provided reconstruction and humanitarian aid programs with additional funding and resources. The reconstruction teams grew much larger in size as robust security elements were added in provinces where the Taliban posed a threat to their efforts. The categories and scope of the projects being undertaken also changed as brigade and battalion commanders, influenced by experiences in Iraq where money was an effective weapon against insurgents, added more reconstruction projects to their tactical repertoire. The Americans also introduced long overdue innovations, such as agricultural development teams that aided Afghan efforts to restore local economies by rejuvenating farming, animal husbandry, and fruit-growing. Translating these efforts into popular support for the central government, however, continued to be a problem.","In addition to the changing nature of the battlefield, the Taliban resurgence added several new elements to the overall strategic equation. First, the enemy’s sanctuaries in Pakistan were a clear threat to Afghan stability, and could not be addressed solely by drone strikes. Second, the groups opposing the U.S.-led coalition and the Karzai government openly reasserted control over areas in Afghanistan’s south and east where a vacuum of security and governance existed. That development would have a significant impact on future security assistance and reconstruction efforts. Finally, the insurgency exposed clear divisions within the international coalition. The coalition had neither a comprehensive campaign plan nor a unified understanding of the mission in Afghanistan. Ostensibly, this problem was resolved with the establishment of USFOR-A in late 2008, but this measure did not address the lack of coalition resources even as the insurgency continued to expand.","${The Economy of Force Campaign Receives More Resources}{bold}","In the fall of 2008, the Bush administration ordered a strategic review of the American effort in Afghanistan. With the situation in Iraq largely stabilized after the troop surge in 2007—and with casualties in Afghanistan climbing steadily as the security situation deteriorated—American policymakers shifted their attention away from what had been the main effort in the Global War on Terrorism since 2003. Led by Lt. Gen. Douglas E. Lute, the National Security Council review recommended pursuing a more robustly resourced counterinsurgency effort with greater attention given to Pakistan. President Bush supported the recommendation, but the November 2008 election of Barack Obama tempered the outgoing administration’s willingness to announce new policy initiatives. Bush did not want to present his successor with a strategic fait accompli.","Upon taking office in January 2009, the new president ordered another strategic review to define the desired end state in Afghanistan and discern the necessary troops and equipment required to achieve it. During a 27 March 2009 address to the nation, Obama signaled his willingness to commit more resources to the campaign. This became clear when the president announced his approval of a long-standing request from ISAF commander General David D. McKiernan for 17,000 additional combat troops to balance increasing insurgent activity and capabilities and to help set conditions for the upcoming Afghan presidential election. That contingent, he explained, would be followed by 4,000 more U.S. personnel dedicated to training and supporting the Afghan army and police. Added to the 32,000 troops already in country, the increase brought American troop levels to 53,000.","The administration began exploring a more robust strategy for Afghanistan by instituting a second review, even as General Stanley A. McChrystal, who was chosen specifically to oversee the future campaign, replaced General McKiernan. McChrystal took charge less than eighty days after Obama’s 27 March address. The incoming commander had experience in both Iraq and Afghanistan, albeit mostly from the perspective of a Special Operations commander focused on counterterrorism. Under pressure to craft an innovative approach, McChrystal began his tenure with a review of the overall situation that was designed to guide the development of a new path forward. The assessment led to a draft campaign plan, which borrowed considerably from recent developments in Iraq. To fully resource his preferred counterinsurgency approach, McChrystal called for a significant increase in American troop strength in Afghanistan over and above the 21,000 recently dispatched soldiers.","General McChrystal’s assessment reinforced the White House’s belief that additional troops in Afghanistan could be employed best by conducting population-centric counterinsurgency. Reasoning that the Taliban’s growing momentum came out of its efforts to coerce support from the Afghan people, McChrystal wanted to employ U.S. and coalition forces to build support for the Kabul government by protecting the people from the enemy’s depredations. The move toward elevating population-centric counterinsurgency over all other doctrines soon gained strong support at the highest levels of the U.S.-dominated ISAF command structure. Pointing to its success in Iraq, proponents of that particular approach failed to realize that far different conditions existed in Afghanistan. The most fundamental and marked difference was the fact that in Afghanistan the enemy was not concentrated large population centers. In addition, the counterinsurgency methods advocated by McChrystal were based on U.S. doctrine, which not all coalition partners accepted or were prepared to employ. Several NATO nations rejected the terminology favored by Americans, because it called to mind the brutal counterguerrilla tactics their militaries used to counter colonial independence movements following World War II. These nations did not want to appear to be involved in similar operations again. Other European countries, such as the United Kingdom, were more willing to participate in counterinsurgency activities. Whatever the case, each troop-contributing nation chose to interpret counterinsurgency through its own historical lens rather than through that of American doctrine.","After numerous planning sessions over the summer and fall months, which strained relations between the White House and the Pentagon,  President Obama delivered a speech in December 2009 outlining his administration’s intended approach to the war in Afghanistan. He reminded listeners that the highest strategic priority would continue to be to dismantle, degrade, and destroy al-Qaeda, because that organization alone had the willpower and capability to carry the war to the American homeland. Obama then elaborated on three key objectives necessary to deny al-Qaeda safe haven in Afghanistan: the implementation of a military strategy over the next eighteen months that included a surge of 30,000 American troops—along with an additional 10,000 from NATO members—to break the Taliban’s momentum and increase Kabul’s security capabilities, greater use of civilian expertise to help Afghan officials learn how to use improved security capabilities effectively, and American recognition that Afghanistan’s path forward would be linked inextricably to Pakistan.","President Obama announced the surge with a timetable; the United States would begin to redeploy these troops from Afghanistan by June 2011. He intended to send the message to both the Afghan government and the DoD that increased resources came with an expiration date that required them to be used to effect within a certain period. The president decided to combine intensive combat operations with an expanded train-and-equip mission for eighteen months, followed by a drawdown as Afghan forces took responsibility for their own security. Critics both inside and outside of the defense establishment were frustrated by the public disclosure of the timeline, claiming that it signaled that the enemy need only hold out during the troop increase. Meanwhile, Obama’s military commanders assured him they could do the mission in the time stipulated.","Although the main thrust of contemporary criticism focused on the timetable, the decision to prioritize population-centric counterinsurgency while conducting high-tempo surge operations (designed to buy time for security force assistance efforts) deserved more analysis and consideration than it received at the time. Even with the urgent need to prepare Afghanistan for its own governance and defense as soon as possible, population-centric counterinsurgency called for sustained patience, thoroughness, and far more military personnel. However, the Obama administration made it clear that while it was willing to authorize a significant increase in boots on the ground, it would not accept an open-ended commitment in a war that had already lasted nearly a decade. The opening moves of the surge did not focus exclusively on large population centers; rather, ISAF emphasized clearing and securing terrain around population centers rather than eliminating the threat by attacking enemy enclaves.","When General David H. Petraeus assumed command after McChrystal’s resignation in June 2010, the former CENTCOM commander emphasized the need to protect civilian communities by diminishing or eliminating the insurgents most likely to prey upon innocents. The approach favored by Petraeus proved more successful in the short term because it took into account the time available to conduct operations. Petraeus also understood that ISAF performed best when it dictated when and where combat occurred rather than reacting to enemy attempts to disrupt the build and hold phases of the operation.","The differing interpretations of counterinsurgency espoused by McChrystal and Petraeus created friction among subordinate commanders. Some commanders gravitated toward an approach that stressed persuading the population to switch allegiances to the central government by cordoning off urban centers from predatory insurgents. McChrystal’s emphasis on reducing civilian casualties and empowering Karzai’s government captured the interest and imagination of outside audiences much more readily than more aggressive methods. At the same time, his restrained operational approach frustrated many of the troops on the ground, who felt constrained in their ability to take the fight to the enemy. Petraeus, who had considerable familiarity with population-centric counterinsurgency, realized that cordoning off urban centers merely allowed the enemy to relocate to areas where coalition forces were not deployed to continue intimidating the population. Commanders who relied on theory and doctrine rather than first-hand surge experience were more liable to elevate protecting the populace over other considerations, while those intimately familiar with the surge in Iraq preferred the more kinetic approach that had been successful in that environment. Even with these highly publicized tensions over the best methods to achieve strategic goals, the more fundamental problem of this disconnect was that it interrupted continuity of effort during a limited-duration campaign.","The new strategy espoused by the Obama administration also ushered in a holistic approach to security assistance. It discarded the  metrics that the DoD had devised in 2002: quality now took precedence over quantity. Rather than turning out tens of thousands of Afghan junior-level personnel in advance of turning over security responsibilities, the Americans and their NATO allies focused on crafting a solid foundation for the existing force structure. For the first time in eight years, American advisers undertook a comprehensive inventory of the equipment and weapons issued to Afghan security forces, allowing them to redistribute items as necessary and reestablish property accountability. Afghan recruits were taught to read and write in order to help them absorb the training methods used by ISAF. Afghan commanders increasingly planned and executed major operations with minimal outside assistance while their staffs coordinated logistics and other types of support. More assistance was focused on developing ministerial-level competency, especially in the defense and interior ministries. However, even with this reinvigorated advisory effort, senior ISAF leaders acknowledged it would take time for Afghan self-reliance to achieve the desired results.","Both McChrystal and Petraeus recognized that dismantling, degrading, and destroying al-Qaeda required both coalition and Pakistani conventional forces working with SOF in conjunction with drone strikes. Coalition conventional forces had responsibility for reversing the Taliban’s momentum and buying time for Afghan security forces to become self-sufficient, with assistance from SOF and their indigenous counterparts, who were tasked with striking high-value enemy leadership targets whenever intelligence sources identified their location. The mission of reducing enemy enclaves within southern and eastern Afghanistan fell to conventional forces that had the necessary combat power and fire support. Enhancing the quality and staying power of Afghan security forces required a mix of conventional and Special Operations participation, with the former outnumbering the latter simply because far more conventional indigenous units existed than Afghan Special Operations units.","Major changes, although trending in different directions in some instances, took place within American- and ISAF-sponsored nation-building programs. The mandate and scope of Provincial Reconstruction Teams evolved in response to the focus on transferring responsibilities to Afghan authorities. Many U.S. government civilians taking part in the Afghan surge were assigned to Afghan national ministries rather than filling long-standing shortfalls on Provincial Reconstruction Teams. Though a number of incoming U.S. civilians received reconstruction-related responsibilities, in many instances they were made part of newly created District Support Teams. Provincial Reconstruction Teams were able to support the increased operational tempo during the surge, but their days were numbered as the senior Afghan cabinet ministers and interior ministry officials made it clear they viewed Western reconstruction teams as shadow entities that undermined Kabul’s authority.","The ultimate outcome of the Afghan surge never depended on taking a softer or harder approach to counterinsurgency. Development and reconstruction projects demonstrated ISAF’s good intentions, but they could not forge stronger ties between the populace and central government if the latter proved unwilling or incapable of matching international efforts. Any success attributable to the surge was because U.S. forces and their coalition partners removed more enemy from the battlefield than ever before. In the vacuum created by this removal, enough ANSF were fielded to enable the Afghans to take the lead in security missions. Nonetheless, the creation of additional army and police units was only one aspect of the overall counterinsurgency effort. It was not a guarantee of either a positive long-term outcome or a seamless handover of security and governance to the Government of the Islamic Republic of Afghanistan.","${Retrograde and Transition}{bold}","The strategy chosen by the Obama administration succeeded in building Afghan security capacity and rolling back the Taliban.  Beginning in 2011 and lasting for the remainder of ENDURING FREEDOM, U.S. commanders focused on building upon the surge’s gains while tackling the massive challenge of withdrawing more than a decade’s worth of equipment and materiel. The retrograde mission in Afghanistan was a far more formidable task for logisticians than it had been in Desert storm or IRAQI FREEDOM. Both of those conflicts had robust ground routes of communication leading to seaports or airfields. The few available ground routes in Afghanistan, by contrast, were underdeveloped and far more susceptible to enemy interdiction or interference by neighboring states. When the surge recovery began in June 2011, the Army faced five major challenges: reducing the operational footprint, materiel stocks, and overall number of personnel to levels acceptable to the Afghans; handing over security responsibilities to the Kabul government in accordance with approved timetables; transferring selected installations, supply stockpiles, and weapons to Afghan security forces; providing effective security assistance to Afghan forces in order to better prepare them to assume leading roles in securing their nation; and ensuring the post–December 2014 residual force could accomplish its mission while conforming to footprint limitations and personnel ceilings.","During the retrograde and transition period, U.S. and ISAF forces continued to conduct combat operations, maintaining pressure on the enemy as coalition troops departed in order to prevent the Taliban and other opposition groups from achieving tactical successes and information operations victories. The collateral effects of the Afghan surge gave Afghan soldiers and police enough time to transition into security leadership throughout the country and prove resilient enough to support those efforts. In an attempt to maintain relevance in Afghanistan, while recuperating from the effects of the surge, the Taliban persuaded its allies to launch attacks against ISAF installations in order to gain propaganda victories. With the sole exception of the assault on Camp Bastion in September 2012, the Taliban’s attempts to penetrate major ISAF bases ended in complete failure. The constantly changing operational dynamic of ENDURING FREEDOM evolved yet again in the final stages of the campaign. As the number of conventional coalition forces focusing on security assistance and retrograde continued to decrease, SOF received a larger share of the tactical fight even as their own security assistance responsibilities grew. Conventional American maneuver units concentrated on training the Afghan army and police, and U.S. SOF invested time and effort in their Afghan counterparts while overseeing the creation of tribal-based militias for local defense. With growing requirements being levied on Special Operations units, integration between those organizations and conventional forces became more important. Innovative solutions to offset resource shortfalls became commonplace, with conventional battalions functioning as the controlling headquarters for Special Operations task forces on several occasions. The organizations involved in nation building experienced a drawdown similar to the conventional forces, as Provincial Reconstruction Teams were deactivated and their responsibilities were turned over to Afghan district and provincial governments.","The most visible threat to the retrograde came not from the Taliban and other opposition groups, but from the Pakistani government. Although Pakistan had consistently expressed its willingness to cooperate with the United States since the September 11th attacks, Islamabad’s actions during the retrograde and transition phases of the campaign reflected a combination of the fragmented nature of the Pakistani government, public frustration fed by the shooting deaths of two Pakistanis by an alleged CIA operative, and lingering fallout from the Osama bin Laden raid. The Pakistanis closed the primary ISAF southern logistics route, threatened to shoot down drones transiting their airspace without authorization, and expelled U.S. personnel from Shamsi Air Base following the November 2011 border post incident in Salala. However, Pakistani officials miscalculated the effect of their retaliatory actions as ISAF weathered the disruption for almost eight months with little discernable impact. That realization, coupled with changes within the Pakistani political leadership, led to Islamabad lifting the closure after Secretary of State Hillary R. Clinton issued a formal apology in July 2012.","The shutdown did not achieve Islamabad’s goals because many U.S. and ISAF units deploying to Afghanistan during this period were tailored to provide security assistance to the Afghan military and police, rather than to conduct combat operations. Many incoming units left their assigned equipment at home station when deploying, and when they arrived in Afghanistan they received whatever equipment they required from in-country stocks. Commanders in theater could continue to downsize stockpiles in Afghanistan because brigades assigned to security assistance did not need much of the equipment issued to conventionally organized maneuver units. In addition, significant amounts of materiel could be turned over to Afghan forces as the security assistance forces completed their deployments. This dynamic ensured that Army units had the right equipment for their primary mission of training their Afghan counterparts, and that this equipment could be transferred to indigenous security forces and reduce the logistics burden of shipping out or disposing of stockpiles.","Continuing instances of green-on-blue incidents, in which Afghan security forces killed or wounded coalition personnel, remained a significant impediment to U.S. and ISAF assistance efforts. This tactic was the Taliban’s most effective weapon during the post-surge period. Although the actual numbers of casualties were low in comparison to the overall number of foreign troops in Afghanistan, the countermeasures adopted by ISAF did not eliminate the dangers that U.S. and coalition soldiers faced in providing security assistance to Afghan units. Consequently, U.S. advisers were under further restrictions during the retrograde and transition phases of the campaign; for instance, they were forbidden from accompanying conventional Afghan units on tactical operations. The restrictions increased after the death of an American general at the hands of an Afghan soldier, resulting in U.S. advisers being withdrawn from all Afghan units below corps level.","Despite the tremendous friction and distrust created by green-on-blue incidents, the training of the ANSF made remarkable progress, reaching its target strength of 352,000 by September 2012, two months ahead of schedule. Success was not measured in mere numbers, as Afghan forces repeatedly proved capable of taking the fight to the enemy after assuming responsibility for key areas following the withdrawal of ISAF troops. These developments allowed President Obama to execute the final portion of the strategy he approved in 2009 as Afghan security forces assumed the lead for combat operations in June 2013 and both the ISAF and U.S. missions officially ended in December 2014.","At the conclusion of Operation ENDURING FREEDOM, the White House left 9,800 troops in Afghanistan to support the new NATO-led advisory mission, Operation RESOLUTE SUPPORT, and to carry out Operation FREEDOM’S SENTINEL, the counterterrorism mission against the remnants of al-Qaeda. At the time, President Obama planned to cut that number in half by 2016, and draw down to an embassy presence by 2017. However, faced with strong opposition from ISAF and Afghan leaders, the administration agreed to keep more troops in place. In announcing this decision, President Obama reasoned that he could “not allow Afghanistan to be used as a safe haven for terrorists to attack our nation again.”","${The Campaign in Retrospect}{bold}","Operation ENDURING FREEDOM began on uncertain footing because key decision makers misread the lessons of recent conflicts. To avoid placing American infantry directly in harm’s way, proponents of transformation and politicians alike preferred to achieve battlefield success using indigenous fighters aided by Special Forces advisers calling in precision airstrikes. With airpower, special operators, and proxies forming the centerpiece of an unproven warfighting arsenal, the United States embarked on the opening campaign of the Global War on Terrorism. Although that unique combination was successful, it disbanded in the wake of its initial triumph, never to be reassembled as originally organized. American foot soldiers were then substituted for absent battlefield proxies until an equivalent indigenous force could be fielded.","Premature thoughts of victory, sparked in part by the unexpected manner in which the campaign unfolded, coupled with the rapid refocusing of the Global War on Terrorism’s main effort to Iraq, placed the conflict in Afghanistan on a shaky foundation. American military and political leaders, convinced that they had adequate situational awareness based upon information derived from technological superiority, did not realize that this technology had lulled them into a false sense of confidence. For example, it was relatively simple to use space and aerial platforms to identify terrorist camps and Taliban military bases. Drones also allowed U.S. forces to track Taliban and al-Qaeda leaders in real time. Decision-makers therefore equated the scarcity of information available after the toppling of the Taliban to the absence of a viable threat.","Yet even after arriving at that determination, the United States did not seek to learn as much as possible about the liberated Afghans or the future intentions of the Taliban and neighboring Pakistan in order to invest resources judiciously and achieve the campaign’s desired end state of a stable, democratic Afghanistan. The Bush administration felt that the rapid victory in Afghanistan permitted national attention and resources to be redirected against Iraq or other efforts, and for several years they were content to absorb information filtered second-hand through proxies, allies, international organizations, Afghan officials, and warlords. The resulting lack of insight reinforced erroneous decisions made early in the campaign while obscuring the dire need for significant changes. The Army—particularly the intelligence community—appeared surprisingly reluctant to enhance its own knowledge of the inner workings of Afghan society and politics, leaving it to the DoD to institute the AfPak Hands program in September 2009 to build its institutional understanding of the region.","This reluctance to learn more about post–Taliban Afghanistan was compounded by the lack of expertise in wartime security assistance. The metrics-based approach adopted for developing indigenous security forces guaranteed neither rapid progress nor an acceptable measure of combat effectiveness, which in turn required U.S. troops to absorb more security-related responsibilities. As a result, the Afghan military was not prepared to deal with a resurgent Taliban in 2006, and the Afghan police forces were even further behind. Additional coalition troops had to be deployed to create the environment necessary to build up indigenous security forces. Nonetheless, when a new strategic approach dictated the need to generate large numbers of indigenous security forces in a short timeframe, the DoD demonstrated it willingness to accomplish that mission while using the Army as its primary agent.","Although the course of Operation ENDURING FREEDOM supports Army Maj. Gen. Herbert R. McMaster’s observation that the United States cannot rely on proxies and partners to achieve objectives of vital national interest, the 2001 decision to do so came from an incongruous mix of caution fostered by the Soviet experience and eagerness to test untried warfighting methods advocated by the DoD. In the same vein, inaccurate perceptions or lack of knowledge also led to the U.S. government relying too much on one component or service. Events in Afghanistan have shown that the U.S. Army, U.S. Marine Corps, and even NATO ISAF cannot accomplish the entire mission unaided. The myriad responsibilities of a protracted campaign offer a strong argument for integrating the capabilities of U.S., allied, and indigenous organizations while simultaneously encouraging further coordination between Special Operations and conventional communities. Other government agencies and international organizations also had to participate in building the Afghan governing capacity, and so all components involved had to understand what capabilities each could bring to the table.","Since the fall of 2001, all interested parties in the region had been planning for the day when America would leave. Yet the United States  itself upset these calculations by remaining in Afghanistan far longer than anyone had anticipated. As time passed, the Bush and Obama administrations made critical decisions that altered the trajectory of those initial calculations on three occasions: first by invading Iraq, second by encouraging NATO to take over the UN-mandated ISAF mission, and third by announcing the surge in conjunction with a withdrawal date. These decisions encouraged Pakistan to hedge its strategic position by continuing to support the Taliban even as it backed efforts to eliminate al-Qaeda and convinced the enemy that he could wait out the United States. Put another way, these three key moments prevented the United States from persuading the enemy that he was defeated. Then again, both the enemy and regional powers miscalculated American intentions.","A final point of discussion on the Army’s involvement in Operation ENDURING FREEDOM concerns the conceptual framework of the campaign. Policymakers routinely displayed a lack of knowledge of Afghanistan, its people, and regional power dynamics. In some cases, political considerations restricted military operations. This was the case with Pakistan throughout the campaign, as Washington officials never reached an accord with their counterparts in Islamabad. A learning curve emerged over time, leading the Obama administration to make the pragmatic choice of transferring responsibility to the Afghans while limiting American participation to counterterrorism operations against al-Qaeda and aiding indigenous allies. Knowledge naturally comes with time, but the United States—including its military leaders—cannot afford, now or in the future, to permit years to elapse before grasping the basic dynamics of a conflict, as was the case in Afghanistan.","${Upon Reflection}{bold}","A closing assessment remains to be made of the U.S. Army’s experience in Operation ENDURING FREEDOM. The fight in Afghanistan began in fall 2001 and continues, as of the time of this writing, under the banner of RESOLUTE SUPPORT. The conflict tested the U.S. Army in ways unimaginable to most soldiers who rolled across the burning Kuwaiti desert in a steel-tipped wave or stood for decades in the Fulda Gap awaiting a Soviet juggernaut that never materialized. Although technology has given the Army a crucial edge in many ways, American soldiers have prevailed time and again in the most elemental form of combat where individuals and not machines count. The Korangal or Arghandab Valleys would seem familiar to veterans who fought at Dak To in Vietnam or atop the shell-torn heights of Pork Chop Hill in Korea. While the soldiers in Korea, Vietnam, and Afghanistan wore different uniforms and carried different weapons, the same shoulder insignia is seen in photographs of each conflict, providing a timeless and compelling reminder that experiences transcend battlefields. To that end, the authors of this study offer eight key lessons from Operation ENDURING FREEDOM.","The first is a reminder that political and military leaders must ensure that sufficient resources are allocated to meet strategic objectives. Put another way, there must be alignment between ends, ways, and means. Overcommitting resources, whether it be personnel, treasure, or time, puts unnecessary pressure on military forces and their families. At the same time, insufficiently resourcing a conflict, as was so often the case in Afghanistan, opens up the nation to the possibility of strategic failure. It erodes morale and sacrifices tactical and operational successes and achievements due to an inability to build upon progress at the strategic level.","This leads directly into the second lesson that innovation and agility are vital components of the armed forces. In an environment where military leaders do not necessarily control resources or mission objectives, they must be able to utilize to the best of their ability the resources they have to complete their assigned mission. The Army cannot be overly tied to current doctrine, force structure, or military operational specialties. Whether it be SOF units riding into combat on horseback, support and service support personnel operating as maneuver forces, or combat troops managing nation-building projects, the Army must remain flexible enough to adapt to the demands of modern war. The war in Afghanistan provides abundant examples of the value of innovation, as U.S. soldiers trained to fight outnumbered and win against a massed enemy—equipped with armor and supported by artillery and airpower—adapted to the combat environment of the rugged Afghan mountains, where often soldiers had nothing more than what they could carry on their backs.","That being said, the third lesson is that initiatives to transform force structure and design should only be undertaken during wartime when necessitated by mission requirements. Though the transformation efforts championed at the DoD could have positive effects in the post–Global War on Terrorism era, many of these same efforts impeded current operations in Afghanistan. A prime example is the opening salvo of the war utilizing smart bombs with limited soldiers on the ground. While the “Shock and Awe” method was successful in scattering al-Qaeda and Taliban forces, the approach had no chance to secure and stabilize Afghanistan afterward. Modularity had the opposite effect during operations in Iraq and Afghanistan, constituting the most significant force design initiative since the Pentomic Division efforts of the late 1950s. Although the modularity initiative caused disruption within the Army, without it the Army could not have fulfilled the combat unit requirements necessary in both countries while also servicing missions around the globe.","Fourth, although some organizations have impressive capabilities, it is unrealistic to expect them to dominate a combat environment in all cases and under all circumstances. Even though the opening phase of ENDURING FREEDOM featured a dazzling display of American airpower, achievements on a comparable scale have not been repeated since. Airpower had a central role in the conflict’s opening months, but over the remaining thirteen years it served as a combat multiplier for American foot soldiers striving to engage with and destroy the enemy. That evolution reflects the enemy’s ability to learn and adapt. Whether they employ sophisticated technology or drape burlap bags over themselves to eliminate thermal signatures, thinking enemies invariably find ways to render the deadliest of weapons far less effective.","The same point applies to the employment of each of the branches of the U.S. Army. SOF, for example, have demonstrated that the individuals in their ranks are among the best-trained, best-equipped, and best-led soldiers in the world. In some ways, Afghanistan has provided an optimal battlefield for these warriors to demonstrate unique skills. Yet the high tempo and tension associated with back-to-back deployments result in unsustainable burdens being placed on these soldiers. In addition, although Special Operations units have unparalleled flexibility, they are not self-sustaining entities over extended periods or under specific circumstances. The necessity for close cooperation between communities was made clear repeatedly during ENDURING FREEDOM when infantrymen, fire supporters, logisticians, and planners from conventional units provided the edge needed by Special Operations personnel to accomplish an assigned mission in the most efficient manner possible.","The fifth lesson from Operation ENDURING FREEDOM is the critical importance of maintaining unity of command and unity of effort, especially in a coalition fight. Over the first four years of the conflict, the United States sought the appropriate operational approach in Afghanistan, shifting from counterterrorism to a limited counterinsurgency effort. When NATO began expanding the ISAF mission in 2005, it anticipated engaging in peacekeeping rather than sustained combat operations. The Army responded by effectively splitting its missions between counterinsurgency under ISAF and counterterrorism under ENDURING FREEDOM. This division included separate American command chains, with the former falling under NATO and the latter continuing under CENTCOM. Although General McNeill tied the American efforts together through his position as ISAF commander, some disconnects persisted within the Army’s operations and between American forces and their NATO allies. It was not until the establishment of USFOR-A under General McKiernan that the coalition effort achieved unity of command. Unity of effort, however, continued to be an issue as national caveats and political concerns resulted in inconsistent capabilities among NATO forces. Even within American operations, the creation of RC Southwest to facilitate the deployment of additional U.S. Marine Corps units unnecessarily disrupted and fragmented American operations. This resulted in an inconsistent effort by NATO forces, enabling the insurgents to take advantage of inefficiencies within the coalition. It is not known whether utilizing a unified command chain and a unified effort from the beginning would have made an appreciable impact on the conflict, but the lack of both aspects created unnecessary and self-inflicted difficulties for the coalition.","Sixth, Afghanistan offers clear evidence of the outsized impact that information operations can have on a conflict. The modern 24-hour news cycle, the prevalence of social media, and competition to dominate the conflict’s strategic narrative placed increased importance on events that were often of limited tactical or operational significance. The American “kill team” controversy, the insurgent attack at Wanat in 2008, and the burning of Qurans at Bagram in 2012 are all examples of small-scale events having significant operational and strategic impacts. They also illustrate the reality that in a persuasion campaign, one negative act can outweigh a hundred positive ones. The high-visibility attacks on Forward Operating Base SALERNO and Camp Bastion, intended primarily to generate news coverage, demonstrates that our foes are equally aware of the influence of mass media and even willing to expend personnel during operations of transitory value in order to gain advantage in that medium.","It should be recognized that the insurgents routinely displayed superiority in communicating with the Afghan people over the course of ENDURING FREEDOM. For all the Army’s efforts to build support for the central government and the coalition among the Afghan people, it could never match the insurgents’ ability to reach them. One problem was that turnover among coalition forces due to force rotations limited their ability to build lasting relationships with locals. The coalition also struggled by failing to make connections with local religious leaders. As in many majority-Muslim countries, mosques were a central element of Afghan communities. The coalition’s inability to establish a presence within the mosques, either directly or through relationships with the mullahs, cut the coalition off from a fundamental element of public discourse.","Most importantly, the coalition had no counterpoint to the simple fact that the threat of violence is more persuasive than the promise of communal betterment, especially when the former arises from within the permanent community whereas foreigners with transient local ties are linked with the latter. Despite its best intentions, the coalition would not remain in Afghanistan indefinitely, whereas the insurgents would. The Army, therefore, must improve its ability to work with indigenous actors to build genuine support among the population, with the understanding that those individuals would remain after the Americans depart.","The penultimate lesson of Operation ENDURING FREEDOM is that without security, there can be no stability. The overthrow of the Taliban government— while key to the American strategic objective of removing safe havens for international terrorists—left a security vacuum throughout Afghanistan. Warlords and militias proved unreliable substitutes for security forces controlled by an elected centralized authority. Neither the Afghan National Army nor the Afghan National Police existed, and it would take time and resources to establish them. Debates over the appropriateness and viability of nation building as a national strategy cannot afford to overlook that the agent for change responsible for removing a national government from power assumes responsibility for providing services to the affected population until a new government can be formed. The absence of a viable plan, or the resources to carry it out, will destabilize the affected society. While the Army cannot create security forces without active indigenous support and supplemental funding over a sustained period, it must take steps to maintain the knowledge base necessary to accomplish that mission in the future.",{"picture":{"source":"/figures/v2/img_14-1.png","caption":"A  Soldier watches over the Arghandab River Valley"}},"Finally, the U.S. Army’s experience in Afghanistan reinforces the maxim that war is a marathon and not a sprint. History is  replete with examples of politicians choosing to resolve national problems through conflict because they honestly believed that war would be a brief and ultimately successful endeavor—but the truth often has turned out differently. It is likely that few within the Army’s senior leadership shortly after 11 September 2001 would have predicted that Operation ENDURING FREEDOM would not end until 31 December 2014, and that it would continue even after that in some form under RESOLUTE SUPPORT. Few could have forecasted that the soldiers fighting in Afghanistan would be taking part in a second major effort in Iraq from 2003 through 2010 or, a few years later, in the battle against the so-called Islamic State. The enemy in each instance was not only tenacious but also tactically and operationally adaptive. Each war evolved to the point at which tactics, techniques, and procedures used by American troops near the end of the conflicts bore scant resemblance to those employed in opening battles. Policymakers and senior uniformed leaders alike would do well to remember what recent history has shown: what appears to be a decisive victory could merely be the start of a new and unpredictable kind of conflict. Leaders must clearly articulate the end state, provide the means to achieve that end state, and approve the ways in which it will be achieved—or risk repeating a protracted campaign.",{"picture":{"source":"/figures/v2/art_14-2.png","caption":"Comms Across the Valley"}}],"appendix a":[{"title":"Bibliographical Note"},"",{"title":"Documents and Publications","level":2},{"section":["The sources for this account by the Chief of Staff of the Army’s Operation Enduring Freedom Study Group were campaign plans, daily update briefings, and monthly and weekly reports compiled or composed before, during, and immediately after many of the events described in this account. They were collected in Afghanistan, from CENTCOM files at MacDill Air Force Base in Tampa, Florida, and from archival sources available at the U.S. Army Center of Military History at Fort McNair, D.C. Those caches of electronic documents—virtually all of which remain classified—were created by the headquarters overseeing the operations discussed in this narrative. These include CJTFs Mountain, 76, 82, 101, and 180; RC East, RC South, and RC Southwest; TF Phoenix; Office of Military Cooperation–Afghanistan and Office of Security Cooperation–Afghanistan; CFC-A; CSTC–A; and USFOR–A. Operational records from upper-echelon headquarters outside of Afghanistan, such as CENTCOM at MacDill Air Force Base; CFLCC at Camp Doha, Kuwait; and Southern European Task Force at Vicenza, Italy, also were useful sources of information.","Much of the documentation required to write about events happening after 2006 was generated by NATO ISAF and its subordinate commands. However, these records are classified by both U.S. and NATO sources. As a result, few of the NATO records were used because of the lengthy procedures required to declassify NATO material. Even more restrictive measures are in place in regards to the release of information on Special Operations activities after the March 2002 timeframe. However, there are a few online avenues for researchers to access formerly classified materials, including George Washington University’s National Security Archive and the CENTCOM Freedom of Information Act Web page. The U.S. material provides strategic level planning, diplomatic, and policy-making documents generated by the Departments of Defense and State, while material found on the latter site is devoted to declassified reports and investigations covering critical events involving U.S. forces in Afghanistan.","Useful unclassified accounts of Operation Enduring Freedom and the events leading up to that conflict include  retired Brig. Gen. John S. Brown’s ${Kevlar Legions: The Transformation of the U}{italic}.${S}{italic}. ${Army, 1989–2005}{italic} as well as two books by the U.S. Army Combat Studies Institute: ${A Different Kind of War: The United States Army in Operation Enduring Freedom}{italic},  October 2001 – September 2005 and ${Weapon of Choice: ARSOF in Afghanistan}{italic}. The material in ${Weapon of Choice}{italic} is amplified by the United States  Special Operations Command’s unclassified ${United States Special Operations Command History 1987–2007}{italic}. In addition to these unclassified  published accounts, primary source materials used to examine the conflict’s impact on the Army as an institution were collected from various staff sections of the  Headquarters, Department of the Army; the National Guard Bureau; Office of the Chief of Army Reserve; U.S. Army TRADOC at Fort Eustis, Virginia; U.S. Army Combined  Arms Center at Fort Leavenworth, Kansas; and U.S. Army Corps of Engineers headquarters in Washington, D.C.","A number of memoirs dealing with events leading up to the events of 11 September 2001 and the American reaction  to the terrorist attacks were consulted. While these accounts often provided a detailed, first-hand perspective of decisions made by senior policymakers and  commanders, in some cases they presented differing interpretations of events that required deconfliction by the Study Group. Useful accounts of events leading up to  the attacks and the U.S. response include CIA director George J. Tenet’s ${At the Center of the Storm: My Years at the CIA}{italic}, Chairman of the Joint Chiefs of  Staff General H. Hugh Shelton’s ${Without Hesitation: The Odyssey of an American Warrior}{italic}, CENTCOM commander General Tommy R. Franks’ ${American Soldier}{italic},  DoD policymaker Douglas J. Feith’s ${War and Decision: Inside the Pentagon at the Dawn of the War on Terrorism}{italic}, and former Secretary of  Defense Donald H. Rumsfeld’s ${Known and Unknown: A Memoir}{italic}. For the post-2002 timeframe, the Study Group utilized Chairman of the  Joint Chiefs of Staff General Richard B. Myers’ ${Eyes on the Horizon: Serving on the Front Lines of National Security}{italic}, Secretary of Defense  Robert M. Gates’ ${Duty: Memoirs of a Secretary at War}{italic}, as well as autobiographies of ISAF commanders, including General Sir David J. Richards’  ${Taking Command}{italic} and General Stanley A. McChrystal’s ${My Share of the Task: A Memoir}{italic}.","In addition to the recollections of senior officials and military officers, American and British soldiers have written  a number of eyewitness accounts that convey a human perspective often invisible to operational and strategic  level participants. These include Robert S. Anders’ ${Winning Paktika: Counterinsurgency in Afghanistan}{italic},  Doug Beattie’s ${Task Force Helmand: A Soldier’s Story of Life, Death and Combat on the Afghan Front Line}{italic},  Jimmy Blackmon’s ${Pale Horse: Hunting Terrorists and Commanding Heroes with the 101st Airborne Division}{italic},  Ronald Fry’s ${Hammerhead Six: How Green Berets Waged an Unconventional War Against the Taliban to Win in Afghanistan’s Deadly Pech Valley}{italic}, Carter Malkasian’s incomparable ${War Comes to Garmser: Thirty Years of Conflict on the Afghan Frontier}{italic},  Dakota Meyer’s ${Into the Fire: A Firsthand Account of the Most Extraordinary Battle in the Afghan War}{italic},  Sean Parnell’s ${Outlaw Platoon: Heroes, Renegades, Infidels, and the Brotherhood of War in Afghanistan}{italic},  Clinton Romesha’s ${Red Platoon: A True Story of American Valor}{italic}, and Stuart Tootal’s ${Danger Close: Commanding 3 Para in Afghanistan}{italic}"]},{"title":"Oral History Interviews and Manuscript Sources","level":2},{"section":["The OEF Study Group’s efforts to interview various notables for the project proved very productive due to the tremendous cooperation it received from virtually everyone contacted. While the roster of prominent civilian officials and military officers—both American and allied—who agreed to be interviewed is too lengthy to list in its entirety, the Study Group gratefully acknowledges President George W. Bush, Vice President Richard B. “Dick” Cheney, Secretaries of Defense Robert M. Gates, Leon E. Panetta, and Charles T. “Chuck” Hagel; CENTCOM commanders Tommy R. Franks, John P. Abizaid, David H. Petraeus, and Lloyd J. Austin III; Ambassadors Ronald E. Neumann, Zalmay Khalilzad, Karl W. Eikenberry, William B. Wood, and Robert P. J. Finn; ISAF commanders Dan K. McNeill, David D. McKiernan, and Stanley A. McChrystal; RC East commanders James J. Schlosser and Curtis M. Scaparrotti; RC South commanders British General Sir Nicholas P. Carter and Dutch Lt. Gen. Mart De Kruif; senior Marine commanders Lt. Gen. Lawrence D. Nicholson and Lt. Gen. Richard P. Mills; and Washington Post reporter Bob Woodward, who provided key insights into the Obama White House. Many other individuals not listed here kindly consented to being interviewed and for that courtesy the Study Group is profoundly grateful.","The authors also made use of unpublished first-person accounts written to satisfy academic requirements in U.S. Army professional development courses. Most prominent were Personal Experience Papers by students attending the Maneuver Captains Career Course at Fort Benning, Georgia’s Maneuver Center of Excellence. Several hundred of these accounts have been declassified and posted on Army Knowledge Online and the Fort Benning Donovan Research Library Web site. Similar narratives utilized by the Study Group included those authored by senior noncommissioned officers attending the U.S. Army Sergeant Majors Academy at Fort Bliss, Texas, available online via the U.S. Army Command and General Staff College’s Ike Skelton Combined Arms Research Library digital collection. That same collection contains Afghanistan-related interviews conducted by Combat Studies Institute historians for the Operational Leadership Experience series.","Recognizing the need to capture information on key events soon after they occurred, the U.S. Army deployed a number of Military History Detachments to Afghanistan during the opening phase of Operation Enduring Freedom. Maj. Richard M. Brown’s 130th Military History Detachment and Maj. John Warsinke’s 47th Military History Detachment conducted valuable interviews between March and July 2002. Following the 2001–2002 timeframe, however, most Military History Detachments were deployed to Iraq, and few U.S. Army historians served in Afghanistan between 2003 and 2010. After discovering large gaps in the available Military History Detachment collections, the OEF Study Group conducted a targeted collection effort by compiling multiple terabytes of electronic records from Maj. Gen. John M. Murray’s 3d Infantry Division headquarters at Bagram and General John F. Campbell’s ISAF headquarters in Kabul."]},{"title":"Secondary Sources","level":2},{"section":["Commercially produced accounts augmented or filled gaps in our primary sources. Although the Study Group drew on information from  many publications, several are worth singling out. For a useful general overview, both Peter Tomsen’s  ${The Wars of Afghanistan: Messianic Terrorism, Tribal Conflicts, and the Failures of Great Powers}{italic} and Thomas J. Barfield’s  ${Afghanistan: A Cultural and Political History}{italic} proved informative. Valuable accounts that shed additional light on extremist  influences in the Middle East and Central Asia included not only Barfield and Tomsen, but also  Peter Bergen’s ${The Osama bin Laden I Know: An Oral History of Al-Qaeda’s Leader}{italic}, Mustafa Hamid and  Leah Farrall’s ${The Arabs at War in Afghanistan}{italic}, Ahmed Rashid’s ${Taliban: Militant Islam, Oil and Fundamentalism in Central Asia}{italic},  and Seth G. Jones’ ${Hunting in the Shadows: The Pursuit of al Qa’ida since 9/11.}{italic}","A selection of useful books on U.S. and ISAF conventional units includes Patrick Bishop’s ${3 Para}{italic},  Stephen Grey’s ${Into the Viper’s Nest: Task Force 1 Fury and the Battle of Musa Qala}{italic},  Toby Harnden’s ${Dead Men Risen: The Welsh Guards and the Defining Story of Britain’s War in Afghanistan}{italic},  Col. Bernd Horn’s ${No Lack of Courage: Operation Medusa, Afghanistan}{italic},  Jake Tapper’s ${The Outpost: An Untold Story of American Valor}{italic},  Gregg Zoroya’s ${The Chosen Few: A Company of Paratroopers and Its Heroic Struggle to Survive in the Mountains of Afghanistan}{italic},  Col. Nathan S. Lowrey’s $${U}{italic}.${S}{italic}. ${Marines in Afghanistan 2001–2002: From the Sea}{italic}, and compiler David W. Kummer’s ${U}{italic}.${S}{italic}. ${Marine Corps in Afghanistan, 2001–2009: Anthology and Annotated Bibliography}{italic} and its companion volume by  Paul W. Westermeyer with Christopher Blaker  entitled ${U}{italic}.${S}{italic}. ${Marines in Afghanistan, 2010–2014: Anthology and Annotated Bibliography}{italic}.","There are a similar, if not greater, number of detailed and well-written accounts dealing with special operations in Afghanistan,  notable among which are Eric Blehm’s ${The Only Thing Worth Dying For: How Eleven Green Berets Fought for a New Afghanistan}{italic},  Rusty Bradley and Kevin Maurer’s ${Lions of Kandahar: The Story of a Fight Against All Odds}{italic},  Daniel R. Green’s ${In the Warlords’ Shadow: Special Operations Forces, the Afghans, and Their Fight Against the Taliban}{italic}, Linda Robinson’s exceptional ${One Hundred Victories: Special Ops and the Future of American Warfare}{italic}, and  Mitch Weiss and Kevin Maurer’s ${No Way Out: A Story of Valor in the Mountains of Afghanistan.}{italic}","The OEF Study Group also relied on published accounts of nation building and coalition warfare, both of which are central to the  Afghanistan conflict. A few of the books consulted for reference on these topics include  James F. Dobbins’ ${After the Taliban: Nation-Building in Afghanistan}{italic};  Ahmed Rashid’s ${Descent into Chaos: The U.S. and the Disaster in Pakistan, Afghanistan}, and Central Asia{italic};  and ${Coalition Challenge in Afghanistan: The Politics of Alliance}{italic}, edited by Gale A. Mattox and Stephen M. Grenier.","Think tank papers and government reports frequently contain facts unavailable elsewhere. First and foremost among sources  covering the period from October 2008 onward were Special Inspector General for Afghanistan Reconstruction reports submitted quarterly to Congress. Among private institutions, the Santa Monica, California–based RAND Corporation has produced a number of useful studies of Afghanistan, including Terrence K. Kelley, Nora Bensahel, and Olga Oliker’s ${Security Force Assistance in Afghanistan: Identifying Lessons for Future Efforts}{italic}, Seth G. Jones and Arturo Muñoz’s ${Afghanistan’s Local War: Building Local Defense Forces}{italic}, and C. Christine Fair’s  ${The Counterterror Coalitions: Cooperation with Pakistan and India}{italic}. Many articles and publications by RAND’s competitors—the majority of which are located in Washington, D.C.—not only enlightened OEF Study Group members but also provided valuable insights to senior commanders in Afghanistan. Sources for these pieces include the Center for Strategic and International Studies, the Institute for the Study of War, the Brookings Institution, the Center for a New American Security, and the Foundation for Defense of Democracies. The last named institution also hosts Bill Roggio’s informative ${Long War Journal}{italic} Web site.","Newspapers often can provide historians with perspectives and facts found nowhere else. Useful media sources on events in Afghanistan for the OEF Study Group included the ${Los Angeles Times, New York Times}{italic}, and ${Washington Post}{italic}; the British newspapers the ${Guardian}{italic} and the ${Independent}{italic}; the Pakistani newspaper ${Dawn}{italic}, and ${Agence France-Presse}{italic}. When consulting these sources,  the OEF Study Group members normally compared multiple accounts from various publications before settling on an accepted version of events in order to compensate for inadvertent errors introduced by journalists writing under tight deadlines. This precaution, however, did not have to be used as frequently when consulting pieces by reporters on extended assignment in the region."]}],"appendix b":[{"title":"Operation Enduring Freedom Study Group Biographies"},"${Col. (Ret.) Edmund J. “EJ” Degen}{bold}, a career field artillery officer, currently serves as the director of the Chief of Staff,  Army’s Operation Enduring Freedom Study Group. He has commanded artillery units at all levels through brigade, and served as the V Corps (U.S.) chief of plans for the Iraq invasion at the start of Operation Iraqi Freedom, chief of future operations for U.S. Forces Korea, and chief of staff for Combined Joint Interagency Task Force 435 in Afghanistan. Colonel Degen was a fellow on the CSA’s inaugural Strategic Studies Group and served as the Senior Fellow the following year. He has multiple combat deployments to Iraq and Afghanistan. Colonel Degen has an  MMAS (Master of Military Art and Science) from the Army’s School of Advanced Military Studies and an MS in  Strategic and Operational Planning from the Joint Advanced Warfighting School. He is the coauthor of  ${On Point: The United States Army in Operation Iraqi Freedom}{italic} (Annapolis, Md.: Naval Institute Press, 2005),  along with numerous journal articles.","${Col. Adrian A. Donahoe}{bold}, a Special Forces officer, enlisted in the Iowa National Guard in 1987. He was commissioned and entered active-duty service in 1993 after graduating from the University of South Dakota. He completed the Special Forces Qualification Course in 1999 and has served in various command and staff positions within Special Operations and the conventional Army. He is a veteran of Operation Enduring Freedom and multiple Operation Enduring Freedom–Philippines deployments. Colonel Donahoe holds an MS from the Naval Postgraduate School and an MMAS from the School of Advanced Military Studies. He is the former director of Special Operations Leadership Development and Education at Fort Leavenworth, Kansas, and the director of the Commander’s Action Group for NATO Special Operations Component Command-Afghanistan/Special Operations Joint Task Force Afghanistan.","${Col. Bryan R. Gibby}{bold} is the chief of the Military History Division in the Department of History, United States Military Academy,  West Point. A 1993 West Point graduate, he was awarded master’s and doctoral degrees in history from Ohio State University.  Colonel Gibby is a career military intelligence officer and has served in command and staff assignments from tactical to strategic levels. His most recent operational experience was as Commander, 707th Military Intelligence Battalion, providing SIGINT (signals intelligence)  support to the CENTCOM areas of responsibility. He twice deployed in Operation Iraqi Freedom as a brigade (2007–2008) and division (2005–2006) intelligence officer. Following service in Iraq, Colonel Gibby joined Allied Force Command, Madrid, where he served as the chief of intelligence assessments for CJTF Unified Protector in 2011. He is the author of ${The Will to Win: American Military Advisors in Korea, 1946–1953.}{italic}","${Dr. Brian F. Neumann}{bold} is a historian at the U.S. Army Center of Military History. He earned his BA in history from the University of Southern California in 1998 and his MA and PhD in history from Texas A&M University in 2001 and 2006, respectively. His academic field is twentieth-century U.S. military history with a focus on World War I. After teaching for four years, he joined CMH in 2010 and began working in the Contemporary Studies Branch, Histories Division, with a focus on Operation Enduring Freedom. He cowrote and edited the center’s campaign brochure on Operation Enduring Freedom 2002–2005. After working with the CSA’s OEF Study Group for two years, Dr. Neumann became the editor of the “U.S. Army Campaigns of World War One” commemorative pamphlet series in November 2016. He also serves as a member of the CMH World War I Commemoration Committee and as the Center’s World War I subject matter expert.","${Col. Francis J. H. Park}{bold} is a historian in the Joint History and Research Office of the Joint Staff. Prior to his current assignment, he was the chief of the Strategy Development Division in the Joint Staff J-5. After commissioning in 1994, he served in command and staff duties primarily in armored cavalry and light airborne cavalry assignments. Designated an Army strategist in 2004, he has served at division, corps, army service component command, and joint task force levels, as well as in the Army Staff and Joint Staff. His service in Operation Enduring Freedom spans 2008–2009 as principal campaign planner for CJTF 101 and RC East, and 2013–2014 as deputy director, Commander’s Action Group, ISAF. His other combat experience includes Operations Iraqi Freedom and Inherent Resolve. Colonel Park holds a BA in history from the Johns Hopkins University; an MA in international relations from St. Mary’s University of San Antonio, Texas; an MMAS from the School of Advanced Military Studies; and a PhD in history from the University of Kansas.","${Mr. Mark J. Reardon}{bold} is a senior civilian historian with the U.S. Army Center of Military History. Before joining the Center in 2006, he served as a regular officer in parachute, reconnaissance, and armor units during a twenty-seven-year career in the Army, and retired as a lieutenant colonel. Mr. Reardon, who recently completed a manuscript for the Center on training the post– Saddam Iraqi Army, has also published four books on World War II and Korea, a history of the initial Stryker Brigade deployment to Iraq, several detailed studies of small-unit actions in Iraq, and three studies on U.S. military innovation in World War II.","${Dr. Gregory G. Roberts}{bold} is a desk officer in the State Department’s Office of Afghanistan Affairs. As a Presidential Management  Fellow (2014–2016), he served as a historian at the U.S. Army Center of Military History and the Combat Studies Institute,  and as a special assistant to the Chairman of the Joint Chiefs of Staff in the Chairman’s Action Group. Prior to  entering federal service, Dr. Roberts worked as a research associate in national security studies at the Council on Foreign Relations.  In 2013, he earned a PhD in history from Yale University, where his research focused on policing in medieval Italy.  He earned an MA and an MPhil in history from Yale in 2010, and a BA in history and a BA in French from Vanderbilt University in 2007.  Dr. Roberts has published on OEF in the ${SAIS Review of International Affairs}{italic} and has a chapter in the forthcoming volume  ${Makers of Modern Landpower: Post-9/11 Perspectives}{italic} (University Press of Kentucky).","${Lt. Col. (Ret.) Matthew B. Smith}{bold} is a graduate of Norwich University where he was commissioned field artillery officer in 1999. His initial assignment was with the 1st Battalion, 94th Field Artillery Regiment, in Idar-Oberstein, Germany. As a battery commander, he deployed with his unit to Iraq and assumed the mission for all surface-to-surface guided MLRS (multiple launch rocket system) fires throughout Multinational Corps–Iraq. Colonel Smith was then assigned as a Fires Observer Trainer with the Mission Command Training Program at Fort Leavenworth, Kansas. Upon graduating the Command and General Staff College, he reported to the 2nd Brigade Combat Team, 10th Mountain Division, in Fort Drum, New York. He deployed to Paktika Province, Afghanistan, in January 2013 and conducted security force assistance with the ANA. Colonel Smith holds an MS in management and business from Webster University.","${Lt. Col. (Ret.) John R. Stark}{bold} retired in 2017 as an armor lieutenant colonel after twenty-five years of service. He graduated as a distinguished cadet from West Point in 1991 and earned an MA (2000) and a PhD (2003) in European history from Ohio State University. He has taught history at West Point and Princeton. While in the Army, he served in Iraq in 2006–2007 as operations officer for t he 1st Battalion, 37th Armor “Bandits,” in Sinjar and Ramadi and in Afghanistan in 2011–2012 for NATO Rule of Law Field Support Mission in Kandahar and Kabul. He was an Observer-Controller-Trainer at the Joint Military Readiness Center in Hohenfels, Germany, where the Grizzly team trained forces for Afghanistan, Iraq, and Kosovo in 2007–2008. He served at NATO headquarters in 2013–2014 as a liaison officer for Allied Command Transformation, Capabilities Engineering and Innovation. He continues his service to the nation as a diplomat at the Department of State.","${Maj. Miranda M. Summers-Lowe}{bold} is a curator of modern military history at Smithsonian’s National Museum of American History and an officer in the District of Columbia National Guard. She enlisted in the Army National Guard in 2002 and served as a supply sergeant in Iraq in 2005 before commissioning through Officer Candidate School in 2009. Other assignments include state public affairs officer, command historian, and intelligence officer in the District of Columbia National Guard. She most recently served as the deputy director of public affairs for CJTF-Horn of Africa in Djibouti and as a public affairs adviser in the Office of the Director, Army National Guard. She was selected as an Army Congressional Fellow and a nonresident fellow of the Modern War Institute at West Point in 2019. Her work has been published in Military Review, War on the Rocks, and the New York Times. She has a BA in history from the College of William and Mary and a master’s in public humanities from Brown University.","${Col. Victor H. Sundquist}{bold}, an intelligence officer, enlisted with the 7th Infantry Division in 1988. He was commissioned in the Intelligence Branch from the United States Military Academy at West Point in 1995 and transitioned to the Army Strategist Functional Branch in 2014. He holds a MMAS from the School of Advanced Military Studies and an MS in counterterrorism theory from Henley-Putnam University. He is a 2016 graduate of the Army’s Senior Service War College, where he served as a Fellow at Georgetown University in the Institute for the Study of Diplomacy under the School of Foreign Service. During his twenty-eight years in the Army, he has served in various intelligence and strategist positions at all levels of command, including assignments in CENTCOM’s J–2 staff; the J–2X at ISAF headquarters; the 1st Cavalry Division G–2; the State Department’s Provincial Reconstruction Team in Basra, Iraq; deputy director for the Headquarters, Department of the Army’s War Plans Division; and most recently as the J–53 plans chief at U.S. Southern Command. He has multiple operational and combat tours, including Operations Southern Watch, Enduring Freedom, Iraqi Freedom, and New Dawn.","${Dr. Colin Jay Williams}{bold} is the command historian for the Defense Logistics Agency. A retired Army officer, he taught military history  at the United States Military Academy and has combat experience in both Afghanistan and Iraq. He received a PhD in military history from the University of Alabama and has been published in Key to the Northern Country: The Hudson River Valley in the American Revolution (SUNY Press, 2013) and New York History (vol. 99, no. 1).",{"figure":{"source":"/figures/m/map-bm-afghanistan-2005-2014.svg","caption":"Afghanistan 2005-2014","prefix":"Supplemental Map"}}],"glossary":{"details":"The following terms and definitions, drawn from official Army publications and used in the text of this book, are provided here for the reader’s ease of reference.","TEXT ACRONYMS AND ABBREVIATIONS":{"ANA":"Afghan National Army","ANP":"Afghan National Police","ANSF":"Afghan National Security Forces","ARCENT":"U.S. Army Central Command","CBU":"cluster bomb unit","CENTCOM":"U.S Central Command","CFACC":"Combined Forces Air Component Command","CFC-A":"Combined Forces Command–Afghanistan","CFLCC":"Coalition Forces Land Component Command","CIA U.S.":"Central Intelligence Agency","CJSOTF":"Combined Joint Special Operations Task Force","CJTF":"Combined Joint Task Force","CMH":"U.S. Army Center of Military History","CSA":"Chief of Staff, Army","DoD":"Department of Defense","FORSCOM":"U.S. Army Forces Command","HIG":"Hezb-e-Islami Gulbuddin","HMMWV":"High Mobility Multipurpose Wheeled Vehicle","IED":"improvised explosive device","ISAF":"International Security Assistance Force","JDAM":"Joint Direct Attack Munition","JSOTF":"Joint Special Operations Task Force","MEDEVAC":"medical evacuation","MLRS":"multiple launch rocket system","MMAS":"Master of Military Art and Science","NATO":"North Atlantic Treaty Organization","ODA":"Operational Detachment Alpha","OEF":"Operation Enduring Freedom","RC":"Regional Command","RMA":"Revolution in Military Affairs","SIGINT":"signals intelligence","SOAR":"Special Operations Aviation Regiment","SOF":"Special Operations Forces","TF":"Task Force","TRADOC":"U.S. Army Training and Doctrine Command","UA":"units of action","UEx":"Units of Employment X","UEy":"Units of Employment Y","UN":"United Nations","U.S.":"United States"}},"references":{"SELECTED TEXT":["${Department of the Army Field Manual (FM) 3–24}{bold}.${2, Tactics in Counterinsurgency, 21 April 2009 (Selected Text)}{bold}.","A ${clear-hold-build}{italic} operation is a full spectrum operation that combines offense (finding and eliminating the insurgent), defense (protecting the local populace) and stability (rebuilding the infrastructure, increasing the legitimacy of the local government, and bringing the rule of law to the area) operations. Each phase—clear, hold, and build—combines offensive, defensive, and stability operations in varying degrees. In the ${clear}{italic} phase, offensive operations usually dominate; in the ${hold}{italic} phase, defensive operations are emphasized; and in the ${build}{italic} phase, stability operations are preeminent. It is usually a relatively long term operation and requires the commitment of a large number of forces. Clear-hold-build operations are often preceded by shaping operations to set the proper conditions.","${Shape}{bold} – A shaping operation is an operation at any echelon that creates and preserves conditions for the success of the decisive operation.","${Clear}{bold} – Clear is a tactical mission task that requires the commander to remove all enemy forces and eliminate organized resistance within an assigned area (FM 3–90). The force does this by destroying, capturing, or forcing the withdrawal of insurgent combatants and leaders. This task is most effectively initiated by a clear-in-zone or cordon-and-search operation, as well as patrolling, ambushes, and targeted raids.","${Hold}{bold} – After clearing the area of guerrillas, the counterinsurgent force must then assign sufficient troops to the cleared area to prevent their return, to defeat any remnants, and to secure the population. This is the hold task. Ideally, Host Nation security forces execute this part of the clear hold- build operation. Success or failure depends on effectively and continuously securing the populace and on reestablishing a Host Nation local government. Although offensive and stability operations continue, this phase uses defensive operations to secure the population.","${Build}{bold} – The build phase of clear-hold-build operations consists of carrying out programs designed to remove the root causes that led to the insurgency, improve the lives of the inhabitants, and strengthen the Host Nation’s ability to provide effective governance. Stability operations predominate in this phase, with many important activities being conducted by nonmilitary agencies. During this phase, the Host Nation security forces should have primary responsibility for security. Progress in building support for the Host Nation government requires protecting the local populace. People who do not believe they are secure from insurgent intimidation, coercion, and reprisals will not risk overtly supporting counterinsurgent efforts."],"FOREIGN TERMS":["${al-Qaeda}{italic}  -  the foundation or the base [organization name]","${Amir al-Mahmunen }{italic}  - Commander of the Faithful","${bayat}{italic}  - an oath of personal allegiance","${burqa}{italic}  - head-to-toe covering","${fatwa}{italic}  - a deliberate call to arms for believers","${jihad}{italic}  - struggle, in the sense of a holy war waged on behalf of Islam","${kandak}{italic}  - Afghan battalion-sized unit","${loya jirga}{italic}  - grand assembly, akin to a national convention","${madrassa}{italic}  - religious educational institution","${melmastiia}{italic}  -  the obligation to offer protection to guests","${mujahideen}{italic}  - those who are struggling or striving for a praiseworthy aim","${pashtunwali}{italic}  - the ancient Pashtun code of conduct that includes a strong tradition of hospitality","${Qala-i-Jangi}{italic}  - house of war [place name]","${sharia}{italic}  - Islamic religious law","${shura}{italic}  - a local consultative council or assembly","${talib}{italic}  -  individual member of the Taliban","${Taliban}{italic}  - students of Islam [organization name]","${ushr}{italic}  - a 10 percent tithe, paid in kind","${wadi}{italic}  - dry riverbed"],"Selected U.S. Military Staff Designations":["C-3 Combined (Coalition) operations","CCJ5-CMO Combined (Coalition) joint planning–civil-military operations","CCJ5-ANA  Combined (Coalition) joint planning–Afghan National Army","CJ–3 Combined (Coalition) joint operations","CJ–35 Combined (Coalition) joint future operations","G–3/5/7 Army operations, plans, and training","J–3  Joint staff intelligence","J–5 Joint staff operations","J–9  Joint staff planning","S–2 Joint staff civil-military cooperation","S-3 battalion or brigade intelligence","C-3 battalion or brigade operations"],"ARMY PUBLICATIONS":["Army Doctrine Publication 1–02, Terms and Military Symbols, 14 August 2018","Most Army doctrinal publications are available online at ${http://www.apd.army.mil}{link: http://www.apd.army.mil}."],"WEB SITES":["${U.S. Army Center of Military History}{link: https://history.army.mil/}"]}}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonpath__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonpath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonpath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_natural_orderby__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_content_book_json__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_content_book_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_content_book_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_state_AppState__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_state_tree__ = __webpack_require__(89);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var metadata=__WEBPACK_IMPORTED_MODULE_3_content_book_json___default.a.metadata,Book=_objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_3_content_book_json___default.a,["metadata"]);var pages=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keys(Book);var bodyBounds={first:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(pages,function(entry){return entry.includes("chapter");}),last:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findLastIndex(pages,function(entry){return entry.includes("chapter");})};/* 
//DEBUG:
console.log("bodyBounds First " + bodyBounds.first);
console.log("bodyBounds Last " + bodyBounds.last); */var frontMatter=pages.slice(0,bodyBounds.first);//get sections
var section=Object(__WEBPACK_IMPORTED_MODULE_2_natural_orderby__["a" /* orderBy */])(pages.filter(function(entry){return entry.includes("section");}));var body=Object(__WEBPACK_IMPORTED_MODULE_2_natural_orderby__["a" /* orderBy */])(pages.filter(function(entry){return entry.includes("chapter");}));/* console.log(
  "body keys before insert = " +
    Object.keys(body) +
    "value: " +
    Object.values(body)
);  *//* console.log("section" + section);
console.log(section[0]);
console.log(section[1]);
console.log(section[2]);
  *//************* UPDATE CHAPTER SECTION KEY HERE TO  *************************//*
INSERT section II, and Section III
NOTE: UPDATE key index to ensure navigation fwd/bwd works
*/body.splice(5,0,section[1]);//section II
body.splice(10,0,section[2]);//section III
/* console.log(" ******************* after splice  ********* ");
Object.keys(body).forEach((prop) => console.log(prop));
Object.values(body).forEach((prop) => console.log(prop));
console.log(" ******************* END after splice  ********* ");
 */var backMatter=pages.slice(bodyBounds.last+1);pages=[].concat(_toConsumableArray(frontMatter),_toConsumableArray(body),_toConsumableArray(backMatter));//DEBUG
/* console.log("PAGES LENGTH " + pages.length);
console.log(" ******************* pages after splice  ********* ");
for (var i = 0; i < pages.length; i++) {
  console.log("pages: [" + i + "]" + pages[i]);
} *//* Object.keys(pages).forEach((prop) => console.log(prop));
Object.values(pages).forEach((prop) => console.log(prop)); *//* console.log(Object.keys(pages));
console.log(Object.values(pages));
console.log(Object.entries(pages));
 */var Contents={};Contents.source=undefined;Contents.get=function(path){var book=Contents.source||Book;return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(book,__WEBPACK_IMPORTED_MODULE_1_jsonpath___default.a.stringify(path).replace(/^[$.]+/i,""));};Contents.extract=function(path,prop){var book=Contents.source||Book;path=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.dropRight(path);return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(book,__WEBPACK_IMPORTED_MODULE_1_jsonpath___default.a.stringify(path).slice(1)+"."+prop);};var selectedIndex=function selectedIndex(){return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.indexOf(pages,__WEBPACK_IMPORTED_MODULE_4_app_state_AppState__["a" /* default */].selectedSection[1]);};Contents.hasNextSection=function(){return selectedIndex(__WEBPACK_IMPORTED_MODULE_4_app_state_AppState__["a" /* default */].selectedSection)<pages.length-1;};Contents.hasPreviousSection=function(){return 0<selectedIndex(__WEBPACK_IMPORTED_MODULE_4_app_state_AppState__["a" /* default */].selectedSection);};Contents.nextSection=function(){if(Contents.hasNextSection()){var path=pages[selectedIndex()+1];//12 MAR OEF TOC/SECTION path = path.includes("chapter") ? [path, 0] : [path];
if(path.includes("chapter")){//DEBUG: console.log("IN IF NEXT SECTION ");
path=[path,0];}else if(path.includes("section")){//DEBUG:  console.log("IN ELSE IF NEXT SECTION ");
path=[path,0];}else{//DEBUG:  console.log("IN ELSE NEXT");
path=[path];}//DEBUG:  console.log("PATH " + path);
__WEBPACK_IMPORTED_MODULE_4_app_state_AppState__["a" /* default */].changeSectionItem(["$"].concat(_toConsumableArray(path)));}};Contents.previousSection=function(){if(Contents.hasPreviousSection()){var path=pages[selectedIndex()-1];//path = path.includes("chapter") ? [path, 0] : [path];
//12 MAR 21 OEF TOC/Section change
if(path.includes("chapter")){path=[path,0];}else if(path.includes("section")){path=[path,0];}else{path=[path];}__WEBPACK_IMPORTED_MODULE_4_app_state_AppState__["a" /* default */].changeSectionItem(["$"].concat(_toConsumableArray(path)));}};/* harmony default export */ __webpack_exports__["a"] = (Contents);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return types; });
/* unused harmony export typecheck */
/* unused harmony export escapeJsonPath */
/* unused harmony export unescapeJsonPath */
/* unused harmony export joinJsonPath */
/* unused harmony export splitJsonPath */
/* unused harmony export decorate */
/* unused harmony export addMiddleware */
/* unused harmony export process */
/* unused harmony export isStateTreeNode */
/* unused harmony export flow */
/* unused harmony export applyAction */
/* unused harmony export onAction */
/* unused harmony export recordActions */
/* unused harmony export createActionTrackingMiddleware */
/* unused harmony export setLivelynessChecking */
/* unused harmony export getType */
/* unused harmony export getChildType */
/* unused harmony export onPatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onSnapshot$$1; });
/* unused harmony export applyPatch */
/* unused harmony export recordPatches */
/* unused harmony export protect */
/* unused harmony export unprotect */
/* unused harmony export isProtected */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applySnapshot$$1; });
/* unused harmony export getSnapshot */
/* unused harmony export hasParent */
/* unused harmony export getParent */
/* unused harmony export hasParentOfType */
/* unused harmony export getParentOfType */
/* unused harmony export getRoot */
/* unused harmony export getPath */
/* unused harmony export getPathParts */
/* unused harmony export isRoot */
/* unused harmony export resolvePath */
/* unused harmony export resolveIdentifier */
/* unused harmony export getIdentifier */
/* unused harmony export tryResolve */
/* unused harmony export getRelativePath */
/* unused harmony export clone */
/* unused harmony export detach */
/* unused harmony export destroy */
/* unused harmony export isAlive */
/* unused harmony export addDisposer */
/* unused harmony export getEnv */
/* unused harmony export walk */
/* unused harmony export getMembers */
/* unused harmony export getPropertyMembers */
/* unused harmony export cast */
/* unused harmony export isType */
/* unused harmony export isArrayType */
/* unused harmony export isFrozenType */
/* unused harmony export isIdentifierType */
/* unused harmony export isLateType */
/* unused harmony export isLiteralType */
/* unused harmony export isMapType */
/* unused harmony export isModelType */
/* unused harmony export isOptionalType */
/* unused harmony export isPrimitiveType */
/* unused harmony export isReferenceType */
/* unused harmony export isRefinementType */
/* unused harmony export isUnionType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(120);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

/**
 * Returns the _actual_ type of the given tree node. (Or throws)
 *
 * @export
 * @param {IStateTreeNode} object
 * @returns {IAnyType}
 */
function getType$$1(object) {
    return getStateTreeNode$$1(object).type;
}
/**
 * Returns the _declared_ type of the given sub property of an object, array or map.
 *
 * @example
 * const Box = types.model({ x: 0, y: 0 })
 * const box = Box.create()
 *
 * console.log(getChildType(box, "x").name) // 'number'
 *
 * @export
 * @param {IStateTreeNode} object
 * @param {string} child
 * @returns {IAnyType}
 */
function getChildType$$1(object, child) {
    return getStateTreeNode$$1(object).getChildType(child);
}
/**
 * Registers a function that will be invoked for each mutation that is applied to the provided model instance, or to any of its children.
 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details. onPatch events are emitted immediately and will not await the end of a transaction.
 * Patches can be used to deep observe a model tree.
 *
 * @export
 * @param {Object} target the model instance from which to receive patches
 * @param {(patch: IJsonPatch, reversePatch) => void} callback the callback that is invoked for each patch. The reversePatch is a patch that would actually undo the emitted patch
 * @returns {IDisposer} function to remove the listener
 */
function onPatch$$1(target, callback) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof callback !== "function")
            fail("expected second argument to be a function, got " + callback + " instead");
    }
    return getStateTreeNode$$1(target).onPatch(callback);
}
/**
 * Registers a function that is invoked whenever a new snapshot for the given model instance is available.
 * The listener will only be fire at the and of the current MobX (trans)action.
 * See [snapshots](https://github.com/mobxjs/mobx-state-tree#snapshots) for more details.
 *
 * @export
 * @param {Object} target
 * @param {(snapshot: any) => void} callback
 * @returns {IDisposer}
 */
function onSnapshot$$1(target, callback) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof callback !== "function")
            fail("expected second argument to be a function, got " + callback + " instead");
    }
    return getStateTreeNode$$1(target).onSnapshot(callback);
}
/**
 * Applies a JSON-patch to the given model instance or bails out if the patch couldn't be applied
 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details.
 *
 * Can apply a single past, or an array of patches.
 *
 * @export
 * @param {Object} target
 * @param {IJsonPatch} patch
 * @returns
 */
function applyPatch$$1(target, patch) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof patch !== "object")
            fail("expected second argument to be an object or array, got " + patch + " instead");
    }
    getStateTreeNode$$1(target).applyPatches(asArray(patch));
}
/**
 * Small abstraction around `onPatch` and `applyPatch`, attaches a patch listener to a tree and records all the patches.
 * Returns an recorder object with the following signature:
 *
 * @example
 * export interface IPatchRecorder {
 *      // the recorded patches
 *      patches: IJsonPatch[]
 *      // the inverse of the recorded patches
 *      inversePatches: IJsonPatch[]
 *      // stop recording patches
 *      stop(target?: IStateTreeNode): any
 *      // resume recording patches
 *      resume()
 *      // apply all the recorded patches on the given target (the original subject if omitted)
 *      replay(target?: IStateTreeNode): any
 *      // reverse apply the recorded patches on the given target  (the original subject if omitted)
 *      // stops the recorder if not already stopped
 *      undo(): void
 * }
 *
 * @export
 * @param {IStateTreeNode} subject
 * @returns {IPatchRecorder}
 */
function recordPatches$$1(subject) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(subject))
            fail("expected first argument to be a mobx-state-tree node, got " + subject + " instead");
    }
    var disposer = null;
    function resume() {
        if (disposer)
            return;
        disposer = onPatch$$1(subject, function (patch, inversePatch) {
            recorder.rawPatches.push([patch, inversePatch]);
        });
    }
    var recorder = {
        rawPatches: [],
        get patches() {
            return this.rawPatches.map(function (_a) {
                var a = _a[0];
                return a;
            });
        },
        get inversePatches() {
            return this.rawPatches.map(function (_a) {
                var _ = _a[0], b = _a[1];
                return b;
            });
        },
        stop: function () {
            if (disposer)
                disposer();
            disposer = null;
        },
        resume: resume,
        replay: function (target) {
            applyPatch$$1(target || subject, recorder.patches);
        },
        undo: function (target) {
            applyPatch$$1(target || subject, recorder.inversePatches.slice().reverse());
        }
    };
    resume();
    return recorder;
}
/**
 * The inverse of `unprotect`
 *
 * @export
 * @param {IStateTreeNode} target
 *
 */
function protect$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    var node = getStateTreeNode$$1(target);
    if (!node.isRoot)
        fail("`protect` can only be invoked on root nodes");
    node.isProtectionEnabled = true;
}
/**
 * By default it is not allowed to directly modify a model. Models can only be modified through actions.
 * However, in some cases you don't care about the advantages (like replayability, traceability, etc) this yields.
 * For example because you are building a PoC or don't have any middleware attached to your tree.
 *
 * In that case you can disable this protection by calling `unprotect` on the root of your tree.
 *
 * @example
 * const Todo = types.model({
 *     done: false
 * }).actions(self => ({
 *     toggle() {
 *         self.done = !self.done
 *     }
 * }))
 *
 * const todo = Todo.create()
 * todo.done = true // throws!
 * todo.toggle() // OK
 * unprotect(todo)
 * todo.done = false // OK
 */
function unprotect$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    var node = getStateTreeNode$$1(target);
    if (!node.isRoot)
        fail("`unprotect` can only be invoked on root nodes");
    node.isProtectionEnabled = false;
}
/**
 * Returns true if the object is in protected mode, @see protect
 */
function isProtected$$1(target) {
    return getStateTreeNode$$1(target).isProtected;
}
/**
 * Applies a snapshot to a given model instances. Patch and snapshot listeners will be invoked as usual.
 *
 * @export
 * @param {Object} target
 * @param {Object} snapshot
 * @returns
 */
function applySnapshot$$1(target, snapshot) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return getStateTreeNode$$1(target).applySnapshot(snapshot);
}
/**
 * Calculates a snapshot from the given model instance. The snapshot will always reflect the latest state but use
 * structural sharing where possible. Doesn't require MobX transactions to be completed.
 *
 * @export
 * @param {Object} target
 * @param {boolean} applyPostProcess = true, by default the postProcessSnapshot gets applied
 * @returns {*}
 */
function getSnapshot$$1(target, applyPostProcess) {
    if (applyPostProcess === void 0) { applyPostProcess = true; }
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    var node = getStateTreeNode$$1(target);
    if (applyPostProcess)
        return node.snapshot;
    return freeze(node.type.getSnapshot(node, false));
}
/**
 * Given a model instance, returns `true` if the object has a parent, that is, is part of another object, map or array
 *
 * @export
 * @param {Object} target
 * @param {number} depth = 1, how far should we look upward?
 * @returns {boolean}
 */
function hasParent$$1(target, depth) {
    if (depth === void 0) { depth = 1; }
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof depth !== "number")
            fail("expected second argument to be a number, got " + depth + " instead");
        if (depth < 0)
            fail("Invalid depth: " + depth + ", should be >= 1");
    }
    var parent = getStateTreeNode$$1(target).parent;
    while (parent) {
        if (--depth === 0)
            return true;
        parent = parent.parent;
    }
    return false;
}
/**
 * Returns the immediate parent of this object, or throws.
 *
 * Note that the immediate parent can be either an object, map or array, and
 * doesn't necessarily refer to the parent model
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired
 *
 *
 * @export
 * @param {Object} target
 * @param {number} depth = 1, how far should we look upward?
 * @returns {*}
 */
function getParent$$1(target, depth) {
    if (depth === void 0) { depth = 1; }
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof depth !== "number")
            fail("expected second argument to be a number, got " + depth + " instead");
        if (depth < 0)
            fail("Invalid depth: " + depth + ", should be >= 1");
    }
    var d = depth;
    var parent = getStateTreeNode$$1(target).parent;
    while (parent) {
        if (--d === 0)
            return parent.storedValue;
        parent = parent.parent;
    }
    return fail("Failed to find the parent of " + getStateTreeNode$$1(target) + " at depth " + depth);
}
/**
 * Given a model instance, returns `true` if the object has a parent of given type, that is, is part of another object, map or array
 *
 * @export
 * @param {Object} target
 * @param {IAnyType} type
 * @returns {boolean}
 */
function hasParentOfType$$1(target, type) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (!isType$$1(type))
            fail("expected second argument to be a mobx-state-tree type, got " + type + " instead");
    }
    var parent = getStateTreeNode$$1(target).parent;
    while (parent) {
        if (type.is(parent.storedValue))
            return true;
        parent = parent.parent;
    }
    return false;
}
/**
 * Returns the target's parent of a given type, or throws.
 *
 *
 * @export
 * @param {IStateTreeNode} target
 * @param {IType<any, any, T>} type
 * @returns {T}
 */
function getParentOfType$$1(target, type) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (!isType$$1(type))
            fail("expected second argument to be a mobx-state-tree type, got " + type + " instead");
    }
    var parent = getStateTreeNode$$1(target).parent;
    while (parent) {
        if (type.is(parent.storedValue))
            return parent.storedValue;
        parent = parent.parent;
    }
    return fail("Failed to find the parent of " + getStateTreeNode$$1(target) + " of a given type");
}
/**
 * Given an object in a model tree, returns the root object of that tree
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired
 *
 * @export
 * @param {Object} target
 * @returns {*}
 */
function getRoot$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return getStateTreeNode$$1(target).root.storedValue;
}
/**
 * Returns the path of the given object in the model tree
 *
 * @export
 * @param {Object} target
 * @returns {string}
 */
function getPath$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return getStateTreeNode$$1(target).path;
}
/**
 * Returns the path of the given object as unescaped string array
 *
 * @export
 * @param {Object} target
 * @returns {string[]}
 */
function getPathParts$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return splitJsonPath$$1(getStateTreeNode$$1(target).path);
}
/**
 * Returns true if the given object is the root of a model tree
 *
 * @export
 * @param {Object} target
 * @returns {boolean}
 */
function isRoot$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return getStateTreeNode$$1(target).isRoot;
}
/**
 * Resolves a path relatively to a given object.
 * Returns undefined if no value can be found.
 *
 * @export
 * @param {Object} target
 * @param {string} path - escaped json path
 * @returns {*}
 */
function resolvePath$$1(target, path) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof path !== "string")
            fail("expected second argument to be a number, got " + path + " instead");
    }
    var node = resolveNodeByPath$$1(getStateTreeNode$$1(target), path);
    return node ? node.value : undefined;
}
/**
 * Resolves a model instance given a root target, the type and the identifier you are searching for.
 * Returns undefined if no value can be found.
 *
 * @export
 * @param {IAnyType} type
 * @param {IStateTreeNode} target
 * @param {(string | number)} identifier
 * @returns {*}
 */
function resolveIdentifier$$1(type, target, identifier$$1) {
    // check all arguments
    if (false) {
        if (!isType$$1(type))
            fail("expected first argument to be a mobx-state-tree type, got " + type + " instead");
        if (!isStateTreeNode$$1(target))
            fail("expected second argument to be a mobx-state-tree node, got " + target + " instead");
        if (!(typeof identifier$$1 === "string" || typeof identifier$$1 === "number"))
            fail("expected third argument to be a string or number, got " + identifier$$1 + " instead");
    }
    var node = getStateTreeNode$$1(target).root.identifierCache.resolve(type, "" + identifier$$1);
    return node ? node.value : undefined;
}
/**
 * Returns the identifier of the target node.
 * This is the *string normalized* identifier, which might not match the type of the identifier attribute
 *
 * @export
 * @param {IStateTreeNode} target
 * @returns {(string | null)}
 */
function getIdentifier$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return getStateTreeNode$$1(target).identifier;
}
/**
 *
 *
 * @export
 * @param {Object} target
 * @param {string} path
 * @returns {*}
 */
function tryResolve$$1(target, path) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof path !== "string")
            fail("expected second argument to be a string, got " + path + " instead");
    }
    var node = resolveNodeByPath$$1(getStateTreeNode$$1(target), path, false);
    if (node === undefined)
        return undefined;
    try {
        return node.value;
    }
    catch (e) {
        // For what ever reason not resolvable (e.g. totally not existing path, or value that cannot be fetched)
        // see test / issue: 'try resolve doesn't work #686'
        return undefined;
    }
}
/**
 * Given two state tree nodes that are part of the same tree,
 * returns the shortest jsonpath needed to navigate from the one to the other
 *
 * @export
 * @param {IStateTreeNode} base
 * @param {IStateTreeNode} target
 * @returns {string}
 */
function getRelativePath$$1(base, target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected second argument to be a mobx-state-tree node, got " + target + " instead");
        if (!isStateTreeNode$$1(base))
            fail("expected first argument to be a mobx-state-tree node, got " + base + " instead");
    }
    return getRelativePathBetweenNodes$$1(getStateTreeNode$$1(base), getStateTreeNode$$1(target));
}
/**
 * Returns a deep copy of the given state tree node as new tree.
 * Short hand for `snapshot(x) = getType(x).create(getSnapshot(x))`
 *
 * _Tip: clone will create a literal copy, including the same identifiers. To modify identifiers etc during cloning, don't use clone but take a snapshot of the tree, modify it, and create new instance_
 *
 * @export
 * @template T
 * @param {T} source
 * @param {boolean | any} keepEnvironment indicates whether the clone should inherit the same environment (`true`, the default), or not have an environment (`false`). If an object is passed in as second argument, that will act as the environment for the cloned tree.
 * @returns {T}
 */
function clone$$1(source, keepEnvironment) {
    if (keepEnvironment === void 0) { keepEnvironment = true; }
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(source))
            fail("expected first argument to be a mobx-state-tree node, got " + source + " instead");
    }
    var node = getStateTreeNode$$1(source);
    return node.type.create(node.snapshot, keepEnvironment === true
        ? node.root._environment
        : keepEnvironment === false
            ? undefined
            : keepEnvironment); // it's an object or something else
}
/**
 * Removes a model element from the state tree, and let it live on as a new state tree
 */
function detach$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    getStateTreeNode$$1(target).detach();
    return target;
}
/**
 * Removes a model element from the state tree, and mark it as end-of-life; the element should not be used anymore
 */
function destroy$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    var node = getStateTreeNode$$1(target);
    if (node.isRoot)
        node.die();
    else
        node.parent.removeChild(node.subpath);
}
/**
 * Returns true if the given state tree node is not killed yet.
 * This means that the node is still a part of a tree, and that `destroy`
 * has not been called. If a node is not alive anymore, the only thing one can do with it
 * is requesting it's last path and snapshot
 *
 * @export
 * @param {IStateTreeNode} target
 * @returns {boolean}
 */
function isAlive$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    return getStateTreeNode$$1(target).isAlive;
}
/**
 * Use this utility to register a function that should be called whenever the
 * targeted state tree node is destroyed. This is a useful alternative to managing
 * cleanup methods yourself using the `beforeDestroy` hook.
 *
 * @example
 * const Todo = types.model({
 *   title: types.string
 * }).actions(self => ({
 *   afterCreate() {
 *     const autoSaveDisposer = reaction(
 *       () => getSnapshot(self),
 *       snapshot => sendSnapshotToServerSomehow(snapshot)
 *     )
 *     // stop sending updates to server if this
 *     // instance is destroyed
 *     addDisposer(self, autoSaveDisposer)
 *   }
 * }))
 *
 * @export
 * @param {IStateTreeNode} target
 * @param {() => void} disposer
 */
function addDisposer$$1(target, disposer) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof disposer !== "function")
            fail("expected second argument to be a function, got " + disposer + " instead");
    }
    getStateTreeNode$$1(target).addDisposer(disposer);
}
/**
 * Returns the environment of the current state tree. For more info on environments,
 * see [Dependency injection](https://github.com/mobxjs/mobx-state-tree#dependency-injection)
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired
 *
 * Returns an empty environment if the tree wasn't initialized with an environment
 *
 * @export
 * @param {IStateTreeNode} target
 * @returns {*}
 */
function getEnv$$1(target) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
    }
    var node = getStateTreeNode$$1(target);
    var env = node.root._environment;
    if (!!!env)
        return EMPTY_OBJECT;
    return env;
}
/**
 * Performs a depth first walk through a tree
 */
function walk$$1(target, processor) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof processor !== "function")
            fail("expected second argument to be a function, got " + processor + " instead");
    }
    var node = getStateTreeNode$$1(target);
    // tslint:disable-next-line:no_unused-variable
    node.getChildren().forEach(function (child) {
        if (isStateTreeNode$$1(child.storedValue))
            walk$$1(child.storedValue, processor);
    });
    processor(node.storedValue);
}
/**
 * Returns a reflection of the model type properties and name for either a model type or model node.
 *
 * @export
 * @param {IAnyModelType | IStateTreeNode} typeOrNode
 * @returns {IModelReflectionPropertiesData}
 */
function getPropertyMembers$$1(typeOrNode) {
    var type;
    if (isStateTreeNode$$1(typeOrNode)) {
        type = getType$$1(typeOrNode);
    }
    else {
        type = typeOrNode;
    }
    if (false) {
        if (!isModelType$$1(type))
            fail("expected a model type, but got " + type + " instead.");
    }
    return {
        name: type.name,
        properties: __assign({}, type.properties)
    };
}
/**
 * Returns a reflection of the model node, including name, properties, views, volatile and actions.
 *
 * @export
 * @param {IAnyStateTreeNode} target
 * @returns {IModelReflectionData}
 */
function getMembers$$1(target) {
    var type = getStateTreeNode$$1(target).type;
    var reflected = __assign({}, getPropertyMembers$$1(type), { actions: [], volatile: [], views: [] });
    var props = Object.getOwnPropertyNames(target);
    props.forEach(function (key) {
        if (key in reflected.properties)
            return;
        var descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor.get) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["o" /* isComputedProp */])(target, key))
                reflected.views.push(key);
            else
                reflected.volatile.push(key);
            return;
        }
        if (descriptor.value._isMSTAction === true)
            reflected.actions.push(key);
        else if (Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["s" /* isObservableProp */])(target, key))
            reflected.volatile.push(key);
        else
            reflected.views.push(key);
    });
    return reflected;
}
/**
 * Casts a node snapshot or instance type to an instance type so it can be assigned to a type instance.
 * Alternatively also casts a node snapshot or instance to an snapshot type so it can be assigned to a type snapshot.
 * Note that this is just a cast for the type system, this is, it won't actually convert a snapshot to an instance
 * (or vice-versa), but just fool typescript into thinking so.
 * Either way, casting when outside an assignation operation will only yield an unusable type (never).
 *
 * @example
 * const ModelA = types.model({
 *   n: types.number
 * }).actions(self => ({
 *   setN(aNumber: number) {
 *     self.n = aNumber
 *   }
 * }))
 *
 * const ModelB = types.model({
 *   innerModel: ModelA
 * }).actions(self => ({
 *   someAction() {
 *     // this will allow the compiler to assign an snapshot to the property
 *     self.innerModel = cast({ a: 5 })
 *   }
 * }))
 *
 * @export
 * @param {CastedType<T>} snapshotOrInstance
 * @returns {T}
 */
function cast$$1(snapshotOrInstance) {
    return snapshotOrInstance;
}

/**
 * @internal
 * @private
 */
var ScalarNode$$1 = /** @class */ (function () {
    function ScalarNode$$1(type, parent, subpath, environment, initialSnapshot) {
        this.parent = null;
        this.subpath = "";
        this.state = NodeLifeCycle$$1.INITIALIZING;
        this._environment = undefined;
        this._initialSnapshot = initialSnapshot;
        this.type = type;
        this.parent = parent;
        this.subpath = subpath;
        var sawException = true;
        try {
            this.storedValue = type.createNewInstance(this, {}, initialSnapshot);
            this.state = NodeLifeCycle$$1.CREATED;
            sawException = false;
        }
        finally {
            if (sawException) {
                // short-cut to die the instance, to avoid the snapshot computed starting to throw...
                this.state = NodeLifeCycle$$1.DEAD;
            }
        }
    }
    Object.defineProperty(ScalarNode$$1.prototype, "path", {
        /*
         * Returnes (escaped) path representation as string
         */
        get: function () {
            if (!this.parent)
                return "";
            return this.parent.path + "/" + escapeJsonPath$$1(this.subpath);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScalarNode$$1.prototype, "isRoot", {
        get: function () {
            return this.parent === null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScalarNode$$1.prototype, "root", {
        get: function () {
            // future optimization: store root ref in the node and maintain it
            if (!this.parent)
                return fail("This scalar node is not part of a tree");
            return this.parent.root;
        },
        enumerable: true,
        configurable: true
    });
    ScalarNode$$1.prototype.setParent = function (newParent, subpath) {
        if (subpath === void 0) { subpath = null; }
        if (this.parent === newParent && this.subpath === subpath)
            return;
        if (this.parent && !newParent) {
            this.die();
        }
        else {
            var newPath = subpath === null ? "" : subpath;
            if (this.subpath !== newPath) {
                this.subpath = newPath;
            }
            if (newParent && newParent !== this.parent) {
                this.parent = newParent;
            }
        }
    };
    Object.defineProperty(ScalarNode$$1.prototype, "value", {
        get: function () {
            return this.type.getValue(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScalarNode$$1.prototype, "snapshot", {
        get: function () {
            var snapshot = this.getSnapshot();
            // avoid any external modification in dev mode
            return freeze(snapshot);
        },
        enumerable: true,
        configurable: true
    });
    ScalarNode$$1.prototype.getSnapshot = function () {
        return this.type.getSnapshot(this);
    };
    Object.defineProperty(ScalarNode$$1.prototype, "isAlive", {
        get: function () {
            return this.state !== NodeLifeCycle$$1.DEAD;
        },
        enumerable: true,
        configurable: true
    });
    ScalarNode$$1.prototype.toString = function () {
        return this.type.name + "@" + (this.path || "<root>") + (this.isAlive ? "" : "[dead]");
    };
    ScalarNode$$1.prototype.die = function () {
        this.state = NodeLifeCycle$$1.DEAD;
    };
    return ScalarNode$$1;
}());

var nextNodeId = 1;
var livelynessChecking = "warn";
/**
 *  Defines what MST should do when running into reads / writes to objects that have died.
 * By default it will print a warning.
 * Use te `"error"` option to easy debugging to see where the error was thrown and when the offending read / write took place
 *
 * Possible values: `"warn"`, `"error"` and `"ignore"`
 *
 * @export
 * @param {LivelynessMode} mode
 */
function setLivelynessChecking$$1(mode) {
    livelynessChecking = mode;
}
var snapshotReactionOptions = {
    onError: function (e) {
        throw e;
    }
};
/**
 * @internal
 * @private
 */
var ObjectNode$$1 = /** @class */ (function () {
    function ObjectNode$$1(type, parent, subpath, environment, initialSnapshot) {
        this.nodeId = ++nextNodeId;
        this.subpathAtom = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["k" /* createAtom */])("path");
        this.subpath = "";
        this.parent = null;
        this.state = NodeLifeCycle$$1.INITIALIZING;
        this.isProtectionEnabled = true;
        this.middlewares = null;
        this._autoUnbox = true; // unboxing is disabled when reading child nodes
        this._environment = undefined;
        this._isRunningAction = false; // only relevant for root
        this._hasSnapshotReaction = false;
        this._disposers = null;
        this._patchSubscribers = null;
        this._snapshotSubscribers = null;
        this._observableInstanceCreated = false;
        this._cachedInitialSnapshot = null;
        this._environment = environment;
        this._initialSnapshot = freeze(initialSnapshot);
        this.type = type;
        this.parent = parent;
        this.subpath = subpath;
        this.escapedSubpath = escapeJsonPath$$1(this.subpath);
        this.identifierAttribute = type.identifierAttribute;
        if (!parent) {
            this.identifierCache = new IdentifierCache$$1();
        }
        this._childNodes = type.initializeChildNodes(this, this._initialSnapshot);
        // identifier can not be changed during lifecycle of a node
        // so we safely can read it from initial snapshot
        this.identifier = null;
        if (this.identifierAttribute && this._initialSnapshot) {
            var id = this._initialSnapshot[this.identifierAttribute];
            if (id === undefined) {
                // try with the actual node if not (for optional identifiers)
                var childNode = this._childNodes[this.identifierAttribute];
                if (childNode) {
                    id = childNode.value;
                }
            }
            if (typeof id !== "string" && typeof id !== "number") {
                fail("Instance identifier '" + this.identifierAttribute + "' for type '" + this.type.name + "' must be a string or a number");
            }
            // normalize internal identifier to string
            this.identifier = "" + id;
        }
        if (!parent) {
            this.identifierCache.addNodeToCache(this);
        }
        else {
            parent.root.identifierCache.addNodeToCache(this);
        }
    }
    ObjectNode$$1.prototype.applyPatches = function (patches) {
        if (!this._observableInstanceCreated)
            this._createObservableInstance();
        this.applyPatches(patches);
    };
    ObjectNode$$1.prototype.applySnapshot = function (snapshot) {
        if (!this._observableInstanceCreated)
            this._createObservableInstance();
        this.applySnapshot(snapshot);
    };
    ObjectNode$$1.prototype._createObservableInstance = function () {
        var type = this.type;
        this.storedValue = type.createNewInstance(this, this._childNodes, this._initialSnapshot);
        this.preboot();
        var sawException = true;
        this._observableInstanceCreated = true;
        try {
            this._isRunningAction = true;
            type.finalizeNewInstance(this, this.storedValue);
            this._isRunningAction = false;
            this.fireHook("afterCreate");
            this.state = NodeLifeCycle$$1.CREATED;
            sawException = false;
        }
        finally {
            if (sawException) {
                // short-cut to die the instance, to avoid the snapshot computed starting to throw...
                this.state = NodeLifeCycle$$1.DEAD;
            }
        }
        // NOTE: we need to touch snapshot, because non-observable
        // "observableInstanceCreated" field was touched
        invalidateComputed(this, "snapshot");
        if (this.isRoot)
            this._addSnapshotReaction();
        this.finalizeCreation();
        this._childNodes = EMPTY_OBJECT;
    };
    Object.defineProperty(ObjectNode$$1.prototype, "path", {
        /*
         * Returnes (escaped) path representation as string
         */
        get: function () {
            this.subpathAtom.reportObserved();
            if (!this.parent)
                return "";
            return this.parent.path + "/" + this.escapedSubpath;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectNode$$1.prototype, "root", {
        get: function () {
            var parent = this.parent;
            return parent ? parent.root : this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectNode$$1.prototype, "isRoot", {
        get: function () {
            return this.parent === null;
        },
        enumerable: true,
        configurable: true
    });
    ObjectNode$$1.prototype.setParent = function (newParent, subpath) {
        if (subpath === void 0) { subpath = null; }
        if (this.parent === newParent && this.subpath === subpath)
            return;
        if (newParent && "production" !== "production") {
            if (this.parent && newParent !== this.parent) {
                fail("A node cannot exists twice in the state tree. Failed to add " + this + " to path '" + newParent.path + "/" + subpath + "'.");
            }
            if (!this.parent && newParent.root === this) {
                fail("A state tree is not allowed to contain itself. Cannot assign " + this + " to path '" + newParent.path + "/" + subpath + "'");
            }
            if (!this.parent &&
                !!this.root._environment &&
                this.root._environment !== newParent.root._environment) {
                fail("A state tree cannot be made part of another state tree as long as their environments are different.");
            }
        }
        if (this.parent && !newParent) {
            this.die();
        }
        else {
            var newPath = subpath === null ? "" : subpath;
            if (this.subpath !== newPath) {
                this.subpath = newPath;
                this.escapedSubpath = escapeJsonPath$$1(this.subpath);
                this.subpathAtom.reportChanged();
            }
            if (newParent && newParent !== this.parent) {
                newParent.root.identifierCache.mergeCache(this);
                this.parent = newParent;
                this.subpathAtom.reportChanged();
                this.fireHook("afterAttach");
            }
        }
    };
    ObjectNode$$1.prototype.fireHook = function (name) {
        var _this = this;
        var fn = this.storedValue && typeof this.storedValue === "object" && this.storedValue[name];
        if (typeof fn === "function") {
            // we check for it to allow old mobx peer dependencies that don't have the method to work (even when still bugged)
            if (__WEBPACK_IMPORTED_MODULE_0_mobx__["e" /* _allowStateChangesInsideComputed */]) {
                Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["e" /* _allowStateChangesInsideComputed */])(function () {
                    fn.apply(_this.storedValue);
                });
            }
            else {
                fn.apply(this.storedValue);
            }
        }
    };
    ObjectNode$$1.prototype.createObservableInstanceIfNeeded = function () {
        if (!this._observableInstanceCreated)
            this._createObservableInstance();
    };
    Object.defineProperty(ObjectNode$$1.prototype, "isObservableInstanceCreated", {
        get: function () {
            return this._observableInstanceCreated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectNode$$1.prototype, "value", {
        get: function () {
            this.createObservableInstanceIfNeeded();
            if (!this.isAlive)
                return undefined;
            return this.type.getValue(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectNode$$1.prototype, "snapshot", {
        // advantage of using computed for a snapshot is that nicely respects transactions etc.
        get: function () {
            if (!this.isAlive)
                return undefined;
            return freeze(this.getSnapshot());
        },
        enumerable: true,
        configurable: true
    });
    // NOTE: we use this method to get snapshot without creating @computed overhead
    ObjectNode$$1.prototype.getSnapshot = function () {
        if (!this.isAlive)
            return undefined;
        return this._observableInstanceCreated
            ? this._getActualSnapshot()
            : this._getInitialSnapshot();
    };
    ObjectNode$$1.prototype._getActualSnapshot = function () {
        return this.type.getSnapshot(this);
    };
    ObjectNode$$1.prototype._getInitialSnapshot = function () {
        if (!this.isAlive)
            return undefined;
        if (!this._initialSnapshot)
            return this._initialSnapshot;
        if (this._cachedInitialSnapshot)
            return this._cachedInitialSnapshot;
        var type = this.type;
        var childNodes = this._childNodes;
        var snapshot = this._initialSnapshot;
        this._cachedInitialSnapshot = type.processInitialSnapshot(childNodes, snapshot);
        return this._cachedInitialSnapshot;
    };
    ObjectNode$$1.prototype.isRunningAction = function () {
        if (this._isRunningAction)
            return true;
        if (this.isRoot)
            return false;
        return this.parent.isRunningAction();
    };
    Object.defineProperty(ObjectNode$$1.prototype, "isAlive", {
        get: function () {
            return this.state !== NodeLifeCycle$$1.DEAD;
        },
        enumerable: true,
        configurable: true
    });
    ObjectNode$$1.prototype.assertAlive = function () {
        if (!this.isAlive) {
            var baseMsg = "[mobx-state-tree][error] You are trying to read or write to an object that is no longer part of a state tree. (Object type was '" + this.type.name + "'). Either detach nodes first, or don't use objects after removing / replacing them in the tree.";
            switch (livelynessChecking) {
                case "error":
                    throw new Error(baseMsg);
                case "warn":
                    console.warn(baseMsg +
                        ' Use setLivelynessChecking("error") to simplify debugging this error.');
            }
        }
    };
    ObjectNode$$1.prototype.getChildNode = function (subpath) {
        this.assertAlive();
        this._autoUnbox = false;
        try {
            return this._observableInstanceCreated
                ? this.type.getChildNode(this, subpath)
                : this._childNodes[subpath];
        }
        finally {
            this._autoUnbox = true;
        }
    };
    ObjectNode$$1.prototype.getChildren = function () {
        this.assertAlive();
        this._autoUnbox = false;
        try {
            return this._observableInstanceCreated
                ? this.type.getChildren(this)
                : convertChildNodesToArray$$1(this._childNodes);
        }
        finally {
            this._autoUnbox = true;
        }
    };
    ObjectNode$$1.prototype.getChildType = function (key) {
        return this.type.getChildType(key);
    };
    Object.defineProperty(ObjectNode$$1.prototype, "isProtected", {
        get: function () {
            return this.root.isProtectionEnabled;
        },
        enumerable: true,
        configurable: true
    });
    ObjectNode$$1.prototype.assertWritable = function () {
        this.assertAlive();
        if (!this.isRunningAction() && this.isProtected) {
            fail("Cannot modify '" + this + "', the object is protected and can only be modified by using an action.");
        }
    };
    ObjectNode$$1.prototype.removeChild = function (subpath) {
        this.type.removeChild(this, subpath);
    };
    ObjectNode$$1.prototype.unbox = function (childNode) {
        if (childNode && childNode.parent)
            childNode.parent.assertAlive();
        if (childNode && childNode.parent && childNode.parent._autoUnbox)
            return childNode.value;
        return childNode;
    };
    ObjectNode$$1.prototype.toString = function () {
        var identifier$$1 = this.identifier ? "(id: " + this.identifier + ")" : "";
        return this.type.name + "@" + (this.path || "<root>") + identifier$$1 + (this.isAlive ? "" : "[dead]");
    };
    ObjectNode$$1.prototype.finalizeCreation = function () {
        // goal: afterCreate hooks runs depth-first. After attach runs parent first, so on afterAttach the parent has completed already
        if (this.state === NodeLifeCycle$$1.CREATED) {
            if (this.parent) {
                if (this.parent.state !== NodeLifeCycle$$1.FINALIZED) {
                    // parent not ready yet, postpone
                    return;
                }
                this.fireHook("afterAttach");
            }
            this.state = NodeLifeCycle$$1.FINALIZED;
            for (var _i = 0, _a = this.getChildren(); _i < _a.length; _i++) {
                var child = _a[_i];
                if (child instanceof ObjectNode$$1)
                    child.finalizeCreation();
            }
        }
    };
    ObjectNode$$1.prototype.detach = function () {
        if (!this.isAlive)
            fail("Error while detaching, node is not alive.");
        if (this.isRoot)
            return;
        else {
            this.fireHook("beforeDetach");
            this._environment = this.root._environment; // make backup of environment
            this.state = NodeLifeCycle$$1.DETACHING;
            this.identifierCache = this.root.identifierCache.splitCache(this);
            this.parent.removeChild(this.subpath);
            this.parent = null;
            this.subpath = this.escapedSubpath = "";
            this.subpathAtom.reportChanged();
            this.state = NodeLifeCycle$$1.FINALIZED;
        }
    };
    ObjectNode$$1.prototype.preboot = function () {
        var self = this;
        this.applyPatches = createActionInvoker$$1(this.storedValue, "@APPLY_PATCHES", function (patches) {
            patches.forEach(function (patch) {
                var parts = splitJsonPath$$1(patch.path);
                var node = resolveNodeByPathParts$$1(self, parts.slice(0, -1));
                node.applyPatchLocally(parts[parts.length - 1], patch);
            });
        });
        this.applySnapshot = createActionInvoker$$1(this.storedValue, "@APPLY_SNAPSHOT", function (snapshot) {
            // if the snapshot is the same as the current one, avoid performing a reconcile
            if (snapshot === self.snapshot)
                return;
            // else, apply it by calling the type logic
            return self.type.applySnapshot(self, snapshot);
        });
        addHiddenFinalProp(this.storedValue, "$treenode", this);
        addHiddenFinalProp(this.storedValue, "toJSON", toJSON$$1);
    };
    ObjectNode$$1.prototype.die = function () {
        if (this.state === NodeLifeCycle$$1.DETACHING)
            return;
        if (isStateTreeNode$$1(this.storedValue)) {
            // optimization: don't use walk, but getChildNodes for more efficiency
            walk$$1(this.storedValue, function (child) {
                var node = getStateTreeNode$$1(child);
                if (node instanceof ObjectNode$$1)
                    node.aboutToDie();
            });
            walk$$1(this.storedValue, function (child) {
                var node = getStateTreeNode$$1(child);
                if (node instanceof ObjectNode$$1)
                    node.finalizeDeath();
            });
        }
    };
    ObjectNode$$1.prototype.aboutToDie = function () {
        if (this._disposers) {
            this._disposers.forEach(function (f) { return f(); });
            this._disposers = null;
        }
        this.fireHook("beforeDestroy");
    };
    ObjectNode$$1.prototype.finalizeDeath = function () {
        // invariant: not called directly but from "die"
        this.root.identifierCache.notifyDied(this);
        addReadOnlyProp(this, "snapshot", this.snapshot); // kill the computed prop and just store the last snapshot
        if (this._patchSubscribers)
            this._patchSubscribers = null;
        if (this._snapshotSubscribers)
            this._snapshotSubscribers = null;
        this.state = NodeLifeCycle$$1.DEAD;
        this.subpath = this.escapedSubpath = "";
        this.parent = null;
        this.subpathAtom.reportChanged();
    };
    ObjectNode$$1.prototype.onSnapshot = function (onChange) {
        this._addSnapshotReaction();
        if (!this._snapshotSubscribers)
            this._snapshotSubscribers = [];
        return registerEventHandler(this._snapshotSubscribers, onChange);
    };
    ObjectNode$$1.prototype.emitSnapshot = function (snapshot) {
        if (this._snapshotSubscribers)
            this._snapshotSubscribers.forEach(function (f) { return f(snapshot); });
    };
    ObjectNode$$1.prototype.onPatch = function (handler) {
        if (!this._patchSubscribers)
            this._patchSubscribers = [];
        return registerEventHandler(this._patchSubscribers, handler);
    };
    ObjectNode$$1.prototype.emitPatch = function (basePatch, source) {
        var patchSubscribers = this._patchSubscribers;
        if (patchSubscribers && patchSubscribers.length) {
            var localizedPatch = extend({}, basePatch, {
                path: source.path.substr(this.path.length) + "/" + basePatch.path // calculate the relative path of the patch
            });
            var _a = splitPatch$$1(localizedPatch), patch_1 = _a[0], reversePatch_1 = _a[1];
            patchSubscribers.forEach(function (f) { return f(patch_1, reversePatch_1); });
        }
        if (this.parent)
            this.parent.emitPatch(basePatch, source);
    };
    ObjectNode$$1.prototype.addDisposer = function (disposer) {
        if (!this._disposers)
            this._disposers = [disposer];
        else
            this._disposers.unshift(disposer);
    };
    ObjectNode$$1.prototype.removeMiddleware = function (handler) {
        if (this.middlewares)
            this.middlewares = this.middlewares.filter(function (middleware) { return middleware.handler !== handler; });
    };
    ObjectNode$$1.prototype.addMiddleWare = function (handler, includeHooks) {
        var _this = this;
        if (includeHooks === void 0) { includeHooks = true; }
        if (!this.middlewares)
            this.middlewares = [{ handler: handler, includeHooks: includeHooks }];
        else
            this.middlewares.push({ handler: handler, includeHooks: includeHooks });
        return function () {
            _this.removeMiddleware(handler);
        };
    };
    ObjectNode$$1.prototype.applyPatchLocally = function (subpath, patch) {
        this.assertWritable();
        if (!this._observableInstanceCreated)
            this._createObservableInstance();
        this.type.applyPatchLocally(this, subpath, patch);
    };
    ObjectNode$$1.prototype._addSnapshotReaction = function () {
        var _this = this;
        if (!this._hasSnapshotReaction) {
            var snapshotDisposer = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["v" /* reaction */])(function () { return _this.snapshot; }, function (snapshot) { return _this.emitSnapshot(snapshot); }, snapshotReactionOptions);
            this.addDisposer(snapshotDisposer);
            this._hasSnapshotReaction = true;
        }
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* action */]
    ], ObjectNode$$1.prototype, "_createObservableInstance", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* computed */]
    ], ObjectNode$$1.prototype, "snapshot", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* action */]
    ], ObjectNode$$1.prototype, "detach", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* action */]
    ], ObjectNode$$1.prototype, "die", null);
    return ObjectNode$$1;
}());

/**
 * @internal
 * @private
 */
var TypeFlags$$1;
(function (TypeFlags$$1) {
    TypeFlags$$1[TypeFlags$$1["String"] = 1] = "String";
    TypeFlags$$1[TypeFlags$$1["Number"] = 2] = "Number";
    TypeFlags$$1[TypeFlags$$1["Boolean"] = 4] = "Boolean";
    TypeFlags$$1[TypeFlags$$1["Date"] = 8] = "Date";
    TypeFlags$$1[TypeFlags$$1["Literal"] = 16] = "Literal";
    TypeFlags$$1[TypeFlags$$1["Array"] = 32] = "Array";
    TypeFlags$$1[TypeFlags$$1["Map"] = 64] = "Map";
    TypeFlags$$1[TypeFlags$$1["Object"] = 128] = "Object";
    TypeFlags$$1[TypeFlags$$1["Frozen"] = 256] = "Frozen";
    TypeFlags$$1[TypeFlags$$1["Optional"] = 512] = "Optional";
    TypeFlags$$1[TypeFlags$$1["Reference"] = 1024] = "Reference";
    TypeFlags$$1[TypeFlags$$1["Identifier"] = 2048] = "Identifier";
    TypeFlags$$1[TypeFlags$$1["Late"] = 4096] = "Late";
    TypeFlags$$1[TypeFlags$$1["Refinement"] = 8192] = "Refinement";
    TypeFlags$$1[TypeFlags$$1["Union"] = 16384] = "Union";
    TypeFlags$$1[TypeFlags$$1["Null"] = 32768] = "Null";
    TypeFlags$$1[TypeFlags$$1["Undefined"] = 65536] = "Undefined";
    TypeFlags$$1[TypeFlags$$1["Integer"] = 131072] = "Integer";
})(TypeFlags$$1 || (TypeFlags$$1 = {}));
/**
 * A complex type produces a MST node (Node in the state tree)
 *
 * @internal
 * @private
 */
var ComplexType$$1 = /** @class */ (function () {
    function ComplexType$$1(name) {
        this["!!complexType"] = undefined;
        this.isType = true;
        this.name = name;
    }
    ComplexType$$1.prototype.create = function (snapshot, environment) {
        if (snapshot === void 0) { snapshot = this.getDefaultSnapshot(); }
        typecheckInternal$$1(this, snapshot);
        return this.instantiate(null, "", environment, snapshot).value;
    };
    ComplexType$$1.prototype.initializeChildNodes = function (node, snapshot) {
        return EMPTY_OBJECT;
    };
    ComplexType$$1.prototype.createNewInstance = function (node, childNodes, snapshot) {
        return snapshot;
    };
    ComplexType$$1.prototype.finalizeNewInstance = function (node, instance) { };
    ComplexType$$1.prototype.processInitialSnapshot = function (childNodes, snapshot) {
        return snapshot;
    };
    ComplexType$$1.prototype.isAssignableFrom = function (type) {
        return type === this;
    };
    ComplexType$$1.prototype.validate = function (value, context) {
        if (isStateTreeNode$$1(value)) {
            return getType$$1(value) === this || this.isAssignableFrom(getType$$1(value))
                ? typeCheckSuccess$$1()
                : typeCheckFailure$$1(context, value);
            // it is tempting to compare snapshots, but in that case we should always clone on assignments...
        }
        return this.isValidSnapshot(value, context);
    };
    ComplexType$$1.prototype.is = function (value) {
        return this.validate(value, [{ path: "", type: this }]).length === 0;
    };
    ComplexType$$1.prototype.reconcile = function (current, newValue) {
        if (current.snapshot === newValue)
            // newValue is the current snapshot of the node, noop
            return current;
        if (isStateTreeNode$$1(newValue) && getStateTreeNode$$1(newValue) === current)
            // the current node is the same as the new one
            return current;
        if (current.type === this &&
            isMutable(newValue) &&
            !isStateTreeNode$$1(newValue) &&
            (!current.identifierAttribute ||
                current.identifier === "" + newValue[current.identifierAttribute])) {
            // the newValue has no node, so can be treated like a snapshot
            // we can reconcile
            current.applySnapshot(newValue);
            return current;
        }
        // current node cannot be recycled in any way
        var parent = current.parent, subpath = current.subpath;
        current.die();
        // attempt to reuse the new one
        if (isStateTreeNode$$1(newValue) && this.isAssignableFrom(getType$$1(newValue))) {
            // newValue is a Node as well, move it here..
            var newNode = getStateTreeNode$$1(newValue);
            newNode.setParent(parent, subpath);
            return newNode;
        }
        // nothing to do, we have to create a new node
        return this.instantiate(parent, subpath, current._environment, newValue);
    };
    Object.defineProperty(ComplexType$$1.prototype, "Type", {
        get: function () {
            return fail("Factory.Type should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.Type`");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComplexType$$1.prototype, "SnapshotType", {
        get: function () {
            return fail("Factory.SnapshotType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.SnapshotType`");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComplexType$$1.prototype, "CreationType", {
        get: function () {
            return fail("Factory.CreationType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.CreationType`");
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* action */]
    ], ComplexType$$1.prototype, "create", null);
    return ComplexType$$1;
}());
/**
 * @internal
 * @private
 */
var Type$$1 = /** @class */ (function (_super) {
    __extends(Type$$1, _super);
    function Type$$1(name) {
        return _super.call(this, name) || this;
    }
    Type$$1.prototype.getValue = function (node) {
        return node.storedValue;
    };
    Type$$1.prototype.getSnapshot = function (node) {
        return node.storedValue;
    };
    Type$$1.prototype.getDefaultSnapshot = function () {
        return undefined;
    };
    Type$$1.prototype.applySnapshot = function (node, snapshot) {
        fail("Immutable types do not support applying snapshots");
    };
    Type$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
        fail("Immutable types do not support applying patches");
    };
    Type$$1.prototype.getChildren = function (node) {
        return EMPTY_ARRAY;
    };
    Type$$1.prototype.getChildNode = function (node, key) {
        return fail("No child '" + key + "' available in type: " + this.name);
    };
    Type$$1.prototype.getChildType = function (key) {
        return fail("No child '" + key + "' available in type: " + this.name);
    };
    Type$$1.prototype.reconcile = function (current, newValue) {
        // reconcile only if type and value are still the same
        if (current.type === this && current.storedValue === newValue)
            return current;
        var res = this.instantiate(current.parent, current.subpath, current._environment, newValue);
        current.die();
        return res;
    };
    Type$$1.prototype.removeChild = function (node, subpath) {
        return fail("No child '" + subpath + "' available in type: " + this.name);
    };
    return Type$$1;
}(ComplexType$$1));
/**
 * Returns if a given value represents a type.
 *
 * @export
 * @param {*} value
 * @returns {value is IAnyType}
 */
function isType$$1(value) {
    return typeof value === "object" && value && value.isType === true;
}

var runningActions = new Map();
/**
 * Convenience utility to create action based middleware that supports async processes more easily.
 * All hooks are called for both synchronous and asynchronous actions. Except that either `onSuccess` or `onFail` is called
 *
 * The create middleware tracks the process of an action (assuming it passes the `filter`).
 * `onResume` can return any value, which will be passed as second argument to any other hook. This makes it possible to keep state during a process.
 *
 * See the `atomic` middleware for an example
 *
 * @export
 * @template T
 * @template any
 * @param {{
 *     filter?: (call: IMiddlewareEvent) => boolean
 *     onStart: (call: IMiddlewareEvent) => T
 *     onResume: (call: IMiddlewareEvent, context: T) => void
 *     onSuspend: (call: IMiddlewareEvent, context: T) => void
 *     onSuccess: (call: IMiddlewareEvent, context: T, result: any) => void
 *     onFail: (call: IMiddlewareEvent, context: T, error: any) => void
 * }} hooks
 * @returns {IMiddlewareHandler}
 */
function createActionTrackingMiddleware(hooks) {
    return function actionTrackingMiddleware(call, next, abort) {
        switch (call.type) {
            case "action": {
                if (!hooks.filter || hooks.filter(call) === true) {
                    var context = hooks.onStart(call);
                    hooks.onResume(call, context);
                    runningActions.set(call.id, {
                        call: call,
                        context: context,
                        async: false
                    });
                    try {
                        var res = next(call);
                        hooks.onSuspend(call, context);
                        if (runningActions.get(call.id).async === false) {
                            runningActions.delete(call.id);
                            hooks.onSuccess(call, context, res);
                        }
                        return res;
                    }
                    catch (e) {
                        runningActions.delete(call.id);
                        hooks.onFail(call, context, e);
                        throw e;
                    }
                }
                else {
                    return next(call);
                }
            }
            case "flow_spawn": {
                var root = runningActions.get(call.rootId);
                root.async = true;
                return next(call);
            }
            case "flow_resume":
            case "flow_resume_error": {
                var root = runningActions.get(call.rootId);
                hooks.onResume(call, root.context);
                try {
                    return next(call);
                }
                finally {
                    hooks.onSuspend(call, root.context);
                }
            }
            case "flow_throw": {
                var root = runningActions.get(call.rootId);
                runningActions.delete(call.id);
                hooks.onFail(call, root.context, call.args[0]);
                return next(call);
            }
            case "flow_return": {
                var root = runningActions.get(call.rootId);
                runningActions.delete(call.id);
                hooks.onSuccess(call, root.context, call.args[0]);
                return next(call);
            }
        }
    };
}

function serializeArgument(node, actionName, index, arg) {
    if (arg instanceof Date)
        return { $MST_DATE: arg.getTime() };
    if (isPrimitive(arg))
        return arg;
    // We should not serialize MST nodes, even if we can, because we don't know if the receiving party can handle a raw snapshot instead of an
    // MST type instance. So if one wants to serialize a MST node that was pass in, either explitly pass: 1: an id, 2: a (relative) path, 3: a snapshot
    if (isStateTreeNode$$1(arg))
        return serializeTheUnserializable("[MSTNode: " + getType$$1(arg).name + "]");
    if (typeof arg === "function")
        return serializeTheUnserializable("[function]");
    if (typeof arg === "object" && !isPlainObject(arg) && !isArray(arg))
        return serializeTheUnserializable("[object " + ((arg && arg.constructor && arg.constructor.name) || "Complex Object") + "]");
    try {
        // Check if serializable, cycle free etc...
        // MWE: there must be a better way....
        JSON.stringify(arg); // or throws
        return arg;
    }
    catch (e) {
        return serializeTheUnserializable("" + e);
    }
}
function deserializeArgument(adm, value) {
    if (value && typeof value === "object" && "$MST_DATE" in value)
        return new Date(value["$MST_DATE"]);
    return value;
}
function serializeTheUnserializable(baseType) {
    return {
        $MST_UNSERIALIZABLE: true,
        type: baseType
    };
}
/**
 * Applies an action or a series of actions in a single MobX transaction.
 * Does not return any value
 * Takes an action description as produced by the `onAction` middleware.
 *
 * @export
 * @param {Object} target
 * @param {IActionCall[]} actions
 */
function applyAction$$1(target, actions) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (typeof actions !== "object")
            fail("expected second argument to be an object or array, got " + actions + " instead");
    }
    Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["w" /* runInAction */])(function () {
        asArray(actions).forEach(function (action$$1) { return baseApplyAction(target, action$$1); });
    });
}
function baseApplyAction(target, action$$1) {
    var resolvedTarget = tryResolve$$1(target, action$$1.path || "");
    if (!resolvedTarget)
        return fail("Invalid action path: " + (action$$1.path || ""));
    var node = getStateTreeNode$$1(resolvedTarget);
    // Reserved functions
    if (action$$1.name === "@APPLY_PATCHES") {
        return applyPatch$$1.call(null, resolvedTarget, action$$1.args[0]);
    }
    if (action$$1.name === "@APPLY_SNAPSHOT") {
        return applySnapshot$$1.call(null, resolvedTarget, action$$1.args[0]);
    }
    if (!(typeof resolvedTarget[action$$1.name] === "function"))
        fail("Action '" + action$$1.name + "' does not exist in '" + node.path + "'");
    return resolvedTarget[action$$1.name].apply(resolvedTarget, action$$1.args ? action$$1.args.map(function (v) { return deserializeArgument(node, v); }) : []);
}
/**
 * Small abstraction around `onAction` and `applyAction`, attaches an action listener to a tree and records all the actions emitted.
 * Returns an recorder object with the following signature:
 *
 * @example
 * export interface IActionRecorder {
 *      // the recorded actions
 *      actions: ISerializedActionCall[]
 *      // stop recording actions
 *      stop(): any
 *      // apply all the recorded actions on the given object
 *      replay(target: IStateTreeNode): any
 * }
 *
 * @export
 * @param {IStateTreeNode} subject
 * @returns {IPatchRecorder}
 */
function recordActions$$1(subject) {
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(subject))
            fail("expected first argument to be a mobx-state-tree node, got " + subject + " instead");
    }
    var recorder = {
        actions: [],
        stop: function () { return disposer(); },
        replay: function (target) {
            applyAction$$1(target, recorder.actions);
        }
    };
    var disposer = onAction$$1(subject, recorder.actions.push.bind(recorder.actions));
    return recorder;
}
/**
 * Registers a function that will be invoked for each action that is called on the provided model instance, or to any of its children.
 * See [actions](https://github.com/mobxjs/mobx-state-tree#actions) for more details. onAction events are emitted only for the outermost called action in the stack.
 * Action can also be intercepted by middleware using addMiddleware to change the function call before it will be run.
 *
 * Not all action arguments might be serializable. For unserializable arguments, a struct like `{ $MST_UNSERIALIZABLE: true, type: "someType" }` will be generated.
 * MST Nodes are considered non-serializable as well (they could be serialized as there snapshot, but it is uncertain whether an replaying party will be able to handle such a non-instantiated snapshot).
 * Rather, when using `onAction` middleware, one should consider in passing arguments which are 1: an id, 2: a (relative) path, or 3: a snapshot. Instead of a real MST node.
 *
 * @example
 * const Todo = types.model({
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.array(Todo)
 * }).actions(self => ({
 *   add(todo) {
 *     self.todos.push(todo);
 *   }
 * }))
 *
 * const s = TodoStore.create({ todos: [] })
 *
 * let disposer = onAction(s, (call) => {
 *   console.log(call);
 * })
 *
 * s.add({ task: "Grab a coffee" })
 * // Logs: { name: "add", path: "", args: [{ task: "Grab a coffee" }] }
 *
 * @export
 * @param {IStateTreeNode} target
 * @param {(call: ISerializedActionCall) => void} listener
 * @param attachAfter {boolean} (default false) fires the listener *after* the action has executed instead of before.
 * @returns {IDisposer}
 */
function onAction$$1(target, listener, attachAfter) {
    if (attachAfter === void 0) { attachAfter = false; }
    // check all arguments
    if (false) {
        if (!isStateTreeNode$$1(target))
            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
        if (!isRoot$$1(target))
            console.warn("[mobx-state-tree] Warning: Attaching onAction listeners to non root nodes is dangerous: No events will be emitted for actions initiated higher up in the tree.");
        if (!isProtected$$1(target))
            console.warn("[mobx-state-tree] Warning: Attaching onAction listeners to non protected nodes is dangerous: No events will be emitted for direct modifications without action.");
    }
    return addMiddleware$$1(target, function handler(rawCall, next) {
        if (rawCall.type === "action" && rawCall.id === rawCall.rootId) {
            var sourceNode_1 = getStateTreeNode$$1(rawCall.context);
            var info = {
                name: rawCall.name,
                path: getRelativePathBetweenNodes$$1(getStateTreeNode$$1(target), sourceNode_1),
                args: rawCall.args.map(function (arg, index) {
                    return serializeArgument(sourceNode_1, rawCall.name, index, arg);
                })
            };
            if (attachAfter) {
                var res = next(rawCall);
                listener(info);
                return res;
            }
            else {
                listener(info);
                return next(rawCall);
            }
        }
        else {
            return next(rawCall);
        }
    });
}

var nextActionId = 1;
var currentActionContext = null;
/**
 * @internal
 * @private
 */
function getNextActionId$$1() {
    return nextActionId++;
}
// TODO: optimize away entire action context if there is no middleware in tree?
/**
 * @internal
 * @private
 */
function runWithActionContext$$1(context, fn) {
    var node = getStateTreeNode$$1(context.context);
    var baseIsRunningAction = node._isRunningAction;
    var prevContext = currentActionContext;
    if (context.type === "action") {
        node.assertAlive();
    }
    node._isRunningAction = true;
    currentActionContext = context;
    try {
        return runMiddleWares(node, context, fn);
    }
    finally {
        currentActionContext = prevContext;
        node._isRunningAction = baseIsRunningAction;
    }
}
/**
 * @internal
 * @private
 */
function getActionContext$$1() {
    if (!currentActionContext)
        return fail("Not running an action!");
    return currentActionContext;
}
/**
 * @internal
 * @private
 */
function createActionInvoker$$1(target, name, fn) {
    var res = function () {
        var id = getNextActionId$$1();
        return runWithActionContext$$1({
            type: "action",
            name: name,
            id: id,
            args: argsToArray(arguments),
            context: target,
            tree: getRoot$$1(target),
            rootId: currentActionContext ? currentActionContext.rootId : id,
            parentId: currentActionContext ? currentActionContext.id : 0,
            allParentIds: currentActionContext
                ? currentActionContext.allParentIds.concat([currentActionContext.id]) : []
        }, fn);
    };
    res._isMSTAction = true;
    return res;
}
/**
 * Middleware can be used to intercept any action is invoked on the subtree where it is attached.
 * If a tree is protected (by default), this means that any mutation of the tree will pass through your middleware.
 *
 * For more details, see the [middleware docs](docs/middleware.md)
 *
 * @export
 * @param {IStateTreeNode} target
 * @param {(action: IRawActionCall, next: (call: IRawActionCall) => any) => any} middleware
 * @returns {IDisposer}
 */
function addMiddleware$$1(target, handler, includeHooks) {
    if (includeHooks === void 0) { includeHooks = true; }
    var node = getStateTreeNode$$1(target);
    if (false) {
        if (!node.isProtectionEnabled)
            console.warn("It is recommended to protect the state tree before attaching action middleware, as otherwise it cannot be guaranteed that all changes are passed through middleware. See `protect`");
    }
    return node.addMiddleWare(handler, includeHooks);
}
/**
 * Binds middleware to a specific action
 *
 * @example
 * type.actions(self => {
 *   function takeA____() {
 *       self.toilet.donate()
 *       self.wipe()
 *       self.wipe()
 *       self.toilet.flush()
 *   }
 *   return {
 *     takeA____: decorate(atomic, takeA____)
 *   }
 * })
 *
 * @export
 * @template T
 * @param {IMiddlewareHandler} handler
 * @param Function} fn
 * @returns the original function
 */
function decorate$$1(handler, fn) {
    var middleware = { handler: handler, includeHooks: true };
    if (fn.$mst_middleware)
        fn.$mst_middleware.push(middleware);
    fn.$mst_middleware = [middleware];
    return fn;
}
function collectMiddlewares(node, baseCall, fn) {
    var middlewares = fn.$mst_middleware || EMPTY_ARRAY;
    var n = node;
    // Find all middlewares. Optimization: cache this?
    while (n) {
        if (n.middlewares)
            middlewares = middlewares.concat(n.middlewares);
        n = n.parent;
    }
    return middlewares;
}
function runMiddleWares(node, baseCall, originalFn) {
    var middlewares = collectMiddlewares(node, baseCall, originalFn);
    // Short circuit
    if (!middlewares.length)
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* action */])(originalFn).apply(null, baseCall.args);
    var index = 0;
    var result = null;
    function runNextMiddleware(call) {
        var middleware = middlewares[index++];
        var handler = middleware && middleware.handler;
        var nextInvoked = false;
        var abortInvoked = false;
        function next(call2, callback) {
            nextInvoked = true;
            // the result can contain
            // - the non manipulated return value from an action
            // - the non manipulated abort value
            // - one of the above but manipulated through the callback function
            if (callback) {
                result = callback(runNextMiddleware(call2) || result);
            }
            else {
                result = runNextMiddleware(call2);
            }
        }
        function abort(value) {
            abortInvoked = true;
            // overwrite the result
            // can be manipulated through middlewares earlier in the queue using the callback fn
            result = value;
        }
        var invokeHandler = function () {
            handler(call, next, abort);
            if (false) {
                if (!nextInvoked && !abortInvoked) {
                    var node2 = getStateTreeNode$$1(call.tree);
                    fail("Neither the next() nor the abort() callback within the middleware " + handler.name + " for the action: \"" + call.name + "\" on the node: " + node2.type.name + " was invoked.");
                }
                if (nextInvoked && abortInvoked) {
                    var node2 = getStateTreeNode$$1(call.tree);
                    fail("The next() and abort() callback within the middleware " + handler.name + " for the action: \"" + call.name + "\" on the node: " + node2.type.name + " were invoked.");
                }
            }
            return result;
        };
        if (handler && middleware.includeHooks) {
            return invokeHandler();
        }
        else if (handler && !middleware.includeHooks) {
            if (HookNames$$1[call.name])
                return runNextMiddleware(call);
            return invokeHandler();
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* action */])(originalFn).apply(null, call.args);
        }
    }
    return runNextMiddleware(baseCall);
}

function safeStringify(value) {
    try {
        return JSON.stringify(value);
    }
    catch (e) {
        return "<Unserializable: " + e + ">";
    }
}
/**
 * @internal
 * @private
 */
function prettyPrintValue$$1(value) {
    return typeof value === "function"
        ? "<function" + (value.name ? " " + value.name : "") + ">"
        : isStateTreeNode$$1(value)
            ? "<" + value + ">"
            : "`" + safeStringify(value) + "`";
}
function shortenPrintValue(valueInString) {
    return valueInString.length < 280
        ? valueInString
        : valueInString.substring(0, 272) + "......" + valueInString.substring(valueInString.length - 8);
}
function toErrorString(error) {
    var value = error.value;
    var type = error.context[error.context.length - 1].type;
    var fullPath = error.context
        .map(function (_a) {
        var path = _a.path;
        return path;
    })
        .filter(function (path) { return path.length > 0; })
        .join("/");
    var pathPrefix = fullPath.length > 0 ? "at path \"/" + fullPath + "\" " : "";
    var currentTypename = isStateTreeNode$$1(value)
        ? "value of type " + getStateTreeNode$$1(value).type.name + ":"
        : isPrimitive(value)
            ? "value"
            : "snapshot";
    var isSnapshotCompatible = type && isStateTreeNode$$1(value) && type.is(getStateTreeNode$$1(value).snapshot);
    return ("" + pathPrefix + currentTypename + " " + prettyPrintValue$$1(value) + " is not assignable " + (type ? "to type: `" + type.name + "`" : "") +
        (error.message ? " (" + error.message + ")" : "") +
        (type
            ? isPrimitiveType$$1(type) || isPrimitive(value)
                ? "."
                : ", expected an instance of `" + type.name + "` or a snapshot like `" + type.describe() + "` instead." +
                    (isSnapshotCompatible
                        ? " (Note that a snapshot of the provided value is compatible with the targeted type)"
                        : "")
            : "."));
}
/**
 * @internal
 * @private
 */
function getContextForPath$$1(context, path, type) {
    return context.concat([{ path: path, type: type }]);
}
/**
 * @internal
 * @private
 */
function typeCheckSuccess$$1() {
    return EMPTY_ARRAY;
}
/**
 * @internal
 * @private
 */
function typeCheckFailure$$1(context, value, message) {
    return [{ context: context, value: value, message: message }];
}
/**
 * @internal
 * @private
 */
function flattenTypeErrors$$1(errors) {
    return errors.reduce(function (a, i) { return a.concat(i); }, []);
}
// TODO; doublecheck: typecheck should only needed to be invoked from: type.create and array / map / value.property will change
/**
 * @internal
 * @private
 */
function typecheckInternal$$1(type, value) {
    // if not in dev-mode, do not even try to run typecheck. Everything is developer fault!
    if (true)
        return;
    typecheck$$1(type, value);
}
/**
 * Run's the typechecker on the given type.
 * Throws if the given value is not according the provided type specification.
 * Use this if you need typechecks even in a production build (by default all automatic runtime type checks will be skipped in production builds)
 *
 * @export
 * @param {IAnyType} type
 * @param {*} value
 */
function typecheck$$1(type, value) {
    var errors = type.validate(value, [{ path: "", type: type }]);
    if (errors.length > 0) {
        fail("Error while converting " + shortenPrintValue(prettyPrintValue$$1(value)) + " to `" + type.name + "`:\n\n    " + errors.map(toErrorString).join("\n    "));
    }
}

/**
 * @internal
 * @private
 */
var IdentifierCache$$1 = /** @class */ (function () {
    function IdentifierCache$$1() {
        // n.b. in cache all identifiers are normalized to strings
        this.cache = __WEBPACK_IMPORTED_MODULE_0_mobx__["t" /* observable */].map();
    }
    IdentifierCache$$1.prototype.addNodeToCache = function (node) {
        if (node.identifierAttribute) {
            var identifier$$1 = node.identifier;
            if (!this.cache.has(identifier$$1)) {
                this.cache.set(identifier$$1, __WEBPACK_IMPORTED_MODULE_0_mobx__["t" /* observable */].array([], mobxShallow));
            }
            var set$$1 = this.cache.get(identifier$$1);
            if (set$$1.indexOf(node) !== -1)
                fail("Already registered");
            set$$1.push(node);
        }
        return this;
    };
    IdentifierCache$$1.prototype.mergeCache = function (node) {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["A" /* values */])(node.identifierCache.cache).forEach(function (nodes) {
            return nodes.forEach(function (child) {
                _this.addNodeToCache(child);
            });
        });
    };
    IdentifierCache$$1.prototype.notifyDied = function (node) {
        if (node.identifierAttribute) {
            var set$$1 = this.cache.get(node.identifier);
            if (set$$1)
                set$$1.remove(node);
        }
    };
    IdentifierCache$$1.prototype.splitCache = function (node) {
        var res = new IdentifierCache$$1();
        var basePath = node.path;
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["A" /* values */])(this.cache).forEach(function (nodes) {
            for (var i = nodes.length - 1; i >= 0; i--) {
                if (nodes[i].path.indexOf(basePath) === 0) {
                    res.addNodeToCache(nodes[i]);
                    nodes.splice(i, 1);
                }
            }
        });
        return res;
    };
    IdentifierCache$$1.prototype.resolve = function (type, identifier$$1) {
        var set$$1 = this.cache.get("" + identifier$$1);
        if (!set$$1)
            return null;
        var matches = set$$1.filter(function (candidate) { return type.isAssignableFrom(candidate.type); });
        switch (matches.length) {
            case 0:
                return null;
            case 1:
                // make sure we instantiate all nodes up to the root (if available and if not done before)
                // fixes #993
                var matched = matches[0];
                if (matched) {
                    // array with parent chain from parent to child
                    var parentChain = [];
                    var parent = matched.parent;
                    // for performance reasons we never go back further than the most direct
                    // uninitialized parent
                    // this is done to avoid traversing the whole tree to the root when using
                    // the same reference again
                    while (parent && !parent.isObservableInstanceCreated) {
                        parentChain.unshift(parent);
                        parent = parent.parent;
                    }
                    // initialize the uninitialized parent chain from parent to child
                    for (var _i = 0, parentChain_1 = parentChain; _i < parentChain_1.length; _i++) {
                        var p = parentChain_1[_i];
                        p.createObservableInstanceIfNeeded();
                    }
                }
                return matched;
            default:
                return fail("Cannot resolve a reference to type '" + type.name + "' with id: '" + identifier$$1 + "' unambigously, there are multiple candidates: " + matches
                    .map(function (n) { return n.path; })
                    .join(", "));
        }
    };
    return IdentifierCache$$1;
}());

/**
 * @internal
 * @private
 */
function createNode$$1(type, parent, subpath, environment, initialValue) {
    var existingNode = getStateTreeNodeSafe$$1(initialValue);
    if (existingNode) {
        if (existingNode.isRoot) {
            existingNode.setParent(parent, subpath);
            return existingNode;
        }
        fail("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '" + (parent ? parent.path : "") + "/" + subpath + "', but it lives already at '" + existingNode.path + "'");
    }
    var Node = type.shouldAttachNode ? ObjectNode$$1 : ScalarNode$$1;
    return new Node(type, parent, subpath, environment, initialValue);
}
/**
 * @internal
 * @private
 */
function isNode$$1(value) {
    return value instanceof ScalarNode$$1 || value instanceof ObjectNode$$1;
}

/**
 * @internal
 * @private
 */
var NodeLifeCycle$$1;
(function (NodeLifeCycle$$1) {
    NodeLifeCycle$$1[NodeLifeCycle$$1["INITIALIZING"] = 0] = "INITIALIZING";
    NodeLifeCycle$$1[NodeLifeCycle$$1["CREATED"] = 1] = "CREATED";
    NodeLifeCycle$$1[NodeLifeCycle$$1["FINALIZED"] = 2] = "FINALIZED";
    NodeLifeCycle$$1[NodeLifeCycle$$1["DETACHING"] = 3] = "DETACHING";
    NodeLifeCycle$$1[NodeLifeCycle$$1["DEAD"] = 4] = "DEAD"; // no coming back from this one
})(NodeLifeCycle$$1 || (NodeLifeCycle$$1 = {}));
/**
 * Returns true if the given value is a node in a state tree.
 * More precisely, that is, if the value is an instance of a
 * `types.model`, `types.array` or `types.map`.
 *
 * @export
 * @param {*} value
 * @returns {value is IStateTreeNode}
 */
function isStateTreeNode$$1(value) {
    return !!(value && value.$treenode);
}
/**
 * @internal
 * @private
 */
function getStateTreeNode$$1(value) {
    if (isStateTreeNode$$1(value))
        return value.$treenode;
    else
        return fail("Value " + value + " is no MST Node");
}
/**
 * @internal
 * @private
 */
function getStateTreeNodeSafe$$1(value) {
    return (value && value.$treenode) || null;
}
/**
 * @internal
 * @private
 */
function toJSON$$1() {
    return getStateTreeNode$$1(this).snapshot;
}
var doubleDot = function (_) { return ".."; };
/**
 * @internal
 * @private
 */
function getRelativePathBetweenNodes$$1(base, target) {
    // PRE condition target is (a child of) base!
    if (base.root !== target.root)
        fail("Cannot calculate relative path: objects '" + base + "' and '" + target + "' are not part of the same object tree");
    var baseParts = splitJsonPath$$1(base.path);
    var targetParts = splitJsonPath$$1(target.path);
    var common = 0;
    for (; common < baseParts.length; common++) {
        if (baseParts[common] !== targetParts[common])
            break;
    }
    // TODO: assert that no targetParts paths are "..", "." or ""!
    return (baseParts
        .slice(common)
        .map(doubleDot)
        .join("/") + joinJsonPath$$1(targetParts.slice(common)));
}
/**
 * @internal
 * @private
 */
function resolveNodeByPath$$1(base, path, failIfResolveFails) {
    if (failIfResolveFails === void 0) { failIfResolveFails = true; }
    return resolveNodeByPathParts$$1(base, splitJsonPath$$1(path), failIfResolveFails);
}
/**
 * @internal
 * @private
 */
function resolveNodeByPathParts$$1(base, pathParts, failIfResolveFails) {
    if (failIfResolveFails === void 0) { failIfResolveFails = true; }
    // counter part of getRelativePath
    // note that `../` is not part of the JSON pointer spec, which is actually a prefix format
    // in json pointer: "" = current, "/a", attribute a, "/" is attribute "" etc...
    // so we treat leading ../ apart...
    var current = base;
    for (var i = 0; i < pathParts.length; i++) {
        var part = pathParts[i];
        if (part === "") {
            current = current.root;
            continue;
        }
        else if (part === "..") {
            current = current.parent;
            if (current)
                continue; // not everything has a parent
        }
        else if (part === "." || part === "") {
            // '/bla' or 'a//b' splits to empty strings
            continue;
        }
        else if (current) {
            if (current instanceof ScalarNode$$1) {
                // check if the value of a scalar resolves to a state tree node (e.g. references)
                // then we can continue resolving...
                try {
                    var value = current.value;
                    if (isStateTreeNode$$1(value)) {
                        current = getStateTreeNode$$1(value);
                        // fall through
                    }
                }
                catch (e) {
                    if (!failIfResolveFails) {
                        return undefined;
                    }
                    throw e;
                }
            }
            if (current instanceof ObjectNode$$1) {
                var subType = current.getChildType(part);
                if (subType) {
                    current = current.getChildNode(part);
                    if (current)
                        continue;
                }
            }
        }
        if (failIfResolveFails)
            return fail("Could not resolve '" + part + "' in path '" + (joinJsonPath$$1(pathParts.slice(0, i)) ||
                "/") + "' while resolving '" + joinJsonPath$$1(pathParts) + "'");
        else
            return undefined;
    }
    return current;
}
/**
 * @internal
 * @private
 */
function convertChildNodesToArray$$1(childNodes) {
    if (!childNodes)
        return EMPTY_ARRAY;
    var keys = Object.keys(childNodes);
    if (!keys.length)
        return EMPTY_ARRAY;
    var result = new Array(keys.length);
    keys.forEach(function (key, index) {
        result[index] = childNodes[key];
    });
    return result;
}

// based on: https://github.com/mobxjs/mobx-utils/blob/master/src/async-action.ts
/*
    All contents of this file are deprecated.

    The term `process` has been replaced with `flow` to avoid conflicts with the
    global `process` object.

    Refer to `flow.ts` for any further changes to this implementation.
*/
var DEPRECATION_MESSAGE = "See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information. " +
    "Note that the middleware event types starting with `process` now start with `flow`.";
/**
 * @deprecated has been renamed to `flow()`.
 * See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information.
 * Note that the middleware event types starting with `process` now start with `flow`.
 *
 * @export
 * @alias process
 * @returns {Promise}
 */
function process$$1(asyncAction) {
    deprecated("process", "`process()` has been renamed to `flow()`. " + DEPRECATION_MESSAGE);
    return flow(asyncAction);
}

/**
 * @internal
 * @private
 */
var EMPTY_ARRAY = Object.freeze([]);
/**
 * @internal
 * @private
 */
var EMPTY_OBJECT = Object.freeze({});
/**
 * @internal
 * @private
 */
var mobxShallow = typeof __WEBPACK_IMPORTED_MODULE_0_mobx__["a" /* $mobx */] === "string" ? { deep: false } : { deep: false, proxy: false };
Object.freeze(mobxShallow);
/**
 * @internal
 * @private
 */
function fail(message) {
    if (message === void 0) { message = "Illegal state"; }
    throw new Error("[mobx-state-tree] " + message);
}
/**
 * @internal
 * @private
 */
function identity(_) {
    return _;
}
// pollyfill (for IE) suggested in MDN:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
/**
 * @internal
 * @private
 */
var isInteger = Number.isInteger ||
    function (value) {
        return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
    };
/**
 * @internal
 * @private
 */
function isArray(val) {
    return !!(Array.isArray(val) || Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["p" /* isObservableArray */])(val));
}
/**
 * @internal
 * @private
 */
function asArray(val) {
    if (!val)
        return EMPTY_ARRAY;
    if (isArray(val))
        return val;
    return [val];
}
/**
 * @internal
 * @private
 */
function extend(a) {
    var b = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        b[_i - 1] = arguments[_i];
    }
    for (var i = 0; i < b.length; i++) {
        var current = b[i];
        for (var key in current)
            a[key] = current[key];
    }
    return a;
}
/**
 * @internal
 * @private
 */
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
/**
 * @internal
 * @private
 */
function isMutable(value) {
    return (value !== null &&
        typeof value === "object" &&
        !(value instanceof Date) &&
        !(value instanceof RegExp));
}
/**
 * @internal
 * @private
 */
function isPrimitive(value) {
    if (value === null || value === undefined)
        return true;
    if (typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean" ||
        value instanceof Date)
        return true;
    return false;
}
/**
 * @internal
 * @private
 * Freeze a value and return it (if not in production)
 */
function freeze(value) {
    if (true)
        return value;
    return isPrimitive(value) || Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["p" /* isObservableArray */])(value) ? value : Object.freeze(value);
}
/**
 * @internal
 * @private
 * Recursively freeze a value (if not in production)
 */
function deepFreeze(value) {
    if (true)
        return value;
    freeze(value);
    if (isPlainObject(value)) {
        Object.keys(value).forEach(function (propKey) {
            if (!isPrimitive(value[propKey]) &&
                !Object.isFrozen(value[propKey])) {
                deepFreeze(value[propKey]);
            }
        });
    }
    return value;
}
/**
 * @internal
 * @private
 */
function isSerializable(value) {
    return typeof value !== "function";
}
/**
 * @internal
 * @private
 */
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
/**
 * @internal
 * @private
 */
function addHiddenWritableProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
/**
 * @internal
 * @private
 */
function addReadOnlyProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: true,
        writable: false,
        configurable: true,
        value: value
    });
}
/**
 * @internal
 * @private
 */
function remove(collection, item) {
    var idx = collection.indexOf(item);
    if (idx !== -1)
        collection.splice(idx, 1);
}
/**
 * @internal
 * @private
 */
function registerEventHandler(handlers, handler) {
    handlers.push(handler);
    return function () {
        remove(handlers, handler);
    };
}
/**
 * @internal
 * @private
 */
function argsToArray(args) {
    var res = new Array(args.length);
    for (var i = 0; i < args.length; i++)
        res[i] = args[i];
    return res;
}
/**
 * @internal
 * @private
 */
function invalidateComputed(target, propName) {
    var atom = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* getAtom */])(target, propName);
    atom.trackAndCompute();
}
/**
 * @internal
 * @private
 */
var deprecated = function (id, message) {
    // skip if running production
    if (true)
        return;
    // warn if hasn't been warned before
    if (deprecated.ids && !deprecated.ids.hasOwnProperty(id)) {
        console.warn("[mobx-state-tree] Deprecation warning: " + message);
    }
    // mark as warned to avoid duplicate warn message
    if (deprecated.ids)
        deprecated.ids[id] = true;
};
deprecated.ids = {};

// based on: https://github.com/mobxjs/mobx-utils/blob/master/src/async-action.ts
/**
 * See [asynchronous actions](https://github.com/mobxjs/mobx-state-tree/blob/master/docs/async-actions.md).
 *
 * @export
 * @alias flow
 * @returns {Promise}
 */
function flow(asyncAction) {
    return createFlowSpawner(asyncAction.name, asyncAction);
}
/**
 * @internal
 * @private
 */
function createFlowSpawner(name, generator) {
    var spawner = function flowSpawner() {
        // Implementation based on https://github.com/tj/co/blob/master/index.js
        var runId = getNextActionId$$1();
        var baseContext = getActionContext$$1();
        var args = arguments;
        function wrap(fn, type, arg) {
            fn.$mst_middleware = spawner.$mst_middleware; // pick up any middleware attached to the flow
            runWithActionContext$$1({
                name: name,
                type: type,
                id: runId,
                args: [arg],
                tree: baseContext.tree,
                context: baseContext.context,
                parentId: baseContext.id,
                allParentIds: baseContext.allParentIds.concat([baseContext.id]),
                rootId: baseContext.rootId
            }, fn);
        }
        return new Promise(function (resolve, reject) {
            var gen;
            var init = function asyncActionInit() {
                gen = generator.apply(null, arguments);
                onFulfilled(undefined); // kick off the flow
            };
            init.$mst_middleware = spawner.$mst_middleware;
            runWithActionContext$$1({
                name: name,
                type: "flow_spawn",
                id: runId,
                args: argsToArray(args),
                tree: baseContext.tree,
                context: baseContext.context,
                parentId: baseContext.id,
                allParentIds: baseContext.allParentIds.concat([baseContext.id]),
                rootId: baseContext.rootId
            }, init);
            function onFulfilled(res) {
                var ret;
                try {
                    // prettier-ignore
                    wrap(function (r) { ret = gen.next(r); }, "flow_resume", res);
                }
                catch (e) {
                    // prettier-ignore
                    setImmediate(function () {
                        wrap(function (r) { reject(e); }, "flow_throw", e);
                    });
                    return;
                }
                next(ret);
                return;
            }
            function onRejected(err) {
                var ret;
                try {
                    // prettier-ignore
                    wrap(function (r) { ret = gen.throw(r); }, "flow_resume_error", err); // or yieldError?
                }
                catch (e) {
                    // prettier-ignore
                    setImmediate(function () {
                        wrap(function (r) { reject(e); }, "flow_throw", e);
                    });
                    return;
                }
                next(ret);
            }
            function next(ret) {
                if (ret.done) {
                    // prettier-ignore
                    setImmediate(function () {
                        wrap(function (r) { resolve(r); }, "flow_return", ret.value);
                    });
                    return;
                }
                // TODO: support more type of values? See https://github.com/tj/co/blob/249bbdc72da24ae44076afd716349d2089b31c4c/index.js#L100
                if (!ret.value || typeof ret.value.then !== "function")
                    fail("Only promises can be yielded to `async`, got: " + ret);
                return ret.value.then(onFulfilled, onRejected);
            }
        });
    };
    return spawner;
}

/**
 * @internal
 * @private
 */
function splitPatch$$1(patch) {
    if (!("oldValue" in patch))
        fail("Patches without `oldValue` field cannot be inversed");
    return [stripPatch$$1(patch), invertPatch(patch)];
}
/**
 * @internal
 * @private
 */
function stripPatch$$1(patch) {
    // strips `oldvalue` information from the patch, so that it becomes a patch conform the json-patch spec
    // this removes the ability to undo the patch
    switch (patch.op) {
        case "add":
            return { op: "add", path: patch.path, value: patch.value };
        case "remove":
            return { op: "remove", path: patch.path };
        case "replace":
            return { op: "replace", path: patch.path, value: patch.value };
    }
}
function invertPatch(patch) {
    switch (patch.op) {
        case "add":
            return {
                op: "remove",
                path: patch.path
            };
        case "remove":
            return {
                op: "add",
                path: patch.path,
                value: patch.oldValue
            };
        case "replace":
            return {
                op: "replace",
                path: patch.path,
                value: patch.oldValue
            };
    }
}
// simple simple simple check
function isNumber(x) {
    return typeof x === "number";
}
/**
 * escape slashes and backslashes
 * http://tools.ietf.org/html/rfc6901
 */
function escapeJsonPath$$1(str) {
    if (isNumber(str) === true) {
        return "" + str;
    }
    return str.replace(/~/g, "~1").replace(/\//g, "~0");
}
/**
 * unescape slashes and backslashes
 */
function unescapeJsonPath$$1(str) {
    return str.replace(/~0/g, "/").replace(/~1/g, "~");
}
/**
 * Generates a json-path compliant json path from path parts
 *
 * @export
 * @param {string[]} path
 * @returns {string}
 */
function joinJsonPath$$1(path) {
    // `/` refers to property with an empty name, while `` refers to root itself!
    if (path.length === 0)
        return "";
    return "/" + path.map(escapeJsonPath$$1).join("/");
}
/**
 * Splits and decodes a json path into several parts
 *
 * @export
 * @param {string} path
 * @returns {string[]}
 */
function splitJsonPath$$1(path) {
    // `/` refers to property with an empty name, while `` refers to root itself!
    var parts = path.split("/").map(unescapeJsonPath$$1);
    // path '/a/b/c' -> a b c
    // path '../../b/c -> .. .. b c
    return parts[0] === "" ? parts.slice(1) : parts;
}

var needsIdentifierError = "Map.put can only be used to store complex values that have an identifier type attribute";
function tryCollectModelTypes(type, modelTypes) {
    if (type instanceof ModelType$$1) {
        modelTypes.push(type);
    }
    else if (type instanceof OptionalValue$$1) {
        if (!tryCollectModelTypes(type.type, modelTypes))
            return false;
    }
    else if (type instanceof Union$$1) {
        for (var i = 0; i < type.types.length; i++) {
            var uType = type.types[i];
            if (!tryCollectModelTypes(uType, modelTypes))
                return false;
        }
    }
    else if (type instanceof Late$$1) {
        var t = type.getSubType(false);
        if (!t)
            return false;
        tryCollectModelTypes(t, modelTypes);
    }
    return true;
}
/**
 * @internal
 * @private
 */
var MapIdentifierMode$$1;
(function (MapIdentifierMode$$1) {
    MapIdentifierMode$$1[MapIdentifierMode$$1["UNKNOWN"] = 0] = "UNKNOWN";
    MapIdentifierMode$$1[MapIdentifierMode$$1["YES"] = 1] = "YES";
    MapIdentifierMode$$1[MapIdentifierMode$$1["NO"] = 2] = "NO";
})(MapIdentifierMode$$1 || (MapIdentifierMode$$1 = {}));
var MSTMap = /** @class */ (function (_super) {
    __extends(MSTMap, _super);
    function MSTMap(initialData) {
        return _super.call(this, initialData, __WEBPACK_IMPORTED_MODULE_0_mobx__["t" /* observable */].ref.enhancer) || this;
    }
    MSTMap.prototype.get = function (key) {
        // maybe this is over-enthousiastic? normalize numeric keys to strings
        return _super.prototype.get.call(this, "" + key);
    };
    MSTMap.prototype.has = function (key) {
        return _super.prototype.has.call(this, "" + key);
    };
    MSTMap.prototype.delete = function (key) {
        return _super.prototype.delete.call(this, "" + key);
    };
    MSTMap.prototype.set = function (key, value) {
        return _super.prototype.set.call(this, "" + key, value);
    };
    MSTMap.prototype.put = function (value) {
        if (!!!value)
            fail("Map.put cannot be used to set empty values");
        if (isStateTreeNode$$1(value)) {
            var node = getStateTreeNode$$1(value);
            if (false) {
                if (!node.identifierAttribute)
                    return fail(needsIdentifierError);
            }
            var key = node.identifier;
            this.set(key, node.value);
            return node.value;
        }
        else if (!isMutable(value)) {
            return fail("Map.put can only be used to store complex values");
        }
        else {
            var key = void 0;
            var mapType = getStateTreeNode$$1(this).type;
            if (mapType.identifierMode === MapIdentifierMode$$1.NO)
                return fail(needsIdentifierError);
            if (mapType.identifierMode === MapIdentifierMode$$1.YES) {
                key = "" + value[mapType.mapIdentifierAttribute];
                this.set(key, value);
                return this.get(key);
            }
            return fail(needsIdentifierError);
        }
    };
    return MSTMap;
}(__WEBPACK_IMPORTED_MODULE_0_mobx__["b" /* ObservableMap */]));
/**
 * @internal
 * @private
 */
var MapType$$1 = /** @class */ (function (_super) {
    __extends(MapType$$1, _super);
    function MapType$$1(name, subType) {
        var _this = _super.call(this, name) || this;
        _this.shouldAttachNode = true;
        _this.identifierMode = MapIdentifierMode$$1.UNKNOWN;
        _this.mapIdentifierAttribute = undefined;
        _this.flags = TypeFlags$$1.Map;
        _this.subType = subType;
        _this._determineIdentifierMode();
        return _this;
    }
    MapType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        if (this.identifierMode === MapIdentifierMode$$1.UNKNOWN) {
            this._determineIdentifierMode();
        }
        return createNode$$1(this, parent, subpath, environment, snapshot);
    };
    MapType$$1.prototype._determineIdentifierMode = function () {
        var modelTypes = [];
        if (tryCollectModelTypes(this.subType, modelTypes)) {
            var identifierAttribute_1 = undefined;
            modelTypes.forEach(function (type) {
                if (type.identifierAttribute) {
                    if (identifierAttribute_1 && identifierAttribute_1 !== type.identifierAttribute) {
                        fail("The objects in a map should all have the same identifier attribute, expected '" + identifierAttribute_1 + "', but child of type '" + type.name + "' declared attribute '" + type.identifierAttribute + "' as identifier");
                    }
                    identifierAttribute_1 = type.identifierAttribute;
                }
            });
            if (identifierAttribute_1) {
                this.identifierMode = MapIdentifierMode$$1.YES;
                this.mapIdentifierAttribute = identifierAttribute_1;
            }
            else {
                this.identifierMode = MapIdentifierMode$$1.NO;
            }
        }
    };
    MapType$$1.prototype.initializeChildNodes = function (objNode, initialSnapshot) {
        if (initialSnapshot === void 0) { initialSnapshot = {}; }
        var subType = objNode.type.subType;
        var environment = objNode._environment;
        var result = {};
        Object.keys(initialSnapshot).forEach(function (name) {
            result[name] = subType.instantiate(objNode, name, environment, initialSnapshot[name]);
        });
        return result;
    };
    MapType$$1.prototype.createNewInstance = function (node, childNodes, snapshot) {
        return new MSTMap(childNodes);
    };
    MapType$$1.prototype.finalizeNewInstance = function (node, instance) {
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["g" /* _interceptReads */])(instance, node.unbox);
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["n" /* intercept */])(instance, this.willChange);
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["u" /* observe */])(instance, this.didChange);
    };
    MapType$$1.prototype.describe = function () {
        return "Map<string, " + this.subType.describe() + ">";
    };
    MapType$$1.prototype.getChildren = function (node) {
        // return (node.storedValue as ObservableMap<any>).values()
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["A" /* values */])(node.storedValue);
    };
    MapType$$1.prototype.getChildNode = function (node, key) {
        var childNode = node.storedValue.get("" + key);
        if (!childNode)
            fail("Not a child " + key);
        return childNode;
    };
    MapType$$1.prototype.willChange = function (change) {
        var node = getStateTreeNode$$1(change.object);
        var key = change.name;
        node.assertWritable();
        var mapType = node.type;
        var subType = mapType.subType;
        switch (change.type) {
            case "update":
                {
                    var newValue = change.newValue;
                    var oldValue = change.object.get(key);
                    if (newValue === oldValue)
                        return null;
                    typecheckInternal$$1(subType, newValue);
                    change.newValue = subType.reconcile(node.getChildNode(key), change.newValue);
                    mapType.processIdentifier(key, change.newValue);
                }
                break;
            case "add":
                {
                    typecheckInternal$$1(subType, change.newValue);
                    change.newValue = subType.instantiate(node, key, undefined, change.newValue);
                    mapType.processIdentifier(key, change.newValue);
                }
                break;
        }
        return change;
    };
    MapType$$1.prototype.processIdentifier = function (expected, node) {
        if (this.identifierMode === MapIdentifierMode$$1.YES && node instanceof ObjectNode$$1) {
            var identifier$$1 = node.identifier;
            if (identifier$$1 !== expected)
                fail("A map of objects containing an identifier should always store the object under their own identifier. Trying to store key '" + identifier$$1 + "', but expected: '" + expected + "'");
        }
    };
    MapType$$1.prototype.getValue = function (node) {
        return node.storedValue;
    };
    MapType$$1.prototype.getSnapshot = function (node) {
        var res = {};
        node.getChildren().forEach(function (childNode) {
            res[childNode.subpath] = childNode.snapshot;
        });
        return res;
    };
    MapType$$1.prototype.processInitialSnapshot = function (childNodes, snapshot) {
        var processed = {};
        Object.keys(childNodes).forEach(function (key) {
            processed[key] = childNodes[key].getSnapshot();
        });
        return processed;
    };
    MapType$$1.prototype.didChange = function (change) {
        var node = getStateTreeNode$$1(change.object);
        switch (change.type) {
            case "update":
                return void node.emitPatch({
                    op: "replace",
                    path: escapeJsonPath$$1(change.name),
                    value: change.newValue.snapshot,
                    oldValue: change.oldValue ? change.oldValue.snapshot : undefined
                }, node);
            case "add":
                return void node.emitPatch({
                    op: "add",
                    path: escapeJsonPath$$1(change.name),
                    value: change.newValue.snapshot,
                    oldValue: undefined
                }, node);
            case "delete":
                // a node got deleted, get the old snapshot and make the node die
                var oldSnapshot = change.oldValue.snapshot;
                change.oldValue.die();
                // emit the patch
                return void node.emitPatch({ op: "remove", path: escapeJsonPath$$1(change.name), oldValue: oldSnapshot }, node);
        }
    };
    MapType$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
        var target = node.storedValue;
        switch (patch.op) {
            case "add":
            case "replace":
                target.set(subpath, patch.value);
                break;
            case "remove":
                target.delete(subpath);
                break;
        }
    };
    MapType$$1.prototype.applySnapshot = function (node, snapshot) {
        typecheckInternal$$1(this, snapshot);
        var target = node.storedValue;
        var currentKeys = {};
        Array.from(target.keys()).forEach(function (key) {
            currentKeys[key] = false;
        });
        // Don't use target.replace, as it will throw all existing items first
        for (var key in snapshot) {
            target.set(key, snapshot[key]);
            currentKeys["" + key] = true;
        }
        Object.keys(currentKeys).forEach(function (key) {
            if (currentKeys[key] === false)
                target.delete(key);
        });
    };
    MapType$$1.prototype.getChildType = function (key) {
        return this.subType;
    };
    MapType$$1.prototype.isValidSnapshot = function (value, context) {
        var _this = this;
        if (!isPlainObject(value)) {
            return typeCheckFailure$$1(context, value, "Value is not a plain object");
        }
        return flattenTypeErrors$$1(Object.keys(value).map(function (path) {
            return _this.subType.validate(value[path], getContextForPath$$1(context, path, _this.subType));
        }));
    };
    MapType$$1.prototype.getDefaultSnapshot = function () {
        return EMPTY_OBJECT;
    };
    MapType$$1.prototype.removeChild = function (node, subpath) {
        node.storedValue.delete(subpath);
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* action */]
    ], MapType$$1.prototype, "applySnapshot", null);
    return MapType$$1;
}(ComplexType$$1));
/**
 * Creates a key based collection type who's children are all of a uniform declared type.
 * If the type stored in a map has an identifier, it is mandatory to store the child under that identifier in the map.
 *
 * This type will always produce [observable maps](https://mobx.js.org/refguide/map.html)
 *
 * @example
 * const Todo = types.model({
 *   id: types.identifier,
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.map(Todo)
 * })
 *
 * const s = TodoStore.create({ todos: {} })
 * unprotect(s)
 * s.todos.set(17, { task: "Grab coffee", id: 17 })
 * s.todos.put({ task: "Grab cookie", id: 18 }) // put will infer key from the identifier
 * console.log(s.todos.get(17).task) // prints: "Grab coffee"
 *
 * @export
 * @alias types.map
 * @param {IType<S, T>} subtype
 * @returns {IComplexType<S[], IObservableArray<T>>}
 */
function map$$1(subtype) {
    var ret = new MapType$$1("map<string, " + subtype.name + ">", subtype);
    return ret;
}
/**
 * Returns if a given value represents a map type.
 *
 * @export
 * @template IT
 * @param {IT} type
 * @returns {type is IT}
 */
function isMapType$$1(type) {
    return isType$$1(type) && (type.flags & TypeFlags$$1.Map) > 0;
}

/**
 * @internal
 * @private
 */
var ArrayType$$1 = /** @class */ (function (_super) {
    __extends(ArrayType$$1, _super);
    function ArrayType$$1(name, subType) {
        var _this = _super.call(this, name) || this;
        _this.shouldAttachNode = true;
        _this.flags = TypeFlags$$1.Array;
        _this.subType = subType;
        return _this;
    }
    ArrayType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        return createNode$$1(this, parent, subpath, environment, snapshot);
    };
    ArrayType$$1.prototype.initializeChildNodes = function (objNode, snapshot) {
        if (snapshot === void 0) { snapshot = []; }
        var subType = objNode.type.subType;
        var environment = objNode._environment;
        var result = {};
        snapshot.forEach(function (item, index) {
            var subpath = "" + index;
            result[subpath] = subType.instantiate(objNode, subpath, environment, item);
        });
        return result;
    };
    ArrayType$$1.prototype.createNewInstance = function (node, childNodes, snapshot) {
        return __WEBPACK_IMPORTED_MODULE_0_mobx__["t" /* observable */].array(convertChildNodesToArray$$1(childNodes), mobxShallow);
    };
    ArrayType$$1.prototype.finalizeNewInstance = function (node, instance) {
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* _getAdministration */])(instance).dehancer = node.unbox;
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["n" /* intercept */])(instance, this.willChange);
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["u" /* observe */])(instance, this.didChange);
    };
    ArrayType$$1.prototype.describe = function () {
        return this.subType.describe() + "[]";
    };
    ArrayType$$1.prototype.getChildren = function (node) {
        return node.storedValue.slice();
    };
    ArrayType$$1.prototype.getChildNode = function (node, key) {
        var index = parseInt(key, 10);
        if (index < node.storedValue.length)
            return node.storedValue[index];
        return fail("Not a child: " + key);
    };
    ArrayType$$1.prototype.willChange = function (change) {
        var node = getStateTreeNode$$1(change.object);
        node.assertWritable();
        var subType = node.type.subType;
        var childNodes = node.getChildren();
        var nodes = null;
        switch (change.type) {
            case "update":
                if (change.newValue === change.object[change.index])
                    return null;
                nodes = reconcileArrayChildren(node, subType, [childNodes[change.index]], [change.newValue], [change.index]);
                if (!nodes) {
                    return null;
                }
                change.newValue = nodes[0];
                break;
            case "splice":
                var index_1 = change.index, removedCount = change.removedCount, added = change.added;
                nodes = reconcileArrayChildren(node, subType, childNodes.slice(index_1, index_1 + removedCount), added, added.map(function (_, i) { return index_1 + i; }));
                if (!nodes) {
                    return null;
                }
                change.added = nodes;
                // update paths of remaining items
                for (var i = index_1 + removedCount; i < childNodes.length; i++) {
                    childNodes[i].setParent(node, "" + (i + added.length - removedCount));
                }
                break;
        }
        return change;
    };
    ArrayType$$1.prototype.getValue = function (node) {
        return node.storedValue;
    };
    ArrayType$$1.prototype.getSnapshot = function (node) {
        return node.getChildren().map(function (childNode) { return childNode.snapshot; });
    };
    ArrayType$$1.prototype.processInitialSnapshot = function (childNodes, snapshot) {
        var processed = [];
        Object.keys(childNodes).forEach(function (key) {
            processed.push(childNodes[key].getSnapshot());
        });
        return processed;
    };
    ArrayType$$1.prototype.didChange = function (change) {
        var node = getStateTreeNode$$1(change.object);
        switch (change.type) {
            case "update":
                return void node.emitPatch({
                    op: "replace",
                    path: "" + change.index,
                    value: change.newValue.snapshot,
                    oldValue: change.oldValue ? change.oldValue.snapshot : undefined
                }, node);
            case "splice":
                for (var i = change.removedCount - 1; i >= 0; i--)
                    node.emitPatch({
                        op: "remove",
                        path: "" + (change.index + i),
                        oldValue: change.removed[i].snapshot
                    }, node);
                for (var i = 0; i < change.addedCount; i++)
                    node.emitPatch({
                        op: "add",
                        path: "" + (change.index + i),
                        value: node.getChildNode("" + (change.index + i)).snapshot,
                        oldValue: undefined
                    }, node);
                return;
        }
    };
    ArrayType$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
        var target = node.storedValue;
        var index = subpath === "-" ? target.length : parseInt(subpath);
        switch (patch.op) {
            case "replace":
                target[index] = patch.value;
                break;
            case "add":
                target.splice(index, 0, patch.value);
                break;
            case "remove":
                target.splice(index, 1);
                break;
        }
    };
    ArrayType$$1.prototype.applySnapshot = function (node, snapshot) {
        typecheckInternal$$1(this, snapshot);
        var target = node.storedValue;
        target.replace(snapshot);
    };
    ArrayType$$1.prototype.getChildType = function (key) {
        return this.subType;
    };
    ArrayType$$1.prototype.isValidSnapshot = function (value, context) {
        var _this = this;
        if (!isArray(value)) {
            return typeCheckFailure$$1(context, value, "Value is not an array");
        }
        return flattenTypeErrors$$1(value.map(function (item, index) {
            return _this.subType.validate(item, getContextForPath$$1(context, "" + index, _this.subType));
        }));
    };
    ArrayType$$1.prototype.getDefaultSnapshot = function () {
        return EMPTY_ARRAY;
    };
    ArrayType$$1.prototype.removeChild = function (node, subpath) {
        node.storedValue.splice(parseInt(subpath, 10), 1);
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* action */]
    ], ArrayType$$1.prototype, "applySnapshot", null);
    return ArrayType$$1;
}(ComplexType$$1));
/**
 * Creates an index based collection type who's children are all of a uniform declared type.
 *
 * This type will always produce [observable arrays](https://mobx.js.org/refguide/array.html)
 *
 * @example
 * const Todo = types.model({
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.array(Todo)
 * })
 *
 * const s = TodoStore.create({ todos: [] })
 * unprotect(s) // needed to allow modifying outside of an action
 * s.todos.push({ task: "Grab coffee" })
 * console.log(s.todos[0]) // prints: "Grab coffee"
 *
 * @export
 * @alias types.array
 * @param {IType<S, T>} subtype
 * @returns {IComplexType<S[], IObservableArray<T>>}
 */
function array$$1(subtype) {
    if (false) {
        if (!isType$$1(subtype))
            fail("expected a mobx-state-tree type as first argument, got " + subtype + " instead");
    }
    var ret = new ArrayType$$1(subtype.name + "[]", subtype);
    return ret;
}
function reconcileArrayChildren(parent, childType, oldNodes, newValues, newPaths) {
    var oldNode, newValue, hasNewNode = false, oldMatch = undefined, nothingChanged = true;
    for (var i = 0;; i++) {
        hasNewNode = i <= newValues.length - 1;
        oldNode = oldNodes[i];
        newValue = hasNewNode ? newValues[i] : undefined;
        // for some reason, instead of newValue we got a node, fallback to the storedValue
        // TODO: https://github.com/mobxjs/mobx-state-tree/issues/340#issuecomment-325581681
        if (isNode$$1(newValue))
            newValue = newValue.storedValue;
        // both are empty, end
        if (!oldNode && !hasNewNode) {
            break;
            // new one does not exists, old one dies
        }
        else if (!hasNewNode) {
            oldNode.die();
            oldNodes.splice(i, 1);
            i--;
            nothingChanged = false;
            // there is no old node, create it
        }
        else if (!oldNode) {
            // check if already belongs to the same parent. if so, avoid pushing item in. only swapping can occur.
            if (isStateTreeNode$$1(newValue) && getStateTreeNode$$1(newValue).parent === parent) {
                // this node is owned by this parent, but not in the reconcilable set, so it must be double
                fail("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '" + parent.path + "/" + newPaths[i] + "', but it lives already at '" + getStateTreeNode$$1(newValue).path + "'");
            }
            oldNodes.splice(i, 0, valueAsNode(childType, parent, "" + newPaths[i], newValue));
            nothingChanged = false;
            // both are the same, reconcile
        }
        else if (areSame(oldNode, newValue)) {
            oldNodes[i] = valueAsNode(childType, parent, "" + newPaths[i], newValue, oldNode);
            // nothing to do, try to reorder
        }
        else {
            oldMatch = undefined;
            // find a possible candidate to reuse
            for (var j = i; j < oldNodes.length; j++) {
                if (areSame(oldNodes[j], newValue)) {
                    oldMatch = oldNodes.splice(j, 1)[0];
                    break;
                }
            }
            oldNodes.splice(i, 0, valueAsNode(childType, parent, "" + newPaths[i], newValue, oldMatch));
            nothingChanged = false;
        }
    }
    return nothingChanged ? null : oldNodes;
}
// convert a value to a node at given parent and subpath. attempts to reuse old node if possible and given
function valueAsNode(childType, parent, subpath, newValue, oldNode) {
    // ensure the value is valid-ish
    typecheckInternal$$1(childType, newValue);
    // the new value has a MST node
    if (isStateTreeNode$$1(newValue)) {
        var childNode = getStateTreeNode$$1(newValue);
        childNode.assertAlive();
        // the node lives here
        if (childNode.parent !== null && childNode.parent === parent) {
            childNode.setParent(parent, subpath);
            if (oldNode && oldNode !== childNode)
                oldNode.die();
            return childNode;
        }
    }
    // there is old node and new one is a value/snapshot
    if (oldNode) {
        var childNode = childType.reconcile(oldNode, newValue);
        childNode.setParent(parent, subpath);
        return childNode;
    }
    // nothing to do, create from scratch
    return childType.instantiate(parent, subpath, parent._environment, newValue);
}
// given a value
function areSame(oldNode, newValue) {
    // the new value has the same node
    if (isStateTreeNode$$1(newValue)) {
        return getStateTreeNode$$1(newValue) === oldNode;
    }
    // the provided value is the snapshot of the old node
    if (oldNode.snapshot === newValue)
        return true;
    // new value is a snapshot with the correct identifier
    if (oldNode instanceof ObjectNode$$1 &&
        oldNode.identifier !== null &&
        oldNode.identifierAttribute &&
        isPlainObject(newValue) &&
        oldNode.identifier === "" + newValue[oldNode.identifierAttribute] &&
        oldNode.type.is(newValue))
        return true;
    return false;
}
/**
 * Returns if a given value represents an array type.
 *
 * @export
 * @template IT
 * @param {IT} type
 * @returns {type is IT}
 */
function isArrayType$$1(type) {
    return isType$$1(type) && (type.flags & TypeFlags$$1.Array) > 0;
}

var PRE_PROCESS_SNAPSHOT = "preProcessSnapshot";
var POST_PROCESS_SNAPSHOT = "postProcessSnapshot";
/**
 * @internal
 * @private
 */
var HookNames$$1;
(function (HookNames$$1) {
    HookNames$$1["afterCreate"] = "afterCreate";
    HookNames$$1["afterAttach"] = "afterAttach";
    HookNames$$1["beforeDetach"] = "beforeDetach";
    HookNames$$1["beforeDestroy"] = "beforeDestroy";
})(HookNames$$1 || (HookNames$$1 = {}));
function objectTypeToString() {
    return getStateTreeNode$$1(this).toString();
}
var defaultObjectOptions = {
    name: "AnonymousModel",
    properties: {},
    initializers: EMPTY_ARRAY
};
function toPropertiesObject(declaredProps) {
    // loop through properties and ensures that all items are types
    return Object.keys(declaredProps).reduce(function (props, key) {
        var _a, _b, _c;
        // warn if user intended a HOOK
        if (key in HookNames$$1)
            return fail("Hook '" + key + "' was defined as property. Hooks should be defined as part of the actions");
        // the user intended to use a view
        var descriptor = Object.getOwnPropertyDescriptor(props, key);
        if ("get" in descriptor) {
            fail("Getters are not supported as properties. Please use views instead");
        }
        // undefined and null are not valid
        var value = descriptor.value;
        if (value === null || value === undefined) {
            fail("The default value of an attribute cannot be null or undefined as the type cannot be inferred. Did you mean `types.maybe(someType)`?");
            // its a primitive, convert to its type
        }
        else if (isPrimitive(value)) {
            return Object.assign({}, props, (_a = {},
                _a[key] = optional$$1(getPrimitiveFactoryFromValue$$1(value), value),
                _a));
            // map defaults to empty object automatically for models
        }
        else if (value instanceof MapType$$1) {
            return Object.assign({}, props, (_b = {},
                _b[key] = optional$$1(value, {}),
                _b));
        }
        else if (value instanceof ArrayType$$1) {
            return Object.assign({}, props, (_c = {}, _c[key] = optional$$1(value, []), _c));
            // its already a type
        }
        else if (isType$$1(value)) {
            return props;
            // its a function, maybe the user wanted a view?
        }
        else if (false) {
            fail("Invalid type definition for property '" + key + "', it looks like you passed a function. Did you forget to invoke it, or did you intend to declare a view / action?");
            // no other complex values
        }
        else if (false) {
            fail("Invalid type definition for property '" + key + "', it looks like you passed an object. Try passing another model type or a types.frozen.");
            // WTF did you pass in mate?
        }
        else {
            fail("Invalid type definition for property '" + key + "', cannot infer a type from a value like '" + value + "' (" + typeof value + ")");
        }
    }, declaredProps);
}
/**
 * @internal
 * @private
 */
var ModelType$$1 = /** @class */ (function (_super) {
    __extends(ModelType$$1, _super);
    function ModelType$$1(opts) {
        var _this = _super.call(this, opts.name || defaultObjectOptions.name) || this;
        _this.flags = TypeFlags$$1.Object;
        _this.shouldAttachNode = true;
        var name = opts.name || defaultObjectOptions.name;
        // TODO: this test still needed?
        if (!/^\w[\w\d_]*$/.test(name))
            fail("Typename should be a valid identifier: " + name);
        Object.assign(_this, defaultObjectOptions, opts);
        // ensures that any default value gets converted to its related type
        _this.properties = toPropertiesObject(_this.properties);
        freeze(_this.properties); // make sure nobody messes with it
        _this.propertyNames = Object.keys(_this.properties);
        _this.identifierAttribute = _this._getIdentifierAttribute();
        return _this;
    }
    ModelType$$1.prototype._getIdentifierAttribute = function () {
        var identifierAttribute = undefined;
        this.forAllProps(function (propName, propType) {
            if (propType.flags & TypeFlags$$1.Identifier) {
                if (identifierAttribute)
                    fail("Cannot define property '" + propName + "' as object identifier, property '" + identifierAttribute + "' is already defined as identifier property");
                identifierAttribute = propName;
            }
        });
        return identifierAttribute;
    };
    ModelType$$1.prototype.cloneAndEnhance = function (opts) {
        return new ModelType$$1({
            name: opts.name || this.name,
            properties: Object.assign({}, this.properties, opts.properties),
            initializers: this.initializers.concat(opts.initializers || []),
            preProcessor: opts.preProcessor || this.preProcessor,
            postProcessor: opts.postProcessor || this.postProcessor
        });
    };
    ModelType$$1.prototype.actions = function (fn) {
        var _this = this;
        var actionInitializer = function (self) {
            _this.instantiateActions(self, fn(self));
            return self;
        };
        return this.cloneAndEnhance({ initializers: [actionInitializer] });
    };
    ModelType$$1.prototype.instantiateActions = function (self, actions) {
        // check if return is correct
        if (!isPlainObject(actions))
            fail("actions initializer should return a plain object containing actions");
        // bind actions to the object created
        Object.keys(actions).forEach(function (name) {
            // warn if preprocessor was given
            if (name === PRE_PROCESS_SNAPSHOT)
                fail("Cannot define action '" + PRE_PROCESS_SNAPSHOT + "', it should be defined using 'type.preProcessSnapshot(fn)' instead");
            // warn if postprocessor was given
            if (name === POST_PROCESS_SNAPSHOT)
                fail("Cannot define action '" + POST_PROCESS_SNAPSHOT + "', it should be defined using 'type.postProcessSnapshot(fn)' instead");
            var action2 = actions[name];
            // apply hook composition
            var baseAction = self[name];
            if (name in HookNames$$1 && baseAction) {
                var specializedAction_1 = action2;
                action2 = function () {
                    baseAction.apply(null, arguments);
                    specializedAction_1.apply(null, arguments);
                };
            }
            // the goal of this is to make sure actions using "this" can call themselves,
            // while still allowing the middlewares to register them
            var middlewares = action2.$mst_middleware; // make sure middlewares are not lost
            var boundAction = action2.bind(actions);
            boundAction.$mst_middleware = middlewares;
            var actionInvoker = createActionInvoker$$1(self, name, boundAction);
            actions[name] = actionInvoker;
            ( true ? addHiddenFinalProp : addHiddenWritableProp)(self, name, actionInvoker);
        });
    };
    ModelType$$1.prototype.named = function (name) {
        return this.cloneAndEnhance({ name: name });
    };
    ModelType$$1.prototype.props = function (properties) {
        return this.cloneAndEnhance({ properties: properties });
    };
    ModelType$$1.prototype.volatile = function (fn) {
        var _this = this;
        var stateInitializer = function (self) {
            _this.instantiateVolatileState(self, fn(self));
            return self;
        };
        return this.cloneAndEnhance({ initializers: [stateInitializer] });
    };
    ModelType$$1.prototype.instantiateVolatileState = function (self, state) {
        // check views return
        if (!isPlainObject(state))
            fail("volatile state initializer should return a plain object containing state");
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["x" /* set */])(self, state);
    };
    ModelType$$1.prototype.extend = function (fn) {
        var _this = this;
        var initializer = function (self) {
            var _a = fn(self), actions = _a.actions, views = _a.views, state = _a.state, rest = __rest(_a, ["actions", "views", "state"]);
            for (var key in rest)
                fail("The `extend` function should return an object with a subset of the fields 'actions', 'views' and 'state'. Found invalid key '" + key + "'");
            if (state)
                _this.instantiateVolatileState(self, state);
            if (views)
                _this.instantiateViews(self, views);
            if (actions)
                _this.instantiateActions(self, actions);
            return self;
        };
        return this.cloneAndEnhance({ initializers: [initializer] });
    };
    ModelType$$1.prototype.views = function (fn) {
        var _this = this;
        var viewInitializer = function (self) {
            _this.instantiateViews(self, fn(self));
            return self;
        };
        return this.cloneAndEnhance({ initializers: [viewInitializer] });
    };
    ModelType$$1.prototype.instantiateViews = function (self, views) {
        // check views return
        if (!isPlainObject(views))
            fail("views initializer should return a plain object containing views");
        Object.keys(views).forEach(function (key) {
            // is this a computed property?
            var descriptor = Object.getOwnPropertyDescriptor(views, key);
            var value = descriptor.value;
            if ("get" in descriptor) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["o" /* isComputedProp */])(self, key)) {
                    var computedValue = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* _getAdministration */])(self, key);
                    // TODO: mobx currently does not allow redefining computes yet, pending #1121
                    // FIXME: this binds to the internals of mobx!
                    computedValue.derivation = descriptor.get;
                    computedValue.scope = self;
                    if (descriptor.set)
                        computedValue.setter = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* action */])(computedValue.name + "-setter", descriptor.set);
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* computed */])(self, key, descriptor, true);
                }
            }
            else if (typeof value === "function") {
                ( true
                    ? addHiddenFinalProp
                    : addHiddenWritableProp)(self, key, value);
            }
            else {
                fail("A view member should either be a function or getter based property");
            }
        });
    };
    ModelType$$1.prototype.preProcessSnapshot = function (preProcessor) {
        var currentPreprocessor = this.preProcessor;
        if (!currentPreprocessor)
            return this.cloneAndEnhance({ preProcessor: preProcessor });
        else
            return this.cloneAndEnhance({
                preProcessor: function (snapshot) { return currentPreprocessor(preProcessor(snapshot)); }
            });
    };
    ModelType$$1.prototype.postProcessSnapshot = function (postProcessor) {
        var currentPostprocessor = this.postProcessor;
        if (!currentPostprocessor)
            return this.cloneAndEnhance({ postProcessor: postProcessor });
        else
            return this.cloneAndEnhance({
                postProcessor: function (snapshot) { return postProcessor(currentPostprocessor(snapshot)); }
            });
    };
    ModelType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        var initialValue = isStateTreeNode$$1(snapshot)
            ? snapshot
            : this.applySnapshotPreProcessor(snapshot);
        return createNode$$1(this, parent, subpath, environment, initialValue);
        // Optimization: record all prop- view- and action names after first construction, and generate an optimal base class
        // that pre-reserves all these fields for fast object-member lookups
    };
    ModelType$$1.prototype.initializeChildNodes = function (objNode, initialSnapshot) {
        if (initialSnapshot === void 0) { initialSnapshot = {}; }
        var type = objNode.type;
        var result = {};
        type.forAllProps(function (name, childType) {
            result[name] = childType.instantiate(objNode, name, objNode._environment, initialSnapshot[name]);
        });
        return result;
    };
    ModelType$$1.prototype.createNewInstance = function (node, childNodes, snapshot) {
        return __WEBPACK_IMPORTED_MODULE_0_mobx__["t" /* observable */].object(childNodes, EMPTY_OBJECT, mobxShallow);
    };
    ModelType$$1.prototype.finalizeNewInstance = function (node, instance) {
        addHiddenFinalProp(instance, "toString", objectTypeToString);
        this.forAllProps(function (name) {
            Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["g" /* _interceptReads */])(instance, name, node.unbox);
        });
        this.initializers.reduce(function (self, fn) { return fn(self); }, instance);
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["n" /* intercept */])(instance, this.willChange);
        Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["u" /* observe */])(instance, this.didChange);
    };
    ModelType$$1.prototype.willChange = function (change) {
        var node = getStateTreeNode$$1(change.object);
        node.assertWritable();
        var type = node.type.properties[change.name];
        // only properties are typed, state are stored as-is references
        if (type) {
            typecheckInternal$$1(type, change.newValue);
            change.newValue = type.reconcile(node.getChildNode(change.name), change.newValue);
        }
        return change;
    };
    ModelType$$1.prototype.didChange = function (change) {
        var node = getStateTreeNode$$1(change.object);
        var type = node.type.properties[change.name];
        if (!type) {
            // don't emit patches for volatile state
            return;
        }
        var oldValue = change.oldValue ? change.oldValue.snapshot : undefined;
        node.emitPatch({
            op: "replace",
            path: escapeJsonPath$$1(change.name),
            value: change.newValue.snapshot,
            oldValue: oldValue
        }, node);
    };
    ModelType$$1.prototype.getChildren = function (node) {
        var _this = this;
        var res = [];
        this.forAllProps(function (name, type) {
            res.push(_this.getChildNode(node, name));
        });
        return res;
    };
    ModelType$$1.prototype.getChildNode = function (node, key) {
        if (!(key in this.properties))
            return fail("Not a value property: " + key);
        var childNode = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* _getAdministration */])(node.storedValue, key).value; // TODO: blegh!
        if (!childNode)
            return fail("Node not available for property " + key);
        return childNode;
    };
    ModelType$$1.prototype.getValue = function (node) {
        return node.storedValue;
    };
    ModelType$$1.prototype.getSnapshot = function (node, applyPostProcess) {
        var _this = this;
        if (applyPostProcess === void 0) { applyPostProcess = true; }
        var res = {};
        this.forAllProps(function (name, type) {
            Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* getAtom */])(node.storedValue, name).reportObserved();
            res[name] = _this.getChildNode(node, name).snapshot;
        });
        if (applyPostProcess) {
            return this.applySnapshotPostProcessor(res);
        }
        return res;
    };
    ModelType$$1.prototype.processInitialSnapshot = function (childNodes, snapshot) {
        var processed = {};
        Object.keys(childNodes).forEach(function (key) {
            processed[key] = childNodes[key].getSnapshot();
        });
        return this.applySnapshotPostProcessor(this.applyOptionalValuesToSnapshot(processed));
    };
    ModelType$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
        if (!(patch.op === "replace" || patch.op === "add"))
            fail("object does not support operation " + patch.op);
        node.storedValue[subpath] = patch.value;
    };
    ModelType$$1.prototype.applySnapshot = function (node, snapshot) {
        var s = this.applySnapshotPreProcessor(snapshot);
        typecheckInternal$$1(this, s);
        this.forAllProps(function (name, type) {
            node.storedValue[name] = s[name];
        });
    };
    ModelType$$1.prototype.applySnapshotPreProcessor = function (snapshot) {
        var processor = this.preProcessor;
        return processor ? processor.call(null, snapshot) : snapshot;
    };
    ModelType$$1.prototype.applyOptionalValuesToSnapshot = function (snapshot) {
        if (snapshot) {
            snapshot = Object.assign({}, snapshot);
            this.forAllProps(function (name, type) {
                if (!(name in snapshot)) {
                    var optional2 = tryGetOptional(type);
                    if (optional2) {
                        snapshot[name] = optional2.getDefaultValueSnapshot();
                    }
                }
            });
        }
        return snapshot;
    };
    ModelType$$1.prototype.applySnapshotPostProcessor = function (snapshot) {
        var postProcessor = this.postProcessor;
        if (postProcessor)
            return postProcessor.call(null, snapshot);
        return snapshot;
    };
    ModelType$$1.prototype.getChildType = function (key) {
        return this.properties[key];
    };
    ModelType$$1.prototype.isValidSnapshot = function (value, context) {
        var _this = this;
        var snapshot = this.applySnapshotPreProcessor(value);
        if (!isPlainObject(snapshot)) {
            return typeCheckFailure$$1(context, snapshot, "Value is not a plain object");
        }
        return flattenTypeErrors$$1(this.propertyNames.map(function (key) {
            return _this.properties[key].validate(snapshot[key], getContextForPath$$1(context, key, _this.properties[key]));
        }));
    };
    ModelType$$1.prototype.forAllProps = function (fn) {
        var _this = this;
        this.propertyNames.forEach(function (key) { return fn(key, _this.properties[key]); });
    };
    ModelType$$1.prototype.describe = function () {
        var _this = this;
        // optimization: cache
        return ("{ " +
            this.propertyNames.map(function (key) { return key + ": " + _this.properties[key].describe(); }).join("; ") +
            " }");
    };
    ModelType$$1.prototype.getDefaultSnapshot = function () {
        return EMPTY_OBJECT;
    };
    ModelType$$1.prototype.removeChild = function (node, subpath) {
        node.storedValue[subpath] = undefined;
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* action */]
    ], ModelType$$1.prototype, "applySnapshot", null);
    return ModelType$$1;
}(ComplexType$$1));
/**
 * Creates a new model type by providing a name, properties, volatile state and actions.
 *
 * See the [model type](https://github.com/mobxjs/mobx-state-tree#creating-models) description or the [getting started](https://github.com/mobxjs/mobx-state-tree/blob/master/docs/getting-started.md#getting-started-1) tutorial.
 *
 * @export
 * @alias types.model
 */
function model$$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var name = typeof args[0] === "string" ? args.shift() : "AnonymousModel";
    var properties = args.shift() || {};
    return new ModelType$$1({ name: name, properties: properties });
}
/**
 * Composes a new model from one or more existing model types.
 * This method can be invoked in two forms:
 * Given 2 or more model types, the types are composed into a new Type.
 * Given first parameter as a string and 2 or more model types,
 * the types are composed into a new Type with the given name
 *
 * @export
 * @alias types.compose
 */
function compose$$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // TODO: just join the base type names if no name is provided
    var typeName = typeof args[0] === "string" ? args.shift() : "AnonymousModel";
    // check all parameters
    if (false) {
        args.forEach(function (type) {
            if (!isModelType$$1(type))
                fail("expected a mobx-state-tree model type, got " + type + " instead");
        });
    }
    return args
        .reduce(function (prev, cur) {
        return prev.cloneAndEnhance({
            name: prev.name + "_" + cur.name,
            properties: cur.properties,
            initializers: cur.initializers,
            preProcessor: function (snapshot) {
                return cur.applySnapshotPreProcessor(prev.applySnapshotPreProcessor(snapshot));
            },
            postProcessor: function (snapshot) {
                return cur.applySnapshotPostProcessor(prev.applySnapshotPostProcessor(snapshot));
            }
        });
    })
        .named(typeName);
}
/**
 * Returns if a given value represents a model type.
 *
 * @export
 * @template IT
 * @param {IT} type
 * @returns {type is IT}
 */
function isModelType$$1(type) {
    return isType$$1(type) && (type.flags & TypeFlags$$1.Object) > 0;
}
function tryGetOptional(type) {
    if (!type)
        return undefined;
    // we need to check for type.types since an optional union doesn't have direct subtypes
    if (type.flags & TypeFlags$$1.Union && type.types)
        return type.types.find(tryGetOptional);
    if (type.flags & TypeFlags$$1.Late && type.getSubType && type.getSubType(false))
        return tryGetOptional(type.subType);
    if (type.flags & TypeFlags$$1.Optional)
        return type;
    return undefined;
}

// TODO: implement CoreType using types.custom ?
/**
 * @internal
 * @private
 */
var CoreType$$1 = /** @class */ (function (_super) {
    __extends(CoreType$$1, _super);
    function CoreType$$1(name, flags, checker, initializer) {
        if (initializer === void 0) { initializer = identity; }
        var _this = _super.call(this, name) || this;
        _this.shouldAttachNode = false;
        _this.flags = flags;
        _this.checker = checker;
        _this.initializer = initializer;
        return _this;
    }
    CoreType$$1.prototype.describe = function () {
        return this.name;
    };
    CoreType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        return createNode$$1(this, parent, subpath, environment, snapshot);
    };
    CoreType$$1.prototype.createNewInstance = function (node, childNodes, snapshot) {
        return this.initializer(snapshot);
    };
    CoreType$$1.prototype.isValidSnapshot = function (value, context) {
        if (isPrimitive(value) && this.checker(value)) {
            return typeCheckSuccess$$1();
        }
        var typeName = this.name === "Date" ? "Date or a unix milliseconds timestamp" : this.name;
        return typeCheckFailure$$1(context, value, "Value is not a " + typeName);
    };
    return CoreType$$1;
}(Type$$1));
/**
 * Creates a type that can only contain a string value.
 * This type is used for string values by default
 *
 * @export
 * @alias types.string
 * @example
 * const Person = types.model({
 *   firstName: types.string,
 *   lastName: "Doe"
 * })
 */
// tslint:disable-next-line:variable-name
var string$$1 = new CoreType$$1("string", TypeFlags$$1.String, function (v) { return typeof v === "string"; });
/**
 * Creates a type that can only contain a numeric value.
 * This type is used for numeric values by default
 *
 * @export
 * @alias types.number
 * @example
 * const Vector = types.model({
 *   x: types.number,
 *   y: 1.5
 * })
 */
// tslint:disable-next-line:variable-name
var number$$1 = new CoreType$$1("number", TypeFlags$$1.Number, function (v) { return typeof v === "number"; });
/**
 * Creates a type that can only contain an integer value.
 * This type is used for integer values by default
 *
 * @export
 * @alias types.integer
 * @example
 * const Size = types.model({
 *   width: types.integer,
 *   height: 10
 * })
 */
// tslint:disable-next-line:variable-name
var integer$$1 = new CoreType$$1("integer", TypeFlags$$1.Integer, function (v) { return isInteger(v); });
/**
 * Creates a type that can only contain a boolean value.
 * This type is used for boolean values by default
 *
 * @export
 * @alias types.boolean
 * @example
 * const Thing = types.model({
 *   isCool: types.boolean,
 *   isAwesome: false
 * })
 */
// tslint:disable-next-line:variable-name
var boolean$$1 = new CoreType$$1("boolean", TypeFlags$$1.Boolean, function (v) { return typeof v === "boolean"; });
/**
 * The type of the value `null`
 *
 * @export
 * @alias types.null
 */
var nullType$$1 = new CoreType$$1("null", TypeFlags$$1.Null, function (v) { return v === null; });
/**
 * The type of the value `undefined`
 *
 * @export
 * @alias types.undefined
 */
var undefinedType$$1 = new CoreType$$1("undefined", TypeFlags$$1.Undefined, function (v) { return v === undefined; });
/**
 * Creates a type that can only contain a javascript Date value.
 *
 * @export
 * @alias types.Date
 * @example
 * const LogLine = types.model({
 *   timestamp: types.Date,
 * })
 *
 * LogLine.create({ timestamp: new Date() })
 */
// tslint:disable-next-line:variable-name
var DatePrimitive$$1 = new CoreType$$1("Date", TypeFlags$$1.Date, function (v) { return typeof v === "number" || v instanceof Date; }, function (v) { return (v instanceof Date ? v : new Date(v)); });
DatePrimitive$$1.getSnapshot = function (node) {
    return node.storedValue.getTime();
};
/**
 * @internal
 * @private
 */
function getPrimitiveFactoryFromValue$$1(value) {
    switch (typeof value) {
        case "string":
            return string$$1;
        case "number":
            return number$$1; // In the future, isInteger(value) ? integer : number would be interesting, but would be too breaking for now
        case "boolean":
            return boolean$$1;
        case "object":
            if (value instanceof Date)
                return DatePrimitive$$1;
    }
    return fail("Cannot determine primitive type from value " + value);
}
/**
 * Returns if a given value represents a primitive type.
 *
 * @export
 * @template IT
 * @param {IT} type
 * @returns {type is IT}
 */
function isPrimitiveType$$1(type) {
    return (isType$$1(type) &&
        (type.flags &
            (TypeFlags$$1.String |
                TypeFlags$$1.Number |
                TypeFlags$$1.Integer |
                TypeFlags$$1.Boolean |
                TypeFlags$$1.Date)) >
            0);
}

/**
 * @internal
 * @private
 */
var Literal$$1 = /** @class */ (function (_super) {
    __extends(Literal$$1, _super);
    function Literal$$1(value) {
        var _this = _super.call(this, JSON.stringify(value)) || this;
        _this.shouldAttachNode = false;
        _this.flags = TypeFlags$$1.Literal;
        _this.value = value;
        return _this;
    }
    Literal$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        return createNode$$1(this, parent, subpath, environment, snapshot);
    };
    Literal$$1.prototype.describe = function () {
        return JSON.stringify(this.value);
    };
    Literal$$1.prototype.isValidSnapshot = function (value, context) {
        if (isPrimitive(value) && value === this.value) {
            return typeCheckSuccess$$1();
        }
        return typeCheckFailure$$1(context, value, "Value is not a literal " + JSON.stringify(this.value));
    };
    return Literal$$1;
}(Type$$1));
/**
 * The literal type will return a type that will match only the exact given type.
 * The given value must be a primitive, in order to be serialized to a snapshot correctly.
 * You can use literal to match exact strings for example the exact male or female string.
 *
 * @example
 * const Person = types.model({
 *     name: types.string,
 *     gender: types.union(types.literal('male'), types.literal('female'))
 * })
 *
 * @export
 * @alias types.literal
 * @template S
 * @param {S} value The value to use in the strict equal check
 * @returns {ISimpleType<S>}
 */
function literal$$1(value) {
    // check that the given value is a primitive
    if (false) {
        if (!isPrimitive(value))
            fail("Literal types can be built only on top of primitives");
    }
    return new Literal$$1(value);
}
/**
 * Returns if a given value represents a literal type.
 *
 * @export
 * @template IT
 * @param {IT} type
 * @returns {type is IT}
 */
function isLiteralType$$1(type) {
    return isType$$1(type) && (type.flags & TypeFlags$$1.Literal) > 0;
}

/**
 * @internal
 * @private
 */
var Refinement$$1 = /** @class */ (function (_super) {
    __extends(Refinement$$1, _super);
    function Refinement$$1(name, type, predicate, message) {
        var _this = _super.call(this, name) || this;
        _this.type = type;
        _this.predicate = predicate;
        _this.message = message;
        return _this;
    }
    Object.defineProperty(Refinement$$1.prototype, "flags", {
        get: function () {
            return this.type.flags | TypeFlags$$1.Refinement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Refinement$$1.prototype, "shouldAttachNode", {
        get: function () {
            return this.type.shouldAttachNode;
        },
        enumerable: true,
        configurable: true
    });
    Refinement$$1.prototype.describe = function () {
        return this.name;
    };
    Refinement$$1.prototype.instantiate = function (parent, subpath, environment, value) {
        // create the child type
        var inst = this.type.instantiate(parent, subpath, environment, value);
        return inst;
    };
    Refinement$$1.prototype.isAssignableFrom = function (type) {
        return this.type.isAssignableFrom(type);
    };
    Refinement$$1.prototype.isValidSnapshot = function (value, context) {
        var subtypeErrors = this.type.validate(value, context);
        if (subtypeErrors.length > 0)
            return subtypeErrors;
        var snapshot = isStateTreeNode$$1(value) ? getStateTreeNode$$1(value).snapshot : value;
        if (!this.predicate(snapshot)) {
            return typeCheckFailure$$1(context, value, this.message(value));
        }
        return typeCheckSuccess$$1();
    };
    return Refinement$$1;
}(Type$$1));
/**
 * `types.refinement(baseType, (snapshot) => boolean)` creates a type that is more specific than the base type, e.g. `types.refinement(types.string, value => value.length > 5)` to create a type of strings that can only be longer then 5.
 *
 * @export
 * @alias types.refinement
 * @template T
 * @param {string} name
 * @param {IType<T, T>} type
 * @param {(snapshot: T) => boolean} predicate
 * @returns {IType<T, T>}
 */
function refinement$$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var name = typeof args[0] === "string" ? args.shift() : isType$$1(args[0]) ? args[0].name : null;
    var type = args[0];
    var predicate = args[1];
    var message = args[2]
        ? args[2]
        : function (v) { return "Value does not respect the refinement predicate"; };
    // ensures all parameters are correct
    if (false) {
        if (typeof name !== "string")
            fail("expected a string as first argument, got " + name + " instead");
        if (!isType$$1(type))
            fail("expected a mobx-state-tree type as first or second argument, got " +
                type +
                " instead");
        if (typeof predicate !== "function")
            fail("expected a function as third argument, got " + predicate + " instead");
        if (typeof message !== "function")
            fail("expected a function as fourth argument, got " + message + " instead");
    }
    return new Refinement$$1(name, type, predicate, message);
}
/**
 * Returns if a given value is a refinement type.
 *
 * @export
 * @template IT
 * @param {IT} type
 * @returns {type is IT}
 */
function isRefinementType$$1(type) {
    return (type.flags & TypeFlags$$1.Refinement) > 0;
}

/**
 * Can be used to create an string based enumeration.
 * (note: this methods is just sugar for a union of string literals)
 *
 * @example
 * const TrafficLight = types.model({
 *   color: types.enumeration("Color", ["Red", "Orange", "Green"])
 * })
 *
 * @export
 * @alias types.enumeration
 * @param {string} name descriptive name of the enumeration (optional)
 * @param {string[]} options possible values this enumeration can have
 * @returns {ISimpleType<string>}
 */
function enumeration$$1(name, options) {
    var realOptions = typeof name === "string" ? options : name;
    // check all options
    if (false) {
        realOptions.forEach(function (option) {
            if (typeof option !== "string")
                fail("expected all options to be string, got " + type + " instead");
        });
    }
    var type = union$$1.apply(void 0, realOptions.map(function (option) { return literal$$1("" + option); }));
    if (typeof name === "string")
        type.name = name;
    return type;
}

/**
 * @internal
 * @private
 */
var Union$$1 = /** @class */ (function (_super) {
    __extends(Union$$1, _super);
    function Union$$1(name, types, options) {
        var _this = _super.call(this, name) || this;
        _this.eager = true;
        options = __assign({ eager: true, dispatcher: undefined }, options);
        _this.dispatcher = options.dispatcher;
        if (!options.eager)
            _this.eager = false;
        _this.types = types;
        return _this;
    }
    Object.defineProperty(Union$$1.prototype, "flags", {
        get: function () {
            var result = TypeFlags$$1.Union;
            this.types.forEach(function (type) {
                result |= type.flags;
            });
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Union$$1.prototype, "shouldAttachNode", {
        get: function () {
            return this.types.some(function (type) { return type.shouldAttachNode; });
        },
        enumerable: true,
        configurable: true
    });
    Union$$1.prototype.isAssignableFrom = function (type) {
        return this.types.some(function (subType) { return subType.isAssignableFrom(type); });
    };
    Union$$1.prototype.describe = function () {
        return "(" + this.types.map(function (factory) { return factory.describe(); }).join(" | ") + ")";
    };
    Union$$1.prototype.instantiate = function (parent, subpath, environment, value) {
        var type = this.determineType(value, undefined);
        if (!type)
            return fail("No matching type for union " + this.describe()); // can happen in prod builds
        return type.instantiate(parent, subpath, environment, value);
    };
    Union$$1.prototype.reconcile = function (current, newValue) {
        var type = this.determineType(newValue, current.type);
        if (!type)
            return fail("No matching type for union " + this.describe()); // can happen in prod builds
        return type.reconcile(current, newValue);
    };
    Union$$1.prototype.determineType = function (value, reconcileCurrentType) {
        // try the dispatcher, if defined
        if (this.dispatcher) {
            return this.dispatcher(value);
        }
        // find the most accomodating type
        // if we are using reconciliation try the current node type first (fix for #1045)
        if (reconcileCurrentType) {
            if (reconcileCurrentType.is(value)) {
                return reconcileCurrentType;
            }
            return this.types.filter(function (t) { return t !== reconcileCurrentType; }).find(function (type) { return type.is(value); });
        }
        else {
            return this.types.find(function (type) { return type.is(value); });
        }
    };
    Union$$1.prototype.isValidSnapshot = function (value, context) {
        if (this.dispatcher) {
            return this.dispatcher(value).validate(value, context);
        }
        var allErrors = [];
        var applicableTypes = 0;
        for (var i = 0; i < this.types.length; i++) {
            var type = this.types[i];
            var errors = type.validate(value, context);
            if (errors.length === 0) {
                if (this.eager)
                    return typeCheckSuccess$$1();
                else
                    applicableTypes++;
            }
            else {
                allErrors.push(errors);
            }
        }
        if (applicableTypes === 1)
            return typeCheckSuccess$$1();
        return typeCheckFailure$$1(context, value, "No type is applicable for the union").concat(flattenTypeErrors$$1(allErrors));
    };
    return Union$$1;
}(Type$$1));
/**
 * types.union(dispatcher?, types...) create a union of multiple types. If the correct type cannot be inferred unambiguously from a snapshot, provide a dispatcher function of the form (snapshot) => Type.
 *
 * @export
 * @alias types.union
 * @param {(ITypeDispatcher | IAnyType)} optionsOrType
 * @param {...IAnyType[]} otherTypes
 * @returns {IAnyType}
 */
function union$$1(optionsOrType) {
    var otherTypes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        otherTypes[_i - 1] = arguments[_i];
    }
    var options = isType$$1(optionsOrType) ? undefined : optionsOrType;
    var types = isType$$1(optionsOrType) ? [optionsOrType].concat(otherTypes) : otherTypes;
    var name = "(" + types.map(function (type) { return type.name; }).join(" | ") + ")";
    // check all options
    if (false) {
        if (!isType$$1(optionsOrType) && !isPlainObject(optionsOrType))
            fail("First argument to types.union should either be a type, or an objects object of the form: { eager?: boolean, dispatcher?: Function }");
        types.forEach(function (type) {
            if (!isType$$1(type))
                fail("expected all possible types to be a mobx-state-tree type, got " +
                    type +
                    " instead");
        });
    }
    return new Union$$1(name, types, options);
}
/**
 * Returns if a given value represents a union type.
 *
 * @export
 * @template IT
 * @param {IT} type
 * @returns {type is IT}
 */
function isUnionType$$1(type) {
    return (type.flags & TypeFlags$$1.Union) > 0;
}

/**
 * @internal
 * @private
 */
var OptionalValue$$1 = /** @class */ (function (_super) {
    __extends(OptionalValue$$1, _super);
    function OptionalValue$$1(type, defaultValue) {
        var _this = _super.call(this, type.name) || this;
        _this.type = type;
        _this.defaultValue = defaultValue;
        return _this;
    }
    Object.defineProperty(OptionalValue$$1.prototype, "flags", {
        get: function () {
            return this.type.flags | TypeFlags$$1.Optional;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OptionalValue$$1.prototype, "shouldAttachNode", {
        get: function () {
            return this.type.shouldAttachNode;
        },
        enumerable: true,
        configurable: true
    });
    OptionalValue$$1.prototype.describe = function () {
        return this.type.describe() + "?";
    };
    OptionalValue$$1.prototype.instantiate = function (parent, subpath, environment, value) {
        if (typeof value === "undefined") {
            var defaultInstanceOrSnapshot = this.getDefaultInstanceOrSnapshot();
            return this.type.instantiate(parent, subpath, environment, defaultInstanceOrSnapshot);
        }
        return this.type.instantiate(parent, subpath, environment, value);
    };
    OptionalValue$$1.prototype.reconcile = function (current, newValue) {
        return this.type.reconcile(current, this.type.is(newValue) && newValue !== undefined
            ? newValue
            : this.getDefaultInstanceOrSnapshot());
    };
    OptionalValue$$1.prototype.getDefaultInstanceOrSnapshot = function () {
        var defaultInstanceOrSnapshot = typeof this.defaultValue === "function"
            ? this.defaultValue()
            : this.defaultValue;
        // while static values are already snapshots and checked on types.optional
        // generator functions must always be rechecked just in case
        if (typeof this.defaultValue === "function") {
            typecheckInternal$$1(this, defaultInstanceOrSnapshot);
        }
        return defaultInstanceOrSnapshot;
    };
    OptionalValue$$1.prototype.getDefaultValueSnapshot = function () {
        var instanceOrSnapshot = this.getDefaultInstanceOrSnapshot();
        return isStateTreeNode$$1(instanceOrSnapshot)
            ? getStateTreeNode$$1(instanceOrSnapshot).snapshot
            : instanceOrSnapshot;
    };
    OptionalValue$$1.prototype.isValidSnapshot = function (value, context) {
        // defaulted values can be skipped
        if (value === undefined) {
            return typeCheckSuccess$$1();
        }
        // bounce validation to the sub-type
        return this.type.validate(value, context);
    };
    OptionalValue$$1.prototype.isAssignableFrom = function (type) {
        return this.type.isAssignableFrom(type);
    };
    return OptionalValue$$1;
}(Type$$1));
/**
 * `types.optional` can be used to create a property with a default value.
 * If the given value is not provided in the snapshot, it will default to the provided `defaultValue`.
 * If `defaultValue` is a function, the function will be invoked for every new instance.
 * Applying a snapshot in which the optional value is _not_ present, causes the value to be reset
 *
 * @example
 * const Todo = types.model({
 *   title: types.optional(types.string, "Test"),
 *   done: types.optional(types.boolean, false),
 *   created: types.optional(types.Date, () => new Date())
 * })
 *
 * // it is now okay to omit 'created' and 'done'. created will get a freshly generated timestamp
 * const todo = Todo.create({ title: "Get coffee "})
 *
 * @export
 * @alias types.optional
 */
function optional$$1(type, defaultValueOrFunction) {
    // make sure we never pass direct instances
    if (typeof defaultValueOrFunction !== "function" && isStateTreeNode$$1(defaultValueOrFunction)) {
        fail("default value cannot be an instance, pass a snapshot or a function that creates an instance/snapshot instead");
    }
    if (false) {
        if (!isType$$1(type))
            fail("expected a mobx-state-tree type as first argument, got " + type + " instead");
        // we only check default values if they are passed directly
        // if they are generator functions they will be checked once they are generated
        // we don't check generator function results here to avoid generating a node just for type-checking purposes
        // which might generate side-effects
        if (typeof defaultValueOrFunction !== "function") {
            typecheckInternal$$1(type, defaultValueOrFunction);
        }
    }
    var ret = new OptionalValue$$1(type, defaultValueOrFunction);
    return ret;
}
/**
 * Returns if a value represents an optional type.
 *
 * @export
 * @template IT
 * @param {IT} type
 * @returns {type is IT}
 */
function isOptionalType$$1(type) {
    return isType$$1(type) && (type.flags & TypeFlags$$1.Optional) > 0;
}

var optionalUndefinedType = optional$$1(undefinedType$$1, undefined);
var optionalNullType = optional$$1(nullType$$1, null);
/**
 * Maybe will make a type nullable, and also optional.
 * The value `undefined` will be used to represent nullability.
 *
 * @export
 * @alias types.maybe
 * @template C
 * @template S
 * @template T
 * @param {IType<C, S, M>} type The type to make nullable
 * @returns {(IType<C | undefined, S | undefined, T | undefined>)}
 */
function maybe$$1(type) {
    if (false)
        fail("expected a mobx-state-tree type as first argument, got " + type + " instead");
    return union$$1(type, optionalUndefinedType);
}
/**
 * Maybe will make a type nullable, and also optional.
 * The value `null` will be used to represent no value.
 *
 * @export
 * @alias types.maybeNull
 * @template C
 * @template S
 * @template T
 * @param {IType<C, S, M>} type The type to make nullable
 * @returns {(IType<C | null | undefined, S | null, T | null>)}
 */
function maybeNull$$1(type) {
    if (false)
        fail("expected a mobx-state-tree type as first argument, got " + type + " instead");
    return union$$1(type, optionalNullType);
}

/**
 * @internal
 * @private
 */
var Late$$1 = /** @class */ (function (_super) {
    __extends(Late$$1, _super);
    function Late$$1(name, definition) {
        var _this = _super.call(this, name) || this;
        _this._subType = null;
        _this.definition = definition;
        return _this;
    }
    Object.defineProperty(Late$$1.prototype, "flags", {
        get: function () {
            return (this._subType ? this._subType.flags : 0) | TypeFlags$$1.Late;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Late$$1.prototype, "shouldAttachNode", {
        get: function () {
            return this.getSubType(true).shouldAttachNode;
        },
        enumerable: true,
        configurable: true
    });
    Late$$1.prototype.getSubType = function (mustSucceed) {
        if (this._subType === null) {
            var t = undefined;
            try {
                t = this.definition();
            }
            catch (e) {
                if (e instanceof ReferenceError)
                    // can happen in strict ES5 code when a definition is self refering
                    t = undefined;
                else
                    throw e;
            }
            if (mustSucceed && t === undefined)
                fail("Late type seems to be used too early, the definition (still) returns undefined");
            if (t) {
                if (false)
                    fail("Failed to determine subtype, make sure types.late returns a type definition.");
                this._subType = t;
                return t;
            }
        }
        return this._subType;
    };
    Late$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        return this.getSubType(true).instantiate(parent, subpath, environment, snapshot);
    };
    Late$$1.prototype.reconcile = function (current, newValue) {
        return this.getSubType(true).reconcile(current, newValue);
    };
    Late$$1.prototype.describe = function () {
        var t = this.getSubType(false);
        return t ? t.name : "<uknown late type>";
    };
    Late$$1.prototype.isValidSnapshot = function (value, context) {
        var t = this.getSubType(false);
        if (!t) {
            // See #916; the variable the definition closure is pointing to wasn't defined yet, so can't be evaluted yet here
            return typeCheckSuccess$$1();
        }
        return t.validate(value, context);
    };
    Late$$1.prototype.isAssignableFrom = function (type) {
        var t = this.getSubType(false);
        return t ? t.isAssignableFrom(type) : false;
    };
    return Late$$1;
}(Type$$1));
/**
 * Defines a type that gets implemented later. This is useful when you have to deal with circular dependencies.
 * Please notice that when defining circular dependencies TypeScript isn't smart enough to inference them.
 * You need to declare an interface to explicit the return type of the late parameter function.
 *
 * @example
 *  interface INode {
 *       childs: INode[]
 *  }
 *
 *   // TypeScript is'nt smart enough to infer self referencing types.
 *  const Node = types.model({
 *       childs: types.optional(types.array(types.late<any, INode>(() => Node)), [])
 *  })
 *
 * @export
 * @alias types.late
 * @template S
 * @template T
 * @param {string} [name] The name to use for the type that will be returned.
 * @param {ILateType<S, T>} type A function that returns the type that will be defined.
 * @returns {IType<S, T>}
 */
function late$$1(nameOrType, maybeType) {
    var name = typeof nameOrType === "string" ? nameOrType : "late(" + nameOrType.toString() + ")";
    var type = typeof nameOrType === "string" ? maybeType : nameOrType;
    // checks that the type is actually a late type
    if (false) {
        if (!(typeof type === "function" && type.length === 0))
            fail("Invalid late type, expected a function with zero arguments that returns a type, got: " +
                type);
    }
    return new Late$$1(name, type);
}
/**
 * Returns if a given value represents a late type.
 *
 * @export
 * @template IT
 * @param {IT} type
 * @returns {type is IT}
 */
function isLateType$$1(type) {
    return isType$$1(type) && (type.flags & TypeFlags$$1.Late) > 0;
}

/**
 * @internal
 * @private
 */
var Frozen$$1 = /** @class */ (function (_super) {
    __extends(Frozen$$1, _super);
    function Frozen$$1(subType) {
        var _this = _super.call(this, subType ? "frozen(" + subType.name + ")" : "frozen") || this;
        _this.subType = subType;
        _this.shouldAttachNode = false;
        _this.flags = TypeFlags$$1.Frozen;
        return _this;
    }
    Frozen$$1.prototype.describe = function () {
        return "<any immutable value>";
    };
    Frozen$$1.prototype.instantiate = function (parent, subpath, environment, value) {
        // create the node
        return createNode$$1(this, parent, subpath, environment, deepFreeze(value));
    };
    Frozen$$1.prototype.isValidSnapshot = function (value, context) {
        if (!isSerializable(value)) {
            return typeCheckFailure$$1(context, value, "Value is not serializable and cannot be frozen");
        }
        if (this.subType)
            return this.subType.validate(value, context);
        return typeCheckSuccess$$1();
    };
    return Frozen$$1;
}(Type$$1));
var untypedFrozenInstance = new Frozen$$1();
/**
 * Frozen can be used to store any value that is serializable in itself (that is valid JSON).
 * Frozen values need to be immutable or treated as if immutable. They need be serializable as well.
 * Values stored in frozen will snapshotted as-is by MST, and internal changes will not be tracked.
 *
 * This is useful to store complex, but immutable values like vectors etc. It can form a powerful bridge to parts of your application that should be immutable, or that assume data to be immutable.
 *
 * Note: if you want to store free-form state that is mutable, or not serializeable, consider using volatile state instead.
 *
 * Frozen properties can be defined in three different ways
 * 1. `types.frozen(SubType)` - provide a valid MST type and frozen will check if the provided data conforms the snapshot for that type
 * 2. `types.frozen({ someDefaultValue: true})` - provide a primitive value, object or array, and MST will infer the type from that object, and also make it the default value for the field
 * 3. `types.frozen<TypeScriptType>()` - provide a typescript type, to help in strongly typing the field (design time only)
 *
 * @example
 * const GameCharacter = types.model({
 *   name: string,
 *   location: types.frozen({ x: 0, y: 0})
 * })
 *
 * const hero = GameCharacter.create({
 *   name: "Mario",
 *   location: { x: 7, y: 4 }
 * })
 *
 * hero.location = { x: 10, y: 2 } // OK
 * hero.location.x = 7 // Not ok!
 *
 * @example
 * type Point = { x: number, y: number }
 *    const Mouse = types.model({
 *         loc: types.frozen<Point>()
 *    })
 *
 * @alias types.frozen
 * @param {Type|value} defaultValueOrType
 * @returns {Type}
 */
function frozen$$1(arg) {
    if (arguments.length === 0)
        return untypedFrozenInstance;
    else if (isType$$1(arg))
        return new Frozen$$1(arg);
    else
        return optional$$1(untypedFrozenInstance, arg);
}
/**
 * Returns if a given value represents a frozen type.
 *
 * @export
 * @template IT
 * @template T
 * @param {IT} type
 * @returns {type is IT}
 */
function isFrozenType$$1(type) {
    return isType$$1(type) && (type.flags & TypeFlags$$1.Frozen) > 0;
}

var StoredReference = /** @class */ (function () {
    function StoredReference(mode, value, targetType) {
        this.mode = mode;
        this.value = value;
        this.targetType = targetType;
        if (mode === "object") {
            if (!isStateTreeNode$$1(value))
                return fail("Can only store references to tree nodes, got: '" + value + "'");
            var targetNode = getStateTreeNode$$1(value);
            if (!targetNode.identifierAttribute)
                return fail("Can only store references with a defined identifier attribute.");
        }
    }
    Object.defineProperty(StoredReference.prototype, "resolvedValue", {
        get: function () {
            // reference was initialized with the identifier of the target
            var _a = this, node = _a.node, targetType = _a.targetType;
            var target = node.root.identifierCache.resolve(targetType, this.value);
            if (!target)
                return fail("Failed to resolve reference '" + this.value + "' to type '" + this.targetType.name + "' (from node: " + node.path + ")");
            return target.value;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* computed */]
    ], StoredReference.prototype, "resolvedValue", null);
    return StoredReference;
}());
/**
 * @internal
 * @private
 */
var BaseReferenceType$$1 = /** @class */ (function (_super) {
    __extends(BaseReferenceType$$1, _super);
    function BaseReferenceType$$1(targetType) {
        var _this = _super.call(this, "reference(" + targetType.name + ")") || this;
        _this.targetType = targetType;
        _this.shouldAttachNode = false;
        _this.flags = TypeFlags$$1.Reference;
        return _this;
    }
    BaseReferenceType$$1.prototype.describe = function () {
        return this.name;
    };
    BaseReferenceType$$1.prototype.isAssignableFrom = function (type) {
        return this.targetType.isAssignableFrom(type);
    };
    BaseReferenceType$$1.prototype.isValidSnapshot = function (value, context) {
        return typeof value === "string" || typeof value === "number"
            ? typeCheckSuccess$$1()
            : typeCheckFailure$$1(context, value, "Value is not a valid identifier, which is a string or a number");
    };
    return BaseReferenceType$$1;
}(Type$$1));
/**
 * @internal
 * @private
 */
var IdentifierReferenceType$$1 = /** @class */ (function (_super) {
    __extends(IdentifierReferenceType$$1, _super);
    function IdentifierReferenceType$$1(targetType) {
        return _super.call(this, targetType) || this;
    }
    IdentifierReferenceType$$1.prototype.getValue = function (node) {
        if (!node.isAlive)
            return undefined;
        var ref = node.storedValue;
        // id already resolved, return
        if (ref.mode === "object")
            return ref.value;
        return ref.resolvedValue;
    };
    IdentifierReferenceType$$1.prototype.getSnapshot = function (node) {
        var ref = node.storedValue;
        switch (ref.mode) {
            case "identifier":
                return ref.value;
            case "object":
                return ref.value[getStateTreeNode$$1(ref.value).identifierAttribute];
        }
    };
    IdentifierReferenceType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        var mode = isStateTreeNode$$1(snapshot) ? "object" : "identifier";
        var r;
        var node = createNode$$1(this, parent, subpath, environment, (r = new StoredReference(mode, snapshot, this.targetType)));
        r.node = node;
        return node;
    };
    IdentifierReferenceType$$1.prototype.reconcile = function (current, newValue) {
        if (current.type === this) {
            var targetMode = isStateTreeNode$$1(newValue) ? "object" : "identifier";
            var ref = current.storedValue;
            if (targetMode === ref.mode && ref.value === newValue)
                return current;
        }
        var newNode = this.instantiate(current.parent, current.subpath, current._environment, newValue);
        current.die();
        return newNode;
    };
    return IdentifierReferenceType$$1;
}(BaseReferenceType$$1));
/**
 * @internal
 * @private
 */
var CustomReferenceType$$1 = /** @class */ (function (_super) {
    __extends(CustomReferenceType$$1, _super);
    function CustomReferenceType$$1(targetType, options) {
        var _this = _super.call(this, targetType) || this;
        _this.options = options;
        return _this;
    }
    CustomReferenceType$$1.prototype.getValue = function (node) {
        if (!node.isAlive)
            return undefined;
        return this.options.get(node.storedValue, node.parent ? node.parent.storedValue : null);
    };
    CustomReferenceType$$1.prototype.getSnapshot = function (node) {
        return node.storedValue;
    };
    CustomReferenceType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        var identifier$$1 = isStateTreeNode$$1(snapshot)
            ? this.options.set(snapshot, parent ? parent.storedValue : null)
            : snapshot;
        return createNode$$1(this, parent, subpath, environment, identifier$$1);
    };
    CustomReferenceType$$1.prototype.reconcile = function (current, snapshot) {
        var newIdentifier = isStateTreeNode$$1(snapshot)
            ? this.options.set(snapshot, current ? current.storedValue : null)
            : snapshot;
        if (current.type === this) {
            if (current.storedValue === newIdentifier)
                return current;
        }
        var newNode = this.instantiate(current.parent, current.subpath, current._environment, newIdentifier);
        current.die();
        return newNode;
    };
    return CustomReferenceType$$1;
}(BaseReferenceType$$1));
/**
 * Creates a reference to another type, which should have defined an identifier.
 * See also the [reference and identifiers](https://github.com/mobxjs/mobx-state-tree#references-and-identifiers) section.
 *
 * @export
 * @alias types.reference
 */
function reference$$1(subType, options) {
    // check that a type is given
    if (false) {
        if (!isType$$1(subType))
            fail("expected a mobx-state-tree type as first argument, got " + subType + " instead");
        if (arguments.length === 2 && typeof arguments[1] === "string")
            fail("References with base path are no longer supported. Please remove the base path.");
    }
    // as any because getValue might actually return undefined if the node is not alive
    if (options)
        return new CustomReferenceType$$1(subType, options);
    else
        return new IdentifierReferenceType$$1(subType);
}
/**
 * Returns if a given value represents a reference type.
 *
 * @export
 * @template IT
 * @param {IT} type
 * @returns {type is IT}
 */
function isReferenceType$$1(type) {
    return (type.flags & TypeFlags$$1.Reference) > 0;
}

/**
 * @internal
 * @private
 */
var IdentifierType$$1 = /** @class */ (function (_super) {
    __extends(IdentifierType$$1, _super);
    function IdentifierType$$1() {
        var _this = _super.call(this, "identifier") || this;
        _this.shouldAttachNode = false;
        _this.flags = TypeFlags$$1.Identifier;
        return _this;
    }
    IdentifierType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        if (!parent || !(parent.type instanceof ModelType$$1))
            fail("Identifier types can only be instantiated as direct child of a model type");
        return createNode$$1(this, parent, subpath, environment, snapshot);
    };
    IdentifierType$$1.prototype.reconcile = function (current, newValue) {
        if (current.storedValue !== newValue)
            return fail("Tried to change identifier from '" + current.storedValue + "' to '" + newValue + "'. Changing identifiers is not allowed.");
        return current;
    };
    IdentifierType$$1.prototype.describe = function () {
        return "identifier";
    };
    IdentifierType$$1.prototype.isValidSnapshot = function (value, context) {
        if (typeof value !== "string") {
            return typeCheckFailure$$1(context, value, "Value is not a valid identifier, expected a string");
        }
        return typeCheckSuccess$$1();
    };
    return IdentifierType$$1;
}(Type$$1));
/**
 * @internal
 * @private
 */
var IdentifierNumberType$$1 = /** @class */ (function (_super) {
    __extends(IdentifierNumberType$$1, _super);
    function IdentifierNumberType$$1() {
        var _this = _super.call(this) || this;
        _this.name = "identifierNumber";
        return _this;
    }
    IdentifierNumberType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        return _super.prototype.instantiate.call(this, parent, subpath, environment, snapshot);
    };
    IdentifierNumberType$$1.prototype.isValidSnapshot = function (value, context) {
        if (typeof value === "number") {
            return typeCheckSuccess$$1();
        }
        return typeCheckFailure$$1(context, value, "Value is not a valid identifierNumber, expected a number");
    };
    IdentifierNumberType$$1.prototype.reconcile = function (current, newValue) {
        return _super.prototype.reconcile.call(this, current, newValue);
    };
    IdentifierNumberType$$1.prototype.getSnapshot = function (node) {
        return node.storedValue;
    };
    IdentifierNumberType$$1.prototype.describe = function () {
        return "identifierNumber";
    };
    return IdentifierNumberType$$1;
}(IdentifierType$$1));
/**
 * Identifiers are used to make references, lifecycle events and reconciling works.
 * Inside a state tree, for each type can exist only one instance for each given identifier.
 * For example there couldn't be 2 instances of user with id 1. If you need more, consider using references.
 * Identifier can be used only as type property of a model.
 * This type accepts as parameter the value type of the identifier field that can be either string or number.
 *
 * @example
 *  const Todo = types.model("Todo", {
 *      id: types.identifier,
 *      title: types.string
 *  })
 *
 * @export
 * @alias types.identifier
 * @template T
 * @returns {IType<T, T>}
 */
var identifier$$1 = new IdentifierType$$1();
/**
 * Similar to `types.identifier`, but `identifierNumber` will serialize from / to a number when applying snapshots
 *
 * @example
 *  const Todo = types.model("Todo", {
 *      id: types.identifierNumber,
 *      title: types.string
 *  })
 *
 * @export
 * @alias types.identifierNumber
 * @template T
 * @returns {IType<T, T>}
 */
var identifierNumber$$1 = new IdentifierNumberType$$1();
/**
 * Returns if a given value represents an identifier type.
 *
 * @export
 * @template IT
 * @param {IT} type
 * @returns {type is IT}
 */
function isIdentifierType$$1(type) {
    return isType$$1(type) && (type.flags & TypeFlags$$1.Identifier) > 0;
}

/**
 * Creates a custom type. Custom types can be used for arbitrary immutable values, that have a serializable representation. For example, to create your own Date representation, Decimal type etc.
 *
 * The signature of the options is:
 *
 * ```javascript
 * export interface CustomTypeOptions<S, T> {
 *     // Friendly name
 *     name: string
 *     // given a serialized value, how to turn it into the target type
 *     fromSnapshot(snapshot: S): T
 *     // return the serialization of the current value
 *     toSnapshot(value: T): S
 *     // if true, this is a converted value, if false, it's a snapshot
 *     isTargetType(value: T | S): boolean
 *     // a non empty string is assumed to be a validation error
 *     getValidationMessage?(snapshot: S): string
 * }
 * ```
 *
 * @example
 * const DecimalPrimitive = types.custom<string, Decimal>({
 *     name: "Decimal",
 *     fromSnapshot(value: string) {
 *         return new Decimal(value)
 *     },
 *     toSnapshot(value: Decimal) {
 *         return value.toString()
 *     },
 *     isTargetType(value: string | Decimal): boolean {
 *         return value instanceof Decimal
 *     },
 *     getValidationMessage(value: string): string {
 *         if (/^-?\d+\.\d+$/.test(value)) return "" // OK
 *         return `'${value}' doesn't look like a valid decimal number`
 *     }
 * })
 *
 * const Wallet = types.model({
 *     balance: DecimalPrimitive
 * })
 *
 * @export
 * @alias types.custom
 * @template S
 * @template T
 * @param {CustomTypeOptions<S, T>} options
 * @returns {(IType<S | T, S, T>)}
 */
function custom$$1(options) {
    return new CustomType$$1(options);
}
/**
 * @internal
 * @private
 */
var CustomType$$1 = /** @class */ (function (_super) {
    __extends(CustomType$$1, _super);
    function CustomType$$1(options) {
        var _this = _super.call(this, options.name) || this;
        _this.options = options;
        _this.flags = TypeFlags$$1.Reference;
        _this.shouldAttachNode = false;
        return _this;
    }
    CustomType$$1.prototype.describe = function () {
        return this.name;
    };
    CustomType$$1.prototype.isAssignableFrom = function (type) {
        return type === this;
    };
    CustomType$$1.prototype.isValidSnapshot = function (value, context) {
        if (this.options.isTargetType(value))
            return typeCheckSuccess$$1();
        var typeError = this.options.getValidationMessage(value);
        if (typeError) {
            return typeCheckFailure$$1(context, value, "Invalid value for type '" + this.name + "': " + typeError);
        }
        return typeCheckSuccess$$1();
    };
    CustomType$$1.prototype.getValue = function (node) {
        if (!node.isAlive)
            return undefined;
        return node.storedValue;
    };
    CustomType$$1.prototype.getSnapshot = function (node) {
        return this.options.toSnapshot(node.storedValue);
    };
    CustomType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
        var valueToStore = this.options.isTargetType(snapshot)
            ? snapshot
            : this.options.fromSnapshot(snapshot);
        return createNode$$1(this, parent, subpath, environment, valueToStore);
    };
    CustomType$$1.prototype.reconcile = function (current, value) {
        var isSnapshot = !this.options.isTargetType(value);
        var unchanged = current.type === this &&
            (isSnapshot ? value === current.snapshot : value === current.storedValue);
        if (unchanged)
            return current;
        var valueToStore = isSnapshot ? this.options.fromSnapshot(value) : value;
        var newNode = this.instantiate(current.parent, current.subpath, current._environment, valueToStore);
        current.die();
        return newNode;
    };
    return CustomType$$1;
}(Type$$1));

/*
 * All imports / exports should be proxied through this file.
 * Why? It gives us full control over the module load order, preventing circular dependency isses
 */

/* all code is initially loaded through internal, to avoid circular dep issues */
var types = {
    enumeration: enumeration$$1,
    model: model$$1,
    compose: compose$$1,
    custom: custom$$1,
    reference: reference$$1,
    union: union$$1,
    optional: optional$$1,
    literal: literal$$1,
    maybe: maybe$$1,
    maybeNull: maybeNull$$1,
    refinement: refinement$$1,
    string: string$$1,
    boolean: boolean$$1,
    number: number$$1,
    integer: integer$$1,
    Date: DatePrimitive$$1,
    map: map$$1,
    array: array$$1,
    frozen: frozen$$1,
    identifier: identifier$$1,
    identifierNumber: identifierNumber$$1,
    late: late$$1,
    undefined: undefinedType$$1,
    null: nullType$$1
};



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(539).setImmediate))

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(199);
var enumBugKeys = __webpack_require__(135);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(209);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet__ = __webpack_require__(7);
var _templateObject=_taggedTemplateLiteral(['\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  word-break: break-word;\n  hyphens: auto;\n'],['\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  word-break: break-word;\n  hyphens: auto;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Anchor=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1_grommet__["c" /* Anchor */])(_templateObject);/* harmony default export */ __webpack_exports__["a"] = (Anchor);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionComponent", function() { return AccordionComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Words__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_Picture__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_MediaClip__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_Thumbnail__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_video_react_dist_video_react_css__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_video_react_dist_video_react_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_video_react_dist_video_react_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_api_layoutEngine__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  max-width: 600px;\n  max-height: 600px;\n  margin: 32px auto;\n'],['\n  max-width: 600px;\n  max-height: 600px;\n  margin: 32px auto;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 600px;\n  overflow: hidden;\n'],['\n  width: 100%;\n  max-width: 600px;\n  overflow: hidden;\n']),_templateObject3=_taggedTemplateLiteral(['\n  height: 40px;\n'],['\n  height: 40px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  height: 300px;\n  max-width: 600px;\n  overflow-y: auto;\n  box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.5) inset;\n  padding: 0 6px;\n'],['\n  height: 300px;\n  max-width: 600px;\n  overflow-y: auto;\n  box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.5) inset;\n  padding: 0 6px;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var scrollIntoViewOptions={behavior:'instant',block:'start'};var Container=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject);var AccordionBookElement=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_10_grommet__["a" /* Accordion */])(_templateObject2);var AccordionPanel=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_10_grommet__["b" /* AccordionPanel */])(_templateObject3);var AccordionContent=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_10_grommet__["d" /* Box */])(_templateObject4);function compileLayoutData(path,content,panel,index){var data=void 0;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isString(content)){data={type:'words',path:[].concat(_toConsumableArray(path),['panels',panel,index])};}else{var type=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(content)[0];type=type.replace(new RegExp(content[type].prefix,'i'),'').replace(new RegExp(content[type].postfix,'i'),'');type=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(type);data={type:type,path:[].concat(_toConsumableArray(path),['panels',panel,index,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(content)[0]])};}return data;}var layoutEngine=new __WEBPACK_IMPORTED_MODULE_12_app_api_layoutEngine__["a" /* default */]({words:__WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Words__["default"],picture:__WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_Picture__["default"],thumbnail:__WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_Thumbnail__["default"],'sound clip':__WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_MediaClip__["default"],'video clip':__WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_MediaClip__["default"]});var Accordion=function(_React$Component){_inherits(Accordion,_React$Component);function Accordion(){_classCallCheck(this,Accordion);return _possibleConstructorReturn(this,(Accordion.__proto__||Object.getPrototypeOf(Accordion)).apply(this,arguments));}_createClass(Accordion,[{key:'render',value:function render(){var _props=this.props,AppState=_props.AppState,path=_props.path,content=_props.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(path,AppState.selectedSectionItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet__["d" /* Box */],{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionBookElement,{'aria-label':'accordion',animate:false},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(content.panels,function(panel,label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionPanel,{key:label,background:'light-4',label:label},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionContent,{flex:'grow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(panel,function(entry,index){return layoutEngine.render(compileLayoutData(path,entry,label,index));}))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet__["m" /* Text */],{weight:'bold',textAlign:'center'},__WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__["a" /* default */].extractTitleFromPath(path),' \u2014 ',content.caption))));}}]);return Accordion;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Accordion.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * source, caption, panels, prefix, postfix,
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,prefix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,postfix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,panels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({picture:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),'video clip':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,poster:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),'sound clip':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,poster:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})})]).isRequired).isRequired).isRequired})};Accordion.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Accordion));Component.displayName='Accordion';var AccordionComponent=Accordion;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselComponent", function() { return CarouselComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  max-width: 600px;\n  max-height: 600px;\n  margin: 32px auto;\n'],['\n  max-width: 600px;\n  max-height: 600px;\n  margin: 32px auto;\n']),_templateObject2=_taggedTemplateLiteral(['\n  max-width: 100%;\n  height: auto;\n'],['\n  max-width: 100%;\n  height: auto;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var scrollIntoViewOptions={behavior:'instant',block:'start'};var Container=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject);var Image=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].img(_templateObject2);var Carousel=function(_React$Component){_inherits(Carousel,_React$Component);function Carousel(){_classCallCheck(this,Carousel);return _possibleConstructorReturn(this,(Carousel.__proto__||Object.getPrototypeOf(Carousel)).apply(this,arguments));}_createClass(Carousel,[{key:'render',value:function render(){var _props=this.props,AppState=_props.AppState,path=_props.path,content=_props.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(path,AppState.selectedSectionItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["e" /* Carousel */],{'aria-label':'carousel',play:5000},content.panels.map(function(panel,index){var source=panel.source.startsWith('http')?panel.source:__webpack_require__(40)("./content"+panel.source);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:source,alt:panel.caption}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["m" /* Text */],{weight:'bold',textAlign:'center'},panel.caption));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["m" /* Text */],{weight:'bold',textAlign:'center'},__WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__["a" /* default */].extractTitleFromPath(path),' \u2014 ',content.caption))));}}]);return Carousel;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Carousel.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * source,caption, and prefix
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,prefix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,panels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired})};Carousel.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Carousel));Component.displayName='Carousel';var CarouselComponent=Carousel;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FigureComponent", function() { return FigureComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  max-width: 600px;\n  max-height: 800px;\n  margin: 32px auto;\n'],['\n  max-width: 600px;\n  max-height: 800px;\n  margin: 32px auto;\n']),_templateObject2=_taggedTemplateLiteral(['\n  max-width: 100%;\n  height: auto;\n'],['\n  max-width: 100%;\n  height: auto;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var scrollIntoViewOptions={behavior:'instant',block:'start'};var Container=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject);var Image=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].img(_templateObject2);var Figure=function(_React$Component){_inherits(Figure,_React$Component);function Figure(){_classCallCheck(this,Figure);return _possibleConstructorReturn(this,(Figure.__proto__||Object.getPrototypeOf(Figure)).apply(this,arguments));}_createClass(Figure,[{key:'render',value:function render(){var _props=this.props,AppState=_props.AppState,path=_props.path,content=_props.content;var source=content.source.startsWith('http')?content.source:__webpack_require__(40)("./content"+content.source);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(path,AppState.selectedSectionItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{'aria-label':'figure',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:source,alt:content.caption}),content.caption&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["m" /* Text */],{weight:'bold',textAlign:'center'},__WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__["a" /* default */].extractTitleFromPath(path),' \u2014 ',content.caption))));}}]);return Figure;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Figure.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * source, caption, prefix, postfix
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,prefix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})};Figure.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Figure));Component.displayName='Figure';var FigureComponent=Figure;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IFrameComponent", function() { return IFrameComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_frame_component__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_frame_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_frame_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_Button__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  max-width: 600px;\n  margin: 32px auto;\n"],["\n  max-width: 600px;\n  margin: 32px auto;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  border: none;\n  width: 100%;\n"],["\n  border: none;\n  width: 100%;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 100%;\n  overflow: hidden;\n"],["\n  width: 100%;\n  overflow: hidden;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 24px;\n  padding: 12px 12px 0;\n  cursor: pointer;\n  @media (max-width: 600px) {\n    svg {\n      width: 100%;\n    }\n  }\n"],["\n  width: 100%;\n  height: 24px;\n  padding: 12px 12px 0;\n  cursor: pointer;\n  @media (max-width: 600px) {\n    svg {\n      width: 100%;\n    }\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var scrollIntoViewOptions={behavior:"instant",block:"start"};var Container=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject);var Frame=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_8_react_frame_component___default.a)(_templateObject2);var Layer=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_6_grommet__["h" /* Layer */])(_templateObject3);var ButtonBar=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject4);var defaultIFrameContent="<div></div>";var IFrame=function(_React$Component){_inherits(IFrame,_React$Component);function IFrame(props){_classCallCheck(this,IFrame);var _this=_possibleConstructorReturn(this,(IFrame.__proto__||Object.getPrototypeOf(IFrame)).call(this,props));_this.onOpen=function(){_this.props.AppState.toggleFullscreen();_this.setState({isFullscreen:true});};_this.onClose=function(){_this.props.AppState.toggleFullscreen();_this.setState({isFullscreen:false});};_this.height=600;_this.state={height:8,isFullscreen:false};return _this;}_createClass(IFrame,[{key:"render",value:function render(){var _this2=this;var _props=this.props,AppState=_props.AppState,path=_props.path,content=_props.content;var isFullscreen=this.state.isFullscreen;var initialContent=!content.source.startsWith("http")?__webpack_require__(1344)("./content"+content.source):defaultIFrameContent;var source=content.source.startsWith("http")?content.source:undefined;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{"aria-label":"iframe"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(path,AppState.selectedSectionItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{align:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{elevation:"small",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_Button__["a" /* default */],{direction:"row",pad:"small",align:"center",justify:"between",width:"100%",height:"40px",background:"light-4",border:"bottom",responsive:true,onClick:this.onOpen},"Expand",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_icons__["k" /* Expand */],{color:"black"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Frame,{id:content.source,height:this.state.height,onLoad:function onLoad(){var intervalID=setInterval(function(){var iframe=document.getElementById(content.source);if(iframe){var documentElement=iframe.contentWindow.document.documentElement;if(documentElement.scrollHeight!==8){_this2.setState({height:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.min([documentElement.scrollHeight,_this2.height])});clearInterval(intervalID);}}},100);},src:source,initialContent:initialContent}),isFullscreen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Layer,{responsive:true,full:true,position:"center",onClickOutside:this.onClose,onEsc:this.onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonBar,{onClick:this.onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_icons__["i" /* Contract */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{pad:"xsmall",align:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Frame,{id:content.source,height:this.state.height,onLoad:function onLoad(){var intervalID=setInterval(function(){var iframe=document.getElementById(content.source);if(iframe){var documentElement=iframe.contentWindow.document.documentElement;if(documentElement.scrollHeight!==8){_this2.setState({height:documentElement.scrollHeight});clearInterval(intervalID);}}},100);},src:source,initialContent:initialContent})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["m" /* Text */],{weight:"bold",textAlign:"center"},__WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__["a" /* default */].extractTitleFromPath(path)," \u2014 ",content.caption))));}}]);return IFrame;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);IFrame.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * source, caption, postfix, and prefix
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,prefix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,postfix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})};IFrame.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(IFrame));Component.displayName="IFrame";var IFrameComponent=IFrame;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListComponent", function() { return ListComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_BookElements_ListItem__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_layoutEngine__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  margin-left: ',';\n'],['\n  margin-left: ',';\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var layoutEngine=new __WEBPACK_IMPORTED_MODULE_6_app_api_layoutEngine__["a" /* default */]({listItem:__WEBPACK_IMPORTED_MODULE_5_app_components_BookElements_ListItem__["default"]});function compileLayoutData(path,content,index){var data=void 0;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isString(content)||__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(content)){data={type:'listItem',path:[].concat(_toConsumableArray(path),[index])};}else{data={type:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(content)[0].split(' ')[0],path:[].concat(_toConsumableArray(path),[index,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(content)[0]])};}return data;}var Container=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject,function(props){return(props.level-1)*30+'px';});var List=function(_React$Component){_inherits(List,_React$Component);function List(){_classCallCheck(this,List);return _possibleConstructorReturn(this,(List.__proto__||Object.getPrototypeOf(List)).apply(this,arguments));}_createClass(List,[{key:'render',value:function render(){var _props=this.props,path=_props.path,content=_props.content;var hasLevel=content[0].level;var level=hasLevel?content.shift().level:1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{level:level,'aria-label':'list'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(content,function(content,index){return layoutEngine.render(compileLayoutData(path,content,index));}));}}]);return List;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);List.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])).isRequired,/**
   * book elements array
   */content:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]))]))};List.defaultProps={content:[]};var Component=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(List));Component.displayName='List';var ListComponent=List;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MediaComponent", function() { return MediaComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_Paragraph__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_video_react__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_video_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_video_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_style_media_player_css__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_style_media_player_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_app_style_media_player_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  max-width: 600px;\n  max-height: 600px;\n  margin: 32px auto;\n'],['\n  max-width: 600px;\n  max-height: 600px;\n  margin: 32px auto;\n']),_templateObject2=_taggedTemplateLiteral(['\n  font-family: inherit !important;\n'],['\n  font-family: inherit !important;\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 600px;\n  overflow: hidden;\n'],['\n  width: 100%;\n  max-width: 600px;\n  overflow: hidden;\n']),_templateObject4=_taggedTemplateLiteral(['\n  height: 40px;\n'],['\n  height: 40px;\n']),_templateObject5=_taggedTemplateLiteral(['\n  height: 150px;\n  overflow-y: auto;\n  box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.5) inset;\n  padding: 0 6px;\n'],['\n  height: 150px;\n  overflow-y: auto;\n  box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.5) inset;\n  padding: 0 6px;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var scrollIntoViewOptions={behavior:'instant',block:'start'};var Container=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject);var Player=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_8_video_react__["Player"])(_templateObject2);var Accordion=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_6_grommet__["a" /* Accordion */])(_templateObject3);var AccordionPanel=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_6_grommet__["b" /* AccordionPanel */])(_templateObject4);var AccordionContent=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */])(_templateObject5);var Media=function(_React$Component){_inherits(Media,_React$Component);function Media(){_classCallCheck(this,Media);return _possibleConstructorReturn(this,(Media.__proto__||Object.getPrototypeOf(Media)).apply(this,arguments));}_createClass(Media,[{key:'render',value:function render(){var _props=this.props,AppState=_props.AppState,path=_props.path,content=_props.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{'aria-label':content.caption},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(path,AppState.selectedSectionItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Player,{'aria-label':'media player',position:'center',alt:content.caption,poster:__webpack_require__(40)("./content"+content.poster)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__webpack_require__(40)("./content"+content.source)})),content.transcript&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Accordion,{animate:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionPanel,{background:'light-4',label:'transcript'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_Paragraph__["a" /* default */],null,content.transcript)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["m" /* Text */],{weight:'bold',textAlign:'center'},__WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__["a" /* default */].extractTitleFromPath(path),' \u2014 ',content.caption))));}}]);return Media;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Media.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * source, caption, poster, prefix, transcript
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,poster:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,transcript:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,prefix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})};Media.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Media));Component.displayName='Media';var MediaComponent=Media;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalComponent", function() { return ModalComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Words__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_Picture__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_MediaClip__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_Thumbnail__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_Button__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_api_layoutEngine__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  max-width: 600px;\n  max-height: 600px;\n  margin: 32px auto;\n'],['\n  max-width: 600px;\n  max-height: 600px;\n  margin: 32px auto;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 768px;\n  overflow-y: auto;\n'],['\n  width: 100%;\n  max-width: 768px;\n  overflow-y: auto;\n']),_templateObject3=_taggedTemplateLiteral(['\n  max-width: 768px;\n  height: 24px;\n  padding: 12px 12px 0;\n  cursor: pointer;\n  @media (max-width: 600px) {\n    svg {\n      width: 100%;\n    }\n  }\n'],['\n  max-width: 768px;\n  height: 24px;\n  padding: 12px 12px 0;\n  cursor: pointer;\n  @media (max-width: 600px) {\n    svg {\n      width: 100%;\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var scrollIntoViewOptions={behavior:'instant',block:'start'};var Container=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject);var Layer=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_11_grommet__["h" /* Layer */])(_templateObject2);var ButtonBar=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject3);function compileLayoutData(path,content,index){var data=void 0;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isString(content)){data={type:'words',path:[].concat(_toConsumableArray(path),['panel',index])};}else{var type=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(content)[0];type=type.replace(new RegExp(content[type].prefix,'i'),'').replace(new RegExp(content[type].postfix,'i'),'');type=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(type);data={type:type,path:[].concat(_toConsumableArray(path),['panel',index,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(content)[0]])};}return data;}var layoutEngine=new __WEBPACK_IMPORTED_MODULE_13_app_api_layoutEngine__["a" /* default */]({words:__WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Words__["default"],picture:__WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_Picture__["default"],thumbnail:__WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_Thumbnail__["default"],'sound clip':__WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_MediaClip__["default"],'video clip':__WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_MediaClip__["default"]});var Modal=function(_React$Component){_inherits(Modal,_React$Component);function Modal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Modal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Modal.__proto__||Object.getPrototypeOf(Modal)).call.apply(_ref,[this].concat(args))),_this),_this.state={isFullscreen:false},_this.onOpen=function(){_this.props.AppState.toggleFullscreen();_this.setState({isFullscreen:true});},_this.onClose=function(){_this.props.AppState.toggleFullscreen();_this.setState({isFullscreen:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Modal,[{key:'render',value:function render(){var _props=this.props,AppState=_props.AppState,path=_props.path,content=_props.content;var isFullscreen=this.state.isFullscreen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(path,AppState.selectedSectionItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet__["d" /* Box */],{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_Button__["a" /* default */],{direction:'row',pad:'small',align:'center',justify:'between',width:'100%',height:'40px',background:'light-4',border:'bottom',responsive:true,onClick:this.onOpen},content.label,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_icons__["k" /* Expand */],{color:'black'})),isFullscreen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Layer,{'aria-label':'modal',responsive:true,position:'center',onClickOutside:this.onClose,onEsc:this.onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonBar,{onClick:this.onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_icons__["i" /* Contract */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet__["d" /* Box */],{pad:'xsmall',align:'center',flex:'grow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(content.panel,function(entry,index){return layoutEngine.render(compileLayoutData(path,entry,index));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet__["m" /* Text */],{weight:'bold',textAlign:'center'},__WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__["a" /* default */].extractTitleFromPath(path),' \u2014 ',content.caption))));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Modal.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * label, caption, panel, prefix, postfix,
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,prefix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,postfix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,panel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({picture:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),'video clip':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,poster:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),'sound clip':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,poster:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})})]).isRequired).isRequired})};Modal.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Modal));Component.displayName='Modal';var ModalComponent=Modal;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TableComponent", function() { return TableComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table_dist_SuperResponsiveTableStyle_css__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table_dist_SuperResponsiveTableStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table_dist_SuperResponsiveTableStyle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_super_responsive_table__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_super_responsive_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_super_responsive_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  border-collapse: collapse;\n  border-style: hidden;\n  td,\n  th {\n    border: 1px solid gray;\n    padding: 5px;\n  }\n'],['\n  border-collapse: collapse;\n  border-style: hidden;\n  td,\n  th {\n    border: 1px solid gray;\n    padding: 5px;\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var scrollIntoViewOptions={behavior:'instant',block:'start'};var ResponsiveTable=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_8_react_super_responsive_table__["Table"])(_templateObject);function TableRow(_ref){var data=_ref.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data,function(entry,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_super_responsive_table__["Td"],{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet__["d" /* Box */],{align:'center'},entry));}));}function TableHeader(_ref2){var data=_ref2.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_super_responsive_table__["Thead"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(data,function(__,header){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_super_responsive_table__["Th"],{key:header},header);})));}var Table=function(_React$Component){_inherits(Table,_React$Component);function Table(){_classCallCheck(this,Table);return _possibleConstructorReturn(this,(Table.__proto__||Object.getPrototypeOf(Table)).apply(this,arguments));}_createClass(Table,[{key:'render',value:function render(){var _props=this.props,AppState=_props.AppState,path=_props.path,content=_props.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,content.caption&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(path,AppState.selectedSectionItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet__["m" /* Text */],{'aria-label':content.caption,title:'caption',weight:'bold',alignSelf:'center',textAlign:'center'},__WEBPACK_IMPORTED_MODULE_6_app_api_bookElement__["a" /* default */].extractTitleFromPath(path),' \u2014 ',content.caption))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet__["d" /* Box */],{background:'accent-3',elevation:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveTable,{border:1,'aria-label':'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableHeader,{data:content.records[0]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_super_responsive_table__["Tbody"],null,__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(content.records,function(record,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableRow,{key:index,data:record});})))));}}]);return Table;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Table.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * records, caption, and prefix
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({records:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,prefix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})};Table.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Table));Component.displayName='Table';var TableComponent=Table;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TabsComponent", function() { return TabsComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Words__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_Picture__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_MediaClip__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_Thumbnail__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_video_react_dist_video_react_css__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_video_react_dist_video_react_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_video_react_dist_video_react_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_api_layoutEngine__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  max-width: 600px;\n  max-height: 600px;\n  margin: 32px auto;\n'],['\n  max-width: 600px;\n  max-height: 600px;\n  margin: 32px auto;\n']),_templateObject2=_taggedTemplateLiteral(['\n  height: 500px;\n  max-width: 600px;\n  overflow-y: auto;\n  padding: 0 6px;\n'],['\n  height: 500px;\n  max-width: 600px;\n  overflow-y: auto;\n  padding: 0 6px;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var scrollIntoViewOptions={behavior:'instant',block:'start'};var Container=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject);var TabContent=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_10_grommet__["d" /* Box */])(_templateObject2);var TabTitle=function TabTitle(_ref){var active=_ref.active,label=_ref.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet__["d" /* Box */],{pad:'xxsmall',background:active?'light-4':'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet__["m" /* Text */],null,label));};function compileLayoutData(path,content,panel,index){var data=void 0;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isString(content)){data={type:'words',path:[].concat(_toConsumableArray(path),['panels',panel,index])};}else{var type=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(content)[0];type=type.replace(new RegExp(content[type].prefix,'i'),'').replace(new RegExp(content[type].postfix,'i'),'');type=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(type);data={type:type,path:[].concat(_toConsumableArray(path),['panels',panel,index,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(content)[0]])};}return data;}var layoutEngine=new __WEBPACK_IMPORTED_MODULE_12_app_api_layoutEngine__["a" /* default */]({words:__WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Words__["default"],picture:__WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_Picture__["default"],thumbnail:__WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_Thumbnail__["default"],'sound clip':__WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_MediaClip__["default"],'video clip':__WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_MediaClip__["default"]});var Tabs=function(_React$Component){_inherits(Tabs,_React$Component);function Tabs(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,Tabs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=Tabs.__proto__||Object.getPrototypeOf(Tabs)).call.apply(_ref2,[this].concat(args))),_this),_this.state={index:0},_this.onActive=function(index){return _this.setState({index:index});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Tabs,[{key:'render',value:function render(){var _props=this.props,AppState=_props.AppState,path=_props.path,content=_props.content;var index=this.state.index;var tabIndex=-1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(path,AppState.selectedSectionItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet__["d" /* Box */],{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet__["l" /* Tabs */],{activeIndex:index,onActive:this.onActive,'aria-label':'tabbed content'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(content.panels,function(panel,label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet__["k" /* Tab */],{key:label,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabTitle,{label:label,active:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(++tabIndex,index)})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabContent,{elevation:'small',background:'light-3',flex:'grow',basis:'auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(panel,function(entry,index){return layoutEngine.render(compileLayoutData(path,entry,label,index));}))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet__["m" /* Text */],{weight:'bold',textAlign:'center'},__WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__["a" /* default */].extractTitleFromPath(path),' \u2014 ',content.caption))));}}]);return Tabs;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Tabs.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * source, caption, panels, prefix, postfix,
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,prefix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,postfix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,panels:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({picture:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),'video clip':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,poster:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),'sound clip':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({source:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,poster:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,caption:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})})]).isRequired).isRequired).isRequired})};Tabs.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Tabs));Component.displayName='Tabs';var TabsComponent=Tabs;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n'],['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["r" /* Revert */])(_templateObject);function RevertButton(_ref){var AppState=_ref.AppState,onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_Button__["a" /* default */],{direction:'row',pad:'small',justify:'center',align:'center',fill:'vertical',onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{size:'large',color:'accent-1'}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(RevertButton)));

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(42);
var document = __webpack_require__(21).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(49);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(79);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(49);
var TAG = __webpack_require__(16)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(297);
var enumBugKeys = __webpack_require__(160);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(110);
var defined = __webpack_require__(79);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(157)('keys');
var uid = __webpack_require__(109);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(76).f;
var has = __webpack_require__(77);
var TAG = __webpack_require__(16)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(78);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $mobx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return untracked; });
/* unused harmony export IDerivationState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return createAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return spy; });
/* unused harmony export comparer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isObservableObject; });
/* unused harmony export isBoxedObservable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isObservableArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isObservableMap; });
/* unused harmony export transaction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return computed; });
/* unused harmony export isObservable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return isObservableProp; });
/* unused harmony export isComputed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isComputedProp; });
/* unused harmony export extendObservable */
/* unused harmony export extendShallowObservable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return observe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return intercept; });
/* unused harmony export autorun */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return reaction; });
/* unused harmony export when */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return action; });
/* unused harmony export isAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return runInAction; });
/* unused harmony export keys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return values; });
/* unused harmony export entries */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return set; });
/* unused harmony export remove */
/* unused harmony export has */
/* unused harmony export get */
/* unused harmony export decorate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return configure; });
/* unused harmony export onBecomeObserved */
/* unused harmony export onBecomeUnobserved */
/* unused harmony export flow */
/* unused harmony export toJS */
/* unused harmony export trace */
/* unused harmony export getDependencyTree */
/* unused harmony export getObserverTree */
/* unused harmony export _resetGlobalState */
/* unused harmony export _getGlobalState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getDebugName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAdministration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return allowStateChanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return allowStateChangesInsideComputed; });
/* unused harmony export isArrayLike */
/* unused harmony export _isComputingDerivation */
/* unused harmony export onReactionError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return interceptReads; });
/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

















function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable) {
    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
    return (cache[prop] ||
        (cache[prop] = {
            configurable: true,
            enumerable: enumerable,
            get: function () {
                initializeInstance(this);
                return this[prop];
            },
            set: function (value) {
                initializeInstance(this);
                this[prop] = value;
            }
        }));
}
function initializeInstance(target) {
    if (target.__mobxDidRunLazyInitializers === true)
        return;
    var decorators = target.__mobxDecorators;
    if (decorators) {
        addHiddenProp(target, "__mobxDidRunLazyInitializers", true);
        for (var key in decorators) {
            var d = decorators[key];
            d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
        }
    }
}
function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
    return function decoratorFactory() {
        var decoratorArguments;
        var decorator = function decorate(target, prop, descriptor, applyImmediately
        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
        // as the instance to apply the decorator to equals the target
        ) {
            if (applyImmediately === true) {
                propertyCreator(target, prop, descriptor, target, decoratorArguments);
                return null;
            }
            if (false)
                fail$1("This function is a decorator, but it wasn't invoked like a decorator");
            if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
                var inheritedDecorators = target.__mobxDecorators;
                addHiddenProp(target, "__mobxDecorators", __assign({}, inheritedDecorators));
            }
            target.__mobxDecorators[prop] = {
                prop: prop,
                propertyCreator: propertyCreator,
                descriptor: descriptor,
                decoratorTarget: target,
                decoratorArguments: decoratorArguments
            };
            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
        };
        if (quacksLikeADecorator(arguments)) {
            // @decorator
            decoratorArguments = EMPTY_ARRAY;
            return decorator.apply(null, arguments);
        }
        else {
            // @decorator(args)
            decoratorArguments = Array.prototype.slice.call(arguments);
            return decorator;
        }
    };
}
function quacksLikeADecorator(args) {
    return (((args.length === 2 || args.length === 3) && typeof args[1] === "string") ||
        (args.length === 4 && args[3] === true));
}

function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    var change = __assign({}, event, { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (change)
        spyReport(__assign({}, change, { spyReportEnd: true }));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function () {
        globalState.spyListeners = globalState.spyListeners.filter(function (l) { return l !== listener; });
    });
}

function createAction(actionName, fn) {
    if (false) {
        invariant(typeof fn === "function", "`action` can only be invoked on functions");
        if (typeof actionName !== "string" || !actionName)
            fail$1("actions should have valid names, got: '" + actionName + "'");
    }
    var res = function () {
        return executeAction(actionName, fn, this, arguments);
    };
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    try {
        return fn.apply(scope, args);
    }
    finally {
        endAction(runInfo);
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy)
        spyReportEnd({ time: Date.now() - runInfo.startTime });
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
function allowStateChangesInsideComputed(func) {
    var prev = globalState.computationDepth;
    globalState.computationDepth = 0;
    var res;
    try {
        res = func();
    }
    finally {
        globalState.computationDepth = prev;
    }
    return res;
}

function dontReassignFields() {
    fail$1("production" !== "production" && "@action fields are not reassignable");
}
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor) {
            if (false) {
                return fail$1("@action cannot be used with getters");
            }
            // babel / typescript
            // @action method() { }
            if (descriptor.value) {
                // typescript
                return {
                    value: createAction(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
                };
            }
            // babel only: @action method = () => {}
            var initializer_1 = descriptor.initializer;
            return {
                enumerable: false,
                configurable: true,
                writable: true,
                initializer: function () {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction(name, initializer_1.call(this));
                }
            };
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function actionFieldDecorator(name) {
    // Simple property that writes on first invocation to the current instance
    return function (target, prop, descriptor) {
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: false,
            get: function () {
                return undefined;
            },
            set: function (value) {
                addHiddenProp(this, prop, action(name, value));
            }
        });
    };
}
function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
    if (applyToInstance === true) {
        defineBoundAction(target, propertyName, descriptor.value);
        return null;
    }
    if (descriptor) {
        // if (descriptor.value)
        // Typescript / Babel: @action.bound method() { }
        // also: babel @action.bound method = () => {}
        return {
            configurable: true,
            enumerable: false,
            get: function () {
                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                return this[propertyName];
            },
            set: dontReassignFields
        };
    }
    // field decorator Typescript @action.bound method = () => {}
    return {
        enumerable: false,
        configurable: true,
        set: function (v) {
            defineBoundAction(this, propertyName, v);
        },
        get: function () {
            return undefined;
        }
    };
}

var action = function action(arg1, arg2, arg3, arg4) {
    // action(fn() {})
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    // action("name", fn() {})
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    // @action("name") fn() {}
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    // @action fn() {}
    if (arg4 === true) {
        // apply to instance immediately
        arg1[arg2] = createAction(arg1.name || arg2, arg3.value);
    }
    else {
        return namedActionDecorator(arg2).apply(null, arguments);
    }
};
action.bound = boundActionDecorator;
function runInAction(arg1, arg2) {
    // TODO: deprecate?
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    if (false) {
        invariant(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
        if (typeof actionName !== "string" || !actionName)
            fail$1("actions should have valid names, got: '" + actionName + "'");
    }
    return executeAction(actionName, fn, this, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
}

var toString = Object.prototype.toString;
function deepEqual(a, b) {
    return eq(a, b);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    return deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `isEqual`.
function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys$$1 = Object.keys(a), key;
        length = keys$$1.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys$$1[length];
            if (!(has$$1(b, key) && eq(a[key], b[key], aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.peek();
    if (isES6Map(a) || isObservableMap(a))
        return iteratorToArray(a.entries());
    return a;
}
function has$$1(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function defaultComparer(a, b) {
    return areBothNaN(a, b) || identityComparer(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer
};

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun(view, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (false) {
        invariant(typeof view === "function", "Autorun expects a function as first argument");
        invariant(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
    }
    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) {
        // normal autorun
        reaction = new Reaction(name, function () {
            this.track(reactionRunner);
        }, opts.onError);
    }
    else {
        var scheduler_1 = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled_1 = false;
        reaction = new Reaction(name, function () {
            if (!isScheduled_1) {
                isScheduled_1 = true;
                scheduler_1(function () {
                    isScheduled_1 = false;
                    if (!reaction.isDisposed)
                        reaction.track(reactionRunner);
                });
            }
        }, opts.onError);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
var run = function (f) { return f(); };
function createSchedulerFromOptions(opts) {
    return opts.scheduler
        ? opts.scheduler
        : opts.delay ? function (f) { return setTimeout(f, opts.delay); } : run;
}
function reaction(expression, effect, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (typeof opts === "boolean") {
        opts = { fireImmediately: opts };
        deprecated("Using fireImmediately as argument is deprecated. Use '{ fireImmediately: true }' instead");
    }
    if (false) {
        invariant(typeof expression === "function", "First argument to reaction should be a function");
        invariant(typeof opts === "object", "Third argument of reactions should be an object");
    }
    var name = opts.name || "Reaction@" + getNextId();
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural
        ? comparer.structural
        : opts.equals || comparer.default;
    var r = new Reaction(name, function () {
        if (firstTime || runSync) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError);
    function reactionRunner() {
        isScheduled = false; // Q: move into reaction runner?
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effectAction(value, r);
        if (!firstTime && changed === true)
            effectAction(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function () {
        try {
            return baseFn.apply(this, arguments);
        }
        catch (e) {
            errorHandler.call(this, e);
        }
    };
}

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce a new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(options) {
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isBeingObserved = false;
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        this.firstGet = true;
        if (false)
            return fail$1("missing option for computed: get");
        this.derivation = options.get;
        this.name = options.name || "ComputedValue@" + getNextId();
        if (options.set)
            this.setter = createAction(this.name + "-setter", options.set);
        this.equals =
            options.equals ||
                (options.compareStructural || options.struct
                    ? comparer.structural
                    : comparer.default);
        this.scope = options.context;
        this.requiresReaction = !!options.requiresReaction;
        this.keepAlive = !!options.keepAlive;
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function () { };
    ComputedValue.prototype.onBecomeObserved = function () { };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        var _this = this;
        if (this.keepAlive && this.firstGet) {
            this.firstGet = false;
            autorun(function () { return _this.get(); });
        }
        if (this.isComputing)
            fail$1("Cycle detected in computation " + this.name + ": " + this.derivation);
        if (globalState.inBatch === 0 && this.observers.length === 0) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead();
                startBatch(); // See perf test 'computed memoization'
                this.value = this.computeValue(false);
                endBatch();
            }
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this
                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false, "production" !== "production" &&
                "[ComputedValue '" + this
                    .name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled()) {
            spyReport({
                object: this.scope,
                type: "compute",
                name: this.name
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = this.computeValue(true);
        var changed = wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue);
        if (changed) {
            this.value = newValue;
        }
        return changed;
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            if (globalState.disableErrorBoundaries === true) {
                res = this.derivation.call(this.scope);
            }
            else {
                try {
                    res = this.derivation.call(this.scope);
                }
                catch (e) {
                    res = new CaughtException(e);
                }
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.suspend = function () {
        clearObserving(this);
        this.value = undefined; // don't hold on to computed value!
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.warnAboutUntrackedRead = function () {
        if (true)
            return;
        if (this.requiresReaction === true) {
            fail$1("[mobx] Computed value " + this.name + " is read outside a reactive context");
        }
        if (this.isTracing !== TraceMode.NONE) {
            console.log("[mobx.trace] '" + this
                .name + "' is being read outside a reactive context. Doing a full recompute");
        }
        if (globalState.computedRequiresReaction) {
            console.warn("[mobx] Computed value " + this
                .name + " is being read outside a reactive context. Doing a full recompute");
        }
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ComputedValue;
}());
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

function hasInterceptors(interceptable) {
    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

var UNCHANGED = {};
declareAtom();
var ObservableValue = /** @class */ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.hasUnreportedChange = false;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) {
                spyReportStart({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.value !== newValue ? newValue : UNCHANGED;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(Atom));
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

var ObservableObjectAdministration = /** @class */ (function () {
    function ObservableObjectAdministration(target, name, defaultEnhancer) {
        this.target = target;
        this.name = name;
        this.defaultEnhancer = defaultEnhancer;
        this.values = {};
    }
    ObservableObjectAdministration.prototype.read = function (owner, key) {
        if ("production" === "production" && this.target !== owner) {
            this.illegalAccess(owner, key);
            if (!this.values[key])
                return undefined;
        }
        return this.values[key].get();
    };
    ObservableObjectAdministration.prototype.write = function (owner, key, newValue) {
        var instance = this.target;
        if ("production" === "production" && instance !== owner) {
            this.illegalAccess(owner, key);
        }
        var observable = this.values[key];
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "update",
                object: instance,
                name: key,
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue(newValue);
        // notify spy & observers
        if (newValue !== UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: instance,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign({}, change, { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableObjectAdministration.prototype.remove = function (key) {
        if (!this.values[key])
            return;
        var target = this.target;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: target,
                name: key,
                type: "remove"
            });
            if (!change)
                return;
        }
        try {
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var oldValue = this.values[key].get();
            if (this.keys)
                this.keys.remove(key);
            delete this.values[key];
            delete this.target[key];
            var change = notify || notifySpy
                ? {
                    type: "remove",
                    object: target,
                    oldValue: oldValue,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign({}, change, { name: this.name, key: key }));
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
        finally {
            endBatch();
        }
    };
    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
        /**
         * This happens if a property is accessed through the prototype chain, but the property was
         * declared directly as own property on the prototype.
         *
         * E.g.:
         * class A {
         * }
         * extendObservable(A.prototype, { x: 1 })
         *
         * classB extens A {
         * }
         * console.log(new B().x)
         *
         * It is unclear whether the property should be considered 'static' or inherited.
         * Either use `console.log(A.x)`
         * or: decorate(A, { x: observable })
         *
         * When using decorate, the property will always be redeclared as own property on the actual instance
         */
        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        "production" !== "production" &&
            invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableObjectAdministration.prototype.getKeys = function () {
        var _this = this;
        if (this.keys === undefined) {
            this.keys = new ObservableArray(Object.keys(this.values).filter(function (key) { return _this.values[key] instanceof ObservableValue; }), referenceEnhancer, "keys(" + this.name + ")", true);
        }
        return this.keys.slice();
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name, defaultEnhancer) {
    if (name === void 0) { name = ""; }
    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer; }
    var adm = target.$mobx;
    if (adm)
        return adm;
    "production" !== "production" &&
        invariant(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    adm = new ObservableObjectAdministration(target, name, defaultEnhancer);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservableProperty(target, propName, newValue, enhancer) {
    var adm = asObservableObject(target);
    assertPropertyConfigurable(target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(target, propName, generateObservablePropConfig(propName));
    if (adm.keys)
        adm.keys.push(propName);
    notifyPropertyAddition(adm, target, propName, newValue);
}
function defineComputedProperty(target, // which objects holds the observable and provides `this` context?
propName, options) {
    var adm = asObservableObject(target);
    options.name = adm.name + "." + propName;
    options.context = target;
    adm.values[propName] = new ComputedValue(options);
    Object.defineProperty(target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = Object.create(null);
var computedPropertyConfigs = Object.create(null);
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this.$mobx.read(this, propName);
            },
            set: function (v) {
                this.$mobx.write(this, propName, v);
            }
        }));
}
function getAdministrationForComputedPropOwner(owner) {
    var adm = owner.$mobx;
    if (!adm) {
        // because computed props are declared on proty,
        // the current instance might not have been initialized yet
        initializeInstance(owner);
        return owner.$mobx;
    }
    return adm;
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: true,
            enumerable: false,
            get: function () {
                return getAdministrationForComputedPropOwner(this).read(this, propName);
            },
            set: function (v) {
                getAdministrationForComputedPropOwner(this).write(this, propName, v);
            }
        }));
}
function notifyPropertyAddition(adm, object, key, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy
        ? {
            type: "add",
            object: object,
            name: key,
            newValue: newValue
        }
        : null;
    if (notifySpy)
        spyReportStart(__assign({}, change, { name: adm.name, key: key }));
    if (notify)
        notifyListeners(adm, change);
    if (notifySpy)
        spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}

function createDecoratorForEnhancer(enhancer) {
    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
        if (false) {
            invariant(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + propertyName + "\"), use @computed instead.");
        }
        var initialValue = descriptor
            ? descriptor.initializer ? descriptor.initializer.call(target) : descriptor.value
            : undefined;
        defineObservableProperty(target, propertyName, initialValue, enhancer);
    });
    var res = 
    // Extra process checks, as this happens during module initialization
    typeof process !== "undefined" && Object({"NODE_ENV":"production","PUBLIC_URL":"/catalog-ws/view/modernwar-vol2"}) && "production" !== "production"
        ? function observableDecorator() {
            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
            // and simply return the created prop decorator
            if (arguments.length < 2)
                return fail$1("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
            return decorator.apply(null, arguments);
        }
        : decorator;
    res.enhancer = enhancer;
    return res;
}

function _isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (false)
            return fail$1("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value.$mobx ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}
function isObservable(value) {
    if (arguments.length !== 1)
        fail$1("production" !== "production" &&
            "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    if (typeof propName !== "string")
        return fail$1("production" !== "production" && "expected a property name as second argument");
    return _isObservable(value, propName);
}

function _isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value.$mobx.values[property])
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}
function isComputed(value) {
    if (arguments.length > 1)
        return fail$1("production" !== "production" &&
            "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    if (typeof propName !== "string")
        return fail$1("production" !== "production" &&
            "isComputed expected a property name as second argument");
    return _isComputed(value, propName);
}

var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
    var get = descriptor.get, set = descriptor.set; // initialValue is the descriptor for get / set props
    // Optimization: faster on decorator target or instance? Assuming target
    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
    var options = decoratorArgs[0] || {};
    defineComputedProperty(instance, propertyName, __assign({ get: get, set: set }, options));
});
var computedStructDecorator = computedDecorator({ equals: comparer.structural });
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        // @computed
        return computedDecorator.apply(null, arguments);
    }
    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
        // @computed({ options })
        return computedDecorator.apply(null, arguments);
    }
    // computed(expr, options?)
    if (false) {
        invariant(typeof arg1 === "function", "First argument to `computed` should be an expression.");
        invariant(arguments.length < 3, "Computed takes one or two arguments if used as function");
    }
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.get = arg1;
    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
    opts.name = opts.name || arg1.name || ""; /* for generated name */
    return new ComputedValue(opts);
};
computed.struct = computedStructDecorator;

function extendShallowObservable(target, properties, decorators) {
    deprecated("'extendShallowObservable' is deprecated, use 'extendObservable(target, props, { deep: false })' instead");
    return extendObservable(target, properties, decorators, shallowCreateObservableOptions);
}
function extendObservable(target, properties, decorators, options) {
    if (false) {
        invariant(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
        invariant(typeof target === "object", "'extendObservable' expects an object as first argument");
        invariant(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
        invariant(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
        if (decorators)
            for (var key in decorators)
                if (!(key in properties))
                    fail$1("Trying to declare a decorator for unspecified property '" + key + "'");
    }
    options = asCreateObservableOptions(options);
    var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
    initializeInstance(target);
    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
    startBatch();
    try {
        for (var key in properties) {
            var descriptor = Object.getOwnPropertyDescriptor(properties, key);
            if (false) {
                if (Object.getOwnPropertyDescriptor(target, key))
                    fail$1("'extendObservable' can only be used to introduce new properties. Use 'set' or 'decorate' instead. The property '" + key + "' already exists on '" + target + "'");
                if (isComputed(descriptor.value))
                    fail$1("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
            }
            var decorator = decorators && key in decorators
                ? decorators[key]
                : descriptor.get ? computedDecorator : defaultDecorator;
            if (false)
                return fail$1("Not a valid decorator for '" + key + "', got: " + decorator);
            var resultDescriptor = decorator(target, key, descriptor, true);
            if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
            )
                Object.defineProperty(target, key, resultDescriptor);
        }
    }
    finally {
        endBatch();
    }
    return target;
}

// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined
};
var shallowCreateObservableOptions = {
    deep: false,
    name: undefined,
    defaultDecorator: undefined
};
Object.freeze(defaultCreateObservableOptions);
Object.freeze(shallowCreateObservableOptions);
function assertValidOption(key) {
    if (!/^(deep|name|defaultDecorator)$/.test(key))
        fail$1("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions(thing) {
    if (thing === null || thing === undefined)
        return defaultCreateObservableOptions;
    if (typeof thing === "string")
        return { name: thing, deep: true };
    if (false) {
        if (typeof thing !== "object")
            return fail$1("expected options object");
        Object.keys(thing).forEach(assertValidOption);
    }
    return thing;
}
function getEnhancerFromOptions(options) {
    return options.defaultDecorator
        ? options.defaultDecorator.enhancer
        : options.deep === false ? referenceEnhancer : deepEnhancer;
}
var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (typeof arguments[1] === "string") {
        return deepDecorator.apply(null, arguments);
    }
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = isPlainObject(v)
        ? observable.object(v, arg2, arg3)
        : Array.isArray(v) ? observable.array(v, arg2) : isES6Map(v) ? observable.map(v, arg2) : v;
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    fail$1("production" !== "production" &&
        "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
}
var observableFactories = {
    box: function (value, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name);
    },
    shallowBox: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        deprecated("observable.shallowBox", "observable.box(value, { deep: false })");
        return observable.box(value, { name: name, deep: false });
    },
    array: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        var o = asCreateObservableOptions(options);
        return new ObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
    },
    shallowArray: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        deprecated("observable.shallowArray", "observable.array(values, { deep: false })");
        return observable.array(initialValues, { name: name, deep: false });
    },
    map: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    shallowMap: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        deprecated("observable.shallowMap", "observable.map(values, { deep: false })");
        return observable.map(initialValues, { name: name, deep: false });
    },
    object: function (props, decorators, options) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("object");
        var o = asCreateObservableOptions(options);
        return extendObservable({}, props, decorators, o);
    },
    shallowObject: function (props, name) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("shallowObject");
        deprecated("observable.shallowObject", "observable.object(values, {}, { deep: false })");
        return observable.object(props, {}, { name: name, deep: false });
    },
    ref: refDecorator,
    shallow: shallowDecorator,
    deep: deepDecorator,
    struct: refStructDecorator
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
function incorrectlyUsedAsDecorator(methodName) {
    fail$1(
    // process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, { name: name });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name });
    if (isES6Map(v))
        return observable.map(v, { name: name });
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
        return v;
    if (Array.isArray(v))
        return observable.array(v, { name: name, deep: false });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name, deep: false });
    if (isES6Map(v))
        return observable.map(v, { name: name, deep: false });
    return fail$1("production" !== "production" &&
        "The shallow modifier / decorator can only used in combination with arrays, objects and maps");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue, name) {
    if (false)
        throw "observable.struct should not be used with observable values";
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

function iteratorSymbol() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}

function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}
function makeIterable(iterator) {
    iterator[iteratorSymbol()] = self;
    return iterator;
}
function self() {
    return this;
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

var ObservableMapMarker = {};
var ObservableMap = /** @class */ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
        if (typeof Map !== "function") {
            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
        }
        this._data = new Map();
        this._hasMap = new Map();
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return this._data.has(key);
    };
    ObservableMap.prototype.has = function (key) {
        if (this._hasMap.has(key))
            return this._hasMap.get(key).get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap.prototype.set = function (key, value) {
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data.get(key).value,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign({}, change, { name: this.name, key: key }));
            transaction(function () {
                _this._keys.remove(key);
                _this._updateHasMapEntry(key, false);
                var observable = _this._data.get(key);
                observable.setNewValue(undefined);
                _this._data.delete(key);
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap.get(key);
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
            this._hasMap.set(key, entry);
        }
        return entry;
    };
    ObservableMap.prototype._updateValue = function (key, newValue) {
        var observable = this._data.get(key);
        newValue = observable.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign({}, change, { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (key, newValue) {
        var _this = this;
        transaction(function () {
            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + key, false);
            _this._data.set(key, observable);
            newValue = observable.value; // value might have been changed
            _this._updateHasMapEntry(key, true);
            _this._keys.push(key);
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(__assign({}, change, { name: this.name, key: key }));
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        if (this.has(key))
            return this.dehanceValue(this._data.get(key).get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        return this._keys[iteratorSymbol()]();
    };
    ObservableMap.prototype.values = function () {
        var self = this;
        var nextIndex = 0;
        return makeIterable({
            next: function () {
                return nextIndex < self._keys.length
                    ? { value: self.get(self._keys[nextIndex++]), done: false }
                    : { value: undefined, done: true };
            }
        });
    };
    ObservableMap.prototype.entries = function () {
        var self = this;
        var nextIndex = 0;
        return makeIterable({
            next: function () {
                if (nextIndex < self._keys.length) {
                    var key = self._keys[nextIndex++];
                    return {
                        value: [key, self.get(key)],
                        done: false
                    };
                }
                return { done: true };
            }
        });
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this._keys.forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (isPlainObject(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                    return _this.set(key, value);
                });
            else if (isES6Map(other))
                other.forEach(function (value, key) { return _this.set(key, value); });
            else if (other !== null && other !== undefined)
                fail$1("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                _this._keys.slice().forEach(function (key) { return _this.delete(key); });
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        transaction(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys(values);
            var oldKeys = _this._keys;
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a plain object that represents this map.
     * Note that all the keys being stringified.
     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
     */
    ObservableMap.prototype.toPOJO = function () {
        var _this = this;
        var res = {};
        this._keys.forEach(function (key) { return (res["" + key] = _this.get(key)); });
        return res;
    };
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        var _this = this;
        var res = new Map();
        this._keys.forEach(function (key) { return res.set(key, _this.get(key)); });
        return res;
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toPOJO();
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            this._keys.map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        "production" !== "production" &&
            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
declareIterator(ObservableMap.prototype, function () {
    return this.entries();
});
addHiddenFinalProp(ObservableMap.prototype, typeof Symbol !== "undefined" ? Symbol.toStringTag : "@@toStringTag", "Map");
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined)
                fail$1("production" !== "production" &&
                    "It is not possible to get index atoms from arrays");
            return thing.$mobx.atom;
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return getAtom(anyThing._keys);
            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
            if (!observable)
                fail$1("production" !== "production" &&
                    "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        if (property && !thing.$mobx)
            thing[property]; // See #1072
        if (isObservableObject(thing)) {
            if (!property)
                return fail$1("production" !== "production" && "please specify a property");
            var observable = thing.$mobx.values[property];
            if (!observable)
                fail$1("production" !== "production" &&
                    "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail$1("production" !== "production" && "Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    if (!thing)
        fail$1("Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    initializeInstance(thing);
    if (thing.$mobx)
        return thing.$mobx;
    fail$1("production" !== "production" && "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook("onBecomeObserved", thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg2 === "string" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = typeof arg2 === "string" ? arg3 : arg2;
    var orig = atom[hook];
    if (typeof orig !== "function")
        return fail$1("production" !== "production" && "Not an atom that can be (un)observed");
    atom[hook] = function () {
        orig.call(this);
        cb.call(this);
    };
    return function () {
        atom[hook] = orig;
    };
}

/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var Atom;
var isAtom;
function declareAtom() {
    if (Atom)
        return;
    Atom = /** @class */ (function () {
        /**
         * Create a new atom. For debugging purposes it is recommended to give it a name.
         * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
         */
        function AtomImpl(name) {
            if (name === void 0) { name = "Atom@" + getNextId(); }
            this.name = name;
            this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
            this.isBeingObserved = false;
            this.observers = [];
            this.observersIndexes = {};
            this.diffValue = 0;
            this.lastAccessedBy = 0;
            this.lowestObserverState = IDerivationState.NOT_TRACKING;
        }
        AtomImpl.prototype.onBecomeUnobserved = function () {
            // noop
        };
        AtomImpl.prototype.onBecomeObserved = function () {
            /* noop */
        };
        /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     * Returns true if there is currently a reactive context.
     */
        AtomImpl.prototype.reportObserved = function () {
            return reportObserved(this);
        };
        /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
        AtomImpl.prototype.reportChanged = function () {
            startBatch();
            propagateChanged(this);
            endBatch();
        };
        AtomImpl.prototype.toString = function () {
            return this.name;
        };
        return AtomImpl;
    }());
    isAtom = createInstanceofPredicate("Atom", Atom);
}
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
    var atom = new Atom(name);
    onBecomeObserved(atom, onBecomeObservedHandler);
    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function () {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = /** @class */ (function () {
    function StubArray() {
    }
    return StubArray;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) {
    
    [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function (key) {
        Object.defineProperty(StubArray.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.atom = new Atom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined && this.values.length > 0)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems =
            newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
        var _a;
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        if (notifySpy)
            spyReportStart(__assign({}, change, { name: this.atom.name }));
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy)
            spyReportStart(__assign({}, change, { name: this.atom.name }));
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray = /** @class */ (function (_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
        if (owned === void 0) { owned = false; }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            var prev = allowStateChangesStart(true);
            _this.spliceWithArray(0, 0, initialValues);
            allowStateChangesEnd(prev);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
    };
    ObservableArray.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        if (arguments.length === 3)
            deprecated("The array.find fromIndex argument to find will not be supported anymore in the next major");
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        if (arguments.length === 3)
            deprecated("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    ObservableArray.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function (fromIndex, toIndex) {
        deprecated("observableArray.move is deprecated, use .slice() & .replace() instead");
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
        }
        else {
            // toIndex < fromIndex
            newItems = __spread(oldItems.slice(0, toIndex), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
                .values
                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    };
    return ObservableArray;
}(StubArray));
declareIterator(ObservableArray.prototype, function () {
    
    this.$mobx.atom.reportObserved();
    var self = this;
    var nextIndex = 0;
    return makeIterable({
        next: function () {
            return nextIndex < self.length
                ? { value: self[nextIndex++], done: false }
                : { done: true, value: undefined };
        }
    });
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
    addHiddenProp(ObservableArray.prototype, typeof Symbol !== "undefined" ? Symbol.toStringTag : "@@toStringTag", "Array");
}
// Internet Explorer on desktop doesn't support this.....
// So, let's don't do this to avoid different semantics
// See #1395
// addHiddenProp(
//     ObservableArray.prototype,
//     typeof Symbol !== "undefined" ? Symbol.isConcatSpreadable as any : "@@isConcatSpreadable",
//     {
//         enumerable: false,
//         configurable: true,
//         value: true
//     }
// )
/**
 * Wrap function from prototype
 */

[
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}

var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is an production build.";
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
function getGlobal() {
    return typeof window !== "undefined" ? window : global;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail$1(message) {
    invariant(false, message);
    throw "X"; // unreachable
}
function invariant(check, message) {
    if (!check)
        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg, thing) {
    if (true)
        return false;
    if (thing) {
        return deprecated("'" + msg + "', use '" + thing + "' instead.");
    }
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function makeNonEnumerable(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    if (false)
        fail$1("Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
function areBothNaN(a, b) {
    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
        return true;
    return false;
}
function getMapLikeKeys(map) {
    if (isPlainObject(map))
        return Object.keys(map);
    if (Array.isArray(map))
        return map.map(function (_a) {
            var _b = __read(_a, 1), key = _b[0];
            return key;
        });
    if (isES6Map(map) || isObservableMap(map))
        return iteratorToArray(map.keys());
    return fail$1("Cannot get keys from '" + map + "'");
}
// use Array.from in Mobx 5
function iteratorToArray(it) {
    var res = [];
    while (true) {
        var r = it.next();
        if (r.done)
            break;
        res.push(r.value);
    }
    return res;
}
function primitiveSymbol() {
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

/**
 * These values will persist if global state is reset
 */
var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "disableErrorBoundaries",
    "runId"
];
var MobXGlobals = /** @class */ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         *
         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
         * internal state storage of MobX, and can be the same across many different package versions
         */
        this.version = 5;
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.enforceActions = false;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
        /**
         * Warn if computed values are accessed outside a reactive context
         */
        this.computedRequiresReaction = false;
        /*
         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
         * the stack when an exception occurs while debugging.
         */
        this.disableErrorBoundaries = false;
    }
    return MobXGlobals;
}());
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = (function () {
    var global = getGlobal();
    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals)
        canMergeGlobalState = false;
    if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals().version)
        canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        setTimeout(function () {
            if (!isolateCalled) {
                fail$1("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
            }
        }, 1);
        return new MobXGlobals();
    }
    else if (global.__mobxGlobals) {
        global.__mobxInstanceCount += 1;
        return global.__mobxGlobals;
    }
    else {
        global.__mobxInstanceCount = 1;
        return (global.__mobxGlobals = new MobXGlobals());
    }
})();
function isolateGlobalState() {
    if (globalState.pendingReactions.length ||
        globalState.inBatch ||
        globalState.isRunningReactions)
        fail$1("isolateGlobalState should be called before MobX is running any reactions");
    isolateCalled = true;
    if (canMergeGlobalState) {
        if (--getGlobal().__mobxInstanceCount === 0)
            getGlobal().__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) {
        // because object assignment is relatively expensive, let's not store data about index 0.
        observable.observersIndexes[node.__mapid] = l;
    }
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                // map store all indexes but 0, see comment in `addObserver`
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBecomeUnobserved();
                }
                if (observable instanceof ComputedValue) {
                    // computed values are automatically teared down when the last observer leaves
                    // this process happens recursively, this computed might be the last observabe of another, etc..
                    observable.suspend();
                }
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
            if (!observable.isBeingObserved) {
                observable.isBeingObserved = true;
                observable.onBecomeObserved();
            }
        }
        return true;
    }
    else if (observable.observers.length === 0 && globalState.inBatch > 0) {
        queueForUnobservation(observable);
    }
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) {
                        obj.get();
                    }
                    else {
                        try {
                            obj.get();
                        }
                        catch (e) {
                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                            untrackedEnd(prevUntracked);
                            return true;
                        }
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            return false;
        }
    }
}
// function invariantShouldCompute(derivation: IDerivation) {
//     const newDepState = (derivation as any).dependenciesState
//     if (
//         process.env.NODE_ENV === "production" &&
//         (newDepState === IDerivationState.POSSIBLY_STALE ||
//             newDepState === IDerivationState.NOT_TRACKING)
//     )
//         fail("Illegal dependency state")
// }
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers$$1 = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers$$1)
        fail$1("production" !== "production" &&
            "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && (hasObservers$$1 || globalState.enforceActions === "strict"))
        fail$1("production" !== "production" &&
            (globalState.enforceActions
                ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: "
                : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") +
                atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    if (globalState.disableErrorBoundaries === true) {
        result = f.call(context);
    }
    else {
        try {
            result = f.call(context);
        }
        catch (e) {
            result = new CaughtException(e);
        }
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail$1("production" !== "production" &&
            "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

var Reaction = /** @class */ (function () {
    function Reaction(name, onInvalidate, errorHandler) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.errorHandler = errorHandler;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                try {
                    this.onInvalidate();
                    if (this._isTrackPending && isSpyEnabled()) {
                        // onInvalidate didn't trigger track right away..
                        spyReport({
                            name: this.name,
                            type: "scheduled-reaction"
                        });
                    }
                }
                catch (e) {
                    this.reportExceptionInDerivation(e);
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                name: this.name,
                type: "reaction"
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries)
            throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
        console.error(message, error);
        /** If debugging brought you here, please, read the above message :-). Tnx! */
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                name: this.name,
                message: message,
                error: "" + error
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
        return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        timeoutHandle = setTimeout(function () {
            if (!disposer.$mobx.isDisposed) {
                disposer();
                var error = new Error("WHEN_TIMEOUT");
                if (opts.onError)
                    opts.onError(error);
                else
                    throw error;
            }
        }, opts.timeout);
    }
    opts.name = opts.name || "When@" + getNextId();
    var effectAction = createAction(opts.name + "-effect", effect);
    var disposer = autorun(function (r) {
        if (predicate()) {
            r.dispose();
            if (timeoutHandle)
                clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    if (false)
        return fail$1("the options 'onError' and 'promise' cannot be combined");
    var cancel;
    var res = new Promise(function (resolve, reject) {
        var disposer = _when(predicate, resolve, __assign({}, opts, { onError: reject }));
        cancel = function () {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}

function keys(obj) {
    if (isObservableObject(obj)) {
        return obj.$mobx.getKeys();
    }
    if (isObservableMap(obj)) {
        return obj._keys.slice();
    }
    if (isObservableArray(obj)) {
        return obj.map(function (_, index) { return index; });
    }
    return fail$1("production" !== "production" &&
        "'keys()' can only be used on observable objects, arrays and maps");
}
function values(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return obj[key]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return obj.get(key); });
    }
    if (isObservableArray(obj)) {
        return obj.slice();
    }
    return fail$1("production" !== "production" &&
        "'values()' can only be used on observable objects, arrays and maps");
}
function entries(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return [key, obj[key]]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return [key, obj.get(key)]; });
    }
    if (isObservableArray(obj)) {
        return obj.map(function (key, index) { return [index, key]; });
    }
    return fail$1("production" !== "production" &&
        "'entries()' can only be used on observable objects, arrays and maps");
}
function set(obj, key, value) {
    if (arguments.length === 2) {
        startBatch();
        var values_1 = key;
        try {
            for (var key_1 in values_1)
                set(obj, key_1, values_1[key_1]);
        }
        finally {
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) {
        var adm = obj.$mobx;
        var existingObservable = adm.values[key];
        if (existingObservable) {
            adm.write(obj, key, value);
        }
        else {
            defineObservableProperty(obj, key, value, adm.defaultEnhancer);
        }
    }
    else if (isObservableMap(obj)) {
        obj.set(key, value);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        startBatch();
        if (key >= obj.length)
            obj.length = key + 1;
        obj[key] = value;
        endBatch();
    }
    else {
        return fail$1("production" !== "production" &&
            "'set()' can only be used on observable objects, arrays and maps");
    }
}
function remove(obj, key) {
    if (isObservableObject(obj)) {
        
        obj.$mobx.remove(key);
    }
    else if (isObservableMap(obj)) {
        obj.delete(key);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        obj.splice(key, 1);
    }
    else {
        return fail$1("production" !== "production" &&
            "'remove()' can only be used on observable objects, arrays and maps");
    }
}
function has$1(obj, key) {
    if (isObservableObject(obj)) {
        // return keys(obj).indexOf(key) >= 0
        var adm = getAdministration(obj);
        adm.getKeys(); // make sure we get notified of key changes, but for performance, use the values map to look up existence
        return !!adm.values[key];
    }
    else if (isObservableMap(obj)) {
        return obj.has(key);
    }
    else if (isObservableArray(obj)) {
        return key >= 0 && key < obj.length;
    }
    else {
        return fail$1("production" !== "production" &&
            "'has()' can only be used on observable objects, arrays and maps");
    }
}
function get(obj, key) {
    if (!has$1(obj, key))
        return undefined;
    if (isObservableObject(obj)) {
        return obj[key];
    }
    else if (isObservableMap(obj)) {
        return obj.get(key);
    }
    else if (isObservableArray(obj)) {
        return obj[key];
    }
    else {
        return fail$1("production" !== "production" &&
            "'get()' can only be used on observable objects, arrays and maps");
    }
}

function decorate(thing, decorators) {
    "production" !== "production" &&
        invariant(isPlainObject(decorators), "Decorators should be a key value map");
    var target = typeof thing === "function" ? thing.prototype : thing;
    var _loop_1 = function (prop) {
        var propertyDecorators = decorators[prop];
        if (!Array.isArray(propertyDecorators)) {
            propertyDecorators = [propertyDecorators];
        }
        "production" !== "production" &&
            invariant(propertyDecorators.every(function (decorator) { return typeof decorator === "function"; }), "Decorate: expected a decorator function or array of decorator functions for '" + prop + "'");
        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
        var newDescriptor = propertyDecorators.reduce(function (accDescriptor, decorator) { return decorator(target, prop, accDescriptor); }, descriptor);
        if (newDescriptor)
            Object.defineProperty(target, prop, newDescriptor);
    };
    for (var prop in decorators) {
        _loop_1(prop);
    }
    return thing;
}

function configure(options) {
    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, disableErrorBoundaries = options.disableErrorBoundaries, arrayBuffer = options.arrayBuffer, reactionScheduler = options.reactionScheduler;
    if (enforceActions !== undefined) {
        if (typeof enforceActions === "boolean" || enforceActions === "strict")
            deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
        var ea = void 0;
        switch (enforceActions) {
            case true:
            case "observed":
                ea = true;
                break;
            case false:
            case "never":
                ea = false;
                break;
            case "strict":
            case "always":
                ea = "strict";
                break;
            default:
                fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
        }
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === "strict" ? false : true;
    }
    if (computedRequiresReaction !== undefined) {
        globalState.computedRequiresReaction = !!computedRequiresReaction;
    }
    if (options.isolateGlobalState === true) {
        isolateGlobalState();
    }
    if (disableErrorBoundaries !== undefined) {
        if (disableErrorBoundaries === true)
            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
    }
    if (typeof arrayBuffer === "number") {
        reserveArrayBuffer(arrayBuffer);
    }
    if (reactionScheduler) {
        setReactionScheduler(reactionScheduler);
    }
}

var generatorId = 0;
function flow(generator) {
    if (arguments.length !== 1)
        fail$1("production" && "Flow expects one 1 argument and cannot be used as decorator");
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    return function () {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var res = new Promise(function (resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (ret && typeof ret.then === "function") {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done)
                    return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        res.cancel = action(name + " - runid: " + runId + " - cancel", function () {
            try {
                if (pendingPromise)
                    cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var res_1 = gen.return();
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(res_1.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new Error("FLOW_CANCELLED"));
            }
            catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return res;
    };
}
function cancelPromise(promise) {
    if (typeof promise.cancel === "function")
        promise.cancel();
}

var defaultOptions = {
    detectCycles: true,
    exportMapsAsObjects: true,
    recurseEverything: false
};
function cache(map, key, value, options) {
    if (options.detectCycles)
        map.set(key, value);
    return value;
}
function toJSHelper(source, options, __alreadySeen) {
    if (!options.recurseEverything && !isObservable(source))
        return source;
    if (typeof source !== "object")
        return source;
    // Directly return null if source is null
    if (source === null)
        return null;
    // Directly return the Date object itself if contained in the observable
    if (source instanceof Date)
        return source;
    if (isObservableValue(source))
        return toJSHelper(source.get(), options, __alreadySeen);
    // make sure we track the keys of the object
    if (isObservable(source))
        keys(source);
    var detectCycles = options.detectCycles === true;
    if (detectCycles && source !== null && __alreadySeen.has(source)) {
        return __alreadySeen.get(source);
    }
    if (isObservableArray(source) || Array.isArray(source)) {
        var res_1 = cache(__alreadySeen, source, [], options);
        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
        res_1.length = toAdd.length;
        for (var i = 0, l = toAdd.length; i < l; i++)
            res_1[i] = toAdd[i];
        return res_1;
    }
    if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_2 = cache(__alreadySeen, source, new Map(), options);
            source.forEach(function (value, key) {
                res_2.set(key, toJSHelper(value, options, __alreadySeen));
            });
            return res_2;
        }
        else {
            var res_3 = cache(__alreadySeen, source, {}, options);
            source.forEach(function (value, key) {
                res_3[key] = toJSHelper(value, options, __alreadySeen);
            });
            return res_3;
        }
    }
    // Fallback to the situation that source is an ObservableObject or a plain object
    var res = cache(__alreadySeen, source, {}, options);
    for (var key in source) {
        res[key] = toJSHelper(source[key], options, __alreadySeen);
    }
    return res;
}
function toJS(source, options) {
    // backward compatibility
    if (typeof options === "boolean")
        options = { detectCycles: options };
    if (!options)
        options = defaultOptions;
    options.detectCycles =
        options.detectCycles === undefined
            ? options.recurseEverything === true
            : options.detectCycles === true;
    var __alreadySeen;
    if (options.detectCycles)
        __alreadySeen = new Map();
    return toJSHelper(source, options, __alreadySeen);
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail$1("production" !== "production" &&
                "InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail$1("production" !== "production" &&
            "Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail$1("production" !== "production" && "An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

/**
 * (c) Michel Weststrate 2015 - 2016
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
try {
    // define process.env if needed
    // if this is not a production build in the first place
    // (in which case the expression below would be substituted with 'production')
    "production";
}
catch (e) {
    var g = typeof window !== "undefined" ? window : global;
    if (typeof process === "undefined")
        g.process = {};
    g.process.env = {};
}

// This line should come after all the imports as well, for the same reason
// as noted above. I will file a bug with rollupjs - @rossipedia
// Devtools support
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    // See: https://github.com/andykog/mobx-devtools/
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: spy,
        extras: {
            getDebugName: getDebugName
        }
    });
}
// TODO: remove in some future build
if (false) {
    var warnedAboutDefaultExport_1 = false;
    Object.defineProperty(module.exports, "default", {
        enumerable: false,
        get: function () {
            if (!warnedAboutDefaultExport_1) {
                warnedAboutDefaultExport_1 = true;
                console.warn("The MobX package does not have a default export. Use 'import { thing } from \"mobx\"' (recommended) or 'import * as mobx from \"mobx\"' instead.\"");
            }
            return undefined;
        }
    });
    [
        "extras",
        "Atom",
        "BaseAtom",
        "asFlat",
        "asMap",
        "asReference",
        "asStructure",
        "autorunAsync",
        "createTranformer",
        "expr",
        "isModifierDescriptor",
        "isStrictModeEnabled",
        "map",
        "useStrict",
        "whyRun"
    ].forEach(function (prop) {
        Object.defineProperty(module.exports, prop, {
            enumerable: false,
            get: function () {
                fail$1("'" + prop + "' is no longer part of the public MobX api. Please consult the changelog to find out where this functionality went");
            },
            set: function () { }
        });
    });
}
// forward compatibility with mobx, so that packages can easily support mobx 4 & 5
var $mobx = "$mobx";



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(121), __webpack_require__(32)))

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return normalizeColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return colorIsDark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRGBA; });
var normalizeColor = function normalizeColor(color, theme, required) {
  var colorSpec = theme.global.colors[color] || color; // If the color has a light or dark object, use that

  var result = colorSpec;

  if (colorSpec) {
    if (theme.dark && colorSpec.dark) {
      result = colorSpec.dark;
    } else if (!theme.dark && colorSpec.light) {
      result = colorSpec.light;
    }
  } // allow one level of indirection in color names


  if (result && theme.global.colors[result]) {
    result = normalizeColor(result, theme);
  }

  return required && result === color ? 'inherit' : result;
};

var parseHexToRGB = function parseHexToRGB(color) {
  return color.length === 4 ? color.match(/[A-Za-z0-9]{1}/g).map(function (v) {
    return parseInt(v, 16);
  }) : // https://stackoverflow.com/a/42429333
  color.match(/[A-Za-z0-9]{2}/g).map(function (v) {
    return parseInt(v, 16);
  });
};

var canExtractRGBArray = function canExtractRGBArray(color) {
  return /^#/.test(color) || /^rgb/.test(color);
};

var getRGBArray = function getRGBArray(color) {
  if (/^#/.test(color)) {
    return parseHexToRGB(color);
  }

  if (/^rgb/.test(color)) {
    return color.match(/rgba?\((\s?[0-9]*\s?),(\s?[0-9]*\s?),(\s?[0-9]*\s?).*?\)/).splice(1);
  }

  return color;
};

var colorIsDark = function colorIsDark(color) {
  var _getRGBArray = getRGBArray(color),
      red = _getRGBArray[0],
      green = _getRGBArray[1],
      blue = _getRGBArray[2]; // http://www.had2know.com/technology/
  //  color-contrast-calculator-web-design.html


  var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
  return brightness < 125;
};
var getRGBA = function getRGBA(color, opacity) {
  if (color && canExtractRGBArray(color)) {
    var _getRGBArray2 = getRGBArray(color),
        red = _getRGBArray2[0],
        green = _getRGBArray2[1],
        blue = _getRGBArray2[2];

    return "rgba(" + red + ", " + green + ", " + blue + ", " + (opacity || 1) + ")";
  }

  return undefined;
};

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__base__["a"]; });
/* unused harmony reexport generate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grommet__ = __webpack_require__(394);
/* unused harmony reexport grommet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dark__ = __webpack_require__(395);
/* unused harmony reexport dark */




/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack__ = __webpack_require__(413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Stack__["a"]; });


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CellWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TableCell__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Text__ = __webpack_require__(29);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }








var Cell = function Cell(_ref) {
  var _ref$column = _ref.column,
      align = _ref$column.align,
      property = _ref$column.property,
      primary = _ref$column.primary,
      render = _ref$column.render,
      context = _ref.context,
      datum = _ref.datum,
      scope = _ref.scope,
      theme = _ref.theme;
  var content;

  if (render) {
    content = render(datum);
  } else if (datum[property] !== undefined) {
    content = datum[property];
  }

  if (typeof content === 'string' || typeof content === 'number') {
    var textProps = primary ? theme.dataTable.primary : {};
    content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Text__["a" /* Text */], textProps, content);
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TableCell__["a" /* TableCell */], _extends({
    scope: scope
  }, theme.dataTable[context], {
    align: align
  }), content);
};

Cell.defaultProps = {};
Object.setPrototypeOf(Cell.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var CellWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(Cell);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropButton__ = __webpack_require__(454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DropButton__["a"]; });


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_string_includes__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_fn_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_object_assign__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_fn_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_number_is_nan__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_content_book_json__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_content_book_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_content_book_json__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var figureTypes=/figure|audio|video|carousel|accordion|interactive|modal/;var book=addNumbersToSections(__WEBPACK_IMPORTED_MODULE_4_content_book_json___default.a);function addNumbersToSections(book){__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(book,function(contents,part){if(part.includes('chapter')||part.includes('appendix')){var number=part.replace('chapter ','').replace('appendix ','');recursivelyNumberElements(contents,number);}});return book;}function recursivelyNumberElements(content,tag){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isString(content))return;var sectionNumeral=0;var figureNumeral=0;var tableNumeral=0;__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(content,function(part){if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(part)){var _$keys=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(part),_$keys2=_slicedToArray(_$keys,1),type=_$keys2[0];if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(type,'section')){sectionNumeral+=1;numberElement(part,tag,type,sectionNumeral);return;}if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(type,'table')){tableNumeral+=1;numberElement(part,tag,type,tableNumeral);return;}if(type.match(figureTypes)){var _type$match=type.match(figureTypes),_type$match2=_slicedToArray(_type$match,1),figure=_type$match2[0];figureNumeral+=1;numberElement(part,tag,figure,figureNumeral);return;}}});}function numberElement(part,tag,type,numeral){// console.log(part, tag, type, numeral)
var label=''+(part[type].prefix&&part[type].prefix+' '||'')+type+(part[type].postfix&&' '+part[type].postfix||'');// console.log(label)
var numberedFigure=label+' '+tag+'-'+numeral;delete Object.assign(part,_defineProperty({},numberedFigure,part[type]))[type];// console.log(part, tag, type, numeral)
recursivelyNumberElements(part[numberedFigure],tag+'-'+numeral);}/* harmony default export */ __webpack_exports__["a"] = (book);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParagraphComponent", function() { return ParagraphComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_HighlightedSentences__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var scrollIntoViewOptions={behavior:'instant',block:'start'};var Paragraph=function(_React$Component){_inherits(Paragraph,_React$Component);function Paragraph(){_classCallCheck(this,Paragraph);return _possibleConstructorReturn(this,(Paragraph.__proto__||Object.getPrototypeOf(Paragraph)).apply(this,arguments));}_createClass(Paragraph,[{key:'render',value:function render(){var _this2=this;var _props=this.props,AppState=_props.AppState,path=_props.path,content=_props.content;return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(content).split('\n').map(function(paragraph,index){var isNewSelection=!AppState.bookmarkingSelectionContent||!content.includes(AppState.bookmarkingSelectionContent);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_scroll_into_view_if_needed__["a" /* default */],{key:index,options:scrollIntoViewOptions,active:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(path,AppState.selectedSectionItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["d" /* Box */],{key:index,direction:'column',flex:'grow',onClick:function onClick(){AppState.isUserBookmarking&&AppState.setMenuBar('BOOKMARKING_MENU');var isBookmarking=AppState.isBookmarkingMenuBar||AppState.isUserAnnotating;if(isNewSelection&&isBookmarking){AppState.newBookmarkingSelection({path:path,content:path});}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_HighlightedSentences__["a" /* default */],Object.assign({},_this2.props,{path:path,content:paragraph}))));}).value();}}]);return Paragraph;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Paragraph.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * paragraph(s)
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Paragraph.defaultProps={content:" "};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Paragraph));Component.displayName='Paragraph';var ParagraphComponent=Paragraph;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_tooltip__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_style_tooltip_css__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_style_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_app_style_tooltip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_Anchor__ = __webpack_require__(96);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(['\n  font-style: italic;\n  font-size: inherit;\n'],['\n  font-style: italic;\n  font-size: inherit;\n']),_templateObject2=_taggedTemplateLiteral(['\n  hyphens: none;\n'],['\n  hyphens: none;\n']),_templateObject3=_taggedTemplateLiteral(['\n  border-bottom: 1px dashed #000;\n  :hover {\n    cursor: pointer;\n  }\n'],['\n  border-bottom: 1px dashed #000;\n  :hover {\n    cursor: pointer;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var contextPattern=/\$\{([^}]+)\}\{(tooltip|link|italic|supplement|header|heading|bold)(?:: )?([^}]*)\}/;var ItalicText=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4_grommet__["m" /* Text */])(_templateObject);var Heading=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4_grommet__["g" /* Heading */])(_templateObject2);var TooltipAnchor=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4_grommet__["m" /* Text */])(_templateObject3);var Markup={};Markup.parse=function(contents){var hasMarkup=contents.match(contextPattern);if(!hasMarkup)return contents;var _hasMarkup=_slicedToArray(hasMarkup,4),context=_hasMarkup[0],anchor=_hasMarkup[1],type=_hasMarkup[2],markup=_hasMarkup[3];var front=contents.substring(0,hasMarkup.index);var wrapper={tooltip:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_rc_tooltip__["a" /* default */],{placement:'top',trigger:['click'],overlay:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["m" /* Text */],{size:'small'},markup)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TooltipAnchor,{color:'black',weight:'bold'},anchor)),link:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_Anchor__["a" /* default */],{href:markup,rel:'noopener noreferrer',target:'_blank'},anchor),italic:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItalicText,null,anchor),bold:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["m" /* Text */],{weight:'bold'},anchor),supplement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItalicText,null,'[',anchor,']'),heading:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Heading,{textAlign:'center',size:markup||'large',margin:'none'},anchor),header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["m" /* Text */],{weight:'bold',size:markup||'large'},anchor)};var back=Markup.parse(contents.substring(hasMarkup.index+context.length));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,front,wrapper[type],back);};Markup.remove=function(contents){var hasMarkup=contents.match(contextPattern);if(!hasMarkup)return contents;var _hasMarkup2=_slicedToArray(hasMarkup,2),context=_hasMarkup2[0],anchor=_hasMarkup2[1];var front=contents.substring(0,hasMarkup.index);var back=Markup.remove(contents.substring(hasMarkup.index+context.length));return front+anchor+back;};/* harmony default export */ __webpack_exports__["a"] = (Markup);

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(54);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(134)('keys');
var uid = __webpack_require__(93);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(39);
var global = __webpack_require__(38);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(92) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 135 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 136 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(588);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(600);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(68);
var dPs = __webpack_require__(593);
var enumBugKeys = __webpack_require__(135);
var IE_PROTO = __webpack_require__(133)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(198)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(594).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(44).f;
var has = __webpack_require__(46);
var TAG = __webpack_require__(56)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(56);


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(38);
var core = __webpack_require__(39);
var LIBRARY = __webpack_require__(92);
var wksExt = __webpack_require__(141);
var defineProperty = __webpack_require__(44).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleLoadStart = handleLoadStart;
exports.handleCanPlay = handleCanPlay;
exports.handleWaiting = handleWaiting;
exports.handleCanPlayThrough = handleCanPlayThrough;
exports.handlePlaying = handlePlaying;
exports.handlePlay = handlePlay;
exports.handlePause = handlePause;
exports.handleEnd = handleEnd;
exports.handleSeeking = handleSeeking;
exports.handleSeeked = handleSeeked;
exports.handleDurationChange = handleDurationChange;
exports.handleTimeUpdate = handleTimeUpdate;
exports.handleVolumeChange = handleVolumeChange;
exports.handleProgressChange = handleProgressChange;
exports.handleRateChange = handleRateChange;
exports.handleSuspend = handleSuspend;
exports.handleAbort = handleAbort;
exports.handleEmptied = handleEmptied;
exports.handleStalled = handleStalled;
exports.handleLoadedMetaData = handleLoadedMetaData;
exports.handleLoadedData = handleLoadedData;
exports.handleResize = handleResize;
exports.handleError = handleError;
exports.handleSeekingTime = handleSeekingTime;
exports.handleEndSeeking = handleEndSeeking;
var LOAD_START = exports.LOAD_START = 'video-react/LOAD_START';
var CAN_PLAY = exports.CAN_PLAY = 'video-react/CAN_PLAY';
var WAITING = exports.WAITING = 'video-react/WAITING';
var CAN_PLAY_THROUGH = exports.CAN_PLAY_THROUGH = 'video-react/CAN_PLAY_THROUGH';
var PLAYING = exports.PLAYING = 'video-react/PLAYING';
var PLAY = exports.PLAY = 'video-react/PLAY';
var PAUSE = exports.PAUSE = 'video-react/PAUSE';
var END = exports.END = 'video-react/END';
var SEEKING = exports.SEEKING = 'video-react/SEEKING';
var SEEKED = exports.SEEKED = 'video-react/SEEKED';
var SEEKING_TIME = exports.SEEKING_TIME = 'video-react/SEEKING_TIME';
var END_SEEKING = exports.END_SEEKING = 'video-react/END_SEEKING';
var DURATION_CHANGE = exports.DURATION_CHANGE = 'video-react/DURATION_CHANGE';
var TIME_UPDATE = exports.TIME_UPDATE = 'video-react/TIME_UPDATE';
var VOLUME_CHANGE = exports.VOLUME_CHANGE = 'video-react/VOLUME_CHANGE';
var PROGRESS_CHANGE = exports.PROGRESS_CHANGE = 'video-react/PROGRESS_CHANGE';
var RATE_CHANGE = exports.RATE_CHANGE = 'video-react/RATE_CHANGE';
var SUSPEND = exports.SUSPEND = 'video-react/SUSPEND';
var ABORT = exports.ABORT = 'video-react/ABORT';
var EMPTIED = exports.EMPTIED = 'video-react/EMPTIED';
var STALLED = exports.STALLED = 'video-react/STALLED';
var LOADED_META_DATA = exports.LOADED_META_DATA = 'video-react/LOADED_META_DATA';
var LOADED_DATA = exports.LOADED_DATA = 'video-react/LOADED_DATA';
var RESIZE = exports.RESIZE = 'video-react/RESIZE';
var ERROR = exports.ERROR = 'video-react/ERROR';

function handleLoadStart(videoProps) {
  return {
    type: LOAD_START,
    videoProps: videoProps
  };
}

function handleCanPlay(videoProps) {
  return {
    type: CAN_PLAY,
    videoProps: videoProps
  };
}

function handleWaiting(videoProps) {
  return {
    type: WAITING,
    videoProps: videoProps
  };
}

function handleCanPlayThrough(videoProps) {
  return {
    type: CAN_PLAY_THROUGH,
    videoProps: videoProps
  };
}

function handlePlaying(videoProps) {
  return {
    type: PLAYING,
    videoProps: videoProps
  };
}

function handlePlay(videoProps) {
  return {
    type: PLAY,
    videoProps: videoProps
  };
}

function handlePause(videoProps) {
  return {
    type: PAUSE,
    videoProps: videoProps
  };
}

function handleEnd(videoProps) {
  return {
    type: END,
    videoProps: videoProps
  };
}

function handleSeeking(videoProps) {
  return {
    type: SEEKING,
    videoProps: videoProps
  };
}

function handleSeeked(videoProps) {
  return {
    type: SEEKED,
    videoProps: videoProps
  };
}

function handleDurationChange(videoProps) {
  return {
    type: DURATION_CHANGE,
    videoProps: videoProps
  };
}

function handleTimeUpdate(videoProps) {
  return {
    type: TIME_UPDATE,
    videoProps: videoProps
  };
}

function handleVolumeChange(videoProps) {
  return {
    type: VOLUME_CHANGE,
    videoProps: videoProps
  };
}

function handleProgressChange(videoProps) {
  return {
    type: PROGRESS_CHANGE,
    videoProps: videoProps
  };
}

function handleRateChange(videoProps) {
  return {
    type: RATE_CHANGE,
    videoProps: videoProps
  };
}

function handleSuspend(videoProps) {
  return {
    type: SUSPEND,
    videoProps: videoProps
  };
}

function handleAbort(videoProps) {
  return {
    type: ABORT,
    videoProps: videoProps
  };
}

function handleEmptied(videoProps) {
  return {
    type: EMPTIED,
    videoProps: videoProps
  };
}

function handleStalled(videoProps) {
  return {
    type: STALLED,
    videoProps: videoProps
  };
}

function handleLoadedMetaData(videoProps) {
  return {
    type: LOADED_META_DATA,
    videoProps: videoProps
  };
}

function handleLoadedData(videoProps) {
  return {
    type: LOADED_DATA,
    videoProps: videoProps
  };
}

function handleResize(videoProps) {
  return {
    type: RESIZE,
    videoProps: videoProps
  };
}

function handleError(videoProps) {
  return {
    type: ERROR,
    videoProps: videoProps
  };
}

function handleSeekingTime(time) {
  return {
    type: SEEKING_TIME,
    time: time
  };
}

function handleEndSeeking(time) {
  return {
    type: END_SEEKING,
    time: time
  };
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findElPosition = findElPosition;
exports.getPointerPosition = getPointerPosition;
exports.blurNode = blurNode;
exports.hasClass = hasClass;

var _reactDom = __webpack_require__(17);

/**
 * Offset Left
 * getBoundingClientRect technique from
 * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @function findElPosition
 * @param {Element} el Element from which to get offset
 * @return {Object}
 */
function findElPosition(el) {
  var box = void 0;

  if (el.getBoundingClientRect && el.parentNode) {
    box = el.getBoundingClientRect();
  }

  if (!box) {
    return {
      left: 0,
      top: 0
    };
  }

  var docEl = document.documentElement;
  var body = document.body;

  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var scrollLeft = window.pageXOffset || body.scrollLeft;
  var left = box.left + scrollLeft - clientLeft;

  var clientTop = docEl.clientTop || body.clientTop || 0;
  var scrollTop = window.pageYOffset || body.scrollTop;
  var top = box.top + scrollTop - clientTop;

  // Android sometimes returns slightly off decimal values, so need to round
  return {
    left: Math.round(left),
    top: Math.round(top)
  };
}

/**
 * Get pointer position in element
 * Returns an object with x and y coordinates.
 * The base on the coordinates are the bottom left of the element.
 *
 * @function getPointerPosition
 * @param {Element} el Element on which to get the pointer position on
 * @param {Event} event Event object
 * @return {Object} This object will have x and y coordinates corresponding to the mouse position
 */
function getPointerPosition(el, event) {
  var position = {};
  var box = findElPosition(el);
  var boxW = el.offsetWidth;
  var boxH = el.offsetHeight;

  var boxY = box.top;
  var boxX = box.left;
  var pageY = event.pageY;
  var pageX = event.pageX;

  if (event.changedTouches) {
    pageX = event.changedTouches[0].pageX;
    pageY = event.changedTouches[0].pageY;
  }

  position.y = Math.max(0, Math.min(1, (boxY - pageY + boxH) / boxH));
  position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));

  return position;
}

// blur an element
function blurNode(reactNode) {
  var domNode = (0, _reactDom.findDOMNode)(reactNode);
  if (domNode && domNode.blur) {
    domNode.blur();
  }
}

// check if an element has a class name
function hasClass(elm, cls) {
  var classes = elm.className.split(' ');
  for (var i = 0; i < classes.length; i++) {
    if (classes[i].toLowerCase() === cls.toLowerCase()) {
      return true;
    }
  }
  return false;
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _dom = __webpack_require__(144);

var Dom = _interopRequireWildcard(_dom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  className: _propTypes2.default.string,
  onMouseDown: _propTypes2.default.func,
  onMouseMove: _propTypes2.default.func,
  stepForward: _propTypes2.default.func,
  stepBack: _propTypes2.default.func,
  sliderActive: _propTypes2.default.func,
  sliderInactive: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  getPercent: _propTypes2.default.func,
  vertical: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  label: _propTypes2.default.string,
  valuenow: _propTypes2.default.string,
  valuetext: _propTypes2.default.string
};

var Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider(props, context) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props, context));

    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.stepForward = _this.stepForward.bind(_this);
    _this.stepBack = _this.stepBack.bind(_this);
    _this.calculateDistance = _this.calculateDistance.bind(_this);
    _this.getProgress = _this.getProgress.bind(_this);
    _this.renderChildren = _this.renderChildren.bind(_this);

    _this.state = {
      active: false
    };
    return _this;
  }

  _createClass(Slider, [{
    key: 'getProgress',
    value: function getProgress() {
      var getPercent = this.props.getPercent;

      if (!getPercent) {
        return 0;
      }
      var progress = getPercent();

      // Protect against no duration and other division issues
      if (typeof progress !== 'number' || progress < 0 || progress === Infinity) {
        progress = 0;
      }
      return progress;
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      var onMouseDown = this.props.onMouseDown;
      // event.preventDefault();
      // event.stopPropagation();

      document.addEventListener('mousemove', this.handleMouseMove, true);
      document.addEventListener('mouseup', this.handleMouseUp, true);
      document.addEventListener('touchmove', this.handleMouseMove, true);
      document.addEventListener('touchend', this.handleMouseUp, true);

      this.setState({
        active: true,
        distance: 0
      });

      if (this.props.sliderActive) {
        this.props.sliderActive(event);
      }

      this.handleMouseMove(event);

      if (onMouseDown) {
        onMouseDown(event);
      }
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      var onMouseMove = this.props.onMouseMove;


      if (onMouseMove) {
        onMouseMove(event);
      }
    }
  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp(event) {
      var onMouseUp = this.props.onMouseUp;


      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseMove, true);
      document.removeEventListener('touchend', this.handleMouseUp, true);

      this.setState({
        active: false
      });

      if (this.props.sliderInactive) {
        this.props.sliderInactive(event);
      }

      if (onMouseUp) {
        onMouseUp(event);
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(e) {
      document.addEventListener('keydown', this.handleKeyPress, true);
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(e) {
      document.removeEventListener('keydown', this.handleKeyPress, true);
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      // event.stopPropagation();
      if (this.props.onClick) {
        this.props.onClick(event);
      }
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(event) {
      if (event.which === 37 || event.which === 40) {
        // Left and Down Arrows
        event.preventDefault();
        event.stopPropagation();
        this.stepBack();
      } else if (event.which === 38 || event.which === 39) {
        // Up and Right Arrows
        event.preventDefault();
        event.stopPropagation();
        this.stepForward();
      }
    }
  }, {
    key: 'stepForward',
    value: function stepForward() {
      if (this.props.stepForward) {
        this.props.stepForward();
      }
    }
  }, {
    key: 'stepBack',
    value: function stepBack() {
      if (this.props.stepBack) {
        this.props.stepBack();
      }
    }
  }, {
    key: 'calculateDistance',
    value: function calculateDistance(event) {
      var node = (0, _reactDom.findDOMNode)(this);
      var position = Dom.getPointerPosition(node, event);
      if (this.props.vertical) {
        return position.y;
      }
      return position.x;
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var progress = this.getProgress();
      var percentage = (progress * 100).toFixed(2) + '%';
      return _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, { progress: progress, percentage: percentage });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          vertical = _props.vertical,
          label = _props.label,
          valuenow = _props.valuenow,
          valuetext = _props.valuetext;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)(this.props.className, {
            'video-react-slider-vertical': vertical,
            'video-react-slider-horizontal': !vertical,
            'video-react-sliding': this.state.active
          }, 'video-react-slider'),
          tabIndex: '0',
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleMouseDown,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onClick: this.handleClick,
          'aria-label': label || '',
          'aria-valuenow': valuenow || '',
          'aria-valuetext': valuetext || '',
          'aria-valuemin': 0,
          'aria-valuemax': 100
        },
        this.renderChildren()
      );
    }
  }]);

  return Slider;
}(_react.Component);

exports.default = Slider;


Slider.propTypes = propTypes;
Slider.displayName = 'Slider';

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _MenuButton = __webpack_require__(793);

var _MenuButton2 = _interopRequireDefault(_MenuButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  player: _propTypes2.default.object,
  actions: _propTypes2.default.object,
  rates: _propTypes2.default.array,
  className: _propTypes2.default.string
};

var defaultProps = {
  rates: [2, 1.5, 1.25, 1, 0.5, 0.25]
};

var PlaybackRateMenuButton = function (_Component) {
  _inherits(PlaybackRateMenuButton, _Component);

  function PlaybackRateMenuButton(props, context) {
    _classCallCheck(this, PlaybackRateMenuButton);

    var _this = _possibleConstructorReturn(this, (PlaybackRateMenuButton.__proto__ || Object.getPrototypeOf(PlaybackRateMenuButton)).call(this, props, context));

    _this.handleSelectItem = _this.handleSelectItem.bind(_this);
    return _this;
  }

  _createClass(PlaybackRateMenuButton, [{
    key: 'handleSelectItem',
    value: function handleSelectItem(index) {
      var _props = this.props,
          rates = _props.rates,
          actions = _props.actions;

      if (index >= 0 && index < rates.length) {
        actions.changeRate(rates[index]);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          rates = _props2.rates,
          player = _props2.player;

      var items = rates.map(function (rate) {
        return {
          label: rate + 'x',
          value: rate
        };
      });
      var selectedIndex = rates.indexOf(player.playbackRate) || 0;

      return _react2.default.createElement(
        _MenuButton2.default,
        {
          className: (0, _classnames2.default)('video-react-playback-rate', this.props.className),
          onSelectItem: this.handleSelectItem,
          items: items,
          selectedIndex: selectedIndex
        },
        _react2.default.createElement(
          'span',
          { className: 'video-react-control-text' },
          'Playback Rate'
        ),
        _react2.default.createElement(
          'div',
          { className: 'video-react-playback-rate-value' },
          player.playbackRate.toFixed(2),
          'x'
        )
      );
    }
  }]);

  return PlaybackRateMenuButton;
}(_react.Component);

PlaybackRateMenuButton.propTypes = propTypes;
PlaybackRateMenuButton.defaultProps = defaultProps;
PlaybackRateMenuButton.displayName = 'PlaybackRateMenuButton';
exports.default = PlaybackRateMenuButton;

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_layoutEngine__ = __webpack_require__(37);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var layoutEngine=new __WEBPACK_IMPORTED_MODULE_5_app_api_layoutEngine__["a" /* default */]({critical:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"],warning:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"],ok:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"],info:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"],unknown:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"],disabled:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"],halt:__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_Callout__["default"]});function compileLayoutData(path,content){var data=[];if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isArray(content)){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(content,function(content,index){if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isString(content)){data.push({type:'paragraph',path:[].concat(_toConsumableArray(path),[index])});}else{data.push({type:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(content)[0].split(' ')[0],path:[].concat(_toConsumableArray(path),[index,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(content)[0]])});}});}else{if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isString(content)){data.push({type:'paragraph',path:path});}else{data.push({type:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(content)[0].split(' ')[0],path:[].concat(_toConsumableArray(path),[__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(content)[0]])});}}return data;}function ListItem(_ref){var AppState=_ref.AppState,path=_ref.path,content=_ref.content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{'aria-label':'list item',border:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.last(path)===0?'horizontal':'bottom',flex:'grow',margin:{horizontal:'medium'}},compileLayoutData(path,content).map(function(data){return layoutEngine.render(data);}));}/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(ListItem)));

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SectionComponent", function() { return SectionComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_BookElements_Accordion__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Callout__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_Carousel__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_Figure__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_IFrame__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_BookElements_List__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_BookElements_Media__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_BookElements_Modal__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_BookElements_Table__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_BookElements_Tabs__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_BookElements_TableOfContentsEntry__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_api_layoutEngine__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Section=function(_React$Component){_inherits(Section,_React$Component);function Section(){_classCallCheck(this,Section);return _possibleConstructorReturn(this,(Section.__proto__||Object.getPrototypeOf(Section)).apply(this,arguments));}_createClass(Section,[{key:'render',value:function render(){var _props=this.props,path=_props.path,content=_props.content;if(__WEBPACK_IMPORTED_MODULE_16_app_api_bookElement__["a" /* default */].isNotSelected(path))return null;var header=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.last(path).replace('section','').toUpperCase();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["d" /* Box */],{margin:{top:'small'},'aria-label':'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_BookElements_TableOfContentsEntry__["default"],{path:path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["m" /* Text */],{weight:'bold'},header))),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(content,function(content,index){return layoutEngine.render(compileLayoutData(path,content,index));}));}}]);return Section;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var layoutEngine=new __WEBPACK_IMPORTED_MODULE_17_app_api_layoutEngine__["a" /* default */]({accordion:__WEBPACK_IMPORTED_MODULE_5_app_components_BookElements_Accordion__["default"],audio:__WEBPACK_IMPORTED_MODULE_11_app_components_BookElements_Media__["default"],carousel:__WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_Carousel__["default"],critical:__WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Callout__["default"],disabled:__WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Callout__["default"],halt:__WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Callout__["default"],figure:__WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_Figure__["default"],info:__WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Callout__["default"],interactive:__WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_IFrame__["default"],list:__WEBPACK_IMPORTED_MODULE_10_app_components_BookElements_List__["default"],modal:__WEBPACK_IMPORTED_MODULE_12_app_components_BookElements_Modal__["default"],ok:__WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Callout__["default"],section:Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Section)),table:__WEBPACK_IMPORTED_MODULE_13_app_components_BookElements_Table__["default"],tabs:__WEBPACK_IMPORTED_MODULE_14_app_components_BookElements_Tabs__["default"],unknown:__WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Callout__["default"],video:__WEBPACK_IMPORTED_MODULE_11_app_components_BookElements_Media__["default"],warning:__WEBPACK_IMPORTED_MODULE_6_app_components_BookElements_Callout__["default"]});function compileLayoutData(path,content,index){var data=void 0;if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isString(content)){data={type:'paragraph',path:[].concat(_toConsumableArray(path),[index])};}else{data={type:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(content)[0].split(' ')[0],path:[].concat(_toConsumableArray(path),[index,__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(content)[0]])};}return data;}Section.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * book elements array
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]))};Section.defaultProps={content:[]};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Section));Component.displayName='Section';var SectionComponent=Section;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TitleComponent", function() { return TitleComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_BookElements_TableOfContentsEntry__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_contents__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_api_bookElement__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function formatTitle(path,content,level){var title=content;var chapterNumber=__WEBPACK_IMPORTED_MODULE_7_app_api_bookElement__["a" /* default */].extractChapterNumber(path);var hasChapterNumber=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(chapterNumber).parseInt().isFinite().value();if(!level&&hasChapterNumber){title='Chapter '+chapterNumber+': '+title;}return title;}var Title=function(_React$Component){_inherits(Title,_React$Component);function Title(){_classCallCheck(this,Title);return _possibleConstructorReturn(this,(Title.__proto__||Object.getPrototypeOf(Title)).apply(this,arguments));}_createClass(Title,[{key:'render',value:function render(){var _props=this.props,path=_props.path,content=_props.content;var level=__WEBPACK_IMPORTED_MODULE_6_app_api_contents__["a" /* default */].extract(path,'level');var getSize=function getSize(level){switch(level){case 2:return'xxlarge';case 3:return'large';default:return'medium';}};if(level){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_BookElements_TableOfContentsEntry__["default"],{path:path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["m" /* Text */],{responsive:true,size:getSize(level),weight:'bold',textAlign:'center',margin:{bottom:'small'},'aria-label':'title'},formatTitle(path,content,level)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_BookElements_TableOfContentsEntry__["default"],{path:path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["g" /* Heading */],{responsive:true,textAlign:'center',margin:{bottom:'small'}},formatTitle(path,content)));}}]);return Title;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Title.propTypes={/**
   * content path, determines numbering
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * title
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Title.defaultProps={content:' '};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Title));Component.displayName='Title';var TitleComponent=Title;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_style_theme__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_Menu_MenuPane__ = __webpack_require__(151);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(['\n  font-style: italic;\n  :hover {\n    color: ',';\n    text-decoration: underline;\n  }\n'],['\n  font-style: italic;\n  :hover {\n    color: ',';\n    text-decoration: underline;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  :hover {\n    cursor: pointer;\n  }\n  ',';\n'],['\n  :hover {\n    cursor: pointer;\n  }\n  ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n      background: ',';\n    '],['\n      background: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  position: relative;\n  /* forms the triangle */\n  :after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-style: solid;\n  }\n  /* controls triangle fill color */\n  :after {\n    bottom: -20px;\n    left: 12px;\n    border-color: ',' transparent\n      transparent transparent;\n    border-width: 10px;\n  }\n'],['\n  position: relative;\n  /* forms the triangle */\n  :after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-style: solid;\n  }\n  /* controls triangle fill color */\n  :after {\n    bottom: -20px;\n    left: 12px;\n    border-color: ',' transparent\n      transparent transparent;\n    border-width: 10px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledText=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5_grommet__["m" /* Text */])(_templateObject,__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors['neutral-2']);var BookmarkEntry=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5_grommet__["d" /* Box */])(_templateObject2,function(props){return props.highlight&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* css */])(_templateObject3,__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors.focus);});// credits: https://stackoverflow.com/questions/9450733/css-triangle-custom-border-color
var Note=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5_grommet__["d" /* Box */])(_templateObject4,__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors['light-1']);function removeMarkup(sentence){var contextPattern=/\$\{([^}]+)\}\{([^}]+)\}/;var hasMarkup=sentence.match(contextPattern);if(!hasMarkup)return sentence;var _hasMarkup=_slicedToArray(hasMarkup,2),context=_hasMarkup[0],anchor=_hasMarkup[1];var front=sentence.substring(0,hasMarkup.index);var back=removeMarkup(sentence.substring(hasMarkup.index+context.length));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,front,anchor,back);}function Bookmarks(_ref){var AppState=_ref.AppState;if(!AppState.isBookmarksMenuOpen)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_Menu_MenuPane__["a" /* default */],{'aria-label':'bookmark menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet__["g" /* Heading */],{responsive:true,textAlign:'center',margin:'small',size:'small'},'Bookmarks'),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(AppState.bookmarks.groupedEntries,function(selections,entry){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:entry},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet__["g" /* Heading */],{responsive:true,level:3,size:'small',margin:'xsmall'},entry),__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(selections,function(selection,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarkEntry,{highlight:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(selection.path,AppState.bookmarkToDelete.slice()),key:entry+index,pad:{vertical:'small'},border:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(index,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(selections)-1)?undefined:'bottom',onClick:function onClick(){if(AppState.isUserDeleting){AppState.prepareToDeleteBookmark(selection.path);}else{AppState.toggleBookmarksMenu();AppState.changeSectionItem(selection.path);}}},selection.note&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Note,{round:'xsmall',background:'light-1',margin:{vertical:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet__["m" /* Text */],{margin:{left:'small'},size:'medium'},selection.note)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledText,{truncate:true},removeMarkup(selection.content)));}));}));}/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(Bookmarks)));

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet__ = __webpack_require__(7);
var _templateObject=_taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  height: calc(100vh - 94px);\n  z-index: 8;\n  background: repeating-linear-gradient(\n    -55deg,\n    #e6e6e6,\n    #e6e6e6 10px,\n    #e9e9e9 10px,\n    #e9e9e9 20px\n  );\n  @media (max-width: 600px) {\n    height: calc(100vh - 74px);\n  }\n'],['\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  height: calc(100vh - 94px);\n  z-index: 8;\n  background: repeating-linear-gradient(\n    -55deg,\n    #e6e6e6,\n    #e6e6e6 10px,\n    #e9e9e9 10px,\n    #e9e9e9 20px\n  );\n  @media (max-width: 600px) {\n    height: calc(100vh - 74px);\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  overflow-y: auto;\n'],['\n  overflow-y: auto;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledBox=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */])(_templateObject);var ScrollableBox=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject2);function MenuPane(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledBox,{direction:'column',width:'large',elevation:'small',pad:{left:'medium',top:'medium',bottom:'xxsmall'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollableBox,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{pad:{right:'medium'}},children)));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(MenuPane)));

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_style_theme__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_Menu_MenuPane__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_AnimatedEllipsis__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_worker_loader_app_api_toc_worker_js__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_worker_loader_app_api_toc_worker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_worker_loader_app_api_toc_worker_js__);
var _templateObject=_taggedTemplateLiteral(['\n  max-width: 700px !important;\n  :hover {\n    cursor: pointer;\n    color: ',';\n    text-decoration: underline;\n  }\n'],['\n  max-width: 700px !important;\n  :hover {\n    cursor: pointer;\n    color: ',';\n    text-decoration: underline;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// eslint-disable-next-line import/no-webpack-loader-syntax
var tocWorker=new __WEBPACK_IMPORTED_MODULE_8_worker_loader_app_api_toc_worker_js___default.a();var TOC=void 0;tocWorker.postMessage('get-toc');tocWorker.onmessage=function(_ref){var toc=_ref.data;TOC=toc;};var StyledEntry=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5_grommet__["g" /* Heading */])(_templateObject,__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors['neutral-2']);function Entry(_ref2){var AppState=_ref2.AppState,entry=_ref2.entry;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledEntry,{color:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(AppState.selectedSectionItem,entry.path)?'neutral-1':undefined,key:entry.path,responsive:true,level:entry.level+1,size:'small',margin:'none',truncate:true,onClick:function onClick(){AppState.toggleTOCMenu();AppState.changeSectionItem(entry.path);},style:{marginLeft:(entry.level-1)*15}},entry.label);}function TableOfContents(_ref3){var AppState=_ref3.AppState;if(!AppState.isTOCMenuOpen)return null;if(!TOC){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_Menu_MenuPane__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet__["g" /* Heading */],{responsive:true,textAlign:'center',margin:'small',size:'small'},'Table of Contents'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledEntry,{responsive:true,level:2,size:'small',margin:'none'},'Loading ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_AnimatedEllipsis__["a" /* default */],null)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_Menu_MenuPane__["a" /* default */],{'aria-label':'table of contents'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet__["g" /* Heading */],{responsive:true,textAlign:'center',margin:'small',size:'small'},'Table of Contents'),TOC.entries.map(function(entry,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Entry,{key:'entry'+index,AppState:AppState,entry:entry});}),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(TOC.figures)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet__["g" /* Heading */],{responsive:true,textAlign:'center',margin:'small',size:'small'},'List of Figures'),TOC.figures.map(function(entry,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Entry,{key:'figure'+index,AppState:AppState,entry:entry});})),!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(TOC.tables)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet__["g" /* Heading */],{responsive:true,textAlign:'center',margin:'small',size:'small'},'List of Tables'),TOC.tables.map(function(entry,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Entry,{key:'table'+index,AppState:AppState,entry:entry});})));}/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(TableOfContents)));

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  .one {\n    opacity: 1;\n    animation: dot 1.3s infinite;\n    animation-delay: 0s;\n  }\n\n  .two {\n    opacity: 1;\n    animation: dot 1.3s infinite;\n    animation-delay: 0.2s;\n  }\n\n  .three {\n    opacity: 1;\n    animation: dot 1.3s infinite;\n    animation-delay: 0.3s;\n  }\n\n  @keyframes dot {\n    0% {\n      opacity: 0;\n    }\n    50% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n'],['\n  .one {\n    opacity: 1;\n    animation: dot 1.3s infinite;\n    animation-delay: 0s;\n  }\n\n  .two {\n    opacity: 1;\n    animation: dot 1.3s infinite;\n    animation-delay: 0.2s;\n  }\n\n  .three {\n    opacity: 1;\n    animation: dot 1.3s infinite;\n    animation-delay: 0.3s;\n  }\n\n  @keyframes dot {\n    0% {\n      opacity: 0;\n    }\n    50% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  font-size: 2em;\n  ',';\n'],['\n  font-size: 2em;\n  ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n      font-size: 1em;\n    '],['\n      font-size: 1em;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AnimatedEllipsis=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject);function EllipsisAnimation(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AnimatedEllipsis,props,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'one'},'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'two'},'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'three'},'.'));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(EllipsisAnimation)(_templateObject2,function(props){return props.small&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(_templateObject3);}));

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(276);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(280);


/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(24);
var global = __webpack_require__(21);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(113) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(16)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(48)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(113);
var $export = __webpack_require__(33);
var redefine = __webpack_require__(59);
var hide = __webpack_require__(48);
var Iterators = __webpack_require__(61);
var $iterCreate = __webpack_require__(294);
var setToStringTag = __webpack_require__(118);
var getPrototypeOf = __webpack_require__(300);
var ITERATOR = __webpack_require__(16)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 160 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(21).document;
module.exports = document && document.documentElement;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(41);
var aFunction = __webpack_require__(78);
var SPECIES = __webpack_require__(16)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(60);
var invoke = __webpack_require__(310);
var html = __webpack_require__(161);
var cel = __webpack_require__(108);
var global = __webpack_require__(21);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(49)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var isObject = __webpack_require__(42);
var newPromiseCapability = __webpack_require__(119);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(320);
var defined = __webpack_require__(79);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(16)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(338);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32), __webpack_require__(171)(module)))

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseMetricToNum; });
/* unused harmony export fontSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return breakpointStyle; });
/* unused harmony export findAllByType */
/* unused harmony export getAvailableAtBadge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);

var parseMetricToNum = function parseMetricToNum(fontAsString) {
  return parseFloat(fontAsString.replace(/[^0-9/.]/g, ''), 10);
};
var fontSize = function fontSize(size, lineHeight) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-size:", ";line-height:", ";"], function (props) {
    return parseMetricToNum(size) / parseMetricToNum(props.theme.global.font.size) * 1 + "rem";
  }, function (props) {
    return lineHeight || Math.ceil(parseMetricToNum(size) / parseMetricToNum(props.theme.global.lineHeight)) * (parseMetricToNum(props.theme.global.lineHeight) / parseMetricToNum(size)) + "px";
  });
};
var breakpointStyle = function breakpointStyle(breakpoint, content) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["@media only screen ", "{", ";}"], breakpoint.value && "and (max-width: " + breakpoint.value + "px)", content);
};
var findAllByType = function findAllByType(component, type) {
  var matches = [];

  if (component.type === type) {
    matches.push(component);
  }

  if (component.children) {
    component.children.forEach(function (child) {
      matches = matches.concat(findAllByType(child, type));
    });
  }

  return matches;
};
var getAvailableAtBadge = function getAvailableAtBadge(availableAt) {
  return [{
    url: "https://storybook.grommet.io/?selectedKind=" + availableAt + "&full=0&addons=0&stories=1&panelRight=0",
    badge: 'https://cdn-images-1.medium.com/fit/c/120/120/1*TD1P0HtIH9zF0UEH28zYtw.png',
    label: 'Storybook'
  }, {
    url: "https://codesandbox.io/s/github/grommet/grommet-sandbox?initialpath=" + availableAt.toLowerCase() + "&module=%2Fsrc%2F" + availableAt + ".js",
    badge: 'https://codesandbox.io/static/img/play-codesandbox.svg',
    label: 'CodeSandbox'
  }];
};

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return controlBorderStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return edgeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return focusStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return inputStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return overflowStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return placeholderStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return evalStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return genericStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(172);



var baseStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-family:", ";font-size:", ";line-height:", ";font-weight:", ";", " box-sizing:border-box;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;"], function (props) {
  return props.theme.global.font.family;
}, function (props) {
  return props.theme.global.font.size;
}, function (props) {
  return props.theme.global.font.height;
}, function (props) {
  return props.theme.global.font.weight;
}, function (props) {
  return !props.plain && props.theme.global.colors.background && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["background:", ";color:", ";"], Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])('background', props.theme, true), Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])('text', props.theme, true));
});
var controlBorderStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border:", " solid ", ";border-radius:", ";"], function (props) {
  return props.theme.global.control.border.width;
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])('border', props.theme);
}, function (props) {
  return props.theme.global.control.border.radius;
});
var edgeStyle = function edgeStyle(kind, data, responsive, responsiveBreakpoint, theme) {
  var breakpoint = responsiveBreakpoint && theme.global.breakpoints[responsiveBreakpoint];

  if (typeof data === 'string') {
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", ":", ";", ";"], kind, theme.global.edgeSize[data] || data, responsive && breakpoint ? Object(__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* breakpointStyle */])(breakpoint, "\n        " + kind + ": " + (breakpoint.edgeSize[data] || data) + ";\n      ") : '');
  }

  var result = [];

  if (data.horizontal) {
    result.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", "-left:", ";", "-right:", ";", ";"], kind, theme.global.edgeSize[data.horizontal] || data.horizontal, kind, theme.global.edgeSize[data.horizontal] || data.horizontal, responsive && breakpoint ? Object(__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* breakpointStyle */])(breakpoint, "\n        " + kind + "-left: " + (breakpoint.edgeSize[data.horizontal] || data.horizontal) + ";\n        " + kind + "-right: " + (breakpoint.edgeSize[data.horizontal] || data.horizontal) + ";\n      ") : ''));
  }

  if (data.vertical) {
    result.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", "-top:", ";", "-bottom:", ";", ";"], kind, theme.global.edgeSize[data.vertical] || data.vertical, kind, theme.global.edgeSize[data.vertical] || data.vertical, responsive && breakpoint ? Object(__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* breakpointStyle */])(breakpoint, "\n        " + kind + "-top: " + (breakpoint.edgeSize[data.vertical] || data.vertical) + ";\n        " + kind + "-bottom: " + (breakpoint.edgeSize[data.vertical] || data.vertical) + ";\n      ") : ''));
  }

  if (data.top) {
    result.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", "-top:", ";", ";"], kind, theme.global.edgeSize[data.top] || data.top, responsive && breakpoint ? Object(__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* breakpointStyle */])(breakpoint, "\n        " + kind + "-top: " + (breakpoint.edgeSize[data.top] || data.top) + ";\n      ") : ''));
  }

  if (data.bottom) {
    result.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", "-bottom:", ";", ";"], kind, theme.global.edgeSize[data.bottom] || data.bottom, responsive && breakpoint ? Object(__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* breakpointStyle */])(breakpoint, "\n        " + kind + "-bottom: " + (breakpoint.edgeSize[data.bottom] || data.bottom) + ";\n      ") : ''));
  }

  if (data.left) {
    result.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", "-left:", ";", ";"], kind, theme.global.edgeSize[data.left] || data.left, responsive && breakpoint ? Object(__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* breakpointStyle */])(breakpoint, "\n        " + kind + "-left: " + (breakpoint.edgeSize[data.left] || data.left) + ";\n      ") : ''));
  }

  if (data.right) {
    result.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", "-right:", ";", ";"], kind, theme.global.edgeSize[data.right] || data.right, responsive && breakpoint ? Object(__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* breakpointStyle */])(breakpoint, "\n        " + kind + "-right: " + (breakpoint.edgeSize[data.right] || data.right) + ";\n      ") : ''));
  }

  return result;
}; // focus also supports clickable elements inside svg

var focusStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["> circle,> ellipse,> line,> path,> polygon,> polyline,> rect{outline:", " solid 2px;}border-color:", ";box-shadow:0 0 2px 2px ", ";::-moz-focus-inner{border:0;}"], function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])(props.theme.global.focus.border.color, props.theme);
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])(props.theme.global.focus.border.color, props.theme);
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])(props.theme.global.focus.border.color, props.theme);
});
var inputStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["box-sizing:border-box;font-size:inherit;border:none;-webkit-appearance:none;padding:", "px;outline:none;background:transparent;color:inherit;", " margin:0;", " ", "::-webkit-search-decoration{-webkit-appearance:none;}"], function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* parseMetricToNum */])(props.theme.global.input.padding) - Object(__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* parseMetricToNum */])(props.theme.global.control.border.width);
}, function (props) {
  return props.theme.global.input.weight && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-weight:", ";"], props.theme.global.input.weight);
}, function (props) {
  return props.focus && (!props.plain || props.focusIndicator) && focusStyle;
}, controlBorderStyle);
var overflowStyle = function overflowStyle(overflowProp) {
  if (typeof overflowProp === 'string') {
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["overflow:", ";"], overflowProp);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", " ", ";"], overflowProp.horizontal && "overflow-x: " + overflowProp.horizontal + ";", overflowProp.vertical && "overflow-y: " + overflowProp.vertical + ";");
};
var placeholderColor = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["color:", ";"], function (props) {
  return props.theme.global.colors.placeholder;
});
var placeholderStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["&::-webkit-input-placeholder{", ";}&::-moz-placeholder{", ";}&:-ms-input-placeholder{", ";}"], placeholderColor, placeholderColor, placeholderColor); // evalStyle() converts a styled-components item into a string

var evalStyle = function evalStyle(arg, theme) {
  if (arg && Array.isArray(arg) && typeof arg[0] === 'function') {
    return arg[0]({
      theme: theme
    });
  }

  return arg;
};
var ALIGN_SELF_MAP = {
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
var genericStyles = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", " ", " ", ""], function (props) {
  return props.alignSelf && "align-self: " + ALIGN_SELF_MAP[props.alignSelf] + ";";
}, function (props) {
  return props.gridArea && "grid-area: " + props.gridArea + ";";
}, function (props) {
  return props.margin && edgeStyle('margin', props.margin, props.responsive, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
});

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PropTypes = __webpack_require__(364);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _describe = __webpack_require__(365);

var _describe2 = _interopRequireDefault(_describe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.PropTypes = _PropTypes2.default;
exports.describe = _describe2.default;

exports.default = {
  describe: _describe2.default,
  PropTypes: _PropTypes2.default
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = descToJSON;

var arrayFormat = function arrayFormat(array, prefix) {
  return array.map(function (propType) {
    return propTypeFormat(propType, prefix);
  });
};

var shapeFormat = function shapeFormat(shape, prefix) {
  var props = Object.keys(shape).map(function (key) {
    var value = shape[key];
    var valueFormat = void 0;
    if (value.type && (value.type === 'arrayOf' || value.type === 'oneOfType' || value.type === 'oneOf') && Array.isArray(value.args)) {
      valueFormat = '\n' + propTypeFormat(value, prefix + '    ');
    } else if (value.type === 'shape') {
      valueFormat = '\n' + propTypeFormat(value, prefix + '    ');
    } else {
      valueFormat = propTypeFormat(value);
    }
    return prefix + '  ' + key + ': ' + valueFormat;
  });
  return prefix + '{\n' + props.join(',\n') + '\n' + prefix + '}';
};

var propTypeFormat = function propTypeFormat(propType) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var result = void 0;
  if (propType.type) {
    switch (propType.type) {
      case 'arrayOf':
        if (Array.isArray(propType.args)) {
          result = prefix + '[\n' + arrayFormat(propType.args, prefix + '  ').join('\n') + '\n' + prefix + ']';
        } else if (propType.args.type === 'oneOfType') {
          result = prefix + '[\n' + propTypeFormat(propType.args, prefix + '  ') + '\n' + prefix + ']';
        } else {
          result = prefix + '[' + propTypeFormat(propType.args) + ']';
        }
        break;
      case 'bool':
        result = prefix + 'boolean';
        break;
      case 'func':
        result = prefix + 'function';
        break;
      case 'instanceOf':
        result = prefix + 'new ' + propType.args.name + '(...)';
        break;
      case 'objectOf':
        result = prefix + '{ test: ' + propType.args.type + ', ... }';
        break;
      case 'oneOf':
        result = propType.args.map(function (a) {
          return '' + prefix + a;
        }).join('\n');
        break;
      case 'oneOfType':
        if (Array.isArray(propType.args)) {
          result = arrayFormat(propType.args, prefix).join('\n');
        } else {
          result = '' + prefix + propTypeFormat(propType.args);
        }
        break;
      case 'shape':
        result = '' + shapeFormat(propType.args, prefix);
        break;
      default:
        result = '' + prefix + propType.type;
        break;
    }
  } else {
    result = prefix + 'custom';
  }
  return result;
};

var propTypeAsJson = function propTypeAsJson(propType, propName, defaultValue) {
  var documentation = _extends({}, propType.reactDesc, {
    name: propName
  });

  if (defaultValue) {
    documentation.defaultValue = defaultValue;
  }

  documentation.format = documentation.format || propTypeFormat(propType);

  return documentation;
};

function descToJSON(component) {
  var reactDesc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!component) {
    throw new Error('react-desc: component is required');
  }

  var documentation = _extends({
    name: component.displayName || component.name
  }, reactDesc);
  if (reactDesc) {
    delete documentation.propTypes;

    if (reactDesc.propTypes) {
      var propTypes = [];
      Object.keys(reactDesc.propTypes).forEach(function (propName) {
        var propType = reactDesc.propTypes[propName];
        propTypes.push(propTypeAsJson(propType, propName, (component.defaultProps || {})[propName]));
      });
      if (propTypes.length > 0) {
        documentation.properties = propTypes;
      }
    }
  }
  return documentation;
}

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deepFreeze; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deepMerge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeUndefined; });
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var isObject = function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
};
var deepFreeze = function deepFreeze(obj) {
  Object.keys(obj).forEach(function (key) {
    return key && isObject(obj[key]) && Object.freeze(obj[key]);
  });
  return Object.freeze(obj);
};
var deepMerge = function deepMerge(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (!sources.length) {
    return target;
  } // making sure to not change target (immutable)


  var output = _extends({}, target);

  sources.forEach(function (source) {
    if (isObject(source)) {
      Object.keys(source).forEach(function (key) {
        if (isObject(source[key])) {
          if (!output[key]) {
            output[key] = _extends({}, source[key]);
          } else {
            output[key] = deepMerge(output[key], source[key]);
          }
        } else {
          output[key] = source[key];
        }
      });
    }
  });
  return output;
};
var removeUndefined = function removeUndefined(obj) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (obj[key] !== undefined) {
      result[key] = obj[key];
    }
  });
  return result;
};

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export adjustHue */
/* unused harmony export animation */
/* unused harmony export backgroundImages */
/* unused harmony export backgrounds */
/* unused harmony export between */
/* unused harmony export border */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* unused harmony export borderStyle */
/* unused harmony export borderWidth */
/* unused harmony export buttons */
/* unused harmony export clearFix */
/* unused harmony export complement */
/* unused harmony export cover */
/* unused harmony export darken */
/* unused harmony export desaturate */
/* unused harmony export directionalProperty */
/* unused harmony export ellipsis */
/* unused harmony export em */
/* unused harmony export fluidRange */
/* unused harmony export fontFace */
/* unused harmony export getLuminance */
/* unused harmony export getValueAndUnit */
/* unused harmony export grayscale */
/* unused harmony export invert */
/* unused harmony export hideText */
/* unused harmony export hideVisually */
/* unused harmony export hiDPI */
/* unused harmony export hsl */
/* unused harmony export hsla */
/* unused harmony export lighten */
/* unused harmony export margin */
/* unused harmony export mix */
/* unused harmony export modularScale */
/* unused harmony export normalize */
/* unused harmony export opacify */
/* unused harmony export padding */
/* unused harmony export parseToHsl */
/* unused harmony export parseToRgb */
/* unused harmony export placeholder */
/* unused harmony export position */
/* unused harmony export radialGradient */
/* unused harmony export readableColor */
/* unused harmony export rem */
/* unused harmony export retinaImage */
/* unused harmony export rgb */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rgba; });
/* unused harmony export saturate */
/* unused harmony export selection */
/* unused harmony export setHue */
/* unused harmony export setLightness */
/* unused harmony export setSaturation */
/* unused harmony export shade */
/* unused harmony export size */
/* unused harmony export stripUnit */
/* unused harmony export textInputs */
/* unused harmony export timingFunctions */
/* unused harmony export tint */
/* unused harmony export toColorString */
/* unused harmony export transitions */
/* unused harmony export transparentize */
/* unused harmony export triangle */
/* unused harmony export wordWrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__ = __webpack_require__(372);



// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var positionMap = ['Top', 'Right', 'Bottom', 'Left'];

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');

  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return "" + acc + capitalizeString(val);
    });
  }

  var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
  return property === joinedProperty ? "" + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};

  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
    }
  }

  return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */


function directionalProperty(property) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === void 0 ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === void 0 ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === void 0 ? secondValue : _values$3;
  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

function endsWith (string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

/**
 * Returns a given CSS value minus its unit (or the original value if an invalid string is passed).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */
function stripUnit(value) {
  var unitlessValue = parseFloat(value);
  if (isNaN(unitlessValue)) return value;
  return unitlessValue;
}

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */

var pxtoFactory = function pxtoFactory(to) {
  return function (pxval, base) {
    if (base === void 0) {
      base = '16px';
    }

    var newPxval = pxval;
    var newBase = base;

    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new Error("Expected a string ending in \"px\" or a number passed as the first argument to " + to + "(), got \"" + pxval + "\" instead.");
      }

      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new Error("Expected a string ending in \"px\" or a number passed as the second argument to " + to + "(), got \"" + base + "\" instead.");
      }

      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new Error("Passed invalid pixel value (\"" + pxval + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
    }

    if (typeof newBase === 'string') {
      throw new Error("Passed invalid base value (\"" + base + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
    }

    return "" + newPxval / newBase + to;
  };
};

/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */

var em =
/*#__PURE__*/
pxtoFactory('em');

var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0]
 *   '--unit': getValueAndUnit('100px')[1]
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]}
 *   --unit: ${getValueAndUnit('100px')[1]}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 *   '--unit': 'px'
 * }
 */

function getValueAndUnit(value) {
  if (typeof value !== 'string') return [value, ''];
  var matchedValue = value.match(cssRegex);
  if (matchedValue) return [parseFloat(value), matchedValue[2]];
  return [value, undefined];
}

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4
};

function getRatio(ratioName) {
  return ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */


function modularScale(steps, base, ratio) {
  if (base === void 0) {
    base = '1em';
  }

  if (ratio === void 0) {
    ratio = 'perfectFourth';
  }

  if (typeof steps !== 'number') {
    throw new Error('Please provide a number of steps to the modularScale helper.');
  }

  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
  }

  var realBase = typeof base === 'string' ? stripUnit(base) : base;
  var realRatio = typeof ratio === 'string' ? getRatio(ratio) : ratio;

  if (typeof realBase === 'string') {
    throw new Error("Invalid value passed as base to modularScale, expected number or em string but got \"" + base + "\"");
  }

  return realBase * Math.pow(realRatio, steps) + "em";
}

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */

var rem =
/*#__PURE__*/
pxtoFactory('rem');

/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */

function between(fromSize, toSize, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }

  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }

  var _getValueAndUnit = getValueAndUnit(fromSize),
      unitlessFromSize = _getValueAndUnit[0],
      fromSizeUnit = _getValueAndUnit[1];

  var _getValueAndUnit2 = getValueAndUnit(toSize),
      unitlessToSize = _getValueAndUnit2[0],
      toSizeUnit = _getValueAndUnit2[1];

  var _getValueAndUnit3 = getValueAndUnit(minScreen),
      unitlessMinScreen = _getValueAndUnit3[0],
      minScreenUnit = _getValueAndUnit3[1];

  var _getValueAndUnit4 = getValueAndUnit(maxScreen),
      unitlessMaxScreen = _getValueAndUnit4[0],
      maxScreenUnit = _getValueAndUnit4[1];

  if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) {
    throw new Error('minScreen and maxScreen must be provided as stringified numbers with the same units.');
  }

  if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || !fromSizeUnit || !toSizeUnit || fromSizeUnit !== toSizeUnit) {
    throw new Error('fromSize and toSize must be provided as stringified numbers with the same units.');
  }

  var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
  var base = unitlessToSize - slope * unitlessMaxScreen;
  return "calc(" + base.toFixed(2) + fromSizeUnit + " + " + (100 * slope).toFixed(2) + "vw)";
}

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */
function clearFix(parent) {
  var _ref;

  if (parent === void 0) {
    parent = '&';
  }

  var pseudoSelector = parent + "::after";
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */
function cover(offset) {
  if (offset === void 0) {
    offset = 0;
  }

  return {
    position: 'absolute',
    top: offset,
    right: offset,
    bottom: offset,
    left: offset
  };
}

/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */
function ellipsis(width) {
  if (width === void 0) {
    width = '100%';
  }

  return {
    display: 'inline-block',
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
}

/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */
function fluidRange(cssProp, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }

  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }

  if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) {
    throw new Error('expects either an array of objects or a single object with the properties prop, fromSize, and toSize.');
  }

  if (Array.isArray(cssProp)) {
    var mediaQueries = {};
    var fallbacks = {};

    for (var _iterator = cssProp, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _extends2, _extends3;

      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var obj = _ref;

      if (!obj.prop || !obj.fromSize || !obj.toSize) {
        throw new Error('expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.');
      }

      fallbacks[obj.prop] = obj.fromSize;
      mediaQueries["@media (min-width: " + minScreen + ")"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = between(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
      mediaQueries["@media (min-width: " + maxScreen + ")"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, fallbacks, mediaQueries);
  } else {
    var _ref2, _ref3, _ref4;

    if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) {
      throw new Error('expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.');
    }

    return _ref4 = {}, _ref4[cssProp.prop] = cssProp.fromSize, _ref4["@media (min-width: " + minScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = between(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref2), _ref4["@media (min-width: " + maxScreen + ")"] = (_ref3 = {}, _ref3[cssProp.prop] = cssProp.toSize, _ref3), _ref4;
  }
}

function generateFileReferences(fontFilePath, fileFormats) {
  var fileFontReferences = fileFormats.map(function (format) {
    return "url(\"" + fontFilePath + "." + format + "\")";
  });
  return fileFontReferences.join(', ');
}

function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return "local(\"" + font + "\")";
  });
  return localFontReferences.join(', ');
}

function generateSources(fontFilePath, localFonts, fileFormats) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));

  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats));
  }

  return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */


function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
      fontFilePath = _ref.fontFilePath,
      fontStretch = _ref.fontStretch,
      fontStyle = _ref.fontStyle,
      fontVariant = _ref.fontVariant,
      fontWeight = _ref.fontWeight,
      _ref$fileFormats = _ref.fileFormats,
      fileFormats = _ref$fileFormats === void 0 ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
      localFonts = _ref.localFonts,
      unicodeRange = _ref.unicodeRange,
      fontDisplay = _ref.fontDisplay,
      fontVariationSettings = _ref.fontVariationSettings,
      fontFeatureSettings = _ref.fontFeatureSettings;
  // Error Handling
  if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');

  if (!fontFilePath && !localFonts) {
    throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
  }

  if (localFonts && !Array.isArray(localFonts)) {
    throw new Error('fontFace expects localFonts to be an array.');
  }

  if (!Array.isArray(fileFormats)) {
    throw new Error('fontFace expects fileFormats to be an array.');
  }

  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight,
      fontDisplay: fontDisplay,
      fontVariationSettings: fontVariationSettings,
      fontFeatureSettings: fontFeatureSettings
    } // Removes undefined fields for cleaner css object.

  };
  return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */
function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */
function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */
function hiDPI(ratio) {
  if (ratio === void 0) {
    ratio = 1.3;
  }

  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize() {
  var _ref;

  return [(_ref = {
    html: {
      lineHeight: '1.15',
      textSizeAdjust: '100%'
    },
    body: {
      margin: '0'
    },
    h1: {
      fontSize: '2em',
      margin: '0.67em 0'
    },
    hr: {
      boxSizing: 'content-box',
      height: '0',
      overflow: 'visible'
    },
    pre: {
      fontFamily: 'monospace, monospace',
      fontSize: '1em'
    },
    a: {
      backgroundColor: 'transparent'
    },
    'abbr[title]': {
      borderBottom: 'none',
      textDecoration: 'underline'
    }
  }, _ref["b,\n    strong"] = {
    fontWeight: 'bolder'
  }, _ref["code,\n    kbd,\n    samp"] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  }, _ref.small = {
    fontSize: '80%'
  }, _ref["sub,\n    sup"] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
  }, _ref.sub = {
    bottom: '-0.25em'
  }, _ref.sup = {
    top: '-0.5em'
  }, _ref.img = {
    borderStyle: 'none'
  }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: '0'
  }, _ref["button,\n    input"] = {
    overflow: 'visible'
  }, _ref["button,\n    select"] = {
    textTransform: 'none'
  }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
    WebkitAppearance: 'button'
  }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
    borderStyle: 'none',
    padding: '0'
  }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
    outline: '1px dotted ButtonText'
  }, _ref.fieldset = {
    padding: '0.35em 0.625em 0.75em'
  }, _ref.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
  }, _ref.progress = {
    verticalAlign: 'baseline'
  }, _ref.textarea = {
    overflow: 'auto'
  }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
    boxSizing: 'border-box',
    padding: '0'
  }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
    height: 'auto'
  }, _ref['[type="search"]'] = {
    WebkitAppearance: 'textfield',
    outlineOffset: '-2px'
  }, _ref['[type="search"]::-webkit-search-decoration'] = {
    WebkitAppearance: 'none'
  }, _ref['::-webkit-file-upload-button'] = {
    WebkitAppearance: 'button',
    font: 'inherit'
  }, _ref.details = {
    display: 'block'
  }, _ref.summary = {
    display: 'list-item'
  }, _ref.template = {
    display: 'none'
  }, _ref['[hidden]'] = {
    display: 'none'
  }, _ref), {
    'abbr[title]': {
      textDecoration: 'underline dotted'
    }
  }];
}

/**
 * CSS to style the placeholder pseudo-element.
 *
 * @deprecated - placeholder has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */
function placeholder(styles, parent) {
  var _ref;

  if (parent === void 0) {
    parent = '&';
  }

  return _ref = {}, _ref[parent + "::-webkit-input-placeholder"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref[parent + ":-moz-placeholder"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref[parent + "::-moz-placeholder"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref[parent + ":-ms-input-placeholder"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref;
}

function _templateObject() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__["a" /* default */])(["radial-gradient(", "", "", "", ")"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function parseFallback(colorStops) {
  return colorStops[0].split(' ')[0];
}

function constructGradientValue(literals) {
  var template = '';

  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i]; // Adds leading coma if properties preceed color-stops

    if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
      template = template.slice(0, -1);
      template += ", " + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // No trailing space if color-stops is the only param provided
    } else if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) {
      template += "" + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // Only adds substitution if it is defined
    } else if (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) {
      template += (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) + " ";
    }
  }

  return template.trim();
}
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */


function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
      extent = _ref.extent,
      fallback = _ref.fallback,
      position = _ref.position,
      shape = _ref.shape;

  if (!colorStops || colorStops.length < 2) {
    throw new Error('radialGradient requries at least 2 color-stops to properly render.');
  }

  return {
    backgroundColor: fallback || parseFallback(colorStops),
    backgroundImage: constructGradientValue(_templateObject(), position, shape, extent, colorStops.join(', '))
  };
}

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
  var _ref;

  if (extension === void 0) {
    extension = 'png';
  }

  if (retinaSuffix === void 0) {
    retinaSuffix = '_2x';
  }

  if (!filename) {
    throw new Error('Please supply a filename to retinaImage() as the first argument.');
  } // Replace the dot at the beginning of the passed extension if one exists


  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
  return _ref = {
    backgroundImage: "url(" + filename + "." + ext + ")"
  }, _ref[hiDPI()] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    backgroundImage: "url(" + rFilename + ")"
  }, backgroundSize ? {
    backgroundSize: backgroundSize
  } : {}), _ref;
}

/**
 * CSS to style the selection pseudo-element.
 *
 * @deprecated - selection has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */
function selection(styles, parent) {
  var _ref;

  if (parent === void 0) {
    parent = '';
  }

  return _ref = {}, _ref[parent + "::-moz-selection"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref[parent + "::selection"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref;
}

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
  /* eslint-enable key-spacing */

};

function getTimingFunction(functionName) {
  return functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */


function timingFunctions(timingFunction) {
  return getTimingFunction(timingFunction);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */
function borderColor() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderColor'].concat(values));
}

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  switch (pointingDirection) {
    case 'top':
      return "0 " + width[0] / 2 + width[1] + " " + height[0] + height[1] + " " + width[0] / 2 + width[1];

    case 'left':
      return "" + height[0] / 2 + height[1] + " " + width[0] + width[1] + " " + height[0] / 2 + height[1] + " 0";

    case 'bottom':
      return "" + height[0] + height[1] + " " + width[0] / 2 + width[1] + " 0 " + width[0] / 2 + width[1];

    case 'right':
      return "" + height[0] / 2 + height[1] + " 0 " + height[0] / 2 + height[1] + " " + width[0] + width[1];

    default:
      throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
  }
}; // needed for border-color


var reverseDirection = ['bottom', 'left', 'top', 'right'];
var NUMBER_AND_FLOAT = /(\d*\.?\d*)/;
/**
 * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent',
 *  'borderLeftColor': 'red !important',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */

function triangle(_ref) {
  var pointingDirection = _ref.pointingDirection,
      height = _ref.height,
      width = _ref.width,
      foregroundColor = _ref.foregroundColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
  var widthAndUnit = [parseFloat(width), String(width).replace(NUMBER_AND_FLOAT, '') || 'px'];
  var heightAndUnit = [parseFloat(height), String(height).replace(NUMBER_AND_FLOAT, '') || 'px'];

  if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) {
    throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
  }

  var reverseDirectionIndex = reverseDirection.indexOf(pointingDirection);
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    width: '0',
    height: '0',
    borderWidth: getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit),
    borderStyle: 'solid'
  }, borderColor.apply(void 0, Array.from({
    length: 4
  }).map(function (_, index) {
    return index === reverseDirectionIndex ? foregroundColor : backgroundColor;
  })));
}

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */
function wordWrap(wrap) {
  if (wrap === void 0) {
    wrap = 'break-word';
  }

  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formular from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = hue % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
  /**
   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
   * @private
   */

};

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor);

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + rgbColorString + ".");
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor);

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + _rgbColorString + ".");
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }

  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}

function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }

  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;

    case green:
      hue = (blue - red) / delta + 2;
      break;

    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;

  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }

  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }

  throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}

var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};

var errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if (typeof color !== 'object') throw new Error(errMsg);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);
  throw new Error(errMsg);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare


function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */

function adjustHue(degree, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    hue: (hslColor.hue + parseFloat(degree)) % 360
  }));
}

var curriedAdjustHue =
/*#__PURE__*/
curry(adjustHue);

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */

function complement(color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */

function darken(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
}

var curriedDarken =
/*#__PURE__*/
curry(darken);

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */

function desaturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - parseFloat(amount))
  }));
}

var curriedDesaturate =
/*#__PURE__*/
curry(desaturate);

/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */

function getLuminance(color) {
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */

function grayscale(color) {
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    saturation: 0
  }));
}

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */

function invert(color) {
  // parse color string to rgb
  var value = parseToRgb(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */

function lighten(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
}

var curriedLighten =
/*#__PURE__*/
curry(lighten);

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */

function mix(weight, color, otherColor) {
  var parsedColor1 = parseToRgb(color);

  var color1 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);

  var color2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1 // The formular is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method

  });

  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha + (color2.alpha - color1.alpha) * (parseFloat(weight) / 1.0)
  };
  return rgba(mixedColor);
}

var curriedMix =
/*#__PURE__*/
curry(mix);

/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */

function opacify(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
  });

  return rgba(colorWithAlpha);
}

var curriedOpacify =
/*#__PURE__*/
curry(opacify);

/**
 * Returns black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */

function readableColor(color) {
  return getLuminance(color) > 0.179 ? '#000' : '#fff';
}

var curriedReadableColor =
/*#__PURE__*/
curry(readableColor);

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */

function saturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
  }));
}

var curriedSaturate =
/*#__PURE__*/
curry(saturate);

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */

function setHue(hue, color) {
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    hue: parseFloat(hue)
  }));
}

var curriedSetHue =
/*#__PURE__*/
curry(setHue);

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */

function setLightness(lightness, color) {
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    lightness: parseFloat(lightness)
  }));
}

var curriedSetLightness =
/*#__PURE__*/
curry(setLightness);

/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */

function setSaturation(saturation, color) {
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    saturation: parseFloat(saturation)
  }));
}

var curriedSetSaturation =
/*#__PURE__*/
curry(setSaturation);

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  return curriedMix(parseFloat(percentage), 'rgb(0, 0, 0)', color);
}

var curriedShade =
/*#__PURE__*/
curry(shade);

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  return curriedMix(parseFloat(percentage), 'rgb(255, 255, 255)', color);
}

var curriedTint =
/*#__PURE__*/
curry(tint);

/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */

function transparentize(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 - parseFloat(amount) * 100) / 100)
  });

  return rgba(colorWithAlpha);
}

var curriedTransparentize =
/*#__PURE__*/
curry(transparentize);

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);

  if (!multiMode && args.length > 8) {
    throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
  }

  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
    }

    if (Array.isArray(arg) && arg.length > 8) {
      throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
    }

    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');
  return {
    animation: code
  };
}

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */
function backgroundImages() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    background: properties.join(', ')
  };
}

var sideMap = ['top', 'right', 'bottom', 'left'];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */

function border(sideKeyword) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (typeof sideKeyword === 'string' && sideMap.indexOf(sideKeyword) >= 0) {
    var _ref;

    return _ref = {}, _ref["border" + capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
  } else {
    values.unshift(sideKeyword);
    return {
      borderWidth: values[0],
      borderStyle: values[1],
      borderColor: values[2]
    };
  }
}

/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */
function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);

  if (!radius && radius !== 0) {
    throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
  }

  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
  }

  throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */
function borderStyle() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderStyle'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderWidth'].concat(values));
}

function generateSelectors(template, state) {
  var stateSuffix = state ? ":" + state : '';
  return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */


function statefulSelectors(states, template, stateMap) {
  if (!template) throw new Error('You must provide a template to this method.');
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];

  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new Error('You passed an unsupported selector state to this method.');
    }

    selectors.push(generateSelectors(template, states[i]));
  }

  selectors = selectors.join(',');
  return selectors;
}

var stateMap = [undefined, null, 'active', 'focus', 'hover'];

function template(state) {
  return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */


function buttons() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template, stateMap);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */
function margin() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['margin'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */
function padding() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['padding'].concat(values));
}

var positionMap$1 = ['absolute', 'fixed', 'relative', 'static', 'sticky'];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */

function position(positionKeyword) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (positionMap$1.indexOf(positionKeyword) >= 0) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      position: positionKeyword
    }, directionalProperty.apply(void 0, [''].concat(values)));
  } else {
    var firstValue = positionKeyword; // in this case position is actually the first value

    return directionalProperty.apply(void 0, ['', firstValue].concat(values));
  }
}

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */
function size(height, width) {
  if (width === void 0) {
    width = height;
  }

  return {
    height: height,
    width: width
  };
}

var stateMap$1 = [undefined, null, 'active', 'focus', 'hover'];

function template$1(state) {
  return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */


function textInputs() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template$1, stateMap$1);
}

/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same tranisition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */
function transitions() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  if (Array.isArray(properties[0]) && properties.length === 2) {
    var value = properties[1];

    if (typeof value !== 'string') {
      throw new Error('Property must be a string value.');
    }

    var transitionsString = properties[0].map(function (property) {
      return property + " " + value;
    }).join(', ');
    return {
      transition: transitionsString
    };
  } else {
    return {
      transition: properties.join(', ')
    };
  }
}

// Helpers




/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(376);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__["b"]; });


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return base; });
var base = {
  global: {
    colors: {
      icon: '#666666'
    }
  },
  icon: {
    size: {
      small: '12px',
      medium: '24px',
      large: '48px',
      xlarge: '96px'
    }
  }
};

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var AccordionContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collapsible__ = __webpack_require__(401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Collapsible__["a"]; });


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizeValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeBounds; });
var normalizeValues = function normalizeValues(values) {
  return (values || []).map(function (value, index) {
    if (Array.isArray(value)) {
      return {
        value: value
      };
    }

    if (typeof value === 'number') {
      return {
        value: [index, value]
      };
    }

    return value;
  });
};
var normalizeBounds = function normalizeBounds(bounds, values) {
  var result = bounds;

  if (!result) {
    result = [[0, 1], [0, 1]];
    (values || []).forEach(function (value) {
      result[0][0] = Math.min(result[0][0], value.value[0]);
      result[0][1] = Math.max(result[0][1], value.value[0]);
      result[1][0] = Math.min(result[1][0], value.value[1]);
      result[1][1] = Math.max(result[1][1], value.value[1]);
    });
  }

  return result;
};

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StyledMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return StyledSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledAnalog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledDigitalDigit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StyledDigitalPrevious; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledDigitalNext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var StyledHour = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].line.withConfig({
  displayName: "StyledClock__StyledHour",
  componentId: "y4xw8s-0"
})(["stroke-width:", ";stroke:", ";transition:stroke 1s ease-out;"], function (props) {
  return props.theme.clock.analog.hour.width;
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.clock.analog.hour.color, props.theme);
});
StyledHour.defaultProps = {};
Object.setPrototypeOf(StyledHour.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledMinute = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].line.withConfig({
  displayName: "StyledClock__StyledMinute",
  componentId: "y4xw8s-1"
})(["stroke-width:", ";stroke:", ";transition:stroke 1s ease-out;"], function (props) {
  return props.theme.clock.analog.minute.width;
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.clock.analog.minute.color, props.theme);
});
StyledMinute.defaultProps = {};
Object.setPrototypeOf(StyledMinute.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledSecond = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].line.withConfig({
  displayName: "StyledClock__StyledSecond",
  componentId: "y4xw8s-2"
})(["stroke-width:", ";stroke:", ";transition:stroke 1s ease-out;"], function (props) {
  return props.theme.clock.analog.second.width;
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.clock.analog.second.color, props.theme);
});
StyledSecond.defaultProps = {};
Object.setPrototypeOf(StyledSecond.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledAnalog = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].svg.withConfig({
  displayName: "StyledClock__StyledAnalog",
  componentId: "y4xw8s-3"
})(["width:", ";height:", ";", " ", ";"], function (props) {
  return props.theme.clock.analog.size[props.size];
}, function (props) {
  return props.theme.clock.analog.size[props.size];
}, __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return props.theme.clock.analog && props.theme.clock.analog.extend;
});
StyledAnalog.defaultProps = {};
Object.setPrototypeOf(StyledAnalog.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);

var sizeStyle = function sizeStyle(props) {
  // size is a combination of the level and size properties
  var size = props.size || 'medium';
  var data = props.theme.clock.digital.text[size];
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-size:", ";line-height:", ";"], data.size, data.height);
};

var StyledDigitalDigit = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledClock__StyledDigitalDigit",
  componentId: "y4xw8s-4"
})(["position:relative;width:0.8em;text-align:center;overflow:hidden;", ";"], function (props) {
  return sizeStyle(props);
});
StyledDigitalDigit.defaultProps = {};
Object.setPrototypeOf(StyledDigitalDigit.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var previousUp = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateY(0);}100%{transform:translateY(-100%);}"]);
var previousDown = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateY(0);}100%{transform:translateY(100%);}"]);
var StyledDigitalPrevious = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledClock__StyledDigitalPrevious",
  componentId: "y4xw8s-5"
})(["position:absolute;top:0;left:0;width:0.8em;text-align:center;animation:", " 0.5s forwards;"], function (props) {
  return props.direction === 'down' ? previousDown : previousUp;
});
StyledDigitalPrevious.defaultProps = {};
Object.setPrototypeOf(StyledDigitalPrevious.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var nextUp = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateY(100%);}100%{transform:translateY(0);}"]);
var nextDown = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateY(-100%);}100%{transform:translateY(0);}"]);
var StyledDigitalNext = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledClock__StyledDigitalNext",
  componentId: "y4xw8s-6"
})(["position:absolute;top:0;left:0;width:0.8em;text-align:center;animation:", " 0.5s forwards;"], function (props) {
  return props.direction === 'down' ? nextDown : nextUp;
});
StyledDigitalNext.defaultProps = {};
Object.setPrototypeOf(StyledDigitalNext.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableHeader__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableHeader__["a"]; });


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocusedContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(5);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var isNotAncestorOf = function isNotAncestorOf(child) {
  return function (parent) {
    return !parent.contains(child);
  };
};

var FocusedContainer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(FocusedContainer, _Component);

  function FocusedContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ref", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeTrap", function () {
      var restrictScroll = _this.props.restrictScroll;
      var child = _this.ref.current;
      Object(__WEBPACK_IMPORTED_MODULE_2__utils__["r" /* getBodyChildElements */])().filter(isNotAncestorOf(child)).forEach(__WEBPACK_IMPORTED_MODULE_2__utils__["y" /* makeNodeFocusable */]);

      if (restrictScroll) {
        document.body.style.overflow = _this.bodyOverflowStyle;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "trapFocus", function () {
      var restrictScroll = _this.props.restrictScroll;
      var child = _this.ref.current;
      Object(__WEBPACK_IMPORTED_MODULE_2__utils__["r" /* getBodyChildElements */])().filter(isNotAncestorOf(child)).forEach(__WEBPACK_IMPORTED_MODULE_2__utils__["z" /* makeNodeUnfocusable */]);

      if (restrictScroll) {
        _this.bodyOverflowStyle = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
    });

    return _this;
  }

  var _proto = FocusedContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var hidden = this.props.hidden; // making sure trap focus always execute
    // after removeTrap for the case where two drops
    // are open at the same time

    setTimeout(function () {
      if (!hidden) {
        _this2.trapFocus();
      }
    }, 0);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeTrap();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        hidden = _this$props.hidden,
        rest = _objectWithoutPropertiesLoose(_this$props, ["children", "hidden"]);

    delete rest.restrictScroll;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
      ref: this.ref,
      "aria-hidden": hidden
    }, rest), children);
  };

  return FocusedContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(FocusedContainer, "defaultProps", {
  hidden: false,
  restrictScroll: false
});

_defineProperty(FocusedContainer, "propTypes", {
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  restrictScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpanderCellWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TableCell__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(5);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }










var ExpanderCell = function ExpanderCell(_ref) {
  var context = _ref.context,
      expanded = _ref.expanded,
      onToggle = _ref.onToggle,
      theme = _ref.theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["context", "expanded", "onToggle", "theme"]);

  var ExpandIcon = theme.dataTable.icons[expanded ? 'contract' : 'expand'];

  if (onToggle) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TableCell__["a" /* TableCell */], {
      size: "xxsmall",
      plain: true,
      verticalAlign: "top"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* Button */], {
      fill: true,
      a11yTitle: expanded ? 'collapse' : 'expand',
      hoverIndicator: true,
      disabled: !onToggle,
      onClick: onToggle
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], _extends({}, _extends({}, theme.table[context], theme.dataTable[context]), rest, {
      align: "center",
      pad: "xsmall"
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExpandIcon, {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["B" /* normalizeColor */])('border', theme)
    }))));
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TableCell__["a" /* TableCell */], {
    size: "xxsmall",
    verticalAlign: "top"
  });
};

ExpanderCell.defaultProps = {};
Object.setPrototypeOf(ExpanderCell.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var ExpanderCellWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(ExpanderCell);


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableFooter__ = __webpack_require__(445);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableFooter__["a"]; });


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Layer__ = __webpack_require__(468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Layer__["a"]; });


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Paragraph__ = __webpack_require__(475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Paragraph__["a"]; });


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Menu__["a"]; });


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Meter__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Meter__["a"]; });


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledMeter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var roundStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border-radius:", ";"], function (props) {
  return props.theme.global.edgeSize[props.round.size];
}); // overflow: hidden is needed for ie11

var StyledMeter = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].svg.withConfig({
  displayName: "StyledMeter",
  componentId: "nsxarx-0"
})(["max-width:100%;overflow:hidden;", " ", " path{transition:all 0.3s;}", ";"], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return props.round && roundStyle;
}, function (props) {
  return props.theme.meter && props.theme.meter.extend;
});
StyledMeter.defaultProps = {};
Object.setPrototypeOf(StyledMeter.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return strokeProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(5);

var strokeProps = function strokeProps(color, theme) {
  var result = {};

  if (color) {
    if (typeof color === 'object') {
      result.stroke = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["B" /* normalizeColor */])(color.color, theme);

      if (color.opacity) {
        result.strokeOpacity = "" + (color.opacity === true ? theme.global.opacity.medium : theme.global.opacity[color.opacity]);
      }
    } else {
      result.stroke = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["B" /* normalizeColor */])(color, theme);
    }
  }

  return result;
};
var neutralExp = /^neutral-\d+/;
var defaultColor = function defaultColor(index, theme) {
  var neutralColors = Object.keys(theme.global.colors).filter(function (k) {
    return neutralExp.test(k);
  });
  return neutralColors[index % neutralColors.length];
};

/***/ }),
/* 194 */
/***/ (function(module, exports) {

/*
Copyright (c) 2011, Chris Umbel

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = [
  'about', 'after', 'all', 'also', 'am', 'an', 'and', 'another', 'any', 'are', 'as', 'at', 'be',
  'because', 'been', 'before', 'being', 'between', 'both', 'but', 'by', 'came', 'can',
  'come', 'could', 'did', 'do', 'each', 'for', 'from', 'get', 'got', 'has', 'had',
  'he', 'have', 'her', 'here', 'him', 'himself', 'his', 'how', 'if', 'in', 'into',
  'is', 'it', 'like', 'make', 'many', 'me', 'might', 'more', 'most', 'much', 'must',
  'my', 'never', 'now', 'of', 'on', 'only', 'or', 'other', 'our', 'out', 'over',
  'said', 'same', 'see', 'should', 'since', 'some', 'still', 'such', 'take', 'than',
  'that', 'the', 'their', 'them', 'then', 'there', 'these', 'they', 'this', 'those',
  'through', 'to', 'too', 'under', 'up', 'very', 'was', 'way', 'we', 'well', 'were',
  'what', 'where', 'which', 'while', 'who', 'with', 'would', 'you', 'your', 'a', 'i']

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sbd__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sbd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sbd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_style_theme__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_markup__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _templateObject=_taggedTemplateLiteral(['\n  color: ',';\n  background-color: ',';\n'],['\n  color: ',';\n  background-color: ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n  max-width: 100%;\n  hyphens: auto;\n  font-size: 18px;\n  line-height: 24px;\n  max-width: 600px;\n  display: block;\n  margin-top: 1em;\n  margin-bottom: 1em;\n  color: ',';\n'],['\n  max-width: 100%;\n  hyphens: auto;\n  font-size: 18px;\n  line-height: 24px;\n  max-width: 600px;\n  display: block;\n  margin-top: 1em;\n  margin-bottom: 1em;\n  color: ',';\n']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var scrollIntoViewOptions={behavior:'instant',block:'start'};var EvenHighlight=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject,__WEBPACK_IMPORTED_MODULE_5_app_style_theme__["a" /* default */].global.colors.black,__WEBPACK_IMPORTED_MODULE_5_app_style_theme__["a" /* default */].global.colors['accent-4']);var OddHighlight=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject,__WEBPACK_IMPORTED_MODULE_5_app_style_theme__["a" /* default */].global.colors.black,__WEBPACK_IMPORTED_MODULE_5_app_style_theme__["a" /* default */].global.colors['accent-3']);var Paragraph=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject2,function(props){return __WEBPACK_IMPORTED_MODULE_5_app_style_theme__["a" /* default */].global.colors[props.color];});function _onClick(_ref,index,path,sentence){var newBookmarkingSelection=_ref.newBookmarkingSelection;newBookmarkingSelection({path:[].concat(_toConsumableArray(path),[index]),content:sentence});}function HighlightedSentences(_ref2){var AppState=_ref2.AppState,index=_ref2.index,path=_ref2.path,content=_ref2.content,color=_ref2.color;var sentences=__WEBPACK_IMPORTED_MODULE_4_sbd___default.a.sentences(content);var paragraphPath=path;var selectionPath=AppState.bookmarkingSelectionPath.slice();var isParagraphSelected=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(selectionPath,paragraphPath);var isSelectedInParagraph=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.take(selectionPath,paragraphPath.length),paragraphPath);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Paragraph,{color:color},sentences.map(function(sentence,index){var Sentence=void 0;var sentencePath=[].concat(_toConsumableArray(path),[index]);var isSentenceSelected=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(selectionPath,sentencePath);var isEven=index%2===0;if(!isParagraphSelected&&!isSentenceSelected&&isSelectedInParagraph){Sentence=function Sentence(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(){return _onClick(AppState,index,path,sentence);}},__WEBPACK_IMPORTED_MODULE_6_app_api_markup__["a" /* default */].parse(sentence),' ');};}else if(!isParagraphSelected&&!isSentenceSelected){Sentence=function Sentence(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_app_api_markup__["a" /* default */].parse(sentence),' ');};}else if(isParagraphSelected&&!isSentenceSelected){Sentence=function Sentence(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,isEven&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EvenHighlight,{onClick:function onClick(){return _onClick(AppState,index,path,sentence);}},__WEBPACK_IMPORTED_MODULE_6_app_api_markup__["a" /* default */].parse(sentence)),!isEven&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OddHighlight,{onClick:function onClick(){return _onClick(AppState,index,path,sentence);}},__WEBPACK_IMPORTED_MODULE_6_app_api_markup__["a" /* default */].parse(sentence)),' ');};}else if(!isParagraphSelected&&isSentenceSelected){Sentence=function Sentence(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EvenHighlight,{onClick:function onClick(){return _onClick(AppState,index,path,sentence);}},__WEBPACK_IMPORTED_MODULE_6_app_api_markup__["a" /* default */].parse(sentence),' ');};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_scroll_into_view_if_needed__["a" /* default */],{key:path.concat(index),elementType:'span',options:scrollIntoViewOptions,active:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(path.concat(index),AppState.selectedSectionItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Sentence,null));}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(HighlightedSentences)));

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(583);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(45) && !__webpack_require__(69)(function () {
  return Object.defineProperty(__webpack_require__(198)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);
var document = __webpack_require__(38).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(46);
var toIObject = __webpack_require__(55);
var arrayIndexOf = __webpack_require__(585)(false);
var IE_PROTO = __webpack_require__(133)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(201);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 201 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(131);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(92);
var $export = __webpack_require__(52);
var redefine = __webpack_require__(205);
var hide = __webpack_require__(53);
var Iterators = __webpack_require__(138);
var $iterCreate = __webpack_require__(592);
var setToStringTag = __webpack_require__(140);
var getPrototypeOf = __webpack_require__(595);
var ITERATOR = __webpack_require__(56)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(53);


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(199);
var hiddenKeys = __webpack_require__(135).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(94);
var createDesc = __webpack_require__(90);
var toIObject = __webpack_require__(55);
var toPrimitive = __webpack_require__(130);
var has = __webpack_require__(46);
var IE8_DOM_DEFINE = __webpack_require__(197);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(45) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(623), __esModule: true };

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getVisibleRectForElement__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adjustForViewport__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRegion__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getElFuturePos__ = __webpack_require__(634);
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */







// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n = void 0;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  // 当前节点可以被放置的显示区域
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_1__getVisibleRectForElement__["a" /* default */])(source);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/ig, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/ig, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, points, offset, targetOffset);
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      points = align.points;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = Object(__WEBPACK_IMPORTED_MODULE_2__adjustForViewport__["a" /* default */])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'width', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'height', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });

  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}

/* harmony default export */ __webpack_exports__["a"] = (doAlign);
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__ = __webpack_require__(632);




/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(element);
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(el, 'overflow') !== 'visible') {
      var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__["a" /* default */])(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);

    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

/* harmony default export */ __webpack_exports__["a"] = (getVisibleRectForElement);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(47);


/**
 * 得到会导致元素显示不全的祖先元素
 */

function getOffsetParent(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = void 0;
  var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
  }

  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (getOffsetParent);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(47);


function getRegion(node) {
  var offset = void 0;
  var w = void 0;
  var h = void 0;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(node) && node.nodeType !== 9) {
    offset = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(node);
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerWidth(node);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerHeight(node);
  } else {
    var win = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindow(node);
    offset = {
      left: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win),
      top: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win)
    };
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/* harmony default export */ __webpack_exports__["a"] = (getRegion);

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.da4db51e.svg";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.operationReducer = exports.playerReducer = exports.videoActions = exports.playerActions = exports.PlaybackRate = exports.PlaybackRateMenuButton = exports.VolumeMenuButton = exports.TimeDivider = exports.DurationDisplay = exports.CurrentTimeDisplay = exports.RemainingTimeDisplay = exports.MouseTimeDisplay = exports.LoadProgressBar = exports.PlayProgressBar = exports.Slider = exports.SeekBar = exports.ProgressControl = exports.FullscreenToggle = exports.ReplayControl = exports.ForwardControl = exports.PlayToggle = exports.ControlBar = exports.Shortcut = exports.Bezel = exports.PosterImage = exports.LoadingSpinner = exports.BigPlayButton = exports.Video = exports.Player = undefined;

var _Player = __webpack_require__(784);

var _Player2 = _interopRequireDefault(_Player);

var _Video = __webpack_require__(225);

var _Video2 = _interopRequireDefault(_Video);

var _BigPlayButton = __webpack_require__(222);

var _BigPlayButton2 = _interopRequireDefault(_BigPlayButton);

var _LoadingSpinner = __webpack_require__(223);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _PosterImage = __webpack_require__(224);

var _PosterImage2 = _interopRequireDefault(_PosterImage);

var _Slider = __webpack_require__(145);

var _Slider2 = _interopRequireDefault(_Slider);

var _Bezel = __webpack_require__(226);

var _Bezel2 = _interopRequireDefault(_Bezel);

var _Shortcut = __webpack_require__(227);

var _Shortcut2 = _interopRequireDefault(_Shortcut);

var _ControlBar = __webpack_require__(228);

var _ControlBar2 = _interopRequireDefault(_ControlBar);

var _PlayToggle = __webpack_require__(234);

var _PlayToggle2 = _interopRequireDefault(_PlayToggle);

var _ForwardControl = __webpack_require__(235);

var _ForwardControl2 = _interopRequireDefault(_ForwardControl);

var _ReplayControl = __webpack_require__(237);

var _ReplayControl2 = _interopRequireDefault(_ReplayControl);

var _FullscreenToggle = __webpack_require__(238);

var _FullscreenToggle2 = _interopRequireDefault(_FullscreenToggle);

var _ProgressControl = __webpack_require__(229);

var _ProgressControl2 = _interopRequireDefault(_ProgressControl);

var _SeekBar = __webpack_require__(230);

var _SeekBar2 = _interopRequireDefault(_SeekBar);

var _PlayProgressBar = __webpack_require__(231);

var _PlayProgressBar2 = _interopRequireDefault(_PlayProgressBar);

var _LoadProgressBar = __webpack_require__(232);

var _LoadProgressBar2 = _interopRequireDefault(_LoadProgressBar);

var _MouseTimeDisplay = __webpack_require__(233);

var _MouseTimeDisplay2 = _interopRequireDefault(_MouseTimeDisplay);

var _VolumeMenuButton = __webpack_require__(243);

var _VolumeMenuButton2 = _interopRequireDefault(_VolumeMenuButton);

var _PlaybackRateMenuButton = __webpack_require__(146);

var _PlaybackRateMenuButton2 = _interopRequireDefault(_PlaybackRateMenuButton);

var _PlaybackRate = __webpack_require__(797);

var _PlaybackRate2 = _interopRequireDefault(_PlaybackRate);

var _RemainingTimeDisplay = __webpack_require__(239);

var _RemainingTimeDisplay2 = _interopRequireDefault(_RemainingTimeDisplay);

var _CurrentTimeDisplay = __webpack_require__(240);

var _CurrentTimeDisplay2 = _interopRequireDefault(_CurrentTimeDisplay);

var _DurationDisplay = __webpack_require__(241);

var _DurationDisplay2 = _interopRequireDefault(_DurationDisplay);

var _TimeDivider = __webpack_require__(242);

var _TimeDivider2 = _interopRequireDefault(_TimeDivider);

var _player = __webpack_require__(72);

var playerActions = _interopRequireWildcard(_player);

var _video = __webpack_require__(143);

var videoActions = _interopRequireWildcard(_video);

var _reducers = __webpack_require__(220);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Player = _Player2.default;
exports.Video = _Video2.default;
exports.BigPlayButton = _BigPlayButton2.default;
exports.LoadingSpinner = _LoadingSpinner2.default;
exports.PosterImage = _PosterImage2.default;
exports.Bezel = _Bezel2.default;
exports.Shortcut = _Shortcut2.default;
exports.ControlBar = _ControlBar2.default;
exports.PlayToggle = _PlayToggle2.default;
exports.ForwardControl = _ForwardControl2.default;
exports.ReplayControl = _ReplayControl2.default;
exports.FullscreenToggle = _FullscreenToggle2.default;
exports.ProgressControl = _ProgressControl2.default;
exports.SeekBar = _SeekBar2.default;
exports.Slider = _Slider2.default;
exports.PlayProgressBar = _PlayProgressBar2.default;
exports.LoadProgressBar = _LoadProgressBar2.default;
exports.MouseTimeDisplay = _MouseTimeDisplay2.default;
exports.RemainingTimeDisplay = _RemainingTimeDisplay2.default;
exports.CurrentTimeDisplay = _CurrentTimeDisplay2.default;
exports.DurationDisplay = _DurationDisplay2.default;
exports.TimeDivider = _TimeDivider2.default;
exports.VolumeMenuButton = _VolumeMenuButton2.default;
exports.PlaybackRateMenuButton = _PlaybackRateMenuButton2.default;
exports.PlaybackRate = _PlaybackRate2.default;
exports.playerActions = playerActions;
exports.videoActions = videoActions;
exports.playerReducer = _reducers.playerReducer;
exports.operationReducer = _reducers.operationReducer;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.operationReducer = exports.playerReducer = undefined;

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  return {
    player: (0, _player2.default)(state.player, action),
    operation: (0, _operation2.default)(state.operation, action)
  };
};

var _player = __webpack_require__(787);

var _player2 = _interopRequireDefault(_player);

var _operation = __webpack_require__(788);

var _operation2 = _interopRequireDefault(_operation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var playerReducer = exports.playerReducer = _player2.default;
var operationReducer = exports.operationReducer = _operation2.default;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Fullscreen = function () {
  function Fullscreen() {
    _classCallCheck(this, Fullscreen);
  }

  _createClass(Fullscreen, [{
    key: 'request',
    value: function request(elm) {
      if (elm.requestFullscreen) {
        elm.requestFullscreen();
      } else if (elm.webkitRequestFullscreen) {
        elm.webkitRequestFullscreen();
      } else if (elm.mozRequestFullScreen) {
        elm.mozRequestFullScreen();
      } else if (elm.msRequestFullscreen) {
        elm.msRequestFullscreen();
      }
    }
  }, {
    key: 'exit',
    value: function exit() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }, {
    key: 'addEventListener',
    value: function addEventListener(handler) {
      document.addEventListener('fullscreenchange', handler);
      document.addEventListener('webkitfullscreenchange', handler);
      document.addEventListener('mozfullscreenchange', handler);
      document.addEventListener('MSFullscreenChange', handler);
    }
  }, {
    key: 'removeEventListener',
    value: function removeEventListener(handler) {
      document.removeEventListener('fullscreenchange', handler);
      document.removeEventListener('webkitfullscreenchange', handler);
      document.removeEventListener('mozfullscreenchange', handler);
      document.removeEventListener('MSFullscreenChange', handler);
    }
  }, {
    key: 'isFullscreen',
    get: function get() {
      return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    }
  }, {
    key: 'enabled',
    get: function get() {
      return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
    }
  }]);

  return Fullscreen;
}();

exports.default = new Fullscreen();

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  actions: _propTypes2.default.object,
  player: _propTypes2.default.object,
  position: _propTypes2.default.string,
  className: _propTypes2.default.string
};

var defaultProps = {
  position: 'left'
};

var BigPlayButton = function (_Component) {
  _inherits(BigPlayButton, _Component);

  function BigPlayButton(props, context) {
    _classCallCheck(this, BigPlayButton);

    var _this = _possibleConstructorReturn(this, (BigPlayButton.__proto__ || Object.getPrototypeOf(BigPlayButton)).call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(BigPlayButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var actions = this.props.actions;

      actions.play();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          player = _props.player,
          position = _props.position;

      return _react2.default.createElement(
        'button',
        {
          className: (0, _classnames2.default)('video-react-big-play-button', 'video-react-big-play-button-' + position, this.props.className, {
            'big-play-button-hide': player.hasStarted || !player.currentSrc
          }),
          type: 'button',
          'aria-live': 'polite',
          tabIndex: '0',
          onClick: this.handleClick
        },
        _react2.default.createElement(
          'span',
          { className: 'video-react-control-text' },
          'Play Video'
        )
      );
    }
  }]);

  return BigPlayButton;
}(_react.Component);

exports.default = BigPlayButton;


BigPlayButton.propTypes = propTypes;
BigPlayButton.defaultProps = defaultProps;
BigPlayButton.displayName = 'BigPlayButton';

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingSpinner;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _player = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  player: _propTypes2.default.object,
  className: _propTypes2.default.string
};

function LoadingSpinner(_ref) {
  var player = _ref.player,
      className = _ref.className;

  if (player.error) {
    return null;
  }
  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)('video-react-loading-spinner', className)
  });
}

LoadingSpinner.propTypes = propTypes;
LoadingSpinner.displayName = 'LoadingSpinner';

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  poster: _propTypes2.default.string,
  player: _propTypes2.default.object,
  actions: _propTypes2.default.object,
  className: _propTypes2.default.string
};

function PosterImage(_ref) {
  var poster = _ref.poster,
      player = _ref.player,
      actions = _ref.actions,
      className = _ref.className;

  if (!poster || player.hasStarted) {
    return null;
  }

  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)('video-react-poster', className),
    style: {
      backgroundImage: 'url("' + poster + '")'
    },
    onClick: function onClick() {
      if (player.paused) {
        actions.play();
      }
    }
  });
}

PosterImage.propTypes = propTypes;
PosterImage.displayName = 'PosterImage';

exports.default = PosterImage;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  actions: _propTypes2.default.object,
  player: _propTypes2.default.object,
  children: _propTypes2.default.any,
  startTime: _propTypes2.default.number,
  loop: _propTypes2.default.bool,
  muted: _propTypes2.default.bool,
  autoPlay: _propTypes2.default.bool,
  playsInline: _propTypes2.default.bool,
  src: _propTypes2.default.string,
  poster: _propTypes2.default.string,
  className: _propTypes2.default.string,
  preload: _propTypes2.default.oneOf(['auto', 'metadata', 'none']),
  crossOrigin: _propTypes2.default.string,

  onLoadStart: _propTypes2.default.func,
  onWaiting: _propTypes2.default.func,
  onCanPlay: _propTypes2.default.func,
  onCanPlayThrough: _propTypes2.default.func,
  onPlaying: _propTypes2.default.func,
  onEnded: _propTypes2.default.func,
  onSeeking: _propTypes2.default.func,
  onSeeked: _propTypes2.default.func,
  onPlay: _propTypes2.default.func,
  onPause: _propTypes2.default.func,
  onProgress: _propTypes2.default.func,
  onDurationChange: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onSuspend: _propTypes2.default.func,
  onAbort: _propTypes2.default.func,
  onEmptied: _propTypes2.default.func,
  onStalled: _propTypes2.default.func,
  onLoadedMetadata: _propTypes2.default.func,
  onLoadedData: _propTypes2.default.func,
  onTimeUpdate: _propTypes2.default.func,
  onRateChange: _propTypes2.default.func,
  onVolumeChange: _propTypes2.default.func,
  onResize: _propTypes2.default.func
};

var defaultProps = {
  preload: 'auto'
};

var Video = function (_Component) {
  _inherits(Video, _Component);

  function Video(props) {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));

    _this.video = null; // the html5 video
    _this.play = _this.play.bind(_this);
    _this.pause = _this.pause.bind(_this);
    _this.seek = _this.seek.bind(_this);
    _this.forward = _this.forward.bind(_this);
    _this.replay = _this.replay.bind(_this);
    _this.toggleFullscreen = _this.toggleFullscreen.bind(_this);
    _this.getProperties = _this.getProperties.bind(_this);
    _this.renderChildren = _this.renderChildren.bind(_this);
    _this.handleLoadStart = _this.handleLoadStart.bind(_this);
    _this.handleCanPlay = _this.handleCanPlay.bind(_this);
    _this.handleCanPlayThrough = _this.handleCanPlayThrough.bind(_this);
    _this.handlePlay = _this.handlePlay.bind(_this);
    _this.handlePlaying = _this.handlePlaying.bind(_this);
    _this.handlePause = _this.handlePause.bind(_this);
    _this.handleEnded = _this.handleEnded.bind(_this);
    _this.handleWaiting = _this.handleWaiting.bind(_this);
    _this.handleSeeking = _this.handleSeeking.bind(_this);
    _this.handleSeeked = _this.handleSeeked.bind(_this);
    _this.handleFullscreenChange = _this.handleFullscreenChange.bind(_this);
    _this.handleError = _this.handleError.bind(_this);
    _this.handleSuspend = _this.handleSuspend.bind(_this);
    _this.handleAbort = _this.handleAbort.bind(_this);
    _this.handleEmptied = _this.handleEmptied.bind(_this);
    _this.handleStalled = _this.handleStalled.bind(_this);
    _this.handleLoadedMetaData = _this.handleLoadedMetaData.bind(_this);
    _this.handleLoadedData = _this.handleLoadedData.bind(_this);
    _this.handleTimeUpdate = _this.handleTimeUpdate.bind(_this);
    _this.handleRateChange = _this.handleRateChange.bind(_this);
    _this.handleVolumeChange = _this.handleVolumeChange.bind(_this);
    _this.handleDurationChange = _this.handleDurationChange.bind(_this);
    _this.handleProgress = (0, _utils.throttle)(_this.handleProgress.bind(_this), 250);
    _this.handleKeypress = _this.handleKeypress.bind(_this);
    return _this;
  }

  _createClass(Video, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.forceUpdate(); // make sure the children can get the video property
    }

    // get all video properties

  }, {
    key: 'getProperties',
    value: function getProperties() {
      var _this2 = this;

      if (!this.video) {
        return null;
      }

      return _utils.mediaProperties.reduce(function (properties, key) {
        properties[key] = _this2.video[key];
        return properties;
      }, {});
    }

    // get playback rate

  }, {
    key: 'play',


    // play the video
    value: function play() {
      var promise = this.video.play();
      if (promise !== undefined) {
        promise.catch(function (error) {}).then(function () {});
      }
    }

    // pause the video

  }, {
    key: 'pause',
    value: function pause() {
      var promise = this.video.pause();
      if (promise !== undefined) {
        promise.catch(function (error) {}).then(function () {});
      }
    }

    // Change the video source and re-load the video:

  }, {
    key: 'load',
    value: function load() {
      this.video.load();
    }

    // Add a new text track to the video

  }, {
    key: 'addTextTrack',
    value: function addTextTrack() {
      var _video;

      (_video = this.video).addTextTrack.apply(_video, arguments);
    }

    // Check if your browser can play different types of video:

  }, {
    key: 'canPlayType',
    value: function canPlayType() {
      var _video2;

      (_video2 = this.video).canPlayType.apply(_video2, arguments);
    }

    // toggle play

  }, {
    key: 'togglePlay',
    value: function togglePlay() {
      if (this.video.paused) {
        this.play();
      } else {
        this.pause();
      }
    }

    // seek video by time

  }, {
    key: 'seek',
    value: function seek(time) {
      try {
        this.video.currentTime = time;
      } catch (e) {
        // console.log(e, 'Video is not ready.')
      }
    }

    // jump forward x seconds

  }, {
    key: 'forward',
    value: function forward(seconds) {
      this.seek(this.video.currentTime + seconds);
    }

    // jump back x seconds

  }, {
    key: 'replay',
    value: function replay(seconds) {
      this.forward(-seconds);
    }

    // enter or exist full screen

  }, {
    key: 'toggleFullscreen',
    value: function toggleFullscreen() {
      var _props = this.props,
          player = _props.player,
          actions = _props.actions;

      actions.toggleFullscreen(player);
    }

    // Fired when the user agent
    // begins looking for media data

  }, {
    key: 'handleLoadStart',
    value: function handleLoadStart() {
      var _props2 = this.props,
          actions = _props2.actions,
          onLoadStart = _props2.onLoadStart;

      actions.handleLoadStart(this.getProperties());
      if (onLoadStart) {
        onLoadStart.apply(undefined, arguments);
      }
    }

    // A handler for events that
    // signal that waiting has ended

  }, {
    key: 'handleCanPlay',
    value: function handleCanPlay() {
      var _props3 = this.props,
          actions = _props3.actions,
          onCanPlay = _props3.onCanPlay;


      actions.handleCanPlay(this.getProperties());

      if (onCanPlay) {
        onCanPlay.apply(undefined, arguments);
      }
    }

    // A handler for events that
    // signal that waiting has ended

  }, {
    key: 'handleCanPlayThrough',
    value: function handleCanPlayThrough() {
      var _props4 = this.props,
          actions = _props4.actions,
          onCanPlayThrough = _props4.onCanPlayThrough;

      actions.handleCanPlayThrough(this.getProperties());

      if (onCanPlayThrough) {
        onCanPlayThrough.apply(undefined, arguments);
      }
    }

    // A handler for events that
    // signal that waiting has ended

  }, {
    key: 'handlePlaying',
    value: function handlePlaying() {
      var _props5 = this.props,
          actions = _props5.actions,
          onPlaying = _props5.onPlaying;

      actions.handlePlaying(this.getProperties());

      if (onPlaying) {
        onPlaying.apply(undefined, arguments);
      }
    }

    // Fired whenever the media has been started

  }, {
    key: 'handlePlay',
    value: function handlePlay() {
      var _props6 = this.props,
          actions = _props6.actions,
          onPlay = _props6.onPlay;

      actions.handlePlay(this.getProperties());

      if (onPlay) {
        onPlay.apply(undefined, arguments);
      }
    }

    // Fired whenever the media has been paused

  }, {
    key: 'handlePause',
    value: function handlePause() {
      var _props7 = this.props,
          actions = _props7.actions,
          onPause = _props7.onPause;

      actions.handlePause(this.getProperties());

      if (onPause) {
        onPause.apply(undefined, arguments);
      }
    }

    // Fired when the duration of
    // the media resource is first known or changed

  }, {
    key: 'handleDurationChange',
    value: function handleDurationChange() {
      var _props8 = this.props,
          actions = _props8.actions,
          onDurationChange = _props8.onDurationChange;

      actions.handleDurationChange(this.getProperties());

      if (onDurationChange) {
        onDurationChange.apply(undefined, arguments);
      }
    }

    // Fired while the user agent
    // is downloading media data

  }, {
    key: 'handleProgress',
    value: function handleProgress() {
      var _props9 = this.props,
          actions = _props9.actions,
          onProgress = _props9.onProgress;

      if (this.video) {
        actions.handleProgressChange(this.getProperties());
      }

      if (onProgress) {
        onProgress.apply(undefined, arguments);
      }
    }

    // Fired when the end of the media resource
    // is reached (currentTime == duration)

  }, {
    key: 'handleEnded',
    value: function handleEnded() {
      var _props10 = this.props,
          loop = _props10.loop,
          player = _props10.player,
          actions = _props10.actions,
          onEnded = _props10.onEnded;

      if (loop) {
        this.seek(0);
        this.play();
      } else if (!player.paused) {
        this.pause();
      }
      actions.handleEnd(this.getProperties());

      if (onEnded) {
        onEnded.apply(undefined, arguments);
      }
    }

    // Fired whenever the media begins waiting

  }, {
    key: 'handleWaiting',
    value: function handleWaiting() {
      var _props11 = this.props,
          actions = _props11.actions,
          onWaiting = _props11.onWaiting;

      actions.handleWaiting(this.getProperties());

      if (onWaiting) {
        onWaiting.apply(undefined, arguments);
      }
    }

    // Fired whenever the player
    // is jumping to a new time

  }, {
    key: 'handleSeeking',
    value: function handleSeeking() {
      var _props12 = this.props,
          actions = _props12.actions,
          onSeeking = _props12.onSeeking;

      actions.handleSeeking(this.getProperties());

      if (onSeeking) {
        onSeeking.apply(undefined, arguments);
      }
    }

    // Fired when the player has
    // finished jumping to a new time

  }, {
    key: 'handleSeeked',
    value: function handleSeeked() {
      var _props13 = this.props,
          actions = _props13.actions,
          onSeeked = _props13.onSeeked;

      actions.handleSeeked(this.getProperties());

      if (onSeeked) {
        onSeeked.apply(undefined, arguments);
      }
    }

    // Handle Fullscreen Change

  }, {
    key: 'handleFullscreenChange',
    value: function handleFullscreenChange() {}

    // Fires when the browser is
    // intentionally not getting media data

  }, {
    key: 'handleSuspend',
    value: function handleSuspend() {
      var _props14 = this.props,
          actions = _props14.actions,
          onSuspend = _props14.onSuspend;

      actions.handleSuspend(this.getProperties());
      if (onSuspend) {
        onSuspend.apply(undefined, arguments);
      }
    }

    // Fires when the loading of an audio/video is aborted

  }, {
    key: 'handleAbort',
    value: function handleAbort() {
      var _props15 = this.props,
          actions = _props15.actions,
          onAbort = _props15.onAbort;

      actions.handleAbort(this.getProperties());
      if (onAbort) {
        onAbort.apply(undefined, arguments);
      }
    }

    // Fires when the current playlist is empty

  }, {
    key: 'handleEmptied',
    value: function handleEmptied() {
      var _props16 = this.props,
          actions = _props16.actions,
          onEmptied = _props16.onEmptied;

      actions.handleEmptied(this.getProperties());
      if (onEmptied) {
        onEmptied.apply(undefined, arguments);
      }
    }

    // Fires when the browser is trying to
    // get media data, but data is not available

  }, {
    key: 'handleStalled',
    value: function handleStalled() {
      var _props17 = this.props,
          actions = _props17.actions,
          onStalled = _props17.onStalled;

      actions.handleStalled(this.getProperties());

      if (onStalled) {
        onStalled.apply(undefined, arguments);
      }
    }

    // Fires when the browser has loaded
    // meta data for the audio/video

  }, {
    key: 'handleLoadedMetaData',
    value: function handleLoadedMetaData() {
      var _props18 = this.props,
          actions = _props18.actions,
          onLoadedMetadata = _props18.onLoadedMetadata,
          startTime = _props18.startTime;


      if (startTime && startTime > 0) {
        this.video.currentTime = startTime;
      }

      actions.handleLoadedMetaData(this.getProperties());

      if (onLoadedMetadata) {
        onLoadedMetadata.apply(undefined, arguments);
      }
    }

    // Fires when the browser has loaded
    // the current frame of the audio/video

  }, {
    key: 'handleLoadedData',
    value: function handleLoadedData() {
      var _props19 = this.props,
          actions = _props19.actions,
          onLoadedData = _props19.onLoadedData;

      actions.handleLoadedData(this.getProperties());

      if (onLoadedData) {
        onLoadedData.apply(undefined, arguments);
      }
    }

    // Fires when the current
    // playback position has changed

  }, {
    key: 'handleTimeUpdate',
    value: function handleTimeUpdate() {
      var _props20 = this.props,
          actions = _props20.actions,
          onTimeUpdate = _props20.onTimeUpdate;

      actions.handleTimeUpdate(this.getProperties());

      if (onTimeUpdate) {
        onTimeUpdate.apply(undefined, arguments);
      }
    }

    /**
     * Fires when the playing speed of the audio/video is changed
     */

  }, {
    key: 'handleRateChange',
    value: function handleRateChange() {
      var _props21 = this.props,
          actions = _props21.actions,
          onRateChange = _props21.onRateChange;

      actions.handleRateChange(this.getProperties());

      if (onRateChange) {
        onRateChange.apply(undefined, arguments);
      }
    }

    // Fires when the volume has been changed

  }, {
    key: 'handleVolumeChange',
    value: function handleVolumeChange() {
      var _props22 = this.props,
          actions = _props22.actions,
          onVolumeChange = _props22.onVolumeChange;

      actions.handleVolumeChange(this.getProperties());

      if (onVolumeChange) {
        onVolumeChange.apply(undefined, arguments);
      }
    }

    // Fires when an error occurred
    // during the loading of an audio/video

  }, {
    key: 'handleError',
    value: function handleError() {
      var _props23 = this.props,
          actions = _props23.actions,
          onError = _props23.onError;

      actions.handleError(this.getProperties());
      if (onError) {
        onError.apply(undefined, arguments);
      }
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      var _props24 = this.props,
          actions = _props24.actions,
          onResize = _props24.onResize;

      actions.handleResize(this.getProperties());
      if (onResize) {
        onResize.apply(undefined, arguments);
      }
    }
  }, {
    key: 'handleKeypress',
    value: function handleKeypress() {}
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _this3 = this;

      var props = _extends({}, this.props, {
        video: this.video
      });

      // to make sure the children can get video property
      if (!this.video) {
        return null;
      }

      // only keep <source />, <track />, <MyComponent isVideoChild /> elements
      return _react2.default.Children.toArray(this.props.children).filter(_utils.isVideoChild).map(function (c) {
        var cprops = void 0;
        if (typeof c.type === 'string') {
          // add onError to <source />
          if (c.type === 'source') {
            cprops = _extends({}, c.props);
            var preOnError = cprops.onError;
            cprops.onError = function () {
              if (preOnError) {
                preOnError.apply(undefined, arguments);
              }
              _this3.handleError.apply(_this3, arguments);
            };
          }
        } else {
          cprops = props;
        }
        return _react2.default.cloneElement(c, cprops);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props25 = this.props,
          loop = _props25.loop,
          poster = _props25.poster,
          preload = _props25.preload,
          src = _props25.src,
          autoPlay = _props25.autoPlay,
          playsInline = _props25.playsInline,
          muted = _props25.muted,
          crossOrigin = _props25.crossOrigin,
          videoId = _props25.videoId;


      return _react2.default.createElement(
        'video',
        {
          className: (0, _classnames2.default)('video-react-video', this.props.className),
          id: videoId,
          crossOrigin: crossOrigin,
          ref: function ref(c) {
            _this4.video = c;
          },
          muted: muted,
          preload: preload,
          loop: loop,
          playsInline: playsInline,
          autoPlay: autoPlay,
          poster: poster,
          src: src,
          onLoadStart: this.handleLoadStart,
          onWaiting: this.handleWaiting,
          onCanPlay: this.handleCanPlay,
          onCanPlayThrough: this.handleCanPlayThrough,
          onPlaying: this.handlePlaying,
          onEnded: this.handleEnded,
          onSeeking: this.handleSeeking,
          onSeeked: this.handleSeeked,
          onPlay: this.handlePlay,
          onPause: this.handlePause,
          onProgress: this.handleProgress,
          onDurationChange: this.handleDurationChange,
          onError: this.handleError,
          onSuspend: this.handleSuspend,
          onAbort: this.handleAbort,
          onEmptied: this.handleEmptied,
          onStalled: this.handleStalled,
          onLoadedMetadata: this.handleLoadedMetaData,
          onLoadedData: this.handleLoadedData,
          onTimeUpdate: this.handleTimeUpdate,
          onRateChange: this.handleRateChange,
          onVolumeChange: this.handleVolumeChange
        },
        this.renderChildren()
      );
    }
  }, {
    key: 'playbackRate',
    get: function get() {
      return this.video.playbackRate;
    }

    // set playback rate
    // speed of video
    ,
    set: function set(rate) {
      this.video.playbackRate = rate;
    }
  }, {
    key: 'muted',
    get: function get() {
      return this.video.muted;
    },
    set: function set(val) {
      this.video.muted = val;
    }
  }, {
    key: 'volume',
    get: function get() {
      return this.video.volume;
    },
    set: function set(val) {
      if (val > 1) {
        val = 1;
      }
      if (val < 0) {
        val = 0;
      }
      this.video.volume = val;
    }

    // video width

  }, {
    key: 'videoWidth',
    get: function get() {
      return this.video.videoWidth;
    }

    // video height

  }, {
    key: 'videoHeight',
    get: function get() {
      return this.video.videoHeight;
    }
  }]);

  return Video;
}(_react.Component);

exports.default = Video;


Video.propTypes = propTypes;
Video.defaultProps = defaultProps;
Video.displayName = 'Video';

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  manager: _propTypes2.default.object,
  className: _propTypes2.default.string
};

var Bezel = function (_Component) {
  _inherits(Bezel, _Component);

  function Bezel(props, context) {
    _classCallCheck(this, Bezel);

    var _this = _possibleConstructorReturn(this, (Bezel.__proto__ || Object.getPrototypeOf(Bezel)).call(this, props, context));

    _this.timer = null;
    props.manager.subscribeToOperationStateChange(_this.handleStateChange.bind(_this));

    _this.state = {
      hidden: true,
      operation: {}
    };
    return _this;
  }

  _createClass(Bezel, [{
    key: 'handleStateChange',
    value: function handleStateChange(state, prevState) {
      var _this2 = this;

      if (state.count !== prevState.count && state.operation.source === 'shortcut') {
        if (this.timer) {
          // previous animation is not finished
          clearTimeout(this.timer); // cancel it
          this.timer = null;
        }

        // show it
        // update operation
        this.setState({
          hidden: false,
          count: state.count,
          operation: state.operation
        });

        // hide it after 0.5s
        this.timer = setTimeout(function () {
          _this2.setState({
            hidden: true
          });
          _this2.timer = null;
        }, 500);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      // only displays for shortcut so far
      if (this.state.operation.source !== 'shortcut') {
        return null;
      }
      var style = this.state.hidden ? {
        display: 'none'
      } : null;

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)({
            'video-react-bezel': true,
            'video-react-bezel-animation': this.state.count % 2 === 0,
            'video-react-bezel-animation-alt': this.state.count % 2 === 1
          }, this.props.className),
          style: style,
          role: 'status',
          'aria-label': this.state.operation.action
        },
        _react2.default.createElement('div', {
          className: (0, _classnames2.default)('video-react-bezel-icon', 'video-react-bezel-icon-' + this.state.operation.action)
        })
      );
    }
  }]);

  return Bezel;
}(_react.Component);

exports.default = Bezel;


Bezel.propTypes = propTypes;
Bezel.displayName = 'Bezel';

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dom = __webpack_require__(144);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  clickable: _propTypes2.default.bool,
  dblclickable: _propTypes2.default.bool,
  manager: _propTypes2.default.object,
  actions: _propTypes2.default.object,
  player: _propTypes2.default.object,
  shortcuts: _propTypes2.default.array
};

var defaultProps = {
  clickable: true,
  dblclickable: true
};

var Shortcut = function (_Component) {
  _inherits(Shortcut, _Component);

  function Shortcut(props, context) {
    _classCallCheck(this, Shortcut);

    var _this = _possibleConstructorReturn(this, (Shortcut.__proto__ || Object.getPrototypeOf(Shortcut)).call(this, props, context));

    _this.defaultShortcuts = [{
      keyCode: 32, // spacebar
      handle: _this.togglePlay
    }, {
      keyCode: 75, // k
      handle: _this.togglePlay
    }, {
      keyCode: 70, // f
      handle: _this.toggleFullscreen
    }, {
      keyCode: 37, // Left arrow
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }
        actions.replay(5, {
          action: 'replay-5',
          source: 'shortcut'
        }); // Go back 5 seconds
      }
    }, {
      keyCode: 74, // j
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }
        actions.replay(10, {
          action: 'replay-10',
          source: 'shortcut'
        }); // Go back 10 seconds
      }
    }, {
      keyCode: 39, // Right arrow
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }
        actions.forward(5, {
          action: 'forward-5',
          source: 'shortcut'
        }); // Go forward 5 seconds
      }
    }, {
      keyCode: 76, // l
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }
        actions.forward(10, {
          action: 'forward-10',
          source: 'shortcut'
        }); // Go forward 10 seconds
      }
    }, {
      keyCode: 36, // Home
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }
        actions.seek(0); // Go to beginning of video
      }
    }, {
      keyCode: 35, // End
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }
        // Go to end of video
        actions.seek(player.duration);
      }
    }, {
      keyCode: 38, // Up arrow
      handle: function handle(player, actions) {
        // Increase volume 5%
        var v = player.volume + 0.05;
        if (v > 1) {
          v = 1;
        }
        actions.changeVolume(v, {
          action: 'volume-up',
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 40, // Down arrow
      handle: function handle(player, actions) {
        // Decrease volume 5%
        var v = player.volume - 0.05;
        if (v < 0) {
          v = 0;
        }
        var action = v > 0 ? 'volume-down' : 'volume-off';
        actions.changeVolume(v, {
          action: action,
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 190, // Shift + >
      shift: true,
      handle: function handle(player, actions) {
        // Increase speed
        var playbackRate = player.playbackRate;
        if (playbackRate >= 1.5) {
          playbackRate = 2;
        } else if (playbackRate >= 1.25) {
          playbackRate = 1.5;
        } else if (playbackRate >= 1.0) {
          playbackRate = 1.25;
        } else if (playbackRate >= 0.5) {
          playbackRate = 1.0;
        } else if (playbackRate >= 0.25) {
          playbackRate = 0.5;
        } else if (playbackRate >= 0) {
          playbackRate = 0.25;
        }
        actions.changeRate(playbackRate, {
          action: 'fast-forward',
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 188, // Shift + <
      shift: true,
      handle: function handle(player, actions) {
        // Decrease speed
        var playbackRate = player.playbackRate;
        if (playbackRate <= 0.5) {
          playbackRate = 0.25;
        } else if (playbackRate <= 1.0) {
          playbackRate = 0.5;
        } else if (playbackRate <= 1.25) {
          playbackRate = 1.0;
        } else if (playbackRate <= 1.5) {
          playbackRate = 1.25;
        } else if (playbackRate <= 2) {
          playbackRate = 1.5;
        }
        actions.changeRate(playbackRate, {
          action: 'fast-rewind',
          source: 'shortcut'
        });
      }
    }];

    _this.shortcuts = [].concat(_toConsumableArray(_this.defaultShortcuts));

    _this.mergeShortcuts = _this.mergeShortcuts.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleDoubleClick = _this.handleDoubleClick.bind(_this);
    return _this;
  }

  _createClass(Shortcut, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mergeShortcuts();
      document.addEventListener('keydown', this.handleKeyPress);
      document.addEventListener('click', this.handleClick);
      document.addEventListener('dblclick', this.handleDoubleClick);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.shortcuts !== this.props.shortcuts) {
        this.mergeShortcuts();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyPress);
      document.removeEventListener('click', this.handleClick);
      document.removeEventListener('dblclick', this.handleDoubleClick);
    }

    // merge the shortcuts from props

  }, {
    key: 'mergeShortcuts',
    value: function mergeShortcuts() {
      var getShortcutKey = function getShortcutKey(_ref) {
        var _ref$keyCode = _ref.keyCode,
            keyCode = _ref$keyCode === undefined ? 0 : _ref$keyCode,
            _ref$ctrl = _ref.ctrl,
            ctrl = _ref$ctrl === undefined ? false : _ref$ctrl,
            _ref$shift = _ref.shift,
            shift = _ref$shift === undefined ? false : _ref$shift,
            _ref$alt = _ref.alt,
            alt = _ref$alt === undefined ? false : _ref$alt;
        return keyCode + ':' + ctrl + ':' + shift + ':' + alt;
      };
      var defaultShortcuts = this.defaultShortcuts.reduce(function (shortcuts, shortcut) {
        return Object.assign(shortcuts, _defineProperty({}, getShortcutKey(shortcut), shortcut));
      }, {});
      var mergedShortcuts = (this.props.shortcuts || []).reduce(function (shortcuts, shortcut) {
        var keyCode = shortcut.keyCode,
            handle = shortcut.handle;

        if (keyCode && typeof handle === 'function') {
          return Object.assign(shortcuts, _defineProperty({}, getShortcutKey(shortcut), shortcut));
        }
        return shortcuts;
      }, defaultShortcuts);

      var gradeShortcut = function gradeShortcut(s) {
        var score = 0;
        var ps = ['ctrl', 'shift', 'alt'];
        ps.forEach(function (key) {
          if (s[key]) {
            score++;
          }
        });
        return score;
      };

      this.shortcuts = Object.keys(mergedShortcuts).map(function (key) {
        return mergedShortcuts[key];
      }).sort(function (a, b) {
        return gradeShortcut(b) - gradeShortcut(a);
      });
    }
  }, {
    key: 'togglePlay',
    value: function togglePlay(player, actions) {
      if (player.paused) {
        actions.play({
          action: 'play',
          source: 'shortcut'
        });
      } else {
        actions.pause({
          action: 'pause',
          source: 'shortcut'
        });
      }
    }
  }, {
    key: 'toggleFullscreen',
    value: function toggleFullscreen(player, actions) {
      actions.toggleFullscreen(player);
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(e) {
      var _props = this.props,
          player = _props.player,
          actions = _props.actions;

      if (!player.isActive) {
        return;
      }
      if (document.activeElement && ((0, _dom.hasClass)(document.activeElement, 'video-react-control') || (0, _dom.hasClass)(document.activeElement, 'video-react-menu-button-active')
      // || hasClass(document.activeElement, 'video-react-slider')
      || (0, _dom.hasClass)(document.activeElement, 'video-react-big-play-button'))) {
        return;
      }

      var keyCode = e.keyCode || e.which;
      var ctrl = e.ctrlKey || e.metaKey;
      var shift = e.shiftKey;
      var alt = e.altKey;

      var shortcut = this.shortcuts.filter(function (s) {
        if (!s.keyCode || s.keyCode - keyCode !== 0) {
          return false;
        }
        if (s.ctrl !== undefined && s.ctrl !== ctrl || s.shift !== undefined && s.shift !== shift || s.alt !== undefined && s.alt !== alt) {
          return false;
        }
        return true;
      })[0];

      if (shortcut) {
        shortcut.handle(player, actions);
        e.preventDefault();
      }
    }

    // only if player is active and player is ready

  }, {
    key: 'canBeClicked',
    value: function canBeClicked(player, e) {
      if (!player.isActive || e.target.nodeName !== 'VIDEO' || player.readyState !== 4) {
        return false;
      }
      return true;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var _props2 = this.props,
          player = _props2.player,
          actions = _props2.actions,
          clickable = _props2.clickable;

      if (!this.canBeClicked(player, e) || !clickable) {
        return;
      }
      this.togglePlay(player, actions);
      // e.preventDefault();
    }
  }, {
    key: 'handleDoubleClick',
    value: function handleDoubleClick(e) {
      var _props3 = this.props,
          player = _props3.player,
          actions = _props3.actions,
          dblclickable = _props3.dblclickable;

      if (!this.canBeClicked(player, e) || !dblclickable) {
        return;
      }
      this.toggleFullscreen(player, actions);
      // e.preventDefault();
    }

    // this component dose not render anything
    // it's just for the key down event

  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Shortcut;
}(_react.Component);

exports.default = Shortcut;


Shortcut.propTypes = propTypes;
Shortcut.defaultProps = defaultProps;
Shortcut.displayName = 'Shortcut';

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _ProgressControl = __webpack_require__(229);

var _ProgressControl2 = _interopRequireDefault(_ProgressControl);

var _PlayToggle = __webpack_require__(234);

var _PlayToggle2 = _interopRequireDefault(_PlayToggle);

var _ForwardControl = __webpack_require__(235);

var _ForwardControl2 = _interopRequireDefault(_ForwardControl);

var _ReplayControl = __webpack_require__(237);

var _ReplayControl2 = _interopRequireDefault(_ReplayControl);

var _FullscreenToggle = __webpack_require__(238);

var _FullscreenToggle2 = _interopRequireDefault(_FullscreenToggle);

var _RemainingTimeDisplay = __webpack_require__(239);

var _RemainingTimeDisplay2 = _interopRequireDefault(_RemainingTimeDisplay);

var _CurrentTimeDisplay = __webpack_require__(240);

var _CurrentTimeDisplay2 = _interopRequireDefault(_CurrentTimeDisplay);

var _DurationDisplay = __webpack_require__(241);

var _DurationDisplay2 = _interopRequireDefault(_DurationDisplay);

var _TimeDivider = __webpack_require__(242);

var _TimeDivider2 = _interopRequireDefault(_TimeDivider);

var _VolumeMenuButton = __webpack_require__(243);

var _VolumeMenuButton2 = _interopRequireDefault(_VolumeMenuButton);

var _PlaybackRateMenuButton = __webpack_require__(146);

var _PlaybackRateMenuButton2 = _interopRequireDefault(_PlaybackRateMenuButton);

var _utils = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.any,
  autoHide: _propTypes2.default.bool,
  disableDefaultControls: _propTypes2.default.bool,
  disableCompletely: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

var defaultProps = {
  autoHide: true,
  disableCompletely: false
};

var ControlBar = function (_Component) {
  _inherits(ControlBar, _Component);

  function ControlBar(props) {
    _classCallCheck(this, ControlBar);

    var _this = _possibleConstructorReturn(this, (ControlBar.__proto__ || Object.getPrototypeOf(ControlBar)).call(this, props));

    _this.getDefaultChildren = _this.getDefaultChildren.bind(_this);
    _this.getFullChildren = _this.getFullChildren.bind(_this);
    return _this;
  }

  _createClass(ControlBar, [{
    key: 'getDefaultChildren',
    value: function getDefaultChildren() {
      return [_react2.default.createElement(_PlayToggle2.default, _extends({}, this.props, {
        key: 'play-toggle',
        order: 1
      })), _react2.default.createElement(_VolumeMenuButton2.default, _extends({}, this.props, {
        key: 'volume-menu-button',
        order: 4
      })), _react2.default.createElement(_CurrentTimeDisplay2.default, _extends({}, this.props, {
        key: 'current-time-display',
        order: 5.1
      })), _react2.default.createElement(_TimeDivider2.default, _extends({}, this.props, {
        key: 'time-divider',
        order: 5.2
      })), _react2.default.createElement(_DurationDisplay2.default, _extends({}, this.props, {
        key: 'duration-display',
        order: 5.3
      })), _react2.default.createElement(_ProgressControl2.default, _extends({}, this.props, {
        key: 'progress-control',
        order: 6
      })), _react2.default.createElement(_FullscreenToggle2.default, _extends({}, this.props, {
        key: 'fullscreen-toggle',
        order: 8
      }))];
    }
  }, {
    key: 'getFullChildren',
    value: function getFullChildren() {
      return [_react2.default.createElement(_PlayToggle2.default, _extends({}, this.props, {
        key: 'play-toggle',
        order: 1
      })), _react2.default.createElement(_ReplayControl2.default, _extends({}, this.props, {
        key: 'replay-control',
        order: 2
      })), _react2.default.createElement(_ForwardControl2.default, _extends({}, this.props, {
        key: 'forward-control',
        order: 3
      })), _react2.default.createElement(_VolumeMenuButton2.default, _extends({}, this.props, {
        key: 'volume-menu-button',
        order: 4
      })), _react2.default.createElement(_CurrentTimeDisplay2.default, _extends({}, this.props, {
        key: 'current-time-display',
        order: 5
      })), _react2.default.createElement(_TimeDivider2.default, _extends({}, this.props, {
        key: 'time-divider',
        order: 6
      })), _react2.default.createElement(_DurationDisplay2.default, _extends({}, this.props, {
        key: 'duration-display',
        order: 7
      })), _react2.default.createElement(_ProgressControl2.default, _extends({}, this.props, {
        key: 'progress-control',
        order: 8
      })), _react2.default.createElement(_RemainingTimeDisplay2.default, _extends({}, this.props, {
        key: 'remaining-time-display',
        order: 9
      })), _react2.default.createElement(_PlaybackRateMenuButton2.default, _extends({}, this.props, {
        rates: [1, 1.25, 1.5, 2],
        key: 'playback-rate',
        order: 10
      })), _react2.default.createElement(_FullscreenToggle2.default, _extends({}, this.props, {
        key: 'fullscreen-toggle',
        order: 11
      }))];
    }
  }, {
    key: 'getChildren',
    value: function getChildren() {
      var children = _react2.default.Children.toArray(this.props.children);
      var defaultChildren = this.props.disableDefaultControls ? [] : this.getDefaultChildren();
      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoHide = _props.autoHide,
          className = _props.className,
          disableCompletely = _props.disableCompletely;

      var children = this.getChildren();

      return disableCompletely ? null : _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('video-react-control-bar', {
            'video-react-control-bar-auto-hide': autoHide
          }, className)
        },
        children
      );
    }
  }]);

  return ControlBar;
}(_react.Component);

exports.default = ControlBar;


ControlBar.propTypes = propTypes;
ControlBar.defaultProps = defaultProps;
ControlBar.displayName = 'ControlBar';

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _dom = __webpack_require__(144);

var Dom = _interopRequireWildcard(_dom);

var _SeekBar = __webpack_require__(230);

var _SeekBar2 = _interopRequireDefault(_SeekBar);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  player: _propTypes2.default.object,
  className: _propTypes2.default.string
};

var ProgressControl = function (_Component) {
  _inherits(ProgressControl, _Component);

  function ProgressControl(props, context) {
    _classCallCheck(this, ProgressControl);

    var _this = _possibleConstructorReturn(this, (ProgressControl.__proto__ || Object.getPrototypeOf(ProgressControl)).call(this, props, context));

    _this.state = {
      mouseTime: {
        time: null,
        position: 0
      }
    };

    _this.handleMouseMoveThrottle = _this.handleMouseMove.bind(_this);
    return _this;
  }

  _createClass(ProgressControl, [{
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      if (!event.pageX) {
        return;
      }
      var duration = this.props.player.duration;

      var node = (0, _reactDom.findDOMNode)(this.seekBar);
      var newTime = Dom.getPointerPosition(node, event).x * duration;
      var position = event.pageX - Dom.findElPosition(node).left;

      this.setState({
        mouseTime: {
          time: newTime,
          position: position
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var className = this.props.className;

      return _react2.default.createElement(
        'div',
        {
          onMouseMove: this.handleMouseMoveThrottle,
          className: (0, _classnames2.default)('video-react-progress-control video-react-control', className)
        },
        _react2.default.createElement(_SeekBar2.default, _extends({
          mouseTime: this.state.mouseTime,
          ref: function ref(c) {
            _this2.seekBar = c;
          }
        }, this.props))
      );
    }
  }]);

  return ProgressControl;
}(_react.Component);

exports.default = ProgressControl;


ProgressControl.propTypes = propTypes;
ProgressControl.displayName = 'ProgressControl';

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Slider = __webpack_require__(145);

var _Slider2 = _interopRequireDefault(_Slider);

var _PlayProgressBar = __webpack_require__(231);

var _PlayProgressBar2 = _interopRequireDefault(_PlayProgressBar);

var _LoadProgressBar = __webpack_require__(232);

var _LoadProgressBar2 = _interopRequireDefault(_LoadProgressBar);

var _MouseTimeDisplay = __webpack_require__(233);

var _MouseTimeDisplay2 = _interopRequireDefault(_MouseTimeDisplay);

var _utils = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  player: _propTypes2.default.object,
  mouseTime: _propTypes2.default.object,
  actions: _propTypes2.default.object,
  className: _propTypes2.default.string
};

var SeekBar = function (_Component) {
  _inherits(SeekBar, _Component);

  function SeekBar(props, context) {
    _classCallCheck(this, SeekBar);

    var _this = _possibleConstructorReturn(this, (SeekBar.__proto__ || Object.getPrototypeOf(SeekBar)).call(this, props, context));

    _this.getPercent = _this.getPercent.bind(_this);
    _this.getNewTime = _this.getNewTime.bind(_this);
    _this.stepForward = _this.stepForward.bind(_this);
    _this.stepBack = _this.stepBack.bind(_this);

    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
    return _this;
  }

  _createClass(SeekBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {}

    /**
     * Get percentage of video played
     *
     * @return {Number} Percentage played
     * @method getPercent
     */

  }, {
    key: 'getPercent',
    value: function getPercent() {
      var _props$player = this.props.player,
          currentTime = _props$player.currentTime,
          seekingTime = _props$player.seekingTime,
          duration = _props$player.duration;

      var time = seekingTime || currentTime;
      var percent = time / duration;
      return percent >= 1 ? 1 : percent;
    }
  }, {
    key: 'getNewTime',
    value: function getNewTime(event) {
      var duration = this.props.player.duration;

      var distance = this.slider.calculateDistance(event);
      var newTime = distance * duration;

      // Don't let video end while scrubbing.
      return newTime === duration ? newTime - 0.1 : newTime;
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown() {}
  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp(event) {
      var actions = this.props.actions;

      var newTime = this.getNewTime(event);
      // Set new time (tell video to seek to new time)
      actions.seek(newTime);
      actions.handleEndSeeking(newTime);
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      var actions = this.props.actions;

      var newTime = this.getNewTime(event);
      actions.handleSeekingTime(newTime);
    }
  }, {
    key: 'stepForward',
    value: function stepForward() {
      var actions = this.props.actions;

      actions.forward(5);
    }
  }, {
    key: 'stepBack',
    value: function stepBack() {
      var actions = this.props.actions;

      actions.replay(5);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$player2 = _props.player,
          currentTime = _props$player2.currentTime,
          seekingTime = _props$player2.seekingTime,
          duration = _props$player2.duration,
          buffered = _props$player2.buffered,
          mouseTime = _props.mouseTime;

      var time = seekingTime || currentTime;

      return _react2.default.createElement(
        _Slider2.default,
        {
          ref: function ref(input) {
            _this2.slider = input;
          },
          label: 'video progress bar',
          className: (0, _classnames2.default)('video-react-progress-holder', this.props.className),
          valuenow: (this.getPercent() * 100).toFixed(2),
          valuetext: (0, _utils.formatTime)(time, duration),
          onMouseDown: this.handleMouseDown,
          onMouseMove: this.handleMouseMove,
          onMouseUp: this.handleMouseUp,
          getPercent: this.getPercent,
          stepForward: this.stepForward,
          stepBack: this.stepBack
        },
        _react2.default.createElement(_LoadProgressBar2.default, {
          buffered: buffered,
          currentTime: time,
          duration: duration
        }),
        _react2.default.createElement(_MouseTimeDisplay2.default, {
          duration: duration,
          mouseTime: mouseTime
        }),
        _react2.default.createElement(_PlayProgressBar2.default, {
          currentTime: time,
          duration: duration
        })
      );
    }
  }]);

  return SeekBar;
}(_react.Component);

exports.default = SeekBar;


SeekBar.propTypes = propTypes;
SeekBar.displayName = 'SeekBar';

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PlayProgressBar;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  currentTime: _propTypes2.default.number,
  duration: _propTypes2.default.number,
  percentage: _propTypes2.default.string,
  className: _propTypes2.default.string
};

// Shows play progress
function PlayProgressBar(_ref) {
  var currentTime = _ref.currentTime,
      duration = _ref.duration,
      percentage = _ref.percentage,
      className = _ref.className;

  return _react2.default.createElement(
    'div',
    {
      'data-current-time': (0, _utils.formatTime)(currentTime, duration),
      className: (0, _classnames2.default)('video-react-play-progress video-react-slider-bar', className),
      style: {
        width: percentage
      }
    },
    _react2.default.createElement(
      'span',
      { className: 'video-react-control-text' },
      _react2.default.createElement(
        'span',
        null,
        'Progress'
      ),
      ': ',
      percentage
    )
  );
}

PlayProgressBar.propTypes = propTypes;
PlayProgressBar.displayName = 'PlayProgressBar';

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadProgressBar;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  duration: _propTypes2.default.number,
  buffered: _propTypes2.default.object,
  className: _propTypes2.default.string
};

// Shows load progress
function LoadProgressBar(_ref) {
  var buffered = _ref.buffered,
      duration = _ref.duration,
      className = _ref.className;

  if (!buffered || !buffered.length) {
    return null;
  }
  var bufferedEnd = buffered.end(buffered.length - 1);
  var style = {};

  if (bufferedEnd > duration) {
    bufferedEnd = duration;
  }

  // get the percent width of a time compared to the total end
  function percentify(time, end) {
    var percent = time / end || 0; // no NaN
    return (percent >= 1 ? 1 : percent) * 100 + '%';
  }

  // the width of the progress bar
  style.width = percentify(bufferedEnd, duration);

  var parts = [];

  // add child elements to represent the individual buffered time ranges
  for (var i = 0; i < buffered.length; i++) {
    var start = buffered.start(i);
    var end = buffered.end(i);
    // set the percent based on the width of the progress bar (bufferedEnd)
    var part = _react2.default.createElement('div', {
      style: {
        left: percentify(start, bufferedEnd),
        width: percentify(end - start, bufferedEnd)
      },
      key: 'part-' + i
    });
    parts.push(part);
  }

  if (parts.length === 0) {
    parts = null;
  }

  return _react2.default.createElement(
    'div',
    {
      style: style,
      className: (0, _classnames2.default)('video-react-load-progress', className)
    },
    _react2.default.createElement(
      'span',
      { className: 'video-react-control-text' },
      _react2.default.createElement(
        'span',
        null,
        'Loaded'
      ),
      ': 0%'
    ),
    parts
  );
}

LoadProgressBar.propTypes = propTypes;
LoadProgressBar.displayName = 'LoadProgressBar';

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MouseTimeDisplay(_ref) {
  var duration = _ref.duration,
      mouseTime = _ref.mouseTime,
      className = _ref.className,
      text = _ref.text;

  if (!mouseTime.time) {
    return null;
  }

  var time = text || (0, _utils.formatTime)(mouseTime.time, duration);

  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)('video-react-mouse-display', className),
    style: {
      left: mouseTime.position + 'px'
    },
    'data-current-time': time
  });
}

MouseTimeDisplay.propTypes = {
  duration: _propTypes2.default.number,
  mouseTime: _propTypes2.default.object,
  className: _propTypes2.default.string
};
MouseTimeDisplay.displayName = 'MouseTimeDisplay';

exports.default = MouseTimeDisplay;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  actions: _propTypes2.default.object,
  player: _propTypes2.default.object,
  className: _propTypes2.default.string
};

var PlayToggle = function (_Component) {
  _inherits(PlayToggle, _Component);

  function PlayToggle(props, context) {
    _classCallCheck(this, PlayToggle);

    var _this = _possibleConstructorReturn(this, (PlayToggle.__proto__ || Object.getPrototypeOf(PlayToggle)).call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(PlayToggle, [{
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          actions = _props.actions,
          player = _props.player;

      if (player.paused) {
        actions.play();
      } else {
        actions.pause();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          player = _props2.player,
          className = _props2.className;

      var controlText = player.paused ? 'Play' : 'Pause';

      return _react2.default.createElement(
        'button',
        {
          ref: function ref(c) {
            _this2.button = c;
          },
          className: (0, _classnames2.default)(className, {
            'video-react-play-control': true,
            'video-react-control': true,
            'video-react-button': true,
            'video-react-paused': player.paused,
            'video-react-playing': !player.paused
          }),
          type: 'button',
          tabIndex: '0',
          onClick: this.handleClick
        },
        _react2.default.createElement(
          'span',
          { className: 'video-react-control-text' },
          controlText
        )
      );
    }
  }]);

  return PlayToggle;
}(_react.Component);

exports.default = PlayToggle;


PlayToggle.propTypes = propTypes;
PlayToggle.displayName = 'PlayToggle';

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForwardReplayControl = __webpack_require__(236);

var _ForwardReplayControl2 = _interopRequireDefault(_ForwardReplayControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Pass mode into parent function
var ForwardControl = (0, _ForwardReplayControl2.default)('forward');

ForwardControl.displayName = 'ForwardControl';
exports.default = ForwardControl;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  actions: _propTypes2.default.object,
  className: _propTypes2.default.string,
  seconds: _propTypes2.default.oneOf([5, 10, 30])
};

var defaultProps = {
  seconds: 10
};

exports.default = function (mode) {
  var ForwardReplayControl = function (_Component) {
    _inherits(ForwardReplayControl, _Component);

    function ForwardReplayControl(props, context) {
      _classCallCheck(this, ForwardReplayControl);

      var _this = _possibleConstructorReturn(this, (ForwardReplayControl.__proto__ || Object.getPrototypeOf(ForwardReplayControl)).call(this, props, context));

      _this.handleClick = _this.handleClick.bind(_this);
      return _this;
    }

    _createClass(ForwardReplayControl, [{
      key: 'handleClick',
      value: function handleClick() {
        var _props = this.props,
            actions = _props.actions,
            seconds = _props.seconds;
        // Depends mode to implement different actions

        if (mode === 'forward') {
          actions.forward(seconds);
        } else {
          actions.replay(seconds);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props2 = this.props,
            seconds = _props2.seconds,
            className = _props2.className;

        var classNames = ['video-react-control', 'video-react-button', 'video-react-icon'];
        classNames.push('video-react-icon-' + mode + '-' + seconds, 'video-react-' + mode + '-control');
        if (this.props.className) {
          classNames.push(this.props.className);
        }
        return _react2.default.createElement(
          'button',
          {
            ref: function ref(c) {
              _this2.button = c;
            },
            className: classNames.join(' '),
            type: 'button',
            onClick: this.handleClick
          },
          _react2.default.createElement(
            'span',
            { className: 'video-react-control-text' },
            mode + ' ' + seconds + ' seconds'
          )
        );
      }
    }]);

    return ForwardReplayControl;
  }(_react.Component);

  ForwardReplayControl.propTypes = propTypes;
  ForwardReplayControl.defaultProps = defaultProps;
  return ForwardReplayControl;
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForwardReplayControl = __webpack_require__(236);

var _ForwardReplayControl2 = _interopRequireDefault(_ForwardReplayControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Pass mode into parent function
var ReplayControl = (0, _ForwardReplayControl2.default)('replay');
ReplayControl.displayName = 'ReplayControl';

exports.default = ReplayControl;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  actions: _propTypes2.default.object,
  player: _propTypes2.default.object,
  className: _propTypes2.default.string
};

var FullscreenToggle = function (_Component) {
  _inherits(FullscreenToggle, _Component);

  function FullscreenToggle(props, context) {
    _classCallCheck(this, FullscreenToggle);

    var _this = _possibleConstructorReturn(this, (FullscreenToggle.__proto__ || Object.getPrototypeOf(FullscreenToggle)).call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(FullscreenToggle, [{
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          player = _props.player,
          actions = _props.actions;

      actions.toggleFullscreen(player);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          player = _props2.player,
          className = _props2.className;

      return _react2.default.createElement(
        'button',
        {
          className: (0, _classnames2.default)(className, {
            'video-react-icon-fullscreen-exit': player.isFullscreen,
            'video-react-icon-fullscreen': !player.isFullscreen
          }, 'video-react-fullscreen-control video-react-control video-react-button video-react-icon'),
          ref: function ref(c) {
            _this2.button = c;
          },
          type: 'button',
          tabIndex: '0',
          onClick: this.handleClick
        },
        _react2.default.createElement(
          'span',
          { className: 'video-react-control-text' },
          'Non-Fullscreen'
        )
      );
    }
  }]);

  return FullscreenToggle;
}(_react.Component);

exports.default = FullscreenToggle;


FullscreenToggle.propTypes = propTypes;
FullscreenToggle.displayName = 'FullscreenToggle';

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  player: _propTypes2.default.object,
  className: _propTypes2.default.string
};

function RemainingTimeDisplay(_ref) {
  var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;

  var remainingTime = duration - currentTime;
  var formattedTime = (0, _utils.formatTime)(remainingTime);
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('video-react-remaining-time video-react-time-control video-react-control', className)
    },
    _react2.default.createElement(
      'div',
      {
        className: 'video-react-remaining-time-display',
        'aria-live': 'off'
      },
      _react2.default.createElement(
        'span',
        { className: 'video-react-control-text' },
        'Remaining Time '
      ),
      '-',
      formattedTime
    )
  );
}

RemainingTimeDisplay.propTypes = propTypes;
RemainingTimeDisplay.displayName = 'RemainingTimeDisplay';

exports.default = RemainingTimeDisplay;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  player: _propTypes2.default.object,
  className: _propTypes2.default.string
};

function CurrentTimeDisplay(_ref) {
  var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;

  var formattedTime = (0, _utils.formatTime)(currentTime, duration);
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('video-react-current-time video-react-time-control video-react-control', className)
    },
    _react2.default.createElement(
      'div',
      {
        className: 'video-react-current-time-display',
        'aria-live': 'off'
      },
      _react2.default.createElement(
        'span',
        { className: 'video-react-control-text' },
        'Current Time '
      ),
      formattedTime
    )
  );
}

CurrentTimeDisplay.propTypes = propTypes;
CurrentTimeDisplay.displayName = 'CurrentTimeDisplay';

exports.default = CurrentTimeDisplay;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  player: _propTypes2.default.object,
  className: _propTypes2.default.string
};

function DurationDisplay(_ref) {
  var duration = _ref.player.duration,
      className = _ref.className;

  var formattedTime = (0, _utils.formatTime)(duration);
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)(className, 'video-react-duration video-react-time-control video-react-control')
    },
    _react2.default.createElement(
      'div',
      {
        className: 'video-react-duration-display',
        'aria-live': 'off'
      },
      _react2.default.createElement(
        'span',
        { className: 'video-react-control-text' },
        'Duration Time '
      ),
      formattedTime
    )
  );
}

DurationDisplay.propTypes = propTypes;
DurationDisplay.displayName = 'DurationDisplay';

exports.default = DurationDisplay;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TimeDivider;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  separator: _propTypes2.default.string,
  className: _propTypes2.default.string
};

function TimeDivider(_ref) {
  var separator = _ref.separator,
      className = _ref.className;

  var separatorText = separator || '/';
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('video-react-time-control video-react-time-divider', className),
      dir: 'ltr'
    },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        null,
        separatorText
      )
    )
  );
}

TimeDivider.propTypes = propTypes;
TimeDivider.displayName = 'TimeDivider';

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _PopupButton = __webpack_require__(789);

var _PopupButton2 = _interopRequireDefault(_PopupButton);

var _VolumeBar = __webpack_require__(791);

var _VolumeBar2 = _interopRequireDefault(_VolumeBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  player: _propTypes2.default.object,
  actions: _propTypes2.default.object,
  vertical: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  alwaysShowVolume: _propTypes2.default.bool
};

var defaultProps = {
  vertical: false
};

var VolumeMenuButton = function (_Component) {
  _inherits(VolumeMenuButton, _Component);

  function VolumeMenuButton(props, context) {
    _classCallCheck(this, VolumeMenuButton);

    var _this = _possibleConstructorReturn(this, (VolumeMenuButton.__proto__ || Object.getPrototypeOf(VolumeMenuButton)).call(this, props, context));

    _this.state = {
      active: false
    };

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    return _this;
  }

  _createClass(VolumeMenuButton, [{
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          player = _props.player,
          actions = _props.actions;

      actions.mute(!player.muted);
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      this.setState({
        active: true
      });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      this.setState({
        active: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          vertical = _props2.vertical,
          player = _props2.player,
          className = _props2.className;

      var inline = !vertical;
      var level = this.volumeLevel;
      return _react2.default.createElement(
        _PopupButton2.default,
        {
          className: (0, _classnames2.default)(className, {
            'video-react-volume-menu-button-vertical': vertical,
            'video-react-volume-menu-button-horizontal': !vertical,
            'video-react-vol-muted': player.muted,
            'video-react-vol-0': level === 0 && !player.muted,
            'video-react-vol-1': level === 1,
            'video-react-vol-2': level === 2,
            'video-react-vol-3': level === 3,
            'video-react-slider-active': this.props.alwaysShowVolume || this.state.active,
            'video-react-lock-showing': this.props.alwaysShowVolume || this.state.active
          }, 'video-react-volume-menu-button'),
          onClick: this.handleClick,
          inline: inline
        },
        _react2.default.createElement(_VolumeBar2.default, _extends({
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }, this.props))
      );
    }
  }, {
    key: 'volumeLevel',
    get: function get() {
      var _props$player = this.props.player,
          volume = _props$player.volume,
          muted = _props$player.muted;

      var level = 3;
      if (volume === 0 || muted) {
        level = 0;
      } else if (volume < 0.33) {
        level = 1;
      } else if (volume < 0.67) {
        level = 2;
      }
      return level;
    }
  }]);

  return VolumeMenuButton;
}(_react.Component);

VolumeMenuButton.propTypes = propTypes;
VolumeMenuButton.defaultProps = defaultProps;
VolumeMenuButton.displayName = 'VolumeMenuButton';
exports.default = VolumeMenuButton;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  tagName: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  className: _propTypes2.default.string
};

var defaultProps = {
  tagName: 'div'
};

var ClickableComponent = function (_Component) {
  _inherits(ClickableComponent, _Component);

  function ClickableComponent(props, context) {
    _classCallCheck(this, ClickableComponent);

    var _this = _possibleConstructorReturn(this, (ClickableComponent.__proto__ || Object.getPrototypeOf(ClickableComponent)).call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleKeypress = _this.handleKeypress.bind(_this);
    return _this;
  }

  _createClass(ClickableComponent, [{
    key: 'handleKeypress',
    value: function handleKeypress(event) {
      // Support Space (32) or Enter (13) key operation to fire a click event
      if (event.which === 32 || event.which === 13) {
        event.preventDefault();
        this.handleClick(event);
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      var onClick = this.props.onClick;

      onClick(event);
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(e) {
      document.addEventListener('keydown', this.handleKeypress);
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(e) {
      document.removeEventListener('keydown', this.handleKeypress);
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var Tag = this.props.tagName;
      var props = _extends({}, this.props);
      delete props.tagName;
      delete props.className;
      return _react2.default.createElement(Tag, _extends({
        className: (0, _classnames2.default)(this.props.className),
        role: 'button',
        tabIndex: '0',
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, props));
    }
  }]);

  return ClickableComponent;
}(_react.Component);

exports.default = ClickableComponent;


ClickableComponent.propTypes = propTypes;
ClickableComponent.defaultProps = defaultProps;
ClickableComponent.displayName = 'ClickableComponent';

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcknowledgementsComponent", function() { return AcknowledgementsComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__ = __webpack_require__(23);
var Component=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* observer */])(__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"]));Component.displayName='Acknowledgements';var AcknowledgementsComponent=__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"];/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultProps; });
/* unused harmony export extendDefaultTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(248);



var defaultProps = {
  theme: __WEBPACK_IMPORTED_MODULE_1__themes__["a" /* base */]
};

var extendDefaultTheme = function extendDefaultTheme(theme) {
  defaultProps.theme = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* deepMerge */])(__WEBPACK_IMPORTED_MODULE_1__themes__["a" /* base */], theme);
};

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(799);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__base__["a"]; });


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrameContextConsumer = exports.FrameContextProvider = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var doc = void 0;
var win = void 0;
if (typeof document !== 'undefined') {
  doc = document;
}
if (typeof window !== 'undefined') {
  win = window;
}

var _React$createContext = _react2.default.createContext({ document: doc, window: win });

var FrameContextProvider = _React$createContext.Provider,
    FrameContextConsumer = _React$createContext.Consumer;
exports.FrameContextProvider = FrameContextProvider;
exports.FrameContextConsumer = FrameContextConsumer;

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = "{\n  \"metadata\": {\n    \"title\": \"Modern War in an Ancient Land Volume II\",\n    \"publication number\": \"Volume II\",\n    \"author\": \"Edmund J. \\\"E.J.\\\" Degen, Mark J. Reardon\",\n    \"date\": \"June 2021\",\n    \"distribution restriction\": \"Approved for public release; distribution is unlimited.\"\n  },\n  \"cover\": [\n    {\n      \"picture\": {\n        \"source\": \"/figures/v2/OEF_CVR2.png\",\n        \"caption\": \"\"\n      }\n    },\n    \"\",\n    \"\",\n    \"\",\n    \"\",\n    \"\",\n    \"\",\n    \"\",\n    {\n      \"picture\": {\n        \"source\": \"/figures/m/map-fm-AfghanistanProvincialBoundaries.svg\",\n        \"caption\": \"Afghanistan Provincial Boundaries\"\n      }\n    },\n    \"\",\n    \"\",\n    \"\",\n    \"\",\n    \"\",\n    \"\",\n    \"\",\n    \"${Prepared by the Chief of Staff of the Army Operation Enduring Freedom Study Group}{bold}\",\n    \"Col. (USA Ret.) Edmund J. “E. J.” Degen, Study Director and Editor\",\n    \"Lt. Col. (USA Ret.) Mark J. Reardon, Senior Historian and Editor\",\n    \"\",\n    \"Study Group Research and Writing Team\",\n    \"Col. Adrian A. Donahoe\",\n    \"Col. Bryan R. Gibby\",\n    \"Dr. Brian F. Neumann\",\n    \"Col. Francis J. H. Park\",\n    \"Dr. Gregory G. Roberts\",\n    \"Lt. Col. (USA Ret.) Matthew B. Smith\",\n    \"Lt. Col. (USA Ret.) John R. Stark\",\n    \"Maj. Miranda M. Summers-Lowe\",\n    \"Col. Victor H. Sundquist\",\n    \"Dr. Colin J. Williams\",\n    \" \",\n    \" \",\n    \"Foreword by\",\n    \"General James C. McConville, CSA\",\n    \" \",\n    \" \",\n    \"${...to Those Who Served}{bold}\"\n  ],\n  \"supplement\": {\n    \"details\": \"Endnotes are not included in the supplement.  Alternate options for viewing are available on the Modern War website at https://rdl.train.army.mil/catalog-ws/view/modernwar/index.html\"\n  },\n  \"instructions\": null,\n  \"information\": null,\n  \"foreword\": [\n    {\n      \"title\": \"Foreword\"\n    },\n    \"The terrorist attacks of 11 September 2001 resulted in the initiation of Operation ENDURING FREEDOM, the longest-tenured named operation in U.S. history. Focused primarily on objectives within the borders of Afghanistan, ENDURING FREEDOM lasted for more than thirteen years. The speed with which our nation concentrated military forces in an undeveloped theater, before executing a coordinated air-ground offensive with our Afghan allies against al-Qaeda and their Taliban supporters, amazed friend and foe alike. Although the “Shock and Awe” campaign removed the threat that al-Qaeda would launch another strike against the United States from its Afghan sanctuary, it was less successful in its efforts to help the post-Taliban Afghan government establish security throughout the newly liberated nation. Achieving the desired level of security in the face of a resurgent Taliban would require a much larger commitment of ground forces, national treasure, and time than originally envisioned.\",\n    \"As we learned in volume one of Modern War in an Ancient Land, initiatives to provide security in Afghanistan struggled because of a lack of resources. After the end of the initial military campaign, the strategic end state for Afghanistan remained ill-defined, and the means to achieve the goal of creating a stable, friendly nation with a functioning government were not immediately forthcoming. American commanders and their subordinates in Afghanistan constantly sought innovative solutions to make up for shortfalls in troops and equipment. However, from 2003, the National Command Authorities prioritized the Iraq conflict—and for those who served in Afghanistan, operating with insufficient means would become the norm rather than the exception.\",\n    \"The worldwide demand for ground forces to fight the Global War on Terrorism highlighted dormant issues within all components of the U.S. Army. Although the Army that existed on 11 September 2001 was prepared to deploy, fight, and win our nation’s wars, Cold War–era thought permeated its existing force structure, training, and equipment design. The initiative known as modularity redesigned the basic combat formation around the maneuver brigade. By pushing assets normally allocated to higher echelons down to brigade levels, the Army was able to increase the number of combat brigades available for worldwide employment and realign brigade capabilities with the dispersed nature of both Iraqi and Afghan battlefields.\",\n    \"Equipping issues also came to the forefront. The Abrams main battle tank and the Bradley infantry fighting vehicle were optimal for combat on the plains of Europe, but they did not transition easily to the counterinsurgency operations in Iraq and Afghanistan. To provide soldiers with needed mobility and protection in these challenging environments, the Department of Defense accelerated the development of new wheeled combat vehicles such as Strykers and Ground Combat Vehicles. Myriad other programs also sought to ensure American soldiers had all of the equipment and resources they would need to locate, engage, and defeat their enemies.\",\n    \"As it waged two simultaneous conflicts that demanded lengthy commitments from its forces, the Army made significant changes in the way it trained and prepared soldiers for deployment to active theaters of operation. It instituted a predeployment readiness and training model known as Army Force Generation (ARFORGEN) to replace Cold War–era readiness and deployment practices. The ARFORGEN model provided better predictability for units, soldiers, and families during this period of sustained conflict by designating predictable timelines. It also made the best use of resources dedicated to preparing soldiers and units for combat by synchronizing the allocation of personnel, equipment, and training.\",\n    \"All three components of the Army—Active, Guard, and Reserve were in high demand for extended periods. To more equitably share operational burdens, senior leaders introduced the “Grow the Army” initiative, which increased the size of the force. Another major program involved an investment in individual readiness, especially for National Guard and Reserve forces. Recognizing the unparalleled demands on these forces, the Army strove to give them proper healthcare, coupled with training opportunities to ensure continued support for their mission. Those programs, along with ARFORGEN, were critical to ensuring the soldiers and families had time to rest and rebuild their strength.\",\n    \"Even as the Army recategorized its thinking at home to better support the war, the conflict in Afghanistan intensified as the enemy used sanctuaries I Pakistan to regenerate combat power. This volume shows the evolution of the international coalition during this period, as our allies dedicated more forces and the NATO-led International Security Assistance Force assumes overall responsibility for the campaign. Later, as the war in Iraq wound down, the war in Afghanistan began to receive the resources it needed—not merely to keep the enemy in check but also to build capacity within the country in order for the Afghan people to take the lead in providing their own security and stability. As this point of transition to Afghan-led security approached, U.S. and coalition forces rapidly and dramatically reduced their presence in theater and returned to their home stations.\",\n    \"Nevertheless, the transition of responsibilities to host-nation security forces has not signaled the end of American efforts in Afghanistan. Leaders at all echelons must continue to build upon their experiences and prepare for the next challenge. As stated in The Army Vision, the Army as a whole must prepare to deploy, fight, and win decisively against an adversary, anytime and anywhere, in a joint, multidomain, high-intensity conflict, while simultaneously deterring others and maintaining its ability to conduct irregular warfare. For our Army, this means high-quality soldiers. We must equip our formations with the latest technology and maximize these organizations to take advantage of our skills in combined arms warfare. Leaders throughout the Army must become expert trainers, prepared to reach the highest levels of readiness in an era of reduced resources. The Army’s training and educational institutions must provide dynamic learning environments. Most importantly, Army leaders must never relinquish the agility and innovation they have gained in the past two decades of the Global War on Terrorism.\",\n    \"These two volumes are the first of many efforts our Army will generate to ensure we learn all we can from Operation ENDURING FREEDOM. History has always been a cornerstone of our education process, and that will remain true for the foreseeable future. The insights and dialogue generated by reading and reflecting on these histories will prove invaluable in the next war. I trust that not just our military readers, but also our civilian counterparts and leaders, can gain value from studying these efforts.\",\n    \"Washington, D.C.\",\n    \"GENERAL JAMES C. MCCONVILLE\",\n    \"40th Chief of Staff of the Army, 2019–\"\n  ],\n  \"preface\": [\n    {\n      \"title\": \"Preface\"\n    },\n    \"Following the fall 2005 elections in Afghanistan, the key question driving the United States’ approach to Operation ENDURING FREEDOM was how to reduce forces without sacrificing the security gains made since 2001. After more than a year of searching, a potential answer emerged in April 2003 when the North Atlantic Treaty Organization (NATO) agreed to broaden the International Security Assistance Force (ISAF) mandate it assumed from the United Nations (UN). Taking leadership of Regional Command (RC) North in October 2004, NATO planned to expand in a counterclockwise direction until it could provide security and developmental assistance to all of Afghanistan. Secretary of Defense Donald H. Rumsfeld understood the importance of the NATO decision, believing that America would “continue to be tied down . . . [in Afghanistan] until the Afghans can provide their own security,” a situation that was “costing the US taxpayers a fortune.” Greater European participation would allow deployed American military forces to protect the U.S. homeland by focusing on counterterrorist missions rather than less essential tasks such as nation building.\",\n    \"With the Global War on Terrorism nearing its fifth year, the United States still devoted a scant 3.9 percent of its gross domestic product to national defense, with only 1.1 percent going to the Army. Subtracting the emergency supplemental allocations passed by Congress to address unforeseen issues affecting combat operations, the Army received only slightly more than one-third of a percent of the U.S. government’s annual budget. As a result of the budget disparity, the Army’s ability to undertake missions other than Iraq and Afghanistan continued to degrade as equipment not needed for immediate warfighting requirements was neither maintained nor upgraded. The lack of funding also took other discrete forms, such as declining opportunities for nondeploying units to maintain proficiency and inadequate recruiting incentives.\",\n    \"Readers will note that many problems and challenges captured in the first volume of Modern War in an Ancient Land persist during the subsequent stages of the conflict in Afghanistan as detailed in this volume. Although the struggle for resources became less urgent for a time following the defeat of the Iraqi insurgency, that issue returned in 2011 as U.S. commanders in theater prepared to transition security responsibilities to their Afghan counterparts. This volume discusses the path taken by Operation ENDURING FREEDOM beginning with ISAF’s expansion through the change of mission on 31 December 2014. The first section examines how ISAF adjusted to the evolving campaign in the aftermath of the Taliban’s return to the fight. The second section examines the Obama administration’s decision, made possible only after the defeat of the Iraqi insurgency, to change the course of the campaign by resourcing a surge in Afghanistan. The concluding section captures the downsizing story and the transition of the ENDURING FREEDOM mission—a period of great complexity.\"\n  ],\n  \"section I\": [\n    {\n      \"title\": \"AN ECONOMY OF FORCE\"\n    },\n    \"In October 2005, the Army had 270,000 soldiers—27 percent of its 1,032,587 officers, warrant officers, cadets, and enlisted soldiers—deployed or forward stationed in 120 countries. The total force of more than 1 million troops included 492,728 active component soldiers, 206,682 Army Reserve members, and 333,177 National Guard personnel. Those figures reflected a decrease over the previous year of 5,888 active component soldiers, 14,126 Army Reserve members, and 9,741 National Guard personnel. Across the entire Army, every component had failed to achieve its retention goals. The Army’s willingness to accept more recruits with waivers and minimum skill qualification test scores also resulted in the number of high school graduates in uniform dropping from 92 to 87 percent.\",\n    \"The personnel crisis improved marginally in 2006 after recruiting programs received more funding to support their efforts. Active component retention and recruiting goals were met, while the National Guard and Army Reserve recruiting targets were not. The drop in qualitative levels continued as the number of service members who had high school diplomas fell to 81 percent. At the end of the fiscal year, the active component numbered 502,790, while the National Guard and Army Reserve totals were 346,288 and 189,975 respectively. The totals reflected an active component gain of 10,062, as well as 13,111 more national guardsmen in uniform, while Army Reserve end strength dropped by 16,707. The latter stemmed in part from widespread dissatisfaction with the Department of Defense’s (DoD) ad hoc approach to employing reservists during the early phases of the Iraq conflict.\",\n    \"During this period, the Army continued its efforts to reach a goal of 70 modular combat brigades and 211 modular support brigades. Those totals were a 46 percent increase in comparison with the premodular force. Nineteen brigade combat teams had converted by the end of 2005, with another eighteen in the process of modularizing by mid-2006. In addition to implementing widespread force structure changes, the Army placed considerable priority on meeting near-term tactical and operational battlefield challenges. It enhanced both the M2A3 Bradley Infantry Fighting Vehicle and the M1A2 Abrams Main Battle Tank to make them more survivable in urban environments. The growing threat posed by improvised explosive devices (IEDs) led to accelerated fielding of up-armored M1114 High Mobility Multipurpose Wheeled Vehicles (HMMWVs), which would be replaced by a totally new design, the Mine Resistant Ambush Protected (MRAP) vehicle, in 2007. Unmanned aerial vehicles also received a higher priority as the Army distributed more RQ–5A Hunter and RQ–7A Shadows to divisions and brigades. Most of the new equipment went to Iraq rather than being deployed to Afghanistan.\",\n    \"A quick comparison of Operation IRAQI FREEDOM (OIF) with its counterpart in Afghanistan reveals why the latter was a lower priority. In January 2006, more than 98,000 soldiers were serving in Iraq with another 14,000 supporting them from Kuwait. The U.S. Army contribution to the U.S.-led Multi-National Force–Iraq consisted of fourteen brigade combat teams, innumerable support elements, two division headquarters, and one corps headquarters. In comparison, Afghanistan required three brigade combat teams with support units and one division headquarters totaling 16,000 soldiers. During fiscal year 2006, Army units in Iraq suffered 440 killed in action, 92 other deaths, and 3,610 wounded in action. Despite the Taliban resurgence, comparable figures for Afghanistan were 54 killed in action, 21 other deaths, and 292 wounded in action. Steadily rising sectarian violence and U.S. military casualties in Iraq, coupled with the Bush administration’s determination to hand over Afghanistan to the NATO-led ISAF, ensured Operation ENDURING FREEDOM (OEF) remained an economy of force effort for the foreseeable future.\",\n    \"In light of the tremendous pressure being exerted on the Army, it is unsurprising that the American approach in Afghanistan from late 2005 through 2008 centered on making the transition to NATO, and eventually the Kabul government, a reality. This process would take time and resources, the two things that the administration of President George W. Bush wanted to avoid committing. It also required that NATO meet Afghanistan’s security and governmental needs, a condition that member nations accepted as a natural outcome of the long-term military commitments experienced in the Balkans. The difficult change from U.S. to ISAF leadership needed a secure environment in order to be successful. Unfortunately for the United States and NATO, Afghanistan’s dynamic environment and the Taliban’s rejuvenation in late 2005 blunted the progress that ENDURING FREEDOM had brought to the country. When America transferred Regional Command (RC) South and RC East to NATO in 2006, the handovers did not go unopposed as the Taliban and its allies launched sequential offensives against incoming NATO forces. Although unsuccessful, the attacks revealed that NATO was unprepared for the renewed violence. As a result, America halted its drawdown as NATO members reevaluated what type of assistance they were prepared to provide. When ENDURING FREEDOM continued to deteriorate in early 2007, the Bush administration committed additional forces to Afghanistan and increased its support for the Kabul government.\",\n    \"America’s concurrent war in Iraq provided the background for this deteriorating situation. In February 2006, the bombing of the al-Askari mosque in Samarra’, Iraq, triggered a sectarian civil war that, combined with the persistent anticoalition insurgency, convinced President Bush that he needed to send a surge of forces there. With the balance of the U.S. Army’s available personnel participating in, recovering from, or preparing for OIF, policymakers confined the United States to an economy of force mission in Afghanistan in 2007–2008. Although violence in Afghanistan escalated, security problems did not reach levels comparable to the events that forced the Bush administration to completely refashion its warfighting strategy in Iraq.\",\n    \"Consequently, the next two years passed in Afghanistan without significant changes to America’s operational approach. Both the U.S. military and the other NATO member nations failed to deploy sufficient forces to meet ISAF objectives, and the Afghan war deteriorated to the point that the United States, its international coalition, and the Afghan government faced the possibility of stalemate or defeat by early 2009.\",\n    \"This section chronicles the three-and-a-half years between the 2005 Afghan national and provincial elections, which marked the end of the original Bonn Process agreed upon in December 2001, and the start of President Barack H. Obama’s administration in early 2009. The initial chapter captures the challenges the Army faced while supporting two major combat theaters simultaneously. The second chapter introduces the strategic situation in Afghanistan following the September 2005 National Assembly and provincial council elections, while analyzing the emerging threat posed by a revived Taliban and other anticoalition groups. It concludes by examining how American forces prepared for the arrival of NATO forces in 2006 and the joint Army and Marine Corps efforts to update counterinsurgency doctrine. The third chapter details how the enemy contested control of RC South— which led to an ISAF counteroffensive to regain the initiative—before ending with a discussion of how U.S. troops refocused on RC East during this period. The fourth chapter begins in 2007 with a new ISAF commander, General Dan K. McNeill, implementing a strategy to smother the insurgency while managing the disparate elements of the NATO coalition. The final chapter details how his successor, General David D. McKiernan, arrived in the summer of 2008 to find a coalition divided by various command chains and lacking a cohesive strategy. Each chapter examines American and ISAF efforts to create Afghan security institutions and rebuild national and local infrastructure.\"\n  ],\n  \"chapter 1\": [\n    {\n      \"title\": \"The Challenges of Protracted War\"\n    },\n    {\n      \"section\": [\n        \"As Task Force SPARTAN (3d Brigade, 10th Mountain Division) spread forces out among the Afghan population in 2005, the Army and Marine Corps were thoroughly reviewing the doctrine that was being used in the wars. The unanticipated trajectory of the Global War on Terrorism placed increasing stress on the Army as the simultaneous conflicts in Afghanistan and Iraq showed few signs of abating, and both conventional and Special Operations Forces (SOF) felt the detrimental effects. The Army initially sought to address this problem by restructuring brigade combat teams and siphoning personnel from nondeployable institutional organizations, namely the Generating Force. The DoD reinforced the Army’s indirect approach to constant combat deployments by creating more indigenous security forces and convincing coalition partners to assume more responsibilities. Although NATO ultimately agreed to expand its mandate while indigenous security forces grew steadily in size and capability, the organizational and operational pressures exerted on the Army lingered long past the January 2007 decision to surge troops into Iraq. When the decision was made to grow the Army force structure, great thought and care had to be put into that effort to ensure there would be no long-lasting negative effects on the mission, the overall quality of the force, and families. Besides the challenges, the manner in which the Army was prosecuting the campaign was under scrutiny at the same time. A full examination of the doctrine that guided campaigns was beginning in earnest at Fort Leavenworth, Kansas.\"\n      ]\n    },\n    {\n      \"title\": \"Revamping Doctrine\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The Army initiated Operation ENDURING FREEDOM with doctrine reflecting the experiences of Operation DESERT STORM, recent peace enforcement operations, and the defense transformation efforts of the 1990s. Operations (Department of the Army Field Manual 3–0), the Army’s capstone publication published on 14 June 2001, described the Army’s newly adopted doctrinal approach as “full spectrum operations,” which combined offense, defense, stability, and support operations. It indicated that training to the highest readiness levels required for combat operations would enable units to win in less-demanding stability and support missions. This approach sought to reconcile two conflicting demands. Although the Army had an overarching need for a strategically agile heavy force, capable of waging decisive combined arms operations against a conventional regional aggressor, U.S. soldiers also had to be prepared for other types of operations against less-conventional opponents. Humanitarian and peacekeeping missions such as those in Somalia and the Balkans, and regional interventions to protect U.S. interests like those in Grenada and Panama, had presented unanticipated challenges to commanders in the field and at home, and the Army wanted to prepare its soldiers for the volatile environment inherent in these types of contingency operations. However, the painful memory of the Vietnam conflict—in which the U.S. military had fought both a conventional opponent and an insurgency and found it difficult to eradicate either—also had left a lasting impression on senior Army leaders. Because the Army leadership was determined never to repeat the experiences of Vietnam, the new field manual dedicated only a single page to counterinsurgency operations. Rather than provide soldiers in Afghanistan and Iraq with guidance that might help them understand the combat environment, the 2001 edition of Field Manual 3–0 left a doctrinal void.\",\n        \"With Field Manual 3–0 lacking necessary insight, commanders turned to Military Operations in Low Intensity Conflicts (Department of the Army Field Manual 100–20), first published in 1990. Although it was still in the final stages of revision, Field Manual 100–20 would become a temporary source of information until it was superseded by Stability Operations and Support Operations (Department of the Army Field Manual 3–07) in 2003. Field Manual 3–07 discussed counterinsurgency and foreign internal defense operations as they related to stability and support operations within full spectrum operations articulated in the 2001 Operations manual. However, troops deploying to Afghanistan had little to no opportunity to train for stability and support operations because the Joint Readiness Training Center only offered a one-week “low intensity conflict” scenario for light forces. Units such as the 1st Cavalry Division, which had some experience with peacekeeping missions in the Balkans, deployed to Iraq in early 2004 optimized for stability and support operations only to discover a full-fledged insurgency in progress.\",\n        \"In response to the urgent need for more detailed counterinsurgency doctrine following the spring 2004 uprising in Iraq, Lt. Col. Jan S. Horvath of the Combined Arms Center at Fort Leavenworth borrowed heavily from French experiences in the Algerian War from 1954 through 1962 to produce an interim document, released to the force in October 2004 as Field Manual–Interim 3–07.22, Counterinsurgency Operations. The manual provided more detail than Field Manual 3–07 had on how to conduct such operations, but Colonel Horvath still faced the unenviable task of sifting out applicable lessons from what could be characterized as a French defeat in Algeria to produce a publication designed to temporarily fill the doctrinal void. This interim manual was rolled out to little fanfare, but its replacement would be far more influential.\",\n        \"In February 2006, Lt. Gen. David H. Petraeus, who had assumed command of the Combined Arms Center five months earlier, hosted a conference of experts on irregular warfare and counterinsurgency drawn from the military, the intelligence community, the Department of State, academia, and elsewhere. The conference solicited input and backing for a new doctrinal publication, Counterinsurgency (Department of the Army Field Manual 3–24). Work on the manual, which included input from the U.S. Marine Corps, had started five months earlier with the arrival of Dr. Conrad C. Crane, a West Point classmate of General Petraeus, who was on loan to Leavenworth from the Military History Institute at the U.S. Army War College in Carlyle, Pennsylvania. Although the first draft reflected a variety of inspirations, its intellectual underpinnings drew heavily from Robert Thompson and Frank Kitson, British commanders whose experiences facing insurgencies in Kenya, Malaya, and Northern Ireland provided a strategic counterpoint to related works by N. Lenin, Mao Zedong, Vo Nguyen Giap, and Ché Guevara. Crane’s other sources included material from Dr. Steven K. Metz of the Army War College’s Strategic Studies Institute, and most significantly, two articles citing Iraq lessons learned from Petraeus, who had commanded the 101st Airborne Division (Air Assault) and the Multinational Security Transition Command–Iraq, and Maj. Gen. Peter W. Chiarelli, who had commanded the 1st Cavalry Division in Baghdad.\",\n        \"Work on the counterinsurgency manual also led to the publication of another important update, ${Stability Operations}{italic} (Department of the Army Field Manual 3–07), during this period. The revision of Field Manual 3–07 began in late 2006, following a discussion between Petraeus and Lt. Col. Steven M. Leonard, a former planner with the 101st Airborne Division in Iraq, who had become chief of operational-level doctrine at the Combined Arms Doctrine Directorate at Fort Leavenworth. After noting that Field Manual 3–24 did not cover all of the potential missions a unit might conduct during counterinsurgency operations, Petraeus told Colonel Leonard to ask the Department of State and the U.S. Agency for International Development for help in updating the Army’s guide to stability and support operations. Leonard also received significant assistance from the Peacekeeping and Stability Operations Institute at Carlisle Barracks.\",\n        \"The resulting manual included some distinctly nonmilitary sources of guidance. At its highest level, ${Stability Operations}{italic} drew on the 2006 National Security Strategy, but more practically, it borrowed from National Security Presidential Directive 44 and DoD Directive 3000.05. Both of the latter documents, first unveiled in 2005, gave authoritative guidance on the conduct of stability operations, with the State Department designated as the lead federal agency for such operations. Other influential sources for Field Manual 3–24 were the U.S. Agency for International Development’s 2005 Fragile States Strategy and the United States Institute of Peace’s Fragile States Framework, as well as Post-Conflict Reconstruction Essential Tasks from the Office of the Coordinator for Reconstruction and Stability at the State Department, which directly linked military operations to a broader whole-of-government approach. Much like its Counterinsurgency predecessor, the ${Stability Operations}{italic} manual also was released by a separate civilian publisher, the University of Michigan Press, with a foreword from Undersecretary of Defense for Policy Michèle A. Flournoy and an introduction by Flournoy’s director of stability operations capabilities, Dr. Janine A. Davidson.\",\n        \"The publication of updated operations, counterinsurgency, and stability operations doctrine showed that the Army could adapt to the immediate needs of two combat theaters, even though it also illustrated the operational limitations of technology-based transformation. In both Afghanistan and Iraq, air- and space-based systems played a central role in defeating the Taliban forces led by Mullah Mohammed Omar and Saddam Hussein’s Iraqi armed forces. In each instance, however, airpower and space-based assets backed by world-class command, control, communications, and intelligence systems could not defeat opponents who subsequently adopted new methods that negated U.S. technological advantages. The Army and Marine Corps ultimately countered these new threats only by adopting new doctrine that enabled ground forces to fill the operational warfighting shortfalls created when asymmetrical enemy countermeasures relegated air- and space-based systems to a distinctly secondary role.\",\n        \"The two doctrinal manuals outlined above would have much greater influence on future doctrine, most significantly in the concepts  of Design and Mission Command. The December 2006 version of Field Manual 3–24 addresses the initial concept of Design:\",\n        {\n          \"list\": [\n            \"It is important to understand the distinction between design and planning. . . . While both activities seek to formulate ways to bring about preferable futures, they are cognitively different. Planning applies established procedures to solve a largely understood problem within an accepted framework. Design inquires into the nature of a problem to conceive a framework for solving that problem. In general, planning is problem solving, while design is problem setting. Where planning focuses on generating a plan—a series of executable actions—design focuses on learning about the nature of an unfamiliar problem.\"\n          ]\n        }\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/grafik_Fig1-1.png\",\n        \"caption\": \"Iterative Nature of Design\"\n      }\n    },\n    \"Figure 4-2 from the 2006 Field Manual 3–24 also shows the iterative nature of Design. A number of artifacts from the counterinsurgency manual, such as lines of operation, lines of effort, and the importance of dialogue, were included in the final design concept. Design, therefore, included much of the understanding and visualizing in what was then called Battle Command. It viewed these actions by the commander as conceptual and separate from planning. In the interim period, before The Operations Process (Department of the Army Field Manual 5–0) was published in 2010, planning consisted of a conceptual component (Design) performed by commanders and the detailed planning (Military Decision Making Process and Joint Operation Planning Process) subsequently conducted by the staff:\",\n    {\n      \"list\": [\n        \"4–1. For every operation, commanders develop personal, detailed understanding of the situation and operational environment. They then visualize a desired end state and craft a broad concept for shaping the current conditions toward that end state. Finally, they describe their visualization through the commander’s intent, planning guidance, and concept of operations, setting formal planning processes in motion. Thus, planning is an adaptive process that ebbs and flows with the situation; as understanding of the situation evolves, planners develop branches and sequels to account for such evolution. Planning is a continuous activity, constantly adapting as the conditions of the operational environment are shaped by activities, both natural and human. Since planning is an ongoing process, the resultant plan is an interim product of deliberate thought, based on knowledge and understanding at a specific point in time and space. The truest measure of a good plan is not whether execution occurs as planned, but whether the plan fosters flexibility, initiative, and adaptability in the face of unforeseen events.\",\n        \"4–2. Planning consists of two separate, but closely related aspects: a conceptual component, represented by the  less tangible aspects of visualization, and a detailed component, which introduces specificity to the plan through a deliberate process. During planning these activities overlap; there is no clear delineation between either. As commanders conceptualize the operation, their vision informs the staff to add detail to the plan.\"\n      ]\n    },\n    \"In comparison, the 2010 edition of Field Manual 5–0, paragraph 3–2, nearly mirrors the opening sentence of paragraph 4–2 above:\",\n    {\n      \"list\": [\n        \"3–2. Planning consists of two separate, but closely related components: a conceptual component and a detailed component.  The conceptual component is represented by the cognitive application of design. The detailed component translates broad concepts into a complete and practical plan. During planning, these components overlap with no clear delineation between them. As commanders conceptualize the operation, their vision guides the staff through design and into detailed planning. Design is continuous throughout planning and evolves with increased understanding throughout the operations process. Design underpins the exercise of battle command, guiding the iterative and often cyclic application of understanding, visualizing, and describing. As these iterations occur, the design concept—the tangible link to detailed planning—is forged.\"\n      ]\n    },\n    \"The introduction of the concepts of Design, Operational Design, and the Army Design Methodology was a major change to the way the Army approached campaign planning. The inclusion of lines of effort and lines of operations, coupled with a new operational approach, reshaped how the Army defined problems and solved them. This conceptual framework had a tremendous impact on the conduct of Enduring Freedom, especially as the Army looked at the overall campaign during the 2010–2011 time frame.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_1-1.png\",\n        \"caption\": \"Army Chief of Staff General Peter J. Schoomaker\"\n      }\n    },\n    {\n      \"title\": \"Stresses on the Force\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The difficulty of fighting two simultaneous conflicts created a tremendous amount of stress on the Army, particularly its human component. The physical and mental health of service members, whether active or reserve, suffered under the strain of multiple rotations. Although the Army made efforts to address these concerns, particularly by giving reservists access to much-needed healthcare services, it struggled to mitigate the effects of personnel problems and shortages as it responded to the rising tempo of operations overseas.\",\n        \"${Dwell Time and Its Effect on Resiliency}{bold}\",\n        \"Keenly aware that Secretary of Defense Donald H. Rumsfeld did not support conventional force structure increases as the primary means of meeting sustained operational requirements, Army Chief of Staff General Peter J. Schoomaker instituted a policy known as dwell time in an effort to ameliorate the stress on service members during and in between deployments. As a core component of the Army Force Generation process, dwell time sought to manage the intervals between deployments, providing service members with time to recuperate from their most recent overseas tour while also preparing for their next one. Despite General Schoomaker’s best intentions, the policy of managing dwell time met with mixed success depending on the soldier’s component. Active component service members could expect only twelve to fifteen months at home station between deployments, which was less than the intended goal of a two-year interval. The policy was more successful for reserve component service members: most, but not all, could expect five years at home for every one year deployed. However, the reserve component soon faced a host of unexpected readiness challenges that emerged during the lengthy interval between deployments.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_1-3.png\",\n        \"caption\": \"Michigan Army National Guard Soldiers\"\n      }\n    },\n    \"Meeting dwell time goals proved to be even more elusive as the tempo of operations in both conflicts ramped up. As of 2007, the deployed-to-dwell time ratio for the active component was closer to 1:1, and for National Guard and Army Reserve it was closer to 1:3. The Iraq surge, the Afghanistan surge, the transformation to modularity, and reductions in overall end strength following a brief period of growth all combined to push against the trend to make mobilizations predictable. The rotational nature of the Army Force Generation process rested on the assumption that all soldiers, and reserve component soldiers specifically, found multiple rotations less stressful than long mobilizations. For many reservists, this particular assumption did not hold true. With the added commitments to complete professional education courses and the need to continue the cross-leveling of personnel to fill units, multiple deployments meant that military service was a larger part of a reservist’s life for longer periods. All of this elevated stress on reservists, who did not have access to the support mechanisms of their active-duty counterparts.\",\n    \"As reservists returned home, the burden of combat shifted to civilian healthcare providers and the Veterans Administration. A Walter Reed Institute study published in 2007 found that there was no reason to believe that reservists were less mentally healthy at the start of a deployment than those on active duty, but they faced significant challenges unique to their situation after a deployment. Active component soldiers continued to have day-to-day contact with their units (or at least with other soldiers) after a deployment, unlike their reserve peers who became isolated in their experiences. As a result, some reservists found little relief in their return to civilian employment. Posttraumatic stress disorder, a condition that affected 15 to 30 percent of soldiers, typically manifested three to twelve months after a traumatic event, but reservists faced legal hurdles in receiving treatment if they did not report symptoms of this condition before they left active duty. As the frequency of deployments increased, many employers unofficially balked at hiring or reemploying reservists. In many cases, unemployment meant that reservists lost their health insurance, which added to their stress and created another hindrance to mobilizing troops.\",\n    \"Demobilization became, in essence, the first chance to prepare a soldier for his or her next deployment. However, the one-year cap on mobilized time increased the pressure on the Army to shorten demobilization procedures to a few days. Healthcare exemplifies the case. Medical and dental care, often needed to treat injuries from previous deployments, continued to be the largest single factor keeping reserve soldiers from returning to combat. In 2007, barely 50 percent of returning Army Reserve personnel sent to Afghanistan or Iraq as individual augmentees met dental readiness requirements at the end of their deployment, mainly because of deferred dental work that had deteriorated further during their deployment. The reservists then returned to their original units, but were nondeployable because the constricted demobilization timeline did not leave enough time to fix their medical and dental issues.\",\n    \"These issues motivated the decision to give all National Guard and Army Reserve personnel access to premium-based healthcare at all times, and starting in October 2007 they would receive free healthcare before deployment. By September 2009, more than 100,000 reservists had signed up for this plan. The program expanded options for reservists who were preparing for deployment and provided comfort to families who now knew that loved ones who were injured on duty would be able to receive long-term medical care. It was also one of the most expensive DoD programs provided to the reserve component after the September 11th attacks.\",\n    \"${Stress Within the Force}{bold}\",\n    \"Although Schoomaker factored dwell time into the Army Force Generation process to help manage the negative effects of multiple combat deployments, it did not turn out to be as effective as hoped. The Army’s first mention of perceptible stress within the force appeared in the 2005 Army Posture Statement. Although the statement explicitly referred to stress in terms of the recapitalization of equipment used in combat, the remarks applied equally well to individual augmentees serving in joint task force headquarters and similar organizations, as well as “low-density/high-demand” units such as civil affairs, military intelligence, and military police. The narrative of the Army Posture Statement soon shifted squarely onto soldiers, their families, and civilian workers as increased stress led to skyrocketing numbers of suicides and other self-destructive behavior.\",\n    \"As Army leaders sought ways to cope with the situation, they learned that stress did not affect soldiers only when they were in combat. In fact, soldiers carried that stress back to their home stations after their deployments ended. Early studies of the problem suggested that stress did not dissipate immediately upon soldiers’ return. In fact, the stress levels of soldiers returning from deployments peaked four to nine months after their return—by which time the soldier was already preparing for the next deployment. The secondhand effects of stress took a toll on soldiers’ families. Whether the result of a soldier’s absence during deployment, violent acts committed by a soldier during or after deployment, or bouts of depression experienced by a soldier who had returned home, stress often had traumatic and damaging results.\",\n    \"As rising operational commitments made units deploy more frequently, both soldiers and their families turned to extreme measures, such as suicide or divorce, to end a downward spiral from which there seemed to be no escape.\",\n    \"Suicide occurred more frequently in the Army than in other services. The vast majority of suicides took place not while soldiers were in Afghanistan or Iraq, but after they returned to their home stations. White soldiers were one-third more likely to commit suicide than African American, Asian, or Hispanic soldiers. Junior enlisted soldiers were slightly more likely to take their own lives compared to career noncommissioned officers, while officers committed suicide at a rate just over half that of junior enlisted. Suicides were more likely to take place in the barracks or in on-post housing than in homes located outside of a military installation. Just as disturbingly, studies disclosed that stress did not diminish even after soldiers returned to civilian life. A Veterans Administration study covering the period 2001–2007 disclosed that deployed and nondeployed veterans respectively committed suicide at rates of 41 and 61 percent higher than the general population.\",\n    \"Aside from the direct impact of growing stress on soldiers and their families, reduced intervals between deployments created long-term issues that threatened the collective fabric of the Army. Inadequate dwell time at home station between deployments not only reduced the time needed to adequately balance soldiers’ needs, but also had detrimental effects on their units. The unit and commanders still had to conduct predeployment training, which encompassed everything from individual skills through large-unit collective training. Officers and noncommissioned officers received fewer opportunities to learn more about their profession as impending deployments delayed their military education. A growing number of potential career noncommissioned officers left the active component for civilian life or reservist duty rather than submit their families to repeated deployments with no relief in sight. Those soldiers who remained in the force, officers and enlisted alike, had to concentrate on learning the counterinsurgency and advisory skills needed for combat deployments rather than hone their abilities to a much broader range of combat operations.\",\n    \"The Army took several different approaches to respond to the increasing stress on the force. The onset of readiness and healthcare  problems that followed multiple combat deployments, and the gradual reduction of time spent at home station between overseas tours, became starkly visible in 2008 when suicide rates exceeded the civilian average for the first time. In a direct response to the increased suicide rate and other reports of high-risk behavior, the Army established the Comprehensive Soldier Fitness Program on 1 October 2008. The program was designed to “increase the resilience of Soldiers and families,” decrease posttraumatic stress, reduce undesirable or destructive behaviors, and promote positive growth from stressors. In 2009, General Chiarelli, now vice chief of staff of the Army, visited six installations to examine suicide prevention efforts in the force. He and his team identified a trend of increased self-destructive, high-risk behavior such as self-harm, illicit drug use, binge drinking, and criminal activity. Chiarelli directed the production of what became the Army Health Promotion/Risk Reduction/ Suicide Prevention Report in 2010, also known as the “Red Book” for its cover color. The conclusions in the Red Book cited a “direct link to increased life stressors and increased risk behavior,” but more pointedly, noted:\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_1-4.png\",\n        \"caption\": \"General Chiarelli\"\n      }\n    },\n    {\n      \"list\": [\n        \"For some, the rigors of service, repeated deployments, injuries and separations from Family resulted in a sense of isolation,  hopelessness and life fatigue. For others, a permissive unit environment, promoted by an out of balance Army with a BOG:dwell of less than 1:2, failed to hold Soldiers accountable for their actions and allowed for risk-taking behavior— sometimes with fatal consequences.\"\n      ]\n    },\n    \"Addressing sources of the stressors themselves required a reduction in demand, which started with the end of the Iraq surge in 2007, and continued through 2009 when the last soldiers on fifteen-month deployments completed their combat tours. On 4 August 2011, Secretary of the Army John M. McHugh directed that combat tours be reduced from twelve to nine months for active division headquarters and their subordinate forces. Although corps headquarters and individual augmentation tours remained at twelve months, the change brought the deployed-to-dwell-time ratios back into a semblance of the goals originally set as part of Army Force Generation.\",\n    \"Even as the Army significantly curtailed the length of combat deployment tours in comparison to previous years, it continued its efforts  to combat stress within the force. Chiarelli’s initial findings were followed up in a 2012 report called ${Army 2020: Generating Health & Discipline in the Force Ahead of the Strategic Reset}{italic}, which was nicknamed the “Gold Book” for its cover. The study illustrated trends resulting from deploying the Army’s forces at the intensity required to meet the demand for twenty-three brigade combat teams. The Gold Book featured an update of the Composite Life Cycle Model from the Red Book, illustrating the aggregate stress to the force over time. Whereas previous analyses of stress to the force focused either on equipment or units, stress levels measured across the overall force indicated the situation was more dire than expected. The Gold Book noted that cumulative stress had built up to the point where soldiers were experiencing a lifetime of stress during their first six years in service. Stress typically occurred in overlapping intervals, and when many stressors concentrated at a given time period, it correlated with the greatest risk of self-harm or suicide, as well as related high-risk behaviors or criminal offenses. Obviously this was an issue requiring a generational approach for the Army and all the services to confront and repair in the upcoming years.\",\n    \"${The Unsustainability of Individual Augmentation}{bold}\",\n    \"The sheer number of deployed brigades obscured the fact that the U.S. Central Command (CENTCOM) command and control structure was taxing the force to its limits. Although the modular force structure resulted in less personnel turbulence within tactical units, it did not address staffing needs for headquarters above the brigade level. Divisions, corps, army service component command headquarters, and units serving as land component headquarters or joint task forces still required robust individual augmentation to fill positions coded for skills normally found only above the tactical level within the Army. Examples of the latter category included strategic intelligence, operations research and systems analysis, force management, acquisitions, and strategic plans and policy specialists. The majority of those positions were also found outside of what the Army called its Operations Career Field, which were its traditional command-track branches and specialties. Joint task forces that were not built around existing organizations, such as Multi-National Force–Iraq, Combined Forces Command–Afghanistan (CFC-A), Combined Joint Interagency Task Force 435, and Combined Security Transition Command–Afghanistan (CSTC-A), had to fill personnel requirements from other organizations.\",\n    \"The DoD’s method of sourcing individual staffing requirements across the components, the Worldwide Individual Augmentation System, dated back to the early 1990s. Under that system, initial responsibility for sourcing a requirement in a combatant command area of responsibility fell to the theater army, navy, or air force using its own assets. For the U.S. Army in particular, if the theater army could not meet the requirement, then it was passed back to Headquarters, Department of the Army, which then tasked the requirement out to another Army organization. Tasked individuals deployed under temporary change of station orders—normally orders for up to one year—to fill the wartime requirement, but this temporary deployment left a vacancy in their parent organizations that would not be backfilled during their absence. For short-term contingency operations, sourcing requirements through individual augmentation was not an excessive strain, but over many years it had a detrimental effect on both individual and collective readiness across the entire force.\",\n    \"The long-term requirements of individual augmentation, such as those necessitated by IRAQI FREEDOM and ENDURING FREEDOM, became a major burden on the active Army for certain high-demand, low-density skills. The impact of maintaining this level of readiness through individual augmentation did not become apparent until several years into the conflict, and it differed by component. The reserve component was able to fill the ranks with volunteers in the short term, but by 2004 the lack of available personnel made many units nondeployable. This was most pronounced in the psychological operations and civil affairs forces that were slated to deploy. At the end of 2004, close to 50 percent of Army Reserve personnel (almost 100,000) had been mobilized since 11 September 2001, including 15,000 who had been mobilized twice and 2,000 mobilized three or more times. Within a few months, only 31,000 of 205,000 Army Reserve soldiers were eligible for mobilization under the policy of twenty-four-month cumulative mobilization without a volunteer statement.\",\n    \"In the active component, those pressures became most apparent by 2006. The individual augmentation requirements for both IRAQI FREEDOM and ENDURING FREEDOM started in earnest in 2003. Individual augmentees typically deployed for a full year in a combat zone. During that time, they were unavailable to their organizations, and according to Army personnel policy they could not be replaced as they were on temporary change of station orders. Once they had returned to their home units, they were nominally exempt from deployment for another year as they met mandatory dwell time at home station. Furthermore, wartime requirements created the additional load of filling organizations such as advisory teams or joint manning documents that did not exist in the permanent force structure. However, the Generating Force that was the usual source for those personnel had already been gutted to provide additional personnel spaces to the Operating Force under modularity. In both cases, personnel deficits—especially in low-density, high-demand specialties—peaked during 2007, just as the Army hit its peak demand for brigade combat teams in ENDURING FREEDOM and IRAQI FREEDOM.\",\n    \"Personnel deficits paralleled equipment shortages as the Army shuffled equipment among organizations to meet requirements for the units slated for deployment. This trend did not abate until November 2008, when equipment-on-hand numbers finally began to improve as surge operations in Iraq came to an end. By 2006, active component brigade combat teams were deploying after spending only a year at home station, even with the Army National Guard’s commitment to replace units undergoing modular conversion. Division and corps headquarters were on similar deployment timelines. For much of the Army, there simply were no personnel available to backfill all of the shortages.\",\n    {\n      \"title\": \"The Near-Term Impact of the Iraq Surge on the Army\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Under the force-sizing construct envisioned by the 2001 ${Quadrennial Defense Review}{italic}, the Army maintained an authorized personnel end strength of 480,000 active component, 350,000 Army National Guard, and 205,000 Army Reserve soldiers. Although those authorizations never envisioned the Army supporting two simultaneous regional conflicts, for more than six years the troop figures remained virtually unchanged. From April 2003 to January 2007, the Army usually sent fourteen brigade combat teams to Iraq and another three to Afghanistan while continuing to meet other contingency response requirements articulated in standing war plans. Those figures tilted dramatically when the Bush administration decided to surge additional forces into Iraq. The commitment of additional troops began with the deployment to Baghdad of the 82d Airborne Division’s 2d Brigade Combat Team, then serving as the CENTCOM “call forward force” in Kuwait. On 10 January 2007, President Bush announced that the Army would send four more brigade combat teams from the United States to Baghdad as part of the surge strategy designed to reclaim the Iraqi capital from insurgents. In addition to the five active component brigade combat teams, the National Guard’s 1st Brigade, 34th Infantry Division, would remain in Iraq for 125 days past its original redeployment date.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_1-5.png\",\n        \"caption\": \"Secretary of Defense Robert M. Gates\"\n      }\n    },\n    \"${Curtailing Predeployment Training}{bold}\",\n    \"The need for more personnel in Iraq temporarily overwhelmed both the Army Force Generation process and its related Army policies. Two of the five brigades being sent to Iraq did not have enough time to go to the Joint Readiness Training Center or the National Training Center for their mission rehearsal exercises, originally scheduled for February and May 2007 respectively. Instead, those two combat training centers sent observers/ controllers, role players, opposing forces, and equipment to Fort Lewis, Washington, to train the 4th Brigade Combat Team, 2d Infantry Division, and to Fort Stewart, Georgia, to train the 2d Brigade Combat Team, 3d Infantry Division. Although Army Force Generation originally had been predicated on a deployment cycle in which brigades remained at home station for two years before serving twelve months in Iraq or Afghanistan, brigade combat teams were now deploying less than two years after returning from a previous combat tour.\",\n    \"${Extending Tours of Duty}{bold}\",\n    \"Even before the additional demand from the Iraq surge, the Army’s standard twelve-month deployment tour did not allow the units next to deploy sufficient time at home station to prepare for their combat deployment. The Army’s solution was to increase deployment lengths to fifteen months for active component brigades, which Secretary of Defense Dr. Robert M. Gates announced on 11 April 2007. The rationale for the three-month extension to overseas tours was twofold. First was for “a fair, predictable and sustainable commitment to our troops,” to provide as much advanced notice as possible to units that were deploying, as well as to eliminate uncertainties that surrounded past extensions. The other reason was to provide the capability to sustain the deployed force. The ad hoc mission rehearsal exercises at units’ home stations were a necessary stopgap, but it would be unacceptable to deploy insufficiently prepared forces. Keeping units at home station for a year was the minimum time required to adequately prepare those units that were returning to combat. However, the cuts made to the Generating Force to fill the Operating Force meant that the Army had already mortgaged its institutional capacity to speed up both individual and collective training.\",\n    \"Secretary Gates’ directive met with the approval of General George W. Casey Jr., who assumed the position of Army Chief of Staff from Schoomaker  on 10 April 2007. General Casey described the existing strategic environment as a period of protracted confrontation among state, nonstate, and individual actors using violence to achieve their political and ideological ends. He also emphasized that the Army was out of balance: the demand for forces exceeded the sustainable supply, systems designed for a pre–September 11th peacetime force had been unequal to the pressures of six years of war, and the Army’s readiness was being consumed as fast as it could be built.\",\n    \"${Utilization of the Total Force}{bold}\",\n    \"By late 2007, the increased operations tempo in Iraq compounded the pressures on the force to a critical point. The peak demand to the Army started that October, when it had twenty-three brigade combat teams in combat, of which twenty were in Iraq. At the same time, three brigade combat teams were still operating in Afghanistan. These were the 4th Brigade Combat Team, 82d Airborne Division; the South Carolina Army National Guard’s 218th Infantry Brigade; and the 173d Airborne Brigade Combat Team, which had been redirected from its originally intended Iraq deployment.\",\n    \"The reserve components received some relief from the policy changes initiated in anticipation of the October 2007 peak. On 19 January 2007,  Gates took the next step in transforming the reserves by outlining a new policy on the “Utilization of the Total Force,” codifying best practices for mobilization. It would provide for consistent troop presence; develop a sustainable long-term rotation policy; spread the burden of operational demands across components; provide predictability to service members, families, and employers; and maintain the all-volunteer force for the long war. The policy outlined several key items:\",\n    {\n      \"list\": [\n        \"1.  Planning objectives for the active force would be a 1:2 deploy to dwell ratio, 1:5 for Reserve and Guard. Minimize stop loss [a force management program used to involuntarily retain enlisted personnel] for both active duty and reserve component members. Establish a new program to incentivize or compensate active and reserve members required to deploy/mobilize early or often, or beyond rotational goals. Provide hardship waivers that recognize exceptional circumstances facing members and families of mobilized/deployed members. Manage mobilization of reserve component members on a unit basis. Limit involuntary mobilizations of reserve component members and units to one year.\",\n        \"2.  Minimize stop loss [a force management program used to involuntarily retain enlisted personnel] for both active duty  and reserve component members.\",\n        \"3.  Establish a new program to incentivize or compensate active and reserve members required to deploy/mobilize early or often, or beyond rotational goals.\",\n        \"4.  Provide hardship waivers that recognize exceptional circumstances facing members and families of mobilized/deployed members.\",\n        \"5.  Manage mobilization of reserve component members on a unit basis.\",\n        \"6.  Limit involuntary mobilizations of reserve component members and units to one year.\"\n      ]\n    },\n    \"Although the reserve typically had mobilized for sixteen to eighteen months under previous policies, the new approach limited the entire mobilization and deployment process to one year. The revised deployment cycle consisted of extended training weekends and annual training periods for a year before mobilization, forty-five days of premobilization, and nine months deployed time in theater. The policy also made reserve leadership responsible for predeployment training and certification. This development was a dramatic shift from long-standing guidance that only training witnessed by an active component representative at a designated mobilization station was valid for certifying reserves readiness. The new policy remained unchanged for little more than a year before Congress passed legislation in January 2008 prohibiting the deployment of reservists without a minimum of thirty days’ advanced notice.\",\n    \"That same month, the Commission on the National Guard and Reserves, an independent thirteen-member body charged with studying reserve  component organization, equipment, and compensation, published Transforming the National Guard and Reserves into a 21st-Century Operational Force. The commission’s findings were a policy watershed: it recommended that the reserves be reshaped as a force designed for consistent deployments. The DoD would implement that finding, along with many of the commission’s other recommendations, in DoD Directive 1200.17, Managing the Reserve Component as an Operational Force. The new directive had minimal impact on existing practices, however, because the Army’s deputy chief of staff G–3/5/7 for operations, plans, and training had anticipated the impending changes by almost a year when he issued Execution Order 150–08 on 29 February 2008. This order contained an expansive adjustment of mobilization procedures, which included bringing Army-wide expectations in line with Directive 1200.17, adjusting critical timelines and benchmarks, and providing detailed procedures for training tasks and validations, particularly for nonstandard missions.\",\n    \"${Readiness and Training}{bold}\",\n    \"When the Army realized Afghanistan and Iraq had evolved into protracted conflicts waged by ground troops, it began to discard long-accepted readiness practices. The standards used up to 2001, including tiered readiness, the mix of organizational designs in the force, and particular types of unit or force packages, provided the only broadly quantifiable measure of readiness. The structures of those units were aligned with the acquisitions system and its goals, rather than operational requirements. Such an arrangement would have sufficed had the transformational form of warfare envisioned by the DoD produced rapid, decisive victories. In reality, it became clear that pre–September 11th readiness models and organizational methodologies were increasingly irrelevant given the frequency with which units deploying to Afghanistan and Iraq replaced outgoing units with significantly dissimilar structures and capabilities.\",\n    \"Recognizing that a wartime army could not afford to take risks in its current capability to resource future force development, the Army implemented plans to spend more money to increase force readiness. From 2003 to 2009, a huge amount of supplemental funding was allocated to that program in order to provide combat units with the necessary capabilities to perform all assigned missions in Afghanistan and Iraq. That action also marked a repudiation of the previous vision of transformation. The issuance of the Army Campaign Plan in 2004 meant that the old Army Transformation Campaign Plan, and everything it was supposed to drive, no longer applied. Other changes included cancellation of the Comanche helicopter and the Crusader howitzer, along with major restructuring of the Future Combat System designed to “spiral” capabilities as they were ready as opposed to fielding full combat systems. The Future Combat System lingered for several years in a reduced capacity until it was canceled in 2009, having faced criticism that it did not “adequately reflect the lessons of counterinsurgency and close quarters combat in Iraq and Afghanistan.”\",\n    \"The implementation of modularity and Army Force Generation, combined with Schoomaker’s directive to bring the entire Army to the highest manning possible, sought to ensure that all units, most notably brigade combat teams, received equitable resources and training to fit their intended mission. In sharp contrast to the discarded tiered readiness and resourcing approach, the constant rotation of forces between home station and combat ensured that the state of training and readiness among active component brigade combat teams reached a rough parity. Units that had not been maintained at full readiness before September 2001 now benefited from an Army Force Generation process that allocated resources solely on the basis of scheduled combat deployments. Within the active component, high readiness levels were no longer limited to select units with a contingency response mission. Instead, the preponderance of the force was now trained to the highest levels of readiness based on a unit’s upcoming deployment or mission set.\",\n    \"In addition to improving force readiness, the Army’s involvement in Afghanistan and Iraq meant that light and heavy forces gained a degree of mutual familiarization that would not have happened in peacetime. The nexus between the two communities that began with the creation of Stryker brigades expanded further when the Army deployed all three types of brigade combat teams to fill requirements in a given division’s area of operations, as was the case in 2005–2006 in Multinational Division North in Iraq. The first heavy brigade combat teams to deploy to Afghanistan did so in an advisory role, and two-star headquarters long associated with the mechanized and armor community, such as the 3d Infantry Division, 1st Infantry Division, and the 1st Cavalry Division, began serving as regional command headquarters in Afghanistan from 2011 onward. Time and repetitive combat rotations helped break down the divides between the light and heavy subcultures.\",\n    \"Although units from various communities worked with increasing harmony and synchronization in overseas combat zones, predeployment training continued to focus on specific mission-oriented tasks rather than a broader approach to honing warfighting proficiency. An unintended effect of that approach, which concentrated on specific deployed mission-essential tasks at the expense of core mission-essential tasks, resulted in a loss of proficiency for traditional skills such as combined arms warfare. That troubling development convinced Col. Sean B. MacFarland, Col. Michael H. Shields, and Col. Jeffrey J. Snow, who had respectively commanded the 1st Brigade Combat Team, 1st Armored Division; 172d Infantry Brigade Combat Team; and the 1st Brigade, 10th Mountain Division, to formulate and send a white paper to Army Chief of Staff General Casey.\",\n    \"That jointly authored document, released in May 2008, minced no words with its title: “The King and I: The Impending Crisis in  Field Artillery’s Ability to Provide Fire Support to Maneuver Commanders.” The authors asserted that “no branch of the Army has suffered a greater identity crisis than Field Artillery, as a result of transformation, COIN-centric [counterinsurgency] operations, and the nonstandard staff demands of OIF/ OEF.” The basic premise was alarming in itself, but the white paper also provided a wealth of evidence from home station and the combat training centers highlighting the fact that the loss of those skills and the attrition of experienced artillerymen risked “mortgaging not only flexibility in today’s fight, but our ability to fight the next war as well.” The paper, one of the few internal critiques of modularity, went viral soon afterward. Anticipating that decreasing force levels in Iraq from 2008 onward would permit more emphasis on regaining proficiency in core mission-essential warfighting tasks, the Army acknowledged the concerns raised by MacFarland, Shields, and Snow by issuing updated training and leader-development guidance. The new directive stated that active units with eighteen months or more (thirty-six months for reserve units) of dwell time would retrain on core mission-essential warfighting tasks in addition to their deployment-oriented mission-essential task training, while units with twenty-four months or more dwell time would regain proficiency in both core tasks and deployment tasks. In the years to follow, many of the modularity force structure changes would be reversed.\",\n    \"The mission-specific requirements of the Afghanistan and Iraq conflicts not only influenced the Army’s overall training philosophy but also created internal organizational tensions, arising from the use of a predominantly conventional force against irregular opponents. An increasingly vocal group of irregular warfare proponents sought to influence the ongoing debate over the roles, missions, and structure best suited for the Army. Two influential papers published in 2007 and 2008 highlighted their views. The first, “An Army at the Crossroads” by Andrew F. Krepinevich, proposed a formal division of forces between those geared to conduct irregular warfare and security force assistance versus those focused on major combat operations. The second, “Institutionalizing Adaptation” by Lt. Col. John A. Nagl, proposed the creation of a permanent advisory corps using personnel drawn from the conventional force. Although the papers had a considerable following, the successes of the Iraq surge convinced senior Army leaders that conventional forces could conduct irregular warfare as well as they carried out major combat operations. In addition, the Army’s institutional expertise in advising was already resident in the Special Forces, and conventional forces could and did supplement these capabilities as needed.\",\n    {\n      \"title\": \"An Army Out of Balance\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Even with the ongoing revisions to doctrine and structure intended to improve efficiency and overhaul the service’s approach to twenty-first-century warfare, the Army faced one overarching problem: it simply did not have enough soldiers to carry out its missions. After years of constraints on the force structure, the Bush administration embarked on an ambitious plan to grow the Army across the board, with a particular focus on the skill sets needed for continued operations in Iraq and Afghanistan.\"\n      ]\n    },\n    \"${Grow the Army}{bold}\",\n    \"In early 2007, President Bush approved adding 74,000 active Army, 8,200 National Guard, and 1,000 Army Reserve soldiers to the force. That increase allowed for an initiative that became known as “Grow the Army,” resulting in an authorized permanent end strength of 547,000 active personnel and 358,200 national guardsmen by 2010, as well as 206,000 reservists by 2013. The decision to increase the Army force structure signaled the Bush administration’s acceptance of the fact that the Army had to expand because there was no other way to reduce the amount of time soldiers were deployed versus at home. Army Force Generation planners had optimistically estimated the deployed-to-dwell ratio as not exceeding 1:2 for the active component and 1:5 for the reserve component. In reality, most active component brigade combat teams were deployed at a 1:1 ratio, with certain portions of the reserve component force, predominantly military intelligence and aviation units, at a 1:3 ratio.\",\n    \"The Grow the Army initiative began to reverse the previous Army end strength plan for modularity, which had paid for the Army’s deployable Operating Force increases by cutting the Generating Force and lesser-used combat formations. On numerous occasions, the Army had redirected or reappropriated the Generating Force’s personnel and resources to make up deficits in other areas, ranging from bringing the entire force to the highest readiness levels, to modular conversions, individual augmentation, and the Iraq surge. However, that approach was a short-term solution at best. The Generating Force was the Army’s institutional repository of knowledge and skills, and it needed sufficient instructors, trainees, transients, and students to continue to resource future requirements in the Operating Force.\",\n    \"Secretary Gates further approved an accelerated Grow the Army plan that would restore balance in the force in 2011, rather than 2013 as originally planned. This increase would create another six infantry brigade combat teams, two signal brigades, and one additional brigade in fires, maneuver enhancement, battlefield surveillance, sustainment, air defense, and engineers. In the meantime, the Army accepted that the Generating Force would have to make do with its existing resource and personnel shortages until the Operating Force expanded enough to meet demand.\",\n    \"The first brigade combat team to be built from scratch as part of that expansion, which was flagged as the 3d Infantry Brigade Combat Team, 1st Armored Division, initially stood up on 2 July 2009—spanning four force generation cycles from decision to availability of the first new Grow the Army unit. The new brigade then underwent almost two years of training, culminating with a June 2011 validation exercise at Fort Irwin, California, before deploying five months later to Afghanistan. Other units built under the provisions of Grow the Army had been converted from units that were already in the force structure and were not representative of the true time required to build a unit from scratch. No matter what plans or programs were implemented to accelerate the growth of the Army, it would simply take time to build and train ready forces for deployment in combat.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/grafik_Fig1-6.png\",\n        \"caption\": \"Efforts to Bring the Army into Balance by 2011\"\n      }\n    },\n    \"Even though it took several years to produce a deployment-ready infantry brigade combat team from scratch, Grow the Army did not create any heavy brigade combat teams, which also would have placed a much greater demand on the supporting industrial base. The Army sought to avoid exactly that type of situation because it was still reconstituting its prepositioned equipment stockpiles, which had been depleted as units rotated through combat operations in Iraq and Afghanistan.\",\n    \"The expansion also allowed the Army to end certain policies that had been difficult but unavoidable for the force. President Bush reinstituted twelve-month deployments on 10 April 2008, effective for units deploying after 1 August 2008, to return to a dwell time of two years at home station for each year deployed. The president’s directive happened to coincide with the withdrawal of the five surge brigades committed to IRAQI FREEDOM. In the sixteen months that the Army used those units in the Iraq surge, multiple active brigade combat teams had an aggregate deployed-to-dwell ratio below 1:1.\",\n    \"The combined effects of the end of the Iraq surge and the expansion in troop numbers also allowed the Army to end the force management program known as stop loss, in which the Army involuntarily extended or retained active-duty enlisted personnel beyond the end date of their enlistment. Stop loss had existed in various forms since 2002, mostly to prevent soldiers in critical occupation fields from leaving the military, but its most unpopular form started in late 2003 and affected all personnel (regardless of component) in units that were slated to deploy. On 18 March 2009, Secretary Gates announced that the stop loss policy would end in August and September for the reserve component and on 1 January 2010 for the active component.\",\n    \"${Growing Special Operations}{bold}\",\n    \"Efforts to field sufficient Special Forces personnel to meet the combined requirements of both Afghanistan and Iraq predated programs to expand conventional forces. The 2006 National Defense Authorization Act included a proposal to increase Army Special Operations authorizations over the next four years. The increase sought to expand each active component group by one battalion, add a forward-support company to each Special Forces battalion, and expand the group-support battalions. Army National Guard Special Forces battalions would not undergo identical changes, but they received additional support units, including augmented military intelligence, logistics, and reconnaissance detachments. To meet the additional personnel demands, U.S. Army Special Operations Command also received permission to form a Special Operations recruiting battalion.\",\n    \"The force structure increases in the defense act affected more than just the seven active and reserve Special Forces groups. The 160th Aviation Regiment (Special Operations), which supported not only the groups but also Joint Special Operations Command, doubled in size to six battalions. The 75th Ranger Regiment added a Ranger company and a forward-support company to each of its three battalions, and bolstered its intelligence, reconnaissance, and surveillance capabilities. In addition, the sole active component civil affairs battalion expanded to form the 95th Civil Affairs Brigade, which would provide dedicated support to deployed SOF. A second active component civil affairs brigade was projected to be activated in 2009 to perform a similar function for conventional forces. Recognizing the need to fully support an increased number of deployed units, the 528th Support Battalion tripled in size to become the 528th Sustainment Brigade. These proposals were approved without significant modification, which allowed the expansion to begin as scheduled in 2007.\",\n    \"Increased SOF force structure meant additional buildings, training areas, and facilities, and realignment of training and deployments to support conventional forces whenever possible. The Special Warfare Center and School readily adapted to growing requirements for qualified Army SOF, and did so in a deliberate manner. To train more personnel and units, it expanded existing facilities at Camp Mackall, North Carolina, eventually moving an entire training battalion there. Simultaneously, each SOF group received additional facilities at Forts Campbell, Bragg, and Lewis to accommodate their fourth battalion and to meet their increased sustainment and training requirements.\",\n    \"As the ranks of the SOF community swelled, individual SOF units found themselves competing for access to ranges and training areas on major installations with sister organizations as well as conventional units. Seeking a near-term solution to that challenge, Army Special Operations turned to contractors in order to maintain, refine, and enhance their shooting, driving, and sustainment skills. The contractors conducting this training provided fully supported, dedicated training areas and instructors, as well as adaptive scheduling. Special Operations personnel attending the training later disseminated the techniques they learned to other members of their units upon returning to home station.\",\n    \"After evaluating the results of the initial contracted training programs, Army Special Operations leadership expanded them to include other specialized mission-essential skills such as diving, military freefall operations, and the newly added multipurpose canine enablers. More Special Operations personnel requested contractor-led training, and some even felt that the training set the standard for determining a team’s deployment readiness. U.S. Army Special Operations Command initially funded these courses and eventually incorporated them into their programmed budget request.\",\n    \"Reliance on contractor support augmented, rather than diminished, the Special Warfare Center and School’s role in providing advanced skills training. Based on lessons learned and collected from teams returning from combat tours, the Special Warfare Center instituted new courses tailored for troops in Afghanistan, such as high-angle shooting, pack animal operations, and parachute resupply. Unlike the conventional army, which had access to combined arms training centers, the Special Warfare Center and School did not have the ability to conduct predeployment certification rotations—featuring friendly and neutral role players as well as simulated enemy forces—at a specially tailored training center resembling the remote, isolated environments they would encounter in Afghanistan and Iraq.\",\n    \"By 2009, however, U.S. Army Special Operations Command gained the funding necessary to create a Special Operations training facility  at Fort Bliss, Texas. Although the new facility addressed long-deferred collective training requirements, it failed to meet a critical shortfall for the Army: incorporating Special Operations training and support into an overall exercise with conventional forces. This mission belonged to the combat training centers and could never be completely satisfied for several reasons. First, the seven-month rotation cycles for Special Operations personnel rarely matched the conventional force’s twelve-month deployment cycles, making it difficult to coordinate predeployment training and their respective arrival dates in theater. Second, the inherently light nature of Army Special Forces meant that the majority of their training center rotations took place at the Joint Readiness Training Center at Fort Polk, Louisiana, rather than the National Training Center at Fort Irwin—while conventional forces trained at both locations. Third, as the Special Operations commitments in theater increased, they had less time for anything besides mission-critical predeployment training.\",\n    \"An often overlooked development during this period was the growing reliance on female soldiers within Special Operations. With all Special Forces and Ranger authorizations coded for male soldiers, Army Special Forces relied heavily on female soldiers in its civil affairs, psychological operations, support, and staff organizations to engage with female civilians who made up 50 percent of the population in Afghanistan and Iraq. Recognizing the need to communicate with these individuals, Army Special Operations formed ad hoc teams of female soldiers as early as 2002 to enhance civil-military operations. By 2009, U.S. Army Special Operations Command formally created a new organization known as a cultural support team. Cultural support teams interacted with indigenous female populations when such contact was deemed culturally inappropriate if performed by a male soldier. Although similar to the female engagement team program for conventional units, cultural support team members were specifically assessed, selected, trained, and educated to support Army Special Operations. The cultural support teams participated in a wide spectrum of activities ranging from medical civic-action programs, searches and seizures, humanitarian assistance, and civil-military operations.\",\n    \"Not only did the Special Operations community have to meet operational requirements while synchronizing force structure increases, constructing additional facilities, and allotting sufficient preparation time to deploying units, it also had to cope with unforeseen decisions by the Base Closure and Realignment Commission. The commission was created to provide an objective, thorough, accurate, and nonpartisan review and analysis, through a process determined by law, of the list of bases and military installations that the DoD recommended be closed or realigned. In 2007, that body determined the 7th Special Forces Group, 1st Special Forces Regiment, would relocate from Fort Bragg, North Carolina, to Eglin Air Force Base, Florida, by 2011. However, because Eglin Air Force Base did not have facilities to accommodate the incoming unit, the DoD spent $255 million to construct new ranges, training areas, motor pools, and barracks before the 7th Special Forces Group arrived. The move also effectively precluded the 7th Special Forces Group from serving as the headquarters and primary force-providing elements for Combined Joint Special Operations Task Force (CJSOTF)–Afghanistan from mid-2010 through late 2011. This only added to the tempo and stress of the other Special Forces Groups who had to fill the void.\",\n    \"As an institution, the U.S. Army’s evolution during these years was critical to its ability to support the Global War on Terrorism with trained and ready forces, as well as to the development of updated counterinsurgency doctrine to guide those operations. As the following chapters will show, this doctrine provided a sound basis for future operations in both Afghanistan and Iraq. Doctrine was only a part of the overall project; efforts to relieve stresses on the force were another vital component. Getting dwell time back to acceptable lengths, reducing stress on military families, improving medical and dental readiness, growing the force, and updating training facilities all would be key elements needed to sustain the U.S. Army through the conflicts ahead.\"\n  ],\n  \"chapter  2\": [\n    {\n      \"title\": \"A War in Transition\"\n    },\n    {\n      \"section\": [\n        \"With the completion of the Bonn Process, Afghanistan possessed the framework for a centralized state that could support the U.S.-led Global War on Terrorism. However, adopting a constitution, holding elections, and forming a government did not by themselves guarantee a functioning bureaucracy or popular support. To achieve those objectives, the state needed to protect its population from foreign and domestic threats, provide essential services such as healthcare and education, and support an economic environment in which people provided for themselves and their families. Consequently, linking the state apparatus established during the Bonn Process to the general populace was necessary for creating a unified nation. As Ambassador Ronald E. Neumann stated, “The fundamental issue all along has been that if you have the goal of preventing a recurrence of terrorism in the country then you have to have a security force to do that. To have a security force you have to have a government. To have a government you have to have a state and an economy. And then you’re doing nation-building.”\",\n        \"${Implementing the NATO Operational Approach}{bold}\",\n        \"As the lead nation for building the Afghan National Army (ANA) under the Bonn Process, the U.S. effort that started with only a few Special Forces detachments had expanded into the Office of Security Cooperation–Afghanistan, an element of Operation ENDURING FREEDOM coequal with its counterterrorist operations under Combined Joint Task Force 76 (CJTF-76). Insurgent attacks in 2005 and 2006, however, made it evident that more work needed to be done before the Afghan government could provide its citizens with adequate security. Lt. Gen. Karl W. Eikenberry and Ambassador Neumann inherited a program to develop the Afghan Army that was well underway by 2005, as well as efforts to build the Afghan National Police (ANP) that could not yet meet the nation’s basic security needs.\",\n        \"After the coalition removed insurgents from communities, a representative of national authority had to secure the population and demonstrate the Afghan government’s presence before Provincial Reconstruction Teams, nongovernmental organizations, and other agencies could inject seed money to build local institutions. Neumann and Eikenberry focused on building indigenous security forces because they saw the Afghan army and police as fulfilling important roles in establishing a functioning Afghan state. While they championed Afghan participation in ongoing combat operations, they also embraced the continued upgrading of Afghan National Security Forces (ANSF) capabilities. In the view of Eikenberry and the CFC-A, ANSF owned the “hold” phase of the “clear, hold, build, and engage” counterinsurgency model.\",\n        \"The Bush administration held views similar to Eikenberry and Neumann, but for different reasons. It viewed Afghanistan’s National Assembly and provincial council elections as the culmination of the Bonn Process and a potential transition point for ENDURING FREEDOM. The elections prompted Secretary of Defense Donald H. Rumsfeld to ask Joint Chiefs Chairman General Richard B. Myers in January 2005 for a strategic approach to Afghanistan for the next twelve to eighteen months. “I think it is critically important that we, very promptly, have a plan for the rest of this year in Afghanistan,” wrote Rumsfeld. “If we announce it and it is a good plan, it can have a positive effect in Iraq.” The note indicated that although the Pentagon needed clear direction in Afghanistan, the secretary’s focus remained on the war in Iraq.\",\n        \"Rumsfeld’s concerns stemmed from his belief that the United States could not maintain its current levels of commitment in Afghanistan as violence mounted in Iraq. As CFC-A understood it, Rumsfeld sought to put U.S. forces on a path out of Afghanistan. He demanded weekly metrics from CFC-A showing progress in ANA training and customs collection and the public revenue necessary for the Afghan government to sustain its army. To hasten the development of Afghan security capabilities, the defense secretary also sought to gain control of training the ANP. He understood that “an effective, professional police force” would be “central to the achievement of [the] U.S. Government’s strategic objectives in Afghanistan.” Effective police forces were needed for counterinsurgency (in support of similar ANA efforts), political development (such as election security), counternarcotics (including interdiction and eradication), border security, customs collection, domestic law and order (personal security for the Afghan people), and the disarmament and demobilization of the remaining private militias. In April 2005, after much interagency and congressional wrangling, the State Department relinquished its responsibility for overseeing Afghan police training to the DoD.\",\n        \"Meanwhile, Rumsfeld also pushed NATO to increase its combat involvement in Afghanistan. Even though ISAF initially agreed to expand into RC West, force generation issues prevented that expansion from happening before the Afghan presidential election. When NATO forces did arrive, the North Atlantic Council could not reach an agreement with the Bush administration about merging the ENDURING FREEDOM (counterterrorist) and ISAF (security) missions. At a meeting of NATO defense ministers in Berlin in September 2005, Germany—with the support of France, Britain, and other European countries—made it clear that they would not accept such a merger. Rumsfeld seemed intent on beginning a U.S. drawdown, with or without increased NATO involvement, as reports surfaced that the Pentagon was considering downsizing the U.S. presence by as much as 4,000 troops.\",\n        \"With the Bonn Process completed and the war in Iraq showing no signs of ending, the American government unilaterally decided to reduce resources already allocated for Afghanistan. The administration reduced total spending on the country from $4.9 billion in fiscal year 2005 to $3.5 billion in 2006. Cuts across the board included significant reductions in the security, governance, development, and humanitarian allocations. In terms of deployed troops, the United States had just 19,500 service members in Afghanistan in April 2005, compared to roughly 137,000 in Iraq. American policymakers continued to press for keeping the U.S. Army’s footprint in Afghanistan small. As a result, Rumsfeld ordered the 10th Mountain Division to trim its planned 2006 ENDURING FREEDOM deployment by roughly 40 percent. The decision reduced the projected number of American forces in Afghanistan from 19,000 to 16,000 by spring 2006.\",\n        \"With the Bush administration intent on reducing U.S. military participation in Afghanistan, NATO took steps to secure and develop the country until the Afghans were capable of doing so themselves. By September 2005, the treaty organization expanded ISAF’s footprint into RC West. Three months later, the North Atlantic Council agreed to a timeframe for taking over RC South and RC East. That same month, NATO revised Supreme Allied Commander Europe Operational Plan 10302 to better align its political and military goals with those pursued by the United States. Politically, NATO aimed for “a self-sustaining, moderate and democratic Afghan government able to exercise its sovereign authority, independently, throughout Afghanistan.” NATO planned to achieve these goals through security and stability operations, in particular through reconstruction teams who would “expand the beneficial ISAF effect” into unassimilated provinces. Militarily, the goal was to develop ANSF to the point that they could “provide security and sustain stability . . . without NATO support.” As with the United States, NATO’s exit from Afghanistan was “dependent on the successful development of credible, professional and legitimate Afghan security structures.” In contrast with earlier American campaign language, the plan called on NATO to “operate with subtlety and a light touch” and to “facilitate the continued physical and moral extension of Afghan government authority.”\",\n        \"The Pentagon welcomed this pathway to securing Afghanistan because it did not rely exclusively on U.S. troops. The shift to international responsibility meant that the United States could begin extricating its forces and sending them to Iraq. In deciding on this course of action, Rumsfeld listened to his closest military advisers rather than their civilian counterparts. Even though Rumsfeld shared his civilian advisers’ worries that ISAF’s capabilities would be limited by member nations’ caveats on force contributions, NATO’s inability to sustain itself over long distances without U.S. assistance, and the inevitable reduction in American influence following a U.S. troop drawdown, he ultimately accepted the military’s opinion that NATO was ready. The next four years would show this assessment to be a critical miscalculation that ignored the enemy’s ability to alter the strategic equation.\"\n      ]\n    },\n    {\n      \"title\": \"The Afghanistan Compact\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"As the United States and NATO worked to transition the ISAF mission, President Hamid Karzai’s government and the international community made new plans for Afghanistan’s future. At a January 2006 conference in London, all parties agreed on a new framework to guide development for the next five years. The subsequent Afghanistan Compact amounted to a pledge by the international community to “build lasting Afghan capacity” with an eye toward Afghan “ownership,” and in return the Afghan government promised to “combat corruption and ensure public transparency and accountability.” Combined with an Interim National Development Strategy agreed upon around the same time, the Afghanistan Compact set specific deadlines for improving security, governance, and economic development.\",\n        \"The compact called for the disbandment of all “illegal armed groups” in 2007, an ethnically balanced Afghan  army of 70,000 to be fully operational by 2010, and a combined ANP and Border Police component of 62,000 by the end of 2010. Among the numerous development initiatives, two in particular would affect U.S. Army operations: the call for a “fully upgraded and maintained” Ring Road, with arteries connecting Afghanistan’s main national highway to neighboring countries by the end of 2008; and an electric system that could supply 65 percent of households and 90 percent of nonresidential establishments in urban areas, as well as 25 percent of households in rural areas, by the end of 2010. Sixty countries represented at the London Conference pledged more than $10 billion to fund these projects. This sum was significant but met only half of Afghanistan’s projected needs for the next five years. To guide program implementation and report on progress, the Afghanistan Compact also established a Joint Coordination Monitoring Board of international and Afghan representatives in Kabul.\",\n        \"For the U.S. Army, the compact’s most relevant portions dealt with security. Its authors articulated that ISAF, U.S. forces, and partner nations would continue to “provide strong support to the Afghan Government in establishing and sustaining security and stability in Afghanistan, subject to participating states’ national approval procedures.” Security and stability operations would become ISAF’s responsibility, particularly through Provincial Reconstruction Teams, which would increase in number to cover the entire country by the end of the year. The agreement further stated that the ENDURING FREEDOM counterterrorism mission, specifically identified as a separate American effort, would be closely coordinated with the Afghan government and ISAF. Taken as a whole, the Afghanistan Compact reaffirmed the international community’s involvement in and support for Afghan development and formalized the process by which NATO would assume the strategic lead for coalition activities in Afghanistan. The United States would continue to conduct counterterrorist operations, but it would fold most American forces into the ISAF structure.\",\n        \"Unfortunately for the coalition, none of the plans for Afghanistan’s future—America’s gradual exit, NATO’s assumption of the stability mission, and the Afghanistan Compact—fully accounted for the realities on the ground. Requests for increased resources by American leaders in Afghanistan went unfilled by Washington. Throughout the fall and winter of 2005–2006, Ambassador Neumann fought to increase funding for agriculture and infrastructure development programs with little success. He warned in October 2005 that the embassy could not implement the National Security Council’s comprehensive strategy without additional monies. In a February 2006 cable, he argued that the United States stood to lose years of critical infrastructure development, especially in the transportation and energy sectors, with negative strategic consequences for the overall war effort.\",\n        \"General Eikenberry separately recommended increases for the train-and-equip missions for both the ANA and the ANP. Unfortunately for America’s ranking civilian and military leaders in Afghanistan, the Office of Management and Budget was dealing with more urgent priorities in Iraq and the aftermath of Hurricane Katrina at the time, and ultimately included only $32 million (rather than the $600 million originally requested) for Afghanistan in the emergency supplemental budget that year. As other priorities diverted and distracted the Bush administration’s attention over the next three years, circumstances in Afghanistan slowly deteriorated.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_2-1.png\",\n        \"caption\": \"Maj. Gen. Jason K. Kamiya\"\n      }\n    },\n    {\n      \"title\": \"The Situation in Fall 2005\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"At the operational level, the 2005 National Assembly and provincial council elections had little influence on U.S. forces in Afghanistan. Based out of Camp Eggers in Kabul, General Eikenberry continued to exercise command and control through his two major subordinate headquarters, the Office of Security Cooperation–Afghanistan under Air Force Maj. Gen. John T. Brennan and CJTF-76 under Maj. Gen. Jason K. Kamiya. Kamiya’s maneuver forces consisted of Col. Patrick J. Donahue II’s 1st Brigade Combat Team, 82d Airborne Division (Task Force DEVIL), located in RC East, and Col. Kevin C. Owens’ 173d Airborne Brigade (Task Force BAYONET) in RC South.\",\n        \"As the CJTF-76 commander, Kamiya exercised operational control over all conventional U.S. Army forces in the country, as well as CJSOTF-Afghanistan until December 2005. To support CJTF-76’s main lines of effort, U.S. SOF conducted counterterrorism operations against high-value targets, foreign internal defense operations in support of the new Afghan government, and security assistance to develop ANSF participation in security sector reforms. At the operational level, the SOF mission included supporting the National Assembly and provincial council elections; disbanding the Afghan militias under the disarmament, demobilization, and reintegration programs; and preparing for the realignment of coalition SOF under ISAF. At the tactical level, SOF aided CJTF-76 with armed reconnaissance, network assessment, and battlefield preparation. A combination of nonlethal and lethal operations had succeeded in safeguarding the presidential elections in 2004 and, to a lesser degree, the national and provincial elections in 2005. Kamiya looked to continue the practice for as long as he had the authority to do so. With the help of Special Forces, Kamiya increasingly emphasized civil affairs and psychological operations during this period. These techniques for exercising influence became particularly relevant as Provincial Reconstruction Teams increased in number.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-2-2.svg\",\n        \"caption\": \"Force Laydown\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"With the SOF remaining under CJTF-76 until December 2005, they requested permission to change missions from guarding borders to developing, partnering, and advising newly trained ANA infantry kandaks (Afghan battalion-sized unit). Recognizing the role that Operation NEWBURGH played in securing the elections, Kamiya approved the request, directing the Special Operations Task Force to issue a new directive named VALLEY FORGE in October 2005, outlining the change in mission. To ease the planned handover, Operational Detachments Alpha (ODAs) holding isolated firebases along the Afghanistan-Pakistan border in RC East and RC South were augmented with infantry squads or an infantry platoon in order to familiarize incoming units with mission requirements.\",\n    \"As the order was being finalized, the command’s ODAs transferred their border mission to conventional forces while preparing for 7th Special Forces Group’s return. The change ensured the incoming group would become intimately involved in training and partnering with ANA kandaks, border police, and local security forces. The new mission also meant that special operations units would be working throughout the country rather than along the borders, which translated into a significant need for additional airlift. With the Army sending most of the 160th Aviation Regiment (Special Forces) to Iraq, a dearth of dedicated airframes, combined with poor roads in many parts of RC South and RC East, forced SOF to rely increasingly on conventional army airframes, which often were not equipped to the same standards as SOF aircraft.\",\n    \"The SOF were not alone in having to meet their mission objectives with limited resources. Eikenberry understood that political leaders in Washington expected U.S. troop levels to drop over the next several years. Correspondingly, he viewed his primary mission as creating “the conditions for a successful battle handoff from CFC-A to ISAF.” He had reduced Lt. Gen. David W. Barno’s lines of operation from twelve to three. Security remained the primary focus for CFC-A in this reduction, with the interconnected goals of defeating al-Qaeda and its associated groups and building up the Afghan government’s ability to provide for its national security as supporting lines. Two parallel lines of effort—governance and justice, and economic and strategic reconstruction—now supported the security thread. Counternarcotics operations remained a tertiary goal, integrated into the primary and secondary lines of operation. Finally, Eikenberry set for himself the tasks of engaging with Central Asia governments and communicating the threat posed by Pakistan to Washington.\",\n    \"While Eikenberry harmonized CFC-A’s theater approach with ISAF’s increased operational role, Kamiya cautioned his Task Force commanders that “the enemy, realizing defeat in his efforts to derail the election process, will launch at least one more offensive surge prior to beginning withdrawal to winter sanctuary [in Pakistan].” U.S. forces would “meet his [i.e., the enemy’s] challenge by sustaining the tempo and nature of our offensive operations.” To do so, Kamiya called for “equally aggressive non-kinetic, offensive-oriented CERP [Commander’s Emergency Response Program]/civil military operations in those areas that the enemy will cede to us due to the oncoming of winter.” Kamiya further noted that although initial planning requests for emergency response funds totaled some $67 million for fiscal year 2006, that amount would grow to $166 million by the end of the fiscal year. Thus, U.S. forces sought to bolster their gains along the Pakistani border during the remainder of 2005 with an ambitious aid program designed to foster support among the local population. An aggressive program of information operations highlighted projects to erode the standing of enemy leaders and build support for Afghan government officials. As Kamiya recalled, “We are engaged in an information campaign that is supported by military operations. We are no longer in a military campaign supported by military operations.” General Kamiya and the CJTF-76 headquarters, the Southern European Task Force, were scheduled to rotate out of Afghanistan in early 2006. In preparation, CJTF-76 crafted its last major operation, SECURE PROSPERITY, to begin in February 2006 and continue into the 10th Mountain Division’s deployment. In congruence with the contraction of U.S. forces in theater to RC East, the plan called for targeting Hezb-e-Islami Gulbuddin (HIG) until it was “defeated and incapable of supporting [al-Qaeda] operations or disrupting the CJTF relief-in-place process.” Operations in central and southern RC East, as well as those in RC South, were to “contain” Haqqani and Taliban forces while, at the same time, build Afghan security force capabilities. The four-phased operation included elements of U.S., coalition, Afghan, and Pakistani forces on both sides of the border. The operation’s goals were to deny the enemy a permanent base of operations in Afghanistan, to maintain continuity of operations during the U.S. transition, to increase Afghan confidence in their own security forces, and to establish a more permanent Afghan security presence in northern RC East, to include establishing a reconstruction team in Nuristan Province. By acclimating Afghan forces to winter operations, Kamiya hoped they would stay close to local communities long enough to build relationships and prevent a resurgence of the insurgency in the spring.\",\n    \"With the successful National Assembly and provincial council elections and apparent synchronization of the ENDURING FREEDOM and ISAF missions, ISAF moved forward with its plan to take over the final two regional commands in 2006. After months of deliberation and planning, NATO announced in December 2005 that it would accomplish that goal over the following year. The move to RC South would be completed by midsummer 2006. A Canadian Task Force would deploy in the spring, operating under CJTF-76 until additional NATO forces arrived and RC South transitioned to ISAF control. After that, ISAF would take control of RC East. CJTF-76 would contract its forces into the region and shift from CFC-A to ISAF command sometime in the fall. With the transition finalized, CFC-A would be disbanded and ISAF would become the headquarters responsible for all military operations in Afghanistan.\",\n    {\n      \"title\": \"Reforming the ANP Training Mission\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"As American forces prepared to transition security responsibilities to NATO ISAF, the Office of Security Cooperation spent the latter half of 2005 building a police program and supporting ANP training. The realization that trained and equipped police units were just as important as ANA units gained increasing traction among American and NATO officials as the transition to ISAF control loomed. In December 2005, President Karzai approved an organizational document known as the tashkil (from the Dari word for “organization,” used here in the sense of an official list) that dictated “force structure, personnel end strength, command relationships, and unit/staff functions and mission descriptions for the ANP.” The product of negotiations between the German Police Project Office and the Afghan Ministry of Interior, with input from the United States and other international partners, the tashkil set the maximum size of the ANP at 62,000. The Afghanistan Compact detailed this desired end state in early February 2006, stating that the ANP not only would become “fully constituted, professional, functional and ethnically balanced” by the end of 2010 but also would be “able to meet the security needs of the country and will be increasingly fiscally responsible.” Considering the current state of the force, these were ambitious goals.\",\n        \"In addition to overseeing the creation of the tashkil, General Brennan initiated pay and rank reform to “break the chain of corruption” that low wages encouraged and designed a nationally recruited police force that based rank and promotion “on merit, not loyalty or connections.” To oversee the effort, the Ministry of Interior formed an all-Afghan board known as the Rank Reform Commission. After consulting with the Office of Security Cooperation–Afghanistan, the commission determined that all new officers would be graduates of the police academy and both new and existing officers would be paid according to new pay scales. Salaries would be funded from the Law and Order Trust Fund for Afghanistan at the annual rate of $75 million. As conceived by the Security Cooperation headquarters, the commission would finish its work by June 2006. Unfortunately, this milestone also proved ambitious. The new protocol called for all officers to take a written exam and mandated both a file review by the Rank Reform Commission and vetting for human rights abuses by the United Nations (UN) Assistance Mission and State Department officials. Widespread illiteracy and the paucity of available records meant that vetting the almost 20,000 officers and noncommissioned officers took longer than anticipated; the final phase (selecting sergeants and patrolmen) did not begin until May 2007.\",\n        \"Reforming the Afghan police required effective leadership as well as time. By necessity, selecting senior ANP officers became the first step in instituting change. After the Reform Commission chose the ANP’s most senior generals, it filled the Ministry of Interior’s 34 provincial police chief positions from a pool of 317 applicants. Driven by a different understanding of effective leadership, Karzai ignored the commission’s recommendations and named his own appointees, including fourteen individuals who either had failed their exams or were known to be corrupt. Although the president eventually agreed to replace eleven of the fourteen generals with commission recommendations, his intransigence set the process back six months.\",\n        \"Karzai’s reluctance to follow his commission’s recommendations highlighted the difference between Afghan and Western concepts of effective governance. While Americans and their allies wanted to remove the corruption they believed was impeding institutional growth, Karzai viewed the political landscape differently. He needed influence and a support base to maintain his position, and experience in Afghan politics had taught him that effectiveness depended on indebting powerful leaders to himself and his network. According to Ambassador Neumann, “Without force, money, or unified support within the government, the power of appointment to build political support networks was Karzai’s only political tool.” By distributing political offices as far down as the district level, Karzai and his coterie could build a patronage system with the stability that the formal Afghan political structure lacked. The practice also ensured that a steady stream of favors and money made their way back to Karzai as officeholders of questionable competency sought to maintain their positions of power. “Some of those appointed were corrupt,” Neumann noted, “but when the U.S. menaced them, it menaced [Karzai’s] entire structure of support.” Unsurprisingly, the patronage system undercut the official political system’s legitimacy, which the Taliban exploited to promote instability. Short-term expediency and personal gain took precedence over the long-term stability of the nascent Afghan government in the eyes of those profiting from the patronage arrangement. In January 2006 the U.S. Army’s Maj. Gen. Robert E. Durbin succeeded General Brennan as the chief of the Office of Security Cooperation–Afghanistan. Unlike his predecessor, Durbin had significant experience in training ground combat troops. Before arriving in Afghanistan, he commanded at company, battalion, and brigade levels in armored and infantry divisions. Soon after Durbin’s arrival, the CENTCOM commander, General John P. Abizaid, elevated Durbin’s organization from an office to a command. The organization’s new name, Combined Security Transition Command–Afghanistan (CSTC-A), went into effect in a redesignation ceremony at Camp Eggers on 6 May 2006. The move not only made the command arrangement between Durbin and his higher headquarters similar to that used in Iraq, but also raised the profile of the training mission in anticipation of CFC-A’s impending disestablishment at the end of the year. Once CFC-A went away, the security transition headquarters could absorb some of its personnel and, because it would operate outside the ISAF chain of command, the training organization needed to have increased authority in theater.\",\n        \"After discerning that he lacked the resources for the mission given to his command, Durbin sought to add an additional  brigade-sized training force to his organization. It took until February 2007 for the Army to agree to his request, and it was not until 2009, long after Durbin had left the assignment, that any significant troop increases took place. Durbin also was dismayed to find a significant imbalance of capabilities within his command. More than 4,000 personnel were involved with training the Afghan Army, while only 88 personnel—later increased to 108—were overseeing the police training mission. Durbin would later observe that police training was “under resourced dollar wise for the first four years, [and] under resourced manpower wise for the next three to four years.” General Eikenberry concurred: “Here, I think the competing demands of the Iraq War were hurting our own efforts.”\",\n        \"One particularly troubling development in local security was that government officials were hiring militia forces as police officers and using them for personal protection. Afghanistan had a long history of local militia leaders increasing their power by supporting warlords. Hiring police as personal militias undercut their professionalism and divided their loyalties, making it possible for police to join militia groups that challenged the central government’s authority. To prevent this from happening, Karzai initiated two new programs. The first, known as Disarmament of Illegal Armed Groups, was launched in May 2006 as a successor to the disarmament, demobilization, and reintegration program that ended with the completion of the Bonn Process. The program sought to disarm and disband all armed groups that were not sanctioned by Kabul. The second was a bridging mechanism that Karzai hoped would provide local security until the Afghan Uniformed Police were more capable. Despite objections from the international community, the Afghan president moved in early June to coopt militias by incorporating them into a new organization called the Afghan National Auxiliary Police. Formalized by presidential decree in October, the auxiliary police proposal called for a force of 11,241 recruited from local militia pools in 124 high-risk districts in Farah, Ghazni, Helmand, Kandahar, Uruzgan, and Zabul Provinces. Recruits would receive ten days of training (five days of classroom instruction, five of range firing) and then be issued an AK47 rifle and a standard ANP uniform (with a distinct patch). Afghan auxiliary policemen would receive a further ten days of training every three months, and would be paid the same monthly salary (US$70) as their regular police counterparts.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_2-2.png\",\n        \"caption\": \"An ANA officer\"\n      }\n    },\n    \"The auxiliary police program sought to legitimize the tribal militia groups that played an important part in Afghan politics. Despite his support for the new disarmament program, Karzai did not want to end the power that the militias represented; rather, he wanted to incorporate their influence into Afghanistan’s formal government. Supporting the Afghan National Auxiliary Police allowed him to regulate a power base that he did not normally control. Reflecting the president’s position, the disarmament and auxiliary police programs were politically sensitive elements of the American and coalition “rebalancing plan” for the ANP. This rebalancing involved eliminating the corrupt and ineffective Afghan Highway Police and integrating their rolls into the Uniformed Police. Unfortunately, many highway police chose to quit rather than join the regular police force, taking their uniforms and weapons and going home. CSTC-A initially intended the auxiliary police to protect rural Afghans for two years while it developed other reform initiatives, but the program’s deficiencies caused it to end within eighteen months. The Afghan auxiliary police program’s failure surprised coalition leaders such as Ambassador Neumann, who later stated that “we knew that the program was a desperate effort when we set it up, but we spent that whole winter of 2005–2006 groping around for anything we could do to deal with what we assumed was going to be an intensified insurgency.”\",\n    \"The rebalancing plan had greater success with the Afghan Standby Police. Instead of simply folding the unit back into the regular police,  Durbin’s planners decided to convert it into a specialized force. The result was the Afghan National Civil Order Police. Developed in the fall of 2006, the concept gave the new unit two primary roles: respond to civil unrest and national emergencies in eight major metropolitan areas and patrol high-threat and remote areas to maintain a robust police presence there. The 5,000-strong, multiethnic force would receive modern equipment and vehicles (including armored patrol vehicles for increased IED survivability), robust training (sixteen weeks rather than the ANP’s standard five to eight weeks), increased communications and logistical support, and other incentives “to attract a better pool of applicants.” The overall force consisted of a headquarters company, three patrol brigades, and one civil order brigade. The Ministry of Interior distributed the patrol brigades among the most unstable districts in the country’s southern and eastern provinces and divided the civil order brigade among eight major population centers. Although the units had specific geographical responsibilities, they could be sent to other provinces as needed. To prevent provincial governors from blocking their deployments, all civil order police units fell under the authority of the Ministry of Interior, with their headquarters in Kabul. Although small, the civil order police would be a vital component of U.S.-led police reforms in the coming years.\",\n    {\n      \"title\": \"Civil Military Operations\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"By the fall of 2005, reconstruction efforts in Afghanistan faced two dramatically different environments. In the western and northern regions, where the Taliban had failed to regain a foothold, reconstruction flourished. In sharp contrast, enemy activity in RC South and RC East threatened humanitarian efforts and inhibited development projects. As the Taliban and its associated insurgent groups intensified their campaigns against the Kabul government and the international coalition, nongovernmental organizations began leaving threatened areas, even if the district or province was otherwise calm. In some cases, the Taliban targeted aid workers and employees of these organizations, seeing them as agents or partners of the government. In other instances, criminal groups preyed on unarmed aid workers, prompting a similar hurried departure and a marked reluctance to return unless their security could be absolutely assured. Over time, this phenomenon resulted in nongovernmental organizations clustering in quiet regions such as northwestern Afghanistan and being virtually absent from the country’s volatile south and east.\",\n        \"As the Taliban grew more aggressive, it began to threaten national infrastructure projects funded by the U.S. Agency for International Development. Insurgents targeted the building efforts of the Kajaki hydroelectric facility in northern Helmand, the Gardez to Khost road, large portions of the Ring Road near Kabul, and the Jalalabad to Asadabad road. The U.S. Agency for International Development was just as reluctant as nongovernmental organizations to venture into disputed provinces. Even the temporary absence of aid officials degraded regional reconstruction efforts because each major project required time, site observation, and constant attention to maintain momentum. As a result, humanitarian projects could take place only in areas where U.S. and ISAF forces maintained a presence or conducted major operations to reestablish security.\",\n        \"In order to focus efforts, General Eikenberry’s reconstruction plans centered on rebuilding Afghanistan’s basic road network. Better roads would not only enable the transport of goods but also improve the Afghan government’s access to communities, strengthening their ties to Kabul. Eikenberry did not want the U.S. military to dominate reconstruction efforts, thinking instead that civilian agencies had the technical expertise needed to oversee projects. He understood that “relative to the civilian team, a military commander usually has comparative advantages in transportation, communication, security, planning competency, flexible funding, and niche skills.” In Eikenberry’s view, the military needed to make these resources available so that civilians could apply their expertise to mission-critical areas while avoiding “the hubris of believing [that] soldiers can do everything well and then indeed trying to do everything.” Instead, he preferred to work in support of the State Department and the U.S. Agency for International Development’s reconstruction projects. These initiatives included both those that could provide short-term tactical benefits for U.S. and Afghan forces as well as those offering long-term improvements to be sustained by the Afghan government.\",\n        \"With American maneuver forces focusing on security, reconstruction teams continued to be the primary means of promoting governance and reconstruction. The teams had been created as “an interim civil-military organization designed to operate in semi-permissive environments” in order to “improve stability in a given area by helping build the host nation’s legitimacy and effectiveness in providing security to its citizens and delivering essential government services.” Ideally, the reconstruction teams could be dissolved “when normal development operations can be carried out without [their] assistance.” Therefore, teams needed sufficient security to prevent the enemy from disrupting their efforts to improve governance and support reconstruction.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_2-3.png\",\n        \"caption\": \"The Gardez-Khost road construction project\"\n      }\n    },\n    {\n      \"title\": \"A Renewed Enemy\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Compared to earlier years, the prospects for enhancing the security situation in Afghanistan seemed dim. During the 2006 fighting season, sustained offensives replaced the Taliban’s hit-and-run tactics of previous years. In 2004, ISAF reported 900 security-related incidents countrywide. Attacks increased in the later part of the campaigning season but were largely held in check by the resource surge that preceded the National Assembly and provincial council elections. By 2006, reported security incidents rose to 5,000. In particular, IED attacks increased from 325 to 1,931 over the period. Coalition casualties also increased, more than tripling from 58 killed in action in 2004 to 191 killed two years later. While Afghanistan had experienced continuous violence since early 2003, the increase in attacks demonstrated that the insurgency was “well past the incubation stage.” Coalition forces now faced deliberate attacks and ambushes, along with attempts to interdict ground lines of communications, harass key bases in outlying provinces, and assassinate effective Afghan partners. All these actions ensured that insurgents maintained a coercive influence on a population suspicious of the Karzai government.\",\n        \"The fact that the U.S.-led coalition did not face a unified front further complicated matters. By the end of the 2005 fighting season,  coalition and Afghan security forces faced three interconnected conflicts. The first was a regional struggle against the Afghan Taliban and associated groups such as Gulbuddin Hekmatyar’s HIG and the Haqqani Network. These groups were motivated by a desire to expel foreigners from Afghanistan and return to implementing the rule of law according to their interpretation of Islam. The second was the Global War on Terrorism directed against al-Qaeda remnants based in Pakistan’s tribal areas and enabled by Pakistani extremists. Finally, coalition and Afghan troops faced numerous destabilizing actors: predatory warlords, narcotics producers, criminal gangs, petty thieves, and smugglers. Some of these parties occasionally allied with factions within the government or insurgent groups, but in sum they were a corrosive presence in both Afghanistan and Pakistan.\",\n        \"Of these three conflicts, the Taliban-led insurgent coalition posed the greatest direct threat to Afghan stability and security. The Quetta Shura Taliban had its strongest organizations in Afghanistan’s Pashtun-dominated southern provinces of Zabul, Uruzgan, Helmand, and Kandahar. In 2005, coalition officers estimated the threat posed in these provinces as low key, with IEDs and ambush cells periodically recruiting the help of local farmers. The absence of sustained enemy activity led one American commander to think that they had the Taliban “all but defeated.” The remaining armed opposition groups in Helmand, Uruzgan, and Kandahar were considered marginal threats. However, fighters trained in Pakistan were arriving in strength, ready to conduct operations once the poppy harvest ended in the late spring. Their successful and largely unnoticed infiltration into the Arghandab and Helmand River valleys menaced the provincial capitals of Kandahar City and Lashkar Gah. By April 2006, the Taliban had assembled numerous well-trained and well-supplied foot soldiers in southern Afghanistan.\",\n        \"The south was not the only region penetrated by substantial insurgent forces. In eastern Afghanistan, the Haqqani family  network directed or facilitated many insurgent and tribal militia groups operating in a region, encompassing Khost, Logar, Paktika, Paktiya, and parts of Nangarhar and Wardak Provinces called Loya-Paktia. The Haqqani and their subordinates were not strictly Taliban, but they were willing to affiliate with Mullah Mohammed Omar’s movement for pragmatic objectives: fighting foreign soldiers, capturing Kabul for the Pashtuns, and establishing sharia (Islamic religious law). In exchange, the Haqqani family had free rein to run their own jihad (struggle, in the sense of a holy war waged on behalf of Islam) on both sides of the border. The Haqqani Network’s main ties to the insurgency stemmed from its value as a facilitator for al-Qaeda and other foreign extremists. From their Pakistan base area of Miran Shah, Haqqani transit lines entered Afghanistan’s Khost Province. The Haqqani knew Khost well, and the restrictive terrain ensured the region remained an active sanctuary for insurgents operating as far away as Kabul. With dozens of madrassas (religious educational institutions) across the border churning out thousands of graduates each year, units operating in eastern Afghanistan faced a seemingly endless stream of potential recruits prepared for jihad.\",\n        \"Throughout 2005 and into 2006, the Haqqani Network expanded from its established positions along the border into Khost and Paktiya Provinces. This expansion was possible not only because of the Haqqani forces but also because religious networks had become stronger at the expense of local tribal leadership. This shift toward fundamentalism allowed the Haqqani to substitute their patronage of madrassas for traditional power structures. Ineffectual district governance then gave the Haqqani the opportunity to exploit their financial strength and prestige as successful mujahideen (holy warriors) in a grab for power. Haqqani-backed insurgents operating from Pakistan became more ambitious in 2006, establishing infiltration routes across the frontier leading to Kabul. As in the south, these groups became more aggressive after several years of low-level action, targeting troops, combat outposts, and forward operating bases with IEDs and rockets. As a significant threat, they endangered the villages and district centers that the United States considered crucial to the region’s stability and inhospitality to al-Qaeda.\",\n        \"Farther north, HIG also became more active in 2006. Pursuing Hekmatyar’s exclusionary political program, HIG fighters surrounded their fundamentalism with a modern, disciplined organization that resembled a Soviet-style political front. Although the group numbered only a few thousand active members, Hekmatyar exploited his position around the Pakistani city of Peshawar to increase his ranks and prepare for military operations in Nuristan, Kunar, and Nangarhar Provinces. These isolated provinces were full of capillary valleys populated by tribes that resented any intrusion by outsiders, especially by those who did not practice their fundamentalist version of Islam. HIG might not have enjoyed tremendous popularity in these regions, but they could exploit the ideals of pashtunwali, Wahhabism, and traditional sociopolitical norms better than any other intruding force could.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-2-5.svg\",\n        \"caption\": \"The Insurgency\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    {\n      \"interactive\": {\n        \"source\": \"/iframe/ch2/OEF_VII_Ch_2_v2.html\",\n        \"caption\": \"2006 Key Insurgent Activity\"\n      }\n    },\n    \"The region also contained numerous other militant groups with agendas in Afghanistan, Pakistan, or both. Two of the larger groups, based out of North Waziristan within the Federally Administered Tribal Areas, were the Islamic Movement of Uzbekistan and the Tehrik-i-Taliban Pakistan (TTP). The former had fought alongside the Afghan Taliban from the earliest days of the U.S. invasion, while the latter was a more recently organized coalition of different Pakistani Taliban groups that opposed not only the U.S. and ISAF presence but also the central government in Islamabad. Hezbe-e-Islami Khalis, an HIG splinter group that broke with Hekmatyar’s forces in the late 1970s, was located along the Afghanistan-Pakistan border in southern Nangarhar Province. Finally, the group known as Tehrik-i-Nezaf Shariat Muhammad was located north of the Pakistan city of Peshawar and inside the northern sections of the tribal areas. For the most part, these organizations did not conduct unilateral operations within Afghanistan, but instead provided support to the larger forces of the Taliban, the Haqqani Network, or HIG.\",\n    \"As the 2006 fighting season began, a new Taliban opposed the coalition and its Afghan partners. Their tactics were beginning to show greater sophistication, daring, and effectiveness. Taliban fighters now went to battle armed with rifles, machine guns, rocket-propelled grenades, mines, mortars, and rockets. They were led by command and control elements capable of discriminating targets and taking countermeasures against U.S. tactics. As an American intelligence officer recalled, by 2006, “You get a large enough [friendly] force and the enemy would disappear; get a small enough force and [the Taliban] would come out from behind every rock or hill top.” The Taliban also began importing methods used by insurgents in Iraq, employing ambushes, IEDs, and suicide attacks. They also benefited from training, financing, and logistical support from extremist groups such as the Haqqani Network.\",\n    \"The use of IEDs escalated in 2006 with nearly 1,300 attacks compared to 782 the year before. Although Taliban IEDs never reached the level of sophistication seen in Iraq, coalition troops learned to respect these deadly and difficult-to-detect bombs. A network of informants, sometimes children, gave advance warning to allow Taliban groups to mass fighters and arm preplaced IEDs, which often initiated or accompanied an ambush. Insurgents began using radio-controlled bombs in 2005–2006, which were more sophisticated than the booby traps with trip wires previously seen. A triggerman could now detonate a hidden bomb from several hundred meters away. When coalition forces began using radio-defeating technologies to protect mounted and dismounted forces, the insurgents went low-tech, substituting command-wire detonators for the radio-controlled variety.\",\n    \"Even as IEDs became more prolific, the tactic that had the most dramatic impact in Afghanistan was the suicide bomb. Unlike in Iraq, suicide attacks began slowly in Afghanistan. The first documented attack took place on 7 June 2003, when a single bomber killed four ISAF soldiers and wounded thirty-one bystanders in Kabul. In just a few years, however, suicide bombings had increased from 21 in 2005 to 141 in 2006, causing a reported 1,166 casualties. This new lethality was attributable primarily to foreign volunteers and technical and ideological training in Pakistan’s tribal area sanctuaries. Often recruited in Pakistani madrassas, bombers were glorified as martyrs, and their families usually received cash payments. On occasion, madrassa students in Pakistan were specifically groomed to participate in these operations, as peer pressure and ideological training made them reliable delivery systems.\",\n    \"The Taliban’s greatest advocate for these martyrdom operations was Mullah Dadullah “Lame” Akhund. In April 2007, a month before he was killed in a U.S. airstrike, Dadullah told a reporter, “We have sent thousands of Taliban suicide bombers to all Afghan cities for attacks on foreign troops and their Afghan puppets, and we will turn our motherland into the graveyard of the U.S. forces, and their families should wait for their dead bodies.” He and others in the Taliban’s leadership justified such tactics by arguing that the Taliban was fighting “for the freedom of Afghanistan from the enemies of Muslims.”\",\n    \"As evidenced by the rise of IEDs, suicide attacks, assassinations, and abductions, the superiority of Afghan and coalition security forces in conventional battles had forced insurgent groups to adopt asymmetric tactics aimed largely at Afghan security and civilian targets. Although the insurgency drew strength from elements within the Afghan community, its leadership, planning, training, funding, and equipment came from foreign-based networks. These networks remained largely beyond the reach of U.S. and ISAF forces in Afghanistan, being formed and controlled from bases in Pakistan.\",\n    \"These same extremists also were poised to attack Pakistan itself. Whether by design or neglect, the Pakistani military proved incapable of securing the border crossings, allowing insurgents to travel back and forth between the Pakistani safe havens and the Afghan battlefields almost at will. Despite growing complaints from American officials and Karzai, the Pakistani government of President Pervez Musharraf issued a steady stream of denials regarding the existence of a Taliban-driven insurgency emanating from Pakistan. The Pakistanis were playing a complicated diplomatic game by accepting billions in U.S. aid to eradicate al-Qaeda in connection with ENDURING FREEDOM counterterrorist operations, while offering political cover and financial support for other militant groups operating in Afghanistan. Pakistan’s true motivations concerned its territorial disputes with India. Its decades of support for radical Islamic governance in Afghanistan was intended to provide both fighters and a secure flank for future conflicts in Kashmir. The Pakistanis thus saw the transfer of authority to NATO ISAF as an opportunity to return to a more traditional security state. With the United States apparently divesting itself of ENDURING FREEDOM, much as it had turned away from Afghanistan after the 1989 Soviet withdrawal, Washington’s support seemed less important to securing Pakistan’s sovereignty.\",\n    \"Islamabad had been utilizing groups such as the Haqqani Network to maintain order among the tribes in the Federally Administered Tribal Areas since before the Soviet-Afghan War. In recent years, however, Pakistan’s evolving interests and loyalties proved unable to provide stability along the frontier, and it was now suffering from the threat of a “Talibanized belt” in the tribal areas. As the region became less stable, the Pakistani government decided that the traditional militia-based security force for the provinces, the Frontier Corps, was no longer sufficient to maintain security. Instead, it turned to the Pakistani Army to assert governmental authority in North and South Waziristan in June 2002.\",\n    \"As thousands of Pakistani soldiers deployed to the tribal areas, radical Islamist groups began calling for a jihad against the central government. Multiple operations by Pakistani military forces that had no counterterrorism or counterinsurgency training invariably failed to constrain the region’s tribal and religious forces while at the same time inflaming local sentiment and increasing popular discontent with the government. After several years of inconclusive results and growing dissent within the army, the Pakistani government agreed to a truce with militants in South Waziristan in early 2005. The government withdrew its troops from the tribal zone in exchange for assurances that the militant groups would not attack the Pakistani Army or give shelter to foreign terrorists. It did not, however, prevent radical Islamists from launching attacks against coalition troops in Afghanistan.\",\n    \"After signing the truce, the Pakistani military began operating in North Waziristan to pursue foreign militants fleeing the southern tribal areas. As in other parts of the tribal areas, soldiers met heavy resistance from groups motivated by both Islamist ideology and tribal autonomy. In an effort to restore order, the Haqqani family helped broker a peace between the government and tribal representatives in North Waziristan in early September 2006. Once again the government agreed to withdraw troops in exchange for a cessation of hostilities, although this time it also secured promises from militants not to conduct attacks in Afghanistan.\",\n    \"The coalition in Afghanistan suffered from Islamabad’s reluctance to continue employing tens of thousands of troops to quell the fiercely independent Pashtun tribes dominating affairs within the Federally Administered Tribal Areas. As General Eikenberry noted in November 2006, the number of attacks emanating from North Waziristan tripled after the peace agreement. The coalition had little means of blunting this influx as U.S. forces in theater began to contract into RC East in preparation for ISAF’s postelection and postconflict stabilization campaign. Policymakers remained blind to a brewing catastrophe as Eikenberry struggled to convince his political superiors that they needed to pressure Islamabad on sanctuaries.\",\n    \"Apart from destabilizing Pakistan and supporting the growing Afghan insurgency, radical Islamists in the tribal areas  also helped ensure the survival of al-Qaeda and Osama bin Laden’s continued leadership of Sunni extremist groups. Although al-Qaeda’s cohesion had been shattered during its withdrawal from Afghanistan, hampering its ability to oversee a global jihad, the group had enough support in Pakistan to survive. In fact, al-Qaeda soon expanded its sanctuary in South Asia by partnering with groups such as the Haqqani Network. This reliance on allies meshed with al-Qaeda’s original intent of representing the Islamic vanguard for the global jihad. Al-Qaeda did not need to engage directly in bombings to be dangerous: its value to the jihadist movement was its ability to link local groups with global sources and to merge regional conflicts with bin Laden’s vision of a worldwide struggle.\",\n    \"Even before the September 11th attacks, bin Laden had supported Pakistan’s conflict with India over the Kashmir region,  comparing it to the jihad in Afghanistan and inviting Pakistanis to join his movement. After the U.S. invasion toppled its Taliban allies, al-Qaeda used its ideological authority to promote increased confrontation with the Pakistani state. The objective was to destabilize the Pakistani government, distract U.S. attention from Afghanistan, and undermine Islamabad’s support for America’s war on terrorism in Southwest Asia. Al-Qaeda’s leaders followed their own lines of operation: providing religious justification to rally tribal support for antigovernment militants; leveraging military experience and organizational reach to train, advise, and fund militant groups; and mediating disputes and building coalitions within Pakistan to insulate bin Laden from external attack.\",\n    \"Though al-Qaeda remained active, bin Laden maintained a low profile, likely settling down in a reclusive Abbottabad compound on the southeastern edge of the Northwest Frontier Province of Pakistan in early 2006. His deputy, Ayman al-Zawahiri, regularly moved among safe houses in the tribal areas. Al-Qaeda’s entrenchment in Pakistan’s tribal areas secured the ideological foundation of the radical Islamist movement. At the same time, the Taliban’s reestablishment in Quetta and the growth of such groups as the Haqqani Network and HIG gave the Islamist militants a stable support base and access to thousands of potential recruits from local madrassas. With sufficient international financial backing, a capable training system, and a logistical network, nefarious groups had the motivation and means to wage a large-scale, multifaceted insurgency against the international coalition and the Karzai government. At a time when the war in Iraq was limiting the resources the United States could make available for its fight in Afghanistan, these militant groups looked to expand their campaign. Because Afghanistan’s new security forces were still being developed, its security and stability would depend on ISAF’s ability to quell an armed insurgency operating out of a Pakistani safe haven.\",\n    {\n      \"title\": \"The Return of the 10th Mountain Division\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"With the Taliban and other anticoalition groups preparing to mount offensives in 2006, the United States rotated its maneuver forces for the coming year. Senior Defense officials had chosen the 10th Mountain Division to oversee the transition to ISAF lead in Afghanistan. Initial proposals called for the 10th Mountain to divide its 3d and 4th Brigade Combat Teams between RC East and RC South, where they would spend the year-long deployment conducting major operations. However, the Department of Defense settled on sending only a portion of the 4th Brigade Combat Team to RC South due to concerns about generating sufficient combat troops for Iraq, coupled with Abizaid’s and Eikenberry’s belief that sending an entire U.S. brigade to RC South could stall the NATO deployment. This meant that U.S. commanders in Afghanistan would not be able to mount simultaneous major operations in the two regional commands, and instead would need to shift forces between the two in order to weight the one most in need.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_2-4.png\",\n        \"caption\": \"General Freakley, pictured as a Lieutenant General in 2011\"\n      }\n    },\n    \"Advance units from the 10th Mountain Division began arriving in December 2005, with the majority of the troops touching ground in January and February. The full transition would be completed by April 2006. The 10th Mountain commander, Maj. Gen. Benjamin C. Freakley, brought his division headquarters and took over CJTF-76 from General Kamiya on 21 February at Bagram Air Base. Col. Michael S. Rose’s Combat Aviation Brigade, 10th Mountain Division (Task Force FALCON), and Col. Larry D. Wyche’s 10th Sustainment Brigade (Task Force MULESKINNER) also deployed to Bagram, where they could provide air and logistical support to CJTF-76.\",\n    \"Col. John W. “Mick” Nicholson Jr.’s 3d Brigade Combat Team (TF SPARTAN) was the 10th Mountain Division maneuver force in RC East.  Headquartered at Forward Operating Base SALERNO in Khost Province, Colonel Nicholson’s force included four combat battalions: Lt. Col. Christopher G. Cavoli’s 1st Battalion, 32d Infantry Regiment (Task Force CHOSIN); Lt. Col. Christopher R. Toner’s 2d Battalion, 87th Infantry Regiment (Task Force CATAMOUNT); Lt. Col. Joseph M. Fenty’s 3d Squadron, 71st Cavalry Regiment (Task Force TITANS); and Lt. Col. David A. Bushey’s 4th Battalion, 25th Field Artillery Regiment (Task Force WOLFPACK). Nicholson distributed the combat units across the regional command while retaining his field artillery at Salerno. Filling out Nicholson’s combat team were Lt. Col. Richard G. Kaiser’s Special Troops Battalion (Task Force VANGUARD) and Lt. Col. Vernon L. Baker’s 710th Support Battalion (Task Force SUPPORT). For the first few months of its deployment, TF SPARTAN also included 1st Battalion, 3d Marines, under the command of Lt. Col. James “Chip” Bierman, which was nearing the end of its seven-month rotation.\",\n    \"The impending ISAF transition in southern Afghanistan, and the U.S. decision not to deploy all of 10th Mountain’s 4th Brigade Combat Team, significantly limited planned operations in RC South. In evaluating the impact of that decision, CENTCOM planners noted that “CFC-A’s current analysis does not indicate the need for [4th Brigade Combat Team, 10th Mountain] as long as Canadian and Great Britain . . . forces arrive as currently planned [no later than] April, 2006.” However, CENTCOM also estimated that if British “forces do not arrive in adequate numbers by the end of March 2006; there will likely be a maneuver force capability gap from April to May.” The absence of 10th Mountain’s 4th Brigade Combat Team would therefore create deficiencies only if NATO deployments were delayed.\",\n    \"Canadian Brig. Gen. David Fraser, who took over RC South from Colonel Owens’s TF BAYONET in mid-February 2006, would oversee the incoming ISAF units. His new command headquarters, Combined Task Force AEGIS, initially fell under CJTF-76’s command before the formal turnover to ISAF. At the time, Fraser’s command consisted of a Canadian Task Force (Task Force ORION) under the command of Col. Ian Hope built around the newly arrived 1st Battalion, Princess Patricia’s Canadian Light Infantry and the Canadian-led Provincial Reconstruction Team in Kandahar City.\",\n    \"Problems emerged with the projected RC South deployment soon afterward because, unlike earlier ISAF efforts in northern and western Afghanistan, sending troops into a potentially dangerous region sparked vigorous political discussions within some participating NATO nations. The Dutch contingent, for example, only received approval to deploy following an extensive parliamentary debate that ended in February 2006, which meant it could not take over responsibility for Uruzgan Province until August. The debate took place because the Dutch government deliberately chose a province where Taliban fighters were active rather than settle for reconstruction work in quieter northern Afghanistan. This delay also set back the arrival of British forces until April because London wanted firm commitments from the other NATO members before sending its own troops.\",\n    \"The combined delays produced the worst-case capability gap in RC South, prompting CENTCOM to fill the void with a composite organization siphoned from Freakley’s newly formed 4th Brigade Combat Team based at Fort Polk, Louisiana. That unit, built around Lt. Col. Frank D. Sturek’s 2d Battalion, 4th Infantry Regiment (Task Force WARRIOR), contained three more companies in addition to its three organic rifle companies, antitank company, and headquarters company to enable the unit to operate as an independent Task Force. In March, General Freakley sent Sturek’s Task Force to Zabul Province in RC South, where it covered ISAF forces filtering into the region.\",\n    \"Although the entire 4th Brigade did not deploy, Freakley received Col. A. Kent Schweikert, the 4th Brigade commander, along with parts of his staff and 200 soldiers from Lt. Col. Michael C. Howitz’s brigade support battalion (Task Force STRENGTH). Freakley dispatched Schweikert to Kandahar to perform as U.S. National Command Element, U.S. National Support Element, and General Fraser’s deputy for Combined TF AEGIS. As head of the U.S. National Command and Support Elements, Schweikert provided logistical, intelligence, and communications support to American (but not ISAF) forces operating in RC South. With the Americans and Canadians comprising the core of his multinational brigade-sized force, Fraser’s command slowly grew as more NATO forces arrived in anticipation of the RC South transfer of responsibility to ISAF. The rotation for 10th Mountain culminated in March 2006, at which point General Freakley’s command now consisted of roughly 20,000 troops, with the majority of U.S. forces located in RC East.\",\n    \"The campaign plan for the new CJTF-76 built on CFC-A’s emphasis on security, governance, and reconstruction as well as ISAF’s goal to “extend and deepen the areas in which the [Afghan Government] and [international agencies and nongovernmental organizations] can safely operate in the interests of the people of Afghanistan.” Freakley thought that Eikenberry’s guidelines and objectives permitted CJTF-76 to exercise “pretty much free rein with constructing our campaign plan.” His staff took this opportunity to develop a campaign to extend the Afghan government’s reach into isolated regions in northeast RC East, block insurgent infiltration routes in the central and southern portions of RC East, and facilitate NATO forces as they moved into RC South.\",\n    \"CJTF-76 sought to achieve these objectives by simultaneously conducting “full spectrum operations” and integrating “joint, inter-agency and multinational forces partnered with the Afghans [in order to] establish security and deter the re-emergence of terrorism to enhance the sovereignty of Afghanistan.” These goals would be realized by implementing a four-step “clear, hold, build, and engage” approach. In simpler terms, coalition troops conducted combat operations against enemy fighters, reducing their strength to the point at which Afghan troops and police could maintain a permanent presence in the designated area of operations. At that point, CJTF-76 would initiate reconstruction projects designed to better the life of local inhabitants while supporting Afghan government and coalition efforts to develop ties with the local communities. The CJTF-76 approach emphasizing “build” and “engage” was a more nuanced variation of the “clear, hold, and consolidate” method found in ${Counterinsurgency Operations}{italic} (Department of the Army Field Manual–Interim 3–07.22).\",\n    \"For CJTF-76’s major operations, the four phases were “initially sequential and [began] with kinetic operations to kill or capture insurgents in a named area of operation.” A further technique to clear an area was an amnesty program that sought to align insurgents behind the Afghan government. Once the clear phase separated the enemy from the population, U.S. and Afghan security forces would maintain or hold that separation by building combat outposts, overseeing the development and deployment of local security forces, and establishing government agencies. The third phase, build, consisted of transforming “the physical and human terrain” through reconstruction and development projects, creating stable local security forces, and encouraging relationships between the population and their governmental representatives. The final phase, engage, was an overarching effort that included meetings with Afghan civil and military leaders and regular civilians “to help them develop the sense of responsibility they would need to eliminate insurgent activity in sanctuaries, among the population, or in transit through the border region.” Although initially sequential, implementation eventually would shift to all four phases being performed in conjunction as “concurrent and ongoing efforts.”\",\n    \"The clear, hold, build, and engage model not only translated operational objectives into tactical approaches but also aligned CJTF-76’s efforts with General Eikenberry’s desire to improve access to communities in RC East. Eikenberry summarized the problem: “Where the road ends, the Taliban begins.” He and Ambassador Neumann had made road construction a centerpiece of their efforts in 2005. Neumann sought additional congressional funding while Eikenberry pushed his military forces to improve the Afghan government’s access to isolated areas and deny that access to insurgents. As NATO prepared to move into RC South, TF SPARTAN would spread throughout RC East, often moving into regions that had seen only limited coalition activity in the past.\",\n    \"In addition to U.S. conventional forces, the 2006 campaign relied heavily on SOF. CJSOTF-Afghanistan now fell under the operational control of Combined Forces Special Operations Component Command–Afghanistan and the tactical control of CFC-A, meaning that CFC-A could only assign missions to SOF and not task-organize or relocate them in theater. The new SOF Task Force commander, Col. Edward M. Reeder Jr., returned to Afghanistan in February 2006, having twice served in the country as a battalion commander in 3d Special Forces Group. His new command consisted of twenty-five ODAs, six civil affairs teams, six psychological operations teams, and SOF units from five partnering nations. His mandate was to develop the ANA, particularly the Afghan 205th and 207th Corps. With Afghanistan rotations normalized between the 3d and 7th Special Forces Groups, 1st Special Forces Regiment, SOF could now be integrated more efficiently into CJTF-76’s upcoming operations.\",\n    \"CJTF-76 planned to conduct four major operations in 2006, two of which specifically targeted RC East. The first, Operation MOUNTAIN LION—the second operation in Afghanistan with that name—would take advantage of a Marine Corps battalion that stayed in country when Kamiya’s forces departed. Freakley wanted to use these available combat forces to push into the northeastern provinces of Nuristan, Kunar, and Laghman, all of which were dominated by isolated river valleys whose resident communities had little to no contact with the central government, much less the outside world. The plan was for U.S. and Afghan troops to move gradually into these regions, especially the dangerous Pech River Valley in Kunar Province and border district of Kamdesh in southern Nuristan Province. In addition, the CJTF-76 commander sought to improve security forces and developmental projects in Nangarhar Province. Unlike previous operations where coalition forces stayed in a region for a brief time, CJTF-76 units would establish outposts and remain for an extended period, overseeing development projects and supporting Provincial Reconstruction Team efforts.\",\n    \"Operation MOUNTAIN LION had two purposes. First, Freakley wanted to connect the Afghan government to areas where it had little to no influence. Second, the operation was to “employ our strengths against the enemy weaknesses” by targeting HIG forces that constituted the primary threat in the region. Though Hekmatyar had a long history of radicalism and armed opposition to any Kabul government that did not reflect his Islamist views, his organization remained a consortium of disparate groups held together more by personality and rhetoric than by core principles. The combination of Hekmatyar’s brutal reputation and vocal opposition to the Kabul government, his known ties to al-Qaeda, and his group’s relative weakness in comparison to the Taliban or Haqqani Network made HIG an appealing target.\",\n    \"CJTF-76 would conduct the second operation, MOUNTAIN THRUST, in RC South from mid-May until the transfer of authority to ISAF on 31 July. Freakley intended to reduce insurgent capabilities long enough to ensure a smooth transition to NATO ISAF. NATO movements likely would be met with lethal attacks. To counter this possibility, MOUNTAIN THRUST would send patrols into isolated areas of Zabul, Uruzgan, and Kandahar Provinces. The operation was designed to “inflict a defeat upon the Taliban, sufficient to force them on the defensive for the time being, and to temporarily instill a period of calm in the southern provinces at a time of year when the Taliban were usually at their strongest.” The objective was not to eliminate opposition groups in RC South but to give international forces time to establish positions within the region and begin their own operations.\",\n    \"Once NATO forces established themselves in RC South, TF SPARTAN would shift forces back to RC East for an offensive named Operation MOUNTAIN FURY. As units in northeast Afghanistan continued to occupy new outposts, the 10th Mountain’s remaining forces would keep the insurgency off balance. Anticipated for late summer or early fall, MOUNTAIN FURY targeted the Haqqani Network by securing the border in “Paktika and Khost Provinces and expanding internally in Paktiya and Gardez [sic] Provinces.” The operation would also increase the ANA’s footprint in the region as elements from the 203d Corps moved to positions from which they could protect approaches to Kabul. Freakley intended the operation to “defeat [Haqqani-backed insurgents], help the Afghan army with that deployment in that area, and reinforce [local, district, and provincial] governments.”\",\n    \"The fourth major effort for TF SPARTAN, initially called Operation MOUNTAIN VICTORY, was planned to begin when the fall weather started to hinder insurgent operations and continue until the anticipated transfer of command and control of CJTF-76 to the 82d Airborne Division. The operation extended northeast from Paktiya Province in central RC East to Nuristan Province. Freakley designed MOUNTAIN VICTORY to ensure “insurgent forces and terrorist networks are defeated in the interior portions of RC-East” so as to consolidate gains made during MOUNTAIN LION and MOUNTAIN FURY. TF SPARTAN sought to assess the enemy’s capabilities throughout the operation so as to advise their successors on how best to secure the gains made in 2006. Freakley would use this intelligence to shift units into new areas to continue pushing the enemy away from the population. Of particular concern was maintaining access to roads cleared or built over the year. All of this had the dual purpose of supporting ISAF and setting conditions for a successful February 2007 handover with the 82d Airborne Division.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-2-8.svg\",\n        \"caption\": \"Area of Operation MOUNTAIN LION\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    {\n      \"title\": \"Operation MOUNTAIN LION (April–June 2006)\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"In his preparation for Operation MOUNTAIN LION, Freakley took an important step in improving relations between CJTF-76 and the Afghans. During a planning meeting, the general asked Abdul Rahim Wardak, the Afghanistan minister of defense, for permission to execute the operation. It was the first time an American commander sought such permission, and it marked an important turning point in American-Afghan relations. Deeply appreciative of the request, Wardak gave his approval, and the operation began on 11 April. In addition to TF SPARTAN, participating units included the 3d Brigade of the Afghan Army’s 203d Corps and the 1st Battalion, 3d Marines.\",\n        \"Preparations for Operation MOUNTAIN LION began in March 2006. Initial movements called for the insertion of a reconnaissance and surveillance unit in Asadabad where it could monitor Kunar and Nuristan. Next, Colonel Fenty’s TF TITANS would move north of Asadabad to secure the Chawkay Valley in central Kunar Province, from which TF SPARTAN would mount its movement into the two northeastern provinces. The main part of the mission involved soldiers from Colonel Cavoli’s TF CHOSIN and Fenty’s squadron air-assaulting into previously isolated valleys to establish company-sized operating bases and platoon-sized combat outposts. The marines were vital to the operation, as Colonel Nicholson needed additional combat power to support his two battalions. They had been responsible for the entire operational area now being divided between the two U.S. Army battalions.\",\n        \"By nearly doubling the forces in the region, Nicholson’s men could reach isolated areas that had not seen foreign troops since the 1980s. In one remote village, an elder mistook the soldiers for Russians and inquired as to when they had changed their uniforms. An Afghan interpreter explained who the soldiers were and reassured the elder that the Americans were better behaved than the Soviets, which comforted the old man considerably. The arrival of the Americans had a marked effect on insurgent groups. The insurgents had become accustomed to U.S. forces conducting operations for only a few days and then withdrawing, and so they were surprised by the Americans’ new tactic of setting up permanent positions. They eventually withdrew to assess the new situation and determine how to react.\",\n        \"The movement into the Korangal and Shoryak River Valleys of Kunar and Nuristan Provinces also included a large SOF presence. The Special Operations Task Force tasked its Naval Special Warfare assets, the SEALs, and coalition SOF to conduct special reconnaissance and direct action missions targeting mid-level HIG leadership before conventional forces began clearing operations. Colonel Reeder followed these initial forays with orders for six ODAs from Special Operations Task Force 202 to conduct partnered operations with the Afghan 201st and 203d Corps. Operation MOUNTAIN LION lasted roughly a month, ending in mid-May, and did not force any major engagements with enemy combatants, who evidently were trying to determine how to adjust to losing their freedom of movement. Intelligence analysts continued to find it difficult to provide maneuver commanders with actionable information.\",\n        \"The American push into the valleys did not come without tragedy. On 5 May, during a nighttime extraction of two observation teams from mountainside positions, a CH–47 Chinook helicopter struck a tree and crashed. The TF TITANS commander, Colonel Fenty, was riding in the helicopter’s jump seat. He and nine other soldiers died when the aircraft fell several hundred feet to the rocks below. Their deaths were the first fatalities for TF SPARTAN and highlighted the difficulties faced by U.S. Army aviators operating in Afghanistan’s rugged mountain terrain.\",\n        \"One of TF SPARTAN’s most ambitious moves came on 7 May, when it established an outpost in the middle of the Korangal Valley. The Korangalis had a long tradition of hostility toward anyone they viewed as an outsider, including Afghans from other valleys. They also practiced Wahhabism, which was brought into their valley in the 1980s by foreign mujahideen fighters sheltering from Soviet attacks. When the ANA chief of staff, General Bismillah Khan Mohammadi, raised the Afghan national flag over the Korangal outpost, he signaled the beginning of a government effort to exert its authority over the traditionally isolated region. (The Korangalis, for their part, seemed indifferent to the arrival of the Afghan government.) This flag-raising accomplished Freakley’s objective for the operation, which was “to go where we hadn’t been before with strength, establish a presence with combat outposts and partner with the Afghan military, and stay there . . . [to] do reconstruction.” The soldiers of TF SPARTAN were ready to begin their counterinsurgency efforts in the northern provinces of RC East.\"\n      ]\n    }\n  ],\n  \"chapter 3\": [\n    {\n      \"title\": \"The Conflict Intensifies\"\n    },\n    {\n      \"section\": [\n        \"The handover to NATO ISAF presented unexpected challenges to the coalition’s key leaders, including Lt. Gen. Karl W. Eikenberry and British Lt. Gen. David J. Richards, who assumed command of ISAF on 4 May 2006. Despite different geography and enemy formations, the regions coming under ISAF control presented similar problems for coalition forces. Whether facing HIG or the Taliban, the United States and its ISAF allies had to defeat the enemy and convince local populations to accept the authority of Afghanistan’s central government. Whether fighting in the mountains or over open terrain, they had to locate insurgents, apply firepower, stay supplied, and partner with the ANSF. The central differences between RC East and RC South were the arrival, focus, and capabilities of the forces executing the main effort. Whereas RC East was a unilateral effort, RC South was coalition warfare, with American units operating alongside British, Canadian, ANSF, and Dutch forces.\",\n        \"By late 2005, NATO finalized Supreme Allied Commander Europe’s Operations Plan 10302 to implement the final transitions of the Afghan regional commands. The plan articulated a clear political and military end state, as well as a basic strategy for how to achieve them. According to 10302, the alliance would follow the transfer of the regional commands to NATO ISAF control with a period of “stabilization” in which ISAF forces would “assist the Afghan government to extend and exercise its authority and influence” until enough “stability is achieved to allow the handover of ISAF military tasks to Afghan authorities.” The operations plan specified that “Provincial Reconstruction Teams . . . will be at the leading edge of NATO’s effort” and “military support to them is one of NATO’s major contributions to the success of ISAF in Afghanistan.” Although “recognizing the different national characters of PRTs [Provincial Reconstruction Teams],” the plan optimistically stated that “increasing convergence between the activities of all PRTs, with synchronized movement towards a set of common objectives, will have the desired strategic impact.”1 How to accomplish this synchronization was left to Richards to work out with the national contingents under his command.\"\n      ]\n    },\n    {\n      \"title\": \"NATO ISAF in RC South\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Responsibility for overseeing the transfer of RC South and RC East fell to Richards. As commander of NATO’s Allied Rapid Reaction Corps, a high-readiness force that could deploy within a week’s time to address emerging crises, Richards faced a daunting challenge. His most pressing concern was the fact that ISAF did not have a permanent headquarters. Richards solved the problem by bringing the Allied Rapid Reaction Corps headquarters with him, though he struggled to get the unit prepared for deployment. Employing the Allied Rapid Reaction Corps staff proved only a temporary solution, however, as it did not have the mandate or personnel to deploy for long periods or exercise control over international forces. Ultimately, ISAF solved the problem by creating a permanent headquarters in Kabul but, much to Richards’ dismay, not until early 2007.\",\n        \"Richards occupied a unique position as the ISAF commander during this period. He operated within the NATO command chain, reporting  to the head of Joint Forces Command–Brunssum, German General Gerhard Beck, in the Netherlands. Above Beck was the American General James L. Jones, who served as the Supreme Allied Commander Europe. Richards did not occupy a position within his national command chain, but exerted control over British soldiers indirectly via Canadian Brig. Gen. David Fraser’s Combined TF AEGIS. While preparing for his deployment, Richards struggled to convince officials in London and Brussels of the complexity of the task ahead:\",\n        {\n          \"list\": [\n            \"I was a British General about to command a major NATO campaign but my own country was not prepared to give me a helicopter or an aircraft to fly around a country that was half the size of Europe so that I could properly exercise command. More important than that, I had no proper reserve force of any kind. No military commander, even at the platoon or company level, will go on operations without a reserve. I had none and NATO and my own country appeared content with this.\"\n          ]\n        },\n        \"Richards never received dedicated air transportation, instead having to work with what he could secure in theater. As for a reserve force, he eventually received a light infantry company from Portugal that would serve as his only reserve unit. Unfortunately, Richards would not be the last ISAF commander frustrated with the level of support he received from NATO.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_3-1.png\",\n        \"caption\": \"Defense Secretary Gates & ISAF commander General Richards\"\n      }\n    },\n    \"With Operations Plan 10302 as their guide, Richards and his staff developed a three-pronged operational approach for Afghanistan. Richards found that the plan contained “lots of fine intent, phasing, and all that, but it is not an operational plan for ground forces in the provinces of Afghanistan.” He soon discovered “big gaps between the ground needs and the higher headquarters’ plan.” Richards therefore used higher headquarters’ guidelines to develop an intent that focused on three areas. The first involved identifying highly populated regions where the majority of security, development, and governance efforts would take place. Termed Afghan Development Zones and modeled after the Regional Development Zones that Lt. Gen. David W. Barno sought to implement in 2004, they were to expand the central government’s influence by widening the spheres of control and progress found around reconstruction team locations. Once security and development improved within a zone, the coalition would tie that progress to the Afghan central government and publicize it. The second element of Richards’ approach was the creation of a Policy Action Group in Kabul with President Hamid Karzai as the head and key leaders of the Afghan government and the international community as its members. The Policy Action Group would monitor the development zones, direct the distribution of resources, and provide unity of effort for Afghan and ISAF endeavors. The final feature of Richards’ approach looked to areas outside of the Afghan Development Zones. Rejecting the American practice of targeting insurgents, Richards wanted operations outside these zones to persuade local leaders to align with the central government. Where necessary, his forces would engage in combat operations, but the emphasis would be on shaping the operational environment in preparation for a counterinsurgency-driven clear, hold, and build campaign.\",\n    \"Although Richards based his approach on a classic understanding of counterinsurgency operations, he incorporated a degree of  controversy. First and foremost, his plan to mass forces in Afghan Development Zones was complicated by the fact that several NATO members prohibited their troops from engaging in combat operations. Massing forces anywhere in an economy-of-force effort led to a second problem: the need to forgo an operational reserve. Without a dedicated theater-level reserve, Richards could not respond to changing circumstances on the ground, especially if he honored the various national caveats within his command. With slim chance of having those caveats rescinded, Richards would need either additional forces or a different plan to succeed in RC South.\",\n    \"The security situation in RC South further constrained Richards’ options. In January, a suicide attacker in Kandahar City killed senior Canadian diplomat Glyn R. Berry, the director of the Kandahar Provincial Reconstruction Team. The Taliban had infiltrated into Zabul and Uruzgan Provinces, intending to bring pressure against Kandahar City from the north. At the same time, Taliban infiltration from Helmand into Kandahar helped reactivate long dormant mujahideen networks in the Arghandab River districts west of Kandahar City. Many Taliban leaders hailed from these districts, so local tribal sympathy, if not active support, was easily obtained. At the time, coalition forces lacked any presence in the region capable of countering Taliban influence. U.S. Special Forces, trying to stave off Taliban encroachment into areas previously considered secure, executed night raids at the expense of rural development and local security. For its part, TF BAYONET was absorbed in maintaining freedom of movement along the Ring Road, leaving it without the combat power to police the provincial boundaries, interdict the flow of Taliban from the north, or halt insurgent traffic between Helmand and Kandahar.\",\n    \"The Arrival of NATO Forces Col. Kevin C. Owens’ TF BAYONET (173d Airborne Brigade) departed Afghanistan in March as an assortment of NATO battle groups rotated into RC South. Before the ISAF transfer of authority on 31 July, the regional command operated under the authority of Maj. Gen. Benjamin C. Freakley’s CJTF-76. The departure of Owens’ brigade and the reduced number of 4th Brigade Combat Team soldiers deployed to Afghanistan limited Freakley’s ability to use U.S. units to provide space and time for incoming NATO forces in RC South. To set the conditions for their arrival, Freakley directed NATO maneuver forces already in the region to operate under the command of U.S. forces in the months leading up to the ISAF transition. Already on the ground were the Canadians, who had staffed the Provincial Reconstruction Team in Kandahar the previous August. In February, General Fraser’s headquarters, Combined TF AEGIS, became Multinational Brigade South under CJTF-76. Freakley’s decision to assign Col. A. Kent Schweikert as Fraser’s deputy at Combined TF AEGIS placed a liaison in the brigade with enough rank to settle problems that arose between the Canadians and the U.S. command. Schweikert and his staff “focused on making sure the American contribution to the combat effort was straight [i.e., with clear and understood command lines], and did all [they] could to ease the bumps to not only the Canadian multinational brigade coming in, but later [with] the arrival and integration of ISAF into the effort.” Despite the best efforts of Fraser and Schweikert, synchronization could not overcome the shortage in effective combat power caused by the staggered arrival times of incoming NATO forces.\",\n    \"Maneuver forces tasked to resource NATO ISAF’s first year in RC South began arriving in February 2006 with Col. Ian Hope’s TF ORION in Kandahar City. Colonel Sturek’s TF WARRIOR followed in March by moving into Zabul Province until the Romanians’ Task Force CALUGENARI could take over in July. After the Romanians arrived, TF WARRIOR served as the command’s quick reaction force until it redeployed to Fort Drum in November. Britain’s Task Force HELMAND assumed responsibility for Helmand Province in April 2006, while Uruzgan remained a U.S. joint special operations area until the arrival of the Dutch Task Force URUZGAN in August. On 29 April, Lt. Col. Steven Gilbert’s 1st Battalion, 102d Infantry (Connecticut Army National Guard), conducted a transfer of authority with the 3d Battalion, 141st Infantry, at Forward Operating Base GHAZNI.\",\n    \"The fundamentally disjointed nature of NATO’s contingency planning and command structure meant that each national battle group arrived with its own ideas about what it was going to do in its respective province. Some, like the Dutch, focused on promoting “stability and security by increasing the support of the local population for the Afghan authorities and eroding the support for the Taliban and related groups.” Although this approach sounded something akin to counterinsurgency, the Dutch government omitted that word from their mission objectives and refused to admit that their troops were involved in a “combat mission.” In a similar vein, the British government did not anticipate that its troops would be engaged in intensive combat. As described by British Lt. Col. Stuart Tootal, the commander of 3d Battalion, Parachute Regiment, “the mission was conceived as a peace support operation. Any use of force was seen as a last resort and actually having to hunt down the Taliban was not part of the mission. Instead our intended role was to provide security to protect the development and reconstruction efforts of the [Provincial Reconstruction Team] that would deploy with the task force.”\",\n    \"Because the British categorized their missions as peacekeeping rather than counterinsurgency, Tootal’s unit deployed without indirect fire assets, armored transport, or attack aviation. The British paratroopers employed unarmored vehicles so as to move easily about the population without conveying an aggressive military presence. The British also staggered Tootal’s deployment, sending one parachute company at a time so as not to overstress their limited strategic movement assets. Consequently, while the first British soldiers began arriving in Helmand in April, the full battle group was not in place until July.\",\n    \"Incoming ISAF units rarely replaced American units with anything close to equal numbers, let alone firepower. With the end of the Cold War, most NATO countries had significantly reduced their militaries, and many of the remaining units were still serving in the Balkans. When TF ORION assumed responsibility for Kandahar in February 2006, its 850 troops took on a mission that previously involved many more soldiers. In a more dramatic example, the Romanian task force replacing Sturek’s TF WARRIOR had only a third of the combat power of its predecessor. As Colonel Schweikert observed, “you don’t just replace an enabled, fully loaded battalion . . . with what is really less than a battalion [I]t just wasn’t going to be the same and they didn’t have the capability to go into some of the areas [we did] because they just didn’t [have the numbers].” CJTF-76 had to assign an American company from 1st Battalion, 4th Infantry Regiment, to provide additional support to the Romanians.\",\n    \"Finally, because the British initially approached operations in RC South with a nonlethal focus, TF HELMAND contained only about 650 combat troops, with the remaining four-fifths of its 3,300 soldiers serving support functions. This balance severely limited the task force’s ability to contribute to combat operations while, at the same time, it simplified the Taliban’s goal of mustering sufficient resources to challenge NATO. As ISAF assumed command of RC South, it was evident that its units had differing levels of combat effectiveness, support capabilities, or rules of engagement, making it difficult to achieve unity of effort throughout the regional command.\",\n    \"${Operation MOUNTAIN THRUST (May–July 2006)}{bold}\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-3-2.svg\",\n        \"caption\": \"Operation MOUNTAIN THRUST\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_3-2.png\",\n        \"caption\": \"Romanian troops\"\n      }\n    },\n    \"As Operation MOUNTAIN LION drew to a close, CJTF-76 and TF Spartan launched Operation MOUNTAIN THRUST to transition RC South to NATO ISAF control. The absence of Freakley’s entire 4th Brigade Combat Team compounded problems created by the piecemeal arrival of NATO forces into RC South and different understandings of the operations in which those forces would engage. The CJTF–76 commander “advocated for 4th Brigade to come to take the pressure off of NATO, to let 4th Brigade come and do [MOUNTAIN THRUST], let NATO get there, get their feet on the ground, understand the situation, start operating, and then send the 4th Brigade home,” but to no avail.\",\n    \"Without requisite support for a smooth transfer, the responsibility for executing MOUNTAIN THRUST devolved to TF AEGIS and the assorted coalition battle groups available in RC South. Changing units presented a problem because the British and Canadians did not anticipate taking part in a major U.S. operation, even if only in a supporting role. Trying to align the various coalition forces operating in RC South in the early summer of 2006 would reveal fundamental flaws within the NATO ISAF mission.\",\n    \"Operation MOUNTAIN THRUST proved nonstandard in that CJTF-76 utilized SOF as the decisive effort and defined success as SOF’s  ability to partner effectively with reliable ANA forces. Special Operations Task Force 73, based out of Kandahar, and Special Operations Task Force 202, based out of Bagram, began operations in May 2006 with a straightforward task: “ANA 205th Corps, combat advised by CJSOTF-A [CJSOTF-Afghanistan], conducts combat operations to defeat Taliban extremists in NE [northeast] Helmand/Uruzgan and deny them sanctuary in this area.” The ANSF were to remain in the area while a Dutch battalion and reconstruction team moved into Uruzgan Province and Romanians took over operations in Zabul Province.\",\n    \"The plan called for coalition forces to establish positions in Qalat, Kandahar City, and Lashkar Gah by mid-May. From there they would push north to “reduce the enemies [sic] ability to either reinforce or exfiltrate from key sanctuaries in [northeast] Helmond [sic] and Uruzgan.” This force array would form a protective belt around Uruzgan Province, allowing Sturek’s TF WARRIOR to conduct aggressive operations in Zabul and Canada’s TF ORION to move into northern Kandahar. Freakley wanted to use British troops for operations in northern Helmand as well, but their staggered deployment meant that too few were available for this mission.\",\n    \"On paper, Freakley was able to commit more than 10,000 troops to MOUNTAIN THRUST (3,300 British, 2,200 Canadians, 2,300 Americans from conventional and special operations units, and 3,500 Afghans) but only a fraction of those were combat forces. To provide additional combat power for the operation, Freakley moved elements of Toner’s TF CATAMOUNT, augmented by Troop A, 3d Squadron, 71st Cavalry Regiment, into RC South. Colonel Toner’s forces conducted a 750-kilometer road march from Paktika to Kandahar Airfield in early May before moving into northern Helmand for operations in the Baghran District. Significantly, CJTF-76 placed TF CATAMOUNT under the tactical control of the CJSOTF, while TF WARRIOR would be under the operational control of the same SOF headquarters.\",\n    \"Early reports from MOUNTAIN THRUST indicated far stiffer resistance than anticipated. RC South contained only 10 percent of the total Afghan population, but Kandahar and Uruzgan were the birthplaces of the Taliban movement and harbored numerous committed fighters. Helmand was also home to large numbers of Taliban supporters but, more importantly, accounted for more than 85 percent of all opium and heroin production in Afghanistan, which the Taliban levied to fund their insurgency. As the Taliban’s spiritual and financial base, RC South would not surrender to NATO willingly.\",\n    \"As a result, the Taliban presented a stauncher defense against the spring operation than in previous years. On 17 May, Canadian troops fought a sustained battle against Taliban fighters who stayed in defensive fighting positions until killed in close combat or by U.S. AH–64 Apache helicopters. Over the following three weeks, Colonel Hope and his soldiers “were engaging, on some days, four or five platoons’ worth of enemy in different locations in these districts . . . there are hundreds of Taliban fighters here.” ISAF troops found enemy bases with logistical support for insurgent forces, including medical services and a cottage industry of IED and suicide vest production. Unable to prevail over the Canadians, insurgents focused on inflicting casualties on Afghan police units in the area.\",\n    \"Conventional U.S. forces fought numerous platoon- and company-sized engagements as the operation’s supporting effort. Soldiers from Toner’s TF CATAMOUNT met stiff opposition in the Baghran Valley in northeast Helmand. A vital avenue used by the enemy to move south from staging areas in Uruzgan Province into the northern portions of Helmand and Kandahar, the valley had been the launching point of several large-scale ambushes to disrupt the American movements. Even though Toner’s men repulsed attacks, conducted cordon-and-search operations, held village shuras (local consultative councils or assemblies) to connect with the local population, and delivered humanitarian assistance, the situation remained tenuous throughout June and July.\",\n    \"Colonel Sturek’s TF WARRIOR faced similar opposition in Zabul Province. He utilized one of his rifle platoons, an Afghan Army platoon, and a Special Forces ODA, supported by six artillery pieces, to establish a base in the Chalekor Valley in the Daychopan District in northern Zabul. Like the Baghran Valley, Chalekor provided an infiltration route into Uruzgan. If TF WARRIOR blocked both valleys, then the Taliban would be hard-pressed to bring reinforcements into Uruzgan. The Chalekor Valley contained members of Mullah Mohammed Omar’s tribe, and as Sturek recalled, “We didn’t find many friendly people when we moved into the area.” In a meeting with local villagers, elders asked U.S. and Afghan governmental forces to withdraw from the region. According to Sturek, “When it was understood that we were not leaving the villagers started to leave.” Anticipating an enemy attack, Sturek sought to secure air and artillery support, but he “couldn’t convince anybody it was really happening.” Only after his men began taking enemy fire did he receive the requested support.\",\n    \"The special operations contribution to MOUNTAIN THRUST proved to be a truly international effort. As supporting efforts, Romanian and U.S. SOF units partnered with a kandak from the 207th ANA Corps to disrupt Taliban elements on the eastern border of Farah Province. The main effort required coalition and U.S. special operations personnel to partner with 205th ANA Corps kandaks in order to shape operations in Kandahar, Helmand, and Uruzgan Provinces. Combined U.S., Czech SOF, and ANA units executed combat reconnaissance in the Chahar Chinah and Khod Valleys of northern Kandahar Province to identify and target enemy forces. At the same time, Dutch and U.S. special operations units partnered with the ANA to reinforce U.S. infantry units conducting air assaults in southern Uruzgan and northern Helmand Provinces to block entrance into the Baghran Valley. Finally, U.S. Special Operations and ANA air-assaulted into the southern portion of the valley in conjunction with Canadian SOF reconnaissance patrols. With the assistance of kandaks from the 205th Corps, the coalition’s special operations detachments were able to push into the Khod, Baghran, and Chore Mandeh Valleys. These forces conducted clearing operations “as part of MOUNTAIN THRUST [which] enabled PRTs [Provincial Reconstruction Teams] and engineers to initiate selected reconstruction projects.” Through the efforts of combined special operations units, the operation ended in late July, with RC South deemed secure enough to continue transitioning to ISAF control.\",\n    \"Despite unexpected difficulties, Operation MOUNTAIN THRUST accomplished its goal of creating time and space for the United States to transfer RC South to NATO ISAF on 31 July. The main problem was achieving unity of effort among the various coalition elements. According to Freakley, “We were operating on a seam between Operation ENDURING FREEDOM rules and procedures, and then ISAF rules in the south.” During the operation, TF AEGIS had to coordinate the decisive ANA and SOF effort taking place in and around Uruzgan under CJSOTF-Afghanistan while managing American maneuver task forces in Zabul and Helmand, along with Canadian units in Kandahar. For their part, the Canadians had to oversee the staged insertion of British troops into Helmand over the course of MOUNTAIN THRUST, and provide road support for the Dutch task force moving into Uruzgan. The organized resistance that all of these units faced showed that the insurgency presented a far greater threat than previously anticipated. The Taliban, in fact, was mustering a major effort to defend its homeland from NATO forces.\",\n    \"With a rejuvenated Taliban arrayed against an untested international military coalition consisting mainly of inexperienced combatants, the situation in RC South in 2006 marked the beginning of a new phase in the Afghan war. Unlike in previous encounters, the enemy now routinely stood to fight rather than flee to nearby sanctuaries after minimal contact. In numerous platoon- and company-sized engagements, coalition units faced insurgent groups numbering in the hundreds that displayed levels of tenacity, training, and staying power previously unseen during the war. Though coalition firepower prevailed in most cases, insurgents waged a steady propaganda campaign to counter their field losses. They maintained ties to the local population, threatening any who aided the coalition or the Karzai government, and brought in reinforcements to keep the pressure on NATO ISAF.\",\n    \"${The Taliban Seizes the Initiative in Helmand}{bold}\",\n    \"The most significant setback for NATO occurred during summer 2006 in Helmand Province. Like the Canadians, the British government deployed troops to Afghanistan with a view of the mission that did not account for all variables. In looking at the upcoming deployment, British Defense Minister John Reid announced that the British “would not be aggressors.” Instead, he highlighted the planned reconstruction and development work British forces would undertake, and believed that, “If we came for three years here to accomplish our mission and had not fired one shot at the end of it, we would be very happy indeed.” However, Reid’s statement overlooked the fact that the United Kingdom planned to wage a drug eradication program in the same region in which it sought to conduct reconstruction and stability operations. Given that many Afghans in Helmand depended on opium farming for income, the local population would view any attempt by foreigners to eradicate the poppy fields as an aggressive move against their economic livelihood, and instigate rising levels of violence.\",\n    \"Stability and economic development would support the other British mission: counternarcotics. The fight against illegal  drug proliferation was critical to building domestic support for the mission in Afghanistan. It was a way for politicians to justify foreign intervention to their constituents and, while not explicitly stated as such, an effective condition for the United Kingdom’s continued involvement in Operation Enduring Freedom. General John P. Abizaid, a strong proponent of British leadership of ISAF, instructed Eikenberry to support the program, even though he personally viewed counternarcotics as a periphery effort that drained limited military assets. Supported by CENTCOM and the CFC-A commander, British soldiers would eradicate poppy fields and target production and transportation networks. It was a daunting task, as opium production was 30 percent of the Afghan economy. Helmand alone accounted for 42 percent of all poppy cultivation in Afghanistan in 2006 and 30 percent of the world’s supply of opium. Also, the powerful provincial governor, Sher Mohammed Akhundzada, had suspected ties to the narcotics trade.\",\n    \"Given their mandate for counternarcotics, the British pushed to have Akhundzada removed from office before they arrived. An important ally of Karzai’s, Akhundzada used his connections to secure a seat in the Afghan senate and arranged for his replacement, Mohammed Daoud, to accept Akhundzada’s younger brother as his deputy, thus ensuring that the elder Akhundzada’s interests remained secure. Even then, however, Akhundzada did not step down quietly; he later claimed to have encouraged 3,000 of his supporters to side with the Taliban. The nature of the Afghan economy and Helmand politics presented tremendous challenges to the British from the outset.\",\n    \"Some individuals within the British defense establishment felt that British soldiers might encounter armed resistance in Helmand, but they exerted little or no influence over predeployment preparations. When the commander of the British contingent slated to deploy to Afghanistan informed his superiors that a minimum of 14,000 military personnel would be required to secure Helmand, they greeted that number with derision before pointedly directing him to downsize the estimate. Although some lower-ranking British military leaders harbored concerns about their ability to conduct their assigned mission, Americans interacting with senior British officials came away with a different impression. General Freakley later recalled, “[The British] held us in somewhat of a negative light in that we had Vietnam and they had Northern Ireland; who had the better outcome? So far as counterterrorism, they looked at themselves as ‘we know how to do this.’”\",\n    \"To accomplish their objectives for Helmand, the British planned to create a secure area (which they called the “Triangle” or “Lozenge”) circumscribed by their main base at Camp Bastion, the provincial capital of Lashkar Gah, and the market town of Girishk. Although this zone represented less than a sixth of the province’s total area, it included two major population centers and comprised the economic heart of the province, bisecting the fertile Helmand River Valley that ran through the province from northeast to southwest. To secure this area, the British sent 16 Air Assault Brigade under Brig. Gen. Edward A. Butler. Because their troops fell under RC South led by a Canadian brigadier, the British military deemed it improper for Butler to serve under a foreign officer of the same rank. London subsequently removed Butler from the ISAF command chain and established him as national contingent commander and senior officer in Afghanistan answering to his political leaders at Whitehall. Effectively removed from any ISAF tactical responsibilities, Butler instead had authority under his national command chain. British forces in Helmand (TF HELMAND) were placed under Col. Charles P. H. Knaggs, who reported to both Fraser and Butler. Knaggs exercised direct authority over British maneuver forces (Tootal’s battalion) and the Helmand Provincial Reconstruction Team.\",\n    \"Knaggs planned to secure the Triangle with the 3d Parachute Battalion, which would enable the reconstruction team to begin work. According to Butler, “Our priorities were to build up the Camp Bastion infrastructure, establish our presence in Lashkar Gah and in Girishk, raise the PRT [Provincial Reconstruction Team] and forge our relationship with Governor Daoud.” Once they were secure, the British would then range outward to the north and south, expanding their area of control in an effort to challenge Taliban encroachment, support the ANP, and link the villages to the provincial capital.\",\n    \"Meanwhile, the Taliban strengthened its position in RC South in anticipation of the arrival of additional NATO troops.  The impending transition offered them an unparalleled opportunity: the Americans were being replaced by newcomers unfamiliar with the region, and the Pashtun majority population remained either uncommitted or supportive of Taliban efforts. Mullah Mohammed Omar dispatched Mullah Dadullah “Lame” Akhund, one of his most committed followers, to take command of the fighters in the south. A native of Uruzgan Province, Dadullah came from the younger generation of Taliban commanders absolutely committed to Omar’s Islamist vision. He also was described as “the most brutal of all [the Taliban’s] commanders” for having shot his own men and massacred unarmed Hazaras a decade earlier. NATO estimated that his fighting force ranged from 300 to more than 2,000. In February 2006, Dadullah sent 300 men to capture Sangin, a town controlling the northern branch of the Helmand River. His fighters also turned the town of Marjah in central Helmand into the Taliban’s biggest stronghold in the province. Unfortunately, these actions were merely a glimpse of what was to come.\",\n    \"By May 2006, the Taliban established a strong position in the town of Baghran in northern Helmand and made a move to seize key points in the adjacent Musa Qal’ah District. After a battle that killed twenty Afghan soldiers, a Taliban spokesman declared, “We are here to destroy the British. We will hunt and kill them. We will not let them go back to England and say that they have defeated the Afghans.” The Taliban were consciously invoking nearly 200 years’ worth of animosity dating back to the British-Afghan wars of the mid-nineteenth century. One British officer recalled, “What we found when we had forces on the ground was starkly different from what we had anticipated and hoped for. We were ready for an adverse reaction, but to be fair we did not expect it to be as vehement as it turned out to be.” That situation did not stem from the British forces’ inability to anticipate Afghan reactions, but rather from systemic issues within the U.S. intelligence effort, which now had to figure out how to share sensitive material with NATO allies in addition to identifying effective methods to gain relevant information about their elusive enemies.\",\n    \"The decision to delay the British deployment until late spring limited what 16 Air Assault Brigade could accomplish. Instead of establishing positions in a relatively benign environment, the British began arriving at the traditional start of the fighting season in April and May. Their staggered arrival also meant they could not contribute to Operation MOUNTAIN THRUST to the degree that General Freakley wanted. To make matters worse, Governor Daoud responded to the Taliban’s attacks in northern Helmand, often with the support of President Karzai, by requesting that the British protect the district centers. As Tootal’s solitary battalion still did not have all of its combat units, sending even a platoon up north limited British ability to develop the Triangle. Even though Butler tried to explain that he was trading space up north for time to build a zone from which to mount a counterattack, “Governor Daoud and President Karzai made it very clear that the ‘black flag’ of Mullah Omar should never be allowed to fly over the district centers and that the Afghan flag must fly at all costs.” Daoud told Butler, “Unless [the British] occupied the District Centers, [they] might as well go home.” Daoud had few other options because both the ANA and the ANP lacked the skill and numbers necessary to confront the Taliban.\",\n    \"In June, Butler consented to secure the province’s northern district centers. Establishing permanent positions in the northern districts meant abandoning their plan to develop the Triangle. It also meant his troops were now spread so thin holding static positions that 16 Air Assault Brigade lacked any capability to maneuver against the Taliban. The British established fortified positions in the government buildings (termed “platoon houses”) in Musa Qal’ah, Sangin, and Now Zad, along with a position protecting the vital Band-e Kajaki hydroelectric complex. What initially had been characterized as a peace-support mission soon turned into a bitter defense of isolated positions.\",\n    \"The Taliban reacted predictably by launching numerous attacks on the dispersed British units. When direct assault failed  to bring victory, the Taliban sought to cut the defenders off from supplies by laying numerous IEDs along access roads. Even though the defenders enjoyed adequate artillery and air support, they now could be supplied only by air, which presented the constant threat of the enemy downing a helicopter. Despite the unfavorable tactical situation, Butler thought that the Taliban had made an error:\",\n    {\n      \"list\": [\n        \"[The Taliban] became engaged in a conventional fight, a pretty ferocious one. We fixed them and fixed ourselves, but that kept the fight on what I called the “strategic pegs” of the northern District Centers. They were acting as “breakwaters” which the Taliban focused on for the next three months. As a result of that, we kept the “deep.”\"\n      ]\n    },\n    \"Freakley disagreed. To the CJTF-76 commander, the British “played straight into the Taliban’s hands,” falling into the same type of trap that the mujahideen had used against the Soviets in the 1980s. Fraser had a more measured view, saying that the British would have been hard-pressed to avoid getting fixed “without ignoring the Afghans completely.”\",\n    \"General Richards thought that the platoon houses, although they might have “achieved some sort of ascendancy over the Taliban in a military sense,” did nothing to win Afghan “hearts and minds.” Prodigious use of artillery and air support invariably devastated the villages in the vicinity of the outposts, while many of the Taliban fighters killed by the British were unemployed opium farmers with familial and tribal ties to the local area. Whatever the case, the British conducted far more combat operations than reconstruction and development missions during their first six months in northern Helmand.\",\n    \"The constant attacks and wide distribution of their forces so strained the British that TF HELMAND agreed in October to withdraw from Musa Qal’ah District Center if the Taliban followed suit. The controversial deal, initially put forward by locals who wanted the fighting to stop, called for a temporary ceasefire followed by the withdrawal of both British and Taliban forces from the area. Although the Americans were critical of the deal, it helped British leaders to recognize belatedly that they had underestimated the security needs of Helmand Province. Whitehall therefore made sure that the 3d Parachute Battalion’s replacement would not cede the initiative to the enemy. When 3 Royal Marine Commando Brigade arrived in Helmand in October 2006, it brought an additional 870 soldiers, armored vehicles, heavier weaponry, more helicopters, and an aggressive tactical mindset. The British had learned a hard lesson about the resources needed to bring stability to southern Afghanistan.\",\n    \"${Operation Medusa (2–17 September 2006)}{bold}\",\n    \"Even after RC South came under ISAF control, the Taliban showed no signs of reducing their attacks in the area. Three days after the transfer of authority, the Taliban sprang a deadly ambush on Canadian troops southwest of Kandahar City. Intelligence reports confirmed that, while Canadian forces were operating in the province’s northern districts, the Taliban had relocated west and southwest of the provincial capital. Having failed to stop NATO’s entry into the region, the Taliban now focused on retaking Kandahar City. Taliban infiltration had already secured entire districts surrounding the city. Abandoning low-level guerrilla tactics, battalion-sized Taliban elements openly fought against coalition troops in a major push, despite their vulnerability to air and rotary-wing support. Coalition leaders understood these tactical changes as evidence that the area around Kandahar City was growing increasingly volatile.\",\n    \"The Canadians also could not counter Taliban presence in Panjwa’i and Zharey Districts west of the city because of their commitments to MOUNTAIN THRUST. General Fraser understood that the region was “an important area for the Taliban” but “didn’t have enough forces to go in there earlier for a sustained offensive effort.” When the Canadians did launch a clearing mission into Panjwa’i on 3 August, a vehicle struck a large IED, killing two soldiers. After dismounting, the Canadians found themselves facing determined fire on three sides from enemy fighters displaying unusual tactical skill. Radio chatter indicated that there might have been as many as a thousand insurgents in the area. After a hard fight to extricate their lead elements, the Canadians pulled back to reassess the situation. Many Kandaharis openly began speculating that the Taliban would return and seize the capital.\",\n    \"Colonel Hope, who led the 3 August attack, anticipated that a determined effort to clear Panjwa’i would require “a brigade operation.” As events transpired, neither a brigade nor Hope’s battalion undertook that mission. Due to the fixed rotation schedule, Fraser would have to rely on a new force for the mission, as Lt. Col. Omer H. Lavoie’s 1st Battalion, Royal Canadian Regiment (Task Force KANDAHAR) began replacing TF ORION in mid-August. Planning for a return to Panjwa’i also began mid-August. The first substantive step of the plan envisioned a major offensive against the town of Pashmul and was set for October.\",\n    \"Events converged to accelerate the original timetable. The Taliban’s steady propaganda sparked considerable distress and  increased anxiety among Afghan civilians and international aid workers in Kandahar City. In mid-August, the governor of Kandahar, Asadullah Khalid, exacerbated the situation by ordering local Afghan Border Police commander Abdul Raziq, a Karzai ally and virulent opponent of the Taliban, to clear Panjwa’i. The move ignited a violent tribal feud, as it sent Raziq’s mostly Achakzai forces into traditional Noorzai territory. Haji Mohammed Qassam, a Kandahar Provincial Council member, acknowledged that the operation boosted local support for the Taliban. “One village had 10 or 20 fighters against the government before he [Raziq] came,” he noted, “and the next day, maybe 200.” Although the new fighters were inexperienced and untrained, they confronted ISAF and Afghan troops in open battle, presenting a direct challenge not only to coalition forces but also to the Karzai government. As if to drive the point home, on the afternoon of 19 August an insurgent force of 300–500 fighters launched a coordinated attack on an ANP position at the large Ma’sum Ghar hill adjacent to the Bazar-e Panjwa’i city center. After hard fighting, the Afghan police unit and an undersized Canadian company (sent as a quick reaction force) withdrew under cover of darkness. Fraser could now see that the “scale of Taliban activity made it clear that we would have to come back” to Pashmul. Only one question remained: When?\",\n    \"In response to the Taliban’s growing influence, Richards and Fraser accelerated the move into Panjwa’i. Spurring their efforts was their knowledge that Freakley’s CJTF-76 wanted to launch Operation MOUNTAIN FURY in RC East in late September, which would limit the availability of U.S. assets in RC South. The attack in Panjwa’i, called Operation MEDUSA, would test ISAF’s ability to conduct major operations against the Taliban. With Richards describing it as the “NATO main effort” and the “first large-scale offensive in [NATO’s] history,” Fraser set about developing his plan and assembling his forces. The main effort consisted of three Canadian infantry companies (designated as Task Force 3-06) commanded by Colonel Lavoie, supported by a battalion from the 205th Afghan National Army Corps. Fraser could also count on the services of a company headquarters and two ODAs from Lt. Col. Donald C. Bolduc’s Special Operations Task Force 31, which were partnered with comparably-sized Afghan units.\",\n    \"Given the Taliban’s willingness to engage in open battle, Fraser decided against a frontal assault on Pashmul, instead directing one company to advance from the north while another moved from the southeast. This double envelopment sought to prevent the Taliban from escaping toward Highway 1 to the north or Kandahar City to the east. After examining the draft plan, Richards felt that it lacked sufficient combat power. At the ISAF commander’s request, Freakley assigned Company A from Sturek’s TF WARRIOR to augment the northern effort while also sending Company C from TF CATAMOUNT south to support TF-31. In addition, various ISAF contingents would establish blocking positions to the west. Freakley also dedicated additional artillery (including 105-mm. howitzers from Battery B, 2d Battalion, 25th Field Artillery Regiment, and a High Mobility Artillery Rocket System launcher) and aviation support to the operation, and asked the 1st Kandak, 3d Brigade, 201st Afghan Corps, to serve as a reserve. Richards approved the adjustments, thinking it enabled Fraser and Lavoie to “compensate for lack of troops with firepower.”\",\n    \"Colonel Bolduc’s ODAs were to conduct reconnaissance, act as a diversion for the Canadian main effort, and establish a blocking position south of Panjwa’i. As Bolduc evaluated the plan, he decided to reinforce the ODAs with additional command and control capabilities to ensure nothing went wrong during the next phase of the operation. The augmented SOF task force planned to take a circuitous route to minimize the chances of inadvertently encountering enemy fighters. Although they would begin by heading south parallel to Highway 4, the SOF personnel then planned to detour west and north through a sparsely populated stretch of desert before occupying their assigned objective. A third ODA would join the task force to act as a quick reaction force. Even with the addition of more command and control capabilities, the SOF element remained a secondary effort in the overall battle plan.\",\n    \"${MEDUSA}{bold}${:}{bold} ${PHASE I (2–4 September 2006)}{bold}.  The initial ISAF plan called for several days of heavy bombardment by indirect fire and aviation assets. During this period, an international battle group composed of Lavoie’s Company B; Company A from the 2d Battalion, 4th Infantry Regiment; and a third company from the 205 ANA Corps would move south from Afghanistan National Highway 1 toward Objective CRICKET on the northern edge of Pashmul. The move would be a feint to draw the Taliban fighters out of their fortified positions and distract them from operations to the south. The main effort was to come from Company C, 1 Royal Canadian Regiment, setting up a blocking position on the southern bank of the Arghandab River as the bombardment pounded the enemy. After the bombardment inflicted enough casualties on the defenders, Canadian foot soldiers were to cross the river and move on Objective RUGBY, the small village of Bayanzi just south of Pashmul, with the support of Lavoie’s Company A, which would air-assault behind Company C, isolate Bazar-e Panjwa’i, and provide overwatch from the Ma’sum Ghar hilltop.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-3-4.svg\",\n        \"caption\": \"OPERATION MEDUSA\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"As ISAF prepared to launch Operation MEDUSA, the governor of Kandahar announced on 1 September that civilians should evacuate Panjwa’i. Civilian casualties were a likely consequence of military action that neither NATO nor the Afghan government wanted to face. The call also helped to isolate the Taliban from the populace, as the locals were showing every sign of opposing a coalition move on the town. The terrain around Pashmul (situated between company objectives RUGBY, CRICKET, and LACROSSE), just north of the Arghandab, was littered with irrigation ditches, bunker-like grape storage huts (some with mud walls up to three feet thick), and lush fields of grape and marijuana. Intelligence was vague; most estimates of Taliban strength ranged in the hundreds. The actual number was likely closer to 2,000 to 3,000 men capable of coordinating large attacks with multiple groups of fighters.\",\n    \"Like innumerable military operations, MEDUSA did not proceed as planned. The step-off on 2 September went well as both northern and southern task forces established their positions while artillery rained down upon the enemy positions. The first deviation from the plan occurred soon afterward as reports that the Taliban fighters were fleeing prompted pressure from higher headquarters for Colonel Lavoie to push Company C across the river to assault rugby on 3 September. The Canadians crossed only to encounter intense fire from prepared defensive positions well-stocked with weapons and ammunition. Mud-walled compounds, reinforced dugouts, trenches, and fighting bunkers turned every cluster of homes into a miniature fortress, impervious to all but armored bulldozers, tanks, or artillery.\",\n    \"Following a seven-hour fight in which they suffered deaths and the loss of vehicles to rocket-propelled grenade fire, the Canadians extricated themselves and reestablished their position on the southern bank of the Arghandab. After spending the night preparing to relaunch the assault, disaster struck. Just after 0500 on 4 September, a U.S. A–10 Thunderbolt II attack aircraft accidently strafed the Canadian position. The attack killed one soldier from Company C, wounded at least thirty others, including the company commander, and rendered the company combat-ineffective. For the second time during ENDURING FREEDOM, mistakes made by American pilots caused the deaths of Canadian soldiers. Unlike the previous incident, however, this fratricidal attack had far more tragic consequences, throwing the main thrust of TF 3-06’s attack into complete disarray.\",\n    \"To the north, the attack of Company B initially went well. The terrain was suited to the Canadian wheeled light-armored vehicles, which could cover a good deal of ground with their 25-mm. cannon. The international battle group had established positions just south of Highway 1 by 2 September. From there the attackers began a back-and-forth engagement with the Taliban, alternating between small feints toward Objective CRICKET and repulsing enemy attacks, while coalition artillery and air assets dropped ordnance on Taliban positions. Company B was preparing to launch its strongest move against the Taliban lines when it received word of the friendly-fire incident to the south. All operations ground to a halt as Fraser and Lavoie evacuated their casualties and reassessed the situation.\",\n    \"${MEDUSA}{bold}${:}{bold}  ${PHASE II (5-10 September 2006)}{bold}. The errant A–10 strike that halted TF 3-06’s southern attack had a profound effect on the coalition. Colonel Lavoie and his men were shocked by the incident, with some arguing that allowing the scheduled three-day bombardment could have averted the tragedy. Fraser acknowledged pressure coming from higher headquarters to “get it done” but responded that “you don’t fight a plan; you fight the enemy guided by a plan.” Intelligence reports indicated that the enemy was sufficiently battered by the initial day’s bombardment, and Fraser decided to push forward rather than allow the Taliban time to recover or withdraw. Now Fraser faced a different challenge. Lavoie had no desire to resume the attack along the same path and preferred a more methodical approach to seizing RUGBY. Fraser understood that this would delay the operation, which was contrary to the desires of ISAF headquarters.\",\n    \"According to the TF AEGIS operations officer, Richards and Freakley were adamant that the attack go forward, telling Fraser, “this is the most important thing NATO’s ever done, the future of NATO rides on this, the future of Afghanistan rides on this.” At the same time, as the Canadian national component commander, Fraser was under pressure from Ottawa not to incur heavy casualties. Richards had to communicate directly with the Canadian government to convince them to approve the attack’s continuation. The next few days would show whether the coalition was capable of conducting the aggressive combat operations needed to secure RC South.\",\n    \"To the southwest, the soldiers of Special Operations TF-31 provided an unexpected opportunity for the coalition to reclaim the initiative. After departing Kandahar on 26 August and moving along a circuitous path from which they could identify Taliban infiltration and resupply routes, training camps, and a command and control node, the Special Forces soldiers and their Afghan partners established their assigned blocking positions on 1 September. Following the friendly fire incident, the partnered SOF task force asked to move from its blocking positions and occupy key terrain to support the offensive.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-3-5.svg\",\n        \"caption\": \"OPERATION MEDUSA Phase II\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"With ISAF permission secured, and with the rifle company from 2d Battalion, 87th Infantry Regiment, taking over its original positions, the small force of eighty-nine U.S. SOF and ANA soldiers assaulted a large hill, called Sperwan Ghundey (also known as Sperwan Ghar), which overlooked the surrounding area. After being repulsed on their first attack, the combined SOF-ANA force took Sperwan Ghundey on 6 September. The feat handed possession of the high ground covering the entire area to Fraser. In evaluating TF-31’s accomplishment, one Canadian officer called it, “one of the most profound acts of bravery I’ve seen since I’ve been over here.” Facing an anticipated counterattack from the Taliban, the special operators and their Afghan counterparts dug defensive positions. They were soon aided by the arrival of an additional ODA and troops from Company C, 2d Battalion, 87th Infantry Regiment. With the extra firepower, along with artillery and air support, TF-31 defeated multiple Taliban counterattacks before finally establishing a firebase at Sperwan Ghundey on 11 September.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_3-3.png\",\n        \"caption\": \"Member of Company A, 2d Princess Patricia’s Canadian Light Infantry\"\n      }\n    },\n    \"As SOF seized the initiative to the southwest, Fraser reconstituted his brigade and revised his attack plan. With General Freakley’s support, Fraser turned to Col. R. Steven Williams, whose Task Force GRIZZLY had replaced Schweikert’s force in June as the U.S. National Command Element in RC South. Williams’ unit, composed of the Alaska Army National Guard’s 207th Infantry Group headquarters and the 297th Support Battalion, was never intended to operate as a combat force. Fraser, however, now called on his American deputy to reinforce and reorganize Company C for a renewed move on Objective RUGBY. In an effort to fix the enemy in place, Williams was told to make his ad hoc unit “look like a thousand man organization.” Williams and his men moved out on 6 September and consolidated the Canadian position south of the Arghandab. Described by Fraser as a “warrior,” Williams immediately began calling in airstrikes against the Taliban across the river and doing everything he could to signal an impending assault against RUGBY from the southeast.\",\n    \"With Special Operations TF-31 securing the high ground to the southwest and TF GRIZZLY fixing the enemy at RUGBY, the main focus of the battle shifted north. Fraser redeployed Company A, 2d Battalion, 4th Infantry Regiment, to the northern battle group to increase its combat strength. Now with three coalition companies (two Canadian and one American) and support from the ANA’s 205th Corps, the combined task force began a slow but steady push south on 6 September. Using what one officer described as “World War I tactics,” the battle group established a line of advance, identified Taliban targets, destroyed them with air and ground fire, and then sent the infantry bounding forward to establish a new position. In this manner the combined task force slowly ground through the Taliban, who found that the constant pressure shattered their command and control and logistics capabilities. As the Taliban began to lose cohesion, the combined task force secured Objective CRICKET on 10 September, setting the stage for MEDUSA’s final phase.\",\n    \"${MEDUSA}{bold}${:}{bold} ${PHASE III (11-17 September 2006)}{bold}\",\n    \"By 11 September, Fraser began preparing to end Operation MEDUSA. With his northern battle group clawing its way south and TF-31 and TF GRIZZLY directing fire on the Taliban from the south and southeast, Fraser directed Williams to assault RUGBY. Against weak resistance, Williams led his men across the river, swept north, and then turned east to advance on the objective. Meanwhile, the combined battle group to the north continued its attack. The U.S. contribution (Company A, 2d Battalion, 4th Infantry Regiment, called Task Force MOHAWK) shifted to the west and seized Objective LACROSSE on 12 September, after which it moved against the western portion of RUGBY. As the Canadian Company A drove toward the northeast portion of RUGBY, Williams’ TF GRIZZLY approached from the east. By 13 September ISAF forces controlled roughly 65 percent of the objective, and TF MOHAWK seized the western portion of RUGBY the following day.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-3-7.svg\",\n        \"caption\": \"OPERATION MEDUSA Phase III\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"As his forces consolidated at Objective RUGBY, Fraser shifted his attention to the southwest, where TF-31 remained entrenched atop Sperwan Ghundey. Fraser ordered the Special Forces task force to push across the river to seize Objective TENNIS at the village of Siyah Choy. For the move, which Fraser designated as the new “main effort,” he “allotted them priority on artillery, aviation, and everything else.” The original plan never called for TF-31 to cross the Arghandab but, as with their earlier exploits, the American and Afghan soldiers unhesitatingly accepted the mission. They forded the river on 12 September, supported by two companies of ANA troops and Company C, 2d Battalion, 87th Infantry Regiment, to begin a sweep west toward Siyah Choy. They found that most of the Taliban had departed, allowing the soldiers to secure the entire objective within a week. Fraser’s units then began preparing for Phase IV operations by establishing security positions near villages in the area. As villagers returned to their homes around Pashmul, General Richards announced that Operation MEDUSA had been successful.\",\n    \"${Continuing the Fight}{bold}\",\n    \"As the largest battle since Operation ANACONDA in March 2002, Operation MEDUSA was an anomaly. It was far closer to a conventional force-on-force battle than the typical experience in Afghanistan. Although the Taliban committed a significant tactical misstep attempting a deliberate defense of Pashmul and Panjwa’i, those actions revealed an enemy with previously unseen military capabilities and resilience. Taliban fighters had stockpiled several months’ worth of munitions that they utilized during MEDUSA and they did not give ground even in the face of logistical shortages. The Taliban fired off 400,000 rounds of small arms, 2,000 rocket-propelled grenades, and 1,000 mortar shells during the battle, expenditures which reflected firepower rarely seen since the first months of the war. Personnel losses, which the coalition estimated to be 512 killed and 160 captured, were easily replaced by the Pakistan madrassas. In the meantime, the insurgents either retreated to Pakistan or melted into the population, content to resume their insurgency at a time and place of their choosing. As for ISAF, the battle ended without coalition forces possessing sufficient resources to prevent the Taliban from returning to Kandahar’s western districts. The engagement, however, assuaged doubts that NATO forces could not or would not fight when pressed. By its international involvement and conventional tactics, if not its ambiguous outcome, Operation MEDUSA had little parallel in almost five years of combat operations.\",\n    \"After MEDUSA, CJTF-76 withdrew U.S. conventional forces from RC South for duty in RC East. The Americans would not return to the south in large numbers until 2008. In the meantime, CJSOTF-Afghanistan continued to support both ISAF and CJTF-76, despite not having a direct command and control relationship with either headquarters. Special Operations TF-31 was called upon to support ISAF in the south not long after MEDUSA’s end. Though ISAF forces began stability operations in Panjwa’i on 23 September, the lack of a large, capable, and permanent security force enabled the Taliban to reoccupy many of their previous strongholds. The Taliban also took advantage of the pause created by ISAF changing command in RC South from Fraser to Maj. Gen. Ton van Loon of the Netherlands on 1 November 2006. In keeping with his experience in Bosnia, van Loon brought with him a new mission emphasis, shifting ISAF efforts to provide more humanitarian assistance.\",\n    \"Following a month of increasing violence and stalled reconstruction in Panjwa’i, van Loon approved Operation FALCON SUMMIT (BAAZ TSUKA in Dari) to follow MEDUSA in December. He sought to drive the Taliban out of its strongholds, provide humanitarian assistance, enhance local infrastructure, and reestablish an Afghan security presence. As executed, FALCON SUMMIT was a series of coordinated efforts involving ANA, U.S. SOF, and Canadian and Dutch forces. Between 15 December 2006 and 12 January 2007, ISAF cleared the Zharey and Panjwa’i regions around the village of Howz-e Madad, located north of the Arghandab River, while SOF-ANA partnered units cleared objectives west from Sperwan Ghundey. The operation included an air assault by a Dutch infantry company into the village of Mushan on 22 December, which established the overall western limit of advance. The operation successfully concluded with the creation of permanent ANSF-staffed checkpoints throughout the area.\",\n    \"The key American contribution to FALCON SUMMIT was to locate and kill Taliban commander Akhtar Mohammed Osmani in Helmand. His loss was a blow to the Taliban leadership and removed a major conduit for funding al-Qaeda. Two months later, as Vice President Richard B. “Dick” Cheney visited Afghanistan and Pakistan in February 2007, Pakistani forces arrested Mullah Obiadullah Akhund, the former Taliban defense minister and insurgent commander, in Quetta. In May 2007, coalition forces in Helmand killed Mullah Dadullah Akhund, described by a NATO spokesman as “the top person in our scope of Afghanistan that we were interested in removing.” These losses, when added to the overall impact of ISAF counterinsurgency efforts, significantly reduced the possibility of renewed Taliban offensive across the south and west in the summer of 2007. The trio of successes capped a year of frustration in Afghanistan, staunching the trend of local reverses that had started with the Taliban revival in late 2005.\",\n    \"${Coalition Difficulties}{bold}\",\n    \"Although ISAF successfully took over responsibility for RC South in mid-2006 and reduced the enemy threat to Kandahar City with Operation MEDUSA, coalition efforts in Afghanistan still faced clear internal problems. The decision not to deploy 10th Mountain’s 4th Brigade Combat Team meant that the forces operating in RC South in mid-2006 had varying capabilities, missions, and rules of engagement. The core issue remained a failure to achieve unity of effort among the troop-contributing nations. Each assumed responsibility for a separate province, crafted its own campaign plan, and deployed forces specifically designed to achieve its objectives. As a result, no single effort covered all of RC South. With the exception of Operation MOUNTAIN THRUST, task forces conducted operations according to their own goals, which were normally national goals. This segmented approach proved ill-suited to the environment, where important tribal alliances spanned provinces. The Taliban, which was not tied to political boundaries, operated along provincial borders to take advantage of weaknesses within the coalition’s structure. The lack of significant reserve forces made it difficult for U.S. and ISAF commands to shift forces between provinces when necessary. The degree to which these ambiguities caused problems varied within the untested, multiple chains of command, but on the whole they highlighted the inefficiency that often defines coalition operations.\",\n    \"Even MOUNTAIN THRUST, which was designed to coordinate multiple national task forces across four provinces, was not free from coalition friction. Although CJTF-76 had designed the operation, the execution fell to the Canadian TF AEGIS. As one observer noted, “The reality was that MOUNTAIN THRUST was a divisional plan using mostly resources executed in TF AEGIS’ area of operations, with CJSOTF-A commanding its own part of the operation and TF AEGIS commanding two battle groups in a supporting role—TF ORION in Kandahar and TF WARRIOR in Zabul.”\",\n    \"Aligning those various efforts proved challenging, particularly because many incoming NATO units had not been briefed on their participation in the operation. General Butler complained that the staggered nature of the British deployment left his nation’s forces with “very little influence on MOUNTAIN THRUST planning, but we were expected to participate in it. . . . We were being asked to do too many tasks beyond our capabilities.” In the end, the British were not able to contribute to MOUNTAIN THRUST to the degree CJTF-76 intended, forcing Freakley to shift U.S. units to Helmand for the operation.\",\n    \"Operation MOUNTAIN THRUST exposed the problems that NATO incurred by not utilizing a rigid chain of command. As a political  alliance, each government within NATO maintained control over its own forces. Field commanders could therefore receive directives from their NATO superiors that contradicted instructions from their own national governments. Navigating these situations required commanders to display more diplomatic skills in executing their military operations and placed a premium on personal relationships. Some, like General Fraser, adapted easily to the challenge. Although deployed to command a NATO force, Fraser served for several months under the U.S. chain of command. To Fraser this was not an issue: “It was real dead simple. General Freakley was the commander of Combined Joint Task Forces 76. [As the RC South commander,] I worked for Freakley.” Others, however, found the command arrangement more difficult. While the British TF HELMAND fell under Fraser’s command, it also reported to General Butler. Although Butler possessed no tactical command authorities, he represented the direct link between British ground forces in Helmand and Whitehall in London. When Fraser sought to use British forces as a part of larger operations in RC South, Butler became an impediment rather than an enabler. The situation eventually pushed Fraser to insist that Richards rectify the matter once RC South transitioned to ISAF control. Richards complied, placing Butler under Fraser’s command authority.\",\n    \"For his part, Butler never thought General Freakley appreciated the pressures constraining national component commanders, nor the fact that they remained responsible to their home governments. “I think as the Afghanistan campaign matures,” Butler later stated, “it will be better understood that” lead nations have to increase their ability to accommodate the “coalitions of the willing.” Freakley drew different conclusions. In looking at NATO, he thought the alliance was “a good strategic platform to keep nations in the fold, have a common interest, have common goals and objectives and strategies, but operational[ly] and tactically . . . [it was] extremely hard” to implement these ideals. The respective viewpoints are telling. Butler focused on personalities and the immature nature of ISAF, whereas Freakley emphasized the ways in which coalition forces cooperated seamlessly with their American counterparts. As the violence spread in Afghanistan, the commanders of ISAF contingents faced the difficult choice of supporting American needs or following the wishes of their home governments.\",\n    {\n      \"title\": \"Competing Approaches to Police Training\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The understandable frictions taking place on the battlefield as NATO ISAF assumed responsibility for Afghan security were mirrored in other areas as well. Although the United States took responsibility for developing the ANP in 2005, the coalition still played a role, leading to continuing disagreements over the proper direction of reforms and the training program. Americans believed that police should be incorporated in the larger framework of Afghan security, linking their efforts to those of coalition and Afghan military forces. Afghan police, therefore, needed to be equipped and trained to secure territory cleared through combat operations, enabling army units to move to other areas. Holding territory, however, required “the addition of a counterinsurgency role for the ANP.” For the Germans, who continued to operate the Kabul Police Academy, this militarization constituted a shift away from the idea that police served as providers of civilian law enforcement. Unlike the Americans, the Germans still believed that there needed to be a sharp division in Afghanistan between the police and the military. According to German embassy officials, the ANP needed to continue exercising “policing functions and should not be altered into a paramilitary force.”\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_3-4.png\",\n        \"caption\": \"42d Brigade (Romania) troops\"\n      }\n    },\n    \"The German viewpoint diverged significantly from tactical reality in 2006 as the resurgent Taliban and other insurgent groups increasingly targeted the ANP. According to CSTC-A, the ANP suffered 1,113 casualties (406 killed and 707 wounded) from May 2006 to May 2007 while the ANA suffered 776 casualties (170 killed and 606 wounded) during the same period. Comparatively, coalition forces suffered 1,220 causalities (181 killed and 1,039 wounded). For the ANP, therefore, 36.5 percent of total casualties were fatalities, compared to 21.9 percent for the ANA and 14.8 percent for coalition forces. Another report indicated that police killed in action rose from 9 in 2002–2003 to 627 in 2006–2007. As Maj. Gen. Robert E. Durbin explained, “we had more Afghan National Police dying [by the fall of 2006] than Afghan National Army and Coalition military combined . . . so, we made the decision that the Afghan National Police needed to be at least as well armed and at least as well trained in self-defense as the enemy they were fighting.”\",\n    \"In 2006, the mounting human cost, coupled with a belated willingness to contribute additional resources, helped the American vision supersede German arguments on Afghan police training. Germany had reached the limits of its capacity regarding the Afghan police program. Although the nominal lead for police reform, it could not match the $2.1 billion in aid that the United States contributed to the ANP between 2002 and 2006. Sensing Germany’s financial limitations, the European Union discussed taking an increased role in police training in mid-summer 2006. After sending a fact-finding mission to Afghanistan, the European Union announced in February 2007 that it would take the international lead. The European Police, formed in the following months, assumed control over Afghan police training from Germany in mid-June 2007. Europeans subsequently deployed some 220 personnel to Kabul, including 160 police officers. However, the involvement of the European Police did not expand police training. Instead, it drew “under one umbrella nearly all non-U.S. actors, including sixteen European Union member states and seven others.” The Germans represented the largest contingent of European Police, with more than thirty members of the former Police Policy Office participating in the effort. The renamed German Police Project Team shed some personnel but continued mentoring police trainers at the Kabul Police Academy. Not surprisingly, the Germans influenced the European Police’s efforts, which were oriented primarily on developing new officers and less focused on meeting American concerns about the inadequate scope of the program or expanding ANP capabilities.\",\n    \"Recognizing the disconnect, Maj. Gen. Robert W. Cone, General Durbin’s replacement at CSTC-A, ordered his staff to reassess the U.S. police training program. It found little improvement, even though the program had shifted roughly 800 trainers from the ANA to the ANP during the previous year. Members of Cone’s staff and CFC-A argued repeatedly that systemic corruption within the Ministry of Interior and the ANP prevented the police from deterring crime, providing stability, and combating the growing insurgency. As Cone explained, “What was actually happening was [trainers] were training large numbers of individuals and then firing them out into these dysfunctional and corrupt organizations that they couldn’t change.” Cone and his staff concluded that they needed to concentrate on individual districts while stepping up their efforts to implement ministerial reform. Adding a local focus had the benefit of allowing Cone’s organization and the ANP to contribute to the fight against the Taliban, something General Dan K. McNeill, the new ISAF commander, expected CSTC-A to do.\",\n    {\n      \"title\": \"Recalibrating Reconstruction\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"In 2006, the U.S. military’s main effort to oversee Afghan reconstruction consisted of twelve Provincial Reconstruction Teams, ten of which were spread throughout RC East. Eight of the teams in RC East, located in the contested provinces of Khost, Kunar, Laghman, Nangarhar, Nuristan, Paktika, and Paktiya, consisted of roughly eighty-nine military personnel, several interpreters, and two or three interagency civilians. They coordinated their activities with the U.S. maneuver brigades operating in that region. The reconstruction teams in Parwan and Panjshir Provinces were allocated somewhat fewer personnel because they were located in relatively benign areas compared to RC East. These teams were eventually placed under an ad hoc tactical headquarters, which had the mission of transitioning ongoing reconstruction projects from the reconstruction teams to the U.S. Agency for International Development and nongovernmental agencies. The final pair of U.S. teams operated under ISAF control in RC South and RC West. These, located in Zabul and Farah Provinces respectively, were authorized ten additional personnel because they were responsible for managing the forward operating bases that housed them and coalition units. Unfortunately, their ISAF-related responsibilities became so consuming that these teams often lacked the time and resources to conduct their primary mission.\",\n        \"In contrast to their U.S. counterparts, the fourteen ISAF Provincial Reconstruction Teams varied significantly in size and composition. The Italian, German, Canadian, and British Provincial Reconstruction Teams all numbered over a hundred personnel, with the Germans having nearly 500 in Kunduz. The non-U.S. teams also had far more civilians, with the German and Canadian contingents numbering twenty civilian personnel each, while the British in Helmand had thirty civilian experts divided into functional cells such as rule of law, governance, development, and stability. The civilian head of the Helmand reconstruction team outranked, but did not exercise direct command of, the British military officer in the province. In addition to non-U.S. civilians, U.S. Agency for International Development and U.S. State Department representatives were assigned to a number of ISAF reconstruction teams.\",\n        \"Provincial Reconstruction Teams in Afghanistan had ample opportunity to improve the economic situation of ordinary Afghans  through both direct and indirect means. The teams, however, had to ensure that every project that they sponsored advanced the goals articulated in the document governing Afghanistan’s reconstruction and development: the Afghan National Development Strategy. Approved in interim form at the London Conference held on 31 January–1 February 2006, the Afghan National Development Strategy was a vision for development that was consistent with Islamic law and the cultural values stated in the Afghan constitution. The strategy not only supported the Afghanistan Compact but also included language to reassure international donors that their reconstruction funds were being used in an effective and coherent manner. Finally, it integrated existing provincial development plans by approving projects drawn up by 345 district development assemblies and 16,753 (later 18,500) community development councils.\",\n        \"As the conflict in Afghanistan entered its sixth year, Provincial Reconstruction Teams deploying to that country underwent significant changes in order to meet the needs of the greater war on terrorism. With the Iraq war limiting available Army personnel, the DoD assigned Air Force and Navy officers to command reconstruction teams. The teams were reconfigured based on feedback from earlier deployments and a growing awareness of Afghan needs. Each of the twelve authorized U.S. teams now had five primary sections: command, administrative, logistics, security forces, and specialized staff comprising the State Department, Department of Agriculture, and U.S. Agency for International Development experts. Reconstruction teams also now included two engineer officers who provided expertise as project managers for construction projects. The engineers, along with interagency subject matter experts and three to eight civil affairs officers, performed most reconstruction-related tasks. The remaining seventy to eighty personnel provided security, mostly for those dozen or so individuals who managed the core missions of the teams.\",\n        \"By 2007, most Provincial Reconstruction Teams sought to give local shuras the responsibility for making key reconstruction decisions. The shura would develop ideas, identify the right contractors, and ensure locals were employed as workers. This approach fostered the notion among Afghans that coalition troops were not a threat to the established hierarchy. As using shuras became accepted practice, U.S commanders recognized that “the more we work in partnership with them, the more the government works in true partnership with them, the more they come to the side of the government, and the more likely they are to take an active role in denying the influence of the insurgents in their local areas.” It took time to build these relationships and establish trust, but designing reconstruction and development efforts so that they were seen as providing sustainable value to the local community was the most effective way to grow support for the central government.\"\n      ]\n    },\n    {\n      \"title\": \"Operations MOUNTAIN FURY and MOUNTAIN EAGLE (July 2006-February 2007)\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"As NATO and U.S. forces battled for control of RC South, American efforts in RC East continued on a considerably smaller scale. The soldiers in TF TITANS and TF CHOSIN worked to establish relations with local villagers and solidify the inroads they had made into Kunar and Nuristan during Operation MOUNTAIN LION. With the majority of CJTF-76’s logistics and air support operating in RC South, Eikenberry and Freakley allowed RC East to become a secondary effort. Units still held outposts and patrolled their immediate areas, but efforts to expand the coalition footprint would have to wait until additional resources became available. By August, after most of TF WARRIOR and TF CATAMOUNT returned from RC South, Freakley stood ready to execute MOUNTAIN FURY, an operation targeting the provinces of Paktika, Paktiya, Khost, and Ghazni.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-3-9.svg\",\n        \"caption\": \"Operation MOUNTAIN FURY\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"In designing Operation MOUNTAIN FURY, CJTF-76 planners took into consideration developments within Pakistan and among the various enemy groups. The Taliban’s efforts in RC South had made it clear that its fighters were attempting to isolate the region from Kabul and the eastern provinces. At the same time, the Taliban was making inroads into Pakistan’s Federally Administered Tribal Areas, the base of the Haqqani family franchise. The result was a “simultaneous expansion of [Taliban] influence from the FATA [Federally Administered Tribal Areas] into the interior portions of Afghanistan [which] has empowered the [Haqqani Network] to establish sanctuaries within Afghanistan.” Haqqani fighters began arming in Ghazni Province as early as 2005, and foreign fighters, including al-Qaeda recruits, began transiting through Paktiya Province via old mujahideen supply routes in the Shahi Kot.\",\n    \"The Taliban leadership pushed the Haqqani Network to pressure the Afghan government in Logar, Paktiya, Khost, and Paktika Provinces;  establish shadow governments; and target Afghan government and security force officials. The network utilized its ties to al-Qaeda, the Pakistani intelligence service, and other militant extremists to launch its signature tactic: the high-profile attack. These attacks, executed by Haqqani operators but typically claimed by the Quetta Shura Taliban, embarrassed the Karzai government and increased the cost of the U.S. and NATO occupation. Favored targets were political and diplomatic figures, civilian-commercial facilities in Kabul, and ISAF bases in eastern Afghanistan. The potential for high casualties became one of the most significant strategic threats to the ISAF mission, earning the Haqqani Network the label of “most lethal insurgent actor operating in Afghanistan today.”\",\n    \"For Operation MOUNTAIN FURY, Freakley consolidated his forces in RC East. Their primary mission was to eliminate insurgent strongholds in western Paktika and southeast Ghazni while simultaneously disrupting enemy activity along the Pakistan border. Freakley and Colonel Nicholson, the TF SPARTAN commander, divided the regional command into seven operational areas, each with a battalion-equivalent force. Units throughout RC East began shaping operations in late August to set conditions for the operation’s decisive phase. Colonel Nicholson also called upon TF WARRIOR in southern Ghazni and TF CATAMOUNT in Paktika to clear insurgents out of the districts along the provincial boundary with the Afghan Army’s 203d Corps.\",\n    \"Unlike previous operations in which American maneuver units tried to connect their efforts in an overarching framework, MOUNTAIN FURY consisted of small unit actions across large areas. As in RC South, the insurgent groups reacted aggressively to coalition movements into previously unoccupied areas, massing fighters against U.S. mounted patrols in an effort to gain an information operations victory by wiping out a platoon-sized American force. ISAF soldiers were usually outnumbered in these attacks, but their better skill, training, and firepower inflicted considerable damage on the enemy. Despite coalition successes, the attacks continued, reminding the Americans they were operating in hostile territory. Ultimately, CJTF-76 utilized roughly 7,000 soldiers in six weeks of operation across the four provinces, killing hundreds of insurgents and capturing numerous weapons caches while suffering sixteen American deaths and eighty-four other casualties.\",\n    \"Operation MOUNTAIN FURY included efforts to improve the lives of local residents. In Paktika and Ghazni Provinces, civil affairs teams followed clearing operations, identifying small, immediate-impact projects that could link communities to Afghanistan’s central government. The teams utilized funds from the Commander’s Emergency Response Program to repair roads, rebuild district centers, provide medical and veterinary assistance, and distribute supplies for schools and clinics. Throughout the rest of TF SPARTAN’s operational area, U.S. forces continued to consolidate the gains achieved during MOUNTAIN LION and support reconstruction and development. During the six-week operation, TF SPARTAN completed one major road project, built thirty-eight district centers, and provided medical assistance to more than 6,000 patients. The tactics pursued in MOUNTAIN FURY were not new, although, like in the 10th Mountain Division’s three previous operations, Freakley directed them to be exercised in communities that had not yet experienced coalition activity.\",\n    \"Halfway through MOUNTAIN FURY, American conventional forces completed the final shift to NATO ISAF authority. On 5 October 2006, CJTF-76 formally became the ISAF RC East headquarters. Freakley maintained command over U.S. forces but took on the role of ISAF deputy commanding officer for security operations. British General Richards said of the move, “By bringing all of these forces under unified command, we enhance the effectiveness of the operation, as we have far greater flexibility in the use of our assets.” For Freakley, the added duties began “one of the hardest times in my life.” He was particularly concerned that German General Beck, the Joint Forces Command–Brunssum commander and Richards’ direct NATO superior, wanted him to spend most of his time in Kabul and travel throughout the other regional commands to coordinate operations. Freakley also had to fend off requests from NATO nations for using American assets in other regional commands. “Had I just agreed,” Freakley later stated, “they would have, in essence, pulled [CJTF-76] apart.” Thankfully for Freakley, Richards allowed the American general to maintain his headquarters at Bagram. For his part, Richards was fighting his own battles trying to secure more troops for the ISAF mission, with limited success.\",\n    \"With Richards’ support, Freakley designed the last operation for TF SPARTAN’s year-long deployment to return American soldiers to aggressive counterinsurgency tactics. The RC East commander wanted to set conditions for TF SPARTAN’s relief by 4th Brigade, 82d Airborne Division (Task Force FURY), and was already seeing his forces rotate out of theater, as Lt. Col. Ronald J. Metternich’s 2d Battalion, 30th Infantry Regiment, 4th Brigade Combat Team, 10th Mountain Division (Task Force WILD BOAR), replaced Sturek’s TF WARRIOR in November. In Freakley’s understanding, the best way to protect the gains achieved during the three previous operations was to open more of the countryside to “steady state COIN [counterinsurgency]” operations.\",\n    \"Operation MOUNTAIN EAGLE (1 November 2006–20 February 2007) therefore pushed soldiers into remote valleys in the northeastern provinces and pressured infiltration routes in RC East’s southern provinces. To block enemy lines of communications with Pakistan and disrupt Taliban and Haqqani coordination before winter, coalition and Afghan forces established twelve new combat outposts during the operation. As Eikenberry prepared to end the CFC-A mission, the political counterinsurgency he had inherited from General David W. Barno, which had been simplified during his first months of command and then imperfectly implemented by NATO in RC South, now became Freakley’s preferred method of securing Afghanistan.\",\n    \"While U.S. conventional forces conducted their final operations in RC East, Colonel Bolduc’s CJSOTF focused on disruptive elements closer to Kabul. In Kapisa Province, just north of RC Capital, Taliban forces had infiltrated the Tagab District in Kapisa Province and established a sanctuary from which they could launch attacks into Kabul, harass convoys, and threaten the security of Bagram Air Base. The locals, left without security since a coalition offensive cleared the valley in 2005, feared Taliban reprisal and were reluctant to accept humanitarian assistance, let alone provide information on Taliban networks or activities. In response, Bolduc directed Special Operations Task Force 33 to plan a multinational effort to establish long-term security and reaffirm Afghan governmental legitimacy in the area. Described as a three-way partnership including TF-33, ANSF, and Task Force 8 (a United Arab Emirates SOF task force), the effort was more than a clearing operation. TF-33 integrated the ANSF, Kapisa provincial government, U.S. agencies, and the United Arab Emirates in the operational planning to ensure a holistic effort that could be transitioned to Afghan lead. The plan leveraged the good relationship between the TF-8 commander, Lt. Col. Nasser al Ottabi, and the Kapisa governor, Satar Murad. Their cooperation led to a better understanding of the terrain, local leadership, and Taliban networks, as well as corresponding improvements in both civil-military targeting and kinetic operations.\",\n    \"The Kapisa segment of MOUNTAIN EAGLE began on 31 October when coalition forces air-assaulted into the northern end of the Tagab Nawah, and two U.S. SOF A-teams infiltrated the southern end with their ANP partners. Aided by AH–64 Apaches, AC–130 Spectre gunships, and more than 900 ANP personnel from Kapisa and neighboring provinces, the combined force cleared the valley over the next eleven days. Within hours of areas being cleared, support personnel built firebases using prepackaged construction materials (often referred to as “firebases-in-a-box”) for the ANSF. An ODA combat outpost was established to maintain partnership with the ANP and develop new auxiliary police forces.\",\n    \"More importantly, the combined multinational and interagency force provided humanitarian and medical assistance to the local residents using international and Afghan government resources. The United Arab Emirates contributed to the effort by funding infrastructure projects, as its international development financing had fewer restrictions than those of the Afghan or U.S. systems. CJTF-76 later dedicated millions of dollars in Commander’s Emergency Response Program funds to the area, while the Kapisa Provincial Reconstruction Team and the U.S. Agency for International Development produced a long-term infrastructure strategy with the governor. All of these efforts were publicized through a radio, leaflet, and shura campaign in which the governor highlighted the benefits of the operation and refuted Taliban misinformation. Partnered security operations, unprecedented levels of civil-military coordination, and substantial infrastructure support during and after kinetic operations all helped the operation succeed, and Eikenberry considered it a model for future counterinsurgency operations.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_3-5.png\",\n        \"caption\": \"Soldiers from Company B, 1st Battalion, 32d Infantry Regiment, 10th Mountain Division\"\n      }\n    },\n    {\n      \"title\": \"Reassessing the Situation\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"TF SPARTAN’s deployment occurred during a tumultuous period as the Taliban committed everything to opposing the shift to NATO ISAF lead. In RC East, American forces pushed into new regions to expand Kabul’s reach. During their deployment, soldiers from the 10th Mountain Division increased the number of outposts in RC East from twenty to forty, conducted hundreds of patrols, and attended seemingly endless shuras as they worked to implement a comprehensive counterinsurgency approach. At the same time, RC South erupted in a level of violence not seen since 2001. British soldiers in Helmand Province and Canadian soldiers in neighboring Kandahar Province faced a far greater test than anyone anticipated. Over many months of hard fighting, they strove to adapt to the enemy while reassessing their resources for the campaign.\",\n        \"In Washington, U.S. policymakers tried to downplay the return of the Taliban. Even with the increase in enemy attacks, Secretary of Defense Donald H. Rumsfeld maintained that “weak provincial governments and corruption” and not security were the chief problems in Afghanistan. In the summer of 2006, he sent Marin J. Strmecki, a former assistant to Ambassador Zalmay M. Khalilzad, to analyze the situation in order to develop policy recommendations. Strmecki’s diagnosis supported Rumsfeld’s views, identifying a “crisis in governance” in Afghanistan. “Enormous popular discontent is building against corrupt and ineffective governance,” Strmecki concluded, “undermining Karzai’s political standing, weakening the legitimacy of the new political order, and creating a vacuum of power in the south and other areas that the Taliban can control.” The insurgency had boomed when the Taliban decided to exploit this “vacuum of governance.” Strmecki recommended escalating initiatives in the security, governance, and economic sectors. Beyond poor governance, he highlighted Pakistan’s role in providing a safe haven for the insurgents. He stated that the elements within Pakistan’s Inter-Service Intelligence organization who had provided “some operational support” to enemy activities and President Pervez Musharraf had “not made the strategic choice to cooperate fully with the U.S. and Afghanistan to suppress the Taliban.” Strmecki recommended a diplomatic initiative to induce “Pakistan’s leaders to deprive the Taliban of sanctuary and support.” Crucially, this “asymmetrical counter-escalation” of diplomatic efforts and reconstruction efforts did not require more U.S. or international military forces. Rumsfeld was so impressed with Strmecki’s analysis that he asked Vice President Cheney and National Security Advisor Steven J. Hadley to try to arrange a briefing for him with the president.\",\n        \"Rumsfeld and Strmecki were not wrong about Musharraf, governmental weakness, or endemic corruption; nonetheless, their analysis was self-serving in that it did not lead to changes in the conflict’s ends or means. The related ENDURING FREEDOMand NATO ISAF campaigns had weathered a tumultuous year in 2006. Poor governance might have been the central reason why the country had returned to a degraded existence, but other factors contributed as well. Some of these were preventable. The late and insufficient arrival of partner nations in RC South, their misunderstanding of the conflict to which they had deployed, and their lack of flexibility on the ground were solvable problems. The enemy’s growing assertiveness owed as much to the coalition and the ANA’s inability to provide consistent levels of security as to domestic issues or the innate popularity of violent Islamic fundamentalism. Faced with multiple challenges, Eikenberry, Richards, and Freakley designed campaigns that addressed the threats they faced. Unfortunately for them and their successors, the execution of these campaigns could never account fully for Afghanistan’s social and political complexities.\"\n      ]\n    }\n  ],\n  \"chapter 4\": [\n    {\n      \"title\": \"A Campaign in Transition\"\n    },\n    {\n      \"section\": [\n        \"The war in Afghanistan entered a new phase in 2007 as NATO ISAF struggled to react to the growing insurgency. The United States now split its forces and missions between ISAF under NATO leadership and Operation ENDURING FREEDOM under U.S. command. While NATO ISAF continued to provide security, governance, and reconstruction assistance to the Afghan government, the remaining American forces divided their efforts between counterterrorist operations and building Afghanistan’s own security forces. The separate American efforts featured competing command chains that could be ruinous to both. In particular, the incoming ISAF commander, American General Dan K. McNeill, would need to overcome burdensome national caveats that prevented him from responding adequately to an increasingly active insurgency.\",\n        \"For the U.S. forces in RC East, 2007 brought a much-needed infusion of troops with the arrival of Col. Martin P. Schweitzer’s 4th Brigade, 82d Airborne Division (TF FURY), and the four-month extension of 3d Brigade, 10th Mountain Division (TF SPARTAN). Maj. Gen. David M. Rodriguez, the 82d Airborne commander, and General McNeill’s senior tactical commander in the east, replaced Maj. Gen. Benjamin C. Freakley and his headquarters. Having two brigades allowed General Rodriguez to conduct operations in the northeastern provinces while maintaining pressure on the central provinces and the Pakistan border.\",\n        \"Unfortunately, these efforts spread American forces thin across the regional command. Insurgents responded by massing fighters and identifying potential weaknesses in the American force array. Taliban efforts to exploit the extension of forces led to a massive attack on a new outpost in the town of Wanat in Nuristan’s Waygal Valley in July 2008 and the stalling of U.S. efforts to exert influence in RC East’s northern provinces.\",\n        \"In RC South, coalition forces presided over a measurable decline in the overall security situation. Insurgents continued to pin down the British in Helmand while increasing the pressure on the Canadians in Kandahar. Taliban fighters avoided a direct confrontation after Operation MEDUSA, choosing instead to infiltrate the territory surrounding Kandahar City as a preliminary step to laying siege to the provincial capital. To aid NATO, the United States sent the 24th Marine Expeditionary Unit to RC South in early 2008, signaling a major increase in the American commitment to the region and an expansion in the overall U.S. effort in Afghanistan.\"\n      ]\n    },\n    {\n      \"title\": \"Strategic Drift\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Violence against American forces in Iraq increased drastically at the same time that attacks on coalition units began to permeate Afghanistan. From his headquarters at MacDill Air Force Base in Tampa, Florida, General John P. Abizaid agreed that “the situation in Iraq was deteriorating. And it was more essential to have combat power in Iraq than in Afghanistan.” He acknowledged that “the priority for all military activity was in Iraq. And whatever we need to do to fight the fight in Iraq, that’s what took priority.” Concerned more with Iraq, President George W. Bush increased deployments to that country in what would become known as “the surge.” This prioritization meant that the war in Afghanistan would remain a supporting effort in the Global War on Terrorism as long as Iraq absorbed the majority of available U.S. resources.\",\n        \"Secretary of Defense Robert M. Gates faced that reality when he replaced Donald H. Rumsfeld in December 2006. When Gates took  the position, he resolved to “give our commanders in Iraq and Afghanistan everything they needed to be successful,” but he soon learned that he could not “deliver in both places at once.” He agreed to keep two brigades in Afghanistan, but found that “in terms of major units, that was all we could do, frankly, until we began drawing down from the [planned] surge in Iraq.” In the meantime, the mission for U.S. forces in Afghanistan remained the same: to create a stable state that could support America’s war on terrorism and deny al-Qaeda a safe haven for large-scale terrorist operations.\",\n        \"Instead of charting a new path in Afghanistan, the Bush administration began 2007 by pressuring NATO partners to meet their troop commitments, drop national caveats, and combat the growing insurgency. As General Abizaid explained, the United States pushed NATO and the international community to increase their troop levels because “there weren’t enough American forces to be able to do the things that we wanted ultimately to do with combat power.” Despite this push, some NATO allies continued to resist calls for boosting force levels, insisting instead that the alliance focus on reconstruction and economic development. NATO Secretary General Jaap de Hoop Scheffer argued to Gates, Secretary of State Condoleezza Rice, and National Security Advisor Stephen J. Hadley that NATO could contain but not prevail against the Taliban. Moreover, diplomatic overtures to Pakistan failed to eliminate insurgent sanctuaries across the border.\",\n        \"Unity of effort within the international coalition was proving elusive, as was gaining a clear picture of the situation on the ground.  Secretary Gates remained frustrated by conflicting intelligence estimates, with Central Intelligence Agency (CIA) analysts painting a dire picture while General McNeill, Ambassador William B. Wood, and others assuring him that the Taliban posed no strategic threat. The frustration would continue through the first half of 2007, culminating in June when Gates concluded that, strategically, the war was “at best, at a stalemate.” Testifying before the House Armed Services Committee, Chairman of the Joint Chiefs of Staff Admiral Michael G. Mullen summed up the situation: “In Afghanistan, we do what we can. In Iraq, we do what we must.” The United States’ continued relegation of Afghanistan to an economy of force effort fixed the conflict’s strategic and operational direction for the next two years. Although Gates provided what resources could be spared, success rested on the international community and its ability to provide forces to achieve the security, governance, and reconstruction objectives outlined in the Afghanistan Compact.\"\n      ]\n    },\n    {\n      \"title\": \"A New American Team\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"After nearly seven years of war, the U.S. Army in Afghanistan had gone through five theater commanders and an evolving operational framework. Though each of the five commanders implemented his own initiatives, the overall U.S. policy objectives remained the same, as did restrictions on troop levels from Washington. Secretary Rumsfeld had begrudgingly accepted the additional tasks of security assistance and state building in Afghanistan, but staunchly opposed major U.S. troop increases. This restriction changed with Gates. In his first meeting with President Bush, the defense secretary expressed deep “concern about Afghanistan and [his] feeling that it was being neglected.”\",\n        \"Gates’ willingness to accept that Afghanistan needed additional resources was not lost on the CFC-A staff. Col. Bart Howard, Lt. Gen. Karl W. Eikenberry’s chief of staff, noted that his subordinates briefed Secretary Rumsfeld in October 2006 about the deteriorating situation in RC East and the danger of CJTF-76 becoming too dispersed. Unconvinced, Rumsfeld asked CFC-A to make better use of what it had on hand. Gates received a similar briefing during his first visit to Afghanistan in January 2007. General Freakley, in his last full month as CJTF-76 commander, pointed to the fact that neither ISAF nor U.S. forces had a reserve force, which limited their ability to mass for specific operations without putting considerable strain on other units. Throughout 2006, Freakley continuously shifted units within RC East and between the eastern and southern regional commands, interrupting the continuity of effort fundamental to counterinsurgency. Gates recognized his predicament, stating that RC East needed another brigade. As the Iraq surge had left only limited forces available, Gates extended TF SPARTAN’s tour for 120 days until it could be replaced by a yet-to-be-determined brigade. Despite Gates’ inability to immediately secure more forces, those on the ground in Afghanistan found the new secretary’s approach “refreshing.”\",\n        \"The soldiers Gates extended would serve alongside members of the 82d Airborne Division arriving in theater beginning in  mid-January 2007. The division commander, General Rodriguez, assumed command of CJTF-76 from Freakley on 2 February. On Rodriguez’s order, that headquarters renamed itself Combined Joint Task Force 82 (CJTF-82) on 7 March. For maneuver forces, Rodriguez brought Colonel Schweitzer’s TF FURY, which included three maneuver battalions: Lt. Col. Brian J. Mennes’ 1st Battalion, 508th Infantry Regiment (Task Force 1 FURY); the 2d Battalion, 508th Infantry Regiment (Task Force 2 FURY) under Lt. Col. Timothy J. McAteer; and Lt. Col. David J. Woods’ 4th Squadron, 73d Cavalry Regiment (Task Force 3 FURY). Because of the lack of an ISAF reserve, the CJTF-82 commander designated TF 1 FURY as a tactical theater reserve.\",\n        \"The other units that Rodriguez brought from Fort Bragg to Afghanistan included Lt. Col. Scott D. Custer’s 2d Battalion, 321st Field Artillery Regiment (Task Force PROFESSIONALS); Lt. Col. Michael P. Peterman’s 782d Support Battalion (Task Force SPARTANS); and Lt. Col. Steven A. Baker’s Special Troops Battalion, 4th Brigade Combat Team (Task Force DIABLO). The latter pair were responsible for providing TF FURY’s combat support and combat service support while Custer’s unit furnished indirect fires to Schweitzer’s infantry battalions as needed. Finally, Col. Kelly J. Thomas’ Combat Aviation Brigade, 82d Airborne Division (Task Force PEGASUS), provided airlift, aerial fires, and medical evacuation support for the new CJTF headquarters.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_4-1.png\",\n        \"caption\": \"TF Spartan commander Colonel Nicholson\"\n      }\n    },\n    \"In addition to acquiring a new defense secretary and extra ground forces, the United States assumed leadership of NATO ISAF. On 4 February 2007, General McNeill formally replaced Lt. Gen. David J. Richards as ISAF commander. Having served as the Combined Joint Task Force 180 (CJTF-180) commander from May 2002 to May 2003, McNeill was no stranger to Afghanistan. His second deployment, however, would be markedly different than his first tour. Instead of heading an American force of less than 10,000, McNeill now led an international coalition of more than 35,000 service members from thirty-seven countries. The mission also had changed from destroying al-Qaeda and the Taliban remnants in Afghanistan to countering a growing insurgency operating from Pakistani sanctuaries while simultaneously strengthening the nascent Kabul government.\",\n    \"McNeill understood the challenges and constraints he faced. As for the U.S. military, the new ISAF commander believed “the expectation was we were an economy of force and that our real mission was to train Afghan National Security Forces so that someday . . . they took responsibility for themselves.” At the same time, he wanted “to attack the insurgents more” in order to gain “better control of certain amounts of battlespace [so that] . . . reconstruction would really take off.” To some degree, these objectives mirrored NATO’s lines of effort, which remained focused on security, governance, and reconstruction.\",\n    \"Despite the apparent similarity, aligning these efforts proved challenging. As McNeill knew, “In Coalition warfare, members will first and foremost see to their own interests, their own national security needs, before they see to anything in the collective and they will see to things in the collective only when it doesn’t go contrary or detract from their national interest.” This focus on national interest included the United States. “I didn’t delude myself,” he later stated, “I got it. It was all about Iraq. I understood that.” The challenge, therefore, was to achieve unity of effort among coalition forces, most of whom had their own conceptions of what they wanted to achieve as well as national caveats that set out what their soldiers would and would not do.\",\n    \"The change in ISAF leadership also marked an overhaul in the American chain of command. As a NATO commander, McNeill reported to  Joint Forces Command–Brunssum, then to Supreme Headquarters Allied Powers Europe, and finally to the North Atlantic Council. This meant that two American command chains would operate in Afghanistan: the ISAF chain through NATO and the Operation ENDURING FREEDOM chain through CENTCOM. It also meant that even though McNeill would be the highest-ranking American commander in Afghanistan, he did not have command authority over all American troops in theater. That command would now fall to General Rodriguez. With NATO ISAF having assumed responsibility for all regional commands, CENTCOM determined that CFC-A no longer had a purpose, and shuttered the headquarters. This situation led to a unique relationship between McNeill and Rodriguez. As the RC East commander, Rodriguez reported to McNeill in his NATO role but, as commander of the U.S. National Support Element, Rodriguez answered to CENTCOM.\",\n    \"At the time of McNeill’s return to Afghanistan, CENTCOM experienced a leadership change of its own, with Admiral William J. Fallon replacing Abizaid in March 2007. A stickler for formal procedures, Admiral Fallon nixed a workaround that would have enabled McNeill to give orders through the CENTCOM command chain directly to U.S. forces—a move the theater commander believed would have simplified targeting operations. McNeill suffered this predicament throughout his command, as did his staff and subordinates at CJTF-82.\",\n    {\n      \"title\": \"Steady-State Operations\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"At the tactical level, Schweitzer’s staff incorporated both TF SPARTAN’s ongoing efforts and NATO ISAF’s overall initiatives when composing TF FURY’s deployment order. Planners noted the insurgents had targeted western Paktika and southern Ghazni Provinces in an attempt to cut off lines of communications between Kandahar City and Kabul. With greater Kandahar remaining the Taliban’s decisive effort, the southern half of RC East became an avenue of transit for fighters and equipment from Pakistan. Despite significant combat losses in RC South during 2006, “the steady influx of replacement fighters . . . resulted in little degradation in the [Taliban’s] ability to conduct operations.” The Taliban’s growing cross-border influence also strengthened the organization’s position in the Afghan interior. Recognizing their increasing strength, Mullah Mohammed Omar and other senior Taliban leaders pushed their fighters to take “a more proactive stance in the insurgency.” Their foot soldiers responded with a nuanced effort that combined lethal methods (direct attacks on coalition and ANSF, targeted assassination of government officials, and increased usage of IEDs) with nonlethal efforts such as propaganda campaigns and the creation of shadow governments.At the tactical level, Schweitzer’s staff incorporated both TF SPARTAN’s ongoing efforts and NATO ISAF’s overall initiatives when composing TF FURY’s deployment order. Planners noted the insurgents had targeted western Paktika and southern Ghazni Provinces in an attempt to cut off lines of communications between Kandahar City and Kabul. With greater Kandahar remaining the Taliban’s decisive effort, the southern half of RC East became an avenue of transit for fighters and equipment from Pakistan. Despite significant combat losses in RC South during 2006, “the steady influx of replacement fighters . . . resulted in little degradation in the [Taliban’s] ability to conduct operations.” The Taliban’s growing cross-border influence also strengthened the organization’s position in the Afghan interior. Recognizing their increasing strength, Mullah Mohammed Omar and other senior Taliban leaders pushed their fighters to take “a more proactive stance in the insurgency.” Their foot soldiers responded with a nuanced effort that combined lethal methods (direct attacks on coalition and ANSF, targeted assassination of government officials, and increased usage of IEDs) with nonlethal efforts such as propaganda campaigns and the creation of shadow governments.\",\n        \"Complicating the problem facing ISAF was the realization that areas often deemed stable because of a lack of insurgent activity were in fact enemy safe havens. As one officer found out over the course of 2007, “just because we didn’t see [incidents] occurring [in certain areas] that didn’t mean that we didn’t have to look there.” Another officer explained, “If the insurgents were walking on [a] path every day for the last year and there was nobody to fire upon and then all of a sudden you put a force there and they are fired upon, does that mean that area has now become worse?” These observations suggest that the insurgents remained capable of exploiting the Kabul government’s lack of a strong presence, even in relatively quiet areas.\",\n        \"At the operational level, General Rodriguez focused on maintaining the integrity of the coalition while, at the tactical level, he utilized Provincial Reconstruction Teams and maneuver forces to support the provincial governments and build ANSF capabilities. To implement these efforts, CJTF-82 adopted the clear, hold, and build dynamic of their predecessors, with the understanding that “the decisive operation will fall within the build portion.” With the extension of the 3d Brigade, 10th Mountain Division, CJTF-82 scrambled to accommodate two brigades in RC East. The revised plan divided RC East in half, with TF SPARTAN operating in Nuristan, Nangarhar, Kunar, and Laghman Provinces and TF FURY taking Paktiya, Paktika, Khost, Ghazni, and Logar Provinces. Focusing on the build phase, CJTF-82’s plan envisioned three sequential counterinsurgency operations to establish Afghan Development Zones around Ghazni, Sharan, and Gardez. These zones eventually would connect to form one single zone in the center of TF FURY’s southern area.\",\n        \"Depending on circumstances, CJTF-82 considered executing a branch plan that would shift the decisive effort to the north in June by creating a development zone in Nuristan that could be linked to the one around Jalalabad in Nangarhar. If the CJTF-82 leadership chose this option, efforts in the south would become shaping operations focused on creating a development zone in Ghazni and Sharan, but forgoing the one in Gardez. Whichever path CJTF-82 took, its subordinate units would work to enhance security, promote good governance, and support economic reconstruction and development throughout RC East.\",\n        \"Before this plan could be enacted, however, the American infrastructure within the regional command needed to be expanded to accommodate two brigade combat teams. Gates’ late decision to extend TF SPARTAN meant that most of TF FURY’s equipment was already enroute to Afghanistan. As previously planned and coordinated, the paratroopers had been counting on using equipment that TF SPARTAN left behind as it rotated out of theater and did not ship their total inventory. The extension decision meant that TF FURY logisticians had to reroute some of their equipment and secure additional materiel. The process took time, as facilities had to be expanded to accommodate the larger American military footprint. In the end, it took several months for logistical systems to adapt to the increased requirements. By the time TF SPARTAN rotated out in May 2007, RC East had forty-three forward operating bases and combat outposts, roughly twice the number that had existed at the beginning of 2006.\",\n        \"Even with two brigades, Rodriguez lacked sufficient forces to cover RC East in its entirety. One key location that he did not want to leave unattended was eastern Paktika. Keeping TF CATAMOUNT there required him to make creative adjustments to his subordinate units’ missions. As a result, Colonel Baker’s Special Troops Battalion became a battlespace owner with a maneuver mission. The unit sent its signal and military intelligence companies to Forward Operating Base SALERNO to support the brigade headquarters and, in turn, received maneuver and artillery support from other TF FURY units. Even with the new forces and mission, Colonel Baker understood that his unit “was the economy of force within the greater economy of force, in comparison of Afghanistan to Iraq.” Likewise, TF PROFESSIONALS continued the practice of splitting its resources between fire support and maneuver tasks. Colonel Custer divided responsibilities between his two key subordinates, directing his executive officer to serve as deputy commander for fires and his operations officer to be the deputy commander for maneuver.\",\n        \"The Army’s attempts to solve resource shortfalls by assembling bits and pieces of disparate organizations to perform nonstandard  missions extended well beyond Schweitzer’s brigade. Another hastily formed ad hoc unit became CJTF-82’s third major battlespace owner: Task Force CINCINNATUS. Shortly after CJTF-82 arrived, the Minnesota Army National Guard’s 219th Support Group, which had provided support and base management for TF Spartan, rotated out of Afghanistan. The active component 43d Support Group normally would have replaced them in support of the 82d Airborne Division. However, the critical needs of the Army diverted that unit to Iraq. In response, U.S. Army Forces Command (FORSCOM) pieced together TF CINCINNATUS, a unit built around officers and noncommissioned officers drawn from Lt. Col. James Bonner’s 23d Chemical Battalion at Fort Lewis, Washington. Its initial responsibilities were to oversee base operations for CJTF-82 installations at Bagram, Kandahar, SALERNO, Jalalabad Airfield, and Camp Eggers in Kabul. To command the new task force, FORSCOM assigned Col. Jonathan G. Ives from the Army Reserve.\",\n        \"When TF CINCINNATUS mobilized on 19 January 2007, it received a complex, nonstandard mission. Fifteen days before his task force took over the area support mission, Ives learned that he would become the battlespace owner for five provinces north and west of Kabul, though he would turn over Wardak Province to TF DIABLO and then TF 2 FURY as security in the province deteriorated. Ives also gained responsibility for New Zealand’s Provincial Reconstruction Team in Bamyan, a Turkish one in Wardak, and American teams in Panjshir and Bagram. To create maneuver forces for his area of operations, Ives pulled the security elements out of the Bagram reconstruction team along with military police from the division special troops battalion and whatever other qualified augmentees he could find. With its forces set across RC East, CJTF-82 was prepared to commence operations.\",\n        \"${Operation OQAB HAMKARI (February - June 2007)}{bold}\",\n        \"Operation OQAB HAMKARI (EAGLE TEAMWORK), McNeill’s first brigade-level operation as ISAF commander, had been designed by his predecessor in an effort to forge Afghan Development Zones. As the CJTF-82 deputy commander for operations termed it, the operation was “a little bit of an ‘ink blot’ approach” to counterinsurgency, and it became the underlying theme for CJTF-82’s efforts in their southern zone of RC East over the first half of 2007. Responsibility for making and maintaining connections with the populace was divided between unit commanders and members of the Provincial Reconstruction Teams, while brigade and battalion commanders developed connections with the provincial governors and the democratically elected provincial councils. Bottom-up and top-down approaches would create a latticework where government officials established connections with their superiors and subordinates and reached out to other leaders for advice and support.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-4-2.svg\",\n        \"caption\": \"TF CINCINNATUS\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_4-2.png\",\n        \"caption\": \"MAJ Rosemary Reed helps SFC Paula Reill\"\n      }\n    },\n    \"Operation OQAB HAMKARI had been developed before TF Spartan had its tour extended. It primarily involved TF FURY, and was one  of three operations ordered in RC East’s Operation Plan 07–02. The other two operations in the plan were OQAB ETEHAB (EAGLE UNITY) and EAGLE STRENGTH. The overall scope of the plan centered on RC East’s southern provinces, with OQAB HAMKARI focused on establishing an Afghan Development Zone in Ghazni. The operation, which was designed to exploit the gains achieved during Operation MOUNTAIN EAGLE, had three interlocking phases: build, clear, and hold. In the first phase, TF FURY would build relationships with local leaders, identifying target areas for economic development and partnering efforts with ANSF. The orders established the conditions for a functioning Afghan Development Zone as: “security threats reduced to minor criminal elements, rule of law maintained by [Afghan government] officials and enforced by ANP, [Afghan government] officials [able to] provide for population needs, local market activity expanded in terms of quality and diversity, and lines of communication expanded to connect outlying communities.” In the second phase, clearing missions would allow the ANSF to maintain security, defeat insurgent groups, and deny sanctuary. American forces were to partner with Afghan forces to improve the latter’s ability to operate alongside coalition forces and eventually as independent units. Once coalition and Afghan forces had cleared an area, then efforts would shift to the holding phase, as police established themselves and linked local communities judicially to the central government.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-4-4.svg\",\n        \"caption\": \"Operation Plan 07-02\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"The most significant display of ANSF capacity-building occurred during Operation MAIWAND, a supporting effort of OQAB HAMKARI. The former, which sought to clear the restive Andar District of Ghazni Province, marked the first time in which Afghans took the lead in both operational planning and execution. It grew out of a meeting in May between Schweitzer and Maj. Gen. Abdul Khaliq, commander of the 203d Afghan Corps. While discussing the anticipated events that would take place over the next three months, the pair agreed that Andar had become increasingly problematic. Khaliq assured Schweitzer that his men could clear the district in a month if the ANA received logistical support during the operation. Schweitzer concurred, but wanted Khaliq’s men to plan and conduct the operation with coalition forces operating in support. Both men agreed and set their staffs to work.\",\n    \"Named after the Afghan victory over the British in 1880, MAIWAND was a substantial step forward in ANA development. To aid Khaliq’s efforts, Schweitzer placed his tactical operations center with the headquarters of the Afghan 2d Brigade, which became the 203d Afghan Corps main effort. He also ordered troops from McAteer’s TF 2 FURY, Woods’ TF 3 FURY, U.S. support elements, and the Polish Brigade Group to assume blocking positions, clear roads, and provide logistical support. Finally, TF FURY helped the 203d Corps establish a fires and effects coordination cell that mirrored the American model but reflected Afghan cultural and religious sensitivities.\",\n    \"Operation MAIWAND began on 1 June 2007, following a shura attended by President Hamid Karzai. Though there were sporadic firefights, the Afghans met limited resistance. In most cases, the insurgents fled long before the ANA arrived. Whenever Afghan soldiers appeared, the local population welcomed them and provided intelligence on insurgents and weapons caches. While MAIWAND garnered little attention from the media or from the CJTF-82 staff, the thirty-day operation succeeded in building “the reputation among the people for the police and the army.” The Afghan people’s acceptance of national police and army forces was not the ultimate goal of the development zone concept; nonetheless, it was progress along the government’s long path to political legitimacy. The mission also reverberated within ISAF after a German officer attended a briefing on the operation. Though initially critical of the American approach, he soon came to believe that the partnering and support displayed between U.S. and Afghan forces during MAIWAND was exactly the type of effort that needed to be replicated amongst ISAF forces. He encouraged British and Canadian commanders in RC South to study the operation closely.\",\n    \"TF FURY commanders considered the operation successful as their staffs were able to build effective working relationships with their Afghan counterparts. As the Afghan officers began to write their own orders and give briefings in Dari, both they and their American counterparts developed more confidence in the ANA’s ability to operate as an independent force. According to one American officer, “getting a cohesive U.S. staff married up with an Afghan brigade staff began to show some incredible benefit.” The example set during MAIWAND would be emulated in several operations conducted by the 203d Corps and TF FURY over the remainder of the latter’s deployment in Afghanistan. The Afghan Development Zone concept may not have been universally successful, but in fostering the relationships between U.S. and ANA units, it had shown clear progress.\",\n    \"${Task Force BAYONET in Nuristan, Nangarhar, Kunar, and Laghman Provinces}{bold}\",\n    \"TF SPARTAN’s extended tour began winding down several weeks before MAIWAND commenced, as the brigade started a relief-in-place with Col. Charles A. Preysler’s 173d Airborne Brigade Combat Team (TF BAYONET). TF BAYONET’s five battalion-sized elements assumed control of TF SPARTAN’s operational area of Nuristan, Nangarhar, Kunar, and Laghman Provinces in the northern portion of RC East. At this point, relief-in-place operations started to become much more structured and formal in order to give the incoming unit full critical knowledge of all facets of the area of operations. Three or more days were set for “right-seat ride” opportunities, during which the incoming leadership followed their outgoing counterparts throughout daily operations, followed by “left-seat ride” sessions, in which the incoming leaders led the daily operations and the outgoing leaders rode along to coach them. At the end of the cycle, a brief would be given to the higher headquarters. If requirements were satisfied, a transfer of authority to the incoming unit was approved. On the whole, the 173d deployed some 3,500 soldiers to provide support to four Provincial Reconstruction Teams while also providing security for an area the size of West Virginia with a population of just over 2.3 million.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-4-5.svg\",\n        \"caption\": \"Nangarhar, Nuristan, Kunar, and Laghman Provinces\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"Initially, Colonel Preysler’s brigade had been slated to deploy to Iraq, but TF BAYONET’S readiness for deployment and its soldiers’ familiarity with Afghanistan made it a natural selection to fulfill Secretary Gates’ commitment to deploy two brigades to RC East. The decision was controversial because the change meant that the brigade could not undergo the normal deployment preparation or gather detailed intelligence of the intended area of operations. As the brigade commander noted, “there’s [sic] two different wars here.” Training for the primarily urban environment of Iraq was not applicable in the remote mountains of Afghanistan, which required more “light infantry classic warfare.” The truncated timetable for preparation also meant that Preysler and his staff were conducting a predeployment site survey in Afghanistan while the rest of the brigade began its mission-rehearsal exercise. During his visit to their proposed area of operations, Preysler discovered that although one battalion from TF SPARTAN had spent the last year in the region, the remainder of the brigade had been in the area for only a few months. This short tenancy limited the situational awareness available to Preysler’s incoming units. Upon their return, Preysler and his staff completed the training exercise, enjoyed a brief holiday, and rolled out for Afghanistan eight days later. Upon reflection, he thought it was a “pretty tough way to come into combat.”\",\n    \"The deployment promised to be a lively one for Colonel Preysler’s paratroopers, as Nuristan and Kunar Provinces were traditional safe havens for regional militant groups. Taliban leaders sought to safeguard the lines of communications running from the tribal areas and Pakistan’s northwestern provinces through the region’s steep river valleys to the provinces surrounding Kabul. To block routes into Nangarhar and Kabul, Preysler spread his three maneuver battalions along a line straddling the southern border of Nuristan and bisecting the brigade’s area of operations. In the northeast, Lt. Col. Christopher D. Kolenda’s 1st Squadron, 91st Cavalry Regiment (Task Force SABER), established a position at Forward Operating Base BOSTICK. Lt. Col. William B. Ostlund’s 2d Battalion, 503d Infantry Regiment (Task Force ROCK), established itself at Camp Blessing in the Pech River Valley in Kunar Province. Farther to the west, Lt. Col. Stephen J. Maranian’s 4th Battalion, 319th Field Artillery Regiment (Task Force KING), converted part of itself to light infantry and settled into Forward Operating Base KALAGUSH.\",\n    \"The brigade headquarters, Lt. Col. James R. Ryan’s 173d Support Battalion, and Lt. Col. Jeffrey O. Milhorn’s Special Troops Battalion, 173d Airborne Brigade Combat Team (Task Force RAPTOR), located themselves at Forward Operating Base FENTY near Jalalabad. Originally configured as a support unit, Milhorn’s TF RAPTOR received a cavalry troop from 1st Squadron, 91st Cavalry Regiment; two field artillery batteries operating in a dismounted infantry role; and a company of Fort Lewis–based military police to enable it to operate in a maneuver role mirroring that of TF DIABLO. The brigade received air support from the 101st Airborne Division’s 2d Squadron, 17th Cavalry Regiment (Task Force OUT FRONT) led by Lt. Col. John M. Lynch, also at FENTY. The Arizona Army National Guard’s 1st Battalion, 158th Infantry Regiment (Task Force DIAMONDBACK), under the command of Lt. Col. Alberto C. Gonzalez, arrived with the rest of TF BAYONET and took up position at Forward Operating Base MEHTAR LAM in Laghman Province until the Pennsylvania Army National Guard’s 3d Battalion, 103d Armored Regiment (Task Force PACESETTER), commanded by Lt. Col. Stephen M. Radulski, arrived in March 2008 for service in the same operational area.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_4-3.png\",\n        \"caption\": \"173d Airborne Brigade Soldiers\"\n      }\n    },\n    \"Preysler designed his campaign to build upon the 10th Mountain Division’s efforts to develop the two most populated areas in the  region: Nangarhar and the Pech River Valley. Nangarhar Province would be the focus of the brigade’s main developmental effort, with an Afghan Development Zone centered on the city of Jalalabad and stretching out into most of the province. Termed “Nangarhar Inc.” by the Americans, the zone was designed to bring $3.2 billion in economic development and employment opportunities to the province.\",\n    \"Preysler distributed his forces across the operational area to build support among the local population, deny insurgents safe havens and infiltration routes, and project TF BAYONET units north of Jalalabad, all in accordance with current counterinsurgency doctrine. Movement north of Jalalabad had begun in 2006 under TF SPARTAN, but could be executed only incrementally; the farther American troops penetrated into remote valleys, the fewer soldiers could participate in missions and the more contact they made with enemy fighters. The rough terrain isolated American and ANSF positions in Kunar and Nuristan and made them vulnerable to attack. Moreover, the incursions presented a broad spectrum of opponents, including local extremists, criminal terrorists, and Taliban insurgents, all of whom refused to accept encroachment by the Karzai government. Isolation made remote American and ANSF detachments prime targets for militants and extremists, based just across the border in Pakistan, who had sophisticated tactical training, leadership, and modern equipment.\",\n    \"The Taliban’s most experienced commander in Nuristan and Kunar, Sheikh Dost Mohammed, had been the top military leader and shadow governor in Nuristan Province for several years, and his influence helped make the resistance to coalition forces formidable. Sheikh Dost Mohammed’s insurgent network maintained deep ties to regional Salafist movements and al-Qaeda, and promoted local Taliban and Haqqani Network operations. Proximity to the border brought the region under firm Taliban influence and made it susceptible to militant strikes from Pakistan. These militants engaged in a constant probing war with the Americans, waiting for the proper time and place to mount a sustained attack to drive the intruders out of the region.\",\n    {\n      \"title\": \"Improving Afghan Security Capabilities\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"As the Americans deployed more troops to restive RC East, CSTC-A planners began developing a complementary program for comprehensive, security-sector reform. The new initiative, known as Focused District Development, was designed to improve police standards and capabilities at the district level. Once a district was designated for police reform, it would go through six phases of reform in forty-three weeks. The first phase, lasting eight weeks, was an evaluation by a district assessment and reform team, composed of a police mentor team, representatives from several Afghan governmental ministries, and other international partners. After the assessment, the second phase began as an Afghan National Civil Order Police unit deployed to the district to relieve the local Afghan Uniformed Police. The uniformed police then reported to a regional training center to begin eight weeks of reconstitution (the third phase). In addition to intense training and administrative processing, the police received daily instruction from their mentor teams, which would return for a week with the reformed police unit to its home district (fourth phase). Once there, they began the fifth phase, consisting of twelve weeks of collective training in the district. Finally, after validating the trained police force, the mentor team shifted into an oversight role (during the sixth and final phase, lasting twelve weeks) to ensure the police retained the ethics and skills they had learned. The first cycle of Focused District Development commenced in seven districts in November 2007. McNeill had chosen these districts, which were scattered across the country, “for military imperatives rather than their potential for durable institutional reform.” Because of this criterion, McNeill’s efforts to improve individual districts were unable to build momentum nationwide. Even so, the ISAF commander believed Focused District Development would “bear some fruit,” although it would “take several years” to do so. He was correct in his prediction. Shortages in available police mentor teams, trained civil order police, and training center billets slowed the pace of training. By December 2008, roughly fifty districts had undergone part or all of the program, though only the first seven had reached full capability.\",\n        \"Although Focused District Development was a step in the right direction, several problems prevented it from building on its initial successes. In particular, the program suffered from a lack of necessary resources. The security transition command estimated that it needed a total of 399 police mentor teams, with the first 250 teams being fielded by the end of 2009 and the remainder by the end of 2010, to apply the program to the entire uniformed police force. Even if the additional personnel were made available by the stated milestones, too much time had passed for the program to meet the deadline established in the Afghanistan Compact for a fully trained and functioning police force by the end of 2010. In addition, the Focused District Development effort placed so much unanticipated stress on the Afghan Civil Order Police that attrition rates skyrocketed and significantly threatened its capabilities.\"\n      ]\n    },\n    {\n      \"title\": \"Growing and Mentoring the Afghan National Army\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"If Americans were exasperated by the problems they faced in building the ANP, they could at least take satisfaction in the ANA, which was developing more or less according to plan. The program called for creating an ANA that could act as the bridge between ISAF and the Afghan po lice. Coalition forces were responsible for engaging with and destroying enemy forces and reducing opposition enclaves to a point at which they could hand over responsibility to the ANA, whose mission was to prevent the enemy from reestablishing a foothold in that area. Once the central government had secured a solid police and governance presence in that region, the ANA would then turn its security responsibilities over to the Afghan police.\",\n        \"However, the ANA’s potential had not been acknowledged at the onset, when the DoD viewed it as a counterbalance to warlord militias rather than a full-fledged counterinsurgency partner. As a result, the nascent Afghan military did not receive sufficient security assistance funding from the start. Although additional dollars were allocated from 2003 onward, the Bush administration remained reluctant to send more trainers, invest in building ministerial capacity, or create a logistics infrastructure. U.S. efforts continued to gain momentum, but the main problem from 2005 to 2008 was not the ANA’s structure, deployment, or ethnic balance but rather its effectiveness against the resurgent Taliban. Battlefield proficiency took time to develop. Even so, compared to the problems affecting the ANP, the ANA remained a bright spot in the effort to build Afghan National Security Forces.\",\n        \"The most positive ANA development from September 2005 to November 2008 resulted from the decision to implement Accelerating Success. That program succeeded in increasing kandak production to the point at which the Ministry of Defense could start building regional corps. In addition to the Kabul Corps, renamed the 201st Sailab (Flood) Corps, the Ministry of Defense had established the 203d Tandar (Thunder) Corps in Paktiya Province, the 205th Atal (Hero) Corps in Kandahar Province, the 207th Zafar (Victory) Corps in Herat Province, and the 209th Shaheen (Falcon) Corps in Balkh Province. These commands continued to grow as the allowable size of the ANA increased from 70,000 to 80,000 in February 2008. The authorized ceiling rose again in September to 122,000.\",\n        \"Each of the ANA’s corps resided in one of the coalition’s regional commands, presenting opportunities for partnered operations. Partnering increased in frequency under Eikenberry and expanded to include coalition forces after McNeill took over ISAF. Including kandaks on operations did not differ tactically from working with warlord militias or early incarnations of Afghan security forces; nonetheless, it had strategic benefit in that it helped legitimize the Afghan national government. Coalition units partnered with Afghan forces “in almost all operations,” letting them take “the lead in about half of them by 2009.”\",\n        \"Embedded Training Teams operating under Task Force PHOENIX became the primary mechanism for overseeing Afghan units in the field. These nineteen-man teams started working with kandaks before graduation and shared their expertise in both garrison and combat duties. Like many jobs in Afghanistan, training-team duty was difficult. Embedded teams served far from U.S. leadership, logistical support, the reach of protective fires, and medical evacuation coverage. They ate, slept, and fought side by side with their Afghan partners, often with limited interactions with or support from coalition maneuver forces. This isolation was not lost on the Taliban, who found the teams to be tempting targets. The training teams were also dangerous to the insurgents, as they had ready access to the freshest and most actionable human intelligence available to non-Afghan forces. Utilizing the information they collected proved challenging, however, as there was no advisory intelligence chain that could receive reports from the field and conduct timely analysis.\",\n        \"Filling these billets proved similarly frustrating. Even after reducing Embedded Training Teams to sixteen soldiers, TF PHOENIX  never received the personnel it needed to meet requirements. The soldiers it did get often were not of the appropriate rank or specialty for the job, or lacked the training or experience to serve as effective mentors. The personnel shortage was serious enough that a 2005 Army study recommended filling officer positions with senior noncommissioned officers, despite Afghan reluctance to interact with coalition advisers of lesser rank. NATO’s assumption of the ISAF mission did not resolve the problem. Although the alliance had a formation to replace training teams—Operational Mentor and Liaison Teams—it experienced the same team staffing and support challenges that U.S. forces did. Larger than the Embedded Training Teams (twenty-five versus sixteen personnel), mentor teams began replacing their American counterparts in May 2006 when a British team started advising the 3d Brigade, 205th Corps, in Helmand Province. Progress was slow: by August 2008, NATO had contributed personnel for only thirty-four of the seventy-one teams deemed necessary to meet ANA training goals.\",\n        \"TF PHOENIX experienced similar difficulties providing sufficient training teams for the 203d Corps in RC East. Because kandaks needed advisers until they were “fully capable of planning, executing and sustaining operations,” they had to be supported by successive training or mentor team rotations. As a result, the ANA required a steadily increasing number of advisers. The 119 teams (71 NATO and 48 U.S.) authorized in summer 2008 were estimated to grow to “125 teams in December 2009, 133 teams in December 2010, 141 teams in December 2011, 159 teams in December 2012, and 168 teams in December 2014.” Given the scarcity of necessary team personnel in 2008, filling the projected 40 percent increase in teams over the next six years would be impossible without a proportional expansion of the international training mission.\",\n        \"As U.S. conventional forces struggled to find the personnel to partner with Afghan security forces, SOF found similar opportunities dwindling. With the disarmament, demobilization, and reintegration process winding down in 2005, SOF units had fewer non-Kabul-sanctioned defense forces with which to conduct counterinsurgency operations. Eikenberry accelerated the SOF transition away from partnering operations by directing CJSOTF−Afghanistan commander Col. Edward M. Reeder Jr. to disband the remaining Afghan militia forces partnered with SOF and position his detachments so as to prevent the Taliban from disrupting the upcoming elections. SOF responded by increasing counterterrorism missions in support of Eikenberry and his priorities but did so with decreasing efficiency as SOF operations depended on intelligence gained from their ANSF partners and the access they provided to local communities.\",\n        \"After analyzing the most effective use of the limited U.S. SOF available in Afghanistan, Special Operations Command Central directed Colonel Reeder to form an Afghan special operations capability. Reeder proposed the creation of Ranger-like, light infantry kandaks. Both 3d Special Forces Group and Special Operations Command Central supported the initiative, which helped develop new Afghan Commando kandaks over the next eight months. American SOF formed these units by selecting 100 soldiers from existing ANA kandaks and sending them to Jordan to receive specialized training. After returning to Afghanistan in March 2007, these soldiers formed the cadre for the first two Commando kandaks. By 16 October 2008, each of the five ANA corps had one Commando kandak consisting of 865 officers and enlisted personnel supporting its operations. Two of these units functioned at partial operational capability, two at initial operational capability, and one had just been formed. Even with the varying capabilities between Commando kandaks, the high standards, constant training, and continued support from Reeder’s command enabled the Afghan Special Forces to become one of the most effective organizations within the Afghan military.\",\n        \"With the addition of the Commando kandaks, the ANA increased to roughly 70,000 trained soldiers by the end of 2008. Of the forty-two infantry kandaks rated in October 2008, seven were deemed capable of planning, executing, and sustaining operations without the support of mentor or training teams. Thirteen more were assessed to be partially operational, meaning that they could plan and support operations but still required guidance from embedded mentors. Overall, roughly 40 percent of the ANA was judged partially or fully capable of conducting operations above the company level independently or with some support. However, a corresponding 60 percent of the ANA still lacked that capability. Considering that the United States had contributed over $10 billion to train and equip the ANA between 2002 and 2008, tremendous work would be needed before the ANA could make good on that investment.\"\n      ]\n    },\n    {\n      \"title\": \"Expanding Development\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"While ISAF increased efforts to build capable Afghan security forces, it also worked to expedite the Afghan governance capacity. The latter effort continued to be challenging. Even though Provincial Reconstruction Teams continued to invest significant effort into new construction and development projects, they found it difficult to make a fundamental and lasting impact on the Afghan standard of living. Reports from reconstruction teams indicated that agricultural knowledge, which had been passed down orally in a culture with a 10 to 15 percent literacy rate, had vanished as tens of thousands of farmers perished or sought other employment as a result of more than twenty years of conflict. Consequently, U.S. civilian and military leaders developed a concept to deploy soldiers with agricultural expertise and embedded security capabilities to Afghanistan as part of the Agribusiness Development Teams. By improving the agricultural system of a nation in which 80 percent of the population was involved in farming or herding, the program would offer young men a reason not to join the insurgency and also contribute significantly to their communities’ standards of living. Although the new program marked a change in how the coalition interacted with rural Afghans, it built on a concept that the United States had used with success for more than two decades in Central America. All told, the National Guard Bureau sent six teams in support of Combined Joint Task Force 101 (CJTF-101) (which would replace CJTF-82) during the first year of the program.\",\n        \"The first project for the agribusiness teams was to train Afghan government officials how to perform the duties of provincial and district agricultural advisers. Team members then made their presence known to local communities by teaching farmers techniques to provide better care for the fruit trees that the Americans found in almost every Afghan compound they visited. The teams distributed basic tools such as tree saws, grafting knives, and metal buckets filled with two pounds of hydrated lime—all suitably marked “Courtesy of the Afghan government”—to improve the growing conditions for the fruit. Agribusiness Development Teams built upon their initial offering to rural Afghans with lessons on how to care for fruit trees, fertilize soil, and take care of farm animals. Unlike many reconstruction team projects, the agribusiness teams produced sustainable local effects that resulted in long-term gains for Afghans, the ultimate goal for the international development effort.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_4-4.png\",\n        \"caption\": \"Soldiers move through poppy fields\"\n      }\n    },\n    {\n      \"title\": \"An Interagency Approach\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The growing importance of reconstruction within the overall counterinsurgency approach mandated the need for greater interagency coordination at all levels. Provincial Reconstruction Teams continued to serve as the interagency coordinators for individual provinces while the civil affairs cell within brigade combat teams did the same for all of the provinces within its area of operations. An integrated civil-military action group, consisting of senior State Department, U.S. Agency for International Development, and military officers with roles in development, was established within the U.S. embassy in 2008 and met regularly to provide senior decision makers with information and recommendations. The State Department’s Office of the Coordinator of Reconstruction and Stabilization ensured the synergy of the overall effort through planning officers assigned to the embassy, brigades, and reconstruction teams.\",\n        \"The project initiated by the 173d Airborne Brigade staff in Nangarhar Province in 2008 illustrates the benefits of an interagency approach. Nangarhar Inc. brought together U.S. players involved in counterinsurgency, counternarcotics, and long-term development in the province. The brigade staff members thought that providing the local population with economic opportunities would complement ongoing counterinsurgency efforts, as most Taliban members in the province appeared to be motivated less by politics or ideology and more by the need to support themselves and their families. The brigade sought to create a sustainable model rather than rely on short-term projects, but it ran into problems because it received little or no assistance from civilian agencies. In an effort to restart the project, the brigade commander sent eight leaders, including his operations officer, fire support officer, CJTF-82 liaison officer, and representatives from the Nangarhar Provincial Reconstruction Team, to the U.S. Embassy to work with State Department and U.S. development assistance officials on a coordinated economic development plan for the province.\",\n        \"The final version of the plan included a range of projects classified as quick-impact, near-term, and long-range. Quick-impact projects offered Afghan farmers a way out of the opium poppy trade, encouraging them to increase their economic gains by growing alternative crops. Near-term and long-range goals were designed to enable quick-impact projects to realize a profit. Near-term goals involved purchasing portable cold storage units that vendors could use to refrigerate produce before selling it in Pakistan. The high fuel costs of these cold storage units, however, prevented them from being a viable long-term solution. To address this predicament, the 173d Airborne Brigade staff initiated a long-term project to build a series of dams in adjacent Kunar Province that would provide Nangarhar merchants with electricity and improve the storage and transportation options for the local economy. The scope and cost of the long-term project required interagency involvement at all levels because the project fell within the purview of multiple U.S. agencies as well as several Afghan government ministries. The Nangarhar Inc. model demonstrated that multiple agencies could work together to contribute to the overall counterinsurgency effort. It proved so promising that reconstruction teams in Kunar, Laghman, and eastern Nuristan Provinces adopted a similar approach.\",\n        \"Yet even with the success of Nangarhar Inc., the varying capabilities and resources of the different reconstruction teams  made it difficult to replicate this model across all of Afghanistan. ISAF had yet to standardize the Provincial Reconstruction Teams, which complicated attempts to link efforts across provincial lines. The Supreme Allied Commander Europe’s operations plan acknowledged that “a ‘one size fits all’ PRT [Provincial Reconstruction Team] makeup could not be applied to various Afghan provinces,” but it still “connected the ‘desired strategic impact’ to convergence between PRT activities and synchronized movement toward common objectives.” Whether a diverse reconstruction team system truly could achieve stability—while also reflecting a unified effort—remained to be seen. Without that unified effort, the various training, reconstruction, and development teams would become an impediment to the very thing they were trying to achieve: a capable, sustainable Afghan state.\"\n      ]\n    }\n  ],\n  \"chapter 5\": [\n    {\n      \"title\": \"Campaign at the Crossroads\"\n    },\n    {\n      \"section\": [\n        \"With NATO forces fully engaged across Afghanistan and General Dan K. McNeill aligning, however informally, the American and ISAF efforts, the coalition was approaching the point of maximum effort under economy-of-force resourcing. Secretary of Defense Robert M. Gates’ approval of an additional American brigade had increased the Army’s footprint, but rather than significantly expanding the American campaign, the arriving troops mainly shored up ISAF’s ability to continue to execute its current operations. Even as the situation in Iraq improved as a result of the surge, coalition forces in Afghanistan were working to simply maintain a status quo against an insurgency that showed little signs of abating.\"\n      ]\n    },\n    {\n      \"title\": \"Continuing Issues with Pakistan\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Although more American troops were deploying to RC East, their presence exerted limited influence in Pakistan’s adjacent tribal areas. Before the September 2006 peace agreement in North Waziristan, the tribal areas became a collective sanctuary where al-Qaeda terrorists intermingled with the Haqqani family network, Taliban sympathizers, and radicalized tribes such as the Mehsud, and were able to operate with relative impunity. Using funds from various sources, including wealthy private donors from the Arab states in the Persian Gulf region, the militants succeeded in acquiring better weaponry than Pakistan’s Frontier Corps, who nominally were in charge of controlling the border provinces. As one Western official noted, militants “have rockets. They have advanced weapons. And the Frontier Corps has sandals and a bolt-action rifle.” While Washington pressured Islamabad to take more aggressive action in dealing with the militant problem, President George W. Bush acknowledged that controlling the remote mountainous region was difficult, describing it as “wilder than the Wild West.” Even though the Bush administration was under no illusions about the region’s instability, it had given Pakistan $1 billion a year for the past five years and now wanted a return on that investment.\",\n        \"General McNeill, the ISAF commander, remained frustrated with the situation across the border. He had clear evidence of a spike in insurgent attacks in RC East after the Waziristan peace agreement, an increase he logically attributed to the fact that “the Pakistanis quit putting pressure on them.” McNeill recalled the radical jihadist leader Baitullah Mehsud telling a gathering of reporters, “Jihad knows no boundaries. There is no reason why we can’t go to Afghanistan.” Because of the NATO mandate, however, McNeill had limited options in addressing issues with Pakistan. He had no authority to conduct operations across the border and could only affect the situation by improving relations among ISAF forces, Afghans, and Pakistanis. One method of achieving the desired level of unity was the Tripartite Commission, a set of recurring meetings between McNeill, Afghan chief of defense General Bismillah Khan Mohammadi, and Pakistan Army chief of staff General Ahsan Hyat (later replaced by General Ashfaq Kayani). Yet getting the sides to cooperate proved difficult. “There is deep and abiding suspicion between the Pakistanis and the Afghans,” McNeill noted, “and it is not going away anytime soon.”\",\n        \"In an effort to expand the program, Brig. Gen. Joseph L. Votel, the CJTF-82 deputy commander for operations, began coordinating meetings among Afghan, Pakistani, and coalition general officers and senior colonels in early 2007. Votel held these meetings to resolve issues and improve coordination in targeting insurgents traveling across the border. The ultimate goal was to formalize the program with a series of border coordination centers that could bring “Afghans, Paks [Pakistanis], and ISAF, [and] the US, under one roof where they could coordinate activities on a portion of the border.” The program went slowly as long-standing disputes over the location of the border and Pakistan’s previous support of the Taliban created considerable distrust. An incident during a 14 May meeting in Pakistan, in which U.S. Maj. Larry J. Bauguess Jr. was murdered by a Pakistani soldier, amplified American concerns over Islamabad’s ability to deal with the internal threat posed by radical Islamists.\",\n        \"President Pervez Musharraf’s government was slowly recognizing the danger these groups posed. The situation finally exploded in early July when a brigade of Pakistani soldiers surrounded the Lal Masjid (Red Mosque) complex in Islamabad. Activists from the mosque had been increasingly aggressive in enforcing their moral views on the community; in one notable instance, they had kidnapped six Chinese women from a local acupuncture clinic on the charge that it was a brothel. Government forces eventually stepped in and laid siege to the mosque for a week (3–11 July). After a three-day battle that resulted in the deaths of more than one hundred militants, including numerous students, and at least ten Pakistani soldiers, the Pakistani military finally seized the compound.\",\n        \"The assault on the Red Mosque reignited the conflict between Islamic militants and the Musharraf government that had been simmering since the North Waziristan peace treaty. Musharraf declared a renewed commitment to securing the Afghanistan-Pakistan border, and stated, “Extremism and terrorism will be defeated in every corner of the country.” Fazal Hayat, more commonly known by his pseudonym Mullah Fazlullah, one of several radical Islamists energized by the mosque raid, initiated his own revolt against the government that July in the Khiali Valley of the Northwest Frontier Province.\",\n        \"By the fall of 2007, the Pakistan government was in crisis. As militants targeted the Pakistani military and intelligence community, Musharraf began to see his political support crumble. Former political leaders such as Benazir Bhutto and Nawaz Sharif openly challenged his government. Meanwhile, Pakistan’s Supreme Court appeared on the verge of declaring the president’s reelection in October invalid. In the face of internal and external threats to his power, Musharraf declared a state of emergency on 3 November, suspending the country’s constitution, blacking out independent media, and postponing the upcoming parliamentary elections. Amid domestic and international opposition, Musharraf agreed that he would step down as head of the Pakistani Army the day before he took the oath of office for a new five-year term and would hold parliamentary elections in early 2008. Although he remained in office, Musharraf relinquished his influence over the Pakistani military. Pakistan’s political structure was imploding just as the jihadist militancy was threatening to overwhelm the state.\",\n        \"By December 2007, Baitullah Mehsud had increased his political power so much that he could form the Tehrik-i-Taliban Pakistan, as an umbrella group harnessing various Islamist factions fighting against the Islamabad government. Although not formally affiliated with Mullah Mohammed Omar’s Taliban, many Pakistani Taliban commanders and foot soldiers had fought in Afghanistan. Baitullah Mehsud’s forces also benefitted from associations with al-Qaeda, the Haqqani Network, Lashkar-e-Taiba, and other extremists. This convergence of talent and tactics spawned an increase in suicide attacks against the Pakistani state from 56 in 2007 to more than 100 in 2008, resulting in a staggering 461 deaths. When Benazir Bhutto was assassinated at a political rally in Rawalpindi on 27 December 2007, the Pakistani government and CIA blamed militants with ties to Baitullah’s organization and al-Qaeda. Bhutto’s death was a tragic end to a long year in which radical Islamic fundamentalists in Pakistan offered a more direct and severe challenge to Islamabad than to the fledgling Karzai administration. This new focus made it increasingly unlikely that whoever was in power in Islamabad would be able to offer meaningful assistance to the United States, ISAF, or the Afghan government.\",\n        \"${A Shift in the ISAF Effort}{bold}\",\n        \"As Pakistan grew increasingly unstable, TF FURY made progress in the southern zone of RC East. It expanded the coalition footprint, blocked traditional insurgent infiltration routes, and supported the continuing development of ANSF. In Khost Province, Taliban presence declined until it was more nuisance than threat. The TF PROFESSIONALS commander, Lt. Col. Scott D. Custer, thought simple criminal activity was the most prevalent problem. Colonel Custer developed a good working relationship with the provincial governor, Arsallah Jamal, whom he considered an effective leader, and encouraged his unit commanders to establish productive relationships with district leaders.\",\n        \"Other provinces proved less welcoming than Khost. In eastern Paktika and western Ghazni, which Operation MAIWAND had  cleared of insurgents, neither the Afghan government nor TF FURY could prevent the return of terrorist groups. Less than a month after MAIWAND, the Taliban captured and held hostage twenty-three South Korean missionaries who were traveling south of the city of Ghazni. The Taliban accused them of proselytizing, while their church leaders claimed they only were doing relief work. Much to the dismay of the Americans, the Korean government negotiated directly with the Taliban, “acknowledging or promoting the legitimacy of the enemy,” as one American officer put it. Following six weeks of negotiations, during which the captors killed two of the hostages and released two others, the Taliban released the remainder after securing a promise from Seoul to withdraw its 200 troops by the end of the year. Subsequently, U.S. special operators systematically dismantled the kidnappers’ network within six weeks, but the message had been clear: just as they had in Iraq, terrorists could force coalition members to pull out of contested areas.\",\n        \"By summer 2007, the continuing security threat convinced McNeill that ISAF needed to be more aggressive in targeting insurgents. Two months into his tour, he could not get a definitive agreement from coalition members or the Afghan government as to the purpose of Afghan Development Zones. Without a consensus, he abandoned the concept. McNeill believed the zones were too ill-defined to support economic development, especially because security remained so poor. He told one Afghan government official, “We’re not where we need to be in security for these things to have a fair chance to succeed. It’s that simple.”\",\n        \"For McNeill, the problem with the American approach was not a lack of effort, but faulty design. He thought that the continuing instability in RC East warranted shifting the main ISAF effort from the south. Of particular concern was Haqqani infiltration into the Tora Bora cave system in southern Nangarhar, from which the network could interdict the main road between Kabul and Jalalabad. To address this challenge, McNeill transferred his Theater Tactical Force, Lt. Col. Brian J. Mennes’ 1st Battalion, 508th Infantry Regiment, from RC South to RC East in August. The paratroopers in the Theater Tactical Force conducted a relief-in-place with Lt. Col. Jeffrey O. Milhorn’s TF RAPTOR before taking responsibility for Nangarhar Province. They would stand ready as the ISAF reserve, keeping one company and the battalion command element prepared to move within twenty-four hours, with the remainder following within forty-eight to seventy-two hours. The Theater Tactical Force remained in RC East until November, when it returned to RC South to help prepare for winter operations.\",\n        \"${Operation PAMIR HAMKARI (October 2007–March 2008)}{bold}\",\n        \"McNeill’s shift away from the Afghan Development Zone concept required an overhaul of CJTF-82’s campaign plan. Intelligence analysis indicated that insurgent groups were adjusting to the presence of two combat brigades within RC East. Although they were capable of massing when necessary or when the opportunity arose, they were more interested in mounting attacks that generated instability rather than defeating ISAF and Afghan forces. To accomplish this, the various groups increased cooperation, coordinating a two-pronged approach to keep ISAF off balance. They continued attacking Afghan Border Police units, forcing other ISAF forces to respond when necessary. At the same time, insurgents sought to establish positions in provinces surrounding Kabul from which they could mount intimidation campaigns against the residents and direct terror attacks against the Afghan government.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_5-1.png\",\n        \"caption\": \"SGT Jonathan Guidry of the 173d Airborne Brigade\"\n      }\n    },\n    \"To combat these efforts, CJTF-82 developed an operations order to serve as the division’s campaign plan from October 2007 to March 2008. The revised plan shifted CJTF-82’s focus away from the population by aggressively targeting insurgents. Termed Operation PAMIR HAMKARI (MOUNTAIN TEAMWORK), it specified that “the decisive operation will remain with TF FURY and its partnered ANA, ANP, and Afghan Border Police forces. TF BAYONET and TF CINCINNATUS with their Afghan security counterparts will conduct shaping operations to help set conditions for the main effort.” Forces within RC East would maintain pressure along the Pakistan border while continuing to develop ANSF. PAMIR HAMKARI sought to maintain pressure on the insurgents during the fall and winter in order to disrupt their ability to resume operations in 2008. To ensure favorable conditions for the spring 2008 campaign, Maj. Gen. David M. Rodriguez and his planners “concentrate[d] CJTF-82’s finite resources into prioritized districts to reinforce success from Operation OQAB HAMKARI and adjust[ed] to changes in the operational environment.” They continued to frame the division’s approach in the standard three lines of operation (security, governance, and development) but changed the targeted districts to commercial centers and those with critical lines of communications. Notably, Rodriguez’s guidance stated that efforts to reinforce economic successes were “not limited to ADZs [Afghan Development Zones].” This process included identifying essential Afghan leaders who understood the needs of the populace and supported the goals outlined in the Afghan National Development Strategy.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-5-2.svg\",\n        \"caption\": \"Operation PAMIR HAMKARI\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"In the first phase, the 4th Brigade, 82d Airborne Division, continued its border security and interdiction efforts  in the Burmal and Ster Giyan areas of Paktika Province as supporting efforts while focusing on the Sperah District of Khost Province for the campaign’s main effort. Other maneuver forces would secure six vital districts: Dzadran, Shwak, and Zurmat in Paktiya Province; and Kharwar, Charkh, and Baraki Barak in Logar Province. These districts supported key commercial centers in Gardez and Khost. Disruption operations in several other districts were launched either to maintain ANSF and coalition presence or set conditions for phase two of the operation, scheduled to begin in mid-December.\",\n    \"In the second phase, TF FURY would spread to the districts of Deh Yak and Ghazni in Ghazni Province, Jaghatu in Wardak Province, and Sharan in Paktika Province, while securing critical lines of communications and interdicting border crossings. In this manner, TF FURY sought to take advantage of the anticipated winter lull in insurgent activity to expand security operations and make areas hostile to insurgents when they returned in the spring.\",\n    \"Despite the shift away from development zones and toward key districts and lines of communications, the campaign changed little at the tactical level. Instead, the main changes were geographic and therefore operational. The districts with lower priority were along Afghanistan National Highway 1, while higher-priority districts were generally closer to Kabul. Whether centered on Afghan Development Zones or Kabul, the operational approach for RC East still had to be executed by troops on the ground. Maneuver forces had to separate the enemy from the local population, connect that population to the central government, and transform areas from insurgent safe havens to loyal jurisdictions of the central government. It also did not alter efforts to develop ANSF capacity. Their ability to secure operational areas and connect with the population would be one criterion of future success. But there were limits to what U.S. forces could achieve. Without indigenous security forces providing for the needs of the people, it would be difficult for the national government to attain public support. Absent that support and trust, the Karzai government would continue to compete with the insurgency for legitimate political authority.\",\n    \"${The Challenge for Task Force ROCK}{bold}\",\n    \"For all of CJTF-82’s focus on Gardez and on Khost Province, the soldiers of TF BAYONET in the northern sector of RC East endured some of the heaviest fighting in late 2007 and early 2008. Operation PAMIR HAMKARI called for TF BAYONET and its partnered Afghan forces to “maintain their forward presence,” secure Bihsud and Jalalabad Districts in Nangarhar Province and the city of Asadabad in Kunar Province, continue to interdict cross-border infiltration, and maintain critical lines of communications. Although comprehensive, the effort equated only to a shaping operation for the decisive effort in TF FURY’s sector to the south. As a supporting effort, TF BAYONET did not receive as many enablers (such as aviation support; funding for projects; and intelligence, surveillance, and reconnaissance assets) as available elsewhere.\",\n    \"Nangarhar remained the focus of the TF BAYONET’s economic development, but the Pech River Valley was the greatest challenge to implementing counterinsurgency tactics and gaining the support of the population. As Col. Charles A. Preysler’s battalions distributed companies and platoons, troop levels at key points in the area of operations decreased commensurately, with some outposts held by as few as fifteen to twenty American soldiers, supported by assorted Afghan security personnel. As their units sought to secure areas where U.S. troops had earlier established a presence under far different conditions, some TF BAYONET leaders became concerned that their predecessors had “gone too far, too fast” in establishing bases in the remote valleys in Nuristan. Few units suffered the dangers of dispersion more than Lt. Col. William B. Ostlund’s TF ROCK in the Pech River.\",\n    \"TF ROCK had inherited efforts to build the Pech River Valley politically and economically. To protect these efforts,  Ostlund directed his maneuver companies to maintain combat outposts and patrol in three surrounding valleys. Their goal was to extend security and development into the valleys and tie them to the main effort along the river. The TF ROCK commander recalled:\",\n    {\n      \"list\": [\n        \"Each platoon went out on two patrols a day, every day, and the intent of nearly every patrol was a non-lethal engagement, checking on a project, meeting with the business people of a village, meeting with the farmers of a village, meeting with the teachers of a village, or meeting with political leaders. It was just shura after shura after shura after shura and with that constant interaction you kind of get it [i.e., understand the population and the environment].\"\n      ]\n    },\n    \"This constant presence gave Ostlund frequent opportunities to assess intelligence coming out of the communities and  reposition forces accordingly. In some instances, this meant pulling back where units were not having the desired influence, or when positions became too difficult to maintain. Such conditions affected two combat outposts in the Waygal Valley: BELLA and RANCH HOUSE. Both were held by less than a platoon and could be supported only by helicopters. Their small size and isolated positions were considered acceptable risks when they were established in 2006. However, while each new outpost increased the ability of Americans to reach Afghan civilians and link them to the government, it also provided another target for the enemy to attack.\",\n    \"The first significant indication of this vulnerability came on 22 August 2007 when a sizable insurgent force led by Hazrat Omar, a reputed al-Qaeda devotee and resident of the nearby village of Arahnas, assaulted Combat Outpost RANCH HOUSE. Having studied the outpost for weeks, Omar had devised a detailed plan that allowed his force to overrun the position before its defenders could mount an effective defense. After penetrating the outer perimeter, the estimated sixty attackers engaged the defenders with hand grenades, not being repulsed until the TF ROCK soldiers called in close air support on their own position. Two Afghan soldiers were killed in the assault, and nearly half of the twenty-two American personnel at the outpost were wounded. Hazrat Omar failed to gain the dramatic victory he so eagerly sought—the assault cost him his life without killing a single American.\",\n    \"The attack forced the Army to reevaluate both outposts’ locations. Delays in constructing a trafficable road up the valley meant that the local population remained largely isolated from the central government. The valley’s residents, who generally did not want a closer relationship with Kabul, grew sympathetic to insurgent groups when the soldiers could not demonstrate the advantages of national governance. The outposts remained accessible only by air, which made them ideal targets for insurgents seeking to control the valley. With the change in circumstances, TF ROCK closed RANCH HOUSE in October and prepared to transfer BELLA to a more suitable position.\",\n    \"Major changes were not limited to ISAF forces. Senior insurgent leaders remained determined to push the Americans out of the valley. With Hazrat Omar dead, they dispatched Mullah Maulawi Mohammed Osman to take up the fight against TF ROCK. Intelligence soon indicated that the insurgents were prioritizing support for Hazrat Omar’s replacement, as Osman busily assembled hundreds of fighters from villages throughout the area in preparation for an attack on BELLA.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_5-2.png\",\n        \"caption\": \"SFC Kahler and PFC Ayers and PFC Hamby\"\n      }\n    },\n    \"Unsurprisingly, insurgent attacks increased in the Pech River Valley and the ancillary Watapur and Korangal Valleys as well as the Waygal Valley. The Korangal was of particular concern. Historically, the Korangalis had been antagonistic to outsiders, and they refused to side with the Americans despite the economic and developmental incentives the coalition forces offered. The Pashtun residents resisted American penetration in early 2007 even more strenuously than they had in Nuristan. As the situation in the Korangal failed to improve over the summer, Ostlund authorized company-sized air assaults along a series of ridgelines meant to funnel the enemy into kill zones. These October operations, known as ROCK AVALANCHE, drove enemy fighters toward the southern end of the valley, pushing them away from the area and making it easier to link the valley politically and economically to the rest of the region. The fight proved difficult, as every family compound the Americans faced was a hardened fort difficult to overcome without artillery or air power—a perfect recipe for civilian casualties that caused yet further hostility. Despite significant enemy losses, the local tribal leaders declined to participate in the American plan to secure the valley. In several cases, they sided with the insurgents in opposition to both the Karzai government and its international backers.\",\n    \"Even considering the antagonistic response of some of the Korangalis, Ostlund viewed ROCK AVALANCHE as a success. He noted a sharp decline in American casualties in the valley, dropping from seven killed and twenty-seven wounded in the five months preceding the operation to zero killed and thirteen wounded in the eight months following it. Continual patrolling and aggressive tactics had overcome the lack of resources to make the valley more hospitable to coalition efforts.\",\n    \"Ostlund was overly simplistic in attributing the decline in casualties solely to aggressive operations. Two other factors  contributed to the shift in the operational environment: the decline coincided with the onset of winter, traditionally the offseason for insurgents, and improved tactics reduced the troops’ exposure to dangers. Whatever the case, the reduced number of American casualties in the isolated valleys of Kunar and Nuristan did not signify that the local population had decided to support the Kabul government. Terrorist leaders still found fertile ground for inspiring homegrown insurgents to fight against the U.S.-Afghan coalition in the northern zone of RC East.\",\n    \"The struggle for the valley was indicative of the larger challenge facing American and Afghan units. Their outposts, purposely positioned in steep valleys, often were surrounded by high ground that made them vulnerable to plunging sniper fire, rocket-propelled grenade volleys, mortar attacks, and outright assault. American and Afghan units existed at the front lines of the war, an environment where success usually was measured in enemy body counts. However, these lethal metrics were the opposite of those articulated as critical in counterinsurgency doctrine, which focused on public diplomacy and strengthening relationships. To influence local populations, units had to push into remote valleys. To create security areas in which Provincial Reconstruction Teams and other agencies could engage in development efforts, commanders had to disperse their forces. At the same time, the division and subdivision of units across multiple outposts increased each position’s vulnerability to attack. Balancing the risk of attack against the need to create time and space for the Afghan government was a dangerous undertaking that could have deadly repercussions should the scales shift too far in the insurgents’ favor.\",\n    \"Indeed, ROCK AVALANCHE provided only a temporary respite. On 9 November, a complex ambush near Arahnas resulted in the deaths of six U.S. and three Afghan soldiers. The timing and location of the attack suggested collusion with local tribal leaders. The attack also confirmed that more insurgents had moved into the region, with an estimated one hundred disciplined fighters having taken part in the ambush. In response, battalion and brigade leaders planned to withdraw to a more defensible position closer to the 2d Battalion’s headquarters at Camp Blessing. Negotiations began that fall to establish a new outpost at the village of Wanat, roughly seven kilometers north of Blessing, although it would take nearly ten months before the move could be arranged.\",\n    {\n      \"title\": \"2008 Force Rotations\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"In the spring of 2008, American forces in Afghanistan experienced yet another major force rotation. At the end of their  fifteen-month deployment, the soldiers of TF FURY prepared for their relief by the 4th Brigade Combat Team, 101st Airborne Division (Task Force CURRAHEE) in March. The incoming brigade, commanded by Col. John P. “Pete” Johnson, consisted of its six organic units: Lt. Col. Anthony G. DeMartino’s 1st Battalion, 506th Infantry Regiment (Task Force RED CURRAHEE); Lt. Col. John C. Allred’s 2d Battalion, 506th Infantry Regiment (Task Force WHITE CURRAHEE); 1st Squadron, 61st Cavalry Regiment (Task Force PANTHER) led by Lt. Col. Thomas W. O’Steen; Lt. Col. David J. Ell’s 4th Battalion, 320th Field Artillery Regiment (Task Force GLORY); Lt. Col. Anthony K. “Kirk” Whitson’s 801st Support Battalion (Task Force MOUNTAINEER); and Lt. Col. Charles D. Bradley’s Special Troops Battalion (Task Force STRENGTH). Johnson received welcome augmentation provided by TF PHOENIX in the form of the Illinois Army National Guard’s 1st Battalion, 178th Infantry Regiment, led by Lt. Col. Daniel J. Fuhr.\",\n        \"The incoming brigade took over TF FURY’s operational area, with Allred’s TF WHITE CURRAHEE replacing Colonel Mennes’ TF 1 FURY. The division also sent Col. Jeffrey P. Kelly’s headquarters from the 101st Sustainment Brigade (Task Force LIFELINER), Col. James M. Richardson’s Combat Aviation Brigade, 101st Airborne Division (Task Force DESTINY), and Lt. Col. David L. Dellinger’s Special Troops Battalion, 101st Airborne Division (Task Force GLADIATOR). The division commander, Maj. Gen. Jeffrey J. Schloesser, assumed command of the newly named CJTF-101 in early April.\",\n        \"Following the arrival of TF CURRAHEE, CJTF-101 managed the arrival of additional U.S. forces into Afghanistan. In early March, the 2,500-strong 24th Marine Expeditionary Unit, under Col. Peter Petronzio, deployed to RC South to serve under ISAF command in support of the British in Helmand. In RC East, Col. Scott A. Spellmon’s 1st Maneuver Enhancement Brigade, a newly formed unit activated at Fort Polk on 16 September 2007, took over from TF CINCINNATUS in June. Spellmon’s brigade only brought two of its four assigned battalions to Afghanistan, with the other pair deploying to Iraq at the same time.\",\n        \"The 3d Brigade Combat Team, 1st Infantry Division (Task Force DUKE), led by Col. John M. Spiszer, would follow in June to replace TF BAYONET in northern RC East. Spiszer’s 3,000-plus task force included Lt. Col. Daniel S. Hurlbut’s 2d Battalion, 2d Infantry Regiment (Task Force RAMROD); Lt. Col. Brett C. Jenkinson’s 1st Battalion, 26th Infantry Regiment (Task Force BLUE SPADER); Lt. Col. James C. Markert’s 6th Squadron, 4th Cavalry Regiment (Task Force RAIDER); 1st Battalion, 6th Field Artillery Regiment (Task Force CENTAUR) led by Lt. Col. Salvatore J. Petrovia; Lt. Col. Patrick Daniel’s Special Troops Battalion, 3d Brigade Combat Team (Task Force VALIANT); and Lt. Col. Bradley A. White’s 201st Support Battalion (Task Force SUPPORT). TF DUKE also received Lt. Col. Stephen M. Radulski’s 3d Battalion, 103d Armored Regiment, which deployed as a maneuver force in Laghman Province.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_5-3.png\",\n        \"caption\": \"General Schloesser and Admiral Mullen\"\n      }\n    },\n    \"As with previous rotations, American forces existed within a bifurcated chain of command. CJTF-101 was under the operational  control of ISAF in RC East. At the same time, it had Title 10 responsibilities for American forces in theater as the National Support Element under CENTCOM. As one of two U.S. major generals in Afghanistan, General Schloesser (and his staff) had a challenging relationship with the other two-star U.S. command, Maj. Gen. Robert W. Cone’s CSTC-A. Both reported directly to CENTCOM along the U.S. command chain, but only CJTF-101 fell under ISAF control as a regional battlespace owner. Coordinating the disparate missions of both commands was, as one staff officer phrased it, “spotty.” The missions that these units engaged in, however, remained relatively straightforward. As the RC East headquarters for ISAF, CJTF-101 and its subordinate units conducted full spectrum operations in support of the three standard lines of operation: security, governance, and development. The security transition command, meanwhile, provided training and security force assistance for the Afghan military and police. Complicating this command and control arrangement was the counterterrorist mission pursued by American SOF, which remained largely independent of both ISAF and CSTC-A. In addition to supporting counterterrorism, SOF conducted foreign internal defense in support of the ANSF.\",\n    \"${A New Operational Focus}{bold}\",\n    \"As the CJTF commander, Schloesser revised the ENDURING FREEDOM operational focus while retaining its clear, hold, and build framework. For the security line of operation, he emphasized developing ANSF over securing territory or maintaining freedom of movement for coalition forces. Although earlier deployments had sought to support ANSF development through partnered operations and coordinating with the Pakistani military, General Schloesser made the ANSF the centerpiece of CJTF-101’s rotation. Tactically, he expanded the definition of combat operations to include those operations “in conjunction with ANSF and [the Pakistani military]” launched to disrupt enemy support areas, interdict insurgent lines of communications along the border, and retain freedom of movement along major lines of communications within Afghanistan.\",\n    \"The new campaign followed this changed emphasis. CJTF-101 developed a three-stage campaign built around four lines of effort:  security; governance; development; and information operations, a new but long overdue line. Schloesser added the last line because he felt that insurgent propaganda had been echoed for far too long in Western and regional media without challenge. The first stage, designed to exploit successes achieved by CJTF-82, began with the transfer of authority and was to run through the fall of 2008. Decisive operations during this phase included partnering throughout the regional command. All other efforts were defined as shaping operations.\",\n    \"The campaign’s second stage, beginning in the fall of 2008 and running through early 2009, was to develop “provincial and district-level governance and development to assist in achieving [Afghan National Development Strategy] milestones.” The goal was to take advantage of security gains over the summer and early fall 2008 as well as the anticipated winter lull in the fighting season to improve governance in targeted districts. If these efforts went well, the campaign would transition to the third phase, which consisted of setting conditions “for capable provincial and district governance and successful transition of security for select districts to ANSF” in the spring of 2009 while also preparing RC East for another rotation of U.S. forces.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_5-4a.png\",\n        \"caption\": \"CWO Sammy Rodriguez, 2d Battalion, 503d Infantry Regiment\"\n      }\n    },\n    \"This new RC East operational approach, which made ANSF development a primary goal, was the culmination of the efforts that the U.S. and ISAF forces had made over the previous three years. However, it highlighted limitations in CJTF-82’s and CJTF-101’s capabilities. Even with considerable expenditures of American resources, neither task force had sufficient strength to provide localized security throughout the regional command. When asked if CJTF-101’s task organization was adequate to meet its needs, one staff officer replied, “In terms of executing the full spectrum operations mission, it was barely sufficient in some places and completely insufficient in others. The fact that a company out of the division special troops battalion was being employed as foot soldiers in lieu of trained infantry was an indicator of that.”\",\n    \"As in previous deployments, American and Afghan units could clear insurgents from a district, but they did not have enough forces to hold these areas long enough to implement meaningful economic and government-building gains. Even though the insurgents had suffered significant losses during these clearing operations, the insurgency as a whole showed no signs of abating so long as it maintained sanctuaries and a base of operations within Pakistan. Another significant (and almost insurmountable) challenge to ISAF counterinsurgency efforts was the fact that many Afghans viewed the Karzai regime as self-serving and corrupt rather than interested in their well-being. For all its proficiency in combat operations and experience with battling a diverse collection of enemies, the U.S. military was reaching the limits of its operational capability in RC East.\",\n    \"${The Limits of Counterinsurgency}{bold}\",\n    \"U.S. and Afghan forces in RC East’s northern sector, particularly in the valleys that branched off from the Pech River Valley, faced an increasingly strained situation. The paratroopers of TF ROCK had an especially trying experience. Operating out of combat outposts, firebases, and observation posts, the troops endured spartan living conditions, an often indifferent or uncooperative populace, and the country’s most mountainous terrain. As their tour wound to a close in the summer of 2008, TF ROCK soldiers prepared to turn over the battlespace to the incoming TF DUKE. Colonel Ostlund remained particularly concerned about Combat Outpost BELLA in the Waygal Valley. Since the closure of RANCH HOUSE the previous October, Ostlund’s staff had sought to relocate the exposed outpost closer to the battalion’s headquarters at Camp Blessing. Schloesser also wanted to place units where they could most influence the population. After months of negotiating for land, the Americans finally procured a local agreement to construct a vehicle patrol base in the village of Wanat. Located seven kilometers from Camp Blessing, it was home to the district governor and police chief and was accessible by road, rather than air only. From there, the battalion could hold the entrance to the Pech River Valley from the Waygal Valley.\",\n    \"CJTF-101 approved TF ROCK’s realignment in the Waygal Valley in late June 2008. Although TF ROCK was in the final weeks of its deployment, Schloesser and his headquarters determined that the unit with the most Afghan experience should execute the operation, as opposed to assigning it to the newly arriving TF DUKE. TF ROCK soldiers had fought forty-eight engagements with insurgents during their fourteen-month deployment. As one analysis put it, “The soldiers of TF ROCK knew how the insurgents fought, they understood their tactics and how they preferred to employ their weapons, and they respected the [anti-Afghan forces] as tough, determined, committed, and skilled fighters.” The soldiers also understood the urgency of the movement, having suffered an attack on Combat Outpost BELLA on 4 July and read reports that the insurgents were massing in anticipation of a more determined assault.\",\n    \"The move from Combat Outpost BELLA to Wanat began on 8 July. Supplies were airlifted out of BELLA, and members of Company C, 2d Battalion, 503d Infantry Regiment, conducted a ground assault convoy from Camp Blessing to Wanat. This position would become Vehicle Patrol Base KAHLER, named after one of the unit’s platoon sergeants who had been killed earlier in the deployment. Over the next several days, the paratroopers worked to construct the outpost, but were hampered by delays in getting heavy equipment to the position. They established the outpost’s basic perimeter, set up defensive positions, and constructed an observation post above the main base for additional protection. Given their experience over the previous year, the soldiers did not expect the insurgents to immediately launch a large attack. What the Americans did not realize, however, was that the move to Wanat forestalled a massive coordinated assault against BELLA organized by Mullah Maulawi Mohammed Osman. Rather than abandon his plan to overrun an ISAF base, the insurgent leader simply redirected his fighters toward Wanat. Within four days, he had assembled between 120 and 300 fighters ready to attack the platoon constructing the outpost.\",\n    \"Insurgent forces launched a blistering attack on Wanat on the night of 13 July. The initial volley of rocket-propelled grenades targeted the base’s heavy weapon systems, disabling a tube-launched, optically tracked wire-guided missile launcher and the outpost’s 120-mm. mortar pit. The attackers also targeted the vulnerable observation post, which was occupied by a squad whose machine guns would be disabled over the course of the battle. The topography enabled the insurgents to approach within hand-grenade distance of the observation post before the attack, and they were able to breach its perimeter briefly during the assault. The fierce battle lasted for hours before the insurgents broke off in the face of repeated attacks by close air support and AH–64 Apaches. In total, nine Americans were killed, most either defending the observation post or trying to reinforce it, and another twenty-seven were wounded. Four of the twenty-four ANA soldiers positioned to the south were also wounded.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-5-6.svg\",\n        \"caption\": \"Battle of Wanat\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"\",\n    \"\",\n    \"The 13 July attack at Wanat reflected the limitations of American operations in RC East. Investigations indicated that members of the local population, including the district governor and police chief, were complicit in the attack. Ostlund later contended that the Waygal Valley had been a significant challenge to his forces throughout their deployment, and stated that “no matter what we did we were just not effective.” Counterinsurgency operations failed when faced with an insurgent force with a strong support base across the border, an intransigent population that was hostile to any incursion into the valley by either the Americans or Afghan security forces, and terrain that made any forward position susceptible to harassing fire and coordinated attack. Schloesser determined that maintaining forces within the Waygal Valley did not justify the risks of doing so. TF DUKE soon abandoned the outpost and launched patrols into the valley from the more defensible Camp Blessing.\",\n    {\n      \"title\": \"The Ongoing Fight in RC South\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"McNeill had originally shifted the ISAF main effort to RC East in 2007 because he wanted to free the southern portion of shadow governments and open lines of communications into the region. This move, however, did not mean that the Taliban’s main effort had transitioned to the region. After being battered by coalition forces in 2006, the Taliban adjusted its operational approach in RC South. It avoided massing in areas that could be cleared by large-scale coalition operations such as mEdusa. Instead, it worked to build its presence in northern Helmand while preparing for a more concerted effort against Kandahar City. Thus, insurgent activity in RC East remained a shaping operation designed to keep the American forces occupied and separate the region from RC South, where the Taliban sought to reestablish control.\",\n        \"The acceleration of insurgent and terrorist activity in RC South since the beginning of the Taliban’s 2006 efforts placed increasing pressure on local governments and security forces, many of which consisted primarily of local warlord forces. ISAF efforts to root out insurgent groups exposed the extent of extremist penetration. Coalition forces would need to do more than merely identify and engage with the enemy, they had to follow tactical successes with aid, jobs, governance, and rule-of-law reforms. Even if U.S. and ISAF operations managed to unveil and dislodge those in the employ of the Taliban, it still would be difficult to maintain the gains without the successful integration of Afghan governance. As a result, the intensified fighting in 2007 did not fatally wound the Taliban, and it remained a viable alternative to the Karzai administration’s incomplete, underresourced, and often unpopular district governments. The 2008 campaign would be the toughest and bloodiest since the conflict began, as coalition fatalities rose from 130 in 2006 to 263 in 2008. Nearly 60 percent of these casualties were caused by IEDs, showing the insurgents’ increased aggressiveness and sophistication in using this tactic.\",\n        \"Growing violence drove ISAF to focus nearly exclusively on security, even though the Taliban sought goals that were more political than military. In general, the Taliban’s military operations—or the mere threat of violence— wanted to expand the group’s political and economic influence, not necessarily to defeat ISAF and government forces in open battle. It was a war of wills in which ISAF, foreign leaders, nongovernmental aid organizations, and the Afghan people all were being led to the conclusion that only a settlement with the Taliban would provide peace and stability. Several polls of ordinary Afghans suggested that the Taliban and other Islamist fighters were achieving these objectives, even if the insurgency did not control entire districts or provinces.\",\n        \"The one area where the Taliban took aggressive moves to seize territory was in northern Helmand. After negotiating a cease-fire with the British in Musa Qal’ah, the Taliban began rebuilding its operational base there. In early 2007, fully reconstituted, the insurgents seized control of Musa Qal’ah. The British responded by announcing that 12 Mechanized Brigade would deploy to Helmand in April. In addition to the 6,300 troops in the brigade, the British committed an additional 1,400 soldiers to the campaign, bringing their force level in Helmand to 7,700, doubling their initial deployment in 2006. With the support of Canadian and American forces (especially TF 1 FURY operating as the ISAF Theater Tactical Force), the British launched Operation ACHILLES in April to clear the Taliban from northern Helmand. Although they recaptured Musa Qal’ah in December 2007, the British still did not have sufficient forces to prevent the eventual return of the Taliban. Focusing on northern Helmand also meant that the southern half of the province lay largely unprotected, enabling the Taliban to establish a presence there.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_5-4b.png\",\n        \"caption\": \"British Royal Air Force\"\n      }\n    },\n    \"British struggles in Helmand convinced the Bush administration that it needed to aid its closest NATO ally. In January 2008, it announced that the U.S. Marine Corps would send Lt. Col. Richard D. Hall’s 2d Battalion, 7th Marines (Reinforced), and Colonel Petronzio’s 24th Marine Expeditionary Unit (Special Operations Capable) to Helmand in the spring. The arrival of the marines considerably increased the coalition’s combat power in Helmand. The 24th consisted of a 1,200-strong reinforced infantry battalion (1st Battalion, 6th Marines), an artillery battery, six AV–8B Harrier fighter aircraft, eight AH–1W attack helicopters, and air and ground support assets. The 2d Battalion, 7th Marines, would serve as police trainers and mentors while the 24th Marine Expeditionary Unit provided security. Soon after establishing a position in southern Helmand, the marines launched an aggressive campaign to secure the Garm Ser District.\",\n    \"The Taliban continued operations in Helmand even with additional coalition forces arrayed against them. Significant numbers of enemy fighters were sent to the province for a counteroffensive called Operation EBRAT (Lesson) designed to secure lines of communications, exert influence over the drug trade, and promote the Taliban’s political authority in the verdant riverine communities. On 11 October 2008, a Taliban force estimated at 150 to 200 fighters attacked the provincial capital of Lashkar Gah. Although more than sixty insurgents were killed in the four-hour fight, the assault proved the enemy remained capable of threatening a provincial capital. Other operations consolidated the Taliban’s grip along a belt of territory stretching from Nawah-ye Barkaza’i District to Nad ‘Ali District and along the Helmand River to Girishk and Sangin. More importantly, the Taliban’s brazenness demonstrated that the coalition and government could not keep the insurgent group from controlling huge swaths of the province.\",\n    \"Although the fighting in Helmand was intense, it was not the main effort for the Taliban in RC South. Their primary focus was to isolate and then seize Kandahar City. Coalition troops’ clearing operations interrupted the Taliban’s efforts to establish shadow governments in the Zharey and Panjwa’i Districts. Although ISAF initiated these operations for good reasons, and the operations had good effects, by dedicating combat forces in these districts, ISAF was unable to maintain an effective troop presence in the province’s northern regions.\",\n    \"Beginning in late 2007, the Taliban sought to use the heavily vegetated Arghandab District as a base for operations throughout adjacent areas. From there, Taliban fighters infiltrated the suburbs of Kandahar City. Canadian forces, still representing the main ISAF contingent in the province, were unable to prevent this infiltration. By the end of 2008, insurgents virtually surrounded the city, controlling the northern, southern, and western districts from which they could project influence, political coercion, and military cells. To the east, Afghan Border Police Commander Abdul Raziq, with a force of about 400 followers aided by U.S. SOF based in Spin Boldak, controlled the road from the border to Kandahar City and kept the surrounding regions from falling to the Taliban. Without his presence and influence, Kandahar City would have been completely surrounded.\",\n    \"As the Taliban advanced, the Canadians realized they needed help defending Kandahar. In January 2008, an independent Canadian government panel recommended that the nation’s contribution to ISAF continue beyond its scheduled termination date in February 2009. The panel’s suggestion was contingent on an additional battle group of 1,000 soldiers from NATO or another ally deploying to Kandahar. A stunning example of the need for better security in Kandahar came on 13 June 2008, when a complex attack on Sarposa Prison freed some 1,000 prisoners, 400 of whom were Taliban captives, including a number of midlevel commanders. Insurgents used suicide bombers to blow holes in the front and back walls of the prison before launching a ground assault and evacuating the prisoners in a disciplined fashion. Waiting buses transported the escapees out of the city. It was a spectacular propaganda coup with tangible results. Two days later, Taliban fighters surged into the Arghandab District in another sophisticated assault that cowed the local population and began a palpable turn away from the government and ISAF forces. The Taliban was now poised to recapture Kandahar City.\",\n    \"By the end of 2008, Kandahar City and its surrounding environs had become the front line in the Taliban’s war against the Karzai government and ISAF. The attack on Sarposa Prison, coupled with the Taliban’s continued offensive in Arghandab, marked a critical point in the battle for Kandahar Province. With the operational initiative, the Taliban began to project military cadres into Kandahar City. A Taliban spokesman announced the deployment of the Khalid ibn bin-Walid suicide bombing cell to Kandahar specifically to target government leaders and police commanders. Several police districts came under direct attack, killing some officers and prompting many more to flee. This initial foray enabled the Taliban to move intelligence agents, large caches of weapons, and multiple fighting cells into the city.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_5-5.png\",\n        \"caption\": \"General McKiernan welcomes Defense Secretary Gates\"\n      }\n    },\n    \"After the Taliban established a large vehicle-borne IED construction and staging center, their explosive devices blew up vehicles in the city center on a weekly basis. As Kandahar teetered on the brink, the United States sent additional forces to support the Canadians. In August 2008, CJTF-101 dispatched Colonel Hurlbut’s 2d Battalion, 2d Infantry Regiment, from TF DUKE for service under the Canadian command in Kandahar. Without ready-made positions or a logistical structure, the American battalion had to devote a considerable period of time establishing itself before conducting full-scale operations in support of its NATO ally. Even with the additional support, the Canadians struggled to stabilize the city. Unable to project force everywhere, they failed to prevent the villages of Nakhune and Bilanday, near the city’s southeastern suburbs, from becoming home to Taliban IED factories, safe houses, weapons caches, and field hospitals.\",\n    {\n      \"title\": \"McKiernan Takes Command\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The worsening situation around Kandahar City would become the responsibility of a new American officer as General David D. McKiernan replaced McNeill as the commander of NATO ISAF on 3 June 2008. Although known for his command of the land forces that invaded Iraq in 2003, McKiernan developed an appreciation for the situation in Kabul and in RC East while serving as commander of U.S. Army Europe and Seventh Army. His understanding of RCs North, West, and South was more limited, but improved as he took the opportunity to assess the situation more closely. On the ground, RC East continued to be a hotbed of enemy activity as CJTF-101 efforts to build the ANSF and bring security to targeted districts were hampered by command and control relationships so complex and geographically stretched that they nearly brought the division to its breaking point. McKiernan recognized that CJTF-101 was operating at, or beyond, its capacity. One of his first initiatives, therefore, was to bring a greater order to the overall campaign. He believed that dividing command and control for U.S. forces between U.S. and NATO command chains was unwieldy, and that the overall ISAF campaign lacked unity of effort and unity of command. As he would state, “in reality, the regional campaigns were all operating to different drumbeats, and a lot of those dictated by the drum being played back in national capitals.” McKiernan was particularly concerned with RC South, where he felt “there were really four different campaigns going on.” He wanted to align the various efforts under a single commander who would articulate a unified strategy and vision. On the U.S. side, this meant breaking down the division between the U.S. and NATO command chains. In response, the new ISAF commander and his staff launched an initiative to create a new headquarters, known as United States Forces–Afghanistan (USFOR-A). Established in October 2008, the headquarters was designed as a Title 10 coordinating headquarters, not one that would give operational guidance, which McKiernan would provide. In particular, USFOR-A would “coordinate the funding, resourcing, and activities on the U.S. side to meet and support that one intent, that one command and one strategy.” The new headquarters would take a heavy burden off of the RC East commander. McKiernan would spend the rest of his command trying to align the coalition to this comprehensive approach.\",\n        \"From the moment he arrived in Afghanistan, McKiernan understood that “whatever the strategy had been, was, and might be in the future, whatever azimuth changes, it was an under-resourced strategy.” Officials in Washington also were noting the dearth of resources available in Afghanistan and its impact on the campaign. In September 2008, Chairman of the Joint Chiefs of Staff Admiral Michael G. Mullen told Congress that, “I would say success in Iraq means we are steadily reducing our commitment for the theater. . . . At the same time, we are able, under those circumstances, to increase our commitment and resources to Afghanistan.” Unfortunately for senior U.S. defense officials, increases in troops, funding, and national assets remained tied to developments in Iraq. CENTCOM had already developed a request for forces in Afghanistan, asking the joint staff for more than 3,000 personnel to assist in training Afghan security forces (primarily the police). With American forces stretched to the limit between Iraq and Afghanistan, the request went unfilled.\",\n        \"The need for more forces in Afghanistan remained, and McKiernan continued to press for more resources. In the fall of 2008, President Bush approved an additional brigade for RC East and some additional forces for RC South. McKiernan received support when a new National Security Council study on Afghanistan, directed by Army Lt. Gen. Douglas E. Lute, also recommended pursuing counterinsurgency over counterterrorism efforts in Afghanistan, a modification which would entail significantly more resources. Bush, however, decided not to authorize additional forces so as to give President-elect Barack H. Obama as many options as possible when he took office in January 2009.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-5-m.svg\",\n        \"caption\": \"National Commands 2008\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    {\n      \"title\": \"Troop to Task Overmatch\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"By the time General McKiernan took command of ISAF, U.S. and coalition forces had spent six years working to build a functioning Afghan state that had the support of the population. For the majority of that time, Americans were working to implement a counterinsurgency approach that could degrade the enemy and provide Afghans the time and space necessary to develop their own capabilities. Despite the effort expended, the goal remained elusive in large part because sufficient numbers of troops had never been allocated to achieve those objectives.\",\n        \"The Afghan central government needed to function well and serve the Afghan people to gain their support. Government agencies and security forces needed to develop organizations from a population that had lost human capital through more than twenty years of warfare, strife, and divisiveness. No simple solution or singular area of focus linked the people and government. It required a comprehensive approach, which was exceedingly difficult to achieve.\",\n        \"For the U.S. Army, success in Afghanistan remained indelibly linked to providing security, governance, and reconstruction. Between 2005 and 2008, the United States contributed considerable resources to providing security in Afghanistan and enabling Afghans to sustain that security for themselves. Progress was slow. The Afghan police, unable to enforce the law, remained years behind the Afghan Army in terms of capabilities. The Afghan legal system was even further behind and could not provide the public with a sense of fair and impartial justice in a society in which personal honor was of critical importance. The United States and the coalition needed more time and additional resources to train, advise, and assist the expanding ANSF. To that end, McKiernan requested in late 2008 that CSTC-A be doubled in size, effectively growing it to two brigades.\",\n        \"Although the presence of more personnel would help Afghans provide for their own security, it was not the only need. Like building the ANSF, the U.S. military’s approach toward reconstruction had evolved significantly from 2006 to 2008. Recognizing that many Afghans supported the Taliban out of a sheer lack of alternatives, U.S. commanders viewed economic development and reconstruction projects as important tools in their fight against the enemy. Rather than sustain past practices where local authorities had little say in reconstruction projects, Provincial Reconstruction Teams and brigade combat teams invested time and effort to ensure Afghan involvement and to counter Taliban efforts to disenfranchise tribal leaders in contested provinces. As a result, local initiatives assumed as great an importance to the overall success of the reconstruction effort as national-level projects had previously. Evolving battlefield dynamics proved the worth of the reconstruction teams while also serving to convince brigade and battalion commanders of the importance of using all available tools—including reconstruction and economic development—in the fight against the Taliban.\"\n      ]\n    },\n    {\n      \"title\": \"SECTION I Conclusion\",\n      \"level\": 2\n    },\n    \"Between Afghanistan’s National Assembly and provincial council elections in September 2005 and the end of 2008, Operation ENDURING FREEDOM was in a state of constant change. Throughout the three-and-a-half-year period, U.S. policymakers relegated the intervention in Afghanistan to an economy-of-force effort. Although troop commitments fluctuated, and were rising at the end of 2008, total numbers paled in comparison to those committed to Operation IRAQI FREEDOM. With the deterioration of the situation in Iraq in 2006, the George W. Bush administration sought to transition primary responsibility for Afghanistan to NATO. However, disparate views between coalition members as to mission requirements resulted in a lack of unity of effort within ISAF and between ISAF and Operation ENDURING FREEDOM. A renewed insurgency by the Taliban and its allied organizations exacerbated this deficiency within the coalition. In effect, between 2005 and 2008 the United States and NATO ceded the operational initiative to the insurgents. As the coalition struggled with internal issues and varied approaches to Afghanistan, by 2008 the entire mission faced the possibility of strategic failure.\",\n    \"The primary demand on the Army during this period was the need to provide sufficient resources for simultaneous operations in Iraq and Afghanistan. Efforts to grow the Army—and to deal with the causes and effects of stress on the armed forces—made it possible to source and sustain a surge of troops in Iraq beginning in 2007 while maintaining a limited presence in Afghanistan. Without these initiatives, senior leaders believed the force as a whole risked being broken. Modularity was one effort to find efficiency in force structure that would enable the Army to do more with less. However, in addition to its detrimental effect on the Field Artillery, among other branches, modularity nearly eliminated the Air Defense Artillery branch. Less visible changes affected the health, discipline, accountability, training, and teamwork of the force. Fifteen-month deployments and the overuse of National Guard and Army Reserve forces were coping strategies for an Army too small for its assigned missions. Recruiting, promotion, accountability, assignment, and training shortcuts also sacrificed long-term capacities for short-term needs.\",\n    \"Beyond the larger problems of Army doctrine, efforts to strengthen the service’s force structure, force design, readiness initiatives, and myriad smaller programs proved that the Army could be agile and adaptable to human and cultural dimensions of the fight. Army leaders inculcated the force into similar environments via new training models created at home stations and at combat training centers. To ensure that soldiers were fully prepared for their upcoming deployments, units rotating through the combat training centers were judged on unit readiness instead of the old model of leader development. Other efforts encompassed training in anthropology, languages, professional readings, studies of the Soviet experience in Afghanistan, and more. The Army established Red Team University to teach members of an organization to challenge itself by assuming an adversarial role or point of view, forcing unit leaders to think differently. All of this contributed to a better prepared and more critically thinking Army.\",\n    \"Even so, the growth of the Army still did not solve all readiness issues, especially in the area of training. Because of time constraints before deployment, soldier training focused intensely on counterinsurgency missions, causing proficiency in combined-arms warfare to atrophy. These skills would not fully recover until the drawdown from both Iraq and Afghanistan. Moreover, despite improvements, the Army would face training and personnel readiness issues for years to come.\",\n    \"For U.S. forces in Afghanistan, the 2005 elections marked the nominal culmination of the Bonn Process begun in 2002. The establishment of a new Afghan government under President Hamid Karzai was meant to mark the end of Taliban rule and the emergence of Afghanistan as a burgeoning democracy that would no longer support and harbor international terrorist organizations such as al-Qaeda. However, the question remained open as to who would provide security as the Afghan state developed and stabilized. The ANSF was not yet ready to take on that responsibility, despite significant strides in building the ANA and the beginnings of a more comprehensive training program for the police. With its growing commitments in Iraq, the United States was incapable of providing additional military resources to adequately secure the country. Responsibility therefore fell to the NATO-resourced ISAF. NATO members saw operations in Afghanistan—the first deployment of alliance forces outside of Europe—as a means to maintain relevancy in a post–Cold War environment. Most alliance members, however, did not envision providing significant forces to establish and maintain security, but rather planned to conduct peacekeeping operations until the ANSF could stand up.\",\n    \"The emergence of an aggressive, multifaceted insurgency in 2006 that targeted various coalition elements fundamentally altered the operational environment in Afghanistan. American and coalition leadership had to react to the changing situation on the ground rather than initiating a more unified coalition effort. For most of 2006, Lt. Gen. Karl W. Eikenberry’s CFC-A worked to finalize the transition to NATO ISAF under the command of British Lt. Gen. David J. Richards despite rising insurgent attacks, particularly in RC South. When General Dan K. McNeill took over command of ISAF in early 2007, he sought to implement a more aggressive approach to battling the growing insurgency. However, a lack of unity of effort and unity of command within NATO ISAF, as evidenced by operational restrictions dictated by national caveats, limited his effectiveness throughout his eighteen-month deployment. Inefficiencies between American forces in ISAF and ENDURING FREEDOM, as seen with competing American command chains operating in theater, further hindered American operations. His successor, General David D. McKiernan, spent the latter half of 2008 working to unify American and coalition efforts through the establishment of USFOR-A. Although successful, the time that passed between the end of the Bonn Process and the firm establishment of NATO ISAF under American leadership enabled the various allied insurgent groups to solidify their presence in Afghanistan’s southern and eastern provinces.\",\n    \"However, even though the Taliban in RC South and the Haqqani Network in the southern and HIG in the northern parts of RC East mounted vigorous opposition, their activity was not the key impediment to American or ISAF goals. Local counterinsurgency successes after the Bonn Process attest to the ability of Afghan, American, and ISAF forces to exert positive influence. In particular, Nangarhar Inc. and the Kapisa portion of Operation MOUNTAIN EAGLE improved stability through increased security operations and economic development, while Operations MAIWAND and MEDUSA established prototypes for effective partnered operations at the brigade level. As these operations indicate, adequate resources devoted to counterinsurgency could increase popular support for the Afghan central government. Nonetheless, insufficient resources prevented theater commanders from focusing on multiple regions at the same time while separate U.S. and ISAF decisions to expand their respective operational footprints—without effective coordination—exacerbated the overall lack of resources.\",\n    \"The coalition forces had good reasons to enlarge their presence in RC South and RC East. In RC South, Helmand Province was the largest source of poppy production in the world, and Kandahar City was the ancestral home of the Pashtuns, the Taliban’s main base of support. RC East, the staging base for HIG and the Haqqani Network, was the primary crossing point into Pakistan where insurgent groups established their operational bases. Neither region necessarily took precedence as each was vital to coalition and Afghan long-term objectives. However, limited resources made it difficult to sustain concurrent efforts to extend coalition influence in southern and northeastern RC East, while also expanding into the rural interior of Helmand and Kandahar Provinces. Without a common enemy and conducted in separate areas, one operation could not necessarily be made to support or shape the other. Maj. Gen. Benjamin C. Freakley was forced to shift American units between the two regional commands in 2006, interrupting the implementation of his campaign plan and forcing some units to curtail their activities while the main effort resided elsewhere. A few months into his command, General McNeill sought to mitigate this problem by establishing one region as his priority, but it instead reflected a continuation of American and NATO forces having to emphasize one region over another. Successive theater commanders found ways to integrate the capabilities of member nations in an effort to align the campaigns, but were continually constrained by a lack of coalition consensus on what the problem in Afghanistan was and how best to solve it. Meanwhile, domestic extremism in Pakistan forced Islamabad to turn its attention away from Afghanistan, which undermined the work of the coalition. The continued existence of insurgent sanctuaries in Pakistan enabled the enemy to sustain activities in both RC South and RC East while the coalition shifted focus between the two.\",\n    \"From a strategic perspective, throughout this period the United States maintained a consistent goal of creating a secure and stable Afghanistan capable of preventing the return of international terrorist groups. What changed were the forces acting in opposition to this objective. Instability and corruption within the Karzai government, coupled with the continued division of the population along religious, ethnic, and tribal lines, undercut coalition efforts to build up popular support for the central government. The slow development of the ANSF forced the coalition to take on far greater responsibility for local and regional security than initially intended by either the United States or the troop-contributing members of NATO. As coalition forces spread out among the population to the greatest extent possible, they became wedded to the terrain they tried to hold. Company, battalion, and brigade commanders were forced to accept tactical risk to cover as much of the ground and the local population as possible, making their units more vulnerable. This increased vulnerability became an opportunity for insurgent operations, where the Taliban propaganda machine could spin any casualty-producing attack into a strategic victory regardless of the large insurgent losses.\",\n    \"Thus by 2008, the challenges facing Operation ENDURING FREEDOM appeared significantly greater than they had been three years earlier. In April, an assassination attempt on President Hamid Karzai killed numerous high-level officials attending the Afghan Victory Day parade in Kabul. In June, attacks on Kandahar City culminated in a breakout at the Sarposa Prison that freed hundreds of suspected Taliban fighters. The following month, an assault on an American platoon and its ANA reinforcements at Wanat in the Waygal Valley upset the coalition’s influence campaign in RC East. Meanwhile, the bombing of the Indian Embassy in Karachi signaled increasing instability in Pakistan, which required a more aggressive stance by the United States. All signs pointed to the fact that the U.S. political and military leadership faced a fundamental disconnect of ends, ways, and means in regard to Afghanistan. The deteriorating security environment prompted the Bush administration to consider McKiernan’s recommendations for troop increases. With the fight in Iraq largely stabilized by the summer of 2008, the administration could undertake a comprehensive reassessment of its strategic objectives and commitment of resources in Afghanistan. The election of a new president in November, however, meant that whatever course the United States and its Army pursued would be in the hands of a new administration.\"\n  ],\n  \"section Ii\": [\n    {\n      \"title\": \"THE SURGE IN AFGHANISTAN\"\n    },\n    {\n      \"picture\": {\n        \"source\": \"/figures/v2/art_sII-1.png\",\n        \"caption\": \"Engaging the People\"\n      }\n    },\n    \"President Barack H. Obama took office on 20 January 2009 having pledged to end the war in Iraq and defeat al-Qaeda in Afghanistan. The two conflicts were going in opposite directions. The surge was complete in Iraq and violence was down significantly. President George W. Bush had signed a Status of Forces Agreement with the Iraqi government to withdraw the nearly 150,000 U.S. troops in country by the end of 2011. Afghanistan, meanwhile, remained an economy-of-force mission, with 30,000 troops fighting a resurgent Taliban. Although General David D. McKiernan, the senior U.S. commander in Afghanistan, had requested additional forces, President Bush only partially fulfilled the request, so as not to handicap the next administration.\",\n    \"Security in Afghanistan had been deteriorating since 2006. The ensuing years had been the most violent for the coalition and U.S. Army since the conflict began in late 2001. In 2007, there had been 771 U.S. battle casualties of whom 78 were killed in action, and in 2008, there had been 663 total casualties including 97 killed in action. For the U.S. Army, 2007 and 2008 experienced a near doubling of the casualties from 2006 (373 casualties, 62 killed), or about two-thirds of the combined total for 2001–2005 (555 casualties, 97 killed). By late 2008, there were more IED and small-arms attacks per month in Afghanistan than in Iraq. This alarming trend showed no sign of reversing, suggesting that the number of Americans killed or wounded in Afghanistan would soon surpass the number of killed or wounded in Iraq for the first time in 2009. While the Joint Staff had begun investigating options for shifting troops from Iraq to Afghanistan as early as May 2008, prior to that date no one had suggested that the situation had reached a point at which the current national strategy in Afghanistan needed to be reexamined.\",\n    \"That situation changed between late 2008 and 2011, during what would come to be known as the surge in Afghanistan. The surge resulted from three discrete decisions—one by Bush and two by Obama—to deploy more forces to Afghanistan. By the end of 2011, 80,000 of the 106,000 U.S. service members deployed in support of Operation Enduring Freedom would be Army personnel, representing more than half of the 140,000 troops deployed from all services and troop-contributing nations. For both administrations, the decision to surge came at the end of intensive and sometimes contentious strategic reviews.\",\n    \"This section covers the surge, focusing on RC South. It reviews the events that occurred during the  successive tenures of three senior American commanders: General David D. McKiernan, June 2008–May 2009; General Stanley A. McChrystal, June 2009–May 2010; and General David H. Petraeus, May 2010–August 2011. The McKiernan section explains the decision-making process behind the surge in Afghanistan, the shift toward a counterinsurgency approach, and the abrupt end to his command. The McChrystal chapter details the campaign pursued and events experienced by McKiernan’s successor, dealing specifically with how additional troops were deployed in RC South, Phase II of Operation Moshtarak (Together), and the changes McChrystal made in how the conflict was fought. The Petraeus section includes Phase III of Operation Moshtarak, fought in and around Kandahar City. The section ends with analysis of the surge, civilian participation, and contributions of Special Forces.\",\n    \"When General McKiernan took command of ISAF on 3 June 2008, the U.S. Army had more than 250,000 soldiers serving across the globe with more than 140,000 of those troops deployed in combat zones. Almost 25 percent of the Army’s total 1,097,050 officers and enlisted personnel were serving outside the continental United States. The active component numbered 539,675, reflecting an increase of 21,982 compared to the previous year. The Army National Guard stood at 360,351, and the Army Reserve numbered 197,024, with these organizations experiencing growth of 7,644 and 7,142 personnel respectively.\",\n    \"The soldiers making up the Army’s ranks were now far more seasoned than their Cold War–era predecessors. From 11 September 2001 to April 2009, a million soldiers from all components completed combat tours, with almost 40 percent of active and 30 percent of reserve personnel deploying two or more times. By fall 2009, soldiers accounted for 70 percent of the nearly 5,300 combat deaths. Despite the high probability of a soldier seeing combat, all three components exceeded not only their recruiting goals but also their enlisted retention targets during 2008, which resulted in nearly 300,000 personnel either enlisting or choosing to remain in the military during the seventh year of the Global War on Terrorism.\",\n    \"The Army’s recruiting and retention success made it possible to begin filling the tens of thousands of additional personnel spaces approved by Secretary of Defense Robert M. Gates in early 2007. Many of these personnel were used to fill six new active component infantry brigade combat teams, two of which began forming in 2008. Others were allocated to eight new active component sustainment brigades, bringing the Army-wide total to 76 brigade combat teams and 225 support brigades. In addition to creating new units, the process of converting existing organizations to the new modular design continued, with 85 percent of the Army having converted by the end of 2008. Considerable resources also went into managing the Army’s equipment fleet, as soldiers were using tanks, infantry fighting vehicles, and helicopters at a rate five times greater than programmed. As a result, the Army refurbished almost 125,000 pieces of equipment and issued nearly one million new items; including 6,500 MRAP vehicles, during 2008.\",\n    \"In addition to the unrelenting press of wartime operations, the Army experienced major internal turbulence  as congressionally mandated Base Realignment and Closure (BRAC) moves took place. Tens of thousands of soldiers and dozens of military installations at home and abroad were affected. Major relocations included the removal of two heavy divisions from Germany: the 1st Armored Division taking up residence at Fort Bliss, Texas, and the 1st Infantry Division, split between Fort Riley, Kansas, and Fort Knox, Kentucky. In addition, the 7th Special Forces Group relocated from Fort Bragg, North Carolina, to Eglin Air Force Base, Florida. None of the units taking part in the realignment process were eligible to send troops to Afghanistan or Iraq, which meant organizations unaffected by BRAC would carry the combat load.\",\n    \"${An Uncertain Way Forward}{bold}\",\n    \"The close of the 2008 fighting season pointed to a grim future for the U.S.-led coalition in Afghanistan. The coalition’s efforts to win the support and loyalty of the people, and eventually transfer that support to the government of Afghanistan, were only marginally more successful than they had been in 2005. The highland Pashtuns of RC East were willing to accept American money and development assistance, and even tolerated American troops in some areas, but the local population generally was not interested in and often was hostile to what coalition forces had to offer. In RC South, NATO forces were hard-pressed to secure the major population centers in the Taliban’s homeland. Taliban forces enjoyed multiple secure lines of communication to safe havens in Pakistan, and the call of jihad ensured a continuous flow of motivated, trained, and experienced foreigners who could mentor and lead local insurgent groups. Lastly, the unrestricted drug industry fueled lawlessness, funded antigovernment groups, enticed government officials to look the other way in return for massive bribes, and gave local communities a stake in the Taliban’s success.\",\n    \"Since the ISAF transition, coalition and Afghan forces had conducted hundreds of counterinsurgency missions in an effort to arrest the Taliban’s momentum in RC South, block the constant stream of jihadist fighters from Pakistan in RC East, and contain the Haqqani Network. Despite killing thousands of insurgents and spending billions on reconstruction and development, ISAF could point to little tangible evidence of lasting success. In fact, the Taliban broke with previous patterns at the end of the 2008 fighting season and did not withdraw its fighting forces to Pakistan. In a surprise move, the Taliban continued ${Operation Ebrat}{italic} in Helmand and increased suicide operations in Kabul. This late-season offensive threw off balance the Afghan and ISAF attempts to secure the population over the winter. In early 2009, the Taliban followed its efforts in Helmand with ${Operation Nasrat}{italic} (Victory). A concentrated campaign to isolate Lashkar Gah, ${Nasrat}{italic} was the Taliban’s boldest move to date in the south. Although it failed to seize the provincial capital, the instability it perpetuated undercut the Karzai government’s legitimacy and weakened popular support for ISAF.\",\n    \"Pakistan’s strategic interests further complicated the situation. The government in Islamabad continued to diverge from the interests of the ISAF coalition and began to focus solely on state survival as growing civil unrest, political turmoil, and concern over India’s actions diverted Pakistani security resources from the Federally Administered Tribal Areas. The enemy’s eastern networks not only affected the Afghan insurgency, but also further destabilized Pakistan by launching offensive operations against its military deployed within the tribal areas. Capitalizing on the gains they had made in 2008, Pakistan-based extremists used the winter months to reconstitute and emerge the following year as a viable threat to Afghanistan, ISAF, and the Pakistan government.\",\n    \"From their sanctuaries in Pakistan, al-Qaeda and local jihadist groups cooperated to plan new attacks in the name of Islam. While the Pakistani Taliban defended refugees from the Pakistani Army, presenting a clear threat to the Pakistani state and contributing to the Afghan Taliban’s momentum, al-Qaeda and like-minded organizations provided money, training, materiel, and leadership to insurgents fighting on both sides of the Afghanistan-Pakistan border. The Afghan Taliban benefited significantly from this nexus of ideology, insurgency, and regional extremism—and even more so as it grew in importance and authority.\",\n    \"${National Strategy: New Goals, New Resources}{bold}\",\n    \"As pressure in Iraq began to ease in 2008, some members of the Bush administration expressed the opinion that the United States should refocus on Afghanistan. Addressing this concern, President Bush ordered Lt. Gen. Douglas E. Lute, the deputy national security advisor for Iraq and Afghanistan, to chair a National Security Council strategy review in early fall 2008. Lute’s report recommended a better-resourced counterinsurgency approach in Afghanistan and a regional strategy that included Pakistan. Although someone in the administration leaked a draft of the report in early October, the final version would not be completed before voters chose Bush’s successor. The outgoing president did not respond formally to Lute’s findings to avoid committing the next president to implementing someone else’s strategy.\",\n    {\n      \"picture\": {\n        \"source\": \"/figures/m/map-s2-helmand-and-kandahar.svg\",\n        \"caption\": \"Map-Helmand and Kandahar\"\n      }\n    },\n    \"The election of President Obama heralded major changes to how the United States waged the conflict in Afghanistan. The Obama national security team held a pragmatic regional view, including on the core motivation of the Pakistani and Afghan governments. The White House newcomers saw Pakistan as a conflicted nation whose leaders sought to promote their nation’s interests at the expense of those of the United States. They also believed Kabul’s politics were so infused with graft and corruption that the Afghan people refused to show allegiance to their government. Afghanistan’s endemic corruption shocked many observers; in one egregious example, the Finance Ministry collected 40 billion afghanis (roughly $800 million) in revenue between March 2007 and March 2008, even though its own calculations stated that the total should have been 120 billion afghanis (about $2.4 billion). Most people believed the disappearance of $1.6 billion—more than 66 percent of forecasted revenues—reflected unsanctioned negligence or the criminal handiwork of low-level officials.\",\n    \"A foretaste of the new administration’s views had surfaced in February 2008 when a U.S. delegation headed by then Senator Joseph R. Biden Jr. visited Kabul. Biden and two other senators questioned Afghan President Hamid Karzai about corruption in his government at a state dinner. Karzai repeatedly assured Biden and his dinner companions that if any corruption in fact existed, then he should not be held responsible for it. After forty-five minutes of fruitless discussion, Biden and the other Americans abruptly left without another word to their host. Many in the new administration shared Biden’s doubts. Soon after Obama’s inauguration, the New York Times reported that “President Barack Obama said he regarded Karzai as unreliable and ineffective. Secretary of State Hillary R. Clinton said he presided over a ‘narco-state.’ The Americans making Afghan policy, worried that the war is being lost, are vowing to bypass Karzai and deal directly with the governors in the countryside.”\",\n    \"In January 2009, now Vice President Biden delivered one of the administration’s first messages to Karzai: he would not enjoy regular video teleconferences with Obama as he had with Bush, a practice Obama officials believed had undermined commanders in the field. The relationship between the two administrations deteriorated further during the 2009 Afghan presidential election, in which Karzai sought his second and final five-year term in office. The new special representative for Afghanistan and Pakistan, Richard C. Holbrooke, reportedly postponed the election from May 2009 to August 2009 in order to give Karzai’s opponents a better chance to win, even though this delay went against the Afghan constitution. He and Ambassador (Ret. Gen.) Karl W. Eikenberry then worked to bolster Karzai’s opponents, including former foreign minister Abdullah Abdullah and former finance minister Ashraf Ghani, so that Karzai would be forced into a run-off that he might lose. This “clumsy and failed putsch,” as Secretary Gates has since called it, likely incited Karzai to arrange the alleged massive voter fraud that marred the 2009 presidential election.\",\n    \"The Obama administration’s dissatisfaction with Kabul became public in early 2010 following the unauthorized release of classified State Department messages by U.S. Army Spec. Bradley E. Manning (now known as Chelsea E. Manning). Manning, a disaffected soldier, had sent several hundred thousand documents containing classified information on Iraq and Afghanistan to a third party who then posted that material on the internet. Within hours, global media consumers were reading that Ambassador Eikenberry viewed Karzai “as an inadequate strategic partner.” Although discomfited by the public exposure of diplomatic cables, the Obama administration did not abandon its goal of eliminating corruption in Kabul. Rather than distance itself from the outspoken former general, the administration signaled that it agreed with Eikenberry by retaining him as U.S. ambassador through July 2011.\",\n    \"In addition to having qualms about America’s Afghan partners, Obama believed that “there just didn’t seem to be a clear, coherent strategy there.”  As the incoming administration looked to rectify this problem, Obama asked Gates to remain as secretary of defense and Lute to stay on as deputy national security advisor. Although Obama’s defense team now included holdovers from the Bush administration, the president asked former CIA analyst Bruce O. Riedel on 30 January 2009 to review the progress of U.S. military efforts in Afghanistan. As with Lute’s effort, Riedel sought to answer two fundamental questions: (1) what were the United States’ goals in Afghanistan, and (2) how should they resource the war.\",\n    \"The strategic review, which drew heavily from Riedel’s work at the Brookings Institution, took two months. After Riedel finished his assessment, Obama presented its broader points to the American public in a speech on 27 March 2009. Obama reframed the war in tighter terms, focusing only on the terrorist group responsible for the September 11th attacks. He made it clear that the war’s “core goal” was “to disrupt, dismantle, and defeat al-Qaeda in Pakistan and Afghanistan, and to prevent their return to either country in the future.” This new strategy departed from the Bush administration’s Global War on Terrorism approach, which sought to eliminate all state-sponsored terrorism that could threaten the American way of life. Indeed, the Obama administration was hostile to the global war concept, which it saw as sanctioning endless war. As the president later remarked:\",\n    {\n      \"list\": [\n        \"\\\"I think the most important aspect of the entire exercise with the Riedel report was making sure everybody reminded ourselves of how we got in there in the first place, which was that al-Qaeda had killed 3,000 Americans and that our goal here had to be focused on dismantling and defeating those extremist elements in that region that could launch an attack of the U.S. homeland or our allies or our outposts.\\\"\"\n      ]\n    },\n    \"Continued interest in preventing al-Qaeda from operating with impunity in Afghanistan or Pakistan guaranteed that the approach  favored by the administration included both new and familiar strategic concepts. The Obama administration rephrased the fundamental aim of Operation Enduring Freedom—to deny terrorists sanctuary, implying a continuing war with the Taliban. Supporting objectives for this core goal included: (1) disrupting terrorist networks and degrading their ability to launch international attacks; (2) “promoting a more capable, accountable, and effective government . . . that serves the Afghan people and can eventually function, especially regarding internal security, with limited international support”; (3) developing Afghan security forces to lead counterinsurgency and counterterrorism operations with reduced U.S. support. Denying safe haven thus remained key to American counterterrorism strategy. The Obama administration would stand by these objectives for the remainder of Enduring Freedom.\",\n    \"Even though Obama had abandoned the democracy-building language of the Bush administration, he still wanted an accountable  and effective Afghan government. In his view, this broader goal included:\",\n    {\n      \"list\": [\n        \"1. Executing and resourcing an integrated civilian-military counterinsurgency strategy;\",\n        \"2. Resourcing and prioritizing civilian assistance in Afghanistan;\",\n        \"3. Expanding the ANSF to 134,000 soldiers and 82,000 police over the next two years, with the potential for additional enlargements;\",\n        \"4. Engaging the Afghan government and bolstering its legitimacy;\",\n        \"5. Encouraging Afghan government efforts to integrate reconcilable insurgents;\",\n        \"6. Including provincial and local governments in our capacity building efforts;\",\n        \"7. Breaking the link between narcotics and the insurgency; and several others dealing with international support and Pakistan.\"\n      ]\n    },\n    \"The Obama administration viewed Pakistan and Afghanistan as an indivisible problem set. The overarching objective for Pakistan involved “[a]ssisting efforts to enhance civilian control and stable constitutional government . . . and a vibrant economy that provides opportunity for the people of Pakistan.” Other goals included building stronger relationships between the Pakistanis and Americans and also between the Afghans and Pakistanis. In addition, Riedel recommended providing the Pakistani Special Forces and Frontier Corps with the training needed to wage sustained counterterrorism and counterinsurgency operations. The Obama administration’s preferred approach to dealing with Pakistan was not a change in emphasis, but a realization that it needed a coordinated interagency approach rather than the previous ad hoc efforts.\",\n    \"Before Riedel had finished his review—but taking into account his input—Obama decided to fill part of General McKiernan’s outstanding troop request so as to secure Afghan elections. On 17 February 2009, the White House announced that the president was sending more forces to Afghanistan in time to secure its upcoming presidential election, scheduled for August 2009. The president initially believed he was approving a request for 17,000, but the Pentagon continued to revise troop numbers until the total reached 21,000. The discrepancy reflected poor staff work by military planners who had overlooked a requirement to send supporting units and trainers to build the ANSF. The shifting numbers fueled the administration’s already considerable suspicions about the Pentagon’s agenda. With the adjusted 21,000 increase, the official number of U.S troops from all services committed to Afghanistan was now 68,000. President Obama also called for a “substantial increase” in the number of civilians in theater, an initiative that came to be known as the “civilian surge.”\",\n    \"The Riedel report received mixed approval from audiences outside the White House when the Obama administration released it in late March 2009. Secretary of Defense Gates recalled that he “was very disappointed in the Riedel review” mostly because it “contained no new ideas.” The White House planned to monitor the adjusted Afghanistan-Pakistan strategy for twelve months before revisiting potential policy and resourcing issues. Holbrooke, the diplomat who had brokered the 1995 Dayton Accords to secure the end of the war in Bosnia and Herzegovina, served as a special representative for Afghanistan and Pakistan to oversee the strategy. Holbrooke’s mission was to coordinate diplomacy in both countries and implement the initiatives outlined in Riedel’s report while working with the State Department.\",\n    \"${Counterinsurgency Redux}{bold}\",\n    \"When President Obama took office on 20 January 2009, the Iraq surge was complete and assessed as a success. Regardless of what else  had happened in 2009 (an uprising of Sunni tribes against al-Qaeda, a political reconciliation to take advantage of that situation, and more), the surge looked like a formula for winning in Afghanistan. In the words of General David H. Petraeus, who executed the Iraq strategy:\",\n    {\n      \"list\": [\n        \"\\\"It [counterinsurgency doctrine coupled with the surge] did prove itself in Iraq. There was no question about when you drive down  the level of violence by 85 to 90 percent; I mean that is proving itself. And keep in mind of course it was sustained for a number of years after the surge . . . almost three-and-a-half years until [Iraqi prime minister Nouri al-]Maliki . . . really undid what it is that we had done together.\"\n      ]\n    },\n    \"As the CENTCOM commander, General Petraeus now championed the adoption of a counterinsurgency approach in Afghanistan that required a  further increase in troop numbers. He used briefing charts similar to those he had used in his congressional testimony in 2007 when he had charted the path out of the surge in Iraq just months after it had begun. In this instance, Petraeus argued that the rising violence in Afghanistan could be punctuated by “Surge Offensives,” eventually leading to a sharp decline in enemy attacks. Petraeus was explicit in signaling that he wanted to apply the lessons of Iraq to Afghanistan. Comparing the rise in enemy activity in Afghanistan to what U.S. commanders in Iraq had faced in 2006, he said:\",\n    {\n      \"list\": [\n        \"\\\"I think, as we turn and shift our focus to Afghanistan and Pakistan, it is very important to reflect on what we learned from Iraq  and to remember that you have to apply what was learned there with a very nuanced understanding, a very granular understanding of local circumstances in which those lessons are being applied . . . you have to—in Iraq—live among the people . . . you have to realize now that as you apply this in Afghanistan, that you don’t live among the people in Afghanistan. First of all, there’s no empty house. Second, the villages, particularly in the rural areas tend to be small. . . . You cannot clear and leave. You have to clear and hold. . . . And again, adapting this to the circumstances in Afghanistan with sufficient understanding will be critical.\\\"\"\n      ]\n    },\n    \"The mention of clear and hold is a reference to the clear, hold, and build sequencing in the Army’s ${Counterinsurgency}{italic} manual (Department of the Army Field Manual 3–24), released in December 2006 under Petraeus’ signature. Harkening back to his Iraq experience, Petraeus exhorted Congress to use all resources, government and otherwise, in a “comprehensive” strategy to defeat the enemy militarily and promote political reconciliation.\",\n    \"Petraeus’ ideas resonated with Riedel’s recommendations while adding the gravitas of the fresh success. They also implied that specific detailed efforts from counterinsurgency in Iraq needed to be reproduced in Afghanistan. The clearest reference to Iraq was in command structure. Petraeus recognized that the existing command structure in Afghanistan lacked the mechanisms necessary to facilitate international, interservice, and interagency cooperation. Petraeus proposed adding both a tactical headquarters and a security force assistance-and-training command to the existing ISAF headquarters. More extensive changes were envisioned for U.S. Forces–Afghanistan (USFOR-A), including joint interagency task forces for detention operations and counternarcotics, a business and stability operations task force to aid the Afghan economy’s development, a combined intelligence operations center, an information operations task force, a specialized cell to track terrorist financing, and an interagency task force to promote effective Afghan governance and combat corruption.\",\n    \"Petraeus, convinced of the success of the Iraq surge, set out to export its “big ideas” to Afghanistan. From his position as commander of CENTCOM, he was uniquely positioned to influence the implementation of the doctrine he had coauthored at Fort Leavenworth and tested in Iraq. Although he could not know it at the time, he soon would be in a position to implement its concepts personally.\",\n    \"${The Resilient Threat, 2009}{bold}\",\n    \"The 2008 fighting season did not taper off in winter as previous fighting seasons had. McKiernan was aware that, with elections coming in the spring of 2009, the security situation was of particular concern. The enemy showed no sign that it was preparing to rotate fighters back to Pakistan for rest and reconstitution. The constant activity reflected the Quetta Shura Taliban’s secure position as the leader of armed opposition to Karzai’s government and ISAF. Taliban leaders were willing to conduct sustained combat operations in order to maintain their position as the dominant faction in the loose collection of extremist groups in Central Asia. The Pakistan Taliban had also been growing in numbers and influence, although it remained focused mainly on turning Pakistan into a fundamentalist Muslim state.\",\n    \"The Taliban leadership placed great importance on swaying local Afghan populations to its side and instructing its fighters to  avoid collateral damage and unnecessary casualties. In 2006, the Quetta Shura leadership originally published a ${layeha}{italic}, or code of conduct. This document, updated and reissued in 2009 and again in 2010, touched on cultural, religious, and historical themes familiar to Pashtuns, stating: “This Book of Rules is intended for the ${Mujahedeen [sic]}{italic} who dedicate their lives to Islam and the almighty Allah. This is a complete guidebook for the progress of Jihad, and every ${Mujahid}{italic} must keep these rules; it is the duty of every Jihadist and true believer.” The otherwise silent voice of Mullah Mohammed Omar figured prominently in later editions of the laheya, possibly signaling that some had lost faith in the Taliban’s reclusive leader. His reemergence indicated that the Taliban was at a critical junction where internal factionalism and wanton bloodshed threatened its strategic aims.\",\n    {\n      \"picture\": {\n        \"source\": \"/figures/v2/img_sII-2.png\",\n        \"caption\": \"MQ-9 Reaper\"\n      }\n    },\n    \"American intelligence assessments admitted that, while the core aims of the Taliban factions remained obscure, their operational goals were clear and “coming into alignment.” Militarily, the insurgency sought to expand its support in Afghanistan through influence and military operations in the western and northern provinces; conducting targeted operations to undermine governance, security, and economic development; inflicting casualties on ISAF and Afghan security forces; and consolidating footholds in the south and east. The Taliban appeared to be making considerable geographic progress by the end of 2009. Of Afghanistan’s 364 districts, 10 were assessed as under Taliban control. A staggering 156, most near the Pakistan border, were coded as “under Taliban influence.” The American surge would attempt to remove or reduce the influence of the Taliban in these contested districts and give the Afghan government a chance to establish legitimacy.\",\n    \"${Drone Operations Reach Their Peak}{bold}\",\n    \"One of the few bright spots of the campaign in the months leading up to the new administration taking office came out of the decision made several years earlier to take the fight into Pakistan’s tribal lands. The Bush administration had some successes using drone strikes against key figures in al-Qaeda operating in Pakistan from late 2005 to the end of 2007. One of the most notable resulted in the death of Abu Hamza al Rabia, al-Qaeda’s third most senior leader and chief operational planner, near Miran Shah in North Waziristan on 30 November 2005. However, drone activity remained limited through 2007, as military planners were still refining effective procedures for locating, identifying, and striking targets. That process had proceeded in fits and spurts as new procedures were tried and discarded or improved. The strikes also began to generate opposition within Pakistan and the United States as increasing civilian casualties were attributed to unmanned aerial vehicles, including one incident in which missiles struck a religious school in Damadola in the northern tribal lands on 30 October 2006.\",\n    \"In the final year of the Bush presidency, U.S. forces solved several procedural and technical challenges that had impeded the unmanned aerial vehicle program, and launched an increasing number of drone strikes within Pakistan. The increase in attacks attributed to unmanned aerial vehicles during 2008—totaling thirty-four, in comparison to an average of three to five in previous years—stimulated a commensurate increase in popular opposition to their use. The first indication that the new president’s views on the potential of unmanned aerial vehicles were somewhat similar to his predecessor came three days after Obama’s inauguration when drones struck several targets in Waziristan.\",\n    \"During Obama’s first term in office, which encompassed the Afghanistan surge, drone strikes steadily rose in numbers and increased in  lethality with fewer civilian casualties than before. The trend stemmed from the fielding of longer-ranging drones, which were capable of loitering over an area for hours in order to collect more detailed information, and the replacement of Hellfire antitank missile warheads by less powerful models. Although few nongovernment sources agreed on the estimated numbers, drone strikes in Pakistan numbered between 53 and 54 in 2009, 117 and 128 in 2010, 64 and 75 in 2011, and anywhere from 46 to 50 attacks in 2012. Based on the source, civilians accounted for a minimum of 2 percent and a maximum of 12 percent of the total casualties in Pakistan credited to drones during Obama’s first term. Obama was keenly aware that some claims of civilian casualties were derived from unverified reports. However, he made his personal views clear: “This is a targeted, focused effort at people who are on a list of active terrorists who are trying to go in and harm Americans, hit American facilities and bases.”\",\n    \"${Operational Overview}{bold}\",\n    \"Each of the three operational commanders from 2009 to 2011 altered ISAF’s approach to the war during his tenure. General David D. McKiernan, who commanded in a resource-constrained environment until 11 May 2009, requested to double the American force from 30,000 to more than 60,000 and attempted to unify the regional commands through coherent campaign revisions before being abruptly replaced.\",\n    \"Assuming command in June 2009, a month after Gates removed McKiernan, General Stanley A. McChrystal adapted and executed his predecessor’s plan. Gates and Obama impressed upon McChrystal the need to reduce civilian casualties, conduct a strategic assessment of the war within sixty days, and streamline the command. McChrystal did this but then asked for even more troops. While McChrystal’s request was mostly filled, he also abruptly left command after a reporter quoted his staff’s disparaging remarks regarding senior leaders in the Obama White House.\",\n    \"General Petraeus relinquished his command of CENTCOM to take over ISAF in May 2010. Petraeus oversaw the Afghan surge. He sought to repeat his Iraq success in Afghanistan, accelerating offensive operations in order to make progress toward ISAF’s operational objectives. The Petraeus period, during which American troop strength exceeded 100,000, ended with a transition plan for the next phase of the war to begin in summer 2011.\",\n    \"Although the term “surge” implies a temporary increase in troops, like a tide that rises and ebbs, it was more than that. The surge in Afghanistan also entailed debates over the strategy, the evolving command structures, and the unique personalities of senior ISAF commanders. It concluded in July 2011 when reinforcing units began returning home and Afghan forces started assuming responsibility for their nation’s security. Simultaneous with the start of the drawdown, President Obama announced that the American combat role would end in 2014.\",\n    \"The Afghan surge was an attempt by American leaders to bring Enduring Freedom to a successful close. The course of this surge led to five conclusions. First, it highlighted the incongruity between the national strategic and operational levels of war, more publicly and openly than ever before. Second, it illuminated and corrected past difficulties in commanding and controlling Enduring Freedom. Third, it exposed problems in tactics, training, counterinsurgency doctrine, and force generation. Fourth, in the rush to train the ANSF, it would test the U.S. Army’s resolve in dealing with difficult subjects like violations of the laws of land warfare, insider attacks, and transitioning key responsibilities from U.S. to indigenous control during combat operations.\",\n    \"Finally, the surge highlighted the DoD’s inability to manage strategic communications effectively. This challenge began when senior administration officials replaced the incumbent ISAF commander on short notice and for reasons that were unclear to the general public. It was exacerbated by poor decision making on the part of senior personnel, which led to another ISAF commander’s resignation in the wake of a damning story filed by a journalist embedded with his command group. Throughout these incidents and thereafter, information operations specialists and public affairs personnel failed to keep pace with events. As they struggled to overcome conceptual and cultural barriers, the management of the public perception of the war would become more and more central to the war in Afghanistan.\"\n  ],\n  \"chapter 6\": [\n    {\n      \"title\": \"McKiernan’s War Ends\"\n    },\n    {\n      \"section\": [\n        \"Although U.S. forces had operated throughout Afghanistan since 2001, eight years later two-thirds of the 30,000 American troops committed to that conflict were concentrated in RC East. By early 2011, 106,000 American troops would be divided almost equally between RC East, RC South, and the newly formed RC Southwest. This increase and dispersion of U.S. forces led to American generals supplanting British, Canadian, and Dutch officers as commanders of RC South. By November 2010, Americans commanded three of the six regional commands (East, South, and Southwest). Even before Americans ascended to operational command, General David D. McKiernan used the pending surge to enhance unity of effort.\"\n      ]\n    },\n    {\n      \"title\": \"Unity of Effort\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"In early 2009, all American troops operated under CJTF-101, CSTC-A, or Special Operations commands. However, by the end of the year, they would be funneled under regional commands as part of the ISAF mandate. McKiernan moved to align U.S. forces by creating a new headquarters, designated as USFOR-A, to serve as the national command element. At the same time, McKiernan did not agree with the idea—favored by General David H. Petraeus at CENTCOM—of forming a similar headquarters for ISAF. While McKiernan recognized that command and control relationships were challenging for ISAF, he believed in less international command and control structure rather than more.\",\n        \"${The Campaign Plan: More Troops and Counterinsurgency}{bold}\",\n        \"While the U.S. military sought to improve its command and control deficiencies, other issues were more pressing. Increased enemy activity had prompted McKiernan to request more forces, particularly in southern Afghanistan. He initially asked for these forces during the last months of the Bush administration. As McKiernan waited for the request to be approved, he directed infrastructure to be built to support them. He also remained aware that to get approval for more forces, he needed a plan for what the requested troops would do. An update to his plan would also help get his units in step with the embassy’s plan for Afghanistan and further enhance unity of effort. To this end, McKiernan drafted an updated Civil-Military Campaign Plan designed to unite the efforts of the embassy and military actors.\",\n        \"On the military side, McKiernan believed that the regional commands were conducting independent campaigns and, even within some regional commands, national efforts were not coordinated. To establish unity of effort among the regional commands, McKiernan authorized a campaign plan known as ISAF Operation Plan 38302. After viewing the initial drafts, he added language from Field Manual 3–24 to the document. Each successive change to the order incorporated more counterinsurgency terminology. Shortly after issuing 38302, McKiernan revised his concept of operations in an ISAF operations order known as TOLO HAMKARI (Dawn of Cooperation, hereafter referred to as OP [Operation] TOLO). The second version (OP TOLO 2) and third revision (referred to as Revision 3 or Rev 3) to ISAF Operation Plan 38302 made greater strides toward achieving unity of effort.\",\n        \"OP TOLO sought to foster “support [for] the population of Afghanistan through an ISAF and the Government of the Islamic Republic of Afghanistan (GIRoA) partnership to build GIRoA capacity and credibility (legitimacy).” The campaign consisted of four lines of operation under which all subordinate efforts were to be nested. The regional commands used these lines to design their operations. The first was governance. In this line, ISAF and U.S. forces supported civilian agencies such as the State Department and the United Nations Assistance Mission in Afghanistan. The second line was security, for which ISAF was the lead. The third line was ISAF-supported, civilian-led reconstruction and development initiatives designed to better the lives of the Afghan people. The final line of effort, information operations and strategic communications, sought to illustrate how ISAF goals were aimed at ending the violence and helping Afghans transform their embattled country into a self-sufficient member of the global community.\",\n        \"With one exception, the lines of operation remained constant in the first three versions of OP TOLO. The only difference was that McKiernan emphasized securing the elections and characterized the enemy as an insurgency in OP TOLO 2. This order was the first official acknowledgment that an insurgency was the main threat in Afghanistan. Until this time, President Hamid Karzai had vehemently denied that an insurgency existed, noting that the term made his government appear illegitimate. Earlier versions of the order had reflected this reluctance to define the problem by inferring that only loose border security had provided the opportunities for foreign militaries to infiltrate the country. The mission before 2009 had not been about defeating an enemy, but “conducting military operations to assist” in securing the country. As the mission statement for ENDURING FREEDOM since 2007 awkwardly stated, U.S. forces were to “conduct military operations in the assigned Area of Operations (AOO) to assist the Government of Afghanistan (GOA) in the establishment and maintenance of a safe and secure environment with full engagement of ANSF, in order to extend GOA authority and influence, thereby facilitating AFG’s [Afghanistan’s] reconstruction and enabling the GOA to control the country.”\",\n        \"For the most part, American commanders in Afghanistan accepted that they were fighting an insurgency. For years, ENDURING FREEDOM documents had referred to the Field Manual 3–24 counterinsurgency terminology of shape, clear, hold, and build while ISAF orders focused on nation building. McKiernan insisted on adding the expression “Shape, Clear, Hold, and Build” to the OP TOLO concept of the operation, but was not successful in changing the mission statement to “conduct counterinsurgency operations.” Because counterinsurgency missions frequently required heavy investments in time and resources, NATO allies were hesitant to identify the mission as a counterinsurgency in their own documents.\",\n        \"McKiernan had misgivings about adopting the population-centric counterinsurgency approach used in Iraq. He interpreted Field Manual 3–24 as directing that he position most of his troops in urban areas and along the Ring Road (Afghanistan National Highway 1). To the ISAF commander, such a disposition was not applicable to Afghanistan, where the insurgency had its roots in rural tradition. This was a significant difference from Iraq, where the insurgency was largely an urban phenomenon. If Afghan and ISAF troops focused on the country’s fourteen largest population centers, the Ring Road, and main border crossing sites, no forces would be available to drive enemy forces out of their rural enclaves. McKiernan concluded that pursuing a population-centric counterinsurgency in Afghanistan meant ceding the initiative to the enemy.\",\n        \"Field Manual 3–24’s emphasis on population-centric counterinsurgency, coupled with Afghanistan’s compartmentalized terrain, created a difficult problem for McKiernan to overcome. Given the theater’s limited infrastructure, large troop increases would be a cost-intensive logistics challenge. Relying on lines of communications that traversed Pakistan presented another operational problem. CJTF-101 leaders had spread their available forces over an expansive operational area. This trend led to outpost garrisons becoming increasingly smaller, which made them more vulnerable to attacks by the enemy—such as in the assault at Wanat in 2008. By any definition, these battles were tactical defeats for the enemy with scores of insurgents killed. Despite this, they demonstrated that the Afghan insurgency still thrived while also using masterful strategic messaging to convince ordinary Afghans that the Taliban was winning. Even after inflicting repeated tactical defeats on the enemy, American commanders began pulling forces out of exceptionally vulnerable small outposts. Thus, when President Barack H. Obama assumed office, the coalition still had not regained the initiative from the Taliban’s 2006 resurgence.\",\n        \"${General McKiernan’s Requests for Forces}{bold}\",\n        \"The Pentagon had all but abandoned its system for generating forces for employment in the war on terrorism by the time McKiernan submitted a formal request for forces through CENTCOM. The Joint Operation Planning and Execution System had been a useful management tool to project which units were training, when they would be deploying, and where they would go. Now, as a result of the U.S. Army and Marine Corps being deployed nearly to full capacity, the Joint Staff required commanders to submit a detailed justification known as a Request for Forces. Although the Request for Forces process theoretically enabled commanders to request exactly what they deemed necessary, it allowed almost every agency in the approval chain to ask for additional clarifying data, which invariably resulted in lengthy delays.\",\n        \"Part of the problem lay with the inherently ad hoc nature of the force request system. First, the granularity of detail required to obtain approval for a unit to be deployed often overwhelmed the staffs and commands tasked with generating these requests. Second, the bureaucracy at every echelon up to the National Command Authority had the opportunity to delay the request for their staffing purposes. Finally, decision makers up to the president of the United States had the ability to approve or disapprove the Request for Forces. For McKiernan, the system resembled a valve that could be opened or closed to control the flow of troops, but would be opened only if a request satisfied every decision maker in the command chain. Instead of the services or the joint forces commander managing what was needed, McKiernan felt that a team of supervisors, with their hands on the valves, micromanaged a process that should have been executed by an operational commander in an efficient manner. The process being what it was, the final hand on the valve was the president. President George W. Bush had opened the valve partially at the end of his term, and now President Obama would assume responsibility for opening it further.\",\n        \"The 15 September 2008 Request for Forces Serial 920—known as RFF 920—stemmed from the shared assessment of the intelligence community that the enemy was moving back into RC South and that RC East needed more troops to secure Wardak and Logar Provinces, outside Kabul. McKiernan based the request strictly on his sense of where troops were needed prior to the elections. He assessed that the enemy would try to influence the Pashtun vote and focused his efforts there. RFF 920 justified the need for a battalion in Helmand and a battalion each in Wardak and Logar Provinces. The Bush administration approved the request, deploying a Marine Air-Ground Task Force configured around Lt. Col. David L. Odom’s 3d Battalion, 8th Marines, to Helmand Province and Col. David B. Haight’s 3d Brigade Combat Team, 10th Mountain Division, to RC East.\",\n        \"McKiernan modified his force request on 24 October 2008 to address three emerging problems. First, CJTF-101 aviation assets were overwhelmed by the need to provide rotary airlift for the whole of Afghanistan. A second combat aviation brigade would cover RCs South and West and allow the aviation brigade at Bagram to focus on RCs East, Capital, and North. Second, McKiernan specifically requested a Stryker brigade combat team to reinforce RC South. He argued that the wheeled Stryker would be effective in the region’s open terrain. Finally, he requested another brigade to deploy as trainers and mentors under CSTC-A. If approved, this last request would double their trainers from 3,000 to 6,000. The first two items were approved, but the request for trainers was denied, as the Bush administration wanted to let the next administration make that decision. That development left McKiernan with the belief that the Request for Forces process did not allow the deployed commander sufficient flexibility or responsiveness.\",\n        \"The request for an additional brigade of trainers and advisers had not been denied because McKiernan’s superiors felt that  additional troops were not needed. Both Chairman of the Joint Chiefs of Staff Admiral Michael G. Mullen and General Petraeus agreed that more “boots on the ground” were necessary in Afghanistan. As violence in Iraq declined and President Obama shifted focus toward the new Afghanistan-Pakistan policy, Operation ENDURING FREEDOM would no longer be an economy-of-force mission but rather the main effort. During a 23 March 2009 video teleconference with McKiernan, Petraeus, and the Joint Chiefs of Staff, Mullen stated: “2009 has to be the year we throw the kitchen sink into Afghanistan. [We m]ust generate progress and some early wins there. We’ll have to once again resource some of the civil surge. I need your best. [We] must arrest this thing this year. Afghanistan is highest priority.”\",\n        \"Petraeus noted Mullen’s reference to the military resourcing some of the civil surge. To Petraeus, this meant that expectations for the civilian side were limited and the military could now begin brainstorming other ways to “arrest this thing.” The idea of doing it all in 2009 seemed overly ambitious, given that additional resources necessary to fulfill Mullen’s proclamation would not be authorized for another eight months. The surge forces could not begin arriving until late 2009 and would not peak until 2011.\",\n        \"Although Petraeus openly agreed that the Pentagon should surge troops to Afghanistan, he saw Mullen’s assessment as a way  to attack as many of Afghanistan’s problems as he could imagine. Soon after Mullen’s suggestion about “throwing the kitchen sink” at Afghanistan, Petraeus listed twelve categories in his personal notebook:\",\n        {\n          \"list\": [\n            \"1. Elections\",\n            \"2. STRATCOM/ IO [strategic communications/information operations]\",\n            \"3. CN [counternarcotics]\",\n            \"4. Agricultural Development\",\n            \"5. Prisons\",\n            \"6. Rule of Law\",\n            \"7. Police Training\",\n            \"8. International Coordination\",\n            \"9. Counter Corruption\",\n            \"10. PRTs [Provincial Reconstruction Teams]\",\n            \"11. Health\",\n            \"12. Education\"\n          ]\n        },\n        \"Petraeus noted that several of these challenging problems lined up well with actors and resources. He put those in parentheses:  counternarcotics (Drug Enforcement Agency), agricultural development (Department of Agriculture), prisons (International Narcotics and Law Enforcement), rule of law (Department of Justice), and international coordination (Ambassador Richard C. Holbrooke). Other areas, such as countercorruption, health, and education, would require more robust support from the Afghan government because the coalition’s military and political resources would not be enough to address them. Some areas, interrelated to others, required visible countercorruption initiatives by the Kabul government and an information-operations effort to begin restoring the Afghan people’s faith in the election process. Petraeus thought in terms of interagency solutions and would push for those when politically opportune. Yet almost from the beginning, some of his programs were destined to achieve far less than desired because they faced resistance from the Taliban. Some also ran counter to fundamental aspects of Afghan culture or to the self-serving nature of the Karzai government.\",\n        \"With 21,000 additional forces authorized and the shift in priority from Iraq to Afghanistan underway, discussions at McKiernan’s headquarters increasingly focused on what missions to assign to the incoming troops. For the most part, enemy activity drove the decisions. An Estonian, British, and U.S. operation in Helmand Province revealed large numbers of IEDs placed to disrupt movement around the capital of Lashkar Gah. At about the same time, the Taliban targeted the Afghan Special Counter-Narcotics Police Force in separate incidents in the district surrounding the Helmand capital. Then, at the intersection of the Ring Road and Helmand River in the town of Girishk, home to the largest and most important bazaar in the province, a single raid netted half a ton of recently harvested opium. Afghan and coalition forces interpreted the increased use of IEDs and the attacks on the counternarcotics police as an effort to protect opium production in Helmand over the next poppy-growing season.\",\n        \"Based on this analysis, McKiernan directed a significant portion of the additional forces, primarily U.S. Marines, to combat the growing threat to stability in Helmand Province—the area at the heart of the illicit opium trade. McKiernan wanted the incoming troops to clear and hold this area until sufficient ANSF could be trained to secure the region. The ANSF, aided by ISAF, could mass forces to clear specific areas but lacked the forces and the logistics necessary to hold them. Soon after clearing any area, the enemy would return. A prime example in Helmand was the village of Babaji, north of Lashkar Gah, used as a transit point for Taliban fighters. In mid-February 2009, more than 700 Afghan, British, Danish, and Canadian troops had established a police station in the area. The operation was deemed successful, but shortly after the assault force departed, the Taliban reasserted control. That development should not have come as a surprise to ISAF commanders familiar with the Taliban’s tactic of falling back in the face of strength before returning when the odds were more favorable. The area had to be cleared again in June 2009.\"\n      ]\n    },\n    {\n      \"title\": \"Significant Operations in RC East, Early 2009\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"McKiernan’s justification for the surge shifted the primary effort from eastern to southern Afghanistan. RC East usually had been the American main effort since Operation ANACONDA. ISAF assumed responsibility for the other regional commands, but RC East remained under U.S. command. While the Marines surged into RC South in 2009–2010, RC East increased in size by one Army brigade combat team. In January 2009, Colonel Haight’s 3d Brigade Combat Team, 10th Mountain Division (TF SPARTAN), established operations with Lt. Col. Kimo C. Gallahue’s 2d Battalion, 87th Infantry (TF CATAMOUNT), in Wardak Province and Lt. Col. Daniel P. Goldthorpe’s 3d Squadron, 71st Cavalry (TF TITANS), in Logar Province. McKiernan detached the third maneuver battalion, Lt. Col. Frederick M. McDonnell’s 1st Battalion, 32d Infantry (TF CHOSIN), to Col. John M. Spiszer’s TF DUKE in Kunar Province. The rest of TF SPARTAN, including Lt. Col. Michael P. Gabel’s 4th Battalion, 25th Field Artillery (TF WOLFPACK); Lt. Col. Eugene A. Shearer’s 710th Brigade Support Battalion (TF SUPPORT); and Lt. Col. Steve Pitts’ Special Troops Battalion (TF VANGUARD), remained with Haight. These units represented the last expansions into new battlespace in RC East under McKiernan’s senior tactician in the region, CJTF-101 commander Maj. Gen. Jeffrey J. Schloesser.\",\n        \"Although the overall main effort would shift to RC South, it was vital to reinforce RC East before the marines arrived.  Violence had spiked in Wardak and Logar Provinces in 2008, and these provinces controlled the southern approaches to Kabul. As Brig. Gen. Mark A. Milley, deputy commanding general for operations of RC East, explained to Brig. Gen. Michael S. Tucker, deputy commanding general for ISAF operations:\",\n        {\n          \"list\": [\n            \"\\\"Kabul is the political center of gravity of Afghanistan and has been for centuries. The enemy is making a conscious effort to surround  Kabul and they project they can do this by end of year 2008. There are four historic approaches to Kabul. The Afghans call these the “gates to Kabul.”The enemy has set up support zones and is infiltrating additional combat power into these support zones that generally align with the approaches and associated districts. From these support zones the enemy plans to launch a steady and increasingly deadly series of spectacular attacks into Kabul— that campaign has already begun. Additionally, from these support zones, the enemy plans to cut the GLOCs [ground lines of communications] (principally Ring Road but other feeder hardball roads as well) leading to Kabul and connecting Kabul to Kandahar. That campaign has also already begun in earnest.  If we get an additional IBCT [Infantry Brigade Combat Team] we will have sufficient combat power to secure the high density population areas; really secure Highway 1 and associated roads; conduct aggressive offensive operations in enemy support zones; and concentrate adequate forces to interdict enemy rat lines from Pakistan border. By positioning the forces in RC-East we will have the second and third order effect of increasing the confidence of the Afghan Government, morale and skill of the ANSF, and concurrently demoralize the enemy because he will realize that his objectives are not achievable.  Our estimate is that the war will be won or lost in RC-East. RC-South is important but the war will not be won or lost in that area of operations. The decisive fight is in RC-East as it has been throughout Afghan history.\\\"\"\n          ]\n        }\n      ]\n    },\n    \"This statement, in advocating for forces in Wardak and Logar Provinces, revealed another idea about where the main effort should be located. While ISAF was shifting to RC South, there were those who fervently believed RC East was still the pivotal fight in Afghanistan.\",\n    \"${The American Shift to Counterinsurgency Gains Traction}{bold}\",\n    \"After attempts by Lt. Gen. Karl W. Eikenberry and General Dan K. McNeill to pursue enemy forces where they were strongest and McKiernan’s desire to win the support of the people of Afghanistan’s hinterlands, RC East was characterized by small units occupying combat outposts along regional lines of communications. Many of these outposts, which numbered 101 upon Schloesser’s arrival in April 2008, were supportable only by airlift. Day-to-day operations at the tactical level included trying to reach the population to assess their needs to gain access for Afghan officials or nongovernmental organizations to provide basic services, secure elections, and gain intelligence on the enemy. As the enemy began to step up attacks on the American positions, these tactical units began to shift more toward combat missions in the form of raids, interdiction, and clearing operations. All of these often took the form of air-assault operations as mounted ground movements became more dangerous over time with the growth in size of IEDs and the limited number of trafficable roads in the restrictive, mountain terrain. These operations put a further strain on the already overworked aviation units.\",\n    \"With the deployment of the 3d Brigade, 10th Mountain Division, to Wardak and Logar Provinces, three American infantry brigade combat teams were now in RC East. Schloesser focused these brigade combat teams in three contiguous areas. While TF SPARTAN covered the southern and western approaches to Kabul, TF DUKE secured the four provinces of Nangarhar, Nuristan, Kunar, and Laghman in the northern zone. In the southern portion of Schloesser’s regional command, the 4th Brigade, 25th Infantry Division, would replace 4th Brigade, 101st Airborne Division (Air Assault), to secure Paktiya, Paktika, and Khost Provinces. Predictably, these border provinces endured the most enemy activity and required the most attention from the Americans. In addition to the three infantry brigades, RC East included the Polish Task Force WHITE EAGLE in Ghazni Province; Col. Scott A. Spellmon’s 1st Maneuver Enhancement Brigade (TF WARRIOR) in Bamyan, Parwan, and Panjshir Provinces; and the French Task Force LAFAYETTE operating in both Kapisa Province and the Sarobi District of Kabul Province.\",\n    \"The addition of TF SPARTAN pushed the personnel strength of RC East to more than 20,000, up from approximately 15,000 one year earlier. However, RC South workforce totals surpassed RC East for the first time, reaching more than 22,000. From February 2009, RC South would grow faster than RC East. RC East would lose its status as the main effort by the end of 2009 and would have a lower troop strength than the south until the end of the subsequent surge instituted by President Obama. Although it was now a supporting effort, RC East would grow in strength by another third, maxing out at approximately 30,000 troops. The reinforcement enabled ISAF to extend its reach into many small combat outposts where ISAF troops could target insurgents more effectively, even though bases located far from population centers provided only marginal support to counterinsurgency efforts. Initial deployments into places like the Pech River Valley led to commanders venturing into sparsely populated tributary valleys in search of an elusive enemy. Experiences like those at Combat Outposts RANCH HOUSE and BELLA, as well as Wanat in 2008, indicated that lack of adequate intelligence, surveillance, and reconnaissance assets at key times made smaller outposts vulnerable to surprise attacks. Commanders subsequently withdrew their troops from a number of isolated bases to minimize tactical risk in the face of an evolving threat while simultaneously placing more emphasis on population-centric counterinsurgency by moving displaced units closer to larger villages and towns.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-6-1.svg\",\n        \"caption\": \"CJTF - 101 Regional Command East\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_6-1.png\",\n        \"caption\": \"Soldiers of Company C, 1st Battalion, 26th Infantry\"\n      }\n    },\n    \"In spite of these challenges, coalition forces in RC East continued to secure the area surrounding Kabul and the most  contentious provinces on the Pakistan border. While other units in RC East conducted operations to disrupt the enemy, TF SPARTAN deployed into Wardak and Logar Provinces to secure roads. Afghanistan National Highway 1 (the Ring Road) approached Kabul through Wardak, and Highway 2 connected Kabul with Pakistan through Khost Province. Thus TF SPARTAN operations, both lethal and nonlethal, focused first on clearing and securing and then on building the roads. As Haight reflected:\",\n    {\n      \"list\": [\n        \"'[M]y top three development priorities were roads, as number one; number two was roads; and number three was roads. And if I  had a four, five, and six, they would have been roads—not literally, but I used to make a joke and say, “I like libraries, I like clinics, I like schools, and I like all those things, but I would turn them all in for one more mile of road.” . . . [R]oads were the most important thing because they fix their economy.'\"\n      ]\n    },\n    \"For the first half of 2009, the remaining brigades focused on “ANSF partnering and mentoring with the two Afghan major commands in RC East, the 201st Corps and 203rd Corps.”\",\n    \"Prior to this troop increase, the mission of ISAF forces in Afghanistan had always been conveyed as full spectrum operations.  After the initial troop increases, this mission would formally change to counterinsurgency operations. The difference in the terms was subtle but important. Counterinsurgency operations indicate the presence of an enemy insurgency, whereas full spectrum operations convey a broad range of military activity from humanitarian assistance to high-intensity conflict. Counterinsurgency also came to mean coordinating efforts from outside the military as well. In any event, until April 2009, Schloesser’s mission statement for RC East was:\",\n    {\n      \"list\": [\n        \"\\\"In conjunction with the Government of the Islamic Republic of Afghanistan (GIRoA), NATO ISAF, and the Interagency  [i.e., other U.S. governmental agencies outside of DoD], RC-(E[ast])/CJTF-101 conducts full spectrum operations to develop Afghan national capability to secure its people, exercise capable governance, and develop a sustainable economy, while defeating terrorists and insurgents, in order to extend GIRoA authority and influence as the legitimate government of the Afghan people.\\\"\"\n      ]\n    },\n    \"In April 2009, following the publication of McKiernan’s OP TOLO 2, the American-led RC East (but not the other regional commands)  would change its mission to:\",\n    {\n      \"list\": [\n        \"Regional Command (East), in close coordination with the Government of the Islamic Republic of Afghanistan (GIRoA), joint, interagency, and multinational partners, conducts counter-insurgency (COIN) operations from 01 APR 09 until the continuance or transfer of constitutional power following the 2009 Afghan Presidential election, in order to improve GIRoA’s capacity to provide security, exercise good governance, develop a sustainable licit economy, and improve the quality of life for the Afghan people.\"\n      ]\n    },\n    \"The success of the Iraq surge, coupled with the Riedel Report and the elevation of Petraeus to CENTCOM commander, influenced the change in the RC East mission to conduct counterinsurgency operations. Securing the elections justified additional forces for RC East. As General Milley explained to General Tucker, Kabul had to be secured for the upcoming elections to be successful.\",\n    \"To enable a shift to a counterinsurgency approach, McKiernan ordered CJTF-101 to relinquish National Support and Command Element responsibilities in April 2009 to USFOR-A, which had been established for exactly that purpose. This transfer allowed the leaders of RC East to focus on the tactical fight.\",\n    \"Although the upcoming elections were supposed to remain the priority for the remainder of the summer, everyone in RC East soon found themselves shifting focus for a completely different reason. At the end of June 2009, Pfc. Beaudry Robert “Bowe” Bergdahl of Lt. Col. Clinton J. Baker’s 1st Battalion, 501st Infantry, disappeared from his base in Paktika Province and was seized by the Taliban. The search for Bergdahl drove operations in RC East for months to come. The diversion of significant resources to that effort would have a major impact on the campaign in Afghanistan for the duration of the search.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-6-3.svg\",\n        \"caption\": \"Regional Command East Transfer of Authority\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"Helicopters were in critically short supply before the deployment of a second combat aviation brigade as part of McKiernan’s most recent request for forces. This scarcity increased after Bergdahl’s disappearance. Almost all units in RC East began conducting additional operations—requiring rotary-wing aircraft; unmanned aerial vehicles; and intelligence, surveillance, and reconnaissance assets—to locate the missing soldier. The search for Bergdahl continued throughout July and into August 2009, when the main effort for all forces in Afghanistan returned to securing the 20 August 2009 elections. These two events—the search for Bergdahl and security preparations for the elections—consumed the second half of the Afghan fighting season.\",\n    \"Another factor influencing operations at the time was the rapid turnover of units. Relief-in-place missions are highly disruptive to campaigns. As in previous years, most Army units deployed to Afghanistan on an annual deployment cycle. CENTCOM and providing commands staggered brigades so that they did not all change at once, which resulted in a constant churn of units coming and going. Most often, the brigades serving in Afghanistan did not serve under their normal stateside divisional headquarters, which meant that they had to take time to become familiar with command structure and practices of their newly assigned higher headquarters.\",\n    \"The one brigade combat team that was aligned under its stateside command—the 4th Brigade, 101st Airborne Division (Air Assault)—had redeployed in March 2009, leaving the rest of the units in RC East populated by soldiers from different divisions. This arrangement was indicative of how modularity supported contingency operations; brigades were supposed to be able to serve under any division headquarters. Although this state of affairs was normal in Operation ENDURING FREEDOM, it gave the divisional team no time for team building. Units, staffs, and commanders often had to develop relationships while conducting combat missions. The Army had adopted modularity so it could “plug and play” units at the brigade combat team level, a structural change that generated flexibility, enabled independent operations, and simplified sustainment. The success of modularity appeared evident in the fact that all brigade combat teams came from different divisions, but the actual situation on the ground challenged Army leaders who were already struggling through a coalition environment that made it difficult to conduct coherent operations.\",\n    \"TF SPARTAN (3d Brigade, 10th Mountain Division) continued securing and clearing its new area throughout 2009 while the other task forces were relieved in place. Task Force YUKON (4th Brigade Combat Team, 25th Infantry Division), under the command of Col. Michael L. Howard, had relieved Col. John P. “Pete” Johnson’s 4th Brigade, 101st Airborne Division (Air Assault), (TF CURRAHEE) in March 2009. On 3 June 2009, Maj. Gen. Curtis M. Scaparrotti’s 82d Airborne Division replaced General Schloesser’s 101st Airborne Division (Air Assault) and reflagged as Combined Joint Task Force 82 (CJTF-82). Just after CJTF-82 arrived, Col. Randy A. George’s Task Force MOUNTAIN WARRIOR, 4th Brigade, 4th Infantry Division, relieved Spiszer’s TF DUKE. The high tempo of units being replaced while searching for Bergdahl and preparing for elections dominated RC East during mid-2009. After the elections, RC East units focused on partnering with and preparing ANSF for transition, and the main effort was to shift to RC South. Simultaneously, the mission changed to conducting counterinsurgency operations.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_6-2.png\",\n        \"caption\": \"RC East Soldiers\"\n      }\n    },\n    {\n      \"title\": \"McKiernan Chooses Helmand\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"During the debate over whether or not to embrace population-centric counterinsurgency, some in the Obama administration began to question  why so many troops had been deployed to sparsely populated Helmand Province, and why that effort rested primarily on the shoulders of the U.S. Marine Corps. Certainly, Petraeus’ map of enemy activity in 2008 helped explain the choice of Helmand. General McKiernan painted a more straightforward picture of why the marines had been assigned to Helmand:\",\n        {\n          \"list\": [\n            \"\\\"Now despite a lot of writings and people saying they decided where they [additional forces] would go, I can categorically tell  you that I personally decided where they would go and briefed that as part of the Request for Forces process—briefed it and got concurrence from the Afghan Ministry of Defense and ultimately briefed it to President Karzai . . . it was a top-down approach of my saying I need these additional capabilities in these particular areas, south, particularly in the Helmand River Valley. \\\"\"\n          ]\n        },\n        \"According to McKiernan’s reasoning, of the two contentious areas in RC South, the smaller problem should be solved first. To provide coalition forces momentum, he sent the marines to Helmand Province. Even though Helmand had extensive poppy fields and had witnessed the most violent insurgent events in 2008, it was a barren land without the cultural and historical importance of Kandahar Province. McKiernan also believed that a long, drawn-out battle in Kandahar just before the elections would not be wise. He lobbied and vetted his proposed troop-deployment locations with the RC commanders, who all felt they would receive additional forces and deploy them as they saw fit. Most importantly, McKiernan vetted his ideas with the RC South commander, Dutch Maj. Gen. Mart de Kruif, who consented to the plan.\",\n        \"The military command in Afghanistan delineated the plan to reinforce RC South in Operations Order 1 for 2009. This document orchestrated the deployment of the combat aviation brigade and Stryker brigade combat team under USFOR-A. It accepted the Marine Expeditionary Brigade–Afghanistan as a voluntary national contribution to ISAF. As ISAF commander, McKiernan delegated NATO tactical command of the expeditionary brigade to RC South. This command relationship allowed de Kruif to designate local control measures and delegate tactical tasks, but prevented him from reorganizing or dividing the Marine brigade. U.S. Marine Corps Forces Central Command in Tampa retained operational control of the unit. To change Marine Expeditionary Brigade–Afghanistan’s task organization, the Marine component commander in Tampa would have to issue the necessary order.\",\n        \"This decision conferred unprecedented authority to someone outside the authority of the joint force commander. It reflected the fact that the modern U.S. military placed as much emphasis on institutional legacy as it did on efficiency when waging war. Considering that the marines operated under similar conditions in Iraq’s Al Anbar Province from March 2004 through January 2010, the decision should not have come as a surprise. Service parochialism, in addition to coalition considerations, had colored U.S. involvement in Afghanistan since the conflict began and continued to complicate the fight. Secretary of Defense Robert M. Gates would reflect that not breaking these institutional barriers was “my biggest mistake in overseeing the wars in Iraq and Afghanistan.” In Gates’ mind, service inflexibility affected the conflict in negative ways.\",\n        {\n          \"list\": [\n            \"\\\"We knew pretty early on—maybe a year in for me [2008]—that the command and control in Afghanistan was all screwed up—that the commander of ISAF, who was an American, did not have command of all the American troops. . . . It was really convoluted, in terms of the command authority of the Marines, because the Marines were actually under the command of a three-star in Tampa, and then back to the Pentagon.\\\"\"\n          ]\n        }\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-6-m.svg\",\n        \"caption\": \"Regional Command South\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"The contorted command relationship in RC South derived from Marine Corps doctrine. The standard task organization of Marine Corps forces since 1952 had been the Marine air-ground task force, consisting of a command element, ground combat element, air combat element, and a logistics combat element. The task force is considered indivisible, fighting in a single battlespace. The sanctity of the U.S. Marine Corps doctrine had been a recurrent thread in previous campaigns, most recently in Operation DESERT STORM where U.S. Marine Corps Forces Central Command retained control over its air combat element after putting up spirited opposition to the Air Force’s view that all aviation in a theater should be under a single joint-force air component command.\",\n    \"Key to the Marine Corps view of operations was the concept of “single battle.” The operational commander must have the authority to use forces as necessary. Within that concept, a Marine air-ground task force commander conducts central planning and enables decentralized execution. As noted in the current version of Marine Corps Doctrinal Publication 1–0, Marine Corps Operations, “a commander must view his area of operations as an indivisible entity.” Although Marine doctrine allows an air-ground task force to be spread over a noncontiguous area of operations, it assumes that the combat force is operating alone. As part of a larger joint ground campaign, Marine Corps forces fought within a single contiguous area, as had been the case in Kuwait during DESERT STORM or in Al Anbar Province during IRAQI FREEDOM. Planners in Afghanistan, the Pentagon, and Tampa took a contiguous area of operations as an article of faith, recognizing that separating the components of Marine Expeditionary Brigade–Afghanistan would have been a deal-breaker for the marines’ deployment to Helmand.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_6-3.png\",\n        \"caption\": \"U.S. Army UH-60 helicopters airlift Marines\"\n      }\n    },\n    \"${Counterinsurgency}{bold}\",\n    \"The U.S. Marine Corps caveats to its deployment into RC South revealed other differences of opinion within the coalition ranks. The United States and the other ISAF nations had adopted operational language that suited their domestic audiences but was incongruous with their allies in Afghanistan. In particular, some ISAF nations disagreed with the population-centric counterinsurgency methods that Petraeus had pursued in Iraq. In early 2009, there would be no official use of the term “counterinsurgency” outside of American commands. Thus, the mission for the incoming forces was to “reinforce Coalition Forces in RC-South with an increase in enduring ground and air/aviation forces beginning no later than 31 March, 2009, in order to ensure success of the ISAF mission in Afghanistan.”\",\n    \"The command of RC South rotated among Canada, Great Britain, and the Netherlands every six months. Dutch General de Kruif had been appointed in late 2008 with the agreement that his tour would last one year to provide continuity. No discussion of changing the mission statement would take place without the North Atlantic Council first agreeing to change it. To nations like the Netherlands, counterinsurgency was an operational paradigm that indicated a larger commitment than they felt was politically acceptable.\",\n    \"McKiernan understood these political considerations. He had not yet rewritten the ISAF mission for several reasons. Neither the North Atlantic Council nor ISAF had officially recognized counterinsurgency as the mission in Afghanistan. Some key players, including Karzai, denied the existence of an insurgency. McKiernan recognized that changing the mission statement would require lobbying coalition nations individually, something he could not do as theater commander. Instead, McKiernan tried to shift operational language toward counterinsurgency gradually. In June, RC South Operations Order 09–07 echoed the language of a counterinsurgency approach by stating that the mission was to neutralize the insurgency, but did not use the specific phrase “conduct counterinsurgency operations.” To make matters more confusing, the order for RC South described the enemy as “a networked movement with diverse motivations aimed at the overthrow of the elected Government of the Islamic Republic of Afghanistan through the use of subversion and armed conflict in order to establish local authority in support of their aims such as the reestablishment of a Taliban government.” Thus, the order employed a classic Western definition of an insurgency without calling it as such. In the same vein, it labeled the enemy’s most dangerous course of action as coordinated attacks to disrupt the upcoming Afghan elections. The order predicted that opposing forces would most likely continue their disjointed and unpredictable attacks on soft vehicle targets to “dissuade contractors and the local populous [sic] from supporting ISAF/GIRoA [Government of the Islamic Republic of Afghanistan] operations” and to steal voter registration materials. In either case, the tactics employed would be those used by insurgents working to overthrow a legitimate government. McKiernan’s careful use of language indicated that the term “counterinsurgency” was still controversial to coalition members, who regarded their role in Afghanistan largely as part of a stabilization and reconstruction mission, not as combatants in a protracted war. At the same time, the Americans had been conducting counterinsurgency operations (since 2002, according to some) and, as the lead nation in ISAF, began to infuse counterinsurgency methods and terminology into ISAF language and orders. McKiernan was able to integrate counterinsurgency doctrine into ISAF Order 001-2009, which was synonymous with the USFOR-A order. This change was a shift in thinking and a significant movement toward unity of effort.\",\n    \"The American forces may have regarded counterinsurgency as relatively benign in comparison to high-intensity combat operations against a conventional regional foe, but several ISAF member nations had far different perspectives on their own activities in Afghanistan. In the past, these countries had used morally questionable methods against insurgents seeking to gain independence from European rule, and they were not inclined to repeat this approach in their current military ventures. A few nations, most notably Germany, faced legal constraints to their use of military power abroad. Although European parliamentary members and their constituents were willing to support sustained peace-enforcement operations in conflicts like that in the Balkans, they would not countenance aggressive combat operations that caused either friendly or civilian casualties. The Americans, by contrast, had first entered Afghanistan in response to the September 11th terrorist attacks, and were much more willing to model their counterinsurgency approach after their successful experiences in Iraq during the 2007–2009 timeframe.\",\n    \"${Change of Command}{bold}\",\n    \"Thousands of troops began to arrive in RC South, prepared to carry out the counterinsurgency mission that the Obama administration hoped  would provide greater security and stability to Afghanistan and its beleaguered central government. Even as the new forces began deploying in April 2009, Gates felt that he needed to solve another problem important to both Karzai and Obama: civilian casualties. He agonized over how to make the necessary corrections: “I don’t believe any military force ever worked harder to avoid innocent victims, but it seemed like every incident was a strategic defeat and we needed to take dramatic action.”\",\n    \"McKiernan’s resistance to a new command and control model—combined with some unease with the general—led Gates to consider  if McKiernan was the best choice to command ISAF. McKiernan had been selected at the recommendation of the military’s highest authorities and was well-respected within the Army; nonetheless, the secretary felt he was not the best officer available: “I told Mullen, ‘I’ve got kids out there dying, and if I don’t have confidence I have the very best commander, I couldn’t live with myself.’”\",\n    \"At the time, Admiral Mullen was looking to change the trajectory of the war. He ordered CENTCOM and the Joint Staff to assess the strategy in Afghanistan and the overall CENTCOM area of responsibility. One result of this assessment was the Afghan Hands program, later called AfPak Hands. Brig. Gen. Austin S. “Scott” Miller and Brig. Gen. Michael T. Flynn created the program to subject the best officers from all services to intense culture and language training to generate expertise and a continuous knowledge base. The AfPak Hands were to be assigned to mentor Afghan leaders in the region for one year, return stateside for a year, and then deploy again to the region on a regular basis. In theory, the program looked promising, but in the end, many of the services’ best and brightest did not participate because they were reluctant to venture off proven career tracks. Indeed, it is not apparent if those that did were rewarded with promotion and opportunity. Even before the AfPak Hands initiative, the Joint Staff, led by its then director Lt. Gen. Stanley A. McChrystal, had shifted its focus from Iraq to Afghanistan and Pakistan. It was during this period that McChrystal emerged as the “heir apparent” for Afghanistan.\",\n    \"The U.S. Army’s decision to accept a counterinsurgency framework in Afghanistan did not quell fighting in RC South. More troops were still needed, but unbeknownst to McKiernan, he would retire before the forces he had requested were fully deployed. The first inkling that his command was in jeopardy emerged in March 2009, when Chief of Staff of the Army General George W. Casey Jr. asked McKiernan if he had a good relationship with the chairman of the Joint Chiefs of Staff. McKiernan replied, “Yeah, I think so,” before realizing something was awry. A month after Casey talked with McKiernan, Under Secretary of Defense for Policy Michèle A. Flournoy visited Afghanistan. When she returned, Flournoy told Gates that McKiernan might not be the best man for the job. The specific concerns she raised paralleled his own.\",\n    \"Admiral Mullen and Secretary Gates had come to agree with Petraeus that the United States needed a three-star operational headquarters between ISAF and the regional commands. McKiernan’s resistance to changing the ISAF command structure continued to irritate the Pentagon’s two senior leaders. Putting a layer of command between him and the troops seemed unnatural to McKiernan, and he candidly made his thinking known. By his own admission, McKiernan spent most of his time and energy working laterally and down, not higher. It was a noble sentiment, but it did not endear him to political leaders who had banked their reputations—and their country’s—on the outcome of the prioritized operations in Afghanistan in April. The discussion in Washington, D.C., came to a head when Mullen sought to convince McKiernan to retire of his own accord. Taken aback, McKiernan told Mullen that he had promised the Afghans and others that he would command at least until 2010, and if he and the secretary wanted to replace him, they would have to fire him. Gates spoke to Obama “on several occasions privately,” and the president backed recommendations from Gates, Petraeus, and Mullen to replace McKiernan with McChrystal. Notably, Casey opposed the move, calling it a “rotten thing to do.”\",\n    \"In the end, the decision was Obama’s, and despite the “political ruckus caused by firing the senior commander in the war . . . he was willing to make the change.” On 6 May 2009, Gates flew to Kabul and informed the ISAF commander who “acceded with extraordinary dignity and class.” According to Gates, “Relieving McKiernan of command was one of the hardest decisions I ever made. He had made no egregious mistake and was deeply respected throughout the Army.” The official record notes that the secretary of defense accepted McKiernan’s resignation on 11 May 2009. In reality, McKiernan had been fired.\",\n    \"Despite rumors that he was too conventionally minded for the complex environment of post-Taliban Afghanistan, McKiernan had accomplished a great deal. His initiatives included many things later attributed to others. He had simplified command and control by standing up USFOR-A to relieve CJTF-101 of extraneous Title 10 (i.e., Army support to all services in the Afghan theater) responsibilities. He had developed the basing and reception initiatives needed to enable the surge. He had piloted the Afghan Public Protection Program, which morphed into the Afghan Local Police in Logar and Wardak Provinces. McKiernan also initiated the first Civil-Military Campaign Plan. Signed by McChrystal in August 2009, the document presented a request to surge some 2,000 civilian governance and development experts to Afghanistan so as to accelerate reconstruction efforts.\",\n    \"In a 2015 interview, McKiernan reflected on lessons drawn from his experience as the ENDURING FREEDOM commander. Chief among them was the need for campaign planning to harness all elements of national power into the overall strategy. McKiernan also felt that America’s NATO allies had been drawn into Afghanistan too quickly and given far too much to do. The coalition, including the United States, lacked understanding of Afghanistan and the region. Its inadequate ways to deal with enemy sanctuaries proved impossible to remedy. Additionally, the Americans’ tendency to speak with Karzai through multiple voices—the ISAF commander, Ambassador Holbrooke, other ambassadors, congressional delegations, and the like—distracted from strategic and diplomatic coherence. Finally, McKiernan believed that there was not enough time to build institutions that would last long enough to resonate with Afghans.\",\n    \"General McKiernan noted that American and allied solutions for Afghan problems were inadequate because top-down, international initiatives outweighed bottom-up, Afghan-centric approaches like the Public Protection Program and Local Police. A key example was the constant focus on the size of the Afghan National Security Forces. While quantity was important, McKiernan felt that the quality of leadership was more important and time would be required before a solid cadre of officers could be developed. Even with McKiernan’s abrupt departure, the campaign plan had been developed and postured to attain its strategic objectives. Regardless of which person was in command, the multiyear campaign plan would continue to shape U.S. and ISAF operations in Afghanistan.\"\n  ],\n  \"chapter 7\": [\n    {\n      \"title\": \"McChrystal’s War\"\n    },\n    {\n      \"section\": [\n        \"On 11 May 2009, General David D. McKiernan left Afghanistan. His replacement, General Stanley A. McChrystal, would not arrive in country until 15 June. McChrystal had served as Admiral Michael G. Mullen’s director of the Joint Staff, responsible for briefing the chairman on developments in Afghanistan on a daily basis in addition to his many other duties. Despite the five-week gap between McKiernan’s departure and his successor’s arrival, ISAF published Operations Plan 38302 Revision 3 on 1 June 2009 with McKiernan’s signature in absentia. These revisions incorporated the shape, clear, hold, and build language of Counterinsurgency (Department of the Army Field Manual 3–24) in its execution paragraphs, but stopped short of changing the mission statement to “conduct counterinsurgency operations.”\"\n      ]\n    },\n    {\n      \"title\": \"McChrystal’s Assessment and Opening Moves\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"McKiernan’s relief changed ISAF’s conduct of the war. McChrystal’s first task upon arriving in Afghanistan was to assemble the  people he needed to assess the situation on the ground. The officer in charge of the ISAF commander’s critical Strategic Advisory Group, Col. Gordon B. “Skip” Davis, had already selected qualified military officers and credentialed scholars to guide the assessment. However, McChrystal preferred U.S. Army officers with Afghanistan experience with whom he had previously served. Davis was replaced by Col. Kevin C. Owens, who had commanded the 173d Airborne Brigade in a previous tour of duty. Col. Christopher D. Kolenda, who had commanded a battalion in Nuristan in 2007, joined Owens. Owens and Kolenda began framing McChrystal’s assessment with members of McKiernan’s remaining staff. Colonel Owens noted the tension:\",\n        {\n          \"list\": [\n            \"\\\"When I came over here [to ISAF headquarters], there was some scar tissue in the force—in the headquarters particularly—but also  in the force. Maybe [there was] some resentment in the change [due to] personal loyalty, and that [is] always going to happen . . . the “old team” felt like it was part of the problem. There was also this perception that this “A team” of handpicked guys was here to take over. I’ve never considered myself a “handpicked” guy. Plus it was a U.S.-only team. This created a palpable resentment when we came on board, and frankly, we probably reinforced it at times, whether consciously or otherwise.\\\"\"\n          ]\n        },\n        \"Whereas McKiernan had been hamstrung by an awkward relationship with General David H. Petraeus (who had been his subordinate years before),  a resistance to changing the command structure, and a lack of resources, McChrystal enjoyed a stellar reputation from his previous work in the special operations community and as director of the Joint Staff. He had a positive relationship both with Mullen and with Secretary of Defense Robert M. Gates, who believed McChrystal would bring synergy to the fight. It also helped that the additional troops McKiernan had requested were arriving. McChrystal planned a listening tour, or battlefield circulation, of Afghanistan beginning on 18 June, before he formally received the orders to begin his assessment. The week-long tour included visits to every regional command headquarters and selected lower-echelon locations. Both the assessment team in Kabul and McChrystal’s traveling entourage focused on three basic questions: Can the mission be achieved? If so, how should ISAF accomplish it? Finally, what is required to achieve the mission?\",\n        \"The initial findings were disquieting. It seemed to McChrystal that there were different wars being fought against different insurgencies  in Afghanistan. The Taliban had taken advantage of local grievances and broken government promises to maintain and strengthen their presence on the ground. McChrystal saw this perceived enemy strength as a weakness to exploit. He believed that effective local governments that relied on and were strengthened by a strong national government would be more effective than firepower when it came to defeating the enemies of Afghanistan. He expressed this same belief in his memoirs: “The introduction of minimally decent and competent governance could cause the local resistance to wilt.”\",\n        \"Although this emphasis on governance was not new, McChrystal’s determination to devote more attention to protecting the populace than finding and killing the enemy was a notable shift in the American operational approach. As McChrystal knew, reducing violence would limit collateral damage. After seeing how Afghan populations responded to civilian casualties from an errant airstrike, he realized that “the instinctive way we reacted to alleged incidents made it worse . . . Afghans viewed our skepticism about the validity of their claims as obfuscation, even if we followed our comments with thorough investigations.”\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_7-1.png\",\n        \"caption\": \"General McChrystal\"\n      }\n    },\n    \"The listening tour predated McChrystal’s formal instructions from the Pentagon. On 26 June, Secretary Gates directed CENTCOM commander Petraeus to order McChrystal to conduct an assessment within sixty days upon his assumption of command. On 1 July, NATO issued similar instructions to McChrystal from both Secretary General Jaap de Hoop Scheffer and the Supreme Allied Commander Europe General Bantz J. Craddock. On 2 July, McChrystal received the written order from CENTCOM for the same purpose.\",\n    \"McChrystal wasted no time, immediately implementing a new tactical directive and issuing guidance to reduce civilian casualties. He also began to establish the three-star headquarters desired by Petraeus and Gates. The new command was called ISAF Joint Command (IJC) under American Lt. Gen. David M. Rodriguez, who had served under Mullen on the Joint Staff before taking on this assignment. In November, McChrystal also created NATO Training Mission–Afghanistan (NTM-A) under American Lt. Gen. William B. Caldwell IV to unify NATO and U.S. efforts in building Afghan security forces. Caldwell would continue to command CSTC-A as the U.S. training headquarters. McChrystal utilized his expertise in special operations to initiate changes to first American and then coalition special operations so as to unify their command structures.\",\n    \"McChrystal ordered Revision 4 of COMISAF (Commander ISAF) Operations Plan 38302 to change the mission statement to “conduct population-centric counterinsurgency operations.” It would take several months for this alteration to be approved, as NATO political realities continued to impede American attempts to change the direction of the conflict. Revision 4 adjusted the concept of McKiernan’s four lines of operation, removing information operations and dividing security into three separate lines: protect the population, enable ANSF, and neutralize malign influence. The updated lines of operation now consisted of:\",\n    {\n      \"list\": [\n        \"1.  Protect the population\",\n        \"2.  Enable Afghan National Security Forces\",\n        \"3.  Neutralize malign influence\",\n        \"4.  Support governance\",\n        \"5.  Support development\"\n      ]\n    },\n    \"The new order needed North Atlantic Council approval, which would not be granted until McChrystal completed his strategic assessment.  Because the new ISAF commander had started the assessment while serving as the director of the Joint Staff, he was armed with a perspective that others may not have had—namely, an understanding of the issues that most concerned the political leadership in Washington. McChrystal requested directives from NATO and CENTCOM to unify the command structure and make his mandate clear: as commander of all U.S. and ISAF forces, he would assess the situation and recommend a way to achieve end-state goals for Afghanistan. Even before he finished his assessment, McChrystal realized that the situation was worse than he thought when he had worked at the Pentagon. Gates learned of this new appraisal when Mullen returned from a trip to Afghanistan in mid-August 2009 and warned the secretary that there would likely be a request for up to 40,000 more troops above the 68,000 already authorized. In response, Gates stated, “I nearly fell off my chair.” Although the secretary could not imagine what all those troops would do, McChrystal could. With nearly half of Helmand’s districts under Taliban control, elections postponed until the fall, and casualty rates accelerating, McChrystal perceived the need for a major shift in both strategy and resources. Even before he submitted his official assessment, he began changing the course of the war.\",\n    \"On 6 July, McChrystal implemented changes to reverse Afghan impressions about the degree to which ISAF cared about civilian casualties.  He coined the term “courageous restraint” while personally authoring parts of a new tactical directive. Key sentences from the document summarized his intent and provided insight as to what his assessment recommended:\",\n    {\n      \"list\": [\n        \"\\\"We will not win based on the number of Taliban we kill, but instead on our ability to separate insurgents from the center of gravity—the people.  That means we must respect and protect the population from coercion and violence—and operate in a manner which will win their support. . . . We must avoid the trap of winning tactical victories—but suffering strategic defeats—by causing civilian casualties or excessive damage and thus alienating the people.\\\"\"\n      ]\n    },\n    \"From McChrystal’s perspective, commanders would need to exercise “courageous restraint” when they weighed the possible gains of using close air support and other weapon systems to attack enemy fighters against the likelihood that such methods would harm civilians and further damage Afghan support for the ISAF mission. In a counterinsurgency campaign, as one NATO press statement read, “sometimes the most effective bullet is the bullet not fired.”\",\n    \"McChrystal formally transmitted his assessment to CENTCOM on 30 August 2009. It began by acknowledging that coalition forces aimed to disrupt, dismantle, and eventually defeat al-Qaeda and prevent its return to Afghanistan. In addition, it pointed out the need to prevent the Taliban from returning to power lest Afghanistan once again became a terrorist haven. The assessment called for an overarching civil-military counterinsurgency strategy based on a population-centric counterinsurgency approach to be fostered by ISAF. The report caused some friction, as the counterinsurgency terminology, while palatable in Washington in 2009, meant different things to different people given their familiarity with the basic concept. To some European members of ISAF, counterinsurgency was an escalation away from the stability and reconstruction missions that their people and political leadership were willing to support. To be effective on the battlefield, warfighters needed a clear understanding of how the strategy chosen by their superiors was supposed to drive operations; using the term “counterinsurgency” to define both the strategy and the operational method militated against this clarity.\",\n    \"Terminology aside, the assessment determined that ISAF was not executing its mission properly and needed a new operational culture. McChrystal was best known for his work in the Special Operations community and considered himself a student of counterinsurgency from his time in Special Forces. However, he had never been an architect of counterinsurgency doctrine. Although he had studied irregular warfare, all of his operational experience was in counterterrorism. McChrystal’s improvements in information flow had turned Special Operations raids into an efficient approach to eliminating al-Qaeda fighters and supporters. He was now being called upon to lead a counterinsurgency in an environment that NATO treated primarily as a reconstruction project, a mission for which his prior operational experience had not prepared him.\",\n    \"McChrystal’s proposal called for ISAF to shift to a counterinsurgency strategy based upon four pillars:\",\n    {\n      \"list\": [\n        \"1. Improved effectiveness through greater radically improved partnering with the Afghan military at every level in order to  prepare them to take the lead in security operations.\",\n        \"2. A series of kinetic operations early in the fighting season to gain the initiative and reverse the insurgency’s momentum.\",\n        \"3. A program to prioritize responsive and accountable governance at all levels, from national to local.\",\n        \"4. The prioritization of resources to those critical areas where vulnerable populations are most threatened—specifically  the eastern border region and the southeastern provinces.\"\n      ]\n    },\n    \"McChrystal specified a “properly-resourced” strategy, meaning enough resources to accomplish the mission with acceptable risk based on the theater commander’s assessment, as opposed to a “fully resourced” strategy, which was untenable and defined differently at every level of command. The assessment explained that civilian as well as military resources needed to be applied to problems in Afghanistan. It called on the Departments of State and Justice, as well as other interagency partners, to participate.\",\n    \"McChrystal suggested investing additional resources in Afghanistan, but only after deciding on a new strategy. He feared that numbers  would be mistaken for strategy when, instead, they should be the outcome of objective analysis:\",\n    {\n      \"list\": [\n        \"\\\"General Rodriguez and I did not come over here expecting to ask for more forces. Of course we spent so much time together in the  Pentagon talking about it; prepping after the day they directed us to do it [the assessment]. We actually thought we didn’t need any more forces. It was only the analysis that pulled us toward that, and we were actually a little bit surprised by it. But we talked every day during that process, often just one-on-one. We let the analysis pull us where it did. We made decisions based on that. We didn’t just start with a pre-conceived notion.\\\"\"\n      ]\n    },\n    \"Shortly after McChrystal delivered his assessment, the Washington Post received a leaked copy of the document, and published a slightly redacted version a few days later. The leak put President Barack H. Obama in the unenviable position of deciding whether to accept the advice of the military or repudiate it. A pervasive belief that the military was trying to box the president into a single solution complicated his staff’s response to the request, with the result that McChrystal had to wait three months for an answer. The situation increased the friction between military and civilian leadership within the Obama administration.\",\n    {\n      \"title\": \"A Disconnect between Ends, Ways, and Means\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"In a public television interview midway through his assessment, McChrystal articulated what he believed was President Obama’s strategy on Afghanistan:\",\n        {\n          \"list\": [\n            \"\\\"Well, I think the decision [as] he described it in that strategy was to do a fully resourced counterinsurgency strategy, to focus on first preventing Al-Qaeda[’s] return to safe havens—it had been here before 9/11—but then also to review the way we fought. And I think that the fully resourced part—that we were going to provide enough forces to do what we felt we had to do— was a major change.\\\"\"\n          ]\n        },\n        \"McChrystal’s understanding that the president had already approved a fully resourced counterinsurgency was reasonable but premature and ultimately incorrect. The president intended to see how well the 21,000 additional troops he had ordered to Afghanistan in February were securing the fall elections before making further deployment decisions. Based on his own experience and the Riedel Report, McChrystal assumed that population-centric counterinsurgency was already being implemented.\",\n        \"While waiting for White House approval, McChrystal took a cue from Gates and NATO secretary general Anders Fogh Rasmussen and changed the ISAF mission to “conduct population-centric counterinsurgency operations” by publishing Operations Plan 38302 Revision 4 in September 2009. When the president formally announced his decision, the national security memo specifically stated that the strategy was not fully resourced, population-centric counterinsurgency. It never had been and indeed never would be.\",\n        \"The ratio of security forces to population drove calculations of how many troops were needed. The accepted wisdom had been that for every 1,000 inhabitants, an intervening force needed twenty troops (a ratio of 50:1) to secure an area with an insurgency. Never did anyone suggest deploying enough foreign troops to approach the 50:1 figure for the entire country, which would have been prohibitively expensive. Most arguments rested upon the assumption that the 50:1 ratio was only necessary in the worst areas and would always be achieved by adding ISAF and ANSF numbers together. McChrystal and Petraeus thought that victory would be achievable with fewer troops than this ratio dictated as long as there was a surge force large enough to clear regions sequentially and enough trained ANSF to hold them once surge forces had shifted to new areas. In the meantime, the surge troops already in country began setting conditions for decisive operations in RC South—namely Operation MOSHTARAK—to be conducted if the second increment of surge units should be approved.\",\n        \"While awaiting a response from the White House, McChrystal and his staff reviewed their options for what to do with the different troop numbers the president could authorize. Recognizing that ISAF would never be able to train enough ANSF or deploy enough of its own forces to obtain the recommended ratio of security forces to population nationwide, McChrystal’s staff looked at what could be achieved by focusing incoming reinforcements on the most volatile areas. This approach appealed to McChrystal, who thought that sequencing could compensate for troop strength. Instead of distributing reinforcements across the theater, he would send them first to Helmand Province, then to Kandahar Province, and finally to selected areas of RC East. This concept depended on the ability of the combined training command to deploy enough ANSF to hold areas cleared by coalition forces. It also assumed that insurgents would not launch offensives in areas of Afghanistan not reinforced by surge forces. Although this approach may have judged the Quetta Shura Taliban’s intentions correctly, it misjudged the strength that sanctuary in Pakistan gave the Taliban and its influence over HIG and other allies.\"\n      ]\n    },\n    {\n      \"title\": \"McChrystal’s Changes in the Command Structure\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"When McChrystal arrived in June 2009, he began to implement the change in command structure desired by Gates. The incoming commander had the support of Petraeus at CENTCOM, who felt strongly that Operation ENDURING FREEDOM never had the right command structure and needed it now. McChrystal was changing that command structure with the creation of the NATO Training Mission–Afghanistan and the IJC. To give the IJC maximum authority, he recommended granting it operational control of all deployed SOF.\",\n        \"McChrystal stood up the three-star IJC between the four-star ISAF headquarters and the two-star regional commands in September 2009. The new headquarters mirrored the command structure in Iraq in many ways. McChrystal had selected General Rodriguez as his deputy commander for USFOR-A with the understanding that, after NATO’s approval, he would become the inaugural IJC commander. Making Rodriguez both the IJC commander and the USFOR-A deputy commander was a political stretch for NATO; nonetheless, the alliance agreed because it saw value in merging the missions.\",\n        \"Creating a new headquarters came at a cost. The IJC required more than 1,000 coalition staff members just to perform its basic functions. Given the zero-sum approach to troop levels, any increase in staff officers and headquarters personnel invariably led to a commensurate reduction in the number of troops available for many other missions required in the theater. It took all summer and into the fall to fill the new headquarters, with the result that it was not fully operational until 12 November 2009.\",\n        \"Despite the draw on the available workforce, the IJC fostered greater unity of effort among ISAF partners. Although establishing IJC enhanced unity of command, the relationship of specific nations to the overall mission remained complex. Even with the United States in command, every nation still had veto power over implementing any aspect of the U.S.-led strategy. The U.S. and ISAF missions could never be merged fully.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_7-2.png\",\n        \"caption\": \"General Rodriguez\"\n      }\n    },\n    \"Other factors limited the IJC’s ability to influence the fight. After the 2009 Strasbourg Summit, during which NATO heads of state and government discussed the alliance’s strategy for Afghanistan, NATO issued a statement recognizing that “extremists in Pakistan especially in western areas and insurgency in Afghanistan undermine security and stability in both countries and that the problems are deeply intertwined.” The declaration listed many items to which NATO already had agreed, but mentioned Pakistan only once more by noting NATO’s desire to “encourage and support the strengthening of Afghan and Pakistani government cooperation; and build a broader political and practical relationship between NATO and Pakistan.” In reality, the only tangible effect of this relationship was that “NATO offered a few training courses for Pakistani officers and emergency relief on occasion.” NATO never really intended to contribute to counterinsurgency operations in Pakistan in any substantive measure.\",\n    \"Although Obama felt that Pakistan held strategic importance to the United States, Bruce O. Riedel’s recommendation to conduct a counterinsurgency campaign was an operational pathway that the political leadership of the NATO forces under American command would not fully accept. NATO, even under American leadership, did not accept Pakistan as part of the mandate. NATO had never been willing to accept counterterrorism as the mission, nor did it acknowledge counterinsurgency until October 2009. At times, various ISAF nations and even President Hamid Karzai denied the existence of the insurgency itself. As a result, the IJC’s influence stopped at the Afghanistan-Pakistan border.\",\n    \"Lacking NATO support, the United States attempted to work with Pakistan bilaterally. Under an agreement reached in late 2008, SOF stood up a Special Operations command in Pakistan to control Special Forces, civil affairs, and psychological operations units training and advising the Pakistani Frontier Corps. Political considerations constrained the activities and operational areas of this small force, under the command of Col. Kurt L. Sonntag, but its personnel aided the Pakistani military forces who belatedly acknowledged their own growing insurgency.\",\n    \"The Americans got part of what they wanted when NATO approved the establishment of the IJC. Nonetheless, the benefit gained from merging the U.S. and ISAF missions remained elusive. Although both special operations and drone strikes in Pakistan were part of the campaign run by American officers who also held NATO positions, other NATO nations provided little support for these efforts. These limitations aside, the headquarters created efficiencies for ISAF nations and regional commanders. More importantly, it streamlined the chain of command of joint ground forces as U.S. troops in Afghanistan were poised to reach peak levels.\",\n    \"McChrystal wasted no time in refocusing the ISAF staff. A key component was his selection of Maj. Gen. Michael T. Flynn as his chief  intelligence officer or J2. Flynn quickly and correctly assessed that the intelligence infrastructure in Afghanistan was built to support tactical operations and did little to support operational and strategic objectives. In Flynn’s own words:\",\n    {\n      \"list\": [\n        \"\\\"Eight years into the war in Afghanistan, the U.S. intelligence community is only marginally relevant to the overall strategy.  Having focused the overwhelming majority of its collection efforts and analytical brainpower on insurgent groups, the vast intelligence apparatus is unable to answer fundamental questions about the environment in which U.S. and allied forces operate and the people they seek to persuade. Ignorant of local economics and landowners, hazy about who the powerbrokers are and how they might be influenced, incurious about the correlations between various development projects and the levels of cooperation among villagers, and disengaged from people in the best position to find answers—whether aid workers or Afghan soldiers—U.S. intelligence officers and analysts can do little but shrug in response to high level decision-makers seeking the knowledge, analysis, and information they need to wage a successful counterinsurgency.\\\"\",\n        \"To achieve the objectives outlined by the Obama administration, the intelligence community would need to make changes in how it conducted daily operations. The U.S. military as a whole would also need to make a huge investment in intelligence, surveillance, and reconnaissance equipment. Flynn thus faced an almost insurmountable challenge as he sought to reorient and restructure intelligence operations in Afghanistan in time to have a tangible impact on the campaign envisioned by McChrystal.\"\n      ]\n    },\n    \" \",\n    {\n      \"title\": \"RC South Becomes the Main Effort\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The majority of the reinforcements approved by President George W. Bush in late 2008 and by President Obama in February 2009 were committed to executing McKiernan’s plan for RC South. Most of the troops were American—even though command of RC South had rotated through British, Canadian, and Dutch leadership—because the other nations could not generate sufficient domestic political support for deploying the troops necessary for this dangerous work.\",\n        \"The United States faced resource limitations as well. The Marines and Army were deployed to maximum capacity in Iraq and Afghanistan, and also were occupied with training requirements. Even approved requests for forces took time to fill and deploy to theater. Knowing that the Marine Corps had immediately available units, Pentagon leaders chose them to secure Helmand Province. It helped that the Marines wanted their own battlespace and that Helmand provided a relatively uncongested airspace for their fixed-wing aircraft and helicopters. In the end, increased enemy activity made the most pressing argument for committing troops in Helmand.\",\n        \"The legitimacy of the Afghan presidential and provincial council elections planned for 2009 would be heavily dependent on the Pashtun population. Since Pashtuns were concentrated in the south (and east) of Afghanistan, McKiernan had planned to expand security in the south before the elections. The former ISAF commander had requested reinforcements of 21,000 troops from the Bush administration for this purpose, and Obama had approved the request. Kandahar, the largest population center in the south, seemed the logical place to receive the influx. However, the British government had lobbied for help in neighboring Helmand, and the U.S. Marines, available first, preferred to operate there. McKiernan agreed that Kandahar, although more important, was the less prudent choice in an election year.\",\n        \"The Marine Corps formed Marine Expeditionary Brigade–Afghanistan specifically for Helmand. In mid-2009, Marine forces flooded into  southern Helmand to seize control of the logistical lines providing the Taliban’s lifeblood: opium outward bound, money and manpower inward bound. As expressed by a Marine officer, “Helmand is the Taliban’s Ruhr Valley—its industrial base,” likening it to the western German industrial region that had supplied the German armies in both of the twentieth century’s world wars. Even though that opinion could be seen as somewhat exaggerated, considering that Pakistan’s tribal areas were the primary source of personnel, training bases, and equipment depots for the Taliban, Helmand Province was a key component in the financial network funding the insurgency. Not only had Helmand Province become the source of 45 percent of the world’s illegal opium, its population was 92 percent Pashtun. In addition, the British were unable to operate in large, unoccupied swathes of terrain by themselves.\",\n        \"Marine commanders recognized that the decisive showdown would take place in the population clusters surrounding the provincial capital of  Lashkar Gah and the district centers of Nawah-ye Barkaza’i, Marjah, Nad ‘Ali, Sangin, Now Zad, and Girishk. Taliban cells effectively ruled in these districts and towns, often coordinating their activities with sympathetic tribal elders, poppy farmers, and drug lords. In addition to harassing ISAF patrols, insurgent groups massed to attack coalition bases and police checkpoints, pinning down the security forces while advertising Taliban supremacy in the region. One marine officer summed up the dilemma affecting ISAF efforts to bring government presence and security to Helmand: “The local cops and the farmers know who the Taliban are. We’re the ones in the dark.” The marines were determined to regain the initiative by extensive and aggressive patrolling, always in conjunction with a like number of Afghan police or soldiers. They sought to secure key towns in the Helmand River Valley, starting near Lashkar Gah, and in critical districts such as Sangin.\",\n        \"A surprise air assault into Nawah-ye Barkaza’i gave the marines a solid base from which to operate. Units quickly pushed south toward Garm Ser, Khan Neshin, and even to Bahram Chah, a border town with a lawless reputation. The Taliban responded to the sudden vigor of ISAF activity by boxing the marines in with IEDs, forcing them to allot more troops to force protection and more surveillance assets to monitor busy transit routes and points. When outgunned, local Taliban kept a few steps ahead of the marine wave, side-stepping or even relocating in Pakistan. The marines could claim to have cleared a vast swath of the Helmand River Valley, but the extent of their actual control of the valley remained in question.\",\n        \"In early 2010, the marines focused their operations on the nearby town of Marjah in southern Nad ‘Ali District, only twenty-five kilometers southwest of Lashkar Gah. Its population consisted mostly of transplanted Pashtuns who had little loyalty to anyone outside their own village. One of the largest known Taliban sanctuaries in Afghanistan, Marjah was a nexus for insurgents reaping economic gain from Helmand’s poppy industry and a base from which they launched attacks into Helmand’s capital. The Taliban found easy refuge here and adequate support for their reemergence in Helmand in 2006–2008. Local farmers growing poppy readily teamed with Taliban cells to protect their fields from government-sponsored eradication efforts. This relationship allowed both the Taliban and narcotics traffickers to operate freely in the populated areas.\",\n        \"Even though ISAF had launched major operations in and around Marjah since the summer of 2009, it had failed to break the Taliban’s hold on the region. Many insurgents simply avoided coalition sweeps, leaving behind hundreds of IEDs and occasionally snipers to distract and weaken ISAF forces. At the same time, enemy commanders called for reinforcements from Pakistan, showing the Taliban’s willingness to fight for Marjah and its surrounding communities. Consequently, Taliban fighters avoided contact when they wanted to and flowed into vacated areas when they came under pressure from ground operations.\",\n        \"Special operations raids into Marjah during 2009 increased pressure on Taliban leaders and gained critical intelligence for the plan developed by RC South commander British Maj. Gen. Nicholas P. “Nick” Carter. Intelligence analysts estimated as many as 1,000 fighters were dug in amid hundreds of IEDs. The town’s buildings and canals provided opportunities for IED and mine strikes, ambushes, and sniper attacks, as the Taliban drove ISAF forces into kill-zones. Evidence suggested that these Taliban fighters were more experienced and tactically proficient than usual, and may have included foreign fighters trained in Pakistan.\",\n        \"The persistent threat of Taliban actions against civilians in the form of IED attacks, night letters (unsigned intimidating messages  from the Taliban, warning locals that they would face reprisal for cooperating with foreign forces), and assassinations undermined the promise of the coalition: side with the government, and the government will protect you. McChrystal and Carter recognized this obstacle and were determined to make Helmand a successful example of how to conduct counterinsurgency operations. McChrystal also recognized that legitimate elections were critical to maintaining a viable partnership with the Afghan government. Otherwise, the military campaign would have no end.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_7-3.png\",\n        \"caption\": \"Soldiers from A Company, The Highlanders, 4th Battalion, The Royal Regiment of Scotland\"\n      }\n    },\n    \"Marjah had been a known Taliban stronghold for months. McKiernan and his RC South commander had known that the town had to be cleared and secured, but wanted to wait until after the elections before initiating what likely would become a bloody battle. Everyone involved believed the effort would require U.S. air assets and troops. These would become available at almost the exact moment that McChrystal arrived in Afghanistan.\",\n    \"${Shaping Operations}{bold}\",\n    \"Even before ANSF units had been designated for the mission to hold RC South, U.S. forces began clearing operations in the region. By summer 2009, time was running short as the new date of the elections was set for 20 August. McChrystal knew his strategy and the additional troops approved in February needed to show progress quickly. He understood that early success would improve the chance that the National Security Council would approve his recommendations in the strategic assessment. With the Marines already clearing villages in the Helmand River Valley, McChrystal wanted to use ISAF’s success in securing the elections as proof that his campaign was progressing.\",\n    \"With additional forces still arriving into RC South and only two months until ballots were to be cast, ISAF conducted one of the largest operations of the war. On 19 June 2009, British, Danish, and Afghan troops launched Operation PANCHAI PALANG (Panther’s Claw) to secure portions of the Helmand River Valley near the provincial capital of Lashkar Gah. The mission had varied results. ISAF troops suffered several casualties from IEDs, including a British infantry battalion commander. Intelligence confirmed Marjah as the main enemy stronghold. PANCHAI PALANG eliminated the Taliban fighters caught between the attacking units, but it did nothing to reduce the enemy operating just outside the area secured by ISAF troops.\",\n    \"On 2 July 2009, more than 4,000 marines of Marine Expeditionary Brigade–Afghanistan and 650 Afghan soldiers launched a sequel to PANCHAI PALANG called Operation KHANJAR (Strike of the Sword) in the Helmand River Valley. Although marines had been fighting in Afghanistan since 2002, KHANJAR was the largest helicopter insertion conducted by the U.S. Marine Corps since the Vietnam conflict. Lt. Col. William F. McCullough’s 1st Battalion, 5th Marines, and Lt. Col. Christian G. Cabaniss’ 2d Battalion, 8th Marines, assaulted into Nawah-ye Barkaza’i and Garm Ser Districts respectively, courtesy of the U.S. Army’s 82d Combat Aviation Brigade. British, Estonian, and other coalition forces followed to establish security. Initially successful, the Marines reported problems getting local leaders to support operations in Helmand. When possible, marines asked elders for support before missions so as to prevent collateral damage and civilian casualties. Elders in the hamlets of Helmand responded that they had seen similar, smaller operations for each of the past four summers, and told the marines that the Taliban had returned after these previous operations to retaliate against those who had aided coalition troops.\",\n    \"In early August, Marine Expeditionary Brigade–Afghanistan continued clearing operations in Helmand with Operation EASTERN RESOLVE II. In bazaar raids south of Garm Ser, near Khan Neshin, the brigade seized over fourteen tons of raw opium and a plethora of IED-making materials, along with other weapons. Despite local skepticism, the three operations had secured Helmand Province temporarily for the upcoming elections. While the decrease in violence provided more Afghans with the opportunity to vote, the local populace’s Pashtun sympathies, coupled with long-standing discontent with the Kabul government, did not guarantee a large turnout at the polls.\",\n    \"Operation KHANJAR could now be seen as a rehearsal for the larger Operation MOSHTARAK, which would clear Marjah in early 2010. The methods and tactics used in KHANJAR were employed again in MOSHTARAK the following year. While KHANJAR was underway, U.S. Army units were starting to arrive in Kandahar, where they began their own shaping operations.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-7-4.svg\",\n        \"caption\": \"Operations PANCHAI PALANG and KHANJAR\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"\",\n    \"\",\n    \"In July 2009, just a month before the Afghan national elections, the 5th Brigade Combat Team, 2d Infantry Division, arrived from Fort Lewis, Washington, to fill McKiernan’s 2008 request for a Stryker brigade for Kandahar. The 4th Brigade, 82d Airborne Division, would soon follow with the mission to partner with Afghan Army units. One battalion would partner with Afghan forces in RC West, and the remainder would work in RC South. The Stryker brigade’s deployment differed from those of other U.S. Army units for several reasons. First, the 5th Stryker Brigade (as it would be known) was the only Army brigade in Operation ENDURING FREEDOM to serve its entire tour as a battlespace-owning unit under the command of a non-U.S. general. Second, they were the first U.S. Army brigade deployed to RC South for the surge. The unit featured the M1126 Stryker, a wheeled combat vehicle with advanced digital technology. No other command in Afghanistan was built around this system. The Kandahar mission would be the 5th Stryker Brigade’s first combat deployment since its activation.\",\n    \"The deployment of the 5th Stryker Brigade to Afghanistan is critical to understanding Operation ENDURING FREEDOM during the initial troop increases authorized by the Bush administration. The ways in which the unit interpreted its mission, understood its enemy, and reacted to the enemy sanctuary in Kandahar were notably different than the mindset and actions of other units deployed at the same time. Friction quickly developed between the brigade commander and the ISAF-appointed RC South commander over the unit tactics involved in a counterinsurgency fight. The deployment of the 5th Stryker Brigade culminated not only in battles that killed hundreds of insurgents but also in war crimes that killed several innocent civilians. The brigade’s leadership suffered negatively from these events and the unit’s legacy would be tarnished for years to come.\",\n    \"To understand the problems surrounding the 5th Stryker Brigade’s time in Afghanistan, it is worth taking a closer look at the circumstances of its training and assignment. In February 2009, in preparation for a long-anticipated deployment to Iraq, the brigade was conducting its mission-readiness exercise at the National Training Center at Fort Irwin, California. On 21 February 2009, the brigade commander, Col. Harry D. Tunnell IV, interrupted the exercise to inform his brigade that it was now going to deploy to Afghanistan. The fact that the 2d Infantry Division’s 5th Stryker Brigade would be sent to Afghanistan instead of Iraq was neither ideal nor unique. Other units, such as the 3d Brigade Combat Team, 10th Mountain Division, in Wardak and Logar Provinces, had received the same change of mission. However, preparation for the two conflicts differed greatly. For example, the brigade had trained about 120 soldiers to speak Arabic, which would now be largely unhelpful as Arabic is not widely spoken in Afghanistan. Although the unit wore the patch of the 2d Infantry Division, the division was headquartered in Korea and not responsible for preparing the brigade to deploy. Therefore, the I Corps assumed this role. The I Corps and FORSCOM approved a letter delineating the training for the brigade that Tunnell wrote using CENTCOM’s prescribed training matrix for deploying forces. This matrix referred to Counterguerrilla Operations (Department of the Army Field Manual 90–8), but not Counterinsurgency (Department of the Army Field Manual 3–24). As a result, the 5th Stryker Brigade’s training focused on a different doctrine than the one that McChrystal intended to employ for U.S. operations in Afghanistan.\",\n    \"The 5th Stryker Brigade’s mission rehearsal exercise showed the friction between the training design and the mission that the unit would assume in Iraq and subsequently Afghanistan. Colonel Tunnell wanted his unit trained in high-intensity battle, the worst-case scenario of any combat action, at a time when the Army’s training centers had switched to providing more discreet scenarios resembling their interpretation of conditions in Iraq and Afghanistan. Although Tunnell was aware that the National Training Center had switched emphasis from its previous focus on high-intensity combat, he was disappointed that his formal request for such training could not be accommodated. Tunnell was sure that the National Training Center’s leadership was misinterpreting the fight his brigade might face in Afghanistan. After arriving at Fort Irwin, the Stryker brigade commander did not endear himself to the trainers by insisting on using more counterguerrilla doctrine rather than population-centric counterinsurgency doctrine to guide his unit’s operations.\",\n    \"Tunnell disagreed not only with the National Training Center and CENTCOM on the nature of the fight, but also with the U.S. and  ISAF mission concepts. The current mission in the NATO-led RC South, where 5th Stryker Brigade would operate, was not the same as the American-led RC East mission. The mission in RC East was to “conduct full-spectrum operations” through 2008 and then changed to “conduct counterinsurgency operations” in April 2009. In RC South, the term “conduct counterinsurgency” was not yet included in the mission statement. The paragraph in the operations order describing the enemy situation in RC South began:\",\n    {\n      \"list\": [\n        \"On 10MAR09, the Insurgent Syndicate (INS) initiated a “Tet-like” [surprise] offensive in RC-South starting with a major attack in Kandahar Province followed a few days later with another large-scale attack in Helmand Province. INS forces in RC-South are now equipped with more sophisticated air defense and anti-armor weapons systems. Enemy main effort remains in Kandahar Province to fix coalition forces allowing the INS freedom of maneuver.\"\n      ]\n    },\n    \"Despite the word “insurgent” in the order, the then RC South commander, Maj. Gen. Mart de Kruif, had avoided the term counterinsurgency,  preferring a mission statement that read:\",\n    \"RC South partnered with ANSF neutralizes insurgent syndicate influence and secures critical areas in order to establish and maintain a safe and secure environment that extends government authority and influence facilitating Afghanistan’s reconstruction and enabling the GIRoA [Government of the Islamic Republic of Afghanistan] to exercise its sovereignty throughout the country.\",\n    \"Although the RC South operations order did not state “conduct counterinsurgency operations,” it did include counterinsurgency doctrinal language. The paragraph on commander’s intent even gave a nod to the term “population-centric.”\",\n    {\n      \"list\": [\n        \"${Commander’s Intent}{bold}. In partnership with ANSF we will concentrate our resources to SHAPE, CLEAR, HOLD and BUILD [emphasis in original] critical areas in order to enable GIRoA [Government of the Islamic Republic of Afghanistan] to deliver improved Governance, Security and Development within the framework of our ‘population-centric’ regional plans. We will continue to operate in partnership with the ANSF and the International Community (IC) to synchronize our efforts across all LOEs [lines of effort] and bring greater coherence to operations in Southern Afghanistan. The Operational Center of Gravity in RC-South is the population’s support of the provincial governments and ANSF. This will deny the insurgent syndicate (INS) access to the population and serve to separate the INS from Afghan citizens both morally and physically.\"\n      ]\n    },\n    \"The campaign plan for RC South consisted of three lines of operations: security, governance, and development. This approach  was not called counterinsurgency, but it closely resembled the definition in Field Manual 3–24. Tunnell deployed his brigade with the understanding that it would serve as a clear-and-hold force, which would indicate a more offensive mission oriented on security rather than the other two lines of operations. Indeed, the RC South operations order defined the operation as offensive, continuing to describe how offensive operations would neutralize the insurgency:\",\n    {\n      \"list\": [\n        \"Decisive to this operation is RC-South’s ability to neutralize the INS [insurgent syndicate] and maintain the lines of communication in our AOR [Area of Responsibility]. Upon completion of the attacks on OBJs [Objectives] COBRA and VIPER, RC-South resumes civil security throughout the AOR to establish and maintain a safe and secure environment that extends government authority and influence facilitating Afghanistan’s reconstruction and enabling the GIRoA [Government of the Islamic Republic of Afghanistan] to exercise its sovereignty throughout the country.\"\n      ]\n    },\n    \"From the outset, General de Kruif and his staff had reservations about how the 5th Stryker Brigade Combat Team would achieve this.  While Tunnell understood that RC South’s mission was to neutralize the enemy, he chose “defeat” as the core mission for his own unit: in essence, to temporarily or permanently destroy the enemy’s physical ability or will to fight, whether by using or threatening the use of force. When Tunnell explained his understanding of his mission and key tasks at the commander’s backbrief, de Kruif disagreed. The American colonel had used the terms “interdict” and “clear” to describe specified tasks from RC South for his unit, indicating that he saw his mission from a more offensive perspective, in which he and his unit would eliminate enemy fighters and organized resistance within their assigned area. De Kruif stopped the briefing and expressed concern that this was not what he wanted. He did not think interdicting was a brigade-level task, and he disagreed with Tunnell’s choice of that term. The Dutch general clearly thought Tunnell was too offensively focused. American Brig. Gen. John W. “Mick” Nicholson Jr., serving as RC South deputy commanding general for stability, was not present at the backbrief but later attempted to mediate the misunderstanding by restraining Tunnell from conducting offensive clearing operations.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/Img_7-4.svg\",\n        \"caption\": \"Note on U.S. Military Tactical Terminology\"\n      }\n    },\n    \"Tunnell disagreed with his superiors on the interpretation of his mission. To him, “neutralize insurgents” implied offensive military force used to clear and hold terrain, in order to prevent enemy fighters from operating in the area. McKiernan had requested the Stryker brigade specifically for its unique capabilities. De Kruif wanted to use nonlethal methods and operations, such as reconstruction and development projects, to achieve the effect “neutralize,” which he thought more appropriate for the build phase of counterinsurgency. The higher standard of defeat was Tunnell’s own doctrinal interpretation. As long as he was defeating the enemy forces, he was also neutralizing them as the higher order directed. Other ISAF commanders, however, regarded Tunnell’s emphasis on a more offensive approach with skepticism, and sought to remind him that nonlethal effects were just as important or even preferred in the counterinsurgency environment being established in Afghanistan. These differences of opinion magnified the long-standing friction within ISAF about how to interpret and implement counterinsurgency doctrine.\",\n    \"Despite misgivings about Tunnell’s views of tactical priorities, de Kruif recognized that the Strykers had capabilities that would prove useful in RC South. Just before the August 2009 national elections, de Kruif tasked Tunnell’s brigade with securing parts of Kandahar and Zabul Provinces known to harbor Taliban fighters. On 18 August, two days before Afghans went to the polls, the enemy attacked a Stryker in Lt. Col. Jonathan A. Neumann’s 1st Battalion, 17th Infantry, with an IED. The damage to the vehicle was so severe that one soldier could not be found or identified. When Tunnell requested additional assets to search for the missing soldier, de Kruif directed all forces under his command to support every Stryker brigade request as much as possible. During the search, another soldier was reported missing following a second massive IED blast. It took two days of intense fighting to locate the remains of both soldiers, during which time six more soldiers were wounded. Ten enemy fighters were confirmed killed and an unknown number wounded.\",\n    \"Enemy contact increased whenever Strykers approached the area near the river in Arghandab District known as “the Green Zone.” Because of its dense vegetation and lack of intensive patrolling, the enemy had chosen Arghandab as its home. The Canadians had not been able to hold the Arghandab District after Operation MEDUSA in 2006, and so it and the neighboring districts of Maywand, Zharey, and Panjwa’i had become insurgent bases. This was not a place insurgents came to train and store weapons, nor was it a transitory safe haven. The Arghandab District was where the enemy lived: he would stand and fight for this terrain. An assault on it would be exactly the high-intensity fight for which the Strykers had trained. Tunnell was determined to neutralize the district.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_7-5.png\",\n        \"caption\": \"A Stryker combat vehicle\"\n      }\n    },\n    \"Intelligence estimated thirty to forty enemy fighters in the entire area of the Arghandab, but future operations would show that that estimate was far too low. Tunnell directed a deliberate attack, Operation OPPORTUNITY HOLD, to seize a foothold in the Arghandab from which the brigade could conduct subsequent clearing operations. Nine days after the elections, 5th Stryker attacked. In the IED-laden Arghandab, the clearing operation required the brigade to breach multiple belts of obstacles that the enemy had laid throughout the terrain. The Stryker was fast, quiet, and able to carry an infantry squad and its equipment over long distances, which made it ideal for surveillance missions, but unlike the MRAP vehicle with its V-shaped hull, it was vulnerable to mine strikes. To address this deficiency, troops cleared the area on foot with Strykers in support-by-fire positions.\",\n    \"Operation OPPORTUNITY HOLD lasted an entire month and was immediately followed with Operations FOCUS HOLD and SUSTAIN HOLD.  These operations lasted until November 2009 and generated the majority of 5th Stryker Brigade’s own casualties: 35 killed in action and 239 wounded. In Arghandab, the Stryker brigade killed fifty insurgents and wounded a sizeable but unknown number as well. During OPPORTUNITY HOLD, it became clear that the new estimate of 200 insurgents was still too low. Instead, a battalion-sized unit of 300–400 Taliban fighters operated from the Green Zone of Arghandab. The fighting continued as the enemy-controlled area gradually shrank. Although the Stryker soldiers were making progress, each victory came at a cost of more killed and wounded. Each casualty report generated renewed discussion of Tunnell’s methods among military leaders in Afghanistan. The IJC commander, General Rodriguez, wondered if the casualties could be attributed to Tunnell’s tactics, rather than considered as the price of having left the enemy to his own devices in and around the Arghandab for years. Yet even with these concerns about the 5th Stryker Brigade’s use of counterguerrilla tactics during the clear phase of their operations, Tunnell and his solders also implemented counterinsurgency tactics in the hold and build phases. The unit aggressively applied nonlethal means as well, dispersing millions of dollars from the Commander’s Emergency Response Program—54 percent of the total for RC South during this period—toward urgent civilian needs even before clearance operations were complete.\",\n    \"In the first months of its deployment, the 5th Stryker Brigade had helped secure the elections. However, its aggressive tactics gave it a reputation among the new RC South leadership, one that was not necessarily beneficial for the brigade or its commander. Tunnell had received mentorship from the I Corps deputy commander at home station, but his unit was now part of a larger U.S. division deployment in which the senior leaders were not necessarily focused on the same training objectives. Although mentoring offered part of the answer, the U.S. Army was still grappling with understanding its own newly devised counterinsurgency doctrine and allies who had a totally different interpretation. Tunnell’s experience was brought on by his and his unit’s own doing, but was amplified exponentially under NATO command.\",\n    {\n      \"title\": \"Unexpected Developments in RC East\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The most obvious example of how important elections were to McChrystal came in Nuristan Province, where he imposed a moratorium on realigning or closing coalition bases until votes had been counted. Small outposts in remote locations had been attacked previously and were still vulnerable. A 3 October 2009 attack on one of the bases that had been kept open for the elections became the most telling and important event in RC East—and perhaps the entire theater. The assault on Combat Outpost KEATING, as in earlier instances, resulted in devastating losses for the attackers, with U.S. forces weathering the storm albeit with numerous casualties. Although the attackers would have preferred to achieve an unequivocal victory by overrunning their objective and eliminating the defending American and Afghan troops, the Taliban and their allies were just as willing to trade lives for the sustained global media coverage that invariably accompanied every dramatic turn of events on Afghan battlefields. The strategic messaging effect was worth the loss of fighters to the Taliban.\",\n        \"${Combat Outpost Keating}{bold}\",\n        \"The events before the assault on KEATING illustrate both the potential and the pitfalls of counterinsurgency theory. Lt. Col. Joseph M. Fenty’s 3d Squadron, 71st Cavalry, from the 10th Mountain Division’s 3d Brigade Combat Team, originally established then Camp Keating in 2006 to secure the local road networks and to provide a secure location from which the Kamdesh Provincial Reconstruction Team could expand economic opportunity and promote local governance in eastern Nuristan Province. It was also the one location where U.S. forces could interdict road traffic from Barg-e Matal, an insurgent base area on the Pakistan border. Although ideally suited for these campaign-related priorities, the outpost was poorly situated from a tactical perspective. It stood at the bottom of a valley surrounded by towering mountains, linked to the outside world by a single unimproved road.\",\n        \"In 2007, Lt. Col. Christopher D. Kolenda’s 1st Squadron, 91st Cavalry, which replaced the 3d Squadron, 71st Cavalry, began to comprehend the situational reality in Kamdesh District. Fighting was seasonal, with hardened cadres flowing in from Pakistan during the late spring and early summer to reinforce local insurgents who knew the terrain and people. During the fighting season, local power brokers refused to meet with Americans, and fewer young men were available for projects. These details indicated that a popular insurrection was forming around isolated KEATING at the apex of the valley. Successive troop and company commanders followed the counterinsurgency template and at times appeared to be making progress using money and words instead of bombs and bullets. The results, though, were personality-dependent and therefore transitory and not exportable. Throughout Combat Outpost KEATING’s lifespan, the incontrovertible evidence was that the locals, even when protected and financially supported by the Americans, did not accept the presence of the newcomers. No amount of aid would suffice to convince them to accept the authority of the government in distant Kabul or tolerate the presence of uninvited foreigners.\",\n        \"S. Sgt. Clinton L. Romesha, who was awarded the Medal of Honor for his actions during the 3 October engagement, later described KEATING as “tactically indefensible.” Unfortunately for successor units, the original decision to spread security forces across the region from 2006 and beyond did not envision the enemy massing against the isolated posts. As a result, force protection was accorded a lesser priority, as counterinsurgency doctrine suggested it might. Initial operations confirmed the wisdom of taking this tactical risk, but progress was slow over the next few years. Police, government officials, and tribal leaders who had been working with the Americans in the area had faced a mounting insurgent backlash, causing the populace to back away from American and Afghan government assistance. Taliban fighters maintained the initiative, eventually closing the one road connecting KEATING and the Kamdesh Provincial Reconstruction Team with other coalition units. Lack of additional resources meant that security remained too frail to enable a build phase, and the area around KEATING had yet to be fully cleared. The original rationale for establishing the position was increasingly irrelevant.\",\n        \"While preparing to deploy to Afghanistan, the commander of 3d Squadron, 61st Cavalry, Lt. Col. Robert B. “Brad” Brown, and his brigade commander, Col. Randy A. George of 4th Brigade Combat Team, 4th Infantry Division, planned to close Combat Outpost KEATING. They believed the outpost’s remote location made it unimportant to the counterinsurgency campaign as the resources it absorbed could be spent more profitably elsewhere. In the past three years, U.S. forces at the outpost had not expanded the Afghan government’s reach, and the scarce resources meant that progress in the area would remain far below expectations for the foreseeable future.\",\n        \"Before deploying in spring 2009, Brown and George briefed their plan for the outpost to the CJTF-82 commander, Maj. Gen. Curtis M. Scaparrotti, who agreed but never approved the extensive resources needed to execute the closure mission. Therefore, Brown’s troopers occupied KEATING with the intent to shutter it as quickly as possible. Their logic reflected McChrystal’s focus on the population centers, which KEATING was not. Proximity to population centers was not a new criterion in deciding where to position forces, but it trumped competing concerns in RC East after the Battle of Wanat in 2008.\",\n        \"During a routine battlefield circulation, McChrystal visited Forward Operating Base BOSTICK where Brown presented his case for  realigning forces, which included closing KEATING and other isolated posts within six weeks. The tactical commanders knew that closing any outpost required airlift assets, which were scarce and needed to be allocated. Brown pitched the closures to McChrystal during his visit so as to alert him that this request would be forthcoming. Brown believed “the presence of the camps had actually worsened the security situation in Nuristan.” But even though McChrystal agreed with the logic of closing bases, he had strategic concerns. Karzai feared that any realignment or closure would be interpreted as a withdrawal: a sign that the American military lacked faith in the Afghan government. This visible retreat would deter turnout in the national election, especially among Karzai supporters. McChrystal wanted to be seen as supporting Karzai, yet at the same time he wanted to avoid the perception in Washington that he was acting in advance of a decision on his strategic assessment. “I don’t want to get ahead of the president,” he told George. McChrystal understood that any realignment could be seen as pulling out troops and could appear as if some bold decision had been made.\",\n        \"Another factor emerged just before the elections. Pfc. Beaudry R. “Bowe” Bergdahl had left his small outpost near Forward O perating Base SHARANA in Paktika on 30 June 2009, and nearly every unit in RC East made his recovery a priority. In addition to conventional units already operating there, Special Operations elements with responsibility for missions across the entire breadth of Afghanistan refocused their efforts on RC East. Every bit of information on Bergdahl’s location, regardless of its plausibility, had to be verified by sending soldiers to the location in question. Troops were shuttled from location to location via helicopter in quick succession in an attempt to catch the Taliban as they shifted their captive from one location to another. The constant movement of troops, combined with their attendant logistical needs, overwhelmed RC East’s already overtasked helicopter fleet. With the search area expanding in scope as time passed, the committed airlift would not be available for other missions until long after the elections.\",\n        \"As if to emphasize McChrystal’s point about perceptions during the election, Karzai asked him for help in the town of Barg-e Matal in northern Nuristan. This town was within George’s boundaries, but it had never been cleared by conventional troops. Karzai was concerned with a recent Taliban takeover, which he needed to reverse before the election. Barg-e Matal, being even more remote than KEATING, was difficult to reach and would be even more difficult to hold. KEATING was the closest U.S. outpost with a helicopter landing pad. ISAF, IJC, and some on the RC East planning staff saw it as a forward arming and refueling point for operations in Barg-e Matal. Brown and others in his command informed the planning staff that the landing zone at KEATING was a tiny flat space in a creek bed, which supported only one aircraft at a time and was safe only at night. Nonetheless, RC East and ISAF staff planners continued to believe that KEATING could support operations in Barg-e Matal.\",\n        \"A combination of unforeseen factors, including the Bergdahl search and the Barg-e Matal mission, delayed the closure of KEATING for almost two months. During that period, Colonel Brown ordered his troops to ship out of KEATING everything deemed nonessential to the outpost’s defense, in order to close KEATING quickly once they received approval to withdraw. (This common practice is referred to as “getting light.”) They did not, however, remove items needed for force protection, because the Taliban often sent small detachments to test the KEATING defenses. These incidents had occurred almost weekly since early 2008, and as the combined U.S.-Afghan garrison prepared to shut down the outpost they did not feel that these relatively minor Taliban incursions warranted them spending additional time and resources to improve their defenses.\",\n        \"At 0558 on 3 October, the Taliban attacked KEATING in strength. The attackers were able to mass undetected because the available unmanned aerial vehicles could not monitor the surrounding area on a regular basis. The assault opened with a bombardment by rocket-propelled grenades and numerous automatic weapons directing fire at the heaviest weapons available to the garrison. The incoming fire pinned down U.S. and ANA mortar crews, inflicted casualties, and suppressed all vehicle-mounted heavy weapons. As soon as the opening barrage ended, the attackers breached the perimeter section held by the ANA. After killing or wounding all of the Afghan soldiers who did not flee, the Taliban attempted to penetrate the U.S. portion of the outpost. In a grueling, close-range firefight, the Americans overcame the attackers, killing or driving out all of the Taliban who had managed to breach the KEATING perimeter.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-7-7.svg\",\n        \"caption\": \"Attack on COP KEATING\"\n      }\n    },\n    \"It took almost thirty minutes for helicopter gunships to be launched in support of the beleaguered outpost. Close air support by a pair of F–15E Strike Eagle fighters began orbiting above KEATING forty-one minutes after the assault began. At 0648, the fighters began making strafing runs and dropping bombs on enemy positions overlooking the outpost. Fifteen minutes later, the first team of AH–64 Apache gunships arrived. Although their appearance meant the defenders now had a decisive advantage in firepower, the Taliban continued the fight. Medical evacuation helicopters made several attempts to lift the wounded out of KEATING, but heavy incoming fire forced them all to turn back. Worn down by an unrelenting aerial assault, the enemy retreated as U.S. ground reinforcements neared KEATING. The battle had lasted nine hours from start to finish. Eight U.S. and three Afghan soldiers, as well as dozens of their assailants, died during the engagement, while numerous enemy fighters, twenty-two U.S. soldiers, and five Afghan soldiers were wounded.\",\n    \"${Folding up Valley Outposts in Kunar and Nuristan}{bold}\",\n    \"Insurgents portrayed the American withdrawal from KEATING as a significant victory. This claim is not entirely accurate, as the redeployment was driven less by enemy pressure and more by the fact that the outpost had little to no impact on the counterinsurgency campaign. In political terms, the local population had learned a hard lesson about staying power. An insurgent cadre with guns in a mountainside cache could outlast an American platoon backed by artillery and air support. Insurgent leaders could call upon dozens or even hundreds of fighters to descend on small mountain communities whenever it suited them. As retired Lt. Gen. Douglas E. Lute, former deputy national security advisor, recalled General John P. Abizaid saying, “Our presence itself, when it is sustained, in countries and cultures like in Iraq and Afghanistan creates antibodies against our presence itself.”\",\n    \"The battle at Combat Outpost KEATING exemplified the limits of Field Manual 3–24 ${Counterinsurgency}{italic} and McChrystal’s tactical directive. Although KEATING’s location, geography, and history made it a unique example, it was also emblematic of larger issues. Tactical commanders up to the brigade level had struggled with the outpost’s location, task, and purpose from its establishment in March 2006, but it was only in 2009 that officers seriously considered closing KEATING. Just weeks before KEATING would be attacked by hundreds of enemy fighters, McChrystal visited the brigade area, but not KEATING itself. Commanders up to the RC East level believed McChrystal wanted to delay the closure of KEATING, but McChrystal had not intended to give that impression.\",\n    \"A January 2009 DoD report to Congress singled out RC East as an example of how counterinsurgency should work. “Our COIN [counterinsurgency] approach is effective in areas such as RC-East where the U.S. and ISAF are able to concentrate sufficient forces (partnered with ANSF), development resources, and civilian expertise. This successful COIN approach integrates military and civilian resources to create a stable and secure environment.” This optimistic interpretation rested on an uncertain tactical foundation. Combat Outpost KEATING, along with many other outposts, was an outgrowth of the wide dispersion of U.S. forces over vast areas of Afghanistan. New units arrived with fewer soldiers, which meant fewer patrols, as the reduced workforce was tied to base security requirements. As roads became more dangerous, units increasingly relied on aerial resupply, which had its own set of logistical and tactical vulnerabilities.\",\n    \"In the aftermath of KEATING, the Army conducted a detailed investigation of the attack. Noting that the 3d Squadron, 61st Cavalry, after-action report identified force-protection shortcomings at KEATING as a contributing factor, the investigation concluded the unit chain of command had been negligent by failing to correct those problems. The findings resulted in letters of reprimand for the entire chain of command at the tactical level. Yet because the investigation focused on the actions of American leaders, it did not account for the ANA role in the battle, including the fact that the enemy penetrated the Afghan portion of the perimeter rather than the section held by U.S. forces.\",\n    \"Some of the investigation’s conclusions were contradictory. It found simultaneously that the perimeter of KEATING was both too large to be defended by the number of troops available and too small to include the helicopter landing zone. These were among the criteria Colonel Brown used in the argument for closing KEATING in the first place. Although most portrayals of the incident directly linked the assault on the outpost to McChrystal telling George and Brown not to close it, the reality was more nuanced. McChrystal never vetoed the plan to close KEATING, and George admitted this. Instead, each request for the helicopters needed for the complex operation was denied, not out of the desire to keep KEATING open, but because the equipment was being used for higher-priority missions, such as the search for Bergdahl and operations at Barg-e Matal.\",\n    \"The analysis of the attack on Combat Outpost KEATING was problematic in other ways. In particular, it did not consider fully the  counterinsurgency principles laid out in Field Manual 3–24 and highlighted in McChrystal’s tactical directive. The investigation found the leaders of 3d Squadron, 61st Cavalry, negligent because they stopped improving the outpost defenses once they knew that KEATING was due to be closed. However, that assessment did not account for the inability of the intelligence system to predict a large-scale attack. In fact, numerous unsubstantiated and erroneous reports of the enemy massing near KEATING before 3 October played a part in the squadron’s decision to defer force-protection improvements. As a result, the final determination relied more on the apparent clarity of hindsight than on the more concrete factors of the situation: intelligence shortcomings, the tactical friction of pairing U.S. and Afghan units, and the subtly corrosive nature of an economy-of-force campaign in which units often made do with far less than their counterparts in Iraq.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_7-6.png\",\n        \"caption\": \"Soldiers from 1st Battalion, 32d Infantry Regiment\"\n      }\n    },\n    \"The investigation’s findings also did not consider fully that the mission at KEATING involved both conducting operations against the enemy and interacting with the local civilian population, requiring the outpost’s command staff to weigh the careful balance between security and accessibility. Field Manual 3–24 and McChrystal’s tactical directive emphasized the need for the commanders to have the authority and flexibility to determine appropriate force protection measures for each area of operations. The U.S. Army had built KEATING in a valley so it could protect the local Provincial Reconstruction Team and the area’s road network. Therefore, the outpost could not have been reinforced as the impregnable fortress needed on 3 October 2009 without inhibiting the counterinsurgency missions of both the soldiers and the team they were supporting. Considering how little the occupying units at KEATING had changed the outpost’s design and structure in the three years since the Army had built it, the risk levels in the vicinity appeared to be within acceptable limits. Even when the new leadership recommended closing this outpost, noting that population outreach efforts had made little progress in the local situation and that the shift from geographic to population-centric counterinsurgency had made KEATING more of a liability than an asset, the Army had delayed the request because other missions took priority.\",\n    \"The investigation had used strong terminology in assigning blame to tactical leaders. “The commander’s plan to abandon COP [Combat Outpost]  KEATING inadvertently undermined the focus on current base defense and preparedness.” It found no fault in operational decisions by general officers, nor did it comment on the larger issues of counterinsurgency doctrine, the tactical directive, or McChrystal’s visit. In fact, it found “no specific responsibility or accountability for inadequate base defense at KEATING above the brigade level.” It mentioned neither the importance of the outpost to the forthcoming elections nor the reasoning behind delaying its closure a few months before the battle. The findings noted the overall approach: the U.S. Army “dedicates the appropriate level of resources and attention to trying to determine what happened and more importantly, to garner lessons learned so that [the] same mistake is not repeated.” On the whole, though, the investigation did not seem to match the doctrine being employed in Afghanistan at that time.\",\n    \"McChrystal determined that the reprimands would remain “locally filed,” meaning that as long as they had no further negative actions against them, dthe reprimands would not be in their permanent records. In the end, the talent and quality of those leaders shone through, as they continued to excel and receive promotion. Later, the investigating officer acknowledged that “the unit probably never should have occupied Combat Outpost KEATING. It should have been closed upon departure of the previous unit.” The reasons for keeping KEATING open were never compelling. Much later, American commanders realized that one of the original reasons for keeping KEATING open was a moot point. Even after U.S. forces closed nearly all outposts in the area, including KEATING, troops “were able to still reach into Barg-e-Matal and [beyond] as late as 2010–2011.”\",\n    {\n      \"title\": \"The Afghan Presidential Election: August–November 2009\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The American strategic review concluded shortly before Afghans went to the polls to elect a new president. Beginning with the Riedel Report, the Obama administration had actively sought to improve Afghan governance, strengthen links between Kabul and remote provinces, and sever ties between Karzai and Afghan drug lords. The concern with governance reflected the corrosive effects of high-level graft and an earnest desire to undercut support for the Taliban among ordinary Afghans. Rather than take drastic and possibly counterproductive measures, the Obama administration sought to install a chief executive officer to relieve the Afghan president of the bulk of his administrative responsibilities. Karzai would not agree to that plan.\",\n        \"The United States, and many ISAF nations, therefore came to view the August 2009 elections as an opportunity to replace Karzai with someone more capable of banishing corruption in the Afghan government. Many candidates actively opposed Karzai’s bid for reelection, but only two were palatable to Western governments. One was Abdullah Abdullah, who had served as foreign minister of the Afghan Transitional Authority for a year after Karzai’s election in 2005. The second candidate, a Western-educated Afghan intellectual named Ashraf Ghani, had been the Obama administration’s favorite. Unfortunately for U.S. intentions, preelection polls indicated that Ghani, who had spent most of his life outside Afghanistan, stood little chance of winning the popular vote. Nonetheless, a number of U.S. officials, including Special Representative to Afghanistan and Pakistan Richard C. Holbrooke and Ambassador Karl W. Eikenberry, openly associated with Ghani during the preelection campaign.\",\n        \"ISAF efforts to secure the August elections met with mixed results. Coordinated assaults, rockets, and IED attacks killed twenty-six people, including nine civilians, nine police, and eight Afghan soldiers. The Taliban also succeeded in shooting down a Royal Air Force CH–47 helicopter in a well-planned aerial ambush near Sangin. While the death toll remained fairly low, UN observers calculated that only 10 percent of eligible voters went to the polls in the Pashtun south. Although voter turnout was lower than desired, President Obama proclaimed, “We had what appears to be a successful election in Afghanistan despite the Taliban’s efforts to disrupt it.” NATO Secretary General Rasmussen observed, “Seen from a security point of view, the election has been a success. It has been conducted effectively.” CENTCOM commander Petraeus told reporters that the elections went “reasonably well,” while cautioning that more time would be needed to assess the results.\",\n        \"Petraeus’ words proved prescient as developments continued to unfold. Unofficial results announced on 16 September showed Karzai garnered 54.6 percent of the ballots cast, with Abdullah’s 27.8 percent placing him solidly in second place. The candidate preferred by the Americans, Ashraf Ghani, came in fourth. However, verified reports of Karzai supporters stuffing ballot boxes dominated both U.S. and international news. On 11 October, the top UN official in Kabul, Kai Eide, confirmed that widespread voter fraud had taken place. As a result, the UN would oversee the audit of 358 ballot boxes by a five-member Afghan electoral committee. Eide explained that if the committee determined that the total number of votes cast for Karzai fell below 50 percent, a nationwide runoff election would have to be held.\",\n        \"Karzai responded to Eide’s remarks by denouncing what he characterized as unwarranted foreign interference in Afghan affairs. Western officials, including Secretary of State Hillary R. Clinton, Richard Holbrooke, Robert Gates, and British prime minister Gordon Brown, publicly encouraged Karzai to accept the audit results. The potential for an equally inconclusive runoff election spurred renewed U.S. efforts to insert a chief executive officer between the Afghan head of state and provincial governors. One suggestion was for Karzai to form a unity government with another candidate. A Karzai spokesman denied that the Afghan president would reject the audit’s findings, though he noted that the electoral process seemed in danger of being “overshadowed by political discussions.”\",\n        \"On 2 November 2009, Afghan officials declared incumbent Karzai the winner of another term in office following the previous day’s announcement that Abdullah Abdullah had withdrawn his candidacy. UN Secretary-General Ban-Ki Moon, who arrived in Kabul that day, issued a statement renewing his commitment to backing the democratically elected government in Kabul. In Washington, Obama told White House reporters that, after congratulating Karzai during a telephone conversation, he had informed his Afghan counterpart that “this has to be a point in time in which we begin to write a new chapter based on improved governance, a much more serious effort to eradicate corruption, joint efforts to accelerate the training of Afghan security forces so that the Afghan people can provide for their own security.”\",\n        \"Although the election appeared to suggest that the Afghan people renewed Karzai’s mandate, low voter turnout in many areas, coupled with ballot stuffing by the Afghan president’s proxies, eroded support for Karzai within the international community. Postelection tensions between Karzai and the international community were rising, fueled by the fact that he was limited to two terms in office by law and exacerbated by Karzai’s attempts to appoint Ghani as chief executive officer. None of this boded well for ISAF. Rather than continue playing the part of staunch ally, Karzai lashed out at those who doubted his legitimacy.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-7-m.svg\",\n        \"caption\": \"RC East Transfer of Authority June 2009-November 2010\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"One of the earliest examples of that political metamorphosis occurred at a January 2010 London conference when Karzai demanded all discussion on important strategic issues be deferred until the Kabul summit scheduled for that summer. The NATO Senior Civilian Representative, British diplomat Mark P. Sedwill, agreed to the request by deferring major strategic questions, such as how the transition to Afghan governance would take place and when Western troops would depart, to the Kabul summit scheduled for the summer.\"\n  ],\n  \"chapter 8\": [\n    {\n      \"title\": \"Exit McChrystal, Enter Petraeus\"\n    },\n    {\n      \"section\": [\n        \"When President Barack H. Obama took office in January 2009, he and his administration were determined to reevaluate the strategic vision of their predecessors. In a dramatic departure from the accelerated process originally adopted by the Bush administration, the Obama White House devoted considerable time and thought to the reassessment effort that led to the Riedel Report. Rather than passively accepting an updated concept provided by the Pentagon, the National Security Council thoroughly overhauled the existing approach, first by redefining the threat and then by reexamining what the United States sought to accomplish and how success would be defined.\"\n      ]\n    },\n    {\n      \"title\": \"The Results of the Strategy Review\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Competing viewpoints soon surfaced, with Vice President Joseph R. Biden Jr. preferring a counterterrorism option while others supported population-centric counterinsurgency. As the administration discussed the pros and cons of different approaches, counterinsurgency emerged as a favorite even in light of concerns about whether the Afghan government was a worthy strategic partner. In the midst of this process, the Pentagon sought permission for the newly appointed ISAF commander, General Stanley A. McChrystal, to conduct a strategic assessment of his own. The White House initially viewed that prospect as a potential source of friction should McChrystal arrive at a different conclusion than the National Security Council. In the end, however, the president approved the request.\",\n        \"The White House’s concern about contradictory statements was prescient. General McChrystal’s assessment, leaked to the media  just before the August 2009 elections in Afghanistan, stressed “the criticality of time” while raising the specter of mission failure: “Failure to gain the initiative and reverse insurgent momentum in the near-term (next 12 months)—while Afghan security capacity matures—risks an outcome where defeating the insurgency is no longer possible.” Troop levels became the lead story, with news outlets indicating that McChrystal was preparing to ask for a significant troop increase. A series of public statements by McChrystal, General David H. Petraeus, and Admiral Michael G. Mullen not only supported this perception, but also fed anxiety within the White House that military leaders intended to hijack the strategic decision-making process. McChrystal had not helped his case when the three troop options he presented to Obama—increases of 11,000, 40,000, or 85,000—made it abundantly clear that he wanted 40,000 more troops. Military planners never seriously explored McChrystal’s first and third options. These developments fueled suspicions between the military and White House staff that would color future debates over Afghanistan policy.\",\n        \"The National Security Council debated McChrystal’s assessment for nearly three months, near the end of which Ambassador Karl W.  Eikenberry felt it necessary to question the counterinsurgency and any potential surge. His concerns in a cable sent directly to Secretary of State Hillary R. Clinton were leaked to the media, which further escalated tensions within the administration just before the president’s 1 December decision on McChrystal’s recommendations. Eikenberry identified six problems with the proposed counterinsurgency strategy:\",\n        {\n          \"list\": [\n            \"1. President Hamid Karzai is not an adequate strategic partner.\",\n            \"2. We overestimate the ability of Afghan security forces to take over.\",\n            \"3. We underestimate the length of time it will take to restore or establish civilian government.\",\n            \"4. The proposed strategy does not remedy an inadequate civilian structure.\",\n            \"5. The proposed strategy may not be cost-effective.\",\n            \"6. More troops won’t end the insurgency as long as Pakistan sanctuaries remain.\"\n          ]\n        },\n        \"Eikenberry blunted his arguments by calling for “a comprehensive, deliberate and interdisciplinary re-examination of our strategic options” at a juncture where little support existed within the administration for another strategic review. However, his concerns about the Afghan government and the insurgency’s safe havens in Pakistan were well-founded.\",\n        \"By late November, McChrystal’s assessment was almost three months old. Petraeus took strong exception to Eikenberry’s critique,  noting that the ambassador had not offered any substantive objections prior to sending the cable to Clinton. Petraeus later observed that “we’re now at the point where literally the president is going to announce his decision and this is on the table waiting for us. And it just comes in out of left field. It wasn’t coordinated with General McChrystal.” The lack of coordination between the embassy and the military was unintentional but consequential. Even though the military had the advantage of having a retired general as ambassador to Afghanistan, Eikenberry and McChrystal had significantly different interpretations of the situation. The resultant disagreement led McChrystal to reflect on the disparity between State Department and Pentagon views:\",\n        {\n          \"list\": [\n            \"\\\"In retrospect, it would have been valuable if the U.S. embassy had also been directed to conduct a parallel analysis.  Although we coordinated our review with the embassy staff, the failure to clearly identify and bring to the fore any differing assessments proved to be [a] problem during the White House’s subsequent decision-making process on our ISAF strategy and troop request.\\\"\"\n          ]\n        },\n        \"Eventually, the president accepted the 40,000 troop increase, but stated that it would consist of 30,000 Americans, with 3,000 more at the discretion of Secretary of Defense Robert M. Gates, and 10,000 more from other ISAF nations. Before announcing his decision, Obama met in the Oval Office with Gates and Petraeus and then video teleconferenced with Eikenberry and McChrystal. He asked each of them if a twenty-one month surge of 30,000 American forces and 10,000 more from ISAF troop-contributing nations would be acceptable. All agreed. McChrystal noted that although the president did not offer enough time, which was itself a critical resource, he decided to give his consent. McChrystal said in an interview that he thought that “it was better to try than not to try at that point.” He then added, “You know, I’ll spend a lot of time for the rest of my life, wondering if I should have said all stop, wait a minute, I don’t think that’s a good plan.” That decision to try would significantly change the scope and character of Operation ENDURING FREEDOM over its remaining five years.\",\n        \"The White House’s second strategic review concluded in November after nine or ten National Security Council meetings that totaled r oughly twenty-five hours. At first glance, the new review did not seem to alter U.S. strategic goals significantly. The revised strategy retained the core goal of disrupting, dismantling, and defeating al-Qaeda, and set out two supporting goals: (1) “deny safe haven to al-Qaeda” and (2) “deny the Taliban the ability to overthrow the Afghan government.” The first goal had been in place since the autumn of 2001, and defending the central government from overthrow had been policy since July 2003. However, President Obama’s revised Afghanistan-Pakistan strategy significantly limited U.S. strategic goals. The new strategy no longer considered it necessary, or even possible, to defeat the insurgency. By doing just enough to keep the Taliban out of power, the Obama administration believed it could deny al-Qaeda sanctuary in its former home.\",\n        \"Thus, the new strategic concept called for the United States “to degrade the Taliban insurgency while building sufficient Afghan c apacity to secure and govern their country, creating conditions for the United States to begin reducing its forces by July 2011.” A major goal was to reconcile the Taliban with the Afghan government through peace negotiations, which the Obama administration saw as the only feasible way to stabilize Afghanistan. The second important change in strategic goals focused on building the capacity of select Afghan ministries, primarily defense and interior. No longer would the U.S. government pursue a capacity-building strategy across the whole of the Afghan government. Rather than seeking to shape a moderate, democratic government capable of exercising full sovereignty, as in Bush-era strategies, the Obama administration would selectively build government capacity, with an emphasis on security institutions. The new policy explicitly stated that the strategy was not “nation building”—a shift that reflected the White House’s growing disillusionment with “the profound problems of legitimacy and effectiveness with the Karzai government.” The Obama administration recognized that it would not be feasible to build a stable democracy in Afghanistan, yet believed it could make the ANSF strong enough to secure the country against the Taliban and ultimately al-Qaeda. The question became: what resources would be necessary to achieve these goals?\",\n        \"After speaking with Karzai and the new Pakistani president Asif Ali Zadari via teleconference, as well as key NATO leaders, Obama announced the troop increase in a speech at the United States Military Academy West Point, New York, on 1 December 2009. The 30,000 American troops plus 10,000 coalition troops option, which had been proposed by Secretary Gates, was a compromise between the military’s counterinsurgency approach and the less resource-intensive counterterrorism advocated by Biden and others in the White House. Although the final summary of the president’s decision, called a “terms sheet,” spoke of denying the Taliban access to the population— language that reflected the tenets of counterinsurgency doctrine—it also stated that the strategy was “not fully resourced counterinsurgency.” Obama had approved a partially resourced political and military compromise to buy time for Afghan security forces to grow and mature.\",\n        \"The surge was a compromise in both resources and time, specifically projected to last eighteen to twenty-one months as opposed  to an indeterminate length of time required to meet the objectives and desired end conditions. Surge forces were to arrive in the first half of 2010 and begin redeploying in July 2011, as President Obama made public in his West Point speech. The president believed he was balancing opportunity costs. He quoted President Dwight D. Eisenhower as stating that national security proposals “must be weighed in the light of a broader consideration: the need to maintain balance in and among national programs.” In light of the 2008 economic crisis and the nearly $1 trillion cost of the wars in Iraq and Afghanistan, Obama opposed dramatic or open-ended escalation. The surge would bring U.S. troop levels in Afghanistan to more than 100,000 by early 2011 at enormous cost to the U.S. Treasury, to say nothing of the human costs. Officially, the force cap was set at 98,000 U.S. soldiers, sailors, airmen, and marines at any one time, with the caveat that 5 to 10 percent over that cap was acceptable to accommodate relief-in-place operations for rotating forces.\",\n        \"Senior policy and military leaders critical of Obama’s decisions pointed out that this seemingly arbitrary deadline signaled to the Afghans, the enemy, and regional actors that they should prepare for an American departure. The Obama administration hoped to bring the Taliban to the bargaining table on favorable terms, but the Taliban now had strong reason to believe that it had the easier task—to survive and wait for the coalition to leave. However, as one senior Army leader later noted, “if we don’t put markers on the table, then things have a tendency to languish on, without clear goals or objectives and from the very start, our goal was to ensure that at some point the Afghans would be able to do this for themselves. We can’t stay there forever.”\"\n      ]\n    },\n    {\n      \"title\": \"Operation MOSHTARAK\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Now that the presidential and provincial council elections were over, the next priority for ISAF was to eliminate Taliban enclaves in Helmand and Kandahar Provinces. With the Marine Expeditionary Brigade–Afghanistan already engaged in clearing the Helmand River Valley, McChrystal felt that expanding that effort would be an opportunity to demonstrate visible progress. McChrystal also wanted to prove the applicability of the principles he had espoused in his assessment, the changes in command structure he had initiated in theater, and the tactical directive he had issued to his troops. McChrystal’s vision, dubbed Operation MOSHTARAK, provided a chance to demonstrate that combining increased troop strength with counterinsurgency techniques could clear, hold, and build pro–central government strength in an enemy-held region. The commander of RC South, British General Nicholas P. “Nick” Carter, would be responsible for executing Operation MOSHTARAK in accordance with McChrystal’s directive. Although MOSHTARAK was supposed to begin soon after the Afghan elections, logistical issues and the delayed deployment timelines of surge forces would delay it until 2010.\",\n        \"McChrystal and Carter envisioned MOSHTARAK as a three-phase operation to expand the authority of the Afghan government in RC South by protecting the population, separating insurgents from innocents, and partnering with ANSF at all levels. Committed forces included three brigades of the ANA’s 205th Corps supported by British and U.S. troops. Describing American involvement using the term “supported” understated the fact that the Marine Expeditionary Brigade would deploy thousands of marines into the region encompassing Helmand and Nimroz Provinces. The sheer number of ISAF troops involved, coupled with the ambitious scope of the effort, led to the three provinces being split off from RC South to become RC Southwest in June. Phase I consisted of the 5th Stryker Brigade Combat Team conducting freedom-of-movement operations (clearing routes and roads) to enable other units to reach the population. Phase II centered on clearing operations in Nad ‘Ali District, particularly Marjah, which became the perceived focus of MOSHTARAK. That impression arose because prominent Afghan officials and ISAF leaders invested considerable time and effort in describing what would happen in Marjah after the Taliban was driven out. In reality, Marjah was one of several second-phase goals of MOSHTARAK.\",\n        \"The final phase focused on central Kandahar. The directive for this phase emphasized the need for stable political conditions and the arrival of the surge forces as preconditions for its execution. The Army units allocated to this phase—Lt. Col. John M. Paganini’s 1st Squadron, 71st Cavalry; followed by Col. Arthur A. Kandarian’s 2d Brigade Combat Team (Combined Task Force STRIKE), 101st Airborne Division; and Col. James D. Edwards’ 525th Battlefield Surveillance Brigade—had been identified well in advance and were soon to arrive. The incoming U.S. units would partner with ANSF immediately after arriving in Afghanistan.\",\n        \"${MOSHTARAK Phase I, Shaping Operations}{bold}\",\n        \"The 5th Stryker Brigade Combat Team provided the main effort in the initial phase of MOSHTARAK. The aggressive attitude of Col. Harry D. Tunnell IV caused friction between him and General Carter soon after the latter took command of RC South. The tension resulted in part from differing visions of how to achieve success. Carter believed Tunnell focused too much on engaging the enemy and too little on the population-centric counterinsurgency approach espoused by McChrystal, stating afterward, “Harry Tunnell was an impediment to the 4-star commander’s intent.” Carter, however, made no effort to impart his intentions or otherwise connect with subordinate commanders by continuing General Mart de Kruif’s practice of visiting or patrolling with frontline units. The same could be said of Tunnell, who apparently made no heartfelt attempt to embrace or otherwise accommodate Carter’s vision.\",\n        \"Thirty days after taking command, Carter changed the 5th Stryker Brigade Combat Team’s mission to route security. The RC South commander wanted to ensure freedom of movement for the populace as well as ISAF and Afghan forces. Carter chose Tunnell’s brigade because it had a large number of light, armored vehicles suitable for covering long distances quickly. The new mission parameters specified by RC South, however, did not authorize the Stryker soldiers to operate more than two kilometers from the routes they were tasked to clear. As a result, units in the 5th Stryker Brigade Combat Team were confined to mounted patrols and key leader engagements with local officials in the villages sited on the tasked routes. Carter was trying to find the best way to employ the Stryker unit’s unique capabilities while harnessing its aggressive brigade commander’s mindset to McChrystal’s operational intent.\",\n        \"The new mission forced most of the 5th Brigade’s subordinate elements to relocate. Lt. Col. Jeffrey W. French’s 2d Battalion, 1st Infantry, was the sole exception, remaining along the Ring Road in Panjwa’i and Maywand Districts. This rearrangement of geographic responsibilities left the Arghandab River Valley vulnerable at almost the exact moment that 5th Stryker Brigade leaders felt they were gaining strength against the enemy. The lost opportunity for tactical success caused friction between Carter and Tunnell, as the latter felt the new directive relied on information crafted months before the current state of affairs, which now clearly showed the Arghandab River Valley as an enemy sanctuary.\",\n        \"Tunnell disagreed with Carter’s approach because intelligence indicated that the IEDs being used on the routes his brigade was supposed to secure were being manufactured in the Arghandab District. Colonel Tunnell did not see the sense in committing troops to dealing with IEDs one at a time for hundreds of kilometers when he believed that he could strike the Taliban strongholds that were making them. Tunnell insisted his units were better suited for clearing operations than light infantry because they had more foot soldiers whose actions could be synchronized through the brigade’s unparalleled digital command and control network. However, Tunnell did not accept alternative solutions, including the use of other units to perform the mission he sought. In fact, Special Operations units were conducting “an aggressive but carefully orchestrated campaign of precision strike operations” to degrade insurgent strength and undermine insurgent confidence across the area of operations. Their precision-strike operations removed key insurgent leaders whose responsibilities included deciding where to mass IEDs.\",\n        \"Colonel Tunnell also had problems with the nebulous language that General Carter used in the task and purpose for the route-security operation, which were to “discombobulate” the enemy so as to “place him on the horns of a dilemma.” Tunnell bristled at receiving directives containing such nondoctrinal terminology, particularly as they also failed to assign sufficient importance to defeating the enemy after seizing the tactical initiative. He felt that Carter had oversimplified the problem and was unable to articulate the mission in achievable doctrinal terms.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-8-1.svg\",\n        \"caption\": \"MOSHTARAK Phase I\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"Carter fully disclosed his reasons for using the Strykers as route security to Tunnell. In focusing on roads, this first phase of MOSHTARAK also served as a deception. Most of the supplies allocated to MOSHTARAK would be carried by ground convoys that required route security, but the key maneuver elements of Phase II would travel not by road, but by air. By focusing enemy attention on the region’s road networks rather than aviation avenues of approach, Carter and McChrystal sought to gain the time they needed to set up the second critical phase in the struggle for RC South.\",\n    \"Nearly simultaneous with the change in mission, a controversy emerged inside the 5th Stryker Brigade Combat Team. The Army Times published an article alleging that Capt. Max Hanlin was replacing Capt. Joel R. Kassulke as commander of Company C, 1st Battalion, 17th Infantry, because the outgoing commander had philosophical differences with Tunnell. The article quoted soldiers, noncommissioned officers, and junior officers who believed that the brigade’s techniques for clearing operations were too enemy-focused and hence antithetical to McChrystal’s tactical directive. Kassulke did not confirm or deny the implied rift between Tunnell and himself. Instead, the article highlighted how his soldiers were surprised by Kassulke’s sudden departure, as well as the unexpected order from RC South to switch from clearing operations to route security in another sector. The soldiers assumed both developments were due to mission failure on their part. Getting units at all echelons in step with a population-centric counterinsurgency plan was proving more difficult than predicted. In this case, tension arose within an American brigade because junior officers interpreted the ISAF commander’s vision in literal terms, while senior leaders viewed McChrystal’s guidance as more nuanced.\",\n    \"${MOSHTARAK Phase II, Operations in Central Helmand}{bold}\",\n    \"McChrystal wanted Phase II to be a truly new and distinct milestone for Operation ENDURING FREEDOM. He wanted to convince Karzai that the south needed to be cleared, but was not sure how to do so. In seeking a way to approach the Afghan president, McChrystal took advice from former Ambassador Ronald E. Neumann, who stated that Karzai “trusts individuals, not reports and frequently told me so.” Neumann elaborated that “Karzai is completely tactical. . . . you cannot be too detailed with Karzai . . . show him a map and walk him through terrain illustrate what you mean.”\",\n    \"On 12 February 2010, McChrystal visited the presidential palace in Kabul to gain Karzai’s approval for Phase II of Operation MOSHTARAK. McChrystal made it a point to ask for permission to execute the operation, even though preparation for MOSHTARAK, and even announcements of its goals, had been known for weeks. According to McChrystal, Karzai paused and said, “General McChrystal, you’ll have to forgive me. I’ve never been asked to approve this kind of operation before.” After specific questions, Karzai gave his approval.\",\n    \"The most controversial part of the second phase of Operation MOSHTARAK was the idea that a “government in a box”—meaning a prepared governmental presence with resources and personnel—would immediately link disaffected residents in a former Taliban stronghold with their provincial and national governments. Building these ties between the population and the government proved harder to execute than to conceptualize. McChrystal later acknowledged that the term “government in a box” was a “superficial description we’d mistakenly coined” and that it “distracted from the serious effort to bring Afghan governance into what had been enemy territory.”\",\n    \"Brig. Gen. Larry D. Nicholson, commander of Marine Expeditionary Brigade–Afghanistan, felt the same way. He recognized in retrospect that finding the right people to lead the Marjah government was his greatest obstacle. Past attempts by previous Afghan governments to irrigate, modernize, and populate the area with tribes from outside Helmand had created demographic chaos, leaving Marjah without a true native population base that could provide a foundation for a strong local government. Sixty years earlier, a U.S. Agency for International Development program had created an irrigation system that was now being used for poppy production, adding to the problems in the region. The Afghans chosen for the government in a box were not from Helmand Province and their American counterparts could not provide the impetus to enable the government to have its promised immediate impact. In spite of these obstacles, the operation went forward.\",\n    \"With more than 3,000 U.S. marines and 4,400 Afghan troops in the assault force, Phase II of Operation MOSHTARAK involved around 15,000 troops in all roles, making it the largest ENDURING FREEDOM operation to date. It would be the first operation in which each U.S. battalion would pair with an ANSF battalion. ISAF announced the operation a few weeks in advance to generate enemy activity and give civilians a chance to leave, which they did in great numbers. Prior to Phase II, elders from the region urged the marines to start the operation as soon as possible, but the flood of people fleeing Marjah was so unmanageable that the elders began asking for time to evacuate more innocents and persuade the enemy to surrender. The marines granted a one-day delay after cutting off all avenues in and out of the town.\",\n    \"On 13 February, 900 British troops and their partnered Afghan forces air-assaulted into Nad ‘Ali to the west of Lashkar Gah, while 1,420 U.S. marines and their partnered Afghan forces air-assaulted into Marjah. The idea was to avoid getting bogged down fighting through the IED belts protecting the ground approaches to Marjah. While massive helicopter lifts of up to sixty rotary-wing aircraft transported part of the attack force, others still had to move by indirect ground routes. Capt. John A. Moder’s Company C, 1st Battalion, 6th Marines, received the unenviable mission of clearing routes into Marjah so as to meet the assault forces and open sustained lines of communications. Knowing that IEDs had been emplaced on the obvious approaches, Moder’s company used a circuitous route that avoided roads and crossed water obstacles without using bridges in order to link up first with its battalion command element and subsequently with Capt. Carl A. Havens’ Company A in the center of Marjah. Company C took no casualties but received sporadic gunfire and found dozens of IEDs, which they detonated harmlessly. Marjah now belonged to the U.S. Marines and Afghan Army.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-8-2.svg\",\n        \"caption\": \"MOSHTARAK Phase II\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_8-1.png\",\n        \"caption\": \"The 1st Battalion, The Royal Welsh\"\n      }\n    },\n    \"This overwhelming success pleased General Nicholson, who entered Marjah to see firsthand how the situation was developing. Upon arrival, he noted that Lt. Col. Calvert L. Worth Jr., the commander of 1st Battalion, 6th Marines, was speaking to men in black turbans. Worth was telling them that U.S. and Afghan forces were there to install civilian government, protect the population, and help reestablish public services. One of the men stood, gestured to the group, and said, “I am Taliban. We are all Taliban. But we agree and we trust you. But if you lie to us or do not do as you say, I will come back here and kill you and your marines.” For the moment, Marjah remained quiet.\",\n    \"Task Force MOHAWK, formed around Lt. Col. Burton K. Shields’ 4th Battalion, 23d Infantry, was a late addition to the assault on Marjah. In mid-January, Colonel Tunnell notified the unit that it would be attached to Marine Regimental Combat Team 7 for Operation HELMAND SPIDER, a supporting effort to Phase II of MOSHTARAK. Company A, 1st Battalion, 17th Infantry— attached by Tunnell to Shields’ battalion—would operate in Nad ‘Ali while the remainder of TF MOHAWK partnered with 1st Kandak, 2d Brigade, 205th Afghan National Army Corps. Their mission was to seize crossing points over the Trikh Zabur Canal to deny the enemy freedom of movement between Sayyidabad and Marjah and disrupt any enemy counterattacks.\",\n    \"Col. Paul W. Bricker’s 3,200-soldier 82d Combat Aviation Brigade, organized with five battalions equipped with 155 cargo, utility, reconnaissance, attack, and medical evacuation helicopters, doubled the rotary-wing platforms taking part in Operation MOSHTARAK. By ferrying units by air, Bricker’s brigade enabled the high operational tempo sought by Carter in Phase II by preventing the Taliban from canalizing ISAF troops into IED belts. The 82d Combat Aviation Brigade not only transported Army, Marine Corps, and Afghan infantry, but also provided British forces with reconnaissance, aerial fire support, cargo lift, and medical evacuation assets. The Army’s UH–60 Black Hawks and CH–47s Chinooks played a prominent role in the opening days due to the Marines’ decision to dedicate their MV–22 Osprey tilt-rotor lift aircraft to supporting a quick-reaction force.\",\n    \"Although the assault on Marjah was successful, it identified ways in which joint operations in Afghanistan needed to improve. Notably, improperly planned logistics left Stryker units short of lodging and maintenance support. Working with the ANA stretched both Army and Marine leaders who were unprepared for the low level of proficiency of many of their Afghan counterparts. Language barriers between Afghans and Americans made rehearsals even more important than anticipated and quadrupled the time necessary to conduct such events.\",\n    \"The enemy remained in Marjah during the operation but did not fight. Marine General Nicholson believed his opposition had made that decision after so many coalition forces had arrived in the center of Marjah and the key areas that surrounded it. The citizens of Marjah were aware that the enemy had decided not to fight, as evidenced by their return en masse only eight days after the air assault. A few weeks later, the area was deemed safe enough for Karzai to attend a local shura and discuss the new situation with elders. The locals made known their concerns about those chosen to lead the district. Karzai assuaged their concerns, and the locals agreed to give the new government a chance.\",\n    \"The seizure of Marjah was the decisive point of Operation MOSHTARAK, but it did not mark the end of hostilities in Helmand Province. To the contrary, it marked the beginning of frustration for the Marines and their Afghan partners as well as for McChrystal. Although the Taliban’s initial reluctance to become entangled in a major engagement meant that U.S. forces were able to net large caches of weapons, drugs, and explosive materials, civil government was not progressing with the same rapidity. In a May 2010 visit to the 3d Battalion, 6th Marines, McChrystal exhorted the unit commander, Lt. Col. Brian S. Christmas, to help representatives of the Afghan government achieve more progress. Christmas replied that doing so required far more time than the ninety days his marines had already spent in Marjah. McChrystal then asked how many days Christmas believed it would take and how many days Washington might give them. When Christmas replied that he did not know, McChrystal responded, “[W]e don’t have as many days as we’d like.”\",\n    \"These situational factors meant that clearing operations in Helmand were characterized by a mix of tactical gains and strategic stalemates. Although the Marines achieved all of their tactical and operational objectives, the province had yet to heed to the dictates of the Karzai government and remained an insurgent base. Afghan government and ISAF claims that reconstruction efforts would begin immediately and that Kabul would reach out to the province’s inhabitants after the Taliban departed rang hollow, in large part because Afghan and American interagency participation fell far short of the Marines’ effort. In fact, Helmandis perceived Operation MOSHTARAK in a negative light precisely because they saw only armed troops, not aid officials, construction crews, or earnest Afghan administrators.\",\n    \"In March, the International Council on Security and Development, a European think tank, interviewed 427 local Afghans in Lashkar Gah  District to capture their opinion on recent security measures and the motivations of the Taliban. Two-thirds of respondents characterized ISAF operations in Marjah as “bad.” About the same number said they would not support ISAF forces in their province, and even more felt that NATO troops should leave Afghanistan and believed the Taliban would return. Oddly enough, two-thirds also answered “yes” to the question: “Should the international and government forces now ‘clean [clear] the road from Lashkar Gah to Kandahar to Kabul’ and start a similar operation in Kandahar or other regions?”\",\n    \"Although Marjah produced relatively little in the way of casualties or results, it still could be considered a showcase operation. However, similar operations in nearby districts such as Sangin and Nad ‘Ali proved more irritating and produced the bulk of the casualties for the U.S. Marine Corps during this period. Just as British troops discovered earlier, the marines found that the enemy had cunningly and effectively employed IEDs throughout the area. Of the 14,803 U.S. marines killed or wounded in all theaters of war since 2001, 5,324 of these casualties—more than a third—occurred in Afghanistan. More than 80 percent (287 killed, 3,953 wounded) of those losses occurred in Helmand from 2009 to 2011.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_8-2.png\",\n        \"caption\": \"General Mills & Chairman of the Joint Chiefs of Staff Admiral Mullen\"\n      }\n    },\n    \"The assignment of Marine Expeditionary Brigade–Afghanistan to Helmand under operational command of Marine Central Command limited the flexibility of the tactical commander. Although RC South sent TF MOHAWK and the 82d Combat Aviation Brigade to Helmand to support the Marines in Phase II of Operation MOSHTARAK, marines contributed far fewer assets in support of operations in other regional commands. The doctrine that deploys a Marine Air-Ground Task Force prevented the Marine brigade from being parceled out to support other operations, which meant that ISAF could not extract the marines from Helmand to augment other major operations. McChrystal conceivably could have requested a boundary change so marines could fight outside of Helmand Province, or he could have requested a change in the command and control arrangements, but he did neither.\",\n    \"In July, General Nicholson’s Marine Expeditionary Brigade was replaced by a much larger force, the I Marine Expeditionary Force (Forward) commanded by Maj. Gen. Richard P. Mills. The arrival of Mills’ command doubled the U.S. Marine Corps commitment in Helmand Province, which now stood at 20,000. With the number of troops in Helmand equaling that in other regional commands and with a two-star general in command, IJC decided to create RC Southwest, consisting of Helmand and Nimroz Provinces. RC South retained responsibility for Kandahar, Uruzgan, Daykundi, and Zabul Provinces.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-8-5.svg\",\n        \"caption\": \"Regional Commands South & Southwest\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"Mills’ marines began operating as a self-contained regional command in May 2010 during what ISAF termed as an “assessment phase.” By the end of May, the I Marine Expeditionary Force (Forward) reported to IJC that it was capable of operating as an independent regional command. On 28 May, the North Atlantic Council officially recognized the establishment of RC Southwest, with IJC doing likewise on 14 June 2010. With the creation of a sixth regional command, command and control arrangements, which had evolved significantly during the past year and a half, were set for the remainder of the surge.\",\n    \"Some irony could be derived from the events that resulted in the U.S. Marine Corps, sent to reinforce the British contingent in Helmand Province two years earlier, gaining command and control over the bulk of British forces in Afghanistan while the majority of the troops reporting to British General Carter in RC South were supplied by the U.S. Army. Carter’s predecessor, General de Kruif, had opposed the division of RC South into two regional commands. He believed such an initiative would be detrimental to the overall coalition unity of effort in the Pashtun heartland, which he insisted represented one battlespace. Thus, in response to the “single battle” doctrine espoused by the Marines, McChrystal had divided what preceding leaders originally considered an indivisible battlespace.\",\n    \"The changes taking place in southern Afghanistan initially resulted in more than 10,000 U.S. marines, or about 10 percent of U.S. forces in the country, operating in remote parts of Helmand to secure only 1 percent of the Afghan population, while the British continued to secure the more populated capital of Lashkar Gah. When the marines in RC Southwest doubled to more than 20,000, now about 20 percent of U.S. forces in country, their new area of operations encompassed about 5 percent of the Afghan population. Arguments about insurgent density or poppy production were used to justify those decisions, but some U.S. officials questioned whether ISAF understood the precepts of counterinsurgency by sending so many troops to secure so few civilians. Regardless of any lingering skepticism about ISAF’s warfighting approach, the marines were successful in shaping, clearing, and holding remote areas of Helmand Province. Like their U.S. Army counterparts in other contentious areas of Afghanistan, however, the U.S. Marine Corps found the build and Afghan-lead phases more difficult to achieve.\",\n    \"${The Stryker Finale}{bold}\",\n    \"A preemptive strike against insurgents massing in Shah Wali Kot by the 5th Stryker Brigade Combat Team in the waning months of its  deployment indicated that ISAF could seize the initiative given the right tactical conditions. In May 2010, Lt. Col. Jonathan A. Neumann, commander of 1st Battalion, 17th Infantry, in northern Kandahar Province, did just that. His units had learned of an imminent massing of Taliban fighters for an attack, likely against ISAF forces near Shah Wali Kot. Being cautious in the last weeks of the brigade’s tour, Tunnell reinforced Neumann with a company from 4th Battalion, 23d Infantry, before taking further action.\",\n    \"When Lt. Col. Karl E. Slaugenhaupt, the deputy brigade commander, recommended attacking the Taliban in Neumann’s area of operations, Tunnell agreed on a series of company-sized operations aimed at destroying the enemy force. Tunnell used companies because Carter still wanted him to focus on maintaining route security until the Stryker brigade left Afghanistan in July 2010. Over the next several days, Colonel Neumann’s task force killed or wounded an estimated one hundred insurgents belonging to the group gathering near Shah Wali Kot.\",\n    \"During the same period, ISAF authorities were searching all personally owned computers in the brigade for photographs or videos showing Afghans being killed by U.S. forces. The images violated standing military policy prohibiting soldiers in a war zone from photographing or filming dead enemy personnel. The hunt for the illicit images began in spring 2010 after their existence became known outside of the brigade. The Army, concerned that some of Tunnell’s soldiers also had sent images to stateside recipients, ordered its own Criminal Investigation Command to perform similar searches of computers belonging to the relatives of soldiers. The search for photos would lead to findings even more atrocious than simply recording the deaths of enemy combatants.\",\n    \"When Army investigators discovered photographs of dead Afghans on laptop computers belonging to soldiers in the Stryker brigade, the initial suspicions of wrongdoing sparked a further investigation. The expanded investigation over the period of many months revealed that four soldiers of a platoon from Company B, 2d Battalion, 1st Infantry, had committed murders while in Afghanistan. Led by S. Sgt. Calvin R. Gibbs, the group orchestrated situations in which they could kill civilians, whom they framed as insurgents. This was not the first time Gibbs had been implicated in illegal actions; earlier in the deployment, he had been relieved of his duties in the brigade command post after receiving nonjudicial punishment for stealing. The actions of Gibbs and several other individuals came to the chain of command’s attention when peers reported them for smoking hashish and telling incriminating stories. Once Tunnell learned all of the details, he immediately referred this case to the Army’s Criminal Investigation Command. The ensuing formal investigation revealed that the soldiers had carried out three staged killings, each falsely reported as a legitimate enemy engagement.\",\n    \"The mentality, methods, and attitude of the 2d Battalion, 1st Infantry, had always been a concern of Tunnell’s. The colonel had worried about the unit long before it arrived in Afghanistan because he felt its former commander had allowed discipline to erode to a dangerous level. As a result, after Tunnell considered formally relieving Lt. Col. Richard A. Demaree of command, he instead cut short the officer’s tour of duty before the deployment. Before Tunnell departed Fort Lewis in 2009, he informed that officer’s replacement, Colonel French, that the 2d Battalion, 1st Infantry’s collective discipline had deteriorated to a point where the performance of individual soldiers in combat could be affected.\",\n    \"It was becoming clear that the reputation of the 5th Stryker was now in question. The first inkling that the 5th Stryker Brigade had fallen  into official disfavor emerged when the 4th Battalion, 23d Infantry’s recommendation for a Presidential Unit Citation successfully made its way through the chain of command while similar awards for all other 5th Stryker Brigade units were returned without action. When Tunnell’s inquiries about the awards went unaddressed by the U.S. chain of command, he sent a memorandum titled “Subject: Open Door Policy—Report from a Tactical Commander” to Secretary of the Army John M. McHugh in August 2010. Tunnell’s memorandum went far beyond the subject of lost awards. In it, he stated that his unit had been denied live-fire training, constrained to policing roads after Carter had assumed command, and forced to share precious resources with allies, all of which amounted to what he called professional malfeasance. The U.S. Army did not take any immediate action, and McHugh released no response.\",\n    \"On 18 October 2010, newly assigned I Corps and Fort Lewis commander Lt. Gen. Curtis M. Scaparrotti appointed Brig. Gen. Stephen M. Twitty to investigate the command climate in Tunnell’s brigade. Officially, he initiated the investigation because of administrative problems associated with submitting awards and officer evaluations. The investigation also looked for any possible connection between the brigade’s overall command climate and the murders committed by Sergeant Gibbs and his associates. Twitty’s investigation found no link between the illegal killings and the command climate. However, Twitty recommended that Tunnell be reprimanded and retired at lieutenant colonel, blaming the poor administration of the unit. A board of officers that convened to discuss the investigation’s findings did not find cause to demote Tunnell, who retained the rank of colonel when he later retired from the Army.\",\n    \"Although the friction between General Carter and the 5th Stryker Brigade Combat Team’s commander did not figure prominently in the investigation, Tunnell’s memorandum had spread word of his dissatisfaction well beyond the confines of Fort Lewis. Although part of the problem could be attributed to a clash of personalities, it also reflected that counterinsurgency was neither uniformly understood nor implemented in Afghanistan. Tunnell incorrectly interpreted the main problem with the doctrine as stemming from its “assumption” that the population represented the center of gravity. That was true at the time in Afghanistan, but only because of the ISAF commander’s personal interpretation of doctrine. Both McChrystal and Tunnell may have been correct to a degree, but their respective approaches suffered from a single-mindedness that failed to account for all of the variables present on a complex battlefield. McChrystal overemphasized courageous restraint— to the point where his soldiers felt they were being put unnecessarily at risk—even as Colonel Tunnell placed overriding faith in more aggressive counterguerrilla tactics.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_8-3.png\",\n        \"caption\": \"General McChrystal\"\n      }\n    },\n    \"Tunnell’s Stryker brigade successfully executed its transfer of authority with the 2d Cavalry Regiment (Stryker) in July 2010. Under the  command of Col. James R. Blackburn Jr., the 2d Cavalry would assume more of a security force assistance mission by more closely partnering with Afghan Army units in RC South. Although the 5th Stryker Brigade was now back at home station in Fort Lewis, its legacy would continue to be marred in the public forum and the press. In March 2011, Rolling Stone magazine published an article about the brigade titled “The Kill Team: How U.S. Soldiers in Afghanistan Murdered Innocent Civilians for Sport.” The story discussed the investigation into the pictures of dead Afghans and the illegal actions of Gibbs and his accomplices. For the military, the Rolling Stone piece was an information operations disaster because the article claimed that the Army had attempted to keep both the illicit photographs and murders secret. Rolling Stone also suggested that Tunnell, which it described as a commander who “openly mocked the military’s approach to counterinsurgency,” had fostered a toxic climate within the brigade by constantly exhorting his men to relentlessly pursue the Taliban. Tunnell had wanted the legacy of his unit’s deployment to be its success at exploiting information dominance to defeat the enemy. Instead, the 5th Stryker Brigade would be remembered as the “Kill Team,” a black mark on the record of U.S. involvement in Afghanistan.\",\n    {\n      \"title\": \"General McChrystal’s Exit\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"In April 2010, McChrystal was traveling from Europe to Afghanistan when he received an email from S. Sgt. Israel Arroyo. Six weeks earlier he had patrolled with Arroyo’s squad from Lt. Col. Reik C. Andersen’s 1st Battalion, 12th Infantry, 4th Brigade Combat Team, 4th Infantry Division. Arroyo wrote now inviting McChrystal to a memorial for Cpl. Michael K. Ingram, a team leader in his squad, who died as a result of an IED attack on 17 April, not far from where McChrystal accompanied the patrol. McChrystal accepted the invitation and traveled to Zharey District with personal staff and Rolling Stone reporter Michael M. Hastings.\",\n        \"Following the memorial service, McChrystal spoke with the fallen service member’s platoon and discussed the challenges of focusing on protecting the civilian population to defeat the insurgency. The soldiers did not respond positively to his remarks. Although McChrystal’s staff tried to explain to Hastings that such a reaction was normal, an article published in mid-June reflected the platoon’s skepticism. “The session ends with no clapping, and no real resolution. McChrystal may have sold President Obama on counterinsurgency, but many of his own men aren’t buying it.” Hastings had intended to highlight the widening disconnect between the counterinsurgency theory espoused by senior leaders and the growing frustration experienced by soldiers fighting a tenacious foe. However, the article also recounted unprofessional and demeaning remarks made by McChrystal’s staff about Vice President Biden, others in the administration, and American allies. In fact, McChrystal’s apparent insubordination seemed to be the central theme of the article, with the title of “The Runaway General” drawing even more attention. The article had been slated for release on 22 June 2010, but an advance copy leaked to senior administration officials and to the press. The article went viral, and senior leaders at multiple levels quickly tried to control the damage.\",\n        \"On 21 June 2010, President Obama summoned McChrystal to the White House. Before arriving, General McChrystal issued a written statement:\",\n        {\n          \"list\": [\n            \"\\\"I extend my sincerest apology for this profile. It was a mistake reflecting poor judgment and should never have happened.  Throughout my career, I have lived by the principles of personal honor and professional integrity. What is reflected in this article falls far short of that standard. I have enormous respect for President Obama and his national security team, and for the civilian leaders and the troops fighting this war and I remain committed to ensuring its successful outcome.\\\"\"\n          ]\n        },\n        \"On 23 June, less than a year after replacing McKiernan, Obama accepted the resignation of McChrystal. The ISAF deputy commander,  British Lt. Gen. Nicholas R. Parker, assumed McChrystal’s duties until the appointment of a successor. The ISAF Web site posted the following announcement from McChrystal:\",\n        \"\\\"This morning the President accepted my resignation as Commander of U.S. and NATO Coalition Forces in Afghanistan. I strongly support  the President’s strategy in Afghanistan and am deeply committed to our coalition forces, our partner nations, and the Afghan people. It was out of respect for this commitment and a desire to see the mission succeed—that I tendered my resignation. It has been my privilege and honor to lead our nation’s finest.\\\"\",\n        \"Before McChrystal’s resignation, and with the support of Vice President Biden, Gates had tried to mediate the situation. However, when Gates asked McChrystal for his explanation, the only response he received was, “No excuse, sir”—the standard line expected from a new cadet at West Point. Gates, lamenting that McChrystal had given him nothing to work with, approached the president, who now seemed determined to take a stand against what he saw as a trend of insubordinate behavior by senior officers, including Petraeus, Admiral Mullen, and McChrystal. Gates told Obama, “If you lose McChrystal, I believe we lose the war in Afghanistan.” Gates cited the gains made in the relationship with Karzai and the length of time that might be needed to get someone else approved. “And without hesitation Obama says, ‘How about Petraeus?’”\",\n        \"${Enter Petraeus}{bold}\",\n        \"General Petraeus took over as ISAF commanding general on 4 July 2010. The selection of Petraeus to replace McChrystal surprised those who saw the change of assignment as a downward move in the profession of a respected and well-known senior commander. Nonetheless, Petraeus’ selection reassured allies of America’s commitment even after two senior American generals had been replaced in two years. The fact that the Obama administration could not easily afford to replace a third senior commander in Afghanistan granted Petraeus greater influence in Washington, D.C., circles than his immediate predecessors had had.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_8-4.png\",\n        \"caption\": \"General Petraeus\"\n      }\n    },\n    \"Petraeus immediately updated the Civil-Military Campaign Plan and published Operation Plan 38302 Revision 5. Both documents continued to  reflect selected elements of McChrystal’s vision, with the exception that they permitted more aggressive execution in order to meet the White House’s goal of buying time and space for the development of Afghan National Security Forces. Revision 5 adapted the existing campaign plan to six lines of operation:\",\n    {\n      \"list\": [\n        \"1. Protect the Population\",\n        \"2. Neutralize Insurgent Networks\",\n        \"3. Support Development of ANSF\",\n        \"4. Neutralize Criminal Patronage Networks\",\n        \"5. Support Development of Legitimate Governance\",\n        \"6. Support Sustainable Socio-Economic Development\"\n      ]\n    },\n    \"The overriding goal still was to protect the population, but the new ISAF commander would employ more aggressive methods to accomplish that task. Prioritizing the neutralization of insurgent networks over supporting ANSF development reflected Petraeus’ belief that both of those tasks were interrelated, but the former rated a higher priority because it also supported protecting the population by degrading the enemy’s capability to intimidate innocents. Yet Petraeus’ priorities also mirrored the Obama administration’s concerns about the Kabul government; the last three lines of operation concentrated on reform within Afghanistan rather than eliminating the enemy.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_8-5.png\",\n        \"caption\": \"Anaconda Strategy in Afghanistan\"\n      }\n    },\n    \"Building upon all of the troops and structure changes begun by McKiernan and McChrystal, Petraeus adapted to evolving battlefield dynamics by altering the trajectory of the surge to the degree necessary to achieve the goals sought by the White House, and monitored its progress. Under Petraeus, RC South completed Operation MOSHTARAK, and IJC oversaw the Afghan-designed Operation NAWEED (Good News). Petraeus’ efforts produced a timeline and plan for transition, with 2014 identified as the tentative completion year.\",\n    \"${Petraeus}{bold}${:}{bold} ${Counterinsurgency Legacy and the Iraq Effect}{bold}\",\n    \"With General Petraeus in command in Afghanistan, ISAF adopted a nuanced counterinsurgency approach, dubbed the Anaconda Strategy, that blended elements of the population-centric version advocated by McChrystal with the more kinetic aspects favored by McKiernan and his predecessors. To explain the numerous facets of the new approach to his superiors, allies, and subordinates, Petraeus prepared a visual aid modified from the same slide he used in Iraq to display his tailored amalgamation of theory, doctrine, and operational method.\",\n    \"While the Anaconda Strategy sought to reduce the visual representation of counterinsurgency to a single page, the number of items in the graphic overwhelmed the senses of many who viewed it. The graphic gave the impression that the enemy was surrounded by programs and efforts— some violent—aimed at suffocating him. This portrayal belied the fact that the thinly spread coalition forces often were the ones surrounded and outnumbered. Still, Petraeus believed the Anaconda Strategy made it easier for multiple audiences to visualize his approach, albeit with the risk that some might confuse aspirations with capabilities. The Anaconda Strategy slide sought to simplify the complicated nature of counterinsurgency; if nothing else, it convinced decision-makers that the general who created it had mastered its complexities. Given the dramatic downturn in sectarian and insurgent violence in Iraq following the arrival of sufficient U.S. troops to simultaneously protect the people and take the fight to the enemy, few could argue that the surge had not been an effective approach. However, several unacknowledged factors played a part in that success. First, the insurgents had located their primary operating bases within Iraq, not in neighboring Iran and Syria. Thus, they had no enabling sanctuaries similar to those used by the Taliban in Pakistan. In addition, the Iraqi government implemented sweeping (albeit temporary) concessions to the Sunni minority during the surge that contributed to the drop in violence. A similar compromise between Karzai and the Taliban seemed all but impossible. Finally, American troops in Iraq had protected civilians of all ethnicities from sectarian death squads, earning first their trust and then their support. Although the Taliban had been guilty of similar crimes during its conflict with the United Front, Mullah Mohammed Omar’s followers had not committed those deeds as part of a systematic ethnic cleansing program.\",\n    {\n      \"title\": \"Operation MOSHTARAK Phase III and Operation HAMKARI\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The first operation conducted under General Patraeus’ leadership was Phase III of Operation MOSHTARAK. As Americans surged into Helmand Province, the Taliban responded in Kandahar Province, Kabul, and elsewhere in eastern Afghanistan. In the south, ISAF documented the increasing toll suffered by Afghan civilians caught in the crossfire or deliberately targeted by insurgent IEDs, suicide-bombings, and assassinations. The first five months of 2010 were deadlier than the first six months of 2009. The new Taliban commander in the south was the 37-year-old Mullah Abdul Qayyum Zakir. Zakir was competent, charismatic, and a veteran military commander who recognized the value of IEDs and suicide operations. Like Mullah Dadullah Akhund, he had gained a reputation for extreme and uncompromising views.\",\n        \"During the previous summer, the Taliban had conducted intimidation operations in and around Kandahar City by assassinating key officials. The Afghan government managed to keep power in the provincial capital but was unable to prevent Taliban attacks. These killings continued through Phase II of MOSHTARAK. During 2010, a media source in the city documented almost 400 assassinations between June and September. While the Taliban in Kandahar City carried out some of these attacks, the majority were launched from strongholds in the outlying districts of Arghandab, Zharey, and Panjwa’i.\",\n        \"The Taliban recognized that, after Marjah, the next logical target for ISAF was Kandahar Province, a vital nerve center for the southern insurgency. The insurgents placed a high priority on defending their most important political and military stronghold, which promised to turn the struggle for Kandahar Province into a decisive engagement. The Taliban knew ISAF intended to increase its security forces in Kandahar and countered by importing volunteers from Pakistani madrassas and recruiting from the surrounding villages. The enemy fighters massing around Kandahar did not affect the ISAF deployment or subsequent operations materially, but they did make it more likely that innocents would be caught between the warring factions.\",\n        \"Phase II of Operation MOSHTARAK in Helmand Province had been highly publicized and quick. Phase III, redesignated as Operation HAMKARI, was designed to achieve dominance over the Taliban in three subphases. The first was to secure Kandahar City. The second subphase was to expand the security zone around Kandahar City and clear the Arghandab District to the northwest. The third and final subphase was to clear the Zharey and Panjwa’i Districts to the west and southwest. Upon completion of the final phase, it would be up to Afghan forces to hold the gained ground and maintain security. HAMKARI was also an attempt to persuade Pashtun tribes maintaining grudges against Karzai’s allies in Kandahar to support the central government. The fact that these tribes were culturally, socially, and religiously inclined to align with the Taliban made that goal problematic.\",\n        \"The preparation for HAMKARI was more deliberate than that for MOSHTARAK because ISAF officers knew the Taliban would commit to defending Kandahar Province. The terrain made the operation forbidding as most residents lived along riverbeds cut by canals. Living compounds were walled, with many roads flanked on both sides by hedgerow-like vines and hundreds of stone and masonry green houses. These features concealed movement and canalized routes, driving forces into choke points that made for optimal ambush sites. Shaping operations for Phase III were to be conducted by units already in Afghanistan as well as those that had not yet arrived. These units were to partner with ANSF upon arrival and gradually disperse throughout the province.\",\n        \"Four months seemed like such a long time to wait for HAMKARI to begin, and locals began circulating rumors that major coalition operations would not take place in Kandahar. A Marjah-style air assault into the middle of a Taliban stronghold was anticipated by the locals for several reasons. First, Kandahar City was not in the hands of the Taliban. Second, ANSF and ISAF had been operating in or nearby the city since 2001. The area had simply been falling under greater Taliban influence. Without reason to trust ISAF’s announced intentions, HAMKARI would surprise the population with its size and intensity.\",\n        \"${HAMKARI Overview}{bold}\",\n        \"Prior to Operation HAMKARI 2,000 Canadians had worked to control the approximately 1.2 million Pashtuns living in Kandahar Province. ISAF forces had now swelled to 24,000 soldiers and police before the attack; ANA force levels were tripled, and the Afghan police saw a five-fold increase in the province. For the first time, ISAF devoted enough forces to clear and hold Kandahar City’s outlying districts while simultaneously interdicting infiltration routes from Pakistan. ISAF commanders ratcheted up the pressure on Taliban leaders before the operation by increasing Special Operations raids. Despite making their own preparations, Taliban fighting cells were unable to stem ISAF’s growing influence in the region.\",\n        \"${HAMKARI Phase I}{bold}. Securing the city of Kandahar was never a matter of attacking to clear it, as there were no known enemy strongholds to eliminate. Instead, the first order of business was to increase ANSF presence in the city. Afghan security forces constructed and staffed sixteen checkpoints in and around the city. American Military Police assisted both the Afghan National Police and Civil Order Police in opening substations at each checkpoint. In sharp contrast to the Operational Mentor and Liaison Teams or Police Operational Mentor and Liaison Teams that commuted to work from an ISAF base, the Americans partnering with the Afghan police in Kandahar were collocated with their counterparts. By ensuring partnered units spent more time together, ISAF sought to increase the professionalism of the indigenous police in the shortest time possible. The checkpoints prevented enemy materiel and personnel from entering the city, and the basic plan paid quick dividends as violence within the city decreased dramatically.\",\n        \"Phase I initially involved establishing a loose cordon around Kandahar using troops siphoned from Col. Brian M. Drinkwine’s 4th Brigade, 82d Airborne Division (TF FURY) of Fort Bragg, North Carolina. Originally earmarked to provide security force assistance in RC West and RC South, Drinkwine’s unit was called upon to maintain a presence in the Arghandab, following the departure of the Stryker brigade, and to assume initial responsibility for Kandahar. The paratroopers were replaced in late June 2010 by Col. Jeffrey R. Martindale’s 1st Brigade Combat Team, 4th Infantry Division (TF RAIDER), of Fort Carson, Colorado, which served as part of the surge forces.\",\n        \"Martindale’s TF RAIDER consisted of Lt. Col. Charles Mitchell’s 7th Squadron, 10th Cavalry; Lt. Col. Clay Padgett’s 1st Battalion, 22d Infantry; Lt. Col. Rodger Lemon’s 1st Battalion, 66th Armored Regiment; and Lt. Col. Craig Berryman’s 4th Battalion, 42d Field Artillery. Mitchell’s reconnaissance squadron and Berryman’s field artillery battalion replaced their counterparts from Drinkwine’s brigade in RC West rather than accompany the remainder of their parent unit to Kandahar. The remaining elements of Martindale’s brigade, which also included Lt. Col. Christopher G. Beck’s 1st Brigade Special Troops Battalion and Lt. Col. Gregory S. Applegate’s 4th Brigade Support Battalion, were positioned within Kandahar or just north of the city. In addition to his own troops, Colonel Martindale received welcome assistance from Lt. Col. John G. Voorhees’ American 504th Military Police Battalion; Lt. Col. Conrad J. Mialkowski’s 1st Battalion, Royal Canadian Regiment; and Lt. Col. John M. Paganini’s 1st Squadron, 71st Cavalry, a U.S. unit operating with Canadian Brig. Gen. Jonathan H. Vance’s Task Force KANDAHAR.\",\n        \"${HAMKARI Phase II}{bold}. The critical district of Arghandab abuts Kandahar City to the north and west. It was here, during the 2001 invasion, that Karzai negotiated with major tribes to secure their support against the Taliban. In 2004 and 2005, U.S. units sought to keep the Taliban out of the region by building a road through the district. The handover to ISAF during the following year, in which a smaller Canadian force replaced a larger American one, changed the tactical balance. With the exception of Operation MEDUSA in September 2006, the initiative had swung to the Taliban by the time Colonel Tunnell’s 5th Stryker Brigade arrived in 2009. The 5th Stryker Brigade Combat Team believed it had begun to loosen the Taliban’s control before it was replaced by the 2d Battalion, 508th Infantry, from the 4th Brigade, 82d Airborne Division. To the residents of the Arghandab River Valley, the absence of a substantial coalition presence and the lack of progress by the Afghan government symbolized the apathy or incompetence of both outside parties. General Carter understood that this perception was the key “terrain” to clear and hold during HAMKARI.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-8-9.svg\",\n        \"caption\": \"Operation HAMKARI\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"The 2nd Brigade, 101st Airborne Division (TF STRIKE), under the command of Colonel Kandarian assumed responsibility for the Arghandab from the 2d Battalion, 508th Infantry, just prior to the execution of phase two. The incoming brigade combat team initially occupied forward operating bases located north of Kandahar as it prepared to mount successive operations in the northern and southern Arghandab. Kandarian’s formation included the 1st Battalion, 502d Infantry, under Lt. Col. Johnny K. Davis; the 2d Battalion, 502d Infantry, under Lt. Col. Peter N. Benchoff; 1st Squadron, 75th Cavalry, with Lt. Col. Thomas N. McFayden commanding; and Lt. Col. David S. Flynn’s 1st Battalion, 320th Field Artillery. Lt. Col. Thomas M. Spenard’s Support Battalion and Lt. Col. Alan R. Preble’s Special Troops Battalion rounded out the brigade combat team. In addition to his organic units, Colonel Kandarian received tactical control of Colonel Lemon’s 1st Battalion, 66th Armored Regiment, and 3d Squadron, 2d Stryker Cavalry Regiment, under Lt. Col. Bryan E. Denny.\",\n    \"TF STRIKE, along with other forces, cleared the Arghandab and Panjwa’i Districts in HAMKARI Phase II. RC South brought more combat power and combat multipliers to bear in the region than at any time before. Petraeus recognized that previous attempts to reduce civilian casualties, although successful, had been so stifling that offensive operations against the enemy had become less effective. He let it be known that he wanted to increase lethal operations against the insurgency. As Petraeus told Kandarian, “You know you’re the main effort of the world, right?” He then worked to get everything Kandarian asked for, including interpreters, mine-clearing equipment, military working dogs, and MRAPs. Although many of these shortages had been identified long before the current operation, most of them were not solved until Petraeus took a personal interest in the mission. From September to December, Kandarian received an infantry battalion from RC East in the form of 1st Battalion, 187th Infantry, under the command of Lt. Col. Robert J. Harmon Jr. With all the forces at his disposal, Kandarian quickly overwhelmed enemy resistance.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_8-6.png\",\n        \"caption\": \"A Soldier patrols\"\n      }\n    },\n    \"In September 2010, the border police commander from Spin Boldak, Abdul Raziq, approached SOF operating in northern Kandahar Province and offered his assistance. Raziq had conducted previous operations with coalition forces; nonetheless, he was controversial among ISAF staffers due to alleged criminal activity. Despite his poor reputation, Raziq was an able tactician, and was popular with the people of Kandahar for his previous contributions to their safety and security. His methods proved devastating to the Taliban, who feared and loathed him. When Raziq offered to clear Arghandab District—which the Taliban had repopulated since the departure of Tunnell’s units—special operators agreed and accompanied his men. On the first day, Raziq’s men removed more than one hundred IEDs and captured dozens of Taliban fighters with hardly any casualties. The speed and ease with which Raziq and his men cleared Arghandab—equipped with Toyota pickup trucks and armed with little more than AK47s and a few rocket-propelled grenades—amazed the special operators and impressed RC South leaders. The police commander from Spin Boldak eventually would be appointed chief of police for all of Kandahar Province and promoted to brigadier general. As Raziq’s forces cleared IEDs from roads, they also gathered valuable and actionable intelligence.\",\n    \"Raziq’s success did not end the fight for Arghandab District. Kandarian needed to be able to hold all the terrain secured by Raziq’s unconventional methods. The American commander felt he needed a minimum of twelve battalions to accomplish that task. Assigned only three organic maneuver battalions, two attached battalions, and six Afghan kandaks, Kandarian needed one more battalion. Before deploying, he had ordered Colonel Flynn’s 1st Battalion, 320th Field Artillery, to train as provisional infantry. This battalion, aided by Lemon’s dismounted tankers, routed the Taliban remnants ensconced in northern Arghandab District.\",\n    \"Intelligence provided by Raziq proved exceptionally useful for TF STRIKE. With mine-clearing equipment, the newly acquired MRAP vehicles, and dismounted patrolling, Flynn’s Task Force TOP GUNS truly cleared the Green Zone of Arghandab for the first time. In the process, they discovered that the villages of Tarok Kolache and Khosrow Sofla were devoid of inhabitants and full of explosives; they had been transformed into IED factories. Using 500-pound bombs and twenty-four tons of artillery munitions, TF TOP GUNS destroyed all structures, enabling the villages to be rebuilt safely.\",\n    \"The tone of the latest fight for the Arghandab reflected Petraeus’ adjusted campaign trajectory. Carter subsequently described the 1st Battalion, 320th Field Artillery’s reduction of the Taliban enclave in northwestern Arghandab as “the greatest achievement of my command.” Over a ninety-day period, Kandarian’s brigade expended 2,035 rounds of 155-mm. artillery, 2,952 mortar rounds, 60 guided rockets, 266 aerial bombs, 19 Hellfire missiles, and uncounted thousands of 30-mm. rounds delivered by A–10 attack aircraft or AH–64 Apache helicopter gunships. The shift to highly kinetic operations did not indicate that Carter had significantly changed his vision of the fight so much as it reflected his willingness to reduce enemy enclaves when suitable assets became available.\",\n    \"The efforts of Kandarian’s brigade combat team were consistent with the ISAF commanding general’s guidance. All told, TF STRIKE killed hundreds of Taliban fighters at the cost of 65 killed and 426 wounded. Although the 5th Stryker Brigade Combat Team had garnered a reputation for unnecessarily heavy casualties, with 37 killed and 239 wounded while fighting the Taliban in that same region, those losses occurred under a different ISAF chain of command that had placed a higher priority on protecting the population than on eliminating the enemy deep in the Arghandab. Whereas Tunnell’s methods had caused friction with his superiors, Kandarian’s similarly unrelenting emphasis on taking the fight to the Taliban met with his superiors’ approval.\",\n    \"${HAMKARI Phase III}{bold}. ISAF renamed HAMKARI Phase III Operation DRAGON STRIKE before its execution. As the last large-scale operation in Operation ENDURING FREEDOM, clearing Zharey and then Panjwa’i Districts would mark the turning point in the surge. From September to October 2010, Operation DRAGON STRIKE featured three battalions of U.S. infantry simultaneously clearing eastern, central, and western Zharey with partnered kandaks. Both of Kandarian’s organic infantry battalions attacked southward through the objective area while the attached 3d Squadron, 2d Stryker Cavalry Regiment blocked enemy escape to the west. In the finale, Colonel Harmon’s 1st Battalion, 187th Infantry, on loan from RC East; SOF; and three Afghan kandaks cleared the horn of Panjwa’i in a two-day operation that began on 15 October. Harmon had expected to be tested by stiff enemy resistance in this last Taliban enclave, but the enemy leadership fled for the city of Kandahar where they melted into the population rather than fight to the death.\",\n    \"Despite launching violent clearing operations around Kandahar, HAMKARI was not a “gloves off” approach to counterinsurgency.  The rules of engagement for RC South were in some ways more restrictive than ever. Operational implications meant that leaders had to take even more care and time to prepare for missions. Before, during, and after each patrol, Kandarian’s troops had to answer fourteen questions:\",\n    {\n      \"list\": [\n        \"1.\\tDid the mission include Afghan National Army or Afghan National Police?\",\n        \"2.\\tWere there any civilians killed or wounded?\",\n        \"3.\\tWas the local civil leadership notified ahead of time?\",\n        \"4.\\tDid they agree?\",\n        \"5.\\tWere bombs dropped, attack helicopters used, artillery delivered, or mortars  fired?\",\n        \"6.\\tDid the enemy present an imminent threat?\",\n        \"7.\\tWere any houses entered without invitation?\",\n        \"8.\\tDid the Afghan forces do the home entries?\",\n        \"9.\\tDid any element enter a mosque?\",\n        \"10.\\tWere any civilians searched?\",\n        \"11.\\tDid the unit search the objective to locate enemy and civilian casualties and material damage?\",\n        \"12.\\tWere there any unobserved fires?\",\n        \"13.\\tHad any escalation of force incidents occurred?\",\n        \"14.\\tWere the Afghan or Western media informed?\"\n      ]\n    },\n    \"This checklist ensured that organic units and those attached to TF STRIKE employed artillery and airstrikes only when necessary. Each question sought to protect troops from violating the laws of armed conflict and the theater-prescribed rules of engagement. Many military leaders complained about the questions, but they established control measures necessary to preventing and minimizing civilian casualties.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-8-11.svg\",\n        \"caption\": \"Operation HAMKARI Phase III\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"Other kinetic and lethal operations, such as the intelligence-driven night raids by SOF, spiked in frequency after Petraeus assumed command. These raids inflicted unprecedented losses on the Taliban. As soon as an insurgent leader rose to a command position, he became a high-value target whose life expectancy was measured in days, not months. The tempo and scale of these operations made life exceedingly difficult for the enemy, regardless of the support that the Taliban continued to enjoy among portions of the local populace. Over a thirty-day period in the summer of 2010, Afghan and ISAF forces eliminated most high-level Taliban leaders in southern Afghanistan; in September, SOF captured twenty-one Taliban fighters in Kandahar City alone. The visiting head of the Virginia-based Joint Forces Command, Marine General James N. Mattis, was so impressed that he told reporters, “Taliban commanders shouldn’t invest in 401(k)s.”\",\n    \"By November 2010, Afghan and ISAF forces had eliminated the Taliban as major players in the provincial capital of Kandahar and its outlying districts. That effort had required more than 24,000 troops, police, and other security forces. After clearing western Kandahar Province, most of the conventional units in Afghanistan pursued hold and build operations. This transition meant that, while some battalion-sized operations still took place, most missions were company-sized or smaller. The enemy was still present, though not in strength. Fighting remained dangerous at the platoon level during these small-scale operations, but there would be no further large-scale clearing operations after the surge peaked in March 2011.\",\n    \"By 2011, Kandahar had moved fully from the clear phase into the hold phase. Unfortunately for the coalition, their efforts stalled here. Afghan civilians in several key regions did not support ANSF in great numbers despite the promise of economic development and improved governance in exchange for withholding support for the Taliban. For the most part, locals never really turned away from the Taliban to support ISAF or the Afghan government. Even though the Taliban had lost many leaders, its fighters continued attacking with suicide bombers, IEDs, and other small-scale operations. When civilians were caught in the crossfire, these events undermined trust in the Afghan government, not the insurgency. One Taliban supporter who eventually became a suicide bomber in Panjwa’i declared, “It [violent resistance] will not stop; this will continue until the day of judgment.” Statements such as these indicated that even though the counterinsurgency campaign could produce tactical victories and some measurable operational progress, there would be little progress at the strategic level so long as the influence of the radical ideology nurtured within the sanctuary of Pakistan went unchecked.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_8-7.png\",\n        \"caption\": \"Vice Admiral Harward\"\n      }\n    },\n    \"${Surge Detentions}{bold}\",\n    \"In 2009, General Petraeus, while commanding CENTCOM, dispatched Marine Maj. Gen. Douglas M. Stone to Afghanistan to evaluate the ISAF detention system. Stone had successfully reformed detention operations in Iraq following the Abu Ghraib scandal, and so Petraeus selected him to review the status of detainees in Afghanistan’s Law of Armed Conflict detention facilities, which were designed to hold those captured on the battlefield. During his tenure in Iraq, Stone learned that detention facilities were serving as recruiting centers for the enemy, and he knew this was likely the case in Afghanistan as well. He confirmed those suspicions in what came to be known as the Stone Report, a comprehensive interagency examination of detentions in Afghanistan. Stone’s revelations led to a new detention facility being built at Parwan, adjacent to Bagram Air Base. This not only consolidated detainees in one modern facility, but also brought together the entire spectrum of critical functions, including incarceration, interrogation, skills training for moderate detainees (who were now held separately from those identified as extremists), and even access to legal services to review the cases of detainees. Stone also recommended the immediate release of 400 to 600 detainees who had no ties to the insurgency and posed no real threat.\",\n    \"On 9 July 2009, just a few weeks after arriving in Afghanistan, McChrystal requested to establish Joint Task Force 435 (later Combined Joint Interagency Task Force 435) to command Law of Armed Conflict detentions operations. McChrystal’s request was approved, and the task force stood up on 24 September 2009, although it did not reach fully operational capability until January 2010. Initially commanded by V. Adm. Robert S. Harward and later by Lt. Gen. Keith M. Huber, the unit reported to USFOR-A, not ISAF, so as to maintain a U.S. chain of command. This was possible since most coalition nations preferred to turn their detainees over to nascent Afghan legal authorities for prosecution and detention.\",\n    \"The new headquarters was not established just to detain and hold enemy combatants. Joint Task Force 435 had a robust military interrogation organization that could rapidly and effectively collect and discern actionable intelligence that was fed back to the battlespace owners and SOF for future operations. The information collected in these interrogations was also critical for discerning real, long-term threats versus what was termed the “$10-a-day Taliban”—those detainees who merely fought on occasion to put food on the table.\",\n    \"Changes to the detention process were well timed. Predictably, incarcerations by U.S forces rose dramatically during the surge, doubling the number of detainees by 2010 and again by the end of 2011. During 2010, U.S. forces took 6,439 individuals into custody, of whom 1,359 (21 percent) were transferred to Parwan for long-term detention. Since 2001, 3,599 of the 6,006 detainees to pass through the U.S. detention facilities in Afghanistan had been released, and 54 individuals had been recaptured while fighting for the insurgency, for a 1.5 percent recidivism rate. About a third of all detainees held during all of Operation ENDURING FREEDOM up to this point were detained during the surge.\",\n    \"Recognizing that it could not oversee detentions indefinitely, the U.S. military sought to turn that responsibility over to  the Kabul government. Joint Task Force 435 managed that transition. The first step was to reevaluate all detainees to determine which could be released, which should be turned over to the Afghans, which non-Afghan citizens should be transferred to other countries, and which still had intelligence value and warranted continued detention. During 2010, U.S. forces conducted 2,342 detention review boards—the legal process that discerned the category to which a detainee belonged. About 1,450 Afghan community members and Afghan government officials participated in the hearings at Parwan. They also provided testimony via video, telephone, letters, and other written material. In roughly 75 percent of the boards, representatives from coalition forces outlined the factual basis for capture by appearing in person, participating via video, or submitting written correspondence; at times, they even spoke on behalf of the detainee. Following the review boards, the detainees faced four options: release, continued internment, referral for prosecution by the Afghan government, or transfer to their country of origin. By the end of the year, 10 percent of the detainees were released, along with another 9 percent who met the criteria for continued detention but were released via reintegration recommendations. A further 58 percent remained in internment, which meant that they continued to have intelligence value or were considered too dangerous to be released. Finally, 21 percent were referred for prosecution by the Afghan government, and 2 percent were transferred to their country of origin.\",\n    \"In 2011, U.S. forces captured more than 9,000 enemy combatants, a 35 percent increase from the preceding year. Of that total, more than 2,000 were transferred to Parwan. The results were 4 percent released; 2 percent met criteria, but were released via reintegration recommended; 76 percent continued internment; and 18 percent referred to the Afghan government for prosecution. The increased inflow, coupled with less-frequent releases by review boards, doubled the overall detainee population for a second year in a row. This growth triggered discussions about housing capacity, which led to a plan to increase capacity by more than 2,100 beds.\",\n    \"Joint Task Force 435 also worked to increase the ANA’s ability to assume the Law of Armed Conflict detention mission when the time came to transition the function to the Afghan Ministry of Defense. An ANA military police brigade worked side by side with its U.S. counterparts to learn all facets of military detention. The Parwan facility eventually was successfully transferred to Afghan control. ISAF then mandated that Joint Task Force 435 partner with and mentor the Afghan Central Prisons Directorate to increase the capacity of the Afghans to detain their civilian criminal population at acceptable international standards. Although efforts in this vein were often lethargic, progress was made and measureable in this critical area. Both the military and civilian detention missions amplified the importance of building the capabilities and capacity of host-nation entities to ensure long-term stability.\",\n    \"The surge period was marked by an increase in operations on the ground and an uptick in number of detainees. However, with this renewed push came the knowledge that the U.S. and ISAF missions were operating under a deadline. Extensive operations like MOSHTARAK and HAMKARI demonstrated that counterinsurgency techniques could produce positive results, but only the increased capacity of the Afghan security forces would be able to extend and maintain the security reach of the coalition. As the Afghan government continued to expand its area of control over the country and reduce the insurgent threat, the focus of U.S. and ISAF efforts would turn to preparing the Afghan forces to take control of the fight.\"\n  ],\n  \"chapter 9\": [\n    {\n      \"title\": \"Preparing the Afghans to Take Over the Fight\"\n    },\n    {\n      \"section\": [\n        \"At the beginning of the surge, it was apparent to senior American and ISAF officials that it would be impossible to stabilize Afghanistan without indigenous governance and security capacity. The commander of the United States’ CSTC-A was responsible for training the ANSF, developing ministries, and funding security assistance under Title 22 of the U.S. Code. In April 2009, President Barack H. Obama pressed for NATO leaders to adopt the recommendations of the Riedel Report during a conference held to observe NATO’s sixtieth anniversary at Strasbourg, France. One of the top recommendations involved creating a new organization to oversee the training and equipping of the ANSF. A multinational approach would allow member states to contribute as they saw fit to the Afghan security sector. The North Atlantic Council formally approved the concepts discussed at Strasbourg on 12 June 2009.\"\n      ]\n    },\n    {\n      \"title\": \"The Pivotal Role of the NATO Training Mission, 2009–2011\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"CTSC-A formed the core of the new organization, designated as NATO Training Mission–Afghanistan, which also replaced the ISAF Directorate of Afghan National Army Training and Equipping. Giving the same officer command of both the new organization and its American counterpart provided both the unity of effort and the unity of command absent from previous efforts to develop the Afghan security forces. The commander would remain a U.S. officer to ensure the legal spending of American funds designated for the mission, and also would be the commander of the NATO element. Yet even though the NATO Training Mission–Afghanistan was to be a focal point for all security sector reforms, ministerial development remained conspicuously absent from the alliance’s agenda. That critical task would remain solely an American effort.\",\n        \"The designated commander of the NATO Training Mission, American Lt. Gen. William B. Caldwell IV, received guidance from Secretary of Defense Robert M. Gates before departing the United States. During one meeting, Gates told Caldwell, “Look, when you get over there what I need you to tell us [is:] ‘Is this mission even doable?’ And, if it is doable, [to] what level can we realistically expect to be able to grow the Afghan National Security Force?” Gates’ concerns stemmed from the fact that previous efforts to increase the size of the ANSF had been negated by attrition and inadequate recruiting. The secretary of defense expected Caldwell not only to integrate current U.S. efforts with NATO programs but also to make the combined ANSF development effort more productive and efficient.\",\n        \"General Caldwell departed for his new assignment accompanied by two members of his personal staff. Because the U.S. Congress did not confirm Caldwell’s promotion until three days before he left the United States, he landed in Kabul without any preparatory training or structural reorganization having taken place. In addition, he had to sort through evolving internal responsibilities generated by an ongoing reorganization. With the exception of twenty to thirty individuals, Americans filled all billets in Caldwell’s headquarters. Just two countries—the United States and Italy—were the inaugural members. Caldwell later reflected, “[T]here was really just three [sic] nations when we stood up the training mission that had forces on the ground that were ready to be a part of and contribute to that mission; with promises of more coming in all ready at that point. Almost all funding for [NATO Training Mission–Afghanistan] also came from the United States.” The change of command between Caldwell and outgoing CTSC-A commander Maj. Gen. Richard P. Formica took place at Camp Eggers in Kabul on 21 November 2009. Not only did Caldwell have to deal with bureaucratic turbulence upon his arrival, but one of the first ISAF directives he received mandated that NATO Training Mission–Afghanistan transfer 10 percent of its end strength to the newly created IJC headquarters. General Stanley A. McChrystal’s well-intentioned but ill-timed effort to bolster IJC resulted in the secretary of defense diverting the 10th Mountain Division’s 2d Battalion, 22d Infantry, to Caldwell’s unit in December 2009 to alleviate his personnel shortfalls. Although the arrival of an infantry battalion provided relief, the command faced personnel shortfalls for the first two years of its existence. The training mission ostensibly was a top priority in Afghanistan, but it comprised only 3 percent of ISAF’s total workforce. The average trainer-to-trainee ratio was 1 trainer per 79 trainees; some locations had a better ratio, while other training sites had only 1 trainer per 466 trainees. When Caldwell took over NATO Training Mission–Afghanistan, he counted one soldier on hand for every four authorized positions. Although more personnel were forthcoming, his command rarely averaged more than 60 percent for the first two years of its existence.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_9-1.png\",\n        \"caption\": \"General Caldwell briefs Ambassador Eikenberry\"\n      }\n    },\n    \"Caldwell intended to ensure that Afghans were capable of conducting operations without considerable coalition assistance for an  entire campaign. He sought to create an ANSF that could prevail in battle and also demonstrate the durability to sustain efforts. Maintaining a purely tactical approach to developing the ANSF would have made it impossible to accomplish this goal. In the American view, growing Afghanistan’s security forces included professionalizing its training, educational, and recruiting programs and developing self-sufficient defense and interior ministries. It focused more on building and supporting the institutions as a whole, as opposed to just training the frontline forces. It was no accident that the NATO Training Mission adopted as its motto the Dari phrase shona ba shona, meaning shoulder-to-shoulder. From its modest beginnings in 2002 with a 600-person kandak, the ANSF grew until it could fight alongside other coalition forces. This progress addressed one of the most fundamental goals for the success of counterinsurgency: creating a self-sufficient, capable, and sustainable ANSF.\",\n    \"${The Building Blocks of Professionalism}{bold}\",\n    \"Before Caldwell assumed command, he met with Richard C. Holbrooke. Holbrooke told the general, “You’re really going to have to  take on the illiteracy issue.” Caldwell answered by explaining, “Ambassador, with all due respect I’m a soldier, I don’t do literacy training.” Less than two weeks after arriving, the new NATO Training Mission–Afghanistan commander realized just how uninformed he had been on that topic. As he later reflected:\",\n    {\n      \"list\": [\n        \"\\\"About 14 percent of the recruits coming in had some level of literacy—14 percent. That meant 86 percent of the recruits coming  in could not read, write, or even count. They had no capability. I’ve been in a lot of places over my career. I had never seen the level of illiteracy or failed to recognize the dramatic impact that that has when you’re trying to build a sustaining, enduring kind of capability.\\\"\"\n      ]\n    },\n    \"In early spring 2010, Caldwell decided to mandate literacy training for ANSF personnel. It took almost half a year for him to obtain funding, acquire materials, develop courses, hire teachers, and send them to Afghan bases. Caldwell later acknowledged, “Dr. Jack Kem led that effort . . . and he did an incredible job of making that happen.” NATO Training Mission–Afghanistan sought support from the Afghan government and NATO. Literacy lesson plans, for example, required Ministry of Education approval. Caldwell also championed a NATO educational trust fund so that member nations that did not want to send personnel to Afghanistan could contribute to the literacy program. When soliciting Western support for this program, training mission representatives argued that “a literate workforce is more likely to observe, understand, and report corrupt behavior. Additionally, a literate workforce is less susceptible to radicalization as they can self-educate and ‘cross-check’ the ‘truth’ being proffered by radical leaders.” Caldwell did not feel that he could pursue the state-building goals sought by the Obama administration without teaching Afghanistan’s soldiers and policemen how to read.\",\n    \"The literacy program had to instruct new inductees, enlisted soldiers, noncommissioned officers, and commissioned officers. Recruits received lessons covering the most common and basic military terms during their eight weeks of initial entry training, while leaders were expected to gain even higher levels of proficiency by attending specialty schools or professional development courses. Instructing soldiers already in the operational force on the front lines presented the greatest challenge. Out of 88,000 ANSF attending literacy training during 2010–2011, only 33,000 received instruction during initial entry or professional development training. The remaining 55,000 received the training while serving in police and army units. The literacy program had to expand every time more local security organizations or ANSF units were generated. Although the literacy program may have made it easier to train soldiers, its impact on ANSF combat effectiveness remained to be seen.\",\n    \"Improvements in literacy proficiency within ANSF ranks did produce near-term benefits by facilitating a nationwide inventory of weapons, communications equipment, and vehicles by Afghan security forces. Although eight months elapsed between the introduction of literacy training and the start of the inventory, Caldwell tolerated the delay because the end state—an account of all the equipment provided to the Afghans since 2002—was only worthwhile if it proved accurate. The inventory took place incrementally, focusing successively on vehicles, weapons, and then communications equipment. The inventory determined what units owned and provided a baseline for identifying the future needs of an expanding ANSF. It helped develop Afghan security forces by demonstrating the value of equipment accountability and the way to conduct a nationwide inventory.\",\n    \"Caldwell also sought to synchronize ANSF concepts of waging war with those practiced by Western troops. He recognized that following a counterinsurgency approach based on U.S. doctrine would be far less effective if ISAF’s Afghan partners did not follow its precepts. Since the best way to instruct Afghan units was through partnering with coalition forces, the training mission commander pushed to have deploying units train in the Dari and Pashto languages as well as cultural sensitivity and religious awareness. This would facilitate a better understanding and working relationship between the partners, exponentially increasing both the efficiency and the effectiveness of the partnership.\",\n    \"NATO Training Mission–Afghanistan devised an ANSF counterinsurgency training model that combined Western and Afghan concepts. This model included more than a refresher on counterguerrilla tactics by introducing students to the economic, political, and military aspects of the warfighting approach. It consisted of three components featuring both individual and collective training approaches. The first component focused on the professional development of noncommissioned and commissioned officers by sending them to an Afghan-led counterinsurgency academy. The second component consisted of rotating kandaks from the operational force through a counterinsurgency-oriented training center. Mobile training teams that deployed to kandaks unable to attend the collective training center were the final component of the Afghan counterinsurgency triad.\",\n    \"${ANSF Expansion}{bold}\",\n    \"The surge in Afghanistan was not just an American or coalition effort. Although American forces in Afghanistan increased from 28,000 in 2008 to more than 100,000 in 2011, and the contributions of other nations grew from 32,000 to nearly 50,000 during the same period, population-centric counterinsurgency could not be pursued in the country unless comparable increases were made in Afghan security forces. ISAF’s efforts to develop the ANSF had initially stressed numbers over quality. Unit partnering then provided ANSF units the opportunity to develop competence and confidence while executing the security mission. The idea was that once fully formed in 2012, the ANSF could address shortfalls in equipment, logistics, personnel, and leadership. After 2012, ISAF shifted focus to enabling the ANSF and professionalizing its units before ISAF combat operations ended in 2014.\",\n    \"At its inception, the NATO Training Mission inherited the Combined Security Training Command’s goal of growing the ANSF to 195,000 (100,000 in the ANA, 95,000 in the ANP). By March 2011, ANSF authorizations had grown to 276,000, increasing even further to 330,000 in March 2012. By September 2011, the ANSF finally started to approach its expanded authorizations. As the surge recovery began and coalition forces started departing Afghanistan, the Afghan Army and Air Force had 170,781 soldiers and airmen, with another 136,122 in the national police for a total of 306,903. The NATO Training Mission needed to increase its trainers quickly in order to keep up with the growing ANSF numbers. At its founding in November 2009, Caldwell’s organization had 3,000 members, of which only thirty were from coalition nations. By November 2010, it had more than doubled in strength to 6,497, with slightly more than 1,000 international trainers from 37 different troop-contributing nations. By the end of 2011, the number of international trainers reached 1,600 with another 700 pledged. Although the mission had grown substantially, it was still 460 trainers short of its authorized level of 2,760. As the organization’s commander, Caldwell tried to convince ambassadors to maximize their nations’ participation in the training mission.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_9-2.png\",\n        \"caption\": \"ANA recruits fire .50 caliber machine guns\"\n      }\n    },\n    \"At the May 2012 NATO Summit in Chicago, ISAF troop-contributing nations agreed to decrease the ANSF end strength to a “sustainable level,” with the goal of Afghanistan being able to fund its security forces by 2024. As the ANSF increased from 330,000 to 352,000 personnel, with an additional 30,000 Afghan Local Police, it became obvious that the Kabul government could not financially maintain a force of that size without international assistance. The dependence on U.S. and ISAF tactical support was particularly critical for Afghan special operations and aviation units. The Afghan security ministries were equally dependent on coalition assistance in planning and sustaining extended campaigns. The premise upon which ISAF had defended building the ANSF to almost 400,000 personnel was that an aggressive expansion would beget security gains impossible to reverse by the time Afghan security forces would have to reduce to a sustainable level. ISAF established Operational Coordination Centers to interact with ANSF components regionally and provincially. At the regional level, coordination occurred among the Afghan Army, National Police, and Border Police. At the provincial level, Afghan Army brigades coordinated with provincial chiefs of police and the nearest Border Police brigade. Local police secured areas outside those of conventional ANSF units, in addition to providing early warning to the other Afghan security forces.\",\n    \"An urgent need to overhaul the police training managed by the U.S. State Department soon surfaced as one of Caldwell’s top priorities. As one member of Caldwell’s command noted, the police training effort experienced major problems with the manner in which contracts were written, as well as the fact that “contractors . . . had no incentive to work themselves out of a job [by teaching] the Afghans to [train] themselves.” Rather than scrap the existing program, Caldwell directed the current contract be amended. As the revision neared completion in March 2010, it encountered a legal challenge in U.S. courts. Faced with at least a twelve-month delay, Caldwell turned to NATO for assistance.\",\n    \"Recognizing that European law enforcement organizations with paramilitary skills possessed the best qualifications to teach these skills to Afghan police, Caldwell’s staff began soliciting trainers from NATO members that had national paramilitary police forces, such as Romania, France, and Italy. However, NATO Training Mission–Afghanistan acknowledged that it would never acquire enough NATO trainers to replace contractors; therefore, recruits would have to receive instruction from contractors until the legal challenges to the new contract could be resolved. Lacking more NATO police trainers, Caldwell focused incoming NATO assets at installations and facilities his planners deemed most critical to the overall effort. The training programs at installations lacking full-time NATO representation were revised once the legal challenges to the new contract were resolved.\",\n    {\n      \"title\": \"Special Operations and Local Security Forces\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Numerous programs and initiatives arose throughout the duration of the U.S. mission to establish local police forces that better understood the environment and the populations where they served. With the completion of the disarmament, demobilization, and reintegration program, but with ANA capacity still lacking, tribal elders called upon ISAF, U.S. forces, and President Hamid Karzai’s government to support forming local militia formations known as arbakai. Fearing a return to warlord militias, the Karzai government instead agreed with a Combined Security Training Command and Ministry of Interior initiative known as the Afghan National Auxiliary Police. Instituted in late 2006 with the support of Ambassador Neumann and General Eikenberry, the program would recruit a community policing force from the local populace. Those selected would receive uniforms, weapons, eighty hours of training, and approximately $70 a month in salary.\",\n        \"Although the program called for more than 10,000 auxiliary police, it had come under scrutiny by May 2008 because of inadequate vetting, poor accountability, unclear lines of command and control, and inadequate logistical support. The effort ended in failure, and the units were disbanded. Some auxiliary police were absorbed into the Afghan Uniformed Police, Border Police, or recruited into the Afghan National Civil Order Police upon the program’s termination in September 2008. However, the poor literacy rates and lack of competency of those auxiliary police that transferred to national police units adversely affected the quality of the gaining units. The failure of the Afghan National Auxiliary Police program also had a measurable, negative impact on police recruitment across the nation.\",\n        \"By 2010, after lengthy negotiations with the IJC, the Karzai government again agreed to establish local security forces in remote provinces. Their creation involved identifying areas that wanted the security, vetting those able to provide the security, empowering and minimally resourcing those willing to provide volunteers, and then supporting the organizations with ANSF assistance and guidance. This process would be the model for what would become the Afghan Local Police. The new program would get off to a slow start, as numerous organizations had large roles in the planning, including the Afghan Ministry of Interior, ISAF, and Combined Forces Special Operations Component Command–Afghanistan, all of which actually would execute the program.\",\n        \"${Decentralizing Security: Afghan Public Protection Program}{bold}\",\n        \"In January 2009, ISAF created a new one-star Special Operations headquarters to provide an operational-level command and control headquarters for NATO forces. Army Brig. Gen. Edward M. Reeder Jr. took charge of the new organization, designated Combined Forces Special Operations Component Command–Afghanistan. Although this new command continued to develop the Afghan special operations kandaks and brigades, and conducted counterterrorism operations against mid-level Taliban and al-Qaeda leadership, it sought to place more emphasis on local security initiatives. Reeder soon discovered that General David D. McKiernan agreed with that approach and had already implemented an experimental program along these lines, the Afghan Public Protection Program, in Wardak Province.\",\n        \"Recruiting for the program, overseen by a Special Forces company led by Maj. Bradley D. Moses, began immediately after Reeder’s arrival. Rather than create a Western-style paramilitary organization, the program drew inspiration from the accepted practice of establishing arbakai. The arbakai differed from previous militias because they formed only when tribal elders determined a need for collective security against external threats. The program sought to correct earlier failures by recruiting only motivated individuals; providing the proper equipment, training, and salaries; and bringing in Ministry of Interior police from district offices to mentor the units. Although the training regimen was shorter than that of a conventional Afghan police recruit, it was conducted at an established police training facility in Mehtar Lam, Laghman Province, and overseen by the same SOF that would later mentor the police in Wardak.\",\n        \"The first forces trained and equipped by the program completed their training in March. The forces were to be employed by the Ministry of Interior in conjunction with McKiernan’s Focused District Development program. By tying the local police initiative to Focused District Development, the coalition and Afghan government alike hoped to reward increased security through additional infrastructure improvements and in turn provide enhanced security for those same projects. Based on the initial success of the program, Reeder pushed to expand the Afghan Public Protection Program throughout the country, and put his staff to work developing an approach focused on internal motivation and Afghan-sponsored solutions. Expanding the program required the support of the ISAF commander, the State Department, and, most importantly, the Afghan government.\",\n        \"The approval process began anew when McChrystal replaced McKiernan. McChrystal approved Reeder’s plan to begin trial runs for six months while attempts were made to subordinate the program to the Ministry of Interior. Labeled the Community Defense Initiative, McChrystal’s idea was distinct from the Afghan Public Protection Program in that locals would volunteer to participate in the initiative to resist the Taliban, request permission to form security forces, provide their own weapons, and receive no salary. Afghan government support would be limited to ammunition, communications equipment, food, and training. Although there were a few Community Defense Initiative success stories, the program never received Karzai’s endorsement.\",\n        \"Adding to the difficulties of gaining a viable local security program was the deterioration of the Afghan Public Protection Program by early 2010. The program faltered as it handed over vetting, partnering, and mentorship responsibilities to unprepared and underresourced conventional battlespace owners. It could not overcome a drastic shift in mission from point defense of the local populace and infrastructure to that of mounted highway patrol. It was further weakened when local political leaders tried to install men with questionable motives as unit commanders and unquestionable loyalty to the politician. Seeking to correct these deficiencies, the coalition Special Operations command renamed the program the Local Defense Initiative but still faced challenges from within the coalition and resistance from the U.S. Embassy.\",\n        \"In March 2010, Brig. Gen. Austin S. “Scott” Miller assumed command of the Combined Forces Special Operations Component Command–Afghanistan and, in April 2010, USFOR-A gained operational control of the headquarters. Miller embraced the program and made it his primary focus. Following the path forged by Reeder and foundations established by 3d and 7th Special Forces Groups, his command began addressing obstacles to community defense at both the operational and tactical (or local) levels. Seeking to flatten his organization, optimize assets in theater, and integrate his plans into Afghan government efforts, Miller called on the new commander of CJSOTF-Afghanistan, Col. Donald C. Bolduc, to overhaul the Local Defense Initiative.\",\n        \"In May 2010, Miller provided a new blueprint now known as Village Stability Operations. Pentagon officials described Village Stability Operations as “a bottom-up counterinsurgency initiative” designed to promote local governance and development by creating secure rural villages. A twelve-man SOF team conducted each operation, establishing itself within selected villages to engage regularly with locals and gauge whether the program would succeed in the area. Village Stability Operations teams linked to district and provincial augmentation teams, as well as Provincial Reconstruction Teams, through Village Stability Platforms that house security and stability assets. Village Stability Platforms required a self-nominated village, an embedded SOF team, ANSF battlespace owners, participation by district and provincial governments, and Ministry of Interior approval and resourcing. Most Village Stability Platforms would request and develop their own Afghan Local Police forces monitored and supported by the district and provincial Afghan National Police commanders. The Afghan government and ISAF enabled the effort through village stability coordination centers where district and provincial augmentation teams received infrastructure improvement projects funded by Provincial Reconstruction Teams.\",\n        \"Using the combined joint special operations task force’s extensive analysis from August 2009 through February 2010 and interviews with local, district, and provincial leaders, the Village Stability Operations pilot program began in five districts in May 2010. In acknowledgment of their success, Karzai signed a presidential decree in August 2010 officially integrating the Afghan Local Police into the Ministry of Interior. Connecting district and provincial governance to national leaders and ministries, mentorship and support from ANSF units, and joint oversight between ISAF and the Afghan government had provided enough layering to satisfy all interested parties.\",\n        \"American SOF units supporting the growing Village Stability program were called upon to employ infantry and Commando kandaks to targeted districts. In many cases, a preliminary clearing operation was required. SOF partnered with the ANA to conduct clearing operations, and then remained on site to serve as civil affairs and military information support teams to publicize opportunities for the Village Stability Operations. In the arbakai tradition, and with prior coordination of the district and provincial governance, embedded SOF, ANA, and ANP units would promote shuras leading to a jirga (larger tribal assembly) and the appointment of volunteers to form Afghan Local Police. Embedded SOF and ANA personnel would vet the nominees through Ministry of Interior, National Directorate of Security, and ISAF security organizations. The new Afghan Local Police unit received training, uniforms, weapons, communications equipment, and vehicles but was not granted the authority to arrest anyone. With local security established, the villages became more resistant to Taliban influence, allowing the coalition military commander, reconstruction teams, nongovernmental organizations, and Afghan government to pursue infrastructure development and other quality of life initiatives.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_9-3.png\",\n        \"caption\": \"Afghan Commandos\"\n      }\n    },\n    \"The Village Stability Operations soon expanded to twenty-three sites, and the appetite for the program began to exceed available SOF teams. The model relied on competent and relatively uncorrupt district and provincial leaders in both the government and police. Those areas supported by district augmentation teams and Provincial Reconstruction Teams were able to mentor these leaders or advocate for the removal of poor leaders. Additionally, resourcing these efforts required close coordination with the Afghan Ministry of Interior, the U.S. State Department, and the NATO Training Mission.\",\n    \"However, not all village stability sites succeeded in forming Afghan Local Police, and not all Village Stability Operations efforts were initially successful. As Village Stability Operations proliferated, Combined Forces Special Operations Component Command–Afghanistan and ISAF Special Operations Command realized the resources required to train and support their foreign internal defense programs, including Village Stability Operations, resided in the NATO Training Mission. Seeking to synchronize both efforts, U.S. Special Operations Command commander Admiral Eric T. Olson and McChrystal agreed to assign an assistant commander for Special Operations to the NATO training organization. General David H. Petraeus supported McChrystal’s decision after the latter’s departure, with the result that Brig. Gen. James B. Linder arrived in October 2011 to oversee the Afghan Special Forces, special police, and Village Stability Operations initiatives. By integrating Village Stability Operations into IJC’s Operational Plan, OMID 1390, and the ISAF commander’s 2011 campaign plan, Linder synchronized all special operations efforts in Afghanistan. Although it was difficult to coordinate the layered security involving a multitude of Afghan security entities, strong leadership and aggressive mentorship overcame these challenges. The many efforts began to coalesce in early 2012.\",\n    \"The success of Village Stability Operations produced unexpected challenges. While Karzai officially validated the program by inducting units into the Ministry of Interior in 2010, he simultaneously outlawed private security forces. Although he initially required all private security forces to disband by 1 January 2011, he later allowed them to remain until 20 March 2012. Beyond this date, a limited number of formerly Afghan-licensed companies were absorbed into the Ministry of Interior under the newly reestablished Afghan Public Protection Force. Yet Karzai’s decree posed a challenge for conventional American units, which had begun to mimic the Village Stability Operations concept by creating ad hoc local security units. Using Commander’s Emergency Response Program funds to resource community-based security solutions, conventional forces had hired locals to provide security for remote bases and small-scale reconstruction projects. As IJC’s executive agent, Miller’s headquarters provided guidance for integrating these security forces into planned or existing Ministry of Interior–approved village stability sites. All of these efforts needed support from the Afghan government or risked being dissolved when coalition conventional forces departed Afghanistan.\",\n    \"By September 2011, Combined Forces Special Operations Component Command–Afghanistan, now commanded by Brig. Gen. Christopher K. Haas had expanded Village Stability Operations to seventy-six sites, forcing Haas and the Ministry of Interior to cap Afghan Local Police based on available special operations teams, projected surge reductions, and resource sustainability. The determined maximum became ninety-nine villages, with each program to last no longer than five years and the forces themselves being disbanded or absorbed into the ANSF by 2016.\",\n    {\n      \"title\": \"Efforts in Development and Governance, 2009–2011\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Even though the U.S. Embassy and the military often generated bureaucratic friction rather than results when they made efforts to work together, cooperation between the DoD and the State Department generally remained positive when it came to Provincial Reconstruction Teams. During the surge, reconstruction team efforts benefited significantly from decisions made before the additional troops arrived. Owing to McKiernan’s estimate that 2,100 civilian positions were needed and Ambassador Karl W. Eikenberry’s push to improve governance and development, more than 1,000 additional civilian positions were filled during the surge.\"\n      ]\n    },\n    \"${The Civilian Surge}{bold}\",\n    \"Although Eikenberry took pride in quadrupling the number of civilian personnel in provincial positions, a typical reconstruction team in 2009 included just three civilians and between sixty-three and ninety-nine military personnel. An average of thirty-five civilians from the Department of State, U.S. Agency for International Development, and the U.S. Department of Agriculture thus were assigned to reconstruction teams nationwide. This number was dwarfed by the funding they managed, which exceeded $600 million. Increases in personnel and funding were managed by the Regional Command’s new senior civilian representative, giving the civilian side its own chain of responsibility. Although more civilian expertise had become available, it fell short of what military commanders wanted and desperately needed. Over time, the civilian staffing issues would improve, but in many cases there simply were not enough people on hand to complete the massive amount of work that was necessary.\",\n    \"During the surge, Americans sought to focus their available resources in geographical areas chosen by the Afghan government. The newly formed Afghan Independent Directorate of Local Governance selected the areas. At the successive requests of McChrystal, Petraeus, and Eikenberry, Afghans identified eighty key-terrain districts and forty-one area-of-interest districts. These districts were mostly along the Ring Road and near border crossings, with approximate locations in Helmand and Kandahar Provinces, and in the most dangerous districts and provinces of RC East that ISAF already had designated for the military surge.\",\n    \"Admiral Mullen’s decision to “throw the kitchen sink” at Afghanistan in 2009 permitted new ideas to be tried. New organizations stood up under the ISAF umbrella to aid in accelerating governance and development. Through these organizations, McChrystal and Petraeus aggressively began pursuing solutions to problems identified years earlier. The key-terrain district concept proved important in focusing the additional resources during 2010–2011. However, when the Afghans and IJC added three more key-terrain districts to the list in mid-2011, before any were considered ready to move to the build phase, interest in the program diminished rapidly. Attention swiftly turned from key-terrain districts to the five tranches—the NATO term designating the selected parts of Afghanistan that would be transitioned to Afghan authority by 2014. Now, rather than try to build Afghan governmental capacity one key district at a time and then transition it to Afghan control, the plan was to transition control in large swaths.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-9-4.svg\",\n        \"caption\": \"Regional Commands South & Southwest\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-9-5.svg\",\n        \"caption\": \"Regional Command East\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"${Corruption and the Rule of Law}{bold}\",\n    \"On 1 July 2010, Brig. Gen. Herbert R. McMaster stood up Task Force SHAFAFIYAT (Transparency) in Afghanistan. Its mission was to foster a common understanding of the corruption problem, plan and implement ISAF anticorruption efforts, and integrate activities in support of an active and honest Afghan administration. It was an unprecedented effort for a foreign military to take such a broad stance on dealing with a host nation’s internal corruption problems. Starting with just three senior personnel, McMaster’s means and results were modest; nonetheless, it showed the extent to which the U.S. military was willing to attempt innovative solutions to old problems during the surge. As McMaster brought more people and assets to support his task force, its results improved over time, but corruption was an issue that would take generations to fix.\",\n    \"Eliminating corruption was not limited to Afghan practices. With billions of dollars spent annually in Afghanistan, American leaders were concerned that contract prices in the country had become inflated. Some inflation came from legitimate security charges that contractors incurred, but often these charges were protection money paid to warlords, Taliban, militias, and even Afghan police. These payments sparked inflation and created an artificial and unsustainable economy in some areas. In response to those concerns, USFOR-A and ISAF created Task Force 2010 in June 2010. Under the command of U.S. Navy R. Adm. Kathleen M. Dussault, the task force mirrored and supervised the U.S. Army’s Task Force SPOTLIGHT, commanded by Army Brig. Gen. Margaret W. Boor. Both organizations focused on identifying and eliminating fraud, waste, and abuse within the contracting processes supporting coalition operations. They tracked contracting funds from allocation to commitment and through the delivery of the services purchased. Task Forces 2010 and SPOTLIGHT discovered that considerable funds were being used for unintended purposes, and the task forces became a viable means of ensuring that this problem did not continue.\",\n    \"Although several NATO nations supported the reform of Afghanistan’s legal institutions, few were willing to send experts to aid in the effort. In a prime example, in September 2010 the United States created the Rule of Law Field Force–Afghanistan, which brought in military lawyers, engineers, police, and others to support civilian efforts in bolstering rule of law in Afghanistan. The organization had become necessary when it became clear that the civilian surge would be insufficient to push judicial reform and infrastructure down to the local levels. It was also critical in Afghanistan to provide the population a responsive and fair recourse in a court of law, as opposed to deferring to traditional sharia law, the preferred Taliban method. Under the command of the U.S. Army’s Brig. Gen. Mark A. Martins, this headquarters eventually also would command NATO’s Rule of Law Field Support Mission–Afghanistan. The decision to add the NATO title was intended to encourage contributions from coalition partners, but it was largely unsuccessful. Experts from outside the United States did not enthusiastically support American military designs for innovation, even if they had been approved by the North Atlantic Council. The U.S. Army filled 80 percent of these billets; other branches of the U.S. military filled most of the remainder. The effort achieved much in terms of pushing the rule of law from the Afghan national government down through the provinces and to the districts. However, the end of the surge greatly hindered the rule of law effort, as it would take more than two years to institute legal reforms of such magnitude in an environment such as Afghanistan.\",\n    {\n      \"title\": \"Special Operations Command and Control\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"For nearly seven years, CJSOTF-Afghanistan had been the Special Operations Command element in Afghanistan. The overall operational dynamic began changing just before the start of the surge as Afghan SOF improved in proficiency, adding complexity to partnered operations. At the same time, U.S. and ISAF SOF in Afghanistan oversaw the formation and training of progovernment militias. The new missions, which were added to other critical tasks such as attacking threat networks and Taliban leadership, took a heavy toll on task force resources, which had been focused on managing operational and tactical integration with the conventional and international forces. Based on recommendations from Admiral Olson and General McKiernan, CENTCOM originally created a new Combined Forces Special Operations Component Command–Afghanistan to relieve the SOF task force’s operational-level burdens. Many viewed the creation of the new headquarters as layering more bureaucracy onto the existing force structure, but the structure under Reeder allowed CJSOTF-Afghanistan to focus on its tactical-level command and advisory requirements.\",\n        \"In addition to gaining operational control of CJSOTF-Afghanistan, Reeder’s headquarters sought to establish a greater unity of effort among U.S. and ISAF Special Operations contingents, as well as the dedicated U.S. counterterrorism forces in Afghanistan. That goal could be achieved only through integrating Special Operations plans within the overall ISAF campaign plan. Although Reeder had no command authority over either ISAF SOF or the counterterrorism task forces, he dedicated considerable time throughout the surge to synchronizing their efforts.\",\n        \"In 2009, recognizing that SOF unity of effort would be almost impossible to achieve under the existing command and control structure, McChrystal proposed changes to CENTCOM that would unify the separate SOF entities. With CENTCOM’s approval, IJC published Fragmentary Order 408 directing that operational control of the Combined Forces Special Operations Component Command–Afghanistan be transferred to NATO by spring 2010. The Combined Forces Special Operations Component Command–Afghanistan provided overall direction to its subordinate units while ensuring they coordinated their activities with regional commands. Fragmentary Order 408 instructed the international SOF contingent to provide command and control elements to the ISAF SOF headquarters and send liaisons to each regional command. The counterterrorism task forces remained under CENTCOM control, but they were directed to provide liaisons to ISAF, USFOR-A, and CJSOTF-Afghanistan.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/grafik_9-4.png\",\n        \"caption\": \"Evolution of Special Operations Command and Control\"\n      }\n    },\n    \"${Special Operations in Afghanistan Receives More Resources}{bold}\",\n    \"While the Combined Forces Special Operations Component Command–Afghanistan now exercised operational control of both ANA Commando units and CJSOTF-Afghanistan, the changes listed in Fragmentary Order 408 did not provide the forces required to address an expanding range of missions. As Col. Gus Benton II prepared to take command of the task force in January 2009, his 3d Special Forces Group staff had to make do with inadequate resources caused by outdated plans. Rather than utilize augmentees provided by other units before deployment, Benton’s group would have to cull from its own ranks to meet increased liaison requirements levied by the Combined Forces Special Operations Component Command–Afghanistan.\",\n    \"Although Benton would receive some assistance from Naval Special Warfare Task Units and Marine Special Operations companies, as well as Special Operations contingents furnished by Canada, Great Britain, France, and the United Arab Emirates, 3d Group found itself hard-pressed to fulfill the demands placed upon CJSOTF-Afghanistan by Fragmentary Order 408. All of these forces and more were essential, as the task force’s operational requirements were increasing with its foreign internal defense efforts. Benton and his organization continued the development of the ANA Commandos, formalized partnerships with conventional ANA units, and experimented with local constabulary-like forces in remote locations. Colonel Benton’s boss, General Reeder, grew more convinced that the last initiative, when combined with the other foreign internal defense programs, would be the key to improving security within Afghanistan.\",\n    \"By May 2009, there were five fully operational Commando kandaks supporting the regional commands, with a sixth kandak nearing the end of its training and preparation for employment, along with a brigade headquarters. Partnered forces raided mid-level enemy leadership and networks, conducted reconnaissance in support of conventional operations, provided regional quick response capabilities, and were publicized as the new face of Afghan Army professionalism through a concentrated information campaign. Commando kandaks had the highest retention rates in the ANA because of their regularly scheduled leave, higher pay, continuous indoctrination and training cycles, predictable deployment cycles, and esprit de corps. As the Commandos increased in capability and capacity, CJSOTF-Afghanistan and the Ministry of Defense began focusing them (with their advisers) on specific areas.\",\n    \"SOF had long supported conventional ANA units by operating in areas of RC West and RC South that lacked ISAF presence. In addition to this informal arrangement, Reeder’s teams sought to develop local security in remote districts and in conjunction with Afghan conventional forces. Increased numbers of SOF personnel were needed to turn this vision into reality if the surge was to produce the outcomes sought by the Obama administration.\",\n    \"${The Special Operation Surge Begins}{bold}\",\n    \"As the conventional forces began increasing in numbers in early 2009, SOF also was preparing to surge operations in Afghanistan. To increase available personnel, all Special Forces Groups activated a fourth battalion, and the 75th Ranger Regiment added a fourth company to each of its three battalions. Similar initiatives had occurred over the past several years within the other services. As a result of these force structure increases, Col. James E. Kraft of the 7th Special Forces Group arrived in Afghanistan in July 2009 with three Special Forces battalions and significantly more Marine and Naval Special Warfare augmentation. The additional manpower permitted the group commander to work with ISAF regional commanders and establish partnerships with ANA corps. In addition, Kraft now had enough resources to support small Afghan units in areas where international forces did not maintain a presence.\",\n    \"Kraft distributed his available resources so they could partner with the ANA’s 201st, 203d, 205th, 207th, and 209th Corps. He left the sixth Commando kandak uncommitted to allow it to meet short-notice requirements such as counterterrorism operations, deploying a quick-reaction force, or relieving other Commando kandaks. In addition to the kandak partnerships, Special Operations detachments were allocated to twelve areas where community defense initiatives were being implemented. In addition to Kraft’s efforts, SOF resources under the control of Combined Forces Special Operations Component Command–Afghanistan supported McChrystal’s population-centric counterinsurgency through a combination of foreign internal defense operations and robust counterterrorism.\",\n    \"At the same time, a growing number of dedicated counterterrorism resources and personnel based in the United States were being diverted from Iraq to increase pressure on enemy logistical networks in Afghanistan. The 75th Ranger Regiment dedicated nearly a full battalion to command and support these assets while Navy Special Warfare elements, the 160th Aviation Regiment (Special Operations), and other Army forces provided assistance. The increased raids and attacks on enemy networks were unfortunately accompanied by increased danger as nineteen special operators were killed in action during the latter half of 2009. Noncombat fatalities and the loss of specialized aircraft proved as harmful to the mission as lost service members. On 28 October, low visibility caused a CH–47 Chinook helicopter to crash in Badghis, killing seven military personnel and three Drug Enforcement Agency civilians on a counternarcotics raid. With limited numbers of Special Operations aircraft available in theater, the loss of every airframe and every highly skilled pilot dealt a serious blow to the entire force.\",\n    \"${Special Operations Presence}{bold}\",\n    \"When Colonel Benton returned with 3d Special Forces Group to relieve the 7th Group and assume command of CJSOTF-Afghanistan in January 2010, he knew that his tour would be shorter than normal. The Defense Base Closure and Realignment Commission had removed the 7th Special Forces Group from the Afghan rotation cycle so it could relocate from Fort. Bragg, North Carolina, to Eglin Air Force Base, Florida. The move would take fourteen months to complete. Rather than commit another group to cover the gap, the U.S. Army Special Operations Command sent Benton to Afghanistan for ninety days before replacing his command with an ad hoc headquarters. Benton thus turned over his command to Colonel Bolduc in April 2010.\",\n    \"Unlike units in earlier rotations, Bolduc’s unit arrived knowing it would remain in Afghanistan until the 7th Special Forces Group resumed operational status in March 2011 and would be available for deployment. Bolduc’s staff was made up of part of the 3d Group headquarters augmented by individuals from a number of organizations, including many drawn from his subordinate elements. The 2d Battalion, 1st Special Forces Group, which formed the core of Special Operations Task Force 12, supported RC South. Responsibility for RC North and RC West fell to Special Operations Task Force 81, which included the first battalion-level Marine Special Operations Command unit in Afghanistan. The 3d Battalion, 3d Special Forces Group provided the core of Special Operations Task Force 33 supporting RC East.\",\n    \"The handover between Benton and Bolduc also signaled the introduction of the “flag-forward” concept designed to provide greater continuity over  time to high-priority projects. This concept involved splitting operational detachments into two halves, each of which was brought back up to full strength by individual replacements. Splitting the teams enabled commanders to send one element to Afghanistan for a specific mission before replacing it with the second half of the split team. It also maintained a single higher headquarters in country for longer periods of time. Allowing for some overlap during changeover, the arrangement allowed commanders to commit an operational detachment to a specific mission for a period greatly exceeding a normal tour of duty, lending tremendous continuity to the effort. Reeder applied “flag forward” to his top priorities: Village Stability Operations and Commando kandaks aligned with ANA Corps.\",\n    \"That decision proved timely as SOF and the conventional forces increasingly needed Afghans in the lead to compensate for restrictions on the use of force mandated by ISAF. Between 2008 and 2010, airstrikes, aerial interdiction, and night raids caused a marked increase in civilian casualties. McChrystal personally intervened by issuing his “Tactical Directive” on 1 July 2009 as well as a “Night Raids Tactical Directive” on 23 January 2010. Both documents were intended to reinforce the tenet of “courageous restraint” introduced by McChrystal as ISAF sought to minimize collateral civilian casualties and placate cultural sensitivities. The directives were well intended, but the Taliban was quick to recognize and take advantage of the revised rules of engagement. As a result, the policy met with mounting disfavor among American and ISAF combat troops who believed McChrystal’s approach placed their own lives at risk by ceding the tactical initiative to their opponents.\",\n    \"Two incidents of special operations units inflicting casualties on Afghan civilians following the introduction of “courageous restraint” called attention to the need for even more deliberate procedures. The reaction to each event illustrated how strongly all parties felt about the accidental targeting of innocents. The first incident, which highlighted the increased activity of counterterrorism units in Afghanistan, took place when troops from the 75th Ranger Regiment raided Khatabah, near Gardez, on 12 February 2010. The operation resulted in the death of five Afghan civilians while provoking accusations from Karzai of an ISAF cover-up. As a testament to the special operations community’s willingness to back McChrystal, Navy V. Adm. William H. McRaven, flew from MacDill Air Base in Florida to the Khatabah to apologize formally for the deaths.\",\n    \"The second incident occurred in Uruzgan Province nine days later, when CJSOTF-Afghanistan authorized a Scout Weapons Team to engage a suspected enemy convoy detected by an unmanned aerial vehicle operator. Events began with a SOF element receiving reports of a potential attack on its position following a night raid. The unmanned aerial vehicle operator who initially detected an approaching convoy chose to discount subsequent analysis indicating that the vehicles contained women and children. Based on the flawed analysis, the SOF task force authorized OH–58 Kiowa pilots to engage the convoy. The strike took place approximately twelve kilometers from friendly forces and clear of populated areas. Once the special operations element reached the destroyed convoy, it discovered that the occupants were unarmed civilians. A total of twenty-seven Afghans, including four women and one child, were killed while numerous others were wounded. The chief investigator subsequently recommended reprimands for the commanders of CJSOTF-Afghanistan and the Special Operations Task Force for failing to report the incident in a timely fashion. He further recommended reprimands for the unmanned aerial vehicle crew for ignoring analysis that indicated a civilian presence. Both incidents served as cautionary indicators for SOF units whose unparalleled ability to connect with a wide range of Afghan tribes and communities was critical to their overall tactical effectiveness.\",\n    {\n      \"title\": \"Special Operations Continues to Evolve, 2010–2011\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Reeder passed command of Combined Forces Special Operations Component Command–Afghanistan to General Miller in March 2010. Some leaders worried that Miller’s previous assignments with Ranger and dedicated counterterrorism units would lead him to abandon the less-direct approaches championed by Reeder and Bolduc. To the command’s relief, Miller immediately recognized the importance of local defense initiatives such as the Village Stability Operations program. Acknowledging its importance to the ISAF counterinsurgency effort, Miller promoted layered security for towns and villages.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_9-5.png\",\n        \"caption\": \"ANA and U.S. Soldiers are airlifted\"\n      }\n    },\n    \"As Miller’s staff refined its approach to local security, counterterrorism forces increased the tempo and precision of their operations. McChrystal, lacking a direct command and control relationship with the counterterrorism task forces, relied on personal relationships with their commanders to redirect their focus toward mid-level networks and leadership. As operations in Iraq ended, counterterrorism resources shifted to Afghanistan. With the increased headquarters, reconnaissance and surveillance, airlift, and fire support assets flowing into theater, counterterrorism missions grew by 200 percent in 2009 before doubling again in 2010. By February 2011, counterterrorism forces led by and consisting primarily of 75th Ranger elements were partnering with Afghan Special Operations units to conduct more than 200 operations a month. Significantly, 90 percent of these missions were conducted without a shot being fired.\",\n    \"Pressuring the enemy’s mid-level networks, combined with the conventional force surge, improvements in local security, and increased infrastructure expenditures began to pay dividends for Afghanistan. Success came at a cost, however. The elevated operational tempo resulted in the loss of an Air Force Special Operations MV–22 Osprey in Zabul Province on 9 April 2010, killing two U.S. Air Force airmen and one Army Ranger. Less than two weeks later, on 21 September 2010 an MH–60 Black Hawk helicopter crashed in Daychopan District, also in Zabul Province, killing nine special operators. As special operations elements increased efforts in Afghanistan, the complementary foreign internal defense initiative in neighboring Pakistan drew to a close. Although the Special Operations Command (Forward)–Pakistan felt that it had been successful within the scope of its authorities, it suffered a series of setbacks, including the loss of three personnel in an IED attack in February 2010 and increasing Pakistani restrictions resulting from border disputes and cross-border incursions by ISAF and ANSF personnel. The initiative ended in 2011 after Pakistan refused to renew the visas of Americans training the Frontier Corps and other Pakistani counterterrorism units.\",\n    {\n      \"title\": \"Taking on the Northern Insurgency\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"While the Americans remained focused on RC East throughout 2009, shifting to RC South and RC Southwest from 2009 to 2011, the enemy quietly opened a new front in the country’s northeastern provinces bordering Tajikistan and Uzbekistan. These militants had two objectives. The first was to launch high-visibility attacks that were guaranteed to generate Western media reports and create the perception of a nationwide uprising beyond the southern Pashtun regions. The second objective was to seize criminal enterprises such as drug and weapons trafficking in order to garner the profits to support their future endeavors. Conditions in the northern provinces, including the Afghan government’s inability to overcome Tajik and Uzbek warlords, political marginalization of Pashtun minorities comprising one-third of the region’s population, and inadequate ISAF and Afghan security personnel offered fertile ground for this latest Taliban effort. Kunduz Province soon emerged as a stronghold for insurgent operations, giving the Taliban and other extremist groups access to Pashtun communities in the north.\",\n        \"The insurgency spread to nearby Takhar and Baghlan Provinces, upsetting efforts by the German Provincial Reconstruction Teams in Kunduz to project the Kabul government’s authority in the region. German troops operated under severe political constraints that limited their ability to confront the insurgency. One particular restriction prevented their forces from conducting night operations. Meanwhile, the disparate insurgent groups now flourishing in the north, including the Quetta Shura Taliban, HIG, and the Islamic Movement of Uzbekistan, were building popular support and cooperating with each other. With increasing frequency, militants launched attacks against ISAF troops and Afghan government targets. IEDs and suicide attacks limited ISAF freedom of movement while increasing the casualties suffered by German and ANSF units in a pattern strongly reminiscent of the British experience in Helmand. Neither the 1,200 Germans nor the ANSF had adequate numbers to confront the burgeoning Taliban threat.\",\n        \"As Operation HAMKARI reached a climax in late fall 2010, U.S. troops from 1st Battalion, 87th Infantry (Task Force SUMMIT), began clearing operations in Kunduz Province with German and ANSF elements. These operations killed or captured dozens of militants and disrupted several Taliban and Uzbek militant networks. One incident revealed evidence of Taliban-Uzbek militant collaboration. A late December raid killed Maulawi Bahadur, a senior Taliban commander with strong links to cells in neighboring Balkh and Baghlan Provinces. He was responsible for IED facilitation and distribution in the region, and had been linked to prominent members of the Uzbek Islamist movement. These connections may have been crucial to several successful suicide bombings. In these attacks, the Uzbek militants likely acted as the conduit for bombers, much as the Haqqanis supported similar operations in southeastern Afghanistan.\",\n        \"The insurgents responded by attacking Afghan security forces and government officials. Suicide bombings struck at the ANA headquarters and targeted the district governor in Chahar Darah District, Kunduz Province, in mid-December. A more brash assault occurred on 19 December 2010, when four attackers outfitted with suicide vests and automatic weapons opened fire on the ANA recruiting center in the city of Kunduz. The attackers killed eight Afghan soldiers and police at the cost of their own lives, and communicated the message that even government centers remained vulnerable. Intelligence pointed to the Gor Teppah area, just south of the city, as the likely staging ground. ISAF responded with SOF raids that killed foreign fighters while destroying an IED factory and capturing an imam suspected of planning the attack.\",\n        \"Although subsequent raids by special operators met with similar success, they failed to quell insurgent activity among Pashtun communities in the north. The first two months of 2011 were particularly active, with insurgent attacks against ANSF and government leaders succeeding in coercing large segments of the population to remain neutral if not actively supporting the Taliban cadres. When American pressure grew too strong, insurgent leaders moved to regions that had fewer ISAF troops. Although results indicated the success of the ISAF and ANSF efforts, many districts in Afghanistan’s northeast corner had not been completely cleared. An uneasy stalemate arose as northern Pashtuns waited to see who would hold military and political superiority.\"\n      ]\n    },\n    {\n      \"title\": \"The Death of Osama bin Laden\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"On 2 May 2011, American SOF conducted the raid that would begin to close a chapter of the Global War on Terrorism that had opened on 11 September 2001. The overnight attack against Osama bin Laden’s home in Abbottabad, Pakistan, combined perceptive intelligence analysis, operational boldness, and good luck. Although bin Laden’s death coincided neatly with the beginning of transition to Afghan control, it had little effect on the war itself. Mullah Mohammed Omar remained central to the Taliban’s identity. As one insurgent commander said, “We are fighting for Mullah Muhammad Omar [sic]. He is our amir [ruler, chief, or commander]. We have never fought for Osama bin Laden. His death does not matter to us. We will continue with our struggle.”\"\n      ]\n    },\n    {\n      \"title\": \"SECTION II CONCLUSION\",\n      \"level\": 2\n    },\n    \"${PLACEHOLDER INTERACTION 9-1 TIMELINE}{bold}\",\n    \"Although the 2009 Bush troop increases to support the Afghan elections, followed by the Obama surge in 2010–2011, bore some resemblance to the surge in Iraq, the similarities between them did not stem from deliberate design, but rather from a misinterpretation of strategic objectives. Upon taking office in January 2009, President Barack H. Obama received three assessments on strategy and operations in Afghanistan. Because these assessments had been conducted under President George W. Bush, Obama directed another strategic assessment, referred to as the Riedel Report. Recognizing that the United States could no longer afford to deal with Pakistan and Afghanistan separately, the Riedel Report noted that a military defeat of the Taliban remained unlikely as long as Pakistan offered sanctuary to Afghan insurgents. Rather than accept an indefinite stalemate, the report recommended transitioning security responsibilities to the Afghans once their army and police forces had improved to the point at which they could check Taliban attempts to overthrow the Kabul government. That course of action, however, also involved degrading Taliban capabilities enough so that the transition could begin. To hand over control of the conflict to the Afghans, the United States would have to provide resources for this transition and devote more effort to neutralizing or eliminating extremist groups in the region that posed a potential threat to the American homeland.\",\n    \"When General Stanley A. McChrystal replaced General David D. McKiernan in mid-2009, the incoming commander’s view of his new responsibilities was influenced by early interpretations of why the surge in Iraq had worked. Proponents of population-centric counterinsurgency loudly proclaimed that the Iraq surge had been successful because it used U.S. troops to protect ethnic communities ravaged by sectarian civil war. These same counterinsurgency advocates paid less attention, however, to the fact that American troops had waged an intensive kinetic campaign against insurgent strongholds within Iraq both before and during the surge. In addition, most accounts ignored the key role played by the Iraqi Army in maintaining order and contributing to the fight against local insurgents.\",\n    \"Upon assuming his responsibilities at ISAF, McChrystal conducted his own assessment. As it was based on recent interpretations of the Iraq surge, it determined that a population-centric counterinsurgency approach would be successful in Afghanistan. However, the Iraq model could not be duplicated in its entirety in Afghanistan, most notably because population-centric counterinsurgency did not directly support the strategic goals articulated in the Riedel Report. President Bush originally approved the Iraq surge in an effort to end sectarian violence and defeat the insurgency, whereas President Obama sought to buy time and space for the Afghan army and police to improve by employing more U.S. troops against the Taliban. Obama’s plan focused on both the enemy and the capacity of the Afghan government to control its country. McChrystal realized from the outset that even though he had been asked to undertake a virtually identical operational approach to that of the Iraq surge, he would not receive the same level of resources for his mission. As he said to an aide, “They [the U.S. government] did not give me enough [troops] to win outright.” He also recognized that unlike the government of Prime Minister Nouri al-Maliki of Iraq, Karzai’s government was “not going to win the battle of legitimacy” by making significant policy changes because the Taliban insurgency was not strong enough to pose a direct threat to the Afghan government’s immediate existence. McChrystal had to adjust the campaign to fit these limitations.\",\n    \"Confusion ensued as some of McChrystal’s subordinates sided with the approach articulated in the Riedel Report while others embraced the Iraq version of counterinsurgency as they understood it. On the ground, tactical commanders independently developed their own views on how to conduct population-centric counterinsurgency, creating additional friction along the chain of command. That friction had been less of a problem in Iraq, where some commanders were able to focus on the far less ambiguous mission of eliminating enemy strongholds. To further complicate matters, a number of allied nations viewed any and all types of counterinsurgency differently than their American counterparts. This created more problems in Afghanistan than in Iraq because the Iraq surge involved primarily U.S. troops while the Afghanistan surge incorporated both U.S. and ISAF personnel. Finally, matters worsened when ISAF issued the “courageous restraint” directive, fostering significant resentment among combat troops who faced an adaptive enemy that took advantage of the new rules of engagement.\",\n    \"The population-centric approach, while admirable from a moral perspective in its desire to limit collateral civilian casualties, did not materially contribute to ongoing efforts to improve Afghan security forces. According to one Strategic Studies Institute analysis published in 2007, counterinsurgency strategies of the kind that McChrystal would later apply in Afghanistan cede the initiative to the insurgents. Although the vagaries of Army doctrine played no part in General David H. Petraeus’ subsequent appointment as ISAF commander, McChrystal’s successor leveraged his firsthand experience with the Iraq surge to realign the command’s population-centric counterinsurgency. Petraeus understood that counterinsurgency’s clear, hold, and build approach was a reminder that there is more than one way for military force to influence the enemy. The approach favored by Petraeus reaped greater operational benefits because ISAF dictated when and where combat occurred rather than simply reacting to enemy efforts to disrupt the hold and build phases of the counterinsurgency in Afghanistan.\",\n    \"The ultimate outcome of the Afghan surge depended on far more than changing the approach to counterinsurgency. Outside observers often were critical of the surge’s impact on the overall campaign because it did not produce the dramatic results that the United States had seen in Iraq. However, the Afghan surge ultimately showed progress once General Petraeus refocused it on protecting the population, improving the ANSF, and targeting enemy sanctuaries and leadership. Crippled by losses suffered during this period, the Taliban was prevented not only from interfering with coalition efforts to improve the ANSF but also from derailing the handover of ISAF security responsibilities to the Afghan government. What remained to be seen was whether the ISAF coalition could strengthen Afghan institutions in a manner that would withstand the future departure of ISAF forces.\"\n  ],\n  \"section Iii\": [\n    {\n      \"title\": \"END OF CAMPAIGNS\"\n    },\n    {\n      \"picture\": {\n        \"source\": \"/figures/v2/art_S3-1.png\",\n        \"caption\": \"GIVE 'EM THE GUN\"\n      }\n    },\n    \"${Section III: Introduction}{bold}\",\n    \"The surge in Afghanistan did not render the same outcomes as its predecessor in Iraq. The latter ended a protracted insurgency on the cusp of becoming a devastating civil war. Efforts to protect ordinary Iraqis from ethnic death squads won the American military popular support, and its alliance with Sunni paramilitaries expanded indigenous opposition to al-Qaeda insurgents. Twenty thousand reinforcements permitted coalition forces to protect the majority of the populace and to eliminate enemy safe havens in Baghdad, Al Anbar Province, and Al Basrah. Deprived of access to the population and safe areas from which it could plan and organize, the Iraqi insurgency collapsed.\",\n    \"The Afghan surge created the time and space necessary for ISAF to transition from combat operations to security force assistance by targeting the Taliban and eliminating its enclaves within Afghanistan. Although it did not result in the Taliban’s outright defeat, the Obama administration’s approach to the mission established the conditions for an uncontested withdrawal of most American and ISAF troops. It also allowed ISAF to retrograde, or remove and reassign, equipment and supplies aggressively within the limited time available. At the same time, the surge provided the ANSF with sufficient breathing space to expand in size, absorb new equipment, upgrade logistics, develop ministerial capacity, take control of former ISAF bases, and refine its command and control procedures. In doing so, it laid the groundwork for the orderly transition of nation-building responsibilities from ISAF and U.S. Provincial Reconstruction Teams to the Afghan government in 2014.\",\n    \"However, time would tell if the ANSF could gain enough experience during and after the retrograde to perform well without coalition assistance, or whether the Government of the Islamic Republic of Afghanistan could refocus its priorities toward serving the people rather than the political elite after the departure of coalition forces.\",\n    \"Reducing troop strength in Afghanistan was the key element to President Barack H. Obama’s strategy for ENDURING FREEDOM. On 22 June 2011, the president announced that he would withdraw 10,000 troops from Afghanistan by year’s end and another 23,000 troops by summer 2012. The Obama administration’s initial reductions of U.S. forces in Afghanistan dropped force levels to 68,000 from 100,000 two months before the U.S. presidential election in November 2012. Obama noted that, after the killing of Osama bin Laden on 1 May 2011, America could reduce forces from “a position of strength” and that it was time to end America’s long wars to “focus on nation building here at home.” Beyond summer 2012, the timetable for drawdown remained unclear, but Obama called for steadily reducing U.S. deployment numbers by the end of 2014, at which point an agreed-upon force, sized for long-term stability operations, would remain.\",\n    \"ISAF sought to transition security responsibilities to Afghans sooner rather than later in order to maximize the effect of the surge. The combination of more ISAF troops, a higher operational tempo, and the increasingly capable Afghan security forces curtailed enemy movement, eliminated many of its leaders and fighters, severed its logistical routes, and separated the Taliban from the Afghan people. These factors prevented the insurgents from seizing more of Afghanistan’s sovereign territory during their 2011 AL-BADR campaign. Many veteran Taliban fighters also were showing signs of disillusionment. As many as 4,990 enemy combatants, a twofold increase over the previous year, had renounced their ties to the insurgency between July 2011 and July 2012 by participating in the Afghan Peace and Reintegration Program.\",\n    \"During this same period, the Pakistani armed forces launched several major offensives against extremist groups based within Pakistan’s Federally Administered Tribal Areas. In some instances, government forces received aid from militia units formed by Pashtun tribes that rejected the corrosive influence of extremist ideologies. However, the Pakistani military’s main targets were extremists that rejected secular rule and challenged the Islamabad regime specifically—such as the Tehrik-i-Taliban Pakistan, al-Qaeda, the Islamic Movement of Uzbekistan, and Lashkar-e-Islam—rather than groups such as the Haqqani Network or the Quetta Shura Taliban that focused on cross-border operations. As a result, Pakistani efforts bolstered their own internal stability but did not necessarily aid the ISAF counterinsurgency campaign being waged in Afghanistan.\",\n    \"At the same time, Americans had not persuaded the Afghans to overcome their ingrained distrust for central government. The self-interested behavior of public officials at the local, district, provincial, and national levels confirmed this perception to many. Despite the battlefield successes of its security forces, the relatively ineffective government of President Hamid Karzai remained incapable of making substantive inroads against the Taliban as it threatened unprotected populations and reconstituted its forces in the Pashtun tribal areas of northwestern Pakistan. U.S. drone attacks and limited Pakistani military offensives created significant problems for some extremist groups, but most Taliban base areas remained undisturbed.\",\n    \"Given both these promising and unfavorable aspects, the Operation ENDURING FREEDOM and ISAF campaigns were defined by two major efforts over their final two-and-a-half years. The first was the Joint Framework for INTEQAL (Transition), an effort to have ANSF lead military operations in all provinces by the end of 2014. This plan had been agreed upon at NATO’s Lisbon Summit in November 2010. The second was the redeployment of forces out of Afghanistan as the United States prepared for the anticipated post-2014 support mission. Backing these efforts were Afghan and coalition partnered offensives against enemy networks and leadership. Implementing these initiatives simultaneously required both coalition and Afghan forces to rebalance their means constantly, with redeployment drawing U.S. resources out of Afghanistan on a fixed schedule and the American personnel remaining in country becoming increasingly devoted to improving ANSF capabilities.\",\n    \"The U.S. Army stood at a crossroads at the time of the Lisbon Summit. The Army’s global commitment at that time numbered more than 230,000 officers and enlisted personnel serving in nearly eighty countries and at the U.S. borders. That figure represented roughly one-fifth of the overall authorized end strength of 1,129,275. As of October 2010, more than one million Army personnel had deployed to Afghanistan and Iraq one or more times, with 4,100 soldiers giving their lives and leaving behind 20,000 surviving family members. Another 27,000 soldiers were wounded, 7,500 of them requiring long-term care. In addition, 10,000 suffered traumatic brain injuries, and 4,500 grappled with post-traumatic stress following their deployments overseas. Despite those sobering statistics, the Army had experienced record retention numbers for enlisted soldiers within every component, averaging 110 percent of their targeted retention numbers during 2010. In terms of new recruits, both the active component and Army Reserve had exceeded their 2010 accession goals, with the Army National Guard achieving more than 95 percent of its end of fiscal year target.\",\n    \"The end of combat operations in Iraq finally allowed the Army to address mounting internal stress by implementing a rotational model of one year deployed to two years at home-station for the active component and a one-to-four ratio for the National Guard and Army Reserve. At the same time, however, the Army still had unprecedented numbers of soldiers in Afghanistan to support the new strategic direction in that vital theater. That effort began to wind down in mid-2011 with an equally intensive redeployment of equipment and materiel from Afghanistan that lasted through December 2014. Throughout the period 2011–2014, Army Chief of Staff General Raymond T. Odierno reinforced his predecessor’s efforts to invest more resources in training, equipping, and staffing the force to perform a wider and more traditional range of missions rather than remain singularly focused on counterinsurgency and security force assistance.\",\n    \"In recognition of negative trends that showed no signs of dissipating—as evidenced by the fact that in 2012 the Army experienced more suicides than combat deaths—the Army’s senior leadership introduced the Ready and Resilient Campaign in March 2013. It was intended to enhance individual and collective resilience in Army soldiers, civilians, and family members. It expanded on the Comprehensive Soldier Fitness Program to integrate Army-wide efforts to improve physical, psychological, and emotional health, with readiness of the force as the overall goal. The Ready and Resilient Campaign sought to influence cultural change in the Army by linking personal resilience to readiness, while addressing destructive behavior such as suicide, domestic violence, substance abuse, sexual harassment and assault, bullying, and hazing. It also sought to promote positive behaviors while eliminating stigmas and cultural norms that discouraged asking for help. Such an initiative was a step forward, but the true costs of employing the force over a sustained period of time still remain to be seen.\",\n    \"${Policy and Strategy Considerations}{bold}\",\n    \"As the security transition began and the balance of the ISAF conventional force shifted from combat to training, advising, and assisting, the Obama administration faced three major policy questions on Afghanistan. First, it had to determine how rapid the drawdown should be. Second, it had to consider whether to establish a long-term security arrangement with the Afghan government that would allow U.S. forces to remain beyond 2014. Finally, it had to ascertain how large the residual force should be based on the potential range of responsibilities and missions it received.\",\n    \"Both Afghan and ISAF leaders believed that the drawdown could be best managed if it took place incrementally. Transitioning security responsibilities in the thirty-four provinces would therefore occur in stages, known as tranches. Debate occurred over the decision to transition certain areas. Even though ISAF literature explicitly stated that its forces would not depart areas until the Afghans could secure them, political considerations still determined who left where and when. Consequently, operational leaders had to choose whether to transition the relatively uncomplicated areas or the more difficult areas first. Although it seemed self-evident to focus on the easier areas first, it would be more difficult to transition harder areas later on because fewer coalition forces would be available.\",\n    \"On 22 March 2011, Karzai publically listed the first provinces and districts to begin transition. Tranche 1 included Bamyan, Panjshir, Kabul (except the Sarobi District), and districts surrounding certain provincial capitals, including Herat, Lashkar Gah, Mazar-e Sharif, and Mehtar Lam. Those areas, especially Panjshir and Bamyan, had been pacified for some time and had good security. The first provincial transition ceremony occurred in Bamyan, the capital of Bamyan Province, on 17 July 2011.\",\n    \"The process continued as planned. Tranche 2 was announced on 27 November 2011. This tranche, which included Balkh, Takhar, Samangan, Daykundi, Nimroz, and Kabul Provinces, as well as selected districts in Parwan, Helmand, Ghazni, and Herat Provinces, began without serious interference in December 2011. Tranche 3, slated to begin in July 2012, not only transferred 122 additional districts but also initiated the handover preparations for all remaining provinces. Upon completion of the fourth tranche, slated to begin in early 2013, Afghan security forces would assume responsibility for 87 percent of the nation’s population and 312 districts in 23 of 34 provinces. The fifth and final tranche, involving the remaining eleven provinces, would take place in mid-2013. Tranches 2 through 5 included areas under government control as well as those still contested, a necessity given that the process had to occur while sufficient coalition resources were still present in country.\",\n    {\n      \"picture\": {\n        \"source\": \"/figures/m/map-afghanistan-transition.svg\",\n        \"caption\": \"Map - Afghanistan Transition\"\n      }\n    },\n    \"One end state remained inexorably clear throughout the process: ready or not, Afghans would be responsible for their own security  by 31 December 2014. On that date, Operation RESOLUTE SUPPORT would replace ISAF as a noncombat NATO mission intended to continue the development of Afghan ministries. Similarly, the United States would transition its missions on the same date, replacing Operation ENDURING FREEDOM with Operation FREEDOM’S SENTINEL.\",\n    \"${Transition in a Complex Operating Environment}{bold}\",\n    \"As the United States brought its combat mission in Afghanistan to a close, its goal in the CENTCOM area of responsibility remained  “to disrupt, dismantle, and eventually defeat al-Qaeda, and to prevent its return to either Afghanistan or Pakistan.” The objectives unique to Afghanistan also remained constant: “to deny safe haven to al-Qaeda and to deny the Taliban the ability to overthrow the Afghan government.” Insofar as the United States was still executing combat missions, it was “to degrade the Taliban insurgency in order to provide time and space to increase the capacity of the Afghan National Security Forces and the Afghan Government so they can assume the lead for Afghanistan’s security by the end of 2014,” although the clear emphasis was now on security force assistance, not combat operations. As a complement to its military campaign, the Obama administration continued its efforts to reconcile the Taliban to the Afghan government.\",\n    \"NATO’s mission likewise changed little in these years, with the North Atlantic Council calling for counterinsurgency operations to protect the Afghan people, neutralize insurgent networks, and build legitimate and sustainable Afghan institutions. Since 2007, a counterinsurgency approach designed to enable Afghanistan to secure and govern itself had translated that guidance into campaign direction. Although tactical methods had varied, the conceptual approach remained in place through 2011. When Marine General John R. Allen succeeded General David H. Petraeus as ISAF commander on 18 July 2011, the campaign changed again. Allen initiated a deliberate transition from counterinsurgency operations to security force assistance by approving Revision 6 to ISAF Operations Plan 38302 on 15 November 2011.\",\n    \"Two subsequent amendments to the plan incorporated guidance for reducing the theater’s “footprint” and retrograding units, personnel, and  equipment out of Afghanistan. Allen approved the second and last amendment to the plan on 27 October 2012. The campaign centered on developing a capable and sustainable ANSF, as described in the mission statement:\",\n    {\n      \"list\": [\n        \"ISAF, in partnership with the International Community, supports GIRoA [Government of the Islamic Republic of Afghanistan] in the conduct of counter-insurgency operations to support development of governmental institutions for legitimate, credible, and enduring governance, security, and sustainable socio-economic growth; support the ANSF as it assumes lead responsibility for security to protect the Afghan people; and neutralize insurgent networks in order to deny terrorist safe-havens, ensure GIRoA stability and sovereignty, and set the conditions for the NATO-led post-ISAF engagement NLT [no later than] 31 December 2014.\"\n      ]\n    },\n    \"${The Evolving Threat}{bold}\",\n    \"The Taliban’s retreat from the battlefield following the surge did not reflect a lasting defeat. Opposition groups had enough money and motivated fighters to continue military operations against ISAF and Afghan security forces.\",\n    \"The Haqqani Network remained foremost among these groups. Its operators and facilitators had survived the surge by avoiding contact with American forces and focusing on well-planned operations offering a high payoff for an acceptable price in lives and materials. During this period, however, the Taliban suffered an internal power struggle that unfolded largely hidden from the U.S. intelligence apparatus. Yet even with the Taliban’s private upheaval, there were no shortage of willing opponents for U.S. and ISAF forces during the transition period.\",\n    \"For much of Operation ENDURING FREEDOM, commanders in Afghanistan dealt with the fact that the economy of force also applied to the entire range of intelligence, surveillance, and reconnaissance systems. The drawdown in Iraq freed up a number of these assets for employment in Afghanistan during the surge, but it took time for commanders and staff to learn how best to use these increased capabilities and then fully integrate them. Unlike in Iraq, American troops worked side by side with international contingents from several dozen nations as well as Afghan security forces on a daily basis. As a result, procedures had to be developed to address myriad interoperability issues, data management problems, and data-sharing policies. Intelligence analysts who previously focused on Iraq had to acquire a new set of skills, including familiarity with different languages, new relationships with ISAF and Afghan counterparts, and efforts to obtain optimal results from systems being employed in a physical environment that differed significantly from Iraq. Regrettably, many of these personnel and some assets were withdrawn just as they reached their peak proficiency in accordance to the firm timetables imposed on the surge.\",\n    \"The Afghan intelligence services also faced comparable challenges, albeit of a far different nature. Even though the vast majority of insurgent groups hailed from Pashtun tribes in the south, approximately 70 percent of National Directorate of Security personnel were Tajiks from the Panjshir region of northeast Afghanistan. The ethnic imbalance had a starkly negative impact on the National Directorate of Security, prompting one of its operatives to complain, “When they send Panjshiri to Pashtun areas they can’t do anything. They don’t know anything about the South or the East. They don’t know how Pashtuns talk or move. If you need information about a Pashtun, you should have a Pashtun to get that information. This is the problem.”26 As a result, even Afghanistan’s own domestic intelligence service had limited ability to infiltrate enemy ranks.\",\n    \"Although the surge helped improve ISAF intelligence, surveillance, and reconnaissance capabilities in Afghanistan, those systems had limited access to Pakistan. The Taliban’s inner workings were well protected in Quetta and its leaders avoided exposing their disagreements. In addition, the success of the drone campaign worked against ISAF intelligence collection efforts by instilling a growing sense of fear and caution in insurgent leaders. Nonetheless, when Pakistani officials arrested Mullah Mohammed Omar’s top deputy, Mullah Abdul Ghani Baradar, in 2010, two Taliban commanders openly clashed as they each tried to replace Baradar. The first was Mullah Abdul Qayyum Zakir, who had commanded the Taliban’s forces in southern Afghanistan. The second was a relatively unknown functionary, Mullah Akhtar Mohammed Mansour. Akhtar Mansour had made his mark in the insurgency through the opium trade. He had allegedly become the Taliban’s main tax collector, responsible for funding the fundamentalist group. This power struggle would resume in the near future with the death of Mullah Mohammed Omar.\",\n    \"New Taliban leadership combined with reduced battlefield operations for the past year promised a renewal of intensive fighting in  2012. On 2 May, just three weeks after German Brig. Gen. Carsten Jacobson, the ISAF spokesman, reiterated his organization’s position that it would not face a sustained, large-scale enemy offensive that spring, the Taliban released a statement that would be paraphrased in the press:\",\n    {\n      \"list\": [\n        \"\\\"[The] Al Farooq Jihadi operation spring offensive would target “foreign invaders, their advisors, their contractors and members  of all associated military, intelligence and auxiliary departments . . . high ranking officials of the stooge Kabul regime; members of Parliament; those associated with Ministries of Defense, Intelligence and Interior; members of the so called High Peace Council; Militia under the name of “Arbakai” and all those people who work against the Mujahedeen [sic], toil to pave ground for the occupation of Afghanistan and become the cause for the strength of the invaders.\\\"\"\n      ]\n    },\n    \"Rather than launch large-scale attacks, the Taliban sought to influence the security handover by indirect means, namely by targeting the ISAF personnel who trained Afghan soldiers and police. Taliban leaders also took advantage of the desperate need for new ANSF personnel by seizing opportunities to infiltrate these formations with insurgents. As more and more foreign soldiers advised Afghan formations, violence by Afghan security forces against their coalition partners, referred to as insider or “green-on-blue” attacks, occurred with increasing frequency. The Taliban infiltration efforts began to yield results in 2008 when two such attacks took place, followed by ten more green-on-blue incidents occurring in 2009 and 2010. A spike in these incidents led some coalition members to question the feasibility of partnering with Afghan forces.\",\n    \"Fifteen green-on-blue attacks occurred in 2011, skyrocketing to forty-two by mid-November 2012. The majority took place in RCs East, South, and Southwest. Although insurgent spokespeople routinely claimed credit for insider attacks, the motives for committing these deadly incidents, which eroded trust between ISAF and Afghan personnel, varied significantly. One of the most publicized attacks, in which an Afghan Air Force colonel executed eight American service members and a civilian contractor, occurred on 27 April 2011 at Kabul International Airport. Although CENTCOM investigators did not uncover proof of third-party involvement, an American news outlet alleged that other U.S. officials discovered that the assailant’s substantial gambling debts were paid off and his family received a large bank deposit one week before the incident.\",\n    \"These attacks directly influenced the theater campaign at the beginning of 2012. On 20 January, an Afghan soldier fired on French trainers who were conducting physical training on their base northeast of Kabul, killing four and wounding fifteen. News of the incident, which took place as a tough election season began in France, led President Nicolas Sarkozy to proclaim, “We are friends of the Afghan people, allies of the Afghan people. But I cannot accept that Afghan soldiers fire on French soldiers.” During a press conference with Karzai on 27 January, Sarkozy announced that his country would pull its combat forces out of Afghanistan one year earlier than scheduled and urged other NATO members to do the same.\",\n    \"${The Decline of Drone Attacks}{bold}\",\n    \"Even as the insider attacks increased, the United States carried out fewer drone attacks in the wake of the surge in Afghanistan and during retrograde operations. This trend reflected the growing American sensitivity to the large-scale public demonstrations in Pakistan from 2012 onward that took place in response to actual or suspected strikes. The decrease in drone attacks also can be attributed to guidance issued by the Obama administration governing their use outside of areas of active hostilities. Without specifically mentioning drones, a White House press statement issued on 23 May 2013 explained, “Lethal force will be used only to prevent or stop attacks against U.S. persons, and even then, only when capture is not feasible and no other reasonable alternatives exist to address the threat effectively.” The statement further elaborated, “The United States will use lethal force only against a target that poses a continuing, imminent threat to U.S. persons. It is simply not the case that all terrorists pose a continuing, imminent threat to U.S. persons; if a terrorist does not pose such a threat, the United States will not use lethal force.”\",\n    \"That same day, President Obama spoke publicly on the drone program at the National Defense University on Fort McNair in Washington, D.C. Even though he admitted that drones offered an alternative to the less-palatable scenario of sending Special Operations units into other countries, he acknowledged the drawbacks of that course of action: “The very precision of drone strikes, and the necessary secrecy involved in such actions can end up shielding our government from the public scrutiny that a troop deployment invites. It can also lead a president and his team to view drone strikes as a cure-all for terrorism.” After noting the wide gap between official government figures and private estimates of civilian deaths, Obama stated, “It is a hard fact that U.S. strikes have resulted in civilian casualties, a risk that exists in all wars. For the families of those civilians, no words or legal construct can justify their loss. For me, and those in my chain of command, these deaths will haunt us for as long as we live, just as we are haunted by civilian casualties that have occurred through conventional fighting in Afghanistan and Iraq.” The president’s address at McNair thus effectively signaled his intention to use drones more selectively and less frequently.\",\n    \"Although nongovernment estimates of the number of drone attacks vary, alleged strikes by unmanned aerial vehicles in Pakistan ranged from forty-six to fifty in 2012 before dropping to twenty-six to twenty-eight incidents in 2013, and between twenty-two to twenty-five attacks in the final year of Operation ENDURING FREEDOM. Depending on the source of the figures, civilians accounted for a minimum of 0.6 percent and a maximum of 14 percent of the total casualties in Pakistan credited to drones during the campaign’s retrograde and transition phase. Although the drone strikes occurred less frequently, they continued to achieve notable results, including the successful targeting of the Tehrik-i-Taliban Pakistan leader Hakimullah Mehsud and his chief deputy in North Waziristan on 1 November 2013. In early February 2014, officials in Washington informally agreed to halt drone strikes in Pakistan, except on positively identified al-Qaeda leaders, while Islamabad pursued peace talks with Taliban militants based in the tribal lands.\",\n    \"With the surge at its peak, efforts to prepare the Afghans to assume the lead in security and stability initiatives across the country had begun in earnest. Beyond putting Afghan soldiers and police out front in the security mission, ISAF had to pull back the stability organizations it had developed, such as Provincial Reconstruction Teams, in order to force the Afghan government to take the lead at all levels. These efforts would require a detailed plan coauthored by ISAF and their Afghan partners.\"\n  ],\n  \"chapter 10\": [\n    {\n      \"title\": \"Afghans Into The Lead\"\n    },\n    {\n      \"section\": [\n        \"President Hamid Karzai’s inauguration remarks on 19 November 2009 indicated that the ANSF would assume full responsibility for securing their country by the end of 2014. ISAF troop-contributing nations formalized that goal two months later at the January 2010 London Conference on Afghanistan. Half a year of planning and negotiation leading up to the Kabul International Conference on Afghanistan in July 2010 had produced a plan for a phased transition. ISAF nations formalized the pending handover with the Afghan government on 20 November 2010 at the NATO head-of-state summit in Lisbon.\",\n        \"The centerpiece of the process was the Joint Framework for INTEQAL, agreed upon by the Afghan government, NATO ISAF, the UN,  nations outside the coalition, and other interested parties. Released on 19 July 2010, the document proposed a two-step process for turning responsibilities over to the ANSF and Afghan government: assessment followed by phased implementation. Regulating the pace of these transitions would be based on the progress made not just in security, but also in governance and economic development.\"\n      ]\n    },\n    {\n      \"title\": \"Inteqal: The Transition Process\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Four principles guided the Joint Framework for INTEQAL. First, the transition was to be based on the conditions on the ground, not on a particular timeline. Second, it would not end ISAF’s involvement in Afghanistan. Instead, intervening forces would shift to a supporting role as the ANSF and Afghan civilian authorities became better at security, governance, and development. Coalition members would support, mentor, enable, and sustain progress. Third, the transition was to be a district- or even subdistrict-level process, netting a “dividend” that would free ISAF resources to be “reinvested in other areas.” Finally, transition was not purely geographical. It also involved Afghan institutions and functions that could be assumed from the Provincial Reconstruction Teams, thus allowing these teams to be dissolved as needed. A potential sensitivity arose as a result of ISAF being able to move assets such as money, forces, and equipment to other areas of the country. Although such movement was unavoidable, unit reassignments disheartened Afghans who had built relationships with coalition forces and also sparked resentment from ISAF nations whose troops were reluctant to move to a location that might present a greater threat. In practice, only American forces could enter areas where new forces might be required. Only the United States, primarily through the Army’s theater and tactical sustainment infrastructure, had the capability to sustain combat power outside the tactical reach of logistics hubs at Bagram and Kandahar.\",\n        \"What made the handover of security unique was the use of distinctive language that introduced the concept of “irreversible transition.” The first public reference to “irreversible transition” appeared at the Kabul Conference in July 2010. Although the Lisbon Communiqué that conveyed the results of the November 2010 conference did not refer to this specific term, it stated that “Afghan forces will be assuming full responsibility for security across the whole of Afghanistan.” The Joint Framework for INTEQAL contained the statement “to ensure the [transition] process is irreversible, at the beginning of INTEQAL the combined ANSF/ISAF forces, under overarching Afghan lead in a province, shall be capable of tackling existing and new challenges that may arise from the insurgency.”\"\n      ]\n    },\n    {\n      \"title\": \"The First Step: Retiring Provincial Reconstruction Teams\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"INTEQAL disestablished the Provincial Reconstruction Teams that had been a fixture of the coalition campaign in Afghanistan since January 2003, when CJTF-180 commander General Dan K. McNeill had established the first team in Gardez, Paktiya Province. In his remarks at the 47th Munich Security Conference on 6 February 2011, Karzai condemned the reconstruction teams as “parallel structures” that delivered assistance to communities without going through the Afghan central government in Kabul. Karzai’s rhetoric played to Pashtun audiences but belied the patronage system that pervaded Afghan politics and was considered corrupt by Western audiences. Those misgivings had been amplified in 2010 after the near failure of the Kabul Bank, an organization that a 2012 audit revealed as a pyramid scheme.\",\n        \"Karzai’s Presidential Directive 45, dated 26 July 2012, ordered Provincial Reconstruction Teams across the country to end operations. Americans closed their teams in Paktiya, Khost, Kunar, Laghman, and Panjshir Provinces that month, while other ISAF nations closed teams in Badakhshan, Faryab, Ghor, Baghlan, and Jowzjan Provinces. Karzai’s advisers welcomed the closures, noting their country’s long-term prospects were not being supported by provincial officials who relied on ISAF representatives for funding rather than their own compatriots in Kabul. Closing the reconstruction teams also forced the preponderance of funding to funnel through the Karzai government. Although most of the remaining reconstruction teams were not slated to cease operations until the 2013–14 timeframe, they received less funding from the Commander’s Emergency Response Program, which forced local officials to route requests for money through the Afghan central government.\",\n        \"The full transition to Afghan civilian authority depended on connecting the government in Kabul with subnational governance, a process that reconstruction teams had fostered but could not enforce and, as Karzai realized, often hindered. One Afghan initiative that could backfill the void left by the dissolution of the Provincial Reconstruction Teams was the National Solidarity Program. This program was a promising development, as it was an initiative of the Ministry of Rural Rehabilitation and Development intended to empower local governance. However, the programs that fell under the National Solidarity Program were still dependent on international financial assistance. Without such aid, the National Solidarity Program was not likely to continue. Much as with efforts to improve the ANSF, efforts to improve governance not only had to prevent the Afghans from failing, but also build their self-sufficiency.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_10-1.png\",\n        \"caption\": \"An Afghan Commando hands out radios\"\n      }\n    },\n    {\n      \"title\": \"The Strategic Partnership Agreement\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"As INTEQAL gained momentum, the United States sought to form a strategic partnership with Afghanistan beyond 2014 to ensure that the government could survive the insurgency and prevent the reemergence of al-Qaeda safe havens. Karzai proved a difficult negotiating partner. He insisted that his government assume responsibility for all U.S. detention centers and that coalition forces stop conducting raids at night before he would sign an agreement. After U.S.-led ISAF and Afghan negotiations had carried on for more than a year, the first breakthrough came in March 2012 when the two sides agreed to transfer prisoners. The memorandum of understanding, signed by General John R. Allen and Afghan defense minister Abdul Rahim Wardak, immediately placed an Afghan official in charge of the U.S. detention facility in Parwan but allowed Americans to transfer their 3,200 detainees over a six-month period. The United States retained control over non-Afghan prisoners and could veto the release of suspected Taliban fighters.\",\n        \"Another development of similar importance took place, although for less positive reasons, soon afterward. After taking command, General David H. Petraeus placed growing emphasis on night raids by U.S. Special Operations elements to eliminate or capture enemy leaders, bomb makers, financiers, and arms dealers. The raids were carried out in darkness to achieve surprise and take advantage of U.S. superiority in night vision. These operations often involved combined U.S. and Afghan units, but the targets were chosen exclusively by American intelligence analysts. However, a series of mistakes led to the raids becoming an increasingly public and controversial element of the overall counterinsurgency campaign. Despite impressive statistics of enemy combatants killed or captured, the benefit of night raids waned as new tales of accidental killings and targeting errors led to mounting criticism from inside and outside Afghanistan. By spring 2012, the United States agreed to give Afghan forces control over night raids and other special operations, while the coalition adopted a supporting role.\",\n        \"These specific agreements paved the way for President Barack H. Obama and Karzai to sign the Enduring Strategic Partnership Agreement on 1 May 2012. The strategic agreement allowed the United States to train Afghan forces and target al-Qaeda beyond 2014 but did not specify troop or funding levels. It also called for the two sides to replace the U.S. State Department’s Diplomatic Note 202, which had served as a Status of Forces Agreement since 2003, a critical step for protecting the legal rights of U.S. combatants in Afghanistan. In its place, a Bilateral Security Agreement would constitute a formal agreement; the United States was also to designate Afghanistan as a major non-NATO ally. The Obama administration followed through with the designation one month later, making it easier for Afghanistan to obtain security funding and assistance in the future. The partnership agreement had symbolic importance, as it was meant to signal the Taliban and Afghanistan’s neighbors that America would not abandon Afghanistan as it had done in the 1990s. In the end, Karzai refused to sign the security agreement and the NATO Status of Forces Agreement, instead having his national security adviser sign the Bilateral Security Agreement on 30 September 2014.\"\n      ]\n    },\n    {\n      \"title\": \"Adapting Tactical Forces for Transition\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"To answer the increased demand for advisers, the Army shifted from deploying brigade combat teams to deploying brigades task organized for security force assistance. Operation IRAQI FREEDOM provided the precedent for a brigade fulfilling both combat and advisory roles in June 2008 when the 4th Brigade Combat Team, 1st Armored Division, deployed as an advise and assist brigade. Even though the Army National Guard assumed the TF PHOENIX mission in Afghanistan, the active Army did not deploy brigades for advisory duties until it ordered Col. Brian M. Drinkwine’s 4th Brigade Combat Team, 82d Airborne Division (TF FURY) to Afghanistan in the summer of 2009 as a modular brigade augmented for security force assistance. The differences within this formation, when compared to the advise and assist brigades deployed earlier to Iraq, were not purely semantic. Unlike brigades sent to Iraq, TF FURY and other brigades augmented for security force assistance were not intended to operate as combat forces. Much like TF PHOENIX, they were purely advisory. Rather than owning an area of operations, a modular brigade augmented for security force assistance would provide advisers who operated under the security “umbrella” of another brigade combat team conducting counterinsurgency operations.\",\n        \"The nuance between the two advising formations was important. Unlike in Iraq, where the United States could position units relatively easily, the political sensitivities of the ISAF mission made changes to task organization a delicate matter. Bringing an American combat force into a coalition commander’s area of operations created command and control problems and risked offending national sensitivities. Nonetheless, brigades augmented for security force assistance would be a less controversial approach than deploying additional combat units. They bolstered existing forces in RCs North, West, and Capital as part of ISAF’s operational approach of partnered operations with the ANSF. They also allowed U.S. and ISAF combat forces to start leaving the country.\",\n        \"One impetus for sourcing advisers from brigades was the cumulative effect of individually sourcing advisers, rather than sourcing them from units. The Army’s Worldwide Individual Augmentation System plucked service members from units to fill operational requirements elsewhere without replacing them. Because the system issued only temporary change-of-station orders, the individuals selected were not considered as having been reassigned. The losing unit simply took a gap in staffing, which detracted from its own readiness. Another impetus for sourcing advisers from brigade combat teams was procedural. In the Joint Operations Planning and Execution System, the overhead associated with each force package being built and readied for deployment was the same, whether it was an ad hoc group of individual augmentees or a full brigade combat team with its organic units. Because of system parameters, it was easier for the Army to source advising personnel by forming brigades.\",\n        \"The institutional solution to providing the ANSF with advisers was a hybrid of the individual augmentation and brigade task organization approaches. Building a modular brigade augmented for security force assistance entailed merging two organizations. In January 2012, the Army started to train security force assistance advisory teams to meet ISAF’s requirements. Armored and infantry brigades across the force supplied the personnel and equipment for these teams. The brigade combat teams that became donors for advisory teams were called security force assistance brigades. The 162d Infantry Brigade at Fort Polk, which inherited duties for training advisers on 31 August 2009 from 1st Brigade, 1st Infantry Division, out of Fort Riley, Kansas, became the responsible agent for molding groups of individuals into advisory teams.\",\n        \"To create modular brigades augmented for security force assistance, the Army incorporated advisory teams into standard brigade combat teams. The underlying assumption was that an infantry brigade combat team or a heavy brigade combat team could be the building block for any combat mission that Army forces might conduct, including training, advising, and assistance operations. The teams included officers and noncommissioned officers with the rank and experience to mentor Afghan leaders up to ANA corps or Afghan Uniformed Police region headquarters. They also provided advisers for the operational coordination centers that were intended to facilitate communication between the ANA and the ANP at the regional and provincial level.\",\n        \"Within the DoD’s Global Force Management system, units were designated as security force assistance brigades or modular brigades augmented for security force assistance according to their intended role. Army leaders tried to meet the demand for personnel without using the Worldwide Individual Augmentation System. At the same time, the Army sought to adjust heavy and light infantry brigade combat teams designed for combat operations for advisory missions. Preparing these units required a significant augmentation of officers and senior noncommissioned officers. The creation of the modular brigade augmented for security force assistance streamlined command and control relationships for advisers and provided partnered forces to conduct combat operations alongside the ANSF.\",\n        \"The Army’s sourcing of security force assistance brigades and augmented modular brigades coincided with a reduction in the demand for Army forces. With the impending end of military operations in Iraq, the Army was able to reallocate heavy brigade combat teams that had been earmarked for that mission. The first heavy brigade combat team redirected to Afghanistan was TF RAIDER, formed from 1st Brigade Combat Team, 4th Infantry Division, and commanded by Col. Jeffrey R. Martindale. In July 2010, TF RAIDER replaced TF FURY as a modular brigade augmented for security force assistance covering Kandahar City. TF RAIDER deployed from Fort Carson, Colorado, without tanks and Bradley fighting vehicles; they assumed control over equipment that the paratroopers of TF FURY had been using. Following this model, the Army converted other heavy brigade combat teams into advisory forces for Operation ENDURING FREEDOM, a theater accustomed to light forces.\",\n        \"The Army’s employment of heavy brigade combat teams in Afghanistan was an opportunity provided by the success of the Iraq surge combined with decisions made as part of the Grow the Army Plan. Approved in January 2007, the Grow the Army Plan sought to add 65,000 soldiers to the active Army, 8,200 to the Army National Guard, and approximately 1,000 to the Army Reserve by fiscal year 2013. New personnel supported an expansion of force to 76 brigade combat teams (48 Active Army, 28 Army National Guard), 97 multifunctional support brigades (including battlefield surveillance, aviation, fires, maneuver enhancement, and sustainment), and 130 functional support brigades (such as air defense, chemical, engineer, intelligence, military police, signal, and medical). All of the new ground maneuver combat units were infantry brigade combat teams. The first completely new unit was the 3d Brigade Combat Team, 1st Armored Division, which did not activate until 16 August 2009. Under the command of Col. Mark H. Landes, it deployed to Wardak and Logar Provinces in October 2011. In a sense, growing the Army initially benefited the Afghan mission, rather than the Iraqi one as intended. The only two maneuver units yet to have undergone modular conversion were the Germany-based 170th Infantry Brigade and 172d Infantry Brigade. They both deployed to Afghanistan as heavy forces instead of light infantry, without their tanks and Bradley fighting vehicles. The 170th Infantry Brigade, commanded by Col. Patrick E. Matlock, deployed to RC North from February 2011 to February 2012 as a modular brigade augmented for security force assistance, minus the 4th Battalion, 70th Armored Regiment, which was assigned as a security force in support of NATO Training Mission–Afghanistan advisers in RC South. Matlock’s brigade replaced Col. Willard M. “Bill” Burleson III’s 1st Brigade Combat Team, 10th Mountain Division, which had spent the past year training Afghan Uniformed Police and Afghan National Border Police. The 172d Infantry Brigade, led by Col. Edward T. Bohnemann, served as a modular brigade augmented for security force assistance in Paktika Province from May 2011 to May 2012.\",\n        \"As the ANSF assumed greater responsibility for security, the requirement for combat power shifted from modular brigades augmented for security force assistance to security force assistance brigades. Although modular brigades augmented for security force assistance were capable of self-defense and independent combat operations if necessary, their most immediate contribution to combat power was providing ANA and ANP units with intelligence and access to close air support and rotary-wing aviation. By the end of 2012, the U.S. Army was no longer sending forces trained, organized, and equipped principally for combat operations. Security force assistance brigades had become the norm.\",\n        \"The last brigade combat team to deploy to Afghanistan not specifically structured for advising was the 3d Brigade Combat Team, 101st Airborne Division, under Col. Reynolds J. Lillibridge. Although ISAF embraced security force assistance as its core mission in 2012, the experiences of several brigades demonstrated that counterinsurgency operations were still necessary to set conditions for the stability operations conducted by units structured for security force assistance. Lillibridge’s brigade replaced the 4th Brigade Combat Team (Airborne), 25th Infantry Division, at Forward Operating Base SALERNO in RC East in September 2012. Its area of responsibility encompassed the volatile Khost, Paktiya, and northeast Paktika Provinces that the Haqqani Network had long sought to dominate. Given that few ANSF were capable of competing with the Haqqani without considerable U.S. assistance, Colonel Lillibridge’s soldiers conducted operations in much the same manner as their predecessors.\",\n        \"Handing over security responsibility to ANSF began with securing the population. Understanding this, Lillibridge supported expanding Village Stability Operations in his districts. These operations began with establishing a village stability platform (similar to a forward operating base) where local Afghan police could be trained to protect their neighborhoods and impede Haqqani IED teams. While ANA units or ANP elements always accompanied units of the 3d Brigade Combat Team, 101st Airborne Division, the high threat environment ensured that the Americans led these combined operations. The firefights that occurred motivated ANSF units to improve their infantry skills, tactical planning, and communications.\"\n      ]\n    },\n    {\n      \"title\": \"The Goal of a Self-Sufficient ANSF\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"As the United States was deploying more advisory units to partner with fielded ANA units, the NATO Training Mission–Afghanistan, now headed by American Lt. Gen. Daniel P. Bolger, remained ISAF’s primary means of ensuring that the ANSF were capable of securing their own country. Between November 2009 and August 2011, the unit issued 56,859 weapons, 10,700 vehicles, and 70,262 radios to the ANA, which expanded during the period by 74,000 personnel and 64 kandaks. These figures indicated the mission’s impressive achievements, but they also created a long-term challenge as the lack of support infrastructure made it difficult for the Afghan military force to maintain the Western-made equipment. The ANA found itself grappling with unfamiliar Western technology while attempting to master tactical proficiency in an expanding force.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_10-2.png\",\n        \"caption\": \"Chairman of the Joint Chiefs of Staff General Dempsey meets with General Bolger\"\n      }\n    },\n    \"The ANSF units created during that period reflected the coalition’s near-term need to generate sufficient light infantry to augment ISAF counterinsurgency efforts as well as Commando units to aid coalition-led counterterrorist operations. Whenever Afghan units were committed alongside ISAF, the latter provided all supporting fires; rotary-wing assets; intelligence, surveillance, and reconnaissance platforms; and logistical support. Bolger’s ambitious charter therefore included not only growing the ANSF—not an easy task, given the average 30 percent annual attrition rate—but also providing Afghans with some of the more critical capabilities previously furnished by ISAF. These capabilities included the further development of self-sustaining branch and vocational schools, as well as army aviation, fire support, engineers, and logistical units.\",\n    \"Coalition efforts to develop the ANSF initially stressed quantity over quality. The idea was that once indigenous forces reached their target sizes in 2012, the ANSF would be better postured to address shortfalls in equipment, logistics, personnel, and leadership. After 2012, advisers and their Afghan counterparts would focus on developing enablers and professionalizing the force. The December 2014 deadline for the transition of the mission was of pressing importance to Afghan Special Operations and aviation units, which were heavily dependent on coalition intelligence collection and close air support.\",\n    \"Increasing ANSF authorizations to 352,000 in October 2012 was a calculated risk. The defense and interior ministries still depended on coalition assistance for planning and sustaining campaigns. A larger ANSF was needed to achieve security gains that would be irreversible by the time decreasing foreign aid forced the ANSF to downsize. Achieving those gains relied on a broad approach across multiple Afghan national defense and security force organizations.\",\n    \"The NATO Training Mission’s tactical advisory efforts in 2012 focused on ANA Corps and Afghan Uniformed Police regions, while CSTC-A covered institutional aspects with the Ministry of Defense, Ministry of Interior, National Directorate of Security, and Kabul Military Academy. Developing an Afghan security establishment that could sustain military and police forces entailed establishing institutions for training, education, and recruiting, and systems for strategic planning, intelligence gathering, logistics, and force generation. Advising commands sought an ANSF that could prevail in battle and sustain forces throughout an entire campaign.\",\n    {\n      \"title\": \"Unexpected Developments\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Although green-on-blue incidents impeded security force assistance, the actions of some Western soldiers also set back Afghan-ISAF relations. On the night of 20 February 2012, soldiers from the 535th Military Police Battalion’s intelligence section burned Islamic religious books at the detention facility in Parwan. The books had been confiscated from the facility library when the Theater Intelligence Group’s counterintelligence team discovered that detainees were using them to pass messages. As the books were examined, an interpreter informed the Americans that three-quarters of them contained extremist sentiments. Several days later, a junior leader acting on his own initiative ordered almost 2,000 of these confiscated books onto a truck for transport to the camp incinerator. Observing U.S. personnel loading Qurans and other religious texts into the vehicle, an ANA soldier went to the detention facility’s operations center to voice his concerns. Operations center personnel attempted to stop the truck but were unsuccessful. The detail arrived at the waste disposal site and began burning the books, only to be stopped by Afghan civilian workers who tossed water into the incinerator in an attempt to extinguish the flames. As the detail ignored continued protests by Afghan workers and attempted to resume burning the books, operations center personnel arrived to terminate their efforts.\",\n        \"Just weeks later, on 11 March 2012, S. Sgt. Robert Bales, a noncommissioned officer from Company B, 2d Battalion, 3d Infantry Regiment, 3d Brigade Combat Team, 2d Infantry Division, out of Fort Lewis, Washington, murdered sixteen Afghan civilians and injured many others during an unauthorized nocturnal foray from Village Stability Platform Belambai in Kandahar Province. Although originally a Special Forces program, Village Stability Operations had proven so successful that Combined Forces Special Operations Component Command–Afghanistan requested two infantry battalions to expand their implementation. At the time of the incident, Bales was the senior member of a two-squad infantry element supporting an operational detachment securing the Belambai platform. Following the Quran burnings, news of an American soldier killing innocent women and children dealt yet another severe setback to ISAF efforts to strengthen its ties with the Afghan populace.\",\n        \"Although a subsequent investigation noted the collocated element’s overall morale was good, the ODA leadership rarely interacted with the infantry squads, preferring to leave that task to noncommissioned officers. In addition, Combined Special Operations Task Force South had denied a request by Bales’ parent company to send a more senior leader to the stability platform. Leaders from the 2d Battalion, 3d Infantry, were not able to visit the outpost on a regular basis because of the remoteness of the platform and difficulties associated with obtaining helicopter transportation to the area. Although Bales did not exhibit overt signs of erratic behavior prior to the 11 March incident, his actions had concerned junior members of the infantry element on several occasions. Unfortunately, those soldiers were reluctant to voice their concerns because Bales was the senior noncommissioned officer in their chain of command. These circumstances enabled Bales to conduct a murderous rampage and hand the Taliban a major information operations victory while eroding the Afghan people’s trust in ISAF.\"\n      ]\n    },\n    {\n      \"title\": \"The Insider Threat: More Green-on-Blue Attacks\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The decision to end combat operations hinged upon Afghan security forces being able to prevent the Taliban from toppling the Kabul government. In preparation for the handover, ISAF invested more personnel, money, and resources in preparing the ANSF for increased responsibilities. ISAF not only sent more advisers to work with ANSF but also conducted more partnered operations in the field. The increasing interaction between foreign and Afghan troops made green-on-blue attacks more common. Vetting of Afghan security forces became even more critical, but assets in theater that could conduct these detailed background checks were limited.\",\n        \"The much publicized Quran burnings encouraged attacks and riots across the country. Company B, 2d Battalion, 508th Infantry Regiment, of the 82d Airborne Division’s 4th Brigade Combat Team experienced a green-on-blue incident within seventy-two hours of arriving at Combat Outpost SANGSAR on 1 March 2012. Although the incoming soldiers knew they were vulnerable to such attacks from news sources and word of mouth, they believed they were far enough from Kabul to escape Afghan discontent.\",\n        \"The incident involving Company B began at 0200 on 2 March when three Afghan attackers shot one of their comrades and an American manning the entry control point separating the Afghan and American portions of the outpost. Both of the wounded men survived, but two attackers were able to gain access to a guard tower on the American side after killing the soldier inside it. The third attacker appeared to lose heart and returned to his barracks. The two Afghans occupying the heavily armored guard tower then turned their weapons on the tents and buildings housing Company B. Within seconds, the attackers killed an American noncommissioned officer making his way to the guard tower to investigate the situation. Fortunately, concrete barriers surrounding the tents and buildings occupied by the Americans prevented the assailants in the guard tower from inflicting additional casualties on Company B.\",\n        \"The other paratroopers on duty mounted a hasty counterattack to recover the downed noncommissioned officer and prevent the rogue ANA soldiers from leaving the tower and entering the sleeping area on the U.S. side of the outpost. The Americans quickly discovered that all of the antitank rockets and 40-mm. grenades they fired at the tower were bouncing off it without inflicting damage because their warheads did not have sufficient time to arm. Undeterred, the paratroopers poured an intense volume of machine-gun fire into the tower, silencing their opponents long enough for several Americans to begin tossing grenades at the guard post atop the tower. Although the grenades only succeeded in setting fire to a fuel container underneath the tower, smoke and flames soon enveloped it. Using the cover provided by the inadvertent conflagration, the attackers climbed down to the top of the perimeter wall, whereupon they began making their way from the camp to the surrounding wood line. The Americans made a quick call to a nearby Apache helicopter, whose crew tracked down and killed both assailants.\",\n        \"The investigative process began almost immediately after the fires were extinguished, as information from the U.S. soldier wounded at the entry control point proved sufficient to identify and arrest the third attacker. The investigation disclosed that an Afghan civilian instructor contracted to teach reading and writing to the Afghan soldiers at the outpost had been the instigator of the attack. The teacher, who had radical ideas and ties to the Taliban, used the Quran burnings as a motivation to recruit an Afghan noncommissioned officer and two enlisted soldiers for a surprise attack on the Americans. The assailants then waited until the U.S. units were in the middle of their relief-in-place to make their move. Although the Americans had adequate reason to distrust their allies, one platoon leader marveled at the sight of “two of my soldiers sitting down, trying to talk with the ANA soldiers. Most of the platoon felt betrayed by these partner forces, but there were a few who understood better than I did that if we showed them we were human too and built a relationship, we could possibly deter these Green on Blue attacks.”\",\n        \"In April 2012, American Lt. Gen. James L. Terry, the V Corps and IJC commander, estimated that 25 percent of green-on-blue incidents were “insurgent-related.” In response, he announced “the vetting process of individuals who are coming into the Afghan National Army and Afghan National Police with an eight-step process [including] the requirement to have valid identification cards, letters of endorsement or recommendation from village elders and other aspects, criminal background checks, and so on.” Expanded collection of biometric data such as fingerprints and iris scans and intensified counterintelligence screening were expected to exclude potential security risks and reduce inside attacks. These efforts led to the discharge of hundreds of recruits who displayed any sign that they were capable of being radicalized. In addition, the deaths of two Americans killed in the offices of the Afghan defense ministry prompted ISAF to implement a program in August 2012 in which armed NATO service members, designated as “guardian angels,” protected unarmed comrades working in administrative areas.\",\n        \"Insider attacks reached new heights in 2012 and influenced NATO’s advisory plan. Protectors such as the guardian angels were now  required to ensure the safety of teams embedded with their Afghan counterparts, increasing the personnel committed to each mission. According to Maj. Gen. Tod D. Wolters, the commander of the 9th Air and Space Expeditionary Task Force–Afghanistan from 2011 to 2012, a single green-on-blue incident could force ISAF at any time:\",\n        {\n          \"list\": [\n            \"\\\"to go back and look at the math equation as far as the ratio is concerned in this Security Force Assistance model. . . .  Any time you have one of these Green on Blue incidents, as you can well imagine, you’re probably a little less prone to have one coalition member support 50 Afghan security members. You might be in a position where you desire to have five or six coalition members.\\\"\"\n          ]\n        },\n        \" \"\n      ]\n    },\n    {\n      \"title\": \"Operation NAWEED\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Maintaining trust between ISAF and Afghan soldiers became paramount as Afghan security forces began repositioning major elements in advance of the security transition. During autumn 2011, the IJC staff worked on a plan supporting Operation NAWEED (Good News), the ANA, ANP, and National Directorate of Security operational campaign for 2012. Operation NAWEED utilized an overarching approach to synchronizing ANSF and ISAF efforts. Also known as Operational Plan 1391 (after the year 1391 under the Afghan calendar), it was authored by the Ministry of Defense with help from the IJC, and was the Kabul government’s attempt to convince its citizens that Afghan army and police units could provide for their safety. The plan divided the country into geographical sections concurrent to the regional command boundaries designated by ISAF, and described a detailed concept for how ISAF, National Directorate of Security, Afghan police, and army forces would cooperate in each region. It listed ISAF and ANSF responsibilities, detailed the conditions under which the handover would occur, and laid out a general timetable.\",\n        \"Operation NAWEED was unique in that it was the first plan conceived and written by the ANSF. The Afghan authors of NAWEED recognized that security transition entailed more than transferring responsibility from one party to the other. As a result, their plan directed shaping operations in the provinces of Nuristan, Kunar, Nangarhar, Logar, Paktiya, Khost, Zabul, Kandahar, Helmand, Nimroz, and Farah to target known enemy strongholds to wrest the operational initiative from the insurgents. The ANSF would also have to blunt enemy counterattacks so as to maintain security in key areas. The Afghan government viewed NAWEED as an opportunity to exert greater control over its borders. Although ISAF would continue to provide air support, helicopters, medical evacuation, and other critical services, General Allen convinced the Afghan Ministry of Defense to use NAWEED to develop the Afghan military’s logistical systems. The nine-month planning process ended with the Afghan Ministry of Defense publishing Joint Order No. 5 on 1 September 2012. Immediately after issuing the plan, the Ministry created the Afghan Army’s Ground Forces Command and ANSF National Military Operations Center. NAWEED would be the first test for both organizations.\",\n        \"Operation NAWEED involved all six ANA Corps, the separate 111th Division, Afghan Uniformed Police, Afghan Border Police, National Security Directorate organizations, and developmental ministries, including the Ministry of Rural Rehabilitation and Development; the Ministry of Agriculture, Irrigation, and Livestock; and the Independent Directorate of Local Government. Each major ANA formation received broad goals and objectives tailored to its area of operations. These objectives included preventing insurgent groups from conducting operations and ensuring that criminal elements such as smugglers, kidnappers, extortionists, and drug lords were unable to take advantage of the security transition process.\",\n        \"Because implementing the plan simultaneously across the country would overwhelm the nascent ANSF logistical system and newly reconfigured national command and control structure, U.S. and Afghan planners ensured that Operation NAWEED unfolded deliberately. By the time Tranche 3 was announced on 13 May 2012, the ANSF was responsible for securing 75 percent of Afghanistan. This period also marked a major structural change for the ANSF, namely the creation of the Afghan National Army Special Operations Command and Special Mission Wing, both of which began operations on 16 July 2012. The first command created an advocate for Afghan SOF that prevented the Afghan conventional force leadership from improperly utilizing their unique capabilities.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_10-3.png\",\n        \"caption\": \"ISAF commander General Allen\"\n      }\n    },\n    \"The Special Mission Wing provided aviation support for the Afghan Special Forces. The wing was created from the former Ministry of Interior Air Interdiction Unit, which was originally formed for counternarcotics operations. Its charter, outlined in a memorandum of understanding among the U.S. Office of the Secretary of Defense, Combined Training Command, and the U.S. Drug Enforcement Administration, expanded the scope of the organization to include aviation support for Afghan counterterrorism and SOF. In spite of an agreement signed by the National Defense Service and the interior and defense ministers in August 2013, the Special Mission Wing’s split parentage was beset with infighting, and its command relationship remained unresolved through the end of the ISAF campaign.\",\n    \"The one bright spot for the Special Mission Wing was its tactical capability. In spite of the fight over the unit, it successfully conducted multiple air assault and aerial surveillance missions in support of Afghan SOF operations. The NATO Training Mission’s deputy commanding general for SOF had originally trained, advised, and assisted the wing. Eventually, oversight was transferred to the newly created NATO Special Operations Component Command–Afghanistan, with Army Special Operations Aviation personnel in charge of training, advising, and assisting. The creation of Afghan SOF and Special Mission Wing came at a favorable moment in September 2012, as Tranche 4 gave the ANSF lead security responsibility for 87 percent of the population.\",\n    \"With the Afghans continuing to increase their control of the security environment across the country, and the Afghan government building capacity and pushing it out to the provinces, the coalition drawdown of forces and materiel could begin in earnest. However, a successful drawdown would be much more complex than merely redeploying soldiers and equipment. An intricate, coordinated plan of base closures throughout Afghanistan would be required so as not to leave security or governance voids that insurgents could exploit. U.S. and ISAF leadership would have to strike the right balance between steadily removing their assets on the ground and maintaining support for continued stability within Afghanistan—a mission that would put all of their hard-learned experience to the test.\"\n  ],\n  \"chapter 11\": [\n    {\n      \"title\": \"Drawdown\"\n    },\n    {\n      \"section\": [\n        \"In his address at the United States Military Academy at West Point, New York, on 1 December 2009, President Barack H.  Obama told the assembled cadets:\",\n        {\n          \"list\": [\n            \"\\\"I have determined that it is in our vital national interest to send an additional 30,000  U.S. troops to Afghanistan. After eighteen months, our troops will begin to come home The 30,000 additional troops  that I’m announcing tonight will deploy in the first part of 2010—the fastest possible pace—so that they can target the insurgency and secure key population centers.\\\"\"\n          ]\n        },\n        \"Seventeen months later, in late June 2011, he followed up on those remarks:\",\n        {\n          \"list\": [\n            \"\\\"Thanks to our extraordinary men and women in uniform, our civilian personnel, and our many coalition partners, we are meeting our goals. As a result, starting next month, we will be able to remove 10,000 of our troops from Afghanistan by the end of this year, and we will bring home a total of 33,000 troops by next summer, fully recovering the surge I announced at West Point.\\\"\"\n          ]\n        },\n        \"The president also explained that U.S. troop withdrawals would not end with the recovery of the surge forces. In fact, tens of thousands of additional American troops would depart Afghanistan in the months leading up to the planned transition of security responsibilities at the end of 2014.\",\n        \"Drawing down forces entailed the retrograde of equipment and the disposal of materiel that would be uneconomical to return to the United States. The stockpile that had to be reduced, retrograded, and disposed of had been accumulating since the U.S. mission began in 2001. In addition to the sheer amount of materiel involved, the equipment was widely dispersed and had to travel long distances over routes that the coalition did not control. Consequently, planning for the retrograde became a multiyear effort to meet the policy goals that had been set for the end of 2014. Although ANSF and Afghan civilian leaders eagerly accepted coalition equipment and bases, materiel without further utility was scrapped or destroyed. The U.S. military leaders who planned and executed the drawdown were mindful of the fact that Soviet military equipment and supplies left over from the Soviet-Afghan War of the 1980s had been used extensively in the Afghan civil war of the early 1990s by government and opposition forces alike. This knowledge shaped their approach to handling their own equipment as the United States pulled back from its involvement in Afghanistan.\",\n        \"Senior commanders in the final three years of the ISAF and Operation ENDURING FREEDOM missions had to balance two necessary tasks while maintaining the force caps specified by policy decisions. Those policy decisions mandated that coalition military equipment in Afghanistan be reduced, while enablers such as close air support and intelligence support to the ANSF would be continued at current levels. Throughout the process, the coalition had to protect itself from the same malign elements that it was training the ANSF to fight. Although the retrograde of equipment and materiel and the transition to security force assistance were separate efforts, they complemented each other.\"\n      ]\n    },\n    {\n      \"title\": \"Scoping the Surge Recovery\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Planning for the drawdown started before Obama announced at the NATO Summit in Lisbon on 20 November 2010 that ISAF would begin transitioning security responsibility to the ANSF in early 2011. The first substantive work toward planning the drawdown of surge forces started in June 2010 and resulted in an order on 18 August 2010 directing units in Afghanistan to prepare to dispose of specified excess equipment. A second conference on excess equipment at the CENTCOM forward headquarters in Qatar from 13–14 October 2010 and a CENTCOM order on 7 December 2010 directed USFOR-A to begin planning to redistribute or dispose of equipment that was not mission essential.\",\n        \"As the USFOR-A deputy commander for support, Maj. Gen. Timothy P. McHale was responsible for withdrawing forces and equipment from Afghanistan. His planning had to occur concurrently with planning for surging forces into theater. As early as July 2010, the 401st Army Field Support Brigade, an organization from the U.S. Army Materiel Command supporting USFOR-A, took advantage of lessons learned in Iraq to begin preparations to expand property holding facilities even as the military saturated the theater with new units. Yet even with these proactive measures, the contractors overseeing operations in the yards soon found themselves struggling with the growing workload.\",\n        \"Although planning continued through winter and spring, it competed with combat operations throughout Afghanistan,  which included the 10th Mountain Division’s assumption of responsibility for RC South from the British. The Afghan surge also marked an expansion of the Afghan Local Police and aggressive clearing operations in Helmand, Kandahar, and Uruzgan Provinces. On 5 April 2012, while those operations were underway, USFOR-A published Fragmentary Order 11–072: ${Interim Base Closure and Transfer Guidance}{italic}, ordering all U.S. units in Afghanistan to prepare for withdrawal concurrent with ongoing combat operations.\",\n        \"Although commanders at all levels understood how important it was to reduce theater assets, units in combat were hard-pressed to account for equipment, redistribute property, remediate hazardous environments, and modify or terminate contracts. The tensions among combat operations, growth of the force as a result of the surge, and planned retrograde were greatest in RCs South and Southwest. Each regional command stood to lose more than one hundred combat outposts and bases by summer 2011. Requirements to return those bases to their original environmental state demanded close oversight from the engineer staff at USFOR-A, and added to the complexity of missions.\",\n        \"Leaders made some broad assumptions at the beginning of the planning process. When the American command started looking at how it could reduce excess, it did not contemplate a full withdrawal from Afghanistan. Furthermore, ISAF and IJC staff officers recognized that the theater had to shed personnel but did not consider that equipment had to be withdrawn in tonnage greater than the equipment associated with current troop numbers. They also had to deal with warehouses and motor parks full of equipment not being used by units in the field. Tactical planners, focused on combat operations, simply wanted to mitigate the burden that retrograde placed on their units that were still conducting combat operations to clear and hold terrain in support of the Afghan surge. This made concurrent planning for the retrograde difficult to attain at all echelons.\",\n        \"Other ISAF members also were reducing their personnel and equipment. The Netherlands ended its combat mission on 1 August 2010, while Canada withdrew its task force in July 2011. The British planned to withdraw roughly 500 troops from their commitment of approximately 9,000 troops, with the goal of reducing the total to 4,500 by 2013.\",\n        \"Planning the drawdown of forces from Afghanistan was not a direct equivalent to the retrograde from Iraq. Brig.  Gen. Scottie D. Carpenter, commanding the 311th Sustainment Command near the end of the Afghan drawdown, was forthright about the considerations:\",\n        {\n          \"list\": [\n            \"\\\"It took me about a week here to realize, this isn’t Iraq. In Iraq, it was a fairly simple process of driving equipment to  Kuwait and letting it sit there until someone else could ship it home. Afghanistan is a landlocked country. Here, everything is difficult. Retrograding equipment is time-consuming, it’s expensive. You have to consider the PAK GLOC [ground lines of communication through Pakistan] and whether it’s open or not. Iraq had improved roads, here the road networks can be very difficult. So, retrograde here is much more complex and difficult than what I experienced in Iraq.\\\"\"\n          ]\n        },\n        \"The stark differences between the two redeployments dwarfed any similarities they shared.\"\n      ]\n    },\n    {\n      \"title\": \"Geography and the Initial Disposition of the Force\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The manner in which the United States retrograded forces from Afghanistan reflected how the conflict had expanded geographically over the past decade. From ISAF’s arrival in Kabul in late 2001 and the 10th Mountain Division’s occupation of the Bagram and Kandahar airfields in early 2002, coalition forces had spread eastward and southward. The desire to interdict lines of communication to Pakistan and interact with Afghans through Provincial Reconstruction Teams justified new bases such as SALERNO in Khost Province and ORGUN-E in Paktika Province. Later, the shift to population-centric counterinsurgency expanded the coalition footprint to the northeast and southwest into the heavily populated Pashtun areas. Because the U.S. footprint had expanded, most of the forces and materiel needing to be withdrawn from Afghanistan were concentrated in RC East, RC South, and RC Southwest.\",\n        \"The Hindu Kush and Afghanistan’s landlocked borders posed challenges to logisticians. Most of the country was either mountainous or desert, cargo coming in by road would transit Afghanistan National Highway 1, the Ring Road, which circled the Hindu Kush in the south, west, and north, and penetrated the mountain range by way of the Salang Tunnel in the east. This increasingly decrepit tunnel was the only alternative to transporting cargo through Taliban-controlled areas in RC South.\",\n        \"There were four border crossing points where cargo could exit Afghanistan via ground transportation in the north. The easternmost, at Qizil Qal’ah in Kunduz Province, led to Tajikistan. Located approximately 260 kilometers by road to the west was a crossing into Uzbekistan at Hairatan in Balkh Province. Hairatan was also the location of the only rail line in Afghanistan, which extended only as far south as the north-central city of Mazar-e Sharif. The third crossing was about 290 kilometers by road west of Hairatan at Aqineh in Faryab Province, bordering Turkmenistan. The westernmost crossing was approximately 940 kilometers west by road at Toraghundi in Herat Province and also spilled traffic into Turkmenistan. The first three, and later all four, of those border crossings were entry points in what the United States called the Northern Distribution Network, a connection of truck, rail, and water routes through Kazakhstan, Russia, and Latvia to Baltic seaports. The network was also operated under NATO authorities as the Northern Ground Line of Communications.\",\n        \"Afghanistan had two border crossing points suitable for heavy cargo south of the Hindu Kush. The eastern crossing was at a gate complex between Tor Kham, Afghanistan, and Tor Kham, Pakistan, entering the Khyber Pass from Nangarhar Province toward the Pakistani city of Peshawar. The western crossing was at Spin Boldak in Kandahar Province, directly opposite the Pakistani city of Chaman and on the route to Quetta, the provincial capital of Balochistan. Both the Peshawar and Quetta routes converged at Karachi on the Arabian Sea. These routes collectively constituted the Pakistan ground line of communications.\",\n        \"All of these border crossing points could handle vehicle traffic. In February 2012, a rail line opened from Mazar-e Sharif to Termiz, Uzbekistan. A subsidiary of the Uzbekistan State Railways Company operated the line, in conjunction with ISAF advisers, while it trained Afghan engineers and mechanics to assume those roles. The continued operation of a rail line required a secure environment, and Balkh Province had been relatively quiet. However, the Taliban had made inroads into neighboring Kunduz Province and launched several successful attacks into Balkh in 2011.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-11-1.svg\",\n        \"caption\": \"Northern Distribution Network\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"Both the Northern Distribution Network and Pakistani ground routes had significant limitations. The latter had been in use for most of the war, but Pakistani instability and cargo theft had persuaded U.S. Transportation Command to develop the Northern Distribution Network as an alternative. Although there was little pilferage of cargo transiting the northern route, it cost approximately double what the Pakistani routes cost and took anywhere from twenty to forty days longer to deliver the goods.\",\n    \"Unfortunately for ISAF, bilateral agreements prevented the Northern Distribution Network from being used for combat vehicles, weapons, and ammunition. Those cargos had to go through Pakistan or move by air transport. Meanwhile, Islamabad’s political sensitivities would not accommodate U.S. personnel working at the Port of Karachi or along the routes connecting offloading docks to Afghanistan. Some outsized cargos such as Stryker personnel carriers and MRAP vehicles were too impractical or sensitive to move through Pakistan and had to exit the theater on Air Force C–5 or C–17 cargo aircraft.\",\n    {\n      \"title\": \"Air Transport and Multimodal Operations\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Air transport was the fastest and most secure method to bring cargo in or out of Afghanistan, but it was also the most expensive. It cost approximately $12,400 to haul a single 6.1-meter shipping container (empty or full) via commercial truck from Afghanistan to Karachi, load it on a ship, and return it to the United States. In comparison, it cost $167,400—nearly $56,000 per container—to transport the equivalent of three fully loaded shipping containers aboard an Air Force C–17 fixed-wing transport aircraft from Kandahar Airfield to Fort Campbell, Kentucky. Furthermore, although airlift was faster than sealift, the actual throughput via air was slower because a single cargo vessel ferried the equivalent of hundreds of aircraft sorties during a single voyage.\",\n        \"The compromise that emerged combined truck, rail, sea, and air transportation in what was called multimodal operations. The Northern Distribution Network was effectively multimodal because cargo moved from border crossing points by truck, watercraft, and rail to the seaports in Europe prior to returning to the United States. Multimodal transport paid huge dividends for cargo leaving from southern Afghanistan. Outgoing cargo could be loaded onto a C–17 at Bagram or Kandahar and flown to Kuwait or another location in the CENTCOM area of responsibility. After being offloaded, vehicles and containers could then be shipped back to the United States. The throughput was greater and cheaper. Because the shorter flights were considered intratheater lift, they were under the control of the Combined Air Operations Center at Al Udeid Air Base in Qatar rather than U.S. Transportation Command. Because of this, they were more responsive to the theater requirements; an important consideration given that circumstances frequently required reallocating transport assets.\"\n      ]\n    },\n    {\n      \"title\": \"Competition for Limited Assets\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"One of the fundamental differences between the drawdowns in Iraq and Afghanistan was coalition presence. The expiration of UN Security Council Resolution 1790 and the refusal of the Iraqi government to approve coalition missions beyond 31 July 2009 meant that the British and Australians departed Iraq on 28 July 2009, leaving only American forces by the end of Operation NEW DAWN. In Afghanistan, however, ISAF’s status as a NATO mission meant that coalition members would continue missions throughout the ISAF campaign. The simultaneous extraction of troops and equipment by several nations complicated retrograde efforts as coalition partners competed for space on ground and air lines of communications.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_11-1.png\",\n        \"caption\": \"A C–17 Globemaster\"\n      }\n    },\n    \"Under NATO doctrine, logistics, including transportation expenses, were a national responsibility. Only NATO equipment and headquarters could receive NATO funding; anything provided by a country for the ISAF mission was paid for by that country. In some cases, the United States supported other countries through lift and sustain agreements. Eligibility for such assistance was limited to those allies deemed essential to stability operations. In practice, it meant that the United States was responsible for redeploying the personnel and equipment for multiple nations. Army forces conducted most of the retrograde activity within the CENTCOM area of responsibility. To coordinate all of the moving parts in multimodal transportation, retrograde required tight synchronization. Detailed planning and control of participating units mitigated the risk of well-meaning tactical commanders unhinging the entire effort through their own, undisciplined initiatives.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_11-2.png\",\n        \"caption\": \"General Rapp visits Army Field Support Battalion Kandahar\"\n      }\n    },\n    {\n      \"title\": \"Planning the Retrograde\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Translating policy guidance into campaign plans started with a Joint Staff order on 1 July 2011 directing the planning of surge recovery. On 20 August, CENTCOM published Fragmentary Order 07–769, Order to Plan Drawdown of U.S. Surge Forces in Afghanistan, directing USFOR-A to begin withdrawing surge forces in accordance with President Obama’s national address. The order outlined two phases. The first was to reduce end strength by 10,000 troops by the end of 2011, leaving 91,000 U.S. service members in country. The second was to send another 33,000 troops back to the United States by the end of September 2012. Planners at USFOR-A were responsible for identifying who would be withdrawn and sequencing their departure. In the meantime, McHale’s tour as deputy commander for support ended on 1 September 2011 when he transferred his duties to Maj. Gen. William E. Rapp. As planning continued, it became apparent that the U.S. forces did not have a truly accurate assessment of what materiel actually was in Afghanistan. Because retrograde planning could not proceed without that knowledge, the USFOR-A Fusion Cell published Fragmentary Order 11–228 on 21 September 2011. The order directed Operation CLEAN SWEEP–AFGHANISTAN, a phased retrograde and base reduction plan that would identify serviceable and unserviceable theater-provided equipment. On 29 September 2011, the initial estimate of theater-provided equipment in Afghanistan was approximately 26,000 vehicles and 1.8 million pieces of nonrolling stock, which later was estimated to require the equivalent of 95,000 containers. The initial estimate valued that materiel at approximately $17 billion and predicted that it would cost $6 billion to move it out of Afghanistan. Those estimates increased to $25 billion and $10 billion respectively as Operation CLEAN SWEEP–AFGHANISTAN continued.\",\n        \"In a discussion near the end of September 2011, Rapp told ISAF commander General John R. Allen that “we have a physics problem.” There was always the potential that the coalition might have “to go to zero,” meaning total withdrawal of all personnel at the end of 2014. Consequently, any planning for surge recovery had to account for the materiel that had accumulated since 2001. In 1989, the Soviet Union’s 40th Guards Army had left stockpiles of weapons, ammunition, and other equipment for the military of the Republic of Afghanistan, and that equipment had been a major factor in the ensuing Afghan civil war. It was unlikely that the American public or NATO would tolerate its war materiel being used in a similar uprising.\",\n        \"General Rapp realized that his subordinate commanders and staff needed a target with which to plan and measure progress. That target, which he termed the “Number,” was his estimate of how much excess needed to be pushed out of theater per month once the surge recovery had ended. The initial Number, calculated on 24 October 2011, was estimated at 1,250 vehicles and equivalent containers. Rapp’s intent was to create a consistent stream of rolling and nonrolling stock to be turned in for disposal. Whatever was not disposed of in Afghanistan would have to be transported out of the theater. As USFOR-A staff members continued analyzing the retrograde, they settled on 1,200 vehicles and 1,000 containers transported a month, along with the closure of twenty bases per month through November 2012. Some believed that President Obama would keep a residual force of 10,000 to 20,000 service members in Afghanistan after 2014, but Rapp assumed the American forces would have to empty the theater by the end of 2014 under the premise that slowing retrograde was easier than accelerating it.\",\n        \"To meet these three targets, USFOR-A would need the assistance of partners outside Afghanistan. The most vital of these were the Army Materiel Command, Defense Logistics Agency, U.S. Transportation Command, and Office of the Assistant Secretary of Defense for Logistics and Materiel Readiness, which granted the authority for much of what eventually transpired. Most of the equipment in theater had been provided by the Army, and the U.S. Army Materiel Command was the agent for identifying outbound equipment to fill requirements outside Afghanistan. Items not identified for shipment out of Afghanistan were slated for disposal and became the responsibility of the Defense Logistics Agency. Armored vehicles were cut apart with plasma torches, while smaller equipment was destroyed in industrial shredders. Finally, U.S. Transportation Command was responsible for moving cargo from Afghanistan to its final destination. Retrograde could not have occurred without outside assistance, although it was impossible for these state-based units to alleviate all withdrawal tasks from deployed units.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_11-3.png\",\n        \"caption\": \"IJC Commander General Scaparrotti\"\n      }\n    },\n    {\n      \"title\": \"The CENTCOM Materiel Recovery Element\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Planning for retrograde had to account for the reality that Afghanistan remained an active combat zone. In his first “surge recovery workshop”  on 5 October 2011, Rapp outlined three priorities for USFOR-A: maintain campaign momentum, plan the surge recovery, and exercise stewardship of equipment. A week earlier, IJC commander Lt. Gen. Curtis M. Scaparrotti had voiced concerns that surge recovery might interfere with combat operations. Scaparrotti’s worries were well founded, as ISAF’s posture at the time included bases ranging in size from giant air fields at Bagram and Kandahar to assistance platforms housing only ANSF advisers. RCs South and Southwest retrograding began the previous summer. As tactical units occupying small bases simply did not have the personnel or resources to conduct advisory operations, protect themselves in contested areas, and retrograde equipment all at the same time.\",\n        \"In mid-November 2011, Rapp asked Scaparrotti for a dedicated force to handle retrograde actions so that units would be free to focus on combat operations. Any dedicated retrograde force had to be counted toward force caps for military personnel as well as limits on exempted staff for contractors. The only other way to get personnel that would be exempt from force caps was to utilize an external logistics task force on temporary duty orders, as was the case with the Marine Corps’ Retrograde and Redeployment In Support of Reset and Reconstitution Operations Group which had been formed the year before to begin the retrograde of RC Southwest. The forces were critical to the retrograde mission, but they could not be assigned the mission unless they were exempt from theater force caps.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-11-5.svg\",\n        \"caption\": \"Force Laydown\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"Fortunately, Scaparrotti and Allen readily endorsed Rapp’s proposal for a Retrograde Task Force, which was intended to be a joint organization, given that RC Southwest included a Marine Air-Ground Task Force and a sizable Army support structure. Rapp had engaged senior leaders such as CENTCOM commander Marine Corps General James N. Mattis and Deputy Secretary of Defense Ashton B. Carter to gain support. In parallel, the USFOR-A and ISAF staffs engaged their counterparts at CENTCOM, Third Army/U.S. Army Central Command, the Defense Logistics Agency, and U.S. Army Materiel Command. Their work came to fruition on 12 December 2011 when CENTCOM published Fragmentary Order 07–778 directing the actions necessary to reduce to 68,000 personnel; setting the roles, missions, command, and control structure for the retrograde; and preparing the theater to endure steady-state retrograde operations through the end of the campaign. The order explicitly stated the need for a “Reposture Task Force” dedicated to retrograde operations.\",\n    \"The retrograde was to be divided into four phases, generally corresponding to the targets that had been given in policy statements on force levels. Phase I, from July 2011 to March 2012, was dedicated to achieving initial operating capability and withdrawing 10,000 troops by the end of 2011 as directed by President Obama in his 22 June 2011 speech. The Phase I goal was to close 10 bases and eliminate 800 containers and 600 vehicles per month. To achieve those aims, approximately 4,000 troops were redeployed or curtailed without replacement. Planners envisioned a Reposture Task Force becoming operational during Phase II to assist in reducing troop strength to 68,000 by the end of summer 2012. They proposed continuing the retrograde based on 10,000–20,000 U.S. forces remaining in Afghanistan after 2014. Rapp’s Number—12,000 vehicles, 1,000 containers, and 20 bases—would remain constant once Phase II started.\",\n    \"The competing demands of progressively smaller force caps, the advising mission, and force protection had stalled previous attempts to retrograde equipment. On 4 January 2012, Mattis formally requested that the secretary of defense and chairman of the Joint Chiefs of Staff support force cap exemptions for the 2,400 military and 1,400 civilian personnel needed for the CENTCOM Materiel Recovery Element and, two days later, sent a formal request to the Joint Staff. After endorsements from Chairman of Joint Chiefs of Staff General Martin E. Dempsey and Secretary of Defense Charles T. “Chuck” Hagel, the president approved a 2,400-troop exemption in March. The Materiel Recovery Element exemption was crucial to pushing forces out of Afghanistan because it concentrated retrograding expertise on the retrograde itself, thereby enabling combat commanders to focus on the immediate needs of the Afghans in their areas of operations.\",\n    {\n      \"title\": \"Trouble on the Border\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"As the retrograde gathered momentum, an unforeseen development in late 2011 closed the Pakistan ground line of communications. On the night of 25–26 November, an ANA Special Forces Company, aided by fourteen U.S. Special Forces soldiers, targeted a Taliban cell operating from the village of Maya near the Afghanistan-Pakistan border. Soon after CH–47 Chinook pilots deposited the Afghan and U.S. forces, they came under machine gun and mortar fire from positions atop a ridgeline to the east. Given the proximity of Maya to the border, the troops on the ground requested a show of force rather than return fire. The unidentified assailants continued targeting the Afghan and U.S. forces despite a low-level pass by an F–15E Strike Eagle. In response, an AC–130 Spectre gunship and AH–64 Apache helicopters engaged the assailants. Over the next ninety minutes, the commander on the ground authorized two more air strikes as his troops continued to receive fire. The engagement ended at 0105 after IJC confirmed that Pakistani Army personnel occupied the high ground overlooking Maya and had been firing on U.S. and Afghan forces. The Afghan and U.S. forces then entered Maya, where they collected a substantial amount of Taliban weapons, supplies, and equipment before being airlifted out on 27 November.\",\n        \"Upon receiving news of the incident, CENTCOM ordered an investigation. CENTCOM offered to conduct a joint inquiry with the Pakistani military, but Islamabad declined. As a result, CENTCOM relied on news agencies for the Pakistani perspective. After interviewing all U.S. and Afghan participants, investigators learned that the Pakistani military had not been notified of the raid in a complete or timely fashion, a required practice. In addition, electronic mapping devices mistakenly depicted the nearest Pakistani unit as fourteen kilometers from Maya. However, poor coordination and erroneous map data do not satisfactorily explain why Pakistani military personnel ignored the show of force or continued firing at U.S. and Afghan troops for almost two hours. In retrospect, it is clear that mistakes by both parties contributed to the fatal encounter.\",\n        \"The incident triggered claims and counterclaims by the United States and Pakistan. According to news accounts, the Pakistani government strongly believed that the air strikes against the ridgeline east of Maya were “premeditated, irresponsible and deliberate. . . . The [Afghan and U.S.] soldiers were 300 meters inside Pakistan, in the Mohmad [Mohmand Agency] tribal areas, recently cleared of militants.” Not content with trading claims with Washington, Islamabad ordered CIA drone operators to leave Shamsi Airfield in southwest Pakistan within fifteen days. Determined to gain as much diplomatic leverage as possible, Pakistan’s high commissioner to the United Kingdom, Hina Rabbani Khar, warned British officials that “this business could . . . wreck the timetable for an American troop withdrawal.” To prove its point, the Pakistani government shut down the roads running through the Khyber Pass that led to the Port of Karachi. Severing the Pakistan ground line of communications posed a tremendous challenge to ISAF; nearly 40 percent of its inbound and outbound logistical traffic utilized those routes. It would take months of negotiation to reopen the Pakistani routes.\",\n        \"The reopening of the ground route through Pakistan on 3 July 2012 did not accelerate retrograde efforts, as the first containers of nonrolling stock did not transit it until February 2013. Although the route was nominally open, throughput lagged for different reasons. Pakistani drivers operating out of Karachi had gone on strike to protest their government’s demand that local truckers could carry ISAF equipment only if they worked with an authorized transport company. Afghan and Pakistani customs agencies had ongoing disputes with each other over procedures and protocol. The only method available to move cargo out of Afghanistan was now flying transport planes to seaports in the CENTCOM area of responsibility.\"\n      ]\n    },\n    {\n      \"title\": \"Accelerating the Surge Recovery\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The loss of the Pakistan ground lines of communications interrupted the retrograde before it had started in earnest. Before that point, outbound retrograde throughput was a trickle; as few as fifty vehicles exited in September 2011. Retrograding the theater became a two-part problem encompassing both inbound and outbound cargo. In its role as the National Support Element, USFOR-A had to control inbound cargo flow while ensuring that it disposed of any equipment that could be dealt with in Afghanistan. Reducing equipment in Afghanistan required controls to ensure that units did not bring in more equipment than could be retrograded; the issue was net cargo flow rather than just outbound throughput. At the front end, the cargo coming into the theater had to be reduced. Units rotating into Afghanistan had tried to bring their own equipment, much of which included the latest and most modern technology. After arriving in Afghanistan, many units received additional equipment specific for the mission they would assume.\",\n        \"The 401st Army Field Support Brigade, which had set up redistribution property accountability yards in anticipation of the surge recovery, began identifying what was actually in Afghanistan. Years of fielding equipment to units after their arrival in Afghanistan had left a mass of excess equipment in theater. After multiple transfers of authority and changes in areas of operations, much of this equipment was badly in need of a proper inventory. Redistribution property accountability teams were responsible for inventorying and accounting for this excess equipment, which then became available to incoming units.\",\n        \"One of the greatest innovations to assist the property accountability process came from Col. Kurt J. Ryan’s 10th Sustainment Brigade, which established a retrograde sorting (“retrosort”) yard at Bagram in December 2011. Retrosort yards accepted excess, nonmission-essential equipment and cargo containers from units that were reducing their bases in Afghanistan, even if the units did not have complete custody paperwork. By relieving units from having to account for this property, retrosort yards helped units clear bases while still conducting partnered operations with the ANSF, and lifted the burden of maintaining, sorting, and processing, materiel not on their property books. The yards also served as reutilization warehouses that provided free issue to units that needed it, rather than shipping it from home station. From February to July 2012, Col. Jeffrey W. Drushal’s 45th Sustainment Brigade established another retrosort yard at Kandahar Airfield and a third at Camp John Pratt near Mazar-e Sharif.\",\n        \"As could be expected, it took time to stand up the CENTCOM Materiel Recovery Element. Although units already in Afghanistan such as the 10th Sustainment Brigade shifted to the mission once approved, the first unit allocated in its entirety to the CENTCOM Materiel Recovery Element mission was the New York Army National Guard’s 427th Support Battalion. Upon its arrival in March 2012, the battalion was split between the 10th and 45th Sustainment Brigades in RC East and RC South respectively. The first dedicated Materiel Recovery Element organization at Kandahar Airfield was established in July 2012 with the arrival of the 18th Support Battalion commanded by Lt. Col. Michelle M. T. Letcher.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_11-4.png\",\n        \"caption\": \"Spc. Jackie Tackett uses a rough terrain container handler\"\n      }\n    },\n    \"Addressing inbound flow required units to identify what equipment they required for the mission. U.S. Army Central Command was the broker for all requests for equipment, which it did in conferences with USFOR-A, IJC, and incoming units. These consultations helped USFOR-A achieve its monthly goal of 1,200 vehicles and 1,000 containers in March 2012, a substantial improvement over the 50 pieces of rolling stock that had moved in September 2011. This achievement validated the multimodal approach and was all the more remarkable because the Pakistani lines of communications were still closed.\",\n    \"Equipment designated for disposal in Afghanistan fell into categories that all required different authorities. Much of the property that had built up in theater, whether operated by military units or contractors, was termed foreign excess personal property since it was no longer necessary to the mission. Foreign excess personal property included containerized housing units, industrial safety equipment, air conditioners, refrigerators, generators, computers, furniture, water trucks, forklifts, tractors, and other nontactical vehicles. On 23 January 2012, Alan F. Estevez, assistant secretary of defense for logistics and materiel readiness, greatly accelerated the retrograde by granting “tiered delegation authority” to tactical commanders, allowing them to approve transfers of foreign excess personal property directly to the Afghans after vetting the transaction with USFOR-A.\",\n    \"Equipment too expensive to transport was designated as excess defense articles. The United States offered excess defense articles to other countries at no charge under the proviso that it was “where is, as is.” Those who received these items were responsible for transporting and maintaining them. USFOR-A worked closely with the U.S. Embassy in Kabul to solicit interest from other Central Asian states, though those countries generally were interested in only new equipment available through foreign military sales. Therefore, the excess defense article program would never become the primary dispersal method of excess property for U.S. forces.\",\n    \"Because Rapp was adamant that the United States would not leave military equipment behind after a drawdown, he permitted excess defense articles to be transferred to the ANSF only under exceptional circumstances. His counterpart in these transactions was Lt. Gen. William B. Caldwell IV, commander of the NATO Training Mission. Caldwell’s command had spent significant effort to disabuse Afghan soldiers of the belief that equipment and other resources had to be hoarded. The tendency to mass combat equipment for status reasons ran counter to the coalition’s efforts to build an Afghan logistics enterprise and streamline ANSF vehicle fleets so to reduce their maintenance burden. The Training Mission had been trying to stop this type of hoarding behavior for years. A similar rationale existed for transferring bases; the ANSF had to be able to maintain any property they received from the coalition. A base that the ANSF could not maintain ran the risk of becoming either a drain on the Afghan government’s resources or a battle position for the insurgency if abandoned or overrun.\",\n    \"In most cases, there was still serviceable equipment left even after disposing of excess personal property and defense articles. On 1 March 2012, the DoD granted its Defense Logistics Agency authority to destroy serviceable equipment that U.S. Transportation Command representatives jointly determined too costly to ship. Serviceable vehicles that were not required elsewhere or whose values were less than the cost to ship them back to the United States—the majority of items being in the latter category—were destroyed in theater. In the absence of the Pakistan ground lines of communications and with the lack of significant backhaul throughput on the Northern Distribution Network, multimodal transport was the most reliable method for equipment that could not be disposed of or destroyed. It was a costly option, but nonetheless it was the most fiscally sound decision given that the campaign was coming to a close.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/map_11-3.svg\",\n        \"caption\": \"Force Laydown\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"The CENTCOM Materiel Recovery Element formed around Letcher’s battalion preceded much larger ones. The August 2012 arrival of the 593d Sustainment Brigade, commanded by Col. Douglas M. McBride Jr., enabled USFOR-A to establish a single materiel recovery element headquarters for all of Afghanistan. As retrograde throughput continued to accelerate, the last of the 33,000 troops constituting the Afghan surge departed by 21 September 2012, marking the end of Phase II and shrinking U.S. forces to their 68,000 force cap.\",\n    {\n      \"title\": \"Securing the Retrograde\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Along with sending additional logistical elements to manage the retrograde, CENTCOM sought to prevent the Taliban from exploiting vulnerabilities in the country’s contested eastern region by temporarily allocating General Allen additional combat power to use as he saw fit. As a result, the U.S. Army deployed Lt. Col. David W. Gardner’s 2d Battalion, 505th Infantry Regiment, 3d Brigade Combat Team, 82d Airborne Division, from Fort Bragg, North Carolina, to Afghanistan as the ISAF Operational Reserve Force. Gardner’s unit was to conduct Operation READY EAGLE, which began on 10 July 2012 and lasted for four months. The mission was “disrupting enemy forces in Afghanistan’s Regional Command East to provide repositioning units space and time to perform retrograde operations and battlespace handover.” In other words, the battalion would engage the Haqqani and the Taliban where they found them so they would not interfere with the retrograde. The forces included a company from the 2d Battalion; an ODA from the 1st Special Forces Group, 1st Special Forces Regiment; and an ANA Commando company. Throughout the operation, the infantry company normally would establish a cordon around the targeted area to secure it so the U.S. and Afghan SOF could search the objective, interact with locals, and gather intelligence. Unlike the broad geographical charter of its predecessors, 2d Battalion, 505th Infantry, focused on Afghanistan National Highway 1, the primary land route supporting retrograde operations in RC East. Rather than react to Taliban attacks, Gardner executed intelligence-driven preemptive strikes on known Taliban bases in order to eliminate fighters and destroy caches stockpiled for future attacks on ISAF convoys. The Taliban fighters could have abandoned their positions near the highway, but they trusted that their elaborate IED fields would give them advance notice of ISAF encroachment and inflict casualties on potential attackers. Many Taliban outposts featured extensive tunnel systems that allowed fighters to avoid detection while minimizing the damage inflicted by fires called in by ISAF ground troops. Conducting READY EAGLE missions until winter terminated the 2012 fighting season, 2d Battalion, 505th Infantry, was able to shift the Taliban’s attention from attacking retrograde convoys to defending their safe havens along the highway.\"\n      ]\n    },\n    {\n      \"title\": \"ISAF Infrastructure Comes Under Attack\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Although the Taliban focused on reconstituting its ranks following the surge, it also sought to remain in the media by  conducting high-profile attacks. This quest for favorable news coverage began on 15 April 2012 with a coordinated assault by Haqqani fighters on embassies, a supermarket, a hotel, and the parliament building in Kabul, as well as targets in eastern Nangarhar, Logar, and Paktiya Provinces. Eleven ANSF personnel, four Afghan civilians, and thirty-six insurgents were killed in the ensuing fighting. ISAF commanders may have considered the attacks relatively ineffective from a purely military standpoint, but Western media outlets took a different view: “Though the death toll was relatively low . . . it highlighted the ability of militants to strike high-profile targets in the heart of the city even after ten years of war.”\",\n        \"The sharply contrasting assessments of the same event once again highlighted the fact that ISAF and the U.S. military rarely conducted effective information operations. News releases from the various military headquarters in Afghanistan often presented the perceptions and beliefs of senior leaders to the public rather than unvarnished facts. They tended to downplay mishaps by friendly forces and enemy successes and overemphasize friendly successes. Even among news agencies that were dedicated to presenting events as objectively as possible, without any particular editorial bias, their reporting was only as accurate as the information they received from official sources. President Hamid Karzai magnified these disparities in reporting when he began regularly contradicting ISAF releases during his second and final term in office. Consequently, global audiences were far more likely to consider the media as more reliable than the military, regardless of the latter’s nationality.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_11-5.png\",\n        \"caption\": \"Field artillery at Forward Operating Base Pasab\"\n      }\n    },\n    \"The media-oriented approach continued when Haqqani fighters launched a complex attack on Forward Operating Base SALERNO near the city of Khost on 1 June 2012. Originally established in September 2002, SALERNO had grown into a sprawling community. The base, which now hosted nearly 5,000 ISAF service members and contractors, had been unsuccessfully assaulted by the Taliban in 2008 and 2010. At the time of the Haqqani attack, it boasted a combat support hospital, aviation hangars, helicopter arming and refueling facilities, subcamps for U.S. special operators, a gymnasium, a post exchange, a chapel, a community dining facility, and a gravel runway capable of supporting C–130 Hercules aircraft.\",\n    \"The Haqqani Network had earned a reputation among ISAF personnel for meticulous planning, disciplined leadership, and mastery of small unit tactics. Exploiting familial ties within Khost, Paktiya, and Paktika Provinces to gain intelligence and access, Haqqani fighters often launched unexpected attacks on ISAF targets before withdrawing to their sanctuary in Miran Shah, Pakistan. At 1200 on 1 June, a flatbed truck loaded with roughly a ton of explosives detonated after being parked next to the southern perimeter wall at SALERNO. A few moments later, an insurgent drove a white minivan through the gaping hole in the wall to disgorge more than a dozen attackers intent on massacring unarmed soldiers and contractors in the nearby dining facility, which had been severely damaged by the blast. Unbeknownst to the insurgents, a platoon from Company A, 1st Battalion, 501st Infantry Regiment, reserved by the commander of 4th Brigade Combat Team, 25th Infantry Division, for high-value targets of opportunity, was billeted near the dining facility.\",\n    \"Without taking time to organize, soldiers from the platoon rushed to the damaged dining hall. An inner wall prevented the Haqqani fighters from advancing directly on their target, allowing the Americans to win the race to the dining facility where they occupied positions overlooking the breach. With bursts of machine gun fire, they cut down a number of heavily armed insurgents clad in U.S. uniforms. As the firefight continued, several American combat vehicles arrived at the scene, oblivious that some of the men dressed in U.S. uniforms were Haqqani fighters.\",\n    \"To the Americans occupying defensive positions near the dining hall, it seemed as if the enemy fighters were chafing at the imposed delay. Instead of remaining in their relatively secure positions, the attackers sprinted across the road, incurring more casualties before stopping to shoot rocket-propelled grenades at their defenders. While the delay permitted the American platoon to consolidate, a single attacker sought cover under vehicles parked near the dining facility. As the firefight increased in intensity, drivers positioned MRAP vehicles and Afghan police vehicles on the flanks of the attackers to cut off their escape routes.\",\n    \"Next to appear on the scene were several OH–58 Kiowa Warrior helicopters from the 82d Airborne Division. The Kiowa pilots could not employ rockets or Hellfire missiles because of the proximity of friendly troops, so they leaned out of their cockpits and emptied M4 rifles at the attackers while making low-level passes over the breach. Reacting to the fire from overhead, the Haqqani sought cover elsewhere only to be killed by Americans firing at point-blank range from their defensive positions. One Haqqani fighter managed to reach a sewage-filled ditch, where he resisted for a few minutes before being shot. At about the same time, the attacker hiding under the vehicles was killed after wounding two Americans. The battle ended with the enemy force eliminated, five Afghan civilians killed, and one 4th Brigade soldier mortally wounded. About one hundred ISAF soldiers and civilians were treated for superficial injuries incurred when the dining facility and adjacent post exchange collapsed.\",\n    \"Although the Haqqani Network failed to inflict serious damage and casualties at Forward Operating Base SALERNO, Taliban spokesmen described the attack as a tremendous victory. To the Americans, it showcased the tensions between retrograde efforts and combat operations. Even though the U.S. military was drawing down its presence in Afghanistan, it still needed sufficient materiel to safeguard U.S. and ISAF forces against well-coordinated insurgent attacks. On the international scene, the incident at SALERNO triggered diplomatic broadsides between Washington and Islamabad. Obama administration officials cited the incident as an example of why the Pakistani government needed to take extraordinary steps against the Haqqani Network. The attack prompted Defense Secretary Leon E. Panetta to proclaim during a 7 June 2012 visit to Kabul that the United States had reached “the limits of our patience” with Pakistan. Those remarks came one day after Panetta “slammed Pakistan as an untrustworthy partner” during a visit to neighboring India.\",\n    \"The Taliban gained the victory it sought with a subsequent attack on the Bastion-Leatherneck-Shorabak base complex in RC Southwest on the night of 14–15 September 2012. Built around Camp Bastion, a British-occupied compound supporting operations in what was then RC South, the complex had merged in June 2010 with the adjacent Camps Leatherneck and Shorabak, respectively occupied by U.S. marines and ANA forces. Forty kilometers of chain-link fence and guard towers girded the base, which could accommodate up to 30,000 personnel within its one hundred square kilometers. The Taliban attack benefited from the fact that ISAF commanders were expected to protect bases enlarged to accommodate surge troops with a dwindling number of personnel. The Marine contingent on Leatherneck, which numbered more than 17,000 in March 2012, had shrunk to 7,000 by the time of the attack.\",\n    \"Fifteen enemy fighters infiltrated through a chain-link fence near an unguarded tower on Camp Bastion just after dark on 14 September. The Taliban strike force, wearing U.S. uniforms adorned with name tags and 10th Mountain Division insignia, split into three five-man teams to attack the fixed-wing aircraft and helicopters of the 3d Marine Air Wing (Forward) parked on the airfield. The infiltrators remained undetected for sixteen minutes while they destroyed six Marine AV–8B Harriers and damaged two more, along with one Army C–12 fixed-wing transport, three Marine MV–22 Ospreys, one C–130 Hercules, and one British Sea King helicopter.\",\n    \"In addition to the damaged and destroyed aircraft, the assault teams exploded three fuel bladders, destroyed five fabric aircraft shelters, and severely damaged two British vehicles. A combination of Taliban grenades, machine guns, and fire from responding ISAF helicopters damaged four more aircraft shelters and a maintenance building. Two Americans were killed and eight more were wounded in the attack, while the British forces suffered eight wounded. ISAF personnel responding to the attack, aided by Marine helicopters, killed fourteen of the fifteen attackers in a hectic four-hour battle. A company from the 2d Battalion, 75th Ranger Regiment, which remained uncommitted during the fight to avoid fratricide, swept the flight line at dawn. Shortly afterward, ISAF soldiers captured the one enemy survivor, who provided his captors with enough information to enable SOF to track down the planner of the attack.\",\n    \"The Taliban’s efforts to duplicate its successful attack on Camp Bastion elsewhere did not prove as fruitful. Twelve Taliban insurgents attacked Forward Operating Base FENTY on the eastern outskirts of Jalalabad on the afternoon of 2 December 2012. At the time, FENTY housed the incoming 1st Brigade Combat Team, 101st Airborne Division; the outgoing 4th Brigade Combat Team, 4th Infantry Division; medical evacuation and attack aviation assets; SOF; ANSF units; contractors; and other tenants. FENTY also had a surgical hospital capable of stabilizing combat injuries prior to sending wounded soldiers out of country. Additionally, FENTY had the only asphalt airfield capable of supporting C–130s in the region, which meant that it handled most of the ISAF air traffic into Nangarhar and surrounding provinces. The attack began suddenly. Insurgents directed a truck bomb against a guard tower overlooking the pedestrian gate entrance on FENTY’s northern perimeter at 0550, and followed it with a second truck bomb at the same location. Twelve enemy fighters, covered by machine guns and rocket-propelled grenades firing from hidden positions across the Kabul-Jalalabad Road on the other side of the ruined pedestrian gate, charged in an attempt to enter FENTY. Fortunately for the camp’s inhabitants, the ANSF unit billeted nearest the gate was preparing for a dawn live-fire exercise. The Afghan soldiers and their American advisers began shooting at the Taliban seeking to enter FENTY, forcing the attackers to take cover in a drainage ditch running along the adjacent highway. Using the fire as cover, soldiers from 3d Special Forces Group, 1st Special Forces Regiment, blocked enemy access to the camp by physically wedging one of their HMMWVs in the gap opened by the truck bomb.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_11-6.png\",\n        \"caption\": \"An AH–64 Apache\"\n      }\n    },\n    \"American troops from the 3d Battalion, 75th Ranger Regiment, ascended the surviving guard tower in order to engage Taliban fighters sheltering in a ditch outside the camp. At the same time, two pilots from 2d Squadron, 17th Cavalry Regiment, jumped in their Kiowa Warrior helicopters and flew to the scene, followed by a pair of AH–64 Apaches. All four helicopters made firing passes along the length of the ditch while the Taliban began engaging the pedestrian gate defenders with mortar fire. Shortly afterward, a third truck bomb rammed the perimeter wall beneath the tower. The explosion wounded six Rangers, forcing them to abandon their vantage point. The efforts of the third truck-bomb operator were in vain, however, as the orbiting Apaches wiped out the pinned-down enemy assault element with 2.75-inch rockets.\",\n    \"The attack, which ended ninety minutes after the first truck bomb exploded, resulted in twelve Taliban deaths, four ANSF fatalities, fourteen Afghan military wounded, ten American service members wounded, and one U.S. civilian contractor injured. The events at FENTY illustrated that although the Taliban had informants within many ISAF installations, those individuals were rarely capable of gathering a full and timely picture of activities taking place within the bases. In this instance, the attackers unexpectedly encountered Afghan and U.S. Special Operations personnel gathering at the point of the attack for a training exercise. Galvanized by the brazen assault, U.S. forces stepped up their own intelligence collection efforts in the region. Consequently, only three weeks later, the timely acquisition of intelligence led to a SOF raid that apprehended six individuals who had been organizing a repeat attack. As coalition forces continued the drawdown, the confidence and competence of the ANSF would become even more critical.\"\n  ],\n  \"chapter 12\": [\n    {\n      \"title\": \"Transitioning from Counterinsurgency to Security\"\n    },\n    {\n      \"section\": [\n        \"By 21 September 2012, the last of the surge forces had redeployed and USFOR-A met the White House’s guidance by reducing end strength to 68,000. The 33,000 troops withdrawn over the previous year predominantly came from everywhere but RC East. Those reductions included six Army brigade combat teams, five Marine infantry battalions, elements of a combat aviation brigade, and headquarters staff. Coalition forces had also reduced, most significantly with the departure of Task Force LAFAYETTE, the French brigade operating in RC East on 16 July 2012. In its place, ISAF increased its security force assistance teams, reflecting the shift in mission from combat to advising. That advisory focus was crucial as the ANSF assumed greater responsibility for securing Afghanistan.\"\n      ]\n    },\n    {\n      \"title\": \"The ANSF and the Culmination of INTEQAL\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Command of ISAF changed in the midst of security transition. On 10 February 2013, Marine General Joseph F. Dunford Jr. assumed command of ISAF from General John R. Allen. Dunford signaled the soundness of the campaign plan developed by Allen with an 18 June 2013 announcement heralding the start of Tranche 5, also known as Milestone 2013. On that day, the ANSF assumed responsibility for securing all of Afghanistan, a landmark achievement that testified to the progress made in the past years. The ANSF also had taken responsibility for planning their annual and seasonal operations. Among the new ANSF plans was Operation OQAB (Eagle), which coordinated the efforts of Afghan ministries. OQAB was the successor of the previous year’s Operation NAWEED. Political corruption and criminality remained problems, but the Ministry of Defense and the Ministry of Interior were markedly better and more independent at Milestone 2013 than they had been in 2011 at the beginning of the surge recovery.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_12-1.png\",\n        \"caption\": \"General Dunford, Lt. Gen. Keith M. Huber, and Brig. Gen. Balan R. Ayyar\"\n      }\n    },\n    \"The decision to stress capability development over rapid growth had started to have a noticeable effect. By the end of June 2013, the ANSF led nearly 90 percent of all operations and secured almost 90 percent of Afghanistan. By the time Milestone 2013 was reached, ANA kandaks had proven themselves capable of planning and executing tactical operations from start to finish and had developed a nascent capability for combined arms operations at the brigade level while preventing the insurgency from seizing population centers or lines of communications. Work remained on logistics, operational and strategic planning, intelligence sharing, and aviation. Enabling Afghans to consolidate gains beyond the small-unit level, however, would require ISAF to change its operational method.\",\n    \"ISAF intensified its efforts to shift from combat advising to functionally based security force assistance during 2013. Advisers now aligned  with Afghan components on eight essential stability functions: (1) plan, program, budget, and execute; (2) transparency, accountability, and oversight; (3) civilian governance of Afghanistan’s security ministries and adherence to rule of law; (4) force generation; (5) sustain the force; (6) plan, resource, and execute effective security campaigns; (7) develop sufficient intelligence capabilities and processes; and (8) maintain internal and external strategic communications capability. Connecting these eight functions was intended to develop the long-term sustainability of the Afghan security ministries and forces. By October 2013, 344,602 Afghans were serving in the army, police, or paramilitary organizations such as the Afghan Local Police. Afghan security forces conducted 95 percent of conventional operations and 98 percent of special operations in Afghanistan. Although the ANA did not exhibit the tactical aptitude of ISAF units, its performance was good enough to force the Taliban to abandon open battle and restrict attacks to indirect methods such as IEDs.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-12-2.svg\",\n        \"caption\": \"Force Laydown\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"The ANA planned, executed, and sustained several major offensives aimed at eliminating staging grounds for insurgent attacks on Kabul during 2013. The largest of these efforts, which took place in Logar Province in September and October, involved several ANA corps, Afghan SOF, and the Afghan Air Force. Its purpose was to clear a valley and secure a district center so that humanitarian supplies and voter registration materials could reach the local population. After three weeks of fighting with intermittent air support as a result of inclement weather, government forces achieved their objectives. As the ANA withdrew from the valley, the Ministry of Interior replaced the departing soldiers with police to provide sustained security.\",\n    \"Now that they led most combat operations, Afghan security forces suffered more killed and wounded than in previous years. During a September  interview, Dunford expressed his concern that ANSF were averaging more than one hundred deaths per week: “I’m not assuming that those casualties are sustainable.” The Afghan National Army’s nonbattle attrition rates, which included desertion due to diminishing ISAF medical support and the increased chance of injury, doubled to almost 3 percent monthly and 30 percent annually. Despite combat losses and nonbattle attrition, no Afghan Army unit collapsed in battle, and recruiting goals continued to be met.\",\n    \"The trends emerging from this period indicated both the strengths and weaknesses of U.S. security force assistance efforts. Fielding new equipment such as the U.S.-manufactured M224 60-mm. mortar proved helpful. This lightweight and easily maintained weapon increased the Afghan Army’s ability to overmatch enemy forces while reducing its reliance on ISAF air support. The ANA performed credibly at the tactical level, but Afghan military units experienced difficulties mastering intricate battlefield functions such as counter-IED operations, maintenance, fire support, collecting and disseminating intelligence, and providing medical care.\",\n    {\n      \"title\": \"The Unified Implementation Plan\",\n      \"level\": 2\n    },\n    \"Putting the Lisbon Communiqué and Allen’s campaign direction into practice required an operational plan to guide tactical actions during INTEQAL. That task initially fell to Lt. Gen. James L. Terry, who approved a support plan that came to be called the Unified Implementation Plan. The Unified Implementation Plan had its roots in Terry’s experience commanding the 10th Mountain Division and RC South in 2010–2011 when Terry attempted to unify the guidance his unit received from the various headquarters in its area of operations. As General Terry prepared to deploy the V Corps staff to Afghanistan, he envisioned a similar approach for IJC. Work on the Implementation Plan started in January 2012 at the V Corps’ home station in Germany and was refined during a mission rehearsal exercise held from 18 March to 5 April 2012. The plan became active after Terry assumed command of IJC when the V Corps relieved Maj. Gen. Curtis M. Scaparrotti’s I Corps on 12 June 2012.\",\n    \"Several years of operating under IJC and with the NATO Training Mission had given conventional ground units a degree of coherence that had not existed before 2012. Unfortunately for unity of effort, that coherence excluded ISAF’s other subordinate commands, most notably NATO Special Operations Component Command–Afghanistan and NATO Air Command–Afghanistan. While operationally relevant within their own domains, these organizations were not part of a unified framework and pursued different campaign objectives. Another factor complicating coalition unity was the Afghan concern that the Unified Implementation Plan would supersede Operation OQAB, the Afghan-planned operation for 2013. Although competition between the two plans was always possible, Terry’s goal was to complement ANSF efforts, not replace them.\",\n    \"Allen had provided Terry guidance on the Unified Implementation Plan by setting the acceptable risks to both the force and the mission. In his own assessments, Terry recognized that the Unified Implementation Plan had to translate ISAF’s strategic guidance into tactical direction for his regional commands. The plan needed to provide context to coalition partners in the joint operating area as well. Even though it had been informed by the highest levels of expertise in operational planning in theater, the plan was limited in that it encompassed only units in IJC’s hierarchy. Therefore, it excluded special operations, air-advisory actions, and much more. The Unified Implementation Plan could not direct the detention and rule of law functions that fell under Lt. Gen. Keith M. Huber’s Combined Joint Interagency Task Force 435 or the anticorruption and economic development efforts that fell under Combined Joint Interagency Task Force SHAFAFIYAT, a command that had just passed from Maj. Gen. Herbert R. McMaster to Maj. Gen. Richard C. Longo. Terry’s immediate concern, consistent with his tactical responsibilities as a corps commander, would be to balance force reductions with risk to the force over time. In October 2012, concurrent with work on the Unified Implementation Plan, ISAF had added additional retrograde guidance by publishing Amendment 2 to Revision 6 of its campaign plan. This plan was inherently a compromise, as it had to be vetted through the NATO chain of command and approved by the North Atlantic Council. It consequently did not meet with Terry’s satisfaction.\",\n    \"The Unified Implementation Plan was not written like a traditional operations plan. Its structure was narrative in form, starting with a statement of operational design more consistent with a theater strategy than a campaign plan. Its planning horizon extended beyond INTEQAL to the end of the ISAF mission in December 2014. It was intended to continue transitioning security responsibility to the ANSF independent of the stability planning occurring at IJC. In the absence of a comprehensive theater strategy in Operation Plan 38302, the Unified Implementation Plan approved by Terry on 1 January 2013 provided long-term direction for U.S. forces in theater.\",\n    \"After seeing the clarity that the Unified Implementation Plan provided to Terry’s subordinate units, Dunford wanted to reexamine Operation Plan 38302 but refrained from doing so knowing that any revision might stall in the NATO approval process. In its existing state, Operation Plan 38302 covered ISAF’s activities to the end of the Afghan surge recovery, which had concluded a year earlier. Because a document such as the Unified Implementation Plan could not serve as authoritative guidance to ISAF beyond regional commands, Dunford filled the gap by directing his deputy chief of staff for operations, American Maj. Gen. Sean B. MacFarland, to develop fragmentary orders that complemented the IJC plan.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_12-2.png\",\n        \"caption\": \"IJC commander General Terry (left) speaks with ISAF commander General Dunford\"\n      }\n    },\n    \"The order to complete Operation Plan 38302, issued as ISAF Fragmentary Order 081–2013 on 20 May 2013, was the first clear statement of what ISAF would do after INTEQAL ended. Fragmentary orders did not normally offer strategic guidance, but 081–2013 foretold how the ISAF and Enduring Freedom campaigns would progress from Milestone 2013 to the end of both missions on 31 December 2014. It built on work in the Unified Implementation Plan to provide guidance critical to implementing Dunford’s campaign visualization. It was through this fragmentary order that Dunford would direct the transformation, started under Allen, of ISAF into an organization dedicated to security force assistance.\",\n    \"The concept, to be instituted in May 2013, included general principles but offered scarce guidance on how units would interact with the ANSF. Because little time was left in the campaign and the ISAF troop-contributing nations had diverse backgrounds, the principles were less prescriptive for adviser conduct. Rather than focus on operations, Dunford emphasized that security force assistance must be done with ANSF sustainability in mind, provisionally defined as “the ability to maintain the SFA [security force assistance] effort throughout all the phases of the operation and the ability of the Afghan Security Institutions and ANSF to sustain their capabilities independently over the long term.”\",\n    \"One example of ANSF sustainability was in the area of planning and executing campaigns, where there had been decent progress already. By fall 2013, the Ministry of Defense had developed the Afghan National Military Strategy to guide the ANA through 2017. The ANA General Staff had completed its planning for Operation OQAB, its operations order for Solar Year 1392 (2013), earlier than in previous years. The Ministry of Interior made similar progress, publishing both a National Police Strategy and a National Police Plan without direct coalition assistance. Although both ministries had made substantial progress in improving their logistics, they still needed help in identifying national sustainment requirements and getting supplies and maintenance to the force.\",\n    \"One of the greatest obstacles to developing those capabilities in the ANSF was finding the appropriate expertise in the coalition itself. Above the tactical level, troop-contributing nations had little expertise in the strategic planning, programming, force structure, and budgeting necessary to advise a national defense establishment. The largest repository of those skills was the contractors and civilians at CTSC-A. Such knowledge was less common in CTSC-A’s uniformed military members, let alone other Operation ENDURING FREEDOM or ISAF organizations. Exacerbating the issue was the need to balance short-term operational imperatives with long-term developmental needs. Building professional security institutions from individual and small-unit skills up to the ministerial level required coalition commanders to allow the Afghans to build expertise in basic tasks such as operational planning, supply, maintenance, and transportation while also addressing their long-term developmental deficiencies.\",\n    \"At the end of 2013, recognizing how little time was left in the ISAF and ENDURING FREEDOM campaigns, Dunford directed a change in emphasis from advising tactical units to advising ANA corps, ANP regional headquarters, and the national ministries. Dunford truly believed the ANSF were becoming tactically proficient, and therefore a change in advisory efforts was warranted. In a statement to the Senate Armed Services Committee on 12 March 2014, he highlighted the improved skills and continued cohesion of the ANSF in spite of increased casualties. As a result of the change from counterinsurgency to stability operations, American and coalition casualties in 2013 were a quarter of what they had been in 2010, when ISAF had started partnered security operations with the ANSF. Dunford’s statements, while indicating the progress that the security forces and Afghan ministries had made, were a precursor to the immense effort required to reshape ISAF and its subordinate commands for the shift away from security operations.\",\n    \"The U.S. policy guidance supported this shift during 2013 and 2014 but remained vague for the post–ENDURING FREEDOM campaign. Surge recovery guidance not only affected retrograde efforts but also changed ISAF’s operational approach. Up to the transition, coalition forces had taken the lead for security so that the ANSF could stand up as an independent force. Coming at the end of surge recovery, a self-sufficient ANSF, capable Afghan institutions, and a transformed ISAF became the operational goals of allied intervention.\",\n    \"The campaign’s dependence on hard policy guidance for the post-2014 mission complicated planning for the retrograde. The final international agreement authorizing military operations in Afghanistan under the ISAF mission was published on 10 October 2013 as United Nations Security Council Resolution 2120. That resolution granted ISAF’s authorization under Chapter VII of the United Nations Charter through 31 December 2014 but indicated that the mission would not be extended further, stipulating that the headquarters would render its final report by December 2014. The way around this impasse came in changing how participants defined the post-2014 mission. As a noncombat mission, the subsequent NATO-led Operation Resolute Support did not fall under the provisions of Chapter VII. Prior to any subsequent UN Security Council resolution, agreements for a noncombat post-2014 mission would have to be negotiated bilaterally between Afghanistan and individual states or multinational entities.\",\n    \"In spite of repeated claims that he would sign a bilateral security agreement between the U.S. and Afghan governments, Afghan president Hamid Karzai refused to do so, even after a referendum and loya jirga (grand assembly) overwhelmingly called for such a document. Karzai’s reticence troubled Dunford and his political leadership as the majority of personnel and equipment for the post-2014 mission would come from the United States. The need for counterterrorism operations to continue under Operation FREEDOM’S SENTINEL (the U.S. mission following ENDURING FREEDOM) required a bilateral security agreement granting the United States legal authorization for military operations in Afghanistan after 2014. Without this authorization, U.S. forces would not be able to participate in the mission—and without the U.S. military contribution, there would be no RESOLUTE SUPPORT mission.\",\n    {\n      \"title\": \"Layered Security and the Maturation of the ANSF\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"With assistance from the NATO Training Mission and CSTC-A, efforts to develop the ANSF and their supporting institutions evolved into what ISAF commander General Allen initially termed as a “layered defense in depth,” in which synchronization, redundancy, and ANSF components would complement each other. Over time, the concept of layered defense in depth gave way to the more general notion of layered security.\",\n        \"Dunford formally introduced his layered security concept in March 2013 as an addendum to the ANSF’s Operation 1392, or OQAB. Rather than applying personnel, resources, attention, and intellectual effort to one component of the ANSF, layered security sought to establish coordination across Afghanistan’s security apparatus. According to the concept, the Afghan Uniformed Police, which comprised most of the Ministry of Interior’s conventional police forces, would operate in the population centers, while the ANA would cover the areas beyond those centers. As its name implied, the Afghan Border Police would control border crossing points.\",\n        \"As the layered security concept evolved, it came to encompass local indigenous forces such as the Afghan Local Police (ALP).  A year earlier, in front of the Senate Armed Services Committee, Allen attested to the effectiveness of the ALP by stating:\",\n        {\n          \"list\": [\n            \"\\\"What has happened with the ALP is it has created opportunities for large amounts of the Afghan population to reject the Taliban.  And there—there is—there have been some SIGINT [signals intelligence] . . . where Taliban commanders have said, if you can, kill an ALP commander, so an Afghan local policeman who is leading his own tribesmen in that particular village, if you can kill an ALP commander it’s worth 10 coalition soldiers. The Taliban are very threatened by the ALP because the significant terrain, the key terrain in a counterinsurgency, is the human terrain, and the Afghan local police deny the human terrain to the Taliban.\\\"\"\n          ]\n        },\n        \"Layered security protected coalition forces as well as Afghans. Dunford used an analogy of a soccer game to describe force protection under the construct. As the last line of defense, security forces guarding coalition bases equated to goalkeepers. Prior to shooting on goal, the insurgency would have to go through the Afghan Border Police, ANA, and ANP. Even though a skilled goalkeeper would stop most shots, given enough opportunities and time, the insurgents would eventually score. The goalkeeper would have a much better chance of defending the goal if the other lines of defense denied the attacker opportunities to shoot. Therefore, it was in the best interest of all to develop all the lines of defense equally. The soccer analogy resonated with coalition audiences and encouraged continued engagement by other troop-contributing nations. What remained, of course, was building those relationships among the ANSF.\",\n        \"The layered security concept would undergo a sustained test even as it was adopted. In early 2013, the Taliban announced that its spring offensive KHALID BIN WALEED—named after the great Muslim general from the time of the Prophet Muhammad—would begin on 28 April. The Taliban promised to direct suicide assaults on coalition installations, launch “special military tactics” and “collective martyrdom operations,” and employ “insider attacks” known as green-on-blue attacks. Although ISAF had met previous spring offensives with intense summer campaigns, recent developments prevented similar action in 2013. The 33,000 additional military personnel deployed to Afghanistan as part of the 2010 surge were now largely gone. The wholesale departure of foreign troops convinced the Taliban that efforts to discredit coalition and ANSF security gains would produce greater dividends at less cost than in the recent past. As a result, the Taliban sought to reassert itself within the Pashtun-dominated south and began to expand its footprint in the east while also making a long-deferred appearance in the west. At the same time, the Taliban sought to influence the domestic political climate of ISAF-contributing nations and dissuade Afghans from supporting the Karzai government by launching multiple, high-profile attacks in Kabul.\",\n        \"Taliban efforts in early 2013 thus focused on gaining tactical advantage over the ANSF and moral ascendency over the Karzai government before the 2014 elections. Although the Taliban’s spring offensive did not begin until 28 April, 2,331 attacks were recorded during the first four months of 2013, a figure that exceeded the previous year’s total for the same period by 47 percent. In addition to launching more attacks, the Taliban targeted ANSF personnel rather than coalition forces. In the first quarter of 2013, the Taliban and its associates killed 1,183 Afghan soldiers, compared to 841 during the same period in 2012. In a related development, coalition fatalities fell from 183 (135 U.S.) during the January–May period in 2012 to 66 (53 U.S.) over the same period in 2013.\",\n        \"Recognizing the threat that the ALP posed, the insurgents focused their attacks on Afghanistan’s auxiliary forces, which suffered disproportionate casualties in the 2013 fighting season and continued to receive the brunt of attacks through 2014. In spite of the Ministry of Interior’s difficulties sustaining the ALP, its formations prevailed against the insurgency even in the face of high casualties, and even had spikes in recruitment following those attacks. Even as the ALP faced increased attacks, it remained an integral element of the layered security concept, which envisaged relationships among ANSF that enabled the whole to be greater than the sum of its parts.\",\n        \"Given that most ANSF senior leaders had once fought as tribal or militia chieftains, the need for unity of command was pronounced. ISAF’s advocacy of a layered security construct was a critical factor in improving the coordination at the ministerial level and among the ANA, ANP, and Afghan Border Police on the ground. The layered security construct broke the competition that existed among components of the ANSF. It also promoted national unity.\"\n      ]\n    },\n    {\n      \"title\": \"Balancing Priorities: Security Force Assistance versus Retrograde\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Whereas most American troops who had deployed to Afghanistan in 2012 understood that they had to ready Afghan security forces for independent operations while preparing to downsize ISAF presence, incoming personnel in 2013 faced an even more complex situation. The CENTCOM Materiel Recovery Element reduced the burden of base closing, but incoming units still had to assist their Afghan army or police counterparts to secure the Afghan population. The units also still had to defend against Taliban and Haqqani attempts to disrupt their operations.\",\n        \"The fact that fewer Americans could provide security assistance to the ANSF meant that incoming U.S. units often found themselves nested within progressively larger Afghan formations. When the 140 soldiers of Capt. Benjamin E. Scott’s Company A, 1st Battalion, 506th Infantry Regiment, 101st Airborne Division, arrived at Assistance Platform CHAMKANI in April–May 2013, they occupied a small portion of a sprawling Afghan installation. CHAMKANI also housed the 7/1 ANA Kandak, the 2/2 Afghan Border Patrol Battalion, a National Directorate of Security office, district-level Afghan Uniformed Police, and Afghan Local Police. In addition, an explosive ordinance detachment team, several Air Force joint terminal attack controllers, a female engagement team, the battalion surgeon, and two howitzers from 4th Battalion, 320th Field Artillery Regiment, were located with Captain Scott’s company. On any given day, the troops under Scott’s command performed force protection duties, mentored ANA soldiers, conducted partnered operations with the Afghan Uniformed Police, fired counterbattery missions against insurgent rocket and mortar teams, worked with the Afghan chain of command to coordinate local operations, inventoried equipment for transfer, or interacted with their own battalion headquarters.\",\n        \"The priority task for the first several months of Company A’s deployment was to train the ANSF by conducting partnered planning and operations. Each of Scott’s platoons was partnered with an Afghan company, though the requirements of other missions prevented them from working with their counterparts daily. Tactical instruction focused on improving individual skills, with emphasis on map reading and marksmanship, while also teaching collective skills such as squad or platoon battle drill and employing the crew-served weapons organic to an infantry company. During partnered operations, the Americans taught planning procedures, orders briefs, and mission rehearsals in lieu of maneuver-oriented skills. The training and partnered operations were aimed at preparing 7/1 Kandak for a multiweek, ANA corps-level mission in RC East. The 203d Corps conducted the mission, designated Operation SEMOURGH, in Logar Province during early August. After three weeks of fighting, Afghan forces succeeded in bringing in humanitarian aid to Azrah and Jaji Districts, securing the Azrah district center, and delivering registration materials for the 2014 national elections.\",\n        \"Captain Scott’s company discovered that mentoring the ANA was simple compared to ridding CHAMKANI of equipment that had accumulated on the post after five years of American troop rotations. This equipment could not be turned over to the Afghans because it exceeded the items authorized for 7/1 Kandak. Because Assistance Platform CHAMKANI was being transferred to the Afghans rather than reoccupied by another U.S. unit, Company A had to turn in 1,000 theater-specific pieces of equipment valued at $30 million. Scott had to modify his own supply procedures to reduce consumables before his unit departed. In addition to his own resources, Scott could count on assistance from the 101st Airborne’s 4th Brigade Combat Team’s support battalion. The logistical specialists from this unit planned to transfer equipment to Forward Operating Base GARDEZ using M1120 Heavy Expanded Mobility Tactical Truck Load Handling Systems, each carrying a shipping container with a second container towed behind the vehicle. Items slated to be retrograded filled seventy containers and required five M1120 trucks towing trailers making seven trips between GARDEZ and CHAMKANI and airlifts to move sensitive equipment. All equipment was sequenced for movement to ensure that mission-essential items would leave on the last convoy.\",\n        \"Backhauling equipment to GARDEZ began with equipment boxes lifted out by six CH–47 Chinooks. Loading and flying took place at night to minimize opportunities for the Haqqani to engage the helicopters. The final airlift, which included a pair of howitzers and two containers of ammunition, was deferred until the day the Americans permanently left the base. A base-closure assistance team provided expertise on force protection, preventative medicine, ordnance disposal, and commodity reduction. The property transfer culminated with Scott signing over $400,000 worth of equipment to 7/1 Kandak.\",\n        \"The final and most dangerous phase took place when oversized items were trucked from CHAMKANI to GARDEZ. The convoy consisted of sixteen cargo trucks, including ten Afghan-operated commercial tractor trailers, escorted by forty-four other vehicles. As the Americans disassembled the tethered surveillance aerostat and tower-mounted cameras, they positioned a thermal sight-equipped outpost overlooking their base while reconfiguring internal barriers to create a 360-degree defensive perimeter. After waiting three days for the weather to allow close air support and predator unmanned aerial vehicles to maintain station over the route, the ground convoy departed from CHAMKANI during the early morning hours of 4 October 2013. Despite constant overhead aerial support and 155-mm. artillery fire missions against suspected ambush positions, a Haqqani recoilless rifle team scored a direct hit on an engineer MRAP, wounding four Americans. The injured soldiers were evacuated by helicopter, and the convoy exited the ambush without further incident, arriving at its destination before dark.\",\n        \"Just before midnight on 5 October, Chinook helicopters airlifted the two howitzers, two mortars, and all four gun crews from CHAMKANI. Within three weeks, Scott’s company began working with the rest of 1st Battalion, 506th Infantry Regiment, to close the massive forward operating base at GARDEZ. Continuing with the orchestrated retrograde plan, elements of the 101st Airborne Division departed GARDEZ on 24 November 2013, transferring to Forward Operating Base SHANK in Logar Province for a short stay before returning to Fort Campbell in early December.\",\n        \"Although ISAF remained focused on advising in 2013, the fact that it was shrinking in size complicated its task. The advisory teams assigned to ANA kandaks, now designated as Security Force Advise and Assist Teams, averaged just nine personnel, all of whom instructed the Afghan kandak headquarters rather than accompanying infantry companies outside the base. In addition, more units and fewer advisers meant that junior U.S. and coalition officers were routinely assigned to mentor Afghans older and more senior to them.\",\n        \"One member of a newly deployed advise-and-assist team working with 1/1 Kandak in Paktiya Province during this period observed:\",\n        {\n          \"list\": [\n            \"Our initial attempts at training the Afghans were largely unsuccessful. . . . First, our mission was to train ANA officers and NCOs, but we had no authority over them. Second, our ability to incentivize constructive change with support or equipment began to disappear as the United States began drawing down its forces and limiting how much its ground forces could get involved in operations the ANA interpreted this as a lack of effort and competence on our part.\"\n          ]\n        },\n        \"The teaching methods adopted by advisory personnel, who often lacked specific guidance and tailored programs of instruction, were counterproductive during this period. Far too many teams wasted time attempting to impart U.S. doctrine to unreceptive Afghan counterparts before switching to other methods. As a result, many advisory teams achieved only incremental success, such as convincing a kandak mortar platoon to make firing calculations using a portable laptop or showing an Afghan kandak how to deploy its companies in an effective cordon.\"\n      ]\n    },\n    {\n      \"title\": \"Operation DRUMBEAT: Cutting the Force in Half by 2014\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Although the Unified Implementation Plan was an IJC document, it served as the basis for Operation DRUMBEAT, the plan guiding the retrograde through the end of the ISAF and ENDURING FREEDOM campaigns. Operation DRUMBEAT was the product of the USFOR-A Joint Operational Corps Headquarters, an entity created on 6 June 2012 to streamline command and control arrangements in Afghanistan. The Joint Operational Corps Headquarters allowed select American members of the IJC staff to contribute to U.S. national planning. That arrangement acknowledged the joint command’s separation from ISAF proper while leveraging the intellectual capacity of the V Corps. The ability to work both sides of the ISAF and ENDURING FREEDOM missions paid dividends with Operation DRUMBEAT, which supported the force posture line of operation in the Unified Implementation Plan.\",\n        \"The creation of the Joint Operational Corps Headquarters coincided with the return to a single command and control arrangement for all U.S. logistical forces in Afghanistan. At the creation of USFOR-A, the Army expeditionary sustainment command and its subordinate sustainment brigades had been controlled by U.S. Army Central Command in its role as the Army service component for CENTCOM. That first experiment in a single logistics command and control had ended on 16 June 2010 when all Army forces were transferred to USFOR-A control.\",\n        \"The return to a single logistics command and control arrangement was a by-product of creating the CENTCOM Materiel Recovery Element and the subsequent division of labor necessary to execute the surge recovery. The centralized control necessary to execute logistics across Afghanistan left no latitude for competing priorities of logistical support. Between a tactical commander’s priorities and the retrograde effort, the latter necessarily took precedence. Instead of exercising command of the U.S. logistics organizations in Afghanistan, USFOR-A became a supported unit for U.S. Army Central Command and its efforts to retrograde rolling and nonrolling stock.\",\n        \"The U.S. units and service members executing the Operation DRUMBEAT directive published on 16 June 2013 faced the challenge of maintaining ISAF’s momentum while achieving the force posture milestones directed by national policy. Although the United States did not command other national elements, it provided about 65 percent of the personnel and 85 percent of the materiel to the coalition in Afghanistan, and so other countries naturally would follow the U.S. lead. Before the start of Operation DRUMBEAT, personnel levels had fallen from 91,000 to 68,000 through relatively natural attrition. Rather than curtail units already in theater and send them home early, the DoD chose not to replace units that redeployed at the end of their tours, and repositioned units already in theater to cover any vacancies. The plan to further reduce U.S. forces to 34,000, however, had to balance several considerations. American and coalition forces had to retain enough capacity to ensure that the ANSF remained tactically successful while continuing to wean the ANSF off coalition support.\",\n        \"The consequences of departing theater early varied greatly between the U.S. Army’s active and reserve components. Deployed Army Reserve and National Guard units were mobilized with the expectation of being away from their civilian jobs for a set period of time. Curtailing expected combat tours or, worse, “off-ramping” mobilized units within 180 days of their originally scheduled deployments—both of which were common at the beginning of the surge recovery—created major administrative difficulties for the soldiers involved. In an effort to mitigate the disruptive consequences of these practices and to ease reintegration into civilian life, the Army published an execution order detailing the administrative requirements for units that were curtailed or off-ramped.\",\n        \"The challenge of reducing U.S. troops to 34,000 was known long before the release of the Operation DRUMBEAT directive. Withdrawing forces required accelerating retrograde, disposal, and base closure efforts while improving “asset visibility,” which is the process of identifying documented and undocumented military equipment in Afghanistan. Maj. Gen. William E. Rapp’s target goal of 1,250 pieces of rolling stock and 1,000 containers per month was still the prevailing guidance. With DRUMBEAT, the retrograde and redeployment pace accelerated in what was called the “R2 Surge” that started in September 2013 and lasted through January 2014. Exceeding monthly targets during those five months cleared much of the theater before the start of the 2014 fighting season and the transition of security force assistance.\",\n        \"By the end of 2013, the R2 Surge actually had increased retrograde capacity beyond the specified targets to 2,975 pieces of rolling stock and 3,300 containers a month. The increased capacity was due solely to multimodal transport. Some equipment did exit theater along the Pakistan ground lines of communications, but the route remained unpredictable. Throughput along the lines stalled when a protest against U.S. drone strikes in the Khyber Pakhtunkhwa Province of Pakistan closed northern routes. The protesters, led by politician and former cricket player Imran Khan and his Pakistan Tehreek-e-Insaf party, blocked the roads with the support of the Khyber Pakhtunkhwa provincial government. More than 10,000 protesters stopped vehicles carrying cargo for ISAF to protest the 1 November 2013 death of Hakimullah Mehsud, the self-proclaimed emir of the Pakistani Taliban who reportedly had been killed by a missile launched from a remotely piloted aircraft.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_12-3.png\",\n        \"caption\": \"MRAPs and other vehicles at Bagram’s Camp Warrior retrosort yard\"\n      }\n    },\n    \"The blockade of the Khyber Pakhtunkhwa route backlogged vehicles and containers at holding yards in eastern Afghanistan. Logisticians at CENTCOM and U.S. Transportation Command responded by developing enhanced options in December 2013 to clear the backlog, which included increasing multimodal lift and shifting cargos to the southern Pakistan route through the Spin Boldak border-crossing point. The latter option required moving cargo from the northern route along Afghanistan National Highway 1 to Kandahar. Such a route was hardly tortuous, but nonetheless it was not a straightforward replacement for the blockaded route. The enhanced options were extraordinarily successful, retrograding 3,000 vehicles in only two months. By February 2014, the cargo backlog along the routes had been cleared in its entirety while backlogged containers at holding yards in eastern Afghanistan were repositioned at Bagram for multimodal movement.\",\n    {\n      \"title\": \"The Retrograde Gains Momentum\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"As part of the enhanced options, the deputy commanding general of the 1st Support Command (Forward), Brig. Gen. Duane A. Gamble, had established a “channel flight” or regular air rotation between Kuwait and Afghanistan. Channel flights allowed certain retrograde functions such as sorting cargo and customs clearance to be done in Kuwait. Assets in Kuwait included the 595th Transportation Brigade, a subordinate unit of the U.S. Army Surface Deployment and Distribution Command, and the 402d Army Field Support Brigade, a forward-deployed U.S. Army Sustainment Command unit.\",\n        \"To reduce the property that had to be shipped or destroyed, the Defense Logistics Agency conducted a “white goods” sale on 28 June 2014 at Bagram Air Base. Unlike excess defense articles, white goods were foreign excess personal property such as usable nonmilitary vehicles, appliances, and furniture. In addition to reducing the retrograde load, the sale stimulated the Afghan economy. Because it recouped value that otherwise would have been lost in scrapping or disposal, the sale generated goodwill with the Afghan government and local businesses and demonstrated good stewardship of taxpayer dollars.\",\n        \"In March 2014, USFOR-A determined that leaving behind only the materiel required for the Resolute Support mission meant that it had to reduce on-hand quantities to about 11,000 pieces of rolling stock and containers by 1 August 2014. The reopening of the Pakistan ground lines of communications, as well as the continued channel flights, enabled USFOR-A to meet this goal by 29 July 2014 and reduce further to 10,350 vehicles by 9 August 2014. The command had to plan carefully so retrograde velocity would not adversely affect operational capacity.\",\n        \"From the start of Operation DRUMBEAT on 1 June 2013 to the end of Phase II on 1 February 2014, logisticians throughout the Afghan theater had met all their goals. They did this in spite of difficulties with the northern route through Pakistan, which did not reopen fully until 27 February 2014, after the Peshawar High Court ruled that the protests by Imran Khan’s Pakistan Tehreek-e-Insaf party were illegal. Of the 158 bases open in June 2013, USFOR-A and ISAF had closed 70, removing all buildings, eliminating all explosive material, and remediating all environmental hazards. The force was also able to redeploy, retrograde, or divest 11,600 pieces of rolling stock, about 55 percent of the original number. More impressively, it had moved more than 1,000,000 pieces, or 2,900 containers, of nonrolling stock, leaving 674,000 pieces, or 1,900 containers. The number of cargo containers in the Afghan theater was reduced by almost 60 percent. The collective efforts of the USFOR-A team and supporting agencies enabled ISAF and ENDURING FREEDOM to meet or exceed all of their redeployment, retrograde, divestiture, and base closure goals. Now the coalition was well-postured to begin the most sweeping change it had yet undertaken in its operational approach.\"\n      ]\n    },\n    {\n      \"title\": \"Functionally Based Security Force Assistance\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Despite its importance to the termination of Operation ENDURING FREEDOM and the ISAF mission, the change from counterinsurgency to stability operations was not recognized immediately in the force. The change in mission marked the first time that ISAF had taken as its primary role security force assistance rather than combat operations. To make this transition work smoothly, ISAF needed to fully restructure not only its force but also its organizational culture.\",\n        \"The vehicle for that change was an evolving process, eventually called functionally based security force assistance, spanning from mid-2011 to late 2014 to reach its final form. Because NATO had no approved plan for advancing the advising mission, General Allen’s 2011 security force assistance concept had served as a stopgap. In the absence of established procedures, ISAF forces needed guidance on how coalition forces would transition from combat to advising.\",\n        \"${Reorganizing the Headquarters for Security Force Assistance}{bold}\",\n        \"With the change in focus from counterinsurgency operations to security force assistance, ISAF headquarters became responsible for many of the functions held by the NATO Training Mission–Afghanistan. The two outgoing change of command ceremonies held on 4 September 2013 for Lt. Gen. Kenneth E. Tovo, commander of both the NATO Training Mission and CSTC-A, were the first visible movements toward that end. When Maj. Gen. Kevin R. Wendel assumed command of CSTC-A from Tovo, it marked the organization’s separation from the NATO Training Mission and ended its responsibility for combat-advising the ANSF conventional forces. At the same time, USFOR-A retained command over Wendel’s formation, because the latter disbursed U.S. security assistance funding to the Afghans.\",\n        \"Wendel also assumed the duties of the newly designated ISAF deputy commander of the Ministerial Advisory Group. This role had two sets of oversight responsibilities. First, Wendel worked with the advisers to the defense and interior ministries and maintained liaisons with the nonsecurity ministries, including the Ministries of Finance, Education, Justice, Public Health, Commerce and Industry, and Communication and Information Technology. Second, he provided advisory oversight of functional enterprises, including human resource management, sustainment, strategic plans and policy, and most notably, inspector general transparency, accountability, and oversight. In addition to these tasks, Wendel was responsible for integrating, coordinating, and synchronizing the critical security force assistance tasks for ISAF.\",\n        \"The full scope of oversight duties for CSTC-A, particularly for fiscal support to the ANSF, required significant expertise in acquisitions and fiscal matters. A deputy command position was established to oversee this critical function. The first deputy commanding general of CSTC-A to serve in that capacity after the training headquarters split was Maj. Gen. Harold R. Greene, a career Acquisitions Corps officer. While Wendel and his staff were looking outward to manage outreach to the ANSF, Greene was looking inward to ensure that the United States and other donor nations provided the ANSF with proper resources through the Afghan Security Forces Fund, security assistance and foreign military sales, contracts, and infrastructure support. The second change of command passed the NATO Training Mission and its oversight for combat advising of the conventional ANSF to Maj. Gen. Dean J. Milner, a Canadian officer who had served as deputy commanding general of the III Corps under Lt. Gen. Mark A. Milley. Under this new arrangement, NATO Training Mission–Afghanistan was subordinated to IJC—a fortuitous development—as the III Corps was the unit providing the nucleus for both headquarters. Milner would once again work for Milley, whose III Corps had succeeded Terry and his V Corps. Under IJC, Milner and his NATO Training Mission were responsible for training, advising, and assisting the ANSF to develop their training, logistics, and medical institutions to support the creation of a sustainable and increasingly professional ANA and ANP capable of protecting the population and denying safe haven to the enemies of Afghanistan. Rather than the previous focus on advising at the brigade and below level, the training mission supported ANSF institutional training centers for their branches of service, as well as in sustainment, police, and combat health support.\",\n        \"In his visualization of the remaining ISAF campaign, Dunford described a “single battle” of security force assistance from the ministerial level down to the kandak level. The notion of single battle came from Marine Corps doctrine, in which a commander would plan centrally and then execute the plan in a decentralized fashion while viewing the area of operations as one indivisible entity. The single-battle concept was intended for a Marine Air-Ground Task Force, but it aptly described Dunford’s vision for the ISAF campaign, in which previously disparate efforts would have to be tied into preparing Afghan ministries and ANSF for RESOLUTE SUPPORT.\",\n        \"To help unity of effort and provide technical assistance to those implementing General Dunford’s guidance, a security force assistance fusion cell began operations under Wendel’s oversight on 27 January 2014. This cell was an instrument for transforming ISAF from a headquarters overseeing counterinsurgency operations to one overseeing stability operations. It served as the secretariat for all of the functionally based security force assistance staff functions and was the focal point for coordination among all related activities.\",\n        \"Instead of relying on the previous pillars of security force assistance outlined in the campaign plan, General Dunford directed Wendel to develop a new organizational design for supporting the Afghan security ministries and increasing ANSF self-sustainability. From 21 to 26 March 2014, the security force assistance fusion cell developed a definition of self-sustainability and, more importantly, eight essential functions that shifted focus to the ministerial level. The release of these eight functions on 26 March 2014 occurred with only 280 days left in the ISAF campaign. Dunford, recognizing that a revision of COMISAF (Commander ISAF) Operational Plan 38302 would require approval by the North Atlantic Council, published the changes in guidance to the force through fragmentary orders. Changing the battle rhythm was a deliberate attempt to change the culture of the organization. It was also a consequence of the inexorable flow of equipment and personnel out of Afghanistan in 2014 and the considerable reorganization of the force itself in its last year.\",\n        \"${Reorganizing the Force for the New Mission}{bold}\",\n        \"The first major reorganization of ISAF toward the RESOLUTE SUPPORT mission, which resulted in the split of NATO Training Mission–Afghanistan and CSTC-A, also included a realignment of the command. The rationale for this realignment was to better posture systems and processes for the advisory missions in accordance with the eight essential functions of functionally based security force assistance. The distribution of missions previously held under the training commands resulted in a completely reorganized ISAF headquarters. The magnitude of the changes that occurred in the ISAF staff and subordinate commands starting on 1 July 2014 was a testament to establishing ISAF as a command that focused primarily on security force assistance.\",\n        \"On 1 July 2014, NATO Training Mission–Afghanistan cased its colors for the last time and was deactivated, with its personnel and functions becoming the CJ–7 (Training and Exercises) staff section within ISAF headquarters. Simultaneously, the title of deputy commander of the Ministerial Advisory Group ceased to exist, leaving Wendel solely with his duties as the commander of CSTC-A. This reorganization codified a number of changes that had been proposed in late 2013 to set the command for the RESOLUTE SUPPORT mission. First was the change of the security force assistance fusion cell into a more expansive Security Force Assistance Center working directly under ISAF. The ministerial advisers who had been part of General Wendel’s groups moved into the ISAF headquarters and picked up advisory roles to the ANSF. Rather than having dedicated advisers, the intent was for the principal staff and their subordinates to double as the ISAF battle staff and as advisers to their Afghan counterparts in the Ministry of Interior, the Ministry of Defense, and the ANA General Staff.\",\n        \"External to the ISAF headquarters, Special Operations institutional training was overseen by the NATO Special Operations Component Command–Afghanistan, commanded by Maj. Gen. Edward M. Reeder Jr., who had five previous Operation ENDURING FREEDOM rotations at multiple levels of command. Air institutional training was overseen by NATO Air Command–Afghanistan, under the command of U.S. Air Force Maj. Gen. Kenneth S. Wilsbach, who also commanded the 9th Air and Space Expeditionary Task Force–Afghanistan.\",\n        \"From 2003 to 2014, ISAF had divided its area of operations into regional commands, which were usually divisional headquarters led by a one- or two-star general officer. Up to 2013, the mission of regional commands had been to control operations at the tactical level, although this singular focus was modified when the United States started deploying security force assistance brigades instead of combat brigades as part of the surge recovery. These headquarters controlled combat forces and also oversaw NATO Operational Mentoring and Liaison Teams in their areas of operation after TF PHOENIX disestablished in 2011. They later added embedded training teams and police mentoring teams.\",\n        \"The regional command structure worked well for overseeing combat operations, but fundamental changes were needed once modular brigades augmented for security force assistance began arriving in theater. By the end of the surge in August 2011, the prevailing philosophy in the campaign— encapsulated in the informal motto “shona ba shona” (shoulder to shoulder)—was that coalition forces were to be partnered fully with their ANSF counterparts. The change to security force assistance in Revision 6 to Operational Plan 38302 shifted the underlying philosophy again to Afghans taking the lead with coalition forces in a supporting role.\"\n      ]\n    }\n  ],\n  \"chapter 13\": [\n    {\n      \"title\": \"ENDURING FREEDOM Becomes Resolute Support\"\n    },\n    {\n      \"section\": [\n        \"The final three years of the ISAF and Operation ENDURING FREEDOM campaigns presented one of the most difficult challenges faced by the coalition and its leaders during the entire conflict. Changing the mission from counterinsurgency operations to security force assistance while simultaneously withdrawing the force was difficult enough. The chaotic policy environment that characterized the last two years of the conflict made closing out the campaign even harder.\"\n      ]\n    },\n    {\n      \"title\": \"A Campaign in Transition\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"One factor that hindered ISAF in transitioning to Resolute Support was the ambiguity of national policy in terms of ends, ways, and means. Delays in signing the Bilateral Security Agreement and the NATO Status of Forces Agreement, combined with the lack of a substantive policy decision, resulted in incomplete campaign guidance and orders. Operational Plan 38312 for RESOLUTE SUPPORT and Operational Plan 1710–14 for Operation FREEDOM’S SENTINEL could not be updated and published with a clearly articulated end state to operations in Afghanistan. Uncertainty over what forces would be available beyond 2014, a direct outcome of the U.S. policy debate, contributed to that ambiguity. Absent clarity, any campaign planning for the post-2014 mission was at best an estimate.\",\n        \"Although President Barack H. Obama had announced that 9,800 U.S. personnel would remain in Afghanistan following the end of Operation ENDURING FREEDOM, some senior officials within the administration continued to press for a much smaller residual force. They proposed that the total of 9,800 personnel could be a starting point, with the desired final number of residual forces being 1,000 officers and enlisted personnel operating from a single base near Kabul. General Joseph F. Dunford Jr.’s replacement, General John F. Campbell, would spend months championing the need to stick to the original target for residual forces and convinced the White House and key members of Congress not to reduce the 9,800 figure before his departure from command. The decision to maintain agreed-upon post–ENDURING FREEDOM troop levels did not come easily given Obama’s pledge to withdraw all U.S. forces by the end of his second term.\",\n        \"Even if there had been complete certainty on the campaign objectives and force structure beyond 2014, getting the right people for the job still remained a challenge. It had not been difficult to choose and train advisers for duty with ANA tactical units from among the large number of eligible individuals, but the same could not be said for advisers responsible for aiding Afghan defense ministry officials. The number of qualified individuals was much smaller because the U.S. Army itself had fewer positions calling for specialized knowledge in strategic planning, large-scale logistics, programming, and budgeting compared to the number of soldiers familiar with leading companies, battalions, and brigades. The former set of responsibilities normally was assigned to selected officers and civilians midway or later in their careers, while all officers had to pass through the crucible of command before advancing to senior ranks. In addition, a number of installations and units were able to provide multiweek advisory-related courses for officers and enlisted soldiers, whereas it required a year or more of specialized education at dedicated learning institutions to provide similar levels of training to ministerial-level advisers. The Army’s ability to generate ministerial-level advisers thus had to contend with limited numbers of qualified individuals within its ranks as well as an equally constrained ability to generate more of them. The confluence of all of these factors meant that more work would be needed to translate unclear policy through military strategy and meaningful operations. Without a coherent strategy, the spirit, blood, and treasure spent in Afghanistan would be for naught. In spite of the extensive efforts to adapt operations and logistics in Afghanistan to the challenges of the ENDURING FREEDOM and ISAF campaigns, the future of Afghanistan, even with forces set for Operations FREEDOM’S SENTINEL and RESOLUTE SUPPORT, remained uncertain.\"\n      ]\n    },\n    {\n      \"title\": \"Competing Demands in the 2014 Fighting Season\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Although the Taliban had halted most of its large-scale efforts to oppose ISAF on the battlefield after the American-led surge, it had not been defeated. Opposition groups had sufficient resources and motivation to continue military operations against ISAF and the government of Afghanistan. Foremost among these groups was the Haqqani Network, whose operators and facilitators had survived the surge by focusing their energies on discrete suicide operations with high payoff and minor cost in lives and property.\",\n        \"The Taliban, meanwhile, was embroiled in an internal power struggle that unfolded largely out of public view. An earlier conflict had developed between Mullah Abdul Qayyum Zakir and Mullah Akhtar Mohammed Mansour to replace Mullah Mohammed Omar’s top deputy, Mullah Abdul Ghani Baradar. The new struggle began when Omar mysteriously died in the summer of 2013. After a two-year power struggle, Akhtar Mansour emerged as the Taliban’s de facto leader. In the process, he recommended ties with the Haqqani Network, choosing two deputies from the Haqqani leadership. This decision was important as the Haqqanis had become somewhat disconnected from the Taliban fight in the south. Bringing Haqqani members and influence into the Taliban’s core leadership channeled the network’s military actions in ways that supported the Taliban’s goals to discredit and undermine the Kabul regime while striking at significant American targets.\",\n        \"Turmoil within the Taliban was not readily apparent in its announcement that the 2014 spring offensive KHAYBAR (named after the Battle of Khaybar, in which Muslim forces led by the Prophet Muhammad overcame a Jewish stronghold in CE 629) would begin on 12 May. ISAF personnel and facilities topped the list of Taliban goals for 2014, which included eliminating “foreign invaders and their backers under various names like spies, military and civilian contractors and everyone working for them like translators, administrators and logistics personnel.” In addition, the Taliban targeted members of the Afghan government such as cabinet ministers, members of Parliament, Interior and Foreign Ministry officials, agents in the National Directorate of Security, and attorneys and judges involved in criminal trials for captured Taliban.\",\n        \"The Taliban claimed it was prepared to utilize “various modern military technique[s],” such as “martyrdom strikes” (suicide attacks and bombings), “infiltrator operations” (insider or green-on-blue attacks), and “head-on offensive operations against enemy gatherings” (attacks on ISAF installations). The Taliban released a list of potential targets for 2014 that included foreign and Afghan bases, “diplomatic centers,” military and civilian convoys, and other “facilities of foreign, interior, intelligence and Arbakai [local] militia.” The reference to the last organization attested to the success of Village Stability Operations. Although the Taliban did not threaten to disrupt the June runoff election—suggesting that such an undertaking would have exceeded its current capabilities—the 2014 announcement made it clear that the Taliban would actively exploit any emerging vulnerability as the ISAF drawdown continued.\",\n        \"The Afghan presidential and provincial council elections would be the biggest tests for the ANSF in 2014. The ANSF had successfully provided security to campaign rallies, but both they and the coalition anticipated high-profile attacks in an attempt to undermine the elections. On 20 March 2014, two weeks before election day, the Taliban attacked the Serena Hotel in Kabul, a popular spot for foreign visitors, killing nine civilians, four of whom were foreigners. That attack came a day after the Taliban conducted a complex attack on a police station in downtown Jalalabad, near the Nangarhar governor’s residence, and two days after a suicide bomber killed sixteen people in a market in Faryab Province. In spite of these events, the Afghans continued to carry on their daily business, an optimistic trend for the election.\",\n        \"The 2014 fighting season was the first in which the ANSF took the lead for security operations. Leaders at ISAF and its subordinate headquarters, anticipating increased election security requirements and reduced coalition visibility during the election period, slowed the pace of retrograde accordingly. The intent was that the capabilities required to support the ANSF would be available through the end of the 2014 fighting season, then retrograded after the election was complete. The Taliban tested the ANSF by launching massed assaults against isolated checkpoints and outlying government centers. Although the attacks often succeeded, the insurgents invariably failed to hold onto their gains. Overall, the ANSF continued to demonstrate tactical superiority over insurgents with some assistance from United States and coalition partners throughout the presidential elections and the fighting season.\",\n        \"When the Afghan people went to the polls on 5 April 2014, less ISAF support was required than expected, even in light of numerous security incidents throughout the day. ANSF operations to disrupt the Taliban prior to the election, along with a comprehensive security plan for the election itself, ensured that no major attacks succeeded and that the 2014 elections saw less violence overall than in the 2009 presidential and the 2010 provincial elections. Even with the high voter turnout, neither Ashraf Ghani nor Abdullah Abdullah, the two leading presidential candidates, was able to secure a decisive victory with more than 50 percent of the vote.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-13-1.svg\",\n        \"caption\": \"Force Laydown January 2014\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"The ANSF protected the candidates and voters leading up to and during the April election, and did so again less than two months later when Ghani and Abdullah competed in a runoff election. More than seven million voters participated in this second round. After credible reports of significant irregularities voided the 14 June runoff, the Afghan Independent Election Commission declared Ghani as Hamid Karzai’s official successor on 21 September. That same day, Ghani announced that he would form a national unity government, with Abdullah holding the newly created post of chief executive. Though initial reports suggested that insurgents had attempted approximately 300 attacks during the June election, along with 351 incidents during the April election, the Taliban was unable to disrupt either event. Throughout the process, U.S. forces limited their involvement to transporting ballots to an audit location where ANSF provided security for the actual counting.\",\n    \"Although the ANSF had succeeded in protecting the runoff election, the fighting continued throughout the year. On 21 June 2014, the Taliban caught the ANSF off guard with an offensive in the Sangin and Now Zad Districts of Helmand Province. Despite the surprise attack, the ANA and Afghan Uniformed Police in those districts were able to regain lost territory before the end of July, preventing the Taliban from holding key terrain. Support from RC South was limited to intelligence, armed helicopter escort for medical evacuation flights, close air support, and advisory support. The ANSF conducted virtually all of the ground combat operations.\",\n    \"By the end of summer 2014, the ANSF were on track to assume responsibility for all conventional and Special Operations missions, many of which were already being conducted solely by Afghans. The successes experienced by the ANSF came at the expense of the retrograde velocity that had accelerated over the winter and decelerated for the fighting season. With only a few months left in ENDURING FREEDOM, USFOR-A focused on clearing the theater in time for the transition to RESOLUTE SUPPORT.\",\n    \"The retrograding success that the United States and its coalition partners had achieved through the 2014 fighting season meant that Operation DRUMBEAT was already about 80 percent complete by the beginning of the fourth and final phase of the plan. Coming out of the surge recovery in January 2012, USFOR-A was responsible for 396 bases, 48,677 pieces of rolling stock, 26,816 containers of equipment, and 78,000 contractors. From the start of DRUMBEAT on 1 June 2013 to its conclusion at the end of 2014, USFOR-A and its coalition partners had closed or transferred 189 bases. They transferred, shipped home, or destroyed 24,450 pieces of rolling stock, 1,794,450 pieces of nonrolling stock (5,300 containers), and 80,900 cargo containers. During the same period, the command reduced the number of civilian contractors in Afghanistan by 45,900 personnel. Commanders and staff balanced downsizing force activities with retaining the capabilities needed to continue advising the ANSF. In most cases, the requirements had reduced to the degree that remaining forces would be able to perform those duties. In some cases, requirements no longer existed and the organizations to which they were assigned were repurposed or withdrawn altogether.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_13-1.png\",\n        \"caption\": \"ANA Commando directs ANA Soldiers\"\n      }\n    },\n    {\n      \"title\": \"From Regional Commands to Train, Advise, and Assist Commands\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"By 30 September 2012, coalition troop levels had reduced from their surge strength of 134,000 to approximately 107,000. A year later, the total ISAF number had shrunk to approximately 65,000, with the U.S. presence in Afghanistan down from 68,000 to just over 39,000 personnel. By October 2014, short of ISAF’s full reorganization, ISAF end strength was just over 34,000 personnel, with American forces constituting approximately 24,000 of that number.\",\n        \"In order to decrease the number of American personnel serving in Afghanistan, tactical units were redeployed to the United States without replacement. With the expanded ANSF assuming greater responsibility for operation planning and execution, U.S. soldiers and marines were no longer needed in the same numbers as before. Although the Bilateral Security Agreement did not stipulate a particular echelon for advisory efforts, the Resolute Support mission eliminated all tactical-level advising except that conducted by special operators working alongside the Afghan Commandos. As a result, advisers from conventional units were withdrawn from every echelon of command below ANA corps.\",\n        \"Coincident with the reduction in force, ISAF began to replace regional commands with train, advise, and assist commands, which ended the military’s practice of appointing battlespace owners. These train, advise, and assist headquarters, which were smaller than the regional commands they replaced, would be the focal point for developing and improving the ANA corps and ANP regional and provincial headquarters in their areas of operations. Their role hearkened to CTSC-A’s previous Afghan Regional Security Integration Commands, which had been located at the same bases as ANA corps headquarters before NATO had established its training missions.\",\n        \"Train, advise, and assist commands had fewer capabilities than their predecessors. In the conversion, regional commands transferred former functions such as medical evacuation and the collection and processing of battlefield intelligence to IJC, which retained tactical responsibilities. Two aspects of these transfers forced the ANSF to become more self-sufficient. First, authority for the release of coalition combat enablers moved to IJC, making it more difficult to request enablers and less likely that they would be provided. Second, as forces redeployed and countries reduced their presence in theater, those combat enablers became less available to provide assistance, decreasing the probability that the ANSF would be able to call on them for help even in exigent circumstances.\",\n        \"The first regional command to transition to a train, advise, and assist command was the Turkish headquarters serving as RC Capital, which became Train, Advise, and Assist Command–Central on 10 July 2014. Next, the Italian headquarters serving as RC West in Herat became Train, Advise, and Assist Command–West on 16 July 2014. The German headquarters in Mazar-e Sharif serving as RC North became Train, Advise, and Assist Command–North on 1 August 2014. The American headquarters at RCs Southwest, South, and East were the last to transition. Each had been organized around an Army division or a reduced Marine Expeditionary Force command and had overseen the efforts of large subordinate units with many troops. On 14 October 2014, RC South transferred authority to Train, Advise, and Assist Command–South in Kandahar. Maj. Gen. Paul J. LaCamera, commanding the 4th Infantry Division, handed over command to Maj. Gen. Michael A. Bills, his counterpart in the 1st Cavalry Division. Bills did not remain in Afghanistan, as command of the newly created headquarters fell to Brig. Gen. Viet Luong, deputy commanding general for maneuver, who remained with a small staff element. In the meantime, most of the 1st Cavalry Division’s staff officers remained at Fort Hood and would rotate with their counterparts in Afghanistan midway through the year.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_13-2.png\",\n        \"caption\": \"Joint Patrol\"\n      }\n    },\n    \"The withdrawal of forces from RC Southwest differed markedly from other areas, as it was the one region where responsibility for ANSF would not transfer to a train, advise, and assist command that would be physically present. On 5 February 2014, authority transferred from II Marine Expeditionary Force (Forward) to the Marine Expeditionary Brigade–Afghanistan. That transfer reduced the grade of the RC commander from major general to brigadier general.\",\n    \"Coalition forces in RC Southwest reduced measurably in early 2014 with the departure of the Tongan, Estonian, Bosnian, and Danish forces. The Georgian and Jordanian missions left a few months later, and by the end of summer 2014 the only forces left in RC Southwest were Marine Expeditionary Brigade–Afghanistan and Task Force HELMAND, formed around the Desert Rats of the British Army’s 7th Armored Brigade.\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-figure-13-4.svg\",\n        \"caption\": \"Force Laydown December 2014\",\n        \"prefix\": \"MAP\"\n      }\n    },\n    \"RC Southwest conducted its end-of-operations ceremony at Camp Leatherneck in Helmand Province on 26 October 2014, transferring the Bastion-Leatherneck-Shorabak base complex to the 215th ANA Corps on 27 October 2014. It turned over its responsibilities to the Kabul-based Train, Advise, and Assist Cell–Southwest, which had begun operations on 15 July 2014 and achieved full operational capability by the end of October. While not an ideal design, Train, Advise, and Assist Cell–Southwest was able to provide some measure of oversight for the ANSF in Helmand and Nimroz Provinces. A similar cell was formed to support the 203d ANA Corps, which had forces in Wardak, Logar, Paktiya, Khost, Paktika, and Ghazni Provinces. In the wake of Milestone 2013, some risk could be assumed, as all four brigades in 203d Corps and three of the four brigades in 215th Corps had shown promise. The American command rated them capable of planning and conducting joint and combined arms operations with minimal to no coalition assistance. The ANP in those areas received similar ratings.\",\n    \"Unlike other regional commands, RC East, now covered by the 10th Mountain Division under the command of Maj. Gen. Stephen J. Townsend, handled two ANA Corps, two Afghan Uniformed Police Type A (Regional) headquarters, and two Afghan Border Police zones. In addition to the 203d ANA Corps headquarters next to Forward Operating Base LIGHTNING at Gardez in Paktiya Province, RC East was responsible for training, advising, and assisting the 201st ANA Corps, whose headquarters was at Forward Operating Base GAMBERI in Laghman Province, a short drive from Jalalabad, the capital of Nangarhar Province. This arrangement led to the creation of two advising commands forward of Bagram, where the RC East main headquarters was located. The 201st ANA Corps was the responsibility of Train, Advise, and Assist Command–East at GAMBERI. The 203d ANA Corps was the responsibility of Train, Advise, and Assist Command–Southeast at LIGHTNING. Each command was led by a one-star general who also had advisory responsibilities to the ANP and Afghan Border Police. Each was assisted in its mission by a brigade combat team serving as a corps support platform, with tactical forces to partner with ANSF units. More importantly, these commands were able to partner with Afghan enablers such as close air support, intelligence, and logistics.\",\n    \"By 2014, the 10th Mountain Division and 3d Cavalry Regiment were sourcing Train, Advise, and Assist Command–Southwest. As the ISAF footprint continued to shrink, this headquarters ceased operations on 1 October 2014 and transferred to Forward Operating Base LIGHTNING to support the 203d ANA Corps while the 3d Cavalry Regiment moved to GAMBERI to serve as the Train, Advise, and Assist Command–East. Although no longer collocated with 203d ANA Corps, the cavalry had built relationships with their ANA counterparts that would help to bridge advising efforts until Train, Advise, and Assist Command–Southeast could be stood up in Kabul. The experience that RC East established with two advising commands was an invaluable test for how to advise at the regional level before ISAF and its subordinate units were reorganized for RESOLUTE SUPPORT.\",\n    \"On 4 November 2014, the 10th Mountain Division curtailed its deployment to RC East, conducting an early transfer of authority with the 3d Infantry Division. The early relief gave the 3d Infantry Division more time to assume its new requirements. The first requirement was to relieve the 3d Cavalry Regiment of the Train, Advise, and Assist Command–East mission at Forward Operating Base GAMBERI. The second was to provide the personnel for the U.S. national support element at Bagram Air Base, which it inherited from the XVIII Airborne Corps. Maj. Gen. John M. Murray, commanding the 3d Infantry Division, assumed the role of the commander of Joint Task Force 3 and also assumed the responsibilities of deputy commander, USFOR-A, from Lt. Gen. Joseph T. Anderson, the XVIII Airborne Corps commander and previous USFOR-A deputy commander.\",\n    \"The decision not to maintain an advisory presence in the two ANSF units covering the most contested areas of the country had a certain degree of logic to it. The 215th ANA Corps had fought a bitter effort to secure the Helmand River Valley and its surrounding districts while the 203d ANA Corps remained astride territory that the Haqqani Network considered its home terrain. The two corps had displayed their capabilities, indicating that they were better equipped (relative to the rest of the ANSF) to operate independently; therefore, it seemed feasible to withdraw the advisers. However, other practical considerations were in play. Both ANA corps were located in dangerous areas, and to maintain a continued advisory presence in those areas, coalition forces would have needed to retain their bases to provide close air support and medical evacuation. More U.S. personnel also would have had to remain behind to operate and secure those sites. Given the noncombat framing of the RESOLUTE SUPPORT mission, the NATO troop-contributing nations were particularly sensitive to casualties, and they were reluctant to leave their advisers in contested areas where they were virtually guaranteed to make contact with the enemy. As the advisers increasingly left ANA units in southern Afghanistan to their own devices, the Afghan forces suffered from mounting desertion rates resulting from poor leadership, intermittent pay, and inadequate logistics, all of which were compounded by increasing casualties.\",\n    {\n      \"title\": \"Consolidating the Task Organization\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Another consequence of reducing forces was the elimination of organizations whose roles had been greatly diminished or made redundant as the counterinsurgency mission transitioned. Much like tactical units that left Afghanistan as part of the drawdown, many of the functional headquarters consolidated roles or simply ended their missions. An example of an organization that eventually disappeared was Combined Joint Task Force PALADIN, which had grown as a response to the enemy’s use of IEDs. PALADIN began in 2005 as a counter-IED organization built around a rotational explosive ordnance disposal group headquarters. It had provided expertise and training to coalition forces throughout Afghanistan but reduced its outreach as part of the drawdown. Although CJTF PALADIN was not an ISAF unit, its mission had evolved to encompass training, advising, and assisting the ANSF. On 15 December 2013, Col. Marue R. Quick’s 52d Ordnance Group (Explosive Ordnance Disposal) began to return to Fort Campbell, Kentucky.\",\n        \"One of the outgrowths of the ISAF population-centric counterinsurgency approach was Combined Joint Interagency Task Force 435, which had been established on 24 September 2009 to manage Law of Armed Conflict detention, Afghan rule of law proceedings, biometrics, and advisory functions to Afghan Central Prisons Directorate. The 25 March 2013 transfer of the U.S. detention facility in Parwan just outside Bagram Air Base coincided with signing a memorandum of understanding on detentions that transferred responsibility for the facility and its detainees to the Afghan Ministry of Defense. Although some U.S. authorities for detentions continued through the ISAF mission, many of Combined Joint Interagency Task Force 435’s authorities would end when the Bilateral Security Agreement took effect on 1 January 2015.\",\n        \"When it was disestablished on 1 October 2014, the interagency task force had assisted the Afghans in moving from confessions to evidence-based justice, a critical element of the rule of law. With the task force’s oversight, the Rule of Law Field Force–Afghanistan worked closely with the Afghan ministries and the U.S. Embassy in Kabul to expand Afghan judiciary coverage to provinces and districts. The organization’s remaining missions transitioned to a Rule of Law Development Team to provide ministerial advising in Kabul after Combined Joint Interagency Task Force 435 and the Rule of Law headquarters were disbanded. Besides managing the critical Law of Armed Conflict detention mission, the task force significantly advanced the Afghan institutional capacity in the rule of law, prisons, and law enforcement.\",\n        \"As the force continued to contract, other functions consolidated. One example was the Joint Force Engineer Command–Afghanistan, which had been established in 2009. Its functions were divided between the USFOR-A and IJC headquarters in 2014. Other organizations ceasing operations included the anticorruption Combined Joint Interagency Task Force SHAFAFIYAT in 2010. Those missions merged with another task force on anticorruption in 2013 to create Combined Joint Interagency Task Force–Afghanistan. This short-lived task force quietly disappeared when the ISAF headquarters reorganized in the second half of 2014.\",\n        \"The largest change was the disbanding of ISAF Joint Command on 8 December 2014. The expansion of the ISAF force structure in 2009 had created the need for a tactical corps headquarters to command and control regional commands, while ISAF conducted engagements at the operational and strategic levels. As the ISAF mission evolved under functionally based security force assistance, the functions that had come to be performed by IJC reconsolidated back into the ISAF headquarters.\",\n        \"IJC had significantly more soldiers and marines in Afghanistan than the rest of ISAF by the beginning of the final transition. As part of the shift to RESOLUTE SUPPORT, IJC passed its responsibility for command and control of the ISAF area of operations to a newly reconstituted ISAF Combined Joint Operations Center starting on 1 November 2014. The Combined Joint Operations Center assumed full responsibility for monitoring current operations and exercising command and control of ISAF subordinate units on 14 November 2014.\",\n        \"The XVIII Airborne Corps was the last corps headquarters to provide the troops for both the USFOR-A and the IJC headquarters missions at the same time. On 8 December 2014, a ceremony held at Kabul’s international airport—recently renamed after former President Hamid Karzai—marked the end of mission for IJC and the end of tour for the XVIII Airborne Corps. The mission passed to the 3d Infantry Division at Bagram.\",\n        \"As ISAF shifted to a supporting position in the wake of Milestone 2013, it took on the same challenging role for the upcoming RESOLUTE SUPPORT mission that the now-defunct NATO Training Mission–Afghanistan had faced before. Reorganizing the ISAF headquarters for security force assistance as IJC stood down created three competing demands. First, the ISAF headquarters retained its theater-strategic role as the senior NATO military organization in Afghanistan. Second, ISAF was also creating a new NATO Training Mission of sorts, though its advisory efforts were almost exclusively focused at the Afghan ministerial level. Third, with the disestablishment of IJC, the ISAF headquarters had to reconstitute the capability to exercise tactical command and control that it had divested to IJC in 2009.\",\n        \"The RESOLUTE SUPPORT troop-contributing nations continued to source forces for the mission, augmenting the ISAF Combined Joint Operations Center with personnel, mostly Army officers and senior noncommissioned officers from Train, Advise, and Assist Commands South and East. Those personnel were in excess of post-2014 requirements; nonetheless, they had the skills and grades to bring the operations center to full operating capability. The joint operations center was capable of monitoring tactical dispositions throughout Afghanistan, but much like its parent command, it now had a different role. Finding the people to run the center was not as much of an issue as finding the people who could advise ministerial-level leaders on their national responsibilities.\"\n      ]\n    },\n    {\n      \"title\": \"The Right People\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Getting the right people in the right numbers and in a timely fashion was not a new problem in Afghanistan. This issue affected plans as far back as Operation ANACONDA and the original formulation of training organizations. The leading challenge that ISAF now faced in assuming the NATO Training Mission was a lack of expertise for its advisory efforts to build ministerial capabilities. Tactical advisers, which had been in demand until 2012, were relatively easy to locate and acquire, but personnel who had experience in the ministerial-level functions needed to strengthen national ministries were far less common. Individuals with these highly specialized skills were difficult to mobilize, partly because most of them were civilians. Those who could deploy could not provide sufficient coverage, especially considering the extent of the reform needed. Even the U.S. Army, which had more capacity for such functions than its sister services, could not meet the requirements.\",\n        \"In a letter to the CENTCOM Commander General Lloyd J. Austin III, General Dunford outlined the changes that ISAF needed to make to  fill its adviser requirements starting in early 2014. To build the long-term sustainability of the Afghan security ministries and ANSF, the pre-mission training would have to change:\",\n        {\n          \"list\": [\n            \"This change in focus will require that advisors sourced by CJSOR (Combined Joint Statement of Requirements) 13.5 and CE (Crisis Establishment) 21 are trained to execute the functional SFA [security force assistance] model at the Afghan ministerial level as well as at the Corps/Zone/Region level. As a result, pre-deployment training for SFA teams will need to be updated.\",\n            \"Rather than studying Afghan tactics and maneuvers, SFA teams will require instruction that is oriented towards  Afghan institutional development. . .  \",\n            \" . . . Additionally, success in Resolute Support will depend on the proper identification, screening,  and selection of personnel to fill advisor positions. I would ask your full support in conveying to the Military Services the importance of sourcing personnel with the correct grade, experience, and skill set for each job.\"\n          ]\n        },\n        \"Unfortunately, no solutions were available to provide an adviser force at the institutional level. The uniformed services simply did not have the personnel to fill the requirements for RESOLUTE SUPPORT. The problem was structural in nature. None of the services, the Army included, had established a way to produce officers in sufficient quantities with technical skills in high-level functions such as strategic assessment, strategic planning, or force management, let alone the DoD’s planning, programming, budgeting, and execution processes that provided context for those skills. Such skills could only be built through experience. Furthermore, every adviser deployed with those skills counted against a force cap for uniformed personnel that became immovable by 2013.\",\n        \"Even in the best circumstances, the likelihood of finding an officer who was experienced at the operational and strategic levels outside of the Army’s functional areas was low. In the case of the combat arms, the demand for tactical command and staff assignments in those branches of the Army made it even less likely to locate suitable candidates. Given the competition for battalion and brigade command, there was little opportunity for officers to gain broader experience outside of their career fields where they might gain a sense of policy and strategy. American officers simply did not have enough time in their careers for such assignments. Many coalition members who sent officers to the ISAF staff did not provide these developmental opportunities either, with the exception of a few who might have gained experience by working in their countries’ defense ministries or on their general staffs.\",\n        \"The U.S. Army’s regulatory guidance for commissioned officer professional development went into effect when ISAF recrafted its mission  to security force assistance and identified three foundations for leader development: institutional training, operational assignments, and self-development. Virtually all the key developmental duty positions critical to promotion, and the majority of the developmental and broadening assignments, were at the tactical level. Battalion and brigade command were viewed as prerequisites to be considered for general officer. Officers seeking those positions needed to take repetitive tactical-level assignments to remain competitive. Those who took multiple broadening assignments found themselves at a disadvantage, especially as promotion timelines accelerated to create the ranks necessary for the modular force. The alternative was to pull from the functional areas, but they were smaller than the basic branches. The demand for functional area officers in operations research, systems analysis, force management, information operations, and strategy development far outstripped the supply available.\",\n        \"An alternative source for those skills might have been found in the Army and other services’ civilian workforces. However, in the case of the Army Civilian Corps and other U.S. civil service personnel, no authority could direct personnel to fill critical ministerial advisory positions. It was easy to advertise such positions, but no mechanism was in place to reassign civilians involuntarily to positions in Afghanistan. Civilians who volunteered then had to meet the physical standards to deploy. This was quite often a challenge.\",\n        \"The last source of personnel was contractors, but their employment was also problematic given the changes in legal protections affected by the Bilateral Security Agreement. The jurisdictional limitations written into the Bilateral Security Agreement and the NATO Status of Forces Agreement reflected Karzai’s August 2010 Presidential Directive 62, which responded to allegations of employee misconduct by banning private security companies in Afghanistan. The bilateral and NATO agreements both specified that Afghanistan maintained the right to exercise jurisdiction over U.S. and NATO contractors and their employees, a distinct change from the permissions given under the preceding U.S. State Department Diplomatic Note 202 and the ISAF Military-Technical Agreement. As a result, it was legally risky for commanders to send contractors to work on predominantly Afghan bases located away from urban centers. In addition to potential legal complications, contractors working at isolated locations often encountered significant transportation difficulties.\",\n        \"Even though the rhetoric about the post-2014 mission consistently emphasized its status as a noncombat mission, the environment remained dangerous. The death of Maj. Gen. Harold R. Greene at the hands of a rogue Afghan soldier on 5 August 2014 served notice that the Guardian Angel program could not prevent all insider attacks. Greene, the first U.S. flag officer to die in combat since Vietnam, was killed by gunfire directed at coalition personnel from a barracks window at Camp Qargha’s Marshal Fahim National Defense University in Kabul. Greene and about ninety other U.S. and coalition personnel were visiting the base for an update on its construction projects and a preview of its officer-producing capabilities. At about 1140, the group made an unplanned stop near the military police barracks for a briefing. About fifteen minutes later, an Afghan military policeman, later identified as Rafiqullah, started shooting. The Afghan army claimed the attacker, a Pashtun serving since 2012, had exhibited no signs of anti-American or anti-ISAF sentiments, but the U.S. investigation “indicated he may have had some bias against coalition forces” with “disdain for Americans in particular.”\",\n        \"At the same time, ISAF continued to walk a fine line between encouraging the ANSF to operate independently and letting them fail. Coalition advisers had become accustomed to desperate pleas for assistance, often containing exaggerated estimates of enemy strength or friendly casualties in an attempt to trigger coalition enablers. Nevertheless, ANSF personnel grudgingly learned how to stand on their own. They had been successful throughout the 2014 fighting season, and yet their sustainability was the pivotal question as the ISAF and ENDURING FREEDOM missions came to a close.\"\n      ]\n    },\n    {\n      \"title\": \"Special Operations at the End of the Campaign\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"As the end of Operation ENDURING FREEDOM neared, U.S. SOF in Afghanistan experienced changes similar to those affecting their conventional brethren. The top priority of CJSOTF–Afghanistan during this period was to build Commando kandaks so that they could assume the missions previously accomplished by ISAF units. The most difficult goal associated with this transition was persuading U.S. Special Operations personnel to allow the Afghans to lead in planning and executing missions. To facilitate the necessary mindset, Col. Patrick B. Roberson, the 3d Special Forces Group, 1st Special Forces Regiment, commander in charge of the combined joint special operations task force from March to November 2013, limited the number of U.S. Special Operations personnel accompanying their Afghan counterparts in the field. When some Americans complained that the Afghans were not as practiced in these tasks as U.S. forces, Roberson explained, “If you want to put the Afghans in the lead, you’re going to have to accept the fact that they are, in some ways, going to be less capable.” By ensuring that Afghans constituted 90 percent of any mission task force, Roberson created a situation where U.S. personnel were forced to assign more responsibility to their Afghan counterparts. As a result, Afghan Commando officers and noncommissioned officers gained experience in tactical planning and mission execution.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_13-3.png\",\n        \"caption\": \"ANA Soldiers rest\"\n      }\n    },\n    \"Ranked immediately below preparing Commando kandaks was turning Village Stability Operations over to Afghan district and provincial officials. The transition involved preparing local police to work with their fellow citizens while showing Afghan officials how to manage the program. The dispersion of local security forces and their unique one-on-one relationships with the American mentors who lived among them added complexity to the transfer. The transition began with consolidating or eliminating some Village Stability Operations sites and continued with transferring the remainder to Afghan security forces. During this phase, U.S. personnel gradually turned over responsibility for training ALP to their ANSF counterparts. As the number of U.S. SOF operational detachments decreased, they transitioned to mounted patrols and circulated among multiple Village Stability Operations locations. The Afghans displayed growing proficiency, so the U.S. SOF personnel incrementally reduced their profile until Afghans owned all platforms and conducted nearly all operations.\",\n    \"The ANSF led nearly all of both conventional and special operations from January to the end of October 2014. The ANSF were generally but not uniformly successful while in the lead. Most promising, they showed resilience after initial setbacks. On the morning of 23 February 2014, Taliban fighters overran an ANA base in Ghaziabad District, near the provincial capital of Asadabad in Kunar Province, killing twenty-one soldiers from 2d Brigade, 201st ANA Corps. The ANA retook the base the same day, using Mi–17 cargo helicopters for air assault and casualty evacuation. Coalition involvement was limited to close air and intelligence support. The Afghan public rallied around the ANA in a large memorial ceremony held in Kabul that week, a resounding indicator of ANSF success.\",\n    \"American Special Operations units and their Afghan counterparts continued to conduct dangerous missions as other ISAF forces retrograded before and after the 2014 Afghan elections. Five Americans, including two soldiers from the 5th Special Forces Group, 1st Special Operations Regiment, and one Afghan Commando were killed on 9 June 2014 by an errant air strike during an intense firefight in the Arghandab District of Zabul Province. The U.S. and Afghan special operators were targeting insurgent groups in advance of the runoff election. The June casualties were followed by more losses as SOF continued to conduct aggressive offensive operations during the last half of the year. The 7th Special Forces Group, 1st Special Forces Regiment, suffered fatalities from enemy small-arms fire during separate combat operations in Helmand and Zabul Provinces in September and December while the 3d Special Forces Group lost one soldier to small-arms fire in Kunduz in November.\",\n    \"Special Operations Task Force–Afghanistan, configured around a core provided by the 3d Battalion, 3d Special Forces Group, under the command of Lt. Col. Michael P. Sullivan, gained responsibility for U.S. SOF in country when CJSOTF-Afghanistan deactivated on 31 December 2014. Sullivan assumed command when the conditions facing SOF in Afghanistan were undergoing significant change. For the first time in more than a decade, the Special Operations geographical footprint aligned with that of conventional forces. While consolidating American units in a few locations and then deploying out to conduct operations eased force protection and logistical burdens, it did not facilitate Sullivan’s mission to conduct ground combat operations against armed groups targeting U.S. troops throughout Afghanistan. Complications arising from consolidating supporting fires, medical evacuation, and logistical assets would hinder the task force’s ability to conduct missions beyond the immediate range of U.S. enclaves.\",\n    {\n      \"title\": \"Obtaining Closure\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"America’s senior commanders in Afghanistan changed once again during this period as Army General John F. Campbell replaced Dunford on 26 August 2014. For the next several months, Campbell guided ENDURING FREEDOM along the established path toward Operation RESOLUTE SUPPORT. Organizational changes associated with the transition included replacing regional commands with the smaller train, advise, and assist commands and merging the IJC with ISAF headquarters so the latter could assume command of all ground operations. These changes occurred in the midst of continuing violence in eastern Afghanistan.\",\n        \"When Campbell told media representatives in fall 2014 that “we’re not out on patrol with the Afghans; they’ve taken over the fight. We’re focused on the systems and processes that they have at the corps level. We’re no longer with the brigades. We’re no longer with the Kandaks,” he was highlighting the rationale behind changes to his command’s physical footprint within Afghanistan prior to ENDURING FREEDOM ending. The total U.S. contribution to RESOLUTE SUPPORT, including both conventional and Special Operations Forces, would not exceed 9,800 personnel. NATO nations added another 2,900 soldiers for a total of 12,700 personnel. Downsizing ISAF dropped personnel numbers and reduced the amount of close air support; intelligence, surveillance, and reconnaissance; medical evacuation; and logistics the coalition could bring to the aid of the Afghans.\",\n        \"A much smaller foreign military presence in Afghanistan would exist, and the remaining troops would be located in just a few key areas  rather than spread across the entire country. As Campbell explained,\",\n        {\n          \"list\": [\n            \"\\\"We will have forces in the north, in the west, in the east, and in the south, and then in Kabul center. So we’re going to really  a spoke and hub, and come 1 January, in the east, we’ll have forces in Jalalabad, in Gamberi, in Bagram. In the north, they’ll be in Mazar-e-Sharif, in the west, they’ll be in Herat, and in the south, they’ll be in Kandahar.\\\"\"\n          ]\n        },\n        \"The smaller geographical footprint, coupled with reduced troop levels, meant that ISAF troops would be collocated with only four of the six ANA corps. The advisory needs of the remaining corps were addressed when resources became available or when the tactical situation dictated additional support, albeit on a temporary basis.\",\n        \"Downsizing ISAF reduced the support available to Afghan security forces, and meant that any available resources had to be concentrated on the most dangerous threats. Identifying these threats was a priority given the fragile state of Afghan politics in this period. The highly contested presidential election reflected this fragility, which barely improved with the installation of a National Unity Government that did not address the Afghan government’s inherent structural problems. In addition, the tense election period had presented the Taliban with an opportunity to exploit political divisions within Afghanistan. Aware that the Constitutional Loya Jirga scheduled for 2016 had the authority to alter the power arrangements in Afghanistan by either codifying or invalidating the president/prime minister structure of the National Unity Government further clouded the political landscape.\",\n        \"Although no fewer than six insurgent or criminal organizations sought to destabilize the newly elected administration of President Ghani by launching attacks in Kabul, both ISAF and Afghans considered the Haqqani the most dangerous. CJSOTF–Afghanistan focused on degrading and disrupting this network. ISAF had been waging an intense battle against the terrorist organization for many years, and countering it was now a top priority for coalition forces. In mid-October 2014, Afghan and ISAF troops managed to detain Anas Haqqani, son of the network’s founder, and Hafiz Raschid, a key planner and suicide attack facilitator. Pakistani armed forces provided belated but welcome assistance during summer 2014 when they responded to a terrorist attack against the Jinnah International Airport in Karachi on 8 June by cordoning off several towns in North Waziristan that had provided safe havens for extremists. Government forces initiated Operation ZARB-E-AZB (Swift and Conclusive Strike) with a series of air strikes against terrorist targets, killing dozens of foreign fighters and prompting others to flee toward the waiting Pakistani ground units. After 450,000 civilians were safely evacuated from the area, government troops initiated a sustained series of attacks against the terrorists that continued through fall 2016. In addition to landing damaging blows against the Pakistan Taliban and the Islamic Movement of Uzbekistan, Pakistani counterterrorist operations also disrupted Haqqani infrastructure in the region.\"\n      ]\n    },\n    {\n      \"figure\": {\n        \"source\": \"/figures/v2/img_13-4.png\",\n        \"caption\": \"General Hans-Lothar Domröse & General Campbell\"\n      }\n    },\n    \"On 28 December 2014, General Campbell presided over a ceremony marking the end of Operation ENDURING FREEDOM and the start of RESOLUTE SUPPORT.  Scores of attendees were present to witness the lowering of the NATO flag, marking a symbolic shift to a new, much smaller assistance and training mission. The speakers included Afghan national security adviser Mohammed Hanif Atmar, who acknowledged past sacrifices by observing, “We recognize that you carried on the fight for us when we were not ready. We pray for the fallen, for your sons and daughters who died on our soil.” In a written statement also issued that day, President Obama reminded Americans of their future responsibilities: “The United States—along with our allies and partners—will maintain a limited military presence in Afghanistan. Our personnel will continue to face risks, but this reflects the enduring commitment of the United States to the Afghan people and to a united, secure and sovereign Afghanistan that is never again used as a source of attacks against our nation.”\",\n    \"With the U.S. Army’s personnel now mostly back at their home stations, whether in the continental United States or abroad, it was time for Army leaders to reset the force. Nearly two decades of irregular warfare had required many changes in order to provide trained and ready formations in numbers necessary to meet the demands. Force designs, structures, doctrine, training methodologies, and much more needed to be reevaluated, adjusted, and reconstituted in order to prepare for the proverbial “Next War.” That war could come from anywhere across the spectrum of conflict, ranging from the lowest to the highest threat.\"\n  ],\n  \"chapter 14\": [\n    {\n      \"title\": \"The U.S. Army Beyond ENDURING FREEDOM\"\n    },\n    {\n      \"section\": [\n        \"Preparations for the 2010 ${Quadrennial Defense Review}{italic} spurred U.S. Army leaders to consider the role of the Army in future conflicts. The first results of that effort produced the ${Army Capstone Concept}{italic} in 2009, but the true harbinger of a significant conceptual change appeared in August 2010 with the publication of the ${Army Operating Concept}{italic}. This release promoted the “central idea” that Army forces would conduct “combined arms maneuver” and “wide area security.”\",\n        \"In 2010, as the School of Advanced Military Studies at Fort Leavenworth prepared to update the Army’s ${Operations}{italic} manual (Department of the Army Field Manual 3–0), General Martin E. Dempsey, commanding U.S. Army Training and Doctrine Command, directed the school to include “combined arms maneuver” and “wide area security” as a distinct statement of the Army’s unique contributions to the nation. Those missions did not replace the offense, defense, stability, or civil support (later defense support to civil authorities) construct that formed full-spectrum operations. Nonetheless, their inclusion undoubtedly informed the Army’s internal fight over whether to stress major combat operations or irregular warfare in its preparation for the 2010 Defense Review. In spite of initial opposition to Dempsey’s guidance, the Field Manual 3–0 authors included “combined arms maneuver” and “wide area security” as “Army core competencies” overlaid on top of full-spectrum operations. Their addition created considerable confusion among readers of the early drafts.\",\n        \"By including combined arms maneuver and wide area security in the official publication describing how the Army fights, the authors ensured that these concepts would receive wide readership. Normally, a strategic concept would be published in The Army (Department of the Army Field Manual 1), but this document had not been revised since 2005. As Army leaders looked to a future beyond Iraq and Afghanistan, they also sought to inform future strategy by including a clear statement of what the Army did in the new national defense strategy that the DoD was about to publish. With General George W. Casey Jr. nearing the end of his term, the responsibility for publishing the new Field Manual 1 would fall to the Army’s new chief of staff.\",\n        \"President Barack H. Obama nominated Dempsey to replace Casey on 8 February 2011. The former Training and Doctrine commander assumed his new duties on 11 April 2011 but held that office less than two months before his name was announced on 26 May 2011 as the nominee to replace Admiral Michael G. Mullen as chairman of the Joint Chiefs of Staff. As the Field Manual 3–0 rewrites continued during 2011, Dempsey recognized that his successor, General Raymond T. Odierno, would inherit the publication. It meant that any planned revision of Field Manual 1 would be deferred until Odierno assumed his duties on 7 September 2011. The next iteration of The Army, now labeled Army Doctrine Publication 1, would be published in September 2012.\"\n      ]\n    },\n    {\n      \"title\": \"Roles, Missions, Strategy, and Doctrine\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The final version of the revised Field Manual 3–0, labeled as Army Doctrine Publication 3–0 and published in October 2011 as Unified Land Operations, introduced the operational concept of the same name. Unified land operations drew initially from the concept of AirLand Battle that had been unveiled in the 1982 edition of Operations (Department of the Army Field Manual 100–5), and then was modified to reflect recent wartime lessons. The new doctrinal manual reestablished the importance of operational art and realigned the doctrinal hierarchy to place stability operations on par with combat operations. As an operational concept, unified land operations sustained intellectual trends that originated with the 2010 Army Operating Concept. In addition to introducing combined arms maneuver and wide area security, the concept replaced “command and control” with “mission command.” Unified land operations established a broader doctrinal framework that provided a stronger foundation than its predecessors had for blending offense, defense, stability operations, and defense support to civil authority.\",\n        \"One other small but far-reaching change occurred with the publication of Army Doctrine Publication 3–0. Odierno had not mandated changes in the content, but he directed that the term “full spectrum operations” be replaced by “decisive action” just after assuming his duties as Army chief of staff. The earliest reference to the new term occurred on 21 July 2011, during General Odierno’s confirmation testimony to the Senate Armed Services Committee, when he described the Army as the “force of decisive action.” In spite of the seemingly drastic change in terminology, there was no change to the arrangements of offense, defense, stability operations, and defense support to civil authorities inherent to full-spectrum operations.\",\n        \"The new operational concept described how the Army fought, but it did not define the Army’s role to the nation, which seemed about to change. When Odierno became chief of staff, the Iraq campaign was nearing its end, and the transformation of the Afghanistan campaign had already been announced. Policy statements by the Obama administration signified that less funding would be allocated to military needs. The role of the Army may have seemed self-evident internally, but externally, the role of the Army in the future was seen in a much different way by the civilian leaders of government.\"\n      ]\n    },\n    {\n      \"title\": \"Budgetary Pressures and Institutional Strategy\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Continuing the work of the 2010 Defense Review, a new National Defense Strategy appeared in January 2012 under the  title ${Sustaining U.S. Global Leadership: Priorities for 21st Century Defense}{italic}. Referred to as the Defense Strategic Guidance, this document announced a need for “a force that would be smaller and leaner, but agile, flexible, ready, and technologically advanced:” language reminiscent of the literature that Secretary of Defense Donald H. Rumsfeld had influenced on defense transformation at the beginning of the Bush administration.\",\n        \"Reductions to the defense budget stemmed from the 2011 Budget Control Act. This act, which formed the underlying context for the ${Defense Strategic Guidance}{italic}, mandated $487 billion in defense cuts to be made from 2012 to 2022, with the stipulation that $259 billion would be cut in the first five years. Other sweeping changes included a repudiation of the 1990s policy of massing resources to defeat one regional adversary while conducting a holding action against a second. Instead, the nation’s military would be sized to defeat a single adversary and then “facilitate a transition to stable governance on a small scale for a limited period using standing forces and, if necessary, for an extended period with mobilized forces.” The force would “no longer be sized to conduct large-scale, prolonged stability operations,” an unmistakable reference to the conflicts in Iraq and Afghanistan. According to the ${Defense Strategic Guidance}{italic}, U.S. forces would “rebalance toward the Asia-Pacific region,” an explicit geographical reprioritization that further distanced the military from the wars of the last decade.\",\n        \"The other major outcome of the ${Defense Strategic Guidance}{italic} was its introduction of ten unclassified missions for U.S. Armed Forces:\",\n        {\n          \"list\": [\n            \"1. Counter Terrorism and Irregular Warfare\",\n            \"2. Deter and Defeat Aggression\",\n            \"3. Project Power Despite Anti-Access/Area Denial Challenges\",\n            \"4. Counter Weapons of Mass Destruction\",\n            \"5. Operate Effectively in Cyberspace and Space\",\n            \"6. Maintain a Safe, Secure, and Effective Nuclear Deterrent\",\n            \"7. Defend the Homeland and Provide Support to Civil Authorities\",\n            \"8. Provide a Stabilizing Presence\",\n            \"9. Conduct Stability and Counterinsurgency Operations\",\n            \"10. Conduct Humanitarian, Disaster Relief, and Other Operations.\"\n          ]\n        },\n        \"\",\n        \"Of those missions, the force was to be sized only to fulfill four: counter terrorism and irregular warfare; deter and defeat aggression; maintain a safe, secure, and effective nuclear deterrent; and defend the homeland and provide support to civil authorities. These “force-sizing missions” drove discussions on force structure and size. By focusing on only one adversary at a time, the new approach lent weight to arguments calling for a reduction in the number of ground units in the active component, meaning the Army and Marine Corps. In addition, the new strategic vision materially influenced Army efforts to articulate its role beyond the wars in Iraq and Afghanistan.\",\n        \"General Odierno’s institutional strategy for the Army rested on a globally engaged and regionally responsive force that could “Prevent, Shape, and Win,” as the Defense Strategic Guidance put it. His vision first appeared in a January 2012 pamphlet that promised to emphasize training on tasks required for decisive action that the Army had put aside during its wartime shift to counterinsurgency and irregular warfare operations. However, such a vision could not ignore the continuing requirement for forces in Afghanistan. Although the Army was recovering from the Afghan surge, it still had to generate forces capable of combat and advising for at least another three years.\",\n        \"Implementing Odierno’s vision meant changing how the Army generated deployable forces in an environment that demanded less from conventional units. One change was reducing combat deployments for most personnel from a year to nine months. The Army also would begin training “Regionally Aligned Forces,” which were tailored to the needs of combatant commands and provided on a predictable basis, while retaining widespread capabilities in the force through units trained for the full range of military operations. Finally, the Army would support the Asia-Pacific “rebalance” by preparing theater support forces and Army service-component commands.\",\n        \"The Regionally Aligned Forces concept, in which forces trained in “decisive action” would be “habitually aligned” to combatant commanders, included corps headquarters, division headquarters, brigade combat teams, and sustainment units charged with providing theater-wide support. Regionally Aligned Forces would conduct more than security cooperation. In addition, they would be capable of operations up to and including combat. By predetermining the theater to which they would deploy, these units would have real-world missions on which they could focus their preparatory training. Implementing Regionally Aligned Forces required the Army to change how it generated forces because there would be little demand for a brigade combat team acting as an undivided or whole organization in a noncombat role. Instead, deployments lasting anywhere from a week to several months and involving small units, teams, or individuals with specific capabilities would become the norm.\"\n      ]\n    },\n    {\n      \"title\": \"Reducing the Force\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"President Obama’s pronouncement that “the tide of war is receding” and “it is time to focus on nation building here at home” in a 22 June 2011 speech at the White House presaged cuts to military spending. It was a foregone conclusion that the Army would shrink after Operation ENDURING FREEDOM and Operation IRAQI FREEDOM. The questions were how much and how quickly. In anticipation of change, the 2012 ${Army Posture Statement}{italic} introduced two terms to govern potential postconflict developments. The first was reversibility, which it described as “structuring and pacing reductions in the Nation’s ground forces in a way that preserves the ability to make a course change to surge, regenerate and mobilize the capabilities needed for any contingency.” The second was expansibility, described as “managing the force in ways that protect the Army’s ability to regenerate capabilities that might be needed to meet future, unforeseen demands, maintaining intellectual capital, rank structure and other assets that could be called upon to expand key elements of the force.”\",\n        \"The first reductions began in 2009 when Secretary of Defense Robert M. Gates announced that the Army would curtail its Grow the Army Plan. The plan was designed to add brigade combat teams to bring the active Army up to a total of forty-eight; Gates’ order stopped that growth at forty-five. Gates then announced that the Army would reduce its active component strength by some 27,000 on 6 January 2011. That reduction included a retraction from its temporary end strength authorized by Section 403 of the National Defense Authorization Act for Fiscal Year 2010, which was effective for two years.\",\n        \"In 2012, the Army planned to decrease its end strength from a wartime peak of 570,000 in the active Army, 358,200 in the Army National Guard, and 206,000 in the Army Reserve to 490,000 active Army, 353,500 Army National Guard, and 205,000 Army Reserve. Those reductions were projected to occur at a measured pace through the end of 2017 so as to allow the Army to meet its commitments in Afghanistan and elsewhere. The pace would facilitate reversibility of the force should unforeseen circumstances arise. To “keep faith” with soldiers and their families, the reductions would not be immediate or massive.\",\n        \"As part of restructuring, the Army decreased its brigade combat teams from forty-five to thirty-three. Although the Army was projected to have fewer brigades, the ones that remained were more capable than their predecessors. As part of the planned reduction, active component units based in the continental United States regained their third maneuver battalion that had been removed in order to create modular brigades. Stryker-equipped brigades, which already had three maneuver battalions, received an engineer battalion. In addition, the Army converted brigade support troop battalions within remaining brigade combat teams into engineer battalions. Artillery battalions in the remaining combat brigades would convert from two firing batteries with eight howitzers apiece to three firing batteries with six howitzers apiece, permitting each maneuver battalion to be supported by a dedicated artillery battery. Upon completion, the reductions left the Army with twelve armored brigades, fourteen infantry brigades, and seven Stryker brigades in the active force.\",\n        \"Army plans to reduce to 490,000 personnel by the end of fiscal year 2017 reverberated throughout organizations above the brigade level. On 12 June 2013, the Army deactivated the V Corps, which had been spared that fate almost exactly four years earlier to fill the requirement for ISAF Joint Command headquarters. With the impending end of this joint command mission, a corps headquarters based in the United States would temporarily fill that billet. The V Corps was left with no subordinate elements following the relocation of the 1st Armored Division from Germany to Fort Bliss, Texas, in 2011.\",\n        \"What was not readily visible in those changes was the streamlining of units outside the combat brigade structure. Consolidations substantially changed the Army’s school systems, perhaps none more so than the restationing of the Air Defense Center and School from Fort Bliss to Fort Sill, Oklahoma, to form the Fires Center of Excellence in 2010. The following year, the Maneuver Center of Excellence was created at Fort Benning, Georgia, by merging the post’s Infantry Center and School with the Armor Center and School, newly arrived from Fort Knox, Kentucky. Other economies came through eliminating overhead such as the U.S. Army Accessions Command in 2012 as well as a mandated 25 percent reduction in the Army Staff and equivalent lower-level headquarters.\"\n      ]\n    },\n    {\n      \"title\": \"Readiness for an Army after ENDURING FREEDOM\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The impending end of combat operations in Afghanistan meant a corresponding decrease in supplemental funding—a troubling prospect for Army leaders, since their service’s base budget did not permit maintaining even a reduced force at full readiness. Faced with less money and fewer soldiers to maintain its operational responsibilities across the globe, Army leadership took steps to synchronize fiscal and strategic realities. The contingency force program was the Army’s means of ensuring it could still meet time-sensitive requirements. Instead of maintaining the force pools created by the Army Force Generation process, a smaller mix of armored, infantry, and Stryker brigade combat teams were kept at full combat readiness. Only those units would benefit from combat training center rotations; the remainder of the Army would be trained at lower levels of proficiency. At the same time, the Army adopted the sustainable readiness model, which brought back what in 2001 had been known as the Band of Excellence, an echelonment in which a unit’s readiness fluctuated but remained below deployable status until assigned missions.\",\n        \"These arrangements to ensure that selected units received the training they needed to achieve deployable readiness did not address the fact that the Army needed to regain experience in conventional warfare after a decade of counterinsurgency operations. That process began in 2009 with the publication of ${Army Training and Leader Development Guidance}{italic}, which combined the core mission essential task list and the directed mission essential task list into a full spectrum mission essential task list. The next step did not take place until the demand for units trained in counterinsurgency abated with the retraction of the Afghan surge. Between August 2011 and February 2012, maneuver combat training centers began discarding tailored mission rehearsal exercises in favor of generic full-spectrum scenarios pitting units against similarly equipped conventional opponents.\",\n        \"The shift from counterinsurgency to full-spectrum operations or decisive action would not be easy. By the end of ENDURING FREEDOM, the Army’s principal repository for skills in conducting major combat operations was senior leaders who had grown up with those processes. In fact, by that point, soldiers who might have had substantial experience in combined arms warfare were brigade commanders and their command sergeants major, a situation the Army had not experienced since the early 1970s. Division commanders noted that leaders at the battalion level simply did not have the knowledge or experience to train their units on techniques that were common knowledge before 2001.\",\n        \"After watching several rotations in which visiting units attempted full-spectrum operations, Brig. Gen. Terry R. Ferrell, c ommanding general of the National Training Center at Fort Irwin, California, observed that “we have second lieutenants, first lieutenants, captains, and many majors now who have not operated or trained on major combat operations.” Ferrell’s comments echoed observations found in a white paper written at the behest of Maj. Gen. Michael S. Tucker, whose South Korea–based 2d Infantry Division faced the threat of conventional invasion across the 38th Parallel. The paper noted that small-unit leaders had “little or no knowledge of breaching or gap crossing operations, have difficulty analyzing the terrain, visualizing enemy courses of action, and developing event templates with time and distance analysis to identify signature equipment and High Value Targets.” Similarly, a soldier at the Joint Readiness Training Center in October 2014 observed that “the basics of fighting position construction, sectors of fire, sector sketches, interlocking fire, obstacle preparation and many more basics of defensive operations have atrophied over the past 13 years at war.” Even more indicative of over a decade of nondoctrinal missions was that junior leaders, many of whom had known no other professional reality, “seemed to be operating with a FOB [forward operating base] mindset.” In this context, “FOB mindset” was shorthand for counterinsurgency operations, a dangerous approach to pursue when engaged in high-intensity combat.\",\n        \"The return to full-spectrum or decisive operations recognized that future opponents likely would be skilled in cyber warfare, unlike those the Army faced in Iraq and Afghanistan. This challenge would be as difficult to address as that of retraining units to fight against conventional foes. Ever since the original decision to go to war as part of a multinational effort, the Secure Internet Protocol Routing Network, a U.S. national secured communications network, gave way to coalition networks such as the ISAF Secret network and national extensions like the British OVERTASK network. A replacement, the U.S. Combined Enterprise Regional Information Exchange System, followed a similar path after General Stanley A. McChrystal directed all units to transition as much traffic as possible off their national networks and onto the Afghan Mission Network in January 2010.\",\n        \"Blending networks hurt the campaign by triggering numerous security breaches as American personnel sent information not cleared for universal distribution to coalition recipients. The Army’s insufficient security protocols against insider threats came to light during the court-martial and conviction of Spc. Bradley E. Manning (now known as Chelsea E. Manning), who had leaked classified diplomatic cables and Army reports to a third-party Web site. Recognizing that future conflicts would likely be multinational, that potential regional aggressors would employ cyber warfare specialists, and that insider threats could cause grievous national harm, the Army began training the entire force in information assurance procedures previously practiced only by its intelligence community.\",\n        \"Although senior Army leaders recognized that the Army had to change its approach to training, the service’s normal means of regaining expertise in long-neglected skills were either greatly diminished or gone. The streamlining of the force that had created centers of excellence from branch schools and substituted civilian instructors for military faculty gave the U.S. Army little excess personnel from which to rebuild expertise. By taking personnel from the Generating Force (mainly from the Army schools) to fill requirements in the Operating Force (forces under FORSCOM prepared for contingency operations), the Army effectively had used up its source for rebuilding expertise in warfighting approaches other than tactical counterinsurgency. It would take time, money, and concerted effort to build proficiency in old and new mission sets alike.\",\n        \"The inescapable need to grow the Army for ENDURING FREEDOM and IRAQI FREEDOM also contributed to the evisceration of the Generating Force. As the Army expanded, promotion timelines shortened so that it could field the appropriate rank of officers and noncommissioned officers needed to fill new requirements. Promotions came overwhelmingly to those who held repetitive tactical command, preferably in combat. In a period of compressed timelines, officers had fewer opportunities to gain experience in anything other than their basic branches. For the majority of the Army’s future senior leaders who came from the combat arms branches, such experience was predominantly in the Operating Force and frequently in units that operated most comfortably at the tactical level.\",\n        \"Studies on officer personnel management conducted as early as 1997 identified these risks but did not forecast the amplifying effects of an expanded Army. The emphasis on brigades, divisions, and corps as the building blocks of the Army’s contribution to the joint force excluded many skills needed at joint task force, service staff, and combatant command levels. In 2005, Human Resources Command had recognized problems with building experience outside an officer’s branch or functional area in the existing Officer Professional Management System—which did nothing to facilitate General Peter J. Schoomaker’s original intent for “pentathletes” who were capable across a broader spectrum of the conflict.\"\n      ]\n    },\n    {\n      \"title\": \"The Reserve Component after Fifteen Years of War\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The wars in both Iraq and Afghanistan were shaped by the decisions to adopt a total-force policy and an all-volunteer force following the Vietnam War. Operation ENDURING FREEDOM and its counterpart in Iraq tested the Army’s ability to sustain overlapping campaigns for almost a decade without the need for the draft. Mobilizing the Guard and Reserve had connected the American public to the Global War on Terrorism in some ways, but it still did not produce wide public support for—or opposition to—the war as conscription had in the past. Although successful, the total-force concept suffered as the reserve component strained under the demands of performing both homeland defense and overseas combat operations after the September 11th attacks. As former Acting Assistant Secretary of Defense for Reserve Affairs David L. McGinnis stated, “If there’s anything you ought to give to the reserve components . . . it’s the high demand/low density unit . . . [which] represents the chasm between service culture and the needs of the nation, because the services will not invest their money . . . in these things that they don’t think is [sic] important to their culture.” Elevating the National Guard and Reserve to full readiness levels between 2001 and 2016 was a costly exercise, undermining the notion that the total-force approach would save money.\",\n        \"Despite the challenges of their varied missions, the National Guard and the Reserve benefited from playing key roles in Iraq and Afghanistan. At the end of both conflicts, reserve units and personnel were more experienced, better trained, and better equipped than they had been in 2001. The number of power projection platforms for the Guard, for example, increased from four in 2001 to fourteen by 2008, ten of which were filled by the reserve component. Until 2007, individual readiness checks and small-unit tasks were permitted only under active component supervision at mobilization stations, but they would now be performed by reserve component personnel ahead of mobilization. Medical and dental readiness went from being the primary factor keeping soldiers from deploying to an administrative issue, although the cost of offering premium-based healthcare for the entire force at all times and no-cost insurance for reservists prior to deployment rose exponentially. The reserve component experienced as dramatic a change in force structure as the active Army. Modularity created interchangeable units across components, eliminating the last vestiges of tiered readiness. The components of the Army came to resemble each other in many ways, although bureaucratic competition for missions, funding, and resources resumed as the tempo of combat operations decreased. For example, the 2014 Army Aviation Restructuring Initiative deactivated two combat aviation brigades and led to the decision to phase out all OH–58 Kiowa Warrior helicopters from the force by fiscal year 2018. An initiative to transfer four National Guard AH–64 Apache helicopter battalions to the active component, in exchange for transferring active component UH–60 Black Hawks to the National Guard and Army Reserve, encountered skepticism from Congress. As a result, while some elements of the restructuring plan proceeded as scheduled, the Apache battalions remained in place until a congressionally appointed commission studied the issue. The commission recommended against the transfer of Apaches, suggesting instead that the National Guard procure fewer modernized Black Hawks to offset the cost of maintaining more attack helicopters.\",\n        \"The Declaration of National Emergency by Reason of Certain Terrorist Attacks, in place since 14 September 2001, underpinned the continued operational use of the reserve component as well as supplemental funding. Although this declaration was renewed each year after 2001, the authority to continue employing the Guard and Reserve as an operational force was not guaranteed. Nearly twenty years after September 11th, the United States continues to use emergency powers. Though the active component likely will continue to call upon the reserve component even after repairs and modifications to the forces are made, access to the reservists may well depend on a reexamination of existing legislation.\"\n      ]\n    },\n    {\n      \"title\": \"Retrospect and a View to the Future\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"To the casual observer, the Army at the end of 2014 looked much the same as it had in late 2001. The force structure appeared outwardly similar in many organizations and the overall size differed little from the beginning of the Afghanistan and Iraq campaigns. The reality, expressed mostly in intangibles, was that the Army had changed significantly. The Army of 2001 had been organized, trained, staffed, and commanded in a manner consistent with its fight against Iraq during Operation DESERT STORM. Changes forced upon the Department of the Army after 2001 occurred in the context of a conflict that senior leaders had not predicted. That experience transformed the Army into a force that started off by fighting terrorists, then countered insurgents, then pursued functionally based security force assistance, and finally prepared for stability operations. A tenacious enemy, an evolving national strategy, and a dynamic environment changed the Army over the longest overseas war it has ever fought.\",\n        \"The Army faced numerous challenges as the fighting in Afghanistan and Iraq continued longer than anticipated. Undisciplined force management—fostered in part by the pervasive but illusory notion in the 1990s that future wars would be short, decisive, and dominated by the precise application of firepower against opposing conventional forces—led to severe staff shortages soon after 11 September 2001. Ironically, the Army had helped create this crisis through its own practice of granting exceptions to existing assignment policies for individuals in the reserve component who volunteered to fill the ranks of joint headquarters and low-density, high-demand units in both Iraq and Afghanistan. Several factors produced this volunteerism, including a professional desire for combat experience and anxieties among Guard and Reserve soldiers that the war would end before they had a chance to deploy, as had happened in Operation DESERT STORM. Though the active component did not experience as significant a backlash, many reserve component units ultimately became nondeployable by 2004 because key individuals had volunteered for overseas service and did not have enough dwell time to return to service.\",\n        \"The Army remained an all-volunteer, professional organization by spreading necessary sacrifices among the various branches of service in deployed active component contingents as well as within the reserve component and stateside Generating Force. These sacrifices included deploying a large number of National Guard units to Iraq to enable the active force to implement modularity, repurposing combat support and combat service support units to perform combat missions, and revising training curriculum to better prepare soldiers for what they would face in Iraq and Afghanistan. Although these developments showed that the Army was adapting to the conflicts it faced, the limited time available to reset units returning from combat meant that whatever proficiency was left in their core mission essential task lists eroded over time as predeployment training continued to focus on tasks unique to Iraq and Afghanistan. Ignoring pre–September 11th core tasks came at a price. By 2011, the revamping of doctrine in the form of the Unified Land Operations manual (Army Doctrine Publication 3–0), and the difficulties the Army faced in reestablishing expertise in full-spectrum operations and decisive action made it clear that the Army had lost much of its original expertise in functions that were not irregular warfare.\",\n        \"Training in full-spectrum operations only partially addressed this deficit in traditional skills. Major structural changes to the modular force were also required. The Army started that process by reflagging its fires brigades as division artillery brigades, beginning with the 1st Armored Division on 23 July 2014, bringing back a combat support command and control structure that had disappeared with the introduction of modularity. Although direct support artillery battalions remained in brigade combat teams, authority for training and certifying fires now became the responsibility of the division artillery commander, infusing a critical mentorship role back into the force structure. Similarly, the return of armor and infantry brigade combat teams with three maneuver battalions was another step away from modularity, although the reorganized brigades retained their cavalry squadrons and organic support organizations that previously belonged under divisional headquarters.\",\n        \"Although the 2012 ${Defense Strategic Guidance}{italic} and 2014 ${Quadrennial Defense Review}{italic} appeared to reinforce the argument that the Army needed to be sized in anticipation of another long-duration conflict, both documents noted that near-term force structure decisions likely would not be influenced by the remote possibility of more conflicts like Iraq and Afghanistan. Given the likelihood that military budgets would shrink, policymakers instead began exploring how to manage the force in ways that would allow the Army to regenerate capabilities that had atrophied as a result of its decade-plus focus on irregular warfare. The 2012 D${Defense Strategic Guidance}{italic} explicitly mentioned the need for “intellectual capital and rank structure that could be called upon to expand key elements of the force.” The 2014 ${Quadrennial Defense Review}{italic} contained similar language suggesting a requirement for regeneration of the force.\",\n        \"If the United States became involved in a conflict that seemed like it might be protracted, a decision to grow the force would have to be made much sooner than occurred during the Bush administration’s Global War on Terrorism. In the Army’s 2015 annual posture statement to the Senate Armed Services Committee, Secretary of the Army John M. McHugh and Chief of Staff General Raymond Odierno noted that it takes around thirty months to generate a complete brigade combat team. That period includes recruiting new soldiers and putting them through initial entry training, assembling the chain of command, building facilities, issuing equipment, and mastering the individual and collective training goals that must be met before committing a unit to combat.\",\n        \"Training concerns were not confined to the physical side of operations. The uniformed expertise previously resident in the Army’s schools and centers had been replaced by civilians as uniformed authorizations were moved from the Generating Force into the Operating Force to fill new unit authorizations. Some of that expertise remained in the reserve component, but those forces were subject to constraints. Maintaining the Guard and Reserve at the same level of readiness as their Active Army counterpart would either increase costs or, worse, force reserve expertise to leave the service because of the higher operations tempo. For competencies such as attack aviation and combined arms warfare, those talents could not be replaced easily.\",\n        \"To regenerate the force, senior leaders would have to make some hard tradeoffs. As the Army at large reduced in size, the size of the Generating Force needed to expand relative to the size of the whole Army. The greatest challenge to regeneration rested in midgrade officers and noncommissioned officers who needed to be capable of serving as a cadre for expansion of the Operating Force and training the personnel that were part of the expansion itself. Those midgrade officers and noncommissioned officers would serve as building blocks to enable that expansion, which itself would require additional recruiters.\",\n        \"In an effort reminiscent of Donald Rumsfeld’s first year as secretary of defense, like-minded Obama administration officials  recommended that U.S. conventional forces should not be resourced or configured to conduct large-scale stability operations over an extended period. The Army’s senior leadership remained opposed to the narrow strategic path espoused by transformation advocates. In a 20 July 2013 New York Times article, Maj. Gen. Herbert R. McMaster exposed the fundamental flaw in both presidential administrations’ arguments by pointing out that technological superiority did not guarantee that the United States could avoid being drawn into irregular conflicts. Two years earlier, Marine General James N. Mattis, then CENTCOM commander, had voiced a similarly sobering assessment before the Senate Armed Services Committee: “I think, as we look toward the future, I have been a horrible prophet. I have never fought anywhere I expected to in all my years.”\"\n      ]\n    },\n    {\n      \"title\": \"SECTION III CONCLUSION\",\n      \"level\": 2\n    },\n    \"${Modern War in an Ancient Land: The United States Army in OPERATION ENDURING FREEDOM, 2001–2014}{bold}\",\n    {\n      \"interactive\": {\n        \"source\": \"/iframe/ch14/VOLII_Ch14Conclusionv2.html\",\n        \"caption\": \"Key Events 2001-2014\"\n      }\n    },\n    \"Following the September 11th terror attacks, the U.S. Army entered an era of sustained warfare unlike anything experienced during its 225-year history. The challenges that the Army faced included skilled and tenacious foes, unreliable regional allies, shifting objectives, and inadequate resourcing. The course of Operation ENDURING FREEDOM thus swung from the high of its initial success in toppling the Taliban to a three-year period where the United States searched for the right operational approach in Afghanistan while it shifted its primary focus to Iraq. As NATO assumed the operational lead in Afghanistan starting in 2006, the Taliban and its allies seized the initiative while the United States maintained an economy of force effort as the situation in Iraq deteriorated. After the election of Barack H. Obama in 2008, the United States reinvigorated its efforts in Afghanistan for roughly eighteen months before retrograding its forces and bringing the campaign to a close. Even after a successful drawdown of American forces, the legacy of the nearly 15-year-long ENDURING FREEDOM campaign remains inconclusive.\",\n    \"${An Imperfect Strategic Crystal Ball}{bold}\",\n    \"The events of 11 September 2001 shocked the United States. In the immediate wake of the attacks, President George W. Bush and his cabinet raced to formulate a retaliatory strategy and prevent further attacks. The 21st-century news cycle, which broadcast images of death and destruction in New York City and at the Pentagon for weeks afterward, influenced strategic deliberation and campaign planning to an unprecedented degree. The speed of the American counterstrike, coupled with the fact that American conventional forces were ill-equipped for a rapid and coordinated response a decade after the end of the Cold War, largely shaped the Army’s opening involvement in Afghanistan.\",\n    \"Despite the many challenges inherent in a U.S. intervention in Afghanistan, the DoD and CENTCOM, with the approval of the National Security Council, championed an untested style of campaign planning and warfighting during the opening phase of Operation ENDURING FREEDOM. The new approach, based on the concept of transformation, blended coalition conventional and unconventional units, airpower, CIA operatives and indigenous opposition groups, to form an effective fighting team against an irregular enemy using conventional tactics. The unproven approach favored by the Bush administration delivered decisive results at little cost in American lives while avoiding the appearance of a Soviet-style occupation. The Taliban government crumbled under the pressure of the United Front supported by American advisors controlling precision aerial strikes. Resistance from al-Qaeda broke after the combined U.S.-Afghan assault at Tora Bora in December 2001. The remnants of al-Qaeda and the Taliban scattered, seeking refuge in rural Afghanistan or in sanctuaries in Pakistan. The speed of the coalition’s victory caught everyone by surprise and appeared to vindicate the American embrace of a new style of warfare.\",\n    \"In the second phase of the campaign, culminating with Operation ANACONDA in March 2002, a number of unexpected issues emerged after the fall of Kabul which signaled the fragile nature of the new coalition and questionable durability of the strategic choices made by the United States. The Americans soon learned that ethnic and personal agendas prevented the United Front from seamlessly transitioning into the role of Afghanistan’s primary security force. The Taliban and al-Qaeda learned the limits of American aerial capabilities and adjusted their tactics accordingly. With enemy fighters focused on reconstituting their power base in cross-border sanctuaries, conventional units increasingly confronted growing administrative responsibilities in support of nation building and humanitarian relief. American combat units also took over many of the missions formerly allocated to allied indigenous forces after diminished United Front involvement affected the ability of Special Forces and the CIA to contribute to the campaign.\",\n    \"President Bush’s speech at the Virginia Military Institute on 17 April 2002 announced a shift in the American approach to Afghanistan, with the employment of additional conventional forces in ground operations and a new commitment to some form of nation building. Operation MOUNTAIN LION, initiated by Maj. Gen. Franklin L. “Buster” Hagenbeck’s CJTF-MOUNTAIN and concluded under General Dan K. McNeill’s CJTF-180 during the summer of 2002, signaled the beginning of a new stage in the campaign, in which American units conducted security operations in support of a new Afghan government established under the aegis of the United Nations. The transition marked a crossroads for the Global War on Terrorism, as the United States shifted its strategic focus to Iraq while continuing to support stabilization efforts in Afghanistan. The invasion of Iraq jeopardized the successful campaign in Afghanistan as the United States was not militarily prepared to wage two protracted conflicts simultaneously. With the Bush administration unwilling to raise taxes, establish additional Army and Marine combat units, or mobilize the nation as a whole to devote greater resources to the war, fighting in multiple locations presented a complex operational challenge. The de facto relegation of Afghanistan to a secondary effort—for the purpose of redirecting limited resources to Iraq—undercut the gains of the opening campaign in the Global War on Terrorism.\",\n    \"${Sustaining the Initial Victories}{bold}\",\n    \"Making Operation ENDURING FREEDOM a lower priority sparked a number of collateral changes as the international community, U.S. government, coalition partners, and Afghans were forced to make do with less support and fewer resources. One justification for shifting the DoD’s attention to Iraq was the American assumption that the Taliban was a defeated entity and no longer of serious concern. Successive U.S. commanders thus received unaccustomed authority and discretion in Afghanistan. However, circumstances on the ground soon began to inhibit the smooth implementation of the Bonn Process. The international humanitarian aid effort, which U.S. authorities originally envisioned as the centerpiece of reconstruction, gradually imploded. The U.S. leadership also came to realize that Pakistan supported the Taliban’s return, a factor that complicated attempts to stabilize Afghanistan’s border regions. Nevertheless, the Bush administration remained reluctant to commit additional U.S. ground combat power to maintain internal stability until sufficient indigenous security forces and government bureaucracies could be created.\",\n    \"American military efforts in Afghanistan from 2002 through 2005 failed to gain momentum owing to the overall lack of boots on the ground and the need to deploy these limited forces in geographically isolated locations. With a focus on mounting counterterrorism operations, newly deployed American combat units discovered that sparse allocations of intelligence and surveillance assets made it difficult to find and engage the enemy. Growing demands for infantry in Iraq resulted in noninfantry organizations being sent to Afghanistan to perform close-combat missions. Even with augmentation by noninfantry units, however, U.S. commanders in Afghanistan lacked adequate numbers to secure the entire country. As a result, available units were deployed in eastern Afghan provinces opposite HIG and Haqqani strongholds as well as in Pashtun tribal areas around Kandahar. In addition, confirmation of growing cross-border traffic between Afghanistan and Pakistan led U.S. and coalition Special Forces, conventional units, and new Afghan security organizations to focus more on securing the eastern and southeastern borders with Pakistan.\",\n    \"Although a larger number of indigenous military units could have helped redress the unavailability of American troops, various obstacles hindered early attempts to create those security forces. First, the U.S. defense establishment balked at absorbing the projected cost of this program. Second, the United Front proved unwilling to deploy its forces in the Pashtun-dominated areas of Afghanistan, or to convert its militia units into regular forces answering to a central government, without commensurate incentives. As the United States hesitated to make significant early investments in security force assistance, these incentives never appeared. By January 2003, the U.S.-led effort had trained only 1,800 ANA troops. The resultant lack of sustainable security beyond the confines of Kabul hampered reconstruction efforts and economic development in areas where U.S. troops did not operate, and facilitated the rise of local strongmen and the reemergence of the opium trade.\",\n    \"Insufficient funding was not the only challenge associated with the creation of Afghan security forces. As a result of growing demands from Iraq, the mission of training Afghan troops shifted from SOF to rotating conventional units operating under the designation of TF PHOENIX. At the same time, the U.S. Special Operations units remaining in Afghanistan made effective security assistance all the more complicated by forming their own indigenous auxiliary units to help fill the security vacuum created by the lack of conventional units in theater. Although this approach satisfied near-term needs, it siphoned off thousands of potential ANA recruits while creating paramilitary units beholden to local authorities rather than the central Afghan government. The limited resourcing caused by the invasion of Iraq therefore directly hampered reconstruction and security force assistance efforts, and offered fewer opportunities to improve the integration of Special Operations and U.S. conventional forces.\",\n    \"American interest in Afghanistan briefly revived after U.S. and coalition troops ousted Iraq’s Saddam Hussein from power in April 2003. Within two months, the National Security Council adopted a new political-military action plan titled Accelerating Success, which aimed to curtail the power of warlords and reform Afghanistan’s interior and defense ministries. Weeks later, the DoD adopted new policy guidelines for the Operation ENDURING FREEDOM coalition. The overarching objective was still to “prevent Afghanistan from serving as a base for terrorists,” but policymakers viewed this goal quite differently. The United States now sought to create a representative and democratic Afghan government capable of controlling and overseeing its territory. NATO, which assumed leadership of ISAF from the UN in August 2003, shared this lofty ambition. CENTCOM tasked Lt. Gen. David W. Barno with overseeing the complex transition from counterterrorist operations to an appropriate mix of counterinsurgency methods. The United States did not digress from this path for the remainder of the Bush presidency.\",\n    \"The adoption of expanded political objectives invariably meant a broader military role as most U.S. government organizations were unwilling to send their personnel into an unstable security environment. Awareness of the difficulties associated with implementing a whole-of-government approach had been growing for some time as Provincial Reconstruction Teams struggled to obtain experts from the Department of State, the U.S. Agency for International Development, the Department of Agriculture, and other agencies. Although these organizations made some efforts to address this issue, the lengthy time required to train these experts coupled with the constant need to provide personnel for similar missions in Iraq ensured that the problem remained unsolved throughout ENDURING FREEDOM.\",\n    \"${The Strategic Equation Is Altered Again}{bold}\",\n    \"The Bush administration viewed the completion of the Bonn Process with the Afghan election in September 2005 as the logical time to downsize the U.S. military presence in Afghanistan. Taking a page from the successful peacekeeping efforts in the Balkans, the Americans sought to transfer security responsibilities to the NATO-led ISAF. After lengthy negotiations, NATO agreed to extend ISAF’s mandate across all of Afghanistan. Likewise, the American government saw the transition as a means to avoid sending more troops rather than as a sign of imminent withdrawal.\",\n    \"Tying the NATO ISAF transition to the culmination of the Bonn Process placed U.S. commanders in Afghanistan in the position of having to factor coalition politics and the concerns of an increasingly assertive Afghan government into strategic deliberations. The uneven nature of insurgent activity throughout Afghanistan influenced NATO ISAF’s initial plans for assuming responsibility over the various regional commands. However, the Taliban’s decision to aggressively oppose the deployment of NATO units into RC South in 2006 added to the challenges facing Operation ENDURING FREEDOM. The enemy actively sought opportunities to fracture the opposing military coalition by inflicting casualties on less resolute participants until domestic political pressure from those nations prompted their withdrawal.\",\n    \"The Taliban viewed the transition period as the optimal time to stage a comeback. Its leadership was aware that the impending transition did not guarantee the departure of U.S. forces. Nonetheless, it knew that a favorable window of opportunity would close once ISAF reinforced the American troop presence and their efforts to provide security assistance and humanitarian aid to the Kabul government, and so it chose to exploit the evolving strategic environment by launching major offensives in contested eastern and southern Afghanistan. In doing so, the Taliban finally shed the strategic and operational hubris that had led to its humiliating rout in late 2001. Their assault caught both the Americans and NATO as they were adjusting dispositions, reconfiguring their command and control apparatus, and refining tactical-level interoperability.\",\n    \"The sheer ferocity of the Taliban’s unexpected return to the battlefield upset American efforts to realign their involvement in Afghanistan. Even though American commanders initially intended to wage an aggressive counterterrorist campaign in RC East, growing insecurity beginning in 2006 forced them to divide their attention between pursuing their own objectives and assisting their NATO allies. The Taliban’s rejuvenation served as a rude shock to the ISAF members who planned to focus on rebuilding war-torn Afghanistan. Many of the United States’ European allies had signed on to the Afghanistan mission expecting to provide security assistance along the lines of their engagements in Kosovo and Bosnia; accordingly, they were reluctant to actively confront the Taliban. What resulted was a bifurcation of the American effort—divided along separate command chains—between counterterrorist operations and support for ISAF. Slowly, the United States assumed full command of the operations in Afghanistan, including both the U.S.-only ENDURING FREEDOM and its NATO ISAF forces, beginning with the appointment of General Dan K. McNeill as ISAF commander in early 2007. Aligning the two campaigns, however, would take considerably more time.\",\n    \"The urgent task of defeating Taliban efforts to reassert control in the south and east fell to ISAF and American conventional and Special Operations units. With the Afghan army and police proving unequal to the demands of fast-paced combat operations, American units also found themselves aiding their underprepared NATO brethren on short notice. The impressive achievements made by coalition and Afghan forces during Operation MEDUSA in September 2006 proved that they could work together and establish clear dominance in a region. The same could be said of Lt. Col. Brian J. Mennes’ 1st Battalion, 508th Infantry’s service as the ISAF Theater Tactical Reserve beginning in mid-2007, which demonstrated that a single battalion could exert a significant impact on the path of the campaign. The experience of Mennes’ battalion, and of other units that performed just as effectively, indicated that both ISAF and American conventional units could develop good working relationships under trying circumstances. However, ISAF simply did not have the numbers and resources needed to fight for every piece of contested ground while attempting to win the Afghan people’s hearts and minds. The ISAF decision to spread its manpower across as many areas as possible in an attempt to hold ground and safeguard the populace, rather than accepting near-term risk by massing to defeat the enemy’s main effort, inadvertently ceded the operational initiative to the insurgents. The Taliban would maintain the gains it had made during the ISAF transition until the end of the surge in Iraq made it possible to send more U.S. troops to Afghanistan. As might be expected, the Taliban resurgence triggered considerable changes in security assistance and reconstruction. Indigenous army and police units that had existed before the Taliban resurgence suffered considerably from casualties and desertions as a result of the high tempo of operations. Armed with additional funding, the U.S. Army undertook immediate steps to rebuild and expand the Afghan army and police forces. Of course, competent armies take time to build. The Afghan police forces required even more augmentation than their army counterparts. ISAF invested considerable funding, time, and effort in forming ad hoc home guard police units in an effort to solve personnel shortfalls more rapidly. However, most of these initiatives fell short of their intended goals or failed outright despite generous funding. Consequently, Afghan security forces were in only marginally better shape several years after NATO ISAF began to devote more resources to train and equip them.\",\n    \"Similar and more successful efforts provided reconstruction and humanitarian aid programs with additional funding and resources. The reconstruction teams grew much larger in size as robust security elements were added in provinces where the Taliban posed a threat to their efforts. The categories and scope of the projects being undertaken also changed as brigade and battalion commanders, influenced by experiences in Iraq where money was an effective weapon against insurgents, added more reconstruction projects to their tactical repertoire. The Americans also introduced long overdue innovations, such as agricultural development teams that aided Afghan efforts to restore local economies by rejuvenating farming, animal husbandry, and fruit-growing. Translating these efforts into popular support for the central government, however, continued to be a problem.\",\n    \"In addition to the changing nature of the battlefield, the Taliban resurgence added several new elements to the overall strategic equation. First, the enemy’s sanctuaries in Pakistan were a clear threat to Afghan stability, and could not be addressed solely by drone strikes. Second, the groups opposing the U.S.-led coalition and the Karzai government openly reasserted control over areas in Afghanistan’s south and east where a vacuum of security and governance existed. That development would have a significant impact on future security assistance and reconstruction efforts. Finally, the insurgency exposed clear divisions within the international coalition. The coalition had neither a comprehensive campaign plan nor a unified understanding of the mission in Afghanistan. Ostensibly, this problem was resolved with the establishment of USFOR-A in late 2008, but this measure did not address the lack of coalition resources even as the insurgency continued to expand.\",\n    \"${The Economy of Force Campaign Receives More Resources}{bold}\",\n    \"In the fall of 2008, the Bush administration ordered a strategic review of the American effort in Afghanistan. With the situation in Iraq largely stabilized after the troop surge in 2007—and with casualties in Afghanistan climbing steadily as the security situation deteriorated—American policymakers shifted their attention away from what had been the main effort in the Global War on Terrorism since 2003. Led by Lt. Gen. Douglas E. Lute, the National Security Council review recommended pursuing a more robustly resourced counterinsurgency effort with greater attention given to Pakistan. President Bush supported the recommendation, but the November 2008 election of Barack Obama tempered the outgoing administration’s willingness to announce new policy initiatives. Bush did not want to present his successor with a strategic fait accompli.\",\n    \"Upon taking office in January 2009, the new president ordered another strategic review to define the desired end state in Afghanistan and discern the necessary troops and equipment required to achieve it. During a 27 March 2009 address to the nation, Obama signaled his willingness to commit more resources to the campaign. This became clear when the president announced his approval of a long-standing request from ISAF commander General David D. McKiernan for 17,000 additional combat troops to balance increasing insurgent activity and capabilities and to help set conditions for the upcoming Afghan presidential election. That contingent, he explained, would be followed by 4,000 more U.S. personnel dedicated to training and supporting the Afghan army and police. Added to the 32,000 troops already in country, the increase brought American troop levels to 53,000.\",\n    \"The administration began exploring a more robust strategy for Afghanistan by instituting a second review, even as General Stanley A. McChrystal, who was chosen specifically to oversee the future campaign, replaced General McKiernan. McChrystal took charge less than eighty days after Obama’s 27 March address. The incoming commander had experience in both Iraq and Afghanistan, albeit mostly from the perspective of a Special Operations commander focused on counterterrorism. Under pressure to craft an innovative approach, McChrystal began his tenure with a review of the overall situation that was designed to guide the development of a new path forward. The assessment led to a draft campaign plan, which borrowed considerably from recent developments in Iraq. To fully resource his preferred counterinsurgency approach, McChrystal called for a significant increase in American troop strength in Afghanistan over and above the 21,000 recently dispatched soldiers.\",\n    \"General McChrystal’s assessment reinforced the White House’s belief that additional troops in Afghanistan could be employed best by conducting population-centric counterinsurgency. Reasoning that the Taliban’s growing momentum came out of its efforts to coerce support from the Afghan people, McChrystal wanted to employ U.S. and coalition forces to build support for the Kabul government by protecting the people from the enemy’s depredations. The move toward elevating population-centric counterinsurgency over all other doctrines soon gained strong support at the highest levels of the U.S.-dominated ISAF command structure. Pointing to its success in Iraq, proponents of that particular approach failed to realize that far different conditions existed in Afghanistan. The most fundamental and marked difference was the fact that in Afghanistan the enemy was not concentrated large population centers. In addition, the counterinsurgency methods advocated by McChrystal were based on U.S. doctrine, which not all coalition partners accepted or were prepared to employ. Several NATO nations rejected the terminology favored by Americans, because it called to mind the brutal counterguerrilla tactics their militaries used to counter colonial independence movements following World War II. These nations did not want to appear to be involved in similar operations again. Other European countries, such as the United Kingdom, were more willing to participate in counterinsurgency activities. Whatever the case, each troop-contributing nation chose to interpret counterinsurgency through its own historical lens rather than through that of American doctrine.\",\n    \"After numerous planning sessions over the summer and fall months, which strained relations between the White House and the Pentagon,  President Obama delivered a speech in December 2009 outlining his administration’s intended approach to the war in Afghanistan. He reminded listeners that the highest strategic priority would continue to be to dismantle, degrade, and destroy al-Qaeda, because that organization alone had the willpower and capability to carry the war to the American homeland. Obama then elaborated on three key objectives necessary to deny al-Qaeda safe haven in Afghanistan: the implementation of a military strategy over the next eighteen months that included a surge of 30,000 American troops—along with an additional 10,000 from NATO members—to break the Taliban’s momentum and increase Kabul’s security capabilities, greater use of civilian expertise to help Afghan officials learn how to use improved security capabilities effectively, and American recognition that Afghanistan’s path forward would be linked inextricably to Pakistan.\",\n    \"President Obama announced the surge with a timetable; the United States would begin to redeploy these troops from Afghanistan by June 2011. He intended to send the message to both the Afghan government and the DoD that increased resources came with an expiration date that required them to be used to effect within a certain period. The president decided to combine intensive combat operations with an expanded train-and-equip mission for eighteen months, followed by a drawdown as Afghan forces took responsibility for their own security. Critics both inside and outside of the defense establishment were frustrated by the public disclosure of the timeline, claiming that it signaled that the enemy need only hold out during the troop increase. Meanwhile, Obama’s military commanders assured him they could do the mission in the time stipulated.\",\n    \"Although the main thrust of contemporary criticism focused on the timetable, the decision to prioritize population-centric counterinsurgency while conducting high-tempo surge operations (designed to buy time for security force assistance efforts) deserved more analysis and consideration than it received at the time. Even with the urgent need to prepare Afghanistan for its own governance and defense as soon as possible, population-centric counterinsurgency called for sustained patience, thoroughness, and far more military personnel. However, the Obama administration made it clear that while it was willing to authorize a significant increase in boots on the ground, it would not accept an open-ended commitment in a war that had already lasted nearly a decade. The opening moves of the surge did not focus exclusively on large population centers; rather, ISAF emphasized clearing and securing terrain around population centers rather than eliminating the threat by attacking enemy enclaves.\",\n    \"When General David H. Petraeus assumed command after McChrystal’s resignation in June 2010, the former CENTCOM commander emphasized the need to protect civilian communities by diminishing or eliminating the insurgents most likely to prey upon innocents. The approach favored by Petraeus proved more successful in the short term because it took into account the time available to conduct operations. Petraeus also understood that ISAF performed best when it dictated when and where combat occurred rather than reacting to enemy attempts to disrupt the build and hold phases of the operation.\",\n    \"The differing interpretations of counterinsurgency espoused by McChrystal and Petraeus created friction among subordinate commanders. Some commanders gravitated toward an approach that stressed persuading the population to switch allegiances to the central government by cordoning off urban centers from predatory insurgents. McChrystal’s emphasis on reducing civilian casualties and empowering Karzai’s government captured the interest and imagination of outside audiences much more readily than more aggressive methods. At the same time, his restrained operational approach frustrated many of the troops on the ground, who felt constrained in their ability to take the fight to the enemy. Petraeus, who had considerable familiarity with population-centric counterinsurgency, realized that cordoning off urban centers merely allowed the enemy to relocate to areas where coalition forces were not deployed to continue intimidating the population. Commanders who relied on theory and doctrine rather than first-hand surge experience were more liable to elevate protecting the populace over other considerations, while those intimately familiar with the surge in Iraq preferred the more kinetic approach that had been successful in that environment. Even with these highly publicized tensions over the best methods to achieve strategic goals, the more fundamental problem of this disconnect was that it interrupted continuity of effort during a limited-duration campaign.\",\n    \"The new strategy espoused by the Obama administration also ushered in a holistic approach to security assistance. It discarded the  metrics that the DoD had devised in 2002: quality now took precedence over quantity. Rather than turning out tens of thousands of Afghan junior-level personnel in advance of turning over security responsibilities, the Americans and their NATO allies focused on crafting a solid foundation for the existing force structure. For the first time in eight years, American advisers undertook a comprehensive inventory of the equipment and weapons issued to Afghan security forces, allowing them to redistribute items as necessary and reestablish property accountability. Afghan recruits were taught to read and write in order to help them absorb the training methods used by ISAF. Afghan commanders increasingly planned and executed major operations with minimal outside assistance while their staffs coordinated logistics and other types of support. More assistance was focused on developing ministerial-level competency, especially in the defense and interior ministries. However, even with this reinvigorated advisory effort, senior ISAF leaders acknowledged it would take time for Afghan self-reliance to achieve the desired results.\",\n    \"Both McChrystal and Petraeus recognized that dismantling, degrading, and destroying al-Qaeda required both coalition and Pakistani conventional forces working with SOF in conjunction with drone strikes. Coalition conventional forces had responsibility for reversing the Taliban’s momentum and buying time for Afghan security forces to become self-sufficient, with assistance from SOF and their indigenous counterparts, who were tasked with striking high-value enemy leadership targets whenever intelligence sources identified their location. The mission of reducing enemy enclaves within southern and eastern Afghanistan fell to conventional forces that had the necessary combat power and fire support. Enhancing the quality and staying power of Afghan security forces required a mix of conventional and Special Operations participation, with the former outnumbering the latter simply because far more conventional indigenous units existed than Afghan Special Operations units.\",\n    \"Major changes, although trending in different directions in some instances, took place within American- and ISAF-sponsored nation-building programs. The mandate and scope of Provincial Reconstruction Teams evolved in response to the focus on transferring responsibilities to Afghan authorities. Many U.S. government civilians taking part in the Afghan surge were assigned to Afghan national ministries rather than filling long-standing shortfalls on Provincial Reconstruction Teams. Though a number of incoming U.S. civilians received reconstruction-related responsibilities, in many instances they were made part of newly created District Support Teams. Provincial Reconstruction Teams were able to support the increased operational tempo during the surge, but their days were numbered as the senior Afghan cabinet ministers and interior ministry officials made it clear they viewed Western reconstruction teams as shadow entities that undermined Kabul’s authority.\",\n    \"The ultimate outcome of the Afghan surge never depended on taking a softer or harder approach to counterinsurgency. Development and reconstruction projects demonstrated ISAF’s good intentions, but they could not forge stronger ties between the populace and central government if the latter proved unwilling or incapable of matching international efforts. Any success attributable to the surge was because U.S. forces and their coalition partners removed more enemy from the battlefield than ever before. In the vacuum created by this removal, enough ANSF were fielded to enable the Afghans to take the lead in security missions. Nonetheless, the creation of additional army and police units was only one aspect of the overall counterinsurgency effort. It was not a guarantee of either a positive long-term outcome or a seamless handover of security and governance to the Government of the Islamic Republic of Afghanistan.\",\n    \"${Retrograde and Transition}{bold}\",\n    \"The strategy chosen by the Obama administration succeeded in building Afghan security capacity and rolling back the Taliban.  Beginning in 2011 and lasting for the remainder of ENDURING FREEDOM, U.S. commanders focused on building upon the surge’s gains while tackling the massive challenge of withdrawing more than a decade’s worth of equipment and materiel. The retrograde mission in Afghanistan was a far more formidable task for logisticians than it had been in Desert storm or IRAQI FREEDOM. Both of those conflicts had robust ground routes of communication leading to seaports or airfields. The few available ground routes in Afghanistan, by contrast, were underdeveloped and far more susceptible to enemy interdiction or interference by neighboring states. When the surge recovery began in June 2011, the Army faced five major challenges: reducing the operational footprint, materiel stocks, and overall number of personnel to levels acceptable to the Afghans; handing over security responsibilities to the Kabul government in accordance with approved timetables; transferring selected installations, supply stockpiles, and weapons to Afghan security forces; providing effective security assistance to Afghan forces in order to better prepare them to assume leading roles in securing their nation; and ensuring the post–December 2014 residual force could accomplish its mission while conforming to footprint limitations and personnel ceilings.\",\n    \"During the retrograde and transition period, U.S. and ISAF forces continued to conduct combat operations, maintaining pressure on the enemy as coalition troops departed in order to prevent the Taliban and other opposition groups from achieving tactical successes and information operations victories. The collateral effects of the Afghan surge gave Afghan soldiers and police enough time to transition into security leadership throughout the country and prove resilient enough to support those efforts. In an attempt to maintain relevance in Afghanistan, while recuperating from the effects of the surge, the Taliban persuaded its allies to launch attacks against ISAF installations in order to gain propaganda victories. With the sole exception of the assault on Camp Bastion in September 2012, the Taliban’s attempts to penetrate major ISAF bases ended in complete failure. The constantly changing operational dynamic of ENDURING FREEDOM evolved yet again in the final stages of the campaign. As the number of conventional coalition forces focusing on security assistance and retrograde continued to decrease, SOF received a larger share of the tactical fight even as their own security assistance responsibilities grew. Conventional American maneuver units concentrated on training the Afghan army and police, and U.S. SOF invested time and effort in their Afghan counterparts while overseeing the creation of tribal-based militias for local defense. With growing requirements being levied on Special Operations units, integration between those organizations and conventional forces became more important. Innovative solutions to offset resource shortfalls became commonplace, with conventional battalions functioning as the controlling headquarters for Special Operations task forces on several occasions. The organizations involved in nation building experienced a drawdown similar to the conventional forces, as Provincial Reconstruction Teams were deactivated and their responsibilities were turned over to Afghan district and provincial governments.\",\n    \"The most visible threat to the retrograde came not from the Taliban and other opposition groups, but from the Pakistani government. Although Pakistan had consistently expressed its willingness to cooperate with the United States since the September 11th attacks, Islamabad’s actions during the retrograde and transition phases of the campaign reflected a combination of the fragmented nature of the Pakistani government, public frustration fed by the shooting deaths of two Pakistanis by an alleged CIA operative, and lingering fallout from the Osama bin Laden raid. The Pakistanis closed the primary ISAF southern logistics route, threatened to shoot down drones transiting their airspace without authorization, and expelled U.S. personnel from Shamsi Air Base following the November 2011 border post incident in Salala. However, Pakistani officials miscalculated the effect of their retaliatory actions as ISAF weathered the disruption for almost eight months with little discernable impact. That realization, coupled with changes within the Pakistani political leadership, led to Islamabad lifting the closure after Secretary of State Hillary R. Clinton issued a formal apology in July 2012.\",\n    \"The shutdown did not achieve Islamabad’s goals because many U.S. and ISAF units deploying to Afghanistan during this period were tailored to provide security assistance to the Afghan military and police, rather than to conduct combat operations. Many incoming units left their assigned equipment at home station when deploying, and when they arrived in Afghanistan they received whatever equipment they required from in-country stocks. Commanders in theater could continue to downsize stockpiles in Afghanistan because brigades assigned to security assistance did not need much of the equipment issued to conventionally organized maneuver units. In addition, significant amounts of materiel could be turned over to Afghan forces as the security assistance forces completed their deployments. This dynamic ensured that Army units had the right equipment for their primary mission of training their Afghan counterparts, and that this equipment could be transferred to indigenous security forces and reduce the logistics burden of shipping out or disposing of stockpiles.\",\n    \"Continuing instances of green-on-blue incidents, in which Afghan security forces killed or wounded coalition personnel, remained a significant impediment to U.S. and ISAF assistance efforts. This tactic was the Taliban’s most effective weapon during the post-surge period. Although the actual numbers of casualties were low in comparison to the overall number of foreign troops in Afghanistan, the countermeasures adopted by ISAF did not eliminate the dangers that U.S. and coalition soldiers faced in providing security assistance to Afghan units. Consequently, U.S. advisers were under further restrictions during the retrograde and transition phases of the campaign; for instance, they were forbidden from accompanying conventional Afghan units on tactical operations. The restrictions increased after the death of an American general at the hands of an Afghan soldier, resulting in U.S. advisers being withdrawn from all Afghan units below corps level.\",\n    \"Despite the tremendous friction and distrust created by green-on-blue incidents, the training of the ANSF made remarkable progress, reaching its target strength of 352,000 by September 2012, two months ahead of schedule. Success was not measured in mere numbers, as Afghan forces repeatedly proved capable of taking the fight to the enemy after assuming responsibility for key areas following the withdrawal of ISAF troops. These developments allowed President Obama to execute the final portion of the strategy he approved in 2009 as Afghan security forces assumed the lead for combat operations in June 2013 and both the ISAF and U.S. missions officially ended in December 2014.\",\n    \"At the conclusion of Operation ENDURING FREEDOM, the White House left 9,800 troops in Afghanistan to support the new NATO-led advisory mission, Operation RESOLUTE SUPPORT, and to carry out Operation FREEDOM’S SENTINEL, the counterterrorism mission against the remnants of al-Qaeda. At the time, President Obama planned to cut that number in half by 2016, and draw down to an embassy presence by 2017. However, faced with strong opposition from ISAF and Afghan leaders, the administration agreed to keep more troops in place. In announcing this decision, President Obama reasoned that he could “not allow Afghanistan to be used as a safe haven for terrorists to attack our nation again.”\",\n    \"${The Campaign in Retrospect}{bold}\",\n    \"Operation ENDURING FREEDOM began on uncertain footing because key decision makers misread the lessons of recent conflicts. To avoid placing American infantry directly in harm’s way, proponents of transformation and politicians alike preferred to achieve battlefield success using indigenous fighters aided by Special Forces advisers calling in precision airstrikes. With airpower, special operators, and proxies forming the centerpiece of an unproven warfighting arsenal, the United States embarked on the opening campaign of the Global War on Terrorism. Although that unique combination was successful, it disbanded in the wake of its initial triumph, never to be reassembled as originally organized. American foot soldiers were then substituted for absent battlefield proxies until an equivalent indigenous force could be fielded.\",\n    \"Premature thoughts of victory, sparked in part by the unexpected manner in which the campaign unfolded, coupled with the rapid refocusing of the Global War on Terrorism’s main effort to Iraq, placed the conflict in Afghanistan on a shaky foundation. American military and political leaders, convinced that they had adequate situational awareness based upon information derived from technological superiority, did not realize that this technology had lulled them into a false sense of confidence. For example, it was relatively simple to use space and aerial platforms to identify terrorist camps and Taliban military bases. Drones also allowed U.S. forces to track Taliban and al-Qaeda leaders in real time. Decision-makers therefore equated the scarcity of information available after the toppling of the Taliban to the absence of a viable threat.\",\n    \"Yet even after arriving at that determination, the United States did not seek to learn as much as possible about the liberated Afghans or the future intentions of the Taliban and neighboring Pakistan in order to invest resources judiciously and achieve the campaign’s desired end state of a stable, democratic Afghanistan. The Bush administration felt that the rapid victory in Afghanistan permitted national attention and resources to be redirected against Iraq or other efforts, and for several years they were content to absorb information filtered second-hand through proxies, allies, international organizations, Afghan officials, and warlords. The resulting lack of insight reinforced erroneous decisions made early in the campaign while obscuring the dire need for significant changes. The Army—particularly the intelligence community—appeared surprisingly reluctant to enhance its own knowledge of the inner workings of Afghan society and politics, leaving it to the DoD to institute the AfPak Hands program in September 2009 to build its institutional understanding of the region.\",\n    \"This reluctance to learn more about post–Taliban Afghanistan was compounded by the lack of expertise in wartime security assistance. The metrics-based approach adopted for developing indigenous security forces guaranteed neither rapid progress nor an acceptable measure of combat effectiveness, which in turn required U.S. troops to absorb more security-related responsibilities. As a result, the Afghan military was not prepared to deal with a resurgent Taliban in 2006, and the Afghan police forces were even further behind. Additional coalition troops had to be deployed to create the environment necessary to build up indigenous security forces. Nonetheless, when a new strategic approach dictated the need to generate large numbers of indigenous security forces in a short timeframe, the DoD demonstrated it willingness to accomplish that mission while using the Army as its primary agent.\",\n    \"Although the course of Operation ENDURING FREEDOM supports Army Maj. Gen. Herbert R. McMaster’s observation that the United States cannot rely on proxies and partners to achieve objectives of vital national interest, the 2001 decision to do so came from an incongruous mix of caution fostered by the Soviet experience and eagerness to test untried warfighting methods advocated by the DoD. In the same vein, inaccurate perceptions or lack of knowledge also led to the U.S. government relying too much on one component or service. Events in Afghanistan have shown that the U.S. Army, U.S. Marine Corps, and even NATO ISAF cannot accomplish the entire mission unaided. The myriad responsibilities of a protracted campaign offer a strong argument for integrating the capabilities of U.S., allied, and indigenous organizations while simultaneously encouraging further coordination between Special Operations and conventional communities. Other government agencies and international organizations also had to participate in building the Afghan governing capacity, and so all components involved had to understand what capabilities each could bring to the table.\",\n    \"Since the fall of 2001, all interested parties in the region had been planning for the day when America would leave. Yet the United States  itself upset these calculations by remaining in Afghanistan far longer than anyone had anticipated. As time passed, the Bush and Obama administrations made critical decisions that altered the trajectory of those initial calculations on three occasions: first by invading Iraq, second by encouraging NATO to take over the UN-mandated ISAF mission, and third by announcing the surge in conjunction with a withdrawal date. These decisions encouraged Pakistan to hedge its strategic position by continuing to support the Taliban even as it backed efforts to eliminate al-Qaeda and convinced the enemy that he could wait out the United States. Put another way, these three key moments prevented the United States from persuading the enemy that he was defeated. Then again, both the enemy and regional powers miscalculated American intentions.\",\n    \"A final point of discussion on the Army’s involvement in Operation ENDURING FREEDOM concerns the conceptual framework of the campaign. Policymakers routinely displayed a lack of knowledge of Afghanistan, its people, and regional power dynamics. In some cases, political considerations restricted military operations. This was the case with Pakistan throughout the campaign, as Washington officials never reached an accord with their counterparts in Islamabad. A learning curve emerged over time, leading the Obama administration to make the pragmatic choice of transferring responsibility to the Afghans while limiting American participation to counterterrorism operations against al-Qaeda and aiding indigenous allies. Knowledge naturally comes with time, but the United States—including its military leaders—cannot afford, now or in the future, to permit years to elapse before grasping the basic dynamics of a conflict, as was the case in Afghanistan.\",\n    \"${Upon Reflection}{bold}\",\n    \"A closing assessment remains to be made of the U.S. Army’s experience in Operation ENDURING FREEDOM. The fight in Afghanistan began in fall 2001 and continues, as of the time of this writing, under the banner of RESOLUTE SUPPORT. The conflict tested the U.S. Army in ways unimaginable to most soldiers who rolled across the burning Kuwaiti desert in a steel-tipped wave or stood for decades in the Fulda Gap awaiting a Soviet juggernaut that never materialized. Although technology has given the Army a crucial edge in many ways, American soldiers have prevailed time and again in the most elemental form of combat where individuals and not machines count. The Korangal or Arghandab Valleys would seem familiar to veterans who fought at Dak To in Vietnam or atop the shell-torn heights of Pork Chop Hill in Korea. While the soldiers in Korea, Vietnam, and Afghanistan wore different uniforms and carried different weapons, the same shoulder insignia is seen in photographs of each conflict, providing a timeless and compelling reminder that experiences transcend battlefields. To that end, the authors of this study offer eight key lessons from Operation ENDURING FREEDOM.\",\n    \"The first is a reminder that political and military leaders must ensure that sufficient resources are allocated to meet strategic objectives. Put another way, there must be alignment between ends, ways, and means. Overcommitting resources, whether it be personnel, treasure, or time, puts unnecessary pressure on military forces and their families. At the same time, insufficiently resourcing a conflict, as was so often the case in Afghanistan, opens up the nation to the possibility of strategic failure. It erodes morale and sacrifices tactical and operational successes and achievements due to an inability to build upon progress at the strategic level.\",\n    \"This leads directly into the second lesson that innovation and agility are vital components of the armed forces. In an environment where military leaders do not necessarily control resources or mission objectives, they must be able to utilize to the best of their ability the resources they have to complete their assigned mission. The Army cannot be overly tied to current doctrine, force structure, or military operational specialties. Whether it be SOF units riding into combat on horseback, support and service support personnel operating as maneuver forces, or combat troops managing nation-building projects, the Army must remain flexible enough to adapt to the demands of modern war. The war in Afghanistan provides abundant examples of the value of innovation, as U.S. soldiers trained to fight outnumbered and win against a massed enemy—equipped with armor and supported by artillery and airpower—adapted to the combat environment of the rugged Afghan mountains, where often soldiers had nothing more than what they could carry on their backs.\",\n    \"That being said, the third lesson is that initiatives to transform force structure and design should only be undertaken during wartime when necessitated by mission requirements. Though the transformation efforts championed at the DoD could have positive effects in the post–Global War on Terrorism era, many of these same efforts impeded current operations in Afghanistan. A prime example is the opening salvo of the war utilizing smart bombs with limited soldiers on the ground. While the “Shock and Awe” method was successful in scattering al-Qaeda and Taliban forces, the approach had no chance to secure and stabilize Afghanistan afterward. Modularity had the opposite effect during operations in Iraq and Afghanistan, constituting the most significant force design initiative since the Pentomic Division efforts of the late 1950s. Although the modularity initiative caused disruption within the Army, without it the Army could not have fulfilled the combat unit requirements necessary in both countries while also servicing missions around the globe.\",\n    \"Fourth, although some organizations have impressive capabilities, it is unrealistic to expect them to dominate a combat environment in all cases and under all circumstances. Even though the opening phase of ENDURING FREEDOM featured a dazzling display of American airpower, achievements on a comparable scale have not been repeated since. Airpower had a central role in the conflict’s opening months, but over the remaining thirteen years it served as a combat multiplier for American foot soldiers striving to engage with and destroy the enemy. That evolution reflects the enemy’s ability to learn and adapt. Whether they employ sophisticated technology or drape burlap bags over themselves to eliminate thermal signatures, thinking enemies invariably find ways to render the deadliest of weapons far less effective.\",\n    \"The same point applies to the employment of each of the branches of the U.S. Army. SOF, for example, have demonstrated that the individuals in their ranks are among the best-trained, best-equipped, and best-led soldiers in the world. In some ways, Afghanistan has provided an optimal battlefield for these warriors to demonstrate unique skills. Yet the high tempo and tension associated with back-to-back deployments result in unsustainable burdens being placed on these soldiers. In addition, although Special Operations units have unparalleled flexibility, they are not self-sustaining entities over extended periods or under specific circumstances. The necessity for close cooperation between communities was made clear repeatedly during ENDURING FREEDOM when infantrymen, fire supporters, logisticians, and planners from conventional units provided the edge needed by Special Operations personnel to accomplish an assigned mission in the most efficient manner possible.\",\n    \"The fifth lesson from Operation ENDURING FREEDOM is the critical importance of maintaining unity of command and unity of effort, especially in a coalition fight. Over the first four years of the conflict, the United States sought the appropriate operational approach in Afghanistan, shifting from counterterrorism to a limited counterinsurgency effort. When NATO began expanding the ISAF mission in 2005, it anticipated engaging in peacekeeping rather than sustained combat operations. The Army responded by effectively splitting its missions between counterinsurgency under ISAF and counterterrorism under ENDURING FREEDOM. This division included separate American command chains, with the former falling under NATO and the latter continuing under CENTCOM. Although General McNeill tied the American efforts together through his position as ISAF commander, some disconnects persisted within the Army’s operations and between American forces and their NATO allies. It was not until the establishment of USFOR-A under General McKiernan that the coalition effort achieved unity of command. Unity of effort, however, continued to be an issue as national caveats and political concerns resulted in inconsistent capabilities among NATO forces. Even within American operations, the creation of RC Southwest to facilitate the deployment of additional U.S. Marine Corps units unnecessarily disrupted and fragmented American operations. This resulted in an inconsistent effort by NATO forces, enabling the insurgents to take advantage of inefficiencies within the coalition. It is not known whether utilizing a unified command chain and a unified effort from the beginning would have made an appreciable impact on the conflict, but the lack of both aspects created unnecessary and self-inflicted difficulties for the coalition.\",\n    \"Sixth, Afghanistan offers clear evidence of the outsized impact that information operations can have on a conflict. The modern 24-hour news cycle, the prevalence of social media, and competition to dominate the conflict’s strategic narrative placed increased importance on events that were often of limited tactical or operational significance. The American “kill team” controversy, the insurgent attack at Wanat in 2008, and the burning of Qurans at Bagram in 2012 are all examples of small-scale events having significant operational and strategic impacts. They also illustrate the reality that in a persuasion campaign, one negative act can outweigh a hundred positive ones. The high-visibility attacks on Forward Operating Base SALERNO and Camp Bastion, intended primarily to generate news coverage, demonstrates that our foes are equally aware of the influence of mass media and even willing to expend personnel during operations of transitory value in order to gain advantage in that medium.\",\n    \"It should be recognized that the insurgents routinely displayed superiority in communicating with the Afghan people over the course of ENDURING FREEDOM. For all the Army’s efforts to build support for the central government and the coalition among the Afghan people, it could never match the insurgents’ ability to reach them. One problem was that turnover among coalition forces due to force rotations limited their ability to build lasting relationships with locals. The coalition also struggled by failing to make connections with local religious leaders. As in many majority-Muslim countries, mosques were a central element of Afghan communities. The coalition’s inability to establish a presence within the mosques, either directly or through relationships with the mullahs, cut the coalition off from a fundamental element of public discourse.\",\n    \"Most importantly, the coalition had no counterpoint to the simple fact that the threat of violence is more persuasive than the promise of communal betterment, especially when the former arises from within the permanent community whereas foreigners with transient local ties are linked with the latter. Despite its best intentions, the coalition would not remain in Afghanistan indefinitely, whereas the insurgents would. The Army, therefore, must improve its ability to work with indigenous actors to build genuine support among the population, with the understanding that those individuals would remain after the Americans depart.\",\n    \"The penultimate lesson of Operation ENDURING FREEDOM is that without security, there can be no stability. The overthrow of the Taliban government— while key to the American strategic objective of removing safe havens for international terrorists—left a security vacuum throughout Afghanistan. Warlords and militias proved unreliable substitutes for security forces controlled by an elected centralized authority. Neither the Afghan National Army nor the Afghan National Police existed, and it would take time and resources to establish them. Debates over the appropriateness and viability of nation building as a national strategy cannot afford to overlook that the agent for change responsible for removing a national government from power assumes responsibility for providing services to the affected population until a new government can be formed. The absence of a viable plan, or the resources to carry it out, will destabilize the affected society. While the Army cannot create security forces without active indigenous support and supplemental funding over a sustained period, it must take steps to maintain the knowledge base necessary to accomplish that mission in the future.\",\n    {\n      \"picture\": {\n        \"source\": \"/figures/v2/img_14-1.png\",\n        \"caption\": \"A  Soldier watches over the Arghandab River Valley\"\n      }\n    },\n    \"Finally, the U.S. Army’s experience in Afghanistan reinforces the maxim that war is a marathon and not a sprint. History is  replete with examples of politicians choosing to resolve national problems through conflict because they honestly believed that war would be a brief and ultimately successful endeavor—but the truth often has turned out differently. It is likely that few within the Army’s senior leadership shortly after 11 September 2001 would have predicted that Operation ENDURING FREEDOM would not end until 31 December 2014, and that it would continue even after that in some form under RESOLUTE SUPPORT. Few could have forecasted that the soldiers fighting in Afghanistan would be taking part in a second major effort in Iraq from 2003 through 2010 or, a few years later, in the battle against the so-called Islamic State. The enemy in each instance was not only tenacious but also tactically and operationally adaptive. Each war evolved to the point at which tactics, techniques, and procedures used by American troops near the end of the conflicts bore scant resemblance to those employed in opening battles. Policymakers and senior uniformed leaders alike would do well to remember what recent history has shown: what appears to be a decisive victory could merely be the start of a new and unpredictable kind of conflict. Leaders must clearly articulate the end state, provide the means to achieve that end state, and approve the ways in which it will be achieved—or risk repeating a protracted campaign.\",\n    {\n      \"picture\": {\n        \"source\": \"/figures/v2/art_14-2.png\",\n        \"caption\": \"Comms Across the Valley\"\n      }\n    }\n  ],\n  \"appendix a\": [\n    {\n      \"title\": \"Bibliographical Note\"\n    },\n    \"\",\n    {\n      \"title\": \"Documents and Publications\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The sources for this account by the Chief of Staff of the Army’s Operation Enduring Freedom Study Group were campaign plans, daily update briefings, and monthly and weekly reports compiled or composed before, during, and immediately after many of the events described in this account. They were collected in Afghanistan, from CENTCOM files at MacDill Air Force Base in Tampa, Florida, and from archival sources available at the U.S. Army Center of Military History at Fort McNair, D.C. Those caches of electronic documents—virtually all of which remain classified—were created by the headquarters overseeing the operations discussed in this narrative. These include CJTFs Mountain, 76, 82, 101, and 180; RC East, RC South, and RC Southwest; TF Phoenix; Office of Military Cooperation–Afghanistan and Office of Security Cooperation–Afghanistan; CFC-A; CSTC–A; and USFOR–A. Operational records from upper-echelon headquarters outside of Afghanistan, such as CENTCOM at MacDill Air Force Base; CFLCC at Camp Doha, Kuwait; and Southern European Task Force at Vicenza, Italy, also were useful sources of information.\",\n        \"Much of the documentation required to write about events happening after 2006 was generated by NATO ISAF and its subordinate commands. However, these records are classified by both U.S. and NATO sources. As a result, few of the NATO records were used because of the lengthy procedures required to declassify NATO material. Even more restrictive measures are in place in regards to the release of information on Special Operations activities after the March 2002 timeframe. However, there are a few online avenues for researchers to access formerly classified materials, including George Washington University’s National Security Archive and the CENTCOM Freedom of Information Act Web page. The U.S. material provides strategic level planning, diplomatic, and policy-making documents generated by the Departments of Defense and State, while material found on the latter site is devoted to declassified reports and investigations covering critical events involving U.S. forces in Afghanistan.\",\n        \"Useful unclassified accounts of Operation Enduring Freedom and the events leading up to that conflict include  retired Brig. Gen. John S. Brown’s ${Kevlar Legions: The Transformation of the U}{italic}.${S}{italic}. ${Army, 1989–2005}{italic} as well as two books by the U.S. Army Combat Studies Institute: ${A Different Kind of War: The United States Army in Operation Enduring Freedom}{italic},  October 2001 – September 2005 and ${Weapon of Choice: ARSOF in Afghanistan}{italic}. The material in ${Weapon of Choice}{italic} is amplified by the United States  Special Operations Command’s unclassified ${United States Special Operations Command History 1987–2007}{italic}. In addition to these unclassified  published accounts, primary source materials used to examine the conflict’s impact on the Army as an institution were collected from various staff sections of the  Headquarters, Department of the Army; the National Guard Bureau; Office of the Chief of Army Reserve; U.S. Army TRADOC at Fort Eustis, Virginia; U.S. Army Combined  Arms Center at Fort Leavenworth, Kansas; and U.S. Army Corps of Engineers headquarters in Washington, D.C.\",\n        \"A number of memoirs dealing with events leading up to the events of 11 September 2001 and the American reaction  to the terrorist attacks were consulted. While these accounts often provided a detailed, first-hand perspective of decisions made by senior policymakers and  commanders, in some cases they presented differing interpretations of events that required deconfliction by the Study Group. Useful accounts of events leading up to  the attacks and the U.S. response include CIA director George J. Tenet’s ${At the Center of the Storm: My Years at the CIA}{italic}, Chairman of the Joint Chiefs of  Staff General H. Hugh Shelton’s ${Without Hesitation: The Odyssey of an American Warrior}{italic}, CENTCOM commander General Tommy R. Franks’ ${American Soldier}{italic},  DoD policymaker Douglas J. Feith’s ${War and Decision: Inside the Pentagon at the Dawn of the War on Terrorism}{italic}, and former Secretary of  Defense Donald H. Rumsfeld’s ${Known and Unknown: A Memoir}{italic}. For the post-2002 timeframe, the Study Group utilized Chairman of the  Joint Chiefs of Staff General Richard B. Myers’ ${Eyes on the Horizon: Serving on the Front Lines of National Security}{italic}, Secretary of Defense  Robert M. Gates’ ${Duty: Memoirs of a Secretary at War}{italic}, as well as autobiographies of ISAF commanders, including General Sir David J. Richards’  ${Taking Command}{italic} and General Stanley A. McChrystal’s ${My Share of the Task: A Memoir}{italic}.\",\n        \"In addition to the recollections of senior officials and military officers, American and British soldiers have written  a number of eyewitness accounts that convey a human perspective often invisible to operational and strategic  level participants. These include Robert S. Anders’ ${Winning Paktika: Counterinsurgency in Afghanistan}{italic},  Doug Beattie’s ${Task Force Helmand: A Soldier’s Story of Life, Death and Combat on the Afghan Front Line}{italic},  Jimmy Blackmon’s ${Pale Horse: Hunting Terrorists and Commanding Heroes with the 101st Airborne Division}{italic},  Ronald Fry’s ${Hammerhead Six: How Green Berets Waged an Unconventional War Against the Taliban to Win in Afghanistan’s Deadly Pech Valley}{italic}, Carter Malkasian’s incomparable ${War Comes to Garmser: Thirty Years of Conflict on the Afghan Frontier}{italic},  Dakota Meyer’s ${Into the Fire: A Firsthand Account of the Most Extraordinary Battle in the Afghan War}{italic},  Sean Parnell’s ${Outlaw Platoon: Heroes, Renegades, Infidels, and the Brotherhood of War in Afghanistan}{italic},  Clinton Romesha’s ${Red Platoon: A True Story of American Valor}{italic}, and Stuart Tootal’s ${Danger Close: Commanding 3 Para in Afghanistan}{italic}\"\n      ]\n    },\n    {\n      \"title\": \"Oral History Interviews and Manuscript Sources\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"The OEF Study Group’s efforts to interview various notables for the project proved very productive due to the tremendous cooperation it received from virtually everyone contacted. While the roster of prominent civilian officials and military officers—both American and allied—who agreed to be interviewed is too lengthy to list in its entirety, the Study Group gratefully acknowledges President George W. Bush, Vice President Richard B. “Dick” Cheney, Secretaries of Defense Robert M. Gates, Leon E. Panetta, and Charles T. “Chuck” Hagel; CENTCOM commanders Tommy R. Franks, John P. Abizaid, David H. Petraeus, and Lloyd J. Austin III; Ambassadors Ronald E. Neumann, Zalmay Khalilzad, Karl W. Eikenberry, William B. Wood, and Robert P. J. Finn; ISAF commanders Dan K. McNeill, David D. McKiernan, and Stanley A. McChrystal; RC East commanders James J. Schlosser and Curtis M. Scaparrotti; RC South commanders British General Sir Nicholas P. Carter and Dutch Lt. Gen. Mart De Kruif; senior Marine commanders Lt. Gen. Lawrence D. Nicholson and Lt. Gen. Richard P. Mills; and Washington Post reporter Bob Woodward, who provided key insights into the Obama White House. Many other individuals not listed here kindly consented to being interviewed and for that courtesy the Study Group is profoundly grateful.\",\n        \"The authors also made use of unpublished first-person accounts written to satisfy academic requirements in U.S. Army professional development courses. Most prominent were Personal Experience Papers by students attending the Maneuver Captains Career Course at Fort Benning, Georgia’s Maneuver Center of Excellence. Several hundred of these accounts have been declassified and posted on Army Knowledge Online and the Fort Benning Donovan Research Library Web site. Similar narratives utilized by the Study Group included those authored by senior noncommissioned officers attending the U.S. Army Sergeant Majors Academy at Fort Bliss, Texas, available online via the U.S. Army Command and General Staff College’s Ike Skelton Combined Arms Research Library digital collection. That same collection contains Afghanistan-related interviews conducted by Combat Studies Institute historians for the Operational Leadership Experience series.\",\n        \"Recognizing the need to capture information on key events soon after they occurred, the U.S. Army deployed a number of Military History Detachments to Afghanistan during the opening phase of Operation Enduring Freedom. Maj. Richard M. Brown’s 130th Military History Detachment and Maj. John Warsinke’s 47th Military History Detachment conducted valuable interviews between March and July 2002. Following the 2001–2002 timeframe, however, most Military History Detachments were deployed to Iraq, and few U.S. Army historians served in Afghanistan between 2003 and 2010. After discovering large gaps in the available Military History Detachment collections, the OEF Study Group conducted a targeted collection effort by compiling multiple terabytes of electronic records from Maj. Gen. John M. Murray’s 3d Infantry Division headquarters at Bagram and General John F. Campbell’s ISAF headquarters in Kabul.\"\n      ]\n    },\n    {\n      \"title\": \"Secondary Sources\",\n      \"level\": 2\n    },\n    {\n      \"section\": [\n        \"Commercially produced accounts augmented or filled gaps in our primary sources. Although the Study Group drew on information from  many publications, several are worth singling out. For a useful general overview, both Peter Tomsen’s  ${The Wars of Afghanistan: Messianic Terrorism, Tribal Conflicts, and the Failures of Great Powers}{italic} and Thomas J. Barfield’s  ${Afghanistan: A Cultural and Political History}{italic} proved informative. Valuable accounts that shed additional light on extremist  influences in the Middle East and Central Asia included not only Barfield and Tomsen, but also  Peter Bergen’s ${The Osama bin Laden I Know: An Oral History of Al-Qaeda’s Leader}{italic}, Mustafa Hamid and  Leah Farrall’s ${The Arabs at War in Afghanistan}{italic}, Ahmed Rashid’s ${Taliban: Militant Islam, Oil and Fundamentalism in Central Asia}{italic},  and Seth G. Jones’ ${Hunting in the Shadows: The Pursuit of al Qa’ida since 9/11.}{italic}\",\n        \"A selection of useful books on U.S. and ISAF conventional units includes Patrick Bishop’s ${3 Para}{italic},  Stephen Grey’s ${Into the Viper’s Nest: Task Force 1 Fury and the Battle of Musa Qala}{italic},  Toby Harnden’s ${Dead Men Risen: The Welsh Guards and the Defining Story of Britain’s War in Afghanistan}{italic},  Col. Bernd Horn’s ${No Lack of Courage: Operation Medusa, Afghanistan}{italic},  Jake Tapper’s ${The Outpost: An Untold Story of American Valor}{italic},  Gregg Zoroya’s ${The Chosen Few: A Company of Paratroopers and Its Heroic Struggle to Survive in the Mountains of Afghanistan}{italic},  Col. Nathan S. Lowrey’s $${U}{italic}.${S}{italic}. ${Marines in Afghanistan 2001–2002: From the Sea}{italic}, and compiler David W. Kummer’s ${U}{italic}.${S}{italic}. ${Marine Corps in Afghanistan, 2001–2009: Anthology and Annotated Bibliography}{italic} and its companion volume by  Paul W. Westermeyer with Christopher Blaker  entitled ${U}{italic}.${S}{italic}. ${Marines in Afghanistan, 2010–2014: Anthology and Annotated Bibliography}{italic}.\",\n        \"There are a similar, if not greater, number of detailed and well-written accounts dealing with special operations in Afghanistan,  notable among which are Eric Blehm’s ${The Only Thing Worth Dying For: How Eleven Green Berets Fought for a New Afghanistan}{italic},  Rusty Bradley and Kevin Maurer’s ${Lions of Kandahar: The Story of a Fight Against All Odds}{italic},  Daniel R. Green’s ${In the Warlords’ Shadow: Special Operations Forces, the Afghans, and Their Fight Against the Taliban}{italic}, Linda Robinson’s exceptional ${One Hundred Victories: Special Ops and the Future of American Warfare}{italic}, and  Mitch Weiss and Kevin Maurer’s ${No Way Out: A Story of Valor in the Mountains of Afghanistan.}{italic}\",\n        \"The OEF Study Group also relied on published accounts of nation building and coalition warfare, both of which are central to the  Afghanistan conflict. A few of the books consulted for reference on these topics include  James F. Dobbins’ ${After the Taliban: Nation-Building in Afghanistan}{italic};  Ahmed Rashid’s ${Descent into Chaos: The U.S. and the Disaster in Pakistan, Afghanistan}, and Central Asia{italic};  and ${Coalition Challenge in Afghanistan: The Politics of Alliance}{italic}, edited by Gale A. Mattox and Stephen M. Grenier.\",\n        \"Think tank papers and government reports frequently contain facts unavailable elsewhere. First and foremost among sources  covering the period from October 2008 onward were Special Inspector General for Afghanistan Reconstruction reports submitted quarterly to Congress. Among private institutions, the Santa Monica, California–based RAND Corporation has produced a number of useful studies of Afghanistan, including Terrence K. Kelley, Nora Bensahel, and Olga Oliker’s ${Security Force Assistance in Afghanistan: Identifying Lessons for Future Efforts}{italic}, Seth G. Jones and Arturo Muñoz’s ${Afghanistan’s Local War: Building Local Defense Forces}{italic}, and C. Christine Fair’s  ${The Counterterror Coalitions: Cooperation with Pakistan and India}{italic}. Many articles and publications by RAND’s competitors—the majority of which are located in Washington, D.C.—not only enlightened OEF Study Group members but also provided valuable insights to senior commanders in Afghanistan. Sources for these pieces include the Center for Strategic and International Studies, the Institute for the Study of War, the Brookings Institution, the Center for a New American Security, and the Foundation for Defense of Democracies. The last named institution also hosts Bill Roggio’s informative ${Long War Journal}{italic} Web site.\",\n        \"Newspapers often can provide historians with perspectives and facts found nowhere else. Useful media sources on events in Afghanistan for the OEF Study Group included the ${Los Angeles Times, New York Times}{italic}, and ${Washington Post}{italic}; the British newspapers the ${Guardian}{italic} and the ${Independent}{italic}; the Pakistani newspaper ${Dawn}{italic}, and ${Agence France-Presse}{italic}. When consulting these sources,  the OEF Study Group members normally compared multiple accounts from various publications before settling on an accepted version of events in order to compensate for inadvertent errors introduced by journalists writing under tight deadlines. This precaution, however, did not have to be used as frequently when consulting pieces by reporters on extended assignment in the region.\"\n      ]\n    }\n  ],\n  \"appendix b\": [\n    {\n      \"title\": \"Operation Enduring Freedom Study Group Biographies\"\n    },\n    \"${Col. (Ret.) Edmund J. “EJ” Degen}{bold}, a career field artillery officer, currently serves as the director of the Chief of Staff,  Army’s Operation Enduring Freedom Study Group. He has commanded artillery units at all levels through brigade, and served as the V Corps (U.S.) chief of plans for the Iraq invasion at the start of Operation Iraqi Freedom, chief of future operations for U.S. Forces Korea, and chief of staff for Combined Joint Interagency Task Force 435 in Afghanistan. Colonel Degen was a fellow on the CSA’s inaugural Strategic Studies Group and served as the Senior Fellow the following year. He has multiple combat deployments to Iraq and Afghanistan. Colonel Degen has an  MMAS (Master of Military Art and Science) from the Army’s School of Advanced Military Studies and an MS in  Strategic and Operational Planning from the Joint Advanced Warfighting School. He is the coauthor of  ${On Point: The United States Army in Operation Iraqi Freedom}{italic} (Annapolis, Md.: Naval Institute Press, 2005),  along with numerous journal articles.\",\n    \"${Col. Adrian A. Donahoe}{bold}, a Special Forces officer, enlisted in the Iowa National Guard in 1987. He was commissioned and entered active-duty service in 1993 after graduating from the University of South Dakota. He completed the Special Forces Qualification Course in 1999 and has served in various command and staff positions within Special Operations and the conventional Army. He is a veteran of Operation Enduring Freedom and multiple Operation Enduring Freedom–Philippines deployments. Colonel Donahoe holds an MS from the Naval Postgraduate School and an MMAS from the School of Advanced Military Studies. He is the former director of Special Operations Leadership Development and Education at Fort Leavenworth, Kansas, and the director of the Commander’s Action Group for NATO Special Operations Component Command-Afghanistan/Special Operations Joint Task Force Afghanistan.\",\n    \"${Col. Bryan R. Gibby}{bold} is the chief of the Military History Division in the Department of History, United States Military Academy,  West Point. A 1993 West Point graduate, he was awarded master’s and doctoral degrees in history from Ohio State University.  Colonel Gibby is a career military intelligence officer and has served in command and staff assignments from tactical to strategic levels. His most recent operational experience was as Commander, 707th Military Intelligence Battalion, providing SIGINT (signals intelligence)  support to the CENTCOM areas of responsibility. He twice deployed in Operation Iraqi Freedom as a brigade (2007–2008) and division (2005–2006) intelligence officer. Following service in Iraq, Colonel Gibby joined Allied Force Command, Madrid, where he served as the chief of intelligence assessments for CJTF Unified Protector in 2011. He is the author of ${The Will to Win: American Military Advisors in Korea, 1946–1953.}{italic}\",\n    \"${Dr. Brian F. Neumann}{bold} is a historian at the U.S. Army Center of Military History. He earned his BA in history from the University of Southern California in 1998 and his MA and PhD in history from Texas A&M University in 2001 and 2006, respectively. His academic field is twentieth-century U.S. military history with a focus on World War I. After teaching for four years, he joined CMH in 2010 and began working in the Contemporary Studies Branch, Histories Division, with a focus on Operation Enduring Freedom. He cowrote and edited the center’s campaign brochure on Operation Enduring Freedom 2002–2005. After working with the CSA’s OEF Study Group for two years, Dr. Neumann became the editor of the “U.S. Army Campaigns of World War One” commemorative pamphlet series in November 2016. He also serves as a member of the CMH World War I Commemoration Committee and as the Center’s World War I subject matter expert.\",\n    \"${Col. Francis J. H. Park}{bold} is a historian in the Joint History and Research Office of the Joint Staff. Prior to his current assignment, he was the chief of the Strategy Development Division in the Joint Staff J-5. After commissioning in 1994, he served in command and staff duties primarily in armored cavalry and light airborne cavalry assignments. Designated an Army strategist in 2004, he has served at division, corps, army service component command, and joint task force levels, as well as in the Army Staff and Joint Staff. His service in Operation Enduring Freedom spans 2008–2009 as principal campaign planner for CJTF 101 and RC East, and 2013–2014 as deputy director, Commander’s Action Group, ISAF. His other combat experience includes Operations Iraqi Freedom and Inherent Resolve. Colonel Park holds a BA in history from the Johns Hopkins University; an MA in international relations from St. Mary’s University of San Antonio, Texas; an MMAS from the School of Advanced Military Studies; and a PhD in history from the University of Kansas.\",\n    \"${Mr. Mark J. Reardon}{bold} is a senior civilian historian with the U.S. Army Center of Military History. Before joining the Center in 2006, he served as a regular officer in parachute, reconnaissance, and armor units during a twenty-seven-year career in the Army, and retired as a lieutenant colonel. Mr. Reardon, who recently completed a manuscript for the Center on training the post– Saddam Iraqi Army, has also published four books on World War II and Korea, a history of the initial Stryker Brigade deployment to Iraq, several detailed studies of small-unit actions in Iraq, and three studies on U.S. military innovation in World War II.\",\n    \"${Dr. Gregory G. Roberts}{bold} is a desk officer in the State Department’s Office of Afghanistan Affairs. As a Presidential Management  Fellow (2014–2016), he served as a historian at the U.S. Army Center of Military History and the Combat Studies Institute,  and as a special assistant to the Chairman of the Joint Chiefs of Staff in the Chairman’s Action Group. Prior to  entering federal service, Dr. Roberts worked as a research associate in national security studies at the Council on Foreign Relations.  In 2013, he earned a PhD in history from Yale University, where his research focused on policing in medieval Italy.  He earned an MA and an MPhil in history from Yale in 2010, and a BA in history and a BA in French from Vanderbilt University in 2007.  Dr. Roberts has published on OEF in the ${SAIS Review of International Affairs}{italic} and has a chapter in the forthcoming volume  ${Makers of Modern Landpower: Post-9/11 Perspectives}{italic} (University Press of Kentucky).\",\n    \"${Lt. Col. (Ret.) Matthew B. Smith}{bold} is a graduate of Norwich University where he was commissioned field artillery officer in 1999. His initial assignment was with the 1st Battalion, 94th Field Artillery Regiment, in Idar-Oberstein, Germany. As a battery commander, he deployed with his unit to Iraq and assumed the mission for all surface-to-surface guided MLRS (multiple launch rocket system) fires throughout Multinational Corps–Iraq. Colonel Smith was then assigned as a Fires Observer Trainer with the Mission Command Training Program at Fort Leavenworth, Kansas. Upon graduating the Command and General Staff College, he reported to the 2nd Brigade Combat Team, 10th Mountain Division, in Fort Drum, New York. He deployed to Paktika Province, Afghanistan, in January 2013 and conducted security force assistance with the ANA. Colonel Smith holds an MS in management and business from Webster University.\",\n    \"${Lt. Col. (Ret.) John R. Stark}{bold} retired in 2017 as an armor lieutenant colonel after twenty-five years of service. He graduated as a distinguished cadet from West Point in 1991 and earned an MA (2000) and a PhD (2003) in European history from Ohio State University. He has taught history at West Point and Princeton. While in the Army, he served in Iraq in 2006–2007 as operations officer for t he 1st Battalion, 37th Armor “Bandits,” in Sinjar and Ramadi and in Afghanistan in 2011–2012 for NATO Rule of Law Field Support Mission in Kandahar and Kabul. He was an Observer-Controller-Trainer at the Joint Military Readiness Center in Hohenfels, Germany, where the Grizzly team trained forces for Afghanistan, Iraq, and Kosovo in 2007–2008. He served at NATO headquarters in 2013–2014 as a liaison officer for Allied Command Transformation, Capabilities Engineering and Innovation. He continues his service to the nation as a diplomat at the Department of State.\",\n    \"${Maj. Miranda M. Summers-Lowe}{bold} is a curator of modern military history at Smithsonian’s National Museum of American History and an officer in the District of Columbia National Guard. She enlisted in the Army National Guard in 2002 and served as a supply sergeant in Iraq in 2005 before commissioning through Officer Candidate School in 2009. Other assignments include state public affairs officer, command historian, and intelligence officer in the District of Columbia National Guard. She most recently served as the deputy director of public affairs for CJTF-Horn of Africa in Djibouti and as a public affairs adviser in the Office of the Director, Army National Guard. She was selected as an Army Congressional Fellow and a nonresident fellow of the Modern War Institute at West Point in 2019. Her work has been published in Military Review, War on the Rocks, and the New York Times. She has a BA in history from the College of William and Mary and a master’s in public humanities from Brown University.\",\n    \"${Col. Victor H. Sundquist}{bold}, an intelligence officer, enlisted with the 7th Infantry Division in 1988. He was commissioned in the Intelligence Branch from the United States Military Academy at West Point in 1995 and transitioned to the Army Strategist Functional Branch in 2014. He holds a MMAS from the School of Advanced Military Studies and an MS in counterterrorism theory from Henley-Putnam University. He is a 2016 graduate of the Army’s Senior Service War College, where he served as a Fellow at Georgetown University in the Institute for the Study of Diplomacy under the School of Foreign Service. During his twenty-eight years in the Army, he has served in various intelligence and strategist positions at all levels of command, including assignments in CENTCOM’s J–2 staff; the J–2X at ISAF headquarters; the 1st Cavalry Division G–2; the State Department’s Provincial Reconstruction Team in Basra, Iraq; deputy director for the Headquarters, Department of the Army’s War Plans Division; and most recently as the J–53 plans chief at U.S. Southern Command. He has multiple operational and combat tours, including Operations Southern Watch, Enduring Freedom, Iraqi Freedom, and New Dawn.\",\n    \"${Dr. Colin Jay Williams}{bold} is the command historian for the Defense Logistics Agency. A retired Army officer, he taught military history  at the United States Military Academy and has combat experience in both Afghanistan and Iraq. He received a PhD in military history from the University of Alabama and has been published in Key to the Northern Country: The Hudson River Valley in the American Revolution (SUNY Press, 2013) and New York History (vol. 99, no. 1).\",\n    {\n      \"figure\": {\n        \"source\": \"/figures/m/map-bm-afghanistan-2005-2014.svg\",\n        \"caption\": \"Afghanistan 2005-2014\",\n        \"prefix\": \"Supplemental Map\"\n      }\n    }\n  ],\n  \"glossary\": {\n    \"details\": \"The following terms and definitions, drawn from official Army publications and used in the text of this book, are provided here for the reader’s ease of reference.\",\n    \"TEXT ACRONYMS AND ABBREVIATIONS\": {\n      \"ANA\": \"Afghan National Army\",\n      \"ANP\": \"Afghan National Police\",\n      \"ANSF\": \"Afghan National Security Forces\",\n      \"ARCENT\": \"U.S. Army Central Command\",\n      \"CBU\": \"cluster bomb unit\",\n      \"CENTCOM\": \"U.S Central Command\",\n      \"CFACC\": \"Combined Forces Air Component Command\",\n      \"CFC-A\": \"Combined Forces Command–Afghanistan\",\n      \"CFLCC\": \"Coalition Forces Land Component Command\",\n      \"CIA U.S.\": \"Central Intelligence Agency\",\n      \"CJSOTF\": \"Combined Joint Special Operations Task Force\",\n      \"CJTF\": \"Combined Joint Task Force\",\n      \"CMH\": \"U.S. Army Center of Military History\",\n      \"CSA\": \"Chief of Staff, Army\",\n      \"DoD\": \"Department of Defense\",\n      \"FORSCOM\": \"U.S. Army Forces Command\",\n      \"HIG\": \"Hezb-e-Islami Gulbuddin\",\n      \"HMMWV\": \"High Mobility Multipurpose Wheeled Vehicle\",\n      \"IED\": \"improvised explosive device\",\n      \"ISAF\": \"International Security Assistance Force\",\n      \"JDAM\": \"Joint Direct Attack Munition\",\n      \"JSOTF\": \"Joint Special Operations Task Force\",\n      \"MEDEVAC\": \"medical evacuation\",\n      \"MLRS\": \"multiple launch rocket system\",\n      \"MMAS\": \"Master of Military Art and Science\",\n      \"NATO\": \"North Atlantic Treaty Organization\",\n      \"ODA\": \"Operational Detachment Alpha\",\n      \"OEF\": \"Operation Enduring Freedom\",\n      \"RC\": \"Regional Command\",\n      \"RMA\": \"Revolution in Military Affairs\",\n      \"SIGINT\": \"signals intelligence\",\n      \"SOAR\": \"Special Operations Aviation Regiment\",\n      \"SOF\": \"Special Operations Forces\",\n      \"TF\": \"Task Force\",\n      \"TRADOC\": \"U.S. Army Training and Doctrine Command\",\n      \"UA\": \"units of action\",\n      \"UEx\": \"Units of Employment X\",\n      \"UEy\": \"Units of Employment Y\",\n      \"UN\": \"United Nations\",\n      \"U.S.\": \"United States\"\n    }\n  },\n  \"references\": {\n    \"SELECTED TEXT\": [\n      \"${Department of the Army Field Manual (FM) 3–24}{bold}.${2, Tactics in Counterinsurgency, 21 April 2009 (Selected Text)}{bold}.\",\n      \"A ${clear-hold-build}{italic} operation is a full spectrum operation that combines offense (finding and eliminating the insurgent), defense (protecting the local populace) and stability (rebuilding the infrastructure, increasing the legitimacy of the local government, and bringing the rule of law to the area) operations. Each phase—clear, hold, and build—combines offensive, defensive, and stability operations in varying degrees. In the ${clear}{italic} phase, offensive operations usually dominate; in the ${hold}{italic} phase, defensive operations are emphasized; and in the ${build}{italic} phase, stability operations are preeminent. It is usually a relatively long term operation and requires the commitment of a large number of forces. Clear-hold-build operations are often preceded by shaping operations to set the proper conditions.\",\n      \"${Shape}{bold} – A shaping operation is an operation at any echelon that creates and preserves conditions for the success of the decisive operation.\",\n      \"${Clear}{bold} – Clear is a tactical mission task that requires the commander to remove all enemy forces and eliminate organized resistance within an assigned area (FM 3–90). The force does this by destroying, capturing, or forcing the withdrawal of insurgent combatants and leaders. This task is most effectively initiated by a clear-in-zone or cordon-and-search operation, as well as patrolling, ambushes, and targeted raids.\",\n      \"${Hold}{bold} – After clearing the area of guerrillas, the counterinsurgent force must then assign sufficient troops to the cleared area to prevent their return, to defeat any remnants, and to secure the population. This is the hold task. Ideally, Host Nation security forces execute this part of the clear hold- build operation. Success or failure depends on effectively and continuously securing the populace and on reestablishing a Host Nation local government. Although offensive and stability operations continue, this phase uses defensive operations to secure the population.\",\n      \"${Build}{bold} – The build phase of clear-hold-build operations consists of carrying out programs designed to remove the root causes that led to the insurgency, improve the lives of the inhabitants, and strengthen the Host Nation’s ability to provide effective governance. Stability operations predominate in this phase, with many important activities being conducted by nonmilitary agencies. During this phase, the Host Nation security forces should have primary responsibility for security. Progress in building support for the Host Nation government requires protecting the local populace. People who do not believe they are secure from insurgent intimidation, coercion, and reprisals will not risk overtly supporting counterinsurgent efforts.\"\n    ],\n    \"FOREIGN TERMS\": [\n      \"${al-Qaeda}{italic}  -  the foundation or the base [organization name]\",\n      \"${Amir al-Mahmunen }{italic}  - Commander of the Faithful\",\n      \"${bayat}{italic}  - an oath of personal allegiance\",\n      \"${burqa}{italic}  - head-to-toe covering\",\n      \"${fatwa}{italic}  - a deliberate call to arms for believers\",\n      \"${jihad}{italic}  - struggle, in the sense of a holy war waged on behalf of Islam\",\n      \"${kandak}{italic}  - Afghan battalion-sized unit\",\n      \"${loya jirga}{italic}  - grand assembly, akin to a national convention\",\n      \"${madrassa}{italic}  - religious educational institution\",\n      \"${melmastiia}{italic}  -  the obligation to offer protection to guests\",\n      \"${mujahideen}{italic}  - those who are struggling or striving for a praiseworthy aim\",\n      \"${pashtunwali}{italic}  - the ancient Pashtun code of conduct that includes a strong tradition of hospitality\",\n      \"${Qala-i-Jangi}{italic}  - house of war [place name]\",\n      \"${sharia}{italic}  - Islamic religious law\",\n      \"${shura}{italic}  - a local consultative council or assembly\",\n      \"${talib}{italic}  -  individual member of the Taliban\",\n      \"${Taliban}{italic}  - students of Islam [organization name]\",\n      \"${ushr}{italic}  - a 10 percent tithe, paid in kind\",\n      \"${wadi}{italic}  - dry riverbed\"\n    ],\n    \"Selected U.S. Military Staff Designations\": [\n      \"C-3 Combined (Coalition) operations\",\n      \"CCJ5-CMO Combined (Coalition) joint planning–civil-military operations\",\n      \"CCJ5-ANA  Combined (Coalition) joint planning–Afghan National Army\",\n      \"CJ–3 Combined (Coalition) joint operations\",\n      \"CJ–35 Combined (Coalition) joint future operations\",\n      \"G–3/5/7 Army operations, plans, and training\",\n      \"J–3  Joint staff intelligence\",\n      \"J–5 Joint staff operations\",\n      \"J–9  Joint staff planning\",\n      \"S–2 Joint staff civil-military cooperation\",\n      \"S-3 battalion or brigade intelligence\",\n      \"C-3 battalion or brigade operations\"\n    ],\n    \"ARMY PUBLICATIONS\": [\n      \"Army Doctrine Publication 1–02, Terms and Military Symbols, 14 August 2018\",\n      \"Most Army doctrinal publications are available online at ${http://www.apd.army.mil}{link: http://www.apd.army.mil}.\"\n    ],\n    \"WEB SITES\": [\n      \"${U.S. Army Center of Military History}{link: https://history.army.mil/}\"\n    ]\n  }\n}\n";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Td = exports.Tbody = exports.Th = exports.Tr = exports.Thead = exports.Table = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _tableContext = __webpack_require__(1482);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var omit = function omit(obj, omitProps) {
  return Object.keys(obj).filter(function (key) {
    return omitProps.indexOf(key) === -1;
  }).reduce(function (returnObj, key) {
    return _extends({}, returnObj, _defineProperty({}, key, obj[key]));
  }, {});
};

var allowed = function allowed(props) {
  return omit(props, ['inHeader', 'columnKey', 'headers']);
};

var Table = exports.Table = function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table(props) {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

    _this.state = {
      headers: {}
    };
    return _this;
  }

  _createClass(Table, [{
    key: 'render',
    value: function render() {
      var headers = this.state.headers;

      var classes = (this.props.className || '') + ' responsiveTable';
      return _react2.default.createElement(
        _tableContext.Provider,
        { value: headers },
        _react2.default.createElement('table', _extends({}, allowed(this.props), { className: classes }))
      );
    }
  }]);

  return Table;
}(_react2.default.Component);

var Thead = exports.Thead = function Thead(props) {
  return _react2.default.createElement(
    'thead',
    allowed(props),
    _react2.default.cloneElement(props.children, { inHeader: true })
  );
};

var TrInner = function (_React$Component2) {
  _inherits(TrInner, _React$Component2);

  function TrInner(props) {
    _classCallCheck(this, TrInner);

    var _this2 = _possibleConstructorReturn(this, (TrInner.__proto__ || Object.getPrototypeOf(TrInner)).call(this, props));

    var headers = props.headers;

    if (headers && props.inHeader) {
      _react2.default.Children.map(props.children, function (child, i) {
        if (child) {
          headers[i] = child.props.children;
        }
      });
    }
    return _this2;
  }

  _createClass(TrInner, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _react2.default.createElement(
        'tr',
        allowed(this.props),
        children && _react2.default.Children.map(children, function (child, i) {
          return child && _react2.default.cloneElement(child, {
            key: i,
            columnKey: i
          });
        })
      );
    }
  }]);

  return TrInner;
}(_react2.default.Component);

var Tr = exports.Tr = function Tr(props) {
  return _react2.default.createElement(
    _tableContext.Consumer,
    null,
    function (headers) {
      return _react2.default.createElement(TrInner, _extends({}, props, { headers: headers }));
    }
  );
};

var Th = exports.Th = function Th(props) {
  return _react2.default.createElement('th', allowed(props));
};
var Tbody = exports.Tbody = function Tbody(props) {
  return _react2.default.createElement('tbody', allowed(props));
};

var TdInner = function (_React$Component3) {
  _inherits(TdInner, _React$Component3);

  function TdInner() {
    _classCallCheck(this, TdInner);

    return _possibleConstructorReturn(this, (TdInner.__proto__ || Object.getPrototypeOf(TdInner)).apply(this, arguments));
  }

  _createClass(TdInner, [{
    key: 'render',
    value: function render() {
      if (this.props.colSpan) {
        return _react2.default.createElement('td', allowed(this.props));
      }
      var _props = this.props,
          headers = _props.headers,
          children = _props.children,
          columnKey = _props.columnKey;

      var classes = (this.props.className || '') + ' pivoted';
      return _react2.default.createElement(
        'td',
        { className: classes },
        _react2.default.createElement(
          'div',
          { className: 'tdBefore' },
          headers[columnKey]
        ),
        children !== undefined ? children : _react2.default.createElement(
          'div',
          null,
          '\xA0'
        )
      );
    }
  }]);

  return TdInner;
}(_react2.default.Component);

var Td = exports.Td = function Td(props) {
  return _react2.default.createElement(
    _tableContext.Consumer,
    null,
    function (headers) {
      return _react2.default.createElement(TdInner, _extends({}, props, { headers: headers }));
    }
  );
};

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppendixComponent", function() { return AppendixComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__ = __webpack_require__(23);
var Component=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* observer */])(__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"]));Component.displayName='Appendix';var AppendixComponent=__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"];/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChapterComponent", function() { return ChapterComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__ = __webpack_require__(23);
var Component=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* observer */])(__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"]));Component.displayName="Chapter";var ChapterComponent=__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"];/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoverComponent", function() { return CoverComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_BookElements_Composite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet__ = __webpack_require__(7);
function Container(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{justify:'center',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_BookElements_Composite__["default"],this.props));}var Component=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(Container));Component.displayName='Cover';var CoverComponent=Container;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ForewordComponent", function() { return ForewordComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__ = __webpack_require__(23);
var Component=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* observer */])(__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"]));Component.displayName="Foreword";var ForewordComponent=__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"];/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GlossaryComponent", function() { return GlossaryComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_natural_orderby__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_SectionBreak__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_BookElements_TableOfContentsEntry__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_Paragraph__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_Anchor__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  min-width: 50px;\n'],['\n  min-width: 50px;\n']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var scrollIntoViewOptions={behavior:'instant',block:'start'};var Entry=__WEBPACK_IMPORTED_MODULE_11_app_components_Paragraph__["a" /* default */];function sortEntries(entries){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(entries).toPairs().thru(function(entries){return Object(__WEBPACK_IMPORTED_MODULE_4_natural_orderby__["a" /* orderBy */])(entries,[function(entry){return entry[0].toUpperCase();}],['asc']);}).fromPairs().value();}function groupEntries(entries){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(entries).toPairs().groupBy(function(entry){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.head(entry[0]).toUpperCase();}).mapValues(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.fromPairs).value();}function prepareEntries(entries){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(entries).thru(sortEntries).thru(groupEntries).value();}function EntryLabel(_ref){var changeSelection=_ref.changeSelection,isSelected=_ref.isSelected,entry=_ref.entry,title=_ref.title,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:isSelected},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{align:'center',justify:'between',direction:'row',gap:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Entry,{key:entry,size:'xlarge'},children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_Anchor__["a" /* default */],{size:'xsmall',onClick:function onClick(){return changeSelection(title);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{direction:'row',align:'center',gap:'xsmall'},'Back to Top',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_icons__["o" /* LinkTop */],{size:'small',color:'neutral-2'})))));}var GlossaryKey=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_6_grommet__["m" /* Text */])(_templateObject);function renderEntry(_ref2){var entries=_ref2.entries,entry=_ref2.entry,title=_ref2.title,changeSelection=_ref2.changeSelection,isSelected=_ref2.isSelected;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EntryLabel,{key:entry,isSelected:isSelected(title+entry),changeSelection:changeSelection,title:title},entry)].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(sortEntries(entries),function(value,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{key:key,margin:{left:'small',bottom:'medium'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GlossaryKey,{weight:'bold'},key),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["m" /* Text */],null,value));})));}var Glossary=function(_React$Component){_inherits(Glossary,_React$Component);function Glossary(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,Glossary);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=Glossary.__proto__||Object.getPrototypeOf(Glossary)).call.apply(_ref3,[this].concat(args))),_this),_this.state={selection:''},_this.changeSelection=function(selection){return _this.setState({selection:selection});},_this.isSelected=function(selection){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(_this.state.selection.toLowerCase(),selection.toLowerCase());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Glossary,[{key:'render',value:function render(){var _this2=this;var _props=this.props,path=_props.path,content=_props.content;if(__WEBPACK_IMPORTED_MODULE_8_app_api_bookElement__["a" /* default */].isNotSelected(path))return null;var details=content.details,sections=_objectWithoutProperties(content,['details']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_BookElements_TableOfContentsEntry__["default"],{path:path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["g" /* Heading */],{responsive:true,textAlign:'center'},'Glossary')),details&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_Paragraph__["a" /* default */],{size:'small'},details),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(sections,function(entries,title){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:_this2.isSelected(title)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["m" /* Text */],{as:'h3',size:'large',weight:'bold'},title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{direction:'row',gap:'xsmall'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(prepareEntries(entries),function(__,label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_Anchor__["a" /* default */],{key:'glossary-entry-'+label,size:'large',onClick:function onClick(){return _this2.changeSelection(title+label);}},label);})),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(prepareEntries(entries),function(entries,entry){return renderEntry({entries:entries,entry:entry,changeSelection:_this2.changeSelection,isSelected:_this2.isSelected,title:title});}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_SectionBreak__["default"],null));}}]);return Glossary;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Glossary.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * glossary entries
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};Glossary.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Glossary));Component.displayName='Glossary';var GlossaryComponent=Glossary;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IndexComponent", function() { return IndexComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_natural_orderby__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_SectionBreak__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_BookElements_TableOfContentsEntry__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_Paragraph__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_Anchor__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_scroll_into_view_if_needed__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  padding-left: ',';\n'],['\n  padding-left: ',';\n']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var scrollIntoViewOptions={behavior:'instant',block:'start'};var Entry=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_11_app_components_Paragraph__["a" /* default */])(_templateObject,function(props){return 10*props.depth+'px';});function sortEntries(entries){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(entries).toPairs().thru(function(entries){return Object(__WEBPACK_IMPORTED_MODULE_4_natural_orderby__["a" /* orderBy */])(entries,[function(entry){console.log(entry);return entry[0].toUpperCase();}],['asc']);}).fromPairs().value();}function groupEntries(entries){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(entries).toPairs().groupBy(function(entry){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.head(entry[0]).toUpperCase();}).mapValues(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.fromPairs).value();}function prepareEntries(entries){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(entries).thru(sortEntries).thru(groupEntries).value();}function EntryLabel(_ref){var changeSelection=_ref.changeSelection,isSelected=_ref.isSelected,entry=_ref.entry,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:isSelected},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{align:'center',justify:'between',direction:'row',gap:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Entry,{key:entry,size:'xlarge',depth:0},children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_Anchor__["a" /* default */],{size:'xsmall',onClick:function onClick(){return changeSelection('index');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{direction:'row',align:'center',gap:'xsmall'},'Back to Top',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_icons__["o" /* LinkTop */],{size:'small',color:'neutral-2'})))));}function renderEntry(_ref2){var subEntries=_ref2.subEntries,entry=_ref2.entry,_ref2$depth=_ref2.depth,depth=_ref2$depth===undefined?0:_ref2$depth,changeSelection=_ref2.changeSelection,isSelected=_ref2.isSelected;var hasSubEntries=!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(subEntries);var component=depth===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EntryLabel,{key:entry,isSelected:isSelected(entry),changeSelection:changeSelection},entry):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Entry,{key:entry,depth:depth},entry);if(hasSubEntries){return[component].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(sortEntries(subEntries),function(_subEntries,_entry){return renderEntry({subEntries:_subEntries,entry:_entry,depth:depth+1});})));}return component;}var Index=function(_React$Component){_inherits(Index,_React$Component);function Index(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,Index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=Index.__proto__||Object.getPrototypeOf(Index)).call.apply(_ref3,[this].concat(args))),_this),_this.state={selection:''},_this.changeSelection=function(selection){return _this.setState({selection:selection});},_this.isSelected=function(selection){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(_this.state.selection.toLowerCase(),selection.toLowerCase());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Index,[{key:'render',value:function render(){var _this2=this;var _props=this.props,path=_props.path,contents=_props.content;var details=contents.details,content=_objectWithoutProperties(contents,['details']);if(__WEBPACK_IMPORTED_MODULE_8_app_api_bookElement__["a" /* default */].isNotSelected(path))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_BookElements_TableOfContentsEntry__["default"],{path:path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["g" /* Heading */],{responsive:true,textAlign:'center'},'Index')),details&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_Paragraph__["a" /* default */],{size:'small'},details),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_scroll_into_view_if_needed__["a" /* default */],{options:scrollIntoViewOptions,active:this.isSelected('index')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{direction:'row',gap:'xsmall'},__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(prepareEntries(content),function(__,entryLabel){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_Anchor__["a" /* default */],{key:entryLabel,size:'large',onClick:function onClick(){return _this2.changeSelection(entryLabel);}},entryLabel);}))),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(prepareEntries(content),function(subEntries,entry){return renderEntry({subEntries:subEntries,entry:entry,changeSelection:_this2.changeSelection,isSelected:_this2.isSelected});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_SectionBreak__["default"],null));}}]);return Index;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Index.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * index entries
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};Index.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Index));Component.displayName='Index';var IndexComponent=Index;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InformationComponent", function() { return InformationComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_SectionBreak__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_BookElements_TableOfContentsEntry__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_Paragraph__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_Anchor__ = __webpack_require__(96);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Information=function(_React$Component){_inherits(Information,_React$Component);function Information(){_classCallCheck(this,Information);return _possibleConstructorReturn(this,(Information.__proto__||Object.getPrototypeOf(Information)).apply(this,arguments));}_createClass(Information,[{key:"render",value:function render(){var path=this.props.path;if(__WEBPACK_IMPORTED_MODULE_3_app_api_bookElement__["a" /* default */].isNotSelected(path))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_BookElements_TableOfContentsEntry__["default"],{path:path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet__["g" /* Heading */],{responsive:true,textAlign:"center"},"Information")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_Paragraph__["a" /* default */],null,"The printed versions of Modern War in an Ancient Land Volume I and Volume II is available from the U.S. Army Center of Military History (CMH)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_Paragraph__["a" /* default */],null,"The CMH Publications Catalog is available at: (",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_Anchor__["a" /* default */],{href:"https://history.army.mil/catalog/index.html"},"https://history.army.mil/catalog/index.html"),")"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_Paragraph__["a" /* default */],null,"The PDF versions of Volume I and Volume II are available at:(",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_Anchor__["a" /* default */],{href:"https://rdl.train.army.mil/catalog-ws/view/modernwar/index.html"},"https://rdl.train.army.mil/catalog-ws/view/modernwar/index.html"),")"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_BookElements_SectionBreak__["default"],null));}}]);return Information;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Component=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(Information));Component.displayName="Information";var InformationComponent=Information;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InstructionsComponent", function() { return InstructionsComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_Paragraph__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_SectionBreak__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_TableOfContentsEntry__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  border-collapse: collapse;\n  border-style: hidden;\n  td,\n  th {\n    border: 1px solid gray;\n    padding: 5px;\n  }\n"],["\n  border-collapse: collapse;\n  border-style: hidden;\n  td,\n  th {\n    border: 1px solid gray;\n    padding: 5px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  transform: translateY(2px);\n  width: 28px;\n  height: 28px;\n"],["\n  transform: translateY(2px);\n  width: 28px;\n  height: 28px;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  transform: translateY(0px);\n  width: 14px;\n  height: 14px;\n"],["\n  transform: translateY(0px);\n  width: 14px;\n  height: 14px;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ResponsiveTable=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Table"])(_templateObject);var ClearIcon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["f" /* Clear */])(_templateObject2);var BookmarksIcon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["n" /* Iteration */])(_templateObject3);var Instructions=function(_React$Component){_inherits(Instructions,_React$Component);function Instructions(){_classCallCheck(this,Instructions);return _possibleConstructorReturn(this,(Instructions.__proto__||Object.getPrototypeOf(Instructions)).apply(this,arguments));}_createClass(Instructions,[{key:"render",value:function render(){var path=this.props.path;if(__WEBPACK_IMPORTED_MODULE_6_app_api_bookElement__["a" /* default */].isNotSelected(path))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_TableOfContentsEntry__["default"],{path:path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["g" /* Heading */],{responsive:true,textAlign:"center"},"Instructions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"large",weight:"bold"},"Control Icons"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_Paragraph__["a" /* default */],null,"Control icons are located along the bottom in the menu bar. Most of these controls are intuitive. These controls and their functions are described below."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{background:"light-3",elevation:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveTable,{border:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Thead"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Th"],null,"Icon"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Th"],null,"Function"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tbody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["p" /* Menu */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Table of Contents: Select the icon to access the table of contents and select a heading from the scrollable list"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["s" /* Search */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Search: Enter a word or group of words to locate the search word(s) within the entire document"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["d" /* ChapterPrevious */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Previous Section: Use to navigate to the previous section"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["c" /* ChapterNext */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Next Section: Use to navigate to the next section"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["q" /* More */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Bookmark Menu: Select the icon to access a scrollable list of captured bookmarks"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["b" /* Bookmark */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Bookmark: Use to mark a paragraph or sentence for quick retrieval in the future"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["j" /* Edit */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Annotate Bookmark: Use to add a note to a bookmark"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["A" /* Trash */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Delete Bookmark: Use to select a bookmark to delete"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["j" /* Stack */],{anchor:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClearIcon,{size:"large",color:"black"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarksIcon,{color:"black"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Clear Bookmarks: Use to delete bookmarks all at once"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["e" /* Checkmark */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Confirm: Use to confirm an action, such as creating or deleting a bookmark"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["g" /* Close */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Cancel: Use to cancel an action"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["r" /* Revert */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Revert: Use to back out of a menu or back up to a previous step"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["l" /* Globe */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Online: This icon indicates the e2book has access to the internet"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{align:"center",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["h" /* Connect */],{color:"black"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_super_responsive_table__["Td"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"small",weight:"normal"},"Offline: This icon indicates the e2book lost internet access, and that some figure types may be inaccessible")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"large",weight:"bold"},"Navigation"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_Paragraph__["a" /* default */],null,"There are several ways to navigate through the text. Select Next Section or Previous Section in navigation bar located at the bottom of the page, respectively to advance or go back one section. To jump to a particular chapter or topic, select the table of contents icon, then select the desired heading from the list. You can also enter a search term and select a page from the list matches that appear in the search results pane. Use the scroll bar to move up and down the page."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"large",weight:"bold"},"Figure Types"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_Paragraph__["a" /* default */],null,"Figure types may represent audio/video files, animations, or interactions. Some of the figure types are expandable to full screen. To return to the page, click the contract button that appears in the upper left corner of the full screen."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"large",weight:"bold"},"\u201CMissing\u201D Text and Prompts"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_Paragraph__["a" /* default */],null,"In some instances, the text may appear to be missing. This indicates that the text has been incorporated into figure type. This is denoted by the numbered paragraph and the prompt, \u201CSelect/See the figure\u2026\u201D or \u201CSelect/See supplemental figure\u2026\u201D and a related image. You must select the related image in order to view the text."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"large",weight:"bold"},"Notes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_Paragraph__["a" /* default */],null,"A notes feature is provided to allow linking comments to a specific location within the IDP. To capture a note, first select the Bookmark icon (as seen above in the Control Icons table), then select a section to highlight it. At this point, you can either select individual sentences in the section, add a note, or just save the selection as a bookmark."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_SectionBreak__["default"],null));}}]);return Instructions;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Component=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(Instructions));Component.displayName="Instructions";var InstructionsComponent=Instructions;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntroductionComponent", function() { return IntroductionComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__ = __webpack_require__(23);
var Component=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* observer */])(__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"]));Component.displayName='Introduction';var IntroductionComponent=__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"];/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PrefaceComponent", function() { return PrefaceComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__ = __webpack_require__(23);
var Component=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* observer */])(__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"]));Component.displayName='Preface';var PrefaceComponent=__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"];/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PrologueComponent", function() { return PrologueComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__ = __webpack_require__(23);
var Component=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* observer */])(__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"]));Component.displayName="Prologue";var PrologueComponent=__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"];/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReferencesComponent", function() { return ReferencesComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_markup__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_SectionBreak__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_TableOfContentsEntry__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_Paragraph__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function extractEntries(entries){var details=entries.details,extracted=_objectWithoutProperties(entries,['details']);return extracted;}function Entry(_ref){var entries=_ref.entries,section=_ref.section;var title=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(section).lowerCase().startCase().value();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["m" /* Text */],{as:'h3',size:'large',weight:'bold'},title),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(entries,function(entry){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_Paragraph__["a" /* default */],{key:entry,size:'small'},__WEBPACK_IMPORTED_MODULE_5_app_api_markup__["a" /* default */].parse(entry));}));}var References=function(_React$Component){_inherits(References,_React$Component);function References(){_classCallCheck(this,References);return _possibleConstructorReturn(this,(References.__proto__||Object.getPrototypeOf(References)).apply(this,arguments));}_createClass(References,[{key:'render',value:function render(){var _props=this.props,path=_props.path,content=_props.content;if(__WEBPACK_IMPORTED_MODULE_6_app_api_bookElement__["a" /* default */].isNotSelected(path))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_TableOfContentsEntry__["default"],{path:path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["g" /* Heading */],{responsive:true,textAlign:'center'},'References')),content.details&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_Paragraph__["a" /* default */],{size:'small'},content.details),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(extractEntries(content),function(entries,section){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Entry,{key:section,entries:entries,section:section});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_SectionBreak__["default"],null));}}]);return References;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);References.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * references entries
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};References.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(References));Component.displayName='References';var ReferencesComponent=References;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BookSectionOneComponent", function() { return BookSectionOneComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__ = __webpack_require__(23);
var Component=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* observer */])(__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"]));Component.displayName="SECTION I";var BookSectionOneComponent=__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"];/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BookSectionTwoComponent", function() { return BookSectionTwoComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__ = __webpack_require__(23);
var Component=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* observer */])(__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"]));Component.displayName="SECTION II";var BookSectionTwoComponent=__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"];/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BookSectionTwoComponent", function() { return BookSectionTwoComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__ = __webpack_require__(23);
var Component=Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_0_mobx_react__["c" /* observer */])(__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"]));Component.displayName="SECTION III";var BookSectionTwoComponent=__WEBPACK_IMPORTED_MODULE_1_app_components_BookElements_Composite__["default"];/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SourcesComponent", function() { return SourcesComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_natural_orderby__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_api_markup__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_SectionBreak__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_BookElements_TableOfContentsEntry__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_Paragraph__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  min-width: 50px;\n'],['\n  min-width: 50px;\n']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function sortEntries(entries){return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(entries).toPairs().thru(function(entries){return Object(__WEBPACK_IMPORTED_MODULE_4_natural_orderby__["a" /* orderBy */])(entries,[function(entry){return entry[0].toUpperCase();}],['asc']);}).fromPairs().value();}var Source=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_6_grommet__["m" /* Text */])(_templateObject);var Sources=function(_React$Component){_inherits(Sources,_React$Component);function Sources(){_classCallCheck(this,Sources);return _possibleConstructorReturn(this,(Sources.__proto__||Object.getPrototypeOf(Sources)).apply(this,arguments));}_createClass(Sources,[{key:'render',value:function render(){var _props=this.props,path=_props.path,content=_props.content;if(__WEBPACK_IMPORTED_MODULE_8_app_api_bookElement__["a" /* default */].isNotSelected(path))return null;var details=content.details,sources=_objectWithoutProperties(content,['details']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_BookElements_TableOfContentsEntry__["default"],{path:path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["g" /* Heading */],{responsive:true,textAlign:'center'},'Source Notes')),details&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_Paragraph__["a" /* default */],{size:'small'},details),__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(sortEntries(sources),function(note,source){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet__["d" /* Box */],{key:source,direction:'row',gap:'small',margin:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Source,{weight:'bold'},source),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_Paragraph__["a" /* default */],{margin:'none',pad:'none',size:'small'},__WEBPACK_IMPORTED_MODULE_7_app_api_markup__["a" /* default */].parse(note)));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_BookElements_SectionBreak__["default"],null));}}]);return Sources;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Sources.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * source notes entries
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};Sources.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Sources));Component.displayName='Sources';var SourcesComponent=Sources;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SupplementComponent", function() { return SupplementComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_Paragraph__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_SectionBreak__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_TableOfContentsEntry__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  text-align: center;\n"],["\n  text-align: center;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  font-style: italic;\n"],["\n  font-style: italic;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4_grommet__["d" /* Box */])(_templateObject);var ItalicText=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_6_app_components_Paragraph__["a" /* default */])(_templateObject2);var Supplement=function(_React$Component){_inherits(Supplement,_React$Component);function Supplement(){_classCallCheck(this,Supplement);return _possibleConstructorReturn(this,(Supplement.__proto__||Object.getPrototypeOf(Supplement)).apply(this,arguments));}_createClass(Supplement,[{key:"render",value:function render(){var _props=this.props,path=_props.path,content=_props.content;if(__WEBPACK_IMPORTED_MODULE_5_app_api_bookElement__["a" /* default */].isNotSelected(path))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_TableOfContentsEntry__["default"],{path:path},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["g" /* Heading */],{responsive:true,textAlign:"center"},"Publication Supplement")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["m" /* Text */],{as:"h3",alignSelf:"start",size:"large",weight:"bold"},"Supplemental Content"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_Paragraph__["a" /* default */],null,"This mobile publication contains additional figure types such as charts and interactions that are not included in the original publication."),content.details&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_Paragraph__["a" /* default */],null,content.details),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_SectionBreak__["default"],null));}}]);return Supplement;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Supplement.propTypes={/**
   * content path
   */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])).isRequired,/**
   * details
   */content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({details:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})};Supplement.defaultProps={content:{}};var Component=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(Supplement));Component.displayName="Supplement";var SupplementComponent=Supplement;/* harmony default export */ __webpack_exports__["default"] = (Component);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_state_AppState__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(["\n  ","\n  ","\n  @media (max-width: 600px) {\n    ","\n    ","\n  }\n"],["\n  ","\n  ","\n  @media (max-width: 600px) {\n    ","\n    ","\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n      width: 30px;\n      height: 30px;\n      transform: translateX(15px);\n    "],["\n      width: 30px;\n      height: 30px;\n      transform: translateX(15px);\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      width: 48px;\n      height: 48px;\n    "],["\n      width: 48px;\n      height: 48px;\n    "]),_templateObject4=_taggedTemplateLiteral(["\n        transform: translate(16px, -5px);\n      "],["\n        transform: translate(16px, -5px);\n      "]),_templateObject5=_taggedTemplateLiteral(["\n        width: 24px;\n        height: 24px;\n      "],["\n        width: 24px;\n        height: 24px;\n      "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var hasInsertedBookmark=false;var hasDeletedBookmark=false;var amountOfBookmarks=void 0;Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["v" /* reaction */])(function(){return __WEBPACK_IMPORTED_MODULE_6_app_state_AppState__["a" /* default */].bookmarks.collection.length;},function(newAmountOfBookmarks){if(!amountOfBookmarks){amountOfBookmarks=newAmountOfBookmarks;return;}if(newAmountOfBookmarks>amountOfBookmarks){hasInsertedBookmark=true;}else{hasDeletedBookmark=true;}amountOfBookmarks=newAmountOfBookmarks;});function showAnimation(){var shouldAnimate=hasInsertedBookmark||hasDeletedBookmark;return shouldAnimate;}function showDeleteIcon(){var shouldShow=hasDeletedBookmark;hasDeletedBookmark=false;return shouldShow;}function showInsertIcon(){var shouldShow=hasInsertedBookmark;hasInsertedBookmark=false;return shouldShow;}var icon=function icon(_icon){return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(_icon)(_templateObject,function(props){return props.indicator&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* css */])(_templateObject2);},function(props){return props.button&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* css */])(_templateObject3);},function(props){return props.indicator&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* css */])(_templateObject4);},function(props){return props.button&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* css */])(_templateObject5);});};var ShowBookmarks=icon(__WEBPACK_IMPORTED_MODULE_5_grommet_icons__["q" /* More */]);var ReturnButton=icon(__WEBPACK_IMPORTED_MODULE_5_grommet_icons__["r" /* Revert */]);var InsertBookmark=icon(__WEBPACK_IMPORTED_MODULE_5_grommet_icons__["a" /* AddCircle */]);var DeleteBookmark=icon(__WEBPACK_IMPORTED_MODULE_5_grommet_icons__["z" /* SubtractCircle */]);function BookmarksButton(_ref){var AppState=_ref.AppState;var isOpen=AppState.isBookmarksMenuOpen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_Button__["a" /* default */],{title:"Bookmark Menu",direction:"row",pad:"small",justify:"center",align:"center",fill:"vertical",onClick:function onClick(){return AppState.toggleBookmarksMenu();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["j" /* Stack */],{anchor:"top-right"},!isOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShowBookmarks,{button:1,color:"accent-1"}),isOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReturnButton,{button:1,color:"accent-1"}),showAnimation()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["d" /* Box */],{animation:[{type:"fadeOut",delay:1200,duration:2400,size:"xlarge"},{type:"slideDown",duration:600,size:"xlarge"}]},showInsertIcon()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InsertBookmark,{indicator:"true",color:"accent-2"}),showDeleteIcon()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeleteBookmark,{indicator:"true",color:"status-critical"}))));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(BookmarksButton)));

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_AnimatedEllipsis__ = __webpack_require__(153);
var _templateObject=_taggedTemplateLiteral(['\n  font-size: 20px;\n  line-height: 28px;\n  @media (max-width: 600px) {\n    font-size: 16px;\n    line-height: 20px;\n  }\n'],['\n  font-size: 20px;\n  line-height: 28px;\n  @media (max-width: 600px) {\n    font-size: 16px;\n    line-height: 20px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ResponsiveText=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_grommet__["m" /* Text */])(_templateObject);function AwaitingSelectionNotification(_ref){var _ref$selection=_ref.selection,selection=_ref$selection===undefined?'selection':_ref$selection;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveText,{weight:'bold',color:'accent-1'},'Awaiting '+selection,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_AnimatedEllipsis__["a" /* default */],null));}/* harmony default export */ __webpack_exports__["a"] = (AwaitingSelectionNotification);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n'],['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["g" /* Close */])(_templateObject);function CancelButton(_ref){var AppState=_ref.AppState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_Button__["a" /* default */],{direction:'row',pad:'small',justify:'center',align:'center',fill:'vertical',onClick:function onClick(){AppState.setMenuBar('MAIN_MENU');AppState.resetBookmarkingSelection();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{size:'large',color:'accent-1'}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(CancelButton)));

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n'],['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["e" /* Checkmark */])(_templateObject);function SaveButton(_ref){var AppState=_ref.AppState,onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_Button__["a" /* default */],{direction:'row',pad:'small',justify:'center',align:'center',fill:'vertical',onClick:function onClick(){AppState.bookmarks.insert({path:AppState.bookmarkingSelectionPath.slice(),content:AppState.bookmarkingSelectionContent,note:AppState.bookmarkingNote});AppState.resetBookmarkingSelection();AppState.setMenuBar('MAIN_MENU');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{size:'large',color:'accent-1'}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(SaveButton)));

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(274);
module.exports = __webpack_require__(279);


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(275).enable();
  window.Promise = __webpack_require__(277);
}

// fetch() polyfill for making API calls.
__webpack_require__(278);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(75);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(154);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(154);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 278 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_find__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_promise__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_string_starts_with__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_index_css__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lib_registerServiceWorker__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_E2Book__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_Loading__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_state_AppState__ = __webpack_require__(66);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  ADDED LINES 10-12 for IE 11 Support
//  import polyfills from core-js to fix:
//
//  'Object doesn't support property or method....' startsWith
//  'possible unhandled promise' online/offline polling bug
//  'object doesn't support property 'find' from xxxx.worker.js
//  array find reference 
//  https://stackoverflow.com/questions/56269966/object-doesnt-support-property-or-method-find-in-ie-11
//import 'core-js/modules/es6.array.find'; //redundant imported by line 1 above
_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var AppState;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_Loading__["a" /* default */],null),document.getElementById('root'));_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_11_app_state_AppState__["b" /* fetchFromStorage */])();case 3:AppState=_context.sent;__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["a" /* Provider */],{AppState:AppState},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_E2Book__["a" /* default */],null)),document.getElementById('root'));case 5:case'end':return _context.stop();}}},_callee,_this);}))();Object(__WEBPACK_IMPORTED_MODULE_8_lib_registerServiceWorker__["a" /* default */])();

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(281);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 281 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(283);
module.exports = __webpack_require__(24).Array.find;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(33);
var $find = __webpack_require__(286)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(158)(KEY);


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(58) && !__webpack_require__(107)(function () {
  return Object.defineProperty(__webpack_require__(108)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(42);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(60);
var IObject = __webpack_require__(110);
var toObject = __webpack_require__(111);
var toLength = __webpack_require__(80);
var asc = __webpack_require__(287);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(288);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(42);
var isArray = __webpack_require__(289);
var SPECIES = __webpack_require__(16)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(49);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(301);
__webpack_require__(304);
__webpack_require__(316);
__webpack_require__(317);
module.exports = __webpack_require__(24).Promise;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(114);
var test = {};
test[__webpack_require__(16)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(59)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(293)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(159)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(112);
var defined = __webpack_require__(79);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(295);
var descriptor = __webpack_require__(156);
var setToStringTag = __webpack_require__(118);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(48)(IteratorPrototype, __webpack_require__(16)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(41);
var dPs = __webpack_require__(296);
var enumBugKeys = __webpack_require__(160);
var IE_PROTO = __webpack_require__(117)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(108)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(161).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(76);
var anObject = __webpack_require__(41);
var getKeys = __webpack_require__(115);

module.exports = __webpack_require__(58) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(77);
var toIObject = __webpack_require__(116);
var arrayIndexOf = __webpack_require__(298)(false);
var IE_PROTO = __webpack_require__(117)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(116);
var toLength = __webpack_require__(80);
var toAbsoluteIndex = __webpack_require__(299);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(112);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(77);
var toObject = __webpack_require__(111);
var IE_PROTO = __webpack_require__(117)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(302);
var getKeys = __webpack_require__(115);
var redefine = __webpack_require__(59);
var global = __webpack_require__(21);
var hide = __webpack_require__(48);
var Iterators = __webpack_require__(61);
var wks = __webpack_require__(16);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(158);
var step = __webpack_require__(303);
var Iterators = __webpack_require__(61);
var toIObject = __webpack_require__(116);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(159)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(113);
var global = __webpack_require__(21);
var ctx = __webpack_require__(60);
var classof = __webpack_require__(114);
var $export = __webpack_require__(33);
var isObject = __webpack_require__(42);
var aFunction = __webpack_require__(78);
var anInstance = __webpack_require__(305);
var forOf = __webpack_require__(306);
var speciesConstructor = __webpack_require__(162);
var task = __webpack_require__(163).set;
var microtask = __webpack_require__(311)();
var newPromiseCapabilityModule = __webpack_require__(119);
var perform = __webpack_require__(164);
var userAgent = __webpack_require__(312);
var promiseResolve = __webpack_require__(165);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(16)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(313)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(118)($Promise, PROMISE);
__webpack_require__(314)(PROMISE);
Wrapper = __webpack_require__(24)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(315)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(60);
var call = __webpack_require__(307);
var isArrayIter = __webpack_require__(308);
var anObject = __webpack_require__(41);
var toLength = __webpack_require__(80);
var getIterFn = __webpack_require__(309);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(41);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(61);
var ITERATOR = __webpack_require__(16)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(114);
var ITERATOR = __webpack_require__(16)('iterator');
var Iterators = __webpack_require__(61);
module.exports = __webpack_require__(24).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 310 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var macrotask = __webpack_require__(163).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(49)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(59);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(21);
var dP = __webpack_require__(76);
var DESCRIPTORS = __webpack_require__(58);
var SPECIES = __webpack_require__(16)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(16)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(33);
var core = __webpack_require__(24);
var global = __webpack_require__(21);
var speciesConstructor = __webpack_require__(162);
var promiseResolve = __webpack_require__(165);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(33);
var newPromiseCapability = __webpack_require__(119);
var perform = __webpack_require__(164);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(319);
module.exports = __webpack_require__(24).String.startsWith;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(33);
var toLength = __webpack_require__(80);
var context = __webpack_require__(166);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(167)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(42);
var cof = __webpack_require__(49);
var MATCH = __webpack_require__(16)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(75),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,A=n?Symbol.for("react.memo"):
60115,B=n?Symbol.for("react.lazy"):60116,C="function"===typeof Symbol&&Symbol.iterator;function aa(a,b,e,c,d,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[e,c,d,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},F={};
function G(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}G.prototype.isReactComponent={};G.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};G.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function H(){}H.prototype=G.prototype;function I(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}var J=I.prototype=new H;
J.constructor=I;k(J,G.prototype);J.isPureReactComponent=!0;var K={current:null,currentDispatcher:null},L=Object.prototype.hasOwnProperty,M={key:!0,ref:!0,__self:!0,__source:!0};
function N(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:d,_owner:K.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,e,c){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return e(c,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+U(d,h);g+=T(d,f,e,c)}else if(null===a||"object"!==typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,h++),g+=T(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function V(a,b,e){return null==a?0:T(a,"",b,e)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,function(a){return a}):null!=a&&(O(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+e)),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(P,"$&/")+"/");b=R(b,g,c,d);V(a,da,b);S(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=R(null,null,b,e);V(a,ca,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){O(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:G,PureComponent:I,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:B,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:A,type:a,compare:void 0===b?null:b}},Fragment:r,StrictMode:t,unstable_ConcurrentMode:x,Suspense:z,unstable_Profiler:u,createElement:N,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),
g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=K.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=N.bind(null,a);b.type=a;return b},
isValidElement:O,version:"16.6.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:K,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(75),da=__webpack_require__(323);function ea(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[c,d,e,f,g,h],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function r(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ea(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:r("227");function fa(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}
var ha=!1,ia=null,ja=!1,ka=null,la={onError:function(a){ha=!0;ia=a}};function ma(a,b,c,d,e,f,g,h,k){ha=!1;ia=null;fa.apply(la,arguments)}function na(a,b,c,d,e,f,g,h,k){ma.apply(this,arguments);if(ha){if(ha){var l=ia;ha=!1;ia=null}else r("198"),l=void 0;ja||(ja=!0,ka=l)}}var oa=null,pa={};
function qa(){if(oa)for(var a in pa){var b=pa[a],c=oa.indexOf(a);-1<c?void 0:r("96",a);if(!ra[c]){b.extractEvents?void 0:r("97",a);ra[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;sa.hasOwnProperty(h)?r("99",h):void 0;sa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ta(k[e],g,h);e=!0}else f.registrationName?(ta(f.registrationName,g,h),e=!0):e=!1;e?void 0:r("98",d,a)}}}}
function ta(a,b,c){ua[a]?r("100",a):void 0;ua[a]=b;va[a]=b.eventTypes[c].dependencies}var ra=[],sa={},ua={},va={},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);na(b,c,void 0,a);a.currentTarget=null}function Aa(a,b){null==b?r("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}
var Ga={injectEventPluginOrder:function(a){oa?r("101"):void 0;oa=Array.prototype.slice.call(a);qa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];pa.hasOwnProperty(c)&&pa[c]===d||(pa[c]?r("102",c):void 0,pa[c]=d,b=!0)}b&&qa()}};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?r("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;if(a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?r("95"):void 0,ja))throw b=ka,ja=!1,ka=null,b;}var Ka=Math.random().toString(36).slice(2),La="__reactInternalInstance$"+Ka,Ma="__reactEventHandlers$"+Ka;function Na(a){if(a[La])return a[La];for(;!a[La];)if(a.parentNode)a=a.parentNode;else return null;a=a[La];return 5===a.tag||6===a.tag?a:null}function Oa(a){a=a[La];return!a||5!==a.tag&&6!==a.tag?null:a}
function Pa(a){if(5===a.tag||6===a.tag)return a.stateNode;r("33")}function Qa(a){return a[Ma]||null}function Ra(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}
function Ta(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Ra(b);for(b=c.length;0<b--;)Sa(c[b],"captured",a);for(b=0;b<c.length;b++)Sa(c[b],"bubbled",a)}}function Ua(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Va(a){a&&a.dispatchConfig.registrationName&&Ua(a._targetInst,null,a)}
function Wa(a){Ba(a,Ta)}var Xa=!("undefined"===typeof window||!window.document||!window.document.createElement);function Ya(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Za={animationend:Ya("Animation","AnimationEnd"),animationiteration:Ya("Animation","AnimationIteration"),animationstart:Ya("Animation","AnimationStart"),transitionend:Ya("Transition","TransitionEnd")},$a={},ab={};
Xa&&(ab=document.createElement("div").style,"AnimationEvent"in window||(delete Za.animationend.animation,delete Za.animationiteration.animation,delete Za.animationstart.animation),"TransitionEvent"in window||delete Za.transitionend.transition);function bb(a){if($a[a])return $a[a];if(!Za[a])return a;var b=Za[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in ab)return $a[a]=b[c];return a}
var cb=bb("animationend"),ib=bb("animationiteration"),jb=bb("animationstart"),kb=bb("transitionend"),lb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),mb=null,nb=null,ob=null;
function pb(){if(ob)return ob;var a,b=nb,c=b.length,d,e="value"in mb?mb.value:mb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return ob=e.slice(a,1<d?1-d:void 0)}function qb(){return!0}function rb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?qb:rb;this.isPropagationStopped=rb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=qb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=qb)},persist:function(){this.isPersistent=qb},isPersistent:rb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=rb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;sb(c);return c};sb(y);function tb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function ub(a){a instanceof this?void 0:r("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function sb(a){a.eventPool=[];a.getPooled=tb;a.release=ub}var vb=y.extend({data:null}),wb=y.extend({data:null}),xb=[9,13,27,32],yb=Xa&&"CompositionEvent"in window,zb=null;Xa&&"documentMode"in document&&(zb=document.documentMode);
var Ab=Xa&&"TextEvent"in window&&!zb,Bb=Xa&&(!yb||zb&&8<zb&&11>=zb),Cb=String.fromCharCode(32),Db={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Eb=!1;
function Fb(a,b){switch(a){case "keyup":return-1!==xb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Gb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Hb=!1;function Kb(a,b){switch(a){case "compositionend":return Gb(b);case "keypress":if(32!==b.which)return null;Eb=!0;return Cb;case "textInput":return a=b.data,a===Cb&&Eb?null:a;default:return null}}
function Lb(a,b){if(Hb)return"compositionend"===a||!yb&&Fb(a,b)?(a=pb(),ob=nb=mb=null,Hb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Bb&&"ko"!==b.locale?null:b.data;default:return null}}
var Mb={eventTypes:Db,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(yb)b:{switch(a){case "compositionstart":e=Db.compositionStart;break b;case "compositionend":e=Db.compositionEnd;break b;case "compositionupdate":e=Db.compositionUpdate;break b}e=void 0}else Hb?Fb(a,c)&&(e=Db.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Db.compositionStart);e?(Bb&&"ko"!==c.locale&&(Hb||e!==Db.compositionStart?e===Db.compositionEnd&&Hb&&(f=pb()):(mb=d,nb="value"in mb?mb.value:mb.textContent,Hb=
!0)),e=vb.getPooled(e,b,c,d),f?e.data=f:(f=Gb(c),null!==f&&(e.data=f)),Wa(e),f=e):f=null;(a=Ab?Kb(a,c):Lb(a,c))?(b=wb.getPooled(Db.beforeInput,b,c,d),b.data=a,Wa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Nb=null,Ob=null,Pb=null;function Vb(a){if(a=xa(a)){"function"!==typeof Nb?r("280"):void 0;var b=wa(a.stateNode);Nb(a.stateNode,a.type,b)}}function Wb(a){Ob?Pb?Pb.push(a):Pb=[a]:Ob=a}function Xb(){if(Ob){var a=Ob,b=Pb;Pb=Ob=null;Vb(a);if(b)for(a=0;a<b.length;a++)Vb(b[a])}}
function Yb(a,b){return a(b)}function Zb(a,b,c){return a(b,c)}function $b(){}var ac=!1;function bc(a,b){if(ac)return a(b);ac=!0;try{return Yb(a,b)}finally{if(ac=!1,null!==Ob||null!==Pb)$b(),Xb()}}var cc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function dc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!cc[a.type]:"textarea"===b?!0:!1}
function ec(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function fc(a){if(!Xa)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function gc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function hc(a){var b=gc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function ic(a){a._valueTracker||(a._valueTracker=hc(a))}function jc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=gc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var kc=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,lc=/^(.*)[\\\/]/,D="function"===typeof Symbol&&Symbol.for,mc=D?Symbol.for("react.element"):60103,nc=D?Symbol.for("react.portal"):60106,oc=D?Symbol.for("react.fragment"):60107,pc=D?Symbol.for("react.strict_mode"):60108,qc=D?Symbol.for("react.profiler"):60114,rc=D?Symbol.for("react.provider"):60109,sc=D?Symbol.for("react.context"):60110,tc=D?Symbol.for("react.concurrent_mode"):60111,uc=D?Symbol.for("react.forward_ref"):60112,vc=D?Symbol.for("react.suspense"):
60113,wc=D?Symbol.for("react.memo"):60115,xc=D?Symbol.for("react.lazy"):60116,yc="function"===typeof Symbol&&Symbol.iterator;function zc(a){if(null===a||"object"!==typeof a)return null;a=yc&&a[yc]||a["@@iterator"];return"function"===typeof a?a:null}
function Ac(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case tc:return"ConcurrentMode";case oc:return"Fragment";case nc:return"Portal";case qc:return"Profiler";case pc:return"StrictMode";case vc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case sc:return"Context.Consumer";case rc:return"Context.Provider";case uc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case wc:return Ac(a.type);case xc:if(a=1===a._status?a._result:null)return Ac(a)}return null}function Bc(a){var b="";do{a:switch(a.tag){case 2:case 16:case 0:case 1:case 5:case 8:var c=a._debugOwner,d=a._debugSource,e=Ac(a.type);var f=null;c&&(f=Ac(c.type));c=e;e="";d?e=" (at "+d.fileName.replace(lc,"")+":"+d.lineNumber+")":f&&(e=" (created by "+f+")");f="\n    in "+(c||"Unknown")+e;break a;default:f=""}b+=f;a=a.return}while(a);return b}
var Cc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Dc=Object.prototype.hasOwnProperty,Ec={},Fc={};
function Gc(a){if(Dc.call(Fc,a))return!0;if(Dc.call(Ec,a))return!1;if(Cc.test(a))return Fc[a]=!0;Ec[a]=!0;return!1}function Hc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ic(a,b,c,d){if(null===b||"undefined"===typeof b||Hc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function F(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var G={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){G[a]=new F(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];G[b]=new F(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){G[a]=new F(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){G[a]=new F(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){G[a]=new F(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){G[a]=new F(a,3,!0,a,null)});
["capture","download"].forEach(function(a){G[a]=new F(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){G[a]=new F(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){G[a]=new F(a,5,!1,a.toLowerCase(),null)});var Mc=/[\-:]([a-z])/g;function Nc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Mc,
Nc);G[b]=new F(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Mc,Nc);G[b]=new F(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Mc,Nc);G[b]=new F(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});G.tabIndex=new F("tabIndex",1,!1,"tabindex",null);
function Oc(a,b,c,d){var e=G.hasOwnProperty(b)?G[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ic(b,c,e,d)&&(c=null),d||null===e?Gc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Pc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Qc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Rc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Pc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Sc(a,b){b=b.checked;null!=b&&Oc(a,"checked",b,!1)}
function Tc(a,b){Sc(a,b);var c=Pc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Uc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Uc(a,b.type,Pc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function bd(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Uc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var cd={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function dd(a,b,c){a=y.getPooled(cd.change,a,b,c);a.type="change";Wb(c);Wa(a);return a}var ed=null,fd=null;function gd(a){Ia(a,!1)}
function hd(a){var b=Pa(a);if(jc(b))return a}function id(a,b){if("change"===a)return b}var jd=!1;Xa&&(jd=fc("input")&&(!document.documentMode||9<document.documentMode));function kd(){ed&&(ed.detachEvent("onpropertychange",ld),fd=ed=null)}function ld(a){"value"===a.propertyName&&hd(fd)&&(a=dd(fd,a,ec(a)),bc(gd,a))}function md(a,b,c){"focus"===a?(kd(),ed=b,fd=c,ed.attachEvent("onpropertychange",ld)):"blur"===a&&kd()}function nd(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return hd(fd)}
function od(a,b){if("click"===a)return hd(b)}function pd(a,b){if("input"===a||"change"===a)return hd(b)}
var qd={eventTypes:cd,_isInputEventSupported:jd,extractEvents:function(a,b,c,d){var e=b?Pa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=id:dc(e)?jd?f=pd:(f=nd,g=md):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=od);if(f&&(f=f(a,b)))return dd(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Uc(e,"number",e.value)}},rd=y.extend({view:null,detail:null}),sd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function td(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=sd[a])?!!b[a]:!1}function ud(){return td}
var vd=0,wd=0,xd=!1,yd=!1,zd=rd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ud,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=vd;vd=a.screenX;return xd?"mousemove"===a.type?a.screenX-b:0:(xd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=wd;wd=a.screenY;return yd?"mousemove"===a.type?a.screenY-b:0:(yd=!0,0)}}),Ad=zd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Bd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Cd={eventTypes:Bd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)g=zd,h=Bd.mouseLeave,k=Bd.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)g=Ad,h=Bd.pointerLeave,k=Bd.pointerEnter,l="pointer";var m=null==f?e:Pa(f);e=null==b?e:Pa(b);a=g.getPooled(h,f,c,d);a.type=l+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;l=0;for(g=b;g;g=Ra(g))l++;g=0;for(k=e;k;k=Ra(k))g++;for(;0<l-g;)b=Ra(b),l--;for(;0<g-l;)e=Ra(e),g--;for(;l--;){if(b===e||b===e.alternate)break a;b=Ra(b);e=Ra(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=Ra(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=Ra(d)}for(d=0;d<b.length;d++)Ua(b[d],"bubbled",a);for(d=f.length;0<d--;)Ua(f[d],"captured",c);return[a,c]}},Dd=Object.prototype.hasOwnProperty;function Ed(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
function Fd(a,b){if(Ed(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!Dd.call(b,c[d])||!Ed(a[c[d]],b[c[d]]))return!1;return!0}function Gd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function Hd(a){2!==Gd(a)?r("188"):void 0}
function Id(a){var b=a.alternate;if(!b)return b=Gd(a),3===b?r("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return Hd(e),a;if(g===d)return Hd(e),b;g=g.sibling}r("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:r("189")}}c.alternate!==d?r("190"):void 0}3!==c.tag?r("188"):void 0;return c.stateNode.current===c?a:b}function Jd(a){a=Id(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var Kd=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Ld=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Md=rd.extend({relatedTarget:null});function Nd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Od={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Pd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Qd=rd.extend({key:function(a){if(a.key){var b=Od[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Nd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Pd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ud,charCode:function(a){return"keypress"===
a.type?Nd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Nd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=zd.extend({dataTransfer:null}),Sd=rd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ud}),Td=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Ud=zd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Vd=[["abort","abort"],[cb,"animationEnd"],[ib,"animationIteration"],[jb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[kb,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Wd={},Xd={};function Yd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Wd[a]=b;Xd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Yd(a,!0)});Vd.forEach(function(a){Yd(a,!1)});
var Zd={eventTypes:Wd,isInteractiveTopLevelEventType:function(a){a=Xd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Xd[a];if(!e)return null;switch(a){case "keypress":if(0===Nd(c))return null;case "keydown":case "keyup":a=Qd;break;case "blur":case "focus":a=Md;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=zd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
Rd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=Sd;break;case cb:case ib:case jb:a=Kd;break;case kb:a=Td;break;case "scroll":a=rd;break;case "wheel":a=Ud;break;case "copy":case "cut":case "paste":a=Ld;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Ad;break;default:a=y}b=a.getPooled(e,b,c,d);Wa(b);return b}},$d=Zd.isInteractiveTopLevelEventType,
ae=[];function be(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Na(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=ec(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<ra.length;h++){var k=ra[h];k&&(k=k.extractEvents(d,b,f,e))&&(g=Aa(g,k))}Ia(g,!1)}}var ce=!0;
function H(a,b){if(!b)return null;var c=($d(a)?de:ee).bind(null,a);b.addEventListener(a,c,!1)}function ge(a,b){if(!b)return null;var c=($d(a)?de:ee).bind(null,a);b.addEventListener(a,c,!0)}function de(a,b){Zb(ee,a,b)}
function ee(a,b){if(ce){var c=ec(b);c=Na(c);null===c||"number"!==typeof c.tag||2===Gd(c)||(c=null);if(ae.length){var d=ae.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{bc(be,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>ae.length&&ae.push(a)}}}var he={},ie=0,je="_reactListenersID"+(""+Math.random()).slice(2);
function ke(a){Object.prototype.hasOwnProperty.call(a,je)||(a[je]=ie++,he[a[je]]={});return he[a[je]]}function le(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function me(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function ne(a,b){var c=me(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=me(c)}}function oe(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?oe(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function pe(){for(var a=window,b=le();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=le(a.document)}return b}function qe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var re=Xa&&"documentMode"in document&&11>=document.documentMode,se={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},te=null,ue=null,He=null,Ie=!1;
function Je(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Ie||null==te||te!==le(c))return null;c=te;"selectionStart"in c&&qe(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return He&&Fd(He,c)?null:(He=c,a=y.getPooled(se.select,ue,a,b),a.type="select",a.target=te,Wa(a),a)}
var Ke={eventTypes:se,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=ke(e);f=va.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Pa(b):window;switch(a){case "focus":if(dc(e)||"true"===e.contentEditable)te=e,ue=b,He=null;break;case "blur":He=ue=te=null;break;case "mousedown":Ie=!0;break;case "contextmenu":case "mouseup":case "dragend":return Ie=!1,Je(c,d);case "selectionchange":if(re)break;
case "keydown":case "keyup":return Je(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa;xa=Oa;ya=Pa;Ga.injectEventPluginsByName({SimpleEventPlugin:Zd,EnterLeaveEventPlugin:Cd,ChangeEventPlugin:qd,SelectEventPlugin:Ke,BeforeInputEventPlugin:Mb});function Le(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function Me(a,b){a=n({children:void 0},b);if(b=Le(b.children))a.children=b;return a}function Ne(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Pc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Oe(a,b){null!=b.dangerouslySetInnerHTML?r("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Pe(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?r("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:r("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:Pc(c)}}
function Qe(a,b){var c=Pc(b.value),d=Pc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Re(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Se={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Te(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ue(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Te(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ve=void 0,We=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Se.svg||"innerHTML"in a)a.innerHTML=b;else{Ve=Ve||document.createElement("div");Ve.innerHTML="<svg>"+b+"</svg>";for(b=Ve.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Xe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Ye={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ze=["Webkit","ms","Moz","O"];Object.keys(Ye).forEach(function(a){Ze.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Ye[b]=Ye[a]})});
function $e(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Ye.hasOwnProperty(e)&&Ye[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var af=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function bf(a,b){b&&(af[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?r("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?r("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:r("61")),null!=b.style&&"object"!==typeof b.style?r("62",""):void 0)}
function cf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function df(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=ke(a);b=va[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":ge("scroll",a);break;case "focus":case "blur":ge("focus",a);ge("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":fc(e)&&ge(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===lb.indexOf(e)&&H(e,a)}c[e]=!0}}}function ef(){}var ff=null,gf=null;
function hf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function jf(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var kf=setTimeout,lf=clearTimeout;function mf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}
function nf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var of=[],pf=-1;function I(a){0>pf||(a.current=of[pf],of[pf]=null,pf--)}function J(a,b){pf++;of[pf]=a.current;a.current=b}var qf={},K={current:qf},L={current:!1},rf=qf;
function sf(a,b){var c=a.type.contextTypes;if(!c)return qf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function M(a){a=a.childContextTypes;return null!==a&&void 0!==a}function tf(a){I(L,a);I(K,a)}function uf(a){I(L,a);I(K,a)}
function vf(a,b,c){K.current!==qf?r("168"):void 0;J(K,b,a);J(L,c,a)}function wf(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:r("108",Ac(b)||"Unknown",e);return n({},c,d)}function xf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||qf;rf=K.current;J(K,b,a);J(L,L.current,a);return!0}
function yf(a,b,c){var d=a.stateNode;d?void 0:r("169");c?(b=wf(a,b,rf),d.__reactInternalMemoizedMergedChildContext=b,I(L,a),I(K,a),J(K,b,a)):I(L,a);J(L,c,a)}var zf=null,Af=null;function Bf(a){return function(b){try{return a(b)}catch(c){}}}
function Cf(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);zf=Bf(function(a){return b.onCommitFiberRoot(c,a)});Af=Bf(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Df(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function N(a,b,c,d){return new Df(a,b,c,d)}
function Ef(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Ff(a){if("function"===typeof a)return Ef(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===uc)return 11;if(a===wc)return 14}return 2}
function Gf(a,b){var c=a.alternate;null===c?(c=N(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.firstContextDependency=a.firstContextDependency;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Hf(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ef(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case oc:return If(c.children,e,f,b);case tc:return Jf(c,e|3,f,b);case pc:return Jf(c,e|2,f,b);case qc:return a=N(12,c,b,e|4),a.elementType=qc,a.type=qc,a.expirationTime=f,a;case vc:return a=N(13,c,b,e),a.elementType=vc,a.type=vc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case rc:g=10;break a;case sc:g=9;break a;case uc:g=11;break a;case wc:g=
14;break a;case xc:g=16;d=null;break a}r("130",null==a?a:typeof a,"")}b=N(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function If(a,b,c,d){a=N(7,a,d,b);a.expirationTime=c;return a}function Jf(a,b,c,d){a=N(8,a,d,b);b=0===(b&1)?pc:tc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function Kf(a,b,c){a=N(6,a,null,b);a.expirationTime=c;return a}
function Lf(a,b,c){b=N(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function Mf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c>b?a.earliestPendingTime=b:a.latestPendingTime<b&&(a.latestPendingTime=b);Nf(b,a)}
function Of(a,b){a.didError=!1;var c=a.latestPingedTime;0!==c&&c<=b&&(a.latestPingedTime=0);c=a.earliestPendingTime;var d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c>b?a.earliestSuspendedTime=b:d<b&&(a.latestSuspendedTime=b);Nf(b,a)}
function Pf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;if(0===b||0!==c&&c<b)b=c;if(0===b||0!==a&&a<b)b=a;return b}function Nf(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d>a)&&(e=d);a=e;0!==a&&0!==c&&c<a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var Qf=!1;
function Rf(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Sf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Tf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Uf(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Vf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=Rf(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=Rf(a.memoizedState),e=c.updateQueue=Rf(c.memoizedState)):d=a.updateQueue=Sf(e):null===e&&(e=c.updateQueue=Sf(d));null===e||d===e?Uf(d,b):null===d.lastUpdate||null===e.lastUpdate?(Uf(d,b),Uf(e,b)):(Uf(d,b),e.lastUpdate=b)}
function Wf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=Rf(a.memoizedState):Xf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Xf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Sf(b));return b}
function Yf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:Qf=!0}return d}
function Zf(a,b,c,d,e){Qf=!1;b=Xf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;if(m>e){if(null===g&&(g=k,f=l),0===h||h>m)h=m}else l=Yf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var p=k.expirationTime;if(p>e){if(null===m&&(m=k,null===g&&(f=l)),0===h||h>p)h=p}else l=Yf(a,b,k,l,c,d),
null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=l}
function $f(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ag(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ag(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ag(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?r("191",c):void 0;c.call(d)}a=a.nextEffect}}
function bg(a,b){return{value:a,source:b,stack:Bc(b)}}var cg={current:null},dg=null,eg=null,fg=null;function gg(a,b){var c=a.type._context;J(cg,c._currentValue,a);c._currentValue=b}function hg(a){var b=cg.current;I(cg,a);a.type._context._currentValue=b}function ig(a){dg=a;fg=eg=null;a.firstContextDependency=null}
function jg(a,b){if(fg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)fg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===eg?(null===dg?r("293"):void 0,dg.firstContextDependency=eg=b):eg=eg.next=b}return a._currentValue}var kg={},O={current:kg},lg={current:kg},mg={current:kg};function ng(a){a===kg?r("174"):void 0;return a}
function og(a,b){J(mg,b,a);J(lg,a,a);J(O,kg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ue(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Ue(b,c)}I(O,a);J(O,b,a)}function pg(a){I(O,a);I(lg,a);I(mg,a)}function qg(a){ng(mg.current);var b=ng(O.current);var c=Ue(b,a.type);b!==c&&(J(lg,a,a),J(O,c,a))}function rg(a){lg.current===a&&(I(O,a),I(lg,a))}var sg=kc.ReactCurrentOwner,tg=(new aa.Component).refs;
function ug(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var yg={isMounted:function(a){return(a=a._reactInternalFiber)?2===Gd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=vg();d=wg(d,a);var e=Tf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Vf(a,e);xg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=vg();d=wg(d,a);var e=Tf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Vf(a,e);xg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=vg();c=wg(c,a);var d=Tf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Vf(a,d);xg(a,c)}};function zg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Fd(c,d)||!Fd(e,f):!0}
function Ag(a,b,c){var d=!1,e=qf;var f=b.contextType;"object"===typeof f&&null!==f?f=sg.currentDispatcher.readContext(f):(e=M(b)?rf:K.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?sf(a,e):qf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=yg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Bg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&yg.enqueueReplaceState(b,b.state,null)}
function Cg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=tg;var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg.currentDispatcher.readContext(f):(f=M(b)?rf:K.current,e.context=sf(a,f));f=a.updateQueue;null!==f&&(Zf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(ug(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&
"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&yg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Zf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Dg=Array.isArray;
function Eg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?r("289"):void 0,d=c.stateNode);d?void 0:r("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===tg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?r("284"):void 0;c._owner?void 0:r("290",a)}return a}
function Fg(a,b){"textarea"!==a.type&&r("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Gg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Gf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Kf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Eg(a,b,c),d.return=a,d;d=Hf(c.type,c.key,c.props,null,a.mode,d);d.ref=Eg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Lf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=If(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Kf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case mc:return c=Hf(b.type,b.key,b.props,null,a.mode,c),c.ref=Eg(a,null,b),c.return=a,c;case nc:return b=Lf(b,a.mode,c),b.return=a,b}if(Dg(b)||
zc(b))return b=If(b,a.mode,c,null),b.return=a,b;Fg(a,b)}return null}function v(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case mc:return c.key===e?c.type===oc?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case nc:return c.key===e?l(a,b,c,d):null}if(Dg(c)||zc(c))return null!==e?null:m(a,b,c,d,null);Fg(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case mc:return a=a.get(null===d.key?c:d.key)||null,d.type===oc?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case nc:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Dg(d)||zc(d))return a=a.get(c)||null,m(b,a,d,e,null);Fg(b,d)}return null}function w(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,A=null;null!==q&&u<h.length;u++){q.index>u?(A=q,q=null):A=q.sibling;var t=v(e,q,h[u],k);if(null===t){null===q&&(q=A);break}a&&
q&&null===t.alternate&&b(e,q);g=f(t,g,u);null===m?l=t:m.sibling=t;m=t;q=A}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(A=B(q,e,u,h[u],k))a&&null!==A.alternate&&q.delete(null===A.key?u:A.key),g=f(A,g,u),null===m?l=A:m.sibling=A,m=A;a&&q.forEach(function(a){return b(e,a)});return l}function C(e,g,h,k){var l=zc(h);"function"!==typeof l?r("150"):void 0;h=l.call(h);null==h?r("151"):void 0;
for(var m=l=null,q=g,u=g=0,A=null,t=h.next();null!==q&&!t.done;u++,t=h.next()){q.index>u?(A=q,q=null):A=q.sibling;var w=v(e,q,t.value,k);if(null===w){q||(q=A);break}a&&q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=A}if(t.done)return c(e,q),l;if(null===q){for(;!t.done;u++,t=h.next())t=p(e,t.value,k),null!==t&&(g=f(t,g,u),null===m?l=t:m.sibling=t,m=t);return l}for(q=d(e,q);!t.done;u++,t=h.next())t=B(q,e,u,t.value,k),null!==t&&(a&&null!==t.alternate&&q.delete(null===t.key?u:
t.key),g=f(t,g,u),null===m?l=t:m.sibling=t,m=t);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===oc&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case mc:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===oc:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===oc?f.props.children:f.props,h);d.ref=Eg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===oc?(d=If(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Hf(f.type,f.key,f.props,null,a.mode,h),h.ref=Eg(a,d,f),h.return=a,a=h)}return g(a);case nc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Lf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=Kf(f,a.mode,h),d.return=a,a=d),g(a);if(Dg(f))return w(a,d,f,h);if(zc(f))return C(a,d,f,h);l&&Fg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,r("152",h.displayName||h.name||"Component")}return c(a,d)}}var Hg=Gg(!0),Ig=Gg(!1),Jg=null,Kg=null,Lg=!1;
function Mg(a,b){var c=N(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Ng(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}
function Og(a){if(Lg){var b=Kg;if(b){var c=b;if(!Ng(a,b)){b=mf(c);if(!b||!Ng(a,b)){a.effectTag|=2;Lg=!1;Jg=a;return}Mg(Jg,c)}Jg=a;Kg=nf(b)}else a.effectTag|=2,Lg=!1,Jg=a}}function Pg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;Jg=a}function Qg(a){if(a!==Jg)return!1;if(!Lg)return Pg(a),Lg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!jf(b,a.memoizedProps))for(b=Kg;b;)Mg(a,b),b=mf(b);Pg(a);Kg=Jg?mf(a.stateNode):null;return!0}function Rg(){Kg=Jg=null;Lg=!1}
function Sg(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:throw a._status=0,b=a._ctor,b=b(),b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)}),a._result=b,b;}}var Tg=kc.ReactCurrentOwner;function P(a,b,c,d){b.child=null===a?Ig(b,null,c,d):Hg(b,a.child,c,d)}
function Ug(a,b,c,d,e){c=c.render;var f=b.ref;if(!L.current&&b.memoizedProps===d&&f===(null!==a?a.ref:null))return Vg(a,b,e);d=c(d,f);P(a,b,d,e);return b.child}
function Wg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ef(g)&&void 0===g.defaultProps&&null===c.compare)return b.tag=15,b.type=g,Xg(a,b,g,d,e,f);a=Hf(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(0===e||e>f)if(e=g.memoizedProps,c=c.compare,c=null!==c?c:Fd,c(e,d)&&a.ref===b.ref)return Vg(a,b,f);a=Gf(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Xg(a,b,c,d,e,f){return null!==a&&(0===e||e>f)&&Fd(a.memoizedProps,d)&&a.ref===b.ref?Vg(a,b,f):Yg(a,b,c,d,f)}function Zg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Yg(a,b,c,d,e){var f=M(c)?rf:K.current;f=sf(b,f);ig(b,e);c=c(d,f);b.effectTag|=1;P(a,b,c,e);return b.child}
function $g(a,b,c,d,e){if(M(c)){var f=!0;xf(b)}else f=!1;ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ag(b,c,d,e),Cg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg.currentDispatcher.readContext(l):(l=M(c)?rf:K.current,l=sf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Bg(b,g,d,l);Qf=!1;var v=b.memoizedState;k=g.state=v;var B=b.updateQueue;null!==B&&(Zf(b,B,d,g,e),k=b.memoizedState);h!==d||v!==k||L.current||Qf?("function"===typeof m&&(ug(b,c,m,d),k=b.memoizedState),(h=Qf||zg(b,c,h,d,v,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=h,k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg.currentDispatcher.readContext(l):(l=M(c)?rf:K.current,l=sf(b,l)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Bg(b,g,d,l),Qf=!1,k=b.memoizedState,v=g.state=k,B=b.updateQueue,null!==B&&(Zf(b,B,d,g,e),v=b.memoizedState),h!==d||k!==v||L.current||Qf?("function"===typeof m&&(ug(b,c,m,d),v=b.memoizedState),(m=Qf||zg(b,c,h,d,k,v,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,v,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,v,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
v),g.props=d,g.state=v,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return ah(a,b,c,d,f,e)}
function ah(a,b,c,d,e,f){Zg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&yf(b,c,!1),Vg(a,b,f);d=b.stateNode;Tg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Hg(b,a.child,null,f),b.child=Hg(b,null,h,f)):P(a,b,h,f);b.memoizedState=d.state;e&&yf(b,c,!0);return b.child}function bh(a){var b=a.stateNode;b.pendingContext?vf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&vf(a,b.context,!1);og(a,b.containerInfo)}
function ch(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function dh(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;null!==f&&(f.alreadyCaptured?null!==a&&f===a.memoizedState?f={alreadyCaptured:!0,didTimeout:!0,timedOutAt:f.timedOutAt}:(f.alreadyCaptured=!0,f.didTimeout=!0):f=null);var g=null!==f&&f.didTimeout;if(null===a)g?(g=e.fallback,e=If(null,d,0,null),d=If(g,d,c,null),e.sibling=d,c=e,c.return=d.return=b):c=d=Ig(b,null,e.children,c);else{var h=a.memoizedState;null!==h&&h.didTimeout?(d=a.child,a=d.sibling,g?(c=e.fallback,d=Gf(d,d.pendingProps,
0),d.effectTag|=2,e=d.sibling=Gf(a,c,a.expirationTime),e.effectTag|=2,c=d,d.childExpirationTime=0,d=e,c.return=d.return=b):(g=a.child,d=Hg(b,d.child,e.children,c),Hg(b,g,null,c),c=d)):(a=a.child,g?(g=e.fallback,e=If(null,d,0,null),e.effectTag|=2,e.child=a,a.return=e,d=e.sibling=If(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Hg(b,a,e.children,c))}b.memoizedState=f;b.child=c;return d}
function Vg(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);var d=b.childExpirationTime;if(0===d||d>c)return null;null!==a&&b.child!==a.child?r("153"):void 0;if(null!==b.child){a=b.child;c=Gf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Gf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function eh(a,b,c){var d=b.expirationTime;if(null!==a&&a.memoizedProps===b.pendingProps&&!L.current&&(0===d||d>c)){switch(b.tag){case 3:bh(b);Rg();break;case 5:qg(b);break;case 1:M(b.type)&&xf(b);break;case 4:og(b,b.stateNode.containerInfo);break;case 10:gg(b,b.memoizedProps.value);break;case 13:if(d=b.memoizedState,null!==d&&d.didTimeout){d=b.child.childExpirationTime;if(0!==d&&d<=c)return dh(a,b,c);b=Vg(a,b,c);return null!==b?b.sibling:null}}return Vg(a,b,c)}b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=sf(b,K.current);ig(b,c);e=d(a,e);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;if(M(d)){var f=!0;xf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&ug(b,d,g,a);e.updater=yg;b.stateNode=e;e._reactInternalFiber=b;Cg(b,d,a,c);b=ah(null,b,d,!0,f,c)}else b.tag=0,
P(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=Sg(e);b.type=a;e=b.tag=Ff(a);f=ch(a,f);g=void 0;switch(e){case 0:g=Yg(null,b,a,f,c);break;case 1:g=$g(null,b,a,f,c);break;case 11:g=Ug(null,b,a,f,c);break;case 14:g=Wg(null,b,a,ch(a.type,f),d,c);break;default:r("283",a)}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ch(d,e),Yg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:ch(d,e),$g(a,b,d,e,c);case 3:bh(b);d=b.updateQueue;null===d?r("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;Zf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Rg(),b=Vg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)Kg=nf(b.stateNode.containerInfo),Jg=b,e=Lg=!0;e?(b.effectTag|=2,b.child=Ig(b,null,d,c)):(P(a,b,d,c),Rg());b=b.child}return b;case 5:return qg(b),null===a&&Og(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,jf(d,
e)?g=null:null!==f&&jf(d,f)&&(b.effectTag|=16),Zg(a,b),1073741823!==c&&b.mode&1&&e.hidden?(b.expirationTime=1073741823,b=null):(P(a,b,g,c),b=b.child),b;case 6:return null===a&&Og(b),null;case 13:return dh(a,b,c);case 4:return og(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Hg(b,null,d,c):P(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ch(d,e),Ug(a,b,d,e,c);case 7:return P(a,b,b.pendingProps,c),b.child;case 8:return P(a,b,b.pendingProps.children,
c),b.child;case 12:return P(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;gg(b,f);if(null!==g){var h=g.value;f=h===f&&(0!==h||1/h===1/f)||h!==h&&f!==f?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!L.current){b=Vg(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){h=g.firstContextDependency;if(null!==h){do{if(h.context===d&&0!==(h.observedBits&
f)){if(1===g.tag){var k=Tf(c);k.tag=2;Vf(g,k)}if(0===g.expirationTime||g.expirationTime>c)g.expirationTime=c;k=g.alternate;null!==k&&(0===k.expirationTime||k.expirationTime>c)&&(k.expirationTime=c);for(var l=g.return;null!==l;){k=l.alternate;if(0===l.childExpirationTime||l.childExpirationTime>c)l.childExpirationTime=c,null!==k&&(0===k.childExpirationTime||k.childExpirationTime>c)&&(k.childExpirationTime=c);else if(null!==k&&(0===k.childExpirationTime||k.childExpirationTime>c))k.childExpirationTime=
c;else break;l=l.return}}k=g.child;h=h.next}while(null!==h)}else k=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==k)k.return=g;else for(k=g;null!==k;){if(k===b){k=null;break}g=k.sibling;if(null!==g){g.return=k.return;k=g;break}k=k.return}g=k}}P(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,ig(b,c),e=jg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,P(a,b,d,c),b.child;case 14:return e=b.type,f=ch(e.type,b.pendingProps),Wg(a,b,e,f,d,c);case 15:return Xg(a,
b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ch(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,M(d)?(a=!0,xf(b)):a=!1,ig(b,c),Ag(b,d,e,c),Cg(b,d,e,c),ah(null,b,d,!0,a,c);default:r("156")}}function zh(a){a.effectTag|=4}var Ah=void 0,Bh=void 0,Ch=void 0,Dh=void 0;
Ah=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Bh=function(){};
Ch=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ng(O.current);a=null;switch(c){case "input":f=Qc(g,f);d=Qc(g,d);a=[];break;case "option":f=Me(g,f);d=Me(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Oe(g,f);d=Oe(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ef)}bf(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var k=f[c];for(g in k)k.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ua.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(g in k)!k.hasOwnProperty(g)||l&&l.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in l)l.hasOwnProperty(g)&&k[g]!==l[g]&&(h||
(h={}),h[g]=l[g])}else h||(a||(a=[]),a.push(c,h)),h=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ua.hasOwnProperty(c)?(null!=l&&df(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&zh(b)}};Dh=function(a,b,c,d){c!==d&&zh(b)};
function Eh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Bc(c));null!==c&&Ac(c.type);b=b.value;null!==a&&1===a.tag&&Ac(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Fh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Gh(a,c)}else b.current=null}
function Hh(a){"function"===typeof Af&&Af(a);switch(a.tag){case 1:Fh(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Gh(a,c)}break;case 5:Fh(a);break;case 4:Ih(a)}}function Jh(a){return 5===a.tag||3===a.tag||4===a.tag}
function Kh(a){a:{for(var b=a.return;null!==b;){if(Jh(b)){var c=b;break a}b=b.return}r("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:r("161")}c.effectTag&16&&(Xe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Jh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=ef)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Ih(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?r("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Hh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?(d=b.stateNode.containerInfo,e=!0):Hh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Lh(a,b){switch(b.tag){case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ma]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Sc(c,d);cf(a,e);b=cf(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?$e(c,h):"dangerouslySetInnerHTML"===g?We(c,h):"children"===g?Xe(c,h):Oc(c,g,h,b)}switch(a){case "input":Tc(c,d);break;case "textarea":Qe(c,d);break;case "select":a=c._wrapperState.wasMultiple,
c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?Ne(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?Ne(c,!!d.multiple,d.defaultValue,!0):Ne(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:null===b.stateNode?r("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:break;case 17:break;default:r("163")}}function Mh(a,b,c){c=Tf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Nh(d);Eh(a,b)};return c}
function Oh(a,b,c){c=Tf(c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ph?Ph=new Set([this]):Ph.add(this));var c=b.value,e=b.stack;Eh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Qh(a){switch(a.tag){case 1:M(a.type)&&tf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return pg(a),uf(a),b=a.effectTag,0!==(b&64)?r("285"):void 0,a.effectTag=b&-1025|64,a;case 5:return rg(a),null;case 13:b=a.effectTag;if(b&1024){a.effectTag=b&-1025|64;b=a.alternate;b=null!==b?b.memoizedState:null;var c=a.memoizedState;null===c?c={alreadyCaptured:!0,didTimeout:!1,timedOutAt:0}:b===c?c={alreadyCaptured:!0,didTimeout:c.didTimeout,timedOutAt:c.timedOutAt}:c.alreadyCaptured=
!0;a.memoizedState=c;return a}return null;case 4:return pg(a),null;case 10:return hg(a),null;default:return null}}var Rh={readContext:jg},Sh=kc.ReactCurrentOwner,Th=0,Uh=0,Vh=!1,Q=null,R=null,S=0,Wh=-1,Xh=!1,T=null,Yh=!1,Ph=null;function Zh(){if(null!==Q)for(var a=Q.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&tf(b);break;case 3:pg(b);uf(b);break;case 5:rg(b);break;case 4:pg(b);break;case 10:hg(b)}a=a.return}R=null;S=0;Wh=-1;Xh=!1;Q=null}
function $h(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){var e=b;b=a;var f=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:M(b.type)&&tf(b);break;case 3:pg(b);uf(b);f=b.stateNode;f.pendingContext&&(f.context=f.pendingContext,f.pendingContext=null);if(null===e||null===e.child)Qg(b),b.effectTag&=-3;Bh(b);break;case 5:rg(b);var g=ng(mg.current),h=b.type;if(null!==e&&null!=b.stateNode)Ch(e,b,h,f,g),e.ref!==b.ref&&(b.effectTag|=128);
else if(f){var k=ng(O.current);if(Qg(b)){f=b;e=f.stateNode;var l=f.type,m=f.memoizedProps,p=g;e[La]=f;e[Ma]=m;h=void 0;g=l;switch(g){case "iframe":case "object":H("load",e);break;case "video":case "audio":for(l=0;l<lb.length;l++)H(lb[l],e);break;case "source":H("error",e);break;case "img":case "image":case "link":H("error",e);H("load",e);break;case "form":H("reset",e);H("submit",e);break;case "details":H("toggle",e);break;case "input":Rc(e,m);H("invalid",e);df(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};H("invalid",e);df(p,"onChange");break;case "textarea":Pe(e,m),H("invalid",e),df(p,"onChange")}bf(g,m);l=null;for(h in m)m.hasOwnProperty(h)&&(k=m[h],"children"===h?"string"===typeof k?e.textContent!==k&&(l=["children",k]):"number"===typeof k&&e.textContent!==""+k&&(l=["children",""+k]):ua.hasOwnProperty(h)&&null!=k&&df(p,h));switch(g){case "input":ic(e);bd(e,m,!0);break;case "textarea":ic(e);Re(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=ef)}h=l;f.updateQueue=h;f=null!==h?!0:!1;f&&zh(b)}else{m=b;e=h;p=f;l=9===g.nodeType?g:g.ownerDocument;k===Se.html&&(k=Te(e));k===Se.html?"script"===e?(e=l.createElement("div"),e.innerHTML="<script>\x3c/script>",l=e.removeChild(e.firstChild)):"string"===typeof p.is?l=l.createElement(e,{is:p.is}):(l=l.createElement(e),"select"===e&&p.multiple&&(l.multiple=!0)):l=l.createElementNS(k,e);e=l;e[La]=m;e[Ma]=f;Ah(e,b,!1,!1);p=e;l=h;m=f;var v=g,B=cf(l,m);switch(l){case "iframe":case "object":H("load",
p);g=m;break;case "video":case "audio":for(g=0;g<lb.length;g++)H(lb[g],p);g=m;break;case "source":H("error",p);g=m;break;case "img":case "image":case "link":H("error",p);H("load",p);g=m;break;case "form":H("reset",p);H("submit",p);g=m;break;case "details":H("toggle",p);g=m;break;case "input":Rc(p,m);g=Qc(p,m);H("invalid",p);df(v,"onChange");break;case "option":g=Me(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};g=n({},m,{value:void 0});H("invalid",p);df(v,"onChange");break;case "textarea":Pe(p,
m);g=Oe(p,m);H("invalid",p);df(v,"onChange");break;default:g=m}bf(l,g);k=void 0;var w=l,C=p,u=g;for(k in u)if(u.hasOwnProperty(k)){var q=u[k];"style"===k?$e(C,q):"dangerouslySetInnerHTML"===k?(q=q?q.__html:void 0,null!=q&&We(C,q)):"children"===k?"string"===typeof q?("textarea"!==w||""!==q)&&Xe(C,q):"number"===typeof q&&Xe(C,""+q):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(ua.hasOwnProperty(k)?null!=q&&df(v,k):null!=q&&Oc(C,k,q,B))}switch(l){case "input":ic(p);
bd(p,m,!1);break;case "textarea":ic(p);Re(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+Pc(m.value));break;case "select":g=p;g.multiple=!!m.multiple;p=m.value;null!=p?Ne(g,!!m.multiple,p,!1):null!=m.defaultValue&&Ne(g,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof g.onClick&&(p.onclick=ef)}(f=hf(h,f))&&zh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?r("166"):void 0;break;case 6:e&&null!=b.stateNode?Dh(e,b,e.memoizedProps,f):("string"!==
typeof f&&(null===b.stateNode?r("166"):void 0),e=ng(mg.current),ng(O.current),Qg(b)?(f=b,h=f.stateNode,e=f.memoizedProps,h[La]=f,(f=h.nodeValue!==e)&&zh(b)):(h=b,f=(9===e.nodeType?e:e.ownerDocument).createTextNode(f),f[La]=b,h.stateNode=f));break;case 11:break;case 13:f=b.memoizedState;h=null!==e?e.memoizedState:null;(null!==f&&f.didTimeout)!==(null!==h&&h.didTimeout)&&(b.effectTag|=4);break;case 7:break;case 8:break;case 12:break;case 4:pg(b);Bh(b);break;case 10:hg(b);break;case 9:break;case 14:break;
case 17:M(b.type)&&tf(b);break;default:r("156")}Q=null;b=a;if(1073741823===S||1073741823!==b.childExpirationTime){f=0;for(h=b.child;null!==h;){e=h.expirationTime;g=h.childExpirationTime;if(0===f||0!==e&&e<f)f=e;if(0===f||0!==g&&g<f)f=g;h=h.sibling}b.childExpirationTime=f}null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?
c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Qh(a,S);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512)}if(null!==d)return d;if(null!==c)a=c;else break}return null}function ai(a){var b=eh(a.alternate,a,S);a.memoizedProps=a.pendingProps;null===b&&(b=$h(a));Sh.current=null;return b}
function bi(a,b,c){Vh?r("243"):void 0;Vh=!0;Sh.currentDispatcher=Rh;var d=a.nextExpirationTimeToWorkOn;if(d!==S||a!==R||null===Q)Zh(),R=a,S=d,Q=Gf(R.current,null,S),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==Q&&!ci();)Q=ai(Q);else for(;null!==Q;)Q=ai(Q)}catch(C){if(null===Q)e=!0,Nh(C);else{null===Q?r("271"):void 0;var f=Q,g=f.return;if(null===g)e=!0,Nh(C);else{a:{var h=a,k=g,l=f,m=C;g=S;l.effectTag|=512;l.firstEffect=l.lastEffect=null;if(null!==m&&"object"===typeof m&&"function"===
typeof m.then){var p=m;m=k;var v=-1,B=-1;do{if(13===m.tag){var w=m.alternate;if(null!==w&&(w=w.memoizedState,null!==w&&w.didTimeout)){B=10*(w.timedOutAt-2);break}w=m.pendingProps.maxDuration;if("number"===typeof w)if(0>=w)v=0;else if(-1===v||w<v)v=w}m=m.return}while(null!==m);m=k;do{if(w=13===m.tag)void 0===m.memoizedProps.fallback?w=!1:(w=m.memoizedState,w=null===w||!w.didTimeout);if(w){k=di.bind(null,h,m,l,0===(m.mode&1)?1:g);p.then(k,k);if(0===(m.mode&1)){m.effectTag|=32;P(l.alternate,l,null,g);
l.effectTag&=-513;1===l.tag&&(l.effectTag&=-421,null===l.alternate&&(l.tag=17));break a}-1===v?h=1073741823:(-1===B&&(B=10*(Pf(h,g)-2)-5E3),h=B+v);0<=h&&Wh<h&&(Wh=h);m.effectTag|=1024;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error("An update was suspended, but no placeholder UI was provided.")}Xh=!0;m=bg(m,l);h=k;do{switch(h.tag){case 3:l=m;h.effectTag|=1024;h.expirationTime=g;g=Mh(h,l,g);Wf(h,g);break a;case 1:if(l=m,k=h.type,p=h.stateNode,0===(h.effectTag&64)&&("function"===typeof k.getDerivedStateFromError||
null!==p&&"function"===typeof p.componentDidCatch&&(null===Ph||!Ph.has(p)))){h.effectTag|=1024;h.expirationTime=g;g=Oh(h,l,g);Wf(h,g);break a}}h=h.return}while(null!==h)}Q=$h(f);continue}}}break}while(1);Vh=!1;fg=eg=dg=Sh.currentDispatcher=null;if(e)R=null,a.finishedWork=null;else if(null!==Q)a.finishedWork=null;else{b=a.current.alternate;null===b?r("281"):void 0;R=null;if(Xh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e>d||0!==f&&f>d||0!==g&&g>d){Of(a,d);ei(a,b,
d,a.expirationTime,-1);return}if(!a.didError&&!c){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;c=a.expirationTime=1;ei(a,b,d,c,-1);return}}c||-1===Wh?(a.pendingCommitExpirationTime=d,a.finishedWork=b):(Of(a,d),c=10*(Pf(a,d)-2),c<Wh&&(Wh=c),c=10*(vg()-2),c=Wh-c,ei(a,b,d,a.expirationTime,0>c?0:c))}}
function Gh(a,b){var c;a:{Vh&&!Yh?r("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ph||!Ph.has(d))){a=bg(b,a);a=Oh(c,a,1);Vf(c,a);xg(c,1);c=void 0;break a}break;case 3:a=bg(b,a);a=Mh(c,a,1);Vf(c,a);xg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=bg(b,a),c=Mh(a,c,1),Vf(a,c),xg(a,1));c=void 0}return c}
function wg(a,b){0!==Uh?a=Uh:Vh?a=Yh?1:S:b.mode&1?(a=fi?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1),null!==R&&a===S&&(a+=1)):a=1;fi&&a>gi&&(gi=a);return a}
function di(a,b,c,d){var e=a.earliestSuspendedTime;var f=a.latestSuspendedTime;if(0!==e&&d>=e&&d<=f){f=e=d;a.didError=!1;var g=a.latestPingedTime;if(0===g||g<f)a.latestPingedTime=f;Nf(f,a)}else e=vg(),e=wg(e,b),Mf(a,e);0!==(b.mode&1)&&a===R&&S===d&&(R=null);hi(b,e);0===(b.mode&1)&&(hi(c,e),1===c.tag&&null!==c.stateNode&&(b=Tf(e),b.tag=2,Vf(c,b)));c=a.expirationTime;0!==c&&ii(a,c)}
function hi(a,b){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;var c=a.alternate;null!==c&&(0===c.expirationTime||c.expirationTime>b)&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;if(0===d.childExpirationTime||d.childExpirationTime>b)d.childExpirationTime=b;null!==c&&(0===c.childExpirationTime||c.childExpirationTime>b)&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return null===
e?null:e}function xg(a,b){a=hi(a,b);null!==a&&(!Vh&&0!==S&&b<S&&Zh(),Mf(a,b),Vh&&!Yh&&R===a||ii(a,a.expirationTime),ji>ki&&(ji=0,r("185")))}function li(a,b,c,d,e){var f=Uh;Uh=1;try{return a(b,c,d,e)}finally{Uh=f}}var U=null,V=null,mi=0,ni=void 0,W=!1,X=null,Y=0,gi=0,oi=!1,pi=!1,qi=null,ri=null,Z=!1,si=!1,fi=!1,ti=null,ui=da.unstable_now(),vi=(ui/10|0)+2,wi=vi,ki=50,ji=0,xi=null,yi=1;function zi(){vi=((da.unstable_now()-ui)/10|0)+2}
function Ai(a,b){if(0!==mi){if(b>mi)return;null!==ni&&da.unstable_cancelCallback(ni)}mi=b;a=da.unstable_now()-ui;ni=da.unstable_scheduleCallback(Bi,{timeout:10*(b-2)-a})}function ei(a,b,c,d,e){a.expirationTime=d;0!==e||ci()?0<e&&(a.timeoutHandle=kf(Ci.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ci(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;zi();wi=vi;Di(a,c)}function vg(){if(W)return wi;Ei();if(0===Y||1073741823===Y)zi(),wi=vi;return wi}
function ii(a,b){if(null===a.nextScheduledRoot)a.expirationTime=b,null===V?(U=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=U);else{var c=a.expirationTime;if(0===c||b<c)a.expirationTime=b}W||(Z?si&&(X=a,Y=1,Fi(a,1,!0)):1===b?Gi(1,null):Ai(a,b))}
function Ei(){var a=0,b=null;if(null!==V)for(var c=V,d=U;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===V?r("244"):void 0;if(d===d.nextScheduledRoot){U=V=d.nextScheduledRoot=null;break}else if(d===U)U=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=U;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;if(1===a)break;
c=d;d=d.nextScheduledRoot}}X=b;Y=a}function Bi(a){if(a.didTimeout&&null!==U){zi();var b=U;do{var c=b.expirationTime;0!==c&&vi>=c&&(b.nextExpirationTimeToWorkOn=vi);b=b.nextScheduledRoot}while(b!==U)}Gi(0,a)}
function Gi(a,b){ri=b;Ei();if(null!==ri)for(zi(),wi=vi;null!==X&&0!==Y&&(0===a||a>=Y)&&(!oi||vi>=Y);)Fi(X,Y,vi>=Y),Ei(),zi(),wi=vi;else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Fi(X,Y,!0),Ei();null!==ri&&(mi=0,ni=null);0!==Y&&Ai(X,Y);ri=null;oi=!1;ji=0;xi=null;if(null!==ti)for(a=ti,ti=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Di(a,b){W?r("253"):void 0;X=a;Y=b;Fi(a,b,!0);Gi(1,null)}
function Fi(a,b,c){W?r("245"):void 0;W=!0;if(null===ri||c){var d=a.finishedWork;null!==d?Hi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,lf(d)),bi(a,!1,c),d=a.finishedWork,null!==d&&Hi(a,d,b))}else d=a.finishedWork,null!==d?Hi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,lf(d)),bi(a,!0,c),d=a.finishedWork,null!==d&&(ci()?a.finishedWork=d:Hi(a,d,b)));W=!1}
function Hi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===ti?ti=[d]:ti.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===xi?ji++:(xi=a,ji=0);Yh=Vh=!0;a.current===b?r("177"):void 0;var e=a.pendingCommitExpirationTime;0===e?r("261"):void 0;a.pendingCommitExpirationTime=0;var f=b.expirationTime,g=b.childExpirationTime,h=0===f||0!==g&&g<f?g:f;a.didError=!1;if(0===h)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=
0,a.latestPingedTime=0;else{var k=a.latestPendingTime;0!==k&&(k<h?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime<h&&(a.earliestPendingTime=a.latestPendingTime));var l=a.earliestSuspendedTime;0===l?Mf(a,h):h>a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,Mf(a,h)):h<l&&Mf(a,h)}Nf(0,a);Sh.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var m=b.firstEffect}else m=b;else m=b.firstEffect;ff=ce;var p=pe();if(qe(p)){if("selectionStart"in
p)var v={start:p.selectionStart,end:p.selectionEnd};else a:{var B=p.ownerDocument,w=B&&B.defaultView||window,C=w.getSelection&&w.getSelection();if(C&&0!==C.rangeCount){var u=C.anchorNode,q=C.anchorOffset,A=C.focusNode,fe=C.focusOffset;try{u.nodeType,A.nodeType}catch(db){v=null;break a}var Ib=0,Jc=-1,Kc=-1,Ni=0,Oi=0,t=p,Jb=null;b:for(;;){for(var Lc;;){t!==u||0!==q&&3!==t.nodeType||(Jc=Ib+q);t!==A||0!==fe&&3!==t.nodeType||(Kc=Ib+fe);3===t.nodeType&&(Ib+=t.nodeValue.length);if(null===(Lc=t.firstChild))break;
Jb=t;t=Lc}for(;;){if(t===p)break b;Jb===u&&++Ni===q&&(Jc=Ib);Jb===A&&++Oi===fe&&(Kc=Ib);if(null!==(Lc=t.nextSibling))break;t=Jb;Jb=t.parentNode}t=Lc}v=-1===Jc||-1===Kc?null:{start:Jc,end:Kc}}else v=null}var fh=v||{start:0,end:0}}else fh=null;gf={focusedElem:p,selectionRange:fh};ce=!1;for(T=m;null!==T;){var gh=!1,hh=void 0;try{for(;null!==T;){if(T.effectTag&256){var ve=T.alternate;a:{var Qb=T;switch(Qb.tag){case 1:if(Qb.effectTag&256&&null!==ve){var Zi=ve.memoizedProps,$i=ve.memoizedState,Vc=Qb.stateNode;
Vc.props=Qb.memoizedProps;Vc.state=Qb.memoizedState;var aj=Vc.getSnapshotBeforeUpdate(Zi,$i);Vc.__reactInternalSnapshotBeforeUpdate=aj}break a;case 3:case 5:case 6:case 4:case 17:break a;default:r("163")}}}T=T.nextEffect}}catch(db){gh=!0,hh=db}gh&&(null===T?r("178"):void 0,Gh(T,hh),null!==T&&(T=T.nextEffect))}for(T=m;null!==T;){var ih=!1,jh=void 0;try{for(;null!==T;){var we=T.effectTag;we&16&&Xe(T.stateNode,"");if(we&128){var kh=T.alternate;if(null!==kh){var Wc=kh.ref;null!==Wc&&("function"===typeof Wc?
Wc(null):Wc.current=null)}}switch(we&14){case 2:Kh(T);T.effectTag&=-3;break;case 6:Kh(T);T.effectTag&=-3;Lh(T.alternate,T);break;case 4:Lh(T.alternate,T);break;case 8:var lh=T;Ih(lh);var Rb=lh;Rb.return=null;Rb.child=null;Rb.alternate&&(Rb.alternate.child=null,Rb.alternate.return=null)}T=T.nextEffect}}catch(db){ih=!0,jh=db}ih&&(null===T?r("178"):void 0,Gh(T,jh),null!==T&&(T=T.nextEffect))}var mh=gf,bj=pe(),E=mh.focusedElem,eb=mh.selectionRange;if(bj!==E&&E&&E.ownerDocument&&oe(E.ownerDocument.documentElement,
E)){if(null!==eb&&qe(E)){var nh=eb.start,xe=eb.end;void 0===xe&&(xe=nh);if("selectionStart"in E)E.selectionStart=nh,E.selectionEnd=Math.min(xe,E.value.length);else{var ye=E.ownerDocument||document,ba=(ye&&ye.defaultView||window).getSelection(),oh=E.textContent.length,fb=Math.min(eb.start,oh),Sb=void 0===eb.end?fb:Math.min(eb.end,oh);if(!ba.extend&&fb>Sb){var cj=Sb;Sb=fb;fb=cj}var Tb=ne(E,fb),Ja=ne(E,Sb);if(Tb&&Ja&&(1!==ba.rangeCount||ba.anchorNode!==Tb.node||ba.anchorOffset!==Tb.offset||ba.focusNode!==
Ja.node||ba.focusOffset!==Ja.offset)){var Xc=ye.createRange();Xc.setStart(Tb.node,Tb.offset);ba.removeAllRanges();fb>Sb?(ba.addRange(Xc),ba.extend(Ja.node,Ja.offset)):(Xc.setEnd(Ja.node,Ja.offset),ba.addRange(Xc))}}}for(var ze=[],gb=E;gb=gb.parentNode;)1===gb.nodeType&&ze.push({element:gb,left:gb.scrollLeft,top:gb.scrollTop});"function"===typeof E.focus&&E.focus();for(var Ae=0;Ae<ze.length;Ae++){var Yc=ze[Ae];Yc.element.scrollLeft=Yc.left;Yc.element.scrollTop=Yc.top}}gf=null;ce=!!ff;ff=null;a.current=
b;for(T=m;null!==T;){var ph=!1,qh=void 0;try{for(var dj=e;null!==T;){var rh=T.effectTag;if(rh&36){var Zc=void 0,hb=T.alternate,x=T,sh=dj;switch(x.tag){case 1:var ca=x.stateNode;if(x.effectTag&4)if(null===hb)ca.props=x.memoizedProps,ca.state=x.memoizedState,ca.componentDidMount();else{var ej=hb.memoizedProps,fj=hb.memoizedState;ca.props=x.memoizedProps;ca.state=x.memoizedState;ca.componentDidUpdate(ej,fj,ca.__reactInternalSnapshotBeforeUpdate)}var th=x.updateQueue;null!==th&&(ca.props=x.memoizedProps,
ca.state=x.memoizedState,$f(x,th,ca,sh));break;case 3:var uh=x.updateQueue;if(null!==uh){var Be=null;if(null!==x.child)switch(x.child.tag){case 5:Be=x.child.stateNode;break;case 1:Be=x.child.stateNode}$f(x,uh,Be,sh)}break;case 5:var gj=x.stateNode;null===hb&&x.effectTag&4&&hf(x.type,x.memoizedProps)&&gj.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(x.effectTag&32){x.memoizedState={alreadyCaptured:!0,didTimeout:!1,timedOutAt:0};xg(x,1);break}var vh=null!==hb?hb.memoizedState:null,
Ub=x.memoizedState,hj=null!==vh?vh.didTimeout:!1,Ce=x;if(null===Ub)Zc=!1;else if(Zc=Ub.didTimeout)Ce=x.child,Ub.alreadyCaptured=!1,0===Ub.timedOutAt&&(Ub.timedOutAt=vg());if(Zc!==hj&&null!==Ce)a:for(var De=Ce,wh=Zc,z=De;;){if(5===z.tag){var ij=z.stateNode;if(wh)ij.style.display="none";else{var jj=z.stateNode,$c=z.memoizedProps.style,kj=void 0!==$c&&null!==$c&&$c.hasOwnProperty("display")?$c.display:null;jj.style.display=kj}}else if(6===z.tag)z.stateNode.nodeValue=wh?"":z.memoizedProps;else if(null!==
z.child){z.child.return=z;z=z.child;continue}if(z===De)break a;for(;null===z.sibling;){if(null===z.return||z.return===De)break a;z=z.return}z.sibling.return=z.return;z=z.sibling}break;case 17:break;default:r("163")}}if(rh&128){var ad=T.ref;if(null!==ad){var xh=T.stateNode;switch(T.tag){case 5:var Ee=xh;break;default:Ee=xh}"function"===typeof ad?ad(Ee):ad.current=Ee}}var lj=T.nextEffect;T.nextEffect=null;T=lj}}catch(db){ph=!0,qh=db}ph&&(null===T?r("178"):void 0,Gh(T,qh),null!==T&&(T=T.nextEffect))}Vh=
Yh=!1;"function"===typeof zf&&zf(b.stateNode);var Fe=b.expirationTime,Ge=b.childExpirationTime,yh=0===Fe||0!==Ge&&Ge<Fe?Ge:Fe;0===yh&&(Ph=null);a.expirationTime=yh;a.finishedWork=null}function ci(){return oi?!0:null===ri||ri.timeRemaining()>yi?!1:oi=!0}function Nh(a){null===X?r("246"):void 0;X.expirationTime=0;pi||(pi=!0,qi=a)}function Ii(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Gi(1,null)}}function Ji(a,b){if(Z&&!si){si=!0;try{return a(b)}finally{si=!1}}return a(b)}
function Ki(a,b,c){if(fi)return a(b,c);Z||W||0===gi||(Gi(gi,null),gi=0);var d=fi,e=Z;Z=fi=!0;try{return a(b,c)}finally{fi=d,(Z=e)||W||Gi(1,null)}}
function Li(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===Gd(c)&&1===c.tag?void 0:r("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(M(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);r("171");g=void 0}if(1===c.tag){var h=c.type;if(M(h)){c=wf(c,h,g);break a}}c=g}else c=qf;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Tf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
Vf(f,e);xg(f,d);return d}function Mi(a,b,c,d){var e=b.current,f=vg();e=wg(f,e);return Li(a,b,c,e,d)}function Pi(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Qi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:nc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Nb=function(a,b,c){switch(b){case "input":Tc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qa(d);e?void 0:r("90");jc(d);Tc(d,e)}}}break;case "textarea":Qe(a,c);break;case "select":b=c.value,null!=b&&Ne(a,!!c.multiple,b,!1)}};
function Ri(a){var b=2+25*(((vg()-2+500)/25|0)+1);b<=Th&&(b=Th+1);this._expirationTime=Th=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ri.prototype.render=function(a){this._defer?void 0:r("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Si;Li(a,b,null,c,d._onCommit);return d};
Ri.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ri.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:r("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?r("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Di(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ri.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Si(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Si.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Si.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?r("191",c):void 0;c()}}};
function Ti(a,b,c){b=N(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Ti.prototype.render=function(a,b){var c=this._internalRoot,d=new Si;b=void 0===b?null:b;null!==b&&d.then(b);Mi(a,c,null,d._onCommit);return d};Ti.prototype.unmount=function(a){var b=this._internalRoot,c=new Si;a=void 0===a?null:a;null!==a&&c.then(a);Mi(null,b,null,c._onCommit);return c};Ti.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Si;c=void 0===c?null:c;null!==c&&e.then(c);Mi(b,d,a,e._onCommit);return e};
Ti.prototype.createBatch=function(){var a=new Ri(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Ui(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Yb=Ii;Zb=Ki;$b=function(){W||0===gi||(Gi(gi,null),gi=0)};
function Vi(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Ti(a,!1,b)}
function Wi(a,b,c,d,e){Ui(c)?void 0:r("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Pi(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Vi(c,d);if("function"===typeof e){var h=e;e=function(){var a=Pi(f._internalRoot);h.call(a)}}Ji(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Pi(f._internalRoot)}
function Xi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ui(b)?void 0:r("200");return Qi(a,b,null,c)}
var Yi={createPortal:Xi,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?r("188"):r("268",Object.keys(a)));a=Jd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){return Wi(null,a,b,!0,c)},render:function(a,b,c){return Wi(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?r("38"):void 0;return Wi(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ui(a)?
void 0:r("40");return a._reactRootContainer?(Ji(function(){Wi(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Xi.apply(void 0,arguments)},unstable_batchedUpdates:Ii,unstable_interactiveUpdates:Ki,flushSync:function(a,b){W?r("187"):void 0;var c=Z;Z=!0;try{return li(a,b)}finally{Z=c,Gi(1,null)}},unstable_flushControlled:function(a){var b=Z;Z=!0;try{li(a)}finally{(Z=b)||W||Gi(1,null)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Oa,
Pa,Qa,Ga.injectEventPluginsByName,sa,Wa,function(a){Ba(a,Va)},Wb,Xb,ee,Ia]},unstable_createRoot:function(a,b){Ui(a)?void 0:r("278");return new Ti(a,!0,null!=b&&!0===b.hydrate)}};(function(a){var b=a.findFiberByHostInstance;return Cf(n({},a,{findHostInstanceByFiber:function(a){a=Jd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Na,bundleType:0,version:"16.6.0",rendererPackageName:"react-dom"});
var mj={default:Yi},nj=mj&&Yi||mj;module.exports=nj.default||nj;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(324);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var c=null,f=3,h=-1,k=-1,l=!1,m=!1,n="object"===typeof performance&&"function"===typeof performance.now,q={timeRemaining:n?function(){if(null!==c&&c.expirationTime<k)return 0;var a=p()-performance.now();return 0<a?a:0}:function(){if(null!==c&&c.expirationTime<k)return 0;var a=p()-Date.now();return 0<a?a:0},didTimeout:!1};function r(){if(!l){var a=c.expirationTime;m?t():m=!0;u(v,a)}}
function w(){var a=c,b=c.next;if(c===b)c=null;else{var d=c.previous;c=d.next=b;b.previous=d}a.next=a.previous=null;d=a.callback;b=a.expirationTime;a=a.priorityLevel;var e=f,R=k;f=a;k=b;try{var g=d(q)}finally{f=e,k=R}if("function"===typeof g)if(g={callback:g,priorityLevel:a,expirationTime:b,next:null,previous:null},null===c)c=g.next=g.previous=g;else{d=null;a=c;do{if(a.expirationTime>=b){d=a;break}a=a.next}while(a!==c);null===d?d=c:d===c&&(c=g,r());b=d.previous;b.next=d.previous=g;g.next=d;g.previous=
b}}function x(){if(-1===h&&null!==c&&1===c.priorityLevel){l=!0;q.didTimeout=!0;try{do w();while(null!==c&&1===c.priorityLevel)}finally{l=!1,null!==c?r():m=!1}}}function v(a){l=!0;q.didTimeout=a;try{if(a)for(;null!==c;){var b=exports.unstable_now();if(c.expirationTime<=b){do w();while(null!==c&&c.expirationTime<=b)}else break}else if(null!==c){do w();while(null!==c&&0<p()-exports.unstable_now())}}finally{l=!1,null!==c?r():m=!1,x()}}
var y=Date,z="function"===typeof setTimeout?setTimeout:void 0,A="function"===typeof clearTimeout?clearTimeout:void 0,B="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,C="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,D,E;function F(a){D=B(function(b){A(E);a(b)});E=z(function(){C(D);a(exports.unstable_now())},100)}if(n){var G=performance;exports.unstable_now=function(){return G.now()}}else exports.unstable_now=function(){return y.now()};var u,t,p;
if("undefined"!==typeof window&&window._schedMock){var H=window._schedMock;u=H[0];t=H[1];p=H[2]}else if("undefined"===typeof window||"function"!==typeof window.addEventListener){var I=null,J=-1,K=function(a,b){if(null!==I){var d=I;I=null;try{J=b,d(a)}finally{J=-1}}};u=function(a,b){-1!==J?setTimeout(u,0,a,b):(I=a,setTimeout(K,b,!0,b),setTimeout(K,1073741823,!1,1073741823))};t=function(){I=null};p=function(){return Infinity};exports.unstable_now=function(){return-1===J?0:J}}else{"undefined"!==typeof console&&
("function"!==typeof B&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof C&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var L=null,M=!1,N=-1,O=!1,P=!1,Q=0,S=33,T=33;p=function(){return Q};var U="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",
function(a){if(a.source===window&&a.data===U){M=!1;a=L;var b=N;L=null;N=-1;var d=exports.unstable_now(),e=!1;if(0>=Q-d)if(-1!==b&&b<=d)e=!0;else{O||(O=!0,F(V));L=a;N=b;return}if(null!==a){P=!0;try{a(e)}finally{P=!1}}}},!1);var V=function(a){if(null!==L){F(V);var b=a-Q+T;b<T&&S<T?(8>b&&(b=8),T=b<S?S:b):S=b;Q=a+T;M||(M=!0,window.postMessage(U,"*"))}else O=!1};u=function(a,b){L=a;N=b;P||0>b?window.postMessage(U,"*"):O||(O=!0,F(V))};t=function(){L=null;M=!1;N=-1}}exports.unstable_ImmediatePriority=1;
exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:break;default:a=3}var d=f,e=h;f=a;h=exports.unstable_now();try{return b()}finally{f=d,h=e,x()}};
exports.unstable_scheduleCallback=function(a,b){var d=-1!==h?h:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=d+b.timeout;else switch(f){case 1:b=d+-1;break;case 2:b=d+250;break;case 4:b=d+1073741823;break;default:b=d+5E3}a={callback:a,priorityLevel:f,expirationTime:b,next:null,previous:null};if(null===c)c=a.next=a.previous=a,r();else{d=null;var e=c;do{if(e.expirationTime>b){d=e;break}e=e.next}while(e!==c);null===d?d=c:d===c&&(c=a,r());b=d.previous;b.next=d.previous=
a;a.next=d;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)c=null;else{a===c&&(c=b);var d=a.previous;d.next=b;b.previous=d}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=f;return function(){var d=f,e=h;f=b;h=exports.unstable_now();try{return a.apply(this,arguments)}finally{f=d,h=e,x()}}};exports.unstable_getCurrentPriorityLevel=function(){return f};


/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/catalog-ws/view/modernwar-vol2",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/catalog-ws/view/modernwar-vol2"+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_style_theme__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_E2Book_css__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_E2Book_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_app_E2Book_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_LayoutEngine__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_Underlay__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_TableOfContents__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_Bookmarks__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_components_SearchResults__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_components_Menu_MenuBar__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_components_MainMenu_MainMenu__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_components_BookmarkMenu_BookmarksMenu__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_components_BookmarkMenu_DeleteBookmarkMenu__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_components_BookmarkMenu_ClearBookmarksMenu__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_components_BookmarkMenu_BookmarkingMenu__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_components_BookmarkMenu_AddNoteMenu__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_components_BookmarkMenu_AwaitingSelectionMenu__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_components_BookmarkMenu_NoteInput__ = __webpack_require__(1514);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var E2Book=function(_Component){_inherits(E2Book,_Component);function E2Book(){_classCallCheck(this,E2Book);return _possibleConstructorReturn(this,(E2Book.__proto__||Object.getPrototypeOf(E2Book)).apply(this,arguments));}_createClass(E2Book,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["f" /* Grommet */],{className:'App',full:true,theme:__WEBPACK_IMPORTED_MODULE_2_app_style_theme__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["d" /* Box */],{fill:true,align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_Underlay__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_BookElements_TableOfContents__["default"],{'aria-label':'table of contents'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_BookElements_Bookmarks__["default"],{'aria-label':'bookmarks'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_components_SearchResults__["a" /* default */],{'aria-label':'search results'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_LayoutEngine__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_app_components_BookmarkMenu_NoteInput__["a" /* default */],{'aria-label':'note input'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_components_Menu_MenuBar__["a" /* default */],{'aria-label':'menu bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_app_components_MainMenu_MainMenu__["a" /* default */],{'aria-label':'main menu'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_app_components_BookmarkMenu_BookmarksMenu__["a" /* default */],{'aria-label':'bookmarks menu'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_app_components_BookmarkMenu_BookmarkingMenu__["a" /* default */],{'aria-label':'bookmarking menu'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_components_BookmarkMenu_DeleteBookmarkMenu__["a" /* default */],{'aria-label':'delete bookmark menu'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_app_components_BookmarkMenu_ClearBookmarksMenu__["a" /* default */],{'aria-label':'clear bookmarks menu'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_app_components_BookmarkMenu_AwaitingSelectionMenu__["a" /* default */],{'aria-label':'awaiting selection'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_app_components_BookmarkMenu_AddNoteMenu__["a" /* default */],{'aria-label':'annotate bookmark menu'}))));}}]);return E2Book;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(E2Book)));

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(329);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Accordion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccordionPanel__ = __webpack_require__(397);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__AccordionPanel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Anchor__ = __webpack_require__(63);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Anchor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Box__ = __webpack_require__(9);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Box__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Calendar__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Carousel__ = __webpack_require__(411);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__Carousel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Chart__ = __webpack_require__(415);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CheckBox__ = __webpack_require__(419);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Clock__ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Collapsible__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DataTable__ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Diagram__ = __webpack_require__(449);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Distribution__ = __webpack_require__(452);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Drop__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DropButton__ = __webpack_require__(126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FormField__ = __webpack_require__(455);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Grid__ = __webpack_require__(457);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Grommet__ = __webpack_require__(460);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_18__Grommet__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Heading__ = __webpack_require__(62);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_19__Heading__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Image__ = __webpack_require__(465);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__InfiniteScroll__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Keyboard__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Layer__ = __webpack_require__(188);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_23__Layer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Markdown__ = __webpack_require__(471);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__MaskedInput__ = __webpack_require__(477);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Menu__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Meter__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Paragraph__ = __webpack_require__(189);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_28__Paragraph__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__RadioButton__ = __webpack_require__(484);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__RangeInput__ = __webpack_require__(487);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__RangeSelector__ = __webpack_require__(490);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__RoutedAnchor__ = __webpack_require__(493);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__RoutedButton__ = __webpack_require__(495);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Select__ = __webpack_require__(497);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__SkipLink__ = __webpack_require__(502);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__SkipLinks__ = __webpack_require__(504);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__SkipLinkTarget__ = __webpack_require__(506);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Stack__ = __webpack_require__(124);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_38__Stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Table__ = __webpack_require__(508);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__TableBody__ = __webpack_require__(510);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__TableCell__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__TableFooter__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__TableHeader__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__TableRow__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Tab__ = __webpack_require__(512);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_45__Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Tabs__ = __webpack_require__(515);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_46__Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Text__ = __webpack_require__(29);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_47__Text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__TextArea__ = __webpack_require__(518);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_48__TextArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__TextInput__ = __webpack_require__(84);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_49__TextInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Video__ = __webpack_require__(521);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__WorldMap__ = __webpack_require__(524);
/* unused harmony namespace reexport */





















































/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(330);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Accordion__["a"]; });


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccordionContext__ = __webpack_require__(180);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var activeAsArray = function activeAsArray(active) {
  return typeof active === 'number' ? [active] : active;
};

var Accordion =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Accordion, _Component);

  function Accordion() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      activeIndexes: []
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onPanelChange", function (index) {
      var activeIndexes = _this.state.activeIndexes;
      var nextActiveIndexes = (activeIndexes || []).concat();
      var _this$props = _this.props,
          onActive = _this$props.onActive,
          multiple = _this$props.multiple;
      var activeIndex = nextActiveIndexes.indexOf(index);

      if (activeIndex > -1) {
        nextActiveIndexes.splice(activeIndex, 1);
      } else if (multiple) {
        nextActiveIndexes.push(index);
      } else {
        nextActiveIndexes = [index];
      }

      _this.setState({
        activeIndexes: nextActiveIndexes
      }, function () {
        if (onActive) {
          onActive(nextActiveIndexes);
        }
      });
    });

    return _this;
  }

  Accordion.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var activeIndex = nextProps.activeIndex;
    var stateActiveIndexes = prevState.activeIndexes,
        stateActiveIndex = prevState.activeIndex;
    var activeIndexes = activeAsArray(activeIndex) || [];

    if ((typeof activeIndex !== 'undefined' || activeIndex !== stateActiveIndex) && activeIndexes.join() !== stateActiveIndexes.join()) {
      return {
        activeIndexes: activeIndexes,
        activeIndex: activeIndex
      };
    }

    return null;
  };

  var _proto = Accordion.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        animate = _this$props2.animate,
        children = _this$props2.children,
        messages = _this$props2.messages,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["animate", "children", "messages"]);

    var activeIndexes = this.state.activeIndexes;
    delete rest.onActive;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Box__["a" /* Box */], _extends({
      role: "tablist"
    }, rest, {
      overflow: "auto"
    }), __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(children).map(function (panel, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AccordionContext__["a" /* AccordionContext */].Provider, {
        key: "accordion-panel_" + (index + 0),
        value: {
          active: activeIndexes.indexOf(index) > -1,
          animate: animate,
          messages: messages,
          onPanelChange: function onPanelChange() {
            return _this2.onPanelChange(index);
          }
        }
      }, panel);
    }));
  };

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Accordion, "defaultProps", {
  animate: true,
  messages: {
    tabContents: 'Tab Contents'
  }
});

var AccordionDoc;

if (false) {
  AccordionDoc = require('./doc').doc(Accordion); // eslint-disable-line global-require
}

var AccordionWrapper = AccordionDoc || Accordion;


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Box; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contexts__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StyledBox__ = __webpack_require__(396);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var wrapWithHocs = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2__hocs__["d" /* withForwardRef */], Object(__WEBPACK_IMPORTED_MODULE_2__hocs__["b" /* withDocs */])('Box'));

var BoxImpl =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(BoxImpl, _Component);

  function BoxImpl() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = BoxImpl.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        a11yTitle = _this$props.a11yTitle,
        background = _this$props.background,
        children = _this$props.children,
        direction = _this$props.direction,
        elevation = _this$props.elevation,
        fill = _this$props.fill,
        forwardRef = _this$props.forwardRef,
        gap = _this$props.gap,
        overflow = _this$props.overflow,
        responsive = _this$props.responsive,
        tag = _this$props.tag,
        as = _this$props.as,
        wrap = _this$props.wrap,
        width = _this$props.width,
        height = _this$props.height,
        propsTheme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["a11yTitle", "background", "children", "direction", "elevation", "fill", "forwardRef", "gap", "overflow", "responsive", "tag", "as", "wrap", "width", "height", "theme"]);

    var theme = this.context || propsTheme;
    var contents = children;

    if (gap) {
      contents = [];
      var firstIndex;
      __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (child, index) {
        if (child) {
          if (firstIndex === undefined) {
            firstIndex = index;
          } else {
            contents.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StyledBox__["b" /* StyledBoxGap */], {
              key: index,
              gap: gap,
              directionProp: direction,
              responsive: responsive
            }));
          }
        }

        contents.push(child);
      });
    }

    var content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StyledBox__["a" /* StyledBox */], _extends({
      as: !as && tag ? tag : as,
      "aria-label": a11yTitle,
      background: background,
      ref: forwardRef,
      directionProp: direction,
      elevationProp: elevation,
      fillProp: fill,
      overflowProp: overflow,
      wrapProp: wrap,
      widthProp: width,
      heightProp: height,
      responsive: responsive
    }, rest), contents);

    if (background) {
      var dark = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* backgroundIsDark */])(background, theme);

      if (dark !== theme.dark) {
        content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__contexts__["c" /* ThemeContext */].Provider, {
          value: _extends({}, theme, {
            dark: dark
          })
        }, content);
      }
    }

    return content;
  };

  return BoxImpl;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(BoxImpl, "contextType", __WEBPACK_IMPORTED_MODULE_3__contexts__["c" /* ThemeContext */]);

_defineProperty(BoxImpl, "displayName", 'Box');

_defineProperty(BoxImpl, "defaultProps", {
  direction: 'column',
  margin: 'none',
  pad: 'none',
  responsive: true
});

Object.setPrototypeOf(BoxImpl.defaultProps, __WEBPACK_IMPORTED_MODULE_4__default_props__["a" /* defaultProps */]);
var Box = wrapWithHocs(BoxImpl);

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(341);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(342);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.5.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.forward_ref"):60112,n=b?Symbol.for("react.placeholder"):60113;
function q(a){if("object"===typeof a&&null!==a){var p=a.$$typeof;switch(p){case c:switch(a=a.type,a){case l:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case m:case h:return a;default:return p}}case d:return p}}}exports.typeOf=q;exports.AsyncMode=l;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=m;exports.Fragment=e;exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===l||a===g||a===f||a===n||"object"===typeof a&&null!==a&&("function"===typeof a.then||a.$$typeof===h||a.$$typeof===k||a.$$typeof===m)};exports.isAsyncMode=function(a){return q(a)===l};exports.isContextConsumer=function(a){return q(a)===k};exports.isContextProvider=function(a){return q(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};
exports.isForwardRef=function(a){return q(a)===m};exports.isFragment=function(a){return q(a)===e};exports.isProfiler=function(a){return q(a)===g};exports.isPortal=function(a){return q(a)===d};exports.isStrictMode=function(a){return q(a)===f};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

!function(e){ true?module.exports=e(null):"function"==typeof define&&define.amd?define(e(null)):window.stylis=e(null)}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
//# sourceMappingURL=stylis.min.js.map

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(347);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,r=b?Symbol.for("react.memo"):
60115,t=b?Symbol.for("react.lazy"):60116;function u(a){if("object"===typeof a&&null!==a){var q=a.$$typeof;switch(q){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return q}}case d:return q}}}function v(a){return u(a)===m}exports.typeOf=u;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;
exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||u(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return u(a)===k};exports.isContextProvider=function(a){return u(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return u(a)===n};exports.isFragment=function(a){return u(a)===e};exports.isProfiler=function(a){return u(a)===g};exports.isPortal=function(a){return u(a)===d};exports.isStrictMode=function(a){return u(a)===f};


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index]);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(350);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(352);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class)|(on[A-Z].*)|((data|aria|x)-.*))$/i;
var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(reactPropsRegex.test.bind(reactPropsRegex));

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnnounceContext__ = __webpack_require__(354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AnnounceContext__["a"]; });


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnnounceContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var createAnnouncer = function createAnnouncer() {
  var announcer = document.createElement('div');
  announcer.style.left = '-100%';
  announcer.style.right = '100%';
  announcer.style.position = 'fixed';
  announcer.style['z-index'] = '-1';
  document.body.insertBefore(announcer, document.body.firstChild);
  return announcer;
};

var AnnounceContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(function (message, mode) {
  if (mode === void 0) {
    mode = 'polite';
  }

  // we only create a new container if we don't have one already
  // we create a separate node so that grommet does not set aria-hidden to it
  var announcer = document.body.querySelector('[aria-live]') || createAnnouncer();
  announcer.setAttribute('aria-live', 'off');
  announcer.innerHTML = message;
  announcer.setAttribute('aria-live', mode);
  setTimeout(function () {
    announcer.innerHTML = '';
  }, 500);
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ResponsiveContext__ = __webpack_require__(356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ResponsiveContext__["a"]; });


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResponsiveContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ResponsiveContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeContext__ = __webpack_require__(358);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ThemeContext__["a"]; });


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(5);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2_styled_components__["a"]; });





__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeContext */].Extend = function (_ref) {
  var children = _ref.children,
      value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeContext */].Consumer, null, function (theme) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeContext */].Provider, {
      value: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["l" /* deepMerge */])(theme, value)
    }, children);
  });
};

__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeContext */].Extend.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired
};


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return normalizeBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return backgroundIsDark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return backgroundStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectedStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(173);



var normalizeBackground = function normalizeBackground(background, theme) {
  // If the background has a light or dark object, use that
  var result = background;

  if (background) {
    if (theme.dark && background.dark && typeof background.dark !== 'boolean') {
      result = background.dark;
    } else if (!theme.dark && background.light && typeof background.light !== 'boolean') {
      result = background.light;
    }

    result = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* evalStyle */])(result, theme);
  }

  return result;
};
var backgroundIsDark = function backgroundIsDark(backgroundArg, theme) {
  var background = normalizeBackground(backgroundArg, theme);
  var result;

  if (background) {
    if (typeof background === 'object') {
      var color = background.color,
          dark = background.dark,
          opacity = background.opacity;

      if (typeof dark === 'boolean') {
        result = dark;
      } else if (color && ( // weak opacity means we keep the existing darkness
      !opacity || opacity !== 'weak')) {
        var backgroundColor = Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])(background.color, theme);

        if (backgroundColor) {
          result = Object(__WEBPACK_IMPORTED_MODULE_1__colors__["a" /* colorIsDark */])(backgroundColor);
        }
      }
    } else {
      var _color = Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])(background, theme);

      if (_color) {
        result = Object(__WEBPACK_IMPORTED_MODULE_1__colors__["a" /* colorIsDark */])(_color);
      }
    }
  }

  return result;
};
var backgroundStyle = function backgroundStyle(backgroundArg, theme, textColorArg) {
  // If the background has a light or dark object, use that
  var background = normalizeBackground(backgroundArg, theme);
  var textColor = textColorArg || theme.global.colors.text;

  if (typeof background === 'object') {
    var styles = [];

    if (background.image) {
      var color;

      if (background.dark === false) {
        color = textColor.light;
      } else if (background.dark) {
        color = textColor.dark;
      } else if (!textColorArg) {
        color = 'inherit';
      }

      styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["background-image:", ";background-repeat:no-repeat;background-position:", ";background-size:cover;color:", ";"], background.image, background.position || 'center center', color));
    }

    if (background.color) {
      var _color2 = Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])(background.color, theme);

      var backgroundColor = Object(__WEBPACK_IMPORTED_MODULE_1__colors__["b" /* getRGBA */])(_color2, background.opacity === true ? theme.global.opacity.medium : theme.global.opacity[background.opacity] || background.opacity) || _color2;

      styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["background-color:", ";", ""], backgroundColor, (!background.opacity || background.opacity !== 'weak') && "color: " + textColor[background.dark || Object(__WEBPACK_IMPORTED_MODULE_1__colors__["a" /* colorIsDark */])(backgroundColor) ? 'dark' : 'light'] + ";"));
    }

    if (background.dark === false) {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["color:", ";"], textColor.light));
    } else if (background.dark) {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["color:", ";"], textColor.dark));
    }

    return styles;
  }

  if (background) {
    if (background.lastIndexOf('url', 0) === 0) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["background:", " no-repeat center center;background-size:cover;"], background);
    }

    var _color3 = Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])(background, theme);

    if (_color3) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["background:", ";color:", ";"], _color3, textColor[Object(__WEBPACK_IMPORTED_MODULE_1__colors__["a" /* colorIsDark */])(_color3) ? 'dark' : 'light']);
    }
  }

  return undefined;
};
var activeStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", " color:", ";"], function (props) {
  return backgroundStyle(Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])(props.theme.global.hover.background, props.theme), props.theme);
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])(props.theme.global.hover.color, props.theme);
});
var selectedStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", " color:", ";"], function (props) {
  return backgroundStyle(Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])(props.theme.global.selected.background, props.theme), props.theme);
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__colors__["c" /* normalizeColor */])(props.theme.global.selected.color, props.theme);
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return debounce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return debounceDelay; });
var _this = this;

var debounce = function debounce(cb, timer) {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = _this;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return cb.apply(context, args);
    }, timer);
  };
};
var debounceDelay = function debounceDelay(_ref) {
  var theme = _ref.theme;
  return theme.global.debounceDelay;
};

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filterByFocusable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findScrollParents; });
/* unused harmony export getFirstFocusableDescendant */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBodyChildElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getNewContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setFocusWithoutScroll; });
/* unused harmony export setTabIndex */
/* unused harmony export copyAttribute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return makeNodeFocusable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return makeNodeUnfocusable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findVisibleParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isNodeAfterScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isNodeBeforeScroll; });
var filterByFocusable = function filterByFocusable(elements) {
  return Array.prototype.filter.call(elements || [], function (element) {
    var currentTag = element.tagName.toLowerCase();
    var validTags = /(svg|a|area|input|select|textarea|button|iframe|div)$/;
    var isValidTag = currentTag.match(validTags) && element.focus;

    if (currentTag === 'a') {
      return isValidTag && element.childNodes.length > 0 && element.getAttribute('href');
    }

    if (currentTag === 'svg' || currentTag === 'div') {
      return isValidTag && element.hasAttribute('tabindex') && element.getAttribute('tabindex') !== '-1';
    }

    return isValidTag;
  });
};
var findScrollParents = function findScrollParents(element, horizontal) {
  var result = [];

  if (element) {
    var parent = element.parentNode;

    while (parent && parent.getBoundingClientRect) {
      var rect = parent.getBoundingClientRect(); // 10px is to account for borders and scrollbars in a lazy way

      if (horizontal) {
        if (rect.width && parent.scrollWidth > rect.width + 10) {
          result.push(parent);
        }
      } else if (rect.height && parent.scrollHeight > rect.height + 10) {
        result.push(parent);
      }

      parent = parent.parentNode;
    } // last scrollable element will be the document
    // if nothing else is scrollable in the page


    if (result.length === 0) {
      result.push(document);
    }
  }

  return result;
};
var getFirstFocusableDescendant = function getFirstFocusableDescendant(element) {
  var children = element.getElementsByTagName('*');

  for (var i = 0; i < children.length; i += 1) {
    var child = children[i];
    var tagName = child.tagName.toLowerCase();

    if (tagName === 'input' || tagName === 'select') {
      return child;
    }
  }

  return undefined;
};
var getBodyChildElements = function getBodyChildElements() {
  var excludeMatch = /^(script|link)$/i;
  var children = [];
  [].forEach.call(document.body.children, function (node) {
    if (!excludeMatch.test(node.tagName)) {
      children.push(node);
    }
  });
  return children;
};
var getNewContainer = function getNewContainer() {
  // setup DOM
  var container = document.createElement('div');
  document.body.appendChild(container);
  return container;
};
var setFocusWithoutScroll = function setFocusWithoutScroll(element) {
  var x = window.scrollX;
  var y = window.scrollY;
  element.focus();
  window.scrollTo(x, y);
};
var setTabIndex = function setTabIndex(tabIndex) {
  return function (element) {
    element.setAttribute('tabindex', tabIndex);
  };
};
var copyAttribute = function copyAttribute(source) {
  return function (target) {
    return function (element) {
      element.setAttribute(target, element.getAttribute(source));
    };
  };
};

var deleteAttribute = function deleteAttribute(attribute) {
  return function (element) {
    return element.removeAttribute(attribute);
  };
};

var unsetTabIndex = setTabIndex(-1);
var saveTabIndex = copyAttribute('tabindex')('data-g-tabindex');
var restoreTabIndex = copyAttribute('data-g-tabindex')('tabindex');
var deleteTabIndex = deleteAttribute('tabindex');
var deleteTabIndexCopy = deleteAttribute('data-g-tabindex');
var makeNodeFocusable = function makeNodeFocusable(node) {
  // do not touch aria live containers so that announcements work
  if (!node.hasAttribute('aria-live')) {
    node.setAttribute('aria-hidden', false); // allow children to receive focus again

    filterByFocusable(node.getElementsByTagName('*')).forEach(function (child) {
      if (child.hasAttribute('data-g-tabindex')) {
        restoreTabIndex(child);
      } else {
        deleteTabIndex(child);
      }

      deleteTabIndexCopy(child);
    });
  }
};
var makeNodeUnfocusable = function makeNodeUnfocusable(node) {
  // do not touch aria live containers so that announcements work
  if (!node.hasAttribute('aria-live')) {
    node.setAttribute('aria-hidden', true); // prevent children to receive focus

    filterByFocusable(node.getElementsByTagName('*')).forEach(function (child) {
      if (child.hasAttribute('tabindex')) {
        saveTabIndex(child);
      }

      unsetTabIndex(child);
    });
  }
};
var findVisibleParent = function findVisibleParent(element) {
  if (element) {
    return element.offsetParent ? element : findVisibleParent(element.parentElement) || element;
  }

  return undefined;
};
var isNodeAfterScroll = function isNodeAfterScroll(node, target) {
  if (target === void 0) {
    target = window;
  }

  var _node$getBoundingClie = node.getBoundingClientRect(),
      bottom = _node$getBoundingClie.bottom;

  var _target$getBoundingCl = target.getBoundingClientRect(),
      height = _target$getBoundingCl.height,
      top = _target$getBoundingCl.top;

  return bottom >= top + height;
};
var isNodeBeforeScroll = function isNodeBeforeScroll(node, target) {
  if (target === void 0) {
    target = window;
  }

  var _node$getBoundingClie2 = node.getBoundingClientRect(),
      top = _node$getBoundingClie2.top;

  var _target$getBoundingCl2 = target.getBoundingClientRect(),
      targetTop = _target$getBoundingCl2.top;

  return top <= targetTop;
};

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseUnit */
/* unused harmony export polarToCartesian */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arcCommands; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return translateEndAngle; });
var POST_DECIMAL_DIGITS = 10;
var baseUnit = 24;
var polarToCartesian = function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
};
var arcCommands = function arcCommands(centerX, centerY, radius, startAngle, endAngle) {
  // handle that we can't draw a complete circle
  var normalizedEndAngle = endAngle;

  if (endAngle - startAngle >= 360) {
    normalizedEndAngle = startAngle + 359.99;
  }

  var start = polarToCartesian(centerX, centerY, radius, normalizedEndAngle);
  var end = polarToCartesian(centerX, centerY, radius, startAngle);
  var arcSweep = normalizedEndAngle - startAngle <= 180 ? '0' : '1';
  var d = ['M', start.x.toFixed(POST_DECIMAL_DIGITS), start.y.toFixed(POST_DECIMAL_DIGITS), 'A', radius.toFixed(POST_DECIMAL_DIGITS), radius.toFixed(POST_DECIMAL_DIGITS), 0, arcSweep, 0, end.x.toFixed(POST_DECIMAL_DIGITS), end.y.toFixed(POST_DECIMAL_DIGITS)].join(' ');
  return d;
};
var translateEndAngle = function translateEndAngle(startAngle, anglePer, value) {
  return Math.min(360, Math.max(0, startAngle + anglePer * value));
};

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export a11yTitlePropType */
/* unused harmony export backgroundPropType */
/* unused harmony export colorPropType */
/* unused harmony export genericProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_desc__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_desc__);

var a11yTitlePropType = __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string.description('Custom title to be used by screen readers.');
var backgroundPropType = __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].shape({
  color: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string,
  opacity: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOf(['weak', 'medium', 'strong']), __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].bool])
})]).description('Background color');
var colorPropType = __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string, __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].shape({
  dark: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string,
  light: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string
})]);
var MARGIN_SIZES = ['xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge'];
var genericProps = {
  a11yTitle: a11yTitlePropType,
  alignSelf: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOf(['start', 'center', 'end', 'stretch']).description("How to align along the cross axis when contained in\n      a Box or along the column axis when contained in a Grid."),
  gridArea: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string.description("The name of the area to place\n    this inside a parent Grid."),
  margin: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOf(['none'].concat(MARGIN_SIZES)), __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].shape({
    bottom: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOf(MARGIN_SIZES), __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string]),
    horizontal: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOf(MARGIN_SIZES), __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string]),
    left: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOf(MARGIN_SIZES), __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string]),
    right: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOf(MARGIN_SIZES), __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string]),
    top: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOf(MARGIN_SIZES), __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string]),
    vertical: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOf(MARGIN_SIZES), __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string])
  }), __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string]).description("The amount of margin around the component. An object can\n      be specified to distinguish horizontal margin, vertical margin, and\n      margin on a particular side.")
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// array function should not be used here so that we can the local this
var addPropTypeDocumentationField = function addPropTypeDocumentationField(fieldName) {
  return function addFieldToReactDesc(value) {
    if (!this.reactDesc) {
      this.reactDesc = {};
    }
    this.reactDesc[fieldName] = value;
    return this;
  };
};

var documentedPropType = {
  defaultValue: addPropTypeDocumentationField('defaultValue'),
  description: addPropTypeDocumentationField('description'),
  deprecated: addPropTypeDocumentationField('deprecated'),
  format: addPropTypeDocumentationField('format')
};

var createPropType = function createPropType(type) {
  var propTypeObj = _extends({
    type: type
  }, documentedPropType);
  Object.defineProperty(propTypeObj, 'isRequired', {
    get: function getRequired() {
      if (!this.reactDesc) {
        this.reactDesc = {};
      }
      this.reactDesc.required = true;
      return this;
    },
    enumerable: true,
    configurable: true
  });
  return propTypeObj;
};

var createPropTypeWithArgs = function createPropTypeWithArgs(type) {
  return function (args) {
    var propTypeObj = _extends({
      args: args,
      type: type
    }, documentedPropType);
    Object.defineProperty(propTypeObj, 'isRequired', {
      get: function getRequired() {
        if (!this.reactDesc) {
          this.reactDesc = {};
        }
        this.reactDesc.required = true;
        return this;
      },
      enumerable: true,
      configurable: true
    });
    return propTypeObj;
  };
};

var PropTypes = {
  custom: function custom(callback) {
    var target = callback.bind(null);
    target.type = 'func';
    Object.keys(documentedPropType).forEach(function (fieldName) {
      target[fieldName] = documentedPropType[fieldName];
    });
    return target;
  }
};

function definePropType(type) {
  Object.defineProperty(PropTypes, type, {
    get: function getPropType() {
      return createPropType(type);
    },
    enumerable: true,
    configurable: true
  });
}

function definePropTypeWithArgs(type) {
  Object.defineProperty(PropTypes, type, {
    get: function getPropType() {
      return createPropTypeWithArgs(type);
    },
    enumerable: true,
    configurable: true
  });
}

definePropType('any');
definePropType('array');
definePropType('bool');
definePropType('element');
definePropType('func');
definePropType('node');
definePropType('number');
definePropType('object');
definePropType('symbol');
definePropType('string');

definePropTypeWithArgs('arrayOf');
definePropTypeWithArgs('instanceOf');
definePropTypeWithArgs('objectOf');
definePropTypeWithArgs('oneOfType');
definePropTypeWithArgs('oneOf');
definePropTypeWithArgs('shape');

exports.default = PropTypes;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = describe;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _descToJSON = __webpack_require__(175);

var _descToJSON2 = _interopRequireDefault(_descToJSON);

var _descToMarkdown = __webpack_require__(366);

var _descToMarkdown2 = _interopRequireDefault(_descToMarkdown);

var _descToTypescript = __webpack_require__(367);

var _descToTypescript2 = _interopRequireDefault(_descToTypescript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var convertArray = function convertArray(array) {
  return array.map(function (type) {
    return convertPropType(type);
  });
};

var convertShape = function convertShape(shape) {
  var result = {};
  Object.keys(shape).forEach(function (key) {
    result[key] = convertPropType(shape[key]);
  });
  return result;
};

var convertPropType = function convertPropType(propType) {
  var result = void 0;
  if (propType && propType.type) {
    if (!_propTypes2.default[propType.type]) {
      throw new Error('react-desc: unknown type ' + propType.type);
    }
    if (propType.args) {
      if (propType.type === 'oneOfType' || propType.type === 'arrayOf') {
        if (Array.isArray(propType.args)) {
          result = _propTypes2.default[propType.type](convertArray(propType.args));
        } else {
          result = _propTypes2.default[propType.type](convertPropType(propType.args));
        }
      } else if (propType.type === 'shape') {
        result = _propTypes2.default[propType.type](convertShape(propType.args));
      } else {
        result = _propTypes2.default[propType.type](propType.args);
      }
    } else {
      result = _propTypes2.default[propType.type];
    }
  } else {
    result = propType;
  }
  return result;
};

function describe(ComponentInstance) {
  if (!ComponentInstance) {
    throw new Error('react-desc: component is required');
  }

  var documentation = {
    propTypes: {}
  };

  var DocumentedComponent = ComponentInstance;

  var addDocumentationProp = function addDocumentationProp(propName) {
    return function (value) {
      documentation[propName] = value;
      return DocumentedComponent;
    };
  };

  DocumentedComponent.availableAt = addDocumentationProp('availableAt');
  DocumentedComponent.description = addDocumentationProp('description');
  DocumentedComponent.details = addDocumentationProp('details');
  DocumentedComponent.deprecated = addDocumentationProp('deprecated');
  DocumentedComponent.usage = addDocumentationProp('usage');
  DocumentedComponent.intrinsicElement = addDocumentationProp('intrinsicElement');

  DocumentedComponent.toJSON = _descToJSON2.default.bind(null, ComponentInstance, documentation);
  DocumentedComponent.toTypescript = _descToTypescript2.default.bind(null, ComponentInstance, documentation);
  DocumentedComponent.toMarkdown = _descToMarkdown2.default.bind(null, ComponentInstance, documentation);

  Object.defineProperty(DocumentedComponent, 'propTypes', {
    get: function get() {
      return DocumentedComponent.propTypesValue;
    },
    set: function set(value) {
      if (!DocumentedComponent.propTypesValue) {
        DocumentedComponent.propTypesValue = {};
      }
      Object.keys(value).forEach(function (name) {
        var propType = value[name];
        if (propType.type) {
          documentation.propTypes[name] = propType;
          propType = convertPropType(propType);
          if (value[name].reactDesc.required) {
            propType = propType.isRequired;
          }
        }
        DocumentedComponent.propTypesValue[name] = propType;
        return propType;
      });
    },
    enumerable: true,
    configurable: true
  });

  return DocumentedComponent;
}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = descToMarkdown;

var _descToJSON = __webpack_require__(175);

var _descToJSON2 = _interopRequireDefault(_descToJSON);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var code = '```';

function parseAvailableAt(_ref) {
  var badge = _ref.badge,
      url = _ref.url;

  return '[![](' + badge + ')](' + url + ')';
}

function getAvailableAt(_ref2) {
  var availableAt = _ref2.availableAt;

  if (!availableAt) {
    return '';
  }
  var availableAtStr = void 0;
  if (Array.isArray(availableAt)) {
    availableAtStr = availableAt.map(function (currentAvailable) {
      return parseAvailableAt(currentAvailable);
    }).join(' ');
  } else {
    availableAtStr = parseAvailableAt(availableAt);
  }
  return '\n' + availableAtStr;
}

function getHeader(_ref3) {
  var description = _ref3.description,
      details = _ref3.details,
      deprecated = _ref3.deprecated,
      name = _ref3.name;

  return '## ' + (deprecated ? '~~' + name + '~~' : name) + (deprecated ? ' (' + deprecated + ')' : '') + '\n' + description + (details ? '\n\n' + details : '') + '\n';
}

function getUsage(_ref4) {
  var usage = _ref4.usage;

  return usage ? '\n## Usage\n\n' + code + 'javascript\n' + usage + '\n' + code : '';
}

function getDefaultValue(defaultValue) {
  var defaultValueString = (typeof defaultValue === 'undefined' ? 'undefined' : _typeof(defaultValue)) === 'object' ? JSON.stringify(defaultValue, undefined, 2) : defaultValue;

  return ' Defaults to `' + defaultValueString + '`.';
}

function getProperties(_ref5) {
  var _ref5$properties = _ref5.properties,
      properties = _ref5$properties === undefined ? [] : _ref5$properties;

  var props = properties.map(function (_ref6) {
    var defaultValue = _ref6.defaultValue,
        deprecated = _ref6.deprecated,
        description = _ref6.description,
        format = _ref6.format,
        name = _ref6.name,
        required = _ref6.required;
    return '\n' + (deprecated ? '**~~' + name + '~~**' : '**' + name + '**') + (deprecated ? ' (' + deprecated + ')' : '') + '\n\n' + (required ? 'Required. ' : '') + description + (defaultValue ? getDefaultValue(defaultValue) : '') + '\n\n' + code + '\n' + format + '\n' + code;
  });
  return '\n\n## Properties\n' + props.join('\n') + '\n  ';
}

function getIntrinsicElement(_ref7) {
  var intrinsicElement = _ref7.intrinsicElement;

  return intrinsicElement ? '\n## Intrinsic element\n\n' + code + '\n' + intrinsicElement + '\n' + code : '';
}

function descToMarkdown(component, reactDesc) {
  if (!component) {
    throw new Error('react-desc: component is required');
  }

  var documentation = (0, _descToJSON2.default)(component, reactDesc);
  var availableAt = getAvailableAt(documentation);
  var header = getHeader(documentation);
  var usage = getUsage(documentation);
  var properties = getProperties(documentation);
  var intrinsicElement = getIntrinsicElement(documentation);
  return '' + header + availableAt + usage + properties + intrinsicElement;
}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = descToTypescript;

var arrayFormat = function arrayFormat(array) {
  return array.map(function (propType) {
    return propTypeFormat(propType);
  });
};

var shapeFormat = function shapeFormat(shape) {
  var props = Object.keys(shape).map(function (key) {
    var value = shape[key];
    var valueFormat = void 0;
    if (value.type && (value.type === 'arrayOf' || value.type === 'oneOfType' || value.type === 'oneOf') && Array.isArray(value.args)) {
      valueFormat = '' + propTypeFormat(value);
    } else if (value.type === 'shape') {
      valueFormat = '' + propTypeFormat(value);
    } else {
      valueFormat = propTypeFormat(value);
    }
    return '' + key + (value.reactDesc && value.reactDesc.required ? '' : '?') + ': ' + valueFormat;
  });
  return '{' + props.join(',') + '}';
};

var propTypeFormat = function propTypeFormat(propType) {
  var result = void 0;
  if (typeof propType !== 'function' && propType.type) {
    switch (propType.type) {
      case 'array':
        result = 'any[]';
        break;
      case 'arrayOf':
        if (Array.isArray(propType.args)) {
          result = arrayFormat(propType.args).join('\n') + '[]';
        } else if (propType.args.type === 'oneOfType') {
          result = propTypeFormat(propType.args) + '[]';
        } else {
          result = propTypeFormat(propType.args) + '[]';
        }
        break;
      case 'bool':
        result = 'boolean';
        break;
      case 'func':
        result = '((...args: any[]) => any)';
        break;
      case 'node':
        result = 'React.ReactNode';
        break;
      case 'element':
        result = 'JSX.Element';
        break;
      case 'instanceOf':
        result = 'any';
        break;
      case 'symbol':
        result = 'any';
        break;
      case 'objectOf':
        result = '{ [key: string]: ' + propType.args.type + ' }';
        break;
      case 'oneOf':
        result = propType.args.map(function (a) {
          return '"' + a + '"';
        }).join(' | ');
        break;
      case 'oneOfType':
        if (Array.isArray(propType.args)) {
          result = arrayFormat(propType.args).join(' | ');
        } else {
          result = '' + propTypeFormat(propType.args);
        }
        break;
      case 'shape':
        result = '' + shapeFormat(propType.args);
        break;
      default:
        result = '' + propType.type;
        break;
    }
  } else {
    result = 'any';
  }
  return result;
};

var propTypeAsTypescript = function propTypeAsTypescript(propType, propName) {
  var documentation = _extends({}, propType.reactDesc, {
    name: propName
  });

  documentation.format = propTypeFormat(propType);

  return documentation;
};

function descToTypescript(component) {
  var reactDesc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!component) {
    throw new Error('react-desc: component is required');
  }

  var documentation = _extends({
    name: component.displayName || component.name
  }, reactDesc);
  if (reactDesc) {
    delete documentation.propTypes;

    if (reactDesc.propTypes) {
      var propTypes = [];
      Object.keys(reactDesc.propTypes).forEach(function (propName) {
        var propType = reactDesc.propTypes[propName];
        propTypes.push(propTypeAsTypescript(propType, propName));
      });
      if (propTypes.length > 0) {
        documentation.properties = propTypes;
      }
    }
  }
  return documentation;
}

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBreakpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDeviceBreakpoint; });
var getBreakpoint = function getBreakpoint(windowWidth, theme) {
  var result;
  Object.keys(theme.global.breakpoints).sort(function (a, b) {
    var first = theme.global.breakpoints[a];
    var second = theme.global.breakpoints[b];
    if (!first) return 1;
    if (!second) return -1;
    if (!first.value) return 1;
    if (!second.value) return -1;
    return first.value - second.value;
  }).some(function (name) {
    var breakpoint = theme.global.breakpoints[name];

    if (breakpoint) {
      if (!breakpoint.value || breakpoint.value >= windowWidth) {
        result = name;
        return true;
      }
    }

    return false;
  });
  return result;
};
var getDeviceBreakpoint = function getDeviceBreakpoint(type, theme) {
  return theme.global.deviceBreakpoints[type];
};

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ROUTER_PROPS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_desc__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_desc__);

var ROUTER_PROPS = {
  path: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].string.description('Indicates the path to be used for react-router link.').isRequired,
  method: __WEBPACK_IMPORTED_MODULE_0_react_desc__["PropTypes"].oneOf(['push', 'replace']).description('Indicates whether the browser history should be appended to or replaced.').defaultValue('push')
};

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return throttle; });
var _this = this;

// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
var throttle = function throttle(fn, threshhold, scope) {
  if (threshhold === void 0) {
    threshhold = 250;
  }

  if (scope === void 0) {
    scope = _this;
  }

  var last;
  var deferTimer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var now = Date.now();

    if (last && now < last + threshhold) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(scope, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(scope, args);
    }
  };
};

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return base; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_polished__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_icons_es6_icons_Actions__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons_es6_icons_ClosedCaption__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_icons_es6_icons_Expand__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_icons_es6_icons_FormDown__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_icons_es6_icons_FormNext__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_icons_es6_icons_FormPrevious__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_icons_es6_icons_FormUp__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_icons_es6_icons_Next__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_icons_es6_icons_Pause__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_icons_es6_icons_Play__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_icons_es6_icons_Previous__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_icons_es6_icons_Subtract__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_icons_es6_icons_Volume__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_icons_es6_icons_VolumeLow__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_icons_es6_themes_base__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils__ = __webpack_require__(5);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



















var brandColor = '#7D4CDB';
var accentColors = ['#6FFFB0', '#FD6FFF', '#81FCED', '#FFCA58'];
var neutralColors = ['#00873D', '#3D138D', '#00739D', '#A2423D'];
var statusColors = {
  critical: '#FF4040',
  error: '#FF4040',
  warning: '#FFAA15',
  ok: '#00C781',
  unknown: '#CCCCCC',
  disabled: '#CCCCCC'
};
var darkColors = ['#333333', '#555555', '#777777', '#999999', '#999999', '#999999'];
var lightColors = ['#F8F8F8', '#F2F2F2', '#EDEDED', '#DADADA', '#DADADA', '#DADADA'];
var focusColor = accentColors[0];
var colors = {
  active: Object(__WEBPACK_IMPORTED_MODULE_0_polished__["a" /* rgba */])(221, 221, 221, 0.5),
  black: '#000000',
  border: {
    dark: Object(__WEBPACK_IMPORTED_MODULE_0_polished__["a" /* rgba */])(255, 255, 255, 0.33),
    light: Object(__WEBPACK_IMPORTED_MODULE_0_polished__["a" /* rgba */])(0, 0, 0, 0.33)
  },
  brand: brandColor,
  control: {
    dark: 'accent-1',
    light: 'brand'
  },
  focus: focusColor,
  placeholder: '#AAAAAA',
  selected: 'brand',
  text: {
    dark: '#f8f8f8',
    light: '#444444'
  },
  icon: {
    dark: '#f8f8f8',
    light: '#666666'
  },
  white: '#FFFFFF'
};

var colorArray = function colorArray(array, prefix) {
  return array.forEach(function (color, index) {
    colors[prefix + "-" + (index + 1)] = color;
  });
};

colorArray(accentColors, 'accent');
colorArray(darkColors, 'dark');
colorArray(lightColors, 'light');
colorArray(neutralColors, 'neutral');
Object.keys(statusColors).forEach(function (color) {
  colors["status-" + color] = statusColors[color];
});
var generate = function generate(baseSpacing, scale) {
  if (baseSpacing === void 0) {
    baseSpacing = 24;
  }

  if (scale === void 0) {
    scale = 6;
  }

  // 24
  var baseFontSize = baseSpacing * 0.75; // 18

  var fontScale = baseSpacing / scale; // 4

  var fontSizing = function fontSizing(factor) {
    return {
      size: baseFontSize + factor * fontScale + "px",
      height: baseSpacing + factor * fontScale + "px",
      // maxWidth chosen to be ~50 characters wide
      // see: https://ux.stackexchange.com/a/34125
      maxWidth: baseSpacing * (baseFontSize + factor * fontScale) + "px"
    };
  };

  var borderWidth = 2;
  var result = Object(__WEBPACK_IMPORTED_MODULE_17__utils__["l" /* deepMerge */])(__WEBPACK_IMPORTED_MODULE_16_grommet_icons_es6_themes_base__["a" /* base */], {
    global: {
      animation: {
        duration: '1s',
        jiggle: {
          duration: '0.1s'
        }
      },
      borderSize: {
        xsmall: '1px',
        small: '2px',
        medium: baseSpacing / 6 + "px",
        // 4
        large: baseSpacing / 2 + "px",
        // 12
        xlarge: baseSpacing + "px" // 24

      },
      breakpoints: {
        small: {
          value: baseSpacing * 32,
          // 768
          borderSize: {
            xsmall: '1px',
            small: '2px',
            medium: baseSpacing / 6 + "px",
            // 4
            large: baseSpacing / 4 + "px",
            // 6
            xlarge: baseSpacing / 2 + "px" // 12

          },
          edgeSize: {
            none: '0px',
            hair: '1px',
            // for Chart
            xxsmall: '2px',
            xsmall: baseSpacing / 8 + "px",
            // 3
            small: baseSpacing / 4 + "px",
            // 6
            medium: baseSpacing / 2 + "px",
            // 12
            large: baseSpacing + "px",
            // 24
            xlarge: baseSpacing * 2 + "px" // 48

          },
          size: {
            xxsmall: baseSpacing + "px",
            // 24
            xsmall: baseSpacing * 2 + "px",
            // 48
            small: baseSpacing * 4 + "px",
            // 96
            medium: baseSpacing * 8 + "px",
            // 192
            large: baseSpacing * 16 + "px",
            // 384
            xlarge: baseSpacing * 32 + "px",
            // 768
            full: '100%'
          }
        },
        medium: {
          value: baseSpacing * 64 // 1536

        },
        large: {} // anything above 'medium'

      },
      // Breakpoints used at Server Side Rendering for the initial rendering
      // These values correspond to the theme breakpoints
      deviceBreakpoints: {
        phone: 'small',
        tablet: 'medium',
        computer: 'large'
      },
      colors: colors,
      control: {
        border: {
          width: '1px',
          radius: '4px',
          color: 'border'
        }
      },
      debounceDelay: 300,
      // The time to wait after the user stopped typing, measured in ms.
      drop: {
        background: '#ffffff',
        border: {
          width: '0px',
          radius: '0px'
        },
        shadowSize: 'small',
        zIndex: '20'
      },
      edgeSize: {
        none: '0px',
        hair: '1px',
        // for Chart
        xxsmall: baseSpacing / 8 + "px",
        // 3
        xsmall: baseSpacing / 4 + "px",
        // 6
        small: baseSpacing / 2 + "px",
        // 12
        medium: baseSpacing + "px",
        // 24
        large: baseSpacing * 2 + "px",
        // 48
        xlarge: baseSpacing * 4 + "px",
        // 96
        responsiveBreakpoint: 'small'
      },
      elevation: {
        light: {
          none: 'none',
          xsmall: '0px 1px 2px rgba(0, 0, 0, 0.20)',
          small: '0px 2px 4px rgba(0, 0, 0, 0.20)',
          medium: '0px 4px 8px rgba(0, 0, 0, 0.20)',
          large: '0px 8px 16px rgba(0, 0, 0, 0.20)',
          xlarge: '0px 12px 24px rgba(0, 0, 0, 0.20)'
        },
        dark: {
          none: 'none',
          xsmall: '0px 2px 2px rgba(255, 255, 255, 0.40)',
          small: '0px 4px 4px rgba(255, 255, 255, 0.40)',
          medium: '0px 6px 8px rgba(255, 255, 255, 0.40)',
          large: '0px 8px 16px rgba(255, 255, 255, 0.40)',
          xlarge: '0px 12px 24px rgba(255, 255, 255, 0.40)'
        }
      },
      focus: {
        border: {
          color: 'focus'
        }
      },
      font: _extends({}, fontSizing(0)),
      hover: {
        background: {
          dark: {
            color: 'active',
            opacity: 'medium'
          },
          light: {
            color: 'active',
            opacity: 'medium'
          }
        },
        color: {
          dark: 'white',
          light: 'black'
        }
      },
      input: {
        padding: baseSpacing / 2 + "px",
        weight: 600
      },
      opacity: {
        strong: 0.8,
        medium: 0.4,
        weak: 0.1
      },
      selected: {
        background: 'selected',
        color: 'white'
      },
      spacing: baseSpacing + "px",
      size: {
        xxsmall: baseSpacing * 2 + "px",
        // 48
        xsmall: baseSpacing * 4 + "px",
        // 96
        small: baseSpacing * 8 + "px",
        // 192
        medium: baseSpacing * 16 + "px",
        // 384
        large: baseSpacing * 32 + "px",
        // 768
        xlarge: baseSpacing * 48 + "px",
        // 1152
        xxlarge: baseSpacing * 64 + "px",
        // 1536
        full: '100%'
      }
    },
    accordion: {
      icons: {
        collapse: __WEBPACK_IMPORTED_MODULE_8_grommet_icons_es6_icons_FormUp__["a" /* FormUp */],
        expand: __WEBPACK_IMPORTED_MODULE_5_grommet_icons_es6_icons_FormDown__["a" /* FormDown */] // color: { dark: undefined, light: undefined },

      }
    },
    anchor: {
      textDecoration: 'none',
      fontWeight: 600,
      color: {
        dark: 'accent-1',
        light: 'brand'
      },
      hover: {
        textDecoration: 'underline' // fontWeight: undefined,
        // extend: undefined,

      } // extend: undefined,

    },
    box: {
      responsiveBreakpoint: 'small' // when we switch rows to columns
      // extend: undefined,

    },
    button: {
      border: {
        // color: { dark: undefined, light: undefined }
        width: borderWidth + "px",
        radius: baseSpacing * 0.75 + "px"
      },
      // color: { dark: undefined, light: undefined }
      primary: {// color: { dark: undefined, light: undefined }
      },
      disabled: {
        opacity: 0.3
      },
      minWidth: baseSpacing * 4 + "px",
      maxWidth: baseSpacing * 16 + "px",
      padding: {
        vertical: baseSpacing / 4 - borderWidth + "px",
        horizontal: baseSpacing - borderWidth + "px"
      }
    },
    calendar: {
      // daySize must align with global.size
      small: {
        fontSize: baseFontSize - fontScale + "px",
        lineHeight: 1.375,
        daySize: baseSpacing * 8 / 7 + "px",
        slideDuration: '0.2s'
      },
      medium: {
        fontSize: baseFontSize + "px",
        lineHeight: 1.45,
        daySize: baseSpacing * 16 / 7 + "px",
        slideDuration: '0.5s'
      },
      large: {
        fontSize: baseFontSize + 3 * fontScale + "px",
        lineHeight: 1.11,
        daySize: baseSpacing * 32 / 7 + "px",
        slideDuration: '0.8s'
      },
      icons: {
        previous: __WEBPACK_IMPORTED_MODULE_12_grommet_icons_es6_icons_Previous__["a" /* Previous */],
        next: __WEBPACK_IMPORTED_MODULE_9_grommet_icons_es6_icons_Next__["a" /* Next */],
        small: {
          previous: __WEBPACK_IMPORTED_MODULE_7_grommet_icons_es6_icons_FormPrevious__["a" /* FormPrevious */],
          next: __WEBPACK_IMPORTED_MODULE_6_grommet_icons_es6_icons_FormNext__["a" /* FormNext */]
        }
      }
    },
    carousel: {
      icons: {
        current: __WEBPACK_IMPORTED_MODULE_13_grommet_icons_es6_icons_Subtract__["a" /* Subtract */],
        next: __WEBPACK_IMPORTED_MODULE_9_grommet_icons_es6_icons_Next__["a" /* Next */],
        previous: __WEBPACK_IMPORTED_MODULE_12_grommet_icons_es6_icons_Previous__["a" /* Previous */] // color: undefined,

      }
    },
    checkBox: {
      border: {
        color: {
          dark: 'rgba(255, 255, 255, 0.5)',
          light: 'rgba(0, 0, 0, 0.15)'
        },
        width: '2px'
      },
      check: {
        radius: '4px',
        thickness: '4px' // extend: undefined,

      },
      icon: {// size: undefined,
        // extend: undefined,
      },
      icons: {// checked: undefined,
        // indeterminate: undefined,
      },
      hover: {
        border: {
          color: {
            dark: 'white',
            light: 'black'
          }
        }
      },
      size: baseSpacing + "px",
      // color: { dark: undefined, light: undefined },
      toggle: {
        color: {
          dark: '#d9d9d9',
          light: '#d9d9d9'
        },
        radius: baseSpacing + "px",
        size: baseSpacing * 2 + "px",
        // extend: undefined,
        knob: {// extend: undefined,
        }
      } // extend: undefined,

    },
    clock: {
      analog: {
        hour: {
          color: {
            dark: 'light-2',
            light: 'dark-3'
          },
          width: baseSpacing / 3 + "px",
          size: baseSpacing + "px",
          shape: 'round'
        },
        minute: {
          color: {
            dark: 'light-4',
            light: 'dark-3'
          },
          width: baseSpacing / 6 + "px",
          size: Math.round(baseSpacing / 2) + "px",
          shape: 'round'
        },
        second: {
          color: {
            dark: 'accent-1',
            light: 'accent-1'
          },
          width: baseSpacing / 8 + "px",
          size: Math.round(baseSpacing / 2.666) + "px",
          shape: 'round'
        },
        size: {
          small: baseSpacing * 3 + "px",
          medium: baseSpacing * 4 + "px",
          large: baseSpacing * 6 + "px",
          xlarge: baseSpacing * 9 + "px",
          huge: baseSpacing * 12 + "px"
        }
      },
      digital: {
        text: {
          xsmall: {
            size: baseFontSize - 2 * fontScale + "px",
            height: 1.5
          },
          small: {
            size: baseFontSize - fontScale + "px",
            height: 1.43
          },
          medium: {
            size: baseFontSize + "px",
            height: 1.375
          },
          large: {
            size: baseFontSize + fontScale + "px",
            height: 1.167
          },
          xlarge: {
            size: baseFontSize + 2 * fontScale + "px",
            height: 1.1875
          },
          xxlarge: {
            size: baseFontSize + 4 * fontScale + "px",
            height: 1.125
          }
        }
      }
    },
    collapsible: {
      minSpeed: 200,
      baseline: 500
    },
    dataTable: {
      header: {},
      groupHeader: {
        border: {
          side: 'bottom',
          size: 'xsmall'
        },
        fill: 'vertical',
        pad: {
          horizontal: 'small',
          vertical: 'xsmall'
        },
        background: {
          dark: 'dark-2',
          light: 'light-2'
        }
      },
      icons: {
        ascending: __WEBPACK_IMPORTED_MODULE_5_grommet_icons_es6_icons_FormDown__["a" /* FormDown */],
        contract: __WEBPACK_IMPORTED_MODULE_8_grommet_icons_es6_icons_FormUp__["a" /* FormUp */],
        descending: __WEBPACK_IMPORTED_MODULE_8_grommet_icons_es6_icons_FormUp__["a" /* FormUp */],
        expand: __WEBPACK_IMPORTED_MODULE_5_grommet_icons_es6_icons_FormDown__["a" /* FormDown */]
      },
      resize: {
        border: {
          side: 'right',
          color: 'border'
        }
      },
      primary: {
        weight: 'bold'
      }
    },
    // drop: {
    //   maxHeight: undefined,
    // },
    formField: {
      border: {
        color: 'border',
        position: 'inner',
        side: 'bottom',
        error: {
          color: {
            dark: 'white',
            light: 'status-critical'
          }
        }
      },
      error: {
        color: {
          dark: 'status-critical',
          light: 'status-critical'
        }
      },
      help: {
        color: {
          dark: 'dark-3',
          light: 'dark-3'
        }
      },
      label: {}
    },
    grommet: {},
    heading: {
      font: {// family: undefined
      },
      level: {
        1: {
          font: {// family: undefined,
          },
          small: _extends({}, fontSizing(4)),
          medium: _extends({}, fontSizing(8)),
          large: _extends({}, fontSizing(16)),
          xlarge: _extends({}, fontSizing(24))
        },
        2: {
          font: {// family: undefined,
          },
          small: _extends({}, fontSizing(2)),
          medium: _extends({}, fontSizing(4)),
          large: _extends({}, fontSizing(8)),
          xlarge: _extends({}, fontSizing(12))
        },
        3: {
          font: {// family: undefined,
          },
          small: _extends({}, fontSizing(1)),
          medium: _extends({}, fontSizing(1)),
          large: _extends({}, fontSizing(4)),
          xlarge: _extends({}, fontSizing(6))
        },
        4: {
          font: {// family: undefined,
          },
          small: _extends({}, fontSizing(0)),
          medium: _extends({}, fontSizing(0)),
          large: _extends({}, fontSizing(0)),
          xlarge: _extends({}, fontSizing(0))
        }
      },
      responsiveBreakpoint: 'small',
      // when we scale the font size down
      weight: 600
    },
    layer: {
      background: 'white',
      border: {
        radius: '4px'
      },
      container: {
        zIndex: '15'
      },
      overlay: {
        background: 'rgba(0, 0, 0, 0.5)'
      },
      responsiveBreakpoint: 'small',
      // when Layer takes over the full screen
      zIndex: '10'
    },
    menu: {
      // background: undefined,
      // extend: undefined,
      icons: {
        down: __WEBPACK_IMPORTED_MODULE_5_grommet_icons_es6_icons_FormDown__["a" /* FormDown */]
      }
    },
    paragraph: {
      small: _extends({}, fontSizing(-1)),
      medium: _extends({}, fontSizing(0)),
      large: _extends({}, fontSizing(1)),
      xlarge: _extends({}, fontSizing(2)),
      xxlarge: _extends({}, fontSizing(4))
    },
    radioButton: {
      border: {
        color: {
          dark: 'rgba(255, 255, 255, 0.5)',
          light: 'rgba(0, 0, 0, 0.15)'
        },
        width: '2px'
      },
      check: {
        radius: '100%' // color: { dark: undefined, light: undefined },
        // extend: undefined,

      },
      hover: {
        border: {
          color: {
            dark: 'white',
            light: 'black'
          }
        }
      },
      icon: {// size: undefined,
        // extend: undefined,
      },
      icons: {// circle: undefined,
      },
      gap: 'small',
      size: baseSpacing + "px"
    },
    rangeInput: {
      track: {
        height: '4px',
        color: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(["", ";"], function (props) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_polished__["a" /* rgba */])(Object(__WEBPACK_IMPORTED_MODULE_17__utils__["B" /* normalizeColor */])('border', props.theme), 0.2);
        })
      },
      thumb: {// color: { dark: undefined, light: undefined },
      }
    },
    select: {
      // background: undefined,
      container: {// extend: undefined,
      },
      control: {// extend: undefined,
      },
      icons: {
        // color: { dark: undefined, light: undefined },
        down: __WEBPACK_IMPORTED_MODULE_5_grommet_icons_es6_icons_FormDown__["a" /* FormDown */]
      },
      // searchInput: undefined,
      step: 20
    },
    tab: {
      active: {
        color: 'text' // background: undefined,

      },
      // background: undefined,
      border: {
        side: 'bottom',
        size: 'small',
        color: {
          dark: 'accent-1',
          light: 'brand'
        },
        active: {
          color: {
            dark: 'white',
            light: 'black'
          }
        },
        hover: {
          color: {
            dark: 'white',
            light: 'black'
          }
        }
      },
      color: 'control',
      // extend: undefined,
      hover: {
        // background: undefined,
        // extend: undefined,
        color: {
          dark: 'white',
          light: 'black'
        }
      },
      margin: {
        vertical: 'xxsmall',
        horizontal: 'small'
      },
      pad: {
        bottom: 'xsmall'
      }
    },
    tabs: {
      // background: undefined,
      // extend: undefined,
      header: {// background: undefined,
        // extend: undefined,
      },
      panel: {// extend: undefined,
      } // gap: undefined,

    },
    table: {
      header: {
        align: 'start',
        pad: {
          horizontal: 'small',
          vertical: 'xsmall'
        },
        border: 'bottom',
        verticalAlign: 'bottom',
        fill: 'vertical' // background: undefined,
        // extend: undefined,

      },
      body: {
        align: 'start',
        pad: {
          horizontal: 'small',
          vertical: 'xsmall'
        } // border: undefined,
        // extend: undefined,

      },
      footer: {
        align: 'start',
        pad: {
          horizontal: 'small',
          vertical: 'xsmall'
        },
        border: 'top',
        verticalAlign: 'top',
        fill: 'vertical' // extend: undefined,

      }
    },
    text: {
      xsmall: _extends({}, fontSizing(-1.5)),
      small: _extends({}, fontSizing(-1)),
      medium: _extends({}, fontSizing(0)),
      large: _extends({}, fontSizing(1)),
      xlarge: _extends({}, fontSizing(2)),
      xxlarge: _extends({}, fontSizing(4))
    },
    // textInput: {
    //   extend: undefined,
    // },
    video: {
      captions: {
        background: 'rgba(0, 0, 0, 0.7)'
      },
      // controls: { background: undefined },
      icons: {
        closedCaption: __WEBPACK_IMPORTED_MODULE_3_grommet_icons_es6_icons_ClosedCaption__["a" /* ClosedCaption */],
        configure: __WEBPACK_IMPORTED_MODULE_2_grommet_icons_es6_icons_Actions__["a" /* Actions */],
        fullScreen: __WEBPACK_IMPORTED_MODULE_4_grommet_icons_es6_icons_Expand__["a" /* Expand */],
        pause: __WEBPACK_IMPORTED_MODULE_10_grommet_icons_es6_icons_Pause__["a" /* Pause */],
        play: __WEBPACK_IMPORTED_MODULE_11_grommet_icons_es6_icons_Play__["a" /* Play */],
        reduceVolume: __WEBPACK_IMPORTED_MODULE_15_grommet_icons_es6_icons_VolumeLow__["a" /* VolumeLow */],
        volume: __WEBPACK_IMPORTED_MODULE_14_grommet_icons_es6_icons_Volume__["a" /* Volume */] // color: { dark: undefined, light: undefined },

      } // scrubber: { track: { color: undefined } },

    },
    worldMap: {
      color: 'light-3',
      continent: {
        active: '8px',
        base: '6px'
      },
      hover: {
        color: 'light-4'
      },
      place: {
        active: '20px',
        base: '8px'
      }
    }
  });
  return Object(__WEBPACK_IMPORTED_MODULE_17__utils__["k" /* deepFreeze */])(result);
};
var base = generate(24);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _taggedTemplateLiteralLoose;
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Actions = function Actions(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Actions' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,17.5 C15.0375661,17.5 17.5,15.0375661 17.5,12 C17.5,8.96243388 15.0375661,6.5 12,6.5 C8.96243388,6.5 6.5,8.96243388 6.5,12 C6.5,15.0375661 8.96243388,17.5 12,17.5 Z M12,6.5 L12,1 M12,23 L12,17.5 M1,12 L6.5,12 M17.5,12 L23,12 M4.4375,4.4375 L8.5625,8.5625 M15.4375,15.4375 L19.5625,19.5625 M19.5625,4.4375 L15.4375,8.5625 M8.5625,15.4375 L4.4375,19.5625' })
  );
};

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(375);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__size__ = __webpack_require__(377);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__size__["a"]; });



/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return colorStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(178);


var colorStyle = function colorStyle(name, value, theme, required) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", ":", ";"], name, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* normalizeColor */])(value, theme, required));
};

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return colorIsDark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizeColor; });
// https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
var parseHexToRGB = function parseHexToRGB(color) {
  return color.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (m, r, g, b) {
    return "#" + r + r + g + g + b + b;
  }).substring(1).match(/.{2}/g).map(function (x) {
    return parseInt(x, 16);
  });
};

var getRGBArray = function getRGBArray(color) {
  if (/^#/.test(color)) {
    return parseHexToRGB(color);
  }

  if (/^rgb/.test(color)) {
    return color.match(/rgba?\((\s?[0-9]*\s?),(\s?[0-9]*\s?),(\s?[0-9]*\s?).*?\)/).splice(1);
  }

  return color;
};

var colorIsDark = function colorIsDark(color) {
  var _getRGBArray = getRGBArray(color),
      red = _getRGBArray[0],
      green = _getRGBArray[1],
      blue = _getRGBArray[2]; // http://www.had2know.com/technology/
  //  color-contrast-calculator-web-design.html


  var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
  return brightness < 125;
};
var normalizeColor = function normalizeColor(color, theme) {
  var colorSpec = theme.global.colors[color] || color; // If the color has a light or dark object, use that

  var result = colorSpec;

  if (theme.dark && colorSpec.dark) {
    result = colorSpec.dark;
  } else if (!theme.dark && colorSpec.light) {
    result = colorSpec.light;
  } // allow one level of indirection in color names


  if (result && theme.global.colors[result] && theme.global.colors[result] !== result) {
    result = normalizeColor(result, theme);
  }

  return result;
};

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sizeStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);

var sizeStyle = function sizeStyle(name, value, theme) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", ":", ";"], name, theme.global.size[value] || value);
};

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultProps; });
/* unused harmony export extendDefaultTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(380);



var defaultProps = {
  theme: __WEBPACK_IMPORTED_MODULE_1__themes__["a" /* base */]
};

var extendDefaultTheme = function extendDefaultTheme(theme) {
  defaultProps.theme = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* deepMerge */])(__WEBPACK_IMPORTED_MODULE_1__themes__["a" /* base */], theme);
};

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = deepMerge;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function isObject(item) {
  return item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && !Array.isArray(item);
}

function deepMerge(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (!sources.length) {
    return target;
  }
  // making sure to not change target (immutable)
  var output = _extends({}, target);
  sources.forEach(function (source) {
    if (isObject(source)) {
      Object.keys(source).forEach(function (key) {
        if (isObject(source[key])) {
          if (!output[key]) {
            output[key] = _extends({}, source[key]);
          } else {
            output[key] = deepMerge(output[key], source[key]);
          }
        } else {
          output[key] = source[key];
        }
      });
    }
  });
  return output;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({ deepMerge: deepMerge, isObject: isObject });

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__base__["a"]; });


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClosedCaption; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ClosedCaption = function ClosedCaption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ClosedCaption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,12 C1,5 2.5,4 12,4 C21.5,4 23,5 23,12 C23,19 21.5,20 12,20 C2.5,20 1,19 1,12 Z M5.25,14 C5.25,15.5 6,16 7.75,16 C9.5,16 10.25,15.5 10.25,14 L9.97861679,14 C9.97861671,15.25 8.97905547,16 7.75,16 C6.52094453,16 5.52138329,15.25 5.52138321,14 L5.52138321,10 C5.5,8.75 6.5,8 7.75,8 C9,8 10,8.75 9.97861679,10 L10.25,10 C10.25,8.75 9.2286998,8 7.75,8 C6.2713002,8 5.25,8.75 5.25,10 L5.25,14 Z M13.25,14 C13.25,15.5 14,16 15.75,16 C17.5,16 18.25,15.5 18.25,14 L17.9786168,14 C17.9786167,15.25 16.9790555,16 15.75,16 C14.5209445,16 13.5213833,15.25 13.5213832,14 L13.5213832,10 C13.5,8.75 14.5,8 15.75,8 C17,8 18,8.75 17.9786168,10 L18.25,10 C18.25,8.75 17.2286998,8 15.75,8 C14.2713002,8 13.25,8.75 13.25,10 L13.25,14 Z' })
  );
};

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Expand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Expand = function Expand(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Expand' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M10,14 L2,22 M1,15 L1,23 L9,23 M22,2 L14,10 M15,1 L23,1 L23,9' })
  );
};

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormDown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormDown = function FormDown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormDown' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '18 9 12 15 6 9' })
  );
};

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormNext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormNext = function FormNext(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormNext' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '9 6 15 12 9 18' })
  );
};

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormPrevious; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormPrevious = function FormPrevious(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormPrevious' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '9 6 15 12 9 18', transform: 'matrix(-1 0 0 1 24 0)' })
  );
};

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormUp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormUp = function FormUp(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormUp' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '18 9 12 15 6 9', transform: 'matrix(1 0 0 -1 0 24)' })
  );
};

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Next; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Next = function Next(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Next' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7 2 17 12 7 22' })
  );
};

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pause; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Pause = function Pause(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Pause' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,21 L9,21 L9,3 L3,3 L3,21 Z M15,21 L21,21 L21,3 L15,3 L15,21 Z' })
  );
};

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Play; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Play = function Play(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Play' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '3 22 21 12 3 2' })
  );
};

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Previous; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Previous = function Previous(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Previous' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7 2 17 12 7 22', transform: 'matrix(-1 0 0 1 24 0)' })
  );
};

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subtract; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Subtract = function Subtract(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Subtract' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,12 L22,12' })
  );
};

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Volume; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Volume = function Volume(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Volume' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,16 C17.209,16 19,14.209 19,12 C19,9.791 17.209,8 15,8 M15,20 C20,20 23,16.411 23,12 C23,7.589 19.411,4 15,4 M1,12 L1,8 L6,8 L12,3 L12,21 L6,16 L1,16 L1,12' })
  );
};

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VolumeLow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var VolumeLow = function VolumeLow(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'VolumeLow' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,8 L1,16 L6.09901951,16 L12,21 L12,3 L6,8 L1,8 Z M15,16 L15,16 C17.209139,16 19,14.209139 19,12 C19,9.790861 17.209139,8 15,8' })
  );
};

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export grommet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);


var grommet = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* deepFreeze */])({
  global: {
    colors: {
      background: '#ffffff'
    },
    font: {
      family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans",  "Helvetica Neue", Arial, sans-serif,  "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
    }
  },
  button: {
    extend: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", ";"], function (props) {
      return !props.plain && 'font-weight: bold;';
    })
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_polished__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(5);



var controlColor = '#FFCA58';
var accentColors = ['#FD6FFF', '#60EB9F', '#60EBE1', '#FFCA58'];
var neutralColors = ['#EB6060', '#01C781', '#6095EB', '#FFB200'];
var statusColors = {
  critical: '#FF3333',
  error: '#FF3333',
  warning: '#F7E464',
  ok: '#7DD892',
  unknown: '#a8a8a8',
  disabled: '#a8a8a8'
};
var backgroundColor = '#111111';
var textColor = '#eeeeee';
var borderColor = Object(__WEBPACK_IMPORTED_MODULE_0_polished__["a" /* rgba */])(255, 255, 255, 0.33);
var activeColor = Object(__WEBPACK_IMPORTED_MODULE_0_polished__["a" /* rgba */])(102, 102, 102, 0.5);
var colors = {
  active: activeColor,
  background: backgroundColor,
  black: '#000000',
  border: borderColor,
  brand: '#FD6FFF',
  control: controlColor,
  focus: controlColor,
  placeholder: '#AAAAAA',
  text: textColor,
  white: '#FFFFFF'
};

var colorArray = function colorArray(array, prefix) {
  return array.forEach(function (color, index) {
    colors[prefix + "-" + (index + 1)] = color;
  });
};

colorArray(accentColors, 'accent');
colorArray(neutralColors, 'neutral');
Object.keys(statusColors).forEach(function (color) {
  colors["status-" + color] = statusColors[color];
});
var dark = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* deepFreeze */])({
  global: {
    colors: colors,
    drop: {
      background: '#333333'
    },
    focus: {
      border: {
        color: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(["", ";"], function (props) {
          return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["B" /* normalizeColor */])('focus', props.theme);
        }),
        width: '2px'
      }
    },
    font: {
      family: 'Arial'
    },
    input: {
      weight: 700
    },
    text: {
      dark: textColor,
      light: '#000000'
    }
  },
  anchor: {
    color: controlColor
  },
  icon: {
    color: textColor,
    colors: colors
  },
  layer: {
    background: backgroundColor,
    overlay: {
      background: Object(__WEBPACK_IMPORTED_MODULE_0_polished__["a" /* rgba */])(48, 48, 48, 0.5)
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledBoxGap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(5);
var _FLEX_MAP;




var ALIGN_MAP = {
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
var alignStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["align-items:", ";"], function (props) {
  return ALIGN_MAP[props.align];
});
var ALIGN_CONTENT_MAP = {
  around: 'around',
  between: 'between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
var alignContentStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["align-content:", ";"], function (props) {
  return ALIGN_CONTENT_MAP[props.alignContent];
});
var BASIS_MAP = {
  auto: 'auto',
  full: '100%',
  '1/2': '50%',
  '1/4': '25%',
  '2/4': '50%',
  '3/4': '75%',
  '1/3': '33.33%',
  '2/3': '66.66%'
};
var basisStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["flex-basis:", ";"], function (props) {
  return BASIS_MAP[props.basis] || props.theme.global.size[props.basis] || props.basis;
}); // min-width and min-height needed because of this
// https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
// we assume we are in the context of a Box going the other direction
// TODO: revisit this

var directionStyle = function directionStyle(direction, theme) {
  var styles = [Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["min-width:0;min-height:0;flex-direction:", ";"], direction === 'row-responsive' ? 'row' : direction)];

  if (direction === 'row-responsive' && theme.box.responsiveBreakpoint) {
    var breakpoint = theme.global.breakpoints[theme.box.responsiveBreakpoint];

    if (breakpoint) {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "\n        flex-direction: column;\n        flex-basis: auto;\n        justify-content: flex-start;\n        align-items: stretch;\n      "));
    }
  }

  return styles;
};

var elevationStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["box-shadow:", ";"], function (props) {
  return props.theme.global.elevation[props.theme.dark ? 'dark' : 'light'][props.elevationProp];
});
var FLEX_MAP = (_FLEX_MAP = {}, _FLEX_MAP[true] = '1 1', _FLEX_MAP[false] = '0 0', _FLEX_MAP.grow = '1 0', _FLEX_MAP.shrink = '0 1', _FLEX_MAP);
var flexStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["flex:", ";"], function (props) {
  return "" + FLEX_MAP[props.flex] + (props.flex !== true && !props.basis ? ' auto' : '');
});

var fillStyle = function fillStyle(fillProp) {
  if (fillProp === 'horizontal') {
    return 'width: 100%;';
  }

  if (fillProp === 'vertical') {
    return 'height: 100%;';
  }

  if (fillProp) {
    return "\n      width: 100%;\n      height: 100%;\n    ";
  }

  return undefined;
};

var JUSTIFY_MAP = {
  between: 'space-between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start'
};
var justifyStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["justify-content:", ";"], function (props) {
  return JUSTIFY_MAP[props.justify];
});
var wrapStyle = 'flex-wrap: wrap;';

var borderStyle = function borderStyle(data, responsive, theme) {
  var styles = [];
  var color = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["B" /* normalizeColor */])(data.color || 'border', theme);
  var borderSize = data.size || 'xsmall';
  var side = typeof data === 'string' ? data : data.side || 'all';
  var value = "solid " + (theme.global.borderSize[borderSize] || borderSize) + " " + color;
  var breakpoint = theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
  var responsiveValue = breakpoint && (breakpoint.borderSize[borderSize] || borderSize) && "solid " + (breakpoint.borderSize[borderSize] || borderSize) + " " + color;

  if (side === 'top' || side === 'bottom' || side === 'left' || side === 'right') {
    styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border-", ":", ";"], side, value));

    if (responsiveValue) {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "\n        border-" + side + ": " + responsiveValue + ";\n      "));
    }
  } else if (side === 'vertical') {
    styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border-left:", ";border-right:", ";"], value, value));

    if (responsiveValue) {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "\n        border-left: " + responsiveValue + ";\n        border-right: " + responsiveValue + ";\n      "));
    }
  } else if (side === 'horizontal') {
    styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border-top:", ";border-bottom:", ";"], value, value));

    if (responsiveValue) {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "\n        border-top: " + responsiveValue + ";\n        border-bottom: " + responsiveValue + ";\n      "));
    }
  } else {
    styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border:", ";"], value));

    if (responsiveValue) {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "border: " + responsiveValue + ";"));
    }
  }

  return styles;
};

var ROUND_MAP = {
  full: '100%'
};

var roundStyle = function roundStyle(data, responsive, theme) {
  var breakpoint = theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
  var styles = [];

  if (typeof data === 'object') {
    var size = ROUND_MAP[data.size] || theme.global.edgeSize[data.size || 'medium'];
    var responsiveSize = breakpoint && breakpoint.edgeSize[data.size] && breakpoint.edgeSize[data.size];

    if (data.corner === 'top') {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border-top-left-radius:", ";border-top-right-radius:", ";"], size, size));

      if (responsiveSize) {
        styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "\n          border-top-left-radius: " + responsiveSize + ";\n          border-top-right-radius: " + responsiveSize + ";\n        "));
      }
    } else if (data.corner === 'bottom') {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border-bottom-left-radius:", ";border-bottom-right-radius:", ";"], size, size));

      if (responsiveSize) {
        styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "\n          border-bottom-left-radius: " + responsiveSize + ";\n          border-bottom-right-radius: " + responsiveSize + ";\n        "));
      }
    } else if (data.corner === 'left') {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border-top-left-radius:", ";border-bottom-left-radius:", ";"], size, size));

      if (responsiveSize) {
        styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "\n          border-top-left-radius: " + responsiveSize + ";\n          border-bottom-left-radius: " + responsiveSize + ";\n        "));
      }
    } else if (data.corner === 'right') {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border-top-right-radius:", ";border-bottom-right-radius:", ";"], size, size));

      if (responsiveSize) {
        styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "\n          border-top-right-radius: " + responsiveSize + ";\n          border-bottom-right-radius: " + responsiveSize + ";\n        "));
      }
    } else if (data.corner) {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border-", "-radius:", ";"], data.corner, size));

      if (responsiveSize) {
        styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "\n          border-" + data.corner + "-radius: " + responsiveSize + ";\n        "));
      }
    } else {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border-radius:", ";"], size));

      if (responsiveSize) {
        styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "\n          border-radius: " + responsiveSize + ";\n        "));
      }
    }
  } else {
    var _size = data === true ? 'medium' : data;

    styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border-radius:", ";"], ROUND_MAP[_size] || theme.global.edgeSize[_size] || _size));

    var _responsiveSize = breakpoint && breakpoint.edgeSize[_size];

    if (_responsiveSize) {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "\n        border-radius: " + _responsiveSize + ";\n      "));
    }
  }

  return styles;
};

var SLIDE_SIZES = {
  xsmall: 1,
  small: 5,
  medium: 10,
  large: 50,
  xlarge: 200
};
var PULSE_SIZES = {
  xsmall: 1.001,
  small: 1.01,
  medium: 1.1,
  large: 1.5,
  xlarge: 2
};
var JIGGLE_SIZES = {
  xsmall: 0.1,
  small: 1,
  medium: 5,
  large: 400,
  xlarge: 1000
};
var ZOOM_SIZES = {
  xsmall: 0.001,
  small: 0.01,
  medium: 0.05,
  large: 0.1,
  xlarge: 0.5
};

var animationBounds = function animationBounds(type, size) {
  if (size === void 0) {
    size = 'medium';
  }

  if (type === 'fadeIn') {
    return ['opacity: 0;', 'opacity: 1;'];
  }

  if (type === 'fadeOut') {
    return ['opacity: 1;', 'opacity: 0;'];
  }

  if (type === 'jiggle') {
    var deg = JIGGLE_SIZES[size];
    return ["transform: rotate(-" + deg + "deg);", "transform: rotate(" + deg + "deg);"];
  }

  if (type === 'pulse') {
    return ['transform: scale(1);', "transform: scale(" + PULSE_SIZES[size] + ")"];
  }

  if (type === 'flipIn') {
    return ['transform: rotateY(90deg);', 'transform: rotateY(0);'];
  }

  if (type === 'flipOut') {
    return ['transform: rotateY(0);', 'transform: rotateY(90deg);'];
  }

  if (type === 'slideDown') {
    return ["transform: translateY(-" + SLIDE_SIZES[size] + "%);", 'transform: none;'];
  }

  if (type === 'slideLeft') {
    return ["transform: translateX(" + SLIDE_SIZES[size] + "%);", 'transform: none;'];
  }

  if (type === 'slideRight') {
    return ["transform: translateX(-" + SLIDE_SIZES[size] + "%);", 'transform: none;'];
  }

  if (type === 'slideUp') {
    return ["transform: translateY(" + SLIDE_SIZES[size] + "%);", 'transform: none;'];
  }

  if (type === 'zoomIn') {
    return ["transform: scale(" + (1 - ZOOM_SIZES[size]) + ");", 'transform: none;'];
  }

  if (type === 'zoomOut') {
    return ["transform: scale(" + (1 + ZOOM_SIZES[size]) + ");", 'transform: none;'];
  }

  return [];
};

var normalizeTiming = function normalizeTiming(time, defaultTiming) {
  return time ? time / 1000.0 + "s" : defaultTiming;
};

var animationEnding = function animationEnding(type) {
  if (type === 'jiggle') {
    return 'alternate infinite';
  }

  if (type === 'pulse') {
    return 'alternate infinite';
  }

  return 'forwards';
};

var animationObjectStyle = function animationObjectStyle(animation, theme) {
  var bounds = animationBounds(animation.type, animation.size);

  if (bounds) {
    var animationTransition = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["from{", ";}to{", ";}"], bounds[0], bounds[1]);
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", " ", " ", " ", ""], Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["", ""], animationTransition), normalizeTiming(animation.duration, (theme.global.animation[animation.type] ? theme.global.animation[animation.type].duration : undefined) || theme.global.animation.duration), normalizeTiming(animation.delay, '0s'), animationEnding(animation.type));
  }

  return '';
};

var animationItemStyle = function animationItemStyle(item, theme) {
  if (typeof item === 'string') {
    return animationObjectStyle({
      type: item
    }, theme);
  }

  if (Array.isArray(item)) {
    return item.reduce(function (style, a, index) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", "", " ", ""], style, index > 0 ? ',' : '', animationItemStyle(a, theme));
    }, '');
  }

  if (typeof item === 'object') {
    return animationObjectStyle(item, theme);
  }

  return '';
};

var animationAncilaries = function animationAncilaries(animation) {
  if (animation.type === 'flipIn' || animation.type === 'flipOut') {
    return 'perspective: 1000px; transform-style: preserve-3d;';
  }

  return '';
};

var animationObjectInitialStyle = function animationObjectInitialStyle(animation) {
  var bounds = animationBounds(animation.type, animation.size);

  if (bounds) {
    return bounds[0] + " " + animationAncilaries(animation);
  }

  return '';
};

var animationInitialStyle = function animationInitialStyle(item) {
  if (typeof item === 'string') {
    return animationObjectInitialStyle({
      type: item
    });
  }

  if (Array.isArray(item)) {
    return item.map(function (a) {
      return typeof a === 'string' ? animationObjectInitialStyle({
        type: a
      }) : animationObjectInitialStyle(a);
    }).join('');
  }

  if (typeof item === 'object') {
    return animationObjectInitialStyle(item);
  }

  return '';
};

var animationStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", ";"], function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", " animation:", ";"], animationInitialStyle(props.animation), animationItemStyle(props.animation, props.theme));
}); // NOTE: basis must be after flex! Otherwise, flex overrides basis

var StyledBox = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledBox",
  componentId: "sc-13pk1d4-0"
})(["display:flex;box-sizing:border-box;outline:none;", ";", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return !props.basis && 'max-width: 100%;';
}, __WEBPACK_IMPORTED_MODULE_2__utils__["q" /* genericStyles */], function (props) {
  return props.heightProp && "height: " + (props.theme.global.size[props.heightProp] || props.heightProp) + ";";
}, function (props) {
  return props.widthProp && "width: " + (props.theme.global.size[props.widthProp] || props.widthProp) + ";";
}, function (props) {
  return props.align && alignStyle;
}, function (props) {
  return props.alignContent && alignContentStyle;
}, function (props) {
  return props.background && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* backgroundStyle */])(props.background, props.theme);
}, function (props) {
  return props.border && borderStyle(props.border, props.responsive, props.theme);
}, function (props) {
  return props.directionProp && directionStyle(props.directionProp, props.theme);
}, function (props) {
  return props.flex !== undefined && flexStyle;
}, function (props) {
  return props.basis && basisStyle;
}, function (props) {
  return props.fillProp && fillStyle(props.fillProp);
}, function (props) {
  return props.justify && justifyStyle;
}, function (props) {
  return props.pad && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["m" /* edgeStyle */])('padding', props.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function (props) {
  return props.round && roundStyle(props.round, props.responsive, props.theme);
}, function (props) {
  return props.wrapProp && wrapStyle;
}, function (props) {
  return props.overflowProp && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["C" /* overflowStyle */])(props.overflowProp);
}, function (props) {
  return props.elevationProp && elevationStyle;
}, function (props) {
  return props.animation && animationStyle;
}, function (props) {
  return props.theme.box && props.theme.box.extend;
});

var gapStyle = function gapStyle(directionProp, gap, responsive, theme) {
  var breakpoint = theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
  var responsiveSize = breakpoint && breakpoint.edgeSize[gap] && breakpoint.edgeSize[gap];
  var styles = [];

  if (directionProp === 'column') {
    styles.push(Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["height:", ";"], theme.global.edgeSize[gap]));

    if (responsiveSize) {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "height: " + responsiveSize + ";"));
    }
  } else {
    styles.push("width: " + theme.global.edgeSize[gap] + ";");

    if (responsive && directionProp === 'row-responsive') {
      styles.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* breakpointStyle */])(breakpoint, "\n        width: auto;\n        height: " + responsiveSize + ";\n      "));
    }
  }

  return styles;
};

StyledBox.defaultProps = {};
Object.setPrototypeOf(StyledBox.defaultProps, __WEBPACK_IMPORTED_MODULE_1__default_props__["a" /* defaultProps */]);
var StyledBoxGap = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledBox__StyledBoxGap",
  componentId: "sc-13pk1d4-1"
})(["flex:0 0 auto;", ";"], function (props) {
  return props.gap && gapStyle(props.directionProp, props.gap, props.responsive, props.theme);
});
StyledBoxGap.defaultProps = {};
Object.setPrototypeOf(StyledBoxGap.defaultProps, __WEBPACK_IMPORTED_MODULE_1__default_props__["a" /* defaultProps */]);


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccordionPanel__ = __webpack_require__(398);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AccordionPanel__["a"]; });


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionPanelWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Collapsible__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Heading__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Accordion_AccordionContext__ = __webpack_require__(180);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var AccordionPanel =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(AccordionPanel, _Component);

  function AccordionPanel() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(_args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      hover: undefined
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseOver", function () {
      var _this$props = _this.props,
          onMouseOver = _this$props.onMouseOver,
          dark = _this$props.theme.dark;

      _this.setState({
        hover: dark ? 'light-4' : 'dark-3'
      });

      if (onMouseOver) {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        onMouseOver(args);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseOut", function () {
      var onMouseOut = _this.props.onMouseOut;

      _this.setState({
        hover: undefined
      });

      if (onMouseOut) {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        onMouseOut(args);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFocus", function () {
      var _this$props2 = _this.props,
          onFocus = _this$props2.onFocus,
          dark = _this$props2.theme.dark;

      _this.setState({
        hover: dark ? 'light-4' : 'dark-3'
      });

      if (onFocus) {
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        onFocus(args);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onBlur", function () {
      var onBlur = _this.props.onBlur;

      _this.setState({
        hover: undefined
      });

      if (onBlur) {
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }

        onBlur(args);
      }
    });

    return _this;
  }

  var _proto = AccordionPanel.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        children = _this$props3.children,
        header = _this$props3.header,
        label = _this$props3.label,
        theme = _this$props3.theme,
        onMouseOut = _this$props3.onMouseOut,
        onMouseOver = _this$props3.onMouseOver,
        onFocus = _this$props3.onFocus,
        onBlur = _this$props3.onBlur,
        rest = _objectWithoutPropertiesLoose(_this$props3, ["children", "header", "label", "theme", "onMouseOut", "onMouseOver", "onFocus", "onBlur"]);

    var hover = this.state.hover;
    var iconColor = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["B" /* normalizeColor */])(theme.accordion.icons.color || 'control', theme);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Accordion_AccordionContext__["a" /* AccordionContext */].Consumer, null, function (panelContext) {
      var active = panelContext.active,
          animate = panelContext.animate,
          onPanelChange = panelContext.onPanelChange;
      var AccordionIcon = active ? theme.accordion.icons.collapse : theme.accordion.icons.expand;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
        flex: false
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* Button */], {
        role: "tab",
        "aria-selected": active,
        "aria-expanded": active,
        onClick: onPanelChange,
        onMouseOver: _this2.onMouseOver,
        onMouseOut: _this2.onMouseOut,
        onFocus: _this2.onFocus,
        onBlur: _this2.onBlur
      }, header || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], _extends({
        align: "center",
        direction: "row",
        justify: "between"
      }, rest), typeof label === 'string' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
        pad: {
          horizontal: 'xsmall'
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Heading__["a" /* Heading */], {
        level: 4,
        color: hover
      }, label)) : label, AccordionIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
        pad: {
          horizontal: 'small'
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionIcon, {
        color: iconColor
      })))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
        border: {
          side: 'bottom',
          color: 'border'
        }
      }, animate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Collapsible__["a" /* Collapsible */], {
        open: active
      }, children) : active && children));
    });
  };

  return AccordionPanel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AccordionPanel.defaultProps = {};
Object.setPrototypeOf(AccordionPanel.defaultProps, __WEBPACK_IMPORTED_MODULE_4__default_props__["a" /* defaultProps */]);
var AccordionPanelDoc;

if (false) {
  AccordionPanelDoc = require('./doc').doc(AccordionPanel); // eslint-disable-line global-require
}

var AccordionPanelWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */], __WEBPACK_IMPORTED_MODULE_9__hocs__["d" /* withForwardRef */])(AccordionPanelDoc || AccordionPanel);


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StyledButton__ = __webpack_require__(400);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var isDarkBackground = function isDarkBackground(props) {
  var backgroundColor = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["A" /* normalizeBackground */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils__["B" /* normalizeColor */])(props.color || props.theme.button.primary.color || props.theme.global.colors.control || 'brand', props.theme), props.theme);
  return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* colorIsDark */])(backgroundColor, props.theme);
};

var Button =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Button, _Component);

  function Button(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var children = props.children,
        icon = props.icon,
        label = props.label;

    if ((icon || label) && children) {
      console.warn('Button should not have children if icon or label is provided');
    }

    return _this;
  }

  var _proto = Button.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        a11yTitle = _this$props.a11yTitle,
        color = _this$props.color,
        forwardRef = _this$props.forwardRef,
        children = _this$props.children,
        disabled = _this$props.disabled,
        icon = _this$props.icon,
        fill = _this$props.fill,
        focus = _this$props.focus,
        href = _this$props.href,
        label = _this$props.label,
        onClick = _this$props.onClick,
        plain = _this$props.plain,
        primary = _this$props.primary,
        reverse = _this$props.reverse,
        theme = _this$props.theme,
        type = _this$props.type,
        as = _this$props.as,
        rest = _objectWithoutPropertiesLoose(_this$props, ["a11yTitle", "color", "forwardRef", "children", "disabled", "icon", "fill", "focus", "href", "label", "onClick", "plain", "primary", "reverse", "theme", "type", "as"]);

    var buttonIcon = icon; // only change color if user did not specify the color themselves...

    if (primary && icon && !icon.props.color) {
      buttonIcon = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(icon, {
        color: theme.global.colors.text[isDarkBackground(this.props) ? 'dark' : 'light']
      });
    }

    var domTag = !as && href ? 'a' : as;
    var first = reverse ? label : buttonIcon;
    var second = reverse ? buttonIcon : label;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledButton__["a" /* StyledButton */], _extends({}, rest, {
      as: domTag,
      ref: forwardRef,
      "aria-label": a11yTitle,
      colorValue: color,
      disabled: disabled,
      hasIcon: !!icon,
      hasLabel: !!label,
      fillContainer: fill,
      focus: focus,
      href: href,
      onClick: onClick,
      plain: typeof plain !== 'undefined' ? plain : __WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children) > 0 || icon && !label,
      primary: primary,
      type: !href ? type : undefined
    }), first || second ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      direction: "row",
      align: "center",
      justify: "center",
      gap: "small"
    }, first, second) : children);
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Button, "defaultProps", {
  type: 'button',
  focusIndicator: true
});

Object.setPrototypeOf(Button.defaultProps, __WEBPACK_IMPORTED_MODULE_4__default_props__["a" /* defaultProps */]);
var ButtonDoc;

if (false) {
  ButtonDoc = require('./doc').doc(Button); // eslint-disable-line global-require
}

var ButtonWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_6__hocs__["c" /* withFocus */], __WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */], __WEBPACK_IMPORTED_MODULE_6__hocs__["d" /* withForwardRef */])(ButtonDoc || Button);


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);




var basicStyle = function basicStyle(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border:", " solid ", ";border-radius:", ";color:", ";padding:", " ", ";font-size:", ";line-height:", ";"], props.theme.button.border.width, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.colorValue || props.theme.button.border.color || 'control', props.theme), props.theme.button.border.radius, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.button.color || 'text', props.theme), props.theme.button.padding.vertical, props.theme.button.padding.horizontal, props.theme.text.medium.size, props.theme.text.medium.height);
};

var primaryStyle = function primaryStyle(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", " border-radius:", ";"], Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* backgroundStyle */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.colorValue || props.theme.button.primary.color || 'control', props.theme), props.theme, props.theme.button.color), props.theme.button.border.radius);
};

var disabledStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["opacity:", ";cursor:default;"], function (props) {
  return props.theme.button.disabled.opacity;
});

function getHoverColor(props) {
  if (props.colorValue) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.colorValue, props.theme);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.button.border.color || 'control', props.theme);
}

function getHoverIndicatorStyle(hoverIndicator, theme) {
  var background;

  if (hoverIndicator === true || hoverIndicator === 'background') {
    background = theme.global.hover.background;
  } else {
    background = hoverIndicator;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", " color:", ";"], Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* backgroundStyle */])(background, theme), Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(theme.global.hover.color, theme));
}

var hoverStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["&:hover{", " ", ";}"], function (props) {
  return props.hoverIndicator && getHoverIndicatorStyle(props.hoverIndicator, props.theme);
}, function (props) {
  return !props.plain && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["box-shadow:0px 0px 0px 2px ", ";"], getHoverColor(props));
});
var fillStyle = "\n  width: 100%;\n  height: 100%;\n  max-width: none;\n  flex: 1 0 auto;\n";
var plainStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["color:inherit;border:none;padding:0;text-align:inherit;"]);
var StyledButton = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].button.withConfig({
  displayName: "StyledButton",
  componentId: "sc-323bzc-0"
})(["display:inline-block;box-sizing:border-box;cursor:pointer;outline:none;font:inherit;text-decoration:none;margin:0;background:transparent;overflow:visible;text-transform:none;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return props.plain && plainStyle;
}, function (props) {
  return !props.plain && basicStyle(props);
}, function (props) {
  return props.primary && primaryStyle(props);
}, function (props) {
  return !props.disabled && !props.focus && hoverStyle;
}, function (props) {
  return !props.disabled && props.active && __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* activeStyle */];
}, function (props) {
  return props.disabled && disabledStyle;
}, function (props) {
  return props.focus && (!props.plain || props.focusIndicator) && __WEBPACK_IMPORTED_MODULE_1__utils__["p" /* focusStyle */];
}, function (props) {
  return !props.plain && "\n    transition: 0.1s ease-in-out;\n  ";
}, function (props) {
  return props.fillContainer && fillStyle;
}, function (props) {
  return props.hasIcon && !props.hasLabel && "\n    padding: " + props.theme.global.edgeSize.small + ";\n  ";
}, function (props) {
  return props.theme.button.extend;
});
StyledButton.defaultProps = {};
Object.setPrototypeOf(StyledButton.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapsibleWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var animatedBoxProperty = function animatedBoxProperty(direction) {
  return direction === 'horizontal' ? 'width' : 'height';
};

var AnimatedBox = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */]).withConfig({
  displayName: "Collapsible__AnimatedBox",
  componentId: "sc-15kniua-0"
})(["", ";"], function (props) {
  return !props.animate && (props.open ? "\n    max-" + animatedBoxProperty(props.collapsibleDirection) + ": unset;\n    visibility: visible;\n  " : "\n    max-" + animatedBoxProperty(props.collapsibleDirection) + ": 0;\n    visibility: hidden;\n  ");
});

var Collapsible =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Collapsible, _Component);

  Collapsible.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var open = nextProps.open;

    if (open !== prevState.open) {
      return {
        animate: true,
        open: open
      };
    }

    return null;
  };

  function Collapsible(props, context) {
    var _this;

    _this = _Component.call(this, props, context) || this;
    /* eslint-disable-next-line react/prop-types */

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ref", Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getSnapshotBeforeUpdate", function () {
      return _this.ref.current && _this.ref.current.getBoundingClientRect();
    });

    _this.state = {
      open: props.open,
      animate: false
    };
    return _this;
  }

  var _proto = Collapsible.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
    var _this2 = this;

    var _this$props = this.props,
        direction = _this$props.direction,
        _this$props$theme$col = _this$props.theme.collapsible,
        minSpeed = _this$props$theme$col.minSpeed,
        baseline = _this$props$theme$col.baseline;
    var _this$state = this.state,
        animate = _this$state.animate,
        open = _this$state.open;
    var container = this.ref.current;

    if (container) {
      var dimension = animatedBoxProperty(direction);
      var boudingClientRect = container.getBoundingClientRect();
      var dimensionSize = boudingClientRect[dimension];
      var shouldAnimate = animate && prevState.open !== open;

      if (open && snapshot[dimension] && dimensionSize !== snapshot[dimension]) {
        shouldAnimate = true;
      }

      if (shouldAnimate) {
        if (this.animationTimeout) {
          clearTimeout(this.animationTimeout);
        }

        var speed = Math.max(dimensionSize / baseline * minSpeed, minSpeed);
        container.style["max-" + dimension] = snapshot[dimension] + "px";
        container.style.overflow = 'hidden';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            container.style.transition = "max-" + dimension + " " + speed + "ms, visibility 50ms";
            container.style["max-" + dimension] = open ? dimensionSize + "px" : '0px';
            _this2.animationTimeout = setTimeout(function () {
              container.removeAttribute('style');

              _this2.setState({
                animate: false
              });
            }, speed);
          });
        });
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
    }
  };

  _proto.render = function render() {
    /* eslint-disable-next-line react/prop-types */
    var _this$props2 = this.props,
        children = _this$props2.children,
        direction = _this$props2.direction;
    var _this$state2 = this.state,
        animate = _this$state2.animate,
        open = _this$state2.open;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AnimatedBox, {
      "aria-hidden": !open,
      ref: this.ref,
      open: open,
      animate: animate,
      collapsibleDirection: direction
    }, children);
  };

  return Collapsible;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapsible.defaultProps = {};
Object.setPrototypeOf(Collapsible.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var CollapsibleDoc;

if (false) {
  CollapsibleDoc = require('./doc').doc(Collapsible); // eslint-disable-line global-require
}

var CollapsibleWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(CollapsibleDoc || Collapsible);


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeadingWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledHeading__ = __webpack_require__(403);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Heading = function Heading(props) {
  var color = props.color,
      level = props.level,
      rest = _objectWithoutPropertiesLoose(props, ["color", "level"]); // enforce level to be a number


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StyledHeading__["a" /* StyledHeading */], _extends({
    as: "h" + level,
    colorProp: color,
    level: +level
  }, rest));
};

Heading.defaultProps = {
  level: 1,
  responsive: true
};
var HeadingDoc;

if (false) {
  HeadingDoc = require('./doc').doc(Heading); // eslint-disable-line global-require
}

var HeadingWrapper = HeadingDoc || Heading;


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledHeading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);




var sizeStyle = function sizeStyle(props) {
  // size is a combination of the level and size properties
  var size = props.size || 'medium';
  var headingTheme = props.theme.heading;
  var levelStyle = headingTheme.level[props.level];

  if (levelStyle) {
    var data = levelStyle[size];
    var styles = [Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-size:", ";line-height:", ";max-width:", ";font-weight:", ";"], data.size, data.height, data.maxWidth, headingTheme.weight)];

    if (props.responsive && headingTheme.responsiveBreakpoint) {
      var breakpoint = props.theme.global.breakpoints[headingTheme.responsiveBreakpoint];

      if (breakpoint) {
        var responsiveData = headingTheme.level[Math.min(props.level + 1, 4)][size];
        styles.push(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* breakpointStyle */])(breakpoint, "\n          font-size: " + responsiveData.size + ";\n          line-height: " + responsiveData.height + ";\n          max-width: " + responsiveData.maxWidth + ";\n        "));
      }
    }

    return styles;
  }

  console.warn("Heading level " + props.level + " is not defined in your theme.");
  return '';
};

var fontFamily = function fontFamily(props) {
  var font = props.theme.heading.level[props.level].font;

  if (font && font.family) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-family:", ";"], font.family);
  }

  return props.theme.heading.font ? Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-family:", ";"], props.theme.heading.font.family) : '';
};

var TEXT_ALIGN_MAP = {
  center: 'center',
  end: 'right',
  start: 'left'
};
var textAlignStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["text-align:", ";"], function (props) {
  return TEXT_ALIGN_MAP[props.textAlign];
});
var truncateStyle = "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var colorStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["color:", ";"], function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.colorProp, props.theme);
});
var StyledHeading = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].h1.withConfig({
  displayName: "StyledHeading",
  componentId: "sc-1rdh4aw-0"
})(["", " ", " ", " ", " ", " ", " ", ""], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return fontFamily(props);
}, function (props) {
  return sizeStyle(props);
}, function (props) {
  return props.textAlign && textAlignStyle;
}, function (props) {
  return props.truncate && truncateStyle;
}, function (props) {
  return props.colorProp && colorStyle;
}, function (props) {
  return props.theme.heading && props.theme.heading.extend;
});
StyledHeading.defaultProps = {};
Object.setPrototypeOf(StyledHeading.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnchorWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StyledAnchor__ = __webpack_require__(405);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }










var Anchor =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Anchor, _Component);

  function Anchor(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var children = props.children,
        icon = props.icon,
        label = props.label;

    if ((icon || label) && children) {
      console.warn('Anchor should not have children if icon or label is provided');
    }

    return _this;
  }

  var _proto = Anchor.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        a11yTitle = _this$props.a11yTitle,
        children = _this$props.children,
        color = _this$props.color,
        disabled = _this$props.disabled,
        forwardRef = _this$props.forwardRef,
        href = _this$props.href,
        icon = _this$props.icon,
        focus = _this$props.focus,
        label = _this$props.label,
        onClick = _this$props.onClick,
        reverse = _this$props.reverse,
        theme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["a11yTitle", "children", "color", "disabled", "forwardRef", "href", "icon", "focus", "label", "onClick", "reverse", "theme"]);

    var coloredIcon = icon;

    if (icon && !icon.props.color) {
      coloredIcon = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(icon, {
        color: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["B" /* normalizeColor */])(color || theme.anchor.color, theme)
      });
    }

    var first = reverse ? label : coloredIcon;
    var second = reverse ? coloredIcon : label;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledAnchor__["a" /* StyledAnchor */], _extends({}, rest, {
      ref: forwardRef,
      "aria-label": a11yTitle,
      colorProp: color,
      disabled: disabled,
      hasIcon: !!icon,
      focus: focus,
      hasLabel: label,
      reverse: reverse,
      href: !disabled ? href : undefined,
      onClick: !disabled ? onClick : undefined
    }), first && second ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      as: "span",
      direction: "row",
      align: "center",
      gap: "small",
      style: {
        display: 'inline-flex'
      }
    }, first, second) : first || second || children);
  };

  return Anchor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Anchor.defaultProps = {};
Object.setPrototypeOf(Anchor.defaultProps, __WEBPACK_IMPORTED_MODULE_4__default_props__["a" /* defaultProps */]);
var AnchorDoc;

if (false) {
  AnchorDoc = require('./doc').doc(Anchor); // eslint-disable-line global-require
}

var AnchorWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_6__hocs__["c" /* withFocus */], __WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */], __WEBPACK_IMPORTED_MODULE_6__hocs__["d" /* withForwardRef */])(AnchorDoc || Anchor);


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledAnchor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var disabledStyle = "\n  opacity: 0.3;\n  cursor: default;\n  text-decoration: none;\n";

var sizeStyle = function sizeStyle(props) {
  if (props.size) {
    var size = props.size || 'medium';
    var data = props.theme.text[size];
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-size:", ";line-height:", ";"], data.size, data.height);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-size:inherit;line-height:inherit;"]);
};

var StyledAnchor = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].a.withConfig({
  displayName: "StyledAnchor",
  componentId: "sc-1rp7lwl-0"
})(["box-sizing:border-box;", " color:", ";", " text-decoration:", ";cursor:pointer;outline:none;", " ", " ", " ", " ", " ", ""], function (props) {
  return sizeStyle(props);
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.colorProp || props.theme.anchor.color, props.theme);
}, function (props) {
  return props.theme.anchor.fontWeight && "font-weight: " + props.theme.anchor.fontWeight + ";";
}, function (props) {
  return props.hasIcon ? 'none' : props.theme.anchor.textDecoration;
}, __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return !props.disabled && props.theme.anchor.hover && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["&:hover{", " ", " ", "}"], props.theme.anchor.hover.textDecoration && "text-decoration: " + props.theme.anchor.hover.textDecoration + ";", props.theme.anchor.hover.fontWeight && "font-weight: " + props.theme.anchor.hover.fontWeight + ";", props.theme.anchor.hover.extend);
}, function (props) {
  return props.hasIcon && !props.hasLabel && "\n    padding: " + props.theme.global.edgeSize.small + ";\n  ";
}, function (props) {
  return props.disabled && disabledStyle;
}, function (props) {
  return props.focus && __WEBPACK_IMPORTED_MODULE_1__utils__["p" /* focusStyle */];
}, function (props) {
  return props.theme.anchor.extend;
});
StyledAnchor.defaultProps = {};
Object.setPrototypeOf(StyledAnchor.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar__ = __webpack_require__(407);
/* unused harmony reexport Calendar */


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Calendar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Heading__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Keyboard__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StyledCalendar__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(410);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }











var headingPadMap = {
  small: 'xsmall',
  medium: 'small',
  large: 'medium'
};

var buildStartEnd = function buildStartEnd(reference, firstDayOfWeek) {
  var start = new Date(reference);
  start.setDate(1); // first of month

  start = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["g" /* subtractDays */])(start, start.getDay() - firstDayOfWeek); // beginning of week

  var end = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* addDays */])(start, 7 * 5 + 7); // 5 weeks to end of week

  return {
    start: start,
    end: end
  };
};

var buildState = function buildState(props) {
  var date = props.date,
      dates = props.dates,
      firstDayOfWeek = props.firstDayOfWeek,
      reference = props.reference;
  var normalizedReference;

  if (reference) {
    normalizedReference = new Date(reference);
  } else if (date) {
    normalizedReference = new Date(date);
  } else if (dates && dates.length > 0) {
    if (typeof dates[0] === 'string') {
      normalizedReference = new Date(dates[0]);
    } else if (Array.isArray(dates[0])) {
      normalizedReference = new Date(dates[0][0]);
    } else {
      normalizedReference = new Date();
    }
  } else {
    normalizedReference = new Date();
  }

  return _extends({}, buildStartEnd(normalizedReference, firstDayOfWeek), {
    reference: normalizedReference
  });
};

var Calendar =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Calendar, _Component);

  function Calendar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dayRefs", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearSlideStateLater", function () {
      clearTimeout(_this.timer);
      _this.timer = setTimeout(function () {
        var targetStartEnd = _this.state.targetStartEnd;

        if (targetStartEnd) {
          _this.setState({
            start: targetStartEnd.start,
            end: targetStartEnd.end,
            targetStartEnd: undefined,
            slide: undefined
          });
        } // Wait for animation to finish before cleaning up. Empirically determined.

      }, 800);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setReference", function (reference) {
      var _this$props = _this.props,
          animate = _this$props.animate,
          bounds = _this$props.bounds,
          firstDayOfWeek = _this$props.firstDayOfWeek,
          onReference = _this$props.onReference;
      var _this$state = _this.state,
          start = _this$state.start,
          end = _this$state.end,
          targetStartEnd = _this$state.targetStartEnd;

      if (Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* betweenDates */])(reference, bounds)) {
        var nextStartEnd = buildStartEnd(reference, firstDayOfWeek);
        var nextState = {
          reference: reference
        }; // if we're changing too fast, bypass animation

        if (!animate || targetStartEnd) {
          nextState.targetStartEnd = nextStartEnd;
          nextState.start = nextStartEnd.start;
          nextState.end = nextStartEnd.end;
          nextState.targetStartEnd = undefined;
          nextState.slide = undefined;
        } else {
          nextState.targetStartEnd = nextStartEnd;

          if (nextStartEnd.start.getTime() < start.getTime()) {
            nextState.start = nextStartEnd.start;
            nextState.slide = {
              direction: 'down',
              weeks: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* daysApart */])(start, nextStartEnd.start) / 7
            };
          } else if (nextStartEnd.end.getTime() > end.getTime()) {
            nextState.end = nextStartEnd.end;
            nextState.slide = {
              direction: 'up',
              weeks: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* daysApart */])(nextStartEnd.end, end) / 7
            };
          }
        }

        _this.clearSlideStateLater();

        _this.setState(nextState, function () {
          if (onReference) {
            onReference(reference.toISOString());
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFocus", function (day) {
      return function () {
        var bounds = _this.props.bounds;
        var reference = _this.state.reference;

        if (Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* betweenDates */])(day, bounds)) {
          _this.setState({
            focused: day
          }, function () {
            if (day.getMonth() !== reference.getMonth()) {
              _this.setReference(day);
            }
          });
        }
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClickDay", function (dateString) {
      return function () {
        var _this$props2 = _this.props,
            onSelect = _this$props2.onSelect,
            range = _this$props2.range;

        if (range) {
          var nextState = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["i" /* updateDateRange */])(dateString, _this.state);

          _this.setState(nextState);

          if (onSelect) {
            onSelect(nextState.dates || nextState.date || undefined);
          }
        } else if (onSelect) {
          onSelect(dateString);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setFocus", function (day) {
      var ref = _this.dayRefs[day.toISOString()];

      if (ref && ref.current) {
        ref.current.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderCalendarHeader", function (previousMonth, nextMonth) {
      var _this$props3 = _this.props,
          bounds = _this$props3.bounds,
          locale = _this$props3.locale,
          size = _this$props3.size,
          theme = _this$props3.theme;
      var reference = _this.state.reference;
      var PreviousIcon = size === 'small' ? theme.calendar.icons.small.previous : theme.calendar.icons.previous;
      var NextIcon = size === 'small' ? theme.calendar.icons.small.next : theme.calendar.icons.next;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
        direction: "row",
        justify: "between",
        align: "center"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
        flex: true,
        pad: {
          horizontal: headingPadMap[size] || 'small'
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Heading__["a" /* Heading */], {
        level: size === 'small' ? 4 : 3,
        size: size,
        margin: "none"
      }, reference.toLocaleDateString(locale, {
        month: 'long',
        year: 'numeric'
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
        flex: false,
        direction: "row",
        align: "center"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* Button */], {
        a11yTitle: previousMonth.toLocaleDateString(locale, {
          month: 'long',
          year: 'numeric'
        }),
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PreviousIcon, {
          size: size !== 'small' ? size : undefined
        }),
        disabled: !Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* betweenDates */])(previousMonth, bounds),
        onClick: function onClick() {
          return _this.setReference(previousMonth);
        }
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* Button */], {
        a11yTitle: nextMonth.toLocaleDateString(locale, {
          month: 'long',
          year: 'numeric'
        }),
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NextIcon, {
          size: size !== 'small' ? size : undefined
        }),
        disabled: !Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* betweenDates */])(nextMonth, bounds),
        onClick: function onClick() {
          return _this.setReference(nextMonth);
        }
      })));
    });

    return _this;
  }

  Calendar.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var reference = nextProps.reference;
    var prevReference = prevState.reference;

    if (Object.prototype.hasOwnProperty.call(nextProps, 'date') || Object.prototype.hasOwnProperty.call(nextProps, 'dates') || !prevReference || reference) {
      var state = {};

      if (Object.prototype.hasOwnProperty.call(nextProps, 'date') || Object.prototype.hasOwnProperty.call(nextProps, 'dates')) {
        state.date = nextProps.date;
        state.dates = nextProps.dates;
      }

      if (!prevReference || reference) {
        state = _extends({}, state, buildState(nextProps));
      }

      return state;
    }

    return null;
  };

  var _proto = Calendar.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var focused = this.state.focused;

    if (focused) {
      var ref = this.dayRefs[focused.toISOString()];

      if (ref && ref.current && ref.current !== document.activeElement) {
        ref.current.focus();
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timer);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props4 = this.props,
        bounds = _this$props4.bounds,
        dateProp = _this$props4.date,
        datesProp = _this$props4.dates,
        disabled = _this$props4.disabled,
        firstDayOfWeek = _this$props4.firstDayOfWeek,
        header = _this$props4.header,
        locale = _this$props4.locale,
        onReference = _this$props4.onReference,
        onSelect = _this$props4.onSelect,
        range = _this$props4.range,
        showAdjacentDays = _this$props4.showAdjacentDays,
        size = _this$props4.size,
        theme = _this$props4.theme,
        rest = _objectWithoutPropertiesLoose(_this$props4, ["bounds", "date", "dates", "disabled", "firstDayOfWeek", "header", "locale", "onReference", "onSelect", "range", "showAdjacentDays", "size", "theme"]);

    var _this$state2 = this.state,
        date = _this$state2.date,
        dates = _this$state2.dates,
        focused = _this$state2.focused,
        start = _this$state2.start,
        reference = _this$state2.reference,
        end = _this$state2.end,
        slide = _this$state2.slide; // We have to deal with reference being the end of a month with more
    // days than the month we are changing to. So, we always set reference
    // to the first of the month before changing the month.

    var previousMonth = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["e" /* endOfMonth */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["h" /* subtractMonths */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["f" /* startOfMonth */])(reference), 1));
    var nextMonth = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["f" /* startOfMonth */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* addMonths */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["f" /* startOfMonth */])(reference), 1));
    var weeks = [];
    var day = new Date(start);
    var days;
    this.dayRefs = {};

    while (day.getTime() < end.getTime()) {
      if (day.getDay() === firstDayOfWeek) {
        if (days) {
          weeks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StyledCalendar__["d" /* StyledWeek */], {
            key: day.getTime()
          }, days));
        }

        days = [];
      }

      var otherMonth = day.getMonth() !== reference.getMonth();

      if (!showAdjacentDays && otherMonth) {
        days.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StyledCalendar__["c" /* StyledDayContainer */], {
          key: day.getTime(),
          sizeProp: size
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StyledCalendar__["b" /* StyledDay */], {
          sizeProp: size
        })));
      } else {
        var dateString = day.toISOString();
        this.dayRefs[dateString] = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
        var selected = false;
        var inRange = false;
        var selectedState = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["j" /* withinDates */])(day, date || dates);

        if (selectedState === 2) {
          selected = true;
        } else if (selectedState === 1) {
          inRange = true;
        }

        var dayDisabled = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["j" /* withinDates */])(day, disabled) || bounds && !Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* betweenDates */])(day, bounds);
        days.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StyledCalendar__["c" /* StyledDayContainer */], {
          key: day.getTime(),
          sizeProp: size
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* Button */], {
          ref: this.dayRefs[dateString],
          a11yTitle: day.toDateString(),
          plain: true,
          hoverIndicator: !dayDisabled,
          disabled: dayDisabled,
          onClick: this.onClickDay(dateString),
          onFocus: this.onFocus(day),
          onBlur: function onBlur() {
            return _this2.setState({
              focused: false
            });
          }
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StyledCalendar__["b" /* StyledDay */], {
          inRange: inRange,
          otherMonth: day.getMonth() !== reference.getMonth(),
          isSelected: selected,
          sizeProp: size
        }, day.getDate()))));
      }

      day = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* addDays */])(day, 1);
    }

    weeks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StyledCalendar__["d" /* StyledWeek */], {
      key: day.getTime()
    }, days));
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StyledCalendar__["a" /* StyledCalendar */], _extends({
      sizeProp: size
    }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Keyboard__["a" /* Keyboard */], {
      onUp: function onUp(event) {
        event.preventDefault();

        _this2.setFocus(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* addDays */])(focused, -7));
      },
      onDown: function onDown(event) {
        event.preventDefault();

        _this2.setFocus(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* addDays */])(focused, 7));
      },
      onLeft: function onLeft() {
        return focused && _this2.setFocus(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* addDays */])(focused, -1));
      },
      onRight: function onRight() {
        return focused && _this2.setFocus(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* addDays */])(focused, 1));
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], null, header ? header({
      date: reference,
      locale: locale,
      onPreviousMonth: function onPreviousMonth() {
        return _this2.setReference(previousMonth);
      },
      onNextMonth: function onNextMonth() {
        return _this2.setReference(nextMonth);
      },
      previousInBound: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* betweenDates */])(previousMonth, bounds),
      nextInBound: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* betweenDates */])(nextMonth, bounds)
    }) : this.renderCalendarHeader(previousMonth, nextMonth), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StyledCalendar__["f" /* StyledWeeksContainer */], {
      sizeProp: size
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StyledCalendar__["e" /* StyledWeeks */], {
      slide: slide,
      sizeProp: size
    }, weeks)))));
  };

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Calendar, "defaultProps", {
  animate: true,
  firstDayOfWeek: 0,
  size: 'medium',
  locale: 'en-US',
  showAdjacentDays: true
});

Object.setPrototypeOf(Calendar.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var CalendarDoc;

if (false) {
  CalendarDoc = require('./doc').doc(Calendar); // eslint-disable-line global-require
}

var CalendarWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(CalendarDoc || Calendar);


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeyboardWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var KEYS = {
  8: 'onBackspace',
  9: 'onTab',
  13: 'onEnter',
  27: 'onEsc',
  32: 'onSpace',
  37: 'onLeft',
  38: 'onUp',
  39: 'onRight',
  40: 'onDown',
  188: 'onComma',
  16: 'onShift'
};

var Keyboard =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Keyboard, _Component);

  function Keyboard() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event) {
      /* eslint-disable-next-line react/prop-types */
      var onKeyDown = _this.props.onKeyDown;
      var key = event.keyCode ? event.keyCode : event.which;
      var callbackName = KEYS[key];
      /* eslint-disable react/destructuring-assignment */

      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }

      if (callbackName && _this.props[callbackName]) {
        var _this$props;

        (_this$props = _this.props)[callbackName].apply(_this$props, [event].concat(rest));
      }
      /* eslint-enable react/destructuring-assignment */


      if (onKeyDown) {
        onKeyDown.apply(void 0, [event].concat(rest));
      }
    });

    return _this;
  }

  var _proto = Keyboard.prototype;

  _proto.componentDidMount = function componentDidMount() {
    /* eslint-disable-next-line react/prop-types */
    var target = this.props.target;

    if (target === 'document') {
      document.addEventListener('keydown', this.onKeyDown);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var target = this.props.target;

    if (target === 'document') {
      document.removeEventListener('keydown', this.onKeyDown);
    }
  };

  _proto.render = function render() {
    /* eslint-disable-next-line react/prop-types */
    var _this$props2 = this.props,
        children = _this$props2.children,
        target = _this$props2.target;
    return target === 'document' ? children : Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children), {
      onKeyDown: this.onKeyDown
    });
  };

  return Keyboard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var KeyboardDoc;

if (false) {
  KeyboardDoc = require('./doc').doc(Keyboard); // eslint-disable-line global-require
}

var KeyboardWrapper = KeyboardDoc || Keyboard;


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StyledWeeksContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledWeeks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StyledWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledDayContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledDay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);




var sizeStyle = function sizeStyle(props) {
  var data = props.theme.calendar[props.sizeProp];
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-size:", ";line-height:", ";width:", ";"], data.fontSize, data.lineHeight, props.theme.global.size[props.sizeProp]);
};

var StyledCalendar = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledCalendar",
  componentId: "sc-1y4xhmp-0"
})(["", " ", " ", ""], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return sizeStyle(props);
}, function (props) {
  return props.theme.calendar && props.theme.calendar.extend;
});
StyledCalendar.defaultProps = {};
Object.setPrototypeOf(StyledCalendar.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledWeeksContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledCalendar__StyledWeeksContainer",
  componentId: "sc-1y4xhmp-1"
})(["overflow:hidden;", ";"], function (props) {
  return "height: " + Object(__WEBPACK_IMPORTED_MODULE_1__utils__["D" /* parseMetricToNum */])(props.theme.calendar[props.sizeProp].daySize) * 6 + "px;";
});
StyledWeeksContainer.defaultProps = {};
Object.setPrototypeOf(StyledWeeksContainer.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);

var slideStyle = function slideStyle(props) {
  var _props$slide = props.slide,
      direction = _props$slide.direction,
      weeks = _props$slide.weeks,
      sizeProp = props.sizeProp,
      theme = props.theme;
  var _theme$calendar$sizeP = theme.calendar[sizeProp],
      daySize = _theme$calendar$sizeP.daySize,
      slideDuration = _theme$calendar$sizeP.slideDuration;
  var amount = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["D" /* parseMetricToNum */])(daySize) * weeks;
  var translateYFrom = direction === 'down' ? "-" + amount + "px" : '0';
  var translateYTo = direction === 'up' ? "-" + amount + "px" : '0';
  var slideTransition = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["0%{transform:translateY(", ");}100%{transform:translateY(", ");}"], translateYFrom, translateYTo);
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["animation:", " ", " forwards;"], Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["", ""], slideTransition), slideDuration);
};

var StyledWeeks = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledCalendar__StyledWeeks",
  componentId: "sc-1y4xhmp-2"
})(["position:relative;", ";"], function (props) {
  return props.slide && slideStyle(props);
});
StyledWeeks.defaultProps = {};
Object.setPrototypeOf(StyledWeeks.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledWeek = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledCalendar__StyledWeek",
  componentId: "sc-1y4xhmp-3"
})(["display:flex;flex-direction:row;flex-justify:between;"]);
StyledWeek.defaultProps = {};
Object.setPrototypeOf(StyledWeek.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledDayContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledCalendar__StyledDayContainer",
  componentId: "sc-1y4xhmp-4"
})(["flex:0 0 auto;"]);
StyledDayContainer.defaultProps = {};
Object.setPrototypeOf(StyledDayContainer.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);

var daySizeStyle = function daySizeStyle(props) {
  var data = props.theme.calendar[props.sizeProp];
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["width:", ";height:", ";"], data.daySize, data.daySize);
};

var StyledDay = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledCalendar__StyledDay",
  componentId: "sc-1y4xhmp-5"
})(["display:flex;justify-content:center;align-items:center;", " ", " ", " ", ""], function (props) {
  return daySizeStyle(props);
}, function (props) {
  return props.isSelected && Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* backgroundStyle */])('control', props.theme) || props.inRange && Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* backgroundStyle */])({
    color: 'control',
    opacity: 'weak'
  }, props.theme);
}, function (props) {
  return props.otherMonth && 'opacity: 0.5;';
}, function (props) {
  return props.isSelected && 'font-weight: bold;';
});
StyledDay.defaultProps = {};
Object.setPrototypeOf(StyledDay.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return subtractDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return subtractMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return startOfMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return endOfMonth; });
/* unused harmony export sameDay */
/* unused harmony export sameDayOrAfter */
/* unused harmony export sameDayOrBefore */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return daysApart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return betweenDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return withinDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateDateRange; });
// Utility functions for the Calendar.
// Just what's needed to avoid having to include a dependency like momentjs.
var DAY_MILLISECONDS = 24 * 60 * 60 * 1000;
var addDays = function addDays(date, days) {
  var result = new Date(date.getTime() + DAY_MILLISECONDS * days); // Deal with crossing the daylight savings time boundary,
  // where adding a day's worth when the time is midnight results in
  // being a day off.

  var hourDelta = result.getHours() - date.getHours(); // At this point, hourDelta is typically 1 or 23, depending on which
  // side of the switch we are on. Convert so that hourDelta is either +1 or -1.

  if (hourDelta > 12) {
    hourDelta -= 24;
  }

  result.setHours(result.getHours() - hourDelta);
  return result;
};
var subtractDays = function subtractDays(date, days) {
  return addDays(date, -days);
};
var addMonths = function addMonths(date, months) {
  var result = new Date(date);
  var years = Math.floor((date.getMonth() + months) / 12);
  result.setFullYear(date.getFullYear() + years);
  var targetMonth = (date.getMonth() + months) % 12;
  result.setMonth(targetMonth < 0 ? 12 + targetMonth : targetMonth);
  return result;
};
var subtractMonths = function subtractMonths(date, months) {
  return addMonths(date, -months);
};
var startOfMonth = function startOfMonth(date) {
  var result = new Date(date);
  result.setDate(1);
  return result;
};
var endOfMonth = function endOfMonth(date) {
  var result = addMonths(date, 1);
  result.setDate(0);
  return result;
};
var sameDay = function sameDay(date1, date2) {
  return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
var sameDayOrAfter = function sameDayOrAfter(date1, date2) {
  return date1.getFullYear() > date2.getFullYear() || date1.getFullYear() === date2.getFullYear() && (date1.getMonth() > date2.getMonth() || date1.getMonth() === date2.getMonth() && date1.getDate() >= date2.getDate());
};
var sameDayOrBefore = function sameDayOrBefore(date1, date2) {
  return date1.getFullYear() < date2.getFullYear() || date1.getFullYear() === date2.getFullYear() && (date1.getMonth() < date2.getMonth() || date1.getMonth() === date2.getMonth() && date1.getDate() <= date2.getDate());
};
var daysApart = function daysApart(date1, date2) {
  return Math.floor((date1.getTime() - date2.getTime()) / DAY_MILLISECONDS);
}; // betweenDates takes and array of two elements and checks if the
// supplied date lies between them, inclusive.
// returns 2 if exact match to one end, 1 if between, undefined otherwise

var betweenDates = function betweenDates(date, dates) {
  var result;

  if (dates) {
    var _dates$map = dates.map(function (d) {
      return new Date(d);
    }),
        from = _dates$map[0],
        to = _dates$map[1];

    if (sameDay(date, from) || sameDay(date, to)) {
      result = 2;
    } else if (sameDayOrAfter(date, from) && sameDayOrBefore(date, to)) {
      result = 1;
    }
  } else {
    result = 1;
  }

  return result;
}; // withinDates takes and array of string dates or 2 element arrays and
// checks whether the supplied date matches any string or is between
// any dates in arrays.
// returns 2 if exact match, 1 if between, undefined otherwise

var withinDates = function withinDates(date, dates) {
  var result;

  if (dates) {
    if (Array.isArray(dates)) {
      dates.some(function (d) {
        if (typeof d === 'string') {
          if (sameDay(date, new Date(d))) {
            result = 2;
          }
        } else {
          result = betweenDates(date, d);
        }

        return result;
      });
    } else if (sameDay(date, new Date(dates))) {
      result = 2;
    }
  }

  return result;
};
var updateDateRange = function updateDateRange(selectedDate, _ref) {
  var date = _ref.date,
      dates = _ref.dates,
      previousSelectedDate = _ref.previousSelectedDate;
  var result = {
    previousSelectedDate: selectedDate
  };

  if (!dates) {
    if (!date) {
      result.date = selectedDate;
    } else {
      var priorDate = new Date(date);
      var nextDate = new Date(selectedDate);

      if (priorDate.getTime() < nextDate.getTime()) {
        result.date = undefined;
        result.dates = [[date, selectedDate]];
      } else if (priorDate.getTime() > nextDate.getTime()) {
        result.date = undefined;
        result.dates = [[selectedDate, date]];
      } else {
        result.date = undefined;
      }
    }
  } else {
    var priorDates = dates[0].map(function (d) {
      return new Date(d);
    });
    var previousDate = new Date(previousSelectedDate);

    var _nextDate = new Date(selectedDate);

    if (_nextDate.getTime() === priorDates[0].getTime()) {
      result.dates = undefined;
      var _dates$ = dates[0];
      result.date = _dates$[1];
    } else if (_nextDate.getTime() === priorDates[1].getTime()) {
      result.dates = undefined;
      var _dates$2 = dates[0];
      result.date = _dates$2[0];
    } else if (_nextDate.getTime() < previousDate.getTime()) {
      if (_nextDate.getTime() < priorDates[0].getTime()) {
        result.dates = [[selectedDate, dates[0][1]]];
      } else if (_nextDate.getTime() > priorDates[0].getTime()) {
        result.dates = [[dates[0][0], selectedDate]];
      }
    } else if (_nextDate.getTime() > previousDate.getTime()) {
      if (_nextDate.getTime() > priorDates[1].getTime()) {
        result.dates = [[dates[0][0], selectedDate]];
      } else if (_nextDate.getTime() < priorDates[1].getTime()) {
        result.dates = [[selectedDate, dates[0][1]]];
      }
    }
  }

  return result;
};

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Carousel__ = __webpack_require__(412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Carousel__["a"]; });


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CarouselWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Keyboard__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Stack__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hocs__ = __webpack_require__(13);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var Carousel =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Carousel, _Component);

  function Carousel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      activeIndex: 0
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "play", function () {
      var play = _this.props.play;
      clearInterval(_this.timer);
      _this.timer = setInterval(function () {
        var children = _this.props.children;
        var activeIndex = _this.state.activeIndex;
        var lastIndex = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children) - 1;

        if (activeIndex < lastIndex) {
          _this.setState({
            activeIndex: activeIndex + 1,
            priorActiveIndex: activeIndex
          });
        } else {
          _this.setState({
            activeIndex: 0,
            priorActiveIndex: activeIndex
          });
        }
      }, play);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onRight", function () {
      var activeIndex = _this.state.activeIndex;
      clearInterval(_this.timer);

      _this.setState({
        activeIndex: activeIndex + 1,
        priorActiveIndex: activeIndex
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onLeft", function () {
      var activeIndex = _this.state.activeIndex;
      clearInterval(_this.timer);

      _this.setState({
        activeIndex: activeIndex - 1,
        priorActiveIndex: activeIndex
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSelect", function (index) {
      return function () {
        var activeIndex = _this.state.activeIndex;
        clearInterval(_this.timer);

        _this.setState({
          activeIndex: index,
          priorActiveIndex: activeIndex
        });
      };
    });

    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var play = this.props.play;

    if (play) {
      this.play();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var play = this.props.play;

    if (play && (!prevProps.play || play !== prevProps.play)) {
      this.play();
    } else if (!play && prevProps.play) {
      clearInterval(this.timer);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearInterval(this.timer);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        fill = _this$props.fill,
        focus = _this$props.focus,
        theme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["children", "fill", "focus", "theme"]);

    var _this$state = this.state,
        activeIndex = _this$state.activeIndex,
        priorActiveIndex = _this$state.priorActiveIndex;
    var lastIndex = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children) - 1;
    var onLeft = activeIndex > 0 ? this.onLeft : undefined;
    var onRight = activeIndex < lastIndex ? this.onRight : undefined;
    var CurrentIcon = theme.carousel.icons.current;
    var iconColor = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["B" /* normalizeColor */])(theme.carousel.icons.color || 'control', theme);
    var selectors = [];
    var wrappedChildren = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child, index) {
      selectors.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* Button */], {
        key: index,
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CurrentIcon, {
          color: activeIndex === index ? iconColor : undefined
        }),
        onClick: _this2.onSelect(index)
      }));
      var animation;

      if (index === activeIndex) {
        if (priorActiveIndex !== undefined) {
          animation = {
            type: priorActiveIndex < activeIndex ? 'slideLeft' : 'slideRight',
            size: 'xlarge'
          };
        }
      } else if (index === priorActiveIndex) {
        animation = {
          type: 'fadeOut'
        };
      } else {
        animation = {
          type: 'fadeOut',
          duration: 0
        };
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
        overflow: "hidden"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
        animation: animation
      }, child));
    });
    var NextIcon = theme.carousel.icons.next;
    var PreviousIcon = theme.carousel.icons.previous;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Keyboard__["a" /* Keyboard */], {
      onLeft: onLeft,
      onRight: onRight
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Stack__["a" /* Stack */], _extends({
      guidingChild: activeIndex,
      fill: fill
    }, rest), wrappedChildren, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      tabIndex: "0",
      focus: focus,
      fill: true,
      direction: "row",
      justify: "between"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      fill: "vertical"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* Button */], {
      fill: true,
      disabled: activeIndex <= 0,
      onClick: onLeft,
      hoverIndicator: true
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      justify: "center"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PreviousIcon, null)))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      justify: "end"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      direction: "row",
      justify: "center"
    }, selectors)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      fill: "vertical"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* Button */], {
      fill: true,
      disabled: activeIndex >= lastIndex,
      onClick: onRight,
      hoverIndicator: true
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      justify: "center"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NextIcon, null)))))));
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Carousel.defaultProps = {};
Object.setPrototypeOf(Carousel.defaultProps, __WEBPACK_IMPORTED_MODULE_4__default_props__["a" /* defaultProps */]);
var CarouselDoc;

if (false) {
  CarouselDoc = require('./doc').doc(Carousel); // eslint-disable-line global-require
}

var CarouselWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_9__hocs__["c" /* withFocus */], __WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(CarouselDoc || Carousel);


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StackWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledStack__ = __webpack_require__(414);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var Stack =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Stack, _Component);

  function Stack() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Stack.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        anchor = _this$props.anchor,
        children = _this$props.children,
        fill = _this$props.fill,
        guidingChild = _this$props.guidingChild,
        rest = _objectWithoutPropertiesLoose(_this$props, ["anchor", "children", "fill", "guidingChild"]); // make all children but the first absolutely positioned


    var guidingIndex = guidingChild;

    if (guidingIndex === 'first' || !guidingIndex) {
      guidingIndex = 0;
    } else if (guidingIndex === 'last') {
      guidingIndex = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) - 1;
    }

    var childIndex = 0;
    var styledChildren = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
      if (child) {
        var layer;

        if (childIndex === guidingIndex) {
          layer = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StyledStack__["b" /* StyledStackLayer */], {
            guiding: true,
            fillContainer: fill
          }, child);
        } else {
          layer = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StyledStack__["b" /* StyledStackLayer */], {
            anchor: anchor
          }, child);
        }

        childIndex += 1;
        return layer;
      }

      return child;
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StyledStack__["a" /* StyledStack */], _extends({
      fillContainer: fill
    }, rest), styledChildren);
  };

  return Stack;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var StackDoc;

if (false) {
  StackDoc = require('./doc').doc(Stack); // eslint-disable-line global-require
}

var StackWrapper = StackDoc || Stack;


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledStack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledStackLayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var fillStyle = "\n  width: 100%;\n  height: 100%;\n  max-width: none;\n  flex-grow: 1;\n  display: flex;\n";
var StyledStack = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledStack",
  componentId: "ajspsk-0"
})(["position:relative;", " ", " ", ""], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return props.fillContainer && fillStyle;
}, function (props) {
  return props.theme.stack && props.theme.stack.extend;
});
StyledStack.defaultProps = {};
Object.setPrototypeOf(StyledStack.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var styleMap = {
  fill: "\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  ",
  center: "\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  ",
  left: "\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n  ",
  right: "\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n  ",
  top: "\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  ",
  bottom: "\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  ",
  'top-left': "\n    top: 0;\n    left: 0;\n  ",
  'bottom-left': "\n    bottom: 0;\n    left: 0;\n  ",
  'top-right': "\n    top: 0;\n    right: 0;\n  ",
  'bottom-right': "\n    bottom: 0;\n    right: 0;\n  "
};
var StyledStackLayer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledStack__StyledStackLayer",
  componentId: "ajspsk-1"
})(["position:", ";", " ", " ", ""], function (props) {
  return props.guiding ? 'relative' : 'absolute';
}, function (props) {
  return props.guiding && 'display: block;';
}, function (props) {
  return !props.guiding && styleMap[props.anchor || 'fill'] + ";";
}, function (props) {
  return props.fillContainer && "\n    width: 100%;\n    height: 100%;\n  ";
});
StyledStackLayer.defaultProps = {};
Object.setPrototypeOf(StyledStackLayer.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chart__ = __webpack_require__(416);
/* unused harmony reexport Chart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calcs__ = __webpack_require__(418);
/* unused harmony reexport calcs */



/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Chart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StyledChart__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(182);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }









var renderBars = function renderBars(values, bounds, scale, height) {
  return (values || []).map(function (valueArg, index) {
    var label = valueArg.label,
        onHover = valueArg.onHover,
        value = valueArg.value,
        rest = _objectWithoutPropertiesLoose(valueArg, ["label", "onHover", "value"]);

    var key = "p-" + index;
    var bottom = value.length === 2 ? bounds[1][0] : value[1];
    var top = value.length === 2 ? value[1] : value[2];

    if (top !== 0) {
      var d = "M " + (value[0] - bounds[0][0]) * scale[0] + "," + ("" + (height - (bottom - bounds[1][0]) * scale[1])) + (" L " + (value[0] - bounds[0][0]) * scale[0] + ",") + ("" + (height - (top - bounds[1][0]) * scale[1]));
      var hoverProps;

      if (onHover) {
        hoverProps = {
          onMouseOver: function onMouseOver() {
            return onHover(true);
          },
          onMouseLeave: function onMouseLeave() {
            return onHover(false);
          }
        };
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
        key: key,
        fill: "none"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({
        d: d
      }, hoverProps, rest)));
    }

    return undefined;
  });
};

var renderLine = function renderLine(values, bounds, scale, height, _ref) {
  var onClick = _ref.onClick,
      onHover = _ref.onHover;
  var d = '';
  (values || []).forEach(function (_ref2, index) {
    var value = _ref2.value;
    d += (index ? ' L' : 'M') + " " + (value[0] - bounds[0][0]) * scale[0] + "," + ("" + (height - (value[1] - bounds[1][0]) * scale[1]));
  });
  var hoverProps;

  if (onHover) {
    hoverProps = {
      onMouseOver: function onMouseOver() {
        return onHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return onHover(false);
      }
    };
  }

  var clickProps;

  if (onClick) {
    clickProps = {
      onClick: onClick
    };
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "none"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({
    d: d
  }, hoverProps, clickProps)));
};

var renderArea = function renderArea(values, bounds, scale, height, _ref3) {
  var color = _ref3.color,
      onClick = _ref3.onClick,
      onHover = _ref3.onHover,
      theme = _ref3.theme;
  var d = '';
  (values || []).forEach(function (_ref4, index) {
    var value = _ref4.value;
    var top = value.length === 2 ? value[1] : value[2];
    d += (!index ? 'M' : ' L') + " " + (value[0] - bounds[0][0]) * scale[0] + "," + ("" + (height - (top - bounds[1][0]) * scale[1]));
  });
  (values || []).reverse().forEach(function (_ref5) {
    var value = _ref5.value;
    var bottom = value.length === 2 ? bounds[1][0] : value[1];
    d += " L " + (value[0] - bounds[0][0]) * scale[0] + "," + ("" + (height - (bottom - bounds[1][0]) * scale[1]));
  });

  if (d.length > 0) {
    d += ' Z';
  }

  var hoverProps;

  if (onHover) {
    hoverProps = {
      onMouseOver: function onMouseOver() {
        return onHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return onHover(false);
      }
    };
  }

  var clickProps;

  if (onClick) {
    clickProps = {
      onClick: onClick
    };
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["B" /* normalizeColor */])(color.color || color, theme)
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({
    d: d
  }, hoverProps, clickProps)));
};

var Chart =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Chart, _Component);

  function Chart() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "containerRef", Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      containerWidth: 0,
      containerHeight: 0
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onResize", function () {
      var containerNode = _this.containerRef.current;

      if (containerNode) {
        var parentNode = containerNode.parentNode;

        if (parentNode) {
          var rect = parentNode.getBoundingClientRect();

          _this.setState({
            containerWidth: rect.width,
            containerHeight: rect.height
          });
        }
      }
    });

    return _this;
  }

  Chart.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var bounds = nextProps.bounds,
        values = nextProps.values;
    var stateBounds = prevState.bounds,
        stateValues = prevState.values;

    if (!stateValues || values !== stateValues || bounds !== stateBounds) {
      var nextValues = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* normalizeValues */])(values);
      var nextBounds = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* normalizeBounds */])(bounds, nextValues);
      return {
        bounds: nextBounds,
        values: nextValues
      };
    }

    return null;
  };

  var _proto = Chart.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        color = _this$props.color,
        onClick = _this$props.onClick,
        onHover = _this$props.onHover,
        overflow = _this$props.overflow,
        round = _this$props.round,
        size = _this$props.size,
        theme = _this$props.theme,
        thickness = _this$props.thickness,
        type = _this$props.type,
        rest = _objectWithoutPropertiesLoose(_this$props, ["color", "onClick", "onHover", "overflow", "round", "size", "theme", "thickness", "type"]);

    delete rest.values;
    var _this$state = this.state,
        bounds = _this$state.bounds,
        containerWidth = _this$state.containerWidth,
        containerHeight = _this$state.containerHeight,
        values = _this$state.values;
    var sizeWidth = typeof size === 'string' ? size : size.width || 'medium';
    var sizeHeight = typeof size === 'string' ? size : size.height || 'medium';
    var width = sizeWidth === 'full' ? containerWidth : Object(__WEBPACK_IMPORTED_MODULE_3__utils__["D" /* parseMetricToNum */])(theme.global.size[sizeWidth]);
    var height = sizeHeight === 'full' ? containerHeight : Object(__WEBPACK_IMPORTED_MODULE_3__utils__["D" /* parseMetricToNum */])(theme.global.size[sizeHeight]);
    var strokeWidth = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["D" /* parseMetricToNum */])(theme.global.edgeSize[thickness]);
    var scale = [width / (bounds[0][1] - bounds[0][0]), height / (bounds[1][1] - bounds[1][0])];
    var viewBox = overflow ? "0 0 " + width + " " + height : "-" + strokeWidth / 2 + " -" + strokeWidth / 2 + " " + (width + strokeWidth) + " " + (height + strokeWidth);
    var colorName = typeof color === 'object' ? color.color : color;
    var opacity = color.opacity ? theme.global.opacity[color.opacity] : undefined;
    var contents;

    if (type === 'bar') {
      contents = renderBars(values, bounds, scale, height);
    } else if (type === 'line') {
      contents = renderLine(values, bounds, scale, height, this.props);
    } else if (type === 'area') {
      contents = renderArea(values, bounds, scale, height, this.props);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledChart__["a" /* StyledChart */], _extends({
      ref: this.containerRef,
      viewBox: viewBox,
      preserveAspectRatio: "none",
      width: size === 'full' ? '100%' : width,
      height: size === 'full' ? '100%' : height
    }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
      stroke: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["B" /* normalizeColor */])(colorName, theme),
      strokeWidth: strokeWidth,
      strokeLinecap: round ? 'round' : 'butt',
      strokeLinejoin: round ? 'round' : 'miter',
      opacity: opacity
    }, contents));
  };

  return Chart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Chart, "defaultProps", {
  color: 'accent-1',
  overflow: false,
  size: {
    width: 'medium',
    height: 'small'
  },
  thickness: 'medium',
  type: 'bar'
});

Object.setPrototypeOf(Chart.defaultProps, __WEBPACK_IMPORTED_MODULE_4__default_props__["a" /* defaultProps */]);
var ChartDoc;

if (false) {
  ChartDoc = require('./doc').doc(Chart); // eslint-disable-line global-require
}

var ChartWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(ChartDoc || Chart);


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledChart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var StyledChart = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].svg.withConfig({
  displayName: "StyledChart",
  componentId: "sc-1nae0gf-0"
})(["display:block;max-width:100%;overflow:visible;", " ", ";"], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return props.theme.chart && props.theme.chart.extend;
});
StyledChart.defaultProps = {};
Object.setPrototypeOf(StyledChart.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calcs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(182);

var calcs = function calcs(values, options) {
  if (options === void 0) {
    options = {};
  }

  var coarseness = options.coarseness || 5;
  var steps = options.steps || [1, 1];
  var calcValues = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* normalizeValues */])(values); // Calculate the max and min y values.

  var min = calcValues[0].value[1];
  var max = min;
  calcValues.forEach(function (value) {
    var y = value.value[1];
    min = Math.min(min, y);
    max = Math.max(max, y);
  }); // Calculate some reasonable y bounds based on the max and min y values.
  // This is so values like 87342.12 don't end up being displayed as the
  // graph axis edge label.

  var delta = max - min;
  var interval = Number.parseFloat((delta / coarseness).toPrecision(1));
  max = max - max % interval + interval;
  min -= min % interval;
  var bounds = [[calcValues[0].value[0], calcValues[calcValues.length - 1].value[0]], [min, max]];
  var dimensions = [bounds[0][1] - bounds[0][0], bounds[1][1] - bounds[1][0]]; // Calculate x and y axis values across the specfied number of steps.

  var yAxis = [];
  var y = bounds[1][1];
  var yStepInterval = dimensions[1] / steps[1];

  while (y >= bounds[1][0]) {
    yAxis.push(y);
    y -= yStepInterval;
  }

  var xAxis = [];
  var x = bounds[0][0];
  var xStepInterval = dimensions[0] / steps[0];

  while (x <= bounds[0][1]) {
    xAxis.push(x);
    x += xStepInterval;
  }

  return {
    axis: [xAxis, yAxis],
    bounds: bounds,
    dimensions: dimensions
  };
};

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CheckBox__ = __webpack_require__(420);
/* unused harmony reexport CheckBox */


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CheckBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StyledCheckBox__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(5);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }











var stopLabelClick = function stopLabelClick(event) {
  // prevents clicking on the label trigging the event twice
  // https://stackoverflow.com/questions/24501497/why-the-onclick-element-will-trigger-twice-for-label-element
  if (event.target.type !== 'checkbox') {
    event.stopPropagation();
  }
};

var CheckBox =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(CheckBox, _Component);

  function CheckBox(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var checked = props.checked,
        indeterminate = props.indeterminate,
        toggle = props.toggle;

    if (checked && indeterminate) {
      console.warn('Checkbox cannot be "checked" and "indeterminate" at the same time.');
    }

    if (toggle && indeterminate) {
      console.warn('Checkbox of type toggle does not have "indeterminate" state.');
    }

    return _this;
  }

  var _proto = CheckBox.prototype;

  _proto.render = function render() {
    var _ref;

    var _this$props = this.props,
        checked = _this$props.checked,
        disabled = _this$props.disabled,
        focus = _this$props.focus,
        forwardRef = _this$props.forwardRef,
        id = _this$props.id,
        label = _this$props.label,
        name = _this$props.name,
        onChange = _this$props.onChange,
        reverse = _this$props.reverse,
        theme = _this$props.theme,
        toggle = _this$props.toggle,
        indeterminate = _this$props.indeterminate,
        rest = _objectWithoutPropertiesLoose(_this$props, ["checked", "disabled", "focus", "forwardRef", "id", "label", "name", "onChange", "reverse", "theme", "toggle", "indeterminate"]);

    var themeableProps = {
      checked: checked,
      disabled: disabled,
      focus: focus,
      reverse: reverse,
      toggle: toggle,
      indeterminate: indeterminate
    };
    var hidden;

    if (disabled && checked) {
      hidden = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        name: name,
        type: "hidden",
        value: "true"
      });
    }

    var _theme$checkBox$icons = theme.checkBox.icons,
        CheckedIcon = _theme$checkBox$icons.checked,
        IndeterminateIcon = _theme$checkBox$icons.indeterminate;
    var borderColor = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["B" /* normalizeColor */])(theme.checkBox.border.color, theme);

    if (checked) {
      borderColor = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["B" /* normalizeColor */])(theme.checkBox.color || 'control', theme);
    }

    var visual = toggle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledCheckBox__["g" /* StyledCheckBoxToggle */], themeableProps, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledCheckBox__["f" /* StyledCheckBoxKnob */], themeableProps)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledCheckBox__["b" /* StyledCheckBoxBox */], _extends({
      as: __WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */],
      align: "center",
      justify: "center",
      width: theme.checkBox.size,
      height: theme.checkBox.size,
      border: {
        size: theme.checkBox.border.width,
        color: borderColor
      },
      round: theme.checkBox.check.radius
    }, themeableProps), !indeterminate && checked && (CheckedIcon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckedIcon, {
      theme: theme,
      as: __WEBPACK_IMPORTED_MODULE_7__StyledCheckBox__["d" /* StyledCheckBoxIcon */]
    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledCheckBox__["d" /* StyledCheckBoxIcon */], _extends({
      theme: theme,
      viewBox: "0 0 24 24",
      preserveAspectRatio: "xMidYMid meet"
    }, themeableProps), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      fill: "none",
      d: "M6,11.3 L10.3,16 L18,6.2"
    }))), !checked && indeterminate && (IndeterminateIcon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndeterminateIcon, {
      theme: theme,
      as: __WEBPACK_IMPORTED_MODULE_7__StyledCheckBox__["d" /* StyledCheckBoxIcon */]
    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledCheckBox__["d" /* StyledCheckBoxIcon */], _extends({
      theme: theme,
      viewBox: "0 0 24 24",
      preserveAspectRatio: "xMidYMid meet"
    }, themeableProps), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      fill: "none",
      d: "M6,12 L18,12"
    }))));
    var side = reverse ? 'left' : 'right';
    var checkBoxNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledCheckBox__["a" /* StyledCheckBox */], _extends({
      as: __WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */],
      align: "center",
      justify: "center",
      margin: (_ref = {}, _ref[side] = theme.checkBox.gap || 'small', _ref)
    }, themeableProps), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledCheckBox__["e" /* StyledCheckBoxInput */], _extends({}, rest, {
      ref: forwardRef,
      type: "checkbox"
    }, Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["c" /* removeUndefined */])({
      id: id,
      name: name,
      checked: checked,
      disabled: disabled,
      onChange: onChange
    }), themeableProps)), visual, hidden);
    var normalizedLabel = typeof label === 'string' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, label) : label;
    var first = reverse ? normalizedLabel : checkBoxNode;
    var second = reverse ? checkBoxNode : normalizedLabel;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledCheckBox__["c" /* StyledCheckBoxContainer */], _extends({
      reverse: reverse
    }, Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["c" /* removeUndefined */])({
      htmlFor: id,
      disabled: disabled
    }), {
      checked: checked,
      onClick: stopLabelClick
    }, themeableProps), first, second);
  };

  return CheckBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CheckBox.defaultProps = {};
Object.setPrototypeOf(CheckBox.defaultProps, __WEBPACK_IMPORTED_MODULE_4__default_props__["a" /* defaultProps */]);
var CheckBoxDoc;

if (false) {
  CheckBoxDoc = require('./doc').doc(CheckBox); // eslint-disable-line global-require
}

var CheckBoxWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_6__hocs__["c" /* withFocus */], __WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */], __WEBPACK_IMPORTED_MODULE_6__hocs__["d" /* withForwardRef */])(CheckBoxDoc || CheckBox);


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StyledCheckBoxIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledCheckBoxContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledCheckBoxInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledCheckBoxBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return StyledCheckBoxToggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StyledCheckBoxKnob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledCheckBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var disabledStyle = "\n  opacity: 0.5;\n  cursor: default;\n";
var hoverStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])([":hover input:not([disabled]) + div,:hover input:not([disabled]) + span{border-color:", ";}"], function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.checkBox.hover.border.color, props.theme);
});
var StyledCheckBoxIcon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].svg.withConfig({
  displayName: "StyledCheckBox__StyledCheckBoxIcon",
  componentId: "sc-1dbk5ju-0"
})(["box-sizing:border-box;position:absolute;stroke-width:", ";stroke:", ";width:", ";height:", ";", ";"], function (props) {
  return props.theme.checkBox.check.thickness;
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.checkBox.color || 'control', props.theme);
}, function (props) {
  return props.theme.checkBox.icon.size || props.theme.checkBox.size;
}, function (props) {
  return props.theme.checkBox.icon.size || props.theme.checkBox.size;
}, function (props) {
  return props.theme.checkBox.icon.extend;
});
StyledCheckBoxIcon.defaultProps = {};
Object.setPrototypeOf(StyledCheckBoxIcon.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledCheckBoxContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].label.withConfig({
  displayName: "StyledCheckBox__StyledCheckBoxContainer",
  componentId: "sc-1dbk5ju-1"
})(["display:flex;flex-direction:row;align-items:center;user-select:none;", " ", " ", " ", ""], function (props) {
  return props.disabled && disabledStyle;
}, function (props) {
  return !props.disabled && 'cursor: pointer;';
}, function (props) {
  return props.theme.checkBox.hover.border.color && hoverStyle;
}, function (props) {
  return props.theme.checkBox.extend;
});
StyledCheckBoxContainer.defaultProps = {};
Object.setPrototypeOf(StyledCheckBoxContainer.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledCheckBoxInput = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].input.withConfig({
  displayName: "StyledCheckBox__StyledCheckBoxInput",
  componentId: "sc-1dbk5ju-2"
})(["position:absolute;opacity:0;top:0;left:0;width:100%;height:100%;margin:0;z-index:1;", ":checked + span > span{left:calc( ", " - ", " );background:", ";}"], function (props) {
  return !props.disabled && 'cursor: pointer;';
}, function (props) {
  return props.theme.checkBox.toggle.size;
}, function (props) {
  return props.theme.checkBox.size;
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.checkBox.color || 'control', props.theme);
});
StyledCheckBoxInput.defaultProps = {};
Object.setPrototypeOf(StyledCheckBoxInput.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledCheckBoxBox = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledCheckBox__StyledCheckBoxBox",
  componentId: "sc-1dbk5ju-3"
})(["", ";", ";"], function (props) {
  return props.focus && __WEBPACK_IMPORTED_MODULE_1__utils__["p" /* focusStyle */];
}, function (props) {
  return props.theme.checkBox.check.extend;
});
StyledCheckBoxBox.defaultProps = {};
Object.setPrototypeOf(StyledCheckBoxBox.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledCheckBoxToggle = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span.withConfig({
  displayName: "StyledCheckBox__StyledCheckBoxToggle",
  componentId: "sc-1dbk5ju-4"
})(["box-sizing:border-box;position:relative;vertical-align:middle;display:inline-block;width:", ";height:", ";border:", " solid;border-color:", ";border-radius:", ";background-color:", ";", ";", ";"], function (props) {
  return props.theme.checkBox.toggle.size;
}, function (props) {
  return props.theme.checkBox.size;
}, function (props) {
  return props.theme.checkBox.border.width;
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.checkBox.border.color, props.theme);
}, function (props) {
  return props.theme.checkBox.toggle.radius;
}, function (props) {
  return props.theme.checkBox.toggle.background ? Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.checkBox.toggle.background, props.theme) : 'transparent';
}, function (props) {
  return props.focus && __WEBPACK_IMPORTED_MODULE_1__utils__["p" /* focusStyle */];
}, function (props) {
  return props.theme.checkBox.toggle.extend;
});
StyledCheckBoxToggle.defaultProps = {};
Object.setPrototypeOf(StyledCheckBoxToggle.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledCheckBoxKnob = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span.withConfig({
  displayName: "StyledCheckBox__StyledCheckBoxKnob",
  componentId: "sc-1dbk5ju-5"
})(["box-sizing:border-box;position:absolute;top:-", ";left:-", ";transition:all 0.3s;width:", ";height:", ";background:", ";border-radius:", ";", ";"], function (props) {
  return props.theme.checkBox.border.width;
}, function (props) {
  return props.theme.checkBox.border.width;
}, function (props) {
  return props.theme.checkBox.size;
}, function (props) {
  return props.theme.checkBox.size;
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.checkBox.toggle.color[props.theme.dark ? 'dark' : 'light'], props.theme);
}, function (props) {
  return props.theme.checkBox.toggle.radius;
}, function (props) {
  return props.theme.checkBox.toggle.knob.extend;
});
StyledCheckBoxKnob.defaultProps = {};
Object.setPrototypeOf(StyledCheckBoxKnob.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledCheckBox = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledCheckBox",
  componentId: "sc-1dbk5ju-6"
})(["position:relative;"]);
StyledCheckBox.defaultProps = {};
Object.setPrototypeOf(StyledCheckBox.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Clock__ = __webpack_require__(423);
/* unused harmony reexport Clock */


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Clock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Analog__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Digital__ = __webpack_require__(425);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var TIME_REGEXP = /T([0-9]{2}):([0-9]{2})(?::([0-9.,]{2,}))?/;
var DURATION_REGEXP = /^(-|\+)?P.*T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?$/;

var parseTime = function parseTime(time, hourLimit) {
  var result = {};

  if (time) {
    var match = DURATION_REGEXP.exec(time);

    if (match) {
      result.hours = parseFloat(match[2]);

      if (hourLimit === 12) {
        result.hours12 = result.hours > 12 ? result.hours - 12 : result.hours;
      }

      result.minutes = parseFloat(match[3]) || 0;
      result.seconds = parseFloat(match[4]) || 0;
      result.duration = true;
    } else {
      match = TIME_REGEXP.exec(time);

      if (match) {
        result.hours = parseFloat(match[1]);

        if (hourLimit === 12) {
          result.hours12 = result.hours > 12 ? result.hours - 12 : result.hours;
        }

        result.minutes = parseFloat(match[2]) || 0;
        result.seconds = parseFloat(match[3]) || 0;
      } else {
        console.error("Grommet Clock cannot parse '" + time + "'");
      }
    }
  } else {
    var date = new Date();
    result.hours = date.getHours();
    result.minutes = date.getMinutes();
    result.seconds = date.getSeconds();
  }

  return result;
};

var Clock =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Clock, _Component);

  function Clock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    return _this;
  }

  Clock.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var hourLimit = nextProps.hourLimit,
        time = nextProps.time;
    var elements = prevState.elements;

    if (!elements || time) {
      var nextElements = parseTime(time, hourLimit);

      if (!elements) {
        return {
          elements: nextElements
        };
      }

      if (Object.keys(nextElements).some(function (k) {
        return elements[k] !== nextElements[k];
      })) {
        return {
          elements: nextElements
        };
      }
    }

    return null;
  };

  var _proto = Clock.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var run = this.props.run;

    if (run) {
      this.run();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var run = this.props.run;

    if (run && !prevProps.run) {
      this.run();
    } else if (!run && prevProps.run) {
      clearInterval(this.timer);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearInterval(this.timer);
  };

  _proto.run = function run() {
    var _this2 = this;

    var _this$props = this.props,
        hourLimit = _this$props.hourLimit,
        onChange = _this$props.onChange,
        precision = _this$props.precision,
        run = _this$props.run;
    var elements = this.state.elements; // set the interval time based on the precision

    var interval = 1000;
    var increment = 'seconds';

    if (precision !== 'seconds' && elements.seconds === 0) {
      interval *= 60;
      increment = 'minutes';

      if (precision !== 'minutes' && elements.minutes === 0) {
        interval *= 60;
        increment = 'hours';
      }
    }

    clearInterval(this.timer);
    this.timer = setInterval(function () {
      var previousElements = _this2.state.elements;

      var nextElements = _extends({}, previousElements); // adjust time based on precision


      if (increment === 'seconds') {
        if (run === 'backward') {
          nextElements.seconds -= 1;
        } else {
          nextElements.seconds += 1;
        }
      } else if (increment === 'minutes') {
        if (run === 'backward') {
          nextElements.minutes -= 1;
        } else {
          nextElements.minutes += 1;
        }
      } else if (increment === 'hours') {
        if (run === 'backward') {
          nextElements.hours -= 1;
        } else {
          nextElements.hours += 1;
        }
      } // deal with overflows


      if (nextElements.seconds >= 60) {
        nextElements.minutes += Math.floor(nextElements.seconds / 60);
        nextElements.seconds = 0;
      } else if (nextElements.seconds < 0) {
        nextElements.minutes += Math.floor(nextElements.seconds / 60);
        nextElements.seconds = 59;
      }

      if (nextElements.minutes >= 60) {
        nextElements.hours += Math.floor(nextElements.minutes / 60);
        nextElements.minutes = 0;
      } else if (nextElements.minutes < 0) {
        nextElements.hours += Math.floor(nextElements.minutes / 60);
        nextElements.minutes = 59;
      }

      if (nextElements.hours >= 24 || nextElements.hours < 0) {
        nextElements.hours = 0;
      }

      if (hourLimit === 12) {
        nextElements.hours12 = nextElements.hours > 12 ? nextElements.hours - 12 : nextElements.hours;
      }

      _this2.setState({
        elements: nextElements
      }, function () {
        if (onChange) {
          if (elements.duration) {
            onChange("P" + elements.hours + "H" + elements.minutes + "M" + elements.seconds + "S");
          } else {
            onChange("T" + elements.hours + ":" + elements.minutes + ":" + elements.seconds);
          }
        }
      });
    }, interval);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        type = _this$props2.type,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["type"]);

    var elements = this.state.elements;
    var content;

    if (type === 'analog') {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Analog__["a" /* Analog */], _extends({
        elements: elements
      }, rest));
    } else if (type === 'digital') {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Digital__["a" /* Digital */], _extends({
        elements: elements
      }, rest));
    }

    return content;
  };

  return Clock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Clock, "defaultProps", {
  hourLimit: 24,
  precision: 'seconds',
  run: 'forward',
  size: 'medium',
  type: 'analog'
});

var ClockDoc;

if (false) {
  ClockDoc = require('./doc').doc(Clock); // eslint-disable-line global-require
}

var ClockWrapper = ClockDoc || Clock;


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnalogWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StyledClock__ = __webpack_require__(183);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // this will serve both minutes and hours (360 / 6)

var ANGLE_UNIT = 6; // 360 / 12

var HOUR_ANGLE_UNIT = 30;

var getClockDimensions = function getClockDimensions(theme) {
  return {
    size: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["D" /* parseMetricToNum */])(theme.clock.analog.size.medium),
    secondSize: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["D" /* parseMetricToNum */])(theme.clock.analog.second.size),
    minuteSize: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["D" /* parseMetricToNum */])(theme.clock.analog.minute.size),
    hourSize: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["D" /* parseMetricToNum */])(theme.clock.analog.hour.size)
  };
};

var getClockState = function getClockState(_ref) {
  var hours = _ref.hours,
      minutes = _ref.minutes,
      seconds = _ref.seconds;
  var hour12 = hours > 12 ? hours - 12 : hours;
  var minuteAngle = minutes * ANGLE_UNIT;
  return {
    // offset hour angle by half of the minute angle so that it gets closer to the next hour
    hourAngle: hour12 * HOUR_ANGLE_UNIT + minutes / 2,
    minuteAngle: minuteAngle,
    secondAngle: seconds * ANGLE_UNIT
  };
};

var Analog =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Analog, _Component);

  function Analog() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    return _this;
  }

  Analog.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var elements = nextProps.elements;
    var nextState = getClockState(elements);

    if (prevState.hourAngle === undefined || Object.keys(nextState).some(function (k) {
      return prevState[k] !== nextState[k];
    })) {
      return nextState;
    }

    return null;
  };

  var _proto = Analog.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        precision = _this$props.precision,
        theme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["precision", "theme"]);

    var _this$state = this.state,
        hourAngle = _this$state.hourAngle,
        minuteAngle = _this$state.minuteAngle,
        secondAngle = _this$state.secondAngle;

    var _getClockDimensions = getClockDimensions(theme),
        size = _getClockDimensions.size,
        secondSize = _getClockDimensions.secondSize,
        minuteSize = _getClockDimensions.minuteSize,
        hourSize = _getClockDimensions.hourSize;

    var halfSize = size / 2;
    var secondHand;

    if (precision === 'seconds') {
      secondHand = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledClock__["g" /* StyledSecond */], {
        x1: halfSize,
        y1: halfSize,
        x2: halfSize,
        y2: secondSize,
        stroke: "#000000",
        strokeLinecap: theme.clock.analog.second.shape,
        style: {
          transform: "rotate(" + secondAngle + "deg)",
          transformOrigin: halfSize + "px " + halfSize + "px"
        }
      });
    }

    var minuteHand;

    if (precision === 'seconds' || precision === 'minutes') {
      minuteHand = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledClock__["f" /* StyledMinute */], {
        x1: halfSize,
        y1: halfSize,
        x2: halfSize,
        y2: minuteSize,
        stroke: "#000000",
        strokeLinecap: theme.clock.analog.minute.shape,
        style: {
          transform: "rotate(" + minuteAngle + "deg)",
          transformOrigin: halfSize + "px " + halfSize + "px"
        }
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledClock__["a" /* StyledAnalog */], _extends({
      version: "1.1",
      width: size,
      height: size,
      preserveAspectRatio: "xMidYMid meet",
      viewBox: "0 0 " + size + " " + size
    }, rest), secondHand, minuteHand, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledClock__["e" /* StyledHour */], {
      x1: halfSize,
      y1: halfSize,
      x2: halfSize,
      y2: hourSize,
      stroke: "#000000",
      strokeLinecap: theme.clock.analog.hour.shape,
      style: {
        transform: "rotate(" + hourAngle + "deg)",
        transformOrigin: halfSize + "px " + halfSize + "px"
      }
    }));
  };

  return Analog;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Analog, "defaultProps", {
  size: 'medium'
});

Object.setPrototypeOf(Analog.defaultProps, __WEBPACK_IMPORTED_MODULE_4__default_props__["a" /* defaultProps */]);
var AnalogWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(Analog);


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Digital; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StyledClock__ = __webpack_require__(183);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var Digit =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Digit, _Component);

  function Digit() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    return _this;
  }

  Digit.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var number = nextProps.number;

    if (number !== prevState.number) {
      return {
        previous: prevState.number,
        number: number
      };
    }

    return null;
  };

  var _proto = Digit.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this2 = this;

    var previous = this.state.previous;

    if (prevState.previous === undefined && previous !== undefined) {
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this2.setState({
          previous: undefined
        });
      }, 900);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timer);
  };

  _proto.render = function render() {
    /* eslint-disable-next-line react/prop-types */
    var _this$props = this.props,
        run = _this$props.run,
        size = _this$props.size;
    var _this$state = this.state,
        number = _this$state.number,
        previous = _this$state.previous;

    if (previous !== undefined) {
      var direction = run === 'backward' ? 'down' : 'up';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StyledClock__["b" /* StyledDigitalDigit */], {
        size: size
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StyledClock__["d" /* StyledDigitalPrevious */], {
        direction: direction
      }, Math.floor(previous)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StyledClock__["c" /* StyledDigitalNext */], {
        direction: direction
      }, Math.floor(number)));
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StyledClock__["b" /* StyledDigitalDigit */], {
      size: size
    }, Math.floor(number));
  };

  return Digit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var Element = function Element(_ref) {
  var number = _ref.number,
      run = _ref.run,
      sep = _ref.sep,
      size = _ref.size;
  var tens = Math.floor(number / 10);
  var ones = number % 10;
  var result = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Digit, {
    key: "tens",
    run: run,
    size: size,
    number: tens
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Digit, {
    key: "ones",
    run: run,
    size: size,
    number: ones
  })];

  if (sep) {
    result.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StyledClock__["b" /* StyledDigitalDigit */], {
      key: "sep",
      size: size
    }, ":"));
  }

  return result;
};

var Digital = function Digital(props) {
  var elements = props.elements,
      precision = props.precision,
      run = props.run,
      size = props.size,
      rest = _objectWithoutPropertiesLoose(props, ["elements", "precision", "run", "size"]);

  var seconds;

  if (precision === 'seconds') {
    seconds = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Element, {
      number: elements.seconds,
      run: run,
      size: size,
      sep: true
    });
  }

  var minutes;

  if (precision === 'minutes' || precision === 'seconds') {
    minutes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Element, {
      number: elements.minutes,
      run: run,
      size: size,
      sep: true
    });
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Box__["a" /* Box */], _extends({
    direction: "row"
  }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Element, {
    number: elements.hours12 || elements.hours,
    run: run,
    size: size
  }), minutes, seconds);
};

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(427);
/* unused harmony reexport DataTable */


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DataTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Body__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GroupedBody__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buildState__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StyledDataTable__ = __webpack_require__(64);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var DataTable =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(DataTable, _Component);

  function DataTable() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFiltering", function (property) {
      _this.setState({
        filtering: property
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFilter", function (property, value) {
      /* eslint-disable-next-line react/prop-types */
      var onSearch = _this.props.onSearch;
      var filters = _this.state.filters;

      var nextFilters = _extends({}, filters);

      nextFilters[property] = value;

      _this.setState({
        filters: nextFilters
      }); // Let caller know about search, if interested


      if (onSearch) {
        onSearch(nextFilters);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSort", function (property) {
      return function () {
        var sort = _this.state.sort;
        var ascending = sort && property === sort.property ? !sort.ascending : true;

        _this.setState({
          sort: {
            property: property,
            ascending: ascending
          }
        });
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onToggleGroup", function (groupValue) {
      return function () {
        var groupState = _this.state.groupState;

        var nextGroupState = _extends({}, groupState);

        nextGroupState[groupValue] = _extends({}, nextGroupState[groupValue], {
          expanded: !nextGroupState[groupValue].expanded
        });

        _this.setState({
          groupState: nextGroupState
        });
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onToggleGroups", function () {
      var groupState = _this.state.groupState;
      var expanded = Object.keys(groupState).filter(function (k) {
        return !groupState[k].expanded;
      }).length === 0;
      var nextGroupState = {};
      Object.keys(groupState).forEach(function (k) {
        nextGroupState[k] = _extends({}, groupState[k], {
          expanded: !expanded
        });
      });

      _this.setState({
        groupState: nextGroupState
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onResize", function (property) {
      return function (width) {
        var widths = _this.state.widths;

        var nextWidths = _extends({}, widths || {});

        nextWidths[property] = width;

        _this.setState({
          widths: nextWidths
        });
      };
    });

    return _this;
  }

  DataTable.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__buildState__["a" /* buildState */])(nextProps, prevState);
  };

  var _proto = DataTable.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        columns = _this$props.columns,
        propsData = _this$props.data,
        groupBy = _this$props.groupBy,
        onMore = _this$props.onMore,
        resizeable = _this$props.resizeable,
        size = _this$props.size,
        sortable = _this$props.sortable,
        onSearch = _this$props.onSearch,
        rest = _objectWithoutPropertiesLoose(_this$props, ["columns", "data", "groupBy", "onMore", "resizeable", "size", "sortable", "onSearch"]);

    var _this$state = this.state,
        data = _this$state.data,
        filtering = _this$state.filtering,
        filters = _this$state.filters,
        footerValues = _this$state.footerValues,
        groups = _this$state.groups,
        groupState = _this$state.groupState,
        primaryProperty = _this$state.primaryProperty,
        showFooter = _this$state.showFooter,
        sort = _this$state.sort,
        widths = _this$state.widths;

    if (size && resizeable) {
      console.warn('DataTable cannot combine "size" and "resizeble".');
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StyledDataTable__["a" /* StyledDataTable */], rest, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* Header */], {
      columns: columns,
      filtering: filtering,
      filters: filters,
      groups: groups,
      groupState: groupState,
      size: size,
      sort: sort,
      widths: widths,
      onFiltering: this.onFiltering,
      onFilter: this.onFilter,
      onResize: resizeable ? this.onResize : undefined,
      onSort: sortable ? this.onSort : undefined,
      onToggle: this.onToggleGroups
    }), groups ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__GroupedBody__["a" /* GroupedBody */], {
      columns: columns,
      groupBy: groupBy,
      groups: groups,
      groupState: groupState,
      primaryProperty: primaryProperty,
      onToggle: this.onToggleGroup
    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Body__["a" /* Body */], {
      columns: columns,
      data: data,
      onMore: onMore,
      primaryProperty: primaryProperty,
      size: size
    }), showFooter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Footer__["a" /* Footer */], {
      columns: columns,
      footerValues: footerValues,
      groups: groups,
      size: size
    }));
  };

  return DataTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(DataTable, "defaultProps", {
  columns: [],
  data: []
});

var DataTableDoc;

if (false) {
  DataTableDoc = require('./doc').doc(DataTable); // eslint-disable-line global-require
}

var DataTableWrapper = DataTableDoc || DataTable;


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableHeader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TableRow__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableCell__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Resizer__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Searcher__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Sorter__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ExpanderCell__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StyledDataTable__ = __webpack_require__(64);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
















var Header = function Header(_ref) {
  var columns = _ref.columns,
      filtering = _ref.filtering,
      filters = _ref.filters,
      groups = _ref.groups,
      groupState = _ref.groupState,
      onFilter = _ref.onFilter,
      onFiltering = _ref.onFiltering,
      onResize = _ref.onResize,
      onSort = _ref.onSort,
      onToggle = _ref.onToggle,
      sort = _ref.sort,
      theme = _ref.theme,
      widths = _ref.widths,
      rest = _objectWithoutPropertiesLoose(_ref, ["columns", "filtering", "filters", "groups", "groupState", "onFilter", "onFiltering", "onResize", "onSort", "onToggle", "sort", "theme", "widths"]);

  var dataTableContextTheme = _extends({}, theme.table.header, theme.dataTable.header); // The tricky part here is that we need to manage the theme styling
  // to make sure that the background, border, and padding are applied
  // at the right places depending on the mix of controls in each header cell.


  var outerThemeProps = function (_ref2) {
    var border = _ref2.border,
        background = _ref2.background;
    return {
      border: border,
      background: background
    };
  }(dataTableContextTheme);

  var border = dataTableContextTheme.border,
      background = dataTableContextTheme.background,
      innerThemeProps = _objectWithoutPropertiesLoose(dataTableContextTheme, ["border", "background"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledDataTable__["d" /* StyledDataTableHeader */], _extends({
    as: __WEBPACK_IMPORTED_MODULE_5__TableHeader__["a" /* TableHeader */]
  }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledDataTable__["e" /* StyledDataTableRow */], {
    as: __WEBPACK_IMPORTED_MODULE_6__TableRow__["a" /* TableRow */]
  }, groups && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ExpanderCell__["a" /* ExpanderCell */], {
    context: "header",
    expanded: Object.keys(groupState).filter(function (k) {
      return !groupState[k].expanded;
    }).length === 0,
    onToggle: onToggle
  }), columns.map(function (_ref3) {
    var property = _ref3.property,
        header = _ref3.header,
        align = _ref3.align,
        search = _ref3.search;
    var content = typeof header === 'string' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Text__["a" /* Text */], null, header) : header;

    if (onSort) {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Sorter__["a" /* Sorter */], {
        align: align,
        fill: !search,
        property: property,
        onSort: onSort,
        sort: sort,
        themeProps: search ? innerThemeProps : dataTableContextTheme
      }, content);
    }

    if (search && filters) {
      if (!onSort) {
        content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], _extends({
          justify: "center",
          align: align
        }, innerThemeProps), content);
      }

      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], _extends({
        fill: true,
        direction: "row",
        justify: "between",
        align: "center"
      }, outerThemeProps), content, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Searcher__["a" /* Searcher */], {
        filtering: filtering,
        filters: filters,
        property: property,
        onFilter: onFilter,
        onFiltering: onFiltering
      }));
    } else if (!onSort) {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], _extends({}, dataTableContextTheme, {
        fill: true,
        justify: "center",
        align: align
      }), content);
    }

    if (onResize) {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Resizer__["a" /* Resizer */], {
        property: property,
        onResize: onResize
      }, content);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TableCell__["a" /* TableCell */], {
      key: property,
      scope: "col",
      plain: true,
      style: widths && widths[property] ? {
        width: widths[property]
      } : undefined
    }, content);
  })));
};

Header.defaultProps = {};
Object.setPrototypeOf(Header.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var HeaderWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(Header);


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableHeaderWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table_TableContext__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table_StyledTable__ = __webpack_require__(50);




var TableHeader = function TableHeader(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Table_TableContext__["a" /* TableContext */].Provider, {
    value: "header"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Table_StyledTable__["f" /* StyledTableHeader */], props));
};

var TableHeaderDoc;

if (false) {
  TableHeaderDoc = require('./doc').doc(TableHeader); // eslint-disable-line global-require
}

var TableHeaderWrapper = TableHeaderDoc || TableHeader;


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableRowWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table_StyledTable__ = __webpack_require__(50);



var TableRow = function TableRow(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Table_StyledTable__["g" /* StyledTableRow */], props);
};

var TableRowDoc;

if (false) {
  TableRowDoc = require('./doc').doc(TableRow); // eslint-disable-line global-require
}

var TableRowWrapper = TableRowDoc || TableRow;


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableCellWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Table_TableContext__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_StyledTable__ = __webpack_require__(50);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }









var TableCell = function TableCell(_ref) {
  var children = _ref.children,
      plain = _ref.plain,
      scope = _ref.scope,
      size = _ref.size,
      theme = _ref.theme,
      verticalAlign = _ref.verticalAlign,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "plain", "scope", "size", "theme", "verticalAlign"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Table_TableContext__["a" /* TableContext */].Consumer, null, function (tableContext) {
    var tableContextTheme;

    if (tableContext === 'header') {
      tableContextTheme = theme.table && theme.table.header;
    } else if (tableContext === 'footer') {
      tableContextTheme = theme.table && theme.table.footer;
    } else {
      tableContextTheme = theme.table && theme.table.body;
    }

    var boxProps = _extends({}, rest);

    Object.keys(boxProps).forEach(function (key) {
      if (tableContextTheme[key] && boxProps[key] === undefined) {
        delete boxProps[key];
      }
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Table_StyledTable__["c" /* StyledTableCell */], _extends({
      as: scope ? 'th' : undefined,
      scope: scope,
      size: size,
      tableContext: tableContext,
      tableContextTheme: tableContextTheme,
      verticalAlign: verticalAlign || (tableContextTheme ? tableContextTheme.verticalAlign : undefined)
    }, plain ? rest : {}), plain ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], _extends({}, tableContextTheme, boxProps), children));
  });
};

TableCell.defaultProps = {};
Object.setPrototypeOf(TableCell.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var TableCellDoc;

if (false) {
  TableCellDoc = require('./doc').doc(TableCell); // eslint-disable-line global-require
}

var TableCellWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(TableCellDoc || TableCell);


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledText__ = __webpack_require__(433);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Text = function Text(_ref) {
  var color = _ref.color,
      tag = _ref.tag,
      as = _ref.as,
      rest = _objectWithoutPropertiesLoose(_ref, ["color", "tag", "as"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StyledText__["a" /* StyledText */], _extends({
    as: !as && tag ? tag : as,
    colorProp: color
  }, rest));
};

Text.defaultProps = {
  level: 1
};
var TextDoc;

if (false) {
  TextDoc = require('./doc').doc(Text); // eslint-disable-line global-require
}

var TextWrapper = TextDoc || Text;


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);




var marginStyle = function marginStyle(props) {
  if (typeof props.margin === 'string') {
    var margin = props.theme.global.edgeSize[props.margin];
    return "\n      margin-top: " + margin + ";\n      margin-bottom: " + margin + ";\n      margin-left: " + margin + ";\n      margin-right: " + margin + ";\n    ";
  }

  if (props.margin.vertical) {
    return "\n      margin-top: " + props.theme.global.edgeSize[props.margin.vertical] + ";\n      margin-bottom: " + props.theme.global.edgeSize[props.margin.vertical] + ";\n    ";
  }

  if (props.margin.horizontal) {
    return "\n      margin-left: " + props.theme.global.edgeSize[props.margin.horizontal] + ";\n      margin-right: " + props.theme.global.edgeSize[props.margin.horizontal] + ";\n    ";
  }

  if (props.margin.top) {
    return "margin-top: " + props.theme.global.edgeSize[props.margin.top] + ";";
  }

  if (props.margin.bottom) {
    return "margin-bottom: " + props.theme.global.edgeSize[props.margin.bottom] + ";";
  }

  if (props.margin.left) {
    return "margin-left: " + props.theme.global.edgeSize[props.margin.left] + ";";
  }

  if (props.margin.right) {
    return "margin-right: " + props.theme.global.edgeSize[props.margin.right] + ";";
  }

  return '';
};

var sizeStyle = function sizeStyle(props) {
  var size = props.size || 'medium';
  var data = props.theme.text[size];

  if (data) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-size:", ";line-height:", ";"], data.size, data.height);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-size:", ";line-height:normal;"], size);
};

var TEXT_ALIGN_MAP = {
  center: 'center',
  end: 'right',
  start: 'left'
};
var textAlignStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["text-align:", ";"], function (props) {
  return TEXT_ALIGN_MAP[props.textAlign];
});
var truncateStyle = "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var colorStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["color:", ";"], function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.colorProp, props.theme);
});
var weightStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-weight:", ";"], function (props) {
  return props.weight;
});
var StyledText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span.withConfig({
  displayName: "StyledText",
  componentId: "sc-1sadyjn-0"
})(["", " ", " ", " ", " ", " ", " ", " ", ""], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return sizeStyle(props);
}, function (props) {
  return props.margin && marginStyle(props);
}, function (props) {
  return props.textAlign && textAlignStyle;
}, function (props) {
  return props.truncate && truncateStyle;
}, function (props) {
  return props.colorProp && colorStyle;
}, function (props) {
  return props.weight && weightStyle;
}, function (props) {
  return props.theme.text && props.theme.text.extend;
});
StyledText.defaultProps = {};
Object.setPrototypeOf(StyledText.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizerWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var ResizerBox = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */]).withConfig({
  displayName: "Resizer__ResizerBox",
  componentId: "sc-8l808w-0"
})(["cursor:col-resize;"]);

var Resizer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Resizer, _Component);

  function Resizer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ref", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseDown", function (event) {
      if (_this.ref.current) {
        var element = _this.ref.current;
        var rect = element.getBoundingClientRect();

        _this.setState({
          start: event.clientX,
          width: rect.width
        }, function () {
          document.addEventListener('mousemove', _this.onMouseMove);
          document.addEventListener('mouseup', _this.onMouseUp);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseMove", function (event) {
      var _this$props = _this.props,
          onResize = _this$props.onResize,
          property = _this$props.property;
      var _this$state = _this.state,
          start = _this$state.start,
          width = _this$state.width; // We determined 12 empirically as being wide enough to hit but
      // not too wide to cause false hits.

      var nextWidth = Math.max(12, width + (event.clientX - start));
      onResize(property)(nextWidth);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseUp", function () {
      document.removeEventListener('mouseup', _this.onMouseUp);
      document.removeEventListener('mousemove', _this.onMouseMove);

      _this.setState({
        start: undefined,
        width: undefined
      });
    });

    return _this;
  }

  var _proto = Resizer.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        onResize = _this$props2.onResize,
        theme = _this$props2.theme;
    var start = this.state.start;

    if (onResize) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
        ref: this.ref,
        direction: "row",
        fill: true
      }, children, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResizerBox, _extends({
        flex: false
      }, theme.dataTable.resize, {
        onMouseDown: this.onMouseDown,
        onMouseMove: start ? this.onMouseMove : undefined,
        onMouseUp: start ? this.onMouseUp : undefined
      })));
    }

    return children;
  };

  return Resizer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Resizer.defaultProps = {};
Object.setPrototypeOf(Resizer.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var ResizerWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(Resizer);


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearcherWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons_es6_icons_FormSearch__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Keyboard__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TextInput__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(5);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var Searcher =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Searcher, _Component);

  function Searcher() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef());

    return _this;
  }

  var _proto = Searcher.prototype;

  _proto.componentDidMount = function componentDidMount() {
    /* eslint-disable-next-line react/prop-types */
    var _this$props = this.props,
        filtering = _this$props.filtering,
        property = _this$props.property;

    if (this.inputRef.current && filtering === property) {
      this.inputRef.current.focus();
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        filtering = _this$props2.filtering,
        filters = _this$props2.filters,
        onFilter = _this$props2.onFilter,
        onFiltering = _this$props2.onFiltering,
        property = _this$props2.property,
        theme = _this$props2.theme;

    if (filtering === property) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Keyboard__["a" /* Keyboard */], {
        onEsc: function onEsc() {
          return onFiltering(undefined);
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
        flex: true,
        pad: {
          horizontal: 'small'
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TextInput__["a" /* TextInput */], {
        ref: this.inputRef,
        value: filters[property],
        onChange: function onChange(event) {
          return onFilter(property, event.target.value);
        },
        onBlur: function onBlur() {
          return onFiltering(undefined);
        }
      })));
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, filters[property] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      flex: false,
      pad: {
        horizontal: 'small'
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Text__["a" /* Text */], null, filters[property])) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* Button */], {
      icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_icons_es6_icons_FormSearch__["a" /* FormSearch */], {
        color: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["B" /* normalizeColor */])(filtering === property ? 'brand' : 'border', theme)
      }),
      hoverIndicator: true,
      onClick: function onClick() {
        return onFiltering(filtering === property ? undefined : property);
      }
    }));
  };

  return Searcher;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Searcher.defaultProps = {};
Object.setPrototypeOf(Searcher.defaultProps, __WEBPACK_IMPORTED_MODULE_4__default_props__["a" /* defaultProps */]);
var SearcherWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(Searcher);


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormSearch = function FormSearch(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormSearch' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M13.8,13.8 L18,18 L13.8,13.8 Z M10.5,15 C12.9852814,15 15,12.9852814 15,10.5 C15,8.01471863 12.9852814,6 10.5,6 C8.01471863,6 6,8.01471863 6,10.5 C6,12.9852814 8.01471863,15 10.5,15 Z' })
  );
};

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextInputWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Drop__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InfiniteScroll__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Keyboard__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StyledTextInput__ = __webpack_require__(442);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













function renderLabel(suggestion) {
  if (suggestion && typeof suggestion === 'object') {
    return suggestion.label || suggestion.value;
  }

  return suggestion;
}

function stringLabel(suggestion) {
  if (suggestion && typeof suggestion === 'object') {
    if (suggestion.label && typeof suggestion.label === 'string') {
      return suggestion.label;
    }

    return suggestion.value;
  }

  return suggestion;
}

var ContainerBox = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */]).withConfig({
  displayName: "TextInput__ContainerBox",
  componentId: "sc-1ai0c08-0"
})(["max-height:inherit;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}"]);

var TextInput =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TextInput, _Component);

  function TextInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      activeSuggestionIndex: -1,
      showDrop: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announce", function (message, mode) {
      var _this$props = _this.props,
          announce = _this$props.announce,
          suggestions = _this$props.suggestions;

      if (suggestions && suggestions.length > 0) {
        announce(message, mode);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceSuggestionsCount", function () {
      var _this$props2 = _this.props,
          suggestions = _this$props2.suggestions,
          suggestionsCount = _this$props2.messages.suggestionsCount;

      _this.announce(suggestions.length + " " + suggestionsCount);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceSuggestionsExist", function () {
      var suggestionsExist = _this.props.messages.suggestionsExist;

      _this.announce(suggestionsExist);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceSuggestionsIsOpen", function () {
      var suggestionIsOpen = _this.props.messages.suggestionIsOpen;

      _this.announce(suggestionIsOpen);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceSuggestion", function (index) {
      var _this$props3 = _this.props,
          suggestions = _this$props3.suggestions,
          enterSelect = _this$props3.messages.enterSelect;

      if (suggestions && suggestions.length > 0) {
        var labelMessage = stringLabel(suggestions[index]);

        _this.announce(labelMessage + " " + enterSelect);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resetSuggestions", function () {
      // delay this to avoid re-render interupting event delivery
      // https://github.com/grommet/grommet/issues/2154
      // 10ms was chosen empirically based on ie11 using TextInput
      // with and without a FormField.
      clearTimeout(_this.resetTimer);
      _this.resetTimer = setTimeout(function () {
        var suggestions = _this.props.suggestions;

        if (suggestions && suggestions.length) {
          _this.setState({
            activeSuggestionIndex: -1,
            showDrop: true,
            selectedSuggestionIndex: -1
          }, _this.announceSuggestionsCount);
        }
      }, 10);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getSelectedSuggestionIndex", function () {
      var _this$props4 = _this.props,
          suggestions = _this$props4.suggestions,
          value = _this$props4.value;
      var suggestionValues = suggestions.map(function (suggestion) {
        if (typeof suggestion === 'object') {
          return suggestion.value;
        }

        return suggestion;
      });
      return suggestionValues.indexOf(value);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onShowSuggestions", function () {
      // Get values of suggestions, so we can highlight selected suggestion
      var selectedSuggestionIndex = _this.getSelectedSuggestionIndex();

      _this.setState({
        showDrop: true,
        activeSuggestionIndex: -1,
        selectedSuggestionIndex: selectedSuggestionIndex
      }, _this.announceSuggestionsIsOpen);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onNextSuggestion", function (event) {
      var suggestions = _this.props.suggestions;
      var _this$state = _this.state,
          activeSuggestionIndex = _this$state.activeSuggestionIndex,
          showDrop = _this$state.showDrop;

      if (suggestions && suggestions.length > 0) {
        if (!showDrop) {
          _this.onShowSuggestions();
        } else {
          event.preventDefault();
          var index = Math.min(activeSuggestionIndex + 1, suggestions.length - 1);

          _this.setState({
            activeSuggestionIndex: index
          }, function () {
            return _this.announceSuggestion(index);
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onPreviousSuggestion", function (event) {
      var suggestions = _this.props.suggestions;
      var _this$state2 = _this.state,
          activeSuggestionIndex = _this$state2.activeSuggestionIndex,
          showDrop = _this$state2.showDrop;

      if (suggestions && suggestions.length > 0 && showDrop) {
        event.preventDefault();
        var index = Math.max(activeSuggestionIndex - 1, 0);

        _this.setState({
          activeSuggestionIndex: index
        }, function () {
          return _this.announceSuggestion(index);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClickSuggestion", function (suggestion) {
      var _this$props5 = _this.props,
          forwardRef = _this$props5.forwardRef,
          onSelect = _this$props5.onSelect;

      _this.setState({
        showDrop: false
      });

      if (onSelect) {
        onSelect({
          target: (forwardRef || _this.inputRef).current,
          suggestion: suggestion
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSuggestionSelect", function (event) {
      var _this$props6 = _this.props,
          forwardRef = _this$props6.forwardRef,
          onSelect = _this$props6.onSelect,
          suggestions = _this$props6.suggestions;
      var activeSuggestionIndex = _this.state.activeSuggestionIndex;

      _this.setState({
        showDrop: false
      });

      if (activeSuggestionIndex >= 0) {
        event.preventDefault(); // prevent submitting forms

        var suggestion = suggestions[activeSuggestionIndex];

        if (onSelect) {
          onSelect({
            target: (forwardRef || _this.inputRef).current,
            suggestion: suggestion
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFocus", function (event) {
      var _this$props7 = _this.props,
          onFocus = _this$props7.onFocus,
          suggestions = _this$props7.suggestions;

      if (suggestions && suggestions.length > 0) {
        _this.announceSuggestionsExist();
      }

      _this.resetSuggestions();

      if (onFocus) {
        onFocus(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onBlur", function (event) {
      var onBlur = _this.props.onBlur;
      clearTimeout(_this.resetTimer);

      if (onBlur) {
        onBlur(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (event) {
      var onChange = _this.props.onChange;

      _this.resetSuggestions();

      if (onChange) {
        onChange(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onEsc", function (event) {
      // we have to stop both synthetic events and native events
      // drop and layer should not close by pressing esc on this input
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();

      _this.setState({
        showDrop: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTab", function () {
      _this.setState({
        showDrop: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderSuggestions", function () {
      var _this$props8 = _this.props,
          suggestions = _this$props8.suggestions,
          theme = _this$props8.theme;
      var _this$state3 = _this.state,
          activeSuggestionIndex = _this$state3.activeSuggestionIndex,
          selectedSuggestionIndex = _this$state3.selectedSuggestionIndex;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__StyledTextInput__["b" /* StyledSuggestions */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InfiniteScroll__["a" /* InfiniteScroll */], {
        items: suggestions,
        step: theme.select.step
      }, function (suggestion, index) {
        var plain = typeof suggestion === 'object' && typeof Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(suggestion.label);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          key: stringLabel(suggestion) + "-" + index
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* Button */], {
          active: activeSuggestionIndex === index || selectedSuggestionIndex === index,
          fill: true,
          hoverIndicator: "background",
          onClick: function onClick() {
            return _this.onClickSuggestion(suggestion);
          }
        }, plain ? renderLabel(suggestion) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
          align: "start",
          pad: "small"
        }, renderLabel(suggestion))));
      }));
    });

    return _this;
  }

  TextInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var suggestions = nextProps.suggestions;
    var showDrop = prevState.showDrop;

    if (showDrop && (!suggestions || !suggestions.length)) {
      return {
        showDrop: false
      };
    }

    return null;
  };

  var _proto = TextInput.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$props9 = this.props,
        onSuggestionsOpen = _this$props9.onSuggestionsOpen,
        onSuggestionsClose = _this$props9.onSuggestionsClose,
        suggestions = _this$props9.suggestions;
    var showDrop = this.state.showDrop;

    if (showDrop !== prevState.showDrop) {
      if (showDrop && onSuggestionsOpen) {
        onSuggestionsOpen();
      } else if (onSuggestionsClose) {
        onSuggestionsClose();
      }
    }

    if (!showDrop && suggestions && (!prevProps.suggestions || !prevProps.suggestions.length)) {
      this.resetSuggestions();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.resetTimer);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props10 = this.props,
        defaultValue = _this$props10.defaultValue,
        dropAlign = _this$props10.dropAlign,
        dropTarget = _this$props10.dropTarget,
        forwardRef = _this$props10.forwardRef,
        id = _this$props10.id,
        placeholder = _this$props10.placeholder,
        plain = _this$props10.plain,
        theme = _this$props10.theme,
        value = _this$props10.value,
        onKeyDown = _this$props10.onKeyDown,
        rest = _objectWithoutPropertiesLoose(_this$props10, ["defaultValue", "dropAlign", "dropTarget", "forwardRef", "id", "placeholder", "plain", "theme", "value", "onKeyDown"]);

    delete rest.onChange; // se we can manage in this.onChange()

    delete rest.onSuggestionsOpen;
    delete rest.onSuggestionsClose;
    var showDrop = this.state.showDrop; // needed so that styled components does not invoke
    // onSelect when text input is clicked

    delete rest.onSelect;
    var drop;

    if (showDrop) {
      drop = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Drop__["a" /* Drop */], {
        id: id ? "text-input-drop__" + id : undefined,
        align: dropAlign,
        responsive: false,
        target: dropTarget || (forwardRef || this.inputRef).current,
        onClickOutside: function onClickOutside() {
          return _this2.setState({
            showDrop: false
          });
        },
        onEsc: function onEsc() {
          return _this2.setState({
            showDrop: false
          });
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContainerBox, {
        overflow: "auto"
      }, this.renderSuggestions()));
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__StyledTextInput__["d" /* StyledTextInputContainer */], {
      plain: plain
    }, placeholder && typeof placeholder !== 'string' && !value ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__StyledTextInput__["a" /* StyledPlaceholder */], null, placeholder) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Keyboard__["a" /* Keyboard */], {
      onEnter: this.onSuggestionSelect,
      onEsc: this.onEsc,
      onTab: this.onTab,
      onUp: this.onPreviousSuggestion,
      onDown: this.onNextSuggestion,
      onKeyDown: onKeyDown
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__StyledTextInput__["c" /* StyledTextInput */], _extends({
      id: id,
      ref: forwardRef || this.inputRef,
      autoComplete: "off",
      plain: plain,
      placeholder: typeof placeholder === 'string' ? placeholder : undefined
    }, rest, {
      defaultValue: renderLabel(defaultValue),
      value: renderLabel(value),
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onChange: this.onChange
    }))), drop);
  };

  return TextInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(TextInput, "defaultProps", {
  dropAlign: {
    top: 'bottom',
    left: 'left'
  },
  messages: {
    enterSelect: '(Press Enter to Select)',
    suggestionsCount: 'suggestions available',
    suggestionsExist: 'This input has suggestions use arrow keys to navigate',
    suggestionIsOpen: 'Suggestions drop is open, continue to use arrow keys to navigate'
  }
});

Object.setPrototypeOf(TextInput.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var TextInputDoc;

if (false) {
  TextInputDoc = require('./doc').doc(TextInput); // eslint-disable-line global-require
}

var TextInputWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_9__hocs__["c" /* withFocus */], __WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */], __WEBPACK_IMPORTED_MODULE_9__hocs__["a" /* withAnnounce */], __WEBPACK_IMPORTED_MODULE_9__hocs__["d" /* withForwardRef */])(TextInputDoc || TextInput);


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DropContainer__ = __webpack_require__(439);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Drop =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Drop, _Component);

  function Drop() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "originalFocusedElement", document.activeElement);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dropContainer", Object(__WEBPACK_IMPORTED_MODULE_2__utils__["u" /* getNewContainer */])());

    return _this;
  }

  var _proto = Drop.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    var restrictFocus = this.props.restrictFocus;

    if (restrictFocus && this.originalFocusedElement) {
      if (this.originalFocusedElement.focus) {
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["H" /* setFocusWithoutScroll */])(this.originalFocusedElement);
      } else if (this.originalFocusedElement.parentNode && this.originalFocusedElement.parentNode.focus) {
        // required for IE11 and Edge
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["H" /* setFocusWithoutScroll */])(this.originalFocusedElement.parentNode);
      }
    }

    document.body.removeChild(this.dropContainer);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        dropTarget = _this$props.target,
        rest = _objectWithoutPropertiesLoose(_this$props, ["target"]);

    return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DropContainer__["a" /* DropContainer */], _extends({
      dropTarget: dropTarget
    }, rest)), this.dropContainer);
  };

  return Drop;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Drop, "defaultProps", {
  align: {
    top: 'top',
    left: 'left'
  },
  plain: false
});

var DropDoc;

if (false) {
  DropDoc = require('./doc').doc(Drop); // eslint-disable-line global-require
}

var DropWrapper = DropDoc || Drop;


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contexts__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FocusedContainer__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Keyboard__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StyledDrop__ = __webpack_require__(440);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








 // using react synthetic event to be able to stop propagation that
// would otherwise close the layer on ESC.

var preventLayerClose = function preventLayerClose(event) {
  var key = event.keyCode ? event.keyCode : event.which;

  if (key === 27) {
    event.stopPropagation();
  }
};

var DropContainer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(DropContainer, _Component);

  function DropContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dropRef", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "addScrollListener", function () {
      var dropTarget = _this.props.dropTarget;
      _this.scrollParents = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["n" /* findScrollParents */])(dropTarget);

      _this.scrollParents.forEach(function (scrollParent) {
        return scrollParent.addEventListener('scroll', _this.place);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeScrollListener", function () {
      _this.scrollParents.forEach(function (scrollParent) {
        return scrollParent.removeEventListener('scroll', _this.place);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClickDocument", function (event) {
      var _this$props = _this.props,
          dropTarget = _this$props.dropTarget,
          onClickOutside = _this$props.onClickOutside;
      var dropTargetNode = dropTarget;
      var dropNode = _this.dropRef.current;

      if (onClickOutside && dropNode && // need this for ie11
      !dropTargetNode.contains(event.target) && !dropNode.contains(event.target)) {
        onClickOutside();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onResize", function () {
      _this.removeScrollListener();

      _this.addScrollListener();

      _this.place(false);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "place", function (preserveHeight) {
      var _this$props2 = _this.props,
          align = _this$props2.align,
          dropTarget = _this$props2.dropTarget,
          responsive = _this$props2.responsive,
          stretch = _this$props2.stretch,
          theme = _this$props2.theme;
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var target = dropTarget;
      var container = _this.dropRef.current;

      if (container && target) {
        // clear prior styling
        container.style.left = '';
        container.style.top = '';
        container.style.bottom = '';
        container.style.width = '';

        if (!preserveHeight) {
          container.style.maxHeight = '';
        } // get bounds


        var targetRect = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["o" /* findVisibleParent */])(target).getBoundingClientRect();
        var containerRect = container.getBoundingClientRect(); // determine width

        var width = Math.min(stretch ? Math.max(targetRect.width, containerRect.width) : containerRect.width, windowWidth); // set left position

        var left;

        if (align.left) {
          if (align.left === 'left') {
            left = targetRect.left;
          } else if (align.left === 'right') {
            left = targetRect.left + targetRect.width;
          }
        } else if (align.right) {
          if (align.right === 'left') {
            left = targetRect.left - width;
          } else if (align.right === 'right') {
            left = targetRect.left + targetRect.width - width;
          }
        } else {
          left = targetRect.left + targetRect.width / 2 - width / 2;
        }

        if (left + width > windowWidth) {
          left -= left + width - windowWidth;
        } else if (left < 0) {
          left = 0;
        } // set top or bottom position


        var top;
        var bottom;
        var maxHeight = containerRect.height;

        if (align.top) {
          if (align.top === 'top') {
            top = targetRect.top;
          } else {
            top = targetRect.bottom;
          }

          maxHeight = windowHeight - top;
        } else if (align.bottom) {
          if (align.bottom === 'bottom') {
            bottom = targetRect.bottom;
          } else {
            bottom = targetRect.top;
          }

          maxHeight = bottom;
        } else {
          // center
          top = targetRect.top + targetRect.height / 2 - containerRect.height / 2;
          maxHeight = windowHeight - top;
        } // if we can't fit it all, or we're rather close,
        // see if there's more room the other direction


        if (responsive && (containerRect.height > maxHeight || maxHeight < windowHeight / 10)) {
          // We need more room than we have.
          if (align.top && top > windowHeight / 2) {
            // We put it below, but there's more room above, put it above
            top = '';

            if (align.top === 'bottom') {
              // top = Math.max(targetRect.top - containerRect.height, 0);
              // maxHeight = targetRect.top - top;
              bottom = targetRect.top;
            } else {
              // top = Math.max(targetRect.bottom - containerRect.height, 0);
              // maxHeight = targetRect.bottom - top;
              bottom = targetRect.bottom;
            }

            maxHeight = bottom;
          } else if (align.bottom && maxHeight < windowHeight / 2) {
            // We put it above but there's more room below, put it below
            bottom = '';

            if (align.bottom === 'bottom') {
              top = targetRect.top;
            } else {
              top = targetRect.bottom;
            }

            maxHeight = windowHeight - top;
          }
        }

        container.style.left = left + "px";

        if (stretch) {
          // offset width by 0.1 to avoid a bug in ie11 that
          // unnecessarily wraps the text if width is the same
          // NOTE: turned off for now
          container.style.width = width + 0.1 + "px";
        } // the (position:absolute + scrollTop)
        // is presenting issues with desktop scroll flickering


        if (top !== '') {
          container.style.top = top + "px";
        }

        if (bottom !== '') {
          container.style.bottom = windowHeight - bottom + "px";
        }

        if (!preserveHeight) {
          if (theme.drop && theme.drop.maxHeight) {
            maxHeight = Math.min(maxHeight, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["D" /* parseMetricToNum */])(theme.drop.maxHeight));
          }

          container.style.maxHeight = maxHeight + "px";
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onEsc", function (event) {
      var onEsc = _this.props.onEsc;
      event.stopPropagation();

      if (onEsc) {
        onEsc(event);
      }
    });

    return _this;
  }

  var _proto = DropContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var restrictFocus = this.props.restrictFocus;
    this.addScrollListener();
    window.addEventListener('resize', this.onResize);
    document.addEventListener('mousedown', this.onClickDocument);
    this.place(false);

    if (restrictFocus) {
      this.dropRef.current.focus();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.place(true);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeScrollListener();
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('mousedown', this.onClickDocument);
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        alignProp = _this$props3.align,
        children = _this$props3.children,
        onClickOutside = _this$props3.onClickOutside,
        onEsc = _this$props3.onEsc,
        onKeyDown = _this$props3.onKeyDown,
        elevation = _this$props3.elevation,
        plain = _this$props3.plain,
        propsTheme = _this$props3.theme,
        rest = _objectWithoutPropertiesLoose(_this$props3, ["align", "children", "onClickOutside", "onEsc", "onKeyDown", "elevation", "plain", "theme"]);

    var theme = this.context || propsTheme;
    var content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledDrop__["a" /* StyledDrop */], _extends({
      as: __WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */],
      plain: plain,
      elevation: !plain ? elevation || theme.global.drop.shadowSize || 'small' : undefined,
      tabIndex: "-1",
      ref: this.dropRef,
      alignProp: alignProp
    }, rest), children);

    if (theme.global.drop.background) {
      var dark = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* backgroundIsDark */])(theme.global.drop.background, theme);

      if (dark !== theme.dark) {
        content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__contexts__["c" /* ThemeContext */].Provider, {
          value: _extends({}, theme, {
            dark: dark
          })
        }, content);
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FocusedContainer__["a" /* FocusedContainer */], {
      onKeyDown: onEsc && preventLayerClose
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Keyboard__["a" /* Keyboard */], {
      onEsc: onEsc && this.onEsc,
      onKeyDown: onKeyDown,
      target: "document"
    }, content));
  };

  return DropContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(DropContainer, "contextType", __WEBPACK_IMPORTED_MODULE_2__contexts__["c" /* ThemeContext */]);

_defineProperty(DropContainer, "defaultProps", {
  align: {
    top: 'top',
    left: 'left'
  },
  stretch: 'width'
});

Object.setPrototypeOf(DropContainer.defaultProps, __WEBPACK_IMPORTED_MODULE_1__default_props__["a" /* defaultProps */]);


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledDrop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);




function getTransformOriginStyle(align) {
  var vertical = 'top';

  if (align.bottom) {
    vertical = 'bottom';
  }

  var horizontal = 'left';

  if (align.right) {
    horizontal = 'right';
  }

  return vertical + " " + horizontal;
}

var dropKeyFrames = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{opacity:0.5;transform:scale(0.8);}100%{opacity:1;transform:scale(1);}"]);
var StyledDrop = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledDrop",
  componentId: "sc-16s5rx8-0"
})(["", " border-radius:", ";position:fixed;z-index:", ";outline:none;overflow:auto;", " opacity:0;transform-origin:", ";animation:", " 0.1s forwards;animation-delay:0.01s;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){display:flex;align-items:stretch;}", ""], __WEBPACK_IMPORTED_MODULE_1__utils__["e" /* baseStyle */], function (props) {
  return props.theme.global.drop.border.radius;
}, function (props) {
  return props.theme.global.drop.zIndex;
}, function (props) {
  return !props.plain && Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* backgroundStyle */])(props.theme.global.drop.background, props.theme);
}, function (props) {
  return getTransformOriginStyle(props.alignProp);
}, dropKeyFrames, function (props) {
  return props.theme.global.drop && props.theme.global.drop.extend;
});
StyledDrop.defaultProps = {};
Object.setPrototypeOf(StyledDrop.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfiniteScrollWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(9);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var InfiniteScroll =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(InfiniteScroll, _PureComponent);

  function InfiniteScroll() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialScroll", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "aboveMarkerRef", Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "belowMarkerRef", Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "addScrollListener", function () {
      var pageHeight = _this.state.pageHeight;

      if (pageHeight && _this.belowMarkerRef.current && !_this.scrollParents) {
        _this.scrollParents = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* findScrollParents */])(_this.belowMarkerRef.current);

        _this.scrollParents.forEach(function (scrollParent) {
          return scrollParent.addEventListener('scroll', _this.onScroll);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeScrollListener", function () {
      if (_this.scrollParents) {
        _this.scrollParents.forEach(function (scrollParent) {
          return scrollParent.removeEventListener('scroll', _this.place);
        });

        _this.scrollParents = undefined;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollShow", function () {
      var show = _this.props.show;

      if (show && !_this.initialScroll && _this.showRef) {
        _this.initialScroll = true; // on initial render, scroll to any 'show'

        _this.showRef.scrollIntoView();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setPageHeight", function () {
      var pageHeight = _this.state.pageHeight;

      if (_this.firstPageItemRef && _this.lastPageItemRef && !pageHeight) {
        var beginRect = _this.firstPageItemRef.getBoundingClientRect();

        var endRect = _this.lastPageItemRef.getBoundingClientRect();

        var nextPageHeight = endRect.y + endRect.height - beginRect.y; // In case the pageHeight is smaller than the visible area,
        // we call onScroll to set the page boundaries appropriately.

        _this.setState({
          pageHeight: nextPageHeight
        }, _this.onScroll);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onScroll", function () {
      var _this$props = _this.props,
          onMore = _this$props.onMore,
          replace = _this$props.replace;
      var _this$state = _this.state,
          beginPage = _this$state.beginPage,
          endPage = _this$state.endPage,
          lastPage = _this$state.lastPage,
          pageHeight = _this$state.pageHeight;

      if (_this.scrollParents && _this.scrollParents[0] && pageHeight) {
        var scrollParent = _this.scrollParents[0]; // Determine the window into the first scroll parent

        var top;
        var height;

        if (scrollParent === document) {
          top = document.documentElement.scrollTop || document.body.scrollTop;
          height = window.innerHeight;
        } else {
          top = scrollParent.scrollTop;
          var rect = scrollParent.getBoundingClientRect();
          height = rect.height;
        } // Figure out which pages we should make visible based on the scroll
        // window.


        var offset = height / 4;
        var nextBeginPage = replace ? Math.min(lastPage, Math.max(0, Math.floor(Math.max(0, top - offset) / pageHeight))) : 0;
        var nextEndPage = Math.min(lastPage, Math.max(!replace && endPage || 0, Math.floor((top + height + offset) / pageHeight)));

        if (nextBeginPage !== beginPage || nextEndPage !== endPage) {
          _this.setState({
            beginPage: nextBeginPage,
            endPage: nextEndPage
          }, function () {
            if (onMore && nextEndPage === lastPage) {
              onMore();
            }
          });
        }
      }
    });

    return _this;
  }

  InfiniteScroll.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var items = nextProps.items,
        show = nextProps.show,
        step = nextProps.step;
    var lastPage = Math.ceil(items.length / step) - 1;

    if (prevState.beginPage === undefined || show && show >= step * (prevState.lastPage + 1) || lastPage !== prevState.lastPage) {
      var endPage = prevState.endPage || 0;

      if (show && show >= step * (endPage + 1)) {
        endPage = Math.floor((show + step) / step) - 1;
      }

      return {
        beginPage: 0,
        endPage: endPage,
        lastPage: lastPage,
        pageHeight: undefined
      };
    }

    return null;
  };

  var _proto = InfiniteScroll.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // ride out any animation, 100ms was chosen empirically
    clearTimeout(this.animationDelayTimer);
    this.animationDelayTimer = setTimeout(function () {
      _this2.setPageHeight();

      _this2.addScrollListener();

      _this2.scrollShow();
    }, 100);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.setPageHeight();
    this.removeScrollListener();
    this.addScrollListener();
    this.scrollShow();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeScrollListener();
    clearTimeout(this.animationDelayTimer);
    clearTimeout(this.scrollTimer);
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        items = _this$props2.items,
        onMore = _this$props2.onMore,
        renderMarker = _this$props2.renderMarker,
        replace = _this$props2.replace,
        show = _this$props2.show,
        step = _this$props2.step;
    var _this$state2 = this.state,
        beginPage = _this$state2.beginPage,
        endPage = _this$state2.endPage,
        lastPage = _this$state2.lastPage,
        pageHeight = _this$state2.pageHeight;
    var firstIndex = beginPage * step;
    var lastIndex = (endPage + 1) * step - 1;
    var result = [];

    if (replace && pageHeight && firstIndex) {
      var marker = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Box__["a" /* Box */], {
        key: "above",
        ref: this.aboveMarkerRef,
        flex: false,
        height: beginPage * pageHeight + "px"
      });

      if (renderMarker) {
        // need to give it a key
        marker = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(renderMarker(marker), {
          key: 'above'
        });
      }

      result.push(marker);
    }

    items.slice(firstIndex, lastIndex + 1).forEach(function (item, index) {
      var itemsIndex = firstIndex + index;
      var child = children(item, itemsIndex);

      if (!pageHeight && itemsIndex === 0) {
        var _child = child,
            _ref = _child.ref;
        child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          ref: function ref(node) {
            _this3.firstPageItemRef = node;

            if (typeof _ref === 'function') {
              _ref(node);
            }
          }
        });
      } else if (!pageHeight && itemsIndex === step - 1) {
        var _child2 = child,
            _ref2 = _child2.ref;
        child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          ref: function ref(node) {
            _this3.lastPageItemRef = node;

            if (typeof _ref2 === 'function') {
              _ref2(node);
            }
          }
        });
      }

      if (show && show === itemsIndex) {
        var _child3 = child,
            _ref3 = _child3.ref;
        child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          key: 'show',
          ref: function ref(node) {
            _this3.showRef = node;

            if (typeof _ref3 === 'function') {
              _ref3(node);
            }
          }
        });
      }

      result.push(child);
    });

    if (endPage < lastPage || replace || onMore) {
      var _marker = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Box__["a" /* Box */], {
        key: "below",
        ref: this.belowMarkerRef,
        flex: false,
        height: (replace ? (lastPage - endPage) * pageHeight : 0) + "px"
      });

      if (renderMarker) {
        // need to give it a key
        _marker = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(renderMarker(_marker), {
          key: 'below'
        });
      }

      result.push(_marker);
    }

    return result;
  };

  return InfiniteScroll;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

_defineProperty(InfiniteScroll, "defaultProps", {
  items: [],
  step: 50
});

var InfiniteScrollDoc;

if (false) {
  InfiniteScrollDoc = require('./doc').doc(InfiniteScroll); // eslint-disable-line global-require
}

var InfiniteScrollWrapper = InfiniteScrollDoc || InfiniteScroll;


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledTextInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StyledTextInputContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledPlaceholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledSuggestions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);




var sizeStyle = function sizeStyle(props) {
  var data = props.theme.text[props.size];
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-size:", ";line-height:", ";"], data.size, data.height);
};

var plainStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border:none;"]);
var StyledTextInput = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].input.withConfig({
  displayName: "StyledTextInput",
  componentId: "sc-1x30a0s-0"
})(["", " width:100%;", " ", " ", " &::-moz-focus-inner{border:none;outline:none;}", ";", ";"], __WEBPACK_IMPORTED_MODULE_1__utils__["v" /* inputStyle */], function (props) {
  return props.size && sizeStyle(props);
}, function (props) {
  return props.plain && plainStyle;
}, __WEBPACK_IMPORTED_MODULE_1__utils__["E" /* placeholderStyle */], function (props) {
  return props.focus && !props.plain && __WEBPACK_IMPORTED_MODULE_1__utils__["p" /* focusStyle */];
}, function (props) {
  return props.theme.textInput && props.theme.textInput.extend;
});
StyledTextInput.defaultProps = {};
Object.setPrototypeOf(StyledTextInput.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledTextInputContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledTextInput__StyledTextInputContainer",
  componentId: "sc-1x30a0s-1"
})(["position:relative;width:100%;"]);
StyledTextInputContainer.defaultProps = {};
Object.setPrototypeOf(StyledTextInputContainer.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledPlaceholder = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledTextInput__StyledPlaceholder",
  componentId: "sc-1x30a0s-2"
})(["position:absolute;left:", "px;top:50%;transform:translateY(-50%);display:flex;justify-content:center;"], function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["D" /* parseMetricToNum */])(props.theme.global.input.padding) - Object(__WEBPACK_IMPORTED_MODULE_1__utils__["D" /* parseMetricToNum */])(props.theme.global.control.border.width);
});
StyledPlaceholder.defaultProps = {};
Object.setPrototypeOf(StyledPlaceholder.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledSuggestions = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].ol.withConfig({
  displayName: "StyledTextInput__StyledSuggestions",
  componentId: "sc-1x30a0s-3"
})(["border-top-left-radius:0;border-top-right-radius:0;margin:0;padding:0;list-style-type:none;"]);
StyledSuggestions.defaultProps = {};
Object.setPrototypeOf(StyledSuggestions.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SorterWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box__ = __webpack_require__(9);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }







var SorterButton = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Button__["a" /* Button */]).withConfig({
  displayName: "Sorter__SorterButton",
  componentId: "fzr2yb-0"
})(["flex-shrink:1;height:100%;"]);

var Sorter = function Sorter(_ref) {
  var align = _ref.align,
      children = _ref.children,
      fill = _ref.fill,
      onSort = _ref.onSort,
      property = _ref.property,
      sort = _ref.sort,
      theme = _ref.theme,
      themeProps = _ref.themeProps;
  var icon;

  if (sort && sort.property === property) {
    var Icon = theme.dataTable.icons[sort.ascending ? 'ascending' : 'descending'];
    icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, null);
  }

  var content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], _extends({}, themeProps, {
    flex: "shrink",
    direction: "row",
    justify: align,
    align: "center",
    gap: "xsmall",
    fill: fill
  }), children, icon);

  if (onSort) {
    content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SorterButton, {
      fill: fill,
      hoverIndicator: true,
      onClick: onSort(property)
    }, content);
  }

  return content;
};

Sorter.defaultProps = {};
Object.setPrototypeOf(Sorter.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var SorterWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(Sorter);


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FooterWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableRow__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TableFooter__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableCell__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Cell__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StyledDataTable__ = __webpack_require__(64);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }












var Footer = function Footer(_ref) {
  var columns = _ref.columns,
      footerValues = _ref.footerValues,
      groups = _ref.groups,
      theme = _ref.theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["columns", "footerValues", "groups", "theme"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__StyledDataTable__["c" /* StyledDataTableFooter */], _extends({
    as: __WEBPACK_IMPORTED_MODULE_6__TableFooter__["a" /* TableFooter */]
  }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TableRow__["a" /* TableRow */], null, groups && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TableCell__["a" /* TableCell */], {
    size: "xxsmall",
    plain: true,
    verticalAlign: "top"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], _extends({}, theme.table.footer, theme.dataTable.footer))), columns.map(function (column) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Cell__["a" /* Cell */], {
      key: column.property,
      context: "footer",
      column: column,
      datum: footerValues
    });
  })));
};

Footer.defaultProps = {};
Object.setPrototypeOf(Footer.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var FooterWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(Footer);


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableFooterWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table_TableContext__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table_StyledTable__ = __webpack_require__(50);




var TableFooter = function TableFooter(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Table_TableContext__["a" /* TableContext */].Provider, {
    value: "footer"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Table_StyledTable__["e" /* StyledTableFooter */], props));
};

var TableFooterDoc;

if (false) {
  TableFooterDoc = require('./doc').doc(TableFooter); // eslint-disable-line global-require
}

var TableFooterWrapper = TableFooterDoc || TableFooter;


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Body; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InfiniteScroll__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableRow__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableCell__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Cell__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StyledDataTable__ = __webpack_require__(64);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var Body = function Body(_ref) {
  var columns = _ref.columns,
      data = _ref.data,
      onMore = _ref.onMore,
      primaryProperty = _ref.primaryProperty,
      size = _ref.size,
      theme = _ref.theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["columns", "data", "onMore", "primaryProperty", "size", "theme"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledDataTable__["b" /* StyledDataTableBody */], _extends({
    size: size
  }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__InfiniteScroll__["a" /* InfiniteScroll */], {
    items: data,
    onMore: onMore,
    scrollableAncestor: "window",
    renderMarker: function renderMarker(marker) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TableRow__["a" /* TableRow */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TableCell__["a" /* TableCell */], null, marker));
    }
  }, function (datum) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledDataTable__["e" /* StyledDataTableRow */], {
      key: datum[primaryProperty],
      size: size
    }, columns.map(function (column) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Cell__["a" /* Cell */], {
        key: column.property,
        context: "body",
        column: column,
        datum: datum,
        scope: column.primary ? 'row' : undefined
      });
    }));
  }));
};

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupedBody; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TableCell__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cell__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExpanderCell__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyledDataTable__ = __webpack_require__(64);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var GroupedBody = function GroupedBody(_ref) {
  var columns = _ref.columns,
      groupBy = _ref.groupBy,
      groups = _ref.groups,
      groupState = _ref.groupState,
      primaryProperty = _ref.primaryProperty,
      onToggle = _ref.onToggle,
      size = _ref.size,
      theme = _ref.theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["columns", "groupBy", "groups", "groupState", "primaryProperty", "onToggle", "size", "theme"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StyledDataTable__["b" /* StyledDataTableBody */], _extends({
    size: size
  }, rest), groups.map(function (group) {
    var expanded = groupState[group.key].expanded;
    var content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StyledDataTable__["e" /* StyledDataTableRow */], {
      key: group.key,
      size: size
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ExpanderCell__["a" /* ExpanderCell */], {
      context: expanded ? 'groupHeader' : 'body',
      expanded: expanded,
      onToggle: onToggle(group.key)
    }), columns.map(function (column) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Cell__["a" /* Cell */], {
        key: column.property,
        context: expanded ? 'groupHeader' : 'body',
        column: column,
        datum: group.datum,
        scope: column.property === groupBy ? 'row' : undefined
      });
    }));

    if (expanded) {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], {
        key: group.key
      }, content, group.data.map(function (datum) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StyledDataTable__["e" /* StyledDataTableRow */], {
          key: datum[primaryProperty],
          size: size
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TableCell__["a" /* TableCell */], {
          verticalAlign: "bottom"
        }, groupState[group.key].expanded), columns.map(function (column) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Cell__["a" /* Cell */], {
            key: column.property,
            context: "body",
            column: column,
            datum: datum,
            scope: column.primary ? 'row' : undefined
          });
        }));
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StyledDataTable__["e" /* StyledDataTableRow */], {
        size: size,
        "aria-hidden": true
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TableCell__["a" /* TableCell */], null)));
    }

    return content;
  }));
};

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildState; });
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var sumReducer = function sumReducer(accumulated, next) {
  return accumulated + next;
};

var minReducer = function minReducer(accumulated, next) {
  return accumulated === undefined ? next : Math.min(accumulated, next);
};

var maxReducer = function maxReducer(accumulated, next) {
  return accumulated === undefined ? next : Math.max(accumulated, next);
};

var reducers = {
  max: maxReducer,
  min: minReducer,
  sum: sumReducer
};

var aggregateColumn = function aggregateColumn(column, data) {
  var value;

  if (column.aggregate === 'avg') {
    value = data.map(function (d) {
      return d[column.property];
    }).reduce(sumReducer);
    value /= data.length;
  } else {
    value = data.map(function (d) {
      return d[column.property];
    }).reduce(reducers[column.aggregate], 0);
  }

  return value;
};

var findPrimary = function findPrimary(nextProps, prevState, nextState) {
  var columns = nextProps.columns;
  var primaryProperty;
  columns.forEach(function (column) {
    // remember the first key property
    if (column.primary && !primaryProperty) {
      primaryProperty = column.property;
    }
  });

  if (!primaryProperty && columns.length > 0) {
    primaryProperty = columns[0].property;
  }

  return _extends({}, nextState, {
    primaryProperty: primaryProperty
  });
};

var filter = function filter(nextProps, prevState, nextState) {
  var columns = nextProps.columns,
      onSearch = nextProps.onSearch;
  var data = nextState.data,
      filters = nextState.filters;
  var nextFilters;
  var regexps;
  columns.forEach(function (column) {
    if (column.search) {
      if (!nextFilters) {
        nextFilters = {};
        regexps = {};
      }

      nextFilters[column.property] = filters ? filters[column.property] || '' : ''; // don't do filtering if the caller has supplied onSearch

      if (nextFilters[column.property] && column.search && !onSearch) {
        regexps[column.property] = new RegExp(nextFilters[column.property], 'i');
      }
    }
  });
  var nextData = data;

  if (nextFilters) {
    nextData = data.filter(function (datum) {
      return !Object.keys(regexps).some(function (property) {
        return !regexps[property].test(datum[property]);
      });
    });
  }

  return _extends({}, nextState, {
    filters: nextFilters,
    data: nextData
  });
};

var aggregate = function aggregate(nextProps, prevState, nextState) {
  var columns = nextProps.columns;
  var data = nextState.data;
  var aggregateValues = {};
  columns.forEach(function (column) {
    if (column.aggregate) {
      aggregateValues[column.property] = aggregateColumn(column, data);
    }
  });
  return _extends({}, nextState, {
    aggregateValues: aggregateValues
  });
};

var buildFooterValues = function buildFooterValues(nextProps, prevState, nextState) {
  var columns = nextProps.columns;
  var aggregateValues = nextState.aggregateValues;
  var showFooter;
  var footerValues = {};
  columns.forEach(function (column) {
    if (column.footer) {
      showFooter = true;

      if (typeof column.footer === 'string') {
        footerValues[column.property] = column.footer;
      } else if (column.footer.aggregate) {
        footerValues[column.property] = aggregateValues[column.property];
      }
    }
  });
  return _extends({}, nextState, {
    footerValues: footerValues,
    showFooter: showFooter
  });
};

var sortData = function sortData(nextProps, prevState, nextState) {
  var sort = prevState.sort;
  var data = nextState.data;
  var nextData = data;

  if (sort) {
    var property = sort.property,
        ascending = sort.ascending;
    nextData = data.concat();
    var before = ascending ? 1 : -1;
    var after = ascending ? -1 : 1;
    nextData.sort(function (d1, d2) {
      if (d1[property] > d2[property]) return before;
      if (d1[property] < d2[property]) return after;
      return 0;
    });
  }

  return _extends({}, nextState, {
    data: nextData
  });
};

var groupData = function groupData(nextProps, prevState, nextState) {
  var columns = nextProps.columns,
      groupBy = nextProps.groupBy;
  var data = nextState.data;
  var groups;
  var groupState;

  if (groupBy) {
    groups = [];
    groupState = {};
    var groupMap = {};
    data.forEach(function (datum) {
      var groupValue = datum[groupBy];

      if (!groupMap[groupValue]) {
        var group = {
          data: [],
          datum: {},
          key: groupValue
        };
        group.datum[groupBy] = groupValue;
        groups.push(group);
        groupState[groupValue] = {
          expanded: prevState.groupState && prevState.groupState[groupValue] ? prevState.groupState[groupValue].expanded : false
        };
        groupMap[groupValue] = group;
      }

      groupMap[groupValue].data.push(datum);
    }); // calculate any aggregates

    columns.forEach(function (column) {
      if (column.aggregate) {
        groups.forEach(function (group) {
          group.datum[column.property] = aggregateColumn(column, group.data); // eslint-disable-line
        });
      }
    });
  }

  return _extends({}, nextState, {
    groups: groups,
    groupState: groupState
  });
};

var buildState = function buildState(nextProps, prevState) {
  var data = nextProps.data;
  var filters = prevState.filters,
      sort = prevState.sort,
      widths = prevState.widths;
  var nextState = {
    data: data,
    filters: filters,
    sort: sort,
    widths: widths
  };
  nextState = findPrimary(nextProps, prevState, nextState);
  nextState = filter(nextProps, prevState, nextState);
  nextState = aggregate(nextProps, prevState, nextState);
  nextState = buildFooterValues(nextProps, prevState, nextState);
  nextState = sortData(nextProps, prevState, nextState);
  nextState = groupData(nextProps, prevState, nextState);
  return nextState;
};

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagram__ = __webpack_require__(450);
/* unused harmony reexport Diagram */


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Diagram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StyledDiagram__ = __webpack_require__(451);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var computeMidPoint = function computeMidPoint(fromPoint, toPoint) {
  return [fromPoint[0] > toPoint[0] ? toPoint[0] + (fromPoint[0] - toPoint[0]) / 2 : fromPoint[0] + (toPoint[0] - fromPoint[0]) / 2, fromPoint[1] > toPoint[1] ? toPoint[1] + (fromPoint[1] - toPoint[1]) / 2 : fromPoint[1] + (toPoint[1] - fromPoint[1]) / 2];
};

var COMMANDS = {
  curved: function curved(fromPoint, toPoint, offset, anchor) {
    var midPoint = computeMidPoint(fromPoint, toPoint);
    var cmds = "M " + (fromPoint[0] + offset) + "," + (fromPoint[1] + offset) + " ";

    if (anchor === 'horizontal') {
      cmds += "Q " + (midPoint[0] + offset) + "," + (fromPoint[1] + offset) + " " + (midPoint[0] + offset + "," + (midPoint[1] + offset) + " ");
    } else {
      cmds += "Q " + (fromPoint[0] + offset) + "," + (midPoint[1] + offset) + " " + (midPoint[0] + offset + "," + (midPoint[1] + offset) + " ");
    }

    cmds += "T " + (toPoint[0] + offset) + "," + (toPoint[1] + offset);
    return cmds;
  },
  direct: function direct(fromPoint, toPoint, offset) {
    return "M " + (fromPoint[0] + offset) + "," + (fromPoint[1] + offset) + " " + ("L " + (toPoint[0] + offset) + "," + (toPoint[1] + offset));
  },
  rectilinear: function rectilinear(fromPoint, toPoint, offset, anchor) {
    var midPoint = computeMidPoint(fromPoint, toPoint);
    var cmds = "M " + (fromPoint[0] + offset) + "," + (fromPoint[1] + offset) + " ";

    if (anchor === 'horizontal') {
      cmds += "L " + (midPoint[0] + offset) + "," + (fromPoint[1] + offset) + " " + ("L " + (midPoint[0] + offset) + "," + (toPoint[1] + offset) + " ");
    } else {
      cmds += "L " + (fromPoint[0] + offset) + "," + (midPoint[1] + offset) + " " + ("L " + (toPoint[0] + offset) + "," + (midPoint[1] + offset) + " ");
    }

    cmds += "L " + (toPoint[0] + offset) + "," + (toPoint[1] + offset);
    return cmds;
  }
};

var findTarget = function findTarget(target) {
  if (typeof target === 'string') {
    return document.getElementById(target);
  }

  return target;
};

var Diagram =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Diagram, _Component);

  function Diagram() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      height: 0,
      width: 0
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "svgRef", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onResize", function () {
      var _this$state = _this.state,
          connectionPoints = _this$state.connectionPoints,
          width = _this$state.width,
          height = _this$state.height;
      var svg = _this.svgRef.current;

      if (svg) {
        var rect = svg.getBoundingClientRect();

        if (rect.width !== width || rect.height !== height) {
          _this.setState({
            width: rect.width,
            height: rect.height,
            connectionPoints: undefined
          });
        } else if (!connectionPoints) {
          _this.placeConnections();
        }
      }
    });

    return _this;
  }

  var _proto = Diagram.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.onResize();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  };

  _proto.placeConnections = function placeConnections() {
    var connections = this.props.connections;
    var containerRect = this.svgRef.current.getBoundingClientRect();
    var connectionPoints = connections.map(function (_ref) {
      var anchor = _ref.anchor,
          fromTarget = _ref.fromTarget,
          toTarget = _ref.toTarget;
      var points;
      var fromElement = findTarget(fromTarget);
      var toElement = findTarget(toTarget);

      if (!fromElement) {
        console.warn("Diagram cannot find " + fromTarget);
      }

      if (!toElement) {
        console.warn("Diagram cannot find " + toTarget);
      }

      if (fromElement && toElement) {
        var fromRect = fromElement.getBoundingClientRect();
        var toRect = toElement.getBoundingClientRect(); // There is no x and y when unit testing.

        var fromPoint = [fromRect.x - containerRect.x || 0, fromRect.y - containerRect.y || 0];
        var toPoint = [toRect.x - containerRect.x || 0, toRect.y - containerRect.y || 0];

        if (anchor === 'vertical') {
          fromPoint[0] += fromRect.width / 2;
          toPoint[0] += toRect.width / 2;

          if (fromRect.y < toRect.y) {
            fromPoint[1] += fromRect.height;
          } else {
            toPoint[1] += toRect.height;
          }
        } else if (anchor === 'horizontal') {
          fromPoint[1] += fromRect.height / 2;
          toPoint[1] += toRect.height / 2;

          if (fromRect.x < toRect.x) {
            fromPoint[0] += fromRect.width;
          } else {
            toPoint[0] += toRect.width;
          }
        } else {
          // center
          fromPoint[0] += fromRect.width / 2;
          fromPoint[1] += fromRect.height / 2;
          toPoint[0] += toRect.width / 2;
          toPoint[1] += toRect.height / 2;
        }

        points = [fromPoint, toPoint];
      }

      return points;
    });
    this.setState({
      connectionPoints: connectionPoints
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        connections = _this$props.connections,
        theme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["connections", "theme"]);

    var _this$state2 = this.state,
        connectionPoints = _this$state2.connectionPoints,
        height = _this$state2.height,
        width = _this$state2.width;
    var paths;

    if (connectionPoints) {
      paths = connections.map(function (_ref2, index) {
        var anchor = _ref2.anchor,
            color = _ref2.color,
            offset = _ref2.offset,
            round = _ref2.round,
            thickness = _ref2.thickness,
            type = _ref2.type,
            connectionRest = _objectWithoutPropertiesLoose(_ref2, ["anchor", "color", "offset", "round", "thickness", "type"]);

        var path;

        var cleanedRest = _extends({}, connectionRest);

        delete cleanedRest.fromTarget;
        delete cleanedRest.toTarget;
        var points = connectionPoints[index];

        if (points) {
          var offsetWidth = offset ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["D" /* parseMetricToNum */])(theme.global.edgeSize[offset]) : 0;
          var d = COMMANDS[type || 'curved'](points[0], points[1], offsetWidth, anchor);
          var strokeWidth = thickness ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["D" /* parseMetricToNum */])(theme.global.edgeSize[thickness] || thickness) : 1;
          path = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({
            key: "" + (index + 0)
          }, cleanedRest, {
            stroke: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["B" /* normalizeColor */])(color || 'accent-1', theme),
            strokeWidth: strokeWidth,
            strokeLinecap: round ? 'round' : 'butt',
            strokeLinejoin: round ? 'round' : 'miter',
            fill: "none",
            d: d
          }));
        }

        return path;
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledDiagram__["a" /* StyledDiagram */], _extends({
      ref: this.svgRef,
      viewBox: "0 0 " + width + " " + height,
      preserveAspectRatio: "xMinYMin meet"
    }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null, paths));
  };

  return Diagram;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Diagram, "defaultProps", {
  connections: []
});

Object.setPrototypeOf(Diagram.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var DiagramDoc;

if (false) {
  DiagramDoc = require('./doc').doc(Diagram); // eslint-disable-line global-require
}

var DiagramWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(DiagramDoc || Diagram);


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledDiagram; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_props__ = __webpack_require__(6);


var StyledDiagram = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].svg.withConfig({
  displayName: "StyledDiagram",
  componentId: "sc-1vzeu9f-0"
})(["max-width:100%;width:100%;height:100%;", ";"], function (props) {
  return props.theme.diagram && props.theme.diagram.extend;
});
StyledDiagram.defaultProps = {};
Object.setPrototypeOf(StyledDiagram.defaultProps, __WEBPACK_IMPORTED_MODULE_1__default_props__["a" /* defaultProps */]);


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Distribution__ = __webpack_require__(453);
/* unused harmony reexport Distribution */


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Distribution */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Text__ = __webpack_require__(29);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Value = function Value(_ref) {
  var basis = _ref.basis,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Box__["a" /* Box */], {
    basis: basis,
    flex: "shrink",
    overflow: "hidden"
  }, children);
};

Value.propTypes = {
  basis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired
};

var Distribution =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Distribution, _Component);

  function Distribution() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Distribution.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        basis = _this$props.basis,
        children = _this$props.children,
        direction = _this$props.direction,
        fill = _this$props.fill,
        gap = _this$props.gap,
        values = _this$props.values,
        rest = _objectWithoutPropertiesLoose(_this$props, ["basis", "children", "direction", "fill", "gap", "values"]);

    if (values.length === 1) {
      var value = values[0];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Value, {
        value: value,
        basis: basis
      }, children(value));
    }

    if (values.length > 1) {
      // calculate total
      var total = 0;
      values.forEach(function (v) {
        total += v.value;
      }); // figure out how many of the values area needed to represent half of the total

      var subTotal = 0;
      var subIndex;
      values.some(function (v, index) {
        subTotal += v.value;

        if (subTotal >= total * 0.4) {
          subIndex = index + 1;
          return true;
        }

        return false;
      });

      if (subIndex === values.length) {
        var _value = values[0];
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Value, {
          value: _value,
          basis: basis
        }, children(_value));
      }

      var childBasis;

      if (subTotal > total * 0.7) {
        childBasis = ['3/4', '1/4'];
      } else if (subTotal > total * 0.6) {
        childBasis = ['2/3', '1/3'];
      } else {
        childBasis = ['1/2', '1/2'];
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Box__["a" /* Box */], _extends({
        direction: direction,
        basis: basis,
        flex: basis ? 'shrink' : true,
        overflow: "hidden",
        gap: gap,
        fill: fill
      }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Distribution, {
        values: values.slice(0, subIndex),
        basis: childBasis[0],
        direction: direction === 'row' ? 'column' : 'row',
        gap: gap
      }, children), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Distribution, {
        values: values.slice(subIndex),
        basis: childBasis[1],
        direction: direction === 'row' ? 'column' : 'row',
        gap: gap
      }, children));
    }

    return null;
  };

  return Distribution;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Distribution, "defaultProps", {
  basis: undefined,
  children: function children(value) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Box__["a" /* Box */], {
      fill: true,
      border: true
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Text__["a" /* Text */], null, value.value));
  },
  direction: 'row',
  gap: 'xsmall',
  values: []
});

var DistributionDoc;

if (false) {
  DistributionDoc = require('./doc').doc(Distribution); // eslint-disable-line global-require
}

var DistributionWrapper = DistributionDoc || Distribution;


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropButtonWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Drop__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(5);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var DropButton =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(DropButton, _Component);

  function DropButton(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "buttonRef", Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropClose", function () {
      var onClose = _this.props.onClose;

      _this.setState({
        show: false
      }, function () {
        if (onClose) {
          onClose();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onToggle", function () {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          onOpen = _this$props.onOpen;
      var show = _this.state.show;

      _this.setState({
        show: !show
      }, function () {
        return show ? onClose && onClose() : onOpen && onOpen();
      });
    });

    _this.state = {
      show: props.open || false
    };
    return _this;
  }

  DropButton.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var show = prevState.show;
    var open = nextProps.open;

    if (open !== undefined && open !== show) {
      return {
        show: open
      };
    }

    return null;
  };

  var _proto = DropButton.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var open = this.props.open;

    if (open) {
      this.forceUpdate();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var forwardRef = this.props.forwardRef;
    var show = this.state.show;

    if (!show && prevState.show) {
      // focus on the button if the drop is closed
      Object(__WEBPACK_IMPORTED_MODULE_5__utils__["H" /* setFocusWithoutScroll */])((forwardRef || this.buttonRef).current);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        dropAlign = _this$props2.dropAlign,
        forwardRef = _this$props2.forwardRef,
        dropContent = _this$props2.dropContent,
        dropTarget = _this$props2.dropTarget,
        id = _this$props2.id,
        open = _this$props2.open,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["disabled", "dropAlign", "forwardRef", "dropContent", "dropTarget", "id", "open"]);

    var show = this.state.show;
    delete rest.onClose;
    delete rest.onOpen;
    var drop;

    if (show && (forwardRef || this.buttonRef).current) {
      drop = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Drop__["a" /* Drop */], {
        id: id ? id + "__drop" : undefined,
        restrictFocus: true,
        align: dropAlign,
        target: dropTarget || (forwardRef || this.buttonRef).current,
        onClickOutside: this.onDropClose,
        onEsc: this.onDropClose
      }, dropContent);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* Button */], _extends({
      id: id,
      ref: forwardRef || this.buttonRef,
      disabled: disabled,
      onClick: this.onToggle
    }, rest)), drop);
  };

  return DropButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(DropButton, "defaultProps", {
  a11yTitle: 'Open Drop',
  dropAlign: {
    top: 'top',
    left: 'left'
  }
});

var DropButtonDoc;

if (false) {
  DropButtonDoc = require('./doc').doc(DropButton); // eslint-disable-line global-require
}

var DropButtonWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_4__hocs__["d" /* withForwardRef */])(DropButtonDoc || DropButton);


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormField__ = __webpack_require__(456);
/* unused harmony reexport FormField */


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hocs__ = __webpack_require__(13);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }










var FormField =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(FormField, _Component);

  function FormField() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = FormField.prototype;

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        children = _this$props.children,
        error = _this$props.error,
        focus = _this$props.focus,
        help = _this$props.help,
        htmlFor = _this$props.htmlFor,
        label = _this$props.label,
        style = _this$props.style,
        theme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["children", "error", "focus", "help", "htmlFor", "label", "style", "theme"]);

    var formField = theme.formField;
    var border = formField.border;
    var contents = children;
    var borderColor;

    if (focus) {
      borderColor = 'focus';
    } else if (error) {
      borderColor = border && border.error.color || 'status-critical';
    } else {
      borderColor = border && border.color || 'border';
    }

    var abut;
    var outerStyle = style;

    if (border) {
      var normalizedChildren = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
        if (child) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
            plain: true,
            focusIndicator: false
          });
        }

        return child;
      });
      contents = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
        ref: function ref(_ref) {
          _this.childContainerRef = _ref;
        },
        border: border.position === 'inner' ? _extends({}, border, {
          side: border.side || 'bottom',
          color: borderColor
        }) : undefined
      }, normalizedChildren);
      abut = border.position === 'outer' && (border.side === 'all' || border.side === 'horizontal' || !border.side);

      if (abut) {
        // marginBottom is set to overlap adjacent fields
        var marginBottom = '-1px';

        if (border.size) {
          marginBottom = "-" + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["D" /* parseMetricToNum */])(theme.global.borderSize[border.size]) + "px";
        }

        outerStyle = _extends({
          position: focus ? 'relative' : undefined,
          marginBottom: marginBottom,
          zIndex: focus ? 10 : undefined
        }, style);
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], _extends({
      border: border && border.position === 'outer' ? _extends({}, border, {
        color: borderColor
      }) : undefined,
      margin: abut ? undefined : {
        bottom: 'small'
      },
      style: outerStyle
    }, rest), label || help ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      margin: {
        vertical: 'xsmall',
        horizontal: 'small'
      },
      gap: "xsmall"
    }, label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Text__["a" /* Text */], _extends({
      as: "label",
      htmlFor: htmlFor
    }, formField.label), label) : undefined, help ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Text__["a" /* Text */], _extends({}, formField.help, {
      color: formField.help.color[theme.dark ? 'dark' : 'light']
    }), help) : undefined) : undefined, contents, error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      margin: {
        vertical: 'xsmall',
        horizontal: 'small'
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Text__["a" /* Text */], _extends({}, formField.error, {
      color: formField.error.color[theme.dark ? 'dark' : 'light']
    }), error)) : undefined);
  };

  return FormField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormField.defaultProps = {};
Object.setPrototypeOf(FormField.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var FormFieldDoc;

if (false) {
  FormFieldDoc = require('./doc').doc(FormField); // eslint-disable-line global-require
}

var FormFieldWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_7__hocs__["c" /* withFocus */], __WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(FormFieldDoc || FormField);


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(458);
/* unused harmony reexport Grid */


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledGrid__ = __webpack_require__(459);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Grid = function Grid(props) {
  var fill = props.fill,
      rows = props.rows,
      tag = props.tag,
      as = props.as,
      rest = _objectWithoutPropertiesLoose(props, ["fill", "rows", "tag", "as"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StyledGrid__["a" /* StyledGrid */], _extends({
    as: !as && tag ? tag : as,
    fillContainer: fill,
    rowsProp: rows
  }, rest));
};

var GridDoc;

if (false) {
  GridDoc = require('./doc').doc(Grid); // eslint-disable-line global-require
}

var GridWrapper = GridDoc || Grid;
GridWrapper.available = typeof window !== 'undefined' && window.CSS && window.CSS.supports && window.CSS.supports('display', 'grid');


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);




var fillStyle = function fillStyle(fill) {
  if (fill === 'horizontal') {
    return 'width: 100%;';
  }

  if (fill === 'vertical') {
    return 'height: 100%;';
  }

  if (fill) {
    return "\n      width: 100%;\n      height: 100%;\n    ";
  }

  return undefined;
};

var ALIGN_MAP = {
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
var alignStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["align-items:", ";"], function (props) {
  return ALIGN_MAP[props.align];
});
var ALIGN_CONTENT_MAP = {
  around: 'space-around',
  between: 'space-between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
var alignContentStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["align-content:", ";"], function (props) {
  return ALIGN_CONTENT_MAP[props.alignContent];
});
var JUSTIFY_MAP = {
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
var justifyStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["justify-items:", ";"], function (props) {
  return JUSTIFY_MAP[props.justify];
});
var JUSTIFY_CONTENT_MAP = {
  around: 'space-around',
  between: 'space-between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
var justifyContentStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["justify-content:", ";"], function (props) {
  return JUSTIFY_CONTENT_MAP[props.justifyContent];
});

var gapStyle = function gapStyle(props) {
  if (typeof props.gap === 'string') {
    var gapSize = props.theme.global.edgeSize[props.gap];
    return "grid-gap: " + gapSize + " " + gapSize + ";";
  }

  if (props.gap.row && props.gap.column) {
    return "\n      grid-row-gap: " + props.theme.global.edgeSize[props.gap.row] + ";\n      grid-column-gap: " + props.theme.global.edgeSize[props.gap.column] + ";\n    ";
  }

  if (props.gap.row) {
    return "\n      grid-row-gap: " + props.theme.global.edgeSize[props.gap.row] + ";\n    ";
  }

  if (props.gap.column) {
    return "\n      grid-column-gap: " + props.theme.global.edgeSize[props.gap.column] + ";\n    ";
  }

  return '';
};

var SIZE_MAP = {
  flex: '1fr',
  full: '100%',
  '1/2': '50%',
  '1/4': '25%',
  '2/4': '50%',
  '3/4': '75%',
  '1/3': '33.33%',
  '2/3': '66.66%'
};

var getRepeatCount = function getRepeatCount(count) {
  return typeof count === 'number' ? count : "auto-" + count;
};

var getRepeatSize = function getRepeatSize(size, theme) {
  return "minmax(" + (theme.global.size[size] || size) + ", 1fr)";
};

var sizeFor = function sizeFor(size, props, isRow) {
  var mapped = SIZE_MAP[size];

  if (isRow && mapped && (!props.fillContainer || props.fillContainer === 'horizontal')) {
    console.warn('Grid needs `fill` when using fractional row sizes');
  }

  return mapped || props.theme.global.size[size] || size;
};

var columnsStyle = function columnsStyle(props) {
  if (Array.isArray(props.columns)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["grid-template-columns:", ";"], props.columns.map(function (s) {
      if (Array.isArray(s)) {
        return "minmax(" + sizeFor(s[0], props) + ", " + sizeFor(s[1], props) + ")";
      }

      return sizeFor(s, props);
    }).join(' '));
  }

  if (typeof props.columns === 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["grid-template-columns:repeat( ", ",", " );"], getRepeatCount(props.columns.count), getRepeatSize(props.columns.size, props.theme));
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["grid-template-columns:repeat( auto-fill,", " );"], getRepeatSize(props.columns, props.theme));
};

var rowsStyle = function rowsStyle(props) {
  if (Array.isArray(props.rowsProp)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["grid-template-rows:", ";"], props.rowsProp.map(function (s) {
      if (Array.isArray(s)) {
        return "minmax(" + sizeFor(s[0], props, true) + ", " + sizeFor(s[1], props, true) + ")";
      }

      return sizeFor(s, props, true);
    }).join(' '));
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["grid-auto-rows:", ";"], props.theme.global.size[props.rowsProp]);
};

var areasStyle = function areasStyle(props) {
  // translate areas objects into grid-template-areas syntax
  if (!Array.isArray(props.rowsProp) || !Array.isArray(props.columns)) {
    console.warn('Grid `areas` requires `rows` and `columns` to be arrays.');
  }

  var cells = props.rowsProp.map(function () {
    return props.columns.map(function () {
      return '.';
    });
  });
  props.areas.forEach(function (area) {
    for (var row = area.start[1]; row <= area.end[1]; row += 1) {
      for (var column = area.start[0]; column <= area.end[0]; column += 1) {
        cells[row][column] = area.name;
      }
    }
  });
  return "grid-template-areas: " + cells.map(function (r) {
    return "\"" + r.join(' ') + "\"";
  }).join(' ') + ";";
};

var StyledGrid = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledGrid",
  componentId: "sc-1wofa1l-0"
})(["display:grid;box-sizing:border-box;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return props.fillContainer && fillStyle(props.fillContainer);
}, function (props) {
  return props.align && alignStyle;
}, function (props) {
  return props.alignContent && alignContentStyle;
}, function (props) {
  return props.areas && areasStyle(props);
}, function (props) {
  return props.columns && columnsStyle(props);
}, function (props) {
  return props.gap && gapStyle(props);
}, function (props) {
  return props.justify && justifyStyle;
}, function (props) {
  return props.justifyContent && justifyContentStyle;
}, function (props) {
  return props.rowsProp && rowsStyle(props);
}, function (props) {
  return props.theme.grid && props.theme.grid.extend;
});
StyledGrid.defaultProps = {};
Object.setPrototypeOf(StyledGrid.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grommet__ = __webpack_require__(461);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grommet__["a"]; });


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Grommet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobile_detect__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobile_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobile_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_styles__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contexts__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themes__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StyledGrommet__ = __webpack_require__(464);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var wrapWithHocs = Object(__WEBPACK_IMPORTED_MODULE_6__hocs__["b" /* withDocs */])('Grommet');

var GrommetImpl =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(GrommetImpl, _Component);

  function GrommetImpl() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onResize", function () {
      var _this$state = _this.state,
          theme = _this$state.theme,
          responsive = _this$state.responsive;
      var breakpoint = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["s" /* getBreakpoint */])(window.innerWidth, theme);

      if (breakpoint !== responsive) {
        _this.setState({
          responsive: breakpoint
        });
      }
    });

    return _this;
  }

  GrommetImpl.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var _nextProps$theme = nextProps.theme,
        theme = _nextProps$theme === void 0 ? {} : _nextProps$theme;
    var stateTheme = prevState.theme,
        themeProp = prevState.themeProp;
    var nextTheme = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["l" /* deepMerge */])(__WEBPACK_IMPORTED_MODULE_5__themes__["a" /* base */], theme);

    if (!stateTheme || theme !== themeProp) {
      if (typeof theme.dark === 'undefined') {
        // calculate if background is dark or not
        // otherwise respect the property passed in the theme
        var colors = nextTheme.global.colors;
        var color = colors.background;
        nextTheme.dark = color ? Object(__WEBPACK_IMPORTED_MODULE_2_grommet_styles__["a" /* colorIsDark */])(color) : false;
      }

      return {
        theme: nextTheme,
        themeProp: theme
      };
    }

    return null;
  };

  var _proto = GrommetImpl.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  };

  _proto.deviceResponsive = function deviceResponsive() {
    var userAgent = this.props.userAgent;
    var theme = this.state.theme;

    if (userAgent) {
      var md = new __WEBPACK_IMPORTED_MODULE_1_mobile_detect___default.a(userAgent);

      if (md.phone()) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["t" /* getDeviceBreakpoint */])('phone', theme);
      }

      if (md.tablet()) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["t" /* getDeviceBreakpoint */])('tablet', theme);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["t" /* getDeviceBreakpoint */])('computer', theme);
    }

    return undefined;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        rest = _objectWithoutPropertiesLoose(_this$props, ["children"]);

    delete rest.theme;
    var _this$state2 = this.state,
        theme = _this$state2.theme,
        stateResponsive = _this$state2.responsive; // Value from state should be correct once we resize
    // On first render we try to guess otherwise set the default as a tablet

    var responsive = stateResponsive || this.deviceResponsive() || theme.global.deviceBreakpoints.tablet;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__contexts__["c" /* ThemeContext */].Provider, {
      value: theme
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__contexts__["b" /* ResponsiveContext */].Provider, {
      value: responsive
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledGrommet__["a" /* StyledGrommet */], rest, children)));
  };

  return GrommetImpl;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(GrommetImpl, "displayName", 'Grommet');

var Grommet = wrapWithHocs(GrommetImpl);

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.4.3 2018-09-08*/
/*global module:false, define:false*/
/*jshint latedef:false*/
/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
(function (define, undefined) {
define(function () {
    'use strict';

    var impl = {};

    impl.mobileDetectRules = {
    "phones": {
        "iPhone": "\\biPhone\\b|\\biPod\\b",
        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
        "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
        "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F",
        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)",
        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
        "NokiaLumia": "Lumia [0-9]{3,4}",
        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
        "Palm": "PalmSource|Palm",
        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
        "Alcatel": "Alcatel",
        "Nintendo": "Nintendo (3DS|Switch)",
        "Amoi": "Amoi",
        "INQ": "INQ",
        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
    },
    "tablets": {
        "iPad": "iPad|iPad.*Mobile",
        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
        "GoogleTablet": "Android.*Pixel C",
        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835",
        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
        "BlackBerryTablet": "PlayBook|RIM Tablet",
        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304F|TB-X304L|TB-8703F|Tab2A7-10F|TB2-X30L",
        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
        "IRUTablet": "M702pro",
        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
        "NokiaLumiaTablet": "Lumia 2520",
        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
        "FlyTablet": "IQ310|Fly Vision",
        "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))|Maxwell.*Lite|Maxwell.*Plus",
        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09",
        "NecTablet": "\\bN-06D|\\bN-08D",
        "PantechTablet": "Pantech.*P4100",
        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
        "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
        "NabiTablet": "Android.*\\bNabi",
        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
        "PlaystationTablet": "Playstation.*(Portable|Vita)",
        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
        "GalapadTablet": "Android.*\\bG1\\b(?!\\))",
        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
        "DPSTablet": "DPS Dream 9|DPS Dual 7",
        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497",
        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
        "iMobileTablet": "i-mobile i-note",
        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
        "AMPETablet": "Android.* A78 ",
        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
        "TecnoTablet": "TECNO P9|TECNO DP8D",
        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
        "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
        "CaptivaTablet": "CAPTIVA PAD",
        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
        "JaytechTablet": "TPC-PA762",
        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
        "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
        "UbislateTablet": "UbiSlate[\\s]?7C",
        "PocketBookTablet": "Pocketbook",
        "KocasoTablet": "\\b(TB-1207)\\b",
        "HisenseTablet": "\\b(F5281|E2371)\\b",
        "Hudl": "Hudl HT7S3|Hudl 2",
        "TelstraTablet": "T-Hub2",
        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
    },
    "oss": {
        "AndroidOS": "Android",
        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
        "MeeGoOS": "MeeGo",
        "MaemoOS": "Maemo",
        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
        "webOS": "webOS|hpwOS",
        "badaOS": "\\bBada\\b",
        "BREWOS": "BREW"
    },
    "uas": {
        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
        "Dolfin": "\\bDolfin\\b",
        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+$|Coast\/[0-9.]+",
        "Skyfire": "Skyfire",
        "Edge": "Mobile Safari\/[.0-9]* Edge",
        "IE": "IEMobile|MSIEMobile",
        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
        "Bolt": "bolt",
        "TeaShark": "teashark",
        "Blazer": "Blazer",
        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
        "WeChat": "\\bMicroMessenger\\b",
        "UCBrowser": "UC.*Browser|UCWEB",
        "baiduboxapp": "baiduboxapp",
        "baidubrowser": "baidubrowser",
        "DiigoBrowser": "DiigoBrowser",
        "Puffin": "Puffin",
        "Mercury": "\\bMercury\\b",
        "ObigoBrowser": "Obigo",
        "NetFront": "NF-Browser",
        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
    },
    "props": {
        "Mobile": "Mobile\/[VER]",
        "Build": "Build\/[VER]",
        "Version": "Version\/[VER]",
        "VendorID": "VendorID\/[VER]",
        "iPad": "iPad.*CPU[a-z ]+[VER]",
        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
        "iPod": "iPod.*CPU[a-z ]+[VER]",
        "Kindle": "Kindle\/[VER]",
        "Chrome": [
            "Chrome\/[VER]",
            "CriOS\/[VER]",
            "CrMo\/[VER]"
        ],
        "Coast": [
            "Coast\/[VER]"
        ],
        "Dolfin": "Dolfin\/[VER]",
        "Firefox": [
            "Firefox\/[VER]",
            "FxiOS\/[VER]"
        ],
        "Fennec": "Fennec\/[VER]",
        "Edge": "Edge\/[VER]",
        "IE": [
            "IEMobile\/[VER];",
            "IEMobile [VER]",
            "MSIE [VER];",
            "Trident\/[0-9.]+;.*rv:[VER]"
        ],
        "NetFront": "NetFront\/[VER]",
        "NokiaBrowser": "NokiaBrowser\/[VER]",
        "Opera": [
            " OPR\/[VER]",
            "Opera Mini\/[VER]",
            "Version\/[VER]"
        ],
        "Opera Mini": "Opera Mini\/[VER]",
        "Opera Mobi": "Version\/[VER]",
        "UCBrowser": [
            "UCWEB[VER]",
            "UC.*Browser\/[VER]"
        ],
        "MQQBrowser": "MQQBrowser\/[VER]",
        "MicroMessenger": "MicroMessenger\/[VER]",
        "baiduboxapp": "baiduboxapp\/[VER]",
        "baidubrowser": "baidubrowser\/[VER]",
        "SamsungBrowser": "SamsungBrowser\/[VER]",
        "Iron": "Iron\/[VER]",
        "Safari": [
            "Version\/[VER]",
            "Safari\/[VER]"
        ],
        "Skyfire": "Skyfire\/[VER]",
        "Tizen": "Tizen\/[VER]",
        "Webkit": "webkit[ \/][VER]",
        "PaleMoon": "PaleMoon\/[VER]",
        "Gecko": "Gecko\/[VER]",
        "Trident": "Trident\/[VER]",
        "Presto": "Presto\/[VER]",
        "Goanna": "Goanna\/[VER]",
        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
        "Android": "Android [VER]",
        "BlackBerry": [
            "BlackBerry[\\w]+\/[VER]",
            "BlackBerry.*Version\/[VER]",
            "Version\/[VER]"
        ],
        "BREW": "BREW [VER]",
        "Java": "Java\/[VER]",
        "Windows Phone OS": [
            "Windows Phone OS [VER]",
            "Windows Phone [VER]"
        ],
        "Windows Phone": "Windows Phone [VER]",
        "Windows CE": "Windows CE\/[VER]",
        "Windows NT": "Windows NT [VER]",
        "Symbian": [
            "SymbianOS\/[VER]",
            "Symbian\/[VER]"
        ],
        "webOS": [
            "webOS\/[VER]",
            "hpwOS\/[VER];"
        ]
    },
    "utils": {
        "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
        "DesktopMode": "WPDesktop",
        "TV": "SonyDTV|HbbTV",
        "WebKit": "(webkit)[ \/]([\\w.]+)",
        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
        "Watch": "SM-V700"
    }
};

    // following patterns come from http://detectmobilebrowsers.com/
    impl.detectMobileBrowsers = {
        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        tabletPattern: /android|ipad|playbook|silk/i
    };

    var hasOwnProp = Object.prototype.hasOwnProperty,
        isArray;

    impl.FALLBACK_PHONE = 'UnknownPhone';
    impl.FALLBACK_TABLET = 'UnknownTablet';
    impl.FALLBACK_MOBILE = 'UnknownMobile';

    isArray = ('isArray' in Array) ?
        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };

    function equalIC(a, b) {
        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
    }

    function containsIC(array, value) {
        var valueLC, i, len = array.length;
        if (!len || !value) {
            return false;
        }
        valueLC = value.toLowerCase();
        for (i = 0; i < len; ++i) {
            if (valueLC === array[i].toLowerCase()) {
                return true;
            }
        }
        return false;
    }

    function convertPropsToRegExp(object) {
        for (var key in object) {
            if (hasOwnProp.call(object, key)) {
                object[key] = new RegExp(object[key], 'i');
            }
        }
    }

    function prepareUserAgent(userAgent) {
        return (userAgent || '').substr(0, 500); // mitigate vulnerable to ReDoS
    }

    (function init() {
        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
        for (key in mobileDetectRules.props) {
            if (hasOwnProp.call(mobileDetectRules.props, key)) {
                values = mobileDetectRules.props[key];
                if (!isArray(values)) {
                    values = [values];
                }
                len = values.length;
                for (i = 0; i < len; ++i) {
                    value = values[i];
                    verPos = value.indexOf('[VER]');
                    if (verPos >= 0) {
                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
                    }
                    values[i] = new RegExp(value, 'i');
                }
                mobileDetectRules.props[key] = values;
            }
        }
        convertPropsToRegExp(mobileDetectRules.oss);
        convertPropsToRegExp(mobileDetectRules.phones);
        convertPropsToRegExp(mobileDetectRules.tablets);
        convertPropsToRegExp(mobileDetectRules.uas);
        convertPropsToRegExp(mobileDetectRules.utils);

        // copy some patterns to oss0 which are tested first (see issue#15)
        mobileDetectRules.oss0 = {
            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
        };
    }());

    /**
     * Test userAgent string against a set of rules and find the first matched key.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
     * @private
     */
    impl.findMatch = function(rules, userAgent) {
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    return key;
                }
            }
        }
        return null;
    };

    /**
     * Test userAgent string against a set of rules and return an array of matched keys.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
     * @private
     */
    impl.findMatches = function(rules, userAgent) {
        var result = [];
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    result.push(key);
                }
            }
        }
        return result;
    };

    /**
     * Check the version of the given property in the User-Agent.
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {String} version or <tt>null</tt> if version not found
     * @private
     */
    impl.getVersionStr = function (propertyName, userAgent) {
        var props = impl.mobileDetectRules.props, patterns, i, len, match;
        if (hasOwnProp.call(props, propertyName)) {
            patterns = props[propertyName];
            len = patterns.length;
            for (i = 0; i < len; ++i) {
                match = patterns[i].exec(userAgent);
                if (match !== null) {
                    return match[1];
                }
            }
        }
        return null;
    };

    /**
     * Check the version of the given property in the User-Agent.
     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {Number} version or <tt>NaN</tt> if version not found
     * @private
     */
    impl.getVersion = function (propertyName, userAgent) {
        var version = impl.getVersionStr(propertyName, userAgent);
        return version ? impl.prepareVersionNo(version) : NaN;
    };

    /**
     * Prepare the version number.
     *
     * @param {String} version
     * @return {Number} the version number as a floating number
     * @private
     */
    impl.prepareVersionNo = function (version) {
        var numbers;

        numbers = version.split(/[a-z._ \/\-]/i);
        if (numbers.length === 1) {
            version = numbers[0];
        }
        if (numbers.length > 1) {
            version = numbers[0] + '.';
            numbers.shift();
            version += numbers.join('');
        }
        return Number(version);
    };

    impl.isMobileFallback = function (userAgent) {
        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
    };

    impl.isTabletFallback = function (userAgent) {
        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
    };

    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
        if (cache.mobile !== undefined) {
            return;
        }
        var phone, tablet, phoneSized;

        // first check for stronger tablet rules, then phone (see issue#5)
        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
        if (tablet) {
            cache.mobile = cache.tablet = tablet;
            cache.phone = null;
            return; // unambiguously identified as tablet
        }

        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
        if (phone) {
            cache.mobile = cache.phone = phone;
            cache.tablet = null;
            return; // unambiguously identified as phone
        }

        // our rules haven't found a match -> try more general fallback rules
        if (impl.isMobileFallback(userAgent)) {
            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
            if (phoneSized === undefined) {
                cache.mobile = impl.FALLBACK_MOBILE;
                cache.tablet = cache.phone = null;
            } else if (phoneSized) {
                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                cache.tablet = null;
            } else {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            }
        } else if (impl.isTabletFallback(userAgent)) {
            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
            cache.phone = null;
        } else {
            // not mobile at all!
            cache.mobile = cache.tablet = cache.phone = null;
        }
    };

    // t is a reference to a MobileDetect instance
    impl.mobileGrade = function (t) {
        // impl note:
        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
        // When changes are made in Mobile_Detect.php, copy this method and replace:
        //     $this-> / t.
        //     self::MOBILE_GRADE_(.) / '$1'
        //     , self::VERSION_TYPE_FLOAT / (nothing)
        //     isIOS() / os('iOS')
        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
        var $isMobile = t.mobile() !== null;

        if (
            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os('iOS') && t.version('iPad')>=4.3 ||
            t.os('iOS') && t.version('iPhone')>=3.1 ||
            t.os('iOS') && t.version('iPod')>=3.1 ||

            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            ( t.version('Android')>2.1 && t.is('Webkit') ) ||

            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version('Windows Phone OS')>=7.0 ||

            // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match('Playbook.*Tablet') ||

            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
            // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match('hp.*TouchPad') ||

            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||

            // Chrome for Android - Tested on Android 4.0, 4.1 device
            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||

            // Skyfire 4.1 - Tested on Android 2.3 device
            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||

            // Opera Mobile 11.5-12: Tested on Android 2.3
            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||

            // Meego 1.2 - Tested on Nokia 950 and N9
            t.is('MeeGoOS') ||

            // Tizen (pre-release) - Tested on early hardware
            t.is('Tizen') ||

            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is('Dolfin') && t.version('Bada')>=2.0 ||

            // UC Browser - Tested on Android 2.3 device
            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||

            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            ( t.match('Kindle Fire') ||
                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||

            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is('AndroidOS') && t.is('NookTablet') ||

            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version('Chrome')>=11 && !$isMobile ||

            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version('Safari')>=5.0 && !$isMobile ||

            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version('Firefox')>=4.0 && !$isMobile ||

            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version('MSIE')>=7.0 && !$isMobile ||

            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version('Opera')>=10 && !$isMobile

            ){
            return 'A';
        }

        if (
            t.os('iOS') && t.version('iPad')<4.3 ||
            t.os('iOS') && t.version('iPhone')<3.1 ||
            t.os('iOS') && t.version('iPod')<3.1 ||

            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||

            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
                (t.version('Android')>=2.3 || t.is('iOS')) ) ||

            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||

            // @todo: report this (tested on Nokia N71)
            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
            ){
            return 'B';
        }

        if (
        // Blackberry 4.x - Tested on the Curve 8330
            t.version('BlackBerry')<5.0 ||
            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2

            ){
            return 'C';
        }

        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
        //will receive the basic, C grade experience.
        return 'C';
    };

    impl.detectOS = function (ua) {
        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
            impl.findMatch(impl.mobileDetectRules.oss, ua);
    };

    impl.getDeviceSmallerSide = function () {
        return window.screen.width < window.screen.height ?
            window.screen.width :
            window.screen.height;
    };

    /**
     * Constructor for MobileDetect object.
     * <br>
     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
     *     <strong>Find information how to download and install:</strong>
     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
     * </div>
     *
     * @example <pre>
     *     var md = new MobileDetect(window.navigator.userAgent);
     *     if (md.mobile()) {
     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
     *     }
     * </pre>
     *
     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
     *        as phone.
     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
     *        for Android</a>.<br>
     *        If you provide a value < 0, then this "fuzzy" check is disabled.
     * @constructor
     * @global
     */
    function MobileDetect(userAgent, maxPhoneWidth) {
        this.ua = prepareUserAgent(userAgent);
        this._cache = {};
        //600dp is typical 7" tablet minimum width
        this.maxPhoneWidth = maxPhoneWidth || 600;
    }

    MobileDetect.prototype = {
        constructor: MobileDetect,

        /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */
        mobile: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.mobile;
        },

        /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */
        phone: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.phone;
        },

        /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */
        tablet: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.tablet;
        },

        /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin,
         * Mercury, ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */
        userAgent: function () {
            if (this._cache.userAgent === undefined) {
                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgent;
        },

        /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin,
         * Mercury, ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */
        userAgents: function () {
            if (this._cache.userAgents === undefined) {
                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgents;
        },

        /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */
        os: function () {
            if (this._cache.os === undefined) {
                this._cache.os = impl.detectOS(this.ua);
            }
            return this._cache.os;
        },

        /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */
        version: function (key) {
            return impl.getVersion(key, this.ua);
        },

        /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */
        versionStr: function (key) {
            return impl.getVersionStr(key, this.ua);
        },

        /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */
        is: function (key) {
            return containsIC(this.userAgents(), key) ||
                   equalIC(key, this.os()) ||
                   equalIC(key, this.phone()) ||
                   equalIC(key, this.tablet()) ||
                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
        },

        /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */
        match: function (pattern) {
            if (!(pattern instanceof RegExp)) {
                pattern = new RegExp(pattern, 'i');
            }
            return pattern.test(this.ua);
        },

        /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */
        isPhoneSized: function (maxPhoneWidth) {
            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
        },

        /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */
        mobileGrade: function () {
            if (this._cache.grade === undefined) {
                this._cache.grade = impl.mobileGrade(this);
            }
            return this._cache.grade;
        }
    };

    // environment-dependent
    if (typeof window !== 'undefined' && window.screen) {
        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
        };
    } else {
        MobileDetect.isPhoneSized = function () {};
    }

    // should not be replaced by a completely new object - just overwrite existing methods
    MobileDetect._impl = impl;
    
    MobileDetect.version = '1.4.3 2018-09-08';

    return MobileDetect;
}); // end of call of define()
})((function (undefined) {
    if (typeof module !== 'undefined' && module.exports) {
        return function (factory) { module.exports = factory(); };
    } else if (true) {
        return __webpack_require__(463);
    } else if (typeof window !== 'undefined') {
        return function (factory) { window.MobileDetect = factory(); };
    } else {
        // please file a bug if you get this error!
        throw new Error('unknown environment');
    }
})());

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledGrommet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var fullStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["width:100vw;height:100vh;overflow:auto;"]);
var StyledGrommet = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledGrommet",
  componentId: "sc-19lkkz7-0"
})(["", " ", " ", " ", ""], function (props) {
  return !props.plain && __WEBPACK_IMPORTED_MODULE_1__utils__["e" /* baseStyle */];
}, function (props) {
  return props.full && fullStyle;
}, function (props) {
  return props.theme.global.font.face;
}, function (props) {
  return props.theme.grommet.extend;
});
StyledGrommet.defaultProps = {};
Object.setPrototypeOf(StyledGrommet.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Image__ = __webpack_require__(466);
/* unused harmony reexport Image */


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StyledImage__ = __webpack_require__(467);

var ImageDoc;

if (false) {
  ImageDoc = require('./doc').doc(StyledImage); // eslint-disable-line global-require
}

var ImageWrapper = ImageDoc || __WEBPACK_IMPORTED_MODULE_0__StyledImage__["a" /* StyledImage */];
ImageWrapper.displayName = 'Image';


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var FIT_MAP = {
  cover: 'cover',
  contain: 'contain'
};
var fitStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["flex:1 1;overflow:hidden;object-fit:", ";"], function (props) {
  return FIT_MAP[props.fit];
});
var StyledImage = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].img.withConfig({
  displayName: "StyledImage",
  componentId: "ey4zx9-0"
})(["", " ", " ", ""], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return props.fit && fitStyle;
}, function (props) {
  return props.theme.image && props.theme.image.extend;
});
StyledImage.defaultProps = {};
Object.setPrototypeOf(StyledImage.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayerWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LayerContainer__ = __webpack_require__(469);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Layer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Layer, _Component);

  function Layer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "originalFocusedElement", document.activeElement);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "layerContainer", Object(__WEBPACK_IMPORTED_MODULE_2__utils__["u" /* getNewContainer */])());

    return _this;
  }

  var _proto = Layer.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this2 = this;

    if (this.originalFocusedElement) {
      if (this.originalFocusedElement.focus) {
        // wait for the fixed positioning to come back to normal
        // see layer styling for reference
        setTimeout(function () {
          _this2.originalFocusedElement.focus();
        }, 0);
      } else if (this.originalFocusedElement.parentNode && this.originalFocusedElement.parentNode.focus) {
        // required for IE11 and Edge
        this.originalFocusedElement.parentNode.focus();
      }
    }

    document.body.removeChild(this.layerContainer);
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LayerContainer__["a" /* LayerContainer */], this.props), this.layerContainer);
  };

  return Layer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Layer, "defaultProps", {
  full: false,
  margin: 'none',
  modal: true,
  position: 'center',
  responsive: true
});

var LayerDoc;

if (false) {
  LayerDoc = require('./doc').doc(Layer); // eslint-disable-line global-require
}

var LayerWrapper = LayerDoc || Layer;


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contexts__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FocusedContainer__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Keyboard__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StyledLayer__ = __webpack_require__(470);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var HiddenAnchor = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].a.withConfig({
  displayName: "LayerContainer__HiddenAnchor",
  componentId: "sc-1srj14c-0"
})(["width:0;height:0;overflow:hidden;position:absolute;"]);

var LayerContainer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(LayerContainer, _Component);

  function LayerContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "anchorRef", Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "containerRef", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "layerRef", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "makeLayerVisible", function () {
      var node = _this.layerRef.current || _this.containerRef.current;

      if (node && node.scrollIntoView) {
        node.scrollIntoView();
      }
    });

    return _this;
  }

  var _proto = LayerContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var position = this.props.position;

    if (position !== 'hidden') {
      this.makeLayerVisible(); // once layer is open we set the focus in the hidden
      // anchor so that you can start tabbing inside the layer

      if (this.anchorRef.current) {
        this.anchorRef.current.focus();
      }
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var position = this.props.position;

    if (prevProps.position !== position && position !== 'hidden') {
      this.makeLayerVisible();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        id = _this$props.id,
        modal = _this$props.modal,
        onClickOutside = _this$props.onClickOutside,
        onEsc = _this$props.onEsc,
        plain = _this$props.plain,
        position = _this$props.position,
        responsive = _this$props.responsive,
        propsTheme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["children", "id", "modal", "onClickOutside", "onEsc", "plain", "position", "responsive", "theme"]);

    var theme = this.context || propsTheme;
    var content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledLayer__["a" /* StyledContainer */], _extends({
      id: id
    }, rest, {
      position: position,
      plain: plain,
      responsive: responsive,
      ref: this.containerRef
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HiddenAnchor, {
      ref: this.anchorRef,
      tabIndex: "-1",
      "aria-hidden": "true"
    }), children);

    if (modal) {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledLayer__["b" /* StyledLayer */], {
        id: id,
        plain: plain,
        position: position,
        responsive: responsive,
        tabIndex: "-1",
        ref: this.layerRef
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledLayer__["c" /* StyledOverlay */], {
        plain: plain,
        onMouseDown: onClickOutside,
        responsive: responsive
      }), content);
      /* eslint-enable jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */
    }

    if (onEsc) {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Keyboard__["a" /* Keyboard */], {
        onEsc: onEsc
      }, content);
    }

    if (theme.layer.background) {
      var dark = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* backgroundIsDark */])(theme.layer.background, theme);

      if (dark !== theme.dark) {
        content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__contexts__["c" /* ThemeContext */].Provider, {
          value: _extends({}, theme, {
            dark: dark
          })
        }, content);
      }
    }

    if (modal) {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FocusedContainer__["a" /* FocusedContainer */], {
        hidden: position === 'hidden',
        restrictScroll: true
      }, content);
    }

    return content;
  };

  return LayerContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(LayerContainer, "contextType", __WEBPACK_IMPORTED_MODULE_3__contexts__["c" /* ThemeContext */]);

_defineProperty(LayerContainer, "defaultProps", {
  full: false,
  margin: 'none',
  modal: true,
  position: 'center'
});

Object.setPrototypeOf(LayerContainer.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledOverlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var hiddenPositionStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["left:-100%;right:100%;z-index:-1;position:fixed;"]);
var desktopLayerStyle = "\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  width: 100vw;\n  height: 100vh;\n";
var responsiveLayerStyle = "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n";
var StyledLayer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledLayer",
  componentId: "rmtehz-0"
})(["", " background:unset;position:relative;z-index:", ";pointer-events:none;outline:none;", " ", ";"], __WEBPACK_IMPORTED_MODULE_1__utils__["e" /* baseStyle */], function (props) {
  return props.theme.layer.zIndex;
}, function (props) {
  if (props.position === 'hidden') {
    return hiddenPositionStyle;
  }

  var styles = [desktopLayerStyle];

  if (props.responsive && props.theme.layer.responsiveBreakpoint) {
    var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
    styles.push(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* breakpointStyle */])(breakpoint, responsiveLayerStyle));
  }

  return styles;
}, function (props) {
  return props.theme.layer && props.theme.layer.extend;
});
StyledLayer.defaultProps = {};
Object.setPrototypeOf(StyledLayer.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledOverlay = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledLayer__StyledOverlay",
  componentId: "rmtehz-1"
})(["position:absolute;", " top:0px;left:0px;right:0px;bottom:0px;", " pointer-events:all;"], function (props) {
  if (props.responsive && props.theme.layer.responsiveBreakpoint) {
    var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* breakpointStyle */])(breakpoint, 'position: relative;');
  }

  return '';
}, function (props) {
  return !props.plain && props.theme.layer.overlay.background && Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* backgroundStyle */])(props.theme.layer.overlay.background, props.theme);
});

var getMargin = function getMargin(margin, theme, position) {
  var axis = position === 'top' || position === 'bottom' ? 'vertical' : 'horizontal';
  var marginValue = margin[position] || margin[axis] || margin;
  var marginApplied = theme.global.edgeSize[marginValue] || marginValue;
  var marginInTheme = !!theme.global.edgeSize[marginValue];
  return !marginInTheme && typeof marginValue !== 'string' ? '0px' : marginApplied;
};

var MARGINS = function MARGINS(margin, theme, position) {
  if (position === void 0) {
    position = undefined;
  }

  if (position) {
    return getMargin(margin, theme, position);
  }

  return {
    top: getMargin(margin, theme, 'top'),
    bottom: getMargin(margin, theme, 'bottom'),
    left: getMargin(margin, theme, 'left'),
    right: getMargin(margin, theme, 'right')
  };
};

var KEYFRAMES = {
  center: {
    vertical: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateX(-50%) scale(0.8);}100%{transform:translateX(-50%) scale(1);}"]),
    horizontal: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateY(-50%) scale(0.8);}100%{transform:translateY(-50) scale(1);}"]),
    true: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:scale(0.8);}100%{transform:scale(1);}"]),
    false: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translate(-50%,-50%) scale(0.8);}100%{transform:translate(-50%,-50%) scale(1);}"])
  },
  top: {
    vertical: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translate(-50%,-100%);}100%{transform:translate(-50%,0);}"]),
    horizontal: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateY(-100%);}100%{transform:translateY(0);}"]),
    true: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateY(-100%);}100%{transform:translateY(0);}"]),
    false: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translate(-50%,-100%);}100%{transform:translate(-50%,0);}"])
  },
  bottom: {
    vertical: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translate(-50%,100%);}100%{transform:translate(-50%,0);}"]),
    horizontal: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateY(100%);}100%{transform:translateY(0);}"]),
    true: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateY(100%);}100%{transform:translateY(0);}"]),
    false: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translate(-50%,100%);}100%{transform:translate(-50%,0);}"])
  },
  left: {
    vertical: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateX(-100%);}100%{transform:translateX(0);}"]),
    horizontal: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"]),
    true: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateX(-100%);}100%{transform:translateX(0);}"]),
    false: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"])
  },
  right: {
    vertical: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateX(100%);}100%{transform:translateX(0);}"]),
    horizontal: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"]),
    true: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translateX(100%);}100%{transform:translateX(0);}"]),
    false: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* keyframes */])(["0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"])
  }
}; // POSITIONS combines 'position', 'full', and 'margin' properties, since
// they are all interdependent.
// Basically, non-full axes combine 50% position with -50% translation.
// full axes pin to the window edges offset by any margin.
// The keyframe animations are included as they are done via translations
// as well so they must take into account the non-animated positioning.

var POSITIONS = {
  center: {
    vertical: function vertical(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["top:", ";bottom:", ";left:50%;transform:translateX(-50%);animation:", " 0.2s ease-in-out forwards;"], margin.top, margin.bottom, KEYFRAMES.center.vertical);
    },
    horizontal: function horizontal(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["left:", ";right:", ";top:50%;transform:translateY(-50%);animation:", " 0.2s ease-in-out forwards;"], margin.left, margin.right, KEYFRAMES.center.horizontal);
    },
    true: function _true(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["top:", ";bottom:", ";left:", ";right:", ";animation:", " 0.2s ease-in-out forwards;"], margin.top, margin.bottom, margin.left, margin.right, KEYFRAMES.center.true);
    },
    false: function _false() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["top:50%;left:50%;transform:translate(-50%,-50%);animation:", " 0.2s ease-in-out forwards;"], KEYFRAMES.center.false);
    }
  },
  top: {
    vertical: function vertical(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["top:", ";bottom:", ";left:50%;transform:translate(-50%,0%);animation:", " 0.2s ease-in-out forwards;"], margin.top, margin.bottom, KEYFRAMES.top.vertical);
    },
    horizontal: function horizontal(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["left:", ";right:", ";top:", ";transform:translateY(0);animation:", " 0.2s ease-in-out forwards;"], margin.left, margin.right, margin.top, KEYFRAMES.top.horizontal);
    },
    true: function _true(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["top:", ";bottom:", ";left:", ";right:", ";transform:translateY(0);animation:", " 0.2s ease-in-out forwards;"], margin.top, margin.bottom, margin.left, margin.right, KEYFRAMES.top.true);
    },
    false: function _false(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["top:", ";left:50%;transform:translate(-50%,0);animation:", " 0.2s ease-in-out forwards;"], margin.top, KEYFRAMES.top.false);
    }
  },
  bottom: {
    vertical: function vertical(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["top:", " bottom:", ";left:50%;transform:translate(-50%,0);animation:", " 0.2s ease-in-out forwards;"], margin.top, margin.bottom, KEYFRAMES.bottom.vertical);
    },
    horizontal: function horizontal(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["left:", ";right:", ";bottom:", ";transform:translateY(0);animation:", " 0.2s ease-in-out forwards;"], margin.left, margin.top, margin.bottom, KEYFRAMES.bottom.horizontal);
    },
    true: function _true(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["top:", ";bottom:", ";left:", ";right:", ";transform:translateY(0);animation:", " 0.2s ease-in-out forwards;"], margin.top, margin.bottom, margin.left, margin.right, KEYFRAMES.bottom.true);
    },
    false: function _false(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["bottom:", ";left:50%;transform:translate(-50%,0);animation:", " 0.2s ease-in-out forwards;"], margin.bottom, KEYFRAMES.bottom.false);
    }
  },
  left: {
    vertical: function vertical(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["top:", ";bottom:", ";left:", ";transform:translateX(0);animation:", " 0.2s ease-in-out forwards;"], margin.top, margin.bottom, margin.left, KEYFRAMES.left.vertical);
    },
    horizontal: function horizontal(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["left:", ";right:", ";top:50%;transform:translate(0,-50%);animation:", " 0.2s ease-in-out forwards;"], margin.left, margin.right, KEYFRAMES.left.horizontal);
    },
    true: function _true(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["top:", ";bottom:", ";left:", ";right:", ";transform:translateX(0);animation:", " 0.2s ease-in-out forwards;"], margin.top, margin.bottom, margin.left, margin.right, KEYFRAMES.left.true);
    },
    false: function _false(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["left:", ";top:50%;transform:translate(0,-50%);animation:", " 0.2s ease-in-out forwards;"], margin.left, KEYFRAMES.left.false);
    }
  },
  right: {
    vertical: function vertical(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["top:", ";bottom:", ";right:", ";transform:translateX(0);animation:", " 0.2s ease-in-out forwards;"], margin.top, margin.bottom, margin.right, KEYFRAMES.right.vertical);
    },
    horizontal: function horizontal(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["left:", ";right:", ";top:50%;transform:translate(0,-50%);animation:", " 0.2s ease-in-out forwards;"], margin.left, margin.right, KEYFRAMES.right.horizontal);
    },
    true: function _true(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["top:", ";bottom:", ";left:", ";right:", ";transform:translateX(0);animation:", " 0.2s ease-in-out forwards;"], margin.top, margin.bottom, margin.left, margin.right, KEYFRAMES.right.true);
    },
    false: function _false(margin) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["right:", ";top:50%;transform:translate(0,-50%);animation:", " 0.2s ease-in-out forwards;"], margin.right, KEYFRAMES.right.false);
    }
  }
};
var desktopContainerStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["position:", ";max-height:", ";max-width:", ";border-radius:", ";", ";"], function (props) {
  return props.modal ? 'absolute' : 'fixed';
}, function (props) {
  return "calc(100% - " + MARGINS(props.margin, props.theme, 'top') + " - " + MARGINS(props.margin, props.theme, 'bottom') + ")";
}, function (props) {
  return "calc(100% - " + MARGINS(props.margin, props.theme, 'left') + " - " + MARGINS(props.margin, props.theme, 'right') + ")";
}, function (props) {
  return props.plain ? 0 : props.theme.layer.border.radius;
}, function (props) {
  return props.position !== 'hidden' && POSITIONS[props.position][props.full](MARGINS(props.margin, props.theme)) || '';
});
var responsiveContainerStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["position:relative;max-height:none;max-width:none;border-radius:0;top:0;bottom:0;left:0;right:0;transform:none;animation:none;height:100vh;width:100vw;"]);
var StyledContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledLayer__StyledContainer",
  componentId: "rmtehz-2"
})(["", " display:flex;flex-direction:column;min-height:", ";", " outline:none;pointer-events:all;z-index:", ";", " ", ";"], function (props) {
  return !props.modal ? __WEBPACK_IMPORTED_MODULE_1__utils__["e" /* baseStyle */] : '';
}, function (props) {
  return props.theme.global.size.xxsmall;
}, function (props) {
  return !props.plain && props.theme.layer.background && Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* backgroundStyle */])(props.theme.layer.background, props.theme);
}, function (props) {
  return props.theme.layer.container.zIndex;
}, desktopContainerStyle, function (props) {
  if (props.responsive && props.theme.layer.responsiveBreakpoint) {
    var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];

    if (breakpoint) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* breakpointStyle */])(breakpoint, responsiveContainerStyle);
    }
  }

  return '';
});
StyledContainer.defaultProps = {};
Object.setPrototypeOf(StyledContainer.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Markdown__ = __webpack_require__(472);
/* unused harmony reexport Markdown */


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Markdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_markdown_to_jsx__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Heading__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Paragraph__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Anchor__ = __webpack_require__(63);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }








var GrommetMarkdown =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(GrommetMarkdown, _Component);

  function GrommetMarkdown() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = GrommetMarkdown.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        components = _this$props.components,
        theme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["components", "theme"]);

    var heading = [1, 2, 3, 4].reduce(function (obj, level) {
      var result = _extends({}, obj);

      result["h" + level] = {
        component: __WEBPACK_IMPORTED_MODULE_3__Heading__["a" /* Heading */],
        props: {
          level: level
        }
      };
      return result;
    }, {});
    var overrides = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["l" /* deepMerge */])({
      p: {
        component: __WEBPACK_IMPORTED_MODULE_4__Paragraph__["a" /* Paragraph */]
      },
      a: {
        component: __WEBPACK_IMPORTED_MODULE_5__Anchor__["a" /* Anchor */]
      }
    }, heading, components);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_markdown_to_jsx__["a" /* default */], _extends({
      options: {
        overrides: overrides
      }
    }, rest));
  };

  return GrommetMarkdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var GrommetMarkdownDoc;

if (false) {
  GrommetMarkdownDoc = require('./doc').doc(GrommetMarkdown); // eslint-disable-line global-require
}

var GrommetMarkdownWrapper = GrommetMarkdownDoc || GrommetMarkdown;


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compiler */
/* harmony export (immutable) */ __webpack_exports__["a"] = Markdown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unquote__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unquote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_unquote__);
var _extends=Object.assign||function(a){for(var b,c=1;c<arguments.length;c++)for(var d in b=arguments[c],b)Object.prototype.hasOwnProperty.call(b,d)&&(a[d]=b[d]);return a},_typeof=typeof Symbol=='function'&&typeof Symbol.iterator=='symbol'?function(a){return typeof a}:function(a){return a&&typeof Symbol=='function'&&a.constructor===Symbol&&a!==Symbol.prototype?'symbol':typeof a};function _objectWithoutProperties(a,b){var c={};for(var d in a)b.indexOf(d)>=0||Object.prototype.hasOwnProperty.call(a,d)&&(c[d]=a[d]);return c}var ATTRIBUTE_TO_JSX_PROP_MAP={accesskey:'accessKey',allowfullscreen:'allowFullScreen',allowtransparency:'allowTransparency',autocomplete:'autoComplete',autofocus:'autoFocus',autoplay:'autoPlay',cellpadding:'cellPadding',cellspacing:'cellSpacing',charset:'charSet',class:'className',classid:'classId',colspan:'colSpan',contenteditable:'contentEditable',contextmenu:'contextMenu',crossorigin:'crossOrigin',enctype:'encType',for:'htmlFor',formaction:'formAction',formenctype:'formEncType',formmethod:'formMethod',formnovalidate:'formNoValidate',formtarget:'formTarget',frameborder:'frameBorder',hreflang:'hrefLang',inputmode:'inputMode',keyparams:'keyParams',keytype:'keyType',marginheight:'marginHeight',marginwidth:'marginWidth',maxlength:'maxLength',mediagroup:'mediaGroup',minlength:'minLength',novalidate:'noValidate',radiogroup:'radioGroup',readonly:'readOnly',rowspan:'rowSpan',spellcheck:'spellCheck',srcdoc:'srcDoc',srclang:'srcLang',srcset:'srcSet',tabindex:'tabIndex',usemap:'useMap'},namedCodesToUnicode={amp:'&',apos:'\'',gt:'>',lt:'<',nbsp:'\xA0',quot:'\u201C'},DO_NOT_PROCESS_HTML_ELEMENTS=['style','script'],ATTR_EXTRACTOR_R=/([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,AUTOLINK_MAILTO_CHECK_R=/mailto:/i,BLOCK_END_R=/\n{2,}$/,BLOCKQUOTE_R=/^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/,BLOCKQUOTE_TRIM_LEFT_MULTILINE_R=/^ *> ?/gm,BREAK_LINE_R=/^ {2,}\n/,BREAK_THEMATIC_R=/^(?:( *[-*_]) *){3,}(?:\n *)+\n/,CODE_BLOCK_FENCED_R=/^\s*(`{3,}|~{3,}) *(\S+)? *\n([\s\S]+?)\s*\1 *(?:\n *)+\n?/,CODE_BLOCK_R=/^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,CODE_INLINE_R=/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,CONSECUTIVE_NEWLINE_R=/^(?:\n *)*\n/,CR_NEWLINE_R=/\r\n?/g,FOOTNOTE_R=/^\[\^(.*)\](:.*)\n/,FOOTNOTE_REFERENCE_R=/^\[\^(.*)\]/,FORMFEED_R=/\f/g,GFM_TASK_R=/^\s*?\[(x|\s)\]/,HEADING_R=/^ *(#{1,6}) *([^\n]+)\n{0,2}/,HEADING_SETEXT_R=/^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,HTML_BLOCK_ELEMENT_R=/^ *<([A-Za-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/,HTML_CHAR_CODE_R=/&([a-z]+);/g,HTML_COMMENT_R=/^<!--.*?-->/,HTML_CUSTOM_ATTR_R=/^(data|aria|x)-[a-z_][a-z\d_.-]*$/,HTML_SELF_CLOSING_ELEMENT_R=/^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,INTERPOLATION_R=/^\{.*\}$/,LINK_AUTOLINK_BARE_URL_R=/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,LINK_AUTOLINK_MAILTO_R=/^<([^ >]+@[^ >]+)>/,LINK_AUTOLINK_R=/^<([^ >]+:\/[^ >]+)>/,LIST_ITEM_END_R=/ *\n+$/,LIST_LOOKBEHIND_R=/(?:^|\n)( *)$/,CAPTURE_LETTER_AFTER_HYPHEN=/-([a-z])?/gi,NP_TABLE_R=/^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/,PARAGRAPH_R=/^((?:[^\n]|\n(?! *\n))+)(?:\n *)+\n/,REFERENCE_IMAGE_OR_LINK=/^\[([^\]]*)\]:\s*(\S+)\s*("([^"]*)")?/,REFERENCE_IMAGE_R=/^!\[([^\]]*)\] ?\[([^\]]*)\]/,REFERENCE_LINK_R=/^\[([^\]]*)\] ?\[([^\]]*)\]/,SQUARE_BRACKETS_R=/(\[|\])/g,SHOULD_RENDER_AS_BLOCK_R=/(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,TAB_R=/\t/g,TABLE_TRIM_PIPES=/(^ *\||\| *$)/g,TABLE_CENTER_ALIGN=/^ *:-+: *$/,TABLE_LEFT_ALIGN=/^ *:-+ *$/,TABLE_RIGHT_ALIGN=/^ *-+: *$/,TABLE_ROW_SPLIT=/ *\| */,TEXT_BOLD_R=/^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/,TEXT_EMPHASIZED_R=/^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1)/,TEXT_STRIKETHROUGHED_R=/^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/,TEXT_ESCAPED_R=/^\\([^0-9A-Za-z\s])/,TEXT_PLAIN_R=/^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,TRIM_NEWLINES_AND_TRAILING_WHITESPACE_R=/(^\n+|(\n|\s)+$)/g,HTML_LEFT_TRIM_AMOUNT_R=/^([ \t]*)/,UNESCAPE_URL_R=/\\([^0-9A-Z\s])/gi,LIST_BULLET='(?:[*+-]|\\d+\\.)',LIST_ITEM_PREFIX='( *)((?:[*+-]|\\d+\\.)) +',LIST_ITEM_PREFIX_R=/^( *)((?:[*+-]|\d+\.)) +/,LIST_ITEM_R=/( *)((?:[*+-]|\d+\.)) +[^\n]*(?:\n(?!\1(?:[*+-]|\d+\.) )[^\n]*)*(\n|$)/gm,LIST_R=/^( *)((?:[*+-]|\d+\.)) [\s\S]+?(?:\n{2,}(?! )(?!\1(?:[*+-]|\d+\.) (?!(?:[*+-]|\d+\.) ))\n*|\s*\n*$)/,LINK_INSIDE='(?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*',LINK_HREF_AND_TITLE='\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+[\'"]([\\s\\S]*?)[\'"])?\\s*',LINK_R=/^\[((?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*)\]\(\s*<?((?:[^\s\\]|\\.)*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*\)/,IMAGE_R=/^!\[((?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*)\]\(\s*<?((?:[^\s\\]|\\.)*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*\)/,BLOCK_SYNTAXES=[BLOCKQUOTE_R,CODE_BLOCK_R,CODE_BLOCK_FENCED_R,HEADING_R,HEADING_SETEXT_R,HTML_BLOCK_ELEMENT_R,HTML_COMMENT_R,HTML_SELF_CLOSING_ELEMENT_R,LIST_ITEM_R,LIST_R,NP_TABLE_R,PARAGRAPH_R];function containsBlockSyntax(a){return BLOCK_SYNTAXES.some(function(b){return b.test(a)})}function slugify(a){return a.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g,'a').replace(/[çÇ]/g,'c').replace(/[ðÐ]/g,'d').replace(/[ÈÉÊËéèêë]/g,'e').replace(/[ÏïÎîÍíÌì]/g,'i').replace(/[Ññ]/g,'n').replace(/[øØœŒÕõÔôÓóÒò]/g,'o').replace(/[ÜüÛûÚúÙù]/g,'u').replace(/[ŸÿÝý]/g,'y').replace(/[^a-z0-9- ]/gi,'').replace(/ /gi,'-').toLowerCase()}function parseTableAlignCapture(a){if(TABLE_RIGHT_ALIGN.test(a))return'right';return TABLE_CENTER_ALIGN.test(a)?'center':TABLE_LEFT_ALIGN.test(a)?'left':null}function parseTableHeader(a,b,c){var d=a[1].replace(TABLE_TRIM_PIPES,'').trim().split(TABLE_ROW_SPLIT);return d.map(function(a){return b(a,c)})}function parseTableAlign(a){var b=a[2].replace(TABLE_TRIM_PIPES,'').trim().split(TABLE_ROW_SPLIT);return b.map(parseTableAlignCapture)}function parseTableCells(a,b,c){var d=a[3].replace(TABLE_TRIM_PIPES,'').trim().split('\n');return d.map(function(a){return a.replace(TABLE_TRIM_PIPES,'').split(TABLE_ROW_SPLIT).map(function(a){return b(a.trim(),c)})})}function parseTable(a,b,c){c.inline=!0;var d=parseTableHeader(a,b,c),e=parseTableAlign(a,b,c),f=parseTableCells(a,b,c);return c.inline=!1,{align:e,cells:f,header:d,type:'table'}}function getTableStyle(a,b){return a.align[b]==null?{}:{textAlign:a.align[b]}}function normalizeAttributeKey(a){var b=a.indexOf('-');return b!==-1&&a.match(HTML_CUSTOM_ATTR_R)===null&&(a=a.replace(CAPTURE_LETTER_AFTER_HYPHEN,function(a,b){return b.toUpperCase()})),a}function attributeValueToJSXPropValue(a,b){return a==='style'?b.split(/;\s?/).reduce(function(a,b){var c=b.slice(0,b.indexOf(':')),d=c.replace(/(-[a-z])/g,function(a){return a[1].toUpperCase()});return a[d]=b.slice(c.length+1).trim(),a},{}):(b.match(INTERPOLATION_R)&&(b=b.slice(1,b.length-1)),b==='true'||b!=='false'&&b)}function normalizeWhitespace(a){return a.replace(CR_NEWLINE_R,'\n').replace(FORMFEED_R,'').replace(TAB_R,'    ')}function parserFor(a){function b(d,e){for(var f=[],g='';d;)for(var l=0;l<c.length;){var h=c[l],j=a[h],k=j.match(d,e,g);if(k){var i=k[0];d=d.substring(i.length);var m=j.parse(k,b,e);m.type==null&&(m.type=h),f.push(m),g=i;break}l++}return f}var c=Object.keys(a);return "production"!=='production'&&c.forEach(function(b){var c=a[b].order;"production"==='production'||typeof c=='number'&&isFinite(c)||console.warn('markdown-to-jsx: Invalid order for rule `'+b+'`: '+c)}),c.sort(function(b,c){var d=a[b].order,e=a[c].order;return d===e?b<c?-1:1:d-e}),function(a,c){return b(normalizeWhitespace(a),c)}}function inlineRegex(a){return function(b,c){return c.inline?a.exec(b):null}}function simpleInlineRegex(a){return function(b,c){return c.inline||c.simple?a.exec(b):null}}function blockRegex(a){return function(b,c){return c.inline||c.simple?null:a.exec(b)}}function anyScopeRegex(a){return function(b){return a.exec(b)}}function reactFor(a){return function b(c,d){if(d=d||{},Array.isArray(c)){for(var e=d.key,f=[],g=!1,h=0;h<c.length;h++){d.key=h;var j=b(c[h],d),k=typeof j=='string';k&&g?f[f.length-1]+=j:f.push(j),g=k}return d.key=e,f}return a(c,b,d)}}function sanitizeUrl(a){try{var b=decodeURIComponent(a);if(b.match(/^\s*javascript:/i))return "production"!=='production'&&console.warn('Anchor URL contains an unsafe JavaScript expression, it will not be rendered.',b),null}catch(b){return "production"!=='production'&&console.warn('Anchor URL could not be decoded due to malformed syntax or characters, it will not be rendered.',a),null}return a}function unescapeUrl(a){return a.replace(UNESCAPE_URL_R,'$1')}function parseInline(a,b,c){var d=c.inline||!1,e=c.simple||!1;c.inline=!0,c.simple=!0;var f=a(b,c);return c.inline=d,c.simple=e,f}function parseSimpleInline(a,b,c){var d=c.inline||!1,e=c.simple||!1;c.inline=!1,c.simple=!0;var f=a(b,c);return c.inline=d,c.simple=e,f}function parseBlock(a,b,c){return c.inline=!1,a(b+'\n\n',c)}function parseCaptureInline(a,b,c){return{content:parseInline(b,a[1],c)}}function captureNothing(){return{}}function renderNothing(){return null}function ruleOutput(a){return function(b,c,d){return a[b.type].react(b,c,d)}}function cx(){for(var a=arguments.length,b=Array(a),c=0;c<a;c++)b[c]=arguments[c];return b.filter(Boolean).join(' ')}function get(a,b,c){for(var d=a,e=b.split('.');e.length&&(d=d[e[0]],d!==void 0);)e.shift();return d||c}function getTag(a,b){var c=get(b,a);return c?typeof c=='function'||(typeof c=='undefined'?'undefined':_typeof(c))==='object'&&'render'in c?c:get(b,a+'.component',a):a}var PARSE_PRIORITY_MAX=1,PARSE_PRIORITY_HIGH=2,PARSE_PRIORITY_MED=3,PARSE_PRIORITY_LOW=4,PARSE_PRIORITY_MIN=5;function compiler(a,b){function d(a,c){for(var d=get(b.overrides,a+'.props',{}),e=arguments.length,g=Array(e>2?e-2:0),h=2;h<e;h++)g[h-2]=arguments[h];return f.apply(void 0,[getTag(a,b.overrides),_extends({},d,c,{className:cx(c&&c.className,d.className)||void 0})].concat(g))}function c(a){var c=!1;b.forceInline?c=!0:!b.forceBlock&&(c=SHOULD_RENDER_AS_BLOCK_R.test(a)===!1);var e=k(j(c?a:a.replace(TRIM_NEWLINES_AND_TRAILING_WHITESPACE_R,'')+'\n\n',{inline:c})),f=void 0;return e.length>1?f=c?d('span',null,e):d('div',null,e):e.length===1?(f=e[0],typeof f=='string'&&(f=d('span',null,f))):f=d('span',null),f}function e(a){var b=a.match(ATTR_EXTRACTOR_R);return b?b.reduce(function(a,b,d){var e=b.indexOf('=');if(e!==-1){var f=normalizeAttributeKey(b.slice(0,e)).trim(),g=__WEBPACK_IMPORTED_MODULE_1_unquote___default()(b.slice(e+1).trim()),h=ATTRIBUTE_TO_JSX_PROP_MAP[f]||f,i=a[h]=attributeValueToJSXPropValue(f,g);(HTML_BLOCK_ELEMENT_R.test(i)||HTML_SELF_CLOSING_ELEMENT_R.test(i))&&(a[h]=__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(c(i.trim()),{key:d}))}else a[ATTRIBUTE_TO_JSX_PROP_MAP[b]||b]=!0;return a},{}):void 0}b=b||{},b.overrides=b.overrides||{},b.slugify=b.slugify||slugify;var f=b.createElement||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement;if(false){if(typeof a!='string')throw new Error('markdown-to-jsx: the first argument must be\n                             a string');if(Object.prototype.toString.call(b.overrides)!=='[object Object]')throw new Error('markdown-to-jsx: options.overrides (second argument property) must be\n                             undefined or an object literal with shape:\n                             {\n                                htmltagname: {\n                                    component: string|ReactComponent(optional),\n                                    props: object(optional)\n                                }\n                             }')}var g=[],h={},i={blockQuote:{match:blockRegex(BLOCKQUOTE_R),order:PARSE_PRIORITY_HIGH,parse:function d(a,b,c){return{content:b(a[0].replace(BLOCKQUOTE_TRIM_LEFT_MULTILINE_R,''),c)}},react:function e(a,b,c){return d('blockquote',{key:c.key},b(a.content,c))}},breakLine:{match:anyScopeRegex(BREAK_LINE_R),order:PARSE_PRIORITY_HIGH,parse:captureNothing,react:function e(a,b,c){return d('br',{key:c.key})}},breakThematic:{match:blockRegex(BREAK_THEMATIC_R),order:PARSE_PRIORITY_HIGH,parse:captureNothing,react:function e(a,b,c){return d('hr',{key:c.key})}},codeBlock:{match:blockRegex(CODE_BLOCK_R),order:PARSE_PRIORITY_MAX,parse:function c(a){var b=a[0].replace(/^ {4}/gm,'').replace(/\n+$/,'');return{content:b,lang:void 0}},react:function e(a,b,c){return d('pre',{key:c.key},d('code',{className:a.lang?'lang-'+a.lang:''},a.content))}},codeFenced:{match:blockRegex(CODE_BLOCK_FENCED_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return{content:a[3],lang:a[2]||void 0,type:'codeBlock'}}},codeInline:{match:simpleInlineRegex(CODE_INLINE_R),order:PARSE_PRIORITY_LOW,parse:function b(a){return{content:a[2]}},react:function e(a,b,c){return d('code',{key:c.key},a.content)}},footnote:{match:blockRegex(FOOTNOTE_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return g.push({footnote:a[2],identifier:a[1]}),{}},react:renderNothing},footnoteReference:{match:inlineRegex(FOOTNOTE_REFERENCE_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return{content:a[1],target:'#'+a[1]}},react:function e(a,b,c){return d('a',{key:c.key,href:sanitizeUrl(a.target)},d('sup',{key:c.key},a.content))}},gfmTask:{match:inlineRegex(GFM_TASK_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return{completed:a[1].toLowerCase()==='x'}},react:function e(a,b,c){return d('input',{checked:a.completed,key:c.key,readOnly:!0,type:'checkbox'})}},heading:{match:blockRegex(HEADING_R),order:PARSE_PRIORITY_HIGH,parse:function e(a,c,d){return{content:parseInline(c,a[2],d),id:b.slugify(a[2]),level:a[1].length}},react:function f(a,b,c){var e='h'+a.level;return d(e,{id:a.id,key:c.key},b(a.content,c))}},headingSetext:{match:blockRegex(HEADING_SETEXT_R),order:PARSE_PRIORITY_MAX,parse:function d(a,b,c){return{content:parseInline(b,a[1],c),level:a[2]==='='?1:2,type:'heading'}}},htmlBlock:{match:anyScopeRegex(HTML_BLOCK_ELEMENT_R),order:PARSE_PRIORITY_HIGH,parse:function k(a,b,c){var d=a[3].match(HTML_LEFT_TRIM_AMOUNT_R),f=d[1],g=new RegExp('^'+f,'gm'),h=a[3].replace(g,''),i=containsBlockSyntax(h)?parseBlock:parseInline,j=DO_NOT_PROCESS_HTML_ELEMENTS.indexOf(a[1])!==-1;return{attrs:e(a[2]),content:j?a[3]:i(b,h,c),noInnerParse:j,tag:a[1]}},react:function e(a,b,c){return d(a.tag,_extends({key:c.key},a.attrs),a.noInnerParse?a.content:b(a.content,c))}},htmlComment:{match:anyScopeRegex(HTML_COMMENT_R),order:PARSE_PRIORITY_HIGH,parse:function a(){return{}},react:renderNothing},htmlSelfClosing:{match:anyScopeRegex(HTML_SELF_CLOSING_ELEMENT_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return{attrs:e(a[2]||''),tag:a[1]}},react:function e(a,b,c){return d(a.tag,_extends({},a.attrs,{key:c.key}))}},image:{match:simpleInlineRegex(IMAGE_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return{alt:a[1],target:unescapeUrl(a[2]),title:a[3]}},react:function e(a,b,c){return d('img',{key:c.key,alt:a.alt||void 0,title:a.title||void 0,src:sanitizeUrl(a.target)})}},link:{match:inlineRegex(LINK_R,!1),order:PARSE_PRIORITY_LOW,parse:function d(a,b,c){return{content:parseSimpleInline(b,a[1],c),target:unescapeUrl(a[2]),title:a[3]}},react:function e(a,b,c){return d('a',{key:c.key,href:sanitizeUrl(a.target),title:a.title},b(a.content,c))}},linkAngleBraceStyleDetector:{match:inlineRegex(LINK_AUTOLINK_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return{content:[{content:a[1],type:'text'}],target:a[1],type:'link'}}},linkBareUrlDetector:{match:inlineRegex(LINK_AUTOLINK_BARE_URL_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return{content:[{content:a[1],type:'text'}],target:a[1],title:void 0,type:'link'}}},linkMailtoDetector:{match:inlineRegex(LINK_AUTOLINK_MAILTO_R),order:PARSE_PRIORITY_MAX,parse:function d(a){var b=a[1],c=a[1];return AUTOLINK_MAILTO_CHECK_R.test(c)||(c='mailto:'+c),{content:[{content:b.replace('mailto:',''),type:'text'}],target:c,type:'link'}}},list:{match:function f(a,b,c){var d=LIST_LOOKBEHIND_R.exec(c),e=b._list||!b.inline;return d&&e?(a=d[1]+a,LIST_R.exec(a)):null},order:PARSE_PRIORITY_HIGH,parse:function j(a,b,c){var d=a[2],e=d.length>1,f=e?+d:void 0,g=a[0].replace(BLOCK_END_R,'\n').match(LIST_ITEM_R),h=!1,i=g.map(function(a,d){var e=LIST_ITEM_PREFIX_R.exec(a)[0].length,f=new RegExp('^ {1,'+e+'}','gm'),i=a.replace(f,'').replace(LIST_ITEM_PREFIX_R,''),j=d===g.length-1,k=i.indexOf('\n\n')!==-1,l=k||j&&h;h=l;var m=c.inline,n=c._list;c._list=!0;var o;l?(c.inline=!1,o=i.replace(LIST_ITEM_END_R,'\n\n')):(c.inline=!0,o=i.replace(LIST_ITEM_END_R,''));var p=b(o,c);return c.inline=m,c._list=n,p});return{items:i,ordered:e,start:f}},react:function f(a,b,c){var e=a.ordered?'ol':'ul';return d(e,{key:c.key,start:a.start},a.items.map(function(a,e){return d('li',{key:e},b(a,c))}))}},newlineCoalescer:{match:blockRegex(CONSECUTIVE_NEWLINE_R),order:PARSE_PRIORITY_LOW,parse:captureNothing,react:function a(){return'\n'}},paragraph:{match:blockRegex(PARAGRAPH_R),order:PARSE_PRIORITY_LOW,parse:parseCaptureInline,react:function e(a,b,c){return d('p',{key:c.key},b(a.content,c))}},ref:{match:inlineRegex(REFERENCE_IMAGE_OR_LINK),order:PARSE_PRIORITY_MAX,parse:function b(a){return h[a[1]]={target:a[2],title:a[4]},{}},react:renderNothing},refImage:{match:simpleInlineRegex(REFERENCE_IMAGE_R),order:PARSE_PRIORITY_MAX,parse:function b(a){return{alt:a[1]||void 0,ref:a[2]}},react:function e(a,b,c){return d('img',{key:c.key,alt:a.alt,src:sanitizeUrl(h[a.ref].target),title:h[a.ref].title})}},refLink:{match:inlineRegex(REFERENCE_LINK_R),order:PARSE_PRIORITY_MAX,parse:function d(a,b,c){return{content:b(a[1],c),fallbackContent:b(a[0].replace(SQUARE_BRACKETS_R,'\\$1'),c),ref:a[2]}},react:function e(a,b,c){return h[a.ref]?d('a',{key:c.key,href:sanitizeUrl(h[a.ref].target),title:h[a.ref].title},b(a.content,c)):d('span',null,b(a.fallbackContent,c))}},table:{match:blockRegex(NP_TABLE_R),order:PARSE_PRIORITY_HIGH,parse:parseTable,react:function f(a,b,e){return d('table',{key:e.key},d('thead',null,d('tr',null,a.header.map(function(c,f){return d('th',{key:f,style:getTableStyle(a,f)},b(c,e))}))),d('tbody',null,a.cells.map(function(c,f){return d('tr',{key:f},c.map(function(f,g){return d('td',{key:g,style:getTableStyle(a,g)},b(f,e))}))})))}},text:{match:anyScopeRegex(TEXT_PLAIN_R),order:PARSE_PRIORITY_MIN,parse:function b(a){return{content:a[0].replace(HTML_CHAR_CODE_R,function(a,b){return namedCodesToUnicode[b]?namedCodesToUnicode[b]:a})}},react:function b(a){return a.content}},textBolded:{match:simpleInlineRegex(TEXT_BOLD_R),order:PARSE_PRIORITY_MED,parse:function d(a,b,c){return{content:b(a[2],c)}},react:function e(a,b,c){return d('strong',{key:c.key},b(a.content,c))}},textEmphasized:{match:simpleInlineRegex(TEXT_EMPHASIZED_R),order:PARSE_PRIORITY_LOW,parse:function d(a,b,c){return{content:b(a[2],c)}},react:function e(a,b,c){return d('em',{key:c.key},b(a.content,c))}},textEscaped:{match:simpleInlineRegex(TEXT_ESCAPED_R),order:PARSE_PRIORITY_HIGH,parse:function b(a){return{content:a[1],type:'text'}}},textStrikethroughed:{match:simpleInlineRegex(TEXT_STRIKETHROUGHED_R),order:PARSE_PRIORITY_LOW,parse:parseCaptureInline,react:function e(a,b,c){return d('del',{key:c.key},b(a.content,c))}}},j=parserFor(i),k=reactFor(ruleOutput(i)),l=c(a);return g.length&&l.props.children.push(d('footer',null,g.map(function(a){return d('div',{id:a.identifier,key:a.identifier},a.identifier,k(j(a.footnote,{inline:!0})))}))),l}function Markdown(a){var b=a.children,c=a.options,d=_objectWithoutProperties(a,['children','options']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(compiler(b,c),d)}if(false){var PropTypes=require('prop-types');Markdown.propTypes={children:PropTypes.string.isRequired,options:PropTypes.object}}

//# sourceMappingURL=esm.js.map

/***/ }),
/* 474 */
/***/ (function(module, exports) {

var reg = /[\'\"]/

module.exports = function unquote(str) {
  if (!str) {
    return ''
  }
  if (reg.test(str.charAt(0))) {
    str = str.substr(1)
  }
  if (reg.test(str.charAt(str.length - 1))) {
    str = str.substr(0, str.length - 1)
  }
  return str
}


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParagraphWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledParagraph__ = __webpack_require__(476);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Paragraph = function Paragraph(_ref) {
  var color = _ref.color,
      rest = _objectWithoutPropertiesLoose(_ref, ["color"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StyledParagraph__["a" /* StyledParagraph */], _extends({
    colorProp: color
  }, rest));
};

var ParagraphDoc;

if (false) {
  ParagraphDoc = require('./doc').doc(Paragraph); // eslint-disable-line global-require
}

var ParagraphWrapper = ParagraphDoc || Paragraph;


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledParagraph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var colorStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["color:", ";"], function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.colorProp, props.theme);
});

var sizeStyle = function sizeStyle(props) {
  var size = props.size || 'medium';
  var data = props.theme.paragraph[size];
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-size:", ";line-height:", ";max-width:", ";"], data.size, data.height, data.maxWidth);
};

var TEXT_ALIGN_MAP = {
  center: 'center',
  end: 'right',
  start: 'left'
};
var textAlignStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["text-align:", ";"], function (props) {
  return TEXT_ALIGN_MAP[props.textAlign];
});
var StyledParagraph = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].p.withConfig({
  displayName: "StyledParagraph",
  componentId: "tbetod-0"
})(["", " ", " ", " ", " ", ""], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return sizeStyle(props);
}, function (props) {
  return props.textAlign && textAlignStyle;
}, function (props) {
  return props.colorProp && colorStyle;
}, function (props) {
  return props.theme.paragraph && props.theme.paragraph.extend;
});
StyledParagraph.defaultProps = {};
Object.setPrototypeOf(StyledParagraph.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MaskedInput__ = __webpack_require__(478);
/* unused harmony reexport MaskedInput */


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MaskedInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contexts__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Drop__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Keyboard__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StyledMaskedInput__ = __webpack_require__(479);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var parseValue = function parseValue(mask, value) {
  // break the value up into mask parts
  var valueParts = []; // { part, beginIndex, endIndex }

  var valueIndex = 0;
  var maskIndex = 0;

  while (value !== undefined && valueIndex < value.length && maskIndex < mask.length) {
    var item = mask[maskIndex];
    var found = void 0;

    if (item.fixed) {
      var length = item.fixed.length;
      valueParts.push({
        part: item.fixed,
        beginIndex: valueIndex,
        endIndex: valueIndex + length - 1
      });
      var part = value.slice(valueIndex, valueIndex + length);

      if (part === item.fixed) {
        valueIndex += length;
      }

      maskIndex += 1;
      found = true;
    } else if (item.options) {
      // reverse assuming larger is later
      found = item.options.slice(0).reverse() // eslint-disable-next-line no-loop-func
      .some(function (option) {
        var length = option.length;
        var part = value.slice(valueIndex, valueIndex + length);

        if (part === option) {
          valueParts.push({
            part: part,
            beginIndex: valueIndex,
            endIndex: valueIndex + length - 1
          });
          valueIndex += length;
          maskIndex += 1;
          return true;
        }

        return false;
      });
    }

    if (!found) {
      if (item.regexp) {
        var minLength = Array.isArray(item.length) && item.length[0] || item.length || 1;
        var maxLength = Array.isArray(item.length) && item.length[1] || item.length || value.length - valueIndex;
        var _length = maxLength;

        while (!found && _length >= minLength) {
          var _part = value.slice(valueIndex, valueIndex + _length);

          if (item.regexp.test(_part)) {
            valueParts.push({
              part: _part,
              beginIndex: valueIndex,
              endIndex: valueIndex + _length - 1
            });
            valueIndex += _length;
            maskIndex += 1;
            found = true;
          }

          _length -= 1;
        }

        if (!found) {
          valueIndex = value.length;
        }
      } else {
        var _length2 = Array.isArray(item.length) ? item.length[1] : item.length || value.length - valueIndex;

        var _part2 = value.slice(valueIndex, valueIndex + _length2);

        valueParts.push({
          part: _part2,
          beginIndex: valueIndex,
          endIndex: valueIndex + _length2 - 1
        });
        valueIndex += _length2;
        maskIndex += 1;
      }
    }
  }

  return valueParts;
};

var MaskedInput =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(MaskedInput, _Component);

  function MaskedInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dropRef", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "locateCaret", function () {
      // leave time for caret to be placed after receiving focus
      clearTimeout(_this.caretTimeout);
      _this.caretTimeout = setTimeout(function () {
        var mask = _this.props.mask;
        var _this$state = _this.state,
            activeMaskIndex = _this$state.activeMaskIndex,
            valueParts = _this$state.valueParts;

        if (_this.inputRef.current) {
          // determine which mask element the caret is at
          var caretIndex = _this.inputRef.current.selectionStart;
          var maskIndex;
          valueParts.some(function (part, index) {
            if (part.beginIndex <= caretIndex && part.endIndex >= caretIndex) {
              maskIndex = index;
              return true;
            }

            return false;
          });

          if (maskIndex === undefined && valueParts.length < mask.length) {
            maskIndex = valueParts.length; // first unused one
          }

          if (maskIndex && mask[maskIndex].fixed) {
            maskIndex -= 1; // fixed mask parts are never "active"
          }

          if (activeMaskIndex !== maskIndex) {
            // eslint-disable-next-line react/no-did-update-set-state
            _this.setState({
              activeMaskIndex: maskIndex,
              activeOptionIndex: -1
            });
          }
        }
      }, 10); // 10ms empirically chosen
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFocus", function (event) {
      var onFocus = _this.props.onFocus;

      _this.locateCaret();

      _this.setState({
        focused: true
      });

      if (onFocus) {
        onFocus(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onBlur", function () {
      // delay so we don't remove the drop before Button events can be processed
      clearTimeout(_this.blurTimeout);
      _this.blurTimeout = setTimeout(function () {
        if (!_this.dropRef.current || !_this.dropRef.current.contains || !_this.dropRef.current.contains(document.activeElement)) {
          _this.setState({
            activeMaskIndex: undefined,
            focused: false
          });
        }
      }, 10); // 10ms empirically chosen
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          mask = _this$props.mask;
      var value = event.target.value; // Align with the mask.

      var valueParts = parseValue(mask, value);
      var nextValue = valueParts.map(function (part) {
        return part.part;
      }).join('');

      if (onChange) {
        onChange({
          target: _extends({}, event.target, {
            value: nextValue
          })
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOption", function (option) {
      return function () {
        var _this$props2 = _this.props,
            onChange = _this$props2.onChange,
            mask = _this$props2.mask;
        var _this$state2 = _this.state,
            activeMaskIndex = _this$state2.activeMaskIndex,
            valueParts = _this$state2.valueParts;
        var nextValueParts = valueParts.concat();
        nextValueParts[activeMaskIndex] = {
          part: option
        }; // add any fixed parts that follow

        var index = activeMaskIndex + 1;

        while (index < mask.length && !nextValueParts[index] && mask[index].fixed) {
          nextValueParts[index] = {
            part: mask[index].fixed
          };
          index += 1;
        }

        var nextValue = nextValueParts.map(function (part) {
          return part.part;
        }).join(''); // restore focus to input

        _this.inputRef.current.focus();

        if (onChange) {
          onChange({
            target: {
              value: nextValue
            }
          });
        }
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onNextOption", function (event) {
      var mask = _this.props.mask;
      var _this$state3 = _this.state,
          activeMaskIndex = _this$state3.activeMaskIndex,
          activeOptionIndex = _this$state3.activeOptionIndex;
      var item = mask[activeMaskIndex];

      if (item && item.options) {
        event.preventDefault();
        var index = Math.min(activeOptionIndex + 1, item.options.length - 1);

        _this.setState({
          activeOptionIndex: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onPreviousOption", function (event) {
      var mask = _this.props.mask;
      var _this$state4 = _this.state,
          activeMaskIndex = _this$state4.activeMaskIndex,
          activeOptionIndex = _this$state4.activeOptionIndex;

      if (activeMaskIndex >= 0 && mask[activeMaskIndex].options) {
        event.preventDefault();
        var index = Math.max(activeOptionIndex - 1, 0);

        _this.setState({
          activeOptionIndex: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSelectOption", function (event) {
      var mask = _this.props.mask;
      var _this$state5 = _this.state,
          activeMaskIndex = _this$state5.activeMaskIndex,
          activeOptionIndex = _this$state5.activeOptionIndex;

      if (activeMaskIndex >= 0 && activeOptionIndex >= 0) {
        event.preventDefault();
        var option = mask[activeMaskIndex].options[activeOptionIndex];

        _this.onOption(option)();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onEsc", function (event) {
      // we have to stop both synthetic events and native events
      // drop and layer should not close by pressing esc on this input
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();

      _this.inputRef.current.blur();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderPlaceholder", function () {
      var mask = _this.props.mask;
      return mask.map(function (item) {
        return item.placeholder || item.fixed;
      }).join('');
    });

    return _this;
  }

  MaskedInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var mask = nextProps.mask,
        value = nextProps.value;
    var priorMask = prevState.priorMask,
        priorValue = prevState.priorValue;

    if (priorMask !== mask || priorValue !== value) {
      var valueParts = parseValue(mask, value);
      return {
        priorMask: mask,
        priorValue: value,
        valueParts: valueParts
      };
    }

    return null;
  };

  var _proto = MaskedInput.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var focused = this.state.focused;

    if (focused) {
      this.locateCaret();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.caretTimeout);
    clearTimeout(this.blurTimeout);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        defaultValue = _this$props3.defaultValue,
        forwardRef = _this$props3.forwardRef,
        id = _this$props3.id,
        placeholder = _this$props3.placeholder,
        plain = _this$props3.plain,
        mask = _this$props3.mask,
        value = _this$props3.value,
        onChange = _this$props3.onChange,
        onKeyDown = _this$props3.onKeyDown,
        propsTheme = _this$props3.theme,
        rest = _objectWithoutPropertiesLoose(_this$props3, ["defaultValue", "forwardRef", "id", "placeholder", "plain", "mask", "value", "onChange", "onKeyDown", "theme"]);

    var theme = this.context || propsTheme;
    var _this$state6 = this.state,
        activeMaskIndex = _this$state6.activeMaskIndex,
        activeOptionIndex = _this$state6.activeOptionIndex;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__StyledMaskedInput__["b" /* StyledMaskedInputContainer */], {
      plain: plain
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Keyboard__["a" /* Keyboard */], {
      onEsc: this.onEsc,
      onTab: this.onTab,
      onLeft: this.locateCaret,
      onRight: this.locateCaret,
      onUp: this.onPreviousOption,
      onDown: this.onNextOption,
      onEnter: this.onSelectOption,
      onKeyDown: onKeyDown
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__StyledMaskedInput__["a" /* StyledMaskedInput */], _extends({
      id: id,
      ref: function ref(node) {
        _this2.inputRef.current = node;

        if (forwardRef) {
          if (typeof forwardRef === 'object') {
            forwardRef.current = node;
          } else {
            forwardRef(node);
          }
        }
      },
      autoComplete: "off",
      plain: plain,
      placeholder: placeholder || this.renderPlaceholder()
    }, rest, {
      defaultValue: defaultValue,
      value: value,
      theme: theme,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onChange: this.onChange
    }))), activeMaskIndex >= 0 && mask[activeMaskIndex].options && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Drop__["a" /* Drop */], {
      id: id ? "masked-input-drop__" + id : undefined,
      align: {
        top: 'bottom',
        left: 'left'
      },
      responsive: false,
      target: this.inputRef.current
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
      ref: this.dropRef
    }, mask[activeMaskIndex].options.map(function (option, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
        key: option,
        flex: false
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* Button */], {
        tabIndex: "-1",
        onClick: _this2.onOption(option),
        onMouseOver: function onMouseOver() {
          return _this2.setState({
            activeOptionIndex: index
          });
        },
        onFocus: function onFocus() {}
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
        pad: {
          horizontal: 'small',
          vertical: 'xsmall'
        },
        background: activeOptionIndex === index ? 'active' : undefined
      }, option)));
    }))));
  };

  return MaskedInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MaskedInput, "contextType", __WEBPACK_IMPORTED_MODULE_2__contexts__["c" /* ThemeContext */]);

_defineProperty(MaskedInput, "defaultProps", {
  mask: []
});

Object.setPrototypeOf(MaskedInput.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var MaskedInputDoc;

if (false) {
  MaskedInputDoc = require('./doc').doc(MaskedInput); // eslint-disable-line global-require
}

var MaskedInputWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_8__hocs__["c" /* withFocus */], __WEBPACK_IMPORTED_MODULE_8__hocs__["d" /* withForwardRef */])(MaskedInputDoc || MaskedInput);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledMaskedInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledMaskedInputContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);



var sizeStyle = function sizeStyle(props) {
  var data = props.theme.text[props.size];
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["font-size:", ";line-height:", ";"], data.size, data.height);
};

var plainStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border:none;"]);
var StyledMaskedInput = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].input.withConfig({
  displayName: "StyledMaskedInput",
  componentId: "sc-99vkfa-0"
})(["", " width:100%;", " ", " ", " &::-moz-focus-inner{border:none;outline:none;}", ";", ";"], __WEBPACK_IMPORTED_MODULE_1__utils__["v" /* inputStyle */], function (props) {
  return props.size && sizeStyle(props);
}, function (props) {
  return props.plain && plainStyle;
}, __WEBPACK_IMPORTED_MODULE_1__utils__["E" /* placeholderStyle */], function (props) {
  return props.focus && !props.plain && __WEBPACK_IMPORTED_MODULE_1__utils__["p" /* focusStyle */];
}, function (props) {
  return props.theme.MaskedInput && props.theme.MaskedInput.extend;
});
var StyledMaskedInputContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledMaskedInput__StyledMaskedInputContainer",
  componentId: "sc-99vkfa-1"
})(["position:relative;width:100%;"]);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DropButton__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Keyboard__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(5);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var ContainerBox = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */]).withConfig({
  displayName: "Menu__ContainerBox",
  componentId: "sc-17fcys9-0"
})(["max-height:inherit;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}", ";"], function (props) {
  return props.theme.menu.extend;
});

var Menu =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Menu, _Component);

  function Menu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      activeItemIndex: -1,
      open: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "buttonRefs", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropClose", function () {
      _this.setState({
        activeItemIndex: -1,
        open: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSelectMenuItem", function (event) {
      var activeItemIndex = _this.state.activeItemIndex;

      if (activeItemIndex >= 0) {
        event.preventDefault();
        event.stopPropagation();

        _this.buttonRefs[activeItemIndex].click();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onNextMenuItem", function (event) {
      event.preventDefault();
      var _this$state = _this.state,
          activeItemIndex = _this$state.activeItemIndex,
          open = _this$state.open;

      if (!open) {
        _this.setState({
          open: true,
          activeItemIndex: -1
        });
      } else {
        var items = _this.props.items;
        var index = Math.min(activeItemIndex + 1, items.length - 1);

        _this.setState({
          activeItemIndex: index
        }); // this.setState({ activeSuggestionIndex: index },
        //   this._announceSuggestion.bind(this, index));

      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onPreviousMenuItem", function (event) {
      event.preventDefault();
      var _this$state2 = _this.state,
          activeItemIndex = _this$state2.activeItemIndex,
          open = _this$state2.open;

      if (!open) {
        _this.setState({
          open: true,
          activeItemIndex: -1
        });
      } else {
        var items = _this.props.items;
        var index = activeItemIndex === -1 ? items.length - 1 : Math.max(activeItemIndex - 1, 0);

        _this.setState({
          activeItemIndex: index
        }); // this.setState({ activeSuggestionIndex: index },
        //   this._announceSuggestion.bind(this, index));

      }
    });

    return _this;
  }

  var _proto = Menu.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        disabled = _this$props.disabled,
        dropAlign = _this$props.dropAlign,
        dropBackground = _this$props.dropBackground,
        dropTarget = _this$props.dropTarget,
        forwardRef = _this$props.forwardRef,
        icon = _this$props.icon,
        items = _this$props.items,
        label = _this$props.label,
        messages = _this$props.messages,
        onKeyDown = _this$props.onKeyDown,
        size = _this$props.size,
        theme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["children", "disabled", "dropAlign", "dropBackground", "dropTarget", "forwardRef", "icon", "items", "label", "messages", "onKeyDown", "size", "theme"]);

    var _this$state3 = this.state,
        activeItemIndex = _this$state3.activeItemIndex,
        open = _this$state3.open;
    var MenuIcon = theme.menu.icons.down;
    var iconColor = Object(__WEBPACK_IMPORTED_MODULE_10__utils__["B" /* normalizeColor */])('control', theme);
    var content = children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
      direction: "row",
      justify: "start",
      align: "center",
      pad: "small",
      gap: label && icon !== false ? 'small' : undefined
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Text__["a" /* Text */], {
      size: size
    }, label), icon !== false ? icon !== true && icon || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuIcon, {
      color: iconColor,
      size: size
    }) : null);
    var controlMirror = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
      flex: false
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* Button */], {
      a11yTitle: messages.closeMenu || 'Close Menu',
      onClick: this.onDropClose
    }, content));
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Keyboard__["a" /* Keyboard */], {
      onEnter: this.onSelectMenuItem,
      onSpace: this.onSelectMenuItem,
      onDown: this.onNextMenuItem,
      onUp: this.onPreviousMenuItem,
      onEsc: this.onDropClose,
      onTab: this.onDropClose,
      onKeyDown: onKeyDown
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DropButton__["a" /* DropButton */], _extends({
      ref: forwardRef
    }, rest, {
      a11yTitle: messages.openMenu || 'Open Menu',
      disabled: disabled,
      dropAlign: dropAlign,
      dropTarget: dropTarget,
      open: open,
      onOpen: function onOpen() {
        return _this2.setState({
          open: true
        });
      },
      onClose: function onClose() {
        return _this2.setState({
          open: false
        });
      },
      dropContent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContainerBox, {
        background: dropBackground || theme.menu.background
      }, dropAlign.top === 'top' ? controlMirror : undefined, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
        overflow: "auto"
      }, items.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
          key: "menuItem_" + (index + 0),
          flex: false
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* Button */], {
          ref: function ref(_ref) {
            _this2.buttonRefs[index] = _ref;
          },
          active: activeItemIndex === index,
          hoverIndicator: "background",
          disabled: !item.onClick && !item.href,
          onClick: function onClick() {
            item.onClick.apply(item, arguments);

            if (item.close !== false) {
              _this2.onDropClose();
            }
          },
          href: item.href
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
          align: "start",
          pad: "small",
          direction: "row"
        }, item.icon, item.label)));
      })), dropAlign.bottom === 'bottom' ? controlMirror : undefined)
    }), content));
  };

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Menu, "defaultProps", {
  dropAlign: {
    top: 'top',
    left: 'left'
  },
  items: [],
  messages: {
    openMenu: 'Open Menu',
    closeMenu: 'Close Menu'
  }
});

Object.setPrototypeOf(Menu.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var MenuDoc;

if (false) {
  MenuDoc = require('./doc').doc(Menu); // eslint-disable-line global-require
}

var MenuWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */], __WEBPACK_IMPORTED_MODULE_9__hocs__["d" /* withForwardRef */])(MenuDoc || Menu);


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MeterWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Bar__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(483);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var deriveMax = function deriveMax(values) {
  var max = 100;

  if (values && values.length > 1) {
    max = 0;
    values.forEach(function (v) {
      max += v.value;
    });
  }

  return max;
};

var Meter =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Meter, _Component);

  function Meter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    return _this;
  }

  Meter.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var max = prevState.max;
    var nextMax = deriveMax(nextProps.values);

    if (!max || nextMax !== max) {
      return {
        max: nextMax
      };
    }

    return null;
  };

  var _proto = Meter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        type = _this$props.type,
        rest = _objectWithoutPropertiesLoose(_this$props, ["type"]);

    var max = this.state.max;
    var content;

    if (type === 'bar') {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Bar__["a" /* Bar */], _extends({
        max: max
      }, rest));
    } else if (type === 'circle') {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* Circle */], _extends({
        max: max
      }, rest));
    }

    return content;
  };

  return Meter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Meter, "defaultProps", {
  background: {
    color: 'light-2',
    opacity: 'medium'
  },
  size: 'medium',
  thickness: 'medium',
  type: 'bar'
});

var MeterDoc;

if (false) {
  MeterDoc = require('./doc').doc(Meter); // eslint-disable-line global-require
}

var MeterWrapper = MeterDoc || Meter;


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BarWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StyledMeter__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(193);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }









var Bar = function Bar(props) {
  var background = props.background,
      max = props.max,
      round = props.round,
      size = props.size,
      theme = props.theme,
      thickness = props.thickness,
      values = props.values,
      rest = _objectWithoutPropertiesLoose(props, ["background", "max", "round", "size", "theme", "thickness", "values"]);

  var width = size === 'full' ? 288 : Object(__WEBPACK_IMPORTED_MODULE_4__utils__["D" /* parseMetricToNum */])(theme.global.size[size]);
  var height = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["D" /* parseMetricToNum */])(theme.global.edgeSize[thickness]); // account for the round cap, if any

  var capOffset = round ? height / 2 : 0;
  var mid = height / 2;
  var someHighlight = (values || []).some(function (v) {
    return v.highlight;
  });
  var start = capOffset;
  var paths = (values || []).filter(function (v) {
    return v.value > 0;
  }).map(function (valueArg, index) {
    var color = valueArg.color,
        highlight = valueArg.highlight,
        label = valueArg.label,
        onHover = valueArg.onHover,
        value = valueArg.value,
        pathRest = _objectWithoutPropertiesLoose(valueArg, ["color", "highlight", "label", "onHover", "value"]);

    var key = "p-" + index;
    var delta = value * (width - 2 * capOffset) / max;
    var d = "M " + start + "," + mid + " L " + (start + delta) + "," + mid;
    var colorName = color || (index === values.length - 1 ? 'accent-1' : Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* defaultColor */])(index, theme));
    var hoverProps;

    if (onHover) {
      hoverProps = {
        onMouseOver: function onMouseOver() {
          return onHover(true);
        },
        onMouseLeave: function onMouseLeave() {
          return onHover(false);
        }
      };
    }

    start += delta;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({
      key: key,
      d: d,
      fill: "none"
    }, Object(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* strokeProps */])(someHighlight && !highlight ? background : colorName, theme), {
      strokeWidth: height,
      strokeLinecap: round ? 'round' : 'butt'
    }, hoverProps, pathRest));
  }).reverse(); // reverse so the caps looks right

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledMeter__["a" /* StyledMeter */], _extends({
    viewBox: "0 0 " + width + " " + height,
    preserveAspectRatio: "none",
    width: size === 'full' ? '100%' : width,
    height: height,
    round: round ? {
      size: thickness
    } : undefined
  }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({
    d: "M " + capOffset + "," + mid + " L " + (width - capOffset) + "," + mid,
    fill: "none"
  }, Object(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* strokeProps */])(background, theme), {
    strokeWidth: height,
    strokeLinecap: round ? 'round' : 'square'
  })), paths);
};

Bar.defaultProps = {
  background: 'light-1'
};
Object.setPrototypeOf(Bar.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var BarWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(Bar);


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CircleWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StyledMeter__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(193);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }









var Circle = function Circle(props) {
  var background = props.background,
      max = props.max,
      round = props.round,
      size = props.size,
      theme = props.theme,
      thickness = props.thickness,
      values = props.values,
      rest = _objectWithoutPropertiesLoose(props, ["background", "max", "round", "size", "theme", "thickness", "values"]);

  var width = size === 'full' ? 288 : Object(__WEBPACK_IMPORTED_MODULE_4__utils__["D" /* parseMetricToNum */])(theme.global.size[size]);
  var height = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["D" /* parseMetricToNum */])(theme.global.edgeSize[thickness]);
  var mid = width / 2;
  var radius = width / 2 - height / 2;
  var anglePer = 360 / max;
  var someHighlight = (values || []).some(function (v) {
    return v.highlight;
  });
  var startValue = 0;
  var startAngle = 0;
  var paths = [];
  var pathCaps = [];
  (values || []).filter(function (v) {
    return v.value > 0;
  }).forEach(function (valueArg, index) {
    var color = valueArg.color,
        highlight = valueArg.highlight,
        label = valueArg.label,
        onHover = valueArg.onHover,
        value = valueArg.value,
        pathRest = _objectWithoutPropertiesLoose(valueArg, ["color", "highlight", "label", "onHover", "value"]);

    var key = "p-" + index;
    var colorName = color || (index === values.length - 1 ? 'accent-1' : Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* defaultColor */])(index, theme));
    var endAngle;

    if (startValue + value >= max) {
      endAngle = 360;
    } else {
      endAngle = Math.min(360, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["J" /* translateEndAngle */])(startAngle, anglePer, value));
    }

    var hoverProps;

    if (onHover) {
      hoverProps = {
        onMouseOver: function onMouseOver() {
          return onHover(true);
        },
        onMouseLeave: function onMouseLeave() {
          return onHover(false);
        }
      };
    }

    var stroke = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* strokeProps */])(someHighlight && !highlight ? background : colorName, theme);

    if (round) {
      var d1 = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* arcCommands */])(width / 2, width / 2, radius, startAngle, endAngle);
      paths.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({
        key: key,
        d: d1,
        fill: "none"
      }, stroke, {
        strokeWidth: height,
        strokeLinecap: "round"
      }, hoverProps, pathRest))); // To handle situations where the last values are small, redraw
      // a dot at the end. Give just a bit of angle to avoid anti-aliasing
      // leakage around the edge.

      var d2 = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* arcCommands */])(width / 2, width / 2, radius, endAngle - 0.5, endAngle);
      var pathCap = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({
        key: key + "-",
        d: d2,
        fill: "none"
      }, stroke, {
        strokeWidth: height,
        strokeLinecap: "round"
      }, hoverProps, pathRest)); // If we are on a large enough path to not need re-drawing previous ones,
      // clear the pathCaps we've collected already.

      if (endAngle - startAngle > 2 * anglePer) {
        pathCaps = [];
      }

      pathCaps.unshift(pathCap);
    } else {
      var d = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* arcCommands */])(width / 2, width / 2, radius, startAngle, endAngle);
      paths.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({
        key: key,
        d: d,
        fill: "none"
      }, stroke, {
        strokeWidth: height,
        strokeLinecap: "butt"
      }, hoverProps, pathRest)));
    }

    startValue += value;
    startAngle = endAngle;
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledMeter__["a" /* StyledMeter */], _extends({
    viewBox: "0 0 " + width + " " + width,
    width: size === 'full' ? '100%' : width,
    height: size === 'full' ? '100%' : width
  }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", _extends({
    cx: mid,
    cy: mid,
    r: radius
  }, Object(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* strokeProps */])(background, theme), {
    strokeWidth: height,
    strokeLinecap: round ? 'round' : 'square',
    fill: "none"
  })), paths, pathCaps);
};

Circle.defaultProps = {};
Object.setPrototypeOf(Circle.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var CircleWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(Circle);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RadioButton__ = __webpack_require__(485);
/* unused harmony reexport RadioButton */


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RadioButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StyledRadioButton__ = __webpack_require__(486);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }










var RadioButton =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(RadioButton, _Component);

  function RadioButton() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = RadioButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        checked = _this$props.checked,
        disabled = _this$props.disabled,
        focus = _this$props.focus,
        forwardRef = _this$props.forwardRef,
        id = _this$props.id,
        label = _this$props.label,
        name = _this$props.name,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["checked", "disabled", "focus", "forwardRef", "id", "label", "name", "onChange", "theme"]);

    var normalizedLabel = typeof label === 'string' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, label) : label;
    var Icon = theme.radioButton.icons.circle;
    var borderColor = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["B" /* normalizeColor */])(theme.radioButton.border.color, theme);

    if (checked) {
      borderColor = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["B" /* normalizeColor */])(theme.radioButton.color || 'control', theme);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledRadioButton__["c" /* StyledRadioButtonContainer */], _extends({
      as: function as(props) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], _extends({
          as: "label"
        }, props));
      },
      direction: "row",
      align: "center"
    }, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["F" /* removeUndefined */])({
      htmlFor: id,
      disabled: disabled
    }), {
      onClick: function onClick(event) {
        // prevents clicking on the label trigging the event twice
        // https://stackoverflow.com/questions/24501497/why-the-onclick-element-will-trigger-twice-for-label-element
        if (event.target.type !== 'radio') {
          event.stopPropagation();
        }
      }
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledRadioButton__["a" /* StyledRadioButton */], {
      as: __WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */],
      margin: {
        right: theme.radioButton.gap || 'small'
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledRadioButton__["e" /* StyledRadioButtonInput */], _extends({}, rest, {
      ref: forwardRef,
      type: "radio"
    }, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["F" /* removeUndefined */])({
      id: id,
      name: name,
      checked: checked,
      disabled: disabled,
      onChange: onChange
    }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledRadioButton__["b" /* StyledRadioButtonBox */], {
      focus: focus,
      as: __WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */],
      align: "center",
      justify: "center",
      width: theme.radioButton.size,
      height: theme.radioButton.size,
      border: {
        size: theme.radioButton.border.width,
        color: borderColor
      },
      round: theme.radioButton.check.radius
    }, checked && (Icon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, {
      as: __WEBPACK_IMPORTED_MODULE_7__StyledRadioButton__["d" /* StyledRadioButtonIcon */]
    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StyledRadioButton__["d" /* StyledRadioButtonIcon */], {
      viewBox: "0 0 24 24",
      preserveAspectRatio: "xMidYMid meet"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 6
    }))))), normalizedLabel);
  };

  return RadioButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RadioButton.defaultProps = {};
Object.setPrototypeOf(RadioButton.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var RadioButtonDoc;

if (false) {
  RadioButtonDoc = require('./doc').doc(RadioButton); // eslint-disable-line global-require
}

var RadioButtonWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_6__hocs__["c" /* withFocus */], __WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */], __WEBPACK_IMPORTED_MODULE_6__hocs__["d" /* withForwardRef */])(RadioButtonDoc || RadioButton);


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledRadioButtonContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledRadioButtonInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StyledRadioButtonIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledRadioButtonBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledRadioButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var disabledStyle = "\n  opacity: 0.5;\n  cursor: default;\n";
var StyledRadioButtonContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].label.withConfig({
  displayName: "StyledRadioButton__StyledRadioButtonContainer",
  componentId: "g1f6ld-0"
})(["user-select:none;", " ", ":hover input:not([disabled]) + div,:hover input:not([disabled]) + span{border-color:", ";}", ";"], function (props) {
  return props.disabled && disabledStyle;
}, function (props) {
  return !props.disabled && 'cursor: pointer;';
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.radioButton.hover.border.color, props.theme);
}, function (props) {
  return props.theme.radioButton.extend;
});
StyledRadioButtonContainer.defaultProps = {};
Object.setPrototypeOf(StyledRadioButtonContainer.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledRadioButtonInput = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].input.withConfig({
  displayName: "StyledRadioButton__StyledRadioButtonInput",
  componentId: "g1f6ld-1"
})(["position:absolute;opacity:0;top:0;left:0;width:100%;height:100%;margin:0;z-index:1;", ";"], function (props) {
  return !props.disabled && 'cursor: pointer;';
});
StyledRadioButtonInput.defaultProps = {};
Object.setPrototypeOf(StyledRadioButtonInput.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledRadioButtonIcon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].svg.withConfig({
  displayName: "StyledRadioButton__StyledRadioButtonIcon",
  componentId: "g1f6ld-2"
})(["box-sizing:border-box;position:absolute;width:", ";height:", ";fill:", ";", ";"], function (props) {
  return props.theme.radioButton.icon.size || props.theme.radioButton.size;
}, function (props) {
  return props.theme.radioButton.icon.size || props.theme.radioButton.size;
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.radioButton.check.color || 'control', props.theme);
}, function (props) {
  return props.theme.radioButton.icon.extend;
});
StyledRadioButtonIcon.defaultProps = {};
Object.setPrototypeOf(StyledRadioButtonIcon.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledRadioButtonBox = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledRadioButton__StyledRadioButtonBox",
  componentId: "g1f6ld-3"
})(["", ";", ";"], function (props) {
  return props.focus && __WEBPACK_IMPORTED_MODULE_1__utils__["p" /* focusStyle */];
}, function (props) {
  return props.theme.radioButton.check.extend;
});
StyledRadioButtonBox.defaultProps = {};
Object.setPrototypeOf(StyledRadioButtonBox.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledRadioButton = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledRadioButton",
  componentId: "g1f6ld-4"
})(["position:relative;", ";"], function (props) {
  return props.theme.radioButton && props.theme.radioButton.extend;
});
StyledRadioButton.defaultProps = {};
Object.setPrototypeOf(StyledRadioButton.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RangeInput__ = __webpack_require__(488);
/* unused harmony reexport RangeInput */


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RangeInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StyledRangeInput__ = __webpack_require__(489);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var RangeInput =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(RangeInput, _Component);

  function RangeInput() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = RangeInput.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        forwardRef = _this$props.forwardRef,
        rest = _objectWithoutPropertiesLoose(_this$props, ["forwardRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__StyledRangeInput__["a" /* StyledRangeInput */], _extends({}, rest, {
      ref: forwardRef,
      type: "range"
    }));
  };

  return RangeInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var RangeInputDoc;

if (false) {
  RangeInputDoc = require('./doc').doc(RangeInput); // eslint-disable-line global-require
}

var RangeInputWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2__hocs__["c" /* withFocus */], __WEBPACK_IMPORTED_MODULE_2__hocs__["d" /* withForwardRef */])(RangeInputDoc || RangeInput);


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledRangeInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var rangeTrackStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["box-sizing:border-box;width:100%;height:", ";background:", ";"], function (props) {
  return props.theme.rangeInput.track.height;
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.rangeInput.track.color, props.theme);
});
var rangeThumbStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["box-sizing:border-box;position:relative;border-radius:", ";height:", ";width:", ";overflow:visible;background:", ";-webkit-appearance:none;cursor:pointer;"], function (props) {
  return props.theme.global.spacing;
}, function (props) {
  return props.theme.global.spacing;
}, function (props) {
  return props.theme.global.spacing;
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.rangeInput.thumb.color || 'control', props.theme);
});
var firefoxMicrosoftThumbStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["", " margin-top:0px;height:", ";width:", ";"], rangeThumbStyle, function (props) {
  return props.theme.global.spacing;
}, function (props) {
  return props.theme.global.spacing;
});
var StyledRangeInput = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].input.withConfig({
  displayName: "StyledRangeInput",
  componentId: "sc-15st9ck-0"
})(["box-sizing:border-box;position:relative;-webkit-appearance:none;border-color:transparent;height:", ";width:100%;padding:0px;cursor:pointer;background:transparent;&:focus{outline:none;}&::-moz-focus-inner{border:none;}&::-moz-focus-outer{border:none;}&::-webkit-slider-runnable-track{", "}&::-webkit-slider-thumb{", " margin-top:-", "px;", "}&::-moz-range-track{", "}&::-moz-range-thumb{", "}&::-ms-thumb{", "}", " &::-ms-track{", " border-color:transparent;color:transparent;}&::-ms-fill-lower{background:", ";border-color:transparent;}&::-ms-fill-upper{background:", ";border-color:transparent;}", " ", ""], function (props) {
  return props.theme.global.spacing;
}, rangeTrackStyle, rangeThumbStyle, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["D" /* parseMetricToNum */])(props.theme.global.spacing) * 0.425;
}, function (props) {
  return !props.disabled && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["&:hover{box-shadow:0px 0px 0px 2px ", ";}"], Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.rangeInput.thumb.color || 'control', props.theme));
}, rangeTrackStyle, firefoxMicrosoftThumbStyle, firefoxMicrosoftThumbStyle, function (props) {
  return !props.disabled && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["&:hover::-moz-range-thumb{box-shadow:0px 0px 0px 2px ", ";}&:hover::-ms-thumb{box-shadow:0px 0px 0px 2px ", ";}"], Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.rangeInput.thumb.color || 'control', props.theme), Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.rangeInput.thumb.color || 'control', props.theme));
}, rangeTrackStyle, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.rangeInput.track.color, props.theme);
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.rangeInput.track.color, props.theme);
}, function (props) {
  return props.focus && __WEBPACK_IMPORTED_MODULE_1__utils__["p" /* focusStyle */];
}, function (props) {
  return props.theme.rangeInput && props.theme.rangeInput.extend;
});
StyledRangeInput.defaultProps = {};
Object.setPrototypeOf(StyledRangeInput.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RangeSelector__ = __webpack_require__(491);
/* unused harmony reexport RangeSelector */


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RangeSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contexts__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EdgeControl__ = __webpack_require__(492);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var RangeSelector =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(RangeSelector, _Component);

  function RangeSelector() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "containerRef", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "valueForMouseCoord", function (event) {
      var _this$props = _this.props,
          direction = _this$props.direction,
          max = _this$props.max,
          min = _this$props.min,
          step = _this$props.step;

      var rect = _this.containerRef.current.getBoundingClientRect();

      var value;

      if (direction === 'vertical') {
        var y = event.clientY - (rect.y || 0); // unit test resilience

        var scaleY = rect.height / (max - min + 1) || 1; // unit test resilience

        value = Math.floor(y / scaleY) + min;
      } else {
        var x = event.clientX - (rect.x || 0); // unit test resilience

        var scaleX = rect.width / (max - min + 1) || 1; // unit test resilience

        value = Math.floor(x / scaleX) + min;
      } // align with closest step within [min, max]


      var result = value + value % step;

      if (result < min) {
        return min;
      }

      if (result > max) {
        return max;
      }

      return result;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClick", function (event) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          values = _this$props2.values;
      var lastChange = _this.state.lastChange;

      var value = _this.valueForMouseCoord(event);

      if (value <= values[0] || value < values[1] && lastChange === 'lower') {
        _this.setState({
          lastChange: 'lower'
        }, function () {
          return onChange([value, values[1]]);
        });
      } else if (value >= values[1] || value > values[0] && lastChange === 'upper') {
        _this.setState({
          lastChange: 'upper'
        }, function () {
          return onChange([values[0], value]);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lowerMouseDown", function () {
      _this.setState({
        changing: 'lower'
      });

      window.addEventListener('mousemove', _this.mouseMove);
      window.addEventListener('mouseup', _this.mouseUp);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "upperMouseDown", function () {
      _this.setState({
        changing: 'upper'
      });

      window.addEventListener('mousemove', _this.mouseMove);
      window.addEventListener('mouseup', _this.mouseUp);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectionMouseDown", function (event) {
      var moveValue = _this.valueForMouseCoord(event);

      _this.setState({
        changing: 'selection',
        moveValue: moveValue
      });

      window.addEventListener('mousemove', _this.mouseMove);
      window.addEventListener('mouseup', _this.mouseUp);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mouseMove", function (event) {
      var _this$props3 = _this.props,
          max = _this$props3.max,
          min = _this$props3.min,
          onChange = _this$props3.onChange,
          values = _this$props3.values;
      var _this$state = _this.state,
          changing = _this$state.changing,
          moveValue = _this$state.moveValue;

      var value = _this.valueForMouseCoord(event);

      var nextValues;

      if (changing === 'lower' && value <= values[1] && value !== moveValue) {
        nextValues = [value, values[1]];
      } else if (changing === 'upper' && value >= values[0] && value !== moveValue) {
        nextValues = [values[0], value];
      } else if (changing === 'selection' && value !== moveValue) {
        var delta = value - moveValue;

        if (values[0] + delta >= min && values[1] + delta <= max) {
          nextValues = [values[0] + delta, values[1] + delta];
        }
      }

      if (nextValues) {
        _this.setState({
          lastChange: changing,
          moveValue: value
        }, function () {
          onChange(nextValues);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mouseUp", function () {
      _this.setState({
        changing: undefined
      });

      window.removeEventListener('mousemove', _this.mouseMove);
      window.removeEventListener('mouseup', _this.mouseMove);
    });

    return _this;
  }

  var _proto = RangeSelector.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('mousemove', this.mouseMove);
    window.removeEventListener('mouseup', this.mouseMove);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        color = _this$props4.color,
        direction = _this$props4.direction,
        forwardRef = _this$props4.forwardRef,
        invert = _this$props4.invert,
        max = _this$props4.max,
        messages = _this$props4.messages,
        min = _this$props4.min,
        onChange = _this$props4.onChange,
        opacity = _this$props4.opacity,
        round = _this$props4.round,
        size = _this$props4.size,
        step = _this$props4.step,
        values = _this$props4.values,
        propsTheme = _this$props4.theme,
        rest = _objectWithoutPropertiesLoose(_this$props4, ["color", "direction", "forwardRef", "invert", "max", "messages", "min", "onChange", "opacity", "round", "size", "step", "values", "theme"]);

    var theme = this.context || propsTheme;
    var _this$state2 = this.state,
        nextLower = _this$state2.nextLower,
        nextUpper = _this$state2.nextUpper;
    var lower = nextLower !== undefined ? nextLower : values[0];
    var upper = nextUpper !== undefined ? nextUpper : values[1]; // It needs to be true when vertical, due to how browsers manage height

    var fill = direction === 'vertical' ? true : 'vertical';
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Box__["a" /* Box */], _extends({
      ref: this.containerRef,
      direction: direction === 'vertical' ? 'column' : 'row',
      fill: fill
    }, rest, {
      onClick: onChange ? this.onClick : undefined
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Box__["a" /* Box */], {
      style: {
        flex: lower - min + " 0 0"
      },
      background: invert ? // preserve existing dark, instead of using darknes of this color
      {
        color: color || 'light-4',
        opacity: opacity,
        dark: theme.dark
      } : undefined,
      fill: fill,
      round: round
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EdgeControl__["a" /* EdgeControl */], {
      a11yTitle: messages.lower,
      tabIndex: 0,
      ref: forwardRef,
      color: color,
      direction: direction,
      edge: "lower",
      onMouseDown: onChange ? this.lowerMouseDown : undefined,
      onDecrease: onChange && lower - step >= min ? function () {
        return onChange([lower - step, upper]);
      } : undefined,
      onIncrease: onChange && lower + step <= upper ? function () {
        return onChange([lower + step, upper]);
      } : undefined
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Box__["a" /* Box */], {
      style: {
        flex: upper - lower + 1 + " 0 0",
        cursor: direction === 'vertical' ? 'ns-resize' : 'ew-resize'
      },
      background: invert ? undefined : // preserve existing dark, instead of using darknes of this color
      {
        color: color || 'control',
        opacity: opacity,
        dark: theme.dark
      },
      fill: fill,
      round: round,
      onMouseDown: onChange ? this.selectionMouseDown : undefined
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EdgeControl__["a" /* EdgeControl */], {
      a11yTitle: messages.upper,
      tabIndex: 0,
      color: color,
      direction: direction,
      edge: "upper",
      onMouseDown: onChange ? this.upperMouseDown : undefined,
      onDecrease: onChange && upper - step >= lower ? function () {
        return onChange([lower, upper - step]);
      } : undefined,
      onIncrease: onChange && upper + step <= max ? function () {
        return onChange([lower, upper + step]);
      } : undefined
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Box__["a" /* Box */], {
      style: {
        flex: max - upper + " 0 0"
      },
      background: invert ? // preserve existing dark, instead of using darknes of this color
      {
        color: color || 'light-4',
        opacity: opacity,
        dark: theme.dark
      } : undefined,
      fill: fill,
      round: round
    }));
  };

  return RangeSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(RangeSelector, "contextType", __WEBPACK_IMPORTED_MODULE_2__contexts__["c" /* ThemeContext */]);

_defineProperty(RangeSelector, "defaultProps", {
  direction: 'horizontal',
  max: 100,
  messages: {
    lower: 'Lower Bounds',
    upper: 'Upper Bounds'
  },
  min: 0,
  opacity: 'medium',
  size: 'medium',
  step: 1,
  values: []
});

var RangeSelectorDoc;

if (false) {
  RangeSelectorDoc = require('./doc').doc(RangeSelector); // eslint-disable-line global-require
}

var RangeSelectorWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_4__hocs__["d" /* withForwardRef */])(RangeSelectorDoc || RangeSelector);


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EdgeControlWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Keyboard__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hocs__ = __webpack_require__(13);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var DIRECTION_PROPS = {
  horizontal: {
    cursor: 'col-resize',
    fill: 'vertical'
  },
  vertical: {
    cursor: 'row-resize',
    fill: 'horizontal'
  }
};

var EdgeControl =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(EdgeControl, _Component);

  function EdgeControl() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    return _this;
  }

  var _proto = EdgeControl.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        color = _this$props.color,
        direction = _this$props.direction,
        edge = _this$props.edge,
        forwardRef = _this$props.forwardRef,
        onDecrease = _this$props.onDecrease,
        onIncrease = _this$props.onIncrease,
        theme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["color", "direction", "edge", "forwardRef", "onDecrease", "onIncrease", "theme"]);

    var focused = this.state.focused;
    var _DIRECTION_PROPS$dire = DIRECTION_PROPS[direction],
        cursor = _DIRECTION_PROPS$dire.cursor,
        fill = _DIRECTION_PROPS$dire.fill;
    var size = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["D" /* parseMetricToNum */])(theme.global.spacing) / 2;
    var halfSize = size / 2;
    var keyboardProps = direction === 'vertical' ? {
      onUp: onDecrease,
      onDown: onIncrease
    } : {
      onLeft: onDecrease,
      onRight: onIncrease
    };
    var boxDirection = direction === 'vertical' ? 'row' : 'column';
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Keyboard__["a" /* Keyboard */], keyboardProps, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
      direction: boxDirection,
      style: {
        flex: '0 0 1px'
      },
      overflow: "visible",
      align: "center"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], _extends({
      ref: forwardRef,
      direction: boxDirection,
      justify: "center",
      align: "center",
      fill: fill,
      margin: "xsmall",
      style: {
        cursor: cursor,
        minWidth: size,
        minHeight: size,
        zIndex: 10
      },
      onFocus: function onFocus() {
        return _this2.setState({
          focused: true
        });
      },
      onBlur: function onBlur() {
        return _this2.setState({
          focused: false
        });
      }
    }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
      direction: boxDirection,
      round: "small",
      focus: focused
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
      viewBox: "0 0 " + size + " " + size,
      width: size,
      height: size
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
      cx: halfSize,
      cy: halfSize,
      r: halfSize,
      fill: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["B" /* normalizeColor */])(color || 'control', theme)
    }))))));
  };

  return EdgeControl;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

EdgeControl.defaultProps = {};
Object.setPrototypeOf(EdgeControl.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var EdgeControlWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_7__hocs__["d" /* withForwardRef */], __WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(EdgeControl);


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RoutedAnchor__ = __webpack_require__(494);
/* unused harmony reexport RoutedAnchor */


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RoutedAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Anchor__ = __webpack_require__(63);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var RoutedAnchor =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(RoutedAnchor, _Component);

  function RoutedAnchor() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = RoutedAnchor.prototype;

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        path = _this$props.path,
        method = _this$props.method,
        rest = _objectWithoutPropertiesLoose(_this$props, ["path", "method"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Anchor__["a" /* Anchor */], _extends({}, rest, {
      href: path,
      onClick: function onClick(event) {
        var onClick = _this.props.onClick;
        var router = _this.context.router;

        if (event) {
          var modifierKey = event.ctrlKey || event.metaKey; // if the user right-clicked in the Anchor we should let it go

          if (modifierKey) {
            return;
          }
        }

        if (router) {
          event.preventDefault();
          (router.history || router)[method](path);
        }

        if (onClick) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          onClick.apply(void 0, [event].concat(args));
        }
      }
    }));
  };

  return RoutedAnchor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(RoutedAnchor, "contextTypes", {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired
});

_defineProperty(RoutedAnchor, "defaultProps", {
  method: 'push'
});

var RoutedAnchorDoc;

if (false) {
  RoutedAnchorDoc = require('./doc').doc(RoutedAnchor); // eslint-disable-line global-require
}

var RoutedAnchorWrapper = RoutedAnchorDoc || RoutedAnchor;


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RoutedButton__ = __webpack_require__(496);
/* unused harmony reexport RoutedButton */


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RoutedButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(19);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var RoutedButton =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(RoutedButton, _Component);

  function RoutedButton() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(_args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClick", function (event) {
      var _this$props = _this.props,
          method = _this$props.method,
          onClick = _this$props.onClick,
          path = _this$props.path;
      var router = _this.context.router;

      if (event) {
        var modifierKey = event.ctrlKey || event.metaKey; // if the user right-clicked in the button we should let it go

        if (modifierKey) {
          return;
        }
      }

      if (router) {
        event.preventDefault();
        (router.history || router)[method](path);
      }

      if (onClick) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        onClick.apply(void 0, [event].concat(args));
      }
    });

    return _this;
  }

  var _proto = RoutedButton.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        href = _this$props2.href,
        path = _this$props2.path,
        method = _this$props2.method,
        onClick = _this$props2.onClick,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["href", "path", "method", "onClick"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* Button */], _extends({}, rest, {
      href: path || href,
      disabled: !path && !onClick,
      onClick: this.onClick
    }));
  };

  return RoutedButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(RoutedButton, "contextTypes", {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired
});

_defineProperty(RoutedButton, "defaultProps", {
  method: 'push'
});

var RoutedButtonDoc;

if (false) {
  RoutedButtonDoc = require('./doc').doc(RoutedButton); // eslint-disable-line global-require
}

var RoutedButtonWrapper = RoutedButtonDoc || RoutedButton;


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(498);
/* unused harmony reexport Select */


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Select */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DropButton__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Keyboard__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TextInput__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SelectContainer__ = __webpack_require__(499);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var SelectTextInput = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_8__TextInput__["a" /* TextInput */]).withConfig({
  displayName: "Select__SelectTextInput",
  componentId: "sc-17idtfo-0"
})(["cursor:pointer;"]);
var StyledSelectBox = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */]).withConfig({
  displayName: "Select__StyledSelectBox",
  componentId: "sc-17idtfo-1"
})(["", ";", ";"], function (props) {
  return !props.plain && __WEBPACK_IMPORTED_MODULE_3__utils__["h" /* controlBorderStyle */];
}, function (props) {
  return props.theme.select && props.theme.select.control && props.theme.select.control.extend;
});
StyledSelectBox.defaultProps = {};
Object.setPrototypeOf(StyledSelectBox.defaultProps, __WEBPACK_IMPORTED_MODULE_4__default_props__["a" /* defaultProps */]);

var Select =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Select, _Component);

  function Select() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      open: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOpen", function () {
      var onOpen = _this.props.onOpen;

      _this.setState({
        open: true
      }, function () {
        if (onOpen) {
          onOpen();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClose", function () {
      var onClose = _this.props.onClose;

      _this.setState({
        open: false
      }, function () {
        if (onClose) {
          onClose();
        }
      });
    });

    return _this;
  }

  var _proto = Select.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        a11yTitle = _this$props.a11yTitle,
        alignSelf = _this$props.alignSelf,
        children = _this$props.children,
        closeOnChange = _this$props.closeOnChange,
        disabled = _this$props.disabled,
        dropAlign = _this$props.dropAlign,
        dropTarget = _this$props.dropTarget,
        forwardRef = _this$props.forwardRef,
        gridArea = _this$props.gridArea,
        id = _this$props.id,
        labelKey = _this$props.labelKey,
        margin = _this$props.margin,
        messages = _this$props.messages,
        onChange = _this$props.onChange,
        onClose = _this$props.onClose,
        options = _this$props.options,
        placeholder = _this$props.placeholder,
        plain = _this$props.plain,
        selected = _this$props.selected,
        size = _this$props.size,
        theme = _this$props.theme,
        value = _this$props.value,
        valueLabel = _this$props.valueLabel,
        rest = _objectWithoutPropertiesLoose(_this$props, ["a11yTitle", "alignSelf", "children", "closeOnChange", "disabled", "dropAlign", "dropTarget", "forwardRef", "gridArea", "id", "labelKey", "margin", "messages", "onChange", "onClose", "options", "placeholder", "plain", "selected", "size", "theme", "value", "valueLabel"]);

    var open = this.state.open;
    delete rest.onSearch;

    var onSelectChange = function onSelectChange(event) {
      if (closeOnChange) {
        _this2.onClose();
      }

      if (onChange) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        onChange.apply(void 0, [_extends({}, event, {
          target: _this2.inputRef.current
        })].concat(args));
      }
    };

    var SelectIcon = theme.select.icons.down;
    var selectValue;
    var inputValue = '';

    if (valueLabel) {
      selectValue = valueLabel;
    } else if (Array.isArray(value)) {
      if (value.length > 1) {
        if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(value[0])) {
          selectValue = value;
        } else {
          inputValue = messages.multiple;
        }
      } else if (value.length === 1) {
        if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(value[0])) {
          selectValue = value[0];
        } else if (labelKey && typeof value[0] === 'object') {
          if (typeof labelKey === 'function') {
            inputValue = labelKey(value[0]);
          } else {
            inputValue = value[0][labelKey];
          }
        } else {
          inputValue = value[0];
        }
      } else {
        inputValue = '';
      }
    } else if (labelKey && typeof value === 'object') {
      if (typeof labelKey === 'function') {
        inputValue = labelKey(value);
      } else {
        inputValue = value[labelKey];
      }
    } else if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(value)) {
      selectValue = value; // deprecated in favor of valueLabel
    } else if (selected !== undefined) {
      if (Array.isArray(selected)) {
        if (selected.length > 1) {
          inputValue = messages.multiple;
        } else if (selected.length === 1) {
          inputValue = options[selected[0]];
        }
      } else {
        inputValue = options[selected];
      }
    } else {
      inputValue = value;
    } // const dark = theme.select.background ? colorIsDark(theme.select.background) : theme.dark;


    var iconColor = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["B" /* normalizeColor */])(theme.select.icons.color || 'control', theme);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Keyboard__["a" /* Keyboard */], {
      onDown: this.onOpen,
      onUp: this.onOpen
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DropButton__["a" /* DropButton */], {
      ref: forwardRef,
      id: id,
      disabled: disabled === true || undefined,
      dropAlign: dropAlign,
      dropTarget: dropTarget,
      open: open,
      alignSelf: alignSelf,
      gridArea: gridArea,
      margin: margin,
      onOpen: this.onOpen,
      onClose: this.onClose,
      dropContent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SelectContainer__["a" /* SelectContainer */], _extends({}, this.props, {
        onChange: onSelectChange
      }))
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledSelectBox, {
      align: "center",
      direction: "row",
      justify: "between",
      background: theme.select.background,
      plain: plain
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      direction: "row",
      flex: true,
      basis: "auto"
    }, selectValue || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectTextInput, _extends({
      a11yTitle: a11yTitle && "" + a11yTitle + (typeof value === 'string' ? ", " + value : ''),
      id: id ? id + "__input" : undefined,
      ref: this.inputRef
    }, rest, {
      tabIndex: "-1",
      type: "text",
      placeholder: placeholder,
      plain: true,
      readOnly: true,
      value: inputValue,
      size: size,
      onClick: disabled === true ? undefined : this.onOpen
    }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Box__["a" /* Box */], {
      margin: {
        horizontal: 'small'
      },
      flex: false,
      style: {
        minWidth: 'auto'
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectIcon, {
      color: iconColor,
      size: size
    })))));
  };

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Select, "defaultProps", {
  closeOnChange: true,
  dropAlign: {
    top: 'bottom',
    left: 'left'
  },
  messages: {
    multiple: 'multiple'
  }
});

Object.setPrototypeOf(Select.defaultProps, __WEBPACK_IMPORTED_MODULE_4__default_props__["a" /* defaultProps */]);
var SelectDoc;

if (false) {
  SelectDoc = require('./doc').doc(Select); // eslint-disable-line global-require
}

var SelectWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */], __WEBPACK_IMPORTED_MODULE_9__hocs__["d" /* withForwardRef */])(SelectDoc || Select);


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectContainerWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InfiniteScroll__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Keyboard__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TextInput__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SelectOption__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StyledSelect__ = __webpack_require__(501);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var OptionsBox = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */]).withConfig({
  displayName: "SelectContainer__OptionsBox",
  componentId: "sc-1wi0ul8-0"
})(["scroll-behavior:smooth;"]);
var OptionBox = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */]).withConfig({
  displayName: "SelectContainer__OptionBox",
  componentId: "sc-1wi0ul8-1"
})(["", ""], function (props) {
  return props.selected && __WEBPACK_IMPORTED_MODULE_2__utils__["G" /* selectedStyle */];
});

var SelectContainer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(SelectContainer, _Component);

  function SelectContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "optionsRef", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "searchRef", Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectRef", Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      search: '',
      activeIndex: -1
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSearchChange", function (event) {
      _this.setState({
        search: event.target.value,
        activeIndex: -1
      }, function () {
        var search = _this.state.search;

        _this.onSearch(search);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSearch", Object(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* debounce */])(function (search) {
      var onSearch = _this.props.onSearch;
      onSearch(search);
    }, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["j" /* debounceDelay */])(_this.props)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectOption", function (option, index) {
      return function () {
        var _this$props = _this.props,
            multiple = _this$props.multiple,
            onChange = _this$props.onChange,
            options = _this$props.options,
            selected = _this$props.selected,
            value = _this$props.value;

        if (onChange) {
          var nextValue = option;
          var nextSelected = index;

          if (multiple) {
            nextValue = [];
            nextSelected = [];
            var removed = false;
            var selectedIndexes = [];

            if (Array.isArray(selected)) {
              selectedIndexes = selected;
            } else if (Array.isArray(value)) {
              selectedIndexes = value.map(function (v) {
                return options.indexOf(v);
              });
            }

            selectedIndexes.forEach(function (selectedIndex) {
              if (selectedIndex === index) {
                removed = true;
              } else {
                nextValue.push(options[selectedIndex]);
                nextSelected.push(selectedIndex);
              }
            });

            if (!removed) {
              nextValue.push(option);
              nextSelected.push(index);
            }
          }

          onChange({
            option: option,
            value: nextValue,
            selected: nextSelected
          });
        }
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearKeyboardNavigation", function () {
      clearTimeout(_this.keyboardNavTimer);
      _this.keyboardNavTimer = setTimeout(function () {
        _this.setState({
          keyboardNavigating: false
        });
      }, 100); // 100ms was empirically determined
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onNextOption", function (event) {
      var options = _this.props.options;
      var activeIndex = _this.state.activeIndex;
      event.preventDefault();
      var nextActiveIndex = activeIndex + 1;

      while (nextActiveIndex < options.length && _this.isDisabled(nextActiveIndex)) {
        nextActiveIndex += 1;
      }

      if (nextActiveIndex !== options.length) {
        _this.setState({
          activeIndex: nextActiveIndex,
          keyboardNavigating: true
        }, function () {
          var buttonNode = _this.optionsRef[nextActiveIndex];
          var selectNode = _this.selectRef.current;

          if (buttonNode && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["w" /* isNodeAfterScroll */])(buttonNode, selectNode) && selectNode.scrollBy) {
            selectNode.scrollBy(0, buttonNode.getBoundingClientRect().height);
          }

          _this.clearKeyboardNavigation();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onPreviousOption", function (event) {
      var activeIndex = _this.state.activeIndex;
      event.preventDefault();
      var nextActiveIndex = activeIndex - 1;

      while (nextActiveIndex >= 0 && _this.isDisabled(nextActiveIndex)) {
        nextActiveIndex -= 1;
      }

      if (nextActiveIndex >= 0) {
        _this.setState({
          activeIndex: nextActiveIndex,
          keyboardNavigating: true
        }, function () {
          var buttonNode = _this.optionsRef[nextActiveIndex];
          var selectNode = _this.selectRef.current;

          if (buttonNode && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["x" /* isNodeBeforeScroll */])(buttonNode, selectNode) && selectNode.scrollBy) {
            selectNode.scrollBy(0, -buttonNode.getBoundingClientRect().height);
          }

          _this.clearKeyboardNavigation();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onActiveOption", function (index) {
      return function () {
        var keyboardNavigating = _this.state.keyboardNavigating;

        if (!keyboardNavigating) {
          _this.setState({
            activeIndex: index
          });
        }
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSelectOption", function (event) {
      var options = _this.props.options;
      var activeIndex = _this.state.activeIndex;

      if (activeIndex >= 0) {
        event.preventDefault(); // prevent submitting forms

        _this.selectOption(options[activeIndex], activeIndex)();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "optionLabel", function (index) {
      var _this$props2 = _this.props,
          options = _this$props2.options,
          labelKey = _this$props2.labelKey;
      var option = options[index];
      var optionLabel;

      if (labelKey) {
        if (typeof labelKey === 'function') {
          optionLabel = labelKey(option);
        } else {
          optionLabel = option[labelKey];
        }
      } else {
        optionLabel = option;
      }

      return optionLabel;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "optionValue", function (index) {
      var _this$props3 = _this.props,
          options = _this$props3.options,
          valueKey = _this$props3.valueKey;
      var option = options[index];
      var optionValue;

      if (valueKey) {
        if (typeof valueKey === 'function') {
          optionValue = valueKey(option);
        } else {
          optionValue = option[valueKey];
        }
      } else {
        optionValue = option;
      }

      return optionValue;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isDisabled", function (index) {
      var _this$props4 = _this.props,
          disabled = _this$props4.disabled,
          disabledKey = _this$props4.disabledKey,
          options = _this$props4.options;
      var option = options[index];
      var result;

      if (disabledKey) {
        if (typeof disabledKey === 'function') {
          result = disabledKey(option, index);
        } else {
          result = option[disabledKey];
        }
      } else if (Array.isArray(disabled)) {
        if (typeof disabled[0] === 'number') {
          result = disabled.indexOf(index) !== -1;
        } else {
          var optionValue = _this.optionValue(index);

          result = disabled.indexOf(optionValue) !== -1;
        }
      }

      return result;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isSelected", function (index) {
      var _this$props5 = _this.props,
          selected = _this$props5.selected,
          value = _this$props5.value,
          valueKey = _this$props5.valueKey;
      var result;

      if (selected) {
        // deprecated in favor of value
        result = selected.indexOf(index) !== -1;
      } else {
        var optionValue = _this.optionValue(index);

        if (Array.isArray(value)) {
          if (value.length === 0) {
            result = false;
          } else if (typeof value[0] !== 'object') {
            result = value.indexOf(optionValue) !== -1;
          } else if (valueKey) {
            result = value.some(function (valueItem) {
              var valueValue = typeof valueKey === 'function' ? valueKey(valueItem) : valueItem[valueKey];
              return valueValue === optionValue;
            });
          }
        } else if (valueKey && typeof value === 'object') {
          var valueValue = typeof valueKey === 'function' ? valueKey(value) : value[valueKey];
          result = valueValue === optionValue;
        } else {
          result = value === optionValue;
        }
      }

      return result;
    });

    return _this;
  }

  SelectContainer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var options = nextProps.options,
        value = nextProps.value,
        onSearch = nextProps.onSearch;

    if (onSearch) {
      if (prevState.activeIndex === -1 && prevState.search === '' && options && value) {
        var optionValue = Array.isArray(value) && value.length ? value[0] : value;
        var activeIndex = options.indexOf(optionValue);
        return {
          activeIndex: activeIndex
        };
      }

      if (prevState.activeIndex === -1 && prevState.search !== '') {
        return {
          activeIndex: 0
        };
      }
    }

    return null;
  };

  var _proto = SelectContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var onSearch = this.props.onSearch;
    var activeIndex = this.state.activeIndex; // timeout need to send the operation through event loop and allow time to the portal
    // to be available

    setTimeout(function () {
      var selectNode = _this2.selectRef.current;

      if (onSearch) {
        var input = _this2.searchRef.current;

        if (input && input.focus) {
          Object(__WEBPACK_IMPORTED_MODULE_2__utils__["H" /* setFocusWithoutScroll */])(input);
        }
      } else if (selectNode) {
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["H" /* setFocusWithoutScroll */])(selectNode);
      } // scroll to active option if it is below the fold


      if (activeIndex >= 0 && selectNode) {
        var optionNode = _this2.optionsRef[activeIndex];

        var _selectNode$getBoundi = selectNode.getBoundingClientRect(),
            containerBottom = _selectNode$getBoundi.bottom;

        if (optionNode) {
          var _optionNode$getBoundi = optionNode.getBoundingClientRect(),
              optionTop = _optionNode$getBoundi.bottom;

          if (containerBottom < optionTop) {
            optionNode.scrollIntoView();
          }
        }
      }
    }, 0);
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props6 = this.props,
        children = _this$props6.children,
        dropHeight = _this$props6.dropHeight,
        emptySearchMessage = _this$props6.emptySearchMessage,
        id = _this$props6.id,
        onKeyDown = _this$props6.onKeyDown,
        onSearch = _this$props6.onSearch,
        options = _this$props6.options,
        searchPlaceholder = _this$props6.searchPlaceholder,
        theme = _this$props6.theme;
    var _this$state = this.state,
        activeIndex = _this$state.activeIndex,
        search = _this$state.search;
    var customSearchInput = theme.select.searchInput;
    var SelectTextInput = customSearchInput || __WEBPACK_IMPORTED_MODULE_8__TextInput__["a" /* TextInput */];
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Keyboard__["a" /* Keyboard */], {
      onEnter: this.onSelectOption,
      onUp: this.onPreviousOption,
      onDown: this.onNextOption,
      onKeyDown: onKeyDown
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__StyledSelect__["a" /* StyledContainer */], {
      as: __WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */],
      id: id ? id + "__select-drop" : undefined,
      dropHeight: dropHeight
    }, onSearch && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
      pad: !customSearchInput ? 'xsmall' : undefined,
      flex: false
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectTextInput, {
      focusIndicator: !customSearchInput,
      size: "small",
      ref: this.searchRef,
      type: "search",
      value: search,
      placeholder: searchPlaceholder,
      onChange: this.onSearchChange
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionsBox, {
      flex: "shrink",
      role: "menubar",
      tabIndex: "-1",
      ref: this.selectRef,
      overflow: "auto"
    }, options.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__InfiniteScroll__["a" /* InfiniteScroll */], {
      items: options,
      step: theme.select.step,
      replace: true
    }, function (option, index) {
      var isDisabled = _this3.isDisabled(index);

      var isSelected = _this3.isSelected(index);

      var isActive = activeIndex === index;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SelectOption__["a" /* SelectOption */], {
        key: "option_" + index,
        ref: function ref(_ref) {
          _this3.optionsRef[index] = _ref;
        },
        disabled: isDisabled || undefined,
        active: isActive,
        selected: isSelected,
        option: option,
        onMouseOver: !isDisabled ? _this3.onActiveOption(index) : undefined,
        onClick: !isDisabled ? _this3.selectOption(option, index) : undefined
      }, children ? children(option, index, options, {
        active: isActive,
        disabled: isDisabled,
        selected: isSelected
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionBox, {
        align: "start",
        pad: "small",
        selected: isSelected
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Text__["a" /* Text */], {
        margin: "none"
      }, _this3.optionLabel(index))));
    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SelectOption__["a" /* SelectOption */], {
      key: "search_empty",
      disabled: true,
      option: emptySearchMessage
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionBox, {
      align: "start",
      pad: "small"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Text__["a" /* Text */], {
      margin: "none"
    }, emptySearchMessage))))));
  };

  return SelectContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(SelectContainer, "defaultProps", {
  children: null,
  disabled: undefined,
  emptySearchMessage: 'No matches found',
  id: undefined,
  multiple: false,
  name: undefined,
  onKeyDown: undefined,
  onSearch: undefined,
  options: undefined,
  searchPlaceholder: undefined,
  selected: undefined,
  value: ''
});

Object.setPrototypeOf(SelectContainer.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var SelectContainerWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["e" /* withTheme */])(SelectContainer);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectOptionWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs__ = __webpack_require__(13);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var SelectOption =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(SelectOption, _Component);

  function SelectOption() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SelectOption.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props = this.props,
        active = _this$props.active,
        disabled = _this$props.disabled,
        option = _this$props.option,
        selected = _this$props.selected;
    var nextActive = nextProps.active,
        nextDisabled = nextProps.disabled,
        nextOption = nextProps.option,
        nextSelected = nextProps.selected;
    return active !== nextActive || selected !== nextSelected || disabled !== nextDisabled || option !== nextOption;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        forwardRef = _this$props2.forwardRef,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["forwardRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Box__["a" /* Box */], {
      flex: false
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* Button */], _extends({
      tabIndex: "-1",
      ref: forwardRef,
      role: "menuitem"
    }, rest)));
  };

  return SelectOption;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var SelectOptionWrapper = Object(__WEBPACK_IMPORTED_MODULE_3__hocs__["d" /* withForwardRef */])(SelectOption);


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_styles__ = __webpack_require__(81);


var StyledContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledSelect__StyledContainer",
  componentId: "znp66n-0"
})(["@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}", ";", ";"], function (props) {
  return props.dropHeight ? Object(__WEBPACK_IMPORTED_MODULE_1_grommet_styles__["c" /* sizeStyle */])('max-height', props.dropHeight, props.theme) : 'max-height: inherit;';
}, function (props) {
  return props.theme.select.container && props.theme.select.container.extend;
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SkipLink__ = __webpack_require__(503);
/* unused harmony reexport SkipLink */


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SkipLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Anchor__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Box__ = __webpack_require__(9);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var SkipLink = function SkipLink(_ref) {
  var id = _ref.id,
      label = _ref.label,
      rest = _objectWithoutPropertiesLoose(_ref, ["id", "label"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Box__["a" /* Box */], {
    margin: "small"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Anchor__["a" /* Anchor */], _extends({
    href: "#" + id,
    label: label
  }, rest)));
};

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SkipLinks__ = __webpack_require__(505);
/* unused harmony reexport SkipLinks */


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SkipLinks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Heading__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layer__ = __webpack_require__(188);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var SkipLinks =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(SkipLinks, _Component);

  function SkipLinks() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      showLayer: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "layerRef", Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onBlur", function () {
      // timeout needed so it gives enough time for activeElement to be updated
      setTimeout(function () {
        var layerNode = _this.layerRef.current;

        if (layerNode && layerNode.layerContainer.contains && !layerNode.layerContainer.contains(document.activeElement)) {
          _this.removeLayer();
        }
      }, 0);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFocus", function () {
      _this.setState({
        showLayer: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeLayer", function () {
      _this.setState({
        showLayer: false
      });
    });

    return _this;
  }

  var _proto = SkipLinks.prototype;

  _proto.render = function render() {
    var _this2 = this;

    /* eslint-disable-next-line react/prop-types */
    var _this$props = this.props,
        children = _this$props.children,
        id = _this$props.id,
        messages = _this$props.messages;
    var showLayer = this.state.showLayer;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Layer__["a" /* Layer */], {
      id: id,
      position: showLayer ? 'top' : 'hidden',
      ref: this.layerRef,
      onFocus: this.onFocus,
      onBlur: this.onBlur
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Box__["a" /* Box */], {
      pad: {
        horizontal: 'medium'
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* Heading */], {
      level: 2
    }, messages.skipTo, ":"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Box__["a" /* Box */], {
      direction: "row",
      align: "center",
      pad: {
        bottom: 'medium'
      }
    }, children.map(function (element, index) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(element, {
        key: "skip-link-" + index,
        onClick: _this2.removeLayer
      });
    }))));
  };

  return SkipLinks;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(SkipLinks, "defaultProps", {
  messages: {
    skipTo: 'Skip To'
  }
});

var SkipLinksDoc;

if (false) {
  SkipLinksDoc = require('./doc').doc(SkipLinks); // eslint-disable-line global-require
}

var SkipLinksWrapper = SkipLinksDoc || SkipLinks;


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SkipLinkTarget__ = __webpack_require__(507);
/* unused harmony reexport SkipLinkTarget */


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SkipLinkTarget */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Anchor__ = __webpack_require__(63);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var HiddenAnchor = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Anchor__["a" /* Anchor */]).withConfig({
  displayName: "SkipLinkTarget__HiddenAnchor",
  componentId: "sc-16wjfgk-0"
})(["width:0;height:0;overflow:hidden;position:absolute;"]);
var SkipLinkTarget = function SkipLinkTarget(_ref) {
  var label = _ref.label,
      rest = _objectWithoutPropertiesLoose(_ref, ["label"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HiddenAnchor, _extends({}, rest, {
    tabIndex: "-1",
    "aria-hidden": "true"
  }), label);
};

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(509);
/* unused harmony reexport Table */


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledTable__ = __webpack_require__(50);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Table = function Table(_ref) {
  var caption = _ref.caption,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["caption", "children"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StyledTable__["a" /* StyledTable */], rest, caption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StyledTable__["d" /* StyledTableDataCaption */], null, caption) : null, children);
};

var TableDoc;

if (false) {
  TableDoc = require('./doc').doc(Table); // eslint-disable-line global-require
}

var TableWrapper = TableDoc || Table;


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableBody__ = __webpack_require__(511);
/* unused harmony reexport TableBody */


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TableBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table_TableContext__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table_StyledTable__ = __webpack_require__(50);




var TableBody = function TableBody(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Table_TableContext__["a" /* TableContext */].Provider, {
    value: "body"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Table_StyledTable__["b" /* StyledTableBody */], props));
};

var TableBodyDoc;

if (false) {
  TableBodyDoc = require('./doc').doc(TableBody); // eslint-disable-line global-require
}

var TableBodyWrapper = TableBodyDoc || TableBody;


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tab__ = __webpack_require__(513);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tab__["a"]; });


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StyledTab__ = __webpack_require__(514);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var Tab =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tab, _Component);

  function Tab() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseOver", function (event) {
      var onMouseOver = _this.props.onMouseOver;

      _this.setState({
        over: true
      });

      if (onMouseOver) {
        onMouseOver(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseOut", function (event) {
      var onMouseOut = _this.props.onMouseOut;

      _this.setState({
        over: undefined
      });

      if (onMouseOut) {
        onMouseOut(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClickTab", function (event) {
      var onActivate = _this.props.onActivate;

      if (event) {
        event.preventDefault();
      }

      onActivate();
    });

    return _this;
  }

  Tab.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var active = nextProps.active;
    var over = prevState.over;

    if (active && over) {
      return {
        over: undefined
      };
    }

    return null;
  };

  var _proto = Tab.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        forwardRef = _this$props.forwardRef,
        plain = _this$props.plain,
        title = _this$props.title,
        onMouseOver = _this$props.onMouseOver,
        onMouseOut = _this$props.onMouseOut,
        theme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["active", "forwardRef", "plain", "title", "onMouseOver", "onMouseOut", "theme"]);

    var over = this.state.over;
    delete rest.onActivate;
    var normalizedTitle = title;
    var tabStyles = {};

    if (!plain) {
      if (typeof title !== 'string') {
        normalizedTitle = title;
      } else if (active) {
        normalizedTitle = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Text__["a" /* Text */], theme.tab.active, title);
      } else {
        normalizedTitle = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Text__["a" /* Text */], {
          color: over ? theme.tab.hover.color : theme.tab.color
        }, title);
      }

      if (theme.tab.border) {
        var borderColor = theme.tab.border.color || theme.global.control.border.color;

        if (active) {
          borderColor = theme.tab.border.active.color || borderColor;
        } else if (over) {
          borderColor = theme.tab.border.hover.color || borderColor;
        }

        borderColor = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["B" /* normalizeColor */])(borderColor, theme);
        tabStyles.border = {
          side: theme.tab.border.side,
          size: theme.tab.border.size,
          color: borderColor
        };
      }

      tabStyles.background = active ? theme.tab.active.background || theme.tab.background : theme.tab.background;
      tabStyles.pad = theme.tab.pad;
      tabStyles.margin = theme.tab.margin;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* Button */], _extends({
      ref: forwardRef,
      plain: true,
      role: "tab",
      "aria-selected": active,
      "aria-expanded": active
    }, rest, {
      onClick: this.onClickTab,
      onMouseOver: this.onMouseOver,
      onMouseOut: this.onMouseOut,
      onFocus: this.onMouseOver,
      onBlur: this.onMouseOut
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__StyledTab__["a" /* StyledTab */], _extends({
      as: __WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */],
      plain: plain
    }, tabStyles), normalizedTitle));
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Tab.defaultProps = {};
Object.setPrototypeOf(Tab.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var TabDoc;

if (false) {
  TabDoc = require('./doc').doc(Tab); // eslint-disable-line global-require
}

var TabWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */], __WEBPACK_IMPORTED_MODULE_7__hocs__["d" /* withForwardRef */])(TabDoc || Tab);


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var tabHoverStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["&:hover{", " ", " ", ";}"], function (props) {
  return props.theme.tab.hover.background && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["background:", ";"], Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.tab.hover.background, props.theme));
}, function (props) {
  return props.theme.tab.hover.color && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["color:", ";"], Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])(props.theme.tab.hover.color, props.theme));
}, function (props) {
  return props.theme.tab.hover.extend;
});
var StyledTab = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledTab",
  componentId: "sc-1nnwnsb-0"
})(["", " ", " ", ""], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return !props.plain && props.theme.tab.hover && tabHoverStyle;
}, function (props) {
  return props.theme.tab.extend;
});
StyledTab.defaultProps = {};
Object.setPrototypeOf(StyledTab.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tabs__["a"]; });


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabsWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StyledTabs__ = __webpack_require__(517);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var Tabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tabs, _Component);

  function Tabs() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "activateTab", function (index) {
      var _this$props = _this.props,
          activeIndex = _this$props.activeIndex,
          onActive = _this$props.onActive;

      if (activeIndex === undefined) {
        _this.setState({
          activeIndex: index
        });
      }

      if (onActive) {
        onActive(index);
      }
    });

    return _this;
  }

  Tabs.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var activeIndex = nextProps.activeIndex;
    var stateActiveIndex = prevState.activeIndex;

    if (stateActiveIndex !== activeIndex && activeIndex !== undefined) {
      return {
        activeIndex: activeIndex
      };
    }

    return {
      activeIndex: stateActiveIndex || 0
    };
  };

  var _proto = Tabs.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        flex = _this$props2.flex,
        justify = _this$props2.justify,
        tabContents = _this$props2.messages.tabContents,
        theme = _this$props2.theme,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["children", "flex", "justify", "messages", "theme"]);

    delete rest.activeIndex;
    delete rest.onActive;
    var activeIndex = this.state.activeIndex;
    var activeContent;
    var activeTitle;
    var tabs = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (tab, index) {
      if (!tab) return undefined;
      var tabProps = tab.props || {};
      var isTabActive = index === activeIndex;

      if (isTabActive) {
        activeContent = tabProps.children;

        if (typeof tabProps.title === 'string') {
          activeTitle = tabProps.title;
        } else {
          activeTitle = index + 1;
        }
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(tab, {
        active: isTabActive,
        onActivate: function onActivate() {
          return _this2.activateTab(index);
        }
      });
    }, this);
    var tabContentTitle = (activeTitle || '') + " " + tabContents;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledTabs__["b" /* StyledTabs */], _extends({
      as: __WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */],
      role: "tablist",
      flex: flex
    }, rest, {
      background: theme.tabs.background
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledTabs__["c" /* StyledTabsHeader */], {
      as: __WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */],
      direction: "row",
      justify: justify,
      flex: false,
      wrap: true,
      background: theme.tabs.header.background,
      gap: theme.tabs.gap
    }, tabs), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledTabs__["a" /* StyledTabPanel */], {
      flex: flex,
      "aria-label": tabContentTitle,
      role: "tabpanel"
    }, activeContent));
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Tabs, "defaultProps", {
  justify: 'center',
  messages: {
    tabContents: 'Tab Contents'
  },
  responsive: true
});

Object.setPrototypeOf(Tabs.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var TabsDoc;

if (false) {
  TabsDoc = require('./doc').doc(Tabs); // eslint-disable-line global-require
}

var TabsWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(TabsDoc || Tabs);


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledTabsHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledTabPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledTabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);
var _FLEX_MAP;




var StyledTabsHeader = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledTabs__StyledTabsHeader",
  componentId: "a4fwxl-0"
})(["", ";"], function (props) {
  return props.theme.tabs.header.extend;
});
StyledTabsHeader.defaultProps = {};
Object.setPrototypeOf(StyledTabsHeader.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var FLEX_MAP = (_FLEX_MAP = {}, _FLEX_MAP[true] = '1 1', _FLEX_MAP[false] = '0 0', _FLEX_MAP.grow = '1 0', _FLEX_MAP.shrink = '0 1', _FLEX_MAP);
var flexStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["flex:", ";"], function (props) {
  return "" + FLEX_MAP[props.flex] + (props.flex !== true ? ' auto' : '');
});
var StyledTabPanel = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledTabs__StyledTabPanel",
  componentId: "a4fwxl-1"
})(["min-height:0;", " ", ";"], function (props) {
  return props.flex && flexStyle;
}, function (props) {
  return props.theme.tabs.panel.extend;
});
StyledTabPanel.defaultProps = {};
Object.setPrototypeOf(StyledTabPanel.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledTabs = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledTabs",
  componentId: "a4fwxl-2"
})(["", " ", ";"], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return props.theme.tabs.extend;
});
StyledTabs.defaultProps = {};
Object.setPrototypeOf(StyledTabs.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextArea__ = __webpack_require__(519);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextArea__["a"]; });


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextAreaWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Keyboard__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyledTextArea__ = __webpack_require__(520);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var TextArea =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TextArea, _Component);

  function TextArea() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onEsc", function (event) {
      // we have to stop both synthetic events and native events
      // drop and layer should not close by pressing esc on this input
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    });

    return _this;
  }

  var _proto = TextArea.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        fill = _this$props.fill,
        forwardRef = _this$props.forwardRef,
        rest = _objectWithoutPropertiesLoose(_this$props, ["fill", "forwardRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Keyboard__["a" /* Keyboard */], {
      onEsc: this.onEsc
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StyledTextArea__["a" /* StyledTextArea */], _extends({
      ref: forwardRef,
      fillArg: fill
    }, rest)));
  };

  return TextArea;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var TextAreaDoc;

if (false) {
  TextAreaDoc = require('./doc').doc(TextArea); // eslint-disable-line global-require
}

var TextAreaWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_3__hocs__["c" /* withFocus */], __WEBPACK_IMPORTED_MODULE_3__hocs__["d" /* withForwardRef */])(TextAreaDoc || TextArea);


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledTextArea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var plainStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["border:none;width:100%;-webkit-appearance:none;"]);
var StyledTextArea = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].textarea.withConfig({
  displayName: "StyledTextArea",
  componentId: "sc-17i3mwp-0"
})(["", " width:100%;", " ", " ", " &::-moz-focus-inner{border:none;outline:none;}", ";", ";"], __WEBPACK_IMPORTED_MODULE_1__utils__["v" /* inputStyle */], function (props) {
  return props.fillArg && 'height: 100%;';
}, function (props) {
  return props.plain && plainStyle;
}, __WEBPACK_IMPORTED_MODULE_1__utils__["E" /* placeholderStyle */], function (props) {
  return props.focus && !props.plain && __WEBPACK_IMPORTED_MODULE_1__utils__["p" /* focusStyle */];
}, function (props) {
  return props.theme.textArea && props.theme.textArea.extend;
});
StyledTextArea.defaultProps = {};
Object.setPrototypeOf(StyledTextArea.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Video__ = __webpack_require__(522);
/* unused harmony reexport Video */


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Video */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Box__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Menu__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Meter__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Stack__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hocs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StyledVideo__ = __webpack_require__(523);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













 // Split the volume control into 6 segments. Empirically determined.

var VOLUME_STEP = 0.166667;

var formatTime = function formatTime(time) {
  var minutes = Math.round(time / 60);

  if (minutes < 10) {
    minutes = "0" + minutes;
  }

  var seconds = Math.round(time) % 60;

  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  return minutes + ":" + seconds;
};

var videoEvents = ['onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onError', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting'];

var Video =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Video, _Component);

  Video.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var forwardRef = nextProps.forwardRef;
    var videoRef = prevState.videoRef;
    var nextVideoRef = forwardRef || videoRef;

    if (nextVideoRef !== videoRef) {
      return {
        videoRef: nextVideoRef
      };
    }

    return null;
  };

  function Video(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      captions: [],
      scrubberRef: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef(),
      videoRef: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef()
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hasPlayed", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "injectUpdateVideoEvents", function () {
      return videoEvents.reduce(function (previousValue, currentValue) {
        var nextValue = _extends({}, previousValue);

        nextValue[currentValue] = function (e) {
          if (currentValue in _this.props &&
          /* eslint-disable react/destructuring-assignment */
          typeof _this.props[currentValue] === 'function') {
            _this.props[currentValue](e);
            /* eslint-enable react/destructuring-assignment */

          }

          _this.update();
        };

        return nextValue;
      }, {});
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "update", function () {
      var videoRef = _this.state.videoRef;
      var video = videoRef.current; // Set flag for Video first play

      if (!_this.hasPlayed && !video.paused && !video.loading || video.currentTime) {
        _this.hasPlayed = true;
      }

      var interacting = _this.state.interacting;

      if (video.ended) {
        interacting = false;
      }

      _this.setState({
        duration: video.duration,
        currentTime: video.currentTime,
        // buffered: video.buffered,
        // paused: video.paused,
        // muted: video.muted,
        volume: video.volume,
        // ended: video.ended,
        // readyState: video.readyState,
        interacting: interacting,
        // computed values
        // hasPlayed: this.hasPlayed,
        playing: !video.paused && !video.loading,
        // percentageBuffered: video.buffered.length &&
        //   (video.buffered.end(video.buffered.length - 1) /
        //   video.duration) * 100,
        percentagePlayed: video.currentTime / video.duration * 100 // loading: video.readyState < video.HAVE_ENOUGH_DATA,

      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "play", function () {
      var videoRef = _this.state.videoRef;
      videoRef.current.play();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "pause", function () {
      var videoRef = _this.state.videoRef;
      videoRef.current.pause();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrub", function (event) {
      var _this$state = _this.state,
          duration = _this$state.duration,
          scrubberRef = _this$state.scrubberRef;

      if (scrubberRef.current) {
        var scrubberRect = scrubberRef.current.getBoundingClientRect();
        var percent = (event.clientX - scrubberRect.left) / scrubberRect.width;

        _this.setState({
          scrubTime: duration * percent
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "seek", function (event) {
      var _this$state2 = _this.state,
          duration = _this$state2.duration,
          scrubberRef = _this$state2.scrubberRef,
          videoRef = _this$state2.videoRef;

      if (scrubberRef.current) {
        var scrubberRect = scrubberRef.current.getBoundingClientRect();
        var percent = (event.clientX - scrubberRect.left) / scrubberRect.width;
        videoRef.current.currentTime = duration * percent;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "unmute", function () {
      var videoRef = _this.state.videoRef;

      if (videoRef.current) {
        videoRef.current.muted = false;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mute", function () {
      var videoRef = _this.state.videoRef;

      if (videoRef.current) {
        videoRef.current.muted = true;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "louder", function () {
      var videoRef = _this.state.videoRef;
      videoRef.current.volume += VOLUME_STEP;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "quieter", function () {
      var videoRef = _this.state.videoRef;
      videoRef.current.volume -= VOLUME_STEP;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showCaptions", function (index) {
      var videoRef = _this.state.videoRef;
      var textTracks = videoRef.current.textTracks;

      for (var i = 0; i < textTracks.length; i += 1) {
        textTracks[i].mode = i === index ? 'showing' : 'hidden';
      } // Using forceUpdate to force redraw of controls when changing captions


      _this.forceUpdate();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "fullscreen", function () {
      var videoRef = _this.state.videoRef;
      var video = videoRef.current;

      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      } else {
        console.warn("Your browser doesn't support fullscreen.");
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "interactionStart", function () {
      _this.setState({
        interacting: true
      });

      clearTimeout(_this.interactionTimer);
      _this.interactionTimer = setTimeout(_this.interactionStop, 3000);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "interactionStop", function () {
      var focus = _this.state.focus;

      if (!focus && !_this.unmounted) {
        _this.setState({
          interacting: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "restate", function () {
      var _this$state3 = _this.state,
          captions = _this$state3.captions,
          height = _this$state3.height,
          videoRef = _this$state3.videoRef,
          width = _this$state3.width;
      var video = videoRef.current;

      if (video) {
        if (video.videoHeight) {
          // set the size based on the video aspect ratio
          var rect = video.getBoundingClientRect();
          var ratio = rect.width / rect.height;
          var videoRatio = video.videoWidth / video.videoHeight;

          if (videoRatio > ratio) {
            var nextHeight = rect.width / videoRatio;

            if (nextHeight !== height) {
              _this.setState({
                height: nextHeight,
                width: undefined
              });
            }
          } else {
            var nextWidth = rect.height * videoRatio;

            if (nextWidth !== width) {
              _this.setState({
                height: undefined,
                width: nextWidth
              });
            }
          }
        } // remember the state of the text tracks for subsequent rendering


        var textTracks = video.textTracks;

        if (textTracks.length > 0) {
          if (textTracks.length === 1) {
            var active = textTracks[0].mode === 'showing';

            if (!captions || !captions[0] || captions[0].active !== active) {
              _this.setState({
                captions: [{
                  active: active
                }]
              });
            }
          } else {
            var nextCaptions = [];
            var set = false;

            for (var i = 0; i < textTracks.length; i += 1) {
              var track = textTracks[i];

              var _active = track.mode === 'showing';

              nextCaptions.push({
                label: track.label,
                active: _active
              });

              if (!captions || !captions[i] || captions[i].active !== _active) {
                set = true;
              }
            }

            if (set) {
              _this.setState({
                captions: nextCaptions
              });
            }
          }
        }
      }
    });

    _this.update = Object(__WEBPACK_IMPORTED_MODULE_11__utils__["I" /* throttle */])(_this.update, 100, _assertThisInitialized(_assertThisInitialized(_this)));
    _this.mediaEventProps = _this.injectUpdateVideoEvents();
    return _this;
  }

  var _proto = Video.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var mute = this.props.mute;
    var videoRef = this.state.videoRef;
    var video = videoRef.current;

    if (mute) {
      this.mute();
    }

    if (video) {
      // hide all captioning to start with
      var textTracks = video.textTracks;

      for (var i = 0; i < textTracks.length; i += 1) {
        textTracks[i].mode = 'hidden';
      }

      this.restate();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var autoPlay = this.props.autoPlay;

    if (autoPlay && !prevProps.autoPlay) {
      // Caller wants the video to play now.
      this.play();
    }

    this.restate();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;
  };

  _proto.renderControls = function renderControls() {
    var _this2 = this;

    var _this$props = this.props,
        controls = _this$props.controls,
        theme = _this$props.theme;
    var _this$state4 = this.state,
        captions = _this$state4.captions,
        currentTime = _this$state4.currentTime,
        duration = _this$state4.duration,
        interacting = _this$state4.interacting,
        percentagePlayed = _this$state4.percentagePlayed,
        playing = _this$state4.playing,
        scrubberRef = _this$state4.scrubberRef,
        scrubTime = _this$state4.scrubTime,
        volume = _this$state4.volume;
    var over = controls === 'over';
    var background = over && (theme.video.controls && theme.video.controls.background || {
      color: 'dark-1',
      opacity: 'strong'
    });
    var iconColor = over && (theme.video.icons.color || 'light-1');
    var formattedTime = formatTime(scrubTime || currentTime || duration);
    var Icons = {
      ClosedCaption: theme.video.icons.closedCaption,
      Configure: theme.video.icons.configure,
      FullScreen: theme.video.icons.fullScreen,
      Pause: theme.video.icons.pause,
      Play: theme.video.icons.play,
      ReduceVolume: theme.video.icons.reduceVolume,
      Volume: theme.video.icons.volume
    };
    var captionControls = captions.map(function (caption) {
      return {
        icon: caption.label ? undefined : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.ClosedCaption, {
          color: iconColor
        }),
        label: caption.label,
        active: caption.active,
        onClick: function onClick() {
          return _this2.showCaptions(caption.active ? -1 : 0);
        }
      };
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__StyledVideo__["c" /* StyledVideoControls */], {
      over: over,
      active: !this.hasPlayed || controls === 'below' || over && interacting
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
      direction: "row",
      align: "center",
      justify: "between",
      background: background
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* Button */], {
      icon: playing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.Pause, {
        color: iconColor
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.Play, {
        color: iconColor
      }),
      hoverIndicator: "background",
      onClick: playing ? this.pause : this.play
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
      direction: "row",
      align: "center",
      flex: true
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
      flex: true
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Stack__["a" /* Stack */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Meter__["a" /* Meter */], {
      "aria-label": "Video progress",
      background: over && (theme.video.scrubber && theme.video.scrubber.track.color || 'dark-3'),
      size: "full",
      thickness: "small",
      values: [{
        value: percentagePlayed || 0
      }]
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__StyledVideo__["d" /* StyledVideoScrubber */], {
      ref: scrubberRef,
      tabIndex: 0,
      role: "button",
      value: scrubTime ? Math.round(scrubTime / duration * 100) : undefined,
      onMouseMove: this.scrub,
      onMouseLeave: function onMouseLeave() {
        return _this2.setState({
          scrubTime: undefined
        });
      },
      onClick: this.seek
    }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Box__["a" /* Box */], {
      pad: {
        horizontal: 'small'
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Text__["a" /* Text */], {
      margin: "none"
    }, formattedTime))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Menu__["a" /* Menu */], {
      icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.Configure, {
        color: iconColor
      }),
      dropAlign: {
        bottom: 'top',
        right: 'right'
      },
      dropBackground: background,
      items: [{
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.Volume, {
          color: iconColor
        }),
        onClick: volume <= 1 - VOLUME_STEP ? this.louder : undefined,
        close: false
      }, {
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.ReduceVolume, {
          color: iconColor
        }),
        onClick: volume >= VOLUME_STEP ? this.quieter : undefined,
        close: false
      }].concat(captionControls, [{
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.FullScreen, {
          color: iconColor
        }),
        onClick: this.fullscreen
      }])
    })));
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        alignSelf = _this$props2.alignSelf,
        autoPlay = _this$props2.autoPlay,
        children = _this$props2.children,
        controls = _this$props2.controls,
        gridArea = _this$props2.gridArea,
        loop = _this$props2.loop,
        margin = _this$props2.margin,
        theme = _this$props2.theme,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["alignSelf", "autoPlay", "children", "controls", "gridArea", "loop", "margin", "theme"]);

    var _this$state5 = this.state,
        height = _this$state5.height,
        videoRef = _this$state5.videoRef,
        width = _this$state5.width;
    var controlsElement = controls ? this.renderControls() : undefined;
    var mouseEventListeners;

    if (controls === 'over') {
      mouseEventListeners = {
        onMouseEnter: this.interactionStart,
        onMouseMove: this.interactionStart,
        onTouchStart: this.interactionStart
      };
    }

    var style;

    if (rest.fit === 'contain' && controls === 'over') {
      // constrain the size to fit the aspect ratio so the controls overlap correctly
      if (width) {
        style = {
          width: width
        };
      } else if (height) {
        style = {
          height: height
        };
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__StyledVideo__["b" /* StyledVideoContainer */], _extends({}, mouseEventListeners, {
      alignSelf: alignSelf,
      gridArea: gridArea,
      margin: margin,
      style: style
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__StyledVideo__["a" /* StyledVideo */], _extends({}, rest, {
      ref: videoRef
    }, this.mediaEventProps, {
      autoPlay: autoPlay || false,
      loop: loop || false
    }), children), controlsElement);
  };

  return Video;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Video, "defaultProps", {
  controls: 'over'
});

Object.setPrototypeOf(Video.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var VideoDoc;

if (false) {
  VideoDoc = require('./doc').doc(Video); // eslint-disable-line global-require
}

var VideoWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */], __WEBPACK_IMPORTED_MODULE_10__hocs__["d" /* withForwardRef */])(VideoDoc || Video);


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledVideoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledVideoControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StyledVideoScrubber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var FIT_MAP = {
  cover: 'cover',
  contain: 'contain'
};
var fitStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["flex:1 1;min-height:0;object-fit:", ";"], function (props) {
  return FIT_MAP[props.fit];
});
var StyledVideo = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].video.withConfig({
  displayName: "StyledVideo",
  componentId: "w4v8h9-0"
})(["max-width:100%;", "::cue{background:", ";}", ";"], function (props) {
  return props.fit && fitStyle;
}, function (props) {
  return props.theme.video.captions.background;
}, function (props) {
  return props.theme.video && props.theme.video.extend;
});
StyledVideo.defaultProps = {};
Object.setPrototypeOf(StyledVideo.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var StyledVideoContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledVideo__StyledVideoContainer",
  componentId: "w4v8h9-1"
})(["flex:1 1;display:flex;flex-direction:column;overflow:hidden;position:relative;", ";"], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */]);
StyledVideoContainer.defaultProps = {};
Object.setPrototypeOf(StyledVideoContainer.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var positionStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["position:absolute;left:0;right:0;bottom:0;"]);
var StyledVideoControls = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledVideo__StyledVideoControls",
  componentId: "w4v8h9-2"
})(["flex:0 0;", " opacity:0;transition:opacity 0.3s;", ";"], function (props) {
  return props.over && positionStyle;
}, function (props) {
  return props.active ? 'opacity: 1;' : 'pointer-events: none';
});
StyledVideoControls.defaultProps = {};
Object.setPrototypeOf(StyledVideoControls.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);
var headStyle = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["::after{content:'';height:100%;width:", ";background:", ";position:absolute;left:", ";}"], function (props) {
  return props.theme.global.edgeSize.xsmall;
}, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["B" /* normalizeColor */])('light-4', props.theme);
}, function (props) {
  return props.value + "%";
});
var StyledVideoScrubber = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
  displayName: "StyledVideo__StyledVideoScrubber",
  componentId: "w4v8h9-3"
})(["cursor:pointer;", ";"], function (props) {
  return props.value && headStyle;
});
StyledVideoScrubber.defaultProps = {};
Object.setPrototypeOf(StyledVideoScrubber.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WorldMap__ = __webpack_require__(525);
/* unused harmony reexport WorldMap */


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WorldMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StyledWorldMap__ = __webpack_require__(526);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






 // The graphic is drawn as a rectangular grid using coordinates spaced
// by FACTOR pixels. The contents have both an area boundary for interaction
// and dots described as rows where each row is described by three values:
// a starting coordinate and a length. This approach is more efficient than
// describing it via SVG elements, keeping the code/library size smaller.

var CONTINENTS = [{
  name: 'Australia',
  origin: [74, 32],
  area: [[4, 0], [7, 1], [15, 7], [13, 9], [0, 6], [0, 2]],
  dots: [[4, 0, 1], [2, 1, 6], [0, 2, 9], [0, 3, 10], [0, 4, 10], [0, 5, 3], [5, 5, 5], [5, 6, 4], [15, 7, 1], [14, 8, 1], [13, 9, 1]]
}, {
  name: 'Asia',
  origin: [52, 1],
  area: [[16, 0], [38, 5], [40, 7], [28, 17], [24, 25], [29, 29], [19, 29], [11, 24], [3, 23], [0, 20], [0, 19], [6, 13], [7, 6]],
  dots: [[16, 0, 1], [17, 1, 2], [18, 2, 2], [15, 3, 6], [28, 3, 1], [30, 3, 1], [10, 4, 2], [13, 4, 10], [24, 4, 1], [9, 5, 22], [32, 5, 1], [38, 5, 1], [7, 6, 2], [10, 6, 1], [12, 6, 27], [7, 7, 34], [7, 8, 31], [7, 9, 26], [34, 9, 3], [7, 10, 22], [31, 10, 1], [33, 10, 1], [7, 11, 21], [32, 11, 2], [7, 12, 21], [32, 12, 1], [6, 13, 22], [32, 13, 1], [6, 14, 22], [5, 15, 22], [3, 16, 2], [6, 16, 20], [2, 17, 3], [6, 17, 16], [24, 17, 1], [28, 17, 1], [1, 18, 22], [26, 18, 2], [0, 19, 24], [0, 20, 5], [6, 20, 17], [2, 21, 5], [10, 21, 14], [2, 22, 5], [11, 22, 4], [16, 22, 4], [3, 23, 3], [11, 23, 2], [17, 23, 3], [23, 23, 1], [11, 24, 2], [18, 24, 2], [23, 24, 1], [24, 25, 1], [18, 26, 1], [22, 26, 1], [18, 27, 1], [20, 27, 4], [18, 28, 1], [21, 28, 1], [23, 28, 1], [26, 28, 3], [19, 29, 1], [28, 29, 2]]
}, {
  // 21X, 40Y
  name: 'Africa',
  origin: [40, 19],
  area: [[3, 0], [6, 0], [11, 2], [16, 7], [16, 15], [11, 18], [9, 18], [0, 6], [0, 3]],
  dots: [[3, 0, 4], [2, 1, 6], [9, 1, 2], [1, 2, 11], [0, 3, 13], [0, 4, 14], [0, 5, 14], [0, 6, 16], [1, 7, 16], [2, 8, 2], [6, 8, 11], [7, 9, 9], [7, 10, 8], [7, 11, 7], [8, 12, 7], [7, 13, 8], [7, 14, 7], [16, 14, 1], [8, 15, 5], [15, 15, 2], [8, 16, 5], [9, 17, 3], [9, 18, 3]]
}, {
  name: 'Europe',
  origin: [39, 2],
  area: [[8, 0], [10, 0], [20, 2], [19, 11], [18, 13], [14, 16], [3, 16], [0, 7]],
  dots: [[8, 0, 3], [9, 1, 1], [20, 2, 1], [19, 3, 1], [12, 4, 1], [19, 4, 1], [9, 5, 6], [9, 6, 7], [17, 6, 3], [0, 7, 1], [8, 7, 12], [7, 8, 3], [11, 8, 9], [7, 9, 3], [11, 9, 9], [4, 10, 1], [7, 10, 1], [9, 10, 1], [11, 10, 9], [3, 11, 2], [7, 11, 13], [4, 12, 1], [6, 12, 13], [4, 13, 15], [5, 14, 3], [9, 14, 4], [15, 14, 2], [3, 15, 3], [8, 15, 1], [10, 15, 5], [6, 15, 2], [3, 16, 2], [10, 16, 5]]
}, {
  name: 'South America',
  origin: [22, 26],
  area: [[2, 0], [5, 0], [11, 4], [11, 8], [3, 18], [2, 17], [0, 4], [0, 3]],
  dots: [[2, 0, 4], [1, 1, 7], [1, 2, 7], [0, 3, 10], [0, 4, 12], [1, 5, 11], [2, 6, 9], [3, 7, 8], [3, 8, 8], [3, 9, 6], [3, 10, 6], [3, 11, 5], [3, 12, 3], [2, 13, 3], [2, 14, 3], [2, 15, 2], [2, 16, 2], [2, 17, 2], [3, 18, 1]]
}, {
  name: 'North America',
  origin: [0, 0],
  area: [[21, 0], [39, 0], [39, 6], [22, 26], [16, 23], [2, 12], [0, 7]],
  dots: [[22, 0, 6], [29, 0, 1], [31, 0, 1], [33, 0, 5], [20, 1, 1], [22, 1, 1], [24, 1, 2], [27, 1, 13], [17, 2, 1], [20, 2, 5], [26, 2, 13], [13, 3, 1], [19, 3, 1], [21, 3, 3], [26, 3, 14], [14, 4, 1], [16, 4, 4], [21, 4, 3], [29, 4, 11], [12, 5, 3], [16, 5, 1], [18, 5, 1], [20, 5, 3], [24, 5, 1], [30, 5, 8], [14, 6, 3], [19, 6, 1], [22, 6, 4], [31, 6, 8], [0, 7, 15], [16, 7, 1], [18, 7, 4], [24, 7, 2], [30, 7, 7], [2, 8, 20], [24, 8, 3], [29, 8, 5], [2, 9, 20], [24, 9, 2], [30, 9, 3], [1, 10, 18], [23, 10, 2], [31, 10, 1], [2, 11, 2], [8, 11, 11], [23, 11, 2], [26, 11, 1], [2, 12, 1], [8, 12, 13], [24, 12, 3], [10, 13, 12], [23, 13, 5], [11, 14, 17], [11, 15, 9], [21, 15, 6], [28, 15, 2], [11, 16, 11], [23, 16, 4], [11, 17, 14], [12, 18, 11], [12, 19, 12], [13, 20, 9], [15, 21, 3], [22, 21, 1], [16, 22, 2], [16, 23, 2], [20, 23, 1], [23, 23, 1], [18, 24, 3], [21, 25, 1], [22, 26, 1]]
}]; // FACTOR is the distance in pixels between coordinates

var FACTOR = 10;

var maxCoordinate = function maxCoordinate(a, b) {
  return [Math.max(a[0], b[0]), Math.max(a[1], b[1])];
}; // const minCoordinate = (a, b) =>
//   [Math.min(a[0], b[0]), Math.min(a[1], b[1])];
// Based on https://stackoverflow.com/a/43861247


var MAP_LAT_BOTTOM = -50.0; // empirically determined

var MAP_LAT_BOTTOM_RAD = MAP_LAT_BOTTOM * Math.PI / 180;
var MAP_LON_LEFT = -171.0; // empirically determined

var MAP_LON_RIGHT = 184.0; // empirically determined

var MAP_LON_DELTA = MAP_LON_RIGHT - MAP_LON_LEFT;

var mapValues = function mapValues(extent) {
  var mapRadius = extent[0] / MAP_LON_DELTA * 360 / (2 * Math.PI);
  var mapOffsetY = Math.round(mapRadius / 2 * Math.log((1 + Math.sin(MAP_LAT_BOTTOM_RAD)) / (1 - Math.sin(MAP_LAT_BOTTOM_RAD))));
  return {
    mapRadius: mapRadius,
    mapOffsetY: mapOffsetY
  };
};

var latLonToCoord = function latLonToCoord(latLon, origin, extent) {
  var _mapValues = mapValues(extent),
      mapRadius = _mapValues.mapRadius,
      mapOffsetY = _mapValues.mapOffsetY;

  var x = Math.round((latLon[1] - MAP_LON_LEFT) * extent[0] / MAP_LON_DELTA);
  var latitudeRad = latLon[0] * Math.PI / 180;
  var y = extent[1] + mapOffsetY - Math.round(mapRadius / 2 * Math.log((1 + Math.sin(latitudeRad)) / (1 - Math.sin(latitudeRad))));
  return [x, y]; // the coordinate value of this point on the map image
};

var coordToLatLon = function coordToLatLon(coord, origin, extent) {
  var _mapValues2 = mapValues(extent),
      mapRadius = _mapValues2.mapRadius,
      mapOffsetY = _mapValues2.mapOffsetY;

  var a = (extent[1] + mapOffsetY - coord[1]) / mapRadius;
  var lat = 180 / Math.PI * (2 * Math.atan(Math.exp(a)) - Math.PI / 2);
  var lon = coord[0] * MAP_LON_DELTA / extent[0] + MAP_LON_LEFT;
  return [lat, lon];
};

var buildContinentState = function buildContinentState(_ref) {
  var area = _ref.area,
      dots = _ref.dots,
      origin = _ref.origin;
  var extent = origin.concat();
  var stateDots = dots.map(function (segment) {
    var count = segment[2];
    var spots = [];

    for (var i = 0; i < count; i += 1) {
      spots.push('h0');
    }

    var dotCommands = spots.join(' m10,0 ');
    var x = FACTOR * (origin[0] + segment[0] + 1);
    var y = FACTOR * (origin[1] + segment[1] + 1);
    extent = maxCoordinate(extent, [origin[0] + segment[0] + segment[2], origin[1] + segment[1]]);
    return "M" + x + "," + y + " " + dotCommands;
  }).join(' ');
  var stateArea = area.map(function (point, index) {
    var x = FACTOR * (point[0] + origin[0] + 1);
    var y = FACTOR * (point[1] + origin[1] + 1);
    return "" + (index === 0 ? 'M' : 'L') + x + "," + y;
  }).join(' ') + " Z";
  var mid = [origin[0] + (extent[0] - origin[0]) / 2, origin[1] + (extent[1] - origin[1]) / 2];
  return {
    area: stateArea,
    dots: stateDots,
    origin: origin,
    extent: extent,
    mid: mid
  };
};

var buildState = function buildState() {
  var continents = {}; // Build the SVG paths describing the individual dots

  var origin = [0, 0];
  var extent = [0, 0];
  CONTINENTS.forEach(function (continent) {
    continents[continent.name] = buildContinentState(continent);
    extent = maxCoordinate(extent, continents[continent.name].extent);
  });
  return {
    continents: continents,
    extent: extent,
    origin: origin,
    x: origin[0] * FACTOR,
    y: origin[1] * FACTOR,
    width: (extent[0] - origin[0] + 1) * FACTOR,
    height: (extent[1] - origin[1] + 2) * FACTOR
  };
};

var updateState = function updateState(state, _ref2) {
  var continents = _ref2.continents,
      places = _ref2.places;

  var nextState = _extends({}, state);

  if (continents) {
    continents.forEach(function (continent) {
      nextState.continents[continent.name] = _extends({}, state.continents[continent.name], continent);
    });
  }

  nextState.places = (places || []).map(function (_ref3) {
    var location = _ref3.location,
        place = _objectWithoutPropertiesLoose(_ref3, ["location"]);

    var coords = latLonToCoord(location, state.origin, state.extent);
    return _extends({
      coords: coords,
      key: location.join(',')
    }, place);
  });
  return nextState;
};

var buildInteractiveProps = function buildInteractiveProps(_ref4, activeFunc, active) {
  var name = _ref4.name,
      onClick = _ref4.onClick,
      onHover = _ref4.onHover;
  return {
    role: 'button',
    'aria-label': name,
    tabIndex: '0',
    onClick: onClick ? function () {
      return onClick(name);
    } : undefined,
    onMouseOver: function onMouseOver() {
      if (!active) {
        activeFunc(name);

        if (onHover) {
          onHover(true);
        }
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (active) {
        activeFunc(undefined);

        if (onHover) {
          onHover(false);
        }
      }
    },
    onFocus: function onFocus() {
      // This moves the map unnecessarily. Instead, we should check
      // the position and scroll if it isn't already visible
      // this._worldMapRef.scrollIntoView();
      if (!active) {
        activeFunc(name);
      }
    },
    onBlur: function onBlur() {
      if (active) {
        activeFunc(undefined);
      }
    }
  };
};

var WorldMap =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(WorldMap, _Component);

  function WorldMap() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseOver", function () {
      // track when we're over the map to avoid dealing with mouse moves
      _this.setState({
        over: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseMove", function (event) {
      var width = _this.state.width; // determine the map coordinates for where the mouse is
      // containerRef uses the group so we can handle aspect ratio scaling

      var rect = _this.containerRef.getBoundingClientRect();

      var scale = rect.width / width; // since the SVG viewBox might be scaled

      var coords = [Math.round((event.clientX - rect.left) / scale / FACTOR), Math.round((event.clientY - rect.top) / scale / FACTOR)];

      _this.setState({
        activeCoords: coords
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseLeave", function () {
      _this.setState({
        over: false,
        activeCoords: undefined
      });
    });

    return _this;
  }

  WorldMap.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.continents) {
      return updateState(buildState(), nextProps);
    }

    return updateState(prevState, nextProps);
  };

  var _proto = WorldMap.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        color = _this$props.color,
        onSelectPlace = _this$props.onSelectPlace,
        hoverColor = _this$props.hoverColor,
        theme = _this$props.theme,
        rest = _objectWithoutPropertiesLoose(_this$props, ["color", "onSelectPlace", "hoverColor", "theme"]);

    delete rest.places;
    delete rest.continents;
    var _this$state = this.state,
        activeContinent = _this$state.activeContinent,
        activeCoords = _this$state.activeCoords,
        activePlace = _this$state.activePlace,
        continentStates = _this$state.continents,
        extent = _this$state.extent,
        origin = _this$state.origin,
        over = _this$state.over,
        placeStates = _this$state.places,
        x = _this$state.x,
        y = _this$state.y,
        width = _this$state.width,
        height = _this$state.height;
    var continents = Object.keys(continentStates).map(function (name) {
      var _continentStates$name = continentStates[name],
          area = _continentStates$name.area,
          continentColor = _continentStates$name.color,
          dots = _continentStates$name.dots,
          onClick = _continentStates$name.onClick,
          onHover = _continentStates$name.onHover;
      var active = activeContinent && activeContinent === name;
      var interactiveProps = {};

      if (onClick || onHover) {
        interactiveProps = buildInteractiveProps(continentStates[name], function (activate) {
          return _this2.setState({
            activeContinent: activate
          });
        }, active);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", _extends({
        key: name
      }, interactiveProps), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        stroke: "none",
        fill: "#fff",
        fillOpacity: "0.01",
        d: area
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: dots,
        strokeLinecap: "round",
        strokeWidth: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["D" /* parseMetricToNum */])(theme.worldMap.continent[active ? 'active' : 'base']),
        stroke: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["B" /* normalizeColor */])(continentColor || color || theme.worldMap.color, theme)
      }));
    });
    var places = placeStates.map(function (place) {
      var placeColor = place.color,
          coords = place.coords,
          key = place.key,
          name = place.name,
          onClick = place.onClick,
          onHover = place.onHover,
          restPlace = _objectWithoutPropertiesLoose(place, ["color", "coords", "key", "name", "onClick", "onHover"]);

      var d = "M" + FACTOR * coords[0] + ", " + FACTOR * coords[1] + " h0";
      var active = activePlace && activePlace === name;
      var interactiveProps = {};

      if (onClick || onHover) {
        interactiveProps = buildInteractiveProps(place, function (activate) {
          return _this2.setState({
            activePlace: activate
          });
        }, active);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({
        key: key,
        strokeLinecap: "round",
        strokeWidth: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["D" /* parseMetricToNum */])(theme.worldMap.place[active ? 'active' : 'base']),
        stroke: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["B" /* normalizeColor */])(placeColor || color || theme.worldMap.color, theme)
      }, interactiveProps, restPlace, {
        d: d
      }));
    }); // If the caller is interested in onSelectPlace changes, track where the

    var interactiveProps = {};

    if (onSelectPlace) {
      interactiveProps = {
        onMouseOver: this.onMouseOver,
        onMouseMove: over ? this.onMouseMove : undefined,
        onMouseLeave: this.onMouseLeave
      };
    }

    var active;

    if (activeCoords) {
      var d = "M" + FACTOR * activeCoords[0] + ", " + FACTOR * activeCoords[1] + " h0";
      active = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
        stroke: "none",
        fill: "none",
        fillRule: "evenodd",
        onClick: function onClick() {
          return onSelectPlace(coordToLatLon(activeCoords, origin, extent));
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        strokeLinecap: "round",
        strokeWidth: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["D" /* parseMetricToNum */])(theme.worldMap.place.active),
        stroke: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["B" /* normalizeColor */])(hoverColor || color || theme.worldMap.hover.color, theme),
        d: d
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StyledWorldMap__["a" /* StyledWorldMap */], _extends({
      viewBox: x + " " + y + " " + width + " " + height,
      preserveAspectRatio: "xMinYMin meet",
      width: width,
      height: height
    }, interactiveProps, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
      ref: function ref(_ref5) {
        _this2.containerRef = _ref5;
      },
      stroke: "none",
      fill: "none",
      fillRule: "evenodd"
    }, continents), places, active);
  };

  return WorldMap;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

WorldMap.defaultProps = {};
Object.setPrototypeOf(WorldMap.defaultProps, __WEBPACK_IMPORTED_MODULE_3__default_props__["a" /* defaultProps */]);
var WorldMapDoc;

if (false) {
  WorldMapDoc = require('./doc').doc(WorldMap); // eslint-disable-line global-require
}

var WorldMapWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* withTheme */])(WorldMapDoc || WorldMap);


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledWorldMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_props__ = __webpack_require__(6);



var StyledWorldMap = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].svg.withConfig({
  displayName: "StyledWorldMap",
  componentId: "had4c3-0"
})(["width:100%;", " ", ";"], __WEBPACK_IMPORTED_MODULE_1__utils__["q" /* genericStyles */], function (props) {
  return props.theme.worldMap && props.theme.worldMap.extend;
});
StyledWorldMap.defaultProps = {};
Object.setPrototypeOf(StyledWorldMap.defaultProps, __WEBPACK_IMPORTED_MODULE_2__default_props__["a" /* defaultProps */]);


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_style_theme__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_book__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_layoutEngine__ = __webpack_require__(37);
var _templateObject=_taggedTemplateLiteral(["\n  max-width: 600px;\n  z-index: 1;\n"],["\n  max-width: 600px;\n  z-index: 1;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  height: 100vh;\n  width: 100%;\n  max-width: 768px;\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: -1;\n  background-color: ",";\n"],["\n  height: 100vh;\n  width: 100%;\n  max-width: 768px;\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: -1;\n  background-color: ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n  height: calc(100vh - 70px);\n  @media (max-width: 600px) {\n    height: calc(100vh - 50px);\n  }\n"],["\n  height: calc(100vh - 70px);\n  @media (max-width: 600px) {\n    height: calc(100vh - 50px);\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/*OEF ToC/SECTION MODs*/var layoutEngine=new __WEBPACK_IMPORTED_MODULE_6_app_api_layoutEngine__["a" /* default */](generateLayoutEngine());function generateLayoutEngine(){var elements={};var metadata=__WEBPACK_IMPORTED_MODULE_5_app_api_book__["a" /* default */].metadata,book=_objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_5_app_api_book__["a" /* default */],["metadata"]);__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(book,function(__,element){try{var type=extractBookElementType(element);//console.log("type =  " + type);
type=type.includes("appendix")?"appendix":type;type=type.includes("section II")?"section II":type;type=type.includes("section III")?"section III":type;var BookElement=__webpack_require__(649)("./"+_.chain(type).camelCase().upperFirst().value()).default;elements[type]=BookElement;}catch(error){console.error(error);}});//DEBUG: console.log(elements);
return elements;}function extractBookElementType(element){if(element.includes("appendix"))return"appendix";//DEBUG:  console.log(element);
return element.replace(/[^A-Za-z ]/gi,"");}var Frame=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject);var Background=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_3_app_style_theme__["a" /* default */].global.colors["accent-5"]);var Container=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4_grommet__["d" /* Box */])(_templateObject3);function LayoutEngineComponent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{fill:true,align:"center",pad:"small",overflow:{vertical:"auto",horizontal:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Frame,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Background,null),__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_5_app_api_book__["a" /* default */],function(__,element){return layoutEngine.render({type:extractBookElementType(element),path:["$",element]});})));}/* harmony default export */ __webpack_exports__["a"] = (LayoutEngineComponent);

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(530);
module.exports = __webpack_require__(24).String.includes;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(33);
var context = __webpack_require__(166);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(167)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(532);
module.exports = __webpack_require__(24).Object.assign;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(33);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(533) });


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(115);
var gOPS = __webpack_require__(534);
var pIE = __webpack_require__(535);
var toObject = __webpack_require__(111);
var IObject = __webpack_require__(110);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(107)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 534 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 535 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(537);
module.exports = __webpack_require__(24).Number.isNaN;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(33);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*! jsonpath 1.0.2 */

(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.jsonpath = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"./aesprim":[function(require,module,exports){
/*
  Copyright (C) 2013 Ariya Hidayat <ariya.hidayat@gmail.com>
  Copyright (C) 2013 Thaddee Tyl <thaddee.tyl@gmail.com>
  Copyright (C) 2013 Mathias Bynens <mathias@qiwi.be>
  Copyright (C) 2012 Ariya Hidayat <ariya.hidayat@gmail.com>
  Copyright (C) 2012 Mathias Bynens <mathias@qiwi.be>
  Copyright (C) 2012 Joost-Wim Boekesteijn <joost-wim@boekesteijn.nl>
  Copyright (C) 2012 Kris Kowal <kris.kowal@cixar.com>
  Copyright (C) 2012 Yusuke Suzuki <utatane.tea@gmail.com>
  Copyright (C) 2012 Arpad Borsos <arpad.borsos@googlemail.com>
  Copyright (C) 2011 Ariya Hidayat <ariya.hidayat@gmail.com>

  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

/*jslint bitwise:true plusplus:true */
/*global esprima:true, define:true, exports:true, window: true,
throwErrorTolerant: true,
throwError: true, generateStatement: true, peek: true,
parseAssignmentExpression: true, parseBlock: true, parseExpression: true,
parseFunctionDeclaration: true, parseFunctionExpression: true,
parseFunctionSourceElements: true, parseVariableIdentifier: true,
parseLeftHandSideExpression: true,
parseUnaryExpression: true,
parseStatement: true, parseSourceElement: true */

(function (root, factory) {
    'use strict';

    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js,
    // Rhino, and plain browser loading.

    /* istanbul ignore next */
    if (typeof define === 'function' && define.amd) {
        define(['exports'], factory);
    } else if (typeof exports !== 'undefined') {
        factory(exports);
    } else {
        factory((root.esprima = {}));
    }
}(this, function (exports) {
    'use strict';

    var Token,
        TokenName,
        FnExprTokens,
        Syntax,
        PropertyKind,
        Messages,
        Regex,
        SyntaxTreeDelegate,
        source,
        strict,
        index,
        lineNumber,
        lineStart,
        length,
        delegate,
        lookahead,
        state,
        extra;

    Token = {
        BooleanLiteral: 1,
        EOF: 2,
        Identifier: 3,
        Keyword: 4,
        NullLiteral: 5,
        NumericLiteral: 6,
        Punctuator: 7,
        StringLiteral: 8,
        RegularExpression: 9
    };

    TokenName = {};
    TokenName[Token.BooleanLiteral] = 'Boolean';
    TokenName[Token.EOF] = '<end>';
    TokenName[Token.Identifier] = 'Identifier';
    TokenName[Token.Keyword] = 'Keyword';
    TokenName[Token.NullLiteral] = 'Null';
    TokenName[Token.NumericLiteral] = 'Numeric';
    TokenName[Token.Punctuator] = 'Punctuator';
    TokenName[Token.StringLiteral] = 'String';
    TokenName[Token.RegularExpression] = 'RegularExpression';

    // A function following one of those tokens is an expression.
    FnExprTokens = ['(', '{', '[', 'in', 'typeof', 'instanceof', 'new',
                    'return', 'case', 'delete', 'throw', 'void',
                    // assignment operators
                    '=', '+=', '-=', '*=', '/=', '%=', '<<=', '>>=', '>>>=',
                    '&=', '|=', '^=', ',',
                    // binary/unary operators
                    '+', '-', '*', '/', '%', '++', '--', '<<', '>>', '>>>', '&',
                    '|', '^', '!', '~', '&&', '||', '?', ':', '===', '==', '>=',
                    '<=', '<', '>', '!=', '!=='];

    Syntax = {
        AssignmentExpression: 'AssignmentExpression',
        ArrayExpression: 'ArrayExpression',
        BlockStatement: 'BlockStatement',
        BinaryExpression: 'BinaryExpression',
        BreakStatement: 'BreakStatement',
        CallExpression: 'CallExpression',
        CatchClause: 'CatchClause',
        ConditionalExpression: 'ConditionalExpression',
        ContinueStatement: 'ContinueStatement',
        DoWhileStatement: 'DoWhileStatement',
        DebuggerStatement: 'DebuggerStatement',
        EmptyStatement: 'EmptyStatement',
        ExpressionStatement: 'ExpressionStatement',
        ForStatement: 'ForStatement',
        ForInStatement: 'ForInStatement',
        FunctionDeclaration: 'FunctionDeclaration',
        FunctionExpression: 'FunctionExpression',
        Identifier: 'Identifier',
        IfStatement: 'IfStatement',
        Literal: 'Literal',
        LabeledStatement: 'LabeledStatement',
        LogicalExpression: 'LogicalExpression',
        MemberExpression: 'MemberExpression',
        NewExpression: 'NewExpression',
        ObjectExpression: 'ObjectExpression',
        Program: 'Program',
        Property: 'Property',
        ReturnStatement: 'ReturnStatement',
        SequenceExpression: 'SequenceExpression',
        SwitchStatement: 'SwitchStatement',
        SwitchCase: 'SwitchCase',
        ThisExpression: 'ThisExpression',
        ThrowStatement: 'ThrowStatement',
        TryStatement: 'TryStatement',
        UnaryExpression: 'UnaryExpression',
        UpdateExpression: 'UpdateExpression',
        VariableDeclaration: 'VariableDeclaration',
        VariableDeclarator: 'VariableDeclarator',
        WhileStatement: 'WhileStatement',
        WithStatement: 'WithStatement'
    };

    PropertyKind = {
        Data: 1,
        Get: 2,
        Set: 4
    };

    // Error messages should be identical to V8.
    Messages = {
        UnexpectedToken:  'Unexpected token %0',
        UnexpectedNumber:  'Unexpected number',
        UnexpectedString:  'Unexpected string',
        UnexpectedIdentifier:  'Unexpected identifier',
        UnexpectedReserved:  'Unexpected reserved word',
        UnexpectedEOS:  'Unexpected end of input',
        NewlineAfterThrow:  'Illegal newline after throw',
        InvalidRegExp: 'Invalid regular expression',
        UnterminatedRegExp:  'Invalid regular expression: missing /',
        InvalidLHSInAssignment:  'Invalid left-hand side in assignment',
        InvalidLHSInForIn:  'Invalid left-hand side in for-in',
        MultipleDefaultsInSwitch: 'More than one default clause in switch statement',
        NoCatchOrFinally:  'Missing catch or finally after try',
        UnknownLabel: 'Undefined label \'%0\'',
        Redeclaration: '%0 \'%1\' has already been declared',
        IllegalContinue: 'Illegal continue statement',
        IllegalBreak: 'Illegal break statement',
        IllegalReturn: 'Illegal return statement',
        StrictModeWith:  'Strict mode code may not include a with statement',
        StrictCatchVariable:  'Catch variable may not be eval or arguments in strict mode',
        StrictVarName:  'Variable name may not be eval or arguments in strict mode',
        StrictParamName:  'Parameter name eval or arguments is not allowed in strict mode',
        StrictParamDupe: 'Strict mode function may not have duplicate parameter names',
        StrictFunctionName:  'Function name may not be eval or arguments in strict mode',
        StrictOctalLiteral:  'Octal literals are not allowed in strict mode.',
        StrictDelete:  'Delete of an unqualified identifier in strict mode.',
        StrictDuplicateProperty:  'Duplicate data property in object literal not allowed in strict mode',
        AccessorDataProperty:  'Object literal may not have data and accessor property with the same name',
        AccessorGetSet:  'Object literal may not have multiple get/set accessors with the same name',
        StrictLHSAssignment:  'Assignment to eval or arguments is not allowed in strict mode',
        StrictLHSPostfix:  'Postfix increment/decrement may not have eval or arguments operand in strict mode',
        StrictLHSPrefix:  'Prefix increment/decrement may not have eval or arguments operand in strict mode',
        StrictReservedWord:  'Use of future reserved word in strict mode'
    };

    // See also tools/generate-unicode-regex.py.
    Regex = {
        NonAsciiIdentifierStart: new RegExp('[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F0\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]'),
        NonAsciiIdentifierPart: new RegExp('[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0\u08A2-\u08AC\u08E4-\u08FE\u0900-\u0963\u0966-\u096F\u0971-\u0977\u0979-\u097F\u0981-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58\u0C59\u0C60-\u0C63\u0C66-\u0C6F\u0C82\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D02\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D60-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F0\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191C\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1D00-\u1DE6\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA697\uA69F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7B\uAA80-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE26\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]')
    };

    // Ensure the condition is true, otherwise throw an error.
    // This is only to have a better contract semantic, i.e. another safety net
    // to catch a logic error. The condition shall be fulfilled in normal case.
    // Do NOT use this to enforce a certain condition on any user input.

    function assert(condition, message) {
        /* istanbul ignore if */
        if (!condition) {
            throw new Error('ASSERT: ' + message);
        }
    }

    function isDecimalDigit(ch) {
        return (ch >= 48 && ch <= 57);   // 0..9
    }

    function isHexDigit(ch) {
        return '0123456789abcdefABCDEF'.indexOf(ch) >= 0;
    }

    function isOctalDigit(ch) {
        return '01234567'.indexOf(ch) >= 0;
    }


    // 7.2 White Space

    function isWhiteSpace(ch) {
        return (ch === 0x20) || (ch === 0x09) || (ch === 0x0B) || (ch === 0x0C) || (ch === 0xA0) ||
            (ch >= 0x1680 && [0x1680, 0x180E, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A, 0x202F, 0x205F, 0x3000, 0xFEFF].indexOf(ch) >= 0);
    }

    // 7.3 Line Terminators

    function isLineTerminator(ch) {
        return (ch === 0x0A) || (ch === 0x0D) || (ch === 0x2028) || (ch === 0x2029);
    }

    // 7.6 Identifier Names and Identifiers

    function isIdentifierStart(ch) {
        return (ch == 0x40) ||  (ch === 0x24) || (ch === 0x5F) ||  // $ (dollar) and _ (underscore)
            (ch >= 0x41 && ch <= 0x5A) ||         // A..Z
            (ch >= 0x61 && ch <= 0x7A) ||         // a..z
            (ch === 0x5C) ||                      // \ (backslash)
            ((ch >= 0x80) && Regex.NonAsciiIdentifierStart.test(String.fromCharCode(ch)));
    }

    function isIdentifierPart(ch) {
        return (ch === 0x24) || (ch === 0x5F) ||  // $ (dollar) and _ (underscore)
            (ch >= 0x41 && ch <= 0x5A) ||         // A..Z
            (ch >= 0x61 && ch <= 0x7A) ||         // a..z
            (ch >= 0x30 && ch <= 0x39) ||         // 0..9
            (ch === 0x5C) ||                      // \ (backslash)
            ((ch >= 0x80) && Regex.NonAsciiIdentifierPart.test(String.fromCharCode(ch)));
    }

    // 7.6.1.2 Future Reserved Words

    function isFutureReservedWord(id) {
        switch (id) {
        case 'class':
        case 'enum':
        case 'export':
        case 'extends':
        case 'import':
        case 'super':
            return true;
        default:
            return false;
        }
    }

    function isStrictModeReservedWord(id) {
        switch (id) {
        case 'implements':
        case 'interface':
        case 'package':
        case 'private':
        case 'protected':
        case 'public':
        case 'static':
        case 'yield':
        case 'let':
            return true;
        default:
            return false;
        }
    }

    function isRestrictedWord(id) {
        return id === 'eval' || id === 'arguments';
    }

    // 7.6.1.1 Keywords

    function isKeyword(id) {
        if (strict && isStrictModeReservedWord(id)) {
            return true;
        }

        // 'const' is specialized as Keyword in V8.
        // 'yield' and 'let' are for compatiblity with SpiderMonkey and ES.next.
        // Some others are from future reserved words.

        switch (id.length) {
        case 2:
            return (id === 'if') || (id === 'in') || (id === 'do');
        case 3:
            return (id === 'var') || (id === 'for') || (id === 'new') ||
                (id === 'try') || (id === 'let');
        case 4:
            return (id === 'this') || (id === 'else') || (id === 'case') ||
                (id === 'void') || (id === 'with') || (id === 'enum');
        case 5:
            return (id === 'while') || (id === 'break') || (id === 'catch') ||
                (id === 'throw') || (id === 'const') || (id === 'yield') ||
                (id === 'class') || (id === 'super');
        case 6:
            return (id === 'return') || (id === 'typeof') || (id === 'delete') ||
                (id === 'switch') || (id === 'export') || (id === 'import');
        case 7:
            return (id === 'default') || (id === 'finally') || (id === 'extends');
        case 8:
            return (id === 'function') || (id === 'continue') || (id === 'debugger');
        case 10:
            return (id === 'instanceof');
        default:
            return false;
        }
    }

    // 7.4 Comments

    function addComment(type, value, start, end, loc) {
        var comment, attacher;

        assert(typeof start === 'number', 'Comment must have valid position');

        // Because the way the actual token is scanned, often the comments
        // (if any) are skipped twice during the lexical analysis.
        // Thus, we need to skip adding a comment if the comment array already
        // handled it.
        if (state.lastCommentStart >= start) {
            return;
        }
        state.lastCommentStart = start;

        comment = {
            type: type,
            value: value
        };
        if (extra.range) {
            comment.range = [start, end];
        }
        if (extra.loc) {
            comment.loc = loc;
        }
        extra.comments.push(comment);
        if (extra.attachComment) {
            extra.leadingComments.push(comment);
            extra.trailingComments.push(comment);
        }
    }

    function skipSingleLineComment(offset) {
        var start, loc, ch, comment;

        start = index - offset;
        loc = {
            start: {
                line: lineNumber,
                column: index - lineStart - offset
            }
        };

        while (index < length) {
            ch = source.charCodeAt(index);
            ++index;
            if (isLineTerminator(ch)) {
                if (extra.comments) {
                    comment = source.slice(start + offset, index - 1);
                    loc.end = {
                        line: lineNumber,
                        column: index - lineStart - 1
                    };
                    addComment('Line', comment, start, index - 1, loc);
                }
                if (ch === 13 && source.charCodeAt(index) === 10) {
                    ++index;
                }
                ++lineNumber;
                lineStart = index;
                return;
            }
        }

        if (extra.comments) {
            comment = source.slice(start + offset, index);
            loc.end = {
                line: lineNumber,
                column: index - lineStart
            };
            addComment('Line', comment, start, index, loc);
        }
    }

    function skipMultiLineComment() {
        var start, loc, ch, comment;

        if (extra.comments) {
            start = index - 2;
            loc = {
                start: {
                    line: lineNumber,
                    column: index - lineStart - 2
                }
            };
        }

        while (index < length) {
            ch = source.charCodeAt(index);
            if (isLineTerminator(ch)) {
                if (ch === 0x0D && source.charCodeAt(index + 1) === 0x0A) {
                    ++index;
                }
                ++lineNumber;
                ++index;
                lineStart = index;
                if (index >= length) {
                    throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
                }
            } else if (ch === 0x2A) {
                // Block comment ends with '*/'.
                if (source.charCodeAt(index + 1) === 0x2F) {
                    ++index;
                    ++index;
                    if (extra.comments) {
                        comment = source.slice(start + 2, index - 2);
                        loc.end = {
                            line: lineNumber,
                            column: index - lineStart
                        };
                        addComment('Block', comment, start, index, loc);
                    }
                    return;
                }
                ++index;
            } else {
                ++index;
            }
        }

        throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
    }

    function skipComment() {
        var ch, start;

        start = (index === 0);
        while (index < length) {
            ch = source.charCodeAt(index);

            if (isWhiteSpace(ch)) {
                ++index;
            } else if (isLineTerminator(ch)) {
                ++index;
                if (ch === 0x0D && source.charCodeAt(index) === 0x0A) {
                    ++index;
                }
                ++lineNumber;
                lineStart = index;
                start = true;
            } else if (ch === 0x2F) { // U+002F is '/'
                ch = source.charCodeAt(index + 1);
                if (ch === 0x2F) {
                    ++index;
                    ++index;
                    skipSingleLineComment(2);
                    start = true;
                } else if (ch === 0x2A) {  // U+002A is '*'
                    ++index;
                    ++index;
                    skipMultiLineComment();
                } else {
                    break;
                }
            } else if (start && ch === 0x2D) { // U+002D is '-'
                // U+003E is '>'
                if ((source.charCodeAt(index + 1) === 0x2D) && (source.charCodeAt(index + 2) === 0x3E)) {
                    // '-->' is a single-line comment
                    index += 3;
                    skipSingleLineComment(3);
                } else {
                    break;
                }
            } else if (ch === 0x3C) { // U+003C is '<'
                if (source.slice(index + 1, index + 4) === '!--') {
                    ++index; // `<`
                    ++index; // `!`
                    ++index; // `-`
                    ++index; // `-`
                    skipSingleLineComment(4);
                } else {
                    break;
                }
            } else {
                break;
            }
        }
    }

    function scanHexEscape(prefix) {
        var i, len, ch, code = 0;

        len = (prefix === 'u') ? 4 : 2;
        for (i = 0; i < len; ++i) {
            if (index < length && isHexDigit(source[index])) {
                ch = source[index++];
                code = code * 16 + '0123456789abcdef'.indexOf(ch.toLowerCase());
            } else {
                return '';
            }
        }
        return String.fromCharCode(code);
    }

    function getEscapedIdentifier() {
        var ch, id;

        ch = source.charCodeAt(index++);
        id = String.fromCharCode(ch);

        // '\u' (U+005C, U+0075) denotes an escaped character.
        if (ch === 0x5C) {
            if (source.charCodeAt(index) !== 0x75) {
                throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
            }
            ++index;
            ch = scanHexEscape('u');
            if (!ch || ch === '\\' || !isIdentifierStart(ch.charCodeAt(0))) {
                throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
            }
            id = ch;
        }

        while (index < length) {
            ch = source.charCodeAt(index);
            if (!isIdentifierPart(ch)) {
                break;
            }
            ++index;
            id += String.fromCharCode(ch);

            // '\u' (U+005C, U+0075) denotes an escaped character.
            if (ch === 0x5C) {
                id = id.substr(0, id.length - 1);
                if (source.charCodeAt(index) !== 0x75) {
                    throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
                }
                ++index;
                ch = scanHexEscape('u');
                if (!ch || ch === '\\' || !isIdentifierPart(ch.charCodeAt(0))) {
                    throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
                }
                id += ch;
            }
        }

        return id;
    }

    function getIdentifier() {
        var start, ch;

        start = index++;
        while (index < length) {
            ch = source.charCodeAt(index);
            if (ch === 0x5C) {
                // Blackslash (U+005C) marks Unicode escape sequence.
                index = start;
                return getEscapedIdentifier();
            }
            if (isIdentifierPart(ch)) {
                ++index;
            } else {
                break;
            }
        }

        return source.slice(start, index);
    }

    function scanIdentifier() {
        var start, id, type;

        start = index;

        // Backslash (U+005C) starts an escaped character.
        id = (source.charCodeAt(index) === 0x5C) ? getEscapedIdentifier() : getIdentifier();

        // There is no keyword or literal with only one character.
        // Thus, it must be an identifier.
        if (id.length === 1) {
            type = Token.Identifier;
        } else if (isKeyword(id)) {
            type = Token.Keyword;
        } else if (id === 'null') {
            type = Token.NullLiteral;
        } else if (id === 'true' || id === 'false') {
            type = Token.BooleanLiteral;
        } else {
            type = Token.Identifier;
        }

        return {
            type: type,
            value: id,
            lineNumber: lineNumber,
            lineStart: lineStart,
            start: start,
            end: index
        };
    }


    // 7.7 Punctuators

    function scanPunctuator() {
        var start = index,
            code = source.charCodeAt(index),
            code2,
            ch1 = source[index],
            ch2,
            ch3,
            ch4;

        switch (code) {

        // Check for most common single-character punctuators.
        case 0x2E:  // . dot
        case 0x28:  // ( open bracket
        case 0x29:  // ) close bracket
        case 0x3B:  // ; semicolon
        case 0x2C:  // , comma
        case 0x7B:  // { open curly brace
        case 0x7D:  // } close curly brace
        case 0x5B:  // [
        case 0x5D:  // ]
        case 0x3A:  // :
        case 0x3F:  // ?
        case 0x7E:  // ~
            ++index;
            if (extra.tokenize) {
                if (code === 0x28) {
                    extra.openParenToken = extra.tokens.length;
                } else if (code === 0x7B) {
                    extra.openCurlyToken = extra.tokens.length;
                }
            }
            return {
                type: Token.Punctuator,
                value: String.fromCharCode(code),
                lineNumber: lineNumber,
                lineStart: lineStart,
                start: start,
                end: index
            };

        default:
            code2 = source.charCodeAt(index + 1);

            // '=' (U+003D) marks an assignment or comparison operator.
            if (code2 === 0x3D) {
                switch (code) {
                case 0x2B:  // +
                case 0x2D:  // -
                case 0x2F:  // /
                case 0x3C:  // <
                case 0x3E:  // >
                case 0x5E:  // ^
                case 0x7C:  // |
                case 0x25:  // %
                case 0x26:  // &
                case 0x2A:  // *
                    index += 2;
                    return {
                        type: Token.Punctuator,
                        value: String.fromCharCode(code) + String.fromCharCode(code2),
                        lineNumber: lineNumber,
                        lineStart: lineStart,
                        start: start,
                        end: index
                    };

                case 0x21: // !
                case 0x3D: // =
                    index += 2;

                    // !== and ===
                    if (source.charCodeAt(index) === 0x3D) {
                        ++index;
                    }
                    return {
                        type: Token.Punctuator,
                        value: source.slice(start, index),
                        lineNumber: lineNumber,
                        lineStart: lineStart,
                        start: start,
                        end: index
                    };
                }
            }
        }

        // 4-character punctuator: >>>=

        ch4 = source.substr(index, 4);

        if (ch4 === '>>>=') {
            index += 4;
            return {
                type: Token.Punctuator,
                value: ch4,
                lineNumber: lineNumber,
                lineStart: lineStart,
                start: start,
                end: index
            };
        }

        // 3-character punctuators: === !== >>> <<= >>=

        ch3 = ch4.substr(0, 3);

        if (ch3 === '>>>' || ch3 === '<<=' || ch3 === '>>=') {
            index += 3;
            return {
                type: Token.Punctuator,
                value: ch3,
                lineNumber: lineNumber,
                lineStart: lineStart,
                start: start,
                end: index
            };
        }

        // Other 2-character punctuators: ++ -- << >> && ||
        ch2 = ch3.substr(0, 2);

        if ((ch1 === ch2[1] && ('+-<>&|'.indexOf(ch1) >= 0)) || ch2 === '=>') {
            index += 2;
            return {
                type: Token.Punctuator,
                value: ch2,
                lineNumber: lineNumber,
                lineStart: lineStart,
                start: start,
                end: index
            };
        }

        // 1-character punctuators: < > = ! + - * % & | ^ /
        if ('<>=!+-*%&|^/'.indexOf(ch1) >= 0) {
            ++index;
            return {
                type: Token.Punctuator,
                value: ch1,
                lineNumber: lineNumber,
                lineStart: lineStart,
                start: start,
                end: index
            };
        }

        throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
    }

    // 7.8.3 Numeric Literals

    function scanHexLiteral(start) {
        var number = '';

        while (index < length) {
            if (!isHexDigit(source[index])) {
                break;
            }
            number += source[index++];
        }

        if (number.length === 0) {
            throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
        }

        if (isIdentifierStart(source.charCodeAt(index))) {
            throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
        }

        return {
            type: Token.NumericLiteral,
            value: parseInt('0x' + number, 16),
            lineNumber: lineNumber,
            lineStart: lineStart,
            start: start,
            end: index
        };
    }

    function scanOctalLiteral(start) {
        var number = '0' + source[index++];
        while (index < length) {
            if (!isOctalDigit(source[index])) {
                break;
            }
            number += source[index++];
        }

        if (isIdentifierStart(source.charCodeAt(index)) || isDecimalDigit(source.charCodeAt(index))) {
            throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
        }

        return {
            type: Token.NumericLiteral,
            value: parseInt(number, 8),
            octal: true,
            lineNumber: lineNumber,
            lineStart: lineStart,
            start: start,
            end: index
        };
    }

    function scanNumericLiteral() {
        var number, start, ch;

        ch = source[index];
        assert(isDecimalDigit(ch.charCodeAt(0)) || (ch === '.'),
            'Numeric literal must start with a decimal digit or a decimal point');

        start = index;
        number = '';
        if (ch !== '.') {
            number = source[index++];
            ch = source[index];

            // Hex number starts with '0x'.
            // Octal number starts with '0'.
            if (number === '0') {
                if (ch === 'x' || ch === 'X') {
                    ++index;
                    return scanHexLiteral(start);
                }
                if (isOctalDigit(ch)) {
                    return scanOctalLiteral(start);
                }

                // decimal number starts with '0' such as '09' is illegal.
                if (ch && isDecimalDigit(ch.charCodeAt(0))) {
                    throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
                }
            }

            while (isDecimalDigit(source.charCodeAt(index))) {
                number += source[index++];
            }
            ch = source[index];
        }

        if (ch === '.') {
            number += source[index++];
            while (isDecimalDigit(source.charCodeAt(index))) {
                number += source[index++];
            }
            ch = source[index];
        }

        if (ch === 'e' || ch === 'E') {
            number += source[index++];

            ch = source[index];
            if (ch === '+' || ch === '-') {
                number += source[index++];
            }
            if (isDecimalDigit(source.charCodeAt(index))) {
                while (isDecimalDigit(source.charCodeAt(index))) {
                    number += source[index++];
                }
            } else {
                throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
            }
        }

        if (isIdentifierStart(source.charCodeAt(index))) {
            throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
        }

        return {
            type: Token.NumericLiteral,
            value: parseFloat(number),
            lineNumber: lineNumber,
            lineStart: lineStart,
            start: start,
            end: index
        };
    }

    // 7.8.4 String Literals

    function scanStringLiteral() {
        var str = '', quote, start, ch, code, unescaped, restore, octal = false, startLineNumber, startLineStart;
        startLineNumber = lineNumber;
        startLineStart = lineStart;

        quote = source[index];
        assert((quote === '\'' || quote === '"'),
            'String literal must starts with a quote');

        start = index;
        ++index;

        while (index < length) {
            ch = source[index++];

            if (ch === quote) {
                quote = '';
                break;
            } else if (ch === '\\') {
                ch = source[index++];
                if (!ch || !isLineTerminator(ch.charCodeAt(0))) {
                    switch (ch) {
                    case 'u':
                    case 'x':
                        restore = index;
                        unescaped = scanHexEscape(ch);
                        if (unescaped) {
                            str += unescaped;
                        } else {
                            index = restore;
                            str += ch;
                        }
                        break;
                    case 'n':
                        str += '\n';
                        break;
                    case 'r':
                        str += '\r';
                        break;
                    case 't':
                        str += '\t';
                        break;
                    case 'b':
                        str += '\b';
                        break;
                    case 'f':
                        str += '\f';
                        break;
                    case 'v':
                        str += '\x0B';
                        break;

                    default:
                        if (isOctalDigit(ch)) {
                            code = '01234567'.indexOf(ch);

                            // \0 is not octal escape sequence
                            if (code !== 0) {
                                octal = true;
                            }

                            if (index < length && isOctalDigit(source[index])) {
                                octal = true;
                                code = code * 8 + '01234567'.indexOf(source[index++]);

                                // 3 digits are only allowed when string starts
                                // with 0, 1, 2, 3
                                if ('0123'.indexOf(ch) >= 0 &&
                                        index < length &&
                                        isOctalDigit(source[index])) {
                                    code = code * 8 + '01234567'.indexOf(source[index++]);
                                }
                            }
                            str += String.fromCharCode(code);
                        } else {
                            str += ch;
                        }
                        break;
                    }
                } else {
                    ++lineNumber;
                    if (ch ===  '\r' && source[index] === '\n') {
                        ++index;
                    }
                    lineStart = index;
                }
            } else if (isLineTerminator(ch.charCodeAt(0))) {
                break;
            } else {
                str += ch;
            }
        }

        if (quote !== '') {
            throwError({}, Messages.UnexpectedToken, 'ILLEGAL');
        }

        return {
            type: Token.StringLiteral,
            value: str,
            octal: octal,
            startLineNumber: startLineNumber,
            startLineStart: startLineStart,
            lineNumber: lineNumber,
            lineStart: lineStart,
            start: start,
            end: index
        };
    }

    function testRegExp(pattern, flags) {
        var value;
        try {
            value = new RegExp(pattern, flags);
        } catch (e) {
            throwError({}, Messages.InvalidRegExp);
        }
        return value;
    }

    function scanRegExpBody() {
        var ch, str, classMarker, terminated, body;

        ch = source[index];
        assert(ch === '/', 'Regular expression literal must start with a slash');
        str = source[index++];

        classMarker = false;
        terminated = false;
        while (index < length) {
            ch = source[index++];
            str += ch;
            if (ch === '\\') {
                ch = source[index++];
                // ECMA-262 7.8.5
                if (isLineTerminator(ch.charCodeAt(0))) {
                    throwError({}, Messages.UnterminatedRegExp);
                }
                str += ch;
            } else if (isLineTerminator(ch.charCodeAt(0))) {
                throwError({}, Messages.UnterminatedRegExp);
            } else if (classMarker) {
                if (ch === ']') {
                    classMarker = false;
                }
            } else {
                if (ch === '/') {
                    terminated = true;
                    break;
                } else if (ch === '[') {
                    classMarker = true;
                }
            }
        }

        if (!terminated) {
            throwError({}, Messages.UnterminatedRegExp);
        }

        // Exclude leading and trailing slash.
        body = str.substr(1, str.length - 2);
        return {
            value: body,
            literal: str
        };
    }

    function scanRegExpFlags() {
        var ch, str, flags, restore;

        str = '';
        flags = '';
        while (index < length) {
            ch = source[index];
            if (!isIdentifierPart(ch.charCodeAt(0))) {
                break;
            }

            ++index;
            if (ch === '\\' && index < length) {
                ch = source[index];
                if (ch === 'u') {
                    ++index;
                    restore = index;
                    ch = scanHexEscape('u');
                    if (ch) {
                        flags += ch;
                        for (str += '\\u'; restore < index; ++restore) {
                            str += source[restore];
                        }
                    } else {
                        index = restore;
                        flags += 'u';
                        str += '\\u';
                    }
                    throwErrorTolerant({}, Messages.UnexpectedToken, 'ILLEGAL');
                } else {
                    str += '\\';
                    throwErrorTolerant({}, Messages.UnexpectedToken, 'ILLEGAL');
                }
            } else {
                flags += ch;
                str += ch;
            }
        }

        return {
            value: flags,
            literal: str
        };
    }

    function scanRegExp() {
        var start, body, flags, pattern, value;

        lookahead = null;
        skipComment();
        start = index;

        body = scanRegExpBody();
        flags = scanRegExpFlags();
        value = testRegExp(body.value, flags.value);

        if (extra.tokenize) {
            return {
                type: Token.RegularExpression,
                value: value,
                lineNumber: lineNumber,
                lineStart: lineStart,
                start: start,
                end: index
            };
        }

        return {
            literal: body.literal + flags.literal,
            value: value,
            start: start,
            end: index
        };
    }

    function collectRegex() {
        var pos, loc, regex, token;

        skipComment();

        pos = index;
        loc = {
            start: {
                line: lineNumber,
                column: index - lineStart
            }
        };

        regex = scanRegExp();
        loc.end = {
            line: lineNumber,
            column: index - lineStart
        };

        /* istanbul ignore next */
        if (!extra.tokenize) {
            // Pop the previous token, which is likely '/' or '/='
            if (extra.tokens.length > 0) {
                token = extra.tokens[extra.tokens.length - 1];
                if (token.range[0] === pos && token.type === 'Punctuator') {
                    if (token.value === '/' || token.value === '/=') {
                        extra.tokens.pop();
                    }
                }
            }

            extra.tokens.push({
                type: 'RegularExpression',
                value: regex.literal,
                range: [pos, index],
                loc: loc
            });
        }

        return regex;
    }

    function isIdentifierName(token) {
        return token.type === Token.Identifier ||
            token.type === Token.Keyword ||
            token.type === Token.BooleanLiteral ||
            token.type === Token.NullLiteral;
    }

    function advanceSlash() {
        var prevToken,
            checkToken;
        // Using the following algorithm:
        // https://github.com/mozilla/sweet.js/wiki/design
        prevToken = extra.tokens[extra.tokens.length - 1];
        if (!prevToken) {
            // Nothing before that: it cannot be a division.
            return collectRegex();
        }
        if (prevToken.type === 'Punctuator') {
            if (prevToken.value === ']') {
                return scanPunctuator();
            }
            if (prevToken.value === ')') {
                checkToken = extra.tokens[extra.openParenToken - 1];
                if (checkToken &&
                        checkToken.type === 'Keyword' &&
                        (checkToken.value === 'if' ||
                         checkToken.value === 'while' ||
                         checkToken.value === 'for' ||
                         checkToken.value === 'with')) {
                    return collectRegex();
                }
                return scanPunctuator();
            }
            if (prevToken.value === '}') {
                // Dividing a function by anything makes little sense,
                // but we have to check for that.
                if (extra.tokens[extra.openCurlyToken - 3] &&
                        extra.tokens[extra.openCurlyToken - 3].type === 'Keyword') {
                    // Anonymous function.
                    checkToken = extra.tokens[extra.openCurlyToken - 4];
                    if (!checkToken) {
                        return scanPunctuator();
                    }
                } else if (extra.tokens[extra.openCurlyToken - 4] &&
                        extra.tokens[extra.openCurlyToken - 4].type === 'Keyword') {
                    // Named function.
                    checkToken = extra.tokens[extra.openCurlyToken - 5];
                    if (!checkToken) {
                        return collectRegex();
                    }
                } else {
                    return scanPunctuator();
                }
                // checkToken determines whether the function is
                // a declaration or an expression.
                if (FnExprTokens.indexOf(checkToken.value) >= 0) {
                    // It is an expression.
                    return scanPunctuator();
                }
                // It is a declaration.
                return collectRegex();
            }
            return collectRegex();
        }
        if (prevToken.type === 'Keyword') {
            return collectRegex();
        }
        return scanPunctuator();
    }

    function advance() {
        var ch;

        skipComment();

        if (index >= length) {
            return {
                type: Token.EOF,
                lineNumber: lineNumber,
                lineStart: lineStart,
                start: index,
                end: index
            };
        }

        ch = source.charCodeAt(index);

        if (isIdentifierStart(ch)) {
            return scanIdentifier();
        }

        // Very common: ( and ) and ;
        if (ch === 0x28 || ch === 0x29 || ch === 0x3B) {
            return scanPunctuator();
        }

        // String literal starts with single quote (U+0027) or double quote (U+0022).
        if (ch === 0x27 || ch === 0x22) {
            return scanStringLiteral();
        }


        // Dot (.) U+002E can also start a floating-point number, hence the need
        // to check the next character.
        if (ch === 0x2E) {
            if (isDecimalDigit(source.charCodeAt(index + 1))) {
                return scanNumericLiteral();
            }
            return scanPunctuator();
        }

        if (isDecimalDigit(ch)) {
            return scanNumericLiteral();
        }

        // Slash (/) U+002F can also start a regex.
        if (extra.tokenize && ch === 0x2F) {
            return advanceSlash();
        }

        return scanPunctuator();
    }

    function collectToken() {
        var loc, token, range, value;

        skipComment();
        loc = {
            start: {
                line: lineNumber,
                column: index - lineStart
            }
        };

        token = advance();
        loc.end = {
            line: lineNumber,
            column: index - lineStart
        };

        if (token.type !== Token.EOF) {
            value = source.slice(token.start, token.end);
            extra.tokens.push({
                type: TokenName[token.type],
                value: value,
                range: [token.start, token.end],
                loc: loc
            });
        }

        return token;
    }

    function lex() {
        var token;

        token = lookahead;
        index = token.end;
        lineNumber = token.lineNumber;
        lineStart = token.lineStart;

        lookahead = (typeof extra.tokens !== 'undefined') ? collectToken() : advance();

        index = token.end;
        lineNumber = token.lineNumber;
        lineStart = token.lineStart;

        return token;
    }

    function peek() {
        var pos, line, start;

        pos = index;
        line = lineNumber;
        start = lineStart;
        lookahead = (typeof extra.tokens !== 'undefined') ? collectToken() : advance();
        index = pos;
        lineNumber = line;
        lineStart = start;
    }

    function Position(line, column) {
        this.line = line;
        this.column = column;
    }

    function SourceLocation(startLine, startColumn, line, column) {
        this.start = new Position(startLine, startColumn);
        this.end = new Position(line, column);
    }

    SyntaxTreeDelegate = {

        name: 'SyntaxTree',

        processComment: function (node) {
            var lastChild, trailingComments;

            if (node.type === Syntax.Program) {
                if (node.body.length > 0) {
                    return;
                }
            }

            if (extra.trailingComments.length > 0) {
                if (extra.trailingComments[0].range[0] >= node.range[1]) {
                    trailingComments = extra.trailingComments;
                    extra.trailingComments = [];
                } else {
                    extra.trailingComments.length = 0;
                }
            } else {
                if (extra.bottomRightStack.length > 0 &&
                        extra.bottomRightStack[extra.bottomRightStack.length - 1].trailingComments &&
                        extra.bottomRightStack[extra.bottomRightStack.length - 1].trailingComments[0].range[0] >= node.range[1]) {
                    trailingComments = extra.bottomRightStack[extra.bottomRightStack.length - 1].trailingComments;
                    delete extra.bottomRightStack[extra.bottomRightStack.length - 1].trailingComments;
                }
            }

            // Eating the stack.
            while (extra.bottomRightStack.length > 0 && extra.bottomRightStack[extra.bottomRightStack.length - 1].range[0] >= node.range[0]) {
                lastChild = extra.bottomRightStack.pop();
            }

            if (lastChild) {
                if (lastChild.leadingComments && lastChild.leadingComments[lastChild.leadingComments.length - 1].range[1] <= node.range[0]) {
                    node.leadingComments = lastChild.leadingComments;
                    delete lastChild.leadingComments;
                }
            } else if (extra.leadingComments.length > 0 && extra.leadingComments[extra.leadingComments.length - 1].range[1] <= node.range[0]) {
                node.leadingComments = extra.leadingComments;
                extra.leadingComments = [];
            }


            if (trailingComments) {
                node.trailingComments = trailingComments;
            }

            extra.bottomRightStack.push(node);
        },

        markEnd: function (node, startToken) {
            if (extra.range) {
                node.range = [startToken.start, index];
            }
            if (extra.loc) {
                node.loc = new SourceLocation(
                    startToken.startLineNumber === undefined ?  startToken.lineNumber : startToken.startLineNumber,
                    startToken.start - (startToken.startLineStart === undefined ?  startToken.lineStart : startToken.startLineStart),
                    lineNumber,
                    index - lineStart
                );
                this.postProcess(node);
            }

            if (extra.attachComment) {
                this.processComment(node);
            }
            return node;
        },

        postProcess: function (node) {
            if (extra.source) {
                node.loc.source = extra.source;
            }
            return node;
        },

        createArrayExpression: function (elements) {
            return {
                type: Syntax.ArrayExpression,
                elements: elements
            };
        },

        createAssignmentExpression: function (operator, left, right) {
            return {
                type: Syntax.AssignmentExpression,
                operator: operator,
                left: left,
                right: right
            };
        },

        createBinaryExpression: function (operator, left, right) {
            var type = (operator === '||' || operator === '&&') ? Syntax.LogicalExpression :
                        Syntax.BinaryExpression;
            return {
                type: type,
                operator: operator,
                left: left,
                right: right
            };
        },

        createBlockStatement: function (body) {
            return {
                type: Syntax.BlockStatement,
                body: body
            };
        },

        createBreakStatement: function (label) {
            return {
                type: Syntax.BreakStatement,
                label: label
            };
        },

        createCallExpression: function (callee, args) {
            return {
                type: Syntax.CallExpression,
                callee: callee,
                'arguments': args
            };
        },

        createCatchClause: function (param, body) {
            return {
                type: Syntax.CatchClause,
                param: param,
                body: body
            };
        },

        createConditionalExpression: function (test, consequent, alternate) {
            return {
                type: Syntax.ConditionalExpression,
                test: test,
                consequent: consequent,
                alternate: alternate
            };
        },

        createContinueStatement: function (label) {
            return {
                type: Syntax.ContinueStatement,
                label: label
            };
        },

        createDebuggerStatement: function () {
            return {
                type: Syntax.DebuggerStatement
            };
        },

        createDoWhileStatement: function (body, test) {
            return {
                type: Syntax.DoWhileStatement,
                body: body,
                test: test
            };
        },

        createEmptyStatement: function () {
            return {
                type: Syntax.EmptyStatement
            };
        },

        createExpressionStatement: function (expression) {
            return {
                type: Syntax.ExpressionStatement,
                expression: expression
            };
        },

        createForStatement: function (init, test, update, body) {
            return {
                type: Syntax.ForStatement,
                init: init,
                test: test,
                update: update,
                body: body
            };
        },

        createForInStatement: function (left, right, body) {
            return {
                type: Syntax.ForInStatement,
                left: left,
                right: right,
                body: body,
                each: false
            };
        },

        createFunctionDeclaration: function (id, params, defaults, body) {
            return {
                type: Syntax.FunctionDeclaration,
                id: id,
                params: params,
                defaults: defaults,
                body: body,
                rest: null,
                generator: false,
                expression: false
            };
        },

        createFunctionExpression: function (id, params, defaults, body) {
            return {
                type: Syntax.FunctionExpression,
                id: id,
                params: params,
                defaults: defaults,
                body: body,
                rest: null,
                generator: false,
                expression: false
            };
        },

        createIdentifier: function (name) {
            return {
                type: Syntax.Identifier,
                name: name
            };
        },

        createIfStatement: function (test, consequent, alternate) {
            return {
                type: Syntax.IfStatement,
                test: test,
                consequent: consequent,
                alternate: alternate
            };
        },

        createLabeledStatement: function (label, body) {
            return {
                type: Syntax.LabeledStatement,
                label: label,
                body: body
            };
        },

        createLiteral: function (token) {
            return {
                type: Syntax.Literal,
                value: token.value,
                raw: source.slice(token.start, token.end)
            };
        },

        createMemberExpression: function (accessor, object, property) {
            return {
                type: Syntax.MemberExpression,
                computed: accessor === '[',
                object: object,
                property: property
            };
        },

        createNewExpression: function (callee, args) {
            return {
                type: Syntax.NewExpression,
                callee: callee,
                'arguments': args
            };
        },

        createObjectExpression: function (properties) {
            return {
                type: Syntax.ObjectExpression,
                properties: properties
            };
        },

        createPostfixExpression: function (operator, argument) {
            return {
                type: Syntax.UpdateExpression,
                operator: operator,
                argument: argument,
                prefix: false
            };
        },

        createProgram: function (body) {
            return {
                type: Syntax.Program,
                body: body
            };
        },

        createProperty: function (kind, key, value) {
            return {
                type: Syntax.Property,
                key: key,
                value: value,
                kind: kind
            };
        },

        createReturnStatement: function (argument) {
            return {
                type: Syntax.ReturnStatement,
                argument: argument
            };
        },

        createSequenceExpression: function (expressions) {
            return {
                type: Syntax.SequenceExpression,
                expressions: expressions
            };
        },

        createSwitchCase: function (test, consequent) {
            return {
                type: Syntax.SwitchCase,
                test: test,
                consequent: consequent
            };
        },

        createSwitchStatement: function (discriminant, cases) {
            return {
                type: Syntax.SwitchStatement,
                discriminant: discriminant,
                cases: cases
            };
        },

        createThisExpression: function () {
            return {
                type: Syntax.ThisExpression
            };
        },

        createThrowStatement: function (argument) {
            return {
                type: Syntax.ThrowStatement,
                argument: argument
            };
        },

        createTryStatement: function (block, guardedHandlers, handlers, finalizer) {
            return {
                type: Syntax.TryStatement,
                block: block,
                guardedHandlers: guardedHandlers,
                handlers: handlers,
                finalizer: finalizer
            };
        },

        createUnaryExpression: function (operator, argument) {
            if (operator === '++' || operator === '--') {
                return {
                    type: Syntax.UpdateExpression,
                    operator: operator,
                    argument: argument,
                    prefix: true
                };
            }
            return {
                type: Syntax.UnaryExpression,
                operator: operator,
                argument: argument,
                prefix: true
            };
        },

        createVariableDeclaration: function (declarations, kind) {
            return {
                type: Syntax.VariableDeclaration,
                declarations: declarations,
                kind: kind
            };
        },

        createVariableDeclarator: function (id, init) {
            return {
                type: Syntax.VariableDeclarator,
                id: id,
                init: init
            };
        },

        createWhileStatement: function (test, body) {
            return {
                type: Syntax.WhileStatement,
                test: test,
                body: body
            };
        },

        createWithStatement: function (object, body) {
            return {
                type: Syntax.WithStatement,
                object: object,
                body: body
            };
        }
    };

    // Return true if there is a line terminator before the next token.

    function peekLineTerminator() {
        var pos, line, start, found;

        pos = index;
        line = lineNumber;
        start = lineStart;
        skipComment();
        found = lineNumber !== line;
        index = pos;
        lineNumber = line;
        lineStart = start;

        return found;
    }

    // Throw an exception

    function throwError(token, messageFormat) {
        var error,
            args = Array.prototype.slice.call(arguments, 2),
            msg = messageFormat.replace(
                /%(\d)/g,
                function (whole, index) {
                    assert(index < args.length, 'Message reference must be in range');
                    return args[index];
                }
            );

        if (typeof token.lineNumber === 'number') {
            error = new Error('Line ' + token.lineNumber + ': ' + msg);
            error.index = token.start;
            error.lineNumber = token.lineNumber;
            error.column = token.start - lineStart + 1;
        } else {
            error = new Error('Line ' + lineNumber + ': ' + msg);
            error.index = index;
            error.lineNumber = lineNumber;
            error.column = index - lineStart + 1;
        }

        error.description = msg;
        throw error;
    }

    function throwErrorTolerant() {
        try {
            throwError.apply(null, arguments);
        } catch (e) {
            if (extra.errors) {
                extra.errors.push(e);
            } else {
                throw e;
            }
        }
    }


    // Throw an exception because of the token.

    function throwUnexpected(token) {
        if (token.type === Token.EOF) {
            throwError(token, Messages.UnexpectedEOS);
        }

        if (token.type === Token.NumericLiteral) {
            throwError(token, Messages.UnexpectedNumber);
        }

        if (token.type === Token.StringLiteral) {
            throwError(token, Messages.UnexpectedString);
        }

        if (token.type === Token.Identifier) {
            throwError(token, Messages.UnexpectedIdentifier);
        }

        if (token.type === Token.Keyword) {
            if (isFutureReservedWord(token.value)) {
                throwError(token, Messages.UnexpectedReserved);
            } else if (strict && isStrictModeReservedWord(token.value)) {
                throwErrorTolerant(token, Messages.StrictReservedWord);
                return;
            }
            throwError(token, Messages.UnexpectedToken, token.value);
        }

        // BooleanLiteral, NullLiteral, or Punctuator.
        throwError(token, Messages.UnexpectedToken, token.value);
    }

    // Expect the next token to match the specified punctuator.
    // If not, an exception will be thrown.

    function expect(value) {
        var token = lex();
        if (token.type !== Token.Punctuator || token.value !== value) {
            throwUnexpected(token);
        }
    }

    // Expect the next token to match the specified keyword.
    // If not, an exception will be thrown.

    function expectKeyword(keyword) {
        var token = lex();
        if (token.type !== Token.Keyword || token.value !== keyword) {
            throwUnexpected(token);
        }
    }

    // Return true if the next token matches the specified punctuator.

    function match(value) {
        return lookahead.type === Token.Punctuator && lookahead.value === value;
    }

    // Return true if the next token matches the specified keyword

    function matchKeyword(keyword) {
        return lookahead.type === Token.Keyword && lookahead.value === keyword;
    }

    // Return true if the next token is an assignment operator

    function matchAssign() {
        var op;

        if (lookahead.type !== Token.Punctuator) {
            return false;
        }
        op = lookahead.value;
        return op === '=' ||
            op === '*=' ||
            op === '/=' ||
            op === '%=' ||
            op === '+=' ||
            op === '-=' ||
            op === '<<=' ||
            op === '>>=' ||
            op === '>>>=' ||
            op === '&=' ||
            op === '^=' ||
            op === '|=';
    }

    function consumeSemicolon() {
        var line;

        // Catch the very common case first: immediately a semicolon (U+003B).
        if (source.charCodeAt(index) === 0x3B || match(';')) {
            lex();
            return;
        }

        line = lineNumber;
        skipComment();
        if (lineNumber !== line) {
            return;
        }

        if (lookahead.type !== Token.EOF && !match('}')) {
            throwUnexpected(lookahead);
        }
    }

    // Return true if provided expression is LeftHandSideExpression

    function isLeftHandSide(expr) {
        return expr.type === Syntax.Identifier || expr.type === Syntax.MemberExpression;
    }

    // 11.1.4 Array Initialiser

    function parseArrayInitialiser() {
        var elements = [], startToken;

        startToken = lookahead;
        expect('[');

        while (!match(']')) {
            if (match(',')) {
                lex();
                elements.push(null);
            } else {
                elements.push(parseAssignmentExpression());

                if (!match(']')) {
                    expect(',');
                }
            }
        }

        lex();

        return delegate.markEnd(delegate.createArrayExpression(elements), startToken);
    }

    // 11.1.5 Object Initialiser

    function parsePropertyFunction(param, first) {
        var previousStrict, body, startToken;

        previousStrict = strict;
        startToken = lookahead;
        body = parseFunctionSourceElements();
        if (first && strict && isRestrictedWord(param[0].name)) {
            throwErrorTolerant(first, Messages.StrictParamName);
        }
        strict = previousStrict;
        return delegate.markEnd(delegate.createFunctionExpression(null, param, [], body), startToken);
    }

    function parseObjectPropertyKey() {
        var token, startToken;

        startToken = lookahead;
        token = lex();

        // Note: This function is called only from parseObjectProperty(), where
        // EOF and Punctuator tokens are already filtered out.

        if (token.type === Token.StringLiteral || token.type === Token.NumericLiteral) {
            if (strict && token.octal) {
                throwErrorTolerant(token, Messages.StrictOctalLiteral);
            }
            return delegate.markEnd(delegate.createLiteral(token), startToken);
        }

        return delegate.markEnd(delegate.createIdentifier(token.value), startToken);
    }

    function parseObjectProperty() {
        var token, key, id, value, param, startToken;

        token = lookahead;
        startToken = lookahead;

        if (token.type === Token.Identifier) {

            id = parseObjectPropertyKey();

            // Property Assignment: Getter and Setter.

            if (token.value === 'get' && !match(':')) {
                key = parseObjectPropertyKey();
                expect('(');
                expect(')');
                value = parsePropertyFunction([]);
                return delegate.markEnd(delegate.createProperty('get', key, value), startToken);
            }
            if (token.value === 'set' && !match(':')) {
                key = parseObjectPropertyKey();
                expect('(');
                token = lookahead;
                if (token.type !== Token.Identifier) {
                    expect(')');
                    throwErrorTolerant(token, Messages.UnexpectedToken, token.value);
                    value = parsePropertyFunction([]);
                } else {
                    param = [ parseVariableIdentifier() ];
                    expect(')');
                    value = parsePropertyFunction(param, token);
                }
                return delegate.markEnd(delegate.createProperty('set', key, value), startToken);
            }
            expect(':');
            value = parseAssignmentExpression();
            return delegate.markEnd(delegate.createProperty('init', id, value), startToken);
        }
        if (token.type === Token.EOF || token.type === Token.Punctuator) {
            throwUnexpected(token);
        } else {
            key = parseObjectPropertyKey();
            expect(':');
            value = parseAssignmentExpression();
            return delegate.markEnd(delegate.createProperty('init', key, value), startToken);
        }
    }

    function parseObjectInitialiser() {
        var properties = [], property, name, key, kind, map = {}, toString = String, startToken;

        startToken = lookahead;

        expect('{');

        while (!match('}')) {
            property = parseObjectProperty();

            if (property.key.type === Syntax.Identifier) {
                name = property.key.name;
            } else {
                name = toString(property.key.value);
            }
            kind = (property.kind === 'init') ? PropertyKind.Data : (property.kind === 'get') ? PropertyKind.Get : PropertyKind.Set;

            key = '$' + name;
            if (Object.prototype.hasOwnProperty.call(map, key)) {
                if (map[key] === PropertyKind.Data) {
                    if (strict && kind === PropertyKind.Data) {
                        throwErrorTolerant({}, Messages.StrictDuplicateProperty);
                    } else if (kind !== PropertyKind.Data) {
                        throwErrorTolerant({}, Messages.AccessorDataProperty);
                    }
                } else {
                    if (kind === PropertyKind.Data) {
                        throwErrorTolerant({}, Messages.AccessorDataProperty);
                    } else if (map[key] & kind) {
                        throwErrorTolerant({}, Messages.AccessorGetSet);
                    }
                }
                map[key] |= kind;
            } else {
                map[key] = kind;
            }

            properties.push(property);

            if (!match('}')) {
                expect(',');
            }
        }

        expect('}');

        return delegate.markEnd(delegate.createObjectExpression(properties), startToken);
    }

    // 11.1.6 The Grouping Operator

    function parseGroupExpression() {
        var expr;

        expect('(');

        expr = parseExpression();

        expect(')');

        return expr;
    }


    // 11.1 Primary Expressions

    function parsePrimaryExpression() {
        var type, token, expr, startToken;

        if (match('(')) {
            return parseGroupExpression();
        }

        if (match('[')) {
            return parseArrayInitialiser();
        }

        if (match('{')) {
            return parseObjectInitialiser();
        }

        type = lookahead.type;
        startToken = lookahead;

        if (type === Token.Identifier) {
            expr =  delegate.createIdentifier(lex().value);
        } else if (type === Token.StringLiteral || type === Token.NumericLiteral) {
            if (strict && lookahead.octal) {
                throwErrorTolerant(lookahead, Messages.StrictOctalLiteral);
            }
            expr = delegate.createLiteral(lex());
        } else if (type === Token.Keyword) {
            if (matchKeyword('function')) {
                return parseFunctionExpression();
            }
            if (matchKeyword('this')) {
                lex();
                expr = delegate.createThisExpression();
            } else {
                throwUnexpected(lex());
            }
        } else if (type === Token.BooleanLiteral) {
            token = lex();
            token.value = (token.value === 'true');
            expr = delegate.createLiteral(token);
        } else if (type === Token.NullLiteral) {
            token = lex();
            token.value = null;
            expr = delegate.createLiteral(token);
        } else if (match('/') || match('/=')) {
            if (typeof extra.tokens !== 'undefined') {
                expr = delegate.createLiteral(collectRegex());
            } else {
                expr = delegate.createLiteral(scanRegExp());
            }
            peek();
        } else {
            throwUnexpected(lex());
        }

        return delegate.markEnd(expr, startToken);
    }

    // 11.2 Left-Hand-Side Expressions

    function parseArguments() {
        var args = [];

        expect('(');

        if (!match(')')) {
            while (index < length) {
                args.push(parseAssignmentExpression());
                if (match(')')) {
                    break;
                }
                expect(',');
            }
        }

        expect(')');

        return args;
    }

    function parseNonComputedProperty() {
        var token, startToken;

        startToken = lookahead;
        token = lex();

        if (!isIdentifierName(token)) {
            throwUnexpected(token);
        }

        return delegate.markEnd(delegate.createIdentifier(token.value), startToken);
    }

    function parseNonComputedMember() {
        expect('.');

        return parseNonComputedProperty();
    }

    function parseComputedMember() {
        var expr;

        expect('[');

        expr = parseExpression();

        expect(']');

        return expr;
    }

    function parseNewExpression() {
        var callee, args, startToken;

        startToken = lookahead;
        expectKeyword('new');
        callee = parseLeftHandSideExpression();
        args = match('(') ? parseArguments() : [];

        return delegate.markEnd(delegate.createNewExpression(callee, args), startToken);
    }

    function parseLeftHandSideExpressionAllowCall() {
        var previousAllowIn, expr, args, property, startToken;

        startToken = lookahead;

        previousAllowIn = state.allowIn;
        state.allowIn = true;
        expr = matchKeyword('new') ? parseNewExpression() : parsePrimaryExpression();
        state.allowIn = previousAllowIn;

        for (;;) {
            if (match('.')) {
                property = parseNonComputedMember();
                expr = delegate.createMemberExpression('.', expr, property);
            } else if (match('(')) {
                args = parseArguments();
                expr = delegate.createCallExpression(expr, args);
            } else if (match('[')) {
                property = parseComputedMember();
                expr = delegate.createMemberExpression('[', expr, property);
            } else {
                break;
            }
            delegate.markEnd(expr, startToken);
        }

        return expr;
    }

    function parseLeftHandSideExpression() {
        var previousAllowIn, expr, property, startToken;

        startToken = lookahead;

        previousAllowIn = state.allowIn;
        expr = matchKeyword('new') ? parseNewExpression() : parsePrimaryExpression();
        state.allowIn = previousAllowIn;

        while (match('.') || match('[')) {
            if (match('[')) {
                property = parseComputedMember();
                expr = delegate.createMemberExpression('[', expr, property);
            } else {
                property = parseNonComputedMember();
                expr = delegate.createMemberExpression('.', expr, property);
            }
            delegate.markEnd(expr, startToken);
        }

        return expr;
    }

    // 11.3 Postfix Expressions

    function parsePostfixExpression() {
        var expr, token, startToken = lookahead;

        expr = parseLeftHandSideExpressionAllowCall();

        if (lookahead.type === Token.Punctuator) {
            if ((match('++') || match('--')) && !peekLineTerminator()) {
                // 11.3.1, 11.3.2
                if (strict && expr.type === Syntax.Identifier && isRestrictedWord(expr.name)) {
                    throwErrorTolerant({}, Messages.StrictLHSPostfix);
                }

                if (!isLeftHandSide(expr)) {
                    throwErrorTolerant({}, Messages.InvalidLHSInAssignment);
                }

                token = lex();
                expr = delegate.markEnd(delegate.createPostfixExpression(token.value, expr), startToken);
            }
        }

        return expr;
    }

    // 11.4 Unary Operators

    function parseUnaryExpression() {
        var token, expr, startToken;

        if (lookahead.type !== Token.Punctuator && lookahead.type !== Token.Keyword) {
            expr = parsePostfixExpression();
        } else if (match('++') || match('--')) {
            startToken = lookahead;
            token = lex();
            expr = parseUnaryExpression();
            // 11.4.4, 11.4.5
            if (strict && expr.type === Syntax.Identifier && isRestrictedWord(expr.name)) {
                throwErrorTolerant({}, Messages.StrictLHSPrefix);
            }

            if (!isLeftHandSide(expr)) {
                throwErrorTolerant({}, Messages.InvalidLHSInAssignment);
            }

            expr = delegate.createUnaryExpression(token.value, expr);
            expr = delegate.markEnd(expr, startToken);
        } else if (match('+') || match('-') || match('~') || match('!')) {
            startToken = lookahead;
            token = lex();
            expr = parseUnaryExpression();
            expr = delegate.createUnaryExpression(token.value, expr);
            expr = delegate.markEnd(expr, startToken);
        } else if (matchKeyword('delete') || matchKeyword('void') || matchKeyword('typeof')) {
            startToken = lookahead;
            token = lex();
            expr = parseUnaryExpression();
            expr = delegate.createUnaryExpression(token.value, expr);
            expr = delegate.markEnd(expr, startToken);
            if (strict && expr.operator === 'delete' && expr.argument.type === Syntax.Identifier) {
                throwErrorTolerant({}, Messages.StrictDelete);
            }
        } else {
            expr = parsePostfixExpression();
        }

        return expr;
    }

    function binaryPrecedence(token, allowIn) {
        var prec = 0;

        if (token.type !== Token.Punctuator && token.type !== Token.Keyword) {
            return 0;
        }

        switch (token.value) {
        case '||':
            prec = 1;
            break;

        case '&&':
            prec = 2;
            break;

        case '|':
            prec = 3;
            break;

        case '^':
            prec = 4;
            break;

        case '&':
            prec = 5;
            break;

        case '==':
        case '!=':
        case '===':
        case '!==':
            prec = 6;
            break;

        case '<':
        case '>':
        case '<=':
        case '>=':
        case 'instanceof':
            prec = 7;
            break;

        case 'in':
            prec = allowIn ? 7 : 0;
            break;

        case '<<':
        case '>>':
        case '>>>':
            prec = 8;
            break;

        case '+':
        case '-':
            prec = 9;
            break;

        case '*':
        case '/':
        case '%':
            prec = 11;
            break;

        default:
            break;
        }

        return prec;
    }

    // 11.5 Multiplicative Operators
    // 11.6 Additive Operators
    // 11.7 Bitwise Shift Operators
    // 11.8 Relational Operators
    // 11.9 Equality Operators
    // 11.10 Binary Bitwise Operators
    // 11.11 Binary Logical Operators

    function parseBinaryExpression() {
        var marker, markers, expr, token, prec, stack, right, operator, left, i;

        marker = lookahead;
        left = parseUnaryExpression();

        token = lookahead;
        prec = binaryPrecedence(token, state.allowIn);
        if (prec === 0) {
            return left;
        }
        token.prec = prec;
        lex();

        markers = [marker, lookahead];
        right = parseUnaryExpression();

        stack = [left, token, right];

        while ((prec = binaryPrecedence(lookahead, state.allowIn)) > 0) {

            // Reduce: make a binary expression from the three topmost entries.
            while ((stack.length > 2) && (prec <= stack[stack.length - 2].prec)) {
                right = stack.pop();
                operator = stack.pop().value;
                left = stack.pop();
                expr = delegate.createBinaryExpression(operator, left, right);
                markers.pop();
                marker = markers[markers.length - 1];
                delegate.markEnd(expr, marker);
                stack.push(expr);
            }

            // Shift.
            token = lex();
            token.prec = prec;
            stack.push(token);
            markers.push(lookahead);
            expr = parseUnaryExpression();
            stack.push(expr);
        }

        // Final reduce to clean-up the stack.
        i = stack.length - 1;
        expr = stack[i];
        markers.pop();
        while (i > 1) {
            expr = delegate.createBinaryExpression(stack[i - 1].value, stack[i - 2], expr);
            i -= 2;
            marker = markers.pop();
            delegate.markEnd(expr, marker);
        }

        return expr;
    }


    // 11.12 Conditional Operator

    function parseConditionalExpression() {
        var expr, previousAllowIn, consequent, alternate, startToken;

        startToken = lookahead;

        expr = parseBinaryExpression();

        if (match('?')) {
            lex();
            previousAllowIn = state.allowIn;
            state.allowIn = true;
            consequent = parseAssignmentExpression();
            state.allowIn = previousAllowIn;
            expect(':');
            alternate = parseAssignmentExpression();

            expr = delegate.createConditionalExpression(expr, consequent, alternate);
            delegate.markEnd(expr, startToken);
        }

        return expr;
    }

    // 11.13 Assignment Operators

    function parseAssignmentExpression() {
        var token, left, right, node, startToken;

        token = lookahead;
        startToken = lookahead;

        node = left = parseConditionalExpression();

        if (matchAssign()) {
            // LeftHandSideExpression
            if (!isLeftHandSide(left)) {
                throwErrorTolerant({}, Messages.InvalidLHSInAssignment);
            }

            // 11.13.1
            if (strict && left.type === Syntax.Identifier && isRestrictedWord(left.name)) {
                throwErrorTolerant(token, Messages.StrictLHSAssignment);
            }

            token = lex();
            right = parseAssignmentExpression();
            node = delegate.markEnd(delegate.createAssignmentExpression(token.value, left, right), startToken);
        }

        return node;
    }

    // 11.14 Comma Operator

    function parseExpression() {
        var expr, startToken = lookahead;

        expr = parseAssignmentExpression();

        if (match(',')) {
            expr = delegate.createSequenceExpression([ expr ]);

            while (index < length) {
                if (!match(',')) {
                    break;
                }
                lex();
                expr.expressions.push(parseAssignmentExpression());
            }

            delegate.markEnd(expr, startToken);
        }

        return expr;
    }

    // 12.1 Block

    function parseStatementList() {
        var list = [],
            statement;

        while (index < length) {
            if (match('}')) {
                break;
            }
            statement = parseSourceElement();
            if (typeof statement === 'undefined') {
                break;
            }
            list.push(statement);
        }

        return list;
    }

    function parseBlock() {
        var block, startToken;

        startToken = lookahead;
        expect('{');

        block = parseStatementList();

        expect('}');

        return delegate.markEnd(delegate.createBlockStatement(block), startToken);
    }

    // 12.2 Variable Statement

    function parseVariableIdentifier() {
        var token, startToken;

        startToken = lookahead;
        token = lex();

        if (token.type !== Token.Identifier) {
            throwUnexpected(token);
        }

        return delegate.markEnd(delegate.createIdentifier(token.value), startToken);
    }

    function parseVariableDeclaration(kind) {
        var init = null, id, startToken;

        startToken = lookahead;
        id = parseVariableIdentifier();

        // 12.2.1
        if (strict && isRestrictedWord(id.name)) {
            throwErrorTolerant({}, Messages.StrictVarName);
        }

        if (kind === 'const') {
            expect('=');
            init = parseAssignmentExpression();
        } else if (match('=')) {
            lex();
            init = parseAssignmentExpression();
        }

        return delegate.markEnd(delegate.createVariableDeclarator(id, init), startToken);
    }

    function parseVariableDeclarationList(kind) {
        var list = [];

        do {
            list.push(parseVariableDeclaration(kind));
            if (!match(',')) {
                break;
            }
            lex();
        } while (index < length);

        return list;
    }

    function parseVariableStatement() {
        var declarations;

        expectKeyword('var');

        declarations = parseVariableDeclarationList();

        consumeSemicolon();

        return delegate.createVariableDeclaration(declarations, 'var');
    }

    // kind may be `const` or `let`
    // Both are experimental and not in the specification yet.
    // see http://wiki.ecmascript.org/doku.php?id=harmony:const
    // and http://wiki.ecmascript.org/doku.php?id=harmony:let
    function parseConstLetDeclaration(kind) {
        var declarations, startToken;

        startToken = lookahead;

        expectKeyword(kind);

        declarations = parseVariableDeclarationList(kind);

        consumeSemicolon();

        return delegate.markEnd(delegate.createVariableDeclaration(declarations, kind), startToken);
    }

    // 12.3 Empty Statement

    function parseEmptyStatement() {
        expect(';');
        return delegate.createEmptyStatement();
    }

    // 12.4 Expression Statement

    function parseExpressionStatement() {
        var expr = parseExpression();
        consumeSemicolon();
        return delegate.createExpressionStatement(expr);
    }

    // 12.5 If statement

    function parseIfStatement() {
        var test, consequent, alternate;

        expectKeyword('if');

        expect('(');

        test = parseExpression();

        expect(')');

        consequent = parseStatement();

        if (matchKeyword('else')) {
            lex();
            alternate = parseStatement();
        } else {
            alternate = null;
        }

        return delegate.createIfStatement(test, consequent, alternate);
    }

    // 12.6 Iteration Statements

    function parseDoWhileStatement() {
        var body, test, oldInIteration;

        expectKeyword('do');

        oldInIteration = state.inIteration;
        state.inIteration = true;

        body = parseStatement();

        state.inIteration = oldInIteration;

        expectKeyword('while');

        expect('(');

        test = parseExpression();

        expect(')');

        if (match(';')) {
            lex();
        }

        return delegate.createDoWhileStatement(body, test);
    }

    function parseWhileStatement() {
        var test, body, oldInIteration;

        expectKeyword('while');

        expect('(');

        test = parseExpression();

        expect(')');

        oldInIteration = state.inIteration;
        state.inIteration = true;

        body = parseStatement();

        state.inIteration = oldInIteration;

        return delegate.createWhileStatement(test, body);
    }

    function parseForVariableDeclaration() {
        var token, declarations, startToken;

        startToken = lookahead;
        token = lex();
        declarations = parseVariableDeclarationList();

        return delegate.markEnd(delegate.createVariableDeclaration(declarations, token.value), startToken);
    }

    function parseForStatement() {
        var init, test, update, left, right, body, oldInIteration;

        init = test = update = null;

        expectKeyword('for');

        expect('(');

        if (match(';')) {
            lex();
        } else {
            if (matchKeyword('var') || matchKeyword('let')) {
                state.allowIn = false;
                init = parseForVariableDeclaration();
                state.allowIn = true;

                if (init.declarations.length === 1 && matchKeyword('in')) {
                    lex();
                    left = init;
                    right = parseExpression();
                    init = null;
                }
            } else {
                state.allowIn = false;
                init = parseExpression();
                state.allowIn = true;

                if (matchKeyword('in')) {
                    // LeftHandSideExpression
                    if (!isLeftHandSide(init)) {
                        throwErrorTolerant({}, Messages.InvalidLHSInForIn);
                    }

                    lex();
                    left = init;
                    right = parseExpression();
                    init = null;
                }
            }

            if (typeof left === 'undefined') {
                expect(';');
            }
        }

        if (typeof left === 'undefined') {

            if (!match(';')) {
                test = parseExpression();
            }
            expect(';');

            if (!match(')')) {
                update = parseExpression();
            }
        }

        expect(')');

        oldInIteration = state.inIteration;
        state.inIteration = true;

        body = parseStatement();

        state.inIteration = oldInIteration;

        return (typeof left === 'undefined') ?
                delegate.createForStatement(init, test, update, body) :
                delegate.createForInStatement(left, right, body);
    }

    // 12.7 The continue statement

    function parseContinueStatement() {
        var label = null, key;

        expectKeyword('continue');

        // Optimize the most common form: 'continue;'.
        if (source.charCodeAt(index) === 0x3B) {
            lex();

            if (!state.inIteration) {
                throwError({}, Messages.IllegalContinue);
            }

            return delegate.createContinueStatement(null);
        }

        if (peekLineTerminator()) {
            if (!state.inIteration) {
                throwError({}, Messages.IllegalContinue);
            }

            return delegate.createContinueStatement(null);
        }

        if (lookahead.type === Token.Identifier) {
            label = parseVariableIdentifier();

            key = '$' + label.name;
            if (!Object.prototype.hasOwnProperty.call(state.labelSet, key)) {
                throwError({}, Messages.UnknownLabel, label.name);
            }
        }

        consumeSemicolon();

        if (label === null && !state.inIteration) {
            throwError({}, Messages.IllegalContinue);
        }

        return delegate.createContinueStatement(label);
    }

    // 12.8 The break statement

    function parseBreakStatement() {
        var label = null, key;

        expectKeyword('break');

        // Catch the very common case first: immediately a semicolon (U+003B).
        if (source.charCodeAt(index) === 0x3B) {
            lex();

            if (!(state.inIteration || state.inSwitch)) {
                throwError({}, Messages.IllegalBreak);
            }

            return delegate.createBreakStatement(null);
        }

        if (peekLineTerminator()) {
            if (!(state.inIteration || state.inSwitch)) {
                throwError({}, Messages.IllegalBreak);
            }

            return delegate.createBreakStatement(null);
        }

        if (lookahead.type === Token.Identifier) {
            label = parseVariableIdentifier();

            key = '$' + label.name;
            if (!Object.prototype.hasOwnProperty.call(state.labelSet, key)) {
                throwError({}, Messages.UnknownLabel, label.name);
            }
        }

        consumeSemicolon();

        if (label === null && !(state.inIteration || state.inSwitch)) {
            throwError({}, Messages.IllegalBreak);
        }

        return delegate.createBreakStatement(label);
    }

    // 12.9 The return statement

    function parseReturnStatement() {
        var argument = null;

        expectKeyword('return');

        if (!state.inFunctionBody) {
            throwErrorTolerant({}, Messages.IllegalReturn);
        }

        // 'return' followed by a space and an identifier is very common.
        if (source.charCodeAt(index) === 0x20) {
            if (isIdentifierStart(source.charCodeAt(index + 1))) {
                argument = parseExpression();
                consumeSemicolon();
                return delegate.createReturnStatement(argument);
            }
        }

        if (peekLineTerminator()) {
            return delegate.createReturnStatement(null);
        }

        if (!match(';')) {
            if (!match('}') && lookahead.type !== Token.EOF) {
                argument = parseExpression();
            }
        }

        consumeSemicolon();

        return delegate.createReturnStatement(argument);
    }

    // 12.10 The with statement

    function parseWithStatement() {
        var object, body;

        if (strict) {
            // TODO(ikarienator): Should we update the test cases instead?
            skipComment();
            throwErrorTolerant({}, Messages.StrictModeWith);
        }

        expectKeyword('with');

        expect('(');

        object = parseExpression();

        expect(')');

        body = parseStatement();

        return delegate.createWithStatement(object, body);
    }

    // 12.10 The swith statement

    function parseSwitchCase() {
        var test, consequent = [], statement, startToken;

        startToken = lookahead;
        if (matchKeyword('default')) {
            lex();
            test = null;
        } else {
            expectKeyword('case');
            test = parseExpression();
        }
        expect(':');

        while (index < length) {
            if (match('}') || matchKeyword('default') || matchKeyword('case')) {
                break;
            }
            statement = parseStatement();
            consequent.push(statement);
        }

        return delegate.markEnd(delegate.createSwitchCase(test, consequent), startToken);
    }

    function parseSwitchStatement() {
        var discriminant, cases, clause, oldInSwitch, defaultFound;

        expectKeyword('switch');

        expect('(');

        discriminant = parseExpression();

        expect(')');

        expect('{');

        cases = [];

        if (match('}')) {
            lex();
            return delegate.createSwitchStatement(discriminant, cases);
        }

        oldInSwitch = state.inSwitch;
        state.inSwitch = true;
        defaultFound = false;

        while (index < length) {
            if (match('}')) {
                break;
            }
            clause = parseSwitchCase();
            if (clause.test === null) {
                if (defaultFound) {
                    throwError({}, Messages.MultipleDefaultsInSwitch);
                }
                defaultFound = true;
            }
            cases.push(clause);
        }

        state.inSwitch = oldInSwitch;

        expect('}');

        return delegate.createSwitchStatement(discriminant, cases);
    }

    // 12.13 The throw statement

    function parseThrowStatement() {
        var argument;

        expectKeyword('throw');

        if (peekLineTerminator()) {
            throwError({}, Messages.NewlineAfterThrow);
        }

        argument = parseExpression();

        consumeSemicolon();

        return delegate.createThrowStatement(argument);
    }

    // 12.14 The try statement

    function parseCatchClause() {
        var param, body, startToken;

        startToken = lookahead;
        expectKeyword('catch');

        expect('(');
        if (match(')')) {
            throwUnexpected(lookahead);
        }

        param = parseVariableIdentifier();
        // 12.14.1
        if (strict && isRestrictedWord(param.name)) {
            throwErrorTolerant({}, Messages.StrictCatchVariable);
        }

        expect(')');
        body = parseBlock();
        return delegate.markEnd(delegate.createCatchClause(param, body), startToken);
    }

    function parseTryStatement() {
        var block, handlers = [], finalizer = null;

        expectKeyword('try');

        block = parseBlock();

        if (matchKeyword('catch')) {
            handlers.push(parseCatchClause());
        }

        if (matchKeyword('finally')) {
            lex();
            finalizer = parseBlock();
        }

        if (handlers.length === 0 && !finalizer) {
            throwError({}, Messages.NoCatchOrFinally);
        }

        return delegate.createTryStatement(block, [], handlers, finalizer);
    }

    // 12.15 The debugger statement

    function parseDebuggerStatement() {
        expectKeyword('debugger');

        consumeSemicolon();

        return delegate.createDebuggerStatement();
    }

    // 12 Statements

    function parseStatement() {
        var type = lookahead.type,
            expr,
            labeledBody,
            key,
            startToken;

        if (type === Token.EOF) {
            throwUnexpected(lookahead);
        }

        if (type === Token.Punctuator && lookahead.value === '{') {
            return parseBlock();
        }

        startToken = lookahead;

        if (type === Token.Punctuator) {
            switch (lookahead.value) {
            case ';':
                return delegate.markEnd(parseEmptyStatement(), startToken);
            case '(':
                return delegate.markEnd(parseExpressionStatement(), startToken);
            default:
                break;
            }
        }

        if (type === Token.Keyword) {
            switch (lookahead.value) {
            case 'break':
                return delegate.markEnd(parseBreakStatement(), startToken);
            case 'continue':
                return delegate.markEnd(parseContinueStatement(), startToken);
            case 'debugger':
                return delegate.markEnd(parseDebuggerStatement(), startToken);
            case 'do':
                return delegate.markEnd(parseDoWhileStatement(), startToken);
            case 'for':
                return delegate.markEnd(parseForStatement(), startToken);
            case 'function':
                return delegate.markEnd(parseFunctionDeclaration(), startToken);
            case 'if':
                return delegate.markEnd(parseIfStatement(), startToken);
            case 'return':
                return delegate.markEnd(parseReturnStatement(), startToken);
            case 'switch':
                return delegate.markEnd(parseSwitchStatement(), startToken);
            case 'throw':
                return delegate.markEnd(parseThrowStatement(), startToken);
            case 'try':
                return delegate.markEnd(parseTryStatement(), startToken);
            case 'var':
                return delegate.markEnd(parseVariableStatement(), startToken);
            case 'while':
                return delegate.markEnd(parseWhileStatement(), startToken);
            case 'with':
                return delegate.markEnd(parseWithStatement(), startToken);
            default:
                break;
            }
        }

        expr = parseExpression();

        // 12.12 Labelled Statements
        if ((expr.type === Syntax.Identifier) && match(':')) {
            lex();

            key = '$' + expr.name;
            if (Object.prototype.hasOwnProperty.call(state.labelSet, key)) {
                throwError({}, Messages.Redeclaration, 'Label', expr.name);
            }

            state.labelSet[key] = true;
            labeledBody = parseStatement();
            delete state.labelSet[key];
            return delegate.markEnd(delegate.createLabeledStatement(expr, labeledBody), startToken);
        }

        consumeSemicolon();

        return delegate.markEnd(delegate.createExpressionStatement(expr), startToken);
    }

    // 13 Function Definition

    function parseFunctionSourceElements() {
        var sourceElement, sourceElements = [], token, directive, firstRestricted,
            oldLabelSet, oldInIteration, oldInSwitch, oldInFunctionBody, startToken;

        startToken = lookahead;
        expect('{');

        while (index < length) {
            if (lookahead.type !== Token.StringLiteral) {
                break;
            }
            token = lookahead;

            sourceElement = parseSourceElement();
            sourceElements.push(sourceElement);
            if (sourceElement.expression.type !== Syntax.Literal) {
                // this is not directive
                break;
            }
            directive = source.slice(token.start + 1, token.end - 1);
            if (directive === 'use strict') {
                strict = true;
                if (firstRestricted) {
                    throwErrorTolerant(firstRestricted, Messages.StrictOctalLiteral);
                }
            } else {
                if (!firstRestricted && token.octal) {
                    firstRestricted = token;
                }
            }
        }

        oldLabelSet = state.labelSet;
        oldInIteration = state.inIteration;
        oldInSwitch = state.inSwitch;
        oldInFunctionBody = state.inFunctionBody;

        state.labelSet = {};
        state.inIteration = false;
        state.inSwitch = false;
        state.inFunctionBody = true;

        while (index < length) {
            if (match('}')) {
                break;
            }
            sourceElement = parseSourceElement();
            if (typeof sourceElement === 'undefined') {
                break;
            }
            sourceElements.push(sourceElement);
        }

        expect('}');

        state.labelSet = oldLabelSet;
        state.inIteration = oldInIteration;
        state.inSwitch = oldInSwitch;
        state.inFunctionBody = oldInFunctionBody;

        return delegate.markEnd(delegate.createBlockStatement(sourceElements), startToken);
    }

    function parseParams(firstRestricted) {
        var param, params = [], token, stricted, paramSet, key, message;
        expect('(');

        if (!match(')')) {
            paramSet = {};
            while (index < length) {
                token = lookahead;
                param = parseVariableIdentifier();
                key = '$' + token.value;
                if (strict) {
                    if (isRestrictedWord(token.value)) {
                        stricted = token;
                        message = Messages.StrictParamName;
                    }
                    if (Object.prototype.hasOwnProperty.call(paramSet, key)) {
                        stricted = token;
                        message = Messages.StrictParamDupe;
                    }
                } else if (!firstRestricted) {
                    if (isRestrictedWord(token.value)) {
                        firstRestricted = token;
                        message = Messages.StrictParamName;
                    } else if (isStrictModeReservedWord(token.value)) {
                        firstRestricted = token;
                        message = Messages.StrictReservedWord;
                    } else if (Object.prototype.hasOwnProperty.call(paramSet, key)) {
                        firstRestricted = token;
                        message = Messages.StrictParamDupe;
                    }
                }
                params.push(param);
                paramSet[key] = true;
                if (match(')')) {
                    break;
                }
                expect(',');
            }
        }

        expect(')');

        return {
            params: params,
            stricted: stricted,
            firstRestricted: firstRestricted,
            message: message
        };
    }

    function parseFunctionDeclaration() {
        var id, params = [], body, token, stricted, tmp, firstRestricted, message, previousStrict, startToken;

        startToken = lookahead;

        expectKeyword('function');
        token = lookahead;
        id = parseVariableIdentifier();
        if (strict) {
            if (isRestrictedWord(token.value)) {
                throwErrorTolerant(token, Messages.StrictFunctionName);
            }
        } else {
            if (isRestrictedWord(token.value)) {
                firstRestricted = token;
                message = Messages.StrictFunctionName;
            } else if (isStrictModeReservedWord(token.value)) {
                firstRestricted = token;
                message = Messages.StrictReservedWord;
            }
        }

        tmp = parseParams(firstRestricted);
        params = tmp.params;
        stricted = tmp.stricted;
        firstRestricted = tmp.firstRestricted;
        if (tmp.message) {
            message = tmp.message;
        }

        previousStrict = strict;
        body = parseFunctionSourceElements();
        if (strict && firstRestricted) {
            throwError(firstRestricted, message);
        }
        if (strict && stricted) {
            throwErrorTolerant(stricted, message);
        }
        strict = previousStrict;

        return delegate.markEnd(delegate.createFunctionDeclaration(id, params, [], body), startToken);
    }

    function parseFunctionExpression() {
        var token, id = null, stricted, firstRestricted, message, tmp, params = [], body, previousStrict, startToken;

        startToken = lookahead;
        expectKeyword('function');

        if (!match('(')) {
            token = lookahead;
            id = parseVariableIdentifier();
            if (strict) {
                if (isRestrictedWord(token.value)) {
                    throwErrorTolerant(token, Messages.StrictFunctionName);
                }
            } else {
                if (isRestrictedWord(token.value)) {
                    firstRestricted = token;
                    message = Messages.StrictFunctionName;
                } else if (isStrictModeReservedWord(token.value)) {
                    firstRestricted = token;
                    message = Messages.StrictReservedWord;
                }
            }
        }

        tmp = parseParams(firstRestricted);
        params = tmp.params;
        stricted = tmp.stricted;
        firstRestricted = tmp.firstRestricted;
        if (tmp.message) {
            message = tmp.message;
        }

        previousStrict = strict;
        body = parseFunctionSourceElements();
        if (strict && firstRestricted) {
            throwError(firstRestricted, message);
        }
        if (strict && stricted) {
            throwErrorTolerant(stricted, message);
        }
        strict = previousStrict;

        return delegate.markEnd(delegate.createFunctionExpression(id, params, [], body), startToken);
    }

    // 14 Program

    function parseSourceElement() {
        if (lookahead.type === Token.Keyword) {
            switch (lookahead.value) {
            case 'const':
            case 'let':
                return parseConstLetDeclaration(lookahead.value);
            case 'function':
                return parseFunctionDeclaration();
            default:
                return parseStatement();
            }
        }

        if (lookahead.type !== Token.EOF) {
            return parseStatement();
        }
    }

    function parseSourceElements() {
        var sourceElement, sourceElements = [], token, directive, firstRestricted;

        while (index < length) {
            token = lookahead;
            if (token.type !== Token.StringLiteral) {
                break;
            }

            sourceElement = parseSourceElement();
            sourceElements.push(sourceElement);
            if (sourceElement.expression.type !== Syntax.Literal) {
                // this is not directive
                break;
            }
            directive = source.slice(token.start + 1, token.end - 1);
            if (directive === 'use strict') {
                strict = true;
                if (firstRestricted) {
                    throwErrorTolerant(firstRestricted, Messages.StrictOctalLiteral);
                }
            } else {
                if (!firstRestricted && token.octal) {
                    firstRestricted = token;
                }
            }
        }

        while (index < length) {
            sourceElement = parseSourceElement();
            /* istanbul ignore if */
            if (typeof sourceElement === 'undefined') {
                break;
            }
            sourceElements.push(sourceElement);
        }
        return sourceElements;
    }

    function parseProgram() {
        var body, startToken;

        skipComment();
        peek();
        startToken = lookahead;
        strict = false;

        body = parseSourceElements();
        return delegate.markEnd(delegate.createProgram(body), startToken);
    }

    function filterTokenLocation() {
        var i, entry, token, tokens = [];

        for (i = 0; i < extra.tokens.length; ++i) {
            entry = extra.tokens[i];
            token = {
                type: entry.type,
                value: entry.value
            };
            if (extra.range) {
                token.range = entry.range;
            }
            if (extra.loc) {
                token.loc = entry.loc;
            }
            tokens.push(token);
        }

        extra.tokens = tokens;
    }

    function tokenize(code, options) {
        var toString,
            token,
            tokens;

        toString = String;
        if (typeof code !== 'string' && !(code instanceof String)) {
            code = toString(code);
        }

        delegate = SyntaxTreeDelegate;
        source = code;
        index = 0;
        lineNumber = (source.length > 0) ? 1 : 0;
        lineStart = 0;
        length = source.length;
        lookahead = null;
        state = {
            allowIn: true,
            labelSet: {},
            inFunctionBody: false,
            inIteration: false,
            inSwitch: false,
            lastCommentStart: -1
        };

        extra = {};

        // Options matching.
        options = options || {};

        // Of course we collect tokens here.
        options.tokens = true;
        extra.tokens = [];
        extra.tokenize = true;
        // The following two fields are necessary to compute the Regex tokens.
        extra.openParenToken = -1;
        extra.openCurlyToken = -1;

        extra.range = (typeof options.range === 'boolean') && options.range;
        extra.loc = (typeof options.loc === 'boolean') && options.loc;

        if (typeof options.comment === 'boolean' && options.comment) {
            extra.comments = [];
        }
        if (typeof options.tolerant === 'boolean' && options.tolerant) {
            extra.errors = [];
        }

        try {
            peek();
            if (lookahead.type === Token.EOF) {
                return extra.tokens;
            }

            token = lex();
            while (lookahead.type !== Token.EOF) {
                try {
                    token = lex();
                } catch (lexError) {
                    token = lookahead;
                    if (extra.errors) {
                        extra.errors.push(lexError);
                        // We have to break on the first error
                        // to avoid infinite loops.
                        break;
                    } else {
                        throw lexError;
                    }
                }
            }

            filterTokenLocation();
            tokens = extra.tokens;
            if (typeof extra.comments !== 'undefined') {
                tokens.comments = extra.comments;
            }
            if (typeof extra.errors !== 'undefined') {
                tokens.errors = extra.errors;
            }
        } catch (e) {
            throw e;
        } finally {
            extra = {};
        }
        return tokens;
    }

    function parse(code, options) {
        var program, toString;

        toString = String;
        if (typeof code !== 'string' && !(code instanceof String)) {
            code = toString(code);
        }

        delegate = SyntaxTreeDelegate;
        source = code;
        index = 0;
        lineNumber = (source.length > 0) ? 1 : 0;
        lineStart = 0;
        length = source.length;
        lookahead = null;
        state = {
            allowIn: true,
            labelSet: {},
            inFunctionBody: false,
            inIteration: false,
            inSwitch: false,
            lastCommentStart: -1
        };

        extra = {};
        if (typeof options !== 'undefined') {
            extra.range = (typeof options.range === 'boolean') && options.range;
            extra.loc = (typeof options.loc === 'boolean') && options.loc;
            extra.attachComment = (typeof options.attachComment === 'boolean') && options.attachComment;

            if (extra.loc && options.source !== null && options.source !== undefined) {
                extra.source = toString(options.source);
            }

            if (typeof options.tokens === 'boolean' && options.tokens) {
                extra.tokens = [];
            }
            if (typeof options.comment === 'boolean' && options.comment) {
                extra.comments = [];
            }
            if (typeof options.tolerant === 'boolean' && options.tolerant) {
                extra.errors = [];
            }
            if (extra.attachComment) {
                extra.range = true;
                extra.comments = [];
                extra.bottomRightStack = [];
                extra.trailingComments = [];
                extra.leadingComments = [];
            }
        }

        try {
            program = parseProgram();
            if (typeof extra.comments !== 'undefined') {
                program.comments = extra.comments;
            }
            if (typeof extra.tokens !== 'undefined') {
                filterTokenLocation();
                program.tokens = extra.tokens;
            }
            if (typeof extra.errors !== 'undefined') {
                program.errors = extra.errors;
            }
        } catch (e) {
            throw e;
        } finally {
            extra = {};
        }

        return program;
    }

    // Sync with *.json manifests.
    exports.version = '1.2.2';

    exports.tokenize = tokenize;

    exports.parse = parse;

    // Deep copy.
   /* istanbul ignore next */
    exports.Syntax = (function () {
        var name, types = {};

        if (typeof Object.create === 'function') {
            types = Object.create(null);
        }

        for (name in Syntax) {
            if (Syntax.hasOwnProperty(name)) {
                types[name] = Syntax[name];
            }
        }

        if (typeof Object.freeze === 'function') {
            Object.freeze(types);
        }

        return types;
    }());

}));
/* vim: set sw=4 ts=4 et tw=80 : */

},{}],1:[function(require,module,exports){
(function (process){
/* parser generated by jison 0.4.13 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parser = (function(){
var parser = {trace: function trace() { },
yy: {},
symbols_: {"error":2,"JSON_PATH":3,"DOLLAR":4,"PATH_COMPONENTS":5,"LEADING_CHILD_MEMBER_EXPRESSION":6,"PATH_COMPONENT":7,"MEMBER_COMPONENT":8,"SUBSCRIPT_COMPONENT":9,"CHILD_MEMBER_COMPONENT":10,"DESCENDANT_MEMBER_COMPONENT":11,"DOT":12,"MEMBER_EXPRESSION":13,"DOT_DOT":14,"STAR":15,"IDENTIFIER":16,"SCRIPT_EXPRESSION":17,"INTEGER":18,"END":19,"CHILD_SUBSCRIPT_COMPONENT":20,"DESCENDANT_SUBSCRIPT_COMPONENT":21,"[":22,"SUBSCRIPT":23,"]":24,"SUBSCRIPT_EXPRESSION":25,"SUBSCRIPT_EXPRESSION_LIST":26,"SUBSCRIPT_EXPRESSION_LISTABLE":27,",":28,"STRING_LITERAL":29,"ARRAY_SLICE":30,"FILTER_EXPRESSION":31,"QQ_STRING":32,"Q_STRING":33,"$accept":0,"$end":1},
terminals_: {2:"error",4:"DOLLAR",12:"DOT",14:"DOT_DOT",15:"STAR",16:"IDENTIFIER",17:"SCRIPT_EXPRESSION",18:"INTEGER",19:"END",22:"[",24:"]",28:",",30:"ARRAY_SLICE",31:"FILTER_EXPRESSION",32:"QQ_STRING",33:"Q_STRING"},
productions_: [0,[3,1],[3,2],[3,1],[3,2],[5,1],[5,2],[7,1],[7,1],[8,1],[8,1],[10,2],[6,1],[11,2],[13,1],[13,1],[13,1],[13,1],[13,1],[9,1],[9,1],[20,3],[21,4],[23,1],[23,1],[26,1],[26,3],[27,1],[27,1],[27,1],[25,1],[25,1],[25,1],[29,1],[29,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */
/**/) {
/* this == yyval */
if (!yy.ast) {
    yy.ast = _ast;
    _ast.initialize();
}

var $0 = $$.length - 1;
switch (yystate) {
case 1:yy.ast.set({ expression: { type: "root", value: $$[$0] } }); yy.ast.unshift(); return yy.ast.yield()
break;
case 2:yy.ast.set({ expression: { type: "root", value: $$[$0-1] } }); yy.ast.unshift(); return yy.ast.yield()
break;
case 3:yy.ast.unshift(); return yy.ast.yield()
break;
case 4:yy.ast.set({ operation: "member", scope: "child", expression: { type: "identifier", value: $$[$0-1] }}); yy.ast.unshift(); return yy.ast.yield()
break;
case 5:
break;
case 6:
break;
case 7:yy.ast.set({ operation: "member" }); yy.ast.push()
break;
case 8:yy.ast.set({ operation: "subscript" }); yy.ast.push() 
break;
case 9:yy.ast.set({ scope: "child" })
break;
case 10:yy.ast.set({ scope: "descendant" })
break;
case 11:
break;
case 12:yy.ast.set({ scope: "child", operation: "member" })
break;
case 13:
break;
case 14:yy.ast.set({ expression: { type: "wildcard", value: $$[$0] } })
break;
case 15:yy.ast.set({ expression: { type: "identifier", value: $$[$0] } })
break;
case 16:yy.ast.set({ expression: { type: "script_expression", value: $$[$0] } })
break;
case 17:yy.ast.set({ expression: { type: "numeric_literal", value: parseInt($$[$0]) } })
break;
case 18:
break;
case 19:yy.ast.set({ scope: "child" })
break;
case 20:yy.ast.set({ scope: "descendant" })
break;
case 21:
break;
case 22:
break;
case 23:
break;
case 24:$$[$0].length > 1? yy.ast.set({ expression: { type: "union", value: $$[$0] } }) : this.$ = $$[$0]
break;
case 25:this.$ = [$$[$0]]
break;
case 26:this.$ = $$[$0-2].concat($$[$0])
break;
case 27:this.$ = { expression: { type: "numeric_literal", value: parseInt($$[$0]) } }; yy.ast.set(this.$)
break;
case 28:this.$ = { expression: { type: "string_literal", value: $$[$0] } }; yy.ast.set(this.$)
break;
case 29:this.$ = { expression: { type: "slice", value: $$[$0] } }; yy.ast.set(this.$)
break;
case 30:this.$ = { expression: { type: "wildcard", value: $$[$0] } }; yy.ast.set(this.$)
break;
case 31:this.$ = { expression: { type: "script_expression", value: $$[$0] } }; yy.ast.set(this.$)
break;
case 32:this.$ = { expression: { type: "filter_expression", value: $$[$0] } }; yy.ast.set(this.$)
break;
case 33:this.$ = $$[$0]
break;
case 34:this.$ = $$[$0]
break;
}
},
table: [{3:1,4:[1,2],6:3,13:4,15:[1,5],16:[1,6],17:[1,7],18:[1,8],19:[1,9]},{1:[3]},{1:[2,1],5:10,7:11,8:12,9:13,10:14,11:15,12:[1,18],14:[1,19],20:16,21:17,22:[1,20]},{1:[2,3],5:21,7:11,8:12,9:13,10:14,11:15,12:[1,18],14:[1,19],20:16,21:17,22:[1,20]},{1:[2,12],12:[2,12],14:[2,12],22:[2,12]},{1:[2,14],12:[2,14],14:[2,14],22:[2,14]},{1:[2,15],12:[2,15],14:[2,15],22:[2,15]},{1:[2,16],12:[2,16],14:[2,16],22:[2,16]},{1:[2,17],12:[2,17],14:[2,17],22:[2,17]},{1:[2,18],12:[2,18],14:[2,18],22:[2,18]},{1:[2,2],7:22,8:12,9:13,10:14,11:15,12:[1,18],14:[1,19],20:16,21:17,22:[1,20]},{1:[2,5],12:[2,5],14:[2,5],22:[2,5]},{1:[2,7],12:[2,7],14:[2,7],22:[2,7]},{1:[2,8],12:[2,8],14:[2,8],22:[2,8]},{1:[2,9],12:[2,9],14:[2,9],22:[2,9]},{1:[2,10],12:[2,10],14:[2,10],22:[2,10]},{1:[2,19],12:[2,19],14:[2,19],22:[2,19]},{1:[2,20],12:[2,20],14:[2,20],22:[2,20]},{13:23,15:[1,5],16:[1,6],17:[1,7],18:[1,8],19:[1,9]},{13:24,15:[1,5],16:[1,6],17:[1,7],18:[1,8],19:[1,9],22:[1,25]},{15:[1,29],17:[1,30],18:[1,33],23:26,25:27,26:28,27:32,29:34,30:[1,35],31:[1,31],32:[1,36],33:[1,37]},{1:[2,4],7:22,8:12,9:13,10:14,11:15,12:[1,18],14:[1,19],20:16,21:17,22:[1,20]},{1:[2,6],12:[2,6],14:[2,6],22:[2,6]},{1:[2,11],12:[2,11],14:[2,11],22:[2,11]},{1:[2,13],12:[2,13],14:[2,13],22:[2,13]},{15:[1,29],17:[1,30],18:[1,33],23:38,25:27,26:28,27:32,29:34,30:[1,35],31:[1,31],32:[1,36],33:[1,37]},{24:[1,39]},{24:[2,23]},{24:[2,24],28:[1,40]},{24:[2,30]},{24:[2,31]},{24:[2,32]},{24:[2,25],28:[2,25]},{24:[2,27],28:[2,27]},{24:[2,28],28:[2,28]},{24:[2,29],28:[2,29]},{24:[2,33],28:[2,33]},{24:[2,34],28:[2,34]},{24:[1,41]},{1:[2,21],12:[2,21],14:[2,21],22:[2,21]},{18:[1,33],27:42,29:34,30:[1,35],32:[1,36],33:[1,37]},{1:[2,22],12:[2,22],14:[2,22],22:[2,22]},{24:[2,26],28:[2,26]}],
defaultActions: {27:[2,23],29:[2,30],30:[2,31],31:[2,32]},
parseError: function parseError(str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        throw new Error(str);
    }
},
parse: function parse(input) {
    var self = this, stack = [0], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    this.lexer.setInput(input);
    this.lexer.yy = this.yy;
    this.yy.lexer = this.lexer;
    this.yy.parser = this;
    if (typeof this.lexer.yylloc == 'undefined') {
        this.lexer.yylloc = {};
    }
    var yyloc = this.lexer.yylloc;
    lstack.push(yyloc);
    var ranges = this.lexer.options && this.lexer.options.ranges;
    if (typeof this.yy.parseError === 'function') {
        this.parseError = this.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    function lex() {
        var token;
        token = self.lexer.lex() || EOF;
        if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
        }
        return token;
    }
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (this.lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + this.lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: this.lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: this.lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(this.lexer.yytext);
            lstack.push(this.lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = this.lexer.yyleng;
                yytext = this.lexer.yytext;
                yylineno = this.lexer.yylineno;
                yyloc = this.lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                this.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};
var _ast = {

  initialize: function() {
    this._nodes = [];
    this._node = {};
    this._stash = [];
  },

  set: function(props) {
    for (var k in props) this._node[k] = props[k];
    return this._node;
  },

  node: function(obj) {
    if (arguments.length) this._node = obj;
    return this._node;
  },

  push: function() {
    this._nodes.push(this._node);
    this._node = {};
  },

  unshift: function() {
    this._nodes.unshift(this._node);
    this._node = {};
  },

  yield: function() {
    var _nodes = this._nodes;
    this.initialize();
    return _nodes;
  }
};
/* generated by jison-lex 0.2.1 */
var lexer = (function(){
var lexer = {

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input) {
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len - 1);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function (match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex() {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin(condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState() {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules() {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState(n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState(condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START
/**/) {

var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:return 4
break;
case 1:return 14
break;
case 2:return 12
break;
case 3:return 15
break;
case 4:return 16
break;
case 5:return 22
break;
case 6:return 24
break;
case 7:return 28
break;
case 8:return 30
break;
case 9:return 18
break;
case 10:yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2); return 32;
break;
case 11:yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2); return 33;
break;
case 12:return 17
break;
case 13:return 31
break;
}
},
rules: [/^(?:\$)/,/^(?:\.\.)/,/^(?:\.)/,/^(?:\*)/,/^(?:[a-zA-Z_]+[a-zA-Z0-9_]*)/,/^(?:\[)/,/^(?:\])/,/^(?:,)/,/^(?:((-?(?:0|[1-9][0-9]*)))?\:((-?(?:0|[1-9][0-9]*)))?(\:((-?(?:0|[1-9][0-9]*)))?)?)/,/^(?:(-?(?:0|[1-9][0-9]*)))/,/^(?:"(?:\\["bfnrt/\\]|\\u[a-fA-F0-9]{4}|[^"\\])*")/,/^(?:'(?:\\['bfnrt/\\]|\\u[a-fA-F0-9]{4}|[^'\\])*')/,/^(?:\(.+?\)(?=\]))/,/^(?:\?\(.+?\)(?=\]))/],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13],"inclusive":true}}
};
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = parser;
exports.Parser = parser.Parser;
exports.parse = function () { return parser.parse.apply(parser, arguments); };
exports.main = function commonjsMain(args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}

}).call(this,require('_process'))
},{"_process":14,"fs":12,"path":13}],2:[function(require,module,exports){
module.exports = {
  identifier: "[a-zA-Z_]+[a-zA-Z0-9_]*",
  integer: "-?(?:0|[1-9][0-9]*)",
  qq_string: "\"(?:\\\\[\"bfnrt/\\\\]|\\\\u[a-fA-F0-9]{4}|[^\"\\\\])*\"",
  q_string: "'(?:\\\\[\'bfnrt/\\\\]|\\\\u[a-fA-F0-9]{4}|[^\'\\\\])*'"
};

},{}],3:[function(require,module,exports){
var dict = require('./dict');
var fs = require('fs');
var grammar = {

    lex: {

        macros: {
            esc: "\\\\",
            int: dict.integer
        },

        rules: [
            ["\\$", "return 'DOLLAR'"],
            ["\\.\\.", "return 'DOT_DOT'"],
            ["\\.", "return 'DOT'"],
            ["\\*", "return 'STAR'"],
            [dict.identifier, "return 'IDENTIFIER'"],
            ["\\[", "return '['"],
            ["\\]", "return ']'"],
            [",", "return ','"],
            ["({int})?\\:({int})?(\\:({int})?)?", "return 'ARRAY_SLICE'"],
            ["{int}", "return 'INTEGER'"],
            [dict.qq_string, "yytext = yytext.substr(1,yyleng-2); return 'QQ_STRING';"],
            [dict.q_string, "yytext = yytext.substr(1,yyleng-2); return 'Q_STRING';"],
            ["\\(.+?\\)(?=\\])", "return 'SCRIPT_EXPRESSION'"],
            ["\\?\\(.+?\\)(?=\\])", "return 'FILTER_EXPRESSION'"]
        ]
    },

    start: "JSON_PATH",

    bnf: {

        JSON_PATH: [
                [ 'DOLLAR',                 'yy.ast.set({ expression: { type: "root", value: $1 } }); yy.ast.unshift(); return yy.ast.yield()' ],
                [ 'DOLLAR PATH_COMPONENTS', 'yy.ast.set({ expression: { type: "root", value: $1 } }); yy.ast.unshift(); return yy.ast.yield()' ],
                [ 'LEADING_CHILD_MEMBER_EXPRESSION',                 'yy.ast.unshift(); return yy.ast.yield()' ],
                [ 'LEADING_CHILD_MEMBER_EXPRESSION PATH_COMPONENTS', 'yy.ast.set({ operation: "member", scope: "child", expression: { type: "identifier", value: $1 }}); yy.ast.unshift(); return yy.ast.yield()' ] ],

        PATH_COMPONENTS: [
                [ 'PATH_COMPONENT',                 '' ],
                [ 'PATH_COMPONENTS PATH_COMPONENT', '' ] ],

        PATH_COMPONENT: [
                [ 'MEMBER_COMPONENT',    'yy.ast.set({ operation: "member" }); yy.ast.push()' ],
                [ 'SUBSCRIPT_COMPONENT', 'yy.ast.set({ operation: "subscript" }); yy.ast.push() ' ] ],

        MEMBER_COMPONENT: [
                [ 'CHILD_MEMBER_COMPONENT',      'yy.ast.set({ scope: "child" })' ],
                [ 'DESCENDANT_MEMBER_COMPONENT', 'yy.ast.set({ scope: "descendant" })' ] ],

        CHILD_MEMBER_COMPONENT: [
                [ 'DOT MEMBER_EXPRESSION', '' ] ],

        LEADING_CHILD_MEMBER_EXPRESSION: [
                [ 'MEMBER_EXPRESSION', 'yy.ast.set({ scope: "child", operation: "member" })' ] ],

        DESCENDANT_MEMBER_COMPONENT: [
                [ 'DOT_DOT MEMBER_EXPRESSION', '' ] ],

        MEMBER_EXPRESSION: [
                [ 'STAR',              'yy.ast.set({ expression: { type: "wildcard", value: $1 } })' ],
                [ 'IDENTIFIER',        'yy.ast.set({ expression: { type: "identifier", value: $1 } })' ],
                [ 'SCRIPT_EXPRESSION', 'yy.ast.set({ expression: { type: "script_expression", value: $1 } })' ],
                [ 'INTEGER',           'yy.ast.set({ expression: { type: "numeric_literal", value: parseInt($1) } })' ],
                [ 'END',               '' ] ],

        SUBSCRIPT_COMPONENT: [
                [ 'CHILD_SUBSCRIPT_COMPONENT',      'yy.ast.set({ scope: "child" })' ],
                [ 'DESCENDANT_SUBSCRIPT_COMPONENT', 'yy.ast.set({ scope: "descendant" })' ] ],

        CHILD_SUBSCRIPT_COMPONENT: [
                [ '[ SUBSCRIPT ]', '' ] ],

        DESCENDANT_SUBSCRIPT_COMPONENT: [
                [ 'DOT_DOT [ SUBSCRIPT ]', '' ] ],

        SUBSCRIPT: [
                [ 'SUBSCRIPT_EXPRESSION', '' ],
                [ 'SUBSCRIPT_EXPRESSION_LIST', '$1.length > 1? yy.ast.set({ expression: { type: "union", value: $1 } }) : $$ = $1' ] ],

        SUBSCRIPT_EXPRESSION_LIST: [
                [ 'SUBSCRIPT_EXPRESSION_LISTABLE', '$$ = [$1]'],
                [ 'SUBSCRIPT_EXPRESSION_LIST , SUBSCRIPT_EXPRESSION_LISTABLE', '$$ = $1.concat($3)' ] ],

        SUBSCRIPT_EXPRESSION_LISTABLE: [
                [ 'INTEGER',           '$$ = { expression: { type: "numeric_literal", value: parseInt($1) } }; yy.ast.set($$)' ],
                [ 'STRING_LITERAL',    '$$ = { expression: { type: "string_literal", value: $1 } }; yy.ast.set($$)' ],
                [ 'ARRAY_SLICE',       '$$ = { expression: { type: "slice", value: $1 } }; yy.ast.set($$)' ] ],

        SUBSCRIPT_EXPRESSION: [
                [ 'STAR',              '$$ = { expression: { type: "wildcard", value: $1 } }; yy.ast.set($$)' ],
                [ 'SCRIPT_EXPRESSION', '$$ = { expression: { type: "script_expression", value: $1 } }; yy.ast.set($$)' ],
                [ 'FILTER_EXPRESSION', '$$ = { expression: { type: "filter_expression", value: $1 } }; yy.ast.set($$)' ] ],

        STRING_LITERAL: [
                [ 'QQ_STRING', "$$ = $1" ],
                [ 'Q_STRING',  "$$ = $1" ] ]
    }
};
if (fs.readFileSync) {
  grammar.moduleInclude = fs.readFileSync(require.resolve("../include/module.js"));
  grammar.actionInclude = fs.readFileSync(require.resolve("../include/action.js"));
}

module.exports = grammar;

},{"./dict":2,"fs":12}],4:[function(require,module,exports){
var aesprim = require('./aesprim');
var slice = require('./slice');
var _evaluate = require('static-eval');
var _uniq = require('underscore').uniq;

var Handlers = function() {
  return this.initialize.apply(this, arguments);
}

Handlers.prototype.initialize = function() {
  this.traverse = traverser(true);
  this.descend = traverser();
}

Handlers.prototype.keys = Object.keys;

Handlers.prototype.resolve = function(component) {

  var key = [ component.operation, component.scope, component.expression.type ].join('-');
  var method = this._fns[key];

  if (!method) throw new Error("couldn't resolve key: " + key);
  return method.bind(this);
};

Handlers.prototype.register = function(key, handler) {

  if (!handler instanceof Function) {
    throw new Error("handler must be a function");
  }

  this._fns[key] = handler;
};

Handlers.prototype._fns = {

  'member-child-identifier': function(component, partial) {
    var key = component.expression.value;
    var value = partial.value;
    if (value instanceof Object && key in value) {
      return [ { value: value[key], path: partial.path.concat(key) } ]
    }
  },

  'member-descendant-identifier':
    _traverse(function(key, value, ref) { return key == ref }),

  'subscript-child-numeric_literal':
    _descend(function(key, value, ref) { return key === ref }),

  'member-child-numeric_literal':
    _descend(function(key, value, ref) { return String(key) === String(ref) }),

  'subscript-descendant-numeric_literal':
    _traverse(function(key, value, ref) { return key === ref }),

  'member-child-wildcard':
    _descend(function() { return true }),

  'member-descendant-wildcard':
    _traverse(function() { return true }),

  'subscript-descendant-wildcard':
    _traverse(function() { return true }),

  'subscript-child-wildcard':
    _descend(function() { return true }),

  'subscript-child-slice': function(component, partial) {
    if (is_array(partial.value)) {
      var args = component.expression.value.split(':').map(_parse_nullable_int);
      var values = partial.value.map(function(v, i) { return { value: v, path: partial.path.concat(i) } });
      return slice.apply(null, [values].concat(args));
    }
  },

  'subscript-child-union': function(component, partial) {
    var results = [];
    component.expression.value.forEach(function(component) {
      var _component = { operation: 'subscript', scope: 'child', expression: component.expression };
      var handler = this.resolve(_component);
      var _results = handler(_component, partial);
      if (_results) {
        results = results.concat(_results);
      }
    }, this);

    return unique(results);
  },

  'subscript-descendant-union': function(component, partial, count) {

    var jp = require('..');
    var self = this;

    var results = [];
    var nodes = jp.nodes(partial, '$..*').slice(1);

    nodes.forEach(function(node) {
      if (results.length >= count) return;
      component.expression.value.forEach(function(component) {
        var _component = { operation: 'subscript', scope: 'child', expression: component.expression };
        var handler = self.resolve(_component);
        var _results = handler(_component, node);
        results = results.concat(_results);
      });
    });

    return unique(results);
  },

  'subscript-child-filter_expression': function(component, partial, count) {

    // slice out the expression from ?(expression)
    var src = component.expression.value.slice(2, -1);
    var ast = aesprim.parse(src).body[0].expression;

    var passable = function(key, value) {
      return evaluate(ast, { '@': value });
    }

    return this.descend(partial, null, passable, count);

  },

  'subscript-descendant-filter_expression': function(component, partial, count) {

    // slice out the expression from ?(expression)
    var src = component.expression.value.slice(2, -1);
    var ast = aesprim.parse(src).body[0].expression;

    var passable = function(key, value) {
      return evaluate(ast, { '@': value });
    }

    return this.traverse(partial, null, passable, count);
  },

  'subscript-child-script_expression': function(component, partial) {
    var exp = component.expression.value.slice(1, -1);
    return eval_recurse(partial, exp, '$[{{value}}]');
  },

  'member-child-script_expression': function(component, partial) {
    var exp = component.expression.value.slice(1, -1);
    return eval_recurse(partial, exp, '$.{{value}}');
  },

  'member-descendant-script_expression': function(component, partial) {
    var exp = component.expression.value.slice(1, -1);
    return eval_recurse(partial, exp, '$..value');
  }
};

Handlers.prototype._fns['subscript-child-string_literal'] =
	Handlers.prototype._fns['member-child-identifier'];

Handlers.prototype._fns['member-descendant-numeric_literal'] =
    Handlers.prototype._fns['subscript-descendant-string_literal'] =
    Handlers.prototype._fns['member-descendant-identifier'];

function eval_recurse(partial, src, template) {

  var jp = require('./index');
  var ast = aesprim.parse(src).body[0].expression;
  var value = evaluate(ast, { '@': partial.value });
  var path = template.replace(/\{\{\s*value\s*\}\}/g, value);

  var results = jp.nodes(partial.value, path);
  results.forEach(function(r) {
    r.path = partial.path.concat(r.path.slice(1));
  });

  return results;
}

function is_array(val) {
  return Array.isArray(val);
}

function is_object(val) {
  // is this a non-array, non-null object?
  return val && !(val instanceof Array) && val instanceof Object;
}

function traverser(recurse) {

  return function(partial, ref, passable, count) {

    var value = partial.value;
    var path = partial.path;

    var results = [];

    var descend = function(value, path) {

      if (is_array(value)) {
        value.forEach(function(element, index) {
          if (results.length >= count) { return }
          if (passable(index, element, ref)) {
            results.push({ path: path.concat(index), value: element });
          }
        });
        value.forEach(function(element, index) {
          if (results.length >= count) { return }
          if (recurse) {
            descend(element, path.concat(index));
          }
        });
      } else if (is_object(value)) {
        this.keys(value).forEach(function(k) {
          if (results.length >= count) { return }
          if (passable(k, value[k], ref)) {
            results.push({ path: path.concat(k), value: value[k] });
          }
        })
        this.keys(value).forEach(function(k) {
          if (results.length >= count) { return }
          if (recurse) {
            descend(value[k], path.concat(k));
          }
        });
      }
    }.bind(this);
    descend(value, path);
    return results;
  }
}

function _descend(passable) {
  return function(component, partial, count) {
    return this.descend(partial, component.expression.value, passable, count);
  }
}

function _traverse(passable) {
  return function(component, partial, count) {
    return this.traverse(partial, component.expression.value, passable, count);
  }
}

function evaluate() {
  try { return _evaluate.apply(this, arguments) }
  catch (e) { }
}

function unique(results) {
  results = results.filter(function(d) { return d })
  return _uniq(
    results,
    function(r) { return r.path.map(function(c) { return String(c).replace('-', '--') }).join('-') }
  );
}

function _parse_nullable_int(val) {
  var sval = String(val);
  return sval.match(/^-?[0-9]+$/) ? parseInt(sval) : null;
}

module.exports = Handlers;

},{"..":"jsonpath","./aesprim":"./aesprim","./index":5,"./slice":7,"static-eval":15,"underscore":12}],5:[function(require,module,exports){
var assert = require('assert');
var dict = require('./dict');
var Parser = require('./parser');
var Handlers = require('./handlers');

var JSONPath = function() {
  this.initialize.apply(this, arguments);
};

JSONPath.prototype.initialize = function() {
  this.parser = new Parser();
  this.handlers = new Handlers();
};

JSONPath.prototype.parse = function(string) {
  assert.ok(_is_string(string), "we need a path");
  return this.parser.parse(string);
};

JSONPath.prototype.parent = function(obj, string) {

  assert.ok(obj instanceof Object, "obj needs to be an object");
  assert.ok(string, "we need a path");

  var node = this.nodes(obj, string)[0];
  var key = node.path.pop(); /* jshint unused:false */
  return this.value(obj, node.path);
}

JSONPath.prototype.apply = function(obj, string, fn) {

  assert.ok(obj instanceof Object, "obj needs to be an object");
  assert.ok(string, "we need a path");
  assert.equal(typeof fn, "function", "fn needs to be function")

  var nodes = this.nodes(obj, string).sort(function(a, b) {
    // sort nodes so we apply from the bottom up
    return b.path.length - a.path.length;
  });

  nodes.forEach(function(node) {
    var key = node.path.pop();
    var parent = this.value(obj, this.stringify(node.path));
    var val = node.value = fn.call(obj, parent[key]);
    parent[key] = val;
  }, this);

  return nodes;
}

JSONPath.prototype.value = function(obj, path, value) {

  assert.ok(obj instanceof Object, "obj needs to be an object");
  assert.ok(path, "we need a path");

  if (arguments.length >= 3) {
    var node = this.nodes(obj, path).shift();
    if (!node) return this._vivify(obj, path, value);
    var key = node.path.slice(-1).shift();
    var parent = this.parent(obj, this.stringify(node.path));
    parent[key] = value;
  }
  return this.query(obj, this.stringify(path), 1).shift();
}

JSONPath.prototype._vivify = function(obj, string, value) {

  var self = this;

  assert.ok(obj instanceof Object, "obj needs to be an object");
  assert.ok(string, "we need a path");

  var path = this.parser.parse(string)
    .map(function(component) { return component.expression.value });

  var setValue = function(path, value) {
    var key = path.pop();
    var node = self.value(obj, path);
    if (!node) {
      setValue(path.concat(), typeof key === 'string' ? {} : []);
      node = self.value(obj, path);
    }
    node[key] = value;
  }
  setValue(path, value);
  return this.query(obj, string)[0];
}

JSONPath.prototype.query = function(obj, string, count) {

  assert.ok(obj instanceof Object, "obj needs to be an object");
  assert.ok(_is_string(string), "we need a path");

  var results = this.nodes(obj, string, count)
    .map(function(r) { return r.value });

  return results;
};

JSONPath.prototype.paths = function(obj, string, count) {

  assert.ok(obj instanceof Object, "obj needs to be an object");
  assert.ok(string, "we need a path");

  var results = this.nodes(obj, string, count)
    .map(function(r) { return r.path });

  return results;
};

JSONPath.prototype.nodes = function(obj, string, count) {

  assert.ok(obj instanceof Object, "obj needs to be an object");
  assert.ok(string, "we need a path");

  if (count === 0) return [];

  var path = this.parser.parse(string);
  var handlers = this.handlers;

  var partials = [ { path: ['$'], value: obj } ];
  var matches = [];

  if (path.length && path[0].expression.type == 'root') path.shift();

  if (!path.length) return partials;

  path.forEach(function(component, index) {

    if (matches.length >= count) return;
    var handler = handlers.resolve(component);
    var _partials = [];

    partials.forEach(function(p) {

      if (matches.length >= count) return;
      var results = handler(component, p, count);

      if (index == path.length - 1) {
        // if we're through the components we're done
        matches = matches.concat(results || []);
      } else {
        // otherwise accumulate and carry on through
        _partials = _partials.concat(results || []);
      }
    });

    partials = _partials;

  });

  return count ? matches.slice(0, count) : matches;
};

JSONPath.prototype.stringify = function(path) {

  assert.ok(path, "we need a path");

  var string = '$';

  var templates = {
    'descendant-member': '..{{value}}',
    'child-member': '.{{value}}',
    'descendant-subscript': '..[{{value}}]',
    'child-subscript': '[{{value}}]'
  };

  path = this._normalize(path);

  path.forEach(function(component) {

    if (component.expression.type == 'root') return;

    var key = [component.scope, component.operation].join('-');
    var template = templates[key];
    var value;

    if (component.expression.type == 'string_literal') {
      value = JSON.stringify(component.expression.value)
    } else {
      value = component.expression.value;
    }

    if (!template) throw new Error("couldn't find template " + key);

    string += template.replace(/{{value}}/, value);
  });

  return string;
}

JSONPath.prototype._normalize = function(path) {

  assert.ok(path, "we need a path");

  if (typeof path == "string") {

    return this.parser.parse(path);

  } else if (Array.isArray(path) && typeof path[0] == "string") {

    var _path = [ { expression: { type: "root", value: "$" } } ];

    path.forEach(function(component, index) {

      if (component == '$' && index === 0) return;

      if (typeof component == "string" && component.match("^" + dict.identifier + "$")) {

        _path.push({
          operation: 'member',
          scope: 'child',
          expression: { value: component, type: 'identifier' }
        });

      } else {

        var type = typeof component == "number" ?
          'numeric_literal' : 'string_literal';

        _path.push({
          operation: 'subscript',
          scope: 'child',
          expression: { value: component, type: type }
        });
      }
    });

    return _path;

  } else if (Array.isArray(path) && typeof path[0] == "object") {

    return path
  }

  throw new Error("couldn't understand path " + path);
}

function _is_string(obj) {
  return Object.prototype.toString.call(obj) == '[object String]';
}

JSONPath.Handlers = Handlers;
JSONPath.Parser = Parser;

var instance = new JSONPath;
instance.JSONPath = JSONPath;

module.exports = instance;

},{"./dict":2,"./handlers":4,"./parser":6,"assert":8}],6:[function(require,module,exports){
var grammar = require('./grammar');
var gparser = require('../generated/parser');

var Parser = function() {

  var parser = new gparser.Parser();

  var _parseError = parser.parseError;
  parser.yy.parseError = function() {
    if (parser.yy.ast) {
      parser.yy.ast.initialize();
    }
    _parseError.apply(parser, arguments);
  }

  return parser;

};

Parser.grammar = grammar;
module.exports = Parser;

},{"../generated/parser":1,"./grammar":3}],7:[function(require,module,exports){
module.exports = function(arr, start, end, step) {

  if (typeof start == 'string') throw new Error("start cannot be a string");
  if (typeof end == 'string') throw new Error("end cannot be a string");
  if (typeof step == 'string') throw new Error("step cannot be a string");

  var len = arr.length;

  if (step === 0) throw new Error("step cannot be zero");
  step = step ? integer(step) : 1;

  // normalize negative values
  start = start < 0 ? len + start : start;
  end = end < 0 ? len + end : end;

  // default extents to extents
  start = integer(start === 0 ? 0 : !start ? (step > 0 ? 0 : len - 1) : start);
  end = integer(end === 0 ? 0 : !end ? (step > 0 ? len : -1) : end);

  // clamp extents
  start = step > 0 ? Math.max(0, start) : Math.min(len, start);
  end = step > 0 ? Math.min(end, len) : Math.max(-1, end);

  // return empty if extents are backwards
  if (step > 0 && end <= start) return [];
  if (step < 0 && start <= end) return [];

  var result = [];

  for (var i = start; i != end; i += step) {
    if ((step < 0 && i <= end) || (step > 0 && i >= end)) break;
    result.push(arr[i]);
  }

  return result;
}

function integer(val) {
  return String(val).match(/^[0-9]+$/) ? parseInt(val) :
    Number.isFinite(val) ? parseInt(val, 10) : 0;
}

},{}],8:[function(require,module,exports){
// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

// when used in node, this will actually load the util module we depend on
// versus loading the builtin util module as happens otherwise
// this is a bug in node module loading as far as I am concerned
var util = require('util/');

var pSlice = Array.prototype.slice;
var hasOwn = Object.prototype.hasOwnProperty;

// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  }
  else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = stackStartFunction.name;
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function replacer(key, value) {
  if (util.isUndefined(value)) {
    return '' + value;
  }
  if (util.isNumber(value) && !isFinite(value)) {
    return value.toString();
  }
  if (util.isFunction(value) || util.isRegExp(value)) {
    return value.toString();
  }
  return value;
}

function truncate(s, n) {
  if (util.isString(s)) {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}

function getMessage(self) {
  return truncate(JSON.stringify(self.actual, replacer), 128) + ' ' +
         self.operator + ' ' +
         truncate(JSON.stringify(self.expected, replacer), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

function _deepEqual(actual, expected) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (util.isBuffer(actual) && util.isBuffer(expected)) {
    if (actual.length != expected.length) return false;

    for (var i = 0; i < actual.length; i++) {
      if (actual[i] !== expected[i]) return false;
    }

    return true;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!util.isObject(actual) && !util.isObject(expected)) {
    return actual == expected;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b) {
  if (util.isNullOrUndefined(a) || util.isNullOrUndefined(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b)) {
    return a === b;
  }
  var aIsArgs = isArguments(a),
      bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b);
  }
  var ka = objectKeys(a),
      kb = objectKeys(b),
      key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key])) return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  } else if (actual instanceof expected) {
    return true;
  } else if (expected.call({}, actual) === true) {
    return true;
  }

  return false;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (util.isString(expected)) {
    message = expected;
    expected = null;
  }

  try {
    block();
  } catch (e) {
    actual = e;
  }

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  if (!shouldThrow && expectedException(actual, expected)) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws.apply(this, [true].concat(pSlice.call(arguments)));
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/message) {
  _throws.apply(this, [false].concat(pSlice.call(arguments)));
};

assert.ifError = function(err) { if (err) {throw err;}};

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

},{"util/":11}],9:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],10:[function(require,module,exports){
module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
},{}],11:[function(require,module,exports){
(function (process,global){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./support/isBuffer":10,"_process":14,"inherits":9}],12:[function(require,module,exports){

},{}],13:[function(require,module,exports){
(function (process){
// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

}).call(this,require('_process'))
},{"_process":14}],14:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],15:[function(require,module,exports){
var unparse = require('escodegen').generate;

module.exports = function (ast, vars) {
    if (!vars) vars = {};
    var FAIL = {};
    
    var result = (function walk (node, scopeVars) {
        if (node.type === 'Literal') {
            return node.value;
        }
        else if (node.type === 'UnaryExpression'){
            var val = walk(node.argument)
            if (node.operator === '+') return +val
            if (node.operator === '-') return -val
            if (node.operator === '~') return ~val
            if (node.operator === '!') return !val
            return FAIL
        }
        else if (node.type === 'ArrayExpression') {
            var xs = [];
            for (var i = 0, l = node.elements.length; i < l; i++) {
                var x = walk(node.elements[i]);
                if (x === FAIL) return FAIL;
                xs.push(x);
            }
            return xs;
        }
        else if (node.type === 'ObjectExpression') {
            var obj = {};
            for (var i = 0; i < node.properties.length; i++) {
                var prop = node.properties[i];
                var value = prop.value === null
                    ? prop.value
                    : walk(prop.value)
                ;
                if (value === FAIL) return FAIL;
                obj[prop.key.value || prop.key.name] = value;
            }
            return obj;
        }
        else if (node.type === 'BinaryExpression' ||
                 node.type === 'LogicalExpression') {
            var l = walk(node.left);
            if (l === FAIL) return FAIL;
            var r = walk(node.right);
            if (r === FAIL) return FAIL;
            
            var op = node.operator;
            if (op === '==') return l == r;
            if (op === '===') return l === r;
            if (op === '!=') return l != r;
            if (op === '!==') return l !== r;
            if (op === '+') return l + r;
            if (op === '-') return l - r;
            if (op === '*') return l * r;
            if (op === '/') return l / r;
            if (op === '%') return l % r;
            if (op === '<') return l < r;
            if (op === '<=') return l <= r;
            if (op === '>') return l > r;
            if (op === '>=') return l >= r;
            if (op === '|') return l | r;
            if (op === '&') return l & r;
            if (op === '^') return l ^ r;
            if (op === '&&') return l && r;
            if (op === '||') return l || r;
            
            return FAIL;
        }
        else if (node.type === 'Identifier') {
            if ({}.hasOwnProperty.call(vars, node.name)) {
                return vars[node.name];
            }
            else return FAIL;
        }
        else if (node.type === 'ThisExpression') {
            if ({}.hasOwnProperty.call(vars, 'this')) {
                return vars['this'];
            }
            else return FAIL;
        }
        else if (node.type === 'CallExpression') {
            var callee = walk(node.callee);
            if (callee === FAIL) return FAIL;
            if (typeof callee !== 'function') return FAIL;
            
            var ctx = node.callee.object ? walk(node.callee.object) : FAIL;
            if (ctx === FAIL) ctx = null;

            var args = [];
            for (var i = 0, l = node.arguments.length; i < l; i++) {
                var x = walk(node.arguments[i]);
                if (x === FAIL) return FAIL;
                args.push(x);
            }
            return callee.apply(ctx, args);
        }
        else if (node.type === 'MemberExpression') {
            var obj = walk(node.object);
            // do not allow access to methods on Function 
            if((obj === FAIL) || (typeof obj == 'function')){
                return FAIL;
            }
            if (node.property.type === 'Identifier') {
                return obj[node.property.name];
            }
            var prop = walk(node.property);
            if (prop === FAIL) return FAIL;
            return obj[prop];
        }
        else if (node.type === 'ConditionalExpression') {
            var val = walk(node.test)
            if (val === FAIL) return FAIL;
            return val ? walk(node.consequent) : walk(node.alternate)
        }
        else if (node.type === 'ExpressionStatement') {
            var val = walk(node.expression)
            if (val === FAIL) return FAIL;
            return val;
        }
        else if (node.type === 'ReturnStatement') {
            return walk(node.argument)
        }
        else if (node.type === 'FunctionExpression') {
            
            var bodies = node.body.body;
            
            // Create a "scope" for our arguments
            var oldVars = {};
            Object.keys(vars).forEach(function(element){
                oldVars[element] = vars[element];
            })

            for(var i=0; i<node.params.length; i++){
                var key = node.params[i];
                if(key.type == 'Identifier'){
                  vars[key.name] = null;
                }
                else return FAIL;
            }
            for(var i in bodies){
                if(walk(bodies[i]) === FAIL){
                    return FAIL;
                }
            }
            // restore the vars and scope after we walk
            vars = oldVars;
            
            var keys = Object.keys(vars);
            var vals = keys.map(function(key) {
                return vars[key];
            });
            return Function(keys.join(', '), 'return ' + unparse(node)).apply(null, vals);
        }
        else if (node.type === 'TemplateLiteral') {
            var str = '';
            for (var i = 0; i < node.expressions.length; i++) {
                str += walk(node.quasis[i]);
                str += walk(node.expressions[i]);
            }
            str += walk(node.quasis[i]);
            return str;
        }
        else if (node.type === 'TaggedTemplateExpression') {
            var tag = walk(node.tag);
            var quasi = node.quasi;
            var strings = quasi.quasis.map(walk);
            var values = quasi.expressions.map(walk);
            return tag.apply(null, [strings].concat(values));
        }
        else if (node.type === 'TemplateElement') {
            return node.value.cooked;
        }
        else return FAIL;
    })(ast);
    
    return result === FAIL ? undefined : result;
};

},{"escodegen":12}],"jsonpath":[function(require,module,exports){
module.exports = require('./lib/index');

},{"./lib/index":5}]},{},["jsonpath"])("jsonpath")
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(540);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(121)))

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var defaultStopwords = __webpack_require__(194).words

exports.removeStopwords = function(tokens, stopwords) {
  stopwords = stopwords || defaultStopwords
  if (typeof tokens !== 'object' || typeof stopwords != 'object'){
    throw new Error ('expected Arrays try: removeStopwords(Array[, Array])')
  }
  return tokens.filter(function (value) {
    return stopwords.indexOf(value.toLowerCase()) === -1
  })
}

exports.ar = __webpack_require__(542).words
exports.bn = __webpack_require__(543).words
exports.br = __webpack_require__(544).words
exports.da = __webpack_require__(545).words
exports.de = __webpack_require__(546).words
exports.en = __webpack_require__(194).words
exports.es = __webpack_require__(547).words
exports.fa = __webpack_require__(548).words
exports.fr = __webpack_require__(549).words
exports.hi = __webpack_require__(550).words
exports.it = __webpack_require__(551).words
exports.ja = __webpack_require__(552).words
exports.nl = __webpack_require__(553).words
exports.no = __webpack_require__(554).words
exports.pa_in = __webpack_require__(555).words
exports.pl = __webpack_require__(556).words
exports.pt = __webpack_require__(557).words
exports.ru = __webpack_require__(558).words
exports.sv = __webpack_require__(559).words
exports.zh = __webpack_require__(560).words


/***/ }),
/* 542 */
/***/ (function(module, exports) {

/*
The MIT License (MIT)

Copyright (c) 2016 Gene Diaz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = ["،","آض","آمينَ","آه","آهاً","آي","أ","أب","أجل","أجمع","أخ","أخذ","أصبح","أضحى","أقبل","أقل","أكثر","ألا","أم","أما","أمامك","أمامكَ","أمسى","أمّا","أن","أنا","أنت","أنتم","أنتما","أنتن","أنتِ","أنشأ","أنّى","أو","أوشك","أولئك","أولئكم","أولاء","أولالك","أوّهْ","أي","أيا","أين","أينما","أيّ","أَنَّ","أََيُّ","أُفٍّ","إذ","إذا","إذاً","إذما","إذن","إلى","إليكم","إليكما","إليكنّ","إليكَ","إلَيْكَ","إلّا","إمّا","إن","إنّما","إي","إياك","إياكم","إياكما","إياكن","إيانا","إياه","إياها","إياهم","إياهما","إياهن","إياي","إيهٍ","إِنَّ","ا","ابتدأ","اثر","اجل","احد","اخرى","اخلولق","اذا","اربعة","ارتدّ","استحال","اطار","اعادة","اعلنت","اف","اكثر","اكد","الألاء","الألى","الا","الاخيرة","الان","الاول","الاولى","التى","التي","الثاني","الثانية","الذاتي","الذى","الذي","الذين","السابق","الف","اللائي","اللاتي","اللتان","اللتيا","اللتين","اللذان","اللذين","اللواتي","الماضي","المقبل","الوقت","الى","اليوم","اما","امام","امس","ان","انبرى","انقلب","انه","انها","او","اول","اي","ايار","ايام","ايضا","ب","بات","باسم","بان","بخٍ","برس","بسبب","بسّ","بشكل","بضع","بطآن","بعد","بعض","بك","بكم","بكما","بكن","بل","بلى","بما","بماذا","بمن","بن","بنا","به","بها","بي","بيد","بين","بَسْ","بَلْهَ","بِئْسَ","تانِ","تانِك","تبدّل","تجاه","تحوّل","تلقاء","تلك","تلكم","تلكما","تم","تينك","تَيْنِ","تِه","تِي","ثلاثة","ثم","ثمّ","ثمّة","ثُمَّ","جعل","جلل","جميع","جير","حار","حاشا","حاليا","حاي","حتى","حرى","حسب","حم","حوالى","حول","حيث","حيثما","حين","حيَّ","حَبَّذَا","حَتَّى","حَذارِ","خلا","خلال","دون","دونك","ذا","ذات","ذاك","ذانك","ذانِ","ذلك","ذلكم","ذلكما","ذلكن","ذو","ذوا","ذواتا","ذواتي","ذيت","ذينك","ذَيْنِ","ذِه","ذِي","راح","رجع","رويدك","ريث","رُبَّ","زيارة","سبحان","سرعان","سنة","سنوات","سوف","سوى","سَاءَ","سَاءَمَا","شبه","شخصا","شرع","شَتَّانَ","صار","صباح","صفر","صهٍ","صهْ","ضد","ضمن","طاق","طالما","طفق","طَق","ظلّ","عاد","عام","عاما","عامة","عدا","عدة","عدد","عدم","عسى","عشر","عشرة","علق","على","عليك","عليه","عليها","علًّ","عن","عند","عندما","عوض","عين","عَدَسْ","عَمَّا","غدا","غير","ـ","ف","فان","فلان","فو","فى","في","فيم","فيما","فيه","فيها","قال","قام","قبل","قد","قطّ","قلما","قوة","كأنّما","كأين","كأيّ","كأيّن","كاد","كان","كانت","كذا","كذلك","كرب","كل","كلا","كلاهما","كلتا","كلم","كليكما","كليهما","كلّما","كلَّا","كم","كما","كي","كيت","كيف","كيفما","كَأَنَّ","كِخ","لئن","لا","لات","لاسيما","لدن","لدى","لعمر","لقاء","لك","لكم","لكما","لكن","لكنَّما","لكي","لكيلا","للامم","لم","لما","لمّا","لن","لنا","له","لها","لو","لوكالة","لولا","لوما","لي","لَسْتَ","لَسْتُ","لَسْتُم","لَسْتُمَا","لَسْتُنَّ","لَسْتِ","لَسْنَ","لَعَلَّ","لَكِنَّ","لَيْتَ","لَيْسَ","لَيْسَا","لَيْسَتَا","لَيْسَتْ","لَيْسُوا","لَِسْنَا","ما","ماانفك","مابرح","مادام","ماذا","مازال","مافتئ","مايو","متى","مثل","مذ","مساء","مع","معاذ","مقابل","مكانكم","مكانكما","مكانكنّ","مكانَك","مليار","مليون","مما","ممن","من","منذ","منها","مه","مهما","مَنْ","مِن","نحن","نحو","نعم","نفس","نفسه","نهاية","نَخْ","نِعِمّا","نِعْمَ","ها","هاؤم","هاكَ","هاهنا","هبّ","هذا","هذه","هكذا","هل","هلمَّ","هلّا","هم","هما","هن","هنا","هناك","هنالك","هو","هي","هيا","هيت","هيّا","هَؤلاء","هَاتانِ","هَاتَيْنِ","هَاتِه","هَاتِي","هَجْ","هَذا","هَذانِ","هَذَيْنِ","هَذِه","هَذِي","هَيْهَاتَ","و","و6","وا","واحد","واضاف","واضافت","واكد","وان","واهاً","واوضح","وراءَك","وفي","وقال","وقالت","وقد","وقف","وكان","وكانت","ولا","ولم","ومن","وهو","وهي","ويكأنّ","وَيْ","وُشْكَانََ","يكون","يمكن","يوم","ّأيّان"]

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 543 */
/***/ (function(module, exports) {

/*
The MIT License (MIT)

Copyright (c) 2016 Gene Diaz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = ["অতএব","অথচ","অথবা","অনুযায়ী","অনেক","অনেকে","অনেকেই","অন্তত","অন্য","অবধি","অবশ্য","অর্থাত","আই","আগামী","আগে","আগেই","আছে","আজ","আদ্যভাগে","আপনার","আপনি","আবার","আমরা","আমাকে","আমাদের","আমার","আমি","আর","আরও","ই","ইত্যাদি","ইহা","উচিত","উত্তর","উনি","উপর","উপরে","এ","এঁদের","এঁরা","এই","একই","একটি","একবার","একে","এক্","এখন","এখনও","এখানে","এখানেই","এটা","এটাই","এটি","এত","এতটাই","এতে","এদের","এব","এবং","এবার","এমন","এমনকী","এমনি","এর","এরা","এল","এস","এসে","ঐ","ও","ওঁদের","ওঁর","ওঁরা","ওই","ওকে","ওখানে","ওদের","ওর","ওরা","কখনও","কত","কবে","কমনে","কয়েক","কয়েকটি","করছে","করছেন","করতে","করবে","করবেন","করলে","করলেন","করা","করাই","করায়","করার","করি","করিতে","করিয়া","করিয়ে","করে","করেই","করেছিলেন","করেছে","করেছেন","করেন","কাউকে","কাছ","কাছে","কাজ","কাজে","কারও","কারণ","কি","কিংবা","কিছু","কিছুই","কিন্তু","কী","কে","কেউ","কেউই","কেখা","কেন","কোটি","কোন","কোনও","কোনো","ক্ষেত্রে","কয়েক","খুব","গিয়ে","গিয়েছে","গিয়ে","গুলি","গেছে","গেল","গেলে","গোটা","চলে","চান","চায়","চার","চালু","চেয়ে","চেষ্টা","ছাড়া","ছাড়াও","ছিল","ছিলেন","জন","জনকে","জনের","জন্য","জন্যওজে","জানতে","জানা","জানানো","জানায়","জানিয়ে","জানিয়েছে","জে","জ্নজন","টি","ঠিক","তখন","তত","তথা","তবু","তবে","তা","তাঁকে","তাঁদের","তাঁর","তাঁরা","তাঁাহারা","তাই","তাও","তাকে","তাতে","তাদের","তার","তারপর","তারা","তারৈ","তাহলে","তাহা","তাহাতে","তাহার","তিনঐ","তিনি","তিনিও","তুমি","তুলে","তেমন","তো","তোমার","থাকবে","থাকবেন","থাকা","থাকায়","থাকে","থাকেন","থেকে","থেকেই","থেকেও","দিকে","দিতে","দিন","দিয়ে","দিয়েছে","দিয়েছেন","দিলেন","দু","দুই","দুটি","দুটো","দেওয়া","দেওয়ার","দেওয়া","দেখতে","দেখা","দেখে","দেন","দেয়","দ্বারা","ধরা","ধরে","ধামার","নতুন","নয়","না","নাই","নাকি","নাগাদ","নানা","নিজে","নিজেই","নিজেদের","নিজের","নিতে","নিয়ে","নিয়ে","নেই","নেওয়া","নেওয়ার","নেওয়া","নয়","পক্ষে","পর","পরে","পরেই","পরেও","পর্যন্ত","পাওয়া","পাচ","পারি","পারে","পারেন","পি","পেয়ে","পেয়্র্","প্রতি","প্রথম","প্রভৃতি","প্রযন্ত","প্রাথমিক","প্রায়","প্রায়","ফলে","ফিরে","ফের","বক্তব্য","বদলে","বন","বরং","বলতে","বলল","বললেন","বলা","বলে","বলেছেন","বলেন","বসে","বহু","বা","বাদে","বার","বি","বিনা","বিভিন্ন","বিশেষ","বিষয়টি","বেশ","বেশি","ব্যবহার","ব্যাপারে","ভাবে","ভাবেই","মতো","মতোই","মধ্যভাগে","মধ্যে","মধ্যেই","মধ্যেও","মনে","মাত্র","মাধ্যমে","মোট","মোটেই","যখন","যত","যতটা","যথেষ্ট","যদি","যদিও","যা","যাঁর","যাঁরা","যাওয়া","যাওয়ার","যাওয়া","যাকে","যাচ্ছে","যাতে","যাদের","যান","যাবে","যায়","যার","যারা","যিনি","যে","যেখানে","যেতে","যেন","যেমন","র","রকম","রয়েছে","রাখা","রেখে","লক্ষ","শুধু","শুরু","সঙ্গে","সঙ্গেও","সব","সবার","সমস্ত","সম্প্রতি","সহ","সহিত","সাধারণ","সামনে","সি","সুতরাং","সে","সেই","সেখান","সেখানে","সেটা","সেটাই","সেটাও","সেটি","স্পষ্ট","স্বয়ং","হইতে","হইবে","হইয়া","হওয়া","হওয়ায়","হওয়ার","হচ্ছে","হত","হতে","হতেই","হন","হবে","হবেন","হয়","হয়তো","হয়নি","হয়ে","হয়েই","হয়েছিল","হয়েছে","হয়েছেন","হল","হলে","হলেই","হলেও","হলো","হাজার","হিসাবে","হৈলে","হোক","হয়"]
// tell the world about the noise words.
exports.words = words


/***/ }),
/* 544 */
/***/ (function(module, exports) {

// Original copyright:
/*
Copyright (c) 2017, Micael Levi

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// This version:
/*
The MIT License (MIT)

Copyright (c) 2017 Fabrício Rodrigues

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

// a list of commonly used words (pt-BR) that have little meaning and can be excluded
// from analysis.
var words = [
  'a',
  'à',
  'adeus',
  'agora',
  'aí',
  'ainda',
  'além',
  'algo',
  'alguém',
  'algum',
  'alguma',
  'algumas',
  'alguns',
  'ali',
  'ampla',
  'amplas',
  'amplo',
  'amplos',
  'ano',
  'anos',
  'ante',
  'antes',
  'ao',
  'aos',
  'apenas',
  'apoio',
  'após',
  'aquela',
  'aquelas',
  'aquele',
  'aqueles',
  'aqui',
  'aquilo',
  'área',
  'as',
  'às',
  'assim',
  'até',
  'atrás',
  'através',
  'baixo',
  'bastante',
  'bem',
  'boa',
  'boas',
  'bom',
  'bons',
  'breve',
  'cá',
  'cada',
  'catorze',
  'cedo',
  'cento',
  'certamente',
  'certeza',
  'cima',
  'cinco',
  'coisa',
  'coisas',
  'com',
  'como',
  'conselho',
  'contra',
  'contudo',
  'custa',
  'da',
  'dá',
  'dão',
  'daquela',
  'daquelas',
  'daquele',
  'daqueles',
  'dar',
  'das',
  'de',
  'debaixo',
  'dela',
  'delas',
  'dele',
  'deles',
  'demais',
  'dentro',
  'depois',
  'desde',
  'dessa',
  'dessas',
  'desse',
  'desses',
  'desta',
  'destas',
  'deste',
  'destes',
  'deve',
  'devem',
  'devendo',
  'dever',
  'deverá',
  'deverão',
  'deveria',
  'deveriam',
  'devia',
  'deviam',
  'dez',
  'dezanove',
  'dezasseis',
  'dezassete',
  'dezoito',
  'dia',
  'diante',
  'disse',
  'disso',
  'disto',
  'dito',
  'diz',
  'dizem',
  'dizer',
  'do',
  'dois',
  'dos',
  'doze',
  'duas',
  'dúvida',
  'e',
  'é',
  'ela',
  'elas',
  'ele',
  'eles',
  'em',
  'embora',
  'enquanto',
  'entre',
  'era',
  'eram',
  'éramos',
  'és',
  'essa',
  'essas',
  'esse',
  'esses',
  'esta',
  'está',
  'estamos',
  'estão',
  'estar',
  'estas',
  'estás',
  'estava',
  'estavam',
  'estávamos',
  'este',
  'esteja',
  'estejam',
  'estejamos',
  'estes',
  'esteve',
  'estive',
  'estivemos',
  'estiver',
  'estivera',
  'estiveram',
  'estivéramos',
  'estiverem',
  'estivermos',
  'estivesse',
  'estivessem',
  'estivéssemos',
  'estiveste',
  'estivestes',
  'estou',
  'etc',
  'eu',
  'exemplo',
  'faço',
  'falta',
  'favor',
  'faz',
  'fazeis',
  'fazem',
  'fazemos',
  'fazendo',
  'fazer',
  'fazes',
  'feita',
  'feitas',
  'feito',
  'feitos',
  'fez',
  'fim',
  'final',
  'foi',
  'fomos',
  'for',
  'fora',
  'foram',
  'fôramos',
  'forem',
  'forma',
  'formos',
  'fosse',
  'fossem',
  'fôssemos',
  'foste',
  'fostes',
  'fui',
  'geral',
  'grande',
  'grandes',
  'grupo',
  'há',
  'haja',
  'hajam',
  'hajamos',
  'hão',
  'havemos',
  'havia',
  'hei',
  'hoje',
  'hora',
  'horas',
  'houve',
  'houvemos',
  'houver',
  'houvera',
  'houverá',
  'houveram',
  'houvéramos',
  'houverão',
  'houverei',
  'houverem',
  'houveremos',
  'houveria',
  'houveriam',
  'houveríamos',
  'houvermos',
  'houvesse',
  'houvessem',
  'houvéssemos',
  'isso',
  'isto',
  'já',
  'la',
  'lá',
  'lado',
  'lhe',
  'lhes',
  'lo',
  'local',
  'logo',
  'longe',
  'lugar',
  'maior',
  'maioria',
  'mais',
  'mal',
  'mas',
  'máximo',
  'me',
  'meio',
  'menor',
  'menos',
  'mês',
  'meses',
  'mesma',
  'mesmas',
  'mesmo',
  'mesmos',
  'meu',
  'meus',
  'mil',
  'minha',
  'minhas',
  'momento',
  'muita',
  'muitas',
  'muito',
  'muitos',
  'na',
  'nada',
  'não',
  'naquela',
  'naquelas',
  'naquele',
  'naqueles',
  'nas',
  'nem',
  'nenhum',
  'nenhuma',
  'nessa',
  'nessas',
  'nesse',
  'nesses',
  'nesta',
  'nestas',
  'neste',
  'nestes',
  'ninguém',
  'nível',
  'no',
  'noite',
  'nome',
  'nos',
  'nós',
  'nossa',
  'nossas',
  'nosso',
  'nossos',
  'nova',
  'novas',
  'nove',
  'novo',
  'novos',
  'num',
  'numa',
  'número',
  'nunca',
  'o',
  'obra',
  'obrigada',
  'obrigado',
  'oitava',
  'oitavo',
  'oito',
  'onde',
  'ontem',
  'onze',
  'os',
  'ou',
  'outra',
  'outras',
  'outro',
  'outros',
  'para',
  'parece',
  'parte',
  'partir',
  'paucas',
  'pela',
  'pelas',
  'pelo',
  'pelos',
  'pequena',
  'pequenas',
  'pequeno',
  'pequenos',
  'per',
  'perante',
  'perto',
  'pode',
  'pude',
  'pôde',
  'podem',
  'podendo',
  'poder',
  'poderia',
  'poderiam',
  'podia',
  'podiam',
  'põe',
  'põem',
  'pois',
  'ponto',
  'pontos',
  'por',
  'porém',
  'porque',
  'porquê',
  'posição',
  'possível',
  'possivelmente',
  'posso',
  'pouca',
  'poucas',
  'pouco',
  'poucos',
  'primeira',
  'primeiras',
  'primeiro',
  'primeiros',
  'própria',
  'próprias',
  'próprio',
  'próprios',
  'próxima',
  'próximas',
  'próximo',
  'próximos',
  'pude',
  'puderam',
  'quais',
  'quáis',
  'qual',
  'quando',
  'quanto',
  'quantos',
  'quarta',
  'quarto',
  'quatro',
  'que',
  'quê',
  'quem',
  'quer',
  'quereis',
  'querem',
  'queremas',
  'queres',
  'quero',
  'questão',
  'quinta',
  'quinto',
  'quinze',
  'relação',
  'sabe',
  'sabem',
  'são',
  'se',
  'segunda',
  'segundo',
  'sei',
  'seis',
  'seja',
  'sejam',
  'sejamos',
  'sem',
  'sempre',
  'sendo',
  'ser',
  'será',
  'serão',
  'serei',
  'seremos',
  'seria',
  'seriam',
  'seríamos',
  'sete',
  'sétima',
  'sétimo',
  'seu',
  'seus',
  'sexta',
  'sexto',
  'si',
  'sido',
  'sim',
  'sistema',
  'só',
  'sob',
  'sobre',
  'sois',
  'somos',
  'sou',
  'sua',
  'suas',
  'tal',
  'talvez',
  'também',
  'tampouco',
  'tanta',
  'tantas',
  'tanto',
  'tão',
  'tarde',
  'te',
  'tem',
  'tém',
  'têm',
  'temos',
  'tendes',
  'tendo',
  'tenha',
  'tenham',
  'tenhamos',
  'tenho',
  'tens',
  'ter',
  'terá',
  'terão',
  'terceira',
  'terceiro',
  'terei',
  'teremos',
  'teria',
  'teriam',
  'teríamos',
  'teu',
  'teus',
  'teve',
  'ti',
  'tido',
  'tinha',
  'tinham',
  'tínhamos',
  'tive',
  'tivemos',
  'tiver',
  'tivera',
  'tiveram',
  'tivéramos',
  'tiverem',
  'tivermos',
  'tivesse',
  'tivessem',
  'tivéssemos',
  'tiveste',
  'tivestes',
  'toda',
  'todas',
  'todavia',
  'todo',
  'todos',
  'trabalho',
  'três',
  'treze',
  'tu',
  'tua',
  'tuas',
  'tudo',
  'última',
  'últimas',
  'último',
  'últimos',
  'um',
  'uma',
  'umas',
  'uns',
  'vai',
  'vais',
  'vão',
  'vários',
  'vem',
  'vêm',
  'vendo',
  'vens',
  'ver',
  'vez',
  'vezes',
  'viagem',
  'vindo',
  'vinte',
  'vir',
  'você',
  'vocês',
  'vos',
  'vós',
  'vossa',
  'vossas',
  'vosso',
  'vossos',
  'zero',
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_'
]

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 545 */
/***/ (function(module, exports) {

/*
Creative Commons – Attribution / ShareAlike 3.0 license
http://creativecommons.org/licenses/by-sa/3.0/

List based on frequently used words in subtitles in 2012.

Thanks to
opensubtitles.org
https://invokeit.wordpress.com/frequency-word-lists/#comment-9707
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = [
  'er', 'jeg', 'det', 'du', 'ikke', 'i', 'at', 'en', 'og', 'har',
  'vi', 'til', 'på', 'hvad', 'med', 'mig', 'så', 'for', 'de', 'dig',
  'der', 'den', 'han', 'kan', 'af', 'vil', 'var', 'her', 'et', 'skal',
  'ved', 'nu', 'men', 'om', 'ja', 'som', 'nej', 'min', 'noget', 'ham',
  'hun', 'bare', 'kom', 'være', 'din', 'hvor', 'dem', 'ud', 'os', 'hvis',
  'må', 'se', 'godt', 'have', 'fra', 'ville', 'okay', 'lige', 'op', 'alle',
  'lad', 'hvorfor', 'sig', 'hvordan', 'få', 'kunne', 'eller', 'hvem', 'man', 'bliver',
  'havde', 'da', 'ingen', 'efter', 'når', 'alt', 'jo', 'to', 'mit', 'ind',
  'hej', 'aldrig', 'lidt', 'nogen', 'over', 'også', 'mand', 'far', 'skulle', 'selv',
  'får', 'hans', 'ser', 'vores', 'jer', 'sådan', 'dit', 'kun', 'deres', 'ned',
  'mine', 'komme', 'tage', 'denne', 'sige', 'dette', 'blive', 'helt', 'fordi',
  'end', 'tag', 'før', 'fik', 'dine',
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 546 */
/***/ (function(module, exports) {

/*
The MIT License (MIT)

Copyright (c) 2016 Gene Diaz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = [
  'a', 'ab', 'aber', 'ach', 'acht', 'achte', 'achten', 'achter', 'achtes', 'ag', 'alle', 'allein', 'allem', 'allen', 'aller', 'allerdings', 'alles', 'allgemeinen', 'als', 'also', 'am', 'an', 'ander', 'andere', 'anderem', 'anderen', 'anderer', 'anderes', 'anderm', 'andern', 'anderr', 'anders', 'au', 'auch', 'auf', 'aus', 'ausser', 'ausserdem', 'außer', 'außerdem', 'b', 'bald', 'bei', 'beide', 'beiden', 'beim', 'beispiel', 'bekannt', 'bereits', 'besonders', 'besser', 'besten', 'bin', 'bis', 'bisher', 'bist', 'c', 'd', 'd.h', 'da', 'dabei', 'dadurch', 'dafür', 'dagegen', 'daher', 'dahin', 'dahinter', 'damals', 'damit', 'danach', 'daneben', 'dank', 'dann', 'daran', 'darauf', 'daraus', 'darf', 'darfst', 'darin', 'darum', 'darunter', 'darüber', 'das', 'dasein', 'daselbst', 'dass', 'dasselbe', 'davon', 'davor', 'dazu', 'dazwischen', 'daß', 'dein', 'deine', 'deinem', 'deinen', 'deiner', 'deines', 'dem', 'dementsprechend', 'demgegenüber', 'demgemäss', 'demgemäß', 'demselben', 'demzufolge', 'den', 'denen', 'denn', 'denselben', 'der', 'deren', 'derer', 'derjenige', 'derjenigen', 'dermassen', 'dermaßen', 'derselbe', 'derselben', 'des', 'deshalb', 'desselben', 'dessen', 'deswegen', 'dich', 'die', 'diejenige', 'diejenigen', 'dies', 'diese', 'dieselbe', 'dieselben', 'diesem', 'diesen', 'dieser', 'dieses', 'dir', 'doch', 'dort', 'drei', 'drin', 'dritte', 'dritten', 'dritter', 'drittes', 'du', 'durch', 'durchaus', 'durfte', 'durften', 'dürfen', 'dürft', 'e', 'eben', 'ebenso', 'ehrlich', 'ei', 'ei, ', 'eigen', 'eigene', 'eigenen', 'eigener', 'eigenes', 'ein', 'einander', 'eine', 'einem', 'einen', 'einer', 'eines', 'einig', 'einige', 'einigem', 'einigen', 'einiger', 'einiges', 'einmal', 'eins', 'elf', 'en', 'ende', 'endlich', 'entweder', 'er', 'ernst', 'erst', 'erste', 'ersten', 'erster', 'erstes', 'es', 'etwa', 'etwas', 'euch', 'euer', 'eure', 'eurem', 'euren', 'eurer', 'eures', 'f', 'folgende', 'früher', 'fünf', 'fünfte', 'fünften', 'fünfter', 'fünftes', 'für', 'g', 'gab', 'ganz', 'ganze', 'ganzen', 'ganzer', 'ganzes', 'gar', 'gedurft', 'gegen', 'gegenüber', 'gehabt', 'gehen', 'geht', 'gekannt', 'gekonnt', 'gemacht', 'gemocht', 'gemusst', 'genug', 'gerade', 'gern', 'gesagt', 'geschweige', 'gewesen', 'gewollt', 'geworden', 'gibt', 'ging', 'gleich', 'gott', 'gross', 'grosse', 'grossen', 'grosser', 'grosses', 'groß', 'große', 'großen', 'großer', 'großes', 'gut', 'gute', 'guter', 'gutes', 'h', 'hab', 'habe', 'haben', 'habt', 'hast', 'hat', 'hatte', 'hatten', 'hattest', 'hattet', 'heisst', 'her', 'heute', 'hier', 'hin', 'hinter', 'hoch', 'hätte', 'hätten', 'i', 'ich', 'ihm', 'ihn', 'ihnen', 'ihr', 'ihre', 'ihrem', 'ihren', 'ihrer', 'ihres', 'im', 'immer', 'in', 'indem', 'infolgedessen', 'ins', 'irgend', 'ist', 'j', 'ja', 'jahr', 'jahre', 'jahren', 'je', 'jede', 'jedem', 'jeden', 'jeder', 'jedermann', 'jedermanns', 'jedes', 'jedoch', 'jemand', 'jemandem', 'jemanden', 'jene', 'jenem', 'jenen', 'jener', 'jenes', 'jetzt', 'k', 'kam', 'kann', 'kannst', 'kaum', 'kein', 'keine', 'keinem', 'keinen', 'keiner', 'keines', 'kleine', 'kleinen', 'kleiner', 'kleines', 'kommen', 'kommt', 'konnte', 'konnten', 'kurz', 'können', 'könnt', 'könnte', 'l', 'lang', 'lange', 'leicht', 'leide', 'lieber', 'los', 'm', 'machen', 'macht', 'machte', 'mag', 'magst', 'mahn', 'mal', 'man', 'manche', 'manchem', 'manchen', 'mancher', 'manches', 'mann', 'mehr', 'mein', 'meine', 'meinem', 'meinen', 'meiner', 'meines', 'mensch', 'menschen', 'mich', 'mir', 'mit', 'mittel', 'mochte', 'mochten', 'morgen', 'muss', 'musst', 'musste', 'mussten', 'muß', 'mußt', 'möchte', 'mögen', 'möglich', 'mögt', 'müssen', 'müsst', 'müßt', 'n', 'na', 'nach', 'nachdem', 'nahm', 'natürlich', 'neben', 'nein', 'neue', 'neuen', 'neun', 'neunte', 'neunten', 'neunter', 'neuntes', 'nicht', 'nichts', 'nie', 'niemand', 'niemandem', 'niemanden', 'noch', 'nun', 'nur', 'o', 'ob', 'oben', 'oder', 'offen', 'oft', 'ohne', 'ordnung', 'p', 'q', 'r', 'recht', 'rechte', 'rechten', 'rechter', 'rechtes', 'richtig', 'rund', 's', 'sa', 'sache', 'sagt', 'sagte', 'sah', 'satt', 'schlecht', 'schluss', 'schon', 'sechs', 'sechste', 'sechsten', 'sechster', 'sechstes', 'sehr', 'sei', 'seid', 'seien', 'sein', 'seine', 'seinem', 'seinen', 'seiner', 'seines', 'seit', 'seitdem', 'selbst', 'sich', 'sie', 'sieben', 'siebente', 'siebenten', 'siebenter', 'siebentes', 'sind', 'so', 'solang', 'solche', 'solchem', 'solchen', 'solcher', 'solches', 'soll', 'sollen', 'sollst', 'sollt', 'sollte', 'sollten', 'sondern', 'sonst', 'soweit', 'sowie', 'später', 'startseite', 'statt', 'steht', 'suche', 't', 'tag', 'tage', 'tagen', 'tat', 'teil', 'tel', 'tritt', 'trotzdem', 'tun', 'u', 'uhr', 'um', 'und', 'und?', 'uns', 'unse', 'unsem', 'unsen', 'unser', 'unsere', 'unserer', 'unses', 'unter', 'v', 'vergangenen', 'viel', 'viele', 'vielem', 'vielen', 'vielleicht', 'vier', 'vierte', 'vierten', 'vierter', 'viertes', 'vom', 'von', 'vor', 'w', 'wahr?', 'wann', 'war', 'waren', 'warst', 'wart', 'warum', 'was', 'weg', 'wegen', 'weil', 'weit', 'weiter', 'weitere', 'weiteren', 'weiteres', 'welche', 'welchem', 'welchen', 'welcher', 'welches', 'wem', 'wen', 'wenig', 'wenige', 'weniger', 'weniges', 'wenigstens', 'wenn', 'wer', 'werde', 'werden', 'werdet', 'weshalb', 'wessen', 'wie', 'wieder', 'wieso', 'will', 'willst', 'wir', 'wird', 'wirklich', 'wirst', 'wissen', 'wo', 'woher', 'wohin', 'wohl', 'wollen', 'wollt', 'wollte', 'wollten', 'worden', 'wurde', 'wurden', 'während', 'währenddem', 'währenddessen', 'wäre', 'würde', 'würden', 'x', 'y', 'z', 'z.b', 'zehn', 'zehnte', 'zehnten', 'zehnter', 'zehntes', 'zeit', 'zu', 'zuerst', 'zugleich', 'zum', 'zunächst', 'zur', 'zurück', 'zusammen', 'zwanzig', 'zwar', 'zwei', 'zweite', 'zweiten', 'zweiter', 'zweites', 'zwischen', 'zwölf', 'über', 'überhaupt', 'übrigens'
]

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 547 */
/***/ (function(module, exports) {

/*
Copyright (c) 2011, David Przybilla, Chris Umbel

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = [
  'a', 'un', 'el', 'ella', 'y', 'sobre', 'de', 'la', 'que', 'en',
  'los', 'del', 'se', 'las', 'por', 'un', 'para', 'con', 'no',
  'una', 'su', 'al', 'lo', 'como', 'más', 'pero', 'sus', 'le',
  'ya', 'o', 'porque', 'cuando', 'muy', 'sin', 'sobre', 'también',
  'me', 'hasta', 'donde', 'quien', 'desde', 'nos', 'durante', 'uno',
  'ni', 'contra', 'ese', 'eso', 'mí', 'qué', 'otro', 'él', 'cual',
  'poco', 'mi', 'tú', 'te', 'ti', 'sí',
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 548 */
/***/ (function(module, exports) {

/*
Copyright (c) 2011, Chris Umbel
Farsi Stop Words by Fardin Koochaki <me@fardinak.com>

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = [
  // Words
  'از', 'با', 'یه', 'برای', 'و', 'باید', 'شاید',

  // Symbols
  '؟', '!', '٪', '.', '،', '؛', ':', ';', ',',

  // Numbers
  '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '۰'
]

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 549 */
/***/ (function(module, exports) {

/*
 Copyright (c) 2014, Ismaël Héry

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 */

// A list of commonly used french words that have little meaning and can be excluded
// from analysis.

var words = ['être', 'avoir', 'faire',
  'a',
  'au',
  'aux',
  'avec',
  'ce',
  'ces',
  'dans',
  'de',
  'des',
  'du',
  'elle',
  'en',
  'et',
  'eux',
  'il',
  'je',
  'la',
  'le',
  'leur',
  'lui',
  'ma',
  'mais',
  'me',
  'même',
  'mes',
  'moi',
  'mon',
  'ne',
  'nos',
  'notre',
  'nous',
  'on',
  'ou',
  'où',
  'par',
  'pas',
  'pour',
  'qu',
  'que',
  'qui',
  'sa',
  'se',
  'ses',
  'son',
  'sur',
  'ta',
  'te',
  'tes',
  'toi',
  'ton',
  'tu',
  'un',
  'une',
  'vos',
  'votre',
  'vous',
  'c',
  'd',
  'j',
  'l',
  'à',
  'm',
  'n',
  's',
  't',
  'y',
  'été',
  'étée',
  'étées',
  'étés',
  'étant',
  'suis',
  'es',
  'est',
  'sommes',
  'êtes',
  'sont',
  'serai',
  'seras',
  'sera',
  'serons',
  'serez',
  'seront',
  'serais',
  'serait',
  'serions',
  'seriez',
  'seraient',
  'étais',
  'était',
  'étions',
  'étiez',
  'étaient',
  'fus',
  'fut',
  'fûmes',
  'fûtes',
  'furent',
  'sois',
  'soit',
  'soyons',
  'soyez',
  'soient',
  'fusse',
  'fusses',
  'fût',
  'fussions',
  'fussiez',
  'fussent',
  'ayant',
  'eu',
  'eue',
  'eues',
  'eus',
  'ai',
  'as',
  'avons',
  'avez',
  'ont',
  'aurai',
  'auras',
  'aura',
  'aurons',
  'aurez',
  'auront',
  'aurais',
  'aurait',
  'aurions',
  'auriez',
  'auraient',
  'avais',
  'avait',
  'avions',
  'aviez',
  'avaient',
  'eut',
  'eûmes',
  'eûtes',
  'eurent',
  'aie',
  'aies',
  'ait',
  'ayons',
  'ayez',
  'aient',
  'eusse',
  'eusses',
  'eût',
  'eussions',
  'eussiez',
  'eussent',
  'ceci',
  'cela',
  'cet',
  'cette',
  'ici',
  'ils',
  'les',
  'leurs',
  'quel',
  'quels',
  'quelle',
  'quelles',
  'sans',
  'soi'
]

exports.words = words


/***/ }),
/* 550 */
/***/ (function(module, exports) {

/*
The MIT License (MIT)

Copyright (c) 2016 Gene Diaz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

Originates from: https://github.com/stopwords-iso/stopwords-hi/
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = [
  'अंदर','अत','अदि','अप','अपना','अपनि','अपनी','अपने','अभि','अभी','आदि','आप','इंहिं',
  'इंहें','इंहों','इतयादि','इत्यादि','इन','इनका','इन्हीं','इन्हें','इन्हों','इस','इसका','इसकि',
  'इसकी','इसके','इसमें','इसि','इसी','इसे','उंहिं','उंहें','उंहों','उन','उनका','उनकि','उनकी',
  'उनके','उनको','उन्हीं','उन्हें','उन्हों','उस','उसके','उसि','उसी','उसे','एक','एवं','एस',
  'एसे','ऐसे','ओर','और','कइ','कई','कर','करता','करते','करना','करने','करें','कहते',
  'कहा','का','काफि','काफ़ी','कि','किंहें','किंहों','कितना','किन्हें','किन्हों','किया','किर','किस',
  'किसि','किसी','किसे','की','कुछ','कुल','के','को','कोइ','कोई','कोन','कोनसा','कौन',
  'कौनसा','गया','घर','जब','जहाँ','जहां','जा','जिंहें','जिंहों','जितना','जिधर','जिन','जिन्हें',
  'जिन्हों','जिस','जिसे','जीधर','जेसा','जेसे','जैसा','जैसे','जो','तक','तब','तरह','तिंहें',
  'तिंहों','तिन','तिन्हें','तिन्हों','तिस','तिसे','तो','था','थि','थी','थे','दबारा','दवारा','दिया',
  'दुसरा','दुसरे','दूसरे','दो','द्वारा','न','नहिं','नहीं','ना','निचे','निहायत','नीचे','ने','पर',
  'पहले','पुरा','पूरा','पे','फिर','बनि','बनी','बहि','बही','बहुत','बाद','बाला','बिलकुल',
  'भि','भितर','भी','भीतर','मगर','मानो','मे','में','यदि','यह','यहाँ','यहां','यहि','यही',
  'या','यिह','ये','रखें','रवासा','रहा','रहे','ऱ्वासा','लिए','लिये','लेकिन','व','वगेरह','वरग',
  'वर्ग','वह','वहाँ','वहां','वहिं','वहीं','वाले','वुह','वे','वग़ैरह','संग','सकता','सकते','सबसे',
  'सभि','सभी','साथ','साबुत','साभ','सारा','से','सो','हि','ही','हुअ','हुआ','हुइ','हुई',
  'हुए','हे','हें','है','हैं','हो','होता','होति','होती','होते','होना','होने']

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 551 */
/***/ (function(module, exports) {

/*
Copyright (c) 2011, David Przybilla, Chris Umbel

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = [
  'ad', 'al', 'allo', 'ai', 'agli', 'all', 'agl', 'alla', 'alle', 'con', 'col', 'coi', 'da', 'dal', 'dallo',
  'dai', 'dagli', 'dall', 'dagl', 'dalla', 'dalle', 'di', 'del', 'dello', 'dei', 'degli', 'dell', 'degl',
  'della', 'delle', 'in', 'nel', 'nello', 'nei', 'negli', 'nell', 'negl', 'nella', 'nelle', 'su', 'sul',
  'sullo', 'sui', 'sugli', 'sull', 'sugl', 'sulla', 'sulle', 'per', 'tra', 'contro', 'io', 'tu', 'lui',
  'lei', 'noi', 'voi', 'loro', 'mio', 'mia', 'miei', 'mie', 'tuo', 'tua', 'tuoi', 'tue', 'suo', 'sua', 'suoi',
  'sue', 'nostro', 'nostra', 'nostri', 'nostre', 'vostro', 'vostra', 'vostri', 'vostre', 'mi', 'ti', 'ci',
  'vi', 'lo', 'la', 'li', 'le', 'gli', 'ne', 'il', 'un', 'uno', 'una', 'ma', 'ed', 'se', 'perché', 'anche', 'come',
  'dov', 'dove', 'che', 'chi', 'cui', 'non', 'più', 'quale', 'quanto', 'quanti', 'quanta', 'quante', 'quello',
  'quelli', 'quella', 'quelle', 'questo', 'questi', 'questa', 'queste', 'si', 'tutto', 'tutti', 'a', 'c', 'e',
  'i', 'l', 'o', 'ho', 'hai', 'ha', 'abbiamo', 'avete', 'hanno', 'abbia', 'abbiate', 'abbiano', 'avrò', 'avrai',
  'avrà', 'avremo', 'avrete', 'avranno', 'avrei', 'avresti', 'avrebbe', 'avremmo', 'avreste', 'avrebbero',
  'avevo', 'avevi', 'aveva', 'avevamo', 'avevate', 'avevano', 'ebbi', 'avesti', 'ebbe', 'avemmo', 'aveste',
  'ebbero', 'avessi', 'avesse', 'avessimo', 'avessero', 'avendo', 'avuto', 'avuta', 'avuti', 'avute', 'sono',
  'sei', 'è', 'siamo', 'siete', 'sia', 'siate', 'siano', 'sarò', 'sarai', 'sarà', 'saremo', 'sarete', 'saranno',
  'sarei', 'saresti', 'sarebbe', 'saremmo', 'sareste', 'sarebbero', 'ero', 'eri', 'era', 'eravamo', 'eravate',
  'erano', 'fui', 'fosti', 'fu', 'fummo', 'foste', 'furono', 'fossi', 'fosse', 'fossimo', 'fossero', 'essendo',
  'faccio', 'fai', 'facciamo', 'fanno', 'faccia', 'facciate', 'facciano', 'farò', 'farai', 'farà', 'faremo',
  'farete', 'faranno', 'farei', 'faresti', 'farebbe', 'faremmo', 'fareste', 'farebbero', 'facevo', 'facevi',
  'faceva', 'facevamo', 'facevate', 'facevano', 'feci', 'facesti', 'fece', 'facemmo', 'faceste', 'fecero',
  'facessi', 'facesse', 'facessimo', 'facessero', 'facendo', 'sto', 'stai', 'sta', 'stiamo', 'stanno', 'stia',
  'stiate', 'stiano', 'starò', 'starai', 'starà', 'staremo', 'starete', 'staranno', 'starei', 'staresti',
  'starebbe', 'staremmo', 'stareste', 'starebbero', 'stavo', 'stavi', 'stava', 'stavamo', 'stavate', 'stavano',
  'stetti', 'stesti', 'stette', 'stemmo', 'steste', 'stettero', 'stessi', 'stesse', 'stessimo', 'stessero', 'stando',
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 552 */
/***/ (function(module, exports) {

// Original copyright:
/*
 Licensed to the Apache Software Foundation (ASF) under one or more
 contributor license agreements.  See the NOTICE file distributed with
 this work for additional information regarding copyright ownership.
 The ASF licenses this file to You under the Apache License, Version 2.0
 the "License"); you may not use this file except in compliance with
 the License.  You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/

// This version:
/*
Copyright (c) 2012, Guillaume Marty

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
// Original location:
// http://svn.apache.org/repos/asf/lucene/dev/trunk/lucene/analysis/kuromoji/src/resources/org/apache/lucene/analysis/ja/stopwords.txt
var words = ['の', 'に', 'は', 'を', 'た', 'が', 'で', 'て', 'と', 'し', 'れ', 'さ',
  'ある', 'いる', 'も', 'する', 'から', 'な', 'こと', 'として', 'い', 'や', 'れる',
  'など', 'なっ', 'ない', 'この', 'ため', 'その', 'あっ', 'よう', 'また', 'もの',
  'という', 'あり', 'まで', 'られ', 'なる', 'へ', 'か', 'だ', 'これ', 'によって',
  'により', 'おり', 'より', 'による', 'ず', 'なり', 'られる', 'において', 'ば', 'なかっ',
  'なく', 'しかし', 'について', 'せ', 'だっ', 'その後', 'できる', 'それ', 'う', 'ので',
  'なお', 'のみ', 'でき', 'き', 'つ', 'における', 'および', 'いう', 'さらに', 'でも',
  'ら', 'たり', 'その他', 'に関する', 'たち', 'ます', 'ん', 'なら', 'に対して', '特に',
  'せる', '及び', 'これら', 'とき', 'では', 'にて', 'ほか', 'ながら', 'うち', 'そして',
  'とともに', 'ただし', 'かつて', 'それぞれ', 'または', 'お', 'ほど', 'ものの', 'に対する',
  'ほとんど', 'と共に', 'といった', 'です', 'とも', 'ところ', 'ここ']

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 553 */
/***/ (function(module, exports) {

/*
Copyright (c) 2011, Chris Umbel, Martijn de Boer, Damien van Holten

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
// This dutch wordlist has been parsed from a list created by Damien van Holten
// source: http://www.damienvanholten.com/blog/dutch-stop-words/
var words = [
  'aan', 'af', 'al', 'alles', 'als', 'altijd', 'andere', 'ben', 'bij', 'daar',
  'dan', 'dat', 'de', 'der', 'deze', 'die', 'dit', 'doch', 'doen', 'door', 'dus',
  'een', 'eens', 'en', 'er', 'ge', 'geen', 'geweest', 'haar', 'had', 'heb',
  'hebben', 'heeft', 'hem', 'het', 'hier', 'hij', 'hoe', 'hun', 'iemand', 'iets',
  'ik', 'in', 'is', 'ja', 'je ', 'kan', 'kon', 'kunnen', 'maar', 'me', 'meer',
  'men', 'met', 'mij', 'mijn', 'moet', 'na', 'naar', 'niet', 'niets', 'nog', 'nu',
  'of', 'om', 'omdat', 'ons', 'ook', 'op', 'over', 'reeds', 'te', 'tegen', 'toch',
  'toen', 'tot', 'u', 'uit', 'uw', 'van', 'veel', 'voor', 'want', 'waren', 'was',
  'wat', 'we', 'wel', 'werd', 'wezen', 'wie', 'wij', 'wil', 'worden', 'zal', 'ze',
  'zei', 'zelf', 'zich', 'zij', 'zijn', 'zo', 'zonder', 'zou',
  'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n',
  'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '$', '1',
  '2', '3', '4', '5', '6', '7', '8', '9', '0', '_', '-']

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 554 */
/***/ (function(module, exports) {

/*
Copyright (c) 2014, Kristoffer Brabrand

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = [
  'og', 'i', 'jeg', 'det', 'at', 'en', 'et', 'den', 'til', 'er', 'som',
  'på', 'de', 'med', 'han', 'av', 'ikke', 'der', 'så', 'var', 'meg',
  'seg', 'men', 'ett', 'har', 'om', 'vi', 'min', 'mitt', 'ha', 'hadde',
  'hun', 'nå', 'over', 'da', 'ved', 'fra', 'du', 'ut', 'sin', 'dem',
  'oss', 'opp', 'man', 'kan', 'hans', 'hvor', 'eller', 'hva', 'skal',
  'selv', 'sjøl', 'her', 'alle', 'vil', 'bli', 'ble', 'blitt', 'kunne',
  'inn', 'når', 'kom', 'noen', 'noe', 'ville', 'dere', 'som',
  'deres', 'kun', 'ja', 'etter', 'ned', 'skulle', 'denne', 'for', 'deg',
  'si', 'sine', 'sitt', 'mot', 'å', 'meget', 'hvorfor', 'dette', 'disse',
  'uten', 'hvordan', 'ingen', 'din', 'ditt', 'blir', 'samme', 'hvilken',
  'hvilke', 'sånn', 'inni', 'mellom', 'vår', 'hver', 'hvem', 'vors',
  'hvis', 'både', 'bare', 'enn', 'fordi', 'før', 'mange', 'også', 'slik',
  'vært', 'være', 'begge', 'siden', 'henne', 'hennar', 'hennes',
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 555 */
/***/ (function(module, exports) {

/* The MIT License (MIT)
Copyright (c) 2018 Espen Klem

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
// This list is frequency sorted. That means it can be sliced from the bottom
// and be less agressive in excluding stopwords */

var words = [
  "ਦੇ", "0", "ਵਿੱਚ", "ਦਾ", "ਅਤੇ", "ਦੀ", "ਇੱਕ", "ਨੂੰ", "ਹੈ", "ਤੋਂ", "ਇਸ", "ਇਹ",
  "ਨੇ", "ਤੇ", "ਨਾਲ", "1", "ਲਈ", "ਵੀ", "ਸੀ", "ਵਿਚ", "ਕਿ", "ਜੋ", "ਉਹ", "ਉਸ",
  "ਹਨ", "ਜਾਂਦਾ", "ਕੀਤਾ", "2", "ਗਿਆ", "ਹੀ", "ਕੇ", "ਜਾਂ", "ਦੀਆਂ", "ਜਿਸ", "ਕਰਨ",
  "ਹੋ", "ਕਰ", "ਆਪਣੇ", "ਕੀਤੀ", "ਤੌਰ", "ਬਾਅਦ", "ਨਹੀਂ", "ਭਾਰਤੀ", "ਪਿੰਡ", "3",
  "ਸਿੰਘ", "ਉੱਤੇ", "ਸਾਲ", "।", "ਪੰਜਾਬ", "ਸਭ", "ਭਾਰਤ", "ਉਨ੍ਹਾਂ", "ਹੁੰਦਾ", "ਤੱਕ",
  "ਇਕ", "ਹੋਇਆ", "ਜਨਮ", "ਬਹੁਤ", "ਪਰ", "ਦੁਆਰਾ", "ਰੂਪ", "4", "ਹੋਰ", "ਕੰਮ", "ਆਪਣੀ",
  "ਤਾਂ", "ਸਮੇਂ", "ਪੰਜਾਬੀ", "ਗਈ", "ਦਿੱਤਾ", "ਦੋ", "ਕਿਸੇ", "ਕਈ", "ਜਾ", "ਵਾਲੇ",
  "ਸ਼ੁਰੂ", "5", "ਉਸਨੇ", "ਕਿਹਾ", "ਹੋਣ", "ਲੋਕ", "ਜਾਂਦੀ", "ਵਿੱਚੋਂ", "ਨਾਮ", "ਜਦੋਂ",
  "ਪਹਿਲਾਂ", "ਕਰਦਾ", "ਹੁੰਦੀ", "ਹੋਏ", "ਸਨ", "ਵਜੋਂ", "ਰਾਜ", "ਮੁੱਖ", "ਕਰਦੇ", "ਕੁਝ",
  "ਸਾਰੇ", "ਹੁੰਦੇ", "ਸ਼ਹਿਰ", "ਭਾਸ਼ਾ", "6", "ਹੋਈ", "ਅਨੁਸਾਰ", "ਸਕਦਾ", "ਆਮ", "ਵੱਖ",
  "ਕੋਈ", "ਵਾਰ", "ਗਏ", "ਖੇਤਰ", "ਜੀ", "ਕਾਰਨ", "ਕਰਕੇ", "ਜਿਵੇਂ", "ਜ਼ਿਲ੍ਹੇ",
  "ਲੋਕਾਂ", "ਚ", "ਸਾਹਿਤ", "ਸਦੀ", "ਬਾਰੇ", "ਜਾਂਦੇ", "ਵਾਲਾ", "ਜਾਣ", "ਪਹਿਲੀ",
  "ਪ੍ਰਾਪਤ", "ਰਿਹਾ", "ਵਾਲੀ", "ਨਾਂ", "ਦੌਰਾਨ", "ਤਰ੍ਹਾਂ", "7", "ਯੂਨੀਵਰਸਿਟੀ", "ਨਾ",
  "ਏ", "ਤਿੰਨ", "ਇਨ੍ਹਾਂ", "ਗੁਰੂ", "ਇਸਨੂੰ", "ਇਹਨਾਂ", "ਪਿਤਾ", "ਲਿਆ", "ਸ਼ਾਮਲ",
  "ਸ਼ਬਦ", "ਅੰਗਰੇਜ਼ੀ", "ਉਸਨੂੰ", "ਉਹਨਾਂ", "8", "ਸਥਿਤ", "ਫਿਰ", "ਜੀਵਨ", "ਸਕੂਲ",
  "ਹੁਣ", "ਦਿਨ", "ਕੀਤੇ", "ਆਦਿ", "ਵੱਧ", "ਲੈ", "ਘਰ", "ਵੱਲ", "ਦੇਸ਼", "ਵਲੋਂ", "ਬਣ",
  "ਵੀਂ", "ਫਿਲਮ", "ਉਮਰ", "ਬਲਾਕ", "ਰਹੇ", "10", "ਸਾਹਿਬ", "ਕਰਦੀ", "ਹਰ", "ਪੈਦਾ",
  "ਘੱਟ", "9", "ਲੇਖਕ", "ਹਿੱਸਾ", "ਫ਼ਿਲਮ", "ਮੌਤ", "ਜਿੱਥੇ", "ਵੱਡਾ", "ਵਿਖੇ", "ਆਪਣਾ",
  "ਪਹਿਲਾ", "ਵਰਤੋਂ", "ਆਪ", "ਕਰਨਾ", "ਵਿਆਹ", "ਰਹੀ", "ਰਾਹੀਂ", "ਦਿੱਤੀ", "ਉਸਦੇ",
  "ਪਰਿਵਾਰ", "ਆ", "ਦੂਜੇ", "ਅਮਰੀਕਾ", "ਮੰਨਿਆ", "ਇਸਦੇ", "ਈ", "ਕਾਲਜ", "ਸਰਕਾਰ",
  "ਇੱਥੇ", "ਪਾਕਿਸਤਾਨ", "ਸ਼ਾਮਿਲ", "ਵਿਗਿਆਨ", "ਉਸਦੀ", "ਪੇਸ਼", "ਕਿਉਂਕਿ", "ਪਹਿਲੇ",
  "ਧਰਮ", "ਮਸ਼ਹੂਰ", "ਅੰਦਰ", "ਵਿਚੋਂ", "ਜਿਨ੍ਹਾਂ", "ਜਾਣਿਆ", "ਪਾਣੀ", "ਇਲਾਵਾ", "ਅਰਥ",
  "ਚਾਰ", "ਪ੍ਰਸਿੱਧ", "ਨਾਵਲ", "ਵੱਡੇ", "ਵੱਲੋਂ", "ਕਹਾਣੀ", "ਵਿਸ਼ਵ", "ਮੂਲ", "ਅਮਰੀਕੀ",
  "ਸਥਾਨ", "ਇਤਿਹਾਸ", "ਕੁੱਝ", "ਵਿਕਾਸ", "ਉੱਤਰ", "ਸਿੱਖਿਆ", "ਹਿੰਦੀ", "ਪ੍ਰਮੁੱਖ",
  "ਰਚਨਾ", "ਬਣਾਇਆ", "ਵਿਸ਼ੇਸ਼", "ਡਾ", "ਉੱਪਰ", "ਪੱਛਮੀ", "ਦੇਣ", "ਇਸਦਾ", "ਸਕਦੇ",
  "ਰੱਖਿਆ", "ਕਵੀ", "ਦਿੱਲੀ", "ਵੱਡੀ", "ਭੂਮਿਕਾ", "ਸਮਾਜ", "ਕਾਵਿ", "ਕੀ", "ਕੋਲ", "ਦ",
  "ਗੱਲ", "ਸੰਸਾਰ", "ਭਾਗ", "ਆਈ", "ਦੱਖਣ", "ਅੱਜ", "ਸਿੱਖ", "ਕਹਿੰਦੇ", "ਸੰਗੀਤ",
  "ਕਿਲੋਮੀਟਰ", "ਜਿਹਨਾਂ", "ਸਭਾ", "ਜਿਸਦਾ", "ਜਨਵਰੀ", "ਕਵਿਤਾ", "ਮੈਂਬਰ", "ਲਿਖਿਆ",
  "ਮਾਂ", "ਕਲਾ", "ਪੰਜ", "ਥਾਂ", "ਹੇਠ", "ਜਿਆਦਾ", "ਵਰਤਿਆ", "ਮਾਰਚ", "ਡੀ", "ਅਕਤੂਬਰ",
  "ਤਕ", "ਨਾਟਕ", "ਬੀ", "ਖਾਸ", "ਇਸੇ", "ਆਧੁਨਿਕ", "ਅਗਸਤ", "ਤਿਆਰ", "ਮਾਤਾ", "ਬਣਾਉਣ",
  "ਨਵੰਬਰ", "ਵਿਅਕਤੀ", "ਦੱਖਣੀ", "ਦਸੰਬਰ", "ਆਫ", "ਗੀਤ", "ਗਿਣਤੀ", "ਕਾਲ", "ਖੋਜ",
  "ਸਾਲਾਂ", "ਪੂਰੀ", "ਸਮਾਂ", "ਜ਼ਿਆਦਾ", "ਇਸਦੀ", "ਸਕਦੀ", "ਵਿਚਕਾਰ", "ਰਾਜਧਾਨੀ",
  "ਉਸਦਾ", "ਜੁਲਾਈ", "ਜੂਨ", "ਅਧੀਨ", "ਸਥਾਪਨਾ", "ਸੇਵਾ", "ਭਾਵ", "ਵਰਗ", "ਛੋਟੇ",
  "ਦਿੰਦਾ", "ਸਮਾਜਿਕ", "ਹੁੰਦੀਆਂ", "ਟੀਮ", "ਔਰਤਾਂ", "ਅਕਸਰ", "ਪ੍ਰਕਾਸ਼ਿਤ", "ਉਰਦੂ",
  "ਰੰਗ", "ਪਾਰਟੀ", "ਬਣਾ", "ਪ੍ਰਭਾਵ", "ਸ਼ੁਰੂਆਤ", "ਲਗਭਗ", "ਮਈ", "ਸਿਰਫ", "ਨੇੜੇ",
  "ਜਿਸਨੂੰ", "ਹਾਲਾਂਕਿ", "ਦੂਰ", "ਸਤੰਬਰ", "ਕਿਤਾਬ", "ਕਦੇ", "ਉੱਤਰੀ", "ਪ੍ਰਕਾਰ",
  "ਇਸਨੇ", "ਪ੍ਰਦੇਸ਼", "ਅੱਗੇ", "ਸੰਯੁਕਤ", "ਪੜ੍ਹਾਈ", "ਵਧੇਰੇ", "ਨਾਲ਼", "ਮਨੁੱਖ",
  "ਬਾਕੀ", "ਪ੍ਰਧਾਨ", "ਦੂਜੀ", "ਕੁੱਲ", "ਆਫ਼", "ਅਧਿਐਨ", "ਰਾਸ਼ਟਰੀ", "ਪੁੱਤਰ",
  "ਅੰਤਰਰਾਸ਼ਟਰੀ", "ਧਰਤੀ", "ਕੇਂਦਰ", "ਦੇਸ਼ਾਂ", "ਮੱਧ", "ਜ਼ਿਲ੍ਹਾ", "ਸਾਰੀਆਂ", "ਪੱਧਰ",
  "ਹੋਵੇ", "ਜੇ", "ਭਾਈ", "ਰਹਿਣ", "ਪੁਰਸਕਾਰ", "ਸਭਿਆਚਾਰ", "ਪਤਾ", "ਪਾਸੇ", "ਨਵੇਂ",
  "ਕੰਪਨੀ", "ਬਾਹਰ", "ਵੇਲੇ", "ਸੰਨ", "ਪੂਰਬੀ", "ਵਿਚਾਰ", "ਕਾਰਜ", "ਪੀ", "ਮਹੱਤਵਪੂਰਨ",
  "ਦੁਨੀਆਂ", "ਧਾਰਮਿਕ", "ਮਨੁੱਖੀ", "ਸਮੂਹ", "ਅਜਿਹੇ", "ਲਾਲ", "ਦੂਜਾ", "ਭਰਾ", "ਸ੍ਰੀ",
  "ਅੰਤ", "ਜਾਂਦੀਆਂ", "ਸ਼ਾਹ", "ਰਹਿੰਦੇ", "ਮਹਾਨ", "ਚੀਨ", "ਮੀਟਰ", "ਵਰਗੇ", "ਨਾਲੋਂ",
  "ਹਾਸਲ", "ਕਿਸਮ", "ਅਜਿਹਾ", "ਬਣਿਆ", "ਭਰ", "ਛੱਡ", "ਲੈਣ", "ਹਿੱਸੇ", "ਟੀ", "ਲਿਖੇ",
  "ਮਿਲ", "ਮੌਜੂਦ", "ਦਿੱਤੇ", "ਵਾਸਤੇ", "ਵਾਲੀਆਂ", "ਵਧੀਆ", "ਰੂਸੀ", "ਜਾਰੀ", "ਸਰਕਾਰੀ",
  "ਡਿਗਰੀ", "ਪੱਛਮ", "ਲੜਾਈ", "ਭਾਸ਼ਾਵਾਂ", "ਰਾਜਾ", "ਜਲੰਧਰ", "ਹਿੰਦੂ", "ਔਰਤ", "ਜੰਗ",
  "ਬਾਬਾ", "ਬੱਚਿਆਂ", "ਮੰਤਰੀ", "ਪਟਿਆਲਾ", "ਵਾਂਗ", "ਆਉਣ", "ਭਾਵੇਂ", "ਕੇਵਲ", "ਐਸ",
  "ਪ੍ਰਾਚੀਨ", "ਰਹਿੰਦਾ", "ਬੋਲੀ", "ਅਵਾਰਡ", "ਨਗਰ", "ਖੇਡਾਂ", "ਫਿਲਮਾਂ", "ਬੱਚੇ",
  "ਕੌਰ", "ਤੋ", "ਪ੍ਰਤੀ", "ਕੁਆਂਟਮ", "ਅਬਾਦੀ", "ਪੁਸਤਕ", "ਐਮ", "ਰਾਮ", "ਖੇਤਰਾਂ",
  "ਫਰਵਰੀ", "ਕ੍ਰਿਕਟ", "ਪੈਂਦਾ", "ਇਤਿਹਾਸਕ", "ਲੱਗ", "ਬ੍ਰਿਟਿਸ਼", "ਆਇਆ", "ਮਿਲਦਾ"
]

// Tell the world about the noise words.
exports.words = words


/***/ }),
/* 556 */
/***/ (function(module, exports) {

/*
Copyright (c) 2013, Paweł Łaskarzewski

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
// list based on: http://pl.wikipedia.org/wiki/Wikipedia:Stopwords
var words = [
  'a', 'aby', 'ach', 'acz', 'aczkolwiek', 'aj', 'albo', 'ale', 'ależ', 'ani',
  'aż', 'bardziej', 'bardzo', 'bo', 'bowiem', 'by', 'byli', 'bynajmniej',
  'być', 'był', 'była', 'było', 'były', 'będzie', 'będą', 'cali', 'cała',
  'cały', 'ci', 'cię', 'ciebie', 'co', 'cokolwiek', 'coś', 'czasami',
  'czasem', 'czemu', 'czy', 'czyli', 'daleko', 'dla', 'dlaczego', 'dlatego',
  'do', 'dobrze', 'dokąd', 'dość', 'dużo', 'dwa', 'dwaj', 'dwie', 'dwoje',
  'dziś', 'dzisiaj', 'gdy', 'gdyby', 'gdyż', 'gdzie', 'gdziekolwiek',
  'gdzieś', 'i', 'ich', 'ile', 'im', 'inna', 'inne', 'inny', 'innych', 'iż',
  'ja', 'ją', 'jak', 'jakaś', 'jakby', 'jaki', 'jakichś', 'jakie', 'jakiś',
  'jakiż', 'jakkolwiek', 'jako', 'jakoś', 'je', 'jeden', 'jedna', 'jedno',
  'jednak', 'jednakże', 'jego', 'jej', 'jemu', 'jest', 'jestem', 'jeszcze',
  'jeśli', 'jeżeli', 'już', 'ją', 'każdy', 'kiedy', 'kilka', 'kimś', 'kto',
  'ktokolwiek', 'ktoś', 'która', 'które', 'którego', 'której', 'który',
  'których', 'którym', 'którzy', 'ku', 'lat', 'lecz', 'lub', 'ma', 'mają',
  'mało', 'mam', 'mi', 'mimo', 'między', 'mną', 'mnie', 'mogą', 'moi', 'moim',
  'moja', 'moje', 'może', 'możliwe', 'można', 'mój', 'mu', 'musi', 'my', 'na',
  'nad', 'nam', 'nami', 'nas', 'nasi', 'nasz', 'nasza', 'nasze', 'naszego',
  'naszych', 'natomiast', 'natychmiast', 'nawet', 'nią', 'nic', 'nich', 'nie',
  'niech', 'niego', 'niej', 'niemu', 'nigdy', 'nim', 'nimi', 'niż', 'no', 'o',
  'obok', 'od', 'około', 'on', 'ona', 'one', 'oni', 'ono', 'oraz', 'oto',
  'owszem', 'pan', 'pana', 'pani', 'po', 'pod', 'podczas', 'pomimo', 'ponad',
  'ponieważ', 'powinien', 'powinna', 'powinni', 'powinno', 'poza', 'prawie',
  'przecież', 'przed', 'przede', 'przedtem', 'przez', 'przy', 'roku',
  'również', 'sam', 'sama', 'są', 'się', 'skąd', 'sobie', 'sobą', 'sposób',
  'swoje', 'ta', 'tak', 'taka', 'taki', 'takie', 'także', 'tam', 'te', 'tego',
  'tej', 'temu', 'ten', 'teraz', 'też', 'to', 'tobą', 'tobie', 'toteż',
  'trzeba', 'tu', 'tutaj', 'twoi', 'twoim', 'twoja', 'twoje', 'twym', 'twój',
  'ty', 'tych', 'tylko', 'tym', 'u', 'w', 'wam', 'wami', 'was', 'wasz', 'zaś',
  'wasza', 'wasze', 'we', 'według', 'wiele', 'wielu', 'więc', 'więcej', 'tę',
  'wszyscy', 'wszystkich', 'wszystkie', 'wszystkim', 'wszystko', 'wtedy',
  'wy', 'właśnie', 'z', 'za', 'zapewne', 'zawsze', 'ze', 'zł', 'znowu',
  'znów', 'został', 'żaden', 'żadna', 'żadne', 'żadnych', 'że', 'żeby',
  '$', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 557 */
/***/ (function(module, exports) {

/*
Copyright (c) 2011, Luís Rodrigues

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = [
  'a',
  'à',
  'ao',
  'aos',
  'aquela',
  'aquelas',
  'aquele',
  'aqueles',
  'aquilo',
  'as',
  'às',
  'até',
  'com',
  'como',
  'da',
  'das',
  'de',
  'dela',
  'delas',
  'dele',
  'deles',
  'depois',
  'do',
  'dos',
  'e',
  'ela',
  'elas',
  'ele',
  'eles',
  'em',
  'entre',
  'essa',
  'essas',
  'esse',
  'esses',
  'esta',
  'estas',
  'este',
  'estes',
  'eu',
  'isso',
  'isto',
  'já',
  'lhe',
  'lhes',
  'mais',
  'mas',
  'me',
  'mesmo',
  'meu',
  'meus',
  'minha',
  'minhas',
  'muito',
  'muitos',
  'na',
  'não',
  'nas',
  'nem',
  'no',
  'nos',
  'nós',
  'nossa',
  'nossas',
  'nosso',
  'nossos',
  'num',
  'nuns',
  'numa',
  'numas',
  'o',
  'os',
  'ou',
  'para',
  'pela',
  'pelas',
  'pelo',
  'pelos',
  'por',
  'quais',
  'qual',
  'quando',
  'que',
  'quem',
  'se',
  'sem',
  'seu',
  'seus',
  'só',
  'sua',
  'suas',
  'também',
  'te',
  'teu',
  'teus',
  'tu',
  'tua',
  'tuas',
  'um',
  'uma',
  'umas',
  'você',
  'vocês',
  'vos',
  'vosso',
  'vossos',
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_'
]

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 558 */
/***/ (function(module, exports) {

/*
Copyright (c) 2011, Polyakov Vladimir, Chris Umbel

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = [
  'о', 'после', 'все', 'также', 'и', 'другие', 'все', 'как', 'во', 'быть',
  'потому', 'был', 'до', 'являюсь', 'между', 'все', 'но', 'от', 'иди', 'могу',
  'подойди', 'мог', 'делал', 'делаю', 'каждый', 'для', 'откуда', 'иметь', 'имел',
  'он', 'имеет', 'её', 'здесь', 'его', 'как', 'если', 'в', 'оно', 'за',
  'делать', 'много', 'я', 'может быть', 'более', 'самый', 'должен',
  'мой', 'никогда', 'сейчас', 'из', 'на', 'только', 'или', 'другой', 'другая',
  'другое', 'наше', 'вне', 'конец', 'сказал', 'сказала', 'также', 'видел', 'c',
  'немного', 'все еще', 'так', 'затем', 'тот', 'их', 'там', 'этот', 'они', 'те',
  'через', 'тоже', 'под', 'над', 'очень', 'был', 'путь', 'мы', 'хорошо',
  'что', 'где', 'который', 'пока', 'кто', 'с кем', 'хотел бы', 'ты', 'твои',
  'а', 'б', 'в', 'г', 'д', 'е', 'ё', 'ж', 'з', 'и', 'й', 'к', 'л', 'м', 'н',
  'o', 'п', 'р', 'с', 'т', 'у', 'ф', 'х', 'ц', 'ч', 'ш', 'щ', 'ъ', 'ы', 'ь',
  'э', 'ю', 'я', '$', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 559 */
/***/ (function(module, exports) {

/*
Creative Commons – Attribution / ShareAlike 3.0 license
http://creativecommons.org/licenses/by-sa/3.0/

List based on frequently used words in subtitles in 2012.

Thanks to
opensubtitles.org
https://invokeit.wordpress.com/frequency-word-lists/#comment-9707
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = [
  'jag', 'det', 'är', 'du', 'inte', 'att', 'en', 'och', 'har', 'vi',
  'på', 'i', 'för', 'han', 'vad', 'med', 'mig', 'som', 'här', 'om',
  'dig', 'var', 'den', 'så', 'till', 'kan', 'de', 'ni', 'ska', 'ett',
  'men', 'av', 'vill', 'nu', 'ja', 'nej', 'bara', 'hon', 'hur', 'min',
  'där', 'honom', 'kom', 'din', 'då', 'när', 'ha', 'er', 'ta', 'ut',
  'får', 'man', 'vara', 'oss', 'dem', 'eller', 'varför', 'alla', 'från', 'upp',
  'igen', 'sa', 'hade', 'allt', 'in', 'sig', 'ingen', 'henne', 'vem', 'mitt',
  'nåt', 'blir', 'än', 'bli', 'ju', 'två', 'tar', 'hans', 'ditt', 'mina',
  'åt', 'väl', 'också', 'nån', 'låt', 'detta', 'va', 'dina', 'dom', 'blev',
  'inga', 'sin', 'just', 'många', 'vart', 'vilken', 'ur', 'ens', 'sitt', 'e',
  'jo', 'era', 'deras', 'fem', 'sex', 'denna', 'vilket', 'fyra', 'vårt', 'emot',
  'tio', 'ert', 'sju', 'åtta', 'nånting', 'ned', 'ers', 'nio', 'mej',
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '_']

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 560 */
/***/ (function(module, exports) {

/*
Copyright (c) 2011, David Przybilla, Chris Umbel

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// a list of commonly used words that have little meaning and can be excluded
// from analysis.
var words = [
  '的', '地', '得', '和', '跟',
  '与', '及', '向', '并', '等',
  '更', '已', '含', '做', '我',
  '你', '他', '她', '们', '某',
  '该', '各', '每', '这', '那',
  '哪', '什', '么', '谁', '年',
  '月', '日', '时', '分', '秒',
  '几', '多', '来', '在', '就',
  '又', '很', '呢', '吧', '吗',
  '了', '嘛', '哇', '儿', '哼',
  '啊', '嗯', '是', '着', '都',
  '不', '说', '也', '看', '把',
  '还', '个', '有', '小', '到',
  '一', '为', '中', '于', '对',
  '会', '之', '第', '此', '或',
  '共', '按', '请'
]

// tell the world about the noise words.
exports.words = words


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var engine = __webpack_require__(562)

var storages = __webpack_require__(563)
var plugins = [__webpack_require__(570)]

module.exports = engine.createStore(storages, plugins)


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(51)
var slice = util.slice
var pluck = util.pluck
var each = util.each
var bind = util.bind
var create = util.create
var isList = util.isList
var isFunction = util.isFunction
var isObject = util.isObject

module.exports = {
	createStore: createStore
}

var storeAPI = {
	version: '2.0.12',
	enabled: false,
	
	// get returns the value of the given key. If that value
	// is undefined, it returns optionalDefaultValue instead.
	get: function(key, optionalDefaultValue) {
		var data = this.storage.read(this._namespacePrefix + key)
		return this._deserialize(data, optionalDefaultValue)
	},

	// set will store the given value at key and returns value.
	// Calling set with value === undefined is equivalent to calling remove.
	set: function(key, value) {
		if (value === undefined) {
			return this.remove(key)
		}
		this.storage.write(this._namespacePrefix + key, this._serialize(value))
		return value
	},

	// remove deletes the key and value stored at the given key.
	remove: function(key) {
		this.storage.remove(this._namespacePrefix + key)
	},

	// each will call the given callback once for each key-value pair
	// in this store.
	each: function(callback) {
		var self = this
		this.storage.each(function(val, namespacedKey) {
			callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''))
		})
	},

	// clearAll will remove all the stored key-value pairs in this store.
	clearAll: function() {
		this.storage.clearAll()
	},

	// additional functionality that can't live in plugins
	// ---------------------------------------------------

	// hasNamespace returns true if this store instance has the given namespace.
	hasNamespace: function(namespace) {
		return (this._namespacePrefix == '__storejs_'+namespace+'_')
	},

	// createStore creates a store.js instance with the first
	// functioning storage in the list of storage candidates,
	// and applies the the given mixins to the instance.
	createStore: function() {
		return createStore.apply(this, arguments)
	},
	
	addPlugin: function(plugin) {
		this._addPlugin(plugin)
	},
	
	namespace: function(namespace) {
		return createStore(this.storage, this.plugins, namespace)
	}
}

function _warn() {
	var _console = (typeof console == 'undefined' ? null : console)
	if (!_console) { return }
	var fn = (_console.warn ? _console.warn : _console.log)
	fn.apply(_console, arguments)
}

function createStore(storages, plugins, namespace) {
	if (!namespace) {
		namespace = ''
	}
	if (storages && !isList(storages)) {
		storages = [storages]
	}
	if (plugins && !isList(plugins)) {
		plugins = [plugins]
	}

	var namespacePrefix = (namespace ? '__storejs_'+namespace+'_' : '')
	var namespaceRegexp = (namespace ? new RegExp('^'+namespacePrefix) : null)
	var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
	if (!legalNamespaces.test(namespace)) {
		throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes')
	}
	
	var _privateStoreProps = {
		_namespacePrefix: namespacePrefix,
		_namespaceRegexp: namespaceRegexp,

		_testStorage: function(storage) {
			try {
				var testStr = '__storejs__test__'
				storage.write(testStr, testStr)
				var ok = (storage.read(testStr) === testStr)
				storage.remove(testStr)
				return ok
			} catch(e) {
				return false
			}
		},

		_assignPluginFnProp: function(pluginFnProp, propName) {
			var oldFn = this[propName]
			this[propName] = function pluginFn() {
				var args = slice(arguments, 0)
				var self = this

				// super_fn calls the old function which was overwritten by
				// this mixin.
				function super_fn() {
					if (!oldFn) { return }
					each(arguments, function(arg, i) {
						args[i] = arg
					})
					return oldFn.apply(self, args)
				}

				// Give mixing function access to super_fn by prefixing all mixin function
				// arguments with super_fn.
				var newFnArgs = [super_fn].concat(args)

				return pluginFnProp.apply(self, newFnArgs)
			}
		},

		_serialize: function(obj) {
			return JSON.stringify(obj)
		},

		_deserialize: function(strVal, defaultVal) {
			if (!strVal) { return defaultVal }
			// It is possible that a raw string value has been previously stored
			// in a storage without using store.js, meaning it will be a raw
			// string value instead of a JSON serialized string. By defaulting
			// to the raw string value in case of a JSON parse error, we allow
			// for past stored values to be forwards-compatible with store.js
			var val = ''
			try { val = JSON.parse(strVal) }
			catch(e) { val = strVal }

			return (val !== undefined ? val : defaultVal)
		},
		
		_addStorage: function(storage) {
			if (this.enabled) { return }
			if (this._testStorage(storage)) {
				this.storage = storage
				this.enabled = true
			}
		},

		_addPlugin: function(plugin) {
			var self = this

			// If the plugin is an array, then add all plugins in the array.
			// This allows for a plugin to depend on other plugins.
			if (isList(plugin)) {
				each(plugin, function(plugin) {
					self._addPlugin(plugin)
				})
				return
			}

			// Keep track of all plugins we've seen so far, so that we
			// don't add any of them twice.
			var seenPlugin = pluck(this.plugins, function(seenPlugin) {
				return (plugin === seenPlugin)
			})
			if (seenPlugin) {
				return
			}
			this.plugins.push(plugin)

			// Check that the plugin is properly formed
			if (!isFunction(plugin)) {
				throw new Error('Plugins must be function values that return objects')
			}

			var pluginProperties = plugin.call(this)
			if (!isObject(pluginProperties)) {
				throw new Error('Plugins must return an object of function properties')
			}

			// Add the plugin function properties to this store instance.
			each(pluginProperties, function(pluginFnProp, propName) {
				if (!isFunction(pluginFnProp)) {
					throw new Error('Bad plugin property: '+propName+' from plugin '+plugin.name+'. Plugins should only return functions.')
				}
				self._assignPluginFnProp(pluginFnProp, propName)
			})
		},
		
		// Put deprecated properties in the private API, so as to not expose it to accidential
		// discovery through inspection of the store object.
		
		// Deprecated: addStorage
		addStorage: function(storage) {
			_warn('store.addStorage(storage) is deprecated. Use createStore([storages])')
			this._addStorage(storage)
		}
	}

	var store = create(_privateStoreProps, storeAPI, {
		plugins: []
	})
	store.raw = {}
	each(store, function(prop, propName) {
		if (isFunction(prop)) {
			store.raw[propName] = bind(store, prop)			
		}
	})
	each(storages, function(storage) {
		store._addStorage(storage)
	})
	each(plugins, function(plugin) {
		store._addPlugin(plugin)
	})
	return store
}


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = [
	// Listed in order of usage preference
	__webpack_require__(564),
	__webpack_require__(565),
	__webpack_require__(566),
	__webpack_require__(567),
	__webpack_require__(568),
	__webpack_require__(569)
]


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(51)
var Global = util.Global

module.exports = {
	name: 'localStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

function localStorage() {
	return Global.localStorage
}

function read(key) {
	return localStorage().getItem(key)
}

function write(key, data) {
	return localStorage().setItem(key, data)
}

function each(fn) {
	for (var i = localStorage().length - 1; i >= 0; i--) {
		var key = localStorage().key(i)
		fn(read(key), key)
	}
}

function remove(key) {
	return localStorage().removeItem(key)
}

function clearAll() {
	return localStorage().clear()
}


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

// oldFF-globalStorage provides storage for Firefox
// versions 6 and 7, where no localStorage, etc
// is available.

var util = __webpack_require__(51)
var Global = util.Global

module.exports = {
	name: 'oldFF-globalStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var globalStorage = Global.globalStorage

function read(key) {
	return globalStorage[key]
}

function write(key, data) {
	globalStorage[key] = data
}

function each(fn) {
	for (var i = globalStorage.length - 1; i >= 0; i--) {
		var key = globalStorage.key(i)
		fn(globalStorage[key], key)
	}
}

function remove(key) {
	return globalStorage.removeItem(key)
}

function clearAll() {
	each(function(key, _) {
		delete globalStorage[key]
	})
}


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

// oldIE-userDataStorage provides storage for Internet Explorer
// versions 6 and 7, where no localStorage, sessionStorage, etc
// is available.

var util = __webpack_require__(51)
var Global = util.Global

module.exports = {
	name: 'oldIE-userDataStorage',
	write: write,
	read: read,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var storageName = 'storejs'
var doc = Global.document
var _withStorageEl = _makeIEStorageElFunction()
var disable = (Global.navigator ? Global.navigator.userAgent : '').match(/ (MSIE 8|MSIE 9|MSIE 10)\./) // MSIE 9.x, MSIE 10.x

function write(unfixedKey, data) {
	if (disable) { return }
	var fixedKey = fixKey(unfixedKey)
	_withStorageEl(function(storageEl) {
		storageEl.setAttribute(fixedKey, data)
		storageEl.save(storageName)
	})
}

function read(unfixedKey) {
	if (disable) { return }
	var fixedKey = fixKey(unfixedKey)
	var res = null
	_withStorageEl(function(storageEl) {
		res = storageEl.getAttribute(fixedKey)
	})
	return res
}

function each(callback) {
	_withStorageEl(function(storageEl) {
		var attributes = storageEl.XMLDocument.documentElement.attributes
		for (var i=attributes.length-1; i>=0; i--) {
			var attr = attributes[i]
			callback(storageEl.getAttribute(attr.name), attr.name)
		}
	})
}

function remove(unfixedKey) {
	var fixedKey = fixKey(unfixedKey)
	_withStorageEl(function(storageEl) {
		storageEl.removeAttribute(fixedKey)
		storageEl.save(storageName)
	})
}

function clearAll() {
	_withStorageEl(function(storageEl) {
		var attributes = storageEl.XMLDocument.documentElement.attributes
		storageEl.load(storageName)
		for (var i=attributes.length-1; i>=0; i--) {
			storageEl.removeAttribute(attributes[i].name)
		}
		storageEl.save(storageName)
	})
}

// Helpers
//////////

// In IE7, keys cannot start with a digit or contain certain chars.
// See https://github.com/marcuswestin/store.js/issues/40
// See https://github.com/marcuswestin/store.js/issues/83
var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g")
function fixKey(key) {
	return key.replace(/^\d/, '___$&').replace(forbiddenCharsRegex, '___')
}

function _makeIEStorageElFunction() {
	if (!doc || !doc.documentElement || !doc.documentElement.addBehavior) {
		return null
	}
	var scriptTag = 'script',
		storageOwner,
		storageContainer,
		storageEl

	// Since #userData storage applies only to specific paths, we need to
	// somehow link our data to a specific path.  We choose /favicon.ico
	// as a pretty safe option, since all browsers already make a request to
	// this URL anyway and being a 404 will not hurt us here.  We wrap an
	// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
	// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
	// since the iframe access rules appear to allow direct access and
	// manipulation of the document element, even for a 404 page.  This
	// document can be used instead of the current document (which would
	// have been limited to the current path) to perform #userData storage.
	try {
		/* global ActiveXObject */
		storageContainer = new ActiveXObject('htmlfile')
		storageContainer.open()
		storageContainer.write('<'+scriptTag+'>document.w=window</'+scriptTag+'><iframe src="/favicon.ico"></iframe>')
		storageContainer.close()
		storageOwner = storageContainer.w.frames[0].document
		storageEl = storageOwner.createElement('div')
	} catch(e) {
		// somehow ActiveXObject instantiation failed (perhaps some special
		// security settings or otherwse), fall back to per-path storage
		storageEl = doc.createElement('div')
		storageOwner = doc.body
	}

	return function(storeFunction) {
		var args = [].slice.call(arguments, 0)
		args.unshift(storageEl)
		// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
		// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
		storageOwner.appendChild(storageEl)
		storageEl.addBehavior('#default#userData')
		storageEl.load(storageName)
		storeFunction.apply(this, args)
		storageOwner.removeChild(storageEl)
		return
	}
}


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// cookieStorage is useful Safari private browser mode, where localStorage
// doesn't work but cookies do. This implementation is adopted from
// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage

var util = __webpack_require__(51)
var Global = util.Global
var trim = util.trim

module.exports = {
	name: 'cookieStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var doc = Global.document

function read(key) {
	if (!key || !_has(key)) { return null }
	var regexpStr = "(?:^|.*;\\s*)" +
		escape(key).replace(/[\-\.\+\*]/g, "\\$&") +
		"\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"
	return unescape(doc.cookie.replace(new RegExp(regexpStr), "$1"))
}

function each(callback) {
	var cookies = doc.cookie.split(/; ?/g)
	for (var i = cookies.length - 1; i >= 0; i--) {
		if (!trim(cookies[i])) {
			continue
		}
		var kvp = cookies[i].split('=')
		var key = unescape(kvp[0])
		var val = unescape(kvp[1])
		callback(val, key)
	}
}

function write(key, data) {
	if(!key) { return }
	doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/"
}

function remove(key) {
	if (!key || !_has(key)) {
		return
	}
	doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/"
}

function clearAll() {
	each(function(_, key) {
		remove(key)
	})
}

function _has(key) {
	return (new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(doc.cookie)
}


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(51)
var Global = util.Global

module.exports = {
	name: 'sessionStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll
}

function sessionStorage() {
	return Global.sessionStorage
}

function read(key) {
	return sessionStorage().getItem(key)
}

function write(key, data) {
	return sessionStorage().setItem(key, data)
}

function each(fn) {
	for (var i = sessionStorage().length - 1; i >= 0; i--) {
		var key = sessionStorage().key(i)
		fn(read(key), key)
	}
}

function remove(key) {
	return sessionStorage().removeItem(key)
}

function clearAll() {
	return sessionStorage().clear()
}


/***/ }),
/* 569 */
/***/ (function(module, exports) {

// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.

module.exports = {
	name: 'memoryStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var memoryStorage = {}

function read(key) {
	return memoryStorage[key]
}

function write(key, data) {
	memoryStorage[key] = data
}

function each(callback) {
	for (var key in memoryStorage) {
		if (memoryStorage.hasOwnProperty(key)) {
			callback(memoryStorage[key], key)
		}
	}
}

function remove(key) {
	delete memoryStorage[key]
}

function clearAll(key) {
	memoryStorage = {}
}


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = json2Plugin

function json2Plugin() {
	__webpack_require__(571)
	return {}
}


/***/ }),
/* 571 */
/***/ (function(module, exports) {

/* eslint-disable */

//  json2.js
//  2016-10-28
//  Public Domain.
//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
//  See http://www.JSON.org/js.html
//  This code should be minified before deployment.
//  See http://javascript.crockford.com/jsmin.html

//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
//  NOT CONTROL.

//  This file creates a global JSON object containing two methods: stringify
//  and parse. This file provides the ES5 JSON capability to ES3 systems.
//  If a project might run on IE8 or earlier, then this file should be included.
//  This file does nothing on ES5 systems.

//      JSON.stringify(value, replacer, space)
//          value       any JavaScript value, usually an object or array.
//          replacer    an optional parameter that determines how object
//                      values are stringified for objects. It can be a
//                      function or an array of strings.
//          space       an optional parameter that specifies the indentation
//                      of nested structures. If it is omitted, the text will
//                      be packed without extra whitespace. If it is a number,
//                      it will specify the number of spaces to indent at each
//                      level. If it is a string (such as "\t" or "&nbsp;"),
//                      it contains the characters used to indent at each level.
//          This method produces a JSON text from a JavaScript value.
//          When an object value is found, if the object contains a toJSON
//          method, its toJSON method will be called and the result will be
//          stringified. A toJSON method does not serialize: it returns the
//          value represented by the name/value pair that should be serialized,
//          or undefined if nothing should be serialized. The toJSON method
//          will be passed the key associated with the value, and this will be
//          bound to the value.

//          For example, this would serialize Dates as ISO strings.

//              Date.prototype.toJSON = function (key) {
//                  function f(n) {
//                      // Format integers to have at least two digits.
//                      return (n < 10)
//                          ? "0" + n
//                          : n;
//                  }
//                  return this.getUTCFullYear()   + "-" +
//                       f(this.getUTCMonth() + 1) + "-" +
//                       f(this.getUTCDate())      + "T" +
//                       f(this.getUTCHours())     + ":" +
//                       f(this.getUTCMinutes())   + ":" +
//                       f(this.getUTCSeconds())   + "Z";
//              };

//          You can provide an optional replacer method. It will be passed the
//          key and value of each member, with this bound to the containing
//          object. The value that is returned from your method will be
//          serialized. If your method returns undefined, then the member will
//          be excluded from the serialization.

//          If the replacer parameter is an array of strings, then it will be
//          used to select the members to be serialized. It filters the results
//          such that only members with keys listed in the replacer array are
//          stringified.

//          Values that do not have JSON representations, such as undefined or
//          functions, will not be serialized. Such values in objects will be
//          dropped; in arrays they will be replaced with null. You can use
//          a replacer function to replace those with JSON values.

//          JSON.stringify(undefined) returns undefined.

//          The optional space parameter produces a stringification of the
//          value that is filled with line breaks and indentation to make it
//          easier to read.

//          If the space parameter is a non-empty string, then that string will
//          be used for indentation. If the space parameter is a number, then
//          the indentation will be that many spaces.

//          Example:

//          text = JSON.stringify(["e", {pluribus: "unum"}]);
//          // text is '["e",{"pluribus":"unum"}]'

//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'

//          text = JSON.stringify([new Date()], function (key, value) {
//              return this[key] instanceof Date
//                  ? "Date(" + this[key] + ")"
//                  : value;
//          });
//          // text is '["Date(---current time---)"]'

//      JSON.parse(text, reviver)
//          This method parses a JSON text to produce an object or array.
//          It can throw a SyntaxError exception.

//          The optional reviver parameter is a function that can filter and
//          transform the results. It receives each of the keys and values,
//          and its return value is used instead of the original value.
//          If it returns what it received, then the structure is not modified.
//          If it returns undefined then the member is deleted.

//          Example:

//          // Parse the text. Values that look like ISO date strings will
//          // be converted to Date objects.

//          myData = JSON.parse(text, function (key, value) {
//              var a;
//              if (typeof value === "string") {
//                  a =
//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
//                  if (a) {
//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
//                          +a[5], +a[6]));
//                  }
//              }
//              return value;
//          });

//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
//              var d;
//              if (typeof value === "string" &&
//                      value.slice(0, 5) === "Date(" &&
//                      value.slice(-1) === ")") {
//                  d = new Date(value.slice(5, -1));
//                  if (d) {
//                      return d;
//                  }
//              }
//              return value;
//          });

//  This is a reference implementation. You are free to copy, modify, or
//  redistribute.

/*jslint
    eval, for, this
*/

/*property
    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/


// Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.

if (typeof JSON !== "object") {
    JSON = {};
}

(function () {
    "use strict";

    var rx_one = /^[\],:{}\s]*$/;
    var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
    var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
    var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
    var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;

    function f(n) {
        // Format integers to have at least two digits.
        return n < 10
            ? "0" + n
            : n;
    }

    function this_value() {
        return this.valueOf();
    }

    if (typeof Date.prototype.toJSON !== "function") {

        Date.prototype.toJSON = function () {

            return isFinite(this.valueOf())
                ? this.getUTCFullYear() + "-" +
                        f(this.getUTCMonth() + 1) + "-" +
                        f(this.getUTCDate()) + "T" +
                        f(this.getUTCHours()) + ":" +
                        f(this.getUTCMinutes()) + ":" +
                        f(this.getUTCSeconds()) + "Z"
                : null;
        };

        Boolean.prototype.toJSON = this_value;
        Number.prototype.toJSON = this_value;
        String.prototype.toJSON = this_value;
    }

    var gap;
    var indent;
    var meta;
    var rep;


    function quote(string) {

// If the string contains no control characters, no quote characters, and no
// backslash characters, then we can safely slap some quotes around it.
// Otherwise we must also replace the offending characters with safe escape
// sequences.

        rx_escapable.lastIndex = 0;
        return rx_escapable.test(string)
            ? "\"" + string.replace(rx_escapable, function (a) {
                var c = meta[a];
                return typeof c === "string"
                    ? c
                    : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
            }) + "\""
            : "\"" + string + "\"";
    }


    function str(key, holder) {

// Produce a string from holder[key].

        var i;          // The loop counter.
        var k;          // The member key.
        var v;          // The member value.
        var length;
        var mind = gap;
        var partial;
        var value = holder[key];

// If the value has a toJSON method, call it to obtain a replacement value.

        if (value && typeof value === "object" &&
                typeof value.toJSON === "function") {
            value = value.toJSON(key);
        }

// If we were called with a replacer function, then call the replacer to
// obtain a replacement value.

        if (typeof rep === "function") {
            value = rep.call(holder, key, value);
        }

// What happens next depends on the value's type.

        switch (typeof value) {
        case "string":
            return quote(value);

        case "number":

// JSON numbers must be finite. Encode non-finite numbers as null.

            return isFinite(value)
                ? String(value)
                : "null";

        case "boolean":
        case "null":

// If the value is a boolean or null, convert it to a string. Note:
// typeof null does not produce "null". The case is included here in
// the remote chance that this gets fixed someday.

            return String(value);

// If the type is "object", we might be dealing with an object or an array or
// null.

        case "object":

// Due to a specification blunder in ECMAScript, typeof null is "object",
// so watch out for that case.

            if (!value) {
                return "null";
            }

// Make an array to hold the partial results of stringifying this object value.

            gap += indent;
            partial = [];

// Is the value an array?

            if (Object.prototype.toString.apply(value) === "[object Array]") {

// The value is an array. Stringify every element. Use null as a placeholder
// for non-JSON values.

                length = value.length;
                for (i = 0; i < length; i += 1) {
                    partial[i] = str(i, value) || "null";
                }

// Join all of the elements together, separated with commas, and wrap them in
// brackets.

                v = partial.length === 0
                    ? "[]"
                    : gap
                        ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]"
                        : "[" + partial.join(",") + "]";
                gap = mind;
                return v;
            }

// If the replacer is an array, use it to select the members to be stringified.

            if (rep && typeof rep === "object") {
                length = rep.length;
                for (i = 0; i < length; i += 1) {
                    if (typeof rep[i] === "string") {
                        k = rep[i];
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (
                                gap
                                    ? ": "
                                    : ":"
                            ) + v);
                        }
                    }
                }
            } else {

// Otherwise, iterate through all of the keys in the object.

                for (k in value) {
                    if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (
                                gap
                                    ? ": "
                                    : ":"
                            ) + v);
                        }
                    }
                }
            }

// Join all of the member texts together, separated with commas,
// and wrap them in braces.

            v = partial.length === 0
                ? "{}"
                : gap
                    ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}"
                    : "{" + partial.join(",") + "}";
            gap = mind;
            return v;
        }
    }

// If the JSON object does not yet have a stringify method, give it one.

    if (typeof JSON.stringify !== "function") {
        meta = {    // table of character substitutions
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            "\"": "\\\"",
            "\\": "\\\\"
        };
        JSON.stringify = function (value, replacer, space) {

// The stringify method takes a value and an optional replacer, and an optional
// space parameter, and returns a JSON text. The replacer can be a function
// that can replace values, or an array of strings that will select the keys.
// A default replacer method can be provided. Use of the space parameter can
// produce text that is more easily readable.

            var i;
            gap = "";
            indent = "";

// If the space parameter is a number, make an indent string containing that
// many spaces.

            if (typeof space === "number") {
                for (i = 0; i < space; i += 1) {
                    indent += " ";
                }

// If the space parameter is a string, it will be used as the indent string.

            } else if (typeof space === "string") {
                indent = space;
            }

// If there is a replacer, it must be a function or an array.
// Otherwise, throw an error.

            rep = replacer;
            if (replacer && typeof replacer !== "function" &&
                    (typeof replacer !== "object" ||
                    typeof replacer.length !== "number")) {
                throw new Error("JSON.stringify");
            }

// Make a fake root object containing our value under the key of "".
// Return the result of stringifying the value.

            return str("", {"": value});
        };
    }


// If the JSON object does not yet have a parse method, give it one.

    if (typeof JSON.parse !== "function") {
        JSON.parse = function (text, reviver) {

// The parse method takes a text and an optional reviver function, and returns
// a JavaScript value if the text is a valid JSON text.

            var j;

            function walk(holder, key) {

// The walk method is used to recursively walk the resulting structure so
// that modifications can be made.

                var k;
                var v;
                var value = holder[key];
                if (value && typeof value === "object") {
                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = walk(value, k);
                            if (v !== undefined) {
                                value[k] = v;
                            } else {
                                delete value[k];
                            }
                        }
                    }
                }
                return reviver.call(holder, key, value);
            }


// Parsing happens in four stages. In the first stage, we replace certain
// Unicode characters with escape sequences. JavaScript handles many characters
// incorrectly, either silently deleting them, or treating them as line endings.

            text = String(text);
            rx_dangerous.lastIndex = 0;
            if (rx_dangerous.test(text)) {
                text = text.replace(rx_dangerous, function (a) {
                    return "\\u" +
                            ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
                });
            }

// In the second stage, we run the text against regular expressions that look
// for non-JSON patterns. We are especially concerned with "()" and "new"
// because they can cause invocation, and "=" because it can cause mutation.
// But just to be safe, we want to reject all unexpected forms.

// We split the second stage into 4 regexp operations in order to work around
// crippling inefficiencies in IE's and Safari's regexp engines. First we
// replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
// replace all simple value tokens with "]" characters. Third, we delete all
// open brackets that follow a colon or comma or that begin the text. Finally,
// we look to see that the remaining characters are only whitespace or "]" or
// "," or ":" or "{" or "}". If that is so, then the text is safe for eval.

            if (
                rx_one.test(
                    text
                        .replace(rx_two, "@")
                        .replace(rx_three, "]")
                        .replace(rx_four, "")
                )
            ) {

// In the third stage we use the eval function to compile the text into a
// JavaScript structure. The "{" operator is subject to a syntactic ambiguity
// in JavaScript: it can begin a block or an object literal. We wrap the text
// in parens to eliminate the ambiguity.

                j = eval("(" + text + ")");

// In the optional fourth stage, we recursively walk the new structure, passing
// each name/value pair to a reviver function for possible transformation.

                return (typeof reviver === "function")
                    ? walk({"": j}, "")
                    : j;
            }

// If the text is not JSON parseable, then a SyntaxError is thrown.

            throw new SyntaxError("JSON.parse");
        };
    }
}());

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_natural_orderby__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_state_models_BookmarkModel__ = __webpack_require__(573);
var BookmarkStore=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["c" /* types */].model({collection:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["c" /* types */].array(__WEBPACK_IMPORTED_MODULE_3_app_state_models_BookmarkModel__["a" /* default */])}).views(function(self){return{get groupedEntries(){var entries=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.groupBy(self.collection.slice(),function(entry){return JSON.stringify(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.chain(entry.path.slice()).drop(1).reject(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isInteger).filter(function(el){return el.match('chapter|section|introduction');}).map(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.capitalize).value().join(', '));});entries=Object(__WEBPACK_IMPORTED_MODULE_2_natural_orderby__["a" /* orderBy */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toPairs(entries),[function(entry){return JSON.stringify(entry[0]);}],['asc']);entries=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(entries,function(entry){var path=entry[0];var selections=entry[1];selections=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(selections,function(_ref){var path=_ref.path,content=_ref.content,note=_ref.note;return{path:path.slice(),content:content,note:note};});return[path.slice(1,-1),selections];});return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.fromPairs(entries);}};}).actions(function(self){return{insert:function insert(bookmark){self.collection.push(bookmark);},delete:function _delete(path){path=path.slice();var bookmark=self.collection.find(function(entry){return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(entry.path.slice(),path);});if(bookmark){self.collection.remove(bookmark);}},clearBookmarks:function clearBookmarks(){self.collection=[];}};});/* harmony default export */ __webpack_exports__["a"] = (BookmarkStore);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__ = __webpack_require__(89);
var Bookmark=__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["c" /* types */].model({path:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["c" /* types */].array(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["c" /* types */].union(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["c" /* types */].string,__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["c" /* types */].integer)),content:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["c" /* types */].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["c" /* types */].string),note:__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["c" /* types */].maybe(__WEBPACK_IMPORTED_MODULE_0_mobx_state_tree__["c" /* types */].string)}).views(function(self){return{};}).actions(function(self){return{};});/* harmony default export */ __webpack_exports__["a"] = (Bookmark);

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*jshint node:true, laxcomma:true */


var sanitizeHtml = __webpack_require__(575);

var stringHelper = __webpack_require__(576);
var Match  = __webpack_require__(577);

var newline_placeholder = " @~@ ";
var newline_placeholder_t = newline_placeholder.trim();


var whiteSpaceCheck = new RegExp("\\S", "");
var addNewLineBoundaries = new RegExp("\\n+|[-#=_+*]{4,}", "g");
var splitIntoWords = new RegExp("\\S+|\\n", "g");


// Split the entry into sentences.
exports.sentences = function(text, user_options) {
    if (!text || typeof text !== "string" || !text.length) {
        return [];
    }

    if (!whiteSpaceCheck.test(text)) {
      // whitespace-only string has no sentences
      return [];
    }

    var options = {
        "newline_boundaries"  : false,
        "html_boundaries"     : false,
        "html_boundaries_tags": ["p","div","ul","ol"],
        "sanitize"            : false,
        "allowed_tags"        : false,
        "preserve_whitespace" : false,
        "abbreviations"       : null
    };

    if (typeof user_options === "boolean") {
        // Deprecated quick option
        options.newline_boundaries = true;
    }
    else {
        // Extend options
        for (var k in user_options) {
            options[k] = user_options[k];
        }
    }

    Match.setAbbreviations(options.abbreviations);

    if (options.newline_boundaries) {
        text = text.replace(addNewLineBoundaries, newline_placeholder);
    }

    if (options.html_boundaries) {
        var html_boundaries_regexp = "(<br\\s*\\/?>|<\\/(" + options.html_boundaries_tags.join("|") + ")>)";
        var re = new RegExp(html_boundaries_regexp, "g");
        text = text.replace(re, "$1" + newline_placeholder);
    }

    if (options.sanitize || options.allowed_tags) {
        if (! options.allowed_tags) {
            options.allowed_tags = [""];
        }

        text = sanitizeHtml(text, { "allowedTags" : options.allowed_tags });
    }


    // Split the text into words
    var words;
    var tokens;

    // Split the text into words
    if (options.preserve_whitespace) {
        // <br> tags are the odd man out, as whitespace is allowed inside the tag
        tokens = text.split(/(<br\s*\/?>|\S+|\n+)/);

        // every other token is a word
        words = tokens.filter(function (token, ii) {
          return ii % 2;
        });
    }
    else {
        // - see http://blog.tompawlak.org/split-string-into-tokens-javascript
        words = text.trim().match(splitIntoWords);
    }


    var wordCount = 0;
    var index = 0;
    var temp  = [];
    var sentences = [];
    var current   = [];

    // If given text is only whitespace (or nothing of \S+)
    if (!words || !words.length) {
        return [];
    }

    for (var i=0, L=words.length; i < L; i++) {
        wordCount++;

        // Add the word to current sentence
        current.push(words[i]);

        // Sub-sentences, reset counter
        if (~words[i].indexOf(',')) {
            wordCount = 0;
        }

        if (Match.isBoundaryChar(words[i]) || stringHelper.endsWithChar(words[i], "?!") || words[i] === newline_placeholder_t) {
            if ((options.newline_boundaries || options.html_boundaries) && words[i] === newline_placeholder_t) {
                current.pop();
            }

            sentences.push(current);

            wordCount = 0;
            current   = [];

            continue;
        }


        if (stringHelper.endsWithChar(words[i], "\"") || stringHelper.endsWithChar(words[i], "”")) {
            words[i] = words[i].slice(0, -1);
        }

        // A dot might indicate the end sentences
        // Exception: The next sentence starts with a word (non abbreviation)
        //            that has a capital letter.
        if (stringHelper.endsWithChar(words[i], '.')) {
            // Check if there is a next word
            // This probably needs to be improved with machine learning
            if (i+1 < L) {
                // Single character abbr.
                if (words[i].length === 2 && isNaN(words[i].charAt(0))) {
                    continue;
                }

                // Common abbr. that often do not end sentences
                if (Match.isCommonAbbreviation(words[i])) {
                    continue;
                }

                // Next word starts with capital word, but current sentence is
                // quite short
                if (Match.isSentenceStarter(words[i+1])) {
                    if (Match.isTimeAbbreviation(words[i], words[i+1])) {
                        continue;
                    }

                    // Dealing with names at the start of sentences
                    if (Match.isNameAbbreviation(wordCount, words.slice(i, 6))) {
                        continue;
                    }

                    if (Match.isNumber(words[i+1])) {
                        if (Match.isCustomAbbreviation(words[i])) {
                            continue;
                        }
                    }
                }
                else {
                    // Skip ellipsis
                    if (stringHelper.endsWith(words[i], "..")) {
                        continue;
                    }

                    //// Skip abbreviations
                    // Short words + dot or a dot after each letter
                    if (Match.isDottedAbbreviation(words[i])) {
                        continue;
                    }

                    if (Match.isNameAbbreviation(wordCount, words.slice(i, 5))) {
                        continue;
                    }
                }
            }

            sentences.push(current);
            current   = [];
            wordCount = 0;

            continue;
        }

        // Check if the word has a dot in it
        if ((index = words[i].indexOf(".")) > -1) {
            if (Match.isNumber(words[i], index)) {
                continue;
            }

            // Custom dotted abbreviations (like K.L.M or I.C.T)
            if (Match.isDottedAbbreviation(words[i])) {
                continue;
            }

            // Skip urls / emails and the like
            if (Match.isURL(words[i]) || Match.isPhoneNr(words[i])) {
                continue;
            }
        }

        if (temp = Match.isConcatenated(words[i])) {
            current.pop();
            current.push(temp[0]);
            sentences.push(current);

            current = [];
            wordCount = 0;
            current.push(temp[1]);
        }
    }

    if (current.length) {
        sentences.push(current);
    }


    // Clear "empty" sentences
    sentences = sentences.filter(function(s) {
        return s.length > 0;
    });

    var result = sentences.slice(1).reduce(function (out, sentence) {
      var lastSentence = out[out.length - 1];
      // Single words, could be "enumeration lists"
      if (lastSentence.length === 1 && /^.{1,2}[.]$/.test(lastSentence[0])) {
          // Check if there is a next sentence
          // It should not be another list item
          if (!/[.]/.test(sentence[0])) {
              out.pop()
              out.push(lastSentence.concat(sentence));
              return out;
          }
      }
      out.push(sentence);
      return out;
    }, [ sentences[0] ]);

    // join tokens back together
    return result.map(function (sentence, ii) {
      if (options.preserve_whitespace && !options.newline_boundaries && !options.html_boundaries) {
        // tokens looks like so: [leading-space token, non-space token, space
        // token, non-space token, space token... ]. In other words, the first
        // item is the leading space (or the empty string), and the rest of
        // the tokens are [non-space, space] token pairs.
        var tokenCount = sentence.length * 2;
        if (ii === 0) {
          tokenCount += 1;
        }
        return tokens.splice(0, tokenCount).join('');
      }
      return sentence.join(" ");
    });
};


/***/ }),
/* 575 */
/***/ (function(module, exports) {


module.exports = function sanitizeHtml(text, opts) {
  // Strip HTML from Text using browser HTML parser
  if ((typeof text == 'string' || text instanceof String) && typeof document !== "undefined") {
    var $div = document.createElement("DIV");
    $div.innerHTML = text;
    text = ($div.textContent || '').trim();
  }
  //DOM Object
  else if (typeof text === 'object' && text.textContent) {
    text = (text.textContent || '').trim();
  }

  return text;
};


/***/ }),
/* 576 */
/***/ (function(module, exports) {


exports.endsWithChar = function ends_with_char(word, c) {
    if (c.length > 1) {
        return c.indexOf(word.slice(-1)) > -1;
    }

    return word.slice(-1) === c;
};

exports.endsWith = function ends_with(word, end) {
    return word.slice(word.length - end.length) === end;
};

/***/ }),
/* 577 */
/***/ (function(module, exports) {

var abbreviations;
var englishAbbreviations = [
    "al",
    "adj",
    "assn",
    "Ave",
    "BSc", "MSc",
    "Cell",
    "Ch",
    "Co",
    "cc",
    "Corp",
    "Dem",
    "Dept",
    "ed",
    "eg",
    "Eq",
    "Eqs",
    "est",
    "est",
    "etc",
    "Ex",
    "ext", // + number?
    "Fig",
    "fig",
    "Figs",
    "figs",
    "i.e",
    "ie",
    "Inc",
    "inc",
    "Jan","Feb","Mar","Apr","Jun","Jul","Aug","Sep","Sept","Oct","Nov","Dec",
    "jr",
    "mi",
    "Miss", "Mrs", "Mr", "Ms",
    "Mol",
    "mt",
    "mts",
    "no",
    "Nos",
    "PhD", "MD", "BA", "MA", "MM",
    "pl",
    "pop",
    "pp",
    "Prof", "Dr",
    "pt",
    "Ref",
    "Refs",
    "Rep",
    "repr",
    "rev",
    "Sec",
    "Secs",
    "Sgt", "Col", "Gen", "Rep", "Sen",'Gov', "Lt", "Maj", "Capt","St",
    "Sr", "sr", "Jr", "jr", "Rev",
    "Sun","Mon","Tu","Tue","Tues","Wed","Th","Thu","Thur","Thurs","Fri","Sat",
    "trans",
    "Univ",
    "Viz",
    "Vol",
    "vs",
    "v",
];

exports.setAbbreviations = function(abbr) {
    if(abbr){
        abbreviations = abbr;
    } else {
        abbreviations = englishAbbreviations;
    }
}

var isCapitalized = exports.isCapitalized = function(str) {
    return /^[A-Z][a-z].*/.test(str) || isNumber(str);
}

// Start with opening quotes or capitalized letter
exports.isSentenceStarter = function(str) {
    return isCapitalized(str) || /``|"|'/.test(str.substring(0,2));
}

exports.isCommonAbbreviation = function(str) {
    return ~abbreviations.indexOf(str.replace(/\W+/g, ''));
}

// This is going towards too much rule based
exports.isTimeAbbreviation = function(word, next) {
    if (word === "a.m." || word === "p.m.") {
        var tmp = next.replace(/\W+/g, '').slice(-3).toLowerCase();

        if (tmp === "day") {
            return true;
        }
    }

    return false;
}

exports.isDottedAbbreviation = function(word) {
    var matches = word.replace(/[\(\)\[\]\{\}]/g, '').match(/(.\.)*/);
    return matches && matches[0].length > 0;
}

// TODO look for next words, if multiple are capitalized,
// then it's probably not a sentence ending
exports.isCustomAbbreviation = function(str) {
    if (str.length <= 3) {
        return true;
    }

    return isCapitalized(str);
}

// Uses current word count in sentence and next few words to check if it is
// more likely an abbreviation + name or new sentence.
exports.isNameAbbreviation = function(wordCount, words) {
    if (words.length > 0) {
        if (wordCount < 5 && words[0].length < 6 && isCapitalized(words[0])) {
            return true;
        }

        var capitalized = words.filter(function(str) {
            return /[A-Z]/.test(str.charAt(0));
        });

        return capitalized.length >= 3;
    }

    return false;
}

var isNumber = exports.isNumber = function(str, dotPos) {
    if (dotPos) {
        str = str.slice(dotPos-1, dotPos+2);
    }

    return !isNaN(str);
};

// Phone number matching
// http://stackoverflow.com/a/123666/951517
exports.isPhoneNr = function(str) {
    return str.match(/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/);
};

// Match urls / emails
// http://stackoverflow.com/a/3809435/951517
exports.isURL = function(str) {
    return str.match(/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/);
};

// Starting a new sentence if beginning with capital letter
// Exception: The word is enclosed in brackets
exports.isConcatenated = function(word) {
    var i = 0;

    if ((i = word.indexOf(".")) > -1 ||
        (i = word.indexOf("!")) > -1 ||
        (i = word.indexOf("?")) > -1)
    {
        var c = word.charAt(i + 1);

        // Check if the next word starts with a letter
        if (c.match(/[a-zA-Z].*/)) {
            return [word.slice(0, i), word.slice(i+1)];
        }
    }

    return false;
};

exports.isBoundaryChar = function(word) {
    return word === "." ||
           word === "!" ||
           word === "?";
};


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(579);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(647);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(581), __esModule: true };

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(582);
module.exports = __webpack_require__(39).Object.assign;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(52);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(584) });


/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(91);
var gOPS = __webpack_require__(136);
var pIE = __webpack_require__(94);
var toObject = __webpack_require__(202);
var IObject = __webpack_require__(200);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(69)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(55);
var toLength = __webpack_require__(586);
var toAbsoluteIndex = __webpack_require__(587);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(132);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(132);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(589), __esModule: true };

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(590);
__webpack_require__(596);
module.exports = __webpack_require__(141).f('iterator');


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(591)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(204)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(132);
var defined = __webpack_require__(131);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(139);
var descriptor = __webpack_require__(90);
var setToStringTag = __webpack_require__(140);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(53)(IteratorPrototype, __webpack_require__(56)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(44);
var anObject = __webpack_require__(68);
var getKeys = __webpack_require__(91);

module.exports = __webpack_require__(45) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(38).document;
module.exports = document && document.documentElement;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(46);
var toObject = __webpack_require__(202);
var IE_PROTO = __webpack_require__(133)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(597);
var global = __webpack_require__(38);
var hide = __webpack_require__(53);
var Iterators = __webpack_require__(138);
var TO_STRING_TAG = __webpack_require__(56)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(598);
var step = __webpack_require__(599);
var Iterators = __webpack_require__(138);
var toIObject = __webpack_require__(55);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(204)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(601), __esModule: true };

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(602);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);
module.exports = __webpack_require__(39).Symbol;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(38);
var has = __webpack_require__(46);
var DESCRIPTORS = __webpack_require__(45);
var $export = __webpack_require__(52);
var redefine = __webpack_require__(205);
var META = __webpack_require__(603).KEY;
var $fails = __webpack_require__(69);
var shared = __webpack_require__(134);
var setToStringTag = __webpack_require__(140);
var uid = __webpack_require__(93);
var wks = __webpack_require__(56);
var wksExt = __webpack_require__(141);
var wksDefine = __webpack_require__(142);
var enumKeys = __webpack_require__(604);
var isArray = __webpack_require__(605);
var anObject = __webpack_require__(68);
var isObject = __webpack_require__(54);
var toIObject = __webpack_require__(55);
var toPrimitive = __webpack_require__(130);
var createDesc = __webpack_require__(90);
var _create = __webpack_require__(139);
var gOPNExt = __webpack_require__(606);
var $GOPD = __webpack_require__(207);
var $DP = __webpack_require__(44);
var $keys = __webpack_require__(91);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(206).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(94).f = $propertyIsEnumerable;
  __webpack_require__(136).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(92)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(53)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(93)('meta');
var isObject = __webpack_require__(54);
var has = __webpack_require__(46);
var setDesc = __webpack_require__(44).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(69)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(91);
var gOPS = __webpack_require__(136);
var pIE = __webpack_require__(94);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(201);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(55);
var gOPN = __webpack_require__(206).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 607 */
/***/ (function(module, exports) {



/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(142)('asyncIterator');


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(142)('observable');


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(611), __esModule: true };

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(612);
module.exports = __webpack_require__(39).Object.setPrototypeOf;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(52);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(613).set });


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(54);
var anObject = __webpack_require__(68);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(196)(Function.call, __webpack_require__(207).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(615), __esModule: true };

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(616);
var $Object = __webpack_require__(39).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(52);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(139) });


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_ContainerRender__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Portal__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Popup__ = __webpack_require__(626);
















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.prevPopupVisible = popupVisible;

    _this.state = {
      popupVisible: popupVisible
    };
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    ALL_HANDLERS.forEach(function (h) {
      _this2['fire' + h] = function (e) {
        _this2.fireEvents(h, e);
      };
    });
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var popupVisible = _ref.popupVisible;

    if (popupVisible !== undefined) {
      this.setState({
        popupVisible: popupVisible
      });
    }
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    this.prevPopupVisible = prevState.popupVisible;

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;


    this.clearDelayTimer();

    if (this.state.popupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this3 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this3.setPopupVisible(visible, point);
        _this3.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this4 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this4.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Portal__["a" /* default */],
        {
          key: 'portal',
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this5.props.mouseEnterDelay;

    _this5.fireEvents('onMouseEnter', e);
    _this5.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this5.fireEvents('onMouseMove', e);
    _this5.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this5.fireEvents('onMouseLeave', e);
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this5.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this5._component && _this5._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(_this5._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this5.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this5.clearDelayTimer();
    if (_this5.isFocusToShow()) {
      _this5.focusTime = Date.now();
      _this5.delaySetPopupVisible(true, _this5.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this5.fireEvents('onMouseDown', e);
    _this5.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this5.fireEvents('onTouchStart', e);
    _this5.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this5.fireEvents('onBlur', e);
    _this5.clearDelayTimer();
    if (_this5.isBlurToHide()) {
      _this5.delaySetPopupVisible(false, _this5.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this5.fireEvents('onContextMenu', e);
    _this5.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this5.isContextMenuToShow()) {
      _this5.close();
    }
  };

  this.onClick = function (event) {
    _this5.fireEvents('onClick', event);
    // focus will trigger click
    if (_this5.focusTime) {
      var preTime = void 0;
      if (_this5.preClickTime && _this5.preTouchTime) {
        preTime = Math.min(_this5.preClickTime, _this5.preTouchTime);
      } else if (_this5.preClickTime) {
        preTime = _this5.preClickTime;
      } else if (_this5.preTouchTime) {
        preTime = _this5.preTouchTime;
      }
      if (Math.abs(preTime - _this5.focusTime) < 20) {
        return;
      }
      _this5.focusTime = 0;
    }
    _this5.preClickTime = 0;
    _this5.preTouchTime = 0;
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this5.state.popupVisible;
    if (_this5.isClickToHide() && !nextVisible || nextVisible && _this5.isClickToShow()) {
      _this5.setPopupVisible(!_this5.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this5.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this5.hasPopupMouseDown = true;

    clearTimeout(_this5.mouseDownTimeout);
    _this5.mouseDownTimeout = setTimeout(function () {
      _this5.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this5.props.mask && !_this5.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
    if (!Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this5.hasPopupMouseDown) {
      _this5.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this5.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this5.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this5.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this5.getPopupAlign();

    var mouseProps = {};
    if (_this5.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this5.onPopupMouseEnter;
    }
    if (_this5.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this5.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this5.onPopupMouseDown;
    mouseProps.onTouchStart = _this5.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this5.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this5.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this5.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this5.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this5.props.alignPoint;

    if (!alignPoint || !point) return;

    _this5.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this5.prevPopupVisible !== _this5.state.popupVisible) {
      _this5.props.afterPopupVisibleChange(_this5.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this5._component = node;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(620);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(621);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(75);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var ContainerRender = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ContainerRender, _React$Component);

  function ContainerRender() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ContainerRender);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ContainerRender.__proto__ || Object.getPrototypeOf(ContainerRender)).call.apply(_ref, [this].concat(args))), _this), _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(_this.container);
        _this.container.parentNode.removeChild(_this.container);
        _this.container = null;
      }
    }, _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ContainerRender, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};
/* harmony default export */ __webpack_exports__["a"] = (ContainerRender);

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(624);
var $Object = __webpack_require__(39).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(52);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(45), 'Object', { defineProperty: __webpack_require__(44).f });


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var Portal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Portal, _React$Component);

  function Portal() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Portal);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: 'createContainer',
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: 'removeContainer',
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(this.props.children, this._container);
      }
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(210);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(628);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_align__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(637);











function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_6_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_6_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Align.prototype.componentDidMount = function componentDidMount() {
    var props = this.props;
    // if parent ref not attached .... use document.getElementById
    this.forceAlign();
    if (!props.disabled && props.monitorWindowResize) {
      this.startMonitorWindowResize();
    }
  };

  Align.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var reAlign = false;
    var props = this.props;

    if (!props.disabled) {
      var source = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var sourceRect = source ? source.getBoundingClientRect() : null;

      if (prevProps.disabled) {
        reAlign = true;
      } else {
        var lastElement = getElement(prevProps.target);
        var currentElement = getElement(props.target);
        var lastPoint = getPoint(prevProps.target);
        var currentPoint = getPoint(props.target);

        if (Object(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* isWindow */])(currentElement)) {
          // Skip if is window
          reAlign = false;
        } else if (lastElement !== currentElement || // Element change
        lastElement && !currentElement && currentPoint || // Change from element to point
        lastPoint && currentPoint && currentElement || // Change from point to element
        currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_8__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
          reAlign = true;
        }

        // If source element size changed
        var preRect = this.sourceRect || {};
        if (!reAlign && source && (preRect.width !== sourceRect.width || preRect.height !== sourceRect.height)) {
          reAlign = true;
        }
      }

      this.sourceRect = sourceRect;
    }

    if (reAlign) {
      this.forceAlign();
    }

    if (props.monitorWindowResize && !props.disabled) {
      this.startMonitorWindowResize();
    } else {
      this.stopMonitorWindowResize();
    }
  };

  Align.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stopMonitorWindowResize();
  };

  Align.prototype.startMonitorWindowResize = function startMonitorWindowResize() {
    if (!this.resizeHandler) {
      this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_8__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
      this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
    }
  };

  Align.prototype.stopMonitorWindowResize = function stopMonitorWindowResize() {
    if (this.resizeHandler) {
      this.bufferMonitor.clear();
      this.resizeHandler.remove();
      this.resizeHandler = null;
    }
  };

  Align.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        childrenProps = _props.childrenProps,
        children = _props.children;

    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children);
    if (childrenProps) {
      var newProps = {};
      var propList = Object.keys(childrenProps);
      propList.forEach(function (prop) {
        newProps[prop] = _this2.props[childrenProps[prop]];
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, newProps);
    }
    return child;
  };

  return Align;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align_alignElement__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align_alignPoint__ = __webpack_require__(636);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__align_alignElement__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__align_alignPoint__["a"]; });





/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__align_alignElement__["a" /* default */]);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRegion__ = __webpack_require__(214);





function isOutOfVisibleRect(target) {
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */])(target);
  var targetRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(target);

  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(target);

  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);

  return Object(__WEBPACK_IMPORTED_MODULE_0__align__["a" /* default */])(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */];

alignElement.__getVisibleRectForElement = __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (alignElement);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransformName;
/* harmony export (immutable) */ __webpack_exports__["e"] = setTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransformXY;
/* harmony export (immutable) */ __webpack_exports__["d"] = setTransformXY;
var vendorPrefix = void 0;

var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
}

function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}

function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
  }
  return {
    x: 0,
    y: 0
  };
}

var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;

function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr = void 0;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, 'matrix(' + arr.join(',') + ')');
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
    }
  } else {
    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
  }
}

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAncestorFixed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(47);


function isAncestorFixed(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(47);


function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(pos, size);
}

/* harmony default export */ __webpack_exports__["a"] = (adjustForViewport);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAlignOffset__ = __webpack_require__(635);


function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(refNodeRegion, points[1]);
  var p2 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];

  return {
    left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
    top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getElFuturePos);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;

  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getAlignOffset);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align__ = __webpack_require__(211);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX = void 0;
  var pageY = void 0;

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(el);
  var win = doc.defaultView || doc.parentWindow;

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };

  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];

  return Object(__WEBPACK_IMPORTED_MODULE_1__align__["a" /* default */])(el, tgtRegion, _extends({}, align, { points: points }), pointInView);
}

/* harmony default export */ __webpack_exports__["a"] = (alignPoint);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["c"] = isWindow;
function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AnimateChild__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_animate__ = __webpack_require__(216);












var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Animate);

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(209);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(216);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(215);
} catch (err) {
  var index = __webpack_require__(215);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(217);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Accordion": 97,
	"./Accordion.js": 97,
	"./Acknowledgements": 246,
	"./Acknowledgements.js": 246,
	"./Appendix": 252,
	"./Appendix.js": 252,
	"./Bookmarks": 150,
	"./Bookmarks.js": 150,
	"./Callout": 74,
	"./Callout.js": 74,
	"./Carousel": 98,
	"./Carousel.js": 98,
	"./Chapter": 253,
	"./Chapter.js": 253,
	"./Composite": 23,
	"./Composite.js": 23,
	"./Cover": 254,
	"./Cover.js": 254,
	"./Figure": 99,
	"./Figure.js": 99,
	"./Foreword": 255,
	"./Foreword.js": 255,
	"./Glossary": 256,
	"./Glossary.js": 256,
	"./IFrame": 100,
	"./IFrame.js": 100,
	"./Index": 257,
	"./Index.js": 257,
	"./Information": 258,
	"./Information.js": 258,
	"./Instructions": 259,
	"./Instructions.js": 259,
	"./Introduction": 260,
	"./Introduction.js": 260,
	"./List": 101,
	"./List.js": 101,
	"./ListItem": 147,
	"./ListItem.js": 147,
	"./Media": 102,
	"./Media.js": 102,
	"./MediaClip": 71,
	"./MediaClip.js": 71,
	"./Modal": 103,
	"./Modal.js": 103,
	"./Paragraph": 128,
	"./Paragraph.js": 128,
	"./Picture": 57,
	"./Picture.js": 57,
	"./Preface": 261,
	"./Preface.js": 261,
	"./Prologue": 262,
	"./Prologue.js": 262,
	"./References": 263,
	"./References.js": 263,
	"./Section": 148,
	"./Section.js": 148,
	"./SectionBreak": 31,
	"./SectionBreak.js": 31,
	"./SectionI": 264,
	"./SectionI.js": 264,
	"./SectionIi": 265,
	"./SectionIi.js": 265,
	"./SectionIii": 266,
	"./SectionIii.js": 266,
	"./Sources": 267,
	"./Sources.js": 267,
	"./Supplement": 268,
	"./Supplement.js": 268,
	"./Table": 104,
	"./Table.js": 104,
	"./TableOfContents": 152,
	"./TableOfContents.js": 152,
	"./TableOfContentsEntry": 28,
	"./TableOfContentsEntry.js": 28,
	"./Tabs": 105,
	"./Tabs.js": 105,
	"./Thumbnail": 73,
	"./Thumbnail.js": 73,
	"./Title": 149,
	"./Title.js": 149,
	"./Words": 70,
	"./Words.js": 70
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 649;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/book.cb74598b.yaml";

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-afghanistan-transition.1ead5bcc.svg";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-bm-afghanistan-2005-2014.1f9e387e.svg";

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-11-1.1454df56.svg";

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-11-5.afa5ecda.svg";

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-11-7.0b642146.svg";

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-12-2.0abb5f2c.svg";

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-13-1.5a737b07.svg";

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-13-4.2a5d7fbc.svg";

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-2-2.456a5854.svg";

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-2-5.0a8521ff.svg";

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-2-8.ddc2f22f.svg";

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-3-2.6bccd37a.svg";

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-3-4.6cdd9310.svg";

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-3-5.e0cc3bc0.svg";

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-3-7.359a83cd.svg";

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-3-9.d4a141bd.svg";

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-4-2.c648c44e.svg";

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-4-4.edb58683.svg";

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-4-5.05df45f1.svg";

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-5-2.6244a0ba.svg";

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-5-6.687ae9a7.svg";

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-5-m.818f5e56.svg";

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-6-1.a5b65f22.svg";

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-6-3.b0a294ac.svg";

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-6-m.1409856a.svg";

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-7-4.b3d7dc54.svg";

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-7-7.028ba5b8.svg";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-7-m.54446c7c.svg";

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-8-1.bc91fc3b.svg";

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-8-11.306a82d8.svg";

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-8-2.0f5ecfd3.svg";

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-8-5.5fd6d095.svg";

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-8-9.a4a8747c.svg";

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-9-4.3973627c.svg";

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-figure-9-5.9cf5c298.svg";

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-fm-AfghanistanProvincialBoundaries.80a30bc4.svg";

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map-s2-helmand-and-kandahar.cb3cecd1.svg";

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Img_7-4.ae690a61.svg";

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OEF_CVR2.942a4476.png";

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/art_14-2.7fa10d01.png";

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/art_S3-1.367f452c.png";

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/art_sII-1.78fdaaf4.png";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/grafik_9-4.ccc05b08.png";

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/grafik_Fig1-1.0ca8d3b5.png";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/grafik_Fig1-6.f39f1559.png";

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_1-1.b39ee64d.png";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_1-3.8c9dc890.png";

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_1-4.e21ddae9.png";

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_1-5.2141c055.png";

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_10-1.516c169d.png";

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_10-2.3ee02699.png";

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_10-3.09c075ed.png";

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_11-1.aa41a92e.png";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_11-2.d6cee854.png";

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_11-3.41fd5b10.png";

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_11-4.358a3ebd.png";

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_11-5.0a4235eb.png";

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_11-6.7d432988.png";

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_12-1.ec43c201.png";

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_12-2.8a79cd26.png";

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_12-3.71ab5b30.png";

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_13-1.7aa7a04e.png";

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_13-2.c90bdbd1.png";

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_13-3.d918a4e5.png";

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_13-4.b01f45ce.png";

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_14-1.6608ab22.png";

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_2-1.42bb58e8.png";

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_2-2.b8095b4b.png";

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_2-3.08618f12.png";

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_2-4.f469cf57.png";

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_3-1.59e6a44d.png";

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_3-2.beb5a226.png";

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_3-3.294d49fe.png";

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_3-4.ef36c7f2.png";

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_3-5.231529f5.png";

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_4-1.9418d085.png";

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_4-2.62371205.png";

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_4-3.7529a840.png";

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_4-4.b0d924f4.png";

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_5-1.f744ad6d.png";

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_5-2.a77cb681.png";

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_5-3.13bd656d.png";

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_5-4a.9f5b72ce.png";

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_5-4b.84efb780.png";

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_5-5.f0a0fbab.png";

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_6-1.c2837b11.png";

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_6-2.581b66c1.png";

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_6-3.fa1b2c15.png";

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_7-1.ebab894d.png";

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_7-2.b58d9ded.png";

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_7-2.037bcb70.svg";

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_7-3.ef53dc3d.png";

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_7-5.b3e899e4.png";

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_7-6.8978b0c0.png";

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_8-1.cddf0cdb.png";

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_8-2.39b7762f.png";

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_8-3.beefe682.png";

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_8-4.6a210b67.png";

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_8-5.1ce57f17.png";

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_8-6.b01a21ac.png";

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_8-7.e481a00b.png";

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_9-1.4535d418.png";

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_9-2.151ada10.png";

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_9-3.72be7366.png";

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_9-5.5d203eb9.png";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_cvr_oef2.256f71f5.png";

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_sII-2.42930ff6.png";

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_11-3.18d4d22c.svg";

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_2-1.7ceb24bd.svg";

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_2-2.e2288f85.svg";

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_2-3.e9edc6d3.svg";

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_3-1.59a42ba4.svg";

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_3-2.4a3ba13b.svg";

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_3-3.8fccd7e7.svg";

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_3-4.3c57c3ab.svg";

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_3-5.6642056f.svg";

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_4-1.0554c888.svg";

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_4-2.68170d9e.svg";

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_4-3.f2bf8908.svg";

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_5-1.4e806eeb.svg";

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_5-2.c8aeaab5.svg";

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_5-3.e0d5fb42.svg";

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_6-1.fda11f32.svg";

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_6-2.58d50f3a.svg";

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_7-1.5f8f39b3.svg";

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_7-3.09150f14.svg";

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_SIII-1.4825fc9a.svg";

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map_sII-1.aa6638c9.svg";

/***/ }),
/* 779 */
/***/ (function(module, exports) {

throw new Error("Module parse failed: Unexpected token (1:0)\nYou may need an appropriate loader to handle this file type.\n| <!DOCTYPE html>\n| <html>\n|   <head>");

/***/ }),
/* 780 */
/***/ (function(module, exports) {

throw new Error("Module parse failed: Unexpected token (1:0)\nYou may need an appropriate loader to handle this file type.\n| <!DOCTYPE html>\n| <html>\n|   <head>");

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/audio.example.2ca80224.mp3";

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/media.example.poster.de6be620.png";

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/video.example.bfd19c4e.mp4";

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Manager = __webpack_require__(785);

var _Manager2 = _interopRequireDefault(_Manager);

var _BigPlayButton = __webpack_require__(222);

var _BigPlayButton2 = _interopRequireDefault(_BigPlayButton);

var _LoadingSpinner = __webpack_require__(223);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _PosterImage = __webpack_require__(224);

var _PosterImage2 = _interopRequireDefault(_PosterImage);

var _Video = __webpack_require__(225);

var _Video2 = _interopRequireDefault(_Video);

var _Bezel = __webpack_require__(226);

var _Bezel2 = _interopRequireDefault(_Bezel);

var _Shortcut = __webpack_require__(227);

var _Shortcut2 = _interopRequireDefault(_Shortcut);

var _ControlBar = __webpack_require__(228);

var _ControlBar2 = _interopRequireDefault(_ControlBar);

var _browser = __webpack_require__(796);

var browser = _interopRequireWildcard(_browser);

var _utils = __webpack_require__(30);

var _fullscreen = __webpack_require__(221);

var _fullscreen2 = _interopRequireDefault(_fullscreen);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.any,

  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  fluid: _propTypes2.default.bool,
  muted: _propTypes2.default.bool,
  playsInline: _propTypes2.default.bool,
  aspectRatio: _propTypes2.default.string,
  className: _propTypes2.default.string,
  videoId: _propTypes2.default.string,

  startTime: _propTypes2.default.number,
  loop: _propTypes2.default.bool,
  autoPlay: _propTypes2.default.bool,
  src: _propTypes2.default.string,
  poster: _propTypes2.default.string,
  preload: _propTypes2.default.oneOf(['auto', 'metadata', 'none']),

  onLoadStart: _propTypes2.default.func,
  onWaiting: _propTypes2.default.func,
  onCanPlay: _propTypes2.default.func,
  onCanPlayThrough: _propTypes2.default.func,
  onPlaying: _propTypes2.default.func,
  onEnded: _propTypes2.default.func,
  onSeeking: _propTypes2.default.func,
  onSeeked: _propTypes2.default.func,
  onPlay: _propTypes2.default.func,
  onPause: _propTypes2.default.func,
  onProgress: _propTypes2.default.func,
  onDurationChange: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onSuspend: _propTypes2.default.func,
  onAbort: _propTypes2.default.func,
  onEmptied: _propTypes2.default.func,
  onStalled: _propTypes2.default.func,
  onLoadedMetadata: _propTypes2.default.func,
  onLoadedData: _propTypes2.default.func,
  onTimeUpdate: _propTypes2.default.func,
  onRateChange: _propTypes2.default.func,
  onVolumeChange: _propTypes2.default.func,

  store: _propTypes2.default.object
};

var defaultProps = {
  fluid: true,
  muted: false,
  playsInline: false,
  aspectRatio: 'auto'
};

var Player = function (_Component) {
  _inherits(Player, _Component);

  function Player(props) {
    _classCallCheck(this, Player);

    var _this = _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, props));

    _this.controlsHideTimer = null;

    _this.video = null; // the Video component
    _this.manager = new _Manager2.default(props.store);
    _this.actions = _this.manager.getActions();
    _this.manager.subscribeToPlayerStateChange(_this.handleStateChange.bind(_this));

    _this.getStyle = _this.getStyle.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);
    _this.getChildren = _this.getChildren.bind(_this);
    _this.handleMouseMove = (0, _utils.throttle)(_this.handleMouseMove.bind(_this), 250);
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.startControlsTimer = _this.startControlsTimer.bind(_this);
    _this.handleFullScreenChange = _this.handleFullScreenChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    return _this;
  }

  _createClass(Player, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);

      _fullscreen2.default.addEventListener(this.handleFullScreenChange);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove event listener
      window.removeEventListener('resize', this.handleResize);
      _fullscreen2.default.removeEventListener(this.handleFullScreenChange);
      if (this.controlsHideTimer) {
        window.clearTimeout(this.controlsHideTimer);
      }
    }
  }, {
    key: 'getDefaultChildren',
    value: function getDefaultChildren(props, fullProps) {
      var _this2 = this;

      return [_react2.default.createElement(_Video2.default, _extends({
        ref: function ref(c) {
          _this2.video = c;
          _this2.manager.video = _this2.video;
        },
        key: 'video',
        order: 0.0
      }, fullProps)), _react2.default.createElement(_PosterImage2.default, _extends({
        key: 'poster-image',
        order: 1.0
      }, props)), _react2.default.createElement(_LoadingSpinner2.default, _extends({
        key: 'loading-spinner',
        order: 2.0
      }, props)), _react2.default.createElement(_Bezel2.default, _extends({
        key: 'bezel',
        order: 3.0
      }, props)), _react2.default.createElement(_BigPlayButton2.default, _extends({
        key: 'big-play-button',
        order: 4.0
      }, props)), _react2.default.createElement(_ControlBar2.default, _extends({
        key: 'control-bar',
        order: 5.0
      }, props)), _react2.default.createElement(_Shortcut2.default, _extends({
        key: 'shortcut',
        order: 99.0
      }, props))];
    }
  }, {
    key: 'getChildren',
    value: function getChildren(props) {
      var propsWithoutChildren = _extends({}, props, {
        children: null
      });
      var children = _react2.default.Children.toArray(this.props.children).filter(function (e) {
        return !(0, _utils.isVideoChild)(e);
      });
      var defaultChildren = this.getDefaultChildren(propsWithoutChildren, props);
      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, propsWithoutChildren);
    }
  }, {
    key: 'setWidthOrHeight',
    value: function setWidthOrHeight(style, name, value) {
      var styleVal = void 0;
      if (typeof value === 'string') {
        if (value === 'auto') {
          styleVal = 'auto';
        } else if (value.match(/\d+%/)) {
          styleVal = value;
        }
      } else if (typeof value === 'number') {
        styleVal = value + 'px';
      }
      Object.assign(style, _defineProperty({}, name, styleVal));
    }
  }, {
    key: 'getStyle',
    value: function getStyle() {
      var fluid = this.props.fluid;

      var _manager$getState = this.manager.getState(),
          player = _manager$getState.player;

      var style = {};
      var width = void 0;
      var height = void 0;
      var aspectRatio = void 0;

      // The aspect ratio is either used directly or to calculate width and height.
      if (this.props.aspectRatio !== undefined && this.props.aspectRatio !== 'auto') {
        // Use any aspectRatio that's been specifically set
        aspectRatio = this.props.aspectRatio;
      } else if (player.videoWidth) {
        // Otherwise try to get the aspect ratio from the video metadata
        aspectRatio = player.videoWidth + ':' + player.videoHeight;
      } else {
        // Or use a default. The video element's is 2:1, but 16:9 is more common.
        aspectRatio = '16:9';
      }

      // Get the ratio as a decimal we can use to calculate dimensions
      var ratioParts = aspectRatio.split(':');
      var ratioMultiplier = ratioParts[1] / ratioParts[0];

      if (this.props.width !== undefined) {
        // Use any width that's been specifically set
        width = this.props.width;
      } else if (this.props.height !== undefined) {
        // Or calulate the width from the aspect ratio if a height has been set
        width = this.props.height / ratioMultiplier;
      } else {
        // Or use the video's metadata, or use the video el's default of 300
        width = player.videoWidth || 400;
      }

      if (this.props.height !== undefined) {
        // Use any height that's been specifically set
        height = this.props.height;
      } else {
        // Otherwise calculate the height from the ratio and the width
        height = width * ratioMultiplier;
      }

      if (fluid) {
        style.paddingTop = ratioMultiplier * 100 + '%';
      } else {
        // If Width contains "auto", set "auto" in style
        this.setWidthOrHeight(style, 'width', width);
        this.setWidthOrHeight(style, 'height', height);
      }

      return style;
    }

    // get redux state
    // { player, operation }

  }, {
    key: 'getState',
    value: function getState() {
      return this.manager.getState();
    }

    // get playback rate

  }, {
    key: 'play',


    // play the video
    value: function play() {
      this.video.play();
    }

    // pause the video

  }, {
    key: 'pause',
    value: function pause() {
      this.video.pause();
    }

    // Change the video source and re-load the video:

  }, {
    key: 'load',
    value: function load() {
      this.video.load();
    }

    // Add a new text track to the video

  }, {
    key: 'addTextTrack',
    value: function addTextTrack() {
      var _video;

      (_video = this.video).addTextTrack.apply(_video, arguments);
    }

    // Check if your browser can play different types of video:

  }, {
    key: 'canPlayType',
    value: function canPlayType() {
      var _video2;

      (_video2 = this.video).canPlayType.apply(_video2, arguments);
    }

    // seek video by time

  }, {
    key: 'seek',
    value: function seek(time) {
      this.video.seek(time);
    }

    // jump forward x seconds

  }, {
    key: 'forward',
    value: function forward(seconds) {
      this.video.forward(seconds);
    }

    // jump back x seconds

  }, {
    key: 'replay',
    value: function replay(seconds) {
      this.video.replay(seconds);
    }

    // enter or exist full screen

  }, {
    key: 'toggleFullscreen',
    value: function toggleFullscreen() {
      this.video.toggleFullscreen();
    }

    // subscribe to player state change

  }, {
    key: 'subscribeToStateChange',
    value: function subscribeToStateChange(listener) {
      return this.manager.subscribeToPlayerStateChange(listener);
    }

    // player resize

  }, {
    key: 'handleResize',
    value: function handleResize() {}
  }, {
    key: 'handleFullScreenChange',
    value: function handleFullScreenChange() {
      this.actions.handleFullscreenChange(_fullscreen2.default.isFullscreen);
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown() {
      this.startControlsTimer();
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove() {
      this.startControlsTimer();
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown() {
      this.startControlsTimer();
    }
  }, {
    key: 'startControlsTimer',
    value: function startControlsTimer() {
      var _this3 = this;

      this.actions.userActivate(true);
      clearTimeout(this.controlsHideTimer);
      this.controlsHideTimer = setTimeout(function () {
        _this3.actions.userActivate(false);
      }, 3000);
    }
  }, {
    key: 'handleStateChange',
    value: function handleStateChange(state, prevState) {
      if (state.isFullscreen !== prevState.isFullscreen) {
        this.handleResize();
      }
      this.forceUpdate(); // re-render
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      this.actions.activate(true);
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      this.actions.activate(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var fluid = this.props.fluid;

      var _manager$getState2 = this.manager.getState(),
          player = _manager$getState2.player;

      var paused = player.paused,
          hasStarted = player.hasStarted,
          waiting = player.waiting,
          seeking = player.seeking,
          isFullscreen = player.isFullscreen,
          userActivity = player.userActivity;


      var props = _extends({}, this.props, {
        player: player,
        actions: this.actions,
        manager: this.manager,
        store: this.manager.store,
        video: this.video ? this.video.video : null
      });
      var children = this.getChildren(props);

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)({
            'video-react-controls-enabled': true,
            'video-react-has-started': hasStarted,
            'video-react-paused': paused,
            'video-react-playing': !paused,
            'video-react-waiting': waiting,
            'video-react-seeking': seeking,
            'video-react-fluid': fluid,
            'video-react-fullscreen': isFullscreen,
            'video-react-user-inactive': !userActivity,
            'video-react-user-active': userActivity,
            'video-react-workinghover': !browser.IS_IOS
          }, 'video-react', this.props.className),
          style: this.getStyle(),
          ref: function ref(c) {
            _this4.manager.rootElement = c;
          },
          role: 'region',
          onTouchStart: this.handleMouseDown,
          onMouseDown: this.handleMouseDown,
          onMouseMove: this.handleMouseMove,
          onKeyDown: this.handleKeyDown,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          tabIndex: '-1'
        },
        children
      );
    }
  }, {
    key: 'playbackRate',
    get: function get() {
      return this.video.playbackRate;
    }

    // set playback rate
    // speed of video
    ,
    set: function set(rate) {
      this.video.playbackRate = rate;
    }
  }, {
    key: 'muted',
    get: function get() {
      return this.video.muted;
    },
    set: function set(val) {
      this.video.muted = val;
    }
  }, {
    key: 'volume',
    get: function get() {
      return this.video.volume;
    },
    set: function set(val) {
      this.video.volume = val;
    }

    // video width

  }, {
    key: 'videoWidth',
    get: function get() {
      return this.video.videoWidth;
    }

    // video height

  }, {
    key: 'videoHeight',
    get: function get() {
      return this.video.videoHeight;
    }
  }]);

  return Player;
}(_react.Component);

exports.default = Player;


Player.contextTypes = { store: _propTypes2.default.object };
Player.propTypes = propTypes;
Player.defaultProps = defaultProps;
Player.displayName = 'Player';

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _redux = __webpack_require__(786);

var _reducers = __webpack_require__(220);

var _reducers2 = _interopRequireDefault(_reducers);

var _player = __webpack_require__(72);

var playerActions = _interopRequireWildcard(_player);

var _video = __webpack_require__(143);

var videoActions = _interopRequireWildcard(_video);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Manager = function () {
  function Manager(store) {
    _classCallCheck(this, Manager);

    this.store = store || (0, _redux.createStore)(_reducers2.default);

    this.video = null;
    this.rootElement = null;
  }

  _createClass(Manager, [{
    key: 'getActions',
    value: function getActions() {
      var manager = this;
      var dispatch = this.store.dispatch;

      var actions = _extends({}, playerActions, videoActions);

      function bindActionCreator(actionCreator) {
        return function bindAction() {
          // eslint-disable-next-line prefer-rest-params
          var action = actionCreator.apply(manager, arguments);
          if (typeof action !== 'undefined') {
            dispatch(action);
          }
        };
      }

      return Object.keys(actions).filter(function (key) {
        return typeof actions[key] === 'function';
      }).reduce(function (boundActions, key) {
        boundActions[key] = bindActionCreator(actions[key]);
        return boundActions;
      }, {});
    }
  }, {
    key: 'getState',
    value: function getState() {
      return this.store.getState();
    }

    // subscribe state change

  }, {
    key: 'subscribeToStateChange',
    value: function subscribeToStateChange(listener, getState) {
      if (!getState) {
        getState = this.getState.bind(this);
      }

      var prevState = getState();

      var handleChange = function handleChange() {
        var state = getState();
        if (state === prevState) {
          return;
        }
        var prevStateCopy = prevState;
        prevState = state;
        listener(state, prevStateCopy);
      };

      return this.store.subscribe(handleChange);
    }

    // subscribe to operation state change

  }, {
    key: 'subscribeToOperationStateChange',
    value: function subscribeToOperationStateChange(listener) {
      var _this = this;

      return this.subscribeToStateChange(listener, function () {
        return _this.getState().operation;
      });
    }

    // subscribe to player state change

  }, {
    key: 'subscribeToPlayerStateChange',
    value: function subscribeToPlayerStateChange(listener) {
      var _this2 = this;

      return this.subscribeToStateChange(listener, function () {
        return _this2.getState().player;
      });
    }
  }]);

  return Manager;
}();

exports.default = Manager;

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(170);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers);
  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.player = player;

var _video = __webpack_require__(143);

var _player = __webpack_require__(72);

var initialState = {
  currentSrc: null,
  duration: 0,
  currentTime: 0,
  seekingTime: 0,
  buffered: null,
  waiting: false,
  seeking: false,
  paused: true,
  autoPaused: false,
  ended: false,
  playbackRate: 1,
  muted: false,
  volume: 1,
  readyState: 0,
  networkState: 0,
  videoWidth: 0,
  videoHeight: 0,
  hasStarted: false,
  userActivity: true,
  isActive: false,
  isFullscreen: false
};

function player() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _player.USER_ACTIVATE:
      return _extends({}, state, {
        userActivity: action.activity
      });
    case _player.PLAYER_ACTIVATE:
      return _extends({}, state, {
        isActive: action.activity
      });
    case _player.FULLSCREEN_CHANGE:
      return _extends({}, state, {
        isFullscreen: !!action.isFullscreen
      });
    case _video.SEEKING_TIME:
      return _extends({}, state, {
        seekingTime: action.time
      });
    case _video.END_SEEKING:
      return _extends({}, state, {
        seekingTime: 0
      });
    case _video.LOAD_START:
      return _extends({}, state, action.videoProps, {
        hasStarted: false,
        ended: false
      });
    case _video.CAN_PLAY:
      return _extends({}, state, action.videoProps, {
        waiting: false
      });
    case _video.WAITING:
      return _extends({}, state, action.videoProps, {
        waiting: true
      });
    case _video.CAN_PLAY_THROUGH:
    case _video.PLAYING:
      return _extends({}, state, action.videoProps, {
        waiting: false
      });
    case _video.PLAY:
      return _extends({}, state, action.videoProps, {
        ended: false,
        paused: false,
        autoPaused: false,
        waiting: false,
        hasStarted: true
      });
    case _video.PAUSE:
      return _extends({}, state, action.videoProps, {
        paused: true
      });
    case _video.END:
      return _extends({}, state, action.videoProps, {
        ended: true
      });
    case _video.SEEKING:
      return _extends({}, state, action.videoProps, {
        seeking: true
      });
    case _video.SEEKED:
      return _extends({}, state, action.videoProps, {
        seeking: false
      });
    case _video.ERROR:
      return _extends({}, state, action.videoProps, {
        error: 'UNKNOWN ERROR',
        ended: true
      });
    case _video.DURATION_CHANGE:
    case _video.TIME_UPDATE:
    case _video.VOLUME_CHANGE:
    case _video.PROGRESS_CHANGE:
    case _video.RATE_CHANGE:
    case _video.SUSPEND:
    case _video.ABORT:
    case _video.EMPTIED:
    case _video.STALLED:
    case _video.LOADED_META_DATA:
    case _video.LOADED_DATA:
    case _video.RESIZE:
      var newState = _extends({}, state, action.videoProps);
      if (action.videoProps.paused === false) {
        newState.hasStarted = true;
        newState.waiting = false;
      }
      return newState;
    default:
      return state;
  }
}

exports.default = player;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.operation = operation;

var _player = __webpack_require__(72);

var initialState = {
  count: 0,
  operation: {
    action: '',
    source: ''
  }
};

function operation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _player.OPERATE:
      return _extends({}, state, {
        count: state.count + 1,
        operation: _extends({}, state.operation, action.operation)
      });
    default:
      return state;
  }
}

exports.default = operation;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = PopupButton;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _ClickableComponent = __webpack_require__(244);

var _ClickableComponent2 = _interopRequireDefault(_ClickableComponent);

var _Popup = __webpack_require__(790);

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  inline: _propTypes2.default.bool,
  onClick: _propTypes2.default.func.isRequired,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  className: _propTypes2.default.string
};

var defaultProps = {
  inline: true
};

function PopupButton(props) {
  var inline = props.inline,
      className = props.className;

  var ps = _extends({}, props);
  delete ps.children;
  delete ps.inline;
  delete ps.className;
  return _react2.default.createElement(
    _ClickableComponent2.default,
    _extends({
      className: (0, _classnames2.default)(className, {
        'video-react-menu-button-inline': !!inline,
        'video-react-menu-button-popup': !inline
      }, 'video-react-control video-react-button video-react-menu-button')
    }, ps),
    _react2.default.createElement(_Popup2.default, props)
  );
}

PopupButton.propTypes = propTypes;
PopupButton.defaultProps = defaultProps;
PopupButton.displayName = 'PopupButton';

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  player: _propTypes2.default.object,
  children: _propTypes2.default.any
};

var Popup = function (_Component) {
  _inherits(Popup, _Component);

  function Popup(props, context) {
    _classCallCheck(this, Popup);

    var _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(Popup, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      // event.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _react2.default.createElement(
        'div',
        {
          className: 'video-react-menu',
          onClick: this.handleClick
        },
        _react2.default.createElement(
          'div',
          { className: 'video-react-menu-content' },
          children
        )
      );
    }
  }]);

  return Popup;
}(_react.Component);

exports.default = Popup;


Popup.propTypes = propTypes;
Popup.displayName = 'Popup';

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Slider = __webpack_require__(145);

var _Slider2 = _interopRequireDefault(_Slider);

var _VolumeLevel = __webpack_require__(792);

var _VolumeLevel2 = _interopRequireDefault(_VolumeLevel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  actions: _propTypes2.default.object,
  player: _propTypes2.default.object,
  className: _propTypes2.default.string,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func
};

var VolumeBar = function (_Component) {
  _inherits(VolumeBar, _Component);

  function VolumeBar(props, context) {
    _classCallCheck(this, VolumeBar);

    var _this = _possibleConstructorReturn(this, (VolumeBar.__proto__ || Object.getPrototypeOf(VolumeBar)).call(this, props, context));

    _this.state = {
      percentage: '0%'
    };

    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    _this.handlePercentageChange = _this.handlePercentageChange.bind(_this);
    _this.checkMuted = _this.checkMuted.bind(_this);
    _this.getPercent = _this.getPercent.bind(_this);
    _this.stepForward = _this.stepForward.bind(_this);
    _this.stepBack = _this.stepBack.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(VolumeBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'getPercent',
    value: function getPercent() {
      var player = this.props.player;

      if (player.muted) {
        return 0;
      }
      return player.volume;
    }
  }, {
    key: 'checkMuted',
    value: function checkMuted() {
      var _props = this.props,
          player = _props.player,
          actions = _props.actions;

      if (player.muted) {
        actions.mute(false);
      }
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      var actions = this.props.actions;

      this.checkMuted();
      var distance = this.slider.calculateDistance(event);
      actions.changeVolume(distance);
    }
  }, {
    key: 'stepForward',
    value: function stepForward() {
      var _props2 = this.props,
          player = _props2.player,
          actions = _props2.actions;

      this.checkMuted();
      actions.changeVolume(player.volume + 0.1);
    }
  }, {
    key: 'stepBack',
    value: function stepBack() {
      var _props3 = this.props,
          player = _props3.player,
          actions = _props3.actions;

      this.checkMuted();
      actions.changeVolume(player.volume - 0.1);
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(e) {
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(e) {
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: 'handlePercentageChange',
    value: function handlePercentageChange(percentage) {
      if (percentage !== this.state.percentage) {
        this.setState({
          percentage: percentage
        });
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      event.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props4 = this.props,
          player = _props4.player,
          className = _props4.className;


      var volume = (player.volume * 100).toFixed(2);
      return _react2.default.createElement(
        _Slider2.default,
        _extends({
          ref: function ref(c) {
            _this2.slider = c;
          },
          label: 'volume level',
          valuenow: volume,
          valuetext: volume + '%',
          onMouseMove: this.handleMouseMove,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onClick: this.handleClick,
          sliderActive: this.handleFocus,
          sliderInactive: this.handleBlur,
          getPercent: this.getPercent,
          onPercentageChange: this.handlePercentageChange,
          stepForward: this.stepForward,
          stepBack: this.stepBack
        }, this.props, {
          className: (0, _classnames2.default)(className, 'video-react-volume-bar video-react-slider-bar')
        }),
        _react2.default.createElement(_VolumeLevel2.default, this.props)
      );
    }
  }]);

  return VolumeBar;
}(_react.Component);

VolumeBar.propTypes = propTypes;
VolumeBar.displayName = 'VolumeBar';

exports.default = VolumeBar;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  percentage: _propTypes2.default.string,
  vertical: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

var defaultProps = {
  percentage: '100%',
  vertical: false
};

function VolumeLevel(_ref) {
  var percentage = _ref.percentage,
      vertical = _ref.vertical,
      className = _ref.className;

  var style = {};
  if (vertical) {
    style.height = percentage;
  } else {
    style.width = percentage;
  }

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)(className, 'video-react-volume-level'),
      style: style
    },
    _react2.default.createElement('span', { className: 'video-react-control-text' })
  );
}

VolumeLevel.propTypes = propTypes;
VolumeLevel.defaultProps = defaultProps;
VolumeLevel.displayName = 'VolumeLevel';
exports.default = VolumeLevel;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Menu = __webpack_require__(794);

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = __webpack_require__(795);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _ClickableComponent = __webpack_require__(244);

var _ClickableComponent2 = _interopRequireDefault(_ClickableComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  inline: _propTypes2.default.bool,
  items: _propTypes2.default.array,
  className: _propTypes2.default.string,
  onSelectItem: _propTypes2.default.func,
  children: _propTypes2.default.any,
  selectedIndex: _propTypes2.default.number
};

var MenuButton = function (_Component) {
  _inherits(MenuButton, _Component);

  function MenuButton(props, context) {
    _classCallCheck(this, MenuButton);

    var _this = _possibleConstructorReturn(this, (MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).call(this, props, context));

    _this.state = {
      active: false,
      activateIndex: props.selectedIndex || 0
    };

    _this.commitSelection = _this.commitSelection.bind(_this);
    _this.activateMenuItem = _this.activateMenuItem.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.renderMenu = _this.renderMenu.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleUpArrow = _this.handleUpArrow.bind(_this);
    _this.handleDownArrow = _this.handleDownArrow.bind(_this);
    _this.handleEscape = _this.handleEscape.bind(_this);
    _this.handleReturn = _this.handleReturn.bind(_this);
    _this.handleTab = _this.handleTab.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.handleSelectItem = _this.handleSelectItem.bind(_this);
    _this.handleIndexChange = _this.handleIndexChange.bind(_this);
    return _this;
  }

  _createClass(MenuButton, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.selectedIndex !== this.props.selectedIndex) {
        this.activateMenuItem(this.props.selectedIndex);
      }
    }
  }, {
    key: 'commitSelection',
    value: function commitSelection(index) {
      this.setState({
        activateIndex: index,
        active: false
      });
      this.handleIndexChange(index);
    }
  }, {
    key: 'activateMenuItem',
    value: function activateMenuItem(index) {
      this.setState({
        activateIndex: index
      });
      this.handleIndexChange(index);
    }
  }, {
    key: 'handleIndexChange',
    value: function handleIndexChange(index) {
      var onSelectItem = this.props.onSelectItem;

      onSelectItem(index);
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.setState({
        active: !this.state.active
      });
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      document.addEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      this.setState({
        active: false
      });
      document.removeEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: 'handleUpArrow',
    value: function handleUpArrow(e) {
      var items = this.props.items;

      if (this.state.active) {
        e.preventDefault();
        var newIndex = this.state.activateIndex - 1;
        if (newIndex < 0) {
          newIndex = items.length ? items.length - 1 : 0;
        }
        this.activateMenuItem(newIndex);
      }
    }
  }, {
    key: 'handleDownArrow',
    value: function handleDownArrow(e) {
      var items = this.props.items;

      if (this.state.active) {
        e.preventDefault();
        var newIndex = this.state.activateIndex + 1;
        if (newIndex >= items.length) {
          newIndex = 0;
        }
        this.activateMenuItem(newIndex);
      }
    }
  }, {
    key: 'handleTab',
    value: function handleTab(e) {
      if (this.state.active) {
        e.preventDefault();
        this.commitSelection(this.state.activateIndex);
      }
    }
  }, {
    key: 'handleReturn',
    value: function handleReturn(e) {
      e.preventDefault();
      if (this.state.active) {
        this.commitSelection(this.state.activateIndex);
      } else {
        this.setState({
          active: true
        });
      }
    }
  }, {
    key: 'handleEscape',
    value: function handleEscape() {
      this.setState({
        active: false,
        activateIndex: 0
      });
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(event) {
      // Escape (27) key
      if (event.which === 27) {
        this.handleEscape(event);
      } else if (event.which === 9) {
        // Tab (9) key
        this.handleTab(event);
      } else if (event.which === 13) {
        // Enter (13) key
        this.handleReturn(event);
      } else if (event.which === 38) {
        // Up (38) key
        this.handleUpArrow(event);
      } else if (event.which === 40) {
        // Down (40) key press
        this.handleDownArrow(event);
      }
    }
  }, {
    key: 'handleSelectItem',
    value: function handleSelectItem(i) {
      this.commitSelection(i);
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }

      var items = this.props.items;

      return _react2.default.createElement(
        _Menu2.default,
        null,
        items.map(function (item, i) {
          return _react2.default.createElement(_MenuItem2.default, {
            item: item,
            index: i,
            onSelectItem: _this2.handleSelectItem,
            activateIndex: _this2.state.activateIndex,
            key: 'item-' + i++
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          inline = _props.inline,
          className = _props.className;


      return _react2.default.createElement(
        _ClickableComponent2.default,
        {
          className: (0, _classnames2.default)(className, {
            'video-react-menu-button-inline': !!inline,
            'video-react-menu-button-popup': !inline,
            'video-react-menu-button-active': this.state.active
          }, 'video-react-control video-react-button video-react-menu-button'),
          role: 'presentation',
          tabIndex: '0',
          ref: function ref(c) {
            _this3.menuButton = c;
          },
          onClick: this.handleClick,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        },
        this.props.children,
        this.renderMenu()
      );
    }
  }]);

  return MenuButton;
}(_react.Component);

exports.default = MenuButton;


MenuButton.propTypes = propTypes;
MenuButton.displayName = 'MenuButton';

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.any
};

var Menu = function (_Component) {
  _inherits(Menu, _Component);

  function Menu(props, context) {
    _classCallCheck(this, Menu);

    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(Menu, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      // event.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'video-react-menu video-react-lock-showing',
          role: 'presentation',
          onClick: this.handleClick
        },
        _react2.default.createElement(
          'ul',
          { className: 'video-react-menu-content' },
          this.props.children
        )
      );
    }
  }]);

  return Menu;
}(_react.Component);

exports.default = Menu;


Menu.propTypes = propTypes;
Menu.displayName = 'Menu';

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  item: _propTypes2.default.object,
  index: _propTypes2.default.number,
  activateIndex: _propTypes2.default.number,
  onSelectItem: _propTypes2.default.func
};

var MenuItem = function (_Component) {
  _inherits(MenuItem, _Component);

  function MenuItem(props, context) {
    _classCallCheck(this, MenuItem);

    var _this = _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(MenuItem, [{
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          index = _props.index,
          onSelectItem = _props.onSelectItem;

      onSelectItem(index);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          item = _props2.item,
          index = _props2.index,
          activateIndex = _props2.activateIndex;

      return _react2.default.createElement(
        'li',
        {
          className: (0, _classnames2.default)({
            'video-react-menu-item': true,
            'video-react-selected': index === activateIndex
          }),
          onClick: this.handleClick
        },
        item.label,
        _react2.default.createElement('span', { className: 'video-react-control-text' })
      );
    }
  }]);

  return MenuItem;
}(_react.Component);

exports.default = MenuItem;


MenuItem.propTypes = propTypes;
MenuItem.displayName = 'MenuItem';

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_AGENT = typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent : '';
// const webkitVersionMap = (/AppleWebKit\/([\d.]+)/i).exec(USER_AGENT);
// const appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;

/*
 * Device is an iPhone
 *
 * @type {Boolean}
 * @constant
 * @private
 */
var IS_IPAD = exports.IS_IPAD = /iPad/i.test(USER_AGENT);

// The Facebook app's UIWebView identifies as both an iPhone and iPad, so
// to identify iPhones, we need to exclude iPads.
// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
var IS_IPHONE = exports.IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
var IS_IPOD = exports.IS_IPOD = /iPod/i.test(USER_AGENT);
var IS_IOS = exports.IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PlaybackRateMenuButton = __webpack_require__(146);

var _PlaybackRateMenuButton2 = _interopRequireDefault(_PlaybackRateMenuButton);

var _utils = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlaybackRate = function (_Component) {
  _inherits(PlaybackRate, _Component);

  function PlaybackRate(props, context) {
    _classCallCheck(this, PlaybackRate);

    var _this = _possibleConstructorReturn(this, (PlaybackRate.__proto__ || Object.getPrototypeOf(PlaybackRate)).call(this, props, context));

    (0, _utils.deprecatedWarning)('PlaybackRate', 'PlaybackRateMenuButton');
    return _this;
  }

  _createClass(PlaybackRate, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_PlaybackRateMenuButton2.default, this.props);
    }
  }]);

  return PlaybackRate;
}(_react.Component);

exports.default = PlaybackRate;


PlaybackRate.displayName = 'PlaybackRate';

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = deepMerge;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function isObject(item) {
  return item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && !Array.isArray(item);
}

function deepMerge(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (!sources.length) {
    return target;
  }
  // making sure to not change target (immutable)
  var output = _extends({}, target);
  sources.forEach(function (source) {
    if (isObject(source)) {
      Object.keys(source).forEach(function (key) {
        if (isObject(source[key])) {
          if (!output[key]) {
            output[key] = _extends({}, source[key]);
          } else {
            output[key] = deepMerge(output[key], source[key]);
          }
        } else {
          output[key] = source[key];
        }
      });
    }
  });
  return output;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({ deepMerge: deepMerge, isObject: isObject });

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return base; });
var base = {
  global: {
    colors: {
      icon: '#666666'
    }
  },
  icon: {
    size: {
      small: '12px',
      medium: '24px',
      large: '48px',
      xlarge: '96px'
    }
  }
};

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accessibility__ = __webpack_require__(801);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Achievement__ = __webpack_require__(802);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Action__ = __webpack_require__(803);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Actions__ = __webpack_require__(804);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Ad__ = __webpack_require__(805);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddCircle__ = __webpack_require__(806);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__AddCircle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Add__ = __webpack_require__(807);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Aed__ = __webpack_require__(808);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Aggregate__ = __webpack_require__(809);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AidOption__ = __webpack_require__(810);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Aid__ = __webpack_require__(811);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Alarm__ = __webpack_require__(812);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Alert__ = __webpack_require__(813);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Amazon__ = __webpack_require__(814);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Amex__ = __webpack_require__(815);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Analytics__ = __webpack_require__(816);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Anchor__ = __webpack_require__(817);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Android__ = __webpack_require__(818);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Announce__ = __webpack_require__(819);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Apple__ = __webpack_require__(820);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Apps__ = __webpack_require__(821);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Archive__ = __webpack_require__(822);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Archlinux__ = __webpack_require__(823);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Article__ = __webpack_require__(824);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Aruba__ = __webpack_require__(825);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Ascend__ = __webpack_require__(826);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__AssistListening__ = __webpack_require__(827);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Atm__ = __webpack_require__(828);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Attachment__ = __webpack_require__(829);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Attraction__ = __webpack_require__(830);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Baby__ = __webpack_require__(831);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__BackTen__ = __webpack_require__(832);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__BarChart__ = __webpack_require__(833);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Bar__ = __webpack_require__(834);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Basket__ = __webpack_require__(835);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Bike__ = __webpack_require__(836);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Bitcoin__ = __webpack_require__(837);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__BlockQuote__ = __webpack_require__(838);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Blog__ = __webpack_require__(839);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Bluetooth__ = __webpack_require__(840);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Bold__ = __webpack_require__(841);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Book__ = __webpack_require__(842);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Bookmark__ = __webpack_require__(843);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_42__Bookmark__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__BottomCorner__ = __webpack_require__(844);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Braille__ = __webpack_require__(845);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Briefcase__ = __webpack_require__(846);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Brush__ = __webpack_require__(847);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Bug__ = __webpack_require__(848);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Bundle__ = __webpack_require__(849);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Bus__ = __webpack_require__(850);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__BusinessService__ = __webpack_require__(851);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Cafeteria__ = __webpack_require__(852);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Calculator__ = __webpack_require__(853);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Calendar__ = __webpack_require__(854);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Camera__ = __webpack_require__(855);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Capacity__ = __webpack_require__(856);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Car__ = __webpack_require__(857);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__CaretDown__ = __webpack_require__(858);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__CaretNext__ = __webpack_require__(859);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__CaretPrevious__ = __webpack_require__(860);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__CaretUp__ = __webpack_require__(861);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Cart__ = __webpack_require__(862);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__CatalogOption__ = __webpack_require__(863);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Catalog__ = __webpack_require__(864);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Centos__ = __webpack_require__(865);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Channel__ = __webpack_require__(866);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ChapterAdd__ = __webpack_require__(867);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ChapterNext__ = __webpack_require__(868);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_67__ChapterNext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__ChapterPrevious__ = __webpack_require__(869);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_68__ChapterPrevious__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__ChatOption__ = __webpack_require__(870);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Chat__ = __webpack_require__(871);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__CheckboxSelected__ = __webpack_require__(872);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Checkbox__ = __webpack_require__(873);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Checkmark__ = __webpack_require__(874);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_73__Checkmark__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Chrome__ = __webpack_require__(875);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__CircleInformation__ = __webpack_require__(876);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__CirclePlay__ = __webpack_require__(877);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__CircleQuestion__ = __webpack_require__(878);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__ClearOption__ = __webpack_require__(879);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Clear__ = __webpack_require__(880);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_79__Clear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__Cli__ = __webpack_require__(881);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Clipboard__ = __webpack_require__(882);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Clock__ = __webpack_require__(883);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__Clone__ = __webpack_require__(884);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__Close__ = __webpack_require__(885);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_84__Close__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__ClosedCaption__ = __webpack_require__(886);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__CloudComputer__ = __webpack_require__(887);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__CloudDownload__ = __webpack_require__(888);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__CloudSoftware__ = __webpack_require__(889);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__CloudUpload__ = __webpack_require__(890);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Cloud__ = __webpack_require__(891);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Cloudlinux__ = __webpack_require__(892);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__Cluster__ = __webpack_require__(893);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__CoatCheck__ = __webpack_require__(894);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__CodeSandbox__ = __webpack_require__(895);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__Code__ = __webpack_require__(896);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__Codepen__ = __webpack_require__(897);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__Columns__ = __webpack_require__(898);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__Command__ = __webpack_require__(899);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__Compare__ = __webpack_require__(900);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__Compass__ = __webpack_require__(901);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__Compliance__ = __webpack_require__(902);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__Configure__ = __webpack_require__(903);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__Connect__ = __webpack_require__(904);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_103__Connect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__Connectivity__ = __webpack_require__(905);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__ContactInfo__ = __webpack_require__(906);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__Contact__ = __webpack_require__(907);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__Contract__ = __webpack_require__(908);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_107__Contract__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__Copy__ = __webpack_require__(909);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__CreativeCommons__ = __webpack_require__(910);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__CreditCard__ = __webpack_require__(911);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__Css3__ = __webpack_require__(912);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__Cube__ = __webpack_require__(913);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__Cubes__ = __webpack_require__(914);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__Currency__ = __webpack_require__(915);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__Cursor__ = __webpack_require__(916);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__Cut__ = __webpack_require__(917);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__Cycle__ = __webpack_require__(918);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__Dashboard__ = __webpack_require__(919);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__Database__ = __webpack_require__(920);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__Debian__ = __webpack_require__(921);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__Deliver__ = __webpack_require__(922);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__Deploy__ = __webpack_require__(923);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__Descend__ = __webpack_require__(924);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__Desktop__ = __webpack_require__(925);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__Detach__ = __webpack_require__(926);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__Device__ = __webpack_require__(927);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__Diamond__ = __webpack_require__(928);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__Directions__ = __webpack_require__(929);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__Dislike__ = __webpack_require__(930);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__Docker__ = __webpack_require__(931);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__DocumentCloud__ = __webpack_require__(932);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__DocumentConfig__ = __webpack_require__(933);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__DocumentCsv__ = __webpack_require__(934);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__DocumentDownload__ = __webpack_require__(935);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__DocumentExcel__ = __webpack_require__(936);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__DocumentImage__ = __webpack_require__(937);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__DocumentLocked__ = __webpack_require__(938);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__DocumentMissing__ = __webpack_require__(939);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__DocumentNotes__ = __webpack_require__(940);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__DocumentOutlook__ = __webpack_require__(941);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__DocumentPdf__ = __webpack_require__(942);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__DocumentPerformance__ = __webpack_require__(943);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__DocumentPpt__ = __webpack_require__(944);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__DocumentRtf__ = __webpack_require__(945);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__DocumentSound__ = __webpack_require__(946);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__DocumentStore__ = __webpack_require__(947);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__DocumentTest__ = __webpack_require__(948);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__DocumentText__ = __webpack_require__(949);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__DocumentThreat__ = __webpack_require__(950);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__DocumentTime__ = __webpack_require__(951);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__DocumentTransfer__ = __webpack_require__(952);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__DocumentTxt__ = __webpack_require__(953);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__DocumentUpdate__ = __webpack_require__(954);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__DocumentUpload__ = __webpack_require__(955);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__DocumentUser__ = __webpack_require__(956);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__DocumentVerified__ = __webpack_require__(957);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__DocumentVideo__ = __webpack_require__(958);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__DocumentWindows__ = __webpack_require__(959);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__DocumentWord__ = __webpack_require__(960);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__DocumentZip__ = __webpack_require__(961);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__Document__ = __webpack_require__(962);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__Domain__ = __webpack_require__(963);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__Dos__ = __webpack_require__(964);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__Down__ = __webpack_require__(965);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__Download__ = __webpack_require__(966);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__Drag__ = __webpack_require__(967);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__Drawer__ = __webpack_require__(968);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__DriveCage__ = __webpack_require__(969);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__Dropbox__ = __webpack_require__(970);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__Duplicate__ = __webpack_require__(971);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__Dxc__ = __webpack_require__(972);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__Edge__ = __webpack_require__(973);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__Edit__ = __webpack_require__(974);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_173__Edit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__Eject__ = __webpack_require__(975);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__Elevator__ = __webpack_require__(976);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__Emergency__ = __webpack_require__(977);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__Emoji__ = __webpack_require__(978);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__EmptyCircle__ = __webpack_require__(979);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__Erase__ = __webpack_require__(980);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__Escalator__ = __webpack_require__(981);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__Expand__ = __webpack_require__(982);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_181__Expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__FacebookOption__ = __webpack_require__(983);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__Facebook__ = __webpack_require__(984);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__Fan__ = __webpack_require__(985);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__FastForward__ = __webpack_require__(986);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__Favorite__ = __webpack_require__(987);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__Fedora__ = __webpack_require__(988);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__Filter__ = __webpack_require__(989);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__FingerPrint__ = __webpack_require__(990);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__Fireball__ = __webpack_require__(991);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__Firefox__ = __webpack_require__(992);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__FlagFill__ = __webpack_require__(993);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__Flag__ = __webpack_require__(994);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__FolderCycle__ = __webpack_require__(995);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__FolderOpen__ = __webpack_require__(996);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__Folder__ = __webpack_require__(997);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__FormAdd__ = __webpack_require__(998);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__FormAttachment__ = __webpack_require__(999);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__FormCalendar__ = __webpack_require__(1000);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__FormCheckmark__ = __webpack_require__(1001);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__FormClock__ = __webpack_require__(1002);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__FormClose__ = __webpack_require__(1003);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__FormCut__ = __webpack_require__(1004);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__FormDown__ = __webpack_require__(1005);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__FormEdit__ = __webpack_require__(1006);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__FormFilter__ = __webpack_require__(1007);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__FormFolder__ = __webpack_require__(1008);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__FormLocation__ = __webpack_require__(1009);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__FormLock__ = __webpack_require__(1010);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__FormNextLink__ = __webpack_require__(1011);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__FormNext__ = __webpack_require__(1012);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__FormPreviousLink__ = __webpack_require__(1013);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__FormPrevious__ = __webpack_require__(1014);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__FormRefresh__ = __webpack_require__(1015);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__FormSchedule__ = __webpack_require__(1016);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__FormSearch__ = __webpack_require__(1017);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__FormSubtract__ = __webpack_require__(1018);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__FormTrash__ = __webpack_require__(1019);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__FormUp__ = __webpack_require__(1020);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__FormUpload__ = __webpack_require__(1021);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__FormViewHide__ = __webpack_require__(1022);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__FormView__ = __webpack_require__(1023);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__ForwardTen__ = __webpack_require__(1024);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__Freebsd__ = __webpack_require__(1025);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__Gallery__ = __webpack_require__(1026);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__Gamepad__ = __webpack_require__(1027);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__Gift__ = __webpack_require__(1028);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__Github__ = __webpack_require__(1029);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__Globe__ = __webpack_require__(1030);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_229__Globe__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__Golang__ = __webpack_require__(1031);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__GooglePlus__ = __webpack_require__(1032);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__GoogleWallet__ = __webpack_require__(1033);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__Google__ = __webpack_require__(1034);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__Gremlin__ = __webpack_require__(1035);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__Grid__ = __webpack_require__(1036);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__Grommet__ = __webpack_require__(1037);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__Group__ = __webpack_require__(1038);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__Grow__ = __webpack_require__(1039);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__Hadoop__ = __webpack_require__(1040);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__Halt__ = __webpack_require__(1041);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_240__Halt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__Help__ = __webpack_require__(1042);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__Heroku__ = __webpack_require__(1043);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__History__ = __webpack_require__(1044);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__Home__ = __webpack_require__(1045);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__Horton__ = __webpack_require__(1046);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__HostMaintenance__ = __webpack_require__(1047);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__Host__ = __webpack_require__(1048);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__Hp__ = __webpack_require__(1049);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__HpeLabs__ = __webpack_require__(1050);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__Hpe__ = __webpack_require__(1051);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__Hpi__ = __webpack_require__(1052);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__Html5__ = __webpack_require__(1053);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__IceCream__ = __webpack_require__(1054);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254__Image__ = __webpack_require__(1055);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255__Impact__ = __webpack_require__(1056);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256__InProgress__ = __webpack_require__(1057);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257__Inbox__ = __webpack_require__(1058);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258__Indicator__ = __webpack_require__(1059);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259__Info__ = __webpack_require__(1060);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260__Inherit__ = __webpack_require__(1061);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261__Inspect__ = __webpack_require__(1062);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262__Instagram__ = __webpack_require__(1063);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263__InstallOption__ = __webpack_require__(1064);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264__Install__ = __webpack_require__(1065);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265__Integration__ = __webpack_require__(1066);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266__InternetExplorer__ = __webpack_require__(1067);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267__Italic__ = __webpack_require__(1068);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268__Iteration__ = __webpack_require__(1069);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_268__Iteration__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269__Java__ = __webpack_require__(1070);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270__Language__ = __webpack_require__(1071);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271__Launch__ = __webpack_require__(1072);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272__Layer__ = __webpack_require__(1073);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273__License__ = __webpack_require__(1074);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274__Like__ = __webpack_require__(1075);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275__LineChart__ = __webpack_require__(1076);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276__LinkBottom__ = __webpack_require__(1077);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277__LinkDown__ = __webpack_require__(1078);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278__LinkNext__ = __webpack_require__(1079);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279__LinkPrevious__ = __webpack_require__(1080);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280__LinkTop__ = __webpack_require__(1081);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_280__LinkTop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281__LinkUp__ = __webpack_require__(1082);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282__Link__ = __webpack_require__(1083);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283__LinkedinOption__ = __webpack_require__(1084);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284__Linkedin__ = __webpack_require__(1085);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285__Local__ = __webpack_require__(1086);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286__LocationPin__ = __webpack_require__(1087);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287__Location__ = __webpack_require__(1088);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288__Lock__ = __webpack_require__(1089);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289__Login__ = __webpack_require__(1090);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290__Logout__ = __webpack_require__(1091);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291__Lounge__ = __webpack_require__(1092);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292__Magic__ = __webpack_require__(1093);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293__MailOption__ = __webpack_require__(1094);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294__Mail__ = __webpack_require__(1095);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295__Mandriva__ = __webpack_require__(1096);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296__Manual__ = __webpack_require__(1097);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297__MapLocation__ = __webpack_require__(1098);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298__Map__ = __webpack_require__(1099);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299__Mastercard__ = __webpack_require__(1100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300__Medium__ = __webpack_require__(1101);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301__Menu__ = __webpack_require__(1102);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_301__Menu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302__Microfocus__ = __webpack_require__(1103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303__Microphone__ = __webpack_require__(1104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304__Money__ = __webpack_require__(1105);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305__Monitor__ = __webpack_require__(1106);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306__Monospace__ = __webpack_require__(1107);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307__More__ = __webpack_require__(1108);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_307__More__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308__Multimedia__ = __webpack_require__(1109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309__Multiple__ = __webpack_require__(1110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310__Music__ = __webpack_require__(1111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311__Mysql__ = __webpack_require__(1112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312__Navigate__ = __webpack_require__(1113);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313__Network__ = __webpack_require__(1114);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314__NewWindow__ = __webpack_require__(1115);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315__New__ = __webpack_require__(1116);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316__Next__ = __webpack_require__(1117);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_317__Nodes__ = __webpack_require__(1118);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_318__Norton__ = __webpack_require__(1119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_319__Note__ = __webpack_require__(1120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_320__Notes__ = __webpack_require__(1121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_321__Notification__ = __webpack_require__(1122);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_322__ObjectGroup__ = __webpack_require__(1123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_323__ObjectUngroup__ = __webpack_require__(1124);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_324__OfflineStorage__ = __webpack_require__(1125);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_325__Onedrive__ = __webpack_require__(1126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_326__Opera__ = __webpack_require__(1127);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_327__Optimize__ = __webpack_require__(1128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_328__Oracle__ = __webpack_require__(1129);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_329__OrderedList__ = __webpack_require__(1130);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_330__Organization__ = __webpack_require__(1131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_331__Overview__ = __webpack_require__(1132);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_332__Paint__ = __webpack_require__(1133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_333__Pan__ = __webpack_require__(1134);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_334__PauseFill__ = __webpack_require__(1135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_335__Pause__ = __webpack_require__(1136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_336__Paypal__ = __webpack_require__(1137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_337__Performance__ = __webpack_require__(1138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_338__PersonalComputer__ = __webpack_require__(1139);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_339__PieChart__ = __webpack_require__(1140);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_340__PiedPiper__ = __webpack_require__(1141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_341__Pin__ = __webpack_require__(1142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_342__Pinterest__ = __webpack_require__(1143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_343__Plan__ = __webpack_require__(1144);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_344__PlayFill__ = __webpack_require__(1145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_345__Play__ = __webpack_require__(1146);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_346__Power__ = __webpack_require__(1147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_347__Previous__ = __webpack_require__(1148);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_348__Print__ = __webpack_require__(1149);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_349__ProductHunt__ = __webpack_require__(1150);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_350__Projects__ = __webpack_require__(1151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_351__RadialSelected__ = __webpack_require__(1152);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_352__Radial__ = __webpack_require__(1153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_353__Raspberry__ = __webpack_require__(1154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_354__Reactjs__ = __webpack_require__(1155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_355__Reddit__ = __webpack_require__(1156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_356__Redhat__ = __webpack_require__(1157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_357__Redo__ = __webpack_require__(1158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_358__Refresh__ = __webpack_require__(1159);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_359__Resources__ = __webpack_require__(1160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_360__Restaurant__ = __webpack_require__(1161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_361__RestroomMen__ = __webpack_require__(1162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_362__RestroomWomen__ = __webpack_require__(1163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_363__Restroom__ = __webpack_require__(1164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_364__Resume__ = __webpack_require__(1165);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_365__Return__ = __webpack_require__(1166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_366__Revert__ = __webpack_require__(1167);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_366__Revert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_367__Rewind__ = __webpack_require__(1168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_368__Risk__ = __webpack_require__(1169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_369__Robot__ = __webpack_require__(1170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_370__RotateLeft__ = __webpack_require__(1171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_371__RotateRight__ = __webpack_require__(1172);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_372__Rss__ = __webpack_require__(1173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_373__Run__ = __webpack_require__(1174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_374__SafariOption__ = __webpack_require__(1175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_375__Satellite__ = __webpack_require__(1176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_376__Save__ = __webpack_require__(1177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_377__Scan__ = __webpack_require__(1178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_378__ScheduleNew__ = __webpack_require__(1179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_379__SchedulePlay__ = __webpack_require__(1180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_380__Schedule__ = __webpack_require__(1181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_381__Schedules__ = __webpack_require__(1182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_382__Sco__ = __webpack_require__(1183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_383__Scorecard__ = __webpack_require__(1184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_384__SearchAdvanced__ = __webpack_require__(1185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_385__Search__ = __webpack_require__(1186);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_385__Search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_386__Secure__ = __webpack_require__(1187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_387__Select__ = __webpack_require__(1188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_388__Selection__ = __webpack_require__(1189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_389__Semantics__ = __webpack_require__(1190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_390__Send__ = __webpack_require__(1191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_391__ServerCluster__ = __webpack_require__(1192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_392__Server__ = __webpack_require__(1193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_393__Servers__ = __webpack_require__(1194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_394__ServicePlay__ = __webpack_require__(1195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_395__Services__ = __webpack_require__(1196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_396__SettingsOption__ = __webpack_require__(1197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_397__ShareOption__ = __webpack_require__(1198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_398__Share__ = __webpack_require__(1199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_399__ShieldSecurity__ = __webpack_require__(1200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_400__Shield__ = __webpack_require__(1201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_401__Shift__ = __webpack_require__(1202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_402__Shop__ = __webpack_require__(1203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_403__Sidebar__ = __webpack_require__(1204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_404__Sign__ = __webpack_require__(1205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_405__Skype__ = __webpack_require__(1206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_406__Slack__ = __webpack_require__(1207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_407__Snapchat__ = __webpack_require__(1208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_408__Solaris__ = __webpack_require__(1209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_409__Sort__ = __webpack_require__(1210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_410__Spa__ = __webpack_require__(1211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_411__Split__ = __webpack_require__(1212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_412__Splits__ = __webpack_require__(1213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_413__Square__ = __webpack_require__(1214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_414__StackOverflow__ = __webpack_require__(1215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_415__Stakeholder__ = __webpack_require__(1216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_416__StarHalf__ = __webpack_require__(1217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_417__Star__ = __webpack_require__(1218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_418__StatusCriticalSmall__ = __webpack_require__(1219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_419__StatusCritical__ = __webpack_require__(1220);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_419__StatusCritical__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_420__StatusDisabledSmall__ = __webpack_require__(1221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_421__StatusDisabled__ = __webpack_require__(1222);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_421__StatusDisabled__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_422__StatusGoodSmall__ = __webpack_require__(1223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_423__StatusGood__ = __webpack_require__(1224);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_423__StatusGood__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_424__StatusInfoSmall__ = __webpack_require__(1225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_425__StatusInfo__ = __webpack_require__(1226);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_425__StatusInfo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_426__StatusPlaceholderSmall__ = __webpack_require__(1227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_427__StatusPlaceholder__ = __webpack_require__(1228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_428__StatusUnknownSmall__ = __webpack_require__(1229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_429__StatusUnknown__ = __webpack_require__(1230);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_429__StatusUnknown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_430__StatusWarningSmall__ = __webpack_require__(1231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_431__StatusWarning__ = __webpack_require__(1232);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_431__StatusWarning__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_432__StepsOption__ = __webpack_require__(1233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_433__Steps__ = __webpack_require__(1234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_434__StopFill__ = __webpack_require__(1235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_435__Stop__ = __webpack_require__(1236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_436__Storage__ = __webpack_require__(1237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_437__StreetView__ = __webpack_require__(1238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_438__StrikeThrough__ = __webpack_require__(1239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_439__Stripe__ = __webpack_require__(1240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_440__Subscript__ = __webpack_require__(1241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_441__SubtractCircle__ = __webpack_require__(1242);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_441__SubtractCircle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_442__Subtract__ = __webpack_require__(1243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_443__Superscript__ = __webpack_require__(1244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_444__Support__ = __webpack_require__(1245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_445__Suse__ = __webpack_require__(1246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_446__Swift__ = __webpack_require__(1247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_447__Swim__ = __webpack_require__(1248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_448__Sync__ = __webpack_require__(1249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_449__System__ = __webpack_require__(1250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_450__TableAdd__ = __webpack_require__(1251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_451__Table__ = __webpack_require__(1252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_452__Tag__ = __webpack_require__(1253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_453__TapeOption__ = __webpack_require__(1254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_454__Tape__ = __webpack_require__(1255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_455__Target__ = __webpack_require__(1256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_456__Task__ = __webpack_require__(1257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_457__Tasks__ = __webpack_require__(1258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_458__Technology__ = __webpack_require__(1259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_459__Template__ = __webpack_require__(1260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_460__Terminal__ = __webpack_require__(1261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_461__TestDesktop__ = __webpack_require__(1262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_462__Test__ = __webpack_require__(1263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_463__TextAlignCenter__ = __webpack_require__(1264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_464__TextAlignFull__ = __webpack_require__(1265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_465__TextAlignLeft__ = __webpack_require__(1266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_466__TextAlignRight__ = __webpack_require__(1267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_467__TextWrap__ = __webpack_require__(1268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_468__Threats__ = __webpack_require__(1269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_469__ThreeDffects__ = __webpack_require__(1270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_470__ThreeD__ = __webpack_require__(1271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_471__Ticket__ = __webpack_require__(1272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_472__Tip__ = __webpack_require__(1273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_473__Toast__ = __webpack_require__(1274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_474__Tools__ = __webpack_require__(1275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_475__Tooltip__ = __webpack_require__(1276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_476__TopCorner__ = __webpack_require__(1277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_477__Train__ = __webpack_require__(1278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_478__Transaction__ = __webpack_require__(1279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_479__Trash__ = __webpack_require__(1280);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_479__Trash__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_480__TreeOption__ = __webpack_require__(1281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_481__Tree__ = __webpack_require__(1282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_482__Trigger__ = __webpack_require__(1283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_483__Trophy__ = __webpack_require__(1284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_484__Troubleshoot__ = __webpack_require__(1285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_485__Tty__ = __webpack_require__(1286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_486__Tumblr__ = __webpack_require__(1287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_487__Turbolinux__ = __webpack_require__(1288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_488__Twitter__ = __webpack_require__(1289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_489__Ubuntu__ = __webpack_require__(1290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_490__Underline__ = __webpack_require__(1291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_491__Undo__ = __webpack_require__(1292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_492__Unlink__ = __webpack_require__(1293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_493__Unlock__ = __webpack_require__(1294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_494__UnorderedList__ = __webpack_require__(1295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_495__Up__ = __webpack_require__(1296);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_496__Update__ = __webpack_require__(1297);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_497__Upgrade__ = __webpack_require__(1298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_498__Upload__ = __webpack_require__(1299);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_499__UserAdd__ = __webpack_require__(1300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_500__UserAdmin__ = __webpack_require__(1301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_501__UserExpert__ = __webpack_require__(1302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_502__UserFemale__ = __webpack_require__(1303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_503__UserManager__ = __webpack_require__(1304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_504__UserNew__ = __webpack_require__(1305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_505__UserPolice__ = __webpack_require__(1306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_506__UserSettings__ = __webpack_require__(1307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_507__UserWorker__ = __webpack_require__(1308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_508__User__ = __webpack_require__(1309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_509__Validate__ = __webpack_require__(1310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_510__Vend__ = __webpack_require__(1311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_511__Video__ = __webpack_require__(1312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_512__View__ = __webpack_require__(1313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_513__Vimeo__ = __webpack_require__(1314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_514__VirtualMachine__ = __webpack_require__(1315);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_515__VirtualStorage__ = __webpack_require__(1316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_516__Visa__ = __webpack_require__(1317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_517__VmMaintenance__ = __webpack_require__(1318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_518__Vmware__ = __webpack_require__(1319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_519__VolumeControl__ = __webpack_require__(1320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_520__VolumeLow__ = __webpack_require__(1321);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_521__VolumeMute__ = __webpack_require__(1322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_522__Volume__ = __webpack_require__(1323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_523__Vulnerability__ = __webpack_require__(1324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_524__Waypoint__ = __webpack_require__(1325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_525__WheelchairActive__ = __webpack_require__(1326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_526__Wheelchair__ = __webpack_require__(1327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_527__WifiLow__ = __webpack_require__(1328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_528__WifiMedium__ = __webpack_require__(1329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_529__WifiNone__ = __webpack_require__(1330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_530__Wifi__ = __webpack_require__(1331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_531__WindowsLegacy__ = __webpack_require__(1332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_532__Windows__ = __webpack_require__(1333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_533__Wordpress__ = __webpack_require__(1334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_534__Workshop__ = __webpack_require__(1335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_535__Yoga__ = __webpack_require__(1336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_536__Youtube__ = __webpack_require__(1337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_537__ZoomIn__ = __webpack_require__(1338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_538__ZoomOut__ = __webpack_require__(1339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_539__Blank__ = __webpack_require__(1340);
/* unused harmony namespace reexport */





























































































































































































































































































































































































































































































































































/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Accessibility */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Accessibility = function Accessibility(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Accessibility' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M4,8 L11,8 L11,14 L7,21 M20,8 L13,8 L13,14 L17,21 M12,5 C12.5522847,5 13,4.55228475 13,4 C13,3.44771525 12.5522847,3 12,3 C11.4477153,3 11,3.44771525 11,4 C11,4.55228475 11.4477153,5 12,5 Z M11,8 L13,8 L13,13 L11,13 L11,8 Z' })
  );
};

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Achievement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Achievement = function Achievement(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Achievement' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M10.3248685,14.7630919 C7.82620532,14.038202 6,11.7325889 6,9 L6,1 L18,1 L18,10 M6,3 L1,3 L1,7 C1,9.509 2.791,11 5,11 L6,11 M20.0335555,10.884915 C21.7416567,10.4908882 23,9.10306372 23,7 L23,3 L18,3 M10,19 L5,19 L5,23 L16.5,23 M16.5,10 C12.9101429,10 10,12.9101429 10,16.5 C10,20.0898571 12.9101429,23 16.5,23 C20.0898571,23 23,20.0898571 23,16.5 C23,12.9101429 20.0898571,10 16.5,10 L16.5,10 Z M20,14 L15.5,18.5 L13,16 M10.2056405,15.4240751 C8.89754812,16.0817472 8,17.4360568 8,19' })
  );
};

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Action */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Action = function Action(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Action' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,23 L4,20 L1,23 Z M20,4 L23,1 L20,4 Z M9,11 L12,8 L9,11 Z M13,15 L16,12 L13,15 Z M10,5 L19,14 L20,13 C22,11 24.0533047,8.00000006 20,4 C15.9466953,-5.91784286e-08 13,2 11,4 L10,5 Z M4,11 L5,10 L14,19 L13,20 C11.0000005,22 7.9999999,24.0873857 4,20 C9.84858655e-08,15.9126143 2,13 4,11 Z' })
  );
};

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Actions = function Actions(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Actions' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,17.5 C15.0375661,17.5 17.5,15.0375661 17.5,12 C17.5,8.96243388 15.0375661,6.5 12,6.5 C8.96243388,6.5 6.5,8.96243388 6.5,12 C6.5,15.0375661 8.96243388,17.5 12,17.5 Z M12,6.5 L12,1 M12,23 L12,17.5 M1,12 L6.5,12 M17.5,12 L23,12 M4.4375,4.4375 L8.5625,8.5625 M15.4375,15.4375 L19.5625,19.5625 M19.5625,4.4375 L15.4375,8.5625 M8.5625,15.4375 L4.4375,19.5625' })
  );
};

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Ad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Ad = function Ad(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Ad' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M10,10 L14,10 L14,14 L10,14 L10,10 Z M14,18 L10,18 C7.790861,18 6,16.209139 6,14 L6,10 C6,7.790861 7.790861,6 10,6 L10,6 L14,6 C16.209139,6 18,7.790861 18,10 L18,14 M14,22 L10,22 C5.581722,22 2,18.418278 2,14 L2,10 C2,5.581722 5.581722,2 10,2 L10,2 L14,2 C18.418278,2 22,5.581722 22,10 L22,14' })
  );
};

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddCircle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var AddCircle = function AddCircle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'AddCircle' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,18 L12,6 M6,12 L18,12' })
  );
};

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Add */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Add = function Add(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Add' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 L12,2 M2,12 L22,12' })
  );
};

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Aed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Aed = function Aed(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Aed' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,8.4 C2,4 5,3 7,3 C9,3 11,5 12,6.5 C13,5 15,3 17,3 C19,3 22,4 22,8.4 C22,15 12,21 12,21 C12,21 2,15 2,8.4 Z M12,6 C11.5,5.5 10,10 10,10 L12,10 L12,12.5 L14,9 L12,9 C12,9 13,3 17,3 C13,3 12,6 12,6 Z' })
  );
};

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Aggregate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Aggregate = function Aggregate(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Aggregate' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,9 L9,9 L9,16 L9,16 C9,19.8659932 12.1340068,23 16,23 L16,23 C19.8659932,23 23,19.8659932 23,16 C23,12.1340068 19.8659932,9 16,9 L16,9 Z M8,15 L15,15 L15,8 L15,8 C15,4.13400675 11.8659932,1 8,1 L8,1 C4.13400675,1 1,4.13400675 1,8 C1,11.8659932 4.13400675,15 8,15 L8,15 Z', transform: 'rotate(180 12 12)' })
  );
};

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AidOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var AidOption = function AidOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'AidOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,9 L12,19 L12,9 Z M17,14 L7,14 L17,14 Z M1,6.99508929 C1,5.8932319 1.88967395,5 2.991155,5 L21.008845,5 C22.1085295,5 23,5.8926228 23,6.99508929 L23,21.0049107 C23,22.1067681 22.1103261,23 21.008845,23 L2.991155,23 C1.89147046,23 1,22.1073772 1,21.0049107 L1,6.99508929 Z M7,5 L7,2.0093689 C7,1.45190985 7.4556644,1 7.99539757,1 L16.0046024,1 C16.5543453,1 17,1.44335318 17,2.0093689 L17,5' })
  );
};

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Aid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Aid = function Aid(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Aid' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,22 L23,22 L23,6 L1,6 L1,22 Z M8,6 L16,6 L16,2 L8,2 L8,6 Z M8,14 L16,14 M12,10 L12,18' })
  );
};

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Alarm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Alarm = function Alarm(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Alarm' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M21,13 C21,17.971 16.971,22 12,22 C7.029,22 3,17.971 3,13 C3,8.029 7.029,4 12,4 C16.971,4 21,8.029 21,13 L21,13 Z M5.5,19.5 L2,23 L5.5,19.5 Z M18.5,19.5 L22,23 L18.5,19.5 Z M9,4 C8.29078014,2.90780142 6.88179669,2 5,2 C2.90070922,2 1,3.90070922 1,6 C1,7.88179669 1.90780142,9.29078014 3,10 M21,10 C22.0921986,9.29078014 23,7.88179669 23,6 C23,3.90070922 21.0992908,2 19,2 C17.1182033,2 15.7092199,2.90780142 15,4 M12,8 L12,13 L15,16' })
  );
};

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Alert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Alert = function Alert(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Alert' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,17 L12,19 M12,10 L12,16 M12,3 L2,22 L22,22 L12,3 Z' })
  );
};

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Amazon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Amazon = function Amazon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Amazon' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#F90', fillRule: 'evenodd', d: 'M11.9924596,23.9397465 C8.83711397,23.9185077 6.03567124,22.8789612 3.53203329,20.9850151 C2.63838806,20.3088366 1.82646601,19.5437784 1.08564773,18.7032301 C1.0593301,18.6732188 1.01408224,18.6445926 1.01108111,18.6122727 C0.999538287,18.4963828 1.00253942,18.3793386 1,18.2627561 C1.10019169,18.278916 1.21815932,18.2662189 1.29780479,18.3156222 C1.96751928,18.7327798 2.61183957,19.1935692 3.29817573,19.5802537 C5.2872347,20.7005999 7.41480753,21.4266434 9.67581537,21.7720046 C10.8557226,21.9520726 12.0409395,22.0114027 13.2256946,21.9426075 C15.4894728,21.8114811 17.6530592,21.2481914 19.7120677,20.2936001 C20.0373444,20.1428508 20.3561571,19.9780193 20.6756624,19.8152656 C20.8303362,19.7363127 20.9829323,19.7039928 21.1142896,19.8425066 C21.2530343,19.9886387 21.247032,20.165013 21.1503032,20.3279977 C21.0948977,20.4217254 21.0106351,20.5020634 20.9279885,20.5757066 C19.0869085,22.2092467 16.9334797,23.2123179 14.5316495,23.6788787 C13.7001046,23.8404782 12.8480135,23.8958838 12.0051567,24 C12.0010013,23.9799155 11.996615,23.959831 11.9924596,23.9397465 M20.882048,18.8454608 C20.4263375,18.8890927 19.9207619,18.9387268 19.4149554,18.9848981 C19.3041444,18.9950558 19.1914864,19.0015197 19.0806753,18.9948249 C18.9532426,18.9872066 18.9329272,18.9087155 19.0026459,18.8159112 C19.0442,18.7605056 19.1065313,18.718028 19.1653996,18.6783207 C19.7005248,18.3191081 20.3062921,18.1618949 20.9339907,18.0787866 C21.5298312,17.9998337 22.124979,18.0183022 22.7074298,18.1743612 C23.1005783,18.2796317 23.186226,18.3269573 23.1569073,18.7845147 C23.0793395,19.9902778 22.691039,21.086615 21.8167857,21.9673322 C21.7719996,22.0125801 21.7297528,22.0707559 21.6743473,22.0926873 C21.6004732,22.1217752 21.5148255,22.1213135 21.4342566,22.1335489 C21.4361035,22.0601365 21.4208669,21.9809528 21.4427983,21.9142353 C21.6512617,21.2800727 21.8689593,20.6489112 22.0762683,20.0145177 C22.1178225,19.8873158 22.1335207,19.750418 22.1494498,19.6165213 C22.2002382,19.1887443 22.0291736,18.9735861 21.575079,18.9070995 C21.3631528,18.8761647 21.1479946,18.8683156 20.882048,18.8454608 M13.9965473,9.42010077 C13.1377614,9.41525279 12.3166051,9.45242067 11.5310007,9.71582785 C11.142931,9.84603088 10.7495517,10.0110932 10.4155024,10.2426422 C9.49276931,10.8818837 9.25267863,11.8334739 9.32863039,12.8935666 C9.36879941,13.4550094 9.53755546,13.9746672 9.95171189,14.381898 C10.5401649,14.9604242 11.5307698,15.0363759 12.3260702,14.5663522 C13.0193321,14.1565821 13.4325651,13.5242663 13.7008203,12.7873726 C14.0960465,11.7021166 13.9716148,10.5713818 13.9965473,9.42010077 M14.6290939,15.7725771 C14.3204389,16.0535293 14.0353312,16.3183217 13.744683,16.5768809 C12.627107,17.5707178 11.3066083,18.0146547 9.82427914,18.0444352 C9.01951364,18.0605951 8.22929209,17.9998799 7.47600757,17.7023059 C6.13427002,17.1720287 5.2787161,16.1915815 4.93173889,14.8002098 C4.5009608,13.0722494 4.64640035,11.4084672 5.66886346,9.89797358 C6.4246874,8.7815519 7.51779258,8.11783967 8.77988467,7.71153236 C9.86283216,7.36293915 10.983871,7.2101122 12.1092961,7.08406459 C12.726837,7.01480766 13.3450705,6.953169 13.9928536,6.88506635 C13.9734617,6.11169732 14.0833494,5.33578887 13.8116313,4.5880449 C13.5708481,3.92571782 13.0622714,3.58520459 12.3976357,3.43283935 C11.3913326,3.20221378 10.250671,3.57758633 9.70977435,4.37103986 C9.52624349,4.64044931 9.41404727,4.9684963 9.31547158,5.28407703 C9.17649601,5.72870651 8.97195721,5.87345349 8.51024436,5.81850966 C7.60782659,5.71162313 6.70333111,5.62297427 5.80091334,5.51747288 C5.35328272,5.46483761 5.17575413,5.20997212 5.26301786,4.77503861 C5.65986006,2.79567561 6.80629307,1.4123839 8.67207471,0.684262729 C10.8742142,-0.174984891 13.1252952,-0.241702398 15.3569843,0.578992199 C17.2063751,1.25909523 18.2221434,2.61445331 18.3574252,4.59243118 C18.402904,5.26006796 18.4093679,5.9311676 18.4121382,6.60088209 C18.4192948,8.33299786 18.4276056,10.0651136 18.4093679,11.7969985 C18.3992103,12.7615167 18.6667729,13.6175323 19.2531482,14.3791277 C19.3939706,14.5624277 19.5366399,14.7461894 19.6559926,14.9433408 C19.8538366,15.2702335 19.8009705,15.5181733 19.5149394,15.7649588 C18.7780456,16.4007374 18.0425371,17.0383629 17.3074902,17.67645 C16.9027989,18.0275826 16.6223083,18.0227347 16.2153085,17.6799129 C15.679029,17.2281268 15.2385549,16.6964645 14.8583344,16.1110126 C14.7890775,16.0043569 14.715896,15.9002407 14.6290939,15.7725771' })
  );
};

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Amex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Amex = function Amex(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Amex' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#002663', fillRule: 'evenodd', d: 'M4.31351102,11.9651322 L3.49408345,9.96838176 L2.67933919,11.9651322 L4.31351102,11.9651322 Z M12.1730058,14.1264026 L12.1684736,10.2036046 L10.4324776,14.1264026 L9.38130189,14.1264026 L7.64077369,10.2001299 L7.64077369,14.1264026 L5.20575645,14.1264026 L4.74573489,13.0092074 L2.25300723,13.0092074 L1.78830236,14.1264026 L0.488004966,14.1264026 L2.63190183,9.11768179 L4.41065186,9.11768179 L6.44683267,13.8599073 L6.44683267,9.11768179 L8.40082901,9.11768179 L9.96762165,12.5154962 L11.4069075,9.11768179 L13.4001832,9.11768179 L13.4001832,14.1264026 L12.1730058,14.1264026 Z M15.3055732,13.1015049 L15.3055732,12.104716 L17.9339657,12.104716 L17.9339657,11.0825466 L15.3055732,11.0825466 L15.3055732,10.171719 L18.3071194,10.171719 L19.6166324,11.6317021 L18.2491069,13.1015049 L15.3055732,13.1015049 Z M23.4171068,14.1455801 L21.8614469,14.1455801 L20.3872629,12.4870853 L18.8552174,14.1455801 L14.1129918,14.1455801 L14.1129918,9.13565077 L18.9281863,9.13565077 L20.4011617,10.7778295 L21.9239917,9.13565077 L23.488005,9.13565077 L21.1613628,11.6406155 L23.4171068,14.1455801 Z' })
  );
};

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Analytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Analytics = function Analytics(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Analytics' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M20,7 C21.25,8.67 22,10.75 22,13 C22,18.52 17.52,23 12,23 C6.48,23 2,18.52 2,13 C2,7.48 6.48,3 12,3 M12,1 L12,13 L21.6,5.8 C19.41,2.89 15.92,1 12,1 L12,1 Z' })
  );
};

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Anchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Anchor = function Anchor(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Anchor' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,6 C13.1045695,6 14,5.1045695 14,4 C14,2.8954305 13.1045695,2 12,2 C10.8954305,2 10,2.8954305 10,4 C10,5.1045695 10.8954305,6 12,6 Z M20,17 C20.5522847,17 21,16.5522847 21,16 C21,15.4477153 20.5522847,15 20,15 C19.4477153,15 19,15.4477153 19,16 C19,16.5522847 19.4477153,17 20,17 Z M4,17 C4.55228475,17 5,16.5522847 5,16 C5,15.4477153 4.55228475,15 4,15 C3.44771525,15 3,15.4477153 3,16 C3,16.5522847 3.44771525,17 4,17 Z M12,6 L12,21 M4,15.9733241 C6.19364176,19.3244414 8.86035276,21 12.000133,21 C15.1399132,21 17.8065356,19.3244414 20,15.9733241 M16,10 L8,10' })
  );
};

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Android */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Android = function Android(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Android' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#A4C639', fillRule: 'evenodd', d: 'M5.68524564,7.91390616 L18.4032637,7.91390616 L18.4032637,18.2777185 C18.4032637,18.8934049 17.9041016,19.392567 17.2891666,19.392567 L16.0152889,19.392567 L16.0152889,22.54887 C16.0152889,23.3504036 15.3759782,24 14.5867968,24 C13.7955958,24 13.1572245,23.3504036 13.1572245,22.54887 L13.1572245,19.392567 L10.9323651,19.392567 L10.9323651,22.54887 C10.9323651,23.3504036 10.2917863,24 9.50265183,24 C8.71365828,24 8.07312646,23.3504036 8.07312646,22.54887 L8.07312646,19.392567 L6.80037593,19.392567 C6.18530006,19.392567 5.68519867,18.8934049 5.68519867,18.2777185 L5.68519867,7.91390616 L5.68524564,7.91390616 Z M3.19295784,7.82931914 C2.39574512,7.82931914 1.75,8.48511514 1.75,9.2946801 L1.75,15.0216583 C1.75,15.8302839 2.39574512,16.4872071 3.19295784,16.4872071 C3.99031146,16.4872071 4.63591568,15.8302839 4.63591568,15.0216583 L4.63591568,9.2946801 C4.63591568,8.48511514 3.99031146,7.82931914 3.19295784,7.82931914 L3.19295784,7.82931914 Z M18.4033106,6.86955468 L5.68524564,6.86955468 C5.84220834,5.05767343 7.01754994,3.49847301 8.70952521,2.59567916 L7.50032062,0.820150132 C7.33725225,0.580713909 7.39877862,0.254013563 7.63868451,0.0909921564 C7.8783086,-0.07202925 8.20435141,-0.0100332096 8.36821822,0.229215147 L9.68615071,2.16574601 C10.4168586,1.91306518 11.2100322,1.76798505 12.0442547,1.76798505 C12.8794634,1.76798505 13.672684,1.91306518 14.4033449,2.16607478 L15.7212774,0.229919647 C15.8831246,-0.00998624287 16.2102007,-0.0719822833 16.4498248,0.0910391231 C16.6897307,0.25406053 16.7512571,0.580760876 16.5881887,0.820197099 L15.3799704,2.59572613 C17.0718987,3.49795638 18.2464419,5.0571568 18.4033106,6.86955468 L18.4033106,6.86955468 Z M10.0653129,4.40760737 C10.0653129,4.01905189 9.75068296,3.70390535 9.36226837,3.70390535 C8.97286748,3.70390535 8.65823758,4.01905189 8.65823758,4.40760737 C8.65823758,4.79597499 8.97390075,5.11098063 9.36226837,5.11098063 C9.75063599,5.11098063 10.0653129,4.79597499 10.0653129,4.40760737 L10.0653129,4.40760737 Z M15.5194145,4.40760737 C15.5194145,4.01905189 15.2037044,3.70390535 14.8153837,3.70390535 C14.4259828,3.70390535 14.1122923,4.01905189 14.1122923,4.40760737 C14.1122923,4.79597499 14.4259828,5.11098063 14.8153837,5.11098063 C15.2037514,5.11098063 15.5194145,4.79597499 15.5194145,4.40760737 L15.5194145,4.40760737 Z M20.8965378,7.82729957 C20.1001704,7.82729957 19.4525936,8.48408187 19.4525936,9.2936938 L19.4525936,15.0226915 C19.4525936,15.8323035 20.1001704,16.4892736 20.8965378,16.4892736 C21.6939384,16.4892736 22.3384623,15.8323504 22.3384623,15.0226915 L22.3384623,9.2936938 C22.3385093,8.48408187 21.6939384,7.82729957 20.8965378,7.82729957 L20.8965378,7.82729957 Z' })
  );
};

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Announce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Announce = function Announce(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Announce' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M11,15 C14,15 19,19 19,19 L19,3 C19,3 14,7 11,7 C11,7 11,15 11,15 Z M5,15 L8,23 L12,23 L9,15 M19,14 C20.657,14 22,12.657 22,11 C22,9.343 20.657,8 19,8 M11,19 C11.9999997,18.9999994 14,18 14,16 M2,11 C2,7.88888889 3.7912,7 6,7 L11,7 L11,15 L6,15 C3.7912,15 2,14.1111111 2,11 Z' })
  );
};

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Apple */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Apple = function Apple(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Apple' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#AAA', fillRule: 'evenodd', d: 'M15.3007013,3.832 C16.1387013,2.818 16.7027013,1.405 16.5487013,0 C15.3407013,0.049 13.8797013,0.805 13.0137013,1.819 C12.2367013,2.717 11.5567013,4.154 11.7407013,5.531 C13.0867013,5.636 14.4627013,4.847 15.3007013,3.832 M18.3207013,12.75 C18.3547013,16.382 21.5067013,17.591 21.5417013,17.607 C21.5157013,17.692 21.0387013,19.329 19.8807013,21.02 C18.8807013,22.482 17.8427013,23.939 16.2067013,23.969 C14.5997013,23.998 14.0837013,23.016 12.2457013,23.016 C10.4097013,23.016 9.83570131,23.939 8.31370131,23.998 C6.73570131,24.058 5.53370131,22.417 4.52470131,20.961 C2.46370131,17.981 0.888701307,12.541 3.00370131,8.869 C4.05470131,7.045 5.93170131,5.89 7.96970131,5.861 C9.51970131,5.831 10.9827013,6.904 11.9307013,6.904 C12.8777013,6.904 14.6557013,5.614 16.5247013,5.803 C17.3077013,5.836 19.5037013,6.119 20.9147013,8.184 C20.8007013,8.254 18.2937013,9.714 18.3207013,12.75' })
  );
};

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Apps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Apps = function Apps(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Apps' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M19,5 L21,5 L21,3 L19,3 L19,5 Z M11,5 L13,5 L13,3 L11,3 L11,5 Z M3,5 L5,5 L5,3 L3,3 L3,5 Z M19,13 L21,13 L21,11 L19,11 L19,13 Z M11,13 L13,13 L13,11 L11,11 L11,13 Z M3,13 L5,13 L5,11 L3,11 L3,13 Z M19,21 L21,21 L21,19 L19,19 L19,21 Z M11,21 L13,21 L13,19 L11,19 L11,21 Z M3,21 L5,21 L5,19 L3,19 L3,21 Z' })
  );
};

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Archive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Archive = function Archive(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Archive' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,23 L21,23 L21,6 L3,6 L3,23 Z M9,14 L15,14 L15,10 L9,10 L9,14 Z M1,6 L23,6 L23,1 L1,1 L1,6 Z' })
  );
};

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Archlinux */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Archlinux = function Archlinux(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Archlinux' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#1793D1', fillRule: 'evenodd', d: 'M11.995499,0 C10.9272763,2.61898783 10.2829772,4.33212022 9.09364861,6.87325951 C9.82285899,7.64621596 10.7179267,8.54636058 12.1714997,9.56299285 C10.6087581,8.91993273 9.54277553,8.27431817 8.74615646,7.60436135 C7.22404876,10.7804724 4.83934636,15.3047005 0,24 C3.8035621,21.8041428 6.75200705,20.4503725 9.49981901,19.9338097 C9.38183641,19.4263273 9.31474077,18.8773854 9.31929729,18.3046251 L9.32381903,18.1827747 C9.38418076,15.7459387 10.6518189,13.8720119 12.1534614,13.9992474 C13.6551031,14.1264836 14.8223099,16.2062608 14.7619552,18.6430989 C14.7506091,19.1016345 14.6988943,19.5427398 14.6085152,19.9518612 C17.3264906,20.483546 20.2434156,21.8338506 23.9955134,24 C23.2556658,22.6379048 22.5952972,21.4100753 21.9646676,20.2406911 C20.9713321,19.4707837 19.9352208,18.4687462 17.8217601,17.3839783 C19.2744348,17.7614433 20.3145182,18.1969375 21.1252451,18.6837145 C14.7134752,6.74608943 14.1942543,5.15982659 11.995499,0 L11.995499,0 Z' })
  );
};

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Article */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Article = function Article(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Article' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,7 L19,7 L19,11 L16,11 L16,7 Z M9,15 L20,15 M9,11 L13,11 M9,7 L13,7 M6,18.5 C6,19.8807119 4.88071187,21 3.5,21 C2.11928813,21 1,19.8807119 1,18.5 L1,7 L6.02493781,7 M6,18.5 L6,3 L23,3 L23,18.5 C23,19.8807119 21.8807119,21 20.5,21 L3.5,21' })
  );
};

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Aruba */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Aruba = function Aruba(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Aruba' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#FF8300', fillRule: 'evenodd', d: 'M12.1099561,17.3015551 C9.03598293,17.3015551 6.50849391,14.8423766 6.50849391,11.836714 C6.50849391,8.83105139 9.03598293,6.37187289 12.1099561,6.37187289 C15.1839292,6.37187289 17.7114182,8.83105139 17.7114182,11.836714 C17.7114182,14.8423766 15.1839292,17.3015551 12.1099561,17.3015551 L12.1099561,17.3015551 Z M12.1099561,2 C6.50849391,2 2,6.4401834 2,11.836714 C2,17.3015551 6.50849391,21.673428 12.1099561,21.673428 C14.4325135,21.673428 16.5501395,20.9220123 18.2579023,19.6241126 C19.28256,21.3318754 22.2199121,21.673428 22.2199121,21.673428 L22.2199121,11.836714 C22.2199121,6.4401834 17.7114182,2 12.1099561,2 L12.1099561,2 Z' })
  );
};

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Ascend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Ascend = function Ascend(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Ascend' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,8 L8,2 L14,8 M11,21 L22,21 M11,17 L19,17 M11,13 L16,13 M8,2 L8,22' })
  );
};

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AssistListening */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var AssistListening = function AssistListening(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'AssistListening' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M11,21 C11.7572165,21.6666667 12.4238831,22 13,22 C15,22 16,21 16,19 C16,17.6666667 16.6666667,16.3333333 18,15 C19.2667508,13.7332492 20,11.9329966 20,10 C20,6.13400675 16.8659932,3 13,3 C9.13400675,3 6,6.13400675 6,10 M17,10 C17,7.790861 15.209139,6 13,6 C10.790861,6 9,7.790861 9,10 M3,20 L8,14 L9,18 L14,12' })
  );
};

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Atm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Atm = function Atm(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Atm' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4,10 L1,10 L1,6 L23,6 L23,10 L20,10 M6,6 L18,6 L18,20.0059397 C18,21.1072288 17.0980496,22 15.9914698,22 L8.0085302,22 C6.8992496,22 6,21.1054862 6,20.0059397 L6,6 Z M13,18 L16,18 M13,15 L16,15 M13,12 L16,12 M10,22 L10,6 M3,2 L6,2 M8,2 L11,2 M13,2 L16,2 M18,2 L21,2' })
  );
};

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Attachment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Attachment = function Attachment(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Attachment' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M22,12 C22,12 19.0000009,15.0000004 13.0000004,21.0000004 C6.99999996,27.0000004 -2.00000007,18.0000004 3.99999994,12.0000004 C9.99999996,6.00000037 9,7.00000011 13,3.00000008 C17,-0.999999955 23,4.99999994 19,9.00000005 C15,13.0000002 12.0000004,16.0000007 9.99999995,18.0000004 C7.99999952,20 5,17 6.99999995,15.0000004 C8.99999991,13.0000007 16,6 16,6' })
  );
};

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Attraction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Attraction = function Attraction(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Attraction' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M13,2 L14.5,2.5 L13,3 L13,2 Z M14,18 L15,23 L13,23 L14,18 Z M14,16.5 L16,23 L12,23 L14,16.5 Z M12,6 L21,11 L21,13 L3,13 L3,11 L12,6 Z M4.5,13 L19.5,13 C19.5,17.1666667 21,23 21,23 L3,23 C3,23 4.5,17.1666667 4.5,13 Z M4.5,13 L19.5,13 C19.5,17.1666667 21,23 21,23 L3,23 C3,23 4.5,17.1666667 4.5,13 Z' })
  );
};

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Baby */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Baby = function Baby(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Baby' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M10,15 L14,15 C14,15 13,16.5 12,16.5 C11,16.5 10,15 10,15 Z M12,6 C12.5522847,6 13,5.55228475 13,5 C13,4.44771525 12.5522847,4 12,4 C11.4477153,4 11,4.44771525 11,5 C11,5.55228475 11.4477153,6 12,6 Z M18,12 L14,9 M14,15 L17,17.5 L14.5,20 M6,12 L10,9 M10,15 L7.5,17.75 L10,20 M10,9 L14,9 L14,12 L10,12 L10,9 Z' })
  );
};

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BackTen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var BackTen = function BackTen(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'BackTen' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3.11111111,7.55555556 C4.66955145,4.26701301 8.0700311,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 L12,22 C6.4771525,22 2,17.5228475 2,12 M2,4 L2,8 L6,8 M9,16 L9,9 L7,9.53333333 M17,12 C17,10 15.9999999,8.5 14.5,8.5 C13.0000001,8.5 12,10 12,12 C12,14 13,15.5000001 14.5,15.5 C16,15.4999999 17,14 17,12 Z M14.5,8.5 C16.9253741,8.5 17,11 17,12 C17,13 17,15.5 14.5,15.5 C12,15.5 12,13 12,12 C12,11 12.059,8.5 14.5,8.5 Z' })
  );
};

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BarChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var BarChart = function BarChart(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'BarChart' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M0,22 L24,22 M22,2 L18,2 L18,18 L22,18 L22,2 Z M6,6 L2,6 L2,18 L6,18 L6,6 Z M14,18 L10,18 L10,10 L14,10 L14,18 Z' })
  );
};

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Bar = function Bar(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Bar' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,5 L23,5 L23,23 L7,23 L7,5 Z M7,5 L23,5 L23,3 C23,1.8954305 22.1054862,1 21.0059397,1 L8.99406028,1 C7.8927712,1 7,1.88772964 7,3 L7,5 Z M1,8.0085302 C1,6.8992496 1.89826062,6 2.99791312,6 L7,6 L7,18 L2.99791312,18 C1.89449617,18 1,17.0980496 1,15.9914698 L1,8.0085302 Z M11,8 L11,18 M15,8 L15,18 M19,8 L19,18' })
  );
};

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Basket */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Basket = function Basket(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Basket' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,12 L22,12 L20,23 L4,23 L2,12 Z M20,8 L14,1 M4,8 L10,1 M1,8 L23,8 L23,12 L1,12 L1,8 Z M8,15 L8,20 M16,15 L16,20 M12,15 L12,20' })
  );
};

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Bike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Bike = function Bike(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Bike' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,19 C7.209139,19 9,17.209139 9,15 C9,12.790861 7.209139,11 5,11 C2.790861,11 1,12.790861 1,15 C1,17.209139 2.790861,19 5,19 Z M19,19 C21.209139,19 23,17.209139 23,15 C23,12.790861 21.209139,11 19,11 C16.790861,11 15,12.790861 15,15 C15,17.209139 16.790861,19 19,19 Z M5,6 L10,6 M19,15 L16,5 L13,5 M9,9 L5,15 L12,15 C12,12 14,9 17,9 L16,9 L9,9 Z M9,9 L7,6' })
  );
};

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Bitcoin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Bitcoin = function Bitcoin(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Bitcoin' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#F90', fillRule: 'evenodd', d: 'M23.6408156,14.9046858 C22.0378949,21.3339956 15.5260763,25.2467873 9.09601649,23.6434916 C2.66858193,22.0405708 -1.24420981,15.5283772 0.359460996,9.09944253 C1.96163164,2.66938268 8.47345019,-1.24378409 14.9016348,0.359136628 C21.3313196,1.96205735 25.2437363,8.47500102 23.6408156,14.9046858 L23.6408156,14.9046858 Z M17.2913894,10.2916945 C17.5302898,8.69477443 16.3144103,7.83630799 14.6518582,7.263622 L15.1911657,5.1003916 L13.8744004,4.77223165 L13.3493445,6.87845598 C13.0031826,6.79219679 12.6476448,6.71081312 12.2943571,6.63017953 L12.8231635,4.51007873 L11.5071483,4.18191878 L10.9674658,6.3443991 C10.6809353,6.27914215 10.3996553,6.21463528 10.1266263,6.14675305 L10.1281264,6.14000233 L8.31218301,5.68657903 L7.9618957,7.09297883 C7.9618957,7.09297883 8.93887476,7.31687767 8.91824756,7.33075415 C9.45155436,7.46389333 9.54793963,7.81680592 9.53181291,8.09658572 L8.91749748,10.5609732 C8.9542514,10.5703492 9.00188147,10.5838506 9.05438706,10.6048529 C9.01050739,10.5939767 8.96362739,10.5819754 8.91524724,10.5703492 L8.05415553,14.0225919 C7.98889858,14.1846091 7.82350596,14.427635 7.45071626,14.3353752 C7.46384266,14.3545022 6.49361432,14.0964747 6.49361432,14.0964747 L5.8399197,15.6037603 L7.5534772,16.0309308 C7.87226116,16.1108143 8.18466943,16.1944482 8.49220218,16.2732066 L7.94726915,18.4611896 L9.26253423,18.7893496 L9.80221671,16.624619 C10.161505,16.7221294 10.5102921,16.812139 10.8515785,16.896898 L10.3137712,19.0515025 L11.6305364,19.3796624 L12.1754695,17.1958048 C14.4208336,17.6207251 16.1092634,17.4493318 16.8199641,15.4184905 C17.3926501,13.7833164 16.7914611,12.8400909 15.6100853,12.2250254 C16.4704269,12.0266293 17.1184959,11.460694 17.2913894,10.2916945 L17.2913894,10.2916945 Z M14.2828189,14.5105188 C13.8759006,16.145693 11.1227324,15.2617238 10.2301373,15.0400752 L10.9532143,12.1413915 C11.8458094,12.3641652 14.7081142,12.8052122 14.2828189,14.5105188 L14.2828189,14.5105188 Z M14.6901123,10.268067 C14.3188228,11.7554754 12.0273287,10.9997699 11.2839995,10.8145002 L11.9395694,8.18547018 C12.6828985,8.37073991 15.0767785,8.71652674 14.6901123,10.268067 L14.6901123,10.268067 Z' })
  );
};

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BlockQuote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var BlockQuote = function BlockQuote(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'BlockQuote' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M.78,8.89c0-3.07,1.53-4.3,4.3-4.34L5.38,6C3.78,6.17,3,7,3.1,8.31H4.54V12H.78Zm5.9,0c0-3.07,1.53-4.3,4.3-4.34L11.28,6C9.68,6.17,8.89,7,9,8.31h1.44V12H6.68Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M16.94,15.11c0,3.07-1.53,4.3-4.3,4.34L12.35,18c1.6-.16,2.39-1,2.28-2.3H13.18V12h3.76Zm5.9,0c0,3.07-1.53,4.3-4.3,4.34L18.24,18c1.6-.16,2.39-1,2.28-2.3H19.08V12h3.76Z' })
  );
};

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Blog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Blog = function Blog(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Blog' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,16 C3.343,16 2,17.343 2,19 C2,20.657 3.343,22 5,22 C6.657,22 8,20.657 8,19 C8,17.343 6.657,16 5,16 L5,16 L5,16 Z M5,1 C14.925,1 23,9.075 23,19 L23,19 M18,19 C18,11.832 12.168,6 5,6 M13,19 C13,14.589 9.411,11 5,11 M2,11 L2,19 L2,19' })
  );
};

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Bluetooth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Bluetooth = function Bluetooth(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Bluetooth' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7 7 17 16 12 20 12 4 17 8 7 16' })
  );
};

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Bold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Bold = function Bold(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Bold' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M14,11.57a7.93,7.93,0,0,1,3.11,1.25,3.32,3.32,0,0,1,1.28,2.71A3.58,3.58,0,0,1,17,18.42a7.9,7.9,0,0,1-5,1.39H4.07v-.42a3.57,3.57,0,0,0,1.46-.2,1.17,1.17,0,0,0,.54-.52,4.75,4.75,0,0,0,.15-1.58V7A4.81,4.81,0,0,0,6.07,5.4a1.13,1.13,0,0,0-.54-.52,3.67,3.67,0,0,0-1.46-.2V4.26h7.45a10.57,10.57,0,0,1,3.78.48,3.94,3.94,0,0,1,1.75,1.42,3.52,3.52,0,0,1,.64,2,2.86,2.86,0,0,1-.81,2A5.84,5.84,0,0,1,14,11.57Zm-4.17.58v5.56a1.27,1.27,0,0,0,.32.93,1.27,1.27,0,0,0,.93.31,3.57,3.57,0,0,0,1.69-.41A2.79,2.79,0,0,0,14,17.37a3.61,3.61,0,0,0,.41-1.73,3.81,3.81,0,0,0-.5-2,2.72,2.72,0,0,0-1.39-1.21A7.52,7.52,0,0,0,9.85,12.15Zm0-.89a5.92,5.92,0,0,0,2.4-.37,2.73,2.73,0,0,0,1.19-1,3.17,3.17,0,0,0,.41-1.7,3.18,3.18,0,0,0-.41-1.69,2.59,2.59,0,0,0-1.16-1,6.2,6.2,0,0,0-2.43-.33Z' })
  );
};

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Book */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Book = function Book(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Book' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M10,1 L10,11 L13,9 L16,11 L16,1 M5.5,18 C4.11928813,18 3,19.1192881 3,20.5 C3,21.8807119 4.11928813,23 5.5,23 L22,23 M3,20.5 L3,3.5 C3,2.11928813 4.11928813,1 5.5,1 L21,1 L21,18.0073514 L5.49217286,18.0073514 M20.5,18 C19.1192881,18 18,19.1192881 18,20.5 C18,21.8807119 19.1192881,23 20.5,23 L20.5,23' })
  );
};

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bookmark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Bookmark = function Bookmark(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Bookmark' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '5 1 5 22 12 17 19 22 19 1' })
  );
};

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BottomCorner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var BottomCorner = function BottomCorner(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'BottomCorner' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '8 20 20 20 20 8' })
  );
};

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Braille */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Braille = function Braille(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Braille' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd', stroke: '#000', strokeWidth: '2' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M7 10C8.65685425 10 10 8.65685425 10 7 10 5.34314575 8.65685425 4 7 4 5.34314575 4 4 5.34314575 4 7 4 8.65685425 5.34314575 10 7 10zM17 20C18.6568542 20 20 18.6568542 20 17 20 15.3431458 18.6568542 14 17 14 15.3431458 14 14 15.3431458 14 17 14 18.6568542 15.3431458 20 17 20zM7 8C7.55228475 8 8 7.55228475 8 7 8 6.44771525 7.55228475 6 7 6 6.44771525 6 6 6.44771525 6 7 6 7.55228475 6.44771525 8 7 8zM17 18C17.5522847 18 18 17.5522847 18 17 18 16.4477153 17.5522847 16 17 16 16.4477153 16 16 16.4477153 16 17 16 17.5522847 16.4477153 18 17 18zM7 20C5.34314575 20 4 18.6568542 4 17 4 15.3431458 5.34314575 14 7 14 8.65685425 14 10 15.3431458 10 17 10 18.6568542 8.65685425 20 7 20zM17 10C15.3431458 10 14 8.65685425 14 7 14 5.34314575 15.3431458 4 17 4 18.6568542 4 20 5.34314575 20 7 20 8.65685425 18.6568542 10 17 10z' })
    )
  );
};

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Briefcase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Briefcase = function Briefcase(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Briefcase' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,6 L23,6 L23,21 L1,21 L1,6 Z M6,6 L6,21 M18,6 L18,21 M8,6 L8,3 L16,3 L16,6' })
  );
};

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Brush */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Brush = function Brush(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Brush' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M10.4350288,13.8510725 C8.66912406,14.6226292 7.43502884,16.3847098 7.43502884,18.4350288 C7.43502884,21.1964526 12.4350288,25.4350288 12.4350288,25.4350288 C12.4350288,25.4350288 17.4350288,21.1964526 17.4350288,18.4350288 C17.4350288,16.3847098 16.2009336,14.6226292 14.4350288,13.8510725 L14.4350288,-0.564864977 C14.4350288,-1.67491274 13.5395983,-2.56497116 12.4350288,-2.56497116 C11.3227585,-2.56497116 10.4350288,-1.66949312 10.4350288,-0.564864977 L10.4350288,13.8510725 Z M10,12 L12.6000977,12 L15,12', transform: 'rotate(45 12.435 11.435)' })
  );
};

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Bug */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Bug = function Bug(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Bug' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M23,20 C21.62,17.91 20,17 19,17 M5,17 C4,17 2.38,17.91 1,20 M19,9 C22,9 23,6 23,6 M1,6 C1,6 2,9 5,9 M19,13 L24,13 L19,13 Z M5,13 L0,13 L5,13 Z M12,23 L12,12 L12,23 L12,23 Z M12,23 C8,22.9999998 5,20.0000002 5,16 L5,9 C5,9 8,6.988 12,7 C16,7.012 19,9 19,9 C19,9 19,11.9999998 19,16 C19,20.0000002 16,23.0000002 12,23 L12,23 Z M7,8 L7,6 C7,3.24 9.24,1 12,1 C14.76,1 17,3.24 17,6 L17,8' })
  );
};

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Bundle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Bundle = function Bundle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Bundle' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17,14 L7,14 L17,14 Z M17,3 L23,3 L23,13 L17,13 M1,13 L1,17 L7,17 M17,17 L23,17 L23,13 M1,17 L1,21 L7,21 M23,17 L23,21 L17,21 M7,22 L17,22 L17,2 L7,2 L7,22 Z M7,13 L1,13 L1,3 L7,3' })
  );
};

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Bus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Bus = function Bus(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Bus' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,12 L21,12 L21,20 L3,20 L3,12 Z M3,3.99961498 C3,2.89525812 3.8926228,2 4.99508929,2 L19.0049107,2 C20.1067681,2 21,2.88743329 21,3.99961498 L21,12 L3,12 L3,3.99961498 Z M3,20 L6,20 L6,22.0010434 C6,22.5527519 5.55733967,23 5.00104344,23 L3.99895656,23 C3.44724809,23 3,22.5573397 3,22.0010434 L3,20 Z M18,20 L21,20 L21,22.0010434 C21,22.5527519 20.5573397,23 20.0010434,23 L18.9989566,23 C18.4472481,23 18,22.5573397 18,22.0010434 L18,20 Z M7,17 C7.55228475,17 8,16.5522847 8,16 C8,15.4477153 7.55228475,15 7,15 C6.44771525,15 6,15.4477153 6,16 C6,16.5522847 6.44771525,17 7,17 Z M17,17 C17.5522847,17 18,16.5522847 18,16 C18,15.4477153 17.5522847,15 17,15 C16.4477153,15 16,15.4477153 16,16 C16,16.5522847 16.4477153,17 17,17 Z M12,6 L12,12 M1,5 L1,13 M23,5 L23,13 M10,16 L14,16 M3,5.99975586 L21,6' })
  );
};

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BusinessService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var BusinessService = function BusinessService(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'BusinessService' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4,23 L1,23 L1,5 L1,5 L23,5 L23,23 L16,23 M8,5 L8,1 L8,1 L16,1 L16,5 M9,16 C11.209139,16 13,14.209139 13,12 C13,9.790861 11.209139,8 9,8 C6.790861,8 5,9.790861 5,12 C5,14.209139 6.790861,16 9,16 Z M14.0084967,17.8761594 C14.3255566,17.9570186 14.6577589,18 15,18 C17.209139,18 19,16.209139 19,14 C19,11.790861 17.209139,10 15,10 C14.1717747,10 13.4023412,10.2517171 12.7640287,10.6828219 M7.70199467,15.7255728 C6.67265121,16.4493031 6,17.6460985 6,19 C6,21.209139 7.790861,23 10,23 L10,23 C12.209139,23 14,21.209139 14,19 C14,17.2838286 12.9192205,15.8200868 11.4011657,15.2522789' })
  );
};

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cafeteria */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Cafeteria = function Cafeteria(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Cafeteria' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,1 L12,7.99967027 C12,9.65670662 10.6526091,11 9.00313032,11 L5.99686968,11 C4.34174426,11 3,9.6513555 3,7.99967027 L3,1 M6,7 C6,7 6,6.54902482 6,6.00922203 L6,1 M9,7 C9,7 9,6.54902482 9,6.00922203 L9,1 M6,11 L6,21.5044548 C6,22.3304216 6.66579723,23 7.5,23 L7.5,23 C8.32842712,23 9,22.3204455 9,21.5044548 L9,11 M15,18 L15,21.4998351 C15,22.3283533 15.6657972,23 16.5,23 L16.5,23 C17.3284271,23 18,22.3316845 18,21.4952612 L18,15 C18,15 21,15 21,12 C21,9 21,10 21,7 C21,4 19,2 15,2 C15,2 15,9.99456145 15,18 L15,18 Z' })
  );
};

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Calculator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Calculator = function Calculator(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Calculator' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M22,23 L2,23 L2,1 L22,1 L22,23 Z M16,17 L18,17 L18,19 L16,19 L16,17 Z M11,17 L13,17 L13,19 L11,19 L11,17 Z M16,12 L18,12 L18,14 L16,14 L16,12 Z M11,12 L13,12 L13,14 L11,14 L11,12 Z M6,17 L8,17 L8,19 L6,19 L6,17 Z M6,12 L8,12 L8,14 L6,14 L6,12 Z M18,9 L6,9 L6,5 L18,5 L18,9 Z' })
  );
};

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Calendar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Calendar = function Calendar(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Calendar' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,5 L22,5 L22,22 L2,22 L2,5 Z M18,5 L18,1 M6,5 L6,1 M2,10 L22,10' })
  );
};

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Camera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Camera = function Camera(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Camera' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,21 L1,7 L6,7 L8,3 L16,3 L18,7 L23,7 L23,21 L1,21 Z M12,18 C14.7614237,18 17,15.7614237 17,13 C17,10.2385763 14.7614237,8 12,8 C9.23857625,8 7,10.2385763 7,13 C7,15.7614237 9.23857625,18 12,18 Z' })
  );
};

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Capacity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Capacity = function Capacity(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Capacity' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeWidth: '2', d: 'M1,19 L23,19 L23,5 L1,5 L1,19 Z M4,16 L7,16 L7,8 L4,8 L4,16 Z M10,16 L13,16 L13,8 L10,8 L10,16 Z' })
  );
};

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Car */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Car = function Car(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Car' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,10.9970301 C1,10.4463856 1.43945834,10 2.00246167,10 L21.9975383,10 C22.5511826,10 23,10.4530363 23,10.9970301 L23,17.0029699 C23,17.5536144 22.5605417,18 21.9975383,18 L2.00246167,18 C1.44881738,18 1,17.5469637 1,17.0029699 L1,10.9970301 Z M6,2 L18,2 L22,10 L2,10 L6,2 Z M12,10.5 L15,5 M3,18 L6,18 L6,20.9906311 C6,21.5480902 5.55733967,22 5.00104344,22 L3.99895656,22 C3.44724809,22 3,21.5566468 3,20.9906311 L3,18 Z M18,18 L21,18 L21,20.9906311 C21,21.5480902 20.5573397,22 20.0010434,22 L18.9989566,22 C18.4472481,22 18,21.5566468 18,20.9906311 L18,18 Z M5,15 C5.55228475,15 6,14.5522847 6,14 C6,13.4477153 5.55228475,13 5,13 C4.44771525,13 4,13.4477153 4,14 C4,14.5522847 4.44771525,15 5,15 Z M19,15 C19.5522847,15 20,14.5522847 20,14 C20,13.4477153 19.5522847,13 19,13 C18.4477153,13 18,13.4477153 18,14 C18,14.5522847 18.4477153,15 19,15 Z M12,13 L12,15 M14,13 L14,15 M10,13 L10,15' })
  );
};

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CaretDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CaretDown = function CaretDown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CaretDown' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '22 8 12 20 2 8' })
  );
};

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CaretNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CaretNext = function CaretNext(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CaretNext' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '6 2 18 12 6 22' })
  );
};

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CaretPrevious */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CaretPrevious = function CaretPrevious(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CaretPrevious' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '6 2 18 12 6 22', transform: 'matrix(-1 0 0 1 24 0)' })
  );
};

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CaretUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CaretUp = function CaretUp(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CaretUp' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '22 4 12 16 2 4', transform: 'matrix(1 0 0 -1 0 20)' })
  );
};

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Cart = function Cart(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Cart' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,5 L22,5 L20,14 L7,14 L4,2 L0,2 M7,14 L8,18 L21,18 M19,23 C18.4475,23 18,22.5525 18,22 C18,21.4475 18.4475,21 19,21 C19.5525,21 20,21.4475 20,22 C20,22.5525 19.5525,23 19,23 Z M9,23 C8.4475,23 8,22.5525 8,22 C8,21.4475 8.4475,21 9,21 C9.5525,21 10,21.4475 10,22 C10,22.5525 9.5525,23 9,23 Z' })
  );
};

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CatalogOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CatalogOption = function CatalogOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CatalogOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5.5,18 C4.11928813,18 3,19.1192881 3,20.5 C3,21.8807119 4.11928813,23 5.5,23 L22,23 M3,20.5 L3,3.5 C3,2.11928813 4.11928813,1 5.5,1 L21,1 L21,18.0073514 L5.49217286,18.0073514 M20.5,18 C19.1192881,18 18,19.1192881 18,20.5 C18,21.8807119 19.1192881,23 20.5,23 L20.5,23' })
  );
};

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Catalog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Catalog = function Catalog(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Catalog' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,6 L1,4.5 L1,18.443038 L12,23 L23,18.443038 L23,4 L19,6 M5,16 L5,2 L12,5 L19,2 L19,16 L12,19 L5,16 Z M11.95,5 L11.95,19' })
  );
};

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Centos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Centos = function Centos(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Centos' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#7E2F76', fillRule: 'evenodd', d: 'M5.1609863,6.25070841 L3.24873581,8.1633816 L3.24873581,3.22722505 L8.18367123,3.22722505 L6.23953033,5.17169472 L6.093182,5.31809002 L6.23953033,5.46453229 L10.7544892,9.98066536 L10.7544892,10.7189824 L9.92411742,10.7189824 L5.45678278,6.25066145 L5.30719374,6.10102544 L5.1609863,6.25070841 L5.1609863,6.25070841 Z M10.7545362,9.39193738 L10.7545362,3.22722505 L8.77239922,3.22722505 L6.68190998,5.31813699 L10.7545362,9.39193738 L10.7545362,9.39193738 Z M5.30728767,6.6930411 L3.24873581,8.75225049 L3.24873581,10.7190294 L9.33224266,10.7190294 L5.30728767,6.6930411 L5.30728767,6.6930411 Z M13.2714364,9.36319374 L17.3154599,5.31809002 L15.1964149,3.19848141 L13.2714364,3.19848141 L13.2714364,9.36319374 L13.2714364,9.36319374 Z M17.9071937,5.31809002 L17.7576047,5.46453229 L13.2713894,9.95516243 L13.2713894,10.7189824 L14.0572368,10.7189824 L18.5340117,6.24108023 L18.680454,6.09463796 L18.8299022,6.24108023 L20.7899648,8.20147162 L20.7899648,3.19852838 L15.785002,3.19852838 L17.7576047,5.17174168 L17.9071937,5.31809002 L17.9071937,5.31809002 Z M11.1714129,2.80720157 L11.1714129,3.01723679 L11.1714129,9.80886106 L11.998638,10.636274 L12.8545127,9.78011742 L12.8545127,2.99168689 L12.8545127,2.78155773 L13.064454,2.78155773 L14.7794912,2.78155773 L11.998638,-1.77635684e-15 L9.19223483,2.80720157 L10.9613777,2.80720157 L11.1714129,2.80720157 L11.1714129,2.80720157 Z M14.6490176,10.7190294 L20.7900587,10.7190294 L20.7900587,8.79358121 L18.6805479,6.68355382 L14.6490176,10.7190294 L14.6490176,10.7190294 Z M10.6241096,12.011225 L9.75231311,11.1391468 L3.03870059,11.1391468 L2.83190607,11.1391468 L2.83190607,10.9291115 L2.83190607,9.16917417 L0,12.0015499 L2.8318591,14.8342544 L2.8318591,13.0167358 L2.8318591,12.8101292 L3.03865362,12.8101292 L9.82539335,12.8101292 L10.6241096,12.011225 L10.6241096,12.011225 Z M13.2714364,14.6909589 L13.2714364,20.747225 L15.2345049,20.747225 L17.2803757,18.7008376 L13.2714364,14.6909589 L13.2714364,14.6909589 Z M5.31691585,17.3197808 L9.40861057,13.226865 L3.24873581,13.226865 L3.24873581,15.2508493 L5.31691585,17.3197808 L5.31691585,17.3197808 Z M18.6805479,17.3197808 L20.7900587,15.2098474 L20.7900587,13.226865 L14.5918121,13.226865 L18.6805479,17.3197808 L18.6805479,17.3197808 Z M21.2099413,14.789589 L23.9970881,12.0015969 L21.2099413,9.21365166 L21.2099413,10.9291585 L21.2099413,11.1391937 L20.9997652,11.1391937 L14.229135,11.1391937 L13.3667319,12.0015969 L14.1750294,12.8101761 L20.9998121,12.8101761 L21.2099883,12.8101761 L21.2099883,13.0167828 L21.2099883,14.789589 L21.2099413,14.789589 Z M18.6805479,17.9083679 L18.5341057,17.7623014 L14.0000783,13.2269119 L13.2714364,13.2269119 L13.2714364,14.1022309 L17.7226614,18.5543953 L17.8689159,18.7008845 L17.7226614,18.8504736 L15.8261918,20.747319 L20.7900117,20.747319 L20.7900117,15.8015342 L18.8299491,17.7622544 L18.6805479,17.9083679 L18.6805479,17.9083679 Z M12.8545127,21.1643836 L12.8545127,20.9542544 L12.8545127,14.2738004 L11.9827162,13.4020509 L11.184,14.2005793 L11.184,20.9542544 L11.184,21.1643836 L10.9741526,21.1643836 L9.14461057,21.1643836 L11.9827162,24 L14.8177221,21.1643836 L13.064407,21.1643836 L12.8545127,21.1643836 L12.8545127,21.1643836 Z M6.09322896,18.7008376 L6.2395773,18.5543483 L10.7672642,14.0256282 L10.7672642,13.226865 L9.99733855,13.226865 L5.46321722,17.7622544 L5.31691585,17.9083209 L5.17047358,17.7622544 L3.24873581,15.8398121 L3.24873581,20.7471781 L8.13590607,20.7471781 L6.2395773,18.8503327 L6.09322896,18.7008376 L6.09322896,18.7008376 Z M10.7672642,14.6176908 L6.68190998,18.7008376 L8.72768689,20.747225 L10.7672642,20.747225 L10.7672642,14.6176908 L10.7672642,14.6176908 Z' })
  );
};

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Channel = function Channel(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Channel' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,9 L22,9 L22,22 L2,22 L2,9 Z M21,2 L13,9 L11,9 L3,2' })
  );
};

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ChapterAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ChapterAdd = function ChapterAdd(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ChapterAdd' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,14 L5,5 L19,5 L19,20 L11,20 M19,16 L23,16 L23,1 L9,1 L9,5 M5,16 L5,24 M9,20 L1,20' })
  );
};

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChapterNext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ChapterNext = function ChapterNext(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ChapterNext' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,3.5 L1,20 L10,14 L10,20 L21,12 L10,4 L10,10 L1,3.5 Z M22,2 L22,22 L22,2 Z' })
  );
};

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChapterPrevious; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ChapterPrevious = function ChapterPrevious(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ChapterPrevious' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M23,3.5 L23,20 L14,14 L14,20 L3,12 L14,4 L14,10 L23,3.5 Z M2,2 L2,22 L2,2 Z' })
  );
};

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ChatOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ChatOption = function ChatOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ChatOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M9,7 L9,1 L23,1 L23,11 L20,11 L20,16 L15,12 M1,7 L15,7 L15,18 L9,18 L4,22 L4,18 L1,18 L1,7 Z' })
  );
};

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Chat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Chat = function Chat(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Chat' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000000', strokeWidth: '2', d: 'M5,1 L19,1 L19,1 C21.209139,1 23,2.790861 23,5 L23,13 L23,13 C23,15.209139 21.209139,17 19,17 L7,17 L1,22 L1,5 L1,5 C1,2.790861 2.790861,1 5,1 Z M5,7 L18,7 M5,11 L14,11', transform: 'matrix(-1 0 0 1 24 0)' })
  );
};

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CheckboxSelected */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CheckboxSelected = function CheckboxSelected(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CheckboxSelected' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,2 L22,2 L22,22 L2,22 L2,2 Z M5,13 L10,17 L19,6' })
  );
};

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Checkbox = function Checkbox(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Checkbox' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { width: '20', height: '20', x: '2', y: '2', fill: 'none', stroke: '#000', strokeWidth: '2' })
  );
};

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkmark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Checkmark = function Checkmark(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Checkmark' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '2 14 9 20 22 4' })
  );
};

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Chrome */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Chrome = function Chrome(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Chrome' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#4285F4', d: 'M11.9733005,16.4144516 C9.59429509,16.4144516 7.65884342,14.4788121 7.65884342,12.0999945 C7.65884342,9.72075429 9.59429509,7.78530262 11.9733005,7.78530262 C14.3523059,7.78530262 16.2879454,9.72075429 16.2879454,12.0999945 C16.2879924,14.4788121 14.3523529,16.4144516 11.9733005,16.4144516 L11.9733005,16.4144516 Z' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#4AAE48', d: 'M13.7910066,17.1810894 C13.1872494,17.4007528 12.5549364,17.5116882 11.9068426,17.5116882 C10.6352186,17.5116882 9.39370022,17.0652225 8.41129728,16.2548117 C7.61431896,15.5972306 7.02033082,14.7318218 6.69297277,13.7500294 L6.691235,13.7442055 L1.93641793,5.50854377 C0.228238232,8.1357683 -0.377867323,11.2684017 0.230163868,14.3493248 C0.849467072,17.4870306 2.65331799,20.1955546 5.30970885,21.9764857 C6.69353637,22.9040785 8.22657716,23.5227711 9.86735961,23.8160783 L13.7910066,17.1810894 L13.7910066,17.1810894 Z' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#EA3939', d: 'M22.7599128,6.70666487 C19.7903479,0.731840215 12.5393434,-1.70437065 6.56465968,1.26519432 C5.01832731,2.03375777 3.65958002,3.12347966 2.57441389,4.45616042 L6.59105498,11.413435 C6.85172029,9.39264477 8.25048322,7.60626547 10.3219975,6.95469613 C10.8217704,6.79763941 11.341739,6.71403864 11.865371,6.70666487 L22.7599128,6.70666487 Z' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#FED14B', d: 'M11.9264747,24 C14.936431,24 17.8171819,22.8712018 20.0368292,20.8218558 C22.2681243,18.7619893 23.6231612,15.9588274 23.8523118,12.9290041 C23.983349,11.1937716 23.7261592,9.41711443 23.1082181,7.78530262 L15.2520944,7.78530262 C16.5738788,8.83162726 17.3494403,10.4306093 17.3416908,12.1250278 C17.3360548,13.3449884 16.9177692,14.5439079 16.1598672,15.5064909 L11.1518525,23.9751076 C11.4097938,23.9916399 11.6696606,24 11.926052,24 L11.9264747,24 L11.9264747,24 Z' })
    )
  );
};

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CircleInformation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CircleInformation = function CircleInformation(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CircleInformation' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,10 L12,18 M12,6 L12,8' })
  );
};

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CirclePlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CirclePlay = function CirclePlay(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CirclePlay' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M9.5,15.5 L15.5,12 L9.5,8.5 L9.5,15.5 Z M10.5,13.5 L12.5,12 L10.5,10.5 L10.5,13.5 Z' })
  );
};

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CircleQuestion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CircleQuestion = function CircleQuestion(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CircleQuestion' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,15 L12,14 C12,13 12,12.5 13,12 C14,11.5 15,11 15,9.5 C15,8.5 14,7 12,7 C10,7 9,8.26413718 9,10 M12,16 L12,18' })
  );
};

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClearOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ClearOption = function ClearOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ClearOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M10,4 C10,2.8954305 10.8954305,2 12,2 C13.1045695,2 14,2.8954305 14,4 L14,10 L20,10 L20,14 L4,14 L4,10 L10,10 L10,4 Z M4,14 L20,14 L20,22 L12,22 L4,22 L4,14 Z M16,22 L16,16.3646005 M8,22 L8,16.3646005 M12,22 L12,16.3646005' })
  );
};

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Clear; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Clear = function Clear(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Clear' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M5,5 L19,19' })
  );
};

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cli */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Cli = function Cli(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Cli' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,1 L23,1 L23,23 L1,23 L1,1 Z M1,5 L23,5 M5,1 L5,5 M11,16 L19,16 M5,10 L8,13 L5,16' })
  );
};

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Clipboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Clipboard = function Clipboard(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Clipboard' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,3 L21,3 L21,23 L3,23 L3,3 L3,3 L8,3 M8,1 L16,1 L16,6 L8,6 L8,1 Z' })
  );
};

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Clock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Clock = function Clock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Clock' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,5 L12,12 L17,12' })
  );
};

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Clone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Clone = function Clone(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Clone' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,23 L23,23 L23,7 L7,7 L7,23 Z M17,3.9997 L17,0.9997 L14,0.9997 M1,13.9997 L1,16.9997 L4,16.9997 M1,11.9997 L1,5.9997 L1,11.9997 Z M4,0.9997 L1,0.9997 L1,3.9997 M6,0.9997 L12,0.9997 L6,0.9997 Z' })
  );
};

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Close; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Close = function Close(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Close' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,3 L21,21 M3,21 L21,3' })
  );
};

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClosedCaption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ClosedCaption = function ClosedCaption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ClosedCaption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,12 C1,5 2.5,4 12,4 C21.5,4 23,5 23,12 C23,19 21.5,20 12,20 C2.5,20 1,19 1,12 Z M5.25,14 C5.25,15.5 6,16 7.75,16 C9.5,16 10.25,15.5 10.25,14 L9.97861679,14 C9.97861671,15.25 8.97905547,16 7.75,16 C6.52094453,16 5.52138329,15.25 5.52138321,14 L5.52138321,10 C5.5,8.75 6.5,8 7.75,8 C9,8 10,8.75 9.97861679,10 L10.25,10 C10.25,8.75 9.2286998,8 7.75,8 C6.2713002,8 5.25,8.75 5.25,10 L5.25,14 Z M13.25,14 C13.25,15.5 14,16 15.75,16 C17.5,16 18.25,15.5 18.25,14 L17.9786168,14 C17.9786167,15.25 16.9790555,16 15.75,16 C14.5209445,16 13.5213833,15.25 13.5213832,14 L13.5213832,10 C13.5,8.75 14.5,8 15.75,8 C17,8 18,8.75 17.9786168,10 L18.25,10 C18.25,8.75 17.2286998,8 15.75,8 C14.2713002,8 13.25,8.75 13.25,10 L13.25,14 Z' })
  );
};

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CloudComputer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CloudComputer = function CloudComputer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CloudComputer' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,6 L6,5 C6,2 7.5,1 10,1 L14,1 C16.5,1 18,2.5 18,5 L18,6 C21,6 23,8 23,11 C23,14 21,16 18,16 M14,6 L6,6 C3,6 1,7.5 1,11 C1,14.5 3,16 6,16 M8,19 L16,19 L16,12 L8,12 L8,19 Z M12,19 L12,23 L12,19 Z M9,23 L15,23 L9,23 Z' })
  );
};

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CloudDownload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CloudDownload = function CloudDownload(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CloudDownload' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,17 C3.23857625,17 1,14.7614237 1,12 C1,9.23857625 3.23857625,7 6,7 L12,7 M6,7 L6,6 C6,3 8,2 11,2 L13,2 C16,2 18,3 18,6 L18,7 C20.7614237,7 23,9.23857625 23,12 C23,14.7614237 20.7614237,17 18,17 M12,12 L12,21 M8,17 L12,21 L16,17' })
  );
};

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CloudSoftware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CloudSoftware = function CloudSoftware(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CloudSoftware' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,23 L16,23 L16,12 L8,12 L8,23 Z M8,16 L16,16 M12,12 L12,16 M6,6 L6,5 C6,2 7.5,1 10,1 L14,1 C16.5,1 18,2.5 18,5 L18,6 C21,6 23,8 23,11 C23,14 21,16 18,16 M14,6 L6,6 C3,6 1,7.5 1,11 C1,14.5 3,16 6,16' })
  );
};

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CloudUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CloudUpload = function CloudUpload(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CloudUpload' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,17 C3.23857625,17 1,14.7614237 1,12 C1,9.23857625 3.23857625,7 6,7 L12,7 M6,7 L6,6 C6,3 8,2 11,2 L13,2 C16,2 18,3 18,6 L18,7 C20.7614237,7 23,9.23857625 23,12 C23,14.7614237 20.7614237,17 18,17 M12,13 L12,22 M8,16.0000004 L11.9653427,11.9653429 L16,16.0000002' })
  );
};

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cloud */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Cloud = function Cloud(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Cloud' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M18,17 L18,18 C18,21 16,22 13,22 L11,22 C8,22 6,21 6,18 L6,17 C3.23857625,17 1,14.7614237 1,12 C1,9.23857625 3.23857625,7 6,7 L12,7 M6,7 L6,6 C6,3 8,2 11,2 L13,2 C16,2 18,3 18,6 L18,7 C20.7614237,7 23,9.23857625 23,12 C23,14.7614237 20.7614237,17 18,17 L12,17' })
  );
};

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cloudlinux */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Cloudlinux = function Cloudlinux(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Cloudlinux' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#5875B8', fillRule: 'evenodd', d: 'M14.0684356,5.79034617 C14.1171022,5.83554613 14.1629688,5.88247942 14.2099021,5.92887939 C14.5235019,6.25221246 14.818835,6.60341217 15.0909681,6.98367853 C15.0913681,6.98407853 15.0919014,6.98487853 15.0923014,6.98527852 C15.3575012,7.36634488 15.601101,7.77674455 15.8359008,8.21887752 C15.8816341,6.72327874 15.5928343,5.40847981 14.9224349,4.18328081 C14.6147018,3.61968127 14.3036354,3.04168174 13.7816358,2.65061539 C13.0331031,2.08901585 12.1863038,1.70701616 11.2797712,1.46634969 C10.8748382,1.35914978 10.4656385,1.28181651 10.0377722,1.23701654 C6.91657474,0.808616892 3.77031064,2.36541562 2.09297867,5.47701309 C2.28097852,5.52674638 2.36111178,5.36594651 2.4687117,5.27861325 C5.99870882,2.40754892 10.8748382,2.70048202 14.0080356,5.73047955 C14.0285689,5.75007953 14.0473689,5.77061285 14.0684356,5.79034617 L14.0684356,5.79034617 Z M10.5404385,16.6888706 C9.96470559,16.3543376 9.44097268,15.9496712 8.90203979,15.5039382 C9.44683934,17.0628703 11.539371,18.9363355 13.3229695,19.4235351 C13.2501696,19.3640684 13.1824363,19.2966018 13.1037697,19.2462019 C12.1952371,18.661269 11.4491044,17.9083363 10.8137716,17.039937 C10.725505,16.9196704 10.659505,16.7579372 10.5404385,16.6888706 L10.5404385,16.6888706 Z M23.5932278,9.59820973 C23.6076278,9.53420978 23.6110945,9.47607649 23.5250945,9.46247651 C23.5210945,9.5082098 23.5160279,9.5543431 23.5120279,9.59994306 C23.5028279,9.70900964 23.4937612,9.81780955 23.4842946,9.92674279 C22.999495,15.3279384 17.8578992,18.9307355 12.6175034,17.5406033 C12.4443036,17.49447 12.271637,17.4443367 12.0989705,17.3963367 C13.2500362,18.6898023 14.6673684,19.466735 16.3432337,19.7827348 C16.9057666,19.889268 17.4509662,19.8734014 18.005099,19.7220681 C20.0790973,19.1556686 21.710696,17.9739362 22.8168284,16.1399377 C24.0517608,14.0920727 24.3364272,11.8972745 23.5932278,9.59820973 L23.5932278,9.59820973 Z M14.4687019,20.5306008 C11.6479042,20.0162012 9.61323921,18.3820692 8.21937368,15.8934046 C8.15030707,17.4810033 8.53657342,18.9334021 9.37977273,20.260201 C9.63537252,20.6626007 9.87683899,21.092467 10.286972,21.3592668 C12.9656365,23.1032654 15.7536342,23.2813986 18.6061652,21.8432664 C20.097364,21.092067 21.1962964,19.9155347 21.9305625,18.4039359 C19.7645643,20.2555344 17.2865663,21.0442004 14.4687019,20.5306008 L14.4687019,20.5306008 Z M9.76577242,0.501683809 C15.4967011,1.01008339 19.0562982,6.22261248 17.4562995,11.762608 C17.4377662,11.8264746 17.3944329,11.8899412 17.5026994,11.9311412 C18.811365,10.6480755 19.6242977,9.11274346 19.8604309,7.28074495 C19.9009642,6.96447854 19.8916308,6.65661213 19.8198976,6.34554571 C19.2596313,3.91008103 17.8805658,2.07994919 15.6775009,0.921950133 C13.7555025,-0.0879157105 11.7263042,-0.27724889 9.63990585,0.398883893 C9.57470591,0.387283902 9.51323929,0.382483906 9.50257263,0.472750499 C9.54990593,0.477017162 9.59710589,0.481683825 9.64417252,0.485950488 C9.68457248,0.491550484 9.72510578,0.498217145 9.76577242,0.501683809 L9.76577242,0.501683809 Z M16.7349667,11.7272747 C16.7345667,11.7143413 16.7336334,11.7019413 16.7331001,11.689408 C16.7325667,11.6836747 16.7316334,11.6783414 16.7313667,11.6728747 C16.7288334,11.6780747 16.7268334,11.6835414 16.7245667,11.688608 C16.7280334,11.701808 16.7316334,11.714208 16.7349667,11.7272747 L16.7349667,11.7272747 Z M20.5508303,9.56420976 C20.0362974,12.3826075 18.3973654,14.4124725 15.8035008,15.8174047 C17.3804329,15.8550046 18.7462984,15.5355382 20.0061641,14.8024722 C20.513897,14.5070057 21.0434966,14.219406 21.3880296,13.726473 C24.159494,9.76794292 22.7444285,4.21368078 18.398432,2.06848253 C20.2738972,4.2370141 21.0689632,6.72927873 20.5508303,9.56420976 L20.5508303,9.56420976 Z M19.4572312,10.7603421 C19.3869646,10.7772754 19.3341646,10.8144754 19.3016313,10.8648754 C18.6622985,11.8550079 17.8510992,12.6742072 16.8687,13.3250067 C16.8020333,13.3692733 16.7323001,13.4259399 16.6949668,13.4938066 C16.3799004,14.0710061 15.963634,14.5762057 15.5736343,15.1023386 C17.4404328,14.1660727 18.7374984,12.7223405 19.4572312,10.7603421 L19.4572312,10.7603421 Z M16.3596337,5.66701293 C16.2429671,5.76541285 16.3189671,5.84594612 16.3360337,5.9144794 C16.5713669,6.85367863 16.6712335,7.81794451 16.4891003,8.75834375 C16.2929671,9.77220959 16.6508335,10.7030088 16.7313667,11.6728747 C16.9784332,11.1238085 17.0598998,10.5355423 17.1194998,9.94634278 C17.2697663,8.45394399 17.0036332,7.03394515 16.3596337,5.66701293 L16.3596337,5.66701293 Z M14.5243019,16.3692709 C14.4153686,16.3479376 14.310702,16.3484709 14.2012355,16.3782042 C13.6208359,16.5352707 13.0252364,16.6068707 12.4288369,16.671804 C12.3929703,16.6548706 12.352037,16.641804 12.3429703,16.6934039 C12.340437,16.7066039 12.3952369,16.7299372 12.4237703,16.7487372 C14.4160353,17.39167 16.3536337,17.2172702 18.2773655,16.3792709 C18.2242989,16.3431376 18.2036322,16.3178043 18.1813656,16.3158043 C18.1412323,16.3115376 18.0993656,16.3174043 18.059899,16.3263376 C16.8842999,16.5972707 15.7055009,16.6047374 14.5243019,16.3692709 L14.5243019,16.3692709 Z M8.87430648,15.5143382 C8.86243982,15.5076716 8.8511065,15.5012716 8.8395065,15.4944716 C8.84897316,15.5032716 8.85830649,15.5114049 8.86750648,15.5202049 L8.87430648,15.5143382 Z M8.38790687,8.95341025 C8.42537351,8.9399436 8.46377348,8.91994361 8.43364017,8.87701032 C8.42617351,8.86607699 8.37084022,8.88847697 8.33737358,8.8954103 C8.3523069,8.91621028 8.36924022,8.93567694 8.38790687,8.95341025 L8.38790687,8.95341025 Z M5.49564256,21.8493997 C5.53044254,21.9048664 5.56937584,21.9484663 5.63937578,21.8973997 C5.6101758,21.8619331 5.58097583,21.8261998 5.55164252,21.7907331 C5.53124253,21.8085998 5.51257588,21.8280664 5.49564256,21.8493997 L5.49564256,21.8493997 Z M10.6501717,4.51008054 C11.6171042,5.12061338 12.4753702,5.86181277 13.0968364,6.81714533 C13.4443028,7.35114489 13.8263024,7.41181151 14.3977686,7.21701167 C13.3940361,5.92421272 12.1791038,4.99848014 10.6501717,4.51008054 L10.6501717,4.51008054 Z M8.33737358,8.8954103 C6.47404177,9.84940952 5.22724278,11.342875 4.45951007,13.29554 C4.52271002,13.2838067 4.55471,13.2871401 4.57230998,13.2723401 C4.60337662,13.2472734 4.6289766,13.2134068 4.65057659,13.1792735 C5.29017606,12.156341 6.11844206,11.317675 7.12044124,10.6487422 C7.21270783,10.5868756 7.2860411,10.512609 7.34244106,10.4142091 C7.64177415,9.89274282 8.01230718,9.42074321 8.38790687,8.95341025 C8.36924022,8.93567694 8.3523069,8.91621028 8.33737358,8.8954103 L8.33737358,8.8954103 Z M7.59857418,18.1031361 C7.63617415,18.0415362 7.64710748,17.9778029 7.63457415,17.9192696 C7.38657436,16.7668706 7.38084103,15.6142048 7.6151075,14.4595391 C7.63084082,14.3810058 7.64057415,14.2915392 7.6187075,14.2168726 C7.43337432,13.5863398 7.37057437,12.934607 7.27444111,12.2867409 C6.61577498,14.2688726 6.71990823,16.2067377 7.59857418,18.1031361 L7.59857418,18.1031361 Z M6.09044208,7.61007802 C7.14644122,7.38141154 8.20657369,7.3864782 9.26990615,7.55074473 C9.41723937,7.57354471 9.57817257,7.64114466 9.71123913,7.60594469 C10.3548386,7.43514482 11.0113714,7.35114489 11.7076375,7.28527828 C10.2203054,6.56794553 7.41577433,6.72301207 5.81017564,7.64007799 C5.90364223,7.630478 5.99937549,7.63034467 6.09044208,7.61007802 L6.09044208,7.61007802 Z M5.55164252,21.7907331 C5.48124258,21.7072665 5.4103093,21.6240666 5.34017602,21.5400667 C1.86364552,17.3782034 2.9519113,11.1947418 7.64044082,8.47221065 C7.79537402,8.38221072 7.95297389,8.29567746 8.10937377,8.20781086 C6.38030851,8.10701094 4.82870977,8.55981057 3.42044425,9.52127646 C2.94751131,9.84394286 2.57311161,10.2408759 2.28831184,10.7392755 C1.22244605,12.6063406 0.903912972,14.5956723 1.41871255,16.6748706 C1.99351208,18.9960687 3.34431098,20.749134 5.49564256,21.8493997 C5.51257588,21.8280664 5.53124253,21.8085998 5.55164252,21.7907331 L5.55164252,21.7907331 Z M7.67084079,19.7224681 C6.04190878,17.3651367 5.76524234,14.7710055 6.60604166,11.9434078 C5.46470926,13.0320736 4.72470986,14.2236726 4.35217683,15.6330048 C4.20191028,16.2007377 4.03097709,16.7784705 4.13564367,17.3708701 C4.97497632,22.1296662 9.90310564,25.0569971 14.4929686,23.5001984 C11.6336376,23.2932652 9.30910612,22.0932662 7.67084079,19.7224681 L7.67084079,19.7224681 Z M0.444580013,14.4472724 C-0.105152872,12.8590071 -0.159819494,11.250075 0.363246746,9.66447634 C1.3635126,6.63074548 3.46084422,4.78501365 6.58804167,4.12408086 C7.06657462,4.02288094 7.54150756,4.15621416 8.00670718,4.25981408 C9.54083927,4.6018138 10.8412382,5.35567985 11.9152373,6.5268789 C9.16990624,5.75301286 6.57550835,6.0360793 4.21751027,7.6670113 C1.86151219,9.29634331 0.666979832,11.6062081 0.444580013,14.4472724 L0.444580013,14.4472724 Z' })
  );
};

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cluster */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Cluster = function Cluster(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Cluster' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,9 L16,9 L16,1 L8,1 L8,9 Z M1,23 L9,23 L9,15 L1,15 L1,23 Z M15,23 L23,23 L23,15 L15,15 L15,23 Z M5,15 L8,9 L5,15 Z M10,19 L14,19 L10,19 Z M16,9 L19,15 L16,9 Z' })
  );
};

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CoatCheck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CoatCheck = function CoatCheck(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CoatCheck' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M12,11 L22.1551134,17.4623449 C22.6217314,17.7592836 23,18.4433532 23,19.0093689 L23,20.9906311 C23,21.5480902 22.5605417,22 21.9975383,22 L2.00246167,22 C1.44881738,22 1,21.5566468 1,20.9906311 L1,19.0093689 C1,18.4519098 1.3786449,17.7590442 1.84488659,17.4623449 L12,11 Z M15,5 C15,3.34314575 13.6568542,2 12,2 C10.3431458,2 9,3.34314575 9,5 C9,5.93157601 9.41137234,6.80169553 10.0908534,7.31422922 C11,8 12,8 12,9.5 L12,11' })
  );
};

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CodeSandbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CodeSandbox = function CodeSandbox(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CodeSandbox' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#444', strokeWidth: '2', d: 'M12,1.5 L3,6.5 L3,17.5 L12,22.5 L21,17.5 L21,6.5 L12,1.5 Z M12,22.5 L12,11.5 M21,6.5 L12,11.5 M12,11.5 L3,6.5 M21,17.5 L21,12 L16.5,14.5 L16.5,20 L21,17.5 Z M3,17.5 L3,12 L7.5,14.5 L7.5,20 L3,17.5 Z M12,1.5 L7.5,4 L12,6.5 L16.5,4 L12,1.5 Z' })
  );
};

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Code */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Code = function Code(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Code' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M9,22 L15,2 M17,17 L22,12 L17,7 M7,17 L2,12 L7,7' })
  );
};

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Codepen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Codepen = function Codepen(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Codepen' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#333', fillRule: 'evenodd', d: 'M12.0001023,22.0293246 C6.46990155,22.0293246 1.97088004,17.5301496 1.97088004,12.0001023 C1.97088004,6.4701062 6.46990155,1.97088004 12.0001023,1.97088004 C17.5300984,1.97088004 22.02912,6.4701062 22.02912,12.0001023 C22.02912,17.5301496 17.5300984,22.0293246 12.0001023,22.0293246 M12.0001023,0 C5.37246693,0 0,5.37251809 0,12.0001023 C0,18.6277377 5.37246693,24.0000512 12.0001023,24.0000512 C18.6275331,24.0000512 24,18.6277377 24,12.0001023 C24,5.37251809 18.6275331,0 12.0001023,0 M18.1444674,13.0672488 L16.5492221,12.0001023 L18.1444674,10.933007 L18.1444674,13.0672488 Z M12.6376991,17.5906236 L12.6376991,14.6163967 L15.4022622,12.767488 L17.6339173,14.2599991 L12.6376991,17.5906236 Z M12.0001126,13.5086784 L9.74466695,12.0001023 L12.0001126,10.4915262 L14.2553535,12.0001023 L12.0001126,13.5086784 Z M11.3623214,17.5906236 L6.36605201,14.2599991 L8.59791172,12.767488 L11.3623214,14.6163967 L11.3623214,17.5906236 Z M5.85555304,10.933007 L7.45095183,12.0001023 L5.85555304,13.0672488 L5.85555304,10.933007 Z M11.3623214,6.40958102 L11.3623214,9.38380794 L8.59791172,11.233126 L6.36605201,9.74015443 L11.3623214,6.40958102 Z M12.6376991,6.40958102 L17.6339173,9.74015443 L15.4022622,11.233126 L12.6376991,9.38380794 L12.6376991,6.40958102 Z M19.414166,9.656248 C19.4128358,9.64688527 19.4104823,9.63793184 19.4089475,9.62856911 C19.4057754,9.61055993 19.402501,9.59260191 19.397794,9.57505319 C19.3950313,9.56451372 19.3911429,9.55438356 19.3878685,9.54425339 C19.3827523,9.52859768 19.3776872,9.51299313 19.3714454,9.49779788 C19.3670966,9.48725842 19.3620827,9.47671895 19.3572222,9.46658879 C19.3505199,9.45210981 19.3435618,9.43804014 19.3355293,9.42443092 C19.3296968,9.4142496 19.323455,9.40447757 19.3174178,9.3947567 C19.3088225,9.38145446 19.3000226,9.36856152 19.2904041,9.35607789 C19.283446,9.34671516 19.2760274,9.33735243 19.2686089,9.32834784 C19.2584275,9.3166828 19.2478881,9.3049666 19.2367858,9.29401783 C19.2284463,9.2854737 19.220158,9.27687841 19.2114092,9.26905055 C19.199693,9.25851109 19.1876187,9.24832976 19.1752885,9.23860889 C19.1657723,9.23119034 19.1563584,9.22377178 19.1464329,9.21676253 C19.1426981,9.21440905 19.1394237,9.21128814 19.1358934,9.20893467 L12.3536963,4.687504 C12.1394791,4.54465843 11.8605414,4.54465843 11.646273,4.687504 L4.86412702,9.20893467 C4.86059681,9.21128814 4.85727125,9.21440905 4.85358755,9.21676253 C4.84361088,9.22377178 4.83424815,9.23119034 4.82488542,9.23860889 C4.81240178,9.24832976 4.80027628,9.25851109 4.78881589,9.26905055 C4.7798113,9.27687841 4.7716253,9.2854737 4.76323466,9.29401783 C4.75213241,9.3049666 4.74159294,9.3166828 4.73161626,9.32834784 C4.72399306,9.33735243 4.7165745,9.34671516 4.70956525,9.35607789 C4.70020252,9.36856152 4.69119793,9.38145446 4.68280728,9.3947567 C4.67636081,9.40447757 4.67032365,9.4142496 4.66449113,9.42443092 C4.65666327,9.43804014 4.64965401,9.45210981 4.64279825,9.46658879 C4.63793781,9.47671895 4.63287273,9.48725842 4.62857508,9.49779788 C4.62233326,9.51299313 4.61726818,9.52859768 4.61215194,9.54425339 C4.60882638,9.55438356 4.60514268,9.56451372 4.60222642,9.57505319 C4.59751947,9.59260191 4.59439856,9.61055993 4.591073,9.62856911 C4.58953813,9.63793184 4.58718466,9.64688527 4.58600792,9.656248 C4.58227306,9.68356875 4.5801754,9.7112988 4.5801754,9.73938699 L4.5801754,14.2608177 C4.5801754,14.2889058 4.58227306,14.3166359 4.58600792,14.3443659 C4.58718466,14.3533705 4.58953813,14.3626821 4.591073,14.3716355 C4.59439856,14.3896447 4.59751947,14.4075516 4.60222642,14.4251515 C4.60514268,14.4356909 4.60882638,14.4458211 4.61215194,14.4560024 C4.61726818,14.4715558 4.62233326,14.4872115 4.62857508,14.5028161 C4.63287273,14.5134067 4.63793781,14.5235369 4.64279825,14.533667 C4.64965401,14.5480437 4.65666327,14.5621134 4.66449113,14.576183 C4.67032365,14.5860062 4.67636081,14.5956759 4.68280728,14.6054479 C4.69119793,14.6187502 4.70020252,14.6316431 4.70956525,14.6441268 C4.7165745,14.6538988 4.72399306,14.6628522 4.73161626,14.6718057 C4.74159294,14.6835219 4.75213241,14.6952381 4.76323466,14.7061868 C4.7716253,14.7147309 4.7798113,14.7233262 4.78881589,14.7311029 C4.80027628,14.7417447 4.81240178,14.7518749 4.82488542,14.7615958 C4.83424815,14.7690655 4.84361088,14.7764329 4.85358755,14.7834421 C4.85727125,14.7857956 4.86059681,14.7889165 4.86412702,14.7912188 L11.646273,19.3127007 C11.7534072,19.3841234 11.8767599,19.4200395 12.0001126,19.4200395 C12.1232606,19.4200395 12.2465621,19.3841234 12.3536963,19.3127007 L19.1358934,14.7912188 C19.1394237,14.7889165 19.1426981,14.7857956 19.1464329,14.7834421 C19.1563584,14.7764329 19.1657723,14.7690655 19.1752885,14.7615958 C19.1876187,14.7518749 19.199693,14.7417447 19.2114092,14.7311029 C19.220158,14.7233262 19.2284463,14.7147309 19.2367858,14.7061868 C19.2478881,14.6952381 19.2584275,14.6835219 19.2686089,14.6718057 C19.2760274,14.6628522 19.283446,14.6538988 19.2904041,14.6441268 C19.3000226,14.6316431 19.3088225,14.6187502 19.3174178,14.6054479 C19.323455,14.5956759 19.3296968,14.5860062 19.3355293,14.576183 C19.3435618,14.5621134 19.3505199,14.5480437 19.3572222,14.533667 C19.3620827,14.5235369 19.3670966,14.5134067 19.3714454,14.5028161 C19.3776872,14.4872115 19.3827523,14.4715558 19.3878685,14.4560024 C19.3911429,14.4458211 19.3950313,14.4356909 19.397794,14.4251515 C19.402501,14.4075516 19.4057754,14.3896447 19.4089475,14.3716355 C19.4104823,14.3626821 19.4128358,14.3533705 19.414166,14.3443659 C19.4176962,14.3166359 19.4198962,14.2889058 19.4198962,14.2608177 L19.4198962,9.73938699 C19.4198962,9.7112988 19.4176962,9.68356875 19.414166,9.656248 L19.414166,9.656248 Z' })
  );
};

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Columns */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Columns = function Columns(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Columns' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17,2 L17,22 L17,2 Z M12,2 L12,22 L12,2 Z M7,2 L7,22 L7,2 Z M2,22 L22,22 L22,2 L2,2 L2,22 Z' })
  );
};

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Command */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Command = function Command(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Command' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,9 C9,9 6.83333333,9 5.5,9 C3.5,9 2,7.5 2,5.5 C2,3.5 3.5,2 5.5,2 C7.5,2 9,3.5 9,5.5 C9,6.83333333 9,9 9,12 C9,15 9,17.1666667 9,18.5 C9,20.5 7.5,22 5.5,22 C3.5,22 2,20.5 2,18.5 C2,16.5 3.5,15 5.5,15 C6.83333333,15 9,15 12,15 C15,15 17.1666667,15 18.5,15 C20.5,15 22,16.5 22,18.5 C22,20.5 20.5,22 18.5,22 C16.5,22 15,20.5 15,18.5 C15,17.1666667 15,15 15,12 L15,5.5 C15,3.5 16.5,2 18.5,2 C20.5,2 22,3.5 22,5.5 C22,7.5 20.5,9 18.5,9 L12,9 Z' })
  );
};

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Compare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Compare = function Compare(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Compare' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M11,7 L1,7 L1,17 L7,17 L7,8 M10.9997,5 L10.9997,9 L12.9997,7 L10.9997,5 Z M10.9999,16.99965 L12.9999,18.9994 L12.9999,14.9994 L10.9999,16.99965 Z M13,17 L23,17 L23,7 L17,7 L17,16' })
  );
};

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Compass */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Compass = function Compass(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Compass' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M10,10 L15,9 L14,14 L9,15 L10,10 Z M12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,10 12,10 C10.8954305,10 10,10.8954305 10,12 C10,13.1045695 10.8954305,14 12,14 Z' })
  );
};

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Compliance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Compliance = function Compliance(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Compliance' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#231F20', strokeWidth: '2', d: 'M8,6 L16,6 L16,1 L8,1 L8,6 L8,6 L8,6 Z M16,3 L21,3 L21,23 L3,23 L3,3 L8,3 M8,14 L11,17 L17,11' })
  );
};

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Configure */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Configure = function Configure(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Configure' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,15 C20.0089021,14.9354541 23,11.9673591 23,8 C23,4.98813056 22.0029673,5.9851632 21,7 C20.0089021,7.97922849 18,10 18,10 L14,6 C14,6 16.0207715,3.99109792 17,3 C18.0148368,1.99703264 18.0148368,1 16,1 C12.0326409,0.999999999 9.05307486,3.99109792 9,8 C9.04154304,8.97626113 9,11 9,11 C7.11486635,12.8970031 4.65923194,15.3526375 3,17 C0.0682492584,19.9436202 4.05637975,23.9317507 7,21 C8.65052042,19.3376102 11.1126942,16.8754364 13,15 C13,15 15.0237389,14.958457 16,15 Z' })
  );
};

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Connect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Connect = function Connect(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Connect' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M10,21 C7.50000053,23.5 5.00000002,23 3,21 C0.999999977,19 0.500000114,16.5 3.00000004,14 C5.49999997,11.5 5.99999998,11 5.99999998,11 L13.0000005,18 C13.0000005,18 12.4999995,18.5 10,21 Z M14.0003207,3 C16.5,0.499999776 19,0.999999776 21.001068,3 C23.002136,5.00000022 23.5,7.49999978 21.001068,10 C18.5021359,12.5000002 18.0007478,13 18.0007478,13 L11,6 C11,6 11.5006414,5.50000022 14.0003207,3 Z M11,9.9999 L8.5,12.4999999 L11,9.9999 Z M14,13 L11.5,15.5 L14,13 Z' })
  );
};

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Connectivity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Connectivity = function Connectivity(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Connectivity' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M6,8 L6,12 L9,15 L15,9 L11,5 L5,5 L2.5,3 M17,7 L20,10 L20,17 M13,11 L16,14 M11,13 L14,16 M7,17 L10,20 L20,20' })
  );
};

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContactInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ContactInfo = function ContactInfo(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ContactInfo' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,12 C3.343,12 2,10.657 2,9 C2,7.343 3.343,6 5,6 C6.657,6 8,7.343 8,9 C8,10.657 6.657,12 5,12 Z M9,18 L9,16 C9,13.7504 7.2128,12 4.964,12 L5.0184,12 C2.7688,12 1,13.7504 1,16 L1,18 M12,7 L24,7 M12,17 L22,17 M12,12 L19,12' })
  );
};

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Contact */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Contact = function Contact(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Contact' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,2 L22,2 L22,18 L14,18 L6,22 L6,18 L1,18 L1,2 Z M6,10 L7,10 L7,11 L6,11 L6,10 Z M11,10 L12,10 L12,11 L11,11 L11,10 Z M16,10 L17,10 L17,11 L16,11 L16,10 Z' })
  );
};

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Contract; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Contract = function Contract(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Contract' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,14 L10,14 L10,22 M1,23 L10,14 M23,1 L14,10 M22,10 L14,10 L14,2' })
  );
};

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Copy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Copy = function Copy(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Copy' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M9,15 L17,15 L9,15 Z M9,11 L19,11 L9,11 Z M9,7 L13,7 L9,7 Z M16,1 L16,7 L22,7 M6,5 L2,5 L2,23 L18,23 L18,19 M22,19 L6,19 L6,1 L17,1 L22,6 L22,19 L22,19 Z' })
  );
};

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CreativeCommons */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CreativeCommons = function CreativeCommons(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CreativeCommons' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#333', fillRule: 'evenodd', d: 'M11.9836946,0 C8.691525,0 5.7944764,1.21835303 3.55571004,3.48973014 C1.25096379,5.82708715 0,8.85609556 0,12.0163054 C0,15.2098843 1.21797384,18.1729128 3.52272009,20.4772799 C5.82746635,22.7820262 8.82310561,24.03299 11.9836946,24.03299 C15.1439044,24.03299 18.2059028,22.7820262 20.5762498,20.4446692 C22.8150161,18.2388928 24,15.3088542 24,12.0163054 C24,8.7571257 22.8150161,5.7944764 20.5432598,3.52272009 C18.2388928,1.21797384 15.2758642,0 11.9836946,0 L11.9836946,0 Z M12.0163054,2.17278645 C14.7161727,2.17278645 17.1195096,3.19319977 18.9957657,5.07021425 C20.839411,6.91348038 21.8268344,9.34980724 21.8268344,12.0163054 C21.8268344,14.7157935 20.8720217,17.0865196 19.0287556,18.897175 C17.0861404,20.806421 14.5842129,21.8272135 12.0163054,21.8272135 C9.41578715,21.8272135 6.97946028,20.8068002 5.102825,18.9297858 C3.22618972,17.0531505 2.17278645,14.5842129 2.17278645,12.0163054 C2.17278645,9.41578715 3.22618972,6.94684952 5.102825,5.0368451 C6.94647033,3.16058902 9.31681729,2.17278645 12.0163054,2.17278645 L12.0163054,2.17278645 Z M11.8615939,10.0194653 C11.1828351,8.78177337 10.0247741,8.28919927 8.68052834,8.28919927 C6.72388296,8.28919927 5.16652974,9.67326044 5.16652974,12.0159262 C5.16652974,14.3984074 6.63060102,15.7430323 8.74688744,15.7430323 C10.1047842,15.7430323 11.2628452,14.9975352 11.9014093,13.866397 L10.4107944,13.1076281 C10.0778613,13.9058333 9.57201542,14.1458636 8.93345131,14.1458636 C7.82847753,14.1458636 7.32263161,13.2274537 7.32263161,12.0159262 C7.32263161,10.805157 7.74884662,9.88636795 8.93345131,9.88636795 C9.25273336,9.88636795 9.89167667,10.0592808 10.2644252,10.8582443 L11.8615939,10.0194653 L11.8615939,10.0194653 Z M18.7936548,10.0194653 C18.114896,8.78177337 16.956835,8.28919927 15.6125893,8.28919927 C13.6559439,8.28919927 12.0985907,9.67326044 12.0985907,12.0159262 C12.0985907,14.3984074 13.5626619,15.7430323 15.6789484,15.7430323 C17.0368451,15.7430323 18.1949061,14.9975352 18.8334703,13.866397 L17.3428553,13.1076281 C17.0099223,13.9058333 16.5040763,14.1458636 15.8655122,14.1458636 C14.7605385,14.1458636 14.2546925,13.2274537 14.2546925,12.0159262 C14.2546925,10.805157 14.6809075,9.88636795 15.8655122,9.88636795 C16.1847943,9.88636795 16.8237376,10.0592808 17.1964861,10.8582443 L18.7936548,10.0194653 L18.7936548,10.0194653 Z' })
  );
};

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CreditCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CreditCard = function CreditCard(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'CreditCard' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,5.00087166 C1,4.4481055 1.43945834,4 2.00246167,4 L21.9975383,4 C22.5511826,4 23,4.44463086 23,5.00087166 L23,18.9991283 C23,19.5518945 22.5605417,20 21.9975383,20 L2.00246167,20 C1.44881738,20 1,19.5553691 1,18.9991283 L1,5.00087166 Z M1,8 L23,8 L23,10 L1,10 L1,8 Z M5,15 L7,15 L7,15.5 L5,15.5 L5,15 Z M10,15 L16,15 L16,15.5 L10,15.5 L10,15 Z' })
  );
};

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Css3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Css3 = function Css3(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Css3' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M7,3 L21,3 L18,18 L10,22 L3,18 L4,14 M5,9 L19,9' })
  );
};

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cube */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Cube = function Cube(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Cube' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,2 L22,7 L22,17 L12,22 L2,17 L2,7 L12,2 Z M2,7 L12,12 L22,7 M12,12 L12,21.9999998 L12,12 Z' })
  );
};

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cubes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Cubes = function Cubes(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Cubes' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6.5,10.5 L12,13.5 L17.5,10.5 L17.5,4.5 L12,1.5 L6.5,4.5 L6.5,10.5 Z M6.5,4.5 L12,7.5 L17.5,4.5 M12,7.5 L12,13.5 L12,7.5 Z M1,19.5 L6.5,22.5 L12,19.5 L12,13.5 L6.5,10.5 L1,13.5 L1,19.5 Z M1,13.5 L6.5,16.5 L12,13.5 M6.5,16.5 L6.5,22.5 L6.5,16.5 Z M12,19.5 L17.5,22.5 L23,19.5 L23,13.5 L17.5,10.5 L12,13.5 L12,19.5 Z M12,13.5 L17.5,16.5 L23,13.5 M17.5,16.5 L17.5,22.5 L17.5,16.5 Z' })
  );
};

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Currency */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Currency = function Currency(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Currency' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,5 L23,5 L23,19 L1,19 L1,5 Z M2,9 L2,9 C3.65685425,9 5,7.65685425 5,6 M2,15 L2,15 C3.65685425,15 5,16.3431458 5,18 M22,9 L22,9 C20.3431458,9 19,7.65685425 19,6 M22,15 L22,15 C20.3431458,15 19,16.3431458 19,18 M12,16 C13.6568542,16 15,14.209139 15,12 C15,9.790861 13.6568542,8 12,8 C10.3431458,8 9,9.790861 9,12 C9,14.209139 10.3431458,16 12,16 Z' })
  );
};

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cursor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Cursor = function Cursor(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Cursor' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '6 3 18 14 13 15 16 20.5 13 22 10 16 6 19' })
  );
};

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Cut = function Cut(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Cut' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M23,4 L8,16 L23,4 Z M23,20 L8,8 L23,20 Z M5,9 C6.65685425,9 8,7.65685425 8,6 C8,4.34314575 6.65685425,3 5,3 C3.34314575,3 2,4.34314575 2,6 C2,7.65685425 3.34314575,9 5,9 Z M5,21 C6.65685425,21 8,19.6568542 8,18 C8,16.3431458 6.65685425,15 5,15 C3.34314575,15 2,16.3431458 2,18 C2,19.6568542 3.34314575,21 5,21 Z' })
  );
};

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cycle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Cycle = function Cycle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Cycle' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M13,20 C19,19 21,14 21,10 M14,16 L12,20 L16,23 M0,9 L4,6 L7,10 M9.00000008,20 C3,17 2.00000006,12 3.99999998,6 M20,6.99999999 C16,0.99999995 10,1 6,4.00609254 M20,2 L20,7 L15,7' })
  );
};

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Dashboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Dashboard = function Dashboard(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Dashboard' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M15,16 C15,14.3431458 13.6568542,13 12,13 C10.3431458,13 9,14.3431458 9,16 M5,5 L7,7 M12,7 L12,13 M12,3 L12,5 M19,12 L21,12 M3,12 L5,12 M17,7 L19,5 M3,17 L21,17' })
  );
};

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Database */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Database = function Database(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Database' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,2 L23,2 L23,9 L1,9 L1,2 Z M4,12 L5,12 L5,13 L4,13 L4,12 Z M4,5 L5,5 L5,6 L4,6 L4,5 Z M4,19 L5,19 L5,20 L4,20 L4,19 Z M1,16 L23,16 L23,23 L1,23 L1,16 Z M1,9 L23,9 L23,16 L1,16 L1,9 Z' })
  );
};

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Debian */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Debian = function Debian(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Debian' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#A80030', fillRule: 'evenodd', d: 'M2.65603874,5.16700815 C2.68642627,5.33364645 3.03933499,4.93419361 2.7631231,5.55645706 C2.23136472,5.92819947 2.69882551,5.71915014 2.65603874,5.16700815 L2.65603874,5.16700815 Z M2.65866423,5.19930536 C2.65706423,5.17900536 2.65606423,5.15910536 2.65376423,5.13840536 C2.65336423,5.16220536 2.65536423,5.18170536 2.65866423,5.19930536 L2.65866423,5.19930536 Z M2.21290675,6.95977879 C1.868546,7.39990489 2.05448766,7.49365067 2.0181823,7.79306417 C2.14278529,7.41066029 2.16532936,7.18103949 2.21290675,6.95977879 L2.21290675,6.95977879 Z M13.0395111,0 C12.6680035,0.0312799047 12.297905,0.0498318001 11.9324561,0.0968925575 L12.0934114,0.118873031 C12.3623434,0.0203366347 12.7543286,0.0648611837 13.0395111,0 L13.0395111,0 Z M12.4285197,0.467238997 L12.4387115,0.427538997 L12.2886995,0.493438997 L12.4285197,0.467238997 L12.4285197,0.467238997 Z M12.0148829,0.309558336 C12.227032,0.34764843 12.4735139,0.376861794 12.4387115,0.427538997 C12.6709155,0.376673927 12.7236592,0.32975407 12.0148829,0.309558336 L12.0148829,0.309558336 Z M9.80002141,13.2015757 C9.66175108,13.0486518 9.57979397,12.8644479 9.48820866,12.6809015 C9.57580179,13.0035166 9.75530899,13.280527 9.92236998,13.5623279 L9.80002141,13.2015757 L9.80002141,13.2015757 Z M14.1172119,12.9648629 C14.2606016,12.8527531 14.3906527,12.7394692 14.5066608,12.629285 C14.1832002,12.7084241 13.8542916,12.7101619 13.5228937,12.6798683 C13.1252256,12.6855982 13.5980875,12.8847845 14.1172119,12.9648629 L14.1172119,12.9648629 Z M15.6571131,12.147875 C15.8942016,11.8210799 16.0668986,11.4631927 16.1274389,11.0931411 C16.0742724,11.3569068 15.9313054,11.5847428 15.7963697,11.8249781 C15.0532137,12.2929556 15.726671,11.5471224 15.795947,11.2635367 C14.9967126,12.269754 15.6861856,11.8669195 15.6571131,12.147875 L15.6571131,12.147875 Z M16.4451694,10.0977732 C16.4930286,9.38167002 16.3039402,9.60800315 16.240488,9.88135006 C16.3145077,9.91995679 16.3734511,10.3861495 16.4451694,10.0977732 L16.4451694,10.0977732 Z M11.8867574,15.2447735 C11.3145606,14.9767808 10.7906457,14.5723025 10.3596781,14.0769904 C10.5883126,14.4117699 10.8349823,14.7369682 11.153934,14.9926086 C10.6143792,14.8097668 9.89357932,13.6851931 9.68312098,13.6393065 C10.6132989,15.3047501 13.4566704,16.5598445 14.9457536,15.9369705 C14.2566564,15.9625674 13.3814766,15.9512484 12.6074633,15.6651265 C12.3129343,15.5135646 11.9222173,15.2147147 11.9101938,15.1117165 C11.8954932,15.1495717 11.871728,15.1878027 11.8867574,15.2447735 L11.8867574,15.2447735 Z M11.9266054,15.0880452 C11.9135054,15.1006452 11.9080054,15.1174452 11.9105054,15.1383452 C11.9171054,15.1216452 11.9226054,15.1049452 11.9266054,15.0880452 L11.9266054,15.0880452 Z M9.12642322,13.5046996 C9.38774663,13.8598158 9.59505819,14.2443332 9.9288514,14.5219071 C9.68871003,14.0531782 9.510377,13.8593931 9.18217284,13.2257637 L9.12642322,13.5046996 L9.12642322,13.5046996 Z M20.4597996,8.57609506 C20.4664689,8.21097497 20.5613419,8.38475222 20.5982578,8.29485772 C20.5265864,8.25366782 20.3385313,7.97374555 20.2238383,7.43682082 C20.3068756,7.31071489 20.4457565,7.76394474 20.5586178,7.78249664 C20.4859601,7.35556821 20.3609344,7.03004115 20.355909,6.70249453 C20.0262019,6.01335032 20.2392904,6.7944086 19.9717204,6.40669747 C19.6206903,5.31185384 20.2629147,6.15251302 20.3062651,5.65513435 C20.8383052,6.42595387 21.1418049,7.6204611 21.2808736,8.11530355 C21.1746347,7.51196773 21.0029709,6.92760651 20.793358,6.36217292 C20.9550648,6.43013391 20.5332088,5.12083977 21.0035345,5.98794127 C20.5010365,4.13960888 18.8535812,2.41254484 17.337727,1.60217926 C17.523058,1.77182343 17.7574695,1.98509978 17.6732579,2.01849319 C16.9195813,1.56953732 17.0519808,1.53468793 16.9441919,1.3450359 C16.3299598,1.09521936 16.2898971,1.36518467 15.8830705,1.34541163 C14.7254322,0.731555248 14.5023868,0.796792166 13.4371322,0.412086912 L13.4859777,0.638560937 C12.7187747,0.383155349 12.5924339,0.735500461 11.7637043,0.639453306 C11.7133089,0.600095108 12.0293017,0.496955963 12.2892631,0.459194636 C11.5478448,0.556979564 11.5825533,0.313080848 10.8571507,0.48605966 C11.0359534,0.36065824 11.2250418,0.277667862 11.4156332,0.171006205 C10.8111232,0.207734262 9.97238965,0.522740749 10.2312708,0.236243124 C9.24524928,0.676275296 7.49385642,1.29388903 6.5109817,2.21547205 L6.4801245,2.00891195 C6.02975963,2.54954706 4.51625373,3.62358439 4.39564292,4.3237658 L4.27526696,4.35189893 C4.0409025,4.74867465 3.88934056,5.19838199 3.70349284,5.60657066 C3.39694038,6.12884174 3.25420821,5.8075417 3.29784038,5.88940487 C2.6950212,7.11176343 2.3956077,8.13874 2.13691443,8.98099605 C2.32116528,9.25659737 2.14132932,10.6396764 2.21102808,11.7466375 C1.908186,17.2136227 6.04793579,22.5218601 10.5729544,23.7472715 C11.236032,23.9847827 12.2225702,23.9755773 13.0613977,24 C12.0715718,23.7167901 11.9434463,23.8500349 10.9793584,23.5137055 C10.2838267,23.1863467 10.1313254,22.8121151 9.63873733,22.3848109 L9.83364965,22.7293126 C8.86754209,22.3873471 9.27173857,22.3060476 8.48579574,22.0570764 L8.69399967,21.7851855 C8.38082489,21.7615612 7.86447163,21.2572784 7.72328936,20.9783424 L7.38071335,20.9918219 C6.96919004,20.4838287 6.74985497,20.1180041 6.76577672,19.8343715 L6.65512288,20.0314443 C6.52972146,19.8161953 5.14067765,18.1269396 5.86138356,18.519911 C5.72748115,18.3976094 5.54947689,18.3208656 5.35649021,17.9703052 L5.50326153,17.8027276 C5.15650547,17.3564488 4.86507633,16.7845338 4.88715074,16.5941303 C5.07210609,16.8439469 5.20041945,16.8906319 5.32755864,16.9332308 C4.45181525,14.7605455 4.40268795,16.8135124 3.7393755,14.7218918 L3.8798063,14.7101971 C3.77211137,14.5484903 3.70682749,14.3725056 3.62040853,14.1998556 L3.6814654,13.5912595 C3.05098276,12.8623344 3.50501104,10.4917309 3.59603275,9.19164225 C3.65910919,8.66293672 4.12229601,8.10013327 4.47464112,7.21762665 L4.2599088,7.18061679 C4.67025794,6.46488936 6.60256701,4.30638808 7.49751984,4.41741765 C7.93111755,3.87279036 7.41157055,4.41544504 7.3267015,4.27825495 C8.27904778,3.29279705 8.57846129,3.58206572 9.22110834,3.40471899 C9.91429169,2.99328962 8.62617958,3.56515766 8.95490038,3.24775587 C10.1529301,2.94181398 9.80401359,2.55213024 11.3671164,2.39667005 C11.53197,2.49050977 10.9844308,2.5415627 10.8470058,2.66339464 C11.8453326,2.17503361 14.0060883,2.28601622 15.4094101,2.93439322 C17.0381256,3.6956315 18.8678121,5.94534236 18.9399062,8.06204317 L19.0220982,8.08411758 C18.9804856,8.92562216 19.1508342,9.89868082 18.8556947,10.7925534 L19.0566657,10.3693823 C19.0801022,11.012546 18.8683757,11.3244527 18.6775965,11.8769234 L18.3338463,12.0486811 C18.052609,12.5948113 18.3609932,12.3953902 18.1598342,12.8297394 C17.7207414,13.2203625 16.8271976,14.0514404 16.5414514,14.1274327 C16.332496,14.1227361 16.6826807,13.8809508 16.7285673,13.7864066 C16.1408714,14.1898986 16.2568794,14.3922317 15.3580284,14.6371637 L15.331633,14.5789718 C13.1144702,15.621964 10.0350434,13.555142 10.0755758,10.7347372 C10.0517636,10.9137278 10.0081784,10.8690154 9.95905107,10.9414852 C9.84468686,9.49030429 10.6292676,8.03287678 11.9523231,7.43776015 C13.2464469,6.79713268 14.7636162,7.06005296 15.6907883,7.92400768 C15.181621,7.25703181 14.1681239,6.54999325 12.9667595,6.61612254 C11.7901936,6.63467443 10.6894321,7.38252717 10.3220577,8.19425478 C9.71914454,8.57384065 9.64921094,9.65736528 9.38652549,9.85561224 C9.03319407,12.4530655 10.0513878,13.5751499 11.7738491,14.8952464 C11.9110392,14.987818 11.9288397,15.0405617 11.9177085,15.0881391 C11.9182721,15.0875755 11.9185539,15.0869649 11.9191175,15.0864483 C13.9511372,15.8454322 16.0503663,15.6614631 17.8083815,14.2520827 C18.2556466,13.9036358 18.7443364,13.3110554 18.8855656,13.3028362 C18.6728998,13.6223985 18.921871,13.4565117 18.7584264,13.7389701 C19.2043294,13.020002 18.5648761,13.4462259 19.219171,12.497543 L19.4609562,12.83035 C19.3711086,12.2338713 20.2019517,11.5092671 20.1175993,10.5657037 C20.3082377,10.2770925 20.3300772,10.8761544 20.127932,11.5401243 C20.4084179,10.8035906 20.2019517,10.6852342 20.2739989,10.0775305 C20.3519638,10.2817422 20.4541166,10.4988229 20.5066255,10.7144476 C20.3237837,10.0027123 20.6941171,9.51580727 20.7857024,9.10221742 C20.6957609,9.06210775 20.5037606,9.41684817 20.4597996,8.57609506 L20.4597996,8.57609506 Z' })
  );
};

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Deliver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Deliver = function Deliver(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Deliver' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,18 L1,18 L1,3 L14,3 L14,17 M14,18 L9,18 M6,21 C7.65685425,21 9,19.6568542 9,18 C9,16.3431458 7.65685425,15 6,15 C4.34314575,15 3,16.3431458 3,18 C3,19.6568542 4.34314575,21 6,21 Z M17,21 C18.6568542,21 20,19.6568542 20,18 C20,16.3431458 18.6568542,15 17,15 C15.3431458,15 14,16.3431458 14,18 C14,19.6568542 15.3431458,21 17,21 Z M14,8 L19,8 L23,13 L23,18 L20,18' })
  );
};

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Deploy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Deploy = function Deploy(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Deploy' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M23,1 C23,1 16.471872,0.541707069 14,3 C13.9767216,3.03685748 10,7 10,7 L5,8 L2,10 L10,14 L14,22 L16,19 L17,14 C17,14 20.9631426,10.0232786 21,10 C23.4582929,7.5281282 23,1 23,1 Z M17,8 C16.4475,8 16,7.5525 16,7 C16,6.4475 16.4475,6 17,6 C17.5525,6 18,6.4475 18,7 C18,7.5525 17.5525,8 17,8 Z M7,17 C6,16 4,16 3,17 C2,18 2,22 2,22 C2,22 6,22 7,21 C8,20 8,18 7,17 Z' })
  );
};

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Descend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Descend = function Descend(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Descend' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,8 L8,2 L14,8 M11,21 L22,21 M11,17 L19,17 M11,13 L16,13 M8,2 L8,22', transform: 'matrix(1 0 0 -1 0 24)' })
  );
};

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Desktop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Desktop = function Desktop(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Desktop' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,1 L23,1 L23,19 L1,19 L1,1 Z M5,23 L19,23 L5,23 Z M10,19 L10,23 L10,19 Z M14,19 L14,23 L14,19 Z' })
  );
};

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Detach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Detach = function Detach(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Detach' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4,4 L20,20 M22,12 C22,12 16.7200572,17.2799437 16.7200572,17.2799437 M15,19 C15,19 13.7932491,20.2067517 13.0000004,21.0000004 C6.99999996,27.0000004 -2.00000007,18.0000004 3.99999994,12.0000004 C4.88551518,11.1144851 6,10 6,10 M8,8 C8,8 10.1615592,5.83844087 13,3.00000008 C17,-0.999999955 23,4.99999994 19,9.00000005 C16.9873313,11.0126688 14,14 14,14 M12,16 C12,16 10.6478339,17.3521667 9.99999995,18.0000004 C7.99999952,20 5,17 6.99999995,15.0000004 C7.50049504,14.4995054 9,13 9,13 M11,11 C10.7388543,11.261146 16,6 16,6' })
  );
};

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Device */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Device = function Device(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Device' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M2,7 L22,7 L22,21 L16,21 L12,17 L8,21 L2,21 L2,7 Z M6,2 L11,7 L12,7 L13,7 L18,2' })
  );
};

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Diamond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Diamond = function Diamond(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Diamond' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,3 L18,3 L22,9 L12,21 L2,9 L6,3 Z M2,9 L22,9 M11,3 L7,9 L12,20 M13,3 L17,9 L12,20' })
  );
};

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Directions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Directions = function Directions(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Directions' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17,11 L22,6 L17,1 M22,6 L18,6 C14.686,6 12,8.686 12,12 L12,24 M7,6 L2,11 L7,16 M2,11 L6,11 C9.314,11 12,13.686 12,17 L12,24' })
  );
};

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Dislike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Dislike = function Dislike(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Dislike' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,23 L20,23 C22,23 23,22 23,20 L23,10 L16,10 L16,4 C16,2 15,1 13,1 L11,1 C11,1 10.9842682,7 10.9842677,8.32575545 C10.9842672,9.65151089 10,11 8,11 L1,11 L1,23 Z M6,23 L6,11', transform: 'rotate(180 12 12)' })
  );
};

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Docker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Docker = function Docker(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Docker' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#0DB7ED', fillRule: 'evenodd', d: 'M6.94221099,14.9002344 C6.9980621,14.9002344 7.05128211,14.9107588 7.10043586,14.9297745 C7.04721586,14.9606302 7.01109801,15.018335 7.01109801,15.0842919 C7.01109801,15.1828984 7.09098782,15.2626686 7.18959432,15.2626686 C7.25710599,15.2626686 7.31570779,15.2251754 7.34608506,15.1698027 C7.36743286,15.2214082 7.37939241,15.2780367 7.37939241,15.3374756 C7.37939241,15.578939 7.18361455,15.774657 6.94221099,15.774657 C6.70080744,15.774657 6.50496978,15.578939 6.50496978,15.3374756 C6.50496978,15.0959525 6.70080744,14.9002344 6.94221099,14.9002344 L6.94221099,14.9002344 Z M6.94221099,16.0853662 C6.52978585,16.0853662 6.19420083,15.7499008 6.19420083,15.3374756 C6.19420083,14.9250505 6.52978585,14.5895253 6.94221099,14.5895253 C7.35457634,14.5895253 7.69010156,14.9250505 7.69010156,15.3374756 C7.69010156,15.7499008 7.35457634,16.0853662 6.94221099,16.0853662 L6.94221099,16.0853662 Z M20.3859431,11.1838037 C18.2619865,16.8117894 13.4653093,19.318631 7.81023526,19.318631 C5.13823222,19.318631 3.00656172,18.3995992 1.64323262,16.8672219 L1.65327865,16.8605843 C2.04609012,16.880497 2.39758135,16.8872541 2.75439457,16.8872541 C3.08065114,16.8872541 3.39979178,16.8838457 3.6953721,16.8672219 C3.72108514,16.8657867 3.75325633,16.8621989 3.77878997,16.8605843 C3.77902916,16.8605245 3.86998155,16.8546046 3.82549202,16.853887 C4.57667146,16.8075437 5.15892224,16.7031368 5.70188589,16.5482008 C5.70200548,16.548141 5.70212508,16.548141 5.70224467,16.5480812 C5.80091098,16.5198567 5.89658739,16.4901372 5.98825735,16.4583846 C6.09081051,16.4228049 6.14510687,16.3108635 6.109587,16.2083104 C6.07406714,16.1056974 5.96218553,16.0512815 5.85957258,16.0869807 C5.16992503,16.3259326 4.26010213,16.4574876 3.14505333,16.4821841 L3.14475434,16.4821841 C2.57739321,16.4947416 1.95717085,16.4797922 1.28450587,16.4365584 L1.28444607,16.4365584 C1.14529669,16.2507668 1.01649231,16.0576798 0.89869073,15.8577161 L0.71248051,15.5172277 C0.149903198,14.4112083 -0.0964037696,13.1191582 0.0343141305,11.7160038 L16.3965356,11.7160038 C17.7407294,11.7160038 19.0534696,11.2143604 19.6764427,10.6609919 C18.5601381,9.75332174 18.670764,7.59731356 19.3822377,6.774616 C19.9997093,7.270758 20.9954018,8.31584342 20.824141,9.64622396 C21.6011531,9.255625 22.9506091,9.06259783 24,9.66816973 C23.3411483,10.9541803 21.8929064,11.3383809 20.3859431,11.1838037 L20.3859431,11.1838037 Z M2.25508329,11.3188869 L4.46771995,11.3188869 L4.46771995,9.1061306 L2.25508329,9.1061306 L2.25508329,11.3188869 Z M4.80808879,11.3188869 L7.02096464,11.3188869 L7.02096464,9.1061306 L4.80808879,9.1061306 L4.80808879,11.3188869 Z M4.80808879,8.76576176 L7.02096464,8.76576176 L7.02096464,6.5530653 L4.80808879,6.5530653 L4.80808879,8.76576176 Z M7.36127369,11.3188869 L9.57402994,11.3188869 L9.57402994,9.1061306 L7.36127369,9.1061306 L7.36127369,11.3188869 Z M7.36127369,8.76576176 L9.57402994,8.76576176 L9.57402994,6.5530653 L7.36127369,6.5530653 L7.36127369,8.76576176 Z M9.91433899,11.3188869 L12.1270952,11.3188869 L12.1270952,9.1061306 L9.91433899,9.1061306 L9.91433899,11.3188869 Z M9.91433899,8.76576176 L12.1270952,8.76576176 L12.1270952,6.5530653 L9.91433899,6.5530653 L9.91433899,8.76576176 Z M9.91433899,6.21275626 L12.1270952,6.21275626 L12.1270952,4 L9.91433899,4 L9.91433899,6.21275626 Z M12.4674043,11.3188869 L14.6801605,11.3188869 L14.6801605,9.1061306 L12.4674043,9.1061306 L12.4674043,11.3188869 Z' })
  );
};

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentCloud */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentCloud = function DocumentCloud(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentCloud' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L19,23 M18,1 L18,6 L23,6 M11,13 L6.00166547,13 C4.34389141,13 3,14.3465171 3,16 L3,16 C3,17.6568542 4.34306961,19 5.9906311,19 L7,19 L7,20.0093689 C7,21.6610488 8.33902013,23 10.0016655,23 L11.9983345,23 C13.6561086,23 15,21.6569304 15,20.0093689 L15,19 M11,19 L15.9983345,19 C17.6561086,19 19,17.6534829 19,16 L19,16 C19,14.3431458 17.6569304,13 16.0093689,13 L15,13 L15,11.9906311 C15,10.3389512 13.6609799,9 11.9983345,9 L10.0016655,9 C8.34389141,9 7,10.3430696 7,11.9906311 L7,13' })
  );
};

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentConfig = function DocumentConfig(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentConfig' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L16,23 M18,1 L18,6 L23,6 M9,14 L9,11 M9,20 C10.6568542,20 12,18.6568542 12,17 C12,15.3431458 10.6568542,14 9,14 C7.34314575,14 6,15.3431458 6,17 C6,18.6568542 7.34314575,20 9,20 Z M9,23 L9,20 M12,17 L15,17 M3,17 L6,17 M5,13 L7,15 M11,19 L13,21 M13,13 L11,15 M7,19 L5,21' })
  );
};

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentCsv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentCsv = function DocumentCsv(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentCsv' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M7,13 C7,13 6.00000004,13 5,13 C3.99999996,13 3,13.5 3,14.5 L3,16 C3,16 3.00000001,16.5 3,17.5 C2.99999999,18.5 4,19 5,19 L7,19 M13.25,13 C13.25,13 12.25,13 10.75,13 C9.25,13 8.75,13.5 8.75,14.5 C8.75,15.5 9.25,16 10.75,16 C12.25,16 12.75,16.5 12.75,17.5 C12.75,18.5 12.25,19 10.75,19 C9.25,19 8.25,19 8.25,19 M20.5,12 C20.5,12 20.5,12 20.5,12.5 C20.5,13 18,19 18,19 L17.5,19 C17.5,19 15,13 15,12.5 L15,12' })
  );
};

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentDownload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentDownload = function DocumentDownload(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentDownload' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M12,9 L12,18 M8,15 L12,19 L16,15' })
  );
};

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentExcel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentExcel = function DocumentExcel(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentExcel' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M9.25,12 L7.25,15.25 L5.25,12 L5,12 L7.25,15.5 L4.75,19 L5,19 L7.25,15.75 L9.5,19 L9.75,19 L7.25,15.5 L9.5,12 L9.25,12 Z' })
  );
};

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentImage = function DocumentImage(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentImage' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L19.9999998,23 M18,1 L18,6 L23,6 M3,11 L16,11 L16,23 L3,23 L3,11 Z M7,16 C7.55228475,16 8,15.5522847 8,15 C8,14.4477153 7.55228475,14 7,14 C6.44771525,14 6,14.4477153 6,15 C6,15.5522847 6.44771525,16 7,16 Z M5,23 L7,20 L9,22 L13,16 L16,20' })
  );
};

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentLocked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentLocked = function DocumentLocked(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentLocked' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L17,23 M18,1 L18,6 L23,6 M4,15 L14,15 L14,23 L4,23 L4,15 Z M6,15 L6,13 C6,11.3431458 7.34314575,10 9,10 C10.6568542,10 12,11.3431458 12,13 L12,15 M8,19 L10,19' })
  );
};

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentMissing = function DocumentMissing(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentMissing' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M9,12 L15,18 M15,12 L9,18' })
  );
};

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentNotes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentNotes = function DocumentNotes(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentNotes' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M9.75,12 L9.75,18.5 L9.5,18.5 L4.5,12 L4,12 L4,19 L4.25,19 L4.25,12.5 L4.5,12.5 L9.5,19 L10,19 L10,12 L9.75,12 Z' })
  );
};

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentOutlook */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentOutlook = function DocumentOutlook(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentOutlook' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2.99787498,8.99999999 L2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L2,23 M16,1 L16,6 L21,6 M7.75,15.75 C7.75,13.5 6.49999991,12 5,12 C3.50000009,12 2.25,13.5 2.25,15.75 C2.25,18 3.50000006,19.5000002 5.00000003,19.5000001 C6.5,19.5 7.75,18 7.75,15.75 Z M5,12 C7.42537405,12 8,14.5 8,15.75 C8,17 7.5,19.5 5,19.5 C2.5,19.5 2,17 2,15.75 C2,14.5 2.559,12 5,12 Z' })
  );
};

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentPdf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentPdf = function DocumentPdf(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentPdf' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M3,12 L3.24999995,12 L4.49999995,12 C6.5,12 6.75,13.25 6.75,14 C6.75,14.75 6.5,16 4.49999995,16 L3.24999995,16 L3.24999995,18 L3,17.9999999 L3,12 Z M9.5,18 L9.5,12 C9.5,12 10.4473684,12 11.2052633,12 C12.3421053,12 13.5,12.5 13.5,15 C13.5,17.5 12.3421053,18 11.2052633,18 C10.4473684,18 9.5,18 9.5,18 Z M16.5,19 L16.5,12 L20.5,12 M16.5,15.5 L19.5,15.5' })
  );
};

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentPerformance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentPerformance = function DocumentPerformance(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentPerformance' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M3,19 L8,14 L12,18 L18.5,11.5 M19,17.0003099 L19,11 L13,11' })
  );
};

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentPpt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentPpt = function DocumentPpt(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentPpt' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M4,12 L4.24999995,12 L5.49999995,12 C7.5,12 9,12.5 8.99999995,14.25 C8.9999999,16 7.5,16.5 5.49999995,16.5 L4.24999995,16.5 L4.24999995,19 L4,18.9999999 L4,12 Z' })
  );
};

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentRtf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentRtf = function DocumentRtf(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentRtf' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M20.5,12 L16.5,12 L16.5,19 M19.5,15.5 L16.5,15.5 M8.5,12 L14.5,12 M11.5,12 L11.5,19 M3,19 L3,12 L4.5,12 C5,12 7,12 7,14 C7,16 5,16 4.5,16 C4,16 3,16 3,16 M5.25,16 L7.5,19' })
  );
};

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentSound */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentSound = function DocumentSound(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentSound' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2.99787498,8.99999999 L2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L18,23 M16,1 L16,6 L21,6 M1,14.0104121 L1,18.0104121 L4,18.0104121 L8,21.0104121 L8,11 L4,14.0104121 L1,14.0104121 Z M11,18 L11,18 C12.1045695,18 13,17.1045695 13,16 C13,14.8954305 12.1045695,14 11,14 M11,22 L11,22 C14.3137085,22 17,19.3137085 17,16 C17,12.6862915 14.3137085,10 11,10' })
  );
};

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentStore = function DocumentStore(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentStore' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L17,23 M18,1 L18,6 L23,6 M3,12 C3,12 4,10 9,10 C14,10 15,12 15,12 L15,21 C15,21 14,23 9,23 C4,23 3,21 3,21 L3,12 Z M3,17 C3,17 5,19 9,19 C13,19 15,17 15,17 M3,13 C3,13 5,15 9,15 C13,15 15,13 15,13' })
  );
};

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentTest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentTest = function DocumentTest(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentTest' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,5.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L20,23 M18,1 L18,6 L23,6 M6,9 L14,9 M8,9 L8,13.5 L3,21.5 L3,23 L17,23 L17,21.4188612 L12,13.5 L12,9 M5.5,17.5 C5.5,17.5 7.5,19.0000002 10,17.5000001 C12.5,16 14.5,17.5000001 14.5,17.5000001' })
  );
};

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentText = function DocumentText(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentText' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,16 L16,16 L6,16 L6,16 Z M6,12 L18,12 L6,12 L6,12 Z M6,8 L11,8 L6,8 L6,8 Z M14,1 L14,8 L21,8 M3,23 L3,1 L15,1 L21,7 L21,23 L3,23 Z' })
  );
};

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentThreat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentThreat = function DocumentThreat(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentThreat' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L17,23 M18,1 L18,6 L23,6 M9,23 C11.7614237,23 14,20.7614237 14,18 C14,15.2385763 11.7614237,13 9,13 C6.23857625,13 4,15.2385763 4,18 C4,20.7614237 6.23857625,23 9,23 Z M9,11 C9,11 9,10 9,9 C9,8 9,7 11,7 C13,7 13.0000001,8 13,9 C12.9999999,10 13,10.9999998 15,10.9999999 C17,11.0000001 17,11 17,11 M8,11 L10,11 L10,13 L8,13 L8,11 Z' })
  );
};

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentTime = function DocumentTime(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentTime' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L17,23 M18,1 L18,6 L23,6 M10,23 C13.8659932,23 17,19.8659932 17,16 C17,12.1340068 13.8659932,9 10,9 C6.13400675,9 3,12.1340068 3,16 C3,19.8659932 6.13400675,23 10,23 Z M10,12 L10,16 L13,19' })
  );
};

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentTransfer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentTransfer = function DocumentTransfer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentTransfer' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M8,12 L4,16 L8,20 M4,16 L15,16' })
  );
};

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentTxt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentTxt = function DocumentTxt(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentTxt' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M2,12 L7,12 M4.5,12 L4.5,19 M16,12 L21,12 M18.5,12 L18.5,19 M14.5,11.5 L8.5,18.5 M8.5,11.5 L14.5,18.5' })
  );
};

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentUpdate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentUpdate = function DocumentUpdate(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentUpdate' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2.99787498,6.99999999 L2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L15,23 M16,1 L16,6 L21,6 M8,23 C11.8659932,23 15,19.8659932 15,16 C15,12.1340068 11.8659932,9 8,9 C4.13400675,9 1,12.1340068 1,16 C1,19.8659932 4.13400675,23 8,23 Z M4.5,16.5 L8,13 L11.5,16.5 M8,13.5 L8,20' })
  );
};

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentUpload = function DocumentUpload(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentUpload' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M12,20 L12,11 M8,14 L12,10 L16,14' })
  );
};

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentUser = function DocumentUser(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentUser' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L16,23 M18,1 L18,6 L23,6 M8,11 C6.34325,11 5,12.34325 5,14 C5,15.65675 6.34325,17 8,17 C9.65675,17 11,15.65675 11,14 C11,12.34325 9.65675,11 8,11 L8,11 Z M3,23 L3,22 C3,18 6,17 8,17 C10,17 13,18 13,22 L13,23 L3,23 Z' })
  );
};

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentVerified */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentVerified = function DocumentVerified(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentVerified' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M7.5,15 L10.5,18 L16.5,12' })
  );
};

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentVideo = function DocumentVideo(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentVideo' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L22.9999998,23 L4,23 M18,1 L18,6 L23,6 M3,10 L12,10 L12,19 L3,19 L3,10 Z M12,13 L17,10.5 L17,18.5 L12,16 L12,13 Z' })
  );
};

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentWindows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentWindows = function DocumentWindows(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentWindows' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M14.25,11.5 L8.25,18.5 M8.25,11.5 L14.25,18.5 M20.5,12 L16.5,12 L16.5,18 L20.5,18 M19.5,15 L16.5,15 M7,12 L3,12 L3,18 L7,18 M6,15 L3,15' })
  );
};

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentWord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentWord = function DocumentWord(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentWord' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M14,12 L12.5,18.75 L12.25,18.75 L9.5,12 L9,12 L6.25,18.75 L6,18.75 L4.5,12 L4,12 L6,19 L6.5,19 L9,12.5 L9.5,12.5 L12,19 L12.5,19 L14.5,12 L14,12 Z' })
  );
};

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentZip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DocumentZip = function DocumentZip(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DocumentZip' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M2,13 L7,13 L7,14 L3,18 L3,19 L8,19 M11,12 L11,20 L11,12 Z M15,13 L15,20 L15,13 Z M20,15 C20,13.895 19.105,13 18,13 L15,13 L15,17 L18,17 C19.105,17 20,16.105 20,15 Z' })
  );
};

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Document */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Document = function Document(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Document' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M14,1 L14,8 L21,8 M21,23 L3,23 L3,1 L15,1 L18,4 L21,7 L21,23 L21,23 L21,23 Z' })
  );
};

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Domain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Domain = function Domain(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Domain' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M13,3 L13,7 L13,3 Z M9,3 L9,7 L9,3 Z M5,3 L5,7 L5,3 Z M1,7 L23,7 L1,7 Z M1,21 L23,21 L23,3 L1,3 L1,21 Z' })
  );
};

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Dos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Dos = function Dos(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Dos' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#333', fillRule: 'evenodd', d: 'M0,4.54603675 L4.93388435,4.42224753 C5.89173496,4.40127916 6.77758573,4.50447894 7.67366806,4.81357302 L7.67366806,4.98877266 C6.90124863,5.64776074 6.34520769,6.43066436 5.84032455,7.30628357 L2.84298349,7.32712563 L2.8634466,15.8248762 L4.63514814,15.9481601 L6.44802853,15.9275707 C7.52954204,15.9169602 8.52857152,14.1868164 8.62153974,13.2494289 L8.88907602,10.2935194 C9.00263368,8.99562738 9.75446367,7.9965979 10.9183349,7.46076745 C11.6497018,8.68653329 11.9689011,10.0461936 11.9689011,11.4778537 C11.9689011,15.9794864 9.17795963,18.8219646 4.77927415,18.6572491 L0,18.4719443 L0,4.54603675 Z M20.7035438,8.71765744 C20.4667022,7.34751295 19.3235467,6.66780912 17.9531496,6.66780912 C17.0163936,6.66780912 15.4814074,7.0793451 15.4301233,8.25382683 C15.4193865,8.31584776 15.4301233,8.36700554 15.4505864,8.41904754 L16.0066274,10.0154231 C16.1200587,10.344854 16.1406481,10.7052322 16.1406481,11.0556315 C16.1406481,11.4570622 16.0891114,11.8588719 16.0378273,12.2606816 C14.0602315,11.7045143 12.6693712,10.74679 12.6693712,8.52174206 C12.6693712,5.52427469 15.0900819,4.12305658 17.8504551,4.12305658 C20.9199223,4.12305658 23.3199172,5.55547462 23.5158326,8.71765744 L20.7035438,8.71765744 Z M12.4634769,14.0839198 L15.2136185,14.1046356 C15.5019968,15.8658529 16.6658681,16.3501466 18.3963907,16.3501466 C19.4779043,16.3501466 21.0949956,16.0927156 21.0949956,14.7123396 C21.0949956,13.9913305 20.5284705,13.6202155 19.9517138,13.3011425 L20.0957135,10.5511273 C22.2896878,11.1480944 24,11.9723032 24,14.5472452 C24,17.5965019 21.0949956,18.8839097 18.4169802,18.8839097 C16.5012789,18.8839097 14.0189263,18.3276162 12.9989284,16.5149884 C12.6797291,15.9585685 12.3812455,15.2376858 12.3812455,14.5886767 C12.3812455,14.5372662 12.3912244,14.4857295 12.4017086,14.4343191 L12.4634769,14.0839198 Z M19.7047038,11.4570369 C19.7047038,13.033202 19.282431,14.506041 18.561422,15.8864171 C18.3757382,15.8965223 18.1904333,15.9169854 18.0050021,15.9169854 C17.4075297,15.9169854 15.9552801,15.515681 15.9552801,14.7844405 C15.9552801,14.6610302 15.9757432,14.537241 16.0170484,14.4236833 L16.5627314,12.600824 C16.6762891,12.2401932 16.6351102,11.8074362 16.6351102,11.4471843 C16.6351102,10.0357347 15.996459,9.15001021 15.9447959,8.18180172 C15.9141012,7.50235052 17.2016354,7.18251962 17.6549818,7.18251962 C17.9639495,7.18251962 18.2726647,7.18251962 18.5816325,7.2133406 C19.3234835,8.52184311 19.7047038,9.9432717 19.7047038,11.4570369 Z M10.6096071,17.0296989 L11.2583637,16.1030482 L12.3397509,16.1232587 C12.8549919,17.2460774 13.6995375,18.0083916 14.7295143,18.6676323 C13.9775579,18.9149581 13.2359595,19.0383683 12.4530559,19.0383683 C11.3097741,19.0383683 10.2383658,18.780811 9.17769436,18.3791276 L10.6096071,17.0296989 Z M12.5356662,6.70871009 C12.3705719,6.69847853 12.2058564,6.68837329 12.0412673,6.68837329 C10.3003867,6.68837329 8.71411639,8.21249639 8.50822209,9.92242964 L8.05487567,13.640906 C7.99310738,14.1663786 7.53976097,14.7018301 7.19971958,15.0830504 C6.91159387,15.3917655 6.5716788,15.4536601 6.14927969,15.4536601 L6.09774295,15.4536601 C5.56216513,14.2179153 5.28401835,12.9406128 5.28401835,11.591184 C5.28401835,7.35784556 7.65306599,4 12.0617304,4 C12.9269917,4 13.7508216,4.16471544 14.5644199,4.39132549 C13.6995375,5.02985046 13.019581,5.74075423 12.5356662,6.70871009 Z' })
  );
};

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Down */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Down = function Down(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Down' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7.086 3.174 17.086 13.174 7.086 23.174', transform: 'scale(1 -1) rotate(-89 -1.32 0)' })
  );
};

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Download */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Download = function Download(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Download' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,17 L1,23 L23,23 L23,17 M12,2 L12,19 M5,12 L12,19 L19,12' })
  );
};

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Drag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Drag = function Drag(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Drag' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,5 L17,5 L17,3 L15,3 L15,5 Z M7,5 L9,5 L9,3 L7,3 L7,5 Z M15,13 L17,13 L17,11 L15,11 L15,13 Z M7,13 L9,13 L9,11 L7,11 L7,13 Z M15,21 L17,21 L17,19 L15,19 L15,21 Z M7,21 L9,21 L9,19 L7,19 L7,21 Z' })
  );
};

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Drawer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Drawer = function Drawer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Drawer' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000000', strokeWidth: '2', d: 'M1,14 L6,2 L18,2 L23,14 L21,22 L3,22 L1,14 Z M1,14 L23,14' })
  );
};

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DriveCage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DriveCage = function DriveCage(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'DriveCage' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,23 L1,2 L23,2 L23,23 M1,8 L23,8 L1,8 Z M1,14 L23,14 L1,14 Z M1,20 L23,20 L1,20 Z M4,5 L16,5 L4,5 Z M18,5 L20,5 L18,5 Z M18,11 L20,11 L18,11 Z M18,17 L20,17 L18,17 Z M4,11 L16,11 L4,11 Z M4,17 L16,17 L4,17 Z' })
  );
};

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Dropbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Dropbox = function Dropbox(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Dropbox' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#007EE5', fillRule: 'evenodd', d: 'M7.0599,1 L0.00015,5.6095 L4.8819,9.5185 L12.00015,5.1235 L7.0599,1 Z M0,13.4281 L7.05975,18.0376 L12,13.9141 L4.88175,9.5191 L0,13.4281 Z M11.99985,13.914175 L16.9401,18.037675 L23.99985,13.428175 L19.1181,9.518425 L11.99985,13.914175 Z M24,5.609575 L16.94025,1.000075 L12,5.123575 L19.11825,9.518575 L24,5.609575 Z M12.014475,14.801275 L7.059975,18.912775 L4.939725,17.528275 L4.939725,19.080025 L12.014475,23.322775 L19.089225,19.080025 L19.089225,17.528275 L16.968975,18.912775 L12.014475,14.801275 Z' })
  );
};

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Duplicate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Duplicate = function Duplicate(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Duplicate' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.5,17 L1,17 L1,1 L1,1 L17,1 L17,4.5 M7,7 L23,7 L23,23 L7,23 L7,7 Z M15,11 L15,19 L15,11 Z M11,15 L19,15 L11,15 Z' })
  );
};

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Dxc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Dxc = function Dxc(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Dxc' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fillRule: 'evenodd', d: 'M12,14 L16,21 L8,21 L12,14 Z M12,10 L8,3 L16,3 L12,10 Z M2,18 C0.65763624,18 -0.00903042669,18 1.01172597e-13,18 L1.01172597e-13,6 L2,6 C5.3137085,6 8,8.6862915 8,12 C8,15.3137085 5.3137085,18 2,18 Z M22,18 C18.6862915,18 16,15.3137085 16,12 C16,8.6862915 18.6862915,6 22,6 L24,6 L24,18 C24.0090304,18 23.3423638,18 22,18 Z' })
  );
};

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Edge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Edge = function Edge(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Edge' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#00A1F1', fillRule: 'evenodd', d: 'M5.487,6.3566 C2.632,8.1336 1,10.6596 1,10.6596 C1,10.6596 1.423,5.3636 5.487,2.2646 C7.103,1.0326 9.313,-0.0004 12.285,-0.0004 C13.402,-0.0004 15.744,0.1946 17.853,1.4946 C19.962,2.7946 20.814,3.8846 21.764,5.4786 C22.174,6.1666 22.508,7.0506 22.716,7.9036 C23.107,9.5016 23.154,11.4116 23.154,11.4116 L23.154,13.9286 L8.081,13.9286 C8.081,13.9286 7.713,18.9936 14.645,18.9936 C17.056,18.9936 17.9,18.6146 18.693,18.3796 C19.934,18.0126 21.133,17.1926 21.133,17.1926 L21.135,22.2526 C21.135,22.2526 18.298,23.9996 14.012,23.9996 C12.805,23.9996 11.533,23.8986 10.306,23.5006 C9.234,23.1526 6.99,22.2146 5.487,20.0166 C4.956,19.2386 4.38,18.2036 4.094,17.1926 C3.786,16.0996 3.79,15.0376 3.79,14.4526 C3.79,12.2646 4.537,10.1756 5.834,8.6656 C7.515,6.7096 9.638,5.8476 9.638,5.8476 C9.638,5.8476 8.947,6.6546 8.521,7.6586 C8.096,8.6626 7.979,9.6726 7.979,9.6726 L16.49,9.6726 C16.49,9.6726 16.988,4.5866 11.675,4.5866 C9.672,4.5866 7.213,5.2816 5.487,6.3566' })
  );
};

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Edit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Edit = function Edit(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Edit' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M14,4 L20,10 L14,4 Z M22.2942268,5.29422684 C22.6840146,5.68401459 22.6812861,6.3187139 22.2864907,6.71350932 L9,20 L2,22 L4,15 L17.2864907,1.71350932 C17.680551,1.319449 18.3127724,1.31277239 18.7057732,1.70577316 L22.2942268,5.29422684 Z M3,19 L5,21 M7,17 L15,9' })
  );
};

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Eject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Eject = function Eject(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Eject' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M21,14 L12,2 L3,14 L21,14 Z M2,22 L22,22 L22,18 L2,18 L2,22 Z' })
  );
};

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Elevator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Elevator = function Elevator(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Elevator' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeWidth: '2', d: 'M1,2.991155 C1,1.89147046 1.88967395,1 2.991155,1 L21.008845,1 C22.1085295,1 23,1.88967395 23,2.991155 L23,21.008845 C23,22.1085295 22.1103261,23 21.008845,23 L2.991155,23 C1.89147046,23 1,22.1103261 1,21.008845 L1,2.991155 Z M16.5,8 L18,10 L15,10 L16.5,8 Z M16.5,16 L18,14 L15,14 L16.5,16 Z M5,13 L6.55613518,9.88772964 C6.80127495,9.3974501 7.44386482,9 8,9 L8,9 C8.55228475,9 9.19907951,9.39815903 9.44386482,9.88772964 L11,13 M6.5,18 L7.75,10 L8,10 L8.25,10 L9.5,18 M8,7 C8.55228475,7 9,6.55228475 9,6 C9,5.44771525 8.55228475,5 8,5 C7.44771525,5 7,5.44771525 7,6 C7,6.55228475 7.44771525,7 8,7 Z' })
  );
};

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Emergency */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Emergency = function Emergency(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Emergency' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fillRule: 'evenodd', d: 'M10,7.17157288 L10,2 L14,2 L14,7.17157288 L17.6568542,3.51471863 L20.4852814,6.34314575 L16.8284271,10 L22,10 L22,14 L16.8284271,14 L20.4852814,17.6568542 L17.6568542,20.4852814 L14,16.8284271 L14,22 L10,22 L10,16.8284271 L6.34314575,20.4852814 L3.51471863,17.6568542 L7.17157288,14 L2,14 L2,10 L7.17157288,10 L3.51471863,6.34314575 L6.34314575,3.51471863 L10,7.17157288 Z' })
  );
};

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Emoji */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Emoji = function Emoji(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Emoji' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M12,1.73A10.27,10.27,0,1,0,22.24,12,10.25,10.25,0,0,0,12,1.73ZM21,12a9,9,0,1,1-9-9A9,9,0,0,1,21,12Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M8.8,11.05a1.55,1.55,0,1,0-1.51-1.5A1.56,1.56,0,0,0,8.8,11.05Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M15.44,11.05a1.55,1.55,0,1,0,0-3.09,1.53,1.53,0,0,0-1.51,1.59A1.51,1.51,0,0,0,15.44,11.05Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M12.19,16.35A6.58,6.58,0,0,1,6.9,13.5a5.71,5.71,0,0,0,5.3,4,5.54,5.54,0,0,0,5.31-4A6.27,6.27,0,0,1,12.19,16.35Z' })
  );
};

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EmptyCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var EmptyCircle = function EmptyCircle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'EmptyCircle' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 C9.790861,8 8,9.790861 8,12 C8,14.209139 9.790861,16 12,16 Z' })
  );
};

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Erase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Erase = function Erase(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Erase' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,21 L22,6 L18,2 L2,18 L5,21 L19,21 M6,14 L10,18' })
  );
};

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Escalator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Escalator = function Escalator(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Escalator' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeWidth: '2', d: 'M22,9 C22,7.8954305 21.1017394,7 20.0020869,7 L16,7 L6,17 L4,17 C2.8954305,17 2,17.8877296 2,19 L2,19 C2,20.1045695 2.89826062,21 3.99791312,21 L8,21 L18,11 L20,11 C21.1045695,11 22,10.1122704 22,9 L22,9 Z M7,9 C7.55228475,9 8,8.55228475 8,8 C8,7.44771525 7.55228475,7 7,7 C6.44771525,7 6,7.44771525 6,8 C6,8.55228475 6.44771525,9 7,9 Z M7,15 L7,12.495389 C7,12.2217932 7.23193359,12 7.5,12 L7.5,12 C7.77614237,12 8,12.214035 8,12.5046844 L8,14 L7,15 Z M12,4 C12.5522847,4 13,3.55228475 13,3 C13,2.44771525 12.5522847,2 12,2 C11.4477153,2 11,2.44771525 11,3 C11,3.55228475 11.4477153,4 12,4 Z M12,10 L12,7.49538898 C12,7.2217932 12.2319336,7 12.5,7 L12.5,7 C12.7761424,7 13,7.21403503 13,7.50468445 L13,9 L12,10 Z' })
  );
};

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Expand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Expand = function Expand(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Expand' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M10,14 L2,22 M1,15 L1,23 L9,23 M22,2 L14,10 M15,1 L23,1 L23,9' })
  );
};

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FacebookOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FacebookOption = function FacebookOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FacebookOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#3B5998', fillRule: 'evenodd', d: 'M9.94474914,22 L9.94474914,13.1657526 L7,13.1657526 L7,9.48481614 L9.94474914,9.48481614 L9.94474914,6.54006699 C9.94474914,3.49740494 11.8713513,2 14.5856738,2 C15.8857805,2 17.0033128,2.09717672 17.3287076,2.13987558 L17.3287076,5.32020466 L15.4462767,5.32094085 C13.9702212,5.32094085 13.6256856,6.02252733 13.6256856,7.05171716 L13.6256856,9.48481614 L17.306622,9.48481614 L16.5704347,13.1657526 L13.6256856,13.1657526 L13.6845806,22' })
  );
};

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Facebook */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Facebook = function Facebook(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Facebook' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#3B5998', fillRule: 'evenodd', d: 'M23.00025,0 L1.0005,0 C0.44775,0 0,0.44775 0,0.99975 L0,23.00025 C0,23.55225 0.44775,24 1.0005,24 L12.75,24 L12.75,15 L9.75,15 L9.75,11.25 L12.75,11.25 L12.75,8.25 C12.75,5.15025 14.71275,3.62475 17.478,3.62475 C18.8025,3.62475 19.941,3.72375 20.2725,3.76725 L20.2725,7.00725 L18.35475,7.008 C16.851,7.008 16.5,7.72275 16.5,8.77125 L16.5,11.25 L20.25,11.25 L19.5,15 L16.5,15 L16.56,24 L23.00025,24 C23.55225,24 24,23.55225 24,23.00025 L24,0.99975 C24,0.44775 23.55225,0 23.00025,0' })
  );
};

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Fan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Fan = function Fan(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Fan' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z M15,12 C19,15 20,19 20,19 M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,9 C15,4 19,3 19,3 M12,15 C9,19 5,20 5,20 M9,12 C5,9 4,5 4,5' })
  );
};

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FastForward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FastForward = function FastForward(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FastForward' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '9 2.059 9 8 1 2.059 1 22.059 9 16 9 22.059 22 12.059' })
  );
};

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Favorite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Favorite = function Favorite(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Favorite' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,8.4 C1,4 4.5,3 6.5,3 C9,3 11,5 12,6.5 C13,5 15,3 17.5,3 C19.5,3 23,4 23,8.4 C23,15 12,21 12,21 C12,21 1,15 1,8.4 Z' })
  );
};

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Fedora */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Fedora = function Fedora(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Fedora' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#4F6DB1', fillRule: 'evenodd', d: 'M11.9998121,0 C5.3752955,0 0.00469667319,5.36825049 0,11.9918748 L0,21.278137 C0.00352250489,22.7820587 1.22334247,23.9996243 2.72820352,23.9996243 L12.0046967,23.9996243 C18.6300587,23.9970411 24,18.6261605 24,12.0002818 C24,5.37285323 18.6273346,0 11.9998121,0 L11.9998121,0 Z M16.595319,5.57654795 C16.2162505,5.57654795 16.0784971,5.50370254 15.5230685,5.50370254 C13.883225,5.50370254 12.5531742,6.83187476 12.5504031,8.4717182 L12.5504031,11.0548415 C12.5504031,11.2862935 12.7382701,11.4738787 12.9702857,11.4738787 L14.9232094,11.4743014 C15.650771,11.4743014 16.2386536,12.0546693 16.2386536,12.7841566 C16.2390763,13.5183875 15.6447123,14.096454 14.9093542,14.096454 L12.5503562,14.096454 L12.5503562,17.0814247 C12.5503562,20.1916086 10.0288063,22.7134873 6.91852838,22.7134873 C6.44665362,22.7134873 6.11112329,22.6601331 5.67428571,22.5460978 C5.03736986,22.379319 4.51688454,21.8570489 4.51669667,21.2496282 C4.51669667,20.5156791 5.04962818,19.9814795 5.84627789,19.9814795 C6.22548728,19.9814795 6.3629589,20.0543249 6.91857534,20.0543249 C8.55832485,20.0543249 9.88837573,18.7260587 9.89133464,17.0864031 L9.89133464,14.5031389 C9.89133464,14.271499 9.70313894,14.0840078 9.47140509,14.0840078 L7.51848141,14.083773 C6.79082583,14.083773 6.20294325,13.5033581 6.20294325,12.7738239 C6.20256751,12.039499 6.79688454,11.4616204 7.53233659,11.4616204 L9.89100587,11.4616204 L9.89100587,8.47646184 C9.89100587,5.36627789 12.4128845,2.84449315 15.5230685,2.84449315 C15.9949432,2.84449315 16.3304736,2.89775342 16.7671703,3.01197652 C17.404274,3.17856751 17.9246184,3.70083757 17.9249941,4.30825832 C17.9249941,5.04248924 17.3920157,5.57654795 16.595319,5.57654795 L16.595319,5.57654795 Z' })
  );
};

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Filter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Filter = function Filter(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Filter' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '3 6 10 13 10 21 14 21 14 13 21 6 21 3 3 3' })
  );
};

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FingerPrint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FingerPrint = function FingerPrint(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FingerPrint' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeWidth: '2', d: 'M14,15 C14,13.8954305 13.1045695,13 12,13 C10.8954305,13 10,13.8954305 10,15 C10,16.1045695 10.8954305,17 12,17 L12,17 M12,20 C9.23857625,20 7,17.7614237 7,15 C7,12.2385763 9.23857625,10 12,10 C14.7614237,10 17,12.2385763 17,15 C17,15.8284271 17.6715729,16.5 18.5,16.5 C19.3284271,16.5 20,15.8284271 20,15 C20,10.581722 16.418278,7 12,7 C7.581722,7 4,10.581722 4,15 C4,19.418278 7.581722,23 12,23 L14,23 M1,15 C1,17.6720798 1.95275656,20.1216314 3.53708682,22.0274719 M20.5202529,8.04207866 C18.5030558,5.574886 15.4354451,4 12,4 C8.59642702,4 5.55389491,5.54579976 3.53616098,7.97364199 M18.5259055,2.61083013 C16.577286,1.58228463 14.3566429,1 12,1 C9.66126395,1 7.45646883,1.57346929 5.51856118,2.58746134' })
  );
};

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Fireball */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Fireball = function Fireball(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Fireball' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,13 L10.25,14 L11,12 L9.75,11 L11.25,11 L12,9.25 L12.75,11 L14.25,11 L13,12 L13.75,14 L12,13 Z' })
  );
};

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Firefox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Firefox = function Firefox(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Firefox' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#E66000', fillRule: 'evenodd', d: 'M4.24954645,1 C4.20019837,2.2660337 4.15311916,3.47137493 4.10547273,4.68409001 C4.72941407,4.52980633 5.34030936,4.43848401 5.93475529,4.69429995 C7.22631387,2.92627708 9.08339018,2.31821789 11.1293506,2.093599 C11.1418294,2.1140189 11.1548754,2.1344388 11.1673543,2.1548587 C11.1265145,2.19853459 11.0868091,2.24277771 11.0448349,2.28531916 C10.2252028,3.11799724 9.56609389,4.0641192 9.09700345,5.13219333 C8.96257245,5.43792459 8.93137538,5.78960062 8.8587713,6.12142397 C8.83041033,6.25074999 8.89564056,6.31995076 9.02666824,6.33810178 C9.633593,6.42091581 10.2393833,6.51791033 10.848577,6.58767831 C11.2308828,6.63135421 11.6177265,6.63929528 12.0028684,6.65517742 C12.1832442,6.66255127 12.2609533,6.75217194 12.2649238,6.92233776 C12.2802387,7.60640436 12.0516493,8.192342 11.5059842,8.61265157 C10.9801719,9.01707901 10.3760832,9.27573105 9.72491533,9.41640146 C9.65741622,9.43114917 9.59048433,9.45100185 9.51674581,9.47028731 C9.58197604,10.3023982 9.64663905,11.1191941 9.7152726,11.9847709 C9.08339018,11.6818757 8.4787343,11.3925939 7.86103238,11.0970725 C7.67498441,11.4890212 7.66137115,11.8769992 7.77878556,12.2729184 C8.09529399,13.3455303 9.21044733,13.9677699 10.3647388,13.6824586 C10.7691662,13.582628 11.1599804,13.4124621 11.5411518,13.2394602 C11.9172183,13.06816 12.2700288,12.8480788 12.6370197,12.6563587 C13.2592594,12.3319092 13.8860368,12.3602702 14.5111126,12.649552 C14.6001661,12.6909591 14.690354,12.7454121 14.7595547,12.8146129 C14.9943836,13.0494417 15.1770282,13.3177365 15.0828698,13.6716814 C14.9915475,14.0137147 14.7431054,14.2116743 14.4056098,14.2831439 C14.2116208,14.3245509 14.0096907,14.3421347 13.8117311,14.3415675 C13.6801362,14.3410003 13.609801,14.384109 13.5377641,14.490179 C12.8582353,15.4986951 11.9762091,16.2417525 10.7476119,16.4544598 C10.2314423,16.5435132 9.69768879,16.5287655 9.17187641,16.5582609 C9.10210842,16.5622315 9.03234044,16.5520215 8.91662768,16.5457821 C8.98639567,16.6104451 9.02156327,16.6501505 9.06353751,16.6813475 C10.4537923,17.7080147 11.9909568,18.0585562 13.6784345,17.654696 C15.0590466,17.3251416 16.2870766,16.7063052 17.3006976,15.6904153 C18.2666723,14.7216045 18.7085362,13.5400865 18.7227167,12.1940749 C18.7368972,10.8412566 18.4345692,9.56047519 17.7425616,8.38689825 C17.6217438,8.18156483 17.4640568,7.99778574 17.288786,7.75615028 C18.4799468,8.29614315 19.5298699,8.90987454 20.0159769,10.1764755 C20.1594834,8.59450055 19.8679326,7.09704134 19.2576046,5.6517663 C18.6478437,4.20762571 17.7726242,2.95747415 16.5763585,1.92059709 C16.6262738,1.93137426 16.6767563,1.93931533 16.7249699,1.95463025 C19.4192621,2.79865272 21.4879113,4.40445084 22.7806043,6.94616097 C23.4068145,8.17645985 23.7272934,9.49751384 23.8923543,10.8588404 C24.0693267,12.316027 24.0483396,13.7647054 23.6762437,15.1969344 C23.054004,17.5945708 21.7408911,19.5560155 19.9229529,21.2100272 C18.1929338,22.7840611 16.1776032,23.805056 13.8707219,24.097174 C8.73171416,24.7483419 4.68120042,22.8986394 1.80823415,18.5707554 C0.665287063,16.8486773 0.125861413,14.921833 0.022627482,12.8594232 C-0.144135022,9.50942545 0.61140122,6.38518099 2.2716524,3.47761434 C2.75492333,2.63018856 3.33745766,1.85423242 4.04875079,1.18094299 C4.09923331,1.13329656 4.1514175,1.08791901 4.24954645,1' })
  );
};

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FlagFill */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FlagFill = function FlagFill(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FlagFill' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fillRule: 'evenodd', stroke: '#000', strokeWidth: '2', d: 'M2,24 L2,2 C10,-1.5238864 13,6.64375708 22,2 L22,14 C14,18.895222 9,9.89651097 2,14' })
  );
};

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Flag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Flag = function Flag(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Flag' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,24 L2,2 C10,-1.5238864 13,6.64375708 22,2 L22,14 C14,18.895222 9,9.89651097 2,14' })
  );
};

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FolderCycle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FolderCycle = function FolderCycle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FolderCycle' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7.0001,18 C7.0001,15.239 9.2391,13 12.0001,13 C13.9851,13 15.6991,14.156 16.5,16 M17.0001,18 C17.0001,20.761 14.7611,23 12.0001,23 C10.0151,23 8.3011,21.844 7.5,20 M13.0001,16 L17.0001,16 L17.0001,12 M11.0001,20 L7.0001,20 L7.0001,24 M4.0001,23 L1.0001,23 L1.0001,5 L1.0001,1 L9.0001,1 L12.0001,5 L23.0001,5 L23.0001,23 L19.0001,23 M1.0001,9 L23.0001,9 M4,23 L1,23 L1,1 L9,1 L12,5 L23,5 L23,23 L19,23 M1,9 L23,9' })
  );
};

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FolderOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FolderOpen = function FolderOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FolderOpen' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,2 L11,1.99999998 L13,6 L19,6 L19,10 L5,10 L5,2 Z M2,10 L22,10 L19,22 L5,22 L2,10 Z' })
  );
};

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Folder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Folder = function Folder(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Folder' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,10 L2,6 L2,2 L10,2 L13,6 L22,6 L22,10 L2,10 Z M2,10 L22,10 L22,22 L2,22 L2,10 Z' })
  );
};

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormAdd = function FormAdd(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormAdd' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,18 L12,6 M6,12 L18,12' })
  );
};

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormAttachment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormAttachment = function FormAttachment(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormAttachment' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,13.2932321 C7.63138164,11.6618504 10.6214284,8.67180351 12.3609131,6.93231878 C15.1879856,4.10524628 19.4285943,8.34585492 16.6015218,11.1729275 C13.7744493,14 11.6541453,16.1203048 10.2406087,17.5338408 C8.82707218,18.9473767 6.70676816,16.8270724 8.12030436,15.4135364 C9.53384056,14.0000004 14.4812175,9.05262308 14.4812175,9.05262308' })
  );
};

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormCalendar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormCalendar = function FormCalendar(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormCalendar' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,19 L18,19 L18,8 L6,8 L6,19 Z M15,8 L15,5 L15,8 Z M9,8 L9,5 L9,8 Z M6,11.5 L18,11.5 L6,11.5 Z' })
  );
};

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormCheckmark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormCheckmark = function FormCheckmark(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormCheckmark' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '6 13 10.2 16.6 18 7' })
  );
};

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormClock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormClock = function FormClock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormClock' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 Z M12,8 L12,12 L15,13' })
  );
};

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormClose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormClose = function FormClose(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormClose' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,7 L17,17 M7,17 L17,7' })
  );
};

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormCut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormCut = function FormCut(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormCut' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M18,7.52380952 L10.1428571,13.8095238 L18,7.52380952 Z M18,15.9047619 L10.1428571,9.61904762 L18,15.9047619 Z M8.57142857,10.1428571 C9.43930461,10.1428571 10.1428571,9.43930461 10.1428571,8.57142857 C10.1428571,7.70355254 9.43930461,7 8.57142857,7 C7.70355254,7 7,7.70355254 7,8.57142857 C7,9.43930461 7.70355254,10.1428571 8.57142857,10.1428571 Z M8.57142857,16.4285714 C9.43930461,16.4285714 10.1428571,15.7250189 10.1428571,14.8571429 C10.1428571,13.9892668 9.43930461,13.2857143 8.57142857,13.2857143 C7.70355254,13.2857143 7,13.9892668 7,14.8571429 C7,15.7250189 7.70355254,16.4285714 8.57142857,16.4285714 Z' })
  );
};

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormDown = function FormDown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormDown' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '18 9 12 15 6 9' })
  );
};

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormEdit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormEdit = function FormEdit(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormEdit' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M11.9955241,8.33576576 L15.4932862,11.8335278 L11.9955241,8.33576576 Z M17.5365751,7.79609426 C17.9262629,8.18578207 17.9321949,8.81165877 17.5321697,9.21168397 L10.0807224,16.6631313 L6,17.829052 L7.16592069,13.7483296 L14.617368,6.29688224 C15.0094888,5.90476144 15.6393004,5.89881957 16.0329577,6.29247691 L17.5365751,7.79609426 Z' })
  );
};

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormFilter = function FormFilter(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormFilter' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '6 8 11.667 12.667 11.667 18 12.333 18 12.333 12.667 18 8 18 6 6 6' })
  );
};

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormFolder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormFolder = function FormFolder(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormFolder' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '6 18 6 6 10.8 6 12.6 8.4 18 8.4 18 18' })
  );
};

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormLocation = function FormLocation(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormLocation' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,17 C12,17 8,14 8,11 C8,8.5 10,7 12,7 C14,7 16,8.5 16,11 C16,14 12,17 12,17 Z M12,12 C12.5523333,12 13,11.5523333 13,11 C13,10.4476667 12.5523333,10 12,10 C11.4476667,10 11,10.4476667 11,11 C11,11.5523333 11.4476667,12 12,12 L12,12 Z' })
  );
};

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormLock = function FormLock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormLock' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M9,11 C9,11 9,8 9,8 C9,6.34314575 10.3431458,5 12,5 C13.6568542,5 15,6.34314575 15,8 L15,11 M12,13 L12,16 M17,18 L17,11 L7,11 L7,18 L17,18 Z' })
  );
};

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormNextLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormNextLink = function FormNextLink(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormNextLink' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,12.4 L18,12.4 M12.6,7 L18,12.4 L12.6,17.8' })
  );
};

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormNext = function FormNext(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormNext' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '9 6 15 12 9 18' })
  );
};

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormPreviousLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormPreviousLink = function FormPreviousLink(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormPreviousLink' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,12.4 L18,12.4 M12.6,7 L18,12.4 L12.6,17.8', transform: 'matrix(-1 0 0 1 24 0)' })
  );
};

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormPrevious */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormPrevious = function FormPrevious(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormPrevious' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '9 6 15 12 9 18', transform: 'matrix(-1 0 0 1 24 0)' })
  );
};

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormRefresh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormRefresh = function FormRefresh(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormRefresh' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17.3333333,9.33333333 C16.3982691,7.36020781 14.3579813,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 M18.5,6 L18.5,10 L14.5,10' })
  );
};

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormSchedule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormSchedule = function FormSchedule(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormSchedule' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,19 L18,19 L18,8 L6,8 L6,19 Z M8,15 L10,15 L8,15 Z M11,15 L16,15 L11,15 Z M15,8 L15,5 L15,8 Z M9,8 L9,5 L9,8 Z M6,11.5 L18,11.5 L6,11.5 Z' })
  );
};

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormSearch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormSearch = function FormSearch(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormSearch' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M13.8,13.8 L18,18 L13.8,13.8 Z M10.5,15 C12.9852814,15 15,12.9852814 15,10.5 C15,8.01471863 12.9852814,6 10.5,6 C8.01471863,6 6,8.01471863 6,10.5 C6,12.9852814 8.01471863,15 10.5,15 Z' })
  );
};

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormSubtract */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormSubtract = function FormSubtract(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormSubtract' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,12 L18,12' })
  );
};

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormTrash */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormTrash = function FormTrash(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormTrash' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7.5,9 L16.5,9 L16.5,19 L7.5,19 L7.5,9 Z M5,9 L19,9 M9.36363636,6 L14.3636364,6 L14.3636364,9 L9.36363636,9 L9.36363636,6 Z M10.5455,11 L10.5455,17 M13.5455,11 L13.5455,17' })
  );
};

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormUp = function FormUp(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormUp' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '18 9 12 15 6 9', transform: 'matrix(1 0 0 -1 0 24)' })
  );
};

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormUpload = function FormUpload(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormUpload' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,14.1818182 L6,17.4545455 L18,17.4545455 L18,14.1818182 M12,6 L12,14 M8.18181818,9.81818182 L12,6 L15.8181818,9.81818182' })
  );
};

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormViewHide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormViewHide = function FormViewHide(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormViewHide' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,12 L6,12 C6.5,14.5 9.27272727,17 12,17 C14.7272727,17 17.5,14.5 18,12 L21,12 M12,17 L12,20 M7.5,15.5 L5.5,17.5 M16.5,15.5 L18.5,17.5' })
  );
};

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var FormView = function FormView(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'FormView' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,17 C9.27272727,17 6,14.2222222 6,12 C6,9.77777778 9.27272727,7 12,7 C14.7272727,7 18,9.77777778 18,12 C18,14.2222222 14.7272727,17 12,17 Z M11,12 C11,12.55225 11.44775,13 12,13 C12.55225,13 13,12.55225 13,12 C13,11.44775 12.55225,11 12,11 C11.44775,11 11,11.44775 11,12 Z' })
  );
};

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ForwardTen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ForwardTen = function ForwardTen(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ForwardTen' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M20.8888889,7.55555556 C19.3304485,4.26701301 15.9299689,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 L12,22 C17.5228475,22 22,17.5228475 22,12 M22,4 L22,8 L18,8 M9,16 L9,9 L7,9.53333333 M17,12 C17,10 15.9999999,8.5 14.5,8.5 C13.0000001,8.5 12,10 12,12 C12,14 13,15.5000001 14.5,15.5 C16,15.4999999 17,14 17,12 Z M14.5,8.5 C16.9253741,8.5 17,11 17,12 C17,13 17,15.5 14.5,15.5 C12,15.5 12,13 12,12 C12,11 12.059,8.5 14.5,8.5 Z' })
  );
};

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Freebsd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Freebsd = function Freebsd(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Freebsd' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#9B2718', fillRule: 'evenodd', d: 'M23.7253418,0.403330656 C24.9975688,1.67496208 21.4706794,7.26490597 20.8744345,7.86115088 C20.2781896,8.45650302 18.7637754,7.90875554 17.4918461,6.63682558 C16.2196191,5.36519416 15.6715737,3.85048208 16.2678187,3.25423717 C16.8640636,2.65769514 22.4534125,-0.868896418 23.7253418,0.403330656 L23.7253418,0.403330656 Z M5.88500669,1.74874919 C3.94274831,0.64670772 1.17931401,-0.579104582 0.300120884,0.300088547 C-0.590973233,1.19058772 0.680063246,4.01650237 1.79341076,5.96233113 C2.78417662,4.23935071 4.19415887,2.78890453 5.88500669,1.74874919 L5.88500669,1.74874919 Z M21.785166,7.42259564 C21.9639794,8.02925383 21.9315489,8.53058725 21.6417578,8.81978414 C20.9639901,9.49755113 19.1338994,8.77634479 17.4844083,7.20599597 C17.3689674,7.10275387 17.2550141,6.99564356 17.1428465,6.88317878 C16.5466016,6.28633892 16.0821617,5.65081997 15.785527,5.06617893 C15.2077288,4.02989107 15.0631307,3.11410221 15.4999004,2.67762963 C15.7379223,2.43960776 16.1187574,2.37474692 16.583198,2.45864948 C16.8863778,2.2673395 17.2437081,2.05371455 17.6358493,1.83503223 C16.0414007,1.00344305 14.2288637,0.533647279 12.305647,0.533647279 C5.92785039,0.533647279 0.757122899,5.70348271 0.757122899,12.0821714 C0.757122899,18.4596702 5.92785039,23.6301005 12.305647,23.6301005 C18.683741,23.6301005 23.8544685,18.4596702 23.8544685,12.0821714 C23.8544685,10.0223894 23.313861,8.09084213 22.3692121,6.41635843 C22.1648105,6.78856511 21.9663598,7.12982838 21.785166,7.42259564 L21.785166,7.42259564 Z' })
  );
};

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Gallery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Gallery = function Gallery(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Gallery' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,1 L19,1 L19,19 L1,19 L1,1 Z M5,19 L5,23 L23,23 L23,5.97061363 L18.9998921,5.97061363 M6,8 C6.55228475,8 7,7.55228475 7,7 C7,6.44771525 6.55228475,6 6,6 C5.44771525,6 5,6.44771525 5,7 C5,7.55228475 5.44771525,8 6,8 Z M2,18 L7,12 L10,15 L14,10 L19,16' })
  );
};

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Gamepad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Gamepad = function Gamepad(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Gamepad' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,6 L12,2 M12,6 C14.4983324,6.0444148 16.0056152,6 17,6 C19,6 21,6.5 22,10 C23,13.5 23,15.5 23,18 C23,20.5 21,21 19,21 C17,21 15.9456522,17 12,17 C8.05434783,17 7,21 5,21 C3,21 1,20.5 1,18 C1,15.5 1,13.5 2,10 C3,6.5 5,6 7,6 C7.99438477,6 9.50166757,6.0444148 12,6 L12,6 L12,6 Z M18,15 C18.5522847,15 19,14.5522847 19,14 C19,13.4477153 18.5522847,13 18,13 C17.4477153,13 17,13.4477153 17,14 C17,14.5522847 17.4477153,15 18,15 Z M14,12 C14.5522847,12 15,11.5522847 15,11 C15,10.4477153 14.5522847,10 14,10 C13.4477153,10 13,10.4477153 13,11 C13,11.5522847 13.4477153,12 14,12 Z M4,12 L10,12 M7,9 L7,15' })
  );
};

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Gift */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Gift = function Gift(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Gift' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,11 L21,11 L21,23 L3,23 L3,11 Z M2,11 L2,7 L22,7 L22,11 L2,11 Z M12,23 L12,7 L12,23 Z M7,7 L12,7 C12,7 10,2 7,2 C3.5,2 3,7 7,7 Z M17.1843819,7 L12.1843819,7 C12.1843819,7 14,2 17.1843819,2 C20.5,2 21.1843819,7 17.1843819,7 Z' })
  );
};

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Github */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Github = function Github(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Github' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#333', fillRule: 'evenodd', d: 'M11.9989871,1 C5.92550416,1 1,5.92482888 1,12.0003376 C1,16.8603395 4.15153934,20.9829338 8.52263728,22.4374904 C9.0729918,22.5387827 9.27355045,22.199116 9.27355045,21.9073943 C9.27355045,21.6467356 9.2640965,20.954572 9.25869425,20.0368642 C6.19899322,20.7013414 5.55342398,18.5620492 5.55342398,18.5620492 C5.0530403,17.2911692 4.33183953,16.9528531 4.33183953,16.9528531 C3.33309801,16.2708186 4.40747107,16.2843243 4.40747107,16.2843243 C5.51155652,16.3619816 6.09229872,17.4181221 6.09229872,17.4181221 C7.07348292,19.0988981 8.66714755,18.6133706 9.2938089,18.3317781 C9.39375058,17.6213819 9.67804414,17.1365297 9.99205009,16.86169 C7.54955646,16.5841493 4.98146045,15.6401056 4.98146045,11.4249977 C4.98146045,10.224347 5.41026428,9.24181221 6.11390773,8.47334172 C6.00046042,8.19512569 5.62297799,7.07618404 6.22195279,5.56220265 C6.22195279,5.56220265 7.14506277,5.26642929 9.24653918,6.68992296 C10.12373,6.44547101 11.0650726,6.32392032 12.0003376,6.31919335 C12.9349274,6.32392032 13.8755947,6.44547101 14.7541361,6.68992296 C16.8542619,5.26642929 17.7760214,5.56220265 17.7760214,5.56220265 C18.3763467,7.07618404 17.9988643,8.19512569 17.8860923,8.47334172 C18.5910863,9.24181221 19.0165137,10.224347 19.0165137,11.4249977 C19.0165137,15.6509101 16.444366,16.5807729 13.9944443,16.8529114 C14.3888087,17.192578 14.7406305,17.863808 14.7406305,18.890236 C14.7406305,20.3603241 14.7271248,21.5467939 14.7271248,21.9073943 C14.7271248,22.2018171 14.9256576,22.5441849 15.4834403,22.4368151 C19.8511618,20.9788821 23,16.8589889 23,12.0003376 C23,5.92482888 18.0744958,1 11.9989871,1' })
  );
};

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Globe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Globe = function Globe(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Globe' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,8 C2,8 5.5,9 7,10 C8.5,11 7.56437103,12.4191614 8,13 C8.43562897,13.5808386 10,12 10,15 C10,18 13,16 13,19 C13,22 15.5,21.5 16,20 C16.5,18.5 18.2333023,16.8664183 18,15 C17.7666977,13.1335817 17,12 15,12 C13,12 11.5,11.5 11,10 C10.5,8.5 14,8 13,5 C12,2 13,1 13,1 M23,12 C23,18.075 18.075,23 12,23 C5.925,23 1,18.075 1,12 C1,5.925 5.925,1 12,1 C18.075,1 23,5.925 23,12 L23,12 Z' })
  );
};

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Golang */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Golang = function Golang(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Golang' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#8CC5E7', d: 'M21.4679537,3.20617761 C22.1814672,4.67953668 20.0131274,4.83706564 20.1243243,5.49498069 C20.3281853,6.68108108 20.1891892,8.44169884 20.0316602,10.1745174 C19.7629344,13.1119691 21.9590734,20.1451737 17.3814672,22.9714286 C16.5196911,23.5088803 14.4718147,23.8054054 12.4517375,23.8517375 C12.4517375,23.8517375 12.442471,23.8517375 12.442471,23.8517375 C12.442471,23.8517375 12.4332046,23.8517375 12.4332046,23.8517375 C10.4131274,23.8054054 8.08725869,23.5088803 7.22548263,22.9714286 C2.65714286,20.1451737 4.85328185,13.1119691 4.59382239,10.1745174 C4.42702703,8.44169884 4.28803089,6.68108108 4.5011583,5.49498069 C4.61235521,4.83706564 2.44401544,4.68880309 3.15752896,3.20617761 C3.76911197,1.93667954 5.27953668,3.05791506 5.65945946,2.65945946 C7.596139,0.648648649 9.94980695,0.111196911 11.8030888,0.0648648649 C11.988417,0.0648648649 12.8223938,0.0648648649 12.8223938,0.0648648649 C14.6664093,0.157528958 17.0200772,0.657915058 18.9660232,2.65945946 C19.3459459,3.05791506 20.8471042,1.93667954 21.4679537,3.20617761 Z M11.4324324,10.9065637 C11.3490347,10.9436293 11.2100386,11.8517375 11.6362934,11.8980695 C11.9235521,11.9258687 12.7111969,12.0185328 12.8965251,11.8980695 C13.2579151,11.6664093 13.2208494,11.1104247 13.0169884,10.9714286 C12.6741313,10.7490347 11.5250965,10.8602317 11.4324324,10.9065637 Z M9.07876448,4.10501931 C8.12432432,3.99382239 6.52123552,4.88339768 6.28030888,6.77374517 C6.02084942,8.73822394 8.33745174,10.6841699 10.56139,8.73822394 C11.7567568,7.69111969 12.1737452,4.46640927 9.07876448,4.10501931 Z M15.5281853,4.10501931 C12.4332046,4.46640927 12.8501931,7.69111969 14.0455598,8.73822394 C16.2694981,10.6841699 18.5861004,8.73822394 18.3266409,6.77374517 C18.0949807,4.88339768 16.4918919,3.99382239 15.5281853,4.10501931 Z' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#B8937F', d: 'M12.3127413,8.98841699 C12.8965251,8.90501931 14.2957529,9.57220077 14.2030888,10.3598456 C14.0918919,11.2772201 10.5984556,11.3976834 10.4131274,10.3042471 C10.3019305,9.63706564 10.8301158,9.21081081 12.3127413,8.98841699 Z M20.1984556,16.3737452 C19.9111969,16.3644788 19.7258687,15.984556 19.7258687,15.7528958 C19.7258687,15.3359073 19.7814672,14.8447876 20.0872587,14.6316602 C20.7173745,14.196139 21.2177606,16.3830116 20.1984556,16.3737452 Z M4.41776062,16.3737452 C3.3984556,16.3830116 3.8988417,14.196139 4.52895753,14.6316602 C4.83474903,14.8447876 4.89034749,15.3359073 4.89034749,15.7528958 C4.89034749,15.984556 4.70501931,16.3644788 4.41776062,16.3737452 Z M18.2617761,23.0918919 C18.4471042,23.3606178 18.4563707,23.5459459 18.1598456,23.6849421 C17.0293436,24.203861 16.019305,23.5088803 16.3992278,23.3142857 C17.2054054,22.9065637 17.7057915,22.2671815 18.2617761,23.0918919 Z M6.35444015,23.184556 C6.91042471,22.3598456 7.41081081,22.9992278 8.21698842,23.4069498 C8.5969112,23.6015444 7.58687259,24.2965251 6.45637066,23.7776062 C6.15984556,23.63861 6.16911197,23.4532819 6.35444015,23.184556 Z' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#000', d: 'M19.7351351,3.42857143 C19.7814672,3.23397683 20.2633205,3.14131274 20.5320463,3.47490347 C20.8563707,3.87335907 20.0594595,4.42007722 20.0223938,4.1976834 C19.9297297,3.5953668 19.6795367,3.62316602 19.7351351,3.42857143 Z M4.88108108,3.42857143 C4.93667954,3.62316602 4.68648649,3.5953668 4.59382239,4.1976834 C4.55675676,4.42007722 3.75984556,3.87335907 4.08416988,3.47490347 C4.34362934,3.14131274 4.82548263,3.23397683 4.88108108,3.42857143 Z M15.7413127,7.94131274 C15.1578953,7.94131274 14.6849421,7.46835949 14.6849421,6.88494208 C14.6849421,6.30152468 15.1578953,5.82857143 15.7413127,5.82857143 C16.3247301,5.82857143 16.7976834,6.30152468 16.7976834,6.88494208 C16.7976834,7.46835949 16.3247301,7.94131274 15.7413127,7.94131274 Z M15.4633205,6.76447876 C15.6475575,6.76447876 15.7969112,6.61512511 15.7969112,6.43088803 C15.7969112,6.24665096 15.6475575,6.0972973 15.4633205,6.0972973 C15.2790834,6.0972973 15.1297297,6.24665096 15.1297297,6.43088803 C15.1297297,6.61512511 15.2790834,6.76447876 15.4633205,6.76447876 Z M11.3583012,9.43320463 C11.4694981,9.00694981 11.8586873,8.86795367 12.1737452,8.85868726 C12.9799228,8.84015444 13.2857143,9.27567568 13.3135135,9.61853282 C13.369112,10.2023166 11.1081081,10.3413127 11.3583012,9.43320463 Z M8.87490347,7.94131274 C8.29148607,7.94131274 7.81853282,7.46835949 7.81853282,6.88494208 C7.81853282,6.30152468 8.29148607,5.82857143 8.87490347,5.82857143 C9.45832088,5.82857143 9.93127413,6.30152468 9.93127413,6.88494208 C9.93127413,7.46835949 9.45832088,7.94131274 8.87490347,7.94131274 Z M9.15289575,6.76447876 C9.33713283,6.76447876 9.48648649,6.61512511 9.48648649,6.43088803 C9.48648649,6.24665096 9.33713283,6.0972973 9.15289575,6.0972973 C8.96865868,6.0972973 8.81930502,6.24665096 8.81930502,6.43088803 C8.81930502,6.61512511 8.96865868,6.76447876 9.15289575,6.76447876 Z' })
    )
  );
};

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GooglePlus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var GooglePlus = function GooglePlus(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'GooglePlus' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#4285F4', fillRule: 'evenodd', d: 'M0.0202537528,11.2032618 C0.0858884305,7.29693926 3.69605513,3.87603603 7.62298049,4.00635861 C9.5045944,3.91939087 11.2733582,4.73384249 12.7144674,5.87784249 C12.0993693,6.57306829 11.4624794,7.24274571 10.7820061,7.86906829 C9.04956189,6.67810055 6.58579693,6.33771345 4.85335275,7.71345539 C2.37505996,9.41848765 2.26220982,13.4442941 4.64607169,15.2796489 C6.96429889,17.3722941 11.3459973,16.3333264 11.9865191,13.1291973 C10.534514,13.1075199 9.07861756,13.1291973 7.62661245,13.0822296 C7.62298049,12.2205522 7.61934853,11.3588747 7.62298049,10.4974554 C10.0504259,10.4902296 12.4778712,10.4863586 14.9089486,10.5046812 C15.0544863,12.532036 14.7852026,14.6897135 13.5332146,16.3658425 C11.6370729,19.0195199 7.83052098,19.7942296 4.86061667,18.6574554 C1.88007591,17.527907 -0.230870232,14.3962941 0.0202537528,11.2032618 M19.6437253,8.32145539 L21.8091508,8.32145539 C21.8127827,9.04197152 21.8164147,9.76610055 21.8236786,10.4863586 C22.5479949,10.4938425 23.2759431,10.4938425 24,10.5010683 L24,12.6551328 C23.2759431,12.6623586 22.5516269,12.6659715 21.8236786,12.6731973 C21.8164147,13.3970683 21.8127827,14.1175844 21.8091508,14.8381005 L19.6400933,14.8381005 C19.6328294,14.1175844 19.6328294,13.3970683 19.6255655,12.6768102 C18.9012492,12.6695844 18.1735604,12.6623586 17.4492441,12.6551328 L17.4492441,10.5010683 C18.1735604,10.4938425 18.8976172,10.4902296 19.6255655,10.4863586 C19.6291974,9.76248765 19.6364613,9.04197152 19.6437253,8.32145539' })
  );
};

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GoogleWallet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var GoogleWallet = function GoogleWallet(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'GoogleWallet' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#4285F4', fillRule: 'evenodd', d: 'M12.3007772,20.2064516 C11.8620675,20.9290323 11.1007772,21.3548387 10.2620675,21.3548387 C10.0298095,21.3548387 9.79755139,21.316129 9.57819655,21.2516129 C9.39755139,21.1870968 9.204003,21.1096774 9.03626107,21.0064516 C8.36529333,20.5935484 7.96529333,19.9096774 7.9007772,19.1870968 C7.89140409,19.0839926 7.88808323,18.9793754 7.89136416,18.8743442 C7.55009449,15.0742313 5.43254085,11.8144954 2.19755139,10.0774194 C1.1007772,9.49677419 0.674970747,8.11612903 1.26851913,7.01935484 C1.66851913,6.27096774 2.42980946,5.81935484 3.26851913,5.81935484 C3.64271268,5.81935484 4.01690623,5.90967742 4.33948688,6.09032258 C6.48434923,7.23339294 8.37353109,8.87504028 9.73981084,10.748043 C9.55437093,9.20494486 9.06580772,7.70138229 8.2491643,6.38709677 C7.86206752,5.74193548 7.82335784,4.95483871 8.05561591,4.3483871 C8.17174494,4.03870968 8.32658365,3.75483871 8.59755139,3.47096774 C8.86851913,3.18709677 9.16529333,3.03225806 9.4491643,2.91612903 C9.72013204,2.81290323 9.91368042,2.76129032 10.3007772,2.76129032 C10.7652933,2.76129032 11.2169062,2.90322581 11.5910998,3.1483871 C11.6256625,3.16950877 11.659368,3.19148766 11.6922588,3.21432378 C11.6556159,3.17419355 11.5910998,3.13548387 11.5910998,3.13548387 C14.3738522,4.83605479 16.7449876,7.17977729 18.3834315,9.79420491 C18.1429112,7.64929068 17.5519189,5.57240342 16.6104546,3.57419355 C16.0169062,2.33548387 16.5459385,0.838709677 17.7975514,0.24516129 C18.1330353,0.0774193548 18.4943256,0 18.8685191,0 C19.8233578,0 20.7136804,0.567741935 21.1265836,1.43225806 C21.9007772,3.05806452 22.4943256,4.76129032 22.8943256,6.51612903 C23.2943256,8.29677419 23.5136804,10.1677419 23.5265836,12.0258065 C23.5265836,13.9096774 23.3072288,15.7419355 22.9072288,17.5354839 C22.804003,18.0129032 22.687874,18.4645161 22.5459385,18.9419355 C22.1072288,20.5290323 21.604003,21.7548387 21.1007772,22.6967742 C20.6620675,23.4967742 19.8233578,24 18.9072288,24 C18.5330353,24 18.1717449,23.9096774 17.8362611,23.7548387 C17.087874,23.4064516 16.6362611,22.7612903 16.4685191,22.0516129 C16.4169062,21.8451613 16.404003,21.6258065 16.404003,21.4709677 C16.404003,20.9290323 16.3781966,20.5677419 16.3781966,20.5677419 C16.3781966,17.8729043 15.7339615,15.3069136 14.548495,13.0500263 C14.3781966,15.6 13.6169062,18.0516129 12.3007772,20.2064516 Z' })
  );
};

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Google */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Google = function Google(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Google' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#EA4335 ', d: 'M5.26620003,9.76452941 C6.19878754,6.93863203 8.85444915,4.90909091 12,4.90909091 C13.6909091,4.90909091 15.2181818,5.50909091 16.4181818,6.49090909 L19.9090909,3 C17.7818182,1.14545455 15.0545455,0 12,0 C7.27006974,0 3.1977497,2.69829785 1.23999023,6.65002441 L5.26620003,9.76452941 Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#34A853', d: 'M16.0407269,18.0125889 C14.9509167,18.7163016 13.5660892,19.0909091 12,19.0909091 C8.86648613,19.0909091 6.21911939,17.076871 5.27698177,14.2678769 L1.23746264,17.3349879 C3.19279051,21.2936293 7.26500293,24 12,24 C14.9328362,24 17.7353462,22.9573905 19.834192,20.9995801 L16.0407269,18.0125889 Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#4A90E2', d: 'M19.834192,20.9995801 C22.0291676,18.9520994 23.4545455,15.903663 23.4545455,12 C23.4545455,11.2909091 23.3454545,10.5272727 23.1818182,9.81818182 L12,9.81818182 L12,14.4545455 L18.4363636,14.4545455 C18.1187732,16.013626 17.2662994,17.2212117 16.0407269,18.0125889 L19.834192,20.9995801 Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#FBBC05', d: 'M5.27698177,14.2678769 C5.03832634,13.556323 4.90909091,12.7937589 4.90909091,12 C4.90909091,11.2182781 5.03443647,10.4668121 5.26620003,9.76452941 L1.23999023,6.65002441 C0.43658717,8.26043162 0,10.0753848 0,12 C0,13.9195484 0.444780743,15.7301709 1.23746264,17.3349879 L5.27698177,14.2678769 Z' })
  );
};

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Gremlin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Gremlin = function Gremlin(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Gremlin' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,14 C7.55228475,14 8,13.5522847 8,13 C8,12.4477153 7.55228475,12 7,12 C6.44771525,12 6,12.4477153 6,13 C6,13.5522847 6.44771525,14 7,14 Z M17,14 C17.5522847,14 18,13.5522847 18,13 C18,12.4477153 17.5522847,12 17,12 C16.4477153,12 16,12.4477153 16,13 C16,13.5522847 16.4477153,14 17,14 Z M12,16 C12.5,16 13,15.6790227 13,15 C13,14.8871314 11,14.9246156 11,15 C11,15.6790227 11.5,16 12,16 Z M3,24 C3,24 3.00341148,16 3,12 C3.00341148,8 2.55309359,4 12,4 C21.4469064,4 20.9965885,8 21,12 C20.9965885,16 21,24 21,24 M20.0682179,7 C23.3272228,7 23.6478055,3.42041241 22.1136966,1.88630344 C20.5795876,0.352194472 17,0.672777193 17,3.93178206 M7,19 C7,18.7966267 9.50000016,20.1517845 12,20 C14.4999998,20.1517846 17,18.5013715 17,19 C17,19.8021982 15.5,21 12,21 C8.5,21 7,19.5069424 7,19 Z M3.94464295,7 C0.604407067,7 0.38005973,3.42041241 1.90773825,1.88630344 C3.43541678,0.352194472 7,0.672777193 7,3.93178206' })
  );
};

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Grid = function Grid(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Grid' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,1 L8,23 M16,1 L16,23 M1,8 L23,8 M1,16 L23,16 M1,1 L23,1 L23,23 L1,23 L1,1 Z' })
  );
};

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Grommet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Grommet = function Grommet(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Grommet' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#865CD6', strokeWidth: '4', d: 'M12,2 C6.485,2 2,6.485 2,12 C2,17.515 6.485,22 12,22 C17.515,22 22,17.515 22,12 C22,6.485 17.515,2 12,2 Z' })
  );
};

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Group */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Group = function Group(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Group' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,13 C14.209139,13 16,11.209139 16,9 C16,6.790861 14.209139,5 12,5 C9.790861,5 8,6.790861 8,9 C8,11.209139 9.790861,13 12,13 Z M6,22 L6,19 C6,15.6862915 8.6862915,13 12,13 C15.3137085,13 18,15.6862915 18,19 L18,22 M13,5 C13.4037285,3.33566165 15.0151447,2 17,2 C19.172216,2 20.98052,3.790861 21,6 C20.98052,8.209139 19.172216,10 17,10 L16,10 L17,10 C20.287544,10 23,12.6862915 23,16 L23,18 M11,5 C10.5962715,3.33566165 8.98485529,2 7,2 C4.82778404,2 3.01948003,3.790861 3,6 C3.01948003,8.209139 4.82778404,10 7,10 L8,10 L7,10 C3.71245602,10 1,12.6862915 1,16 L1,18' })
  );
};

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Grow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Grow = function Grow(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Grow' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,16 L12,7 M12.0000002,11 C12,8 12,5 5,5 C5,8 5,11 12.0000002,11 Z M4,16 L20,16 M18,16 L16,23 L8,23 L6,16 L6,16 M12,7 C12,4 12,1 19,1 C19,4 19,7 12,7 Z' })
  );
};

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Hadoop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Hadoop = function Hadoop(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Hadoop' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#92CCF4', fillRule: 'evenodd', d: 'M22.6148786,8.51458809 C22.4527967,9.15577678 22.1254391,9.70110654 21.4473346,9.94260905 C21.1149047,10.060965 20.9000793,9.93918049 20.561027,9.84144289 C20.8938327,9.87309841 21.0852218,9.92424509 21.3832721,9.77672285 C21.939686,9.50159222 22.3496579,9.05202745 22.6148786,8.51458809 L22.6148786,8.51458809 Z M23.9697255,12.7295161 C23.8906337,13.5066732 23.683182,14.2616621 23.3136953,14.9015827 C22.9828153,15.4754212 22.5216967,15.9578157 21.9074669,16.2867231 C21.4900743,16.5086405 21.0050967,16.6371413 20.5037277,16.68965 C19.9832433,16.7437556 19.4459448,16.7148241 18.9445759,16.6297205 C18.9211395,16.7074034 18.8969047,16.7863543 18.8738441,16.8635205 C18.8445369,16.9605536 18.814854,17.0582442 18.7855468,17.1547137 C18.6832065,17.4910419 18.4386981,17.7941647 18.1340254,18.0187592 C17.8195837,18.2507744 17.436195,18.4023358 17.0787318,18.4183984 C16.7372843,18.4349776 16.4734256,18.3545238 16.2394847,18.2163948 C16.0129176,18.0831974 15.8191802,17.897867 15.6078303,17.69375 L15.3309149,17.4273551 C15.268825,17.3668151 15.2066881,17.306463 15.1438468,17.2464866 C15.1371775,17.2900247 15.1309779,17.3316371 15.1243086,17.3696801 C15.2219523,17.5671749 15.2910872,17.7523174 15.3613963,17.9421566 L15.3613963,17.9427202 C15.4057328,18.061264 15.4512435,18.1831425 15.5061475,18.3152127 C15.5879634,18.5105 15.6497245,18.6734273 15.692699,18.8423663 C15.7356265,19.0129022 15.7592977,19.1863031 15.764558,19.3988272 C15.7695834,19.5798836 15.7745149,19.7605643 15.7795403,19.941245 C15.7840491,20.111734 15.7883701,20.2822699 15.7938182,20.4527588 C15.8691997,20.5894787 15.913771,20.6832241 15.9359863,20.7867386 C15.9609725,20.8971103 15.9584833,21.0047109 15.9457553,21.1800843 C15.918045,21.5742754 15.7877595,21.7939384 15.568848,21.9185879 C15.3633689,22.0350182 15.0912911,22.0523959 14.754775,22.050799 C14.7035814,22.0500006 14.6206383,22.0500006 14.5199888,22.0500006 C14.1934766,22.0500006 13.6883973,22.050799 13.533877,22.0398558 C13.3262844,22.0248265 13.153588,22.0089987 13.0086959,21.9742434 C12.8969623,21.9477072 12.8051425,21.9089598 12.728399,21.8527407 C12.6168532,21.9427757 12.5188338,22.0242159 12.4203447,22.1052803 C12.1304196,22.3441527 11.8361266,22.5875339 11.7175827,22.6663909 C11.672166,22.7363242 11.6310702,22.8068212 11.593356,22.8722927 C11.4716654,23.0855682 11.3816303,23.2433292 11.094711,23.3990237 C10.5312052,23.7033206 10.0951198,23.6767844 9.71257649,23.4419981 C9.3481153,23.218343 9.04705907,22.8074318 8.73228859,22.3218905 C8.58255892,22.0914252 8.34349867,21.7117468 8.22711532,21.3394422 C8.0984267,20.9273568 8.11627402,20.5265434 8.5268095,20.3156162 C8.54634763,20.3054714 8.56616756,20.2952796 8.58471938,20.2855106 C8.627506,20.2632484 8.66785035,20.2429588 8.70814774,20.2221995 C8.55254723,20.2304187 8.39614829,20.2367122 8.24054778,20.2347396 C7.93507669,20.232767 7.62814964,20.211726 7.31516389,20.1714286 C7.32023629,20.2087671 7.32455722,20.2386379 7.32695252,20.2579881 C7.35090551,20.4655807 7.36748474,20.6015022 7.34775875,20.7376585 C7.32793882,20.8780888 7.27218941,21.003067 7.15350469,21.1800374 C7.14561429,21.191779 7.11903117,21.2302447 7.09629931,21.2624638 C6.98625645,21.4245927 6.92120764,21.5210622 6.76983413,21.8560283 C6.78476953,22.0211161 6.78965406,22.1538908 6.77871083,22.2861019 C6.76668737,22.4285048 6.73672264,22.5733969 6.68604563,22.7628604 C6.55684038,23.2406052 6.07646549,23.3507419 5.54423942,23.3173487 C5.05588021,23.2869143 4.52121188,23.1331924 4.21231223,23.0492161 C4.14524385,23.0314157 4.09085647,23.0173257 4.03801899,23.0034705 C3.77735409,22.9355098 3.49649353,22.862054 3.26011038,22.7546412 C2.78678049,22.5385947 2.48342291,22.1995894 2.77884313,21.5505103 C2.82642035,21.4476064 2.8678919,21.3429177 2.90560612,21.2374306 C2.92007184,21.1999512 2.92955911,21.1640217 2.9418174,21.1265424 C2.70083153,21.1640217 2.44481632,21.1183232 2.19551735,21.0235915 C1.75938505,20.8577992 1.342603,20.5410091 1.08762107,20.2859333 C0.883738843,20.0815814 0.725132469,19.8617305 0.606447747,19.6359148 C0.478040929,19.3913595 0.395896259,19.1378805 0.354095942,18.8882528 C0.285242834,18.4796899 0.333289716,18.4331929 0.574792225,18.2013185 C0.610815645,18.1659996 0.651159997,18.1275339 0.661022993,18.1179527 C0.780365248,17.9999725 0.89890907,17.8816635 1.01796953,17.7642469 C1.14501431,17.6382824 1.27351506,17.5113315 1.40009018,17.3847564 C1.45828186,17.2273242 1.51619174,17.0703147 1.57457128,16.9115204 C1.61209764,16.8101664 1.64929522,16.7080139 1.68639887,16.6070826 C1.66855155,16.5129145 1.65239502,16.4182297 1.63882166,16.3213375 C1.6231348,16.2082418 1.61078257,16.1043516 1.60261037,16.0106062 C1.56588245,15.5787948 1.55357719,15.2074295 1.56639909,14.8711483 C1.57607422,14.6146634 1.59998024,14.37875 1.63933829,14.1529813 C1.4399179,14.1974117 1.23678714,14.1939832 1.05272485,14.1356036 C0.825265365,14.0621478 0.626737339,13.9051383 0.503778652,13.6470096 C0.457704369,13.5522778 0.421446116,13.4564659 0.387160463,13.3483017 C0.357007874,13.2528654 0.329156651,13.1463451 0.299285862,13.0256408 C0.13617069,12.8575941 0.0437403251,12.6812344 0.0130711032,12.5006476 C-0.0233750164,12.2933838 0.0186131678,12.0866835 0.111419266,11.8886252 C0.200280166,11.6982694 0.336718282,11.5172129 0.494620156,11.3529706 C0.919903162,10.9112492 1.5244109,10.579242 1.80574113,10.5303967 L2.01676228,10.4934809 L1.94654714,10.6956253 C1.91005406,10.7979657 1.86736137,10.9051905 1.82607769,11.0107246 C1.81442996,11.0413938 1.80264133,11.0723448 1.7898664,11.1056442 C1.91925952,11.2079845 1.99680146,11.3499647 2.03301274,11.5115769 C2.08956059,11.7614865 2.05302054,12.049392 2.00478579,12.264828 L1.94725164,12.5227219 L1.7838077,12.3159747 C1.74426179,12.2672233 1.71133817,12.2164524 1.67968264,12.1672314 C1.65046939,12.1222843 1.62275906,12.0800143 1.59443818,12.045259 C1.57194115,12.3807417 1.53112713,12.7171638 1.29206689,12.946502 C1.29883009,12.9753395 1.30202382,12.9907446 1.30681442,12.9940792 C1.31061872,12.9960518 1.35124487,12.9738835 1.44931123,12.9356997 C1.6176397,12.8714493 1.76736938,12.7642244 1.90822236,12.6381659 C2.05302054,12.5077865 2.18546649,12.3589492 2.31946234,12.2116618 C2.47092978,11.9175097 2.64428368,11.6392792 2.84670994,11.3746691 C3.05247083,11.1046579 3.28796161,10.8493941 3.55980457,10.6085492 C4.22513412,10.0193056 4.87238151,9.62689924 5.6070808,9.34261011 C6.32623413,9.06470845 7.12795483,8.88956982 8.11284546,8.73166794 C8.23679045,8.60316719 8.36256713,8.47588757 8.49153755,8.35001695 C8.6299013,8.21719527 8.77286778,8.08437358 8.92259746,7.95159887 C9.13296108,7.7666442 9.30875724,7.65354851 9.48361408,7.58356821 C9.64151595,7.51931783 9.79730433,7.49419067 9.97239599,7.48141574 C10.2730765,7.0805554 10.5472208,6.73661862 10.8697408,6.4386622 C11.207431,6.12638095 11.5952346,5.86646752 12.1173629,5.6469454 C13.1987699,5.19080531 14.1156059,4.95320103 14.9827981,5.00768234 C15.8562369,5.06230455 16.6734096,5.41197126 17.5491967,6.13455315 C17.7144724,6.2710852 17.8828008,6.41856048 18.0505657,6.56589486 C18.4175631,6.88855573 18.7777034,7.20450038 19.2007789,7.46911048 C19.3601368,7.56783438 19.494931,7.65359548 19.6281285,7.75457378 C19.759776,7.8550824 19.8812787,7.96737966 20.0078069,8.11678057 C20.1607303,8.29985657 20.3003621,8.48269774 20.4228511,8.67850169 C20.5257551,8.84208653 20.6156023,9.01572223 20.6949289,9.20621896 C20.8742006,9.13393729 21.0640398,9.05428185 21.2160239,8.92582807 C21.3472957,8.81324901 21.456634,8.65337454 21.5656436,8.4940167 C21.6632873,8.35053358 21.7613067,8.20836554 21.877737,8.09118375 C21.9156861,8.0518257 21.9589893,8.01970051 22.005909,7.99607628 C22.1844292,7.90181422 22.4103858,7.91736018 22.6242719,7.99119175 C22.8262285,8.06032666 23.0211401,8.18319141 23.153586,8.31385263 C23.2145018,8.37335938 23.2633471,8.43709312 23.2953784,8.49890123 C23.5613975,9.00750307 23.7527865,9.71463294 23.8684184,10.4424281 C23.9972949,11.2597887 24.032426,12.1066913 23.9697255,12.7295161 L23.9697255,12.7295161 Z M20.2449884,9.38187423 C20.2063349,9.38286053 20.1684328,9.38384683 20.1317049,9.38520886 C20.1867968,9.43931444 20.2299591,9.50356482 20.2616146,9.57457839 C20.2772076,9.559643 20.2950079,9.54517727 20.3141233,9.53212054 C20.2914384,9.48139656 20.2684248,9.43109528 20.2449884,9.38187423 L20.2449884,9.38187423 Z M1.49914284,11.6538859 C1.59749101,11.6428487 1.65864158,11.694512 1.73472756,11.7702692 C1.72096633,11.5887431 1.68658674,11.4539958 1.55911926,11.379084 C1.54996076,11.4085791 1.5427279,11.438262 1.53422693,11.4682267 C1.5177886,11.5266063 1.50764381,11.5886962 1.49914284,11.6538859 L1.49914284,11.6538859 Z M1.88995233,13.6347043 C1.89915779,13.6020625 1.90878596,13.5699373 1.91935345,13.5371076 C1.98116156,13.3420081 2.04738454,13.1526386 2.11839811,12.969046 C1.9698426,13.1033236 1.80278223,13.2172647 1.60012114,13.2984231 C1.07606727,13.5080822 1.0867287,13.3269318 0.861147885,12.8719659 C1.34072434,12.4889529 1.11875995,12.0185349 1.27140156,11.4898314 C1.30695532,11.3683287 1.35843076,11.249597 1.43127604,11.0930571 C0.929014692,11.3954284 0.00597913924,12.2399357 0.622792141,12.8799502 C0.689672649,13.1214528 0.741335963,13.3093663 0.833155762,13.5003327 C1.02196169,13.8947586 1.51515847,13.7935925 1.88995233,13.6347043 L1.88995233,13.6347043 Z M3.27852131,20.0330179 C2.74235004,19.2215281 2.25798299,18.2554711 1.97374083,17.2730697 C1.92127909,17.4138757 1.86867644,17.5535545 1.81649649,17.6941727 C1.57616815,17.9367084 1.33593374,18.1800896 1.0956054,18.4236117 C0.91755483,18.6042924 0.88279951,18.610539 0.91882293,18.8658027 C0.967386445,19.2162209 1.17413363,19.5886664 1.48298632,19.9039065 C1.76549071,20.1924227 2.74070621,20.9449223 3.1241889,20.4320465 C3.20581694,20.3226612 3.24423566,20.1874912 3.27852131,20.0480472 L3.27852131,20.0330179 L3.27852131,20.0330179 Z M15.0621717,18.4968797 C14.9773969,18.2953458 14.9305242,18.106305 14.8715341,17.9154326 C14.7439727,18.3717136 14.5718869,18.8011766 14.4156758,19.294937 C14.2676369,19.7621142 13.507059,21.1168203 13.0602183,21.4461034 C13.1472945,21.5109644 13.307075,21.5359506 13.5918338,21.5606081 C13.7934147,21.5777509 14.5869632,21.5824476 14.7869472,21.5853595 C15.2259914,21.5933908 15.3926291,21.5599976 15.4371535,21.0603663 C15.4586172,20.8152474 15.4390791,20.7697367 15.316778,20.5550991 C15.3062574,20.1726497 15.2957369,19.7894488 15.2851694,19.4070464 C15.2740853,19.0447456 15.2043868,18.8351804 15.0621717,18.4968797 L15.0621717,18.4968797 Z M22.9516294,8.87327239 C22.849477,8.62589905 22.441055,8.25519129 22.1816582,8.50716736 C21.91996,8.7621493 21.7230758,9.12102146 21.4379413,9.34660228 C21.0492923,9.65207336 20.3809099,9.54700897 20.5019899,10.196229 C20.5904751,10.6690892 20.6156492,11.1983563 20.5144831,11.6389035 C20.4180136,12.0620261 20.3176458,12.6633401 20.0969026,12.9465959 C20.1621393,12.7068781 20.2719003,12.0801082 20.3025695,11.6572675 C20.3191957,11.4259098 20.2932232,11.146693 20.2500139,10.8656916 C20.2012155,10.8666779 20.152605,10.8678051 20.1027734,10.869308 C19.9246289,10.8729244 19.634375,11.128376 19.5562695,11.2877808 C19.3382973,11.7317096 19.3234558,12.1442177 19.0793232,12.5667766 C19.2758316,12.094433 19.1652721,11.6684455 19.3447317,11.1618163 C19.4078549,10.9831082 19.568199,10.8290106 19.7535294,10.7352182 C19.6503907,10.7198132 19.5472519,10.7649011 19.3948921,10.8004549 C18.742948,10.9555388 18.7722552,11.4679449 18.3713009,11.9572904 C18.7577895,11.248188 18.5605296,10.7780048 19.3986025,10.5867097 C19.6743906,10.5241971 19.8757366,10.4991169 20.0570279,10.644009 C20.0609261,10.644009 20.0648713,10.644009 20.0683469,10.6432106 C20.116018,10.6395941 20.1632665,10.6356959 20.2113133,10.6323613 C20.1875013,10.5022167 20.1620923,10.3739977 20.1367303,10.2531525 C19.7535294,10.2029452 19.4003872,10.2136066 19.0074172,10.2729725 C19.0923799,10.2360567 19.1749942,10.2019589 19.2550724,10.1729805 C19.3800506,10.1270941 19.5015533,10.0908358 19.6223985,10.0701705 C19.6343281,10.0462644 19.6413261,10.0198692 19.6447077,9.99145437 C19.6572008,9.85905538 19.5591814,9.74079336 19.4269233,9.72768967 C19.2941017,9.71510261 19.1812408,9.81274627 19.168325,9.94556795 C19.1636283,9.99770093 19.1819923,10.0600257 19.2112995,10.111689 C19.2048181,10.1000413 19.1985715,10.0885344 19.1928885,10.0762292 L19.1923249,10.0754307 C19.1417418,9.97788101 19.1186812,9.86534892 19.1290139,9.74868376 C19.1381724,9.66062129 19.1656948,9.57941596 19.20773,9.50746305 C19.1948611,9.51056285 19.1819453,9.51469591 19.1690764,9.51925168 C19.0759416,9.55663713 18.8772726,9.54466064 18.7874254,9.51389748 C18.9635973,9.48468423 19.2260939,9.39103273 19.3956436,9.30841839 C19.4003402,9.30644579 19.404802,9.30452016 19.4085124,9.30217183 C19.5143752,9.23693515 19.6412791,9.20480996 19.7737251,9.21711523 C19.8409344,9.22383146 19.9041515,9.24120912 19.9620144,9.26877854 C20.0409183,9.29202703 20.1292156,9.32340075 20.2354072,9.36158464 C20.0740768,9.02445803 19.8918932,8.71969145 19.6725589,8.41393856 C19.4651542,8.1253285 19.2909079,8.02566527 18.9842627,7.84451491 C18.9174761,7.80487506 18.8522394,7.76528217 18.7878012,7.72371669 C18.5612341,7.68219817 18.3085065,7.64138415 18.0904873,7.68290267 C18.2701817,7.61221786 18.4053518,7.58370911 18.562784,7.57069934 C18.1288121,7.25954529 17.754394,6.91034826 17.3260582,6.55011406 C15.6731609,5.16027698 14.3356447,5.25900088 12.2307873,6.17287794 C11.3766049,6.54475986 11.070852,6.91866136 10.5453421,7.5914586 C10.5499449,7.5914586 10.5554869,7.59098894 10.5617805,7.59098894 C11.096214,7.57750951 11.6275946,7.55914555 12.1770105,7.50748223 C11.608761,7.63978729 11.0654038,7.74555618 10.507487,7.83004918 C9.89184819,7.92398248 9.70280743,7.90834258 9.23844817,8.36025568 C8.38276279,9.19269257 7.66600476,10.1335754 6.88278892,10.977801 C6.42956076,11.4670525 6.20416781,11.9573844 5.93805478,12.5147376 C5.67410221,13.0692258 5.71064226,13.2792607 6.06481776,13.7584614 C6.42664883,14.2489811 6.64537251,14.4708516 6.79876559,14.9063733 C7.19887447,14.2888088 7.68089319,13.7767784 8.1891193,13.1629243 C7.77416895,13.8279721 7.39575866,14.4563858 7.05280819,15.1325647 C6.8391569,15.5532919 6.73423341,15.7676947 6.74109054,16.2329933 C7.14213876,16.6950981 7.39364516,16.9415791 7.76599676,17.0439194 C8.16709194,17.1541032 8.54507953,17.1357392 8.90761509,16.9478257 C9.80956262,16.4810711 10.6668918,15.8720546 11.667939,15.7953111 C12.184713,14.8742481 12.0395391,13.7160036 11.8540678,12.6683655 C11.7004399,11.7977447 11.7394222,11.0299809 11.946827,10.15673 C11.9987721,11.0048538 12.0666389,11.7923905 12.2348734,12.6238881 C12.4799924,13.8419681 12.5315617,14.8935044 12.0192965,16.1521167 C10.9129501,16.1786528 10.0049439,16.8268865 9.02371665,17.3286782 C8.58251195,17.5544939 8.169816,17.5771318 7.67614956,17.4597152 C7.17285495,17.3399972 6.78697696,16.9517239 6.26912269,16.3846955 C6.31989363,15.955984 6.37583091,15.6895891 6.52847252,15.3747717 C6.34379966,14.8184987 6.11479028,14.5626714 5.69147987,13.9937174 C5.20053749,13.3341647 5.19208349,13.0484196 5.56344878,12.297329 C5.83111172,11.7527976 6.08200756,11.2504424 6.50536493,10.7536761 C6.92214697,10.2615126 7.3054418,9.80339991 7.69286968,9.3703674 C6.08271206,9.61478184 5.05489391,10.0030551 3.95516982,10.9676092 C3.13982879,11.6834279 2.63127392,12.5722248 2.26845656,13.5985869 C2.03855481,14.246257 1.97411657,14.8987647 2.08251559,15.9575339 C2.22186564,17.3221968 2.94656103,18.8618575 3.72695887,19.984877 C3.63175748,20.6841165 3.50832912,21.2108945 3.3131827,21.7106666 C3.09196978,22.2774601 3.97226568,22.4509079 4.39754869,22.5672913 C4.74289446,22.662023 6.0544851,23.0219754 6.18416002,22.5571465 C6.26142016,22.2785873 6.26142016,22.0840984 6.2420699,21.790322 C6.47586987,21.324131 6.54688345,21.2618063 6.71375595,20.9860651 C6.89227618,20.6909267 6.90721158,20.5731343 6.90866755,20.2264735 C6.90937204,19.779398 6.89781825,18.9809649 6.91665188,18.6923079 C6.97719189,18.9504836 7.04919176,19.3098724 7.1088394,19.6547954 C8.04108042,19.821574 8.96627644,19.8094566 9.89790689,19.6192417 C9.90974248,19.5541929 9.93130018,19.4832732 9.95544103,19.3961971 C10.0177188,19.1781779 10.142838,18.9602526 10.2058202,18.7418577 C10.1882077,18.956918 10.1718164,19.1713677 10.1543448,19.3858174 C10.1369671,19.6071243 10.1362626,19.7856445 10.1635033,20.0063408 C10.1785326,20.1277966 10.1939846,20.2489235 10.2084504,20.3701914 C10.1410532,20.2590683 10.0360828,20.1524071 9.97474433,20.0406734 C9.55979398,20.3136906 9.33158303,20.4682578 8.92414735,20.6832711 C8.49374498,20.9110124 8.98741143,21.7258368 9.16513323,22.0090927 C9.55584878,22.6291933 10.0224624,23.3643153 10.7482381,22.980363 C10.986312,22.8547741 11.1256621,22.563393 11.2845502,22.353593 C11.497544,22.228239 12.62836,21.27491 12.8080544,21.1709728 C13.0615804,21.0254701 13.9750817,19.5287839 14.0908545,19.15554 C14.3463061,18.3289739 14.646329,17.6999026 14.7311038,16.8375949 C14.1494689,16.5930396 13.8666827,16.3213845 13.4498537,15.8313345 C14.0358096,16.265682 14.5416404,16.4978852 15.1732948,16.6979161 C15.4035254,16.900812 15.6358224,17.1059624 15.8773719,17.3209757 C16.2275552,17.6328812 16.5490889,17.9508454 17.0568453,17.9600039 C17.6060733,17.9693972 18.2271603,17.5494684 18.3869408,17.0287492 C18.4482793,16.8285773 18.5101344,16.6277949 18.5712849,16.4273882 C18.462698,16.4011808 18.3560837,16.3719206 18.2533207,16.3404529 C18.1394266,16.6142685 18.1484442,16.7203662 18.0947143,16.9215243 C18.0021431,17.265649 17.5284844,17.5045213 17.0322348,17.3847564 C16.8558281,17.3422046 16.7521257,17.3175941 16.6892374,17.2722713 C16.7388811,17.407817 16.8361021,17.523261 17.0165949,17.5562316 C17.2166259,17.5933353 17.364242,17.6093979 17.6548717,17.5433628 C17.2955298,17.7297264 17.179898,17.7377108 16.9251978,17.6808811 C16.2550777,17.5320438 16.4910381,16.7250159 16.6371044,16.2314903 C16.7288772,15.920759 16.6978323,15.5910531 16.6282747,15.2797112 C16.8821764,15.4402432 17.0833345,15.5816598 17.3722264,15.6793504 C18.7255234,16.1352087 20.3314071,16.5998498 21.6935338,15.8388961 C22.7618842,15.2426075 23.3476522,13.9201206 23.4792528,12.7087098 C23.5965285,11.6287587 23.3941962,9.94411199 22.9516294,8.87327239 L22.9516294,8.87327239 Z M16.0434459,15.3758049 C16.0168628,15.5439925 15.9807455,15.7515851 15.9541623,15.9197727 C16.0256456,15.7299335 16.1106083,15.5101765 16.1932696,15.3289322 C16.2809563,15.1373553 16.3299425,15.1199776 16.5149441,15.0187645 C16.6470144,14.9469055 16.8860276,14.8484634 17.0174873,14.7773559 C16.8821294,14.7999938 16.6393588,14.8494027 16.5045645,14.8722755 C16.1430152,14.9334261 16.1000408,15.0199386 16.0434459,15.3758049 L16.0434459,15.3758049 Z M9.86540597,8.90807468 C9.44618166,9.32340075 9.03874598,10.7473356 8.90855443,11.3167593 C9.11314115,10.8429127 9.62709719,9.52000315 10.0206777,9.18315834 C10.1293585,9.08988257 10.2059142,9.03267719 10.2868847,8.99106474 C10.0050848,9.46448857 10.0255622,9.58176429 10.1245679,10.2151096 C10.2085443,9.57124376 10.4319647,9.32194479 10.7968955,8.84218047 C11.1974741,8.74092037 11.5732542,8.62115542 11.9837897,8.46081128 C11.5201349,8.51346089 11.0579362,8.56099114 10.593436,8.60476406 C10.2045052,8.64144501 10.1417108,8.63590294 9.86540597,8.90807468 L9.86540597,8.90807468 Z M16.8285874,10.4872343 C16.7385524,10.2980996 16.5803687,10.1626478 16.3973396,10.0959082 C16.5639304,10.006061 16.7266228,9.9133958 16.8543251,9.79766997 C16.4808933,9.97064814 16.0465457,9.92814333 15.7269847,10.1449414 C15.4437758,10.3347806 15.0545632,10.9391004 14.7680196,11.194552 C14.9754243,11.1140982 15.1754083,10.9747012 15.3594237,10.828447 C15.3607857,10.9371278 15.3852084,11.048157 15.4340537,11.1529866 C15.4852004,11.2597887 15.5594077,11.3477103 15.6457793,11.4172209 C15.6211688,11.3926104 15.5998459,11.3645713 15.5840652,11.3319765 C15.5075095,11.1718202 15.575846,10.979163 15.7360023,10.9033588 C15.8965343,10.8260517 16.0900838,10.8945761 16.1666395,11.0545445 C16.1734966,11.0699965 16.1801189,11.0854016 16.1844398,11.1008536 C16.0309059,11.2154052 15.8902877,11.3492132 15.7726832,11.5041562 C15.6699672,11.6393732 15.5840182,11.7920148 15.5227267,11.9610947 C16.0684322,11.3139413 16.8600551,10.8243609 17.6043356,10.6159699 C17.3961324,10.6135276 17.1496514,10.6526039 16.8988495,10.7342319 C16.8898789,10.6514297 16.8670531,10.5676412 16.8285874,10.4872343 L16.8285874,10.4872343 Z M14.1629483,9.9039555 C14.2885371,9.34810521 14.5118166,8.81235664 15.3754393,8.39750023 C14.230909,8.68413769 14.0160836,9.16479438 14.1629483,9.9039555 L14.1629483,9.9039555 Z' })
  );
};

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Halt; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Halt = function Halt(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Halt' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,23 C10,23 12.9996892,23 15,23 C18,23 19,21 19,18 L19,6 C19,4.00000008 18,3.99999992 17.5,4 C17,4.00000008 15.9998779,4.00000008 15.9998779,5.99999984 C15.9998779,7.9999996 15.9998782,13 15.9998782,13 C15.9998782,13 15.9998784,5.00000004 15.9998782,4 C15.9998779,2.99999996 15.9998779,2 14.5,2 C13.0001221,2 12.9996891,2.99999994 12.9996891,4.00000006 C12.9996891,5.00000017 12.9996892,13 12.9996892,13 C12.9996892,13 12.9996891,4.00000006 12.9996891,3.00000006 C12.9996891,2.00000006 13,1.00000001 11.5,0.999999996 C10,0.999999981 10,2.00000006 10,3 L10,13 L10,4 C10,3 10.029402,2 8.5,2 C7,2 7,3 7,4 L7,18 L7,14 C7,13 6.44999986,12 5.00000005,12 C5,12 4,12 4,12 C4,12 4.00000001,14.0384045 4,18 C3.99999999,21.9615955 6,23.023861 8,23 Z' })
  );
};

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Help */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Help = function Help(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Help' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,23 C12.5522847,23 13,22.5522847 13,22 C13,21.4477153 12.5522847,21 12,21 C11.4477153,21 11,21.4477153 11,22 C11,22.5522847 11.4477153,23 12,23 Z M12,18 L12,15 C12,13 13,13 15,12 C17,11 18,9.15767339 18,7 C18,3.6862915 15.3137085,1 12,1 C8.6862915,1 6,3.6862915 6,7' })
  );
};

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Heroku */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Heroku = function Heroku(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Heroku' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#6762A6', fillRule: 'evenodd', d: 'M20.4425631,0 L3.16168659,0 C1.96912351,0 1,0.966467463 1,2.16168659 L1,21.8403054 C1,23.0335325 1.96912351,24 3.16168659,24 L20.4425631,24 C21.6354582,24 22.6015936,23.0335325 22.6015936,21.8403054 L22.6015936,2.16168659 C22.6015936,0.966467463 21.6354582,0 20.4425631,0 L20.4425631,0 Z M21.4013944,21.8403054 C21.4013944,22.3701859 20.9721116,22.7991368 20.4425631,22.7991368 L3.16168659,22.7991368 C2.63247012,22.7991368 2.2001992,22.3701859 2.2001992,21.8403054 L2.2001992,2.16168659 C2.2001992,1.62981408 2.63247012,1.2001992 3.16168659,1.2001992 L20.4425631,1.2001992 C20.9721116,1.2001992 21.4013944,1.62981408 21.4013944,2.16168659 L21.4013944,21.8403054 Z M6.40036521,20.4013612 L9.10222444,18.0002988 L6.40036521,15.5999004 L6.40036521,20.4013612 L6.40036521,20.4013612 Z M16.1577357,10.6722776 C15.672012,10.1838977 14.7852258,9.60056441 13.302158,9.60056441 C11.675,9.60056441 9.99903718,10.0245352 8.80116202,10.4126494 L8.80116202,3.60122842 L6.40043161,3.60122842 L6.40043161,14.0085989 L8.09697875,13.2400066 C8.1251992,13.2273904 10.860259,12.0012948 13.302158,12.0012948 C14.5202855,12.0012948 14.7902058,12.6719456 14.8031541,13.2323705 L14.8031541,20.4013612 L17.2012284,20.4013612 L17.2012284,13.201494 C17.2038845,13.0474436 17.1886122,11.7157703 16.1577357,10.6722776 M13.0012948,7.50039841 L15.4020252,7.50039841 C16.4866866,6.27164675 17.0394754,4.96354582 17.201494,3.60099602 L14.8030876,3.60099602 C14.5358234,4.96088977 13.9445219,6.26135458 13.0012948,7.50039841' })
  );
};

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export History */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var History = function History(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'History' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,12 C1,18.075 5.925,23 12,23 C18.075,23 23,18.075 23,12 C23,5.925 18.075,1 12,1 C7.563,1 4,4 2,7.5 M1,1 L1,8 L8,8 M16,17 L12,13 L12,6' })
  );
};

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Home */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Home = function Home(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Home' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,11 L12,2 L23,11 M15,23 L15,15 L15,15 L9,15 L9,23 M4,23 L4,9 M20,23 L20,9' })
  );
};

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Horton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Horton = function Horton(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Horton' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#89BA4E', fillRule: 'evenodd', d: 'M2.30070636,12.9767911 L2.14328961,12.9767911 C1.82441978,13.9656912 1.38849647,14.9344097 1.21089808,15.9475277 C0.988900101,17.2391524 0.972754793,18.5711403 0.87184662,19.8829465 C0.843592331,20.221998 0.996972755,20.3995964 1.33602422,20.4036327 C2.8617558,20.4238143 2.68819374,20.4843592 2.93844601,19.2048436 C2.95459132,19.1160444 2.9667003,19.0272452 2.99495459,18.938446 C3.51564077,17.2795156 3.53985873,15.6528759 2.72452069,14.0625631 C2.5469223,13.7194753 2.4419778,13.3400605 2.30070636,12.9767911 L2.30070636,12.9767911 Z M18.9061554,7.0554995 C18.9061554,6.77699294 18.6801211,6.55499495 18.4056509,6.55499495 C18.1271443,6.55499495 17.9051463,6.77699294 17.9051463,7.0554995 C17.9051463,7.32996973 18.1271443,7.55600404 18.4056509,7.55600404 C18.6801211,7.55600404 18.9061554,7.32996973 18.9061554,7.0554995 L18.9061554,7.0554995 Z M21.0817356,9.79212916 C21.2875883,10.2320888 21.235116,10.8133199 21.2310797,11.3299697 C21.2270434,12.2542886 21.1745711,13.1786075 21.1342079,14.1029263 C21.0978809,15.0191726 21.0575177,15.9354188 21.0090817,17.025227 C20.431887,16.6700303 19.9717457,16.419778 19.5519677,16.1170535 C19.4106963,16.0161453 19.3097881,15.7820383 19.2976791,15.6004036 C19.2008073,14.5025227 19.1039354,13.4006054 19.0716448,12.2986882 C19.0554995,11.60444 18.8698285,11.0918264 18.1473259,10.8940464 C17.7638749,10.7931382 17.5660949,10.5267407 17.4207871,10.1594349 C16.8072654,8.63370333 16.1695257,7.11200807 15.4914228,5.47325933 C16.653885,5.68718466 17.7275479,5.86074672 18.7891019,6.09081736 C18.9788093,6.13118063 19.1644803,6.36932392 19.2774975,6.56306761 C19.8990918,7.62865792 20.5529768,8.67810293 21.0817356,9.79212916 L21.0817356,9.79212916 Z M21.6508577,17.0171544 C21.6508577,17.0332997 21.667003,17.0454087 21.691221,17.0978809 C22.4621594,17.1543895 23.3057518,17.4490414 23.8627649,16.3794147 C23.4994955,16.2744702 23.1765893,16.1775984 22.8536831,16.0928355 C21.6508577,15.778002 21.6508577,15.778002 21.6508577,17.0171544 L21.6508577,17.0171544 Z M15.3501514,13.8123108 C15.2532795,13.4651867 15.0797175,13.3158426 14.7204844,13.2633703 C14.284561,13.1947528 13.7880928,13.1463169 13.4490414,12.9041372 C11.9515641,11.8183653 10.506559,10.6599395 9.02522704,9.54994955 C8.62563068,9.24722503 8.52875883,8.93239152 8.69424823,8.46821393 C8.94046418,7.77396569 9.15035318,7.06760848 9.41271443,6.26034309 C9.18668012,6.28456105 9.08173562,6.28859738 8.98082745,6.30877901 C7.67305752,6.59939455 6.37739657,6.95459132 5.05348133,7.16851665 C4.19374369,7.30978809 3.67305752,7.7457114 3.15237134,8.419778 C1.88900101,10.0544904 0.920282543,11.790111 0.565085772,13.8486377 C0.43592331,14.6034309 0.193743693,15.3380424 0,16.0807265 C0.0605449041,16.1210898 0.125126135,16.1614531 0.185671039,16.2018163 C0.310797175,16.0565086 0.48839556,15.9313824 0.552976791,15.765893 C0.956609485,14.6760848 1.33198789,13.5782038 1.72754793,12.4883956 C1.93340061,11.9233098 2.11503532,11.8789102 2.49041372,12.3592331 C2.73259334,12.6659939 2.95459132,13.0171544 3.08375378,13.3804238 C3.77396569,15.3299697 4.43592331,17.2875883 5.10998991,19.2411705 C5.51765893,20.431887 5.52169526,20.4117053 6.79313824,20.4157417 C7.27346115,20.4157417 7.44702321,20.2462159 7.40665994,19.778002 C7.32189707,18.764884 7.26942482,17.7517659 7.1765893,16.7426842 C7.13218971,16.2260343 7.36226034,15.987891 7.83854692,15.8587286 C9.01311806,15.5438951 10.1796165,15.2048436 11.346115,14.8698285 C12.0807265,14.6639758 12.1533804,14.6881937 12.5166498,15.3420787 C13.2795156,16.7023209 14.0787084,18.0464178 14.7769929,19.4429869 C15.1564077,20.209889 15.6609485,20.5045409 16.4924319,20.4157417 C17.1019173,20.3511604 17.1503532,20.3430878 16.9848638,19.7336024 C16.4399596,17.7598385 15.8829465,15.7860747 15.3501514,13.8123108 L15.3501514,13.8123108 Z M15.2330979,6.27245207 C14.8536831,5.23107972 14.3047427,4.66195762 13.1786075,4.55297679 C12.4601413,4.48435923 11.7618567,4.19374369 11.0514632,4 L10.8335015,4 C10.7366297,4.21392533 10.6195762,4.419778 10.5469223,4.63773966 C10.1392533,5.86074672 9.75983855,7.09182644 9.34006054,8.30676085 C9.18264379,8.75882947 9.28355197,9.04944501 9.66700303,9.32795156 C10.728557,10.1150353 11.7941473,10.9061554 12.815338,11.7497477 C14.4500505,12.7386478 15.0554995,12.7386478 15.790111,12.7346115 C16.5247225,12.7305752 17.1099899,12.7346115 17.8486377,12.7346115 C17.7558022,12.4722503 17.6992936,12.2865792 17.6266398,12.1089808 C16.8193744,10.1675076 15.9475277,8.25025227 15.2330979,6.27245207 L15.2330979,6.27245207 Z M11.4470232,15.4510595 C11.160444,15.4873865 10.7891019,15.5035318 10.764884,15.987891 C10.7124117,17.0696266 10.6155399,18.1513623 10.530777,19.3420787 C10.5509586,19.592331 10.4581231,20.1210898 10.6437941,20.2542886 C10.9182644,20.443996 11.4026236,20.407669 11.7820383,20.3551968 C11.9354188,20.3350151 12.1210898,20.0484359 12.1735621,19.8466196 C12.3148335,19.3259334 12.3269425,18.764884 12.5005045,18.2563068 C12.8193744,17.3118063 12.6215943,16.4803229 12.0484359,15.7255298 C11.9273461,15.5640767 11.6367306,15.4268416 11.4470232,15.4510595 L11.4470232,15.4510595 Z M24,15.7255298 C23.9071645,15.160444 23.8546922,14.6437941 23.7255298,14.1473259 C23.6932392,14.0221998 23.4349142,13.9091826 23.2653885,13.889001 C23.1564077,13.8728557 22.9465187,14.0020182 22.9061554,14.110999 C22.6195762,14.8617558 23.0958628,15.6165489 24,15.7255298 L24,15.7255298 Z' })
  );
};

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HostMaintenance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var HostMaintenance = function HostMaintenance(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'HostMaintenance' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M14,23 L20,17 M21,14 C19.8954305,14 19,14.8954305 19,16 C19,17.1045695 19.8954305,18 21,18 C22.1045695,18 23,17.1045695 23,16 M17,4 L18,4 L18,5 L17,5 L17,4 Z M10,23 L3,23 L3,1 L3,1 L21,1 L21,11 M3,13 L17,13 M3,18 L13,18 M3,8 L21,8' })
  );
};

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Host */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Host = function Host(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Host' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17,4 L18,4 L18,5 L17,5 L17,4 Z M3,1 L21,1 L21,23 L3,23 L3,1 Z M3,13 L21,13 L3,13 Z M3,18 L21,18 L3,18 Z M3,8 L21,8 L3,8 Z' })
  );
};

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Hp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Hp = function Hp(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Hp' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#333', fillRule: 'evenodd', d: 'M8.4210347,0.00016035599 L5,15.127022 L7.13818677,15.127022 L10.5590611,0.00016035599 L8.4210347,0.00016035599 Z M17.4142797,8.87313837 L15.9176772,15.0979976 L18.0557037,15.0979976 L19.5523061,8.87313837 L17.4142797,8.87313837 Z M13.7794905,8.87313837 L10.3586161,24 L12.4966425,24 L15.9176772,8.87313837 L13.7794905,8.87313837 Z M10.131552,8.87313837 L8.63478923,15.0979976 L10.7728157,15.0979976 L12.2694181,8.87313837 L10.131552,8.87313837 Z' })
  );
};

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HpeLabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var HpeLabs = function HpeLabs(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'HpeLabs' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#01A982', strokeWidth: '2', points: '14 23 5 23 5 2 17 2 17 15 13 15 13 6 9 6 9 19 20 19' })
  );
};

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Hpe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Hpe = function Hpe(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Hpe' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { width: '22', height: '6', x: '1', y: '9', fill: 'none', stroke: '#01A982', strokeWidth: '3' })
  );
};

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Hpi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Hpi = function Hpi(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Hpi' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#0096D6', fillRule: 'evenodd', d: 'M15.7928421,15.3333704 C15.9768442,15.3333704 16.1755131,15.1915021 16.2349804,15.0183002 L18.4310048,8.64836276 C18.4908721,8.47529417 18.3902043,8.33315926 18.2063356,8.33315926 L17.2052578,8.33315926 C17.0219225,8.33315926 16.8228536,8.47529417 16.7629863,8.64836276 L14.5570951,15.0183002 C14.4973611,15.1915021 14.5981622,15.3333704 14.7821642,15.3333704 L15.7928421,15.3333704 Z M24.0002667,12 C24.0002667,18.627007 18.6267403,24 12,24 C11.8170646,24 11.6393293,23.9803998 11.4581273,23.9727997 L13.8777542,16.981922 C13.9382882,16.8085868 14.1365571,16.6668519 14.3205591,16.6668519 L16.0003111,16.6668519 C18.6083401,16.6668519 18.632207,15.8021756 18.9066101,15.0079001 C19.5488839,13.1445461 20.6560962,9.93424371 20.8714319,9.30583673 C21.1779686,8.40956011 21.2793031,7.00007778 19.0002111,7.00007778 L15.0000333,7.00007778 C14.816698,7.00007778 14.6177624,7.14194602 14.5570951,7.31528128 L8.92489917,23.5871954 C3.79030878,22.2271803 0,17.5617951 0,12 C0,6.69394104 3.44790498,2.20055778 8.22275803,0.615473505 L2.77589751,16.3513817 C2.71523017,16.5248503 2.81643129,16.6668519 3.00003333,16.6668519 L4.99965555,16.6668519 C5.1836576,16.6668519 5.38232647,16.5248503 5.44272714,16.3513817 L8.1092901,8.64836276 C8.16915744,8.47529417 8.36755964,8.33315926 8.55102834,8.33315926 L9.539706,8.33315926 C9.72330804,8.33315926 9.82410916,8.47529417 9.76424182,8.64836276 L7.10847898,16.3513817 C7.04914499,16.5248503 7.14994611,16.6668519 7.33328148,16.6668519 L9.33357037,16.6668519 C9.51690574,16.6668519 9.71570795,16.5248503 9.77544195,16.3513817 C9.77544195,16.3513817 11.6389293,10.9485217 12.2016022,9.3149035 C12.7649418,7.68155202 12.3125368,7.00007778 10.3462483,7.00007778 L9.01290014,7.00007778 C8.82956477,7.00007778 8.72889699,6.8580762 8.78916432,6.68514095 L11.0862565,0.0464005156 C11.3887932,0.0234669274 11.6913299,0 12,0 C18.6267403,0 24.0002667,5.37299303 24.0002667,12 L24.0002667,12 Z' })
  );
};

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Html5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Html5 = function Html5(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Html5' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,2 L21,2 L21,18 L12,22 L3,18 L3,2 Z M17,6 L8,6 L8,11 L16,11 L16,16 L12,17.5 L8,16 L8,14' })
  );
};

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IceCream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var IceCream = function IceCream(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'IceCream' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17,8 C19,8 19,6.5 17.5,6.5 C17.5,3.5 15.5,1 12,1 C8.5,1 6.5,3.5 6.5,6.5 C5,6.5 5,8 7,8 M7,8 L17,8 L12,21 L7,8 Z' })
  );
};

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Image = function Image(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Image' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,3 L23,3 L23,21 L1,21 L1,3 Z M6,9 C6.55228475,9 7,8.55228475 7,8 C7,7.44771525 6.55228475,7 6,7 C5.44771525,7 5,7.44771525 5,8 C5,8.55228475 5.44771525,9 6,9 Z M23,15 L18,9 L12,16 L9,13 L1,21' })
  );
};

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Impact */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Impact = function Impact(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Impact' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M13,2 L22,6 L22,17 L13,22 L13,2 Z M22,6 L13,11 L22,6 Z M9,22 L9,2 L9,22 Z M9,12 L3,5 L9,12 Z M9,12 L1,12 L9,12 Z M9,12 L3,19 L9,12 Z' })
  );
};

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var InProgress = function InProgress(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'InProgress' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,1 L23,1 M10,4.5 L14,4.5 C14,4.5 14,6 14,6 C14,7 12,8 12,8 C12,8 10,7 10,6 C10,6 10,4.5 10,4.5 Z M5,1 C5,1 5,3 5,6 C5,9 10,9.23530084 10,12 C10,14.7646992 5.00000001,15 5,18 C4.99999999,21 5,23 5,23 M19,1 C19,1 19,3 19,6 C19,9 14,9.23530084 14,12 C14,14.7646992 19,15 19,18 C19,21 19,23 19,23 M1,23 L23,23 M8,21 C8,19 12,17 12,17 C12,17 16,19 16,21 C16,21 16,23 16,23 L8,23 L8,21 Z' })
  );
};

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Inbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Inbox = function Inbox(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Inbox' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,13 L6,2 L18,2 L23,13 L23,22 L1,22 L1,13 Z M1,13 L8,13 L8,16 L16,16 L16,13 L23,13' })
  );
};

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Indicator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Indicator = function Indicator(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Indicator' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,11 C13.6568542,11 15,9.65685425 15,8 C15,6.34314575 13.6568542,5 12,5 C10.3431458,5 9,6.34314575 9,8 C9,9.65685425 10.3431458,11 12,11 Z M19,8 C19,4.13400675 15.8659932,1 12,1 C8.13400675,1 5,4.13400675 5,8 C5,9.93299662 5.5,11 7,13 C8.5,15 10,16.5 10,19 L10,23 L14,23 L14,19 C14,16.5 15.5,15 17,13 C18.5,11 19,9.93299662 19,8 Z' })
  );
};

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Info */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Info = function Info(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Info' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,17.0002864 C15,14.0000003 19,12.0005727 19,8.00028636 C19,4.00000002 16,1.00028636 12,1.00028636 C8,1.00028636 5,4.00000002 5,8.00028636 C5,12.0005727 9,14.0000003 9,17.0002864 C9,20.0005725 9,20 9,20 C9,22.0000003 10,22.9999997 12,23 C14,23.0000003 15,22.0000003 15,20 C15,20 15,20.0005725 15,17.0002864 Z M9,18 L15,18' })
  );
};

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Inherit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Inherit = function Inherit(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Inherit' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#231F20', strokeWidth: '2', d: 'M17,18 L12,15 L17,18 Z M7,18 L12,15 L12,11 M17,20 C17,21.657 18.343,23 20,23 C21.657,23 23,21.657 23,20 C23,18.343 21.657,17 20,17 C18.343,17 17,18.343 17,20 L17,20 L17,20 Z M4,17 C2.343,17 1,18.343 1,20 C1,21.657 2.343,23 4,23 C5.657,23 7,21.657 7,20 C7,18.343 5.657,17 4,17 L4,17 L4,17 Z M17,6 C17,8.761 14.761,11 12,11 C9.239,11 7,8.761 7,6 C7,3.239 9.239,1 12,1 C14.761,1 17,3.239 17,6 L17,6 L17,6 Z' })
  );
};

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Inspect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Inspect = function Inspect(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Inspect' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5.5,21 C7.98528137,21 10,18.9852814 10,16.5 C10,14.0147186 7.98528137,12 5.5,12 C3.01471863,12 1,14.0147186 1,16.5 C1,18.9852814 3.01471863,21 5.5,21 Z M1,16 L1,7 L1,6.5 C1,4.01471863 3.01471863,2 5.5,2 L6,2 M23,16 L23,7 L23,6.5 C23,4.01471863 20.9852814,2 18.5,2 L18,2 M18.5,21 C20.9852814,21 23,18.9852814 23,16.5 C23,14.0147186 20.9852814,12 18.5,12 C16.0147186,12 14,14.0147186 14,16.5 C14,18.9852814 16.0147186,21 18.5,21 Z M10,17 C10,17 10,15 12,15 C14,15 14,17 14,17' })
  );
};

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Instagram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Instagram = function Instagram(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Instagram' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#FF933A', fillRule: 'evenodd', d: 'M12.0000238,0 C8.74099567,0 8.33234294,0.0138138818 7.05241535,0.0722132578 C5.77515526,0.130469732 4.90283244,0.333343257 4.13954402,0.630008276 C3.35043794,0.936628817 2.68122682,1.34694874 2.01406396,2.01406396 C1.34694874,2.68122682 0.936628817,3.35043794 0.630008276,4.13954402 C0.333343257,4.90283244 0.130469732,5.77515526 0.0722132578,7.05241535 C0.0138138818,8.33234294 0,8.74099567 0,12.0000238 C0,15.2590043 0.0138138818,15.6676571 0.0722132578,16.9475847 C0.130469732,18.2248447 0.333343257,19.0971676 0.630008276,19.860456 C0.936628817,20.6495621 1.34694874,21.3187732 2.01406396,21.985936 C2.68122682,22.6530513 3.35043794,23.0633712 4.13954402,23.3700394 C4.90283244,23.6666567 5.77515526,23.8695303 7.05241535,23.9277867 C8.33234294,23.9861861 8.74099567,24 12.0000238,24 C15.2590043,24 15.6676571,23.9861861 16.9475847,23.9277867 C18.2248447,23.8695303 19.0971676,23.6666567 19.860456,23.3700394 C20.6495621,23.0633712 21.3187732,22.6530513 21.985936,21.985936 C22.6530513,21.3187732 23.0633712,20.6495621 23.3700394,19.860456 C23.6666567,19.0971676 23.8695303,18.2248447 23.9277867,16.9475847 C23.9861861,15.6676571 24,15.2590043 24,12.0000238 C24,8.74099567 23.9861861,8.33234294 23.9277867,7.05241535 C23.8695303,5.77515526 23.6666567,4.90283244 23.3700394,4.13954402 C23.0633712,3.35043794 22.6530513,2.68122682 21.985936,2.01406396 C21.3187732,1.34694874 20.6495621,0.936628817 19.860456,0.630008276 C19.0971676,0.333343257 18.2248447,0.130469732 16.9475847,0.0722132578 C15.6676571,0.0138138818 15.2590043,0 12.0000238,0 Z M12.0000238,2.1621583 C15.2041299,2.1621583 15.5836782,2.17440026 16.8490298,2.23213276 C18.0190179,2.28548292 18.6544088,2.48097316 19.0772565,2.64531072 C19.6373856,2.86299845 20.0371308,3.12303286 20.4570251,3.54297487 C20.8769671,3.96286924 21.1370016,4.3626144 21.3546893,4.92274348 C21.5190268,5.34559117 21.7145171,5.9809821 21.7678672,7.15097025 C21.8255997,8.41632182 21.8378417,8.79587013 21.8378417,12.0000238 C21.8378417,15.2041299 21.8255997,15.5836782 21.7678672,16.8490298 C21.7145171,18.0190179 21.5190268,18.6544088 21.3546893,19.0772565 C21.1370016,19.6373856 20.8769671,20.0371308 20.4570251,20.4570251 C20.0371308,20.8769671 19.6373856,21.1370016 19.0772565,21.3546893 C18.6544088,21.5190268 18.0190179,21.7145171 16.8490298,21.7678672 C15.5838687,21.8255997 15.204368,21.8378417 12.0000238,21.8378417 C8.79563196,21.8378417 8.41617891,21.8255997 7.15097025,21.7678672 C5.9809821,21.7145171 5.34559117,21.5190268 4.92274348,21.3546893 C4.3626144,21.1370016 3.96286924,20.8769671 3.54297487,20.4570251 C3.1230805,20.0371308 2.86299845,19.6373856 2.64531072,19.0772565 C2.48097316,18.6544088 2.28548292,18.0190179 2.23213276,16.8490298 C2.17440026,15.5836782 2.1621583,15.2041299 2.1621583,12.0000238 C2.1621583,8.79587013 2.17440026,8.41632182 2.23213276,7.15097025 C2.28548292,5.9809821 2.48097316,5.34559117 2.64531072,4.92274348 C2.86299845,4.3626144 3.12303286,3.96286924 3.54297487,3.54297487 C3.96286924,3.12303286 4.3626144,2.86299845 4.92274348,2.64531072 C5.34559117,2.48097316 5.9809821,2.28548292 7.15097025,2.23213276 C8.41632182,2.17440026 8.79587013,2.1621583 12.0000238,2.1621583 L12.0000238,2.1621583 Z M12.0000238,16 C9.79085069,16 8,14.2091493 8,12.0000238 C8,9.79085069 9.79085069,8 12.0000238,8 C14.2091493,8 16,9.79085069 16,12.0000238 C16,14.2091493 14.2091493,16 12.0000238,16 Z M12.0000238,5.8378417 C8.59671206,5.8378417 5.8378417,8.59671206 5.8378417,12.0000238 C5.8378417,15.4032879 8.59671206,18.1621583 12.0000238,18.1621583 C15.4032879,18.1621583 18.1621583,15.4032879 18.1621583,12.0000238 C18.1621583,8.59671206 15.4032879,5.8378417 12.0000238,5.8378417 L12.0000238,5.8378417 Z M19.8456418,5.59438394 C19.8456418,6.38968246 19.2009146,7.03436203 18.4056161,7.03436203 C17.6103652,7.03436203 16.965638,6.38968246 16.965638,5.59438394 C16.965638,4.79908543 17.6103652,4.15435822 18.4056161,4.15435822 C19.2009146,4.15435822 19.8456418,4.79908543 19.8456418,5.59438394' })
  );
};

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InstallOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var InstallOption = function InstallOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'InstallOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,18 L12,8 L12,18 Z M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M17,12 L12,7 L7,12', transform: 'matrix(1 0 0 -1 0 24)' })
  );
};

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Install */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Install = function Install(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Install' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M19,13.5 L19,17.5 L12,22 L5,17.5 L5,13.5 M12,22 L12,13.5 M18.5,8.5 L12,4.5 L15.5,2 L22,6 L18.5,8.5 L18.5,8.5 L18.5,8.5 Z M5.5,8.5 L12,4.5 L8.5,2 L2,6 L5.5,8.5 L5.5,8.5 L5.5,8.5 Z M18.5,9 L12,13 L15.5,15.5 L22,11.5 L18.5,9 L18.5,9 L18.5,9 Z M5.5,9 L12,13 L8.5,15.5 L2,11.5 L5.5,9 L5.5,9 Z' })
  );
};

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Integration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Integration = function Integration(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Integration' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#231F20', strokeWidth: '2', d: 'M5,21 L23,21 L23,9 L5,9 M19,15 L1,15 L1,3 L19,3' })
  );
};

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InternetExplorer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var InternetExplorer = function InternetExplorer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'InternetExplorer' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#00A1F1', fillRule: 'evenodd', d: 'M23.9995527,12.3365818 C23.9995527,10.4393317 23.5090273,8.656914 22.6488466,7.1080745 C26.3153205,-1.18993486 18.7201703,0.0254770168 18.2972919,0.108218948 C16.688185,0.423085539 15.1995011,0.928594013 13.8263205,1.56939672 C13.6238264,1.55799176 13.4201024,1.5517302 13.2148129,1.5517302 C8.09006842,1.5517302 3.80034655,5.12618162 2.70245058,9.91794575 C5.40352737,6.88769025 7.29384506,5.6650105 8.42584412,5.17571497 C8.24515364,5.33717355 8.06826481,5.50042114 7.89428312,5.66489868 C7.83636377,5.71957545 7.78056888,5.7750349 7.72343222,5.83004711 C7.60871165,5.94040695 7.49421471,6.05087861 7.38240129,6.16235659 C7.3158723,6.22866195 7.25113233,6.29552637 7.18560967,6.36227899 C7.08643116,6.4632465 6.98747629,6.56410221 6.89064586,6.6656288 C6.82188061,6.73774845 6.75479256,6.81009173 6.68725725,6.8823232 C6.59680019,6.97915363 6.5069022,7.07609586 6.41868142,7.17337354 C6.35013979,7.24895941 6.2827163,7.32454528 6.21540462,7.40035478 C6.13176818,7.49450168 6.04891444,7.58864858 5.96717882,7.68301911 C5.89941989,7.7612885 5.83222003,7.8395579 5.76580285,7.9179391 C5.68831615,8.00940248 5.61183578,8.10086586 5.53613809,8.19232924 C5.46916185,8.27328215 5.40240924,8.35412326 5.33688657,8.43496436 C5.26599687,8.52240245 5.19667255,8.60972873 5.12746004,8.6969432 C5.06037199,8.78147415 4.99328393,8.86589328 4.92776127,8.95031241 C4.86536938,9.03070626 4.80476651,9.11076467 4.74371638,9.19093489 C4.67483931,9.28150376 4.60540318,9.37207263 4.53831513,9.46219425 C4.49034717,9.52671059 4.44428004,9.59055606 4.39720659,9.65484877 C3.97108565,10.2362786 3.58175132,10.806527 3.23009811,11.3543009 C3.2292036,11.3556427 3.22830909,11.3569845 3.2275264,11.3583262 C3.13494489,11.5025655 3.04560597,11.6446804 2.95805606,11.7855653 C2.95335989,11.7931686 2.9484401,11.8008838 2.94374394,11.8085989 C2.85608222,11.9500429 2.77143946,12.0890269 2.68892115,12.2265574 C2.68601401,12.2313654 2.68299504,12.2362852 2.68008789,12.2410932 C2.45825007,12.6113074 2.25251338,12.9682159 2.06723854,13.3039916 C1.09591536,15.0642702 0.623056401,16.294106 0.602594545,16.3671202 C-2.4646712,27.332886 7.10834659,22.7021332 8.44418153,22.0109026 C9.88254936,22.7214769 11.5018313,23.1214335 13.2148129,23.1214335 C17.9042678,23.1214335 21.894106,20.1280764 23.3792119,15.9479317 L17.7125077,15.9479317 C16.8740189,17.3644959 15.2597686,18.3239669 13.4052312,18.3239669 C10.6880532,18.3239669 8.48544068,16.2652582 8.48544068,13.72564 L23.9112201,13.72564 C23.9696986,13.270783 24,12.8072045 24,12.3365818 L23.9995527,12.3365818 Z M21.9848985,1.72369924 C22.9136208,2.35052528 23.6585218,3.33493063 22.3792645,6.65008673 C21.1523358,4.6769153 19.3064081,3.12908212 17.1124051,2.27829381 C18.1104517,1.79626615 20.5820874,0.776751388 21.9848985,1.72369924 L21.9848985,1.72369924 Z M2.24759358,21.9887635 C1.4911758,21.213002 1.35744695,19.3235789 3.02659768,15.88062 C3.86899999,18.3026105 5.55000295,20.3320241 7.72276134,21.6200029 C6.64219644,22.2147385 3.77351133,23.553816 2.24759358,21.9887635 L2.24759358,21.9887635 Z M8.46117717,10.7761138 C8.54738531,8.3078325 10.6955447,6.3315303 13.3349005,6.3315303 C15.9741445,6.3315303 18.1224157,8.3078325 18.2086239,10.7761138 L8.46117717,10.7761138 L8.46117717,10.7761138 Z' })
  );
};

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Italic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Italic = function Italic(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Italic' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M13,19.56l-.13.43H6.3l.16-.43a4.05,4.05,0,0,0,1.3-.17,1.6,1.6,0,0,0,.76-.55,7.22,7.22,0,0,0,.8-2l2.77-9.61a7.07,7.07,0,0,0,.35-1.81.86.86,0,0,0-.15-.52.94.94,0,0,0-.46-.32,4.28,4.28,0,0,0-1.22-.11l.14-.43h6.16l-.13.43a2.6,2.6,0,0,0-1.12.17,1.78,1.78,0,0,0-.81.67,9.08,9.08,0,0,0-.71,1.93L11.4,16.87A8.76,8.76,0,0,0,11,18.56a.83.83,0,0,0,.15.5.92.92,0,0,0,.47.32A6.35,6.35,0,0,0,13,19.56Z' })
  );
};

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Iteration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Iteration = function Iteration(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Iteration' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,9 L1,23 L15,23 M5,5 L5,19 L19,19 M9,15 L23,15 L23,1 L9,1 L9,15 L9,15 L9,15 Z' })
  );
};

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Java */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Java = function Java(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Java' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,18 L1,9 L17,9 L17,18 C17,22 15,23 9,23 C3,23 1,22 1,18 Z M17,9 L17,12 C17,13.657 18.343,15 20,15 C21.657,15 23,13.657 23,12 C23,10.343 21.657,9 20,9 L17,9 Z M13,6 L13,2 M5,6 L5,4 M9,6 L9,0' })
  );
};

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Language */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Language = function Language(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Language' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8' })
  );
};

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Launch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Launch = function Launch(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Launch' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,9 L7,14 C7,14 4,16 4,19 L4,20 L8,20 L10,23 L14,23 L16,20 L20,20 L20,19 C20,16 17,14 17,14 L17,9 C17,5 14,1 12,1 C10,1 7,5 7,9 Z M8,20 L16,20 M12,9 C12.5522847,9 13,8.55228475 13,8 C13,7.44771525 12.5522847,7 12,7 C11.4477153,7 11,7.44771525 11,8 C11,8.55228475 11.4477153,9 12,9 Z' })
  );
};

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Layer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Layer = function Layer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Layer' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,1 L17,1 L17,17 L1,17 L1,1 Z M20,7 L23,7 L23,23 L7,23 L7,20 L7,20' })
  );
};

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export License */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var License = function License(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'License' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M10,13 L10,16 L13,16 L13,19 L16,19 L16,21 L18,23 L23,23 L23,19 L12.74,8.74 C12.91,8.19 13,7.6 13,7 C13,3.69 10.31,1 7,1 C3.69,1 1,3.69 1,7 C1,10.31 3.69,13 7,13 C7.88,13 8.72,12.81 9.47,12.47 L10,13 Z M6,7 C5.4475,7 5,6.5525 5,6 C5,5.4475 5.4475,5 6,5 C6.5525,5 7,5.4475 7,6 C7,6.5525 6.5525,7 6,7 Z' })
  );
};

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Like */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Like = function Like(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Like' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,23 L20,23 C22,23 23,22 23,20 L23,10 L16,10 L16,4 C16,2 15,1 13,1 L11,1 C11,1 10.9842682,7 10.9842677,8.32575545 C10.9842672,9.65151089 10,11 8,11 L1,11 L1,23 Z M6,23 L6,11' })
  );
};

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LineChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var LineChart = function LineChart(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'LineChart' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,16 L8,9 L13,14 L23,4 M0,22 L23.999,22 M16,4 L23,4 L23,11' })
  );
};

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LinkBottom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var LinkBottom = function LinkBottom(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'LinkBottom' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,5 L12,23 M4,13 L12,5 L20,13 M2,2 L22,2', transform: 'matrix(1 0 0 -1 0 24)' })
  );
};

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LinkDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var LinkDown = function LinkDown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'LinkDown' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,2 L12,22 M3,11 L12,2 L21,11', transform: 'matrix(1 0 0 -1 0 24)' })
  );
};

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LinkNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var LinkNext = function LinkNext(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'LinkNext' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,12 L22,12 M13,3 L22,12 L13,21' })
  );
};

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LinkPrevious */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var LinkPrevious = function LinkPrevious(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'LinkPrevious' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,12 L22,12 M13,3 L22,12 L13,21', transform: 'matrix(-1 0 0 1 24 0)' })
  );
};

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkTop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var LinkTop = function LinkTop(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'LinkTop' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,5 L12,23 M4,13 L12,5 L20,13 M2,2 L22,2' })
  );
};

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LinkUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var LinkUp = function LinkUp(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'LinkUp' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,2 L12,22 M3,11 L12,2 L21,11' })
  );
};

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Link = function Link(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Link' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16.1251884,2.42026615 C16.9095797,1.63587482 18.1818354,1.63638083 18.9643331,2.41887857 L21.5811214,5.03566688 C22.3647464,5.81929188 22.3723943,7.08215115 21.5797338,7.87481161 L17.8748116,11.5797338 C17.0904203,12.3641252 15.8181646,12.3636192 15.0356669,11.5811214 L12.4188786,8.96433312 C11.6352536,8.18070812 11.6276057,6.91784885 12.4202662,6.12518839 L16.1251884,2.42026615 Z M6.12518839,12.4202662 C6.90957973,11.6358748 8.18183538,11.6363808 8.96433312,12.4188786 L11.5811214,15.0356669 C12.3647464,15.8192919 12.3723943,17.0821512 11.5797338,17.8748116 L7.87481161,21.5797338 C7.09042027,22.3641252 5.81816462,22.3636192 5.03566688,21.5811214 L2.41887857,18.9643331 C1.63525357,18.1807081 1.6276057,16.9178488 2.42026615,16.1251884 L6.12518839,12.4202662 Z M7,17 L17,7' })
  );
};

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LinkedinOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var LinkedinOption = function LinkedinOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'LinkedinOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#0077B5', fillRule: 'evenodd', d: 'M22.0367422,22 L17.8848745,22 L17.8848745,15.5036305 C17.8848745,13.9543347 17.85863,11.9615082 15.7275829,11.9615082 C13.5676669,11.9615082 13.237862,13.6498994 13.237862,15.3925291 L13.237862,22 L9.0903683,22 L9.0903683,8.64071385 L13.0707725,8.64071385 L13.0707725,10.4673257 L13.1276354,10.4673257 C13.6813927,9.41667396 15.0356049,8.3091593 17.0555507,8.3091593 C21.2599073,8.3091593 22.0367422,11.0753215 22.0367422,14.6734319 L22.0367422,22 Z M4.40923804,6.81585163 C3.07514653,6.81585163 2,5.73720584 2,4.40748841 C2,3.07864579 3.07514653,2 4.40923804,2 C5.73720584,2 6.81585163,3.07864579 6.81585163,4.40748841 C6.81585163,5.73720584 5.73720584,6.81585163 4.40923804,6.81585163 L4.40923804,6.81585163 Z M6.48604672,22 L2.32980492,22 L2.32980492,8.64071385 L6.48604672,8.64071385 L6.48604672,22 Z' })
  );
};

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Linkedin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Linkedin = function Linkedin(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Linkedin' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#0077B5', fillRule: 'evenodd', d: 'M20.45175,20.45025 L16.89225,20.45025 L16.89225,14.88075 C16.89225,13.5525 16.86975,11.844 15.04275,11.844 C13.191,11.844 12.90825,13.2915 12.90825,14.7855 L12.90825,20.45025 L9.3525,20.45025 L9.3525,8.997 L12.765,8.997 L12.765,10.563 L12.81375,10.563 C13.2885,9.66225 14.4495,8.71275 16.18125,8.71275 C19.78575,8.71275 20.45175,11.08425 20.45175,14.169 L20.45175,20.45025 Z M5.33925,7.4325 C4.1955,7.4325 3.27375,6.50775 3.27375,5.36775 C3.27375,4.2285 4.1955,3.30375 5.33925,3.30375 C6.47775,3.30375 7.4025,4.2285 7.4025,5.36775 C7.4025,6.50775 6.47775,7.4325 5.33925,7.4325 L5.33925,7.4325 Z M7.11975,20.45025 L3.5565,20.45025 L3.5565,8.997 L7.11975,8.997 L7.11975,20.45025 Z M23.00025,0 L1.0005,0 C0.44775,0 0,0.44775 0,0.99975 L0,22.9995 C0,23.55225 0.44775,24 1.0005,24 L23.00025,24 C23.55225,24 24,23.55225 24,22.9995 L24,0.99975 C24,0.44775 23.55225,0 23.00025,0 L23.00025,0 Z' })
  );
};

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Local */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Local = function Local(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Local' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,4 L23,4 L23,20 L1,20 L1,4 Z M11,8 L23,8 M1,16 L23,16 M1,12 L23,12 M11,4 L11,12' })
  );
};

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LocationPin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var LocationPin = function LocationPin(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'LocationPin' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,10 C14.209139,10 16,8.209139 16,6 C16,3.790861 14.209139,2 12,2 C9.790861,2 8,3.790861 8,6 C8,8.209139 9.790861,10 12,10 Z M12,10 L12,22' })
  );
};

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Location */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Location = function Location(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Location' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C12,22 4,16 4,10 C4,5 8,2 12,2 C16,2 20,5 20,10 C20,16 12,22 12,22 Z M12,13 C13.657,13 15,11.657 15,10 C15,8.343 13.657,7 12,7 C10.343,7 9,8.343 9,10 C9,11.657 10.343,13 12,13 L12,13 Z' })
  );
};

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Lock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Lock = function Lock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Lock' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M19,23 L19,11 L5,11 L5,23 L19,23 Z M12,15 L12,19 M17,11 L17,7 C17,4 17,1 12,1 C7,1 7,4 7,7 L7,11' })
  );
};

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Login */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Login = function Login(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Login' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M9,15 L9,22 L22,22 L22,2 L9,2 L9,9 M18,12 L0,12 M13,7 L18,12 L13,17' })
  );
};

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Logout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Logout = function Logout(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Logout' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#231F20', strokeWidth: '2', d: 'M13,9 L13,2 L1,2 L1,22 L13,22 L13,15 M22,12 L5,12 M17,7 L22,12 L17,17' })
  );
};

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Lounge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Lounge = function Lounge(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Lounge' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,5.99703014 C5,5.4463856 5.44994876,5 6.00684547,5 L17.9931545,5 C18.5492199,5 19,5.45303631 19,5.99703014 L19,13 L5,13 L5,5.99703014 Z M22,8 L22,15.0029699 C22,15.5536144 21.5446944,16 21.0081969,16 L2.99180311,16 C2.44404538,16 2,15.5469637 2,15.0029699 L2,8 M5,16 L5,18 L5,16 Z M19,16 L19,18 L19,16 Z' })
  );
};

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Magic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Magic = function Magic(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Magic' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2.5,19.5 L19.5,2.5 L21.5,4.5 L4.5,21.5 L2.5,19.5 Z M3,20 L15,8 L16,9 L4,21 L3,20 Z M5.5,3 L5,3.5 L5.5,4 L6,3.5 L5.5,3 Z M11.5,3 L11,3.5 L11.5,4 L12,3.5 L11.5,3 Z M8.5,6 L8,6.5 L8.5,7 L9,6.5 L8.5,6 Z M20.5,12 L20,12.5 L20.5,13 L21,12.5 L20.5,12 Z M20.5,17 L20,17.5 L20.5,18 L21,17.5 L20.5,17 Z' })
  );
};

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MailOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var MailOption = function MailOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'MailOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,4 L23,4 L23,20 L1,20 L1,4 Z M1,5 L12,13.5 L23,5' })
  );
};

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Mail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Mail = function Mail(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Mail' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#01A982', fillRule: 'evenodd', d: 'M23,20 L23,6 L12,15 L1,6 L1,20 L23,20 Z M12,12 L22,4 L2,4 L12,12 Z' })
  );
};

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Mandriva */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Mandriva = function Mandriva(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Mandriva' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#E8B845', fillRule: 'evenodd', d: 'M14.5570931,17.2000288 C11.5359885,19.9198072 8.20256657,21.3464829 5.48168143,21.3477982 L5.47448141,21.3477982 C3.53623738,21.3469582 1.90939399,20.6221567 0.929831949,19.1255136 C-1.43057297,15.5191461 0.857831799,8.79721207 6.0417226,4.11132231 C6.48248351,3.71304149 6.93008445,3.34272071 7.38104539,3 C3.03835634,7.58232954 1.26883266,13.546462 3.44275718,16.8678289 C5.39538971,19.8509662 9.91672716,19.7668791 14.3554206,16.9971815 L13.0316172,15.6656664 C12.8748968,15.5090661 12.6040563,15.4076658 12.3402957,15.4076658 C12.2337355,15.4076658 12.1324553,15.4249459 12.0478551,15.4574659 L7.76936619,17.1139494 C7.66772598,17.1534295 7.57496579,17.1731095 7.49408562,17.1731095 C7.31780525,17.1731095 7.23512508,17.0811893 7.20176501,17.0262292 C7.1495649,16.940789 7.11452483,16.7857487 7.2444851,16.5305082 L9.33848946,12.4490597 C9.48608977,12.1594991 9.43796967,11.7014581 9.23264924,11.4486176 L6.33584321,7.89157019 C6.1409628,7.65300969 6.15512283,7.48608934 6.20168293,7.38816914 C6.235163,7.31748899 6.32816319,7.19892875 6.5736837,7.19892875 C6.6216838,7.19892875 6.67364391,7.20360876 6.72884403,7.21260877 L11.2574135,7.94185029 C11.2922135,7.9476103 11.3294136,7.95037031 11.3676937,7.95037031 C11.6742943,7.95037031 12.0216951,7.77084994 12.1756554,7.53348944 L14.6625406,3.67956142 C14.8154209,3.44304092 14.9649412,3.39336082 15.0633414,3.39336082 C15.1529816,3.39336082 15.368742,3.43704091 15.4313822,3.84156175 L16.1365036,8.3750512 C16.1864237,8.69701187 16.4945844,9.03925258 16.808865,9.12241275 L21.2429943,10.2967352 C21.5752749,10.3851754 21.6415151,10.5556957 21.6513551,10.6492959 C21.6613151,10.7426561 21.6323951,10.9227765 21.3261544,11.0781768 L17.2318659,13.1493811 C16.9415853,13.2957814 16.7119048,13.6941823 16.7297849,14.019503 L16.9825054,18.6005125 C16.9935454,18.7941929 16.9555053,18.9384332 16.8698251,19.0291534 C16.811985,19.0899935 16.7372249,19.1222736 16.6528647,19.1222736 C16.5299844,19.1222736 16.3999042,19.0537534 16.2657439,18.9186332 L14.5570935,17.2000293 L14.5570931,17.2000288 Z M24,11.4025855 C22.7552374,10.7310641 22.576677,10.7632242 21.6445151,11.8272664 C22.3162765,10.5826238 22.2838764,10.4035834 21.2195942,9.47142148 C22.4647168,10.1433029 22.6436372,10.1110228 23.5756791,9.04710059 C22.9040377,10.2918632 22.9364378,10.4706636 24,11.4025855 Z' })
  );
};

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Manual */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Manual = function Manual(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Manual' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M14,9 L14,17 L14,9 Z M10,9 L10,17 L10,9 Z M8,5 C8,7.209 9.791,9 12,9 C14.209,9 16,7.209 16,5 C16,2.791 14.209,1 12,1 C9.791,1 8,2.791 8,5 Z M4,23 L20,23 L20,20 L4,20 L4,23 Z M7,20 L17,20 L17,17 L7,17 L7,20 Z' })
  );
};

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MapLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var MapLocation = function MapLocation(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'MapLocation' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17.5,6.5 L23,9 L23,22 L16,19 L8,22 L1,19 L1,6 L6,8 M16,19 L16,12 M8,22 L8,12 M12,16.2727273 C12,16.2727273 6,11.5 6,7 C6,3.25 9,1 12,1 C15,1 18,3.25 18,7 C18,11.5 12,16.2727273 12,16.2727273 Z M13,7 C13,6.44766667 12.5523333,6 12,6 C11.4476667,6 11,6.44766667 11,7 C11,7.55233333 11.4476667,8 12,8 C12.5523333,8 13,7.55233333 13,7 Z' })
  );
};

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Map */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Map = function Map(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Map' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,15 L19,15 L22,22 L2,22 L5,15 L9,15 M13,8 C13,8.5525 12.5525,9 12,9 C11.4475,9 11,8.5525 11,8 C11,7.4475 11.4475,7 12,7 C12.5525,7 13,7.4475 13,8 M6,8 C6,13 12,18 12,18 C12,18 18,13 18,8 C18,4.58317221 15.3135725,2 12,2 C8.68642746,2 6,4.58317221 6,8 Z' })
  );
};

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Mastercard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Mastercard = function Mastercard(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Mastercard' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: '7', cy: '12', r: '7', fill: '#EA001B' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: '17', cy: '12', r: '7', fill: '#FFA200', fillOpacity: '.8' })
    )
  );
};

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Medium */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Medium = function Medium(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Medium' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#444', d: 'M2.84593838,5.88685595 C2.87575654,5.59224254 2.76340763,5.30104995 2.54341737,5.10276397 L0.302521008,2.4032473 L0.302521008,2 L7.2605042,2 L12.6386555,13.7949836 L17.3669469,2 L24,2 L24,2.4032473 L22.0840336,4.2402628 C21.9188563,4.36617057 21.8369199,4.57310892 21.8711485,4.77792587 L21.8711485,18.2755093 C21.8369199,18.4803262 21.9188563,18.6872645 22.0840336,18.8131723 L23.9551821,20.6501878 L23.9551821,21.0534351 L14.5434174,21.0534351 L14.5434174,20.6501878 L16.4817928,18.7683671 C16.6722689,18.5779447 16.6722689,18.5219382 16.6722689,18.2307041 L16.6722689,7.32062416 L11.2829132,21.0086299 L10.5546219,21.0086299 L4.28011204,7.32062416 L4.28011204,16.4945003 C4.22779746,16.8801958 4.35589372,17.2685069 4.62745097,17.5474239 L7.14845938,20.6053826 L7.14845938,21.0086299 L0,21.0086299 L0,20.6053826 L2.5210084,17.5474239 C2.79058848,17.2680445 2.91121535,16.8771576 2.84593838,16.4945003 L2.84593838,5.88685595 Z' })
  );
};

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Menu = function Menu(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Menu' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,19 L22,19 M2,5 L22,5 M2,12 L22,12' })
  );
};

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Microfocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Microfocus = function Microfocus(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Microfocus' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#0078EF', fillRule: 'evenodd', d: 'M1,5 L5,5 L5,19 L19,19 L19,23 L1,23 L1,5 Z M5,1 L23,1 L23,19 L19,19 L19,5 L5,5 L5,1 Z' })
  );
};

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Microphone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Microphone = function Microphone(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Microphone' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,11 C8,14 9.790861,15 12,15 C14.209139,15 16,14 16,11 L16,5 C16,2 14.209139,1 12,1 C9.790861,1 8,2 8,5 L8,11 Z M4,9 L4,11 C4,16 7.581722,19 12,19 C16.418278,19 20,16 20,11 L20,9 M12,24 L12,19' })
  );
};

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Money */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Money = function Money(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Money' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,16 C16,14.8954305 12.8659932,14 9,14 C5.13400675,14 2,14.8954305 2,16 C2,17.1045695 5.13400675,18 9,18 C12.8659932,18 16,17.1045695 16,16 Z M2,16 L2,20.9367547 C2,22.0762536 5.13400675,23 9,23 C12.8659932,23 16,22.0762537 16,20.9367548 L16,16 M9,5 C4.581722,5 1,5.8954305 1,7 C1,8.1045695 4.581722,9 9,9 M1,7 L1,12.0000002 C1,13.0128881 4.581722,14 9,14 M23,4 C23,2.8954305 19.9004329,2 16.0769231,2 C12.2534133,2 9.15384615,2.8954305 9.15384615,4 C9.15384615,5.1045695 12.2534133,6 16.0769231,6 C19.9004329,6 23,5.1045695 23,4 Z M16,16 C19.8235098,16 23.0000002,15.0128879 23.0000002,14 L23,4 M9.15384615,3.99999999 L9.15384615,14.1660042 M8.99999999,9.00000001 C8.99999999,10.0128879 12.2534135,11 16.0769233,11 C19.9004331,11 23.0000004,10.0128879 23.0000004,9.00000001' })
  );
};

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Monitor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Monitor = function Monitor(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Monitor' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,16 L23,16 L23,2 L1,2 L1,16 Z M5,22 L19,22 L5,22 Z M9,22 L15,22 L15,16 L9,16 L9,22 Z' })
  );
};

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Monospace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Monospace = function Monospace(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Monospace' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M11.88,17H9.58L8.65,14.1H4.44L3.57,17H1.32L5.41,4.17H7.66ZM8,11.93,6.52,7.17,5.09,11.93Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M14.13,17,12.22,4.17h1.66L15.07,13l1.46-8.82h1.92l1.4,9,1.23-9h1.62L20.78,17H19.06l-1.6-9.6L15.88,17Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { points: '11.36 17.95 11.36 19.34 1.89 19.34 1.89 17.95 1.38 17.95 1.38 19.86 1.64 19.86 1.89 19.86 11.36 19.86 11.87 19.86 11.87 19.86 11.87 17.95 11.36 17.95' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { points: '22.17 18 22.17 19.39 12.69 19.39 12.69 18 12.19 18 12.19 19.91 12.45 19.91 12.69 19.91 22.17 19.91 22.67 19.91 22.68 19.91 22.68 18 22.17 18' })
  );
};

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return More; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var More = function More(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'More' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,13 L3,11 L5,11 L5,13 L3,13 Z M11,12.9995001 L11,11 L12.9995001,11 L12.9995001,12.9995001 L11,12.9995001 Z M19,12.9995001 L19,11 L20.9995001,11 L20.9995001,12.9995001 L19,12.9995001 Z' })
  );
};

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Multimedia */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Multimedia = function Multimedia(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Multimedia' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M2,8 L2,22 L22,22 L22,9 M11,4 L7,8 M2,4 L2,8 L17,8 L21,4 L2,4 Z M16,4 L12,8' })
  );
};

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Multiple */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Multiple = function Multiple(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Multiple' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M19,15 L23,15 L23,1 L9,1 L9,5 M15,19 L19,19 L19,5 L5,5 L5,9 M1,23 L15,23 L15,9 L1,9 L1,23 L1,23 L1,23 Z' })
  );
};

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Music */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Music = function Music(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Music' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,17.9979131 C1,16.8944962 1.88670635,16 2.99810135,16 L9,16 L9,20.0020869 C9,21.1055038 8.11329365,22 7.00189865,22 L2.99810135,22 C1.89458045,22 1,21.1017394 1,20.0020869 L1,17.9979131 Z M15,17.9979131 C15,16.8944962 15.8867064,16 16.9981014,16 L23,16 L23,20.0020869 C23,21.1055038 22.1132936,22 21.0018986,22 L16.9981014,22 C15.8945804,22 15,21.1017394 15,20.0020869 L15,17.9979131 Z M9,16 L9,2 L23,2 L23,15.5 M9,6 L23,6' })
  );
};

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Mysql */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Mysql = function Mysql(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Mysql' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#00758F', fillRule: 'evenodd', d: 'M5.46192862,4.04007684 C5.18892668,4.03501656 4.99575061,4.06967946 4.79169495,4.11446291 L4.79169495,4.15152944 L4.82901449,4.15152944 C4.95944313,4.41909158 5.18943271,4.591394 5.35034952,4.82188962 C5.47407329,5.08262038 5.59817658,5.34297163 5.72227987,5.60332288 C5.73493056,5.5909252 5.74745474,5.57865403 5.75959941,5.56625635 C5.99047454,5.40394797 6.0957283,5.14410275 6.09471625,4.74737704 C6.00211318,4.64996671 5.98832392,4.52826705 5.90837155,4.4122602 C5.80235875,4.25754224 5.59615247,4.17012595 5.46192862,4.04007684 L5.46192862,4.04007684 Z M23.478665,23.1369293 C23.6543831,23.2658398 23.772161,23.4657208 24,23.5466852 L24,23.5093657 C23.8800714,23.3573044 23.8495833,23.1474294 23.7395222,22.9880306 C23.5786054,22.8271138 23.4164236,22.6655645 23.2555068,22.5040152 C22.7821179,21.8759083 22.1818425,21.3245911 21.5432356,20.8663831 C21.0345512,20.5006515 19.8944709,20.0072745 19.6819392,19.4148426 C19.6697946,19.4021919 19.6571439,19.3896677 19.6444932,19.3770171 C20.0054174,19.3365348 20.4283301,19.2059797 20.7614228,19.1165393 C21.3210894,18.9665021 21.8214243,19.0054662 22.3990549,18.8560615 C22.6600387,18.781296 22.9203899,18.7066569 23.1808677,18.6329033 L23.1808677,18.4834987 C22.8887632,18.1836773 22.6805328,17.7869515 22.3622414,17.5155942 C21.5283078,16.8061434 20.6188495,16.0966926 19.6818127,15.5056522 C19.1626283,15.1774933 18.5200996,14.9645821 17.969415,14.6865199 C17.7842089,14.5931578 17.4590861,14.5444526 17.3365009,14.3887226 C17.0476856,14.0198284 16.8899314,13.5523853 16.6667732,13.1228943 C16.1997097,12.2230506 15.740363,11.2403448 15.3263059,10.293567 C15.044322,9.6481287 14.8597484,9.01154587 14.5076796,8.43227067 C12.8174206,5.65329311 10.9976185,3.97581132 8.17942382,2.3270466 C7.57927498,1.97649592 6.85742648,1.83809735 6.09471625,1.65719245 C5.68546635,1.6325236 5.27545742,1.60734872 4.86620752,1.58267987 C4.61635635,1.47831166 4.35651113,1.17267094 4.12184079,1.02427832 C3.18796669,0.434503045 0.792811133,-0.848656668 0.10157731,0.838313141 C-0.335124586,1.90286889 0.753847001,2.94174374 1.14361483,3.48142227 C1.4172493,3.85980447 1.76704094,4.2842352 1.96287366,4.70967798 C2.09127818,4.98938478 2.11316388,5.27010364 2.22385744,5.56600333 C2.49432924,6.29518923 2.7293791,7.08838764 3.07929725,7.76241652 C3.25653344,8.10322617 3.45173363,8.46263233 3.67539786,8.76738751 C3.81265788,8.95449125 4.04720171,9.03684725 4.08401522,9.32578906 C3.85465817,9.64749617 3.84150145,10.1466925 3.7125909,10.5541713 C3.13065906,12.3887747 3.35014857,14.6686824 4.19660638,16.0266077 C4.45594557,16.443195 5.06773305,17.3374725 5.90837155,16.9942592 C6.64375629,16.6946908 6.47980332,15.76613 6.69018433,14.9469976 C6.73749792,14.760906 6.70865434,14.624405 6.80176344,14.5003017 L6.80176344,14.5373682 C7.02542767,14.9840642 7.2488389,15.4307601 7.47199711,15.8773296 C7.96815726,16.6759678 8.84826592,17.5111665 9.59415073,18.0739958 C9.98037636,18.3659737 10.2848785,18.8709894 10.7852134,19.0419002 L10.7852134,19.0040746 L10.7478939,19.0040746 C10.6504835,18.8536579 10.4989282,18.790531 10.3759635,18.6694638 C10.0844916,18.3836847 9.76050733,18.0287063 9.51938514,17.7014329 C8.84080201,16.780589 8.24153872,15.7725818 7.69553484,14.7235864 C7.43455106,14.2224925 7.20785066,13.6697838 6.98785512,13.1600874 C6.90322199,12.9633691 6.90423404,12.6662043 6.72737736,12.5643663 C6.48650818,12.9378147 6.13190928,13.2401663 5.94556458,13.6811694 C5.64776729,14.386319 5.60943569,15.2461865 5.49899515,16.1379338 C5.43371758,16.1614641 5.46268766,16.1453977 5.42422956,16.1750003 C4.90555118,16.0502645 4.72350772,15.5164053 4.53096418,15.0584502 C4.04378602,13.9006589 3.95333357,12.0360734 4.38206553,10.7030699 C4.4930121,10.3583386 4.99499157,9.27202362 4.79131543,8.95347919 C4.69441112,8.63544079 4.37510765,8.45187925 4.19635337,8.20885945 C3.97420721,7.90853201 3.75332613,7.5134509 3.59974672,7.16644241 C3.20150293,6.26368901 3.01528474,5.25024206 2.59540827,4.33749461 C2.39451528,3.90142525 2.0550972,3.45966308 1.77627595,3.07166635 C1.46759906,2.64204884 1.12185564,2.32578153 0.882884062,1.80583808 C0.797744903,1.62126448 0.681991069,1.32587082 0.808244978,1.13598393 C0.848094658,1.00783242 0.905022773,0.954446496 1.03190922,0.912572704 C1.24810955,0.746089595 1.84889092,0.967982736 2.07394674,1.06147135 C2.67055338,1.30929841 3.16924367,1.54548684 3.67489184,1.88035066 C3.91740561,2.04126747 4.16295554,2.35272751 4.45607208,2.43887872 L4.79118892,2.43887872 C5.31568662,2.5591868 5.90280525,2.47645128 6.39200751,2.62509691 C7.25744137,2.8881048 8.0329288,3.29722819 8.73719284,3.74202653 C10.8826237,5.09653615 12.6370217,7.02526068 13.8370664,9.32578906 C14.030116,9.69620133 14.1138635,10.0496617 14.2836358,10.4427187 C14.6265961,11.2350315 15.0591233,12.0501156 15.4004389,12.825097 C15.7408691,13.5978013 16.0728232,14.3779695 16.5541821,15.0213837 C16.8071959,15.3594102 17.7850944,15.5408211 18.2297663,15.7288104 C18.5412263,15.8602511 19.0514287,15.9976376 19.3460633,16.1750003 C19.9100312,16.5151775 20.4556556,16.9197466 20.9842015,17.292183 C21.2483479,17.4785277 22.0606489,17.886639 22.1006251,18.2223884 C20.7916579,18.1877255 19.7916207,18.3092986 18.9366869,18.6695903 C18.6936671,18.7716814 18.3064295,18.7747176 18.2664533,19.0787137 C18.4000446,19.2186304 18.4211712,19.4281259 18.527437,19.6000488 C18.7309867,19.9304848 19.0755915,20.3728795 19.3833829,20.6053993 C19.7195118,20.8590456 20.0657612,21.130403 20.4255469,21.3498925 C21.0663045,21.7407989 21.7818276,21.9638306 22.3984224,22.3551165 C22.7632683,22.5861182 23.1241926,22.8764515 23.478665,23.1369293 L23.478665,23.1369293 Z' })
  );
};

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Navigate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Navigate = function Navigate(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Navigate' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M20,11 L22,8 L20,5 L12,5 L12,11 L20,11 Z M12,24 L12,0 M4,2 L2,5 L4,8 L12,8 L12,2 L4,2 Z' })
  );
};

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Network */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Network = function Network(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Network' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000000', strokeWidth: '2', d: 'M7.5,7 L7.5,15.5142857 C7.5,19.7571429 13,18.3428571 13,22.1142857 L13,24 M11,10 L7.5,7 L4,10 M16.5,2 L16.5,10.440516 C16.5,14.5083612 13,13.1524128 13,16.7682752 L13,24 M13,5 L16.5,2 L20,5' })
  );
};

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NewWindow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var NewWindow = function NewWindow(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'NewWindow' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M11,9 L19,9 M15,13 L15,5 M17,17 L17,23 L1,23 L1,7 L1,7 L7,7 M7,1 L23,1 L23,17 L7,17 L7,1 Z' })
  );
};

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export New */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var New = function New(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'New' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,1 L12,23 M2,6 L22,18 M22.0000001,6 L2.00000008,18' })
  );
};

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Next */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Next = function Next(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Next' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7 2 17 12 7 22' })
  );
};

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Nodes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Nodes = function Nodes(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Nodes' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M14,4 C14,5.1048 13.1048,6 12,6 C10.8952,6 10,5.1048 10,4 C10,2.8952 10.8952,2 12,2 C13.1048,2 14,2.8952 14,4 Z M14,20 C14,21.1048 13.1048,22 12,22 C10.8952,22 10,21.1048 10,20 C10,18.8952 10.8952,18 12,18 C13.1048,18 14,18.8952 14,20 Z M7,8 C7,9.1048 6.1048,10 5,10 C3.8952,10 3,9.1048 3,8 C3,6.8952 3.8952,6 5,6 C6.1048,6 7,6.8952 7,8 Z M7,16 C7,17.1048 6.1048,18 5,18 C3.8952,18 3,17.1048 3,16 C3,14.8952 3.8952,14 5,14 C6.1048,14 7,14.8952 7,16 Z M21,8 C21,9.1048 20.1048,10 19,10 C17.8952,10 17,9.1048 17,8 C17,6.8952 17.8952,6 19,6 C20.1048,6 21,6.8952 21,8 Z M21,16 C21,17.1048 20.1048,18 19,18 C17.8952,18 17,17.1048 17,16 C17,14.8952 17.8952,14 19,14 C20.1048,14 21,14.8952 21,16 Z' })
  );
};

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Norton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Norton = function Norton(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Norton' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#E0B02F', d: 'M21.9101215,0.816194332 L22.7068826,0.816194332 L22.7068826,1.61295547 L21.9101215,1.61295547 L21.9101215,0.816194332 Z M21.9101215,1.61295547 L20.4331984,1.61295547 L20.4331984,2.4097166 L21.9101215,2.4097166 L21.9101215,1.61295547 Z M20.4331984,2.4097166 L20.4331984,3.96437247 L19.6947368,3.96437247 L19.6947368,2.4097166 L20.4331984,2.4097166 Z M20.4331984,3.96437247 L21.1910931,3.96437247 L21.1910931,4.72226721 L20.4331984,4.72226721 L20.4331984,3.96437247 Z M21.1910931,3.96437247 L21.1910931,3.21619433 L22.0267206,3.21619433 L22.0267206,3.96437247 L21.1910931,3.96437247 Z M20.4331984,4.72226721 L20.4331984,6.33522267 L19.7821862,6.33522267 L19.7821862,6.96680162 L19.0923077,6.96680162 L19.0923077,7.88987854 L18.4995951,7.88987854 L18.4995951,8.67692308 L17.7417004,8.67692308 L17.7417004,7.89959514 L16.9838057,7.89959514 L16.9740891,8.67692308 L17.7417004,8.67692308 L17.7417004,9.50283401 L16.9838057,9.50283401 L16.9935223,10.4064777 L16.3425101,10.4064777 L16.3522267,11.1643725 L15.7497976,11.1643725 L15.740081,12.0194332 C14.6042656,13.6541793 13.8165786,15.3703291 13.1068826,17.0817814 C13.0166656,17.2993424 12.9843157,17.4767392 12.8736842,17.6064777 C12.6350495,17.886327 12.2792569,17.974147 11.9894737,17.9659919 C11.4470717,17.9507255 10.9697158,17.6983044 10.7165992,17.1109312 C9.86728944,15.1400551 9.44710048,13.7603465 7.11174089,11.1740891 C6.73552723,10.7574572 6.82323501,10.2253563 7.12145749,10.0566802 C7.40843204,9.89436507 7.80877956,10.0107768 8.2582996,10.2607287 C9.51609859,10.9601153 10.2158747,11.6755026 11.7076923,13.6615385 C12.2511882,12.3496564 13.19015,10.5765708 14.3603239,8.65748988 L14.9044534,8.65748988 L14.9044534,7.89959514 L15.4194332,7.89959514 L15.4194332,7.151417 L16.1773279,7.151417 L16.1773279,5.9562753 L16.9935223,5.9562753 L16.9838057,6.71417004 L17.7417004,6.71417004 L17.7417004,5.9562753 L16.9935223,5.9562753 L16.9935223,5.27611336 L17.6736842,5.27611336 L17.6736842,4.72226721 L18.9271255,4.72226721 L18.9271255,5.49959514 L19.6947368,5.49959514 L19.6947368,4.72226721 L20.4331984,4.72226721 Z M18.9271255,4.72226721 L18.9271255,3.96437247 L19.6947368,3.96437247 L19.6947368,4.72226721 L18.9271255,4.72226721 Z M18.9271255,3.96437247 L18.1595142,3.96437247 L18.1595142,3.23562753 L18.9271255,3.23562753 L18.9271255,3.96437247 Z M20.4331999,2.41353172 L21.1897089,2.41353172 L21.1897089,3.21168583 L20.4331999,3.21168583 L20.4331999,2.41353172 Z M22.7027248,1.61537762 L23.5216979,1.61537762 L23.5216979,2.41353172 L22.7027248,2.41353172 L22.7027248,1.61537762 Z M16.5465587,4.54360314 L16.5465587,5.28582996 L15.6137652,5.28582996 L15.6137652,6.52955466 L14.6809717,6.52955466 L14.6809717,7.26441847 C13.6908876,6.74537522 12.5637461,6.45182186 11.3676113,6.45182186 C7.42126355,6.45182186 4.21619433,9.64716515 4.21619433,13.5935223 C4.21619433,17.5398576 7.42126355,20.7352227 11.3676113,20.7352227 C15.3139591,20.7352227 18.5093117,17.5398576 18.5093117,13.5935223 C18.5093117,12.3895534 18.2119011,11.2554858 17.6864896,10.2607287 L18.4121457,10.2607287 L18.4121457,9.32793522 L19.0340081,9.32793522 L19.0340081,8.3951417 L19.6558704,8.3951417 L19.6558704,7.61781377 L19.9265337,7.61781377 C21.1151026,9.30906076 21.8129555,11.3700091 21.8129555,13.5935223 C21.8129555,19.3395646 17.1525368,24 11.4064777,24 C5.66041864,24 1,19.3395646 1,13.5935223 C1,7.84746131 5.66041864,3.18704453 11.4064777,3.18704453 C13.2757551,3.18704453 15.0301395,3.68025475 16.5465587,4.54360314 L16.5465587,4.54360314 Z M22.7027248,0 L23.5216979,0 L23.5216979,0.817223514 L22.7027248,0.817223514 L22.7027248,0 Z' })
  );
};

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Note */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Note = function Note(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Note' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,23 L16,23 L23,16 L23,1 L1,1 L1,23 Z M15,23 L15,15 L23,15' })
  );
};

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Notes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Notes = function Notes(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Notes' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,1 L3,23 L16,23 L21,18 L21,1 L3,1 Z M6,17 L11,17 M6,13 L18,13 M6,9 L16,9 M3,5 L21,5 M21,17 L15,17 L15,23' })
  );
};

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Notification */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Notification = function Notification(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Notification' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4,19 L4,9 C4,4.582 7.582,1 12,1 C16.418,1 20,4.582 20,9 L20,19 M1,19 L23,19 M15,19 L15,20 C15,21.657 13.657,23 12,23 C10.343,23 9,21.657 9,20 L9,19' })
  );
};

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ObjectGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ObjectGroup = function ObjectGroup(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ObjectGroup' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,1 L4,1 L4,4 L1,4 L1,1 Z M20,1 L23,1 L23,4 L20,4 L20,1 Z M4,2 L20,2 M4,22 L20,22 M1,20 L4,20 L4,23 L1,23 L1,20 Z M20,20 L23,20 L23,23 L20,23 L20,20 Z M2,4 L2,20 M22,4 L22,20 M7,7 L14,7 L14,13 L7,13 L7,7 Z M17,10 L17,17 L10,17 L10,15' })
  );
};

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ObjectUngroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ObjectUngroup = function ObjectUngroup(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ObjectUngroup' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,1 L4,1 L4,4 L1,4 L1,1 Z M13,1 L16,1 L16,4 L13,4 L13,1 Z M4,2 L13,2 M15,9 L20,9 M4,15 L13,15 M1,13 L4,13 L4,16 L1,16 L1,13 Z M13,13 L16,13 L16,16 L13,16 L13,13 Z M2,4 L2,13 M15,4 L15,13 M20,8 L23,8 L23,11 L20,11 L20,8 Z M11,22 L20,22 M8,20 L11,20 L11,23 L8,23 L8,20 Z M20,20 L23,20 L23,23 L20,23 L20,20 Z M9,16 L9,20 M22,11 L22,20' })
  );
};

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OfflineStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var OfflineStorage = function OfflineStorage(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'OfflineStorage' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,21 C15.5230211,21 18.5732537,18.9757518 20.0510587,16.0268945 C20.6582603,14.8152657 21,13.4475416 21,12 C21,10.5673224 20.6652426,9.21283165 20.0696798,8.01047964 C18.5989839,5.04136538 15.5378852,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M20,9 L12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 L20,15' })
  );
};

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Onedrive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Onedrive = function Onedrive(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Onedrive' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#4F8AD8', fillRule: 'evenodd', d: 'M21.6924215,13.986674 C22.9997233,14.1908343 24,15.3216239 24,16.6862741 C24,17.7522298 23.3892094,18.6751163 22.4988002,19.1254521 C22.4321553,19.1592575 22.3639409,19.1904067 22.294157,19.2186583 L8.59404885,19.2186583 L8.59404885,19.2181754 C6.85476268,19.2073094 5.44797646,17.7943658 5.44797646,16.0524235 C5.44797646,14.3037201 6.86550796,12.8860679 8.61421133,12.8860679 C8.70222602,12.8860679 8.78903338,12.8906557 8.87511633,12.8976583 C8.87028699,12.8172498 8.86702719,12.7364791 8.86702719,12.6548633 C8.86702719,10.4662072 10.6413261,8.69190834 12.8299821,8.69190834 C14.3676434,8.69190834 15.6998164,9.5683125 16.3568479,10.8482079 C16.9002691,10.4918027 17.5498151,10.283779 18.2483789,10.283779 C20.1559675,10.283779 21.7023216,11.8301331 21.7023216,13.7377217 C21.7023216,13.8215107 21.6982167,13.9043338 21.6924215,13.986674 Z M8.18741857,12.2086324 C6.25507961,12.421727 4.74711875,14.0641849 4.74711875,16.0524235 C4.74711875,16.8619413 4.9992102,17.6150766 5.42841764,18.2378198 L3.27887919,18.2378198 C1.46799809,18.2378198 -1.77635684e-15,16.7698217 -1.77635684e-15,14.9589406 C-1.77635684e-15,13.2281057 1.34134869,11.8115401 3.04103428,11.6894786 C2.98428956,11.4324371 2.95350253,11.1656161 2.95350253,10.8915512 C2.95350253,8.85248384 4.60646427,7.19964283 6.64541087,7.19964283 C7.40977438,7.19964283 8.11980783,7.43181327 8.70886636,7.82963 C9.54542848,6.15252157 11.276867,5 13.2783862,5 C15.9223281,5 18.0967377,7.01021204 18.3569183,9.58557738 C18.3206982,9.58461151 18.2847197,9.58292125 18.2483789,9.58292125 C17.6798451,9.58292125 17.1232638,9.6982217 16.6079734,9.92012979 C15.7386926,8.71545137 14.3462736,7.99105063 12.8299821,7.99105063 C10.4089142,7.99105063 8.41282793,9.84563725 8.18741857,12.2086324 Z' })
  );
};

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Opera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Opera = function Opera(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Opera' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#CC0F16', fillRule: 'evenodd', d: 'M12.124775,0 C5.56831311,0 1,4.75571037 1,11.888501 C1,18.2355851 5.43849706,24 12.1251037,24 C18.8774638,24 23.3506693,18.2369941 23.3506693,11.888501 C23.3506223,4.69859883 18.621683,0 12.124775,0 L12.124775,0 Z M12.1251037,21.3207828 C11.5820274,21.3207828 11.1100117,21.2149198 10.6996164,21.0221213 C9.55884149,20.4469667 8.87181213,19.1728532 8.46982387,17.6127593 C8.03491194,15.803319 7.98578474,13.6079061 7.98578474,11.6864031 C7.98578474,8.2547319 8.23625832,5.15403523 9.63680626,3.60648141 C10.2479843,2.95679061 11.0537456,2.57222701 12.1121409,2.56936204 C12.1165088,2.56936204 12.1208767,2.5689863 12.1250098,2.5689863 C13.5037182,2.5689863 14.4704814,3.24413307 15.1409315,4.30276321 C16.1404305,5.99107632 16.3679843,8.72707632 16.3679843,11.6711389 C16.3680783,15.8502857 16.0902701,21.3207828 12.1251037,21.3207828 L12.1251037,21.3207828 Z' })
  );
};

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Optimize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Optimize = function Optimize(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Optimize' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,22 L6,22 L6,18 L2,18 L2,22 Z M22,2 L12,12 M22,10 L22,2 L14,2 M22,13 L18,13 L18,22 L22,22 L22,13 Z M10,22 L14,22 L14,16 L10,16 L10,22 Z' })
  );
};

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Oracle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Oracle = function Oracle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Oracle' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#F00', fillRule: 'evenodd', d: 'M7.957359,18.9123664 C4.11670252,18.9123664 1,15.803458 1,11.9617373 C1,8.12000773 4.11670252,5 7.957359,5 L16.0437948,5 C19.8855156,5 23,8.12000773 23,11.9617373 C23,15.803458 19.8855156,18.9123664 16.0437948,18.9123664 L7.957359,18.9123664 L7.957359,18.9123664 Z M15.8639176,16.4585488 C18.352201,16.4585488 20.3674397,14.448858 20.3674397,11.9617373 C20.3674397,9.47460595 18.352201,7.45381934 15.8639176,7.45381934 L8.1360824,7.45381934 C5.64895285,7.45381934 3.63255855,9.47460595 3.63255855,11.9617373 C3.63255855,14.448858 5.64895285,16.4585488 8.1360824,16.4585488 L15.8639176,16.4585488 L15.8639176,16.4585488 Z' })
  );
};

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OrderedList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var OrderedList = function OrderedList(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'OrderedList' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '5.77', y: '6.42', width: '18.06', height: '1.75' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '5.77', y: '11.71', width: '18.06', height: '1.75' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '5.77', y: '16.99', width: '18.06', height: '1.75' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M3.13,4.87V8a2,2,0,0,0,0,.45.3.3,0,0,0,.13.16.62.62,0,0,0,.32.06H3.7v.11h-2V8.71h.1a.79.79,0,0,0,.35-.06.29.29,0,0,0,.14-.16A1.75,1.75,0,0,0,2.3,8V6a1.28,1.28,0,0,0,0-.33.24.24,0,0,0-.1-.11.28.28,0,0,0-.16,0,.91.91,0,0,0-.35.09l-.05-.1L3,4.87Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M3.65,14.3H1.37v-.06a12.51,12.51,0,0,0,1.27-1.67,1.81,1.81,0,0,0,.22-.84.7.7,0,0,0-.18-.5.6.6,0,0,0-.45-.2.75.75,0,0,0-.68.44l-.11,0a1.58,1.58,0,0,1,.47-.81,1.09,1.09,0,0,1,.72-.26,1.06,1.06,0,0,1,.54.14,1,1,0,0,1,.38.37.9.9,0,0,1,.14.45,1.6,1.6,0,0,1-.21.77,7.28,7.28,0,0,1-1.25,1.47h.83a1.87,1.87,0,0,0,.4,0,.33.33,0,0,0,.15-.09,1.16,1.16,0,0,0,.16-.26h.1Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M2.09,18v-.1a1.88,1.88,0,0,0,.45-.17.67.67,0,0,0,.22-.25.69.69,0,0,0,.09-.34.55.55,0,0,0-.17-.41.58.58,0,0,0-.43-.17.8.8,0,0,0-.68.42l-.11,0A1.72,1.72,0,0,1,2,16.19a1.16,1.16,0,0,1,.71-.24.93.93,0,0,1,.66.24.76.76,0,0,1,.26.57.78.78,0,0,1-.12.41,1,1,0,0,1-.38.35,1.34,1.34,0,0,1,.51.4,1,1,0,0,1,.17.6,1.38,1.38,0,0,1-.44,1A1.62,1.62,0,0,1,2.2,20a1.24,1.24,0,0,1-.71-.16.34.34,0,0,1-.16-.29.32.32,0,0,1,.31-.32.41.41,0,0,1,.18,0l.32.25a.84.84,0,0,0,.52.23A.47.47,0,0,0,3,19.55a.61.61,0,0,0,.15-.42,1.1,1.1,0,0,0-.27-.72A1.42,1.42,0,0,0,2.09,18Z' })
  );
};

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Organization */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Organization = function Organization(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Organization' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M20,3 L20,23 L4,23 L4,3 L20,3 Z M8.042,9 L10.042,9 L10.042,7 L8.042,7 L8.042,9 Z M14,9 L16,9 L16,7 L14,7 L14,9 Z M8.042,15 L10.042,15 L10.042,13 L8.042,13 L8.042,15 Z M10.042,23 L14.042,23 L14.042,19 L10.042,19 L10.042,23 Z M14,15 L16,15 L16,13 L14,13 L14,15 Z M2,3 L22,3 L22,1 L2,1 L2,3 Z' })
  );
};

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Overview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Overview = function Overview(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Overview' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M18.5,21 C20.9852814,21 23,18.9852814 23,16.5 C23,14.0147186 20.9852814,12 18.5,12 C16.0147186,12 14,14.0147186 14,16.5 C14,18.9852814 16.0147186,21 18.5,21 L18.5,21 Z M10,7 L14,7 M1.5,14.5 C1.5,14.5 5.5,5 6,4 C6.5,3 7.5,3 8,3 C8.5,3 10,3 10,5 L10,16 M5.5,21 C3.01471863,21 1,18.9852814 1,16.5 C1,14.0147186 3.01471863,12 5.5,12 C7.98528137,12 10,14.0147186 10,16.5 C10,18.9852814 7.98528137,21 5.5,21 L5.5,21 L5.5,21 Z M22.5,14.5 C22.5,14.5 18.5,5 18,4 C17.5,3 16.5,3 16,3 C15.5,3 14,3 14,5 L14,16 M10,16 L14,16' })
  );
};

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Paint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Paint = function Paint(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Paint' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4,10 L2,10 C2,4.4771525 2,1 12,1 C22,1 22,4.4771525 22,10 L20,10 M12,10 C16.418278,10 20,9.1045695 20,8 C20,6.8954305 16.418278,6 12,6 C7.581722,6 4,6.8954305 4,8 C4,9.1045695 7.581722,10 12,10 Z M4,20 C4,21.6568542 7.581722,23 12,23 C16.418278,23 20,21.6568542 20,20 M20,8 L20,20 L20,8 Z M4,20 L4,8 L4,20 Z M8,13 L8,17 M13,13 L13,17 M7,12 C5.5,12 4,11 4,8 M18,13.5 C18,13.5 18,14 18,12 C18,10 20,11 20,8 M8,13 C8,12.4477153 7.55228475,12 7,12 M13,13 C13,12.4477153 13.4477153,12 14,12 C14.5522847,12 15,12.4477153 15,13 L15,13.5 M15,13.5 C15,14.3284271 15.6715729,15 16.5,15 C17.3284271,15 18,14.3284271 18,13.5 M8,17 C8,18.3807119 9.11928813,19.5 10.5,19.5 C11.8807119,19.5 13,18.3807119 13,17' })
  );
};

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Pan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Pan = function Pan(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Pan' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8.5,5.5 L12,2 L15.5,5.5 M22,12 L2,12 M5.5,8.5 L2,12 L5.5,15.5 M18.5,15.5 L22,12 L18.5,8.5 M12,22 L12,2 M8.5,18.5 L12,22 L15.5,18.5' })
  );
};

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PauseFill */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var PauseFill = function PauseFill(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'PauseFill' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,21 L9,21 L9,3 L3,3 L3,21 Z M4,19 L8,19 L8,5 L4,5 L4,19 Z M5,17 L7,17 L7,7 L5,7 L5,17 Z M15,21 L21,21 L21,3 L15,3 L15,21 Z M16,19 L20,19 L20,5 L16,5 L16,19 Z M17,17 L19,17 L19,7 L17,7 L17,17 Z' })
  );
};

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Pause */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Pause = function Pause(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Pause' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,21 L9,21 L9,3 L3,3 L3,21 Z M15,21 L21,21 L21,3 L15,3 L15,21 Z' })
  );
};

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Paypal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Paypal = function Paypal(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Paypal' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#003087', fillRule: 'evenodd', d: 'M21.4945038,7.054125 C20.4250038,12.026625 17.0155038,14.658375 11.6050038,14.658375 L9.64300376,14.658375 L8.17975376,24.000375 L11.3620038,24.000375 C11.8217538,24.000375 12.2125038,23.665875 12.2845038,23.212125 L12.3220038,23.014125 L13.0540038,18.377625 L13.1012538,18.121875 C13.1725038,17.668125 13.5640038,17.333625 14.0230038,17.333625 L14.6042538,17.333625 C18.3640038,17.333625 21.3085038,15.805875 22.1687538,11.388375 C22.5137538,9.615375 22.3480038,8.128875 21.4945038,7.054125 M19.3172538,1.80975 C18.2057538,0.543 16.1972538,0 13.6270038,0 L6.16900376,0 C5.64325376,0 5.19625376,0.3825 5.11375376,0.90075 L2.00800376,20.59725 C1.94650376,20.98575 2.24725376,21.3375 2.64100376,21.3375 L7.24525376,21.3375 L8.40175376,14.0025 L8.36575376,14.232 C8.44825376,13.71375 8.89225376,13.33125 9.41725376,13.33125 L11.6050038,13.33125 C15.9040038,13.33125 19.2692538,11.58525 20.2525038,6.53475 C20.2817538,6.38475 20.3290038,6.0975 20.3290038,6.0975 C20.6080038,4.2285 20.3267538,2.96025 19.3172538,1.80975' })
  );
};

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Performance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Performance = function Performance(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Performance' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M12,19 L10,22 L7,21 L6.5,17.5 L3,17 L2,14 L5,12 L2,10 L3,7 L6.5,6.5 L7,3 L10,2 L12,5 L14,2 L17,3 L17.5,6.5 L21,7 L22,10 L19,12 L22,14 L21,17 L17.5,17.5 L17,21 L14,22 L12,19 Z M12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 C9.790861,8 8,9.790861 8,12 C8,14.209139 9.790861,16 12,16 Z' })
  );
};

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PersonalComputer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var PersonalComputer = function PersonalComputer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'PersonalComputer' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,18 L21,18 L21,5 L21,5 C21,4.44771525 20.5522847,4 20,4 L4,4 L4,4 C3.44771525,4 3,4.44771525 3,5 L3,18 Z M2,20 L22,20 C23,20 23,19 23,19 L1,19 C1,19 1,20 2,20 Z' })
  );
};

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PieChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var PieChart = function PieChart(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'PieChart' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M10,23 C5.02943725,23 1,18.9705627 1,14 C1,9.02943725 5.02943725,5 10,5 L10,14 C10,14 10.7746374,14.7746374 11.1619561,15.1619561 L16.363961,20.363961 C14.7352814,21.9926407 12.4852814,23 10,23 Z M14,10 L14,1 C18.9705627,1 23,5.02943725 23,10 L14,10 Z M14,13 L22,13 C22,15.2037225 21.2079601,17.2224541 19.8930183,18.7870568 L14,13 Z' })
  );
};

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PiedPiper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var PiedPiper = function PiedPiper(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'PiedPiper' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#609B4D', fillRule: 'evenodd', d: 'M0,19.4210526 C2.2736843,19.4210526 4.04210525,18.6631579 4.04210525,18.6631579 C4.04210525,18.6631579 7.0736842,11.0842105 11.368421,11.0842105 C14.6526316,11.0842105 15.1578947,13.6105264 15.1578947,13.6105264 C15.1578947,13.6105264 19.9578947,4.26315788 24,3 C20.2105263,6.03157895 20.7157895,9.31578948 18.9473684,10.831579 C17.1789474,12.3473684 17.1789477,10.8381579 15.1578951,14.375 C10.6105267,14.8802632 9.125,16.3894739 6.06315789,18.1578947 C11.3684206,15.6315794 12.3789474,15.3789474 17.1789474,15.631579 C17.6828892,15.6581022 17.9368421,15.8842105 17.6842105,16.3894737 C16.951256,17.8553827 16.4037001,20.0617486 15.4105263,19.9263158 C9.85263157,19.1684211 6.56842104,20.431579 3.78947367,20.431579 C1.0105263,20.431579 0,19.9263158 0,19.4210526 Z' })
  );
};

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Pin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Pin = function Pin(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Pin' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,3 L10,9 C10,9 6,8 3,11 C3,11 13,21 13,21 C16,18 15,14 15,14 L21,8 L16,3 Z M1,23 L8,16 M14,1 L23,10' })
  );
};

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Pinterest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Pinterest = function Pinterest(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Pinterest' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#BD081C', fillRule: 'evenodd', d: 'M12,0 C5.37225,0 0,5.37225 0,12 C0,17.0835 3.16275,21.426 7.62675,23.17425 C7.52175,22.22475 7.42725,20.76825 7.66875,19.73175 C7.88625,18.79575 9.07575,13.767 9.07575,13.767 C9.07575,13.767 8.7165,13.0485 8.7165,11.98575 C8.7165,10.317 9.684,9.07125 10.88775,9.07125 C11.9115,9.07125 12.4065,9.84 12.4065,10.76175 C12.4065,11.7915 11.751,13.3305 11.41275,14.757 C11.13,15.95175 12.01125,16.926 13.1895,16.926 C15.3225,16.926 16.962,14.67675 16.962,11.43075 C16.962,8.5575 14.89725,6.54825 11.949,6.54825 C8.535,6.54825 6.531,9.1095 6.531,11.75625 C6.531,12.7875 6.92775,13.89375 7.4235,14.4945 C7.52175,14.61375 7.536,14.71725 7.50675,14.83875 C7.416,15.21825 7.2135,16.03275 7.17375,16.2 C7.12125,16.419 6.99975,16.46625 6.7725,16.3605 C5.27325,15.66225 4.3365,13.4715 4.3365,11.71125 C4.3365,7.926 7.08675,4.44975 12.2655,4.44975 C16.428,4.44975 19.6635,7.416 19.6635,11.3805 C19.6635,15.516 17.05575,18.8445 13.43625,18.8445 C12.2205,18.8445 11.0775,18.21225 10.686,17.466 C10.686,17.466 10.0845,19.75725 9.93825,20.319 C9.6675,21.36075 8.93625,22.66725 8.4465,23.4645 C9.57,23.8125 10.76325,24 12,24 C18.62775,24 24,18.627 24,12 C24,5.37225 18.62775,0 12,0' })
  );
};

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Plan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Plan = function Plan(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Plan' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M18,4 L18,0 L18,4 Z M7,18 L5,18 L7,18 Z M19,18 L9,18 L19,18 Z M7,14 L5,14 L7,14 Z M19,14 L9,14 L19,14 Z M6,4 L6,0 L6,4 Z M1,9 L23,9 L1,9 Z M1,23 L23,23 L23,4 L1,4 L1,23 Z' })
  );
};

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PlayFill */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var PlayFill = function PlayFill(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'PlayFill' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,22.0000002 L21,12 L3,2 L3,22.0000002 Z M5,19 L17.5999998,11.9999999 L5,5 L5,19 Z M7,16 L14.1999999,12 L7,8 L7,16 Z M9,13 L10.8,12 L9,11 L9,13 Z' })
  );
};

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Play */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Play = function Play(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Play' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '3 22 21 12 3 2' })
  );
};

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Power */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Power = function Power(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Power' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,4 C19.3637732,5.43018182 22,8.98935065 22,13 C22,18.6008831 17.5273457,23 12,23 C6.47265429,23 2,18.6008831 2,13 C2,8.98935065 4.63622679,5.43018182 8,4 M12,1 L12,11' })
  );
};

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Previous */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Previous = function Previous(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Previous' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7 2 17 12 7 22', transform: 'matrix(-1 0 0 1 24 0)' })
  );
};

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Print */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Print = function Print(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Print' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,19 L1,19 L1,7 L23,7 L23,19 L18,19 M3,16 L21,16 M6,16 L6,23 L6,23 L18,23 L18,16 M18,7 L18,1 L6,1 L6,7 L6,7 M17,12 L19,12 L19,11 L17,11 L17,12 Z' })
  );
};

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductHunt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ProductHunt = function ProductHunt(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ProductHunt' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#DA552F', fillRule: 'evenodd', d: 'M13.59975,8.4 L13.59975,8.4 L10.2,8.4 L10.2,12 L13.59975,12 C14.59425,12 15.39975,11.19375 15.39975,10.2 C15.39975,9.20625 14.59425,8.4 13.59975,8.4 M13.59975,14.4 L13.59975,14.4 L10.2,14.4 L10.2,18 L7.8,18 L7.8,6 L13.59975,6 C15.9195,6 17.79975,7.88025 17.79975,10.2 C17.79975,12.51975 15.9195,14.4 13.59975,14.4 M12,0 C5.37225,0 0,5.37225 0,12 C0,18.62775 5.37225,24 12,24 C18.627,24 24,18.62775 24,12 C24,5.37225 18.627,0 12,0' })
  );
};

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Projects */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Projects = function Projects(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Projects' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,1 L9,1 L9,9 L1,9 L1,1 Z M15,1 L23,1 L23,9 L15,9 L15,1 Z M1,15 L9,15 L9,23 L1,23 L1,15 Z M15,15 L23,15 L23,23 L15,23 L15,15 Z' })
  );
};

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RadialSelected */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var RadialSelected = function RadialSelected(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'RadialSelected' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,13 C12.5522847,13 13,12.5522847 13,12 C13,11.4477153 12.5522847,11 12,11 C11.4477153,11 11,11.4477153 11,12 C11,12.5522847 11.4477153,13 12,13 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z M12,17 C14.7614237,17 17,14.7614237 17,12 C17,9.23857625 14.7614237,7 12,7 C9.23857625,7 7,9.23857625 7,12 C7,14.7614237 9.23857625,17 12,17 Z' })
  );
};

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Radial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Radial = function Radial(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Radial' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: '12', cy: '12', r: '11', fill: 'none', stroke: '#000', strokeWidth: '2' })
  );
};

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Raspberry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Raspberry = function Raspberry(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Raspberry' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#C7053D', fillRule: 'evenodd', d: 'M8.08672829,0.000264753559 C7.96534395,0.00402127507 7.836217,0.0481047507 7.68796657,0.165057787 C7.32481529,0.0250230129 6.97132662,-0.0244169841 6.65646751,0.260682129 C6.17026232,0.197621263 6.01323276,0.328417777 5.89352494,0.480410812 C5.78679799,0.478115159 5.09388673,0.371256036 4.77657197,0.844591729 C3.97915982,0.750226517 3.7280781,1.31407319 4.01363634,1.83946446 C3.85077722,2.09159662 3.68159462,2.33945747 4.06246416,2.82009742 C3.9277233,3.08780523 4.01160503,3.37809391 4.32898241,3.72952345 C4.24521198,4.10585734 4.41005371,4.37099819 4.70536499,4.57791992 C4.65013021,5.09291119 5.1765302,5.39291118 5.3340328,5.4995616 C5.3945128,5.79964506 5.52094757,6.08354835 6.12342406,6.24011878 C6.22279101,6.6872631 6.58455099,6.76475179 6.93518749,6.85861613 C5.77626582,7.53228566 4.78203284,8.41722473 4.78878066,10.5919375 L4.61991804,10.8950888 C3.29104858,11.703207 2.09522952,14.3014816 3.96480852,16.4126885 C4.08692329,17.0735093 4.29107632,17.5474988 4.47343457,18.072856 C4.74617195,20.1897463 6.52675621,21.1823654 6.99623096,21.2995897 C7.68421005,21.8236175 8.41761523,22.3205844 9.40915603,22.668814 C10.3438551,23.6328278 11.3552638,23.9999583 12.4141375,24 C13.4730105,24.0000348 14.4844191,23.6328278 15.4191182,22.668814 C16.410659,22.3205844 17.1440781,21.8236175 17.8320432,21.2995897 C18.301518,21.1823654 20.0821022,20.1897463 20.3548396,18.072856 C20.5371909,17.5474988 20.741337,17.0735093 20.8634726,16.4126885 C22.7330377,14.3014816 21.5372187,11.703207 20.2083492,10.8950888 L20.0394935,10.5919375 C20.0462414,8.41722473 19.0520014,7.53228566 17.8930867,6.85861613 C18.2437093,6.76475179 18.6054832,6.6872631 18.7048571,6.24011878 C19.3073266,6.08354835 19.4337614,5.79964506 19.4942414,5.4995616 C19.651744,5.39291118 20.1781509,5.09291119 20.1229092,4.57791992 C20.4182135,4.37099819 20.5830553,4.10585734 20.4992918,3.72952345 C20.8166692,3.37809391 20.9005509,3.08780523 20.765817,2.82009742 C21.1466865,2.33945747 20.9775039,2.09159662 20.8146448,1.83946446 C21.1001891,1.31407319 20.8491213,0.750226517 20.0516953,0.844591729 C19.7343944,0.371256036 19.0414832,0.478129073 18.9347562,0.480410812 C18.8150414,0.328417777 18.6580189,0.197621263 18.1718067,0.260682129 C17.8569406,-0.0244169841 17.5034589,0.0250230129 17.1403076,0.165057787 C16.9920572,0.0481047507 16.8629164,0.00404214463 16.7415459,0.000264753559 C16.5099007,-0.00692133296 16.312572,0.133996919 16.0986381,0.201683872 C15.5762243,0.0310751865 15.4578869,0.26317952 15.2014208,0.358337775 C14.6320504,0.237996913 14.45948,0.500981245 14.186193,0.777454341 L13.8667774,0.771332603 C13.0081548,1.27731493 12.5837723,2.30648356 12.4141375,2.30648356 C12.244502,2.30648356 11.8201194,1.27731493 10.9614968,0.771332603 L10.6420812,0.777454341 C10.3687873,0.500981245 10.1962238,0.237996913 9.62685341,0.358337775 C9.37038734,0.26317952 9.25204996,0.0310751865 8.72963608,0.201683872 C8.51569522,0.133996919 8.31836654,-0.00692133296 8.08672829,0.000264753559 L8.08672829,0.000264753559 Z M8.11723959,0.608584717 C8.55334391,0.770163907 8.78002912,0.978497808 9.01650215,1.18435494 C9.09674562,1.07614653 9.21854039,0.995833459 9.06939258,0.734720431 C9.37908995,0.913196942 9.61296124,1.12368739 9.78554558,1.3593184 C9.97706557,1.2373358 9.89847774,1.07156913 9.89947948,0.917836942 C10.2213229,1.17960363 10.4266934,1.45753057 10.676662,1.72960012 C10.7270273,1.6928836 10.7699838,1.56820187 10.8089055,1.3715271 C11.5766551,2.11633401 12.661247,3.99280691 11.0876325,4.73661208 C9.74914906,3.63272346 8.15102046,2.83019829 6.37977187,2.2280627 C8.65689869,3.40221217 9.98173339,4.35076863 10.7071873,5.15979119 C10.3355282,6.64922484 8.39685001,6.7193257 7.68796657,6.67753788 C7.83314917,6.60997615 7.95432482,6.52719354 7.99721177,6.40288051 C7.81933352,6.27641095 7.18837008,6.38981616 6.74801533,6.14246313 C6.91716314,6.10741618 6.99650922,6.0740527 7.07557009,5.94918245 C6.65961881,5.81650767 6.21198753,5.70103637 5.94845364,5.48123813 C6.09067971,5.48297726 6.22252666,5.51436508 6.40825882,5.3856277 C6.03566059,5.1847651 5.63886757,5.02516859 5.32996324,4.71830252 C5.52261714,4.71357209 5.72937191,4.7159373 5.78976843,4.64506426 C5.44871801,4.43378776 5.16123977,4.19811473 4.92306239,3.941113 C5.19265542,3.97365561 5.30546933,3.94744344 5.37065193,3.90041735 C5.11287803,3.63638259 4.78767457,3.41396173 4.63212674,3.08865392 C4.8322937,3.15760001 5.01483282,3.18202435 5.14686064,3.08051479 C5.05925021,2.88290785 4.68341021,2.76718612 4.46732675,2.30536356 C4.67805369,2.32579487 4.90277718,2.35134617 4.94747283,2.30536356 C4.84966414,1.90687315 4.68279804,1.68304708 4.51819283,1.45086622 C4.96919109,1.44418796 5.65184844,1.45239666 5.62089887,1.41425405 L5.34217193,1.12942652 C5.7827006,1.01081085 6.23361536,1.14928711 6.56084316,1.25149232 C6.70777881,1.1355413 6.55701708,0.988174329 6.37774057,0.838483903 C6.75211967,0.888466509 7.09125704,0.974170851 7.39702398,1.09279348 C7.5604118,0.945287375 7.28933008,0.798831731 7.15898574,0.651304714 C7.73737874,0.76107869 7.98362569,0.914003898 8.22711089,1.06838305 C8.40385523,0.899019551 8.23647437,0.756063038 8.11723959,0.608584717 L8.11723959,0.608584717 Z M16.7110277,0.608584717 C16.5917929,0.756063038 16.4244259,0.899019551 16.6011633,1.06838305 C16.8446485,0.914003898 17.0908955,0.76107869 17.6692815,0.651304714 C17.5389511,0.798831731 17.2678624,0.945287375 17.4312433,1.09279348 C17.7370172,0.974170851 18.0761476,0.888466509 18.4505336,0.838483903 C18.271271,0.988174329 18.1204954,1.1355413 18.267438,1.25149232 C18.5946658,1.14928711 19.0455736,1.01081085 19.4861092,1.12942652 L19.2073753,1.41425405 C19.1764258,1.45236188 19.8590762,1.44422275 20.3100883,1.45086622 C20.1454692,1.68304708 19.9786101,1.90687315 19.8808014,2.30536356 C19.925497,2.35134617 20.1502205,2.32579487 20.3609474,2.30536356 C20.144864,2.76718612 19.769024,2.88290785 19.6814205,3.08051479 C19.8134414,3.18202435 19.9959805,3.15760001 20.1961544,3.08865392 C20.0405927,3.41396173 19.7154031,3.63638259 19.4576223,3.90041735 C19.5228049,3.94743648 19.6356188,3.97365561 19.9052118,3.941113 C19.6670414,4.19811473 19.3795562,4.43378776 19.0385127,4.64506426 C19.0989023,4.71589556 19.305664,4.71355122 19.498311,4.71830252 C19.1894136,5.02516859 18.7926206,5.1847651 18.4200223,5.3856277 C18.6057545,5.51436508 18.7376015,5.48299813 18.8798206,5.48123813 C18.6162867,5.70103637 18.1686554,5.81650767 17.7527041,5.94918245 C17.831765,6.0740527 17.911118,6.10741618 18.0802589,6.14246313 C17.6399041,6.38981616 17.0089337,6.27641095 16.8310624,6.40288051 C16.8739494,6.52719354 16.995125,6.60997615 17.1403076,6.67753788 C16.4314312,6.7193257 14.4927461,6.64922484 14.121087,5.15979119 C14.8465339,4.35076863 16.1713755,3.40221217 18.4485023,2.2280627 C16.6772538,2.83019829 15.0791182,3.63272346 13.7406418,4.73661208 C12.1670203,3.99280691 13.2516053,2.11633401 14.0193687,1.3715271 C14.0582835,1.56820187 14.101247,1.6928836 14.1516122,1.72960012 C14.4015878,1.45753057 14.6069513,1.17960363 14.9287947,0.917836942 C14.9297686,1.07156913 14.8512017,1.2373358 15.0427286,1.3593184 C15.2153199,1.12368739 15.4491843,0.913196942 15.7588816,0.734720431 C15.6097269,0.995833459 15.7315216,1.07614653 15.8117721,1.18435494 C16.0482451,0.978497808 16.2749233,0.770163907 16.7110277,0.608584717 L16.7110277,0.608584717 Z M12.4141375,6.77007353 C13.7727322,6.77007353 14.9056504,7.69321086 14.9084539,8.23597257 C14.9120017,8.91685587 13.9141096,9.61605583 12.4324471,9.63369061 C12.4262557,9.63371843 12.4203218,9.63366278 12.4141375,9.63369061 C12.4079462,9.63366278 12.4019907,9.63371843 12.3958272,9.63369061 C10.9141577,9.61605583 9.91632122,8.91685587 9.91982035,8.23597257 C9.92267253,7.69321086 11.0555421,6.77007353 12.4141375,6.77007353 L12.4141375,6.77007353 Z M8.60146217,7.21668915 C8.62928826,7.2159935 8.65689869,7.2159935 8.68487086,7.21668915 C8.90498911,7.2178022 9.13188996,7.23677263 9.36236647,7.27568741 C10.1386029,7.40612218 5.64137887,11.3335235 5.57207105,10.4576627 C5.51003975,8.4547969 6.85024141,7.24467524 8.60146217,7.21668915 L8.60146217,7.21668915 Z M16.1434033,7.21668915 C16.1713755,7.2159935 16.198986,7.2159935 16.226812,7.21668915 C17.9780328,7.24467524 19.3182414,8.4547969 19.2562032,10.4576627 C19.1868953,11.3335235 14.6896643,7.40612218 15.4659077,7.27568741 C15.6963773,7.23677263 15.9232851,7.21785785 16.1434033,7.21668915 L16.1434033,7.21668915 Z M9.31760821,9.71710625 C9.57666211,9.71515843 9.83913166,9.75334277 10.0947908,9.83917233 C11.4583247,10.2968767 12.1474377,11.8915618 11.6349229,13.3995756 C11.1223943,14.9075685 9.60082211,15.7595407 8.23728132,15.3018364 C6.87374054,14.8441251 6.18464145,13.24944 6.6971562,11.74144 C7.11358052,10.5161879 8.19509698,9.72545408 9.31760821,9.71710625 L9.31760821,9.71710625 Z M15.510666,9.71710625 C16.6331842,9.72545408 17.7146937,10.5161879 18.131125,11.74144 C18.6436328,13.24944 17.9545337,14.8441251 16.5909929,15.3018364 C15.2274591,15.7595407 13.70588,14.9075685 13.1933514,13.3995756 C12.6808366,11.8915618 13.3699496,10.2968767 14.7334834,9.83917233 C14.9891426,9.75334277 15.2516191,9.71521408 15.510666,9.71710625 L15.510666,9.71710625 Z M5.32996324,11.3996453 C6.39246752,11.4152557 5.60278409,16.4517006 4.64025891,16.0240902 C3.54755637,15.145252 3.19627293,12.5727583 5.22213716,11.4159235 C5.25074933,11.4082505 5.27710759,11.4032627 5.30351454,11.4016835 C5.31211976,11.4009879 5.32159454,11.399527 5.32996324,11.3996662 L5.32996324,11.3996453 Z M19.498311,11.3996453 C19.5066797,11.3996453 19.5161475,11.4010366 19.5247597,11.4016627 C19.5511736,11.4031931 19.5775318,11.4082714 19.6061371,11.4159166 C21.6319943,12.5727443 21.2807039,15.1452381 20.1880153,16.0240833 C19.2254832,16.4516867 18.4358067,11.4152418 19.498311,11.3996383 L19.498311,11.3996453 Z M12.4141298,14.8822955 C13.1302557,14.8822955 13.8011496,15.1418364 14.2879252,15.5826085 C14.80716,16.0527511 15.1097686,16.7222954 15.1057965,17.3933145 C15.1057965,18.0521743 14.8114591,18.7056142 14.3062348,19.1714925 C13.8097478,19.6292942 13.1160435,19.9007933 12.4141375,19.9100176 C11.7122238,19.9007933 11.0185333,19.6292942 10.5220394,19.1714925 C10.0168151,18.7056142 9.72247776,18.0521743 9.72247776,17.3933145 C9.71851254,16.7222954 10.0211073,16.0527511 10.540349,15.5826085 C11.0271177,15.1418364 11.6980047,14.8822955 12.4141298,14.8822955 L12.4141298,14.8822955 Z M6.14784145,16.1990606 C6.8512988,16.184598 7.71643962,16.739951 8.41631436,17.5520136 C9.19689866,18.4924177 9.55193863,20.1452246 8.90053694,20.6322576 C8.28421002,21.0040767 6.78638054,20.8502124 5.72262408,19.3220385 C5.00519108,18.0397082 5.09887456,16.734998 5.60258931,16.351645 C5.76736147,16.251318 5.9508745,16.2030676 6.14784145,16.1990606 L6.14784145,16.1990606 Z M18.6132954,16.1990606 C18.635591,16.198365 18.6584502,16.198365 18.6804397,16.1990606 C18.8774067,16.2030259 19.0609127,16.251318 19.2256919,16.351645 C19.7294066,16.734998 19.8230831,18.0397082 19.1056571,19.3220385 C18.0418798,20.8502124 16.5440503,21.0040767 15.9277373,20.6322576 C15.2763356,20.1452246 15.6313547,18.4924177 16.4119599,17.5520136 C17.0899563,16.7653284 17.9223389,16.2192554 18.6132954,16.1990606 L18.6132954,16.1990606 Z M12.4141375,20.7034715 C13.5040226,20.691068 15.1237165,21.1498297 15.1037652,21.7349775 C15.1211634,22.1401114 13.7921409,23.3091896 12.4365097,23.2506853 C12.4290036,23.2506853 12.4216366,23.2506296 12.4141375,23.2506853 C12.4066307,23.2506296 12.3992568,23.2506853 12.3917646,23.2506853 C11.0361264,23.3091896 9.70711776,22.1401114 9.72450906,21.7349775 C9.70455776,21.1498297 11.3242516,20.691068 12.4141375,20.7034715 L12.4141375,20.7034715 Z' })
  );
};

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Reactjs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Reactjs = function Reactjs(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Reactjs' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: '#00D8FF', fillRule: 'evenodd' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: '11.996', cy: '11.653', r: '2.142' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fillRule: 'nonzero', d: 'M11.9957722,7.80914159 C14.763782,7.80914159 17.3932297,8.19939152 19.3922491,8.88758063 C21.6123871,9.6518808 22.9666335,10.7818833 22.9666335,11.652558 C22.9666335,12.5799965 21.5040812,13.7840336 19.1293161,14.5708627 C17.2387355,15.1972602 14.7092455,15.538679 11.9957722,15.538679 C9.14520032,15.538679 6.58717845,15.203913 4.71853163,14.565185 C3.54866968,14.1653247 2.58256656,13.6456709 1.92037292,13.0785821 C1.32532838,12.5689984 1.02491103,12.0630628 1.02491103,11.652558 C1.02491103,10.7789546 2.32734001,9.66464781 4.49959681,8.90729393 C6.49945246,8.21010004 9.19325759,7.80914159 11.9957722,7.80914159 L11.9957722,7.80914159 L11.9957722,7.80914159 L11.9957722,7.80914159 L11.9957722,7.80914159 M11.9957722,6.78423056 C9.08437994,6.78423056 6.2777499,7.20198239 4.1621939,7.93951199 C1.62214541,8.82509585 0,10.2129394 0,11.652558 C0,13.1394248 1.74140227,14.6307252 4.38703934,15.5350074 C6.37567236,16.2147483 9.04125041,16.56359 11.9957722,16.56359 C14.8115523,16.56359 17.4474553,16.2078081 19.4516644,15.5437626 C22.2020573,14.632477 23.9915445,13.1592927 23.9915445,11.652558 C23.9915445,10.2077356 22.3170688,8.81052922 19.7258695,7.91848823 C17.6128656,7.19105846 14.871718,6.78423056 11.9957722,6.78423056 L11.9957722,6.78423056 L11.9957722,6.78423056 L11.9957722,6.78423056 L11.9957722,6.78423056 M8.64782576,9.74318674 C10.0306294,7.34537922 11.6822995,5.26251432 13.2771145,3.87459857 C15.0483324,2.33318986 16.7037652,1.72455661 17.4580053,2.15950561 C18.2614273,2.62281187 18.5738182,4.49132292 18.0690455,6.94154209 C17.6671734,8.89223963 16.6992742,11.2540339 15.3437168,13.6046372 C13.9196524,16.0740185 12.3517605,18.1226845 10.8648902,19.4223695 C9.93407029,20.2360369 9.00127666,20.8133347 8.17921011,21.1036655 C7.44050831,21.3645543 6.85214323,21.3720417 6.49651234,21.1669615 C5.73974814,20.7305244 5.42512511,19.045619 5.85426462,16.7855049 C6.24932455,14.7048419 7.24772098,12.1710157 8.64782671,9.74318508 L8.64782576,9.74318674 L8.64782576,9.74318674 L8.64782576,9.74318674 L8.64782576,9.74318674 M7.759974,9.23116928 C6.30547459,11.7533204 5.26525979,14.3932772 4.84734364,16.5943171 C4.34554839,19.2370813 4.73740525,21.3355983 5.98449631,22.0548141 C7.2725788,22.7976074 9.43439148,22.0341158 11.5394159,20.1940284 C13.121755,18.8108935 14.7555742,16.6760844 16.2315707,14.1166508 C17.6382359,11.6774242 18.6468519,9.21627599 19.0728759,7.1483441 C19.6574939,4.31054745 19.2752706,2.02434609 17.9700071,1.27164481 C16.7184046,0.549880923 14.6715337,1.30242953 12.6042836,3.1014613 C10.9185312,4.56851694 9.19669947,6.73986025 7.75997496,9.23116762 L7.759974,9.23116928 L7.759974,9.23116928 L7.759974,9.23116928 L7.759974,9.23116928 M8.65102932,13.6102163 C7.26423584,11.2147037 6.28457878,8.74353725 5.87862056,6.66870559 C5.42774955,4.36439699 5.72720706,2.6262057 6.48072727,2.18999639 C7.28337846,1.72531755 9.05821175,2.38783711 10.9288592,4.04883669 C12.4181905,5.37119379 13.9809502,7.38921897 15.3404734,9.7376059 C16.7686644,12.2045881 17.7605533,14.5861039 18.1440168,16.5233658 C18.384086,17.7361541 18.4183857,18.8326057 18.2593637,19.6898062 C18.1164684,20.4600771 17.8291151,20.9735449 17.473831,21.1792215 C16.7177635,21.6169189 15.1008664,21.0480332 13.3571194,19.5474962 C11.7518336,18.1661133 10.0552117,16.0356933 8.65102599,13.6102105 L8.65102932,13.6102163 L8.65102932,13.6102163 L8.65102932,13.6102163 L8.65102932,13.6102163 M7.76403451,14.1237168 C9.2227685,16.6434222 10.9904487,18.863069 12.6886037,20.3243677 C14.727583,22.0789594 16.7414064,22.7874988 17.9873239,22.0662207 C19.2741476,21.3212689 19.6923336,19.0670565 19.1494202,16.3243517 C18.741335,14.2627011 17.7077401,11.7810493 16.2274688,9.22410641 C14.8166895,6.78718171 13.1881856,4.68425955 11.6093526,3.2824351 C9.4428116,1.3587035 7.27122101,0.548080175 5.96723274,1.30299809 C4.71682218,2.02685487 4.34655386,4.17606524 4.87278214,6.8655093 C5.30188762,9.05864543 6.32316039,11.6347867 7.76403118,14.1237111 L7.76403451,14.1237168 L7.76403451,14.1237168 L7.76403451,14.1237168 L7.76403451,14.1237168' })
    )
  );
};

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Reddit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Reddit = function Reddit(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Reddit' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#FF4500', fillRule: 'evenodd', d: 'M15.57,15.284 C14.673,15.284 13.91925,14.5565 13.91925,13.6595 C13.91925,12.7625 14.673,12.011 15.57,12.011 C16.467,12.011 17.1945,12.7625 17.1945,13.6595 C17.1945,14.5565 16.467,15.284 15.57,15.284 M15.951,18.437 C15.1155,19.27175 13.827,19.6775 12.012,19.6775 C12.00825,19.6775 12.00375,19.67675 11.99925,19.67675 C11.9955,19.67675 11.991,19.6775 11.9865,19.6775 C10.1715,19.6775 8.88375,19.27175 8.049,18.437 C7.7925,18.1805 7.7925,17.76575 8.049,17.51 C8.30475,17.25425 8.7195,17.25425 8.976,17.51 C9.552,18.086 10.53675,18.3665 11.9865,18.3665 C11.991,18.3665 11.9955,18.36725 11.99925,18.36725 C12.00375,18.36725 12.00825,18.3665 12.012,18.3665 C13.46175,18.3665 14.44725,18.086 15.024,17.51 C15.2805,17.2535 15.69525,17.25425 15.951,17.51 C16.20675,17.7665 16.20675,18.18125 15.951,18.437 M6.8055,13.6595 C6.8055,12.76325 7.55775,12.011 8.454,12.011 C9.351,12.011 10.0785,12.76325 10.0785,13.6595 C10.0785,14.5565 9.351,15.284 8.454,15.284 C7.55775,15.284 6.8055,14.5565 6.8055,13.6595 M19.998,3.311 C20.6055,3.311 21.09975,3.80525 21.09975,4.412 C21.09975,5.0195 20.6055,5.51375 19.998,5.51375 C19.3905,5.51375 18.89625,5.0195 18.89625,4.412 C18.89625,3.80525 19.3905,3.311 19.998,3.311 M24,11.87525 C24,10.2845 22.70625,8.99075 21.1155,8.99075 C20.427,8.99075 19.79475,9.23375 19.29825,9.638 C17.5395,8.5325 15.3075,7.8665 12.915,7.7255 L14.163,3.77975 L17.59275,4.5875 C17.68275,5.83625 18.72675,6.82475 19.998,6.82475 C21.32775,6.82475 22.41,5.7425 22.41,4.412 C22.41,3.08225 21.32775,2 19.998,2 C19.068,2 18.2595,2.5295 17.85675,3.30275 L13.87125,2.3645 C13.5375,2.28575 13.2,2.47775 13.0965,2.80475 L11.547,7.70225 C8.96925,7.76525 6.546,8.4335 4.65825,9.6035 C4.1685,9.22025 3.55275,8.99075 2.8845,8.99075 C1.29375,8.99075 0,10.2845 0,11.87525 C0,12.8585 0.495,13.72775 1.24875,14.24825 C1.21725,14.477 1.20075,14.70725 1.20075,14.9405 C1.20075,16.92875 2.3565,18.77825 4.455,20.14775 C6.4665,21.461 9.129,22.184 11.95125,22.184 C14.7735,22.184 17.436,21.461 19.4475,20.14775 C21.546,18.77825 22.70175,16.92875 22.70175,14.9405 C22.70175,14.72825 22.6875,14.5175 22.66125,14.30825 C23.46525,13.796 24,12.89675 24,11.87525' })
  );
};

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Redhat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Redhat = function Redhat(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Redhat' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#C00', fillRule: 'evenodd', d: 'M11.7749354,5.3508728 C11.7943796,5.51309589 11.7270763,5.6666771 11.0665362,5.71444227 C9.68031311,5.81471624 9.53636008,5.96454012 9.27658708,6.24089237 C8.91085714,6.63062231 8.42850881,5.7348728 8.42850881,5.7348728 C8.1389589,5.67414481 7.78807045,5.20753033 7.97772211,4.77177299 C8.16394521,4.3406184 8.50839922,4.47010568 8.61637573,4.60428963 C8.74774168,4.76773386 9.02799217,5.03478669 9.39156164,5.02515851 C9.75555382,5.0152955 10.1752485,4.93911546 10.760501,4.93911546 C11.3535969,4.93916243 11.7526262,5.16065753 11.7749354,5.3508728 L11.7749354,5.3508728 Z M14.6175499,17.4133855 C14.6064188,17.4133855 14.5968845,17.4176595 14.5898395,17.4255029 C14.4339569,17.6051507 14.3667476,17.6653151 14.2548258,17.7555382 C13.9841096,17.9729472 13.6747397,17.7274051 13.4769159,17.6108337 C13.0358513,17.3524227 12.6812055,17.5149276 12.5952564,17.7160861 C12.5087436,17.9172446 12.6040861,18.1594521 12.8443209,18.1281722 C13.1800391,18.0848219 13.1946928,18.1365793 13.4382622,18.2906771 C13.8906458,18.5777847 14.220681,18.4215264 14.3894325,18.2863562 C14.5300509,18.1746693 14.6083914,18.0783405 14.6812368,17.9422309 C14.8113346,17.685182 14.704908,17.4828963 14.6431468,17.4223562 C14.6367593,17.4168611 14.627319,17.4133855 14.6175499,17.4133855 L14.6175499,17.4133855 Z M14.0982387,3.03156164 C14.075225,3.03118591 14.0523523,3.03085714 14.0297143,3.03085714 C13.9004149,3.03212524 13.7658552,3.03926419 13.6279139,3.05340117 C13.1690959,3.10027397 12.7681409,3.21280626 12.4992094,3.35497456 C12.4863405,3.3608454 12.4777456,3.37352642 12.4777456,3.38799217 C12.4777456,3.4077182 12.4949354,3.42472016 12.5165871,3.42472016 C12.5183718,3.42472016 12.5204853,3.42443836 12.5226458,3.42410959 C12.5996243,3.41199217 12.679092,3.40156556 12.7605323,3.39325245 C13.5046732,3.31866928 14.1321957,3.44228571 14.1626771,3.66922896 C14.1851272,3.8407045 13.8616673,4.02237182 13.3815734,4.13335421 C13.3573386,4.13922505 13.339773,4.15956164 13.339773,4.18356164 C13.339773,4.20770254 13.3573386,4.22827397 13.380775,4.23414481 C13.5823562,4.29243053 13.8157808,4.32826614 14.0647515,4.33413699 C14.8343014,4.35132681 15.4649706,4.07380039 15.4739413,3.71422309 C15.4831937,3.35441096 14.8674129,3.04875147 14.0982387,3.03156164 L14.0982387,3.03156164 Z M22.0745988,18.5231155 L22.0745988,18.5227397 C21.6121174,18.416454 21.1215029,18.3493386 20.6250176,18.3493386 C19.7764227,18.3493386 19.0042896,18.4965793 18.4342074,18.7337143 C18.3715068,18.7645714 18.3269824,18.8306067 18.3269824,18.9051898 C18.3269824,18.9051898 18.3269824,18.9051898 18.3269824,18.9055656 C18.3269824,18.9323366 18.3340274,18.9602818 18.3445949,18.9832955 C18.3528141,19.0075303 18.358638,19.0321409 18.3609863,19.0571272 C18.3770489,19.2297769 18.2316869,19.4051507 17.7496673,19.5110137 C16.9324932,19.6908963 16.4164227,20.5340431 16.1211429,20.8137299 C15.7959452,21.1223014 14.9168219,21.3197965 14.9277652,21.18209 C14.9285636,21.1731663 14.9332603,21.1621761 14.9424658,21.1500587 C15.0576751,20.9965245 15.4985049,20.5180274 15.7666849,20.0002661 C16.0063562,19.5379726 16.219773,19.4067006 16.5137378,18.9657299 C16.6002975,18.8360078 16.9346536,18.3815577 17.0321096,18.0219804 C17.1410724,17.6707632 17.1041566,17.230544 17.1461918,17.0492994 C17.2063092,16.7877886 17.4532133,16.2200078 17.4717652,15.8998826 L17.4717652,15.8996947 L17.4717652,15.8988963 C17.4825205,15.7179804 16.7153659,16.157683 16.3512798,16.157683 C15.986818,16.157683 15.6319843,15.9398982 15.3069746,15.9242583 C14.9042348,15.9051429 14.6454481,16.2344266 14.281362,16.177409 C14.0731585,16.1438278 13.8981605,15.9602348 13.5343092,15.9467554 C13.0169237,15.9281566 12.3845166,16.2344266 11.1964462,16.1961957 C10.0276791,16.1582935 8.94838356,14.7196556 8.80095499,14.4908806 C8.62858708,14.2225127 8.41765949,14.2225127 8.18785127,14.4332524 C7.95780822,14.6438043 7.67469276,14.4785753 7.59362818,14.3369706 C7.44061057,14.0691663 7.03082583,13.2850098 6.39588258,13.1203444 C5.57321331,12.9073033 5.13102153,13.5211585 5.12655969,14.066818 C5.12618395,14.103546 5.12792172,14.1394755 5.13144423,14.1750763 C5.19005871,14.7512642 5.56259883,14.9127358 5.73524853,15.2190059 C5.90742857,15.5254638 5.99591389,15.7235225 6.32031311,15.8594442 C6.49268102,15.9309276 6.58417221,16.0287593 6.59004305,16.1527984 C6.59201566,16.1942231 6.58436008,16.238137 6.56731115,16.2854325 C6.50756947,16.4494873 6.26818004,16.4872016 6.11098239,16.4948102 C5.77634442,16.5108258 5.54221526,16.4197573 5.37116243,16.3114051 C5.17225832,16.1840783 5.01059883,16.0084697 4.83696282,15.7090568 C4.63618004,15.3793503 4.32018787,15.2350215 3.95159295,15.2350215 C3.77579648,15.2350215 3.61174168,15.2821292 3.46586301,15.3567123 C2.88859491,15.65791 2.20118982,15.8356321 1.4610411,15.8356321 L0.626864971,15.8360078 C0.626864971,15.8360078 0.626864971,15.8364305 0.626958904,15.8364305 L0.626864971,15.8364305 C0.220227006,14.6317339 0,13.3418865 0,12.0004697 C0,5.3727593 5.3730411,0 12.0002818,0 C18.6279452,0 24,5.3727593 24,12.0004697 C24,14.4051663 23.2929628,16.6450098 22.0745988,18.5231155 L22.0745988,18.5231155 Z M18.7718982,8.80762427 C18.6534951,9.20604305 18.4847906,9.71614873 17.7344031,10.1012759 C17.6253933,10.1568376 17.583593,10.0652524 17.634364,9.97920939 C17.9173855,9.49690802 17.9680157,9.37629746 18.0503953,9.18575342 C18.1656047,8.90785127 18.2261448,8.51225049 17.9964775,7.68695108 C17.545362,6.06270059 16.6035382,3.89189824 15.9195147,3.18791389 C15.2590215,2.50821135 14.0624971,2.31672798 12.9808532,2.5942544 C12.5828102,2.69659491 11.8032094,3.10187084 10.358137,2.77620352 C7.85687671,2.21269667 7.4861683,3.46544031 7.34277886,4.0109589 C7.19934247,4.55685323 6.85451272,6.10736595 6.85451272,6.10736595 C6.73986693,6.73869276 6.58938552,7.83715068 10.4728767,8.57668885 C12.2822231,8.92142466 12.3744188,9.38897847 12.4543092,9.72540117 C12.5980744,10.3283131 12.827319,10.6730489 13.0859178,10.8454168 C13.3445166,11.0179256 13.0859178,11.1606575 12.799045,11.1899648 C12.0287436,11.2698552 9.18068102,10.4531507 7.49598434,9.49592172 C6.1174638,8.65343249 6.09435616,7.8948728 6.40987867,7.25119374 C4.32765558,7.02608219 2.76535421,7.44671624 2.48195695,8.43231311 C1.99561644,10.1241018 6.20139335,13.0134012 10.9900274,14.4634051 C16.0156086,15.9850333 21.1837808,14.9227397 21.758184,11.76418 C22.0195068,10.3289237 20.8105362,9.2673816 18.7718982,8.80762427 L18.7718982,8.80762427 Z' })
  );
};

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Redo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Redo = function Redo(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Redo' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M16.82,4,15.4,5.44,17.94,8H8.23a6,6,0,0,0,0,12h2V18h-2a4,4,0,0,1,0-8h9.71L15.4,12.51l1.41,1.41L21.77,9Z' })
  );
};

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Refresh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Refresh = function Refresh(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Refresh' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M20,8 C18.5974037,5.04031171 15.536972,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 L12,21 C16.9705627,21 21,16.9705627 21,12 M21,3 L21,9 L15,9' })
  );
};

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Resources */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Resources = function Resources(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Resources' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,3 L21,7.5 L12,12 L3,7.5 L12,3 Z M16.5,10.25 L21,12.5 L12,17 L3,12.5 L7.5,10.25 L7.5,10.25 M16.5,15.25 L21,17.5 L12,22 L3,17.5 L7.5,15.25 L7.5,15.25' })
  );
};

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Restaurant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Restaurant = function Restaurant(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Restaurant' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M19,18 L5,18 L19,18 Z M12,18 L12,12 L12,18 Z M15,18 L15,14 L15,18 Z M9,18 L9,14 L9,18 Z M19,22 L19,11.3292943 C20.1651924,10.9174579 21,9.80621883 21,8.5 C21,6.84314575 19.6568542,5.5 18,5.5 C17.6192862,5.5 17.2551359,5.57091725 16.9200387,5.7002623 C16.5495238,3.87433936 14.4600194,2 12,2 C9.53998063,2 7.45047616,3.87433936 7.07996126,5.7002623 C6.74486408,5.57091725 6.38071384,5.5 6,5.5 C4.34314575,5.5 3,6.84314575 3,8.5 C3,9.80621883 3.83480763,10.9174579 5,11.3292943 L5,22 L19,22 Z' })
  );
};

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RestroomMen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var RestroomMen = function RestroomMen(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'RestroomMen' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M7,13.5 L11,8 L10,21 M17,13.5 L13,8 L14,21 M12,5 C12.5522847,5 13,4.55228475 13,4 C13,3.44771525 12.5522847,3 12,3 C11.4477153,3 11,3.44771525 11,4 C11,4.55228475 11.4477153,5 12,5 Z M11,8 L13,8 L13,13.5 L11,13.5 L11,8 Z' })
  );
};

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RestroomWomen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var RestroomWomen = function RestroomWomen(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'RestroomWomen' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M7,13.5 L11,8 L12,21 M17,13.5 L13,8 L12,21 M12,5 C12.5522847,5 13,4.55228475 13,4 C13,3.44771525 12.5522847,3 12,3 C11.4477153,3 11,3.44771525 11,4 C11,4.55228475 11.4477153,5 12,5 Z M11,8 L13,8 L14.5,16.5 L9.5,16.5 L11,8 Z' })
  );
};

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Restroom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Restroom = function Restroom(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Restroom' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeWidth: '2', d: 'M6,11 L18,11 M6,3 L18,3 M12,16 C14.7614237,16 17,13.7614237 17,11 C17,11 7,11 7,11 C7,13.7614237 9.23857625,16 12,16 Z M7,3 L17,3 L17,11 L7,11 L7,3 Z M7,6 L9.5,6 M14.5,15.5 L16,21.5 L8,21.5 L9.5,15.5' })
  );
};

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Resume */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Resume = function Resume(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Resume' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,20 L6,20 L6,4 L1,4 L1,20 Z M11,19.0000002 L22,12 L11,5 L11,19.0000002 Z' })
  );
};

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Return */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Return = function Return(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Return' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M9,4 L4,9 L9,14 M18,19 L18,9 L5,9', transform: 'matrix(1 0 0 -1 0 23)' })
  );
};

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Revert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Revert = function Revert(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Revert' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,3 L3,8 L8,13 M12,20 L15,20 C18.3137085,20 21,17.3137085 21,14 C21,10.6862915 18.3137085,8 15,8 L4,8' })
  );
};

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Rewind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Rewind = function Rewind(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Rewind' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '22 3.5 22 20 13 14 13 20 2 12 13 4 13 10' })
  );
};

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Risk */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Risk = function Risk(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Risk' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M14,10 L15,10 L15,9 L14,9 L14,10 Z M18,10 L19,10 L19,9 L18,9 L18,10 Z M18,6 L19,6 L19,5 L18,5 L18,6 Z M14,6 L15,6 L15,5 L14,5 L14,6 Z M9,19 L10,19 L10,18 L9,18 L9,19 Z M5,15 L6,15 L6,14 L5,14 L5,15 Z M10,10 L1,10 L1,23 L14,23 L14,14 M10,14 L23,14 L23,1 L10,1 L10,14 Z' })
  );
};

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Robot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Robot = function Robot(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Robot' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M18.3482396,15.9535197 C18.7664592,15.0561341 19,14.0553403 19,13 C19,9.13400675 15.8659932,6 12,6 C8.13400675,6 5,9.13400675 5,13 C5,14.1167756 5.2615228,15.1724692 5.72666673,16.1091793 L5.72666673,16.1091793 M12,3 C12.5522847,3 13,2.55228475 13,2 C13,1.44771525 12.5522847,1 12,1 C11.4477153,1 11,1.44771525 11,2 C11,2.55228475 11.4477153,3 12,3 Z M12,23 C12.5522847,23 13,22.5522847 13,22 C13,21.4477153 12.5522847,21 12,21 C11.4477153,21 11,21.4477153 11,22 C11,22.5522847 11.4477153,23 12,23 Z M12,6 L12,3 M9,14 C9.55228475,14 10,13.5522847 10,13 C10,12.4477153 9.55228475,12 9,12 C8.44771525,12 8,12.4477153 8,13 C8,13.5522847 8.44771525,14 9,14 Z M15,14 C15.5522847,14 16,13.5522847 16,13 C16,12.4477153 15.5522847,12 15,12 C14.4477153,12 14,12.4477153 14,13 C14,13.5522847 14.4477153,14 15,14 Z M6,18.9876876 L5,16 C5,16 5.07242747,15.2283988 5.5,15.5 C6.43069361,16.0911921 8.57396448,17 12,17 C15.5536669,17 17.6181635,16.0844828 18.5,15.5 C18.8589052,15.262117 19,16 19,16 L18,18.9876876 C18,18.9876876 17.0049249,20.9999997 12,21 C6.99507512,21.0000003 6,18.9876876 6,18.9876876 Z' })
  );
};

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RotateLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var RotateLeft = function RotateLeft(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'RotateLeft' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M11.52,3.43A9.09,9.09,0,0,0,5.7,5.55V2.35H4.07v6.5h6.5V7.21H6.3a7.46,7.46,0,1,1-1.47,8.65l-1.46.73A9.11,9.11,0,1,0,11.52,3.43Z' })
  );
};

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RotateRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var RotateRight = function RotateRight(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'RotateRight' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M12.48,3.43A9.09,9.09,0,0,1,18.3,5.55V2.35h1.64v6.5h-6.5V7.21H17.7a7.46,7.46,0,1,0,1.47,8.65l1.46.73A9.11,9.11,0,1,1,12.48,3.43Z' })
  );
};

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Rss */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Rss = function Rss(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Rss' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M22,21 C22,10.5065898 13.4934102,2 3,2 M17,21 C17,13.2680135 10.7319865,7 3,7 M12,21 C12,16.0294373 7.97056275,12 3,12 M4,23 C5.65685425,23 7,21.6568542 7,20 C7,18.3431458 5.65685425,17 4,17 C2.34314575,17 1,18.3431458 1,20 C1,21.6568542 2.34314575,23 4,23 Z' })
  );
};

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Run */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Run = function Run(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Run' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M15,11 L18,13 M18,5 C18.5522847,5 19,4.55228475 19,4 C19,3.44771525 18.5522847,3 18,3 C17.4477153,3 17,3.44771525 17,4 C17,4.55228475 17.4477153,5 18,5 Z M9.5,9.5 L9.52493781,6 L14.0249378,6 L15,6 L8,17 L4,17 M15,8 L12,13 L12.5,14 L17,7.5 L15,6 M11,13 L16,16.5 L16,21.5' })
  );
};

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SafariOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var SafariOption = function SafariOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'SafariOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#87C5F8', fillRule: 'evenodd', d: 'M12.5410065,11.8438452 C12.5626839,11.4304258 12.2112,11.0719742 11.7660387,11.0541677 C11.2961032,11.0348129 10.9392,11.3785548 10.9314581,11.8562323 C10.9244903,12.2789419 11.2682323,12.6141677 11.7219097,12.6281032 C12.1717161,12.6420387 12.5162323,12.3114581 12.5410065,11.8438452 M17.2140387,5.12152258 C17.1962323,5.1075871 17.1784258,5.09442581 17.1613935,5.08126452 C17.1079742,5.12616774 17.0522323,5.16874839 17.0019097,5.21674839 C15.0865548,7.0035871 13.1696516,8.78810323 11.2597161,10.5811355 C11.0398452,10.7886194 10.8277161,11.0208774 10.6721032,11.2771355 C9.2708129,13.5842323 7.88345806,15.8998452 6.49300645,18.2131355 C6.43649032,18.3068129 6.3908129,18.4074581 6.33971613,18.5050065 C6.42565161,18.5019097 6.47287742,18.4732645 6.51236129,18.4361032 C8.45171613,16.6237161 10.3949419,14.8152 12.3257806,12.9927484 C12.5773935,12.755071 12.7949419,12.4662968 12.975329,12.1690065 C14.3472,9.91300645 15.7066839,7.64771613 17.0684903,5.38552258 C17.1203613,5.2995871 17.1660387,5.20978065 17.2140387,5.12152258 M17.1443613,4.02836129 C19.1425548,5.42190968 20.3952,7.28461935 21.0339097,9.63507097 C20.8008774,9.69236129 20.5841032,9.72797419 20.3820387,9.80152258 C20.295329,9.83403871 20.2372645,9.94552258 20.1660387,10.0206194 C20.2604903,10.0624258 20.3588129,10.1452645 20.4486194,10.1375226 C20.6545548,10.1181677 20.8573935,10.0546839 21.1043613,9.99971613 C21.5533935,12.4066839 21.1717161,14.6286194 19.9206194,16.7290065 C19.7255226,16.6105548 19.5644903,16.4874581 19.3841032,16.4123613 C19.2648774,16.3620387 19.1177806,16.379071 18.983071,16.3666839 C19.0488774,16.4758452 19.0937806,16.6090065 19.1859097,16.6895226 C19.3337806,16.8188129 19.5126194,16.9140387 19.7185548,17.0502968 C18.3443613,19.0608774 16.5041032,20.3739097 14.1188129,21.011071 C14.0491355,20.7447484 13.9980387,20.4846194 13.9074581,20.2384258 C13.8741677,20.1478452 13.7495226,20.0905548 13.6659097,20.0177806 C13.6395871,20.1184258 13.5792,20.2237161 13.5923613,20.3181677 C13.6272,20.5604903 13.6945548,20.7981677 13.7611355,21.0915871 C11.3309419,21.5452645 9.07339355,21.1868129 6.92732903,19.9024258 C7.09145806,19.6461677 7.25636129,19.4185548 7.38487742,19.1715871 C7.43752258,19.0709419 7.40965161,18.9277161 7.41894194,18.8038452 C7.30590968,18.8642323 7.16036129,18.899071 7.0868129,18.9912 C6.92036129,19.1994581 6.78874839,19.4371355 6.61610323,19.7042323 C4.57842581,18.3075871 3.27545806,16.4293935 2.63442581,14.0247484 C2.94410323,13.9519742 3.20810323,13.9047484 3.45971613,13.8211355 C3.54487742,13.7932645 3.60061935,13.6748129 3.66952258,13.5973935 C3.56965161,13.5641032 3.46590968,13.4928774 3.37145806,13.5052645 C3.11829677,13.5377806 2.86900645,13.6051355 2.57403871,13.6686194 C2.12578065,11.2299097 2.51210323,8.97313548 3.82513548,6.84023226 C4.0148129,6.96023226 4.17894194,7.09029677 4.36474839,7.17390968 C4.50874839,7.23971613 4.67907097,7.24823226 4.83778065,7.28152258 C4.74178065,7.14216774 4.66590968,6.98113548 4.5435871,6.86965161 C4.3988129,6.7388129 4.21455484,6.65132903 4.01945806,6.52668387 C5.44397419,4.53545806 7.3035871,3.22552258 9.7268129,2.63249032 C9.78255484,2.87326452 9.81429677,3.1032 9.89249032,3.31532903 C9.93661935,3.43378065 10.0573935,3.5228129 10.143329,3.62578065 C10.1727484,3.50423226 10.2354581,3.3795871 10.2238452,3.26268387 C10.2013935,3.0435871 10.1363613,2.82913548 10.0782968,2.56513548 C12.4930065,2.14242581 14.7250065,2.53726452 16.8292645,3.82010323 C16.6798452,4.06165161 16.5265548,4.27997419 16.4088774,4.51532903 C16.367071,4.59739355 16.4119742,4.7228129 16.4173935,4.82810323 C16.5064258,4.78861935 16.6248774,4.77236129 16.679071,4.70500645 C16.8385548,4.50371613 16.9724903,4.28307097 17.1443613,4.02836129 M11.8450065,22.4201032 C17.7211355,22.4061677 22.431329,17.6595871 22.4220387,11.7610065 C22.4135226,5.98861935 17.639071,1.25442581 11.8333935,1.26216774 C5.9355871,1.26990968 1.24939355,6.00874839 1.26410323,11.9499097 C1.2788129,17.7021677 6.06100645,22.4340387 11.8450065,22.4201032 M11.8364903,0.000232258065 C18.3420387,-0.00673548387 23.6808774,5.30732903 23.6862968,11.7942968 C23.6917161,18.3532645 18.4217806,23.6502968 11.8604903,23.6828129 C5.32784516,23.7145548 0.000619354838,18.3780387 -0.00015483871,11.8012645 C-0.00015483871,5.30345806 5.3115871,0.0072 11.8364903,0.000232258065' })
  );
};

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Satellite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Satellite = function Satellite(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Satellite' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,17 C2.97059067,12.7941347 2.97059067,6.11763731 7,2 L22,17 C17.8823627,21.0294093 11.2058653,21.0294093 7,17 Z M7,17 C3.705,17 1,19.9491525 1,23 L13,23 C13,21.8610169 12.63,20.9661017 12,20 M15,9 L19,5 L15,9 Z M20.5,1 C19.119,1 18,2.119 18,3.5 C18,4.881 19.119,6 20.5,6 C21.881,6 23,4.881 23,3.5 C23,2.119 21.881,1 20.5,1 L20.5,1 Z' })
  );
};

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Save */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Save = function Save(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Save' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,2 L3,21 L21,21 L21,3 L12,3 L12,14 M8,11 L12,15 L16,11' })
  );
};

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Scan = function Scan(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Scan' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M20,14 L20,21 L4,21 L4,14 L4,14 M1,12 L23,12 L1,12 Z M4,11 L4,8 L4,11 Z M20,8 L20,11 L20,8 Z M7,3 L4,3 L4,6 M20,6 L20,3 L17,3 M9,3 L15,3 L9,3 Z', transform: 'matrix(1 0 0 -1 0 24)' })
  );
};

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScheduleNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ScheduleNew = function ScheduleNew(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ScheduleNew' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M14,0 L14,3 M1,7 L19,7 M6,0 L6,3 M4,11 L6,11 M8,11 L16,11 M4,15 L6,15 M8,15 L14,15 M12,19 L1,19 L1,3 L19,3 L19,13 M19,15 L19,24 M15,17 L23,22 M23,17 L15,22' })
  );
};

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SchedulePlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var SchedulePlay = function SchedulePlay(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'SchedulePlay' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M14,0 L14,3 M1,7 L19,7 M6,0 L6,3 M4,11 L6,11 M8,11 L16,11 M4,15 L6,15 M8,15 L14,15 M13,19 L1,19 L1,3 L19,3 L19,13 M18,23 C20.7614237,23 23,20.7614237 23,18 C23,15.2385763 20.7614237,13 18,13 C15.2385763,13 13,15.2385763 13,18 C13,20.7614237 15.2385763,23 18,23 Z M17.5,17 L19,18 L17.5,19 L17.5,17 Z' })
  );
};

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Schedule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Schedule = function Schedule(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Schedule' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,23 L23,23 L23,4 L1,4 L1,23 Z M4,18 L6,18 L4,18 Z M8,18 L20,18 L8,18 Z M4,14 L6,14 L4,14 Z M8,14 L20,14 L8,14 Z M18,4 L18,0 L18,4 Z M6,4 L6,0 L6,4 Z M1,9 L23,9 L1,9 Z' })
  );
};

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Schedules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Schedules = function Schedules(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Schedules' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17,7 L23,7 L23,23 L7,23 L7,19 M23,11 L17,11 M13,0 L13,3 M1,7 L17,7 M1,3 L17,3 L17,19 L1,19 L1,3 Z M5,0 L5,3 M4,11 L6,11 M8,11 L14,11 M4,15 L6,15 M8,15 L14,15' })
  );
};

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Sco */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Sco = function Sco(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Sco' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#3158A0', fillRule: 'evenodd', d: 'M16.1601041,16.1052616 L24,16.1052616 C23.7531246,16.8514638 23.0107679,17.4724977 22.2065,17.4724977 L1.27284858,17.4724977 C0.469157559,17.4724977 -0.0563179315,16.8514638 0.00482411239,16.1052616 L14.7072237,16.1052616 C14.4878705,15.5269428 14.3890063,14.8374216 14.5068517,14.1475626 L14.5068517,14.1479472 L15.4658973,14.1479472 C15.4658973,14.3350264 15.4658973,14.4905733 15.4968529,14.6453511 C15.8058317,14.5517154 16.1153874,14.3657897 16.3934106,14.1479472 L17.0117528,14.1479472 C16.4862773,14.7072623 15.9915651,15.1733261 15.7439206,15.3600209 C15.8577181,15.6369483 16.0052874,15.8883615 16.1601041,16.1052616 L16.1601041,16.1052616 L16.1601041,16.1052616 Z M21.7427242,7.71466974 C20.6915809,7.27975369 19.3616453,7 17.8469377,7 C16.3012746,7 14.8167534,7.27975369 13.6414034,7.71466974 L13.6725512,7.77696541 L21.6817744,7.77696541 L21.7427242,7.71466974 L21.7427242,7.71466974 L21.7427242,7.71466974 Z M15.1260976,12.6562543 C15.1570531,12.5939587 15.1882009,12.531663 15.2189642,12.4384118 L4.42700896,12.4695596 L4.39605339,12.3449683 C7.0557323,11.816801 10.3641321,11.5060917 13.9203688,11.5060917 C14.4767998,11.5060917 15.0643787,11.5060917 15.5898542,11.5372396 C15.6208097,11.4126482 15.651573,11.3195893 15.6827209,11.1951902 L7.02554582,11.1951902 L6.99459026,11.101939 C9.31375797,10.6049195 12.2203123,10.2944025 15.3427865,10.2944025 L15.6832977,10.2944025 C15.6525344,10.2321069 15.6215788,10.1077078 15.5906233,10.0142643 L9.71541121,10.0142643 L9.68445565,9.92101308 C11.2301188,9.57915599 13.0547666,9.2994023 15.0651478,9.23710663 C14.9718965,9.11270757 14.8484588,9.01964861 14.7244443,8.92678192 L11.8486533,8.92678192 L11.7869344,8.83333842 C13.2714556,8.36727454 15.0651478,8.08771311 17.0134255,8.08771311 C18.8995999,8.08771311 20.5692776,8.39842237 21.8984441,8.83333842 L21.8676808,8.89563408 L15.3127923,8.92678192 C15.4048899,8.98888531 15.4977566,9.08232882 15.5906233,9.2059588 C15.9615132,9.17500323 16.3320186,9.17500323 16.7036776,9.17500323 C19.0536087,9.17500323 21.2179986,9.4549492 22.9493951,9.82795412 L22.9184395,10.0142643 L16.0232321,10.0142643 C16.0541876,10.1077078 16.0541876,10.2321069 16.0851432,10.3253581 C18.5902366,10.3566982 20.8780642,10.6358751 22.7948096,11.0084955 L22.7640463,11.1951902 L16.1472466,11.1951902 C16.1472466,11.3195893 16.1472466,11.4437961 16.1159065,11.536855 C18.5279409,11.6608695 20.7542419,11.9098599 22.6098453,12.2824803 L22.5786974,12.4380272 L18.4352665,12.4380272 C18.4043109,12.5314707 18.3425921,12.5935741 18.2802964,12.6558698 L17.7857765,12.6558698 C17.816732,12.5935741 17.8786431,12.5314707 17.909791,12.4380272 L15.9615132,12.4380272 C15.9305576,12.5314707 15.9305576,12.5935741 15.8992175,12.6558698 L15.1260976,12.6558698 L15.1260976,12.6562543 L15.1260976,12.6562543 L15.1260976,12.6562543 Z M14.5068517,14.1475626 C14.5378073,13.9920157 14.5689551,13.8374302 14.6308662,13.6814987 L6.83890877,13.6814987 L6.77718992,13.5570997 C9.09616536,13.0906512 11.9719564,12.779942 15.0642441,12.779942 C15.0642441,12.7487942 15.0951997,12.6872676 15.1261552,12.656312 L15.8986984,12.656312 C15.8986984,12.6872676 15.8675506,12.7487942 15.8675506,12.779942 C16.4553217,12.8110898 17.0738562,12.8110898 17.6302872,12.8733855 C17.6920061,12.8110898 17.7535327,12.7176463 17.784296,12.656312 L18.2790082,12.656312 C18.2480526,12.7487942 18.1861415,12.8110898 18.0930825,12.9045333 C19.7016182,12.9974 21.1544147,13.2152426 22.4533947,13.4636562 L22.4224391,13.6814987 L17.4435925,13.6814987 C17.289007,13.8372379 17.1649924,13.9914389 17.0109837,14.1475626 L16.3926415,14.1475626 C16.6095227,14.0231635 16.7950639,13.8374302 16.9498417,13.6814987 L15.5272317,13.6814987 C15.4962761,13.8372379 15.4651283,14.022779 15.4651283,14.1475626 L14.5068517,14.1475626 L14.5068517,14.1475626 L14.5068517,14.1475626 Z' })
  );
};

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Scorecard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Scorecard = function Scorecard(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Scorecard' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M9,18 L9,12 M12,18 L12,13 M15,18 L15,10 M17,3 L21,3 L21,23 L3,23 L3,3 L7,3 M7,1 L17,1 L17,5 L7,5 L7,1 Z' })
  );
};

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SearchAdvanced */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var SearchAdvanced = function SearchAdvanced(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'SearchAdvanced' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,16 L21,22 L15,16 Z M10,18 C13.8659932,18 17,14.8659932 17,11 C17,7.13400675 13.8659932,4 10,4 C6.13400675,4 3,7.13400675 3,11 C3,14.8659932 6.13400675,18 10,18 Z M20,1 L20,7 M17,4 L23,4' })
  );
};

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Search; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Search = function Search(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Search' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,15 L22,22 L15,15 Z M9.5,17 C13.6421356,17 17,13.6421356 17,9.5 C17,5.35786438 13.6421356,2 9.5,2 C5.35786438,2 2,5.35786438 2,9.5 C2,13.6421356 5.35786438,17 9.5,17 Z' })
  );
};

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Secure */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Secure = function Secure(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Secure' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,11 L7,6 C7,3 9,1 12,1 C15,1 17,3 17,6 L17,11 M12,23 C15.8659932,23 19,19.8659932 19,16 C19,12.1340068 15.8659932,9 12,9 C8.13400675,9 5,12.1340068 5,16 C5,19.8659932 8.13400675,23 12,23 Z M12,15 L12,19 M12,16 C12.5522847,16 13,15.5522847 13,15 C13,14.4477153 12.5522847,14 12,14 C11.4477153,14 11,14.4477153 11,15 C11,15.5522847 11.4477153,16 12,16 Z' })
  );
};

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Select */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Select = function Select(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Select' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,1 L14,1 L8,1 Z M19.188,19.472 L16,22 L12.5,17.5 L9.5,21 L7,7 L20,13.5 L15.5,15 L19.188,19.472 Z M19,4 L19,1 L16,1 M6,1 L3,1 L3,4 M3,14 L3,17 L6,17 M19,6 L19,10 L19,6 Z M3,12 L3,6 L3,12 Z' })
  );
};

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Selection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Selection = function Selection(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Selection' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,18 L8,18 L8,6 L5,6 L5,18 Z M12,2 L12,22 L12,2 Z M1,22 L23,22 L23,2 L1,2 L1,22 Z' })
  );
};

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Semantics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Semantics = function Semantics(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Semantics' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,17 L12,12 L22,17 L22,21 L12,16 L2,21 L2,17 Z M2,8 L12,3 L22,8 L22,12 L12,7 L2,12 L2,8 Z' })
  );
};

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Send */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Send = function Send(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Send' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M22,3 L2,11 L20.5,19 L22,3 Z M10,20.5 L13,16 M15.5,9.5 L9,14 L9.85884537,20.0119176 C9.93680292,20.5576204 10.0751625,20.5490248 10.1651297,20.009222 L11,15 L15.5,9.5 Z' })
  );
};

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ServerCluster */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ServerCluster = function ServerCluster(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ServerCluster' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,8 L23,8 L23,1 L1,1 L1,8 Z M11,5 L12,5 L12,4 L11,4 L11,5 Z M19,5 L20,5 L20,4 L19,4 L19,5 Z M15,5 L16,5 L16,4 L15,4 L15,5 Z M11,12 L12,12 L12,11 L11,11 L11,12 Z M19,12 L20,12 L20,11 L19,11 L19,12 Z M15,12 L16,12 L16,11 L15,11 L15,12 Z M11,19 L12,19 L12,18 L11,18 L11,19 Z M19,19 L20,19 L20,18 L19,18 L19,19 Z M15,19 L16,19 L16,18 L15,18 L15,19 Z M1,15 L23,15 L23,8 L1,8 L1,15 Z M1,22 L23,22 L23,15 L1,15 L1,22 Z M21,23 L3,23' })
  );
};

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Server */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Server = function Server(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Server' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M14,19 L15,19 L15,18 L14,18 L14,19 Z M5,23 L19,23 L19,1 L5,1 L5,23 Z M8,5 L16,5 L8,5 Z M8,9 L16,9 L8,9 Z M8,13 L16,13 L8,13 Z' })
  );
};

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Servers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Servers = function Servers(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Servers' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,19 L8,19 L8,18 L7,18 L7,19 Z M18,19 L19,19 L19,18 L18,18 L18,19 Z M1,23 L12,23 L12,1 L1,1 L1,23 Z M12,23 L23,23 L23,1 L12,1 L12,23 Z M4,5 L9,5 L4,5 Z M15,5 L20,5 L15,5 Z M4,9 L9,9 L4,9 Z M15,9 L20,9 L15,9 Z M4,13 L9,13 L4,13 Z M15,13 L20,13 L15,13 Z' })
  );
};

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ServicePlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ServicePlay = function ServicePlay(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ServicePlay' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,13 C10.3137085,13 13,10.3137085 13,7 C13,3.6862915 10.3137085,1 7,1 C3.6862915,1 1,3.6862915 1,7 C1,10.3137085 3.6862915,13 7,13 Z M14.995457,16.6569808 L14.995457,16.6569808 C15.6222982,16.8791083 16.2970312,17 17,17 C20.3137085,17 23,14.3137085 23,11 C23,7.6862915 20.3137085,5 17,5 C15.5133616,5 14.1530044,5.54067366 13.1048383,6.43611087 M4.82356548,12.6921643 C3.69893809,13.7826979 3,15.3097261 3,17 C3,20.3137085 5.6862915,23 9,23 L9,23 C12.3137085,23 15,20.3137085 15,17 C15,14.4351166 13.3906156,12.2461251 11.1265973,11.3877758 M6.5,6 L8,7 L6.5,8 L6.5,6 Z' })
  );
};

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Services */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Services = function Services(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Services' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,9 C7.65685425,9 9,7.65685425 9,6 C9,4.34314575 7.65685425,3 6,3 C4.34314575,3 3,4.34314575 3,6 C3,7.65685425 4.34314575,9 6,9 Z M6,3 L6,0 M6,12 L6,9 M0,6 L3,6 M9,6 L12,6 M2,2 L4,4 M8,8 L10,10 M10,2 L8,4 M4,8 L2,10 M18,12 C19.6568542,12 21,10.6568542 21,9 C21,7.34314575 19.6568542,6 18,6 C16.3431458,6 15,7.34314575 15,9 C15,10.6568542 16.3431458,12 18,12 Z M18,6 L18,3 M18,15 L18,12 M12,9 L15,9 M21,9 L24,9 M14,5 L16,7 M20,11 L22,13 M22,5 L20,7 M16,11 L14,13 M9,21 C10.6568542,21 12,19.6568542 12,18 C12,16.3431458 10.6568542,15 9,15 C7.34314575,15 6,16.3431458 6,18 C6,19.6568542 7.34314575,21 9,21 Z M9,15 L9,12 M9,24 L9,21 M3,18 L6,18 M12,18 L15,18 M5,14 L7,16 M11,20 L13,22 M13,14 L11,16 M7,20 L5,22' })
  );
};

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SettingsOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var SettingsOption = function SettingsOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'SettingsOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,9 L12,0 M15,12 L24,12 M0,12 L9,12 M12,24 L12,15 M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M3.5,8.5 L1,7.5 M20.5,15.5 L23,16.5 M3,3 L5.5,5.5 M3,3 L5.5,5.5 M18,18 L20.5,20.5 M20.5,3 L18,5.5 M5.5,18 L3,20.5 M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z M20.5,8.5 L23,7.5 M15.5,3.5 L16.5,1 M15.5,20.5 L16.5,23 M8.5,20.5 L7.5,23 M3.5,15.5 L1,16.5 M8.5,3.5 L7.5,1' })
  );
};

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ShareOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ShareOption = function ShareOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ShareOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M18,8 C19.6568542,8 21,6.65685425 21,5 C21,3.34314575 19.6568542,2 18,2 C16.3431458,2 15,3.34314575 15,5 C15,6.65685425 16.3431458,8 18,8 Z M6,15 C7.65685425,15 9,13.6568542 9,12 C9,10.3431458 7.65685425,9 6,9 C4.34314575,9 3,10.3431458 3,12 C3,13.6568542 4.34314575,15 6,15 Z M18,22 C19.6568542,22 21,20.6568542 21,19 C21,17.3431458 19.6568542,16 18,16 C16.3431458,16 15,17.3431458 15,19 C15,20.6568542 16.3431458,22 18,22 Z M16,18 L8,13 M16,6 L8,11' })
  );
};

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Share */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Share = function Share(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Share' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M19,13 L19,23 L1,23 L1,5 L1,5 L11,5 M14,1 L23,1 L23,10 M10,14 L22.9999998,1 L10,14 Z' })
  );
};

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ShieldSecurity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ShieldSecurity = function ShieldSecurity(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ShieldSecurity' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C12,22 2.99999999,18 3,11 L3,5 L12,2 L21,5 C21,5 21,11 21,11 C21,18 12,22 12,22 Z M12,14 C13.6568542,14 15,12.6568542 15,11 C15,9.34314575 13.6568542,8 12,8 C10.3431458,8 9,9.34314575 9,11 C9,12.6568542 10.3431458,14 12,14 Z M12,8 L12,5 M12,17 L12,14 M6,11 L9,11 M15,11 L18,11 M8,7 L10,9 M14,13 L16,15 M16,7 L14,9 M10,13 L8,15' })
  );
};

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Shield */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Shield = function Shield(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Shield' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C12,22 3,18 3,5 C3,5 12,2 12,2 C12,2 21,5 21,5 C21,18 12,22 12,22 Z M4,11 L20,11 M12,2 L12,22' })
  );
};

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Shift */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Shift = function Shift(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Shift' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,0 L12,24 M2,12 L12,12 M22,12 L12,12 M6,8 L2,12 L6,16 M18,8 L22,12 L18,16' })
  );
};

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Shop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Shop = function Shop(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Shop' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeWidth: '2', d: 'M4,7 L20,7 L20,23 L4,23 L4,7 Z M8,9 L8,5 C8,2.790861 9.79535615,1 12,1 L12,1 C14.209139,1 16,2.79535615 16,5 L16,9' })
  );
};

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Sidebar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Sidebar = function Sidebar(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Sidebar' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,22 L23,22 L23,2 L1,2 L1,22 Z M16,2 L16,22 L16,2 Z' })
  );
};

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Sign */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Sign = function Sign(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Sign' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,23 C10,23 12.9996892,23 15,23 C18,23 19,21 19,18 L19,6 C19,4.00000008 18,3.99999992 17.5,4 C17,4.00000008 15.9998779,4.00000008 15.9998779,5.99999984 L15.9998779,13 C15.9998777,12 16.0001888,10.9999999 14.5003109,10.9999999 C13.000433,10.9999999 13,13 13,13 C13,12 13,11 11.5,10.9999999 C10,10.9999999 10,12 10,12.9999999 L10,4 C10,3 10.029402,2 8.5,2 C7,2 7,3 7,4 L7,18 L7,14 C7,13 6.44999986,12 5.00000005,12 C5,12 4,12 4,12 C4,12 4.00000001,14.0384045 4,18 C3.99999999,21.9615955 6,23.023861 8,23 Z' })
  );
};

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Skype */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Skype = function Skype(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Skype' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#00AFF0', fillRule: 'evenodd', d: 'M12.05175,18.85575 C8.025,18.85575 6.22425,16.8765 6.22425,15.393 C6.22425,14.63175 6.786,14.0985 7.56,14.0985 C9.2835,14.0985 8.83725,16.57275 12.05175,16.57275 C13.69725,16.57275 14.60625,15.67875 14.60625,14.7645 C14.60625,14.21475 14.33475,13.605 13.251,13.338 L9.66975,12.444 C6.786,11.721 6.2625,10.16175 6.2625,8.69625 C6.2625,5.65275 9.1275,4.5105 11.8185,4.5105 C14.2965,4.5105 17.2185,5.88 17.2185,7.7055 C17.2185,8.48775 16.54125,8.943 15.76725,8.943 C14.2965,8.943 14.56725,6.9075 11.6055,6.9075 C10.1355,6.9075 9.32175,7.5735 9.32175,8.526 C9.32175,9.47625 10.48275,9.78 11.49,10.0095 L14.14125,10.59825 C17.0445,11.24475 17.78025,12.93975 17.78025,14.5365 C17.78025,17.00925 15.88275,18.85575 12.05175,18.85575 M23.15025,13.9695 C23.14275,14.0115 23.1375,14.05425 23.12925,14.09625 L23.08875,13.85475 C23.1105,13.89225 23.12925,13.93125 23.15025,13.9695 C23.274,13.29525 23.33925,12.60525 23.33925,11.91525 C23.33925,10.38525 23.03925,8.901 22.44825,7.50375 C21.87675,6.1545 21.06075,4.9425 20.019,3.9015 C18.97875,2.8605 17.766,2.04375 16.41675,1.473 C15.02025,0.882 13.536,0.58275 12.00675,0.58275 C11.28525,0.58275 10.563,0.65025 9.86025,0.78525 C9.85875,0.78525 9.85725,0.78525 9.855,0.786 C9.89475,0.807 9.9345,0.82575 9.9735,0.8475 L9.735,0.81 C9.77475,0.8025 9.81525,0.79425 9.855,0.786 C8.8905,0.27375 7.80675,0 6.70875,0 C4.917,0 3.23175,0.6975 1.965,1.965 C0.69825,3.23175 0,4.917 0,6.7095 C0,7.8495 0.29325,8.97075 0.84375,9.96225 C0.8505,9.921 0.85575,9.879 0.864,9.8385 L0.90525,10.07625 C0.8835,10.03875 0.86475,9.99975 0.84375,9.96225 C0.732,10.6035 0.67275,11.25975 0.67275,11.91525 C0.67275,13.44525 0.97275,14.9295 1.5645,16.32675 C2.1345,17.67675 2.952,18.888 3.99225,19.929 C5.03325,20.96925 6.2445,21.7875 7.59525,22.35675 C8.99175,22.94925 10.47675,23.2485 12.00675,23.2485 C12.672,23.2485 13.3395,23.18775 13.99125,23.07225 C13.953,23.05125 13.914,23.03175 13.87575,23.00925 L14.118,23.052 C14.076,23.0595 14.034,23.06475 13.99125,23.07225 C14.99475,23.64075 16.131,23.94225 17.29125,23.94225 C19.08375,23.94225 20.7675,23.2455 22.035,21.97725 C23.3025,20.71125 24,19.026 24,17.2335 C24,16.089 23.70525,14.964 23.15025,13.9695' })
  );
};

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Slack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Slack = function Slack(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Slack' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#6ECADC', fillRule: 'evenodd', d: 'M10.9829147,13.9325266 L10.0460003,11.1353533 L12.9732746,10.1548615 L13.910189,12.9520348 L10.9829147,13.9325266 Z M22.0848234,8.9814134 C19.8208835,1.4349469 16.5278799,-0.348763364 8.9814134,1.91517659 C1.4349469,4.17911654 -0.348763364,7.4721201 1.91517659,15.0185866 C4.17911654,22.5650531 7.4721201,24.3487634 15.0185866,22.0848234 C22.5650531,19.8208835 24.3487634,16.5278799 22.0848234,8.9814134 L22.0848234,8.9814134 Z M18.2429859,13.8523145 L16.8022969,14.3325442 L17.2825265,15.7732332 C17.4883393,16.3906714 17.1453181,17.0081096 16.5964841,17.2139223 C16.4592757,17.2825265 16.3220672,17.2825265 16.1848587,17.2825265 C15.704629,17.2825265 15.2930036,16.9395053 15.1557951,16.5278799 L14.6755654,15.0871908 L11.725583,16.0476502 L12.2058127,17.4883393 C12.4116254,18.1057774 12.0686042,18.7232156 11.5197703,18.9290283 C11.3825618,18.9976326 11.2453534,18.9976326 11.1081449,18.9976326 C10.6279152,18.9976326 10.2162897,18.6546114 10.0790813,18.2429859 L9.59885157,16.8022969 L8.15816251,17.2825265 C8.02095403,17.3511308 7.88374555,17.3511308 7.74653706,17.3511308 C7.26630738,17.3511308 6.85468193,17.0081096 6.71747345,16.5964841 C6.51166073,15.979046 6.85468193,15.3616078 7.40351586,15.1557951 L8.84420492,14.6755654 L7.88374555,11.7941873 L6.51166073,12.274417 C6.37445225,12.3430212 6.23724376,12.3430212 6.10003528,12.3430212 C5.6198056,12.3430212 5.20818015,12 5.07097167,11.5883746 C4.86515895,10.9709364 5.20818015,10.3534982 5.75701408,10.1476855 L7.19770314,9.66745581 L6.71747345,8.22676675 C6.51166073,7.60932858 6.78607769,6.92328617 7.40351586,6.71747345 C8.02095403,6.51166073 8.6383922,6.85468193 8.84420492,7.40351586 L9.3244346,8.84420492 L12.274417,7.88374555 L11.7941873,6.44305649 C11.5883746,5.82561832 11.9313958,5.20818015 12.4802297,5.00236743 C13.0976679,4.7965547 13.715106,5.13957591 13.9209187,5.68840984 L14.4011484,7.19770314 L15.8418375,6.71747345 C16.4592757,6.51166073 17.0767138,6.85468193 17.2825265,7.40351586 C17.4883393,8.02095403 17.1453181,8.6383922 16.5964841,8.84420492 L15.1557951,9.3244346 L16.1162545,12.1372085 L17.5569435,11.6569788 C18.1743817,11.4511661 18.7918198,11.7941873 18.9976326,12.3430212 C19.1348411,13.0290636 18.8604241,13.6465018 18.2429859,13.8523145 L18.2429859,13.8523145 Z' })
  );
};

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Snapchat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Snapchat = function Snapchat(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Snapchat' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#FFFC00', fillRule: 'evenodd', d: 'M12.1511006,22.5316101 C12.0830801,22.5316101 12.0181804,22.5291262 11.9688209,22.5267697 C11.9296518,22.5301452 11.8892088,22.5316101 11.8487022,22.5316101 C10.4196979,22.5316101 9.46422593,21.8560541 8.62103883,21.259537 C8.01668787,20.8326253 7.44672931,20.4295973 6.77900716,20.3185226 C6.45106922,20.2641317 6.12485091,20.236554 5.8096509,20.236554 C5.24173041,20.236554 4.79290954,20.3246368 4.46522636,20.3887086 C4.26358497,20.4280051 4.08971226,20.4618243 3.95532713,20.4618243 C3.81457303,20.4618243 3.64356636,20.4306164 3.57229765,20.1872583 C3.51580495,19.9952977 3.47529834,19.809324 3.4361929,19.6302287 C3.33836562,19.1826816 3.26741536,18.9095168 3.09984793,18.8835951 C1.30755787,18.6070547 0.248590282,18.1996958 0.0376502063,17.7063558 C0.0155499024,17.6545125 0.00319411295,17.6023507 0.00045545858,17.5507621 C-0.00776050453,17.4037027 0.096053603,17.2747312 0.241011216,17.2507202 C1.66434721,17.0163423 2.92992398,16.2640403 4.00277591,15.0140038 C4.83386197,14.0462398 5.24198516,13.1215937 5.28580363,13.0194992 C5.28771432,13.0149135 5.28994346,13.0100731 5.29223629,13.0056785 C5.49903654,12.5860912 5.54018004,12.2235061 5.41490253,11.9283046 C5.18396391,11.3836946 4.41911506,11.141037 3.9131009,10.9804755 C3.78725018,10.9406695 3.66821425,10.9029652 3.57338038,10.8653246 C3.12481427,10.68814 2.38709721,10.3137724 2.48537032,9.79705834 C2.55695747,9.42027045 3.05532887,9.15786915 3.45810214,9.15786915 C3.56994114,9.15786915 3.66904221,9.17748555 3.75247564,9.21665468 C4.20760178,9.42988758 4.61706245,9.5379689 4.96920245,9.5379689 C5.40713239,9.5379689 5.61864568,9.37122943 5.66978845,9.32384434 C5.65717791,9.09023075 5.64176501,8.84324234 5.62686164,8.60962875 C5.62686164,8.609374 5.62654319,8.60657165 5.62654319,8.60657165 C5.52374812,6.97134023 5.39554088,4.93632897 5.91607628,3.76934376 C7.47405217,0.276158264 10.7780794,0.00452196419 11.7532952,0.00452196419 C11.7792805,0.00452196419 12.1783598,0.000573206729 12.1783598,0.000573206729 C12.196384,0.000254758546 12.2159367,0 12.23619,0 C13.2140807,0 16.5249864,0.271954748 18.0839176,3.767242 C18.604453,4.93499149 18.4761184,6.97172237 18.3730049,8.60867341 L18.3681645,8.68701166 C18.3540254,8.90928849 18.340969,9.11965536 18.3299507,9.32358958 C18.3781001,9.36791757 18.5716529,9.52077269 18.9654459,9.53624928 C19.301154,9.52338397 19.6869221,9.41581217 20.111732,9.21690944 C20.24306,9.15525787 20.3884635,9.14245625 20.4871824,9.14245625 C20.6364072,9.14245625 20.7882433,9.17149873 20.9147946,9.22429744 L20.9215457,9.22690871 C21.2820291,9.35486119 21.5181265,9.61057508 21.5232217,9.87921797 C21.5277437,10.1296456 21.3416426,10.5039496 20.4262951,10.865452 C20.332544,10.902583 20.2129348,10.9405421 20.0865746,10.9806029 C19.5801146,11.1413555 18.8159026,11.3838856 18.584964,11.9281773 C18.4594954,12.2233787 18.5007663,12.5858365 18.7076303,13.0052964 C18.7099231,13.0098821 18.7118975,13.0145314 18.7141266,13.0193718 C18.7778162,13.1686603 20.3194239,16.683755 23.758919,17.2504017 C23.9038129,17.2745401 24.0078181,17.403639 23.9995385,17.5504436 C23.9964814,17.6031786 23.9837434,17.6559137 23.9614521,17.7074386 C23.7519768,18.1980398 22.693073,18.6048256 20.9002734,18.8817481 C20.7320054,18.9077335 20.6611188,19.1796882 20.5641832,19.6248788 C20.5240587,19.8087507 20.4832336,19.9889924 20.4275052,20.1784054 C20.3753434,20.3565453 20.2593009,20.443609 20.072945,20.443609 L20.0448579,20.443609 C19.9235291,20.443609 19.7516308,20.4215724 19.5348313,20.3791551 C19.1558779,20.3054025 18.730877,20.2367451 18.1904067,20.2367451 C17.8752704,20.2367451 17.5491158,20.2643864 17.2207957,20.3187137 C16.5537741,20.4297884 15.9838793,20.8321795 15.380611,21.2586453 C14.535768,21.8559904 13.5799776,22.5316101 12.1511006,22.5316101' })
  );
};

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Solaris */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Solaris = function Solaris(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Solaris' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#D47B27', fillRule: 'evenodd', d: 'M10.1802464,4.7643196 C9.30783675,4.45498283 8.90876565,3.63737375 8.90876565,3.63737375 C8.84089823,3.54283936 8.5558284,2.85816509 8.5562284,2.85789842 C8.25689174,2.06482294 7.71088568,1.82242025 7.71088568,1.82242025 C7.03954488,1.42788253 6.21046901,1.41801576 6.21046901,1.41801576 C6.24620274,1.4132157 6.70394115,1.62521806 6.70394115,1.62521806 C7.78395316,2.13989044 7.46048289,3.3691041 7.46048289,3.3691041 C7.39021545,3.70004111 7.37381526,4.33911488 7.37381526,4.33911488 C7.35914843,5.19085768 7.96582184,5.60659563 8.03302259,5.65099612 C8.3674263,5.44779386 8.7239636,5.26739186 9.09756775,5.1147235 C9.45570506,4.96832187 9.81744242,4.85138724 10.1802464,4.7643196 M5.59699552,8.17022411 C4.76098623,8.56862854 3.90111001,8.27249192 3.90111001,8.27249192 C3.78604207,8.25382504 3.10043445,7.97115524 3.10043445,7.97115524 C2.32802587,7.62208469 1.77081968,7.83648707 1.77081968,7.83648707 C1.0168113,8.03182258 0.423738042,8.61142902 0.423738042,8.61142902 C0.445338282,8.58276203 0.919076879,8.40889343 0.919076879,8.40889343 C2.04668941,8.00915566 2.68682985,9.10716786 2.68682985,9.10716786 C2.87149857,9.39063767 3.31177013,9.85410949 3.31177013,9.85410949 C3.9033767,10.4670496 4.62685141,10.3319815 4.70538562,10.3161146 C4.79818665,9.93531039 4.9228547,9.55610618 5.0791231,9.18383538 C5.2288581,8.82703141 5.40166002,8.48876099 5.59699552,8.17022411 M4.76458627,13.8196202 C4.45511617,14.6924299 3.63764042,15.0916344 3.63764042,15.0916344 C3.54310603,15.1592351 2.85843176,15.4444383 2.85816509,15.4443049 C2.06508961,15.7436416 1.82268692,16.2895143 1.82268692,16.2895143 C1.42788253,16.9605885 1.41854909,17.7897977 1.41854909,17.7897977 C1.41361571,17.7540639 1.62535139,17.2963255 1.62535139,17.2963255 C2.14002378,16.2163135 3.36950411,16.5401838 3.36950411,16.5401838 C3.70004111,16.6097846 4.33898154,16.6264514 4.33898154,16.6264514 C5.19085768,16.6415182 5.6068623,16.0343115 5.65099612,15.9676441 C5.4479272,15.6325737 5.26765853,15.2763031 5.1151235,14.9026989 C4.96832187,14.5444283 4.8512539,14.1826909 4.76458627,13.8196202 M8.17075745,18.4032711 C8.56889521,19.2391471 8.27315859,20.0994233 8.27315859,20.0994233 C8.25435838,20.2138246 7.97155524,20.9000989 7.97128857,20.8999656 C7.62195136,21.6722408 7.83675374,22.2297137 7.83675374,22.2297137 C8.03195591,22.9835887 8.61169569,23.5767953 8.61169569,23.5767953 C8.5830287,23.5549284 8.40902677,23.0813231 8.40902677,23.0813231 C8.00942233,21.9535773 9.1077012,21.3135702 9.1077012,21.3135702 C9.39103768,21.1287681 9.85464283,20.6884965 9.85464283,20.6884965 C10.4673163,20.09689 10.3325148,19.3735486 10.3163813,19.2951477 C9.9357104,19.2019467 9.55610618,19.077412 9.18370204,18.9211436 C8.82703141,18.7716752 8.48876099,18.5984733 8.17075745,18.4032711 M13.8200202,19.2359471 C14.6929633,19.5448838 15.0917677,20.3626263 15.0917677,20.3626263 C15.1596351,20.4571606 15.4445716,21.1421016 15.4441716,21.1423682 C15.7435083,21.9353104 16.289781,22.1777131 16.289781,22.1777131 C16.9609885,22.5727841 17.7900643,22.5822509 17.7900643,22.5822509 C17.7545973,22.5869176 17.2967255,22.3749153 17.2967255,22.3749153 C16.2163135,21.8602429 16.5403171,20.6311626 16.5403171,20.6311626 C16.6103179,20.3000922 16.6264514,19.6612851 16.6264514,19.6612851 C16.6416516,18.8092757 16.0344448,18.393271 15.9680441,18.3492705 C15.6328404,18.5524728 15.2767031,18.7326081 14.9026989,18.8852765 C14.5448283,19.0319448 14.1833576,19.1488794 13.8200202,19.2359471 M18.4035378,15.8299092 C19.2394138,15.4312381 20.09969,15.7275081 20.09969,15.7275081 C20.2146246,15.7463083 20.9002322,16.0291114 20.8999656,16.0293781 C21.6726408,16.3783153 22.2299803,16.1636463 22.2299803,16.1636463 C22.984122,15.9681774 23.5769286,15.3887043 23.5769286,15.3887043 C23.5551951,15.4175046 23.0818565,15.5911066 23.0818565,15.5911066 C21.9538439,15.990711 21.3135702,14.8928321 21.3135702,14.8928321 C21.1287681,14.6093623 20.6887632,14.1460238 20.6887632,14.1460238 C20.0970233,13.532817 19.3736819,13.6680185 19.2952811,13.6838854 C19.2023467,14.0645563 19.0775453,14.4441605 18.9214102,14.816298 C18.7720752,15.1731019 18.5988733,15.5113723 18.4035378,15.8299092 M19.2364804,10.1802464 C19.5455505,9.30757008 20.3628929,8.90849898 20.3628929,8.90849898 C20.4574273,8.84063156 21.1426349,8.55542839 21.1429016,8.55596173 C21.9351771,8.25662507 22.1777131,7.71101901 22.1777131,7.71101901 C22.5726508,7.03927821 22.5826509,6.21046901 22.5826509,6.21046901 C22.587051,6.24593607 22.3753153,6.70367449 22.3753153,6.70367449 C21.8606429,7.78368649 20.6312959,7.46021622 20.6312959,7.46021622 C20.3003589,7.39034878 19.6615518,7.37368193 19.6615518,7.37368193 C18.809409,7.35848176 18.393671,7.96582184 18.3492705,8.03235592 C18.5527395,8.36729297 18.7330081,8.72383026 18.8854098,9.09756775 C19.0323448,9.45557173 19.1488794,9.81730908 19.2364804,10.1802464 M15.8303092,5.59659552 C15.4316381,4.76111957 15.7273747,3.90084334 15.7273747,3.90084334 C15.7464416,3.78604207 16.0289781,3.09990111 16.0296448,3.10030111 C16.378582,2.32789253 16.1639129,1.77055301 16.1639129,1.77055301 C15.9681774,1.01641129 15.3892377,0.423471372 15.3892377,0.423471372 C15.417638,0.445338282 15.5916399,0.918810209 15.5916399,0.918810209 C15.9909777,2.04642274 14.8928321,2.68669652 14.8928321,2.68669652 C14.609629,2.87163191 14.1464238,3.31150346 14.1464238,3.31150346 C13.5330837,3.9029767 13.6684185,4.62658474 13.6844187,4.70525228 C14.0649563,4.79791998 14.4445605,4.92298803 14.8164313,5.07885643 C15.1732353,5.22819142 15.511639,5.40139335 15.8301759,5.59659552 M7.58741764,5.98366649 C6.66234069,6.02633363 5.98473316,5.41926021 5.98473316,5.41926021 C5.88633207,5.35752619 5.36419294,4.83058701 5.36432627,4.830187 C4.78831987,4.2085801 4.19124657,4.19017989 4.19124657,4.19017989 C3.42070467,4.07711197 2.64896277,4.38084868 2.64896277,4.38084868 C2.68016311,4.36271514 3.18416871,4.38658207 3.18416871,4.38658207 C4.37844865,4.45618285 4.5417838,5.71699686 4.5417838,5.71699686 C4.60205113,6.04966722 4.82752031,6.6478072 4.82752031,6.6478072 C5.13472372,7.44248269 5.85366504,7.5987511 5.93233258,7.61448461 C6.16580184,7.30021445 6.42793809,6.99874443 6.71660796,6.71660796 C6.99314437,6.44580495 7.2839476,6.20113557 7.58741764,5.98366649 M4.6256514,10.8662541 C4.00151113,11.5502617 3.0933677,11.6003956 3.0933677,11.6003956 C2.97989978,11.6261292 2.23829154,11.6227958 2.23829154,11.6223958 C1.39108212,11.5899954 0.955743953,11.9990667 0.955743953,11.9990667 C0.331337015,12.4642718 0,13.2248136 0,13.2248136 C0.00946677185,13.1897466 0.382670919,12.8502761 0.382670919,12.8502761 C1.27641418,12.0552006 2.2833587,12.8309426 2.2833587,12.8309426 C2.56109512,13.0237447 3.14363493,13.2873476 3.14363493,13.2873476 C3.92271025,13.6320181 4.5417838,13.234147 4.60845121,13.1896132 C4.5513839,12.8021422 4.52338359,12.4037378 4.52805031,12.0002667 C4.53218369,11.612929 4.56498406,11.2343915 4.6256514,10.8662541 M5.98393315,16.4127157 C6.02646696,17.3377926 5.41952688,18.0155335 5.41952688,18.0155335 C5.35752619,18.1140679 4.83058701,18.6360737 4.83032034,18.6359404 C4.2085801,19.2119468 4.19004656,19.8090201 4.19004656,19.8090201 C4.07711197,20.5794287 4.38084868,21.3513039 4.38084868,21.3513039 C4.36284848,21.3201036 4.38658207,20.8162313 4.38658207,20.8162313 C4.45631618,19.6216847 5.71673019,19.4584829 5.71673019,19.4584829 C6.04966722,19.3982155 6.6478072,19.1728797 6.6478072,19.1728797 C7.44248269,18.8658096 7.59901777,18.1466016 7.61461794,18.0680674 C7.30021445,17.8343315 6.9990111,17.5721952 6.7167413,17.2836587 C6.44580495,17.007389 6.2012689,16.7163191 5.98393315,16.4127157 M10.8663874,19.3746153 C11.550395,19.9987555 11.6002622,20.906899 11.6002622,20.906899 C11.6262625,21.0203669 11.6227958,21.7622418 11.6225291,21.7622418 C11.5902621,22.6090512 11.9993333,23.0446561 11.9993333,23.0446561 C12.4644052,23.6693297 13.2248136,24 13.2248136,24 C13.1900132,23.9905332 12.8504094,23.6175958 12.8504094,23.6175958 C12.0552006,22.7237192 12.8310759,21.7170413 12.8310759,21.7170413 C13.023878,21.4391715 13.2873476,20.8566317 13.2873476,20.8566317 C13.6320181,20.0775564 13.2340137,19.4584829 13.1900132,19.3916821 C12.8022756,19.4491494 12.4038712,19.4767497 12.0001333,19.4722164 C11.6131957,19.4679496 11.2345248,19.4354159 10.8663874,19.3746153 M16.4129824,18.0166002 C17.3380593,17.9740664 18.0155335,18.5810065 18.0155335,18.5810065 C18.1140679,18.6427405 18.6363404,19.1696797 18.6359404,19.1699463 C19.2119468,19.7916866 19.8092868,19.8104868 19.8092868,19.8104868 C20.5798287,19.923288 21.3514372,19.6195513 21.3514372,19.6195513 C21.3202369,19.6372849 20.8162313,19.6136846 20.8162313,19.6136846 C19.621818,19.5439505 19.4584829,18.2834031 19.4584829,18.2834031 C19.3983489,17.9505995 19.1727464,17.3525928 19.1727464,17.3525928 C18.8656763,16.557784 18.1466016,16.4012489 18.0682008,16.3855154 C17.8345982,16.7001856 17.5723286,17.0013889 17.2836587,17.2835254 C17.007389,17.5544617 16.7164524,17.7989978 16.4129824,18.0166002 M19.3748819,13.1341459 C19.9988889,12.4497383 20.9070323,12.3998711 20.9070323,12.3998711 C21.0206336,12.3740042 21.7625085,12.3772042 21.7625085,12.3780042 C22.6093179,12.4098712 23.0446561,12.0008 23.0446561,12.0008 C23.669463,11.5355948 24.0004,10.7755864 24.0004,10.7755864 C23.9907999,10.8102534 23.6177291,11.1498572 23.6177291,11.1498572 C22.7239858,11.9451994 21.7167746,11.1693241 21.7167746,11.1693241 C21.4391715,10.9763886 20.8568984,10.7130524 20.8568984,10.7130524 C20.0775564,10.3682485 19.4584829,10.7659863 19.3919488,10.8102534 C19.4491494,11.1978578 19.4767497,11.5965289 19.472083,12 C19.4683496,12.3869376 19.4354159,12.7654752 19.3748819,13.1341459 M18.0167335,7.5872843 C17.973933,6.66220736 18.5808731,5.98473316 18.5808731,5.98473316 C18.6430071,5.88619874 19.1699463,5.36379293 19.170213,5.3640596 C19.7916866,4.78831987 19.8104868,4.19124657 19.8104868,4.19124657 C19.9231547,3.42030467 19.619818,2.64896277 19.619818,2.64896277 C19.6375515,2.68002978 19.6136846,3.18416871 19.6136846,3.18416871 C19.5439505,4.37844865 18.2835365,4.54165046 18.2835365,4.54165046 C17.9505995,4.6019178 17.3527261,4.82752031 17.3527261,4.82752031 C16.557784,5.13445705 16.4013822,5.85366504 16.3853821,5.93206591 C16.7000522,6.16553517 17.0013889,6.42820476 17.2835254,6.71647463 C17.5547284,6.9928777 17.7989978,7.28354759 18.0167335,7.5872843 M13.1341459,4.62551806 C12.450005,4.00164446 12.3997378,3.09323437 12.3997378,3.09323437 C12.3742708,2.97963311 12.3773375,2.23789153 12.3778709,2.23789153 C12.4101379,1.39094879 12.0012,0.955743953 12.0012,0.955743953 C11.5358615,0.330803676 10.7757197,0 10.7757197,0 C10.8103868,0.00946677185 11.1499906,0.382537584 11.1499906,0.382537584 C11.9451994,1.27654752 11.1693241,2.2833587 11.1693241,2.2833587 C10.976522,2.56122846 10.713319,3.14336826 10.713319,3.14336826 C10.3681152,3.92271025 10.766253,4.54165046 10.8103868,4.60858454 C11.1979911,4.5509839 11.5965289,4.52365026 12,4.52818365 C12.3869376,4.53191702 12.7656085,4.56485072 13.1340126,4.62551806' })
  );
};

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Sort */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Sort = function Sort(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Sort' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,3 L22,3 M7,9 L16,9 M7,15 L22,15 M2,2 L4,2 L4,4 L2,4 L2,2 Z M2,8 L4,8 L4,10 L2,10 L2,8 Z M2,14 L4,14 L4,16 L2,16 L2,14 Z M2,20 L4,20 L4,22 L2,22 L2,20 Z M7,21 L16,21' })
  );
};

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Spa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Spa = function Spa(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Spa' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C13.5,22 16,21 16,16.5 C16,12 12,6 12,6 C12,6 8,12 8,16.5 C8,21 10.5,22 12,22 Z M12,22 C10.5,22 9.04678627,21.7792414 7,20.5 C3,18 2.5,10 2.5,10 C2.5,10 7,10.5 9,12 M12,22 C13.5,22 14.9532137,21.7792414 17,20.5 C21,18 21.5,10 21.5,10 C21.5,10 17,10.5 15,12' })
  );
};

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Split */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Split = function Split(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Split' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,22 L23,22 L23,2 L1,2 L1,22 Z M12,2 L12,22 L12,2 Z' })
  );
};

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Splits */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Splits = function Splits(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Splits' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,22 L23,22 L23,2 L1,2 L1,22 Z M8,2 L8,22 L8,2 Z M16,2 L16,22 L16,2 Z' })
  );
};

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Square */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Square = function Square(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Square' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#28C101', fillRule: 'evenodd', d: 'M14.4444444,8.33333333 L9.55555556,8.33333333 C8.88088889,8.33333333 8.33333333,8.88088889 8.33333333,9.55555556 L8.33333333,14.4444444 C8.33333333,15.1191111 8.88088889,15.6666667 9.55555556,15.6666667 L14.4444444,15.6666667 C15.1191111,15.6666667 15.6666667,15.1191111 15.6666667,14.4444444 L15.6666667,9.55555556 C15.6666667,8.88088889 15.1191111,8.33333333 14.4444444,8.33333333 M18.1111111,22 L5.88888889,22 C3.74128475,22 2,20.2587153 2,18.1111111 L2,5.88888889 C2,3.74128475 3.74128475,2 5.88888889,2 L18.1111111,2 C20.2587153,2 22,3.74128475 22,5.88888889 L22,18.1111111 C22,20.2587153 20.2587153,22 18.1111111,22 L18.1111111,22 Z M18.1111111,24 C21.3632847,24 24,21.3632847 24,18.1111111 L24,5.88888889 C24,2.63671525 21.3632847,0 18.1111111,0 L5.88888889,0 C2.63671525,0 0,2.63671525 0,5.88888889 L0,18.1111111 C0,21.3632847 2.63671525,24 5.88888889,24 L18.1111111,24 L18.1111111,24 Z' })
  );
};

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StackOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StackOverflow = function StackOverflow(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StackOverflow' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#FE7A15', fillRule: 'evenodd', d: 'M11.4137208,0.131625 C11.7902208,-0.043875 12.2252208,-0.043875 12.6017208,0.131625 L23.4227208,5.187375 C23.7467208,5.338875 23.7459708,5.800875 23.4204708,5.950875 L12.5154708,10.968375 C12.1929708,11.116875 11.8217208,11.116875 11.4992208,10.968375 L0.594970771,5.950875 C0.269470771,5.800875 0.267970771,5.338875 0.592720771,5.187375 L11.4137208,0.131625 Z M23.4227208,11.6582856 C23.7474708,11.8097856 23.7459708,12.2717856 23.4204708,12.4217856 L12.5162208,17.4392856 C12.1937208,17.5877856 11.8224708,17.5877856 11.4999708,17.4392856 L0.594970771,12.4217856 C0.269470771,12.2717856 0.267970771,11.8097856 0.592720771,11.6582856 L2.82772077,10.6142856 C3.15172077,10.4627856 3.52597077,10.4620356 3.85072077,10.6112856 L11.4999708,14.1302856 C11.8224708,14.2787856 12.1937208,14.2787856 12.5162208,14.1302856 L20.1647208,10.6112856 C20.4894708,10.4620356 20.8637208,10.4627856 21.1877208,10.6142856 L23.4227208,11.6582856 Z M23.4227208,18.1582856 C23.7474708,18.3097856 23.7459708,18.7717856 23.4204708,18.9217856 L12.5162208,23.9392856 C12.1937208,24.0877856 11.8224708,24.0877856 11.4999708,23.9392856 L0.594970771,18.9217856 C0.269470771,18.7717856 0.267970771,18.3097856 0.592720771,18.1582856 L2.82772077,17.1142856 C3.15172077,16.9627856 3.52597077,16.9620356 3.85072077,17.1112856 L11.4999708,20.6302856 C11.8224708,20.7787856 12.1937208,20.7787856 12.5162208,20.6302856 L20.1647208,17.1112856 C20.4894708,16.9620356 20.8637208,16.9627856 21.1877208,17.1142856 L23.4227208,18.1582856 Z' })
  );
};

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Stakeholder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Stakeholder = function Stakeholder(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Stakeholder' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M14,9 L18.5,11 L23,9 L23,4 L18.5,2 L14,4 L14,9 Z M7,7 C4.791,7 3,8.791 3,11 C3,13.209 4.791,15 7,15 C9.209,15 11,13.209 11,11 C11,8.791 9.209,7 7,7 L7,7 Z M1,23 L1,21 C1,17 3.5,15 7,15 C10.5,15 13,17 13,21 L13,23 L1,23 Z M14,4 L18.5,6 L23,4 M18.5,6 L18.5,11 L18.5,6 Z' })
  );
};

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StarHalf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StarHalf = function StarHalf(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StarHalf' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: '#000', fillOpacity: '.2', points: '12 16.667 12 2 14.5 9.5 22 9.5 16 14 19 22' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: '#FFC95E', points: '12 16.667 5 22 8 14 2 9.5 9.5 9.5 12 2' })
    )
  );
};

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Star */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Star = function Star(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Star' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: '#FFC95E', fillRule: 'evenodd', points: '12 16.667 5 22 8 14 2 9.5 9.5 9.5 12 2 14.5 9.5 22 9.5 16 14 19 22' })
  );
};

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatusCriticalSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusCriticalSmall = function StatusCriticalSmall(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 12 12', a11yTitle: 'StatusCriticalSmall' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fillRule: 'evenodd', stroke: '#000', d: 'M6.71239638,1.26313029 C6.31895072,0.869684641 5.68347072,0.867263198 5.28760362,1.26313029 L1.26313029,5.28760362 C0.869684641,5.68104928 0.867263198,6.31652928 1.26313029,6.71239638 L5.28760362,10.7368697 C5.68104928,11.1303154 6.31652928,11.1327368 6.71239638,10.7368697 L10.7368697,6.71239638 C11.1303154,6.31895072 11.1327368,5.68347072 10.7368697,5.28760362 L6.71239638,1.26313029 Z' })
  );
};

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusCritical; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusCritical = function StatusCritical(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StatusCritical' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12.7031806,2.70318058 C12.3148247,2.31482467 11.6897542,2.31024575 11.2968194,2.70318058 L2.70318058,11.2968194 C2.31482467,11.6851753 2.31024575,12.3102458 2.70318058,12.7031806 L11.2968194,21.2968194 C11.6851753,21.6851753 12.3102458,21.6897542 12.7031806,21.2968194 L21.2968194,12.7031806 C21.6851753,12.3148247 21.6897542,11.6897542 21.2968194,11.2968194 L12.7031806,2.70318058 Z M8.98264552,14.7001725 L14.7001725,8.98264552 M8.98264552,8.98264552 L14.7001725,14.7001725' })
  );
};

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatusDisabledSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusDisabledSmall = function StatusDisabledSmall(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 12 12', a11yTitle: 'StatusDisabledSmall' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { width: '10', height: '10', x: '1', y: '1', fillRule: 'evenodd', stroke: '#000', rx: '1' })
  );
};

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusDisabled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusDisabled = function StatusDisabled(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StatusDisabled' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,3.99079514 C2,2.89130934 2.89821238,2 3.99079514,2 L20.0092049,2 C21.1086907,2 22,2.89821238 22,3.99079514 L22,20.0092049 C22,21.1086907 21.1017876,22 20.0092049,22 L3.99079514,22 C2.89130934,22 2,21.1017876 2,20.0092049 L2,3.99079514 Z M18,12 L6,12' })
  );
};

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatusGoodSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusGoodSmall = function StatusGoodSmall(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 12 12', a11yTitle: 'StatusGoodSmall' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: '6', cy: '6', r: '5', fillRule: 'evenodd', stroke: '#000' })
  );
};

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusGood; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusGood = function StatusGood(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StatusGood' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M7,12 L11,15 L16,8' })
  );
};

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatusInfoSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusInfoSmall = function StatusInfoSmall(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 12 12', a11yTitle: 'StatusInfoSmall' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { width: '10', height: '10', x: '1', y: '1', fillRule: 'evenodd', stroke: '#000', rx: '1' })
  );
};

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusInfo = function StatusInfo(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StatusInfo' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,3.99079514 C2,2.89130934 2.89821238,2 3.99079514,2 L20.0092049,2 C21.1086907,2 22,2.89821238 22,3.99079514 L22,20.0092049 C22,21.1086907 21.1017876,22 20.0092049,22 L3.99079514,22 C2.89130934,22 2,21.1017876 2,20.0092049 L2,3.99079514 Z M12,10 L12,18 M12,6 L12,8' })
  );
};

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatusPlaceholderSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusPlaceholderSmall = function StatusPlaceholderSmall(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 12 12', a11yTitle: 'StatusPlaceholderSmall' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { width: '10', height: '10', x: '1', y: '1', fillRule: 'evenodd', stroke: '#000', rx: '1' })
  );
};

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatusPlaceholder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusPlaceholder = function StatusPlaceholder(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StatusPlaceholder' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { width: '20', height: '20', x: '2', y: '2', fill: 'none', stroke: '#000', strokeWidth: '2', rx: '2' })
  );
};

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatusUnknownSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusUnknownSmall = function StatusUnknownSmall(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 12 12', a11yTitle: 'StatusUnknownSmall' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { width: '10', height: '10', x: '1', y: '1', fillRule: 'evenodd', stroke: '#000', rx: '1' })
  );
};

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusUnknown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusUnknown = function StatusUnknown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StatusUnknown' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,3.99079514 C2,2.89130934 2.89821238,2 3.99079514,2 L20.0092049,2 C21.1086907,2 22,2.89821238 22,3.99079514 L22,20.0092049 C22,21.1086907 21.1017876,22 20.0092049,22 L3.99079514,22 C2.89130934,22 2,21.1017876 2,20.0092049 L2,3.99079514 Z M12,15 L12,14 C12,13 12,12.5 13,12 C14,11.5 15,11 15,9.5 C15,8.5 14,7 12,7 C10,7 9,8.26413718 9,10 M12,16 L12,18' })
  );
};

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatusWarningSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusWarningSmall = function StatusWarningSmall(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 12 12', a11yTitle: 'StatusWarningSmall' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fillRule: 'evenodd', stroke: '#000', strokeLinejoin: 'round', points: '6 1 11 10 1 10' })
  );
};

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusWarning; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StatusWarning = function StatusWarning(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StatusWarning' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinejoin: 'round', strokeWidth: '2', d: 'M12,3 L22,21 L2,21 L12,3 Z M12,9 L12,15 M12,16 L12,18' })
  );
};

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StepsOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StepsOption = function StepsOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StepsOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M24,9 L19,9 L19,14 L14,14 L14,19 L9,19 L9,24 M1,24 L1,16.9970301 C1,16.4463856 1.31329632,15.6867037 1.70336215,15.2966378 L15.2966378,1.70336215 C15.685094,1.31490596 16.4530363,1 16.9970301,1 L24,1' })
  );
};

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Steps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Steps = function Steps(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Steps' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '16 6 11 6 11 11 6 11 6 16 1 16 1 23 23 23 23 1 16 1' })
  );
};

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StopFill */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StopFill = function StopFill(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StopFill' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4,4 L20,4 L20,20 L4,20 L4,4 Z M6,6 L18,6 L18,18 L6,18 L6,6 Z M8,8 L16,8 L16,16 L8,16 L8,8 Z M10,10 L14,10 L14,14 L10,14 L10,10 Z M11,11 L13,11 L13,13 L11,13 L11,11 Z' })
  );
};

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Stop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Stop = function Stop(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Stop' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { width: '16', height: '16', x: '4', y: '4', fill: 'none', stroke: '#000', strokeWidth: '2' })
  );
};

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Storage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Storage = function Storage(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Storage' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000000', strokeWidth: '2', d: 'M2,5.07692308 C2,5.07692308 3.66666667,2 12,2 C20.3333333,2 22,5.07692308 22,5.07692308 L22,18.9230769 C22,18.9230769 20.3333333,22 12,22 C3.66666667,22 2,18.9230769 2,18.9230769 L2,5.07692308 Z M2,13 C2,13 5.33333333,16 12,16 C18.6666667,16 22,13 22,13 M2,7 C2,7 5.33333333,10 12,10 C18.6666667,10 22,7 22,7' })
  );
};

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StreetView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StreetView = function StreetView(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StreetView' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,5 C16,7.209 14.209,9 12,9 C9.791,9 8,7.209 8,5 C8,2.791 9.791,1 12,1 C14.209,1 16,2.791 16,5 L16,5 Z M15,23 L15,17 L18,17 L18,15 C18,11.66 15.24,9.03 12,9 C8.79,9.03 6,11.66 6,15 L6,17 L9,17 L9,23 M3.5,23 L20.5,23 L3.5,23 Z' })
  );
};

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StrikeThrough */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var StrikeThrough = function StrikeThrough(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'StrikeThrough' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '5.77', y: '12.17', width: '12.46', height: '1.09' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M16.7,13.65H12.89c.59.34,1,.6,1.18.74a3.39,3.39,0,0,1,1,1.07,2.38,2.38,0,0,1,.31,1.14,2.3,2.3,0,0,1-.82,1.76,3.18,3.18,0,0,1-2.22.74,4.7,4.7,0,0,1-2.23-.54A3.77,3.77,0,0,1,8.56,17.2a7.41,7.41,0,0,1-.79-2.46H7.36V20h.41a1.35,1.35,0,0,1,.24-.7.59.59,0,0,1,.44-.17,6.5,6.5,0,0,1,1.39.35,12.63,12.63,0,0,0,1.45.41,7.26,7.26,0,0,0,1.25.1A4.87,4.87,0,0,0,16,18.72a4,4,0,0,0,1.34-3A3.8,3.8,0,0,0,16.92,14C16.86,13.87,16.78,13.77,16.7,13.65Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M8.89,11.21c.21.17.49.36.81.57h4.87c-.48-.29-1.07-.62-1.76-1A12.49,12.49,0,0,1,9.48,8.54,1.93,1.93,0,0,1,9,7.26a2.18,2.18,0,0,1,.77-1.63,2.72,2.72,0,0,1,1.93-.71,4.14,4.14,0,0,1,2,.53,3.78,3.78,0,0,1,1.49,1.43,6.6,6.6,0,0,1,.73,2.42h.41V4h-.41a1.39,1.39,0,0,1-.3.7.67.67,0,0,1-.48.17,2.64,2.64,0,0,1-.89-.28A6.45,6.45,0,0,0,11.68,4,4.49,4.49,0,0,0,8.47,5.21,3.75,3.75,0,0,0,7.21,8a3.57,3.57,0,0,0,.43,1.73A4.72,4.72,0,0,0,8.89,11.21Z' })
  );
};

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Stripe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Stripe = function Stripe(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Stripe' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#AACBFB', fillRule: 'evenodd', d: 'M1,1 L23,1 L23,23 L1,23 L1,1 Z M11.1196337,9.18908425 C11.1196337,8.58622711 11.6142857,8.35435897 12.4335531,8.35435897 C13.6083516,8.35435897 15.0923077,8.70989011 16.2671062,9.343663 L16.2671062,5.71106227 C14.9841026,5.20095238 13.7165568,5 12.4335531,5 C9.2956044,5 7.20879121,6.6385348 7.20879121,9.37457875 C7.20879121,13.6409524 13.0827839,12.9608059 13.0827839,14.800293 C13.0827839,15.5113553 12.4644689,15.7432234 11.5988278,15.7432234 C10.3158242,15.7432234 8.67728938,15.2176557 7.37882784,14.5065934 L7.37882784,18.1855678 C8.81641026,18.8038828 10.2694505,19.0666667 11.5988278,19.0666667 C14.8140659,19.0666667 17.0245421,17.4745055 17.0245421,14.7075458 C17.0090842,10.1010989 11.1196337,10.9203663 11.1196337,9.18908425 L11.1196337,9.18908425 Z' })
  );
};

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Subscript */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Subscript = function Subscript(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Subscript' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M18.74,3.63l.19,4.07h-.49a4.92,4.92,0,0,0-.38-1.54A2.58,2.58,0,0,0,17,5.07a3.68,3.68,0,0,0-1.73-.35H12.83V18a3.54,3.54,0,0,0,.35,2,1.92,1.92,0,0,0,1.5.54h.6V21H7.92V20.5h.61a1.76,1.76,0,0,0,1.56-.67A3.88,3.88,0,0,0,10.38,18V4.72H8.29a5.79,5.79,0,0,0-1.73.18,2.37,2.37,0,0,0-1.14.93A3.78,3.78,0,0,0,4.86,7.7H4.38l.21-4.07Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M22.48,16.68h.33v5.59a1.13,1.13,0,0,0,.06.4.41.41,0,0,0,.17.21.63.63,0,0,0,.28.08h.4v.27H20.76V23l.45,0a.62.62,0,0,0,.29-.1.38.38,0,0,0,.15-.22,1.4,1.4,0,0,0,0-.37V18.42a4.45,4.45,0,0,0,0-.64c0-.15-.1-.23-.24-.23a.82.82,0,0,0-.28,0l-.3.13-.18-.25Z' })
  );
};

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubtractCircle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var SubtractCircle = function SubtractCircle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'SubtractCircle' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M6,12 L18,12' })
  );
};

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Subtract */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Subtract = function Subtract(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Subtract' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,12 L22,12' })
  );
};

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Superscript */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Superscript = function Superscript(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Superscript' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M18.74,3.63l.19,4.07h-.49a4.9,4.9,0,0,0-.38-1.54A2.57,2.57,0,0,0,17,5.07a3.68,3.68,0,0,0-1.73-.35H12.83V18a3.56,3.56,0,0,0,.34,2,1.92,1.92,0,0,0,1.5.54h.6V21H7.92V20.5h.61a1.76,1.76,0,0,0,1.56-.67A3.88,3.88,0,0,0,10.38,18V4.72H8.29a5.82,5.82,0,0,0-1.73.18,2.37,2.37,0,0,0-1.14.93A3.78,3.78,0,0,0,4.86,7.7H4.38l.21-4.07Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M22.48,1h.33V6.62a1.13,1.13,0,0,0,.06.4.41.41,0,0,0,.17.21.63.63,0,0,0,.28.08h.4V7.6H20.76V7.33l.45,0a.62.62,0,0,0,.29-.1A.38.38,0,0,0,21.65,7a1.4,1.4,0,0,0,0-.37V2.77a4.45,4.45,0,0,0,0-.64c0-.15-.1-.23-.24-.23a.82.82,0,0,0-.28,0l-.3.13-.18-.25Z' })
  );
};

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Support */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Support = function Support(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Support' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M15,23 L15,17 M9,23 L9,17 M15,7 L15,1 M9,7 L9,1 M12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 Z M1,15 L7,15 M1,9 L7,9 M17,15 L23,15 M17,9 L23,9', transform: 'rotate(45 12 12)' })
  );
};

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Suse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Suse = function Suse(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Suse' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#7AC142', fillRule: 'evenodd', d: 'M24,8.28528691 C22.5804639,5.99050902 20.3366451,4.34898102 17.9130991,3.93053502 C15.8761713,3.57729259 12.1607377,3.53965483 10.1932153,7.25267133 C9.3714001,8.80307066 9.42181398,10.8206616 10.3230483,12.5212667 C11.241893,14.2615813 12.8841423,15.3796644 14.8274936,15.5927148 C16.7549611,15.8023122 18.2031515,15.3565292 19.0170248,14.3047439 C19.8367683,13.2419089 19.9887005,11.7961356 19.4075597,10.6179702 C18.7825658,9.35278909 17.8402407,8.68083428 16.531897,8.56964751 C15.5332879,8.48125058 14.7950354,8.8966471 14.5267369,9.32033084 C14.4504255,9.45292624 14.3098881,9.69739901 14.3085069,10.0565116 C14.3085069,11.0067786 15.1759018,11.2667899 15.3523504,11.2785301 C15.4062173,11.2764583 15.6676098,11.2712788 16.0139462,11.1839178 L16.1817623,11.1276338 L16.381346,11.0720404 C17.0132459,10.9570553 17.6199389,11.3299799 17.7970781,11.9439242 C17.8281551,12.0575281 17.8454202,12.1704413 17.8454202,12.2819734 C17.8454202,12.6897733 17.6375493,13.0709851 17.2138655,13.3534409 C17.0315468,13.4677354 16.8644214,13.5319613 16.6890087,13.5868641 C16.1928119,13.7481194 15.7546255,13.8227043 15.3157486,13.8227043 C13.8112742,13.8209778 11.7163359,12.5278274 11.6900931,10.0989835 C11.6759358,8.72779515 12.3627385,7.48091497 13.5747433,6.67705536 C14.9690668,5.75475767 17.377538,5.4419154 19.61474,6.81379436 C22.365404,8.4957532 23.0836291,11.7950997 22.365404,14.0447326 C21.3219058,17.3022977 18.3851249,19.0436482 14.5118889,18.6973118 C11.7667498,18.4531843 9.21705077,17.003958 7.70014558,14.8233852 C7.02715487,13.8575797 6.52888622,12.7805874 6.25920651,11.7042856 C5.63939208,9.24816303 6.26645782,6.6380364 6.73192292,5.48231556 C7.53228768,3.50084082 8.72510717,1.66935452 10.2982381,6.09512441e-14 L1.0005,-1.26217745e-29 C0.44775,-1.26217745e-29 0,0.44775 0,0.99975 L0,23.00025 C0,23.55225 0.44775,24 1.0005,24 L23.00025,24 C23.55225,24 24,23.55225 24,23.00025 L24,8.28528691 Z' })
  );
};

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Swift */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Swift = function Swift(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Swift' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#D15F3E', fillRule: 'evenodd', d: 'M18.1029473,21.0182797 C15.2758951,22.6513915 11.388774,22.8191853 7.4780286,21.143065 C4.31157263,19.7958689 1.6842374,17.43767 -1.77635684e-15,14.7432778 C0.808438798,15.4168759 1.7515972,15.9559966 2.76211541,16.4272729 C6.80079604,18.320253 10.8386286,18.1906218 13.6802189,16.432119 C13.6784016,16.4303017 13.6771901,16.4290902 13.6759786,16.4272729 C9.63378462,13.3282374 6.19795002,9.28604337 3.63803517,5.98529182 C3.09885386,5.44629224 2.69463446,4.77257305 2.29041506,4.16627424 C5.38939007,6.99574946 10.3075644,10.5660614 12.0587981,11.5770642 C8.35400892,7.6693475 5.05265163,2.81907816 5.18712893,2.95355547 C11.0484011,8.88206627 16.5056356,12.2506622 16.5056356,12.2506622 C16.6861501,12.3524288 16.8254735,12.4372343 16.9375379,12.5129535 C17.0556599,12.2124997 17.1592437,11.9005366 17.2464723,11.5770642 C18.1896307,8.14122958 17.1119949,4.23351289 14.7537961,1 C20.2104248,4.30105442 23.4445434,10.4988227 22.0967416,15.6864968 C22.0616079,15.8264259 22.0234454,15.9645377 21.9822542,16.1002266 C21.9980037,16.1190049 22.0137533,16.138389 22.0295029,16.1583789 C24.7238951,19.5269749 23.9830584,23.0972868 23.6462594,22.4236887 C22.1845759,19.5633201 19.4786744,20.4380283 18.1030079,21.0183403 L18.1029473,21.0182797 Z' })
  );
};

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Swim */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Swim = function Swim(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Swim' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M11,13 C11.5,13.5 13.1299859,12.8876287 14.2620192,12.5 C15.7222222,12 17.5,12.5 17,12 C15.3609614,10.3609614 15,10 15,10 C15,10 10.5,12.5 11,13 Z M2,20 C4,20 5,19 7,19 C9,19 10,20 12,20 C14,20 15,19 17,19 C19,19 20,20 22,20 M2,16 C4,16 5,15 7,15 C9,15 10,16 12,16 C14,16 15,15 17,15 C19,15 20,16 22,16 M17.5,4 L12.2222222,7 L15.5,10.5 L12,12 M19.2222222,10 C19.774507,10 20.2222222,9.55228475 20.2222222,9 C20.2222222,8.44771525 19.774507,8 19.2222222,8 C18.6699375,8 18.2222222,8.44771525 18.2222222,9 C18.2222222,9.55228475 18.6699375,10 19.2222222,10 Z' })
  );
};

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Sync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Sync = function Sync(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Sync' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,19 L16,19 C19.866,19 23,15.866 23,12 L23,9 M8,15 L4,19 L8,23 M19,5 L8,5 C4.134,5 1,8.134 1,12 L1,15 M16,1 L20,5 L16,9' })
  );
};

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export System */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var System = function System(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'System' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,19 L23,19 L23,1 L1,1 L1,19 Z M5,23 L19,23 L5,23 Z M8,23 L16,23 L16,19 L8,19 L8,23 Z M7.757,5.757 L9.879,7.879 L7.757,5.757 Z M9,10 L6,10 L9,10 Z M9.879,12.121 L7.757,14.243 L9.879,12.121 Z M12,13 L12,16 L12,13 Z M14.121,12.121 L16.243,14.243 L14.121,12.121 Z M18,10 L15,10 L18,10 Z M16.243,5.757 L14.121,7.879 L16.243,5.757 Z M12,7 L12,4 L12,7 Z M12,7 C10.343,7 9,8.343 9,10 C9,11.657 10.343,13 12,13 C13.657,13 15,11.657 15,10 C15,8.343 13.657,7 12,7 L12,7 Z' })
  );
};

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TableAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TableAdd = function TableAdd(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'TableAdd' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,5 L8,23 M16,5 L16,11 M1,11 L17,11 M1,5 L23,5 M1,17 L11,17 M17,23 L1,23 L1,1 L23,1 L23,17 M17,23 C20.3137085,23 23,20.3137085 23,17 C23,13.6862915 20.3137085,11 17,11 C13.6862915,11 11,13.6862915 11,17 C11,20.3137085 13.6862915,23 17,23 Z M17,14 L17,20 M17,14 L17,20 M14,17 L20,17' })
  );
};

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Table = function Table(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Table' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,5 L8,23 M16,5 L16,23 M1,11 L23,11 M1,5 L23,5 M1,17 L23,17 M1,1 L23,1 L23,23 L1,23 L1,1 Z' })
  );
};

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Tag = function Tag(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Tag' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M11.7058543,22.2941457 C11.3160217,22.6839783 10.6897542,22.6897542 10.2968194,22.2968194 L1.70318058,13.7031806 C1.31482467,13.3148247 1.32097101,12.679029 1.70585426,12.2941457 L13,1 L23,1 L23,11 L11.7058543,22.2941457 Z M6,12 L12,18 M9,9 L15,15 M17,6 C17,5.4475 17.4475,5 18,5 C18.5525,5 19,5.4475 19,6 C19,6.5525 18.5525,7 18,7 C17.4475,7 17,6.5525 17,6' })
  );
};

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TapeOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TapeOption = function TapeOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'TapeOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,2 L22,2 L22,22 L2,22 L2,7 M12,19 C8.13409091,19 5,15.8659091 5,12 M12,19 C15.8659091,19 19,15.8659091 19,12 C19,8.13409091 15.8659091,5 12,5 L1,5 M12,9 C10.3455,9 9,10.3455 9,12 C9,13.6545 10.3455,15 12,15 C13.6545,15 15,13.6545 15,12 C15,10.3455 13.6545,9 12,9 Z' })
  );
};

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Tape = function Tape(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Tape' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,2 L22,2 L22,22 L2,22 L2,2 Z M19,12 C19,15.8659091 15.8659091,19 12,19 C8.13409091,19 5,15.8659091 5,12 C5,8.13409091 8.13409091,5 12,5 C15.8659091,5 19,8.13409091 19,12 L19,12 Z M12,9 C10.3455,9 9,10.3455 9,12 C9,13.6545 10.3455,15 12,15 C13.6545,15 15,13.6545 15,12 C15,10.3455 13.6545,9 12,9 Z' })
  );
};

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Target */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Target = function Target(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Target' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M23,12 C23,18.075 18.075,23 12,23 C5.925,23 1,18.075 1,12 C1,5.925 5.925,1 12,1 C18.075,1 23,5.925 23,12 L23,12 Z M18,12 C18,8.691 15.309,6 12,6 C8.691,6 6,8.691 6,12 C6,15.309 8.691,18 12,18 C15.309,18 18,15.309 18,12 L18,12 Z M13,12 C13,11.448 12.552,11 12,11 C11.448,11 11,11.448 11,12 C11,12.552 11.448,13 12,13 C12.552,13 13,12.552 13,12 L13,12 Z' })
  );
};

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Task */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Task = function Task(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Task' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,20 L24,20 M12,12 L24,12 M12,4 L24,4 M1,19 L4,22 L9,17 M1,11 L4,14 L9,9 M9,1 L4,6 L1,3' })
  );
};

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tasks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Tasks = function Tasks(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Tasks' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,3 L23,3 L23,7 L1,7 L1,3 Z M1,10 L23,10 L23,14 L1,14 L1,10 Z M1,17 L23,17 L23,21 L1,21 L1,17 Z M1,4 L16,4 L16,6 L1,6 L1,4 Z M1,11 L6,11 L6,13 L1,13 L1,11 Z M1,18 L11,18 L11,20 L1,20 L1,18 Z' })
  );
};

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Technology */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Technology = function Technology(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Technology' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M16.5,19 C17.8807119,19 19,17.8807119 19,16.5 C19,15.1192881 17.8807119,14 16.5,14 C15.1192881,14 14,15.1192881 14,16.5 C14,17.8807119 15.1192881,19 16.5,19 Z M10,5 L12,3 M7.5,10 C8.88071187,10 10,8.88071187 10,7.5 C10,6.11928813 8.88071187,5 7.5,5 C6.11928813,5 5,6.11928813 5,7.5 C5,8.88071187 6.11928813,10 7.5,10 Z M8,16 L16,8 M5.5,21 C6.88071187,21 8,19.8807119 8,18.5 C8,17.1192881 6.88071187,16 5.5,16 C4.11928813,16 3,17.1192881 3,18.5 C3,19.8807119 4.11928813,21 5.5,21 Z M18.5,8 C19.8807119,8 21,6.88071187 21,5.5 C21,4.11928813 19.8807119,3 18.5,3 C17.1192881,3 16,4.11928813 16,5.5 C16,6.88071187 17.1192881,8 18.5,8 Z M12,21 L14,19' })
  );
};

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Template */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Template = function Template(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Template' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,3 L23,3 L23,21 L1,21 L1,3 Z M1,8 L23,8 M7,8 L7,21' })
  );
};

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Terminal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Terminal = function Terminal(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Terminal' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,5 L8,11 L2,17 M9,17 L23,17' })
  );
};

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TestDesktop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TestDesktop = function TestDesktop(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'TestDesktop' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M18.218,1 L23,1 L23,19 L1,19 L1,1 L6,1 M16.9999996,9.99999996 C13,6.99999996 11,13 7.00000002,9.99999996 M5,23 L19,23 L5,23 Z M10,1 L10,5.773 L5,12.955 L5,15 L19,15 L19,12.955 L14,5.773 L14,1 M8,1 L16,1 L8,1 Z M8,23 L16,23 L16,19 L8,19 L8,23 Z' })
  );
};

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Test */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Test = function Test(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Test' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8.9997,0.99999995 L8.9997,8.0003 L1.9997,20.0003 L1.9997,23.0003 L21.9997,23.0003 L21.9997,20.0003 L14.9997,8.0003 L14.9997,0.99999995 M15,18 C15.5522847,18 16,17.5522847 16,17 C16,16.4477153 15.5522847,16 15,16 C14.4477153,16 14,16.4477153 14,17 C14,17.5522847 14.4477153,18 15,18 Z M9,20 C9.55228475,20 10,19.5522847 10,19 C10,18.4477153 9.55228475,18 9,18 C8.44771525,18 8,18.4477153 8,19 C8,19.5522847 8.44771525,20 9,20 Z M18,13 C11,9.99999996 12,17.0000002 6,14 M5.9997,1.0003 L17.9997,1.0003' })
  );
};

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TextAlignCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TextAlignCenter = function TextAlignCenter(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'TextAlignCenter' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0.46', y: '3.06', width: '23.08', height: '2.18' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '4.1', y: '8.29', width: '15.81', height: '2.18' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0.46', y: '13.53', width: '23.08', height: '2.18' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '4.1', y: '18.76', width: '15.81', height: '2.18' })
  );
};

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TextAlignFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TextAlignFull = function TextAlignFull(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'TextAlignFull' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0.46', y: '3.06', width: '23.08', height: '2.18' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0.46', y: '8.29', width: '23.08', height: '2.18' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0.46', y: '13.53', width: '23.08', height: '2.18' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0.46', y: '18.76', width: '15.81', height: '2.18' })
  );
};

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TextAlignLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TextAlignLeft = function TextAlignLeft(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'TextAlignLeft' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0.46', y: '3.06', width: '23.08', height: '2.18' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0.46', y: '8.29', width: '15.81', height: '2.18' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0.46', y: '13.53', width: '23.08', height: '2.18' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0.46', y: '18.76', width: '15.81', height: '2.18' })
  );
};

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TextAlignRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TextAlignRight = function TextAlignRight(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'TextAlignRight' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0.46', y: '3.06', width: '23.08', height: '2.18' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '7.73', y: '8.29', width: '15.81', height: '2.18' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0.46', y: '13.53', width: '23.08', height: '2.18' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '7.73', y: '18.76', width: '15.81', height: '2.18' })
  );
};

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TextWrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TextWrap = function TextWrap(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'TextWrap' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17,10 L24,10 L17,10 L17,10 Z M1,14 L14,14 L14,2 L1,2 L1,14 Z M6,6 C6,6.5525 5.5525,7 5,7 C4.4475,7 4,6.5525 4,6 C4,5.4475 4.4475,5 5,5 C5.5525,5 6,5.4475 6,6 M17,6 L24,6 L17,6 L17,6 Z M17,2 L24,2 L17,2 L17,2 Z M17,14 L24,14 L17,14 L17,14 Z M0,18 L24,18 L0,18 L0,18 Z M0,22 L24,22 L0,22 L0,22 Z M14,14 L14,13 L10,8 L7,11 L6,10 L2,14 L14,14 Z' })
  );
};

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Threats */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Threats = function Threats(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Threats' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M9,23 C12.8659932,23 16,19.8659932 16,16 C16,12.1340068 12.8659932,9 9,9 C5.13400675,9 2,12.1340068 2,16 C2,19.8659932 5.13400675,23 9,23 Z M9,6 C9,6 9,8 9,5 C9,2 11,1 13,1 C15,1 17,2 17,5 L17,8 C17,9 17,11 19,11 C21,11 21,9 21,8 C21,6 22,6 23,6 M12,13 L6,19 M6,13 L12,19 M6,10 L6,6 L12,6 L12,10' })
  );
};

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ThreeDffects */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ThreeDffects = function ThreeDffects(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ThreeDffects' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '11 3 13 3 22 6 22 17 12 20.5 2 17 2 6.5 4 6 13 8.5 11 9 2 6.5' })
  );
};

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ThreeD */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ThreeD = function ThreeD(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ThreeD' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,5.5 L2,18.5 L12,22.5 L22,18.5 L22,5.5 L12,1.5 L2,5.5 Z M13,12 L18,12 L18,17 M2,5.5 L12,9.5 L22,5.5 M6,14 C6,14 12,20.5 18,12' })
  );
};

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Ticket */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Ticket = function Ticket(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Ticket' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,16 L17,16 L17,8 L7,8 L7,16 Z M20,12 C20,14 21,15 23,15 L23,20 L1,20 L1,15 C3,15 4,14 4,12 C4,10 3,9 1,9 L1,4 L23,4 L23,9 C21,9 20,10 20,12 Z' })
  );
};

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Tip = function Tip(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Tip' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16.0073529,18 L22,18 L22,2 L2,2 L2,18 L8.24264706,18 L12.125,22 L16.0073529,18 Z' })
  );
};

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Toast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Toast = function Toast(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Toast' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,2 C5.790861,2 4,3.790861 4,6 C4,7.48056471 4.80439726,8.77325238 6,9.46487122 L6,16 L18,16 L18,9.46487122 C19.1956027,8.77325238 20,7.48056471 20,6 C20,3.790861 18.209139,2 16,2 L8,2 Z M11.3212774,6.87413911 C11.600007,6.39136541 12.209917,6.22167659 12.700101,6.50468445 L14.4159244,7.49531555 C14.8986981,7.77404508 15.0683869,8.38395511 14.7853791,8.87413911 L13.794748,10.5899625 C13.5160184,11.0727362 12.9061084,11.242425 12.4159244,10.9594172 L10.700101,9.96878606 C10.2173273,9.69005654 10.0476385,9.0801465 10.3306463,8.58996251 L11.3212774,6.87413911 Z M8,18 L8,20 M12,18 L12,23 M16,18 L16,21' })
  );
};

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tools */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Tools = function Tools(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Tools' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M11,2 L22,13 L17.5,17.5 L6.5,6.5 L11,2 Z M16,6 L17,5 L19,7 L18,8 M13,13 L4,22 L2,20 L11,11 M5,18 L6,19' })
  );
};

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Tooltip = function Tooltip(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Tooltip' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16.5,18 L12,22.5 L7.5,18 L1,18 L1,1 L23,1 L23,18 L16.5,18 Z M6,10 L7,10 L7,9 L6,9 L6,10 Z M11.5,10 L12.5,10 L12.5,9 L11.5,9 L11.5,10 Z M17,10 L18,10 L18,9 L17,9 L17,10 Z' })
  );
};

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TopCorner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TopCorner = function TopCorner(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'TopCorner' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '4 16 16 16 16 4', transform: 'rotate(180 10 10)' })
  );
};

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Train */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Train = function Train(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Train' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,1 L19,1 L19,1 C20.1045695,1 21,1.8954305 21,3 L21,18 L21,18 C21,19.1045695 20.1045695,20 19,20 L5,20 L5,20 C3.8954305,20 3,19.1045695 3,18 L3,3 L3,3 C3,1.8954305 3.8954305,1 5,1 Z M9,2 L15,2 M3,5 L21,5 M4,23 L20,23 M3,12 L21,12 M7,17 C7.55228475,17 8,16.5522847 8,16 C8,15.4477153 7.55228475,15 7,15 C6.44771525,15 6,15.4477153 6,16 C6,16.5522847 6.44771525,17 7,17 Z M17,17 C17.5522847,17 18,16.5522847 18,16 C18,15.4477153 17.5522847,15 17,15 C16.4477153,15 16,15.4477153 16,16 C16,16.5522847 16.4477153,17 17,17 Z M12,5 L12,12 M9,20 L7,23 M15,20 L17,23' })
  );
};

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Transaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Transaction = function Transaction(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Transaction' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,7 L20,7 M16,2 L21,7 L16,12 M22,17 L4,17 M8,12 L3,17 L8,22' })
  );
};

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Trash; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Trash = function Trash(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Trash' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4,5 L20,5 L20,23 L4,23 L4,5 Z M1,5 L23,5 M9,1 L15,1 L15,5 L9,5 L9,1 Z M9,1 L15,1 L15,5 L9,5 L9,1 Z M15,9 L15,19 M9,9 L9,19' })
  );
};

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TreeOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TreeOption = function TreeOption(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'TreeOption' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,13 L11.375,6 L9,6 L12,2 L15,6 L12.625,6 L17,13 L15,13 L19,19.6666667 L5,19.6666667 L9,13 L7,13 Z M12,24 L12,20' })
  );
};

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Tree = function Tree(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Tree' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4,1 L10,1 L10,7 L4,7 L4,1 Z M16,11 L20,11 L20,15 L16,15 L16,11 Z M16,19 L20,19 L20,23 L16,23 L16,19 Z M7,7 L7,21 L16,21 M7,13 L16,13' })
  );
};

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Trigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Trigger = function Trigger(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Trigger' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '4 14 10 14 7 23 9 23 20 9 14 9 18 1 7 1' })
  );
};

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Trophy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Trophy = function Trophy(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Trophy' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,15 C8.686,15 6,12.314 6,9 L6,1 L18,1 L18,9 C18,12.314 15.314,15 12,15 Z M6,3 L1,3 L1,7 C1,9.509 2.791,11 5,11 L6,11 L6,3 Z M18,11 L19,11 C21.209,11 23,9.509 23,7 L23,3 L18,3 L18,11 Z M5,23 L19,23 L19,19 L5,19 L5,23 Z M16,19 C16,16.790861 14.209139,15 12,15 C9.790861,15 8,16.790861 8,19' })
  );
};

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Troubleshoot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Troubleshoot = function Troubleshoot(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Troubleshoot' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,5 C1,3.00000024 2,1 3,1 C3,1 5,5 5,5 L7,5 C7,5 9,1 9,1 C10,1 11,3.00000006 11,5 C11,7.25400025 10,9.0000003 8,10 L8,21 C8,22 8,23 6,23 C4,23 4,22 4,21 L4,10 C2,9.0000003 1,7.25400042 1,5 Z M19,12 L19,18 M17,18 L18,23 L20,23 L21,18 L17,18 Z M14,12 L24,12 L14,12 Z M21,12 L21,3 C21,1.895 20.105,1 19,1 C17.895,1 17,1.895 17,3 L17,12' })
  );
};

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Tty = function Tty(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Tty' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeWidth: '2', d: 'M7,19 L17,19 L17,19 C17.5522847,19 18,19.4477153 18,20 L18,20 L18,20 C18,20.5522847 17.5522847,21 17,21 L7,21 L7,21 C6.44771525,21 6,20.5522847 6,20 L6,20 L6,20 C6,19.4477153 6.44771525,19 7,19 Z M7,10 C7.55228475,10 8,9.55228475 8,9 C8,8.44771525 7.55228475,8 7,8 C6.44771525,8 6,8.44771525 6,9 C6,9.55228475 6.44771525,10 7,10 Z M7,5 C7.55228475,5 8,4.55228475 8,4 C8,3.44771525 7.55228475,3 7,3 C6.44771525,3 6,3.44771525 6,4 C6,4.55228475 6.44771525,5 7,5 Z M7,15 C7.55228475,15 8,14.5522847 8,14 C8,13.4477153 7.55228475,13 7,13 C6.44771525,13 6,13.4477153 6,14 C6,14.5522847 6.44771525,15 7,15 Z M12,10 C12.5522847,10 13,9.55228475 13,9 C13,8.44771525 12.5522847,8 12,8 C11.4477153,8 11,8.44771525 11,9 C11,9.55228475 11.4477153,10 12,10 Z M12,5 C12.5522847,5 13,4.55228475 13,4 C13,3.44771525 12.5522847,3 12,3 C11.4477153,3 11,3.44771525 11,4 C11,4.55228475 11.4477153,5 12,5 Z M12,15 C12.5522847,15 13,14.5522847 13,14 C13,13.4477153 12.5522847,13 12,13 C11.4477153,13 11,13.4477153 11,14 C11,14.5522847 11.4477153,15 12,15 Z M17,10 C17.5522847,10 18,9.55228475 18,9 C18,8.44771525 17.5522847,8 17,8 C16.4477153,8 16,8.44771525 16,9 C16,9.55228475 16.4477153,10 17,10 Z M17,5 C17.5522847,5 18,4.55228475 18,4 C18,3.44771525 17.5522847,3 17,3 C16.4477153,3 16,3.44771525 16,4 C16,4.55228475 16.4477153,5 17,5 Z M17,15 C17.5522847,15 18,14.5522847 18,14 C18,13.4477153 17.5522847,13 17,13 C16.4477153,13 16,13.4477153 16,14 C16,14.5522847 16.4477153,15 17,15 Z' })
  );
};

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tumblr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Tumblr = function Tumblr(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Tumblr' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#35465C', fillRule: 'evenodd', d: 'M17.6389798,19.1699694 C17.1927306,19.3822191 16.3392319,19.5682188 15.7024829,19.5847188 C13.781736,19.6357187 13.4089866,18.2354709 13.3924866,17.2184725 L13.3924866,9.74773446 L18.2119789,9.74773446 L18.2119789,6.11399025 L13.4104866,6.11399025 L13.4104866,0 L9.8944922,0 C9.83674229,0 9.73624245,0.0509999187 9.72199247,0.179999713 C9.5164928,2.05124673 8.6404942,5.33474149 5,6.6472394 L5,9.74773446 L7.42849613,9.74773446 L7.42849613,17.588972 C7.42849613,20.2739677 9.40924297,24.0877116 14.6374846,23.9984617 C16.4014818,23.9677118 18.3597287,23.229713 18.793228,22.592964 L17.6389798,19.1699694 Z' })
  );
};

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Turbolinux */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Turbolinux = function Turbolinux(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Turbolinux' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#528DC4', fillRule: 'evenodd', d: 'M9.41886316,6.22224 L9.96581053,7.45268211 L6.61541053,7.45268211 L6,6.22224 L9.41886316,6.22224 Z M13.1110105,12.1706526 L7.09383158,0 L14.1364421,4.17056842 L14.5465895,6.15397895 L17.8971158,6.15397895 L17.1449053,8.20509474 L14.9569895,8.20509474 L16.7346316,16.4785263 L12.5636842,14.4267789 L14.6833895,24 L8.18785263,10.8034105 L13.1110105,12.1706526 Z' })
  );
};

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Twitter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Twitter = function Twitter(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Twitter' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#1DA1F2', fillRule: 'evenodd', d: 'M24,4.3086 C23.117,4.7006 22.168,4.9646 21.172,5.0836 C22.188,4.4746 22.969,3.5096 23.337,2.3596 C22.386,2.9246 21.332,3.3336 20.21,3.5556 C19.312,2.5976 18.032,1.9996 16.616,1.9996 C13.897,1.9996 11.692,4.2046 11.692,6.9236 C11.692,7.3096 11.736,7.6856 11.82,8.0456 C7.728,7.8406 4.099,5.8806 1.671,2.9006 C1.247,3.6286 1.004,4.4736 1.004,5.3766 C1.004,7.0846 1.873,8.5926 3.195,9.4756 C2.388,9.4486 1.628,9.2276 0.964,8.8596 L0.964,8.9206 C0.964,11.3066 2.661,13.2966 4.914,13.7486 C4.501,13.8626 4.065,13.9216 3.617,13.9216 C3.299,13.9216 2.991,13.8906 2.69,13.8336 C3.317,15.7896 5.135,17.2136 7.29,17.2536 C5.604,18.5736 3.481,19.3606 1.175,19.3606 C0.777,19.3606 0.385,19.3376 0,19.2926 C2.179,20.6886 4.767,21.5046 7.548,21.5046 C16.605,21.5046 21.557,14.0016 21.557,7.4946 C21.557,7.2816 21.552,7.0696 21.543,6.8586 C22.505,6.1636 23.34,5.2966 24,4.3086' })
  );
};

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Ubuntu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Ubuntu = function Ubuntu(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Ubuntu' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#DD4814', fillRule: 'evenodd', d: 'M24,12.000127 C24,18.6272309 18.6273155,23.9999153 11.999873,23.9999153 C5.37243046,23.9999153 0,18.6273155 0,12.000127 C0,5.37251513 5.37234579,0 11.9997883,0 C18.6272309,0 24,5.37251513 24,12.000127 L24,12.000127 Z M3.84013547,10.3980668 C2.95511615,10.3980668 2.23799058,11.1151924 2.23799058,12.0002117 C2.23799058,12.8848923 2.95511615,13.6021026 3.84013547,13.6021026 C4.72481611,13.6021026 5.44202635,12.8848923 5.44202635,12.0002117 C5.44202635,11.1151077 4.72490078,10.3980668 3.84013547,10.3980668 L3.84013547,10.3980668 Z M15.2791773,17.6795583 C14.5128605,18.121941 14.2505636,19.1013635 14.6927769,19.8673416 C15.1352442,20.6336585 16.114582,20.8961247 16.8808989,20.4537421 C17.6469617,20.0114441 17.909428,19.0320216 17.4670453,18.2657894 C17.0247473,17.4998113 16.0452402,17.2372603 15.2791773,17.6795583 L15.2791773,17.6795583 Z M7.32009948,11.9999577 C7.32009948,10.4166088 8.10690561,9.01808689 9.31010178,8.17125218 L8.1388249,6.20927451 C6.73674704,7.14602508 5.69382463,8.57807489 5.26058596,10.255319 C5.76663786,10.6678144 6.08997936,11.2959554 6.08997936,12.000127 C6.08997936,12.7041293 5.76663786,13.3322703 5.2605013,13.744681 C5.6936553,15.4220944 6.73666237,16.8541443 8.13874023,17.7908102 L9.31010178,15.8286632 C8.10690561,14.9819978 7.32009948,13.5835606 7.32009948,11.9999577 L7.32009948,11.9999577 Z M12.0000423,7.32001482 C14.4449579,7.32001482 16.4504542,9.19461662 16.6606812,11.5849223 L18.9439684,11.5515637 C18.8316159,9.78677438 18.0607271,8.20198614 16.8759882,7.03722858 C16.2668971,7.26735223 15.5632336,7.23246962 14.9550738,6.88127282 C14.3461521,6.52973736 13.964052,5.93673293 13.8594042,5.29318258 C13.2674157,5.12935283 12.6443547,5.04002963 12.000127,5.04002963 C10.8921807,5.04002963 9.84544829,5.30012524 8.91564038,5.7607112 L10.0286667,7.75545482 C10.6278518,7.47664791 11.2955321,7.32001482 12.0000423,7.32001482 L12.0000423,7.32001482 Z M12.0000423,16.6799852 C11.2954474,16.6799852 10.6278518,16.5233521 10.028582,16.2445452 L8.91538638,18.2394581 C9.84527896,18.6998748 10.892096,18.960055 12.0000423,18.960055 C12.64427,18.960055 13.2673311,18.8707318 13.8594042,18.7069021 C13.964052,18.0633517 14.3462367,17.4703473 14.9552432,17.1185578 C15.5634029,16.7675304 16.2670665,16.7326478 16.8761576,16.9628561 C18.0608117,15.7980139 18.8317006,14.2132256 18.9438837,12.4484363 L16.6605965,12.4150777 C16.4505389,14.805722 14.4449579,16.6799852 12.0000423,16.6799852 L12.0000423,16.6799852 Z M15.2789233,6.32027234 C16.0451555,6.76282433 17.0246627,6.5002734 17.466876,5.73429524 C17.9093433,4.96797841 17.6470464,3.98855591 16.8807295,3.54608858 C16.114582,3.10379059 15.1351595,3.36625686 14.6926922,4.13257369 C14.2503942,4.89855185 14.5128605,5.87805902 15.2789233,6.32027234 L15.2789233,6.32027234 Z' })
  );
};

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Underline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Underline = function Underline(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Underline' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M14.41,4.53V4.18h4.66v.36h-.49a1.34,1.34,0,0,0-1.19.65,3,3,0,0,0-.2,1.4v5.33A9.45,9.45,0,0,1,16.78,15a3.85,3.85,0,0,1-1.54,1.87,5.49,5.49,0,0,1-3.13.78,5.89,5.89,0,0,1-3.27-.75,4,4,0,0,1-1.58-2A11.14,11.14,0,0,1,7,11.64V6.5a2.58,2.58,0,0,0-.33-1.59,1.38,1.38,0,0,0-1.08-.38H5V4.18h5.68v.36h-.5A1.3,1.3,0,0,0,9.06,5,2.87,2.87,0,0,0,8.81,6.5v5.73A12.52,12.52,0,0,0,9,14a3.71,3.71,0,0,0,.51,1.54,2.77,2.77,0,0,0,1.06.91,3.68,3.68,0,0,0,1.7.36,4.69,4.69,0,0,0,2.31-.56,3,3,0,0,0,1.39-1.44,8.33,8.33,0,0,0,.37-3V6.5A2.72,2.72,0,0,0,16,5a1.43,1.43,0,0,0-1.12-.43Z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M4.93,20V19H19v1Z' })
  );
};

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Undo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Undo = function Undo(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Undo' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M7.18,4,8.6,5.44,6.06,8h9.71a6,6,0,0,1,0,12h-2V18h2a4,4,0,0,0,0-8H6.06L8.6,12.51,7.18,13.92,2.23,9Z' })
  );
};

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Unlink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Unlink = function Unlink(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Unlink' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17,11 L21.5856815,15.5856815 C22.366788,16.366788 22.3692352,17.6307648 21.5856815,18.4143185 L18.4143185,21.5856815 C17.633212,22.366788 16.3692352,22.3692352 15.5856815,21.5856815 L11,17 M17,8 L21,8 M16,7 L16,3 M8,21 L8,17 M3,16 L7,16 M7,13 L2.4143185,8.4143185 C1.63321196,7.63321196 1.63076481,6.36923519 2.4143185,5.5856815 L5.5856815,2.4143185 C6.36678804,1.63321196 7.63076481,1.63076481 8.4143185,2.4143185 L13,7' })
  );
};

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Unlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Unlock = function Unlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Unlock' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M23,23 L23,11 L9,11 L9,23 L23,23 Z M14,17 L18,17 M11,11 L11,7 C11,4 11,1 6,1 C1,1 1,4 1,7 L1,11' })
  );
};

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UnorderedList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var UnorderedList = function UnorderedList(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'UnorderedList' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '5.94', y: '6.42', width: '18.06', height: '1.75' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '5.94', y: '11.71', width: '18.06', height: '1.75' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '5.94', y: '16.99', width: '18.06', height: '1.75' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: '1.85', cy: '7.29', r: '1.52' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: '1.85', cy: '12.58', r: '1.52' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: '1.85', cy: '17.87', r: '1.52' })
  );
};

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Up */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Up = function Up(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Up' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7.086 1.174 17.086 11.174 7.086 21.174', transform: 'rotate(-89 12.086 11.174)' })
  );
};

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Update */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Update = function Update(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Update' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1.7507,16.0022 C3.3517,20.0982 7.3367,23.0002 11.9997,23.0002 C18.0747,23.0002 22.9997,18.0752 22.9997,12.0002 M22.2497,7.9982 C20.6487,3.9012 16.6627,1.0002 11.9997,1.0002 C5.9247,1.0002 0.9997,5.9252 0.9997,12.0002 M8.9997,16.0002 L0.9997,16.0002 L0.9997,24.0002 M22.9997,0.0002 L22.9997,8.0002 L14.9997,8.0002' })
  );
};

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Upgrade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Upgrade = function Upgrade(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Upgrade' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,18 L12,8 L12,18 Z M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M17,12 L12,7 L7,12' })
  );
};

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Upload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Upload = function Upload(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Upload' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,17 L1,23 L23,23 L23,17 M12,2 L12,19 M5,9 L12,2 L19,9' })
  );
};

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var UserAdd = function UserAdd(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'UserAdd' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,24 L5,19 M11,24 L11,19 M1,24 L1,18 C1,13.0294373 4.13400675,11 8,11 C11.8659932,11 15,13 15,18 L15,24 M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z M16,11 L24,11 M20,7 L20,15' })
  );
};

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserAdmin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var UserAdmin = function UserAdmin(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'UserAdmin' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z M13.0233822,13.0234994 C11.7718684,11.7594056 10.0125018,11 8,11 C4,11 1,14 1,18 L1,23 L8,23 M10,19.5 C10,20.88 11.12,22 12.5,22 C13.881,22 15,20.88 15,19.5 C15,18.119 13.881,17 12.5,17 C11.12,17 10,18.119 10,19.5 L10,19.5 Z M23,15 L20,12 L14,18 M17.5,14.5 L20.5,17.5 L17.5,14.5 Z' })
  );
};

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserExpert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var UserExpert = function UserExpert(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'UserExpert' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z M14.6431888,15.6961461 C14.3091703,14.6675626 13.7524493,13.7598949 13.0233822,13.0234994 C11.7718684,11.7594056 10.0125018,11 8,11 C4,11 1,14 1,18 L1,23 L11,23 M12,18.8235294 L16.1904762,22 L23,13' })
  );
};

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserFemale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var UserFemale = function UserFemale(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'UserFemale' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M20,24 L20,19 C19.9999999,15 15.9403581,14 15,14 C18.9475,14 20,12 20,12 C20,12 16.942739,10.031 17,6 C16.942739,3 14.8497684,1 12,1 C9.01190309,1 6.91893246,3 7,6 C6.91893246,9.969 4,12 4,12 C4,12 4.91417116,14 9,14 C7.92131306,14 4,15 4,19 L4,24 M16,19 L16,24 M8,19 L8,24' })
  );
};

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var UserManager = function UserManager(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'UserManager' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,12 C18.3736719,13.1826446 20,15.6506255 20,19 L20,23 L4,23 L4,19 C4,15.6457258 5.6310898,13.1754259 8,12 M12,13 C15.3137085,13 18,10.3137085 18,7 C18,3.6862915 15.3137085,1 12,1 C8.6862915,1 6,3.6862915 6,7 C6,10.3137085 8.6862915,13 12,13 Z M18,7 C16.5,7 15,7.3599999 13,5 C11,7.3599999 8.5,8 6,7 M7,13 L12.0249378,18.2571942 L17,13 M12,18 L12,23' })
  );
};

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var UserNew = function UserNew(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'UserNew' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M18,24 L18,12 M23,22 L13,15 M23,15 L13,22 M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z M13.0233822,13.0234994 C11.7718684,11.7594056 10.0125018,11 8,11 C4,11 1,14 1,18 L1,23 L11,23' })
  );
};

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserPolice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var UserPolice = function UserPolice(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'UserPolice' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,14 C18.3736719,15.1826446 20,17.6506255 20,21 L20,23 L4,23 L4,21 C4,17.6457258 5.6310898,15.1754259 8,14 M12,15 C15.2602409,15 17.9031883,12.3141492 17.9031883,9.00098429 C17.9031883,8.29933805 18.1210147,7.62582606 17.9031883,7 M6.09318017,7 C5.88352479,7.61511425 6.09318017,8.31344562 6.09318017,9.00098429 C6.09318017,12.3141492 8.73775349,15 12,15 L12,15 M6,8 L18,8 L21,4 C19.0884181,2.26537447 15.7904958,1 12,1 C8.16364606,1 4.83185613,2.29617718 3,4 L6,8 L6,8 L6,8 Z M12,5 C12.5522847,5 13,4.55228475 13,4 C13,4 11,4 11,4 C11,4.55228475 11.4477153,5 12,5 L12,5 L12,5 Z' })
  );
};

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserSettings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var UserSettings = function UserSettings(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'UserSettings' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M18.0003,20.9998 C16.3453,20.9998 15.0003,19.6538 15.0003,17.9998 C15.0003,16.3458 16.3453,14.9998 18.0003,14.9998 C19.6543,14.9998 21.0003,16.3458 21.0003,17.9998 C21.0003,19.6538 19.6543,20.9998 18.0003,20.9998 L18.0003,20.9998 Z M24.0003,17.9998 L21.0003,17.9998 L24.0003,17.9998 Z M20.1213,20.1218 L22.2423,22.2428 L20.1213,20.1218 Z M18.0003,23.9998 L18.0003,20.9998 L18.0003,23.9998 Z M13.7573,22.2428 L15.8783,20.1208 L13.7573,22.2428 Z M12.0003,17.9998 L15.0003,17.9998 L12.0003,17.9998 Z M15.8783,15.8788 L13.7573,13.7578 L15.8783,15.8788 Z M18.0003,14.9998 L18.0003,11.9998 L18.0003,14.9998 Z M20.1213,15.8788 L22.2423,13.7578 L20.1213,15.8788 Z M12.5,12.5 C11.2660678,11.4458897 9.77508483,11 8,11 C4.13400675,11 1,13.0294373 1,18 L1,23 L11,23 M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z' })
  );
};

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserWorker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var UserWorker = function UserWorker(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'UserWorker' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,6 L21,6 L3,6 Z M10,2 L10,4 M14,2 L14,4 M16,12 C18.3736719,13.1826446 20,15.6506255 20,19 L20,23 L4,23 L4,19 C4,15.6457258 5.6310898,13.1754259 8,12 M12,16.5 L12,23 M12,13 C15.3137085,13 18,10.3137085 18,7 C18,3.6862915 15.3137085,1 12,1 C8.6862915,1 6,3.6862915 6,7 C6,10.3137085 8.6862915,13 12,13 Z M8,12 C8,14.209139 9.790861,16 12,16 L12,16 C14.209139,16 16,14.209139 16,12' })
  );
};

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export User */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var User = function User(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'User' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,24 L8,19 M16,24 L16,19 M3,24 L3,19 C3,14.0294373 7.02943725,11 12,11 C16.9705627,11 21,14.0294373 21,19 L21,24 M12,11 C14.7614237,11 17,8.76142375 17,6 C17,3.23857625 14.7614237,1 12,1 C9.23857625,1 7,3.23857625 7,6 C7,8.76142375 9.23857625,11 12,11 Z' })
  );
};

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Validate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Validate = function Validate(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Validate' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M20,15 C19,16 21.25,18.75 20,20 C18.75,21.25 16,19 15,20 C14,21 13.5,23 12,23 C10.5,23 10,21 9,20 C8,19 5.25,21.25 4,20 C2.75,18.75 5,16 4,15 C3,14 1,13.5 1,12 C1,10.5 3,10 4,9 C5,8 2.75,5.25 4,4 C5.25,2.75 8,5 9,4 C10,3 10.5,1 12,1 C13.5,1 14,3 15,4 C16,5 18.75,2.75 20,4 C21.25,5.25 19,8 20,9 C21,10 23,10.5 23,12 C23,13.5 21,14 20,15 Z M7,12 L10,15 L17,8' })
  );
};

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Vend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Vend = function Vend(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Vend' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,2.00246167 C3,1.44881738 3.44494629,1 3.99339768,1 L20.0066023,1 C20.5552407,1 21,1.43945834 21,2.00246167 L21,23 L3,23 L3,2.00246167 Z M15,1 L15,23 M3,16 L15,16 M8,17 L10,17 M7,16 L7,12 M7,9 L7,5 M11,16 L11,12 M11,9 L11,5 M17,12 L18,12 M17,9 L19,8.99999994 M17,20 L19,19.9999999 M3,9 L15,9' })
  );
};

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Video */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Video = function Video(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Video' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,9 L23,5 L23,19 L15,15 L15,9 Z M1,5 L15,5 L15,19 L1,19 L1,5 Z' })
  );
};

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export View */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var View = function View(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'View' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,21 C7,21 1,16 1,12 C1,8 7,3 12,3 C17,3 23,8 23,12 C23,16 17,21 12,21 Z M12,7 C9.23875,7 7,9.23875 7,12 C7,14.76125 9.23875,17 12,17 C14.76125,17 17,14.76125 17,12 C17,9.23875 14.76125,7 12,7 L12,7 Z' })
  );
};

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Vimeo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Vimeo = function Vimeo(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Vimeo' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#1AB7EA', fillRule: 'evenodd', d: 'M23.9883358,6.80210856 C23.8810843,9.13839127 22.2498115,12.336436 19.0937673,16.3969929 C15.8304716,20.6368022 13.069683,22.7570819 10.8121514,22.7570819 C9.41263176,22.7570819 8.22836518,21.4663138 7.26160165,18.8840277 C6.61584261,16.5162445 5.97083358,14.1484614 5.32432453,11.7806783 C4.60581447,9.19914212 3.8363037,7.90687403 3.01204216,7.90687403 C2.83203964,7.90687403 2.20428086,8.28487932 1.12801579,9.03713985 L0,7.58286949 C1.18426658,6.54260493 2.35203292,5.50234037 3.50179902,4.45982578 C5.08132113,3.09555668 6.26858775,2.37779663 7.0583488,2.30504561 C8.92587495,2.1257931 10.075641,3.40231097 10.5068971,6.13459922 C10.9734036,9.08289049 11.2966581,10.9166662 11.4774107,11.6344262 C12.0166682,14.0809605 12.6091765,15.3027276 13.2556856,15.3027276 C13.7574426,15.3027276 14.5127032,14.5092164 15.5184672,12.9214442 C16.5234813,11.335172 17.0619888,10.1284051 17.1339898,9.2981435 C17.2779919,7.92937434 16.7394843,7.24311474 15.5184672,7.24311474 C14.9439592,7.24311474 14.3514509,7.37511658 13.7424424,7.63612024 C14.9222089,3.77356617 17.1752404,1.89778991 20.501537,2.0042914 C22.9675715,2.07704242 24.1308378,3.6760648 23.9883358,6.80210856' })
  );
};

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VirtualMachine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var VirtualMachine = function VirtualMachine(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'VirtualMachine' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,23 L14,23 L14,10 L1,10 L1,23 Z M10,19 L23,19 L23,6 L10,6 L10,19 Z M5,14 L18,14 L18,1 L5,1 L5,14 Z' })
  );
};

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VirtualStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var VirtualStorage = function VirtualStorage(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'VirtualStorage' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000000', strokeWidth: '2', d: 'M12,22 C16.9705627,22 21,19.7614237 21,17 C21,14.2385763 16.9705627,12 12,12 C7.02943725,12 3,14.2385763 3,17 C3,19.7614237 7.02943725,22 12,22 Z M12,17.5 C16.9705627,17.5 21,15.2614237 21,12.5 C21,9.73857625 16.9705627,7.5 12,7.5 C7.02943725,7.5 3,9.73857625 3,12.5 C3,15.2614237 7.02943725,17.5 12,17.5 Z M12,12 C16.9705627,12 21,9.76142375 21,7 C21,4.23857625 16.9705627,2 12,2 C7.02943725,2 3,4.23857625 3,7 C3,9.76142375 7.02943725,12 12,12 Z' })
  );
};

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Visa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Visa = function Visa(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Visa' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#1A1F71', fillRule: 'evenodd', d: 'M5.75604904,6.3421103 C4.34405863,5.55921989 2.73289927,4.92988052 0.93115208,4.49372953 L0.98977571,4.14310685 L8.39658295,4.14310685 C9.39421768,4.18029541 10.2006584,4.49872244 10.4787118,5.56582745 L12.0890953,13.309165 C12.0891819,13.3094435 12.0892685,13.3097219 12.0893551,13.3100003 L12.5685021,15.6453901 L17.065563,4.15352309 L21.9311521,4.15352309 L14.6996992,20.9731676 L9.8397917,20.9787631 L5.75604904,6.3421103 L5.75604904,6.3421103 Z' })
  );
};

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VmMaintenance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var VmMaintenance = function VmMaintenance(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'VmMaintenance' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M19,9.9999 L19,1.9999 L7,1.9999 L7,13.9999 L14,13.9999 L14,6.9999 L2,6.9999 L2,18.9999 L10,18.9999 M14,23 L20,17 M21,14 C19.8954305,14 19,14.8954305 19,16 C19,17.1045695 19.8954305,18 21,18 C22.1045695,18 23,17.1045695 23,16' })
  );
};

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Vmware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Vmware = function Vmware(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Vmware' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#879AC3', fillRule: 'evenodd', d: 'M5.57403651,0 C4.61501014,0 3.84584178,0.753590264 3.84584178,1.67951318 L3.84584178,7.42393509 L1.72819473,7.42393509 C0.769168365,7.42393486 0,8.18044625 0,9.10344828 L0,21.5415822 C0,22.4675058 0.769168357,23.2210953 1.72819473,23.2210953 L14.5801217,23.2210953 C15.5391481,23.2210946 16.3326572,22.4675051 16.3326572,21.5415822 L16.3326572,19.4969574 L22.2718053,19.4969574 C23.229858,19.4969582 24,18.7404462 24,17.8174442 L24,5.37931034 C24,4.45533461 23.229858,3.72413793 22.2718053,3.72413793 L20.1541582,3.72413793 L20.1541582,1.67951318 C20.1541582,0.753590287 19.3830426,0 18.4259635,0 L5.57403651,0 L5.57403651,0 Z M5.57403651,0.949290061 L18.4259635,0.949290061 C18.8455976,0.949290139 19.1805274,1.2725355 19.1805274,1.67951318 L19.1805274,3.72413793 L9.4198783,3.72413793 C8.46279919,3.72413785 7.6673428,4.45533469 7.6673428,5.37931034 L7.6673428,7.42393509 L4.81947262,7.42393509 L4.81947262,1.67951318 C4.81947246,1.2725355 5.15148073,0.949290061 5.57403651,0.949290061 L5.57403651,0.949290061 Z M9.4198783,4.64908722 L19.1805274,4.64908722 L19.1805274,14.0933063 C19.1805274,14.5002848 18.8455984,14.8478702 18.4259635,14.8478702 L16.3326572,14.8478702 L16.3326572,9.10344828 C16.332658,8.18044625 15.5391481,7.42393509 14.5801217,7.42393509 L8.64097363,7.42393509 L8.64097363,5.37931034 C8.64097363,4.97330621 9.00024341,4.64908722 9.4198783,4.64908722 L9.4198783,4.64908722 Z M20.1541582,4.64908722 L22.2718053,4.64908722 C22.6924138,4.64908707 23.0263692,4.97330629 23.0263692,5.37931034 L23.0263692,17.8174442 C23.0263692,18.2234483 22.6924138,18.5476673 22.2718053,18.5476673 L16.3326572,18.5476673 L16.3326572,15.7971602 L18.4259635,15.7971602 C19.3830418,15.7971595 20.1541582,15.0192292 20.1541582,14.0933063 L20.1541582,4.64908722 L20.1541582,4.64908722 Z M1.72819473,8.37322515 L3.84584178,8.37322515 L3.84584178,14.0933063 C3.84584178,15.01923 4.61501014,15.7971602 5.57403651,15.7971602 L7.6673428,15.7971602 L7.6673428,17.8174442 C7.66734295,18.7404462 8.46279919,19.4969574 9.4198783,19.4969574 L15.3590264,19.4969574 L15.3590264,21.5415822 C15.3590271,21.947587 15.0026775,22.2718053 14.5801217,22.2718053 L1.72819473,22.2718053 C1.30271805,22.2718045 0.973630832,21.9475862 0.973630832,21.5415822 L0.973630832,9.10344828 C0.97363091,8.69841785 1.30271805,8.37322515 1.72819473,8.37322515 L1.72819473,8.37322515 Z M4.81947262,8.37322515 L7.6673428,8.37322515 L7.6673428,14.8478702 L5.57403651,14.8478702 C5.15148073,14.8478702 4.81947262,14.500284 4.81947262,14.0933063 L4.81947262,8.37322515 L4.81947262,8.37322515 Z M8.64097363,8.37322515 L14.5801217,8.37322515 C15.0026775,8.37322515 15.3590264,8.69841785 15.3590264,9.10344828 L15.3590264,14.8478702 L8.64097363,14.8478702 L8.64097363,8.37322515 L8.64097363,8.37322515 Z M8.64097363,15.7971602 L15.3590264,15.7971602 L15.3590264,18.5476673 L9.4198783,18.5476673 C9.00024341,18.5476673 8.64097363,18.2234483 8.64097363,17.8174442 L8.64097363,15.7971602 L8.64097363,15.7971602 Z' })
  );
};

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VolumeControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var VolumeControl = function VolumeControl(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'VolumeControl' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 Z M8,8 L11,11 M12,22 C15.4612937,22 18.5118579,20.2414583 20.3069882,17.5690793 C21.3761716,15.9774047 22,14.0615538 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12' })
  );
};

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VolumeLow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var VolumeLow = function VolumeLow(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'VolumeLow' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,8 L1,16 L6.09901951,16 L12,21 L12,3 L6,8 L1,8 Z M15,16 L15,16 C17.209139,16 19,14.209139 19,12 C19,9.790861 17.209139,8 15,8' })
  );
};

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VolumeMute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var VolumeMute = function VolumeMute(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'VolumeMute' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,8 L1,16 L6.09901951,16 L12,21 L12,3 L6,8 L1,8 Z M15,9 L21,15 M21,9 L15,15' })
  );
};

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Volume */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Volume = function Volume(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Volume' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,16 C17.209,16 19,14.209 19,12 C19,9.791 17.209,8 15,8 M15,20 C20,20 23,16.411 23,12 C23,7.589 19.411,4 15,4 M1,12 L1,8 L6,8 L12,3 L12,21 L6,16 L1,16 L1,12' })
  );
};

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Vulnerability */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Vulnerability = function Vulnerability(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Vulnerability' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,0 L12,24 L12,0 Z M0,12 L24,12 L0,12 Z M17,12 C17,9.243 14.757,7 12,7 C9.243,7 7,9.243 7,12 C7,14.757 9.243,17 12,17 C14.757,17 17,14.757 17,12 L17,12 Z M12,21 C7.038,21 3,16.963 3,12 C3,7.037 7.038,3 12,3 C16.962,3 21,7.037 21,12 C21,16.963 16.962,21 12,21 L12,21 Z' })
  );
};

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Waypoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Waypoint = function Waypoint(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Waypoint' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '3 11 11 13 13 21 21 3' })
  );
};

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WheelchairActive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var WheelchairActive = function WheelchairActive(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'WheelchairActive' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M7,6 L10,3 L17,6 L17,8 L14,11 M9,22 C12.3137085,22 15,19.3137085 15,16 C15,12.6862915 12.3137085,10 9,10 C5.6862915,10 3,12.6862915 3,16 C3,19.3137085 5.6862915,22 9,22 Z M9,17 C9.55228475,17 10,16.5522847 10,16 C10,15.4477153 9.55228475,15 9,15 C8.44771525,15 8,15.4477153 8,16 C8,16.5522847 8.44771525,17 9,17 Z M14,12 L19,15 L17,21 M19,4 C19.5522847,4 20,3.55228475 20,3 C20,2.44771525 19.5522847,2 19,2 C18.4477153,2 18,2.44771525 18,3 C18,3.55228475 18.4477153,4 19,4 Z M13,10 L17,6 M11,10 L15,6' })
  );
};

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Wheelchair */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Wheelchair = function Wheelchair(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Wheelchair' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M10,3 L10,12 L17,12 L19,18 L21,18 M15,9 L9,9 C5.6862915,9 3,11.6862915 3,15 C3,18.3137085 5.6862915,21 9,21 C12.3137085,21 15,18.3137085 15,15 M11,4 C11.5522847,4 12,3.55228475 12,3 C12,2.44771525 11.5522847,2 11,2 C10.4477153,2 10,2.44771525 10,3 C10,3.55228475 10.4477153,4 11,4 Z' })
  );
};

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WifiLow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var WifiLow = function WifiLow(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'WifiLow' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { stroke: '#000', strokeWidth: '2', d: 'M12,20 C13.1045695,20 14,19.1045695 14,18 C14,16.8954305 13.1045695,16 12,16 C10.8954305,16 10,16.8954305 10,18 C10,19.1045695 10.8954305,20 12,20 Z M7.75735931,13.7573593 C10.1005051,11.4142136 13.8994949,11.4142136 16.2426407,13.7573593' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { stroke: '#000', strokeOpacity: '.2', strokeWidth: '2', d: 'M4.92893219,10.9289322 C8.83417511,7.02368927 15.1658249,7.02368927 19.0710678,10.9289322 M2.10050506,8.10050506 C7.56784515,2.63316498 16.4321549,2.63316498 21.8994949,8.10050506', opacity: '.8' })
    )
  );
};

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WifiMedium */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var WifiMedium = function WifiMedium(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'WifiMedium' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { stroke: '#000', strokeWidth: '2', d: 'M12,20 C13.1045695,20 14,19.1045695 14,18 C14,16.8954305 13.1045695,16 12,16 C10.8954305,16 10,16.8954305 10,18 C10,19.1045695 10.8954305,20 12,20 Z M7.75735931,13.7573593 C10.1005051,11.4142136 13.8994949,11.4142136 16.2426407,13.7573593 M4.92893219,10.9289322 C8.83417511,7.02368927 15.1658249,7.02368927 19.0710678,10.9289322' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { stroke: '#000', strokeOpacity: '.2', strokeWidth: '2', d: 'M2.10050506,8.10050506 C7.56784515,2.63316498 16.4321549,2.63316498 21.8994949,8.10050506', opacity: '.8' })
    )
  );
};

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WifiNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var WifiNone = function WifiNone(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'WifiNone' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: '12', cy: '18', r: '2', stroke: '#000', strokeWidth: '2' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { stroke: '#000', strokeOpacity: '.2', strokeWidth: '2', d: 'M7.75735931,13.7573593 C10.1005051,11.4142136 13.8994949,11.4142136 16.2426407,13.7573593 M4.92893219,10.9289322 C8.83417511,7.02368927 15.1658249,7.02368927 19.0710678,10.9289322 M2.10050506,8.10050506 C7.56784515,2.63316498 16.4321549,2.63316498 21.8994949,8.10050506', opacity: '.8' })
    )
  );
};

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Wifi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Wifi = function Wifi(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Wifi' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,20 C13.1045695,20 14,19.1045695 14,18 C14,16.8954305 13.1045695,16 12,16 C10.8954305,16 10,16.8954305 10,18 C10,19.1045695 10.8954305,20 12,20 Z M7.75735931,13.7573593 C10.1005051,11.4142136 13.8994949,11.4142136 16.2426407,13.7573593 M4.92893219,10.9289322 C8.83417511,7.02368927 15.1658249,7.02368927 19.0710678,10.9289322 M2.10050506,8.10050506 C7.56784515,2.63316498 16.4321549,2.63316498 21.8994949,8.10050506' })
  );
};

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WindowsLegacy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var WindowsLegacy = function WindowsLegacy(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'WindowsLegacy' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd', transform: 'translate(0 1)' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#F35325', d: 'M2.61341757,9.09629841 C2.7158178,8.7382976 2.805018,8.42456355 2.89541821,8.11136284 C3.56075305,5.80989096 4.22662122,3.50828575 4.8912894,1.2065472 C4.91715612,1.11628032 4.94488952,1.04348016 5.04795642,1.0020134 C6.19889236,0.54067902 7.37476169,0.176944863 8.61343117,0.0430778925 C10.2790349,-0.137189183 11.8078384,0.252278367 13.2198416,1.13694704 C13.4037087,1.25228063 13.5815758,1.37681425 13.7695762,1.48414783 C13.8894431,1.55294798 13.9063765,1.62561481 13.8678431,1.75601511 C13.3153085,3.65268607 12.7681072,5.55149038 12.2195727,7.44962801 C12.0282389,8.11136284 11.8315718,8.77229768 11.6463714,9.43629918 C11.6051713,9.58403285 11.5710379,9.60896624 11.4346376,9.51576603 C10.6210357,8.96309811 9.7627671,8.49949706 8.80209826,8.25256316 C7.58996218,7.94109579 6.3794261,8.00362927 5.1699567,8.26842987 C4.30822141,8.45709696 3.47768619,8.74189761 2.61341757,9.09629841' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#81BC06', d: 'M17.2771841,12.0252117 C15.748114,12.0356117 14.3994443,11.4986772 13.1433081,10.673742 C12.7882406,10.4397415 12.7886406,10.4422748 12.9053076,10.0392072 C13.6165092,7.58053497 14.3261108,5.12119607 15.0394457,2.66292383 C15.1090459,2.42198995 15.0575791,2.37798985 15.3281131,2.5593236 C16.2241151,3.15892495 17.1677172,3.65252607 18.2365196,3.8690599 C19.3649222,4.09746041 20.4851914,4.01946024 21.5987939,3.77025967 C22.2990622,3.61345932 22.9791971,3.39345882 23.6470652,3.13545823 C23.7433321,3.09852482 23.841999,3.03665801 23.9410659,3.12825822 C24.0378661,3.21772509 23.993066,3.31839198 23.9631993,3.42092555 C23.2499977,5.88613113 22.5371961,8.35133672 21.8289278,10.8178756 C21.7963944,10.9330759 21.7361276,10.9893427 21.629594,11.0320095 C20.4671914,11.4973439 19.2778553,11.8633447 18.0245192,11.982945 C17.7765186,12.0066783 17.5266514,12.0116117 17.2771841,12.0252117' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#FFBA08', d: 'M21.3774601,12.3517725 C21.2214597,12.8916403 21.0781261,13.3883081 20.9345258,13.8851093 C20.3333244,15.9657806 19.7294564,18.0467187 19.133855,20.1296567 C19.0849216,20.2995238 18.999188,20.3868573 18.8355877,20.4499241 C17.8101187,20.8453917 16.767183,21.1704591 15.6730472,21.3241928 C13.9798433,21.5615267 12.4050398,21.2415259 10.9429031,20.3605906 C10.7010359,20.2151236 10.4675687,20.0545899 10.2238348,19.9119229 C10.1034345,19.8412561 10.0921012,19.7668559 10.1301013,19.638989 C10.6530358,17.8428516 11.1705036,16.0445808 11.6902381,14.2472434 C11.9013053,13.5156418 12.1131724,12.7837734 12.3247729,12.0528384 C12.3922397,11.8223046 12.3930397,11.8233713 12.6042402,11.9623049 C13.3642419,12.4640394 14.1561104,12.8985737 15.0387791,13.1489743 C16.3118486,13.5093751 17.5858515,13.4499083 18.8613211,13.1671076 C19.7098563,12.9795072 20.5285248,12.6953732 21.3774601,12.3517725' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#05A6F0', d: 'M11.1789303,11.0465695 C11.0506634,11.4885705 10.9317298,11.8983048 10.8131962,12.3081724 C10.1897281,14.4641772 9.56425999,16.6203155 8.94679192,18.7783204 C8.8931918,18.9633874 8.84385836,18.9676541 8.69425802,18.8655205 C7.83718941,18.2809859 6.92972068,17.8009848 5.9074517,17.5680509 C4.74984908,17.3036503 3.5983798,17.3749838 2.44904386,17.6268511 C1.72917556,17.7844514 1.03050731,18.0113853 0.342905756,18.2757859 C0.252505551,18.3104526 0.159972008,18.3605861 0.0658384616,18.2835192 C-0.0394951104,18.1976524 0.00623832657,18.0928521 0.0351717255,17.9928519 C0.746506671,15.5340463 1.45837495,13.0755074 2.16810989,10.6163019 C2.19837663,10.5137683 2.24971008,10.4544348 2.35291031,10.4131014 C3.53371299,9.93803365 4.74171573,9.56909948 6.01571861,9.45123255 C7.58705551,9.30656555 9.0422588,9.66336636 10.3882619,10.4799015 C10.618129,10.6195019 10.8451962,10.7648355 11.0723967,10.9100359 C11.1302635,10.9475026 11.2103971,10.980036 11.1789303,11.0465695' })
    )
  );
};

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Windows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Windows = function Windows(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Windows' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#001589', fillRule: 'evenodd', d: 'M23.923,0 L10.959,1.893 L10.959,11.481 L23.923,11.379 L23.923,0 Z M0,3.398 L0.009,11.553 L9.782,11.498 L9.778,2.066 L0,3.398 Z M0.008,20.681 L9.781,22.025 L9.773,12.585 L0.007,12.522 L0.008,20.681 Z M10.959,22.171 L23.923,24 L23.927,12.674 L10.941,12.652 L10.959,22.171 Z' })
  );
};

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Wordpress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Wordpress = function Wordpress(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Wordpress' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#21759B', fillRule: 'evenodd', d: 'M0,11.99925 C0,16.749 2.76,20.85375 6.76275,22.7985 L1.03875,7.116 C0.3735,8.60775 0,10.25925 0,11.99925 M20.10015,11.394 C20.10015,9.9105 19.5669,8.88375 19.1109,8.085 C18.50265,7.09575 17.9319,6.25875 17.9319,5.27025 C17.9319,4.167 18.76815,3.14025 19.94715,3.14025 C20.0004,3.14025 20.05065,3.147 20.1024,3.15 C17.9679,1.194 15.12315,0 11.9994,0 C7.8069,0 4.11915,2.151 1.9734,5.40825 C2.2554,5.41725 2.5209,5.4225 2.7459,5.4225 C4.00065,5.4225 5.9439,5.27025 5.9439,5.27025 C6.5904,5.232 6.6669,6.183 6.0204,6.25875 C6.0204,6.25875 5.37015,6.33525 4.64715,6.3735 L9.01665,19.371 L11.64315,11.49525 L9.77415,6.3735 C9.12765,6.33525 8.5149,6.25875 8.5149,6.25875 C7.8684,6.2205 7.94415,5.232 8.5914,5.27025 C8.5914,5.27025 10.5729,5.4225 11.7519,5.4225 C13.00665,5.4225 14.9499,5.27025 14.9499,5.27025 C15.59715,5.232 15.6729,6.183 15.0264,6.25875 C15.0264,6.25875 14.3754,6.33525 13.65315,6.3735 L17.98965,19.272 L19.1874,15.273 C19.7049,13.6125 20.10015,12.42075 20.10015,11.394 M12.21015,13.04895 L8.6094,23.5107 C9.6849,23.8272 10.8219,23.9997 11.9994,23.9997 C13.39665,23.9997 14.7369,23.7582 15.98415,23.31945 C15.95265,23.2677 15.92265,23.2137 15.89865,23.15445 L12.21015,13.04895 Z M22.52925,6.242475 C22.581,6.624975 22.61025,7.034475 22.61025,7.476225 C22.61025,8.693475 22.38225,10.062225 21.6975,11.774475 L18.03225,22.371225 C21.6,20.291475 23.99925,16.425975 23.99925,11.999475 C23.99925,9.912975 23.466,7.951725 22.52925,6.242475' })
  );
};

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Workshop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Workshop = function Workshop(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Workshop' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M19,7 C19,7 14,14 6.5,14 C4.5,14 1,15 1,19 L1,23 L12,23 L12,19 C12,16.5 15,18 19,11 L17.5,9.5 M3,5 L3,2 L23,2 L23,16 L20,16 M11,1 L15,1 L15,3 L11,3 L11,1 Z M6.5,14 C8.43299662,14 10,12.4329966 10,10.5 C10,8.56700338 8.43299662,7 6.5,7 C4.56700338,7 3,8.56700338 3,10.5 C3,12.4329966 4.56700338,14 6.5,14 Z' })
  );
};

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Yoga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Yoga = function Yoga(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Yoga' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M12,11 L11,14 L12,17 L10.5,17 L9,14 L9.5,9.5 L12,11 Z M13,2 L9,6 L9,11 L9,14 L10,17 L6,17 L3,22 M20.5,22 L15.5,18.5 L12,17 L11,14 L12,11 L15.5,13 L15.5,18.5 M14,8.5 C13.4477153,8.5 13,8.05228475 13,7.5 C13,6.94771525 13.4477153,6.5 14,6.5 C14.5522847,6.5 15,6.94771525 15,7.5 C15,8.05228475 14.5522847,8.5 14,8.5 Z M11,10.5 L10,17 L10,13.5 L11,10.5 Z' })
  );
};

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Youtube */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Youtube = function Youtube(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'Youtube' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: '#CD201F', fillRule: 'evenodd', d: 'M9.522,15.553 L9.52125,8.80975 L16.00575,12.193 L9.522,15.553 Z M23.76,7.64125 C23.76,7.64125 23.52525,5.9875 22.806,5.25925 C21.89325,4.303 20.87025,4.2985 20.4015,4.243 C17.043,4 12.00525,4 12.00525,4 L11.99475,4 C11.99475,4 6.957,4 3.5985,4.243 C3.129,4.2985 2.10675,4.303 1.19325,5.25925 C0.474,5.9875 0.24,7.64125 0.24,7.64125 C0.24,7.64125 0,9.58375 0,11.5255 L0,13.3465 C0,15.289 0.24,17.23075 0.24,17.23075 C0.24,17.23075 0.474,18.8845 1.19325,19.61275 C2.10675,20.569 3.306,20.539 3.84,20.63875 C5.76,20.82325 12,20.88025 12,20.88025 C12,20.88025 17.043,20.87275 20.4015,20.62975 C20.87025,20.5735 21.89325,20.569 22.806,19.61275 C23.52525,18.8845 23.76,17.23075 23.76,17.23075 C23.76,17.23075 24,15.289 24,13.3465 L24,11.5255 C24,9.58375 23.76,7.64125 23.76,7.64125 L23.76,7.64125 Z' })
  );
};

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ZoomIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ZoomIn = function ZoomIn(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ZoomIn' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,16 L23,23 L16,16 Z M10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z M10,15 L10,5 M5,10 L15,10' })
  );
};

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ZoomOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ZoomOut = function ZoomOut(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */],
    _extends({ viewBox: '0 0 24 24', a11yTitle: 'ZoomOut' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,16 L23,23 L16,16 Z M10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z M5,10 L15,10' })
  );
};

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Blank */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyledIcon__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Blank = function Blank(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StyledIcon__["a" /* StyledIcon */], _extends({ viewBox: '0 0 24 24', 'aria-hidden': true }, props));
};

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrameContextConsumer = undefined;

var _Context = __webpack_require__(249);

Object.defineProperty(exports, 'FrameContextConsumer', {
  enumerable: true,
  get: function get() {
    return _Context.FrameContextConsumer;
  }
});

var _Frame = __webpack_require__(1342);

var _Frame2 = _interopRequireDefault(_Frame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Frame2.default;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Context = __webpack_require__(249);

var _Content = __webpack_require__(1343);

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Frame = function (_Component) {
  _inherits(Frame, _Component);

  // React warns when you render directly into the body since browser extensions
  // also inject into the body and can mess up React. For this reason
  // initialContent is expected to have a div inside of the body
  // element that we render react into.
  function Frame(props, context) {
    _classCallCheck(this, Frame);

    var _this = _possibleConstructorReturn(this, (Frame.__proto__ || Object.getPrototypeOf(Frame)).call(this, props, context));

    _this.handleLoad = function () {
      _this.forceUpdate();
    };

    _this._isMounted = false;
    return _this;
  }

  _createClass(Frame, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;

      var doc = this.getDoc();
      if (doc && doc.readyState === 'complete') {
        this.forceUpdate();
      } else {
        this.node.addEventListener('load', this.handleLoad);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;

      this.node.removeEventListener('load', this.handleLoad);
    }
  }, {
    key: 'getDoc',
    value: function getDoc() {
      return this.node.contentDocument; // eslint-disable-line
    }
  }, {
    key: 'getMountTarget',
    value: function getMountTarget() {
      var doc = this.getDoc();
      if (this.props.mountTarget) {
        return doc.querySelector(this.props.mountTarget);
      }
      return doc.body.children[0];
    }
  }, {
    key: 'renderFrameContents',
    value: function renderFrameContents() {
      if (!this._isMounted) {
        return null;
      }

      var doc = this.getDoc();

      var contentDidMount = this.props.contentDidMount;
      var contentDidUpdate = this.props.contentDidUpdate;

      var win = doc.defaultView || doc.parentView;
      var initialRender = !this._setInitialContent;
      var contents = _react2.default.createElement(
        _Content2.default,
        { contentDidMount: contentDidMount, contentDidUpdate: contentDidUpdate },
        _react2.default.createElement(
          _Context.FrameContextProvider,
          { value: { document: doc, window: win } },
          _react2.default.createElement(
            'div',
            { className: 'frame-content' },
            this.props.children
          )
        )
      );

      if (initialRender) {
        doc.open('text/html', 'replace');
        doc.write(this.props.initialContent);
        doc.close();
        this._setInitialContent = true;
      }

      var mountTarget = this.getMountTarget();

      return [_reactDom2.default.createPortal(this.props.head, this.getDoc().head), _reactDom2.default.createPortal(contents, mountTarget)];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = _extends({}, this.props, {
        children: undefined // The iframe isn't ready so we drop children from props here. #12, #17
      });
      delete props.head;
      delete props.initialContent;
      delete props.mountTarget;
      delete props.contentDidMount;
      delete props.contentDidUpdate;
      return _react2.default.createElement(
        'iframe',
        _extends({}, props, { ref: function ref(node) {
            return _this2.node = node;
          } }),
        this.renderFrameContents()
      );
    }
  }]);

  return Frame;
}(_react.Component);

Frame.propTypes = {
  style: _propTypes2.default.object, // eslint-disable-line
  head: _propTypes2.default.node,
  initialContent: _propTypes2.default.string,
  mountTarget: _propTypes2.default.string,
  contentDidMount: _propTypes2.default.func,
  contentDidUpdate: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)])
};
Frame.defaultProps = {
  style: {},
  head: null,
  children: undefined,
  mountTarget: undefined,
  contentDidMount: function contentDidMount() {},
  contentDidUpdate: function contentDidUpdate() {},
  initialContent: '<!DOCTYPE html><html><head></head><body><div class="frame-root"></div></body></html>'
};
exports.default = Frame;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars


var Content = function (_Component) {
  _inherits(Content, _Component);

  function Content() {
    _classCallCheck(this, Content);

    return _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).apply(this, arguments));
  }

  _createClass(Content, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.contentDidMount();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.props.contentDidUpdate();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return Content;
}(_react.Component);

Content.propTypes = {
  children: _propTypes2.default.element.isRequired,
  contentDidMount: _propTypes2.default.func.isRequired,
  contentDidUpdate: _propTypes2.default.func.isRequired
};
exports.default = Content;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./content/book": 250,
	"./content/book.json": 250,
	"./content/book.yaml": 1345,
	"./content/figures/m/map-afghanistan-transition.svg": 1346,
	"./content/figures/m/map-bm-afghanistan-2005-2014.svg": 1347,
	"./content/figures/m/map-figure-11-1.svg": 1348,
	"./content/figures/m/map-figure-11-5.svg": 1349,
	"./content/figures/m/map-figure-11-7.svg": 1350,
	"./content/figures/m/map-figure-12-2.svg": 1351,
	"./content/figures/m/map-figure-13-1.svg": 1352,
	"./content/figures/m/map-figure-13-4.svg": 1353,
	"./content/figures/m/map-figure-2-2.svg": 1354,
	"./content/figures/m/map-figure-2-5.svg": 1355,
	"./content/figures/m/map-figure-2-8.svg": 1356,
	"./content/figures/m/map-figure-3-2.svg": 1357,
	"./content/figures/m/map-figure-3-4.svg": 1358,
	"./content/figures/m/map-figure-3-5.svg": 1359,
	"./content/figures/m/map-figure-3-7.svg": 1360,
	"./content/figures/m/map-figure-3-9.svg": 1361,
	"./content/figures/m/map-figure-4-2.svg": 1362,
	"./content/figures/m/map-figure-4-4.svg": 1363,
	"./content/figures/m/map-figure-4-5.svg": 1364,
	"./content/figures/m/map-figure-5-2.svg": 1365,
	"./content/figures/m/map-figure-5-6.svg": 1366,
	"./content/figures/m/map-figure-5-m.svg": 1367,
	"./content/figures/m/map-figure-6-1.svg": 1368,
	"./content/figures/m/map-figure-6-3.svg": 1369,
	"./content/figures/m/map-figure-6-m.svg": 1370,
	"./content/figures/m/map-figure-7-4.svg": 1371,
	"./content/figures/m/map-figure-7-7.svg": 1372,
	"./content/figures/m/map-figure-7-m.svg": 1373,
	"./content/figures/m/map-figure-8-1.svg": 1374,
	"./content/figures/m/map-figure-8-11.svg": 1375,
	"./content/figures/m/map-figure-8-2.svg": 1376,
	"./content/figures/m/map-figure-8-5.svg": 1377,
	"./content/figures/m/map-figure-8-9.svg": 1378,
	"./content/figures/m/map-figure-9-4.svg": 1379,
	"./content/figures/m/map-figure-9-5.svg": 1380,
	"./content/figures/m/map-fm-AfghanistanProvincialBoundaries.svg": 1381,
	"./content/figures/m/map-s2-helmand-and-kandahar.svg": 1382,
	"./content/figures/v2/Img_7-4.svg": 1383,
	"./content/figures/v2/OEF_CVR2.png": 1384,
	"./content/figures/v2/art_14-2.png": 1385,
	"./content/figures/v2/art_S3-1.png": 1386,
	"./content/figures/v2/art_sII-1.png": 1387,
	"./content/figures/v2/grafik_9-4.png": 1388,
	"./content/figures/v2/grafik_Fig1-1.png": 1389,
	"./content/figures/v2/grafik_Fig1-6.png": 1390,
	"./content/figures/v2/img_1-1.png": 1391,
	"./content/figures/v2/img_1-3.png": 1392,
	"./content/figures/v2/img_1-4.png": 1393,
	"./content/figures/v2/img_1-5.png": 1394,
	"./content/figures/v2/img_10-1.png": 1395,
	"./content/figures/v2/img_10-2.png": 1396,
	"./content/figures/v2/img_10-3.png": 1397,
	"./content/figures/v2/img_11-1.png": 1398,
	"./content/figures/v2/img_11-2.png": 1399,
	"./content/figures/v2/img_11-3.png": 1400,
	"./content/figures/v2/img_11-4.png": 1401,
	"./content/figures/v2/img_11-5.png": 1402,
	"./content/figures/v2/img_11-6.png": 1403,
	"./content/figures/v2/img_12-1.png": 1404,
	"./content/figures/v2/img_12-2.png": 1405,
	"./content/figures/v2/img_12-3.png": 1406,
	"./content/figures/v2/img_13-1.png": 1407,
	"./content/figures/v2/img_13-2.png": 1408,
	"./content/figures/v2/img_13-3.png": 1409,
	"./content/figures/v2/img_13-4.png": 1410,
	"./content/figures/v2/img_14-1.png": 1411,
	"./content/figures/v2/img_2-1.png": 1412,
	"./content/figures/v2/img_2-2.png": 1413,
	"./content/figures/v2/img_2-3.png": 1414,
	"./content/figures/v2/img_2-4.png": 1415,
	"./content/figures/v2/img_3-1.png": 1416,
	"./content/figures/v2/img_3-2.png": 1417,
	"./content/figures/v2/img_3-3.png": 1418,
	"./content/figures/v2/img_3-4.png": 1419,
	"./content/figures/v2/img_3-5.png": 1420,
	"./content/figures/v2/img_4-1.png": 1421,
	"./content/figures/v2/img_4-2.png": 1422,
	"./content/figures/v2/img_4-3.png": 1423,
	"./content/figures/v2/img_4-4.png": 1424,
	"./content/figures/v2/img_5-1.png": 1425,
	"./content/figures/v2/img_5-2.png": 1426,
	"./content/figures/v2/img_5-3.png": 1427,
	"./content/figures/v2/img_5-4a.png": 1428,
	"./content/figures/v2/img_5-4b.png": 1429,
	"./content/figures/v2/img_5-5.png": 1430,
	"./content/figures/v2/img_6-1.png": 1431,
	"./content/figures/v2/img_6-2.png": 1432,
	"./content/figures/v2/img_6-3.png": 1433,
	"./content/figures/v2/img_7-1.png": 1434,
	"./content/figures/v2/img_7-2.png": 1435,
	"./content/figures/v2/img_7-2.svg": 1436,
	"./content/figures/v2/img_7-3.png": 1437,
	"./content/figures/v2/img_7-5.png": 1438,
	"./content/figures/v2/img_7-6.png": 1439,
	"./content/figures/v2/img_8-1.png": 1440,
	"./content/figures/v2/img_8-2.png": 1441,
	"./content/figures/v2/img_8-3.png": 1442,
	"./content/figures/v2/img_8-4.png": 1443,
	"./content/figures/v2/img_8-5.png": 1444,
	"./content/figures/v2/img_8-6.png": 1445,
	"./content/figures/v2/img_8-7.png": 1446,
	"./content/figures/v2/img_9-1.png": 1447,
	"./content/figures/v2/img_9-2.png": 1448,
	"./content/figures/v2/img_9-3.png": 1449,
	"./content/figures/v2/img_9-5.png": 1450,
	"./content/figures/v2/img_cvr_oef2.png": 1451,
	"./content/figures/v2/img_sII-2.png": 1452,
	"./content/figures/v2/map_11-3.svg": 1453,
	"./content/figures/v2/map_2-1.svg": 1454,
	"./content/figures/v2/map_2-2.svg": 1455,
	"./content/figures/v2/map_2-3.svg": 1456,
	"./content/figures/v2/map_3-1.svg": 1457,
	"./content/figures/v2/map_3-2.svg": 1458,
	"./content/figures/v2/map_3-3.svg": 1459,
	"./content/figures/v2/map_3-4.svg": 1460,
	"./content/figures/v2/map_3-5.svg": 1461,
	"./content/figures/v2/map_4-1.svg": 1462,
	"./content/figures/v2/map_4-2.svg": 1463,
	"./content/figures/v2/map_4-3.svg": 1464,
	"./content/figures/v2/map_5-1.svg": 1465,
	"./content/figures/v2/map_5-2.svg": 1466,
	"./content/figures/v2/map_5-3.svg": 1467,
	"./content/figures/v2/map_6-1.svg": 1468,
	"./content/figures/v2/map_6-2.svg": 1469,
	"./content/figures/v2/map_7-1.svg": 1470,
	"./content/figures/v2/map_7-3.svg": 1471,
	"./content/figures/v2/map_SIII-1.svg": 1472,
	"./content/figures/v2/map_sII-1.svg": 1473,
	"./content/iframe/ch14/VOLII_Ch14Conclusionv2.html": 1474,
	"./content/iframe/ch2/OEF_VII_Ch_2_v2.html": 1475,
	"./content/logo.svg": 1476,
	"./content/media/audio.example.mp3": 1477,
	"./content/media/media.example.poster.png": 1478,
	"./content/media/video.example.mp4": 1479
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1344;

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/book.cb74598b.yaml\";";

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-afghanistan-transition.1ead5bcc.svg\";";

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-bm-afghanistan-2005-2014.1f9e387e.svg\";";

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-11-1.1454df56.svg\";";

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-11-5.afa5ecda.svg\";";

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-11-7.0b642146.svg\";";

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-12-2.0abb5f2c.svg\";";

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-13-1.5a737b07.svg\";";

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-13-4.2a5d7fbc.svg\";";

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-2-2.456a5854.svg\";";

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-2-5.0a8521ff.svg\";";

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-2-8.ddc2f22f.svg\";";

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-3-2.6bccd37a.svg\";";

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-3-4.6cdd9310.svg\";";

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-3-5.e0cc3bc0.svg\";";

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-3-7.359a83cd.svg\";";

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-3-9.d4a141bd.svg\";";

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-4-2.c648c44e.svg\";";

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-4-4.edb58683.svg\";";

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-4-5.05df45f1.svg\";";

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-5-2.6244a0ba.svg\";";

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-5-6.687ae9a7.svg\";";

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-5-m.818f5e56.svg\";";

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-6-1.a5b65f22.svg\";";

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-6-3.b0a294ac.svg\";";

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-6-m.1409856a.svg\";";

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-7-4.b3d7dc54.svg\";";

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-7-7.028ba5b8.svg\";";

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-7-m.54446c7c.svg\";";

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-8-1.bc91fc3b.svg\";";

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-8-11.306a82d8.svg\";";

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-8-2.0f5ecfd3.svg\";";

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-8-5.5fd6d095.svg\";";

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-8-9.a4a8747c.svg\";";

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-9-4.3973627c.svg\";";

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-figure-9-5.9cf5c298.svg\";";

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-fm-AfghanistanProvincialBoundaries.80a30bc4.svg\";";

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-s2-helmand-and-kandahar.cb3cecd1.svg\";";

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/Img_7-4.ae690a61.svg\";";

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/OEF_CVR2.942a4476.png\";";

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/art_14-2.7fa10d01.png\";";

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/art_S3-1.367f452c.png\";";

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/art_sII-1.78fdaaf4.png\";";

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/grafik_9-4.ccc05b08.png\";";

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/grafik_Fig1-1.0ca8d3b5.png\";";

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/grafik_Fig1-6.f39f1559.png\";";

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_1-1.b39ee64d.png\";";

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_1-3.8c9dc890.png\";";

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_1-4.e21ddae9.png\";";

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_1-5.2141c055.png\";";

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_10-1.516c169d.png\";";

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_10-2.3ee02699.png\";";

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_10-3.09c075ed.png\";";

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_11-1.aa41a92e.png\";";

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_11-2.d6cee854.png\";";

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_11-3.41fd5b10.png\";";

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_11-4.358a3ebd.png\";";

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_11-5.0a4235eb.png\";";

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_11-6.7d432988.png\";";

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_12-1.ec43c201.png\";";

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_12-2.8a79cd26.png\";";

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_12-3.71ab5b30.png\";";

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_13-1.7aa7a04e.png\";";

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_13-2.c90bdbd1.png\";";

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_13-3.d918a4e5.png\";";

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_13-4.b01f45ce.png\";";

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_14-1.6608ab22.png\";";

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_2-1.42bb58e8.png\";";

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_2-2.b8095b4b.png\";";

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_2-3.08618f12.png\";";

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_2-4.f469cf57.png\";";

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_3-1.59e6a44d.png\";";

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_3-2.beb5a226.png\";";

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_3-3.294d49fe.png\";";

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_3-4.ef36c7f2.png\";";

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_3-5.231529f5.png\";";

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_4-1.9418d085.png\";";

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_4-2.62371205.png\";";

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_4-3.7529a840.png\";";

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_4-4.b0d924f4.png\";";

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_5-1.f744ad6d.png\";";

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_5-2.a77cb681.png\";";

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_5-3.13bd656d.png\";";

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_5-4a.9f5b72ce.png\";";

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_5-4b.84efb780.png\";";

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_5-5.f0a0fbab.png\";";

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_6-1.c2837b11.png\";";

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_6-2.581b66c1.png\";";

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_6-3.fa1b2c15.png\";";

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_7-1.ebab894d.png\";";

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_7-2.b58d9ded.png\";";

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_7-2.037bcb70.svg\";";

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_7-3.ef53dc3d.png\";";

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_7-5.b3e899e4.png\";";

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_7-6.8978b0c0.png\";";

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_8-1.cddf0cdb.png\";";

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_8-2.39b7762f.png\";";

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_8-3.beefe682.png\";";

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_8-4.6a210b67.png\";";

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_8-5.1ce57f17.png\";";

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_8-6.b01a21ac.png\";";

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_8-7.e481a00b.png\";";

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_9-1.4535d418.png\";";

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_9-2.151ada10.png\";";

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_9-3.72be7366.png\";";

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_9-5.5d203eb9.png\";";

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_cvr_oef2.256f71f5.png\";";

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_sII-2.42930ff6.png\";";

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_11-3.18d4d22c.svg\";";

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_2-1.7ceb24bd.svg\";";

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_2-2.e2288f85.svg\";";

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_2-3.e9edc6d3.svg\";";

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_3-1.59a42ba4.svg\";";

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_3-2.4a3ba13b.svg\";";

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_3-3.8fccd7e7.svg\";";

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_3-4.3c57c3ab.svg\";";

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_3-5.6642056f.svg\";";

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_4-1.0554c888.svg\";";

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_4-2.68170d9e.svg\";";

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_4-3.f2bf8908.svg\";";

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_5-1.4e806eeb.svg\";";

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_5-2.c8aeaab5.svg\";";

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_5-3.e0d5fb42.svg\";";

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_6-1.fda11f32.svg\";";

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_6-2.58d50f3a.svg\";";

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_7-1.5f8f39b3.svg\";";

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_7-3.09150f14.svg\";";

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_SIII-1.4825fc9a.svg\";";

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/map_sII-1.aa6638c9.svg\";";

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html>\n<html>\n  <head>\n    <meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\" />\n    <meta http-equiv=\"X-UA-Compatible\" content=\"chrome=1,IE=edge\" />\n    <title>VOLII_Ch14Conclusionv2</title>\n    <style>\n      html {\n        height: 100%;\n      }\n      body {\n        background-color: #fff;\n        margin: 0;\n        height: 100%;\n      }\n    </style>\n    <!-- copy these lines to your document head: -->\n\n    <meta name=\"viewport\" content=\"user-scalable=yes, width=600\" />\n    <link\n      href=\"https://fonts.googleapis.com/css?family=STIX+Two+Text&subset=latin\"\n      rel=\"stylesheet\"\n      type=\"text/css\"\n    />\n\n    <!-- end copy -->\n  </head>\n  <body>\n    <!-- copy these lines to your document: -->\n\n    <div\n      id=\"voliich14conclusionv2_hype_container\"\n      class=\"HYPE_document\"\n      style=\"\n        margin: auto;\n        position: relative;\n        width: 600px;\n        height: 678px;\n        overflow: hidden;\n      \"\n    >\n      <script\n        type=\"text/javascript\"\n        charset=\"utf-8\"\n        src=\"iframe/ch14/VOLII_Ch14Conclusionv2.hyperesources/voliich14conclusionv2_hype_generated_script.js\"\n      ></script>\n    </div>\n\n    <!-- end copy -->\n\n    <!-- text content for search engines: -->\n\n    <div style=\"display: none\" aria-hidden=\"true\">\n      <div>SEP 2001</div>\n      <div></div>\n      <div>Early 2001</div>\n      <div>HOME</div>\n      <div>DEC 2014</div>\n      <div>APR 2003</div>\n      <div>SELECT A DATE TO VIEW KEY EVENT</div>\n      <div>JUN 2001</div>\n      <div>MAR 2009</div>\n      <div>JUN 2013</div>\n      <div>\n        Following the September 11th terror attacks, the U.S. Army entered an\n        era of sustained warfare unlike anything experienced during its 225-year\n        history.\n      </div>\n      <div>\n        U.S. and coalition troops ousted Iraq’s Saddam Hussein from power.\n      </div>\n      <div>\n        During the address to the nation, President Obama signaled his\n        willingness to commit more resources to the campaign.\n      </div>\n      <div>\n        At the conclusion of Enduring Freedom, the White House left 9,800 troops\n        in Afghanistan to support the new NATO-led mission, operation Resolute\n        Support.\n      </div>\n      <div>\n        President Obama executes final portion of strategy he approved in 2009\n        as Afghan security forces assumed lead for combat operations.\n      </div>\n      <div>\n        President Obama announced the surge with a timetable; the U.S. would\n        begin to redeploy troops from Afghanistan by June 2011.\n      </div>\n      <div>\n        U.S. commanders focused on building the surge’s gains while tackling\n        withdrawal of  a decades worth of equipment and material.\n      </div>\n    </div>\n\n    <!-- end text content: -->\n  </body>\n</html>\n";

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html>\n<html>\n  <head>\n    <meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\" />\n    <meta http-equiv=\"X-UA-Compatible\" content=\"chrome=1,IE=edge\" />\n    <title>OEF_VII_Ch_2_v2</title>\n    <style>\n      html {\n        height: 100%;\n      }\n      body {\n        background-color: #fff;\n        margin: 0;\n        height: 100%;\n      }\n    </style>\n    <!-- copy these lines to your document head: -->\n\n    <meta name=\"viewport\" content=\"user-scalable=yes, width=600\" />\n\n    <!-- end copy -->\n  </head>\n  <body>\n    <!-- copy these lines to your document: -->\n\n    <div\n      id=\"oefviich2v2_hype_container\"\n      class=\"HYPE_document\"\n      style=\"\n        margin: auto;\n        position: relative;\n        width: 600px;\n        height: 383px;\n        overflow: hidden;\n      \"\n    >\n      <script\n        type=\"text/javascript\"\n        charset=\"utf-8\"\n        src=\"iframe/ch2/OEF_VII_Ch_2_v2.hyperesources/oefviich2v2_hype_generated_script.js\"\n      ></script>\n    </div>\n\n    <!-- end copy -->\n\n    <!-- text content for search engines: -->\n\n    <div style=\"display: none\" aria-hidden=\"true\">\n      <div></div>\n      <div></div>\n      <div>Select an Icon to View Insurgent Activity</div>\n      <div>2006Key Insurgent Activity</div>\n      <div>HOME</div>\n      <div>\n        The Haqqani Network expanded from its established positions along the\n        border into Khost and Paktiya Provinces. \n      </div>\n      <div>2006Key Insurgent Activity Haqqani Network </div>\n      <div>\n        The Hezb-e-Islami Gulbuddin (HIG) fighters surrounded their\n        fundamentalism with a modern, disciplined organization that resembled a\n        Soviet-style political front.  \n      </div>\n      <div>2006Key Insurgent Activity HIG</div>\n      <div>\n        As the season began, a new Taliban opposed the coalition and its Afghan\n        partners. Their tactics began to show greater sophistication, daring,\n        and effectiveness.\n      </div>\n      <div>2006Key Insurgent Activity Taliban</div>\n      <div>\n        Mullah Mohammed Omar dispatched Mullah Dadullah “Lame” Akhund, one of\n        his most committed followers to take command of the fighters in the\n        South. \n      </div>\n      <div>2006Key Insurgent Activity Mullah Akhund</div>\n    </div>\n\n    <!-- end text content: -->\n  </body>\n</html>\n";

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/logo.da4db51e.svg\";";

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/audio.example.2ca80224.mp3\";";

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/media.example.poster.de6be620.png\";";

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

module.exports = "module.exports = __webpack_public_path__ + \"static/media/video.example.bfd19c4e.mp4\";";

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Consumer = exports.Provider = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactContext = __webpack_require__(1483);

var _createReactContext2 = _interopRequireDefault(_createReactContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// use the polyfill only if Context API not available (react<16)
var createContext = _react2.default.createContext || _createReactContext2.default;

var _createContext = createContext({}),
    Provider = _createContext.Provider,
    Consumer = _createContext.Consumer;

exports.Provider = Provider;
exports.Consumer = Consumer;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1484);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(1485);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(1486);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1487);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "16703de1ce52b726b912.worker.js");
};

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: -1;\n  background: repeating-linear-gradient(\n    -55deg,\n    #e6e6e6,\n    #e6e6e6 10px,\n    #e9e9e9 10px,\n    #e9e9e9 20px\n  );\n'],['\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: -1;\n  background: repeating-linear-gradient(\n    -55deg,\n    #e6e6e6,\n    #e6e6e6 10px,\n    #e9e9e9 10px,\n    #e9e9e9 20px\n  );\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledBox=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_grommet__["d" /* Box */])(_templateObject);function Underlay(_ref){var AppState=_ref.AppState;return(AppState.isUserBookmarking||AppState.isBookmarkingMenuBar)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledBox,{elevation:'small',fill:'vertical',width:'large'});}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(Underlay)));

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_style_theme__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_highlight_words__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_highlight_words___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_highlight_words__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_state_AppState__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_Menu_MenuPane__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_worker_loader_app_api_search_worker_js__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_worker_loader_app_api_search_worker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_worker_loader_app_api_search_worker_js__);
var _templateObject=_taggedTemplateLiteral(['\n  margin: 0px 0;\n  ',';\n'],['\n  margin: 0px 0;\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      font-style: italic;\n    '],['\n      font-style: italic;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n  margin: 10px 0;\n  hyphens: auto;\n  cursor: pointer;\n  .highlight {\n    color: ',';\n    background-color: ','\n  }\n'],['\n  margin: 10px 0;\n  hyphens: auto;\n  cursor: pointer;\n  .highlight {\n    color: ',';\n    background-color: ','\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// eslint-disable-next-line import/no-webpack-loader-syntax
var searchWorker=new __WEBPACK_IMPORTED_MODULE_9_worker_loader_app_api_search_worker_js___default.a();searchWorker.onmessage=function(_ref){var results=_ref.data;var hasResults=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(results.matches);if(hasResults){__WEBPACK_IMPORTED_MODULE_7_app_state_AppState__["a" /* default */].changeSearchStatus('SEARCH_RESULTS_FOUND');__WEBPACK_IMPORTED_MODULE_7_app_state_AppState__["a" /* default */].newSearchResults(results);}else{__WEBPACK_IMPORTED_MODULE_7_app_state_AppState__["a" /* default */].changeSearchStatus('SEARCH_RESULTS_EMPTY');}};var StyledHeader=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5_grommet__["g" /* Heading */])(_templateObject,function(props){return props.searchTerm&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* css */])(_templateObject2);});var HighlighterParagraph=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_6_react_highlight_words___default.a)(_templateObject3,__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors.black,__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors.focus);function SearchResults(_ref2){var AppState=_ref2.AppState;if(!AppState.isSearchResultsOpen)return null;var searchTerm=AppState.searchTerm,isSearchResultsPending=AppState.isSearchResultsPending,isSearchResultsFound=AppState.isSearchResultsFound,isSearchResultsEmpty=AppState.isSearchResultsEmpty;if(isSearchResultsPending){searchWorker.postMessage(searchTerm);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_Menu_MenuPane__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet__["d" /* Box */],{direction:'column',justify:'center',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledHeader,{responsive:true,size:'small',textAlign:'center'},'Search Results')),isSearchResultsPending&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Searching...'),isSearchResultsEmpty&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'No matches found!'),isSearchResultsFound&&__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(AppState.searchResults.matches,function(_ref3,index,matches){var path=_ref3.path,value=_ref3.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet__["d" /* Box */],{key:index,border:index!==matches.length-1?'bottom':undefined,flex:'grow',margin:{horizontal:'none'},onClick:function onClick(){AppState.changeSectionItem(path);AppState.toggleSearchResults();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HighlighterParagraph,{highlightClassName:'highlight',searchWords:searchTerm.split(' '),autoEscape:true,textToHighlight:value}));}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(SearchResults)));

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Highlighter = __webpack_require__(2);
	
	var _Highlighter2 = _interopRequireDefault(_Highlighter);

	exports['default'] = _Highlighter2['default'];
	module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Highlighter;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _highlightWordsCore = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _memoizeOne = __webpack_require__(15);
	
	var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
	
	Highlighter.propTypes = {
	  activeClassName: _propTypes2['default'].string,
	  activeIndex: _propTypes2['default'].number,
	  activeStyle: _propTypes2['default'].object,
	  autoEscape: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  findChunks: _propTypes2['default'].func,
	  highlightClassName: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
	  highlightStyle: _propTypes2['default'].object,
	  highlightTag: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func, _propTypes2['default'].string]),
	  sanitize: _propTypes2['default'].func,
	  searchWords: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].instanceOf(RegExp)])).isRequired,
	  textToHighlight: _propTypes2['default'].string.isRequired,
	  unhighlightClassName: _propTypes2['default'].string,
	  unhighlightStyle: _propTypes2['default'].object
	};
	
	/**
	 * Highlights all occurrences of search terms (searchText) within a string (textToHighlight).
	 * This function returns an array of strings and <span>s (wrapping highlighted words).
	 */
	
	function Highlighter(_ref) {
	  var _ref$activeClassName = _ref.activeClassName;
	  var activeClassName = _ref$activeClassName === undefined ? '' : _ref$activeClassName;
	  var _ref$activeIndex = _ref.activeIndex;
	  var activeIndex = _ref$activeIndex === undefined ? -1 : _ref$activeIndex;
	  var activeStyle = _ref.activeStyle;
	  var autoEscape = _ref.autoEscape;
	  var _ref$caseSensitive = _ref.caseSensitive;
	  var caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive;
	  var className = _ref.className;
	  var findChunks = _ref.findChunks;
	  var _ref$highlightClassName = _ref.highlightClassName;
	  var highlightClassName = _ref$highlightClassName === undefined ? '' : _ref$highlightClassName;
	  var _ref$highlightStyle = _ref.highlightStyle;
	  var highlightStyle = _ref$highlightStyle === undefined ? {} : _ref$highlightStyle;
	  var _ref$highlightTag = _ref.highlightTag;
	  var highlightTag = _ref$highlightTag === undefined ? 'mark' : _ref$highlightTag;
	  var sanitize = _ref.sanitize;
	  var searchWords = _ref.searchWords;
	  var textToHighlight = _ref.textToHighlight;
	  var _ref$unhighlightClassName = _ref.unhighlightClassName;
	  var unhighlightClassName = _ref$unhighlightClassName === undefined ? '' : _ref$unhighlightClassName;
	  var unhighlightStyle = _ref.unhighlightStyle;
	
	  var chunks = (0, _highlightWordsCore.findAll)({
	    autoEscape: autoEscape,
	    caseSensitive: caseSensitive,
	    findChunks: findChunks,
	    sanitize: sanitize,
	    searchWords: searchWords,
	    textToHighlight: textToHighlight
	  });
	  var HighlightTag = highlightTag;
	  var highlightCount = -1;
	  var highlightClassNames = '';
	  var highlightStyles = undefined;
	
	  var lowercaseProps = function lowercaseProps(object) {
	    var mapped = {};
	    for (var key in object) {
	      mapped[key.toLowerCase()] = object[key];
	    }
	    return mapped;
	  };
	  var memoizedLowercaseProps = (0, _memoizeOne2['default'])(lowercaseProps);
	
	  return _react2['default'].createElement(
	    'span',
	    { className: className },
	    chunks.map(function (chunk, index) {
	      var text = textToHighlight.substr(chunk.start, chunk.end - chunk.start);
	
	      if (chunk.highlight) {
	        highlightCount++;
	
	        var highlightClass = undefined;
	        if (typeof highlightClassName === 'object') {
	          if (!caseSensitive) {
	            highlightClassName = memoizedLowercaseProps(highlightClassName);
	            highlightClass = highlightClassName[text.toLowerCase()];
	          } else {
	            highlightClass = highlightClassName[text];
	          }
	        } else {
	          highlightClass = highlightClassName;
	        }
	
	        var isActive = highlightCount === +activeIndex;
	
	        highlightClassNames = highlightClass + ' ' + (isActive ? activeClassName : '');
	        highlightStyles = isActive === true && activeStyle != null ? Object.assign({}, highlightStyle, activeStyle) : highlightStyle;
	
	        return _react2['default'].createElement(
	          HighlightTag,
	          {
	            className: highlightClassNames,
	            key: index,
	            style: highlightStyles
	          },
	          text
	        );
	      } else {
	        return _react2['default'].createElement(
	          'span',
	          {
	            className: unhighlightClassName,
	            key: index,
	            style: unhighlightStyle
	          },
	          text
	        );
	      }
	    })
	  );
	}
	
	module.exports = exports['default'];

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1);
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _utils = __webpack_require__(2);
		
		Object.defineProperty(exports, 'combineChunks', {
		  enumerable: true,
		  get: function get() {
		    return _utils.combineChunks;
		  }
		});
		Object.defineProperty(exports, 'fillInChunks', {
		  enumerable: true,
		  get: function get() {
		    return _utils.fillInChunks;
		  }
		});
		Object.defineProperty(exports, 'findAll', {
		  enumerable: true,
		  get: function get() {
		    return _utils.findAll;
		  }
		});
		Object.defineProperty(exports, 'findChunks', {
		  enumerable: true,
		  get: function get() {
		    return _utils.findChunks;
		  }
		});
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		/**
		 * Creates an array of chunk objects representing both higlightable and non highlightable pieces of text that match each search word.
		 * @return Array of "chunks" (where a Chunk is { start:number, end:number, highlight:boolean })
		 */
		var findAll = exports.findAll = function findAll(_ref) {
		  var autoEscape = _ref.autoEscape,
		      _ref$caseSensitive = _ref.caseSensitive,
		      caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive,
		      _ref$findChunks = _ref.findChunks,
		      findChunks = _ref$findChunks === undefined ? defaultFindChunks : _ref$findChunks,
		      sanitize = _ref.sanitize,
		      searchWords = _ref.searchWords,
		      textToHighlight = _ref.textToHighlight;
		  return fillInChunks({
		    chunksToHighlight: combineChunks({
		      chunks: findChunks({
		        autoEscape: autoEscape,
		        caseSensitive: caseSensitive,
		        sanitize: sanitize,
		        searchWords: searchWords,
		        textToHighlight: textToHighlight
		      })
		    }),
		    totalLength: textToHighlight ? textToHighlight.length : 0
		  });
		};
		
		/**
		 * Takes an array of {start:number, end:number} objects and combines chunks that overlap into single chunks.
		 * @return {start:number, end:number}[]
		 */
		var combineChunks = exports.combineChunks = function combineChunks(_ref2) {
		  var chunks = _ref2.chunks;
		
		  chunks = chunks.sort(function (first, second) {
		    return first.start - second.start;
		  }).reduce(function (processedChunks, nextChunk) {
		    // First chunk just goes straight in the array...
		    if (processedChunks.length === 0) {
		      return [nextChunk];
		    } else {
		      // ... subsequent chunks get checked to see if they overlap...
		      var prevChunk = processedChunks.pop();
		      if (nextChunk.start <= prevChunk.end) {
		        // It may be the case that prevChunk completely surrounds nextChunk, so take the
		        // largest of the end indeces.
		        var endIndex = Math.max(prevChunk.end, nextChunk.end);
		        processedChunks.push({ start: prevChunk.start, end: endIndex });
		      } else {
		        processedChunks.push(prevChunk, nextChunk);
		      }
		      return processedChunks;
		    }
		  }, []);
		
		  return chunks;
		};
		
		/**
		 * Examine text for any matches.
		 * If we find matches, add them to the returned array as a "chunk" object ({start:number, end:number}).
		 * @return {start:number, end:number}[]
		 */
		var defaultFindChunks = function defaultFindChunks(_ref3) {
		  var autoEscape = _ref3.autoEscape,
		      caseSensitive = _ref3.caseSensitive,
		      _ref3$sanitize = _ref3.sanitize,
		      sanitize = _ref3$sanitize === undefined ? identity : _ref3$sanitize,
		      searchWords = _ref3.searchWords,
		      textToHighlight = _ref3.textToHighlight;
		
		  textToHighlight = sanitize(textToHighlight);
		
		  return searchWords.filter(function (searchWord) {
		    return searchWord;
		  }) // Remove empty words
		  .reduce(function (chunks, searchWord) {
		    searchWord = sanitize(searchWord);
		
		    if (autoEscape) {
		      searchWord = escapeRegExpFn(searchWord);
		    }
		
		    var regex = new RegExp(searchWord, caseSensitive ? 'g' : 'gi');
		
		    var match = void 0;
		    while (match = regex.exec(textToHighlight)) {
		      var start = match.index;
		      var end = regex.lastIndex;
		      // We do not return zero-length matches
		      if (end > start) {
		        chunks.push({ start: start, end: end });
		      }
		
		      // Prevent browsers like Firefox from getting stuck in an infinite loop
		      // See http://www.regexguru.com/2008/04/watch-out-for-zero-length-matches/
		      if (match.index == regex.lastIndex) {
		        regex.lastIndex++;
		      }
		    }
		
		    return chunks;
		  }, []);
		};
		// Allow the findChunks to be overridden in findAll,
		// but for backwards compatibility we export as the old name
		exports.findChunks = defaultFindChunks;
		
		/**
		 * Given a set of chunks to highlight, create an additional set of chunks
		 * to represent the bits of text between the highlighted text.
		 * @param chunksToHighlight {start:number, end:number}[]
		 * @param totalLength number
		 * @return {start:number, end:number, highlight:boolean}[]
		 */
		
		var fillInChunks = exports.fillInChunks = function fillInChunks(_ref4) {
		  var chunksToHighlight = _ref4.chunksToHighlight,
		      totalLength = _ref4.totalLength;
		
		  var allChunks = [];
		  var append = function append(start, end, highlight) {
		    if (end - start > 0) {
		      allChunks.push({
		        start: start,
		        end: end,
		        highlight: highlight
		      });
		    }
		  };
		
		  if (chunksToHighlight.length === 0) {
		    append(0, totalLength, false);
		  } else {
		    var lastIndex = 0;
		    chunksToHighlight.forEach(function (chunk) {
		      append(lastIndex, chunk.start, false);
		      append(chunk.start, chunk.end, true);
		      lastIndex = chunk.end;
		    });
		    append(lastIndex, totalLength, false);
		  }
		  return allChunks;
		};
		
		function identity(value) {
		  return value;
		}
		
		function escapeRegExpFn(str) {
		  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
		}
	
	/***/ })
	/******/ ]);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(6)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(13)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	var invariant = __webpack_require__(8);
	var warning = __webpack_require__(9);
	var assign = __webpack_require__(10);
	
	var ReactPropTypesSecret = __webpack_require__(11);
	var checkPropTypes = __webpack_require__(12);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (process.env.NODE_ENV !== 'production') {
	  var invariant = __webpack_require__(8);
	  var warning = __webpack_require__(9);
	  var ReactPropTypesSecret = __webpack_require__(11);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	var invariant = __webpack_require__(8);
	var ReactPropTypesSecret = __webpack_require__(11);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = __webpack_require__(0);

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	var simpleIsEqual = function simpleIsEqual(a, b) {
	  return a === b;
	};
	
	function index (resultFn) {
	  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;
	
	  var lastThis = void 0;
	  var lastArgs = [];
	  var lastResult = void 0;
	  var calledOnce = false;
	
	  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
	    return isEqual(newArg, lastArgs[index]);
	  };
	
	  var result = function result() {
	    for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
	      newArgs[_key] = arguments[_key];
	    }
	
	    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
	      return lastResult;
	    }
	
	    calledOnce = true;
	    lastThis = this;
	    lastArgs = newArgs;
	    lastResult = resultFn.apply(this, newArgs);
	    return lastResult;
	  };
	
	  return result;
	}
	
	module.exports = index;


/***/ })
/******/ ]);
//# sourceMappingURL=main.js.map

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "01a620125e3ae245844d.worker.js");
};

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_detect_offline__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_detect_offline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_detect_offline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_api_book__ = __webpack_require__(127);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  bottom: 70px;\n  left: 50%;\n  transform: translateX(-50%);\n  max-width: 768px;\n  width: 100%;\n  z-index: 9;\n  @media (max-width: 600px) {\n    bottom: 50px;\n  }\n"],["\n  position: fixed;\n  bottom: 70px;\n  left: 50%;\n  transform: translateX(-50%);\n  max-width: 768px;\n  width: 100%;\n  z-index: 9;\n  @media (max-width: 600px) {\n    bottom: 50px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  min-height: 70px !important;\n  height: 70px !important;\n  max-height: 70px !important;\n  z-index: 9;\n  @media (max-width: 600px) {\n    min-height: 50px !important;\n    height: 50px !important;\n    max-height: 50px !important;\n  }\n"],["\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  min-height: 70px !important;\n  height: 70px !important;\n  max-height: 70px !important;\n  z-index: 9;\n  @media (max-width: 600px) {\n    min-height: 50px !important;\n    height: 50px !important;\n    max-height: 50px !important;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n"],["\n  width: 24px;\n  height: 24px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*OEF ToC/SECTION MODs*/var Context=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4_grommet__["d" /* Box */])(_templateObject);var Bar=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4_grommet__["d" /* Box */])(_templateObject2);var OnlineContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].span(_templateObject3);function MenuBar(_ref){var AppState=_ref.AppState,children=_ref.children;//MAR 21 By RR changed declaration from const to let
var context=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(AppState.selectedSection).drop().filter(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isString).map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.startCase).join(" / ").value();//DEBUG: console.log(`CONTEXT ${context}`);
//check if section, convert to uppercase
if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(context,"Section")){context=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toUpper(context);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!AppState.isUserAnnotating&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context,{direction:"row",alignContent:"center",justify:"between",pad:{horizontal:"small"},background:"dark-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["m" /* Text */],{color:"focus",weight:"bold"},__WEBPACK_IMPORTED_MODULE_7_app_api_book__["a" /* default */].metadata.title+" / "+context),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_detect_offline__["Online"],{polling:false,url:"https://google.com"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OnlineContainer,{title:"ONLINE"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_icons__["l" /* Globe */],{color:"status-ok"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_detect_offline__["Offline"],{polling:false,url:"https://google.com"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["d" /* Box */],{direction:"row",alignContent:"center",align:"center",gap:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["m" /* Text */],{weight:"bold",color:"white"},"OFFLINE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_icons__["h" /* Connect */],{color:"white"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Bar,{tag:"nav",justify:"between",align:"center",direction:"row",background:"brand",overflow:"hidden",width:"large",pad:{horizontal:"medium"}},children));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(MenuBar)));

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Detector = exports.Offline = exports.Online = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var inBrowser = typeof navigator !== "undefined";

// these browsers don't fully support navigator.onLine, so we need to use a polling backup
var unsupportedUserAgentsPattern = /Windows.*Chrome|Windows.*Firefox|Linux.*Chrome/;

var ping = function ping(_ref) {
  var url = _ref.url,
      timeout = _ref.timeout;

  return new Promise(function (resolve) {
    var isOnline = function isOnline() {
      return resolve(true);
    };
    var isOffline = function isOffline() {
      return resolve(false);
    };

    var xhr = new XMLHttpRequest();

    xhr.onerror = isOffline;
    xhr.ontimeout = isOffline;
    xhr.onload = function () {
      var response = xhr.responseText.trim();
      if (!response) {
        isOffline();
      } else {
        isOnline();
      }
    };

    xhr.open("GET", url);
    xhr.timeout = timeout;
    xhr.send();
  });
};

var propTypes = {
  children: _propTypes2.default.node,
  onChange: _propTypes2.default.func,
  polling: _propTypes2.default.oneOfType([_propTypes2.default.shape({
    url: _propTypes2.default.string,
    interval: _propTypes2.default.number,
    timeout: _propTypes2.default.number
  }), _propTypes2.default.bool]),
  wrapperType: _propTypes2.default.string
};

var defaultProps = {
  polling: true,
  wrapperType: "span"
};

var defaultPollingConfig = {
  enabled: inBrowser && unsupportedUserAgentsPattern.test(navigator.userAgent),
  url: "https://ipv4.icanhazip.com/",
  timeout: 5000,
  interval: 5000
};

// base class that detects offline/online changes

var Base = function (_Component) {
  _inherits(Base, _Component);

  function Base() {
    _classCallCheck(this, Base);

    var _this = _possibleConstructorReturn(this, (Base.__proto__ || Object.getPrototypeOf(Base)).call(this));

    _this.state = {
      online: inBrowser && typeof navigator.onLine === "boolean" ? navigator.onLine : true
    };
    // bind event handlers
    _this.goOnline = _this.goOnline.bind(_this);
    _this.goOffline = _this.goOffline.bind(_this);
    return _this;
  }

  _createClass(Base, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("online", this.goOnline);
      window.addEventListener("offline", this.goOffline);

      if (this.getPollingConfig().enabled) {
        this.startPolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("online", this.goOnline);
      window.removeEventListener("offline", this.goOffline);

      if (this.pollingId) {
        this.stopPolling();
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _props = this.props,
          children = _props.children,
          wrapperType = _props.wrapperType;

      // usual case: one child that is a react Element

      if ((0, _react.isValidElement)(children)) {
        return children;
      }

      // no children
      if (!children) {
        return null;
      }

      // string children, multiple children, or something else
      return _react.createElement.apply(undefined, [wrapperType, {}].concat(_toConsumableArray(_react.Children.toArray(children))));
    }
  }, {
    key: "getPollingConfig",
    value: function getPollingConfig() {
      switch (this.props.polling) {
        case true:
          return defaultPollingConfig;
        case false:
          return { enabled: false };
        default:
          return Object.assign({}, defaultPollingConfig, this.props.polling);
      }
    }
  }, {
    key: "goOnline",
    value: function goOnline() {
      if (!this.state.online) {
        this.callOnChangeHandler(true);
        this.setState({ online: true });
      }
    }
  }, {
    key: "goOffline",
    value: function goOffline() {
      if (this.state.online) {
        this.callOnChangeHandler(false);
        this.setState({ online: false });
      }
    }
  }, {
    key: "callOnChangeHandler",
    value: function callOnChangeHandler(online) {
      if (this.props.onChange) {
        this.props.onChange(online);
      }
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      var _this2 = this;

      var _getPollingConfig = this.getPollingConfig(),
          interval = _getPollingConfig.interval;

      this.pollingId = setInterval(function () {
        var _getPollingConfig2 = _this2.getPollingConfig(),
            url = _getPollingConfig2.url,
            timeout = _getPollingConfig2.timeout;

        ping({ url: url, timeout: timeout }).then(function (online) {
          online ? _this2.goOnline() : _this2.goOffline();
        });
      }, interval);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      clearInterval(this.pollingId);
    }
  }]);

  return Base;
}(_react.Component);

Base.propTypes = propTypes;
Base.defaultProps = defaultProps;

var Online = exports.Online = function (_Base) {
  _inherits(Online, _Base);

  function Online() {
    _classCallCheck(this, Online);

    return _possibleConstructorReturn(this, (Online.__proto__ || Object.getPrototypeOf(Online)).apply(this, arguments));
  }

  _createClass(Online, [{
    key: "render",
    value: function render() {
      return this.state.online ? this.renderChildren() : null;
    }
  }]);

  return Online;
}(Base);

Online.propTypes = propTypes;
Online.defaultProps = defaultProps;

var Offline = exports.Offline = function (_Base2) {
  _inherits(Offline, _Base2);

  function Offline() {
    _classCallCheck(this, Offline);

    return _possibleConstructorReturn(this, (Offline.__proto__ || Object.getPrototypeOf(Offline)).apply(this, arguments));
  }

  _createClass(Offline, [{
    key: "render",
    value: function render() {
      return !this.state.online ? this.renderChildren() : null;
    }
  }]);

  return Offline;
}(Base);

Offline.propTypes = propTypes;
Offline.defaultProps = defaultProps;

var Detector = exports.Detector = function (_Base3) {
  _inherits(Detector, _Base3);

  function Detector() {
    _classCallCheck(this, Detector);

    return _possibleConstructorReturn(this, (Detector.__proto__ || Object.getPrototypeOf(Detector)).apply(this, arguments));
  }

  _createClass(Detector, [{
    key: "render",
    value: function render() {
      return this.props.render({ online: this.state.online });
    }
  }]);

  return Detector;
}(Base);

Detector.propTypes = Object.assign({}, propTypes, {
  render: _propTypes2.default.func.isRequired
});
Detector.defaultProps = defaultProps;


/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_MainMenu_ContentsButton__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_MainMenu_BookmarksButton__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_MainMenu_BookmarkingButton__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_MainMenu_SearchButton__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_MainMenu_SearchInput__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_components_MainMenu_NavigationButtons__ = __webpack_require__(1500);
function MainMenu(_ref){var AppState=_ref.AppState;if(!AppState.isMainMenuBar)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet__["d" /* Box */],{direction:'row',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_MainMenu_ContentsButton__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_MainMenu_SearchButton__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_MainMenu_SearchInput__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_components_MainMenu_NavigationButtons__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet__["d" /* Box */],{direction:'row',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_MainMenu_BookmarksButton__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_MainMenu_BookmarkingButton__["a" /* default */],null)));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(MainMenu)));

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(["\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n"],["\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ShowTOC=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["p" /* Menu */])(_templateObject);var ReturnButton=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["r" /* Revert */])(_templateObject);function ContentsButton(_ref){var AppState=_ref.AppState;var isOpen=AppState.isTOCMenuOpen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_Button__["a" /* default */],{title:"Table of Contents",direction:"row",pad:"small",justify:"center",align:"center",fill:"vertical",onClick:function onClick(){return AppState.toggleTOCMenu();}},!isOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShowTOC,{color:"accent-1"}),isOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReturnButton,{size:"large",color:"accent-1"}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(ContentsButton)));

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n'],['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["b" /* Bookmark */])(_templateObject);function BookmarkingMenu(_ref){var AppState=_ref.AppState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_Button__["a" /* default */],{direction:'row',pad:'small',justify:'center',align:'center',fill:'vertical',onClick:function onClick(){AppState.setMenuBar('USER_IS_BOOKMARKING');AppState.closeMenus();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{size:'full',color:'accent-1'}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(BookmarkingMenu)));

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(["\n  width: 40px;\n  height: 40px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n"],["\n  width: 40px;\n  height: 40px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n"],["\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["s" /* Search */])(_templateObject);var Return=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["r" /* Revert */])(_templateObject2);function SearchButton(_ref){var AppState=_ref.AppState;var isOpen=AppState.isSearchResultsOpen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_Button__["a" /* default */],{title:"Search",pad:"small",justify:"center",align:"center",onClick:function onClick(){AppState.toggleSearchResults();}},!isOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{color:"accent-1"}),isOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Return,{color:"accent-1"}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(SearchButton)));

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_style_theme__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  background: ',';\n  border: 2px solid ',';\n  :focus {\n    color: ',';\n    background: ',';\n    border: 1px solid ',';\n    box-shadow: 0 0 1px 1px ',';\n    outline: none !important;\n  }\n  @media (max-width: 600px) {\n    height: 32px;\n  }\n'],['\n  background: ',';\n  border: 2px solid ',';\n  :focus {\n    color: ',';\n    background: ',';\n    border: 1px solid ',';\n    box-shadow: 0 0 1px 1px ',';\n    outline: none !important;\n  }\n  @media (max-width: 600px) {\n    height: 32px;\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Input=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet__["o" /* TextInput */])(_templateObject,__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors['accent-3'],__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors['dark-1'],__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors.text,__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors['accent-2'],__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors.focus,__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors.focus);var SearchInput=function(_React$Component){_inherits(SearchInput,_React$Component);function SearchInput(props){_classCallCheck(this,SearchInput);var _this=_possibleConstructorReturn(this,(SearchInput.__proto__||Object.getPrototypeOf(SearchInput)).call(this,props));_this.onSubmit=_this.onSubmit.bind(_this);_this.onChange=_this.onChange.bind(_this);_this.onFocus=_this.onFocus.bind(_this);_this.onBlur=_this.onBlur.bind(_this);_this.state={searchTerm:'',tempSearchTerm:''};return _this;}_createClass(SearchInput,[{key:'onSubmit',value:function onSubmit(keypress){var AppState=this.props.AppState;var searchTerm=this.state.searchTerm;if(keypress==='Enter'){AppState.changeSearchStatus('SEARCH_RESULTS_PENDING');AppState.newSearchTerm(searchTerm);// this.setState({ searchTerm: '' });
}}},{key:'onChange',value:function onChange(searchTerm){this.setState({searchTerm:searchTerm,tempSearchTerm:searchTerm});}},{key:'onFocus',value:function onFocus(){this.setState({searchTerm:''});}},{key:'onBlur',value:function onBlur(){var tempSearchTerm=this.state.tempSearchTerm;this.setState({searchTerm:tempSearchTerm});}},{key:'render',value:function render(){var _this2=this;var AppState=this.props.AppState;var searchTerm=this.state.searchTerm;if(!AppState.isUserSearching)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{pad:'xsmall',basis:'1/2',justify:'start',align:'center',flex:'shrink',fill:'horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Input,{focusIndicator:true,autoFocus:!AppState.hasSearchResults,value:searchTerm,onChange:function onChange(event){return _this2.onChange(event.target.value);},onFocus:this.onFocus,onBlur:this.onBlur,onKeyPress:function onKeyPress(event){return _this2.onSubmit(event.key);}}));}}]);return SearchInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(SearchInput)));

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_contents__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(["\n  width: 32px;\n  height: 32px;\n  @media (max-width: 600px) {\n    width: 20px;\n    height: 20px;\n  }\n"],["\n  width: 32px;\n  height: 32px;\n  @media (max-width: 600px) {\n    width: 20px;\n    height: 20px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var container=function container(component){return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(component)(_templateObject);};var PreviousIcon=container(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["d" /* ChapterPrevious */]);var NextIcon=container(__WEBPACK_IMPORTED_MODULE_4_grommet_icons__["c" /* ChapterNext */]);function NavigationButtons(_ref){var AppState=_ref.AppState;if(AppState.isUserSearching)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{direction:"row",justify:"between",width:"25%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_Button__["a" /* default */],{title:"Previous Section",pad:"small",justify:"center",align:"center",onClick:__WEBPACK_IMPORTED_MODULE_5_app_api_contents__["a" /* default */].previousSection},__WEBPACK_IMPORTED_MODULE_5_app_api_contents__["a" /* default */].hasPreviousSection()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PreviousIcon,{color:"accent-1"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_Button__["a" /* default */],{title:"Next Section",pad:"small",justify:"center",align:"center",onClick:__WEBPACK_IMPORTED_MODULE_5_app_api_contents__["a" /* default */].nextSection},__WEBPACK_IMPORTED_MODULE_5_app_api_contents__["a" /* default */].hasNextSection()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NextIcon,{color:"accent-1"})));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])("AppState")(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(NavigationButtons)));

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_BookmarkMenu_DeleteBookmarkButton__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_BookmarkMenu_ClearBookmarksButton__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_MainMenu_BookmarksButton__ = __webpack_require__(269);
function BookmarksMenu(_ref){var AppState=_ref.AppState;if(!AppState.isBookmarksMenuBar)return null;var hasBookmarks=!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(AppState.bookmarks.collection);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,hasBookmarks&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_BookmarkMenu_DeleteBookmarkButton__["a" /* default */],null),hasBookmarks&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_BookmarkMenu_ClearBookmarksButton__["a" /* default */],null),!hasBookmarks&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_MainMenu_BookmarksButton__["a" /* default */],null));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(BookmarksMenu)));

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n'],['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["A" /* Trash */])(_templateObject);function DeleteBookmarkButton(_ref){var AppState=_ref.AppState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_Button__["a" /* default */],{direction:'row',pad:'small',justify:'center',align:'center',fill:'vertical',onClick:function onClick(){AppState.setMenuBar('USER_IS_DELETING');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{size:'large',color:'accent-1'}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(DeleteBookmarkButton)));

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(['\n  transform: translateY(2px);\n  width: 52px;\n  height: 52px;\n  @media (max-width: 600px) {\n    width: 28px;\n    height: 28px;\n  }\n'],['\n  transform: translateY(2px);\n  width: 52px;\n  height: 52px;\n  @media (max-width: 600px) {\n    width: 28px;\n    height: 28px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  transform: translateY(2px);\n  width: 26px;\n  height: 26px;\n  @media (max-width: 600px) {\n    transform: translateY(0px);\n    width: 14px;\n    height: 14px;\n  }\n'],['\n  transform: translateY(2px);\n  width: 26px;\n  height: 26px;\n  @media (max-width: 600px) {\n    transform: translateY(0px);\n    width: 14px;\n    height: 14px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ClearIcon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["f" /* Clear */])(_templateObject);var BookmarksIcon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["n" /* Iteration */])(_templateObject2);function ClearBookmarksButton(_ref){var AppState=_ref.AppState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_Button__["a" /* default */],{direction:'column',pad:'small',onClick:function onClick(){AppState.setMenuBar('USER_IS_CLEARING');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet__["j" /* Stack */],{anchor:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClearIcon,{size:'large',color:'accent-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarksIcon,{color:'accent-1'})));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(ClearBookmarksButton)));

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_BookmarkMenu_RevertButton__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_BookmarkMenu_AwaitingSelectionNotification__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_components_BookmarkMenu_CancelDeleteBookmarkButton__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_components_BookmarkMenu_ConfirmDeleteBookmarkButton__ = __webpack_require__(1506);
var _templateObject=_taggedTemplateLiteral(['\n  font-size: 20px;\n  line-height: 28px;\n  @media (max-width: 600px) {\n    font-size: 16px;\n    line-height: 20px;\n  }\n'],['\n  font-size: 20px;\n  line-height: 28px;\n  @media (max-width: 600px) {\n    font-size: 16px;\n    line-height: 20px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ResponsiveText=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */])(_templateObject);function DeleteBookmarkMenu(_ref){var AppState=_ref.AppState;if(!AppState.isUserDeleting)return null;if(AppState.bookmarkToDelete.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_components_BookmarkMenu_CancelDeleteBookmarkButton__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveText,{weight:'bold',color:'accent-1'},'Delete this bookmark?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_app_components_BookmarkMenu_ConfirmDeleteBookmarkButton__["a" /* default */],null));}if(!AppState.bookmarkToDelete.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_BookmarkMenu_AwaitingSelectionNotification__["a" /* default */],{selection:'bookmark to delete'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_BookmarkMenu_RevertButton__["a" /* default */],{onClick:function onClick(){return AppState.setMenuBar('BOOKMARKS_MENU');}}));}}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(DeleteBookmarkMenu)));

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n'],['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["g" /* Close */])(_templateObject);function CancelDeleteBookmarkButton(_ref){var AppState=_ref.AppState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_Button__["a" /* default */],{direction:'row',pad:'small',justify:'center',align:'center',fill:'vertical',onClick:function onClick(){AppState.prepareToDeleteBookmark([]);AppState.setMenuBar('BOOKMARKS_MENU');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{size:'large',color:'accent-1'}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(CancelDeleteBookmarkButton)));

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n'],['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["e" /* Checkmark */])(_templateObject);function ConfirmDeleteBookmarkButton(_ref){var AppState=_ref.AppState,onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_Button__["a" /* default */],{direction:'row',pad:'small',justify:'center',align:'center',fill:'vertical',onClick:function onClick(){AppState.deleteBookmark();AppState.prepareToDeleteBookmark([]);AppState.toggleBookmarksMenu();AppState.setMenuBar('MAIN_MENU');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{size:'large',color:'accent-1'}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(ConfirmDeleteBookmarkButton)));

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_BookmarkMenu_CancelClearBookmarksButton__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_BookmarkMenu_ConfirmClearBookmarksButton__ = __webpack_require__(1509);
var _templateObject=_taggedTemplateLiteral(['\n  font-size: 20px;\n  line-height: 28px;\n  @media (max-width: 600px) {\n    font-size: 16px;\n    line-height: 20px;\n  }\n'],['\n  font-size: 20px;\n  line-height: 28px;\n  @media (max-width: 600px) {\n    font-size: 16px;\n    line-height: 20px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ResponsiveText=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet__["m" /* Text */])(_templateObject);function ClearBookmarksMenu(_ref){var AppState=_ref.AppState;if(!AppState.isUserClearing)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_BookmarkMenu_CancelClearBookmarksButton__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveText,{weight:'bold',color:'accent-1'},'Delete all bookmarks?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_BookmarkMenu_ConfirmClearBookmarksButton__["a" /* default */],null));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(ClearBookmarksMenu)));

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n'],['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["g" /* Close */])(_templateObject);function CancelClearBookmarksButton(_ref){var AppState=_ref.AppState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_Button__["a" /* default */],{direction:'row',pad:'small',justify:'center',align:'center',fill:'vertical',onClick:function onClick(){AppState.setMenuBar('BOOKMARKS_MENU');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{size:'large',color:'accent-1'}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(CancelClearBookmarksButton)));

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n'],['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["e" /* Checkmark */])(_templateObject);function ConfirmClearBookmarksButton(_ref){var AppState=_ref.AppState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_Button__["a" /* default */],{direction:'row',pad:'small',justify:'center',align:'center',fill:'vertical',onClick:function onClick(){AppState.clearBookmarks();AppState.toggleBookmarksMenu();AppState.setMenuBar('MAIN_MENU');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{size:'large',color:'accent-1'}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(ConfirmClearBookmarksButton)));

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_BookmarkMenu_AddNoteButton__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_BookmarkMenu_RevertButton__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_BookmarkMenu_CancelButton__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_components_BookmarkMenu_SaveButton__ = __webpack_require__(272);
function BookmarkingMenu(_ref){var AppState=_ref.AppState;if(!AppState.isBookmarkingMenuBar)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_BookmarkMenu_AddNoteButton__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_BookmarkMenu_RevertButton__["a" /* default */],{onClick:function onClick(){AppState.resetBookmarkingSelection();AppState.setMenuBar('USER_IS_BOOKMARKING');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_BookmarkMenu_CancelButton__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_components_BookmarkMenu_SaveButton__["a" /* default */],null));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(BookmarkingMenu)));

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_icons__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_Button__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n'],['\n  width: 48px;\n  height: 48px;\n  @media (max-width: 600px) {\n    width: 24px;\n    height: 24px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet_icons__["j" /* Edit */])(_templateObject);function AddNoteButton(_ref){var AppState=_ref.AppState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_Button__["a" /* default */],{direction:'row',pad:'small',justify:'center',align:'center',fill:'vertical',onClick:function onClick(){AppState.setMenuBar('USER_IS_ANNOTATING');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{size:'large',color:'accent-1'}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(AddNoteButton)));

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_BookmarkMenu_RevertButton__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_BookmarkMenu_CancelButton__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_BookmarkMenu_SaveButton__ = __webpack_require__(272);
function AddNoteMenu(_ref){var AppState=_ref.AppState;if(!AppState.isUserAnnotating)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_BookmarkMenu_RevertButton__["a" /* default */],{onClick:function onClick(){AppState.resetBookmarkingNote();AppState.setMenuBar('BOOKMARKING_MENU');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_BookmarkMenu_CancelButton__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_BookmarkMenu_SaveButton__["a" /* default */],null));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(AddNoteMenu)));

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_components_BookmarkMenu_RevertButton__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_components_BookmarkMenu_AwaitingSelectionNotification__ = __webpack_require__(270);
function AwaitingSelectionMenu(_ref){var AppState=_ref.AppState;if(!AppState.isUserBookmarking)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_components_BookmarkMenu_AwaitingSelectionNotification__["a" /* default */],{selection:'selection to bookmark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_components_BookmarkMenu_RevertButton__["a" /* default */],{onClick:function onClick(){return AppState.setMenuBar('MAIN_MENU');}}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(AwaitingSelectionMenu)));

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_style_theme__ = __webpack_require__(34);
var _templateObject=_taggedTemplateLiteral(['\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 8;\n  height: 175px;\n  padding: 11px 11px 80px 11px;\n  background: ',';\n'],['\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 8;\n  height: 175px;\n  padding: 11px 11px 80px 11px;\n  background: ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n  resize: none;\n  width: 100%;\n  height: 100%;\n  background: ',';\n'],['\n  resize: none;\n  width: 100%;\n  height: 100%;\n  background: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledBox=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */])(_templateObject,__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors['neutral-4']);var Input=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_grommet__["n" /* TextArea */])(_templateObject2,__WEBPACK_IMPORTED_MODULE_4_app_style_theme__["a" /* default */].global.colors['accent-2']);function onSubmit(AppState,keypress){if(keypress==='Enter'){AppState.bookmarks.insert({path:AppState.bookmarkingSelectionPath.slice(),content:AppState.bookmarkingSelectionContent,note:AppState.bookmarkingNote});AppState.resetBookmarkingSelection();AppState.setMenuBar('MAIN_MENU');}}function NoteInput(_ref){var AppState=_ref.AppState;if(!AppState.isUserAnnotating)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledBox,{width:'large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Input,{required:true,autoFocus:true,placeholder:'Type note here...',value:AppState.bookmarkingNote,onChange:function onChange(event){return AppState.newBookmarkingNote(event.target.value);},onKeyPress:function onKeyPress(event){return onSubmit(AppState,event.key);}}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])('AppState')(Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(NoteInput)));

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_style_theme__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_E2Book_css__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_E2Book_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_app_E2Book_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_components_AnimatedEllipsis__ = __webpack_require__(153);
function Loading(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["f" /* Grommet */],{className:'App',full:true,theme:__WEBPACK_IMPORTED_MODULE_1_app_style_theme__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["d" /* Box */],{fill:true,align:'center',justify:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet__["g" /* Heading */],null,'loading',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_components_AnimatedEllipsis__["a" /* default */],{small:true}))));}/* harmony default export */ __webpack_exports__["a"] = (Loading);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.868c6ca5.js